(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
"use strict";

_dereq_(2);

var _global = _interopRequireDefault(_dereq_(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;
},{"15":15,"2":2}],2:[function(_dereq_,module,exports){
"use strict";

_dereq_(3);

_dereq_(5);

_dereq_(4);

_dereq_(11);

_dereq_(10);

_dereq_(13);

_dereq_(12);

_dereq_(14);

_dereq_(7);

_dereq_(8);

_dereq_(6);

_dereq_(9);

_dereq_(306);

_dereq_(307);
},{"10":10,"11":11,"12":12,"13":13,"14":14,"3":3,"306":306,"307":307,"4":4,"5":5,"6":6,"7":7,"8":8,"9":9}],3:[function(_dereq_,module,exports){
_dereq_(278);
_dereq_(214);
_dereq_(216);
_dereq_(215);
_dereq_(218);
_dereq_(220);
_dereq_(225);
_dereq_(219);
_dereq_(217);
_dereq_(227);
_dereq_(226);
_dereq_(222);
_dereq_(223);
_dereq_(221);
_dereq_(213);
_dereq_(224);
_dereq_(228);
_dereq_(229);
_dereq_(180);
_dereq_(182);
_dereq_(181);
_dereq_(231);
_dereq_(230);
_dereq_(201);
_dereq_(211);
_dereq_(212);
_dereq_(202);
_dereq_(203);
_dereq_(204);
_dereq_(205);
_dereq_(206);
_dereq_(207);
_dereq_(208);
_dereq_(209);
_dereq_(210);
_dereq_(184);
_dereq_(185);
_dereq_(186);
_dereq_(187);
_dereq_(188);
_dereq_(189);
_dereq_(190);
_dereq_(191);
_dereq_(192);
_dereq_(193);
_dereq_(194);
_dereq_(195);
_dereq_(196);
_dereq_(197);
_dereq_(198);
_dereq_(199);
_dereq_(200);
_dereq_(265);
_dereq_(270);
_dereq_(277);
_dereq_(268);
_dereq_(260);
_dereq_(261);
_dereq_(266);
_dereq_(271);
_dereq_(273);
_dereq_(256);
_dereq_(257);
_dereq_(258);
_dereq_(259);
_dereq_(262);
_dereq_(263);
_dereq_(264);
_dereq_(267);
_dereq_(269);
_dereq_(272);
_dereq_(274);
_dereq_(275);
_dereq_(276);
_dereq_(175);
_dereq_(177);
_dereq_(176);
_dereq_(179);
_dereq_(178);
_dereq_(163);
_dereq_(161);
_dereq_(168);
_dereq_(165);
_dereq_(171);
_dereq_(173);
_dereq_(160);
_dereq_(167);
_dereq_(157);
_dereq_(172);
_dereq_(155);
_dereq_(170);
_dereq_(169);
_dereq_(162);
_dereq_(166);
_dereq_(154);
_dereq_(156);
_dereq_(159);
_dereq_(158);
_dereq_(174);
_dereq_(164);
_dereq_(247);
_dereq_(248);
_dereq_(254);
_dereq_(249);
_dereq_(250);
_dereq_(251);
_dereq_(252);
_dereq_(253);
_dereq_(232);
_dereq_(183);
_dereq_(255);
_dereq_(290);
_dereq_(291);
_dereq_(279);
_dereq_(280);
_dereq_(285);
_dereq_(288);
_dereq_(289);
_dereq_(283);
_dereq_(286);
_dereq_(284);
_dereq_(287);
_dereq_(281);
_dereq_(282);
_dereq_(233);
_dereq_(234);
_dereq_(235);
_dereq_(236);
_dereq_(237);
_dereq_(240);
_dereq_(238);
_dereq_(239);
_dereq_(241);
_dereq_(242);
_dereq_(243);
_dereq_(244);
_dereq_(246);
_dereq_(245);
module.exports = _dereq_(52);

},{"154":154,"155":155,"156":156,"157":157,"158":158,"159":159,"160":160,"161":161,"162":162,"163":163,"164":164,"165":165,"166":166,"167":167,"168":168,"169":169,"170":170,"171":171,"172":172,"173":173,"174":174,"175":175,"176":176,"177":177,"178":178,"179":179,"180":180,"181":181,"182":182,"183":183,"184":184,"185":185,"186":186,"187":187,"188":188,"189":189,"190":190,"191":191,"192":192,"193":193,"194":194,"195":195,"196":196,"197":197,"198":198,"199":199,"200":200,"201":201,"202":202,"203":203,"204":204,"205":205,"206":206,"207":207,"208":208,"209":209,"210":210,"211":211,"212":212,"213":213,"214":214,"215":215,"216":216,"217":217,"218":218,"219":219,"220":220,"221":221,"222":222,"223":223,"224":224,"225":225,"226":226,"227":227,"228":228,"229":229,"230":230,"231":231,"232":232,"233":233,"234":234,"235":235,"236":236,"237":237,"238":238,"239":239,"240":240,"241":241,"242":242,"243":243,"244":244,"245":245,"246":246,"247":247,"248":248,"249":249,"250":250,"251":251,"252":252,"253":253,"254":254,"255":255,"256":256,"257":257,"258":258,"259":259,"260":260,"261":261,"262":262,"263":263,"264":264,"265":265,"266":266,"267":267,"268":268,"269":269,"270":270,"271":271,"272":272,"273":273,"274":274,"275":275,"276":276,"277":277,"278":278,"279":279,"280":280,"281":281,"282":282,"283":283,"284":284,"285":285,"286":286,"287":287,"288":288,"289":289,"290":290,"291":291,"52":52}],4:[function(_dereq_,module,exports){
_dereq_(292);
module.exports = _dereq_(52).Array.flatMap;

},{"292":292,"52":52}],5:[function(_dereq_,module,exports){
_dereq_(293);
module.exports = _dereq_(52).Array.includes;

},{"293":293,"52":52}],6:[function(_dereq_,module,exports){
_dereq_(294);
module.exports = _dereq_(52).Object.entries;

},{"294":294,"52":52}],7:[function(_dereq_,module,exports){
_dereq_(295);
module.exports = _dereq_(52).Object.getOwnPropertyDescriptors;

},{"295":295,"52":52}],8:[function(_dereq_,module,exports){
_dereq_(296);
module.exports = _dereq_(52).Object.values;

},{"296":296,"52":52}],9:[function(_dereq_,module,exports){
'use strict';
_dereq_(232);
_dereq_(297);
module.exports = _dereq_(52).Promise['finally'];

},{"232":232,"297":297,"52":52}],10:[function(_dereq_,module,exports){
_dereq_(298);
module.exports = _dereq_(52).String.padEnd;

},{"298":298,"52":52}],11:[function(_dereq_,module,exports){
_dereq_(299);
module.exports = _dereq_(52).String.padStart;

},{"299":299,"52":52}],12:[function(_dereq_,module,exports){
_dereq_(301);
module.exports = _dereq_(52).String.trimRight;

},{"301":301,"52":52}],13:[function(_dereq_,module,exports){
_dereq_(300);
module.exports = _dereq_(52).String.trimLeft;

},{"300":300,"52":52}],14:[function(_dereq_,module,exports){
_dereq_(302);
module.exports = _dereq_(151).f('asyncIterator');

},{"151":151,"302":302}],15:[function(_dereq_,module,exports){
_dereq_(32);
module.exports = _dereq_(18).global;

},{"18":18,"32":32}],16:[function(_dereq_,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],17:[function(_dereq_,module,exports){
var isObject = _dereq_(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"28":28}],18:[function(_dereq_,module,exports){
var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],19:[function(_dereq_,module,exports){
// optional / simple context binding
var aFunction = _dereq_(16);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"16":16}],20:[function(_dereq_,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !_dereq_(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"23":23}],21:[function(_dereq_,module,exports){
var isObject = _dereq_(28);
var document = _dereq_(24).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"24":24,"28":28}],22:[function(_dereq_,module,exports){
var global = _dereq_(24);
var core = _dereq_(18);
var ctx = _dereq_(19);
var hide = _dereq_(26);
var has = _dereq_(25);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"18":18,"19":19,"24":24,"25":25,"26":26}],23:[function(_dereq_,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],24:[function(_dereq_,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],25:[function(_dereq_,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],26:[function(_dereq_,module,exports){
var dP = _dereq_(29);
var createDesc = _dereq_(30);
module.exports = _dereq_(20) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"20":20,"29":29,"30":30}],27:[function(_dereq_,module,exports){
module.exports = !_dereq_(20) && !_dereq_(23)(function () {
  return Object.defineProperty(_dereq_(21)('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"20":20,"21":21,"23":23}],28:[function(_dereq_,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],29:[function(_dereq_,module,exports){
var anObject = _dereq_(17);
var IE8_DOM_DEFINE = _dereq_(27);
var toPrimitive = _dereq_(31);
var dP = Object.defineProperty;

exports.f = _dereq_(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"17":17,"20":20,"27":27,"31":31}],30:[function(_dereq_,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],31:[function(_dereq_,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = _dereq_(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"28":28}],32:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-global
var $export = _dereq_(22);

$export($export.G, { global: _dereq_(24) });

},{"22":22,"24":24}],33:[function(_dereq_,module,exports){
arguments[4][16][0].apply(exports,arguments)
},{"16":16}],34:[function(_dereq_,module,exports){
var cof = _dereq_(48);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"48":48}],35:[function(_dereq_,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _dereq_(152)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _dereq_(72)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"152":152,"72":72}],36:[function(_dereq_,module,exports){
'use strict';
var at = _dereq_(129)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

},{"129":129}],37:[function(_dereq_,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],38:[function(_dereq_,module,exports){
arguments[4][17][0].apply(exports,arguments)
},{"17":17,"81":81}],39:[function(_dereq_,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = _dereq_(142);
var toAbsoluteIndex = _dereq_(137);
var toLength = _dereq_(141);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"137":137,"141":141,"142":142}],40:[function(_dereq_,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = _dereq_(142);
var toAbsoluteIndex = _dereq_(137);
var toLength = _dereq_(141);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"137":137,"141":141,"142":142}],41:[function(_dereq_,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = _dereq_(140);
var toLength = _dereq_(141);
var toAbsoluteIndex = _dereq_(137);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"137":137,"140":140,"141":141}],42:[function(_dereq_,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = _dereq_(54);
var IObject = _dereq_(77);
var toObject = _dereq_(142);
var toLength = _dereq_(141);
var asc = _dereq_(45);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"141":141,"142":142,"45":45,"54":54,"77":77}],43:[function(_dereq_,module,exports){
var aFunction = _dereq_(33);
var toObject = _dereq_(142);
var IObject = _dereq_(77);
var toLength = _dereq_(141);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"141":141,"142":142,"33":33,"77":77}],44:[function(_dereq_,module,exports){
var isObject = _dereq_(81);
var isArray = _dereq_(79);
var SPECIES = _dereq_(152)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"152":152,"79":79,"81":81}],45:[function(_dereq_,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = _dereq_(44);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"44":44}],46:[function(_dereq_,module,exports){
'use strict';
var aFunction = _dereq_(33);
var isObject = _dereq_(81);
var invoke = _dereq_(76);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"33":33,"76":76,"81":81}],47:[function(_dereq_,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = _dereq_(48);
var TAG = _dereq_(152)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"152":152,"48":48}],48:[function(_dereq_,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],49:[function(_dereq_,module,exports){
'use strict';
var dP = _dereq_(99).f;
var create = _dereq_(98);
var redefineAll = _dereq_(117);
var ctx = _dereq_(54);
var anInstance = _dereq_(37);
var forOf = _dereq_(68);
var $iterDefine = _dereq_(85);
var step = _dereq_(87);
var setSpecies = _dereq_(123);
var DESCRIPTORS = _dereq_(58);
var fastKey = _dereq_(94).fastKey;
var validate = _dereq_(149);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"117":117,"123":123,"149":149,"37":37,"54":54,"58":58,"68":68,"85":85,"87":87,"94":94,"98":98,"99":99}],50:[function(_dereq_,module,exports){
'use strict';
var redefineAll = _dereq_(117);
var getWeak = _dereq_(94).getWeak;
var anObject = _dereq_(38);
var isObject = _dereq_(81);
var anInstance = _dereq_(37);
var forOf = _dereq_(68);
var createArrayMethod = _dereq_(42);
var $has = _dereq_(71);
var validate = _dereq_(149);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"117":117,"149":149,"37":37,"38":38,"42":42,"68":68,"71":71,"81":81,"94":94}],51:[function(_dereq_,module,exports){
'use strict';
var global = _dereq_(70);
var $export = _dereq_(62);
var redefine = _dereq_(118);
var redefineAll = _dereq_(117);
var meta = _dereq_(94);
var forOf = _dereq_(68);
var anInstance = _dereq_(37);
var isObject = _dereq_(81);
var fails = _dereq_(64);
var $iterDetect = _dereq_(86);
var setToStringTag = _dereq_(124);
var inheritIfRequired = _dereq_(75);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"117":117,"118":118,"124":124,"37":37,"62":62,"64":64,"68":68,"70":70,"75":75,"81":81,"86":86,"94":94}],52:[function(_dereq_,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"18":18}],53:[function(_dereq_,module,exports){
'use strict';
var $defineProperty = _dereq_(99);
var createDesc = _dereq_(116);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"116":116,"99":99}],54:[function(_dereq_,module,exports){
arguments[4][19][0].apply(exports,arguments)
},{"19":19,"33":33}],55:[function(_dereq_,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = _dereq_(64);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"64":64}],56:[function(_dereq_,module,exports){
'use strict';
var anObject = _dereq_(38);
var toPrimitive = _dereq_(143);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"143":143,"38":38}],57:[function(_dereq_,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],58:[function(_dereq_,module,exports){
arguments[4][20][0].apply(exports,arguments)
},{"20":20,"64":64}],59:[function(_dereq_,module,exports){
arguments[4][21][0].apply(exports,arguments)
},{"21":21,"70":70,"81":81}],60:[function(_dereq_,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],61:[function(_dereq_,module,exports){
// all enumerable object keys, includes symbols
var getKeys = _dereq_(107);
var gOPS = _dereq_(104);
var pIE = _dereq_(108);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"104":104,"107":107,"108":108}],62:[function(_dereq_,module,exports){
var global = _dereq_(70);
var core = _dereq_(52);
var hide = _dereq_(72);
var redefine = _dereq_(118);
var ctx = _dereq_(54);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"118":118,"52":52,"54":54,"70":70,"72":72}],63:[function(_dereq_,module,exports){
var MATCH = _dereq_(152)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"152":152}],64:[function(_dereq_,module,exports){
arguments[4][23][0].apply(exports,arguments)
},{"23":23}],65:[function(_dereq_,module,exports){
'use strict';
_dereq_(248);
var redefine = _dereq_(118);
var hide = _dereq_(72);
var fails = _dereq_(64);
var defined = _dereq_(57);
var wks = _dereq_(152);
var regexpExec = _dereq_(120);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"118":118,"120":120,"152":152,"248":248,"57":57,"64":64,"72":72}],66:[function(_dereq_,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = _dereq_(38);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"38":38}],67:[function(_dereq_,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = _dereq_(79);
var isObject = _dereq_(81);
var toLength = _dereq_(141);
var ctx = _dereq_(54);
var IS_CONCAT_SPREADABLE = _dereq_(152)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"141":141,"152":152,"54":54,"79":79,"81":81}],68:[function(_dereq_,module,exports){
var ctx = _dereq_(54);
var call = _dereq_(83);
var isArrayIter = _dereq_(78);
var anObject = _dereq_(38);
var toLength = _dereq_(141);
var getIterFn = _dereq_(153);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"141":141,"153":153,"38":38,"54":54,"78":78,"83":83}],69:[function(_dereq_,module,exports){
module.exports = _dereq_(126)('native-function-to-string', Function.toString);

},{"126":126}],70:[function(_dereq_,module,exports){
arguments[4][24][0].apply(exports,arguments)
},{"24":24}],71:[function(_dereq_,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"25":25}],72:[function(_dereq_,module,exports){
arguments[4][26][0].apply(exports,arguments)
},{"116":116,"26":26,"58":58,"99":99}],73:[function(_dereq_,module,exports){
var document = _dereq_(70).document;
module.exports = document && document.documentElement;

},{"70":70}],74:[function(_dereq_,module,exports){
arguments[4][27][0].apply(exports,arguments)
},{"27":27,"58":58,"59":59,"64":64}],75:[function(_dereq_,module,exports){
var isObject = _dereq_(81);
var setPrototypeOf = _dereq_(122).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"122":122,"81":81}],76:[function(_dereq_,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],77:[function(_dereq_,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = _dereq_(48);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"48":48}],78:[function(_dereq_,module,exports){
// check on default Array iterator
var Iterators = _dereq_(88);
var ITERATOR = _dereq_(152)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"152":152,"88":88}],79:[function(_dereq_,module,exports){
// 7.2.2 IsArray(argument)
var cof = _dereq_(48);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"48":48}],80:[function(_dereq_,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = _dereq_(81);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"81":81}],81:[function(_dereq_,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"28":28}],82:[function(_dereq_,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = _dereq_(81);
var cof = _dereq_(48);
var MATCH = _dereq_(152)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"152":152,"48":48,"81":81}],83:[function(_dereq_,module,exports){
// call something on iterator step with safe closing on error
var anObject = _dereq_(38);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"38":38}],84:[function(_dereq_,module,exports){
'use strict';
var create = _dereq_(98);
var descriptor = _dereq_(116);
var setToStringTag = _dereq_(124);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_dereq_(72)(IteratorPrototype, _dereq_(152)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"116":116,"124":124,"152":152,"72":72,"98":98}],85:[function(_dereq_,module,exports){
'use strict';
var LIBRARY = _dereq_(89);
var $export = _dereq_(62);
var redefine = _dereq_(118);
var hide = _dereq_(72);
var Iterators = _dereq_(88);
var $iterCreate = _dereq_(84);
var setToStringTag = _dereq_(124);
var getPrototypeOf = _dereq_(105);
var ITERATOR = _dereq_(152)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"105":105,"118":118,"124":124,"152":152,"62":62,"72":72,"84":84,"88":88,"89":89}],86:[function(_dereq_,module,exports){
var ITERATOR = _dereq_(152)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"152":152}],87:[function(_dereq_,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],88:[function(_dereq_,module,exports){
module.exports = {};

},{}],89:[function(_dereq_,module,exports){
module.exports = false;

},{}],90:[function(_dereq_,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],91:[function(_dereq_,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = _dereq_(93);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"93":93}],92:[function(_dereq_,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],93:[function(_dereq_,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],94:[function(_dereq_,module,exports){
var META = _dereq_(147)('meta');
var isObject = _dereq_(81);
var has = _dereq_(71);
var setDesc = _dereq_(99).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_dereq_(64)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"147":147,"64":64,"71":71,"81":81,"99":99}],95:[function(_dereq_,module,exports){
var global = _dereq_(70);
var macrotask = _dereq_(136).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = _dereq_(48)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"136":136,"48":48,"70":70}],96:[function(_dereq_,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = _dereq_(33);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"33":33}],97:[function(_dereq_,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = _dereq_(58);
var getKeys = _dereq_(107);
var gOPS = _dereq_(104);
var pIE = _dereq_(108);
var toObject = _dereq_(142);
var IObject = _dereq_(77);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || _dereq_(64)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"104":104,"107":107,"108":108,"142":142,"58":58,"64":64,"77":77}],98:[function(_dereq_,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = _dereq_(38);
var dPs = _dereq_(100);
var enumBugKeys = _dereq_(60);
var IE_PROTO = _dereq_(125)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _dereq_(59)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _dereq_(73).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"100":100,"125":125,"38":38,"59":59,"60":60,"73":73}],99:[function(_dereq_,module,exports){
arguments[4][29][0].apply(exports,arguments)
},{"143":143,"29":29,"38":38,"58":58,"74":74}],100:[function(_dereq_,module,exports){
var dP = _dereq_(99);
var anObject = _dereq_(38);
var getKeys = _dereq_(107);

module.exports = _dereq_(58) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"107":107,"38":38,"58":58,"99":99}],101:[function(_dereq_,module,exports){
var pIE = _dereq_(108);
var createDesc = _dereq_(116);
var toIObject = _dereq_(140);
var toPrimitive = _dereq_(143);
var has = _dereq_(71);
var IE8_DOM_DEFINE = _dereq_(74);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = _dereq_(58) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"108":108,"116":116,"140":140,"143":143,"58":58,"71":71,"74":74}],102:[function(_dereq_,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = _dereq_(140);
var gOPN = _dereq_(103).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"103":103,"140":140}],103:[function(_dereq_,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = _dereq_(106);
var hiddenKeys = _dereq_(60).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"106":106,"60":60}],104:[function(_dereq_,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],105:[function(_dereq_,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = _dereq_(71);
var toObject = _dereq_(142);
var IE_PROTO = _dereq_(125)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"125":125,"142":142,"71":71}],106:[function(_dereq_,module,exports){
var has = _dereq_(71);
var toIObject = _dereq_(140);
var arrayIndexOf = _dereq_(41)(false);
var IE_PROTO = _dereq_(125)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"125":125,"140":140,"41":41,"71":71}],107:[function(_dereq_,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = _dereq_(106);
var enumBugKeys = _dereq_(60);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"106":106,"60":60}],108:[function(_dereq_,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],109:[function(_dereq_,module,exports){
// most Object methods by ES6 should accept primitives
var $export = _dereq_(62);
var core = _dereq_(52);
var fails = _dereq_(64);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"52":52,"62":62,"64":64}],110:[function(_dereq_,module,exports){
var DESCRIPTORS = _dereq_(58);
var getKeys = _dereq_(107);
var toIObject = _dereq_(140);
var isEnum = _dereq_(108).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"107":107,"108":108,"140":140,"58":58}],111:[function(_dereq_,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = _dereq_(103);
var gOPS = _dereq_(104);
var anObject = _dereq_(38);
var Reflect = _dereq_(70).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"103":103,"104":104,"38":38,"70":70}],112:[function(_dereq_,module,exports){
var $parseFloat = _dereq_(70).parseFloat;
var $trim = _dereq_(134).trim;

module.exports = 1 / $parseFloat(_dereq_(135) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"134":134,"135":135,"70":70}],113:[function(_dereq_,module,exports){
var $parseInt = _dereq_(70).parseInt;
var $trim = _dereq_(134).trim;
var ws = _dereq_(135);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"134":134,"135":135,"70":70}],114:[function(_dereq_,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],115:[function(_dereq_,module,exports){
var anObject = _dereq_(38);
var isObject = _dereq_(81);
var newPromiseCapability = _dereq_(96);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"38":38,"81":81,"96":96}],116:[function(_dereq_,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"30":30}],117:[function(_dereq_,module,exports){
var redefine = _dereq_(118);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"118":118}],118:[function(_dereq_,module,exports){
var global = _dereq_(70);
var hide = _dereq_(72);
var has = _dereq_(71);
var SRC = _dereq_(147)('src');
var $toString = _dereq_(69);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

_dereq_(52).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"147":147,"52":52,"69":69,"70":70,"71":71,"72":72}],119:[function(_dereq_,module,exports){
'use strict';

var classof = _dereq_(47);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

},{"47":47}],120:[function(_dereq_,module,exports){
'use strict';

var regexpFlags = _dereq_(66);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

},{"66":66}],121:[function(_dereq_,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],122:[function(_dereq_,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = _dereq_(81);
var anObject = _dereq_(38);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _dereq_(54)(Function.call, _dereq_(101).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"101":101,"38":38,"54":54,"81":81}],123:[function(_dereq_,module,exports){
'use strict';
var global = _dereq_(70);
var dP = _dereq_(99);
var DESCRIPTORS = _dereq_(58);
var SPECIES = _dereq_(152)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"152":152,"58":58,"70":70,"99":99}],124:[function(_dereq_,module,exports){
var def = _dereq_(99).f;
var has = _dereq_(71);
var TAG = _dereq_(152)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"152":152,"71":71,"99":99}],125:[function(_dereq_,module,exports){
var shared = _dereq_(126)('keys');
var uid = _dereq_(147);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"126":126,"147":147}],126:[function(_dereq_,module,exports){
var core = _dereq_(52);
var global = _dereq_(70);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: _dereq_(89) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"52":52,"70":70,"89":89}],127:[function(_dereq_,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = _dereq_(38);
var aFunction = _dereq_(33);
var SPECIES = _dereq_(152)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"152":152,"33":33,"38":38}],128:[function(_dereq_,module,exports){
'use strict';
var fails = _dereq_(64);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"64":64}],129:[function(_dereq_,module,exports){
var toInteger = _dereq_(139);
var defined = _dereq_(57);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"139":139,"57":57}],130:[function(_dereq_,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = _dereq_(82);
var defined = _dereq_(57);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"57":57,"82":82}],131:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var fails = _dereq_(64);
var defined = _dereq_(57);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"57":57,"62":62,"64":64}],132:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = _dereq_(141);
var repeat = _dereq_(133);
var defined = _dereq_(57);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"133":133,"141":141,"57":57}],133:[function(_dereq_,module,exports){
'use strict';
var toInteger = _dereq_(139);
var defined = _dereq_(57);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"139":139,"57":57}],134:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var defined = _dereq_(57);
var fails = _dereq_(64);
var spaces = _dereq_(135);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"135":135,"57":57,"62":62,"64":64}],135:[function(_dereq_,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],136:[function(_dereq_,module,exports){
var ctx = _dereq_(54);
var invoke = _dereq_(76);
var html = _dereq_(73);
var cel = _dereq_(59);
var global = _dereq_(70);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_dereq_(48)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"48":48,"54":54,"59":59,"70":70,"73":73,"76":76}],137:[function(_dereq_,module,exports){
var toInteger = _dereq_(139);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"139":139}],138:[function(_dereq_,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = _dereq_(139);
var toLength = _dereq_(141);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"139":139,"141":141}],139:[function(_dereq_,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],140:[function(_dereq_,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = _dereq_(77);
var defined = _dereq_(57);
module.exports = function (it) {
  return IObject(defined(it));
};

},{"57":57,"77":77}],141:[function(_dereq_,module,exports){
// 7.1.15 ToLength
var toInteger = _dereq_(139);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"139":139}],142:[function(_dereq_,module,exports){
// 7.1.13 ToObject(argument)
var defined = _dereq_(57);
module.exports = function (it) {
  return Object(defined(it));
};

},{"57":57}],143:[function(_dereq_,module,exports){
arguments[4][31][0].apply(exports,arguments)
},{"31":31,"81":81}],144:[function(_dereq_,module,exports){
'use strict';
if (_dereq_(58)) {
  var LIBRARY = _dereq_(89);
  var global = _dereq_(70);
  var fails = _dereq_(64);
  var $export = _dereq_(62);
  var $typed = _dereq_(146);
  var $buffer = _dereq_(145);
  var ctx = _dereq_(54);
  var anInstance = _dereq_(37);
  var propertyDesc = _dereq_(116);
  var hide = _dereq_(72);
  var redefineAll = _dereq_(117);
  var toInteger = _dereq_(139);
  var toLength = _dereq_(141);
  var toIndex = _dereq_(138);
  var toAbsoluteIndex = _dereq_(137);
  var toPrimitive = _dereq_(143);
  var has = _dereq_(71);
  var classof = _dereq_(47);
  var isObject = _dereq_(81);
  var toObject = _dereq_(142);
  var isArrayIter = _dereq_(78);
  var create = _dereq_(98);
  var getPrototypeOf = _dereq_(105);
  var gOPN = _dereq_(103).f;
  var getIterFn = _dereq_(153);
  var uid = _dereq_(147);
  var wks = _dereq_(152);
  var createArrayMethod = _dereq_(42);
  var createArrayIncludes = _dereq_(41);
  var speciesConstructor = _dereq_(127);
  var ArrayIterators = _dereq_(164);
  var Iterators = _dereq_(88);
  var $iterDetect = _dereq_(86);
  var setSpecies = _dereq_(123);
  var arrayFill = _dereq_(40);
  var arrayCopyWithin = _dereq_(39);
  var $DP = _dereq_(99);
  var $GOPD = _dereq_(101);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"101":101,"103":103,"105":105,"116":116,"117":117,"123":123,"127":127,"137":137,"138":138,"139":139,"141":141,"142":142,"143":143,"145":145,"146":146,"147":147,"152":152,"153":153,"164":164,"37":37,"39":39,"40":40,"41":41,"42":42,"47":47,"54":54,"58":58,"62":62,"64":64,"70":70,"71":71,"72":72,"78":78,"81":81,"86":86,"88":88,"89":89,"98":98,"99":99}],145:[function(_dereq_,module,exports){
'use strict';
var global = _dereq_(70);
var DESCRIPTORS = _dereq_(58);
var LIBRARY = _dereq_(89);
var $typed = _dereq_(146);
var hide = _dereq_(72);
var redefineAll = _dereq_(117);
var fails = _dereq_(64);
var anInstance = _dereq_(37);
var toInteger = _dereq_(139);
var toLength = _dereq_(141);
var toIndex = _dereq_(138);
var gOPN = _dereq_(103).f;
var dP = _dereq_(99).f;
var arrayFill = _dereq_(40);
var setToStringTag = _dereq_(124);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"103":103,"117":117,"124":124,"138":138,"139":139,"141":141,"146":146,"37":37,"40":40,"58":58,"64":64,"70":70,"72":72,"89":89,"99":99}],146:[function(_dereq_,module,exports){
var global = _dereq_(70);
var hide = _dereq_(72);
var uid = _dereq_(147);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"147":147,"70":70,"72":72}],147:[function(_dereq_,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],148:[function(_dereq_,module,exports){
var global = _dereq_(70);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"70":70}],149:[function(_dereq_,module,exports){
var isObject = _dereq_(81);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"81":81}],150:[function(_dereq_,module,exports){
var global = _dereq_(70);
var core = _dereq_(52);
var LIBRARY = _dereq_(89);
var wksExt = _dereq_(151);
var defineProperty = _dereq_(99).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"151":151,"52":52,"70":70,"89":89,"99":99}],151:[function(_dereq_,module,exports){
exports.f = _dereq_(152);

},{"152":152}],152:[function(_dereq_,module,exports){
var store = _dereq_(126)('wks');
var uid = _dereq_(147);
var Symbol = _dereq_(70).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"126":126,"147":147,"70":70}],153:[function(_dereq_,module,exports){
var classof = _dereq_(47);
var ITERATOR = _dereq_(152)('iterator');
var Iterators = _dereq_(88);
module.exports = _dereq_(52).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"152":152,"47":47,"52":52,"88":88}],154:[function(_dereq_,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = _dereq_(62);

$export($export.P, 'Array', { copyWithin: _dereq_(39) });

_dereq_(35)('copyWithin');

},{"35":35,"39":39,"62":62}],155:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $every = _dereq_(42)(4);

$export($export.P + $export.F * !_dereq_(128)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"128":128,"42":42,"62":62}],156:[function(_dereq_,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = _dereq_(62);

$export($export.P, 'Array', { fill: _dereq_(40) });

_dereq_(35)('fill');

},{"35":35,"40":40,"62":62}],157:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $filter = _dereq_(42)(2);

$export($export.P + $export.F * !_dereq_(128)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"128":128,"42":42,"62":62}],158:[function(_dereq_,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = _dereq_(62);
var $find = _dereq_(42)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_dereq_(35)(KEY);

},{"35":35,"42":42,"62":62}],159:[function(_dereq_,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = _dereq_(62);
var $find = _dereq_(42)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_dereq_(35)(KEY);

},{"35":35,"42":42,"62":62}],160:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $forEach = _dereq_(42)(0);
var STRICT = _dereq_(128)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"128":128,"42":42,"62":62}],161:[function(_dereq_,module,exports){
'use strict';
var ctx = _dereq_(54);
var $export = _dereq_(62);
var toObject = _dereq_(142);
var call = _dereq_(83);
var isArrayIter = _dereq_(78);
var toLength = _dereq_(141);
var createProperty = _dereq_(53);
var getIterFn = _dereq_(153);

$export($export.S + $export.F * !_dereq_(86)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"141":141,"142":142,"153":153,"53":53,"54":54,"62":62,"78":78,"83":83,"86":86}],162:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $indexOf = _dereq_(41)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(128)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"128":128,"41":41,"62":62}],163:[function(_dereq_,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = _dereq_(62);

$export($export.S, 'Array', { isArray: _dereq_(79) });

},{"62":62,"79":79}],164:[function(_dereq_,module,exports){
'use strict';
var addToUnscopables = _dereq_(35);
var step = _dereq_(87);
var Iterators = _dereq_(88);
var toIObject = _dereq_(140);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = _dereq_(85)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"140":140,"35":35,"85":85,"87":87,"88":88}],165:[function(_dereq_,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = _dereq_(62);
var toIObject = _dereq_(140);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (_dereq_(77) != Object || !_dereq_(128)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"128":128,"140":140,"62":62,"77":77}],166:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var toIObject = _dereq_(140);
var toInteger = _dereq_(139);
var toLength = _dereq_(141);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(128)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"128":128,"139":139,"140":140,"141":141,"62":62}],167:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $map = _dereq_(42)(1);

$export($export.P + $export.F * !_dereq_(128)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"128":128,"42":42,"62":62}],168:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var createProperty = _dereq_(53);

// WebKit Array.of isn't generic
$export($export.S + $export.F * _dereq_(64)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"53":53,"62":62,"64":64}],169:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $reduce = _dereq_(43);

$export($export.P + $export.F * !_dereq_(128)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"128":128,"43":43,"62":62}],170:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $reduce = _dereq_(43);

$export($export.P + $export.F * !_dereq_(128)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"128":128,"43":43,"62":62}],171:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var html = _dereq_(73);
var cof = _dereq_(48);
var toAbsoluteIndex = _dereq_(137);
var toLength = _dereq_(141);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * _dereq_(64)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"137":137,"141":141,"48":48,"62":62,"64":64,"73":73}],172:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $some = _dereq_(42)(3);

$export($export.P + $export.F * !_dereq_(128)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"128":128,"42":42,"62":62}],173:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var aFunction = _dereq_(33);
var toObject = _dereq_(142);
var fails = _dereq_(64);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !_dereq_(128)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"128":128,"142":142,"33":33,"62":62,"64":64}],174:[function(_dereq_,module,exports){
_dereq_(123)('Array');

},{"123":123}],175:[function(_dereq_,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = _dereq_(62);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"62":62}],176:[function(_dereq_,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = _dereq_(62);
var toISOString = _dereq_(55);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"55":55,"62":62}],177:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var toObject = _dereq_(142);
var toPrimitive = _dereq_(143);

$export($export.P + $export.F * _dereq_(64)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"142":142,"143":143,"62":62,"64":64}],178:[function(_dereq_,module,exports){
var TO_PRIMITIVE = _dereq_(152)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) _dereq_(72)(proto, TO_PRIMITIVE, _dereq_(56));

},{"152":152,"56":56,"72":72}],179:[function(_dereq_,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  _dereq_(118)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"118":118}],180:[function(_dereq_,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = _dereq_(62);

$export($export.P, 'Function', { bind: _dereq_(46) });

},{"46":46,"62":62}],181:[function(_dereq_,module,exports){
'use strict';
var isObject = _dereq_(81);
var getPrototypeOf = _dereq_(105);
var HAS_INSTANCE = _dereq_(152)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) _dereq_(99).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"105":105,"152":152,"81":81,"99":99}],182:[function(_dereq_,module,exports){
var dP = _dereq_(99).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || _dereq_(58) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"58":58,"99":99}],183:[function(_dereq_,module,exports){
'use strict';
var strong = _dereq_(49);
var validate = _dereq_(149);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = _dereq_(51)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"149":149,"49":49,"51":51}],184:[function(_dereq_,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = _dereq_(62);
var log1p = _dereq_(92);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"62":62,"92":92}],185:[function(_dereq_,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = _dereq_(62);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"62":62}],186:[function(_dereq_,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = _dereq_(62);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"62":62}],187:[function(_dereq_,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = _dereq_(62);
var sign = _dereq_(93);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"62":62,"93":93}],188:[function(_dereq_,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = _dereq_(62);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"62":62}],189:[function(_dereq_,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = _dereq_(62);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"62":62}],190:[function(_dereq_,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = _dereq_(62);
var $expm1 = _dereq_(90);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"62":62,"90":90}],191:[function(_dereq_,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = _dereq_(62);

$export($export.S, 'Math', { fround: _dereq_(91) });

},{"62":62,"91":91}],192:[function(_dereq_,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = _dereq_(62);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"62":62}],193:[function(_dereq_,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = _dereq_(62);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * _dereq_(64)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"62":62,"64":64}],194:[function(_dereq_,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = _dereq_(62);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"62":62}],195:[function(_dereq_,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = _dereq_(62);

$export($export.S, 'Math', { log1p: _dereq_(92) });

},{"62":62,"92":92}],196:[function(_dereq_,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = _dereq_(62);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"62":62}],197:[function(_dereq_,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = _dereq_(62);

$export($export.S, 'Math', { sign: _dereq_(93) });

},{"62":62,"93":93}],198:[function(_dereq_,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = _dereq_(62);
var expm1 = _dereq_(90);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * _dereq_(64)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"62":62,"64":64,"90":90}],199:[function(_dereq_,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = _dereq_(62);
var expm1 = _dereq_(90);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"62":62,"90":90}],200:[function(_dereq_,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = _dereq_(62);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"62":62}],201:[function(_dereq_,module,exports){
'use strict';
var global = _dereq_(70);
var has = _dereq_(71);
var cof = _dereq_(48);
var inheritIfRequired = _dereq_(75);
var toPrimitive = _dereq_(143);
var fails = _dereq_(64);
var gOPN = _dereq_(103).f;
var gOPD = _dereq_(101).f;
var dP = _dereq_(99).f;
var $trim = _dereq_(134).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(_dereq_(98)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = _dereq_(58) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  _dereq_(118)(global, NUMBER, $Number);
}

},{"101":101,"103":103,"118":118,"134":134,"143":143,"48":48,"58":58,"64":64,"70":70,"71":71,"75":75,"98":98,"99":99}],202:[function(_dereq_,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = _dereq_(62);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"62":62}],203:[function(_dereq_,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = _dereq_(62);
var _isFinite = _dereq_(70).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"62":62,"70":70}],204:[function(_dereq_,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = _dereq_(62);

$export($export.S, 'Number', { isInteger: _dereq_(80) });

},{"62":62,"80":80}],205:[function(_dereq_,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = _dereq_(62);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"62":62}],206:[function(_dereq_,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = _dereq_(62);
var isInteger = _dereq_(80);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"62":62,"80":80}],207:[function(_dereq_,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = _dereq_(62);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"62":62}],208:[function(_dereq_,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = _dereq_(62);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"62":62}],209:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var $parseFloat = _dereq_(112);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"112":112,"62":62}],210:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var $parseInt = _dereq_(113);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"113":113,"62":62}],211:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var toInteger = _dereq_(139);
var aNumberValue = _dereq_(34);
var repeat = _dereq_(133);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !_dereq_(64)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"133":133,"139":139,"34":34,"62":62,"64":64}],212:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $fails = _dereq_(64);
var aNumberValue = _dereq_(34);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"34":34,"62":62,"64":64}],213:[function(_dereq_,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = _dereq_(62);

$export($export.S + $export.F, 'Object', { assign: _dereq_(97) });

},{"62":62,"97":97}],214:[function(_dereq_,module,exports){
var $export = _dereq_(62);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: _dereq_(98) });

},{"62":62,"98":98}],215:[function(_dereq_,module,exports){
var $export = _dereq_(62);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !_dereq_(58), 'Object', { defineProperties: _dereq_(100) });

},{"100":100,"58":58,"62":62}],216:[function(_dereq_,module,exports){
var $export = _dereq_(62);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !_dereq_(58), 'Object', { defineProperty: _dereq_(99).f });

},{"58":58,"62":62,"99":99}],217:[function(_dereq_,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = _dereq_(81);
var meta = _dereq_(94).onFreeze;

_dereq_(109)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"109":109,"81":81,"94":94}],218:[function(_dereq_,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = _dereq_(140);
var $getOwnPropertyDescriptor = _dereq_(101).f;

_dereq_(109)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"101":101,"109":109,"140":140}],219:[function(_dereq_,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
_dereq_(109)('getOwnPropertyNames', function () {
  return _dereq_(102).f;
});

},{"102":102,"109":109}],220:[function(_dereq_,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = _dereq_(142);
var $getPrototypeOf = _dereq_(105);

_dereq_(109)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"105":105,"109":109,"142":142}],221:[function(_dereq_,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = _dereq_(81);

_dereq_(109)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"109":109,"81":81}],222:[function(_dereq_,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = _dereq_(81);

_dereq_(109)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"109":109,"81":81}],223:[function(_dereq_,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = _dereq_(81);

_dereq_(109)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"109":109,"81":81}],224:[function(_dereq_,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = _dereq_(62);
$export($export.S, 'Object', { is: _dereq_(121) });

},{"121":121,"62":62}],225:[function(_dereq_,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = _dereq_(142);
var $keys = _dereq_(107);

_dereq_(109)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"107":107,"109":109,"142":142}],226:[function(_dereq_,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = _dereq_(81);
var meta = _dereq_(94).onFreeze;

_dereq_(109)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"109":109,"81":81,"94":94}],227:[function(_dereq_,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = _dereq_(81);
var meta = _dereq_(94).onFreeze;

_dereq_(109)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"109":109,"81":81,"94":94}],228:[function(_dereq_,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = _dereq_(62);
$export($export.S, 'Object', { setPrototypeOf: _dereq_(122).set });

},{"122":122,"62":62}],229:[function(_dereq_,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = _dereq_(47);
var test = {};
test[_dereq_(152)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  _dereq_(118)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"118":118,"152":152,"47":47}],230:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var $parseFloat = _dereq_(112);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"112":112,"62":62}],231:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var $parseInt = _dereq_(113);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"113":113,"62":62}],232:[function(_dereq_,module,exports){
'use strict';
var LIBRARY = _dereq_(89);
var global = _dereq_(70);
var ctx = _dereq_(54);
var classof = _dereq_(47);
var $export = _dereq_(62);
var isObject = _dereq_(81);
var aFunction = _dereq_(33);
var anInstance = _dereq_(37);
var forOf = _dereq_(68);
var speciesConstructor = _dereq_(127);
var task = _dereq_(136).set;
var microtask = _dereq_(95)();
var newPromiseCapabilityModule = _dereq_(96);
var perform = _dereq_(114);
var userAgent = _dereq_(148);
var promiseResolve = _dereq_(115);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_dereq_(152)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _dereq_(117)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
_dereq_(124)($Promise, PROMISE);
_dereq_(123)(PROMISE);
Wrapper = _dereq_(52)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && _dereq_(86)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"114":114,"115":115,"117":117,"123":123,"124":124,"127":127,"136":136,"148":148,"152":152,"33":33,"37":37,"47":47,"52":52,"54":54,"62":62,"68":68,"70":70,"81":81,"86":86,"89":89,"95":95,"96":96}],233:[function(_dereq_,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = _dereq_(62);
var aFunction = _dereq_(33);
var anObject = _dereq_(38);
var rApply = (_dereq_(70).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !_dereq_(64)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"33":33,"38":38,"62":62,"64":64,"70":70}],234:[function(_dereq_,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = _dereq_(62);
var create = _dereq_(98);
var aFunction = _dereq_(33);
var anObject = _dereq_(38);
var isObject = _dereq_(81);
var fails = _dereq_(64);
var bind = _dereq_(46);
var rConstruct = (_dereq_(70).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"33":33,"38":38,"46":46,"62":62,"64":64,"70":70,"81":81,"98":98}],235:[function(_dereq_,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = _dereq_(99);
var $export = _dereq_(62);
var anObject = _dereq_(38);
var toPrimitive = _dereq_(143);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * _dereq_(64)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"143":143,"38":38,"62":62,"64":64,"99":99}],236:[function(_dereq_,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = _dereq_(62);
var gOPD = _dereq_(101).f;
var anObject = _dereq_(38);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"101":101,"38":38,"62":62}],237:[function(_dereq_,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = _dereq_(62);
var anObject = _dereq_(38);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
_dereq_(84)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"38":38,"62":62,"84":84}],238:[function(_dereq_,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = _dereq_(101);
var $export = _dereq_(62);
var anObject = _dereq_(38);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"101":101,"38":38,"62":62}],239:[function(_dereq_,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = _dereq_(62);
var getProto = _dereq_(105);
var anObject = _dereq_(38);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"105":105,"38":38,"62":62}],240:[function(_dereq_,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = _dereq_(101);
var getPrototypeOf = _dereq_(105);
var has = _dereq_(71);
var $export = _dereq_(62);
var isObject = _dereq_(81);
var anObject = _dereq_(38);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"101":101,"105":105,"38":38,"62":62,"71":71,"81":81}],241:[function(_dereq_,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = _dereq_(62);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"62":62}],242:[function(_dereq_,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = _dereq_(62);
var anObject = _dereq_(38);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"38":38,"62":62}],243:[function(_dereq_,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = _dereq_(62);

$export($export.S, 'Reflect', { ownKeys: _dereq_(111) });

},{"111":111,"62":62}],244:[function(_dereq_,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = _dereq_(62);
var anObject = _dereq_(38);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"38":38,"62":62}],245:[function(_dereq_,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = _dereq_(62);
var setProto = _dereq_(122);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"122":122,"62":62}],246:[function(_dereq_,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = _dereq_(99);
var gOPD = _dereq_(101);
var getPrototypeOf = _dereq_(105);
var has = _dereq_(71);
var $export = _dereq_(62);
var createDesc = _dereq_(116);
var anObject = _dereq_(38);
var isObject = _dereq_(81);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"101":101,"105":105,"116":116,"38":38,"62":62,"71":71,"81":81,"99":99}],247:[function(_dereq_,module,exports){
var global = _dereq_(70);
var inheritIfRequired = _dereq_(75);
var dP = _dereq_(99).f;
var gOPN = _dereq_(103).f;
var isRegExp = _dereq_(82);
var $flags = _dereq_(66);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (_dereq_(58) && (!CORRECT_NEW || _dereq_(64)(function () {
  re2[_dereq_(152)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  _dereq_(118)(global, 'RegExp', $RegExp);
}

_dereq_(123)('RegExp');

},{"103":103,"118":118,"123":123,"152":152,"58":58,"64":64,"66":66,"70":70,"75":75,"82":82,"99":99}],248:[function(_dereq_,module,exports){
'use strict';
var regexpExec = _dereq_(120);
_dereq_(62)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

},{"120":120,"62":62}],249:[function(_dereq_,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (_dereq_(58) && /./g.flags != 'g') _dereq_(99).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: _dereq_(66)
});

},{"58":58,"66":66,"99":99}],250:[function(_dereq_,module,exports){
'use strict';

var anObject = _dereq_(38);
var toLength = _dereq_(141);
var advanceStringIndex = _dereq_(36);
var regExpExec = _dereq_(119);

// @@match logic
_dereq_(65)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"119":119,"141":141,"36":36,"38":38,"65":65}],251:[function(_dereq_,module,exports){
'use strict';

var anObject = _dereq_(38);
var toObject = _dereq_(142);
var toLength = _dereq_(141);
var toInteger = _dereq_(139);
var advanceStringIndex = _dereq_(36);
var regExpExec = _dereq_(119);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
_dereq_(65)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

},{"119":119,"139":139,"141":141,"142":142,"36":36,"38":38,"65":65}],252:[function(_dereq_,module,exports){
'use strict';

var anObject = _dereq_(38);
var sameValue = _dereq_(121);
var regExpExec = _dereq_(119);

// @@search logic
_dereq_(65)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"119":119,"121":121,"38":38,"65":65}],253:[function(_dereq_,module,exports){
'use strict';

var isRegExp = _dereq_(82);
var anObject = _dereq_(38);
var speciesConstructor = _dereq_(127);
var advanceStringIndex = _dereq_(36);
var toLength = _dereq_(141);
var callRegExpExec = _dereq_(119);
var regexpExec = _dereq_(120);
var fails = _dereq_(64);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
_dereq_(65)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

},{"119":119,"120":120,"127":127,"141":141,"36":36,"38":38,"64":64,"65":65,"82":82}],254:[function(_dereq_,module,exports){
'use strict';
_dereq_(249);
var anObject = _dereq_(38);
var $flags = _dereq_(66);
var DESCRIPTORS = _dereq_(58);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  _dereq_(118)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (_dereq_(64)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"118":118,"249":249,"38":38,"58":58,"64":64,"66":66}],255:[function(_dereq_,module,exports){
'use strict';
var strong = _dereq_(49);
var validate = _dereq_(149);
var SET = 'Set';

// 23.2 Set Objects
module.exports = _dereq_(51)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"149":149,"49":49,"51":51}],256:[function(_dereq_,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
_dereq_(131)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"131":131}],257:[function(_dereq_,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
_dereq_(131)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"131":131}],258:[function(_dereq_,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
_dereq_(131)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"131":131}],259:[function(_dereq_,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
_dereq_(131)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"131":131}],260:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $at = _dereq_(129)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"129":129,"62":62}],261:[function(_dereq_,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = _dereq_(62);
var toLength = _dereq_(141);
var context = _dereq_(130);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * _dereq_(63)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"130":130,"141":141,"62":62,"63":63}],262:[function(_dereq_,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
_dereq_(131)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"131":131}],263:[function(_dereq_,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
_dereq_(131)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"131":131}],264:[function(_dereq_,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
_dereq_(131)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"131":131}],265:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var toAbsoluteIndex = _dereq_(137);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"137":137,"62":62}],266:[function(_dereq_,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = _dereq_(62);
var context = _dereq_(130);
var INCLUDES = 'includes';

$export($export.P + $export.F * _dereq_(63)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"130":130,"62":62,"63":63}],267:[function(_dereq_,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
_dereq_(131)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"131":131}],268:[function(_dereq_,module,exports){
'use strict';
var $at = _dereq_(129)(true);

// 21.1.3.27 String.prototype[@@iterator]()
_dereq_(85)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"129":129,"85":85}],269:[function(_dereq_,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
_dereq_(131)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"131":131}],270:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var toIObject = _dereq_(140);
var toLength = _dereq_(141);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"140":140,"141":141,"62":62}],271:[function(_dereq_,module,exports){
var $export = _dereq_(62);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: _dereq_(133)
});

},{"133":133,"62":62}],272:[function(_dereq_,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
_dereq_(131)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"131":131}],273:[function(_dereq_,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = _dereq_(62);
var toLength = _dereq_(141);
var context = _dereq_(130);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * _dereq_(63)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"130":130,"141":141,"62":62,"63":63}],274:[function(_dereq_,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
_dereq_(131)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"131":131}],275:[function(_dereq_,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
_dereq_(131)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"131":131}],276:[function(_dereq_,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
_dereq_(131)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"131":131}],277:[function(_dereq_,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
_dereq_(134)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"134":134}],278:[function(_dereq_,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = _dereq_(70);
var has = _dereq_(71);
var DESCRIPTORS = _dereq_(58);
var $export = _dereq_(62);
var redefine = _dereq_(118);
var META = _dereq_(94).KEY;
var $fails = _dereq_(64);
var shared = _dereq_(126);
var setToStringTag = _dereq_(124);
var uid = _dereq_(147);
var wks = _dereq_(152);
var wksExt = _dereq_(151);
var wksDefine = _dereq_(150);
var enumKeys = _dereq_(61);
var isArray = _dereq_(79);
var anObject = _dereq_(38);
var isObject = _dereq_(81);
var toObject = _dereq_(142);
var toIObject = _dereq_(140);
var toPrimitive = _dereq_(143);
var createDesc = _dereq_(116);
var _create = _dereq_(98);
var gOPNExt = _dereq_(102);
var $GOPD = _dereq_(101);
var $GOPS = _dereq_(104);
var $DP = _dereq_(99);
var $keys = _dereq_(107);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  _dereq_(103).f = gOPNExt.f = $getOwnPropertyNames;
  _dereq_(108).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !_dereq_(89)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _dereq_(72)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"101":101,"102":102,"103":103,"104":104,"107":107,"108":108,"116":116,"118":118,"124":124,"126":126,"140":140,"142":142,"143":143,"147":147,"150":150,"151":151,"152":152,"38":38,"58":58,"61":61,"62":62,"64":64,"70":70,"71":71,"72":72,"79":79,"81":81,"89":89,"94":94,"98":98,"99":99}],279:[function(_dereq_,module,exports){
'use strict';
var $export = _dereq_(62);
var $typed = _dereq_(146);
var buffer = _dereq_(145);
var anObject = _dereq_(38);
var toAbsoluteIndex = _dereq_(137);
var toLength = _dereq_(141);
var isObject = _dereq_(81);
var ArrayBuffer = _dereq_(70).ArrayBuffer;
var speciesConstructor = _dereq_(127);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * _dereq_(64)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

_dereq_(123)(ARRAY_BUFFER);

},{"123":123,"127":127,"137":137,"141":141,"145":145,"146":146,"38":38,"62":62,"64":64,"70":70,"81":81}],280:[function(_dereq_,module,exports){
var $export = _dereq_(62);
$export($export.G + $export.W + $export.F * !_dereq_(146).ABV, {
  DataView: _dereq_(145).DataView
});

},{"145":145,"146":146,"62":62}],281:[function(_dereq_,module,exports){
_dereq_(144)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],282:[function(_dereq_,module,exports){
_dereq_(144)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],283:[function(_dereq_,module,exports){
_dereq_(144)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],284:[function(_dereq_,module,exports){
_dereq_(144)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],285:[function(_dereq_,module,exports){
_dereq_(144)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],286:[function(_dereq_,module,exports){
_dereq_(144)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],287:[function(_dereq_,module,exports){
_dereq_(144)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],288:[function(_dereq_,module,exports){
_dereq_(144)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"144":144}],289:[function(_dereq_,module,exports){
_dereq_(144)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"144":144}],290:[function(_dereq_,module,exports){
'use strict';
var global = _dereq_(70);
var each = _dereq_(42)(0);
var redefine = _dereq_(118);
var meta = _dereq_(94);
var assign = _dereq_(97);
var weak = _dereq_(50);
var isObject = _dereq_(81);
var validate = _dereq_(149);
var NATIVE_WEAK_MAP = _dereq_(149);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = _dereq_(51)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"118":118,"149":149,"42":42,"50":50,"51":51,"70":70,"81":81,"94":94,"97":97}],291:[function(_dereq_,module,exports){
'use strict';
var weak = _dereq_(50);
var validate = _dereq_(149);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
_dereq_(51)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"149":149,"50":50,"51":51}],292:[function(_dereq_,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = _dereq_(62);
var flattenIntoArray = _dereq_(67);
var toObject = _dereq_(142);
var toLength = _dereq_(141);
var aFunction = _dereq_(33);
var arraySpeciesCreate = _dereq_(45);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

_dereq_(35)('flatMap');

},{"141":141,"142":142,"33":33,"35":35,"45":45,"62":62,"67":67}],293:[function(_dereq_,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = _dereq_(62);
var $includes = _dereq_(41)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

_dereq_(35)('includes');

},{"35":35,"41":41,"62":62}],294:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = _dereq_(62);
var $entries = _dereq_(110)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"110":110,"62":62}],295:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = _dereq_(62);
var ownKeys = _dereq_(111);
var toIObject = _dereq_(140);
var gOPD = _dereq_(101);
var createProperty = _dereq_(53);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"101":101,"111":111,"140":140,"53":53,"62":62}],296:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = _dereq_(62);
var $values = _dereq_(110)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"110":110,"62":62}],297:[function(_dereq_,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = _dereq_(62);
var core = _dereq_(52);
var global = _dereq_(70);
var speciesConstructor = _dereq_(127);
var promiseResolve = _dereq_(115);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"115":115,"127":127,"52":52,"62":62,"70":70}],298:[function(_dereq_,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = _dereq_(62);
var $pad = _dereq_(132);
var userAgent = _dereq_(148);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"132":132,"148":148,"62":62}],299:[function(_dereq_,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = _dereq_(62);
var $pad = _dereq_(132);
var userAgent = _dereq_(148);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"132":132,"148":148,"62":62}],300:[function(_dereq_,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
_dereq_(134)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"134":134}],301:[function(_dereq_,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
_dereq_(134)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"134":134}],302:[function(_dereq_,module,exports){
_dereq_(150)('asyncIterator');

},{"150":150}],303:[function(_dereq_,module,exports){
var $iterators = _dereq_(164);
var getKeys = _dereq_(107);
var redefine = _dereq_(118);
var global = _dereq_(70);
var hide = _dereq_(72);
var Iterators = _dereq_(88);
var wks = _dereq_(152);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"107":107,"118":118,"152":152,"164":164,"70":70,"72":72,"88":88}],304:[function(_dereq_,module,exports){
var $export = _dereq_(62);
var $task = _dereq_(136);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"136":136,"62":62}],305:[function(_dereq_,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = _dereq_(70);
var $export = _dereq_(62);
var userAgent = _dereq_(148);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"148":148,"62":62,"70":70}],306:[function(_dereq_,module,exports){
_dereq_(305);
_dereq_(304);
_dereq_(303);
module.exports = _dereq_(52);

},{"303":303,"304":304,"305":305,"52":52}],307:[function(_dereq_,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}]},{},[1]);

// Configure global plugins in the RequireJS environment

(function () {
  'use strict';

  /* {"urls":{"cdn":"https://cdn-rest.staging.hcloud.trustyou.net/apps","commons":"/commons","tasks":"/tasks","goals":"/goals","dashboard":"/dashboard","social":"/social","portfolio":"/portfolio","survey":"/surveys","reports":"/export","reviews":"/reviews","export_app":"/export-tmp","tyra":"/tyra-5","metaresponse":"/metaresponse","hoteladmin":"/hoteladmin","products":"/products","messaging_api":"","messaging":"","cluster":"/cluster","sso":"https://restaurant-analytics.staging.trustyou.com/sso","links":"","i18n":"/i18n","login":"https://login.staging.trustyou.com"},"social":{"facebook_app_id":"369833126389025","facebook_api_version":"v2.6"},"gaq":{"enabled":"false","account":"","site_speed_sample_rate":"25","ga4_account":"","debug_timing":"false"},"zendesk_chat":{"enabled":true,"locales":"","cluster_countries":"","basic_roles":"","excluded_domains":""},"sidebar_tabs":{"social":"disabled"},"sidebar_modules":{"survey_module":"disabled","messaging_module":"disabled","marketing_module":"disabled"}} will be replaced with the configuration object at build time.
   * We don't need to worry about modifying it because it's not shared. */

  var config = { "urls": { "cdn": "https://cdn-rest.staging.hcloud.trustyou.net/apps", "commons": "/commons", "tasks": "/tasks", "goals": "/goals", "dashboard": "/dashboard", "social": "/social", "portfolio": "/portfolio", "survey": "/surveys", "reports": "/export", "reviews": "/reviews", "export_app": "/export-tmp", "tyra": "/tyra-5", "metaresponse": "/metaresponse", "hoteladmin": "/hoteladmin", "products": "/products", "messaging_api": "", "messaging": "", "cluster": "/cluster", "sso": "https://restaurant-analytics.staging.trustyou.com/sso", "links": "", "i18n": "/i18n", "login": "https://login.staging.trustyou.com" }, "social": { "facebook_app_id": "369833126389025", "facebook_api_version": "v2.6" }, "gaq": { "enabled": "false", "account": "", "site_speed_sample_rate": "25", "ga4_account": "", "debug_timing": "false" }, "zendesk_chat": { "enabled": true, "locales": "", "cluster_countries": "", "basic_roles": "", "excluded_domains": "" }, "sidebar_tabs": { "social": "disabled" }, "sidebar_modules": { "survey_module": "disabled", "messaging_module": "disabled", "marketing_module": "disabled" } },
      urls = config.urls; // eslint-disable-line no-undef

  for (var u in urls) {
    if (u !== 'cdn' && u !== 'sso' && urls.hasOwnProperty(u)) {
      urls[u] = urls[u].substr(1);
    }
  }

  var profile = 'staging';

  // versioned app urls
  var apps = {
    'tasks-app': urls.tasks + "/static/js/tasks.agg.min",
    'tasks-app-css': "css!" + urls.tasks + "/static/css/tasks.agg.min",

    'goals-app': urls.goals + "/static/js/goals.agg.min",
    'goals-app-css': "css!" + urls.goals + "/static/css/goals.agg.min",

    'dashboard-agg': urls.dashboard + "/static/js/dashboard.agg.min",
    'dashboard-agg-css': "css!" + urls.dashboard + "/static/css/dashboard.agg.min",
    'dashboard-export': urls.dashboard + "/static/js/dashboard-export.agg.min",
    'dashboard-export-css': "css!" + urls.dashboard + "/static/css/dashboard-export.agg.min",

    'social-agg': urls.social + "/js/social.agg.min",
    'social-agg-css': "css!" + urls.social + "/css/social.agg.min",
    'social-export-agg': urls.social + "/js/social-export.agg.min",

    'portfolio-app': urls.portfolio + "/static/js/portfolio.agg.min",
    'portfolio-app-css': "css!" + urls.portfolio + "/static/css/portfolio.agg.min",
    'portfolio-agg-export': urls.portfolio + "/static/js/portfolio-export.agg.min",
    'portfolio-agg-export-css': "css!" + urls.portfolio + "/static/css/export/portfolio-export.agg.min",

    'survey-app': urls.survey + "/static/js/survey-aggr",
    'survey-app-css': "css!" + urls.survey + "/static/css/survey-aggr",
    'survey-export': urls.survey + "/static/js/survey-export-aggr",
    'survey-export-css': "css!" + urls.survey + "/static/css/surveys",
    'survey-app-export': urls.survey + "/static/js/owners-app/export-modules-requirejs",

    'review-plugins': urls.reviews + "/static/js/review-plugins.agg",
    'review-export-agg': urls.reviews + "/static/js/review-export.agg",

    'export-app': urls.export_app + "/static/js/plugins/all.agg.min",
    'export-app-dashboard-css': "css!" + urls.export_app + "/static/css/modules/dashboard",
    'export-bootstrap': urls.export_app + "/static/js/bootstrap.agg.min",
    'export-bootstrap-css': "css!" + urls.export_app + "/static/css/report.agg.min",

    'tyra-bootstrap': urls.tyra + "/static/js/bootstrap.agg.min",
    'tyra-bootstrap-css': "css!" + urls.tyra + "/static/css/base.agg.min",

    'meta-response-app': urls.metaresponse + "/static/js/metaresponse.min",
    'meta-response-export': urls.metaresponse + "/static/js/metaresponse-export.agg.min",

    'hotel-admin-app': urls.hoteladmin + "/static/js/hoteladmin.min",
    'hotel-admin-app-css': "css!" + urls.hoteladmin + "/static/css/hoteladmin.agg.min",

    'users-utils': 'sso/static/js/users-utils/utils.agg.min',
    'users-management': 'sso/static/js/users-management/all.agg.min',

    'products-app': urls.products + "/static/js/products.min"
  };

  // TODO: this whole mechanism will need a clean up once we are fully on Tsuru.
  if (window.ty_versions) {
    // eslint-disable-line camelcase
    // append resource versions
    for (var a in apps) {
      if (apps.hasOwnProperty(a)) {
        var absPath = "/" + apps[a].replace('css!', '');
        absPath += apps[a].indexOf('css!') !== 0 ? '.js' : '.css';

        var ver = window.ty_versions[absPath]; // eslint-disable-line camelcase

        if (ver) {
          apps[a] = apps[a] + "." + ver;
        }
      }
    }

    // Override any version from old cdn if it is in hybrid mode - Tsuru
    if (window.ty_cdn_versioning && window.ty_cdn_versioning_bundles_for) {
      // eslint-disable-line camelcase
      var version = window.ty_cdn_versioning; // eslint-disable-line camelcase
      var bundlesFromTsuru = window.ty_cdn_versioning_bundles_for; // eslint-disable-line camelcase
      bundlesFromTsuru.forEach(function (bundle, index) {
        if (apps.hasOwnProperty(bundle)) {
          var lastIndex = apps[bundle].lastIndexOf('.');
          var bundlePath = apps[bundle].substr(0, lastIndex);
          apps[bundle] = bundlePath + "." + version;
        }
      });
    }
  } else if (window.ty_cdn_versioning) {
    // eslint-disable-line camelcase
    var _version = window.ty_cdn_versioning; // eslint-disable-line camelcase
    for (var _a in apps) {
      if (apps.hasOwnProperty(_a)) {
        apps[_a] = apps[_a] + "." + _version;
      }
    }
  }

  require = { // eslint-disable-line no-global-assign
    baseUrl: urls.cdn,

    // Timeout in Seconds
    waitSeconds: 60,

    paths: {
      // jQuery
      jquery: urls.commons + "/public/bower_components/jquery/jquery",
      'fine-uploader': urls.commons + "/public/bower_components/fine-uploader/dist/fine-uploader.min",
      'phoenix-socket': urls.commons + "/public/bower_components/js-phoenix-socket/dist/phoenix-socket",
      'jquery-placeholder': urls.commons + "/public/bower_components/jquery-placeholder/jquery.placeholder",

      // jQuery UI
      'jquery-ui-plugins': urls.commons + "/public/3rd-party/jqueryui/jquery-ui-1.8.18",
      'jquery-ui': urls.commons + "/public/3rd-party/jqueryui/jquery-ui-i18n-1.8.18",
      'jquery-ui-custom-css': urls.commons + "/public/3rd-party/jqueryui/tyra5-jqueryui-theme",

      // jQuery select menu
      'jquery-ui-selectmenu': urls.commons + "/public/bower_components/jquery-selectmenu/ui/jquery.ui.selectmenu",
      'jquery-ui-selectmenu-css': urls.commons + "/public/bower_components/jquery-selectmenu/themes/base/jquery.ui.selectmenu",

      // Some jQuery plugins
      'jquery-cookie': urls.commons + "/public/bower_components/jquery-cookie/jquery.cookie",
      'jquery-base64': urls.commons + "/public/bower_components/jquery-base64/jquery.base64",
      'jquery-truncate': urls.commons + "/public/bower_components/jquery-truncate/jquery.truncate",
      'jquery-textfill': urls.commons + "/public/bower_components/jquery-textfill/jquery.textfill",
      'jquery-tmpl': urls.commons + "/public/bower_components/jquery-tmpl/jquery.tmpl",
      hashchange: urls.commons + "/public/bower_components/jquery-hashchange/jquery.ba-hashchange",

      // plugin to wait for images in pdf exports
      waitForImages: urls.commons + "/public/bower_components/waitForImages/jquery.waitforimages",

      expanding: urls.commons + "/public/bower_components/ExpandingTextareas/expanding",
      'jquery-md5': urls.commons + "/public/bower_components/jQuery-MD5-Plugin/jquery.md5",

      'zero-clipboard': urls.commons + "/public/bower_components/zeroclipboard/ZeroClipboard",

      'textext-core': urls.commons + "/public/bower_components/jquery-textext/src/js/textext.core",
      'textext-tags': urls.commons + "/public/bower_components/jquery-textext/src/js/textext.plugin.tags",
      'textext-core-css': urls.commons + "/public/bower_components/jquery-textext/src/css/textext.core",
      'textext-tags-css': urls.commons + "/public/bower_components/jquery-textext/src/css/textext.plugin.tags",

      // Fancybox
      easing: urls.commons + "/public/bower_components/jquery.fancybox/fancybox/jquery.easing-1.3.pack",
      fancybox: urls.commons + "/public/bower_components/jquery.fancybox/fancybox/jquery.fancybox-1.3.4",
      fancyboxCss: urls.commons + "/public/bower_components/jquery.fancybox/fancybox/jquery.fancybox-1.3.4",

      // Some RequireJS plugins
      text: urls.commons + "/public/bower_components/requirejs-text/text",
      async: urls.commons + "/public/bower_components/requirejs-plugins/src/async",
      font: urls.commons + "/public/3rd-party/requirejs-plugins/src/font",
      goog: urls.commons + "/public/3rd-party/goog_stub",
      json: urls.commons + "/public/bower_components/requirejs-plugins/src/json",
      propertyParser: urls.commons + "/public/bower_components/requirejs-plugins/src/propertyParser",

      // Require-CSS
      css: urls.commons + "/public/bower_components/require-css/css",
      normalize: urls.commons + "/public/bower_components/require-css/normalize",

      // Jade Templates
      jadeRuntime: urls.commons + "/public/bower_components/jade/runtime",

      // TODO replace with moment.js
      datejs: urls.commons + "/public/bower_components/datejs_original/date",
      moment: urls.commons + "/public/bower_components/moment/min/moment-with-langs",
      twix: urls.commons + "/public/bower_components/twix/bin/twix",

      iframeResizer: urls.commons + "/public/bower_components/iframe-resizer/js/iframeResizer.min",

      verge: urls.commons + "/public/bower_components/verge/verge",
      qTip: urls.commons + "/public/bower_components/qtip2/jquery.qtip",
      qTipCss: urls.commons + "/public/bower_components/qtip2/jquery.qtip",
      imagesloaded: urls.commons + "/public/bower_components/imagesloaded/imagesloaded",
      toastr: urls.commons + "/public/bower_components/toastr/toastr",
      select2: urls.commons + "/public/3rd-party/select2-3.4.5/select2.min",
      'jquery-sidr': urls.commons + "/public/3rd-party/sidr/jquery.sidr",

      'jquery.multiselect.raw': urls.commons + "/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect",
      'jquery.multiselect.filter': urls.commons + "/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.filter",
      'jquery.multiselect': urls.commons + "/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.filter.custommatch",

      jfeeds: urls.commons + "/public/3rd-party/jquery-feeds/jquery.feeds",

      tooltipsy: urls.commons + "/public/3rd-party/tooltipsy.min",

      waves: urls.commons + "/public/3rd-party/waves/waves.min",
      wavesCss: urls.commons + "/public/3rd-party/waves/waves.min",

      // apps

      'tasks-app': apps['tasks-app'],
      'goals-app': apps['goals-app'],
      'dashboard-css': apps['dashboard-agg-css'].replace('css!', ''),
      'dashboard-export-css': apps['dashboard-export-css'].replace('css!', ''),
      'dashboard-export': apps['dashboard-export'],
      'social-agg': apps['social-agg'],
      'portfolio-plugins': urls.portfolio + "/static/js/portfolio.agg", // Not a file, just a module id!
      'portfolio-css': apps['portfolio-app-css'].replace('css!', ''),
      'portfolio-export-css': apps['portfolio-agg-export-css'].replace('css!', ''),
      'survey-app': apps['survey-app'],
      'survey-export': apps['survey-export'],
      'users-app': urls.sso + "/static/js/users",
      'export-bootstrap': apps['export-bootstrap'],
      'tyra-bootstrap': apps['tyra-bootstrap'],
      'meta-response-app': apps['meta-response-app'],
      'meta-response-export': apps['meta-response-export'],
      'hotel-admin-app': apps['hotel-admin-app'],
      'hotel-admin-css': apps['hotel-admin-app-css'].replace('css!', ''),
      'products-app': apps['products-app'],

      // Facebook External SDK
      _facebook_external: '//connect.facebook.net/en_US/sdk',

      // Cyclops components library
      Cyclops: ['//cdn-public.messaging.trustyou.com/cyclops/1.8.0/cyclops.min', '//cdn-messaging.herokuapp.com/cyclops/1.8.0/cyclops.min'],
      'cyclops-css': ['//cdn-public.messaging.trustyou.com/cyclops/1.8.0/cyclops.min', '//cdn-messaging.herokuapp.com/cyclops/1.8.0/cyclops.min'],

      // React components library
      react: urls.cdn + "/commons/public/node_modules/react/umd/react.production.min" + (profile !== 'local' ? ".latest" : ''),
      'react-dom': urls.cdn + "/commons/public/node_modules/react-dom/umd/react-dom.production.min" + (profile !== 'local' ? ".latest" : ''),

      survey_ui: urls.cdn + "/commons/public/node_modules/@trustyou/survey_ui/dist/survey_ui." + profile + ".min" + (profile !== 'local' ? ".latest" : ''),
      'survey_ui-css': urls.cdn + "/commons/public/node_modules/@trustyou/survey_ui/dist/survey_ui.tyui.min" + (profile !== 'local' ? ".latest" : ''),
      // analytics ui module
      analytics_ui: urls.cdn + "/commons/public/node_modules/@trustyou/analytics_ui/dist/analytics_ui." + profile + ".min" + (profile !== 'local' ? ".latest" : ''),
      // assignments module (goals/tasks)
      TYAssignments: urls.cdn + "/commons/public/node_modules/@trustyou/assignments-app/dist/assignments.bundle",
      // settings ui
      'settings-ui': urls.cdn + "/commons/public/node_modules/@trustyou/settings-ui/dist/settings-ui." + profile + ".min",
      'settings-ui-css': urls.cdn + "/commons/public/node_modules/@trustyou/settings-ui/dist/settings-ui.tyui.min"
    },
    map: {
      '*': {
        'eventEmitter/EventEmitter': urls.commons + "/public/bower_components/eventEmitter/EventEmitter",
        'eventie/eventie': urls.commons + "/public/bower_components/eventie/eventie",

        session: urls.commons + "/public/js/old_components/session",
        'ty-i18n': urls.commons + "/public/js/old_components/ty-i18n",
        'time-dropdown': urls.commons + "/public/js/old_components/time-dropdown",
        'flextable-formatter': urls.commons + "/public/js/old_components/flextable-formatter",
        _gaq: urls.commons + "/public/js/old_components/_gaq",
        zendesk_chat: urls.commons + "/public/js/old_components/_zendesk_chat",
        'timing-tracker': urls.commons + "/public/js/old_components/timing-tracker",
        'timing-by-key': urls.commons + "/public/js/old_components/timing-by-key",
        'export-pane': urls.commons + "/public/js/old_components/export-pane",
        'manage-users': urls.commons + "/public/js/old_components/manage-users",
        list: urls.commons + "/public/js/old_components/list",
        UiComponent: urls.commons + "/public/js/ui_components/ui-component",
        widget: urls.commons + "/public/js/ui_components/widget",
        multipleentries: urls.commons + "/public/js/ui_components/multiple-entries",
        smartlist: urls.commons + "/public/js/ui_components/smart-list",
        dropdown: urls.commons + "/public/js/ui_components/dropdown",
        dropdownsmartlist: urls.commons + "/public/js/ui_components/dropdown-smartlist",
        TYCheckbox: urls.commons + "/public/js/ui_components/ty-checkbox",
        dropdown2levelsmartlist: urls.commons + "/public/js/ui_components/dropdown-2level-smartlist",
        dropdownmenu: urls.commons + "/public/js/ui_components/dropdown-menu",
        'dropdown-menu-template': urls.commons + "/public/jadec/ui_components/dropdown-menu",
        'smartlist-template': urls.commons + "/public/jadec/ui_components/smartlist",
        'smartlistitem-template': urls.commons + "/public/jadec/ui_components/smartlist-item",
        'dropdown-template': urls.commons + "/public/jadec/ui_components/dropdown",
        'dropdownsmartlist-template': urls.commons + "/public/jadec/ui_components/dropdown-smartlist",
        'dropdown2levelsmartlist-template': urls.commons + "/public/jadec/ui_components/dropdown-2level-smartlist",
        'dropdownjumbomenu-template': urls.commons + "/public/jadec/ui_components/dropdown-jumbomenu",
        'timedropdown-v2': urls.commons + "/public/js/ui_components/timedropdown",
        'side-panel': urls.commons + "/public/js/old_components/side-panel",
        'messaging-auth-link': urls.commons + "/public/js/old_components/messaging-auth-link",
        'accordion-template': urls.commons + "/public/jadec/ui_components/accordion",
        'accordion-element-template': urls.commons + "/public/jadec/ui_components/accordion-element",
        accordion: urls.commons + "/public/js/ui_components/accordion",
        'paginator-template': urls.commons + "/public/jadec/ui_components/paginator",
        paginator: urls.commons + "/public/js/ui_components/paginator",
        'ty_tab-template': urls.commons + "/public/jadec/ui_components/ty_tab",
        ty_tab: urls.commons + "/public/js/ui_components/ty_tab",
        'modal-template': urls.commons + "/public/jadec/ui_components/modal",
        'slide-modal-template': urls.commons + "/public/jadec/ui_components/slide-modal",
        modal: urls.commons + "/public/js/ui_components/modal",
        'dialog-template': urls.commons + "/public/jadec/ui_components/dialog",
        dialog: urls.commons + "/public/js/ui_components/dialog",
        'slide-modal': urls.commons + "/public/js/ui_components/slide-modal",
        'table-content': urls.commons + "/public/jadec/ui_components/table-content",
        'table-template': urls.commons + "/public/jadec/ui_components/table",
        table: urls.commons + "/public/js/ui_components/table",
        'single-barchart-template': urls.commons + "/public/jadec/ui_components/single-barchart",
        'single-barchart': urls.commons + "/public/js/ui_components/single-barchart",
        'wordcloud-template': urls.commons + "/public/jadec/ui_components/wordcloud",
        wordcloud: urls.commons + "/public/js/ui_components/wordcloud",
        'welcome-message': urls.commons + "/public/js/ui_components/welcome-message",
        'welcome-message-template': urls.commons + "/public/jadec/ui_components/welcome-message",
        donutchart: urls.commons + "/public/js/ui_components/donutchart",
        'donutchart-template': urls.commons + "/public/jadec/ui_components/donutchart",
        card: urls.commons + "/public/js/ui_components/card",
        'card-template': urls.commons + "/public/jadec/ui_components/card",
        'card-footer-button-template': urls.commons + "/public/jadec/ui_components/card-footer-button",
        'card-title-template': urls.commons + "/public/jadec/ui_components/card-title",
        tile: urls.commons + "/public/js/ui_components/tile",
        'tile-template': urls.commons + "/public/jadec/ui_components/tile",
        'tile-grid': urls.commons + "/public/js/ui_components/tile-grid",
        'tile-grid-tile-template': urls.commons + "/public/jadec/ui_components/tile-grid/tile-grid-tile",
        'tile-grid-row-template': urls.commons + "/public/jadec/ui_components/tile-grid/tile-grid-row",
        'tile-grid-details-template': urls.commons + "/public/jadec/ui_components/tile-grid/tile-grid-details",
        pagesize: urls.commons + "/public/js/ui_components/pagesize",
        toast: urls.commons + "/public/js/ui_components/toast",
        'sidebar-template': urls.commons + "/public/jadec/ui_components/sidebar",
        'permission-managers': urls.commons + "/public/js/permission_managers",
        'sidebar-module-template': urls.commons + "/public/jadec/ui_components/sidebar-module",
        'sidebar-tab-template': urls.commons + "/public/jadec/ui_components/sidebar-tab",
        'settings-permissions': urls.commons + "/public/js/permissions/settings",
        'users-permissions': urls.commons + "/public/js/permissions/users",
        'product-service': urls.commons + "/public/js/product_service",

        'email-input': urls.commons + "/public/js/ui_components/email-input",
        'email-input-template': urls.commons + "/public/jadec/ui_components/email-input",

        'add-tile-button': urls.commons + "/public/js/ui_components/add-tile-button",

        topic: urls.commons + "/public/js/old_components/topic",
        // apps

        /*
         Base url for app static resources. Usage:
          require(['portfolio-static/my-module'], ...)  OR
         define(['portfolio-static/my-module'], ...)
         */
        'social-static': urls.social + "/js", // Just path
        'social-plugins': urls.social + "/js/social-plugins", // Not a file, just a module id!
        'social-app-export': urls.social + "/js/export/export-module", // Not a file, just a module id!
        'social-export': urls.social + "/js/export/export-api", // Not a file, just a module id!

        'portfolio-app': apps['portfolio-app'],
        'portfolio-plugins': urls.portfolio + "/static/js/portfolio.agg", // Not a file, just a module id!
        'portfolio-export': urls.portfolio + "/static/js/export/export-api", // Not a file, just a module id!
        'portfolio-app-export': urls.portfolio + "/static/js/export/export-module", // Not a file, just a module id!

        'dashboard-static': urls.dashboard + "/static", // Just path
        'dashboard-app-export': urls.dashboard + "/static/js/export/export-module", // Not a file, just a module id!
        'dashboard-plugins': urls.dashboard + "/static/js/plugins", // Not a file, just a module id!
        'dashboard-predefined': urls.dashboard + "/static/js/predefined", // Not a file, just a module id!
        'dashboard-agg': urls.dashboard + "/static/js/predefined",

        'review-plugins': urls.reviews + "/static/js/review-plugins.agg",
        'review-app-export': urls.reviews + "/static/js/export/export-module", // Not a file, just a module id!
        'review-export': urls.reviews + "/static/js/export/export-api", // Not a file, just a module id!
        'export-app': urls.export_app + "/static/js/plugins/all",

        'users-utils': 'sso/static/js/users-utils/utils',
        'users-management': 'sso/static/js/users-management/all',

        'survey-app-export': apps['survey-app-export'],

        'meta-response-app': apps['meta-response-app'],
        'meta-response-plugins': urls.metaresponse + "/public/js/metaresponse/metaresponse-plugin", // Not a file, just a module id!
        'meta-response-export': urls.metaresponse + "/public/js/export/export-api",
        'meta-response-app-export': urls.metaresponse + "/public/js/export/export-module",

        'hotel-admin-app': apps['hotel-admin-app'],
        'hotel-admin-plugins': urls.hoteladmin + "/public/js/hoteladmin/hoteladmin-plugin", // Not a file, just a module id!,

        'products-app': apps['products-app'],

        // Facebook SDK
        'facebook-sdk': urls.commons + "/public/js/old_components/facebook-sdk",
        'facebook-dialog': urls.commons + "/public/js/old_components/facebook-dialog",

        // TileSpec
        TileSpec: urls.commons + "/public/js/ui_components/tilespec/tileSpec",
        TileRenderable: urls.commons + "/public/js/ui_components/tilespec/tileRenderable",

        // moved tyra-5 modules mapping for backwords compatibility
        'tyra-5/static/js/topbar': urls.commons + "/public/js/tyra-5/topbar", // used in tyra-5-ui
        'tyra-5/static/js/config': urls.commons + "/public/js/tyra-5/config", // currently still used in tyra-5, will be used in tyra-5-ui
        'tyra-5/static/js/init-slidepane': urls.commons + "/public/js/tyra-5/init-slidepane", // currently still used in tyra-5, will be used in tyra-5-ui
        'tyra-5/static/js/views/dashboard_modules_utils': urls.commons + "/public/js/tyra-5/views/dashboard_modules_utils", // used in tyra-5-ui
        'tyra-export': urls.commons + "/public/js/tyra-5/export", // used in dashboard-app
        'tyra-5/static/js/export': urls.commons + "/public/js/tyra-5/export", // simlink of tyra-export, used in dashboard-app
        'tyra-5/static/js/tiles/sentiment/index': urls.commons + "/public/js/tyra-5/tiles/sentiment/index", // used in dashboard-app
        'tyra-5/static/js/compset-share-manager': urls.commons + "/public/js/tyra-5/compset-share-manager", // used in dashboard-app
        'tyra-5/static/js/common/chooser': urls.commons + "/public/js/tyra-5/common/chooser", // used in dashboard-app
        // goals/tasks dependencies
        'assignments-export-module': urls.commons + "/public/js/tyra-5/assignments/export/assignments-export-module", // used in init-slidepane.js and sidePanels.js
        'assignments-export': urls.commons + "/public/js/tyra-5/assignments/export/assignments-export", // needed for export-app
        'tyra-5/static/js/apps_bootstrap/assignments': urls.commons + "/public/js/tyra-5/assignments/bootstrap", // used in tyra-5-ui
        // settings dependencies
        'tyra-5/static/js/views/settings/basic': urls.commons + "/public/js/tyra-5/views/settings/basic",
        'tyra-5/static/js/views/settings/alerts': urls.commons + "/public/js/tyra-5/views/settings/alerts",
        'tyra-5/static/js/views/settings/response_templates': urls.commons + "/public/js/tyra-5/views/settings/response_templates",
        'tyra-5/static/js/views/settings/pms_integrations': urls.commons + "/public/js/tyra-5/views/settings/pms_integrations",
        'tyra-5/static/js/views/settings/direct_responses': urls.commons + "/public/js/tyra-5/views/settings/direct_responses",
        // other tyra-5 modules
        'rss-reader': urls.commons + "/public/js/tyra-5/common/rss-reader", // only used in metaresponse-app
        MessageDirectionTileSpec: urls.commons + "/public/js/tyra-5/tiles/messageDirection/tile", // messaging tile in analytics, candidate for deprecation
        'user-events-manager': urls.commons + "/public/js/tyra-5/user-events-manager" // only used in products-app, candidate for deprecation
      }
    },

    shim: {
      'settings-ui': { deps: ['react', 'react-dom', 'css!settings-ui-css'], exports: 'settings-ui' },
      jadeRuntime: { exports: 'jade' },
      jquerySelectorProfile: { deps: ['jquery'], exports: 'jQuery.profile' },
      'jquery-ui-plugins': { deps: ['jquery', 'css!jquery-ui-custom-css'], exports: 'jQuery.fn.tabs' },
      'jquery-ui': { deps: ['jquery-ui-plugins'], exports: 'jQuery.widget' },
      'jquery-tmpl': { deps: ['jquery'], exports: 'jQuery.tmpl' },
      'jquery-sidr': { deps: ['jquery'], exports: 'jQuery.fn.sidr' },
      expanding: { deps: ['jquery'], exports: 'jQuery.fn.expanding' },
      'jquery-ui-selectmenu': {
        deps: ['jquery', 'jquery-ui', 'css!jquery-ui-selectmenu-css'],
        exports: 'jQuery.fn.selectmenu'
      },
      'jquery-base64': { deps: ['jquery'], exports: 'jQuery.base64' },
      'jquery-truncate': { deps: ['jquery'], exports: 'jQuery.fn.truncate' },
      'jquery-textfill': { deps: ['jquery'], exports: 'jQuery.fn.textfill' },
      waitForImages: { deps: ['jquery'], exports: 'jQuery.fn.waitForImages' },
      easing: { deps: ['jquery'] },
      'textext-core': { deps: ['jquery', 'css!textext-core-css'], exports: 'jQuery.textext' },
      'textext-tags': { deps: ['textext-core', 'css!textext-tags-css'], exports: 'jQuery.fn.textext.TextExtTags' },
      fancybox: { deps: ['jquery', 'easing', 'css!fancyboxCss'], exports: 'jQuery.fancybox' },
      datejs: { exports: 'Date.CultureInfo' }, // Just to know if the script was loaded successfully
      hashchange: { deps: ['jquery'], exports: 'jQuery.fn.hashchange' },
      verge: { exports: 'verge' },
      qTip: { deps: ['css!qTipCss'], exports: 'jQuery.fn.qtip' },
      waves: { deps: ['css!wavesCss'], exports: 'Waves' },
      select2: {
        deps: ['jquery', "css!" + urls.commons + "/public/3rd-party/select2-3.4.5/select2"],
        exports: 'jQuery.fn.select2'
      },
      'jquery.multiselect.raw': {
        deps: ['jquery', 'jquery-ui', "css!" + urls.commons + "/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect"],
        exports: 'jQuery.ech.multiselect'
      },
      'jquery.multiselect.filter': {
        deps: ['jquery.multiselect.raw', "css!" + urls.commons + "/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.filter"],
        exports: 'jQuery.ech.multiselectfilter'
      },
      'jquery.multiselect': {
        deps: ['jquery.multiselect.filter'],
        exports: 'jQuery.ty.multiselectcustomfilter'
      },

      // apps

      'tasks-app': {
        deps: ['jquery', 'jquery-ui', 'goog!visualization,1,packages:[table]', 'fancybox', 'jquery-tmpl', apps['tasks-app-css']],
        exports: 'tasks'
      },
      'goals-app': {
        deps: ['jquery', 'jquery-ui', 'goog!visualization,1,packages:[table]', 'fancybox', 'jquery-tmpl', apps['goals-app-css']],
        exports: 'goals'
      },
      'dashboard-export': {
        deps: ['jquery', 'jquery-tmpl', 'jquery-textfill', 'moment', 'iframeResizer', 'goals-app', 'tasks-app', 'timedropdown-v2', 'goog!visualization,1,packages:[table,corechart,gauge]', 'font!google,families:[Roboto:300,Roboto:400,Roboto:500,Roboto:700]', 'table', 'single-barchart', 'wordcloud', 'donutchart', apps['dashboard-export-css'], apps['social-agg-css'], apps['export-app-dashboard-css']],
        exports: 'tyra.dashboard.renderHtmlReport'
      },
      'survey-app': {
        deps: ['jquery', 'jquery-tmpl', 'jquery-textfill', 'jquery-base64', 'jquery-cookie', 'goog!visualization,1,packages:[table,corechart,gauge]', 'review-plugins', 'moment', 'timedropdown-v2', apps['survey-app-css'], 'css!dashboard-css', 'accordion', 'table', 'paginator'],
        exports: 'surveys'
      },
      'survey-export': {
        deps: ['jquery', 'jquery-tmpl', 'jquery-cookie', 'jquery-base64', 'timedropdown-v2', 'goog!visualization,1,packages:[corechart]', apps['survey-export-css'], 'survey-app'],
        exports: 'TYAPP_SURVEYS.exporter.exportSurvey'
      },
      'users-app': {
        deps: ['jquery', 'jquery-tmpl', 'jquery-ui', "css!" + urls.sso + "/static/css/userstyles"],
        exports: 'jQuery.fn.UserLoginAs'
      },

      // bootstrap files for the web and export pages
      'export-bootstrap': { deps: [apps['export-bootstrap-css']] },
      'tyra-bootstrap': { deps: [apps['tyra-bootstrap-css']] },

      // Facebook External SDK
      _facebook_external: { exports: 'FB' },
      Cyclops: { deps: ['css!cyclops-css'], exports: 'Cyclops' },
      survey_ui: { deps: ['css!survey_ui-css'], exports: 'survey_ui' },
      'phoenix-socket': { exports: 'Socket' }
    }
  };

  require.bundles = {};
  require.bundles[apps['export-app']] = [urls.export_app + "/static/js/plugins/all"];
  require.bundles[apps['dashboard-agg']] = [urls.dashboard + "/static/js/plugins", urls.dashboard + "/static/js/predefined"];
  require.bundles[apps['review-plugins']] = [urls.reviews + "/static/js/review-plugins.agg"];
  require.bundles[apps['review-export-agg']] = [urls.reviews + "/static/js/export/export-api"];
  require.bundles[apps['social-agg']] = [urls.social + "/js/social-plugins"];
  require.bundles[apps['social-export-agg']] = [urls.social + "/js/export/export-api"];
  require.bundles[apps['meta-response-app']] = [urls.metaresponse + "/public/js/metaresponse/metaresponse-plugin"];
  require.bundles[apps['meta-response-export']] = [urls.metaresponse + "/public/js/export/export-api"];
  require.bundles[apps['hotel-admin-app']] = [urls.hoteladmin + "/public/js/hoteladmin/hoteladmin-plugin"];
  require.bundles[apps['portfolio-app']] = [urls.portfolio + "/static/js/portfolio.agg"];

  // For some reason the exports need all the modules to be specified in the bundle config
  require.bundles[apps['portfolio-agg-export']] = [urls.portfolio + "/static/js/export/comparison-detail", urls.portfolio + "/static/js/export/comparison-overview", urls.portfolio + "/static/js/export/constants", urls.portfolio + "/static/js/export/custom", urls.portfolio + "/static/js/export/export-api", urls.portfolio + "/static/js/export/goals", urls.portfolio + "/static/js/export/login-tracking", urls.portfolio + "/static/js/export/performance", urls.portfolio + "/static/js/export/popularity", urls.portfolio + "/static/js/export/portfolio-detail", urls.portfolio + "/static/js/export/portfolio-overview", urls.portfolio + "/static/js/export/presets-comparison", urls.portfolio + "/static/js/export/presets", urls.portfolio + "/static/js/export/responses", urls.portfolio + "/static/js/export/reviews", urls.portfolio + "/static/js/export/sentiment", urls.portfolio + "/static/js/export/social", urls.portfolio + "/static/js/export/tasks", urls.portfolio + "/static/js/export/templates", urls.portfolio + "/static/js/export/tripadvisor", urls.portfolio + "/static/js/export/trustscore"];
  require.bundles[apps['users-utils']] = ['sso/static/js/users-utils/utils'];
  require.bundles[apps['users-management']] = ['sso/static/js/users-management/all'];
  require.bundles[apps['products-app']] = [urls.products + "/static/js/products.min"];

  /*
   OMG!!!! this makes puppies cry
    What happens is that this export utils file is needed also for the web app, but we don't want to load
   it from this bundle which includes other export scripts. And so, we add it only if the html is loaded from exports.
   */
  if (location.pathname.indexOf(urls.export_app) !== -1) {
    require.bundles[apps['portfolio-agg-export']].push(urls.portfolio + "/static/js/export/utils");
  }
})();
/** vim: et:ts=4:sw=4:sts=4
 * @license RequireJS 2.3.2 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, https://github.com/requirejs/requirejs/blob/master/LICENSE
 */
//Not using strict: uneven strict support in browsers, #392, and causes
//problems with requirejs.exec()/transpiler plugins that may not be strict.
/*jslint regexp: true, nomen: true, sloppy: true */
/*global window, navigator, document, importScripts, setTimeout, opera */

var requirejs, require, define;
(function (global, setTimeout) {
    var req, s, head, baseElement, dataMain, src,
        interactiveScript, currentlyAddingScript, mainScript, subPath,
        version = '2.3.2',
        commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/mg,
        cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
        jsSuffixRegExp = /\.js$/,
        currDirRegExp = /^\.\//,
        op = Object.prototype,
        ostring = op.toString,
        hasOwn = op.hasOwnProperty,
        isBrowser = !!(typeof window !== 'undefined' && typeof navigator !== 'undefined' && window.document),
        isWebWorker = !isBrowser && typeof importScripts !== 'undefined',
        //PS3 indicates loaded and complete, but need to wait for complete
        //specifically. Sequence is 'loading', 'loaded', execution,
        // then 'complete'. The UA check is unfortunate, but not sure how
        //to feature test w/o causing perf issues.
        readyRegExp = isBrowser && navigator.platform === 'PLAYSTATION 3' ?
                      /^complete$/ : /^(complete|loaded)$/,
        defContextName = '_',
        //Oh the tragedy, detecting opera. See the usage of isOpera for reason.
        isOpera = typeof opera !== 'undefined' && opera.toString() === '[object Opera]',
        contexts = {},
        cfg = {},
        globalDefQueue = [],
        useInteractive = false;

    //Could match something like ')//comment', do not lose the prefix to comment.
    function commentReplace(match, singlePrefix) {
        return singlePrefix || '';
    }

    function isFunction(it) {
        return ostring.call(it) === '[object Function]';
    }

    function isArray(it) {
        return ostring.call(it) === '[object Array]';
    }

    /**
     * Helper function for iterating over an array. If the func returns
     * a true value, it will break out of the loop.
     */
    function each(ary, func) {
        if (ary) {
            var i;
            for (i = 0; i < ary.length; i += 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    /**
     * Helper function for iterating over an array backwards. If the func
     * returns a true value, it will break out of the loop.
     */
    function eachReverse(ary, func) {
        if (ary) {
            var i;
            for (i = ary.length - 1; i > -1; i -= 1) {
                if (ary[i] && func(ary[i], i, ary)) {
                    break;
                }
            }
        }
    }

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    function getOwn(obj, prop) {
        return hasProp(obj, prop) && obj[prop];
    }

    /**
     * Cycles over properties in an object and calls a function for each
     * property value. If the function returns a truthy value, then the
     * iteration is stopped.
     */
    function eachProp(obj, func) {
        var prop;
        for (prop in obj) {
            if (hasProp(obj, prop)) {
                if (func(obj[prop], prop)) {
                    break;
                }
            }
        }
    }

    /**
     * Simple function to mix in properties from source into target,
     * but only if target does not already have a property of the same name.
     */
    function mixin(target, source, force, deepStringMixin) {
        if (source) {
            eachProp(source, function (value, prop) {
                if (force || !hasProp(target, prop)) {
                    if (deepStringMixin && typeof value === 'object' && value &&
                        !isArray(value) && !isFunction(value) &&
                        !(value instanceof RegExp)) {

                        if (!target[prop]) {
                            target[prop] = {};
                        }
                        mixin(target[prop], value, force, deepStringMixin);
                    } else {
                        target[prop] = value;
                    }
                }
            });
        }
        return target;
    }

    //Similar to Function.prototype.bind, but the 'this' object is specified
    //first, since it is easier to read/figure out what 'this' will be.
    function bind(obj, fn) {
        return function () {
            return fn.apply(obj, arguments);
        };
    }

    function scripts() {
        return document.getElementsByTagName('script');
    }

    function defaultOnError(err) {
        throw err;
    }

    //Allow getting a global that is expressed in
    //dot notation, like 'a.b.c'.
    function getGlobal(value) {
        if (!value) {
            return value;
        }
        var g = global;
        each(value.split('.'), function (part) {
            g = g[part];
        });
        return g;
    }

    /**
     * Constructs an error with a pointer to an URL with more information.
     * @param {String} id the error ID that maps to an ID on a web page.
     * @param {String} message human readable error.
     * @param {Error} [err] the original error, if there is one.
     *
     * @returns {Error}
     */
    function makeError(id, msg, err, requireModules) {
        var e = new Error(msg + '\nhttp://requirejs.org/docs/errors.html#' + id);
        e.requireType = id;
        e.requireModules = requireModules;
        if (err) {
            e.originalError = err;
        }
        return e;
    }

    if (typeof define !== 'undefined') {
        //If a define is already in play via another AMD loader,
        //do not overwrite.
        return;
    }

    if (typeof requirejs !== 'undefined') {
        if (isFunction(requirejs)) {
            //Do not overwrite an existing requirejs instance.
            return;
        }
        cfg = requirejs;
        requirejs = undefined;
    }

    //Allow for a require config object
    if (typeof require !== 'undefined' && !isFunction(require)) {
        //assume it is a config object.
        cfg = require;
        require = undefined;
    }

    function newContext(contextName) {
        var inCheckLoaded, Module, context, handlers,
            checkLoadedTimeoutId,
            config = {
                //Defaults. Do not set a default for map
                //config to speed up normalize(), which
                //will run faster if there is no default.
                waitSeconds: 7,
                baseUrl: './',
                paths: {},
                bundles: {},
                pkgs: {},
                shim: {},
                config: {}
            },
            registry = {},
            //registry of just enabled modules, to speed
            //cycle breaking code when lots of modules
            //are registered, but not activated.
            enabledRegistry = {},
            undefEvents = {},
            defQueue = [],
            defined = {},
            urlFetched = {},
            bundlesMap = {},
            requireCounter = 1,
            unnormalizedCounter = 1;

        /**
         * Trims the . and .. from an array of path segments.
         * It will keep a leading path segment if a .. will become
         * the first path segment, to help with module name lookups,
         * which act like paths, but can be remapped. But the end result,
         * all paths that use this function should look normalized.
         * NOTE: this method MODIFIES the input array.
         * @param {Array} ary the array of path segments.
         */
        function trimDots(ary) {
            var i, part;
            for (i = 0; i < ary.length; i++) {
                part = ary[i];
                if (part === '.') {
                    ary.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || (i === 1 && ary[2] === '..') || ary[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        ary.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
        }

        /**
         * Given a relative module name, like ./something, normalize it to
         * a real name that can be mapped to a path.
         * @param {String} name the relative name
         * @param {String} baseName a real name that the name arg is relative
         * to.
         * @param {Boolean} applyMap apply the map config to the value. Should
         * only be done if this normalization is for a dependency ID.
         * @returns {String} normalized name
         */
        function normalize(name, baseName, applyMap) {
            var pkgMain, mapValue, nameParts, i, j, nameSegment, lastIndex,
                foundMap, foundI, foundStarMap, starI, normalizedBaseParts,
                baseParts = (baseName && baseName.split('/')),
                map = config.map,
                starMap = map && map['*'];

            //Adjust any relative paths.
            if (name) {
                name = name.split('/');
                lastIndex = name.length - 1;

                // If wanting node ID compatibility, strip .js from end
                // of IDs. Have to do this here, and not in nameToUrl
                // because node allows either .js or non .js to map
                // to same file.
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                // Starts with a '.' so need the baseName
                if (name[0].charAt(0) === '.' && baseParts) {
                    //Convert baseName to array, and lop off the last part,
                    //so that . matches that 'directory' and not name of the baseName's
                    //module. For instance, baseName of 'one/two/three', maps to
                    //'one/two/three.js', but we want the directory, 'one/two' for
                    //this normalization.
                    normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                    name = normalizedBaseParts.concat(name);
                }

                trimDots(name);
                name = name.join('/');
            }

            //Apply map config if available.
            if (applyMap && map && (baseParts || starMap)) {
                nameParts = name.split('/');

                outerLoop: for (i = nameParts.length; i > 0; i -= 1) {
                    nameSegment = nameParts.slice(0, i).join('/');

                    if (baseParts) {
                        //Find the longest baseName segment match in the config.
                        //So, do joins on the biggest to smallest lengths of baseParts.
                        for (j = baseParts.length; j > 0; j -= 1) {
                            mapValue = getOwn(map, baseParts.slice(0, j).join('/'));

                            //baseName segment has config, find if it has one for
                            //this name.
                            if (mapValue) {
                                mapValue = getOwn(mapValue, nameSegment);
                                if (mapValue) {
                                    //Match, update name to the new value.
                                    foundMap = mapValue;
                                    foundI = i;
                                    break outerLoop;
                                }
                            }
                        }
                    }

                    //Check for a star map match, but just hold on to it,
                    //if there is a shorter segment match later in a matching
                    //config, then favor over this star map.
                    if (!foundStarMap && starMap && getOwn(starMap, nameSegment)) {
                        foundStarMap = getOwn(starMap, nameSegment);
                        starI = i;
                    }
                }

                if (!foundMap && foundStarMap) {
                    foundMap = foundStarMap;
                    foundI = starI;
                }

                if (foundMap) {
                    nameParts.splice(0, foundI, foundMap);
                    name = nameParts.join('/');
                }
            }

            // If the name points to a package's name, use
            // the package main instead.
            pkgMain = getOwn(config.pkgs, name);

            return pkgMain ? pkgMain : name;
        }

        function removeScript(name) {
            if (isBrowser) {
                each(scripts(), function (scriptNode) {
                    if (scriptNode.getAttribute('data-requiremodule') === name &&
                            scriptNode.getAttribute('data-requirecontext') === context.contextName) {
                        scriptNode.parentNode.removeChild(scriptNode);
                        return true;
                    }
                });
            }
        }

        function hasPathFallback(id) {
            var pathConfig = getOwn(config.paths, id);
            if (pathConfig && isArray(pathConfig) && pathConfig.length > 1) {
                //Pop off the first array value, since it failed, and
                //retry
                pathConfig.shift();
                context.require.undef(id);

                //Custom require that does not do map translation, since
                //ID is "absolute", already mapped/resolved.
                context.makeRequire(null, {
                    skipMap: true
                })([id]);

                return true;
            }
        }

        //Turns a plugin!resource to [plugin, resource]
        //with the plugin being undefined if the name
        //did not have a plugin prefix.
        function splitPrefix(name) {
            var prefix,
                index = name ? name.indexOf('!') : -1;
            if (index > -1) {
                prefix = name.substring(0, index);
                name = name.substring(index + 1, name.length);
            }
            return [prefix, name];
        }

        /**
         * Creates a module mapping that includes plugin prefix, module
         * name, and path. If parentModuleMap is provided it will
         * also normalize the name via require.normalize()
         *
         * @param {String} name the module name
         * @param {String} [parentModuleMap] parent module map
         * for the module name, used to resolve relative names.
         * @param {Boolean} isNormalized: is the ID already normalized.
         * This is true if this call is done for a define() module ID.
         * @param {Boolean} applyMap: apply the map config to the ID.
         * Should only be true if this map is for a dependency.
         *
         * @returns {Object}
         */
        function makeModuleMap(name, parentModuleMap, isNormalized, applyMap) {
            var url, pluginModule, suffix, nameParts,
                prefix = null,
                parentName = parentModuleMap ? parentModuleMap.name : null,
                originalName = name,
                isDefine = true,
                normalizedName = '';

            //If no name, then it means it is a require call, generate an
            //internal name.
            if (!name) {
                isDefine = false;
                name = '_@r' + (requireCounter += 1);
            }

            nameParts = splitPrefix(name);
            prefix = nameParts[0];
            name = nameParts[1];

            if (prefix) {
                prefix = normalize(prefix, parentName, applyMap);
                pluginModule = getOwn(defined, prefix);
            }

            //Account for relative paths if there is a base name.
            if (name) {
                if (prefix) {
                    if (pluginModule && pluginModule.normalize) {
                        //Plugin is loaded, use its normalize method.
                        normalizedName = pluginModule.normalize(name, function (name) {
                            return normalize(name, parentName, applyMap);
                        });
                    } else {
                        // If nested plugin references, then do not try to
                        // normalize, as it will not normalize correctly. This
                        // places a restriction on resourceIds, and the longer
                        // term solution is not to normalize until plugins are
                        // loaded and all normalizations to allow for async
                        // loading of a loader plugin. But for now, fixes the
                        // common uses. Details in #1131
                        normalizedName = name.indexOf('!') === -1 ?
                                         normalize(name, parentName, applyMap) :
                                         name;
                    }
                } else {
                    //A regular module.
                    normalizedName = normalize(name, parentName, applyMap);

                    //Normalized name may be a plugin ID due to map config
                    //application in normalize. The map config values must
                    //already be normalized, so do not need to redo that part.
                    nameParts = splitPrefix(normalizedName);
                    prefix = nameParts[0];
                    normalizedName = nameParts[1];
                    isNormalized = true;

                    url = context.nameToUrl(normalizedName);
                }
            }

            //If the id is a plugin id that cannot be determined if it needs
            //normalization, stamp it with a unique ID so two matching relative
            //ids that may conflict can be separate.
            suffix = prefix && !pluginModule && !isNormalized ?
                     '_unnormalized' + (unnormalizedCounter += 1) :
                     '';

            return {
                prefix: prefix,
                name: normalizedName,
                parentMap: parentModuleMap,
                unnormalized: !!suffix,
                url: url,
                originalName: originalName,
                isDefine: isDefine,
                id: (prefix ?
                        prefix + '!' + normalizedName :
                        normalizedName) + suffix
            };
        }

        function getModule(depMap) {
            var id = depMap.id,
                mod = getOwn(registry, id);

            if (!mod) {
                mod = registry[id] = new context.Module(depMap);
            }

            return mod;
        }

        function on(depMap, name, fn) {
            var id = depMap.id,
                mod = getOwn(registry, id);

            if (hasProp(defined, id) &&
                    (!mod || mod.defineEmitComplete)) {
                if (name === 'defined') {
                    fn(defined[id]);
                }
            } else {
                mod = getModule(depMap);
                if (mod.error && name === 'error') {
                    fn(mod.error);
                } else {
                    mod.on(name, fn);
                }
            }
        }

        function onError(err, errback) {
            var ids = err.requireModules,
                notified = false;

            if (errback) {
                errback(err);
            } else {
                each(ids, function (id) {
                    var mod = getOwn(registry, id);
                    if (mod) {
                        //Set error on module, so it skips timeout checks.
                        mod.error = err;
                        if (mod.events.error) {
                            notified = true;
                            mod.emit('error', err);
                        }
                    }
                });

                if (!notified) {
                    req.onError(err);
                }
            }
        }

        /**
         * Internal method to transfer globalQueue items to this context's
         * defQueue.
         */
        function takeGlobalQueue() {
            //Push all the globalDefQueue items into the context's defQueue
            if (globalDefQueue.length) {
                each(globalDefQueue, function(queueItem) {
                    var id = queueItem[0];
                    if (typeof id === 'string') {
                        context.defQueueMap[id] = true;
                    }
                    defQueue.push(queueItem);
                });
                globalDefQueue = [];
            }
        }

        handlers = {
            'require': function (mod) {
                if (mod.require) {
                    return mod.require;
                } else {
                    return (mod.require = context.makeRequire(mod.map));
                }
            },
            'exports': function (mod) {
                mod.usingExports = true;
                if (mod.map.isDefine) {
                    if (mod.exports) {
                        return (defined[mod.map.id] = mod.exports);
                    } else {
                        return (mod.exports = defined[mod.map.id] = {});
                    }
                }
            },
            'module': function (mod) {
                if (mod.module) {
                    return mod.module;
                } else {
                    return (mod.module = {
                        id: mod.map.id,
                        uri: mod.map.url,
                        config: function () {
                            return getOwn(config.config, mod.map.id) || {};
                        },
                        exports: mod.exports || (mod.exports = {})
                    });
                }
            }
        };

        function cleanRegistry(id) {
            //Clean up machinery used for waiting modules.
            delete registry[id];
            delete enabledRegistry[id];
        }

        function breakCycle(mod, traced, processed) {
            var id = mod.map.id;

            if (mod.error) {
                mod.emit('error', mod.error);
            } else {
                traced[id] = true;
                each(mod.depMaps, function (depMap, i) {
                    var depId = depMap.id,
                        dep = getOwn(registry, depId);

                    //Only force things that have not completed
                    //being defined, so still in the registry,
                    //and only if it has not been matched up
                    //in the module already.
                    if (dep && !mod.depMatched[i] && !processed[depId]) {
                        if (getOwn(traced, depId)) {
                            mod.defineDep(i, defined[depId]);
                            mod.check(); //pass false?
                        } else {
                            breakCycle(dep, traced, processed);
                        }
                    }
                });
                processed[id] = true;
            }
        }

        function checkLoaded() {
            var err, usingPathFallback,
                waitInterval = config.waitSeconds * 1000,
                //It is possible to disable the wait interval by using waitSeconds of 0.
                expired = waitInterval && (context.startTime + waitInterval) < new Date().getTime(),
                noLoads = [],
                reqCalls = [],
                stillLoading = false,
                needCycleCheck = true;

            //Do not bother if this call was a result of a cycle break.
            if (inCheckLoaded) {
                return;
            }

            inCheckLoaded = true;

            //Figure out the state of all the modules.
            eachProp(enabledRegistry, function (mod) {
                var map = mod.map,
                    modId = map.id;

                //Skip things that are not enabled or in error state.
                if (!mod.enabled) {
                    return;
                }

                if (!map.isDefine) {
                    reqCalls.push(mod);
                }

                if (!mod.error) {
                    //If the module should be executed, and it has not
                    //been inited and time is up, remember it.
                    if (!mod.inited && expired) {
                        if (hasPathFallback(modId)) {
                            usingPathFallback = true;
                            stillLoading = true;
                        } else {
                            noLoads.push(modId);
                            removeScript(modId);
                        }
                    } else if (!mod.inited && mod.fetched && map.isDefine) {
                        stillLoading = true;
                        if (!map.prefix) {
                            //No reason to keep looking for unfinished
                            //loading. If the only stillLoading is a
                            //plugin resource though, keep going,
                            //because it may be that a plugin resource
                            //is waiting on a non-plugin cycle.
                            return (needCycleCheck = false);
                        }
                    }
                }
            });

            if (expired && noLoads.length) {
                //If wait time expired, throw error of unloaded modules.
                err = makeError('timeout', 'Load timeout for modules: ' + noLoads, null, noLoads);
                err.contextName = context.contextName;
                return onError(err);
            }

            //Not expired, check for a cycle.
            if (needCycleCheck) {
                each(reqCalls, function (mod) {
                    breakCycle(mod, {}, {});
                });
            }

            //If still waiting on loads, and the waiting load is something
            //other than a plugin resource, or there are still outstanding
            //scripts, then just try back later.
            if ((!expired || usingPathFallback) && stillLoading) {
                //Something is still waiting to load. Wait for it, but only
                //if a timeout is not already in effect.
                if ((isBrowser || isWebWorker) && !checkLoadedTimeoutId) {
                    checkLoadedTimeoutId = setTimeout(function () {
                        checkLoadedTimeoutId = 0;
                        checkLoaded();
                    }, 50);
                }
            }

            inCheckLoaded = false;
        }

        Module = function (map) {
            this.events = getOwn(undefEvents, map.id) || {};
            this.map = map;
            this.shim = getOwn(config.shim, map.id);
            this.depExports = [];
            this.depMaps = [];
            this.depMatched = [];
            this.pluginMaps = {};
            this.depCount = 0;

            /* this.exports this.factory
               this.depMaps = [],
               this.enabled, this.fetched
            */
        };

        Module.prototype = {
            init: function (depMaps, factory, errback, options) {
                options = options || {};

                //Do not do more inits if already done. Can happen if there
                //are multiple define calls for the same module. That is not
                //a normal, common case, but it is also not unexpected.
                if (this.inited) {
                    return;
                }

                this.factory = factory;

                if (errback) {
                    //Register for errors on this module.
                    this.on('error', errback);
                } else if (this.events.error) {
                    //If no errback already, but there are error listeners
                    //on this module, set up an errback to pass to the deps.
                    errback = bind(this, function (err) {
                        this.emit('error', err);
                    });
                }

                //Do a copy of the dependency array, so that
                //source inputs are not modified. For example
                //"shim" deps are passed in here directly, and
                //doing a direct modification of the depMaps array
                //would affect that config.
                this.depMaps = depMaps && depMaps.slice(0);

                this.errback = errback;

                //Indicate this module has be initialized
                this.inited = true;

                this.ignore = options.ignore;

                //Could have option to init this module in enabled mode,
                //or could have been previously marked as enabled. However,
                //the dependencies are not known until init is called. So
                //if enabled previously, now trigger dependencies as enabled.
                if (options.enabled || this.enabled) {
                    //Enable this module and dependencies.
                    //Will call this.check()
                    this.enable();
                } else {
                    this.check();
                }
            },

            defineDep: function (i, depExports) {
                //Because of cycles, defined callback for a given
                //export can be called more than once.
                if (!this.depMatched[i]) {
                    this.depMatched[i] = true;
                    this.depCount -= 1;
                    this.depExports[i] = depExports;
                }
            },

            fetch: function () {
                if (this.fetched) {
                    return;
                }
                this.fetched = true;

                context.startTime = (new Date()).getTime();

                var map = this.map;

                //If the manager is for a plugin managed resource,
                //ask the plugin to load it now.
                if (this.shim) {
                    context.makeRequire(this.map, {
                        enableBuildCallback: true
                    })(this.shim.deps || [], bind(this, function () {
                        return map.prefix ? this.callPlugin() : this.load();
                    }));
                } else {
                    //Regular dependency.
                    return map.prefix ? this.callPlugin() : this.load();
                }
            },

            load: function () {
                var url = this.map.url;

                //Regular dependency.
                if (!urlFetched[url]) {
                    urlFetched[url] = true;
                    context.load(this.map.id, url);
                }
            },

            /**
             * Checks if the module is ready to define itself, and if so,
             * define it.
             */
            check: function () {
                if (!this.enabled || this.enabling) {
                    return;
                }

                var err, cjsModule,
                    id = this.map.id,
                    depExports = this.depExports,
                    exports = this.exports,
                    factory = this.factory;

                if (!this.inited) {
                    // Only fetch if not already in the defQueue.
                    if (!hasProp(context.defQueueMap, id)) {
                        this.fetch();
                    }
                } else if (this.error) {
                    this.emit('error', this.error);
                } else if (!this.defining) {
                    //The factory could trigger another require call
                    //that would result in checking this module to
                    //define itself again. If already in the process
                    //of doing that, skip this work.
                    this.defining = true;

                    if (this.depCount < 1 && !this.defined) {
                        if (isFunction(factory)) {
                            //If there is an error listener, favor passing
                            //to that instead of throwing an error. However,
                            //only do it for define()'d  modules. require
                            //errbacks should not be called for failures in
                            //their callbacks (#699). However if a global
                            //onError is set, use that.
                            if ((this.events.error && this.map.isDefine) ||
                                req.onError !== defaultOnError) {
                                try {
                                    exports = context.execCb(id, factory, depExports, exports);
                                } catch (e) {
                                    err = e;
                                }
                            } else {
                                exports = context.execCb(id, factory, depExports, exports);
                            }

                            // Favor return value over exports. If node/cjs in play,
                            // then will not have a return value anyway. Favor
                            // module.exports assignment over exports object.
                            if (this.map.isDefine && exports === undefined) {
                                cjsModule = this.module;
                                if (cjsModule) {
                                    exports = cjsModule.exports;
                                } else if (this.usingExports) {
                                    //exports already set the defined value.
                                    exports = this.exports;
                                }
                            }

                            if (err) {
                                err.requireMap = this.map;
                                err.requireModules = this.map.isDefine ? [this.map.id] : null;
                                err.requireType = this.map.isDefine ? 'define' : 'require';
                                return onError((this.error = err));
                            }

                        } else {
                            //Just a literal value
                            exports = factory;
                        }

                        this.exports = exports;

                        if (this.map.isDefine && !this.ignore) {
                            defined[id] = exports;

                            if (req.onResourceLoad) {
                                var resLoadMaps = [];
                                each(this.depMaps, function (depMap) {
                                    resLoadMaps.push(depMap.normalizedMap || depMap);
                                });
                                req.onResourceLoad(context, this.map, resLoadMaps);
                            }
                        }

                        //Clean up
                        cleanRegistry(id);

                        this.defined = true;
                    }

                    //Finished the define stage. Allow calling check again
                    //to allow define notifications below in the case of a
                    //cycle.
                    this.defining = false;

                    if (this.defined && !this.defineEmitted) {
                        this.defineEmitted = true;
                        this.emit('defined', this.exports);
                        this.defineEmitComplete = true;
                    }

                }
            },

            callPlugin: function () {
                var map = this.map,
                    id = map.id,
                    //Map already normalized the prefix.
                    pluginMap = makeModuleMap(map.prefix);

                //Mark this as a dependency for this plugin, so it
                //can be traced for cycles.
                this.depMaps.push(pluginMap);

                on(pluginMap, 'defined', bind(this, function (plugin) {
                    var load, normalizedMap, normalizedMod,
                        bundleId = getOwn(bundlesMap, this.map.id),
                        name = this.map.name,
                        parentName = this.map.parentMap ? this.map.parentMap.name : null,
                        localRequire = context.makeRequire(map.parentMap, {
                            enableBuildCallback: true
                        });

                    //If current map is not normalized, wait for that
                    //normalized name to load instead of continuing.
                    if (this.map.unnormalized) {
                        //Normalize the ID if the plugin allows it.
                        if (plugin.normalize) {
                            name = plugin.normalize(name, function (name) {
                                return normalize(name, parentName, true);
                            }) || '';
                        }

                        //prefix and name should already be normalized, no need
                        //for applying map config again either.
                        normalizedMap = makeModuleMap(map.prefix + '!' + name,
                                                      this.map.parentMap);
                        on(normalizedMap,
                            'defined', bind(this, function (value) {
                                this.map.normalizedMap = normalizedMap;
                                this.init([], function () { return value; }, null, {
                                    enabled: true,
                                    ignore: true
                                });
                            }));

                        normalizedMod = getOwn(registry, normalizedMap.id);
                        if (normalizedMod) {
                            //Mark this as a dependency for this plugin, so it
                            //can be traced for cycles.
                            this.depMaps.push(normalizedMap);

                            if (this.events.error) {
                                normalizedMod.on('error', bind(this, function (err) {
                                    this.emit('error', err);
                                }));
                            }
                            normalizedMod.enable();
                        }

                        return;
                    }

                    //If a paths config, then just load that file instead to
                    //resolve the plugin, as it is built into that paths layer.
                    if (bundleId) {
                        this.map.url = context.nameToUrl(bundleId);
                        this.load();
                        return;
                    }

                    load = bind(this, function (value) {
                        this.init([], function () { return value; }, null, {
                            enabled: true
                        });
                    });

                    load.error = bind(this, function (err) {
                        this.inited = true;
                        this.error = err;
                        err.requireModules = [id];

                        //Remove temp unnormalized modules for this module,
                        //since they will never be resolved otherwise now.
                        eachProp(registry, function (mod) {
                            if (mod.map.id.indexOf(id + '_unnormalized') === 0) {
                                cleanRegistry(mod.map.id);
                            }
                        });

                        onError(err);
                    });

                    //Allow plugins to load other code without having to know the
                    //context or how to 'complete' the load.
                    load.fromText = bind(this, function (text, textAlt) {
                        /*jslint evil: true */
                        var moduleName = map.name,
                            moduleMap = makeModuleMap(moduleName),
                            hasInteractive = useInteractive;

                        //As of 2.1.0, support just passing the text, to reinforce
                        //fromText only being called once per resource. Still
                        //support old style of passing moduleName but discard
                        //that moduleName in favor of the internal ref.
                        if (textAlt) {
                            text = textAlt;
                        }

                        //Turn off interactive script matching for IE for any define
                        //calls in the text, then turn it back on at the end.
                        if (hasInteractive) {
                            useInteractive = false;
                        }

                        //Prime the system by creating a module instance for
                        //it.
                        getModule(moduleMap);

                        //Transfer any config to this other module.
                        if (hasProp(config.config, id)) {
                            config.config[moduleName] = config.config[id];
                        }

                        try {
                            req.exec(text);
                        } catch (e) {
                            return onError(makeError('fromtexteval',
                                             'fromText eval for ' + id +
                                            ' failed: ' + e,
                                             e,
                                             [id]));
                        }

                        if (hasInteractive) {
                            useInteractive = true;
                        }

                        //Mark this as a dependency for the plugin
                        //resource
                        this.depMaps.push(moduleMap);

                        //Support anonymous modules.
                        context.completeLoad(moduleName);

                        //Bind the value of that module to the value for this
                        //resource ID.
                        localRequire([moduleName], load);
                    });

                    //Use parentName here since the plugin's name is not reliable,
                    //could be some weird string with no path that actually wants to
                    //reference the parentName's path.
                    plugin.load(map.name, localRequire, load, config);
                }));

                context.enable(pluginMap, this);
                this.pluginMaps[pluginMap.id] = pluginMap;
            },

            enable: function () {
                enabledRegistry[this.map.id] = this;
                this.enabled = true;

                //Set flag mentioning that the module is enabling,
                //so that immediate calls to the defined callbacks
                //for dependencies do not trigger inadvertent load
                //with the depCount still being zero.
                this.enabling = true;

                //Enable each dependency
                each(this.depMaps, bind(this, function (depMap, i) {
                    var id, mod, handler;

                    if (typeof depMap === 'string') {
                        //Dependency needs to be converted to a depMap
                        //and wired up to this module.
                        depMap = makeModuleMap(depMap,
                                               (this.map.isDefine ? this.map : this.map.parentMap),
                                               false,
                                               !this.skipMap);
                        this.depMaps[i] = depMap;

                        handler = getOwn(handlers, depMap.id);

                        if (handler) {
                            this.depExports[i] = handler(this);
                            return;
                        }

                        this.depCount += 1;

                        on(depMap, 'defined', bind(this, function (depExports) {
                            if (this.undefed) {
                                return;
                            }
                            this.defineDep(i, depExports);
                            this.check();
                        }));

                        if (this.errback) {
                            on(depMap, 'error', bind(this, this.errback));
                        } else if (this.events.error) {
                            // No direct errback on this module, but something
                            // else is listening for errors, so be sure to
                            // propagate the error correctly.
                            on(depMap, 'error', bind(this, function(err) {
                                this.emit('error', err);
                            }));
                        }
                    }

                    id = depMap.id;
                    mod = registry[id];

                    //Skip special modules like 'require', 'exports', 'module'
                    //Also, don't call enable if it is already enabled,
                    //important in circular dependency cases.
                    if (!hasProp(handlers, id) && mod && !mod.enabled) {
                        context.enable(depMap, this);
                    }
                }));

                //Enable each plugin that is used in
                //a dependency
                eachProp(this.pluginMaps, bind(this, function (pluginMap) {
                    var mod = getOwn(registry, pluginMap.id);
                    if (mod && !mod.enabled) {
                        context.enable(pluginMap, this);
                    }
                }));

                this.enabling = false;

                this.check();
            },

            on: function (name, cb) {
                var cbs = this.events[name];
                if (!cbs) {
                    cbs = this.events[name] = [];
                }
                cbs.push(cb);
            },

            emit: function (name, evt) {
                each(this.events[name], function (cb) {
                    cb(evt);
                });
                if (name === 'error') {
                    //Now that the error handler was triggered, remove
                    //the listeners, since this broken Module instance
                    //can stay around for a while in the registry.
                    delete this.events[name];
                }
            }
        };

        function callGetModule(args) {
            //Skip modules already defined.
            if (!hasProp(defined, args[0])) {
                getModule(makeModuleMap(args[0], null, true)).init(args[1], args[2]);
            }
        }

        function removeListener(node, func, name, ieName) {
            //Favor detachEvent because of IE9
            //issue, see attachEvent/addEventListener comment elsewhere
            //in this file.
            if (node.detachEvent && !isOpera) {
                //Probably IE. If not it will throw an error, which will be
                //useful to know.
                if (ieName) {
                    node.detachEvent(ieName, func);
                }
            } else {
                node.removeEventListener(name, func, false);
            }
        }

        /**
         * Given an event from a script node, get the requirejs info from it,
         * and then removes the event listeners on the node.
         * @param {Event} evt
         * @returns {Object}
         */
        function getScriptData(evt) {
            //Using currentTarget instead of target for Firefox 2.0's sake. Not
            //all old browsers will be supported, but this one was easy enough
            //to support and still makes sense.
            var node = evt.currentTarget || evt.srcElement;

            //Remove the listeners once here.
            removeListener(node, context.onScriptLoad, 'load', 'onreadystatechange');
            removeListener(node, context.onScriptError, 'error');

            return {
                node: node,
                id: node && node.getAttribute('data-requiremodule')
            };
        }

        function intakeDefines() {
            var args;

            //Any defined modules in the global queue, intake them now.
            takeGlobalQueue();

            //Make sure any remaining defQueue items get properly processed.
            while (defQueue.length) {
                args = defQueue.shift();
                if (args[0] === null) {
                    return onError(makeError('mismatch', 'Mismatched anonymous define() module: ' +
                        args[args.length - 1]));
                } else {
                    //args are id, deps, factory. Should be normalized by the
                    //define() function.
                    callGetModule(args);
                }
            }
            context.defQueueMap = {};
        }

        context = {
            config: config,
            contextName: contextName,
            registry: registry,
            defined: defined,
            urlFetched: urlFetched,
            defQueue: defQueue,
            defQueueMap: {},
            Module: Module,
            makeModuleMap: makeModuleMap,
            nextTick: req.nextTick,
            onError: onError,

            /**
             * Set a configuration for the context.
             * @param {Object} cfg config object to integrate.
             */
            configure: function (cfg) {
                //Make sure the baseUrl ends in a slash.
                if (cfg.baseUrl) {
                    if (cfg.baseUrl.charAt(cfg.baseUrl.length - 1) !== '/') {
                        cfg.baseUrl += '/';
                    }
                }

                // Convert old style urlArgs string to a function.
                if (typeof cfg.urlArgs === 'string') {
                    var urlArgs = cfg.urlArgs;
                    cfg.urlArgs = function(id, url) {
                        return (url.indexOf('?') === -1 ? '?' : '&') + urlArgs;
                    };
                }

                //Save off the paths since they require special processing,
                //they are additive.
                var shim = config.shim,
                    objs = {
                        paths: true,
                        bundles: true,
                        config: true,
                        map: true
                    };

                eachProp(cfg, function (value, prop) {
                    if (objs[prop]) {
                        if (!config[prop]) {
                            config[prop] = {};
                        }
                        mixin(config[prop], value, true, true);
                    } else {
                        config[prop] = value;
                    }
                });

                //Reverse map the bundles
                if (cfg.bundles) {
                    eachProp(cfg.bundles, function (value, prop) {
                        each(value, function (v) {
                            if (v !== prop) {
                                bundlesMap[v] = prop;
                            }
                        });
                    });
                }

                //Merge shim
                if (cfg.shim) {
                    eachProp(cfg.shim, function (value, id) {
                        //Normalize the structure
                        if (isArray(value)) {
                            value = {
                                deps: value
                            };
                        }
                        if ((value.exports || value.init) && !value.exportsFn) {
                            value.exportsFn = context.makeShimExports(value);
                        }
                        shim[id] = value;
                    });
                    config.shim = shim;
                }

                //Adjust packages if necessary.
                if (cfg.packages) {
                    each(cfg.packages, function (pkgObj) {
                        var location, name;

                        pkgObj = typeof pkgObj === 'string' ? {name: pkgObj} : pkgObj;

                        name = pkgObj.name;
                        location = pkgObj.location;
                        if (location) {
                            config.paths[name] = pkgObj.location;
                        }

                        //Save pointer to main module ID for pkg name.
                        //Remove leading dot in main, so main paths are normalized,
                        //and remove any trailing .js, since different package
                        //envs have different conventions: some use a module name,
                        //some use a file name.
                        config.pkgs[name] = pkgObj.name + '/' + (pkgObj.main || 'main')
                                     .replace(currDirRegExp, '')
                                     .replace(jsSuffixRegExp, '');
                    });
                }

                //If there are any "waiting to execute" modules in the registry,
                //update the maps for them, since their info, like URLs to load,
                //may have changed.
                eachProp(registry, function (mod, id) {
                    //If module already has init called, since it is too
                    //late to modify them, and ignore unnormalized ones
                    //since they are transient.
                    if (!mod.inited && !mod.map.unnormalized) {
                        mod.map = makeModuleMap(id, null, true);
                    }
                });

                //If a deps array or a config callback is specified, then call
                //require with those args. This is useful when require is defined as a
                //config object before require.js is loaded.
                if (cfg.deps || cfg.callback) {
                    context.require(cfg.deps || [], cfg.callback);
                }
            },

            makeShimExports: function (value) {
                function fn() {
                    var ret;
                    if (value.init) {
                        ret = value.init.apply(global, arguments);
                    }
                    return ret || (value.exports && getGlobal(value.exports));
                }
                return fn;
            },

            makeRequire: function (relMap, options) {
                options = options || {};

                function localRequire(deps, callback, errback) {
                    var id, map, requireMod;

                    if (options.enableBuildCallback && callback && isFunction(callback)) {
                        callback.__requireJsBuild = true;
                    }

                    if (typeof deps === 'string') {
                        if (isFunction(callback)) {
                            //Invalid call
                            return onError(makeError('requireargs', 'Invalid require call'), errback);
                        }

                        //If require|exports|module are requested, get the
                        //value for them from the special handlers. Caveat:
                        //this only works while module is being defined.
                        if (relMap && hasProp(handlers, deps)) {
                            return handlers[deps](registry[relMap.id]);
                        }

                        //Synchronous access to one module. If require.get is
                        //available (as in the Node adapter), prefer that.
                        if (req.get) {
                            return req.get(context, deps, relMap, localRequire);
                        }

                        //Normalize module name, if it contains . or ..
                        map = makeModuleMap(deps, relMap, false, true);
                        id = map.id;

                        if (!hasProp(defined, id)) {
                            return onError(makeError('notloaded', 'Module name "' +
                                        id +
                                        '" has not been loaded yet for context: ' +
                                        contextName +
                                        (relMap ? '' : '. Use require([])')));
                        }
                        return defined[id];
                    }

                    //Grab defines waiting in the global queue.
                    intakeDefines();

                    //Mark all the dependencies as needing to be loaded.
                    context.nextTick(function () {
                        //Some defines could have been added since the
                        //require call, collect them.
                        intakeDefines();

                        requireMod = getModule(makeModuleMap(null, relMap));

                        //Store if map config should be applied to this require
                        //call for dependencies.
                        requireMod.skipMap = options.skipMap;

                        requireMod.init(deps, callback, errback, {
                            enabled: true
                        });

                        checkLoaded();
                    });

                    return localRequire;
                }

                mixin(localRequire, {
                    isBrowser: isBrowser,

                    /**
                     * Converts a module name + .extension into an URL path.
                     * *Requires* the use of a module name. It does not support using
                     * plain URLs like nameToUrl.
                     */
                    toUrl: function (moduleNamePlusExt) {
                        var ext,
                            index = moduleNamePlusExt.lastIndexOf('.'),
                            segment = moduleNamePlusExt.split('/')[0],
                            isRelative = segment === '.' || segment === '..';

                        //Have a file extension alias, and it is not the
                        //dots from a relative path.
                        if (index !== -1 && (!isRelative || index > 1)) {
                            ext = moduleNamePlusExt.substring(index, moduleNamePlusExt.length);
                            moduleNamePlusExt = moduleNamePlusExt.substring(0, index);
                        }

                        return context.nameToUrl(normalize(moduleNamePlusExt,
                                                relMap && relMap.id, true), ext,  true);
                    },

                    defined: function (id) {
                        return hasProp(defined, makeModuleMap(id, relMap, false, true).id);
                    },

                    specified: function (id) {
                        id = makeModuleMap(id, relMap, false, true).id;
                        return hasProp(defined, id) || hasProp(registry, id);
                    }
                });

                //Only allow undef on top level require calls
                if (!relMap) {
                    localRequire.undef = function (id) {
                        //Bind any waiting define() calls to this context,
                        //fix for #408
                        takeGlobalQueue();

                        var map = makeModuleMap(id, relMap, true),
                            mod = getOwn(registry, id);

                        mod.undefed = true;
                        removeScript(id);

                        delete defined[id];
                        delete urlFetched[map.url];
                        delete undefEvents[id];

                        //Clean queued defines too. Go backwards
                        //in array so that the splices do not
                        //mess up the iteration.
                        eachReverse(defQueue, function(args, i) {
                            if (args[0] === id) {
                                defQueue.splice(i, 1);
                            }
                        });
                        delete context.defQueueMap[id];

                        if (mod) {
                            //Hold on to listeners in case the
                            //module will be attempted to be reloaded
                            //using a different config.
                            if (mod.events.defined) {
                                undefEvents[id] = mod.events;
                            }

                            cleanRegistry(id);
                        }
                    };
                }

                return localRequire;
            },

            /**
             * Called to enable a module if it is still in the registry
             * awaiting enablement. A second arg, parent, the parent module,
             * is passed in for context, when this method is overridden by
             * the optimizer. Not shown here to keep code compact.
             */
            enable: function (depMap) {
                var mod = getOwn(registry, depMap.id);
                if (mod) {
                    getModule(depMap).enable();
                }
            },

            /**
             * Internal method used by environment adapters to complete a load event.
             * A load event could be a script load or just a load pass from a synchronous
             * load call.
             * @param {String} moduleName the name of the module to potentially complete.
             */
            completeLoad: function (moduleName) {
                var found, args, mod,
                    shim = getOwn(config.shim, moduleName) || {},
                    shExports = shim.exports;

                takeGlobalQueue();

                while (defQueue.length) {
                    args = defQueue.shift();
                    if (args[0] === null) {
                        args[0] = moduleName;
                        //If already found an anonymous module and bound it
                        //to this name, then this is some other anon module
                        //waiting for its completeLoad to fire.
                        if (found) {
                            break;
                        }
                        found = true;
                    } else if (args[0] === moduleName) {
                        //Found matching define call for this script!
                        found = true;
                    }

                    callGetModule(args);
                }
                context.defQueueMap = {};

                //Do this after the cycle of callGetModule in case the result
                //of those calls/init calls changes the registry.
                mod = getOwn(registry, moduleName);

                if (!found && !hasProp(defined, moduleName) && mod && !mod.inited) {
                    if (config.enforceDefine && (!shExports || !getGlobal(shExports))) {
                        if (hasPathFallback(moduleName)) {
                            return;
                        } else {
                            return onError(makeError('nodefine',
                                             'No define call for ' + moduleName,
                                             null,
                                             [moduleName]));
                        }
                    } else {
                        //A script that does not call define(), so just simulate
                        //the call for it.
                        callGetModule([moduleName, (shim.deps || []), shim.exportsFn]);
                    }
                }

                checkLoaded();
            },

            /**
             * Converts a module name to a file path. Supports cases where
             * moduleName may actually be just an URL.
             * Note that it **does not** call normalize on the moduleName,
             * it is assumed to have already been normalized. This is an
             * internal API, not a public one. Use toUrl for the public API.
             */
            nameToUrl: function (moduleName, ext, skipExt) {
                var paths, syms, i, parentModule, url,
                    parentPath, bundleId,
                    pkgMain = getOwn(config.pkgs, moduleName);

                if (pkgMain) {
                    moduleName = pkgMain;
                }

                bundleId = getOwn(bundlesMap, moduleName);

                if (bundleId) {
                    return context.nameToUrl(bundleId, ext, skipExt);
                }

                //If a colon is in the URL, it indicates a protocol is used and it is just
                //an URL to a file, or if it starts with a slash, contains a query arg (i.e. ?)
                //or ends with .js, then assume the user meant to use an url and not a module id.
                //The slash is important for protocol-less URLs as well as full paths.
                if (req.jsExtRegExp.test(moduleName)) {
                    //Just a plain path, not module name lookup, so just return it.
                    //Add extension if it is included. This is a bit wonky, only non-.js things pass
                    //an extension, this method probably needs to be reworked.
                    url = moduleName + (ext || '');
                } else {
                    //A module that needs to be converted to a path.
                    paths = config.paths;

                    syms = moduleName.split('/');
                    //For each module name segment, see if there is a path
                    //registered for it. Start with most specific name
                    //and work up from it.
                    for (i = syms.length; i > 0; i -= 1) {
                        parentModule = syms.slice(0, i).join('/');

                        parentPath = getOwn(paths, parentModule);
                        if (parentPath) {
                            //If an array, it means there are a few choices,
                            //Choose the one that is desired
                            if (isArray(parentPath)) {
                                parentPath = parentPath[0];
                            }
                            syms.splice(0, i, parentPath);
                            break;
                        }
                    }

                    //Join the path parts together, then figure out if baseUrl is needed.
                    url = syms.join('/');
                    url += (ext || (/^data\:|^blob\:|\?/.test(url) || skipExt ? '' : '.js'));
                    url = (url.charAt(0) === '/' || url.match(/^[\w\+\.\-]+:/) ? '' : config.baseUrl) + url;
                }

                return config.urlArgs && !/^blob\:/.test(url) ?
                       url + config.urlArgs(moduleName, url) : url;
            },

            //Delegates to req.load. Broken out as a separate function to
            //allow overriding in the optimizer.
            load: function (id, url) {
                req.load(context, id, url);
            },

            /**
             * Executes a module callback function. Broken out as a separate function
             * solely to allow the build system to sequence the files in the built
             * layer in the right sequence.
             *
             * @private
             */
            execCb: function (name, callback, args, exports) {
                return callback.apply(exports, args);
            },

            /**
             * callback for script loads, used to check status of loading.
             *
             * @param {Event} evt the event from the browser for the script
             * that was loaded.
             */
            onScriptLoad: function (evt) {
                //Using currentTarget instead of target for Firefox 2.0's sake. Not
                //all old browsers will be supported, but this one was easy enough
                //to support and still makes sense.
                if (evt.type === 'load' ||
                        (readyRegExp.test((evt.currentTarget || evt.srcElement).readyState))) {
                    //Reset interactive script so a script node is not held onto for
                    //to long.
                    interactiveScript = null;

                    //Pull out the name of the module and the context.
                    var data = getScriptData(evt);
                    context.completeLoad(data.id);
                }
            },

            /**
             * Callback for script errors.
             */
            onScriptError: function (evt) {
                var data = getScriptData(evt);
                if (!hasPathFallback(data.id)) {
                    var parents = [];
                    eachProp(registry, function(value, key) {
                        if (key.indexOf('_@r') !== 0) {
                            each(value.depMaps, function(depMap) {
                                if (depMap.id === data.id) {
                                    parents.push(key);
                                    return true;
                                }
                            });
                        }
                    });
                    return onError(makeError('scripterror', 'Script error for "' + data.id +
                                             (parents.length ?
                                             '", needed by: ' + parents.join(', ') :
                                             '"'), evt, [data.id]));
                }
            }
        };

        context.require = context.makeRequire();
        return context;
    }

    /**
     * Main entry point.
     *
     * If the only argument to require is a string, then the module that
     * is represented by that string is fetched for the appropriate context.
     *
     * If the first argument is an array, then it will be treated as an array
     * of dependency string names to fetch. An optional function callback can
     * be specified to execute when all of those dependencies are available.
     *
     * Make a local req variable to help Caja compliance (it assumes things
     * on a require that are not standardized), and to give a short
     * name for minification/local scope use.
     */
    req = requirejs = function (deps, callback, errback, optional) {

        //Find the right context, use default
        var context, config,
            contextName = defContextName;

        // Determine if have config object in the call.
        if (!isArray(deps) && typeof deps !== 'string') {
            // deps is a config object
            config = deps;
            if (isArray(callback)) {
                // Adjust args if there are dependencies
                deps = callback;
                callback = errback;
                errback = optional;
            } else {
                deps = [];
            }
        }

        if (config && config.context) {
            contextName = config.context;
        }

        context = getOwn(contexts, contextName);
        if (!context) {
            context = contexts[contextName] = req.s.newContext(contextName);
        }

        if (config) {
            context.configure(config);
        }

        return context.require(deps, callback, errback);
    };

    /**
     * Support require.config() to make it easier to cooperate with other
     * AMD loaders on globally agreed names.
     */
    req.config = function (config) {
        return req(config);
    };

    /**
     * Execute something after the current tick
     * of the event loop. Override for other envs
     * that have a better solution than setTimeout.
     * @param  {Function} fn function to execute later.
     */
    req.nextTick = typeof setTimeout !== 'undefined' ? function (fn) {
        setTimeout(fn, 4);
    } : function (fn) { fn(); };

    /**
     * Export require as a global, but only if it does not already exist.
     */
    if (!require) {
        require = req;
    }

    req.version = version;

    //Used to filter out dependencies that are already paths.
    req.jsExtRegExp = /^\/|:|\?|\.js$/;
    req.isBrowser = isBrowser;
    s = req.s = {
        contexts: contexts,
        newContext: newContext
    };

    //Create default context.
    req({});

    //Exports some context-sensitive methods on global require.
    each([
        'toUrl',
        'undef',
        'defined',
        'specified'
    ], function (prop) {
        //Reference from contexts instead of early binding to default context,
        //so that during builds, the latest instance of the default context
        //with its config gets used.
        req[prop] = function () {
            var ctx = contexts[defContextName];
            return ctx.require[prop].apply(ctx, arguments);
        };
    });

    if (isBrowser) {
        head = s.head = document.getElementsByTagName('head')[0];
        //If BASE tag is in play, using appendChild is a problem for IE6.
        //When that browser dies, this can be removed. Details in this jQuery bug:
        //http://dev.jquery.com/ticket/2709
        baseElement = document.getElementsByTagName('base')[0];
        if (baseElement) {
            head = s.head = baseElement.parentNode;
        }
    }

    /**
     * Any errors that require explicitly generates will be passed to this
     * function. Intercept/override it if you want custom error handling.
     * @param {Error} err the error object.
     */
    req.onError = defaultOnError;

    /**
     * Creates the node for the load command. Only used in browser envs.
     */
    req.createNode = function (config, moduleName, url) {
        var node = config.xhtml ?
                document.createElementNS('http://www.w3.org/1999/xhtml', 'html:script') :
                document.createElement('script');
        node.type = config.scriptType || 'text/javascript';
        node.charset = 'utf-8';
        node.async = true;
        return node;
    };

    /**
     * Does the request to load a module for the browser case.
     * Make this a separate function to allow other environments
     * to override it.
     *
     * @param {Object} context the require context to find state.
     * @param {String} moduleName the name of the module.
     * @param {Object} url the URL to the module.
     */
    req.load = function (context, moduleName, url) {
        var config = (context && context.config) || {},
            node;
        if (isBrowser) {
            //In the browser so use a script tag
            node = req.createNode(config, moduleName, url);

            node.setAttribute('data-requirecontext', context.contextName);
            node.setAttribute('data-requiremodule', moduleName);

            //Set up load listener. Test attachEvent first because IE9 has
            //a subtle issue in its addEventListener and script onload firings
            //that do not match the behavior of all other browsers with
            //addEventListener support, which fire the onload event for a
            //script right after the script execution. See:
            //https://connect.microsoft.com/IE/feedback/details/648057/script-onload-event-is-not-fired-immediately-after-script-execution
            //UNFORTUNATELY Opera implements attachEvent but does not follow the script
            //script execution mode.
            if (node.attachEvent &&
                    //Check if node.attachEvent is artificially added by custom script or
                    //natively supported by browser
                    //read https://github.com/requirejs/requirejs/issues/187
                    //if we can NOT find [native code] then it must NOT natively supported.
                    //in IE8, node.attachEvent does not have toString()
                    //Note the test for "[native code" with no closing brace, see:
                    //https://github.com/requirejs/requirejs/issues/273
                    !(node.attachEvent.toString && node.attachEvent.toString().indexOf('[native code') < 0) &&
                    !isOpera) {
                //Probably IE. IE (at least 6-8) do not fire
                //script onload right after executing the script, so
                //we cannot tie the anonymous define call to a name.
                //However, IE reports the script as being in 'interactive'
                //readyState at the time of the define call.
                useInteractive = true;

                node.attachEvent('onreadystatechange', context.onScriptLoad);
                //It would be great to add an error handler here to catch
                //404s in IE9+. However, onreadystatechange will fire before
                //the error handler, so that does not help. If addEventListener
                //is used, then IE will fire error before load, but we cannot
                //use that pathway given the connect.microsoft.com issue
                //mentioned above about not doing the 'script execute,
                //then fire the script load event listener before execute
                //next script' that other browsers do.
                //Best hope: IE10 fixes the issues,
                //and then destroys all installs of IE 6-9.
                //node.attachEvent('onerror', context.onScriptError);
            } else {
                node.addEventListener('load', context.onScriptLoad, false);
                node.addEventListener('error', context.onScriptError, false);
            }
            node.src = url;

            //Calling onNodeCreated after all properties on the node have been
            //set, but before it is placed in the DOM.
            if (config.onNodeCreated) {
                config.onNodeCreated(node, config, moduleName, url);
            }

            //For some cache cases in IE 6-8, the script executes before the end
            //of the appendChild execution, so to tie an anonymous define
            //call to the module name (which is stored on the node), hold on
            //to a reference to this node, but clear after the DOM insertion.
            currentlyAddingScript = node;
            if (baseElement) {
                head.insertBefore(node, baseElement);
            } else {
                head.appendChild(node);
            }
            currentlyAddingScript = null;

            return node;
        } else if (isWebWorker) {
            try {
                //In a web worker, use importScripts. This is not a very
                //efficient use of importScripts, importScripts will block until
                //its script is downloaded and evaluated. However, if web workers
                //are in play, the expectation is that a build has been done so
                //that only one script needs to be loaded anyway. This may need
                //to be reevaluated if other use cases become common.

                // Post a task to the event loop to work around a bug in WebKit
                // where the worker gets garbage-collected after calling
                // importScripts(): https://webkit.org/b/153317
                setTimeout(function() {}, 0);
                importScripts(url);

                //Account for anonymous modules
                context.completeLoad(moduleName);
            } catch (e) {
                context.onError(makeError('importscripts',
                                'importScripts failed for ' +
                                    moduleName + ' at ' + url,
                                e,
                                [moduleName]));
            }
        }
    };

    function getInteractiveScript() {
        if (interactiveScript && interactiveScript.readyState === 'interactive') {
            return interactiveScript;
        }

        eachReverse(scripts(), function (script) {
            if (script.readyState === 'interactive') {
                return (interactiveScript = script);
            }
        });
        return interactiveScript;
    }

    //Look for a data-main script attribute, which could also adjust the baseUrl.
    if (isBrowser && !cfg.skipDataMain) {
        //Figure out baseUrl. Get it from the script tag with require.js in it.
        eachReverse(scripts(), function (script) {
            //Set the 'head' where we can append children by
            //using the script's parent.
            if (!head) {
                head = script.parentNode;
            }

            //Look for a data-main attribute to set main script for the page
            //to load. If it is there, the path to data main becomes the
            //baseUrl, if it is not already set.
            dataMain = script.getAttribute('data-main');
            if (dataMain) {
                //Preserve dataMain in case it is a path (i.e. contains '?')
                mainScript = dataMain;

                //Set final baseUrl if there is not already an explicit one,
                //but only do so if the data-main value is not a loader plugin
                //module ID.
                if (!cfg.baseUrl && mainScript.indexOf('!') === -1) {
                    //Pull off the directory of data-main for use as the
                    //baseUrl.
                    src = mainScript.split('/');
                    mainScript = src.pop();
                    subPath = src.length ? src.join('/')  + '/' : './';

                    cfg.baseUrl = subPath;
                }

                //Strip off any trailing .js since mainScript is now
                //like a module name.
                mainScript = mainScript.replace(jsSuffixRegExp, '');

                //If mainScript is still a path, fall back to dataMain
                if (req.jsExtRegExp.test(mainScript)) {
                    mainScript = dataMain;
                }

                //Put the data-main script in the files to load.
                cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript];

                return true;
            }
        });
    }

    /**
     * The function that handles definitions of modules. Differs from
     * require() in that a string for the module should be the first argument,
     * and the function to execute after dependencies are loaded should
     * return a value to define the module corresponding to the first argument's
     * name.
     */
    define = function (name, deps, callback) {
        var node, context;

        //Allow for anonymous modules
        if (typeof name !== 'string') {
            //Adjust args appropriately
            callback = deps;
            deps = name;
            name = null;
        }

        //This module may not have dependencies
        if (!isArray(deps)) {
            callback = deps;
            deps = null;
        }

        //If no name, and callback is a function, then figure out if it a
        //CommonJS thing with dependencies.
        if (!deps && isFunction(callback)) {
            deps = [];
            //Remove comments from the callback string,
            //look for require calls, and pull them into the dependencies,
            //but only if there are function args.
            if (callback.length) {
                callback
                    .toString()
                    .replace(commentRegExp, commentReplace)
                    .replace(cjsRequireRegExp, function (match, dep) {
                        deps.push(dep);
                    });

                //May be a CommonJS thing even without require calls, but still
                //could use exports, and module. Avoid doing exports and module
                //work though if it just needs require.
                //REQUIRES the function to expect the CommonJS variables in the
                //order listed below.
                deps = (callback.length === 1 ? ['require'] : ['require', 'exports', 'module']).concat(deps);
            }
        }

        //If in IE 6-8 and hit an anonymous define() call, do the interactive
        //work.
        if (useInteractive) {
            node = currentlyAddingScript || getInteractiveScript();
            if (node) {
                if (!name) {
                    name = node.getAttribute('data-requiremodule');
                }
                context = contexts[node.getAttribute('data-requirecontext')];
            }
        }

        //Always save off evaluating the def call until the script onload handler.
        //This allows multiple modules to be in a file without prematurely
        //tracing dependencies, and allows for anonymous module support,
        //where the module name is not known until the script onload event
        //occurs. If no context, use the global queue, and get it processed
        //in the onscript load callback.
        if (context) {
            context.defQueue.push([name, deps, callback]);
            context.defQueueMap[name] = true;
        } else {
            globalDefQueue.push([name, deps, callback]);
        }
    };

    define.amd = {
        jQuery: true
    };

    /**
     * Executes the text. Normally just uses eval, but can be modified
     * to use a better, environment-specific call. Only used for transpiling
     * loader plugins, not for plain JS modules.
     * @param {String} text the text to execute/evaluate.
     */
    req.exec = function (text) {
        /*jslint evil: true */
        return eval(text);
    };

    //Set up with config info.
    req(cfg);
}(this, (typeof setTimeout === 'undefined' ? undefined : setTimeout)));

var google={loader:{loaded:function(){},eval:{}}};
(function() {
var aa=encodeURIComponent,ca=window,da=Object,ea=Infinity,fa=document,ga=isNaN,h=Math,ha=Array,ia=Number,ja=NaN,m=Error,ka=Boolean,la=parseInt,ma=parseFloat,na=isFinite,oa=decodeURIComponent;function pa(a,b){return a.width=b}function ra(a,b){return a.data=b}function sa(a,b){return a.ceil=b}function ta(a,b){return a.floor=b}function ua(a,b){return a.format=b}function va(a,b){return a.remove=b}function wa(a,b){return a.clear=b}function xa(a,b){return a.getColumnIndex=b}
function za(a,b){return a.stroke=b}function Ba(a,b){return a.getTime=b}function Ca(a,b){return a.fill=b}function Da(a,b){return a.toString=b}function Ea(a,b){return a.position=b}function Fa(a,b){return a.toJSON=b}function Ga(a,b){return a.next=b}function Ia(a,b){return a.constructor=b}function Ja(a,b){return a.fontSize=b}function Ka(a,b){return a.message=b}function La(a,b){return a.start=b}function Ma(a,b){return a.init=b}function Na(a,b){return a.bottom=b}function Oa(a,b){return a.scale=b}
function Pa(a,b){return a.contains=b}function Qa(a,b){return a.label=b}function Ra(a,b){return a.display=b}function Sa(a,b){return a.height=b}function Ta(a,b){return a.right=b}function Ua(a,b){return a.isEmpty=b}function Va(a,b){return a.round=b}function Wa(a,b){return a.innerHTML=b}function Xa(a,b){return a.color=b}function Ya(a,b){return a.left=b}function Za(a,b){return a.equals=b}function $a(a,b){return a.cssText=b}function ab(a,b){return a.type=b}function bb(a,b){return a.tabIndex=b}
function db(a,b){return a.translate=b}function eb(a,b){return a.name=b}function fb(a,b){return a.getValue=b}function gb(a,b){return a.parse=b}function hb(a,b){return a.visibility=b}function ib(a,b){return a.bold=b}function jb(a,b){return a.length=b}function kb(a,b){return a.prototype=b}function lb(a,b){return a.className=b}function mb(a,b){return a.opacity=b}function nb(a,b){return a.sort=b}
var p="appendChild",ob="filter",pb="activeElement",qb="getBoundingClientRect",rb="shift",sb="exec",r="width",tb="collapse",ub="pattern",vb="replace",wb="toFixed",xb="ceil",t="floor",yb="content",zb="offsetWidth",Ab="concat",Bb="charAt",Cb="createTextNode",Db="getDate",Eb="insertBefore",Fb="targetTouches",Gb="screenX",Hb="screenY",Ib="match",Jb="getUTCFullYear",Kb="format",Lb="getBoxObjectFor",Nb="cols",Ob="remove",Pb="querySelector",Qb="createElement",Rb="scrollHeight",Sb="firstChild",Tb="forEach",
Ub="clientLeft",v="setAttribute",Vb="clientTop",Wb="clear",Xb="childNodes",Yb="stroke",Zb="bind",$b="getHours",ac="nextSibling",bc="getTime",cc="getElementsByTagName",dc="documentElement",ec="substr",fc="fill",gc="previousSibling",hc="toString",ic="propertyIsEnumerable",jc="position",lc="getDay",mc="sourceIndex",nc="index",oc="next",pc="split",qc="offsetParent",rc="constructor",sc="userAgent",tc="location",uc="fontSize",vc="hasOwnProperty",x="style",wc="ownerDocument",xc="search",yc="lastChild",zc=
"getUTCMonth",Ac="getYear",Bc="scrollWidth",y="start",Cc="random",Dc="setProperty",Ec="getFullYear",Fc="init",Gc="scrollLeft",Hc="bottom",Ic="href",Jc="setTime",Kc="rows",Lc="contains",Mc="apply",Nc="tagName",Pc="removeAttribute",Qc="getMinutes",Rc="label",Sc="display",Tc="offsetTop",A="height",Uc="offsetHeight",Vc="Range",Xc="execScript",Yc="nodeValue",Zc="right",C="push",$c="isEmpty",ad="valueOf",bd="test",cd="text",D="round",dd="slice",ed="nodeType",fd="load",gd="getElementById",hd="innerHTML",
id="value",jd="item",ld="indexOf",E="color",md="compareDocumentPosition",nd="nodeName",od="createRange",G="left",pd="setMonth",qd="fromCharCode",rd="setFullYear",sd="atan2",td="children",ud="sqrt",vd="Format",wd="parentElement",H="type",xd="defaultView",yd="name",I="getValue",zd="clientX",Ad="clientY",Bd="setDate",Cd="scrollTop",Dd="getMonth",Ed="bold",J="length",K="prototype",Fd="className",Gd="clientWidth",Hd="document",Id="getSeconds",Jd="getUTCDate",Kd="opacity",Ld="getMilliseconds",Md="visualization",
Nd="disabled",Od="offsetLeft",Pd="body",Qd="removeChild",L="call",Rd="lastIndexOf",Sd="getAttribute",Td="querySelectorAll",Ud="setUTCMonth",Wd="clientHeight",Xd="charCodeAt",Yd="compatMode",Zd="sort",$d="currentStyle",ae="substring",be="documentMode",ce="every",de="getUTCMinutes",ee="getUTCHours",fe="parentNode",ge="toUpperCase",he="splice",ie="join",je="unshift",ke="toLowerCase",le="getTimezoneOffset",O="",me="\n",ne=" ",aaa=" and ",baa=" does not match type ",caa=' name="',daa=' type="',oe='"',
pe='" />',qe="#",eaa="#$1$1$2$2$3$3",re="#000000",se="#808080",te="#fff",ue="#ffffff",ve="$",faa="$1",we="%",xe="&",ye="&#39;",ze="&amp;",gaa="&client=google-gviz",Ae="&gt;",Be="&lt;",De="&quot;",Ee="'",haa="''",Fe="(",iaa="(^",Ge=")",jaa=")([a-z])",He="*",Ie="+",Je=",",Ke=", ",Le="-",kaa="-moz",laa="-ms",maa="-o",naa="-transform",oaa="-webkit",Me=".",Ne="...",paa='.png" height="12" width="',qaa="https://cdn-rest.staging.hcloud.trustyou.net/apps",raa="/commons/public",saa="",taa="/3rd-party/gc/all.latest.css",Oe="0",
Pe="0.5",Qe="0.6",Re="00",Se="000",uaa="0000000000000000",Te="1",vaa="",waa="1.9",Ue="10",Ve="3",We="9",Xe=":",Ye=";",Ze="<",xaa="</span>\u00a0",yaa="</table>",zaa="</tr>",$e="<br>",Aaa='<img style="padding: 0" src="',Baa='<span style="padding: 0; float: left; white-space: nowrap;">',Caa="<table>",Daa="<td>&nbsp;</td>",Eaa="<td></td>",Faa="<tr>",af="=",bf=">",cf="?",Gaa="@",df="A",Haa="APPLET",Iaa="AREA",Jaa="BASE",ef="BR",ff="BUTTON",Kaa="COL",Laa="COMMAND",gf="CSS1Compat",Maa="Can't combine significant digits and minimum fraction digits",
hf="Container is not defined",jf="DAY",kf="DIV",Naa="Date(",lf="December",mf="E",Oaa="EMBED",Paa="Etc/GMT",nf="F",Qaa="FRAME",of="February",Raa="G",Saa="GMT",Taa="H",Uaa="HOUR",pf="HR",Vaa="IFRAME",Waa="IMG",qf="INPUT",Xaa="ISINDEX",Yaa="JavaScript",Zaa="K",$aa="KEYGEN",rf="L",aba="LINK",sf="M",bba="META",tf="MILLISECOND",cba="MINUTE",uf="MMM d",vf="MONTH",wf="MSIE",dba="Moz",eba="MozOpacity",xf="N",fba="NOFRAMES",gba="NOSCRIPT",yf="November",zf="O",hba="OBJECT",iba="PARAM",Af="Q",jba="Q yyyy",Bf=
"QUARTER",Cf="S",Df="SCRIPT",kba="SECOND",Ef="SELECT",Ff="SOURCE",lba="STYLE",mba="SVG",If="Saturday",Kf="September",nba="Style",Lf="T",Mf="TEXTAREA",Nf="TL",Of="TR",oba="TRACK",Pf="Thursday",pba="Too many percent/permill",qba="Type mismatch. Value ",rba="UTC",sba="Uneven number of arguments",Qf="W",tba="WBR",uba="WEEK",vba="Webkit",Rf="Wednesday",wba="Width",Sf="YEAR",Vf="Z",xba="[",yba="[object Array]",zba="[object Function]",Aba="[object Window]",Bba="\\",Cba="\\$1",Yf="\\\\",Zf="\\s",Dba="\\u",
Eba="\\x08",$f="]",Fba="]+",Gba="_bar_format_old_value",ag="_default_",bg="a",cg="absolute",Hba="alpha(opacity=",Iba="amp",Jba="aria-",dg="array",eg="auto",fg="b",gg="background-color:",Kba="bar.groupWidth",hg="body",jg="boolean",Lba="borderBottom",Mba="borderBottomWidth",Nba="borderLeft",Oba="borderLeftWidth",Pba="borderRight",Qba="borderRightWidth",Rba="borderTop",Sba="borderTopWidth",kg="both",lg="c",Tba="call",Uba="callee",Vba="class",Wba="className",Xba="clearMinutes",Yba="color:",mg="column",
Zba="columnFilters[",$ba="compare",ng="d",aca="data-",og="date",pg="datetime",bca="decimalSymbol",cca="desc",qg="direction",rg="display",Q="div",dca="document",vg="f",wg="false",xg="filter",yg="fixed",zg="focus",eca="for",fca="formatType",gca="fractionDigits",Ag="full",Bg="function",Cg="g",hca="google-visualization-formatters-arrow-dr",ica="google-visualization-formatters-arrow-empty",jca="google-visualization-formatters-arrow-ug",kca="google.loader.GoogleApisBase",lca="google.maps.DirectionsService",
mca="google.visualization.",nca="google.visualization.ModulePath",oca="google.visualization.NumberFormat",pca="google.visualization.Version",qca="groupingSymbol",rca="gt",Dg="h",Eg="h:mm a",Fg="h:mm:ss a",Gg="head",Hg="height",sca="hex",Ig="hidden",Jg="horizontal",Kg="href",Mg="html",Ng="https",Og="inline",tca="innerText",Pg="k",Qg="left",Rg="link",Sg="long",uca="lt",Tg="m",vca="maps",Ug="maxValue",Vg="medium",Wg="minValue",wca="ms",xca="named",yca="native code",zca="negativeColor",Aca="negativeParens",
Bca="new ",R="none",Xg="null",Yg="number",Zg="o",$g="object",ah="on",bh="opacity",Cca="outerHTML",ch="overflow",Dca="paddingBottom",Eca="paddingLeft",Fca="paddingRight",Gca="paddingTop",dh="pattern",Hca="pixelHeight",Ica="pixelLeft",Jca="pixelWidth",eh="position",Kca="prefix",S="px",Lca="quot",fh="r",gh="relative",hh="rgb",ih="role",jh="rtl",kh="s",Mca="scaleFactor",lh="script",mh="selection",Nca="sensor=false",nh="short",oh="single",ph="solid",Oca="sortColumns",Pca="sortColumns[",Qca="sourceIndex",
Rca="splice",qh="static",rh="string",sh="style",Sca="stylesheet",th="suffix",Tca="tabIndex",Uca="tabindex",Vca="text/css",uh="text/javascript",Wca="textContent",vh="time",Xca="timeZone",wh="timeofday",xh="transform",yh="transparent",zh="true",Ah="type",Bh="unselectable",Ch="v",Dh="value",Yca="valueType",Zca="var ",$ca="var _et_ = 1;",Eh="vertical",Fh="visible",ada="visualization",Gh="w",Hh="white",Ih="width",Jh="y",Kh="z",Lh="{",bda="{0}",cda="{1}",dda="|[",Mh="}",Nh="\u00a0",eda="\u00a4",fda="\u2030",
T,Oh=Oh||{},Ph=this;function Qh(a){return void 0!==a}function V(a,b,c){a=a[pc](Me);c=c||Ph;a[0]in c||!c[Xc]||c[Xc](Zca+a[0]);for(var d;a[J]&&(d=a[rb]());)!a[J]&&Qh(b)?c[d]=b:c=c[d]?c[d]:c[d]={}}function Sh(a,b){for(var c=a[pc](Me),d=b||Ph,e;e=c[rb]();)if(null!=d[e])d=d[e];else return null;return d}function Th(){}function Uh(a){a.Xb=function(){return a.Xca?a.Xca:a.Xca=new a}}
function Vh(a){var b=typeof a;if(b==$g)if(a){if(a instanceof ha)return dg;if(a instanceof da)return b;var c=da[K][hc][L](a);if(c==Aba)return $g;if(c==yba||typeof a[J]==Yg&&"undefined"!=typeof a[he]&&"undefined"!=typeof a[ic]&&!a[ic](Rca))return dg;if(c==zba||"undefined"!=typeof a[L]&&"undefined"!=typeof a[ic]&&!a[ic](Tba))return Bg}else return Xg;else if(b==Bg&&"undefined"==typeof a[L])return $g;return b}function Wh(a){return null===a}function Xh(a){return null!=a}
function Yh(a){return Vh(a)==dg}function Zh(a){var b=Vh(a);return b==dg||b==$g&&typeof a[J]==Yg}function $h(a){return ai(a)&&typeof a[Ec]==Bg}function bi(a){return typeof a==rh}function ci(a){return typeof a==jg}function di(a){return typeof a==Yg}function ei(a){return Vh(a)==Bg}function ai(a){var b=typeof a;return b==$g&&null!=a||b==Bg}function fi(a){return a[gda]||(a[gda]=++hda)}var gda="closure_uid_"+(1E9*h[Cc]()>>>0),hda=0;function ida(a,b,c){return a[L][Mc](a[Zb],arguments)}
function jda(a,b,c){if(!a)throw m();if(2<arguments[J]){var d=ha[K][dd][L](arguments,2);return function(){var c=ha[K][dd][L](arguments);ha[K][je][Mc](c,d);return a[Mc](b,c)}}return function(){return a[Mc](b,arguments)}}function W(a,b,c){W=Function[K][Zb]&&-1!=Function[K][Zb][hc]()[ld](yca)?ida:jda;return W[Mc](null,arguments)}function gi(a,b){var c=ha[K][dd][L](arguments,1);return function(){var b=c[dd]();b[C][Mc](b,arguments);return a[Mc](this,b)}}var hi=Date.now||function(){return+new Date};
function kda(a){if(Ph[Xc])Ph[Xc](a,Yaa);else if(Ph.eval)if(null==ii&&(Ph.eval($ca),"undefined"!=typeof Ph._et_?(delete Ph._et_,ii=!0):ii=!1),ii)Ph.eval(a);else{var b=Ph[Hd],c=b[Qb](lh);ab(c,uh);c.defer=!1;c[p](b[Cb](a));b[Pd][p](c);b[Pd][Qd](c)}else throw m("goog.globalEval not available");}var ii=null;function X(a,b){function c(){}kb(c,b[K]);a.e=b[K];kb(a,new c);Ia(a[K],a);a.Ud=function(a,c,f){var g=ha[K][dd][L](arguments,2);return b[K][c][Mc](a,g)}};var google=google||ca.google||{};function ji(a){if(m.captureStackTrace)m.captureStackTrace(this,ji);else{var b=m().stack;b&&(this.stack=b)}a&&Ka(this,String(a))}X(ji,m);eb(ji[K],"CustomError");var lda;function ki(a,b){return 0==a[Rd](b,0)}function mda(a){var b=a[J]-1;return 0<=b&&a[ld](we,b)==b}function li(a){return/^[\s\xa0]*$/[bd](a)}function mi(a){return li(ni(a))}function oi(a){return!/[^0-9]/[bd](a)}function nda(a){return a[vb](/[\t\r\n ]+/g,ne)[vb](/^[\t\r\n ]+|[\t\r\n ]+$/g,O)}function pi(a){return a[vb](/^[\s\xa0]+|[\s\xa0]+$/g,O)}
function qi(a,b){if(b)return a[vb](oda,ze)[vb](pda,Be)[vb](qda,Ae)[vb](rda,De)[vb](sda,ye);if(!tda[bd](a))return a;-1!=a[ld](xe)&&(a=a[vb](oda,ze));-1!=a[ld](Ze)&&(a=a[vb](pda,Be));-1!=a[ld](bf)&&(a=a[vb](qda,Ae));-1!=a[ld](oe)&&(a=a[vb](rda,De));-1!=a[ld](Ee)&&(a=a[vb](sda,ye));return a}var oda=/&/g,pda=/</g,qda=/>/g,rda=/"/g,sda=/'/g,tda=/[&<>"']/;function uda(a){return ri(a,xe)?dca in Ph?vda(a):wda(a):a}
function vda(a){var b={"&amp;":xe,"&lt;":Ze,"&gt;":bf,"&quot;":oe},c;c=fa[Qb](Q);return a[vb](xda,function(a,e){var f=b[a];if(f)return f;if(e[Bb](0)==qe){var g=ia(Oe+e[ec](1));ga(g)||(f=String[qd](g))}f||(Wa(c,a+ne),f=c[Sb][Yc][dd](0,-1));return b[a]=f})}function wda(a){return a[vb](/&([^;]+);/g,function(a,c){switch(c){case Iba:return xe;case uca:return Ze;case rca:return bf;case Lca:return oe;default:if(c[Bb](0)==qe){var d=ia(Oe+c[ec](1));if(!ga(d))return String[qd](d)}return a}})}var xda=/&([^;\s<&]+);?/g;
function si(a,b){a[J]>b&&(a=a[ae](0,b-3)+Ne);return a}function ri(a,b){return-1!=a[ld](b)}function ti(a,b){return ha(b+1)[ie](a)}function ui(a,b){var c=Qh(void 0)?a[wb](void 0):String(a),d=c[ld](Me);-1==d&&(d=c[J]);return ti(Oe,h.max(0,b-d))+c}function ni(a){return null==a?O:String(a)}function yda(a){return ha[K][ie][L](arguments,O)}
function vi(a,b){for(var c=0,d=pi(String(a))[pc](Me),e=pi(String(b))[pc](Me),f=h.max(d[J],e[J]),g=0;0==c&&g<f;g++){var k=d[g]||O,l=e[g]||O,n=/(\d*)(\D*)/g,q=/(\d*)(\D*)/g;do{var s=n[sb](k)||[O,O,O],u=q[sb](l)||[O,O,O];if(0==s[0][J]&&0==u[0][J])break;c=wi(0==s[1][J]?0:la(s[1],10),0==u[1][J]?0:la(u[1],10))||wi(0==s[2][J],0==u[2][J])||wi(s[2],u[2])}while(0==c)}return c}function wi(a,b){return a<b?-1:a>b?1:0}function xi(a){for(var b=0,c=0;c<a[J];++c)b=31*b+a[Xd](c),b%=4294967296;return b}
var zda=2147483648*h[Cc]()|0;function yi(a){var b=ia(a);return 0==b&&li(a)?ja:b}function zi(a){return String(a)[vb](/\-([a-z])/g,function(a,c){return c[ge]()})}function Ada(a){var b=bi(void 0)?"undefined"[vb](/([-()\[\]{}+?*.$\^|,:#<!\\])/g,Cba)[vb](/\x08/g,Eba):Zf;return a[vb](new RegExp(iaa+(b?dda+b+Fba:O)+jaa,Cg),function(a,b,e){return b+e[ge]()})};function Ai(a){return a[a[J]-1]}var Bi=ha[K],Ci=Bi[ld]?function(a,b,c){return Bi[ld][L](a,b,c)}:function(a,b,c){c=null==c?0:0>c?h.max(0,a[J]+c):c;if(bi(a))return bi(b)&&1==b[J]?a[ld](b,c):-1;for(;c<a[J];c++)if(c in a&&a[c]===b)return c;return-1},Y=Bi[Tb]?function(a,b,c){Bi[Tb][L](a,b,c)}:function(a,b,c){for(var d=a[J],e=bi(a)?a[pc](O):a,f=0;f<d;f++)f in e&&b[L](c,e[f],f,a)};function Ei(a,b,c){for(var d=a[J],e=bi(a)?a[pc](O):a,d=d-1;0<=d;--d)d in e&&b[L](c,e[d],d,a)}
var Fi=Bi[ob]?function(a,b,c){return Bi[ob][L](a,b,c)}:function(a,b,c){for(var d=a[J],e=[],f=0,g=bi(a)?a[pc](O):a,k=0;k<d;k++)if(k in g){var l=g[k];b[L](c,l,k,a)&&(e[f++]=l)}return e},Gi=Bi.map?function(a,b,c){return Bi.map[L](a,b,c)}:function(a,b,c){for(var d=a[J],e=ha(d),f=bi(a)?a[pc](O):a,g=0;g<d;g++)g in f&&(e[g]=b[L](c,f[g],g,a));return e},Hi=Bi.reduce?function(a,b,c,d){d&&(b=W(b,d));return Bi.reduce[L](a,b,c)}:function(a,b,c,d){var e=c;Y(a,function(c,g){e=b[L](d,e,c,g,a)});return e},Mi=Bi.some?
function(a,b,c){return Bi.some[L](a,b,c)}:function(a,b,c){for(var d=a[J],e=bi(a)?a[pc](O):a,f=0;f<d;f++)if(f in e&&b[L](c,e[f],f,a))return!0;return!1},Ni=Bi[ce]?function(a,b,c){return Bi[ce][L](a,b,c)}:function(a,b,c){for(var d=a[J],e=bi(a)?a[pc](O):a,f=0;f<d;f++)if(f in e&&!b[L](c,e[f],f,a))return!1;return!0};function Oi(a,b){var c=Pi(a,b,void 0);return 0>c?null:bi(a)?a[Bb](c):a[c]}function Pi(a,b,c){for(var d=a[J],e=bi(a)?a[pc](O):a,f=0;f<d;f++)if(f in e&&b[L](c,e[f],f,a))return f;return-1}
function Qi(a,b){var c;t:{var d=a[J];c=bi(a)?a[pc](O):a;for(d-=1;0<=d;d--)if(d in c&&b[L](void 0,c[d],d,a)){c=d;break t}c=-1}return 0>c?null:bi(a)?a[Bb](c):a[c]}function Ri(a,b){return 0<=Ci(a,b)}function Si(a){return 0==a[J]}function Ti(a){if(!Yh(a))for(var b=a[J]-1;0<=b;b--)delete a[b];jb(a,0)}function Ui(a,b,c){Vi(a,c,0,b)}function Wi(a,b){var c=Ci(a,b),d;(d=0<=c)&&Bi[he][L](a,c,1);return d}function Xi(a){return Bi[Ab][Mc](Bi,arguments)}
function Yi(a){var b=a[J];if(0<b){for(var c=ha(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}function Zi(a,b){for(var c=1;c<arguments[J];c++){var d=arguments[c],e;if(Yh(d)||(e=Zh(d))&&da[K][vc][L](d,Uba))a[C][Mc](a,d);else if(e)for(var f=a[J],g=d[J],k=0;k<g;k++)a[f+k]=d[k];else a[C](d)}}function Vi(a,b,c,d){return Bi[he][Mc](a,$i(arguments,1))}function $i(a,b,c){return 2>=arguments[J]?Bi[dd][L](a,b):Bi[dd][L](a,b,c)}
function Bda(a){for(var b={},c=0,d=0;d<a[J];){var e=a[d++],f=ai(e)?Zg+fi(e):(typeof e)[Bb](0)+e;da[K][vc][L](b,f)||(b[f]=!0,a[c++]=e)}jb(a,c)}function aj(a,b,c){return Cda(a,c||bj,!1,b)}function Dda(a,b,c){return Cda(a,b,!0,void 0,c)}function Cda(a,b,c,d,e){for(var f=0,g=a[J],k;f<g;){var l=f+g>>1,n;n=c?b[L](e,a[l],l,a):b(d,a[l]);0<n?f=l+1:(g=l,k=!n)}return k?f:~f}function cj(a,b){a[Zd](b||bj)}
function dj(a,b){for(var c=0;c<a[J];c++)a[c]={index:c,value:a[c]};var d=b||bj;cj(a,function(a,b){return d(a[id],b[id])||a[nc]-b[nc]});for(c=0;c<a[J];c++)a[c]=a[c][id]}function Eda(a){var b=bj;cj(a,function(a,d){return b(a.x,d.x)})}function ej(a,b){if(!Zh(a)||!Zh(b)||a[J]!=b[J])return!1;for(var c=a[J],d=Fda,e=0;e<c;e++)if(!d(a[e],b[e]))return!1;return!0}function bj(a,b){return a>b?1:a<b?-1:0}function Fda(a,b){return a===b}
function Gda(a,b){for(var c={},d=0;d<a[J];d++){var e=a[d],f=b[L](void 0,e,d,a);Qh(f)&&(c[f]||(c[f]=[]))[C](e)}return c}function fj(a){var b=[];if(0>1*(a-0))return[];for(var c=0;c<a;c+=1)b[C](c);return b}function gj(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c}function ij(a){for(var b=[],c=0;c<arguments[J];c++){var d=arguments[c];Yh(d)?b[C][Mc](b,ij[Mc](null,d)):b[C](d)}return b}
function Hda(a){if(!arguments[J])return[];for(var b=[],c=0;;c++){for(var d=[],e=0;e<arguments[J];e++){var f=arguments[e];if(c>=f[J])return b;d[C](f[c])}b[C](d)}};function jj(a){return function(){return a}}var Ida=jj(!0),Jda=jj(null);function kj(a){return a}function Kda(a){return function(){throw a;}}function Lda(a){var b;b=b||0;return function(){return a[Mc](this,ha[K][dd][L](arguments,0,b))}};function nj(a,b,c){return h.min(h.max(a,b),c)}function oj(a,b){var c=a%b;return 0>c*b?c+b:c}function pj(a,b,c){return a+c*(b-a)}function qj(a){return a*h.PI/180}function rj(a,b){return b*h.cos(qj(a))}function sj(a,b){return b*h.sin(qj(a))}function tj(a,b,c,d){return oj(180*h[sd](d-b,c-a)/h.PI,360)}function uj(a){return 0==a?0:0>a?-1:1}function Mda(a){return Hi(arguments,function(a,c){return a+c},0)}function vj(a){return Mda[Mc](null,arguments)/arguments[J]}function wj(a){return na(a)&&0==a%1}
function xj(a){return na(a)&&!ga(a)};var yj="StopIteration"in Ph?Ph.StopIteration:m("StopIteration");function zj(){}Ga(zj[K],function(){throw yj;});zj[K].fs=function(){return this};function Aj(a){if(a instanceof zj)return a;if(typeof a.fs==Bg)return a.fs(!1);if(Zh(a)){var b=0,c=new zj;Ga(c,function(){for(;;){if(b>=a[J])throw yj;if(b in a)return a[b++];b++}});return c}throw m("Not implemented");}
function Bj(a,b,c){if(Zh(a))try{Y(a,b,c)}catch(d){if(d!==yj)throw d;}else{a=Aj(a);try{for(;;)b[L](c,a[oc](),void 0,a)}catch(e){if(e!==yj)throw e;}}}function Cj(a,b,c){var d=0,e=a,f=c||1;1<arguments[J]&&(d=a,e=b);if(0==f)throw m("Range step argument must not be zero");var g=new zj;Ga(g,function(){if(0<f&&d>=e||0>f&&d<=e)throw yj;var a=d;d+=f;return a});return g}function Nda(a,b,c){var d=Aj(a);a=new zj;Ga(a,function(){var a=d[oc]();return b[L](c,a,void 0,d)});return a}
function Oda(a){var b=Aj(arguments),c=new zj,d=null;Ga(c,function(){for(;;){if(null==d){var a=b[oc]();d=Aj(a)}try{return d[oc]()}catch(c){if(c!==yj)throw c;d=null}}});return c}function Pda(a){if(Zh(a))return Yi(a);a=Aj(a);var b=[];Bj(a,function(a){b[C](a)});return b}function Qda(a){try{return Aj(a)[oc]()}catch(b){if(b!=yj)throw b;return null}};function Dj(a,b,c){for(var d in a)b[L](c,a[d],d,a)}function Ej(a,b,c){var d={},e;for(e in a)d[e]=b[L](c,a[e],e,a);return d}function Fj(a,b){for(var c in a)if(b[L](void 0,a[c],c,a))return!0;return!1}function Rda(a,b,c){for(var d in a)if(!b[L](c,a[d],d,a))return!1;return!0}function Sda(a){var b=0,c;for(c in a)b++;return b}function Gj(a){for(var b in a)return a[b]}function Hj(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ij(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}
function Jj(a,b){for(var c in a)if(a[c]==b)return!0;return!1}function Kj(a){for(var b in a)return!1;return!0}function Lj(a,b){b in a&&delete a[b]}function Mj(a,b,c){if(b in a)throw m('The object already contains the key "'+b+oe);a[b]=c}function Nj(a,b){return b in a?a[b]:void 0}function Oj(a,b,c){return b in a?a[b]:a[b]=c}function Pj(a){var b={},c;for(c in a)b[c]=a[c];return b}
function Qj(a){var b=Vh(a);if(b==$g||b==dg){if(a.o)return a.o();var b=b==dg?[]:{},c;for(c in a)b[c]=Qj(a[c]);return b}return a}function Rj(a){var b={},c;for(c in a)b[a[c]]=c;return b}var Tda="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function Sj(a,b){for(var c,d,e=1;e<arguments[J];e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Tda[J];f++)c=Tda[f],da[K][vc][L](d,c)&&(a[c]=d[c])}}
function Uda(a){var b=arguments[J];if(1==b&&Yh(arguments[0]))return Uda[Mc](null,arguments[0]);if(b%2)throw m(sba);for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c}function Tj(a){var b=arguments[J];if(1==b&&Yh(arguments[0]))return Tj[Mc](null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};function Uj(a,b){this.ab={};this.Yd=[];this.Tx=this.Mb=0;var c=arguments[J];if(1<c){if(c%2)throw m(sba);for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.Q0(a)}T=Uj[K];T.Lc=function(){return this.Mb};T.La=function(){Vj(this);for(var a=[],b=0;b<this.Yd[J];b++)a[C](this.ab[this.Yd[b]]);return a};T.hk=function(){Vj(this);return this.Yd[Ab]()};T.$e=function(a){return Wj(this.ab,a)};T.$R=function(a){for(var b=0;b<this.Yd[J];b++){var c=this.Yd[b];if(Wj(this.ab,c)&&this.ab[c]==a)return!0}return!1};
Za(T,function(a,b){if(this===a)return!0;if(this.Mb!=a.Lc())return!1;var c=b||Vda;Vj(this);for(var d,e=0;d=this.Yd[e];e++)if(!c(this.get(d),a.get(d)))return!1;return!0});function Vda(a,b){return a===b}Ua(T,function(){return 0==this.Mb});wa(T,function(){this.ab={};jb(this.Yd,0);this.Tx=this.Mb=0});va(T,function(a){return Wj(this.ab,a)?(delete this.ab[a],this.Mb--,this.Tx++,this.Yd[J]>2*this.Mb&&Vj(this),!0):!1});
function Vj(a){if(a.Mb!=a.Yd[J]){for(var b=0,c=0;b<a.Yd[J];){var d=a.Yd[b];Wj(a.ab,d)&&(a.Yd[c++]=d);b++}jb(a.Yd,c)}if(a.Mb!=a.Yd[J]){for(var e={},c=b=0;b<a.Yd[J];)d=a.Yd[b],Wj(e,d)||(a.Yd[c++]=d,e[d]=1),b++;jb(a.Yd,c)}}T.get=function(a,b){return Wj(this.ab,a)?this.ab[a]:b};T.set=function(a,b){Wj(this.ab,a)||(this.Mb++,this.Yd[C](a),this.Tx++);this.ab[a]=b};T.Q0=function(a){var b;a instanceof Uj?(b=a.hk(),a=a.La()):(b=Ij(a),a=Hj(a));for(var c=0;c<b[J];c++)this.set(b[c],a[c])};
T.forEach=function(a,b){for(var c=this.hk(),d=0;d<c[J];d++){var e=c[d],f=this.get(e);a[L](b,f,e,this)}};T.o=function(){return new Uj(this)};T.transpose=function(){for(var a=new Uj,b=0;b<this.Yd[J];b++){var c=this.Yd[b];a.set(this.ab[c],c)}return a};T.fs=function(a){Vj(this);var b=0,c=this.Yd,d=this.ab,e=this.Tx,f=this,g=new zj;Ga(g,function(){for(;;){if(e!=f.Tx)throw m("The map has changed since the iterator was created");if(b>=c[J])throw yj;var g=c[b++];return a?g:d[g]}});return g};
function Wj(a,b){return da[K][vc][L](a,b)};function Wda(a){return typeof a.Lc==Bg?a.Lc():Zh(a)||bi(a)?a[J]:Sda(a)}function Xj(a){if(typeof a.La==Bg)return a.La();if(bi(a))return a[pc](O);if(Zh(a)){for(var b=[],c=a[J],d=0;d<c;d++)b[C](a[d]);return b}return Hj(a)}function ak(a){if(typeof a.hk==Bg)return a.hk();if(typeof a.La!=Bg){if(Zh(a)||bi(a)){var b=[];a=a[J];for(var c=0;c<a;c++)b[C](c);return b}return Ij(a)}}
function bk(a,b,c){if(typeof a[Tb]==Bg)a[Tb](b,c);else if(Zh(a)||bi(a))Y(a,b,c);else for(var d=ak(a),e=Xj(a),f=e[J],g=0;g<f;g++)b[L](c,e[g],d&&d[g],a)}function Xda(a,b,c){if(typeof a[ob]==Bg)return a[ob](b,c);if(Zh(a)||bi(a))return Fi(a,b,c);var d,e=ak(a),f=Xj(a),g=f[J];if(e){d={};for(var k=0;k<g;k++)b[L](c,f[k],e[k],a)&&(d[e[k]]=f[k])}else for(d=[],k=0;k<g;k++)b[L](c,f[k],void 0,a)&&d[C](f[k]);return d}
function Yda(a,b,c){if(typeof a.map==Bg)return a.map(b,c);if(Zh(a)||bi(a))return Gi(a,b,c);var d,e=ak(a),f=Xj(a),g=f[J];if(e){d={};for(var k=0;k<g;k++)d[e[k]]=b[L](c,f[k],e[k],a)}else for(d=[],k=0;k<g;k++)d[k]=b[L](c,f[k],void 0,a);return d}function Zda(a,b,c){if(typeof a[ce]==Bg)return a[ce](b,c);if(Zh(a)||bi(a))return Ni(a,b,c);for(var d=ak(a),e=Xj(a),f=e[J],g=0;g<f;g++)if(!b[L](c,e[g],d&&d[g],a))return!1;return!0};function ck(a){this.ab=new Uj;a&&this.Q0(a)}function dk(a){var b=typeof a;return b==$g&&a||b==Bg?Zg+fi(a):b[ec](0,1)+a}T=ck[K];T.Lc=function(){return this.ab.Lc()};T.add=function(a){this.ab.set(dk(a),a)};T.Q0=function(a){a=Xj(a);for(var b=a[J],c=0;c<b;c++)this.add(a[c])};T.oc=function(a){a=Xj(a);for(var b=a[J],c=0;c<b;c++)this[Ob](a[c])};va(T,function(a){return this.ab[Ob](dk(a))});wa(T,function(){this.ab[Wb]()});Ua(T,function(){return this.ab[$c]()});Pa(T,function(a){return this.ab.$e(dk(a))});
T.Ky=function(a){var b=new ck;a=Xj(a);for(var c=0;c<a[J];c++){var d=a[c];this[Lc](d)&&b.add(d)}return b};T.Il=function(a){var b=this.o();b.oc(a);return b};T.La=function(){return this.ab.La()};T.o=function(){return new ck(this)};Za(T,function(a){return this.Lc()==Wda(a)&&this.rS(a)});T.rS=function(a){var b=Wda(a);if(this.Lc()>b)return!1;!(a instanceof ck)&&5<b&&(a=new ck(a));return Zda(this,function(b){var d=a;return typeof d[Lc]==Bg?d[Lc](b):typeof d.$R==Bg?d.$R(b):Zh(d)||bi(d)?Ri(d,b):Jj(d,b)})};
T.fs=function(){return this.ab.fs(!1)};var ek;t:{var $da=Ph.navigator;if($da){var aea=$da[sc];if(aea){ek=aea;break t}}ek=O};var fk,gk,hk,bea;function ik(){return Ph.navigator||null}var jk=ri(ek,"Opera")||ri(ek,"OPR"),kk=ri(ek,"Trident")||ri(ek,wf),lk=ri(ek,"Gecko")&&!ri(ek[ke](),"webkit")&&!(ri(ek,"Trident")||ri(ek,wf)),mk=ri(ek[ke](),"webkit"),cea=mk&&ri(ek,"Mobile"),dea=ik(),nk=dea&&dea.platform||O;fk=ri(nk,"Mac");gk=ri(nk,"Win");hk=ri(nk,"Linux");bea=!!ik()&&ri(ik().appVersion||O,"X11");var ok=ek;ok&&ri(ok,"Android");ok&&ri(ok,"iPhone");ok&&ri(ok,"iPad");function eea(){var a=Ph[Hd];return a?a[be]:void 0}
var pk=function(){var a=O,b;if(jk&&Ph.opera)return a=Ph.opera.version,ei(a)?a():a;lk?b=/rv\:([^\);]+)(\)|;)/:kk?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:mk&&(b=/WebKit\/(\S+)/);b&&(a=(a=b[sb](ek))?a[1]:O);return kk&&(b=eea(),b>ma(a))?String(b):a}(),fea={};function qk(a){return fea[a]||(fea[a]=0<=vi(pk,a))}function rk(a){return kk&&gea>=a}var hea=Ph[Hd],gea=hea&&kk?eea()||(hea[Yd]==gf?la(pk,10):5):void 0;function sk(a,b){this.x=Qh(a)?a:0;this.y=Qh(b)?b:0}T=sk[K];T.o=function(){return new sk(this.x,this.y)};function tk(a,b){return a==b?!0:a&&b?a.x==b.x&&a.y==b.y:!1}function uk(a,b){var c=a.x-b.x,d=a.y-b.y;return h[ud](c*c+d*d)}function vk(a,b){return new sk(a.x-b.x,a.y-b.y)}function wk(a,b){return new sk(a.x+b.x,a.y+b.y)}sa(T,function(){this.x=h[xb](this.x);this.y=h[xb](this.y);return this});ta(T,function(){this.x=h[t](this.x);this.y=h[t](this.y);return this});
Va(T,function(){this.x=h[D](this.x);this.y=h[D](this.y);return this});db(T,function(a,b){a instanceof sk?(this.x+=a.x,this.y+=a.y):(this.x+=a,di(b)&&(this.y+=b));return this});Oa(T,function(a,b){var c=di(b)?b:a;this.x*=a;this.y*=c;return this});function xk(a,b){pa(this,a);Sa(this,b)}function yk(a,b){return a==b?!0:a&&b?a[r]==b[r]&&a[A]==b[A]:!1}T=xk[K];T.o=function(){return new xk(this[r],this[A])};function zk(a){return h.min(a[r],a[A])}T.area=function(){return this[r]*this[A]};Ua(T,function(){return!this.area()});sa(T,function(){pa(this,h[xb](this[r]));Sa(this,h[xb](this[A]));return this});ta(T,function(){pa(this,h[t](this[r]));Sa(this,h[t](this[A]));return this});Va(T,function(){pa(this,h[D](this[r]));Sa(this,h[D](this[A]));return this});
Oa(T,function(a,b){var c=di(b)?b:a;pa(this,this[r]*a);Sa(this,this[A]*c);return this});var iea=!kk||rk(9),jea=!lk&&!kk||kk&&rk(9)||lk&&qk("1.9.1"),kea=kk&&!qk(We),lea=kk||jk||mk;function Ak(a){a=a[Fd];return bi(a)&&a[Ib](/\S+/g)||[]}function Bk(a,b){for(var c=Ak(a),d=$i(arguments,1),e=c[J]+d[J],f=c,g=0;g<d[J];g++)Ri(f,d[g])||f[C](d[g]);f=c[ie](ne);lb(a,f);return c[J]==e}function Ck(a,b){var c=Ak(a),d=$i(arguments,1),c=mea(c,d)[ie](ne);lb(a,c)}function mea(a,b){return Fi(a,function(a){return!Ri(b,a)})}function Dk(a,b,c){c?Bk(a,b):Ck(a,b)};function Ek(a){return a?new Fk(Gk(a)):lda||(lda=new Fk)}function Hk(a){return bi(a)?fa[gd](a):a}function Ik(a,b,c){return Jk(fa,a,b,c)}function Mk(a,b){var c=b||fa;return c[Td]&&c[Pb]?c[Td](Me+a):Jk(fa,He,a,b)}function Nk(a,b){var c=b||fa,d=null;return(d=c[Td]&&c[Pb]?c[Pb](Me+a):Jk(fa,He,a,b)[0])||null}
function Jk(a,b,c,d){a=d||a;b=b&&b!=He?b[ge]():O;if(a[Td]&&a[Pb]&&(b||c))return a[Td](b+(c?Me+c:O));if(c&&a.getElementsByClassName){a=a.getElementsByClassName(c);if(b){d={};for(var e=0,f=0,g;g=a[f];f++)b==g[nd]&&(d[e++]=g);jb(d,e);return d}return a}a=a[cc](b||He);if(c){d={};for(f=e=0;g=a[f];f++)b=g[Fd],typeof b[pc]==Bg&&Ri(b[pc](/\s+/),c)&&(d[e++]=g);jb(d,e);return d}return a}
function Ok(a,b){Dj(b,function(b,d){d==sh?$a(a[x],b):d==Vba?lb(a,b):d==eca?a.htmlFor=b:d in nea?a[v](nea[d],b):ki(d,Jba)||ki(d,aca)?a[v](d,b):a[d]=b})}var nea={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:Hg,maxlength:"maxLength",role:ih,rowspan:"rowSpan",type:Ah,usemap:"useMap",valign:"vAlign",width:Ih};function Pk(a){a=a[Hd];a=a[Yd]==gf?a[dc]:a[Pd];return new xk(a[Gd],a[Wd])}function oea(a){return mk||a[Yd]!=gf?a[Pd]||a[dc]:a[dc]}
function Qk(a){return a?a.parentWindow||a[xd]:ca}function Rk(a,b,c){return pea(fa,arguments)}function pea(a,b){var c=b[0],d=b[1];if(!iea&&d&&(d[yd]||d[H])){c=[Ze,c];d[yd]&&c[C](caa,qi(d[yd]),oe);if(d[H]){c[C](daa,qi(d[H]),oe);var e={};Sj(e,d);delete e[H];d=e}c[C](bf);c=c[ie](O)}c=a[Qb](c);d&&(bi(d)?lb(c,d):Yh(d)?Bk[Mc](null,[c][Ab](d)):Ok(c,d));2<b[J]&&qea(a,c,b,2);return c}
function qea(a,b,c,d){function e(c){c&&b[p](bi(c)?a[Cb](c):c)}for(;d<c[J];d++){var f=c[d];Zh(f)&&!Sk(f)?Y(rea(f)?Yi(f):f,e):e(f)}}function Tk(a){return fa[Qb](a)}function Uk(a){if(1!=a[ed])return!1;switch(a[Nc]){case Haa:case Iaa:case Jaa:case ef:case Kaa:case Laa:case Oaa:case Qaa:case pf:case Waa:case qf:case Vaa:case Xaa:case $aa:case aba:case fba:case gba:case bba:case hba:case iba:case Df:case Ff:case lba:case oba:case tba:return!1}return!0}function sea(a,b){a[p](b)}
function Vk(a,b){qea(Gk(a),a,arguments,1)}function Wk(a){for(var b;b=a[Sb];)a[Qd](b)}function Xk(a,b){b[fe]&&b[fe][Eb](a,b)}function Yk(a,b){b[fe]&&b[fe][Eb](a,b[ac])}function Zk(a){return a&&a[fe]?a[fe][Qd](a):null}function $k(a){return jea&&void 0!=a[td]?a[td]:Fi(a[Xb],function(a){return 1==a[ed]})}function al(a){return void 0!=a.firstElementChild?a.firstElementChild:tea(a[Sb])}function tea(a){for(;a&&1!=a[ed];)a=a[ac];return a}function Sk(a){return ai(a)&&0<a[ed]}
function bl(a){return ai(a)&&1==a[ed]}function cl(a){var b;if(lea&&!(kk&&qk(We)&&!qk(Ue)&&Ph.SVGElement&&a instanceof Ph.SVGElement)&&(b=a[wd]))return b;b=a[fe];return bl(b)?b:null}function dl(a,b){if(a[Lc]&&1==b[ed])return a==b||a[Lc](b);if("undefined"!=typeof a[md])return a==b||ka(a[md](b)&16);for(;b&&a!=b;)b=b[fe];return b==a}
function uea(a,b){if(a==b)return 0;if(a[md])return a[md](b)&2?1:-1;if(kk&&!rk(9)){if(9==a[ed])return-1;if(9==b[ed])return 1}if(Qca in a||a[fe]&&Qca in a[fe]){var c=1==a[ed],d=1==b[ed];if(c&&d)return a[mc]-b[mc];var e=a[fe],f=b[fe];return e==f?vea(a,b):!c&&dl(e,b)?-1*wea(a,b):!d&&dl(f,a)?wea(b,a):(c?a[mc]:e[mc])-(d?b[mc]:f[mc])}d=Gk(a);c=d[od]();c.selectNode(a);c[tb](!0);d=d[od]();d.selectNode(b);d[tb](!0);return c.compareBoundaryPoints(Ph[Vc].START_TO_END,d)}
function wea(a,b){var c=a[fe];if(c==b)return-1;for(var d=b;d[fe]!=c;)d=d[fe];return vea(d,a)}function vea(a,b){for(var c=b;c=c[gc];)if(c==a)return-1;return 1}function Gk(a){return 9==a[ed]?a:a[wc]||a[Hd]}function el(a,b){if(Wca in a)a.textContent=b;else if(3==a[ed])ra(a,b);else if(a[Sb]&&3==a[Sb][ed]){for(;a[yc]!=a[Sb];)a[Qd](a[yc]);ra(a[Sb],b)}else{Wk(a);var c=Gk(a);a[p](c[Cb](String(b)))}}function xea(a){if(Cca in a)return a.outerHTML;var b=Gk(a)[Qb](Q);b[p](a.cloneNode(!0));return b[hd]}
function yea(a,b){var c=[];return fl(a,b,c,!0)?c[0]:void 0}function zea(a,b){var c=[];fl(a,b,c,!1);return c}function fl(a,b,c,d){if(null!=a)for(a=a[Sb];a;){if(b(a)&&(c[C](a),d)||fl(a,b,c,d))return!0;a=a[ac]}return!1}var Aea={SCRIPT:1,STYLE:1,HEAD:1,IFRAME:1,OBJECT:1},Bea={IMG:ne,BR:me};function gl(a,b){b?bb(a,0):(bb(a,-1),a[Pc](Tca))}function hl(a){a=a.getAttributeNode(Uca);return null!=a&&a.specified}function il(a){a=a.tabIndex;return di(a)&&0<=a&&32768>a}
function jl(a){if(kea&&tca in a)a=a.innerText[vb](/(\r\n|\r|\n)/g,me);else{var b=[];kl(a,b,!0);a=b[ie](O)}a=a[vb](/ \xAD /g,ne)[vb](/\xAD/g,O);a=a[vb](/\u200B/g,O);kea||(a=a[vb](/ +/g,ne));a!=ne&&(a=a[vb](/^\s*/,O));return a}function ll(a){var b=[];kl(a,b,!1);return b[ie](O)}function kl(a,b,c){if(!(a[nd]in Aea))if(3==a[ed])c?b[C](String(a[Yc])[vb](/(\r\n|\r|\n)/g,O)):b[C](a[Yc]);else if(a[nd]in Bea)b[C](Bea[a[nd]]);else for(a=a[Sb];a;)kl(a,b,c),a=a[ac]}
function rea(a){if(a&&typeof a[J]==Yg){if(ai(a))return typeof a[jd]==Bg||typeof a[jd]==rh;if(ei(a))return typeof a[jd]==Bg}return!1}function Cea(a){return ml(a,function(a){return a[nd]==mba&&!0},!0)}function ml(a,b,c){c||(a=a[fe]);for(c=0;a;){if(b(a))return a;a=a[fe];c++}return null}function nl(a){try{return a&&a[pb]}catch(b){}return null}function Fk(a){this.of=a||Ph[Hd]||fa}T=Fk[K];T.ea=Ek;T.$b=function(){return this.of};T.a=function(a){return bi(a)?this.of[gd](a):a};
T.Kv=function(a,b){return Nk(a,b||this.of)};T.kv=Ok;T.h=function(a,b,c){return pea(this.of,arguments)};T.createElement=function(a){return this.of[Qb](a)};T.createTextNode=function(a){return this.of[Cb](String(a))};T.Xda=function(a,b,c){var d=this.of,e=!!c;c=[Faa];for(var f=0;f<b;f++)c[C](e?Daa:Eaa);c[C](zaa);c=c[ie](O);b=[Caa];for(f=0;f<a;f++)b[C](c);b[C](yaa);a=d[Qb](kf);Wa(a,b[ie](O));return a[Qd](a[Sb])};
function ol(a,b){var c;var d=a.of;c=d[Qb](Q);kk?(Wa(c,$e+b),c[Qd](c[Sb])):Wa(c,b);if(1==c[Xb][J])c=c[Qd](c[Sb]);else{for(d=d.createDocumentFragment();c[Sb];)d[p](c[Sb]);c=d}return c}function pl(a){return a.of[Yd]==gf}T.xB=function(){var a=this.of;return a.parentWindow||a[xd]};function ql(a){var b=a.of;a=oea(b);b=b.parentWindow||b[xd];return kk&&qk(Ue)&&b.pageYOffset!=a[Cd]?new sk(a[Gc],a[Cd]):new sk(b.pageXOffset||a[Gc],b.pageYOffset||a[Cd])}T.bE=function(a){return nl(a||this.of)};T.appendChild=sea;
T.append=Vk;T.cd=Wk;T.FX=Xk;T.zga=Yk;T.removeNode=Zk;T.$f=$k;T.n9=al;T.mK=Sk;T.Zia=bl;Pa(T,dl);T.yna=el;T.Jq=function(a){var b;(b=a[Nc]==df||a[Nc]==qf||a[Nc]==Mf||a[Nc]==Ef||a[Nc]==ff?!a[Nd]&&(!hl(a)||il(a)):hl(a)&&il(a))&&kk?(a=ei(a[qb])?a[qb]():{height:a[Uc],width:a[zb]},a=null!=a&&0<a[A]&&0<a[r]):a=b;return a};function Dea(){return mk?vba:lk?dba:kk?wca:jk?zf:null}function Eea(){return mk?oaa:lk?kaa:kk?laa:jk?maa:null};function rl(a,b,c,d){this.top=a;Ta(this,b);Na(this,c);Ya(this,d)}T=rl[K];T.o=function(){return new rl(this.top,this[Zc],this[Hc],this[G])};Pa(T,function(a){return this&&a?a instanceof rl?a[G]>=this[G]&&a[Zc]<=this[Zc]&&a.top>=this.top&&a[Hc]<=this[Hc]:a.x>=this[G]&&a.x<=this[Zc]&&a.y>=this.top&&a.y<=this[Hc]:!1});
T.expand=function(a,b,c,d){ai(a)?(this.top-=a.top,Ta(this,this[Zc]+a[Zc]),Na(this,this[Hc]+a[Hc]),Ya(this,this[G]-a[G])):(this.top-=a,Ta(this,this[Zc]+b),Na(this,this[Hc]+c),Ya(this,this[G]-d));return this};function tl(a,b){Ya(a,h.min(a[G],b[G]));a.top=h.min(a.top,b.top);Ta(a,h.max(a[Zc],b[Zc]));Na(a,h.max(a[Hc],b[Hc]))}function ul(a,b){return a[G]<=b[Zc]&&b[G]<=a[Zc]&&a.top<=b[Hc]&&b.top<=a[Hc]}
sa(T,function(){this.top=h[xb](this.top);Ta(this,h[xb](this[Zc]));Na(this,h[xb](this[Hc]));Ya(this,h[xb](this[G]));return this});ta(T,function(){this.top=h[t](this.top);Ta(this,h[t](this[Zc]));Na(this,h[t](this[Hc]));Ya(this,h[t](this[G]));return this});Va(T,function(){this.top=h[D](this.top);Ta(this,h[D](this[Zc]));Na(this,h[D](this[Hc]));Ya(this,h[D](this[G]));return this});
db(T,function(a,b){a instanceof sk?(Ya(this,this[G]+a.x),Ta(this,this[Zc]+a.x),this.top+=a.y,Na(this,this[Hc]+a.y)):(Ya(this,this[G]+a),Ta(this,this[Zc]+a),di(b)&&(this.top+=b,Na(this,this[Hc]+b)));return this});Oa(T,function(a,b){var c=di(b)?b:a;Ya(this,this[G]*a);Ta(this,this[Zc]*a);this.top*=c;Na(this,this[Hc]*c);return this});function vl(a,b,c,d){Ya(this,a);this.top=b;pa(this,c);Sa(this,d)}T=vl[K];T.o=function(){return new vl(this[G],this.top,this[r],this[A])};function wl(a){return new rl(a.top,a[G]+a[r],a.top+a[A],a[G])}function xl(a){return new vl(a[G],a.top,a[Zc]-a[G],a[Hc]-a.top)}function yl(a,b){return a==b?!0:a&&b?a[G]==b[G]&&a[r]==b[r]&&a.top==b.top&&a[A]==b[A]:!1}
T.Ky=function(a){var b=h.max(this[G],a[G]),c=h.min(this[G]+this[r],a[G]+a[r]);if(b<=c){var d=h.max(this.top,a.top);a=h.min(this.top+this[A],a.top+a[A]);if(d<=a)return Ya(this,b),this.top=d,pa(this,c-b),Sa(this,a-d),!0}return!1};function Fea(a,b){var c=h.max(a[G],b[G]),d=h.min(a[G]+a[r],b[G]+b[r]);if(c<=d){var e=h.max(a.top,b.top),f=h.min(a.top+a[A],b.top+b[A]);if(e<=f)return new vl(c,e,d-c,f-e)}return null}
T.Il=function(a){var b=Fea(this,a);if(b&&b[A]&&b[r]){var b=[],c=this.top,d=this[A],e=this[G]+this[r],f=this.top+this[A],g=a[G]+a[r],k=a.top+a[A];a.top>this.top&&(b[C](new vl(this[G],this.top,this[r],a.top-this.top)),c=a.top,d-=a.top-this.top);k<f&&(b[C](new vl(this[G],k,this[r],f-k)),d=k-c);a[G]>this[G]&&b[C](new vl(this[G],c,a[G]-this[G],d));g<e&&b[C](new vl(g,c,e-g,d));a=b}else a=[this.o()];return a};
Pa(T,function(a){return a instanceof vl?this[G]<=a[G]&&this[G]+this[r]>=a[G]+a[r]&&this.top<=a.top&&this.top+this[A]>=a.top+a[A]:a.x>=this[G]&&a.x<=this[G]+this[r]&&a.y>=this.top&&a.y<=this.top+this[A]});function Gea(a,b){var c=b.x<a[G]?a[G]-b.x:h.max(b.x-(a[G]+a[r]),0),d=b.y<a.top?a.top-b.y:h.max(b.y-(a.top+a[A]),0);return c*c+d*d}T.distance=function(a){return h[ud](Gea(this,a))};T.Ub=function(){return new xk(this[r],this[A])};
T.getCenter=function(){return new sk(this[G]+this[r]/2,this.top+this[A]/2)};sa(T,function(){Ya(this,h[xb](this[G]));this.top=h[xb](this.top);pa(this,h[xb](this[r]));Sa(this,h[xb](this[A]));return this});ta(T,function(){Ya(this,h[t](this[G]));this.top=h[t](this.top);pa(this,h[t](this[r]));Sa(this,h[t](this[A]));return this});Va(T,function(){Ya(this,h[D](this[G]));this.top=h[D](this.top);pa(this,h[D](this[r]));Sa(this,h[D](this[A]));return this});
db(T,function(a,b){a instanceof sk?(Ya(this,this[G]+a.x),this.top+=a.y):(Ya(this,this[G]+a),di(b)&&(this.top+=b));return this});Oa(T,function(a,b){var c=di(b)?b:a;Ya(this,this[G]*a);pa(this,this[r]*a);this.top*=c;Sa(this,this[A]*c);return this});function zl(a,b,c){bi(b)?Hea(a,c,b):Dj(b,gi(Hea,a))}function Hea(a,b,c){(c=Iea(a,c))&&(a[x][c]=b)}function Iea(a,b){var c=zi(b);if(void 0===a[x][c]){var d=Dea()+Ada(b);if(void 0!==a[x][d])return d}return c}function Jea(a,b){var c=a[x][zi(b)];return"undefined"!==typeof c?c:a[x][Iea(a,b)]||O}function Al(a,b){var c=Gk(a);return c[xd]&&c[xd].getComputedStyle&&(c=c[xd].getComputedStyle(a,null))?c[b]||c.getPropertyValue(b)||O:O}function Bl(a,b){return Al(a,b)||(a[$d]?a[$d][b]:null)||a[x]&&a[x][b]}
function Cl(a){return Bl(a,eh)}function Dl(a,b,c){var d,e=lk&&(fk||bea)&&qk(waa);b instanceof sk?(d=b.x,b=b.y):(d=b,b=c);Ya(a[x],El(d,e));a[x].top=El(b,e)}function Fl(a){return new sk(a[Od],a[Tc])}function Gl(a){a=a?Gk(a):fa;return!kk||rk(9)||pl(Ek(a))?a[dc]:a[Pd]}function Hl(a){var b;try{b=a[qb]()}catch(c){return{left:0,top:0,right:0,bottom:0}}kk&&a[wc][Pd]&&(a=a[wc],Ya(b,b[G]-(a[dc][Ub]+a[Pd][Ub])),b.top-=a[dc][Vb]+a[Pd][Vb]);return b}
function Kea(a){if(kk&&!rk(8))return a[qc];var b=Gk(a),c=Bl(a,eh),d=c==yg||c==cg;for(a=a[fe];a&&a!=b;a=a[fe])if(c=Bl(a,eh),d=d&&c==qh&&a!=b[dc]&&a!=b[Pd],!d&&(a[Bc]>a[Gd]||a[Rb]>a[Wd]||c==yg||c==cg||c==gh))return a;return null}
function Il(a){for(var b=new rl(0,ea,ea,0),c=Ek(a),d=c.$b()[Pd],e=c.$b()[dc],f=oea(c.of);a=Kea(a);)if(!(kk&&0==a[Gd]||mk&&0==a[Wd]&&a==d||a==d||a==e||Bl(a,ch)==Fh)){var g=Jl(a),k;k=a;if(lk&&!qk(waa)){var l=ma(Al(k,Oba));if(Kl(k))var n=k[zb]-k[Gd]-l-ma(Al(k,Qba)),l=l+n;k=new sk(l,ma(Al(k,Sba)))}else k=new sk(k[Ub],k[Vb]);g.x+=k.x;g.y+=k.y;b.top=h.max(b.top,g.y);Ta(b,h.min(b[Zc],g.x+a[Gd]));Na(b,h.min(b[Hc],g.y+a[Wd]));Ya(b,h.max(b[G],g.x))}d=f[Gc];f=f[Cd];Ya(b,h.max(b[G],d));b.top=h.max(b.top,f);c=
c.xB();c=Pk(c||ca);Ta(b,h.min(b[Zc],d+c[r]));Na(b,h.min(b[Hc],f+c[A]));return 0<=b.top&&0<=b[G]&&b[Hc]>b.top&&b[Zc]>b[G]?b:null}
function Jl(a){var b,c=Gk(a),d=Bl(a,eh),e=lk&&c[Lb]&&!a[qb]&&d==cg&&(b=c[Lb](a))&&(0>b[Gb]||0>b[Hb]),f=new sk(0,0),g=Gl(c);if(a==g)return f;if(a[qb])b=Hl(a),a=ql(Ek(c)),f.x=b[G]+a.x,f.y=b.top+a.y;else if(c[Lb]&&!e)b=c[Lb](a),a=c[Lb](g),f.x=b[Gb]-a[Gb],f.y=b[Hb]-a[Hb];else{b=a;do{f.x+=b[Od];f.y+=b[Tc];b!=a&&(f.x+=b[Ub]||0,f.y+=b[Vb]||0);if(mk&&Cl(b)==yg){f.x+=c[Pd][Gc];f.y+=c[Pd][Cd];break}b=b[qc]}while(b&&b!=a);if(jk||mk&&d==cg)f.y-=c[Pd][Tc];for(b=a;(b=Kea(b))&&b!=c[Pd]&&b!=g;)f.x-=b[Gc],jk&&b[Nc]==
Of||(f.y-=b[Cd])}return f}function Ll(a,b){var c=Ml(a),d=Ml(b);return new sk(c.x-d.x,c.y-d.y)}function Lea(a){var b;if(a[qb])b=Hl(a),b=new sk(b[G],b.top);else{b=ql(Ek(a));var c=Jl(a);b=new sk(c.x-b.x,c.y-b.y)}if(lk&&!qk(12)){i:{c=zi(xh);if(void 0===a[x][c]&&(c=Dea()+Ada(xh),void 0!==a[x][c])){c=Eea()+naa;break i}c=xh}a=(a=Bl(a,c)||Bl(a,xh))?(a=a[Ib](Mea))?new sk(ma(a[1]),ma(a[2])):new sk(0,0):new sk(0,0);a=wk(b,a)}else a=b;return a}
function Ml(a){if(1==a[ed])return Lea(a);var b=ei(a.Rpa),c=a;a[Fb]?c=a[Fb][0]:b&&a.Ka[Fb]&&(c=a.Ka[Fb][0]);return new sk(c[zd],c[Ad])}function Nl(a,b,c){if(b instanceof xk)c=b[A],b=b[r];else if(void 0==c)throw m("missing height argument");pa(a[x],El(b,!0));Sa(a[x],El(c,!0))}function El(a,b){typeof a==Yg&&(a=(b?h[D](a):a)+S);return a}function Ol(a){return Pl(a)}
function Pl(a){var b=Nea;if(Bl(a,rg)!=R)return b(a);var c=a[x],d=c[Sc],e=c.visibility,f=c[jc];hb(c,Ig);Ea(c,cg);Ra(c,Og);a=b(a);Ra(c,d);Ea(c,f);hb(c,e);return a}function Nea(a){var b=a[zb],c=a[Uc],d=mk&&!b&&!c;return Qh(b)&&!d||!a[qb]?new xk(b,c):(a=Hl(a),new xk(a[Zc]-a[G],a[Hc]-a.top))}function Ql(a){var b=Jl(a);a=Pl(a);return new vl(b.x,b.y,a[r],a[A])}function Rl(a,b){var c=a[x];bh in c?mb(c,b):eba in c?c.MozOpacity=b:xg in c&&(c.filter=b===O?O:Hba+100*b+Ge)}function Sl(a,b){Ra(a[x],b?O:R)}
function Tl(a){var b=Ek(void 0),c=null,c=b.$b();if(kk&&c.createStyleSheet)b=c=c.createStyleSheet(),kk&&Qh(b.cssText)?$a(b,a):Wa(b,a);else{var d=Jk(b.of,Gg,void 0,void 0)[0];d||(c=Jk(b.of,hg,void 0,void 0)[0],d=b.h(Gg),c[fe][Eb](d,c));var e=c=b.h(sh);kk&&Qh(e.cssText)?$a(e,a):Wa(e,a);b[p](d,c)}return c}function Kl(a){return jh==Bl(a,qg)}var Ul=lk?"MozUserSelect":mk?"WebkitUserSelect":null;
function Vl(a,b,c){c=c?null:a[cc](He);if(Ul){if(b=b?R:O,a[x][Ul]=b,c){a=0;for(var d;d=c[a];a++)d[x][Ul]=b}}else if(kk||jk)if(b=b?ah:O,a[v](Bh,b),c)for(a=0;d=c[a];a++)d[v](Bh,b)}function Wl(a){var b=Gk(a),c=kk&&a[$d];if(c&&pl(Ek(b))&&c[r]!=eg&&c[A]!=eg&&!c.boxSizing)return b=Xl(a,c[r],Ih,Jca),a=Xl(a,c[A],Hg,Hca),new xk(b,a);c=new xk(a[zb],a[Uc]);b=Yl(a);a=Zl(a);return new xk(c[r]-a[G]-b[G]-b[Zc]-a[Zc],c[A]-a.top-b.top-b[Hc]-a[Hc])}
function Xl(a,b,c,d){if(/^\d+px?$/[bd](b))return la(b,10);var e=a[x][c],f=a.runtimeStyle[c];a.runtimeStyle[c]=a[$d][c];a[x][c]=b;b=a[x][d];a[x][c]=e;a.runtimeStyle[c]=f;return b}function $l(a,b){var c=a[$d]?a[$d][b]:null;return c?Xl(a,c,Qg,Ica):0}function Yl(a){if(kk){var b=$l(a,Eca),c=$l(a,Fca),d=$l(a,Gca);a=$l(a,Dca);return new rl(d,c,a,b)}b=Al(a,Eca);c=Al(a,Fca);d=Al(a,Gca);a=Al(a,Dca);return new rl(ma(d),ma(c),ma(a),ma(b))}var Oea={thin:2,medium:4,thick:6};
function am(a,b){if((a[$d]?a[$d][b+nba]:null)==R)return 0;var c=a[$d]?a[$d][b+wba]:null;return c in Oea?Oea[c]:Xl(a,c,Qg,Ica)}function Zl(a){if(kk&&!rk(9)){var b=am(a,Nba),c=am(a,Pba),d=am(a,Rba);a=am(a,Lba);return new rl(d,c,a,b)}b=Al(a,Oba);c=Al(a,Qba);d=Al(a,Sba);a=Al(a,Mba);return new rl(ma(d),ma(c),ma(a),ma(b))}function bm(a){var b={};Y(a[pc](/\s*;\s*/),function(a){a=a[pc](/\s*:\s*/);2==a[J]&&(b[zi(a[0][ke]())]=a[1])});return b}var Mea=/matrix\([0-9\.\-]+, [0-9\.\-]+, [0-9\.\-]+, [0-9\.\-]+, ([0-9\.\-]+)p?x?, ([0-9\.\-]+)p?x?\)/;var Pea=RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");function cm(a){if(dm){dm=!1;var b=Ph[tc];if(b){var c=b[Ic];if(c&&(c=em(c))&&c!=b.hostname)throw dm=!0,m();}}return a[Ib](Pea)}var dm=mk;function em(a){return(a=cm(a)[3]||null)&&oa(a)}function fm(a){return(a=cm(a)[5]||null)&&oa(a)}
function gm(a,b,c,d){for(var e=c[J];0<=(b=a[ld](c,b))&&b<d;){var f=a[Xd](b-1);if(38==f||63==f)if(f=a[Xd](b+e),!f||61==f||38==f||35==f)return b;b+=e+1}return-1}var hm=/#|$/;function im(a,b){var c=a[xc](hm),d=gm(a,0,b,c);if(0>d)return null;var e=a[ld](xe,d);if(0>e||e>c)e=c;d+=b[J]+1;return oa(a[ec](d,e-d)[vb](/\+/g,ne))}var Qea=/[?&]($|#)/;function jm(a,b){for(var c=a[xc](hm),d=0,e,f=[];0<=(e=gm(a,d,b,c));)f[C](a[ae](d,e)),d=h.min(a[ld](xe,e)+1||c,c);f[C](a[ec](d));return f[ie](O)[vb](Qea,faa)}
function km(a,b,c){a=[jm(a,b),xe,b];null!=c&&a[C](af,aa(String(c)));a[1]&&(c=a[0],b=c[ld](qe),0<=b&&(a[C](c[ec](b)),a[0]=c=c[ec](0,b)),b=c[ld](cf),0>b?a[1]=cf:b==c[J]-1&&(a[1]=void 0));return a[ie](O)};var lm={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:re,blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkgrey:"#a9a9a9",
darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkslategrey:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",
gold:"#ffd700",goldenrod:"#daa520",gray:se,green:"#008000",greenyellow:"#adff2f",grey:se,honeydew:"#f0fff0",hotpink:"#ff69b4",indianred:"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgray:"#d3d3d3",lightgreen:"#90ee90",lightgrey:"#d3d3d3",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",
lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370db",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",
navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#db7093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",
silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",slategrey:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:ue,whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};function mm(a){var b={};a=String(a);var c=a[Bb](0)==qe?a:qe+a;if(nm[bd](c))return b.vd=om(c),ab(b,sca),b;c=Rea(a);if(c[J])return b.vd=pm(c),ab(b,hh),b;if(lm&&(c=lm[a[ke]()]))return b.vd=c,ab(b,xca),b;throw m(a+" is not a valid color string");}function qm(a){return!!(nm[bd](a[Bb](0)==qe?a:qe+a)||Rea(a)[J]||lm&&lm[a[ke]()])}var Sea=/#(.)(.)(.)/;function om(a){if(!nm[bd](a))throw m(Ee+a+"' is not a valid hex color");4==a[J]&&(a=a[vb](Sea,eaa));return a[ke]()}
function rm(a){a=om(a);return[la(a[ec](1,2),16),la(a[ec](3,2),16),la(a[ec](5,2),16)]}function sm(a,b,c){a=ia(a);b=ia(b);c=ia(c);if(ga(a)||0>a||255<a||ga(b)||0>b||255<b||ga(c)||0>c||255<c)throw m('"('+a+Je+b+Je+c+'") is not a valid RGB color');a=tm(a[hc](16));b=tm(b[hc](16));c=tm(c[hc](16));return qe+a+b+c}function pm(a){return sm(a[0],a[1],a[2])}
function Tea(a){var b=a[0]/255,c=a[1]/255;a=a[2]/255;var d=h.max(b,c,a),e=h.min(b,c,a),f=0,g=0,k=0.5*(d+e);d!=e&&(d==b?f=60*(c-a)/(d-e):d==c?f=60*(a-b)/(d-e)+120:d==a&&(f=60*(b-c)/(d-e)+240),g=0<k&&0.5>=k?(d-e)/(2*k):(d-e)/(2-2*k));return[h[D](f+360)%360,g,k]}function um(a,b,c){0>c?c+=1:1<c&&(c-=1);return 1>6*c?a+6*(b-a)*c:1>2*c?b:2>3*c?a+(b-a)*(2/3-c)*6:a}
function Uea(a){var b=a[1],c=a[2],d=0,e=0,f=0;a=a[0]/360;if(0==b)d=e=f=255*c;else var g=f=0,g=0.5>c?c*(1+b):c+b-b*c,f=2*c-g,d=255*um(f,g,a+1/3),e=255*um(f,g,a),f=255*um(f,g,a-1/3);return[h[D](d),h[D](e),h[D](f)]}var nm=/^#(?:[0-9a-f]{3}){1,2}$/i,Vea=/^(?:rgb)?\((0|[1-9]\d{0,2}),\s?(0|[1-9]\d{0,2}),\s?(0|[1-9]\d{0,2})\)$/i;function Rea(a){var b=a[Ib](Vea);if(b){a=ia(b[1]);var c=ia(b[2]),b=ia(b[3]);if(0<=a&&255>=a&&0<=c&&255>=c&&0<=b&&255>=b)return[a,c,b]}return[]}
function tm(a){return 1==a[J]?Oe+a:a}function vm(a,b,c){c=nj(c,0,1);return[h[D](c*a[0]+(1-c)*b[0]),h[D](c*a[1]+(1-c)*b[1]),h[D](c*a[2]+(1-c)*b[2])]}function wm(a,b){return vm([0,0,0],a,b)}function xm(a,b){return vm([255,255,255],a,b)}function ym(a,b){for(var c=[],d=0;d<b[J];d++)c[C]({color:b[d],eh:Wea(b[d],a)+Xea(b[d],a)});c[Zd](function(a,b){return b.eh-a.eh});return c[0][E]}function Wea(a,b){return h.abs(h[D]((299*a[0]+587*a[1]+114*a[2])/1E3)-h[D]((299*b[0]+587*b[1]+114*b[2])/1E3))}
function Xea(a,b){return h.abs(a[0]-b[0])+h.abs(a[1]-b[1])+h.abs(a[2]-b[2])};function zm(a,b){La(this,a<b?a:b);this.end=a<b?b:a}zm[K].o=function(){return new zm(this[y],this.end)};zm[K].getLength=function(){return this.end-this[y]};function Am(a,b){La(a,h.min(a[y],b));a.end=h.max(a.end,b)}function Bm(a,b){return a[y]<=b&&a.end>=b};function Cm(a,b){a&&(a.logicalname=b)}function Yea(a){return(a=ml(a,function(a){return null!=a.logicalname},!0))?a.logicalname:ag};function Dm(a){return a==R||a==O||a==yh?R:mm(a).vd}function Em(a){if(a==R)return R;a=rm(a);a=h[D]((a[0]+a[1]+a[2])/3);return sm(a,a,a)}function Zea(a){a=Pj(a);null==a[Ed]&&ib(a,!0);return a}function $ea(a,b){var c=a.h(b[yd],b.fd);a.kv(c,{style:b[x]});if(null!=b[yb]){var d=Yh(b[yb])?b[yb]:[b[yb]];Y(d,function(b){if(bi(b))a[p](c,a[Cb](b));else b=bi(b[yb])&&b.ela?ol(a,b[yb]):$ea(a,b),a[p](c,b)})}null!=b.id&&Cm(c,b.id);return c};function Mm(a,b,c){return a&&a!=R?b&&b!=R?pm(vm(rm(a),rm(b),c)):a:b}function Nm(a,b){if(null==b)return a;var c=new zm(b,b);return a?new zm(h.min(a[y],c[y]),h.max(a.end,c.end)):c}function afa(a,b,c){var d=null!=b?b:a&&null!=c&&c<a[y]?c:a?a[y]:null;a=null!=c?c:a&&null!=b&&b>a.end?b:a?a.end:null;return null!=d&&null!=a?new zm(d,a):null}function Om(a){if(0==a[J])return null;for(var b=a[0].o(),c=1;c<a[J];c++)tl(b,a[c]);return b}
function Pm(a,b){var c=aj(a,b);if(0<=c)return b;c=-(c+1);if(0==c)return a[0];if(c==a[J])return Ai(a);var d=a[c-1],c=a[c];return h.abs(b-d)<=h.abs(b-c)?d:c};function Qm(a,b,c){this.Ge=a;this.qk=Dm(b);this.yx=Dm(null!=c?c:ue)}Qm[K].Hd=function(){return this.qk};Qm[K].qr=function(){return this.yx};Qm[K].o=function(){return new Qm(this.Ge,this.qk,this.yx)};Qm[K].lF=function(){return new Qm(this.Ge,Em(this.qk),Em(this.yx))};function Rm(a){a=a||{};this.aB=R;null!=a[fc]&&this.pe(a[fc]);this.Oe=1;null!=a.ae&&this.dh(a.ae);this.Qd=R;null!=a[Yb]&&this.dd(a[Yb]);this.Hb=1;null!=a.qa&&this.yk(a.qa);this.Ai=1;null!=a.Cg&&Sm(this,a.Cg);this.Hk=ph;null!=a.cO&&(this.Hk=a.cO);this.mA=null!=a.ji?a.ji:null;this.nA=null!=a.ki?a.ki:null;this.Qg=null;a.gh&&(this.Qg=Pj(a.gh),this.Qg.lg=Dm(this.Qg.lg),this.Qg.Tf=Dm(this.Qg.Tf));this.fe=null;a[ub]&&(this.fe=a[ub]);this.VW=null}T=Rm[K];
T.sm=function(){return{fill:this.gb(),ae:this.Oe,stroke:this.Qd,qa:this.Hb,Cg:this.Ai,cO:this.Hk,ji:this.mA,ki:this.nA,gh:Qj(this.Qg),pattern:Qj(this.fe)}};
Fa(T,function(){var a=this.Qg||null;a&&(a={color1:a.lg,color2:a.Tf,opacity1:a.Wy,opacity2:a.Xy,x1:a.x1,y1:a.y1,x2:a.hb,y2:a.kb,useObjectBoundingBoxUnits:a.sv,sharpTransition:a.uK});var b=this.fe||null;b&&(b={style:b.Ge,color:b.Hd(),bgcolor:b.qr()});a={fill:this.gb(),fillOpacity:this.Oe,stroke:this.Qd,strokeWidth:this.Hb,strokeOpacity:this.Ai,strokeDashStyle:this.Hk,rx:this.mA,ry:this.nA,gradient:a,pattern:b};return"undefined"!==typeof JSON&&JSON.stringify?JSON.stringify(a):Tm(a)});T.o=function(){return new Rm(this.sm())};
T.lF=function(){var a=this.o();a.pe(Em(this.aB));a.dd(Em(this.Qd));if(this.Qg){var b=Pj(this.Qg);b.lg=Em(this.Qg.lg);b.Tf=Em(this.Qg.Tf);a.gh=b}this.fe&&(b=this.fe.lF(),a.fe=b);return a};function bfa(a){return null==a||a==R}T.pe=function(a){this.aB=Dm(a)};T.gb=function(){return this.aB};T.dh=function(a){this.Oe=nj(a,0,1)};T.dd=function(a,b){this.Qd=Dm(a);null!=b&&this.yk(b)};T.Yaa=function(){return this.Qd};T.yk=function(a){this.Hb=a};function Um(a){return Vm(a)?a.Hb:0}
function Sm(a,b){a.Ai=nj(b,0,1)}T.setShadow=function(a){this.VW=a};T.getShadow=function(){return this.VW};function Wm(a){return 0<a.Oe&&(!bfa(a.aB)||null!=a.Qg||null!=a.fe)}function Vm(a){return 0<a.Hb&&0<a.Ai&&!bfa(a.Qd)}function Xm(a){return Wm(a)&&1<=a.Oe}var Ym=new Rm({ae:0,fill:Hh,Cg:0,stroke:Hh});function Zm(a,b){return new Rm({stroke:R,fill:a,ae:null!=b?b:1})}function $m(a,b,c,d){return new Rm({stroke:a,qa:b,Cg:null!=d?d:1,fill:null!=c&&c?te:R})}
function cfa(a,b){var c;if(a===b)c=!0;else if(null==a||null==b)c=!1;else if(c=a.aB==b.aB)if(c=a.Oe==b.Oe)if(c=a.Qd==b.Qd)if(c=a.Hb==b.Hb)if(c=a.Ai==b.Ai)if(c=a.Hk==b.Hk)if(c=a.mA==b.mA)if(c=a.nA==b.nA){c=a.gh;var d=b.gh;if(c=c===d?!0:null==c||null==d?!1:c.lg==d.lg&&c.Tf==d.Tf&&c.x1==d.x1&&c.y1==d.y1&&c.hb==d.hb&&c.kb==d.kb&&c.sv===d.sv)c=a.fe,d=b.fe,c=c===d?!0:null==c||null==d?!1:c.yx==d.yx&&c.qk==d.qk&&c.Ge==d.Ge}return c};var an,bn="Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),dfa=["Sunday","Monday","Tuesday",Rf,Pf,"Friday",If];
an={ERAS:["BC","AD"],ERANAMES:["Before Christ","Anno Domini"],NARROWMONTHS:["J",nf,sf,df,sf,"J","J",df,Cf,zf,xf,"D"],STANDALONENARROWMONTHS:["J",nf,sf,df,sf,"J","J",df,Cf,zf,xf,"D"],MONTHS:["January",of,"March","April","May","June","July","August",Kf,"October",yf,lf],STANDALONEMONTHS:["January",of,"March","April","May","June","July","August",Kf,"October",yf,lf],SHORTMONTHS:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),STANDALONESHORTMONTHS:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
WEEKDAYS:["Sunday","Monday","Tuesday",Rf,Pf,"Friday",If],STANDALONEWEEKDAYS:["Sunday","Monday","Tuesday",Rf,Pf,"Friday",If],SHORTWEEKDAYS:"Sun Mon Tue Wed Thu Fri Sat".split(" "),STANDALONESHORTWEEKDAYS:"Sun Mon Tue Wed Thu Fri Sat".split(" "),NARROWWEEKDAYS:[Cf,sf,Lf,Qf,Lf,nf,Cf],STANDALONENARROWWEEKDAYS:[Cf,sf,Lf,Qf,Lf,nf,Cf],SHORTQUARTERS:["Q1","Q2","Q3","Q4"],QUARTERS:["1st quarter","2nd quarter","3rd quarter","4th quarter"],AMPMS:["AM","PM"],DATEFORMATS:["EEEE, MMMM d, y","MMMM d, y","MMM d, y",
"M/d/yy"],TIMEFORMATS:["h:mm:ss a zzzz","h:mm:ss a z",Fg,Eg],DATETIMEFORMATS:["{1} 'at' {0}","{1} 'at' {0}","{1}, {0}","{1}, {0}"],FIRSTDAYOFWEEK:6,WEEKENDRANGE:[5,6],FIRSTWEEKCUTOFFDAY:5};function cn(a,b){switch(b){case 1:return 0!=a%4||0==a%100&&0!=a%400?28:29;case 5:case 8:case 10:case 3:return 30}return 31}function efa(a,b){var c=b||new Date(hi());return a[Ec]()==c[Ec]()}function dn(a,b,c){di(a)?(this.qb=ffa(a,b||0,c||1),en(this,c||1)):ai(a)?(this.qb=ffa(a[Ec](),a[Dd](),a[Db]()),en(this,a[Db]())):(this.qb=new Date(hi()),this.qb.setHours(0),this.qb.setMinutes(0),this.qb.setSeconds(0),this.qb.setMilliseconds(0))}
function ffa(a,b,c){b=new Date(a,b,c);0<=a&&100>a&&b[rd](b[Ec]()-1900);return b}T=dn[K];T.Kca=an.FIRSTDAYOFWEEK;T.Lca=an.FIRSTWEEKCUTOFFDAY;T.o=function(){var a=new dn(this.qb);a.Kca=this.Kca;a.Lca=this.Lca;return a};T.getFullYear=function(){return this.qb[Ec]()};T.getYear=function(){return this[Ec]()};T.getMonth=function(){return this.qb[Dd]()};T.getDate=function(){return this.qb[Db]()};Ba(T,function(){return this.qb[bc]()});T.getDay=function(){return this.qb[lc]()};T.getUTCFullYear=function(){return this.qb[Jb]()};
T.getUTCMonth=function(){return this.qb[zc]()};T.getUTCDate=function(){return this.qb[Jd]()};T.getUTCHours=function(){return this.qb[ee]()};T.getUTCMinutes=function(){return this.qb[de]()};T.getTimezoneOffset=function(){return this.qb[le]()};T.set=function(a){this.qb=new Date(a[Ec](),a[Dd](),a[Db]())};T.setFullYear=function(a){this.qb[rd](a)};T.setMonth=function(a){this.qb[pd](a)};T.setDate=function(a){this.qb[Bd](a)};T.setTime=function(a){this.qb[Jc](a)};T.setUTCFullYear=function(a){this.qb.setUTCFullYear(a)};
T.setUTCMonth=function(a){this.qb[Ud](a)};T.setUTCDate=function(a){this.qb.setUTCDate(a)};T.add=function(a){if(a.years||a.months){var b=this[Dd]()+a.months+12*a.years,c=this[Ac]()+h[t](b/12),b=b%12;0>b&&(b+=12);var d=h.min(cn(c,b),this[Db]());this[Bd](1);this[rd](c);this[pd](b);this[Bd](d)}a.days&&(a=new Date((new Date(this[Ac](),this[Dd](),this[Db](),12))[bc]()+864E5*a.days),this[Bd](1),this[rd](a[Ec]()),this[pd](a[Dd]()),this[Bd](a[Db]()),en(this,a[Db]()))};
T.kta=function(){return[this[Ec](),ui(this[Dd]()+1,2),ui(this[Db](),2)][ie](O)+O};Za(T,function(a){return!(!a||this[Ac]()!=a[Ac]()||this[Dd]()!=a[Dd]()||this[Db]()!=a[Db]())});Da(T,function(){return this.kta()});function en(a,b){a[Db]()!=b&&a.qb.setUTCHours(a.qb[ee]()+(a[Db]()<b?1:-1))}T.valueOf=function(){return this.qb[ad]()};function fn(a,b){return a[bc]()-b[bc]()};function gn(a,b){if(null==a&&null==b)return a===b;if(a===b)return!0;var c=Vh(a),d=Vh(b);if(c!=d)return!1;var d=$h(a),e=$h(b);if(d!=e)return!1;switch(c){case $g:if(d&&e)return 0==fn(a,b);for(var f in a)if(a[vc](f)&&(!b[vc](f)||!gn(a[f],b[f])))return!1;for(var g in b)if(b[vc](g)&&!a[vc](g))return!1;return!0;case dg:if(a[J]!=b[J])return!1;for(c=0;c<a[J];++c)if(!gn(a[c],b[c]))return!1;return!0;case Bg:return!0;case rh:case Yg:case jg:return!1;default:throw m("Error while comparing "+a+aaa+b+": unexpected type of obj1 "+
c);}}function hn(a){if($h(a)){var b=new Date;b[Jc](a[ad]());return b}var c=Vh(a);if(c==$g||c==dg){if(a.o)return a.o();c=c==dg?[]:{};for(b in a)c[b]=hn(a[b]);return c}return a};function jn(a){this.Vj=a||[{}]}function kn(a,b){Ui(a.Vj,b,1)}function gfa(a,b){for(var c in b)ai(b[c])&&a[c]?gfa(a[c],b[c]):a[c]=b[c]}function hfa(a,b){Dj(b,function(b,d){ai(b)&&!Yh(b)?(a[d]=a[d]||{},hfa(a[d],b)):null!=b&&(a[d]=b)})}function ln(a){var b={};Ei(a.Vj,function(a){hfa(b,a)});return b}function mn(a,b,c){t:{b=b[pc](Me);a=a||Ph;for(var d=0;d<b[J];d++){var e=b[d];if(null!=a[e])a=a[e];else{b=null;break t}}b=a}return null!=b&&ei(c)?c(b):b}
jn[K].R=function(a,b,c){for(var d=null,e=0;e<this.Vj[J];e++){t:{var d=this.Vj[e],f=a,g=c;if(bi(f))d=mn(d,f,g);else{for(var k=0;k<f[J];++k){var l=mn(d,f[k],g);if(null!=l){d=l;break t}}d=null}}if(null!=d)return d}d=b;return Qh(d)?d:null};function nn(a,b,c,d){c=null!=c?Pj(c):{};for(var e=a.Vj[J]-1;0<=e;e--){var f=c,g=a.Vj[e],k=b,l=d;bi(k)&&(k=[k]);for(var n=k[J]-1;0<=n;--n){var q=mn(g,k[n],l)||{};Sj(f,q)}}return c}
function on(a){if(null==a)return null;if(typeof a==jg)return a;a=String(a);return a==Te||a[ke]()==zh?!0:a==Oe||a[ke]()==wg?!1:null}function pn(a,b,c){a=a.R(b,null,on);if(null!=a)return a;Qh(c)||(c=!1);return c}function qn(a){if(null==a)return null;if(typeof a==Yg)return a;a=yi(String(a));return ga(a)?null:a}function rn(a){return null!=a?Yh(a)?Gi(a,qn):null:null}function ifa(a){if(null==a)return null;if(di(a))return a;a=ia(a);return ga(a)?null:a}
function sn(a,b,c){a=tn(a,b);if(null!=a)return a;Qh(c)||(c=0);return c}function jfa(a,b,c){a=a.R(b,null,ifa);if(null!=a)return a;Qh(c)||(c=0);return c}function tn(a,b){return a.R(b,null,qn)}function un(a){a=qn(a);return null!=a&&0<=a?a:null}function vn(a,b,c){a=a.R(b,null,un);if(null!=a)return a;Qh(c)||(c=0);return c}function wn(a){a=un(a);return null!=a?nj(a,0,1):null}function xn(a,b,c){a=a.R(b,null,wn);if(null!=a)return a;Qh(c)||(c=0);return c}function yn(a){return null!=a?String(a):null}
function zn(a,b,c){Qh(c)||(c=O);return a.R(b,c,yn)}function An(a,b){return a.R(b,null,yn)}function Bn(a,b){var c=yn(a);if(!c)return null;if(Ri(b||[],c))return c;try{return Dm(c)}catch(d){return null}}function Cn(a,b,c){return a.R(b,c,Bn)}function Dn(a,b,c,d){return a.R(b,d,function(a){return Bn(a,c)})}function En(a,b){return a.R(b,null,Bn)}function kfa(a){return null!=a?Yh(a)?Gi(a,String):null:null}function Fn(a,b){var c=yn(b);return Jj(a,c)?c:null}
function Gn(a,b,c,d){return a.R(b,d,W(Fn,null,c))}function Hn(a,b,c){return a.R(b,null,W(Fn,null,c))}function In(a,b,c){Qh(c)||(c=null);return a.R(b,c)}
function Jn(a,b,c){c=c?c.sm():null;a=nn(a,b,c,function(a){ai(a)||(a={fill:a});var b={},c=Bn(a[fc]);null!=c&&Ca(b,c);c=wn(a.fillOpacity);null!=c&&(b.ae=c);c=Bn(a[Yb]);null!=c&&za(b,c);c=un(a.strokeWidth);null!=c&&(b.qa=c);c=wn(a.strokeOpacity);null!=c&&(b.Cg=c);c=rn(a.strokeDashStyle);null!=c&&Yh(c)&&(b.cO=c);c=qn(a.rx);null!=c&&(b.ji=c);c=qn(a.ry);null!=c&&(b.ki=c);(a=a.gradient)&&null!=a.color1&&null!=a.color2&&null!=a.x1&&null!=a.y1&&null!=a.x2&&null!=a.y2&&(c={},c.lg=Bn(a.color1),c.Tf=Bn(a.color2),
c.Wy=wn(a.opacity1),c.Xy=wn(a.opacity2),c.x1=a.x1,c.y1=a.y1,c.hb=a.x2,c.kb=a.y2,c.sv=on(a.useObjectBoundingBoxUnits),b.gh=c);return b});a=new Rm(a);Wm(a)||(a.pe(Ym.gb()),a.dh(Ym.Oe));Vm(a)||(a.dd(Ym.Qd),Sm(a,Ym.Ai));return a}
function Kn(a,b){var c={},d=Bn(a[E],b);null!=d&&Xa(c,d);d=wn(a[Kd]);null!=d&&mb(c,d);d=Bn(a.auraColor,b);null!=d&&(c.Tb=d);if(d=yn(a.fontName))c.Va=d;(d=un(a[uc]))&&Ja(c,d);d=on(a[Ed]);null!=d&&ib(c,d);d=on(a.italic);null!=d&&(c.Ic=d);d=on(a.underline);null!=d&&(c.De=d);return c}function Ln(a,b,c){return nn(a,b,c,function(a){return Kn(a)})}function lfa(a,b,c,d){return nn(a,b,d,function(a){return Kn(a,c)})}
function mfa(a,b){var c=null,d=qn(b);if(null!=d)c=d;else if(d=yn(b),null!=d&&mda(d)){var c=d[J]-1,e=d;0<=c&&c<d[J]&&(e=d[ec](0,c)+d[ec](c+1,d[J]-c-1));c=a*yi(e)/100}null!=c&&(c=nj(c,0,a));return c}function nfa(a,b){var c,d=Mn(a,Kba,b);if(null!=d)return d;Qh(c)||(c=0);return c}function Mn(a,b,c){return a.R(b,null,W(mfa,null,c))}var ofa={Hva:"multiple",gwa:oh},Nn={NONE:R,Ura:zg,asa:mh,Vx:kg},pfa={NONE:R,Ura:zg,asa:mh,Vx:kg},qfa={xS:Jg,yS:Eh,Vx:kg};function rfa(){this.Um=!1;this.p2=[]}Uh(rfa);function sfa(a,b,c){var d=c.callback;c.callback=function(){var b=d[Mc](this,arguments);0<a.p2[J]?(a.p2[rb]()(),a.Um=!0):a.Um=!1;return b};b=W(google[fd],Ph.google,ada,b,c);if(a.Um)a.p2[C](b);else a.Um=!0,b()};function On(a,b,c){return b.R(Ih,null,un)||Wl(a)[r]||c||400}function Pn(a,b,c){return b.R(Hg,null,un)||Wl(a)[A]||c||200}function Qn(a,b,c,d){return b&&(b=b[r],bi(b)&&oi(b)&&(b=la(b,10)),typeof b==Yg&&30<=b&&(!d||b<=d))||a&&(b=a[Gd],30<=b&&(!d||b<=d))?b:c||400}function Rn(a,b,c,d,e){return b&&(b=b[A],bi(b)&&oi(b)&&(b=la(b,10)),typeof b==Yg&&b>=(e||30)&&(!d||b<=d))||a&&(b=a[Wd],b>=(e||30)&&(!d||b<=d))?b:c||200}function tfa(a){var b=ufa,c=a&&a.colors;c&&0!=c[J]||(c=(a=a&&a[E])?[a]:b);return c}
function Wn(){var a=Sh(nca);if(null!=a)return a;a=Sh(kca);null!=a||(a=qaa);var b=Sh(pca);null!=b||(b=vaa);return a+raa+b}function vfa(){if(0==fa[cc](Gg)[J]){var a=fa[cc](Mg)[0],b=fa[cc](hg)[0],c=fa[Qb](Gg);a[Eb](c,b)}return fa[cc](Gg)[0]}function Xn(a){a=Wn()+a;for(var b=fa[cc](aba),c=0;c<b[J];c++)if(b[c]&&b[c][Sd](Kg)&&b[c][Sd](Kg)===a)return;b=fa[Qb](Rg);b.href=a;b.rel=Sca;ab(b,Vca);vfa()[p](b)}var Yn=[];
function wfa(a){function b(){if(xfa()){var a=Yn;Yn=[];Y(a,function(a){a()})}else throw m("Error: cannot load Maps API.");}xfa()?a():(Yn[C](a),1==Yn[J]&&(a=Nca,yfa()&&(a+=gaa),google[fd](vca,Ve,{callback:b,other_params:a})))}function yfa(){var a=Ph[tc][Ic];if(!mi(a)){if((cm(a)[1]||null)!=Ng)return!1;a=em(a);if(!mi(a)){var b=/^ajax\.googleapis\.com$/[bd](a);return/\.google\.com$/[bd](a)||b}}return!1}function xfa(){return!!Sh(lca)}
function Zn(a){var b=null,c=Ph.google;(c=c&&c[Md]&&c[Md].Locale)&&c.packages&&c.packages[a]&&(b=c.locale);return b}function $n(a,b){var c=Vh(a);b=(31*b+xi(c))%67108864;switch(c){case $g:if(a[rc]==Date)b=(31*b+xi(og))%67108864,b=$n(a[bc](),b);else{c=Ij(a);cj(c);var c=Tj(c),d;for(d in c)b=$n(a[d],$n(d,b))}break;case dg:for(d=0;d<a[J];d++)b=$n(a[d],$n(String(d),b));break;default:b=(31*b+xi(String(a)))%67108864}return b}function ao(a){if(!Sk(a))throw m(hf);return a}
function bo(a){var b=Sh(mca+a);ei(b)||(b=Sh(a),ei(b)||(b=null));return b};function co(a){this.b=a||{};Xn(taa)}ua(co[K],function(a,b){if(a.D(b)==Yg)for(var c=this.b.base||0,d=0;d<a.M();d++){var e=a[I](d,b),f=null,f=e<c?hca:e>c?jca:ica;a[Dc](d,b,Wba,f)}});function eo(a){a=String(a);if(/^\s*$/[bd](a)?0:/^[\],:{}\s\u2028\u2029]*$/[bd](a[vb](/\\["\\\/bfnrtu]/g,Gaa)[vb](/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,$f)[vb](/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,O)))try{return eval(Fe+a+Ge)}catch(b){}throw m("Invalid JSON string: "+a);}function fo(a){return eval(Fe+a+Ge)}function Tm(a){return(new zfa(void 0)).Hn(a)}function zfa(a){this.GS=a}zfa[K].Hn=function(a){var b=[];go(this,a,b);return b[ie](O)};
function go(a,b,c){switch(typeof b){case rh:Afa(b,c);break;case Yg:c[C](na(b)&&!ga(b)?b:Xg);break;case jg:c[C](b);break;case "undefined":c[C](Xg);break;case $g:if(null==b){c[C](Xg);break}if(Yh(b)){var d=b[J];c[C](xba);for(var e=O,f=0;f<d;f++)c[C](e),e=b[f],go(a,a.GS?a.GS[L](b,String(f),e):e,c),e=Je;c[C]($f);break}c[C](Lh);d=O;for(f in b)da[K][vc][L](b,f)&&(e=b[f],typeof e!=Bg&&(c[C](d),Afa(f,c),c[C](Xe),go(a,a.GS?a.GS[L](b,f,e):e,c),d=Je));c[C](Mh);break;case Bg:break;default:throw m("Unknown type: "+
typeof b);}}var ho={'"':'\\"',"\\":Yf,"/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Bfa=/\uffff/[bd]("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;function Afa(a,b){b[C](oe,a[vb](Bfa,function(a){if(a in ho)return ho[a];var b=a[Xd](0),e=Dba;16>b?e+=Se:256>b?e+=Re:4096>b&&(e+=Oe);return ho[a]=e+b[hc](16)}),oe)};function io(a){return Tm(jo(a,ko))}function lo(a){eo(a);return Cfa(a)}function Cfa(a){a=mo(a);return eval(Fe+a+Ge)}function jo(a,b){a=b(a);var c=Vh(a);if(c==$g||c==dg){var c=c==dg?[]:{},d;for(d in a)if(a[vc](d)){var e=jo(a[d],b);Qh(e)&&(c[d]=e)}}else c=a;return c}function mo(a){return a[vb](/"(Date\([\d,\s]*\))"/g,function(a,c){return Bca+c})}
function ko(a){$h(a)&&(a=0!==a[Ld]()?[a[Ec](),a[Dd](),a[Db](),a[$b](),a[Qc](),a[Id](),a[Ld]()]:0!==a[Id]()||0!==a[Qc]()||0!==a[$b]()?[a[Ec](),a[Dd](),a[Db](),a[$b](),a[Qc](),a[Id]()]:[a[Ec](),a[Dd](),a[Db]()],a=Naa+a[ie](Ke)+Ge);return a};var Dfa={Cva:tf,awa:kba,Dva:cba,ava:Uaa,Nua:jf,Hwa:uba,Fva:vf,Xva:Bf,Lwa:Sf};function no(a){switch(a){case tf:return 1;case kba:return 1E3;case cba:return 6E4;case Uaa:return 36E5;case jf:return 864E5;case uba:return 6048E5;case vf:return 2629746E3;case Bf:return 7889238E3;case Sf:return 31556952E3}return 0};function oo(){}function po(a){if(typeof a==Yg){var b=new oo;b.qda=a;var c;c=a;if(0==c)c=Paa;else{var d=[Paa,0>c?Le:Ie];c=h.abs(c);d[C](h[t](c/60)%100);c%=60;0!=c&&d[C](Xe,ui(c,2));c=d[ie](O)}b.rda=c;0==a?a=rba:(c=[rba,0>a?Ie:Le],a=h.abs(a),c[C](h[t](a/60)%100),a%=60,0!=a&&c[C](Xe,a),a=c[ie](O));b.k2=[a,a];b.vC=[];return b}b=new oo;b.rda=a.id;b.qda=-a.std_offset;b.k2=a.names;b.vC=a.transitions;return b}T=oo[K];
T.getDaylightAdjustment=function(a){a=Date.UTC(a[Jb](),a[zc](),a[Jd](),a[ee](),a[de]())/36E5;for(var b=0;b<this.vC[J]&&a>=this.vC[b];)b+=2;return 0==b?0:this.vC[b-1]};T.getGMTString=function(a){a=this.getOffset(a);var b=[Saa];b[C](0>=a?Ie:Le);a=h.abs(a);b[C](ui(h[t](a/60)%100,2),Xe,ui(a%60,2));return b[ie](O)};T.getLongName=function(a){return this.k2[this.isDaylightTime(a)?3:1]};T.getOffset=function(a){return this.qda-this.getDaylightAdjustment(a)};
T.getRFCTimeZoneString=function(a){a=-this.getOffset(a);var b=[0>a?Le:Ie];a=h.abs(a);b[C](ui(h[t](a/60)%100,2),ui(a%60,2));return b[ie](O)};T.getShortName=function(a){return this.k2[this.isDaylightTime(a)?2:0]};T.getTimeZoneId=function(){return this.rda};T.isDaylightTime=function(a){return 0<this.getDaylightAdjustment(a)};function qo(a,b){this.qS=[];this.df=b||an;typeof a==Yg?this.fR(a):this.ls(a)}var Efa=[/^\'(?:[^\']|\'\')*\'/,/^(?:G+|y+|M+|k+|S+|E+|a+|h+|K+|H+|c+|L+|Q+|d+|m+|s+|v+|w+|z+|Z+)/,/^[^\'GyMkSEahKHcLQdmsvwzZ]+/];qo[K].ls=function(a){for(;a;)for(var b=0;b<Efa[J];++b){var c=a[Ib](Efa[b]);if(c){c=c[0];a=a[ae](c[J]);0==b&&(c==haa?c=Ee:(c=c[ae](1,c[J]-1),c=c[vb](/\'\'/,Ee)));this.qS[C]({text:c,type:b});break}}};
ua(qo[K],function(a,b){if(!a)throw m("The date to format must be non-null.");var c=b?6E4*(a[le]()-b.getOffset(a)):0,d=c?new Date(a[bc]()+c):a,e=d;b&&d[le]()!=a[le]()&&(c+=0<c?-864E5:864E5,e=new Date(a[bc]()+c));for(var c=[],f=0;f<this.qS[J];++f){var g=this.qS[f][cd];1==this.qS[f][H]?c[C](Ffa(this,g,a,d,e,b)):c[C](g)}return c[ie](O)});
qo[K].fR=function(a){var b;if(4>a)b=this.df.DATEFORMATS[a];else if(8>a)b=this.df.TIMEFORMATS[a-4];else if(12>a)b=this.df.DATETIMEFORMATS[a-8],b=b[vb](cda,this.df.DATEFORMATS[a-8]),b=b[vb](bda,this.df.TIMEFORMATS[a-8]);else{this.fR(10);return}this.ls(b)};function ro(a,b){var c;c=String(b);var d=a.df||an;if(void 0!==d.Fqa){for(var e=[],f=0;f<c[J];f++){var g=c[Xd](f);e[C](48<=g&&57>=g?String[qd](d.Fqa+g-48):c[Bb](f))}c=e[ie](O)}return c}
function so(a){if(!(a[$b]&&a[Id]&&a[Qc]))throw m("The date to format has no time (probably a goog.date.Date). Use Date or goog.date.DateTime, or use a pattern without time fields.");}
function Ffa(a,b,c,d,e,f){var g=b[J];switch(b[Bb](0)){case Raa:return c=0<d[Ec]()?1:0,4<=g?a.df.ERANAMES[c]:a.df.ERAS[c];case Jh:return c=d[Ec](),0>c&&(c=-c),2==g&&(c%=100),ro(a,ui(c,g));case sf:t:switch(c=d[Dd](),g){case 5:a=a.df.NARROWMONTHS[c];break t;case 4:a=a.df.MONTHS[c];break t;case 3:a=a.df.SHORTMONTHS[c];break t;default:a=ro(a,ui(c+1,g))}return a;case Pg:return so(e),ro(a,ui(e[$b]()||24,g));case Cf:return c=e[bc]()%1E3/1E3,ro(a,c[wb](h.min(3,g))[ec](2)+(3<g?ui(0,g-3):O));case mf:return c=
d[lc](),4<=g?a.df.WEEKDAYS[c]:a.df.SHORTWEEKDAYS[c];case bg:return so(e),g=e[$b](),a.df.AMPMS[12<=g&&24>g?1:0];case Dg:return so(e),ro(a,ui(e[$b]()%12||12,g));case Zaa:return so(e),ro(a,ui(e[$b]()%12,g));case Taa:return so(e),ro(a,ui(e[$b](),g));case lg:t:switch(c=d[lc](),g){case 5:a=a.df.STANDALONENARROWWEEKDAYS[c];break t;case 4:a=a.df.STANDALONEWEEKDAYS[c];break t;case 3:a=a.df.STANDALONESHORTWEEKDAYS[c];break t;default:a=ro(a,ui(c,1))}return a;case rf:t:switch(c=d[Dd](),g){case 5:a=a.df.STANDALONENARROWMONTHS[c];
break t;case 4:a=a.df.STANDALONEMONTHS[c];break t;case 3:a=a.df.STANDALONESHORTMONTHS[c];break t;default:a=ro(a,ui(c+1,g))}return a;case Af:return c=h[t](d[Dd]()/3),4>g?a.df.SHORTQUARTERS[c]:a.df.QUARTERS[c];case ng:return ro(a,ui(d[Db](),g));case Tg:return so(e),ro(a,ui(e[Qc](),g));case kh:return so(e),ro(a,ui(e[Id](),g));case Ch:return a=f||po(c[le]()),a.getTimeZoneId();case Gh:return c=new Date(e[Ec](),e[Dd](),e[Db]()),b=a.df.FIRSTDAYOFWEEK||0,c=c[ad]()+864E5*(((a.df.FIRSTWEEKCUTOFFDAY||3)-b+7)%
7-((c[lc]()+6)%7-b+7)%7),c=h[t](h[D]((c-(new Date((new Date(c))[Ec](),0,1))[ad]())/864E5)/7)+1,ro(a,ui(c,g));case Kh:return a=f||po(c[le]()),4>g?a.getShortName(c):a.getLongName(c);case Vf:return b=f||po(c[le]()),4>g?b.getRFCTimeZoneString(c):ro(a,b.getGMTString(c));default:return O}};var Gfa={YEAR_FULL:Jh,YEAR_FULL_WITH_ERA:"y G",YEAR_MONTH_ABBR:"MMM y",YEAR_MONTH_FULL:"MMMM y",MONTH_DAY_ABBR:uf,MONTH_DAY_FULL:"MMMM dd",MONTH_DAY_SHORT:"M/d",MONTH_DAY_MEDIUM:"MMMM d",MONTH_DAY_YEAR_MEDIUM:"MMM d, y",WEEKDAY_MONTH_DAY_MEDIUM:"EEE, MMM d",WEEKDAY_MONTH_DAY_YEAR_MEDIUM:"EEE, MMM d, y",DAY_ABBR:ng},Hfa=Gfa,Hfa=Gfa;var Ifa={oqa:{1E3:{other:"0K"},1E4:{other:"00K"},1E5:{other:"000K"},1E6:{other:"0M"},1E7:{other:"00M"},1E8:{other:"000M"},1E9:{other:"0B"},1E10:{other:"00B"},1E11:{other:"000B"},1E12:{other:"0T"},1E13:{other:"00T"},1E14:{other:"000T"}},nqa:{1E3:{other:"0 thousand"},1E4:{other:"00 thousand"},1E5:{other:"000 thousand"},1E6:{other:"0 million"},1E7:{other:"00 million"},1E8:{other:"000 million"},1E9:{other:"0 billion"},1E10:{other:"00 billion"},1E11:{other:"000 billion"},1E12:{other:"0 trillion"},1E13:{other:"00 trillion"},
1E14:{other:"000 trillion"}}},to=Ifa,to=Ifa;function Jfa(a){var b=uo.Qra,c=[Oe];a=vo[a][0]&7;if(0<a){c[C](Me);for(var d=0;d<a;d++)c[C](Oe)}return b[vb](/0.00/g,c[ie](O))}
var vo={AED:[2,"dh","\u062f.\u0625.","DH"],ALL:[0,"Lek","Lek"],AUD:[2,ve,"AU$"],BDT:[2,"\u09f3","Tk"],BGN:[2,"lev","lev"],BRL:[2,"R$","R$"],CAD:[2,ve,"C$"],CDF:[2,"FrCD","CDF"],CHF:[2,"CHF","CHF"],CLP:[0,ve,"CL$"],CNY:[2,"\u00a5","RMB\u00a5"],COP:[0,ve,"COL$"],CRC:[0,"\u20a1","CR\u20a1"],CZK:[50,"K\u010d","K\u010d"],DKK:[18,"kr","kr"],DOP:[2,ve,"RD$"],EGP:[2,"\u00a3","LE"],ETB:[2,"Birr","Birr"],EUR:[2,"\u20ac","\u20ac"],GBP:[2,"\u00a3","GB\u00a3"],HKD:[2,ve,"HK$"],HRK:[2,"kn","kn"],HUF:[0,"Ft","Ft"],
IDR:[0,"Rp","Rp"],ILS:[2,"\u20aa","IL\u20aa"],INR:[2,"\u20b9","Rs"],IRR:[0,"Rial","IRR"],ISK:[0,"kr","kr"],JMD:[2,ve,"JA$"],JPY:[0,"\u00a5","JP\u00a5"],KRW:[0,"\u20a9","KR\u20a9"],LKR:[2,"Rs","SLRs"],LTL:[2,"Lt","Lt"],LVL:[2,"Ls","Ls"],MNT:[0,"\u20ae","MN\u20ae"],MXN:[2,ve,"Mex$"],MYR:[2,"RM","RM"],NOK:[50,"kr","NOkr"],PAB:[2,"B/.","B/."],PEN:[2,"S/.","S/."],PHP:[2,"\u20b1","Php"],PKR:[0,"Rs","PKRs."],PLN:[50,"z\u0142","z\u0142"],RON:[2,"RON","RON"],RSD:[0,"din","RSD"],RUB:[50,"\u0440\u0443\u0431.",
"\u0440\u0443\u0431."],SAR:[2,"Rial","Rial"],SEK:[2,"kr","kr"],SGD:[2,ve,"S$"],THB:[2,"\u0e3f","THB"],TRY:[2,Nf,"YTL"],TWD:[2,"NT$","NT$"],TZS:[0,"TSh","TSh"],UAH:[2,"\u20b4","UAH"],USD:[2,ve,"US$"],UYU:[2,ve,"$U"],VND:[0,"\u20ab","VN\u20ab"],YER:[0,"Rial","Rial"],ZAR:[2,"R","ZAR"]};var Kfa={DECIMAL_SEP:Me,GROUP_SEP:Je,o1:we,z1:Oe,Lqa:Ie,Kqa:Le,nca:mf,jca:fda,P0:"\u221e",Noa:"NaN",DECIMAL_PATTERN:"#,##0.###",Gqa:"#E0",Z1:"#,##0%",Qra:"\u00a4#,##0.00",Ona:"USD"},uo=Kfa,uo=Kfa;function wo(a,b,c){this.jJ=b||uo.Ona;this.Dna=c||0;this.NQ=40;this.po=1;this.fy=0;this.Yx=3;this.cR=this.hs=0;this.Xaa=this.xaa=!1;this.QI=this.Ux=O;this.Fu=Le;this.rC=O;this.Vi=1;this.b0=3;this.OQ=this.waa=!1;this.$I=0;this.Aaa=null;typeof a==Yg?this.fR(a):this.ls(a)}var xo=!1;T=wo[K];T.setMinimumFractionDigits=function(a){if(0<this.fy&&0<a)throw m(Maa);this.hs=a;return this};T.setMaximumFractionDigits=function(a){this.Yx=a;return this};
T.setSignificantDigits=function(a){if(0<this.hs&&0<=a)throw m(Maa);this.fy=a;return this};
T.ls=function(a){this.fe=a[vb](/ /g,Nh);var b=[0];this.Ux=yo(this,a,b);for(var c=b[0],d=-1,e=0,f=0,g=0,k=-1,l=a[J],n=!0;b[0]<l&&n;b[0]++)switch(a[Bb](b[0])){case qe:0<f?g++:e++;0<=k&&0>d&&k++;break;case Oe:if(0<g)throw m('Unexpected "0" in pattern "'+a+oe);f++;0<=k&&0>d&&k++;break;case Je:k=0;break;case Me:if(0<=d)throw m('Multiple decimal separators in pattern "'+a+oe);d=e+f+g;break;case mf:if(this.OQ)throw m('Multiple exponential symbols in pattern "'+a+oe);this.OQ=!0;this.cR=0;b[0]+1<l&&a[Bb](b[0]+
1)==Ie&&(b[0]++,this.xaa=!0);for(;b[0]+1<l&&a[Bb](b[0]+1)==Oe;)b[0]++,this.cR++;if(1>e+f||1>this.cR)throw m('Malformed exponential pattern "'+a+oe);n=!1;break;default:b[0]--,n=!1}0==f&&0<e&&0<=d&&(f=d,0==f&&f++,g=e-f,e=f-1,f=1);if(0>d&&0<g||0<=d&&(d<e||d>e+f)||0==k)throw m('Malformed pattern "'+a+oe);g=e+f+g;this.Yx=0<=d?g-d:0;0<=d&&(this.hs=e+f-d,0>this.hs&&(this.hs=0));this.po=(0<=d?d:g)-e;this.OQ&&(this.NQ=e+this.po,0==this.Yx&&0==this.po&&(this.po=1));this.b0=h.max(0,k);this.waa=0==d||d==g;c=
b[0]-c;this.QI=yo(this,a,b);b[0]<a[J]&&a[Bb](b[0])==Ye?(b[0]++,this.Fu=yo(this,a,b),b[0]+=c,this.rC=yo(this,a,b)):(this.Fu=this.Ux+this.Fu,this.rC+=this.QI)};T.fR=function(a){switch(a){case 1:this.ls(uo.DECIMAL_PATTERN);break;case 2:this.ls(uo.Gqa);break;case 3:this.ls(uo.Z1);break;case 4:this.ls(Jfa(this.jJ));break;case 5:Lfa(this,1);break;case 6:Lfa(this,2);break;default:throw m("Unsupported pattern type.");}};
function Lfa(a,b){a.$I=b;a.ls(uo.DECIMAL_PATTERN);a.setMinimumFractionDigits(0);a.setMaximumFractionDigits(2);a.setSignificantDigits(2)}
gb(T,function(a,b){var c=b||[0];if(0!=this.$I)throw m("Parsing of compact numbers is unimplemented");var d=ja;a=a[vb](/ /g,Nh);var e=a[ld](this.Ux,c[0])==c[0],f=a[ld](this.Fu,c[0])==c[0];e&&f&&(this.Ux[J]>this.Fu[J]?f=!1:this.Ux[J]<this.Fu[J]&&(e=!1));e?c[0]+=this.Ux[J]:f&&(c[0]+=this.Fu[J]);if(a[ld](uo.P0,c[0])==c[0])c[0]+=uo.P0[J],d=ea;else{var d=a,g=!1,k=!1,l=!1,n=1,q=uo.DECIMAL_SEP,s=uo.GROUP_SEP,u=uo.nca;if(0!=this.$I)throw m("Parsing of compact style numbers is not implemented");for(var w=O;c[0]<
d[J];c[0]++){var z=d[Bb](c[0]),B=Mfa(z);if(0<=B&&9>=B)w+=B,l=!0;else if(z==q[Bb](0)){if(g||k)break;w+=Me;g=!0}else if(z==s[Bb](0)&&(Nh!=s[Bb](0)||c[0]+1<d[J]&&0<=Mfa(d[Bb](c[0]+1)))){if(g||k)break}else if(z==u[Bb](0)){if(k)break;w+=mf;k=!0}else if(z==Ie||z==Le)w+=z;else if(z==uo.o1[Bb](0)){if(1!=n)break;n=100;if(l){c[0]++;break}}else if(z==uo.jca[Bb](0)){if(1!=n)break;n=1E3;if(l){c[0]++;break}}else break}d=ma(w)/n}if(e){if(a[ld](this.QI,c[0])!=c[0])return ja;c[0]+=this.QI[J]}else if(f){if(a[ld](this.rC,
c[0])!=c[0])return ja;c[0]+=this.rC[J]}return f?-d:d});
ua(T,function(a){if(ga(a))return uo.Noa;var b=[],c;var d=null===this.Aaa?a:this.Aaa,e=a;0==this.$I?c=zo:(d=h.abs(d),e=h.abs(e),c=Nfa(this,1>=d?0:Ao(d)).S0,e/=h.pow(10,c),Bo(this,e),d/=h.pow(10,c),d=Bo(this,d),c=Nfa(this,c+Ao(d.cba)));a/=h.pow(10,c.S0);b[C](c.prefix);d=0>a||0==a&&0>1/a;b[C](d?this.Fu:this.Ux);if(na(a))if(a=a*(d?-1:1)*this.Vi,this.OQ)if(0==a)Co(this,a,this.po,b),Ofa(this,0,b);else{e=h.log(a)/h.log(10);e=h[t](e+2E-15);a/=h.pow(10,e);var f=this.po;if(1<this.NQ&&this.NQ>this.po){for(;0!=
e%this.NQ;)a*=10,e--;f=1}else 1>this.po?(e++,a/=10):(e-=this.po-1,a*=h.pow(10,this.po-1));Co(this,a,f,b);Ofa(this,e,b)}else Co(this,a,this.po,b);else b[C](uo.P0);b[C](d?this.rC:this.QI);b[C](c.zg);return b[ie](O)});function Bo(a,b){var c=h.pow(10,a.Yx),d=0>=a.fy?h[D](b*c):h[t](Pfa(b*c,a.fy,a.Yx)),e;na(d)?(e=h[t](d/c),c=h[t](d-e*c)):(e=b,c=0);return{cba:e,Ypa:c}}
function Co(a,b,c,d){if(a.hs>a.Yx)throw m("Min value must be less than max value");b=Bo(a,b);var e=h.pow(10,a.Yx),f=b.cba,g=b.Ypa,k=0==f?0:Ao(f)+1,l=0<a.hs||0<g||a.Xaa&&k<a.fy;b=a.hs;l&&(b=a.Xaa&&0<a.fy?a.fy-k:a.hs);for(var n=O,k=f;1E20<k;)n=Oe+n,k=h[D](k/10);var n=k+n,q=uo.DECIMAL_SEP,s=uo.GROUP_SEP,k=xo?48:uo.z1[Xd](0),u=n[J];if(0<f||0<c){for(f=u;f<c;f++)d[C](String[qd](k));for(f=0;f<u;f++)d[C](String[qd](k+1*n[Bb](f))),1<u-f&&0<a.b0&&1==(u-f)%a.b0&&d[C](s)}else l||d[C](String[qd](k));(a.waa||l)&&
d[C](q);a=O+(g+e);for(c=a[J];a[Bb](c-1)==Oe&&c>b+1;)c--;for(f=1;f<c;f++)d[C](String[qd](k+1*a[Bb](f)))}function Ofa(a,b,c){c[C](uo.nca);0>b?(b=-b,c[C](uo.Kqa)):a.xaa&&c[C](uo.Lqa);b=O+b;for(var d=xo?Oe:uo.z1,e=b[J];e<a.cR;e++)c[C](d);c[C](b)}function Mfa(a){a=a[Xd](0);if(48<=a&&58>a)return a-48;var b=uo.z1[Xd](0);return b<=a&&a<b+10?a-b:-1}
function yo(a,b,c){for(var d=O,e=!1,f=b[J];c[0]<f;c[0]++){var g=b[Bb](c[0]);if(g==Ee)c[0]+1<f&&b[Bb](c[0]+1)==Ee?(c[0]++,d+=Ee):e=!e;else if(e)d+=g;else switch(g){case qe:case Oe:case Je:case Me:case Ye:return d;case eda:if(c[0]+1<f&&b[Bb](c[0]+1)==eda)c[0]++,d+=a.jJ;else switch(a.Dna){case 0:d+=vo[a.jJ][1];break;case 2:var g=a.jJ,k=vo[g],d=d+(g==k[1]?g:g+ne+k[1]);break;case 1:d+=vo[a.jJ][2]}break;case we:if(1!=a.Vi)throw m(pba);a.Vi=100;d+=uo.o1;break;case fda:if(1!=a.Vi)throw m(pba);a.Vi=1E3;d+=
uo.jca;break;default:d+=g}}return d}var zo={prefix:O,zg:O,S0:0};function Nfa(a,b){var c=1==a.$I?to.oqa:to.nqa;if(3>b)return zo;b=h.min(14,b);c=c[h.pow(10,b)];if(!c)return zo;c=c.other;return c&&c!=Oe?(c=/([^0]*)(0+)(.*)/[sb](c))?{prefix:c[1],zg:c[3],S0:b-(c[2][J]-1)}:zo:zo}function Ao(a){for(var b=0;1<=(a/=10);)b++;return b}function Pfa(a,b,c){if(!a)return a;b=b-Ao(a)-1;if(b<-c)return c=h.pow(10,c),h[D](a/c)*c;c=h.pow(10,b);return h[D](a*c)/c};ua(qo[K],qo[K][Kb]);qo.Format={FULL_DATE:0,LONG_DATE:1,MEDIUM_DATE:2,SHORT_DATE:3,FULL_TIME:4,LONG_TIME:5,MEDIUM_TIME:6,SHORT_TIME:7,FULL_DATETIME:8,LONG_DATETIME:9,MEDIUM_DATETIME:10,SHORT_DATETIME:11};var Do=Hfa;ua(wo[K],wo[K][Kb]);wo.setEnforceAsciiDigits=function(a){xo=a};wo.isEnforceAsciiDigits=function(){return xo};var Eo=uo;oo.createTimeZone=po;function Fo(){}Fo[K].Ee=function(a){return this.$da(a)};function Go(a){this[Fc](a)}X(Go,Fo);Ma(Go[K],function(a){a=new jn([a||{},{formatType:nh,valueType:pg}]);this.fe=a.R(dh);this.le=null;this.Ena=Hn(a,fca,Qfa);this.wna=Hn(a,Yca,Rfa);this.Cna=pn(a,Xba,!1);this.bba=null;a=tn(a,Xca);null!=a&&(this.bba=oo.createTimeZone(60*-a))});var Ho=qo[vd],Qfa={Vua:Ag,qva:Sg,wva:Vg,SHORT:nh},Rfa={Sra:og,Tra:pg,uwa:vh};
function Sfa(a,b){switch(a){case og:switch(b){case Ag:return qo[vd].FULL_DATE;case Sg:return qo[vd].LONG_DATE;case Vg:return qo[vd].MEDIUM_DATE;case nh:return qo[vd].SHORT_DATE}case pg:switch(b){case Ag:return qo[vd].FULL_DATETIME;case Sg:return qo[vd].LONG_DATETIME;case Vg:return qo[vd].MEDIUM_DATETIME;case nh:return qo[vd].SHORT_DATETIME}case vh:switch(b){case Ag:return qo[vd].FULL_TIME;case Sg:return qo[vd].LONG_TIME;case Vg:return qo[vd].MEDIUM_TIME;case nh:return qo[vd].SHORT_TIME}default:return qo[vd].FULL_DATETIME}}
Go[K].Dk=function(a){switch(a){case Sf:a=Do.YEAR_FULL;break;case Bf:a=jba;break;case vf:a=Do.YEAR_MONTH_ABBR;break;case jf:a=qo[vd].SHORT_DATE;break;default:a=qo[vd].SHORT_DATETIME}this[Fc]({pattern:a,timeZone:0})};ua(Go[K],function(a,b){var c=Fn(Rfa,a.D(b));if(c==og||c==pg)for(var c=this.cN(c),d=a.M(),e=0;e<d;e++){var f=a[I](e,b),f=Tfa(this,c,f);a.uH(e,b,f)}});Go[K].$da=function(a){this.le||(this.le=this.cN(this.wna));return Tfa(this,this.le,a)};
Go[K].cN=function(a){var b=this.fe;null!=b||(b=Sfa(a,this.Ena));return new qo(b)};function Tfa(a,b,c){if(null===c)return O;var d=a.bba;null==d&&(d=oo.createTimeZone(c[le]()));c=new Date(c[bc]());a.Cna&&c.setMinutes(0);return b[Kb](c,d)};function Io(a){var b=new jn([a||{},{decimalSymbol:Ufa,groupingSymbol:Vfa,fractionDigits:2,negativeParens:!1,prefix:O,suffix:O,scaleFactor:1}]);this.oy=vn(b,gca);a&&di(a.fractionDigits)&&ga(a.fractionDigits)&&(this.oy=ja);this.Ipa=zn(b,bca);this.v1=zn(b,qca);this.uca=zn(b,Kca);this.vca=zn(b,th);this.p$=En(b,zca);this.tca=pn(b,Aca);this.fe=An(b,dh);this.QG=sn(b,Mca);if(0>=this.QG)throw m("Scale factor must be a positive number.");}X(Io,Fo);var Ufa=Eo.DECIMAL_SEP,Vfa=Eo.GROUP_SEP,Jo=Eo.DECIMAL_PATTERN;
ua(Io[K],function(a,b){if(a.D(b)==Yg)for(var c=0;c<a.M();c++){var d=a[I](c,b);if(null!=d){var e=this.Ee(d);a.uH(c,b,e);!mi(this.p$)&&0>d&&a[Dc](c,b,sh,Yba+this.p$+Ye)}}});
Io[K].$da=function(a){var b=null,b=a/this.QG;if(null===this.fe){if(ga(this.oy))return String(a);this.tca&&(b=h.abs(b));var c=b;0==this.oy&&(c=h[D](c));b=[];0>c&&(c=-c,b[C](Le));var d=h.pow(10,this.oy),e=h[D](c*d),c=String(h[t](e/d)),d=String(e%d);if(3<c[J]&&this.v1)for(e=c[J]%3,0<e&&(b[C](c[ae](0,e),this.v1),c=c[ae](e));3<c[J];)b[C](c[ae](0,3),this.v1),c=c[ae](3);b[C](c);0<this.oy&&(b[C](this.Ipa),d[J]<this.oy&&(d=uaa+d),b[C](d[ae](d[J]-this.oy)));b=b[ie](O);b=this.uca+b+this.vca;this.tca&&0>a&&(b=
Fe+b+Ge)}else a=(new wo(this.fe))[Kb](b),b=this.uca+a+this.vca;return b};function Wfa(a){return null==a?null:ei(a.Mx)?a:Yh(a)?Xfa(a):new Ko(a)}function Yfa(a){var b={};if(Vh(a)!=$g||$h(a))b.v=null!=a?a:null,b.f=null;else{b.v="undefined"==typeof a.v?null:a.v;var c=typeof a.f;if("undefined"==c||c==Xg)b.f=null;else if(c==rh)b.f=a.f;else throw m("Formatted value ('f'), if specified, must be a string.");c=typeof a.p;if(c==$g)b.p=a.p;else if(c!=Xg&&"undefined"!=c)throw m("Properties ('p'), if specified, must be an Object.");}return{v:b.v,f:b.f,p:b.p}}
function Zfa(a,b,c){if(typeof b==$g&&mg in b){if(cca in b&&typeof b.desc!=jg)throw m('Property "desc" in '+c+" must be boolean.");if($ba in b&&!ei(b.compare))throw m('Property "compare" in '+c+" must be a function.");}else throw m(c+' must be an object with a "column" property.');Lo(a,b.column)}
function $fa(a,b,c){function d(d,e){for(var f=0;f<c[J];f++){var g=c[f],k=g.column,l=b(d,k),B=b(e,k),k=g.compare?null===l?null===B?0:-1:null===B?1:g.compare(l,B):Mo(a.D(k),l,B);if(0!=k)return k*(g.desc?-1:1)}return 0}if(ei(c))d=c;else if(typeof c==Yg)Lo(a,c),c=[{column:c}];else if(typeof c==$g)if(Zh(c)){if(1>c[J])throw m("sortColumns is an empty array. Must have at least one element.");for(var e={},f=[],g=0;g<c[J];g++){var k,l=c[g];if(typeof c[g]==Yg)k=c[g],Lo(a,k),l={column:c[g]};else if(typeof c[g]==
$g)k=c[g].column,Zfa(a,c[g],Pca+g+$f);else throw m("sortColumns is an array, but not composed of only objects or numbers.");if(k in e)throw m("Column index "+k+" is duplicated in sortColumns.");e[k]=!0;f[C](l)}c=f}else Zfa(a,c,Oca),c=[c];return d}function No(a,b){var c=a.M();if(0<c){if(h[t](b)!==b||0>b||b>=c)throw m("Invalid row index "+b+". Should be in the range [0-"+(c-1)+"].");}else throw m("Table has no rows.");}
function Lo(a,b){var c=a.H();if(0<c){if(h[t](b)!==b||0>b||b>=c)throw m("Invalid column index "+b+". Should be an integer in the range [0-"+(c-1)+"].");}else throw m("Table has no columns.");}function Oo(a,b,c){a=a.D(b);if(!aga(c,a))throw m(qba+c+baa+a+" in column index "+b);}
function aga(a,b){if(null==a)return!0;var c=typeof a;switch(b){case Yg:if(c==Yg)return!0;break;case rh:if(c==rh)return!0;break;case jg:if(c==jg)return!0;break;case og:case pg:if($h(a))return!0;break;case wh:if(Zh(a)&&2<a[J]&&5>a[J]){for(var c=!0,d=0;d<a[J];d++){var e=a[d];if(typeof e!=Yg||e!=h[t](e)){c=!1;break}}if(0>a[0]||0>a[1]||59<a[1]||0>a[2]||59<a[2])c=!1;4==a[J]&&(0>a[3]||999<a[3])&&(c=!1);if(c)return!0}}return!1}
function Mo(a,b,c){if(null==b)return null==c?0:-1;if(null==c)return 1;switch(a){case wh:for(a=0;3>a;a++){if(b[a]<c[a])return-1;if(c[a]<b[a])return 1}b=4>b[J]?0:b[3];c=4>c[J]?0:c[3];return b<c?-1:c<b?1:0;default:return b<c?-1:c<b?1:0}}function bga(a,b){Lo(a,b);var c=a.D(b),d=null,e=null,f,g,k=a.M();for(f=0;f<k;f++)if(g=a[I](f,b),null!=g){e=d=g;break}if(null==d)return{min:null,max:null};for(f++;f<k;f++)g=a[I](f,b),null!=g&&(0>Mo(c,g,d)?d=g:0>Mo(c,e,g)&&(e=g));return{min:d,max:e}}
function cga(a,b){for(var c=$fa(a,function(b,c){return a[I](b,c)},b),d=[],e=a.M(),f=0;f<e;f++)d[C](f);dj(d,c);return d}function dga(a,b){Lo(a,b);var c=a.M();if(0==c)return[];for(var d=[],e=0;e<c;++e)d[C](a[I](e,b));var f=a.D(b);dj(d,function(a,b){return Mo(f,a,b)});var c=d[0],g=[];g[C](c);for(e=1;e<d[J];e++){var k=d[e];0!=Mo(f,k,c)&&g[C](k);c=k}return g}
function ega(a,b,c){if(ei(b))return b(a,c);for(var d=0;d<b[J];d++){var e=b[d],f=e.column,g=a[I](c,f),k=a.D(f);if(Dh in e){if(0!==Mo(k,g,e[id]))return!1}else if(null!=e.minValue||null!=e.maxValue)if(null==g||null!=e.minValue&&0>Mo(k,g,e.minValue)||null!=e.maxValue&&0<Mo(k,g,e.maxValue))return!1;if(ei(e[bd])&&!e[bd](g,c,f,a))return!1}return!0}
function fga(a,b){if(!ei(b)){if(!Zh(b)||0==b[J])throw m("columnFilters must be a non-empty array");for(var c={},d=0;d<b[J];d++){if(typeof b[d]!=$g||!(mg in b[d])){if(!(Dh in b[d]||Wg in b[d]||Ug in b[d]))throw m(Zba+d+'] must have properties "column" and "value", "minValue"or "maxValue"');if(Dh in b[d]&&(Wg in b[d]||Ug in b[d]))throw m(Zba+d+'] must specify either "value" or range properties ("minValue" and/or "maxValue"');}var e=b[d].column;if(e in c)throw m("Column index "+e+" is duplicate in columnFilters.");
Lo(a,e);Oo(a,e,b[d][id]);c[e]=!0}}c=[];d=a.M();for(e=0;e<d;e++)ega(a,b,e)&&c[C](e);return c}function Po(a,b){var c;b==wh?(c=[],c[C](a[0]),c[C]((10>a[1]?Oe:O)+a[1]),c[C]((10>a[2]?Oe:O)+a[2]),c=c[ie](Xe),3<a[J]&&0<a[3]&&(c+=Me+(10>a[3]?Re:100>a[3]?Oe:O)+a[3])):b==og?(c=new Go({formatType:Vg,valueType:og}),c=c.Ee(a)):b==pg?(c=new Go({formatType:Vg,valueType:pg}),c=c.Ee(a)):b==Yg?(c=new Io({fractionDigits:ja}),c=c.Ee(a)):c=null!=a?String(a):O;return c}
function gga(a,b){var c={};if(!Yh(a))throw m("Not an array");if(0<a[J]){var d=!b,e,f;if(d)e=Gi(a[0],function(a){if(bi(a))return{label:a};if(ai(a))return Pj(a);throw m("Unknown header type: "+a);});else{e=[];f=0;Yh(a[0])?f=a[0][J]:ai(a[0])&&lg in a[0]&&Yh(a[0].c)&&(f=a[0].c[J]);for(var g=0;g<f;g++)e[C]({type:void 0})}c.cols=e;c.rows=[];f=e[J];for(var k=ha(e[J]),d=d?$i(a,1):a,g=0;g<d[J];g++){var l=d[g];if(Yh(l))l={c:l};else if(!(ai(l)&&lg in l))throw m("Invalid row type for row "+g);if(l.c[J]!==e[J])throw m("Row "+
g+" has "+l.c[J]+" columns, but must have "+e[J]);l.c=Yi(l.c);c[Kc][C](l);for(var n=0;n<f;n++){var q=rh,q=l.c[n];ai(q)&&(Ch in q||vg in q)?q=q.v:l.c[n]={v:q};if(null==e[n][H]&&(null==k[n]||k[n]===og)&&null!=q){if(bi(q))q=rh;else if(di(q))q=Yg;else if(Yh(q))q=wh;else if(ci(q))q=jg;else if($h(q))q=new Date(q),q=0!==q[$b]()+q[Qc]()+q[Id]()+q[Ld]()?pg:og;else throw m("Unknown type of value in "+g+Je+n);k[n]=q}}}Y(c[Nb],function(a,b){null!=a[H]||ab(a,k[b]||rh)})}return c}
function Xfa(a,b){return new Ko(gga(a,b))}function hga(a,b,c,d){for(var e=null,f=a.M();(d?0<=b:b<f)&&null===e;)e=a[I](b,c),b+=d?-1:1;return e};var iga={Fwa:Pe,Gwa:Qe};function Ko(a,b){this.Tx=b===Pe?Pe:Qe;if(!ei(this.Mx))throw m('You called google.visualization.DataTable() without the "new" keyword');a?(bi(a)?a=lo(a):jga(a),this.uf=[],this.tf=[],this.vs=a.p||null,null!=a[Nb]&&Y(a[Nb],W(function(a){this.mg(a)},this)),null!=a[Kc]&&(this.tf=a[Kc])):(this.uf=[],this.tf=[],this.vs=null);this.Ad=[]}var kga={rua:jg,Kva:Yg,pwa:rh,Sra:og,wwa:wh,Tra:pg};
function jga(a){var b=a[Nb]||[];a=a[Kc]||[];for(var c=b[J],d=0;d<c;d++){var e=b[d][H];if(e==og||e==pg)for(var e=a[J],f=0;f<e;f++){var g=a[f].c[d];if(g){var k=g.v;if($h(k))return;bi(k)&&(g=io(g),g=lo(g),a[f].c[d]=g)}}}}T=Ko[K];T.uf=null;T.Tx=null;T.tf=null;T.vs=null;T.Ad=null;T.M=function(){return this.tf[J]};T.H=function(){return this.uf[J]};T.jf=function(a){Lo(this,a);return this.uf[a].id||O};xa(T,function(a){for(var b=this.uf,c=0;c<b[J];c++)if(b[c].id==a)return c;return-1});
T.cb=function(a){Lo(this,a);return this.uf[a][Rc]||O};T.ju=function(a){Lo(this,a);return this.uf[a][ub]};T.Ss=function(a){a=this.Li(a,ih);return a=bi(a)?a:O};T.D=function(a){Lo(this,a);return this.uf[a][H]};fb(T,function(a,b){No(this,a);Lo(this,b);var c=this.Pr(a,b),d=null;c&&(d=c.v,d=Qh(d)?d:null);return d});T.Pr=function(a,b){return this.tf[a].c[b]};
T.Aa=function(a,b){No(this,a);Lo(this,b);var c=this.Pr(a,b),d=O;if(c)if("undefined"!=typeof c.f&&null!=c.f)d=c.f;else{this.Ad[a]=this.Ad[a]||[];var e=this.Ad[a],c=e[b]||{};e[b]=c;Qh(c.Pe)?d=c.Pe:(e=this[I](a,b),null===e||(d=Po(e,this.D(b))),c.Pe=d)}return d};T.Ao=function(a,b,c){No(this,a);Lo(this,b);return(a=(a=this.Pr(a,b))&&a.p)&&c in a?a[c]:null};T.sm=function(a,b){No(this,a);Lo(this,b);var c=this.Pr(a,b);c||(c={v:null,f:null},this.tf[a].c[b]=c);c.p||(c.p={});return c.p};T.Mx=function(){return this.vs};
T.uR=function(a){var b=this.vs;return b&&a in b?b[a]:null};T.gta=function(a){this.vs=a};T.hta=function(a,b){this.vs||(this.vs={});this.vs[a]=b};T.wa=function(a,b,c){this.al(a,b,c,void 0,void 0)};T.uH=function(a,b,c){this.al(a,b,void 0,c,void 0)};T.kv=function(a,b,c){this.al(a,b,void 0,void 0,c)};T.setProperty=function(a,b,c,d){this.sm(a,b)[c]=d};
T.al=function(a,b,c,d,e){No(this,a);Lo(this,b);var f=this.Ad[a];f&&f[b]&&(f[b]={});f=this.Pr(a,b);f||(f={},this.tf[a].c[b]=f);"undefined"!=typeof c&&(this.D(b)==Yg&&bi(c)&&!ga(c)?f.v=ia(c):(Oo(this,b,c),f.v=c));"undefined"!=typeof d&&(f.f=d);Qh(e)&&(f.p=ai(e)?e:{})};T.fta=function(a,b){No(this,a);this.tf[a].p=b};T.s4=function(a,b,c){this.mJ(a)[b]=c};T.Yq=function(a,b){No(this,a);var c=this.tf[a];return(c=c&&c.p)&&b in c?c[b]:null};T.mJ=function(a){No(this,a);a=this.tf[a];a.p||(a.p={});return a.p};
T.Tsa=function(a,b){Lo(this,a);Qa(this.uf[a],b)};T.paa=function(a,b){Lo(this,a);this.uf[a].p=b};T.Sv=function(a,b,c){this.Sq(a)[b]=c};T.Li=function(a,b){Lo(this,a);var c=this.uf[a];return(c=c&&c.p)&&b in c?c[b]:null};T.Sq=function(a){Lo(this,a);a=this.uf[a];a.p||(a.p={});return a.p};
T.jda=function(a,b,c,d){a!==this.uf[J]&&(this.Ad=[],Lo(this,a));ai(b)||(b={id:d||O,label:c||O,pattern:O,type:b});c=b[H];if(!Jj(kga,c))throw m("Invalid type, "+c+', for column "'+(b[Rc]||b.id||a)+'".');if(c=b.role)d=b.p||{},null==d.role&&(d.role=c,b.p=d);this.uf[he](a,0,b);for(b=0;b<this.tf[J];b++)this.tf[b].c[he](a,0,{v:null,f:null})};T.mg=function(a,b,c){this.jda(this.uf[J],a,b,c);return this.uf[J]-1};function lga(a,b,c){c=Yfa(c);Oo(a,b,c.v);return c}
T.sY=function(a,b){a!==this.tf[J]&&(this.Ad=[],No(this,a));var c;if(Yh(b))c=b;else if(typeof b==Yg){if(b!=h[t](b)||0>b)throw m("Invalid value for numOrArray: "+b+". If numOrArray is a number it should be a nonnegative integer.");c=gj(null,b)}else throw m("Invalid value for numOrArray. Should be a number or an array of arrays of cells.");for(var d=[],e=0;e<c[J];e++){var f=c[e],g=[];if(null===f)for(f=0;f<this.uf[J];f++)g[C]({v:null,f:null});else if(Yh(f)){if(f[J]!=this.uf[J])throw m("Row given with size different than "+
this.uf[J]+" (the number of columns in the table).");for(var k=0;k<f[J];k++)g[C](lga(this,k,f[k]))}else throw m("Every row given must be either null or an array.");f={};f.c=g;d[C](f);1E4==d[J]&&(g=d,gi(Vi,this.tf,a,0)[Mc](null,g),a+=d[J],d=[])}c=d;gi(Vi,this.tf,a,0)[Mc](null,c);return a+d[J]-1};T.Cz=function(a){if(typeof a==Yg||Yh(a))return this.sY(this.tf[J],a);throw m("Argument given to addRows must be either a number or an array");};
T.lq=function(a){if(Yh(a))return this.Cz([a]);if(null!=a)throw m("If argument is given to addRow, it must be an array, or null");return this.Cz(1)};T.qp=function(a){return bga(this,a)};T.Co=function(a){return cga(this,a)};nb(T,function(a){this.Ad=[];a=$fa(this,function(a,c){var d=a.c[c];return d?d.v:null},a);dj(this.tf,a)});T.sR=function(a){Lo(this,a);return a};T.pR=function(a){No(this,a);return a};T.o=function(){return new Ko(this.Ir())};
T.Ir=function(){return jo({cols:this.uf,rows:this.tf,p:this.vs},ko)};Fa(T,function(){return Tm(this.Ir())});T.QR=function(a){return dga(this,a)};T.WJ=function(a){return fga(this,a)};T.hea=function(a,b){0>=b||(this.Ad=[],No(this,a),a+b>this.tf[J]&&(b=this.tf[J]-a),this.tf[he](a,b))};T.mB=function(a){this.hea(a,1)};T.gea=function(a,b){if(!(0>=b)){this.Ad=[];Lo(this,a);a+b>this.uf[J]&&(b=this.uf[J]-a);this.uf[he](a,b);for(var c=0;c<this.tf[J];c++)this.tf[c].c[he](a,b)}};T.a2=function(a){this.gea(a,1)};function Qo(a){this.b=a||{};So||(So=Wn()+saa)}var So=null,mga={red:fh,blue:fg,green:Cg};function To(a,b,c){0<b&&c[C](Aaa,So,a,paa,b,pe)}
ua(Qo[K],function(a,b){if(a.D(b)==Yg){var c=this.b,d=c.min,e=c.max,f=null;if(null==d||null==e)f=a.qp(b),null==e&&(e=f.max),null==d&&(d=h.min(0,f.min));d>=e&&(f=f||a.qp(b),e=f.max,d=f.min);d==e&&(0==d?e=1:0<d?d=0:e=0);var f=e-d,g=c.base||0,g=h.max(d,h.min(e,g)),k=c[r]||100,l=c.showValue;null==l&&(l=!0);for(var n=h[D]((g-d)/f*k),q=k-n,s=0;s<a.M();s++){var u=a[I](s,b),w=[],u=h.max(d,h.min(e,u)),z=h[xb]((u-d)/f*k);w[C](Baa);To(kh,1,w);var B=nga(c.colorPositive,fg),F=nga(c.colorNegative,fh),M=c.drawZeroLine?
1:0;0<n?u<g?(To(Gh,z,w),To(F,n-z,w),0<M&&To(Kh,M,w),To(Gh,q,w)):(To(Gh,n,w),0<M&&To(Kh,M,w),To(B,z-n,w),To(Gh,k-z,w)):(To(B,z,w),To(Gh,k-z,w));To(kh,1,w);u=a.Ao(s,b,Gba);null==u&&(u=a.Aa(s,b),a[Dc](s,b,Gba,u));l&&(w[C](Nh),w[C](u));w[C](xaa);a.uH(s,b,w[ie](O))}}});function nga(a,b){a=(a||O)[ke]();return mga[a]||b};function Yo(a,b,c,d){$h(a)&&(a=a[bc]());$h(b)&&(b=b[bc]());Yh(a)&&(a=Zo(a));Yh(b)&&(b=Zo(b));this.Zca=a;this.Bqa=b;this.qk=c;this.yx=d}Pa(Yo[K],function(a){var b=this.Zca,c=this.Bqa;if(null==a)return null==b&&null==c;$h(a)?a=a[bc]():Yh(a)&&(a=Zo(a));return(null==b||a>=b)&&(null==c||a<c)});Yo[K].Hd=function(){return this.qk};Yo[K].qr=function(){return this.yx};function $o(a,b,c,d,e){Yo[L](this,a,b,c,O);this.I1=b-a;0>=this.I1&&(this.I1=1);this.cqa=rm(mm(d).vd);this.dqa=rm(mm(e).vd)}X($o,Yo);
$o[K].qr=function(a){if(!di(a))return O;a=vm(this.cqa,this.dqa,1-(a-this.Zca)/this.I1);return sm(a[0],a[1],a[2])};function ap(){this.BQ=[]}ap[K].addRange=function(a,b,c,d){this.BQ[C](new Yo(a,b,c,d))};ap[K].msa=function(a,b,c,d,e){this.BQ[C](new $o(a,b,c,d,e))};
ua(ap[K],function(a,b){var c=a.D(b);if(c==Yg||c==rh||c==og||c==pg||c==wh)for(c=0;c<a.M();c++){for(var d=a[I](c,b),e=O,f=0;f<this.BQ[J];f++){var g=this.BQ[f];if(g[Lc](d)){f=g.Hd();d=g.qr(d);f&&(e+=Yba+f+Ye);d&&(e+=gg+d+Ye);break}}a[Dc](c,b,sh,e)}});function Zo(a){return 36E5*a[0]+6E4*a[1]+1E3*a[2]+(4==a[J]?a[3]:0)};function bp(a){this.fe=a||O}function oga(a,b,c,d,e,f,g){return 0<f&&g[f-1]==Bba?d:b.Aa(a,c[la(e,10)])}ua(bp[K],function(a,b,c,d){var e=b[0];null!=c&&Vh(c)==Yg&&(e=c);c=d||null;for(d=0;d<a.M();d++){var f=this.fe[vb](/{(\d+)}/g,gi(oga,d,a,b)),f=f[vb](/\\(.)/g,faa);c?a[Dc](d,e,c,f):a.uH(d,e,f)}});V(oca,Io,void 0);ua(Io[K],Io[K][Kb]);Io[K].formatValue=Io[K].Ee;V("google.visualization.NumberFormat.useNativeCharactersIfAvailable",function(a){wo.setEnforceAsciiDigits(!a)},void 0);V("google.visualization.NumberFormat.DECIMAL_SEP",Ufa,void 0);V("google.visualization.NumberFormat.GROUP_SEP",Vfa,void 0);V("google.visualization.NumberFormat.DECIMAL_PATTERN",Jo,void 0);V("google.visualization.ColorFormat",ap,void 0);ua(ap[K],ap[K][Kb]);ap[K].addRange=ap[K].addRange;ap[K].addGradientRange=ap[K].msa;
V("google.visualization.BarFormat",Qo,void 0);ua(Qo[K],Qo[K][Kb]);V("google.visualization.ArrowFormat",co,void 0);ua(co[K],co[K][Kb]);V("google.visualization.PatternFormat",bp,void 0);ua(bp[K],bp[K][Kb]);V("google.visualization.DateFormat",Go,void 0);ua(Go[K],Go[K][Kb]);Go[K].formatValue=Go[K].Ee;V(oca,Io,void 0);ua(Io[K],Io[K][Kb]);V("google.visualization.TableColorFormat",ap,void 0);V("google.visualization.TableBarFormat",Qo,void 0);ua(Qo[K],Qo[K][Kb]);
V("google.visualization.TableArrowFormat",co,void 0);ua(co[K],co[K][Kb]);V("google.visualization.TablePatternFormat",bp,void 0);ua(bp[K],bp[K][Kb]);V("google.visualization.TableDateFormat",Go,void 0);;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



function cp(a,b){return a.onload=b}function dp(a,b){return a.dispatchEvent=b}function ep(a,b){return a.setPath=b}function fp(a,b){return a.screenX=b}function gp(a,b){return a.screenY=b}function hp(a,b){return a.send=b}function ip(a,b){return a.getName=b}function jp(a,b){return a.keyCode=b}function kp(a,b){return a.handleEvent=b}function lp(a,b){return a.bind=b}function mp(a,b){return a.altKey=b}function np(a,b){return a.index=b}function op(a,b){return a.setOptions=b}
function pp(a,b){return a.getOption=b}function qp(a,b){return a.state=b}function rp(a,b){return a.options=b}function sp(a,b){return a.getState=b}function tp(a,b){return a.onreadystatechange=b}function up(a,b){return a.cancel=b}function vp(a,b){return a.metaKey=b}function wp(a,b){return a.currentTarget=b}function xp(a,b){return a.clientX=b}function yp(a,b){return a.clientY=b}function zp(a,b){return a.stop=b}function Ap(a,b){return a.title=b}function Bp(a,b){return a.abort=b}
function Cp(a,b){return a.visualization=b}function Dp(a,b){return a.target=b}function Ep(a,b){return a.draw=b}
var Fp="relatedTarget",Gp="clearTimeout",Z="data",Hp="preventDefault",$="dispatchEvent",Ip="setPath",Jp="MAX_VALUE",Kp="send",Lp="getName",Mp="charCode",Np="keyCode",Op="LatLng",Pp="handleEvent",Qp="getColumnIndex",Rp="source",Sp="bounds",Tp="altKey",Up="create",Vp="table",Wp="toJSON",Xp="LatLngBounds",Yp="setTimeout",Zp="stopPropagation",$p="setOptions",aq="message",bq="maps",cq="getOption",dq="state",eq="options",fq="protocol",hq="getState",kq="removeNode",lq="offsetX",mq="offsetY",nq="gadgets",
oq="open",pq="cancel",qq="RequestParameters",rq="button",Cq="metaKey",Dq="currentTarget",Eq="readyState",Fq="addEventListener",Gq="parse",Hq="stop",Iq="abort",Jq="ctrlKey",Kq="getPath",Lq="view",Mq="target",Nq="draw",Oq="shiftKey",pga="\n\x3c/script>",qga="\r",rga=" [",sga=" at line ",tga=" does not fit either the Control or Visualization specification.",uga=" does not fit the Control specification while handling 'ready' event.",vga=" does not fit the Control specification.",Pq=" must be of type '",
wga='""',xga='">\n',yga="%22",zga="%27",Aga="&requireauth=1&",Qq="'.",Rq="..",Bga="./",Sq=".format",Tq="/",Cga="/.",Dga="//",Ega="/chart.html",Fga="/chart.js",Gga="/gviz/tq",Uq="/tq",Vq="528",Wq="8",Hga=":\n",Iga=";sig:",Jga=";type:",Xq="<CRLF>",Kga="<EMPTY>",Yq="<EOF>",Zq="<EOR>",Lga='<script type="text/javascript" src="',$q="AnnotatedTimeLine",ar="AreaChart",br="AreaChart-stacked",cr="BarChart",dr="BubbleChart",er="CandlestickChart",Mga="Cannot bind a control to itself.",fr="ColumnChart",gr="ComboChart",
Nga="Content-Type",Oga="Custom response handler must be a function.",Pga="Dashboard",Qga="GET",hr="Gauge",ir="GeoChart",jr="Histogram",kr="ImageRadarChart",lr="ImageSparkLine",Rga="Incompatible data table: ",Sga="Invalid DataView column type.",mr="Invalid data table format: column #",Tga="Invalid data table format: must have 3 columns.",nr="LineChart",Uga="MSXML2.XMLHTTP",Vga="MSXML2.XMLHTTP.3.0",Wga="MSXML2.XMLHTTP.6.0",or="Map",Xga="Microsoft.XMLHTTP",pr="MotionChart",Yga="Name",Zga="One or more participants failed to draw()",
qr="OrgChart",rr="POST",sr="PieChart",$ga="Request timed out",tr="ScatterChart",ur="SteppedAreaChart",vr="Table",aha="The requested control and participant cannot be bound together, as this would introduce a dependency cycle",bha="Timed out after ",wr="Timeline",xr="TreeMap",cha="Type",yr="WordTree",dha="\\c",zr="^",eha="_table_query_refresh_interval",fha="_table_query_url",gha="a String",hha="abort",Ar="addTrendLine",Br="address",iha="an Array",Cr="annotatedtimeline",jha="application/x-www-form-urlencoded;charset=utf-8",
Dr="block",Er="chart",Fr="click",Gr="complete",kha="content-type",lha="control",Hr="controls",Ir="corechart",mha="dashboard",Jr="data",Kr="datatable",nha="date|datetime",oha="detailed_message",pha="display: none; padding-top: 2px",Lr="domain",qha="domainAxis",rha="draw",Mr="drawing",sha="emptyString",Nr="error",Or="focusin",Pr="focusout",tha="gadgets.io.makeRequest",uha="gadgets.io.makeRequest failed",Qr="gauge",Rr="geochart",vha="google.maps.Geocoder",wha="google.visualization.LoadArgs",xha="google.visualization.Query",
yha="google.visualization.events.addListener",zha="google.visualization.events.addOneTimeListener",Aha="google.visualization.events.removeAllListeners",Bha="google.visualization.events.removeListener",Cha="google.visualization.events.trigger",Sr="hasLabelsColumn",Dha="hl",Tr="http",Eha="http%",Fha="http://dummy.com",Gha="https%",Hha="identity",Ur="imagesparkline",Vr="img",Iha="invalid_query",Wr="json",Xr="keypress",Yr="latlng",Zr="linktable",as="makeRequest",Jha="make_request_failed",bs="map",cs=
"markers",Kha="message",Lha="modifier",ds="motionchart",es="mousedown",fs="mouseout",gs="mouseover",Mha="ms, aborting",Nha="nodetable",Oha="not_modified",Pha="options",us="orgchart",Qha="padding: 2px",vs="pending",Rha="percent",Sha="position: absolute; top: 0; left: 0; z-index: 1;",Tha="pub",ws="ready",Uha="readystatechange",Vha="reason",Wha="refresh",xs="regioncode",ys="regions",Xha="reqId:",zs="right",As="select",Yha="series.1.lineWidth",Zha="series.1.pointSize",$ha="series.1.visibleInLegend",aia=
"sig:",Bs="span",Cs="statechange",bia="stringify",cia="success",Ds="table",dia="targetAxes.0",eia="targetAxes.1",fia="targetAxis",Es="text",gia="the wrong type of data",Fs="tick",Gs="timeline",hia="timeline.taskMajor",iia="timeout",Hs="tooltip",jia="tqrt",Is="treemap",Js="ui",kia="ui.type",Ks="uichange",lia="user_not_authenticated",Ls="vAxis",Ms="warning",mia="window.event",nia="withCredentials",Ns="xhr",Os="xhrpost",oia="zx",Ps="|",pia="\u00d7";
function Qs(a){this.sna=qia(a);this.l0=a.status;this.Ku=[];this.Lu=[];this.Lu=a.warnings||[];this.Ku=a.errors||[];ria(this.Lu);ria(this.Ku);this.l0!=Nr&&(this.Z_=a.sig,this.t=new Ko(a[Vp],this.sna))}function ria(a){for(var b=0;b<a[J];b++){var c=a[b].detailed_message;if(c){var d=a[b],c=c?c[Ib](sia)&&!c[Ib](tia)?c:c[vb](/&/g,ze)[vb](/</g,Be)[vb](/>/g,Ae)[vb](/\"/g,De):O;d.detailed_message=c}}}
var sia=/^[^<]*(<a(( )+target=('_blank')?("_blank")?)?( )+(href=('[^']*')?("[^"]*")?)>[^<]*<\/a>[^<]*)*$/,tia=/javascript((s)?( )?)*:/;function qia(a){a=a.version||Qe;return Jj(iga,a)?a:Qe}T=Qs[K];T.Z_=null;T.t=null;T.Ni=function(){return this.l0==Nr};T.f1=function(){return this.l0==Ms};function uia(a){for(var b=0;b<a.Ku[J];b++)if(a.Ku[b].reason==Oha)return!0;for(b=0;b<a.Lu[J];b++)if(a.Lu[b].reason==Oha)return!0;return!1}T.Pa=function(){return this.t};
function Rs(a,b){return a.Ni()&&a.Ku&&a.Ku[0]&&a.Ku[0][b]?a.Ku[0][b]:a.f1()&&a.Lu&&a.Lu[0]&&a.Lu[0][b]?a.Lu[0][b]:null}T.mca=function(){var a=Rs(this,Vha);return null!=a&&a!=O?[a]:[]};T.fI=function(){return Rs(this,Kha)||O};T.I0=function(){return Rs(this,oha)||O};var Ss={D2:"google-visualization-errors"};Ss.haa=Ss.D2+Le;Ss.kca=Ss.D2+Xe;Ss.t2=Ss.D2+"-all-";Ss.r_=Ss.kca+" container is null";Ss.Ima="background-color: #c00000; color: white; padding: 2px;";Ss.Kma="background-color: #fff4c2; color: black; white-space: nowrap; padding: 2px; border: 1px solid black;";Ss.Lma="font: normal 0.8em arial,sans-serif; margin-bottom: 5px;";Ss.Jma="font-size: 1.1em; color: #0000cc; font-weight: bold; cursor: pointer; padding-left: 10px; color: black;text-align: right; vertical-align: top;";
Ss.caa=0;
Ss.td=function(a,b,c,d){if(!Ss.ME(a))throw m(Ss.r_+". message: "+b);c=Ss.Nma(b,c,d);var e=c.errorMessage;b=c.detailedMessage;c=c[eq];var f=null!=c.showInTooltip?!!c.showInTooltip:!0,g=(c[H]==Ms?Ms:Nr)==Nr?Ss.Ima:Ss.Kma,g=g+(c[x]?c[x]:O),k=!!c.removable;d=Ek();var e=d.h(Bs,{style:g},d[Cb](e)),g=Ss.haa+Ss.caa++,l=d.h(Q,{id:g,style:Ss.Lma},e);b&&(f?Ap(e,b):(f=fa[Qb](Bs),Wa(f,b),d[p](l,d.h(Q,{style:Qha},f))));k&&(b=d.h(Bs,{style:Ss.Jma},d[Cb](pia)),b.onclick=gi(Ss.N_,l),d[p](e,b));Ss.Mma(a,l);c.removeDuplicates&&
Ss.Oma(a,l);return g};Ss.oc=function(a){if(!Ss.ME(a))throw m(Ss.r_);if(a=Ss.j2(a,!1))Ra(a[x],R),Wk(a)};Ss.TB=function(a,b){if(!Ss.ME(a))throw m(Ss.r_);if(!b)throw m(Ss.kca+" response is null");if(!b.Ni()&&!b.f1())return null;var c=b.mca(),d=!0;b.Ni()&&(d=!(Ri(c,lia)||Ri(c,Iha)));var c=b.fI(),e=b.I0(),d={showInTooltip:d};ab(d,b.Ni()?Nr:Ms);d.removeDuplicates=!0;return Ss.td(a,c,e,d)};Ss.Qsa=function(a){a=fa[gd](a);return Ss.w2(a)?(Ss.N_(a),!0):!1};
Ss.ac=function(a){a=fa[gd](a);return Ss.w2(a)?a[fe][fe]:null};Ss.UP=function(a,b){return function(){try{a[Mc](null,arguments)}catch(c){ei(b)?b(c):Ss.td(b,c[aq])}}};Ss.N_=function(a){var b=a[fe];Zk(a);0==b[Xb][J]&&Ra(b[x],R)};Ss.w2=function(a){return Sk(a)&&a.id&&ki(a.id,Ss.haa)&&(a=a[fe])&&a.id&&ki(a.id,Ss.t2)&&a[fe]?!0:!1};
Ss.Nma=function(a,b,c){var d=null!=a&&a?a:Nr,e=O,f={},g=arguments[J];2==g?b&&Vh(b)==$g?f=b:e=null!=b?b:e:3==g&&(e=null!=b?b:e,f=c||{});d=pi(d);e=pi(e);return{errorMessage:d,detailedMessage:e,options:f}};Ss.ME=function(a){return null!=a&&Sk(a)};Ss.j2=function(a,b){for(var c=a[Xb],d=null,e=Ek(),f=0;f<c[J];f++)if(c[f].id&&ki(c[f].id,Ss.t2)){d=c[f];e[kq](d);break}!d&&b&&(d=Ss.t2+Ss.caa++,d=Rk(Q,{id:d,style:pha},null));d&&((c=a[Sb])?e.FX(d,c):e[p](a,d));return d};
Ss.Mma=function(a,b){var c=Ss.j2(a,!0);Ra(c[x],Dr);c[p](b)};Ss.vra=function(a,b){var c=Ss.j2(a,!0);Y(c&&c[Xb],function(a){Ss.w2(a)&&b(a)})};Ss.Oma=function(a,b){var c=/id="?google-visualization-errors-[0-9]*"?/,d=xea(b),d=d[vb](c,O),e=[];Ss.vra(a,function(a){if(a!=b){var g=xea(a),g=g[vb](c,O);g==d&&e[C](a)}});Y(e,Ss.N_)};function Ts(a){var b;if(0==fa[cc](Gg)[J]){b=fa[cc](Mg)[0];var c=fa[cc](hg)[0],d=fa[Qb](Gg);b[Eb](d,c)}b=fa[cc](Gg)[0];c=fa[Qb](lh);ab(c,uh);c.src=a;b[p](c)}function via(a){return function(b){Ss.oc(a);var c=b.Ni();c&&Ss.TB(a,b);return!c}};function Us(){}Us[K].Mj=!1;Us[K].Bg=function(){return this.Mj};Us[K].W=function(){this.Mj||(this.Mj=!0,this.w())};function Vs(a,b){var c=gi(Ws,b);a.aK||(a.aK=[]);a.aK[C](W(c,void 0))}Us[K].w=function(){if(this.aK)for(;this.aK[J];)this.aK[rb]()()};function Ws(a){a&&typeof a.W==Bg&&a.W()}function wia(a){for(var b=0,c=arguments[J];b<c;++b){var d=arguments[b];Zh(d)?wia[Mc](null,d):Ws(d)}};function Xs(a,b){ab(this,a);Dp(this,b);wp(this,this[Mq]);this.defaultPrevented=this.xy=!1;this.zba=!0}Xs[K].w=function(){};Xs[K].W=function(){};Xs[K].stopPropagation=function(){this.xy=!0};Xs[K].preventDefault=function(){this.defaultPrevented=!0;this.zba=!1};function Ys(a){a[Hp]()};function Zs(a){Zs[ne](a);return a}Zs[ne]=Th;var xia=!kk||rk(9),yia=!kk||rk(9),zia=kk&&!qk(We);!mk||qk(Vq);lk&&qk("1.9b")||kk&&qk(Wq)||jk&&qk("9.5")||mk&&qk(Vq);lk&&!qk(Wq)||kk&&qk(We);var Aia=kk?Or:"DOMFocusIn",Bia=kk?Pr:"DOMFocusOut";function $s(a,b){Xs[L](this,a?a[H]:O);Dp(this,null);wp(this,null);this.relatedTarget=null;this.offsetY=this.offsetX=0;xp(this,0);yp(this,0);fp(this,0);gp(this,0);this.button=0;jp(this,0);this.charCode=0;this.ctrlKey=!1;mp(this,!1);this.shiftKey=!1;vp(this,!1);qp(this,null);this.O0=!1;this.Ka=null;a&&this[Fc](a,b)}X($s,Xs);var Cia=[1,4,2];T=$s[K];
Ma(T,function(a,b){var c=ab(this,a[H]);Dp(this,a[Mq]||a.srcElement);wp(this,b);var d=a[Fp];if(d){if(lk){var e;t:{try{Zs(d[nd]);e=!0;break t}catch(f){}e=!1}e||(d=null)}}else c==gs?d=a.fromElement:c==fs&&(d=a.toElement);this.relatedTarget=d;this.offsetX=mk||void 0!==a[lq]?a[lq]:a.layerX;this.offsetY=mk||void 0!==a[mq]?a[mq]:a.layerY;xp(this,void 0!==a[zd]?a[zd]:a.pageX);yp(this,void 0!==a[Ad]?a[Ad]:a.pageY);fp(this,a[Gb]||0);gp(this,a[Hb]||0);this.button=a[rq];jp(this,a[Np]||0);this.charCode=a[Mp]||
(c==Xr?a[Np]:0);this.ctrlKey=a[Jq];mp(this,a[Tp]);this.shiftKey=a[Oq];vp(this,a[Cq]);this.O0=fk?a[Cq]:a[Jq];qp(this,a[dq]);this.Ka=a;a.defaultPrevented&&this[Hp]()});function at(a,b){return xia?a.Ka[rq]==b:a[H]==Fr?0==b:!!(a.Ka[rq]&Cia[b])}function bt(a){return at(a,0)&&!(mk&&fk&&a[Jq])}T.stopPropagation=function(){$s.e[Zp][L](this);this.Ka[Zp]?this.Ka[Zp]():this.Ka.cancelBubble=!0};
T.preventDefault=function(){$s.e[Hp][L](this);var a=this.Ka;if(a[Hp])a[Hp]();else if(a.returnValue=!1,zia)try{(a[Jq]||112<=a[Np]&&123>=a[Np])&&jp(a,-1)}catch(b){}};T.Rpa=function(){return this.Ka};T.w=function(){};var ct="closure_listenable_"+(1E6*h[Cc]()|0);function dt(a){try{return!(!a||!a[ct])}catch(b){return!1}}var Dia=0;function Eia(a,b,c,d,e){this.ro=a;this.OR=null;this.src=b;ab(this,c);this.OC=!!d;this.Na=e;this.key=++Dia;this.GC=this.DR=!1}function et(a){a.GC=!0;a.ro=null;a.OR=null;a.src=null;a.Na=null};function ft(a){this.src=a;this.bh={};this.OJ=0}T=ft[K];T.add=function(a,b,c,d,e){var f=a[hc]();a=this.bh[f];a||(a=this.bh[f]=[],this.OJ++);var g=gt(a,b,d,e);-1<g?(b=a[g],c||(b.DR=!1)):(b=new Eia(b,this.src,f,!!d,e),b.DR=c,a[C](b));return b};va(T,function(a,b,c,d){a=a[hc]();if(!(a in this.bh))return!1;var e=this.bh[a];b=gt(e,b,c,d);return-1<b?(et(e[b]),Bi[he][L](e,b,1),0==e[J]&&(delete this.bh[a],this.OJ--),!0):!1});
function ht(a,b){var c=b[H];if(!(c in a.bh))return!1;var d=Wi(a.bh[c],b);d&&(et(b),0==a.bh[c][J]&&(delete a.bh[c],a.OJ--));return d}T.oc=function(a){a=a&&a[hc]();var b=0,c;for(c in this.bh)if(!a||c==a){for(var d=this.bh[c],e=0;e<d[J];e++)++b,et(d[e]);delete this.bh[c];this.OJ--}return b};T.eS=function(a,b){var c=this.bh[a[hc]()],d=[];if(c)for(var e=0;e<c[J];++e){var f=c[e];f.OC==b&&d[C](f)}return d};T.yJ=function(a,b,c,d){a=this.bh[a[hc]()];var e=-1;a&&(e=gt(a,b,c,d));return-1<e?a[e]:null};
T.sS=function(a,b){var c=Qh(a),d=c?a[hc]():O,e=Qh(b);return Fj(this.bh,function(a){for(var g=0;g<a[J];++g)if(!(c&&a[g][H]!=d||e&&a[g].OC!=b))return!0;return!1})};function gt(a,b,c,d){for(var e=0;e<a[J];++e){var f=a[e];if(!f.GC&&f.ro==b&&f.OC==!!c&&f.Na==d)return e}return-1};var it="closure_lm_"+(1E6*h[Cc]()|0),jt={},Fia=0;function kt(a,b,c,d,e){if(Yh(b)){for(var f=0;f<b[J];f++)kt(a,b[f],c,d,e);return null}c=lt(c);return dt(a)?a.l(b,c,d,e):Gia(a,b,c,!1,d,e)}function Gia(a,b,c,d,e,f){if(!b)throw m("Invalid event type");var g=!!e,k=mt(a);k||(a[it]=k=new ft(a));c=k.add(b,c,d,e,f);if(c.OR)return c;d=Hia();c.OR=d;d.src=a;d.ro=c;a[Fq]?a[Fq](b[hc](),d,g):a.attachEvent(Iia(b[hc]()),d);Fia++;return c}
function Hia(){var a=Jia,b=yia?function(c){return a[L](b.src,b.ro,c)}:function(c){c=a[L](b.src,b.ro,c);if(!c)return c};return b}function nt(a,b,c,d,e){if(Yh(b)){for(var f=0;f<b[J];f++)nt(a,b[f],c,d,e);return null}c=lt(c);return dt(a)?a.sB(b,c,d,e):Gia(a,b,c,!0,d,e)}function ot(a,b,c,d,e){if(Yh(b))for(var f=0;f<b[J];f++)ot(a,b[f],c,d,e);else c=lt(c),dt(a)?a.uc(b,c,d,e):a&&(a=mt(a))&&(b=a.yJ(b,c,!!d,e))&&pt(b)}
function pt(a){if(di(a)||!a||a.GC)return!1;var b=a.src;if(dt(b))return ht(b.rl,a);var c=a[H],d=a.OR;b.removeEventListener?b.removeEventListener(c,d,a.OC):b.detachEvent&&b.detachEvent(Iia(c),d);Fia--;(c=mt(b))?(ht(c,a),0==c.OJ&&(c.src=null,b[it]=null)):et(a);return!0}function qt(a){if(!a)return 0;if(dt(a))return a.rl?a.rl.oc(void 0):0;a=mt(a);if(!a)return 0;var b=0,c;for(c in a.bh)for(var d=Yi(a.bh[c]),e=0;e<d[J];++e)pt(d[e])&&++b;return b}
function Kia(a){if(dt(a))return a.sS(es,!1);a=mt(a);return!!a&&a.sS(es,!1)}function Iia(a){return a in jt?jt[a]:jt[a]=ah+a}function Lia(a,b,c,d){var e=1;if(a=mt(a))if(b=a.bh[b[hc]()])for(b=Yi(b),a=0;a<b[J];a++){var f=b[a];f&&f.OC==c&&!f.GC&&(e&=!1!==Mia(f,d))}return ka(e)}function Mia(a,b){var c=a.ro,d=a.Na||a.src;a.DR&&pt(a);return c[L](d,b)}
function Jia(a,b){if(a.GC)return!0;if(!yia){var c=b||Sh(mia),d=new $s(c,this),e=!0;if(!(0>c[Np]||void 0!=c.returnValue)){t:{var f=!1;if(0==c[Np])try{jp(c,-1);break t}catch(g){f=!0}if(f||void 0==c.returnValue)c.returnValue=!0}c=[];for(f=d[Dq];f;f=f[fe])c[C](f);for(var f=a[H],k=c[J]-1;!d.xy&&0<=k;k--)wp(d,c[k]),e&=Lia(c[k],f,!0,d);for(k=0;!d.xy&&k<c[J];k++)wp(d,c[k]),e&=Lia(c[k],f,!1,d)}return e}return Mia(a,new $s(b,this))}function mt(a){a=a[it];return a instanceof ft?a:null}
var Nia="__closure_events_fn_"+(1E9*h[Cc]()>>>0);function lt(a){return ei(a)?a:a[Nia]||(a[Nia]=function(b){return a[Pp](b)})};function rt(){this.rl=new ft(this);this.vqa=this}X(rt,Us);rt[K][ct]=!0;T=rt[K];T.KB=null;T.Az=function(a){this.KB=a};T.addEventListener=function(a,b,c,d){kt(this,a,b,c,d)};T.removeEventListener=function(a,b,c,d){ot(this,a,b,c,d)};
dp(T,function(a){var b,c=this.KB;if(c)for(b=[];c;c=c.KB)b[C](c);var c=this.vqa,d=a[H]||a;if(bi(a))a=new Xs(a,c);else if(a instanceof Xs)Dp(a,a[Mq]||c);else{var e=a;a=new Xs(d,c);Sj(a,e)}var e=!0,f;if(b)for(var g=b[J]-1;!a.xy&&0<=g;g--)f=wp(a,b[g]),e=st(f,d,!0,a)&&e;a.xy||(f=wp(a,c),e=st(f,d,!0,a)&&e,a.xy||(e=st(f,d,!1,a)&&e));if(b)for(g=0;!a.xy&&g<b[J];g++)f=wp(a,b[g]),e=st(f,d,!1,a)&&e;return e});T.w=function(){rt.e.w[L](this);this.rl&&this.rl.oc(void 0);this.KB=null};
T.l=function(a,b,c,d){return this.rl.add(String(a),b,!1,c,d)};T.sB=function(a,b,c,d){return this.rl.add(String(a),b,!0,c,d)};T.uc=function(a,b,c,d){return this.rl[Ob](String(a),b,c,d)};function st(a,b,c,d){b=a.rl.bh[String(b)];if(!b)return!0;b=Yi(b);for(var e=!0,f=0;f<b[J];++f){var g=b[f];if(g&&!g.GC&&g.OC==c){var k=g.ro,l=g.Na||g.src;g.DR&&ht(a.rl,g);e=!1!==k[L](l,d)&&e}}return e&&!1!=d.zba}T.eS=function(a,b){return this.rl.eS(String(a),b)};
T.yJ=function(a,b,c,d){return this.rl.yJ(String(a),b,c,d)};T.sS=function(a,b){return this.rl.sS(Qh(a)?String(a):void 0,b)};function tt(a,b){rt[L](this);this.Nu=a||1;this.QB=b||Ph;this.r1=W(this.n1,this);this.ZC=hi()}X(tt,rt);T=tt[K];T.is=!1;T.Sc=null;T.n1=function(){if(this.is){var a=hi()-this.ZC;0<a&&a<0.8*this.Nu?this.Sc=this.QB[Yp](this.r1,this.Nu-a):(this.Sc&&(this.QB[Gp](this.Sc),this.Sc=null),this[$](Fs),this.is&&(this.Sc=this.QB[Yp](this.r1,this.Nu),this.ZC=hi()))}};La(T,function(){this.is=!0;this.Sc||(this.Sc=this.QB[Yp](this.r1,this.Nu),this.ZC=hi())});
zp(T,function(){this.is=!1;this.Sc&&(this.QB[Gp](this.Sc),this.Sc=null)});T.w=function(){tt.e.w[L](this);this[Hq]();delete this.QB};function ut(a,b,c){if(ei(a))c&&(a=W(a,c));else if(a&&typeof a[Pp]==Bg)a=W(a[Pp],a);else throw m("Invalid listener argument");return 2147483647<b?-1:Ph[Yp](a,b||0)}function vt(a){Ph[Gp](a)};function wt(){}wt[K].Wda=null;wt[K].Vc=function(){var a;(a=this.Wda)||(a={},Oia(this)&&(a[0]=!0,a[1]=!0),a=this.Wda=a);return a};var xt;function Pia(){}X(Pia,wt);function Qia(a){return(a=Oia(a))?new ActiveXObject(a):new XMLHttpRequest}function Oia(a){if(!a.cea&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=[Wga,Vga,Uga,Xga],c=0;c<b[J];c++){var d=b[c];try{return new ActiveXObject(d),a.cea=d}catch(e){}}throw m("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.cea}xt=new Pia;function yt(a){rt[L](this);this.headers=new Uj;this.cQ=a||null;this.au=!1;this.ZP=this.pd=null;this.Cx=this.$Z=O;this.mx=this.IZ=this.WP=this.ZZ=!1;this.bQ=0;this.aQ=null;this.h$=O;this.VZ=this.T7=!1}X(yt,rt);var Ria=/^https?$/i,Sia=[rr,"PUT"],Tia=[];T=yt[K];T.Sla=function(){this.W();Wi(Tia,this)};
hp(T,function(a,b,c,d){if(this.pd)throw m("[goog.net.XhrIo] Object is active with another request="+this.$Z+"; newUri="+a);b=b?b[ge]():Qga;this.$Z=a;this.Cx=O;this.ZZ=!1;this.au=!0;this.pd=this.cQ?Qia(this.cQ):Qia(xt);this.ZP=this.cQ?this.cQ.Vc():xt.Vc();tp(this.pd,W(this.m$,this));try{this.IZ=!0,this.pd[oq](b,String(a),!0),this.IZ=!1}catch(e){this.Lr(5,e);return}a=c||O;var f=this.headers.o();d&&bk(d,function(a,b){f.set(b,a)});d=Oi(f.hk(),Uia);c=Ph.FormData&&a instanceof Ph.FormData;!Ri(Sia,b)||d||
c||f.set(Nga,jha);f[Tb](function(a,b){this.pd.setRequestHeader(b,a)},this);this.h$&&(this.pd.responseType=this.h$);nia in this.pd&&(this.pd.withCredentials=this.T7);try{Via(this),0<this.bQ&&((this.VZ=Wia(this.pd))?(this.pd.timeout=this.bQ,this.pd.ontimeout=W(this.Ve,this)):this.aQ=ut(this.Ve,this.bQ,this)),this.WP=!0,this.pd[Kp](a),this.WP=!1}catch(g){this.Lr(5,g)}});function Wia(a){return kk&&qk(9)&&di(a.timeout)&&Qh(a.ontimeout)}function Uia(a){return kha==a[ke]()}
T.Ve=function(){"undefined"!=typeof Oh&&this.pd&&(this.Cx=bha+this.bQ+Mha,this[$](iia),this[Iq](8))};T.Lr=function(a,b){this.au=!1;this.pd&&(this.mx=!0,this.pd[Iq](),this.mx=!1);this.Cx=b;Xia(this);zt(this)};function Xia(a){a.ZZ||(a.ZZ=!0,a[$](Gr),a[$](Nr))}Bp(T,function(){this.pd&&this.au&&(this.au=!1,this.mx=!0,this.pd[Iq](),this.mx=!1,this[$](Gr),this[$](hha),zt(this))});T.w=function(){this.pd&&(this.au&&(this.au=!1,this.mx=!0,this.pd[Iq](),this.mx=!1),zt(this,!0));yt.e.w[L](this)};
T.m$=function(){this.Mj||(this.IZ||this.WP||this.mx?Yia(this):this.rqa())};T.rqa=function(){Yia(this)};function Yia(a){if(a.au&&"undefined"!=typeof Oh&&(!a.ZP[1]||4!=At(a)||2!=Bt(a)))if(a.WP&&4==At(a))ut(a.m$,0,a);else if(a[$](Uha),4==At(a)){a.au=!1;try{if(Zia(a))a[$](Gr),a[$](cia);else{var b;try{b=2<At(a)?a.pd.statusText:O}catch(c){b=O}a.Cx=b+rga+Bt(a)+$f;Xia(a)}}finally{zt(a)}}}
function zt(a,b){if(a.pd){Via(a);var c=a.pd,d=a.ZP[0]?Th:null;a.pd=null;a.ZP=null;b||a[$](ws);try{tp(c,d)}catch(e){}}}function Via(a){a.pd&&a.VZ&&(a.pd.ontimeout=null);di(a.aQ)&&(vt(a.aQ),a.aQ=null)}T.nk=function(){return!!this.pd};function Zia(a){var b=Bt(a),c;t:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break t;default:c=!1}if(!c){if(b=0===b)a=cm(String(a.$Z))[1]||null,!a&&self[tc]&&(a=self[tc][fq],a=a[ec](0,a[J]-1)),b=!Ria[bd](a?a[ke]():O);c=b}return c}
function At(a){return a.pd?a.pd[Eq]:0}function Bt(a){try{return 2<At(a)?a.pd.status:-1}catch(b){return-1}}function $ia(a){return bi(a.Cx)?a.Cx:String(a.Cx)};function Ct(a,b){var c;if(a instanceof Ct)this.Km=Qh(b)?b:a.Km,Dt(this,a.Zk),c=a.Sx,Et(this),this.Sx=c,Ft(this,a.Au),Gt(this,a.zu),this[Ip](a[Kq]()),Ht(this,a.Oi.o()),c=a.Rx,Et(this),this.Rx=c;else if(a&&(c=cm(String(a)))){this.Km=!!b;Dt(this,c[1]||O,!0);var d=c[2]||O;Et(this);this.Sx=It(d);Ft(this,c[3]||O,!0);Gt(this,c[4]);this[Ip](c[5]||O,!0);Ht(this,c[6]||O,!0);c=c[7]||O;Et(this);this.Rx=It(c)}else this.Km=!!b,this.Oi=new Jt(null,0,this.Km)}T=Ct[K];T.Zk=O;T.Sx=O;T.Au=O;T.zu=null;T.sk=O;T.Rx=O;
T.Nsa=!1;T.Km=!1;Da(T,function(){var a=[],b=this.Zk;b&&a[C](Kt(b,aja),Xe);if(b=this.Au){a[C](Dga);var c=this.Sx;c&&a[C](Kt(c,aja),Gaa);a[C](aa(String(b)));b=this.zu;null!=b&&a[C](Xe,String(b))}if(b=this[Kq]())this.Au&&b[Bb](0)!=Tq&&a[C](Tq),a[C](Kt(b,b[Bb](0)==Tq?bja:cja));(b=this.Oi[hc]())&&a[C](cf,b);(b=this.Rx)&&a[C](qe,Kt(b,dja));return a[ie](O)});
T.resolve=function(a){var b=this.o(),c=!!a.Zk;c?Dt(b,a.Zk):c=!!a.Sx;if(c){var d=a.Sx;Et(b);b.Sx=d}else c=!!a.Au;c?Ft(b,a.Au):c=null!=a.zu;d=a[Kq]();if(c)Gt(b,a.zu);else if(c=!!a.sk){if(d[Bb](0)!=Tq)if(this.Au&&!this.sk)d=Tq+d;else{var e=b[Kq]()[Rd](Tq);-1!=e&&(d=b[Kq]()[ec](0,e+1)+d)}e=d;if(e==Rq||e==Me)d=O;else if(ri(e,Bga)||ri(e,Cga)){for(var d=ki(e,Tq),e=e[pc](Tq),f=[],g=0;g<e[J];){var k=e[g++];k==Me?d&&g==e[J]&&f[C](O):k==Rq?((1<f[J]||1==f[J]&&f[0]!=O)&&f.pop(),d&&g==e[J]&&f[C](O)):(f[C](k),d=
!0)}d=f[ie](Tq)}else d=e}c?b[Ip](d):c=a.Oi[hc]()!==O;c?Ht(b,It(a.Oi[hc]())):c=!!a.Rx;c&&(a=a.Rx,Et(b),b.Rx=a);return b};T.o=function(){return new Ct(this)};function Dt(a,b,c){Et(a);a.Zk=c?It(b):b;a.Zk&&(a.Zk=a.Zk[vb](/:$/,O))}function Ft(a,b,c){Et(a);a.Au=c?It(b):b}function Gt(a,b){Et(a);if(b){b=ia(b);if(ga(b)||0>b)throw m("Bad port number "+b);a.zu=b}else a.zu=null}T.getPath=function(){return this.sk};ep(T,function(a,b){Et(this);this.sk=b?It(a):a;return this});
function Ht(a,b,c){Et(a);b instanceof Jt?(a.Oi=b,a.Oi.R1(a.Km)):(c||(b=Kt(b,eja)),a.Oi=new Jt(b,0,a.Km));return a}T.fk=function(a,b){return Ht(this,a,b)};T.On=function(){return this.Oi[hc]()};T.Oc=function(a,b){Et(this);this.Oi.set(a,b);return this};function fja(a,b,c){Et(a);Yh(c)||(c=[String(c)]);a.Oi.setValues(b,c)}function Lt(a,b){return a.Oi.get(b)}T.s1=function(a){Et(this);this.Oi[Ob](a);return this};function Et(a){if(a.Nsa)throw m("Tried to modify a read-only Uri");}
T.R1=function(a){this.Km=a;this.Oi&&this.Oi.R1(a);return this};function gja(a){return a instanceof Ct?a.o():new Ct(a,void 0)}function It(a){return a?oa(a):O}function Kt(a,b){return bi(a)?encodeURI(a)[vb](b,hja):null}function hja(a){a=a[Xd](0);return we+(a>>4&15)[hc](16)+(a&15)[hc](16)}var aja=/[#\/\?@]/g,cja=/[\#\?:]/g,bja=/[\#\?]/g,eja=/[\#\?@]/g,dja=/#/g;function Jt(a,b,c){this.Al=a||null;this.Km=!!c}
function Mt(a){if(!a.Rf&&(a.Rf=new Uj,a.Mb=0,a.Al))for(var b=a.Al[pc](xe),c=0;c<b[J];c++){var d=b[c][ld](af),e=null,f=null;0<=d?(e=b[c][ae](0,d),f=b[c][ae](d+1)):e=b[c];e=oa(e[vb](/\+/g,ne));e=Nt(a,e);a.add(e,f?oa(f[vb](/\+/g,ne)):O)}}T=Jt[K];T.Rf=null;T.Mb=null;T.Lc=function(){Mt(this);return this.Mb};T.add=function(a,b){Mt(this);this.Al=null;a=Nt(this,a);var c=this.Rf.get(a);c||this.Rf.set(a,c=[]);c[C](b);this.Mb++;return this};
va(T,function(a){Mt(this);a=Nt(this,a);return this.Rf.$e(a)?(this.Al=null,this.Mb-=this.Rf.get(a)[J],this.Rf[Ob](a)):!1});wa(T,function(){this.Rf=this.Al=null;this.Mb=0});Ua(T,function(){Mt(this);return 0==this.Mb});T.$e=function(a){Mt(this);a=Nt(this,a);return this.Rf.$e(a)};T.$R=function(a){var b=this.La();return Ri(b,a)};T.hk=function(){Mt(this);for(var a=this.Rf.La(),b=this.Rf.hk(),c=[],d=0;d<b[J];d++)for(var e=a[d],f=0;f<e[J];f++)c[C](b[d]);return c};
T.La=function(a){Mt(this);var b=[];if(bi(a))this.$e(a)&&(b=Xi(b,this.Rf.get(Nt(this,a))));else{a=this.Rf.La();for(var c=0;c<a[J];c++)b=Xi(b,a[c])}return b};T.set=function(a,b){Mt(this);this.Al=null;a=Nt(this,a);this.$e(a)&&(this.Mb-=this.Rf.get(a)[J]);this.Rf.set(a,[b]);this.Mb++;return this};T.get=function(a,b){var c=a?this.La(a):[];return 0<c[J]?String(c[0]):b};T.setValues=function(a,b){this[Ob](a);0<b[J]&&(this.Al=null,this.Rf.set(Nt(this,a),Yi(b)),this.Mb+=b[J])};
Da(T,function(){if(this.Al)return this.Al;if(!this.Rf)return O;for(var a=[],b=this.Rf.hk(),c=0;c<b[J];c++)for(var d=b[c],e=aa(String(d)),d=this.La(d),f=0;f<d[J];f++){var g=e;d[f]!==O&&(g+=af+aa(String(d[f])));a[C](g)}return this.Al=a[ie](xe)});T.o=function(){var a=new Jt;a.Al=this.Al;this.Rf&&(a.Rf=this.Rf.o(),a.Mb=this.Mb);return a};function Nt(a,b){var c=String(b);a.Km&&(c=c[ke]());return c}
T.R1=function(a){a&&!this.Km&&(Mt(this),this.Al=null,this.Rf[Tb](function(a,c){var d=c[ke]();c!=d&&(this[Ob](c),this.setValues(d,a))},this));this.Km=a};T.extend=function(a){for(var b=0;b<arguments[J];b++)bk(arguments[b],function(a,b){this.add(b,a)},this)};var ija=/\/spreadsheet/,jja=/\/(ccc|tq|pub)$/,kja=/^spreadsheets?[0-9]?\.google\.com$/,lja=/^docs\.google\.com*$/,mja=/^(trix|spreadsheets|docs|webdrive)(-[a-z]+)?\.(corp|sandbox)\.google\.com/,nja=/^(\w*\.){1,2}corp\.google\.com$/,oja=/\/spreadsheets(\/d\/[^/]+)?/,pja=/\/(edit|gviz\/tq|)$/,qja=/^docs\.google\.com*$/,rja=/^docs\.sandbox\.google\.com*$/,sja=/^(\w*\.){1,2}corp\.google\.com$/,tja=/^\/a\/([\w-]+\.)+\w+/,Ot=/^(\/a\/([\w-]+\.)+\w+)?/,uja=/^[a-z]+\d+\:[a-z]+\d+$/i,vja=/^[a-z]+\d+$/i;
function Pt(a){var b=em(a),c=kja[bd](b),d=mja[bd](b),e=nja[bd](b),b=lja[bd](b),f=fm(a),g=new RegExp(Ot[Rp]+jja[Rp]),f=(a=(new RegExp(Ot[Rp]+ija[Rp]+jja[Rp]))[bd](f))||g[bd](f);return b&&a||(d||e||c)&&f}function wja(a){var b=em(a),c=rja[bd](b),d=sja[bd](b),b=qja[bd](b);a=fm(a);a=(new RegExp(Ot[Rp]+oja[Rp]+pja[Rp]))[bd](a);return(b||c||d)&&a}
function xja(a){if(!vja[bd](a))return null;a=a[ge]();for(var b,c=O,d=0;d<a[J];d++){var e=a[Xd](d);if(65>e||90<e){c=a[ae](0,d);b=a[ae](d);break}}a=0;d=1;for(e=c[J]-1;0<=e;e--)a+=d*(c[Xd](e)-64),d*=26;c=a;b=la(b,10);return ga(b)||0>=b||0>c?null:new sk(c,b)};var yja={firstLineIsHeader:!1};function Qt(a,b,c,d){b=b[pc](/\r?\n/)[c];Ka(this,a+sga+(c+1)+Hga+b);Ka(this,this[aq]+(me+ti(ne,-1==d?b[J]:d)+zr))}X(Qt,m);V("vis.csv.ParseError",Qt,void 0);eb(Qt[K],"ParseError");function Rt(a){this.b=a||{};Dj(yja,function(a,c){Oj(this.b,c,a)},this)}V("vis.csv.Parser",Rt,void 0);
gb(Rt[K],function(a){function b(a){a==Xq&&(l--,n=q);s=a}function c(){q=n;if(null!=s){var b=s;b==Xq&&(l++,n=0);s=null;return b}if(k>=g)return Yq;b=a[Bb](k++);n++;var c=!1;b==me?c=!0:b==qga&&(k<g&&a[Bb](k)==me&&k++,c=!0);return c?(l++,n=0,Xq):b}function d(){var d=k,e=u;u=!1;var f=c();if(f==Kga)return Zq;if(f==Yq||f==Xq)return e?(b(Kga),O):Zq;if(f==oe){d=k;e=null;for(f=c();f!=Yq;f=c())if(f==oe)if(e=k-1,f=c(),f==oe)e=null;else{if(f==Je||f==Yq||f==Xq){f==Xq&&b(f);break}throw new Qt('Unexpected character "'+
f+'" after quote mark',a,l,n-1);}if(null==e)throw new Qt("Unexpected end of text after open quote",a,l,n);return a[ae](d,e)[vb](/""/g,oe)}for(;f!=Yq&&f!=Je&&f!=Xq;f=c())if(f==oe)throw new Qt("Unexpected quote mark",a,l,n-1);f==Je&&(u=!0);f!=Yq&&f!=Xq||b(f);return a[ae](d,f==Yq?k:k-1)[vb](/[\r\n]+/g,O)}function e(){if(k>=g)return Yq;for(var a=[],b=d();b!=Zq;b=d())a[C](b);return a}var f=this.b.firstLineIsHeader,g=a[J],k=0,l=0,n=0,q=0,s=null,u=!1,w=[],z=[],B=null;f&&(w=e(),B=w[J]);for(var F=e();F!=Yq;F=
e()){null==B&&(B=F[J]);if(F[J]!=B)throw new Qt("Record has "+F[J]+" field"+(1==F[J]?O:kh)+", but expected "+B,a,l-1,-1);if(f){for(var M={},N=0;N<F[J];N++)M[w[N]]=F[N];z[C](M)}else z[C](F)}return z});gb(Rt[K],Rt[K][Gq]);function zja(a,b,c){this.Xna=new Rt;this.ZQ=null!=c?c:!1;this.Wna=a;for(a=0;a<b[J];a++)if(c=b[a],!Aja[c])throw m("Unsupported type: "+c);this.Yna=b;this.Ib=[]}var Aja={number:function(a){var b=ma(a);if(ga(b))throw m("Not a number "+a);return b},string:function(a){return a},"boolean":function(a){return a[ke]()===zh},date:function(a){return new Date(a)},datetime:function(a){return new Date(a)},timeofday:function(a){return a[pc](Je)}};function St(a,b){var c=b||{};this.v9=Qh(c.csvColumns);this.lna=c.csvColumns;this.ZQ=!!c.csvHasHeader;this.n_=c.sendMethod||eg;this.Jla=!!c.xhrWithCredentials;if(!Jj(Bja,this.n_))throw m("Send method not supported: "+this.n_);this.d$=c.makeRequestParams_||{};if(wja(a)){var d=a,c=new Ct(d);433==c.zu&&Gt(c,null);var e=c[Kq](),e=e[vb](/\/edit$/,Gga);c[Ip](e);e=em(d);d=!Wh(ia(cm(d)[4]||null)||null);d=sja[bd](e)&&d;Dt(c,d?Tr:Ng);a=c[hc]()}else if(Pt(a)){e=a;c=new Ct(e);433==c.zu&&Gt(c,null);d=c[Kq]();d=
d[vb](/\/ccc$/,Uq);/\/pub$/[bd](d)&&(d=d[vb](/\/pub$/,Uq),c.Oc(Tha,Te));c[Ip](d);var d=em(e),e=null!=(ia(cm(e)[4]||null)||null),f=mja[bd](d),d=nja[bd](d)&&!f&&e;Dt(c,d?Tr:Ng);a=c[hc]()}d=a;c=Pt(d);d=fm(d);d=tja[bd](d);(c=c&&d)||(d=a,c=wja(d),d=fm(d),d=tja[bd](d),c=c&&d);this.Ila=c;this.Hla=a;this.m_=Cja++;Tt[C](this)}var Bja={Jwa:Ns,Kwa:Os,$va:"scriptInjection",sva:as,Oda:eg},Dja=new Uj({"X-DataSource-Auth":bg}),Cja=0,Ut={};St[K].Eda=30;var Tt=[],Vt=Ph[nq];
function Eja(){for(var a=0;a<Tt[J];a++){var b=Tt[a];b.H1&&b.ct()}}function Fja(a,b){var c=a[ld](qe);-1!=c&&(a=a[ae](0,c));var d=a[ld](cf),e=c=O,f=[];-1==d?c=a:(c=a[ae](0,d),e=a[ae](d+1),f=e[pc](xe));d=[];for(e=0;e<f[J];e++){var g=f[e][pc](af),k={};eb(k,g[0]);k.P2=f[e];d[C](k)}for(var l in b){f=b[l];g=!1;for(e=0;e<d[J];e++)if(d[e][yd]==l){d[e].P2=l+af+aa(f);g=!0;break}g||(e={},eb(e,l),e.P2=l+af+aa(f),d[C](e))}l=c;if(0<d[J]){l+=cf;c=[];for(e=0;e<d[J];e++)c[C](d[e].P2);l+=c[ie](xe)}return l}T=St[K];
T.Wla=function(a,b){if(Zia(b[Mq])){var c;var d=b[Mq];try{c=d.pd?d.pd.responseText:O}catch(e){c=O}c=pi(c);if(this.v9){var f=new zja(c,this.lna,this.ZQ),d=f.Xna[Gq](f.Wna);c=new Ko;if(d&&0<d[J]){for(var g=[],k=f.Yna,l=0,n=k[J];l<n;l++)g[C]({type:k[l],label:[]});if(f.ZQ)for(k=0,n=g[J];k<n;k++)g[k][Rc][C](d[0][k]);k=0;for(n=g[J];k<n;k++)l=g[k],c.mg(l[H],l[Rc][ie](ne));f.Ib=g;g=f.Ib;n=f=f.ZQ?1:0;for(k=d[J];n<k;n++){c.lq();for(var l=0,q=g[J];l<q;l++)c.al(n-f,l,Aja[g[l][H]](d[n][l]))}}d={};d.table=c[Wp]();
d.version=qia(d);d.reqId=a;Wt(d)}else c[Ib](/^({.*})$/)?(c=Cfa(c),Wt(c)):kda(mo(c))}else if(this.xu)Xt(this,xha,$ia(b[Mq]));else throw m("google.visualization.Query: "+$ia(b[Mq]));};function Wt(a){var b=a.reqId,c=Ut[b];if(c)Ut[b]=null,c.aD(a);else throw m("Missing query for request id: "+b);}T.xu=null;T.oS=null;T.wS=null;T.lj=null;T.w_=null;T.iC=null;T.H1=!0;T.cl=0;T.nI=null;T.nk=!1;T.Vm=function(a){if(typeof a!=Yg||0>a)throw m("Refresh interval must be a non-negative number");this.cl=a;Yt(this)};
function Zt(a){a.wS&&(ca[Gp](a.wS),a.wS=null)}function Xt(a,b,c,d){a.aD({version:Qe,status:Nr,errors:[{reason:b,message:c,detailed_message:d}]})}
T.ct=function(){var a;a=this.Hla;var b={};this.lj&&(b.tq=String(this.lj));var c=Xha+String(this.m_),d=this.nI;d&&(c+=Iga+d);this.w_&&(c+=Jga+this.w_);b.tqx=c;if(this.iC){var c=[],e;for(e in this.iC)c[C](e+Xe+this.iC[e]);b.tqh=c[ie](Ye)}a=Fja(a,b);this.cl&&(a=new Ct(a),mk&&(Et(a),a.Oc(oia,h[t](2147483648*h[Cc]())[hc](36)+h.abs(h[t](2147483648*h[Cc]())^hi())[hc](36))),a=a[hc]());e={};Ut[String(this.m_)]=this;c=this.n_;b=Qga;c==Os&&(c=Ns,b=rr);c==eg&&(c={},/[?&]alt=gviz(&[^&]*)*$/[bd](a)?e=as:(d=im(a,
jia)||eg,d=d[pc](Xe),e=d[0],e!==Ns&&e!==Os||!Ri(d,nia)||(c.xhrWithCredentials=!0),Jj(Bja,e)||(e=eg)),e={sendMethod:e,options:c},c=e.sendMethod,e=e[eq]);if(c==as)if(Sh(tha))b=this.d$,null==b[Vt.io[qq].CONTENT_TYPE]&&(b[Vt.io[qq].CONTENT_TYPE]=Vt.io.ContentType.TEXT),null==b[Vt.io[qq].AUTHORIZATION]&&(b[Vt.io[qq].AUTHORIZATION]=Vt.io.AuthorizationType.SIGNED),null==b.OAUTH_ENABLE_PRIVATE_NETWORK&&(b.OAUTH_ENABLE_PRIVATE_NETWORK=!0),null==b.OAUTH_ADD_EMAIL&&(b.OAUTH_ADD_EMAIL=!0),Vt.io.makeRequest(a,
W(this.Vla,this),b),$t(this);else throw m("gadgets.io.makeRequest is not defined.");else{if(!(d=c==Ns)){if(c=c==eg)d=Ph[tc][Ic],c=(new Ct(d)).resolve(new Ct(a))[hc](),d=cm(d),c=cm(c),c=d[3]==c[3]&&d[1]==c[1]&&d[4]==c[4];d=c}if(d){c=void 0;d=a;b==rr&&(a=a[pc](cf),1<=a[J]&&(d=a[0]),2<=a[J]&&(c=a[1]));a=d;d=W(gi(this.Wla,this.m_),this);e=this.Jla||!!e.xhrWithCredentials;var f=new yt;Tia[C](f);d&&f.l(Gr,d);f.sB(ws,f.Sla);e&&(f.T7=e);f[Kp](a,b,c,Dja)}else{if(this.v9)throw m("CSV files on other domains are not supported. Please use sendMethod: 'xhr' or 'auto' and serve your .csv file from the same domain as this page.");
b=fa[cc](hg)[0];e=null===this.nI;this.Ila&&e?(e=fa[Qb](Vr),Gja(this,e,a),b[p](e)):($t(this),Ts(a),Yt(this))}}};function Gja(a,b,c){b.onerror=function(){$t(a);Ts(c);Yt(a)};cp(b,function(){$t(a);Ts(c);Yt(a)});Ra(b[x],R);var d=c+Aga+(new Date)[bc]();b.src=d}T.Vla=function(a){if(null!=a&&a[Z])kda(mo(a[Z]));else{var b=O;a&&a.errors&&(b=a.errors[ie](ne));Xt(this,Jha,uha,b)}};function $t(a){Zt(a);a.wS=ca[Yp](function(){Xt(a,iia,$ga)},1E3*a.Eda)}function Hja(a){a.oS&&(ca[Gp](a.oS),a.oS=null)}
function Yt(a){Hja(a);0!=a.cl&&a.H1&&a.nk&&(a.oS=ca[Yp](function(){a.ct()},1E3*a.cl))}hp(T,function(a){this.nk=!0;this.xu=a;this.ct()});T.makeRequest=function(a,b){this.nk=!0;this.xu=a;this.Zta=as;this.d$=b||{};this.ct()};Bp(T,function(){this.nk=!1;Zt(this);Hja(this)});T.aD=function(a){Zt(this);a=new Qs(a);if(!uia(a)){this.nI=a.Ni()?null:a.Z_;var b=this.xu;b[L](b,a)}};T.setTimeout=function(a){if(typeof a!=Yg||ga(a)||0>=a)throw m("Timeout must be a positive number");this.Eda=a};
T.eta=function(a){if(typeof a!=jg)throw m("Refreshable must be a boolean");return this.H1=a};T.fk=function(a){if(typeof a!=rh)throw m("queryString must be a string");this.lj=a};T.ata=function(a){this.w_=a;null!=a&&this.Fda(Ah,a)};T.Fda=function(a,b){a=a[vb](/\\/g,Yf);b=b[vb](/\\/g,Yf);a=a[vb](/:/g,dha);b=b[vb](/:/g,dha);a=a[vb](/;/g,Zf);b=b[vb](/;/g,Zf);this.iC||(this.iC={});this.iC[a]=b};function au(){Ija||(Ija=!0,Ph.jra&&Ph.jra.cua(Eja,{pollingInterval:100}),Ph[nq]&&(Jja(),this.vda()));var a=Ik(hg)[0];this.nra=via(a)}var Ija=!1;au[K].Kda=200;function bu(){return!!Ph[nq]&&!!Ph[nq].rpc}au[K].vda=function(){if(bu()){var a=Ph[nq];ei(a.rpc.register)&&a.rpc.register(Wha,Eja)}else 0<this.Kda&&(this.Kda--,ca[Yp](W(this.vda,this),100))};au[K].rsa=function(a){var b=a.getString(fha),c=b[ke]();if(0==c[ld](Eha)||0==c[ld](Gha))b=oa(b);b=new St(b);a=a.getInt(eha);b.Vm(a);return b};au[K].lta=function(a){return this.nra(a)};
function Jja(){if(bu()){var a=Ph[nq];try{a.rpc.getRelayUrl(Rq)||a.rpc.setRelayUrl(Rq,Fha)}catch(b){ei(a.rpc.setRelayUrl)&&a.rpc.setRelayUrl(Rq,Fha)}}}Ph[nq]&&!bu()&&Ts("//www-opensocial.googleusercontent.com/gadgets/rpc/rpc.v.js");Jja();var eu=Ph.__gvizguard__?Sh(yha):function(a,b,c){a=cu(a);b=kt(a,b,Kja(c));return new du(b)},fu=Ph.__gvizguard__?Sh(zha):function(a,b,c){a=cu(a);b=nt(a,b,Kja(c));return new du(b)},hu=Ph.__gvizguard__?Sh(Cha):function(a,b,c){cu(a)[$](new gu(b,c))},iu=Ph.__gvizguard__?Sh(Bha):function(a){return(a=a&&ei(a.getKey)&&a.getKey())?pt(a):!1},ju=Ph.__gvizguard__?Sh(Aha):function(a){var b=cu(a),b=qt(b);Ws(a.__eventTarget);a.__eventTarget=void 0;return b};
function cu(a){var b=a.__eventTarget;null==b&&(b=new rt,a.__eventTarget=b);return a=b}function Kja(a){return function(b){b&&b.wra?a(b.Mda):a()}}function du(a){this.Osa=a}du[K].getKey=function(){return this.Osa};function gu(a,b){Xs[L](this,a);this.Mda=b}X(gu,Xs);gu[K].wra=function(){return this.Mda};function ku(a){this.t=a;var b=[];a=a.H();for(var c=0;c<a;c++)b[C](c);this.Ib=b;this.Qr=!0;this.Or=null;this.a_=[];this.ax=!0}T=ku[K];T.Pa=function(){return this.t};function Lja(a){for(var b=[],c=a.t.M(),d=0;d<c;d++)b[C](d);a.Or=b;a.ax=!0}
T.yq=function(a){for(var b=this.t,c=Ij(Mja),d=0;d<a[J];d++){var e=a[d];if(di(e))Lo(b,e);else if(ai(e)){var f=e.sourceColumn,e=e.calc;if(bi(e)){if(!c||c&&!Ri(c,e))throw m('Unknown function "'+e+oe);null!=f&&Lo(b,f)}}else throw m("Invalid column input, expected either a number or an object.");}this.Ib=Qj(a);a=this.t;b=this.Ib;for(c=0;c<b[J];c++)if(d=b[c],ai(d)){if(f=d.role)e=d.properties||{},e.role=f,d.properties=e;f=d.sourceColumn;di(f)&&(Lo(a,f),d.calc=d.calc||Hha,ab(d,d[H]||a.D(f)))}this.ax=!0};
function Nja(a,b,c){if(Yh(b)){if(Qh(c))throw m("If the first parameter is an array, no second parameter is expected");for(var d=0;d<b[J];d++)No(a.t,b[d]);return Yi(b)}if(Vh(b)==Yg){if(!Vh(c)==Yg)throw m("If first parameter is a number, second parameter must be specified and be a number.");if(b>c)throw m("The first parameter (min) must be smaller than or equal to the second parameter (max).");No(a.t,b);No(a.t,c);a=[];for(d=b;d<=c;d++)a[C](d);return a}throw m("First parameter must be a number or an array.");
}T.qn=function(a,b){this.Or=Nja(this,a,b);this.Qr=!1;this.ax=!0};T.N9=function(){return Qj(this.Ib)};T.oca=function(){if(this.Qr){for(var a=[],b=this.t.M(),c=0;c<b;c++)a[C](c);return a}return Yi(this.Or)};T.Ksa=function(a){this.yq(Fi(this.Ib,function(b){return!Ri(a,b)}));this.ax=!0};T.Lsa=function(a,b){var c=Nja(this,a,b);this.Qr&&(Lja(this),this.Qr=!1);this.qn(Fi(this.Or,function(a){return!Ri(c,a)}));this.ax=!0};
T.Daa=function(a){for(var b=0;b<this.Ib[J];b++){var c=this.Ib[b];if(c==a||ai(c)&&c.sourceColumn==a)return b}return-1};T.Isa=function(a){return this.Qr?0>a||a>=this.t.M()?-1:a:Ci(this.Or,a)};T.jF=function(a){Lo(this,a);a=this.Ib[a];return di(a)?a:ai(a)&&di(a.sourceColumn)?a.sourceColumn:-1};T.sR=function(a){a=this.jF(a);return-1==a?a:a=this.t.sR(a)};T.cn=function(a){No(this,a);return this.Qr?a:this.Or[a]};T.pR=function(a){a=this.cn(a);return a=this.t.pR(a)};
T.M=function(){return this.Qr?this.t.M():this.Or[J]};T.H=function(){return this.Ib[J]};T.jf=function(a){Lo(this,a);a=this.Ib[a];return di(a)?this.t.jf(a):a.id||O};xa(T,function(a){for(var b=0;b<this.Ib[J];b++){var c=this.Ib[b];if(ai(c)&&c.id==a)return b}a=this.t[Qp](a);return this.Daa(a)});T.cb=function(a){Lo(this,a);a=this.Ib[a];return di(a)?this.t.cb(a):a[Rc]||O};T.ju=function(a){Lo(this,a);a=this.Ib[a];return di(a)?this.t.ju(a):null};T.Ss=function(a){a=this.Li(a,ih);return a=bi(a)?a:O};
T.D=function(a){Lo(this,a);a=this.Ib[a];return di(a)?this.t.D(a):a[H]};
T.Pr=function(a,b){Lo(this,b);var c=this.Ib[b],d=null,e=this.cn(a);if(ai(c)){if(this.ax){for(c=0;c<this.Ib[J];c++)ai(this.Ib[c])&&(this.a_[c]=[]);this.ax=!1}c=this.a_[b][e];if(!Qh(c)){var c=null,d=this.Ib[b],f=d.calc;bi(f)?(f=Mja[f],c=f(this.t,e,d)):ei(f)&&(c=f[L](null,this.t,e));c=Yfa(c);d=d[H];f=c.v;if(mi(d))throw m('"type" must be specified');if(!aga(f,d))throw m(qba+f+baa+d);this.a_[b][e]=c}d=c;d.p=ai(d.p)?d.p:{}}else if(di(c))d={v:this.t[I](e,c),f:null,p:null};else throw m("Invalid column definition: "+
d);return d};fb(T,function(a,b){return this.Pr(a,b).v});T.Aa=function(a,b){var c=this.Pr(a,b);if(null==c.f){var d=this.Ib[b];if(ai(d))d=this.D(b),c.f=null!=c.v?Po(c.v,d):O;else if(di(d)){var e=this.cn(a);c.f=this.t.Aa(e,d)}}return c.f};T.Ao=function(a,b,c){a=this.sm(a,b)[c];return Qh(a)?a:null};T.sm=function(a,b){var c=this.Pr(a,b);if(!c.p){var c=this.cn(a),d=this.jF(b);return this.t.sm(c,d)}return c.p};T.Li=function(a,b){Lo(this,a);var c=this.Ib[a];return di(c)?this.t.Li(c,b):this.Sq(a)[b]||null};
T.Sq=function(a){Lo(this,a);a=this.Ib[a];return di(a)?this.t.Sq(a):a.properties||{}};T.uR=function(a){return this.t.uR(a)};T.Mx=function(){return this.t.Mx()};T.Yq=function(a,b){var c=this.cn(a);return this.t.Yq(c,b)};T.mJ=function(a){No(this,a);a=this.cn(a);return this.t.mJ(a)};T.qp=function(a){return bga(this,a)};T.QR=function(a){return dga(this,a)};T.Co=function(a){return cga(this,a)};T.WJ=function(a){return fga(this,a)};
T.ww=function(){var a=this.t;ei(a.ww)&&(a=a.ww());var a=a.Ir(),b=this.H(),c=this.M(),d,e,f,g=[],k=[];for(d=0;d<b;d++){f=this.Ib[d];if(ai(f))e=Pj(f),delete e.calc,delete e.sourceColumn;else if(di(f))e=a[Nb][f];else throw m(Sga);g[C](e)}for(e=0;e<c;e++){var l=a[Kc][this.Qr?e:this.Or[e]],n=[];for(d=0;d<b;d++){f=this.Ib[d];if(ai(f))f={v:this[I](e,d)};else if(di(f))f=l.c[this.Ib[d]];else throw m(Sga);n[C](f)}l.c=n;k[C](l)}a.cols=g;a.rows=k;return a=new Ko(a)};
T.Ir=function(){for(var a={},b=[],c=0;c<this.Ib[J];c++){var d=this.Ib[c];ai(d)&&!bi(d.calc)||b[C](d)}Si(b)||(a.columns=b);this.Qr||(a.rows=Yi(this.Or));return a};Fa(T,function(){return io(this.Ir())});function lu(a,b){bi(b)&&(b=lo(b));var c=new ku(a),d=b.columns,e=b[Kc];null!=d&&c.yq(d);null!=e&&c.qn(e);return c}
var Mja={emptyString:function(){return O},error:function(a,b,c){var d=c.sourceColumn,e=c.magnitude;if(!di(d)||!di(e))return null;a=a[I](b,d);return di(a)?c.errorType==Rha?a+e/100*a:a+e:null},stringify:function(a,b,c){c=c.sourceColumn;return di(c)?a.Aa(b,c):O},fillFromTop:function(a,b,c){c=c.sourceColumn;return di(c)?hga(a,b,c,!0):null},fillFromBottom:function(a,b,c){c=c.sourceColumn;return di(c)?hga(a,b,c,!1):null},identity:function(a,b,c){c=c.sourceColumn;return di(c)?a[I](b,c):null}};function mu(a,b,c){this.QN=a;this.m=b;a=Cl(b);a!=O&&a!=qh||zl(b,eh,gh);this.hJ=null;c&&(this.hJ=Rk(Q,{style:Sha}))}function Oja(a){return a.hJ?(a.hJ[fe]!=a.m&&a.m[p](a.hJ),a.hJ):a.m}mu[K].td=function(a){Pja(this,a,Nr)};function nu(a,b){Pja(a,b,Ms)}function Pja(a,b,c){var d=Oja(a);c={removable:!0,type:c};b={id:Ss.td(d,b,null,c),message:b,detailedMessage:O,options:c};hu(a.QN,Nr,b)}mu[K].oc=function(){var a=Oja(this);Ss.oc(a)};function ou(a,b,c){try{b[L](c)}catch(d){a.td(d[aq])}};function Qja(a){this.yc=a;this.LR=!1}Qja[K].$pa=function(a,b){return W(function(){if(!this.LR){var c=arguments;ou(this.yc,function(){a[Mc](b,c)})}},this)};function pu(a){this.lb=ao(a);this.tu=new mu(this,this.lb);this.Tu=null}X(pu,Us);pu[K].ac=function(){return this.lb};Ep(pu[K],function(a,b,c){ou(this.tu,W(function(){this.We(a,b,c)},this))});pu[K].We=function(a,b,c){if(!a)throw m("Data table is not defined.");if(!ei(a.Mx))throw b=gia,Yh(a)?b=iha:bi(a)&&(b=gha),m("You called the draw() method with "+b+" rather than a DataTable or DataView");this.Tu&&(this.Tu.LR=!0);this.Tu=new Qja(this.tu);var d=W(this.Tu.$pa,this.Tu);this.Ym(d,a,b,c)};
pu[K].Yf=function(){this.Tu&&(this.Tu.LR=!0,this.Tu=null);this.Wg()};function qu(a,b,c,d){this.lj=a;this.QN=b;this.b=c||{};this.m=d;this.yc=null;d&&(this.yc=this.VY=via(d));if(!(b&&rha in b&&typeof b[Nq]==Bg))throw m("Visualization must have a draw method.");}T=qu[K];T.VY=null;T.JC=null;T.fJ=null;T.t=null;op(T,function(a){this.b=a||{}});Ep(T,function(){this.t&&this.QN[Nq](this.t,this.b)});T.Wsa=function(a){var b=this.m;this.yc=a?a:b?this.yc=this.VY:null};
T.xC=function(){if(!this.yc)throw m("If no container was supplied, a custom error handler must be supplied instead.");var a=this;this.lj[Kp](function(b){var c=a.JC;c&&c(b);a.aD(b);(c=a.fJ)&&c(b)})};T.aD=function(a){var b=this.yc;b(a)&&(this.t=a.Pa(),this.QN[Nq](this.t,this.b))};T.yR=function(a){if(null!=a){if(typeof a!=Bg)throw m(Oga);this.JC=a}};T.xR=function(a){if(null!=a){if(typeof a!=Bg)throw m("Custom post response handler must be a function.");this.fJ=a}};Bp(T,function(){this.lj[Iq]()});function ru(a,b){this.Qe=b;this.kqa=a}hp(ru[K],function(a){this.xu=a;this.ct()});ru[K].ct=function(){var a;a=this.Qe;var b={},c,d=this.nI;d&&(c=aia+d);c&&(b.tqx=c,a=Fja(a,b));this.kqa[L](this,W(this.aD,this),a)};ru[K].aD=function(a){a=new Qs(a);if(!uia(a)){this.nI=a.Ni()?null:a.Z_;var b=this.xu;b[L](b,a)}};function su(){this.Xp=this.Ec=0;this.Fa=[]}function tu(a){if(a.Ec!=a.Xp){var b=a.Fa[a.Ec];delete a.Fa[a.Ec];a.Ec++;return b}}T=su[K];T.zO=function(){return this.Ec==this.Xp?void 0:this.Fa[this.Ec]};T.Lc=function(){return this.Xp-this.Ec};Ua(T,function(){return 0==this.Xp-this.Ec});wa(T,function(){jb(this.Fa,0);this.Xp=this.Ec=0});Pa(T,function(a){return Ri(this.Fa,a)});va(T,function(a){a=Ci(this.Fa,a);if(0>a)return!1;a==this.Ec?tu(this):(Bi[he][L](this.Fa,a,1),this.Xp--);return!0});
T.La=function(){return this.Fa[dd](this.Ec,this.Xp)};function uu(){if(!Sh(vha))throw m("your page is missing the google maps API");this.YC=new google[bq].Geocoder;this.Ad={};this.Ad[Tm({address:O})]={response:[],status:google[bq].GeocoderStatus.ZERO_RESULTS};this.Um=new ck;this.Bu=new Uj;this.mC=new su}Uh(uu);function vu(a,b,c){this.os=a||[];this.NJ=0;this.Yr=b;this.UQ=!1;this.gS=new Uj;this.Jpa=c||this.os[J]}up(vu[K],function(){this.UQ=!0});
vu[K].finish=function(a,b){var c=Tm(a);this.gS.$e(c)||this.gS.set(c,b);c=[];if(!this.UQ){for(var d=h.min(this.NJ+this.Jpa,this.os[J]),e=this.NJ;e<d;e++){var f=Tm(this.os[e]);if(!this.gS.$e(f))return;f=this.gS.get(f);null!=f&&(f=f.response);c[C](f)}this.NJ+=c[J];this.Yr(c);this.NJ>=this.os[J]&&this[pq]()}};function wu(){this.os=[];this.YC=null}wu[K].add=function(a){this.os[C](a)};
wu[K].create=function(a,b,c){if(null!=this.YC){var d=new vu(a,b,c);this.add(d);this.YC.geocode(d)}else wfa(W(function(){null==this.YC&&(this.YC=uu.Xb());this[Up](a,b,c)},this))};up(wu[K],function(){Y(this.os,function(a){a[pq]()});this.os=[]});uu[K].geocode=function(a){Y(a.os,W(function(b){var c=Tm(b);if(c in this.Ad)a.finish(b,this.Ad[c]);else{if(!this.Bu.$e(c)){var d=this.mC;d.Fa[d.Xp++]=b;this.Bu.set(c,[])}this.Bu.get(c)[C](a)}},this));this.eba()};
uu[K].eba=function(){if(0!==this.mC.Lc()||0!==this.Um.Lc()){var a=0<this.Um.Lc()?eo(this.Um.La()[0]):this.mC.zO(),b=Tm(a);if(b in this.Ad){var c=this.Bu.get(b),c=this.Ad[b];tu(this.mC);this.rR(a,c.response,c.status);this.Bu[Ob](b)}else 0===this.Um.Lc()&&0<this.mC.Lc()?(tu(this.mC),c=this.Bu.get(b),Ni(c,function(a){return a.UQ})?this.rR(a,null,null):(this.Um.add(b),Rja(this,a,W(this.rR,this,a)))):0<this.Um.Lc()&&Rja(this,a,W(this.rR,this,a))}};
function Rja(a,b,c){if(ai(b)&&(b=Qj(b),b[Sp])){var d=b[Sp];b.bounds=new google[bq][Xp](new google[bq][Op](d.lo.lat,d.lo.lng),new google[bq][Op](d.hi.lat,d.hi.lng))}a.YC.geocode(b,c)}function Sja(a,b,c){var d=Tm(b),e=a.Bu.get(d);null!=e&&Y(e,function(a){a.UQ||a.finish(b,c)});a.Um[Ob](d);a.Bu[Ob](d)}
uu[K].rR=function(a,b,c){var d=0;if(c==google[bq].GeocoderStatus.OVER_QUERY_LIMIT)d=520;else if(c==google[bq].GeocoderStatus.OK){var e=Tm(a);b={response:b,status:c};this.Ad[e]=b;Sja(this,a,b)}else Sja(this,a,null);this.LR=!1;ut(W(this.eba,this),d,this)};function xu(){}function yu(a){if(!(ai(a)&&ei(a.H)&&ei(a.M)))throw m("Invalid data table.");}T=xu[K];T.Ij=function(a){return this.Lb(a)?2:0};T.Ua=function(a,b,c){return a.H()>b&&c==a.D(b)};function Tja(a,b,c,d){for(var e=0;e<d[J];e++)if(a.Ua(b,c,d[e]))return!0;return!1}T.indexOf=function(a,b){for(var c=0;c<a.H();c++)if(a.D(c)==b)return c;return-1};function zu(a,b,c){for(var d=0;d<b[J];++d){var e=b[d];if(e>=a.H()||a.D(e)!=c[d])return!1}return!0}
function Au(a,b,c){return a.Ua(b,c,Yg)?Bu(b,c,function(a){return 0<=a}):!1}function Bu(a,b,c){for(var d=h.min(a.M(),20),e=0;e<d;e++){var f=a[I](e,b);if(null!=f&&!c(f))return!1}return!0}T.tna=function(a){return Bm(new zm(-90,90),a)&&!wj(a)};T.una=function(a){return Bm(new zm(-180,180),a)&&!wj(a)};function Uja(a){for(var b=a.QR(0),c=h.min(a.M(),20),d=0,e=0;e<c;e++){var f=a[I](e,1);f&&!Ri(b,f)||d++}return 0.6<d/c};function Cu(){}X(Cu,xu);Cu[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};Cu[K].xd=function(a){yu(a);var b=a.H();if(2>b)throw m("Invalid data table format: must have at least 2 columns.");for(var c=!0,d=[],e=0;e<b;e++){var f=a.Ss(e);li(f)&&(c?(f=Lr,c=!1):f=Jr);d[C](f)}if(d[0]!==Lr)throw m("Invalid data format: first column must be domain.");a=Vja(d);return{Ng:a.Ng,fw:Gi(a.Df,function(a){return{gm:a.Af,Ng:a.Ng,k:Gi(a.Df,function(a){return{RK:a.Af,Ng:a.Ng}})}})}};
function Vja(a){for(var b=[Lr,Jr],c={Df:[],Ng:{}},d=[c],e=-1,f=0;f<a[J];f++){var g=a[f],k=Ci(b,g),l=null;0<=k&&(l={Af:f,Iv:g,Df:[],Ng:{}});if(0<=k&&k<e){e-=k;for(g=0;g<=e;g++)d.pop();e=k;k=d[d[J]-1];d[C](l);k.Df[C](l)}else 0<=e&&g===b[e]?(d.pop(),k=d[d[J]-1],d[C](l),k.Df[C](l)):e+1<b[J]&&g===b[e+1]?(k=d[d[J]-1],e++,d[C](l),k.Df[C](l)):(k=d[d[J]-1],g in k.Ng||(k.Ng[g]=[]),k.Ng[g][C](f))}return c};function Du(){}X(Du,xu);Du[K].Lb=function(a){yu(a);var b=a.H();if(2>b)return!1;var c=a.D(0);if(c!=og&&c!=pg||a.D(1)!=Yg)return!1;for(var c=0,d=1;d<b;d++){var e=a.D(d);if(e==Yg)c=0;else if(e==rh){if(c++,2<c)return!1}else return!1}return!0};Du[K].Ij=function(a){if(!this.Lb(a))return 0;var b=!1,c=0<this[ld](a,rh),b=a.M(),d=a.Co(0);if(50<b)b=!0;else{for(var e=ia[Jp],f=ia.MIN_VALUE,g=1;g<b;g++)var k=h.abs(a[I](d[g-1],0)-a[I](d[g],0)),e=0<k&&k<e?k:e,f=k>f?k:f;b=0!=e&&50<f/e?!0:!1}return c&&b?3:c||b?2:1};function Eu(a){this.C$=!!(a||{}).Ida}X(Eu,xu);Eu[K].Lb=function(a){yu(a);var b=0,c=a.H();if(1>c)return!1;if(!this.Ua(a,0,Yg)&&(b++,this.C$))for(;b<c&&this.Ua(a,b,rh);)b++;for(var d=null;b<c;){var e=a.D(b);if(e==Yg)d={};else if(this.C$&&e==rh){if(!d)return!1}else if(e==jg){if(!d||d.Qv)return!1;d.Qv=b}else return!1;b++}return null!==d};function Fu(a){this.GO=a&&a.Dd||!1;Eu[L](this,a)}X(Fu,Eu);Fu[K].Lb=function(a){yu(a);if(!Fu.e.Lb[L](this,a))return!1;var b=a.H();if(this.GO)for(var c=1;c<b;c++)if(this.Ua(a,c,Yg)&&!Au(this,a,c))return!1;return!0};Fu[K].Ij=function(a){for(var b=a.H(),c=a.M(),d=0,e=!1,f=0;f<b;f++)this.Ua(a,f,Yg)&&(d++,Au(this,a,f)||(e=!0));return this.Lb(a)?1==c||e||this.Ua(a,0,rh)?1:2<d&&this.GO?3:1!=d||this.GO?1:2:0};function Gu(){}X(Gu,xu);Gu[K].Lb=function(a){yu(a);var b=a.H();return 3>b||5<b||!this.Ua(a,0,rh)||!this.Ua(a,1,Yg)||!this.Ua(a,2,Yg)||3<b&&!this.Ua(a,3,rh)||4<b&&!this.Ua(a,4,Yg)?!1:!0};Gu[K].Ij=function(a){if(this.Lb(a)){var b;if(this.Ua(a,3,rh)){b={};for(var c=0,d=h.min(a.M(),20),e=0;e<d;e++){var f=a[I](e,3);b[f]||c++;b[f]=!0}b=10>c}else b=!1;a=b?3:this.Ua(a,3,rh)?1:2}else a=0;return a};function Hu(){}X(Hu,xu);Hu[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};Hu[K].xd=function(a){yu(a);var b=a.H();if(2!==b&&3!==b)throw m("Invalid data table format: must have 2 or 3 columns.");var c=1,d=2;2===b&&(c--,d--);this.Db(a,0,rh);this.Db(a,c,rh);this.Db(a,d,Yg);return{vt:c,zja:0,oB:d}};Hu[K].Db=function(a,b,c){if(!this.Ua(a,b,c))throw m(mr+b+Pq+c+Qq);};function Iu(a){this.Jm=a;this.b8=new Uj}np(Iu[K],function(){return this.Jm});function Ju(){}X(Ju,xu);Ju[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};Ju[K].xd=function(a){yu(a);for(var b=[],c=a.H(),d=0;d<c;++d){var e=a.Ss(d);if(e===O)b[C](new Iu(d));else{if(1>b[J])throw m("At least 1 data column must come before any role column.");Ai(b).b8.set(e,d)}}if(2!=b[J])throw m("Invalid data table format: must have 2 data columns.");c=b[0];b=b[1];this.Db(a,c[nc](),nha);this.Db(a,b[nc](),Yg);return{yX:c,oB:b}};
Ju[K].Db=function(a,b,c){if(!Mi(c[pc](Ps),function(c){return this.Ua(a,b,c)},this))throw m(mr+b+Pq+c+Qq);};function Ku(){}X(Ku,xu);Ku[K].Lb=function(a){yu(a);var b=a.H();if(5>b||6<b||!(this.Ua(a,0,rh)&&this.Ua(a,1,Yg)&&this.Ua(a,2,Yg)&&this.Ua(a,3,Yg)&&this.Ua(a,4,Yg))||6==b&&!this.Ua(a,5,rh))return!1;for(var b=h.min(a.M(),20),c=0;c<b;c++){var d=a[I](c,1),e=a[I](c,2),f=a[I](c,3),g=a[I](c,4);if(d!=h.min(d,e,f,g)||g!=h.max(d,e,f,g))return!1}return!0};Ku[K].Ij=function(a){return this.Lb(a)?3:0};function Lu(){Eu[L](this)}X(Lu,Eu);Lu[K].Ij=function(a){var b=this.Ua(a,0,Yg),c=a.H();b||c--;return this.Lb(a)?2>c?1:2:0};function Mu(){this.Lr=null}X(Mu,xu);Mu[K].Lb=function(a){return!!Wja(this,a)};Mu[K].xd=function(a){a=Wja(this,a);if(null!=a)return a;throw m(this.Lr);};function Wja(a,b){var c=new Iu(0),d=new Iu(1),e=new Iu(2),f=new Iu(3),g=new Iu(4),k=new Iu(5),l=new Iu(6);return a.Db(b,c[nc](),rh)&&a.Db(b,d[nc](),rh)&&a.Db(b,e[nc](),og)&&a.Db(b,f[nc](),og)&&a.Db(b,g[nc](),Yg)&&a.Db(b,k[nc](),Yg)&&a.Db(b,l[nc](),rh)?{zpa:c,vt:d,OF:e,NF:f,vpa:g,Apa:k,upa:l}:null}
Mu[K].Db=function(a,b,c){return this.Ua(a,b,c)?!0:(this.Lr=mr+b+Pq+c+Qq,!1)};function Nu(){}X(Nu,xu);Nu[K].Lb=function(a){yu(a);var b;b=a.H();if(1>b||2<b)b=!1;else{var c=!0;2==b&&(c=c&&this.Ua(a,0,rh));b=c=c&&Au(this,a,b-1)}if(!b)if(b=a.H(),c=a.M(),0==b||1!=c)b=!1;else{for(var c=!0,d=0;d<b;d++)if(!this.Ua(a,d,Yg)){c=!1;break}b=c}return b};Nu[K].Ij=function(a){return this.Lb(a)?1<a.M()?2:3:0};function Ou(){}X(Ou,xu);var Xja={Zva:ys,uva:cs,TEXT:Es,Oda:eg};Ou[K].Lb=function(a){var b=a.H();if(1>b||2<b)return!1;var c=this.Ua(a,0,rh);2==b&&(c=c&&this.Ua(a,1,Yg));return c};Ou[K].Ij=function(a){return this.Lb(a)?1:0};
Ou[K].xd=function(a,b,c){try{b=b||eg;var d=0,e,f=-1,g=-1,k=-1,l=-1;if(zu(a,[d,d+1],[Yg,Yg])){e=Yr;k=d;l=d+1;d+=2;if(b===ys)throw m("displayMode must be set to Markers when using lat/long addresses.");b===eg&&(b=cs)}else if(zu(a,[d],[rh])){switch(b){case eg:e=xs;b=ys;f=d;break;case ys:e=xs;f=d;break;case cs:case Es:e=Br;g=d;break;default:throw m("Unknown displayMode: "+b);}d+=1}else throw m("Unknown address type.");var n=null;zu(a,[d],[rh])&&Hs!=a.Li(d,ih)&&(n=d++);var q=null,s=null;zu(a,[d],[Yg])&&
(q=d++,zu(a,[d],[Yg])&&(s=d++));var u=null;zu(a,[d],[rh])&&Hs==a.Li(d,ih)&&(u=d++);e!=xs&&null!=q&&null==s&&(s=q);if(a.H()!=d)throw m("Table contains more columns than expected (Expecting "+d+" columns)");return{xX:e,a3:b,pG:f,qG:g,FA:k,HA:l,RG:n,xt:q,YA:s,rY:u}}catch(w){return c&&c.td(Rga+w),null}};function Pu(){}X(Pu,xu);Pu[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};Pu[K].xd=function(a){yu(a);if(5!=a.H())throw m("Invalid data table format: must have 5 columns.");this.Db(a,0,Yg);this.Db(a,1,Yg);this.Db(a,2,Yg);this.Db(a,3,Yg);this.Db(a,4,rh);return{Tga:0,Uga:1,Sga:2,Kta:3,Rga:4}};Pu[K].Db=function(a,b,c){if(!this.Ua(a,b,c))throw m(mr+b+Pq+c+Qq);};function Qu(a){Eu[L](this,a)}X(Qu,Eu);Qu[K].Lb=function(a){yu(a);if(!Qu.e.Lb[L](this,a))return!1;var b=a.H();if(this.GO)for(var c=1;c<b;c++)if(this.Ua(a,c,Yg)&&!Au(this,a,c))return!1;return!0};Qu[K].Ij=function(a){for(var b=a.H(),c=a.M(),d=0,e=0,f=0;f<b;f++)this.Ua(a,f,Yg)?d++:this.Ua(a,f,og)&&e++;return this.Lb(a)?10>c?1:2>d&&0==e?3:2:0};function Ru(){}X(Ru,xu);Ru[K].Lb=function(a){return Yja(this,a)||Zja(this,a)};Ru[K].Ij=function(a){var b=Yja(this,a);a=Zja(this,a);return b||a?a?1:3:0};function Yja(a,b){yu(b);var c=b.H();if(2>c||3<c)return!1;var d=a.Ua(b,0,Yg),d=d&&a.Ua(b,1,Yg);3==c&&(d=d&&a.Ua(b,2,rh));if(c=d)a.Ua(b,0,Yg)&&a.Ua(b,1,Yg)?(c=W(a.tna,a),d=W(a.una,a),c=Bu(b,0,c)&&Bu(b,1,d)):c=!1;return c}function Zja(a,b){yu(b);var c=b.H();return 1>c||2<c||!a.Ua(b,0,rh)||2==c&&!a.Ua(b,1,rh)?!1:!0};function Su(){}X(Su,xu);Su[K].Lb=function(a){yu(a);var b=a.H();if(3>b||a.D(0)!=rh)return!1;var c=a.D(1);if(c!=Yg&&c!=og&&c!=rh||c==rh&&!$ja(a)&&!aka(a)||c==Yg&&!Bu(a,1,function(a){return wj(a)}))return!1;for(c=2;c<b;c++){var d=a.D(c);if(d!=Yg&&d!=rh)return!1}return!0};Su[K].Ij=function(a){return this.Lb(a)?this.Ua(a,1,Yg)&&!bka(a)?1:3:0};function bka(a){return Bu(a,1,function(a){return 1900<a&&2100>a})}
function $ja(a){return Bu(a,1,function(a){return 7!=a[J]||ga(a[ae](0,3))||a[Bb](4)!=Qf||ga(a[ae](6,7))?!1:!0})}function aka(a){return Bu(a,1,function(a){return 6!=a[J]||ga(a[ae](0,3))||a[Bb](4)!=Af||ga(a[Bb](5))?!1:!0})};function Tu(){}X(Tu,xu);Tu[K].Lb=function(a){yu(a);var b=a.H();if(2>b||3<b)return!1;var c=this.Ua(a,0,rh)&&this.Ua(a,1,rh);3==b&&(c=c&&this.Ua(a,2,rh));return c&&Uja(a)};Tu[K].Ij=function(a){return this.Lb(a)?3:0};function $u(){}X($u,xu);$u[K].Lb=function(a){yu(a);var b=a.H();if(1>b||2<b)return!1;var c=this.Ua(a,b-1,Yg);return c=c&&Au(this,a,b-1)};$u[K].Ij=function(a){if(this.Lb(a))if(1==a.M())a=1;else{var b;if(!(b=!this.Ua(a,0,rh))&&!(b=25<a.M())){for(var c=b=0;c<a.M();c++)b+=a[I](c,1);b=!(97<b&&103>b||0.97<b&&1.03>b)}a=b?2:3}else a=0;return a};function av(){}X(av,xu);av[K].Lb=function(a){yu(a);var b=a.H();if(0==b)return!1;for(var c=this.Ua(a,0,rh)?1:0,d=b>c;c<b;c++)if(!this.Ua(a,c,Yg)){d=!1;break}return d};function bv(){}X(bv,xu);bv[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};
bv[K].xd=function(a){if(Yh(a)){var b=a[0];a=a[1];var c=b.H();if(3!==c)throw m("Invalid linkTable format: must have 3 columns.");this.Db(Zr,b,0,Yg);this.Db(Zr,b,1,Yg);this.Db(Zr,b,2,Yg);c=a.H();if(1!==c&&2!==c)throw m("Invalid nodeTable format: must have 1 or 2 columns.");this.Db(Nha,a,0,rh);2===c&&this.Db(Nha,a,1,rh);for(var d=[],e=[],f=0,g=b.M();f<g;++f){var k=b[I](f,0),l=b[I](f,1),n=b[I](f,2);e[C]({source:k,target:l,value:n})}f=0;for(g=a.M();f<g;++f)d[C]({name:a[I](f,0),jb:2===c?a[I](f,1):O});return{links:e,
nodes:d}}yu(a);if(3!==a.H())throw m(Tga);this.Db(Kr,a,0,rh);this.Db(Kr,a,1,rh);this.Db(Kr,a,2,Yg);b=new Uj;c=[];d=[];e=0;for(f=a.M();e<f;++e)g=cka(b,c,a[I](e,0)),k=cka(b,c,a[I](e,1)),l=a[I](e,2),d[C]({source:g,target:k,value:l});return{links:d,nodes:c}};function cka(a,b,c){if(a.$e(c))return a.get(c);a.set(c,b[J]);b[C]({name:c,jb:O});return b[J]-1}bv[K].Db=function(a,b,c,d){if(!this.Ua(b,c,d))throw m("Invalid format in "+a+": column #"+c+Pq+d+Qq);};function cv(){}X(cv,xu);cv[K].Lb=function(a){yu(a);var b=a.H();if(2>b||this.Ua(a,0,jg)||this.Ua(a,0,rh))return!1;for(var c=1,d=0,e=0;c<b;){var f=a.D(c);if(f==Yg)d++,e=0;else if(f==jg){if(e++,0==d||1<e)return!1}else return!1;c++}return 0<d};function dv(){}X(dv,xu);dv[K].Lb=function(a){yu(a);for(var b=!0,c=a.H(),d=0;d<c;d++)if(!this.Ua(a,d,Yg)){b=!1;break}return b};dv[K].Ij=function(a){return this.Lb(a)?2>a.H()?1:2:0};function ev(){}X(ev,xu);ev[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};ev[K].xd=function(a){yu(a);var b=a.H();if(1>b)throw m("Invalid data table format: must have at least 1 column.");this.Db(a,0,og);for(var c=[],d=1;d<b;d++)this.Db(a,d,Yg),c[C](d);return{yX:0,rja:c}};ev[K].Db=function(a,b,c){if(!this.Ua(a,b,c))throw m(mr+b+Pq+c+Qq);};function fv(){}X(fv,xu);fv[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};fv[K].xd=function(a){yu(a);if(3!=a.H())throw m(Tga);this.Db(a,0,rh);this.Db(a,1,Yg);this.Db(a,2,rh);return{vt:0,rka:2,oB:1}};fv[K].Db=function(a,b,c){if(!this.Ua(a,b,c))throw m(mr+b+Pq+c+Qq);};function gv(){}X(gv,xu);gv[K].Lb=function(){return!0};function hv(a){this.b=a||new jn([])}X(hv,xu);var dka=[og,Yg,pg];hv[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};
hv[K].xd=function(a){yu(a);for(var b=[],c=a.H(),d=0;d<c;++d){var e=a.Ss(d);if(e===O)b[C]({index:d,Ng:{}});else{if(1>b[J])throw m("At least 1 data column must come before any role columns");Ai(b).Ng[e]=d}}c=b[J];if(3!==c&&4!==c)throw m("Invalid data table format: must have 3 or 4 data columns.");d=4==c;this.Db(a,b[0][nc],rh);d&&this.Db(a,b[1][nc],rh);this.Db(a,b[d?2:1][nc],dka);this.Db(a,b[d?3:2][nc],dka);return 4===c?(a=!pn(this.b,hia,!0),{vt:b[a?1:0],lA:b[a?0:1],OF:b[2],NF:b[3]}):{vt:b[0],lA:null,
OF:b[1],NF:b[2]}};hv[K].Db=function(a,b,c){Yh(c)||(c=[c]);if(!Tja(this,a,b,c))throw m(mr+b+Pq+c+Qq);};function iv(){}X(iv,xu);iv[K].Lb=function(a){try{this.xd(a)}catch(b){return!1}return!0};iv[K].xd=function(a){yu(a);if(2>a.H())throw m("Invalid data table format: must have 2 columns.");this.Db(a,0,og);this.Db(a,1,Yg);return{Qta:0,Rta:1}};iv[K].Db=function(a,b,c){Yh(c)||(c=[c]);if(!Tja(this,a,b,c))throw m(mr+b+Pq+c+Qq);};function jv(){}X(jv,xu);jv[K].Lb=function(a){yu(a);var b=a.H();if(2>b||4<b)return!1;var c=this.Ua(a,0,rh)&&this.Ua(a,1,rh);2<b&&(c=c&&Au(this,a,2))&&3<b&&(c=c&&this.Ua(a,3,Yg));return c&&Uja(a)};jv[K].Ij=function(a){return this.Lb(a)?3:0};function kv(a){this.xk=Yh(a)?a:Hj(eka)}kv[K].kU=function(a){var b=[];Dj(this.xk,function(c){var d=fka[c],e=d&&d[Kb];e&&(e=e.Ij(a),0!=e&&b[C]({type:c,Hca:e,oe:d.oe}))});gka(b);return Gi(b,function(a){return a[H]})};function gka(a){dj(a,function(a,c){var d=a.Hca-c.Hca;0==d&&(d=a.oe-c.oe);return-d})}
var eka={hua:$q,Gra:ar,nua:cr,yua:dr,Aua:er,Iua:fr,Kra:gr,Wua:hr,Xua:ir,Wra:jr,bva:kr,cva:lr,Gva:pr,Xra:nr,Tva:sr,tva:or,Lva:qr,$ra:tr,kwa:br,nwa:ur,l5:vr,vwa:wr,xwa:xr,gsa:yr},fka={AnnotatedTimeLine:{format:new Du,oe:3},AreaChart:{format:new Fu({Ida:!0}),oe:2},BarChart:{format:new Eu,oe:2},BubbleChart:{format:new Gu,oe:2},CandlestickChart:{format:new Ku,oe:2},ColumnChart:{format:new Eu,oe:2},ComboChart:{format:new Lu,oe:2},Gauge:{format:new Nu,oe:1},GeoChart:{format:new Ou,oe:3},Histogram:{format:new Qu,
oe:3},LineChart:{format:new Eu({Ida:!0}),oe:2},ImageRadarChart:{format:new av,oe:1},ImageSparkLine:{format:new dv,oe:1},Map:{format:new Ru,oe:2},MotionChart:{format:new Su,oe:3},OrgChart:{format:new Tu,oe:2},PieChart:{format:new $u,oe:2},ScatterChart:{format:new cv,oe:2},"AreaChart-stacked":{format:new Fu({Dd:!0}),oe:2},SteppedAreaChart:{format:new Fu,oe:2},Table:{format:new gv,oe:0},Timeline:{format:new hv,oe:2},TreeMap:{format:new jv,oe:2},WordTree:{format:new Ou,oe:2}};V("google.visualization.ChartSelection",kv,void 0);kv[K].calculateChartTypes=kv[K].kU;var hka={AnnotatedTimeLine:Cr,AnnotationChart:"annotationchart",AreaChart:Ir,BarChart:Ir,BubbleChart:Ir,CandlestickChart:Ir,ColumnChart:Ir,ComboChart:Ir,Gauge:Qr,GeoChart:Rr,GeoMap:"geomap",Histogram:Ir,ImageAreaChart:"imageareachart",ImageBarChart:"imagebarchart",ImageCandlestickChart:"imagechart",ImageChart:"imagechart",ImageLineChart:"imagelinechart",ImagePieChart:"imagepiechart",ImageSparkLine:Ur,IntensityMap:"intensitymap",LineChart:Ir,Map:bs,MotionChart:ds,OrgChart:us,PieChart:Ir,RangeSelector:Ir,
ScatterChart:Ir,SparklineChart:Ir,SteppedAreaChart:Ir,Table:Ds,Timeline:Gs,TreeMap:Is,StringFilter:Hr,DateRangeFilter:Hr,NumberRangeFilter:Hr,CategoryFilter:Hr,ChartRangeFilter:Hr,NumberRangeSetter:Hr,ColumnSelector:Hr,Dashboard:Hr};function lv(a,b){var c=a.useFormatFromData;ci(c)&&!c||!mi(a[Kb])||(b=Fi(b,function(a){return!mi(a)}),Bda(b),1==b[J]&&(c=ika(b[0]),ua(a,c)))}function ika(a){mi(a)||(a=a[vb](/\d/g,Oe),a=a[vb](/#{10,}/,ti(qe,10)));return a};function jka(a){var b=kka(a),c=new ku(a);c.yq([0,1,{type:Yg,calc:function(c,e){var f=mv(a,e);return null!=f?b.gJ*f.x+b.coa:null}}]);return c}function kka(a){var b;b=a.M();for(var c=new sk,d=0;d<b;d++){var e=mv(a,d);null!=e&&(c.x+=e.x,c.y+=e.y)}b=new sk(c.x/b,c.y/b);for(e=d=c=0;e<a.M();e++){var f=mv(a,e);null!=f&&(f=new sk(f.x-b.x,f.y-b.y),c+=f.x*f.y,d+=f.x*f.x)}a={};a.gJ=c/d||1;a.coa=b.y-a.gJ*b.x;return a}function mv(a,b){var c=a[I](b,0),d=a[I](b,1);return null==c||null==d?null:new sk(c,d)};function lka(a){var b=a.Vb(),c=a.Pa();a=a.Vc();var d;t:if(d=a.useFormatFromData,ci(d)&&!d)d=!1;else{d=[Ls,fia,dia,eia,qha];for(var e=0;e<d[J];e++)if(Sh(d[e]+Sq,a)){d=!1;break t}d=!0}if(d)if(b==dr)3>c.H()||(b=c.ju(1),d=a.hAxis||{},lv(d,[b]),a.hAxis=d,c=c.ju(2),b=a.vAxes||{},d=b[0]||{},lv(d,[c]),b[0]=d,a.vAxes=b);else{d=a.vAxes||[{},{}];for(var e=a.hAxis||{},f=d[0]||{},g=d[1]||{},k=[],l=[],n=c&&c.H()||0,q=0;q<n;q++)if(c.D(q)==Yg){var s=c.ju(q),u;u=q;0==u?u=null:(u--,u=((a.series||{})[u]||{}).targetAxisIndex||
0);switch(u){case 0:k[C](s);break;case 1:l[C](s)}}b==cr?lv(e,k):(lv(f,k),lv(g,l));0<n&&c.D(0)!=rh&&(b=b==cr?f:e,s=c.ju(0),lv(b,[s]));d[0]=f;d[1]=g;a.vAxes=d;a.hAxis=e}}function mka(a){if(a[cq](Ar)){var b=a.Pa();a.Vb()==tr&&2==b.H()&&(b=jka(b),a.jg(b),a.K(Yha,2),a.K(Zha,0),a.K($ha,!1));a.K(Ar,null)}}function nka(a){var b=a.Pa(),c=a.In;if(Yh(c))for(var d=0;d<c[J];d++)b=lu(b,c[d]);else null!=c&&(b=lu(b,c));a.PB(null);a.jg(b)}
function oka(a){var b=a.Vb();if((hka[b]||null)==Ir&&b!=tr){var b=a.Pa(),c=a[cq](Sr);if(null!=c){for(var d=[{calc:c?bia:sha,sourceColumn:0,type:rh}],e=b.H(),c=c?1:0;c<e;c++)d[C](c);b=new ku(b);b.yq(d);a.K(Sr,null);a.jg(b)}}};function nv(a,b){var c=b||{};bi(c)&&(c=lo(c));this.$F=c.containerId||null;this.fM=a;this.rg=c[a+cha]||null;this.Oh=c[a+Yga]||null;this.wA=null;Cp(this,null);this.hN=null;this.Qe=c.dataSourceUrl||null;this.t=null;this.jg(c.dataTable);this.b=c[eq]||{};this.n=c[dq]||{};var d=c.packages;this.xM=Qh(d)?d:null;this.lj=c.query||null;this.cl=c.refreshInterval||null;this.In=c[Lq]||null;this.FE=null;this.r6=[nka,oka,lka,mka];this.l7=c.isDefaultVisualization||!Qh(c.isDefaultVisualization)}X(nv,Us);T=nv[K];
T.saa=null;T.pS=null;T.m=null;T.o=function(){var a=new this[rc](this[Wp]());a.FE=this.FE;return a};T.w=function(){this[Wb]();nv.e.w[L](this)};wa(T,function(){ov(this)});
Ep(T,function(a){a=Hk(a||O);if(!Sk(a)){var b=this.$F;a=Hk(b);if(!Sk(a))throw m("The container #"+b+" is null or not defined.");}this.m=a;try{if(null==this.Vb())throw m("The "+this.fM+" type is not defined.");if(bo(this.Vb()))this.O$(a);else{var c=W(this.O$,this,a),c=Ss.UP(c,W(this.Ip,this,a)),d=this.xM;if(null==d){var e=this.Vb(),e=e[vb](mca,O),d=hka[e]||null;if(null==d)throw m("Invalid visualization type: "+e);}bi(d)&&(d=[d]);var d={packages:d,callback:c},f=Sh(pca);null===f&&(f=vaa);d=d?d:{callback:Th};
d.callback=d.callback||Th;var g,e=null,k=Sh(wha);k&&0<=gm(k,0,Dha,k[xc](hm))&&(e=im(k,Dha));(g=e)&&!d.language&&(d.language=g);sfa(rfa.Xb(),f,d)}}catch(l){this.Ip(a,l)}});Fa(T,function(){return io(pka(this,this.Pa()))});T.Ir=function(){return pka(this,this.saa||this.Pa())};
function pka(a,b){var c=a.xM,d=void 0;null===b||(d=ei(b.ww)?b.ww().Ir():b.Ir());c={containerId:a.$F||void 0,dataSourceUrl:a.Qe||void 0,dataTable:d,options:a.Vc()||void 0,state:a[hq]()||void 0,packages:null===c?void 0:c,refreshInterval:a.cl||void 0,query:a.On()||void 0,view:a.In||void 0,isDefaultVisualization:a.Waa()};c[a.fM+cha]=a.Vb()||void 0;c[a.fM+Yga]=a[Lp]()||void 0;a.Vaa(c);return c}T.Vaa=function(){};T.CS=function(){return this.Qe};T.Pa=function(){return this.t};T.Vb=function(){return this.rg};
ip(T,function(){return this.Oh});T.N2=function(){return this[Md]};T.zS=function(){return this.$F};T.On=function(){return this.lj};T.DS=function(){return this.cl};pp(T,function(a,b){return pv(this.b,a,b)});function pv(a,b,c){a=-1==b[ld](Me)?a[b]:Sh(b,a);c=Qh(c)?c:null;return null!=a?a:c}T.Vc=function(){return this.b};sp(T,function(){return this.n});T.Waa=function(){return this.l7};T.qi=function(a){this.Qe=a};T.Xsa=function(a){this.FE=a};T.Dsa=function(){return this.FE};T.jg=function(a){this.t=Wfa(a)};
T.Du=function(a){this.rg=a};T.An=function(a){this.Oh=a};T.HS=function(a){this.$F=a};T.fk=function(a){this.lj=a};T.Vm=function(a){this.cl=a};T.K=function(a,b){qka(this.b,a,b)};function qka(a,b,c){null==c?Wh(pv(a,b))||(c=b[pc](Me),1<c[J]&&(b=c.pop(),a=pv(a,c[ie](Me))),delete a[b]):V(b,c,a)}op(T,function(a){this.b=a||{}});T.setProperty=function(a,b){var c=a[pc](Me);if(0<c[J]){var d=c[rb]();if(d=rka[d])if(0===c[J])d.set[Mc](this,b);else d=d.get[Mc](this),qka(d,c[ie](Me),b)}};
T.vc=function(a){this.n=a||{}};T.gI=function(a){this.xM=a};T.PB=function(a){this.In=a};T.ita=function(a){a!=this[Md]&&(this.hN=a)};T.R3=function(a){this.l7=a};T.$Q=function(){return new this[rc](this.Ir())};T.FS=function(){return this.In};T.K2=function(){return this.xM};T.Ip=function(a,b){var c=b&&b[aq]||Nr,d=Ss.td(a,c);hu(this,Nr,{id:d,message:c})};
T.PP=function(a,b){var c=bo(this.Vb());if(!c)throw m("Invalid "+this.fM+" type: "+this.Vb());this.hN&&(ov(this),Cp(this,this.hN),this.hN=null);var d;if(d=this[Md])if(d=this[Md][rc]==c)d=(d=this[Md])&&ei(d.ac)?d.ac()==a:!1;d?c=this[Md]:(ov(this),c=new c(a));this.wA&&this.wA!=c&&ei(this.wA.Yf)&&this.wA.Yf();this.wA=c;ska(this,c);this.saa=b;d=hn(this.Vc());d=new qv({chartType:this.Vb(),dataTable:b,options:d,view:this.In});for(var e=0;e<this.r6[J];e++)this.r6[e](d);c[Nq](d.Pa(),d.Vc(),this[hq]())};
T.Psa=function(a){Yh(this.In)?this.In[C](a):this.In=null===this.In?[a]:[this.In,a]};T.Toa=function(a,b){if(b.Ni()){var c=b.fI(),d=b.I0(),e=Ss.TB(a,b);hu(this,Nr,{id:e,message:c,detailedMessage:d})}else this.PP(a,b.Pa())};function ska(a,b){tka(a);var c=[];Y([ws,As,Nr,Cs],function(d){var e=eu(b,d,function(c){d==ws&&(a.wA=null,Cp(a,b));d!=ws&&d!=Cs||!ei(b[hq])||a.vc(b[hq][L](b));hu(a,d,c)});c[C](e)});a.pS=c}
T.O$=function(a){var b=this.Pa();if(b)this.PP(a,b);else if(null!=this.Qe)b=W(this.Toa,this,a),b=Ss.UP(b,W(this.Ip,this,a)),this.KQ(b,!0);else throw m("Cannot draw chart: no data specified.");};T.KQ=function(a,b){var c=ci(b)?b:!1,d=new St(this.Qe||O),e=this.cl;e&&c&&d.Vm(e);(c=this.On())&&d.fk(c);d[Kp](a)};function ov(a){a[Md]&&ei(a[Md].Yf)&&a[Md].Yf();Ws(a[Md]);Cp(a,null)}function tka(a){Yh(a.pS)&&(Y(a.pS,function(a){iu(a)}),a.pS=null)}
var rka={name:{get:nv[K][Lp],set:nv[K].An},type:{get:nv[K].Vb,set:nv[K].Du},containerId:{get:nv[K].zS,set:nv[K].HS},options:{get:nv[K].Vc,set:nv[K][$p]},state:{get:nv[K][hq],set:nv[K].vc},dataSourceUrl:{get:nv[K].CS,set:nv[K].qi},dataTable:{get:nv[K].Pa,set:nv[K].jg},refreshInterval:{get:nv[K].DS,set:nv[K].Vm},query:{get:nv[K].On,set:nv[K].fk},view:{get:nv[K].FS,set:nv[K].PB}};function qv(a){nv[L](this,Er,a)}X(qv,nv);T=qv[K];T.Sd=nv[K].N2;T.xL=nv[K].ita;T.Gd=nv[K].Du;T.Ya=nv[K].Vb;T.oW=nv[K].An;
T.nW=nv[K][Lp];function rv(a){nv[L](this,lha,a)}X(rv,nv);T=rv[K];T.eR=nv[K].N2;T.Vsa=nv[K].Du;T.Csa=nv[K].Vb;T.Usa=nv[K].An;T.Bsa=nv[K][Lp];function sv(a){this.Td=a;this.Yd={}}X(sv,Us);var uka=[];T=sv[K];T.l=function(a,b,c,d){return tv(this,a,b,c,d)};function uv(a,b,c,d,e){tv(a,b,c,d,!1,e)}function tv(a,b,c,d,e,f){Yh(c)||(c&&(uka[0]=c[hc]()),c=uka);for(var g=0;g<c[J];g++){var k=kt(b,c[g],d||a[Pp],e||!1,f||a.Td||a);if(!k)break;a.Yd[k.key]=k}return a}T.sB=function(a,b,c,d){return vka(this,a,b,c,d)};
function vka(a,b,c,d,e,f){if(Yh(c))for(var g=0;g<c[J];g++)vka(a,b,c[g],d,e,f);else{b=nt(b,c,d||a[Pp],e,f||a.Td||a);if(!b)return a;a.Yd[b.key]=b}return a}T.uc=function(a,b,c,d,e){if(Yh(b))for(var f=0;f<b[J];f++)this.uc(a,b[f],c,d,e);else c=c||this[Pp],e=e||this.Td||this,c=lt(c),d=!!d,b=dt(a)?a.yJ(b,c,d,e):a?(a=mt(a))?a.yJ(b,c,d,e):null:null,b&&(pt(b),delete this.Yd[b.key]);return this};T.oc=function(){Dj(this.Yd,pt);this.Yd={}};T.w=function(){sv.e.w[L](this);this.oc()};
kp(T,function(){throw m("EventHandler.handleEvent not implemented");});function vv(a){this.m=a;this.C=new sv(this)}X(vv,Us);T=vv[K];T.w=function(){this[Wb]();vv.e.w[L](this)};wa(T,function(){this.C.oc();Ws(this.C);Wk(this.m)});T.ac=function(){return this.m};T.addEventListener=function(a,b,c,d,e){e?tv(this.C,a,b,c,d,e):this.C.l(a,b,c,d)};Ep(T,function(){});sp(T,function(){return{}});function wv(a){this.m=ao(a);this.yc=new mu(this,this.m);this.yaa=[]}X(wv,Us);T=wv[K];T.w=function(){this[Wb]();wv.e.w[L](this)};wa(T,function(){wka(this)});T.xa=null;T.lz=null;T.b=null;T.Mc=null;T.XG=null;T.$W=null;T.n=null;T.Ut=null;T.Pa=function(){return this.xa};T.Vc=function(){return this.b};T.uj=function(){return{}};T.$k=function(a,b){return In(b,Js,{})};T.Ar=function(){return O};T.Rba=function(a){this.yaa=a};T.sP=function(){return this.yaa};T.zp=function(){};
sp(T,function(){return this.n?lo(io(this.n)):null});Ep(T,function(a,b,c){this.xa=a;this.lz=b||{};this.$W=c||{};ou(this.yc,this.wz,this)});
T.wz=function(){if(this.xa){this.n=this.$W||{};if(!ai(this.n))throw m("Control state must be an object.");this.Ut=this.Ut||this.n;this.b=new jn([this.lz,this.uj()||{}]);this.zp(this.xa,this.b,this.n);wka(this);var a=zn(this.b,kia,this.Ar());this.Mc=(a=bo(a))?new a(this.m):null;if(!this.Mc)throw m("Invalid Ui instance.");this.XG=eu(this.Mc,Ks,W(this.uia,this));this.Mc[Nq](this.n,this.$k(this.xa,this.b));this.n=this.Mc[hq]();hu(this,ws,null)}};
function wka(a){a.XG&&(iu(a.XG),Ws(a.XG),a.XG=null);Ws(a.Mc);a.Mc=null;Wk(a.m)}T.uia=function(a){this.n=this.Mc[hq]();hu(this,Cs,a)};T.zs=function(){ou(this.yc,this.mqa,this)};T.mqa=function(){this.Ut&&(this.$W=this.Ut,this.wz())};function xv(){this.Vg=new Uj;this.ts=new Uj;this.Iu=new Uj}function xka(a,b,c){yka(a,b,c)||(a.Vg.set(yv(b),b),a.Vg.set(yv(c),c),zka(b,c,a.ts),zka(c,b,a.Iu))}T=xv[K];wa(T,function(){this.Vg[Wb]();this.ts[Wb]();this.Iu[Wb]()});Ua(T,function(){return this.Vg[$c]()});T.Lc=function(){return this.Vg.Lc()};T.La=function(){return this.Vg.La()};Pa(T,function(a){return this.Vg.$e(yv(a))});function yka(a,b,c){b=yv(b);return a.ts.$e(b)&&a.ts.get(b)[Lc](yv(c))}
function zv(a,b){if(!a[Lc](b))return null;var c=a.Iu.get(yv(b));return c?Yda(c,function(a){return this.Vg.get(a)},a):null}T.$f=function(a){return this[Lc](a)?(a=this.ts.get(yv(a)))?Yda(a,function(a){return this.Vg.get(a)},this):null:null};function Av(a){if(a.Vg[$c]())return[];var b=[];bk(a.ts,function(a,d){this.Iu.$e(d)||b[C](this.Vg.get(d))},a);if(0==b[J])throw m("Invalid state: DAG has not root node(s).");return b}
function Aka(a){for(var b=Bka(a.Iu),c=[],d=Gi(Av(a),function(a){return yv(a)},a);0<d[J];){for(var e=[],f=0;f<d[J];f++){var g=d[f];c[C](a.Vg.get(g));var k=a.ts.get(g);k&&bk(k,function(a){b.get(a)[Ob](g);b.get(a)[$c]()&&(b[Ob](a),e[C](a))})}d=e}if(c[J]!=a.Vg.Lc())throw m("cycle detected");}T.o=function(){return this[$c]()?new xv:xv[K].tR[Mc](this,Av(this))};T.tR=function(a){var b=new xv;if(0==arguments[J])return b;for(var c=0;c<arguments[J];c++)Cka(this,arguments[c],b);return b};
function Cka(a,b,c){var d=a.$f(b);d&&bk(d,function(a){xka(c,b,a);Cka(this,a,c)},a)}function yv(a){var b=typeof a;return b==$g&&a||b==Bg?Zg+fi(a):b[ec](0,1)+a}function zka(a,b,c){var d=c.get(yv(a));d||(d=new ck,c.set(yv(a),d));d.add(yv(b))}function Dka(a,b,c){var d=c.get(yv(a));d[Ob](yv(b));d[$c]()&&c[Ob](yv(a))}function Eka(a,b){return!a.ts.$e(yv(b))&&!a.Iu.$e(yv(b))}function Bka(a){var b=new Uj;bk(a,function(a,d){b.set(d,a.o())});return b};function Bv(a){this.Yg=new xv;this.kR=null;this.xJ=[];this.yc=new mu(this,a);this.Tm=null}X(Bv,Us);T=Bv[K];T.w=function(){this[Wb]();Bv.e.w[L](this)};wa(T,function(){Y(this.xJ,function(a){iu(a)});this.xJ=[];this.Tm=null;this.Yg[Wb]()});T.Ip=function(a){this.yc.td(a)};
lp(T,function(a,b){if(Fka(a))if(Gka(b)){var c=fi(a);if(fi(b)==c)this.Ip(Mga);else{c=[];this.Yg[Lc](a)||c[C](a);this.Yg[Lc](b)||c[C](b);xka(this.Yg,a,b);var d;try{Aka(this.Yg),d=!0}catch(e){d=!1}d?d=!0:(this.Ip(aha),d=!1);if(d)for(d=0;d<c[J];d++)this.xJ[C](eu(c[d],Cs,W(this.ypa,this,c[d]))),this.xJ[C](eu(c[d],ws,W(this.xpa,this,c[d]))),this.xJ[C](eu(c[d],Nr,W(this.wpa,this,c[d])));else c=this.Yg,yka(c,a,b)&&(Dka(a,b,c.ts),Dka(b,a,c.Iu),Eka(c,a)&&c.Vg[Ob](yv(a)),Eka(c,b)&&c.Vg[Ob](yv(b)))}}else this.Ip(b+
tga);else this.Ip(a+vga)});Ep(T,function(a){if(a&&!this.Yg[$c]()){this.kR=Wfa(a);this.Tm=new Cv(this);a=Av(this.Yg);for(var b=0;b<a[J];b++)a[b].jg(this.kR);this.Tm[y](a)}});function Gka(a){return ai(a)&&ei(a[Nq])&&ei(a.setDataTable)}function Fka(a){return Gka(a)&&ei(a.getControl)}T.ypa=function(a){this.Tm=this.Tm||new Cv(this);Hka(this.Tm,a)};
T.xpa=function(a){var b;if(b=Fka(a)){b=a.eR();var c;if(c=ai(b)){if(ei(b.applyOperator))t:{b=this.Yg;c=b.tR(a);for(var d=c.La(),e=0;e<d[J];e++){var f=d[e];if(f!=a&&zv(c,f)[J]!=zv(b,f)[J]){b=!1;break t}}b=!0}else b=ei(b[Mc]);c=b}b=!c}b?this.Ip(a+uga):(this.Tm=this.Tm||new Cv(this),Hka(this.Tm,a))};T.wpa=function(a){this.Tm&&this.Tm.handleError(a)};function Ika(a,b){b?hu(a,ws,null):a.Ip(Zga);a.Tm=null}
function Jka(a,b){if(1==b[J])return b[0];for(var c=b[0],d=$i(b,1),e=new ck(Kka(a,d[0])),f=1;f<d[J]&&(e=e.Ky(Kka(a,d[f])),!e[$c]());f++);for(var f=[],g=0;g<c.M();g++)e[Lc](Lka(a,c,g))&&f[C](g);e=new ck(Mka(a,d[0]));for(g=1;g<d[J]&&(e=e.Ky(Mka(a,d[g])),!e[$c]());g++);d=[];for(g=0;g<c.H();g++)e[Lc](Nka(a,c,g))&&d[C](g);c=new ku(c);c.qn(f);c.yq(d);return c}function Kka(a,b){for(var c=[],d=0;d<b.M();d++){var e=Lka(a,b,d);null!=e&&c[C](e)}return c}
function Lka(a,b,c){for(;b!==a.kR;)c=b.cn(c),b=b.Pa();return c}function Mka(a,b){for(var c=[],d=0;d<b.H();d++){var e=Nka(a,b,d);null!=e&&c[C](e)}return c}function Nka(a,b,c){for(;b!==a.kR&&-1!==c;)c=b.jF(c),b=b.Pa();-1==c&&(c=null);return c}function Cv(a){this.xr=a;this.Yg=a.Yg.o();this.Qp={};a=this.Yg.La();for(var b=0;b<a[J];b++)this.Qp[fi(a[b])]=ws}La(Cv[K],function(a){Cv[K].Jca[Mc](this,a);for(var b=0;b<a[J];b++)this.We(a[b])});
function Hka(a,b){if(a.Yg[Lc](b)){switch(a.Qp[fi(b)]){case vs:break;case Nr:break;case Mr:a.Qp[fi(b)]=ws;Oka(a,b);break;case ws:a.Jca(b);Oka(a,b);break;default:fi(b)}Pka(a)}}Cv[K].handleError=function(a){if(this.Yg[Lc](a)){switch(this.Qp[fi(a)]){case vs:case ws:case Nr:break;case Mr:this.Qp[fi(a)]=Nr;a=this.Yg.tR(a).La();for(var b=1;b<a[J];b++)this.Qp[fi(a[b])]=Nr;break;default:fi(a)}Pka(this)}};
function Pka(a){var b=0;Rda(a.Qp,function(a){if(a==Nr)b++;else if(a!=ws)return!1;return!0},a)&&Ika(a.xr,0==b)}Cv[K].Jca=function(a){for(var b=xv[K].tR[Mc](this.Yg,arguments),c=b.La(),d=0;d<c[J];d++){var e=b,f=c[d];if(!e[Lc](f)||e.Iu.$e(yv(f)))this.Qp[fi(c[d])]=vs}};Cv[K].We=function(a){this.Qp[fi(a)]=Mr;var b=Ss.UP(function(){a[Nq]()},W(this.handleError,this,a));ut(b)};
function Oka(a,b){var c=a.Yg.$f(b);if(c){var d=b.eR();d.Rba&&d.Rba(c);for(d=0;d<c[J];d++){var e=c[d],f;t:{f=a;var g=zv(f.Yg,e);if(g)for(var k=0;k<g[J];k++)if(f.Qp[fi(g[k])]!=ws){f=!1;break t}f=!0}f&&(f=Qka(a,e),e.jg(f),a.We(e))}}}function Qka(a,b){var c=Gi(zv(a.Yg,b),function(a){a=a.eR();if(ei(a[Mc]))return a[Mc][L](a)});return Jka(a.xr,c)};function Dv(a){this.m=a;this.xr=new Bv(a);Ws(this.hY);this.hY=eu(this.xr,ws,W(this.Gaa,this,ws));Ws(this.gY);this.gY=eu(this.xr,Nr,W(this.Gaa,this,Nr))}X(Dv,Us);T=Dv[K];T.w=function(){this[Wb]();Ws(this.hY);Ws(this.gY);Ws(this.xr);Dv.e.w[L](this)};wa(T,function(){iu(this.hY);iu(this.gY);this.xr[Wb]()});lp(T,function(a,b){Yh(a)||(a=[a]);Yh(b)||(b=[b]);for(var c=0;c<a[J];c++)for(var d=0;d<b[J];d++)this.xr[Zb](a[c],b[d]);return this});Ep(T,function(a){this.xr[Nq](a)});T.ac=function(){return this.m};
T.Gaa=function(a,b){hu(this,a,b||null)};function Ev(a){nv[L](this,mha,a);a=a||{};bi(a)&&(a=lo(a));this.Vp=a.wrappers||null;this.kC=a.bindings||null;this.Du(a.dashboardType||Pga);Fv(this)}X(Ev,nv);T=Ev[K];T.PP=function(a,b){function c(a){return f[a]}Ws(this[Md]);a=ao(a);for(var d=new Dv(a),e=this.kC||[],f=this.Vp,g=e[J],k=0;k<g;k++){var l=Gi(e[k].controls,c),n=Gi(e[k].participants,c);d[Zb](l,n)}Cp(this,d);Ev.e.PP[L](this,a,b)};T.Vaa=function(a){a.wrappers=this.Vp?Gi(this.Vp,function(a){return a[Wp]()}):void 0;a.bindings=this.kC||void 0};
T.jta=function(a){this.Vp=a||null;Fv(this)};T.Jsa=function(){return this.Vp};T.Ssa=function(a){this.kC=a||null;Fv(this)};T.xsa=function(){return this.kC};T.Esa=nv[K].N2;T.Zsa=nv[K].An;T.Fsa=nv[K][Lp];function Fv(a){var b=a.Vp;if(null!==b&&!Yh(b)){var c=[];Dj(b,function(a,b){ei(a[Wp])||(a=Gv(a));a.An(b);c[C](a)},a);b=c}var d=a.kC;Hv(b)&&Hv(d)||(a.Vp=Gi(b,a.q_,a),a.kC=Gi(d,a.lqa,a))}T.q_=function(a){ei(a[Wp])||(a=Gv(a));a.jg(null);a.qi(null);return a};
T.lqa=function(a){var b=a.controls,c=a.participants;if(Hv(b)||Hv(c))throw m("invalid binding: "+a);b=Gi(b,this.Yda,this);c=Gi(c,this.Yda,this);return{controls:b,participants:c}};T.Yda=function(a){var b=a,c=/^{.*}$/;if(ai(a)||bi(a)&&c[bd](a))return ei(b[Wp])||(b=Gv(b)),this.Vp[C](b),this.Vp[J]-1;a=Rka(this);a=mi(b)?-1:Ci(a,b);if(-1==a)throw m("Invalid wrapper name: "+b);return a};function Rka(a){return Gi(a.Vp,function(a){return a[Lp]()})}function Hv(a){return Yh(a)?Si(a):!0};function Iv(a,b){Gv(a)[Nq](b)}function Gv(a){a=a||{};bi(a)&&(a=lo(a));return a.controlType?new rv(a):a.dashboardType?new Ev(a):new qv(a)};function Jv(a,b,c){var d=b.D(c),e=b.jf(c),f=b.cb(c),d=a.mg(d,f,e);a.paa(d,b.Sq(c))}function Kv(a){for(var b=0,c=0;c<a[J];c++)b+=a[c];return b}function Ska(a){return a[J]}function Tka(a){return Kv(a)/a[J]}
function Lv(a,b,c){function d(a,b,c,d){return b[L](null,c[I](d,a))}var e=[],f=[];Y(b,function(a){if(di(a))e[C](a);else if(Vh(a)==$g){var b=a.column;Lha in a&&f[C]([b,{calc:gi(d,b,a.modifier),type:a[H],label:a[Rc],id:a.id}]);e[C](b)}});if(!Si(f)){for(var g=new ku(a),k=g.N9(),l=a.M(),n=0;n<l;n++)Y(f,function(a){k[a[0]]=a[1]});g.yq(k);a=g}var q=new Ko,s=[];Y(e,function(c,d){var e=a.D(c),f=b[d][Rc]||a.cb(c),g=null!=b[d].id?b[d].id:a.jf(c);q.mg(e,f,g);s[C](e)});c=c||[];Y(c,function(b){var c=b.column,d=
b[Rc]||a.cb(c),c=null!=b.id?b.id:a.jf(c);q.mg(b[H],d,c)});var u=[];Y(e,function(a){u[C]({column:a})});for(var w=a.Co(u),z=[],B=0;B<c[J];B++)z[C]([]);for(B=0;B<w[J];B++){Y(c,function(b,c){z[c][C](a[I](w[B],b.column))});g=!1;if(B<w[J]-1)for(g=!0,l=0;l<e[J];l++){var n=a[I](w[B],e[l]),F=a[I](w[B+1],e[l]);if(0!=Mo(s[l],n,F)){g=!1;break}}if(!g){var M=q.lq();Y(e,function(b,c){q.wa(M,c,a[I](w[B],b))});var N=b[J];Y(c,function(a,b){var c=a.aggregation[L](null,z[b]);q.wa(M,N+b,c)});for(g=0;g<c[J];g++)z[g]=[]}}return q}
;V("google.visualization.drawChart",Iv,void 0);V("google.visualization.drawFromUrl",function(a,b){var c=new Ct(b||fa[tc][Ic]),d=Lt(c,Wr),e;null!=d?e=d:(e={},Y(c.Oi.hk(),function(a){var b=Lt(c,a);try{null!=b&&(b=lo(b))}catch(d){}e[a]=b}),rp(e,Qj(e)));Iv(e,a)},void 0);
V("google.visualization.createUrl",function(a,b){bi(a)&&(a=lo(a));var c=[],d,e;for(e in a)if(e==Pha){var f=a[e],g;for(g in f)d=f[g],bi(d)||(d=io(d)),c[C](g+af+aa(String(d)))}else d=a[e],bi(d)||(d=ei(d[Wp])?d[Wp]():io(d)),c[C](e+af+aa(String(d)));d=Wn()+Ega;d=d[vb](/^https?:/,O);c=(b||d)+cf+c[ie](xe);c=c[vb](/'/g,zga);return c=c[vb](/"/g,yga)},void 0);
V("google.visualization.createSnippet",function(a){var b=Wn()+Fga,b=b[vb](/^https?:/,O),b=Lga+b+xga;a=Gv(a)[Wp]();a=a[vb](/</g,Be);a=a[vb](/>/g,Ae);return b=b+a+pga},void 0);V("google.visualization.createWrapper",Gv,void 0);V("google.visualization.ChartWrapper",qv,void 0);wa(qv[K],qv[K][Wb]);Ep(qv[K],qv[K][Nq]);qv[K].clone=qv[K].o;Fa(qv[K],qv[K][Wp]);qv[K].getSnapshot=qv[K].$Q;qv[K].getDataSourceUrl=qv[K].CS;qv[K].getDataTable=qv[K].Pa;qv[K].getChartName=qv[K].nW;qv[K].getChartType=qv[K].Ya;
qv[K].getChart=qv[K].Sd;qv[K].getContainerId=qv[K].zS;qv[K].getPackages=qv[K].K2;qv[K].getQuery=qv[K].On;qv[K].getRefreshInterval=qv[K].DS;qv[K].getView=qv[K].FS;pp(qv[K],qv[K][cq]);qv[K].getOptions=qv[K].Vc;sp(qv[K],qv[K][hq]);qv[K].getCustomRequestHandler=qv[K].Dsa;qv[K].isDefaultVisualization=qv[K].Waa;qv[K].pushView=qv[K].Psa;qv[K].sendQuery=qv[K].KQ;qv[K].setDataSourceUrl=qv[K].qi;qv[K].setDataTable=qv[K].jg;qv[K].setChart=qv[K].xL;qv[K].setChartName=qv[K].oW;qv[K].setChartType=qv[K].Gd;
qv[K].setContainerId=qv[K].HS;qv[K].setIsDefaultVisualization=qv[K].R3;qv[K].setPackages=qv[K].gI;qv[K].setQuery=qv[K].fk;qv[K].setRefreshInterval=qv[K].Vm;qv[K].setView=qv[K].PB;qv[K].setOption=qv[K].K;op(qv[K],qv[K][$p]);qv[K].setState=qv[K].vc;qv[K].setCustomRequestHandler=qv[K].Xsa;V("google.visualization.ControlWrapper",rv,void 0);wa(rv[K],rv[K][Wb]);Ep(rv[K],rv[K][Nq]);Fa(rv[K],rv[K][Wp]);rv[K].getSnapshot=rv[K].$Q;rv[K].getDataSourceUrl=rv[K].CS;rv[K].getDataTable=rv[K].Pa;
rv[K].getControlName=rv[K].Bsa;rv[K].getControlType=rv[K].Csa;rv[K].getControl=rv[K].eR;rv[K].getContainerId=rv[K].zS;rv[K].getPackages=rv[K].K2;rv[K].getQuery=rv[K].On;rv[K].getRefreshInterval=rv[K].DS;rv[K].getView=rv[K].FS;pp(rv[K],rv[K][cq]);rv[K].getOptions=rv[K].Vc;sp(rv[K],rv[K][hq]);rv[K].sendQuery=rv[K].KQ;rv[K].setDataSourceUrl=rv[K].qi;rv[K].setDataTable=rv[K].jg;rv[K].setControlName=rv[K].Usa;rv[K].setControlType=rv[K].Vsa;rv[K].setContainerId=rv[K].HS;rv[K].setPackages=rv[K].gI;
rv[K].setQuery=rv[K].fk;rv[K].setRefreshInterval=rv[K].Vm;rv[K].setView=rv[K].PB;rv[K].setOption=rv[K].K;op(rv[K],rv[K][$p]);rv[K].setState=rv[K].vc;V("google.visualization.DashboardWrapper",Ev,void 0);wa(Ev[K],Ev[K][Wb]);Ep(Ev[K],Ev[K][Nq]);Fa(Ev[K],Ev[K][Wp]);Ev[K].getBindings=Ev[K].xsa;Ev[K].getDataSourceUrl=Ev[K].CS;Ev[K].getDataTable=Ev[K].Pa;Ev[K].getDashboard=Ev[K].Esa;Ev[K].getDashboardName=Ev[K].Fsa;Ev[K].getContainerId=Ev[K].zS;Ev[K].getPackages=Ev[K].K2;Ev[K].getQuery=Ev[K].On;
Ev[K].getRefreshInterval=Ev[K].DS;Ev[K].getView=Ev[K].FS;Ev[K].getWrappers=Ev[K].Jsa;Ev[K].setBindings=Ev[K].Ssa;Ev[K].setDataSourceUrl=Ev[K].qi;Ev[K].setDataTable=Ev[K].jg;Ev[K].setDashboardName=Ev[K].Zsa;Ev[K].setContainerId=Ev[K].HS;Ev[K].setPackages=Ev[K].gI;Ev[K].setQuery=Ev[K].fk;Ev[K].setRefreshInterval=Ev[K].Vm;Ev[K].setView=Ev[K].PB;Ev[K].getSnapshot=Ev[K].$Q;Ev[K].setWrappers=Ev[K].jta;V("google.visualization.data.avg",Tka,void 0);V("google.visualization.data.count",Ska,void 0);V("google.visualization.data.group",Lv,void 0);
V("google.visualization.data.join",function(a,b,c,d,e,f){var g=c==Qg||c==Ag,k=c==zs||c==Ag,l=new Ko,n=[];Y(d,function(c){var d=a.D(c[0]),e=b.D(c[1]);if(d!=e)throw m("Key types do not match:"+d+Ke+e);Jv(l,a,c[0]);n[C](d)});var q=[],s=[];Y(d,function(a){q[C]({column:a[0]});s[C]({column:a[1]})});var u=a.Co(q),w=b.Co(s);Y(e,function(b){Jv(l,a,b)});Y(f,function(a){Jv(l,b,a)});for(var z=!1,B=0,F=0,M=0;B<u[J]||F<w[J];){var N=0,P=[];if(F>=w[J])if(g)P[0]=u[B],N=-1;else break;else if(B>=u[J])if(k)P[1]=w[F],
N=1;else break;else{P[0]=u[B];P[1]=w[F];for(var ba=0;ba<d[J];ba++){var N=a[I](P[0],d[ba][0]),U=b[I](P[1],d[ba][1]),N=Mo(n[ba],N,U);if(0!=N)break}}if(z&&0!=N)z=!1,F++;else{if(-1==N&&g||1==N&&k||0==N){l.lq();var qa,ya;-1==N&&g||0==N&&c!=zs?(qa=a,ya=0):(qa=b,ya=1);Y(d,function(a,b){c==Ag?l.wa(M,b,qa[I](P[ya],a[ya])):l.al(M,b,qa[I](P[ya],a[ya]),qa.Aa(P[ya],a[ya]),qa.sm(P[ya],a[ya]))});if(-1==N&&g||0==N){var Ha=d[J];Y(e,function(b,c){l.al(M,c+Ha,a[I](P[0],b),a.Aa(P[0],b),a.sm(P[0],b))})}if(1==N&&k||0==
N)Ha=e[J]+d[J],Y(f,function(a,c){l.al(M,c+Ha,b[I](P[1],a),b.Aa(P[1],a),b.sm(P[1],a))});M++}1==N?F++:B++;0==N&&(z=!0)}}return l},void 0);V("google.visualization.data.max",function(a){if(0==a[J])return null;for(var b=a[0],c=1;c<a[J];c++){var d=a[c];null!=d&&d>b&&(b=d)}return b},void 0);V("google.visualization.data.min",function(a){if(0==a[J])return null;for(var b=a[0],c=1;c<a[J];c++){var d=a[c];null!=d&&d<b&&(b=d)}return b},void 0);V("google.visualization.data.month",function(a){return a[Dd]()+1},void 0);
V("google.visualization.data.sum",Kv,void 0);V("__gvizguard__",!0,void 0);V(xha,St,void 0);St[K].makeRequest=St[K].makeRequest;St[K].setRefreshInterval=St[K].Vm;St[K].setQuery=St[K].fk;hp(St[K],St[K][Kp]);St[K].setRefreshable=St[K].eta;St[K].setTimeout=St[K][Yp];St[K].setHandlerType=St[K].ata;St[K].setHandlerParameter=St[K].Fda;St.setResponse=Wt;Bp(St[K],St[K][Iq]);V("google.visualization.CustomQuery",ru,void 0);hp(ru[K],ru[K][Kp]);V("google.visualization.QueryResponse",Qs,void 0);Qs[K].getDataTable=Qs[K].Pa;Qs[K].isError=Qs[K].Ni;
Qs[K].hasWarning=Qs[K].f1;Qs[K].getReasons=Qs[K].mca;Qs[K].getMessage=Qs[K].fI;Qs[K].getDetailedMessage=Qs[K].I0;V("google.visualization.DataTable",Ko,void 0);Ko[K].addColumn=Ko[K].mg;Ko[K].addRow=Ko[K].lq;Ko[K].addRows=Ko[K].Cz;Ko[K].clone=Ko[K].o;Ko[K].getColumnId=Ko[K].jf;xa(Ko[K],Ko[K][Qp]);Ko[K].getColumnLabel=Ko[K].cb;Ko[K].getColumnPattern=Ko[K].ju;Ko[K].getColumnProperty=Ko[K].Li;Ko[K].getColumnProperties=Ko[K].Sq;Ko[K].getColumnRange=Ko[K].qp;Ko[K].getColumnRole=Ko[K].Ss;
Ko[K].getColumnType=Ko[K].D;Ko[K].getDistinctValues=Ko[K].QR;Ko[K].getFilteredRows=Ko[K].WJ;Ko[K].getFormattedValue=Ko[K].Aa;Ko[K].getNumberOfColumns=Ko[K].H;Ko[K].getNumberOfRows=Ko[K].M;Ko[K].getProperties=Ko[K].sm;Ko[K].getProperty=Ko[K].Ao;Ko[K].getRowProperty=Ko[K].Yq;Ko[K].getRowProperties=Ko[K].mJ;Ko[K].getSortedRows=Ko[K].Co;Ko[K].getTableProperty=Ko[K].uR;Ko[K].getTableProperties=Ko[K].Mx;Ko[K].getUnderlyingTableColumnIndex=Ko[K].sR;Ko[K].getUnderlyingTableRowIndex=Ko[K].pR;fb(Ko[K],Ko[K][I]);
Ko[K].insertColumn=Ko[K].jda;Ko[K].insertRows=Ko[K].sY;Ko[K].removeColumn=Ko[K].a2;Ko[K].removeColumns=Ko[K].gea;Ko[K].removeRow=Ko[K].mB;Ko[K].removeRows=Ko[K].hea;Ko[K].setCell=Ko[K].al;Ko[K].setColumnLabel=Ko[K].Tsa;Ko[K].setColumnProperties=Ko[K].paa;Ko[K].setColumnProperty=Ko[K].Sv;Ko[K].setFormattedValue=Ko[K].uH;Ko[K].setProperties=Ko[K].kv;Ko[K].setProperty=Ko[K][Dc];Ko[K].setRowProperties=Ko[K].fta;Ko[K].setRowProperty=Ko[K].s4;Ko[K].setTableProperties=Ko[K].gta;Ko[K].setTableProperty=Ko[K].hta;
Ko[K].setValue=Ko[K].wa;nb(Ko[K],Ko[K][Zd]);Fa(Ko[K],Ko[K][Wp]);V("google.visualization.DataView",ku,void 0);ku.fromJSON=lu;ku[K].getColumnId=ku[K].jf;xa(ku[K],ku[K][Qp]);ku[K].getColumnLabel=ku[K].cb;ku[K].getColumnPattern=ku[K].ju;ku[K].getColumnProperty=ku[K].Li;ku[K].getColumnProperty=ku[K].Li;ku[K].getColumnProperties=ku[K].Sq;ku[K].getColumnRange=ku[K].qp;ku[K].getColumnRole=ku[K].Ss;ku[K].getColumnType=ku[K].D;ku[K].getDistinctValues=ku[K].QR;ku[K].getFilteredRows=ku[K].WJ;
ku[K].getFormattedValue=ku[K].Aa;ku[K].getNumberOfColumns=ku[K].H;ku[K].getNumberOfRows=ku[K].M;ku[K].getProperties=ku[K].sm;ku[K].getProperty=ku[K].Ao;ku[K].getRowProperty=ku[K].Yq;ku[K].getRowProperties=ku[K].mJ;ku[K].getSortedRows=ku[K].Co;ku[K].getTableColumnIndex=ku[K].jF;ku[K].getUnderlyingTableColumnIndex=ku[K].sR;ku[K].getTableRowIndex=ku[K].cn;ku[K].getUnderlyingTableRowIndex=ku[K].pR;ku[K].getTableProperty=ku[K].uR;ku[K].getTableProperties=ku[K].Mx;fb(ku[K],ku[K][I]);
ku[K].getViewColumnIndex=ku[K].Daa;ku[K].getViewColumns=ku[K].N9;ku[K].getViewRowIndex=ku[K].Isa;ku[K].getViewRows=ku[K].oca;ku[K].hideColumns=ku[K].Ksa;ku[K].hideRows=ku[K].Lsa;ku[K].setColumns=ku[K].yq;ku[K].setRows=ku[K].qn;ku[K].toDataTable=ku[K].ww;Fa(ku[K],ku[K][Wp]);V("google.visualization.errors",Ss,void 0);Ss.addError=Ss.td;Ss.removeAll=Ss.oc;Ss.removeError=Ss.Qsa;Ss.addErrorFromQueryResponse=Ss.TB;Ss.getContainer=Ss.ac;Ss.createProtectedCallback=Ss.UP;V(yha,eu,void 0);V(zha,fu,void 0);
V(Cha,hu,void 0);V(Bha,iu,void 0);V(Aha,ju,void 0);V("google.visualization.QueryWrapper",qu,void 0);op(qu[K],qu[K][$p]);Ep(qu[K],qu[K][Nq]);qu[K].setCustomErrorHandler=qu[K].Wsa;qu[K].sendAndDraw=qu[K].xC;qu[K].setCustomPostResponseHandler=qu[K].xR;qu[K].setCustomResponseHandler=qu[K].yR;Bp(qu[K],qu[K][Iq]);V("google.visualization.arrayToDataTable",Xfa,void 0);V("google.visualization.datautils.compareValues",Mo,void 0);
V("google.visualization.dataTableToCsv",function(a){for(var b=O,c=0;c<a.M();c++){for(var d=0;d<a.H();d++){0<d&&(b+=Je);var e=a.Aa(c,d),e=e[vb](/"/g,wga),f=-1!=e[ld](Je),g=-1!=e[ld](me),k=-1!=e[ld](oe);if(f||g||k)e=oe+e+oe;b+=e}b+=me}return b},void 0);V("google.visualization.GadgetHelper",au,void 0);au[K].createQueryFromPrefs=au[K].rsa;au[K].validateResponse=au[K].lta;;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



var Mv=unescape,Nv=escape,Ov=setTimeout,Pv=navigator;function Qv(a,b){return a.direction=b}function Rv(a,b){return a.filled=b}function Sv(a,b){return a.weight=b}function Tv(a,b){return a.collapse=b}function Uv(a,b){return a.selected=b}function Vv(a,b){return a.stroked=b}function Wv(a,b){return a.fillcolor=b}function Xv(a,b){return a.select=b}function Yv(a,b){return a.setRadius=b}function Zv(a,b){return a.setSelection=b}function $v(a,b){return a.depth=b}function aw(a,b){return a.refresh=b}
function bw(a,b){return a.items=b}function cw(a,b){return a.whiteSpace=b}function dw(a,b){return a.strokeweight=b}function ew(a,b){return a.fillStyle=b}function fw(a,b){return a.setVisible=b}function gw(a,b){return a.marginWidth=b}function hw(a,b){return a.cursor=b}function iw(a,b){return a.size=b}function jw(a,b){return a.setVisibleChartRange=b}function kw(a,b){return a.coordorigin=b}function lw(a,b){return a.style=b}function mw(a,b){return a.close=b}function nw(a,b){return a.ticks=b}
function ow(a,b){return a.parent=b}function pw(a,b){return a.getPosition=b}function qw(a,b){return a.isEnabled=b}function rw(a,b){return a.range=b}function sw(a,b){return a.marginHeight=b}function tw(a,b){return a.coordinates=b}function uw(a,b){return a.action=b}function vw(a,b){return a.reset=b}function ww(a,b){return a.startTime=b}function xw(a,b){return a.node=b}function yw(a,b){return a.root=b}function zw(a,b){return a.lineWidth=b}function Aw(a,b){return a.frameBorder=b}
function Bw(a,b){return a.text=b}function Cw(a,b){return a.annotations=b}function Dw(a,b){return a.createCaption=b}function Ew(a,b){return a.fontFamily=b}function Fw(a,b){return a.value=b}function Gw(a,b){return a.move=b}function Hw(a,b){return a.strokeStyle=b}function Iw(a,b){return a.strokecolor=b}function Jw(a,b){return a.radius=b}function Kw(a,b){return a.getHeight=b}function Lw(a,b){return a.scrolling=b}function Mw(a,b){return a.orientation=b}function Nw(a,b){return a.setContent=b}
function Ow(a,b){return a.getContent=b}function Pw(a,b){return a.visible=b}function Qw(a,b){return a.fontWeight=b}function Rw(a,b){return a.scrollTop=b}function Sw(a,b){return a.getColors=b}function Tw(a,b){return a.getSelection=b}function Uw(a,b){return a.disabled=b}function Vw(a,b){return a.textAlign=b}function Ww(a,b){return a.background=b}function Xw(a,b){return a.fontStyle=b}function Yw(a,b){return a.getId=b}function Zw(a,b){return a.anchor=b}function $w(a,b){return a.coords=b}
function ax(a,b){return a.coordsize=b}function bx(a,b){return a.setPosition=b}function cx(a,b){return a.element=b}function dx(a,b){return a.update=b}function ex(a,b){return a.transform=b}
var gx="origin",ix="order",jx="direction",kx="shape",lx="fillColor",mx="getParent",nx="center",ox="classList",px="selection",qx="inRange",rx="reverse",sx="extend",tx="layout",ux="selected",vx="collapsed",wx="insert",xx="interval",yx="geometry",zx="setEnd",Ax="strokeColor",Bx="registerElement",Cx="write",Dx="definition",Ex="fillText",Fx="focus",Gx="select",Hx="values",Vx="padding",Wx="elements",Xx="moveTo",Yx="setSelection",Zx="depth",$x="getBounds",ay="datum",by="offset",cy="items",dy="contentWindow",
ey="duplicate",fy="time",gy="caption",hy="setVisible",iy="cursor",jy="html",ky="views",ly="size",my="MapTypeId",ny="createElementNS",oy="setVisibleChartRange",py="handle",qy="save",ry="nodes",sy="rotate",ty="moveToElementText",uy="addListener",vy="close",wy="ticks",xy="parent",yy="dataType",zy="getPosition",Ay="isEnabled",By="range",Cy="multiple",Dy="fireEvent",Ey="coordinates",Fy="scale",Gy="restore",Hy="action",Iy="startTime",Jy="fillRect",Ky="attributes",Ly="node",My="compact",Ny="lineWidth",Oy=
"closePath",Py="isCollapsed",Qy="margin",Ry="lineTo",Sy="icon",Ty="replaceChild",Uy="annotations",Vy="getCenter",Wy="createCaption",Xy="blur",Yy="move",Zy="backgroundColor",$y="domain",az="updateOptions",bz="radius",cz="equals",dz="beginPath",ez="getHeight",fz="play",gz="path",hz="detach",iz="getContext",jz="translate",kz="LN10",lz="orientation",mz="setContent",nz="getContent",oz="visible",pz="setActive",qz="strokeRect",rz="frames",sz="setStart",tz="getColors",uz="title",vz="labels",wz="getSelection",
xz="duration",yz="scope",zz="rect",Az="then",Bz="alpha",Cz="Circle",Dz="background",Ez="entries",Fz="getId",Gz="anchor",Hz="moveEnd",Iz="coords",Jz="compareEndPoints",Kz="addColorStop",Lz="setPosition",Mz="element",Nz="contentDocument",Oz="axis",Pz="update",Qz="areas",Rz="append",Sz="transform",Tz="event",Uka="\n M/d",Vka="\n a",Wka="\n yyyy",Xka="\x0B",Yka=" (",Zka=" (count)",$ka=" * ",ala=" + ",Uz=" - ",bla=" - Flash Player Installation",cla=" / ",dla=" 0 ",ela=" = ",fla=" [+]",gla=" _loaded = true;",
hla=" already defined.",ila=" does not have a domain column.",Vz=' id="',jla=" loaded, but verification object ",kla=' onload="CHART_loaded()"',Wz=" to ",lla=" was not defined.",mla=' xmlns:svg="http://www.w3.org/2000/svg"',nla=' xmlns:xlink="http://www.w3.org/1999/xlink">',Xz='" ',ola='" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="',pla='" height="',qla='" name="',rla='" src="http://www.google.com/ig/ifr?url=',sla='" style="',Yz='" value="',tla='" width="',Zz='">',$z='"></div>',ula=
"#.###",aA="#000",vla="#000020",bA="#00f",cA="#0f0",dA="#109618",eA="#222222",fA="#333333",gA="#3399CC",hA="#444444",iA="#666",jA="#666666",wla="#7993ad",xla="#7f9a6b",yla="#8080ff",kA="#994499",lA="#999",mA="#999999",zla="#9a9a9a",Ala="#9bbdde",nA="#CCCCCC",oA="#DC3912",Bla="#DDD",pA="#EFE6DC",qA="#FF9900",rA="#FFFFFF",Cla="#a2c488",Dla="#a992ad",Ela="#ad7d79",Fla="#aea971",sA="#b7b7b7",Gla="#c991ff",tA="#ccc",uA="#cccccc",Hla="#cdc785",Ila="#ce9839",Jla="#d2feb0",Kla="#d6b9db",vA="#dc3912",Lla=
"#dea19b",Mla="#default#VML",wA="#e0e0e0",xA="#eee",Nla="#eeee5b",Ola="#eeeeac",Pla="#eeeeee",yA="#f00",Qla="#ff9900",Rla="#ffbc46",Sla="#ffd1c9",Tla="#fff0db",Ula="#visualization",Vla="$version",Wla="%s",Xla="%s's administration (under dispute)",Yla="%s://www.gstatic.com/charts/%s/%s/",zA="&nbsp;",Zla="&up_",$la="&up__table_query_url=",ama="').send(\n     function(response) {\n      new ",bma="']});\n\n   function drawVisualization() {\n    new google.visualization.Query('",cma='(\n       document.getElementById(\'visualization\')).\n        draw(response.getDataTable(), null);\n      });\n   }\n\n   google.setOnLoadCallback(drawVisualization);\n  \x3c/script>\n </head>\n <body>\n  <div id="visualization" style="width: 500px; height: 500px;"></div>\n </body>\n</html>',
dma=") translate(",ema=",0,",fma="--",gma="-10000px",hma="-1000px",ima="-active",jma="-bg",kma="-buttons",AA="-caption",lma="-checkbox",mma="-checked",nma="-collapse-left",oma="-collapse-right",BA="-content",CA="-default",DA="-disabled",EA="-dropdown",pma="-focused",qma="-highlight",rma="-horizontal",sma="-hover",tma="-inner-box",uma="-mag",vma="-open",wma="-outer-box",xma="-rtl",yma="-selected",zma="-title",Ama="-title-close",Bma="-title-draggable",Cma="-title-text",Dma="-unchecked",Ema="-undetermined",
Fma="-vertical",Gma="-webkit-user-select:none;",Hma="../../shapes/rect-util",FA="./abstract_shape",GA="./circle",HA="./ellipse",Ima="./group",IA="./line",JA="./path",Jma="./path-util",KA="./rect",Kma="./shapes",LA="./svg-util",MA="./text",Lma=".annotations.",Mma=".color",Nma=".enableInteractivity",Oma=".gif",Pma=".hole",Qma=".js",Rma=".lbl",Sma=".offset",Tma=".style",Uma=".textStyle",Vma=".type",Wma=".visibleInLegend",Xma="//chart.googleapis.com/chart",Yma="/>",Zma="/core/patterns/",NA="/3rd-party/gc/all.latest.css",
OA="0 0",$ma="0 0 4 4",PA="0%",ana="1.8",bna="1/",QA="100%",cna="12pt Times New Roman",RA="15px",SA="1e12",TA="1px",dna="1px solid infotext",UA="2",ena="200px",VA="2d",YA="4",fna="420+",gna="49.99%",hna="5.5",ina="50%",jna="525",kna="531",lna="532.0",mna="533.17.9",ZA="6",$A="636363",aB="7",nna="808080",ona="9.0",pna="90%",qna="9e9e9e",bB=": ",rna=":m",cB=":mm",sna=":ss",tna=":|",una=";color: #333333;margin:0;font-style:",vna=";font-weight:",wna=";height:",xna=";overflow-y:",yna=";stop-opacity:",
zna=";text-decoration:",Ana=";width:",Bna="< ",dB="</body>",eB="</div>",fB="</head>",gB="</html>",Cna="</object>",Dna="\x3c/script>",hB="</span>",Ena='<?xml version="1.0"?>',Fna='<body marginwidth="0" marginheight="0"',Gna="<default>",Hna='<div id="chartArea"></div>',Ina='<div id="renderers"></div>',Jna='<embed type="application/x-shockwave-flash" src="',iB="<head>",Kna='<html xmlns:v="urn:schemas-microsoft-com:vml">',Lna='<html xmlns="http://www.w3.org/1999/xhtml"',Mna='<html>\n <head>\n  <title>Google Visualization API</title>\n  <script type="text/javascript" src="http://www.google.com/jsapi">\x3c/script>\n  <script type="text/javascript">\n   google.load(\'visualization\', \'1\', {packages: [\'',
Nna='<iframe style="',Ona='<object id="',Pna='<param name="',Qna='<param name="flashvars" value="',Rna='<param name="movie" value="',Sna='<script type="text/javascript">',Tna='<span style="color:',jB="<style> v\\:* { behavior:url(#default#VML);}</style>",kB='="',Una="A ",Vna="A chart.",lB="AT",Wna="ActiveX",Xna="Add to iGoogle",Yna="All data columns of the same series must be of the same data type",Zna="All domains must be of the same data type",mB="Area",nB="Arial",$na="B",oB="BACKGROUND",aoa="BODY",
pB="Bars",boa="Billion",qB="C",rB="CELL",coa="COLUMN_INDEX",sB="COM",tB="COUNTRIES",doa="Cancel",eoa="Chart options",foa="Circle",goa="Click",hoa="Click to expand annotations",ioa="Close",IB="Column ",JB="Columns",KB="Component already rendered",joa="Copy-Paste this code to an HTML page",koa="Current: ",loa="DOMMouseScroll",moa="Data has no columns.",noa="Data must contain at least two columns.",LB="Data table is not defined",ooa="DblClick",poa="Drawing_Frame_",qoa="Each values column may be followed by one or two annotation columns. column number ",
roa="Ellipse",MB="End",soa="EndToEnd",toa="Error while loading script ",uoa="Export data as CSV",voa="Export data as HTML",woa='Failed geocoding "',xoa="First column must be a domain column",yoa="First column must contain date, or date and time.",zoa="GViz is Great.",Aoa="Geocoding failed for all data points",Boa="Google Visualization",Coa="Google_Visualization",Doa="Group",Eoa="HEAD",NB="HH:mm",Foa="HH:mm MMMM dd, yyyy",Goa="HH:mm:ss",Hoa="HTML",Ioa="HoverIn",Joa="HoverOut",Koa="Items",Loa="Javascript code",
Moa="Jsloader error (code #",Noa="L ",OB="LI",Ooa="Last domain does not have enough data columns (missing ",PB="Line",QB="Lines",Poa="M ",Qoa="METROS",RB="MMM",SB="MMMM dd, yyyy",Roa="Million",Soa="MouseDown",Toa="MouseUp",TB="No data",Uoa="OK",Voa="Only one data column with role 'tooltip' per series is allowed",Woa="Other",Xoa="PROVINCES",Yoa="Path",UB="Pie",Zoa="PlugIn",$oa="Previous data",apa="Previous: ",bpa="Promise cannot resolve to itself",cpa="Publish to web page",dpa="Quadrillion",epa="REGIONS",
VB="ROW",WB="ROW_INDEX",fpa="Rect",gpa="Requested map does not exist.",hpa="RightClick",XB="Roboto2",YB="Roboto2-light",ipa="SU",jpa="SUBREGIONS",ZB="SUBTYPE",$B="Scatter",kpa="Script ",lpa="Scroll",mpa="Shockwave Flash",npa="ShockwaveFlash.ShockwaveFlash",opa="ShockwaveFlash.ShockwaveFlash.",ppa="ShockwaveFlash.ShockwaveFlash.6",qpa="ShockwaveFlash.ShockwaveFlash.7",rpa="SourceAlpha",spa="SourceGraphic",aC="Start",tpa="Start and end points must be 2D",upa="StartToEnd",vpa="StartToStart",bC="TD",
cC="Text",wpa="The columns type does not match the supported data format. See documentation for supported formats.",xpa="The visualization is not ready yet.",ypa="Timeout reached for loading script ",dC="To",zpa="Trendline ",Apa="Trillion",Bpa="UK",Cpa="UL",eC="US",fC="US-",Dpa="UTF-8",Epa="Unable to set parent component",Fpa="Unexpected domain column (column #",Gpa="Unknown granularity.",gC="Value",Hpa="Verification object ",Ipa="WA",Jpa="Windows CE",hC="X",Kpa="Y",Lpa="Your browser does not support charts",
iC="_",Mpa="_ABSTRACT_RENDERER_ID_",Npa="__",Opa="__DISPUTED__",Ppa="__DISPUTED__All",Qpa="__internal_",Rpa="_callbacks_.",jC="_focusedLabels",kC="_selectedLabels",Spa="_trendline",Tpa="charts-button",Upa="charts-checkbox",Vpa="charts-container",Wpa="charts-control",Xpa="charts-custom-button",Ypa="charts-flat-button",lC="charts-inline-block",mC="charts-inline-block ",Zpa="charts-link-button",
nC="charts-menu",$pa="charts-menu-button",aqa="charts-menuheader",bqa="charts-menuitem",cqa="charts-menuitem-accel",dqa="charts-menuitem-mnemonic-separator",oC="charts-menuseparator",eqa="charts-modalpopup",pC="charts-option",fqa="charts-option-selected",gqa="charts-select",hqa="charts-serverchart-image",iqa="charts-slider-disabled",
jqa="charts-slider-dragging",kqa="charts-slider-thumb-dragging",qC="action",lqa="actionsMenu.disabledTextStyle",mqa="actionsMenu.textStyle",nqa="actionsMenuEntry",oqa="actionsMenuEntryClick",pqa="actionsMenuEntryHoverIn",qqa="actionsMenuEntryHoverOut",rqa="activate",rC="activedescendant",sqa="additions text",tqa="ae",sC="afterhide",tC="aftershow",uqa="aggregationTarget",uC="allValuesSuffix",vqa="allowContainerBoundaryTextCufoff",vC="always",wqa="alwaysOutside",xqa="angle",
yqa="animate",wC="animation.duration",zqa="animation.easing",Aqa="animation.maxFramesPerSecond",Bqa="animationEasing",Cqa="animationfinish",Dqa="animationframefinish",xC="annotation",Eqa="annotation.",Fqa="annotationClick",Gqa="annotationHoverIn",Hqa="annotationHoverOut",Iqa="annotations.alwaysOutside",Jqa="annotations.boxStyle",Kqa="annotations.datum.alwaysOutside",Lqa="annotations.datum.boxStyle",Mqa="annotations.datum.highContrast",Nqa="annotations.datum.stemColor",Oqa="annotations.datum.style",
Pqa="annotations.datum.textStyle",Qqa="annotations.domain.boxStyle",Rqa="annotations.domain.stemColor",Sqa="annotations.domain.style",Tqa="annotations.domain.textStyle",Uqa="annotations.highContrast",Vqa="annotations.stemColor",Wqa="annotations.style",yC="annotations.textStyle",zC="annotationtext",AC="arc",BC="area",Xqa="area.",CC="areaOpacity",Yqa="aria-activedescendant",Zqa="aria-hidden",DC="aria-label",EC="arial",$qa="attachToEnd",ara="attachToStart",FC="axis",bra="axisBackgroundColor",cra="axisLabelFormatter",
dra="axisTitlesPosition",GC="background",HC="backgroundColor",IC="backgroundColor.fill",JC="bar",era="bar.",fra="barWidth",KC="bars",LC="baseline",gra="baselineColor",MC="beforedrag",NC="beforehide",OC="beforeshow",hra="begin",ira="bfbfbf",jra="bg",PC="bhg",QC="bhs",RC="black",SC="blue",TC="blur",UC="bold",kra="bold ",lra="border",VC="border-box",mra="border:0;vertical-align:bottom;",WC="bottom",XC="bottom-space",YC="bottom-vert",ZC="bottom_left",nra="bound",$C="bounds",aD="box",ora="boxStyle",pra=
"boxWidth",qra="boxes",bD="br",cD="bubble",rra="bubble.opacity",sra="bubble.stroke",tra="bubble.textStyle",dD="bubbles",eD="button",fD="bvg",gD="bvs",ura="callImmediate",vra="callback",hD="cancel",iD="candlestick",wra="candlestick.fallingColor",xra="candlestick.hollowIsRising",yra="candlestick.risingColor",jD="candlesticks",kD="canvas",lD="category",zra="categoryClick",Ara="categoryHoverIn",Bra="categoryHoverOut",mD="categorypoint",nD="categorysensitivityarea",Cra="cccccc",oD="cell",pD="center",Dra=
"centerSelectionAroundData",qD="change",rD="character",sD="chartArea",Era="chartArea.backgroundColor",tD="chartArea.height",uD="chartArea.left",vD="chartArea.top",wD="chartArea.width",Fra="chartClick",Gra="chartDblClick",Hra="chartDrag",Ira="chartDragEnd",Jra="chartDragStart",Kra="chartHoverIn",Lra="chartHoverOut",Mra="chartMouseDown",Nra="chartMouseMove",Ora="chartMouseUp",Pra="chartOptions",Qra="chartPinch",Rra="chartPinchEnd",Sra="chartPinchStart",Tra="chartRightClick",Ura="chartScroll",xD="chartType",
yD="chartarea",Vra="charteditor",zD="chco",Wra="chd",Xra="chdl",Yra="check",AD="checkbox",BD="checked",Zra="chf",$ra="chl",asa="chld",CD="chs",DD="cht",bsa="chtt",csa="chxl",dsa="chxt",ED="circle",FD="classdef",esa="clear",fsa="clip-path",gsa="clipPath",GD="clipped",hsa="clone",HD="close",ID="closedPhase",JD="col-resize",isa="collapse",KD="color",jsa="color2",LD="colorAxis.colors",ksa="colorAxis.legend.numberFormat",lsa="colorAxis.legend.position",msa="colorAxis.legend.textStyle",nsa="colorAxis.maxValue",
osa="colorAxis.minValue",psa="colorAxis.values",qsa="colorAxis.values must not contain nulls",MD="colorBar",rsa="colorbar",ND="colors",ssa="columns",tsa="connectSteps",OD="contextmenu",usa="continents",vsa="corners.bottomleft.rx",wsa="corners.bottomleft.ry",xsa="corners.bottomright.rx",ysa="corners.bottomright.ry",zsa="corners.rx",Asa="corners.ry",Bsa="corners.topleft.rx",Csa="corners.topleft.ry",Dsa="corners.topright.rx",Esa="corners.topright.ry",PD="countries",Fsa="countries_en",Gsa="country",Hsa=
"crosshair.color",Isa="crosshair.focused.color",Jsa="crosshair.focused.opacity",Ksa="crosshair.focused.orientation",Lsa="crosshair.opacity",Msa="crosshair.orientation",Nsa="crosshair.selected.color",Osa="crosshair.selected.opacity",Psa="crosshair.selected.orientation",Qsa="crosshair.trigger",Rsa="csv",Ssa="cursor:default;-webkit-user-select:none;",QD="curve",RD="curveType",Tsa="cut",SD="cx",TD="cy",UD="dash",Usa="dataOpacity",Vsa="datalessRegionColor",VD="dateFormat",WD="datum",Wsa="datumClick",Xsa=
"datumHoverIn",Ysa="datumHoverOut",XD="day",YD="dblclick",Zsa="deactivate",ZD="default",$sa="defaultColor",$D="defs",ata="degree",bta="destroy",cta="detectflash",aE="dialogselect",dta="diamond",eta="diff.innerCircle.borderFactor",fta="diff.innerCircle.radiusFactor",bE="diff.newData.opacity",gta="diff.newData.tooltip.prefix",hta="diff.newData.widthFactor",ita="diff.oldData.color",jta="diff.oldData.inCenter",cE="diff.oldData.opacity",kta="diff.oldData.tooltip.prefix",dE="disable",lta="disabled",mta=
"display:table-cell;padding: 0;margin: 0;border: 0",nta="display:table;position:absolute;padding:0;margin:0;border:0",ota="displayAnnotations",pta="displayDateBarSeparator",qta="displayLegendDots",rta="displayLegendValues",sta="displayMode",eE="displayRangeSelector",tta="displayTinySlicesInLegend",fE="displayZoomButtons",uta="disputed",gE="dive",hE="doExpressInstall",vta="down",iE="drag",wta="dragToPan",xta="dragToZoom",yta="dragend",zta="dragstart",Ata="drawCircle",Bta="drawEllipse",Cta="drawLine",
Dta="drawRect",Eta="drawShape",Fta="drawText",Gta="drop",Hta="dx",Ita="dy",jE="e",Jta="earlycancel",Kta="easing",Lta="elaborated",Mta="elaborated.isDisputed",Nta="elaborated.origin.x",Ota="elaborated.origin.y",Pta="elaborated.rowId",kE="ellipse",Qta="empty",lE="en",mE="enable",nE="enableInteractivity",Rta="enableRegionInteractivity",Sta="enableScrollWheel",oE="end",pE="enter",Tta="exp",Uta="expanded",qE="explicit",rE="explorer",sE="explorer.actions",Vta="explorer.axis",Wta="explorer.axis.",Xta="explorer.keepInBounds",
Yta="explorer.maxZoomIn",Zta="explorer.maxZoomOut",$ta="explorer.zoomDelta",aua="feComponentTransfer",bua="feFuncA",cua="feGaussianBlur",dua="feMerge",tE="feMergeNode",eua="feOffset",uE="feature",vE="featureClick",wE="featureHover",xE="featureMove",yE="fgrid",zE="fill",AE="fill-opacity",fua="fill.color",gua="fill.opacity",hua="fillColor",iua="fillOpacity",BE="finish",jua="firstVisibleText",kua="fixedRangeSize",lua='flashvars="',CE="focusTarget",mua="focusedFeature",nua="focusedMarker",oua="font-family",
pua="font-family:",qua="font-size",DE="font-style",EE="font-weight",rua="font.family",sua="font.size",FE="fontColor",tua="fontFamily",GE="fontName",HE="fontSize",IE="forceIFrame",JE="format",uua="formatOptions",KE="formatOptions.prefix",LE="formatOptions.scaleFactor",ME="formatOptions.suffix",vua="formatter.numDecimals",wua="formatter.numSignificantDigits",xua="formatter.unit",yua="formatter.useMagnitudes",zua="function CHART_loaded() {",Aua="g_vml_",Bua="g_vml_:",Cua="g_vml_\\:*{behavior:url(#default#VML)}",
Dua="geocodingContext",NE="get",Eua="goog_",Fua="google-visualization-toolbar-big-dialog",Gua="google-visualization-toolbar-html-code-explanation",Hua="google-visualization-toolbar-small-dialog",OE="google-visualization-tooltip",Iua="google-visualization-tooltip-action",Jua="google-visualization-tooltip-action-list",Kua="google-visualization-tooltip-item",Lua="google-visualization-tooltip-item-list",Mua="google-visualization-tooltip-separator",Nua="google-visualization-tooltip-square",Oua="google.visualization.AreaChart",
Pua="google.visualization.BarChart",Qua="google.visualization.ColumnChart",Rua="google.visualization.LineChart",Sua="google.visualization.PieChart",Tua="google.visualization.ScatterChart",Uua="google_visualization_geochart_",Vua="google_visualization_geochart_boundingBoxes",Wua="google_visualization_geochart_mapList",PE="gradient",Xua="gradientUnits",QE="gray",RE="green",SE="grid",TE="gridline",Yua="gridlineColor",Zua="gridlines.allowMinor",$ua="gridlines.color",ava="gridlines.count",bva="gridlines.minMajorTextDistance",
cva="gridlines.minMinorTextDistance",dva="gridlines.minNotchDistance",eva="gridlines.minStrongLineDistance",fva="gridlines.minStrongToWeakLineDistance",gva="gridlines.minWeakLineDistance",hva="gridlines.minorGridlineOpacity",iva="gridlines.minorTextOpacity",jva="gridlines.newTimeline",kva="gridlines.unitThreshold",UE="group",lva="hAxes.",VE="hAxis",mva="hAxis#",WE="halign",XE="haspopup",YE="headerColor",ZE="headerHeight",nva="height:",$E="hide",aF="high",ova="highContrast",bF="highlight",cF="histogram",
pva="histogram.bucketSize",dF="histogram.hideBucketItems",qva="histogram.lastBucketPercentile",rva="histogram.maxBucketNumber",sva="histogram.minBucketNumber",tva="histogram.sortBucketItems",uva="histogramBucketItems",vva="histogramBuckets",wva="histogramElementIndexes",xva="hour",yva="hover",eF="hoverIn",fF="hoverOut",zva="htmlcode",Ava="http:",Bva="http://www.google.com/ig/adde?moduleurl=",Cva="http://www.w3.org/1999/xlink",gF="http://www.w3.org/2000/svg",hF="https:",iF="hybrid",jF="i",kF="id",
Dva="identifier",lF="iframe",Eva="igoogle",Fva="image",Gva="image/png",Hva="image/svg+xml",mF="in",nF="inAndOut",Iva="inTextPosition",Jva="info/boundingBoxes.js",Kva="info/mapList.js",Lva="infobackground",oF="input",pF="inside",Mva="interactivityModel",qF="interpolateNulls",rF="interval",Nva="interval.",Ova="intervals.",sF="is3D",Pva="isDiff",tF="isStacked",uF="italic",Qva="italic ",Rva='javascript:""',Sva="jscode",Tva="kavrayskiy-vii",Uva="keepAspectRatio",vF="key",wF="keydown",xF="keyup",yF="l",
zF="label",AF="labelInLegend",BF="labeled",CF="labelledby",Vva="leave",DF="legend",Wva="legend.alignment",Xva="legend.bar.length",Yva="legend.iconWidthScaleFactor",Zva="legend.labeledValueText",$va="legend.maxLines",awa="legend.newLegend",bwa="legend.numberFormat",cwa="legend.orientation",dwa="legend.pagingTextStyle",ewa="legend.position",fwa="legend.scrollArrows.activeColor",gwa="legend.scrollArrows.inactiveColor",hwa="legend.scrollArrows.orientation",iwa="legend.showPageIndex",jwa="legend.textStyle",
kwa="legendEntry",Bwa="legendEntryClick",Cwa="legendEntryHoverIn",Dwa="legendEntryHoverOut",Ewa="legendFontSize",Fwa="legendScrollButton",Gwa="legendScrollButtonClick",Hwa="legendTextColor",EF="legendTextStyle",FF="legendentry",GF="legendscrollbutton",HF="letter",IF="li",JF="line",KF="line.",Iwa="lineColor",Jwa="lineDashStyle",Kwa="lineSize",Lwa="lineSpacing",Mwa="lineWeight",LF="lineWidth",MF="linear",Nwa="linearGradient",NF="links",Owa="listbox",Pwa="load",Qwa="loaded",OF="log",PF="logScale",Rwa=
"logScaleX",Swa="losecapture",Twa="low",QF="ltr",Uwa="magnifyingGlass.enable",Vwa="magnifyingGlass.zoomFactor",RF="magnifyingGlassBorder",SF="magnifyingGlassTriangle",Wwa="majorAxisTextColor",Xwa="mapLoaded",TF="mapType",Ywa="mapfiles/%s.js",UF="marker",Zwa="marker.style.stroke",$wa="marker.style.stroke.color",axa="marker.style.stroke.width",VF="markerClick",mG="markerHover",bxa="markerMove",cxa="markerOpacity",nG="math",dxa="matrix(",oG="max",exa="maxAlternation",pG="maxColor",fxa="maxColorValue",
qG="maxDepth",gxa="maxTextLines",rG="maximized",hxa="menu",ixa="menuitem",sG="menuitemcheckbox",tG="menuitemradio",uG="mercator",jxa="meta",vG="metros",wG="midColor",xG="middle",yG="min",zG="minColor",kxa="minColorValue",lxa="minRangeSize",mxa="minTextSpacing",nxa="minorAxisTextColor",AG="minorGridlines.color",oxa="minorGridlines.count",BG="mirrorLog",CG="mixed",pxa="modal-dialog",DG="month",qxa="mouseenter",rxa="mouseleave",EG="mousemove",FG="mouseup",GG="mousewheel",HG="move",IG="move_offscreen",
JG="name",KG="natural",LG="no",sxa="nodeType",MG="normal",txa="notime",NG="nowrap",uxa="objectBoundingBox",vxa="ocean",OG="off",PG="offset",QG="ok",RG="old-data",wxa="onmousedown",SG="onmousemove",TG="onmouseout",UG="onmouseover",xxa="onmouseup",yxa="onreadystatechange",zxa="onunload",Axa="opacity2",VG="opaque",Bxa="open",Cxa="optimizeQuality",Dxa="option",WG="orientation",XG="out",Exa="out:csv;",Fxa="out:html;",Gxa="outTextPosition",YG="outside",Hxa="oval",Ixa="overflow:auto;position:absolute;top:0;width:100px;height:100px",
Jxa="overflow:hidden;position:relative;width:",Kxa="overflowX",Lxa="overlaybox",ZG="owns",$G="p",Mxa="p3",Nxa="package",Oxa="paste",aH="path",Pxa="pathinterval",Qxa="patternUnits",Rxa="pc",bH="percentage",Sxa="phase",cH="pie",dH="pieHole",Txa="pieResidueSliceColor",Uxa="pieResidueSliceLabel",eH="pieSliceBorderColor",fH="pieSliceText",Vxa="pieSliceTextStyle",Wxa="pieStartAngle",gH="piecewiseLinear",Xxa="pinchToZoom",Yxa="pixelsPerLabel",hH="play",iH="point",Zxa="point.",$xa="pointShape",jH="pointSize",
kH="pointer",lH="points",mH="pointsensitivityarea",nH="polygon",aya="position:absolute;display:none;",bya="position:relative;overflow:hidden",cya="pre",dya="preserveAspectRatio",eya="pressed",oH="pretty",pH="primarydiagonalstripes",fya="projection",gya="propertychange",qH="provinces",hya="pt",iya="purple",jya="px ",rH="px;",kya="px;overflow-x:",lya="px;position: absolute;top:0;left:0;",sH="quadtree",mya="rablshadow",tH="range",nya="rangeChangeEventFiringRate",uH="rangechange",vH="rect",oya="rect(",
wH="red",xH="redirectUrl",yH="redraw",zH="region",pya="regionClick",AH="remove",qya="removeSerieButton",rya="removeSerieButtonClick",sya="removeSerieButtonHoverIn",tya="removeSerieButtonHoverOut",uya="removeShape",vya="removeserie",wya="removeseriebutton",xya="renderers",BH="renderers/abstract/abstractrenderer",yya="renderers/canvas/canvas",zya="renderers/canvas/circle",Aya="renderers/canvas/ellipse",Bya="renderers/canvas/line",Cya="renderers/canvas/path",Dya="renderers/canvas/rect",Eya="renderers/canvas/shapes",
Fya="renderers/canvas/text",Gya="renderers/svg/circle",Hya="renderers/svg/ellipse",Iya="renderers/svg/group",Jya="renderers/svg/line",Kya="renderers/svg/path",Lya="renderers/svg/path-util",Mya="renderers/svg/rect",Nya="renderers/svg/shapes",Oya="renderers/svg/svg",Pya="renderers/svg/svg-util",Qya="renderers/svg/text",Rya="repeat",Sya="reset",CH="resize",DH="resolution",Tya="resume",Uya="reverse",Vya="reverseAxis",EH="reverseCategories",Wya="rgb(",Xya="rgba(",FH="rgba(0,0,0,0)",GH="right-space",Yya=
"rightClickToReset",HH="rightclick",Zya="rotate",IH="rotate(",JH="row",$ya="row-resize",KH="rowlabels",LH="rows",MH="rx",NH="ry",OH="sans-serif",aza="scale(",PH="scaleType",QH="scatter",bza="scene",RH="screen",SH="scroll",cza="scrollToZoom",dza="secondarydiagonalstripes",TH="selected",UH="selectedRows",eza="selectionMode",VH="separator",fza="serie",gza="serieClick",hza="serieHoverIn",iza="serieHoverOut",WH="series",XH="series-color",YH="series-color-dark",jza="series-color-light",ZH="series.",kza=
"seriesType",$H="set",lza="shadow.opacity",mza="shadow.radius",nza="shadow.x-offset",oza="shadow.xOffset",pza="shadow.xoffset",qza="shadow.y-offset",rza="shadow.yOffset",sza="shadow.yoffset",aI="shape",tza="shapes/abstract_shape",uza="shapes/circle",vza="shapes/ellipse",wza="shapes/group",xza="shapes/line",yza="shapes/path",zza="shapes/rect",Aza="shapes/rect-util",bI="shapes/shapes",Bza="shapes/text",Cza="shortBarWidth",Dza="shortdash",cI="show",Eza="showChartButtons",Fza="showGeocodeWarnings",dI=
"showLine",Gza="showR2",Hza="showRemoveSeriesButton",Iza="showScale",Jza="showSidePanel",Kza="showTextEvery",Lza="showTextEveryMode",eI="showTip",fI="showTooltips",Mza="sideScreenColor",Nza="sizeAxis.logScale",Oza="sizeAxis.maxSize",Pza="sizeAxis.maxValue",Qza="sizeAxis.minSize",Rza="sizeAxis.minValue",Sza="sizeAxis.scaleType",Tza="slantedText",Uza="slantedTextAngle",gI="slice",Vza="sliceVisibilityThreshold",Wza="slices.",hI="slider",Xza="slope",iI="smoothingFactor",Yza="snapToData",Zza="sortBubblesBySize",
$za="sparkline",jI="square",kI="src",lI="stack",aAa="stageShape",mI="star",nI="start",oI="state",bAa="stdDeviation",cAa="stemColor",pI="step",qI="steppedArea",rI="steppedareabar",dAa="sticks",sI="stop",tI="stop-color:",uI="stroke",eAa="stroke-dasharray",fAa="stroke-linecap",vI="stroke-opacity",wI="stroke-width",gAa="stroke.color",hAa="stroke.opacity",iAa="stroke.width",jAa="strokeColor",kAa="strokeOpacity",lAa="strokeWidth",mAa="subcontinents",nAa="submit",xI="svg",yI="swf",zI="t",oAa="targetAxes.",
AI="targetAxisIndex",BI="tbody",CI="td",DI="text-anchor",pAa="text-decoration",qAa="textColor",rAa="textFontSize",sAa="textPosition",EI="textStyle",tAa="textpath",FI="textpathok",uAa="thickness",vAa="tickScoringWeights",GI="ticks",wAa="timeGranularity",HI="title",xAa="titleColor",II="titleFontSize",yAa="titlePosition",JI="titleTextStyle",zAa="titleX",KI="titleY",LI="toggle_display",AAa="tooltip.isHtml",BAa="tooltip.showColorCode",CAa="tooltip.showDisputedText",DAa="tooltip.showEmpty",EAa="tooltip.showTitle",
FAa="tooltip.text",GAa="tooltip.textStyle",MI="tooltip.trigger",HAa="tooltipFontSize",IAa="tooltipHoverIn",JAa="tooltipHoverOut",KAa="tooltipText",LAa="tooltipTextColor",MAa="tooltipTextStyle",NAa="tooltipTrigger",NI="top",OI="top-space",PI="top_left",OAa="top_right",PAa="touchcancel",QAa="touchend",RAa="touchmove",QI="touchstart",SAa="tqx",RI="tr",TAa="track",UAa="translate(",VAa="trendlines.",WAa="triangle",XAa="trigger",YAa="type_error:SafeHtml",SI="ul",ZAa="unbound",$Aa="uncheck",TI="underline",
UI="unhighlight",aBa="unselect",bBa="up",cBa="uritoolong",dBa="url(",VI="url(#",eBa="urn:schemas-microsoft-com:vml",fBa="useExpressInstall",gBa="useLargeControl",hBa="useMapTypeControl",WI="userSpaceOnUse",XI="v-text-align",YI="v:fill",iBa="v:group",ZI="v:oval",$I="v:path",jBa="v:rect",aJ="v:shape",kBa="v:stroke",lBa="v:textpath",mBa="vAxes.",nBa="vAxis#",bJ="valign",oBa="value-and-percentage",pBa="valueFormatter",qBa="valuemax",rBa="valuemin",sBa="valuenow",tBa="valuetext",uBa="var _loaded = false;",
cJ="version",dJ="viewBox",eJ="viewWindow.max",fJ="viewWindow.min",vBa="viewWindow.numericMax",wBa="viewWindow.numericMin",gJ="viewWindowMode",hJ="visibleInLegend",xBa="week",iJ="width: ",yBa="width: 700px; height: 500px;",zBa="width:100px;height:100px;overflow:scroll;position:absolute;visibility:hidden;",jJ="wordtree",kJ="world",lJ="x",mJ="x1",nJ="x2",ABa="xiRedirectUrl",oJ="y1",pJ="y2",qJ="year",rJ="yyyy",BBa="zOrder",CBa="zoomAroundSelection",DBa="zoomLevel",EBa="zoomOut",sJ="{}",FBa="\u00b0";
function GBa(a,b){var c=b||HBa;return function(){var b=this||Ph,b=b.closure_memoize_cache_||(b.closure_memoize_cache_={}),e=c(fi(a),arguments);return b[vc](e)?b[e]:b[e]=a[Mc](this,arguments)}}function HBa(a,b){for(var c=[a],d=b[J]-1;0<=d;--d)c[C](typeof b[d],b[d]);return c[ie](Xka)};Tj([BC,"base",bD,"col","command","embed","hr",Vr,oF,"keygen",Rg,jxa,"param","source",TAa,"wbr"]);var IBa=/<[^>]*>|&[^;]+;/g;function tJ(a,b){return b?a[vb](IBa,O):a}
var JBa=/[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/,KBa=/^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\u200f\ufb1d-\ufdff\ufe70-\ufefc]/,LBa=/^http:\/\/.*/,MBa=RegExp("^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Arab|Hebr|Thaa|Nkoo|Tfng))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)",jF);function uJ(){return MBa[bd](Zn(Vra)||lE)}
var NBa=/\s+/,OBa=/\d/;function PBa(a,b){for(var c=0,d=0,e=!1,f=tJ(a,b)[pc](NBa),g=0;g<f[J];g++){var k=f[g];KBa[bd](tJ(k,void 0))?(c++,d++):LBa[bd](k)?e=!0:JBa[bd](tJ(k,void 0))?d++:OBa[bd](k)&&(e=!0)}return 0==d?e?1:0:0.4<c/d?-1:1};function vJ(){this.b2=O;this.hra=QBa;this.zda=null}vJ[K].cra=!0;vJ[K].f2=function(){return this.zda};vJ[K].dra=!0;function wJ(a){return a instanceof vJ&&a[rc]===vJ&&a.hra===QBa?a.b2:YAa}function xJ(a){var b=null;a.cra&&(b=a.f2());return yJ(qi(a.dra?a.b2:String(a)),b)}Tj(qC,"cite",Jr,"formaction",Kg,"manifest","poster",kI);Tj(Rg,lh,sh);var QBa={};function yJ(a,b){var c=new vJ;c.b2=a;c.zda=b;return c}var zJ=xJ(O);function AJ(a,b){Wa(a,wJ(b))};function RBa(a){var b=a[Od],c=a[qc];c||Cl(a)!=yg||(c=Gk(a)[dc]);if(!c)return b;if(lk)var d=Zl(c),b=b+d[G];else rk(8)&&(d=Zl(c),b-=d[G]);return Kl(c)?c[Gd]-(b+a[zb]):b};function BJ(a,b,c,d,e,f,g,k,l){var n=CJ(c),q=Ql(a),s=Il(a);s&&q.Ky(xl(s));var s=Ek(a),u=Ek(c);if(s.$b()!=u.$b()){var w=s.$b()[Pd],u=u.xB(),z=new sk(0,0),B=Qk(Gk(w)),F=w;do{var M=B==u?Jl(F):Lea(F);z.x+=M.x;z.y+=M.y}while(B&&B!=u&&(F=B.frameElement)&&(B=B[xy]));w=vk(z,Jl(w));kk&&!pl(s)&&(w=vk(w,ql(s)));Ya(q,q[G]+w.x);q.top+=w.y}a=DJ(a,b);q=new sk(a&2?q[G]+q[r]:q[G],a&1?q.top+q[A]:q.top);q=vk(q,n);e&&(q.x+=(a&2?-1:1)*e.x,q.y+=(a&1?-1:1)*e.y);var N;if(g)if(l)N=l;else if(N=Il(c))N.top-=n.y,Ta(N,N[Zc]-
n.x),Na(N,N[Hc]-n.y),Ya(N,N[G]-n.x);return EJ(q,c,d,f,N,g,k)}function CJ(a){var b;if(a=a[qc]){var c=a[Nc]==Hoa||a[Nc]==aoa;c&&Cl(a)==qh||(b=Jl(a),c||(c=(c=Kl(a))&&lk?-a[Gc]:!c||kk&&qk(Wq)||Bl(a,Kxa)==Fh?a[Gc]:a[Bc]-a[Gd]-a[Gc],b=vk(b,new sk(c,a[Cd]))))}return b||new sk}
function EJ(a,b,c,d,e,f,g){a=a.o();var k=0,l=DJ(b,c);c=Pl(b);g=g?g.o():c.o();if(d||0!=l)l&2?a.x-=g[r]+(d?d[Zc]:0):d&&(a.x+=d[G]),l&1?a.y-=g[A]+(d?d[Hc]:0):d&&(a.y+=d.top);if(f&&(e?(k=a,d=0,65==(f&65)&&(k.x<e[G]||k.x>=e[Zc])&&(f&=-2),132==(f&132)&&(k.y<e.top||k.y>=e[Hc])&&(f&=-5),k.x<e[G]&&f&1&&(k.x=e[G],d|=1),k.x<e[G]&&k.x+g[r]>e[Zc]&&f&16&&(pa(g,h.max(g[r]-(k.x+g[r]-e[Zc]),0)),d|=4),k.x+g[r]>e[Zc]&&f&1&&(k.x=h.max(e[Zc]-g[r],e[G]),d|=1),f&2&&(d=d|(k.x<e[G]?16:0)|(k.x+g[r]>e[Zc]?32:0)),k.y<e.top&&
f&4&&(k.y=e.top,d|=2),k.y<=e.top&&k.y+g[A]<e[Hc]&&f&32&&(Sa(g,h.max(g[A]-(e.top-k.y),0)),k.y=e.top,d|=8),k.y>=e.top&&k.y+g[A]>e[Hc]&&f&32&&(Sa(g,h.max(g[A]-(k.y+g[A]-e[Hc]),0)),d|=8),k.y+g[A]>e[Hc]&&f&4&&(k.y=h.max(e[Hc]-g[A],e.top),d|=2),f&8&&(d=d|(k.y<e.top?64:0)|(k.y+g[A]>e[Hc]?128:0)),k=d):k=256,k&496))return k;Dl(b,a);yk(c,g)||(a=Gk(b),e=pl(Ek(a)),!kk||e&&qk(Wq)?(b=b[x],lk?b.MozBoxSizing=VC:mk?b.WebkitBoxSizing=VC:b.boxSizing=VC,pa(b,h.max(g[r],0)+S),Sa(b,h.max(g[A],0)+S)):(a=b[x],e?(e=Yl(b),
b=Zl(b),a.pixelWidth=g[r]-b[G]-e[G]-e[Zc]-b[Zc],a.pixelHeight=g[A]-b.top-e.top-e[Hc]-b[Hc]):(a.pixelWidth=g[r],a.pixelHeight=g[A])));return k}function DJ(a,b){return(b&4&&Kl(a)?b^2:b)&-5};function FJ(){}FJ[K].Ie=function(){};function GJ(a,b,c){cx(this,a);this.fH=b;this.pra=c}X(GJ,FJ);GJ[K].Ie=function(a,b,c){BJ(this[Mz],this.fH,a,b,void 0,c,this.pra)};function HJ(a,b){this.aa=a instanceof sk?a:new sk(a,b)}X(HJ,FJ);HJ[K].Ie=function(a,b,c,d){BJ(Gl(a),0,a,b,this.aa,c,null,d)};function IJ(a,b,c,d){GJ[L](this,a,b);this.XN=c?5:0;this.r2=d||void 0}X(IJ,GJ);IJ[K].Eia=function(){return this.XN};IJ[K].Ie=function(a,b,c,d){var e=BJ(this[Mz],this.fH,a,b,null,c,10,d,this.r2);if(e&496){var f=JJ(e,this.fH);b=JJ(e,b);e=BJ(this[Mz],f,a,b,null,c,10,d,this.r2);e&496&&(f=JJ(e,f),b=JJ(e,b),BJ(this[Mz],f,a,b,null,c,this.XN,d,this.r2))}};function JJ(a,b){a&48&&(b^=2);a&192&&(b^=1);return b};function KJ(a,b){this.aa=a instanceof sk?a:new sk(a,b)}X(KJ,FJ);KJ[K].Ie=function(a,b,c,d){var e;e=Gk(a);var f=e[Pd];e=e[dc];e=new sk(f[Gc]||e[Gc],f[Cd]||e[Cd]);f=this.aa.x+e.x;e=this.aa.y+e.y;var g=CJ(a),f=f-g.x;e-=g.y;EJ(new sk(f,e),a,b,c,null,null,d)};function SBa(a){if(a[Tp]&&!a[Jq]||a[Cq]||112<=a[Np]&&123>=a[Np])return!1;switch(a[Np]){case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 224:case 92:return!1;case 0:return!lk;default:return 166>a[Np]||183<a[Np]}}
function TBa(a,b,c,d,e){if(!(kk||mk&&qk(jna)))return!0;if(fk&&e)return LJ(a);if(e&&!d)return!1;di(b)&&(b=MJ(b));if(!c&&(17==b||18==b||fk&&91==b))return!1;if(mk&&d&&c)switch(a){case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:return!1}if(kk&&d&&b==a)return!1;switch(a){case 13:return!(kk&&rk(9));case 27:return!mk}return LJ(a)}
function LJ(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=a||mk&&0==a)return!0;switch(a){case 32:case 63:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:return!0;default:return!1}}function MJ(a){if(lk)a=UBa(a);else if(fk&&mk)t:switch(a){case 93:a=91;break t}return a}
function UBa(a){switch(a){case 61:return 187;case 59:return 186;case 173:return 189;case 224:return 91;case 0:return 224;default:return a}};function NJ(a,b){rt[L](this);this.Td=new sv(this);this.hF(a||null);b&&this.Du(b)}X(NJ,rt);T=NJ[K];T.q=null;T.B9=!0;T.aba=null;T.MB=!1;T.pna=!1;T.hZ=-1;T.Cka=!1;T.Bna=!0;T.rg=LI;T.Vb=function(){return this.rg};T.Du=function(a){this.rg=a};T.a=function(){return this.q};T.hF=function(a){VBa(this);this.q=a};T.uL=function(a){VBa(this);this.B9=a};T.NM=function(a,b){this.zA=a;this.kB=b};T.hc=function(){return this.Td};
function VBa(a){if(a.MB)throw m("Can not change this state of the popup while showing.");}T.O=function(){return this.MB};fw(T,function(a){this.zA&&this.zA[Hq]();this.kB&&this.kB[Hq]();a?this.R0():this.lC()});T.Ie=Th;
T.R0=function(){if(!this.MB&&this.JW()){if(!this.q)throw m("Caller must call setElement before trying to show the popup");this.Ie();var a=Gk(this.q);this.Cka&&this.Td.l(a,wF,this.Dka,!0);if(this.B9)if(this.Td.l(a,es,this.D9,!0),kk){var b;try{b=a[pb]}catch(c){}for(;b&&b[nd]==Vaa;){try{var d=b[Nz]||b[dy][Hd]}catch(e){break}a=d;b=a[pb]}this.Td.l(a,es,this.D9,!0);this.Td.l(a,Zsa,this.C9)}else this.Td.l(a,TC,this.C9);this.rg==LI?(hb(this.q[x],Fh),Sl(this.q,!0)):this.rg==IG&&this.Ie();this.MB=!0;this.hZ=
hi();this.zA?(nt(this.zA,oE,this.E9,!1,this),this.zA[fz]()):this.E9()}};T.lC=function(a){if(!this.MB||!this[$]({type:NC,target:a}))return!1;this.Td&&this.Td.oc();this.MB=!1;hi();this.kB?(nt(this.kB,oE,gi(this.ica,a),!1,this),this.kB[fz]()):this.ica(a);return!0};T.ica=function(a){this.rg==LI?this.pna?ut(this.Jaa,0,this):this.Jaa():this.rg==IG&&(this.q[x].top=gma);this.WX(a)};T.Jaa=function(){hb(this.q[x],Ig);Sl(this.q,!1)};T.JW=function(){return this[$](OC)};T.E9=function(){this[$](cI)};
T.WX=function(a){this[$]({type:$E,target:a})};T.D9=function(a){a=a[Mq];dl(this.q,a)||this.aba&&!dl(this.aba,a)||150>hi()-this.hZ||this.lC(a)};T.Dka=function(a){27==a[Np]&&this.lC(a[Mq])&&(a[Hp](),a[Zp]())};T.C9=function(a){if(this.Bna){var b=Gk(this.q);if("undefined"!=typeof fa[pb]){if(a=b[pb],!a||dl(this.q,a)||a[Nc]==aoa)return}else if(a[Mq]!=b)return;150>hi()-this.hZ||this.lC()}};T.w=function(){NJ.e.w[L](this);this.Td.W();Ws(this.zA);Ws(this.kB);delete this.q;delete this.Td};function OJ(a,b){this.b7=4;this.ya=b||void 0;NJ[L](this,a)}X(OJ,NJ);pw(OJ[K],function(){return this.ya||null});bx(OJ[K],function(a){this.ya=a||void 0;this.O()&&this.Ie()});OJ[K].Ie=function(){if(this.ya){var a=!this.O()&&this.Vb()!=IG,b=this.a();a&&(hb(b[x],Ig),Sl(b,!0));this.ya.Ie(b,this.b7,this.wta);a&&Sl(b,!1)}};function PJ(a,b,c){this.P=c||(a?Ek(Hk(a)):Ek());OJ[L](this,this.P.h(Q,{style:aya}));this.ub=new sk(1,1);this.Fa=new ck;a&&this.cz(a);null!=b&&this.$q(b)}X(PJ,OJ);var QJ=[];T=PJ[K];T.Lf=null;lb(T,"charts-tooltip");T.UM=500;T.S7=0;T.ea=function(){return this.P};T.cz=function(a){a=Hk(a);this.Fa.add(a);kt(a,gs,this.En,!1,this);kt(a,fs,this.YR,!1,this);kt(a,EG,this.Zba,!1,this);kt(a,zg,this.Pt,!1,this);kt(a,TC,this.YR,!1,this)};
T.detach=function(a){if(a)a=Hk(a),WBa(this,a),this.Fa[Ob](a);else{for(var b=this.Fa.La(),c=0;a=b[c];c++)WBa(this,a);this.Fa[Wb]()}};function WBa(a,b){ot(b,gs,a.En,!1,a);ot(b,fs,a.YR,!1,a);ot(b,EG,a.Zba,!1,a);ot(b,zg,a.Pt,!1,a);ot(b,TC,a.YR,!1,a)}T.$q=function(a){el(this.a(),a)};T.F_=function(a){var b=this.a();b&&AJ(b,a)};T.hF=function(a){var b=this.a();b&&Zk(b);PJ.e.hF[L](this,a);a&&(b=this.P.$b()[Pd],b[Eb](a,b[yc]))};T.Mu=function(){return jl(this.a())};T.G5=function(){return this.a()[hd]};
sp(T,function(){return this.Hu?this.O()?4:1:this.vH?3:this.O()?2:0});T.JW=function(){if(!NJ[K].JW[L](this))return!1;if(this[Gz])for(var a,b=0;a=QJ[b];b++)dl(a.a(),this[Gz])||a[hy](!1);Ri(QJ,this)||QJ[C](this);a=this.a();lb(a,this[Fd]);RJ(this);kt(a,gs,this.y9,!1,this);kt(a,fs,this.x9,!1,this);SJ(this);return!0};
T.WX=function(){Wi(QJ,this);for(var a=this.a(),b,c=0;b=QJ[c];c++)b[Gz]&&dl(a,b[Gz])&&b[hy](!1);this.z9&&TJ(this.z9);ot(a,gs,this.y9,!1,this);ot(a,fs,this.x9,!1,this);Zw(this,void 0);0==this[hq]()&&(this.lO=!1);NJ[K].WX[L](this)};T.Mca=function(a,b){this[Gz]==a&&this.Fa[Lc](this[Gz])&&(this.lO||!this.Jta?(this[hy](!1),this.O()||(Zw(this,a),this[Lz](b||this.ON(0)),this[hy](!0))):Zw(this,void 0));this.Hu=void 0};T.j_=function(){return this.Fa};T.bE=function(){return this.Lf};
T.gra=function(a){this.vH=void 0;a==this[Gz]&&(null!=this.Lf&&(this.Lf==this.a()||this.Fa[Lc](this.Lf))||this.O8&&this.O8.Lf||this[hy](!1))};function XBa(a,b){var c=ql(a.P);a.ub.x=b[zd]+c.x;a.ub.y=b[Ad]+c.y}T.En=function(a){var b=UJ(this,a[Mq]);this.Lf=b;RJ(this);b!=this[Gz]&&(Zw(this,b),this.Hu||(this.Hu=ut(W(this.Mca,this,b,void 0),this.UM)),YBa(this),XBa(this,a))};function UJ(a,b){try{for(;b&&!a.Fa[Lc](b);)b=b[fe];return b}catch(c){return null}}T.Zba=function(a){XBa(this,a);this.lO=!0};
T.Pt=function(a){this.Lf=a=UJ(this,a[Mq]);this.lO=!0;if(this[Gz]!=a){Zw(this,a);var b=this.ON(1);RJ(this);this.Hu||(this.Hu=ut(W(this.Mca,this,a,b),this.UM));YBa(this)}};T.ON=function(a){return 0==a?(a=this.ub.o(),new VJ(a)):new WJ(this.Lf)};function YBa(a){if(a[Gz])for(var b,c=0;b=QJ[c];c++)dl(b.a(),a[Gz])&&(b.O8=a,a.z9=b)}T.YR=function(a){var b=UJ(this,a[Mq]),c=UJ(this,a[Fp]);b!=c&&(b==this.Lf&&(this.Lf=null),SJ(this),this.lO=!1,!this.O()||a[Fp]&&dl(this.a(),a[Fp])?Zw(this,void 0):TJ(this))};
T.y9=function(){var a=this.a();this.Lf!=a&&(RJ(this),this.Lf=a)};T.x9=function(a){var b=this.a();this.Lf!=b||a[Fp]&&dl(b,a[Fp])||(this.Lf=null,TJ(this))};function SJ(a){a.Hu&&(vt(a.Hu),a.Hu=void 0)}function TJ(a){2==a[hq]()&&(a.vH=ut(W(a.gra,a,a[Gz]),a.S7))}function RJ(a){a.vH&&(vt(a.vH),a.vH=void 0)}T.w=function(){this[hy](!1);SJ(this);this[hz]();this.a()&&Zk(this.a());this.Lf=null;delete this.P;PJ.e.w[L](this)};function VJ(a,b){HJ[L](this,a,b)}X(VJ,HJ);
VJ[K].Ie=function(a,b,c){b=Gl(a);b=Il(b);c=c?new rl(c.top+10,c[Zc],c[Hc],c[G]+10):new rl(10,0,0,10);EJ(this.aa,a,4,c,b,9)&496&&EJ(this.aa,a,4,c,b,5)};function WJ(a){GJ[L](this,a,3)}X(WJ,GJ);WJ[K].Ie=function(a,b,c){var d=new sk(10,0);BJ(this[Mz],this.fH,a,b,d,c,9)&496&&BJ(this[Mz],2,a,1,d,c,5)};function XJ(a){var b=null,c=null;ei(a)?b=a:c=a;this.Hna=b;this.q=c;this.qR=null}XJ[K].zn=function(a){this.qR=a;this.q&&Cm(this.q,a)};XJ[K].Er=function(){return this.q?Yea(this.q):this.qR};XJ[K].a=function(){this.q||(this.q=this.Hna(),null===this.qR||Cm(this.q,this.qR));return this.q};function YJ(){this.Yc=[]}T=YJ[K];T.qj=function(a){this.Yc[C](a)};Gw(T,function(a,b){this.qj(ZJ(a,b))});T.Z=function(a,b){this.qj({type:JF,data:{x:a,y:b}})};T.Zj=function(a,b,c,d,e,f){this.qj({type:QD,data:{x1:a,y1:b,hb:c,kb:d,x:e,y:f}})};T.Wf=function(a,b,c,d,e,f,g){this.qj({type:AC,data:{WA:a,XA:b,ji:c,ki:d,ew:e,Rq:f,c$:g}})};
function $J(a,b,c){if(0!=b[J])if(0==a.Yc[J]?a[Yy](b[0].x,b[0].y):a.Z(b[0].x,b[0].y),c)for(var d=1;d<b[J];++d)a.Zj(c[d-1][1].x,c[d-1][1].y,c[d][0].x,c[d][0].y,b[d].x,b[d].y);else for(d=1;d<b[J];++d)a.Z(b[d].x,b[d].y)}mw(T,function(){this.qj({type:HD,data:null})});function ZJ(a,b){return{type:HG,data:{x:a,y:b}}}function aK(a,b){var c=new YJ;0<a[J]&&($J(c,a),b||c[vy]());return c};function bK(a,b,c){switch(c){case nI:c=a;a+=b;break;case oE:c=a-b;break;case pD:c=a-b/2;a+=b/2;break;default:c=a=ja}return{start:c,end:a}}function cK(a,b,c){switch(c){case oE:return b;case pD:return vj(a,b);default:return a}};function dK(a,b){this.lb=a;this.fC=b;this.Cs=null;this.vf=GBa(W(function(a,b){return this.hC(a,b)},this),function(a,b){var e=[a,b[0]];Dj(b[1],function(a,b){e[C](a);e[C](b)});return e[ie](iC)});this.Uu=null}X(dK,Us);function eK(){Ph.__googleVisualizationAbstractRendererElementsCount__=Ph.__googleVisualizationAbstractRendererElementsCount__||0;var a=Mpa+Ph.__googleVisualizationAbstractRendererElementsCount__[hc]();Ph.__googleVisualizationAbstractRendererElementsCount__++;return a}T=dK[K];pa(T,0);
Sa(T,0);T.wk=function(a,b){var c=this.qP(a,b);c.zn(ag);return this.Cs=c};T.deleteContents=function(a){this.J2(a)};T.flush=function(){};wa(T,function(){this.Wg()});T.Wg=function(){this.Cs=null};T.w=function(){this.Wg();dK.e.w[L](this)};T.ac=function(){return this.lb};T.zn=function(a,b){a&&(a[rc]==XJ?a.zn(b):Cm(a,b))};T.Er=function(a){return Yea(a)};T.appendChild=function(a,b){if(b){var c;if(b[rc]==XJ){if(!b.q)return;c=b.a()}else c=b;a.a()[p](c)}};T.replaceChild=function(a,b,c){a.a()[Ty](b,c)};
T.cd=function(a){if(a.q){var b=a.a();this.nt.cd(b);a.a()}};T.za=function(a){a=null!=a?a:!1;var b=new XJ(W(this.oZ,this));a||b.a();return b};T.JU=function(){};T.tba=function(){return null};T.uba=function(){};function fK(a,b,c,d,e,f){var g=new YJ;g[Yy](b,c);g.Z(d,e);return a.tc(g,f)}
T.tc=function(a,b){for(var c=[],d=0;d<a.Yc[J];d++){var e=c,f=a.Yc[d];switch(f[H]){case HG:f=f[Z];this.Zc(e,f.x,f.y);break;case JF:f=f[Z];this.va(e,f.x,f.y);break;case QD:f=f[Z];this.Cq(e,f.x1,f.y1,f.hb,f.kb,f.x,f.y);break;case AC:f=f[Z];this.rm(e,f.WA,f.XA,f.ji,f.ki,f.ew,f.Rq,f.c$);break;case HD:this.vi(e)}}return this.f_(c,b)};
function ZBa(a,b,c,d,e,f,g,k){b=b[pc](me);var l=[],n=f;f=qj(f+90);c-=h.cos(f)*k*b[J];d-=h.sin(f)*k*b[J];for(var q=0,s=b[J];q<s;q++)l[C](a.Jp(b[q],c,d,e,n,pD,nI,g)),c+=h.cos(f)*k,d+=h.sin(f)*k;return l}T.Zd=function(a,b,c,d,e){a=this.Uv(a,b,c,d);this[p](e,a);return a};T.Nj=function(a,b,c,d,e,f){a=this.I2(a,b,c,d,e);this[p](f,a);return a};T.rb=function(a,b,c,d,e,f){a=this.Ak(a,b,c,d,e);this[p](f,a);return a};T.eK=function(a,b,c,d,e,f){a=fK(this,a,b,c,d,e);this[p](f,a);return a};
T.na=function(a,b,c){a=this.tc(a,b);this[p](c,a);return a};T.Pd=function(a,b,c,d,e,f,g,k){a=this.qt(a,b,c,d,e,f,g);this[p](k,a);return a};T.mi=function(a,b,c,d,e,f,g,k,l){a=this.nJ(a,b,c,d,e,f,g,k);this[p](l,a);return a};function $Ba(a,b,c,d,e,f,g,k,l,n){b=a.Jp(b,c,d,e,f,g,k,l);a[p](n,b)}T.Gk=function(a,b){return this.vf(a,b)[r]};function aCa(a,b,c){var d;d=d||0;b=b[pc](me);for(var e=0,f=0,g=0,k=b[J];g<k;g++){var l=a.vf(b[g],c),e=h.max(e,l[r]),f=f+l[A];0<g&&(f+=d)}return new xk(e,f)}T.qB=function(){return!1};function bCa(a){return ml(a,function(a){return a.referencepoint},!0)}function gK(a){var b=bCa(a[Mq]);return Ll(a,b)};function hK(a,b){dK[L](this,a,b);this.nt=Ek(a);this.pN=this.nt.$b();this.Aq=[];this.C=new sv}X(hK,dK);function cCa(a,b,c,d){b=new PJ(b);var e=a.nt.h(Q);c=c[pc](me);e[p](a.nt[Cb](c[0]));for(var f=1;f<c[J];++f)e[p](a.nt.h(bD)),e[p](a.nt[Cb](c[f]));zl(e,d);b.a()[p](e);b.UM=100;b.S7=100;a.Aq[C](b)}T=hK[K];T.Ff=function(a){this.nt[kq](a);qt(a)};wa(T,function(){this.C.oc();Ws(this.C);this.C=new sv;hK.e[Wb][L](this)});
T.Wg=function(){hK.e.Wg[L](this);Y(this.Aq,function(a){Ws(a)});Ti(this.Aq);this.nt.cd(this.lb);this.C.oc();Ws(this.C)};T.Nk=function(a){var b=bCa(a);return b?(b=Ll(a,b),a=Pl(a),new rl(b.y,b.x+a[r],b.y+a[A],b.x)):null};T.Fb=function(a,b,c){a[rc]==XJ&&(a=a.a());this.C.l(a,b,c)};T.replaceChild=function(a,b,c){hK.e[Ty][L](this,a,b,c);qt(c)};function iK(a,b,c,d){this.x0=a;this.y0=b;this.x1=c;this.y1=d}iK[K].o=function(){return new iK(this.x0,this.y0,this.x1,this.y1)};Za(iK[K],function(a){return this.x0==a.x0&&this.y0==a.y0&&this.x1==a.x1&&this.y1==a.y1});function dCa(a){var b=a.x1-a.x0;a=a.y1-a.y0;return h[ud](b*b+a*a)}function jK(a,b){return new sk(pj(a.x0,a.x1,b),pj(a.y0,a.y1,b))};function kK(a,b){this.x=a;this.y=b}X(kK,sk);T=kK[K];T.o=function(){return new kK(this.x,this.y)};T.hba=function(){return h[ud](this.x*this.x+this.y*this.y)};Oa(T,sk[K][Fy]);T.add=function(a){this.x+=a.x;this.y+=a.y;return this};T.w0=function(a){this.x-=a.x;this.y-=a.y;return this};T.rotate=function(a){var b=h.cos(a);a=h.sin(a);var c=this.y*b+this.x*a;this.x=this.x*b-this.y*a;this.y=c;return this};Za(T,function(a){return this==a||!!a&&this.x==a.x&&this.y==a.y});
function lK(a,b){return new kK(a.x+b.x,a.y+b.y)}function mK(a,b){return new kK(a.x-b.x,a.y-b.y)};function nK(a,b){hK[L](this,a,b);this.ha=null;var c=Ek(b)[Qb](kD);this.fC[p](c);this.dca=c[iz](VA);this.h1=null}X(nK,hK);function oK(a){a.Xba||(a.ha[dz](),a.Xba=!0)}T=nK[K];T.qP=function(a,b){var c=Ek(this.lb)[Qb](kD);c[v](Ih,a);c[v](Hg,b);this.lb[p](c);this.ha=c[iz](VA);return new XJ(c)};T.J2=function(){var a=this.Cs.a();this.ha.clearRect(0,0,a[r],a[A])};function pK(a){return Ek(a.lb)[Qb](Qta)}function qK(a,b){if(a==R)return FH;b==R&&(b=1);return Xya+rm(a)+Je+b+Ge}
function rK(a,b){"undefined"!==typeof a.setLineDash?a.setLineDash(b):a.Nwa=b}
T.$h=function(a){Hw(this.ha,qK(a.Qd,a.Ai));ew(this.ha,qK(a.gb(),a.Oe));var b=a.Hk;null!=b&&b==UD?rK(this.ha,[8,2]):Yh(b)?rK(this.ha,b):rK(this.ha,[]);var b=a.fe,c=a.Qg;if(null!=b){var d;switch(b.Ge){case pH:c=this.pN[Qb](kD),c[v](Ih,4),c[v](Hg,4),d=c[iz](VA),ew(d,b.qr()),d[Jy](0,0,4,4),Hw(d,b.Hd()),d[dz](),zw(d,2),d.lineCap=jI,d[Xx](2,0),d[Ry](4,2),d[Xx](0,2),d[Ry](2,4),d[Yb](),d=c}ew(this.ha,this.ha.createPattern(d,Rya))}else null!=c&&(b=this.ha.createLinearGradient(+c.x1,+c.y1,+c.hb,+c.kb),b[Kz](0,
c.lg),b[Kz](1,c.Tf),ew(this.ha,b));zw(this.ha,a.Hb)};function eCa(a,b){b.Tb&&b.Tb!=R?(Hw(a,b.Tb),zw(a,3)):Hw(a,FH);ew(a,qK(b[E],b[Kd]?b[Kd]:1));rK(a,[]);var c=O;b.Ic&&(c=Qva);b[Ed]&&(c+=kra);c+=b[uc]+jya+b.Va;a.font=c}T.Uv=function(a,b,c,d){this.ha[dz]();this.$h(d);this.ha.arc(a,b,c,0,2*h.PI);this.ha[Oy]();this.ha[fc]();this.ha[Yb]();return pK(this)};
T.I2=function(a,b,c,d,e){this.ha[qy]();this.$h(e);this.ha[jz](a,b);c>d?(this.ha[Fy](1,d/c),a=c):(this.ha[Fy](c/d,1),a=d);this.ha.arc(0,0,a,0,2*h.PI,!1);this.ha[fc]();this.ha[Yb]();this.ha[Gy]();return pK(this)};T.Ak=function(a,b,c,d,e){this.$h(e);this.ha[Jy](a,b,c,d);this.ha[qz](a,b,c,d);return pK(this)};T.pZ=function(){return pK(this)};T.f_=function(a,b){this.$h(b);this.ha[fc]();this.ha[Yb]();this.Xba=!1;return pK(this)};T.qt=function(a,b,c,d,e,f,g){return this.Jp(a,b,c,d,0,e,f,g)};
T.nJ=function(a,b,c,d,e,f,g,k){var l=cK(b,d,f),n=cK(c,e,f),q=dCa(new iK(b,c,d,e));return this.Jp(a,l,n,q,tj(b,c,d,e),f,g,k)};
T.Jp=function(a,b,c,d,e,f,g,k){eCa(this.ha,k);this.ha[qy]();e=qj(e);d=b*h.sin(-e)+c*h.cos(-e);b=b*h.cos(-e)-c*h.sin(-e);this.ha[sy](e);g==nI?d+=4*k[uc]/5:g==pD?d+=k[uc]/3:g==oE&&(d-=k[uc]/5);f!=nI&&(f==pD?b-=this.hC(a,k)[r]/2:f==oE&&(b-=this.hC(a,k)[r]));this.ha.strokeText(a,b,d);this.ha[Ex](a,b,d);k.De&&(this.ha[dz](),e=k[uc]/15,d+=e+1,1>e&&(e=1),zw(this.ha,e),this.ha[Xx](b,d),this.ha[Ry](this.ha.measureText(a)[r]+b,d),Hw(this.ha,this.ha.fillStyle),this.ha[Yb]());this.ha[Gy]();return pK(this)};
T.oZ=function(){return pK(this)};T.JU=function(a){this.h1=a;this.ha[qy]();this.ha[dz]();ew(this.ha,FH);this.ha[zz](a[G],a.top,a[r],a[A]);this.ha[Yb]();this.ha.clip();return pK(this)};T.uba=function(){this.h1=null;this.ha[Gy]()};T.tba=function(){return this.h1};T.cE=function(){return pK(this)};T.Zc=function(a,b,c){oK(this);this.ha[Xx](b,c)};T.va=function(a,b,c){oK(this);this.ha[Ry](b,c)};T.Cq=function(a,b,c,d,e,f,g){oK(this);this.ha.bezierCurveTo(b,c,d,e,f,g)};T.vi=function(){oK(this);this.ha[Oy]()};
T.rm=function(a,b,c,d,e,f,g,k){oK(this);f=qj(f-90);g=qj(g-90);a=h.max(d,e);this.ha[qy]();this.ha[jz](b,c);this.ha[Fy](d/a,e/a);this.ha.arc(0,0,a,f,g,!k);this.ha[Gy]()};T.em=function(){};T.sl=function(){};T.Ex=function(){};T.jQ=function(){};T.kQ=function(){};T.dd=function(){};T.hC=function(a,b){eCa(this.dca,b);return new xk(this.dca.measureText(a)[r],b[uc])};T.i0=function(){return pK(this)};T.Ri=function(){};function sK(a){this.m=a;this.C=new sv}X(sK,Us);T=sK[K];T.ac=function(){return this.m};wa(T,function(){this.TE();this.C=new sv});T.TE=function(){Wk(this.m);this.C.oc();Ws(this.C)};T.w=function(){this.TE();sK.e.w[L](this)};T.Fb=function(a,b,c){this.C.l(a,b,c)};function tK(a,b){hK[L](this,a,b);this.$o=null;this.qO={};this.SX={};this.hC(zoa,{fontSize:8,Va:nB,bold:!1,Ic:!1})}X(tK,hK);function fCa(a,b){a.$o=a.Ra($D);a.$o[v](kF,$D);a.qO={};a.SX={};a.D8={};b[p](a.$o)}T=tK[K];T.qP=function(a,b){pa(this,a);Sa(this,b);var c=this.Ra(xI);c[v](Ih,a);c[v](Hg,b);c[x].overflow=Ig;c[v](DC,Vna);this.lb[p](c);fCa(this,c);return new XJ(c)};
T.Nk=function(a){if(a instanceof Ph.SVGElement&&a[Nc][ke]()!==aH){var b=a.getBBox();return b.y|b.x|b[A]|b[r]?new rl(b.y,b.x+b[r],b.y+b[A],b.x):tK.e.Nk[L](this,a)}return tK.e.Nk[L](this,a)};T.J2=function(){for(var a=this.Cs.a(),b=a[Xb],c=b[J];1<c;)a[Qd](b[0]),c--;fCa(this,a)};T.Jna=function(){return this.lb[hd]};Va(T,function(a){return h[D](100*a)/100});T.Uv=function(a,b,c,d){var e=this.Ra(ED);e[v](SD,a);e[v](TD,b);e[v](fh,c);this.Ri(e,d);return e};
T.I2=function(a,b,c,d,e){var f=this.Ra(kE);f[v](SD,a);f[v](TD,b);f[v](MH,c);f[v](NH,d);this.Ri(f,e);return f};T.Ak=function(a,b,c,d,e){var f=this.Ra(vH);f[v](lJ,a);f[v](Jh,b);f[v](Ih,c);f[v](Hg,d);this.Ri(f,e);return f};T.pZ=function(a,b,c,d,e,f,g){b=nva+c+kya+(f?SH:Ig)+xna+(g?SH:Ig)+Ana+b+lya;d=this.qP(d,e);if(Zh(a))for(e=0,c=a[J];e<c;e++)this[p](d,a[e]);else this[p](d,a);a=Rk(Q,{style:b},d.a());this.lb[p](a);return{append:[],w6:[d.a()]}};
T.f_=function(a,b){var c=this.Ra(aH);0<a[J]&&c[v](ng,a[ie](O));this.Ri(c,b);return c};T.qt=function(a,b,c,d,e,f,g){return this.Jp(a,b,c,d,0,e,f,g)};T.nJ=function(a,b,c,d,e,f,g,k){var l=cK(b,d,f),n=cK(c,e,f),q=dCa(new iK(b,c,d,e));return this.Jp(a,l,n,q,tj(b,c,d,e),f,g,k)};
T.Jp=function(a,b,c,d,e,f,g,k){var l=Qh(k[Kd])?k[Kd]:1,n=new Rm({fill:k[E],ae:l});if(k[E]&&k[E]!=R&&k.Tb&&k.Tb!=R){var l=new Rm({fill:k[E],ae:l,stroke:k.Tb,Cg:l,qa:3}),q=this.za();this.tH(a,b,c,d,e,f,g,k,l,q);this.tH(a,b,c,d,e,f,g,k,n,q);return q.a()}return this.sH(a,b,c,d,e,f,g,k,n)};
T.sH=function(a,b,c,d,e,f,g,k,l){d=this.Ra(Es);g=bK(0,k[uc],g);g=cK(g[y],g.end,oE);g-=0.15*k[uc];g=new kK(0,g);g[sy](qj(e));c=new kK(b,c);c.add(g);b=c.x;c=c.y;d[p](this.pN[Cb](a));switch(f){case nI:d[v](DI,nI);break;case pD:d[v](DI,xG);break;case oE:d[v](DI,oE)}d[v](lJ,b);d[v](Jh,c);d[v](oua,k.Va);d[v](qua,k[uc]||0);k[Ed]&&d[v](EE,UC);k.Ic&&d[v](DE,uF);k.De&&d[v](pAa,TI);0!=e&&d[v](xh,IH+e+ne+b+ne+c+Ge);this.Ri(d,l);return d};
T.tH=function(a,b,c,d,e,f,g,k,l,n){a=this.sH(a,b,c,d,e,f,g,k,l);this[p](n,a);return a};T.oZ=function(){return this.Ra(Cg)};T.cE=function(a,b,c){var d=eK(),e=this.Ra(gsa);c?(c=this.Ra(kE),c[v](SD,b[G]+b[r]/2),c[v](TD,b.top+b[A]/2),c[v](MH,b[r]/2),c[v](NH,b[A]/2)):(c=this.Ra(vH),c[v](lJ,b[G]),c[v](Jh,b.top),c[v](Ih,b[r]),c[v](Hg,b[A]));e[p](c);e[v](kF,d);this.$o[p](e);a=a.a();b=O;lk&&(b=ca[tc][Ic][pc](qe)[0]);a[v](fsa,dBa+b+qe+d+Ge);return a};T.Zc=function(a,b,c){a[C](sf+b+Je+c)};
T.va=function(a,b,c){a[C](rf+b+Je+c)};T.Cq=function(a,b,c,d,e,f,g){a[C](qB+b+Je+c+Je+d+Je+e+Je+f+Je+g)};T.vi=function(a){a[C](Vf)};T.rm=function(a,b,c,d,e,f,g,k){f=oj(f,360);g=oj(g,360);var l=rj(g-90,d),n=sj(g-90,e);f=k?g-f:f-g;0>f&&(f+=360);a[C](df+d+Je+e+ema+(180<f?1:0)+Je+(k?1:0)+Je+h[t](1E5*(b+l))/1E5+Je+h[t](1E5*(c+n))/1E5)};T.em=function(a,b,c){a[v](xh,UAa+b+Ke+c+Ge)};T.sl=function(a,b){a[v](Ih,b)};T.Ex=function(a,b){a[v](Hg,b)};T.jQ=function(a,b){a[v](lJ,b)};T.kQ=function(a,b){a[v](Jh,b)};
T.dd=function(a,b,c){a[v](wI,c);b&&a[v](uI,b)};T.hC=function(a,b){var c=this.fC;ra(c[Sb],a);var d=c[x];Ew(d,b.Va);Ja(d,b[uc]+S);Qw(d,b[Ed]?UC:O);Xw(d,b.Ic?uF:O);Ra(d,Dr);var e=c[Gd],c=c[Wd];Ra(d,R);return new xk(e,c)};T.i0=function(){if(null!=this.Uu)return this.Uu;var a=Tk(Q);$a(a[x],Ixa);var b=Tk(Q);Nl(b,ena,ena);a[p](b);fa[Pd][p](a);b=a[zb]-a[Gd];Zk(a);return this.Uu=b};T.Ra=function(a){return this.pN[ny](gF,a)};
T.Ri=function(a,b){Vm(b)?(a[v](uI,b.Qd),a[v](wI,b.Hb),Vm(b)&&1<=b.Ai?a[Pc](vI):a[v](vI,b.Ai),b.Hk!=ph?a[v](eAa,gCa(b.Hk,b.Hb)):a[Pc](eAa)):(a[v](uI,R),a[v](wI,0));Xm(b)?a[Pc](AE):a[v](AE,b.Oe);var c=b.mA;di(c)&&a[v](MH,c);c=b.nA;di(c)&&a[v](NH,c);var d=b.Qg;if(d){var e=$n(d,1)[hc](),c=this.SX[e];if(!c){c=eK();this.SX[e]=c;var e=this.Ra(Nwa),f=d.x1,g=d.hb,k=d.y1,l=d.kb,n=d.lg,q=d.Tf,s=d.Wy||1,u=d.Xy||1,w=d.sv?uxa:WI;e[v](kF,c);e[v](mJ,f);e[v](oJ,k);e[v](nJ,g);e[v](pJ,l);e[v](Xua,w);f=tI+n+yna+s;q=
tI+q+yna+u;u=this.Ra(sI);u[v](PG,PA);u[v](sh,f);e[p](u);d.uK&&(d=this.Ra(sI),d[v](PG,gna),d[v](sh,f),e[p](d),d=this.Ra(sI),d[v](PG,ina),d[v](sh,q),e[p](d));d=this.Ra(sI);d[v](PG,QA);d[v](sh,q);e[p](d);this.$o[p](e)}a[v](zE,VI+c+Ge)}else if(null!=b.fe){e=b.fe;c=e.Ge+iC+e.Hd()+iC+e.qr();if(!(c in this.qO)){d=null;switch(e.Ge){case pH:d=this.Ra(dh);d[v](Qxa,WI);d[v](lJ,Oe);d[v](Jh,Oe);d[v](Ih,YA);d[v](Hg,YA);d[v](dJ,$ma);q=this.Ra(vH);q[v](lJ,Oe);q[v](Jh,Oe);q[v](Ih,YA);q[v](Hg,YA);q[v](zE,e.qr());d[p](q);
q=this.Ra(Cg);q[v](uI,e.Hd());q[v](fAa,jI);e=this.Ra(JF);e[v](mJ,UA);e[v](oJ,Oe);e[v](nJ,YA);e[v](pJ,UA);e[v](wI,UA);q[p](e);e=this.Ra(JF);e[v](mJ,Oe);e[v](oJ,UA);e[v](nJ,UA);e[v](pJ,YA);e[v](wI,UA);q[p](e);d[p](q);break;case dza:d=this.Ra(dh),d[v](Qxa,WI),d[v](lJ,Oe),d[v](Jh,Oe),d[v](Ih,ZA),d[v](Hg,ZA),d[v](dJ,$ma),q=this.Ra(vH),q[v](lJ,Oe),q[v](Jh,Oe),q[v](Ih,YA),q[v](Hg,YA),q[v](zE,e.qr()),d[p](q),q=this.Ra(Cg),q[v](uI,e.Hd()),q[v](fAa,jI),e=this.Ra(JF),e[v](mJ,UA),e[v](oJ,Oe),e[v](nJ,Oe),e[v](pJ,
UA),e[v](wI,UA),q[p](e),e=this.Ra(JF),e[v](mJ,YA),e[v](oJ,UA),e[v](nJ,UA),e[v](pJ,YA),e[v](wI,UA),q[p](e),d[p](q)}e=eK();d[v](kF,e);this.$o[p](d);this.qO[c]=e}c=this.qO[c];a[v](zE,VI+c+Ge)}else a[v](zE,b.gb());null!=b.VW&&(d=b.getShadow(),e=$n(d,1)[hc](),c=this.D8[e],c||(c=eK(),this.D8[e]=c,e=this.Ra(xg),e[v](kF,c),q=this.Ra(cua),q[v](mF,rpa),q[v](bAa,d[bz]),e[p](q),q=this.Ra(eua),q[v](Hta,d.dia||0),q[v](Ita,d.eia||0),e[p](q),null!=d[Kd]&&(q=this.Ra(aua),u=this.Ra(bua),u[v](Ah,MF),u[v](Xza,d[Kd]),
q[p](u),e[p](q)),d=this.Ra(dua),q=this.Ra(tE),d[p](q),q=this.Ra(tE),q[v](mF,spa),d[p](q),e[p](d),this.$o[p](e)),a[v](xg,VI+c+Ge))};function gCa(a,b){if(Yh(a))return a[ie](Je);switch(a){case ph:return Oe;case UD:return String(4*b)+Je+String(b);default:return gCa(ph,b)}};function uK(a,b){hK[L](this,a,b);this.ru=null}X(uK,hK);T=uK[K];T.qP=function(a,b){pa(this,a);Sa(this,b);var c=this.Vd(Q);this.tj(c,-5E4,-5E4,this[r]+1E5,this[A]+1E5);this.lb[p](c);var d=this.za(),e=d.a();kw(e,OA);ax(e,a+ne+b);e[x].top=5E4;Ya(e[x],5E4);c[p](e);return d};T.J2=function(){for(var a=this.Cs.a(),b=a[Xb],c=b[J];1<c;)a[Qd](b[0]),c--};Va(T,function(a){return h[D](a)});T.Uv=function(a,b,c,d){var e=this.Vd(ZI),f=2*c;this.tj(e,a-c,b-c,f,f);this.Ri(e,d,!1);return e};
T.I2=function(a,b,c,d,e){var f=this.Vd(ZI);this.tj(f,a-c,b-d,2*c,2*d);this.Ri(f,e,!1);return f};T.Ak=function(a,b,c,d,e){var f=this.Vd(jBa),g=Xm(e)&&1<=d&&1<=c&&null==e.Qg;this.Ri(f,e,g);if(Vm(e)||g)c=h.max(c-1,0),d=h.max(d-1,0);this.tj(f,a,b,c,d);return f};T.pZ=function(a,b,c,d,e,f,g){b=Rk(Q,{style:nva+c+kya+(f?SH:Ig)+xna+(g?SH:Ig)+Ana+b+rH});b=new XJ(b);if(Zh(a))for(c=0,d=a[J];c<d;c++)this[p](b,a[c]);else this[p](b,a);return{append:[b.a()],w6:[]}};
T.f_=function(a,b){for(var c=this.Vd(aJ),d=this.Vd($I);0<a[J]&&ki(Ai(a),sf);)a=$i(a,0,a[J]-1);d[v](Ch,a[ie](O));this.tj(c,0,0,this[r],this[A]);c[p](d);this.Ri(c,b,!1);return c};T.qt=function(a,b,c,d,e,f,g){b=bK(b,d,e);c=bK(c,g[uc],f);f=pD;c=cK(c[y],c.end,f);return this.nJ(a,b[y],c,b.end,c,e,f,g)};
T.nJ=function(a,b,c,d,e,f,g,k){var l=new Rm({fill:k[E]});if(k[E]&&k[E]!=R&&k.Tb&&k.Tb!=R){var n=new Rm({fill:k[E],stroke:k.Tb,qa:2}),q=this.za();this.tH(a,b,c,d,e,f,g,k,n,q);this.tH(a,b,c,d,e,f,g,k,l,q);return q.a()}return this.sH(a,b,c,d,e,f,g,k,l)};T.Jp=function(a,b,c,d,e,f,g,k){e=qj(e);d=bK(b,d,f);b=new kK(b,c);var l=new kK(d[y],c),l=l.o().w0(b)[sy](e).add(b);c=new kK(d.end,c);c=c.o().w0(b)[sy](e).add(b);return this.nJ(a,l.x,l.y,c.x,c.y,f,g,k)};
T.sH=function(a,b,c,d,e,f,g,k,l){var n=this.Vd(aJ);this.tj(n,0,0,this[r],this[A]);g!=pD&&(g=bK(0,k[uc],g),g=cK(g[y],g.end,pD),g=new kK(0,g),g[sy](qj(tj(b,c,d,e))),c=new kK(b,c),e=new kK(d,e),c.add(g),e.add(g),b=c.x,c=c.y,d=e.x,e=e.y);b=h[D](b);c=h[D](c);d=h[D](d);e=h[D](e);g=this.Vd($I);g[v](Ch,sf+b+Je+c+rf+d+Je+e+mf);g[v](FI,zh);b=this.Vd(lBa);b[v](ah,zh);d=b[x];Ja(d,k[uc]||O);Ew(d,k.Va||O);switch(f){case nI:d[v](XI,Qg);break;case pD:d[v](XI,pD);break;case oE:d[v](XI,zs)}k[Ed]&&Qw(d,UC);k.Ic&&Xw(d,
uF);b[v](rh,a);n[p](g);n[p](b);this.Ri(n,l,!1);return n};T.tH=function(a,b,c,d,e,f,g,k,l,n){a=this.sH(a,b,c,d,e,f,g,k,l);this[p](n,a);return a};T.oZ=function(){var a=this.Vd(iBa);this.tj(a,0,0,this[r],this[A]);return a};T.cE=function(a,b){var c=this.Vd(Q),d=[this.Rb(5E4+b.top),this.Rb(5E4+b[G]+b[r]),this.Rb(5E4+b.top+b[A]),this.Rb(5E4+b[G])];c[x].clip=oya+d[ie](Ke)+Ge;this.tj(c,0,0,this[r]+1E5,this[A]+1E5);a.a();d=new XJ(c);this[p](d,a);this.rb(1,1,1,1,new Rm({fill:Hh}),d);return c};
T.Zc=function(a,b,c){a[C](sf+h[D](b)+Je+h[D](c))};T.va=function(a,b,c){a[C](rf+h[D](b)+Je+h[D](c))};T.Cq=function(a,b,c,d,e,f,g){a[C](qB+h[D](b)+Je+h[D](c)+Je+h[D](d)+Je+h[D](e)+Je+h[D](f)+Je+h[D](g))};T.vi=function(a){a[C](hC)};
T.rm=function(a,b,c,d,e,f,g,k){f=oj(f,360);g=oj(g,360);var l=h[D](rj(f-90,d)),n=h[D](sj(f-90,e)),q=h[D](rj(g-90,d)),s=h[D](sj(g-90,e));d=h[D](d);e=h[D](e);b=h[D](b);c=h[D](c);l===q&&n===s&&(k&&180>oj(g-f,360)||!k&&180>oj(f-g,360))||a[C]((k?Ipa:lB)+(b-d)+Je+(c-e)+Je+(b+d)+Je+(c+e)+Je+(b+l)+Je+(c+n)+Je+(b+q)+Je+(c+s))};T.em=function(a,b,c){a[x].top=this.Rb(c);Ya(a[x],this.Rb(b))};T.sl=function(a,b){pa(a[x],this.Rb(b))};T.Ex=function(a,b){Sa(a[x],this.Rb(b))};T.jQ=function(a,b){Ya(a[x],this.Rb(b))};
T.kQ=function(a,b){a[x].top=this.Rb(b)};T.dd=function(a,b,c){0==c?Vv(a,!1):(Vv(a,!0),b&&Iw(a,b),dw(a,c))};T.hC=function(a,b){var c=this.fC;ra(c[Sb],a);var d=c[x];Ew(d,b.Va);Ja(d,this.Rb(b[uc]||0));Qw(d,b[Ed]?UC:O);Xw(d,b.Ic?uF:O);Ra(d,Dr);var e=c[Gd],c=c[Wd];Ra(d,R);b[Ed]&&(e*=1.1);b.Ic&&(e*=0.9);return new xk(e,c)};T.i0=function(){if(null!=this.Uu)return this.Uu;var a=Rk(Q,{style:zBa});this.fC[p](a);Ra(this.fC[x],Dr);this.Uu=a[zb]-a[Gd];Ra(this.fC[x],R);Zk(a);return this.Uu};
T.Rb=function(a){return h[D](a)+S};T.Vd=function(a){return this.pN[Qb](a)};
T.Ri=function(a,b,c){for(var d=a[td],e=0;e<d[J];e++)a[td][e][Nc]!=zE&&a[td][e][Nc]!=uI||a[Qd](d[e]);c=null!=c?c:!0;if(Vm(b)){if(Vv(a,!0),dw(a,b.Hb),Iw(a,b.Qd),c=!(Vm(b)&&1<=b.Ai),d=b.Hk!=ph,c||d)e=this.Vd(kBa),c&&mb(e,String(h[D](100*b.Ai))+we),d&&(e.dashstyle=hCa(b.Hk)),a[p](e)}else c&&Xm(b)?(Vv(a,!0),dw(a,1),Iw(a,b.gb())):Vv(a,!1);Qh(a.filled)&&Rv(a,!0);c=b.Qg;if(null!=c){b=this.Vd(YI);b[v](KD,c.lg);b[v](jsa,c.Tf);b[v](bh,c.Wy||1);b[v](Axa,c.Xy||1);var d=c.x1,e=c.y1,f=c.hb;c=c.kb;typeof d==rh&&
(d=la(d,10));typeof e==rh&&(e=la(e,10));typeof f==rh&&(f=la(f,10));typeof c==rh&&(c=la(c,10));c=tj(d,e,f,c);c=oj(270-c,360);b[v](xqa,c);b[v](Ah,PE);a[p](b)}else b.fe?(c=b.fe,b=this.Vd(YI),b[v](Ah,dh),b[v](KD,c.Hd()),b[v](jsa,c.qr()),c=Wn()+Zma+c.Ge+Oma,b[v](kI,c),a[p](b)):b.gb()==R?Rv(a,!1):Xm(b)?Wv(a,b.gb()):(c=this.Vd(YI),mb(c,String(h[D](100*b.Oe))+we),Xa(c,b.gb()),a[p](c))};T.tj=function(a,b,c,d,e){a=a[x];Ea(a,cg);Ya(a,this.Rb(b));a.top=this.Rb(c);pa(a,this.Rb(d));Sa(a,this.Rb(e))};T.qB=function(){return!0};
function hCa(a){if(Yh(a))return a[ie](ne);switch(a){case ph:return ph;case UD:return Dza;default:return hCa(ph)}};function vK(a,b,c,d){if(!(kk?0<=vi(pk,hna):lk?0<=vi(pk,ana):jk?0<=vi(pk,ona):mk&&0<=vi(pk,fna)))throw m("Graphics is not supported");for(var e=h[t](1E5*h[Cc]());ca[rz][poa+e];)e++;this.ak=poa+e;(a=this.m=a)&&(a.referencepoint=!0);Wa(this.m,O);this.Dp=b;this.hm=Ek(this.m);this.CX=this.ym=null;this.tr=!1;this.hO=[];this.si=null;this.mma=(b=kk?null!=fa[be]?9>fa[be]:!qk(We):!1)?uK:tK;if(this.fO=b||d)d=this.hm[Qb](lF),eb(d,this.ak),d.id=this.ak,pa(d,this.Dp[r][hc]()),Sa(d,this.Dp[A][hc]()),Aw(d,0),Lw(d,
LG),sw(d,0),gw(d,0),d.allowTransparency=zh,b||ab(d,Hva),this.hm[p](this.m,d),d=d[Nz]||d[dy][Hd],d[oq](),a=[],b?(a[C](Kna),a[C](iB),a[C](jB)):(a[C](Ena),a[C](Lna),a[C](mla),a[C](nla),a[C](iB)),a[C](Sna),a[C](uBa),a[C](zua),a[C](gla),a[C](Mh),a[C](Dna),a[C](fB),a[C](Fna),a[C](kla),a[C](bf),a[C](Ina),a[C](dB),a[C](gB),d[Cx](a[ie](me)),d[vy]();iCa(this,c)}X(vK,Us);function iCa(a,b){var c=W(a.Dra,a),d=W(a.Era,a);wK(c,d,b)}T=vK[K];
T.Era=function(){if(this.fO){var a;a=(a=this.hm.a(this.ak))?a[Nz]||a[dy][Hd]:null;var b=this.ym=a[gd](xya);b&&(b.referencepoint=!0);this.CX=xK(a[Pd],this.Dp)}else this.ym=this.hm[Qb](Q),zl(this.ym,eh,gh),Nl(this.ym,this.Dp),this.ym.dir=QF,this.m[p](this.ym),this.CX=xK(this.m,this.Dp);this.tr=!0};function xK(a,b){var c=Ek(a),d=c[Qb](Q),e=d[x];Ra(e,R);Ea(e,cg);e.top=b[A]+10+S;Ya(e,b[r]+10+S);cw(e,NG);e=c.$b();c[p](d,e[Cb](ne));c[p](a,d);return d}
T.Dra=function(){if(!this.fO)return!0;var a;return(a=(a=this.hm.a(this.ak))?a[dy]||Qk(a[Nz]||a[dy][Hd]):null)&&a._loaded};T.eb=function(a){if(!this.tr)return null;for(a=null!=a?a:0;this.hO[J]<=a;){var b=Ek(this.ym)[Qb](Q);zl(b,eh,cg);Dl(b,0,0);Nl(b,QA,QA);this.ym[p](b);b=new this.mma(b,this.CX);Vs(this,b);this.hO[C](b)}return this.hO[a]};T.Av=function(){if(!this.tr)return null;if(!this.si){var a;a=this.hm[Qb](Q);this.si=new sK(a);this.hm[p](this.m,this.si.ac())}return this.si};
T.Io=function(a,b){wK(W(function(){return null!=this.ym},this),a,b)};dx(T,function(a,b){if(!yk(this.Dp,a))if(this.Dp=a,this.fO){var c=this.hm.a(this.ak);c&&(pa(c,this.Dp[r][hc]()),Sa(c,this.Dp[A][hc]()))}else this.tr&&Nl(this.ym,this.Dp);this.tr||iCa(this,b)});function wK(a,b,c,d){a[L]()?b[L]():jCa(a,b,c,d)}function jCa(a,b,c,d){var e=null!=d?d:10;ca[Yp](c(function(){wK(a,b,c,e)}),e)}T.w=function(){this.hm.cd(this.m);Ws(this.si);Y(this.hO,function(a){Ws(a)});vK.e.w[L](this)};function yK(){this.Yc=[]}T=yK[K];T.qj=function(a,b){this.Yc[C]({brush:a,JX:b})};Gw(T,function(a,b){this.qj(null,ZJ(a,b))});T.Z=function(a,b,c){this.qj(a,{type:JF,data:{x:b,y:c}})};T.Zj=function(a,b,c,d,e,f,g){this.qj(a,{type:QD,data:{x1:b,y1:c,hb:d,kb:e,x:f,y:g}})};T.Wf=function(a,b,c,d,e,f,g,k){this.qj(a,{type:AC,data:{WA:b,XA:c,ji:d,ki:e,ew:f,Rq:g,c$:k}})};mw(T,function(a){var b=this.Yc[0].JX[Z];this.Z(a,b.x,b.y)});
function kCa(a){switch(a[H]){case HG:case JF:case QD:return a=a[Z],new sk(a.x,a.y);case AC:a=a[Z];var b=oj(a.Rq,360);return new sk(a.WA+rj(b-90,a.ji),a.XA+sj(b-90,a.ki));default:return new sk(0,0)}}
T.tc=function(a){for(var b=[],c=null,d=0;d<this.Yc[J];d++){var e=this.Yc[d],f=e.JX;if(f[H]==HG)c=kCa(f);else{t:{for(var e=e.brush,g=0;g<b[J];g++){var k=b[g];if(cfa(e,k.brush)){e=k;break t}}k={brush:e,Yc:new YJ,Gh:null};b[C](k);e=k}tk(e.Gh,c)||e.Yc[Yy](c.x,c.y);e.Yc.qj(f);c=e.Gh=kCa(f)}}if(Si(b))a=null;else if(1==b[J])a=a.tc(b[0].Yc,b[0].brush);else{c=a.za();for(d=0;d<b[J];d++)f=b[d],f=a.tc(f.Yc,f.brush),a[p](c,f);a=c.a()}return a};
function lCa(a){for(var b=new YJ,c=0;c<a.Yc[J];c++)b.qj(a.Yc[c].JX);return b};function mCa(a,b){var c=new YJ,d=a.Yc;if(0==d[J]||1==d[J])return c;for(var e=[null],f=0;f<d[J];f++){var g=d[f];g[Z]&&e[C](new sk(g[Z].x,g[Z].y))}e[C](null);var g=d[d[J]-1][H]==HD,f=e[1].o(),k=e[2].o(),l=e[e[J]-3].o(),n=e[e[J]-2].o();g?(e[0]=n,e[e[J]-1]=f):tk(f,n)?(e[0]=l,e[e[J]-1]=k):(e[0]=jK(new iK(f.x,f.y,k.x,k.y),-1),e[e[J]-1]=jK(new iK(n.x,n.y,l.x,l.y),-1));for(var k=0>b,q=null,s=null,n=null,l=e[J]-2,f=0;f<=l;f++)if(!tk(e[f],e[f+1])){var u;u=e[f];var w=e[f+1],z,B=(w.y-u.y)/(w.x-u.x);z=na(B)?{kl:B,
no:u.y-B*u.x}:{kl:ea,no:u.x};B=z.kl;z=z.no;if(B==ea)u={kl:ea,no:0>w.y-u.y?z+b:z-b};else{var F=b*h[ud](1+B*B);u={kl:B,no:0<w.x-u.x?z+F:z-F}}q?(w=zK(q,u),ai(w)?(B=zK(AK(s,e[f]),q),z=zK(AK(e[f],s),q),B=Bm(new zm(B.x,z.x),w.x)&&Bm(new zm(B.y,z.y),w.y)):B=w==ea,q=B&&w!=ea?w:zK(AK(e[f],s),q),c.qj(nCa(n,q)),B||(n=zK(AK(e[f],e[f+1]),u),c.Wf(e[f].x,e[f].y,h.abs(b),h.abs(b),180-180*h[sd](q.x-e[f].x,q.y-e[f].y)/h.PI,180-180*h[sd](n.x-e[f].x,n.y-e[f].y)/h.PI,k)),q=u,s=e[f],n=d[f]):(q=u,s=e[f],n=ZJ(d[f].x,d[f].y))}g&&
c[vy]();return c}function nCa(a,b){var c=Qj(a);switch(a[H]){case HG:case JF:c[Z].x=b.x;c[Z].y=b.y;break;case QD:c[Z].x=b.x;c[Z].y=b.y;var d=b.x-a[Z].x,e=b.y-a[Z].y;c[Z].x1+=d;c[Z].y1+=e;c[Z].hb+=d;c[Z].kb+=e}return c}function AK(a,b){var c=(a.x-b.x)/(b.y-a.y),d;na(c)?d=a.y-c*a.x:(c=ea,d=a.x);return{kl:c,no:d}}
function zK(a,b){var c=a.kl,d=a.no,e=b.kl,f=b.no;na(c)||(c=ea);na(e)||(e=ea);if(c==e||1E-5>=h.abs(c-e))return d==f||1E-5>=h.abs(d-f)?ea:null;if(c==ea)return new sk(d,e*d+f);if(e==ea)return new sk(f,c*f+d);var g=e-c;return new sk(-(f-d)/g,(d*e-c*f)/g)};var BK=function(){function a(a,b){if(-1===b[ld](Me))return b;var c=a[pc](Tq);c.pop();var d=b[pc](Tq),l=d.pop();if(d[0]===Me)d[he][Mc](d,[0,1][Ab](c));else{for(var n=0,q=d[J];n<q;n++)if(d[n]===Rq)c.pop(),d[he](n,1),n--;else break;d=c[Ab](d)}d[C](l);return d[ie](Tq)}function b(b,c,g){for(var k=[],l=0,n=c[J];l<n;l++)k[C](d[a(b,c[l])]);d[b]=g[Mc](this,k)}var c,d={};b(sH,[],function(){function a(b,c){if(!b||b.x1>=b.hb||b.y1>=b.kb)throw"Error constructing QuadTree: invalid bounds given.";this.v4=c||0;this.bounds=
b;this.nodes=ha(4);this.Tz=!1;bw(this,[])}function b(a,c){if(this.Tz){var d=this.KU(c);b[L](this[ry][d],a,c)}a[C][Mc](a,this[cy]);return a}kb(a,{insert:function(a){var b=a.Nk();if(this.Tz){var c=this.KU(b),c=this[ry][c],d=c[Sp];b.x1>=d.x1&&b.hb<=d.hb&&b.y1>=d.y1&&b.kb<=d.kb?c[wx](a):this[cy][C](a)}else if(this[cy][C](a),4>this.v4&&4<this[cy][J]){this[pc]();a=0;for(b=this[cy][J];a<b;a++)this[wx](this[cy][a]);bw(this,this[cy][J]>b?this[cy][he](b,this[cy][J]-b):[])}},clear:function(){bw(this,[]);if(this.Tz){for(var a=
0,b=this[ry][J];a<b;a++)this[ry][a][Wb]();delete this[ry];this.nodes=ha(4);this.Tz=!1}},query:function(a){return b[L](this,[],a)},KU:function(a){var b=!(a.y1>(this[Sp].y1+this[Sp].kb)/2),c=0;a.x1>(this[Sp].x1+this[Sp].hb)/2?c=b?1:2:b||(c=3);return c},split:function(){var b=(this[Sp].hb-this[Sp].x1)/2,c=(this[Sp].kb-this[Sp].y1)/2,d=this[Sp].x1,f=this[Sp].y1,q=this.v4+1;this[ry][0]=new a({x1:d,y1:f,hb:d+b,kb:f+c},q);this[ry][1]=new a({x1:d+b,y1:f,hb:d+b+b,kb:f+c},q);this[ry][2]=new a({x1:d+b,y1:f+
c,hb:d+b+b,kb:f+c+c},q);this[ry][3]=new a({x1:d,y1:f+c,hb:d+b,kb:f+c+c},q);this.Tz=!0},remove:function(a){var b=this[cy][ld](a);return 0<=b?(this[cy][he](b,1),!0):this.Tz?!this[ry][ce](function(b){return!b[Ob](a)}):!1}});return a});b(FD,[],function(){function a(){}function b(c){kb(a,c);return new a}function c(a){return function(){throw'abstract method "'+a+'" not implemented.';}}var d={};d.Vq=da[Up]||b;d.Bfa=c;d.vfa=function(a){for(var b=[Ata,Bta,Cta,Dta,Eta,Fta,uya,aAa,esa],d,e=0,f=b[J];e<f;e++)d=
b[e],a[K][d]=c(d)};return d});b(BH,[FD],function(a){function b(a,c,d){this.V=c;this.Oa=d}a.vfa(b);return b});b(tza,[FD],function(a){function b(a){this.DL={click:[],mousemove:[],mouseenter:[],mouseleave:[],box:[],redraw:[],remove:[]};ow(this,null);this.xa=null;yw(this,null);this.children=null;this.Ge=a||{}}function c(a){if(!this.DL[vc](a))throw'event type "'+a+'" unknown.';}ra(b[K],function(a){return void 0!==a?(this.xa=a,this):this.xa});lw(b[K],function(a,b){if(void 0!==b){var c=this.Ge,d;d=a[pc](Me);
for(var e=0,f=d[J];e<f;e++)if(e<f-1){if(typeof c[d[e]]!==$g||null==c[d[e]])c[d[e]]={};c=c[d[e]]}else c[d[e]]=b;this[Dy](yH,[this]);return this}c=this.Ge;if(null!=a)for(d=a[pc](Me),e=0,f=d[J];e<f&&typeof c===$g&&null!=c;e++)c=c[d[e]];return c});b[K].l=function(a,b){c[L](this,a);this.DL[a][C](b);return this};b[K].uc=function(a,b){c[L](this,a);for(var d=this.DL[a],e=0,f=d[J];e<f;e++)if(d[e]===b)return delete d[e],!0;return!1};b[K].Nk=function(){if(!this[Dy](aD,[this])||null==this.Of)if(!this.Rz()||null==
this.Of)throw"cannot determine bounding box until inserted into a scene.";return this.Of};b[K].Rz=function(){return!1};b[K].fireEvent=function(a,b){c[L](this,a);for(var d=this.DL[a],e=0,f=d[J];e<f;e++)d[e][Mc](this,b);return 0<f};b[K].o=a.Bfa(hsa);return b});b(wza,[FA,FD],function(a,b){function c(b,f){a[L](this,f);this.ng=b||[];this.OU=d[Zb](this)}function d(){this[Dy](yH,[this])}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=Doa;c[K].add=function(a){this.ng[C](a);a.l(yH,this.OU);this[Dy](yH,[this]);return this};
wa(c[K],function(){for(var a=0,b=this.ng[J];a<b;a++)this.ng[a].uc(yH,this.OU),this[Dy](AH,[this.ng[a]]);this.ng=[];this[Dy](yH,[this]);return this});va(c[K],function(a){a.uc(yH,this.OU);var b=this.ng[ld](a);if(0>b)throw"Shape does not exist.";this.ng[he](b,1);this[Dy](AH,[a]);return this});c[K].NU=function(){return this.ng};return c});b(uza,[FA,FD],function(a,b){function c(b,d,f,g){g=g||{};g.r=null==b?g.r:b;g.x=null==d?g.x:d;g.y=null==f?g.y:f;a[L](this,g)}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=foa;c[K].Rz=
function(){var a=this[x](fh),b=this[x](lJ),c=this[x](Jh);this.Of={x:b-a,y:c-a,width:2*a,height:2*a};return!0};return c});b(vza,[FA,FD],function(a,b){function c(b,d,f,g,s){s=s||{};s.rx=null==b?s.rx:b;s.ry=null==d?s.ry:d;s.x=null==f?s.x:f;s.y=null==g?s.y:g;a[L](this,s)}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=roa;c[K].Rz=function(){var a=this[x](MH),b=this[x](NH),c=this[x](lJ),d=this[x](Jh);this.Of={x:c-a,y:d-b,width:2*a,height:2*b};return!0};return c});b(xza,[FA,FD],function(a,b){function c(b,d,f,g,s){s=s||
{};s.x1=null==b?s.x1:b;s.y1=null==d?s.y1:d;s.x2=null==f?s.x2:f;s.y2=null==g?s.y2:g;a[L](this,s)}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=PB;c[K].Rz=function(){var a=this[x](mJ),b=this[x](oJ),c=this[x](nJ),d=this[x](pJ);this.Of={x:h.min(a,c),y:h.min(b,d),width:h.abs(c-a),height:h.abs(d-b)};return!0};return c});b(nG,[],function(){function a(b,c){var d=b%c;return 0>d*c?d+c:d}function b(c,d,f){c=a(c,360);d=a(d,360);d<c&&(d+=360);f=a(f,360);f<c&&(f+=360);return f<=d}return{EL:a,yfa:function(c,d,l,n,q,s,u){q=a(q,
360);s=a(s,360);var w=q/180*h.PI,z=q/180*h.PI,B=c+l*h.cos(w),w=d+n*h.sin(w),F=c+l*h.cos(z),z=d+n*h.sin(z);u||(u=q,q=s,s=u);u=b(q,s,0)?c+l:h.max(B,F);var M=b(q,s,90)?d+n:h.max(w,z);c=b(q,s,180)?c-l:h.min(B,F);d=b(q,s,270)?d-n:h.min(w,z);return{x1:c,y1:d,hb:u,kb:M}},zfa:function(a,b,c,d){function e(q){var w=1-q,z=w*w,B=q*q,F=z*w,z=3*q*z,w=3*w*B;q*=B;f[C](a.x*F+b.x*z+c.x*w+d.x*q);u[C](a.y*F+b.y*z+c.y*w+d.y*q)}var f=[a.x,d.x],u=[a.y,d.y],w=2*a.x-4*b.x+2*c.x,z=b.x-a.x,B=-a.x+3*b.x+d.x-3*c.x,F=(-w+h[ud](w*
w-4*z*B))/(2*B),w=(-w-h[ud](w*w-4*z*B))/(2*B);h.abs(F)>SA&&(F=0.5);h.abs(w)>SA&&(w=0.5);0<F&&1>F&&e(F);0<w&&1>w&&e(w);w=2*a.y-4*b.y+2*c.y;z=b.y-a.y;B=-a.y+3*b.y+d.y-3*c.y;F=(-w+h[ud](w*w-4*z*B))/(2*B);w=(-w-h[ud](w*w-4*z*B))/(2*B);h.abs(F)>SA&&(F=0.5);h.abs(w)>SA&&(w=0.5);0<F&&1>F&&e(F);0<w&&1>w&&e(w);F={x1:h.min[Mc](h,f),y1:h.min[Mc](h,u),hb:h.max[Mc](h,f),kb:h.max[Mc](h,u)};pa(F,F.hb-F.x1);Sa(F,F.kb-F.y1);return F}}});b(yza,[FA,FD,nG],function(a,b,c){function d(b){a[L](this,b);this.Of={x1:null,
y1:null,hb:null,kb:null,width:0,height:0};this.rt=[];this.Uz=null}function l(a){if(null==a)throw"Point cannot be null.";null==this.Of.x1&&(this.Of.x1=ea);null==this.Of.y1&&(this.Of.y1=ea);null==this.Of.hb&&(this.Of.hb=-ea);null==this.Of.kb&&(this.Of.kb=-ea);var b=h.min(this.Of.x1,a.x),c=h.min(this.Of.y1,a.y),d=h.max(this.Of.hb,a.x);a=h.max(this.Of.kb,a.y);this.Of={x1:b,y1:c,hb:d,kb:a,width:d-b,height:a-c}}function n(){var a=this.rt[this.rt[J]-1][pc](ne);switch(a[0]){case rf:l[L](this,this.Uz);l[L](this,
{x:a[1],y:a[2]});break;case qB:a=c.zfa(this.Uz,{x:+a[1],y:+a[2]},{x:+a[3],y:+a[4]},{x:+a[5],y:+a[6]});l[L](this,{x:a.x1,y:a.y1});l[L](this,{x:a.hb,y:a.kb});break;case df:a=c.yfa(+a[1],+a[2],+a[3],+a[4],+a[5],+a[6],+a[7]);l[L](this,{x:a.x1,y:a.y1});l[L](this,{x:a.hb,y:a.kb});break;default:throw"unknown command.";}}kb(d,b.Vq(a[K]));Ia(d[K],d);d.xh=Yoa;d[K].Rz=function(){return!0};Gw(d[K],function(a,b){this.rt[C](Poa+a+ne+b);this.Uz={x:a,y:b};return this});d[K].line=function(a,b){this.rt[C](Noa+a+ne+
b);n[L](this);this.Uz={x:a,y:b};return this};d[K].arc=function(a,b,d,e,f,k,l){f=c.EL(f,360);k=c.EL(k,360);this.rt[C](Una+a+ne+b+ne+d+ne+e+ne+f+ne+k+ne+ia(l));n[L](this);this.Uz={x:a,y:b};return this};mw(d[K],function(){this.rt[C](Vf);this.Uz=null;return this});return d});b(zza,[FA,FD],function(a,b){function c(b,d,f,g,s){s=s||{};s.x=null==b?s.x:b;s.y=null==d?s.y:d;pa(s,null==f?s[r]:f);Sa(s,null==g?s[A]:g);a[L](this,s)}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=fpa;c[K].Rz=function(){this.Of={x:this[x](lJ),y:this[x](Jh),
width:this[x](Ih),height:this[x](Hg)};return!0};c[K].o=function(){return new c(this[x](lJ),this[x](Jh),this[x](Ih),this[x](Hg),this[x]())};return c});b(Bza,[FA,FD],function(a,b){function c(b,d,f,g){g=g||{};g.x=null==b?g.x:b;g.y=null==d?g.y:d;Bw(g,null==f?g[cd]:f);a[L](this,g)}kb(c,b.Vq(a[K]));Ia(c[K],c);c.xh=cC;return c});b(bI,[Ima,GA,HA,IA,JA,KA,MA],function(a,b,c,d,l,n,q){return{h4:a,Circle:b,pF:c,ot:d,rU:l,Xj:n,Nv:q}});b(Pya,[],function(){function a(e,q,s){var u=q[x](mza)||0,w=q[x](lza)||0;if(u||
w){var z=q[x](oza)||q[x](nza)||q[x](pza)||0,B=q[x](rza)||q[x](qza)||q[x](sza)||0,F=[u,w,z,B][ie](),M=q.iw;if(q=M?c[F]:b[F])N=q[Sd](kF);else{q=fa[ny](gF,xg);var N=mya+(M?l++:d++);q[v](kF,N);var P=fa[ny](gF,cua);P[v](mF,rpa);P[v](bAa,u);u=fa[ny](gF,eua);u[v](Hta,z);u[v](Ita,B);if(null!=w){var ba=fa[ny](gF,aua),U=fa[ny](gF,bua);U[v](Ah,MF);U[v](Xza,w)}var z=fa[ny](gF,dua),B=fa[ny](gF,tE),qa=fa[ny](gF,tE);qa[v](mF,spa);q[p](P);q[p](u);null!=w&&(ba[p](U),q[p](ba));z[p](B);z[p](qa);q[p](z);for(M?c[F]=q:
b[F]=q;s[nd]!==xI;)s=s[fe];s=s[Pb]($D)||s;s[Eb](q,s[Sb])}e[v](xg,VI+N+Ge)}}var b={},c={},d=0,l=0;return{nta:a,Qz:function(b,c,d){var f=c[x](fua)||c[x](hua);typeof f!==rh&&typeof f!==Yg||b[v](zE,f);f=c[x](gua)||c[x](iua)||c[x](AE);typeof f!==rh&&typeof f!==Yg||b[v](AE,f);f=c[x](gAa)||c[x](jAa)||c[x](uI);typeof f!==rh&&typeof f!==Yg||b[v](uI,f);f=c[x](hAa)||c[x](kAa)||c[x](vI);typeof f!==rh&&typeof f!==Yg||b[v](vI,f);f=c[x](iAa)||c[x](lAa)||c[x](wI);typeof f!==rh&&typeof f!==Yg||b[v](wI,f);a(b,c,d)},
wfa:function(){for(var a in b)if(b[vc](a)){var c=b[a];c[fe][Qd](c);delete b[a]}d=0;b={}}}});b(Gya,[LA],function(a){function b(c,d,f){f=f||fa[ny](gF,ED);f[v](SD,c[x](lJ));f[v](TD,c[x](Jh));f[v](fh,c[x](fh));a.Qz(f,c,d);d&&d[p](f);return f}var c={};Ep(c,b);c.Mg=function(a,c,d){b(a,c,d);return[]};return c});b(Hya,[LA],function(a){function b(c,d,f){f=f||fa[ny](gF,kE);f[v](SD,c[x](lJ));f[v](TD,c[x](Jh));f[v](MH,c[x](MH));f[v](NH,c[x](NH));a.Qz(f,c,d);d&&d[p](f);return f}var c={};Ep(c,b);c.Mg=function(a,
c,d){b(a,c,d);return[]};return c});b(Jya,[LA],function(a){function b(c,d,f){f=f||fa[ny](gF,JF);f[v](mJ,c[x](mJ));f[v](oJ,c[x](oJ));f[v](nJ,c[x](nJ));f[v](pJ,c[x](pJ));a.Qz(f,c,d);d&&d[p](f);return f}var c={};Ep(c,b);c.Mg=function(a,c,d){b(a,c,d);return[]};return c});b(Lya,[nG,LA],function(a,b){return{u4:function(c,d,l){for(var n=l||fa[ny](gF,aH),q=d.rt,s=[],u=0,w=q[J];u<w;u++){var z=q[u];if(z[0]===df){var B=z[pc](ne),F=+B[1],M=+B[2],z=+B[3],N=+B[4],P=a.EL(+B[5],360),ba=a.EL(+B[6],360),B=!!+B[7],F=
F+h.cos(ba/180*h.PI)*z,M=M+h.sin(ba/180*h.PI)*N,P=B?ba-P:P-ba;0>P&&(P+=360);z=Una+z+ne+N+dla+ia(180<P)+ne+ia(B)+ne+F+ne+M}s[C](z)}l||n[v](ng,s[ie](ne));b.Qz(n,d,c);return n}}});b(Kya,[Jma,LA],function(a){function b(c,d,f){c=a.u4(d,c,f);d&&d[p](c);return c}var c={};Ep(c,b);c.Mg=function(a,c,d){b(a,c,d);return[]};return c});b(Aza,[JA],function(a){return{Afa:function(a){var b=a[x](Bsa)||0,c=a[x](Csa)||0,d=a[x](Dsa)||0,e=a[x](Esa)||0,q=a[x](vsa)||0,s=a[x](wsa)||0,u=a[x](xsa)||0;a=a[x](ysa)||0;return b||
c||d||e||q||s||u||a},xfa:function(b){var c=b[x](Bsa)||0,d=b[x](Csa)||0,l=b[x](Dsa)||0,n=b[x](Esa)||0,q=b[x](vsa)||0,s=b[x](wsa)||0,u=b[x](xsa)||0,w=b[x](ysa)||0,z=b[x](Ih),B=b[x](Hg),F=b[x](lJ),M=b[x](Jh),F=0<=z?F:F+z,M=0<=B?M:M+B,z=h.abs(z),B=h.abs(B);if(c+l>z)var N=z/(c+l),c=c*N,d=d*N,l=l*N,n=n*N;q+u>z&&(N=z/(q+u),q*=N,s*=N,u*=N,w*=N);d+s>B&&(N=B/(d+s),c*=N,d*=N,q*=N,s*=N);n+w>B&&(N=B/(n+w),l*=N,n*=N,u*=N,w*=N);return(new a(b[x]()))[Yy](F+z-l,M).arc(F+z-l,M+n,l,n,270,0,!0).line(F+z,M+B-w).arc(F+
z-u,M+B-w,u,w,0,90,!0).line(F+q,M+B).arc(F+q,M+B-s,q,s,90,180,!0).line(F,M+d).arc(F+c,M+d,c,d,180,270,!0)[vy]()}}});b(Mya,[Hma,Jma,LA],function(a,b,c){function d(k,l,s){var u=k[x](zsa),w=k[x](Asa),z=k[x](Ih),B=k[x](Hg),F=k[x](lJ),M=k[x](Jh),F=0<=z?F:F+z,M=0<=B?M:M+B,z=h.abs(z),B=h.abs(B);typeof u===Yg&&typeof w===Yg||!a.Afa(k)?(s=s||fa[ny](gF,vH),s[v](lJ,F),s[v](Jh,M),s[v](Ih,z),s[v](Hg,B),null!=u&&typeof u===Yg&&s[v](MH,u),null!=w&&typeof w===Yg&&s[v](NH,w),c.Qz(s,k,l)):(k=a.xfa(k),s=b.u4(l,k,s));
l&&l[p](s);return s}var l={};Ep(l,d);l.Mg=function(a,b,c){d(a,b,c);return[]};return l});b(Qya,[LA],function(a){function b(c,d,f,g,k,l){var B=f[x](rua)||f[x](tua)||f[x](GE),F=f[x](sua)||f[x](HE);g=g||fa[ny](gF,Es);g[v](lJ,null==k?f[x](lJ):k);g[v](Jh,null==l?f[x](Jh):l);g[v](sh,Ssa);g.textContent=d;a.Qz(g,f,c);typeof B===rh&&Ew(g[x],B);typeof F!==rh&&typeof F!==Yg||Ja(g[x],F);return g}function c(a,d,e,g,k){var l=null!=g;g=b(k,a,d,g,null,e);l||k[p](g);return g}function d(a,e,k){var l,w,z;z=a[x](Lwa)||
0;var B=a[x](Es)[pc](me),F=a[x](Jh),M=[];k=k||fa[ny](gF,Cg);e&&e[p](k);for(var N=0,P=B[J];N<P;N++){var ba=B[N];l=a;w=F;var U=k,qa=l[x](Lwa)||0,ya=l[x](Ih)||ea,Ha=c(ba,l,w,null,U),Aa=Ha.getBBox();if(Aa[r]>ya){for(var Wc=b(U,zA,l,Ha,100,100).getBBox(),ba=ba[pc](ne),Aa=[],cb=0,kc=ba[J];cb<kc;cb++)Aa[C](b(U,ba[cb],l,Ha,null,0).getBBox());for(var kd=[],Mb=0,cb=0,kc=ba[J];cb<kc;cb++){var Oc;if(Oc=1<cb-Mb){for(var Vd=Oc=0,Tf=Mb,Uf=h.min(cb,Aa[J]);Tf<Uf;Tf++)Oc=h.max(Oc,Aa[Tf][A]),0<Tf&&(Vd+=Wc[r]),Vd+=Aa[Tf][r];
Oc=Vd>ya}Oc&&(kd[C]([Mb,cb]),Mb=cb)}0<cb-Mb&&kd[C]([Mb,cb]);Aa=null;ya=[];cb=0;for(kc=kd[J];cb<kc;cb++){Wc=kd[cb];Ha=c(ba[dd](Wc[0],Wc[1])[ie](ne),l,w,0===cb?Ha:null,U);Vd=Ha.getBBox();w+=qa+Vd[A];ya[C](Ha);if(null==Aa)Wc=Vd;else{var Tf=Aa.x,Mb=Aa.y,Wc=Aa[r]+Tf,Aa=Aa[A]+Mb,Ce=Vd.x,Uf=Vd.y;Oc=Vd[r]+Ce;Vd=Vd[A]+Uf;Tf=h.min(Tf,Ce);Mb=h.min(Mb,Uf);Wc=h.max(Wc,Oc);Aa=h.max(Aa,Vd);Wc={x:Tf,y:Mb,width:Wc-Tf,height:Aa-Mb}}Aa=Wc}l=ya}else l=[Ha];w=Aa;U=0;for(qa=l[J];U<qa;U++)M[C](l[U]);F+=w[A]+z}z=k===e?M[0]:
k;e&&e[p](z);e=h.max(0,h.min(1,a[x](WE)||0));if(ga(e)||!na(e))e=0;B=a[x](bJ);if(typeof B===Yg){if(B=h.max(0,h.min(1,B)),ga(B)||!na(B))B=0}else B=LC;F=z.getBBox();k=a[x](Jh)-F.y;N=M[M[J]-1].getBBox().y-F.y;P=0;for(l=M[J];P<l;P++){w=M[P];U=w.getBBox();w[v](lJ,a[x](lJ)-U[r]*e);U=U.y;if(typeof B===Yg)U+=2*k,U-=F[A]*B;else if(B===LC)U=U+k-N;else throw"Unrecognized valign value: "+B;w[v](Jh,U)}M=a[x](Zya);null!=M&&0!=M&&z[v](xh,IH+M+ne+a[x](lJ)+ne+a[x](Jh)+Ge);return z}var l={};Ep(l,d);l.Mg=function(a,
b,c){for(;c&&c[Sb];)c[Qd](c[Sb]);d(a,b,c);return[]};return l});b(Iya,[GA,HA,IA,JA,KA,MA],function(a,b,c,d,l,n){var q={draw:function(a,b){var c=fa[ny](gF,Cg),d=[c];b[p](c);for(var e=a.ng,f=0,g=e[J];f<g;f++){var k=e[f];d[C](s[k[rc].xh][Nq](k,c))}return d},Mg:function(a){return a.ng}},s={Circle:a,Ellipse:b,Line:c,Path:d,Rect:l,Text:n,Group:q};return q});b(Nya,[bI,Ima,GA,HA,IA,JA,KA,MA],function(a,b,c,d,l,n,q,s){var u={};u[a.h4.xh]=b;u[a[Cz].xh]=c;u[a.pF.xh]=d;u[a.ot.xh]=l;u[a.rU.xh]=n;u[a.Xj.xh]=q;u[a.Nv.xh]=
s;return u});b(Oya,[sH,BH,FD,bI,Kma,LA],function(a,b,c,d,l,n){function q(c,d,g){b[L](this,c,d,g);var k=this.svg=fa[ny](gF,xI);k[v](Ih,d);k[v](Hg,g);F[L]({svg:c,Wq:{clear:function(){}}});k[p](fa[ny](gF,$D));c[p](k);c=u[Zb](this);k[Fq](Fr,c);k[Fq](EG,c);k[Fq](qxa,c);k[Fq](rxa,c);this.Wq=new a({x1:0,y1:0,hb:d,kb:g});this.st=[];this.elements=[]}function s(a){var b=this.st[ld](a);if(0>b)return!1;a.iw||(this[Wx][b][fe][Qd](this[Wx][b]),this.Wq[Ob](a));this.st[he](b,1);this[Wx][he](b,1);return!0}function u(a){for(var b=
{x1:a[lq],y1:a[mq],hb:a[lq],kb:a[mq]},c=[],d=a[Mq];d!==this.svg;)c[C](d),d=d[fe];for(var d=this.Wq.query(b),e=0,f=d[J];e<f;e++){var g=d[e];if(!(0>c[ld](B[L](this,g)))){g[Dy](a[H],[{point:{x:b.x1,y:b.y1}}]);break}}}function w(a){for(a=[a];0<a[J];){var b=a.pop(),c=b[rc].xh,d=B[L](this,b);a=a[Ab](l[c].Mg(b,this.svg,d)||[])}}function z(a){if(a[rc].xh!==Yoa){if(a.iw){var b;if(!this.w4){b=this.w4=fa[Qb](Q);Ea(b[x],cg);b[x].top=hma;Ya(b[x],hma);cw(b[x],NG);var c=fa[ny](gF,xI);b[p](c);fa[Pd][p](b)}b=this.w4;
Ra(b[x],Dr);c=l[a[rc].xh][Nq](a,b[Sb])}else c=B[L](this,a);var d=c.getBBox();a.Of={width:d[r],height:d[A],x:d.x,y:d.y};a.iw&&(Ra(b[x],R),c[wd][Qd](c))}}function B(a){a=this.st[ld](a);return 0>a?null:this[Wx][a]}function F(){for(var a=this.svg,b;a[Sb];)a[Sb][Nc]===$D&&(b=!0),a[Qd](a[Sb]);b&&a[p](fa[ny](gF,$D));this.st=[];this.elements=[];this.Wq[Wb]();n.wfa()}kb(q,c.Vq(b[K]));Ia(q[K],q);q[K].Rs=function(a){var b=B[L](this,a);if(b)return a[Dy](yH,[a]),a;var b=l[a[rc].xh][Nq](a,this.svg),b=[][Ab](b),
c=[a];for(a.NU&&(c=c[Ab](a.ng));0<c[J];){var d=c[rb](),e=b[rb]();if(d.NU&&e[rb])var f=e[rb](),b=b[Ab](e),c=c[Ab](d.ng),e=f;f=this.st[ld](d);if(0<=f){if(null!=this[Wx][f]||!d.iw)throw"Shape exists and is not a staged shape.";d.iw=!1;this[Wx][f]=e}else this.st[C](d),this[Wx][C](e);d.l(aD,z[Zb](this));d.l(yH,w[Zb](this));d.l(AH,s[Zb](this));this.Wq[wx](d)}return a};q[K].Zd=function(a,b,c,e){a=new d[Cz](a,b,c,e);return this.Rs(a)};q[K].Nj=function(a,b,c,e,f){a=new d.pF(a,b,c,e,f);return this.Rs(a)};q[K].rb=
function(a,b,c,e,f){a=new d.Xj(a,b,c,e,f);return this.Rs(a)};q[K].eK=function(a,b,c,e,f){a=new d.ot(a,b,c,e,f);return this.Rs(a)};q[K].Pd=function(a,b,c,e){c=new d.Nv(a,b,c,e);return this.Rs(c)};q[K].IU=s;q[K].Cfa=function(a){if(a.iw)throw m("can't stage a shape that's already staged.");if(-1!==this.st[ld](a))throw m("can't stage a shape that's already drawn.");a.iw=!0;this.st[C](a);this[Wx][C](null);a.l(aD,z[Zb](this))};wa(q[K],F);return q});b(zya,[],function(){return{draw:function(a,b){b[dz]();
b.arc(a.x,a.y,a.lt,0,2*h.PI,!1);b[Oy]();b[fc]()},Sz:function(a,b){var c=a.x-b.x,d=a.y-b.y;return h[ud](c*c+d*d)<=a.lt}}});b(Aya,[],function(){return{draw:function(a,b){b[qy]();b[dz]();b[jz](a.x-a.ji,a.y-a.ki);b[Fy](a.ji,a.ki);b.arc(1,1,1,0,2*h.PI,!1);ew(b,yA);b[fc]();b[Gy]()},Sz:function(a,b){var c=(b.x-a.x)/a.ji,d=(b.y-a.y)/a.ki;return 1>=c*c+d*d}}});b(Bya,[],function(){return{draw:function(a,b){b[qy]();b[dz]();b[Xx](a.x1,a.y1);b[Ry](a.hb,a.kb);b[Oy]();Hw(b,iya);b[Yb]();b[Gy]()},Sz:function(a,b){var c=
(a.y1-a.kb)/(a.x1-a.hb);return 0.5>h.abs(c*b.x+(a.y1-c*a.x1)-b.y)}}});b(Cya,[],function(){function a(b,c){c[dz]();for(var d=b.rt,e=0,n=d[J];e<n;e++){var q=d[e][pc](ne);switch(q[0]){case sf:c[Xx](q[1],q[2]);break;case rf:c[Ry](q[1],q[2]);break;case qB:c.bezierCurveTo(q[1],q[2],q[3],q[4],q[5],q[6]);break;case Vf:c[Oy]();return;default:throw'unknown path command "'+d[e]+'".';}}}return{draw:function(b,c){c[qy]();a(b,c);ew(c,bA);c[fc]();c[Gy]()},Sz:function(b,c){var d=fa[Qb](kD)[iz](VA);a(b,d);return d.isPointInPath(c.x,
c.y)||d.ota(c.x,c.y)}}});b(Dya,[],function(){return{draw:function(a,b){b[qy]();b[dz]();b[zz](a.x,a.y,a[r],a[A]);ew(b,cA);b[fc]();b[Gy]()},Sz:function(a,b){return b.x>a.x&&b.x<a.x+a[r]&&b.y>a.y&&b.y<a.y+a[A]}}});b(Fya,[],function(){return{draw:function(a,b){b.font=cna;b[Ex](a.zq,a.x,a.y)},Sz:function(a,b){var c=a.Nk();return b.x>c.x&&b.x<c.x+c[r]&&b.y>c.y&&b.y<c.y+c[A]}}});b(Eya,[GA,HA,IA,JA,KA,MA],function(a,b,c,d,l,n){return{Circle:a,pF:b,ot:c,rU:d,Xj:l,Nv:n}});b(yya,[sH,BH,FD,bI,Kma],function(a,
b,c,d,l){function n(c,d,g){b[L](this,c,d,g);var k=this.canvas=fa[Qb](kD);k[v](Ih,d);k[v](Hg,g);k[v](sh,Gma);c[p](k);this.hw=k[iz](VA);this.Wq=new a({x1:0,y1:0,hb:d,kb:g});this.all=[];c[Fq](Fr,s[Zb](this))}function q(a){this.all[C](a);a.l(aD,u[Zb](this));this.Wq[wx](a);return a}function s(a){var b={x:a[lq],y:a[mq]};a=[];for(var c=this.Wq.query({x1:b.x,y1:b.y,hb:b.x,kb:b.y}),d=0,e=c[J];d<e;d++){var f=c[d];l[f[rc][yd]].Sz(f,b)&&a[C](f)}if(a[J]){b=-1;c=a[0];d=0;for(e=a[J];d<e;d++)f=this.all[ld](a[d]),
f>b&&(b=f,c=a[d]);c[Dy](Fr)}}function u(a){a[rc][yd]===cC&&(a.Of={width:this.hw.measureText(a.zq)[r],height:12,x:a.x,y:a.y})}kb(n,c.Vq(b[K]));Ia(n[K],n);n[K].Rs=function(a){l[a[rc][yd]][Nq](a,this.hw);return q[L](this,a)};n[K].Zd=function(a,b,c){a=new d[Cz](a,b,c);l[Cz][Nq](a,this.hw);return q[L](this,a)};n[K].Nj=function(a,b,c,e){a=new d.pF(a,b,c,e);l.pF[Nq](a,this.hw);return q[L](this,a)};n[K].rb=function(a,b,c,e){a=new d.Xj(a,b,c,e);l.Xj[Nq](a,this.hw);return q[L](this,a)};n[K].eK=function(a,b,
c,e){a=new d.ot(a,b,c,e);l.ot[Nq](a,this.hw);return q[L](this,a)};n[K].IU=function(a){var b=this.all[ld](a);if(0>b)return!1;this.Wq[Ob](a);this.all[he](b,1);pa(this.canvas,this.canvas[r]);a=0;for(b=this.all[J];a<b;a++){var c=this.all[a];c&&l[c[rc][yd]][Nq](c,this.hw)}return!0};return n});b(bza,[Oya,yya,bI],function(a,b,d){function k(c,k,u,w){var z;u===xI?z=a:u===kD&&(z=b);n.G=z;n.Gg=d;n.X3=l;return new z(w,c,k)}function l(a){return function(b,c){var e=new d.Nv(0,0,b,c);a.Cfa(e);var f=e.Nk();a.IU(e);
delete f.x;delete f.y;return f}}var n=c=function(a,b,c,d,e){var f=function(){return this}(),g,l=!1;e&&e.fonts&&f.WebFont?WebFont[fd]({custom:{families:e.fonts},active:function(){g&&g(k(a,b,c,d))},fontinactive:function(){throw m("one or more fonts could not be loaded.");}}):l=!0;return{then:function(e){if(l)f[Yp](e[Zb](f,k(a,b,c,d)),0);else g=e}}};n.Gg=d});return c}();function CK(a,b,c,d){var e=this;(new BK(b[r]||0,b[A]||0,xI,a,d?{fonts:[XB,YB]}:void 0))[Az](function(a){e.Aw=a;e.Aw.vf=BK.Ac=BK.X3(e.Aw);e.ym={}})}X(CK,vK);T=CK[K];T.eb=function(){return this.Aw};T.Av=function(){return{}};T.Io=function(a,b){CK.e.Io[L](this,a,b)};dx(T,function(){});T.w=function(){};function DK(a,b,c,d,e){this.eg=!!b;a&&this[Lz](a,d);$v(this,void 0!=e?e:this.rk||0);this.eg&&$v(this,-1*this[Zx]);this.lS=!c}X(DK,zj);T=DK[K];xw(T,null);T.rk=0;T.a1=!1;bx(T,function(a,b,c){xw(this,a);a&&(this.rk=di(b)?b:1!=this[Ly][ed]?0:this.eg?-1:1);di(c)&&$v(this,c)});T.TP=function(a){xw(this,a[Ly]);this.rk=a.rk;$v(this,a[Zx]);this.eg=a.eg;this.lS=a.lS};T.o=function(){return new DK(this[Ly],this.eg,!this.lS,this.rk,this[Zx])};
Ga(T,function(){var a;if(this.a1){if(!this[Ly]||this.lS&&0==this[Zx])throw yj;a=this[Ly];var b=this.eg?-1:1;if(this.rk==b){var c=this.eg?a[yc]:a[Sb];c?this[Lz](c):this[Lz](a,-1*b)}else(c=this.eg?a[gc]:a[ac])?this[Lz](c):this[Lz](a[fe],-1*b);$v(this,this[Zx]+this.rk*(this.eg?-1:1))}else this.a1=!0;a=this[Ly];if(!this[Ly])throw yj;return a});Za(T,function(a){return a[Ly]==this[Ly]&&(!this[Ly]||a.rk==this.rk)});
T.splice=function(a){var b=this[Ly],c=this.eg?1:-1;this.rk==c&&(this.rk=-1*c,$v(this,this[Zx]+this.rk*(this.eg?-1:1)));this.eg=!this.eg;DK[K][oc][L](this);this.eg=!this.eg;for(var c=Zh(arguments[0])?arguments[0]:arguments,d=c[J]-1;0<=d;d--)Yk(c[d],b);Zk(b)};function EK(){}EK[K].vba=function(){return!1};EK[K].$b=function(){return Gk(kk?this.ac():this.Si())};EK[K].xB=function(){return Qk(this.$b())};EK[K].containsNode=function(a,b){return this.uC(oCa(a),b)};function pCa(a,b){DK[L](this,a,b,!0)}X(pCa,DK);function FK(a,b,c,d,e){var f;a&&(this.Nd=a,this.Md=b,this.qd=c,this.Ld=d,1==a[ed]&&a[Nc]!=ef&&(a=a[Xb],(b=a[b])?(this.Nd=b,this.Md=0):(a[J]&&(this.Nd=Ai(a)),f=!0)),1==c[ed]&&((this.qd=c[Xb][d])?this.Ld=0:this.qd=c));DK[L](this,e?this.qd:this.Nd,e,!0);if(f)try{this[oc]()}catch(g){if(g!=yj)throw g;}}X(FK,pCa);T=FK[K];T.Nd=null;T.qd=null;T.Md=0;T.Ld=0;T.Si=function(){return this.Nd};T.tl=function(){return this.qd};T.xma=function(){return this.a1&&this[Ly]==this.qd&&(!this.Ld||1!=this.rk)};
Ga(T,function(){if(this.xma())throw yj;return FK.e[oc][L](this)});T.TP=function(a){this.Nd=a.Nd;this.qd=a.qd;this.Md=a.Md;this.Ld=a.Ld;this.Vn=a.Vn;FK.e.TP[L](this,a)};T.o=function(){var a=new FK(this.Nd,this.Md,this.qd,this.Ld,this.Vn);a.TP(this);return a};function GK(){}GK[K].uC=function(a,b){var c=b&&!a[Py](),d=a.Sa;try{return c?0<=this.Gm(d,0,1)&&0>=this.Gm(d,1,0):0<=this.Gm(d,0,0)&&0>=this.Gm(d,1,1)}catch(e){if(!kk)throw e;return!1}};GK[K].containsNode=function(a,b){return this.uC(HK(a),b)};GK[K].fs=function(){return new FK(this.Si(),this.Em(),this.tl(),this.bo())};function IK(a){this.Sa=a}X(IK,GK);function JK(a){var b=Gk(a)[od]();if(3==a[ed])b[sz](a,0),b[zx](a,a[J]);else if(KK(a)){for(var c,d=a;(c=d[Sb])&&KK(c);)d=c;b[sz](d,0);for(d=a;(c=d[yc])&&KK(c);)d=c;b[zx](d,1==d[ed]?d[Xb][J]:d[J])}else c=a[fe],a=Ci(c[Xb],a),b[sz](c,a),b[zx](c,a+1);return b}function LK(a,b,c,d){var e=Gk(a)[od]();e[sz](a,b);e[zx](c,d);return e}T=IK[K];T.o=function(){return new this[rc](this.Sa.cloneRange())};T.ac=function(){return this.Sa.commonAncestorContainer};T.Si=function(){return this.Sa.startContainer};
T.Em=function(){return this.Sa.startOffset};T.tl=function(){return this.Sa.endContainer};T.bo=function(){return this.Sa.endOffset};T.Gm=function(a,b,c){return this.Sa.compareBoundaryPoints(1==c?1==b?Ph[Vc].START_TO_START:Ph[Vc].START_TO_END:1==b?Ph[Vc].END_TO_START:Ph[Vc].END_TO_END,a)};T.isCollapsed=function(){return this.Sa[vx]};T.Mu=function(){return this.Sa[hc]()};Xv(T,function(a){var b=Qk(Gk(this.Si()));this.EI(b[wz](),a)});T.EI=function(a){a.removeAllRanges();a.addRange(this.Sa)};Tv(T,function(a){this.Sa[tb](a)});function MK(a){this.Sa=a}X(MK,IK);MK[K].EI=function(a,b){if(!b||this[Py]())MK.e.EI[L](this,a,b);else a[tb](this.tl(),this.bo()),a[sx](this.Si(),this.Em())};function NK(a,b){this.Sa=a;this.wj=b}X(NK,GK);function OK(a){var b=Gk(a)[Pd].createTextRange();if(1==a[ed])b[ty](a),KK(a)&&!a[Xb][J]&&b[tb](!1);else{for(var c=0,d=a;d=d[gc];){var e=d[ed];if(3==e)c+=d[J];else if(1==e){b[ty](d);break}}d||b[ty](a[fe]);b[tb](!d);c&&b[Yy](rD,c);b[Hz](rD,a[J])}return b}T=NK[K];T.ms=null;T.Nd=null;T.qd=null;T.Md=-1;T.Ld=-1;T.o=function(){var a=new NK(this.Sa[ey](),this.wj);a.ms=this.ms;a.Nd=this.Nd;a.qd=this.qd;return a};
T.ac=function(){if(!this.ms){var a=this.Sa[cd],b=this.Sa[ey](),c=a[vb](/ +$/,O);(c=a[J]-c[J])&&b[Hz](rD,-c);c=b[wd]();b=b.htmlText[vb](/(\r\n|\r|\n)+/g,ne)[J];if(this[Py]()&&0<b)return this.ms=c;for(;b>c.outerHTML[vb](/(\r\n|\r|\n)+/g,ne)[J];)c=c[fe];for(;1==c[Xb][J]&&c.innerText==qCa(c[Sb])&&KK(c[Sb]);)c=c[Sb];0==a[J]&&(c=rCa(this,c));this.ms=c}return this.ms};
function rCa(a,b){for(var c=b[Xb],d=0,e=c[J];d<e;d++){var f=c[d];if(KK(f)){var g=OK(f),k=g.htmlText!=f.outerHTML;if(a[Py]()&&k?0<=a.Gm(g,1,1)&&0>=a.Gm(g,1,0):a.Sa[qx](g))return rCa(a,f)}}return b}T.Si=function(){this.Nd||(this.Nd=PK(this,1),this[Py]()&&(this.qd=this.Nd));return this.Nd};T.Em=function(){0>this.Md&&(this.Md=this.WC(1),this[Py]()&&(this.Ld=this.Md));return this.Md};T.tl=function(){if(this[Py]())return this.Si();this.qd||(this.qd=PK(this,0));return this.qd};
T.bo=function(){if(this[Py]())return this.Em();0>this.Ld&&(this.Ld=this.WC(0),this[Py]()&&(this.Md=this.Ld));return this.Ld};T.Gm=function(a,b,c){return this.Sa[Jz]((1==b?aC:MB)+dC+(1==c?aC:MB),a)};
function PK(a,b,c){c=c||a.ac();if(!c||!c[Sb])return c;for(var d=1==b,e=0,f=c[Xb][J];e<f;e++){var g=d?e:f-e-1,k=c[Xb][g],l;try{l=HK(k)}catch(n){continue}var q=l.Sa;if(a[Py]())if(!KK(k)){if(0==a.Gm(q,1,1)){a.Md=a.Ld=g;break}}else{if(l.uC(a))return PK(a,b,k)}else{if(a.uC(l)){if(!KK(k)){d?a.Md=g:a.Ld=g+1;break}return PK(a,b,k)}if(0>a.Gm(q,1,0)&&0<a.Gm(q,0,1))return PK(a,b,k)}}return c}
T.WC=function(a,b){var c=1==a,d=b||(c?this.Si():this.tl());if(1==d[ed]){for(var d=d[Xb],e=d[J],f=c?1:-1,g=c?0:e-1;0<=g&&g<e;g+=f){var k=d[g];if(!KK(k)&&0==this.Sa[Jz]((1==a?aC:MB)+dC+(1==a?aC:MB),HK(k).Sa))return c?g:g+1}return-1==g?0:g}e=this.Sa[ey]();f=OK(d);e.setEndPoint(c?soa:vpa,f);e=e[cd][J];return c?d[J]-e:e};function qCa(a){return 3==a[ed]?a[Yc]:a.innerText}T.isCollapsed=function(){return 0==this.Sa[Jz](upa,this.Sa)};T.Mu=function(){return this.Sa[cd]};Xv(T,function(){this.Sa[Gx]()});
Tv(T,function(a){this.Sa[tb](a);a?(this.qd=this.Nd,this.Ld=this.Md):(this.Nd=this.qd,this.Md=this.Ld)});function QK(a){this.Sa=a}X(QK,IK);QK[K].EI=function(a){a[tb](this.Si(),this.Em());this.tl()==this.Si()&&this.bo()==this.Em()||a[sx](this.tl(),this.bo());0==a.rangeCount&&a.addRange(this.Sa)};function RK(a){this.Sa=a}X(RK,IK);RK[K].Gm=function(a,b,c){return qk(Vq)?RK.e.Gm[L](this,a,b,c):this.Sa.compareBoundaryPoints(1==c?1==b?Ph[Vc].START_TO_START:Ph[Vc].END_TO_START:1==b?Ph[Vc].START_TO_END:Ph[Vc].END_TO_END,a)};RK[K].EI=function(a,b){a.removeAllRanges();b?a.setBaseAndExtent(this.tl(),this.bo(),this.Si(),this.Em()):a.setBaseAndExtent(this.Si(),this.Em(),this.tl(),this.bo())};function HK(a){if(kk&&!rk(9)){var b=new NK(OK(a),Gk(a));if(KK(a)){for(var c,d=a;(c=d[Sb])&&KK(c);)d=c;b.Nd=d;b.Md=0;for(d=a;(c=d[yc])&&KK(c);)d=c;b.qd=d;b.Ld=1==d[ed]?d[Xb][J]:d[J];b.ms=a}else b.Nd=b.qd=b.ms=a[fe],b.Md=Ci(b.ms[Xb],a),b.Ld=b.Md+1;a=b}else a=mk?new RK(JK(a)):lk?new MK(JK(a)):jk?new QK(JK(a)):new IK(JK(a));return a}function KK(a){return Uk(a)||3==a[ed]};function SK(){}X(SK,EK);T=SK[K];T.$x=null;T.Nd=null;T.Md=null;T.qd=null;T.Ld=null;T.Vn=!1;T.o=function(){var a=new SK;a.$x=this.$x;a.Nd=this.Nd;a.Md=this.Md;a.qd=this.qd;a.Ld=this.Ld;a.Vn=this.Vn;return a};T.Vb=function(){return Es};
function TK(a){var b;if(!(b=a.$x)){b=a.Si();var c=a.Em(),d=a.tl(),e=a.bo();if(kk&&!rk(9)){var f=b,g=c,k=d,l=e,n=!1;1==f[ed]&&(g=f[Xb][g],n=!g,f=g||f[yc]||f,g=0);var q=OK(f);g&&q[Yy](rD,g);if(f==k&&g==l)q[tb](!0);else n&&q[tb](!1),n=!1,1==k[ed]&&(k=(g=k[Xb][l])||k[yc]||k,l=0,n=!g),f=OK(k),f[tb](!n),l&&f[Hz](rD,l),q.setEndPoint(soa,f);l=new NK(q,Gk(b));l.Nd=b;l.Md=c;l.qd=d;l.Ld=e;b=l}else b=mk?new RK(LK(b,c,d,e)):lk?new MK(LK(b,c,d,e)):jk?new QK(LK(b,c,d,e)):new IK(LK(b,c,d,e));b=a.$x=b}return b}
T.ac=function(){return TK(this).ac()};T.Si=function(){return this.Nd||(this.Nd=TK(this).Si())};T.Em=function(){return null!=this.Md?this.Md:this.Md=TK(this).Em()};T.tl=function(){return this.qd||(this.qd=TK(this).tl())};T.bo=function(){return null!=this.Ld?this.Ld:this.Ld=TK(this).bo()};T.vba=function(){return this.Vn};T.uC=function(a,b){var c=a.Vb();return c==Es?TK(this).uC(TK(a),b):c==lha?(c=a.j_(),(b?Mi:Ni)(c,function(a){return this.containsNode(a,b)},this)):!1};T.isCollapsed=function(){return TK(this)[Py]()};
T.Mu=function(){return TK(this).Mu()};T.fs=function(){return new FK(this.Si(),this.Em(),this.tl(),this.bo())};Xv(T,function(){TK(this)[Gx](this.Vn)});Tv(T,function(a){a=this.vba()?!a:a;this.$x&&this.$x[tb](a);a?(this.qd=this.Nd,this.Ld=this.Md):(this.Nd=this.qd,this.Md=this.Ld);this.Vn=!1});function oCa(a){a=HK(a);var b=new SK;b.$x=a;b.Vn=!1;return b}function sCa(a,b,c,d){if(a==c)return d<b;var e;if(1==a[ed]&&b)if(e=a[Xb][b])a=e,b=0;else if(dl(a,c))return!0;if(1==c[ed]&&d)if(e=c[Xb][d])c=e,d=0;else if(dl(c,a))return!1;return 0<(uea(a,c)||b-d)};function UK(){}Uh(UK);UK[K].hqa=0;function VK(a){rt[L](this);this.P=a||Ek();this.jo=tCa}X(VK,rt);VK[K].gqa=UK.Xb();var tCa=null;function uCa(a,b){switch(a){case 1:return b?dE:mE;case 2:return b?bF:UI;case 4:return b?rqa:Zsa;case 8:return b?As:aBa;case 16:return b?Yra:$Aa;case 32:return b?zg:TC;case 64:return b?Bxa:HD}throw m("Invalid component state");}T=VK[K];T.bc=null;T.yb=!1;T.q=null;T.jo=null;T.Uk=null;T.Kd=null;T.ie=null;T.un=null;T.K5=!1;Yw(T,function(){return this.bc||(this.bc=Xe+(this.gqa.hqa++)[hc](36))});
T.jw=function(a){this.Kd&&this.Kd.un&&(Lj(this.Kd.un,this.bc),Mj(this.Kd.un,a,this));this.bc=a};T.a=function(){return this.q};T.Kv=function(a){return this.q?this.P.Kv(a,this.q):null};T.hc=function(){this.Lw||(this.Lw=new sv(this));return this.Lw};function WK(a,b){if(a==b)throw m(Epa);if(b&&a.Kd&&a.bc&&a.Kd.ut(a.bc)&&a.Kd!=b)throw m(Epa);a.Kd=b;VK.e.Az[L](a,b)}T.getParent=function(){return this.Kd};T.Az=function(a){if(this.Kd&&this.Kd!=a)throw m("Method not supported");VK.e.Az[L](this,a)};T.ea=function(){return this.P};
T.h=function(){this.q=this.P[Qb](Q)};T.B=function(a){this.Hy(a)};T.Hy=function(a,b){if(this.yb)throw m(KB);this.q||this.h();a?a[Eb](this.q,b||null):this.P.$b()[Pd][p](this.q);this.Kd&&!this.Kd.yb||this.Bb()};T.Ia=function(a){if(this.yb)throw m(KB);if(a&&this.Ah(a)){this.K5=!0;var b=Gk(a);this.P&&this.P.$b()==b||(this.P=Ek(a));this.mf(a);this.Bb()}else throw m("Invalid element to decorate");};T.Ah=function(){return!0};T.mf=function(a){this.q=a};
T.Bb=function(){this.yb=!0;XK(this,function(a){!a.yb&&a.a()&&a.Bb()})};T.ve=function(){XK(this,function(a){a.yb&&a.ve()});this.Lw&&this.Lw.oc();this.yb=!1};T.w=function(){this.yb&&this.ve();this.Lw&&(this.Lw.W(),delete this.Lw);XK(this,function(a){a.W()});!this.K5&&this.q&&Zk(this.q);this.Kd=this.Uk=this.q=this.un=this.ie=null;VK.e.w[L](this)};function YK(a){return a.Uk}T.ua=function(a,b){this.qx(a,this.Zf(),b)};
T.qx=function(a,b,c){if(a.yb&&(c||!this.yb))throw m(KB);if(0>b||b>this.Zf())throw m("Child component index out of bounds");this.un&&this.ie||(this.un={},this.ie=[]);if(a[mx]()==this){var d=a[Fz]();this.un[d]=a;Wi(this.ie,a)}else Mj(this.un,a[Fz](),a);WK(a,this);Ui(this.ie,a,b);a.yb&&this.yb&&a[mx]()==this?(c=this.$a(),c[Eb](a.a(),c[Xb][b]||null)):c?(this.q||this.h(),b=this.ff(b+1),a.Hy(this.$a(),b?b.q:null)):this.yb&&!a.yb&&a.q&&a.q[fe]&&1==a.q[fe][ed]&&a.Bb()};T.$a=function(){return this.q};
T.Lg=function(){null==this.jo&&(this.jo=Kl(this.yb?this.q:this.P.$b()[Pd]));return this.jo};T.rv=function(a){if(this.yb)throw m(KB);this.jo=a};T.Zf=function(){return this.ie?this.ie[J]:0};T.ut=function(a){return this.un&&a?Nj(this.un,a)||null:null};T.ff=function(a){return this.ie?this.ie[a]||null:null};function XK(a,b,c){a.ie&&Y(a.ie,b,c)}function ZK(a,b){return a.ie&&b?Ci(a.ie,b):-1}
T.removeChild=function(a,b){if(a){var c=bi(a)?a:a[Fz]();a=this.ut(c);c&&a&&(Lj(this.un,c),Wi(this.ie,a),b&&(a.ve(),a.q&&Zk(a.q)),WK(a,null))}if(!a)throw m("Child is not in parent component");return a};function vCa(a,b){return a[Qd](a.ff(0),b)}T.cd=function(a){for(var b=[];this.ie&&0!=this.ie[J];)b[C](vCa(this,a));return b};var $K;function aL(a,b){b?a[v](ih,b):a[Pc](ih)}function bL(a,b,c){Zh(c)&&(c=c[ie](ne));var d=Jba+b;if(c===O||void 0==c)$K||($K={atomic:!1,autocomplete:R,dropeffect:R,haspopup:!1,live:OG,multiline:!1,multiselectable:!1,orientation:Eh,readonly:!1,relevant:sqa,required:!1,sort:R,busy:!1,disabled:!1,hidden:!1,invalid:wg}),c=$K,b in c?a[v](d,c[b]):a[Pc](d);else a[v](d,c)}function cL(a){a=a[Sd](DC);return null==a||void 0==a?O:String(a)};function dL(a){if(a[ox])return a[ox];a=a[Fd];return bi(a)&&a[Ib](/\S+/g)||[]}function wCa(a,b){lb(a,b)}function eL(a,b){return a[ox]?a[ox][Lc](b):Ri(dL(a),b)}function fL(a,b){a[ox]?a[ox].add(b):eL(a,b)||lb(a,a[Fd]+(0<a[Fd][J]?ne+b:b))}function gL(a,b){if(a[ox])Y(b,function(b){fL(a,b)});else{var c={};Y(dL(a),function(a){c[a]=!0});Y(b,function(a){c[a]=!0});lb(a,O);for(var d in c)lb(a,a[Fd]+(0<a[Fd][J]?ne+d:d))}}
function hL(a,b){if(a[ox])a[ox][Ob](b);else eL(a,b)&&lb(a,Fi(dL(a),function(a){return a!=b})[ie](ne))}function iL(a,b){a[ox]?Y(b,function(b){hL(a,b)}):lb(a,Fi(dL(a),function(a){return!Ri(b,a)})[ie](ne))}function jL(a,b,c){c?fL(a,b):hL(a,b)};function kL(a,b,c){rt[L](this);Dp(this,a);this.handle=b||a;this.B0=c||new vl(ja,ja,ja,ja);this.of=Gk(a);this.C=new sv(this);Vs(this,this.C);kt(this[py],[QI,es],this.n8,!1,this)}X(kL,rt);var lL=kk||lk&&qk("1.9.3");T=kL[K];xp(T,0);yp(T,0);fp(T,0);gp(T,0);T.Qt=0;T.Tl=0;T.Nt=0;T.lr=0;T.qg=!0;T.Ep=!1;T.p9=0;T.zM=0;T.Gka=!1;T.nx=!1;T.wt=function(a){this.nx=a};T.hc=function(){return this.C};function mL(a,b){a.B0=b||new vl(ja,ja,ja,ja)}T.Ga=function(a){this.qg=a};
T.w=function(){kL.e.w[L](this);ot(this[py],[QI,es],this.n8,!1,this);this.C.oc();lL&&this.of.releaseCapture();Dp(this,null);this.handle=null};T.sG=function(){Qh(this.jo)||(this.jo=Kl(this[Mq]));return this.jo};
T.n8=function(a){var b=a[H]==es;if(!this.qg||this.Ep||b&&!bt(a))this[$](Jta);else{nL(a);if(0==this.p9)if(this[$](new oL(nI,this,a[zd],a[Ad],a)))this.Ep=!0,a[Hp]();else return;else a[Hp]();var b=this.of,c=b[dc],d=!lL;this.C.l(b,[RAa,EG],this.EK,d);this.C.l(b,[QAa,FG],this.zP,d);lL?(c.setCapture(!1),this.C.l(c,Swa,this.zP)):this.C.l(Qk(b),TC,this.zP);kk&&this.Gka&&this.C.l(b,zta,Ys);this.Ika&&this.C.l(this.Ika,SH,this.Hka,d);xp(this,this.Qt=a[zd]);yp(this,this.Tl=a[Ad]);fp(this,a[Gb]);gp(this,a[Hb]);
this.Nt=this.nx?RBa(this[Mq]):this[Mq][Od];this.lr=this[Mq][Tc];this.kZ=ql(Ek(this.of));this.zM=hi()}};T.zP=function(a){this.C.oc();lL&&this.of.releaseCapture();if(this.Ep){nL(a);this.Ep=!1;var b=xCa(this,this.Nt),c=yCa(this,this.lr);this[$](new oL(oE,this,a[zd],a[Ad],a,b,c))}else this[$](Jta)};function nL(a){var b=a[H];b==QI||b==RAa?a[Fc](a.Ka[Fb][0],a[Dq]):b!=QAa&&b!=PAa||a[Fc](a.Ka.changedTouches[0],a[Dq])}
T.EK=function(a){if(this.qg){nL(a);var b=(this.nx&&this.sG()?-1:1)*(a[zd]-this[zd]),c=a[Ad]-this[Ad];xp(this,a[zd]);yp(this,a[Ad]);fp(this,a[Gb]);gp(this,a[Hb]);if(!this.Ep){var d=this.Qt-this[zd],e=this.Tl-this[Ad];if(d*d+e*e>this.p9)if(this[$](new oL(nI,this,a[zd],a[Ad],a)))this.Ep=!0;else{this.Mj||this.zP(a);return}}c=zCa(this,b,c);b=c.x;c=c.y;this.Ep&&this[$](new oL(MC,this,a[zd],a[Ad],a,b,c))&&(ACa(this,a,b,c),a[Hp]())}};
function zCa(a,b,c){var d=ql(Ek(a.of));b+=d.x-a.kZ.x;c+=d.y-a.kZ.y;a.kZ=d;a.Nt+=b;a.lr+=c;b=xCa(a,a.Nt);a=yCa(a,a.lr);return new sk(b,a)}T.Hka=function(a){var b=zCa(this,0,0);xp(a,this[zd]);yp(a,this[Ad]);ACa(this,a,b.x,b.y)};function ACa(a,b,c,d){a.Jw(c,d);a[$](new oL(iE,a,b[zd],b[Ad],b,c,d))}function xCa(a,b){var c=a.B0,d=ga(c[G])?null:c[G],c=ga(c[r])?0:c[r];return h.min(null!=d?d+c:ea,h.max(null!=d?d:-ea,b))}
function yCa(a,b){var c=a.B0,d=ga(c.top)?null:c.top,c=ga(c[A])?0:c[A];return h.min(null!=d?d+c:ea,h.max(null!=d?d:-ea,b))}T.Jw=function(a,b){this.nx&&this.sG()?Ta(this[Mq][x],a+S):Ya(this[Mq][x],a+S);this[Mq][x].top=b+S};function oL(a,b,c,d,e,f,g){Xs[L](this,a);xp(this,c);yp(this,d);this.xja=e;Ya(this,Qh(f)?f:b.Nt);this.top=Qh(g)?g:b.lr;this.XX=b}X(oL,Xs);function pL(a){rt[L](this);this.q=a;a=kk?Pr:TC;this.Dja=kt(this.q,kk?Or:zg,this,!kk);this.Eja=kt(this.q,a,this,!kk)}X(pL,rt);kp(pL[K],function(a){var b=new $s(a.Ka);ab(b,a[H]==Or||a[H]==zg?Or:Pr);this[$](b)});pL[K].w=function(){pL.e.w[L](this);pt(this.Dja);pt(this.Eja);delete this.q};function qL(a,b){VK[L](this,b);this.hla=!!a;this.$H=null}X(qL,VK);T=qL[K];T.dV=null;T.Rd=!1;T.Vk=null;T.Ii=null;T.Dn=null;T.QY=!1;T.$=function(){return eqa};T.xA=function(){return this.Vk};T.h=function(){qL.e.h[L](this);var a=this.a(),b=pi(this.$())[pc](ne);gL(a,b);gl(a,!0);Sl(a,!1);BCa(this);CCa(this)};function BCa(a){if(a.hla&&!a.Ii){var b;b=a.ea().h(lF,{frameborder:0,style:mra,src:Rva});a.Ii=b;lb(a.Ii,a.$()+jma);Sl(a.Ii,!1);Rl(a.Ii,0)}a.Vk||(a.Vk=a.ea().h(Q,a.$()+jma),Sl(a.Vk,!1))}
function CCa(a){a.Dn||(a.Dn=a.ea()[Qb](Bs),Sl(a.Dn,!1),gl(a.Dn,!0),Ea(a.Dn[x],cg))}T.g9=function(){this.QY=!1};T.Ah=function(a){return!!a&&a[Nc]==kf};T.mf=function(a){qL.e.mf[L](this,a);a=pi(this.$())[pc](ne);gL(this.a(),a);BCa(this);CCa(this);Sl(this.a(),!1)};T.Bb=function(){this.Ii&&Xk(this.Ii,this.a());Xk(this.Vk,this.a());qL.e.Bb[L](this);Yk(this.Dn,this.a());this.dV=new pL(this.ea().$b());this.hc().l(this.dV,Or,this.Aga);rL(this,!1)};
T.ve=function(){this.O()&&this[hy](!1);Ws(this.dV);qL.e.ve[L](this);Zk(this.Ii);Zk(this.Vk);Zk(this.Dn)};fw(T,function(a){a!=this.Rd&&(this.Gw&&this.Gw[Hq](),this.KA&&this.KA[Hq](),this.Uw&&this.Uw[Hq](),this.lB&&this.lB[Hq](),this.yb&&rL(this,a),a?this.R0():this.lC())});function rL(a,b){for(var c=a.ea().$b()[Pd][Sb];c;c=c[ac])if(1==c[ed]){var d=c;b?bL(d,Ig,b):d[Pc](Zqa)}c=a.q;(d=!b)?bL(c,Ig,d):c[Pc](Zqa)}T.NM=function(a,b,c,d){this.Gw=a;this.Uw=b;this.KA=c;this.lB=d};
T.R0=function(){if(this[$](OC)){try{this.$H=this.ea().$b()[pb]}catch(a){}this.YY();this.Ie();this.hc().l(this.ea().xB(),CH,this.YY);DCa(this,!0);this[Fx]();this.Rd=!0;this.Gw&&this.KA?(nt(this.Gw,oE,this.kO,!1,this),this.KA[fz](),this.Gw[fz]()):this.kO()}};
T.lC=function(){if(this[$](NC)){this.hc().uc(this.ea().xB(),CH,this.YY);this.Rd=!1;this.Uw&&this.lB?(nt(this.Uw,oE,this.LO,!1,this),this.lB[fz](),this.Uw[fz]()):this.LO();try{var a=this.ea().$b()[Pd],b=this.ea().$b()[pb]||a;this.$H&&b==a&&this.$H!=a&&this.$H[Fx]()}catch(c){}this.$H=null}};function DCa(a,b){a.Ii&&Sl(a.Ii,b);a.Vk&&Sl(a.Vk,b);Sl(a.a(),b);Sl(a.Dn,b)}T.kO=function(){this[$](cI)};T.LO=function(){DCa(this,!1);this[$]($E)};T.O=function(){return this.Rd};T.focus=function(){this.mda()};
T.YY=function(){this.Ii&&Sl(this.Ii,!1);this.Vk&&Sl(this.Vk,!1);var a=this.ea().$b(),b=Pk(Qk(a)||ca||ca),c=h.max(b[r],h.max(a[Pd][Bc],a[dc][Bc])),a=h.max(b[A],h.max(a[Pd][Rb],a[dc][Rb]));this.Ii&&(Sl(this.Ii,!0),Nl(this.Ii,c,a));this.Vk&&(Sl(this.Vk,!0),Nl(this.Vk,c,a))};T.Ie=function(){var a=this.ea().$b(),b=Qk(a)||ca;if(Cl(this.a())==yg)var c=a=0;else c=ql(this.ea()),a=c.x,c=c.y;var d=Ol(this.a()),b=Pk(b||ca),a=h.max(a+b[r]/2-d[r]/2,0),c=h.max(c+b[A]/2-d[A]/2,0);Dl(this.a(),a,c);Dl(this.Dn,a,c)};
T.Aga=function(a){this.QY?this.g9():a[Mq]==this.Dn&&ut(this.mda,0,this)};T.mda=function(){try{kk&&this.ea().$b()[Pd][Fx](),this.a()[Fx]()}catch(a){}};T.w=function(){Ws(this.Gw);this.Gw=null;Ws(this.Uw);this.Uw=null;Ws(this.KA);this.KA=null;Ws(this.lB);this.lB=null;qL.e.w[L](this)};function sL(a,b,c){qL[L](this,b,c);this.hj=a||pxa;this.Mh=(new tL).Ti(uL,!0).Ti(vL,!1,!0)}X(sL,qL);T=sL[K];T.oka=!0;T.RD=!0;T.DD=!0;T.O5=!0;T.kL=0.5;T.Bf=O;T.ph=null;T.rj=null;T.gH=!1;T.$j=null;T.ej=null;T.lL=null;T.wi=null;T.ck=null;T.kh=null;T.bK="dialog";T.$=function(){return this.hj};T.setTitle=function(a){this.Bf=a;this.ej&&el(this.ej,a)};T.getTitle=function(){return this.Bf};Nw(T,function(a){this.ph=a=yJ(a,null);this.ck&&AJ(this.ck,a)});Ow(T,function(){return null!=this.ph?wJ(this.ph):O});
T.vv=function(){return this.bK};T.iea=function(a){this.bK=a};function wL(a){a.a()||a.B()}T.$a=function(){wL(this);return this.ck};function ECa(a){wL(a);return a.a()}T.xA=function(){wL(this);return sL.e.xA[L](this)};function xL(a,b){a.kL=b;if(a.a()){var c=a.xA();c&&Rl(c,a.kL)}}function yL(a,b){a.DD=b;if(a.yb){var c=a.ea(),d=a.xA(),e=a.Ii;b?(e&&c.FX(e,a.a()),c.FX(d,a.a())):(c[kq](e),c[kq](d))}a.O()&&rL(a,b)}T.getDraggable=function(){return this.O5};
function FCa(a,b){var c=pi(a.hj+Bma)[pc](ne);a.a()&&(b?gL(a.$j,c):iL(a.$j,c));if(b&&!a.rj){var d;d=new kL(a.a(),a.$j);a.rj=d;gL(a.$j,c);kt(a.rj,nI,a.NX,!1,a)}else!b&&a.rj&&(a.rj.W(),a.rj=null)}
T.h=function(){sL.e.h[L](this);var a=this.a(),b=this.ea();this.$j=b.h(Q,this.hj+zma,this.ej=b.h(Bs,{className:this.hj+Cma,id:this[Fz]()},this.Bf),this.wi=b.h(Bs,this.hj+Ama));Vk(a,this.$j,this.ck=b.h(Q,this.hj+BA),this.kh=b.h(Q,this.hj+kma));aL(this.wi,eD);gl(this.wi,!0);bL(this.wi,zF,ioa);this.lL=this.ej.id;aL(a,this.vv());bL(a,CF,this.lL||O);this.ph&&AJ(this.ck,this.ph);Sl(this.wi,this.RD);this.Mh&&(a=this.Mh,a.q=this.kh,a.B());Sl(this.kh,!!this.Mh);xL(this,this.kL)};
T.mf=function(a){sL.e.mf[L](this,a);a=this.a();var b=this.hj+BA;this.ck=Ik(null,b,a)[0];this.ck||(this.ck=this.ea().h(Q,b),this.ph&&AJ(this.ck,this.ph),a[p](this.ck));var b=this.hj+zma,c=this.hj+Cma,d=this.hj+Ama;(this.$j=Ik(null,b,a)[0])?(this.ej=Ik(null,c,this.$j)[0],this.wi=Ik(null,d,this.$j)[0]):(this.$j=this.ea().h(Q,b),a[Eb](this.$j,this.ck));this.ej?(this.Bf=jl(this.ej),this.ej.id||(this.ej.id=this[Fz]())):(this.ej=Rk(Bs,{className:c,id:this[Fz]()}),this.$j[p](this.ej));this.lL=this.ej.id;
bL(a,CF,this.lL||O);this.wi||(this.wi=this.ea().h(Bs,d),this.$j[p](this.wi));Sl(this.wi,this.RD);b=this.hj+kma;(this.kh=Ik(null,b,a)[0])?(this.Mh=new tL(this.ea()),this.Mh.Ia(this.kh)):(this.kh=this.ea().h(Q,b),a[p](this.kh),this.Mh&&(a=this.Mh,a.q=this.kh,a.B()),Sl(this.kh,!!this.Mh));xL(this,this.kL)};
T.Bb=function(){sL.e.Bb[L](this);this.hc().l(this.a(),wF,this.P5).l(this.a(),Xr,this.P5);this.hc().l(this.kh,Fr,this.$ga);FCa(this,this.O5);this.hc().l(this.wi,Fr,this.aha);var a=this.a();aL(a,this.vv());this.ej.id!==O&&bL(a,CF,this.ej.id);this.DD||yL(this,!1)};T.ve=function(){this.O()&&this[hy](!1);FCa(this,!1);sL.e.ve[L](this)};fw(T,function(a){a!=this.O()&&(this.yb||this.B(),sL.e[hy][L](this,a))});T.kO=function(){sL.e.kO[L](this);this[$](tC)};
T.LO=function(){sL.e.LO[L](this);this[$](sC);this.gH&&this.W()};T.NX=function(){var a=this.ea().$b(),b=Pk(Qk(a)||ca||ca),c=h.max(a[Pd][Bc],b[r]),a=h.max(a[Pd][Rb],b[A]),d=Ol(this.a());Cl(this.a())==yg?mL(this.rj,new vl(0,0,h.max(0,b[r]-d[r]),h.max(0,b[A]-d[A]))):mL(this.rj,new vl(0,0,c-d[r],a-d[A]))};T.aha=function(){zL(this)};function zL(a){if(a.RD){var b=a.Mh,c=b&&b.OY;if(c)b=b.get(c),a[$](new AL(c,b))&&a[hy](!1);else a[hy](!1)}}T.YS=function(a){this.gH=a};T.w=function(){this.kh=this.wi=null;sL.e.w[L](this)};
T.$ga=function(a){t:{for(a=a[Mq];null!=a&&a!=this.kh;){if(a[Nc]==ff)break t;a=a[fe]}a=null}if(a&&!a[Nd]){a=a[yd];var b=this.Mh.get(a);this[$](new AL(a,b))&&this[hy](!1)}};
T.P5=function(a){var b=!1,c=!1,d=this.Mh,e=a[Mq];if(a[H]==wF)if(this.oka&&27==a[Np]){var f=d&&d.OY,e=e[Nc]==Ef&&!e[Nd];f&&!e?(c=!0,b=d.get(f),b=this[$](new AL(f,b))):e||(b=!0)}else{if(9==a[Np]&&a[Oq]&&e==this.a()){this.QY=!0;try{this.Dn[Fx]()}catch(g){}ut(this.g9,0,this)}}else if(13==a[Np]){if(e[Nc]==ff&&!e[Nd])f=e[yd];else if(e==this.wi)zL(this);else if(d){var k=d.NW,l=k&&BL(d,k),e=(e[Nc]==Mf||e[Nc]==Ef||e[Nc]==df)&&!e[Nd];!l||l[Nd]||e||(f=k)}f&&d&&(c=!0,b=this[$](new AL(f,String(d.get(f)))))}else e==
this.wi&&32==a[Np]&&zL(this);if(b||c)a[Zp](),a[Hp]();b&&this[hy](!1)};function AL(a,b){ab(this,aE);this.key=a;this.caption=b}X(AL,Xs);function tL(a){this.P=a||Ek();Uj[L](this)}X(tL,Uj);T=tL[K];T.hj="charts-buttonset";T.NW=null;T.q=null;T.OY=null;T.set=function(a,b,c,d){Uj[K].set[L](this,a,b);c&&(this.NW=a);d&&(this.OY=a);return this};T.Ti=function(a,b,c){return this.set(a.key,a[gy],b,c)};
T.B=function(){if(this.q){AJ(this.q,zJ);var a=Ek(this.q);this[Tb](function(b,c){var d=a.h(eD,{name:c},b);c==this.NW&&lb(d,this.hj+CA);this.q[p](d)},this)}};T.Ia=function(a){if(a&&1==a[ed]){this.q=a;a=this.q[cc](eD);for(var b=0,c,d,e;c=a[b];b++)if(d=c[yd]||c.id,e=jl(c)||c[id],d){var f=0==b;this.set(d,e,f,c[yd]==hD);f&&fL(c,this.hj+CA)}}};T.a=function(){return this.q};T.ea=function(){return this.P};function BL(a,b){for(var c=a.q[cc](ff),d=0,e;e=c[d];d++)if(e[yd]==b||e.id==b)return e;return null}
var uL={key:QG,caption:Uoa},vL={key:hD,caption:doa},GCa={key:"yes",caption:"Yes"},HCa={key:LG,caption:"No"},ICa={key:"save",caption:"Save"},JCa={key:"continue",caption:"Continue"};"undefined"!=typeof fa&&((new tL).Ti(uL,!0,!0),(new tL).Ti(uL,!0).Ti(vL,!1,!0),(new tL).Ti(GCa,!0).Ti(HCa,!1,!0),(new tL).Ti(GCa).Ti(HCa,!0).Ti(vL,!1,!0),(new tL).Ti(JCa).Ti(ICa).Ti(vL,!0,!0));function CL(a,b){rt[L](this);a&&this.cz(a,b)}X(CL,rt);T=CL[K];T.q=null;T.aR=null;T.c0=null;T.bR=null;T.El=-1;T.Eu=-1;T.k1=!1;
var KCa={3:13,12:144,63232:38,63233:40,63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},LCa={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},MCa=kk||mk&&qk(jna),NCa=fk&&lk;T=CL[K];
T.mm=function(a){mk&&(17==this.El&&!a[Jq]||18==this.El&&!a[Tp]||fk&&91==this.El&&!a[Cq])&&(this.Eu=this.El=-1);-1==this.El&&(a[Jq]&&17!=a[Np]?this.El=17:a[Tp]&&18!=a[Np]?this.El=18:a[Cq]&&91!=a[Np]&&(this.El=91));if(MCa&&!TBa(a[Np],this.El,a[Oq],a[Jq],a[Tp]))this[Pp](a);else this.Eu=MJ(a[Np]),NCa&&(this.k1=a[Tp])};T.ona=function(a){this.Eu=this.El=-1;this.k1=a[Tp]};
kp(T,function(a){var b=a.Ka,c,d,e=b[Tp];kk&&a[H]==Xr?(c=this.Eu,d=13!=c&&27!=c?b[Np]:0):mk&&a[H]==Xr?(c=this.Eu,d=0<=b[Mp]&&63232>b[Mp]&&LJ(c)?b[Mp]:0):jk?(c=this.Eu,d=LJ(c)?b[Np]:0):(c=b[Np]||this.Eu,d=b[Mp]||0,NCa&&(e=this.k1),fk&&63==d&&224==c&&(c=191));var f=c=MJ(c),g=b.keyIdentifier;c?63232<=c&&c in KCa?f=KCa[c]:25==c&&a[Oq]&&(f=9):g&&g in LCa&&(f=LCa[g]);a=f==this.El;this.El=f;b=new OCa(f,d,a,b);mp(b,e);this[$](b)});T.a=function(){return this.q};
T.cz=function(a,b){this.bR&&this[hz]();this.q=a;this.aR=kt(this.q,Xr,this,b);this.c0=kt(this.q,wF,this.mm,b,this);this.bR=kt(this.q,xF,this.ona,b,this)};T.detach=function(){this.aR&&(pt(this.aR),pt(this.c0),pt(this.bR),this.bR=this.c0=this.aR=null);this.q=null;this.Eu=this.El=-1};T.w=function(){CL.e.w[L](this);this[hz]()};function OCa(a,b,c,d){$s[L](this,d);ab(this,vF);jp(this,a);this.charCode=b;this.repeat=c}X(OCa,$s);function DL(){}var EL;Uh(DL);function PCa(a){var b=new FL;b.$=function(){return a};return b}var QCa={button:eya,checkbox:BD,menuitem:TH,menuitemcheckbox:BD,menuitemradio:BD,radio:BD,tab:TH,treeitem:TH};T=DL[K];T.yj=function(){};T.h=function(a){var b=a.ea().h(Q,this.ol(a)[ie](ne),a[nz]());GL(this,a,b);return b};T.$a=function(a){return a};T.fr=function(a,b,c){if(a=a.a?a.a():a){var d=[b];kk&&!qk(aB)&&(d=HL(dL(a),b),d[C](b));(c?gL:iL)(a,d)}};T.Ah=function(){return!0};
T.Ia=function(a,b){b.id&&a.jw(b.id);var c=this.$a(b);c&&c[Sb]?a.zz(c[Sb][ac]?Yi(c[Xb]):c[Sb]):a.zz(null);var d=0,e=this.$(),f=this.$(),g=!1,k=!1,c=!1,l=Yi(dL(b));Y(l,function(a){g||a!=e?k||a!=f?d|=this.qY(a):k=!0:(g=!0,f==e&&(k=!0))},this);a.n=d;g||(l[C](e),f==e&&(k=!0));k||l[C](f);var n=a.Ln;n&&l[C][Mc](l,n);if(kk&&!qk(aB)){var q=HL(l);0<q[J]&&(l[C][Mc](l,q),c=!0)}g&&k&&!n&&!c||wCa(b,l[ie](ne));GL(this,a,b);return b};T.im=function(a){a.Lg()&&this.rv(a.a(),!0);a[Ay]()&&this.kn(a,a.O())};
function IL(a,b,c){if(a=c||a.yj())c=b[Sd](ih)||null,a!=c&&aL(b,a)}function GL(a,b,c){b.O()||bL(c,Ig,!b.O());b[Ay]()||a.op(c,1,!b[Ay]());JL(b,8)&&a.op(c,8,b.rP());JL(b,16)&&a.op(c,16,b.Xl());JL(b,64)&&a.op(c,64,KL(b,64))}T.HF=function(a,b){Vl(a,!b,!kk&&!jk)};T.rv=function(a,b){this.fr(a,this.$()+xma,b)};T.Jq=function(a){var b;return JL(a,32)&&(b=a.pg())?hl(b)&&il(b):!1};
T.kn=function(a,b){var c;if(JL(a,32)&&(c=a.pg())){if(!b&&KL(a,32)){try{c[Xy]()}catch(d){}KL(a,32)&&a.Hw(null)}(hl(c)&&il(c))!=b&&gl(c,b)}};fw(T,function(a,b){Sl(a,b);a&&bL(a,Ig,!b)});T.vc=function(a,b,c){var d=a.a();if(d){var e=this.yG(b);e&&this.fr(a,e,c);this.op(d,b,c)}};T.op=function(a,b,c){EL||(EL={1:lta,8:TH,16:BD,64:Uta});b=EL[b];var d=a[Sd](ih)||null;d&&(d=QCa[d]||b,b=b==BD||b==TH?d:b);b&&bL(a,b,c)};
Nw(T,function(a,b){var c=this.$a(a);if(c&&(Wk(c),b))if(bi(b))el(c,b);else{var d=function(a){if(a){var b=Gk(c);c[p](bi(a)?b[Cb](a):a)}};Yh(b)?Y(b,d):!Zh(b)||sxa in b?d(b):Y(Yi(b),d)}});T.pg=function(a){return a.a()};T.$=function(){return Wpa};T.ol=function(a){var b=this.$(),c=[b],d=this.$();d!=b&&c[C](d);b=a[hq]();for(d=[];b;){var e=b&-b;d[C](this.yG(e));b&=~e}c[C][Mc](c,d);(a=a.Ln)&&c[C][Mc](c,a);kk&&!qk(aB)&&c[C][Mc](c,HL(c));return c};
function HL(a,b){var c=[];b&&(a=a[Ab]([b]));Y([],function(d){!Ni(d,gi(Ri,a))||b&&!Ri(d,b)||c[C](d[ie](iC))});return c}T.yG=function(a){this.XR||RCa(this);return this.XR[a]};T.qY=function(a){this.Dda||(this.XR||RCa(this),this.Dda=Rj(this.XR));a=la(this.Dda[a],10);return ga(a)?0:a};function RCa(a){var b=a.$();ri(b[vb](/\xa0|\s/g,ne),ne);a.XR={1:b+DA,2:b+sma,4:b+ima,8:b+yma,16:b+mma,32:b+pma,64:b+vma}};function ML(a,b){if(!a)throw m("Invalid class name "+a);if(!ei(b))throw m("Invalid decorator function "+b);NL[a]=b}function SCa(a){var b;a=dL(a);for(var c=0,d=a[J];c<d;c++)if(b=a[c],b=b in NL?NL[b]():null)return b;return null}var TCa={},NL={};function UCa(a){var b=SCa(a);b&&b.Ia(a);return b};function OL(a,b,c){VK[L](this,c);if(!b){b=this[rc];for(var d;b;){d=fi(b);if(d=TCa[d])break;b=b.e?b.e[rc]:null}b=d?ei(d.Xb)?d.Xb():new d:null}this.g=b;this.zz(Qh(a)?a:null)}X(OL,VK);T=OL[K];T.ph=null;T.n=0;T.wG=39;T.Br=255;T.$r=0;T.Rd=!0;T.Ln=null;T.sL=!0;T.XL=!1;T.bK=null;function PL(a,b){a.yb&&b!=a.sL&&VCa(a,b);a.sL=b}T.pg=function(){return this.g.pg(this)};T.rN=function(){return this.lf||(this.lf=new CL)};T.eb=function(){return this.g};
T.L$=function(a){if(this.yb)throw m(KB);this.a()&&(this.q=null);this.g=a};T.en=function(a){a&&(this.Ln?Ri(this.Ln,a)||this.Ln[C](a):this.Ln=[a],this.g.fr(this,a,!0))};T.fr=function(a,b){b?this.en(a):a&&this.Ln&&Wi(this.Ln,a)&&(0==this.Ln[J]&&(this.Ln=null),this.g.fr(this,a,!1))};T.h=function(){var a=this.g.h(this);this.q=a;IL(this.g,a,this.vv());this.XL||this.g.HF(a,!1);this.O()||this.g[hy](a,!1)};T.vv=function(){return this.bK};T.iea=function(a){this.bK=a};T.$a=function(){return this.g.$a(this.a())};
T.Ah=function(a){return this.g.Ah(a)};T.mf=function(a){this.q=a=this.g.Ia(this,a);IL(this.g,a,this.vv());this.XL||this.g.HF(a,!1);this.Rd=a[x][Sc]!=R};T.Bb=function(){OL.e.Bb[L](this);this.g.im(this);if(this.wG&-2&&(this.sL&&VCa(this,!0),JL(this,32))){var a=this.pg();if(a){var b=this.rN();b.cz(a);this.hc().l(b,vF,this.Ci).l(a,zg,this.Pt).l(a,TC,this.Hw)}}};
function VCa(a,b){var c=a.hc(),d=a.a();b?(c.l(d,gs,a.En).l(d,es,a.Le).l(d,FG,a.np).l(d,fs,a.uM),a.bH!=Th&&c.l(d,OD,a.bH),kk&&c.l(d,YD,a.k7)):(c.uc(d,gs,a.En).uc(d,es,a.Le).uc(d,FG,a.np).uc(d,fs,a.uM),a.bH!=Th&&c.uc(d,OD,a.bH),kk&&c.uc(d,YD,a.k7))}T.ve=function(){OL.e.ve[L](this);this.lf&&this.lf[hz]();this.O()&&this[Ay]()&&this.g.kn(this,!1)};T.w=function(){OL.e.w[L](this);this.lf&&(this.lf.W(),delete this.lf);delete this.g;this.Ln=this.ph=null};Ow(T,function(){return this.ph});
Nw(T,function(a){this.g[mz](this.a(),a);this.zz(a)});T.zz=function(a){this.ph=a};T.Tk=function(){var a=this[nz]();if(!a)return O;a=bi(a)?a:Yh(a)?Gi(a,ll)[ie](O):jl(a);return nda(a)};T.rv=function(a){OL.e.rv[L](this,a);var b=this.a();b&&this.g.rv(b,a)};T.HF=function(a){this.XL=a;var b=this.a();b&&this.g.HF(b,a)};T.O=function(){return this.Rd};fw(T,function(a,b){if(b||this.Rd!=a&&this[$](a?cI:$E)){var c=this.a();c&&this.g[hy](c,a);this[Ay]()&&this.g.kn(this,a);this.Rd=a;return!0}return!1});
qw(T,function(){return!KL(this,1)});T.Ga=function(a){var b=this[mx]();b&&typeof b[Ay]==Bg&&!b[Ay]()||!QL(this,1,!a)||(a||(this[pz](!1),this.uh(!1)),this.O()&&this.g.kn(this,a),this.vc(1,!a))};T.uh=function(a){QL(this,2,a)&&this.vc(2,a)};T.nk=function(){return KL(this,4)};T.setActive=function(a){QL(this,4,a)&&this.vc(4,a)};T.rP=function(){return KL(this,8)};T.Fn=function(a){QL(this,8,a)&&this.vc(8,a)};T.Xl=function(){return KL(this,16)};T.Dg=function(a){QL(this,16,a)&&this.vc(16,a)};
T.pC=function(a){QL(this,32,a)&&this.vc(32,a)};T.ad=function(a){QL(this,64,a)&&this.vc(64,a)};sp(T,function(){return this.n});function KL(a,b){return!!(a.n&b)}T.vc=function(a,b){JL(this,a)&&b!=KL(this,a)&&(this.g.vc(this,a,b),this.n=b?this.n|a:this.n&~a)};function JL(a,b){return!!(a.wG&b)}function RL(a,b,c){if(a.yb&&KL(a,b)&&!c)throw m(KB);!c&&KL(a,b)&&a.vc(b,!1);a.wG=c?a.wG|b:a.wG&~b}function SL(a,b){return!!(a.Br&b)&&JL(a,b)}
function QL(a,b,c){return JL(a,b)&&KL(a,b)!=c&&(!(a.$r&b)||a[$](uCa(b,c)))&&!a.Mj}T.En=function(a){!WCa(a,this.a())&&this[$](pE)&&this[Ay]()&&SL(this,2)&&this.uh(!0)};T.uM=function(a){!WCa(a,this.a())&&this[$](Vva)&&(SL(this,4)&&this[pz](!1),SL(this,2)&&this.uh(!1))};T.bH=Th;function WCa(a,b){return!!a[Fp]&&dl(b,a[Fp])}T.Le=function(a){this[Ay]()&&(SL(this,2)&&this.uh(!0),bt(a)&&(SL(this,4)&&this[pz](!0),this.g.Jq(this)&&this.pg()[Fx]()));!this.XL&&bt(a)&&a[Hp]()};
T.np=function(a){this[Ay]()&&(SL(this,2)&&this.uh(!0),this.nk()&&this.Wh(a)&&SL(this,4)&&this[pz](!1))};T.k7=function(a){this[Ay]()&&this.Wh(a)};T.Wh=function(a){SL(this,16)&&this.Dg(!this.Xl());SL(this,8)&&this.Fn(!0);SL(this,64)&&this.ad(!KL(this,64));var b=new Xs(qC,this);a&&(mp(b,a[Tp]),b.ctrlKey=a[Jq],vp(b,a[Cq]),b.shiftKey=a[Oq],b.O0=a.O0);return this[$](b)};T.Pt=function(){SL(this,32)&&this.pC(!0)};T.Hw=function(){SL(this,4)&&this[pz](!1);SL(this,32)&&this.pC(!1)};
T.Ci=function(a){return this.O()&&this[Ay]()&&this.ml(a)?(a[Hp](),a[Zp](),!0):!1};T.ml=function(a){return 13==a[Np]&&this.Wh(a)};if(!ei(OL))throw m("Invalid component class "+OL);if(!ei(DL))throw m("Invalid renderer class "+DL);var XCa=fi(OL);TCa[XCa]=DL;ML(Wpa,function(){return new OL(null)});function TL(){this.j1=[]}X(TL,DL);Uh(TL);function UL(a,b){var c=a.j1[b];if(!c){switch(b){case 0:c=a.$()+qma;break;case 1:c=a.$()+lma;break;case 2:c=a.$()+BA}a.j1[b]=c}return c}T=TL[K];T.yj=function(){return ixa};T.h=function(a){var b=a.ea().h(Q,this.ol(a)[ie](ne),YCa(this,a[nz](),a.ea()));VL(this,a,b,JL(a,8)||JL(a,16));GL(this,a,b);ZCa(this,a,b);return b};T.$a=function(a){return a&&a[Sb]};
T.Ia=function(a,b){var c=al(b),d=UL(this,2);c&&eL(c,d)||b[p](YCa(this,b[Xb],a.ea()));eL(b,pC)&&(a.nN(!0),this.nN(a,b,!0));return TL.e.Ia[L](this,a,b)};Nw(T,function(a,b){var c=this.$a(a),d=WL(this,a)?c[Sb]:null;TL.e[mz][L](this,a,b);d&&!WL(this,a)&&c[Eb](d,c[Sb]||null)});function YCa(a,b,c){a=UL(a,2);return c.h(Q,a,b)}T.IY=function(a,b,c){b&&(aL(b,c?tG:this.yj()),VL(this,a,b,c))};T.nN=function(a,b,c){b&&(aL(b,c?sG:this.yj()),VL(this,a,b,c))};
function WL(a,b){var c=a.$a(b);if(c){var c=c[Sb],d=UL(a,1);return!!c&&bl(c)&&eL(c,d)}return!1}function VL(a,b,c,d){if(d!=WL(a,c))if(jL(c,pC,d),c=a.$a(c),d)a=UL(a,1),c[Eb](b.ea().h(Q,a),c[Sb]||null);else c[Qd](c[Sb])}T.yG=function(a){switch(a){case 2:return UL(this,0);case 16:case 8:return fqa;default:return TL.e.yG[L](this,a)}};T.qY=function(a){var b=UL(this,0);switch(a){case fqa:return 16;case b:return 2;default:return TL.e.qY[L](this,a)}};T.$=function(){return bqa};
function ZCa(a,b,c){(JL(b,8)||JL(b,16))&&IL(a,c,JL(b,16)?sG:tG)};function XL(a,b,c,d){OL[L](this,a,d||TL.Xb(),c);this.wa(b)}X(XL,OL);T=XL[K];fb(T,function(){var a=this.Uk;return null!=a?a:this.Tk()});T.wa=function(a){this.Uk=a};T.IY=function(a){RL(this,8,a);this.Xl()&&!a&&this.Dg(!1);var b=this.a();b&&this.eb().IY(this,b,a)};T.nN=function(a){RL(this,16,a);var b=this.a();b&&this.eb().nN(this,b,a)};T.Tk=function(){var a=this[nz]();return Yh(a)?(a=Gi(a,function(a){return bl(a)&&(eL(a,cqa)||eL(a,dqa))?O:ll(a)})[ie](O),nda(a)):XL.e.Tk[L](this)};
T.np=function(a){var b=this[mx]();if(b){var c=b.n$;b.n$=null;if(c&&di(a[zd])&&tk(c,new sk(a[zd],a[Ad])))return}XL.e.np[L](this,a)};T.ml=function(a){return a[Np]==this.FZ&&this.Wh(a)?!0:XL.e.ml[L](this,a)};T.Tla=function(){return this.FZ};ML(bqa,function(){return new XL(null)});XL[K].h=function(){XL.e.h[L](this);ZCa(this.eb(),this,this.a())};XL[K].vv=function(){return JL(this,16)?sG:JL(this,8)?tG:XL.e.vv[L](this)};function YL(a,b,c,d){IJ[L](this,a,b,c||d);if(c||d)this.XN=65|(d?32:132)}X(YL,IJ);var ZL,$L;$L=ZL=!1;var aM=ek;aM&&(-1!=aM[ld]("Firefox")||-1!=aM[ld]("Camino")||(-1!=aM[ld]("iPhone")||-1!=aM[ld]("iPod")?ZL=!0:-1!=aM[ld]("iPad")?$L=!0:-1!=aM[ld]("Chrome")||-1!=aM[ld]("Android")||aM[ld]("Safari")));var $Ca=ZL,aDa=$L;function bM(){}X(bM,DL);Uh(bM);T=bM[K];T.yj=function(){return eD};T.op=function(a,b,c){switch(b){case 8:case 16:bL(a,eya,c);break;default:case 64:case 1:bM.e.op[L](this,a,b,c)}};T.h=function(a){var b=bM.e.h[L](this,a);this.Rh(b,a.gk());var c=a[I]();c&&this.wa(b,c);JL(a,16)&&this.op(b,16,a.Xl());return b};T.Ia=function(a,b){b=bM.e.Ia[L](this,a,b);var c=this[I](b);a.hd=c;a.tA(this.gk(b));JL(a,16)&&this.op(b,16,a.Xl());return b};fb(T,Th);T.wa=Th;T.gk=function(a){return a[uz]};
T.Rh=function(a,b){a&&b&&Ap(a,b)};T.tt=function(a,b){var c=a.Lg(),d=this.$()+nma,e=this.$()+oma;a.fr(c?e:d,!!(b&1));a.fr(c?d:e,!!(b&2))};T.$=function(){return Tpa};function cM(){}X(cM,bM);Uh(cM);T=cM[K];T.yj=function(){};T.h=function(a){PL(a,!1);a.Br&=-256;RL(a,32,!1);return a.ea().h(eD,{"class":this.ol(a)[ie](ne),disabled:!a[Ay](),title:a.gk()||O,value:a[I]()||O},a.Tk()||O)};T.Ah=function(a){return a[Nc]==ff||a[Nc]==qf&&(a[H]==eD||a[H]==nAa||a[H]==Sya)};T.Ia=function(a,b){PL(a,!1);a.Br&=-256;RL(a,32,!1);if(b[Nd]){var c=this.yG(1);fL(b,c)}return cM.e.Ia[L](this,a,b)};T.im=function(a){a.hc().l(a.a(),Fr,a.Wh)};T.HF=Th;T.rv=Th;T.Jq=function(a){return a[Ay]()};
T.kn=Th;T.vc=function(a,b,c){cM.e.vc[L](this,a,b,c);(a=a.a())&&1==b&&Uw(a,c)};fb(T,function(a){return a[id]});T.wa=function(a,b){a&&Fw(a,b)};T.op=Th;function dM(a,b,c){OL[L](this,a,b||cM.Xb(),c)}X(dM,OL);T=dM[K];fb(T,function(){return this.hd});T.wa=function(a){this.hd=a;this.eb().wa(this.a(),a)};T.gk=function(){return this.ka};T.Rh=function(a){this.ka=a;this.eb().Rh(this.a(),a)};T.tA=function(a){this.ka=a};T.tt=function(a){this.eb().tt(this,a)};T.w=function(){dM.e.w[L](this);delete this.hd;delete this.ka};T.Bb=function(){dM.e.Bb[L](this);if(JL(this,32)){var a=this.pg();a&&this.hc().l(a,xF,this.ml)}};
T.ml=function(a){return 13==a[Np]&&a[H]==vF||32==a[Np]&&a[H]==xF?this.Wh(a):32==a[Np]};ML(Tpa,function(){return new dM(null)});function eM(a){this.vS=a}Uh(eM);T=eM[K];T.yj=function(){return this.vS};function fM(a,b){a&&bb(a,b?0:-1)}T.h=function(a){return a.ea().h(Q,this.ol(a)[ie](ne))};T.$a=function(a){return a};T.Ah=function(a){return a[Nc]==kf};T.Ia=function(a,b){b.id&&a.jw(b.id);var c=this.$(),d=!1,e=dL(b);e&&Y(e,function(b){b==c?d=!0:b&&this.tZ(a,b,c)},this);d||fL(b,c);bDa(this,a,this.$a(b));return b};T.tZ=function(a,b,c){b==c+DA?a.Ga(!1):b==c+rma?a.HG(Jg):b==c+Fma&&a.HG(Eh)};
function bDa(a,b,c){if(c)for(var d=c[Sb],e;d&&d[fe]==c;){e=d[ac];if(1==d[ed]){var f=a.iY(d);f&&(f.q=d,b[Ay]()||f.Ga(!1),b.ua(f),f.Ia(d))}else d[Yc]&&pi(d[Yc])!=O||c[Qd](d);d=e}}T.iY=function(a){return SCa(a)};T.im=function(a){a=a.a();Vl(a,!0,lk);kk&&(a.hideFocus=!0);var b=this.yj();b&&aL(a,b)};T.pg=function(a){return a.a()};T.$=function(){return Vpa};T.ol=function(a){var b=this.$(),c=[b,a.Dr()==Jg?b+rma:b+Fma];a[Ay]()||c[C](b+DA);return c};function gM(a,b,c){VK[L](this,c);this.g=b||eM.Xb();this.ib=a||Eh}X(gM,VK);T=gM[K];T.FW=null;T.lf=null;T.g=null;T.ib=null;T.Rd=!0;T.qg=!0;T.U0=!0;T.qf=-1;T.Rg=null;T.nn=!1;T.Ala=!1;T.Qja=!0;T.Xq=null;T.pg=function(){return this.FW||this.g.pg(this)};T.rN=function(){return this.lf||(this.lf=new CL(this.pg()))};T.eb=function(){return this.g};T.L$=function(a){if(this.a())throw m(KB);this.g=a};T.h=function(){this.q=this.g.h(this)};T.$a=function(){return this.g.$a(this.a())};T.Ah=function(a){return this.g.Ah(a)};
T.mf=function(a){this.q=this.g.Ia(this,a);a[x][Sc]==R&&(this.Rd=!1)};T.Bb=function(){gM.e.Bb[L](this);XK(this,function(a){a.yb&&cDa(this,a)},this);var a=this.a();this.g.im(this);this[hy](this.Rd,!0);this.hc().l(this,pE,this.PU).l(this,bF,this.BU).l(this,UI,this.DU).l(this,Bxa,this.Hfa).l(this,HD,this.Ffa).l(a,es,this.Le).l(Gk(a),FG,this.Gfa).l(a,[es,FG,gs,fs,OD],this.Efa);this.Jq()&&dDa(this,!0)};
function dDa(a,b){var c=a.hc(),d=a.pg();b?c.l(d,zg,a.Pt).l(d,TC,a.Hw).l(a.rN(),vF,a.Ci):c.uc(d,zg,a.Pt).uc(d,TC,a.Hw).uc(a.rN(),vF,a.Ci)}T.ve=function(){this.nf(-1);this.Rg&&this.Rg.ad(!1);this.nn=!1;gM.e.ve[L](this)};T.w=function(){gM.e.w[L](this);this.lf&&(this.lf.W(),this.lf=null);this.g=this.Rg=this.Xq=this.FW=null};T.PU=function(){return!0};
T.BU=function(a){var b=ZK(this,a[Mq]);if(-1<b&&b!=this.qf){var c=hM(this);c&&c.uh(!1);this.qf=b;c=hM(this);this.nn&&c[pz](!0);this.Qja&&this.Rg&&c!=this.Rg&&(JL(c,64)?c.ad(!0):this.Rg.ad(!1))}b=this.a();null!=a[Mq].a()&&bL(b,rC,a[Mq].a().id)};T.DU=function(a){a[Mq]==hM(this)&&(this.qf=-1);this.a()[Pc](Yqa)};T.Hfa=function(a){(a=a[Mq])&&a!=this.Rg&&a[mx]()==this&&(this.Rg&&this.Rg.ad(!1),this.Rg=a)};T.Ffa=function(a){a[Mq]==this.Rg&&(this.Rg=null)};
T.Le=function(a){this.qg&&(this.nn=!0);var b=this.pg();b&&hl(b)&&il(b)?b[Fx]():a[Hp]()};T.Gfa=function(){this.nn=!1};T.Efa=function(a){var b;t:{b=a[Mq];if(this.Xq)for(var c=this.a();b&&b!==c;){var d=b.id;if(d in this.Xq){b=this.Xq[d];break t}b=b[fe]}b=null}if(b)switch(a[H]){case es:b.Le(a);break;case FG:b.np(a);break;case gs:b.En(a);break;case fs:b.uM(a);break;case OD:b.bH(a)}};T.Pt=function(){};T.Hw=function(){this.nf(-1);this.nn=!1;this.Rg&&this.Rg.ad(!1)};
T.Ci=function(a){return this[Ay]()&&this.O()&&(0!=this.Zf()||this.FW)&&this.ml(a)?(a[Hp](),a[Zp](),!0):!1};
T.ml=function(a){var b=hM(this);if(b&&typeof b.Ci==Bg&&b.Ci(a)||this.Rg&&this.Rg!=b&&typeof this.Rg.Ci==Bg&&this.Rg.Ci(a))return!0;if(a[Oq]||a[Jq]||a[Cq]||a[Tp])return!1;switch(a[Np]){case 27:if(this.Jq())this.pg()[Xy]();else return!1;break;case 36:eDa(this);break;case 35:fDa(this);break;case 38:if(this.ib==Eh)iM(this);else return!1;break;case 37:if(this.ib==Jg)this.Lg()?jM(this):iM(this);else return!1;break;case 40:if(this.ib==Eh)jM(this);else return!1;break;case 39:if(this.ib==Jg)this.Lg()?iM(this):
jM(this);else return!1;break;default:return!1}return!0};function cDa(a,b){var c=b.a(),c=c.id||(c.id=b[Fz]());a.Xq||(a.Xq={});a.Xq[c]=b}T.ua=function(a,b){gM.e.ua[L](this,a,b)};T.qx=function(a,b,c){a.$r|=2;a.$r|=64;!this.Jq()&&this.Ala||RL(a,32,!1);PL(a,!1);gM.e.qx[L](this,a,b,c);a.yb&&this.yb&&cDa(this,a);b<=this.qf&&this.qf++};
T.removeChild=function(a,b){if(a=bi(a)?this.ut(a):a){var c=ZK(this,a);-1!=c&&(c==this.qf?(a.uh(!1),this.qf=-1):c<this.qf&&this.qf--);(c=a.a())&&c.id&&this.Xq&&Lj(this.Xq,c.id)}a=gM.e[Qd][L](this,a,b);PL(a,!0);return a};T.Dr=function(){return this.ib};T.HG=function(a){if(this.a())throw m(KB);this.ib=a};T.O=function(){return this.Rd};fw(T,function(a,b){if(b||this.Rd!=a&&this[$](a?cI:$E)){this.Rd=a;var c=this.a();c&&(Sl(c,a),this.Jq()&&fM(this.pg(),this.qg&&this.Rd),b||this[$](this.Rd?tC:sC));return!0}return!1});
qw(T,function(){return this.qg});T.Ga=function(a){this.qg!=a&&this[$](a?mE:dE)&&(a?(this.qg=!0,XK(this,function(a){a.qba?delete a.qba:a.Ga(!0)})):(XK(this,function(a){a[Ay]()?a.Ga(!1):a.qba=!0}),this.nn=this.qg=!1),this.Jq()&&fM(this.pg(),a&&this.Rd))};T.Jq=function(){return this.U0};T.kn=function(a){a!=this.U0&&this.yb&&dDa(this,a);this.U0=a;this.qg&&this.Rd&&fM(this.pg(),a)};T.nf=function(a){(a=this.ff(a))?a.uh(!0):-1<this.qf&&hM(this).uh(!1)};T.uh=function(a){this.nf(ZK(this,a))};
function hM(a){return a.ff(a.qf)}function eDa(a){kM(a,function(a,c){return(a+1)%c},a.Zf()-1)}function fDa(a){kM(a,function(a,c){a--;return 0>a?c-1:a},0)}function jM(a){kM(a,function(a,c){return(a+1)%c},a.qf)}function iM(a){kM(a,function(a,c){a--;return 0>a?c-1:a},a.qf)}function kM(a,b,c){c=0>c?ZK(a,a.Rg):c;var d=a.Zf();c=b[L](a,c,d);for(var e=0;e<=d;){var f=a.ff(c);if(f&&a.rca(f)){a.i_(c);break}e++;c=b[L](a,c,d)}}T.rca=function(a){return a.O()&&a[Ay]()&&JL(a,2)};T.i_=function(a){this.nf(a)};function lM(){}X(lM,DL);Uh(lM);lM[K].$=function(){return aqa};function mM(a,b,c){OL[L](this,a,c||lM.Xb(),b);RL(this,1,!1);RL(this,2,!1);RL(this,4,!1);RL(this,32,!1);this.n=1}X(mM,OL);ML(aqa,function(){return new mM(null)});function nM(){}X(nM,DL);Uh(nM);nM[K].h=function(a){return a.ea().h(Q,this.$())};nM[K].Ia=function(a,b){b.id&&a.jw(b.id);if(b[Nc]==pf){var c=b;b=this.h(a);Xk(b,c);Zk(c)}else fL(b,this.$());return b};Nw(nM[K],function(){});nM[K].$=function(){return oC};function oM(a,b){OL[L](this,null,a||nM.Xb(),b);RL(this,1,!1);RL(this,2,!1);RL(this,4,!1);RL(this,32,!1);this.n=1}X(oM,OL);oM[K].Bb=function(){oM.e.Bb[L](this);var a=this.a();aL(a,VH)};ML(oC,function(){return new oM});function pM(a){this.vS=a||hxa}X(pM,eM);Uh(pM);T=pM[K];T.Ah=function(a){return a[Nc]==Cpa||pM.e.Ah[L](this,a)};T.iY=function(a){return a[Nc]==pf?new oM:pM.e.iY[L](this,a)};T.zr=function(a,b){return dl(a.a(),b)};T.$=function(){return nC};T.im=function(a){pM.e.im[L](this,a);a=a.a();bL(a,XE,zh)};ML(oC,function(){return new oM});function qM(a,b){gM[L](this,Eh,b||pM.Xb(),a);this.kn(!1)}X(qM,gM);T=qM[K];T.YG=!0;T.x$=!1;T.$=function(){return this.eb().$()};T.zr=function(a){if(this.eb().zr(this,a))return!0;for(var b=0,c=this.Zf();b<c;b++){var d=this.ff(b);if(typeof d.zr==Bg&&d.zr(a))return!0}return!1};T.bj=function(a){this.ua(a,!0)};T.uu=function(a,b){this.qx(a,b,!0)};T.bd=function(a){return this.ff(a)};T.Ig=function(){return this.Zf()};T.vA=function(){var a=[];XK(this,function(b){a[C](b)});return a};
bx(T,function(a,b){var c=this.O();c||Sl(this.a(),!0);var d=this.a(),e=a,f=b,g=Jl(d);e instanceof sk&&(f=e.y,e=e.x);Dl(d,d[Od]+(e-g.x),d[Tc]+(f-g.y));c||Sl(this.a(),!1)});pw(T,function(){return this.O()?Jl(this.a()):null});fw(T,function(a,b,c){(b=qM.e[hy][L](this,a,b))&&a&&this.yb&&this.YG&&this.pg()[Fx]();this.n$=a&&c&&di(c[zd])?new sk(c[zd],c[Ad]):null;return b});T.PU=function(a){this.YG&&this.pg()[Fx]();return qM.e.PU[L](this,a)};T.rca=function(a){return(this.x$||a[Ay]())&&a.O()&&JL(a,2)};
T.mf=function(a){var b=this.eb(),c;c=this.ea();var d=b.$()+BA;c=Jk(c.of,Q,d,a);for(var d=c[J],e=0;e<d;e++)bDa(b,this,c[e]);qM.e.mf[L](this,a)};T.ml=function(a){var b=qM.e.ml[L](this,a);b||XK(this,function(c){!b&&c.Tla&&c.FZ==a[Np]&&(this[Ay]()&&this.uh(c),b=c.Ci(a))},this);return b};
T.nf=function(a){qM.e.nf[L](this,a);if(a=this.ff(a)){var b=a.a();a=this.a();var c=Jl(b),d=Jl(a),e=Zl(a),f=c.x-d.x-e[G],c=c.y-d.y-e.top,d=a[Wd]-b[Uc],e=a[Gc],g=a[Cd],e=e+h.min(f,h.max(f-(a[Gd]-b[zb]),0)),g=g+h.min(c,h.max(c-d,0)),b=new sk(e,g);a.scrollLeft=b.x;Rw(a,b.y)}};function rM(){}X(rM,bM);Uh(rM);T=rM[K];T.h=function(a){var b={"class":mC+this.ol(a)[ie](ne)},b=a.ea().h(Q,b,this.UN(a[nz](),a.ea()));this.Rh(b,a.gk());GL(this,a,b);return b};T.yj=function(){return eD};T.$a=function(a){return a&&a[Sb][Sb]};T.UN=function(a,b){return b.h(Q,mC+(this.$()+wma),b.h(Q,mC+(this.$()+tma),a))};T.Ah=function(a){return a[Nc]==kf};
T.Ia=function(a,b){gDa(b,!0);gDa(b,!1);var c;t:{c=a.ea().n9(b);var d=this.$()+wma;if(c&&eL(c,d)&&(c=a.ea().n9(c),d=this.$()+tma,c&&eL(c,d))){c=!0;break t}c=!1}c||b[p](this.UN(b[Xb],a.ea()));gL(b,[lC,this.$()]);return rM.e.Ia[L](this,a,b)};T.$=function(){return Xpa};function gDa(a,b){if(a)for(var c=b?a[Sb]:a[yc],d;c&&c[fe]==a;){d=b?c[ac]:c[gc];if(3==c[ed]){var e=c[Yc];if(pi(e)==O)a[Qd](c);else{c.nodeValue=b?e[vb](/^[\s\xa0]+/,O):e[vb](/[\s\xa0]+$/,O);break}}else break;c=d}};function sM(){}X(sM,rM);Uh(sM);T=sM[K];T.$a=function(a){return sM.e.$a[L](this,a&&a[Sb])};T.Ia=function(a,b){var c=Ik(He,nC,b)[0];if(c){Sl(c,!1);Gk(c)[Pd][p](c);var d=new qM;d.Ia(c);a.jm(d)}return sM.e.Ia[L](this,a,b)};T.UN=function(a,b){return sM.e.UN[L](this,[this[Wy](a,b),this.DN(b)],b)};Dw(T,function(a,b){return tM(a,this.$(),b)});function tM(a,b,c){return c.h(Q,mC+(b+AA),a)}T.DN=function(a){return a.h(Q,mC+(this.$()+EA),Nh)};T.$=function(){return $pa};function uM(a,b,c,d,e){dM[L](this,a,c||sM.Xb(),d);RL(this,64,!0);this.wN=new YL(null,5);b&&this.jm(b);this.gia=null;this.Sc=new tt(500);!$Ca&&!aDa||qk(mna)||(this.rz=!0);this.qma=e||pM.Xb()}X(uM,dM);T=uM[K];T.rz=!1;T.gfa=!1;T.Bb=function(){uM.e.Bb[L](this);hDa(this,!0);this.Y&&vM(this,this.Y,!0);bL(this.q,XE,!!this.Y)};T.ve=function(){uM.e.ve[L](this);hDa(this,!1);if(this.Y){this.ad(!1);this.Y.ve();vM(this,this.Y,!1);var a=this.Y.a();a&&Zk(a)}};
T.w=function(){uM.e.w[L](this);this.Y&&(this.Y.W(),delete this.Y);delete this.Xfa;this.Sc.W()};T.Le=function(a){uM.e.Le[L](this,a);this.nk()&&(this.ad(!KL(this,64),a),this.Y&&(this.Y.nn=KL(this,64)))};T.np=function(a){uM.e.np[L](this,a);this.Y&&!this.nk()&&(this.Y.nn=!1)};T.Wh=function(){this[pz](!1);return!0};T.dfa=function(a){this.Y&&this.Y.O()&&!this.zr(a[Mq])&&this.ad(!1)};T.zr=function(a){return a&&dl(this.a(),a)||this.Y&&this.Y.zr(a)||!1};
T.ml=function(a){if(32==a[Np]){if(a[Hp](),a[H]!=xF)return!0}else if(a[H]!=vF)return!1;if(this.Y&&this.Y.O()){var b=this.Y.Ci(a);return 27==a[Np]?(this.ad(!1),!0):b}return 40==a[Np]||38==a[Np]||32==a[Np]||13==a[Np]?(this.ad(!0,a),!0):!1};T.Hr=function(){this.ad(!1)};T.efa=function(){this.nk()||this.ad(!1)};T.Hw=function(a){this.rz||this.ad(!1);uM.e.Hw[L](this,a)};T.bg=function(){this.Y||this.jm(new qM(this.ea(),this.qma));return this.Y||null};
T.jm=function(a){var b=this.Y;if(a!=b&&(b&&(this.ad(!1),this.yb&&vM(this,b,!1),delete this.Y),this.yb&&bL(this.q,XE,!!a),a)){this.Y=a;WK(a,this);a[hy](!1);var c=this.rz;(a.YG=c)&&a.kn(!0);this.yb&&vM(this,a,!0)}return b};T.bj=function(a){this.bg().ua(a,!0)};T.uu=function(a,b){this.bg().qx(a,b,!0)};T.bd=function(a){return this.Y?this.Y.ff(a):null};T.Ig=function(){return this.Y?this.Y.Zf():0};fw(T,function(a,b){var c=uM.e[hy][L](this,a,b);c&&!this.O()&&this.ad(!1);return c});
T.Ga=function(a){uM.e.Ga[L](this,a);this[Ay]()||this.ad(!1)};T.iaa=function(){this.ad(!0)};T.ev=function(){this.ad(!1)};
T.ad=function(a,b){uM.e.ad[L](this,a);if(this.Y&&KL(this,64)==a){if(a){if(!this.Y.yb)if(this.gfa){var c;c=this.a();(c=void 0!=c.nextElementSibling?c.nextElementSibling:tea(c[ac]))?this.Y.Hy(c[fe],c):this.Y.B(this.a()[fe])}else this.Y.B();this.W3=Il(this.a());this.V3=Ql(this.a());this.TK();this.Y.nf(!b||40!=b[Np]&&38!=b[Np]?-1:0)}else{this[pz](!1);this.Y.nn=!1;if(c=this.a())bL(c,rC,O),bL(c,ZG,O);null!=this.ZK&&(this.ZK=void 0,(c=this.Y.a())&&Nl(c,O,O))}this.Y[hy](a,!1,b);if(!this.Mj){c=this.hc();var d=
a?c.l:c.uc;d[L](c,this.ea().$b(),es,this.dfa,!0);this.rz&&d[L](c,this.Y,TC,this.efa);d[L](c,this.Sc,Fs,this.ffa);a?this.Sc[y]():this.Sc[Hq]()}}};T.TK=function(){if(this.Y.yb){var a=this.Xfa||this.a(),b=this.wN;cx(this.wN,a);a=this.Y.a();this.Y.O()||(hb(a[x],Ig),Sl(a,!0));!this.ZK&&this.wN.Eia&&this.wN.XN&32&&(this.ZK=Pl(a));b.Ie(a,b.fH^1,this.gia,this.ZK);this.Y.O()||(Sl(a,!1),hb(a[x],Fh))}};
T.ffa=function(){var a=Ql(this.a()),b=Il(this.a()),c;(c=!yl(this.V3,a))||(c=this.W3,c=!(c==b||c&&b&&c.top==b.top&&c[Zc]==b[Zc]&&c[Hc]==b[Hc]&&c[G]==b[G]));c&&(this.V3=a,this.W3=b,this.TK())};function vM(a,b,c){var d=a.hc();c=c?d.l:d.uc;c[L](d,b,qC,a.Hr);c[L](d,b,bF,a.BU);c[L](d,b,UI,a.DU)}function hDa(a,b){var c=a.hc();(b?c.l:c.uc)[L](c,a.a(),wF,a.Tia)}T.BU=function(a){var b=this.a();null!=a[Mq].a()&&(bL(b,rC,a[Mq].a().id),bL(b,ZG,a[Mq].a().id))};
T.Tia=function(a){JL(this,32)&&this.pg()&&this.Y&&this.Y.O()&&a[Zp]()};T.DU=function(){if(!hM(this.Y)){var a=this.a();bL(a,rC,O);bL(a,ZG,O)}};ML($pa,function(){return new uM(null)});function wM(a){rt[L](this);this.Mr=[];iDa(this,a)}X(wM,rt);T=wM[K];T.wx=null;T.zN=null;T.Ig=function(){return this.Mr[J]};T.bd=function(a){return this.Mr[a]||null};function iDa(a,b){b&&(Y(b,function(a){this.zB(a,!1)},a),Zi(a.Mr,b))}T.bj=function(a){this.uu(a,this.Ig())};T.uu=function(a,b){a&&(this.zB(a,!1),Ui(this.Mr,a,b))};T.Ke=function(){return this.wx};T.vA=function(){return Yi(this.Mr)};T.lk=function(a){a!=this.wx&&(this.zB(this.wx,!1),this.wx=a,this.zB(a,!0));this[$](As)};
T.sr=function(){var a=this.wx;return a?Ci(this.Mr,a):-1};T.Ok=function(a){this.lk(this.bd(a))};wa(T,function(){Ti(this.Mr);this.wx=null});T.w=function(){wM.e.w[L](this);delete this.Mr;this.wx=null};T.zB=function(a,b){a&&(typeof this.zN==Bg?this.zN(a,b):typeof a.Fn==Bg&&a.Fn(b))};function xM(a,b,c,d,e){uM[L](this,a,b,c,d,e||new pM(Owa));this.oF=this[nz]();this.PX=null}X(xM,uM);T=xM[K];T.pa=null;T.Bb=function(){xM.e.Bb[L](this);yM(this);jDa(this)};T.mf=function(a){xM.e.mf[L](this,a);(a=this.Tk())?(this.oF=a,yM(this)):this.Ke()||this.Ok(0)};T.w=function(){xM.e.w[L](this);this.pa&&(this.pa.W(),this.pa=null);this.oF=null};T.Hr=function(a){this.lk(a[Mq]);xM.e.Hr[L](this,a);a[Zp]();this[$](qC)};T.jY=function(){var a=this.Ke();xM.e.wa[L](this,a&&a[I]());yM(this)};
T.jm=function(a){var b=xM.e.jm[L](this,a);a!=b&&(this.pa&&this.pa[Wb](),a&&(this.pa?XK(a,function(a){zM(a);this.pa.bj(a)},this):AM(this,a)));return b};T.bj=function(a){zM(a);xM.e.bj[L](this,a);this.pa?this.pa.bj(a):AM(this,this.bg())};T.uu=function(a,b){zM(a);xM.e.uu[L](this,a,b);this.pa?this.pa.uu(a,b):AM(this,this.bg())};T.lk=function(a){if(this.pa){var b=this.Ke();this.pa.lk(a);a!=b&&this[$](qD)}};T.Ok=function(a){this.pa&&this.lk(this.pa.bd(a))};
T.wa=function(a){if(null!=a&&this.pa)for(var b=0,c;c=this.pa.bd(b);b++)if(c&&typeof c[I]==Bg&&c[I]()==a){this.lk(c);return}this.lk(null)};fb(T,function(){var a=this.Ke();return a?a[I]():null});T.Ke=function(){return this.pa?this.pa.Ke():null};T.sr=function(){return this.pa?this.pa.sr():-1};function AM(a,b){a.pa=new wM;b&&XK(b,function(a){zM(a);this.pa.bj(a)},a);jDa(a)}function jDa(a){a.pa&&a.hc().l(a.pa,As,a.jY)}
function yM(a){var b=a.Ke();a[mz](b?b.Tk():a.oF);var c=a.eb().$a(a.a());c&&a.ea().Zia(c)&&(null==a.PX&&(a.PX=cL(c)),a=(b=b?b.a():null)?cL(b):a.PX,bL(c,zF,a))}function zM(a){a.iea(a instanceof XL?Dxa:VH)}T.ad=function(a,b){xM.e.ad[L](this,a,b);KL(this,64)&&this.bg().nf(this.sr())};ML(gqa,function(){return new xM(null)});function BM(a,b){this.P=Ek();this.m=a;this.o$=[];this.We(b)}BM[K].nB=null;
function kDa(a,b){var c=Ek(),d,e,f=null;switch(a){case 2:d=new sL(Hua);f=tH+d[Fz]();e=c.h(Q,null,c.h(Q,{"class":Gua},joa),c.h(bD,null),c.h(cya,null,c.h(Q,{id:f},b[aq])));break;case 3:d=new sL(Fua);e=c.h(Q,null,c.h(Q,{"class":Gua},joa),c.h(bD,null));var g=c.h(Q,null,c.h(cya,null,b[aq]));c[p](e,g)}d[mz](e[hd]);c=d;wL(c);Wa(c.ej,Boa);c=d;wL(c);Wa(c.kh,O);d[hy](!0);if(f){d=c=Hk(f);f=0;e=1;g=new SK;g.Vn=sCa(d,f,c,e);if(bl(d)&&!Uk(d)){var k=d[fe],f=Ci(k[Xb],d);d=k}bl(c)&&!Uk(c)&&(k=c[fe],e=Ci(k[Xb],c),
c=k);g.Vn?(g.Nd=c,g.Md=e,g.qd=d,g.Ld=f):(g.Nd=d,g.Md=f,g.qd=c,g.Ld=e);g[Gx]()}}
BM[K].We=function(a){a=a||[];var b=this.m,c=this.P;c.cd(b);if(!b)throw m(hf);var d=c.h(Bs,null),e=[c.h(Bs,null,eoa)];this.nB=new xM(e);if(a)for(e=0;e<a[J];e++){var f=null,f=a[e],g=f.datasource,k=f.gadget,l=f.userprefs,n=f[Md],q=f[Nxa],s=f[x]||yBa;switch(f[H]){case Rsa:f=CM(this,e,gi(function(a){ca[oq]((new Ct(a)).Oc(SAa,Exa),Coa)},g),uoa);break;case zva:f=CM(this,e,gi(function(a,b){kDa(2,{message:Nna+s+rla+aa(a)+$la+aa(b)+lDa(l)+pe})},k,g),cpa);break;case Sva:f=CM(this,e,gi(function(a,b,c){kDa(3,
{message:Mna+aa(b)+bma+a+ama+aa(c)+cma})},g,q,n),Loa);break;case Mg:f=CM(this,e,gi(function(a){ca[oq]((new Ct(a)).Oc(SAa,Fxa),Coa)},g),voa);break;case Eva:f=CM(this,e,gi(function(a,b,c){ca[oq](Bva+aa(a)+$la+aa(b)+lDa(c))},k,g,l),Xna);break;default:throw m("No such toolbar component as: "+f.toSource());}f&&this.nB.bj(f)}kt(this.nB,qC,W(this.Pia,this));this.nB.B(d);c[p](b,d)};BM[K].Pia=function(){var a=this.nB.sr();this.o$[a]();this.nB.Ok(-1)};function CM(a,b,c,d){d=new XL(d);a.o$[b]=c;return d}
function lDa(a){if(!a)return O;var b=O,c;for(c in a)b+=Zla+c+af+aa(a[c]);return b};function FL(){}X(FL,DL);Uh(FL);FL[K].h=function(a){var b=a.ea().h(Bs,this.ol(a)[ie](ne));mDa(this,b,a.lp);return b};FL[K].Ia=function(a,b){b=FL.e.Ia[L](this,a,b);var c=dL(b),d=!1;Ri(c,KM(this,null))?d=null:Ri(c,KM(this,!0))?d=!0:Ri(c,KM(this,!1))&&(d=!1);a.lp=d;bL(b,BD,null==d?CG:!0==d?zh:wg);return b};FL[K].yj=function(){return AD};function mDa(a,b,c){if(b){var d=KM(a,c);eL(b,d)||(Dj(nDa,function(a){a=KM(this,a);jL(b,a,a==d)},a),bL(b,BD,null==c?CG:!0==c?zh:wg))}}FL[K].$=function(){return Upa};
function KM(a,b){var c=a.$();if(!0==b)return c+mma;if(!1==b)return c+Dma;if(null==b)return c+Ema;throw m("Invalid checkbox state: "+b);};function LM(a,b,c){c=c||FL.Xb();OL[L](this,null,c,b);this.lp=Qh(a)?a:!1}X(LM,OL);var nDa={Fua:!0,Bwa:!1,Cwa:null};T=LM[K];T.Gb=null;T.Xl=function(){return!0==this.lp};T.Dg=function(a){a!=this.lp&&(this.lp=a,mDa(this.eb(),this.a(),this.lp))};T.Zl=function(a){this.yb?(this.ve(),this.Gb=a,this.Bb()):this.Gb=a};T.toggle=function(){this.Dg(this.lp?!1:!0)};
T.Bb=function(){LM.e.Bb[L](this);if(this.sL){var a=this.hc();this.Gb&&a.l(this.Gb,Fr,this.OV).l(this.Gb,gs,this.En).l(this.Gb,fs,this.uM).l(this.Gb,es,this.Le).l(this.Gb,FG,this.np);a.l(this.a(),Fr,this.OV)}if(this.Gb){if(!this.Gb.id){var a=this.Gb,b;b=this[Fz]()+Rma;a.id=b}a=this.a();bL(a,CF,this.Gb.id)}};T.Ga=function(a){LM.e.Ga[L](this,a);(a=this.a())&&bb(a,this[Ay]()?0:-1)};T.OV=function(a){a[Zp]();var b=this.lp?$Aa:Yra;this[Ay]()&&!a[Mq][Ic]&&this[$](b)&&(a[Hp](),this.toggle(),this[$](qD))};
T.ml=function(a){32==a[Np]&&this.OV(a);return!1};ML(Upa,function(){return new LM});function MM(a,b){rt[L](this);this.q=a;var c=bl(this.q)?this.q:this.q?this.q[Pd]:null;this.ena=!!c&&Kl(c);this.H8=kt(this.q,lk?loa:GG,this,b)}X(MM,rt);
kp(MM[K],function(a){var b=0,c=0,d=0;a=a.Ka;if(a[H]==GG){c=1;if(kk||mk&&(gk||qk(lna)))c=40;d=$M(-a.wheelDelta,c);Qh(a.wheelDeltaX)?(b=$M(-a.wheelDeltaX,c),c=$M(-a.wheelDeltaY,c)):c=d}else d=a.detail,100<d?d=3:-100>d&&(d=-3),Qh(a[Oz])&&a[Oz]===a.HORIZONTAL_AXIS?b=d:c=d;di(this.yca)&&(b=nj(b,-this.yca,this.yca));di(this.zca)&&(c=nj(c,-this.zca,this.zca));this.ena&&(b=-b);b=new oDa(d,a,b,c);this[$](b)});function $M(a,b){return mk&&(fk||hk)&&0!=a%b?a:a/b}
MM[K].w=function(){MM.e.w[L](this);pt(this.H8);this.H8=null};function oDa(a,b,c,d){$s[L](this,b);ab(this,GG);this.detail=a;this.Nt=c;this.lr=d}X(oDa,$s);function aN(){rt[L](this);this.n=0;ww(this,null);this.Ks=null}X(aN,rt);aN[K].Zt=function(){return 1==this.n};aN[K].nH=function(){this.Qi(hra)};aN[K].Zw=function(){this.Qi(oE)};aN[K].Qi=function(a){this[$](a)};function bN(){aN[L](this);this.Cr=[]}X(bN,aN);bN[K].add=function(a){Ri(this.Cr,a)||(this.Cr[C](a),kt(a,BE,this.uda,!1,this))};va(bN[K],function(a){Wi(this.Cr,a)&&ot(a,BE,this.uda,!1,this)});bN[K].w=function(){Y(this.Cr,function(a){a.W()});jb(this.Cr,0);bN.e.w[L](this)};function cN(){bN[L](this);this.R_=0}X(cN,bN);
cN[K].play=function(a){if(0==this.Cr[J])return!1;if(a||0==this.n)this.R_=0,this.nH();else if(this.Zt())return!1;this.Qi(hH);-1==this.n&&this.Qi(Tya);var b=-1==this.n&&!a;ww(this,hi());this.Ks=null;this.n=1;Y(this.Cr,function(c){b&&-1!=c.n||c[fz](a)});return!0};zp(cN[K],function(a){Y(this.Cr,function(b){0==b.n||b[Hq](a)});this.n=0;this.Ks=hi();this.Qi(sI);this.Zw()});cN[K].uda=function(){this.R_++;this.R_==this.Cr[J]&&(this.Ks=hi(),this.n=0,this.Qi(BE),this.Zw())};function dN(a,b,c){this.yr=a;this.Nu=b||0;this.Td=c;this.Yr=W(this.zJ,this)}X(dN,Us);T=dN[K];T.bc=0;T.w=function(){dN.e.w[L](this);this[Hq]();delete this.yr;delete this.Td};La(T,function(a){this[Hq]();this.bc=ut(this.Yr,Qh(a)?a:this.Nu)});zp(T,function(){this.nk()&&vt(this.bc);this.bc=0});T.VR=function(){this[Hq]();this.zJ()};T.nk=function(){return 0!=this.bc};T.zJ=function(){this.bc=0;this.yr&&this.yr[L](this.Td)};var eN={},fN=null;function gN(a){a=fi(a);delete eN[a];Kj(eN)&&fN&&fN[Hq]()}function pDa(){fN||(fN=new dN(function(){qDa()},20));var a=fN;a.nk()||a[y]()}function qDa(){var a=hi();Dj(eN,function(b){rDa(b,a)});Kj(eN)||pDa()};function hN(a,b,c,d){aN[L](this);if(!Yh(a)||!Yh(b))throw m("Start and end parameters must be arrays");if(a[J]!=b[J])throw m("Start and end points must be the same length");this.Ei=a;this.Iq=b;this.duration=c;this.Yca=d;$w(this,[]);this.nx=!1}X(hN,aN);T=hN[K];T.wt=function(a){this.nx=a};T.Nm=0;
T.play=function(a){if(a||0==this.n)this.Nm=0,$w(this,this.Ei);else if(this.Zt())return!1;gN(this);a=hi();ww(this,a);-1==this.n&&ww(this,this[Iy]-this[xz]*this.Nm);this.Ks=this[Iy]+this[xz];this.Nm||this.nH();this.Qi(hH);-1==this.n&&this.Qi(Tya);this.n=1;var b=fi(this);b in eN||(eN[b]=this);pDa();rDa(this,a);return!0};zp(T,function(a){gN(this);this.n=0;a&&(this.Nm=1);sDa(this,this.Nm);this.Qi(sI);this.Zw()});T.w=function(){0==this.n||this[Hq](!1);this.Qi(bta);hN.e.w[L](this)};
function rDa(a,b){a.Nm=(b-a[Iy])/(a.Ks-a[Iy]);1<=a.Nm&&(a.Nm=1);sDa(a,a.Nm);1==a.Nm?(a.n=0,gN(a),a.Qi(BE),a.Zw()):a.Zt()&&a.bZ()}function sDa(a,b){ei(a.Yca)&&(b=a.Yca(b));$w(a,ha(a.Ei[J]));for(var c=0;c<a.Ei[J];c++)a[Iz][c]=(a.Iq[c]-a.Ei[c])*b+a.Ei[c]}T.bZ=function(){this.Qi(yqa)};T.Qi=function(a){this[$](new tDa(a,this))};function tDa(a,b){Xs[L](this,a);$w(this,b[Iz]);this.x=b[Iz][0];this.y=b[Iz][1];this.z=b[Iz][2];this.duration=b[xz];this.Nm=b.Nm;qp(this,b.n)}X(tDa,Xs);function iN(a,b,c,d,e){hN[L](this,b,c,d,e);cx(this,a)}X(iN,hN);T=iN[K];T.Px=Th;T.Lg=function(){Qh(this.jo)||(this.jo=Kl(this[Mz]));return this.jo};T.bZ=function(){this.Px();iN.e.bZ[L](this)};T.Zw=function(){this.Px();iN.e.Zw[L](this)};T.nH=function(){this.Px();iN.e.nH[L](this)};function jN(a,b,c,d,e){if(2!=b[J]||2!=c[J])throw m(tpa);iN[Mc](this,arguments)}X(jN,iN);jN[K].Px=function(){var a=this.nx&&this.Lg()?zs:Qg;this[Mz][x][a]=h[D](this[Iz][0])+S;this[Mz][x].top=h[D](this[Iz][1])+S};
function kN(a,b,c,d,e){if(2!=b[J]||2!=c[J])throw m(tpa);iN[Mc](this,arguments)}X(kN,iN);kN[K].Px=function(){pa(this[Mz][x],h[D](this[Iz][0])+S);Sa(this[Mz][x],h[D](this[Iz][1])+S)};function lN(a,b,c,d,e){iN[L](this,a,[b],[c],d,e)}X(lN,iN);lN[K].Px=function(){pa(this[Mz][x],h[D](this[Iz][0])+S)};function mN(a,b,c,d,e){iN[L](this,a,[b],[c],d,e)}X(mN,iN);mN[K].Px=function(){Sa(this[Mz][x],h[D](this[Iz][0])+S)};function nN(){rt[L](this)}X(nN,rt);T=nN[K];T.hd=0;T.qo=0;T.Sm=100;T.Gl=0;T.Ui=1;T.tk=!1;T.Lx=!1;T.wa=function(a){a=oN(this,a);this.hd!=a&&(this.hd=a+this.Gl>this.Sm?this.Sm-this.Gl:a<this.qo?this.qo:a,this.tk||this.Lx||this[$](qD))};fb(T,function(){return oN(this,this.hd)});T.VQ=function(a){a=oN(this,a);this.Gl!=a&&(this.Gl=0>a?0:this.hd+a>this.Sm?this.Sm-this.hd:a,this.tk||this.Lx||this[$](qD))};T.fl=function(){var a=this.Gl;return null==this.Ui?a:h[D](a/this.Ui)*this.Ui};
T.Gs=function(a){if(this.qo!=a){var b=this.tk;this.tk=!0;this.qo=a;a+this.Gl>this.Sm&&(this.Gl=this.Sm-this.qo);a>this.hd&&this.wa(a);a>this.Sm&&(this.Gl=0,this.nq(a),this.wa(a));(this.tk=b)||this.Lx||this[$](qD)}};T.Ye=function(){return oN(this,this.qo)};T.nq=function(a){a=oN(this,a);if(this.Sm!=a){var b=this.tk;this.tk=!0;this.Sm=a;a<this.hd+this.Gl&&this.wa(a-this.Gl);a<this.qo&&(this.Gl=0,this.Gs(a),this.wa(this.Sm));a<this.qo+this.Gl&&(this.Gl=this.Sm-this.qo);(this.tk=b)||this.Lx||this[$](qD)}};
T.Xe=function(){return oN(this,this.Sm)};T.dI=function(){return this.Ui};T.GQ=function(a){this.Ui!=a&&(this.Ui=a,a=this.tk,this.tk=!0,this.nq(this.Xe()),this.VQ(this.fl()),this.wa(this[I]()),(this.tk=a)||this.Lx||this[$](qD))};function oN(a,b){return null==a.Ui?b:a.qo+h[D]((b-a.qo)/a.Ui)*a.Ui};function pN(a,b){VK[L](this,a);this.J9=null;this.ze=new nN;this.$ja=b||Jda;kt(this.ze,qD,this.Kaa,!1,this)}X(pN,VK);var uDa={yS:Eh,xS:Jg};T=pN[K];T.ib=Jg;T.BP=!1;T.nia=!1;T.Im=10;T.PQ=0;T.e7=!0;T.zM=0;T.mia=1E3;T.qg=!0;T.Yk=!1;T.h=function(){pN.e.h[L](this);var a=this.ea().h(Q,this.$(this.ib));this.mf(a)};T.mf=function(a){pN.e.mf[L](this,a);fL(a,this.$(this.ib));this.Vha();a=this.a();aL(a,hI);vDa(this)};
T.Bb=function(){pN.e.Bb[L](this);this.Sk=new kL(this.ld);this.dp=new kL(this.Bi);this.Sk.wt(this.Yk);this.dp.wt(this.Yk);this.Sk.Jw=this.dp.Jw=Th;this.lf=new CL(this.a());wDa(this,!0);bb(this.a(),0);qN(this)};
function wDa(a,b){b?(a.hc().l(a.Sk,MC,a.FN).l(a.dp,MC,a.FN).l(a.Sk,[nI,oE],a.Tt).l(a.dp,[nI,oE],a.Tt).l(a.lf,vF,a.mm).l(a.a(),Fr,a.JN).l(a.a(),es,a.JN),a.e7&&xDa(a,!0)):(a.hc().uc(a.Sk,MC,a.FN).uc(a.dp,MC,a.FN).uc(a.Sk,[nI,oE],a.Tt).uc(a.dp,[nI,oE],a.Tt).uc(a.lf,vF,a.mm).uc(a.a(),Fr,a.JN).uc(a.a(),es,a.JN),a.e7&&xDa(a,!1))}T.ve=function(){pN.e.ve[L](this);wia(this.Sk,this.dp,this.lf,this.Rl)};
T.FN=function(a){var b=a.XX==this.Sk?this.ld:this.Bi,c;this.ib==Eh?(c=this.a()[Wd]-b[Uc],c=(c-a.top)/c*(this.Xe()-this.Ye())+this.Ye()):(c=this.a()[Gd]-b[zb],c=a[G]/c*(this.Xe()-this.Ye())+this.Ye());c=a.XX==this.Sk?h.min(h.max(c,this.Ye()),this[I]()+this.fl()):h.min(h.max(c,this[I]()),this.Xe());rN(this,b,c)};T.Tt=function(a){var b=a[H]==nI;jL(this.a(),jqa,b);jL(a[Mq][py],kqa,b);a=a.XX==this.Sk;b?(this[$](jE),this[$](a?bg:lg)):(this[$](vg),this[$](a?fg:ng))};
T.mm=function(a){var b=!0;switch(a[Np]){case 36:sN(this,this.Ye());break;case 35:sN(this,this.Xe());break;case 33:tN(this,this.Im);break;case 34:tN(this,-this.Im);break;case 37:var c=this.Yk&&this.Lg()?1:-1;tN(this,a[Oq]?c*this.Im:c*this.Qx);break;case 40:tN(this,a[Oq]?-this.Im:-this.Qx);break;case 39:c=this.Yk&&this.Lg()?-1:1;tN(this,a[Oq]?c*this.Im:c*this.Qx);break;case 38:tN(this,a[Oq]?this.Im:this.Qx);break;default:b=!1}b&&a[Hp]()};
T.JN=function(a){this.a()[Fx]&&this.a()[Fx]();var b=a[Mq];dl(this.ld,b)||dl(this.Bi,b)||(b=a[H]==Fr,b&&hi()<this.zM+this.mia||(b||(this.zM=hi()),this.nia?sN(this,yDa(this,a)):(this.UW(a),this.xm=zDa(this,yDa(this,a)),this.W6=this.ib==Eh?this.tw<this.xm[Tc]:this.tw>uN(this,this.xm)+this.xm[zb],a=Gk(this.a()),this.hc().l(a,FG,this.QW,!0).l(this.a(),EG,this.UW),this.kt||(this.kt=new tt(200),this.hc().l(this.kt,Fs,this.X6)),this.X6(),this.kt[y]())))};
T.G7=function(a){tN(this,(0<a.detail?-1:1)*this.Qx);a[Hp]()};T.X6=function(){var a;if(this.ib==Eh){var b=this.tw,c=this.xm[Tc];this.W6?b<c&&(a=vN(this,this.xm)+this.Im):b>c+this.xm[Uc]&&(a=vN(this,this.xm)-this.Im)}else b=this.tw,c=uN(this,this.xm),this.W6?b>c+this.xm[zb]&&(a=vN(this,this.xm)+this.Im):b<c&&(a=vN(this,this.xm)-this.Im);Qh(a)&&rN(this,this.xm,a)};T.QW=function(){this.kt&&this.kt[Hq]();var a=Gk(this.a());this.hc().uc(a,FG,this.QW,!0).uc(this.a(),EG,this.UW)};
function wN(a,b){var c=Ll(b,a.a());return a.ib==Eh?c.y:a.Yk&&a.Lg()?a.a()[Gd]-c.x:c.x}T.UW=function(a){this.tw=wN(this,a)};function yDa(a,b){var c=a.Ye(),d=a.Xe();if(a.ib==Eh){var e=a.ld[Uc],f=a.a()[Wd]-e,e=wN(a,b)-e/2;return(d-c)*(f-e)/f+c}e=a.ld[zb];f=a.a()[Gd]-e;e=wN(a,b)-e/2;return(d-c)*e/f+c}function vN(a,b){if(b==a.ld)return a.ze[I]();if(b==a.Bi)return a.ze[I]()+a.ze.fl();throw m("Illegal thumb element. Neither minThumb nor maxThumb");}
function tN(a,b){h.abs(b)<a.dI()&&(b=uj(b)*a.dI());var c=vN(a,a.ld)+b,d=vN(a,a.Bi)+b,c=nj(c,a.Ye(),a.Xe()-a.PQ),d=nj(d,a.Ye()+a.PQ,a.Xe());xN(a,c,d-c)}function rN(a,b,c){var d=oN(a.ze,c);c=b==a.ld?d:a.ze[I]();b=b==a.Bi?d:a.ze[I]()+a.ze.fl();c>=a.Ye()&&b>=c+a.PQ&&a.Xe()>=b&&xN(a,c,b-c)}function xN(a,b,c){a.Ye()<=b&&b<=a.Xe()-c&&a.PQ<=c&&c<=a.Xe()-b&&(b!=a[I]()||c!=a.fl())&&(a.ze.Lx=!0,a.ze.VQ(0),a.ze.wa(b),a.ze.VQ(c),a.ze.Lx=!1,a.Kaa())}T.Ye=function(){return this.ze.Ye()};T.Gs=function(a){this.ze.Gs(a)};
T.Xe=function(){return this.ze.Xe()};T.nq=function(a){this.ze.nq(a)};function zDa(a,b){return b<=a.ze[I]()+a.ze.fl()/2?a.ld:a.Bi}T.Kaa=function(){qN(this);vDa(this);this[$](qD)};
function qN(a){if(a.ld&&!a.BP){var b=yN(a,vN(a,a.ld)),c=yN(a,vN(a,a.Bi));if(a.ib==Eh)a.ld[x].top=b.y+S,a.Bi[x].top=c.y+S,a.cg&&(b=zN(c.y,b.y,a.ld[Uc]),a.cg[x].top=b[by]+S,Sa(a.cg[x],b[ly]+S));else{var d=a.Yk&&a.Lg()?zs:Qg;a.ld[x][d]=b.x+S;a.Bi[x][d]=c.x+S;a.cg&&(b=zN(b.x,c.x,a.ld[zb]),a.cg[x][d]=b[by]+S,pa(a.cg[x],b[ly]+S))}}}function zN(a,b,c){var d=h[xb](c/2);return{offset:a+d,size:h.max(b-a+c-2*d,0)}}
function yN(a,b){var c=new sk;if(a.ld){var d=a.Ye(),e=a.Xe(),d=b==d&&d==e?0:(b-d)/(e-d);a.ib==Eh?(e=a.ld[Uc],e=a.a()[Wd]-e,d=h[D](d*e),c.x=uN(a,a.ld),c.y=e-d):(e=a.a()[Gd]-a.ld[zb],d=h[D](d*e),c.x=d,c.y=a.ld[Tc])}return c}
function sN(a,b){b=nj(b,a.Ye(),a.Xe());a.BP&&a.QM[Hq](!0);var c=new cN,d,e=zDa(a,b),f=a[I](),g=a.fl(),k=vN(a,e),l=yN(a,k);d=a.dI();h.abs(b-k)<d&&(b=nj(k+(b>k?d:-d),a.Ye(),a.Xe()));rN(a,e,b);k=yN(a,vN(a,e));d=a.ib==Eh?[uN(a,e),k.y]:[k.x,e[Tc]];l=new jN(e,[l.x,l.y],d,100);l.wt(a.Yk);c.add(l);a.cg&&ADa(a,e,f,g,k,c);a.J9&&(e=a.J9.Eta(f,b,100),Y(e,function(a){c.add(a)}));a.QM=c;a.hc().l(c,oE,a.jla);a.BP=!0;c[fz](!1)}
function ADa(a,b,c,d,e,f){var g=yN(a,c),k=yN(a,c+d);c=g;d=k;b==a.ld?c=e:d=e;a.ib==Eh?(b=zN(k.y,g.y,a.ld[Uc]),g=zN(d.y,c.y,a.ld[Uc]),e=new jN(a.cg,[uN(a,a.cg),b[by]],[uN(a,a.cg),g[by]],100),b=new mN(a.cg,b[ly],g[ly],100)):(b=zN(g.x,k.x,a.ld[zb]),g=zN(c.x,d.x,a.ld[zb]),e=new jN(a.cg,[b[by],a.cg[Tc]],[g[by],a.cg[Tc]],100),b=new lN(a.cg,b[ly],g[ly],100));e.wt(a.Yk);b.wt(a.Yk);f.add(e);f.add(b)}T.jla=function(){this.BP=!1};
T.HG=function(a){if(this.ib!=a){var b=this.$(this.ib),c=this.$(a);this.ib=a;this.a()&&(a=this.a(),eL(a,b)&&(hL(a,b),fL(a,c)),b=this.Yk&&this.Lg()?zs:Qg,this.ld[x][b]=this.ld[x].top=O,this.Bi[x][b]=this.Bi[x].top=O,this.cg&&(this.cg[x][b]=this.cg[x].top=O,pa(this.cg[x],Sa(this.cg[x],O))),qN(this))}};T.Dr=function(){return this.ib};
T.w=function(){pN.e.w[L](this);this.kt&&this.kt.W();delete this.kt;this.QM&&this.QM.W();delete this.QM;delete this.ld;delete this.Bi;this.cg&&delete this.cg;this.ze.W();delete this.ze;this.lf&&(this.lf.W(),delete this.lf);this.Rl&&(this.Rl.W(),delete this.Rl);this.Sk&&(this.Sk.W(),delete this.Sk);this.dp&&(this.dp.W(),delete this.dp)};T.Qx=1;T.dI=function(){return this.ze.dI()};T.GQ=function(a){this.ze.GQ(a)};fb(T,function(){return this.ze[I]()});T.wa=function(a){rN(this,this.ld,a)};T.fl=function(){return this.ze.fl()};
T.VQ=function(a){rN(this,this.Bi,this.ze[I]()+a)};fw(T,function(a){Sl(this.a(),a);a&&qN(this)});function vDa(a){var b=a.a();b&&(bL(b,rBa,a.Ye()),bL(b,qBa,a.Xe()),bL(b,sBa,a[I]()),bL(b,tBa,a.$ja(a[I]())||O))}function xDa(a,b){b?(a.Rl||(a.Rl=new MM(a.a())),a.hc().l(a.Rl,GG,a.G7)):a.hc().uc(a.Rl,GG,a.G7)}T.Ga=function(a){this.qg!=a&&this[$](a?mE:dE)&&(this.qg=a,wDa(this,a),a||this.QW(),jL(this.a(),iqa,!a))};qw(T,function(){return this.qg});function uN(a,b){return a.Yk?RBa(b):b[Od]};V("google.visualization.drawToolbar",function(a,b){new BM(a,b)},void 0);var BDa=h.log(10);function AN(a){return a[ie](qe)}var CDa=["minorgridline",TE,BC,rI,JC,Pxa,LC,rF,JF,iD,cD,xC,mH,iH,HI,"axistick","axistitle",nD,zC,DF,GF,FF,rsa,Hs,qC];function BN(a,b,c){return{html:DDa(a),Eca:!1,Fca:c,anchor:c,Dca:b,Gca:20,margin:5}}function DDa(a){if(0==a[Ez][J])return{name:Q,content:[],fd:{className:OE}};var b=Pi(a[Ez],function(a){return a[H]==VH}),c;-1==b?c=EDa(a[Ez]):(c=EDa($i(a[Ez],0,b)),a=FDa($i(a[Ez],b+1)),c=Xi(c,{name:Q,fd:{className:Mua}},a));return{name:Q,content:c,fd:{className:OE}}}function EDa(a){return{name:SI,fd:{className:Lua},content:Gi(a,function(a){return{name:IF,content:GDa(a[Z]),fd:{className:Kua}}})}}
function FDa(a){return{name:SI,fd:{className:Jua},content:Gi(a,function(a){return{name:IF,id:AN([qC,a[Z].id]),content:GDa(a[Z]),fd:{className:Iua}}})}}function GDa(a){return Gi(a[cy],function(a,c){switch(a[H]){case Es:var d=a[Z][x];return{name:Bs,style:pua+d.Va+una+(d.Ic?uF:R)+zna+(d.De?TI:R)+vna+(d[Ed]?UC:R)+Ye,ela:!!a[jy],content:(0==c?O:ne)+a[Z][cd]};case jI:return{name:Q,style:gg+(a[Z].brush&&a[Z].brush.gb())+Ye,fd:{className:Nua}}}})};function CN(a,b,c,d,e,f,g,k,l){var n={items:[]};null!=e&&(e=Zm(e,f),n[cy][C]({type:jI,data:{size:b[uc]/2,brush:e}}));null!=g&&n[cy][C](DN(g,b));if(null!=c){if(null==d)throw m("Line title is specified without a text style.");c=DN(c+Xe,d);n[cy][C](c)}c=DN(a,b,k);n[cy][C](c);null!=l&&(n.id=l,Ww(n,{brush:Ym}));return{type:JF,data:n}}function HDa(a){return{type:JF,data:{items:Gi(a,function(a){if(null!=a[cd])return DN(a[cd],a[x],a[jy]);throw m("Unrecognized item.");})}}}
function IDa(){return{type:VH,data:{brush:$m(xA,1)}}}function DN(a,b,c){a={type:Es,data:{text:a,style:b}};c&&(a.html=!0);return a}
function EN(a,b,c,d,e,f,g,k){if(k)return BN(a,e,f);for(var l=k=0;l<a[Ez][J];l++){var n=a[Ez][l];if(n[H]==JF)for(var n=n[Z],q=0;q<n[cy][J];q++){var s=n[cy][q];s[H]==Es&&(k=h.max(k,s[Z][x][uc]))}}0==k&&(k=g||0);var u;g=k;for(q=l=n=0;q<a[Ez][J];q++)switch(s=a[Ez][q],s[H]){case JF:s=JDa(s[Z],b);l+=s[A]+(0<q?s.Ou:0);n=h.max(n,s[r]);break;case VH:l+=1.5*g+s[Z].brush.Hb}n=h.max(n,2*g);n=h[D](n+2*g/1.618);g=h[D](l+2*g/1.618);u=new xk(n,g);var l=uj(d.x-f.x),n=uj(d.y-f.y),w=null,w=c?new sk(d.x+l*k,d.y+n*(k+
u[A]/2)):new sk(d.x+l*u[r]/2,d.y+n*u[A]/2),q=w.x-u[r]/2,s=q+u[r],z=w.y-u[A]/2,B=z+u[A];g={};c&&(c=new sk(w.x,pj(d.y,w.y,k/(k+u[A]/2))),w=new sk(pj(w.x,d.x,-1),c.y),c.x=h[D](c.x),c.y=h[D](c.y),w.x=h[D](w.x),w.y=h[D](w.y),g.zj=1==l*n?[c,d,w]:[w,d,c]);g.la=new rl(h[D](z),h[D](s),h[D](B),h[D](q));d=e[G]+5;c=e[Zc]-5;if(!(g.la[G]>=d&&g.la[Zc]<=c)){l=Qj(g);n=l.la[G];Ya(l.la,pj(f.x,l.la[Zc],-1));Ta(l.la,pj(f.x,n,-1));if(n=l.zj)q=n[0],n[0]=n[2],n[2]=q,n[0].x=pj(f.x,n[0].x,-1),n[1].x=pj(f.x,n[1].x,-1),n[2].x=
pj(f.x,n[2].x,-1);l.la[G]>=d&&l.la[Zc]<=c?(g.la=l.la,g.zj=l.zj):(g.zj&&(n=new zm(d+4,c-4),q=new zm(l.zj[0].x,l.zj[2].x),s=new zm(g.zj[0].x,g.zj[2].x),!(n[y]<=s[y]&&n.end>=s.end)&&n[y]<=q[y]&&n.end>=q.end&&(g.la=l.la,g.zj=l.zj)),g.la[Zc]>c&&(Ya(g.la,g.la[G]-(g.la[Zc]-c)),Ta(g.la,c)),g.la[G]<d&&(Ta(g.la,g.la[Zc]+(d-g.la[G])),Ya(g.la,d)))}d=e.top+5;e=e[Hc]-5;if(!(g.la.top>=d&&g.la[Hc]<=e)){c=Qj(g);l=c.la.top;c.la.top=pj(f.y,c.la[Hc],-1);Na(c.la,pj(f.y,l,-1));if(l=c.zj)n=l[0],l[0]=l[2],l[2]=n,l[0].y=
pj(f.y,l[0].y,-1),l[1].y=pj(f.y,l[1].y,-1),l[2].y=pj(f.y,l[2].y,-1);c.la.top>=d&&c.la[Hc]<=e?(g.la=c.la,g.zj=c.zj):(g.la[Hc]>e&&(g.la.top-=g.la[Hc]-e,Na(g.la,e)),g.la.top<d&&(Na(g.la,g.la[Hc]+(d-g.la.top)),g.la.top=d),delete g.zj)}f=k;e={};k=f/1.618;k=new rl(g.la.top+k,g.la[Zc]-k,g.la[Hc]-k,g.la[G]+k);d=[];var F=k.top,l=a[Ez][J],M=!1;for(c=0;c<l;c++)if(a[Ez][c].UI){M=!0;break}var N=[],n=[];for(c=0;c<l;c++)if(u=a[Ez][c],u[H]===JF){var P=u[Z],q=[];n[C](q);B=0;for(w=P[cy][J];B<w;B++){var ba=KDa(P[cy][B],
b);q[C](ba);u.UI&&(B>N[J]-1?N[C](ba[r]):N[B]=h.max(N[B],ba[r]))}}q=[];s=[];z=0;if(M)for(c=0;c<l;c++)if(u=a[Ez][c],u[H]==JF){M=[];s[C](M);var U=0;if(u.UI)for(P=u[Z],B=0,w=P[cy][J];B<w;B++)ba=n[z][B],u=N[B]-ba[r],M[C](u),U+=u;q[C](U);z++}for(c=z=0;c<l;c++){u=a[Ez][c];N={ih:u,data:{}};switch(u[H]){case JF:P=u[Z];M=N[Z];U=JDa(P,b);u.UI&&pa(U,U[r]+q[z]);0<c&&(F+=U.Ou);P[Dz]&&Ww(M,{la:new rl(F-U.Ou/2,g.la[Zc],F+U[A]+U.Ou,g.la[G])});for(var qa=[],ya=k[G],B=0,w=P[cy][J];B<w;B++){P={};ba=n[z][B];u.UI&&pa(ba,
ba[r]+s[z][B]);0<B&&(ya+=ba.iR);var Ha=F+(U[A]-ba[A])/2;P.la=new rl(h[D](Ha),h[D](ya+ba[r]),h[D](Ha+ba[A]),h[D](ya));qa[C](P);ya+=ba[r]}bw(M,qa);F+=U[A];z++;break;case VH:B=u[Z],w=F+f+B.brush.Hb/2,N[Z].line=new iK(g.la[G],w,g.la[Zc],w),F+=1.5*f+B.brush.Hb/2}d[C](N)}e.entries=d;return{outline:g,qH:e}}function JDa(a,b){for(var c=0,d=0,e=0,f=0;f<a[cy][J];f++)var g=KDa(a[cy][f],b),c=c+(g[r]+(0<f?g.iR:0)),d=h.max(d,g[A]),e=h.max(e,g[A]/2+g.Ou);return{width:c,height:d,Ou:e-d/2}}
function KDa(a,b){switch(a[H]){case Es:var c=a[Z][x];return{width:b?b(String(a[Z][cd]),c)[r]:0,height:c[uc],Ou:c[uc]/3.236,iR:c[uc]/3.236};case jI:var d=c=a[Z][ly];return{width:c,height:c,Ou:d,iR:d};default:return d=c=a[Z][ly],{width:c,height:c,Ou:d,iR:d}}};function FN(){this.sc=new ck;this.uk=new ck;this.bi=new ck}T=FN[K];wa(T,function(){this.sc=new ck;this.uk=new ck;this.bi=new ck});T.o=function(){var a=new FN;a.sc=new ck(this.sc.La());a.uk=new ck(this.uk.La());a.bi=new ck(this.bi.La());return a};Za(T,function(a){return this.sc[cz](a.sc)&&this.uk[cz](a.uk)&&this.bi[cz](a.bi)});function GN(a,b){var c=[];Bj(b==JH?a.sc:a.uk,function(a){c[C](la(a,10))});return c}function HN(a){return GN(a,JH)}
function IN(a){var b=[];Bj(a.bi,function(a){a=a[pc](Je);b[C]({row:la(a[0],10),column:la(a[1],10)})});return b}Tw(T,function(){for(var a=[],b=HN(this),c=GN(this,mg),d=IN(this),e=0;e<b[J];e++){var f={};f.row=b[e];f.column=null;a[C](f)}for(e=0;e<c[J];e++)f={row:null},f.column=c[e],a[C](f);for(e=0;e<d[J];e++)f={},f.row=d[e].row,f.column=d[e].column,a[C](f);return a});function JN(a,b){return a.sc[Lc](String(b))}function KN(a,b){return a.uk[Lc](String(b))}
function LN(a,b,c){if(b==JH?JN(a,c[0]):b==mg?KN(a,c[0]):a.bi[Lc](String(c[0]+Je+c[1])))return!1;b==JH?a.sc.add(String(c[0])):b==mg?a.uk.add(String(c[0])):a.bi.add(String(c[0]+Je+c[1]));return!0}T.lq=function(a){return LN(this,JH,[a])};T.mg=function(a){return LN(this,mg,[a])};function MN(a,b,c){var d=JN(a,b);c&&a[Wb]();d?a.mB(b):a.lq(b)}function NN(a,b,c){var d=KN(a,b);c&&a[Wb]();d?a.a2(b):a.mg(b)}
function ON(a,b,c,d){var e=a.bi[Lc](String(b+Je+c));d&&a[Wb]();e?a.bi[Lc](String(b+Je+c))&&a.bi[Ob](String(b+Je+c)):LN(a,oD,[b,c])}T.mB=function(a){if(!JN(this,a))return!1;this.sc[Ob](String(a));return!0};T.a2=function(a){if(!KN(this,a))return!1;this.uk[Ob](String(a));return!0};
Zv(T,function(a){var b=new ck,c=new ck,d=new ck;a||(a=[]);for(var e=0;e<a[J];e++){var f=a[e];null!=f.row&&null!=f.column?d.add(String(f.row+Je+f.column)):null!=f.row?b.add(String(f.row)):null!=f.column&&c.add(String(f.column))}var g=b.Il(this.sc),k=c.Il(this.uk),l=d.Il(this.bi);a=this.sc.Il(b);e=this.uk.Il(c);f=this.bi.Il(d);this.sc=b;this.uk=c;this.bi=d;b=new FN;b.sc=g;b.uk=k;b.bi=l;c=new FN;c.sc=a;c.uk=e;c.bi=f;return new LDa(b,c)});function LDa(a,b){this.eG=a;this.fG=b};function PN(a,b){if(a instanceof PN)this.rd=a.ZB();else{var c;if(c=Zh(a))t:{for(var d=c=0;d<a[J];d++){if(!Zh(a[d])||0<c&&a[d][J]!=c){c=!1;break t}for(var e=0;e<a[d][J];e++)if(!di(a[d][e])){c=!1;break t}0==c&&(c=a[d][J])}c=0!=c}if(c)this.rd=Yi(a);else if(a instanceof xk)this.rd=MDa(a[A],a[r]);else if(di(a)&&di(b)&&0<a&&0<b)this.rd=MDa(a,b);else throw m("Invalid argument(s) for Matrix contructor");}this.da=new xk(this.rd[0][J],this.rd[J])}
function QN(a,b,c){for(var d=0;d<a.Ub()[A];d++)for(var e=0;e<a.Ub()[r];e++)b[L](c,a.rd[d][e],d,e,a)}function RN(a,b){var c=new PN(a.Ub());QN(a,function(d,e,f){c.rd[e][f]=b[L](void 0,d,e,f,a)});return c}function MDa(a,b){for(var c=[],d=0;d<a;d++){c[d]=[];for(var e=0;e<b;e++)c[d][e]=0}return c}T=PN[K];T.add=function(a){if(!yk(this.da,a.Ub()))throw m("Matrix summation is only supported on arrays of equal size");return RN(this,function(b,c,d){return b+a.rd[c][d]})};
function NDa(a,b){if(a.da[A]!=b.Ub()[A])throw m("The given matrix has height "+b.da[A]+", but  needs to have height "+a.da[A]+Me);var c=new PN(a.da[A],a.da[r]+b.da[r]);QN(a,function(a,b,f){c.rd[b][f]=a});QN(b,function(a,b,f){c.rd[b][this.da[r]+f]=a},a);return c}Za(T,function(a,b){if(this.da[r]!=a.da[r]||this.da[A]!=a.da[A])return!1;for(var c=b||0,d=0;d<this.da[A];d++)for(var e=0;e<this.da[r];e++)if(!(h.abs(this.rd[d][e]-a.rd[d][e])<=(c||1E-6)))return!1;return!0});
T.bma=function(){if(this.da[r]!=this.da[A])throw m("An inverse can only be taken on a square matrix.");if(1==this.Ub()[r]){var a=SN(this,0,0);return 0==a?null:new PN([[1/a]])}for(var a=this.da[A],b=[],c=0;c<a;c++){b[c]=[];for(var d=0;d<a;d++)b[c][d]=c==d?1:0}a=new PN(b);b=ODa(NDa(this,a));return PDa(b,0,a.da[r]-1,a.da[A]-1)[cz](a)?PDa(b,a.da[r]):null};
function ODa(a){for(var b=new PN(a),c=0,d=0;d<b.da[A]&&!(c>=b.da[r]);d++){for(var e=d;0==b.rd[e][c];)if(e++,e==b.da[A]&&(e=d,c++,c==b.da[r]))return b;var f=a,g=d,k=f.rd[e];f.rd[e]=f.rd[g];f.rd[g]=k;e=b.rd[d][c];for(f=c;f<b.da[r];f++)b.rd[d][f]/=e;for(e=0;e<b.da[A];e++)if(e!=d)for(g=b.rd[e][c],f=c;f<b.da[r];f++)b.rd[e][f]-=g*b.rd[d][f];c++}return b}T.Ub=function(){return this.da};function TN(a){var b=new PN(a.da[r],a.da[A]);QN(a,function(a,d,e){b.rd[e][d]=a});return b}
function SN(a,b,c){return 0<=b&&b<a.da[A]&&0<=c&&c<a.da[r]?a.rd[b][c]:null}T.multiply=function(a){if(a instanceof PN){if(this.da[r]!=a.Ub()[A])throw m("Invalid matrices for multiplication. Second matrix should have the same number of rows as the first has columns.");return QDa(this,a)}if(di(a))return RDa(this,a);throw m("A matrix can only be multiplied by a number or another matrix.");};
T.w0=function(a){if(!yk(this.da,a.Ub()))throw m("Matrix subtraction is only supported on arrays of equal size.");return RN(this,function(b,c,d){return b-a.rd[c][d]})};T.ZB=function(){return this.rd};function PDa(a,b,c,d){var e=new PN((c?c:a.da[A]-1)-0+1,(d?d:a.da[r]-1)-b+1);QN(e,function(a,c,d){e.rd[c][d]=this.rd[0+c][b+d]},a);return e}
function QDa(a,b){var c=new PN(a.da[A],b.Ub()[r]);QN(c,function(a,e,f){for(var g=a=0;g<this.da[r];g++)a+=SN(this,e,g)*SN(b,g,f);if(!(0<=e&&e<c.da[A]&&0<=f&&f<c.da[r]))throw m("Index out of bounds when setting matrix value, ("+e+Je+f+") in size ("+c.da[A]+Je+c.da[r]+Ge);c.rd[e][f]=a},a);return c}function RDa(a,b){return RN(a,function(a){return a*b})};function UN(a,b,c,d,e,f){var g=null!=e?e:1;if(0==g)return{F:[],ge:!1,Kg:0};e=[];b=SDa(b,e,d,g,null!=f?f:!1,function(b){return a(b,c)[r]});return{F:e,ge:b.qs,Kg:b.Kg}}
function SDa(a,b,c,d,e,f){var g=f(a);if(g<=c)return a&&Zi(b,a[hc]()[pc](me)),{qs:!1,Kg:g};if(1<d){for(var k=0,l=0,g=1;g<a[J];g++){var n=a[Bb](g);if(n==ne||n==me){var q=f(a[ec](0,g));if(q<=c)if(l=q,k=g,n==me)break;else continue;break}}if(0<k)return b[C](a[ec](0,k)),b=SDa(a[ec](k+1),b,c,d-1,!1,f),{qs:b.qs,Kg:h.max(l,b.Kg)}}if(e&&(d=f(a[ec](0,1)+Ne),c<d)){for(g=h.min(a[J],5);1<=g;g--)if(d=f(a[ec](0,g)),d<=c)return b[C](a[ec](0,g)),{qs:!0,Kg:d};return{qs:!0,Kg:0}}d=f(Ne);if(c<d){for(g=2;1<=g;g--)if(a=
f("..."[ec](0,g)),a<=c)return b[C]("..."[ec](0,g)),{qs:!0,Kg:a};return{qs:!0,Kg:0}}for(g=a[J]-1;1<=g;g--)if(e=a[ec](0,g)+Ne,l=f(e),l<=c)return b[C](e),{qs:!0,Kg:l};b[C](Ne);return{qs:!0,Kg:d}}function TDa(a){var b={background:Lva,padding:TA,border:dna};null!=a[uc]&&(Ja(b,a[uc]+S),b.margin=a[uc]+S);null!=a.Va&&Ew(b,a.Va);return b};function VN(a){this.Yr=a;this.es=ea;this.ZC=0;a=new tt(15);Vs(this,a);kt(a,Fs,W(this.n1,this));this.Sc=a}X(VN,Us);function WN(a,b){var c=a.es;a.es=h.min(a.es,b);xj(a.es)?xj(c)||a.Sc[y]():a.Sc[Hq]()}VN[K].n1=function(){var a=hi();this.es-=a-this.ZC;this.ZC=a;0>=this.es&&(this.Yr(),this.es=ea,this.Sc[Hq]())};function XN(a,b){var c=b?UDa:VDa,d=c[J];this.Kk=[];for(var e=1+h[t]((a-1)/d),f=h[xb](a/e),g=[],k=0;k<d;k++)c[k][1]<f&&g[C](c[k][0]);for(k=0;k<a;k++){var c=g[b?k%f:h[t](k/e)],l=h.pow(b?0.7:0.85,b?h[t](k/f):k%e);this.Kk[k]=Gi(c,function(a){return~~(l*a+255*(1-l))})}}
var VDa=[[[67,69,157],6],[[67,116,224],0],[[83,168,251],1],[[26,135,99],7],[[95,150,84],4],[[185,194,70],9],[[241,202,58],2],[[228,147,7],3],[[231,113,27],8],[[211,54,45],5],[[135,27,71],10]],UDa=[[[67,69,157],6],[[83,168,251],8],[[95,150,84],10],[[241,202,58],2],[[231,113,27],5],[[135,27,71],4],[[67,116,224],0],[[26,135,99],1],[[185,194,70],9],[[228,147,7],7],[[211,54,45],3]];XN[K].Ub=function(){return this.Kk[J]};XN[K].Hd=function(a){return Wya+this.Kk[a]+Ge};
function YN(a,b){function c(a){a=a[hc](16);1==a[J]&&(a=Oe+a);return a}var d=a.Kk[b];return qe+(c(d[0])+c(d[1])+c(d[2]))[ge]()};function ZN(){this.$C=this.z2=null}function WDa(a){var b=new ZN;b.z2=a;return b}function XDa(a){var b=new ZN;b.$C=a;return b}function $N(a){if(null!=a.z2)return a.z2;throw m("AbstractRenderer not set");}ZN[K].Aw=function(){if(null!=this.$C)return this.$C;throw m("Scene not set");};function aO(a,b){this.rg=a;this.dc=null!=b&&Pj(b)||{}}function bO(a){return cO(new aO(VB),WB,a)}function dO(a,b){return cO(cO(new aO(rB),WB,b),coa,a)}function eO(a){a=eo(a);return new aO(a.rg,a.dc)}aO[K].o=function(){return eO(this.Hn())};Za(aO[K],function(a){if(!a||this.rg!=a.rg)return!1;var b=Ij(this.dc);return b[J]!==Ij(a.dc)[J]?!1:Ni(Gi(b,W(function(b){return this.dc[b]===a.dc[b]},this)),kj)});function cO(a,b,c){a.dc[b]=c;return a}ab(aO[K],function(){return this.rg});aO[K].Hn=function(){return Tm(this)};function YDa(a){ab(this,a);ra(this,null)}function fO(a,b){bi(a)&&(a=new YDa(a));this.Gp=a;this.Fp=[];b&&this.Fp[C](b)}function ZDa(){this.Wr=[];this.Xr=[];this.HQ=!1};function gO(){Uv(this,new FN);this.ci=this.Qm=this.af=null}gO[K].o=function(){var a=new gO;Uv(a,this[ux].o());a.af=this.af?this.af.o():null;a.Qm=this.Qm?this.Qm.o():null;a.ci=this.ci?this.ci.o():null;return a};Za(gO[K],function(a){return this[ux][cz](a[ux])&&(this.af?this.af[cz](a.af):!a.af)&&(this.Qm?this.Qm[cz](a.Qm):!a.Qm)&&(this.ci?this.ci[cz](a.ci):!a.ci)});function $Da(a){this.n=null;this.eu=[];this.iI=a}T=$Da[K];T.hI=function(a){if(this.n[cz](a))return{HQ:!1,Wr:[],Xr:[]};var b=this.eu;a=this.ql(a);return this.XI(a,b)};T.ql=function(a){if(null==this.iI)return[];var b=Hi(this.iI,function(b,d){Zi(b,d.ql(a));return b},[],this);this.eu=b;this.n=a.o();return b};T.XI=function(a,b){var c=this.Wu(a),d=this.Wu(b),e=c.Il(d),c=d.Il(c),d=new ZDa;d.Wr=this.Xu(e);d.Xr=this.Xu(c);return d};T.Wu=function(a){a=Gi(a,function(a){return Tm(a)});return new ck(a)};
T.Xu=function(a){a=a.La();return Gi(a,function(a){a=eo(a);a.Fp=Gi(a.Fp,function(a){return new aO(a.rg,a.dc)});return a})};function hO(a,b){this.Tma=new ck(a);this.Uma=new ck(b)};function iO(a){hO[L](this,a,[eF,fF])}X(iO,hO);iO[K].SQ=function(a,b,c){if(b==eF){if(!a[cz](c.af))return c.af=a,!0}else if(null!=c.af)return c.af=null,!0;return!1};iO[K].ql=function(a){return null!=a.af?[new fO(zg,a.af)]:[]};function aEa(){};function jO(a,b,c,d,e){this.WB=a;this.G=b;this.Wd=WDa(b);this.Pq=c;this.hu=null;this.Ax=bEa;this.ur=d;this.FQ=e;this.eo=null}X(jO,aEa);T=jO[K];Ep(T,function(a){this.hu={};var b=this.G;b[Wb]();this.eo=this.WB.yu(a,this.Pq);a=this.eo.Ub();a=b.wk(a[r],a[A]);for(var c=0;c<this.Ax[J];c++){var d=this.Ax[c],e=b.za();b[p](a,e);this.hu[d]=e}this.eo[Nq](this);this.z_(a)});T.MI=function(a){this.Ax=a};aw(T,function(a){this.YJ(a.Xr,!1);this.YJ(a.Wr,!0);this.eo[Nq](this)});
T.YJ=function(a,b){for(var c=0;c<a[J];c++)for(var d=a[c],e=d.Fp,f=0;f<e[J];f++)this.eo.Pm(e[f],d.Gp,b)};T.z_=function(a){var b=this.G;b.Fb(a,OD,Ys);b.Fb(a,gs,this.FQ(W(this[Pp],this,eF)));b.Fb(a,fs,this.FQ(W(this[Pp],this,fF)));b.Fb(a,Fr,this.FQ(W(this[Pp],this,Fr)))};kp(T,function(a,b){b[Zp]&&b[Zp]();var c=this.G.Er(b[Mq]);c!=ag&&(c=eO(c),this.ur(c,a))});T.eb=function(){return this.Wd};T.qe=function(a,b,c,d){null!=b?this.s2(a,b):this.Cn(a,c,d)};
T.Cn=function(a,b,c){this.G[p](this.hu[c],a);this.G.zn(a,b.Hn())};T.s2=function(a,b){cl(b)[Ty](a,b);var c=this.G.Er(b);this.G.zn(a,c)};T.Ff=function(a){this.G.Ff(a)};var bEa=[GC,LH,KH,kC,jC];function kO(a){this.hy=a;this.n=null}kO[K].vc=function(a){this.n=a.o()};kO[K].nv=function(a){var b=this.n;a[ux][cz](b[ux])||this[$](As,null);null===a.ci||a.ci[cz](b.ci)||this[$](As,null);var c=a.af,d=b.af,e=c;if(!c&&d||c&&!c[cz](d)){var b=UG,f;if(!d)f=c.dc.ROW_INDEX;else if(!c)b=TG,f=d.dc.ROW_INDEX,e=d;else if(d[H]()!==c[H]()||d.dc.ROW_INDEX!==c.dc.ROW_INDEX)f=c.dc.ROW_INDEX;c={row:f};e&&(e=e.dc.DATE,null!=e&&(c.date=e));this[$](b,c)}this.n=a.o()};dp(kO[K],function(a,b){hu(this.hy,a,b)});function lO(a,b){this.n=null;this.iI=b;this.Xa=new VN(a);Vs(this,this.Xa)}X(lO,Us);lO[K].vc=function(a){this.n=a};lO[K].eI=function(){return W(this[Pp],this)};kp(lO[K],function(a,b){if(null!=this.iI){var c=!1;Y(this.iI,function(d){d.Tma[Lc](a[H]())&&d.Uma[Lc](b)&&(d=d.SQ(a,b,this.n),c=c||d)},this);c&&WN(this.Xa,50)}});function mO(a,b,c,d,e){this.WB=a;qp(this,null);this.qI=null;a=this.WB.my();this.I$=new $Da(a);var f=e(W(this.Lh,this,!0));this.ur=new lO(f,a);Vs(this,this.ur);this.H$=this.WB.Hx(b,c,this.ur.eI(),e);this.D_=new kO(d)}X(mO,Us);Ep(mO[K],function(a,b){qp(this,b.o());this.ur.vc(this[dq]);this.D_.vc(this[dq]);var c=this.I$.ql(this[dq]);this.H$[Nq](a,c);this.qI=this[dq].o();this.D_[$](ws,null)});mO[K].Lh=function(a){var b=this.I$.hI(this[dq]);this.H$.refresh(b);this.qI=this[dq].o();a&&this.D_.nv(this[dq])};
Zv(mO[K],function(a){this.Lh(!0);this[dq][ux][Yx](a);this.Lh(!1)});Tw(mO[K],function(){if(null==this.qI.ci)return this.qI[ux][wz]();var a=this.qI.ci,b={};null!=a.dc.DATE&&(b.date=a.dc.DATE);null!=a.dc.ROW_INDEX&&(b.row=a.dc.ROW_INDEX);return[b]});function nO(a){pu[L](this,a)}X(nO,pu);nO[K].my=function(){return null};nO[K].Wg=function(){Ws(this.Bd);this.Bd=null};Zv(nO[K],function(a){this.Bd&&this.Bd[Yx](a)});Tw(nO[K],function(){return this.Bd?this.Bd[wz]():[]});function oO(a){pu[L](this,a);this.$n=null}X(oO,nO);T=oO[K];T.Hx=function(a,b,c,d){if(null==b)throw m("Internal error: missing overlayArea");a=$N(a);return new jO(this,a,b,c,d)};T.Ym=function(a,b,c){Ss.oc(this.lb);c=new jn([c||{},this.uj()||{}]);var d=On(this.lb,c),e=Pn(this.lb,c),d=new xk(d,e),e=pn(c,IE);this.wba(d,a,e);this.$n.Io(W(this.xn,this,b,c,d,a),a)};T.wba=function(a,b,c){null!=this.$n?this.$n[Pz](a,b):this.$n=new vK(this.lb,a,b,c)};
T.xn=function(a,b,c,d){var e=this.$n.eb(),f=this.$n.Av();a=this.ps(a,b,W(e.vf,e),c).Zh();Ws(this.Bd);e=e instanceof dK?WDa(e):XDa(e);this.Bd=new mO(this,e,f,this,d);b=new gO(nn(b,oI));this.Bd[Nq](a,b)};T.Wg=function(){oO.e.Wg[L](this);Ws(this.$n);this.$n=null};function pO(){this.Kk=null;this.KJ=new Uj}pO[K].Ly=function(a){this.KJ.$e(a)||this.KJ.set(a,this.KJ.Lc())};pO[K].Ev=function(a){null==this.Kk&&(this.Kk=new XN(this.KJ.Lc()));return YN(this.Kk,this.KJ.get(a))};function qO(a,b,c){this.tm=a;this.Ot=b.o();this.ll=c};function rO(){this.cs=new Uj;this.JQ=null;this.D$=!0}rO[K].Sba=function(){return[]};Ep(rO[K],function(a){if(null==this.JQ){this.JQ=new Uj;var b=this.Sba(a);Y(b,W(this.Tba,this,a,this.JQ))}var b=this.EJ(a),c=new ck(this.cs.hk());Y(b,function(b){var e=b.Ot.Hn();c[Ob](e);this.Tba(a,this.cs,b)},this);this.D$&&Bj(c,function(b){var c=this.cs.get(b);a.Ff(c.tm);this.cs[Ob](b)},this)});
rO[K].Tba=function(a,b,c){var d=c.Ot.Hn(),e=b.get(d,null);e&&e.V0&&a.Ff(e.V0);c.ll[0]===iC?(Sl(e.tm,!1),e.V0=c.tm,e.Qoa=c.ll,a.Cn(e.V0,e.Ot,e.Qoa)):(null===e||e.ll!==c.ll?(null!=e&&a.Ff(e.tm),a.Cn(c.tm,c.Ot,c.ll)):a.qe(c.tm,e.tm,c.Ot,c.ll),b.set(d,c))};function cEa(a,b){dEa(b);return 0==b[J]?null===a?0:a:Hi(b,function(a,b){return a+b},0)}function eEa(a,b){dEa(b);if(0==b[J])return a;var c=Fi(b,function(a){return null!=a});return 0==c[J]?null:cEa(a,c)/c[J]}function dEa(a){Y(a,function(){})};function sO(a){this.Vj=gj({},a);this.i2=gj({},a)}function tO(a,b,c){var d=a.Vj[J];for(a.Vj[b]=c;b<d;++b)a.i2[b]=uO(a,0==b?{}:a.i2[b-1],a.Vj[b])}function fEa(a){var b=Vh(a);return b!=$g&&b!=dg||b==$g&&ei(a.o)||$h(a)}function uO(a,b,c){if(fEa(c)||fEa(b)||Vh(c)==dg)return c;if(Vh(b)==$g){var d=Pj(b);Dj(c,function(a,c){d[c]=c in b&&null!=b[c]?uO(this,b[c],a):a},a)}else d=Yi(b),Dj(c,function(a,c){d[c]=uO(this,b[c],a)},a);return d}sO[K].compact=function(){return Ai(this.i2)};function vO(a,b){this.bc=a;this.Oh=b}X(vO,Us);var gEa=[];T=vO[K];T.Kd=null;T.ie=null;T.jw=function(a){this.bc=a};Yw(T,function(){return this.bc});ip(T,function(){return this.Oh});T.getParent=function(){return this.Kd};T.dF=function(){return!this.Zf()};T.$f=function(){return this.ie||gEa};T.ff=function(a){return this.$f()[a]||null};T.Zf=function(){return this.$f()[J]};Kw(T,function(){var a=this.$f();return Hi(a,function(a,c){return h.max(a,c[ez]())},-1)+1});
function hEa(a){var b=[];for(a=a[mx]();a;)b[C](a),a=a[mx]();return b}Pa(T,function(a){do a=a[mx]();while(a&&a!=this);return ka(a)});T.eJ=function(a,b){function c(d,e){!1!==a[L](b,d,e)&&Y(d.$f(),function(a){c(a,e+1)})}c(this,0)};T.find=function(a,b){var c=[];this.eJ(function(d){a[L](b,d)&&c[C](d)});return c};T.vR=function(a,b,c,d){for(var e=a[L](d,this),f=[],g=this.$f(),k=0;k<g[J];k++){var l=g[k].vR(a,b,c,d);f[C](l)}a=b[L](d,e,f);c&&c[L](d,this,a);return a};
T.ua=function(a){a.Kd=this;this.ie=this.ie||[];this.ie[C](a);Vs(this,a)};function wO(a,b,c){vO[L](this,c,a);this.t=b}X(wO,vO);T=wO[K];T.Pa=function(){return this.t};function iEa(a){return a.Aa(0)||a[Lp]()}T.Yq=function(a){return this.P_(this.t.Yq,a)};fb(T,function(a){return this.P_(this.t[I],a)});T.Aa=function(a){return this.P_(this.t.Aa,a)};T.P_=function(a,b){var c=this[Fz]();return null!=c?(c=[c],Zi(c,$i(arguments,1)),a[Mc](this.t,c)):null};function xO(){this.hp=[];this.Rw={}}X(xO,Us);T=xO[K];T.NB=function(a){var b=a[Fz]();null!=b&&(this.Rw[b]=a)};Kw(T,function(){return Hi(this.hp,function(a,b){return h.max(a,b[ez]())},-1)});T.eJ=function(a,b){for(var c=this.hp,d=0;d<c[J];d++)c[d].eJ(a,b)};T.find=function(a,b){for(var c=[],d=this.hp,e=0;e<d[J];e++)Zi(c,d[e].find(a,b));return c};T.vR=function(a,b,c,d){for(var e=this.hp,f=0;f<e[J];f++)e[f].vR(a,b,c,d)};function yO(a,b){xO[L](this);if(2>a.H())throw m("Data table should have at least 2 columns");if(a.D(0)!=rh)throw m("Column 0 must be of type string");if(a.D(1)!=rh)throw m("Column 1 must be of type string");for(var c=this.rq(b),d=c.x5,e=c.y5,c=c.z5,f={},g=[],k=0;k<a.M();k++){var l=a[I](k,0);if(l){var n=f[l];n?null==n[Fz]()&&n.jw(k):(f[l]=n=new wO(l,a,k),g[C](n));if(l=n[I](1)){var q=f[l];q||(f[l]=q=new wO(l,a,null),g[C](q));if(n[mx]()){if(e)throw m("More than one row with the same id ("+n[Lp]()+").");
}else if(n!=q&&!n[Lc](q))q.ua(n);else if(d)throw m("Data contains a cycle: "+jEa(Xi(q,hEa(q)))+Me);}}}for(d=0;d<g[J];d++){n=g[d];if(c&&Wh(n[Fz]()))throw m('Failed to find row with id "'+n[Lp]()+'".');n[mx]()?this.NB(n):(e=n,this.hp[C](e),Vs(this,e),this.NB(e))}}X(yO,xO);function jEa(a){return Gi(a,function(a){return a[Lp]()})[hc]()}yO[K].rq=function(a){var b=new sO(2);tO(b,0,{x5:!0,y5:!0,z5:!0});null!=a&&tO(b,1,a);return b[My]()};function zO(a,b,c){xO[L](this);a=a.hp;for(var d=0;d<a[J];d++){var e=kEa(this,a[d],b,c);this.hp[C](e);Vs(this,e);this.NB(e)}}X(zO,xO);function kEa(a,b,c,d){var e=c[L](d,b);b=b.$f();for(var f=0;f<b[J];f++){var g=kEa(a,b[f],c,d);a.NB(g);e.ua(g)}return e};function AO(){};function lEa(a){this.vsa=a||String}var mEa={number:function(a,b){return b.vsa(a[id])},identifier:function(a){return a[yd]},"+":function(){return ala},"-":function(){return Uz},"--":function(){return Le},"=":function(){return ela},"*":function(){return $ka},"(":function(){return Fe},")":function(){return Ge},",":function(){return Ke},"^":function(){return zr}};lEa[K].B=function(a){return Gi(a,function(a){return mEa[a.vo()](a,this)},this)[ie](O)};function BO(){}X(BO,AO);BO[K].vo=function(){return Le};function CO(){}X(CO,AO);CO[K].vo=function(){return Ie};Th[K].zl=function(){return this};Th[K].Kx=function(){return!1};Th[K].J$=function(){return!1};function DO(a){this.$g=a}X(DO,Th);DO[K].join=function(a){var b=[];Y(this.$g,function(c,d){0<d&&b[C](a);Zi(b,c.Qk())});return b};DO[K].zl=function(){if(1===this.$g[J])return this.$g[0];var a=[];Y(this.$g,function(b){a[C](b.zl())});this.$g=a;return this};function EO(a){this.$g=a}X(EO,DO);EO[K].Qk=function(){var a=[];Y(this.$g,function(b){var c=b.Kx();0<a[J]&&c?(a[C](new BO),b=(new FO(b)).zl()):0<a[J]&&a[C](new CO);a=Xi(a,b.Qk())});return a};function GO(){}X(GO,AO);GO[K].vo=function(){return Ge};function HO(a){eb(this,a)}X(HO,AO);HO[K].vo=function(){return Dva};function IO(){}X(IO,AO);IO[K].vo=function(){return Fe};function JO(){}X(JO,AO);JO[K].vo=function(){return Je};function KO(a,b){this.$g=b;eb(this,a)}X(KO,DO);KO[K].zl=function(){return this};KO[K].Qk=function(){var a=[new HO(this[yd]),new IO];Zi(a,this[ie](new JO),[new GO]);return a};function LO(){}X(LO,AO);LO[K].vo=function(){return af};function MO(a){this.$g=a}X(MO,DO);MO[K].Qk=function(){return this[ie](new LO)};function NO(){}X(NO,AO);NO[K].vo=function(){return He};function OO(){}X(OO,AO);OO[K].vo=function(){return fma};function nEa(a){this.$g=[a]}X(nEa,DO);function FO(a){this.$g=[a]}X(FO,nEa);FO[K].zl=function(){var a=this.$g[0].zl();if(a.Kx()){if(a instanceof FO)return a.$g[0];if(a instanceof PO)return new PO(-a[I]());throw m("Unknown type of negative.");}return new FO(a)};FO[K].Qk=function(){return Xi([new OO],this.$g[0].Qk())};FO[K].Kx=function(){return this.zl()instanceof FO};function QO(a){Fw(this,a)}X(QO,AO);QO[K].vo=function(){return Yg};function PO(a){Fw(this,a)}X(PO,Th);PO[K].Qk=function(){return[new QO(this[id])]};PO[K].Kx=function(){return 0>this[id]};fb(PO[K],function(){return this[id]});PO[K].J$=function(){return!0};function RO(a,b){this.$g=a;this.z$=null!=b?b:!1}X(RO,DO);RO[K].zl=function(){RO.e.zl[L](this);var a=0,b=[],c=1;Y(this.$g,function(d){d.Kx()&&(d=(new FO(d)).zl(),a++);d.J$()&&(c*=d[I](),d=null);d&&b[C](d)});1!==c&&Vi(b,0,0,new PO(c));var d=new RO(b,this.z$);a%2&&(d=new FO(d));return d};RO[K].Qk=function(){return this.z$?Xi[Mc](null,Gi(this.$g,function(a){return a.Qk()})):this[ie](new NO)};RO[K].Kx=function(){var a=0;Y(this.$g,function(b){b.Kx()&&a++});return!!(a%2)};function oEa(a,b){this.xa=[];this.pca=a;this.qca=b}function SO(a,b){if(0<a.xa[J]){var c=a.xa[a.xa[J]-1][0],d=b-c;if(d>a.pca&&(d=h[D](d/a.pca),1<d))for(var e=1;e<d;e++){var f=e/d*(b-c)+c;a.xa[C]([f,a.qca(f)])}}a.xa[C]([b,a.qca(b)])}oEa[K].jq=function(){return this.xa};function pEa(a,b,c,d){a=qEa(a,b,c,{range:d[By],Oaa:d.Oaa,jz:1});return null===a||ga(a.So)?null:{data:a[Z],So:a.So,$s:{offset:a.oI[0],gJ:a.oI[1]}}};function TO(a,b){return 0>b?a/h.pow(10,-b):a*h.pow(10,b)}function UO(a){a=h.abs(0.4342944819032518*h.log(a));return 1E-7>h.abs(a-h[D](a))}function VO(a){return h[t](0.4342944819032518*h.log(a))}function WO(a){return h[xb](0.4342944819032518*h.log(a))};function rEa(){return{transform:function(a){return a},inverse:function(a){return a}}}function sEa(a){var b=tEa(a);return{transform:function(a){var d=uEa(b,a,function(a){return a[Rp]});return null===d?a:d[Mq]+(a-d[Rp])*d.kD},inverse:function(a){var d=uEa(b,a,function(a){return a[Mq]});return null===d?a:0==d.kD?d[Rp]:d[Rp]+(a-d[Mq])/d.kD}}}
function tEa(a){for(var b=[],c=0,d=null,e=0;e<a[J];e++){var f=a[e],g=f.Zka,k=f[y],f=f.end,l=g/(f-k);null===d||d!=k?(d={source:k,target:k+c,kD:l},b[C](d)):(d=b[b[J]-1],d.kD=l);b[C]({source:f,target:k+c+g,kD:1});c+=g-(f-k);d=f}return b}function uEa(a,b,c){b=aj(a,{source:b,target:b,kD:0},function(a,b){var f=c(a),g=c(b);return f<g?-1:f>g?1:0});0>b&&(b=-b-2);return 0>b?null:a[b]}function vEa(){return{transform:function(a){return h.log(a)/h[kz]},inverse:function(a){return h.pow(10,a)}}}
function wEa(a){return{transform:function(b){return b>a?h.log(b/a)/h[kz]:b<-a?-h.log(-b/a)/h[kz]:0},inverse:function(b){return 0<b?h.pow(10,b)*a:0>b?-h.pow(10,-b)*a:0}}}var xEa={Sva:gH,pva:OF,Eva:BG};function XO(a,b,c){return(c=Hn(a,c,xEa))?c:pn(a,b)?OF:gH}function yEa(a,b,c){switch(a){case gH:return Si(c)?rEa():sEa(c);case OF:return vEa();case BG:return wEa(b);default:return rEa()}};function zEa(a,b){return h.abs(a-b)}function AEa(a,b,c){if(!a||!b)return!0;var d=c||zEa;return Rda(a,function(a,c){var g=b[c];return!Qh(b[c])||0.05>=d(a,g)})}function BEa(a,b,c){if(0==a.x||0==b.x)return{x:0,y:(0==a.x&&0==b.x?0:0==a.x?a.y:b.y)*c/6};c=c/3*h.min(h.abs(a.x),h.abs(b.x));b=(a.y/a.x+b.y/b.x)/2;return 0<a.x?{x:c,y:c*b}:{x:-c,y:-c*b}}function CEa(a,b,c){var d=a.hba(),e=b.hba();if(0==d||0==e)return new kK(0,0);d=h[ud](d/e);a=lK(a.o()[Fy](1/d),b.o()[Fy](d));a[Fy](c/6);return a}
function YO(a,b,c,d,e){c=c?BEa:CEa;for(var f=[],g=0;g<a[J];++g){var k,l;e?(k=DEa(a,g,1,d),l=DEa(a,g,-1,d)):(k=d?(g+1)%a[J]:g+1,l=d?(a[J]+g-1)%a[J]:g-1);null!=k&&null!=l&&null!=a[g]&&null!=a[l]&&null!=a[k]?(k=c(mK(a[g],a[l]),mK(a[k],a[g]),b),f[C]([mK(a[g],k),lK(a[g],k)])):null!=a[g]?f[C]([a[g].o(),a[g].o()]):f[C](null)}return f}function DEa(a,b,c,d){var e=b+c;for(d&&(e=(e+a[J])%a[J]);e!=b&&0<=e&&e<a[J];){if(null!=a[e])return e;e+=c;d&&(e=(e+a[J])%a[J])}return null}
function ZO(a,b,c){c=c||0;var d=Pi(b,function(b){return b[c]>a});return-1==d?b[J]-1:0==d?0:b[d][c]-a<a-b[d-1][c]?d:d-1}function EEa(a,b,c){var d;d=d||0;c=c||0;if(0<b[J]&&a<=Ai(b))return c=ZO(a,b,d),[c,b[c][d]];var e=b[J]-1-c,f=Ai(b)[d],g=b[e][d],k=f-g,l=h[t]((a-f)/k);a=a-f-l*k;e=Gi($i(b,e),function(a){return[a[d]-g]});a=ZO(a,e,0);return[b[J]-1+l*c+a,f+l*k+e[a][0]]}function $O(a,b,c){for(var d=[],e=0;e<a;e++)d[e]=b[L](c,e);return d}function FEa(a){return null!=a.max?a.max:a.min}
function GEa(a,b,c,d){Qh(c)||(c=0);Qh(d)||(d=a[J]);c=b-c;for(var e=0,f=0<=c?0:null,g=0,k=0,l=null,n=null;e<a[J];){var q=a[e].min,s=FEa(a[e])-q,g=g+q;if(g<=c)var f=e+1,u=h.min(c-g,s),k=g+u,n=q+u;if(g>b)return e>=d?{no:e,last:l,VJ:b-(g-q)}:null===f?null:{no:f,last:n,VJ:c-k};u=h.min(b-g,s);g+=u;l=q+u;e++}return{no:e,last:l,VJ:b-g}}function HEa(a,b,c){a=Gi(a,c||kj);cj(a);for(var d=c=0;d<a[J];d++){var e=a[J]-d,f=(a[d]-c)*e;if(f<=b)c=a[d],b-=f;else{c+=b/e;b=0;break}}return{Xpa:c,VJ:b}}
function aP(a,b,c,d){var e=GEa(a,b,c,d);if(!e)return null;b=e.VJ;c=$i(a,0,e.no);d=Hi(c,function(a,b){return h.max(a,b.Tc[J])},0);var f=Gi(c,FEa);0<f[J]&&(f[f[J]-1]=e.last);for(var g=0;g<d;g++){e=HEa(c,b,function(a){return a.Tc[g]||0});b=e.VJ;for(var k=0;k<f[J];k++)f[k]+=h.min(e.Xpa,a[k].Tc[g]||0);if(0==b)break}return f}function bP(a,b){var c=aP(a,b,void 0,void 0),d={};Y(a,function(a,b){var g=a.key;null!=d[g]||(d[g]=[]);b<c[J]&&d[g][C](c[b])});return d}
function IEa(a,b){for(var c=$i(arguments,1),d=[],e=0;e<c[J];e+=2){var f=h.min(c[e],a[J]),g=h.min(c[e+1],a[J]),f=$i(a,f,g);Zi(d,f)}return d}function JEa(a){if(0==a)return 0;a=h.abs(a);for(var b=0;16>b;++b){if(h.abs(a-h[D](a))<1E-7*a)return b;a*=10}return 16}function cP(a){var b=Jo;if(0>=a)return b[ec](0,b[Rd](Me));for(var b=b[ec](0,b[Rd](Me)+1),c=0;c<a;c++)b+=qe;return b}function KEa(a,b){return bi(a)?[a+Me+b]:Gi(a,function(a){return a+Me+b})}function dP(a,b,c){return 0>b||0>c?null:a[b][c]}
function LEa(a,b,c,d,e,f){var g=[],k=dP(c,d-1,e);k&&g[C]({iS:k,Kl:k.Kl+1,RJ:d-1,jS:null,SJ:null,kS:null});(k=dP(c,d,e-1))&&g[C]({iS:k,Kl:k.Kl+1,RJ:null,jS:null,SJ:e-1,kS:null});(c=dP(c,d-1,e-1))&&f(a[d-1],b[e-1])&&g[C]({iS:c,Kl:c.Kl,RJ:d-1,jS:e-1,SJ:e-1,kS:d-1});cj(g,function(a,b){return a.Kl-b.Kl});return 0<g[J]?g[0]:{iS:null,Kl:0,RJ:null,jS:null,SJ:null,kS:null}}
function eP(a,b,c){var d=c||function(a,b){return a==b};c=[];for(var e=0,f=a[J];e<=f;e++){c[e]=c[e]||[];for(var g=0,k=b[J];g<=k;g++)c[e][g]=LEa(a,b,c,e,g,d)}a={};b={};k=c[f][k];for(c=k.Kl;k;)null!=k.RJ&&(a[k.RJ]=k.jS),null!=k.SJ&&(b[k.SJ]=k.kS),k=k.iS;return{Kl:c,lV:a,mV:b}}
function MEa(a,b,c){function d(a,b,c){if(null==c)return 0;if(c===b[J]-1||null==a)return c;var d=f(b[c]);if(null==d)return c+1;b=f(b[c+1]);return null==b?c:h.abs(a-d)<=h.abs(a-b)?c:c+1}if(!a||!b||0===a[J]||0===b[J])return null;for(var e=[],f=c||kj,g=c=0,k,l;c<a[J]||g<b[J];)c<a[J]&&(k=f(a[c])),g<b[J]&&(l=f(b[g])),c<a[J]&&g<b[J]&&k==l?(e[C]({value:k,HC:c,IC:g}),c++,g++):c<a[J]&&(null==k||g==b[J]||k<l)?(e[C]({value:k,HC:c,IC:null}),c++):g<b[J]&&(null==l||c==a[J]||l<k)&&(e[C]({value:l,HC:null,IC:g}),g++);
var n=null,q=null;Y(e,function(c){null==c.HC?c.HC=d(c[id],a,n):n=c.HC;null==c.IC?c.IC=d(c[id],b,q):q=c.IC});return e}function fP(a,b){for(var c in a)if(!Ri(b,c))return!1;return!0}function NEa(a,b,c,d){for(var e=1,f=0;1E3>f;f++){var g=OEa(a,b,c,e),k=OEa(a,b,c,0),l=AEa(a,g,d),k=AEa(a,k,d);if(l&&k)break;a=g;e*=0.99}return a}function OEa(a,b,c,d){var e={};Dj(a,function(f,g){for(var k=f,l=0;l<b[J];l++)var n=(0,b[l])(a,g,d),k=c(k,n);e[g]=k});return e}
function gP(a,b,c){if(c)return hP(Fi(a,Xh),b);var d=-1;for(c=0;c<a[J];c++)if(null===a[c]){d=$i(a,d+1,c);d=hP(d,b);if(null!==d)return d;d=c}a=$i(a,d+1);return hP(a,b)}function hP(a,b){var c=aj(a,b,function(a,b){return bj(a,b.x)});if(0<=c)return a[c].y;var d=-(c+1);if(0==d||d==a[J])return null;c=a[d-1];d=a[d];return jK(new iK(c.x,c.y,d.x,d.y),(b-c.x)/(d.x-c.x)).y};function iP(){}T=iP[K];Ma(T,function(a,b,c){this.b=a;this.CE=b;this.Ap=null===c||0>c?this.P8():2<c?c-1:1;nw(this,[]);this.jc=ea;this.ic=-ea;ua(this,An(a,this.Ha(JE)));a.R(this.Ha(pBa),function(a,b){return b});this.eA=null});
T.$A=function(a,b){var c=XO(this.b,this.Ha(PF),this.Ha(PH));if(!Si(b)&&c!=gH)throw m("Non-linear scale with gaps is not supported.");for(var d=[],e=0;e<b[J];e++){var f;t:{var g=b[e];f=this.wZ(g.wia);var k=this.jI(g.wc),g=this.jI(g.xe);if(0<f)if(k+f<g)k+=f;else{f=null;break t}f={Zka:0,start:k,end:g}}f&&d[C](f)}this.eA=yEa(c,TO(1,VO(a)),d)};T.Ha=function(a){return KEa(this.CE,a)};T.P8=function(){return-1};
function PEa(a,b,c,d){d&&(a.fc(jP(a,b)),a.fc(jP(a,c)));a.jc==ea&&a.ic==-ea&&(a.jc=0,a.ic=1);a.jc==ea&&(a.jc=a.ic);a.ic==-ea&&(a.ic=a.jc);a.jc==a.ic&&(0==a.jc?(a.jc=-1,a.ic=1):0<a.jc?(a.jc/=2,a.ic*=2):(a.jc*=2,a.ic/=2));a.cH(a.jc,a.ic,d);a.N0(a.jc,a.ic,d);a.pH();a.Ap=h.max(1,a[wy][J]-1)}T.cH=function(){};T.Ro=function(a){nw(this,a)};function kP(a){a.le||a.pH();return a.le}function jP(a,b){var c=lP(a,b);if(null==c)return null;c=a.eA[Sz](c);return na(c)?c:null}
function lP(a,b){return null!=b?a.jI(b):null}T.fc=function(a){null!=a&&(this.jc=h.min(this.jc,a),this.ic=h.max(this.ic,a))};T.Po=function(a){return this.xE(this.eA.inverse(a))};T.K8=function(a,b){return a<b?-1:a>b?1:0};function mP(a){eb(this,a)}X(mP,Th);mP[K].Qk=function(){return[new HO(this[yd])]};ip(mP[K],function(){return this[yd]});function nP(){}X(nP,AO);nP[K].vo=function(){return zr};function oP(a){this.$g=a}X(oP,DO);oP[K].Qk=function(){return this[ie](new nP)};function QEa(a){this.zR=a.jz+1;this.Sa=a[By];this.Vna=a.Oaa;this.s0=this.F0=0;this.xa=[]}QEa[K].add=function(a,b){if(0<this.xa[J]){var c=a-this.xa[this.xa[J]-1].x;0<c&&(this.F0+=c)}this.s0+=b;this.xa[C]({x:a,y:b})};function REa(a){var b=a.Vna||null!=a.Sa&&null!=a.Sa.min&&xj(a.Sa.min)&&null!=a.Sa.max&&xj(a.Sa.max)&&(a.Sa.max-a.Sa.min)/100||void 0;null!=b&&xj(b)||(b=a.F0/(a.xa[J]-1));return b}function SEa(a,b){return Hi(a.xa,function(a,d){return a+h.pow(d.x,b)},0)}
function TEa(a,b){return Hi(a.xa,function(a,d){return a+h.pow(d.x,b)*d.y},0)}function UEa(a){for(var b=[],c=a.zR,d=0;d<c;d++){for(var e=ha(c+1),f=0;f<=c;f++)e[f]=f<c?SEa(a,d+f):TEa(a,d);b[C](e)}return new PN(b)}function VEa(a){var b=ODa(UEa(a));return Gi(fj(a.zR),function(a){return SN(b,a,this.zR)},a)}function WEa(a,b){var c=a.zR;return function(a){for(var e=0,f=0;f<c;f++)e+=b[f]*h.pow(a,f);return e}}
function XEa(a,b){var c=WEa(a,b),d=REa(a);if(null==d||ga(d)||!xj(d)||0===d)return null;var d=new oEa(d,c),e=a.xa;cj(e,function(a,b){return a.x>b.x?1:a.x<b.x?-1:0});var f=a.s0/e[J],g=a.Sa;null!=a.Sa&&null!=a.Sa.min&&xj(a.Sa.min)&&g.min<e[0].x&&SO(d,g.min);for(var k=0,l=0,n=0;n<e[J];n++){var q=e[n].x,s=e[n].y;SO(d,q);k+=h.pow(s-c(q),2);l+=h.pow(s-f,2)}c=1-k/l;null!=a.Sa&&null!=a.Sa.max&&xj(a.Sa.max)&&g.max>e[e[J]-1].x&&SO(d,g.max);return{data:d.jq(),So:c}}
function YEa(a){var b=VEa(a),c;c=[];for(var d=b[J]-1;0<=d;d--){var e=b[d];if(null!=e&&0<e){e=new PO(e);if(0<d){var f=new mP(lJ);1<d&&(f=new oP([f,new PO(d)]));e=new RO([e,f],!0)}c[C](e)}}c=new MO([new mP(Jh),new EO(c)]);a=XEa(a,b);return null!=a&&0!==a[Z][J]?{oI:b,data:a[Z],So:a.So,$s:c.zl()}:null};function qEa(a,b,c,d){var e=new QEa(d);Bj(Cj(a),function(a){var d=b(a);a=c(a);null!=d&&xj(d)&&null!=a&&xj(a)&&e.add(d,a)});return YEa(e)};var ZEa={LINEAR:MF,Tua:"exponential",Uva:"polynomial"},$Ea={linear:function(a,b,c,d){a=pEa(a,b,c,d);if(null===a)return null;b=new MO([new mP(Jh),new EO([new RO([new PO(a.$s.gJ),new mP(lJ)]),new PO(a.$s[by])])]);return{data:a[Z],So:a.So,$s:b.zl()}},exponential:function(a,b,c,d){for(var e=ea,f=0;f<a;f++){var g=b(f),k=c(f);null!=k&&k<e&&(e=k)}e=0<e?null:e-1;a=pEa(a,b,function(a){a=c(a);if(null==a)return null;null!=e&&(a-=e);return h.log(a)},d);if(null===a)return null;b=[];for(f=0;f<a[Z][J];f++)g=a[Z][f][0],
k=h.exp(a[Z][f][1]),null!=e&&(k+=e),b[C]([g,k]);f=new KO(Tta,[new EO([new RO([new PO(a.$s.gJ),new mP(lJ)]),new PO(a.$s[by])])]);null===e||(f=new EO([f,new PO(e)]));f=(new MO([new mP(Jh),f])).zl();return{data:b,So:a.So,$s:f}}};$Ea.polynomial=qEa;var aFa={NONE:R,Rva:cH,Vra:Bg,Zra:QH,wua:cD,Wra:cF},bFa={NONE:R,Rda:JF,Fra:BC,mwa:qI,Hra:KC,zua:jD,Zra:QH,xua:dD},cFa={Hra:KC,owa:dAa,vua:qra,POINTS:lH,Rda:JF,Fra:BC,NONE:R},dFa={Lua:YH,ova:jza,Hua:XH},eFa={Pda:lD,Vda:Dh,Bua:mD},fFa={Vva:oH,vva:rG,Sua:qE},gFa={NONE:R,RIGHT:zs,LEFT:Qg,TOP:NI,BOTTOM:WC,Qda:mF,lva:BF,sua:YC},hFa={NONE:R,TOP:NI,BOTTOM:WC,Qda:mF},pP={yS:Eh,xS:Jg},iFa={lwa:nI,Cua:pD,Qua:oE},qP={NONE:R,Qda:mF,Nva:XG},jFa={tua:nra,Awa:ZAa},kFa={$ua:aF,rva:Twa},lFa={NONE:R,kva:zF,Vda:Dh,Yra:bH,
Ewa:oBa},mFa={Vx:kg,Vda:Dh,Yra:bH},nFa={DEFAULT:ZD,Oua:gE},oFa={Mua:WD,Pda:lD,bsa:WH},pFa={Oda:eg,Pda:lD,bsa:WH,NONE:R},rP={NONE:R,Vra:Bg,Qva:Sxa,Gua:ID},qFa={mua:ara,lua:$qa},sP={nva:HF,Rda:JF},tP=[{color:"#3366CC",lighter:"#45AFE2"},{color:oA,lighter:"#FF3300"},{color:qA,lighter:"#FFCC00"},{color:dA,lighter:"#14C21D"},{color:"#990099",lighter:"#DF51FD"},{color:"#0099C6",lighter:"#15CBFF"},{color:"#DD4477",lighter:"#FF97D2"},{color:"#66AA00",lighter:"#97FB00"},{color:"#B82E2E",lighter:"#DB6651"},
{color:"#316395",lighter:"#518BC6"},{color:kA,lighter:"#BD6CBD"},{color:"#22AA99",lighter:"#35D7C2"},{color:"#AAAA11",lighter:"#E9E91F"},{color:"#6633CC",lighter:"#9877DD"},{color:"#E67300",lighter:"#FF8F20"},{color:"#8B0707",lighter:"#D20B0B"},{color:"#651067",lighter:"#B61DBA"},{color:"#329262",lighter:"#40BD7E"},{color:"#5574A6",lighter:"#6AA7C4"},{color:"#3B3EAC",lighter:"#6D70CD"},{color:"#B77322",lighter:"#DA9136"},{color:"#16D620",lighter:"#2DEA36"},{color:"#B91383",lighter:"#E81EA6"},{color:"#F4359E",
lighter:"#F558AE"},{color:"#9C5935",lighter:"#C07145"},{color:"#A9C413",lighter:"#D7EE53"},{color:"#2A778D",lighter:"#3EA7C6"},{color:"#668D1C",lighter:"#97D129"},{color:"#BEA413",lighter:"#E9CA1D"},{color:"#0C5922",lighter:"#149638"},{color:"#743411",lighter:"#C5571D"}],rFa={color:"#EEEEEE",lighter:"#FEFEFE"},sFa=[[5],[2,5],[2,5],[2,4,6,8],[2,4,6,8],[2,3,4,5,6,7],[2,3,4,5,6,7,8],[2,3,4,5,6,7,8,9]],tFa={titleTextStyle:{color:eA,italic:!0},gridlines:{baseline:eg,minorTextOpacity:0.7,minorGridlineOpacity:0.4,
newTimeline:!1,allowMinor:!0,minStrongLineDistance:40,minWeakLineDistance:40,minStrongToWeakLineDistance:5,minNotchDistance:10,minMajorTextDistance:10,minMinorTextDistance:5,unitThreshold:1.5}},uFa={histogram:{hAxis:{baselineColor:R,gridlines:{color:R}},bar:{groupWidth:QA}}},vFa={vAxis:tFa,hAxis:tFa,sizeAxis:{minSize:5,maxSize:30},fontName:nB,titleTextStyle:{color:re,bold:!0},bubble:{textStyle:{color:re}},candlestick:{hollowIsRising:!1},annotations:{datum:{textStyle:{color:XH},stemColor:mA},domain:{textStyle:{color:eA},
stemColor:mA}},majorAxisTextColor:eA,minorAxisTextColor:hA,backgroundColor:{fill:te,stroke:jA,strokeWidth:0},chartArea:{backgroundColor:{fill:R}},tooltip:{textStyle:{color:re}},baselineColor:fA,gridlineColor:uA,pieSliceBorderColor:ue,pieResidueSliceColor:uA,pieSliceTextStyle:{color:ue},areaOpacity:0.3,intervals:{style:KC,color:YH,lineWidth:1,fillOpacity:0.3,barWidth:0.25,shortBarWidth:0.1,boxWidth:0.25,dataOpacity:1,pointSize:6},actionsMenu:{textStyle:{color:re},disabledTextStyle:{color:"#c0c0c0"}},
legend:{newLegend:!1,textStyle:{color:eA},pagingTextStyle:{color:"#0011cc"},scrollArrows:{activeColor:"#0011cc",inactiveColor:uA}},aggregationTarget:eg,colorAxis:{legend:{textStyle:{color:re}}},bar:{groupWidth:100/1.618+we},histogram:{lastBucketPercentile:0,hideBucketItems:!1,bucketSize:-1,minBucketNumer:5,maxBucketNumber:50}};function uP(a,b){this.x=a||0;this.y=b||0}uP[K].o=function(){return new uP(this.x,this.y)};function vP(){this.sqa=GBa(W(this.sra,this));ua(this,W(this.tra,this))}Uh(vP);vP[K].tra=function(a,b){return this.sqa(a).Ee(b)};vP[K].sra=function(a){return new Go({pattern:a,valueType:vh})};function wP(a,b,c){Qa(this,a);this.X=b;Vw(this,c||null)}wP[K].qc=function(a){for(var b=this[Rc][pc](me),c=0,d=0,e=b[J];d<e;d++)c=h.max(c,a(b[d],this.X));return c};function xP(a,b,c,d,e,f,g){this.V=a;this.wc=b;this.xe=c;this.zv=e;this.Bja=f;this.nm=!0;this.xg=[];this.tY=d;this.Tl=null;this.$E=0;this.Kka=g||null;a=W(this.vma,this);b=Dygraph.pickDateTickGranularity(this.wc,this.xe,this.V,a);this.Mn=Dygraph.getDateAxis(this.wc,this.xe,b,a);this.Mn[0].v[ad]()>this.wc&&(this.Mn[je]({v:this.wc,label:O}),this.xg[je](new wP(O,{})));this.wc=h.min(this.Mn[0].v[ad](),this.wc);a=this.Mn[this.Mn[J]-1].v[ad]();a>this.xe[ad]()&&(this.xe=a);this.gX=this.V/(this.xe-this.wc);
this.kp=[];a=0;for(b=this.Mn[J];a<b;a++)this.kp[C](this[Fy](this.Mn[a].v))}
Ep(xP[K],function(a,b){if(this.nm){if(null==this.Tl)throw"startY must be set before calling draw().";var c=this.Mn[J]-1;if(0!==c){var d=W(a.Gk,a),e=this.xg[c],f=this.xg[c-1],g=e.qc(d),k=f.qc(d);g/2+this.kp[c]-this.Bja>this.V+this.tY&&(Vw(e,oE),k/2+this.kp[c-1]>this.kp[c]-g&&(Qa(f,O),f.X={Tb:O,bold:!1,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1}));c=this.xg[0];e=this.xg[1];f=c.qc(d);d=e.qc(d);this.kp[0]-f/2<this.tY-this.zv&&(Vw(c,nI),this.kp[0]+f>this.kp[1]-d/2&&(Qa(e,O),e.X={Tb:O,bold:!1,color:RC,Va:nB,
fontSize:13,Ic:!1,De:!1}))}d={};c=0;for(e=this.Mn[J];c<e;c++)if(!(this.wc>this.Mn[c].v)){for(var l=this.xg[c],f=a,g=this.kp[c],k=this.Tl+10,n=l.textAlign||pD,q=l.X,l=l[Rc][pc](me),s=[],u=0,w=l[J];u<w;u++)s[C](f.qt(l[u],g,k,15,n,nI,q)),k+=15;f=s;g=0;for(k=f[J];g<k;g++)b(f[g],null,d)}this.nm=!1}});Oa(xP[K],function(a){return(a-this.wc)*this.gX+this.tY});
xP[K].vma=function(a){function b(a,b){return e(c.Kka||a,b)}var c=this,d=!0,e=vP.Xb()[Kb];switch(a){case cra:return function(a,e){var k,l;c.$E=e;if(e<=Dygraph.THIRTY_SECONDLY)return l=b(kh,a),c.xg[C](new wP(l,{Tb:O,bold:!1,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.THIRTY_MINUTELY)return l=cB,0===a[Qc]()||d?(k=!0,l=NB):k=!1,d=!1,l=b(l,a),c.xg[C](new wP(l,{Tb:O,bold:k,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.SIX_HOURLY)return l=Dg,k=a[$b](),0!==a[Qc]()&&
(l+=rna),k=12===k||0===k||d,d=c.wc>a[ad]()?!0:!1,k&&(l+=Vka),l=b(l,a),c.xg[C](new wP(l,{Tb:O,bold:k,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.DAILY)return l=mf,0===a[lc]()||d?(l+=Uka,k=!0):k=!1,d=!1,l=b(l,a),c.xg[C](new wP(l,{Tb:O,bold:k,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.WEEKLY)return k=d,d=!1,l=b(uf,a),c.xg[C](new wP(l,{Tb:O,bold:k,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.BIANNUAL)return l=RB,k=0===a[Dd]()||d,
d=c.wc>a[ad]()?!0:!1,k&&(l+=Wka),l=b(l,a),c.xg[C](new wP(l,{Tb:O,bold:k,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;if(e<=Dygraph.CENTENNIAL)return l=b(rJ,a),c.xg[C](new wP(l,{Tb:O,bold:!1,color:RC,Va:nB,fontSize:13,Ic:!1,De:!1})),c.xg[J]-1+O;throw Gpa;};case Yxa:return 50}};function yP(a,b){var c=a[jy],c=$ea(Ek(b),c);b[p](c);a.Eca&&Wa(c,a[jy][yb]);var d,e=a.Fca;d=a.Dca;var f=a.Gca,g=a[Qy],k=new xk(c[Gd],c[Wd]),l=d[Zc]-e.x>=k[r]+g,n=d[Hc]-e.y>=k[A]+g,q=e.y-d.top>=k[A]+g,s=e.y+(f+k[A]/2)*(q||l?-1:1),e=nj(e.x+(f+k[r]/2)*(e.x-d[G]>=k[r]+g&&!l&&!n&&!q?-1:1)-k[r]/2,d[G]+g,d[Zc]-g-k[r]);d=nj(s-k[A]/2,d.top+g,d[Hc]-g-k[A]);d=new sk(e,d);pa(c[x],c[Gd]+1+S);Sa(c[x],c[Wd]+S);Ya(c[x],d.x+S);c[x].top=d.y+S;return c};function zP(a,b,c){var d=b.za(),e=a.outline,f=new YJ,g=new rl(e.la.top+0.5,e.la[Zc]+0.5,e.la[Hc]+0.5,e.la[G]+0.5),k=e.zj;f[Yy](g[G]+1,g[Hc]);f.Wf(g[G]+1,g[Hc]-1,1,1,180,270,!0);f.Z(g[G],g.top+1);f.Wf(g[G]+1,g.top+1,1,1,270,0,!0);if(null!=k&&k[0].y==e.la.top)for(var l=0;3>l;++l)f.Z(k[l].x+0.5,k[l].y+0.5);f.Z(g[Zc]-1,g.top);f.Wf(g[Zc]-1,g.top+1,1,1,0,90,!0);f.Z(g[Zc],g[Hc]-1);f.Wf(g[Zc]-1,g[Hc]-1,1,1,90,180,!0);if(null!=k&&k[0].y==e.la[Hc])for(l=0;3>l;++l)f.Z(k[l].x+0.5,k[l].y+0.5);f[vy]();e=[new Rm({fill:Hh,
stroke:tA,qa:1}),new Rm({fill:tA,qa:0,ae:0.6}),new Rm({fill:tA,qa:0,ae:0.4})];for(g=e[J]-1;0<=g;--g)k=b.na(f,e[g],d),b.em(k,g,g);a=a.qH;for(f=0;f<a[Ez][J];f++)switch(k=a[Ez][f],g=k.ih,e=b.za(),b[p](d,e),g[H]){case JF:g=g[Z];k=k[Z];k[Dz]&&b.rb(k[Dz].la[G],k[Dz].la.top,k[Dz].la[Zc]-k[Dz].la[G],k[Dz].la[Hc]-k[Dz].la.top,g[Dz].brush,e);for(l=0;l<k[cy][J];l++){var n=g[cy][l],q=k[cy][l];switch(n[H]){case Es:b.Pd(n[Z][cd],q.la[G],q.la.top,1,nI,nI,n[Z][x],e);break;case jI:b.rb(q.la[G],q.la.top,q.la[Zc]-q.la[G],
q.la[Hc]-q.la.top,n[Z].brush,e)}}null!=g.id&&(g=AN([qC,g.id]),b.zn(e,g));break;case VH:g=g[Z],k=k[Z],l=new YJ,l[Yy](k.line.x0,k.line.y0),l.Z(k.line.x1,k.line.y1),b.na(l,g.brush,e)}b[p](c,d);return d};function AP(){this.Hj=[];this.Mb=[];this.Jl=[]}AP[K].Zp=null;AP[K].Ag=null;AP[K].Fx=!0;var wFa=[2,2,6,6,0];T=AP[K];wa(T,function(){jb(this.Hj,0);jb(this.Mb,0);jb(this.Jl,0);delete this.Zp;delete this.Ag;delete this.Fx;return this});T.moveTo=function(a,b){0==Ai(this.Hj)?jb(this.Jl,this.Jl[J]-2):(this.Hj[C](0),this.Mb[C](1));this.Jl[C](a,b);this.Ag=this.Zp=[a,b];return this};
T.lineTo=function(a){var b=Ai(this.Hj);if(null==b)throw m("Path cannot start with lineTo");1!=b&&(this.Hj[C](1),this.Mb[C](0));for(b=0;b<arguments[J];b+=2){var c=arguments[b],d=arguments[b+1];this.Jl[C](c,d)}this.Mb[this.Mb[J]-1]+=b/2;this.Ag=[c,d];return this};
T.lda=function(a){var b=Ai(this.Hj);if(null==b)throw m("Path cannot start with curve");2!=b&&(this.Hj[C](2),this.Mb[C](0));for(b=0;b<arguments[J];b+=6){var c=arguments[b+4],d=arguments[b+5];this.Jl[C](arguments[b],arguments[b+1],arguments[b+2],arguments[b+3],c,d)}this.Mb[this.Mb[J]-1]+=b/6;this.Ag=[c,d];return this};mw(T,function(){var a=Ai(this.Hj);if(null==a)throw m("Path cannot start with close");4!=a&&(this.Hj[C](4),this.Mb[C](1),this.Ag=this.Zp);return this});
T.arc=function(a,b,c,d,e,f,g){a+=rj(e,c);b+=sj(e,d);g?this.Ag&&a==this.Ag[0]&&b==this.Ag[1]||this[Ry](a,b):this[Xx](a,b);return this.arcTo(c,d,e,f)};T.arcTo=function(a,b,c,d){var e=this.Ag[0]-rj(c,a)+rj(c+d,a),f=this.Ag[1]-sj(c,b)+sj(c+d,b);this.Hj[C](3);this.Mb[C](1);this.Jl[C](a,b,c,d,e,f);this.Fx=!1;this.Ag=[e,f];return this};
T.nsa=function(a,b,c,d){var e=this.Ag[0]-rj(c,a),f=this.Ag[1]-sj(c,b),g=qj(d);d=h[xb](h.abs(g)/h.PI*2);g/=d;c=qj(c);for(var k=0;k<d;k++){var l=h.cos(c),n=h.sin(c),q=4/3*h.sin(g/2)/(1+h.cos(g/2)),s=e+(l-q*n)*a,u=f+(n+q*l)*b;c+=g;l=h.cos(c);n=h.sin(c);this.lda(s,u,e+(l+q*n)*a,f+(n-q*l)*b,e+l*a,f+n*b)}return this};function BP(a,b){for(var c=a.Jl,d=0,e=0,f=a.Hj[J];e<f;e++){var g=a.Hj[e],k=wFa[g]*a.Mb[e];b(g,c[dd](d,d+k));d+=k}}
T.o=function(){var a=new this[rc];a.Hj=this.Hj[Ab]();a.Mb=this.Mb[Ab]();a.Jl=this.Jl[Ab]();a.Zp=this.Zp&&this.Zp[Ab]();a.Ag=this.Ag&&this.Ag[Ab]();a.Fx=this.Fx;return a};var CP={};CP[0]=AP[K][Xx];CP[1]=AP[K][Ry];CP[4]=AP[K][vy];CP[2]=AP[K].lda;CP[3]=AP[K].nsa;function xFa(a){if(a.Fx)return a.o();var b=new AP;BP(a,function(a,d){CP[a][Mc](b,d)});return b}
ex(AP[K],function(a){if(!this.Fx)throw m("Non-simple path");a[Sz](this.Jl,0,this.Jl,0,this.Jl[J]/2);this.Zp&&a[Sz](this.Zp,0,this.Zp,0,1);this.Ag&&this.Zp!=this.Ag&&a[Sz](this.Ag,0,this.Ag,0,1);return this});Ua(AP[K],function(){return 0==this.Hj[J]});function DP(a,b,c,d,e){VK[L](this,e);pa(this,a);Sa(this,b);this.Jn=c||null;this.RF=d||null}X(DP,VK);T=DP[K];T.Kf=null;T.Dt=0;T.qw=0;function EP(a){return a.Jn?new xk(a.Jn,a.RF):a.ik()}T.Ub=function(){return this.ik()};T.ik=function(){return this.yb?Ol(this.a()):di(this[r])&&di(this[A])?new xk(this[r],this[A]):null};function FP(a){var b=a.ik();return b?b[r]/EP(a)[r]:0}T.Ff=function(a){Zk(a.a())};T.Zd=function(a,b,c,d,e,f){return this.Nj(a,b,c,c,d,e,f)};
T.Pd=function(a,b,c,d,e,f,g,k,l,n,q){var s=k[ly]/2;c=g==WC?c+e-s:g==pD?c+e/2:c+s;return this.mi(a,b,c,b+d,c,f,k,l,n,q)};T.tc=function(){return new AP};function GP(a,b,c,d,e,f){if(6==arguments[J])this.setTransform(a,b,c,d,e,f);else{if(0!=arguments[J])throw m("Insufficient matrix parameters");this.Ej=this.Gj=1;this.Wi=this.Fj=this.Bj=this.Cj=0}}T=GP[K];T.o=function(){return new GP(this.Ej,this.Wi,this.Fj,this.Gj,this.Bj,this.Cj)};T.setTransform=function(a,b,c,d,e,f){if(!(di(a)&&di(b)&&di(c)&&di(d)&&di(e)&&di(f)))throw m("Invalid transform parameters");this.Ej=a;this.Wi=b;this.Fj=c;this.Gj=d;this.Bj=e;this.Cj=f;return this};
T.TP=function(a){this.Ej=a.Ej;this.Wi=a.Wi;this.Fj=a.Fj;this.Gj=a.Gj;this.Bj=a.Bj;this.Cj=a.Cj;return this};Oa(T,function(a,b){this.Ej*=a;this.Wi*=a;this.Fj*=b;this.Gj*=b;return this});db(T,function(a,b){this.Bj+=a*this.Ej+b*this.Fj;this.Cj+=a*this.Wi+b*this.Gj;return this});
T.rotate=function(a,b,c){var d=new GP,e=h.cos(a);a=h.sin(a);b=d.setTransform(e,a,-a,e,b-b*e+c*a,c-b*a-c*e);c=this.Ej;d=this.Fj;this.Ej=b.Ej*c+b.Wi*d;this.Fj=b.Fj*c+b.Gj*d;this.Bj+=b.Bj*c+b.Cj*d;c=this.Wi;d=this.Gj;this.Wi=b.Ej*c+b.Wi*d;this.Gj=b.Fj*c+b.Gj*d;this.Cj+=b.Bj*c+b.Cj*d;return this};Da(T,function(){return dxa+[this.Ej,this.Wi,this.Fj,this.Gj,this.Bj,this.Cj][ie]()+Ge});
ex(T,function(a,b,c,d,e){var f=b;for(b+=2*e;f<b;){e=a[f++];var g=a[f++];c[d++]=e*this.Ej+g*this.Fj+this.Bj;c[d++]=e*this.Wi+g*this.Gj+this.Cj}});Za(T,function(a){return this==a?!0:a?this.Ej==a.Ej&&this.Fj==a.Fj&&this.Bj==a.Bj&&this.Wi==a.Wi&&this.Gj==a.Gj&&this.Cj==a.Cj:!1});function HP(a,b){rt[L](this);this.q=a;this.jd=b;this[ct]=!1}X(HP,rt);T=HP[K];T.jd=null;T.q=null;T.dR=null;T.a=function(){return this.q};T.bea=function(){return this.jd};T.addEventListener=function(a,b,c,d){kt(this.q,a,b,c,d)};T.removeEventListener=function(a,b,c,d){ot(this.q,a,b,c,d)};T.w=function(){HP.e.w[L](this);qt(this.q)};function IP(a,b,c,d){HP[L](this,a,b);this.dd(c);this.pe(d)}X(IP,HP);T=IP[K];Ca(T,null);T.Qd=null;T.pe=function(a){Ca(this,a);this.jd.U1(this,a)};T.gb=function(){return this[fc]};T.dd=function(a){this.Qd=a;this.jd.B1(this,a)};T.Yaa=function(){return this.Qd};function JP(a,b,c,d){IP[L](this,a,b,c,d)}X(JP,IP);function KP(a,b){HP[L](this,a,b)}X(KP,HP);function LP(a,b){HP[L](this,a,b)}X(LP,HP);function MP(a,b,c,d){IP[L](this,a,b,c,d)}X(MP,IP);function NP(a,b,c,d){IP[L](this,a,b,c,d)}X(NP,IP);function OP(a,b,c,d){IP[L](this,a,b,c,d)}X(OP,IP);function PP(a){HP[L](this,null,a);this.ie=[]}X(PP,KP);wa(PP[K],function(){this.ie[J]&&(jb(this.ie,0),this.jd.Mg())});PP[K].Je=function(){};PP[K].appendChild=function(a){this.ie[C](a)};Ep(PP[K],function(){for(var a=0,b=this.ie[J];a<b;a++)this.jd.qe(this.ie[a])});function QP(a,b,c,d,e,f,g,k){IP[L](this,a,b,g,k);this.Vca=c;this.Wca=d;this.J1=e;this.K1=f;this.sk=new AP;RP(this);this.L1=new SP(null,b,this.sk,g,k)}X(QP,JP);
function RP(a){a.sk[Wb]();a.sk[Xx](a.Vca+rj(0,a.J1),a.Wca+sj(0,a.K1));a.sk.arcTo(a.J1,a.K1,0,360);a.sk[vy]()}QP[K].setCenter=function(a,b){this.Vca=a;this.Wca=b;RP(this);this.L1[Ip](this.sk)};Yv(QP[K],function(a,b){this.J1=a;this.K1=b;RP(this);this.L1[Ip](this.sk)});Ep(QP[K],function(a){this.L1[Nq](a)});function TP(a,b,c,d,e,f,g,k){IP[L](this,a,b,g,k);this.Ru=c;this.Su=d;this.ky=e;this.jy=f}X(TP,NP);bx(TP[K],function(a,b){this.Ru=a;this.Su=b;this.Yp&&this.jd.Mg()});TP[K].Yp=!1;
TP[K].Je=function(a,b){this.ky=a;this.jy=b;this.Yp&&this.jd.Mg()};Ep(TP[K],function(a){this.Yp=!0;a[dz]();a[Xx](this.Ru,this.Su);a[Ry](this.Ru,this.Su+this.jy);a[Ry](this.Ru+this.ky,this.Su+this.jy);a[Ry](this.Ru+this.ky,this.Su);a[Oy]()});function SP(a,b,c,d,e){IP[L](this,a,b,d,e);this[Ip](c)}X(SP,MP);SP[K].Yp=!1;ep(SP[K],function(a){this.sk=a.Fx?a:xFa(a);this.Yp&&this.jd.Mg()});
Ep(SP[K],function(a){this.Yp=!0;a[dz]();BP(this.sk,function(b,c){switch(b){case 0:a[Xx](c[0],c[1]);break;case 1:for(var d=0;d<c[J];d+=2)a[Ry](c[d],c[d+1]);break;case 2:for(d=0;d<c[J];d+=6)a.bezierCurveTo(c[d],c[d+1],c[d+2],c[d+3],c[d+4],c[d+5]);break;case 3:throw m("Canvas paths cannot contain arcs");case 4:a[Oy]()}})});
function UP(a,b,c,d,e,f,g,k,l,n){var q=Rk(kf,{style:nta});IP[L](this,q,a,l,n);this.zq=b;this.d8=c;this.nja=d;this.e8=e;this.oja=f;this.lja=g||Qg;this.mja=k;this.wO=Rk(kf,{style:mta});c=this.d8;k=this.e8;d=this.nja;e=this.oja;l=this.lja;f=this.mja;b=this.a()[x];g=FP(this.jd);n=this.jd;var s=n.ik();n=s?s[A]/EP(n)[A]:0;c==k?(b.lineHeight=pna,this.wO[x].verticalAlign=l==pD?xG:l==Qg?d<e?NI:WC:d<e?WC:NI,Vw(b,pD),k=f[ly]*g,b.top=h[D](h.min(d,e)*n)+S,Ya(b,h[D]((c-k/2)*g)+S),pa(b,h[D](k)+S),Sa(b,h.abs(d-e)*
n+S),Ja(b,0.6*f[ly]*n+hya)):(b.lineHeight=QA,this.wO[x].verticalAlign=NI,Vw(b,l),b.top=h[D](((d+e)/2-2*f[ly]/3)*n)+S,Ya(b,h[D](c*g)+S),pa(b,h[D](h.abs(k-c)*g)+S),Sa(b,eg),Ja(b,f[ly]*n+hya));Qw(b,f[Ed]?UC:MG);Xw(b,f.Ic?uF:MG);Ew(b,f.family);c=this.gb();Xa(b,c.Hd()||c.x7());yFa(this);a.a()[p](q);q[p](this.wO)}X(UP,OP);UP[K].$q=function(a){this.zq=a;yFa(this)};UP[K].pe=function(a){Ca(this,a);var b=this.a();b&&Xa(b[x],a.Hd()||a.x7())};UP[K].dd=function(){};Ep(UP[K],function(){});
function yFa(a){Wa(a.wO,a.d8==a.e8?Gi(a.zq[pc](O),function(a){return qi(a)})[ie]($e):qi(a.zq))}function VP(a,b,c,d,e,f,g){HP[L](this,a,b);this.Ru=c;this.Su=d;this.ky=e;this.jy=f;this.Tpa=g}X(VP,LP);T=VP[K];T.Yp=!1;bx(T,function(a,b){this.Ru=a;this.Su=b;this.Yp&&this.jd.Mg()});T.Je=function(a,b){this.ky=a;this.jy=b;this.Yp&&this.jd.Mg()};Ep(T,function(a){this.Qba?(this.ky&&this.jy&&a.drawImage(this.Qba,this.Ru,this.Su,this.ky,this.jy),this.Yp=!0):(a=new Image,cp(a,W(this.Vpa,this,a)),a.src=this.Tpa)});
T.Vpa=function(a){this.Qba=a;this.jd.Mg()};function zFa(){};function WP(a,b){this.qk=a;this.Vl=null==b?1:b}X(WP,zFa);WP[K].Hd=function(){return this.qk};function XP(a,b,c,d,e){DP[L](this,a,b,c,d,e)}X(XP,DP);T=XP[K];T.U1=function(){this.Mg()};T.B1=function(){this.Mg()};function AFa(a,b){var c=a[iz]();c[qy]();var d=b.dR?b.dR.o():new GP,e=d.Bj,f=d.Cj;(e||f)&&c[jz](e,f);(d=d.Wi)&&c[sy](h.asin(d))}T.h=function(){var a=this.P.h(Q,{style:bya});this.q=a;this.gc=this.P.h(kD);a[p](this.gc);this.eY=this.Kf=new PP(this);this.tja=0;YP(this)};T.getContext=function(){this.a()||this.h();this.gA||(this.gA=this.gc[iz](VA),this.gA[qy]());return this.gA};
T.Je=function(a,b){pa(this,a);Sa(this,b);YP(this);this.Mg()};T.ik=function(){var a=this[r],b=this[A],c=bi(a)&&-1!=a[ld](we),d=bi(b)&&-1!=b[ld](we);if(!this.yb&&(c||d))return null;var e,f;c&&(e=this.a()[fe],f=Pl(e),a=ma(a)*f[r]/100);d&&(e=e||this.a()[fe],f=f||Pl(e),b=ma(b)*f[A]/100);return new xk(a,b)};function YP(a){Nl(a.a(),a[r],a[A]);var b=a.ik();b&&(Nl(a.gc,b[r],b[A]),pa(a.gc,b[r]),Sa(a.gc,b[A]),a.gA=null)}
vw(T,function(){var a=this[iz]();a[Gy]();var b=this.ik();b[r]&&b[A]&&a.clearRect(0,0,b[r],b[A]);a[qy]()});wa(T,function(){this.reset();this.Kf[Wb]();for(var a=this.a();1<a[Xb][J];)a[Qd](a[yc])});T.Mg=function(){if(!this.Tta&&this.yb){this.reset();if(this.Jn){var a=this.ik();this[iz]()[Fy](a[r]/this.Jn,a[A]/this.RF)}(this.Dt||this.qw)&&this[iz]()[jz](-this.Dt,-this.qw);AFa(this,this.Kf);this.Kf[Nq](this.gA);this[iz]()[Gy]()}};
T.qe=function(a){if(!(a instanceof UP)){var b=this[iz]();AFa(this,a);if(a.gb&&a.Yaa){var c=a.gb();if(c)if(c instanceof WP)0!=c.Vl&&(b.globalAlpha=c.Vl,ew(b,c.Hd()),a[Nq](b),b[fc](),b.globalAlpha=1);else{var d=b.createLinearGradient(c.Mta(),c.Ota(),c.Nta(),c.Pta());d[Kz](0,c.x7());d[Kz](1,c.Lta());ew(b,d);a[Nq](b);b[fc]()}if(c=a.Qd)a[Nq](b),Hw(b,c.Hd()),a=c.qc(),bi(a)&&-1!=a[ld](S)&&(a=ma(a)/FP(this)),zw(b,a),b[Yb]()}else a[Nq](b);this[iz]()[Gy]()}};T.Mm=function(a,b){this[Rz](a,b)};
T.append=function(a,b){b=b||this.Kf;b[p](a);!this.yb||this.tja||b!=this.Kf&&b!=this.eY||this.qe(a)};T.Nj=function(a,b,c,d,e,f,g){a=new QP(null,this,a,b,c,d,e,f);this[Rz](a,g);return a};T.rb=function(a,b,c,d,e,f,g){a=new TP(null,this,a,b,c,d,e,f);this[Rz](a,g);return a};T.drawImage=function(a,b,c,d,e,f){a=new VP(null,this,a,b,c,d,e);this[Rz](a,f);return a};T.mi=function(a,b,c,d,e,f,g,k,l,n){a=new UP(this,a,b,c,d,e,f,g,k,l);this[Rz](a,n);return a};
T.na=function(a,b,c,d){a=new SP(null,this,a,b,c);this[Rz](a,d);return a};T.za=function(a){var b=new PP(this);a=a||this.Kf;if(a==this.Kf||a==this.eY)this.eY=b;this[Rz](b,a);return b};T.w=function(){this.gA=null;XP.e.w[L](this)};T.Bb=function(){var a=this.ik();XP.e.Bb[L](this);a||(YP(this),this[$](CH));this.Mg()};function ZP(a,b){this.V=a;this.qk=b}ZP[K].qc=function(){return this.V};ZP[K].Hd=function(){return this.qk};function $P(a,b){HP[L](this,a,b)}X($P,KP);wa($P[K],function(){Wk(this.a())});$P[K].Je=function(a,b){aQ(this.a(),{width:a,height:b})};function bQ(a,b,c,d){IP[L](this,a,b,c,d)}X(bQ,JP);bQ[K].setCenter=function(a,b){aQ(this.a(),{cx:a,cy:b})};Yv(bQ[K],function(a,b){aQ(this.a(),{rx:a,ry:b})});function cQ(a,b,c,d){IP[L](this,a,b,c,d)}X(cQ,NP);bx(cQ[K],function(a,b){aQ(this.a(),{x:a,y:b})});cQ[K].Je=function(a,b){aQ(this.a(),{width:a,height:b})};function dQ(a,b,c,d){IP[L](this,a,b,c,d)}X(dQ,MP);
ep(dQ[K],function(a){aQ(this.a(),{d:BFa(a)})});function eQ(a,b,c,d){IP[L](this,a,b,c,d)}X(eQ,OP);eQ[K].$q=function(a){ra(this.a()[Sb],a)};function fQ(a,b){HP[L](this,a,b)}X(fQ,LP);bx(fQ[K],function(a,b){aQ(this.a(),{x:a,y:b})});fQ[K].Je=function(a,b){aQ(this.a(),{width:a,height:b})};function gQ(a,b,c,d,e){DP[L](this,a,b,c,d,e);this.$o={};this.SU=mk&&!qk(526);this.Td=new sv(this)}var hQ;X(gQ,DP);T=gQ[K];T.Ra=function(a,b){var c=this.P.$b()[ny](gF,a);b&&aQ(c,b);return c};function aQ(a,b){for(var c in b)a[v](c,b[c])}T.Mm=function(a,b){(b||this.Kf).a()[p](a.a())};T.U1=function(a,b){var c=a.a();if(b instanceof WP)c[v](zE,b.Hd()),c[v](AE,b.Vl);else c[v](zE,R)};
T.B1=function(a,b){var c=a.a();if(b){c[v](uI,b.Hd());var d=b.qc();bi(d)&&-1!=d[ld](S)?c[v](wI,ma(d)/FP(this)):c[v](wI,d)}else c[v](uI,R)};T.h=function(){var a=this.Ra(xI,{width:this[r],height:this[A],overflow:Ig}),b=this.Ra(Cg);this.zV=this.Ra($D);this.Kf=new $P(b,this);a[p](this.zV);a[p](b);this.q=a;if(this.Jn||this.Dt||this.qw)this.a()[v](dya,R),this.SU?this.JL():this.a()[v](dJ,this.Dt+ne+this.qw+ne+(this.Jn?this.Jn+ne+this.RF:O))};
T.JL=function(){if(this.yb&&(this.Jn||this.Dt||!this.qw)){var a=this.ik();if(0==a[r])hb(this.a()[x],Ig);else{hb(this.a()[x],O);var b=-this.Dt,c=-this.qw,d=a[r]/this.Jn,a=a[A]/this.RF;this.Kf.a()[v](xh,aza+d+ne+a+dma+b+ne+c+Ge)}}};T.Je=function(a,b){Nl(this.a(),a,b)};
T.ik=function(){if(!lk)return this.yb?Ol(this.a()):gQ.e.ik[L](this);var a=this[r],b=this[A],c=bi(a)&&-1!=a[ld](we),d=bi(b)&&-1!=b[ld](we);if(!this.yb&&(c||d))return null;var e,f;c&&(e=this.a()[fe],f=Pl(e),a=ma(a)*f[r]/100);d&&(e=e||this.a()[fe],f=f||Pl(e),b=ma(b)*f[A]/100);return new xk(a,b)};wa(T,function(){this.Kf[Wb]();Wk(this.zV);this.$o={}});T.Nj=function(a,b,c,d,e,f,g){a=this.Ra(kE,{cx:a,cy:b,rx:c,ry:d});e=new bQ(a,this,e,f);this.Mm(e,g);return e};
T.rb=function(a,b,c,d,e,f,g){a=this.Ra(vH,{x:a,y:b,width:c,height:d});e=new cQ(a,this,e,f);this.Mm(e,g);return e};T.drawImage=function(a,b,c,d,e,f){a=this.Ra(Fva,{x:a,y:b,width:c,height:d,"image-rendering":Cxa,preserveAspectRatio:R});a.setAttributeNS(Cva,Kg,e);e=new fQ(a,this);this.Mm(e,f);return e};
T.mi=function(a,b,c,d,e,f,g,k,l,n){var q=h[D](tj(b,c,d,e));d-=b;e-=c;e=h[D](h[ud](d*d+e*e));var s=g[ly];d={"font-family":g.family,"font-size":s};var u=h[D](0.85*s),s=h[D](c-s/2+u),u=b;f==pD?(u+=h[D](e/2),d[DI]=xG):f==zs&&(u+=e,d[DI]=oE);d.x=u;d.y=s;g[Ed]&&(d[EE]=UC);g.Ic&&(d[DE]=uF);0!=q&&ex(d,IH+q+ne+b+ne+c+Ge);b=this.Ra(Es,d);b[p](this.P.$b()[Cb](a));null==k&&lk&&fk&&(a=RC,l instanceof WP&&(a=l.Hd()),k=new ZP(1,a));l=new eQ(b,this,k,l);this.Mm(l,n);return l};
T.na=function(a,b,c,d){a=this.Ra(aH,{d:BFa(a)});b=new dQ(a,this,b,c);this.Mm(b,d);return b};function BFa(a){var b=[];BP(a,function(a,d){switch(a){case 0:b[C](sf);ha[K][C][Mc](b,d);break;case 1:b[C](rf);ha[K][C][Mc](b,d);break;case 2:b[C](qB);ha[K][C][Mc](b,d);break;case 3:var e=d[3];b[C](df,d[0],d[1],0,180<h.abs(e)?1:0,0<e?1:0,d[4],d[5]);break;case 4:b[C](Vf)}});return b[ie](ne)}T.za=function(a){var b=this.Ra(Cg);(a||this.Kf).a()[p](b);return new $P(b,this)};T.Gk=function(){};
T.Bb=function(){var a=this.ik();gQ.e.Bb[L](this);a||this[$](CH);if(this.SU){var a=this[r],b=this[A];typeof a==rh&&-1!=a[ld](we)&&typeof b==rh&&-1!=b[ld](we)&&this.Td.l(CFa(),Fs,this.JL);this.JL()}};T.ve=function(){gQ.e.ve[L](this);this.SU&&this.Td.uc(CFa(),Fs,this.JL)};T.w=function(){delete this.$o;delete this.zV;delete this.Kf;gQ.e.w[L](this)};function CFa(){hQ||(hQ=new tt(400),hQ[y]());return hQ};function iQ(){return this.q=this.jd.P.a(this.bc)||this.q}function jQ(a,b){this.bc=a.id;HP[L](this,a,b)}X(jQ,KP);jQ[K].a=iQ;wa(jQ[K],function(){Wk(this.a())});jQ[K].Je=function(a,b){var c=this.a(),d=c[x];pa(d,kQ(a)+S);Sa(d,kQ(b)+S);ax(c,kQ(a)+ne+kQ(b));this.jd.Kf!=this&&kw(c,OA)};function lQ(a,b,c,d,e,f,g,k){this.bc=a.id;IP[L](this,a,b,g,k);this.WA=c;this.XA=d;this.ji=e;this.ki=f}X(lQ,JP);lQ[K].a=iQ;lQ[K].setCenter=function(a,b){this.WA=a;this.XA=b;mQ(this.a(),a-this.ji,b-this.ki,2*this.ji,2*this.ki)};
Yv(lQ[K],function(a,b){this.ji=a;this.ki=b;mQ(this.a(),this.WA-a,this.XA-b,2*a,2*b)});function nQ(a,b,c,d){this.bc=a.id;IP[L](this,a,b,c,d)}X(nQ,NP);nQ[K].a=iQ;bx(nQ[K],function(a,b){var c=this.a()[x];Ya(c,oQ(a));c.top=oQ(b)});nQ[K].Je=function(a,b){var c=this.a()[x];pa(c,kQ(a)+S);Sa(c,kQ(b)+S)};function pQ(a,b,c,d){this.bc=a.id;IP[L](this,a,b,c,d)}X(pQ,MP);pQ[K].a=iQ;ep(pQ[K],function(a){qQ(this.a(),aH,DFa(a))});function rQ(a,b,c,d){this.bc=a.id;IP[L](this,a,b,c,d)}X(rQ,OP);rQ[K].a=iQ;
rQ[K].$q=function(a){qQ(this.a()[Xb][1],rh,a)};function sQ(a,b){this.bc=a.id;HP[L](this,a,b)}X(sQ,LP);sQ[K].a=iQ;bx(sQ[K],function(a,b){var c=this.a()[x];Ya(c,oQ(a));c.top=oQ(b)});sQ[K].Je=function(a,b){var c=this.a()[x];pa(c,oQ(a));Sa(c,oQ(b))};function tQ(a,b,c,d,e){DP[L](this,a,b,c,d,e);this.Td=new sv(this)}X(tQ,DP);var uQ=fa[be]&&8<=fa[be];function EFa(a){return bi(a)&&mda(a)?a:ma(a[hc]())+S}function vQ(a){return h[D](100*(ma(a[hc]())-0.5))}function oQ(a){return vQ(a)+S}function kQ(a){return h[D](100*ma(a[hc]()))}function qQ(a,b,c){uQ?a[b]=c:a[v](b,c)}function wQ(a,b){var c=a.P[Qb](Bua+b);c.id=Eua+zda++;return c}function xQ(a){uQ&&a.yb&&Wa(a.a(),a.a()[hd])}tQ[K].Mm=function(a,b){(b||this.Kf).a()[p](a.a());xQ(this)};
tQ[K].U1=function(a,b){var c=a.a();Wv(c,O);for(var d=0;d<c[Xb][J];d++){var e=c[Xb][d];e[Nc]==zE&&c[Qd](e)}b instanceof WP?b.Hd()==yh?Rv(c,!1):1!=b.Vl?(Rv(c,!0),d=wQ(this,zE),mb(d,h[D](100*b.Vl)+we),Xa(d,b.Hd()),c[p](d)):(Rv(c,!0),Wv(c,b.Hd())):Rv(c,!1);xQ(this)};tQ[K].B1=function(a,b){var c=a.a();if(b){Vv(c,!0);var d=b.qc(),d=bi(d)&&-1==d[ld](S)?ma(d):d*FP(this),e=c[cc](uI)[0];1>d?(e=e||wQ(this,uI),mb(e,d),Sv(e,TA),Xa(e,b.Hd()),c[p](e)):(e&&c[Qd](e),Iw(c,b.Hd()),dw(c,d+S))}else Vv(c,!1);xQ(this)};
function mQ(a,b,c,d,e){var f=a[x];Ea(f,cg);Ya(f,oQ(b));f.top=oQ(c);pa(f,kQ(d)+S);Sa(f,kQ(e)+S);a[Nc]==aI&&ax(a,kQ(d)+ne+kQ(e))}function yQ(a,b){var c=wQ(a,b),d=EP(a);mQ(c,0,0,d[r],d[A]);return c}try{eval("document.namespaces")}catch(FFa){}T=tQ[K];
T.h=function(){var a=this.P.$b();a.namespaces.g_vml_||(uQ?a.namespaces.add(Aua,eBa,Mla):a.namespaces.add(Aua,eBa),$a(a.createStyleSheet(),Cua));var a=this[r],b=this[A],c=this.P.h(Q,{style:Jxa+EFa(a)+wna+EFa(b)});this.q=c;var d=wQ(this,UE),e=d[x];Ea(e,cg);Ya(e,e.top=0);pa(e,this[r]);Sa(e,this[A]);ax(d,this.Jn?kQ(this.Jn)+ne+kQ(this.RF):kQ(a)+ne+kQ(b));kw(d,Qh(this.Dt)?kQ(this.Dt)+ne+kQ(this.qw):OA);c[p](d);this.Kf=new jQ(d,this);kt(c,CH,W(this.cU,this))};
T.cU=function(){var a=Ol(this.a()),b=this.Kf.a()[x];if(a[r])pa(b,a[r]+S),Sa(b,a[A]+S);else{for(a=this.a();a&&a[$d]&&a[$d][Sc]!=R;)a=a[fe];a&&a[$d]&&this.Td.l(a,gya,this.cU)}this[$](CH)};T.Je=function(a,b){Nl(this.a(),a,b)};T.ik=function(){var a=this.a();return new xk(a[x].pixelWidth||a[zb]||1,a[x].pixelHeight||a[Uc]||1)};wa(T,function(){this.Kf[Wb]()});T.Nj=function(a,b,c,d,e,f,g){var k=wQ(this,Hxa);mQ(k,a-c,b-d,2*c,2*d);a=new lQ(k,this,a,b,c,d,e,f);this.Mm(a,g);return a};
T.rb=function(a,b,c,d,e,f,g){var k=wQ(this,vH);mQ(k,a,b,c,d);a=new nQ(k,this,e,f);this.Mm(a,g);return a};T.drawImage=function(a,b,c,d,e,f){var g=wQ(this,Fva);mQ(g,a,b,c,d);qQ(g,kI,e);a=new sQ(g,this);this.Mm(a,f);return a};
T.mi=function(a,b,c,d,e,f,g,k,l,n){var q=yQ(this,aI),s=wQ(this,aH);b=sf+vQ(b)+Je+vQ(c)+rf+vQ(d)+Je+vQ(e)+mf;qQ(s,Ch,b);qQ(s,FI,zh);b=wQ(this,tAa);b[v](ah,zh);c=b[x];Ja(c,g[ly]*FP(this));Ew(c,g.family);null!=f&&(c[XI]=f);g[Ed]&&Qw(c,UC);g.Ic&&Xw(c,uF);qQ(b,rh,a);q[p](s);q[p](b);a=new rQ(q,this,k,l);this.Mm(a,n);return a};T.na=function(a,b,c,d){var e=yQ(this,aI);qQ(e,aH,DFa(a));a=new pQ(e,this,b,c);this.Mm(a,d);return a};
function DFa(a){var b=[];BP(a,function(a,d){switch(a){case 0:b[C](Tg);ha[K][C][Mc](b,Gi(d,kQ));break;case 1:b[C](yF);ha[K][C][Mc](b,Gi(d,kQ));break;case 2:b[C](lg);ha[K][C][Mc](b,Gi(d,kQ));break;case 4:b[C](lJ);break;case 3:var e=d[2]+d[3],f=kQ(d[4]-rj(e,d[0])),e=kQ(d[5]-sj(e,d[1])),g=kQ(d[0]),k=kQ(d[1]),l=h[D](-65536*d[2]),n=h[D](-65536*d[3]);b[C](tqa,f,e,g,k,l,n)}});return b[ie](ne)}T.za=function(a){var b=yQ(this,UE);(a||this.Kf).a()[p](b);return new jQ(b,this)};T.Gk=function(){return 0};
T.Bb=function(){tQ.e.Bb[L](this);this.cU();xQ(this)};T.w=function(){this.Kf=null;tQ.e.w[L](this)};function zQ(a,b,c,d,e){VK[L](this,d);this.ye=new Ct(e||Xma);this.xG=O;this.wd=[];this.vz=[];this.aO=[];this.It=[];this.Uia=[];this.Xia=[];this.iH=[];this.wX={};this.Via={};this.bO={};this.Wia={};this.Du(a);this.Je(b,c);this.Ca=AQ(this)?0:ea}X(zQ,VK);T=zQ[K];T.p5=2048;T.ija=0;T.jja=0;T.mb=-ea;T.Bf=null;T.uW=null;T.h=function(){var a=this.Ub();this.q=this.ea().h(Vr,{src:BQ(this),"class":hqa,width:a[0],height:a[1]})};T.mf=function(a){a.src=BQ(this);this.q=a};
function BQ(a){var b;a.xG!=O?b=CQ(a,a.xG):(b=CQ(a,jE))||(b=CQ(a,kh));b||a[$](new GFa(a.ye[hc]()));return a.ye}function HFa(a,b){var c=[];Y(b,function(a){a.area=a.area||jra;a.Gp=a.Gp||kh;c[C]([a.area,a.Gp,a[E]][ie]())});c=c[ie](Ps);a.Oc(Zra,c)}T.Du=function(a){this.ye.Oc(DD,a)};T.Vb=function(){return Lt(this.ye,DD)};T.Je=function(a,b){var c=[a||300,b||150][ie](lJ);this.ye.Oc(CD,c)};T.Ub=function(){return Lt(this.ye,CD)[pc](lJ)};T.eN=function(a){this.Ca=a};T.dN=function(a){this.mb=a};
function DQ(a,b){a.It=b;a.ye.Oc($ra,a.It[ie](Ps))}function EQ(a){a=a.Vb();return a==bD||a==PC||a==QC||a==fD||a==gD}function AQ(a){a=a.Vb();return a==$G||a==Mxa||a==Rxa}function IFa(a){a=a.Vb();return a==bD||a==PC||a==QC}function JFa(a){a=a.Vb();return a==bD||a==QC||a==gD}T.Oc=function(a,b){this.ye.Oc(a,b)};T.s1=function(a){this.ye.s1(a)};T.setTitle=function(a){this.Bf=a;this.ye.Oc(bsa,this.Bf[vb](/\n/g,Ps))};function FQ(a,b){a.iH[C](b);a.ye.Oc(dsa,a.iH[ie](Je));return a.iH[J]-1}
function GQ(a,b,c){a.wX[b]=c;b=KFa(a,a.wX,tna,Ps);a.ye.Oc(csa,b)}function HQ(a,b,c,d){var e;e=ea;for(var f=0,g=b[J];f<g;++f){var k=b[f];null!=k&&k<e&&(e=k)}e<a.Ca&&(a.Ca=e);e=-ea;f=0;for(g=b[J];f<g;++f)k=b[f],null!=k&&k>e&&(e=k);e>a.mb&&(a.mb=e);if(Qh(d)){if(a.aO[J]<a.wd[J])throw m("Cannot start adding legends text after first element.");a.aO[C](d);a.ye.Oc(Xra,a.aO[ie](Ps))}a.wd[C](b);a.vz[C](c);a.ye.Oc(zD,a.vz[ie](Je))}T.getData=function(a){return Qh(a)?this.wd[a]:this.wd};
function CQ(a,b){for(var c=[],d=0,e=a.wd[J];d<e;++d){var f=c,g=d,k;k=a;for(var l=a.wd[d],n=a.Ca,q=a.mb,s=b,u=[],w=0,z=l[J];w<z;++w)u[C](LFa(l[w],n,q,s));k=u[ie](k.xG==zI?Je:O);f[g]=k}c=c[ie](b==zI?Ps:Je);c=null==a.uW?yda(b,Xe,c):yda(b,a.uW,Xe,c);a.ye.Oc(Wra,c);return a.ye[hc]()[J]<a.p5}function KFa(a,b,c,d){var e=[],f=0;for(a=a.iH[J];f<a;++f)b[f]&&e[C](f+c+b[f][ie](d));return e[ie](Ps)}var MFa=h.pow(64,2)-1;
function LFa(a,b,c,d){var e=d==jE;if(null===a||!Qh(a)||ga(a)||a<b||a>c)return e?Npa:iC;if(d==zI)return String(a);d=0.5;c>b&&(d=(a-b)/(c-b));if(e)return"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-."[Bb](h[t](d*MFa/64))+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-."[Bb](h[t](d*MFa%64));a=h[D](61*d);return"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"[Bb](a)}
zQ[K].w=function(){zQ.e.w[L](this);delete this.It;delete this.Uia;delete this.Xia;delete this.ija;delete this.jja;delete this.vz;delete this.aO;delete this.wd;this.ye=null;delete this.Ca;delete this.mb;this.Bf=null;delete this.iH;delete this.wX;delete this.Via;delete this.bO;delete this.Wia};function GFa(a){Xs[L](this,cBa);this.uri=a}X(GFa,Xs);function IQ(a){hO[L](this,a,[eF,fF])}X(IQ,hO);IQ[K].SQ=function(a,b,c){if(b==eF){if(!a[cz](c.Qm))return c.Qm=a,!0}else if(null!=c.Qm)return c.Qm=null,!0;return!1};IQ[K].ql=function(a){return null!=a.Qm?[new fO(Hs,a.af)]:[]};function JQ(a,b,c,d,e){this.WB=a;this.G=b.Aw();this.Wd=b;this.hu=null;this.Ax=NFa;this.ur=d;this.FQ=e;this.eo=null}X(JQ,aEa);T=JQ[K];Ep(T,function(a){this.hu={};this.G[Wb]();this.eo=this.WB.yu(a,null);this.eo.Ub();for(a=0;a<this.Ax[J];a++)this.hu[this.Ax[a]]=new BK.Gg.h4;this.eo[Nq](this)});function OFa(a){var b=a.Wd.Aw();Y(Hj(a.hu),function(a){b.Rs(a)},a)}T.MI=function(a){this.Ax=a};aw(T,function(a){this.YJ(a.Xr,!1);this.YJ(a.Wr,!0);this.eo[Nq](this)});
T.YJ=function(a,b){for(var c=0;c<a[J];c++)for(var d=a[c],e=d.Fp,f=0;f<e[J];f++)this.eo.Pm(e[f],d.Gp,b)};T.z_=function(a){function b(a,b){return function(e){a[Mc](b,[this,e])}}a.l(Fr,b(function(a){this[Pp](Fr,a)},this));a.l(EG,b(function(a){this[Pp](eF,a)},this));a.l(rxa,b(function(a){this[Pp](fF,a)},this))};kp(T,function(a,b){var c=b[Z]().idStr;c!=ag&&(c=eO(c),this.ur(c,a))});T.eb=function(){return this.Wd};T.Cn=function(a,b){var c=a[Z]()||{};c.idStr=b.Hn();a[Z](c);this.z_(a)};
T.qe=function(a,b,c,d){b&&this.Ff(b);this.Cn(a,c,d)};T.Ff=function(a){a&&this.G.IU(a)};var NFa=[GC,LH,KH,kC,jC];function KQ(a,b){var c=ha[K][dd][L](arguments),d=c[rb]();if("undefined"==typeof d)throw m("[goog.string.format] Template required");return d[vb](/%([0\-\ \+]*)(\d+)?(\.(\d+))?([%sfdiu])/g,function(a,b,d,k,l,n,q,s){if(n==we)return we;var u=c[rb]();if("undefined"==typeof u)throw m("[goog.string.format] Not enough arguments");arguments[0]=u;return LQ[n][Mc](null,arguments)})}
var LQ={s:function(a,b,c){return ga(c)||c==O||a[J]>=c?a:a=-1<b[ld](Le,0)?a+ti(ne,c-a[J]):ti(ne,c-a[J])+a},f:function(a,b,c,d,e){d=a[hc]();ga(e)||e==O||(d=a[wb](e));var f;f=0>a?Le:0<=b[ld](Ie)?Ie:0<=b[ld](ne)?ne:O;0<=a&&(d=f+d);if(ga(c)||d[J]>=c)return d;d=ga(e)?h.abs(a)[hc]():h.abs(a)[wb](e);a=c-d[J]-f[J];0<=b[ld](Le,0)?d=f+d+ti(ne,a):(b=0<=b[ld](Oe,0)?Oe:ne,d=f+ti(b,a)+d);return d},d:function(a,b,c,d,e,f,g,k){return LQ.f(la(a,10),b,c,d,0,f,g,k)}};LQ.i=LQ.d;LQ.u=LQ.d;function MQ(a,b){var c;c=Ph[tc][Ic];c=mi(c)||(cm(c)[1]||null)!=Tr?Ng:Tr;return KQ(Yla,c,a,b)};function PFa(a,b){if(a){if(b[J]!=a[J])throw m("colorsScale and valuesScale must be of the same length");}else if(1!=b[J])throw m("colorsScale must contain exactly one element when no valueScale is provided");this.mk=a;this.iu=Gi(b,function(a){return mm(a).vd})}var QFa=[pA,dA],RFa=[oA,pA,dA];
function NQ(a,b){if(!a.mk)return a.iu[0];if(b>=a.mk[a.mk[J]-1])return a.iu[a.iu[J]-1];if(b<=a.mk[0])return a.iu[0];var c=aj(a.mk,b);if(0<=c)return a.iu[c];var d=-c-2,c=-c-1;return Mm(a.iu[c],a.iu[d],(b-a.mk[d])/(a.mk[c]-a.mk[d]))}
function SFa(a,b){b&&0!=b[J]?1==b[J]&&(b=[QFa[0],b[0]]):b=a&&3==a[J]?RFa:QFa;if(!a||2>a[J])return{values:null,b1:[Ai(b)]};var c=a[0],d=a[a[J]-1],e=d-c;if(0==e)return{values:[d],b1:[Ai(b)]};if(2==a[J])for(a=[],d=e/(b[J]-1),e=0;e<b[J];e++)a[C](c+d*e);return{values:a,b1:b}}
function TFa(a,b){var c=null,d=a.R(psa);if(d&&0<d[J]){1==d[J]&&(d=[d[0],d[0]]);b&&(null==d[0]&&(d[0]=b[y]),null==d[d[J]-1]&&(d[d[J]-1]=b.end));if(null==d[0])throw m(qsa);for(c=1;c<d[J];c++){if(null==d[c])throw m(qsa);if(d[c]<d[c-1])throw m("colorAxis.values must be a monotonically increasing series");}c=d}else{var d=tn(a,osa),e=tn(a,nsa);if(null!=d&&null!=e&&d>e)throw m("colorAxis.minValue ("+d+") must be at most colorAxis.maxValue ("+e+Ge);(d=afa(b,d,e))&&(c=[d[y],d.end])}d=a.R(ND);d=a.R(LD,d);c=
SFa(c,d);return new PFa(c[Hx],c.b1)};function OQ(a){var b=Gi(a.F,function(b){var d=a[Gz]?a[Gz]:{x:0,y:0},e=bK(b.x+d.x,b[J],a.Cc);b=bK(b.y+d.y,a.X[uc],a.Bc);return e[y]==e.end||b[y]==b.end?null:new rl(b[y],e.end,b.end,e[y])}),b=Fi(b,Xh);return Om(b)};function UFa(a){a=VFa(a);ei(Ph.setImmediate)?Ph.setImmediate(a):(PQ||(PQ=WFa()),PQ(a))}var PQ;
function WFa(){if(Ph.Hda&&Ph.Hda.resolve){var a=Ph.Hda.resolve();return function(b){a[Az](function(){try{b()}catch(a){Ph[Yp](Kda(a),0)}})}}var b=Ph.MessageChannel;"undefined"===typeof b&&"undefined"!==typeof ca&&ca.postMessage&&ca[Fq]&&(b=function(){var a=fa[Qb](lF);Ra(a[x],R);a.src=O;fa[dc][p](a);var b=a[dy],a=b[Hd];a[oq]();a[Cx](O);a[vy]();var c=ura+h[Cc](),d=b[tc][fq]+Dga+b[tc].host,a=W(function(a){if(a[gx]==d||a[Z]==c)this.port1.onmessage()},this);b[Fq](Kha,a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,
d)}}});if("undefined"!==typeof b){var c=new b,d={},e=d;c.port1.onmessage=function(){d=d[oc];var a=d.Jda;d.Jda=null;a()};return function(a){Ga(e,{Jda:a});e=e[oc];c.port2.postMessage(0)}}return"undefined"!==typeof fa&&yxa in fa[Qb](lh)?function(a){var b=fa[Qb](lh);tp(b,function(){tp(b,null);b[fe][Qd](b);b=null;a();a=null});fa[dc][p](b)}:function(a){Ph[Yp](a,0)}}var VFa=kj;function XFa(a){UFa(function(){throw a;})}function QQ(a,b){RQ||(UFa(YFa),RQ=!0);SQ[C](new ZFa(a,b))}var RQ=!1,SQ=[];function YFa(){for(;SQ[J];){var a=SQ;SQ=[];for(var b=0;b<a[J];b++){var c=a[b];try{c.usa[L](c[yz])}catch(d){XFa(d)}}}RQ=!1}function ZFa(a,b){this.usa=a;this.scope=b};function $Fa(a){a[K].then=a[K][Az];a[K].$goog_Thenable=!0}function aGa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function TQ(a,b){this.n=0;this.bs=void 0;this.Om=this.Kd=null;this.TQ=this.S_=!1;try{var c=this;a[L](b,function(a){UQ(c,2,a)},function(a){UQ(c,3,a)})}catch(d){UQ(this,3,d)}}TQ[K].then=function(a,b,c){return bGa(this,ei(a)?a:null,ei(b)?b:null,c)};$Fa(TQ);up(TQ[K],function(a){0==this.n&&QQ(function(){var b=new VQ(a);cGa(this,b)},this)});
function cGa(a,b){if(0==a.n)if(a.Kd){var c=a.Kd;if(c.Om){for(var d=0,e=-1,f=0,g;g=c.Om[f];f++)if(g=g.YQ)if(d++,g==a&&(e=f),0<=e&&1<d)break;0<=e&&(0==c.n&&1==d?cGa(c,b):(d=c.Om[he](e,1)[0],dGa(c,d,3,b)))}}else UQ(a,3,b)}function eGa(a,b){a.Om&&a.Om[J]||2!=a.n&&3!=a.n||fGa(a);a.Om||(a.Om=[]);a.Om[C](b)}
function bGa(a,b,c,d){var e={YQ:null,Sca:null,Tca:null};e.YQ=new TQ(function(a,g){e.Sca=b?function(c){try{var e=b[L](d,c);a(e)}catch(n){g(n)}}:a;e.Tca=c?function(b){try{var e=c[L](d,b);!Qh(e)&&b instanceof VQ?g(b):a(e)}catch(n){g(n)}}:g});e.YQ.Kd=a;eGa(a,e);return e.YQ}TQ[K].Paa=function(a){this.n=0;UQ(this,2,a)};TQ[K].Qaa=function(a){this.n=0;UQ(this,3,a)};
function UQ(a,b,c){if(0==a.n){if(a==c)b=3,c=new TypeError(bpa);else{if(aGa(c)){a.n=1;c[Az](a.Paa,a.Qaa,a);return}if(ai(c))try{var d=c[Az];if(ei(d)){gGa(a,c,d);return}}catch(e){b=3,c=e}}a.bs=c;a.n=b;fGa(a);3!=b||c instanceof VQ||hGa(a,c)}}function gGa(a,b,c){function d(b){f||(f=!0,a.Qaa(b))}function e(b){f||(f=!0,a.Paa(b))}a.n=1;var f=!1;try{c[L](b,e,d)}catch(g){d(g)}}function fGa(a){a.S_||(a.S_=!0,QQ(a.ura,a))}
TQ[K].ura=function(){for(;this.Om&&this.Om[J];){var a=this.Om;this.Om=[];for(var b=0;b<a[J];b++)dGa(this,a[b],this.n,this.bs)}this.S_=!1};function dGa(a,b,c,d){if(2==c)b.Sca(d);else{for(;a&&a.TQ;a=a.Kd)a.TQ=!1;b.Tca(d)}}function hGa(a,b){a.TQ=!0;QQ(function(){a.TQ&&iGa[L](null,b)})}var iGa=XFa;function VQ(a){ji[L](this,a)}X(VQ,ji);eb(VQ[K],hD);/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function WQ(a,b){this.Ne=[];this.Mba=a;this.Raa=b||null;this.iJ=this.BC=!1;this.bs=void 0;this.X0=this.vna=this.p0=!1;this.lR=0;this.Kd=null;this.m0=0}T=WQ[K];up(T,function(a){if(this.BC)this.bs instanceof WQ&&this.bs[pq]();else{if(this.Kd){var b=this.Kd;delete this.Kd;if(a)b[pq](a);else b.m0--,0>=b.m0&&b[pq]()}this.Mba?this.Mba[L](this.Raa,this):this.X0=!0;this.BC||XQ(this,new YQ)}});T.jba=function(a,b){this.p0=!1;ZQ(this,a,b)};function ZQ(a,b,c){a.BC=!0;a.bs=c;a.iJ=!b;jGa(a)}
T.Et=function(){if(this.BC){if(!this.X0)throw new $Q;this.X0=!1}};T.cda=function(a){this.Et();ZQ(this,!0,a)};function XQ(a,b){a.Et();ZQ(a,!1,b)}function kGa(a,b){aR(a,b,null,void 0)}function lGa(a,b){aR(a,null,b,void 0)}function aR(a,b,c,d){a.Ne[C]([b,c,d]);a.BC&&jGa(a)}T.then=function(a,b,c){var d,e,f=new TQ(function(a,b){d=a;e=b});aR(this,d,function(a){a instanceof YQ?f[pq]():e(a)});return f[Az](a,b,c)};$Fa(WQ);WQ[K].Ni=function(a){return a instanceof m};
function mGa(a){return Mi(a.Ne,function(a){return ei(a[1])})}
function jGa(a){if(a.lR&&a.BC&&mGa(a)){var b=a.lR,c=bR[b];c&&(Ph[Gp](c.bc),delete bR[b]);a.lR=0}a.Kd&&(a.Kd.m0--,delete a.Kd);for(var b=a.bs,d=c=!1;a.Ne[J]&&!a.p0;){var e=a.Ne[rb](),f=e[0],g=e[1],e=e[2];if(f=a.iJ?g:f)try{var k=f[L](e||a.Raa,b);Qh(k)&&(a.iJ=a.iJ&&(k==b||a.Ni(k)),a.bs=b=k);aGa(b)&&(d=!0,a.p0=!0)}catch(l){b=l,a.iJ=!0,mGa(a)||(c=!0)}}a.bs=b;if(d)if(k=W(a.jba,a,!0),d=W(a.jba,a,!1),b instanceof WQ)aR(b,k,d),b.vna=!0;else b[Az](k,d);c&&(b=new nGa(b),bR[b.bc]=b,a.lR=b.bc)}
function oGa(a){var b=new WQ;XQ(b,a);return b}function $Q(){ji[L](this)}X($Q,ji);Ka($Q[K],"Deferred has already fired");eb($Q[K],"AlreadyCalledError");function YQ(){ji[L](this)}X(YQ,ji);Ka(YQ[K],"Deferred was canceled");eb(YQ[K],"CanceledError");function nGa(a){this.bc=Ph[Yp](W(this.Zpa,this),0);this.Lr=a}nGa[K].Zpa=function(){delete bR[this.bc];throw this.Lr;};var bR={};function pGa(a,b){var c=b||{},d=c[Hd]||fa,e=Tk(Df),f={eda:e,Ve:void 0},g=new WQ(qGa,f),k=null,l=null!=c.timeout?c.timeout:5E3;0<l&&(k=ca[Yp](function(){cR(e,!0);XQ(g,new dR(1,ypa+a))},l),f.Ve=k);cp(e,tp(e,function(){e[Eq]&&e[Eq]!=Qwa&&e[Eq]!=Gr||(cR(e,c.Y$||!1,k),g.cda(null))}));e.onerror=function(){cR(e,!0,k);XQ(g,new dR(0,toa+a))};Ok(e,{type:uh,charset:Dpa,src:a});rGa(d)[p](e);return g}
function eR(a,b){Ph.closure_verification||(Ph.closure_verification={});var c=Ph.closure_verification;if(Qh(c[b]))return oGa(new dR(3,Hpa+b+hla));var d=pGa(a,{Y$:!0}),e=new WQ(W(d[pq],d));kGa(d,function(){var d=c[b];Qh(d)?(e.cda(d),delete c[b]):XQ(e,new dR(2,kpa+a+jla+b+lla))});lGa(d,function(a){Qh(c[b])&&delete c[b];XQ(e,a)});return e}function rGa(a){var b=a[cc](Eoa);return!b||Si(b)?a[dc]:b[0]}function qGa(){if(this&&this.eda){var a=this.eda;a&&a[Nc]==Df&&cR(a,!0,this.Ve)}}
function cR(a,b,c){null!=c&&Ph[Gp](c);cp(a,Th);a.onerror=Th;tp(a,Th);b&&ca[Yp](function(){Zk(a)},0)}function dR(a,b){var c=Moa+a+Ge;b&&(c+=bB+b);ji[L](this,c);this.code=a}X(dR,ji);var __flash_unloadHandler,__flash_savedUnloadHandler;/*
 SWFObject v1.5: Flash Player detection and embed -
 http://blog.deconcept.com/swfobject/

 SWFObject is (c) 2007 Geoff Stearns and is released under the MIT License:
 http://www.opensource.org/licenses/mit-license.php

*/
function fR(a,b,c,d,e,f,g,k,l,n){if(fa[gd]){this.ppa=n?n:cta;t:{n=this.ppa;var q=fa[tc][xc]||fa[tc].hash;if(null==n)n=q;else{if(q)for(var q=q[ae](1)[pc](xe),s=0;s<q[J];s++)if(q[s][ae](0,q[s][ld](af))==n){n=q[s][ae](q[s][ld](af)+1);break t}n=O}}this.jpa=n;this.Ta={};this.wm={};this.attributes=[];a&&this[v](yI,a);b&&this[v](kF,b);c&&this[v](Ih,c);d&&this[v](Hg,d);e&&this[v](cJ,new gR(e[hc]()[pc](Me)));t:if(a=new gR([0,0,0]),Pv.plugins&&Pv.mimeTypes[J])(b=Pv.plugins[mpa])&&b.description&&(a=new gR(b.description[vb](/([a-zA-Z]|\s)+/,
O)[vb](/(\s+r|\s+b[0-9]+)/,Me)[pc](Me)));else if(Pv[sc]&&0<=Pv[sc][ld](Jpa))for(b=1,c=3;b;)try{c++,b=new ActiveXObject(opa+c),a=new gR([c,0,0])}catch(u){b=null}else{b=null;try{b=new ActiveXObject(qpa)}catch(w){try{b=new ActiveXObject(ppa),a=new gR([6,0,21]),b.Uta=vC}catch(z){if(6==a.dD)break t}try{b=new ActiveXObject(npa)}catch(B){}}null!=b&&(a=new gR(b.GetVariable(Vla)[pc](ne)[1][pc](Je)))}this.aS=a;!ca.opera&&fa.all&&7<this.aS.dD&&(sGa=!0);f&&(this.Ta.bgcolor=f);this.Ta.quality=g?g:aF;this[v](fBa,
!1);this[v](hE,!1);this[v](ABa,k?k:ca[tc]);this[v](xH,O);l&&this[v](xH,l)}}var sGa;
kb(fR,{setAttribute:function(a,b){this[Ky][a]=b},getAttribute:function(a){return this[Ky][a]},getParams:function(){return this.Ta},write:function(a){if(this[Sd](fBa)&&hR(this.aS,new gR([6,0,65]))&&!hR(this.aS,this[Sd](cJ))){this[v](hE,!0);var b=Nv(this[Sd](ABa));this.wm.MMredirectURL=b;Ap(fa,fa[uz][dd](0,47)+bla);this.wm.MMdoctitle=fa[uz]}if(this.jpa||this[Sd](hE)||hR(this.aS,this[Sd](cJ))){a=typeof a==rh?fa[gd](a):a;b=O;if(Pv.plugins&&Pv.mimeTypes&&Pv.mimeTypes[J]){this[Sd](hE)&&(this.wm.MMplayerType=
Zoa,this[v](yI,this.Jqa));var b=Jna+this[Sd](yI)+tla+this[Sd](Ih)+pla+this[Sd](Hg)+sla+this[Sd](sh)+oe,b=b+(Vz+this[Sd](kF)+qla+this[Sd](kF)+Xz),c=this.getParams(),d;for(d in c)b+=[d]+kB+c[d]+Xz;d=tGa(this)[ie](xe);0<d[J]&&(b+=lua+d+oe);b+=Yma}else{this[Sd](hE)&&(this.wm.MMplayerType=Wna,this[v](yI,this.Jqa));b=Ona+this[Sd](kF)+ola+this[Sd](Ih)+pla+this[Sd](Hg)+sla+this[Sd](sh)+Zz;b+=Rna+this[Sd](yI)+pe;c=this.getParams();for(d in c)b+=Pna+d+Yz+c[d]+pe;d=tGa(this)[ie](xe);0<d[J]&&(b+=Qna+d+pe);b+=
Cna}Wa(a,b);return!0}this[Sd](xH)!=O&&fa[tc][vb](this[Sd](xH));return!1}});function tGa(a){var b=[],c;a=a.wm;for(c in a)b[b[J]]=c+af+a[c];return b}function gR(a){this.dD=null!=a[0]?la(a[0],10):0;this.uS=null!=a[1]?la(a[1],10):0;this.rev=null!=a[2]?la(a[2],10):0}function hR(a,b){return a.dD<b.dD?!1:a.dD>b.dD?!0:a.uS<b.uS?!1:a.uS>b.uS?!0:a.rev<b.rev?!1:!0}function uGa(){for(var a=fa[cc](hba),b=a[J]-1;0<=b;b--){Ra(a[b][x],R);for(var c in a[b])typeof a[b][c]==Bg&&(a[b][c]=function(){})}}
if(sGa&&!vGa){ca.attachEvent("onbeforeunload",function(){__flash_unloadHandler=function(){};__flash_savedUnloadHandler=function(){};ca.attachEvent(zxa,uGa)});var vGa=!0}!fa[gd]&&fa.all&&(fa.getElementById=function(a){return fa.all[a]});function wGa(a){this.ssa=a}var xGa=MQ("regioncoder",Oe)+"geocodes",iR={};function yGa(a,b){a=pi(a[ke]());a=aa(String(a));var c=iR[a];if(null==c){iR[a]=[b];var c=xGa+Tq+a+Qma,d=vfa(),e=fa[Qb](lh);ab(e,uh);e.src=c;d[p](e);ut(gi(zGa,a,null),5E3)}else Vh(c)==dg?Ri(c,b)||c[C](b):ut(gi(b,c),0)}function zGa(a,b){if(b){var c=new wGa(b),d=iR[a];if(Vh(d)==dg){iR[a]=c;for(var e=0;e<d[J];e++)d[e](c)}}else if(d=iR[a],Vh(d)==dg)for(iR[a]=null,e=0;e<d[J];e++)d[e](null)}
function AGa(a,b){b=pi(b[ke]());return a.ssa[b]}
var BGa=["AD","AE","AF","AG","AL","AM","AO","AR",lB,"AU","AZ","BA","BB","BD","BE","BF","BG","BH","BI","BJ","BN","BO",ef,"BS","BT","BW","BY","BZ","CA","CD","CF","CG","CH","CI","CL","CM","CN","CO","CR","CS","CU","CV","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG","ER","ES","ET","FI","FJ","FM","FR","GA","GB","GD","GE","GH","GM","GN","GQ","GR","GT","GW","GY","HN",pf,"HT","HU","ID","IE","IL","IN","IQ","IR","IS","IT","JM","JO","JP","KE","KG","KH","KI","KM","KN","KP","KR","KW","KZ","LA","LB",OB,
"LK","LR","LS","LT","LU","LV","LY","MA","MD","ME","MG","MH","MK","ML","MM","MN","MR","MT","MU","MV","MW","MX","MY","MZ","NA","NE","NG","NI","NL","NO","NP","NR","NZ","OM","PA","PE","PG","PH","PK","PL","PT","PW","PY","QA","RO","RS","RU","RW","SA","SB","SC","SD","SE","SG","SH","SI","SK","SL","SM","SN","SO","SR","ST","SV","SY","SZ",bC,"TG","TH","TJ",Nf,"TM","TN","TO",Of,"TT","TV","TW","TZ","UA","UG","UM",eC,"UY","UZ","VC","VE","VN","VU","WS","YE","YU","ZA","ZM","ZW"];V("gviz.util.RegionCoder.dictionaryReady",zGa,void 0);var CGa={xS:Jg,yS:Eh};
function jR(a,b,c,d){var e={},f={},g=b.K6||Jo;if(b[lz]==Jg){var f=b.X,e=a.mk[0],k=a.mk[a.mk[J]-1],g=new Io({pattern:g}),e=g.Ee(e),k=g.Ee(k),f={Hh:{text:e,width:d?d(e,f)[r]:0,height:f[uc]},Zi:{text:k,width:d?d(k,f)[r]:0,height:f[uc]}};d=f.Hh[A]/4;e=new vl(f.Hh[r]+d,0,b[r]-(f.Hh[r]+f.Zi[r]+2*d),b[A])}else e=new vl(0,0,b[r],b[A]);d=0.33*e[A];var k=2*(d/h[ud](3)),g=new vl(e[G]+k/2,e.top+d+1,e[r]-k,e[A]-d-1),l=a.iu,n=a.mk,q=n[n[J]-1]-n[0],s;if(0==q)s=[{Xg:new vl(g[G],g.top,g[r],g[A]),brush:new Rm({fill:l[0]})}];
else{s=[];for(var q=g[r]/q,u=g[G],w=0,z=0;z<n[J]-1;++z)w=u+(n[z+1]-n[z])*q,s[z]={Xg:new vl(u,g.top,w-u,g[A]),brush:new Rm({gh:{x1:u,y1:0,hb:w,kb:0,lg:l[z],Tf:l[z+1]}})},u=w}g=s;if(null!=g&&0<g[J]&&(0>g[0].Xg[r]||0>g[0].Xg[A]))return null;l=e;n=b.J6;e=[];for(s=0;s<c[J];++s)q=c[s][id],u=a.mk,q<u[0]?q=0:(w=l[r]-k,q>u[u[J]-1]?q=w:(z=u[u[J]-1]-u[0],q=0==z?0.5*w:(q-u[0])/z*w)),q=l[G]+q+k/2,q=[q-k/2,l.top,q+k/2,l.top,q,l.top+d],u=new Rm({fill:n,stroke:n}),e[s]={path:q,brush:u};a=[];b[lz]==Jg&&(a=f,c=[],
c[0]={x:0,y:b[A]-a.Hh[A],text:a.Hh[cd],style:b.X},c[1]={x:b[r]-a.Zi[r],y:b[A]-a.Zi[A],text:a.Zi[cd],style:b.X},a=c);a={pW:g,qW:e,rW:a};f=a.pW;for(c=0;c<f[J];++c)d=f[c],b[lz]==Eh&&(k=d.Xg[G],Ya(d.Xg,d.Xg.top),d.Xg.top=k,k=d.Xg[r],pa(d.Xg,d.Xg[A]),Sa(d.Xg,k)),Ya(d.Xg,d.Xg[G]+b[G]),d.Xg.top+=b.top,k=d.brush.o(),d.brush=k,d=k.Qg,b[lz]==Eh&&(d.y1=d.x1,d.x1=0,d.kb=d.hb,d.hb=0),null!=d&&(d.x1+=b[G],d.y1+=b.top,d.hb+=b[G],d.kb+=b.top);f=a.qW;for(c=0;c<f[J];++c)for(d=0;3>d;++d)b[lz]==Eh&&(k=f[c][gz][2*d],
f[c][gz][2*d]=f[c][gz][2*d+1],f[c][gz][2*d+1]=k),f[c][gz][2*d]+=b[G],f[c][gz][2*d+1]+=b.top;f=a.rW;for(c=0;c<f[J];++c)f[c].x+=b[G],f[c].y+=b.top;return a};var DGa={Jua:usa,qwa:mAa,Kua:PD,Wva:qH,Ava:vG};function kR(a){this.b=a||{}}kR[K].uV=function(){return 1.618};kR[K].set=function(a,b){this.b[a]=b};kR[K].Vc=function(){return Qj(this.b)};function lR(a){var b=0,c=0;if(a.boundingBox)var d=a.boundingBox.lo,c=a.boundingBox.hi,b=(c[0]-d[0])/2+d[0],c=(c[1]-d[1])/2+d[1];d=[29.5,45.5];b={parallels:d,origin:{lat:b,lng:c}};c=b[gx];a[gx]&&Sj(c,a[gx]);Sj(b,a);b.origin=c;b.Dl&&0!==b.Dl[J]?2>b.Dl[J]&&(b.Dl[1]=h.abs(b.Dl[0]-d[0])>h.abs(b.Dl[0]-d[1])?d[0]:d[1]):b.Dl=d;this.b=a||{};this.v_=b[gx].lat/(180/h.PI);this.rQ=b[gx].lng/(180/h.PI);this.mo=Gi(b.parallels,function(a){return a/(180/h.PI)})}X(lR,kR);
lR[K].iD=function(a){return Gi(arguments,W(function(a){var c=a[0]/(180/h.PI),d=0.5*(h.sin(this.mo[0])+h.sin(this.mo[1]));a=d*(a[1]/(180/h.PI)-this.rQ);var e=h.cos(this.mo[0]),e=e*e+2*d*h.sin(this.mo[0]),c=h[ud](e-2*d*h.sin(c))/d,d=h[ud](e-2*d*h.sin(this.v_))/d;return{x:180/h.PI*h.sin(a)*c,y:180/h.PI*(d-c*h.cos(a))}},this))};function mR(a){this.b=a||{}}X(mR,kR);mR[K].uV=function(){return 2.2};mR[K].iD=function(a){return Gi(arguments,function(a){var c=a[0]/(180/h.PI);a=a[1]/(180/h.PI)*3/(2*h.PI)*(180/h.PI);return{x:h[ud](h.PI*h.PI/3-c*c)*a,y:c}})};function nR(a){var b=0,c=0;if(a.boundingBox)var d=a.boundingBox.lo,c=a.boundingBox.hi,b=(c[0]-d[0])/2+d[0],c=(c[1]-d[1])/2+d[1];d=[20,50];b={parallels:d,origin:{lat:b,lng:c}};c=b[gx];a[gx]&&Sj(c,a[gx]);Sj(b,a);b.origin=c;b.Dl&&0!==b.Dl[J]?2>b.Dl[J]&&(b.Dl[1]=h.abs(b.Dl[0]-d[0])>h.abs(b.Dl[0]-d[1])?d[0]:d[1]):b.Dl=d;this.b=a||{};this.v_=b[gx].lat/(180/h.PI);this.rQ=b[gx].lng/(180/h.PI);this.mo=Gi(b.parallels,function(a){return a/(180/h.PI)})}X(nR,kR);
nR[K].iD=function(a){return Gi(arguments,W(function(a){var c=a[0]/(180/h.PI);a=a[1]/(180/h.PI);var d=h.log(1/h.cos(this.mo[1])*h.cos(this.mo[0]))/h.log(h.tan(0.25*h.PI+0.5*this.mo[1])*(1/h.tan(0.25*h.PI+0.5*this.mo[0]))),e=h.cos(this.mo[0])*h.pow(h.tan(0.25*h.PI+0.5*this.mo[0]),d)/d,c=e*h.pow(1/h.tan(0.25*h.PI+0.5*c),d),e=e*h.pow(1/h.tan(0.25*h.PI+0.5*this.v_),d);return{x:180/h.PI*h.sin(d*(a-this.rQ))*c,y:e-180/h.PI*h.cos(d*(a-this.rQ))*c}},this))};function oR(a){return 180/h.PI*(h.atan(h.exp(a/(180/h.PI)))-h.PI/4)*2}function pR(){this.bq={}}pR[K].aqa=function(a){Y(arguments,W(function(a){for(var c in a)if(a[vc](c)){c in this.bq||(this.bq[c]={min:ea,max:-ea});if(!this.bq[c].min||a[c]<this.bq[c].min)this.bq[c].min=a[c];if(!this.bq[c].max||a[c]>this.bq[c].max)this.bq[c].max=a[c]}},this))};pR[K].getBounds=function(a){return{min:this.bq[a].min,max:this.bq[a].max}};function qR(a){this.b=a||{}}X(qR,kR);qR[K].iD=function(a){return Gi(arguments,function(a){return{x:a[1],y:180/h.PI*h.log(h.tan(a[0]/180*0.5*h.PI+h.PI/4))}})};var EGa={gua:"albers",jva:Tva,mva:"lambert",zva:uG},rR={};rR.mercator=qR;rR[Tva]=mR;rR.albers=lR;rR.lambert=nR;var FGa={NONE:R,TOP_LEFT:PI,TOP_RIGHT:OAa,BOTTOM_LEFT:ZC,BOTTOM_RIGHT:"bottom_right"},GGa={NONE:R,Yva:zH,uua:$C,Vx:kg};function HGa(a){return nn(a,fya,{name:uG},function(a){ai(a)||(a={name:a});var c=a[yd];if(null!=c&&!Jj(EGa,yn(c)))throw m("The projection you specified is not valid.");return a})}
var IGa={region:kJ,resolution:PD,domain:sB,displayMode:eg,showGeocodeWarnings:!1,backgroundColor:{fill:Hh,stroke:iA,strokeWidth:0},datalessRegionColor:"F5F5F5",defaultColor:"267114",markerOpacity:1,selectionMode:oh,fontName:nB,geocodingContext:zH,tooltip:{isHtml:!1,textStyle:{fontName:nB,fontSize:13,color:RC},trigger:zg,showDisputedText:!1,showTitle:!0},colorAxis:{minValue:null,maxValue:null,values:null},sizeAxis:{minValue:null,maxValue:null,minSize:3,maxSize:12},legend:{position:ZC,orientation:Jg,
textStyle:{color:RC,auraColor:Hh}},marker:{style:{stroke:{color:tA,width:1}}},projection:uG,keepAspectRatio:!0,magnifyingGlass:{enable:!0,zoomFactor:5}};function sR(a){this.yc=a;this.wC=null;this.Faa=!0;this.oJ=null;this.To=new wu;this.Kpa=/^([a-zA-Z][a-zA-Z]|[a-zA-Z][a-zA-Z]\-[a-zA-Z0-9](|[a-zA-Z0-9](|[a-zA-Z0-9]))|\d\d\d)$/;this.epa=/^\d\d\d$/}X(sR,Us);T=sR[K];T.g1=function(a){this.wC=a;null!=this.ora&&this.ora(a)};function JGa(a,b,c,d,e,f){a.Faa=e;if(0==b.M())ut(function(){f([],[],!0)});else switch(c.xX){case Yr:a.gW(b,c,f);break;case xs:KGa(a,b,c,d,f);break;case Br:a.fW(b,c,d,f)}}
T.gW=function(a,b,c){for(var d=[],e=0;e<a.M();e++){var f=a[I](e,b.FA),g=a[I](e,b.HA);d[e]=null==f||null==g?null:{lat:ni(f),lng:ni(g)}}ut(function(){c([],d,!0)})};function KGa(a,b,c,d,e){for(var f=[],g=0;g<b.M();g++)f[C](b[I](g,c.pG));d.Rm==vG||d.Rm==usa||d.Rm==mAa?a.cW(d,f,e):a.dW(d,f,e)}T.cW=function(a,b,c){a=ki(a.Ju,eC)&&a.Rm==vG;for(var d=[],e=0;e<b[J];e++){var f=ni(b[e]);a&&this.epa[bd](f)&&(f=fC+f);d[C](f[ge]())}ut(function(){c(d,[],!0)})};
T.dW=function(a,b,c){var d=a.Ju,e;e=a.Rm==qH&&0<=aj(BGa,d)?d:Fsa;if(a.Rm==qH&&d==eC)for(a=0;a<b[J];++a){var f=b[a];2==f[J]&&(b[a]=fC+f)}yGa(e,this.Fi(function(a){a=this.NY(b,a);for(var e=[],f=0;f<b[J];f++)if(null==a[f]){var n=b[f];e[C]({f0:n,Uaa:f,Taa:null});a[f]=n}Si(e)?c(a,[],!0):(c(a,[],!1),LGa(this,e,d,c,a))}))};T.NY=function(a,b){for(var c=[],d=0;d<a[J];++d){var e=pi(ni(a[d]))[ke](),f=b&&AGa(b,e),e=f?f:this.Kpa[bd](e)?e[ge]():null;c[C](e)}return c};function tR(a,b){a.Faa&&a.yc&&nu(a.yc,b)}
T.fW=function(a,b,c,d){var e=[];c=c.Ju;2==c[J]&&(c=c[ge](),c=c[vb](/GB/,Bpa),c=c[vb](/RU/,ipa),c=c[vb](/TP/,Nf));for(var f=0;f<a.M();f++){var g=ni(a[I](f,b.qG));MGa(this,c)&&(g+=ne+c);e[C]({f0:g,Taa:f,Uaa:null})}LGa(this,e,c,d,[])};function MGa(a,b){return b==kJ||oi(b)?!1:a.oJ===zH||a.oJ===kg}
function NGa(a){var b=ea,c=ea,d=-ea,e=-ea;if(null!=a.wC&&0!==a.wC[ky][J])return Y(a.wC[ky],function(a){a=a.bt;b=h.min(b,a.Og[0]);c=h.min(b,a.Og[1]);d=h.max(d,a.Uh[0]);e=h.max(d,a.Uh[1])}),{lo:{lat:b,lng:c},hi:{lat:d,lng:e}}}function LGa(a,b,c,d,e){for(var f=[],g=0;g<b[J];g++){var k={address:b[g].f0};MGa(a,c)&&(k.region=c);a.oJ!==$C&&a.oJ!==kg||(k.bounds=NGa(a));f[C](k)}b=Yi(b);d=W(a.$Y,a,b,d,e,[]);a.To[Up](f,d,1)}
T.$Y=function(a,b,c,d,e){for(var f=e[J],g=0;g<f;g++){var k=a[g],l=k.f0,n=k.Uaa,q=k.Taa;if(e[g]&&e[g][0]){k=e[g][0];if(null!=n){var s=c,u=n,w=k.address_components,z=null;1==w[J]&&0<=Ci(w[0].types,Gsa)?z=w[0].short_name:2==w[J]&&w[1].short_name==eC&&(z=fC+w[0].short_name);s[u]=z;c[n]||(tR(this,woa+l+oe),c[n]=l)}null!=q&&(l=d,n=q,k={lat:k[yx][tc].lat(),lng:k[yx][tc].lng()},l[n]=k)}else null!=n&&(c[n]=null),null!=q&&(d[q]=null),tR(this,woa+l+oe)}Vi(a,0,f);(a=Si(a))&&Ni(c,Wh)&&Ni(d,Wh)&&tR(this,Aoa);b(c,
d,a)};T.Fi=function(a){return W(a,this)};T.w=function(){this.To[pq]();sR.e.w[L](this)};function OGa(a,b,c){for(var d=0;d<a[J];++d)b.rb(a[d].Xg[G],a[d].Xg.top,a[d].Xg[r],a[d].Xg[A],a[d].brush,c)}function PGa(a,b,c){for(var d=0;d<a[J];++d){var e=new YJ;e[Yy](a[d][gz][0],a[d][gz][1]);e.Z(a[d][gz][2],a[d][gz][3]);e.Z(a[d][gz][4],a[d][gz][5]);e[vy]();b.na(e,a[d].brush,c)}}function QGa(a,b,c){for(var d=0;d<a[J];++d)b.Pd(a[d][cd],a[d].x,a[d].y,1,nI,nI,a[d][x],c)};function uR(a){return a[ie](Me)};function vR(a,b,c){this.g=b;this.vf=W(this.g.vf,this.g);this.si=a;this.iN=[];this.Za=c;this.ed={};this.pc=new rt;this.SW=this.Jv=this.Yv=this.Xv=this.Pv=this.mt=this.Fz=null}X(vR,Us);vR[K].l=function(a,b){kt(this.pc,a,b)};
function RGa(a,b){var c=a.g;c[Wb]();var d=c.wk(b[r],b[A]);a.ed={};var e=c.za();SGa(a,e,b,new vl(0,0,b[r],b[A]),!1);var f=c.za(),g=a.g,k=g.za();a.Pv=g.za();for(var l=0;l<b[ky][J];++l)TGa(a,k,b,b[ky][l],!1),UGa(a,b,b[ky][l]);a.mt=g.za();wR(a,a.mt,b.Fy,!1,b.Kj);g[p](f,k);g[p](f,a.Pv);g[p](f,a.mt);g=b.bfa;f=c.cE(f,a.qB()?new vl(g[G],g.top,g[r]-1,g[A]-1):g);a.Yv=c.za();VGa(a,b);a.Jv=c.za();WGa(a,b);a.Xv=c.za();XGa(a,b);c[p](d,e);c[p](e,f);c[p](e,a.Yv);c[p](e,a.Jv);c[p](e,a.Xv);a.Fz=b;YGa(a,d)}
function xR(a,b,c){c=c||!1;a.g.cd(a.Xv);XGa(a,b);if(c||!gn(a.Fz.nz,b.nz))for(a.g.cd(a.Pv),c=0;c<b[ky][J];++c)UGa(a,b,b[ky][c]);ZGa(a,b);a.g.cd(a.Yv);VGa(a,b);a.SW!=(b.UD?b.UD.bn:null)&&(a.g.cd(a.Jv),WGa(a,b));a.Fz=b}function UGa(a,b,c){var d=a.g.za();c=Fi(c.N,function(a){return Ri(b.nz,a.id)});for(var e=0;e<c[J];++e)$Ga(a,d,b,c[e]);a.g[p](a.Pv,d)}function aHa(a,b){var c=a.g;Y($k(a.mt.a()),function(a){Y($k(a),function(a){c.Ff(a)},this)},a);wR(a,a.mt,b.Fy,!1,b.Kj)}
var bHa=new Rm({qa:Ve,stroke:RC,Cg:"0.2"}),cHa=new Rm({qa:Te,stroke:RC,Cg:"0.1"});function $Ga(a,b,c,d){a.qB()||(c=c.hz[d.id].ce,yR(a,b,d,!1,!1,[bHa,cHa,c[fc]]),Si(d.Cm)||(yR(a,b,d,!0,!1,[c.Cm]),yR(a,b,d,!1,!1,[c.border])))}
function WGa(a,b){var c=b.UD;if(c){var d=a.Jv,e=a.g,f=c[Lq].Zy,g=f[G]+f[r]/2,k=f.top+f[A]/2,l=f[r]/2,n=f[A]/2,q=c.A5.x,s=c.A5.y,u=new Rm({fill:nna,ae:0.25}),w=new YJ;w[Yy](q,s);w.Z(q,s+(k>s?n:-n));w.Z(q+(g>q?l:-l),s);w[vy]();q=e.na(w,u,d);zR(a,q,SF,!0);q=new Rm({fill:Hh});q=e.Nj(g,k,l,n,q,d);zR(a,q,RF,!0);q=new Rm({stroke:ira,qa:1.5});q=e.Nj(g,k,l,n,q,d);zR(a,q,RF,!0);q=e.za();f=e.cE(q,new vl(f[G]+3.5,f.top+3.5,f[r]-7,f[A]-7),!0);e[p](d,f);f=new Rm({stroke:Cra,qa:1.5});d=e.Nj(g,k,l-3.5,n-3.5,f,d);
zR(a,d,RF,!0);d=c[Lq];SGa(a,q,b,d.Zy,!0);TGa(a,q,b,d,!0);wR(a,q,c.Fy,!0,b.Kj);a.SW=c.bn}else a.SW=null}function XGa(a,b){0<a.iN[J]&&(Gi(a.iN,function(a){this.g.Ff(a)},a),a.iN=[]);a.iN=0<b.Aq[J]?Gi(b.Aq,function(a){return a[jy]?yP(a,this.si.ac()):zP(a,this.g,this.Xv).a()},a):[]}function dHa(a,b){Dj(b.hz,function(a,b){var e=a.ce;AR(this,b,uE,e[fc]);AR(this,b,uta,e.Cm);AR(this,b,lra,e.border)},a)}function AR(a,b,c,d){b=uR([c,b]);b=a.ed[b];if(null!=b)for(c=0;c<b[J];++c)a.g.Ri(b[c],d)}
function YGa(a,b){var c=a.Fi(function(a){var b=eHa(this,a[Mq]);if(b&&b.oO){var c=fHa(a[H],b[H]),d=b.cu,b=Pj(b[Z]);a[H]==fs?b.jn=!1:a[H]==gs&&(b.jn=!0);b.ub=gK(a);this.pc[$]({type:c,cu:d,data:b})}}),d=a.g;d.Fb(b,EG,c);d.Fb(b,fs,c);d.Fb(b,gs,c);d.Fb(b,Fr,c)}function fHa(a,b){switch(b){case uE:switch(a){case Fr:return vE;case EG:return xE;case fs:case gs:return wE}case UF:switch(a){case Fr:return VF;case EG:return bxa;case fs:case gs:return mG}}return null}
function zR(a,b,c,d){BR(a,b,[nf,c,Te,d?Te:Oe,O,Oe])}function BR(a,b,c){c=c[ie](qe);a.g.zn(b,c)}function eHa(a,b){var c=a.g.Er(b);if(!c||c==ag)return null;var c=c[pc](qe),d=c[1],e=c[2]==Te?!0:!1,f=c[3]==Te?!0:!1;switch(c[0]){case nf:return{type:uE,cu:d,oO:e,data:{WH:f,Ot:c[4]?c[4]:null,zF:c[5]==Te?!0:!1}};case sf:return{type:UF,cu:d,oO:e,data:{WH:f,bn:c[4],ri:yi(c[5]),Ty:c[6]==Te?!0:!1}};default:return null}}function SGa(a,b,c,d,e){b=a.g.rb(d[G],d.top,d[r],d[A],c.nD,b);zR(a,b,vxa,e)}
function TGa(a,b,c,d,e){for(var f=a.g.za(),g=0;g<d.N[J];++g){var k=a,l=f,n=d.N[g],q=e,s=c.hz[n.id].ce;yR(k,l,n,!1,q,[s[fc]],uE);Si(n.Cm)||(yR(k,l,n,!0,q,[s.Cm],uta),yR(k,l,n,!1,q,[s.border],lra))}a.g[p](b,f)}
function yR(a,b,c,d,e,f,g){var k=d?c.Cm:c.IB,l=c.id;(g=null!=g?uR([g,l]):null)&&(a.ed[g]=a.ed[g]||[]);for(l=0;l<k[J];++l){var n;n=k[l];var q=new YJ;gHa(q,n.lI,KG);for(var s=0;s<n.kI[J];s++)gHa(q,n.kI[s],Uya);n=q;if(0<n.Yc[J])for(q=0;q<f[J];++q)if(s=a.g.na(n,f[q],b))BR(a,s,[nf,uE,c.oO?Te:Oe,e?Te:Oe,c.id,d?Te:Oe]),g&&a.ed[g][C](s)}}
function gHa(a,b,c){b=b.j;var d=b[J];if(!(1>=d)){var e=c==KG?0:d-1,d=c==KG?d:-1;c=c==KG?1:-1;for(var f=e;f!=d;f+=c){var g=b[f][0],k=b[f][1];f==e?a[Yy](g,k):a.Z(g,k)}a[vy]()}}
function wR(a,b,c,d,e){var f=a.g;c=Yi(c);cj(c,function(a,b){return b[ly]-a[ly]});for(var g=0;g<c[J];++g){var k=c[g],l=f.za();BR(a,l,[sf,UF,Te,d?Te:Oe,k.bn,k.ri,k.Ty?Te:Oe]);f[p](b,l);a.Za.a3===Es?f.Pd(k[Rc],k.x,k.y,20,pD,pD,{Va:e,fontSize:k[ly],color:k.brush.gb(),opacity:k.brush.Oe,Tb:O,bold:!1,De:!1,Ic:!1},l):f.Zd(k.x,k.y,k[ly],k.brush,l);k=uR([UF,k.bn]);a.ed[k]=l.a()}}
function ZGa(a,b){var c=a.g,d=a.Fz.sz;Y(d,function(a){if(!Ri(b.sz,a)){a=uR([UF,a]);a=$k(this.ed[a]);for(var d=1;d<a[J];++d)c.Ff(a[d])}},a);Y(b.sz,function(a){if(!Ri(d,a)){a=uR([UF,a]);a=this.ed[a];var b=al(a).cloneNode(!0);c.Ri(b,bHa);a[p](b)}},a)}function VGa(a,b){if(b.gi){var c=b.gi,d=a.g,e=a.Yv;OGa(c.pW,d,e);PGa(c.qW,d,e);QGa(c.rW,d,e)}}
vR[K].w=function(){qt(this.pc);null!=this.kga&&this.g.Ff(this.kga);this.g[Wb]();Ws(this.Fz);this.Fz=null;this.mt&&this.g.Ff(this.mt.a());this.mt=null;this.Pv&&this.g.Ff(this.Pv.a());this.Pv=null;this.Xv&&this.g.Ff(this.Xv.a());this.Xv=null;this.Yv&&this.g.Ff(this.Yv.a());this.Yv=null;this.Jv&&this.g.Ff(this.Jv.a());this.Jv=null;vR.e.w[L](this)};vR[K].Fi=function(a){return W(a,this)};vR[K].qB=function(){return this.g.qB()};function CR(a){this.selection=new FN;this.Ft=this.sj=this.mG=this.af=null;if(null!=a){this[px][Yx](a[px]);var b=new jn([a]);this.af=An(b,mua);this.mG=An(b,nua);if(null!=nn(b,Lta)){a=tn(b,Pta);var c=b.R(Mta,null,on),d=tn(b,Nta),b=tn(b,Ota);null!=a&&null!=d&&null!=b&&null!=c&&(this.sj={ri:a,zF:c,origin:{x:d,y:b}})}}}CR[K].o=function(){var a=new CR;a.selection=this[px].o();a.af=Qj(this.af);a.sj=Qj(this.sj);a.Ft=Qj(this.Ft);return a};Za(CR[K],function(a){return Tm(this)==Tm(a)});function hHa(a,b){var c=new rl(-5,-5,-5,-5);this.tn=b.o().expand(c);c=2*zk(a)/5;this.y7=new xk(c,c)}hHa[K].j9=function(a,b,c){var d=b.FT,e=b.Zy.Ub();b=ma(a.lat);a=ma(a.lng);a<d.Og[1]?a+=360:a>d.Uh[1]&&(a-=360);c=zk(this.y7)/2/c/(e[A]/(d.Uh[0]-d.Og[0]));return{Uh:[b+c,a+c],Og:[b-c,a-c]}};function iHa(a,b){var c=Oi(a.Fy,function(a){return a.ri==b});if(!c)return!1;var d=a[Lq].Zy,c=uk(new sk(c.x,c.y),new sk(d[G]+d[r]/2,d.top+d[A]/2)),d=zk(d.Ub())/2;return c<0.9*d};function DR(a,b,c,d){this.qg=!a.qB()&&pn(b,Uwa);this.n=c;this.Xa=d;this.dC=this.wI=null}kp(DR[K],function(a,b){if(!this.qg)return!1;if(jHa(this,a)||kHa(this,a,b))return!0;var c=a.cu==uE;return a[Z].WH&&c?!0:!1});function kHa(a,b,c){if(b[H]!=mG)return!1;if(b[Z].jn){if(!b[Z].Ty)return!1;if(c&&iHa(c,b[Z].ri))return!0;lHa(a);a.wI=ca[Yp](a.Fi(function(){this.wI=null;this.n.Ft={bn:b[Z].bn,ri:b[Z].ri};WN(this.Xa,0)}),300);return!0}lHa(a);return!1}
function jHa(a,b){if(!a.n.Ft)return!1;switch(b[H]){case VF:case vE:var c;b[Z].WH?c=!1:(ER(a),c=!0);return c;case mG:case wE:if(b[Z].jn){c=b.cu==UF;var d=b.cu==SF;b[Z].WH&&!d?FR(a):c&&(b[Z].Ty?FR(a):ER(a))}else null===a.dC&&(c=b.cu==UF,(b[Z].WH||c)&&mHa(a));return!1;case xE:return b.cu==SF?(mHa(a),c=!0):c=!1,c;default:return!1}}function mHa(a){FR(a);a.dC=ca[Yp](a.Fi(function(){this.dC=null;ER(this)}),500)}function ER(a){a.n.Ft=null;WN(a.Xa,0)}function lHa(a){null!==a.wI&&(Ph[Gp](a.wI),a.wI=null)}
function FR(a){null!==a.dC&&(Ph[Gp](a.dC),a.dC=null)}DR[K].Fi=function(a){return W(a,this)};function nHa(a,b,c,d){this.P1=h.pow(a,2);this.O1=h.pow(b,2);this.qqa=b;this.Q1=(this.aq=c?new zm(d[Sz](c[y]),d[Sz](c.end)):null)?this.aq.end-this.aq[y]:null;this.dda=d}function oHa(a,b){var c=null;null!=b&&null!=a.dda&&(b=a.dda[Sz](b));if(null!=b&&null!=a.aq)0===a.Q1&&b===a.aq[y]?c=(a.O1+a.P1)/2:b<=a.aq[y]?c=a.P1:b>=a.aq.end&&(c=a.O1);else if(!a.Q1||null==b)return a.qqa;null==c&&(b=nj(b,a.aq[y],a.aq.end),c=pj(a.P1,a.O1,(b-a.aq[y])/a.Q1));return h[D](h[ud](c))}
function pHa(a,b){var c=vn(a,Qza),d=vn(a,Oza);if(c>d)throw m("sizeAxis.minSize ("+c+") must be at most sizeAxis.maxSize ("+d+Ge);var e=tn(a,Rza),f=tn(a,Pza);if(null!=e&&null!=f&&e>f)throw m("sizeAxis.minValue ("+e+") must be at most sizeAxis.maxValue ("+f+Ge);e=afa(b,e,f);f=XO(a,Nza,Sza);f=yEa(f,ja,[]);return new nHa(c,d,e,f)};function GR(a){this.b=a||{}}X(GR,kR);GR[K].uV=function(){return 1};GR[K].iD=function(a){return Gi(arguments,function(a){return{x:a[1],y:a[0]}})};function qHa(a,b,c,d,e,f){this.b=a;var g=HGa(a);this.mT=new rR[g[yd]](g);this.V=b;this.Oa=c;var k=Um(Jn(a,HC)),g=b-k,k=c-k,l=h[D]((b-g)/2),n=h[D]((c-k)/2);this.Gq=new vl(l,n,g,k);l=this.Gq;if(a.R(Uva,null,on))var q=l[r],n=l[A],s=this.mT.uV(),g=h.min(q,h[D](n*s)),k=h[D]((q-g)/2)+l[G],q=h.min(n,h[D](q/s)),l=h[D]((n-q)/2)+l.top,g=new vl(k,l,g,q);else g=l.o();this.Us=g;this.Wc=d;this.t=e;this.Za=f;this.v3=vn(a,HE,h[D](h.pow(2*(this.Gq[r]+this.Gq[A]),1/3)));this.ifa=Cn(a,[$wa,Zwa],tA);this.jfa=vn(a,axa,
1);this.lT=zn(a,GE);this.iq=rHa(this);this.rD=sHa(this);d=a.R(DF);this.Lfa=Vh(d)==$g;this.LL=Gn(a,ewa,FGa,ZC);this.I4=xn(a,Xva,1/3);this.KL=Gn(a,cwa,CGa,Jg);this.J4=Ln(a,jwa,{Va:this.lT,fontSize:this.v3});this.RT=An(a,bwa);this.Dfa=Cn(a,Vsa,O);this.YK=Cn(a,$sa,O);this.s3=tHa(this);this.kfa=uHa(this);d=Ln(a,GAa);e=Zea(d);this.kz=Gn(a,MI,Nn,zg);this.As=this.kz!=R;this.Kq={normal:d,bold:e};d=pn(a,CAa);this.qfa=pn(a,EAa);this.pfa=d?Xla:Wla;this.FU=pn(a,AAa);this.cga=10;this.sT=this.Oo=this.pz=null;this.Yy=
tA;this.YD=null;this.hfa=xn(a,cxa);this.ofa=new hHa(this.Us.Ub(),new rl(0,b,c,0))}function vHa(a,b){for(var c=0,d=a.pz[J];c<d;c++)for(var e=a.pz[c].qV.N,f=0,g=e[J];f<g;f++){var k=e[f];if(k.id==b)return k}return null}function wHa(a,b){var c=xHa(a,a.Dfa),d={};Y(b[ky],function(a){Y(a.N,function(a){d[a.id]={ce:c}},this)},a);return d}
function yHa(a,b){for(var c=new pR,d=1;10>d;d++){var e=(a.Uh[1]-a.Og[1])/10*d+a.Og[1],f=(a.Uh[0]-a.Og[0])/10*d+a.Og[0],e=b.iD([f,a.Og[1]],[f,a.Uh[1]],[a.Og[0],e],[a.Uh[0],e]);c.aqa[Mc](c,e)}d=c[$x](lJ);c=c[$x](Jh);return{Uh:[c.max,d.max],Og:[c.min,d.min]}}T=qHa[K];
T.i5=function(a,b,c,d){for(var e=zHa(this,Oda(Aj(d.IB),Aj(d.Cm)));e[1]>a.Uh[1];)e[1]-=360;for(;e[1]<a.Og[1];)e[1]+=360;return{id:d.id,center:this.lX(a,b,c,e),IB:Gi(d.IB,W(this.sca,this,a,b,c)),Cm:Gi(d.Cm,W(this.sca,this,a,b,c)),oO:d.id!=Ppa}};function zHa(a,b){var c=0,d=0,e=0;Bj(b,function(a){Y(a.lI,function(a){c+=a[0];d+=oj(a[1],360);e++},this)},a);return[c/e,d/e]}T.sca=function(a,b,c,d){return{lI:this.tda(a,b,c,d.lI),kI:Gi(d.kI,W(this.tda,this,a,b,c))}};
T.tda=function(a,b,c,d){return{j:Gi(d,W(this.lX,this,a,b,c))}};T.lX=function(a,b,c,d){var e=a.Og;a=a.Uh;var f=b[r],g=b[A],k=b[G];b=b.top;c=c.iD(d)[0];return[k+f*(c.x-e[1])/(a[1]-e[1]),b+g*(1-(c.y-e[0])/(a[0]-e[0]))]};function AHa(a,b){var c=[];a.Oo=[];for(var d=Gi(a.pz,function(a){return a.qV}),e=0;e<b[J];++e){var f=b[e],g={location:f,PV:{}};if(null!=f){f=BHa(a,e,f,d);Zi(c,f);for(var k=0;k<f[J];k++){var l=f[k];g.PV[l.bn]=l}}a.Oo[C](g)}CHa(c);return c}
function CHa(a){for(var b=0;b<a[J];b++){for(var c=a[b],d=new sk(c.x,c.y),e=0,f=0;f<a[J];f++)if(b!=f){var g=a[f],k=uk(d,new sk(g.x,g.y));k<c[ly]+g[ly]&&(e+=c[ly]+g[ly]-k)}c.Ty=e>c[ly]}}
function BHa(a,b,c,d){var e=a.kfa(b),f=a.s3(b);if(null==f)return[];var f=new Rm({stroke:a.ifa,qa:a.jfa,fill:f,ae:a.hfa}),g=ma(c.lat),k=[];c=ma(c.lng);c=[c,c+360,c-360];for(var l=0;l<d[J];++l){var n=d[l],q=a.YD[l],s=n.FT;if(!(g<s.Og[0]||g>s.Uh[0])){for(var u=0;u<c[J];++u){var w=c[u];if(!(w<s.Og[1]||w>s.Uh[1])){var w=a.lX(n.bt,n.Zy,q,[g,w]),z=String(b+Le+n.id+Le+u),B=UF;null!=a.Za.RG&&0<=a.Za.RG?B=a.t.Aa(b,a.Za.RG):null!=a.Za.qG&&0<=a.Za.qG?B=a.t.Aa(b,a.Za.qG):null!=a.Za.pG&&0<=a.Za.pG?B=a.t.Aa(b,a.Za.pG):
null!=a.Za.FA&&null!=a.Za.HA&&0<=a.Za.FA&&0<=a.Za.HA&&(B=DHa(a.t[I](b,a.Za.FA),a.t[I](b,a.Za.HA)));k[C]({bn:z,label:B,ri:b,x:w[0],y:w[1],size:e,brush:f,Ty:!1})}}if(0<k[J])break}}return k}
function EHa(a,b,c){var d=a.Oo,e=d[c],f=e.PV[b];if(!f.Ty)return null;var g=b[pc](Le)[1],k=a.pz[g],l=a.YD[g],n=sn(a.b,Vwa),q=a.ofa,e=q.j9(e[tc],k.qV,n),f=new sk(f.x,f.y),n=q.tn,q=q.y7,s=f.x;s+q[r]>n[Zc]&&(s=f.x-q[r]);var u=f.y-q[A];u<n.top&&(u=f.y);q=new vl(s,u,q[r],q[A]);l=yHa(e,l);c={id:g+Le+c+uma,bt:l,FT:e,Zy:q,N:Gi(k.N,W(a.i5,a,e,q,new GR))};g=[];for(k=0;k<d[J];k++)l=d[k][tc],null!=l&&Zi(g,BHa(a,k,l,[c]));return{bn:b,A5:f,view:c,Fy:g}}
function FHa(a,b){if(!a.Lfa||null==a.iq||!a.iq.mk)return null;var c=a.J4[uc],d=a.Gq[r],e=a.Gq[A],f={top:0,left:0,width:a.KL==Jg?d*a.I4:e*a.I4,height:1.5*c,orientation:a.KL,X:a.J4,J6:RC,K6:a.RT};f.top=a.LL==PI||a.LL==OAa?3*c:a.KL==Eh?e-c-f[r]:e-c-f[A];Ya(f,a.LL==PI||a.LL==ZC?0.5*c:a.KL==Eh?d-c-f[A]:d-c-f[r]);Ya(f,f[G]+a.Gq[G]);f.top+=a.Gq.top;return jR(a.iq,f,b,a.Wc)}function GHa(a,b){for(var c=null,d=0;d<a.t.M();++d)var e=a.t[I](d,b),c=Nm(c,e);return c}
function tHa(a){var b=a.Za.xt;return null!=b?function(a){a=this.t[I](a,b);return null!=a?NQ(this.iq,a):this.YK}:function(){return this.YK}}function uHa(a){var b=a.Za.YA;return null!=b?function(a){a=this.t[I](a,b);return oHa(this.rD,a)}:function(){return this.cga}}function rHa(a){var b=a.Za.xt;if(null==b)return null;b=GHa(a,b);return TFa(a.b,b)}function sHa(a){var b=a.Za.YA,b=null!=b?GHa(a,b):null;return pHa(a.b,b)}
function HHa(a,b){var c={nz:[],sz:[]};null!=b.af&&(c.nz=[b.af]);null!=b.mG&&(c.sz=[b.mG]);c.Aq=[];a.As&&(a.kz===kg||a.kz===mh)&&Y(HN(b[px]),function(a){var b=IHa(this,a,!1),d=this.Wc,e=this.Kq.normal[uc],f=new rl(0,this.V-1,this.Oa-1,0),s=this.Oo[a];a=(a=this.sT[a])&&vHa(this,a);var u=null,w=null;a?(c.nz[C](a.id),u=w=new sk(a[nx][0],a[nx][1]),c.Aq[C](EN(b,d,!1,w,f,u,void 0,this.FU))):s&&Dj(s.PV,function(a,g){c.sz[C](g);c.Aq[C](EN(b,d,!1,new sk(a.x-e,a.y-e),f,new sk(a.x,a.y),void 0,this.FU))},this)},
a);if(null!=b.sj){if(a.As&&(a.kz===kg||a.kz===zg)){var d=IHa(a,b.sj.ri,b.sj.zF),e=a.Kq.normal[uc],f=new sk(b.sj[gx].x,b.sj[gx].y);c.Aq[C](EN(d,a.Wc,!1,new sk(f.x-e,f.y-e),new rl(0,a.V-1,a.Oa-1,0),f,void 0,a.FU))}null!=a.Za.xt&&(d={value:a.t[I](b.sj.ri,a.Za.xt)},c.gi=FHa(a,[d]))}null!=b.Ft&&(c.UD=EHa(a,b.Ft.bn,b.Ft.ri));return c}function JHa(a,b,c){b=0<=a?c:b;a=h.abs(a);c=h[t](a);var d=60*(a-c);a=h[t](d);d=h[D](60*(d-a));return c+FBa+a+Ee+d+oe+b}
function DHa(a,b){return JHa(a,Cf,xf)+ne+JHa(b,Qf,mf)}
function IHa(a,b,c){var d=a.Za,e=a.t,f={entries:[]},g;if(null!=d.RG)g=e.Aa(b,d.RG);else switch(d.xX){case Yr:c=e[I](b,d.FA);g=e[I](b,d.HA);g=DHa(c,g);break;case xs:g=e.Aa(b,d.pG);c&&(g=KQ(a.pfa,g));break;case Br:g=e.Aa(b,d.qG);break;default:g=O}a.qfa&&(c=CN(g,a.Kq[Ed]),f[Ez][C](c));if(null!=d.rY)if(c=e.Aa(b,d.rY),e.Li(d.rY,Mg))f[Ez][C](CN(c,a.Kq.normal,void 0,void 0,void 0,void 0,void 0,!0));else for(b=c[pc](me),d=0;d<b[J];d++)c=CN(b[d],a.Kq.normal),f[Ez][C](c);else null!=d.xt&&(g=e.cb(d.xt),c=e.Aa(b,
d.xt),c=CN(c,a.Kq[Ed],g,a.Kq.normal),f[Ez][C](c)),null!=d.YA&&d.YA!=d.xt&&(g=e.cb(d.YA),c=e.Aa(b,d.YA),c=CN(c,a.Kq[Ed],g,a.Kq.normal),f[Ez][C](c));return f}T.Fi=function(a){return W(a,this)};function xHa(a,b){var c=b===R?[255,255,255]:rm(b),c=pm(wm(c,0.1));return{fill:new Rm({stroke:c,fill:b}),Cm:new Rm({stroke:R,pattern:new Qm(pH,b,b==a.Yy?te:a.Yy)}),border:new Rm({stroke:c})}};function HR(a,b,c,d,e,f,g,k,l){this.Pk=a;this.b=b;this.V=c;this.Oa=d;this.Za=f;this.n=g;this.dm=null;this.vU=!1;this.uha=k;this.mn=l;this.fT=!1;this.kT=null;this.l4=!1;this.Xa=new VN(this.Fi(this.wq));this.kA=new sO(3);this.WM=[!1,!1,!1];this.Oy=new qHa(this.b,this.V,this.Oa,this.Pk.vf,e,this.Za);this.a5=new DR(a,b,g,this.Xa);this.c6=pn(b,Rta,f.a3==ys);this.XV()}X(HR,Us);T=HR[K];
T.g1=function(a,b){var c;c=this.Oy;var d=c.b;c.pz=[];c.YD=[];for(var e=[],f=0,g=a[ky][J];f<g;f++){var k=a[ky][f],l=c.mT.Vc();l.boundingBox={lo:k.bt.Og,hi:k.bt.Uh};l=new c.mT[rc](l);c.YD[C](l);var l=c,n=k,q=f,s=new vl(n.oga*l.Us[r]+l.Us[G],n.pga*l.Us[A]+l.Us.top,n[Fy]*l.Us[r],n[Fy]*l.Us[A]),u=l.YD[q],w=yHa(n.bt,u),l={id:String(q),bt:w,FT:n.bt,Zy:s,N:Gi(n.N,W(l.i5,l,w,s,u))};e[C](l);c.pz[C]({N:k.N,qV:l})}c={width:c.V,height:c.Oa,bfa:c.Us,Gy:Gn(d,eza,ofa,oh),tta:c.kz,nD:Jn(d,HC),T2:En(d,Yua),title:{text:zn(d,
HI),X:Ln(d,JI,{Va:c.lT,fontSize:c.v3}),F:[],align:nI,vb:O},views:e,hz:wHa(c,a),nz:[],sz:[],Fy:[],gi:null,UD:null,Kj:c.lT};this.iE(0,c);this.fT=!0;this.mn(Xwa,b);null!=this.kT?this.kT():this.wq()};
function KHa(a,b,c,d,e,f){a.vU=!1;var g=a.Fi(function(){this.l4=d;if(null!=e){this.dm=null;var a=this.Oy;a.t=e;a.iq=rHa(a);a.rD=sHa(a)}null!=f&&(this.n=f,this.a5.n=f);a=this.Oy;a.sT=[];for(var g={},n=0;n<a.t.M();++n){var q=b[n];a.sT[C](q);if(null!=q){var s=a.s3(n);null!=s&&(g[q]={ri:n,ce:xHa(a,s)})}}a={hz:g,Fy:AHa(a,c),gi:FHa(a,[])};this.iE(1,a);this.wq()});a.fT?g():a.kT=g}Zv(T,function(a){this.n[px][Yx](a);WN(this.Xa,1)});Tw(T,function(){return this.n[px][wz]()});
T.wq=function(){if(this.fT){if(null==this.dm||!this.dm[cz](this.n)){var a=HHa(this.Oy,this.n);this.iE(2,a)}a=this.kA[My]();if(this.WM[0])RGa(this.Pk,a);else if(this.WM[1]){var b=this.Pk;dHa(b,a);aHa(b,a);xR(b,a,!0)}else xR(this.Pk,a);this.WM=[!1,!1,!1];this.dm=this.n.o();!this.vU&&this.l4&&(this.uha(),this.vU=!0)}};
T.$ma=function(a){if(!IR(this,a)&&this.c6){var b=a[Z].Ot;null!==b&&(a[Z].jn?(this.n.af=b,b=LHa(this,b),this.n.sj=null!=b?{ri:b,zF:a[Z].zF,origin:{x:a[Z].ub.x,y:a[Z].ub.y}}:null):(this.n.af=null,this.n.sj=null),WN(this.Xa,50))}};T.cna=function(a){IR(this,a)||(a[Z].jn?(this.n.mG=a[Z].bn,this.n.sj={ri:a[Z].ri,zF:!1,origin:{x:a[Z].ub.x,y:a[Z].ub.y}}):(this.n.mG=null,this.n.sj=null),WN(this.Xa,50))};T.ana=function(a){IR(this,a)||MHa(this,a)};T.dna=function(a){MHa(this,a)};
function MHa(a,b){null!=a.n.sj&&(a.n.sj.origin={x:b[Z].ub.x,y:b[Z].ub.y},WN(a.Xa,3))}T.Zma=function(a){if(!IR(this,a)&&this.c6){var b=a[Z].Ot;null===b||this.mn(pya,{region:b});b=LHa(this,b);this.Dv(a,b)}};T.bna=function(a){IR(this,a)||this.Dv(a,a[Z].ri)};T.Dv=function(a,b){var c=this.kA[My]().Gy==oh;if(null!=b)MN(this.n[px],b,c),this.mn(As,{});else this.n[px][Wb]();this.Xa&&WN(this.Xa,50)};function IR(a,b){var c=a.kA[My]();return a.a5[Pp](b,c?c.UD:null)}
T.XV=function(){this.Pk.l(vE,this.Fi(this.Zma));this.Pk.l(wE,this.Fi(this.$ma));this.Pk.l(xE,this.Fi(this.ana));this.Pk.l(VF,this.Fi(this.bna));this.Pk.l(mG,this.Fi(this.cna));this.Pk.l(bxa,this.Fi(this.dna))};function LHa(a,b){if(null===b)return null;var c=a.kA[My]();return c.hz[b]?c.hz[b].ri:null}T.iE=function(a,b){tO(this.kA,a,b);this.WM[a]=!0};T.w=function(){Ws(this.Xa);this.Xa=null;Ws(this.Pk);this.Pk=null;Ws(this.Oy);this.Oy=null;HR.e.w[L](this)};T.Fi=function(a){return W(a,this)};var NHa={COM:{COUNTRIES:["002","005","009","011","013","014","015","017","018","019","021","029","030","034","035","039","053","054","057","061","142","143","145","150","151","154","155","AD","AE","AF","AG","AI","AL","AM","AO","AR","AS",lB,"AU","AW","AX","AZ","BA","BB","BD","BE","BF","BG","BH","BI","BJ","BL","BM","BN","BO","BQ",ef,"BS","BT","BV","BW","BY","BZ","CA","CC","CD","CF","CG","CH","CI","CK","CL","CM","CN","CO","CR","CU","CV","CW","CX","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG",
"EH","ER","ES","ET","FI","FJ","FK","FM","FO","FR","GA","GB","GD","GE","GF","GG","GH","GI","GL","GM","GN","GP","GQ","GR","GS","GT","GU","GW","GY","HK","HM","HN",pf,"HT","HU","ID","IE","IL","IM","IN","IO","IQ","IR","IS","IT","JE","JM","JO","JP","KE","KG","KH","KI","KM","KN","KP","KR","KW","KY","KZ","LA","LB","LC",OB,"LK","LR","LS","LT","LU","LV","LY","MA","MC","MD","ME","MF","MG","MH","MK","ML","MM","MN","MO","MP","MQ","MR","MS","MT","MU","MV","MW","MX","MY","MZ","NA","NC","NE","NF","NG","NI","NL",
"NO","NP","NR","NU","NZ","OM","PA","PE","PF","PG","PH","PK","PL","PM","PN","PR","PS","PT","PW","PY","QA","RE","RO","RS","RU","RW","SA","SB","SC","SD","SE","SG","SH","SI","SJ","SK","SL","SM","SN","SO","SR","SS","ST","SV","SX","SY","SZ","TC",bC,"TF","TG","TH","TJ","TK",Nf,"TM","TN","TO",Of,"TT","TV","TW","TZ","UA","UG","UM",eC,"UY","UZ","VA","VC","VE","VG","VI","VN","VU","WF","WS","XK","YE","YT","ZA","ZM","ZW",kJ],METROS:[eC,"US-500","US-501","US-502","US-503","US-504","US-505","US-506","US-507","US-508",
"US-509","US-510","US-511","US-512","US-513","US-514","US-515","US-516","US-517","US-518","US-519","US-520","US-521","US-522","US-523","US-524","US-525","US-526","US-527","US-528","US-529","US-530","US-531","US-532","US-533","US-534","US-535","US-536","US-537","US-538","US-539","US-540","US-541","US-542","US-543","US-544","US-545","US-546","US-547","US-548","US-549","US-550","US-551","US-552","US-553","US-554","US-555","US-556","US-557","US-558","US-559","US-560","US-561","US-563","US-564","US-565",
"US-566","US-567","US-569","US-570","US-571","US-573","US-574","US-575","US-576","US-577","US-581","US-582","US-583","US-584","US-588","US-592","US-596","US-597","US-598","US-600","US-602","US-603","US-604","US-605","US-606","US-609","US-610","US-611","US-612","US-613","US-616","US-617","US-618","US-619","US-622","US-623","US-624","US-625","US-626","US-627","US-628","US-630","US-631","US-632","US-633","US-634","US-635","US-636","US-637","US-638","US-639","US-640","US-641","US-642","US-643","US-644",
"US-647","US-648","US-649","US-650","US-651","US-652","US-656","US-657","US-658","US-659","US-661","US-662","US-669","US-670","US-671","US-673","US-675","US-676","US-678","US-679","US-682","US-686","US-687","US-691","US-692","US-693","US-698","US-702","US-705","US-709","US-710","US-711","US-716","US-717","US-718","US-722","US-724","US-725","US-734","US-736","US-737","US-740","US-743","US-744","US-745","US-746","US-747","US-749","US-751","US-752","US-753","US-754","US-755","US-756","US-757","US-758",
"US-759","US-760","US-762","US-764","US-765","US-766","US-767","US-770","US-771","US-773","US-789","US-790","US-798","US-800","US-801","US-802","US-803","US-804","US-807","US-810","US-811","US-813","US-819","US-820","US-821","US-825","US-828","US-839","US-855","US-862","US-866","US-868","US-881","US-AK","US-AL","US-AR","US-AZ","US-CA","US-CO","US-CT","US-DC","US-DE","US-FL","US-GA","US-HI","US-IA","US-ID","US-IL","US-IN","US-KS","US-KY","US-LA","US-MA","US-MD","US-ME","US-MI","US-MN","US-MO","US-MS",
"US-MT","US-NC","US-ND","US-NE","US-NH","US-NJ","US-NM","US-NV","US-NY","US-OH","US-OK","US-OR","US-PA","US-RI","US-SC","US-SD","US-TN","US-TX","US-UT","US-VA","US-VT","US-WA","US-WI","US-WV","US-WY"],PROVINCES:["AD","AE","AF","AG","AL","AM","AO","AR",lB,"AU","AZ","BA","BB","BD","BE","BF","BG","BH","BI","BJ","BN","BO","BQ",ef,"BS","BT","BW","BY","BZ","CA","CD","CF","CG","CH","CI","CL","CM","CN","CO","CR","CU","CV","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG","EH","ER","ES","ET","FI","FJ",
"FM","FR","GA","GB","GD","GE","GH","GL","GM","GN","GQ","GR","GT","GW","GY","HN",pf,"HT","HU","ID","IE","IL","IN","IQ","IR","IS","IT","JM","JO","JP","KE","KG","KH","KI","KM","KN","KP","KR","KW","KZ","LA","LB","LC",OB,"LK","LR","LS","LT","LU","LV","LY","MA","MD","ME","MG","MH","MK","ML","MM","MN","MR","MU","MV","MW","MX","MY","MZ","NA","NE","NG","NI","NL","NO","NP","NR","NZ","OM","PA","PE","PG","PH","PK","PL","PT","PW","PY","QA","RO","RS","RU","RW","SA","SB","SC","SD","SE","SH","SI","SK","SL","SM",
"SN","SO","SR","SS","ST","SV","SY","SZ",bC,"TG","TH","TJ",Nf,"TM","TN","TO",Of,"TT","TV","TZ","UA","UG",eC,"US-AK","US-AL","US-AR","US-AZ","US-CA","US-CO","US-CT","US-DC","US-DE","US-FL","US-GA","US-HI","US-IA","US-ID","US-IL","US-IN","US-KS","US-KY","US-LA","US-MA","US-MD","US-ME","US-MI","US-MN","US-MO","US-MS","US-MT","US-NC","US-ND","US-NE","US-NH","US-NJ","US-NM","US-NV","US-NY","US-OH","US-OK","US-OR","US-PA","US-RI","US-SC","US-SD","US-TN","US-TX","US-UT","US-VA","US-VT","US-WA","US-WI","US-WV",
"US-WY","UY","UZ","VC","VE","VN","VU","YE","ZA","ZM","ZW"],REGIONS:["002","009","019","142","150",kJ],SUBREGIONS:["002","005","009","011","013","014","015","017","018","019","021","029","030","034","035","039","053","054","057","061","142","143","145","150","151","154","155",kJ]},IN:{COUNTRIES:["002","009","019","030","034","035","142","143","145","151","AF","BD","BT","CN","IN","MM","NP","PK","RU","TJ","UZ",kJ],PROVINCES:"AF BD BT CN IN MM NP PK RU TJ UZ".split(" "),REGIONS:["002","009","019","142",
kJ],SUBREGIONS:["002","009","019","030","034","035","142","143","145","151",kJ]}};var JR={},KR={},LR=null,OHa=MQ(Rr,Ue),MR=OHa;function PHa(a,b,c){MR=a?a+Tq:OHa;KR={};NR=null;a?aR(eR(MR+Kva,Wua),function(a){OR=a;b()},function(){c()}):(OR=NHa,b())}
function QHa(a,b){if(null==b)throw m("Callback is null or undefined");var c=RHa(a);if(Qh(KR[c])){var d=W(b,null,KR[c]);Ov(d,0)}else if(Qh(JR[c]))JR[c][C](b);else JR[c]=[b],d=MR+KQ(Ywa,c),aR(eR(d,Uua+c[vb](Le,ve)),function(a){var b={views:Gi(a[ky],SHa)};KR[c]=b;Y(JR[c],function(a){a(b)});delete JR[c]},function(){Y(JR[c],function(a){a(null)});delete JR[c]})}function RHa(a){var b=O;a[$y]!=sB&&(b=a[$y]+iC);return b+a.Ju+iC+THa(a.Rm)}
function THa(a){null!=LR||(LR={continents:epa,subcontinents:jpa,countries:tB,provinces:Xoa,metros:Qoa});return LR[a]}var OR=NHa;function UHa(a){var b=a[$y],c=a.Ju;a=THa(a.Rm);if(b=OR[b])if(b=b[a])return 0<=aj(b,c);return!1}var NR=null;function VHa(a){null!=NR?a(NR):aR(eR(MR+Jva,Vua),function(b){NR=b=Gi(b,WHa);a(b)},function(){a(null)})}
function SHa(a){for(var b=Gi(a.features,XHa),c={},d=[],e=0;e<b[J];e++){var f=b[e],g=f.id;ki(g,Opa)?c[g]=f:d[C](f)}for(e=0;e<d[J];e++)f=d[e],b=c[Opa+f.id],f.Cm=b?b.IB:[];if(c=c.__DISPUTED__All)c.Cm=c.IB,d[C](c);return{N:d,bt:YHa(a.boundingBox),oga:a.xoffset,pga:a.yoffset,scale:a[Fy]}}function XHa(a){return{id:a.id,IB:Gi(a.polygons,ZHa),Cm:[]}}function ZHa(a){return Zh(a)?{lI:PR(a),kI:[]}:{lI:PR(a.shell),kI:Gi(a.holes,PR)}}function PR(a){return Gi(a,function(a){return[oR(a[0]),ma(a[1])]})}
function YHa(a){return{Uh:[oR(a.hi[0]),ma(a.hi[1])],Og:[oR(a.lo[0]),ma(a.lo[1])]}}function WHa(a){return{Ju:a.region,Rm:a.resolution,domain:a[$y],Qna:Gi(a.boundingBoxes,YHa)}};function $Ha(a,b,c,d){var e=zn(c,zH);if(e!=eg)d(QR(e,c));else if(b.xX!=Yr)d(QR(kJ,c));else{for(var f=Hn(c,DH,DGa),g=An(c,Lr),k=[],e=0;e<a.M();++e)k[C]({lat:a[I](e,b.FA),lng:a[I](e,b.HA)});VHa(function(a){if(a){t:{for(var b=0;b<a[J];++b){var e=a[b];if(null==f||e.Rm==f)if(null==g||e[$y]==g){for(var s=!0,u=0;u<k[J];++u){for(var w=k[u],z=!1,B=e.Qna,F=0;F<B[J];++F)if(aIa(w,B[F])){z=!0;break}if(!z){s=!1;break}}if(s){a={Ju:e.Ju,Rm:e.Rm,domain:e[$y]};break t}}}a=null}null!=a?d(a):d(QR(kJ,c))}else d(null)})}}
function QR(a,b){var c=Gn(b,DH,DGa,PD),d=zn(b,Lr),c={Ju:a,Rm:c,domain:d};return UHa(c)||c[$y]!=sB&&(c.domain=sB,UHa(c))?c:null}function aIa(a,b){return a.lat>b.Og[0]&&a.lat<b.Uh[0]&&Mi([-360,0,360],function(c){return a.lng+c>b.Og[1]&&a.lng+c<b.Uh[1]})};function RR(a){pu[L](this,a);this.ul=this.Da=null;this.Gx=new sR(this.tu);this.d_=O;this.Ma=this.vj=null}X(RR,pu);T=RR[K];T.Ym=function(a,b,c,d){Xn(NA);Ss.oc(this.lb);this.vj=a;Ws(this.Gx);this.Gx=new sR(this.tu);a=c||{};a=lo(io(a));var e=new jn([a,IGa]),f=new CR(d);this.Ma=this.Ht(this.lb,e);d=Gn(e,sta,Xja,eg);var g=(new Ou).xd(b,d,this.tu);if(null!=g){var k=Tm({options:a,format:g,size:this.Ma});d=this.vj(function(a){if(null==a)throw m(gpa);bIa(this,b,g,e,k,f,a)},this);$Ha(b,g,e,d)}};
T.Jj=function(){var a=Ek(this.lb)[Qb](Q),b=xK(a,this.Ma),c=new sK(a),d=new nK(a,b),b=this.ul,c=new vR(c,d,b.Pk.Za),b=b.kA[My]();RGa(c,b);dHa(c,b);aHa(c,b);xR(c,b,!0);xR(c,b);return a[Xb][0].toDataURL(Gva)};T.Ht=function(a,b){var c=On(a,b,-1),d=Pn(a,b,-1);-1==c&&-1==d?(c=556,d=347):-1==c?c=h[D](556*d/347):-1==d&&(d=h[D](347*c/556));return new xk(c,d)};
function bIa(a,b,c,d,e,f,g){var k=pn(d,Fza);if(a.d_==e)cIa(a,!1,d,b,c,g,k,f,e);else{if(null!=a.Da)a.Da[Pz](a.Ma,a.vj);else{var l=pn(d,IE);a.Da=new vK(a.lb,a.Ma,a.vj,l)}a.Da.Io(W(function(){var a=this.Da.eb(),l=this.Da.Av(),a=new vR(l,a,c);null!=this.ul&&Ws(this.ul);l=this.Ma;Ws(this.ul);this.ul=new HR(a,d,l[r],l[A],b,c,f,W(this.kma,this),W(this.U$,this));cIa(this,!0,d,b,c,g,k,f,e)},a),a.vj)}}
function cIa(a,b,c,d,e,f,g,k,l){c=Gn(c,Dua,GGa,zH);var n=c===$C||c===kg,q=a.vj(function(a,b,c){KHa(this.ul,a,b,c,d,k)},a),s=W(function(){JGa(this.Gx,d,e,f,g,q)},a);a.Gx.oJ=c;b&&(a.Gx.wC=null,QHa(f,a.vj(function(a){null!=a?(this.ul.g1(a,f),n&&(this.Gx.g1(a),s()),this.d_=l):this.tu.td(gpa)},a)));n||(a.Gx.wC=null,s())}Zv(T,function(a){null!=this.ul?this.ul[Yx](a):this.tu.td(xpa)});Tw(T,function(){if(null!=this.ul)return this.ul[wz]();this.tu.td(xpa);return[]});T.kma=function(){this.U$(ws,{})};
T.U$=function(a,b){hu(this,a,b)};T.Wg=function(){this.d_=O;Ws(this.ul);this.ul=null;Ws(this.Da);this.Da=null};V("google.visualization.GeoChart",RR,void 0);Ep(RR[K],RR[K][Nq]);RR[K].getImageURI=RR[K].Jj;Zv(RR[K],RR[K][Yx]);Tw(RR[K],RR[K][wz]);RR[K].clearChart=RR[K].Yf;V("google.visualization.GeoChart.mapExists",function(a){null!=a||(a={});a=new jn([a,IGa]);var b=zn(a,zH);return null!=QR(b,a)},void 0);V("google.visualization.GeoChart.setMapsSource",function(a,b,c){PHa(a,function(){b&&b()},function(){c&&c()})},void 0);function SR(a){pu[L](this,a);this.$C=new BK(800,600,xI,fa[Pb](Ula))}X(SR,nO);T=SR[K];T.Ym=function(a,b,c){Ss.oc(this.lb);c=new jn([c||{},this.uj()||{}]);var d=On(this.lb,c),e=Pn(this.lb,c);Ov(W(this.xn,this,b,c,new xk(d,e),a),0)};T.xn=function(a,b,c,d){BK.Ac=BK.X3(this.$C);a=this.ps(a,b,BK.Ac,c).Zh();c=XDa(this.$C);this.Bd=new mO(this,c,null,this,d);b=new gO(nn(b,oI));this.Bd[Nq](a,b)};T.Wg=function(){SR.e.Wg[L](this)};T.Hx=function(a,b,c,d){a=new JQ(this,a,0,c,d);(b=this.Bda())&&a.MI(b);return a};
T.Bda=function(){};function TR(a,b,c){this.rg=a;this.Bma=b;this.Pi={};this.Epa=!1;this.eD=null;this.Cma=c;a===aH&&(this.eD=new BK.Gg.rU({fill:R,stroke:aA}))}T=TR[K];vw(T,function(){this.Epa&&(this.Pi=da.getPrototypeOf(this.Pi))});T.tm=function(){if(null==this.eD){var a=dIa[this.rg];if(!a)throw m("No draw routine for "+this.rg+Me);this.eD=a[L](null,this.Pi)}return this.eD};function UR(a,b){a.Pi.x=b;return a}function VR(a,b){a.Pi.y=b;return a}T.sl=function(a){pa(this.Pi,a);return this};
T.Ex=function(a){Sa(this.Pi,a);return this};T.$q=function(a){Bw(this.Pi,a);return this};Yv(T,function(a){Jw(this.Pi,a);return this});function WR(a,b,c,d){var e=d||{};nn(b,c,null,function(b){var c=Bn(b[fc]||e[fc])||R;a.pe(c);c=wn(b.fillOpacity);null!=c&&a.dh(c);c=Bn(b[Yb]||e[Yb]);null!=c&&a.dd(c);b=un(b.strokeWidth);null!=b&&a.yk(b);return null})}T.dd=function(a){za(this.Pi,a);return this};T.yk=function(a){this.Pi.qa=a;return this};T.pe=function(a){Ca(this.Pi,a);return this};
T.dh=function(a){this.Pi.ae=a;return this};Gw(T,function(a,b){this.eD[Yy](a,b);return this});T.Z=function(a,b){this.eD.line(a,b);return this};var dIa={circle:function(a){return new BK.Gg[Cz](a[bz],a.x,a.y,{fill:a[fc]})},line:function(a){return new BK.Gg.ot(a.x,a.y,a.hb,a.kb,a)},rect:function(a){return new BK.Gg.Xj(a.x,a.y,a[r],a[A],a)},text:function(a){return new BK.Gg.Nv(a.x,a.y,a[cd],a)}};function XR(a){this.ng=[];this.da=a;this.c1=0}XR[K].Ub=function(){return this.da};XR[K].NU=function(){return this.ng};XR[K].Z=function(a,b,c,d,e,f){a=VR(UR(new TR(JF,a||YR(this),b||GC),c),d);a.Pi.hb=e;a.Pi.kb=f;this.ng[C](a);return a};function ZR(a,b,c,d,e,f,g){b=VR(UR(new TR(vH,b||YR(a),c||GC),d),e).sl(f).Ex(g);a.ng[C](b);return b}function eIa(a,b,c,d,e,f,g){b=VR(UR((new TR(Es,b||YR(a),c||GC)).$q(d),e),f).sl(g);a.ng[C](b);return b}
function YR(a){var b=new aO(oB);cO(b,ZB,Qpa+a.c1);a.c1+=1;return b};function fIa(){this.cs=new Uj;this.ga=this.da=this.JQ=null}T=fIa[K];T.Pm=function(){};T.IH=function(a){this.ga=a;this.Je(a.Ub())};T.Je=function(a){this.da=a};T.Ub=function(){return this.da};Ep(T,function(a){var b=new Uj;Y(this.ga.ng,function(c){var d=c.Bma.Hn();this.cs.$e(d)?c.tm=this.cs.get(d).tm:a.hu[c.Cma].add(c.tm());b.set(d,c)},this);Bj(this.cs.fs(!0),function(a){b.$e(a)},this);this.cs=b;OFa(a)});function $R(a){SR[L](this,a)}X($R,SR);$R[K].yu=function(a){var b=new fIa;b.IH(a);return b};function aS(a,b){return bS(a,b,0)}function bS(a,b,c){for(var d=new Date(a),e=!1,f=b[J],g=[h[t],h[xb]][c],k=0;k<f;++k){var l=a[$H+cS[k]],n=a[NE+cS[k]][Mc](a),q=b[k],s=gIa[k];if(0==q)e=e||0!=n&&0!=c,l[Mc](d,[s]);else{e?l[Mc](d,[s+q*(1+h[t]((n-s)/q))]):l[Mc](d,[s+q*g((n-s)/q)]);break}}return d}function hIa(a,b){var c=h[D],d=Yi(a),e;for(e=0;e<d[J]&&0==b[e];++e)d[e]=0;if(0==e)return d[0]=c(a[0]/b[0])*b[0],d;var f=0;a[e-1]>=iIa[e-1]?f=0.7:0<a[e-1]&&(f=0.1);d[e]=c((a[e]+f)/b[e])*b[e];return d}
function jIa(a){a=aS(a,[0,0,0,0,1]);return a=kIa(a,[0,0,0,0,(7+a[lc]()-1)%7],-1)}function dS(a,b,c){var d=Gi(b,function(a){return[h.log(eS(a))]});if(!c)return a=ZO(h.log(a),d),b[a];c=EEa(h.log(a),d,c);a=c[0];return a<=d[J]-1?b[a]:hIa(lIa(h.exp(c[1])),Ai(b))}
function kIa(a,b,c){var d=new Date(a[bc]()),e;t:{for(e=0;e<b[J];++e)if(0!=b[e]){e=!1;break t}e=!0}if(e)return d;for(e=0;e<b[J];++e)if(0!=b[e]){var f=cS[e],g=d[$H+f],f=d[NE+f][Mc](d,[]);g[Mc](d,[f+c*b[e]])}if(0<c&&d<=a)throw"Error adding duration to date";if(0>c&&d>=a)throw"Error subtracting duration from date";return d}function fS(a,b,c,d){this.gda=a[bc]();this.Oz=b;this.tqa=d;this.V1=a[NE+cS[c]][Mc](a,[]);this.uqa=a[$H+cS[c]];this.bx=new Date(this.gda)}
Ga(fS[K],function(){var a=this.bx;this.bx=new Date(this.gda);this.V1+=this.tqa;this.uqa[Mc](this.bx,[this.V1]);return a});fS[K].zO=function(){return this.bx<this.Oz?this.bx:null};function gS(a){a=Pi(a,function(a){return 0!=a});return h.max(0,a)}function eS(a){if(null==a)return-1;for(var b=0,c=a[J],d=0;d<c;++d)b+=a[d]*hS[d];return b}function lIa(a){for(var b=[],c=hS[J]-1;0<=c;c--)b[c]=h[t](a/hS[c]),a-=b[c]*hS[c];return b}
function iS(a){var b=0;4===a[J]&&(b=a[3]);return 1E3*(60*(60*a[0]+a[1])+a[2])+b}function jS(a){var b=[],c=a%1E3;a=h[t](a/1E3);b=a%60;a=h[t](a/60);var d=a%60;a=h[t](a/60);b=[a,d,b];0!==c&&b[C](c);return b}function mIa(a,b){return Gi(a,function(a){return a*b})}var cS="Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),gIa=[0,0,0,0,1,0,0],iIa=[500,30,30,12,15,6,0],hS=[1,1E3,6E4,36E5,864E5,2629743830,31556926E3];function nIa(a){switch(a){case og:case pg:return{xl:oIa,Bx:pIa};case wh:return{xl:qIa,Bx:rIa};case Yg:case rh:return{xl:sIa,Bx:tIa};default:return{xl:sIa,Bx:tIa}}}function sIa(a){return ia(a)}function tIa(a){return a}function oIa(a){return a[bc]()}function pIa(a){return new Date(a)}function qIa(a){return iS(a)}function rIa(a){return jS(a)};function uIa(a){return h.pow(a,3)}function vIa(a){return 1-h.pow(1-a,3)}function wIa(a){return 3*a*a-2*a*a*a};var xIa={LINEAR:MF,dva:mF,Mva:XG,iva:nF};function yIa(a){switch(a){case MF:return kj;case mF:return uIa;case XG:return vIa;case nF:return wIa;default:return kj}}function zIa(a,b,c){b=vn(a,wC,b);if(!b)return null;var d=vn(a,Aqa,30);a=Gn(a,zqa,xIa,c);a=yIa(a);return{duration:b,u3:a,nT:d}};function kS(){}X(kS,bM);Uh(kS);T=kS[K];T.h=function(a){var b={"class":mC+this.ol(a)[ie](ne)},b=a.ea().h(Q,b,a[nz]());this.Rh(b,a.gk());GL(this,a,b);return b};T.yj=function(){return eD};T.Ah=function(a){return a[Nc]==kf};T.Ia=function(a,b){fL(b,lC);return kS.e.Ia[L](this,a,b)};fb(T,function(){return O});T.$=function(){return Ypa};ML(Ypa,function(){return new dM(null,kS.Xb())});function lS(){}X(lS,kS);Uh(lS);lS[K].$=function(){return Zpa};ML(Zpa,function(){return new dM(null,lS.Xb())});function mS(a,b,c){this.VX=a;this.uO=b;this.b_=c}X(mS,iP);T=mS[K];Ma(T,function(a,b,c){mS.e[Fc][L](this,a,b,c);a=nn(a,this.Ha(uua));b=[];b[C](a.millisecond);b[C](a.second);b[C](a.minute);b[C](a.hour);b[C](a.day);b[C](a.month);b[C](a.year);this.b_=AIa([b,gj(this[Kb],b[J]),this.b_])});function AIa(a){a=Hda[Mc](null,a);return Gi(a,function(a){return Oi(a,function(a){return a})})}T.R=function(a,b){return a.R(b)};T.jI=function(a){return oIa(a)};T.xE=function(a){return pIa(a)};T.wZ=function(a){return a};
T.jZ=function(){var a=new Date(0);a[rd](0);return a};T.cH=function(a,b,c){var d=this.Ap;-1===d&&(d=6);var e=(b-a)/d,d=dS(e,this.VX,this.uO);c?(a=aS(new Date(a),d),b=bS(new Date(b),d,1)):(a=bS(new Date(a),d,1),b=aS(new Date(b),d));e=lIa(e);e=hIa(e,d);this.rba=e=0<eS(e)?e:d;this.Loa=a;this.Eba=b;c&&(this.jc=a[bc](),this.ic=b[bc]())};T.N0=function(a,b,c){a=[];for(b=this.Loa;b<this.Eba;)a[C](b[bc]()),b=kIa(b,this.rba,1);if(c||b<=this.Eba)a[C](b[bc]()),this.ic=h.max(this.ic,b[bc]());this.Ro(a)};
T.pH=function(){var a=gS(this.rba),a=this.b_[a];this.le=typeof a===$g?new Go(a):new Go({pattern:a})};
var BIa=[[0,0,0,0,1],[0,0,0,0,2],[0,0,0,0,7],[0,0,0,0,0,1],[0,0,0,0,0,3],[0,0,0,0,0,6],[0,0,0,0,0,12],[0,0,0,0,0,0,1],[0,0,0,0,0,0,5],[0,0,0,0,0,0,10],[0,0,0,0,0,0,25],[0,0,0,0,0,0,50],[0,0,0,0,0,0,100]],CIa=[Ho.MEDIUM_DATE,Ho.MEDIUM_DATE,Ho.MEDIUM_DATE,Ho.MEDIUM_DATE,Ho.MEDIUM_DATE,Do.YEAR_MONTH_ABBR,Jh],DIa=[[1],[2],[5],[10],[20],[50],[100],[200],[500],[0,1],[0,2],[0,5],[0,10],[0,15],[0,30],[0,0,1],[0,0,2],[0,0,5],[0,0,10],[0,0,15],[0,0,30],[0,0,0,1],[0,0,0,2],[0,0,0,3],[0,0,0,4],[0,0,0,6],[0,0,
0,12],[0,0,0,0,1],[0,0,0,0,2],[0,0,0,0,7],[0,0,0,0,0,1],[0,0,0,0,0,3],[0,0,0,0,0,6],[0,0,0,0,0,12],[0,0,0,0,0,0,1],[0,0,0,0,0,0,5],[0,0,0,0,0,0,10],[0,0,0,0,0,0,25],[0,0,0,0,0,0,50],[0,0,0,0,0,0,100]],EIa=[Ho.MEDIUM_TIME,Ho.MEDIUM_TIME,Ho.SHORT_TIME,{pattern:Ho.SHORT_TIME,clearMinutes:!0},Ho.MEDIUM_DATE,Do.YEAR_MONTH_ABBR,Jh];function FIa(a,b,c,d,e,f,g,k){var l=b-a;if(0>=l)return null;for(var n=h[t](h.log(l)/h.log(10)),l=$O(5,function(a){return{Ud:h.pow(10,n-a),cS:5}}),q=[],s=!1,u=0;u<l[J];++u){var w=l[u],z=GIa(a/(w.Ud*w.cS),b/(w.Ud*w.cS),c,d,e,f,g),q=q[Ab](Gi(z,function(a){return[w,a]}));if(s)break;s=!Si(z)}return Hi(q,function(a,b){for(var c=b[0],d=b[1],e=null,f=d.gpa;f<=d.fpa&&e!=f;e=f,f+=d.hpa){var e=h[D](c.cS*f),l=h[D](c.cS*(f+g*d.ipa)),n=k(e,l,c.Ud);n>a.Kl&&(a={Kl:n,fca:{Ei:h[D](e)*c.Ud,Iq:h[D](l)*c.Ud}})}return a},
{Kl:-ea,fca:null}).fca}function GIa(a,b,c,d,e,f,g){for(var k=[],l=b-a,n=d+f,q=h[xb](l/(1-(c+e))/g),l=h[t](l/(1-n)/g);q<ea&&q<=l;++q){var n=q*g,s=h[xb](h.max(a-d*n,b-(1-e)*n)),u=h[t](h.min(a-c*n,b-(1-f)*n)),w=1;0<b&&0>a?1<g&&(s=h[xb](s/q)*q,u=h[t](u/q)*q,w=q):0<=a?s=h.max(0,s):u=h.min(-n,u);0<=u-s&&k[C]({ipa:q,hpa:w,gpa:s,fpa:u})}return k}function nS(a){if(0==a)return 0;0>a&&(a=-a);if(0.5>a)return 0;for(;0==h[D](a%10);)a=h[D](a/10);return 1==a||5==a?0.5:h[t](h.log(a)/h.log(10))+1};function oS(){this.a8=0}X(oS,iP);T=oS[K];T.P8=function(){return 4};Ma(T,function(a,b,c){oS.e[Fc][L](this,a,b,c);this.le=null;this.QG=sn(a,this.Ha(LE),1);this.XO=a.R(this.Ha(vAa),[10,2,5,1])});
T.N0=function(a,b,c){var d,e,f,g,k;c?(d=W(HIa,null,this.XO,this.Ap,a,b),e=-1E-4,f=1/h.max(this.Ap,3),g=e,k=f):(e=-1/h.max(this.Ap,3),f=0,g=e,k=f,this.XO[0]*=-1,d=W(HIa,null,this.XO,this.Ap,this.jc,this.ic));c=this.Ap;(d=FIa(a,b,e,f,g,k,c,d))||(0<=a||0>=b||1==c?d={Ei:a,Iq:b}:(d=h.max(1,h.min(c-1,h[D](b/(b-a)*c))),c-=d,a=h.max(b/d,-a/c),d={Ei:-c*a,Iq:d*a}));a=d;b=(a.Iq-a.Ei)/this.Ap;c=[];for(d=0;d<=this.Ap;++d)c[C](a.Ei+b*d);this.jc=h.min(c[0],this.jc);this.ic=h.max(c[c[J]-1],this.ic);this.Ro(c)};
T.Ro=function(a){oS.e.Ro[L](this,a);var b=0;Y(this[wy],function(a){a=this.Po(a);b=h.max(b,JEa(a/this.QG))},this);this.a8=b};T.pH=function(){var a={pattern:this[Kb],fractionDigits:this[Kb]?null:this.a8,scaleFactor:this.QG,prefix:An(this.b,this.Ha(KE)),suffix:An(this.b,this.Ha(ME))};this.le=new Io(a)};function HIa(a,b,c,d,e,f,g){c=a[0]*(d-c)/(g*(f-e));d=(f-e)/b;for(g=1;g<b;++g)c-=a[1]*h.pow(nS(e+g*d),1.2);c-=a[2]*h.pow(nS(e),1.2);c-=a[2]*h.pow(nS(f),1.2);return c-=a[3]*h.pow(nS(d),1.2)}
T.R=function(a,b){return tn(a,b)};T.jI=function(a){return ia(a)};T.xE=function(a){return a};T.wZ=function(a){return a};T.jZ=function(){return 0};function IIa(){this.cK={}}var pS=null;function qS(){return pS?pS:pS=new IIa}IIa[K].Ug=function(a){return(a=this.cK[a])?a[Mc](null,[]):null};function rS(){this.daa=1}X(rS,iP);T=rS[K];T.R=function(a,b){var c;t:{c=a.R(b,null);if(bi(c)){var d=c[pc](Xe);1==d[J]&&(d=c[pc](Je));if(3==d[J]){var e=yi(d[0]),f=yi(d[1]),d=yi(d[2]);if(0<=d&&0<=f&&0<=e){c=[e,f,d];break t}}}c=!Yh(c)||3!=c[J]&&4!=c[J]?null:c}return c};T.K8=function(a,b){var c=iS(a),d=iS(b);return c<d?-1:c>d?1:0};T.jI=function(a){return iS(a)};T.xE=function(a){return jS(a)};T.wZ=function(a){return a};T.jZ=function(){return jS(0)};
T.cH=function(a,b,c){var d=this.Ap;-1===d&&(d=6);var d=(b-a)/d,e=dS(d,JIa,0);this.daa=gS(e);e=eS(e);this.tickSize=d=h.max(1,h[D](d/e))*e;c?(a=h[t](a/d)*d,b=h[xb](b/d)*d):(a=h[xb](a/d)*d,b=h[t](b/d)*d);this.Ca=a;this.mb=b;c&&(this.jc=a,this.ic=b)};T.N0=function(){for(var a=[],b=this.Ca;b<this.mb;)a[C](b),b+=this.tickSize;a[C](b);this.Ro(a)};T.pH=function(){var a=new Go({pattern:this[Kb]?this[Kb]:1>=this.daa?Goa:NB});this.le={Ee:function(b){return a.Ee(new Date(1970,0,1,b[0],b[1],b[2],0))}}};
var JIa=[[0,1,0,0],[0,2,0,0],[0,5,0,0],[0,10,0,0],[0,20,0,0],[0,30,0,0],[0,0,1,0],[0,0,5,0],[0,0,10,0],[0,0,15,0],[0,0,30,0],[0,0,0,1],[0,0,0,2],[0,0,0,3],[0,0,0,4],[0,0,0,6],[0,0,0,12]];qS().cK.timeofday=function(){return new rS};qS().cK.date=function(){return new mS(BIa,3,CIa)};qS().cK.datetime=function(){return new mS(DIa,3,EIa)};qS().cK.number=function(){return new oS};function sS(){}T=sS[K];T.iO=function(a){var b=a.nb;a=a.jb;var c=tS(this,b,a);return this.k[b].j[c].de.gv||(this.Ba[c]?this.Ba[a].Ts[0]:null)};function KIa(a,b){var c=b.nb,d=tS(a,c,b.jb);return a.k[c].j[d].de.$l||a.k[c][uz]}T.QX=function(a){return a.jb};T.$V=function(a){return{bb:a.jb,Af:this.k[a.nb].Bs}};T.hM=function(a){var b=this.hq[a.Af].kc;return null!=b?{nb:b,jb:this.eq[a.bb]}:null};T.qF=function(a,b){return this.k[a].j[b].de};function uS(a,b){this.G=b;this.Pq=a;this.bv=this.dq=this.xW=this.Ob=this.uv=this.ed=this.gq=null}T=uS[K];T.yo=function(a,b){this.ed={};this.uv={};this.G[Wb]();this.Pq[Wb]();LIa(this,a,b);var c=this.Ob,c=this.G.wk(c[r],c[A]);MIa(this,b,c)};function LIa(a,b,c){var d=new sO(2);tO(d,0,b);tO(d,1,c);a.Ob=d[My]()}
function MIa(a,b,c){a[Bx](c.a(),Er);var d=a.Ob,e=a.G,f=d.nD;!Wm(f)&&!Vm(f)||e.rb(0,0,d[r],d[A],f,c);d.Iy==XG&&(f=a.Is(d[uz],c),a[Bx](f,HI));a.dq=e.za(!0);f=d.Ea;a.mD(f);f&&f[jc]!=mF&&(e[p](c,a.dq),a[Bx](a.dq.a(),DF));a.bv=e.za(!0);f=d.gi;NIa(a,f);f&&f[jc]!=mF&&(e[p](c,a.bv),a.ed.colorbar=a.bv.a());a.xW=e.za(!1);a.I6(d,c)||a.XT(d,c);e[p](c,a.xW);a.gq=b}
T.XT=function(a,b){var c={color:RC,Va:a.Kj,fontSize:a.Nl,bold:!1,Ic:!1,De:!1};this.$i(TB,c,a.A[r]);var d=a.A.top+h[D](a.A[A]/2);this.G.mi(TB,a.A[G],d,a.A[G]+a.A[r],d,pD,pD,c,b)};T.mD=function(a){if(a){var b=a.ln;if(b){var c;a.iG?c=a.area:(c=Gi(b,function(a){return OIa(a)},this),c=Om(c));c&&(c=xl(c),this.G.rb(c[G],c.top,c[r],c[A],Ym,this.dq));for(c=0;c<b[J];c++)PIa(this,b[c]);QIa(this,a.iG)}}};function OIa(a){var b=[];if(a.ma){var c=OQ(a.ma);c&&b[C](c)}a.Wb&&b[C](wl(a.Wb[Ey]));return Om(b)}
function vS(a,b,c,d,e,f,g){var k=f[H],l=ia(f.sides);null!=l&&xj(l)||(l=5);var n=ia(f.rotation);null!=n&&xj(n)||(n=0);n=n/180*h.PI-h.PI/2;k===WAa?(k=nH,l=3):k===jI?(k=nH,l=4,n+=h.PI/4):k===dta&&(k=nH,l=4);var q=k===mI;500<l&&(k===nH||k===mI)&&(k=ED);var s=null;if(k===nH||k===mI){f=ia(f.dent);null!=f&&xj(f)||(5<=l?(f=h.cos(h.PI/l),f-=h.pow(h.sin(h.PI/l),2)/h.sin(h.PI/2-h.PI/l)):f=0.3);f*=d;k===mI&&(l*=2);k=new YJ;for(s=0;s<l;s++){var u=d;q&&s%2&&(u=f);var w=2*h.PI/l*s+n,z=h.cos(w)*u+b,u=h.sin(w)*u+
c;0<s?k.Z(z,u):k[Yy](z,u)}k[vy]();s=a.G.tc(k,e)}else s=a.G.Uv(b,c,d,e);s&&g&&a.G[p](g,s);return s}
function PIa(a,b){if(b.O){var c=a.G.za(!1),d=AN([FF,b[nc]]);a[Bx](c.a(),d,FF);if(d=OIa(b))d=xl(d),a.G.rb(d[G],d.top,d[r],d[A],Ym,c);b.ma&&a.Is(b.ma,c);if(b.Wb)if(d=a.Ob.k[b[nc]],a.Ob.R2&&d&&!d.eh&&d.oD){var e=b.Wb[Ey][G],f=b.Wb[Ey][r],g=b.Wb[Ey][A],k=e+f/2,l=b.Wb[Ey].top+g/2;d.Yu&&a.G.rb(e,l,f,g/2,d.Yu,c);var n=0.5*g,q=d.$d;q&&(q.Hb>n&&(q=q.o(),q.yk(n)),a.G.eK(e,l,e+f,l,q,c));d.fh&&((e=d.oD)||(e={type:ED}),vS(a,k,l,g/2,d.fh,e,c))}else a.G.rb(b.Wb[Ey][G],b.Wb[Ey].top,b.Wb[Ey][r],b.Wb[Ey][A],b.Wb.brush,
c);d=null;b.re&&b.re.O&&(k=b.re[Ey].x,l=b.re[Ey].y,e=b.re.brush,d=a.G,g=d.za(),d.rb(k,l,12,12,e,g),d[p](c,g),e=new YJ,e[Yy](k+2,l+2),e.Z(k+12-2,l+12-2),e[Yy](k+12-2,l+2),e.Z(k+2,l+12-2),k=new Rm,k.dd(ue),k.yk(2),d.na(e,k,g),d=g.a(),g=AN([wya,b[nc]]),a[Bx](d,g));a.G[p](a.dq,c)}}function QIa(a,b){b&&(RIa(a,b.YW,-1),b.XW&&a.Is(b.XW,a.dq),RIa(a,b.WW,1))}function RIa(a,b,c){if(b){var d=aK(b[gz]),d=a.G.na(d,b.brush,a.dq);b.Kt&&(b=AN([GF,c]),a[Bx](d,b))}}
function NIa(a,b){if(b){var c=b[Dx],d=a.G,e=a.bv;OGa(c.pW,d,e);PGa(c.qW,d,e);QGa(c.rW,d,e);c=a.G.rb(b.oG[G],b.oG.top,b.oG[r],b.oG[A],Ym,a.bv);a[Bx](c,rsa)}}T.$i=function(a,b,c){var d=b[uc];a=this.G.Gk(a,b);a>c&&(d=h.max(1,h[t](b[uc]*c/a)));return d};function wS(a,b){var c=a.ed[b];c&&(a.G.Ff(c),delete a.ed[b])}T.kE=function(a,b){var c=a[jy]?yP(a,this.Pq.ac()):zP(a,this.G,this.xW).a();this[Bx](c,b)};T.Is=function(a,b,c){(a=SIa(this,a,c))&&this.G[p](b,a);return a};
function SIa(a,b,c){var d=b.F;if(!d||0==d[J])return null;a=a.G;var e=b.X,f=b.cq,g=null!=b.Cb?b.Cb:0,k=b[Gz]?b[Gz]:{x:0,y:0},l=b.vb,n=!!l||c||!1;c=a.za();if(0===g&&f){var q=OQ(b);if(q){var s=h[xb](q[G]-3)+0.5,u=h[t](q.top-1)+0.5;a.rb(s,u,h[t](q[Zc]+3)+0.5-s,h[t](q[Hc]+1)+0.5-u,f,c)}}for(f=0;f<d[J];f++)q=d[f],0===g?a.Pd(q[cd],q.x+k.x,q.y+k.y,q[J],b.Cc,b.Bc,e,c):$Ba(a,q[cd],q.x+k.x,q.y+k.y,q[J],g,b.Cc,b.Bc,e,c);if(n){n=null;if(0===g)(q=OQ(b))&&(n=a.rb(q[G],q.top,q[Zc]-q[G],q[Hc]-q.top,Ym,c));else{var w=
qj(g);b=Qj(b);b.Cb=0;k=(new kK(k.x,k.y))[sy](-w);Zw(b,new uP(k.x,k.y));for(f=0;f<d[J];f++)k=(new kK(d[f].x,d[f].y))[sy](-w),b.F[f].x=k.x,b.F[f].y=k.y;if(q=OQ(b))d=[new kK(q[G],q.top),new kK(q[Zc],q.top),new kK(q[Zc],q[Hc]),new kK(q[G],q[Hc])],Y(d,function(a){a[sy](w)}),d=aK(d,!1),n=a.na(d,Ym,c)}l&&n&&cCa(a,n,l,TDa(e))}return c.a()}T.qe=function(a,b,c){var d=this.ed[b];null!=d?this.G[Ty](a,c,d):this.G[p](a,c);this[Bx](c,b)};
T.registerElement=function(a,b,c){a&&(this.G.zn(a,b),this.ed[b]=a,c&&(this.uv[c]||(this.uv[c]=[]),Ri(this.uv[c],b)||this.uv[c][C](b)))};function xS(a,b){var c=a.ed[b];c&&(a.G.Ff(c),delete a.ed[b])}T.Nk=function(a){var b=[];if(this.ed[a]){var c=this.G.Nk(this.ed[a]);c&&b[C](c)}a=this.uv[a]||[];for(var d=0;d<a[J];++d)(c=this.G.Nk(this.ed[a[d]]))&&b[C](c);return Om(b)};function yS(a,b){return a.S&&a.S.brush||a.brush||b.fh}function zS(a,b){return null===a.kw?null:a.kw||b.$d}function AS(a){return a[H]==JF||a[H]==BC||a[H]==QH}function BS(a,b){return null!=a[oz]?a[oz]:b.dK}function tS(a,b,c){b=a.k[b];return b.Eg&&Qh(b.J3)?(a=a.k[b.J3].j[c],a=null!=a?a.Cf.Jk:a,null!=a?aj(b.j,a,function(a,b){return a-b.Cf.Jk}):c):c}function TIa(a,b){return a.S&&null!=a.S[bz]?a.S[bz]:null!=a[bz]?a[bz]:b.Pc}function CS(a,b){return TIa(a,b)+Um(yS(a,b))/2}
function UIa(a){return a.Dd&&a.Wa==Bg&&a[lz]==Jg}
function DS(a,b){for(var c=new yK,d=!0,e=!0,f=null,g=null,k=0;k<a.j[J];k++){var l=a.j[k];if(l&&l.S&&null!=l.S.x&&null!=l.S.y){d&&(f=k,d=!1);var n=l.S,q=zS(l,a);e||null===q?(c[Yy](n.x,n.y),e=!1):a.QV?c.Zj(q,a.j[g].jr.x,a.j[g].jr.y,l.ir.x,l.ir.y,n.x,n.y):c.Z(q,n.x,n.y);g=k}else e=!b||d}!d&a.Hga&&(d=b?g:a.j[J]-1,f=b?f:0,null!=d&&null!=f&&a.j[d]&&a.j[f]&&(q=zS(a.j[f],a),a.QV?c.Zj(q,a.j[d].jr.x,a.j[d].jr.y,a.j[f].ir.x,a.j[f].ir.y,a.j[f].S.x,a.j[f].S.y):c[vy](q)));return c}
function ES(a){for(var b=new yK,c=!0,d=0;d<a.j[J];d++){var e=a.j[d].S;null!=e.x&&null!=e.y?(c||b.Z(zS(a.j[d],a),e.JK,e.KK),(c||e.JK!=e.GK||e.KK!=e.IK)&&b[Yy](e.GK,e.IK),c=!1):c=!0}return b}function VIa(a,b,c){return(c=(a=a.Be)&&a[c||0])&&c[jc].Se(b)}function WIa(a,b,c){return(c=(a=a.be)&&a[c||0])&&c[jc].Se(b)}function XIa(a,b,c){return(c=(a=a.Be)&&a[c||0])&&c[jc].Bk(b)}function YIa(a,b,c){return(c=(a=a.be)&&a[c||0])&&c[jc].Bk(b)}
function ZIa(a,b,c,d){for(var e=a.k,f=null,g=ea,k,l=new sk(b,c),n=0,q=e[J];n<q;n++){var s=e[n];if(!s.Eg)if(a.Wa===cH){t:{var u=b,w=c;k=d;var z=s.My.x-u,B=s.My.y-w,F=0<-z*(s.My.y-s.Ue.y)+B*(s.My.x-s.Ue.x);if(0<-(s.Es.x-s.jh.x)*B+(s.Es.y-s.jh.y)*z&&F&&(z=h[ud](h.pow(s.Es.x-s.jh.x,2)+h.pow(s.Es.y-s.jh.y,2)),h[ud](h.pow(s.Es.x-u,2)+h.pow(s.Es.y-w,2))<z+k)){s=!0;break t}s=!1}if(s)return{bb:n}}else{u=0;for(w=s.j[J];u<w;u++)if((k=s.j[u])&&null!=k.S)switch(k=k.S,s[H]){case JF:case dD:case QH:k=uk(l,k);k<
d&&k<g&&(f={uD:u,bb:n},g=k);break;case jD:case KC:z=null;s[H]===KC?z=new vl(k[G],k.top,k[r],k[A]):s[H]===jD&&(z=k.line,B=h.min(k[zz].top,z.top),z=new vl(k[zz][G],B,k[zz][r],h.max(k[zz].top+k[zz][A],z.top+z[A])-B));k=d;z=z.distance(l);(k=z>k?null:z)&&k<g&&(f={uD:u,bb:n},g=k);break;default:throw"unknown chart type for getPointDatum.";}if(0===g)break}}return f};function FS(a,b){uS[L](this,a,b);this.gf=null;this.v0=[]}X(FS,uS);function GS(a,b,c){a.v0[C]({definition:b,id:c})}function HS(a){var b=a.G.tba();a.G.uba();Y(a.v0,W(function(a){this.kE(a[Dx],a.id)},a));a.G.JU(b);a.v0=[]}T=FS[K];
T.I6=function(a,b){function c(b){b=a.k[b];return!a.Uc||b[H]!==QH||b.dK}$Ia(this,a);var d=this.G.za(!1);this.G[p](b,d);this[Bx](d.a(),yD);Dj(this.gf,function(a){a.Fe||(a.Fe=this.G.za(!(Qh(a.i4)&&!a.i4)))},this);this.G.rb(a.A[G],a.A.top,a.A[r],a.A[A],a.W2,d);a.Iy==mF&&this.Is(a[uz],this.gf[uz].Fe);a.JD&&this.Is(a.JD,this.gf.axistitle.Fe);Y(a.Ba,function(a,b){a.Jc&&IS(this,a.Jc,null,b)},this);Dj(a.Be,function(b){aJa(this,a,b)},this);Dj(a.be,function(b){bJa(this,a,b)},this);Dj(a.Be,function(a){cJa(this,
a)},this);Dj(a.be,function(a){cJa(this,a)},this);var e=new vl(a.A[G],a.A.top,a.A[r],a.A[A]);this.G.JU(e);for(var f=[],g=0;g<a.k[J];g++)c(g)&&f[C]({pD:a.k[g].pD,index:g});dj(f,function(a,b){return bj(a.pD,b.pD)});for(g=0;g<f[J];g++){var k=f[g][nc];JS(this,a.k[k],k)}a.Uc&&a.k[0][H]===QH&&dJa(this,a,b);for(g=0;g<a.Ba[J];g++)a.Ba[g].vb&&(f=AN([Hs,g]),GS(this,a.Ba[g].vb,f));HS(this);var l=this.G.za(!1),e=this.G.cE(l,e);this.G[p](d,e);Y(CDa,function(a){var c=this.gf[a].Fe;if(c){var e;switch(this.gf[a][jc]){case GD:e=
l;break;case pF:e=d;break;case YG:e=b}this.G[p](e,c)}},this);return!0};
function $Ia(a,b){a.gf={};var c=a.gf;uw(c,{position:YG});c.annotation={position:GD};c.annotationtext={position:pF};c.area={position:GD};c.bar={position:GD};c.baseline={position:GD};c.bubble={position:GD};c.categorysensitivityarea={position:GD};c.candlestick={position:GD};c.histogram={position:GD};c.gridline={position:GD};c.interval={position:GD};c.line={position:GD};c.minorgridline={position:GD};c.overlaybox={position:GD};c.pathinterval={position:GD};c.point={position:pF,i4:!1};c.pointsensitivityarea=
{position:pF};c.steppedareabar={position:GD};c.tooltip={position:YG};Ap(c,{position:b.Iy==mF?pF:YG});c.axistick={position:pF};c.axistitle={position:b.qD==mF?pF:YG};var d=b.Ea&&b.Ea[jc]==mF,e=d?a.dq:null,d=d?pF:YG;c.legend={Fe:e,position:d};c.legendscrollbutton={Fe:e,position:d};c.legendentry={Fe:e,position:d};e=b.gi&&b.gi[jc]==mF;c.colorbar={Fe:e?a.bv:null,position:e?pF:YG}}
function JS(a,b,c){if(b[H]==dD)eJa(a,b,c);else if(b[H]==KC)fJa(a,b,c);else if(b[H]==qI)fJa(a,b,c);else if(b[H]==jD)for(var d=0;d<b.j[J];d++)gJa(a,c,b.j[d],d);else if(b[H]==BC){var e=a.Ob.Dd,f=a.Ob.Lj;if(0!=b.j[J]){for(var f=f&&!e,g=[],k={start:null,end:null,brush:null},d=0;d<=b.j[J];d++){var l=b.j[d];l&&!l.Ae?null===k[y]?La(k,d):(l=l.QS||b.Yu,null===k.brush||cfa(k.brush,l)?(k.end=d,k.brush=l):(g[C](k),k={start:d-1,end:d,brush:l})):f&&d!==b.j[J]||(null===k[y]||null===k.end||g[C](k),d<b.j[J]&&(k={start:null,
end:null,brush:null}))}l=a.G.za();for(d=0;d<g[J];d++){var k=g[d],n=k.brush,q=new YJ,s=q,u=b,w=e,z=k[y],k=k.end,B=!0,F=null;s[Yy](u.j[z].S.tT,u.j[z].S.uT);for(var M=z;M<=k;M++){var N=u.j[M],P=N.S;N.Ae||(s.Z(P.JK,P.KK),P.GK==P.JK&&P.IK==P.KK||s.Z(P.GK,P.IK),null!=P.x&&null!=P.y&&(B=!1,F=M))}if(!B)if(w)for(M=k;M>=z;M--)P=u.j[M].S,s.Z(P.vT,P.wT),P.tT==P.vT&&P.uT==P.wT||s.Z(P.tT,P.uT);else P=u.j[F].S,s.Z(P.vT,P.wT),s[vy]();a.G.na(q,n,l)}d=AN([BC,c]);a.qe(a.gf.area.Fe,d,l.a());if(e){d=ES(b);e=AN([JF,c]);
f=d.tc(a.G);g=hJa(a,b);if(f){l=b.an;n=b.li;if(l||n){g=g||a.G.za();if(l)for(d=0;d<l.Hf[J];d++)a.G.na(l.Hf[d][gz],l.Hf[d].brush,g);n&&a.G.na(n[gz],n.brush,g)}g&&a.G[p](g,f)}d=g?g.a():f;null!=d&&a.qe(a.gf.line.Fe,e,d);KS(a,b,c)}else iJa(a,b,c,f)}}else iJa(a,b,c,a.Ob.Lj);if(b.ef&&b.ef.ii)for(b=b.ef.ii,d=0;e=b[d];++d)0!=e.line[J]&&(f=new YJ,$J(f,e.line,e.JS),e[Hc]&&$J(f,e[Hc],e.Rea),g=a.G.za(),a.G.na(f,e.brush,g),e=g.a(),f=AN([Pxa,c,d]),a.qe(a.gf.pathinterval.Fe,f,e))}
function jJa(a,b,c,d,e){b[H]==KC||b[H]==qI?a.ue(b,c,d,e):b[H]==jD?gJa(a,c,d,e):b[H]==dD?a.hG(b,c,d,e):LS(a,b,c,d,e,a.gf.point.Fe)}function eJa(a,b,c){var d=a.gf.bubble.Fe,e=$O(b.j[J],function(a){return a});b.Qea&&cj(e,function(a,c){var d=b.j[a],e=b.j[c];return(e?e.S[bz]:0)-(d?d.S[bz]:0)});for(var f=0;f<e[J];f++){var g=e[f],k=b.j[g];k&&(a.hG(b,c,k,g),k=a.G.Pd(k[cd],k.S.x,k.S.y,k.Mea,pD,pD,k.X,d),g=AN([cD,c,g]),a.G.zn(k,g))}}function fJa(a,b,c){for(var d=0;d<b.j[J];d++)a.ue(b,c,b.j[d],d)}
T.ue=function(a,b,c,d){if(c&&c.S){var e=c.brush||yS(c,a),f=a[H]==KC?JC:rI,g=AN([f,b,d]),k=c.S.vD||c.S,e=this.G.Ak(k[G],k.top,k[r],k[A],e),k=null,l=c.S.outline,n=c.an,q=c.li;if(l||n||q){k=this.G.za();this.G[p](k,e);if(l){var s=c.$d||a.$d,l=aK(l,!0);this.G.na(l,s,k)}if(n)for(s=0;s<n.Hf[J];s++)l=n.Hf[s][zz],this.G.rb(l[G],l.top,l[r],l[A],n.Hf[s].brush,k);q&&this.G.rb(q[zz][G],q[zz].top,q[zz][r],q[zz][A],q.brush,k)}e=k?k.a():e;this.qe(this.gf[f].Fe,g,e);c.vb&&(f=AN([Hs,b,d]),GS(this,c.vb,f));c.Jc&&IS(this,
c.Jc,b,d);c.S.sq&&kJa(this,a,b,d,c.S.sq)}};function hJa(a,b){var c=null,d=null;Y(b.j,function(a,f){var g=b.j[f-1],k=b.j[f+1],g=!g||!g.S||g.Ae,k=!k||!k.S||k.Ae;a&&a.S&&!a.Ae&&g&&k&&(c||(c=this.G.za()),d||(d=Zm(b.$d.Qd,b.$d.Ai)),this.G.Zd(a.S.x,a.S.y,b[Ny],d,c))},a);return c}
function iJa(a,b,c,d){var e=AN([JF,c]);if(0>=b[Ny])xS(a,e),KS(a,b,c);else{var f=DS(b,d);if(!Si(f.Yc)){d=(f=f.tc(a.G))&&d?null:hJa(a,b);if(f){var g=b.an,k=b.li;if(g||k){d||(d=a.G.za());if(g)for(var l=0;l<g.Hf[J];l++)a.G.na(g.Hf[l][gz],g.Hf[l].brush,d);k&&a.G.na(k[gz],k.brush,d)}d&&a.G[p](d,f)}f=d?d.a():f;null!=f&&a.qe(a.gf.line.Fe,e,f);KS(a,b,c)}}}
function dJa(a,b,c){for(var d=0,e=b.k[J];d<e;d+=2){var f=b.k[d],g=b.k[d+1],k=f.j[J];if(0!=k)for(var l=new Rm({stroke:f.fh.gb(),Cg:f.fh.Oe,qa:1}),n=0;n<k;n++){var q=f.j[n],s=g.j[n];q&&q.S&&!q.Ae&&a.G.eK(q.S.x,q.S.y,s.S.x,s.S.y,l,c)}}}function KS(a,b,c){for(var d=0;d<b.j[J];d++)LS(a,b,c,b.j[d],d,a.gf.point.Fe)}T.hG=function(a,b,c,d){LS(this,a,b,c,d,this.gf.bubble.Fe)};
function lJa(a,b,c,d){var e=null,f=b.li,g=b.an,k=b.I5;if(f||g||k)e=a.G.za();k&&a.G.na(k[gz],k.brush,e);k=b[kx]||{type:ED};f&&vS(a,f.x,f.y,f[bz]+0.5,f.brush,k,e);if(g)for(f=0;f<g.Hf[J];f++)vS(a,g.x,g.y,g.Hf[f][bz],g.Hf[f].brush,k,e);b=vS(a,b.S.x,b.S.y,c,d,k);e&&a.G[p](e,b);return e?e.a():b}
function LS(a,b,c,d,e,f){var g;if(g=d&&d.S&&!d.Ae)t:{var k=d.S;g=CS(d,b);var l=a.Ob.A;if(k.x-g>=l[Zc]||k.x+g<=l[G]||k.y-g>=l[Hc]||k.y+g<=l.top)g=!1;else{if((k.x>=l[Zc]||k.x<=l[G])&&(k.y>=l[Hc]||k.y<=l.top)){g*=g;var n=k.x-l[Zc],q=k.x-l[G],s=k.y-l[Hc],k=k.y-l.top,l=n*n,q=q*q,s=s*s,k=k*k;if(l+s>=g&&l+k>=g&&q+k>=g&&q+s>=g){g=!1;break t}}g=!0}}g&&(g=AN([b[H]==dD?cD:iH,c,e]),BS(d,b)?a.qe(f,g,lJa(a,d,TIa(d,b),yS(d,b))):xS(a,g),d.vb&&(f=AN([Hs,c,e]),GS(a,d.vb,f)),d.Jc&&IS(a,d.Jc,c,e),d.S.sq&&kJa(a,b,c,e,
d.S.sq))}function gJa(a,b,c,d){if(c&&c.S){var e=a.G.Ak(c.S.line[G],c.S.line.top,c.S.line[r],c.S.line[A],c.$d),f=a.G.Ak(c.S[zz][G],c.S[zz].top,c.S[zz][r],c.S[zz][A],c.Jy),g=a.G.za();a.G[p](g,e);a.G[p](g,f);if(e=c.an)for(f=0;f<e.Hf[J];f++){var k=e.Hf[f][zz];a.G.rb(k[G],k.top,k[r],k[A],e.Hf[f].brush,g)}(e=c.li)&&a.G.rb(e[zz][G],e[zz].top,e[zz][r],e[zz][A],e.brush,g);e=AN([iD,b,d]);a.qe(a.gf.candlestick.Fe,e,g.a());c.vb&&(b=AN([Hs,b,d]),GS(a,c.vb,b))}}
function IS(a,b,c,d){if(b){var e=b.E3,f=a.Ob.A;if(e&&!(e.x<f[G]||e.x>f[Zc])&&(f=b[vz])&&!Si(f)){var g=[xC,d];null!=c&&Ui(g,c,1);var g=AN(g),k=e.x,l=e.y,n=e[J],q=e[E],e=e[lz]==Jg?[n,1]:[1,n],e=a.G.Ak(h.min(k,k+e[0]),h.min(l,l+e[1]),h.abs(e[0]),h.abs(e[1]),new Rm({fill:q}));a.qe(a.gf.annotation.Fe,g,e);e=a.G.za();g=[zC,d];null!=c&&Ui(g,c,1);k=null;b.bundle&&!b.bundle.KS&&(f=[b.bundle[Rc]],k=-1);for(b=0;b<f[J];b++)if(q=f[b],l=SIa(a,q,!0))q.ka&&(n=AN([Hs,c,d,b]),GS(a,q.ka,n)),a.G[p](e,l),q=Yi(g),q[C](k||
b),q=AN(q),a[Bx](l,q);c=AN(g);a.qe(a.gf.annotationtext.Fe,c,e.a())}}}function kJa(a,b,c,d,e){if(null!=b.ef){var f=a.G.za();b=b.ef.ND;for(var g=0;g<e[J];g++){var k=e[g][zz],l=b[e[g].LD];if(l&&l[x]!=BC&&l[x]!=JF){var n=l.brush;if(0==k[r]&&0==k[A])l=l.KD/2,0<l&&(k=a.G.Uv(k[G],k.top,l,n),a.G[p](f,k));else if(0==k[r]||0==k[A])l=new YJ,l[Yy](k[G],k.top),l.Z(k[G]+k[r],k.top+k[A]),a.G.na(l,n,f);else a.G[p](f,a.G.Ak(k[G],k.top,k[r],k[A],n))}}f.q&&(c=AN([rF,c,d]),f=f.a(),a.qe(a.gf[xx].Fe,c,f))}}
function aJa(a,b,c){var d=W(function(a,d){var g=h[t](a.aa),k=null!=a[J]?a[J]:b.A[A],l=c.VM.aa,l=h.min(l,l+c.VM[jx]*k);return this.G.rb(g,l,1,k,a.brush,d)},a);mJa(a,c,d)}function bJa(a,b,c){var d=W(function(a,d){var g=h[t](a.aa),k=null!=a[J]?a[J]:b.A[r],l=c.VM.aa,l=h.min(l,l+c.VM[jx]*k);return this.G.rb(l,g,k,1,a.brush,d)},a);mJa(a,c,d)}
function mJa(a,b,c){if(b.wb){var d=a.gf.gridline.Fe,e=AN([b[yd],TE]);Y(b.wb,function(a,f){var g=AN([b[yd],TE,f]);nJa(this,a,c,d,g,e)},a)}var f=a.gf.baseline.Fe,g=AN([b[yd],LC]);nJa(a,b.Ed,c,f,g)}function nJa(a,b,c,d,e,f){var g;if(g=b)if(g=b.O)g=b.brush,g=!(!Wm(g)&&!Vm(g));g&&(b=c(b,d),a[Bx](b,e,f))}
function cJa(a,b){var c=a.gf,d=a.Is(b[uz],c.axistitle.Fe),e=AN([b[yd],HI]);a[Bx](d,e);if(b[cd]){var f=c.axistick.Fe,g=AN([b[yd],zF]);Y(b[cd],function(a,c){if(a.O){var d=this.Is(a.ma,f),e=AN([b[yd],zF,c]);this[Bx](d,e,g)}},a)}}T.d3=function(a,b){this.oK(a);this.j0(a,b)};
T.oK=function(a){var b=this.gq;if(b){for(var c in b.k){var d=a.k[c];if(fP(b.k[c],Ij({j:null}))){var e=b.k[c].j,f;for(f in e){var g=e[f];if(g.vb){var k=AN([Hs,ia(c),ia(f)]);wS(this,k)}if(g=g.Jc)for(var l in g[vz])g[vz][l].ka&&(k=AN([Hs,ia(c),ia(f),ia(l)]),wS(this,k));jJa(this,d,ia(c),d.j[f],ia(f))}}else{for(f in b.k[c].j)b.k[c].j[f].vb&&(k=AN([Hs,ia(c),ia(f)]),wS(this,k));JS(this,d,ia(c))}}for(var n in b.Ba)if(c=b.Ba[n],c.vb&&(k=AN([Hs,ia(n)]),wS(this,k)),g=c.Jc){for(l in g[vz])g[vz][l].ka&&(k=AN([Hs,
null,ia(n),ia(l)]),wS(this,k));IS(this,a.Ba[n].Jc,null,ia(n))}HS(this)}};T.j0=function(a,b){for(var c in b.k){var d=a.k[c];if(fP(b.k[c],Ij({j:null})))for(var e in b.k[c].j){var f=new sO(2);tO(f,0,d.j[e]);tO(f,1,b.k[c].j[e]);f=f[My]();jJa(this,d,ia(c),f,ia(e))}else f=new sO(2),tO(f,0,d),tO(f,1,b.k[c]),d=f[My](),JS(this,d,ia(c))}for(var g in b.Ba)b.Ba[g].vb&&(c=AN([Hs,ia(g)]),GS(this,b.Ba[g].vb,c)),b.Ba[g].Jc&&(c=new sO(2),tO(c,0,a.Ba[g].Jc),tO(c,1,b.Ba[g].Jc),c=c[My](),IS(this,c,null,ia(g)));HS(this)};function oJa(a){this.x=a.x||0;this.y=a.y||0;this.Ze=new uP(this.x,this.y);jb(this,a[J]);Bw(this,a[cd])};function pJa(a){Bw(this,a[cd]);this.X=a.X;this.F=a.F;this.Cc=a.Cc;this.Bc=a.Bc;this.vb=void 0!==a.vb?a.vb:O;this.de=a.de;this.Cb=null!=a.Cb?a.Cb:0;Zw(this,void 0!==a[Gz]?a[Gz]:null);this.TA=!!a.TA}pJa[K].j9=function(){var a=this,b=Gi(this.F,function(b){var d=a[Gz]?a[Gz]:{x:0,y:0},e=bK(b.x+d.x,b[J],a.Cc);b=bK(b.y+d.y,a.X[uc],a.Bc);return e[y]==e.end||b[y]==b.end?null:new rl(b[y],e.end,b.end,e[y])}),b=Fi(b,Xh);return Om(b)};function qJa(a){a=Fi(a[pc](Mh),function(a){return null!=a&&pi(a)!==O});for(var b={},c=0;c<a[J];c++){var d=a[c][pc](Lh),e=Gi(d[0][pc](Je),pi),f=bm(pi(d[1]));0===e[J]?Sj(b,f):Y(e,function(a){b[a]=b[a]||{};Sj(b[a],f)})}return b};var MS={},rJa=!1;
function sJa(a){if(!rJa){var b={colors:[{color:Lla,dark:Ela,light:Sla},{color:Hla,dark:Fla,light:Ola},{color:Kla,dark:Dla,light:Tla},{color:Cla,dark:xla,light:Jla},{color:Rla,dark:Ila,light:Nla},{color:Ala,dark:wla,light:Gla}],backgroundColor:{gradient:{color1:yla,color2:vla,x1:PA,y1:PA,x2:QA,y2:QA}},titleTextStyle:{color:Hh},hAxis:{textStyle:{color:Hh},titleTextStyle:{color:Hh}},vAxis:{textStyle:{color:Hh},titleTextStyle:{color:Hh}},legend:{textStyle:{color:Hh}},chartArea:{backgroundColor:{stroke:wA,fill:R}},
areaOpacity:0.8};MS.classic=b;b={titlePosition:mF,axisTitlesPosition:mF,legend:{position:mF},chartArea:{width:QA,height:QA},vAxis:{textPosition:mF},hAxis:{textPosition:mF}};MS.maximized=b;b={enableInteractivity:!1,legend:{position:R},seriesType:BC,lineWidth:1.6,chartArea:{width:QA,height:QA},vAxis:{textPosition:R,gridlines:{color:R},baselineColor:R},hAxis:{textPosition:R,gridlines:{color:R},baselineColor:R}};MS.sparkline=b;rJa=!0}return MS[a]}
function NS(a){var b={};Xa(b,a[E]||a);var c=Dm(b[E]);c==R?(b.tb=a.darker||c,b.Mi=a.lighter||c):(c=rm(c),b.tb=a.darker||pm(wm(c,0.25)),b.Mi=a.lighter||pm(xm(c,0.25)));return b};function OS(a,b,c,d){this.Uf=a;this.b=b;this.Pl=d;this.Wc=c;this.ta=Ln(this.b,tra,{Va:d.Kj,fontSize:d.Nl,Tb:d.$u});this.Qd=Cn(this.b,sra,tA);this.Vl=xn(this.b,rra,0.8);this.VS=0;this.yD=1;this.zD=2;this.pq=3;this.qq=4;this.Do=this.j3=this.i3=this.l3=this.k3=O;this.pT=this.b.R(ND,tP);this.YK=NS(this.pT[0])[E];this.rD=this.iq=this.qT=this.oT=this.Vy=this.Qy=null;this.Yi()}
OS[K].Yi=function(){function a(a,b,d){if(c.H()<=a)return O;var e=c.D(a);if(b&&!Ri(d,e))throw m(IB+a+" must be of type "+d[ie](Tq));if(!b&&Ri(d,e))throw m(IB+a+" cannot be of type "+d[ie](Tq));return e}var b=this.Pl,c=this.Uf,d=c.H();if(3>d)throw m("Data table should have at least 3 columns");a(this.VS,!0,[rh]);var e=a(this.yD,!1,[rh]),f=a(this.zD,!1,[rh]);this.k3=c.cb(this.yD);this.l3=c.cb(this.zD);di(this.pq)&&this.pq<d?(this.Do=a(this.pq,!0,[Yg,rh]),this.Do==rh&&(this.Qy={},this.Vy=[]),this.i3=
c.cb(this.pq)):this.pq=null;var g=!1;di(this.qq)&&this.qq<d?(a(this.qq,!0,[Yg]),this.j3=c.cb(this.qq),g=pn(this.b,Zza,!0)):this.qq=null;b.Ba=[];b.eq={};for(d=0;d<c.M();d++){var k=c.cn(d);b.eq[k]=d}b.k=[{type:dD,dK:!0,Qea:g,j:[],pta:this.Qy,qta:this.Vy}];b.Ns=e;b.eE=[f];b.xf={};b.xf.bubbles=1;b.dn=[]};function tJa(a,b,c){for(var d=a.Uf,e=0;e<d.M();e++){var f=d[I](e,a.yD),g=d[I](e,a.zD),f=lP(b.ca,f),g=lP(c.ca,g);null!=f&&PS(b,f);null!=g&&PS(c,g)}}
function uJa(a,b,c,d){for(var e=0;e<a.Uf.M();e++){var f;t:{f=a;var g=b,k=c,l=e,n=f.Uf,q=n[I](l,f.VS),s=n.Aa(l,f.VS),u=n[I](l,f.yD),w=n[I](l,f.zD),z=null;if(null!=f.pq&&(z=n[I](l,f.pq),null==z)){f=null;break t}var B=null;if(null!=f.qq&&(B=n[I](l,f.qq),null==B)){f=null;break t}n=f.Wc(s,f.ta)[r];if(f.Do==Yg)f.oT=Nm(f.oT,z);else if(f.Do==rh){var F=z,M=f.Qy[F];if(!M){var M=ZH+F+Me,N=Cn(f.b,M+KD,f.pT[f.Vy[J]%f.pT[J]]),N=NS(N),P=pn(f.b,M+hJ,!0),M=zn(f.b,M+AF,F),M={color:N[E],Oj:P,zk:M};f.Qy[F]=M;f.Vy[C](F)}}f.qT=
Nm(f.qT,B);u=jP(g.ca,u);w=jP(k.ca,w);null===u||null===w?f=null:(QS(g,u)&&QS(k,w)&&(g.fc(u),k.fc(w)),g=f.ZT(l,s),f={id:q,text:s,Mea:n,X:f.ta,de:g,Cf:{x:u,y:w,color:z,size:B}})}a.Pl.k[0].j[C](f)}if(a.Do==Yg)a.iq=TFa(a.b,a.oT),d.c4(a.iq);else if(a.Do==rh)for(e=0;e<a.Vy[J];e++)b=a.Vy[e],c=a.Qy[b],c.Oj&&a.Pl.dn[C]({index:e,id:b,text:c.zk,brush:new Rm({fill:c[E]}),O:!0});a.rD=pHa(a.b,a.qT)}
OS[K].ZT=function(a,b){var c=this.Uf,d=c.Aa(a,this.yD),e=c.Aa(a,this.zD),d=[{title:this.k3,value:d},{title:this.l3,value:e}];null!=this.pq&&(e=c.Aa(a,this.pq),d[C]({title:this.i3,value:e}));null!=this.qq&&(c=c.Aa(a,this.qq),d[C]({title:this.j3,value:c}));return{title:b,F:d}};function vJa(){this.um=0;this.wW=this.vp=-1;this.pr=0;this.nG=-1}
vJa[K].create=function(a,b,c,d,e){if(0!=a[J]&&(a=Fi(a,function(a){return null!=a}),cj(a),0!=a[J]))if(a[0]==a[a[J]-1])this.um=1,this.vp=a[0],this.wW=a[0],this.nG=0;else{var f=h[xb](0.5*a[J])-1,g=h.min(a[J]-1,h[xb]((100-b)/100*a[J])-1),k=h.max(0,h[xb](b/100*a[J])-1);b=wJa(a);var l=a[f]-h.min(a[f]-a[0],1.5*(a[f]-a[k]));l!=a[0]&&(this.pr=1,b&&(l=h[t](l)));var n=a[f]+h.min(a[a[J]-1]-a[f],1.5*(a[g]-a[f])),f=Fi(a,function(a){return a<n&&a>l});this.um=di(c)&&0<c?c:xJa(l,n,f[J],b,d,e);this.vp=this.um*(1==
this.pr?h[D](l/this.um):h[t](l/this.um));1==this.pr&&this.vp<a[0]&&(this.pr=0);a=h[t]((n-this.vp)/this.um);this.wW=this.um*a+this.vp;this.nG=a+this.pr}};function wJa(a){for(var b=0;b<a[J];b++)if(!wj(a[b]))return!1;return!0}function yJa(a){var b=[];1==a.pr&&b[C](Bna+(a.vp.toPrecision(10)-0));for(var c=a.nG-a.pr,d=0;d<c+1;d++)b[C]((d*a.um+a.vp).toPrecision(10)-0+Ie);return b}function zJa(a){for(var b=[],c=0;c<=a.nG+1;c++)b[C]((c-a.pr)*a.um+a.vp);return b}
function xJa(a,b,c,d,e,f){if(a==b)return 1;if(0==c)return b-a;a=b-a;c=h[ud](c);b=null!=e&&0<e;var g=null!=f&&0<f;e=b&&g?f>e?nj(c,e,f):c:b?h.max(c,e):g?h.min(c,f):c;e=a/e;f=0.8*e;a=1.2*e;c=h[D];if(!(e>a||e<f||f>=a)){b=1;g=e;do{var g=e,k=b,l=c;0==g||!xj(g)||0>=k||(k=(0==g?1:h.pow(10,h[xb](-h.log(h.abs(g))/h[kz])-1))*h.pow(10,h.max(0,k)),k*=0<g?1:-1,g=h.max(5*l(k*g/5),1)/k);b++}while(!(g>=f&&g<=a)&&5>b);e=5>b?g:e}return d?0.5<e?h[D](e):1:e};function AJa(a,b,c){this.Pl=a;this.ya=c?Gn(b,lsa,hFa,c):R;this.ta=Ln(b,msa,{Va:a.Kj,fontSize:a.Nl,Tb:this.ya==mF?a.$u:R});this.RT=An(b,ksa);this.vg=this.Yb=null}T=AJa[K];pw(T,function(){return this.ya});Kw(T,function(){return 1.5*this.ta[uc]});T.getArea=function(){return this.Yb};T.Go=function(a){this.Yb=a};T.c4=function(a){this.vg=a};
T.zW=function(){if(!this.Yb||!this.vg)return null;var a={top:this.Yb.top,left:this.Yb[G],width:this.Yb[Zc]-this.Yb[G],height:this.Yb[Hc]-this.Yb.top,orientation:Jg,X:this.ta,J6:RC,K6:this.RT},b=jR(this.vg,a,[],this.Pl.Ac);return null!=b?{position:this.ya,scale:this.vg,oG:a,definition:b}:null};function RS(a,b,c){this.m1=a;this.Oa=b;this.rw=a-b/2;this.Bga=c;np(this,0)}RS[K].getCenter=function(){return this.rw+this.Oa/2};Kw(RS[K],function(){return this.Oa});function BJa(a,b){this.bI=a;this.yy=b;for(var c=0,d=b[J];c<d;c++)np(b[c],c)}function CJa(a){for(var b=0,c=0,d=a.yy[J];c<d;c++)b+=a.yy[c][ez]();if(b>a.bI)throw m("Not enough space for labels. Need: "+b+" got: "+a.bI);a.yy[Zd](function(a,b){var c=a.m1,d=b.m1;return c==d?a[nc]>b[nc]?1:0:c>d?1:-1});c=0;for(d=a.yy[J];c<d;c++){var b=a.yy[c],e=DJa(a,b.rw,b[ez]());b.rw=e}c=[];b=0;for(d=a.yy[J];b<d;b++)c[C]([a.yy[b]]);for(;EJa(a,c););}
function EJa(a,b){for(var c=0;c<b[J]-1;c++){var d=b[c],e=b[c+1],f=d[d[J]-1];if(f.rw+f.Oa>e[0].rw){for(var f=a,g=e,e=0;e<g[J];e++)d[C](g[e]);for(var k=0,e=g=0;e<d[J];e++)k+=d[e].m1,g+=d[e][ez]();k=k/d[J]-g/2;k=DJa(f,k,g);for(e=0;e<d[J];e++)f=d[e],f.rw=k,k+=f[ez]();b[he](c+1,1);return!0}}return!1}function DJa(a,b,c){return nj(b,0,a.bI-c)};function SS(a,b,c,d){this.Pl=a;this.ya=c?Gn(b,ewa,gFa,c):R;this.tL=Gn(b,Wva,iFa,this.ya==WC?pD:nI);c=Jg;if(this.ya==Qg||this.ya==zs||this.ya==BF||this.ya==YC)c=Eh;this.ib=c;this.ta=Ln(b,jwa,{Va:a.Kj,fontSize:a.Nl,Tb:this.ya==mF?a.$u:R});this.Mq=!1;this.S5=Ln(b,dwa,this.ta);this.Wc=a.Ac;this.iF=this.ta[uc];d=d?nj(d,1,2):1;this.ek=this.iF*d;this.ht=h[D](this.ta[uc]/(1.618*1.618));this.qE=this.Yb=null;this.TV=pn(b,iwa,!0);this.iha=Gn(b,hwa,pP,this.ib);this.gha=Jn(b,fwa);this.hha=Jn(b,gwa);this.Me=null;
this.IM=this.ht;this.xw=this.yw=this.RV=0;this.m4=this.ya==NI?vn(b,$va,1):1;this.tE=0}pw(SS[K],function(){return this.ya});SS[K].getArea=function(){return this.Yb};SS[K].Go=function(a){this.Yb=a};function FJa(a){a.qE=Fi(a.Pl.dn,function(a){return a.O})}
SS[K].zW=function(){if(!this.Yb)return null;if(this.ya!=R)if(this.ib==Eh)GJa(this);else{for(var a=[1,9,99,0],b=0;b<a[J];++b){var c;t:{c=a[b];var d=this.Yb[Zc]-this.Yb[G],e=!1;1!=c&&(d-=2*(this.ek+this.ht),e=!0,0!=c&&(d-=TS(this,c)+this.ht));var f=US(this,this.qE,d);if(0==f[J])this.Mq=!1;else{this.Me=[];for(var g=this.qE;0<g[J];){if(0<c&&this.Me[J]==c){c=!1;break t}for(var k=[HJa(this,f,g,e)],l=1;l<this.tE&&g[J]!=f[J];l++)g=$i(g,f[J]),f=US(this,g,d),k[C](HJa(this,f,g,e));k=IJa(this,k);this.Me[C](k);
g=$i(g,f[J]);f=US(this,g,d)}this.Mq=1<this.Me[J]}c=!0}if(c)break}this.Mq&&(this.RV=h[D]((this.Yb.top+this.Yb[Hc]-this.ek)/2),this.xw=this.Yb[Zc]-this.ek,this.yw=this.xw-this.IM-this.ek,this.TV&&(a=TS(this,this.Me[J]),this.yw-=a+this.IM))}a=this.Me&&0<this.Me[J]?this.Me[0]:null;if(this.Mq){b=1<this.Me[J];c=this.RV;d=null;this.TV&&(d=bna+this.Me[J],e=this.yw+this.ek,f=this.xw-e,d={text:d,X:this.S5,cq:null,F:[{x:e+f/2,y:c,text:d,length:f}],Cc:pD,Bc:nI,vb:O,anchor:null,Cb:0});var g=this.iha==Eh,k=this.ek,
l=h[D](k/2),n=this.yw,q=this.xw,f=e=null;g?(e=[{x:n+k,y:c+k},{x:n+l,y:c},{x:n,y:c+k}],f=[{x:q,y:c},{x:q+k,y:c},{x:q+l,y:c+k}]):(e=[{x:n+k,y:c+k},{x:n+k,y:c},{x:n,y:c+l}],f=[{x:q,y:c},{x:q+k,y:c+l},{x:q,y:c+k}]);c={Kt:this.gha,yN:this.hha};b={YW:{path:e,Kt:!1,ce:c,brush:c.yN},WW:{path:f,Kt:b,ce:c,brush:b?c.Kt:c.yN},XW:d}}else b=null;return{position:this.ya,area:this.Yb,Me:this.Me,ln:a,iG:b}};
function GJa(a){var b=h.max(a.Yb[Zc]-a.Yb[G]-(a.ek+a.ht),0),c=a.Yb[Hc]-a.Yb.top,d=h.max(c-2*a.iF,0),e=a.qE,f=a.Pl;UIa(f)&&e[rx]();var g=Gi(e,function(a){a=UN(this.Wc,a[cd],this.ta,b,ea);0==a.F[J]&&(a.F=[O]);return a},a);if(a.ya!=BF||f.eT!=JF&&f.eT!=BC)if(c=VS(a,g,c),a.Mq=JJa(e,c),a.Mq)if(c=VS(a,g,d),Qh(c[0])&&0!=c[0][J]){for(a.Me=[];0<e[J];){f=KJa(a,c,e);a.Me[C](f);for(f=0;Qh(c[f])&&0!=c[f][J];)++f;g=$i(g,f);c=VS(a,g,d);e=$i(e,f)}a.Mq&&(a.RV=h[D](a.Yb[Hc]-a.iF),a.yw=a.Yb[G],a.xw=a.yw+a.ek+a.IM,a.TV&&
(d=TS(a,a.Me[J]),a.xw+=d+a.IM))}else a.Mq=!1;else f=KJa(a,c,e),a.Me=[f];else f=LJa(a,g,c,e),a.Me=[f]}function VS(a,b,c){var d=a.ta[uc],e=h[D](d/1.618),f=h[D](d/3.236);a=MJa(a,b,d+e,d+f);return bP(a,c)}function NJa(a,b){var c=Gj(a.Pl.Be),d=a.Pl.k[b],e=Gi(d.j,function(a){return!a||a.Ae?null:new sk(a.S.x,a.S.y)}),d=gP(e,c.Gh,d.Lj);return null===d?OJa(e,c.Gh):d}
function OJa(a,b){a=Fi(a,Xh);var c=-(aj(a,b,function(a,b){return bj(a,b.x)})+1),c=$i(a,0,c);return(c=Qi(c,function(a){return null!==a.y}))?c.y:null}
function LJa(a,b,c,d){for(var e=a.Yb[Zc]-a.Yb[G],f=h[D](a.Yb[G]),g=[],k=[],l=a.Pl.By==gE,n=0;n<d[J];n++){var q=d[n],s=UN(a.Wc,q[cd],a.ta,e,b[n].F[J]),u={};u.id=q.id;u.brush=q.brush.o();var w=Pj(a.ta);Xa(w,u.brush.gb());u.ma={text:q[cd],X:w,cq:null,F:[],Cc:nI,Bc:nI,vb:s.ge?q[cd]:O,anchor:null,Cb:0};w.Tb&&u.brush.dd(w.Tb,1);u.O=!0;for(var z=0;z<s.F[J];z++)u.ma.F[C]({length:e,text:s.F[z]});l&&(z=a.Wc(u.ma.F[0][cd],w)[r],u.re={},tw(u.re,{x:f+z+5}),u.re.brush=u.brush,u.re.O=!1);np(u,q[nc]);z=NJa(a,u[nc])||
0;w=a.Wc(u.ma.F[0],w)[A];q=new RS(z,u.ma.F[J]*w,u);g[C](q);k[C](u)}CJa(new BJa(c,g));for(z=0;z<g[J];z++)for(q=g[z],a=q.rw,u=q.Bga,b=u.ma.F,n=0;n<b[J];n++)b[n].y=h[D](n*w+a),b[n].x=f,l&&(u.re[Ey].y=b[n].y);return k}
function KJa(a,b,c){for(var d=a.ek+a.ht,e=a.Yb[Zc]-a.Yb[G]-d,f=a.ta[uc],g=h[D](f/1.618),k=h[D](f/3.236),l=f+g,n=f+k,f=[],k=0,q=h[D](a.Yb[G]),s=0;s<c[J];s++){var u=c[s],w=b[s][J];if(0!=w){var z=UN(a.Wc,u[cd],a.ta,e,w),w={};w.id=u.id;w.ma={text:u[cd],X:a.ta,cq:null,F:[],anchor:new uP(q,0),Cc:nI,Bc:nI,vb:z.ge?u[cd]:O,Cb:0};w.Wb={};tw(w.Wb,new vl(q,k,a.ek,a.iF));w.Wb.brush=u.brush.o();a.ta.Tb&&w.Wb.brush.dd(a.ta.Tb,1);w.O=!0;for(var B=0;B<z.F[J];B++)0<B&&(k+=n),w.ma.F[C]({x:d,y:k,length:e,text:z.F[B]});
np(w,u[nc]);k+=l;f[C](w)}}b=h[D](a.Yb.top);a.Mq||(g=k-g,c=a.Yb[Hc]-a.Yb.top,a.tL==oE?b+=c-g:a.tL==pD&&(b+=h[t]((c-g)/2)));for(s=0;s<f[J];s++)w=f[s],w.Wb[Ey].top+=b,w.ma[Gz].y+=b;return f}function MJa(a,b,c,d){for(var e=Hi(b,function(a,b){return h.max(a,b.F[J])},0),f=[],g=0;g<e;g++){var k=0==g?c:d;Y(b,function(a,b){g<a.F[J]&&f[C]({key:b,min:0==g&&0==b?this.ta[uc]:k,Tc:[]})},a)}return f}function JJa(a,b){var c=a[J]-1;return 1<a[J]&&1>b[c][J]}
function IJa(a,b){var c=a.Yb[Hc]-a.Yb.top,d=a.ta[uc],e=c-a.tE*d,f=1<a.tE?e/(a.tE-1):0,g=(c-((d+f)*b[J]-f))/2,k=[];Y(b,function(a){var b=h[D](g);Y(a,function(a){a.ma[Gz].y+=b;a.Wb[Ey].top+=b});g+=d+f;Zi(k,a)});return k}function US(a,b,c){var d=a.ek+a.ht,e=h.min(a.Pl[r]*(2-1.618)/2,c);if(e<d)return[];a=PJa(a,e,b);return aP(a,c)}
function HJa(a,b,c,d){for(var e=a.Yb[Zc]-a.Yb[G],f=a.ek+a.ht,g=h[D](1.618*a.ta[uc]),k=[],l=0,n=h[D](a.Yb.top),q=0;q<b[J];q++){var s=c[q],u=UN(a.Wc,s[cd],a.ta,b[q]-f-(0<q?g:0),1),w=0<u.F[J]?u.F[0]:O,z=a.Wc(w,a.ta)[r],B=[{x:l+f,y:0,length:z,text:w}],F={};F.id=s.id;F.ma={text:s[cd],X:a.ta,cq:null,F:w?B:[],anchor:new uP(0,n),Cc:nI,Bc:nI,vb:u.ge?s[cd]:O,Cb:0};F.O=!0;F.Wb={};F.Wb.brush=s.brush.o();a.ta.Tb&&F.Wb.brush.dd(a.ta.Tb,1);tw(F.Wb,new vl(l,n,a.ek,a.iF));np(F,s[nc]);k[C](F);l+=z+f+g}b=a.Yb[G];d||
(d=l-g,a.tL==oE?b+=e-d:a.tL==pD&&(b+=h[t]((e-d)/2)));for(q=0;q<k[J];q++)F=k[q],Ya(F.Wb[Ey],F.Wb[Ey][G]+b),F.ma[Gz].x+=b;return k}function PJa(a,b,c){var d=a.ek+a.ht,e=h[D](1.618*a.ta[uc]);return Gi(c,function(a,c){var k=this.Wc(a[cd],this.ta)[r]+d,l=h.min(b,k),k=k-l;0<c&&(l+=e);return{min:l,Tc:[k]}},a)}function TS(a,b){for(var c=Oe;10<=b;)c+=Oe,b/=10;return a.Wc(c+Tq+c,a.S5)[r]};function WS(a,b,c,d,e){this.mz=a;this.Nb=null;rp(this,b);this.Ac=c;this.fj=this.kf=null;a=this.L=this.f5();a.Ac=c;pa(a,d);Sa(a,e);a.Wa=Gn(b,Ah,aFa,R);a.Kj=zn(b,GE);a.Nl=vn(b,HE,h[D](h.pow(2*(a[r]+a[A]),1/3)));a.eT=Gn(b,kza,bFa,JF);a.Ls=pn(b,AAa);a.Gy=Gn(b,eza,ofa,oh);a.R2=pn(b,awa);a.nD=Jn(b,HC);a.W2=Jn(b,Era);c=a.W2;d=a.nD;c=Xm(c)?c.gb():Xm(d)?Wm(c)?Mm(c.gb(),d.gb(),c.Oe):d.gb():null;a.fK=c;a.lea=Cn(b,gra,O);a.T2=Cn(b,Yua,O);a.$u=a.fK||O;c=zn(b,HI);a.Iy=Gn(b,yAa,qP,XG);d=Ln(b,JI,{Va:a.Kj,fontSize:a.Nl,
Tb:a.Iy==mF?a.$u:R});Ap(a,{text:c,X:d,cq:null,F:[],Cc:nI,Bc:oE,vb:O,anchor:null,Cb:0});a.qD=Gn(b,dra,qP,XG);a.Fc=pn(b,sF);a.Lj=pn(b,qF);a.By=Gn(b,Mva,nFa,ZD);this.e5();this[Fc]();if(a.By==gE&&(!a.xf||a.xf.line!=a.k[J]))throw m("DIVE interactivity model is only supported when all series are of type line.");}WS[K].f5=function(){return new sS};WS[K].Ay=function(){return this.L};
Ma(WS[K],function(){var a=this.L;QJa(this);var b=this.u6(),c=this.t6(),d=null,e=a.Wa;!a.Uc||e!==cH&&e!==QH?a.R2&&e!==cH&&e!==cD&&(d=2):d=2;this.kf=new SS(a,this[eq],b,d);this.fj=new AJa(a,this[eq],c);this.s6();FJa(this.kf);var b=this.L,e=b[uz].X[uc],c=this.kf.ta[uc],f=this.kf[zy](),g=this.fj.ta[uc],k=this.fj[zy](),d=b.Iy==XG?b[uz][cd]:O,l=UN(this.Ac,d,b[uz].X,b.A[r],ea),n=h.max(2,h[D](e/3.236)),q=h.max(2,h[D](c/1.618)),g=h.max(2,h[D](g/1.618)),s=h.max(2,h[D](1.618*b.Nl)),u=[];u[C]({key:XC,min:2,Tc:[s-
2]});u[C]({key:OI,min:0,Tc:[ea]});0<l.F[J]&&u[C]({key:HI,min:e+2,Tc:[]});if(f==NI){for(var f=this.kf,s=b.A[r],w=f.qE,z=US(f,w,s),B=1;(0==f.m4||f.m4>B)&&z[J]<w[J];)++B,w=$i(w,z[J]),z=US(f,w,s);s=B;for(f=0;f<s;++f)u[C]({key:DF,min:c+2,Tc:[q-2]})}k==NI&&u[C]({key:MD,min:this.fj[ez]()+2,Tc:[g-2]});for(f=1;f<l.F[J];f++)u[C]({key:HI,min:e+2,Tc:[n-2]});k=bP(u,b.A.top);e=k[OI][0]||0;l=k[uz]||[];n=UN(this.Ac,d,b[uz].X,b.A[r],l[J]);for(f=0;f<n.F[J];f++)e+=l[f],b[uz].F[C]({text:n.F[f],x:b.A[G],y:e,length:b.A[r]});
b[uz].vb=n.ge?d:O;d=k.legend||[];0<d[J]&&(this.kf.tE=d[J],c=e+d[0]-c,e+=Mda[Mc](null,d),this.kf.Go(new rl(c,b.A[Zc],e,b.A[G])));c=k.colorBar||[];0<c[J]&&(e+=c[0],b=new rl(e-this.fj[ez](),b.A[Zc],e,b.A[G]),this.fj.Go(b));a.Ea=this.kf.zW();a.gi=this.fj.zW()});WS[K].e5=function(){var a=this.mz,b=new ku(a);if(2>b.H())throw m("Not enough columns given to draw the requested chart.");if(pn(this[eq],EH)){for(var c=[],a=a.M()-1;0<=a;a--)c[C](a);b.qn(c)}this.Nb=b};
function RJa(a,b,c,d){null!=b||(b=d());b=h[D](b);null!=a||(a=(c-b)/2);a=h[D](a);b=h.min(a+b,c);return{start:a,end:b}}
function QJa(a){var b=a.L,c=Mn(a[eq],wD,b[r]),d=Mn(a[eq],tD,b[A]),e=Mn(a[eq],vD,b[A]),f=Mn(a[eq],uD,b[r]),g=W(function(){var a=b[r]/1.618,c=b[r]-b[A]*(1.618-1);return h[D](a>c?a:(a+2*c)/3)},a),f=RJa(f,c,b[r],g),c=h.min(f[y],f.end),f=f.end,g=f-c;a=W(function(){var a=b[A]/1.618,c=b[A]-b[r]*(1.618-1);return h[D](a>c?a:(a+2*c)/3)},a);e=RJa(e,d,b[A],a);d=h.min(e[y],e.end);e=e.end;b.A={left:c,right:f,width:g,top:d,bottom:e,height:e-d}};function XS(a,b,c,d){return new SJa(a,b,c,d)}function SJa(a,b,c,d){this.vN=b;this.le=new Io({pattern:a});this.Opa=c;this.Npa=d}ua(SJa[K],function(a){a/=this.vN;return this.le.Ee(a)+(ne+(2>h.abs(a)?this.Opa:this.Npa))});function YS(){this.wca=new Date;this.Dk(tf)}YS[K].Dk=function(a){switch(a){case Sf:a=Do.YEAR_FULL;break;case Bf:a=jba;break;case vf:a=Do.YEAR_MONTH_ABBR;break;case jf:a=qo[vd].SHORT_DATE;break;default:a=qo[vd].SHORT_DATETIME}this.le=new Go({pattern:a,timeZone:0})};ua(YS[K],function(a){this.wca[Jc](a);return this.le.Ee(this.wca)});function ZS(){this.S1=null;this.hD=[];this.AV=this.ny=this.LJ=null}function $S(a,b){a.S1=b;return a}function aT(a,b){a.LJ=b;return a}ZS[K].mE=function(a){this.ny=a;return this};
function TJa(a,b){var c;c=cP(di(b)?b:3);c=[XS(c,h.pow(10,15),dpa,dpa),XS(c,h.pow(10,12),Apa,Apa),XS(c,h.pow(10,9),boa,boa),XS(c,h.pow(10,6),Roa,Roa)];a.hD=c;return a}function bT(a){var b;b=cP(di(5)?5:3);b=[XS(b,h.pow(10,15),Af,Af),XS(b,h.pow(10,12),Lf,Lf),XS(b,h.pow(10,9),$na,$na),XS(b,h.pow(10,6),sf,sf)];a.hD=b;return a}ZS[K].jq=function(){var a;a=this.AV?new Io(this.AV):new Io({pattern:cP(di(this.S1)?this.S1:16)});return new UJa(a,this.hD,this.LJ,this.ny)};
function UJa(a,b,c,d){this.Upa=a;this.hD=b||[];this.LJ=c||null;this.ny=d||null}ua(UJa[K],function(a){var b=0>a;a=h.abs(a);if(this.LJ){var c=this.LJ;if(0!=a){var d=h[t](h.log(h.abs(a))/BDa)+1;d>c?(c=h.pow(10,d-c),a=h[D](a/c)*c):(c=h.pow(10,c-d),a=h[D](a*c)/c)}}c=null;for(d=0;d<this.hD[J];d++){var e=this.hD[d];if(a>=e.vN){c=e[Kb](a);break}}null==c&&(c=this.Upa.Ee(a));this.ny&&(a=this.ny.symbol,d=this.ny.usePadding?ne:O,c=this.ny[jc]==zs?c+d+a:a+d+c);return b?Le+c:c});function cT(a,b,c,d,e,f){this.hd=a;this.ya=b;this.vw=c;this.zt=d;this.Gb=f}function VJa(a,b,c){return new cT(a,b,!0,!0,0,c)}function dT(a,b,c){return new cT(a,b,!1,!1,0,c)}pw(cT[K],function(){return h[D](this.ya)});fb(cT[K],function(){return this.hd});cT[K].sd=function(){return this.Gb};cT[K].Zl=function(a){this.Gb=a};function eT(a,b){this.JJ=a;this.IJ=b||0;var c;c=this.JJ+this.IJ;if(1<=c)c=1;else{var d=c[hc]();c=0;var e=d[ld](jE);-1!=e?c=la(d[ec](e+1),10):e=d[J];d=d[ld](Me);-1!=d&&(c-=e-1-d);c=h.pow(10,-c)}this.hca=c;this.ya=0}T=eT[K];Ga(T,function(){this.ya++;return this[I]()});T.wg=function(){this.ya--;return this[I]()};fb(T,function(){return h[D]((this.ya*this.JJ+this.IJ)*this.hca)/this.hca});ta(T,function(a){this.ya=h[t]((a-this.IJ)/this.JJ);return this[I]()});
sa(T,function(a){this.ya=h[xb]((a-this.IJ)/this.JJ);return this[I]()});Va(T,function(a){this.ya=h[D]((a-this.IJ)/this.JJ);return this[I]()});function WJa(a,b,c,d){this.fa=a;this.dg=b;this.ib=c;this.le=d}function XJa(a,b){var c=b[J];if(0<c)for(;--c;)if(YJa(a,b[c-1],b[c]))return!1;return!0}function YJa(a,b,c){var d=ZJa(a,b),e=ZJa(a,c);return h.abs(a.fa.fb(b)-a.fa.fb(c))<(d+e)/2}function ZJa(a,b){var c=a.le[Kb](b);return a.dg.mu(c,a.ib)}function $Ja(a,b,c){b=a.fa.bf(b);a=a.fa.bf(c);return h.abs(a-b)}function fT(a,b){for(var c=[],d=0;d<b[J];d++){var e=b[d];c[C](VJa(e,a.fa.fb(e),a.le[Kb](e)))}return c}
function gT(a,b,c,d){if(b==c)return[b];if(!xj(b))return[c];var e=[];for(b=a[xb](b);b<=c;)e[C](b),b=a[oc]();1==e[J]&&(b=(new eT(d/10))[t](c),b!=e[0]&&e[C](b));return e};function hT(a,b,c,d,e){this.lJ=a;this.nR=b;this.nS=c;this.E1=d;this.jD=e;a=iT(this,a);b=iT(this,b)-a;this.py=(d-c)/b;this.QJ=this.py*a-c}hT[K].fb=function(a){return iT(this,a)*this.py-this.QJ};hT[K].bf=function(a){t:switch(a=(a+this.QJ)/this.py,this.jD){case 0:a=h.pow(h.E,a);break t;case 1:break t;default:a=h.pow(a*this.jD+1,1/this.jD)}return a};function iT(a,b){switch(a.jD){case 0:return h.log(b);case 1:return b;default:return(h.pow(b,a.jD)-1)/a.jD}};function jT(a,b,c,d,e,f){this.ks=a;this.dJ=b;this.Jz=c;this.Iz=d;this.Pu=e;this.$aa=f;this.ks==this.dJ?e=this.ks/2:ga(this.$aa)?e=TO(1,VO(this.dJ-this.ks))/1E3:(e=this.$aa/2,0<this.ks&&(e=h.min(this.ks,e)));this.Hl=e;a>=this.Hl?(this.Sf=new hT(a,b,c,d,this.Pu),this.ei=h[D](this.Sf.fb(this.Hl))):b<=-this.Hl?(this.Sf=new hT(-b,-a,d,c,this.Pu),this.ei=h[D](this.Sf.fb(this.Hl)),f=2*this.ei-d,e=2*this.ei-c,this.Sf=new hT(-b,-a,f,e,this.Pu)):a>=-this.Hl?(this.ei=h[D](c),this.Sf=new hT(this.Hl,b,this.ei,
d,this.Pu)):b<=this.Hl?(this.ei=h[D](d),e=2*this.ei-c,this.Sf=new hT(this.Hl,-a,this.ei,e,this.Pu)):(this.Sf=new hT(this.Hl,b,0,1,this.Pu),e=this.Sf.fb(-a),this.ei=h[D](c+e/(e+1)*(d-c)),b>=-a?this.Sf=new hT(this.Hl,b,this.ei,d,this.Pu):(e=2*this.ei-c,this.Sf=new hT(this.Hl,-a,this.ei,e,this.Pu)));this.eg=d<c}T=jT[K];T.Sb=function(){return this.ks};T.Zb=function(){return this.dJ};T.Zn=function(){return this.Jz};T.Dm=function(){return this.Iz};
T.bf=function(a){if(this.ks==this.dJ)return this.ks;var b=this.eg?-1:1;return a*b>this.ei*b?this.Sf.bf(a):a*b<this.ei*b?-this.Sf.bf(2*this.ei-a):0};T.fb=function(a){return this.ks==this.dJ?h.abs(this.Jz-this.Iz)/2:a>this.Hl?this.Sf.fb(a):a<-this.Hl?2*this.ei-this.Sf.fb(-a):this.ei};function kT(a){this.Fpa=a[Ab]();this.GJ=a[J];this.ya=0}T=kT[K];Ga(T,function(){this.ya++;return this[I]()});T.wg=function(){this.ya--;return this[I]()};fb(T,function(){var a=h[t](this.ya/this.GJ);return TO(this.Fpa[this.ya-a*this.GJ],a)});ta(T,function(a){this.ya=this.GJ*WO(a);if(this[I]()!=a)for(;this.wg()>a;);return this[I]()});sa(T,function(a){this.ya=this.GJ*VO(a);if(this[I]()!=a)for(;this[oc]()<a;);return this[I]()});
Va(T,function(a){this.ya=this.GJ*WO(a);if(this[I]()!=a){for(;this.wg()>a;);if(a-this[I]()<this[oc]()-a)return this.wg()}return this[I]()});function lT(a,b,c,d,e){this.Sf=a;this.G0=e;this.Kp=new WJa(a,c,d,b);this.Sr=new kT([1,2,5])}lT[K].cG=function(){var a=this.O_(),b;this.Sr[t](a);do b=new eT(a),b=gT(b,this.Sf.Sb(),this.Sf.Zb(),a),a=this.Sr[oc]();while(!XJa(this.Kp,b));return fT(this.Kp,b)};lT[K].O_=function(){var a=this.Sf.Zn(),b=this.Sf.Dm(),c=$Ja(this.Kp,b-this.G0,b),d=$Ja(this.Kp,a,a+this.G0),c=h.max(d,c),d=this.Sf.fb(0);d>=a&&d<=b&&(a=this.Sf.bf(this.Sf.fb(0)+this.G0),c=h.max(c,a));return this.Sr[xb](c)};function mT(a,b,c,d){this.lJ=a;this.nR=b;this.T1=c;this.fda=d;this.py=(this.fda-this.T1)/(this.nR-this.lJ);this.QJ=this.py*this.lJ-this.T1}T=mT[K];T.bf=function(a){return(a+this.QJ)/this.py};T.fb=function(a){return a*this.py-this.QJ};T.Zn=function(){return this.T1};T.Dm=function(){return this.fda};T.Sb=function(){return this.lJ};T.Zb=function(){return this.nR};function nT(a,b){this.jR=a;this.kJ=h[t](a/10);this.ss=a-this.kJ;this.ec=0;this.mR=VO(h.abs(b));this.gy=this.ss*this.mR;this.ya=0}function aKa(a){var b=h[t](a.ya/a.ss);a=10*(a.ya+a.kJ-b*a.ss)/a.jR;0==a&&(a=1);return TO(a,b)}T=nT[K];fb(T,function(){this.ya=h.abs(this.ec)+this.gy;return 0<this.ec?aKa(this):0>this.ec?-aKa(this):0});Ga(T,function(){this.ec++;return this[I]()});T.wg=function(){this.ec--;return this[I]()};
ta(T,function(a){var b=this.kJ,c=VO(h.abs(a));if(h.abs(a)<=h.pow(10,this.mR))return this.ec=0>a?-1:0,this[I]();0<a?this.ec=this.ss*c-this.gy:0>a&&(this.ec=this.gy-this.ss*c,b=-b);this[I]()!=a&&(c=this.jR*a/TO(1,WO(h.abs(a))),this.ec+=h[t](c)-b);return this[I]()});
sa(T,function(a){var b=this.kJ,c=VO(h.abs(a));if(h.abs(a)<=h.pow(10,this.mR))return this.ec=0<a?1:0,this[I]();0<a?this.ec=this.ss*c-this.gy:0>a&&(this.ec=this.gy-this.ss*c,b=-b);this[I]()!=a&&(c=this.jR*a/TO(1,WO(h.abs(a))),this.ec+=h[xb](c)-b);return this[I]()});
Va(T,function(a){var b=VO(h.abs(a));if(h.abs(a)<=h.pow(10,this.mR))return this.ec=0;if(0<a){this.ec=this.ss*b-this.gy;if(this[oc]()>a)return a-this[I]()>=this.wg()-a?this[oc]():this[I]();this.wg()}else if(0>a){this.ec=this.gy-this.ss*b;if(this.wg()<a)return a-this[I]()<this[oc]()-a?this.wg():this[I]();this[oc]()}this[I]()!=a&&(b=this.jR*a/TO(1,WO(h.abs(a))),this.ec+=h[D](b)-this.kJ);return this[I]()});function oT(a,b,c,d,e,f){this.fa=a;this.le=b;this.dg=c;this.ib=d;this.xj=f;this.dma=e;this.Kp=new WJa(a,c,d,b);this.Sr=new kT([1,2,5])}
oT[K].cG=function(){var a=this.xj/10,b=this.O_(),c=new nT(b,a),c=gT(c,this.fa.Sb(),this.fa.Zb(),b);if(2>c[J])return fT(this.Kp,c);var b=c[0],d=c[1];if(0==b){if(3>c[J])return fT(this.Kp,c);b=d;d=c[2]}c=TO(1,WO(h.abs(b)));c==b&&(c*=10);this.Sr[xb](c/h.abs(d-b));do if(b=this.Sr.wg(),c=new nT(b,a),c=gT(c,this.fa.Sb(),this.fa.Zb(),b),b=this.Kp,d=[],!(1>=c[J]||0!=c[0])){d[C](c[0]);for(var e=1,f=c[J];e<f;e++)YJa(b,c[0],c[e])||d[C](c[e]);c=d}while(!XJa(this.Kp,c));return fT(this.Kp,c)};
oT[K].O_=function(){var a=this.fa.fb(10*this.xj),b;this.Sr[t](1);do b=this.Sr[oc](),b=this.fa.fb(10*this.xj*(b-1)/b);while(h.abs(a-b)>=this.dma);return this.Sr.wg()};function bKa(a,b){this.wy=null!=a?a:1;12<this.wy&&(this.Cqa=new eT(h[t](this.wy/12)));this.Aqa=b||0;this.Ml=new Date;this[t](0)}T=bKa[K];fb(T,function(){return this.Ml[bc]()});Ga(T,function(){var a=this.Ml[zc](),a=a+this.wy;this.Ml[Ud](a);return this[I]()});T.wg=function(){this.Ml[Ud](this.Ml[zc]()-this.wy);return this[I]()};
ta(T,function(a){this.Ml[Jc](a);1<this.wy&&(this.Ml[Ud](this.Ml[zc]()-(this.Ml[zc]()+12-this.Aqa)%this.wy%12),12<this.wy&&(a=this.Cqa[t](this.Ml[Jb]()),this.Ml.setUTCFullYear(a)));this.Ml.setUTCDate(1);this.Ml.setUTCHours(0,0,0,0);return this[I]()});sa(T,function(a){return this[t](a)<a?this[oc]():this[I]()});Va(T,function(a){return this[t](a)!=a&&a-this[I]()<this[oc]()-a?this.wg():this[I]()});function cKa(){this.ya=0}T=cKa[K];Ga(T,function(){this.ya++;return this[I]()});T.wg=function(){this.ya--;return this[I]()};fb(T,function(){return TO(1,this.ya)});ta(T,function(a){this.ya=VO(a);return this[I]()});sa(T,function(a){this.ya=WO(a);return this[I]()});Va(T,function(a){var b=TO(1,WO(a)),c=b/10;this.ya=h[D](0.4342944819032518*h.log(a-c<b-a?c:b));return this[I]()});function dKa(a){a?(this.Dj=[1E3,5E3,1E4,15E3,3E4,6E4,3E5,6E5,9E5,18E5,36E5,108E5,216E5,432E5,864E5,6048E5,2629746E3,7889238E3,31556952E3],this.Ne=new kT([1,2,5])):(this.Dj=[1E3,6E4,36E5,864E5,6048E5,2629746E3,7889238E3,31556952E3],this.Ne=new cKa);this.gR=this.Ne[D](this.Dj[0]);this.r0=this.Ne.wg();this.xna=this.r0+(this.gR-this.r0)/2;this.AC=this.Dj[this.Dj[J]-1];this.Ne[D](1);this.Zaa=this.AC*this.Ne[oc]();this.zna=this.AC+(this.Zaa-this.AC)/2;pT(this,2)}
function pT(a,b){a.t0=1==b||4==b;2==b?a.ya=0:3==b?a.ya=a.Dj[J]-1:1==b?a.Vi=1:4==b&&(a.Vi=a.AC)}T=dKa[K];fb(T,function(){return this.t0?this.Vi*this.Ne[I]():this.Dj[this.ya]});ta(T,function(a){if(a<this.gR)return pT(this,1),this.Ne[t](a);if(a>=this.Zaa)return pT(this,4),this.Vi*this.Ne[t](a/this.Vi);for(pT(this,2);a>=this.Dj[this.ya];)this.ya++;return this.Dj[--this.ya]});
sa(T,function(a){if(a<=this.r0)return pT(this,1),this.Ne[xb](a);if(a>this.AC)return pT(this,4),this.Vi*this.Ne[xb](a/this.Vi);for(pT(this,3);a<=this.Dj[this.ya];)this.ya--;return this.Dj[++this.ya]});Va(T,function(a){if(a<this.xna)return pT(this,1),this.Ne[D](a);if(a>=this.zna)return pT(this,4),this.Vi*this.Ne[D](a/this.Vi);for(pT(this,3);0<this.ya&&a<this.Dj[this.ya];)this.ya--;this.Dj[this.ya+1]-a<=a-this.Dj[this.ya]&&this.ya++;return this.Dj[this.ya]});
Ga(T,function(){this.t0?(this.Ne[oc](),1==this.Vi&&this.Ne[I]()==this.gR&&pT(this,2)):(this.ya++,this.ya==this.Dj[J]&&(pT(this,4),this.Ne[D](1),this.Ne[oc]()));return this[I]()});T.wg=function(){this.t0?(this.Ne.wg(),this.Vi==this.AC&&1==this.Ne[I]()&&pT(this,3)):(this.ya--,-1==this.ya&&(pT(this,1),this.Ne[D](this.gR),this.Ne.wg()));return this[I]()};function qT(a){a=(new dKa(!0))[D](a);return 2629746E3>a?6048E5==a?new eT(a,3456E5):new eT(a):new bKa(h[D](a/2629746E3))}
function eKa(a){if(!na(a))return txa;var b=new Date;b[Jc](a);a=O+rT(b[Jb]()[hc](),4);var c=b[zc](),d=b[Jd](),e=1!=d,f=b[ee](),g=b[de](),k=b.getUTCSeconds(),b=b.getUTCMilliseconds(),l=0!=f||0!=g||0!=k||0!=b;if(0!=c||e||l)a=a+Le+rT((c+1)[hc](),2);if(e||l)a+=Le,a+=rT(d[hc](),2);l&&(a+=Lf,a+=rT(f[hc](),2),a+=Xe,a+=rT(g[hc](),2),a+=Xe,a+=rT(k[hc](),2),a+=Me,a+=rT(b[hc](),3));return a}
function sT(a,b){var c=O,d=new Date;d[Jc](a);var e=d[zc](),f=d[Jd](),g=d[ee](),k=d[de](),l=d.getUTCSeconds(),n=d.getUTCMilliseconds(),c=c+rT(d[Jb]()[hc](),4);if(b==Sf)return c;c=c+Le+rT((e+1)[hc](),2);if(b==vf)return c;c+=Le;c+=rT(f[hc](),2);if(b==jf)return c;c+=Lf;c+=rT(g[hc](),2);c+=Xe;c+=rT(k[hc](),2);c+=Xe;c+=rT(l[hc](),2);c+=Me;return c+=rT(n[hc](),3)}function rT(a,b){for(var c=a[J];c<b;c++)a=Oe+a;return a}
function tT(a){if(a==txa||null==a||a==O)return ja;var b=0,c=0,d=1,e=0,f=0,g=0,k=0,b=la(a[ec](0,4),10);4<a[J]&&(c=la(a[ec](5,2),10)-1,7<a[J]&&(d=la(a[ec](8,2),10),10<a[J]&&(e=la(a[ec](11,2),10),f=la(a[ec](14,2),10),g=la(a[ec](17,2),10),k=la(a[ec](20,3),10))));return Date.UTC(b,c,d,e,f,g,k)}function uT(a,b){if(a[y]==a.end||0==b)return a;var c=(a.end-a[y])*b,d;d=a[y];d=0>d?-fKa(-d,c):gKa(d,c);var e=a.end,c=0>e?-gKa(-e,c):fKa(e,c);return new zm(d,c)}
function gKa(a,b){if(0==a)return 0;for(var c=a,d=0,e=ja;0<c;){var f=VO(c),g=TO(1,f),k=hKa(c);if(5<k&&(e=5*g+d,e=vT(e,f),e<=a&&e>a-b))break;e=k*g+d;e=vT(e,f);if(e<=a&&e>a-b)break;f=k*g;d+=f;c-=f}return e}function fKa(a,b){if(0==a)return 0;for(var c=a,d=0,e=ja;0<c;){var f=VO(c),g=TO(1,f),k=hKa(c);if(5>k&&(e=5*g+d,e=vT(e,f),e<=a+b&&e>=a))break;e=k*g+d;e=vT(e,f);if(e<=a+b&&e>=a)break;e=(k+1)*g+d;e=vT(e,f);if(e<=a+b&&e>=a)break;f=k*g;d+=f;c-=f}return e}
function vT(a,b){var c=TO(1,h.abs(b));return h[D](a*c)/c}function hKa(a){var b=VO(a),b=TO(1,b);a/=b;b=h.abs(h[D](a)-a);0!=b&&1E-10>b&&(a=h[D](a));return h[t](a)};function iKa(a,b,c,d,e,f,g,k,l){this.Wja=a;this.Q8=b;this.R8=c;this.dg=d;this.Nf=e;this.fa=f;this.jP=g;this.ib=k;this.HY=l;this.Vja=no(a);this.oP=no(b);this.Nf.Dk(this.Q8)}function jKa(a,b,c){var d=a.fa.fb(b);c=a.fa.fb(c);d=(d+c)/2;return dT(a.fa.bf(d),d,a.Nf[Kb](b))};function wT(a,b,c,d,e,f,g){this.fa=a;this.Pj=b;this.dg=c;this.Nf=d;this.jP=e;this.ib=f;this.HY=g;this.W8=[xT(this,jf,1),xT(this,jf,7),xT(this,vf,1),xT(this,vf,2),xT(this,vf,3),xT(this,Bf,1),xT(this,vf,6),xT(this,Sf,1),xT(this,Sf,2),xT(this,Sf,5),xT(this,Sf,10),xT(this,Sf,20),xT(this,Sf,50),xT(this,Sf,100),xT(this,Sf,1E3),xT(this,Sf,1E4),xT(this,Sf,1E7)]}function xT(a,b,c){return new iKa(a.Pj,b,c,a.dg,a.Nf,a.fa,a.jP,a.ib,a.HY)}
wT[K].cG=function(){for(var a=no(this.Pj),b=0;b<this.W8[J];b++){var c=this.W8[b];if(a<=c.oP){t:{var d=c,e=d.fa.Sb(),f=d.fa.Zb();d.Nf.Dk(d.Wja);if(e==f)c=[dT(e,h.abs(d.fa.Zn()-d.fa.Dm())/2,d.Nf[Kb](e))];else{var g,c=d.Nf[Kb](f);g=new cT(f,d.fa.Dm(),!0,!0,0,c);d.Nf.Dk(d.Q8);for(var k=1==d.R8&&d.oP>d.Vja,l=qT(d.oP*d.R8),n=qT(d.oP),c=[],q=ja,s=l[xb](e),e=n[xb](e);e<=f;e=n[oc]()){var u=d.fa.fb(e);if(e==s){var s=l[oc](),w=d,z=q,B=e,F=w.dg.mu(w.Nf[Kb](z),w.ib),M=w.dg.mu(w.Nf[Kb](B),w.ib);if(h.abs(w.fa.fb(z)-
w.fa.fb(B))-(F+M)/2<w.jP){c=null;break t}k?(ga(q)||c[C](jKa(d,q,e)),c[C](new cT(e,u,!0,!0,0,null))):(q=VJa(e,u,d.Nf[Kb](e)),c[C](q));q=e}else c[C](new cT(e,u,!1,!0,0,null))}k&&f<e&&(l=d,k=c,e=n,n=l.Nf[Kb](f),s=l.dg.mu(n,l.ib),q=e[I](),e=e.wg(),e=l.fa.fb(e),q=l.fa.fb(q),l=l.fa.fb(f),q=(e+q)/2,l-q>s/2&&k[C](dT(f,q,n)));if(d.HY){f=d;n=g;l=c;k=void 0;i:{for(k=l[J]-1;0<=k;k--)if(null!=l[k].sd()){k=l[k];break i}k=null}null!=k&&(l=f.dg.mu(k.sd(),f.ib),s=f.dg.mu(n.sd(),f.ib),h.abs(k[zy]()-n[zy]())-(l+s)/
2<f.jP&&k.Zl(null));c[C](g)}g=c;for(n=f=0;n<g[J];n++)null!=g[n].sd()&&f++;if(2>f)c=d,d=c.Nf[Kb](c.fa.Sb()),g=c.Nf[Kb](c.fa.Zb()),d=d+Le+g,g=[],f=h.abs(c.fa.Zn()-c.fa.Dm()),c.dg.qc(d)>f+40||g[C](dT(ja,c.fa.Zn()+c.fa.Dm()/2,d)),c=g;else{i:{d=c;if(!(2>d[J]))for(g=d[0],f=1;f<d[J];f++){n=d[f];if(5>h.abs(n[zy]()-g[zy]())&&g[I]()!=n[I]()){d=!0;break i}g=n}d=!1}if(d){d=[];for(g=0;g<c[J];g++)f=c[g],f.zt&&!f.vw||d[C](f);c=d}}}}if(null!=c)return c}}return[]};function yT(a,b,c,d,e,f,g,k,l,n,q){e&&(e=c,c=d,d=e);if(a==b)return g=(d-c)/2+c,q=q[Kb](a),[dT(a,g,q)];a=1==f?new mT(a,b,c,d):new jT(a,b,c,d,f,g);if(a.Sb()==a.Zb())b=1;else{c=h.min(a.Zn(),a.Dm());d=h.max(a.Zn(),a.Dm());f=h.abs(a.bf(c));e=h.abs(a.bf(d));b=h.max(f,e);var s=0,u=a.fb(0);if(c>u||u>d)s=h.min(f,e);c=a.fb(s);b=a.fb(b);b=kKa(c,a)/kKa(b,a)}return(0.65<b?new lT(a,q,n,k,l):new oT(a,q,n,k,l,g)).cG()}function kKa(a,b){var c=b.bf(a),d=b.bf(a+10);return h.abs(d-c)};function zT(a,b){this.Ara=a;this.zra=b}zT[K].qc=function(a){return a[J]*this.Ara};Kw(zT[K],function(){return this.zra});zT[K].mu=function(a,b){return b==Jg?this.qc(a):this[ez](a)};function AT(a,b){this.JR=a;this.ta=b}AT[K].qc=function(a){return this.JR(a,this.ta)[r]};Kw(AT[K],function(a){return this.JR(a,this.ta)[A]});AT[K].mu=function(a,b){return b==Jg?this.qc(a):this[ez](a)};function lKa(a,b,c,d,e){this.VX=a;this.uO=b;this.N8=c;this.Mja=vn(d,e(eva));this.Oja=vn(d,e(gva));this.Nja=vn(d,e(fva));this.Lja=vn(d,e(dva));this.Kja=vn(d,e(bva));this.p6=vn(d,e(cva));this.Pja=vn(d,e(kva));this.L8=pn(d,e(Zua))}function mKa(a,b){return new lKa(nKa,oKa,pKa,a,b)}
lKa[K].dga=function(a,b,c,d,e,f){var g,k;g=h[D](0.15*(b-a));a-=g;b+=g;k=dS(c,qKa,this.uO);c=dS((b-a)/this.Pja/2,this.VX,this.uO);var l=rKa(c);c=gS(l);g=a;a=this.N8[c];k=eS(k)<eS(l);a=sKa({Hh:g,Zi:b,oY:a[nc],t8:a[xz],u8:a.jx,pY:a.nu,Dta:Ai(a.nu),r8:this.Mja,Js:e.Js,gd:e.gd,s8:this.Kja,mY:[],q8:0},d,f);if(!(this.L8&&1==a[Cy]&&0<c&&k)){f=BT(this,e.gd,1==a[Cy]&&k?1:0,a.wb,a.UO);if(this.L8&&1<a[Cy]){if(a.vja/a[Cy]<this.Lja)d=[];else{e=e.Js;g=[];c=new fS(a.wb[0].ra,new Date(b),c,1);for(b=0;c.bx<c.Oz;)0!=
b%a[Cy]&&(k=c[oc](),l=d(k[bc]()),g[C]({ra:k,aa:l,O:!0,brush:e,length:5})),b++;d=g}a=Xi(a.wb,d)}else a=a.wb;return{wb:a,aj:f}}c=this.N8[c-1];f=sKa({Hh:g,Zi:b,oY:c[nc],t8:c[xz],u8:c.kx,pY:c.lx,r8:this.Oja,Js:e.kK,gd:e.OD,s8:this.p6,mY:a.wb,q8:this.Nja},d,f);if(null==f)return d=BT(this,e.gd,2,a.wb,a.UO),{wb:a.wb,aj:d};d=BT(this,e.gd,1,a.wb,a.UO);e=BT(this,e.OD,1,f.wb,f.UO,d);a=Xi(f.wb,a.wb);f=Xi(d,e);return{wb:a,aj:f}};
function sKa(a,b,c){for(var d=Gi(a.u8,function(a){return new Go({pattern:a})}),e=0;e<a.pY[J];++e){var f=a.pY[e],g=0,k=mIa(a.t8,f),k=aS(new Date(a.Hh),k);4==a.oY&&(k=jIa(k));for(var l=new fS(k,new Date(a.Zi),a.oY,f),k=[],n=!0,q=b(a.Hh),s=-1;l.bx<l.Oz;){var u=l[oc](),w=b(u[bc]());-1==s&&w>=q&&(s=k[J]);var z=l.zO();if(null!=z){z=b(z[bc]());if(z<w+1)continue;if(z-w<a.r8){n=!1;break}}for(z=!1;g<a.mY[J];){var B=a.mY[g];if(h.abs(B.aa-w)<a.q8){z=!0;break}if(B.aa>w){g=h.max(0,g-1);break}g++}z||k[C]({ra:u,
aa:w,O:!0,brush:a.Js,length:null})}if(n){1<s&&(k=$i(k,s-1));g=n=null;for(q=0;q<d[J];++q){s=d[q];u=!0;w=[];for(l=0;l<k[J];++l){var z=k[l],B=s.Ee(z.ra),F=c(B,a.gd)[r];if(l+1<k[J]&&k[l+1].aa-z.aa<a.s8+F){u=!1;break}w[C]({text:B,Oha:F})}if(u){n=q;g=w;break}}if(null!=n){a=ea;for(l=0;l<k[J]-1;++l)a=h.min(a,k[l+1].aa-k[l].aa);return{wb:k,UO:g,multiple:f,vja:a}}}}return null}
function BT(a,b,c,d,e,f){var g=[];if(null!=f)for(var k=0;k<f[J];++k){var l=f[k].ma,n=l.F[0];g[C](tKa(n.x,n[J],l.Cc,a.p6))}a=1==c?nI:pD;f=0;k=[];l=2==c?d[J]-1:d[J];for(n=0;n<l;++n){var q=d[n];if(q.O&&e[n]){for(var s=h[D](2==c?(d[n+1].aa+q.aa)/2:q.aa),u=e[n].Oha,w=tKa(s,u,a),z=!0;f<g[J];){var B=g[f],F=w,M=B;if(h.max(F[y],M[y])<=h.min(F.end,M.end)){z=!1;break}if(B[y]>w.end){f=h.max(0,f-1);break}f++}z&&k[C]({ra:q.ra,O:!0,aa:s,ma:{text:e[n][cd],X:b,F:[{x:s,y:0,text:e[n][cd],length:u}],Cc:a,Bc:oE,xta:e[n][cd],
anchor:null,Cb:0}})}}return k}function rKa(a){return Gi(a,function(a){return 0<a?1:0})}function tKa(a,b,c,d){d=Qh(d)?d:0;c==nI?(c=a,a=c+b):(c=h[D](a-b/2),a=h[D](a+b/2));return new zm(c-d,a+d)}
var qKa=[[1],[50],[500],[0,1],[0,15],[0,30],[0,0,1],[0,0,15],[0,0,30],[0,0,0,1],[0,0,0,6],[0,0,0,12],[0,0,0,0,1],[0,0,0,0,7],[0,0,0,0,0,1],[0,0,0,0,0,3],[0,0,0,0,0,6],[0,0,0,0,0,0,1]],nKa=[[1],[2],[5],[10],[20],[50],[100],[200],[500],[0,1],[0,2],[0,5],[0,10],[0,15],[0,30],[0,0,1],[0,0,2],[0,0,5],[0,0,10],[0,0,15],[0,0,30],[0,0,0,1],[0,0,0,2],[0,0,0,3],[0,0,0,4],[0,0,0,6],[0,0,0,12],[0,0,0,0,1],[0,0,0,0,2],[0,0,0,0,7],[0,0,0,0,0,1],[0,0,0,0,0,3],[0,0,0,0,0,0,1],[0,0,0,0,0,0,10],[0,0,0,0,0,0,50],[0,
0,0,0,0,0,100]],oKa=3,pKa=[{index:0,duration:[1],jx:[Fg],nu:[1,5,10,50,100,500],kx:[Fg],lx:[1,5,10,50,100]},{index:1,duration:[0,1],jx:[Fg],nu:[1,5,10,15,30],kx:[sna],lx:[1,5,10,15]},{index:2,duration:[0,0,1],jx:[Eg],nu:[1,2,5,15,20,30],kx:[cB],lx:[1,2,5,15]},{index:3,duration:[0,0,0,1],jx:["h a"],nu:[1,2,6,12],kx:["h a"],lx:[1,2,6]},{index:4,duration:[0,0,0,0,1],jx:[uf,ng],nu:[1,2,7],kx:[ng],lx:[1,7]},{index:5,duration:[0,0,0,0,0,1],jx:["MMM y","MMM yy",RB],nu:[1,3,6],kx:[RB],lx:[1,3]},{index:6,
duration:[0,0,0,0,0,0,1],jx:[Jh],nu:[1,2,5,10,20,50,100,200,500,1E3],kx:[Jh],lx:[1,2,5,10,20,50,100,200,500,1E3]}];function CT(a,b,c,d,e,f,g){this.CE=c;this.b=b;np(this,d);ab(this,Gn(b,this.Ha(Ah),eFa,e));this.Zi=this.Hh=null;this.XD=[];this.Bq=null;this.Iea=0<a.xf.bars;c=zn(b,this.Ha(HI));d={Va:a.Kj,fontSize:a.Nl,Tb:a.qD==mF?a.$u:R};d=Ln(b,this.Ha(JI),d);Ap(this,{text:c,X:d,cq:null,F:[],Cc:pD,Bc:nI,vb:O,anchor:null,Cb:0});this.aj=null;this.Sl=Gn(b,this.Ha(sAa),qP,XG);c={color:this[H]!=Dh||a.Wa==QH?zn(b,Wwa):zn(b,nxa),Va:a.Kj,fontSize:a.Nl,Tb:this.Sl==mF?a.$u:R};this.gd=Ln(b,this.Ha(EI),c);d=vn(b,this.Ha(iva));
d=Mm(this.gd[E],a.fK||te,d);this.OD=Ln(b,this.Ha(EI),c);Xa(this.OD,d);this.Pea=Gn(b,this.Ha(Gxa),jFa,ZAa);this.Z2=Gn(b,this.Ha(Iva),kFa,Twa);c=Cn(b,this.Ha(gra),a.lea);this.ZD=new Rm({fill:c});c=Cn(b,this.Ha($ua),a.T2);this.Js=new Rm({fill:c});this.Vo=vn(b,this.Ha(oxa),0);d=vn(b,this.Ha(hva));a=Mm(c,a.fK||te,d);a=Cn(b,this.Ha(AG),a);this.kK=new Rm({fill:a});this.Eo=2;this.Y2=h.max(this.Eo,h[D](this[uz].X[uc]/3.236));nw(this,[]);if(this.zi=g||b.R(this.Ha(GI)))this.zi=Gi(this.zi,function(a){var b={};
b.v=Qh(a.v)?a.v:a;bi(a.f)&&(b.f=a.f);return b});this.WD=0;this.Ol=sn(b,this.Ha(qg),1);Qv(this,this.Ol);this.Gh=this.hh=null;this.iz=this.pv=0;this.zb={min:-ea,max:ea};this.vq=null;this.$ea=f;f=XO(this.b,this.Ha(PF),this.Ha(PH));this.cfa=f===BG;this.Sy=f===OF||this.cfa;this[H]==Dh?(this.gT=this.Ed=this.ca=null,this.Pj=Gn(b,this.Ha(wAa),Dfa,tf),this.qK=ea):this.zi=null}T=CT[K];T.Ha=function(a){return KEa(this.CE,a)};function PS(a,b){di(b)&&0!==b&&!ga(b)&&(a.qK=h.min(h.abs(b),a.qK))}
T.$A=function(a){this.ca.$A(this.qK/10,a||[])};function DT(a,b,c){var d=qS().Ug(b);a.Tw=tn(c,a.Ha(ava));var e=a.Dr(),e=!a.Sy&&In(c,rE)&&(!In(c,Vta)||An(c,a.Ha(Wta+e)));!a.zi&&(e||0>a.Tw||null===a.Tw&&a.Sy)&&(a.gT=!0,a.Tw=-1);d[Fc](c,a.CE,a.Tw);a.ca=d;a.dataType=b;a.Hh=d.R(c,a.Ha(Wg));a.Zi=d.R(c,a.Ha(Ug));a.Bq=c.R(a.Ha(LC),vFa.vAxis.gridlines.baseline)}
function ET(a,b){a.vq=Hn(b,a.Ha(gJ),fFa);if(null===a.vq||a.vq==qE){if(a[H]==Dh){var c=a.ca,d=c.R(b,a.Ha(wBa));di(d)||(d=jP(c,c.R(b,a.Ha(fJ))));var e=c.R(b,a.Ha(vBa));di(e)||(e=jP(c,c.R(b,a.Ha(eJ))));null!=d&&(a.zb.min=d);null!=e&&(a.zb.max=e)}else a.zb.min=sn(b,a.Ha(fJ),a.zb.min),a.zb.max=sn(b,a.Ha(eJ),a.zb.max);a.zb.min>a.zb.max&&(c=a.zb.min,a.zb.min=a.zb.max,a.zb.max=c);a.vq=a.zb.min!=-ea||a.zb.max!=ea?qE:a.$ea;a[H]==Dh&&a.vq==qE&&(a.zb.min!=-ea&&(a.ca.jc=a.zb.min),a.zb.max!=ea&&(a.ca.ic=a.zb.max))}}
function uKa(a){return a.vq==qE&&(a.zb.min==-ea||a.zb.max==ea)}function vKa(a){if(a[H]==Dh&&!a.ca)throw m("Axis type/data type mismatch for "+a.CE);}
function wKa(a,b,c,d,e,f){a.hh=d+(1==a[jx]?0.5:-0.5);a.WD=c-1;a.Gh=d+c*a[jx];c=a.l8(b);d=!1;xKa(a)&&(pn(a.b,a.Ha(jva))||a.gT)&&(d=!0);b=d?yKa(a,b,e,f):zKa(a,b,e,f);return{title:a[uz],name:a.m8(),type:a[H],xo:a.Sy,dataType:a[yy],Ol:a.Ol,hh:a.hh,Gh:a.Gh,ke:{Se:W(a.i8,a),Bk:W(a.Po,a)},position:{Se:W(a.OG,a),Bk:W(a.A6,a)},VM:c,Ed:b.Ed,wb:b.wb,text:a.aj}}
function zKa(a,b,c,d){a[H]==Dh?(AKa(a),a.zi?BKa(a):a.gT?xKa(a)?CKa(a,b):DKa(a,b):EKa(a)):FKa(a,b,a.WD+1);var e=GKa(a),f=null;if(a[H]==Dh){var f=Gi(a[wy],function(a){return{Q9:a,ra:a.ra,aa:a.aa,O:!0,length:null,brush:this.Js}},a),g;if(g=a.Sy?HKa(a,f):IKa(a,f))g=Gi(g,function(a){return{ra:this.A6(a),aa:a,O:!0,length:null,brush:this.kK}},a),Zi(f,g);Ei(f,function(a){if(a.aa*this[jx]<this.hh*this[jx]||FT(this,a.aa))a.O=!1,Wi(this[wy],a.Q9);delete a.Q9},a)}a.iV(b,c,d,null);a.hV(b);return{wb:f,Ed:e}}
function yKa(a,b,c,d){GT(a);if(a.ca.jc>=a.ca.ic)return{wb:null,Ed:null};var e=GKa(a);cj(a.XD);for(var f=ea,g=1;g<a.XD[J];++g){var k=a.XD[g]-a.XD[g-1];k&&(f=h.min(f,k))}var g=mKa(a.b,W(a.Ha,a)),k={gd:a.gd,Js:a.Js,OD:a.OD,kK:a.kK},l=a[jx];Qv(a,1);var n=g.dga(a.ca.jc,a.ca.ic,f,W(a.se,a),k,b.Ac);Qv(a,l);-1===l&&(Ei(n.wb,function(a){a.aa=HT(this,a.aa)},a),Ei(n.aj,function(a){a.aa=HT(this,a.aa);a.ma.F[0].x=HT(this,a.ma.F[0].x)},a));var q=a.oL(b)[lz]===Eh;Ei(n.aj,function(a){a.ra=this.ca.Po(a.ra[bc]());
if(q){var b=a.ma.F[0].x;a.ma.F[0].x=a.ma.F[0].y;a.ma.F[0].y=b}},a);Ei(n.wb,function(a){a.ra=this.ca.Po(a.ra[bc]());if(a.aa*this[jx]<this.hh*this[jx]||FT(this,a.aa))a.O=!1,Wi(n.wb,a)},a);var s=nw(a,[]);Ei(n.aj,function(a){a.aa*this[jx]<this.hh*this[jx]||FT(this,a.aa)?Wi(n.aj,a):s[C]({ra:a.ra,aa:a.aa,text:a.ma[cd],O:a.O})},a);a.iV(b,c,d,n.aj);a.hV(b);return{wb:n.wb,Ed:e}}
function FKa(a,b,c){var d;a.vq==qE?(a.zb.min==-ea?a.zb.min=h.min(0,a.zb.max-1):a.zb.max==ea&&(a.zb.max=h.max(b.Ba[J],a.zb.min+1)),d=a.zb.max-a.zb.min):(a.zb.min=0,a.zb.max=b.Ba[J],d=b.Ba[J]);a.Iea&&(d=h.min(d,h[t]((c+1)/2)));a[H]==mD&&(d=h.max(1,d-1));a.iz=JKa(a);a.pv=a.WD/d;nw(a,$O(b.Ba[J],function(a){var c=a-this.iz;return{ra:b.Ba[a][Z],aa:this.se(a),text:b.Ba[a].Ts[0],O:0<=c&&c<=d}},a))}
function BKa(a){var b=a.ca;cj(a.zi,function(a,c){return b.K8(a.v,c.v)});0<a.zi[J]&&(a.fc(jP(b,a.zi[0].v)),a.fc(jP(b,a.zi[a.zi[J]-1].v)));GT(a);b.cH(b.jc,b.ic,!1);-1===a.Ol&&(a.zi=Yi(a.zi),a.zi[rx]());var c=Gi(a.zi,function(a){return jP(this.ca,a.v)},a);b.Ro(c);var d=kP(a.ca);nw(a,Gi(a.zi,function(a){var c=a.v,g=jP(b,c),g=this.se(g);a=a.f;bi(a)||(a=d.Ee(c));return{ra:c,aa:g,text:a,O:!0}},a))}
function EKa(a){PEa(a.ca,a.Hh,a.Zi,a.vq==oH||uKa(a));a.Sy&&KKa(a);var b=a.ca[wy];uKa(a)&&(b=Fi(b,function(a){return a>=this.zb.min&&a<=this.zb.max},a));di(a.Tw)&&2>a.Tw&&(b=$i(b,0,a.Tw));a.ca.Ro(b);a.ca.pH();var c=kP(a.ca);GT(a);nw(a,Gi(a.ca[wy],function(a){var b=this.ca.Po(a),f=c.Ee(b);return{ra:b,aa:this.se(a),text:f,O:!0}},a))}
function KKa(a){var b=ea,c=null,d,e=a.ca[wy],e=Gi(e,function(a){d=0<a-c?1:-1;a=d*h[t](d*a);c&&0!==a*c&&0<a-c&&(b=h.min(b,h.abs(a-c)));return c=a});b!==ea&&(c=null,Ei(e,function(a,g){null!==c&&(c===a&&Bi[he][L](e,g,1),h.abs(a-c)>b&&(d=0<a-c?1:-1,Ui(e,c+d*b,g+1)));c=a}));a.ca.Ro(e)}
function CKa(a,b){GT(a);var c=a.ca,d=a.oL(b);c.cH(c.jc,c.ic,!1);var e=kP(c);e.Dk(a.Pj);var f=d.Jz,g=d.Iz-1,k=new AT(b.Ac,a.gd);if(d.eg)var l=f,f=g,g=l;d=(new wT(new mT(c.jc,c.ic,f,g),a.Pj,k,e,10,d[lz],!1)).cG();nw(a,[]);for(e=0;e<d[J];e++)f=d[e],f.sd()&&a[wy][C]({ra:c.Po(f[I]()),aa:f[zy](),text:f.sd(),O:!0})}
function IKa(a,b){if(!b||1>=b[J]||0==a.Vo)return null;var c=(b[1].aa-b[0].aa)/(a.Vo+1),d=[],e,f,g=b[0].aa;for(e=f=h[t]((g-a.hh)/c);0<e;e--){var k=h[t](g-c*e);1<h.abs(k-a.hh)&&d[C](k)}for(e=0;e<b[J]-1;e++)for(g=b[e].aa,f=0;f<a.Vo;f++)g+=c,d[C](h[t](g));g=Ai(b).aa;f=h[t]((a.Gh-g)/c);for(e=1;e<=f;e++)k=h[t](g+c*e),1<h.abs(k-a.Gh)&&d[C](k);return d}
function HKa(a,b){if(!b||1>=b[J]||0==a.Vo)return null;for(var c=b[0],d=c.ra,e=d,f=[c],g=1;g<b[J]-1;g++)c=b[g],e=d,d=c.ra,0!==d&&(UO(d)||e&&UO(e/d))&&f[C](c);f[C](b[b[J]-1]);b=f;if(1>=b[J])return null;var k=b[1].aa-b[0].aa,c=[],d=[],l;a.Vo=h.min(sFa[J],a.Vo);e=sFa[a.Vo-1];a.Vo=e[J];for(g=0;g<a.Vo;g++)f=h.log(e[g])/h.log(10),d[C](f);for(g=0;g<b[J]-1;g++)if(e=b[g].aa,f=1,k=b[g+1].ra/b[g].ra,!(0>k)&&UO(k))for(1>k&&(f=-1,e=b[g+1].aa),k=b[g+1].aa-b[g].aa,l=0;l<a.Vo;l++)c[C](e+f*k*d[l]);return c}
function GKa(a){var b=null;a[H]==Dh&&a.Ed&&(b={ra:a.Ed.ra,aa:a.Ed.aa,O:!0,length:null,brush:a.ZD});return b}function AKa(a){null!=a.Bq&&a.Bq!==eg&&a.fc(jP(a.ca,a.Bq));null!=a.Hh&&a.fc(jP(a.ca,a.Hh));null!=a.Zi&&a.fc(jP(a.ca,a.Zi))}
function GT(a){var b=xj(a.zb.min)?a.zb.min:a.ca.jc,c=xj(a.zb.max)?a.zb.max:a.ca.ic;b===c&&(b-=1,c+=1);a.pv=a.WD/(c-b);b!==ea&&(a.iz=b);if(Qh(a.Bq)&&a.Bq!==eg)b=jP(a.ca,a.Bq);else{var d=jP(a.ca,a.ca.jZ()),b=nj(d,b,c);xj(b)||(b=0)}a.Ed=null;xj(b)&&(c=a.se(b),ga(c)||(a.Ed={ra:a.ca.Po(b),aa:c}))}
function DKa(a,b){if(a.vq==oH&&na(a.ca.jc)&&na(a.ca.ic)){var c=uT(new zm(a.ca.jc,a.ca.ic),0.1);a.fc(c[y]);a.fc(c.end)}GT(a);var c=a.oL(b),d=a.ca.eA.inverse(a.ca.jc),e=a.ca.eA.inverse(a.ca.ic);PS(a,d);PS(a,e);var f=a.Sy?0:1,g=new AT(b.Ac,a.gd),k,l=a.b;k=new ZS;var n=An(l,a.Ha(JE));In(l,a.Ha(uua));var q=tn(l,a.Ha(LE)),s=An(l,a.Ha(KE)),u=An(a.b,a.Ha(ME));n||q||s||u?k.AV={pattern:n,scaleFactor:q,prefix:s,suffix:u}:(n=tn(l,a.Ha(vua)),di(n)&&$S(k,n),n=tn(l,a.Ha(wua)),di(n)&&aT(k,n),(n=l.R(a.Ha(xua)))&&
k.mE({symbol:n.symbol,position:n[jc],usePadding:n.usePadding}),pn(l,a.Ha(yua))&&bT(k));k=k.jq();l=[];xj(d)&&(l=yT(d,e,c.Jz,c.Iz-1,c.eg,f,a.qK,c[lz],40,g,k));nw(a,[]);for(c=0;c<l[J];c++)d=l[c],e=d[I](),f=a.ca.eA[Sz](e),a[wy][C]({ra:e,aa:a.se(f),text:d.sd(),O:!0})}T.fc=function(a){this[H]==Dh&&null!=a&&QS(this,a)&&(this.ca.fc(a),this.XD[C](a))};function LKa(a){if(a[H]==Dh){var b=a.ca,c=0.01*(b.ic-b.jc);0<b.jc&&a.zb.min==-ea&&(b.jc=h.max(b.jc-c,0));0>b.ic&&a.zb.max==ea&&(b.ic=h.min(b.ic+c,0))}}
T.se=function(a){return null!=a?this.hh+(a-this.iz)*this[jx]*this.pv:null};function HT(a,b){if(null==b)return null;Qv(a,1);var c=null!=b?(b-a.hh)*a[jx]/a.pv+a.iz:null;Qv(a,-1);return a.se(c)}T.i8=function(a){return this[H]==Dh?jP(this.ca,a):a};T.Po=function(a){return null!=a?this[H]==Dh?this.ca.Po(a):a:null};T.A6=function(a){a=null!=a?(a-this.hh)*this[jx]/this.pv+this.iz:null;return null!=a?this.Po(a):null};T.OG=function(a){return this.se(this.i8(a))};
function JKa(a){switch(a[H]){case lD:return a.zb.min-0.5}return a.zb.min}function QS(a,b){return a[H]==Dh?b>=a.zb.min&&b<=a.zb.max:b>=h[t](a.zb.min)&&b<h[xb](a.zb.max)}function FT(a,b){return b*a[jx]>a.Gh*a[jx]}function xKa(a){return null!=a.ca&&(a.ca instanceof mS||a.ca instanceof rS)};function MKa(a,b,c,d,e,f,g,k,l,n){this.g$=a;this.Mf=b;this.boa=c;this.ina=d;this.Iba=e;this.RR=f;this.vla=g;this.ula=k;this.tla=l;this.e$=n}function NKa(a,b,c,d){switch(d){case $qa:return(b-1-a)%c;default:return a}}function IT(a,b,c){b=h[xb]((a.Mf[J]-0)/(b*c));return 2>a.Mf[J]||2>b}
function OKa(a,b,c,d,e){b=NKa(b,a.Mf[J],d,a.vla);for(var f=1>=a.Mf[J]?a.g$:h.abs(a.Mf[1].aa-a.Mf[0].aa)*d-a.ula,g=[];b<a.Mf[J];b+=d){var k=a.Mf[b],l=k.O&&!a.tla?h.min(f,2*k.aa,2*(a.g$-k.aa)):f,n=a.e$(k[cd],l,e),q=n.ge;l<f&&(q=a.e$(k[cd],f,e).ge);g[C]({ra:k.ra,O:k.O,aa:k.aa,U4:c,text:k[cd],width:n.Kg,layout:n,ge:q})}return g}function PKa(a,b,c,d){var e=b*c;d=1<b?1:d;for(var f=[],g=0;g<b;g++){var k=OKa(a,a.boa+g*c,g*d,e,d);Zi(f,k)}cj(f,function(a,b){return a.aa-b.aa});return f}
function JT(a,b,c){a=PKa(a,b,c,a.ina);return Hi(a,function(a,b){return{yt:h.max(a.yt,b[tx].F[J]),ge:a.ge||b.ge}},{yt:0,ge:!1})}function KT(a){for(var b=1,c=a.RR||1,d=JT(a,b,c),e=b;d.ge&&b<a.Iba;){b++;if(IT(a,b,c))break;e=b;d=JT(a,e,c)}b=c;if(!a.RR)for(;d.ge;){c++;if(IT(a,e,c))break;b=c;d=JT(a,e,b)}return{pV:e,ow:b,yt:d.yt*e}}function LT(a,b,c,d,e){a=PKa(a,b,c,d);e=Hi(a,function(a,b){var c=b.ge?1:0;delete b.ge;return a+c},0)<=a[J]*e;return{jM:a,Ica:e}}
function QKa(a,b,c,d,e){var f=h.min(a.Iba,d);b=h.min(b,f);c=a.RR||c;for(var g=LT(a,b,c,d,e),k=b;!g.Ica&&b<f;){b++;if(IT(a,b,c))break;k=b;g=LT(a,k,c,d,e)}f=c;if(!a.RR)for(;!g.Ica;){c++;if(IT(a,k,c))break;f=c;g=LT(a,k,f,d,e)}return{pV:k,ow:f,jM:g.jM}};function MT(a,b,c,d,e,f,g){CT[L](this,a,b,Xi([lva+d,VE],c),d,e,f,g);a=this.Ha(Tza);this.QU=b.R(a,null,on);a=vn(b,this.Ha(Uza),30);if(0>a||90<a)a=30;this.Dha=a;this.bN=qj(a);this.p4=vn(b,this.Ha(jua));this.q4=vn(b,this.Ha(gxa),ea);this.xU=vn(b,this.Ha(exa),2);this.zL=vn(b,this.Ha(Kza),0);this.tU=Gn(b,this.Ha(Lza),qFa,ara);this.r4=vn(b,this.Ha(mxa),this.gd[uc]);this.o4=pn(b,this.Ha(vqa),!1)}X(MT,CT);T=MT[K];T.m8=function(){return mva+this[nc]};
T.hX=function(a,b,c){return wKa(this,a,a.A[r],1==this[jx]?a.A[G]:a.A[Zc],b,c)};
T.iV=function(a,b,c,d){if(0==this[nc]){var e=a.Ac,f=this.gd[uc],g=this[uz].X[uc],k=b.ta[uc],l=a.qD==XG?this[uz][cd]:O,n=this,q=new MKa(a[r],this[wy],this.p4,this.q4,this.xU,this.zL,this.tU,this.r4,this.o4,function(a,b,c){return UN(e,a,n.gd,b,c)}),s=this.zL||1,u,w;if(this.Sl==XG&&!d)if(null!=this.QU)this.QU?w=NT(this,e):u=KT(q);else if(this[wy][J]*f/(this.xU*s)<=a[r]){if(u=KT(q),u.ow>s||0==u.yt)w=NT(this,e),u=null}else w=NT(this,e);var z=UN(e,l,this[uz].X,a.A[r],ea),B=this.Eo,F=h.max(B,h[D](f/1.618)),
M=h.max(B,h[D](f/3.236)),N=function(){return{key:GI,min:w.minHeight+B,max:w.maxHeight+B,Tc:[F-B]}},P=[];P[C]({key:XC,min:B,Tc:[ea]});0<z.F[J]&&P[C]({key:HI,min:g+B,Tc:[ea]});b[zy]()==WC&&P[C]({key:DF,min:k+B,Tc:[ea]});c[zy]()==WC&&P[C]({key:MD,min:c[ez]()+B,Tc:[ea]});var ba=P[J];d||u&&0<u.yt?P[C]({key:GI,min:f+B,Tc:[F-B]}):w&&P[C](N());var U=P[J];if(u)for(var qa=1;qa<u.yt;qa++)P[C]({key:GI,min:f+B,Tc:[M-B]});f=P[J];for(qa=1;qa<z.F[J];qa++)P[C]({key:HI,min:g+B,Tc:[this.Y2-B]});var g=bP(P,a[A]-a.A[Hc]),
ya=g[wy]||[],Ha;u&&(Ha=QKa(q,u.pV,u.ow,ya[J],0),null==this.QU&&Ha.ow>s&&(Ha=u=null,w=NT(this,e),P[ba]=N(),P=IEa(P,0,U,f,void 0),g=bP(P,a[A]-a.A[Hc])));var Aa=a.A[Hc],ya=g[wy]||[];if(0<ya[J]){for(qa=1;qa<ya[J];qa++)ya[qa]+=ya[qa-1];if(d){q=Aa+ya[0];for(qa=0;qa<d[J];qa++)s=d[qa].ma,Zw(s,s[Gz]||new uP(0,0)),s[Gz].y=q;this.aj=d}else u?this.aj=Gi(Ha.jM,function(a){var b=Gi(a[tx].F,function(b,c){return{x:0,y:ya[a.U4+c],length:a[r],text:b}},this);return{ra:a.ra,O:a.O,ma:{text:a[cd],X:this.gd,F:b,Cc:pD,Bc:oE,
vb:a[tx].ge?a[cd]:O,anchor:new uP(a.aa,Aa),Cb:0}}},this):w&&(qa=ya[0],d=h.min(qa-B,w.maxHeight),this.aj=RKa(this,e,Aa+qa-d,d,w.ow));Aa+=Ai(ya)}d=g[uz]||[];if(0<d[J])for(q=UN(e,l,this[uz].X,a.A[r],d[J]),this[uz].vb=q.ge?l:O,qa=0;qa<d[J];qa++)Aa+=d[qa],this[uz].Bc=oE,this[uz].F[C]({x:a.A[G]+a.A[r]/2,y:Aa,length:a.A[r],text:q.F[qa]});l=g.legend||[];0<l[J]&&(Aa+=l[0],b.Go(new rl(Aa-k,a.A[Zc],Aa,a.A[G])));b=g.colorBar||[];0<b[J]&&(Aa+=b[0],a=new rl(Aa-c[ez](),a.A[Zc],Aa,a.A[G]),c.Go(a))}};
function NT(a,b){function c(a){a=b(a[cd],d)[r]*f+e*g;return h[xb](a)}var d=a.gd,e=d[uc],f=h.sin(a.bN),g=h.cos(a.bN),k=a.zL;k||(k=2>a[wy][J]?1:h[xb]((e+a.Eo)/f/h.abs(a[wy][1].aa-a[wy][0].aa)));for(var l=0,n=0;n<a[wy][J];n+=k)l=h.max(c(a[wy][n]),l);n=c({text:Ne});return{minHeight:h.min(l,n),maxHeight:l,ow:k}}
function RKa(a,b,c,d,e){var f=a.gd[uc],g=h.sin(a.bN),k=NKa(0,a[wy][J],e,a.tU);d=(d-f*h.cos(a.bN))/g;d=h[t](d);for(var l=[];k<a[wy][J];k+=e){var n=a[wy][k],q=UN(b,n[cd],a.gd,d,1),s={text:n[cd],X:a.gd,F:[],Cb:-a.Dha,Cc:oE,Bc:nI,vb:q.ge?n[cd]:O,anchor:new uP(n.aa-0.5*g*f,c)};0<q.F[J]&&s.F[C]({x:0,y:0,length:d,text:q.F[0]});l[C]({ra:n.ra,O:n.O,ma:s})}return l}
T.hV=function(a){if(0==this[nc]){var b=a.Ac,c=this.gd[uc],d=new MKa(a[r],this[wy],this.p4,this.q4,this.xU,this.zL,this.tU,this.r4,this.o4,W(function(a,c,d){return UN(b,a,this.gd,c,d)},this)),e;this.Sl==mF&&(e=KT(d));var f=this.Eo,g=h.max(this.Eo,h[D](c/3.236)),k=h.max(this.Eo,h[D](c/1.618)),k=this[H]==Dh?g:k,l=h.max(f,h[D](c/3.236)),n,q;this[H]==Dh?this.Z2==aF?(n=nI,q=g):(n=oE,q=-g):(n=pD,q=0);g=[];g[C]({key:OI,min:f,Tc:[ea]});if(e)for(var s=0;s<e.yt;s++)g[C]({key:GI,min:c+f,Tc:[(0==s?k:l)-f]});var u=
bP(g,h[t](a.A[A]/2))[wy]||[];if(0<u[J]){for(s=1;s<u[J];s++)u[s]+=u[s-1];c=QKa(d,e.pV,e.ow,u[J],0.5);this.aj=Gi(c.jM,function(b){var c=b[tx].F;c[rx]();c=Gi(c,function(a,c){return{x:0,y:-u[b.U4+c],length:b[r],text:a}},this);return{ra:b.ra,O:b.O,ma:{text:b[cd],X:this.gd,F:c,Cc:n,Bc:nI,vb:b[tx].ge?b[cd]:O,anchor:new uP(q+b.aa,a.A[Hc]),Cb:0}}},this)}}};T.oL=function(a){var b={};b.eg=-1==this[jx];b.Jz=a.A[G];b.Iz=a.A[Zc];Mw(b,this.Dr());return b};T.Dr=function(){return Jg};
T.l8=function(a){return 0==this[nc]?{aa:a.A[Hc],direction:-1}:{aa:a.A.top,direction:1}};function SKa(a){return new kK(h[D](a.x),h[D](a.y))}function TKa(a){return Hi(arguments,lK,new kK(0,0))}function UKa(a){return Hi(arguments,function(a,c){return new xk(a[r]+c[r],a[A]+c[A])},new xk(0,0))}function OT(a,b,c){return new kK(h.cos(a)*b,h.sin(a)*c)}function VKa(a){return new kK(a[0],a[1])}function WKa(a,b){return Gi([[a.x-b[r]/2,a.y-b[A]/2],[a.x+b[r]/2,a.y-b[A]/2],[a.x+b[r]/2,a.y+b[A]/2],[a.x-b[r]/2,a.y+b[A]/2]],VKa)}
function XKa(a,b,c,d){return new vl(h.min(a,c),h.min(b,d),h.abs(c-a),h.abs(d-b))};function PT(a,b,c,d,e,f,g){CT[L](this,a,b,Xi([mBa+d,Ls],c),d,e,f,g);this[H]==Dh&&Qv(this,-this[jx])}X(PT,CT);T=PT[K];T.m8=function(){return nBa+this[nc]};T.hX=function(a,b,c){return wKa(this,a,a.A[A],1==this[jx]?a.A.top:a.A[Hc],b,c)};
T.iV=function(a){var b=a.Ac,c=this.gd[uc],d=this[uz].X[uc],e=a.qD==XG?this[uz][cd]:O,f=this.Eo,g=Hi(this[wy],function(a,c){return h.max(a,b(c[cd],this.gd)[r])},0,this),k=b(Ne,this.gd)[r],k=h.min(k,g),l=UN(b,e,this[uz].X,a.A[A],ea),n=[];this.Sl==XG?n[C]({key:GH,min:f,Tc:[c-f]}):n[C]({key:GH,min:0,Tc:[ea]});0<l.F[J]&&n[C]({key:HI,min:d+f,Tc:[ea]});this.Sl==XG&&n[C]({key:GI,min:k+f,max:g+f,Tc:[ea]});for(c=1;c<l.F[J];c++)n[C]({key:HI,min:d+f,Tc:[this.Y2-f]});var d=bP(n,0==this[nc]?a.A[G]:a[r]-a.A[Zc]),
q=0==this[nc]?0:a[r],l=d[uz]||[];if(0<l[J])for(n=UN(b,e,this[uz].X,a.A[A],l[J]),1===this[nc]&&n.F[rx](),this[uz].vb=n.ge?e:O,c=0;c<l[J];c++)q+=l[c]*(0==this[nc]?1:-1),this[uz].Cb=-90,this[uz].Bc=0==this[nc]?oE:nI,this[uz].F[C]({x:q,y:a.A.top+a.A[A]/2,length:a.A[A],text:n.F[c]});if(this.Sl==XG){var e=d[wy][0]||0,q=q+e*(0==this[nc]?1:-1),s=h.min(g,e-f);this.aj=s<k?[]:Gi(this[wy],function(b,c){var d=0==this[nc]?oE:nI,e=pD;this.Pea==nra&&(0==c&&(e=1==this[jx]?nI:oE),c==this[wy][J]-1&&(e=1==this[jx]?oE:
nI));return YKa(this,a,b,q,s,d,e,0)},this)}};
T.hV=function(a){var b=a.Ac,c=this.gd[uc],d=this.Eo,e=h.max(this.Eo,h[D](c/3.236)),c=h.max(this.Eo,h[D](c/1.618)),c=this[H]==Dh?e:c,f,g;this[H]==Dh?this.Z2==aF?(f=oE,g=e):(f=nI,g=-e):(f=pD,g=0);var e=Hi(this[wy],function(a,c){return h.max(a,b(c[cd],this.gd)[r])},0,this),k=b(Ne,this.gd)[r],k=h.min(k,e),l=[];l[C]({key:GH,min:d,Tc:[ea]});this.Sl==mF&&l[C]({key:GI,min:k+d,max:e+c,Tc:[]});var c=bP(l,a.A[r]/2),n=0==this[nc]?a.A[G]:a.A[Zc];if(this.Sl==mF){var c=c[wy][0]||0,q=h.min(e,c-d),n=n+(c-q)*(0==this[nc]?
1:-1);this.aj=Gi(this[wy],function(b){return YKa(this,a,b,n,q,0==this[nc]?nI:oE,f,g)},this)}};function YKa(a,b,c,d,e,f,g,k){b=UN(b.Ac,c[cd],a.gd,e,1);var l=Gi(b.F,function(a){return{x:0,y:0,length:e,text:a}},a);return{ra:c.ra,O:c.O,ma:{text:c[cd],X:a.gd,cq:null,F:l,Cc:f,Bc:g,vb:b.ge?c[cd]:O,anchor:new uP(d,c.aa-k),Cb:0}}}T.oL=function(a){var b={};b.eg=-1==this[jx];b.Jz=a.A.top;b.Iz=a.A[Hc];Mw(b,this.Dr());return b};T.Dr=function(){return Eh};
T.l8=function(a){return 0==this[nc]?{aa:a.A[G],direction:1}:{aa:a.A[Zc],direction:-1}};function QT(a,b,c,d,e){this.Eq=this.tM=this.rT=this.Te=this.Xc=this.Re=this.kg=this.sb=null;this.Zv=1;this.KM=null;WS[L](this,a,b,c,d,e)}X(QT,WS);T=QT[K];
Ma(T,function(){var a=this[eq];this.As=Hn(a,MI,Nn)!=R;this.L.Fh=Gn(a,CE,oFa,WD);if(this.L.Fh==lD&&this.L.Wa!=Bg)throw m("Focus target "+this.L.Fh+" is not supported for the chosen chart type.");this.L.Uc=pn(this[eq],Pva);this.L.Wa==cD?this.Eq=new OS(this.Nb,this[eq],this.Ac,this.L):(this.sb=a.R(ND,tP),ZKa(this));a=0<this.L.xf.bars||0<this.L.xf.area||0<this.L.xf.steppedArea;this.L.Dd=pn(this[eq],tF)&&a;this.L.S2=pn(this[eq],Hza,!1);a=this.L;switch(a.Wa){case Bg:case cF:Mw(a,Gn(this[eq],WG,pP,O));if(!a[lz])throw m("Unspecified orientation.");
this.Te={};this.kg={};this.Re={};var b,c,d,e;switch(a[lz]){case Jg:d=MT;e=this.kg;b=PT;c=this.Re;break;case Eh:d=PT,e=this.Re,b=MT,c=this.kg}for(var f=this.rT.La(),g=0;g<f[J];++g){var k=f[g],l=new b(a,this[eq],[oAa+k,fia],k,Dh,oH);if(l[H]!=Dh)throw m("Target-axis must be of type value");this.Te[k]=l;c[k]=l}var n;a.Wa===cF&&(n=a.k[0].fd.histogramBuckets);b=d;c=this[eq];if(this.Nb.D(0)==rh)i:{switch($Ka(this)){case BC:d=1<this.L.Ba[J]?mD:lD;break i;case JF:case KC:case qI:case jD:d=lD;break i}d=null}else d=
Dh;this.Xc=new b(a,c,[qha],0,d,rG,n);e[0]=this.Xc;break;case QH:case cD:this.kg={0:new MT(a,this[eq],[],0,Dh,oH)},this.Re={0:new PT(a,this[eq],[],0,Dh,oH)}}aLa(this);QT.e[Fc][L](this)});
function ZKa(a){var b=a.L,c=a.Nb,d=b.Wa==QH?function(){return QH}:b.Wa===cF?function(){return KC}:W(function(a){return Gn(this[eq],ZH+a+Vma,bFa,b.eT)},a),d=b.Uc?bLa(c,d,b.Wa):cLa(c,d);b.Ba=[];b.eq={};for(var e=d.Tj,f=0;f<c.M();f++){var g=c.cn(f),k=c[I](f,0),l=Gi(e,function(a){return c.Aa(f,a.oa[$y][0])||O}),k={data:k,Ts:l,Bs:g};if(l=e[0].oa.tooltip)k.de=RT(a,l[0],f);b.Ba[C](k);b.eq[g]=f}b.k=[];for(f=0;f<d.TU[J];f++)e=dLa(a,f,d.TU[f]),b.k[C](e),Kj(c.Sq(f))||(b.k[f].fd=c.Sq(f));b.hq=d.K4;b.Tj=d.Tj;
b.Ns=d.Ns;b.eE={};b.xf={};a.rT=new ck;a.tM=[];for(f=0;f<b.k[J];++f){d=b.k[f];a.rT.add(d.ee);e=b.eE[d.ee];if(null==e)b.eE[d.ee]=d[yy];else if(e!=d[yy])throw m("All series on a given axis must be of the same data type");b.xf[d[H]]=(b.xf[d[H]]||0)+1;e=a.tM[d.ee]||{};a.tM[d.ee]=e;e[d[H]]=(e[d[H]]||0)+1}}
function eLa(a){var b={},c=a.L;c.dn=[];var d=W(function(a){var d=c.k[a];if(c.Uc&&d[H]===QH){var g=[this[eq].R(cE,0.5),this[eq].R(bE,1)],k=d[E][E];c.dn[C]({id:d.id,text:d.zk,brush:new Rm({gh:{lg:k,Tf:k,Wy:g[0],Xy:g[1],x1:QA,y1:PA,hb:PA,kb:PA,sv:!0,uK:!0}}),index:a,O:d.Oj})}else g=new Rm({fill:d[E][E]}),d.HD&&g.dh(d.HD),c.dn[C]({id:d.id,text:d.zk,brush:g,index:a,O:d.Oj});b[a]=!0},a);Y(c.k,function(a,c){b[c]||(d(c),null!=a.tD&&d(a.tD))},a);c.Uc&&c.k[0][H]===KC&&c.dn[C]({id:-1,text:$oa,brush:new Rm({fill:rFa[E]}),
index:-1,O:!0})}
function fLa(a,b){function c(a){return a=864E5*a+e}function d(a){a-=e;return a/864E5}for(var e=(new Date(1900,0,1,0,0,0))[bc](),f=new wo(ula),g=new lEa(function(a){return f[Kb](a)}),k=a.L,l=k.Wa==QH?QH:JF,n=0,q=k.k[J],s=0;s<q;s++){var u=k.k[s],w=VAa+s+Me;if(null!=In(a[eq],VAa+s)){n++;var z=Gn(a[eq],w+Ah,ZEa,MF),B=a[eq].R(w+KD,Gna),F=B===Gna;F&&(B=u.fh.gb());var F=xn(a[eq],[w+bh,bh],F?0.5:1),M=vn(a[eq],[w+jH,jH],0),N=0<M;0>=M&&(M=6);M/=2;0<M&&(M+=1);var P={};null!=u.oa[Z]&&ra(P,u.oa[Z]);var ba=vn(a[eq],
[w+LF,LF],2);Gn(a[eq],w+RD,rP,R);pn(a[eq],w+hJ,!1);var B=NS(B),z=$Ea[z],U=a.kg[0],qa=a.Re[0];if(k[lz]===Eh)var ya=U,U=qa,qa=ya;if(U[H]===Dh){var Ha=U.ca,Aa=qa.ca,Wc=u.oa[Z][0],cb=kj,kc=kj;0<b.M()&&$h(b[I](0,0))&&(cb=d,kc=c);U={min:cb(Ha.jc),max:cb(Ha.ic)};z=z(b.M(),function(a){a=b[I](a,0);a=lP(Ha,a);return cb(a)},function(a){return lP(Aa,b[I](a,Wc))},{range:U,jz:sn(a[eq],w+ata,3)});if(null!==z){U=zn(a[eq],w+HI,g.B(z.$s.Qk())||zpa+n);qa=Gi(z[Z],function(a){var b=kc(a[0]),b=null!=b?Ha.xE(b):null;a=
a[1];a=null!=a?Aa.xE(a):null;return[b,a]});u.tD=k.k[J];ya=$m(B[E],ba);Sm(ya,F);var kd=Zm(B[E]);kd.dh(F);var Mb=zn(a[eq],w+AF,U);pn(a[eq],w+Gza,!1)&&(Mb+=me+g.B((new MO([new oP([new mP(fh),new PO(2)]),new PO(z.So)])).Qk()));k.k[C]({id:u.id+Spa,title:U,Eg:!0,data:qa,dataType:u[yy],O:!0,Bs:0,oa:P,J3:s,He:u.He,ef:null,color:B,HD:F,fh:kd,$d:ya,Yu:null,FD:null,type:l,pD:sn(a[eq],w+BBa,0),lineWidth:ba,Pc:M,V2:12,av:Gn(a[eq],w+RD,rP,R),gK:vn(a[eq],[w+iI,iI],1),dK:N,j:[],JS:[],ee:u.ee,Oj:pn(a[eq],w+hJ,!1),
zk:Mb})}}}}}
function cLa(a,b){for(var c=[],d=[],e=null,f=null,g=0,k=[],l=0;l<a.H();++l){var n=a.D(l),q=a.Li(l,ih)||(0==l?Lr:Jr);if(0==l&&q!==Lr)throw m(xoa);if(q==Lr){if(0<g)throw m(Fpa+l+Ge);e={oa:{},dataType:n};f={kc:null,He:d[J]};d[C](e)}0==g&&q===Jr&&(f=c[J],g=b(f),e={type:g,dataType:n,oa:{}},f={kc:f,He:null},c[C](e),g=g===jD?4:1);if(q===Jr&&(g--,n!==e[yy]))throw m(Yna);if(q===Hs&&e.oa[q])throw m(Voa);e.oa[q]=e.oa[q]||[];k[C]({kc:f.kc,He:f.He,Iv:q,Uy:e.oa[q][J]});e.oa[q][C](l)}if(0<g)throw m(Ooa+g+Ge);e=
0;n=d[0][yy];for(l=0;l<c[J];++l){if(d[J]<=e)throw m("Series #"+l+ila);q=d[e+1];f=c[l].oa[Z];if(q&&q.oa[$y][0]<=f[0]&&(++e,n!==d[e][yy]))throw m(Zna);c[l].He=e}return{TU:c,Tj:d,Ns:n,K4:k}}function gLa(a,b){if(a!==b)throw m("Column types must be consistent: equal for domain columns and for columns in the same serie.");}
function bLa(a,b,c){var d=[],e=[],f=null,g=[];if(c===QH){for(var k=a.H()-2,l=function(a){if(a!==Jr&&a!==RG)throw m("All columns must be either data or old-data columns");},n={data:null,"old-data":null},f=a.D(0),q=0;2>q;++q){var s=a.D(q);c=a.Li(q,ih);l(c);gLa(f,s);s={oa:{},dataType:s};s.oa.domain=[q];e[C](s);n[c]=q;g[C]({He:q,Iv:Lr,Uy:0,kc:null})}for(q=0;q<k;++q){var u=2+q,s=a.D(q);c=a.Li(q,ih);l(c);q%2&&gLa(d[q-1][yy],s);var w=n[c],s={type:b(q),dataType:s,He:w,oa:{}};s.oa[c]=[u];d[C](s);g[C]({He:w,
Iv:c,Uy:0,kc:q})}}else if(c===Bg){k=f=null;for(q=l=0;q<a.H();++q){s=a.D(q);c=a.Li(q,ih)||(0===q?Lr:Jr);if(0===q&&c!==Lr)throw m(xoa);if(c===Lr){if(0<l)throw m(Fpa+q+Ge);f={oa:{},dataType:s};k={kc:null,He:e[J]};e[C](f)}0!==l||c!==Jr&&c!==RG||(k=d[J],l=b(k),f={type:l,dataType:s,oa:{}},k={kc:k,He:null},d[C](f),l=l===jD?4:c===RG?2:1);if(c===Jr||c===RG)if(l--,s!==f[yy])throw m(Yna);if(c===Hs&&f.oa[c])throw m(Voa);f.oa[c]=f.oa[c]||[];g[C]({kc:k.kc,He:k.He,Iv:c,Uy:f.oa[c][J]});f.oa[c][C](q)}if(0<l)throw m(Ooa+
l+Ge);a=0;f=e[0][yy];for(q=0;q<d[J];++q){if(e[J]<=a)throw m("Series #"+q+ila);b=e[a+1];c=d[q].oa[RG]||d[q].oa[Z];if(b&&b.oa[$y][0]<=c[0]&&(++a,f!==e[a][yy]))throw m(Zna);d[q].He=a}}return{TU:d,Tj:e,Ns:f,K4:g}}T.RE=function(a){a=a.oa[RG];return null!=a&&0<a[J]};
function dLa(a,b,c){var d=c[H],e=c.oa,f=c.He,g=a[eq],k=ZH+b+Me,l=e[Z]||e[RG],n=a.Nb.jF(l[0]),q=a.Nb.cb(l[0])||O,s=d==QH?0:2,u=vn(g,[k+jH,jH],d==QH?7:0),w=d==JF||d==BC||d==QH?0<u:!0;0==u&&(u=d==QH?7:6);u/=2;0<u&&(u+=1);b=g.R(k+KD,a.sb[(a.L.Uc&&d==QH?h[t](b/2):b)%a.sb[J]]);b=NS(b);var z=null;if(d==BC||d==qI)z=xn(g,[k+CC,CC]),z=Zm(b[E],z);var B=null;if(d==jD)var B=new Rm({stroke:b[E],qa:2,fill:b[E]}),F=new Rm({stroke:b[E],qa:2,fill:te}),M=pn(g,xra),N=M?B:F,B={I3:Jn(g,[k+yra,yra],M?F:B),H3:Jn(g,[k+wra,
wra],N)};s=vn(g,[k+LF,LF],s);F=$m(b[E],s);if(M=g.R([k+Jwa,Jwa],null,rn))F.Hk=M;M=vn(g,[k+Usa,Usa],1);N=null;if(d===QH||d===JF||d===BC)N=In(g,[k+$xa,$xa],{type:ED}),bi(N)&&(N={type:N});var P=null;if(a.L.Uc&&d===QH){var ba=a.RE(c),M=ba?a[eq].R(cE,0.5):a[eq].R(bE,1);ba&&(P=!1)}ba=d==qI?z:Zm(b[E],M);if(a.L.Uc)if(d===KC)var U=g.R(ita,rFa),U=NS(U),U={background:{fh:Zm(U[E],M)}};else d===QH&&a.RE(c)&&(w=!1);var qa=hLa(a,e,g,k,b);return{id:a.Nb.jf(l[0]),title:q,dataType:c[yy],O:!0,Bs:n,oa:e,He:f,ef:qa,color:b,
HD:M,fh:ba,$d:F,oD:N,eh:U,Yu:z,FD:B,type:d,pD:sn(g,k+BBa,0),lineWidth:s,Pc:u,V2:12,av:Gn(g,[k+RD,RD],rP,R),gK:vn(g,[k+iI,iI],1),dK:w,j:[],JS:[],ee:vn(g,[k+AI,AI],0),Oj:null!=P?P:pn(g,k+hJ,!0),zk:zn(g,k+AF,q)}}
function hLa(a,b,c,d,e){function f(a,b){return g(a,b)[Ab]([d+b,b])}function g(a,b){return[d+Nva+a+Me+b,d+Ova+b,Nva+a+Me+b,Ova+b]}var k=b[xx];if(!k)return null;b={Eb:[],Kw:[],tN:[],j:[],areas:[],F:[],ND:{}};for(var l={},n=0;n<k[J];n++){var q=k[n],s=a.Nb.jf(q)||a.Nb.cb(q)||ZD,u=Hn(c,g(s,sh),cFa);switch(u){case KC:b.Eb[C](q);break;case dAa:b.Kw[C](q);break;case qra:b.tN[C](q);break;case lH:b.j[C](q);break;case BC:b[Qz][C](q);break;case JF:b.F[C](q);break;case R:break;default:throw m("Invalid interval style: "+
u);}s in l?l[s][C](q):l[s]=[q]}1<b.Eb[J]&&0==b.Kw[J]&&(b.Kw=[b.Eb[0],b.Eb[b.Eb[J]-1]]);if(0!=b.Kw[J]%2)throw m("Stick-intervals must be defined by an even number of columns");if(0!=b[Qz][J]%2)throw m("Area-intervals must be defined by an even number of columns");for(s in l){u=vn(c,g(s,LF));n=xn(c,g(s,iua));q=Dn(c,g(s,KD),Hj(dFa),O);q=ST(q,e);n=new Rm({stroke:q,fill:q,ae:n,qa:u});q=vn(c,g(s,fra));a=vn(c,g(s,Cza));var k=vn(c,g(s,pra)),w=vn(c,g(s,jH)),u=Hn(c,g(s,sh),cFa),z=pn(c,f(s,qF)),B=Gn(c,f(s,RD),
rP,R),F=vn(c,f(s,iI),1),u={style:u,brush:n,Sha:q,Uha:a,Tha:k,KD:w,Lj:z,av:B,gK:F};a=l[s];for(n=0;n<a[J];++n)q=a[n],b.ND[q]=u}return b}function $Ka(a){var b=[JF,BC,qI,KC,jD],c={};Y(b,function(a,b){c[a]=b});a=Hi(a.L.k,function(a,b){return h.max(a,c[b[H]])},0);return b[a]}
function aLa(a){var b=a.L;switch(b.Wa){case QH:case cD:if(b.Ns==rh)throw m("X values column cannot be of type string");var c=b.eE[0];if(c==rh)throw m("Data column(s) cannot be of type string");var d=a.kg[0],e=a.Re[0];if(d[H]!=Dh)throw m("The x-axis must be of type value");DT(d,b.Ns,a[eq]);if(e[H]!=Dh)throw m("The y-axis must be of type value");DT(e,c,a[eq]);break;case Bg:case cF:c=a.Xc;if(c[H]==Dh){if(b.Ns==rh)throw m("Domain column cannot be of type string, it should be the X values on a continuous domain axis");
DT(c,b.Ns,a[eq])}Dj(a.Te,function(a,c){var d=b.eE[c];if(d==rh)throw m("Data column(s) for axis #"+c+" cannot be of type string");DT(a,d,this[eq]);d=this.tM[c];null===a.Bq&&(0<d.bars||0<d.area||0<d.steppedArea)&&(a.Bq=0)},a)}Dj(a.kg,function(a){vKa(a)});Dj(a.Re,function(a){vKa(a)})}
function iLa(a){if(null===TT(a))return[];for(var b=(a.L.Tj[0].oa[$y]||[])[0],c=[],d=null,e=a.Nb,f=0;f<e.M();f++){var g=e[I](f,b),k=UT(a,f);if(null!==d&&null!=k){if(0>k)throw m("Invalid gap value ("+k+") in data row #"+f+". Gap value must be non-negative.");c[C]({wc:d,xe:g,wia:k})}d=g}return c}T.u6=function(){return this.Eq&&this.Eq.Do==Yg?null:null!=this.Re[0]&&null!=this.Re[1]?NI:null!=this.Re[1]?Qg:zs};T.t6=function(){return this.Eq&&this.Eq.Do==Yg?NI:null};
function VT(a){var b=a.oa[Z];return b?b[0]:a.oa[RG][0]}function jLa(a){for(var b=a.L,c=a.Nb,d=a.Xc,e=0;e<b.Ba[J];e++){for(var f=0;f<b.k[J];f++){var g=b.k[f],k=a.Te[g.ee],g=c[I](e,VT(g)),g=lP(k.ca,g);null!=g&&PS(k,g)}d[H]==Dh&&(f=c[I](e,0),f=lP(d.ca,f),PS(d,f))}}function kLa(a){var b=a.L,c=a.Nb,d=a.kg[0];a=a.Re[0];for(var e=0;e<c.M();e++)for(var f=0;f<b.k[J];f++){var g=b.k[f],k=VT(g),g=c[I](e,b.Tj[g.He].oa[$y][0]),k=c[I](e,k),g=lP(d.ca,g),k=lP(a.ca,k);null!=g&&PS(d,g);null!=k&&PS(a,k)}}
T.s6=function(){var a=this.L;lLa(this);(a.Dd||a.Uc||a.Wa===cF)&&Dj(this.Te,function(a){a.fc(0)});if(a.Wa===Bg||a.Wa===cF)jLa(this),this.Xc[H]==Dh&&this.Xc.$A(iLa(this)),ET(this.Xc,this[eq]),Dj(this.Te,function(a){a.$A();ET(a,this[eq])},this);else{var b=this.kg[0],c=this.Re[0];a.Wa==cD?tJa(this.Eq,b,c):a.Wa==QH&&kLa(this);b.$A();ET(b,this[eq]);c.$A();ET(c,this[eq])}a.xf.bars&&mLa(this,KC);if(a.xf.steppedArea){if(this.Xc[H]==Dh)throw m("Stepped area series with value domain axis is not supported.");
mLa(this,qI)}a.xf.candlesticks&&nLa(this);a.xf.line&&(oLa(this),pLa(this));a.xf.area&&qLa(this);a.xf.scatter&&(rLa(this),pLa(this));a.xf.bubbles&&uJa(this.Eq,this.kg[0],this.Re[0],this.fj);(a.xf.bars||a.xf.candlesticks)&&a.Wa!==cF&&this.Xc&&this.Xc[H]==Dh&&sLa(this);a.Be=Ej(this.kg,function(a){return a.hX(this.L,this.kf,this.fj)},this);a.be=Ej(this.Re,function(a){return a.hX(this.L,this.kf,this.fj)},this);tLa(this);uLa(this);vLa(this);(a.Wa===Bg&&a[lz]===Jg||a.xf.bars)&&wLa(this);var b=this.kf[zy](),
c=this.kf.ta[uc],d=null;b!=zs&&b!=BF||null!=this.Re[1]||(d=new rl(a.A.top,a[r]-c,a.A[Hc],a.A[Zc]+c));b!=Qg||null!=this.Re[0]||(d=new rl(a.A.top,a.A[G]-c,a.A[Hc],c));d&&d[Zc]>=d[G]&&this.kf.Go(d);xLa(this);yLa(this);this.Eq||(fLa(this,this.Nb),eLa(this),zLa(this))};
function lLa(a){var b=a.L,c=a.Ac,d=Gj(a.kg)[uz].X,e=h.max(b[uz].X[uc],d[uc]),f=a.kf.ta[uc],g=a.kf[zy](),k=a.fj.ta[uc],l=a.fj[zy](),n=b.Iy==mF?b[uz][cd]:O,q=O,s=O;if(b.qD==mF){var u=function(a){var b=Ij(a);cj(b);b=Gi(b,function(b){return a[b][uz][cd]});return Fi(b,function(a){return a!=O})[ie](Ke)};switch(b.Wa){case QH:case cD:q=u(a.kg);s=u(a.Re);break;case Bg:q=u({0:a.Xc}),s=u(a.Te)}}var q=q&&s?q+cla+s:q?q:s?s:O,s=h.max(2,h[D](e/1.618)),w=h.max(2,h[D](f/1.618)),z=h.max(2,h[D](k/1.618)),B=b.A[r]-2*
s,k=UN(c,n,b[uz].X,B,1),u=0<k.F[J]?k.F[0]:O,F=c(u,b[uz].X)[r],M=h[D](h.max(2,1.618*e)),B=h.max(B-F-M,0),c=UN(c,q,d,B,1),M=0<c.F[J]?c.F[0]:O,N=[];N[C]({key:XC,min:2,Tc:[ea]});(u||M)&&N[C]({key:HI,min:e+2,Tc:[s-2]});g==mF&&N[C]({key:DF,min:f+2,Tc:[w-2]});l==mF&&N[C]({key:MD,min:a.fj[ez]()+2,Tc:[z-2]});g=bP(N,h[t](b.A[A]/2));e=b.A.top;l=g[uz]||[];0<l[J]&&(e+=l[0],u&&(b[uz].F[C]({text:u,x:b.A[G]+s,y:e,length:F}),b[uz].vb=k.ge?n:O),M&&(b.JD={text:q,X:d,cq:null,F:[],Cc:oE,Bc:oE,vb:c.ge?q:O,anchor:null,
Cb:0},b.JD.F[C]({text:M,x:b.A[Zc]-s,y:e,length:B})));d=g.legend||[];0<d[J]&&(e+=d[0],a.kf.Go(new rl(e-f,b.A[Zc],e,b.A[G])));f=g.colorBar||[];0<f[J]&&(e+=f[0],b=new rl(e-a.fj[ez](),b.A[Zc],e,b.A[G]),a.fj.Go(b))}function mLa(a,b){var c=a.L;c.Uc?ALa(a,b):BLa(a,b,c.Dd)}function sLa(a){var b=a.Xc,c=Fi(a.L.Ba,function(a,b){return 0!=UT(this,b)},a),d=ea,e;Y(c,function(a){a=jP(b.ca,a[Z]);Qh(e)&&(d=h.min(d,h.abs(a-e)));e=a},a);xj(d)&&(a=d/2,b.fc(b.ca.jc-a),b.fc(b.ca.ic+a))}
function BLa(a,b,c){var d=a.L,e=a.Nb,f=a.Xc,g=a.L.Wa===cF,k=(d.A[A]-1)/CLa(c,d,e);a.L.ov=g&&DLa(k,pn(a[eq],dF));for(var l=0;l<d.Ba[J];l++)for(var k=0==UT(a,l),n=Ej(a.Te,function(){return[0,0]}),q=-1,s=0;s<d.k[J];s++){var u=d.k[s];if(u[H]==b){q++;!1==c&&(n[u.ee]=[0,0]);var w=u.j;if(k)w[C](null);else{var z=u.ee,B=a.Te[z],F=e[I](l,u.oa[Z][0]),F=jP(B.ca,F),M=WT(a,l);f.fc(M);var N=0<F?0:1,P=n[z];QS(f,M)&&(c?B.fc(F+P[N]):B.fc(F));c||(a.Zv=h.max(a.Zv,q+1));var z=function(a,b,c,d){b={Cf:{Dq:l,Fv:b,Rj:c,Ck:a+
(d||g?P[N]:0),Jk:M,zE:XT(this,u,l,P[N],!0)}};null==a&&(b.Ae=!0);u[H]==qI&&(c=w[J],b.Cf.g4=0!=c&&w[c-1]?w[c-1].Cf.Ck:null);YT(this,b,u,s,l);w[C](b);P[N]+=a},B=c?0:q,ba=c||g?P[N]:null;if(g&&!a.L.ov)for(var U=0;U<F;U++)ba=c||g?P[N]:null,z[L](a,1,B,ba,c);else z[L](a,F,B,ba,c)}}}c||Dj(a.Te,function(a){LKa(a)})}
function ALa(a,b){for(var c=a.L,d=a.Nb,e=a.Xc,f=Fi(c.k,function(a){return a[H]==b}),g=0;g<c.Ba[J];++g){var k=0==UT(a,g),l=WT(a,g);e.fc(l);for(var n=QS(e,l),q=[RG,Jr],s=0;s<f[J];++s){var u=f[s];if(k){u.j[C](null);return}for(var w=a.Te[u.ee],z=w.ca,B=0;B<q[J];++B){var F=q[B],M=d[I](g,u.oa[F][0]),M=jP(z,M);if(null===M){u.j[C](null);return}n&&w.fc(M);a.Zv=h.max(a.Zv,s+1);F={brush:F==RG?u.eh[Dz].fh:null,Cf:{Dq:g,Fv:s,Rj:null,Ck:M,Jk:l,aga:F==Jr,zE:XT(a,u,g,0,!0)}};YT(a,F,u,s,g);u.j[C](F)}}}Dj(a.Te,function(a){LKa(a)})}
function nLa(a){var b=a.L,c=a.Nb,d=a.Xc,e=Fi(b.k,function(a){return a[H]==jD});Y(b.Ba,function(a,b){var k=0==UT(this,b);Y(e,function(a,e){if(k)a.j[C](null);else{var f=a.oa[Z],s=this.Te[a.ee];this.Zv=h.max(this.Zv,e+1);var u=c[I](b,f[0]),w=c[I](b,f[1]),z=c[I](b,f[2]),f=c[I](b,f[3]),u=jP(s.ca,u),w=jP(s.ca,w),z=jP(s.ca,z),f=jP(s.ca,f);if(null===u||null===f||null===w||null===z)a.j[C](null);else{var B=WT(this,b);d.fc(B);var F=z<w;QS(d,B)&&(s.fc(u),s.fc(f));s={Jy:F?a.FD.H3:a.FD.I3,$d:Zm(a[E][E]),Cf:{Dq:b,
Fv:e,dha:u,lineTo:f,eha:F?z:w,fha:F?w:z,cha:F,Jk:B}};YT(this,s,a,e,b);a.j[C](s)}}},this)},a)}function ELa(a,b){var c=a.L,d=a.Nb,e=a.Xc,f=c.k[b];if(f[H]==JF)for(var c=f.Eg?f[Z]:c.Ba,g=0;g<c[J];g++){var k=a.Te[f.ee],l=f.oa[Z][0],l=f.Eg?f[Z][g][1]:d[I](g,l),l=jP(k.ca,l),n;if(null!=l){var q=WT(a,g,f);e.fc(q);(n=QS(e,q)&&!f.Eg)&&k.fc(l);k=f.Eg?null:XT(a,f,g,0,n)}else n=!1,k=null;k={Cf:{Dq:g,Fv:0,Jk:q,Vv:l,zE:k},shape:f.oD,x4:n};null==l&&(k.Ae=!0);YT(a,k,f,b,g);f.j[C](k)}}
function oLa(a){for(var b=a.L,c=0;c<b.k[J];c++)ELa(a,c);FLa(a);ZT(a)}function FLa(a){for(var b=a.Xc,c=a.L.k,d=0;d<c[J];d++){var e=c[d];if((e[H]==JF||e[H]==BC)&&0!=e[Ny]){var f=a.Te[e.ee],g=Gi(e.j,function(a){return!a||a.Ae?null:new sk(a.Cf.Jk,a.Cf.Vv)}),k=a.L.Lj,e=gP(g,JKa(b),k),l;t:{switch(b[H]){case mD:l=b.zb.max-1;break t;case lD:l=b.zb.max-0.5;break t}l=b.zb.max}k=gP(g,l,k);f.fc(e);f.fc(k)}}}
function qLa(a){for(var b=a.L,c=a.Nb,d=a.Xc,e=b.Lj,f=0;f<b.Ba[J];f++)for(var g=Ej(a.Te,function(){return 0}),k=Pj(g),l=Pj(g),n=0;n<b.k[J];n++){var q=b.k[n];if(q[H]==BC){var s=q.ee,u=a.Te[s],w=null,z=null,B=q.oa[Z][0],F=c[I](f,B),F=jP(u.ca,F),M=WT(a,f),N;if(null==F||ga(F))b.Dd&&(w=k[s],z=g[s]),s={B4:M,C4:w,z4:M,A4:z,G4:M,H4:z,D4:M,E4:w},N=!1;else{var P,ba;N=0<f?c[I](f-1,B):null;var U=f<c.M()-1?c[I](f+1,B):null;b.Dd?(B=F+l[s],w=k[s],z=g[s],P=k[s]+F,ba=g[s]+F,f==c.M()-1||null!==U&&!ga(U)?k[s]+=F:P=k[s],
0==f||null!==N&&!ga(N)?g[s]+=F:ba=g[s]):(P=ba=B=F,f==c.M()-1||null!==U&&!ga(U)?P=B:e||(P=null),0==f||null!==N&&!ga(N)?ba=B:e||(ba=null));d.fc(M);(N=QS(d,M))&&u.fc(B);u=XT(a,q,f,l[s],N);b.Dd&&(l[s]=B);s={Jk:M,Vv:B,Dq:f,Fv:0,G4:M,H4:ba,D4:M,E4:P,B4:M,C4:w,z4:M,A4:z,zE:u}}s={Cf:s,shape:q.oD,x4:N};YT(a,s,q,n,f);if(null==F||ga(F))s.Ae=!0;q.j[C](s)}}FLa(a);ZT(a)}function zLa(a){Y(a.L.k,function(a,c){a.Eg&&(a[H]===QH?GLa(this,c):a[H]===JF&&ELa(this,c),HLa(this,c))},a)}
function GLa(a,b){var c=a.L,d=a.Nb,e=a.kg[0],f=a.Re[0],g=c.k[b],k=g.He;if(g[H]===QH)for(var l=g.Eg?g[Z][J]:d.M(),n=0;n<l;n++){var q=c.Tj[k].oa[$y][0],s=VT(g),q=g.Eg?g[Z][n][0]:d[I](n,q),u=g.Eg?g[Z][n][1]:d[I](n,s),s=jP(e.ca,q),q=jP(f.ca,u);if(null===s||null===q)g.j[C](null);else(u=QS(e,s)&&QS(f,q))&&!g.Eg&&(e.fc(s),f.fc(q)),s={Cf:{x:s,y:q},shape:g.oD,bga:u},YT(a,s,g,b,n),g.j[C](s)}}function rLa(a){for(var b=a.L,c=0;c<b.k[J];c++)GLa(a,c);ZT(a)}
function ZT(a){function b(a){return!(!a||a.Ae)}for(var c=W(function(a){var b=null!=a.Cf?a.Cf.Dq:null;return{Qv:null!=a.Qv?a.Qv:1,lw:null!=a.lw?a.lw:1,scope:null!=a[yz]?a[yz]:!0,Qia:null!=b?UT(this,b):null}},a),d=null===TT(a),e=0;e<a.L.k[J];e++){var f=a.L.k[e],g=f.Yu,k=f.oa.emphasis||[],l=f.oa[yz]||[];if(0!=(f.oa.certainty||[])[J]||0!=k[J]||0!=l[J]||!d)for(var k=Qi(f.j,b),n=c(k||{}),l=0;l<f.j[J];l++){var q=f.j[l];if(q&&!q.Ae){var s=c(q),u=f.$d;s[yz]||n[yz]||(f.N7=f.N7||u.lF(),u=f.N7,q.kw=u,g&&(f.M7=
f.M7||g.lF(),q.QS=f.M7));if(1>s.Qv||1>n.Qv)u=$T(u,!1),q.kw=u;1!=s.lw&&1!=n.lw&&(n=h.min(n.lw,s.lw),u=ILa(u,n),q.kw=u);0==s.Qia&&k&&!k.Ae&&(q.kw=null);n=s}k=q}}}function JLa(a){var b={fill:{},stroke:{}};null!=a&&(null!=a[E]&&Xa(b[fc],Xa(b[Yb],a[E])),null!=a[Kd]&&mb(b[fc],mb(b[Yb],a[Kd])),null!=a[lx]&&Xa(b[fc],a[lx]),null!=a.fillOpacity&&mb(b[fc],a.fillOpacity),null!=a[Ax]&&Xa(b[Yb],a[Ax]),null!=a.strokeOpacity&&mb(b[Yb],a.strokeOpacity),null!=a.strokeWidth&&pa(b[Yb],a.strokeWidth));return b}
function KLa(a,b,c){var d=void 0;b=null!=b.oa[x]?b.oa[x][0]:void 0;if(null!=b&&a.Nb.D(b)===rh&&(a=a.Nb[I](c,b),null!=a)){var e,d=pi(a);if(qm(d))e={fill:{color:d},stroke:{color:d}};else if(d[Bb](0)===Lh){try{var f=eo(d)}catch(g){}null!=f&&(e=f)}null==e&&(ri(d,Lh)?(e=Ej(qJa(d),JLa),O in e&&(Sj(e,e[O]),Lj(e,O)),He in e&&(Sj(e,e[He]),Lj(e,He))):e=JLa(bm(d)));d=e}if(null!=d)return new jn([d])}
function YT(a,b,c,d,e){a.As&&(b.de=LLa(a,c,d,e));var f=KLa(a,c,e);d=MLa(a,c,e);var g=NLa(a,c,e);a=OLa(a,c,e);e=c.fh;if(null!=f){e=e.o();var k=function(a,b){var c=b||O;a.pe(Cn(f,[c+fua,c+zE],a.gb()));a.dh(xn(f,c+gua,a.Oe));a.dd(Cn(f,[c+gAa,c+uI],a.Qd));Sm(a,xn(f,c+hAa,a.Ai));a.yk(sn(f,c+iAa,a.Hb))};k(e);switch(c[H]){case JF:case QH:case BC:k(e,Zxa);Xh(f.R(JF,null))&&null!=c.$d&&(b.kw=c.$d.o(),k(b.kw,KF));Xh(f.R(BC,null))&&null!=c.Yu&&(b.QS=c.Yu.o(),k(b.QS,Xqa));break;case qI:Xh(f.R(JF,null))&&k(e,
KF);case KC:k(e,era);break;case jD:b.Jy=b.Jy.o(),k(b.Jy),k(b.$d),k(b.Jy,era),k(b.$d,KF)}b.brush=e}k=CS(b,c);a||(b.scope=a,c.Z7=c.Z7||e.lF(),e=c.Z7,b.brush=e);1!=g&&(b.lw=g,c[H]==JF||c[H]==BC||c[H]==QH)&&(k=h[D](k*h[ud](g)*10)/10,Jw(b,k));if(1>d)switch(b.Qv=d,c[H]){case JF:case BC:case QH:b.brush=$T(e,!0);Jw(b,h.max(k-Um(b.brush)/2,0));break;case KC:case qI:b.brush=$T(e,!1)}}function LLa(a,b,c,d){c=a.ZT(b,c,d);var e=b.oa.tooltip;e&&!b.Eg&&(a=RT(a,e[0],d))&&Sj(c,a);c.am=!!c.am;return c}
function RT(a,b,c){var d=a.Nb;a=a.L.Ls&&(d.Ao(c,b,Mg)||d.Li(b,Mg));b=d.Aa(c,b);return{am:!!a,ti:b?!0:!1,content:b}}
T.ZT=function(a,b,c){if(this.L.Wa===QH||a.Eg){var d=this.Nb,e=this.L,f,g,k,l;if(a.Eg)f=a[Z][c][0],g=a[Z][c][1],null!=f&&(f=Po(f,d.D(a.He))),null!=g&&(g=Po(g,a[yy])),k=e.Fh===lD?g:f+Ke+g,l=f;else if(this.L.Uc){var n=this.kg[0][uz][cd]||hC,q=this.Re[0][uz][cd]||Kpa;k=b%2?b-1:b;b=e.k[k];k=e.k[k+1];f=e.Tj[k.He].oa[$y][0];g=VT(k);f=d.Aa(c,f);g=d.Aa(c,g);k=n+bB+f+Ke+q+bB+g;f=e.Tj[b.He].oa[$y][0];g=VT(b);f=d.Aa(c,f);g=d.Aa(c,g);k+=me+n+bB+f+Ke+q+bB+g}else f=e.Tj[a.He].oa[$y][0],g=VT(a),f=d.Aa(c,f),g=d.Aa(c,
g),k=f+Ke+g;a={ti:!1,content:k,$l:a[uz],gv:l}}else a=PLa(this,a,c);return a};
function PLa(a,b,c){var d=a.Nb,e=a.L.Ba[c],e=b.Eg?b[Z][c][0][hc]():e.Ts[b.He];if(b[H]==jD){var f=b.oa[Z];a=d.Aa(c,f[0])+Uz+d.Aa(c,f[3])+Ke+d.Aa(c,f[1])+Uz+d.Aa(c,f[2])}else if(a.L.Uc){var g=b.oa[RG],f=b.oa[Z],k=a.Nb[I](c,g[0]);a=a.Nb[I](c,f[0]);g=d.Aa(c,g[0]);f=d.Aa(c,f[0]);if(null===k&&li(g)&&null===a&&li(f))return{ti:!1,content:null};a=f+me+g}else{f=b.oa[Z];k=b.Eg?b[Z][c][1]:a.Nb[I](c,f[0]);a=b.Eg?b[Z][c][1][hc]():a.Nb.Aa(c,f[0]);if(null===k&&li(a))return{ti:!1,content:null};k=b.oa[xx]||[];k[J]&&
(k=Gi(k,function(a){return d.Aa(c,a)}),a+=rga+k[ie](Ke)+$f)}return{ti:!1,content:a,gv:e,$l:b[uz],am:!1}}
function pLa(a){function b(a){return{Jk:a.x,Vv:a.y}}function c(a){return new kK(a.Jk,a.Vv)}function d(a){return{x:a.x,y:a.y}}function e(a){return new kK(a.x,a.y)}var f=a.L,g=a.Xc,k=W(function(a,b,c){b.bga&&(this.kg[0].fc(c.x),this.Re[0].fc(c.y))},a);a=W(function(a,b,c){g.fc(c.Jk);b.x4&&this.Te[a.ee].fc(c.Vv)},a);var l,n,q;switch(f.Wa){case QH:l=e;n=d;q=k;break;case Bg:l=c,n=b,q=a}for(k=0;k<f.k[J];k++)if(a=f.k[k],a[H]==QH||a[H]==JF)if(Ri([Bg,Sxa,ID],a.av)){var s=a[H]==QH&&a.av==ID,u=a.av==Bg;a.QV=
!0;a.Hga=s;s=YO(Gi(a.j,function(a){return!a||a.Ae?null:l(a.Cf)}),a.gK,u,s,f.Lj);for(u=0;u<a.j[J];++u){var w=a.j[u];if(s[u]){var z=n(s[u][0]),B=n(s[u][1]);w.v5=z;w.w5=B;q(a,w,z);q(a,w,B)}}}else a.QV=!1}
function uLa(a){if(a.L.Fh==lD){var b=a.Xc,c=fj(a.L.Ba[J]);dj(c,W(function(a,b){return bj(aU(this,a),aU(this,b))},a));var d=b.hh,e=b.Gh;if(d>e)var f=d,d=e,e=f;for(var g,k,f=0;f<c[J];f++){var l=c[f];k=aU(a,l);if(null!=k){if(FT(b,k))return;if(!(k*b[jx]<b.hh*b[jx])){g=f;break}}}if(Qh(g))for(var n=d,q,d=null,f=g;f<c[J];f++){null!=d&&f<d&&(f=d,d=null);l=c[f];g=n;if(f==c[J]-1){bU(a,l,g,e);break}q=aU(a,c[f+1]);if(null==q){for(n=f+2;n<c[J];n++)if(q=aU(a,c[n]),null!=q){d=n;break}if(null==q){bU(a,l,g,e);break}}if(FT(b,
q)){bU(a,l,g,e);break}n=vj(k,q);bU(a,l,g,n);k=q}}}function aU(a,b){var c=a.L.Ba,d=a.Xc;return d[H]==Dh?null!=c[b][Z]?d.OG(c[b][Z]):null:d.se(b)}function bU(a,b,c,d){function e(){var a=c;c=d;d=a}var f=a.L.A.top,g=a.L.A[Hc],k=a.L.A[G],l=a.L.A[Zc],n=a.Xc[jx];b=a.L.Ba[b];a.L[lz]==Jg?1==n?(d<c&&e(),b.kP=new rl(f,d,g,c)):(d>c&&e(),b.kP=new rl(f,c,g,d)):1==n?(d<c&&e(),b.kP=new rl(c,l,d,k)):(d>c&&e(),b.kP=new rl(d,l,c,k))}
function xLa(a){var b=a.L;Dj(b.be,function(a,d){cU(this,this.Re[d],b.be[d],this.kna)},a);Dj(b.Be,function(a,d){cU(this,this.kg[d],b.Be[d],this.jna)},a)}function yLa(a){var b=a.L;Dj(b.Be,function(a,d){cU(this,this.kg[d],b.Be[d],this.Mna)},a)}function cU(a,b,c,d){c[cd]&&Bw(c,Fi(c[cd],W(d,a,b)))}T.jna=function(a,b){var c=this.L,d=b.ma;return d.Cb?!0:(d=OQ(d))?a.Sl!=mF||(new rl(c.A.top,c.A[Zc],c.A[Hc],c.A[G]))[Lc](d)?!0:!1:!0};
T.Mna=function(a,b){var c=this.L;if(a.Sl!=mF)return!0;var d=b.ma;if(d.Cb)return!0;var e=OQ(d);if(!e)return!0;var d=d.X[uc]/2,f=new rl(e.top,e[Zc]+d,e[Hc],e[G]-d),g;for(g in c.be){var k=ia(g);if(this.Re[k].Sl==mF&&!(1>(c.be[k][cd]?c.be[k][cd][J]:0))){var l=OQ(c.be[k][cd][0].ma),n=OQ(Ai(c.be[k][cd]).ma);if(l||n){if(l&&ul(f,l)||n&&ul(f,n))return!1;l?n?(k=h.min(l[G],n[G]),l=h.max(l[Zc],n[Zc])):(k=l[G],l=l[Zc]):(k=n[G],l=n[Zc]);if(h.abs(e[G]-k)<d||h.abs(e[Zc]-l)<d)return!1}}}return!0};
T.kna=function(a,b){var c=this.L,d=new rl(c.A.top,c.A[Zc],c.A[Hc],c.A[G]),e=b.ma,f=e.X[uc]/2,e=OQ(e);if(!e)return!0;if(a.Sl==mF&&!d[Lc](e))return!1;d=new rl(e.top,e[Zc]+f,e[Hc],e[G]-f);return(f=OQ(c[uz]))&&ul(d,f)||(c=c.JD?OQ(c.JD):null)&&ul(d,c)?!1:(c=this.kf.getArea())&&ul(d,c)?!1:!0};
function wLa(a){var b=a.L,c=a.Xc,d=a[eq],e={Va:b.Kj,fontSize:b.Nl,Tb:b.$u},f=Ln(d,[Tqa,yC],e),g=Jn(d,[Qqa,Jqa]),k=Cn(d,[Rqa,Vqa],O),l=Gn(d,[Sqa,Wqa],sP,HF);Y(a.L.Ba,function(a,d){var e=[],n=[];Y(b.Tj,function(a){a=this.iK(d,a.oa,l);Zi(e,a.FL);Zi(n,a.line)},this);if(e[J]||n[J]){var q=WT(this,d),q=c.se(q),s=b.A.top+b.A[A];e[J]&&(s={x:q,y:s},a.Jc=QLa(this,s,R,O,!1,this.L[lz],e,f,g,5,k));n[J]&&(s={x:q,y:null},a.Jc=RLa(this,s,n,f,k))}},a);var n=Hj(dFa),q=pn(d,[Mqa,Uqa],!0),s=pn(d,[Kqa,Iqa],!1),u=lfa(d,
[Pqa,yC],n,e),w=Jn(d,[Lqa,Jqa]),z=Dn(d,[Nqa,Vqa],n,O),B=Gn(d,[Oqa,Wqa],sP,HF);Y(a.L.k,function(a,b){if(a[H]==BC||a[H]==KC||a[H]==JF||a[H]==QH){var c=ZH+b+Lma,e=pn(d,c+ova,q),f=pn(d,c+wqa,s),g=lfa(d,c+EI,n,u);Xa(g,ST(g[E],a[E]));var k=Jn(d,[c+ora],w),l=Dn(d,c+cAa,n,z),l=ST(l,a[E]);Gn(d,c+sh,sP,B);for(c=0;c<a.j[J];++c)if(null!=a.j[c]&&null!=a.j[c].S){var Ha=a.j[c],Aa=this.iK(c,a.oa,B),Wc=Ha.S,cb=a[E][E][ke](),Ha=Ha.brush?Ha.brush.gb():cb;if(Ha!==cb&&e){var cb=Pj(g),kc=[0.1,0.2,0.3],kd=rm(Ha),Mb=rm(this.L.nD.gb()),
Oc=Gi(kc,gi(wm,kd)),kc=Gi(kc,gi(xm,kd)),kd=pm(ym(Mb,Xi([kd],Oc,kc)));Xa(cb,kd)}else cb=g;Aa.FL[J]&&(a.j[c].Jc=QLa(this,Wc,a[H],Ha,this.L.Dd,this.L[lz],Aa.FL,cb,k,12,l,e,f));Aa.line[J]&&(a.j[c].Jc=RLa(this,Wc,Aa.line,g,l))}}},a)}T.iK=function(a,b,c){var d=this.Nb,e=b.annotation,f={line:[],FL:[]};if(null==e)return f;b=b.annotationText||[];for(var g=0;g<e[J];++g){var k=e[g],l=k+1,n=0<=Ci(b,l);d[I](a,k)&&(l={text:d.Aa(a,k),W5:n?l:null,rowIndex:a},Gn(this[eq],Eqa+k+Tma,sP,c)==JF?f.line[C](l):f.FL[C](l))}return f};
function QLa(a,b,c,d,e,f,g,k,l,n,q,s,u){var w=[[64,64,64],[128,128,128],[255,255,255]],z=null==s?!0:s;s=c===KC;var B,F;if(s)var M=new vl(b[G],b.top,b[r],b[A]),N=F=b.top,P=B=h[t](b[G]+b[r]/2);else var P=B=b.x,N=F=b.y;var ba=N-n,U=ba,qa=-n,ya=g[J],Ha=n+k[uc]*ya;N-Ha<a.L.A.top&&N+Ha<a.L.A[Hc]&&(ba=N+Ha,U=N+n+k[uc],qa=n);N=null;1<ya&&(n=P,N=U,U=null,U=g[0][cd]+fla,Ha=a.Ac(U,k),c===KC&&Ha[r]>b[r]?(c=b[G],n=nI):(c=n,n=pD),U={KS:!1,label:{text:U,X:k,F:[{x:0,y:0,length:Ha[r],text:U}],Cc:n,Bc:oE,anchor:new uP(c,
N),Cb:0}},a.As&&(U[Rc].vb=hoa),N=U);c=[];for(n=0;n<ya;n++){var U=g[n],Aa=a.Ac(U[cd],k),Ha={},Wc=new uP(B,ba),cb=null;Ha.X=jo(k,ko);if(s){if(M&&!u){var cb=rm(d),kc=pm(ym(cb,w)),cb=f===Jg?NI:zs,kd=jo(k,ko);z&&(kd.Tb=R,Xa(kd,kc));t:{var Mb=U[cd],Oc=kd,Vd=cb,cb=M,Tf=a.Ac,kd=a.As,Uf=di(2)?2:0,Ce=di(2)?2:0,kc=Tf(Mb,Oc),gq,Gf=cb.Ub();gq=kc[r]<=Gf[r]&&kc[A]<=Gf[A];var Gf={},Di=[];Bw(Gf,Mb);Gf.X=Oc;if(Vd===NI)Vd=h[t](cb[Vy]().x),Ce=cb.top+Ce,Gf.Cc=pD,Gf.Bc=nI;else if(Vd===zs)Vd=cb[G]+(cb[r]-Uf),Ce=h[t](cb[Vy]().y),
Gf.Cc=oE,Gf.Bc=pD;else throw m("Invalid text block position.");if(!gq||kc[r]>cb[r]-Uf)if(kc[A]<cb[A]){if(Oc=UN(Tf,Mb,Oc,cb[r]-Uf,cb[A]/(kc[A]+2)),Di=Oc.F,Oc.ge){var hj=Mb;Gf.TA=!0}}else if(cb[A]>Oc[uc]/3)hj=Mb,Di=[Ne],Ce=h[t](cb[Vy]().y),Gf.Bc=pD,Gf.TA=!0;else{cb=null;break t}Gf.F=[];if(Di[J])for(Oc=Mb=0,Tf=Di[J];Oc<Tf;Oc++)Gf.F[C](new oJa({x:0,y:Mb,length:cb[r],text:Di[Oc]})),Mb+=kc[A];else Gf.F[C](new oJa({x:0,y:0,length:kc[r],text:Mb}));Gf.Cb=0;Zw(Gf,new uP(Vd,Ce));kd&&hj&&(Gf.de={am:!1,ti:!1,
content:hj});cb=new pJa(Gf)}}if(u||!e&&(!cb||1<cb.F[J]||cb.TA))switch(f){case Jg:Ha.Bc=oE;b[r]>Aa[r]?(Wc.x=B,Ha.Cc=pD):(Wc.x=M[G],Ha.Cc=nI);break;case Eh:Wc.x=M[G]+M[r]+2,Ha.Cc=nI,Ha.Bc=pD,Wc.y=M[Vy]().y}}else Wc.x=P,Ha.Cc=pD,Ha.Bc=oE;if(cb&&(e||!e&&!cb.TA)){c[C](cb);var Hf=!0}else{switch(f){case Jg:Ha.Cc=pD;Ha.Bc=oE;break;case Eh:Ha.Cc=nI,Ha.Bc=pD}Bw(Ha,U[cd]);Ha.X=k;Ha.cq=l;Zw(Ha,Wc);Ha.TA=!1;Ha.F=[{x:0,y:0,length:Aa[r],text:U[cd]}];Ha.Cb=0;Aa=U.W5;a.As&&null!=Aa&&(Ha.de=RT(a,Aa,U.rowIndex));c[C](Ha);
ba-=k[uc]}}n=Hf?0:qa;a=Eh;s&&f===Eh&&(n=0,a=Jg,B=b[G]+b[r],F=h[t](b.top+b[A]/2));return{E3:{x:B,y:F,length:n,orientation:a,color:q},labels:c,bundle:N?N:null}}
function RLa(a,b,c,d,e){var f=b.x,g=b.y,k=d[uc];b=[];for(var l=0;l<c[J];l++){var n=c[l],q=UN(a.L.Ac,n[cd],d,a.L.A[A]-k);b[C](q)}if(null!=g){for(l=n=0;l<b[J];l++)q=b[l],n=h.max(n,q.Kg);l=n+k;g=h[D](g-l/2);g<a.L.A.top&&(g=a.L.A.top);k=g+l;k>a.L.A[Hc]&&(k=a.L.A[Hc],g=k-l)}else g=a.L.A.top,k=a.L.A[Hc];for(var s=h[D]((g+k)/2),u=f+2,w=[],l=0;l<c[J];l++){var n=c[l],q=b[l],q={text:n,X:d,F:[{x:u,y:s,length:q.Kg,text:q.F[0]}],Cc:pD,Bc:nI,anchor:null,Cb:270},z=n.W5;a.As&&null!=z&&(q.de=RT(a,z,n.rowIndex));w[C](q);
u+=d[uc]}return{E3:{x:f,y:g,length:k-g,orientation:Eh,color:e},labels:w,bundle:null}}function HLa(a,b){var c=a.L.k[b],d=SLa(a,c);c.j&&Y(c.j,function(a){null!=a&&(a.S=d(a.Cf),null!=a.v5&&(a.ir=d(a.v5)),null!=a.w5&&(a.jr=d(a.w5)))});c.ef&&(0<c.ef.F[J]||0<c.ef[Qz][J])&&TLa(c)}function vLa(a){Y(a.L.k,function(a,c){HLa(this,c)},a)}
function TLa(a){function b(b){var c=e[b];delete e[b];if(c&&1<c.line[J]){c[Hc]&&c[Hc][rx]();if(f[b].av!=R){var d=f[b].av==Bg;b=f[b].gK;c.JS=YO(c.line,b,d,!1,!1);c[Hc]&&(c.Rea=YO(c[Hc],b,d,!1,!1))}a.ef.ii[C](c)}}function c(a,b){if(!e[a]){var c=f[a].brush.o(),d=f[a][x],g={};g.LD=a;g.line=[];d==BC?(c.yk(0),Na(g,[])):c.dh(0);g.brush=c;e[a]=g}e[a].line[C](new kK(b[G],b.top));e[a][Hc]&&e[a][Hc][C](new kK(b[G]+b[r],b.top+b[A]))}function d(a){a=f[a][x];return a==BC||a==JF}var e={},f=a.ef.ND;a.ef.ii=[];for(var g=
0;g<a.j[J];g++){var k={},l=a.j[g];if(l&&l.S&&l.S.sq)for(var l=l.S.sq,n=0;n<l[J];++n){var q=l[n].LD;d(q)&&(k[q]=!0,c(q,l[n][zz]))}for(q in e)k[q]||f[q].Lj||b(q)}for(q in e)b(q)}function SLa(a,b){switch(b[H]){case QH:return W(a.Zqa,a,b);case dD:return W(a.Wqa,a,b);case JF:return W(a.Yqa,a,b);case KC:return W(a.Vqa,a,b);case qI:return W(a.$qa,a,b);case jD:return W(a.Xqa,a,b);case BC:return W(a.Uqa,a,b)}return null}T.Zqa=function(a,b){return{x:this.kg[0].se(b.x),y:this.Re[0].se(b.y)}};
T.Wqa=function(a,b){var c=this.Eq,d=this.kg[0].se(b.x),e=this.Re[0].se(b.y),f;f=c.Do==Yg?NQ(c.iq,b[E]):c.Do==rh?c.Qy[b[E]][E]:c.YK;f=new Rm({fill:f,ae:c.Vl,stroke:c.Qd});c=oHa(c.rD,b[ly]);return{x:d,y:e,brush:f,radius:c,lN:c}};T.Yqa=function(a,b){var c=dU(this,a.ee,b.Jk,b.Vv);c.sq=eU(this,a,b);return c};T.Vqa=function(a,b){var c=fU(this,a,b,b.Rj,b.Ck);return c?{top:c.top,left:c[G],width:c[r],height:c[A],sq:eU(this,a,b)}:null};
T.Xqa=function(a,b){var c=fU(this,a,b,b.eha,b.fha),d=fU(this,a,b,b.dha,b[Ry]);if(!c||!d)return null;pa(d,2);Ya(d,d[G]+(c[r]-(c[r]%2?3:2))/2);var e=b.cha?a.FD.H3:a.FD.I3;Vm(e)&&(e=e.Hb/2,Sa(c,c[A]-2*e),pa(c,c[r]-2*e),Ya(c,c[G]+e),c.top+=e);Sa(c,h.max(c[A],2));pa(c,h.max(c[r],1));return{rect:c,line:d}};
T.$qa=function(a,b){var c=this.Te[a.ee];null==b.Rj&&(b.Rj=jP(c.ca,c.Ed.ra));var d=this.Xc,e=d[wy][b.Dq].aa,f=d.pv,g=h[t](e-d[jx]*f/2),f=h[t](e+d[jx]*f/2),k=c.se(b.Ck),d=gU(this,g,c.se(b.Rj)),e=gU(this,g,k),f=gU(this,f,k),k=[];pn(this[eq],tsa,!0)&&null!=b.g4&&(c=gU(this,g,c.se(b.g4)),k[C](c));k[C](e);k[C](f);return{vD:XKa(d.x,d.y,f.x,f.y),outline:k,sq:eU(this,a,b)}};
function fU(a,b,c,d,e){var f=a.Xc,g=a.Te[b.ee];b=a.KM;null!=d||(d=jP(g.ca,g.Ed.ra));if(c.Fv>=b.z6||c.Dq>=f[wy][J]&&f[H]!=Dh)return null;f=h.min(g.se(d),g.se(e));d=h.max(g.se(d),g.se(e));g=(e=a.L.Wa===cF)?DLa(g.pv,pn(a[eq],dF))?0:1:h.min(1,0.2*(d-f));0===g||h[t](f+g)<h[t](d)&&h[t](f+g)>h[t](f)?(f=h[t](f+g),d=h[t](d)):f+=g;var k=sn(a[eq],hta,0.3),g=ULa(a,c);c=(c.aga?k:1)*b.kN/2;b=(e?h[xb]:h[t])(g-c);c=h[t](g+c);f=gU(a,b,f);a=gU(a,c,d);return XKa(f.x,f.y,a.x,a.y)}
T.Uqa=function(a,b){function c(a){return null!=a?a:e}var d=this.Te[a.ee],e=jP(d.ca,d.Ed.ra),d=dU(this,a.ee,b.Jk,b.Vv),f=dU(this,a.ee,b.z4,c(b.A4)),g=dU(this,a.ee,b.B4,c(b.C4)),k=dU(this,a.ee,b.D4,c(b.E4)),l=dU(this,a.ee,b.G4,c(b.H4)),n=eU(this,a,b);return{x:d.x,y:d.y,tT:f.x,uT:f.y,vT:g.x,wT:g.y,GK:k.x,IK:k.y,JK:l.x,KK:l.y,sq:n}};
function eU(a,b,c){if(!c.zE)return[];var d=a.Xc;b=a.Te[b.ee];var e=a.KM;if(c.Fv>=e.z6||c.Dq>=d[wy][J]&&d[H]!=Dh)return[];for(var f=ULa(a,c),g=[],k=0,l;l=c.zE[k];k++){var n=b.se(l.hia),q=b.se(l.iia),s=(d[H]==Dh?d[wy]&&1<d[wy][J]?d[wy][1].aa-d[wy][0].aa:0:e.kN)*l.jia,u=h.abs(n-q),q=gU(a,f-s/2,h.min(q,n)),n=q.x,q=q.y,s=gU(a,s,u);g[C]({rect:new vl(n,q,s.x,s.y),LD:l.LD})}return g}function ULa(a,b){var c=a.Xc,d=a.KM;return(c[H]==Dh?c.se(b.Jk):c[wy][b.Dq].aa)-d.$ia+(d.kN+1)*b.Fv+d.kN/2}
function ST(a,b){switch(a){case YH:return b.tb;case jza:return b.Mi;case XH:return b[E];default:return a}}function gU(a,b,c){switch(a.L[lz]){case Jg:return{x:b,y:c};case Eh:return{x:c,y:b}}throw m("Invalid orientation.");}function dU(a,b,c,d){return gU(a,a.Xc.se(c),a.Te[b].se(d))}function $T(a,b){var c=a.o();if(Wm(c)&&c.gb()!=ue){var d=new Qm(pH,c.gb());c.fe=d;!Vm(c)&&b&&(c.dd(c.gb()),c.yk(1))}else Vm(c)&&(c.Hk=UD);return c}function ILa(a,b){var c=a.o();c.yk(c.Hb*b);return c}
function MLa(a,b,c){a=a.Nb;b=b.oa.certainty||[];return b[J]&&(c=a[I](c,b[0]),null!=c)?a.D(b[0])==jg?c?1:0:c:1}function OLa(a,b,c){a=a.Nb;b=b.oa[yz]||[];return b[J]&&(c=a[I](c,b[0]),null!=c)?!!c:!0}function NLa(a,b,c){a=a.Nb;b=b.oa.emphasis||[];return b[J]&&(c=a[I](c,b[0]),null!=c)?a.D(b[0])==jg?c?2:1:c:1}function UT(a,b){var c=TT(a);return null===c?null:a.Nb[I](b,c)}function TT(a){if(null===a.Xc||a.Xc[H]!=Dh)return null;a=a.L.Tj[0].oa.gap||[];return Si(a)?null:a[0]}
function XT(a,b,c,d,e){function f(a,b,f){var g=jP(k.ca,l[I](c,a));b=jP(k.ca,l[I](c,b));null!=g&&null!=b&&(g+=d,b+=d,e&&(k.fc(g),k.fc(b)),n[C]({iia:g,hia:b,jia:f,LD:a}))}var g=b.ef;if(!g)return null;var k=a.Te[b.ee],l=a.Nb,n=[];for(a=0;a<g.Kw[J];a+=2)f(g.Kw[a],g.Kw[a+1],0);for(var q=0,s=g.tN[J]-1;q<=s;q++,s--)a=g.tN[q],b=g.tN[s],f(a,b,g.ND[a].Tha);for(b=0;b<g.j[J];b++)a=g.j[b],f(a,a,0);for(b=0;b<g.Eb[J];b++)a=g.Eb[b],q=g.ND[a],f(a,a,0==b||b==g.Eb[J]-1?q.Sha:q.Uha);q=0;for(s=g[Qz][J]-1;q<=s;q++,s--)a=
g[Qz][q],b=g[Qz][s],f(a,b,0);for(b=0;b<g.F[J];b++)a=g.F[b],f(a,a,0);return n[J]?n:null}function tLa(a){var b=a.L;if(b.xf.bars||b.xf.candlesticks||!Wh(Oi(b.k,function(a){return null!=a.ef}))){var c=Fi(b.Ba,function(a,b){return 0!=UT(this,b)},a),c=VLa(a.Xc,c),c=h.max(c,1),d=nfa(a[eq],c),d=h.max(d,1),e=h.min(a.Zv,h[t]((d+1)/2)),f=(d-e+1)/e;c>d&&(f=h[t](f));a.KM={z6:e,kN:f,$ia:b.Wa===cF?0:((f+1)*e-1)/2}}}
function VLa(a,b){if(Si(b))return 0;if(a[H]==Dh){for(var c=a.WD,d=null,e=0;e<b[J];e++){var f=a.OG(b[e][Z]);null!=d&&(c=h.min(c,h.abs(f-d)));d=f}return c}return h.abs(a.OG(1)-a.OG(0))}function WT(a,b,c){var d=a.Nb;a=a.Xc;a[H]==Dh&&(b=c&&c.Eg?c[Z][b][0]:d[I](b,0),b=jP(a.ca,b));return b};function hU(a){this.Ql=a;this.k_=[];this.mQ=!1;this.Ch={ne:null,Qt:0,Tl:0,uI:0,vI:0}}hU[K].Le=function(a,b,c){this.k_[c]=!0;0===c&&(this.Ch.ne=b,this.Ch.Qt=a.x,this.Ch.Tl=a.y,this.Ch.uI=a.x,this.Ch.vI=a.y)};dp(hU[K],function(a,b){this.Ql[$]({type:a,data:b})});function iU(a,b,c,d){this.Ql=a;this.G=b;this.Pq=c;this.pi=d;this.zx=null;this.yZ=new hU(a);this.mO=null}X(iU,Us);T=iU[K];T.w=function(){this.G[Wb]();this.Pq[Wb]();Ws(this.mO);iU.e.w[L](this)};function WLa(a){var b=a.G.Cs;XLa(a,W(function(a,d){this.G.Fb(b,a,d)},a));Ws(a.mO);a.mO=new MM(a.G.ac());kt(a.mO,GG,W(a.gna,a))}function YLa(a){var b=a.Pq.ac();XLa(a,W(function(a,d){this.Pq.Fb(b,a,d)},a))}function ZLa(a){var b=fa;$La(a,W(function(a,d){this.Pq.Fb(b,a,d)},a))}
function $La(a,b){b(EG,W(a.Bra,a));b(FG,W(a.Cra,a))}function XLa(a,b){b(gs,W(a.oda,a));b(fs,W(a.Rqa,a));b(EG,W(a.oda,a));b(FG,W(a.Qqa,a));b(es,W(a.Pqa,a));b(Fr,W(a.Nqa,a));b(OD,W(a.Sqa,a));b(YD,W(a.Oqa,a))}T.Bra=function(a){var b=Ml(this.G.ac());a=Ml(a);a.x-=b.x;a.y-=b.y;b=this.yZ;b.k_[0]&&(b.Ch.uI=a.x,b.Ch.vI=a.y,b.mQ||b[$](Jra,{ne:b.Ch.ne,ub:{x:b.Ch.Qt,y:b.Ch.Tl}}),b.mQ=!0,b[$](Hra,{ne:b.Ch.ne,ub:{x:b.Ch.uI,y:b.Ch.vI}}))};
T.Cra=function(a){var b=Ml(this.G.ac()),c=Ml(a);c.x-=b.x;c.y-=b.y;b=this.yZ;a=a[rq];b.k_[a]=!1;0===a&&b.mQ&&(b.mQ=!1,b.Ch.uI=c.x,b.Ch.vI=c.y,b[$](Ira,{ne:b.Ch.ne,ub:{x:b.Ch.uI,y:b.Ch.vI}}))};T.oda=function(a){var b=gK(a),c=this.us(a);a[H]==EG&&this[$](Nra,{ub:b,ne:c});c!=this.zx&&(null!=this.zx&&aMa(this,this.zx),this[$](Kra,{ub:b}),jU(this,Ioa,c),this.zx=c)};T.Rqa=function(a){a=this.us(a);a==this.zx&&(aMa(this,a),this.zx=null)};function aMa(a,b){a[$](Lra,null);jU(a,Joa,b)}
T.Qqa=function(a){var b=gK(a);a=this.us(a);this[$](Ora,{ub:b,ne:a});jU(this,Toa,a)};T.Pqa=function(a){var b=gK(a),c=this.us(a);this[$](Mra,{ub:b,ne:c,preventDefault:W(a[Hp],a)});jU(this,Soa,c);this.yZ.Le(b,c,a[rq])};T.Nqa=function(a){var b=gK(a);a=this.us(a);this[$](Fra,{ub:b,ne:a});jU(this,goa,a)};T.Sqa=function(a){var b=gK(a),c=this.us(a);this[$](Tra,{ub:b,ne:c});jU(this,hpa,c);Ys(a)};T.Oqa=function(a){var b=gK(a);a=this.us(a);this[$](Gra,{ub:b,ne:a});jU(this,ooa,a)};
T.gna=function(a){var b=gK(a),c=this.us(a);this[$](Ura,{ub:b,ne:c,wheelDelta:a.detail,preventDefault:W(a[Hp],a)});jU(this,lpa,c)};
function jU(a,b,c){var d=c[pc](qe);switch(d[0]){case Hs:var e=c=null,f=null;a.pi==cH?c=ia(d[1]):4==d[J]?(c=d[1]?ia(d[1]):null,e=ia(d[2]),f=ia(d[3])):3==d[J]?(c=ia(d[1]),e=ia(d[2])):e=ia(d[1]);d={kc:c,Ji:e,fx:f};a[$](Hs+b,d);break;case qC:d={$v:d[1]};a[$](nqa+b,d);break;case FF:d=ia(d[1]);if(0>d)break;d={mP:d};a[$](kwa+b,d);break;case GF:d={jma:ia(d[1])};a[$](Fwa+b,d);break;case wya:d=ia(d[1]);d={mP:d};a[$](qya+b,d);break;default:a.Wba(b,c)}}dp(T,function(a,b){this.Ql[$]({type:a,data:b})});function kU(a,b,c,d){iU[L](this,a,b,c,d.Wa);this.Q=d;this.mZ=bMa(this)}X(kU,iU);kU[K].e3=function(a){this.Q=a;this.mZ=bMa(this)};function bMa(a){var b=a.Q;if(b.Wa!=Bg&&b.Wa!=QH)return{};a={};for(var b=b.k,c=0;c<b[J];c++){var d=b[c];if(AS(d))for(var e=d.j,f=0;f<e[J];f++){var g=e[f];if(g&&g.S&&!g.Ae){var k=AN([iH,c,f]);a[k]={center:g.S,radius:g.S&&null!=g.S.lN?g.S.lN:null!=g.lN?g.lN:d.V2,kc:c,Ji:f}}}}return a}
kU[K].us=function(a){var b=this.G.Er(a[Mq]),c=gK(a),c=cMa(this,c);if(a[H]==fs){a=this.zx;if(null==a)return b;c=c==a?null:a}if(null!=c){a=dMa(b);var d=dMa(c),b=a>d?b:c}this.Q.Fh==lD?(c=b[pc](qe)[0],c=c!=JC&&c!=cD&&c!=iD&&c!=iH&&c!=mH&&c!=rI):c=!0;return c?b:Er};
function cMa(a,b){if(!(new vl(a.Q.A[G]+1,a.Q.A.top+1,a.Q.A[r]-2,a.Q.A[A]-2))[Lc](b))return null;switch(a.Q.Fh){case WD:var c=b.x,d=b.y,e=null,f=ea,g;for(g in a.mZ){var k=a.mZ[g],l=k[nx].x,n=k[nx].y,q=k[bz];l-c<=q&&l-c>=-q&&n-d<=q&&n-d>=-q&&(l=(l-c)*(l-c)+(n-d)*(n-d),l<=q*q&&l<=f&&(e=AN([mH,k.kc,k.Ji]),f=l))}return e;case lD:t:{c=a.Q.Ba;for(d=0;d<c[J];d++)if((e=c[d].kP)&&e[Lc](b)){c=AN([nD,d]);break t}c=null}return c}return null}function dMa(a){a=a[pc](qe);return Ci(CDa,a[0])}
kU[K].Wba=function(a,b){var c=b[pc](qe);switch(c[0]){case JC:case cD:case iD:case iH:case mH:case rI:var d=ia(c[1]),c={kc:d,Ji:ia(c[2])};this[$](WD+a,c);break;case nD:c=ia(c[1]);c={kc:null,Ji:c};this[$](lD+a,c);break;case zC:d=ia(Ai(c));this[$](xC+a,3==c[J]?{kc:null,Ji:ia(c[1]),fx:d}:{kc:ia(c[1]),Ji:ia(c[2]),fx:d});break;case JF:case BC:d=ia(c[1]),c={kc:d,Ji:null},this[$](fza+a,c)}};function lU(a,b){this.Gu={};this.Qu={};this.UC=[];this[az](a,b)}function eMa(a){Y(a.UC,function(a){fMa(this,this.Qu[a])},a)}lU[K].updateOptions=function(a,b){this.ta=Ln(a,mqa,b);this.Uoa=Ln(a,lqa,b);eMa(this)};lU[K].getEntries=function(){for(var a=[],b=0,c=this.UC[J];b<c;b++){var d=this.UC[b],e=this.Qu[d];if(!e[oz]||e[oz]()){var f=null,f=e.is&&!e.is()?CN(e[cd]||O,this.Uoa,null,null,null,null,null,!1,null):Qj(this.Gu[d]);a[C](f)}}return a};
function fMa(a,b){if(!b.id)throw m("Missing mandatory ID for action.");var c=null;a.Qu[b.id]?c=a.Qu[b.id]:(c=a.Qu[b.id]={id:b.id,text:void 0,visible:void 0,is:void 0,action:void 0},a.UC[C](b.id));Sj(c,b);a.Gu[b.id]=CN(c[cd]||O,a.ta,null,null,null,null,null,!1,c.id)}lU[K].Tg=function(a){(a=this.Qu[a])&&(a=Qj(a));return a};function gMa(a,b){a.qH=a.qH||{};var c=a.qH;c.entries=c[Ez]||{};c=c[Ez];c[b]=c[b]||{};c=c[b];c.ih=c.ih||{};return c.ih}
lU[K].gu=function(a,b,c){if(!a[jy]){var d=b.Qa.$v;null!=d&&(a=Pi(a.qH[Ez],function(a){return a.ih[Z].id==d}),-1!==a&&(c=gMa(c,a),ra(c,c[Z]||{}),Ww(c[Z],c[Z][Dz]||{}),c[Z][Dz].brush=Zm(Bla)))}};function hMa(a){this.Ob=a}function mU(a,b){var c={index:{},order:[],Ts:{}};Y(b,function(a){var b=this.getKey(a);if(null!=b){if(!c.Ts[vc](b)){var f=this.getTitle(a);f&&(c.Ts[b]=f)}c[nc][vc](b)||(c[nc][b]=[],c[ix][C](b));c[nc][b][C](a)}},a);return c};function nU(a){this.Ob=a}X(nU,hMa);nU[K].getKey=function(a){return this.Ob.QX(a)};nU[K].getTitle=function(a){return this.Ob.iO(a)};Ow(nU[K],function(a,b,c){var d=KIa(this.Ob,c);return iMa(a,d,b[yb]||O,!0,a.Lka,this.Ob.k[c.nb])});function oU(a){this.Ob=a}X(oU,hMa);oU[K].getKey=function(a){return a.nb};oU[K].getTitle=function(a){return KIa(this.Ob,a)};Ow(oU[K],function(a,b,c){c=this.Ob.iO(c)||O;return[c?CN(b[yb]||O,a.aH,c,a.ta):null]});function pU(a,b,c,d){b=Ln(a,GAa,{Va:b.Va,fontSize:b[uc]});this.ar=pn(a,BAa,c==lD);this.Lka=pn(a,BAa,!0);this.tia=pn(a,DAa,!0);this.ta=b;this.aH=Zea(b);this.te=d||null;this.Z6=zn(a,gta,koa);this.a7=zn(a,kta,apa)}pU[K].jt=function(){};function qU(a,b,c,d){pU[L](this,a,b,c,d)}X(qU,pU);
qU[K].Y5=function(a,b,c){var d=a.Ob,e=d.k[b];c=d.qF(b,c);var f=!1,g=null,k=null,l=null!=d.Uc&&d.Uc;if(d.Uc)if(f=!0,k=[this.Z6,this.a7],d=e[H],d===KC)g=[{color:e.fh.gb(),alpha:e.fh.Oe},{color:e.eh[Dz].fh.gb(),alpha:e.eh[Dz].fh.Oe}];else if(d===QH)d=b%2?b-1:b,b=a.Ob.k[d],d=a.Ob.k[d+1],g=[{color:d.fh.gb(),alpha:d.fh.Oe},{color:b.fh.gb(),alpha:b.fh.Oe}];else throw m("Diff chart not supported for the chosen chart type.");b={entries:[]};if(c.F)for(c[uz]&&rU(this,b,c[uz]),e=0;e<c.F[J];e++)k=c.F[e],f=b,k=
(l=k[uz])?CN(k[id],this.aH,l,this.ta):null,null!=k&&f[Ez][C](k);else c.gv&&!c.ti?(rU(this,b,c.gv),sU(this,b,c.$l,c[yb],!0,this.ar,e,f,g,k,l)):c.$l&&!c.ti?sU(this,b,c.$l,c[yb],!0,this.ar,e,!0,g,k,l):null!=c[yb]&&sU(this,b,null,c[yb],!1,this.ar,e);this.jt(b,a.Sj);return b};
function jMa(a,b,c,d){var e=b.Ob,f=new nU(e),g=new oU(e),k=null;d==lD?k=f:d==WH&&(k=g);var l;if(k)l=mU(k,c);else{d=mU(f,c);var n=mU(g,c),k=g;l=n;1==d[ix][J]&&1<n[ix][J]&&(k=f,l=d)}var q={entries:[]};Y(l[ix],function(a){rU(this,q,l.Ts[a][hc]());Y(l[nc][a],function(a){var b=e.qF(a.nb,a.jb);b.ti?sU(this,q,null,b[yb],!1,this.ar,e.k[a.nb]):q[Ez][C][Mc](q[Ez],k[nz](this,b,a))},this)},a);a.jt(q,b.Sj,0<c[J]);return q}
qU[K].Z5=function(a,b){var c=a.Ob,d=c.k[b],e=d.de,f=null,g=null,k=null!=c.Uc&&c.Uc;c.Uc&&(f=c.k[J],f=(b+f/c.pie.Ih[J])%f,g=c.k[f],c={color:d.brush.gb(),alpha:d.brush.Oe},g={color:g.brush.gb(),alpha:g.brush.Oe},f=b>f?[c,g]:[g,c],g=[this.Z6,this.a7]);c={entries:[]};e.$l?sU(this,c,e.$l,e[yb],!0,this.ar,d,!0,f,g,k):sU(this,c,null,e[yb],!1,this.ar,d);this.jt(c,a.Sj);return c};
function kMa(a,b,c){var d=b.Ob,e={entries:[]};Y(c,W(function(a){a=d.k[a];var b=a.de;b.$l?sU(this,e,b.$l,b[yb],!0,this.ar,a,!0):sU(this,e,null,b[yb],!1,this.ar,a)},a));a.jt(e,b.Sj);return e}
qU[K].X5=function(a,b){var c=a.Ob,d=c.Ba[b].de,e=!1,f={entries:[]};if(d&&d[yb])sU(this,f,null,d[yb],!1,!1);else{var g=0,k=1,l=c.k[J];UIa(c)&&(g=c.k[J]-1,l=k=-1);for(var n=null;g!=l;g+=k){var q=c.k[g],d=tS(c,g,b);if(n!=q.He){var n=q.He,s=c.Ba[b].Ts[n];mi(s)||rU(this,f,s)}q.j[d]&&q.j[d].de&&q.j[d].de[yb]&&(d=q.j[d].de,sU(this,f,d.$l,d[yb],!0,this.ar,q,void 0,void 0,void 0,void 0,d.ti&&d.am),e=!0)}}null!=a.Sj&&0<a.Sj[J]&&(e=!0);this.jt(f,a.Sj);return e||this.tia?f:null};
function rU(a,b,c){a=CN(c,a.aH);b[Ez][C](a)}function iMa(a,b,c,d,e,f,g,k,l,n,q){g=null!=g?g:!1;d=d?a.aH:a.ta;c=c[pc](me);var s=e?f[E][E]:null;b=g&&null!=b?CN(b,a.ta,null,null,s,f&&f.HD):CN(c[0],d,b,a.ta,s,f&&f.HD,null,q);a=[b];for(g=g?0:1;g<c[J];g++)s=null!=k?k[g][E]:e?R:null,b=CN(c[g],d,null,null,s,null!=k?k[g][Bz]:null,null!=l?l[g]:null,q),b.UI=n,a[C](b);return a}function sU(a,b,c,d,e,f,g,k,l,n,q,s){b[Ez][C][Mc](b[Ez],iMa(a,c,d,e,f,g,k,l,n,q,s))}
qU[K].jt=function(a,b,c){b&&0!==b[J]&&((void 0==c||c)&&a[Ez][C](IDa()),Zi(a[Ez],b))};function tU(a,b,c){pU[L](this,a,b,c);this.I8=this.aH;this.gP=Pj(this.ta);Xa(this.gP,jA);Ja(this.gP,this.gP[uc]-2)}X(tU,pU);tU[K].Y5=function(a,b,c){b=a.Ob.k[b];a=b.j[c].de;c=[];b.Oj||(b=CN(b[uz],this.I8),c[C](b));b=CN(a[yb],this.I8);c[C](b);a=CN(a.gv,this.gP);c[C](a);return{entries:c}};tU[K].Z5=function(){return{entries:[]}};tU[K].X5=function(){return{entries:[]}};function lMa(a,b,c){this.Gt=b;this.tn=new rl(0,c[r],c[A],0);b=null!=b.te&&0<b.te.getEntries()[J]?kg:zg;this.aT=Gn(a,MI,Nn,b)}function uU(a){if(a.Wa==cH){var b=a.pie[nx];return new sk(b.x,b.y)}b=Gj(a.Be);b=null!=b.Ed?b.Ed.aa:h.min(b.hh,b.Gh);a=Gj(a.be);a=null!=a.Ed?a.Ed.aa:h.max(a.hh,a.Gh);return new sk(b,a)}function mMa(a,b){a.tn=b}function vU(a,b,c){var d=b.S;b=CS(b,c);a=uU(a);b=1+h[xb](b/h[ud](2));return new sk(d.x+(d.x>=a.x?b:-b),d.y+(d.y<=a.y?-b:b))}
function nMa(a,b){var c=lK(a.pie[nx],OT(((b.mq?45:(b.Fd+b.$c)/2)/180-0.5)*h.PI,a.pie.Qc,a.pie.Rc)),c=new sk(c.x+b[by].x,c.y+b[by].y);c.x=nj(c.x,0,a[r]);c.y=nj(c.y,0,a[A]);return c}function oMa(a){var b=a[Gz]?a[Gz]:new sk(0,0),c=a.F[0],d=a.X[uc];return 270==a.Cb?new sk(b.x+c.x+d,b.y+c.y-c[J]/2):new sk(b.x+c.x+c[J]/2,b.y+c.y-d)}
function pMa(a,b,c){var d=a.k[b],e=d[H];c=tS(a,b,c);switch(a.Wa){case Bg:case cF:switch(e){case KC:case qI:return d=d.j[c],d=d.S.vD||d.S,b=uU(a),d=new sk(d[G]+(d[G]<b.x?0:d[r]),d.top+(d.top<b.y?0:d[A])),qMa(a,d),d;case JF:case BC:return vU(a,d.j[c],d);case jD:return d=d.j[c].S[zz],b=uU(a),d=new sk(d[G]+d[r]>b.x?d[G]+d[r]:d[G],d.top<b.y?d.top:d.top+d[A]),qMa(a,d),d}case QH:return vU(a,d.j[c],d);case cD:c=d.j[c];b=c.S;d=vU(a,c,d);if(d.x<a.A[G]||d.x>a.A[Zc])d.x+=2*(b.x-d.x);if(d.y<a.A.top||d.y>a.A[Hc])d.y+=
2*(b.y-d.y);return d}return new sk(0,0)}function qMa(a,b){var c=a.A;b.x=nj(b.x,c[G],c[Zc]);b.y=nj(b.y,c.top,c[Hc])}function rMa(a,b){var c=lK(a.pie[nx],OT(((b.mq?45:(b.Fd+b.$c)/2)/180-0.5)*h.PI,a.pie.Qc-0.1,a.pie.Rc-0.1));return new sk(c.x+b[by].x,c.y+b[by].y)}function sMa(a){var b=a[Gz]?a[Gz]:new sk(0,0),c=a.F[0],d=a.X[uc];return 270==a.Cb?new sk(b.x+c.x+d/2,b.y+c.y):new sk(b.x+c.x,b.y+c.y-d/2)}
function tMa(a,b,c){c=tS(a,b,c);var d=a.k[b];b=d[H];c=d.j[c].S;if(b==KC||b==qI||b==jD){var e=c.vD||c[zz]||c;c=e[G];b=e[r];var d=c+b,f=e.top,e=e[A],g=f+e,k=uU(a);a=a[lz]==Jg?g>k.y?new sk(c+b/2,g-0.1):new sk(c+b/2,f+0.1):c<k.x?new sk(c+0.1,f+e/2):new sk(d-0.1,f+e/2)}else a=new sk(c.x,c.y);return a}
function wU(a,b,c,d,e,f){if(null===c||null===d||null===e)if(null===c||null===d)if(null!==c&&null===d){d=b.Ob;f=d.k[c];e=nMa(d,f);f=rMa(d,f);var g=d.k[c].de;g.am&&g.ti?a=xU(a,g[yb],f):(b=a.Gt.Z5(b,c),a=EN(b,d.Ac,!0,e,a.tn,f,void 0,d.Ls))}else if(null!==c||null===d||null===e)if(null===c&&null!==d){c=b.Ob;e=f.o();var g=f=null,k=Gj(c.Be),l=Gj(c.be),n=k.Ol,q=l.Ol,s=d;c[lz]&&c[lz]!==Jg?(q=-q,l[H]===Dh&&(s=c.Ba[d][Z]),g=l[jc].Se(s)):(k[H]===Dh&&(s=c.Ba[d][Z]),f=k[jc].Se(s));k=a.Gt.ta[uc];e.x=null===f?e.x:
f;e.y=null===g?e.y:g;f=e.x-n*k;g=e.y+q*k;f=new sk(f,g);(g=c.Ba[d].de)&&g.am&&g.ti?a=xU(a,g[yb],e):(b=a.Gt.X5(b,d),a=null===b?null:EN(b,c.Ac,!1,f,a.tn,e,void 0,c.Ls))}else a=null;else c=b.Ob,g=c.Ba[d].Jc[vz][e],(n=g.de)?(f=oMa(g),g=sMa(g),n.am&&n.ti?a=xU(a,n[yb],g):(n=a.Gt,d={entries:[CN(b.Ob.Ba[d].Jc[vz][e].de[yb],n.ta)]},0<b.Sj[J]&&n.jt(d,b.Sj),a=EN(d,c.Ac,!1,f,a.tn,g,void 0,c.Ls))):a=null;else e=b.Ob,f=pMa(e,c,d),g=tMa(e,c,d),n=e.k[c].j[d].de,n.am&&n.ti?a=xU(a,n[yb],g):(b=a.Gt.Y5(b,c,d),a=EN(b,
e.Ac,!0,f,a.tn,g,void 0,e.Ls));else f=b.Ob,n=f.k[c].j[d].Jc[vz][e],(q=n.de)?(g=oMa(n),n=sMa(n),q.am&&q.ti?a=xU(a,q[yb],n):(q=a.Gt,d={entries:[CN(b.Ob.k[c].j[d].Jc[vz][e].de[yb],q.ta)]},q.jt(d,b.Sj),a=EN(d,f.Ac,!1,g,a.tn,n,void 0,f.Ls))):a=null;return a}function uMa(a,b,c,d){var e=b.Ob,f=b.Ob.k[d];d=nMa(e,f);var f=rMa(e,f),g=Gi(c,function(a){return e.k[a].de});Mi(g,function(a){return a.am&&a.ti});b=kMa(a.Gt,b,c);return EN(b,e.Ac,!0,d,a.tn,f,void 0,e.Ls)}
function vMa(a,b,c,d,e){var f=b.Ob,g=pMa(f,d.nb,d.jb);d=tMa(f,d.nb,d.jb);var k=Gi(c,function(a){var b=tS(f,a.nb,a.jb);return f.k[a.nb].j[b].de});Mi(k,function(a){return a.am&&a.ti});b=jMa(a.Gt,b,c,e);return EN(b,f.Ac,!0,g,a.tn,d,void 0,f.Ls)}function xU(a,b,c){return{html:{content:b,fd:{className:OE}},Eca:!0,Fca:c,anchor:c,Dca:a.tn,Gca:20,margin:5}};function yU(a,b,c,d,e,f){this.te=f;d==gE||this.te?null!=this.te&&this.te[az](a,c):this.te=new lU(a,c);c=d==gE?new tU(a,c,e):new qU(a,c,e,this.te);this.Fo=new lMa(a,c,b)}function zU(a,b,c){var d={};if(null!=c.Ea.vB){d.Ea=d.Ea||{};var e=b.Ea,f=c.Ea.vB;d.Ea.ln=e.Me[f];var g=f+1+Tq+e.Me[J],k=e.iG.YW,l=0<f,e=e.iG.WW,f=f<b.Ea.Me[J]-1;d.Ea.iG={YW:{brush:l?k.ce.Kt:k.ce.yN,Kt:l},WW:{brush:f?e.ce.Kt:e.ce.yN,Kt:f},XW:{text:g,F:{0:{text:g}}}}}a.gu(b,c,d);return d}yU[K].Hi=function(a){this.te&&fMa(this.te,a)};
yU[K].Tg=function(a){if(this.te)return this.te.Tg(a)};yU[K].Gi=function(a){if(this.te){var b=this.te;a in b.Gu&&delete b.Gu[a];a in b.Qu&&delete b.Qu[a];a=Ci(b.UC,a);0<=a&&b.UC[he](a,1)}};function AU(a){Uv(this,new FN);this.Qa={nb:null,datum:null,jb:null};Cw(this,{Qa:null,lK:null});this.Ea={Qa:{ih:null},vB:null};this.wh={Qa:{$v:null}};hw(this,{position:null,t4:null});this.Jh=this.hn=null;a&&(this[ux][Yx](a[ux]),a.Qa&&(this.Qa=BU(this.Qa,a.Qa)),a[Uy]&&Cw(this,BU(this[Uy],a[Uy])),a.Ea&&(this.Ea=BU(this.Ea,a.Ea)),a.wh&&(this.wh=BU(this.wh,a.wh)),a.hn&&(this.hn=BU(this.hn,a.hn)),a.Jh&&BU(this.Jh,a.Jh))}
AU[K].o=function(){var a=new AU;Uv(a,this[ux].o());a.Qa=hn(this.Qa);Cw(a,hn(this[Uy]));a.Ea=hn(this.Ea);a.wh=hn(this.wh);hw(a,hn(this[iy]));a.hn=hn(this.hn);a.Jh=hn(this.Jh);return a};Za(AU[K],function(a,b){var c=Qh(b)?b:!1;return this[ux][cz](a[ux])&&gn(this.Qa,a.Qa)&&gn(this[Uy],a[Uy])&&gn(this.Ea,a.Ea)&&gn(this.wh,a.wh)&&(c||gn(this[iy],a[iy]))&&gn(this.hn,a.hn)&&gn(this.Jh,a.Jh)});function BU(a,b){var c=new sO(2);tO(c,0,a);tO(c,1,b);return c[My]()};function CU(){}X(CU,sS);T=CU[K];T.iO=function(a){var b=a.nb,c=a.jb;return this.ov?CU.e.iO[L](this,a):this.k[b].fd.histogramBucketItems[c][Rc].gv};T.QX=function(a){return this.ov?CU.e.QX[L](this,a):this.k[a.nb].fd.histogramBucketItems[a.jb].bb};T.$V=function(a){if(this.ov)return CU.e.$V[L](this,a);a=this.k[a.nb].fd.histogramBucketItems[a.jb];return{bb:a.bb,Af:a.Af}};
T.hM=function(a){var b=this.hq[a.Af].kc;return null!=b?this.ov?CU.e.hM[L](this,a):{nb:b,jb:this.k[b].fd.histogramElementIndexes[a.bb]}:null};T.qF=function(a,b){var c=this.k[a],d=c.j[b];return this.ov?{F:[{title:Koa,value:d.Cf.Ck-d.Cf.Rj}]}:c.fd.histogramBucketItems[b][Rc]};function DU(a,b,c,d,e){QT[L](this,a,b,c,d,e)}X(DU,QT);DU[K].f5=function(){return new CU};
DU[K].e5=function(){for(var a=this.mz,b=a.D(0)===rh,c=b?1:0,d=[],e=a.M(),f=a.H(),g=0;g<e;g++)for(var k=c;k<f;k++){var l=a[I](g,k);di(l)&&!na(l)||null===l&&!this.L.Lj||d[C](l||0)}var g=sn(this[eq],pva),n=sn(this[eq],qva),k=sn(this[eq],sva),l=sn(this[eq],rva),q=pn(this[eq],tva),s=new vJa;s[Up](d,n,g,k,l);g=g||s.um;n=[];l=yJa(s);d=new Ko;d.mg(Yg,zF);for(g=c;g<f;g++)for(k=a.cb(g)+Zka,d.mg(Yg,k),n[g-c]=[],k=0;k<l[J];k++)n[g-c][C]([]);a=zJa(s);for(g=0;g<l[J];g++)d.lq(),d.wa(g,0,a[g]);for(g=0;g<e;g++)for(a=
b?this.mz[I](g,0):O,k=c;k<f;k++)if(l=this.mz[I](g,k),!(di(l)&&!na(l)||null===l&&!this.L.Lj)){var u=0==s.um||l<s.vp?0:l>=s.wW?s.nG:h[t]((l-s.vp)/s.um)+s.pr,w=k+1-c;d.wa(u,w,(d[I](u,w)||0)+1);w=this.mz.cb(k)||gC;n[k-c][u][C]({bb:g,Af:k,label:{title:a,gv:a,$l:w,content:l[hc](),F:[{title:w,value:l||0}]}})}for(var z=[],k=c;k<f;k++)z[k]=[];for(k=c;k<f;k++)b=ij(n[k-c]),q&&b[Zd](function(a,b){var c=a[Rc].F[0][id],d=b[Rc].F[0][id];return c<d?-1:c>d?1:0}),d.Sv(k-c,uva,b),Y(b,function(a,b){z[a.Af][a.bb]=b});
for(k=c;k<f;k++)d.Sv(k-c,wva,z[k]);c=zJa(s);d.Sv(0,vva,c);this.Nb=new ku(d)};function DLa(a,b){return 4>a||b}function CLa(a,b,c){for(var d=[],e=0;e<b.Ba[J];e++){d[e]=[];for(var f=0;f<b.k[J];f++){var g=b.k[f];if(g[H]==KC){var k=a?0:f;d[e][k]=(d[e][k]||0)+c[I](e,g.oa[Z][0])}}}for(e=a=0;e<d[J];e++)for(f=0;f<d[e][J];f++)a=h.max(d[e][f],a);return a};function EU(a,b,c,d,e,f,g){yU[L](this,a,b,c,d,e,g);var k=pn(a,nE,!0);this.iT=k;this.yM=Hn(a,Qsa,pfa);this.mha=Gn(a,[Psa,Msa],qfa,kg);this.ria=Gn(a,[Ksa,Msa],qfa,kg);this.kha=En(a,[Nsa,Hsa]);this.pia=En(a,[Isa,Hsa]);this.lha=xn(a,[Osa,Lsa],1);this.qia=xn(a,[Jsa,Lsa],1);this.q6=Gn(a,uqa,pFa,R);this.bm=$O(f,function(b){return pn(a,ZH+b+Nma,k)});this.Gna=Mi(this.bm,kj);this.vK=!0}X(EU,yU);EU[K].gu=function(a,b,c){this.vK=!0;switch(a.By){case ZD:this.q2(a,b,c);break;case gE:wMa(this,a,b,c)}};
EU[K].c3=function(a,b){return a[cz](b,this.vK)};function FU(a,b,c){a.k=a.k||{};a=a.k;a[b]=a[b]||{};b=a[b];b.j=b.j||{};b=b.j;b[c]=b[c]||{};return b[c]}function GU(a,b,c){if(null!=b)return a=FU(a,b,c),a.Jc=a.Jc||{},a.Jc;a=xMa(a,c);a.Jc=a.Jc||{};return a.Jc}function HU(a,b){a.k=a.k||{};var c=a.k;c[b]=c[b]||{};return c[b]}function xMa(a,b){a.Ba=a.Ba||{};var c=a.Ba;c[b]=c[b]||{};return c[b]}function IU(a,b){a.Ea=a.Ea||{};var c=a.Ea;c.ln=c.ln||{};c=c.ln;c[b]=c[b]||{};return c[b]}
EU[K].q2=function(a,b,c){var d={Ob:a,Sj:this.te.getEntries(),qv:c,Yl:b.wh},e=b.wh.Qa.$v;null!=e&&uw(b.wh.Qa,this.te.Tg(e)[Hy]);for(var e=this.Fo.aT,f=e==mh||e==kg,e=e==zg||e==kg,g=this.q6!=R,k=this.te&&0<d.Sj[J],l=IN(b[ux]),n=1<l[J]&&(g||k),q=0;q<l[J];++q){var s=l[q],u=s.column,w=s.row,z=a.hq[u],s=z.kc;if(w=a.hM({Af:u,bb:w}))switch(z.Iv){case Jr:if(!this.bm[s])break;JU(this,a,w.nb,w.jb,c);f&&!n&&KU(this,d,w.nb,w.jb);break;case xC:if(null!=s?!this.bm[s]:!this.iT)break;s=z.Uy;yMa(w.nb,w.jb,s,c);f&&
LU(this,d,w.nb,w.jb,s)}}f&&n&&!a.ov&&(q=Fi(Gi(l,function(b){return a.hM({Af:b.column,bb:b.row})}),Xh),0<q[J]&&zMa(this,d,g?q:[],q[q[J]-1]));l=GN(b[ux],mg);for(q=0;q<l[J];++q)u=l[q],z=a.hq[u],null!=z&&(s=z.kc,null!=s&&this.bm[s]&&AMa(this,a,s,c));l=a.Wa===cD;n=HN(b[ux]);k=1<n[J]&&(g||k);for(q=0;q<n[J];++q)w=n[q],w=a.eq[w],l?(s=0,this.bm[s]&&(JU(this,a,s,w,c),f&&!k&&KU(this,d,s,w))):(BMa(this,a,w,c),f&&!k&&CMa(this,d,b[iy].t4,w));if(k)if(l)KU(this,d,0,a.eq[n[n[J]-1]]);else if(f){var B=a.k,q=ij(Gi(n,
function(b){for(var c=[],d=0;d<B[J];d++){var e=a.eq[b];null!=e&&c[C]({nb:d,jb:e})}return c}));0<q[J]&&zMa(this,d,g?q:[],q[q[J]-1])}f=b.Qa.nb;g=b.Qa[ay];null!=g?this.bm[f]&&(MU(this,a,f,g,c),e&&KU(this,d,f,g),DMa(a,f,g,c)):null!=f&&this.bm[f]&&NU(this,a,f,c);f=b.Ea.Qa.ih;null!=f&&this.bm[f]&&NU(this,a,f,c);f=b.Qa.jb;null!=f&&a.Ba[f]&&(EMa(this,a,f,c),e&&(CMa(this,d,b[iy][jc],f),this.vK=!1));if(f=b[Uy].lK)f=GU(c,f.kc,f.$S),f.bundle=f.bundle||{},f.bundle.KS=!0;(f=b[Uy].Qa)&&e&&(g=a.hq[f.Af],e=g.kc,f=
a.eq[f.bb],g=g.Uy,(null!=e?this.bm[e]:this.iT)&&LU(this,d,e,f,g));if(b=b.Jh)c.Jh=b};var FMa=[0.25,0.1,0.05],GMa=[0.3,0.1,0.05],HMa=[0.3,0.15,0.05];
function MU(a,b,c,d,e){var f=b.k[c],g=f.j[d];if(g&&!g.Ae&&g.S&&(!AS(f)||0!=f[Ny]||BS(g,f))){var k=f[H]==KC?HMa:FMa;e=FU(e,c,d);e.an={};c=e.an;c.Hf=[];for(d=0;d<k[J];d++){var l=new Rm({fill:R,stroke:RC,Cg:k[d],qa:1});c.Hf[C]({brush:l})}switch(f[H]){case KC:case qI:case jD:a=g.S.vD||g.S[zz]||g.S;b=new vl(a[G],a.top,a[r],a[A]);for(d=0;d<k[J];d++)a=c.Hf[d].brush.Hb,c.Hf[d].rect=new vl(b[G]-a/2,b.top-a/2,b[r]+a,b[A]+a),Ya(b,b[G]-a),b.top-=a,pa(b,b[r]+2*a),Sa(b,b[A]+2*a);break;case JF:case BC:case QH:case dD:Pw(e,
!0);c.x=g.S.x;c.y=g.S.y;if(a.yM===kg||a.yM===zg)d=yS(g,f),d=$m(a.pia||d.gb(),1,!1,a.qia),IMa(b,g,e,d,a.ria);e.li?(a=e.li,b=a[bz]+a.brush.Hb/2):b=CS(g,f);for(d=0;d<k[J];d++)a=c.Hf[d].brush.Hb,Jw(c.Hf[d],b+a/2),b+=a}}}
function NU(a,b,c,d){var e=b.k[c],f;if(AS(e)&&0<e[Ny]){f=HU(d,c);f.an={};f=f.an;f.Hf=[];var g;g=e[H]==BC?b.Dd?ES(e):DS(e,!1):DS(e,b.Lj);g=lCa(g);for(var k=e.$d.Hb/2,l=0;l<GMa[J];l++){var n=new Rm({fill:R,stroke:RC,Cg:GMa[l],qa:1}),q=mCa(g,k+n.Hb/2);f.Hf[C]({brush:n,path:q});k+=n.Hb}}f=(f=(f=d.k)&&f[c])&&f.j;for(g=0;g<e.j[J];++g)k=e.j[g],!k||k.Ae||(BS(k,e)||f&&f[g]&&f[g][oz])&&MU(a,b,c,g,d);b.Uc&&e[H]===QH&&!a.RE(e.oa)&&NU(a,b,c-1,d)}EU[K].RE=function(a){a=a[RG];return null!=a&&0<a[J]};
function EMa(a,b,c,d){for(var e=b.k,f=0;f<e[J];++f){var g=tS(b,f,c);a.bm[f]&&null!=g&&MU(a,b,f,g,d)}}
function JU(a,b,c,d,e){var f=b.k[c],g=f.j[d];if(g&&!g.Ae&&g.S&&(!AS(f)||0!=f[Ny]||BS(g,f))){var k=yS(g,f);c=FU(e,c,d);c.li={};d=c.li;var l=b.fK;e=1;null==l&&(l=Hh,e=0);switch(f[H]){case KC:case qI:case jD:e=1;d.brush=Ym.o();d.brush.dd(l);f[H]==jD&&(a=rm(mm(k.gb()).vd),b=rm(mm(l).vd),f=rm(mm(g.Jy.gb()).vd),d.brush.dd(pm(ym(f,[a,b]))));Sm(d.brush,e);d.brush.yk(1);g=g.S.vD||g.S[zz]||g.S;k=k.Hb;a=d.brush.Hb;d.rect=new vl(g[G]+k/2+1.5+a/2,g.top+k/2+1.5+a/2,g[r]-(k+3+a),g[A]-(k+3+a));(0>=d[zz][r]||0>=d[zz][A])&&
delete c.li;break;case JF:case BC:case QH:case dD:Pw(c,!0);d.x=g.S.x;d.y=g.S.y;if(a.yM===kg||a.yM===mh){var n=$m(a.kha||k.gb(),1,!1,a.lha);IMa(b,g,c,n,a.mha)}d.brush=new Rm({fill:l,ae:e,stroke:k.gb(),qa:1});Jw(d,CS(g,f)+1.5+d.brush.Hb/2)}}}
function IMa(a,b,c,d,e){c=c.I5||(c.I5={});c.x=b.S.x;c.y=b.S.y;c.brush=d;b=new sk(a.A[G],c.y);d=new sk(a.A[Zc],c.y);var f=new sk(c.x,a.A.top);a=new sk(c.x,a.A[Hc]);c.path=c[gz]||new YJ;if(e===kg||e===Eh)for(f=aK([f,a]),a=0;a<f.Yc[J]-1;a++)c[gz].qj(f.Yc[a]);if(e===kg||e===Jg)for(e=aK([b,d]),a=0;a<e.Yc[J]-1;a++)c[gz].qj(e.Yc[a]);c[gz][vy]()}
function AMa(a,b,c,d){var e=b.k[c];if((e[H]==JF||e[H]==BC||e[H]==QH)&&0<e[Ny]){var f=HU(d,c);f.li={};var f=f.li,g;g=e[H]==BC?b.Dd?ES(e):DS(e,!1):DS(e,b.Lj);g=lCa(g);f.brush=new Rm({stroke:e.$d.Qd,qa:h.min(1,e.$d.Hb/2)});f.path=mCa(g,-(e.$d.Hb/2+2+f.brush.Hb/2))}for(f=0;f<e.j[J];++f)g=e.j[f],!g||g.Ae||BS(g,e)&&JU(a,b,c,f,d);b.Uc&&e[H]===QH&&!a.RE(e.oa)&&AMa(a,b,c-1,d)}function BMa(a,b,c,d){for(var e=b.k,f=0;f<e[J];++f){var g=tS(b,f,c);a.bm[f]&&null!=g&&JU(a,b,f,g,d)}}
function JMa(a,b,c,d){c=FU(b.qv,c.nb,c.jb);var e=null!=b.Yl;c.vb=d;e&&a.te.gu(d,b.Yl,c.vb)}function KU(a,b,c,d){var e=wU(a.Fo,b,c,d,null);JMa(a,b,{nb:c,jb:d},e)}function zMa(a,b,c,d){c=vMa(a.Fo,b,c,d,a.q6);JMa(a,b,d,c)}function CMa(a,b,c,d){if(c&&a.Gna){var e=xMa(b.qv,d),f=null!=b.Yl;c=wU(a.Fo,b,null,d,null,c);null!==c&&(e.vb=c,f&&a.te.gu(c,b.Yl,e.vb))}}
function LU(a,b,c,d,e){var f=GU(b.qv,c,d);f.labels=f[vz]||{};f=f[vz];f[e]=f[e]||{};var f=f[e],g=null!=b.Yl;c=wU(a.Fo,b,c,d,e);f.ka=c;g&&c&&a.te.gu(c,b.Yl,f.ka)}function DMa(a,b,c,d){if(a.gi){var e=a.gi;a=jR(e[Fy],e.oG,[{value:a.k[b].j[c].Cf[E]}],a.Ac);d.gi={definition:a}}}function yMa(a,b,c,d){a=GU(d,a,b);a.labels=a[vz]||{};a=a[vz];a[c]=a[c]||{};c=a[c];c.X=c.X||{};ib(c.X,!0)}
function wMa(a,b,c,d){var e={Ob:b,Sj:[],qv:d,Yl:null},f=c.Qa.nb,g=c.Qa[ay];b.Ea&&mMa(a.Fo,new rl(0,b.Ea.area[G],b[A],0));var k=a.Fo.aT;if(null!=f&&null==g){for(var l=c[iy][jc].x,n=b.k[f].j,g=Fi(n,function(a){return null!=a}),q=0;q<g[J]&&g[q].S.x<l;)q++;0==q?g=0:q==g[J]?g=g[J]-1:(l=l<vj(g[q-1].S.x,g[q].S.x)?q-1:q,g=Ci(n,g[l]));a.vK=!1}n=null;if(null!=g)for(n=FU(d,f,g),Pw(n,!0),k==zg&&KU(a,e,f,g),b.Ea&&(n=IU(d,f),n.re={O:b.S2}),n=0;n<b.k[J];n++)n!=f&&(b.Ea&&(g=IU(d,n),g.ma={X:{color:nA}}),g=HU(d,n),
l=b.k[n],g.$d=l.$d.o(),Sm(g.$d,0.3));if(f=c[Uy].lK)f=GU(d,f.kc,f.$S),f.bundle=f.bundle||{},f.bundle.KS=!0;if(g=c[Uy].Qa)n=b.hq[g.Af],f=n.kc,g=b.eq[g.bb],n=n.Uy,(null!=f?a.bm[f]:a.iT)&&LU(a,e,f,g,n);if(b.Ea&&b.Ea[jc]==BF&&null!=c.Ea.Qa.ih){c=c.Ea.Qa.ih;n=IU(d,c);n.re={O:b.S2};for(var f=b.k[c].j,s,n=f[J]-1;0<=n;n--)if((g=f[n])&&!g.Ae&&g.S&&(new rl(b.A.top,b.A[Zc],b.A[Hc],b.A[G]))[Lc](new sk(g.S.x,g.S.y))){s=n;break}null!=s&&(n=FU(d,c,s),Pw(n,!0),k==zg&&KU(a,e,c,s));for(n=0;n<b.k[J];n++)n!=c&&(g=IU(d,
n),g.ma={X:{color:nA}},g=HU(d,n),l=b.k[n],g.$d=l.$d.o(),Sm(g.$d,0.3))}};function KMa(a,b){this.oA=a;this.wM=b;this.kj=Pj(a);this.kj.Be&&(this.kj.Be=Ej(this.kj.Be,Pj),this.Xga=Ej(a.Be,function(c,d){return LMa(a.Be[d],b.Be[d],this.kj.Be[d],!0,!1)},this));this.kj.be&&(this.kj.be=Ej(this.kj.be,Pj),this.Yga=Ej(a.be,function(c,d){return LMa(a.be[d],b.be[d],this.kj.be[d],!1,!0)},this));this.vn=this.bk=null;MMa(this);this.dM=this.jV=null;NMa(this)}
function LMa(a,b,c,d,e){if(!a||!b)return null;var f=Pj(a),g=Pj(a);if(a[H]==Dh&&b[H]==Dh&&a[yy]===b[yy]){a.Ed&&b.Ed&&(g.Ed=b.Ed,c.Ed=Pj(c.Ed));g.ke=Pj(g.ke);Ea(g,Pj(g[jc]));c.ke=Pj(c.ke);Ea(c,Pj(c[jc]));g[jc].Se=b[jc].Se;if(a.wb&&b.wb){g.wb=Yi(g.wb);c.wb=Yi(c.wb);for(var k=g.wb,l=c.wb,n=0;n<k[J];n++){k[n]=Pj(k[n]);l[n]=Pj(l[n]);var q=k[n],s=a.ke.Se(q.ra),s=b.ke.Bk(s);q.aa=b[jc].Se(s)}}if(a[cd]&&b[cd])for(Bw(g,Yi(g[cd])),Bw(c,Yi(c[cd])),k=g[cd],c=c[cd],OU(k),OU(c),n=0;n<k[J];n++)OMa(a,b,a[cd][n],k[n],
d,e)}else if(a[cd]&&b[cd]){var u=eP(a[cd],b[cd],function(a,b){return a.ra==b.ra});Bw(f,Fi(a[cd],function(a,b){return null!=u.lV[b]}));Bw(g,Fi(b[cd],function(a,b){return null!=u.mV[b]}));Bw(c,Yi(f[cd]));OU(f[cd]);OU(g[cd]);OU(c[cd])}return[f,g]}function OMa(a,b,c,d,e,f){var g=d.ma,k=a.ke.Se(d.ra),k=b.ke.Bk(k);a=a[jc].Se(d.ra);b=b[jc].Se(k);e&&(e=c.ma[Gz].x-a,g[Gz].x=b+e);f&&(e=c.ma[Gz].y-a,g[Gz].y=b+e)}
function OU(a){Y(a,function(b,c){a[c]=Pj(a[c]);b=a[c];b.ma=Pj(b.ma);var d=b.ma;if(d[Gz]){var e=d[Gz];Zw(d,new uP(e.x,e.y))}})}function MMa(a){var b=a.oA,c=a.wM;if(b.k&&c.k){var d=eP(b.k,c.k,function(a,b){return a.id==b.id});a.bk=Fi(b.k,function(a,b){return null!=d.lV[b]});a.vn=Fi(c.k,function(a,b){return null!=d.mV[b]});b.Wa==Bg||b.Wa==QH?(b=b[lz]==Jg?b.Be[0]:b.be[0],c=c[lz]==Jg?c.Be[0]:c.be[0],b[H]==Dh&&c[H]==Dh&&b[yy]===c[yy]?PMa(a,b.ke.Se,b.ke.Bk):QMa(a)):b.Wa==cD&&RMa(a)}}
function QMa(a){var b=a.oA.Ba,c=a.wM.Ba;if(b&&c){var d={},e={},f={},g={};Y(b,function(a,b){null!=a[Z]&&(f[a[Z]]=b)});Y(c,function(a,b){null!=a[Z]&&(g[a[Z]]=b)});Y(b,function(a,b){null!=a[Z]&&(d[b]=g[a[Z]])});Y(c,function(a,b){if(null!=a[Z]){var c=f[a[Z]];d[c]!==b&&(c=null);e[b]=c}});Y(b,function(a,b){null!=a[Z]&&e[g[a[Z]]]!==b&&(d[b]=null)});for(var k=0,l=0,n=[],q=[];k<b[J]||l<c[J];)k<b[J]&&null==d[k]?(q[C]({Nw:{Vh:k,iy:!0},Ow:{Vh:l,iy:!1}}),n[C]({data:b[k][Z]}),k++):(l<c[J]&&null==e[l]?(q[C]({Nw:{Vh:k,
iy:!1},Ow:{Vh:l,iy:!0}}),n[C]({data:c[l][Z]})):(q[C]({Nw:{Vh:k,iy:!0},Ow:{Vh:l,iy:!0}}),n[C]({data:b[k][Z]}),k++),l++);a.kj.Ba=n;var s=function(a,b){return 0==b?a[0]:b>=a[J]?Ai(a):PU(a[b-1],a[b],0.5)};a.oA.Uc?SMa(a,q,function(a,b,c,d){return b.iy?a[b.Vh*c+d]:s(a,b.Vh*c+d)}):QU(a,q,function(a,b){return b.iy?a[b.Vh]:s(a,b.Vh)})}}
function PMa(a,b,c){var d=a.oA.Ba,e=a.wM.Ba;if(d&&e)if(0==d[J]||0==e[J])a.kj.Ba=[],QU(a,[],function(){return null});else{var f=function(a){return b(a[Z])},g=[],k=[];if(d[J]===e[J])for(var l=0;l<d[J];l++)k[C]({Nw:l,Ow:l}),g[C]({data:c(vj(f(d[l]),f(e[l])))});else l=MEa(d,e,f),Y(l,function(a){var b=a.HC;a=a.IC;var l;null!=d[b]&&null!=e[a]&&(l=c(vj(f(d[b]),f(e[a]))));null!=l&&(k[C]({Nw:b,Ow:a}),g[C]({data:l}))});a.kj.Ba=g;a.oA.Uc?SMa(a,k,function(a,b,c,d){return a[b*c+d]}):QU(a,k,function(a,b){return a[b]})}}
function RMa(a){function b(a){a=Pj(a);a.S=Pj(a.S);a.S.brush=a.S.brush.o();a.S.brush.dh(0);Sm(a.S.brush,0);a.X=Pj(a.X);mb(a.X,0);return a}var c=a.bk[0].j,d=a.vn[0].j,e=[],f=[],g=[],k={};Y(d,function(a,b){null!=a&&(Qh(k[a.id])||(k[a.id]=[]),k[a.id][C](b))});Dj(c,function(a,b){if(null!=a){var c=a.id&&k[a.id],c=c&&c[rb]();Qh(c)?g[C]({Nw:b,Ow:c}):e[C](a)}});Dj(k,function(a){Y(a,function(a){f[C](d[a])})});QU(a,g,function(a,b){return a[b]});var c=Gi(e,b),l=Gi(f,b);a.bk[0].Kz=Xi(e,l);a.vn[0].Kz=Xi(c,f)}
function QU(a,b,c){for(var d=0;d<a.bk[J];d++){for(var e=a.bk[d].j,f=a.vn[d].j,g=[],k=[],l=0;l<b[J];l++){var n=b[l],q=c(e,n.Nw),n=c(f,n.Ow);q&&!q.Ae&&n&&!n.Ae&&(g[C](q),k[C](n))}a.bk[d]=RU(a.bk[d],g);a.vn[d]=RU(a.vn[d],k)}}
function SMa(a,b,c){for(var d=0;d<a.bk[J];d++){var e=a.bk[d].j,f=a.vn[d].j,g=[],k=[];if(0<b[J])for(var l=h[xb](e[J]/b[J]),n=h[xb](f[J]/b[J]),q=0;q<b[J];q++){for(var s=b[q],u=0;u<l;u++){var w=c(e,s.Nw,l,u);w&&!w.Ae&&g[C](w)}for(u=0;u<n;u++)(w=c(f,s.Ow,n,u))&&!w.Ae&&k[C](w)}a.bk[d]=RU(a.bk[d],g);a.vn[d]=RU(a.vn[d],k)}}function RU(a,b){var c=Pj(a);c.j=b;return c}
function NMa(a){var b=a.oA,c=a.wM;if(b.Ea&&b.Ea.Me&&c.Ea&&c.Ea.Me){var b=b.Ea.Me[0],c=c.Ea.Me[0],d=eP(b,c,function(a,b){return a.id==b.id});a.jV=Fi(b,function(a,b){return null!=d.lV[b]});a.dM=Fi(c,function(a,b){return null!=d.mV[b]});a.kj.Ea=Pj(a.kj.Ea);c=a.kj.Ea;c.ln=Yi(a.dM);c.Me=[c.ln];a=c.ln;for(c=0;c<a[J];++c){a[c]=Pj(a[c]);b=a[c];if(b.ma&&(b.ma=Pj(b.ma),b.ma.F)){b.ma.F=Yi(b.ma.F);for(var e=0;e<b.ma.F[J];e++)b.ma.F[e]=Pj(b.ma.F[e])}b.Wb&&(b.Wb=Pj(b.Wb),b.Wb[Ey]&&tw(b.Wb,b.Wb[Ey].o()));b.re&&
(b.re=Pj(b.re),b.re[Ey]&&tw(b.re,Pj(b.re[Ey])))}}}function SU(a,b,c){if(a!==b)if(a&&a[rc]==Rm&&b&&b[rc]==Rm)a=new Rm({fill:Mm(a.gb(),b.gb(),1-c),ae:SU(a.Oe,b.Oe,c),stroke:Mm(a.Qd,b.Qd,1-c),qa:SU(a.Hb,b.Hb,c),Cg:SU(a.Ai,b.Ai,c),cO:a.Hk,gh:a.Qg,pattern:a.fe});else if(Yh(a)&&Yh(b))if(a){if(b){for(var d=[],e=h.min(a[J],b[J]),f=0;f<e;f++)d[C](SU(a[f],b[f],c));a=d}}else a=b;else a=ai(a)||ai(b)?TMa(a,b,c):bi(a)||bi(b)?a:di(a)&&di(b)?a*(1-c)+b*c:null;return a}
function TMa(a,b,c){if(!a)return b;if(!b)return a;var d={};Dj(a,function(e,f){Qh(b[f])&&(d[f]=SU(a[f],b[f],c))});return d}function UMa(a,b,c,d,e){b=!e||(c?b>=c.top&&b<=c[Hc]:!1);return(!d||(c?a>=c[G]&&a<=c[Zc]:!1))&&b}
function VMa(a,b,c,d,e){a[jc]&&a[jc].Se&&b[jc]&&b[jc].Se&&(c[jc].Se=function(c){var d=a[jc].Se(c);c=b[jc].Se(c);return SU(d,c,e)});a.Ed&&b.Ed&&(c.Ed.aa=SU(a.Ed.aa,b.Ed.aa,e));a.wb&&b.wb&&Y(c.wb,function(c,g){c.aa=SU(a.wb[g].aa,b.wb[g].aa,e);c.O=d(c.aa,c.aa)});a[cd]&&b[cd]&&Y(c[cd],function(c,g){if(c){var k=a[cd][g].ma,l=b[cd][g].ma,n=c.ma;n&&n[Gz]&&(n[Gz].x=SU(k[Gz].x,l[Gz].x,e),n[Gz].y=SU(k[Gz].y,l[Gz].y,e));c.ma&&(k=0<c.ma.F[J],c.O=d((k?c.ma.F[0].x:0)+c.ma[Gz].x,(k?c.ma.F[0].y:0)+c.ma[Gz].y))}})}
function PU(a,b,c){if(!a||!b)return null;var d=Pj(a);if(Qh(a.S)||Qh(b.S))d.S=SU(a.S||{},b.S||{},c),d.Cf=SU(a.Cf||{},b.Cf||{},c);Qh(a.ir)&&Qh(b.ir)&&(d.ir=SU(a.ir,b.ir,c));Qh(a.jr)&&Qh(b.jr)&&(d.jr=SU(a.jr,b.jr,c));Qh(a.X)&&Qh(b.X)&&a.X!==b.X&&(d.X=Pj(a.X),Xa(d.X,Mm(a.X[E],b.X[E],1-c)),mb(d.X,SU(Qh(a.X[Kd])?a.X[Kd]:1,Qh(b.X[Kd])?b.X[Kd]:1,c)));null!=a.Jc&&null!=b.Jc&&a.Jc[vz][0][cd]===b.Jc[vz][0][cd]?d.Jc=SU(a.Jc,b.Jc,c):delete d.Jc;return d}
KMa[K].interpolate=function(a){var b=this.kj;if(b.Be){var c=function(a,c){return UMa(a,c,b.A,!0,!1)};Dj(b.Be,function(b,d){var e=this.Xga[d];e&&VMa(e[0],e[1],b,c,a)},this)}if(b.be){var d=function(a,c){return UMa(a,c,b.A,!1,!0)};Dj(b.be,function(b,c){var e=this.Yga[c];e&&VMa(e[0],e[1],b,d,a)},this)}if(this.bk&&this.vn){b.k=[];for(var e=0;e<this.bk[J];++e){var f=this.bk[e],g=this.vn[e],k=Pj(g);if(f&&g&&f[H]==g[H]){if(f.j&&g.j){k.j=[];for(var l=0;l<f.j[J];l++)k.j[l]=PU(f.j[l],g.j[l],a);if(f.Kz&&g.Kz)for(l=
0;l<f.Kz[J];l++)k.j[C](PU(f.Kz[l],g.Kz[l],a))}f.ef&&f.ef.ii&&g.ef&&g.ef.ii&&(k.ef=Pj(k.ef),k.ef.ii=SU(f.ef.ii,g.ef.ii,a))}b.k[e]=k}}if(this.jV&&this.dM&&b.Ea&&b.Ea.ln)for(e=0;e<b.Ea.ln[J];e++){f=b.Ea.ln[e];g=this.jV[e];k=this.dM[e];if(f.ma&&f.ma.F&&g.ma&&g.ma.F&&!Si(g.ma.F)&&k.ma&&k.ma.F)for(var n=f.ma.F,q=g.ma.F,s=k.ma.F,u=q[J],l=0;l<n[J];l++){var w=l<u?q[l]:q[u-1];n[l].x=SU(w.x,s[l].x,a);n[l].y=SU(w.y,s[l].y,a)}f.Wb&&f.Wb[Ey]&&g.Wb&&g.Wb[Ey]&&k.Wb&&k.Wb[Ey]&&(l=SU(g.Wb[Ey],k.Wb[Ey],a),tw(f.Wb,new vl(l[G],
l.top,l[r],l[A])));f.re&&f.re[Ey]&&g.re&&g.re[Ey]&&k.re&&k.re[Ey]&&tw(f.re,SU(g.re[Ey],k.re[Ey],a))}return b};function TU(a){this.hy=a}
TU[K].nv=function(a,b,c,d){var e=[],f=b.Qa,g=a.Qa;if(f.nb!=g.nb||f[ay]!=g[ay])null!=g.nb&&e[C](UU(TG,g.nb,g[ay],c,d)),null!=f.nb&&e[C](UU(UG,f.nb,f[ay],c,d));f.jb!=g.jb&&(null!=g.jb&&(g=g.jb,e[C]({type:TG,data:{row:g,column:null}})),null!=f.jb&&(g=f.jb,e[C]({type:UG,data:{row:g,column:null}})));f=b[Uy].Qa;g=a[Uy].Qa;!g||f&&f.bb==g.bb&&f.Af==g.Af||e[C]({type:TG,data:{row:g.bb,column:g.Af}});!f||g&&f.bb==g.bb&&f.Af==g.Af||e[C]({type:UG,data:{row:f.bb,column:f.Af}});f=b.Ea.Qa;g=a.Ea.Qa;f.ih!=g.ih&&(null!=
g.ih&&e[C](UU(TG,g.ih,null,c,d)),null!=f.ih&&e[C](UU(UG,f.ih,null,c,d)));b[ux][cz](a[ux])||e[C]({type:As});Y(e,W(function(a){this[$](a[H],a[Z])},this))};dp(TU[K],function(a,b){hu(this.hy,a,b||null)});function UU(a,b,c,d,e){b=e[b];d==cH?(c=b.Bs,d=null):d=b.Bs;return{type:a,data:{row:c,column:d}}};function VU(a,b){return nj(a.x,b[G],b[G]+b[r])===a.x&&nj(a.y,b.top,b.top+b[A])===a.y?!0:!1};function WMa(a,b){this.Mt=a;this.Lt=b};function XMa(a,b,c,d,e,f,g,k){this.Op=ia(a);this.Pp=ia(c);this.Mp=ia(b);this.Np=ia(d);this.CQ=ia(a);this.DQ=ia(c);this.pQ=ia(b)-ia(a);this.oQ=ia(d)-ia(c);Oa(this,1);this.Tna=e;this.k0=f;this.pba=g;this.EQ=k};function WU(a,b,c){this.kr=c;this.Ja=a;this.oj=b;this.Mf=this.ug=null}T=WU[K];sp(T,function(){return this.Ja});T.Gv=function(a){this.ug=a};T.ey=function(){};T.ay=function(){};T.by=function(){};T.XC=function(){};T.CC=function(){};T.DC=function(){};T.zC=function(){};T.yC=function(){};T.Le=function(){};
T.updateOptions=function(){var a={hAxis:{viewWindowMode:qE,viewWindow:{}},vAxis:{viewWindowMode:qE,viewWindow:{}}};this.Ja.hn=a;this.kr.Mt&&(ga(this.ug.Op)||(a.hAxis.viewWindow.numericMin=this.ug.Op),ga(this.ug.Mp)||(a.hAxis.viewWindow.numericMax=this.ug.Mp));this.kr.Lt&&(ga(this.ug.Pp)||(a.vAxis.viewWindow.numericMin=this.ug.Pp),ga(this.ug.Np)||(a.vAxis.viewWindow.numericMax=this.ug.Np))};function XU(a,b,c){WU[L](this,a,b,c);this.Ka=null}X(XU,WU);T=XU[K];T.ey=function(a){var b=this.oj().getChartAreaBoundingBox();VU(a,b)&&(this.Ka={x:a.x,y:a.y,md:0,Xd:0})};T.ay=function(a){if(this.Ka){var b=a.x;a=a.y;this.Ka={md:b-this.Ka.x,Xd:a-this.Ka.y,x:b,y:a};this.PC()}};T.by=function(){this.Ka=null};T.Le=function(a,b){var c=this.oj().getChartAreaBoundingBox();VU(a,c)&&b()};
T.PC=function(){var a=this.ug;if(a){var b=this.kr,c=this.oj();if(b.Mt){var d=this.Ka.x-this.Ka.md,e=c.getHAxisValue(this.Ka.x)-c.getHAxisValue(d),f=a.Op-e,g=a.Mp-e,d=h.max(f,a.CQ),k=h.min(g,a.CQ+a.pQ);if(a.EQ&&(d===f||0>e)&&(k===g||0<e)||!a.EQ)a.Op=f,a.Mp=g}b.Lt&&(d=this.Ka.y-this.Ka.Xd,c=c.getVAxisValue(this.Ka.y)-c.getVAxisValue(d),b=a.Pp-c,e=a.Np-c,d=h.max(b,a.DQ),k=h.min(e,a.DQ+a.oQ),a.EQ&&(d===b||0>c)&&(k===e||0<c)||!a.EQ)&&(a.Pp=b,a.Np=e);this[az]()}};function YU(a,b,c){WU[L](this,a,b,c);this.Ka=null}X(YU,WU);T=YU[K];T.ey=function(a){var b=this.oj().getChartAreaBoundingBox();VU(a,b)&&(this.Ka={Qt:a.x,Tl:a.y,z0:0,A0:0})};
T.ay=function(a){if(this.Ka){var b=this.oj().getChartAreaBoundingBox(),c=this.kr;this.u0(a,b);this.Ka.z0=a.x;this.Ka.A0=a.y;if(c.Mt){a=h.min(this.Ka.Qt,this.Ka.z0);var d=h.abs(this.Ka.Qt-this.Ka.z0)}else a=b[G],d=b[r];c.Lt?(c=h.min(this.Ka.Tl,this.Ka.A0),b=h.abs(this.Ka.Tl-this.Ka.A0)):(c=b.top,b=b[A]);this[hq]().Jh={left:a,top:c,width:d,height:b,color:SC,opacity:0.2}}};T.by=function(){this.Ka&&(this.PC(),this.Ka=null)};
T.PC=function(){var a=this.kr,b=this.ug,c=this.oj(),d=this[hq]().Jh,e=c.getHAxisValue(d[G]),f=c.getHAxisValue(d[G]+d[r]),g=c.getVAxisValue(d.top),c=c.getVAxisValue(d.top+d[A]);if(e!==f&&g!==c){d=b.pQ*b.k0;if(a.Mt){var k=h.min(e,f),e=h.max(e,f);e-k<d&&(e=(k+e)/2,k=e-d/2,e+=d/2);b.Op=k;b.Mp=e}f=b.oQ*b.k0;a.Lt&&(a=h.min(g,c),g=h.max(g,c),g-a<f&&(e=(a+g)/2,a=e-f/2,g=e+f/2),b.Pp=a,b.Np=g);this[az]()}};T.u0=function(a,b){a.x=nj(a.x,b[G],b[G]+b[r]);a.y=nj(a.y,b.top,b.top+b[A])};function ZU(a,b,c){WU[L](this,a,b,c);this.Ka=null}X(ZU,WU);T=ZU[K];T.XC=function(a){var b=this.oj().getChartAreaBoundingBox();VU(a,b)&&(this.Ka={x:a.x,y:a.y,scale:a.gesture[Fy],kba:1})};T.CC=function(a){if(this.Ka){var b=this.oj().getChartAreaBoundingBox();this.u0(a,b);this.Ka.kba=this.Ka[Fy];Oa(this.Ka,a.gesture[Fy]);this.PC()}};T.DC=function(){this.Ka&&(this.PC(),this.Ka=null)};
T.PC=function(){var a=this.ug,b=this.oj();if(a){var c=1-(this.Ka.kba-this.Ka[Fy]),d=b.getHAxisValue(this.Ka.x),e=a.Mp-d;a.Op=d-(d-a.Op)/c;a.Mp=d+e/c;b=b.getVAxisValue(this.Ka.y);d=a.Np-b;a.Pp=b-(b-a.Pp)/c;a.Np=b+d/c;this[az]()}};T.u0=function(a,b){a.x=nj(a.x,b[G],b[G]+b[r]);a.y=nj(a.y,b.top,b.top+b[A])};function $U(a,b,c){WU[L](this,a,b,c)}X($U,WU);$U[K].yC=function(){var a=this.ug;Oa(a,1);a.Op=a.CQ;a.Mp=a.CQ+a.pQ;a.Pp=a.DQ;a.Np=a.DQ+a.oQ;this[az]()};function aV(a,b,c){WU[L](this,a,b,c)}X(aV,WU);aV[K].zC=function(a,b){var c=this.kr,d=this.oj().getChartAreaBoundingBox();if(VU(a,d)){b();d=this.ug;if(0>a.wheelDelta){if(d[Fy]>=d.Tna)return;Oa(d,d[Fy]*d.pba)}else{if(d[Fy]<=d.k0)return;Oa(d,d[Fy]/d.pba)}if(c.Mt){var e=(d.Mp+d.Op)/2,f=d.pQ*d[Fy]/2;d.Op=e-f;d.Mp=e+f}c.Lt&&(c=(d.Np+d.Pp)/2,e=d.oQ*d[Fy]/2,d.Pp=c-e,d.Np=c+e);this[az]()}};var YMa=[{isEnabled:function(a){a=a.R(sE);return null==a||Yh(a)&&Ri(a,wta)?!0:!1},constructor:XU},{isEnabled:function(a){a=a.R(sE);return Yh(a)&&Ri(a,xta)?!0:!1},constructor:YU},{isEnabled:function(a){a=a.R(sE);return null==a||Yh(a)&&Ri(a,Yya)?!0:!1},constructor:$U},{isEnabled:function(a){a=a.R(sE);return Yh(a)&&Ri(a,Xxa),!1},constructor:ZU},{isEnabled:function(a){a=a.R(sE);return null==a||Yh(a)&&Ri(a,cza)?!0:!1},constructor:aV}];function ZMa(a,b,c,d){if(c.R(Ah)===cH)throw m("Cannot use explorer with a pie chart");this.b=c;this.Ja=a;this.kr=null;this.oj=b;this.Q=d;this.Mf=this.ug=null;this.Tn=[];$Ma(this,d)}T=ZMa[K];
T.Gv=function(){var a=this.oj(),b=a.getChartAreaBoundingBox(),c=a.getHAxisValue(b[G]),d=a.getHAxisValue(b[G]+b[r]),e=a.getVAxisValue(b.top+b[A]),a=a.getVAxisValue(b.top),b=sn(this.b,Zta,4),f=sn(this.b,Yta,0.25),g=sn(this.b,$ta,1.5),k=pn(this.b,Xta,!1);this.ug=new XMa(c,d,e,a,b,f,g,k);Y(this.Tn,function(a){a.Gv(this.ug)},this)};
function $Ma(a,b){var c=b.Be[0],d=b.be[0],c=!b.Be[1]&&c[H]===Dh&&!c.xo,d=!b.be[1]&&d[H]===Dh&&!d.xo,e=a.b.R(rE)[Oz];e===Jg?d=!1:e===Eh&&(c=!1);a.kr=new WMa(c,d);Y(YMa,function(a){a[Ay](this.b)&&this.Tn[C](new a[rc](this.Ja,this.oj,this.kr))},a)}T.ey=function(a){Y(this.Tn,function(b){b.ey(a)},this)};T.ay=function(a){Y(this.Tn,function(b){b.ay(a)},this)};T.by=function(a){Y(this.Tn,function(b){b.by(a)},this)};T.yC=function(a){Y(this.Tn,function(b){b.yC(a)},this)};
T.zC=function(a,b){Y(this.Tn,function(c){c.zC(a,b)},this)};T.Le=function(a,b){Y(this.Tn,function(c){c.Le(a,b)},this)};T.XC=function(a,b){Y(this.Tn,function(c){c.XC(a,b)},this)};T.CC=function(a,b){Y(this.Tn,function(c){c.CC(a,b)},this)};T.DC=function(a,b){Y(this.Tn,function(c){c.DC(a,b)},this)};var aNa=[{isEnabled:function(a){return a.R(rE)?!0:!1},constructor:ZMa}];function bNa(a,b,c,d){this.b=a;this.n=b;this.oj=c;this.Q=d;this.Un=[];this.Xa=null;cNa(this)}function cNa(a){a.b&&Y(aNa,function(a){a[Ay]&&a[Ay](this.b)&&this.Un[C](new a[rc](this.n,this.oj,this.b,this.Q))},a)}T=bNa[K];T.by=function(a){Y(this.Un,function(b){b.by(a)});WN(this.Xa,15)};T.ay=function(a){Y(this.Un,function(b){b.ay(a)});WN(this.Xa,5)};T.ey=function(a){Y(this.Un,function(b){b.ey(a)});WN(this.Xa,5)};T.zC=function(a,b){Y(this.Un,function(c){c.zC(a,b)});WN(this.Xa,5)};
T.yC=function(a){Y(this.Un,function(b){b.yC(a)});WN(this.Xa,5)};T.Le=function(a,b){Y(this.Un,function(c){c.Le(a,b)})};T.XC=function(a,b){Y(this.Un,function(c){c.XC(a,b)})};T.CC=function(a,b){Y(this.Un,function(c){c.CC(a,b)});WN(this.Xa,5)};T.DC=function(a,b){Y(this.Un,function(c){c.DC(a,b)});WN(this.Xa,15)};T.Gv=function(){Y(this.Un,function(a){a.Gv()})};function bV(a,b,c,d,e,f){this.Q=a;this.Ja=b;this.Ql=c;this.yf=d;this.Xa=new VN(e);Vs(this,this.Xa);this.co=f;this.co.Xa=this.Xa;this.XV()}X(bV,Us);T=bV[K];T.w=function(){qt(this.Ql);bV.e.w[L](this)};T.qoa=function(a){Ea(this.Ja[iy],a[Z].ub);WN(this.Xa,5)};T.roa=function(){};T.toa=function(a){Ea(this.Ja[iy],a[Z].ub);this.yf[$](SG,{targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y})};T.uoa=function(a){this.yf[$](xxa,{targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y})};
T.soa=function(a){var b={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y};this.yf[$](wxa,b);this.co.Le(b,a[Z][Hp])};T.loa=function(a){this.yf[$](Fr,{targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y})};T.yoa=function(a){a={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y};this.yf[$](HH,a);this.co.yC(a)};T.moa=function(a){this.yf[$](YD,{targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y})};T.zoa=function(a){var b={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y,wheelDelta:a[Z].wheelDelta};this.yf[$](SH,b);this.co.zC(b,a[Z][Hp])};
T.ooa=function(a){a={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y};this.yf[$](zta,a);this.co.ey(a)};T.poa=function(a){a={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y};this.yf[$](iE,a);this.co.ay(a)};T.noa=function(a){a={targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y};this.yf[$](yta,a);this.co.by(a)};T.woa=function(a){this.co.XC({targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y,gesture:a[Z].Fba},a[Z][Hp])};T.xoa=function(a){this.co.CC({targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y,gesture:a[Z].Fba},a[Z][Hp])};
T.voa=function(a){this.co.DC({targetID:a[Z].ne,x:a[Z].ub.x,y:a[Z].ub.y,gesture:a[Z].Fba},a[Z][Hp])};T.joa=function(a){this.Ja.Qa.jb=a[Z].Ji;WN(this.Xa,50)};T.koa=function(){Ea(this.Ja[iy],null);this.Ja.Qa.jb=null;WN(this.Xa,50)};T.ioa=function(a){var b=this.Q;this.Ja[iy].t4=this.Ja[iy][jc].o();MN(this.Ja[ux],b.Ba[a[Z].Ji].Bs,b.Gy==oh);WN(this.Xa,0)};T.Aba=function(a){this.Q.Wa!=cD&&(this.Ja.Ea.Qa.ih=a[Z].mP,WN(this.Xa,50))};T.Bba=function(){this.Q.Wa!=cD&&(this.Ja.Ea.Qa.ih=null,WN(this.Xa,250))};
T.Doa=function(a){this.Q.Wa!=cD&&(dNa(this,a[Z].mP),WN(this.Xa,0))};T.Eoa=function(a){null==this.Ja.Ea.vB&&(this.Ja.Ea.vB=0);this.Ja.Ea.vB+=a[Z].jma;WN(this.Xa,0)};T.d9=function(a){if(this.Q.Wa!=cD){var b=this.Q.By;if(this.Q.Fh==WH||b==gE)this.Ja.Qa.nb=a[Z].kc,WN(this.Xa,50)}};T.K$=function(){if(this.Q.Wa!=cD){var a=this.Q.By;if(this.Q.Fh==WH||a==gE)this.Ja.Qa.nb=null,WN(this.Xa,250)}};T.Q6=function(a){this.Q.Wa!=cD&&this.Q.Fh==WH&&(dNa(this,a[Z].kc),WN(this.Xa,0))};T.Goa=function(a){this.Aba(a)};
T.Hoa=function(){this.Bba()};T.Foa=function(a){this.yf[$](vya,{index:a[Z].mP})};T.Boa=function(a){this.Q.Fh==WH?this.d9(a):(this.Ja.Qa.nb=a[Z].kc,this.Ja.Qa.datum=a[Z].Ji,WN(this.Xa,50))};T.Coa=function(){this.Q.Fh==WH?this.K$():(cV(this),WN(this.Xa,250))};T.Aoa=function(a){var b=this.Q;if(b.Fh==WH)this.Q6(a);else{var c=b.Gy==oh;a={jb:a[Z].Ji,nb:a[Z].kc};b.Wa==cD?MN(this.Ja[ux],a.jb,c):b.k[a.nb].Eg||(b=b.$V(a),this.Q.Fh==WH?NN(this.Ja[ux],b.Af,c):ON(this.Ja[ux],b.bb,b.Af,c));WN(this.Xa,0)}};
T.x8=function(a){var b=a[Z].fx;-1!=b&&(this.Ja[Uy].Qa={bb:a[Z].Ji,Af:eNa(this,a[Z].kc,b)},cV(this),WN(this.Xa,50))};T.V8=function(a){-1!=a[Z].fx&&(this.Ja[Uy].Qa=null,WN(this.Xa,250))};T.hoa=function(a){var b=this.Q.Gy==oh,c=a[Z].Ji,d=a[Z].kc;a=a[Z].fx;-1==a?this.Ja[Uy].lK={kc:d,$S:c}:ON(this.Ja[ux],c,eNa(this,d,a),b);WN(this.Xa,0)};
T.Ioa=function(a){if(null===a[Z].fx){switch(this.Q.Fh){case WD:this.Ja.Qa.datum=a[Z].Ji;this.Ja.Qa.nb=a[Z].kc;break;case WH:this.Ja.Qa.nb=a[Z].kc;break;case lD:this.Ja.Qa.jb=a[Z].Ji}WN(this.Xa,50)}else this.x8(a)};T.Joa=function(a){if(null===a[Z].fx){switch(this.Q.Fh){case WD:cV(this);break;case WH:this.Ja.Qa.nb=null;break;case lD:Ea(this.Ja[iy],null),this.Ja.Qa.jb=null}WN(this.Xa,750)}else this.V8(a)};T.foa=function(a){this.Ja.wh.Qa.$v=a[Z].$v;WN(this.Xa,50)};
T.goa=function(){this.Ja.wh.Qa.$v=null;WN(this.Xa,250)};T.eoa=function(){this.Ja.wh.Qa[Hy]&&this.Ja.wh.Qa[Hy]();WN(this.Xa,250)};T.Gv=function(){this.co.Gv()};function cV(a){a.Ja.Qa.nb=null;a.Ja.Qa.datum=null}function eNa(a,b,c){a=a.Q;var d=null;if(null!=b)d=a.k[b].oa.annotation;else for(b=0;b<a.Tj[J];++b)d=a.Tj[b].oa.annotation;return d[c]}
T.XV=function(){var a=W(function(a,c){kt(this.Ql,a,W(c,this))},this);a(Kra,this.qoa);a(Lra,this.roa);a(Nra,this.toa);a(Ora,this.uoa);a(Mra,this.soa);a(Fra,this.loa);a(Tra,this.yoa);a(Gra,this.moa);a(Ura,this.zoa);a(Jra,this.ooa);a(Hra,this.poa);a(Ira,this.noa);a(Sra,this.woa);a(Qra,this.xoa);a(Rra,this.voa);a(Ara,this.joa);a(Bra,this.koa);a(zra,this.ioa);a(Cwa,this.Aba);a(Dwa,this.Bba);a(Bwa,this.Doa);a(Gwa,this.Eoa);a(hza,this.d9);a(iza,this.K$);a(gza,this.Q6);a(sya,this.Goa);a(tya,this.Hoa);a(rya,
this.Foa);a(Xsa,this.Boa);a(Ysa,this.Coa);a(Wsa,this.Aoa);a(Gqa,this.x8);a(Hqa,this.V8);a(Fqa,this.hoa);a(IAa,this.Ioa);a(JAa,this.Joa);a(pqa,this.foa);a(qqa,this.goa);a(oqa,this.eoa)};function dNa(a,b){var c=a.Q,d=c.Gy==oh,e=c.k[b].Bs;c.Wa==cH?MN(a.Ja[ux],e,d):NN(a.Ja[ux],e,d)};function dV(a,b){uS[L](this,a,b);this.OL=this.wf=null}X(dV,uS);dV[K].I6=function(a,b){var c=this.G;if(1>a.k[J])return!1;this.wf=b;for(var d=a.pie.Ih,e=a.k[J]/d[J],f=0;f<d[J];++f){for(var g=d[f].Qc,k=d[f].Rc,l=d[f].hL,n=f*e,q=n+e;n<q&&180>a.k[n].$c;)eV(this,a.k[n],g,k),n+=1;l&&eV(this,l,g,k);for(l=q-1;l>=n;--l)eV(this,a.k[l],g,k)}a.wo&&(this.OL=c.za(),fNa(this,a.wo),c[p](this.wf,this.OL));return!0};
function eV(a,b,c,d){if(b.O){var e=a.G.za(),f=a.Ob,g=f.pie[nx],k=b[by];if(b.Pb){var l=f.pie.Cy,n=b.Pb,q=new YJ;q[Yy](k.x+n.Ue.x,k.y+n.Ue.y);q.Z(k.x+n.Ue.x,k.y+n.Ue.y+l);q.Wf(k.x+g.x,k.y+g.y+l,c,d,n.Fd,n.$c,!0);q.Z(k.x+n.jh.x,k.y+n.jh.y);q.Wf(k.x+g.x,k.y+g.y,c,d,n.$c,n.Fd,!1);a.G.na(q,n.brush,e)}if(b.Fs||b.jv)l=f.pie.Cy,f=new YJ,f[Yy](k.x+g.x,k.y+g.y),f.Z(k.x+g.x,k.y+g.y+l),b.jv&&(f.Z(k.x+b.jh.x,k.y+b.jh.y+l),f.Z(k.x+b.jh.x,k.y+b.jh.y)),b.Fs&&(f.Z(k.x+b.Ue.x,k.y+b.Ue.y+l),f.Z(k.x+b.Ue.x,k.y+b.Ue.y)),
a.G.na(f,b.jK,e);f=b.cv?b.cv.brush:b.brush;b.mq?0==b.ED&&0==b.Ry?a.G.Nj(g.x,g.y,c,d,f,e):(n=new YJ,n[Yy](g.x,g.y-d),n.Wf(g.x,g.y,c,d,0,180,!0),n.Wf(g.x,g.y,c,d,180,360,!0),n[Yy](g.x,g.y-b.Ry),n.Wf(g.x,g.y,b.ED,b.Ry,360,180,!1),n.Wf(g.x,g.y,b.ED,b.Ry,180,0,!1),n[vy](),a.G.na(n,f,e)):(n=new YJ,n[Yy](k.x+b.My.x,k.y+b.My.y),n.Z(k.x+b.Ue.x,k.y+b.Ue.y),n.Wf(k.x+g.x,k.y+g.y,c,d,b.Fd,b.$c,!0),n.Z(k.x+b.Es.x,k.y+b.Es.y),n.Wf(k.x+g.x,k.y+g.y,b.ED,b.Ry,b.$c,b.Fd,!1),a.G.na(n,f,e));b.li&&gNa(a,b.li,e);if(c=b.an){c.Pb&&
(d=new YJ,d[Yy](c.Pb.Ue.x,c.Pb.Ue.y),d.Z(c.Pb.Ue.x,c.Pb.Ue.y+l),d.Wf(c.Pb.qh.x,c.Pb.qh.y+l,c.Pb.Qc,c.Pb.Rc,c.Pb.Fd,c.Pb.$c,!0),d.Z(c.Pb.jh.x,c.Pb.jh.y),d.Wf(c.Pb.qh.x,c.Pb.qh.y,c.Pb.Qc,c.Pb.Rc,c.Pb.$c,c.Pb.Fd,!1),a.G.na(d,c.Pb.brush,e));if(c.Fs||c.jv)d=new YJ,d[Yy](c.dz.x,c.dz.y),d.Z(c.nK.x,c.nK.y),d.Z(c.nK.x,c.nK.y+l),d.Z(c.dz.x,c.dz.y+l),d.Z(c.dz.x,c.dz.y),a.G.na(d,c.jK,e);gNa(a,c,e)}b.cT&&a.G.Pd(b[cd],b.dT.x+k.x,b.dT.y+k.y,b.pK[r],nI,nI,b.X,e);k=AN([gI,b[nc]]);e=e.a();a.qe(a.wf,k,e);b.vb&&(e=AN([Hs,
b[nc]]),a.kE(b.vb,e))}}function gNa(a,b,c){if(b.mq)a.G.Nj(b.qh.x,b.qh.y,b.Qc,b.Rc,b.brush,c);else{var d=new YJ;d[Yy](b.Ue.x,b.Ue.y);d.Wf(b.qh.x,b.qh.y,b.Qc,b.Rc,b.Fd,b.$c,!0);a.G.na(d,b.brush,c)}}
function fNa(a,b){for(var c=W(a.Is,a),d=W(a[Bx],a),e=a.G,f=a.OL,g=0;g<b[J];++g){var k=b[g],l=e.za(),n=e.za(),q=new YJ;q[Yy](k.Ei.x+0.5,k.Ei.y+0.5);q.Z(k.b4+0.5,k.Ei.y+0.5);q.Z(k.b4+0.5,k.Iq.y+0.5);q.Z(k.Iq.x+0.5,k.Iq.y+0.5);e.na(q,k.$d,n);e.Zd(k.Ei.x+0.5,k.Ei.y+0.5,k.a4,k.lfa,n);c(k.$y,l);c(k.az,l);e[p](f,l);e[p](f,n);k=AN([FF,k[nc]]);d(l.a(),k)}}
dV[K].d3=function(a,b){if(!gn(b.wo,this.gq.wo)){this.G.cd(this.OL);var c=new sO(2);tO(c,0,a.wo||{});tO(c,1,b.wo||{});c=c[My]();fNa(this,c)}this.oK(a);this.j0(a,b)};dV[K].oK=function(a){var b=this.gq;if(b)for(var c in b.k){if(b.k[c].vb){var d=AN([Hs,ia(c)]);wS(this,d)}d=a.pie.Ih[c<a.k[J]/a.pie.Ih[J]?0:1];eV(this,a.k[c],d.Qc,d.Rc)}};dV[K].j0=function(a,b){for(var c in b.k){var d=new sO(2);tO(d,0,a.k[c]);tO(d,1,b.k[c]);var e=a.pie.Ih[c<a.k[J]/a.pie.Ih[J]?0:1],f=e.Qc,e=e.Rc;eV(this,d[My](),f,e)}};function hNa(a,b,c,d,e){var f=a[Zc]-a[G],g=Pj(d),k=Pj(d);Xa(k,qna);d=d[uc]/3.236;var l=g[uc]+d,n=k[uc]+d,q=iNa(a,f,b,g,k,d,e),s=[],u;2==c?(c=a[Zc],a=a[G],u=oE):(c=a[G],a=a[Zc],u=nI);for(var w=0;w<e[J];++w){var z=e[w],B=q[w];if(null!=B){var F=UN(b,z.$y,g,f,B.lH),M=UN(b,z.az,k,f,B.mH),N=SKa(new kK(c,B.y));s[C]({a4:2,Ei:SKa(z.N4(nj(B.y,z.HL[y],z.HL.end))),b4:a,Iq:N,lfa:new Rm({fill:$A,ae:0.7}),$d:new Rm({stroke:$A,qa:1,Cg:0.7}),Cta:d,$y:{text:z.$y,X:g,anchor:new uP(N.x,N.y),F:Gi(F.F,function(a,b){return{x:0,
y:(b-F.F[J])*l,length:F.Kg,text:a}}),Cc:u,Bc:nI,vb:F.ge?z.$y:O,Cb:0},zta:g,az:{text:z.az,X:k,anchor:new uP(N.x,N.y),F:Gi(M.F,function(a,b){return{x:0,y:(b+1)*n,length:M.Kg,text:a}}),Cc:u,Bc:oE,vb:M.ge?z.az:O,Cb:0},Bta:k,Ata:u,index:z[nc]})}}return s}
function iNa(a,b,c,d,e,f,g){var k=d[uc]+f,l=e[uc]+f,n=Gi(g,function(a,g){var k=UN(c,a.$y,d,b,ea),l=UN(c,a.az,e,b,ea);return{bJ:g,Y_:a.V6,Zx:a.V6,lH:k.F[J],mH:l.F[J],WQ:f,XQ:f}});cj(n,function(a,b){return a.Zx-b.Zx});n=Yi(n);cj(n,function(a,b){return g[a.bJ].U6-g[b.bJ].U6});var q=[];0<n[J]&&q[C](n.pop());for(var s=null,u=0,w;w=fV(a,k,l,g,q,!1),!(0===n[J]||w.cJ&&15<u);)w.cJ?(u++,s&&Wi(q,s)):u=0,s=n.pop(),q[C](s),cj(q,function(a,b){return a.Zx-b.Zx});w.cJ&&s&&(Wi(q,s),w=fV(a,k,l,g,q,!1));a=fV(a,k,l,
g,q,!0);a.cJ||(w=a);return w[tx]}function fV(a,b,c,d,e,f){0<e[J]&&(e[0].WQ=0,Ai(e).XQ=0);for(var g=0;g<e[J];g++){var k=e[g],l=e[g-1],n=e[g+1],n=n?d[n.bJ].HL.end-5:a[Hc];k.Bca=new zm(h.min(k.Y_,l?d[l.bJ].HL[y]+5:a.top),h.max(k.Y_,n))}a=jNa(a,b,c,e,f);d=!1;f={};for(g=0;g<e[J];g++){var k=e[g],l=a[g],n=(l[Gz]-l.top-k.WQ)/b,q=(l[Hc]-l[Gz]-k.XQ)/c,n=h[t](n+0.1),q=h[t](q+0.1),s=n<k.lH||q<k.mH;d=d||s;f[k.bJ]={y:l[Gz],lH:n,mH:q,cJ:s}}return{layout:f,cJ:d}}
function jNa(a,b,c,d,e){var f=Ej(d,function(a){return{anchor:a.Zx,top:a.Zx-(a.lH*b+a.WQ),bottom:a.Zx+(a.mH*c+a.XQ)}}),g=[];g[C](function(b,c){var d=b[c].top;return 0==c?{top:h.max(a.top-d,0)}:{top:h.max(b[yi(c)-1][Hc]-d,0)/2}});g[C](function(b,c){var e=b[c][Hc];return c==d[J]-1?{bottom:h.min(a[Hc]-e,0)}:{bottom:h.min(b[yi(c)+1].top-e,0)/2}});g[C](function(a,c,f){var g=a[c][Gz]-a[c].top;a=h.max(-g,0);c=d[c];c=h.max(c.lH*b+c.WQ-h.max(g,0),0);f=(a+c*(e?1:f))/2;return{anchor:f,top:-f}});g[C](function(a,
b,f){var g=a[b][Hc]-a[b][Gz];a=h.max(-g,0);b=d[b];b=h.max(b.mH*c+b.XQ-h.max(g,0),0);f=(a+b*(e?1:f))/2;return{anchor:-f,bottom:f}});g[C](function(a,b){var c=a[b][Gz],e=d[b];return{anchor:nj(c,e.Bca[y],e.Bca.end)-c}});e&&g[C](function(a,b,c){return{anchor:(d[b].Y_-a[b][Gz])*c}});var k=NEa(f,g,function(a,b){return{anchor:a[Gz]+(b[Gz]||0),top:a.top+(b.top||0),bottom:a[Hc]+(b[Hc]||0)}},function(a,b){return h.max(h.abs(a[Gz]-b[Gz]),h.abs(a.top-b.top),h.abs(a[Hc]-b[Hc]))});return Gi(d,function(a,b){var c=
k[String(b)];return{anchor:c[Gz],top:c.top,bottom:c[Hc]}})}function kNa(a,b){var c=Pi(a,function(a){return a[nc]==b});if(0>c)return{};var d={};d[c]={a4:4,$d:new Rm({stroke:$A,qa:2,Cg:0.7})};return d};function gV(a,b,c,d,e){this.sb=b.R(ND,tP);this.B5=sn(b,Wxa,0);this.Fga=0>sn(b,qg,1);WS[L](this,a,b,c,d,e)}X(gV,WS);Ma(gV[K],function(){this.L.Fh=WH;this.L.Uc=pn(this[eq],Pva);this.L.Fc&=!this.L.Uc;this.L.Uc&&(this.L.eh=this.L.eh||{},this.L.eh.pie=this.L.eh.pie||{},this.L.eh.pie.h3=this[eq].R(jta,!0),this.L.eh.pie.hT=this[eq].R(fta,0.6));for(var a=0;a<this.Nb.M();a++)if(0>this.Nb[I](a,1))throw m("Negative values are invalid for a pie chart.");gV.e[Fc][L](this)});gV[K].u6=function(){return zs};
gV[K].t6=function(){return null};
gV[K].s6=function(){var a=this.L;if(this.Nb.D(0)!=rh)throw m("Pie chart should have a first column of type string");var b;b=this.L;var c=b.A,d=this.kf[zy](),e=null,f=null,g=h[D](1.618*b.Nl),e=h[D](c[r]*(1-1/1.618)-g);d==Qg?(f=new rl(c.top,c[G]+e,c[Hc],c[G]),e=new rl(c.top,c[Zc],c[Hc],f[Zc]+g)):d==zs?(f=new rl(c.top,c[Zc],c[Hc],c[Zc]-e),e=new rl(c.top,f[G]-g,c[Hc],c[G])):d==YC?(e=new rl(c.top,c[Zc],c.top+1/1.618*(c[Hc]-c.top-g),c[G]),f=new rl(e[Hc]+g,c[Zc],c[Hc],c[G])):e=new rl(c.top,c[Zc],c[Hc],c[G]);
var c=0,d=h.min(e[Zc]-e[G],e[Hc]-e.top),k=g=h[t](d/2),d=h[D]((e[Zc]+e[G])/2),e=h[D]((e[Hc]+e.top)/2);b.Fc&&(k*=0.8,c=g/5,e-=c/2);if(b.Uc){var l={Qc:g*b.eh.pie.hT,Rc:k*b.eh.pie.hT},g={Qc:g,Rc:k};b={pie:{center:new kK(d,e),Qc:g.Qc,Rc:g.Rc,Cy:c,Ih:b.eh.pie.h3?[l,g]:[g,l]},Ea:f}}else b={pie:{center:new kK(d,e),Qc:g,Rc:k,Cy:c,Ih:[{Qc:g,Rc:k}]},Ea:f};lNa(this,b);f=this.kf[zy]();b.Ea?this.kf.Go(b.Ea):f==WC?this.kf.Go(mNa(this)):f==BF&&nNa(this,a.A,b,this.kf.ta)};
function oNa(a,b,c){var d=a.L,e={},f=Cn(a[eq],eH,O);a=b[E];var g=b.tb;b=b.Mi;var k;d.Fc?(d=a,k=g,f=b):k=d=f;e.normal=new Rm({stroke:d,qa:1,fill:a,ae:null!=c?c:1});e.tb=new Rm({stroke:k,qa:1,fill:g,ae:null!=c?c:1});e.Mi=new Rm({stroke:f,qa:1,fill:b,ae:null!=c?c:1});return e}function mNa(a){var b=a.L,c=b[A]-b.A[Hc];a=a.kf.ta[uc];var d=[];d[C]({min:2,Tc:[ea]});var e=d[J];d[C]({min:a+2,Tc:[ea]});c=aP(d,c);return c[J]>e?(c=b.A[Hc]+c[e],new rl(c-a,b.A[Zc],c,b.A[G])):null}
function lNa(a,b){var c=a.L,d=a.Nb,e=b.pie[nx],f=b.pie.Cy,g=d.M(),k=NS(Cn(a[eq],Txa,O)),l=oNa(a,k,1),n=Ln(a[eq],Vxa,{Va:c.Kj,fontSize:c.Nl}),q=Gn(a[eq],fH,lFa,c.Uc?R:bH),s=Gn(a[eq],FAa,mFa,kg),u=xn(a[eq],Vza,1/720),w=pn(a[eq],tta),z=zn(a[eq],Uxa,Woa),B=xn(a[eq],dH,0);a[eq][Yva]=2;c.k=[];c.dn=[];var F,M,N;c.Uc?(F=a[eq].R(eta,0.01),F=c.eh.pie.hT*(1+F),F=c.eh.pie.h3?[0,F]:[F,0],M=[!1,!0],N=[a[eq].R(cE,0.5),a[eq].R(bE,1)]):(F=[0],M=[!0],N=[1]);c.pie={center:e,Cy:f,Qc:b.pie.Qc,Rc:b.pie.Rc,Ih:[]};for(var f=
W(function(a,b){var d=c.k[a];if(1==b)hV(d,s,d);else{var e=c.k[a-g];hV(d,s,d,e);hV(e,s,d,e)}},a),P=W(function(a){var b=c.pie.Ih[a-1].hL,d=c.pie.Ih[0].hL;1==a&&b?hV(b,s,b):1<a&&(b&&d?(hV(b,s,b,d),hV(d,s,b,d)):b?(d={oz:Oe,Pe:Oe},hV(b,s,b,d)):d&&(b={oz:Oe,Pe:Oe},hV(d,s,b,d)))},a),ba=W(function(a,b,d,e,f){c.Uc?c.dn[C]({id:a,text:b,brush:new Rm({gh:{lg:d,Tf:d,Wy:N[0],Xy:N[1],x1:QA,y1:PA,hb:PA,kb:PA,sv:!0,uK:!0}}),index:e,O:f}):c.dn[C]({id:a,text:b,brush:new Rm({fill:d}),index:e,O:f})},a),U=c.pie.Ih,qa=
b.pie.Ih,ya=qa[J],Ha=0,Aa=0;Aa<ya;++Aa){for(var Wc=qa[Aa],cb=null,kc=Wc.Qc,Wc=Wc.Rc,kd=F[Aa],Mb=M[Aa],Oc=0,Vd=0,Tf=0,Uf=0;Uf<g;Uf++)Tf+=d[I](Uf,Aa+1)||0;for(Uf=0;Uf<g;++Uf){var Ce=d[I](Uf,Aa+1)||0,gq=d.Aa(Uf,Aa+1),Gf=d[I](Uf,0),Di=d.Aa(Uf,0),hj=Vd/Tf,Hf=hj+Ce/Tf,sg=Hf-hj>=u;sg?Vd+=Ce:Oc+=Ce;var $r=Wza+Ha,Ro=a[eq].R($r+Mma,a.sb[Uf%a.sb[J]]),Ro=NS(Ro),hx=oNa(a,Ro,N[Aa]),XA=sn(a[eq],$r+Sma,0),jq=xn(a[eq],$r+Pma,B)+kd,tg=Ln(a[eq],$r+Uma,n),Ce=pNa(a,Ha,Uf,hj,Hf,Ce,gq,Di,sg,e,kc,Wc,jq,XA,q,tg,Ro,hx);c.k[C](Ce);
sg=pn(a[eq],$r+Wma,Mb&&(sg||w));ba(Gf,Di,Ro[E],Ha,sg);Aa==ya-1&&f(Ha,ya);Ha+=1}0<Oc&&(hj=1-Oc/Tf,Hf=1,Ce=Oc,gq=String(Oc),Di=z,cb=pNa(a,-1,-1,hj,Hf,Ce,gq,Di,!0,e,kc,Wc,B+kd,0,q,n,k,l),Mb&&!w&&ba(O,Di,k[E],-1,!0));U[C]({Qc:kc,Rc:Wc,hL:cb});Aa==ya-1&&P(ya)}}function iV(a,b){switch(b){case bH:return a.oz;case Dh:return a.Pe;case kg:return a.Pe+Yka+a.oz+Ge}return O}
function pNa(a,b,c,d,e,f,g,k,l,n,q,s,u,w,z,B,F,M){var N=a.L;if(N.Fc||1<=u)u=0;var P={},ba=e-d;Fw(P,f);P.Pe=g;Xa(P,F);P.ce=M;P.brush=P.ce.normal;Ap(P,k);np(P,b);P.Bs=0<=c?a.Nb.cn(c):null;P.O=l;b=q*u;u*=s;P.ED=b;P.Ry=u;P.Fd=360*d+a.B5;P.$c=360*e+a.B5;a.Fga&&(c=360-P.Fd,P.Fd=360-P.$c,P.$c=c);c=h.PI*(P.Fd-90)/180;f=h.PI*(P.$c-90)/180;P.oz=h[D](1E3*ba)/10+we;k=O;switch(z){case bH:k=P.oz;break;case zF:k=P[uz];break;case Dh:k=g;break;case oBa:k=g+Yka+P.oz+Ge}Bw(P,k);if(!l)return P;P.X=B;a=a.Ac(P[cd],B)[r];
B=B[uc];P.pK=new xk(a,B);P.mq=1==ba;if(P[cd])if(P.mq)P.dT=mK(n,new kK(a/2,B/2)),P.cT=!0;else{ba=q-B;B=s-B;a=P.pK;a=new xk(a[r]/ba,a[A]/B);g=new xk(2/ba,2/B);l=OT((c+f)/2+h.PI,1,1);i:{z=WKa(new kK(0,0),a);k=1;F=h.min;for(M=0;M<z[J];++M){var U;var qa=z[M];U=l.x*qa.x+l.y*qa.y;qa=U*U+1-(qa.x*qa.x+qa.y*qa.y);0>qa?U=null:(qa=h[ud](qa),U=[U-qa,U+qa]);if(null===U||0>U[1]){z=null;break i}k=F(k,U[1])}z=k}if(0.4>z)a=null;else{l=l.o();l[Fy](-z);a=UKa(a,g,g);i:{a=WKa(l,a);g=oj(f-c,2*h.PI);z=0;k=g;for(F=0;F<a[J];++F){M=
oj(h[sd](a[F].y,a[F].x)-c,2*h.PI);if(M>=g||0==M){a=!1;break i}k=h.min(M,k);z=h.max(M,z)}a=z-k<h.PI}a=a?l:null}ba=a&&new kK(a.x*ba,a.y*B);null!==ba&&(P.cT=!0,P.dT=TKa(n,ba,new kK(-P.pK[r]/2,-P.pK[A]/2)))}else P.cT=!1;P.offset=OT((c+f)/2,q,s)[Fy](w);w=OT(f,q,s);P.Ue=lK(n,OT(c,q,s));P.jh=lK(n,w);s=OT(f,b,u);P.My=lK(n,OT(c,b,u));P.Es=lK(n,s);N.Fc&&270>=P.Fd&&90<=P.$c&&(s={},90>P.Fd?(s.Fd=90,s.Ue=new kK(n.x+q,n.y)):(s.Fd=P.Fd,s.Ue=P.Ue),270<P.$c?(s.$c=270,s.jh=new kK(n.x-q,n.y)):(s.$c=P.$c,s.jh=P.jh),
s.brush=P.ce.tb,P.Pb=s);P.Fs=N.Fc&&0.5<d;P.jv=N.Fc&&0.5>e;if(P.Fs||P.jv)P.jK=P.ce.tb;return P}function hV(a,b,c,d){c=iV(c,b);d&&(c+=me+iV(d,b));a.de={$l:a[uz],content:c}}
function nNa(a,b,c,d){var e=a.L,f=e.pie.Qc,g=e.pie.Rc,k=c.pie[nx],l=Gn(a[eq],Zva,mFa,bH),n=h.PI*(3*(f+g)-h[ud]((3*f+g)*(f+3*g))),q=[];c=[];for(var s=0;s<e.dn[J];++s){var u=e.dn[s];if(u.O){var w;if(0<=u[nc])w=e.k[u[nc]];else{var z=e.pie.Ih;w=z[z[J]-1].hL}var B=h.max((f+w.ED)/2,0.75*f),F=h.max((g+w.Ry)/2,0.75*g),M=(w.$c+w.Fd)/2,z=oj(M,360),N=vj(f-B,g-F)/n*360,P,ba;2*N<w.$c-w.Fd?(P=w.Fd+N,ba=w.$c-N,180>z?ba=h.min(ba,180):P=h.max(P,180)):ba=P=M;var U=function(a){return lK(k,OT(a,B,F))},N=function(a){return U(h.asin(nj((a-
k.y)/F,-1,1)))},qa=function(a){return U(h.PI-h.asin(nj((a-k.y)/F,-1,1)))},u={V6:U(qj(M-90)).y,HL:new zm(U(qj(P-90)).y,U(qj(ba-90)).y),$y:u[cd],az:iV(w,l),U6:w[id],index:w[nc]};180>z?(u.N4=N,q[C](u)):(u.N4=qa,c[C](u))}}f=b[r]/2-f-d[uc];e=hNa(new rl(b.top,b[Zc],b[Hc],b[Zc]-f),a.Ac,2,d,q);b=hNa(new rl(b.top,b[G]+f,b[Hc],b[G]),a.Ac,1,d,c);d=[];Zi(d,e,b);a.L.wo=d};function jV(a,b,c){iU[L](this,a,b,c,cH)}X(jV,iU);jV[K].us=function(a){return this.G.Er(a[Mq])};jV[K].Wba=function(a,b){var c=b[pc](qe);switch(c[0]){case gI:c=ia(c[1]);if(0>c)break;this[$](fza+a,{kc:c,Ji:null})}};function kV(a,b,c,d,e,f,g){yU[L](this,a,b,c,d,e,g);var k=pn(a,nE,!0);this.C6=$O(f,function(b){return pn(a,Wza+b+Nma,k)})}X(kV,yU);kV[K].gu=function(a,b,c){this.q2(a,b,c)};kV[K].c3=function(a,b){return a[cz](b,!0)};function lV(a,b){a.k=a.k||{};var c=a.k;c[b]=c[b]||{};return c[b]}
kV[K].q2=function(a,b,c){var d={Ob:a,Sj:this.te.getEntries(),qv:c,Yl:b.wh},e=b.wh.Qa.$v;null!=e&&uw(b.wh.Qa,this.te.Tg(e)[Hy]);for(var f=this.Fo.aT,e=f==mh||f==kg,g=f==zg||f==kg,k=this.te&&0<d.Sj[J],f=HN(b[ux]),k=1<f[J]&&k,l=0;l<f[J];++l){var n=f[l],q=a.pie.Ih[J],n=n+a.k[J]/q*(q-1);this.C6[n]&&(qNa(a,n,c),e&&!k&&rNa(this,d,n))}e&&k&&sNa(this,d,f,f[f[J]-1]);var s=W(function(b){if(a.Uc){var c=a.k[J];return[b,(b+c/a.pie.Ih[J])%c]}return[b]},this),e=W(function(b,e){if(null!=b){for(var f=s(b),k=!1,l=0;l<
f[J];++l){var n=f[l];if(null!=n&&this.C6[n]){k=k||!0;if(a.Uc){var q=n,P=c,ba=a.k[q];if(null!=ba[by]){var U=ba.brush.o();U.dd(Mm(ba.brush.gb(),re,0.7));U.dh(ba.brush.Oe+0.1);lV(P,q).cv={brush:U}}}else tNa(a,n,c);a.wo&&(c.wo=kNa(a.wo,n))}}e&&g&&k&&rNa(this,d,b)}},this);if(f=b.Jh)c.Jh=f;e(b.Qa.nb,!0);e(b.Ea.Qa.ih,!1)};
function tNa(a,b,c){var d=a.pie;a=a.k[b];if(null!=a[by]){c=lV(c,b);c.an={};b=c.an;b.brush=new Rm({stroke:a.brush.gb(),qa:6.5,Cg:0.3});b.qh=new sk(d[nx].x+a[by].x,d[nx].y+a[by].y);b.Fd=a.Fd;b.$c=a.$c;b.mq=a.mq;var e;(e=c.li)?(c=e.Qc+e.brush.Hb/2,e=e.Rc+e.brush.Hb/2):(e=a.brush.Hb/2,c=d.Qc+e,e=d.Rc+e);d=b.brush.Hb/2;b.Qc=c+d;b.Rc=e+d;c=qj(b.Fd-90);e=qj(b.$c-90);b.Ue=wk(b.qh,OT(c,b.Qc,b.Rc));b.jh=wk(b.qh,OT(e,b.Qc,b.Rc));var f=a.Pb;f&&(b.Pb=b.Pb||{},b.Pb.brush=Zm(f.brush.gb(),0.3),b.Pb.qh=b.qh.o(),b.Pb.Fd=
f.Fd,b.Pb.$c=f.$c,b.Pb.Qc=b.Qc+d,b.Pb.Rc=b.Rc+d,c=qj(b.Pb.Fd-90),e=qj(b.Pb.$c-90),b.Pb.Ue=wk(b.Pb.qh,OT(c,b.Pb.Qc,b.Pb.Rc)),b.Pb.jh=wk(b.Pb.qh,OT(e,b.Pb.Qc,b.Pb.Rc)));b.Fs=a.Fs;b.jv=a.jv;if(b.Fs||b.jv)b.jK=Zm(a.jK.gb(),0.3),b.kia=b.Fs?c:e,a=function(a,b){return wk(a.qh,OT(a.kia,a.Qc+b*a.brush.Hb/2,a.Rc+b*a.brush.Hb/2))},b.dz=a(b,-1),b.nK=a(b,1)}}
function qNa(a,b,c){var d=a.pie;0<d.Cy||(a=a.k[b],null!=a[by]&&(b=lV(c,b),b.li={},b=b.li,b.brush=$m(a.brush.gb(),2),b.qh=new sk(d[nx].x+a[by].x,d[nx].y+a[by].y),b.Fd=a.Fd,b.$c=a.$c,b.mq=a.mq,a=a.brush.Hb/2+2.5+b.brush.Hb/2,b.Qc=d.Qc+a,b.Rc=d.Rc+a,d=qj(b.$c-90),b.Ue=wk(b.qh,OT(qj(b.Fd-90),b.Qc,b.Rc)),b.jh=wk(b.qh,OT(d,b.Qc,b.Rc))))}function rNa(a,b,c){var d=lV(b.qv,c);c=wU(a.Fo,b,c,null,null);d.vb=c;b.Yl&&a.te.gu(c,b.Yl,d.vb)}
function sNa(a,b,c,d){var e=lV(b.qv,d);c=uMa(a.Fo,b,c,d);e.vb=c;b.Yl&&a.te.gu(c,b.Yl,e.vb)};function mV(a){pu[L](this,a);this.pi=null;this.ib=Jg;this.Ef=this.Gc=this.b=this.Q=this.M3=null;this.wK=[];this.og=this.Da=this.tv=this.Ja=null;this.Ql=new rt;this.C=null;this.yf=new TU(this);this.$m=null}X(mV,pu);T=mV[K];T.w=function(){this.Wg();Ws(this.Ql);mV.e.w[L](this)};T.sh=null;function uNa(a,b,c,d,e,f){return a.pi===cH?new gV(b,c,d,e,f):a.pi===cF?new DU(b,c,d,e,f):new QT(b,c,d,e,f)}T.Gd=function(a,b,c,d){this.pi=a;null!=b&&(this.Gpa=b);null!=c&&(this.ib=c);null!=d&&(this.M3=d)};
T.Ym=function(a,b,c,d){Xn(NA);c=c||{};c=lo(io(c));vNa(this,c);wNa(this,c);Mw(c,c[lz]||this.ib);c.theme=c.theme||this.M3;this.pi!=R&&xNa(c);if(this.pi!=cH&&on(c.reverseCategories)){var e=c[lz]===Eh?Ls:VE;c[e]=c[e]||{};Qv(c[e],-1);delete c.reverseCategories}yNa(c);Ss.oc(this.lb);if(!b)throw m(LB);Mi(fj(b.H()),function(a){return b.Ss(a)==RG})&&(c.isDiff=!0);this.xv=b.D(0)!=Yg?1:0;this.Nh=b.M();zNa(this);if(c.isStacked&&c.vAxis&&c.vAxis.baseline)throw m("Cannot set a non-zero base-line for a stacked chart");
var f=c.theme||[];Yh(f)||(f=[f]);for(var e=[c],g=0;g<f[J];++g){var k;if(bi(f[g]))k=sJa(f[g]);else if(ai(f[g]))k=f[g];else throw m("Theme should be a theme name or an options object.");e[C](k)}c=c[H][ke]();uFa[c]&&e[C](uFa[c]);e[C](vFa);this.b=new jn(e);this.pi=Gn(this.b,Ah,aFa,R);this.V=On(this.lb,this.b);this.Oa=Pn(this.lb,this.b);c=new xk(this.V,this.Oa);e=pn(this.b,IE);if(!this.Da||this.Da.Mj)try{this.Da=new vK(this.lb,c,a,e)}catch(l){throw m(Lpa);}else this.Da[Pz](c,a);this.Ja=new AU(d);this.t=
b;this.Da.Io(W(this.xn,this),a)};
T.xn=function(){var a=this.Da.eb(),b=this.Da.Av(),c;this.og?(c=this.og.z3,this.kq()):c=this.Q;var d=this.b,e=uNa(this,this.t,d,W(a.vf,a),this.V,this.Oa).Ay(),f=new bNa(d,this.Ja,W(this.Bo,this),e);Ws(this.C);this.C=new bV(e,this.Ja,this.Ql,this.yf,W(this.Lh,this,!0),f);var f=new xk(this.V,this.Oa),g={Va:e.Kj,fontSize:e.Nl},k=e.By,l=e.Fh,n=e.k[J],q=this.Ef?this.Ef.te:void 0;this.Ef=e.Wa==cH?new kV(d,f,g,k,l,n,q):new EU(d,f,g,k,l,n,q);Y(this.wK,W(function(a){bi(a)?this.Gi(a):this.Hi(a)},this));this.wK=
[];this.Gc=e.Wa==cH?new dV(b,a):new FS(b,a);(a=zIa(d,0,MF))&&c&&c.Wa==e.Wa&&c[r]==e[r]&&c[A]==e[A]&&c.A.top==e.A.top&&c.A[Hc]==e.A[Hc]&&c.A[G]==e.A[G]&&c.A[Zc]==e.A[Zc]?(this.Q=null,b=hi(),this.kq(),this.og={mta:c,y3:e,Oea:new KMa(c,e),z3:c,startTime:b,Ks:b+a[xz],A3:0,timer:new tt(10),Nea:a.u3,nT:a.nT,x3:!1},this.B3(),kt(this.og.timer,Fs,W(this.B3,this)),this.og.timer[y](),this.Q=e):(this.Q=e,ANa(this),BNa(this));this.yf[$](ws);this.C.Gv()};
function nV(a,b){var c=new Ko,d=b.M(),e=b.H(),f=a.D(0)!=Yg;f&&c.mg(a.D(0),a.cb(0));for(var g=f?1:0,k=g;k<e;++k)c.mg({type:a.D(k),label:a.cb(k),role:RG}),c.mg({type:b.D(k),label:b.cb(k),role:Jr});c.Cz(d);for(var l=0;l<d;++l){k=null;f&&(k=b[I](l,0),c.al(l,0,k));for(var n=g,k=g;k<e;++k){var q=a[I](l,k);c.al(l,n,q);n+=1;q=b[I](l,k);c.al(l,n,q);n+=1}}return c}
function vNa(a,b){switch(b[H]){case JF:a.Gd(Bg,JF,Jg);ab(b,null);break;case BC:a.Gd(Bg,BC,Jg);ab(b,null);break;case ssa:a.Gd(Bg,KC,Jg);ab(b,null);break;case KC:a.Gd(Bg,KC,Eh);ab(b,null);break;case QH:a.Gd(QH);ab(b,null);break;case cH:a.Gd(cH),ab(b,null)}var c=a.pi;c==R&&(c=null);var d=b[H]||R;d==R&&(d=null);if(!c&&!d)throw m("Unspecified chart type.");if(c&&d&&c!=d)throw m("Incompatible chart types.");ab(b,c||d)}
function wNa(a,b){if(b[H]==Bg){var c=a.Gpa;c==R&&(c=null);var d=b.seriesType||R;d==R&&(d=null);if(c&&d&&c!=d)throw m("Incompatible default series types.");b.seriesType=c||d}}
function xNa(a){a.hAxis=a.hAxis||{};a.vAxis=a.vAxis||{};var b=a.hAxis,c=a.vAxis,d=null;switch(a[H]){case QH:d=c;break;case Bg:a.targetAxis=a.targetAxis||{},d=a.targetAxis}d&&(oV(a,yG,d,Wg),oV(a,oG,d,Ug),oV(a,PF,d,PF));b&&(oV(a,Rwa,b,PF),oV(a,zAa,b,HI));c&&oV(a,KI,c,HI);a.smoothLine&&!Qh(a.curveType)&&(a.curveType=Bg);oV(a,Kwa,a,LF);oV(a,Vya,a,EH);a.chartArea=a.chartArea||{};oV(a,bra,a.chartArea,HC)}
function yNa(a){pV(a,xAa,II,JI);pV(a,Hwa,Ewa,EF);qV(a.hAxis);for(var b in a.hAxes)qV(a.hAxes[b]);qV(a.vAxis);for(b in a.vAxes)qV(a.vAxes[b]);b=a.tooltip;null==b&&(b={},a.tooltip=b);pV(a,LAa,HAa,MAa);oV(a,MAa,b,EI);oV(a,KAa,b,Es);oV(a,NAa,b,XAa);b.trigger==yva&&(b.trigger=zg);b=a.legend;if(null==b)b={},a.legend=b;else if(typeof b==rh){var c=b;b={};a.legend=b;Ea(b,c)}oV(a,EF,b,EI);b=a.animation;null==b?(b={},a.animation=b):typeof b==Yg&&(c=1E3*b,b={},a.animation=b,b.duration=c);oV(a,Bqa,b,Kta)}
function qV(a){if(null!=a){pV(a,qAa,rAa,EI);pV(a,xAa,II,JI);a.gridlines=a.gridlines||{};var b=a.gridlines,c=a.numberOfSections;!Qh(b.count)&&Qh(c)&&typeof c==Yg&&(b.count=c+1);a=a.gridlineColor;!Qh(b[E])&&Qh(a)&&Xa(b,a)}}function pV(a,b,c,d){a[d]=a[d]||{};d=a[d];oV(a,b,d,KD);oV(a,c,d,HE)}function oV(a,b,c,d){Qh(a[b])&&!Qh(c[d])&&(c[d]=a[b])}T.Wg=function(){this.kq();zNa(this);Ws(this.Da);qt(this)};function zNa(a){if(a.C&&!a.C.Mj){var b=a.C.Xa;b.es=ea;b.Sc[Hq]()}Ws(a.C);Ws(a.$m);qt(a.Ql)}
T.Hi=function(a){null!=this.Ef?this.Ef.Hi(a):this.wK[C](a)};function CNa(a,b){var c=new FN;c[Yx](b);for(var c=IN(c),d=!1,e=0;e<c[J];e++){var f=c[e],g=f.column,f=f.row,g=a.Q.hq&&a.Q.hq[g];if(!g)return!1;var k=g.kc,l,n;null!=k?l=a.Q.k[k].j[f]:n=a.Q.Ba[f];if(!l&&!n)return!1;if(g.Iv==xC){if(d)return!1;d=!0;if(!(l||n).Jc)return!1}}return!0}
Zv(T,function(a){if(CNa(this,a)){var b=null;if(this.Q.Wa!=cH){var c=new FN;c[Yx](a);for(var c=IN(c),d=0;d<c[J];d++){var e=c[d],f=this.Q.hq[e.column];if(f.Iv==xC){b={kc:f.kc,$S:e.row};break}}}this.Lh(!0);this.Ja[ux][Yx](a);b&&(this.Ja[Uy].lK=b);this.Lh(!1)}});
T.Lh=function(a){var b=this.tv;if(!this.Ef.c3(this.Ja,this.tv)){var c=this.Ja.hn,d;if(c){gfa(this.b.Vj[0],c);c=this.Da.eb();c=uNa(this,this.t,this.b,W(c.vf,c),this.V,this.Oa).Ay();this.C.Q=c;this.$m.e3&&this.$m.e3(c);d=zU(this.Ef,c,this.Ja);this.Q=c;this.Gc.oK(this.Q);var c=this.Gc,e=this.Q;c.ed={};c.uv={};LIa(c,e,d);c.G.deleteContents(!0);MIa(c,d,c.G.Cs);c.G.flush();this.Ja.hn=null}else{d=zU(this.Ef,this.Q,this.Ja);var c=this.Gc,e=this.Q,f=Ij({k:null,Ba:null,Ea:null,wo:null,gi:null,Jh:null});fP(d,
f)&&fP(c.gq,f)?(gn(d.Ea,c.gq.Ea)||(c.G.cd(c.dq),f=new sO(2),tO(f,0,e.Ea||{}),tO(f,1,d.Ea||{}),f=f[My](),c.mD(f)),gn(d.gi,c.gq.gi)||(c.G.cd(c.bv),f=new sO(2),tO(f,0,e.gi||{}),tO(f,1,d.gi||{}),f=f[My](),NIa(c,f)),c.d3(e,d),gn(d.Jh,c.gq.Jh)||(xS(c,Lxa),e=d.Jh,f=new Rm,f.pe(e[E]),f.dh(e[Kd]),e=c.G.rb(e[G],e.top,e[r],e[A],f,c.G.Cs),c[Bx](e,Lxa)),c.gq=d):c.yo(e,d)}this.tv=this.Ja.o()}a&&this.yf.nv(b,this.tv,this.Q.Wa,this.Q.k)};Tw(T,function(){return this.tv?this.tv[ux][wz]():[]});
T.Tg=function(a){return this.Ef?this.Ef.Tg(a):void 0};T.Gi=function(a){null!=this.Ef?this.Ef.Gi(a):this.wK[C](a)};T.tsa=function(){var a=this.Da.eb();return a.Jna?a.lb[hd]:O};function ANa(a){var b=zU(a.Ef,a.Q,a.Ja);a.Gc.yo(a.Q,b);a.tv=a.Ja.o()}function BNa(a){var b=a.Da.eb(),c=a.Da.Av();Ws(a.$m);a.$m=a.Q.Wa==cH?new jV(a.Ql,b,c):new kU(a.Ql,b,c,a.Q);WLa(a.$m);YLa(a.$m);ZLa(a.$m)}
T.B3=function(){var a=this.og;this.Q=null;if(a.x3)this.kq(),this.Q=a.y3,ANa(this),BNa(this),this.yf[$](Cqa);else{var b=hi(),c=(b-a[Iy])/(a.Ks-a[Iy]);if(1>c){if(b-a.A3<1E3/this.og.nT)return}else c=1,a.x3=!0;c=a.Oea.interpolate(a.Nea(c));a.z3=c;a.A3=b;this.Gc.yo(c,{});this.yf[$](Dqa)}this.Q=a.y3};T.kq=function(){this.og&&(Ws(this.og.timer),this.og=null)};T.Moa=function(){var a=this.Q.A;return{left:a[G],top:a.top,width:a[r],height:a[A]}};
T.Nk=function(a){return null==this.Gc?null:(a=this.Gc.Nk(a))?{left:a[G],top:a.top,width:a[Zc]-a[G],height:a[Hc]-a.top}:null};T.Bo=function(){var a=this.Q;return{getChartAreaBoundingBox:W(this.Moa,this),getBoundingBox:W(this.Nk,this),getXLocation:W(VIa,null,a),getYLocation:W(WIa,null,a),getHAxisValue:W(XIa,null,a),getVAxisValue:W(YIa,null,a),getPointDatum:W(ZIa,null,a)}};T.Ay=function(){return this.Q};
T.Jj=function(){if(!this.b)throw m("Chart not drawn.");var a=new xk(this.V,this.Oa),b=Ek(this.lb)[Qb](Q),a=xK(b,a),a=new nK(b,a),c=new sK(b),a=this.pi==cH?new dV(c,a):new FS(c,a),c=zU(this.Ef,this.Q,this.Ja);a.yo(this.Q,c);return b[Xb][0].toDataURL(Gva)};function rV(a){mV[L](this,a);this.Gd(Bg,BC,Jg)}X(rV,mV);function sV(a){mV[L](this,a);this.Gd(Bg,qI,Jg)}X(sV,mV);function tV(a){mV[L](this,a);this.Gd(Bg,R,Jg,$za)}X(tV,mV);function vV(a){mV[L](this,a);this.Gd(Bg,JF,Jg)}X(vV,mV);function wV(a){mV[L](this,a);this.Gd(QH)}X(wV,mV);wV[K].uo=function(a,b){return nV(a,b)};V("google.visualization.ScatterChart.prototype.computeDiff",wV[K].uo,void 0);function xV(a){mV[L](this,a);this.Gd(cD)}X(xV,mV);function yV(a){mV[L](this,a);this.Gd(Bg,KC,Eh)}X(yV,mV);
yV[K].uo=function(a,b){return nV(a,b)};V("google.visualization.BarChart.prototype.computeDiff",yV[K].uo,void 0);function zV(a){mV[L](this,a);this.Gd(Bg,jD,Jg)}X(zV,mV);function AV(a){mV[L](this,a);this.Gd(Bg,KC,Jg)}X(AV,mV);AV[K].uo=function(a,b){return nV(a,b)};V("google.visualization.ColumnChart.prototype.computeDiff",AV[K].uo,void 0);function BV(a){mV[L](this,a);this.Gd(Bg,R,Jg)}X(BV,mV);function CV(a){mV[L](this,a);this.Gd(cH)}X(CV,mV);CV[K].uo=function(a,b){return nV(a,b)};
V("google.visualization.PieChart.prototype.computeDiff",CV[K].uo,void 0);function DV(a){mV[L](this,a);this.Gd(cF,KC,Jg)}X(DV,mV);function EV(a){rt[L](this);this.ed={};this.J=null;this.Uj={et:!1};this.vE=this.wE=this.C=this.g=this.sg=this.Q=this.ij=this.t=null;this.m=a;this.lE=50;this.L3=0;this.mL=1;this.xT=this.yT=this.rK=!1;this.VK=this.WK=this.NS=this.OS=null;this.Xf=!1;this.ud=null;this.n={range:null,yL:null,Hg:null};this.jj={dk:{min:0,max:0},value:{min:0,max:0}};this.$T=null;this.RS=!1;this.ft=null}X(EV,rt);
var FV={naa:yG,maa:oG,Vx:kg},GV={p3:"rangeSelectorMinHandle",o3:"rangeSelectorMaxHandle",r3:"rangeSelectorMinScreen",q3:"rangeSelectorMaxScreen"},DNa={Xra:nr,Gra:ar,Kra:gr,$ra:tr},ENa={fill:tA,ae:0.5},FNa={chartArea:{top:Oe,height:QA},enableInteractivity:!1,legend:{position:R},hAxis:{textPosition:mF},vAxis:{textPosition:R,gridlines:{color:R}}},GNa={chartArea:{left:Oe,width:QA},enableInteractivity:!1,legend:{position:R},vAxis:{textPosition:mF},hAxis:{textPosition:R,gridlines:{color:R}}},HV={brush:new Rm({stroke:aA,
fill:te}),uG:new xk(10,16),sja:3};T=EV[K];
Ep(T,function(a,b,c){this.Yf();this.t=a;this.ij=nIa(a.D(0));this.ed={};null==this.wE&&(this.wE=new VN(W(this.fja,this)));null==this.vE&&(this.vE=new VN(W(this.hW,this,!0)));b=new jn([b||{}]);this.rq(b);this.ud=this.V7(b);c=c||{};eu(this.J,ws,W(this.eja,this,c));this.rK&&(this.WK=this.t[I](0,0),this.VK=this.t[I](h.max(0,this.t.M()-1),0),b={min:this.WK,max:this.VK},c[By]&&HNa(this,b,c[By]),this.ud.domainAxis=this.ud.domainAxis||{},this.ud.domainAxis.viewWindow=b);this.J[Nq](a,this.ud)});
T.rq=function(a){this.lE=vn(a,nya,50);this.L3=vn(a,lxa,0);this.SS=pn(a,kua,!1);this.rK=pn(a,CBa,!1);this.yT=pn(a,Yza,!1);this.xT=pn(a,Dra,!1);this.OS=Jn(a,Mza,new Rm(ENa));this.NS=Ym.o();this.Yf();var b=null;switch(Gn(a,xD,DNa,gr)){case ar:b=new rV(this.m);break;case gr:b=new BV(this.m);break;case tr:b=new wV(this.m);break;case nr:b=new vV(this.m);break;default:b=new BV(this.m)}this.J=b;this.Xf=Gn(a,WG,pP,Jg)==Eh};T.V7=function(a){a=hn(nn(a,Pra));a.theme=this.Xf?GNa:FNa;return a};
function INa(a,b){var c=$O(a.M(),function(b){return a[I](b,0)}),c=Fi(c,Xh);return Gi(c,b)}T.eja=function(a){ju(this.J);this.Uj={et:!0};JNa(this,a);Ws(this.g);this.g=this.J.Da.eb(1);Ws(this.C);this.C=new sv;this.We()};T.U7=function(a){ju(this.J);JNa(this,a);IV(this,kg)};
function JNa(a,b){a.Q=a.J.Ay();a.sg=a.Xf?a.Q.be[0]:a.Q.Be[0];var c=a.jj,d;d={min:h.min(a.sg.hh,a.sg.Gh),max:h.max(a.sg.hh,a.sg.Gh)};c.dk=d;c=a.jj;d=a.sg[jc].Bk(a.sg.hh);var e=a.sg[jc].Bk(a.sg.Gh);d={min:h.min(d,e),max:h.max(d,e)};Fw(c,d);c=a.L3;if(0>=c)a.mL=1;else{d=0;d=a.jj.dk.min;var e=a.sg[jc].Bk(d),f=null;$h(e)?(f=new Date,f[Jc](e[bc]()+c)):f=e+c;d=h[xb](h.abs(a.sg[jc].Se(f)-d));c=h.max(d,1);a.mL=c<a.jj.dk.max-a.jj.dk.min?c:1}if(a.yT||a.xT)c=a.sg,d=INa(a.t,c[jc].Se),c=a.Xf?1==c.Ol?d[rx]():d:1==
c.Ol?d:d[rx](),a.$T=c;b&&(c=b[By],rw(a.n,KNa(a,ai(c)?c[y]:null,ai(c)?c.end:null)))}
T.We=function(){var a=this.g,b=this.Q,c=a.wk(b[r],b[A]),d=a.za(!1);a[p](c,d);c=b.A;a.rb(0,0,b[r],b[A],this.NS,d);var b=a.rb(c[G],c.top,c[r],c[A],this.NS,d),e=LNa(this),e=a.rb(e[G],e.top,e[r],e[A],this.OS,d);this.ed[GV.r3]=e;e=MNa(this);e=a.rb(e[G],e.top,e[r],e[A],this.OS,d);this.ed[GV.q3]=e;e=NNa(this,this.n[By].nh,c,a,d);this.ed[GV.p3]=e;a=NNa(this,this.n[By].mh,c,a,d);this.ed[GV.o3]=a;var f=Gk(this.m);this.C.l(f[Pd],EG,W(this.Kea,this,this.Uj));this.C.l(f[Pd],FG,W(this.t3,this,this.Uj));d=d.a();
this.C.l(d,EG,W(this.Lea,this,this.Uj));this.C.l(d,fs,W(this.jE,this,this.Uj,{type:RH,jn:!1}));(this.RS=ml(d,function(a){return a==f[Pd]}))||this.C.l(d,FG,W(this.t3,this,this.Uj));this.SS||(ONa(this,e,yG,yG),ONa(this,a,oG,oG));this.C.l(b,es,W(this.xK,this,this.Uj,{Hg:kg}));this.C.l(b,gs,W(this.jE,this,this.Uj,{type:RH,jn:!0}));this.C.l(b,fs,W(this.jE,this,this.Uj,{type:RH,jn:!1}));hu(this,ws,null)};
function ONa(a,b,c,d){a.C.l(b,es,W(a.xK,a,a.Uj,{Hg:d}));a.C.l(b,gs,W(a.jE,a,a.Uj,{type:c,jn:!0}));a.C.l(b,fs,W(a.jE,a,a.Uj,{type:c,jn:!1}))}
function NNa(a,b,c,d,e){var f=HV.uG,g=HV.sja,k=HV.brush,l=d.za(!1);d[p](e,l);e=0.5*f[r];var n=a.Xf?c[G]:h[t](b-e)+0.5;b=a.Xf?h[t](b-e)+0.5:c.top;d.em(l.a(),n,b);a.Xf?(b=h[D](e),b=aK(a.Xf?[{x:0,y:b},{x:0+c[r],y:b}]:[{x:0,y:b},{x:0,y:b+c[A]}]),d.na(b,k,l),a.SS||PNa(a,0.5*(c[r]-f[A]),0,f[A],f[r],g,d,k,l)):(b=h[D](e),b=aK(a.Xf?[{x:b,y:0},{x:b+c[r],y:0}]:[{x:b,y:0},{x:b,y:0+c[A]}]),d.na(b,k,l),a.SS||PNa(a,0,0.5*(c[A]-f[A]),f[r],f[A],g,d,k,l));return l.a()}
function PNa(a,b,c,d,e,f,g,k,l){d=b+d;e=c+e;var n=aK([{x:b+f,y:c},{x:d-f,y:c},{x:d,y:c+f},{x:d,y:e-f},{x:d-f,y:e},{x:b+f,y:e},{x:b,y:e-f},{x:b,y:c+f}],!1);g.na(n,k,l);f+=1;a.Xf?(a=aK([{x:b+f,y:c+f},{x:d-f,y:c+f}]),b=aK([{x:b+f,y:e-f},{x:d-f,y:e-f}])):(a=aK([{x:b+f,y:c+f},{x:b+f,y:e-f}]),b=aK([{x:d-f,y:c+f},{x:d-f,y:e-f}]));g.na(a,k,l);g.na(b,k,l)}function LNa(a){var b=a.Q.A,c=a.n[By].nh;return a.Xf?new vl(b[G],b.top,b[r],c-b.top):new vl(b[G],b.top,c-b[G],b[A])}
function MNa(a){var b=a.Q.A,c=a.n[By].mh;return a.Xf?new vl(b[G],c,b[r],b[Hc]-c):new vl(c,b.top,b[Zc]-c,b[A])}function KNa(a,b,c){var d=a.jj.dk.min,e=a.jj.dk.max,f=1==a.sg.Ol&&!a.Xf;null!=b&&(b=a.sg[jc].Se(b),f?d=h.max(b,d):e=h.min(b,e));null!=c&&(a=a.sg[jc].Se(c),f?e=h.min(a,e):d=h.max(a,d));return{nh:d,mh:e}}T.pO=function(){var a=this.n[By],b=this.sg[jc].Bk(a.nh),a=this.sg[jc].Bk(a.mh),c=1==this.sg.Ol&&!this.Xf;return{start:c?b:a,end:c?a:b}};
T.dta=function(a,b){if(!this.Uj.et)return!1;var c=this.n[By];if(null==c.nh||null==c.mh)return!1;c=KNa(this,a,b);c=JV(this,c.nh,c.mh,kg);this.n.Hg=null;return c};function JV(a,b,c,d){var e=a.n[By];if(e.nh==b&&e.mh==c)return!1;rw(a.n,{nh:b,mh:c});IV(a,d);return!0}
function IV(a,b){var c=a.Xf?HV.uG[A]:HV.uG[r],d=a.Xf?HV.uG[r]:HV.uG[A];if(b!=oG){var e=LNa(a),f=a.ed[GV.r3],g=a.ed[GV.p3];if(a.Xf){var k=h[t](e.top+e[A]-0.5*d)+0.5;a.g.em(g,0,k);a.g.kQ(f,e.top);a.g.Ex(f,e[A])}else k=h[t](e[G]+e[r]-0.5*c)+0.5,a.g.em(g,k,0),a.g.jQ(f,e[G]),a.g.sl(f,e[r])}b!=yG&&(e=MNa(a),f=a.ed[GV.q3],g=a.ed[GV.o3],a.Xf?(k=h[t](e.top-0.5*d)+0.5,a.g.em(g,0,k),a.g.kQ(f,e.top),a.g.Ex(f,e[A])):(k=h[t](e[G]-0.5*c)+0.5,a.g.em(g,k,0),a.g.jQ(f,e[G]),a.g.sl(f,e[r])))}
T.fja=function(){IV(this,this.n.Hg)};function QNa(a){var b=a.jj.dk.max-a.jj.dk.min,c=a.sg.Ol,d=(a.n[By].nh-a.jj.dk.min)/b;if(0.1>d)return{direction:-1*c,c8:d/0.1};a=(a.jj.dk.max-a.n[By].mh)/b;return 0.1>a?{direction:1*c,c8:a/0.1}:null}function KV(a){if(a.rK){var b=!1;a.n.Hg==kg&&QNa(a)&&(b=!0);b&&!a.ft?(a.ft=new tt(a.lE),a.C.l(a.ft,Fs,W(a.cka,a)),a.ft[y]()):!b&&a.ft&&(Ws(a.ft),a.ft=null)}}
T.cka=function(){if(this.ft){var a=QNa(this),b=this.lE/pj(1E3,6E4,a.c8),c=this.ij.xl(this.WK),d=this.ij.xl(this.VK),e=(d-c)*b,b=this.ud.domainAxis.viewWindow,f=b.max,g=this.ij.xl(b.min),f=this.ij.xl(f);0>a[jx]?(c=h.max(g-e,c),a=f-(g-c)):(a=h.min(f+e,d),c=g+(a-f));g=this.ij.Bx(c);a=this.ij.Bx(a);b.min=g;b.max=a;eu(this.J,ws,W(this.U7,this,null));this.J[Nq](this.t,this.ud);this.hW(!0)}};T.Lea=function(a,b){a.et&&null!=this.n.Hg&&(this.RS||RNa(this,b),hw(b[Mq][x],HG))};
T.Kea=function(a,b){a.et&&null!=this.n.Hg&&RNa(this,b)};function RNa(a,b){var c=a.n;c[By]&&null!=c[By].nh&&null!=c[By].mh||rw(c,{nh:a.jj.dk.min,mh:a.jj.dk.max});var d=Ml(b),e,d=(a.Xf?d.y:d.x)-c.yL,f=a.n[By],g=a.jj.dk,k;switch(a.n.Hg){case kg:e=g.min-f.nh;k=g.max-f.mh;break;case yG:e=g.min-f.nh;k=f.mh-a.mL-f.nh;break;case oG:e=f.nh+a.mL-f.mh,k=g.max-f.mh}e=nj(d,e,k);c.yL+=e;c.Hg!=oG&&(c[By].nh+=e);c.Hg!=yG&&(c[By].mh+=e);KV(a);WN(a.wE,a.lE);WN(a.vE,a.lE)}
T.xK=function(a,b,c){if(a.et&&bt(c)){a=Ml(c);var d=this.n;d.yL=this.Xf?a.y:a.x;d.Hg=b.Hg;KV(this);c[Hp]()}};
T.t3=function(a){if(a.et&&(a=this.n,null!==a.Hg)){if(this.yT){var b=this.$T,c=a[By].mh,d=Pm(b,a[By].nh),c=Pm(b,c);JV(this,d,c,a.Hg)}else if(this.xT){var e=new zm(a[By].nh,a[By].mh),d=e.end-e[y],c=this.jj.dk,f=b=this.$T,g=W(Bm,null,e),b=Oi(f,g),g=Qi(f,g);if(null===b||null===g)b=Pm(f,e[y]),f=Pm(f,e.end),g=b=f=h.abs(e[y]-b)<=h.abs(e.end-f)?b:f;e=e.end-e[y];b=vj(b,g)-e/2;e=new zm(b,b+e);La(e,h.max(e[y],c.min));e.end=e[y]+d;e.end=h.min(e.end,c.max);La(e,e.end-d);JV(this,e[y],e.end,a.Hg)}else this.rK&&
a.Hg!=kg&&(d=this.ud.domainAxis.viewWindow,c=this.pO(),HNa(this,d,c),eu(this.J,ws,W(this.U7,this,{range:c})),this.J[Nq](this.t,this.ud));this.hW(!1);a.Hg=null;KV(this)}};
function HNa(a,b,c){var d=b.max,e=a.ij.xl(b.min),d=a.ij.xl(d),f=d-e;0===f&&(e-=1,d+=1,f=2);var g=c[y];c=c.end;if(null!=g&&null!=c){var k=a.ij.xl(g),l=a.ij.xl(c);c=l-k;var g=0.1*f,n=0.6*f;c>=g&&c<=n||(k=(k+l)/2,f/=(c<g?0.9*n:1.1*g)/c,f=new zm(k-f/2,k+f/2),c<g||(e=a.ij.xl(a.WK),d=a.ij.xl(a.VK)),SNa(f,new zm(e,d)),e=a.ij.Bx(f[y]),a=a.ij.Bx(f.end),b.min=e,b.max=a)}}function SNa(a,b){a[y]<b[y]&&(a.end+=b[y]-a[y],La(a,b[y]));a.end>b.end&&(La(a,a[y]-(a.end-b.end)),a.end=b.end);a[y]<b[y]&&La(a,b[y])}
T.jE=function(a,b,c){a.et&&!this.n.Hg&&hw(c[Mq][x],b.jn?b[H]==RH?HG:this.Xf?$ya:JD:ZD)};T.hW=function(a){var b=this.n.Hg,c=this.pO();if(null!=b&&null!=c){var d=this.sg.Ol;hu(this,uH,{start:c[y],end:c.end,startChanged:b==(1==d?FV.naa:FV.maa)||b==FV.Vx,endChanged:b==(1==d?FV.maa:FV.naa)||b==FV.Vx,inProgress:a})}};T.Yf=function(){this.J&&(ju(this.J),Ws(this.wE),this.wE=null,Ws(this.vE),this.vE=null,this.Uj.et=!1,Ws(this.g),this.g=null,Ws(this.C),this.C=null,this.J.Yf(),this.J=null,qt(this))};var TNa={day:864E5,hour:36E5,minute:6E4,second:1E3,millisecond:1};function LV(a){var b=MV(a),c;t:{c=a[pc](ne);if(2===c[J]){c=ia(c[0]);if(di(c)&&!ga(c))break t;throw m('Invalid number for increment: "'+a+'".');}c=1}b=TNa[b];if(!b)throw m('Invalid number for increment "'+a+'".');return c*b}function MV(a){var b=a[J]-1;a=a[Bb](b)===kh?a[ae](0,b):a;a=a[pc](ne);return 2===a[J]?a[1]:a[0]}function UNa(a,b,c){a=ia(a);b=(a-c)%LV(b);return a=new Date(a-b)}
function VNa(a,b,c){a=ia(a);c=a-c;b=LV(b);c%=b;return a=0===c?new Date(a):new Date(a+b-c)};function NV(a){rt[L](this);this.q=a;a=kk||mk&&!qk(kna)&&a[Nc]==Mf;this.C=new sv(this);this.C.l(this.q,a?[wF,Oxa,Tsa,Gta,oF]:oF,this)}X(NV,rt);NV[K].Sc=null;kp(NV[K],function(a){if(a[H]==oF)kk&&qk(10)&&0==a[Np]&&0==a[Mp]||(OV(this),jk&&this.q!=Gk(this.q)[pb]||this[$](WNa(a)));else if(a[H]!=wF||SBa(a)){var b=a[H]==wF?this.q[id]:null;kk&&229==a[Np]&&(b=null);var c=WNa(a);OV(this);this.Sc=ut(function(){this.Sc=null;this.q[id]!=b&&this[$](c)},0,this)}});
function OV(a){null!=a.Sc&&(vt(a.Sc),a.Sc=null)}function WNa(a){a=new $s(a.Ka);ab(a,oF);return a}NV[K].w=function(){NV.e.w[L](this);this.C.W();OV(this);delete this.q};function PV(a,b,c){dM[L](this,a,b||rM.Xb(),c)}X(PV,dM);ML(Xpa,function(){return new PV(null)});function QV(a,b){VK[L](this,b);this.Gb=a||O}X(QV,VK);QV[K].Hp=null;QV[K].qka=10;var RV="placeholder"in fa[Qb](oF);T=QV[K];T.lG=!1;T.h=function(){this.q=this.ea().h(oF,{type:Es})};T.mf=function(a){QV.e.mf[L](this,a);this.Gb||(this.Gb=a[Sd](zF)||O);nl(Gk(a))==a&&(this.lG=!0,a=this.a(),hL(a,this.$G));RV?this.a().placeholder=this.Gb:(a=this.a(),bL(a,zF,this.Gb))};
T.Bb=function(){QV.e.Bb[L](this);var a=new sv(this);a.l(this.a(),zg,this.m5);a.l(this.a(),TC,this.gM);if(RV)this.C=a;else{lk&&a.l(this.a(),[Xr,wF,xF],this.Dga);var b=Gk(this.a());a.l(Qk(b),Pwa,this.Ega);this.C=a;XNa(this)}this.Et();this.a().ni=this};T.ve=function(){QV.e.ve[L](this);this.C&&(this.C.W(),this.C=null);this.a().ni=null};function XNa(a){!a.yia&&a.C&&a.a().form&&(a.C.l(a.a().form,nAa,a.zia),a.yia=!0)}T.w=function(){QV.e.w[L](this);this.C&&(this.C.W(),this.C=null)};T.$G="label-input-label";
T.m5=function(){this.lG=!0;var a=this.a();hL(a,this.$G);if(!RV&&!SV(this)&&!this.pka){var b=this,a=function(){b.a()&&Fw(b.a(),O)};kk?ut(a,10):a()}};T.gM=function(){RV||(this.C.uc(this.a(),Fr,this.m5),this.Hp=null);this.lG=!1;this.Et()};T.Dga=function(a){27==a[Np]&&(a[H]==wF?this.Hp=this.a()[id]:a[H]==Xr?Fw(this.a(),this.Hp):a[H]==xF&&(this.Hp=null),a[Hp]())};T.zia=function(){SV(this)||(Fw(this.a(),O),ut(this.Uka,10,this))};T.Uka=function(){SV(this)||Fw(this.a(),this.Gb)};T.Ega=function(){this.Et()};
function SV(a){return!!a.a()&&a.a()[id]!=O&&a.a()[id]!=a.Gb}wa(T,function(){Fw(this.a(),O);null!=this.Hp&&(this.Hp=O)});vw(T,function(){SV(this)&&(this[Wb](),this.Et())});T.wa=function(a){null!=this.Hp&&(this.Hp=a);Fw(this.a(),a);this.Et()};fb(T,function(){return null!=this.Hp?this.Hp:SV(this)?this.a()[id]:O});T.Zl=function(a){RV?(this.Gb=a,this.a()&&(this.a().placeholder=this.Gb)):(this.a()&&!SV(this)&&Fw(this.a(),O),this.Gb=a,this.i9(),(a=this.a())&&bL(a,zF,this.Gb))};T.sd=function(){return this.Gb};
T.Et=function(){var a=this.a();RV?this.a().placeholder!=this.Gb&&(this.a().placeholder=this.Gb):(XNa(this),bL(a,zF,this.Gb));SV(this)?(a=this.a(),hL(a,this.$G)):(this.pka||this.lG||(a=this.a(),fL(a,this.$G)),RV||ut(this.i9,this.qka,this))};T.Ga=function(a){Uw(this.a(),!a);var b=this.a();jL(b,this.$G+DA,!a)};qw(T,function(){return!this.a()[Nd]});T.i9=function(){!this.a()||SV(this)||this.lG||Fw(this.a(),this.Gb)};function TV(a,b){this.ye=new Ct(a);this.wma=b?b:vra;this.Ve=5E3}var YNa=0;hp(TV[K],function(a,b,c,d){a=a||null;d=d||iC+(YNa++)[hc](36)+hi()[hc](36);Ph._callbacks_||(Ph._callbacks_={});var e=this.ye.o();if(a)for(var f in a)a[vc]&&!a[vc](f)||fja(e,f,a[f]);b&&(Ph._callbacks_[d]=ZNa(d,b),fja(e,this.wma,Rpa+d));b=pGa(e[hc](),{timeout:this.Ve,Y$:!0});lGa(b,$Na(d,a,c));return{bc:d,baa:b}});up(TV[K],function(a){a&&(a.baa&&a.baa[pq](),a.bc&&UV(a.bc,!1))});
function $Na(a,b,c){return function(){UV(a,!1);c&&c(b)}}function ZNa(a,b){return function(c){UV(a,!0);b[Mc](void 0,arguments)}}function UV(a,b){Ph._callbacks_[a]&&(b?delete Ph._callbacks_[a]:Ph._callbacks_[a]=Th)};;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



var DX="page",RRa="\u2717",SRa="\u2714",TRa="\u25bc",URa="\u25b2",VRa="\u2003",WRa="width: 200px;",XRa="tq",EX="sort",YRa="rowColor",ZRa="previous",$Ra="prev",aSa="position: relative;",bSa="position: absolute; top: 0; left: 0; overflow: hidden;",cSa="position: absolute; top: -5000px; width: 100px; overflow: scroll;",dSa="position: absolute; top: -5000px;",FX="page",eSa="order by `",fSa="next",gSa="limit ",hSa="javascript:void(0)",iSa="height: 8px; width: 8px",jSa="google-visualization-table-th gradient",
kSa="google-visualization-table-loadtest",lSa="ft",mSa="fh",GX="event",nSa="current",oSa="` desc",pSa="`",qSa="__td-colSpan",HX="-nonstrict",rSa=" offset ";function IX(a,b,c,d){this.MF=a;this.WR=b;this.A1=c;this.jga=d}IX[K].dea=!1;IX[K].Fn=function(a){this.dea=a};IX[K].rP=function(){return this.dea};function sSa(a,b){this.Uf=a;var c=a.M(),d=c;b[DX]&&b[DX]!=dE&&(d=b.pageSize||10);this.Wx=d;this.OE=0<c?h[xb](c/this.Wx):1;this.Lna=null!=b.firstRowNumber?b.firstRowNumber:1;this.mna=!b[Zd]||b[Zd]==mE}T=sSa[K];T.Uf=null;T.Bn=0;T.fD=null;T.Ov=-1;T.yz=!1;T.u2=null;function JX(a,b){0<=b&&b<a.OE&&(a.Bn=b)}function tSa(a){for(var b=KX(a),c=[],d={},e=b[y];e<=b.end;e++){var f=LX(a,e);d[f.MF]=f.A1;c[C](f)}a.u2=d;return c}T.iQ=function(){return{column:this.Ov,ascending:!this.yz,sortedIndexes:this.fD}};
function MX(a){return LX(a,KX(a)[y])}function uSa(a,b){a.u2||tSa(a);var c=a.u2[b];return null!=c?c:-1}function KX(a){var b=a.Wx*a.Bn,c=b+a.Wx-1,c=h.min(a.Uf.M()-1,c);return new zm(b,c)}function LX(a,b){var c=a.fD,d=a.Lna,e=KX(a)[y];return new IX(c?c[b]:b,b,b-e,b+d)}function vSa(a){if(a.mna&&-1!=a.Ov){var b=a.Uf.Co([{column:a.Ov,desc:a.yz}]),c=a.Uf.oca(),d=Gi(b,function(a){return c[a]},a);a.Uf.qn(d);a.fD=a.fD?Gi(b,function(a){return this.fD[a]},a):b}else a.fD=null};function NX(a){pu[L](this,a);this.P=Ek();this.sc=new FN}X(NX,pu);
var wSa={l5:"google-visualization-table-table",jL:"google-visualization-table-tr-head",yE:"google-visualization-table-tr-even",UK:"google-visualization-table-tr-odd",Zs:"google-visualization-table-tr-sel",Iw:"google-visualization-table-tr-over",ZL:jSa,O4:"google-visualization-table-th-webkit gradient",UU:"google-visualization-table-td",tma:"google-visualization-table-td-number",sma:"google-visualization-table-td-center",rma:"google-visualization-table-td-bool",swa:"google-visualization-table-td-freeze-rightmost",
k5:"google-visualization-table-seq",Nfa:"google-visualization-table-sorthdr",Ofa:"google-visualization-table-sortind",wga:"google-visualization-table-div-page",yga:"google-visualization-table-page-numbers",xga:"page-number gradient"},xSa={jL:"headerRow",yE:"tableRow",UK:"oddTableRow",Zs:"selectedTableRow",Iw:"hoverTableRow",ZL:"headerCell",UU:"tableCell",k5:"rowNumberCell"},ySa={"background-image":R,backgroundColor:yh,borderColor:yh},zSa={"background-image":R,backgroundColor:yh},OX={visibility:Ig},
ASa={borderRight:"2px solid gray"},BSa=Wn()+"/3rd-party/gc/arrow_left.gif",CSa=Wn()+"/3rd-party/gc/arrow_right.gif";T=NX[K];T.N6=!0;T.qN=null;T.Lo=null;T.jG=null;T.t=null;T.Uf=null;T.b=null;T.we=null;T.uE=null;T.Mz=null;T.gw=null;T.n4=-1;T.NK=!1;T.Xz=null;T.uF=null;T.tF=null;T.wU=0;T.C=null;
T.Ym=function(a,b,c){a=c||{};if(!this.lb)throw m(hf);if(!b)throw m(LB);this.t=b;this.Uf=new ku(this.t);this.b=a;this.NK=0<this.Uf.M();this.we=new sSa(this.Uf,this.b);this.NK&&(a.startPage&&JX(this.we,a.startPage),a[Zd]!=dE&&null!=a.sortColumn&&(c=a.sortAscending,b=this.we,c=!(null!=c?c:1),b.Ov=a.sortColumn,b.yz=c,vSa(b)),this.jG=MX(this.we));this.wU=a.scrollLeftStartPosition||0;b=a.frozenColumns;b=null!=b?b:-1;0!=b||a.showRowNumber||(b=-1);b>=this.Uf.H()&&(b=-1);-1>b&&(b=-1);this.n4=b;this.Lo=Pj(wSa);
if(-1==b&&(a=this.Lo,b=this.b.cssClassNames)){b.headerCell&&(a.jL+=HX);if(b.tableCell||b.rowNumberCell)a.yE+=HX,a.UK+=HX,a.Zs+=HX,a.Iw+=HX;for(var d in xSa)(c=b[xSa[d]])&&(a[d]=c)}d=!0;this.N6&&(d=DSa(this),this.N6=!1);this.wq();d?(Zk(this.qN),this.tz()):this.L6(0)};T.tz=function(){hu(this,ws,null)};T.iQ=function(){return this.we?this.we.iQ():null};
T.wq=function(){var a=this.Uf,b=this.b,c=this.lb,d=[],e=this.P,f,g=this.Lo,k=this.wU,l=0;b.keepScrollPosition&&this.Xz&&(k=this.Xz[Gc],l=this.Xz[Cd]);this.uE=null;this.TE();this.C=new sv;var n=c[x][r]||b[r]||0,q=c[x][A]||b[A]||0,n=ESa(n),q=ESa(q),s=FSa(a),u=GSa(a,g),g=HSa(this),w=this.Mz=ISa(this,g,b,u,s),s=this.Xz=e.h(Q,{style:aSa},w);n&&zl(s,{overflow:eg,width:n});u=e.h(Q,{style:aSa},s);q&&(zl(s,{overflow:eg,height:q}),f=PX(this,{Jfa:!0}),d[C]({EV:f,type:Dg}));var z=this.n4;if(a=n&&0<a.H()&&0<a.M()&&
-1<z)f=PX(this,{Kfa:!0,y4:z}),this.gw=f[Sb],d[C]({EV:f,type:lSa}),q&&(f=PX(this,{y4:z,Ifa:!0}),d[C]({EV:f,type:mSa}));hb(u[x],Ig);e[p](c,u);c=this.NK&&1<this.we.OE;f=b.pagingButtonsConfiguration;(c=null!=f&&f!=eg||c)&&b[DX]&&b[DX]!=dE&&(f=u[Uc],JSa(this,u),q&&(q=f-(u[Uc]-f),zl(s,Hg,q+S)));!b.rtlTable||c||n||q||Qv(this.Mz[x],jh);c=0;a&&(c=2+Fl(g[Xb][z+(b.showRowNumber?1:0)]).x);b=s[Wd]<s[Rb];z=s[Gd]<s[Bc];q&&!n&&(n=this.Mz[Gd],b?(q=Ek(),a=q.h(Q,{style:cSa},q.h(Q,{style:WRa})),q[p](Ph[Hd][Pd],a),f=
a[zb]-a[Gd],q[kq](a),zl(s,{width:n+(f||16)+S})):zl(s,{width:n+S}));n=0;0<s[Gd]-w[Gd]&&(n=s[Gd],zl(w,Ih,n+S));for(w=0;w<d[J];w++)switch(q=d[w].EV,a=d[w][H],n&&zl(q[Sb],Ih,s[Gd]+S),a){case Dg:b&&(zl(q,{height:g[Wd]+S,width:s[Gd]+S}),e[p](u,q));break;case lSa:z&&(zl(q,{height:s[Wd]+S,width:c+S}),e[p](u,q));break;case mSa:b&&z&&(zl(q,{height:g[Wd]+S,width:c+S}),e[p](u,q))}Rw(s,l);s.scrollLeft=k;hb(u[x],O)};
function PX(a,b){var c=a.P,d=a.b,e=a.Lo,f=a.Xz,g=a.Uf,k=FSa(g),e=GSa(g,e),g=b.y4,l=KSa,n=HSa(a);if(0<=g){var q=g+(d.showRowNumber?1:0);zl(n[Xb][q-1],ASa);QX(n);for(var s=n[Xb];q<s[J];q++){var u=s[q];zl(u,OX);QX(u)}s=b.Ifa;null!=s&&s||(l=LSa(g))}d=ISa(a,n,d,e,k,l);zl(d,{backgroundColor:yh});c=c.h(Q,{style:bSa},d);b.Jfa&&a.C.l(f,SH,gi(MSa,f,c));b.Kfa&&a.C.l(f,SH,gi(NSa,f,c));return c}
function ISa(a,b,c,d,e,f){f=f||Th;var g=a.Uf,k=a.t,l=a.P,n=a.Lo,q=l.h(Ds,{"class":n.l5,cellspacing:Oe}),s=l.h(BI);l[p](q,s);l[p](s,b);var u,w;null==a.uE&&(a.uE=a.NK?tSa(a.we):[]);b=a.uE;for(var z=!0,B=c.alternatingRowStyle,B=null!=B?B:!0,F=0;F<b[J];F++){var M=b[F],N=M.MF,P=k.Yq(N,YRa);w=P?O:B?z?n.yE:n.UK:n.yE;z=!z;w=l.h(RI,{"class":w});JN(a.sc,N)&&(lb(w,n.Zs),M.Fn(!0));P&&(w[x].backgroundColor=P);a.C.l(w,es,W(a.fU,a,M));a.C.l(w,gs,W(a.hU,a,M));a.C.l(w,fs,W(a.gU,a,M));l[p](s,w);c.showRowNumber&&(u=
l.h(CI,{"class":n.UU+ne+n.k5}),l[p](w,u),l[p](u,l[Cb](String(M.jga))),f(u,F,-1));N=0;for(P=g.H();N<P;){var ba=M.MF;u={};var U=d[N],qa=k.Ao(ba,N,Wba);qa&&(U=qa);u[Vba]=U;(U=(U=k.Ao(ba,N,qSa))&&h.min(U,P-N))&&1<U?u.colSpan=U:U=1;u=l.h(CI,u);l[p](w,u);var qa=k[I](ba,N),ya=k.Aa(ba,N);null==qa?ya=mi(ya)?Nh:ya:e[N]==jg&&(ya=qa?SRa:RRa);if(c.allowHtml)Wa(u,ya),(ba=k.Ao(ba,N,sh))&&$a(u[x],ba);else l[p](u,l[Cb](ya));f(u,F,N);N+=U}f(w,F)}return q}
function HSa(a){var b=a.Uf,c=a.b||{},d=a.P,e=a.Lo,f=b.H(),g=c[Zd]!=dE&&0<b.M(),k=d.h(RI,{"class":e.jL}),l,n=mk&&c[A]&&e.ZL==jSa;if(c.showRowNumber&&0<b.H()){var q=e.ZL;n&&(q=e.O4);l=d.h(CI,{"class":q});d[p](k,l);Wa(l,zA)}for(q=0;q<f;q++){l=e.ZL;n&&(l=e.O4);g&&(l+=ne+e.Nfa);l=d.h(CI,{"class":l});d[p](k,l);var s=b.cb(q);c.allowHtml?Wa(l,s):d[p](l,d[Cb](s));g&&(d[p](l,d.h(Bs,{"class":e.Ofa},a.we.Ov==q?a.we.yz?TRa:URa:VRa)),a.C.l(l,Fr,W(a.Pfa,a,q),!0))}return k}
function JSa(a,b){var c=a.b,d=a.P,e=a.Lo,f=null!=c.pagingSymbols?c.pagingSymbols:{},g=f.prev,f=f[oc],c=!!c.allowHtml,g=g?c?ol(d,g):g:d.h(Vr,{src:BSa,alt:ZRa,style:iSa}),f=f?c?ol(d,f):f:d.h(Vr,{src:CSa,alt:fSa,style:iSa});Ws(a.uF);Ws(a.tF);g=a.uF=new PV(g);f=a.tF=new PV(f);g.tt(2);f.tt(1);a.C.l(g,qC,W(a.q5,a,!1));a.C.l(f,qC,W(a.q5,a,!0));OSa(a);c=d.h(Q,e.wga);d[p](b,c);g.B(c);f.B(c);var k=d.h(Q,{"class":e.yga});d[p](c,k);var l=W(function(a,b){var c=e.xga;b&&(c+=ne+b);c=d.h(bg,{href:hSa,"class":c});
Wa(c,String(a+1));this.C.l(c,Fr,W(this.o5,this,a));d[p](k,c)},a),g=a.we.OE,f=a.we.Bn;Y(PSa(0,f-1),function(a){l(a)});l(f,nSa);Y(PSa(f+1,g-1),function(a){l(a)})}function PSa(a,b){var c=[];if(a+10>b)for(var d=a;d<=b;d++)c[C](d);else{d=a;c[C](d);var e=b;c[C](e);for(var f=10;d<e;)d=f*h[xb]((d+2)/f)-1,d<e&&c[C](d),e=f*h[t](e/f)-1,d<e&&c[C](e),f*=10;cj(c)}return c}T.q5=function(a){var b=this.we.OE,c=this.we.Bn;a=a?h.min(b,c+1):h.max(0,c-1);this.o5(a)};
T.o5=function(a){this.b[DX]==mE&&(JX(this.we,a),QSa(this),this.wq());OSa(this);hu(this,FX,{page:a})};function OSa(a){var b=a.b.pagingButtonsConfiguration||eg,c=a.we.Bn,d=a.tF,e=a.uF;d.Ga(!0);e.Ga(!0);switch(b){case $Ra:d.Ga(!1);break;case fSa:e.Ga(!1);break;case kg:break;default:0==c&&e.Ga(!1),c==a.we.OE-1&&d.Ga(!1)}}function MSa(a,b){b.scrollLeft=a[Gc]}function NSa(a,b){Rw(b,a[Cd])}
function DSa(a){var b=a.qN;if(!b){var c=a.lb,b=Rk(Q,{style:dSa,"class":kSa},fa[Cb](Nh));c[p](b);a.qN=b}return Yl(b)[G]==ZA}T.L6=function(a){if(10>a)if(DSa(this))this[Nq](this.Uf,this.b);else{var b=200*a;a++;Ov(W(this.L6,this,a),b)}else Zk(this.qN),this.tz()};Tw(T,function(){return this.sc[wz]()});
Zv(T,function(a){if(this.t){var b=this.sc[Yx](a);a=this.uE;this.jG=MX(this.we);for(var c=this.Mz[Sb][Xb],d=this.gw?this.gw[Sb][Xb]:null,e,f,g=this.Lo,k=HN(b.fG),l=0;l<k[J];l++)f=k[l],f=uSa(this.we,f),-1!=f&&(e=a[f],e.Fn(!1),(e=c[f+1])&&Ck(e,g.Zs),(f=d&&d[f+1])&&Ck(f,g.Zs));b=HN(b.eG);for(l=0;l<b[J];l++)f=b[l],f=uSa(this.we,f),-1!=f&&(e=a[f],e.Fn(!0),(e=c[f+1])&&Bk(e,g.Zs),(f=d&&d[f+1])&&Bk(f,g.Zs))}});
T.fU=function(a,b){var c,d=this.jG,e=a.MF;c=fk?b[Cq]:b[Jq];if(b[Oq]){b[Hp]();var f=h.min(a.WR,d.WR),e=h.max(a.WR,d.WR);c=c?this.sc[wz]():[];for(var g=this.we,k=[];f<=e;f++){var l=LX(g,f);k[C](l)}for(e=0;e<k[J];e++)c[C]({row:k[e].MF})}else if(c)if(b[Hp](),c=this.sc[wz](),JN(this.sc,e))k=new FN,k[Yx](c),k.mB(e),c=k[wz]();else c[C]({row:e});else c=JN(this.sc,e)?null:[{row:e}];this[Yx](c);this.jG=b[Oq]?d:a;hu(this,As,{})};
T.hU=function(a){var b=this.Lo;a=a.A1;var c=this.Mz[Sb][Xb][a+1];c&&Bk(c,b.Iw);(c=(c=this.gw?this.gw[Sb][Xb]:null)&&c[a+1])&&Bk(c,b.Iw)};T.gU=function(a){a=a.A1;var b=this.Lo,c=this.Mz[Sb][Xb][a+1];c&&Ck(c,b.Iw);(c=(c=this.gw?this.gw[Sb][Xb]:null)&&c[a+1])&&Ck(c,b.Iw)};T.Pfa=function(a){var b=this.we,c=!b.yz,c=b.Ov==a?!c:!0;this.b[Zd]!=GX?(b.Ov=a,b.yz=!c,vSa(b),JX(this.we,0),this.jG=MX(this.we),QSa(this),this.wq(),hu(this,EX,this.we.iQ())):hu(this,EX,{column:a,ascending:c,sortedIndexes:null})};
function QSa(a){var b=a.Xz;b&&(a.wU=b[Gc])}T.TE=function(){Ws(this.C);this.C=null;this.P.cd(this.lb);Ws(this.uF);this.uF=null;Ws(this.tF);this.tF=null};T.Yf=function(){this.TE();this.sc[Wb]();this.we=null};function ESa(a){if(mi(a))return a;var b=a;oi(a)&&String(a)!==Oe&&(b+=S);return b}function GSa(a,b){for(var c=[],d=0;d<a.H();d++){var e=b.UU;switch(a.D(d)){case jg:e+=ne+b.rma;break;case Yg:e+=ne+b.tma;break;case og:case pg:case wh:e+=ne+b.sma}c[C](e)}return c}
function FSa(a){for(var b=[],c=0;c<a.H();c++)b[C](a.D(c));return b}function KSa(a){zl(a,OX);QX(a)}function LSa(a){return function(b,c,d){b[Nc]==Of?QX(b):d==a-1?zl(b,ASa):d>=a&&(zl(b,OX),QX(b))}}function QX(a){kk&&7>pk?zl(a,zSa):zl(a,ySa);a[Nc]==bC&&(zl(a,KD,yh),Rl(a,0))};function RX(a,b,c,d){this.Qe=a;this.hR=new NX(b);this.rna=c;eu(this.hR,FX,W(this.Hba,this));eu(this.hR,EX,W(this.Lpa,this));this.lQ=a=Qh(d)?Pj(d):{};this.Gba=d[DX]==mE;a.showRowNumber=!0;a.pagingButtonsConfiguration=d.pagingButtonsConfiguration||kg;nb(a,null==d[Zd]||d[Zd]==mE?GX:dE);this.Gba&&(a.page=GX,d=d.pageSize||0,this.Wx=0>=d?10:d,a.pageSize=this.Wx,this.Bn=0,RSa(this,0))}T=RX[K];T.QC=null;T.lj=null;T.br=null;T.Haa=O;T.M$=O;T.Wx=-1;T.Bn=-1;T.cl=0;T.H0=null;T.JC=null;T.fJ=null;
T.xC=function(){this.H0&&this.H0();var a;a=Lt(gja(this.Qe),XRa)||O;a+=ne+this.Haa+ne+this.M$;this.lj=new St(this.Qe);this.lj.fk(a);this.Vm(this.cl);this[Iq]();this.hR[Yx]([]);this.QC=new qu(this.lj,this.hR,this.lQ,this.rna);this.QC.yR(W(this.xu,this));this.QC.xR(this.fJ);this.QC.xC()};Bp(T,function(){this.QC&&this.QC[Iq]()});T.Lpa=function(a){var b=a.column;a=a.ascending;this.lQ.sortColumn=b;this.lQ.sortAscending=a;this.Haa=eSa+this.br.jf(b)+(a?pSa:oSa);this.Gba?this.Hba({page:0}):this.xC()};
T.Vm=function(a){this.cl=h.max(0,a);this.lj&&this.lj.Vm(this.cl)};T.Hba=function(a){var b=this.Bn,c=0;switch(a[DX]){case 0:c=0;break;case 1:c=b+1;break;case -1:c=b-1}RSa(this,c);this.xC()};function RSa(a,b){var c=a.Bn,d=a.Wx,e;if(!(e=0>b||b>c+1)){if(c=b==c+1)c=-1,a.br&&(c=a.br.M()),c=c<=d;e=c}e||(a.Bn=b,c=a.Bn*d,a.M$=gSa+(d+1)+rSa+c,a.lQ.firstRowNumber=c+1)}T.xu=function(a){this.JC&&this.JC(a);this.br=a.Ni()?null:a.Pa()};T.yR=function(a){if(null!=a){if(typeof a!=Bg)throw m(Oga);this.JC=a}};
T.xR=function(a){if(null!=a){if(typeof a!=Bg)throw m("Custom post-response handler must be a function.");this.fJ=a}};T.Ysa=function(a){if(null!=a){if(typeof a!=Bg)throw m("Custom sendAndDraw must be a function.");this.H0=a}};V("google.visualization.Table",NX,void 0);Ep(NX[K],NX[K][Nq]);Tw(NX[K],NX[K][wz]);Zv(NX[K],NX[K][Yx]);NX[K].getSortInfo=NX[K].iQ;NX[K].clearChart=NX[K].Yf;V("google.visualization.TableQueryWrapper",RX,void 0);RX[K].sendAndDrawTable=RX[K].xC;Bp(RX[K],RX[K][Iq]);RX[K].setCustomSendAndDraw=RX[K].Ysa;RX[K].setCustomPostResponseHandler=RX[K].xR;RX[K].setCustomResponseHandler=RX[K].yR;RX[K].setRefreshInterval=RX[K].Vm;Bp(RX[K],RX[K][Iq]);;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



var IXa="border: 0; padding: 0; margin: 0;",JXa="border: 0; padding: 0; margin: 0; width: ",KXa="greenColor",LXa="greenFrom",MXa="greenTo",NXa="majorTicks",OXa="minorTicks",PXa="redColor",QXa="redFrom",RXa="redTo",SXa="yellowColor",TXa="yellowFrom",UXa="yellowTo";
function yZ(a,b,c,d,e){rt[L](this);this.m=a;this.V=b;this.Oa=c;this.xD={Va:EC,fontSize:d,color:fA,Tb:O,bold:!1,Ic:!1,De:!1};this.Vga={Va:EC,fontSize:d,color:RC,Tb:O,bold:!1,Ic:!1,De:!1};this.nfa={Va:EC,fontSize:0,color:fA,Tb:O,bold:!1,Ic:!1,De:!1};this.mfa=e;this.wf=this.Da=this.g=null;this.mU=[]}X(yZ,rt);
var VXa=new Rm({fill:uA,stroke:fA,qa:1}),WXa=new Rm({fill:"#f7f7f7",stroke:wA,qa:2}),XXa=new Rm({stroke:jA,qa:1}),YXa=new Rm({stroke:fA,qa:2}),ZXa=new Rm({fill:vA,ae:0.7,stroke:"#c63310",qa:1}),$Xa=new Rm({fill:"#4684ee",stroke:jA,qa:1});T=yZ[K];T.Ca=ja;T.mb=ja;T.r5=ja;T.Ny=ja;T.hd=0;T.HX=null;T.nE=null;T.FV=null;T.xO=270;T.h5=0;T.g8=null;T.kH=null;T.Hv=null;T.og=null;T.Ye=function(){return this.Ca};T.Gs=function(a){this.Ca=a};T.Xe=function(){return this.mb};T.nq=function(a){this.mb=a};
T.wa=function(a,b,c){this.hd=a;this.HX=b;this.kq();a=zZ(this,a);null!=this.kH&&c?(this.og=new hN([this.kH],[a],c[xz],c.u3),kt(this.og,[hra,yqa,oE],this.Cpa,!1,this),kt(this.og,oE,this.Bpa,!1,this),this.og[fz](!1)):(this.kH=a,AZ(this))};T.Ro=function(a,b){this.r5=h.max(1,a);this.Ny=h.max(1,b)};T.VT=function(a){this.Hv=a};function BZ(a,b,c,d){a.mU[C]({Se:b,Bk:c,color:d})}T.x6=function(){};wa(T,function(){this.kq();Ws(this.Da);this.Da=null;qt(this)});
Ep(T,function(a,b){var c=new xk(this.V,this.Oa);null!=this.Da?this.Da[Pz](c,a):this.Da=new vK(this.m,c,a,b);this.Da.Io(W(this.xn,this),a)});
T.xn=function(){var a=this.Da.eb(),b=a.wk(this.V,this.Oa);a.Fb(b,OD,Ys);this.g=a;var c=this.wf=a.za(!1);a[p](b,c);var d,e,b=h.min(this.V,this.Oa),b=h[D](0.45*b),f=this.V/2,g=this.Oa/2;a.Zd(f-0.5,g-0.5,b,VXa,c);b-=VXa.Hb;b=h[D](0.9*b);a.Zd(f-0.5,g-0.5,b,WXa,c);b-=2*WXa.Hb;e=0.75*b;for(var k=0;k<this.mU[J];k++){var l=this.mU[k],n=l.Bk,q=CZ(this,l.Se),s=CZ(this,n),n=new YJ,u=f+rj(q,b),w=g+sj(q,b);n[Yy](u,w);n.Wf(f,g,b,b,q+90,s+90,!0);u=f+rj(s,e);w=g+sj(s,e);n.Z(u,w);n.Wf(f,g,e,e,s+90,q+90,!1);n[vy]();
a.na(n,new Rm({fill:l[E]}),c)}if(this.nE||this.FV)this.nE&&(e=g-h[D](0.35*b),a.mi(this.nE,0,e,this.V,e,pD,pD,this.xD,c)),this.FV&&(e=g+h[D](0.35*b),a.mi(this.FV,0,e,this.V,e,pD,pD,this.xD,c));var l=this.Ny,q=0.8*b,s=0.9*b,u=this.r5*l,w=(this.mb-this.Ca)/u,z=new YJ,B=new YJ,F=this.nfa,M=h[D](0.14*b);Ja(F,M);for(k=0;k<=u;k++){var N=CZ(this,k*w+this.Ca),P=0==k%l,ba=P?q:s,n=P?z:B;d=f+rj(N,ba);e=g+sj(N,ba);n[Yy](d,e);d=f+rj(N,b);e=g+sj(N,b);n.Z(d,e);P&&this.Hv&&(n=this.Hv[h[t](k/l)])&&(d=f+rj(N,ba-M/2),
e=g+sj(N,ba-M/2),ba=pD,280<N||90>N?(ba=oE,N=0):90<=N&&260>N?(ba=nI,N=d,d=this.V):(P=h.min(d,this.V-d),N=d-P,d+=P,e+=h[D](M/4)),a.mi(n,N,e,d,e,ba,pD,F,c))}a.na(B,XXa,c);a.na(z,YXa,c);this.kq();zZ(this,this.hd);this.h5=b;AZ(this);this.mfa()};T.Cpa=function(a){this.kH=a.x;AZ(this)};T.Bpa=function(){this.kq()};T.kq=function(){this.og&&(qt(this.og),this.og[Hq](!1),Ws(this.og),this.og=null)};function zZ(a,b){var c=(b-a.Ca)/(a.mb-a.Ca),c=h.max(c,-0.02);return c=h.min(c,1.02)}
function CZ(a,b){var c=zZ(a,b);return a.xO*c+oj((360-a.xO)/2+90,360)}
function AZ(a){if(a.g){var b=a.h5,c=a.g,d=a.V/2,e=a.Oa/2,f=a.xO*a.kH+oj((360-a.xO)/2+90,360),g=h[D](0.95*b),k=h[D](0.3*b),l=rj(f,g),g=sj(f,g),n=rj(f,k),k=sj(f,k),f=oj(f+90,360),q=0.07*b,s=rj(f,q),q=sj(f,q),f=new YJ;f[Yy](d+l,e+g);f.Zj(d+s,e+q,d-n+s/2,e-k+q/2,d-n,e-k);f.Zj(d-n-s/2,e-k-q/2,d-s,e-q,d+l,e+g);l=h[D](0.15*b);(g=a.g8)?c.cd(g):g=a.g8=c.za();a.HX&&(b=e+h[D](0.75*b),c.mi(a.HX,0,b,a.V,b,pD,pD,a.Vga,g));c.na(f,ZXa,g);c.Zd(d-0.5,e-0.5,l,$Xa,g);c[p](a.wf,g)}};function aYa(a,b,c,d){this.m=a;this.V=b;this.Oa=c;this.aL=d;this.Ew=[];this.Kc=[];this.Hv=[];this.yW=[];this.Wj=[];this.Ca=0;this.mb=100;this.W7=this.OT=this.eL=this.dL=this.QT=this.gL=this.fL=this.NT=this.cL=this.bL=null;this.Wo=!0;this.EW=0}T=aYa[K];T.Ny=2;T.Gs=function(a){this.Ca!=a&&(this.Ca=a,this.Wo=!0)};T.Ye=function(){return this.Ca};T.nq=function(a){this.mb!=a&&(this.mb=a,this.Wo=!0)};T.Xe=function(){return this.mb};T.x6=function(a){this.W7=a};
T.setValues=function(a,b,c){this.Wo=this.Wo||this.Kc[J]!=a[J]||this.Wj[J]!=c[J]||!ej(this.Wj,c);this.Kc=a;this.yW=b;this.Wj=c};T.VT=function(a){1==a[J]&&(a=[O,a[0],O]);ej(this.Hv,a)||(this.Hv=a,this.Wo=!0)};function DZ(a,b,c){return h.min(h[t](a.V/c),h[t](a.Oa/b))}Ep(T,function(a){if(this.Wo)bYa(this,a);else for(a=0;a<this.Kc[J];a++){var b=this.Ew[a];b.nE=this.Wj[a];b.wa(this.Kc[a],this.yW[a],this.W7)}});
function bYa(a,b){a[Wb]();var c=a.Kc[J],d=1,e=1;if(1<c)for(var f=h[t](h[ud](a.V*a.Oa/c)),e=h[t](a.V/f),d=h[t](a.Oa/f);!(c<=h[t](a.V/f)*h[t](a.Oa/f));){var g=DZ(a,d,e+1),k=DZ(a,d+1,e);g>=k&&(f=g,e++);k>=g&&(f=k,d++)}f=DZ(a,d,e);f-=4;k=Ek();k.cd(a.m);a.Ew=[];if(0!=c){var l=k.h(Ds,{style:IXa,cellpadding:2,cellspacing:0,align:pD}),n=k.h(BI,null);k[p](l,n);for(var g=[],q=0,s=0;s<d;s++){var u=k.h(RI,{style:IXa});k[p](n,u);for(var w=0;w<e;w++){var z=k.h(CI,{style:JXa+f+rH});g[q++]=z;k[p](u,z)}}k[p](a.m,
l);d=h[D](0.1*f);a.EW=0;a.Wo=!0;for(e=0;e<c;e++)k=a.Ew[e]=new yZ(g[e],f,f,d,W(function(){this.EW++;this.EW==this.Ew[J]&&(this.Wo=!1)},a)),k.Gs(a.Ca),k.nq(a.mb),k.nE=a.Wj[e],l=a.Hv,n=l[J],k.Ro(1<n?n-1:4,a.Ny),0<n&&k.VT(l),k.wa(a.Kc[e],a.yW[e],null),null!=a.bL&&null!=a.cL&&BZ(k,a.bL,a.cL,a.NT),null!=a.fL&&null!=a.gL&&BZ(k,a.fL,a.gL,a.QT),null!=a.dL&&null!=a.eL&&BZ(k,a.dL,a.eL,a.OT),k[Nq](b,a.aL)}}wa(T,function(){for(var a=0;a<this.Ew[J];++a)this.Ew[a][Wb]();this.Ew=[]});function EZ(a){pu[L](this,a);this.P=Ek()}X(EZ,pu);T=EZ[K];T.V=0;T.Oa=0;T.aL=!0;
T.Ym=function(a,b,c){var d=new jn([c||{}]);c=this.lb;var e=On(c,d),f=Pn(c,d),g=pn(d,IE);if(e!=this.V||f!=this.Oa||g!=this.aL)this.rG&&this.rG[Wb](),this.rG=new aYa(c,e,f,g),this.V=e,this.Oa=f,this.aL=g;c=this.rG;e=sn(d,yG,0);c.Gs(e);e=sn(d,oG,100);c.nq(e);e=[String(c.Ye()),O,O,O,String(c.Xe())];e=d.R(NXa,e);c.VT(e);e=sn(d,OXa,2);c.Ny!=e&&(c.Ny=e,c.Wo=!0);var e=tn(d,LXa),f=tn(d,MXa),g=tn(d,TXa),k=tn(d,UXa),l=tn(d,QXa),n=tn(d,RXa),q=Cn(d,KXa,dA),s=Cn(d,SXa,qA),u=Cn(d,PXa,oA);if(c.bL!=e||c.cL!=f||c.NT!=
q||c.fL!=g||c.gL!=k||c.QT!=s||c.dL!=l||c.eL!=n||c.OT!=u)c.bL=e,c.cL=f,c.NT=q,c.fL=g,c.gL=k,c.QT=s,c.dL=l,c.eL=n,c.OT=u,c.Wo=!0;d=zIa(d,400,nF);c.x6(d);d=[];e=[];f=[];if(2==b.H()&&b.D(0)==rh&&b.D(1)==Yg)for(g=0;g<b.M();g++)null!=b[I](g,0)&&null!=b[I](g,1)&&(f[C](b[I](g,0)),d[C](b[I](g,1)),e[C](b.Aa(g,1)));else for(k=0;k<b.H();k++)if(b.D(k)==Yg)for(g=0;g<b.M();g++)null!=b[I](g,k)&&(d[C](b[I](g,k)),e[C](b.Aa(g,k)),f[C](b.cb(k)));c.setValues(d,e,f);c[Nq](a);hu(this,ws,null)};
T.Wg=function(){this.rG&&this.rG[Wb]()};V("google.visualization.Gauge",EZ,void 0);Ep(EZ[K],EZ[K][Nq]);EZ[K].clearChart=EZ[K].Yf;EZ[K].getContainer=EZ[K].ac;;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});



function IZ(a,b){return a.time=b}var BYa="#444",JZ="#990000",CYa="annotationText",KZ="certainty",DYa="inline-block",LZ="size";V("google.visualization.CoreChart",mV,void 0);Ep(mV[K],mV[K][Nq]);mV[K].getImageURI=mV[K].Jj;Tw(mV[K],mV[K][wz]);Zv(mV[K],mV[K][Yx]);mV[K].dump=mV[K].tsa;mV[K].clearChart=mV[K].Yf;mV[K].getChartLayoutInterface=mV[K].Bo;mV[K].getContainer=mV[K].ac;mV[K].setAction=mV[K].Hi;mV[K].getAction=mV[K].Tg;mV[K].removeAction=mV[K].Gi;V(Oua,rV,void 0);Ep(rV[K],rV[K][Nq]);
rV[K].getImageURI=rV[K].Jj;Tw(rV[K],rV[K][wz]);Zv(rV[K],rV[K][Yx]);rV[K].setAction=rV[K].Hi;rV[K].getAction=rV[K].Tg;rV[K].removeAction=rV[K].Gi;V(Pua,yV,void 0);yV[K].computeDiff=yV[K].uo;Ep(yV[K],yV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(yV[K],yV[K][wz]);Zv(yV[K],yV[K][Yx]);yV[K].setAction=yV[K].Hi;yV[K].getAction=yV[K].Tg;yV[K].removeAction=yV[K].Gi;V("google.visualization.BubbleChart",xV,void 0);Ep(xV[K],xV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(xV[K],xV[K][wz]);Zv(xV[K],xV[K][Yx]);
xV[K].setAction=xV[K].Hi;xV[K].getAction=xV[K].Tg;xV[K].removeAction=xV[K].Gi;V("google.visualization.CandlestickChart",zV,void 0);Ep(zV[K],zV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(zV[K],zV[K][wz]);Zv(zV[K],zV[K][Yx]);zV[K].setAction=zV[K].Hi;zV[K].getAction=zV[K].Tg;zV[K].removeAction=zV[K].Gi;V("google.visualization.Histogram",DV,void 0);Ep(DV[K],DV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(DV[K],DV[K][wz]);Zv(DV[K],DV[K][Yx]);DV[K].setAction=DV[K].Hi;DV[K].getAction=DV[K].Tg;DV[K].removeAction=DV[K].Gi;
V(Qua,AV,void 0);AV[K].computeDiff=AV[K].uo;Ep(AV[K],AV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(AV[K],AV[K][wz]);Zv(AV[K],AV[K][Yx]);AV[K].setAction=AV[K].Hi;AV[K].getAction=AV[K].Tg;AV[K].removeAction=AV[K].Gi;V("google.visualization.ComboChart",BV,void 0);Ep(BV[K],BV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(BV[K],BV[K][wz]);Zv(BV[K],BV[K][Yx]);BV[K].setAction=BV[K].Hi;BV[K].getAction=BV[K].Tg;BV[K].removeAction=BV[K].Gi;V(Rua,vV,void 0);Ep(vV[K],vV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(vV[K],vV[K][wz]);
Zv(vV[K],vV[K][Yx]);vV[K].setAction=vV[K].Hi;vV[K].getAction=vV[K].Tg;vV[K].removeAction=vV[K].Gi;V(Sua,CV,void 0);CV[K].computeDiff=CV[K].uo;Ep(CV[K],CV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(CV[K],CV[K][wz]);Zv(CV[K],CV[K][Yx]);CV[K].setAction=CV[K].Hi;CV[K].getAction=CV[K].Tg;CV[K].removeAction=CV[K].Gi;V(Tua,wV,void 0);wV[K].computeDiff=wV[K].uo;Ep(wV[K],wV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(wV[K],wV[K][wz]);Zv(wV[K],wV[K][Yx]);wV[K].setAction=wV[K].Hi;wV[K].getAction=wV[K].Tg;
wV[K].removeAction=wV[K].Gi;V("google.visualization.SparklineChart",tV,void 0);Ep(tV[K],tV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(tV[K],tV[K][wz]);Zv(tV[K],tV[K][Yx]);tV[K].setAction=tV[K].Hi;tV[K].getAction=tV[K].Tg;tV[K].removeAction=tV[K].Gi;V("google.visualization.SteppedAreaChart",sV,void 0);Ep(sV[K],sV[K][Nq]);yV[K].getImageURI=yV[K].Jj;Tw(sV[K],sV[K][wz]);Zv(sV[K],sV[K][Yx]);sV[K].setAction=sV[K].Hi;sV[K].getAction=sV[K].Tg;sV[K].removeAction=sV[K].Gi;
V("google.visualization.RangeSelector",EV,void 0);Ep(EV[K],EV[K][Nq]);EV[K].getRange=EV[K].pO;EV[K].setRange=EV[K].dta;;window.google&&window.google.loader&&window.google.loader.eval&&window.google.loader.eval.visualization&&(window.google.loader.eval.visualization=function(){eval(arguments[0])});


google.loader.loaded({"module":"visualization","version":"1.0","components":["ui","corechart","default","gauge","table","format","geochart"]});
google.loader.eval.visualization = function() {eval(arguments[0]);};if (google.loader.eval.scripts && google.loader.eval.scripts['visualization']) {(function() {var scripts = google.loader.eval.scripts['visualization'];for (var i = 0; i < scripts.length; i++) {google.loader.eval.visualization(scripts[i]);}})();google.loader.eval.scripts['visualization'] = null;}})();/*!
 * jQuery JavaScript Library v1.7.2
 * http://jquery.com/
 *
 * Copyright 2011, John Resig
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 * Copyright 2011, The Dojo Foundation
 * Released under the MIT, BSD, and GPL Licenses.
 *
 * Date: Wed Mar 21 12:46:34 2012 -0700
 */
(function( window, undefined ) {

// Use the correct document accordingly with window argument (sandbox)
var document = window.document,
	navigator = window.navigator,
	location = window.location;
var jQuery = (function() {

// Define a local copy of jQuery
var jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		return new jQuery.fn.init( selector, context, rootjQuery );
	},

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$,

	// A central reference to the root jQuery(document)
	rootjQuery,

	// A simple way to check for HTML strings or ID strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	quickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,

	// Check if a string has a non-whitespace character in it
	rnotwhite = /\S/,

	// Used for trimming whitespace
	trimLeft = /^\s+/,
	trimRight = /\s+$/,

	// Match a standalone tag
	rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>)?$/,

	// JSON RegExp
	rvalidchars = /^[\],:{}\s]*$/,
	rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
	rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
	rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g,

	// Useragent RegExp
	rwebkit = /(webkit)[ \/]([\w.]+)/,
	ropera = /(opera)(?:.*version)?[ \/]([\w.]+)/,
	rmsie = /(msie) ([\w.]+)/,
	rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/,

	// Matches dashed string for camelizing
	rdashAlpha = /-([a-z]|[0-9])/ig,
	rmsPrefix = /^-ms-/,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return ( letter + "" ).toUpperCase();
	},

	// Keep a UserAgent string for use with jQuery.browser
	userAgent = navigator.userAgent,

	// For matching the engine and version of the browser
	browserMatch,

	// The deferred used on DOM ready
	readyList,

	// The ready event handler
	DOMContentLoaded,

	// Save a reference to some core methods
	toString = Object.prototype.toString,
	hasOwn = Object.prototype.hasOwnProperty,
	push = Array.prototype.push,
	slice = Array.prototype.slice,
	trim = String.prototype.trim,
	indexOf = Array.prototype.indexOf,

	// [[Class]] -> type pairs
	class2type = {};

jQuery.fn = jQuery.prototype = {
	constructor: jQuery,
	init: function( selector, context, rootjQuery ) {
		var match, elem, ret, doc;

		// Handle $(""), $(null), or $(undefined)
		if ( !selector ) {
			return this;
		}

		// Handle $(DOMElement)
		if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;
		}

		// The body element only exists once, optimize finding it
		if ( selector === "body" && !context && document.body ) {
			this.context = document;
			this[0] = document.body;
			this.selector = selector;
			this.length = 1;
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			// Are we dealing with HTML string or an ID?
			if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = quickExpr.exec( selector );
			}

			// Verify a match, and that no context was specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;
					doc = ( context ? context.ownerDocument || context : document );

					// If a single string is passed in and it's a single tag
					// just do a createElement and skip the rest
					ret = rsingleTag.exec( selector );

					if ( ret ) {
						if ( jQuery.isPlainObject( context ) ) {
							selector = [ document.createElement( ret[1] ) ];
							jQuery.fn.attr.call( selector, context, true );

						} else {
							selector = [ doc.createElement( ret[1] ) ];
						}

					} else {
						ret = jQuery.buildFragment( [ match[1] ], [ doc ] );
						selector = ( ret.cacheable ? jQuery.clone(ret.fragment) : ret.fragment ).childNodes;
					}

					return jQuery.merge( this, selector );

				// HANDLE: $("#id")
				} else {
					elem = document.getElementById( match[2] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {
						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[2] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return rootjQuery.ready( selector );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	},

	// Start with an empty selector
	selector: "",

	// The current version of jQuery being used
	jquery: "1.7.2",

	// The default length of a jQuery object is 0
	length: 0,

	// The number of elements contained in the matched element set
	size: function() {
		return this.length;
	},

	toArray: function() {
		return slice.call( this, 0 );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num == null ?

			// Return a 'clean' array
			this.toArray() :

			// Return just the object
			( num < 0 ? this[ this.length + num ] : this[ num ] );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems, name, selector ) {
		// Build a new jQuery matched element set
		var ret = this.constructor();

		if ( jQuery.isArray( elems ) ) {
			push.apply( ret, elems );

		} else {
			jQuery.merge( ret, elems );
		}

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		ret.context = this.context;

		if ( name === "find" ) {
			ret.selector = this.selector + ( this.selector ? " " : "" ) + selector;
		} else if ( name ) {
			ret.selector = this.selector + "." + name + "(" + selector + ")";
		}

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	ready: function( fn ) {
		// Attach the listeners
		jQuery.bindReady();

		// Add the callback
		readyList.add( fn );

		return this;
	},

	eq: function( i ) {
		i = +i;
		return i === -1 ?
			this.slice( i ) :
			this.slice( i, i + 1 );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ),
			"slice", slice.call(arguments).join(",") );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: [].sort,
	splice: [].splice
};

// Give the init function the jQuery prototype for later instantiation
jQuery.fn.init.prototype = jQuery.fn;

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( length === i ) {
		target = this;
		--i;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	noConflict: function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}

		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	},

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {
		// Either a released hold or an DOMready/load event and not yet ready
		if ( (wait === true && !--jQuery.readyWait) || (wait !== true && !jQuery.isReady) ) {
			// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
			if ( !document.body ) {
				return setTimeout( jQuery.ready, 1 );
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}

			// If there are functions bound, to execute
			readyList.fireWith( document, [ jQuery ] );

			// Trigger any bound ready events
			if ( jQuery.fn.trigger ) {
				jQuery( document ).trigger( "ready" ).off( "ready" );
			}
		}
	},

	bindReady: function() {
		if ( readyList ) {
			return;
		}

		readyList = jQuery.Callbacks( "once memory" );

		// Catch cases where $(document).ready() is called after the
		// browser event has already occurred.
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			return setTimeout( jQuery.ready, 1 );
		}

		// Mozilla, Opera and webkit nightlies currently support this event
		if ( document.addEventListener ) {
			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", DOMContentLoaded, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", jQuery.ready, false );

		// If IE event model is used
		} else if ( document.attachEvent ) {
			// ensure firing before onload,
			// maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", DOMContentLoaded );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", jQuery.ready );

			// If IE and not a frame
			// continually check to see if the document is ready
			var toplevel = false;

			try {
				toplevel = window.frameElement == null;
			} catch(e) {}

			if ( document.documentElement.doScroll && toplevel ) {
				doScrollCheck();
			}
		}
	},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type(obj) === "array";
	},

	isWindow: function( obj ) {
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {
		return !isNaN( parseFloat(obj) ) && isFinite( obj );
	},

	type: function( obj ) {
		return obj == null ?
			String( obj ) :
			class2type[ toString.call(obj) ] || "object";
	},

	isPlainObject: function( obj ) {
		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {
			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call(obj, "constructor") &&
				!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
				return false;
			}
		} catch ( e ) {
			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.

		var key;
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		for ( var name in obj ) {
			return false;
		}
		return true;
	},

	error: function( msg ) {
		throw new Error( msg );
	},

	parseJSON: function( data ) {
		if ( typeof data !== "string" || !data ) {
			return null;
		}

		// Make sure leading/trailing whitespace is removed (IE can't handle it)
		data = jQuery.trim( data );

		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
			return window.JSON.parse( data );
		}

		// Make sure the incoming data is actual JSON
		// Logic borrowed from http://json.org/json2.js
		if ( rvalidchars.test( data.replace( rvalidescape, "@" )
			.replace( rvalidtokens, "]" )
			.replace( rvalidbraces, "")) ) {

			return ( new Function( "return " + data ) )();

		}
		jQuery.error( "Invalid JSON: " + data );
	},

	// Cross-browser xml parsing
	parseXML: function( data ) {
		if ( typeof data !== "string" || !data ) {
			return null;
		}
		var xml, tmp;
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new DOMParser();
				xml = tmp.parseFromString( data , "text/xml" );
			} else { // IE
				xml = new ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	},

	noop: function() {},

	// Evaluates a script in a global context
	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && rnotwhite.test( data ) ) {
			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data );
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase();
	},

	// args is for internal usage only
	each: function( object, callback, args ) {
		var name, i = 0,
			length = object.length,
			isObj = length === undefined || jQuery.isFunction( object );

		if ( args ) {
			if ( isObj ) {
				for ( name in object ) {
					if ( callback.apply( object[ name ], args ) === false ) {
						break;
					}
				}
			} else {
				for ( ; i < length; ) {
					if ( callback.apply( object[ i++ ], args ) === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isObj ) {
				for ( name in object ) {
					if ( callback.call( object[ name ], name, object[ name ] ) === false ) {
						break;
					}
				}
			} else {
				for ( ; i < length; ) {
					if ( callback.call( object[ i ], i, object[ i++ ] ) === false ) {
						break;
					}
				}
			}
		}

		return object;
	},

	// Use native String.trim function wherever possible
	trim: trim ?
		function( text ) {
			return text == null ?
				"" :
				trim.call( text );
		} :

		// Otherwise use our own trimming functionality
		function( text ) {
			return text == null ?
				"" :
				text.toString().replace( trimLeft, "" ).replace( trimRight, "" );
		},

	// results is for internal usage only
	makeArray: function( array, results ) {
		var ret = results || [];

		if ( array != null ) {
			// The window, strings (and functions) also have 'length'
			// Tweaked logic slightly to handle Blackberry 4.7 RegExp issues #6930
			var type = jQuery.type( array );

			if ( array.length == null || type === "string" || type === "function" || type === "regexp" || jQuery.isWindow( array ) ) {
				push.call( ret, array );
			} else {
				jQuery.merge( ret, array );
			}
		}

		return ret;
	},

	inArray: function( elem, array, i ) {
		var len;

		if ( array ) {
			if ( indexOf ) {
				return indexOf.call( array, elem, i );
			}

			len = array.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {
				// Skip accessing in sparse arrays
				if ( i in array && array[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var i = first.length,
			j = 0;

		if ( typeof second.length === "number" ) {
			for ( var l = second.length; j < l; j++ ) {
				first[ i++ ] = second[ j ];
			}

		} else {
			while ( second[j] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, inv ) {
		var ret = [], retVal;
		inv = !!inv;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( var i = 0, length = elems.length; i < length; i++ ) {
			retVal = !!callback( elems[ i ], i );
			if ( inv !== retVal ) {
				ret.push( elems[ i ] );
			}
		}

		return ret;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value, key, ret = [],
			i = 0,
			length = elems.length,
			// jquery objects are treated as arrays
			isArray = elems instanceof jQuery || length !== undefined && typeof length === "number" && ( ( length > 0 && elems[ 0 ] && elems[ length -1 ] ) || length === 0 || jQuery.isArray( elems ) ) ;

		// Go through the array, translating each of the items to their
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret[ ret.length ] = value;
				}
			}

		// Go through every key on the object,
		} else {
			for ( key in elems ) {
				value = callback( elems[ key ], key, arg );

				if ( value != null ) {
					ret[ ret.length ] = value;
				}
			}
		}

		// Flatten any nested arrays
		return ret.concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		if ( typeof context === "string" ) {
			var tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		var args = slice.call( arguments, 2 ),
			proxy = function() {
				return fn.apply( context, args.concat( slice.call( arguments ) ) );
			};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || proxy.guid || jQuery.guid++;

		return proxy;
	},

	// Mutifunctional method to get and set values to a collection
	// The value/s can optionally be executed if it's a function
	access: function( elems, fn, key, value, chainable, emptyGet, pass ) {
		var exec,
			bulk = key == null,
			i = 0,
			length = elems.length;

		// Sets many values
		if ( key && typeof key === "object" ) {
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], 1, emptyGet, value );
			}
			chainable = 1;

		// Sets one value
		} else if ( value !== undefined ) {
			// Optionally, function values get executed if exec is true
			exec = pass === undefined && jQuery.isFunction( value );

			if ( bulk ) {
				// Bulk operations only iterate when executing function values
				if ( exec ) {
					exec = fn;
					fn = function( elem, key, value ) {
						return exec.call( jQuery( elem ), value );
					};

				// Otherwise they run against the entire set
				} else {
					fn.call( elems, value );
					fn = null;
				}
			}

			if ( fn ) {
				for (; i < length; i++ ) {
					fn( elems[i], key, exec ? value.call( elems[i], i, fn( elems[i], key ) ) : value, pass );
				}
			}

			chainable = 1;
		}

		return chainable ?
			elems :

			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[0], key ) : emptyGet;
	},

	now: function() {
		return ( new Date() ).getTime();
	},

	// Use of jQuery.browser is frowned upon.
	// More details: http://docs.jquery.com/Utilities/jQuery.browser
	uaMatch: function( ua ) {
		ua = ua.toLowerCase();

		var match = rwebkit.exec( ua ) ||
			ropera.exec( ua ) ||
			rmsie.exec( ua ) ||
			ua.indexOf("compatible") < 0 && rmozilla.exec( ua ) ||
			[];

		return { browser: match[1] || "", version: match[2] || "0" };
	},

	sub: function() {
		function jQuerySub( selector, context ) {
			return new jQuerySub.fn.init( selector, context );
		}
		jQuery.extend( true, jQuerySub, this );
		jQuerySub.superclass = this;
		jQuerySub.fn = jQuerySub.prototype = this();
		jQuerySub.fn.constructor = jQuerySub;
		jQuerySub.sub = this.sub;
		jQuerySub.fn.init = function init( selector, context ) {
			if ( context && context instanceof jQuery && !(context instanceof jQuerySub) ) {
				context = jQuerySub( context );
			}

			return jQuery.fn.init.call( this, selector, context, rootjQuerySub );
		};
		jQuerySub.fn.init.prototype = jQuerySub.fn;
		var rootjQuerySub = jQuerySub(document);
		return jQuerySub;
	},

	browser: {}
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

browserMatch = jQuery.uaMatch( userAgent );
if ( browserMatch.browser ) {
	jQuery.browser[ browserMatch.browser ] = true;
	jQuery.browser.version = browserMatch.version;
}

// Deprecated, use jQuery.browser.webkit instead
if ( jQuery.browser.webkit ) {
	jQuery.browser.safari = true;
}

// IE doesn't match non-breaking spaces with \s
if ( rnotwhite.test( "\xA0" ) ) {
	trimLeft = /^[\s\xA0]+/;
	trimRight = /[\s\xA0]+$/;
}

// All jQuery objects should point back to these
rootjQuery = jQuery(document);

// Cleanup functions for the document ready method
if ( document.addEventListener ) {
	DOMContentLoaded = function() {
		document.removeEventListener( "DOMContentLoaded", DOMContentLoaded, false );
		jQuery.ready();
	};

} else if ( document.attachEvent ) {
	DOMContentLoaded = function() {
		// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
		if ( document.readyState === "complete" ) {
			document.detachEvent( "onreadystatechange", DOMContentLoaded );
			jQuery.ready();
		}
	};
}

// The DOM ready check for Internet Explorer
function doScrollCheck() {
	if ( jQuery.isReady ) {
		return;
	}

	try {
		// If IE is used, use the trick by Diego Perini
		// http://javascript.nwbox.com/IEContentLoaded/
		document.documentElement.doScroll("left");
	} catch(e) {
		setTimeout( doScrollCheck, 1 );
		return;
	}

	// and execute any waiting functions
	jQuery.ready();
}

return jQuery;

})();


// String to Object flags format cache
var flagsCache = {};

// Convert String-formatted flags into Object-formatted ones and store in cache
function createFlags( flags ) {
	var object = flagsCache[ flags ] = {},
		i, length;
	flags = flags.split( /\s+/ );
	for ( i = 0, length = flags.length; i < length; i++ ) {
		object[ flags[i] ] = true;
	}
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	flags:	an optional list of space-separated flags that will change how
 *			the callback list behaves
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible flags:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( flags ) {

	// Convert flags from String-formatted to Object-formatted
	// (we check in cache first)
	flags = flags ? ( flagsCache[ flags ] || createFlags( flags ) ) : {};

	var // Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = [],
		// Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Add one or several callbacks to the list
		add = function( args ) {
			var i,
				length,
				elem,
				type,
				actual;
			for ( i = 0, length = args.length; i < length; i++ ) {
				elem = args[ i ];
				type = jQuery.type( elem );
				if ( type === "array" ) {
					// Inspect recursively
					add( elem );
				} else if ( type === "function" ) {
					// Add if not in unique mode and callback is not in
					if ( !flags.unique || !self.has( elem ) ) {
						list.push( elem );
					}
				}
			}
		},
		// Fire callbacks
		fire = function( context, args ) {
			args = args || [];
			memory = !flags.memory || [ context, args ];
			fired = true;
			firing = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( context, args ) === false && flags.stopOnFalse ) {
					memory = true; // Mark as halted
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( !flags.once ) {
					if ( stack && stack.length ) {
						memory = stack.shift();
						self.fireWith( memory[ 0 ], memory[ 1 ] );
					}
				} else if ( memory === true ) {
					self.disable();
				} else {
					list = [];
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					var length = list.length;
					add( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away, unless previous
					// firing was halted (stopOnFalse)
					} else if ( memory && memory !== true ) {
						firingStart = length;
						fire( memory[ 0 ], memory[ 1 ] );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					var args = arguments,
						argIndex = 0,
						argLength = args.length;
					for ( ; argIndex < argLength ; argIndex++ ) {
						for ( var i = 0; i < list.length; i++ ) {
							if ( args[ argIndex ] === list[ i ] ) {
								// Handle firingIndex and firingLength
								if ( firing ) {
									if ( i <= firingLength ) {
										firingLength--;
										if ( i <= firingIndex ) {
											firingIndex--;
										}
									}
								}
								// Remove the element
								list.splice( i--, 1 );
								// If we have some unicity property then
								// we only need to do this once
								if ( flags.unique ) {
									break;
								}
							}
						}
					}
				}
				return this;
			},
			// Control if a given callback is in the list
			has: function( fn ) {
				if ( list ) {
					var i = 0,
						length = list.length;
					for ( ; i < length; i++ ) {
						if ( fn === list[ i ] ) {
							return true;
						}
					}
				}
				return false;
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory || memory === true ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( stack ) {
					if ( firing ) {
						if ( !flags.once ) {
							stack.push( [ context, args ] );
						}
					} else if ( !( flags.once && memory ) ) {
						fire( context, args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};




var // Static reference to slice
	sliceDeferred = [].slice;

jQuery.extend({

	Deferred: function( func ) {
		var doneList = jQuery.Callbacks( "once memory" ),
			failList = jQuery.Callbacks( "once memory" ),
			progressList = jQuery.Callbacks( "memory" ),
			state = "pending",
			lists = {
				resolve: doneList,
				reject: failList,
				notify: progressList
			},
			promise = {
				done: doneList.add,
				fail: failList.add,
				progress: progressList.add,

				state: function() {
					return state;
				},

				// Deprecated
				isResolved: doneList.fired,
				isRejected: failList.fired,

				then: function( doneCallbacks, failCallbacks, progressCallbacks ) {
					deferred.done( doneCallbacks ).fail( failCallbacks ).progress( progressCallbacks );
					return this;
				},
				always: function() {
					deferred.done.apply( deferred, arguments ).fail.apply( deferred, arguments );
					return this;
				},
				pipe: function( fnDone, fnFail, fnProgress ) {
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( {
							done: [ fnDone, "resolve" ],
							fail: [ fnFail, "reject" ],
							progress: [ fnProgress, "notify" ]
						}, function( handler, data ) {
							var fn = data[ 0 ],
								action = data[ 1 ],
								returned;
							if ( jQuery.isFunction( fn ) ) {
								deferred[ handler ](function() {
									returned = fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise().then( newDefer.resolve, newDefer.reject, newDefer.notify );
									} else {
										newDefer[ action + "With" ]( this === deferred ? newDefer : this, [ returned ] );
									}
								});
							} else {
								deferred[ handler ]( newDefer[ action ] );
							}
						});
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					if ( obj == null ) {
						obj = promise;
					} else {
						for ( var key in promise ) {
							obj[ key ] = promise[ key ];
						}
					}
					return obj;
				}
			},
			deferred = promise.promise({}),
			key;

		for ( key in lists ) {
			deferred[ key ] = lists[ key ].fire;
			deferred[ key + "With" ] = lists[ key ].fireWith;
		}

		// Handle state
		deferred.done( function() {
			state = "resolved";
		}, failList.disable, progressList.lock ).fail( function() {
			state = "rejected";
		}, doneList.disable, progressList.lock );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( firstParam ) {
		var args = sliceDeferred.call( arguments, 0 ),
			i = 0,
			length = args.length,
			pValues = new Array( length ),
			count = length,
			pCount = length,
			deferred = length <= 1 && firstParam && jQuery.isFunction( firstParam.promise ) ?
				firstParam :
				jQuery.Deferred(),
			promise = deferred.promise();
		function resolveFunc( i ) {
			return function( value ) {
				args[ i ] = arguments.length > 1 ? sliceDeferred.call( arguments, 0 ) : value;
				if ( !( --count ) ) {
					deferred.resolveWith( deferred, args );
				}
			};
		}
		function progressFunc( i ) {
			return function( value ) {
				pValues[ i ] = arguments.length > 1 ? sliceDeferred.call( arguments, 0 ) : value;
				deferred.notifyWith( promise, pValues );
			};
		}
		if ( length > 1 ) {
			for ( ; i < length; i++ ) {
				if ( args[ i ] && args[ i ].promise && jQuery.isFunction( args[ i ].promise ) ) {
					args[ i ].promise().then( resolveFunc(i), deferred.reject, progressFunc(i) );
				} else {
					--count;
				}
			}
			if ( !count ) {
				deferred.resolveWith( deferred, args );
			}
		} else if ( deferred !== firstParam ) {
			deferred.resolveWith( deferred, length ? [ firstParam ] : [] );
		}
		return promise;
	}
});




jQuery.support = (function() {

	var support,
		all,
		a,
		select,
		opt,
		input,
		fragment,
		tds,
		events,
		eventName,
		i,
		isSupported,
		div = document.createElement( "div" ),
		documentElement = document.documentElement;

	// Preliminary tests
	div.setAttribute("className", "t");
	div.innerHTML = "   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/>";

	all = div.getElementsByTagName( "*" );
	a = div.getElementsByTagName( "a" )[ 0 ];

	// Can't get basic test support
	if ( !all || !all.length || !a ) {
		return {};
	}

	// First batch of supports tests
	select = document.createElement( "select" );
	opt = select.appendChild( document.createElement("option") );
	input = div.getElementsByTagName( "input" )[ 0 ];

	support = {
		// IE strips leading whitespace when .innerHTML is used
		leadingWhitespace: ( div.firstChild.nodeType === 3 ),

		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		tbody: !div.getElementsByTagName("tbody").length,

		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		htmlSerialize: !!div.getElementsByTagName("link").length,

		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		style: /top/.test( a.getAttribute("style") ),

		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		hrefNormalized: ( a.getAttribute("href") === "/a" ),

		// Make sure that element opacity exists
		// (IE uses filter instead)
		// Use a regex to work around a WebKit issue. See #5145
		opacity: /^0.55/.test( a.style.opacity ),

		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		cssFloat: !!a.style.cssFloat,

		// Make sure that if no value is specified for a checkbox
		// that it defaults to "on".
		// (WebKit defaults to "" instead)
		checkOn: ( input.value === "on" ),

		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		optSelected: opt.selected,

		// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		getSetAttribute: div.className !== "t",

		// Tests for enctype support on a form(#6743)
		enctype: !!document.createElement("form").enctype,

		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		html5Clone: document.createElement("nav").cloneNode( true ).outerHTML !== "<:nav></:nav>",

		// Will be defined later
		submitBubbles: true,
		changeBubbles: true,
		focusinBubbles: false,
		deleteExpando: true,
		noCloneEvent: true,
		inlineBlockNeedsLayout: false,
		shrinkWrapBlocks: false,
		reliableMarginRight: true,
		pixelMargin: true
	};

	// jQuery.boxModel DEPRECATED in 1.3, use jQuery.support.boxModel instead
	jQuery.boxModel = support.boxModel = (document.compatMode === "CSS1Compat");

	// Make sure checked status is properly cloned
	input.checked = true;
	support.noCloneChecked = input.cloneNode( true ).checked;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Test to see if it's possible to delete an expando from an element
	// Fails in Internet Explorer
	try {
		delete div.test;
	} catch( e ) {
		support.deleteExpando = false;
	}

	if ( !div.addEventListener && div.attachEvent && div.fireEvent ) {
		div.attachEvent( "onclick", function() {
			// Cloning a node shouldn't copy over any
			// bound event handlers (IE does this)
			support.noCloneEvent = false;
		});
		div.cloneNode( true ).fireEvent( "onclick" );
	}

	// Check if a radio maintains its value
	// after being appended to the DOM
	input = document.createElement("input");
	input.value = "t";
	input.setAttribute("type", "radio");
	support.radioValue = input.value === "t";

	input.setAttribute("checked", "checked");

	// #11217 - WebKit loses check when the name is after the checked attribute
	input.setAttribute( "name", "t" );

	div.appendChild( input );
	fragment = document.createDocumentFragment();
	fragment.appendChild( div.lastChild );

	// WebKit doesn't clone checked state correctly in fragments
	support.checkClone = fragment.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	support.appendChecked = input.checked;

	fragment.removeChild( input );
	fragment.appendChild( div );

	// Technique from Juriy Zaytsev
	// http://perfectionkills.com/detecting-event-support-without-browser-sniffing/
	// We only care about the case where non-standard event systems
	// are used, namely in IE. Short-circuiting here helps us to
	// avoid an eval call (in setAttribute) which can cause CSP
	// to go haywire. See: https://developer.mozilla.org/en/Security/CSP
	if ( div.attachEvent ) {
		for ( i in {
			submit: 1,
			change: 1,
			focusin: 1
		}) {
			eventName = "on" + i;
			isSupported = ( eventName in div );
			if ( !isSupported ) {
				div.setAttribute( eventName, "return;" );
				isSupported = ( typeof div[ eventName ] === "function" );
			}
			support[ i + "Bubbles" ] = isSupported;
		}
	}

	fragment.removeChild( div );

	// Null elements to avoid leaks in IE
	fragment = select = opt = div = input = null;

	// Run tests that need a body at doc ready
	jQuery(function() {
		var container, outer, inner, table, td, offsetSupport,
			marginDiv, conMarginTop, style, html, positionTopLeftWidthHeight,
			paddingMarginBorderVisibility, paddingMarginBorder,
			body = document.getElementsByTagName("body")[0];

		if ( !body ) {
			// Return for frameset docs that don't have a body
			return;
		}

		conMarginTop = 1;
		paddingMarginBorder = "padding:0;margin:0;border:";
		positionTopLeftWidthHeight = "position:absolute;top:0;left:0;width:1px;height:1px;";
		paddingMarginBorderVisibility = paddingMarginBorder + "0;visibility:hidden;";
		style = "style='" + positionTopLeftWidthHeight + paddingMarginBorder + "5px solid #000;";
		html = "<div " + style + "display:block;'><div style='" + paddingMarginBorder + "0;display:block;overflow:hidden;'></div></div>" +
			"<table " + style + "' cellpadding='0' cellspacing='0'>" +
			"<tr><td></td></tr></table>";

		container = document.createElement("div");
		container.style.cssText = paddingMarginBorderVisibility + "width:0;height:0;position:static;top:0;margin-top:" + conMarginTop + "px";
		body.insertBefore( container, body.firstChild );

		// Construct the test element
		div = document.createElement("div");
		container.appendChild( div );

		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		// (only IE 8 fails this test)
		div.innerHTML = "<table><tr><td style='" + paddingMarginBorder + "0;display:none'></td><td>t</td></tr></table>";
		tds = div.getElementsByTagName( "td" );
		isSupported = ( tds[ 0 ].offsetHeight === 0 );

		tds[ 0 ].style.display = "";
		tds[ 1 ].style.display = "none";

		// Check if empty table cells still have offsetWidth/Height
		// (IE <= 8 fail this test)
		support.reliableHiddenOffsets = isSupported && ( tds[ 0 ].offsetHeight === 0 );

		// Check if div with explicit width and no margin-right incorrectly
		// gets computed margin-right based on width of container. For more
		// info see bug #3333
		// Fails in WebKit before Feb 2011 nightlies
		// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
		if ( window.getComputedStyle ) {
			div.innerHTML = "";
			marginDiv = document.createElement( "div" );
			marginDiv.style.width = "0";
			marginDiv.style.marginRight = "0";
			div.style.width = "2px";
			div.appendChild( marginDiv );
			support.reliableMarginRight =
				( parseInt( ( window.getComputedStyle( marginDiv, null ) || { marginRight: 0 } ).marginRight, 10 ) || 0 ) === 0;
		}

		if ( typeof div.style.zoom !== "undefined" ) {
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			// (IE < 8 does this)
			div.innerHTML = "";
			div.style.width = div.style.padding = "1px";
			div.style.border = 0;
			div.style.overflow = "hidden";
			div.style.display = "inline";
			div.style.zoom = 1;
			support.inlineBlockNeedsLayout = ( div.offsetWidth === 3 );

			// Check if elements with layout shrink-wrap their children
			// (IE 6 does this)
			div.style.display = "block";
			div.style.overflow = "visible";
			div.innerHTML = "<div style='width:5px;'></div>";
			support.shrinkWrapBlocks = ( div.offsetWidth !== 3 );
		}

		div.style.cssText = positionTopLeftWidthHeight + paddingMarginBorderVisibility;
		div.innerHTML = html;

		outer = div.firstChild;
		inner = outer.firstChild;
		td = outer.nextSibling.firstChild.firstChild;

		offsetSupport = {
			doesNotAddBorder: ( inner.offsetTop !== 5 ),
			doesAddBorderForTableAndCells: ( td.offsetTop === 5 )
		};

		inner.style.position = "fixed";
		inner.style.top = "20px";

		// safari subtracts parent border width here which is 5px
		offsetSupport.fixedPosition = ( inner.offsetTop === 20 || inner.offsetTop === 15 );
		inner.style.position = inner.style.top = "";

		outer.style.overflow = "hidden";
		outer.style.position = "relative";

		offsetSupport.subtractsBorderForOverflowNotVisible = ( inner.offsetTop === -5 );
		offsetSupport.doesNotIncludeMarginInBodyOffset = ( body.offsetTop !== conMarginTop );

		if ( window.getComputedStyle ) {
			div.style.marginTop = "1%";
			support.pixelMargin = ( window.getComputedStyle( div, null ) || { marginTop: 0 } ).marginTop !== "1%";
		}

		if ( typeof container.style.zoom !== "undefined" ) {
			container.style.zoom = 1;
		}

		body.removeChild( container );
		marginDiv = div = container = null;

		jQuery.extend( support, offsetSupport );
	});

	return support;
})();




var rbrace = /^(?:\{.*\}|\[.*\])$/,
	rmultiDash = /([A-Z])/g;

jQuery.extend({
	cache: {},

	// Please use with caution
	uuid: 0,

	// Unique for each copy of jQuery on the page
	// Non-digits removed to match rinlinejQuery
	expando: "jQuery" + ( jQuery.fn.jquery + Math.random() ).replace( /\D/g, "" ),

	// The following elements throw uncatchable exceptions if you
	// attempt to add expando properties to them.
	noData: {
		"embed": true,
		// Ban all objects except for Flash (which handle expandos)
		"object": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
		"applet": true
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}

		var privateCache, thisCache, ret,
			internalKey = jQuery.expando,
			getByName = typeof name === "string",

			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,

			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,

			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey,
			isEvents = name === "events";

		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( (!id || !cache[id] || (!isEvents && !pvt && !cache[id].data)) && getByName && data === undefined ) {
			return;
		}

		if ( !id ) {
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				elem[ internalKey ] = id = ++jQuery.uuid;
			} else {
				id = internalKey;
			}
		}

		if ( !cache[ id ] ) {
			cache[ id ] = {};

			// Avoids exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			if ( !isNode ) {
				cache[ id ].toJSON = jQuery.noop;
			}
		}

		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}

		privateCache = thisCache = cache[ id ];

		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}

			thisCache = thisCache.data;
		}

		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}

		// Users should not attempt to inspect the internal events object using jQuery.data,
		// it is undocumented and subject to change. But does anyone listen? No.
		if ( isEvents && !thisCache[ name ] ) {
			return privateCache.events;
		}

		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( getByName ) {

			// First Try to find as-is property data
			ret = thisCache[ name ];

			// Test for null|undefined property data
			if ( ret == null ) {

				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}

		return ret;
	},

	removeData: function( elem, name, pvt /* Internal Use Only */ ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}

		var thisCache, i, l,

			// Reference to internal data cache key
			internalKey = jQuery.expando,

			isNode = elem.nodeType,

			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,

			// See jQuery.data for more information
			id = isNode ? elem[ internalKey ] : internalKey;

		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}

		if ( name ) {

			thisCache = pvt ? cache[ id ] : cache[ id ].data;

			if ( thisCache ) {

				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {

					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {

						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split( " " );
						}
					}
				}

				for ( i = 0, l = name.length; i < l; i++ ) {
					delete thisCache[ name[i] ];
				}

				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( !( pvt ? isEmptyDataObject : jQuery.isEmptyObject )( thisCache ) ) {
					return;
				}
			}
		}

		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;

			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject(cache[ id ]) ) {
				return;
			}
		}

		// Browsers that fail expando deletion also refuse to delete expandos on
		// the window, but it will allow it on all other JS objects; other browsers
		// don't care
		// Ensure that `cache` is not a window object #10080
		if ( jQuery.support.deleteExpando || !cache.setInterval ) {
			delete cache[ id ];
		} else {
			cache[ id ] = null;
		}

		// We destroyed the cache and need to eliminate the expando on the node to avoid
		// false lookups in the cache for entries that no longer exist
		if ( isNode ) {
			// IE does not allow us to delete expando properties from nodes,
			// nor does it have a removeAttribute function on Document nodes;
			// we must handle all of these cases
			if ( jQuery.support.deleteExpando ) {
				delete elem[ internalKey ];
			} else if ( elem.removeAttribute ) {
				elem.removeAttribute( internalKey );
			} else {
				elem[ internalKey ] = null;
			}
		}
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return jQuery.data( elem, name, data, true );
	},

	// A method for determining if a DOM node can handle the data expando
	acceptData: function( elem ) {
		if ( elem.nodeName ) {
			var match = jQuery.noData[ elem.nodeName.toLowerCase() ];

			if ( match ) {
				return !(match === true || elem.getAttribute("classid") !== match);
			}
		}

		return true;
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var parts, part, attr, name, l,
			elem = this[0],
			i = 0,
			data = null;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					attr = elem.attributes;
					for ( l = attr.length; i < l; i++ ) {
						name = attr[i].name;

						if ( name.indexOf( "data-" ) === 0 ) {
							name = jQuery.camelCase( name.substring(5) );

							dataAttr( elem, name, data[ name ] );
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				jQuery.data( this, key );
			});
		}

		parts = key.split( ".", 2 );
		parts[1] = parts[1] ? "." + parts[1] : "";
		part = parts[1] + "!";

		return jQuery.access( this, function( value ) {

			if ( value === undefined ) {
				data = this.triggerHandler( "getData" + part, [ parts[0] ] );

				// Try to fetch any internally stored data first
				if ( data === undefined && elem ) {
					data = jQuery.data( elem, key );
					data = dataAttr( elem, key, data );
				}

				return data === undefined && parts[1] ?
					this.data( parts[0] ) :
					data;
			}

			parts[1] = value;
			this.each(function() {
				var self = jQuery( this );

				self.triggerHandler( "setData" + part, parts );
				jQuery.data( this, key, value );
				self.triggerHandler( "changeData" + part, parts );
			});
		}, null, value, arguments.length > 1, null, false );
	},

	removeData: function( key ) {
		return this.each(function() {
			jQuery.removeData( this, key );
		});
	}
});

function dataAttr( elem, key, data ) {
	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
				data === "false" ? false :
				data === "null" ? null :
				jQuery.isNumeric( data ) ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	for ( var name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}




function handleQueueMarkDefer( elem, type, src ) {
	var deferDataKey = type + "defer",
		queueDataKey = type + "queue",
		markDataKey = type + "mark",
		defer = jQuery._data( elem, deferDataKey );
	if ( defer &&
		( src === "queue" || !jQuery._data(elem, queueDataKey) ) &&
		( src === "mark" || !jQuery._data(elem, markDataKey) ) ) {
		// Give room for hard-coded callbacks to fire first
		// and eventually mark/queue something else on the element
		setTimeout( function() {
			if ( !jQuery._data( elem, queueDataKey ) &&
				!jQuery._data( elem, markDataKey ) ) {
				jQuery.removeData( elem, deferDataKey, true );
				defer.fire();
			}
		}, 0 );
	}
}

jQuery.extend({

	_mark: function( elem, type ) {
		if ( elem ) {
			type = ( type || "fx" ) + "mark";
			jQuery._data( elem, type, (jQuery._data( elem, type ) || 0) + 1 );
		}
	},

	_unmark: function( force, elem, type ) {
		if ( force !== true ) {
			type = elem;
			elem = force;
			force = false;
		}
		if ( elem ) {
			type = type || "fx";
			var key = type + "mark",
				count = force ? 0 : ( (jQuery._data( elem, key ) || 1) - 1 );
			if ( count ) {
				jQuery._data( elem, key, count );
			} else {
				jQuery.removeData( elem, key, true );
				handleQueueMarkDefer( elem, type, "mark" );
			}
		}
	},

	queue: function( elem, type, data ) {
		var q;
		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			q = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !q || jQuery.isArray(data) ) {
					q = jQuery._data( elem, type, jQuery.makeArray(data) );
				} else {
					q.push( data );
				}
			}
			return q || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			fn = queue.shift(),
			hooks = {};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
		}

		if ( fn ) {
			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			jQuery._data( elem, type + ".run", hooks );
			fn.call( elem, function() {
				jQuery.dequeue( elem, type );
			}, hooks );
		}

		if ( !queue.length ) {
			jQuery.removeData( elem, type + "queue " + type + ".run", true );
			handleQueueMarkDefer( elem, type, "queue" );
		}
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	delay: function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";

		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, object ) {
		if ( typeof type !== "string" ) {
			object = type;
			type = undefined;
		}
		type = type || "fx";
		var defer = jQuery.Deferred(),
			elements = this,
			i = elements.length,
			count = 1,
			deferDataKey = type + "defer",
			queueDataKey = type + "queue",
			markDataKey = type + "mark",
			tmp;
		function resolve() {
			if ( !( --count ) ) {
				defer.resolveWith( elements, [ elements ] );
			}
		}
		while( i-- ) {
			if (( tmp = jQuery.data( elements[ i ], deferDataKey, undefined, true ) ||
					( jQuery.data( elements[ i ], queueDataKey, undefined, true ) ||
						jQuery.data( elements[ i ], markDataKey, undefined, true ) ) &&
					jQuery.data( elements[ i ], deferDataKey, jQuery.Callbacks( "once memory" ), true ) )) {
				count++;
				tmp.add( resolve );
			}
		}
		resolve();
		return defer.promise( object );
	}
});




var rclass = /[\n\t\r]/g,
	rspace = /\s+/,
	rreturn = /\r/g,
	rtype = /^(?:button|input)$/i,
	rfocusable = /^(?:button|input|object|select|textarea)$/i,
	rclickable = /^a(?:rea)?$/i,
	rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
	getSetAttribute = jQuery.support.getSetAttribute,
	nodeHook, boolHook, fixSpecified;

jQuery.fn.extend({
	attr: function( name, value ) {
		return jQuery.access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	},

	prop: function( name, value ) {
		return jQuery.access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each(function() {
			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch( e ) {}
		});
	},

	addClass: function( value ) {
		var classNames, i, l, elem,
			setClass, c, cl;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call(this, j, this.className) );
			});
		}

		if ( value && typeof value === "string" ) {
			classNames = value.split( rspace );

			for ( i = 0, l = this.length; i < l; i++ ) {
				elem = this[ i ];

				if ( elem.nodeType === 1 ) {
					if ( !elem.className && classNames.length === 1 ) {
						elem.className = value;

					} else {
						setClass = " " + elem.className + " ";

						for ( c = 0, cl = classNames.length; c < cl; c++ ) {
							if ( !~setClass.indexOf( " " + classNames[ c ] + " " ) ) {
								setClass += classNames[ c ] + " ";
							}
						}
						elem.className = jQuery.trim( setClass );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, i, l, elem, className, c, cl;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call(this, j, this.className) );
			});
		}

		if ( (value && typeof value === "string") || value === undefined ) {
			classNames = ( value || "" ).split( rspace );

			for ( i = 0, l = this.length; i < l; i++ ) {
				elem = this[ i ];

				if ( elem.nodeType === 1 && elem.className ) {
					if ( value ) {
						className = (" " + elem.className + " ").replace( rclass, " " );
						for ( c = 0, cl = classNames.length; c < cl; c++ ) {
							className = className.replace(" " + classNames[ c ] + " ", " ");
						}
						elem.className = jQuery.trim( className );

					} else {
						elem.className = "";
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isBool = typeof stateVal === "boolean";

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					state = stateVal,
					classNames = value.split( rspace );

				while ( (className = classNames[ i++ ]) ) {
					// check each className given, space seperated list
					state = isBool ? state : !self.hasClass( className );
					self[ state ? "addClass" : "removeClass" ]( className );
				}

			} else if ( type === "undefined" || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					jQuery._data( this, "__className__", this.className );
				}

				// toggle whole className
				this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	},

	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// handle most common string cases
					ret.replace(rreturn, "") :
					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var self = jQuery(this), val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, self.val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map(val, function ( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				// attributes.value is undefined in Blackberry 4.7 but
				// uses .value. See #6932
				var val = elem.attributes.value;
				return !val || val.specified ? elem.value : elem.text;
			}
		},
		select: {
			get: function( elem ) {
				var value, i, max, option,
					index = elem.selectedIndex,
					values = [],
					options = elem.options,
					one = elem.type === "select-one";

				// Nothing was selected
				if ( index < 0 ) {
					return null;
				}

				// Loop through all the selected options
				i = one ? index : 0;
				max = one ? index + 1 : options.length;
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Don't return options that are disabled or in a disabled optgroup
					if ( option.selected && (jQuery.support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) &&
							(!option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" )) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				// Fixes Bug #2551 -- select.val() broken in IE after form.reset()
				if ( one && !values.length && options.length ) {
					return jQuery( options[ index ] ).val();
				}

				return values;
			},

			set: function( elem, value ) {
				var values = jQuery.makeArray( value );

				jQuery(elem).find("option").each(function() {
					this.selected = jQuery.inArray( jQuery(this).val(), values ) >= 0;
				});

				if ( !values.length ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	},

	attrFn: {
		val: true,
		css: true,
		html: true,
		text: true,
		data: true,
		width: true,
		height: true,
		offset: true
	},

	attr: function( elem, name, value, pass ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( pass && name in jQuery.attrFn ) {
			return jQuery( elem )[ name ]( value );
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( notxml ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] || ( rboolean.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;

			} else if ( hooks && "set" in hooks && notxml && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, "" + value );
				return value;
			}

		} else if ( hooks && "get" in hooks && notxml && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {

			ret = elem.getAttribute( name );

			// Non-existent attributes return null, we normalize to undefined
			return ret === null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var propName, attrNames, name, l, isBool,
			i = 0;

		if ( value && elem.nodeType === 1 ) {
			attrNames = value.toLowerCase().split( rspace );
			l = attrNames.length;

			for ( ; i < l; i++ ) {
				name = attrNames[ i ];

				if ( name ) {
					propName = jQuery.propFix[ name ] || name;
					isBool = rboolean.test( name );

					// See #9699 for explanation of this approach (setting first, then removal)
					// Do not do this for boolean attributes (see #10870)
					if ( !isBool ) {
						jQuery.attr( elem, name, "" );
					}
					elem.removeAttribute( getSetAttribute ? name : propName );

					// Set corresponding property to false for boolean attributes
					if ( isBool && propName in elem ) {
						elem[ propName ] = false;
					}
				}
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				// We can't allow the type property to be changed (since it causes problems in IE)
				if ( rtype.test( elem.nodeName ) && elem.parentNode ) {
					jQuery.error( "type property can't be changed" );
				} else if ( !jQuery.support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
					// Setting the type on a radio button after the value resets the value in IE6-9
					// Reset value to it's default in case type is set after value
					// This is for element creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		},
		// Use the value property for back compat
		// Use the nodeHook for button elements in IE6/7 (#1954)
		value: {
			get: function( elem, name ) {
				if ( nodeHook && jQuery.nodeName( elem, "button" ) ) {
					return nodeHook.get( elem, name );
				}
				return name in elem ?
					elem.value :
					null;
			},
			set: function( elem, value, name ) {
				if ( nodeHook && jQuery.nodeName( elem, "button" ) ) {
					return nodeHook.set( elem, value, name );
				}
				// Does not return so that setAttribute is also used
				elem.value = value;
			}
		}
	},

	propFix: {
		tabindex: "tabIndex",
		readonly: "readOnly",
		"for": "htmlFor",
		"class": "className",
		maxlength: "maxLength",
		cellspacing: "cellSpacing",
		cellpadding: "cellPadding",
		rowspan: "rowSpan",
		colspan: "colSpan",
		usemap: "useMap",
		frameborder: "frameBorder",
		contenteditable: "contentEditable"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				return ( elem[ name ] = value );
			}

		} else {
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;

			} else {
				return elem[ name ];
			}
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				var attributeNode = elem.getAttributeNode("tabindex");

				return attributeNode && attributeNode.specified ?
					parseInt( attributeNode.value, 10 ) :
					rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
						0 :
						undefined;
			}
		}
	}
});

// Add the tabIndex propHook to attrHooks for back-compat (different case is intentional)
jQuery.attrHooks.tabindex = jQuery.propHooks.tabIndex;

// Hook for boolean attributes
boolHook = {
	get: function( elem, name ) {
		// Align boolean attributes with corresponding properties
		// Fall back to attribute presence where some booleans are not supported
		var attrNode,
			property = jQuery.prop( elem, name );
		return property === true || typeof property !== "boolean" && ( attrNode = elem.getAttributeNode(name) ) && attrNode.nodeValue !== false ?
			name.toLowerCase() :
			undefined;
	},
	set: function( elem, value, name ) {
		var propName;
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			// value is true since we know at this point it's type boolean and not false
			// Set boolean attributes to the same name and set the DOM property
			propName = jQuery.propFix[ name ] || name;
			if ( propName in elem ) {
				// Only set the IDL specifically if it already exists on the element
				elem[ propName ] = true;
			}

			elem.setAttribute( name, name.toLowerCase() );
		}
		return name;
	}
};

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	fixSpecified = {
		name: true,
		id: true,
		coords: true
	};

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret;
			ret = elem.getAttributeNode( name );
			return ret && ( fixSpecified[ name ] ? ret.nodeValue !== "" : ret.specified ) ?
				ret.nodeValue :
				undefined;
		},
		set: function( elem, value, name ) {
			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				ret = document.createAttribute( name );
				elem.setAttributeNode( ret );
			}
			return ( ret.nodeValue = value + "" );
		}
	};

	// Apply the nodeHook to tabindex
	jQuery.attrHooks.tabindex.set = nodeHook.set;

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each([ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = jQuery.extend( jQuery.attrHooks[ name ], {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		});
	});

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		get: nodeHook.get,
		set: function( elem, value, name ) {
			if ( value === "" ) {
				value = "false";
			}
			nodeHook.set( elem, value, name );
		}
	};
}


// Some attributes require a special call on IE
if ( !jQuery.support.hrefNormalized ) {
	jQuery.each([ "href", "src", "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = jQuery.extend( jQuery.attrHooks[ name ], {
			get: function( elem ) {
				var ret = elem.getAttribute( name, 2 );
				return ret === null ? undefined : ret;
			}
		});
	});
}

if ( !jQuery.support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {
			// Return undefined in the case of empty string
			// Normalize to lowercase since IE uppercases css property names
			return elem.style.cssText.toLowerCase() || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = "" + value );
		}
	};
}

// Safari mis-reports the default selected property of an option
// Accessing the parent's selectedIndex property fixes it
if ( !jQuery.support.optSelected ) {
	jQuery.propHooks.selected = jQuery.extend( jQuery.propHooks.selected, {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		}
	});
}

// IE6/7 call enctype encoding
if ( !jQuery.support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}

// Radios and checkboxes getter/setter
if ( !jQuery.support.checkOn ) {
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			get: function( elem ) {
				// Handle the case where in Webkit "" is returned instead of "on" if a value isn't specified
				return elem.getAttribute("value") === null ? "on" : elem.value;
			}
		};
	});
}
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = jQuery.extend( jQuery.valHooks[ this ], {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	});
});




var rformElems = /^(?:textarea|input|select)$/i,
	rtypenamespace = /^([^\.]*)?(?:\.(.+))?$/,
	rhoverHack = /(?:^|\s)hover(\.\S+)?\b/,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rquickIs = /^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,
	quickParse = function( selector ) {
		var quick = rquickIs.exec( selector );
		if ( quick ) {
			//   0  1    2   3
			// [ _, tag, id, class ]
			quick[1] = ( quick[1] || "" ).toLowerCase();
			quick[3] = quick[3] && new RegExp( "(?:^|\\s)" + quick[3] + "(?:\\s|$)" );
		}
		return quick;
	},
	quickIs = function( elem, m ) {
		var attrs = elem.attributes || {};
		return (
			(!m[1] || elem.nodeName.toLowerCase() === m[1]) &&
			(!m[2] || (attrs.id || {}).value === m[2]) &&
			(!m[3] || m[3].test( (attrs[ "class" ] || {}).value ))
		);
	},
	hoverHack = function( events ) {
		return jQuery.event.special.hover ? events : events.replace( rhoverHack, "mouseenter$1 mouseleave$1" );
	};

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	add: function( elem, types, handler, data, selector ) {

		var elemData, eventHandle, events,
			t, tns, type, namespaces, handleObj,
			handleObjIn, quick, handlers, special;

		// Don't attach events to noData or text/comment nodes (allow plain objects tho)
		if ( elem.nodeType === 3 || elem.nodeType === 8 || !types || !handler || !(elemData = jQuery._data( elem )) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		events = elemData.events;
		if ( !events ) {
			elemData.events = events = {};
		}
		eventHandle = elemData.handle;
		if ( !eventHandle ) {
			elemData.handle = eventHandle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && (!e || jQuery.event.triggered !== e.type) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};
			// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		// jQuery(...).bind("mouseover mouseout", fn);
		types = jQuery.trim( hoverHack(types) ).split( " " );
		for ( t = 0; t < types.length; t++ ) {

			tns = rtypenamespace.exec( types[t] ) || [];
			type = tns[1];
			namespaces = ( tns[2] || "" ).split( "." ).sort();

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: tns[1],
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				quick: selector && quickParse( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			handlers = events[ type ];
			if ( !handlers ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	global: {},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var elemData = jQuery.hasData( elem ) && jQuery._data( elem ),
			t, tns, type, origType, namespaces, origCount,
			j, events, special, handle, eventType, handleObj;

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = jQuery.trim( hoverHack( types || "" ) ).split(" ");
		for ( t = 0; t < types.length; t++ ) {
			tns = rtypenamespace.exec( types[t] ) || [];
			type = origType = tns[1];
			namespaces = tns[2];

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector? special.delegateType : special.bindType ) || type;
			eventType = events[ type ] || [];
			origCount = eventType.length;
			namespaces = namespaces ? new RegExp("(^|\\.)" + namespaces.split(".").sort().join("\\.(?:.*\\.)?") + "(\\.|$)") : null;

			// Remove matching events
			for ( j = 0; j < eventType.length; j++ ) {
				handleObj = eventType[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					 ( !handler || handler.guid === handleObj.guid ) &&
					 ( !namespaces || namespaces.test( handleObj.namespace ) ) &&
					 ( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					eventType.splice( j--, 1 );

					if ( handleObj.selector ) {
						eventType.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( eventType.length === 0 && origCount !== eventType.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			handle = elemData.handle;
			if ( handle ) {
				handle.elem = null;
			}

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery.removeData( elem, [ "events", "handle" ], true );
		}
	},

	// Events that are safe to short-circuit if no handlers are attached.
	// Native DOM events should not be added, they may have inline handlers.
	customEvent: {
		"getData": true,
		"setData": true,
		"changeData": true
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		// Don't do events on text and comment nodes
		if ( elem && (elem.nodeType === 3 || elem.nodeType === 8) ) {
			return;
		}

		// Event object or event type
		var type = event.type || event,
			namespaces = [],
			cache, exclusive, i, cur, old, ontype, special, handle, eventPath, bubbleType;

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "!" ) >= 0 ) {
			// Exclusive events trigger only for the exact event (no namespaces)
			type = type.slice(0, -1);
			exclusive = true;
		}

		if ( type.indexOf( "." ) >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}

		if ( (!elem || jQuery.event.customEvent[ type ]) && !jQuery.event.global[ type ] ) {
			// No jQuery handlers for this event type, and it can't have inline handlers
			return;
		}

		// Caller can pass in an Event, Object, or just an event type string
		event = typeof event === "object" ?
			// jQuery.Event object
			event[ jQuery.expando ] ? event :
			// Object literal
			new jQuery.Event( type, event ) :
			// Just the event type (string)
			new jQuery.Event( type );

		event.type = type;
		event.isTrigger = true;
		event.exclusive = exclusive;
		event.namespace = namespaces.join( "." );
		event.namespace_re = event.namespace? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.)?") + "(\\.|$)") : null;
		ontype = type.indexOf( ":" ) < 0 ? "on" + type : "";

		// Handle a global trigger
		if ( !elem ) {

			// TODO: Stop taunting the data cache; remove global events and always attach to document
			cache = jQuery.cache;
			for ( i in cache ) {
				if ( cache[ i ].events && cache[ i ].events[ type ] ) {
					jQuery.event.trigger( event, data, cache[ i ].handle.elem, true );
				}
			}
			return;
		}

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data != null ? jQuery.makeArray( data ) : [];
		data.unshift( event );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		eventPath = [[ elem, special.bindType || type ]];
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			cur = rfocusMorph.test( bubbleType + type ) ? elem : elem.parentNode;
			old = null;
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push([ cur, bubbleType ]);
				old = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( old && old === elem.ownerDocument ) {
				eventPath.push([ old.defaultView || old.parentWindow || window, bubbleType ]);
			}
		}

		// Fire handlers on the event path
		for ( i = 0; i < eventPath.length && !event.isPropagationStopped(); i++ ) {

			cur = eventPath[i][0];
			event.type = eventPath[i][1];

			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}
			// Note that this is a bare JS function and not a jQuery handler
			handle = ontype && cur[ ontype ];
			if ( handle && jQuery.acceptData( cur ) && handle.apply( cur, data ) === false ) {
				event.preventDefault();
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( elem.ownerDocument, data ) === false) &&
				!(type === "click" && jQuery.nodeName( elem, "a" )) && jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				// IE<9 dies on focus/blur to hidden element (#1486)
				if ( ontype && elem[ type ] && ((type !== "focus" && type !== "blur") || event.target.offsetWidth !== 0) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					old = elem[ ontype ];

					if ( old ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( old ) {
						elem[ ontype ] = old;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event || window.event );

		var handlers = ( (jQuery._data( this, "events" ) || {} )[ event.type ] || []),
			delegateCount = handlers.delegateCount,
			args = [].slice.call( arguments, 0 ),
			run_all = !event.exclusive && !event.namespace,
			special = jQuery.event.special[ event.type ] || {},
			handlerQueue = [],
			i, j, cur, jqcur, ret, selMatch, matched, matches, handleObj, sel, related;

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers that should run if there are delegated events
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && !(event.button && event.type === "click") ) {

			// Pregenerate a single jQuery object for reuse with .is()
			jqcur = jQuery(this);
			jqcur.context = this.ownerDocument || this;

			for ( cur = event.target; cur != this; cur = cur.parentNode || this ) {

				// Don't process events on disabled elements (#6911, #8165)
				if ( cur.disabled !== true ) {
					selMatch = {};
					matches = [];
					jqcur[0] = cur;
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];
						sel = handleObj.selector;

						if ( selMatch[ sel ] === undefined ) {
							selMatch[ sel ] = (
								handleObj.quick ? quickIs( cur, handleObj.quick ) : jqcur.is( sel )
							);
						}
						if ( selMatch[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, matches: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( handlers.length > delegateCount ) {
			handlerQueue.push({ elem: this, matches: handlers.slice( delegateCount ) });
		}

		// Run delegates first; they may want to stop propagation beneath us
		for ( i = 0; i < handlerQueue.length && !event.isPropagationStopped(); i++ ) {
			matched = handlerQueue[ i ];
			event.currentTarget = matched.elem;

			for ( j = 0; j < matched.matches.length && !event.isImmediatePropagationStopped(); j++ ) {
				handleObj = matched.matches[ j ];

				// Triggered event must either 1) be non-exclusive and have no namespace, or
				// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
				if ( run_all || (!event.namespace && !handleObj.namespace) || event.namespace_re && event.namespace_re.test( handleObj.namespace ) ) {

					event.data = handleObj.data;
					event.handleObj = handleObj;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						event.result = ret;
						if ( ret === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	// *** attrChange attrName relatedNode srcElement  are not normalized, non-W3C, deprecated, will be removed in 1.8 ***
	props: "attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop,
			originalEvent = event,
			fixHook = jQuery.event.fixHooks[ event.type ] || {},
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = jQuery.Event( originalEvent );

		for ( i = copy.length; i; ) {
			prop = copy[ --i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Fix target property, if necessary (#1925, IE 6/7/8 & Safari2)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Target should not be a text node (#504, Safari)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// For mouse/key events; add metaKey if it's not there (#3368, IE6/7/8)
		if ( event.metaKey === undefined ) {
			event.metaKey = event.ctrlKey;
		}

		return fixHook.filter? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		ready: {
			// Make sure the ready event is setup
			setup: jQuery.bindReady
		},

		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},

		focus: {
			delegateType: "focusin"
		},
		blur: {
			delegateType: "focusout"
		},

		beforeunload: {
			setup: function( data, namespaces, eventHandle ) {
				// We only want to do this special case on windows
				if ( jQuery.isWindow( this ) ) {
					this.onbeforeunload = eventHandle;
				}
			},

			teardown: function( namespaces, eventHandle ) {
				if ( this.onbeforeunload === eventHandle ) {
					this.onbeforeunload = null;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{ type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

// Some plugins are using, but it's undocumented/deprecated and will be removed.
// The 1.7 special event interface should provide all the hooks needed now.
jQuery.event.handle = jQuery.event.dispatch;

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	} :
	function( elem, type, handle ) {
		if ( elem.detachEvent ) {
			elem.detachEvent( "on" + type, handle );
		}
	};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = ( src.defaultPrevented || src.returnValue === false ||
			src.getPreventDefault && src.getPreventDefault() ) ? returnTrue : returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

function returnFalse() {
	return false;
}
function returnTrue() {
	return true;
}

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	preventDefault: function() {
		this.isDefaultPrevented = returnTrue;

		var e = this.originalEvent;
		if ( !e ) {
			return;
		}

		// if preventDefault exists run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// otherwise set the returnValue property of the original event to false (IE)
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		this.isPropagationStopped = returnTrue;

		var e = this.originalEvent;
		if ( !e ) {
			return;
		}
		// if stopPropagation exists run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}
		// otherwise set the cancelBubble property of the original event to true (IE)
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		this.isImmediatePropagationStopped = returnTrue;
		this.stopPropagation();
	},
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse
};

// Create mouseenter/leave events using mouseover/out and event-time checks
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj,
				selector = handleObj.selector,
				ret;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// IE submit delegation
if ( !jQuery.support.submitBubbles ) {

	jQuery.event.special.submit = {
		setup: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
				if ( form && !form._submit_attached ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submit_bubble = true;
					});
					form._submit_attached = true;
				}
			});
			// return undefined since we don't need an event listener
		},
		
		postDispatch: function( event ) {
			// If form was submitted by the user, bubble the event up the tree
			if ( event._submit_bubble ) {
				delete event._submit_bubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event, true );
				}
			}
		},

		teardown: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !jQuery.support.changeBubbles ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {
				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._just_changed = true;
						}
					});
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._just_changed && !event.isTrigger ) {
							this._just_changed = false;
							jQuery.event.simulate( "change", this, event, true );
						}
					});
				}
				return false;
			}
			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !elem._change_attached ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event, true );
						}
					});
					elem._change_attached = true;
				}
			});
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return rformElems.test( this.nodeName );
		}
	};
}

// Create "bubbling" focus and blur events
if ( !jQuery.support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler while someone wants focusin/focusout
		var attaches = 0,
			handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				if ( attaches++ === 0 ) {
					document.addEventListener( orig, handler, true );
				}
			},
			teardown: function() {
				if ( --attaches === 0 ) {
					document.removeEventListener( orig, handler, true );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) { // && selector != null
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			var handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( var type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	live: function( types, data, fn ) {
		jQuery( this.context ).on( types, this.selector, data, fn );
		return this;
	},
	die: function( types, fn ) {
		jQuery( this.context ).off( types, this.selector || "**", fn );
		return this;
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length == 1? this.off( selector, "**" ) : this.off( types, selector, fn );
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		if ( this[0] ) {
			return jQuery.event.trigger( type, data, this[0], true );
		}
	},

	toggle: function( fn ) {
		// Save reference to arguments for access in closure
		var args = arguments,
			guid = fn.guid || jQuery.guid++,
			i = 0,
			toggler = function( event ) {
				// Figure out which function to execute
				var lastToggle = ( jQuery._data( this, "lastToggle" + fn.guid ) || 0 ) % i;
				jQuery._data( this, "lastToggle" + fn.guid, lastToggle + 1 );

				// Make sure that clicks stop
				event.preventDefault();

				// and execute the function
				return args[ lastToggle ].apply( this, arguments ) || false;
			};

		// link all the functions, so any of them can unbind this click handler
		toggler.guid = guid;
		while ( i < args.length ) {
			args[ i++ ].guid = guid;
		}

		return this.click( toggler );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
});

jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		if ( fn == null ) {
			fn = data;
			data = null;
		}

		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};

	if ( jQuery.attrFn ) {
		jQuery.attrFn[ name ] = true;
	}

	if ( rkeyEvent.test( name ) ) {
		jQuery.event.fixHooks[ name ] = jQuery.event.keyHooks;
	}

	if ( rmouseEvent.test( name ) ) {
		jQuery.event.fixHooks[ name ] = jQuery.event.mouseHooks;
	}
});



/*!
 * Sizzle CSS Selector Engine
 *  Copyright 2011, The Dojo Foundation
 *  Released under the MIT, BSD, and GPL Licenses.
 *  More information: http://sizzlejs.com/
 */
(function(){

var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
	expando = "sizcache" + (Math.random() + '').replace('.', ''),
	done = 0,
	toString = Object.prototype.toString,
	hasDuplicate = false,
	baseHasDuplicate = true,
	rBackslash = /\\/g,
	rReturn = /\r\n/g,
	rNonWord = /\W/;

// Here we check if the JavaScript engine is using some sort of
// optimization where it does not always call our comparision
// function. If that is the case, discard the hasDuplicate value.
//   Thus far that includes Google Chrome.
[0, 0].sort(function() {
	baseHasDuplicate = false;
	return 0;
});

var Sizzle = function( selector, context, results, seed ) {
	results = results || [];
	context = context || document;

	var origContext = context;

	if ( context.nodeType !== 1 && context.nodeType !== 9 ) {
		return [];
	}

	if ( !selector || typeof selector !== "string" ) {
		return results;
	}

	var m, set, checkSet, extra, ret, cur, pop, i,
		prune = true,
		contextXML = Sizzle.isXML( context ),
		parts = [],
		soFar = selector;

	// Reset the position of the chunker regexp (start from head)
	do {
		chunker.exec( "" );
		m = chunker.exec( soFar );

		if ( m ) {
			soFar = m[3];

			parts.push( m[1] );

			if ( m[2] ) {
				extra = m[3];
				break;
			}
		}
	} while ( m );

	if ( parts.length > 1 && origPOS.exec( selector ) ) {

		if ( parts.length === 2 && Expr.relative[ parts[0] ] ) {
			set = posProcess( parts[0] + parts[1], context, seed );

		} else {
			set = Expr.relative[ parts[0] ] ?
				[ context ] :
				Sizzle( parts.shift(), context );

			while ( parts.length ) {
				selector = parts.shift();

				if ( Expr.relative[ selector ] ) {
					selector += parts.shift();
				}

				set = posProcess( selector, set, seed );
			}
		}

	} else {
		// Take a shortcut and set the context if the root selector is an ID
		// (but not if it'll be faster if the inner selector is an ID)
		if ( !seed && parts.length > 1 && context.nodeType === 9 && !contextXML &&
				Expr.match.ID.test(parts[0]) && !Expr.match.ID.test(parts[parts.length - 1]) ) {

			ret = Sizzle.find( parts.shift(), context, contextXML );
			context = ret.expr ?
				Sizzle.filter( ret.expr, ret.set )[0] :
				ret.set[0];
		}

		if ( context ) {
			ret = seed ?
				{ expr: parts.pop(), set: makeArray(seed) } :
				Sizzle.find( parts.pop(), parts.length === 1 && (parts[0] === "~" || parts[0] === "+") && context.parentNode ? context.parentNode : context, contextXML );

			set = ret.expr ?
				Sizzle.filter( ret.expr, ret.set ) :
				ret.set;

			if ( parts.length > 0 ) {
				checkSet = makeArray( set );

			} else {
				prune = false;
			}

			while ( parts.length ) {
				cur = parts.pop();
				pop = cur;

				if ( !Expr.relative[ cur ] ) {
					cur = "";
				} else {
					pop = parts.pop();
				}

				if ( pop == null ) {
					pop = context;
				}

				Expr.relative[ cur ]( checkSet, pop, contextXML );
			}

		} else {
			checkSet = parts = [];
		}
	}

	if ( !checkSet ) {
		checkSet = set;
	}

	if ( !checkSet ) {
		Sizzle.error( cur || selector );
	}

	if ( toString.call(checkSet) === "[object Array]" ) {
		if ( !prune ) {
			results.push.apply( results, checkSet );

		} else if ( context && context.nodeType === 1 ) {
			for ( i = 0; checkSet[i] != null; i++ ) {
				if ( checkSet[i] && (checkSet[i] === true || checkSet[i].nodeType === 1 && Sizzle.contains(context, checkSet[i])) ) {
					results.push( set[i] );
				}
			}

		} else {
			for ( i = 0; checkSet[i] != null; i++ ) {
				if ( checkSet[i] && checkSet[i].nodeType === 1 ) {
					results.push( set[i] );
				}
			}
		}

	} else {
		makeArray( checkSet, results );
	}

	if ( extra ) {
		Sizzle( extra, origContext, results, seed );
		Sizzle.uniqueSort( results );
	}

	return results;
};

Sizzle.uniqueSort = function( results ) {
	if ( sortOrder ) {
		hasDuplicate = baseHasDuplicate;
		results.sort( sortOrder );

		if ( hasDuplicate ) {
			for ( var i = 1; i < results.length; i++ ) {
				if ( results[i] === results[ i - 1 ] ) {
					results.splice( i--, 1 );
				}
			}
		}
	}

	return results;
};

Sizzle.matches = function( expr, set ) {
	return Sizzle( expr, null, null, set );
};

Sizzle.matchesSelector = function( node, expr ) {
	return Sizzle( expr, null, null, [node] ).length > 0;
};

Sizzle.find = function( expr, context, isXML ) {
	var set, i, len, match, type, left;

	if ( !expr ) {
		return [];
	}

	for ( i = 0, len = Expr.order.length; i < len; i++ ) {
		type = Expr.order[i];

		if ( (match = Expr.leftMatch[ type ].exec( expr )) ) {
			left = match[1];
			match.splice( 1, 1 );

			if ( left.substr( left.length - 1 ) !== "\\" ) {
				match[1] = (match[1] || "").replace( rBackslash, "" );
				set = Expr.find[ type ]( match, context, isXML );

				if ( set != null ) {
					expr = expr.replace( Expr.match[ type ], "" );
					break;
				}
			}
		}
	}

	if ( !set ) {
		set = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( "*" ) :
			[];
	}

	return { set: set, expr: expr };
};

Sizzle.filter = function( expr, set, inplace, not ) {
	var match, anyFound,
		type, found, item, filter, left,
		i, pass,
		old = expr,
		result = [],
		curLoop = set,
		isXMLFilter = set && set[0] && Sizzle.isXML( set[0] );

	while ( expr && set.length ) {
		for ( type in Expr.filter ) {
			if ( (match = Expr.leftMatch[ type ].exec( expr )) != null && match[2] ) {
				filter = Expr.filter[ type ];
				left = match[1];

				anyFound = false;

				match.splice(1,1);

				if ( left.substr( left.length - 1 ) === "\\" ) {
					continue;
				}

				if ( curLoop === result ) {
					result = [];
				}

				if ( Expr.preFilter[ type ] ) {
					match = Expr.preFilter[ type ]( match, curLoop, inplace, result, not, isXMLFilter );

					if ( !match ) {
						anyFound = found = true;

					} else if ( match === true ) {
						continue;
					}
				}

				if ( match ) {
					for ( i = 0; (item = curLoop[i]) != null; i++ ) {
						if ( item ) {
							found = filter( item, match, i, curLoop );
							pass = not ^ found;

							if ( inplace && found != null ) {
								if ( pass ) {
									anyFound = true;

								} else {
									curLoop[i] = false;
								}

							} else if ( pass ) {
								result.push( item );
								anyFound = true;
							}
						}
					}
				}

				if ( found !== undefined ) {
					if ( !inplace ) {
						curLoop = result;
					}

					expr = expr.replace( Expr.match[ type ], "" );

					if ( !anyFound ) {
						return [];
					}

					break;
				}
			}
		}

		// Improper expression
		if ( expr === old ) {
			if ( anyFound == null ) {
				Sizzle.error( expr );

			} else {
				break;
			}
		}

		old = expr;
	}

	return curLoop;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Utility function for retreiving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
var getText = Sizzle.getText = function( elem ) {
    var i, node,
		nodeType = elem.nodeType,
		ret = "";

	if ( nodeType ) {
		if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent || innerText for elements
			if ( typeof elem.textContent === 'string' ) {
				return elem.textContent;
			} else if ( typeof elem.innerText === 'string' ) {
				// Replace IE's carriage returns
				return elem.innerText.replace( rReturn, '' );
			} else {
				// Traverse it's children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	} else {

		// If no nodeType, this is expected to be an array
		for ( i = 0; (node = elem[i]); i++ ) {
			// Do not traverse comment nodes
			if ( node.nodeType !== 8 ) {
				ret += getText( node );
			}
		}
	}
	return ret;
};

var Expr = Sizzle.selectors = {
	order: [ "ID", "NAME", "TAG" ],

	match: {
		ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
		CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
		NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,
		ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,
		TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,
		CHILD: /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,
		POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,
		PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/
	},

	leftMatch: {},

	attrMap: {
		"class": "className",
		"for": "htmlFor"
	},

	attrHandle: {
		href: function( elem ) {
			return elem.getAttribute( "href" );
		},
		type: function( elem ) {
			return elem.getAttribute( "type" );
		}
	},

	relative: {
		"+": function(checkSet, part){
			var isPartStr = typeof part === "string",
				isTag = isPartStr && !rNonWord.test( part ),
				isPartStrNotTag = isPartStr && !isTag;

			if ( isTag ) {
				part = part.toLowerCase();
			}

			for ( var i = 0, l = checkSet.length, elem; i < l; i++ ) {
				if ( (elem = checkSet[i]) ) {
					while ( (elem = elem.previousSibling) && elem.nodeType !== 1 ) {}

					checkSet[i] = isPartStrNotTag || elem && elem.nodeName.toLowerCase() === part ?
						elem || false :
						elem === part;
				}
			}

			if ( isPartStrNotTag ) {
				Sizzle.filter( part, checkSet, true );
			}
		},

		">": function( checkSet, part ) {
			var elem,
				isPartStr = typeof part === "string",
				i = 0,
				l = checkSet.length;

			if ( isPartStr && !rNonWord.test( part ) ) {
				part = part.toLowerCase();

				for ( ; i < l; i++ ) {
					elem = checkSet[i];

					if ( elem ) {
						var parent = elem.parentNode;
						checkSet[i] = parent.nodeName.toLowerCase() === part ? parent : false;
					}
				}

			} else {
				for ( ; i < l; i++ ) {
					elem = checkSet[i];

					if ( elem ) {
						checkSet[i] = isPartStr ?
							elem.parentNode :
							elem.parentNode === part;
					}
				}

				if ( isPartStr ) {
					Sizzle.filter( part, checkSet, true );
				}
			}
		},

		"": function(checkSet, part, isXML){
			var nodeCheck,
				doneName = done++,
				checkFn = dirCheck;

			if ( typeof part === "string" && !rNonWord.test( part ) ) {
				part = part.toLowerCase();
				nodeCheck = part;
				checkFn = dirNodeCheck;
			}

			checkFn( "parentNode", part, doneName, checkSet, nodeCheck, isXML );
		},

		"~": function( checkSet, part, isXML ) {
			var nodeCheck,
				doneName = done++,
				checkFn = dirCheck;

			if ( typeof part === "string" && !rNonWord.test( part ) ) {
				part = part.toLowerCase();
				nodeCheck = part;
				checkFn = dirNodeCheck;
			}

			checkFn( "previousSibling", part, doneName, checkSet, nodeCheck, isXML );
		}
	},

	find: {
		ID: function( match, context, isXML ) {
			if ( typeof context.getElementById !== "undefined" && !isXML ) {
				var m = context.getElementById(match[1]);
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [m] : [];
			}
		},

		NAME: function( match, context ) {
			if ( typeof context.getElementsByName !== "undefined" ) {
				var ret = [],
					results = context.getElementsByName( match[1] );

				for ( var i = 0, l = results.length; i < l; i++ ) {
					if ( results[i].getAttribute("name") === match[1] ) {
						ret.push( results[i] );
					}
				}

				return ret.length === 0 ? null : ret;
			}
		},

		TAG: function( match, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( match[1] );
			}
		}
	},
	preFilter: {
		CLASS: function( match, curLoop, inplace, result, not, isXML ) {
			match = " " + match[1].replace( rBackslash, "" ) + " ";

			if ( isXML ) {
				return match;
			}

			for ( var i = 0, elem; (elem = curLoop[i]) != null; i++ ) {
				if ( elem ) {
					if ( not ^ (elem.className && (" " + elem.className + " ").replace(/[\t\n\r]/g, " ").indexOf(match) >= 0) ) {
						if ( !inplace ) {
							result.push( elem );
						}

					} else if ( inplace ) {
						curLoop[i] = false;
					}
				}
			}

			return false;
		},

		ID: function( match ) {
			return match[1].replace( rBackslash, "" );
		},

		TAG: function( match, curLoop ) {
			return match[1].replace( rBackslash, "" ).toLowerCase();
		},

		CHILD: function( match ) {
			if ( match[1] === "nth" ) {
				if ( !match[2] ) {
					Sizzle.error( match[0] );
				}

				match[2] = match[2].replace(/^\+|\s*/g, '');

				// parse equations like 'even', 'odd', '5', '2n', '3n+2', '4n-1', '-n+6'
				var test = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec(
					match[2] === "even" && "2n" || match[2] === "odd" && "2n+1" ||
					!/\D/.test( match[2] ) && "0n+" + match[2] || match[2]);

				// calculate the numbers (first)n+(last) including if they are negative
				match[2] = (test[1] + (test[2] || 1)) - 0;
				match[3] = test[3] - 0;
			}
			else if ( match[2] ) {
				Sizzle.error( match[0] );
			}

			// TODO: Move to normal caching system
			match[0] = done++;

			return match;
		},

		ATTR: function( match, curLoop, inplace, result, not, isXML ) {
			var name = match[1] = match[1].replace( rBackslash, "" );

			if ( !isXML && Expr.attrMap[name] ) {
				match[1] = Expr.attrMap[name];
			}

			// Handle if an un-quoted value was used
			match[4] = ( match[4] || match[5] || "" ).replace( rBackslash, "" );

			if ( match[2] === "~=" ) {
				match[4] = " " + match[4] + " ";
			}

			return match;
		},

		PSEUDO: function( match, curLoop, inplace, result, not ) {
			if ( match[1] === "not" ) {
				// If we're dealing with a complex expression, or a simple one
				if ( ( chunker.exec(match[3]) || "" ).length > 1 || /^\w/.test(match[3]) ) {
					match[3] = Sizzle(match[3], null, null, curLoop);

				} else {
					var ret = Sizzle.filter(match[3], curLoop, inplace, true ^ not);

					if ( !inplace ) {
						result.push.apply( result, ret );
					}

					return false;
				}

			} else if ( Expr.match.POS.test( match[0] ) || Expr.match.CHILD.test( match[0] ) ) {
				return true;
			}

			return match;
		},

		POS: function( match ) {
			match.unshift( true );

			return match;
		}
	},

	filters: {
		enabled: function( elem ) {
			return elem.disabled === false && elem.type !== "hidden";
		},

		disabled: function( elem ) {
			return elem.disabled === true;
		},

		checked: function( elem ) {
			return elem.checked === true;
		},

		selected: function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		parent: function( elem ) {
			return !!elem.firstChild;
		},

		empty: function( elem ) {
			return !elem.firstChild;
		},

		has: function( elem, i, match ) {
			return !!Sizzle( match[3], elem ).length;
		},

		header: function( elem ) {
			return (/h\d/i).test( elem.nodeName );
		},

		text: function( elem ) {
			var attr = elem.getAttribute( "type" ), type = elem.type;
			// IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)
			// use getAttribute instead to test this case
			return elem.nodeName.toLowerCase() === "input" && "text" === type && ( attr === type || attr === null );
		},

		radio: function( elem ) {
			return elem.nodeName.toLowerCase() === "input" && "radio" === elem.type;
		},

		checkbox: function( elem ) {
			return elem.nodeName.toLowerCase() === "input" && "checkbox" === elem.type;
		},

		file: function( elem ) {
			return elem.nodeName.toLowerCase() === "input" && "file" === elem.type;
		},

		password: function( elem ) {
			return elem.nodeName.toLowerCase() === "input" && "password" === elem.type;
		},

		submit: function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && "submit" === elem.type;
		},

		image: function( elem ) {
			return elem.nodeName.toLowerCase() === "input" && "image" === elem.type;
		},

		reset: function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && "reset" === elem.type;
		},

		button: function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && "button" === elem.type || name === "button";
		},

		input: function( elem ) {
			return (/input|select|textarea|button/i).test( elem.nodeName );
		},

		focus: function( elem ) {
			return elem === elem.ownerDocument.activeElement;
		}
	},
	setFilters: {
		first: function( elem, i ) {
			return i === 0;
		},

		last: function( elem, i, match, array ) {
			return i === array.length - 1;
		},

		even: function( elem, i ) {
			return i % 2 === 0;
		},

		odd: function( elem, i ) {
			return i % 2 === 1;
		},

		lt: function( elem, i, match ) {
			return i < match[3] - 0;
		},

		gt: function( elem, i, match ) {
			return i > match[3] - 0;
		},

		nth: function( elem, i, match ) {
			return match[3] - 0 === i;
		},

		eq: function( elem, i, match ) {
			return match[3] - 0 === i;
		}
	},
	filter: {
		PSEUDO: function( elem, match, i, array ) {
			var name = match[1],
				filter = Expr.filters[ name ];

			if ( filter ) {
				return filter( elem, i, match, array );

			} else if ( name === "contains" ) {
				return (elem.textContent || elem.innerText || getText([ elem ]) || "").indexOf(match[3]) >= 0;

			} else if ( name === "not" ) {
				var not = match[3];

				for ( var j = 0, l = not.length; j < l; j++ ) {
					if ( not[j] === elem ) {
						return false;
					}
				}

				return true;

			} else {
				Sizzle.error( name );
			}
		},

		CHILD: function( elem, match ) {
			var first, last,
				doneName, parent, cache,
				count, diff,
				type = match[1],
				node = elem;

			switch ( type ) {
				case "only":
				case "first":
					while ( (node = node.previousSibling) ) {
						if ( node.nodeType === 1 ) {
							return false;
						}
					}

					if ( type === "first" ) {
						return true;
					}

					node = elem;

					/* falls through */
				case "last":
					while ( (node = node.nextSibling) ) {
						if ( node.nodeType === 1 ) {
							return false;
						}
					}

					return true;

				case "nth":
					first = match[2];
					last = match[3];

					if ( first === 1 && last === 0 ) {
						return true;
					}

					doneName = match[0];
					parent = elem.parentNode;

					if ( parent && (parent[ expando ] !== doneName || !elem.nodeIndex) ) {
						count = 0;

						for ( node = parent.firstChild; node; node = node.nextSibling ) {
							if ( node.nodeType === 1 ) {
								node.nodeIndex = ++count;
							}
						}

						parent[ expando ] = doneName;
					}

					diff = elem.nodeIndex - last;

					if ( first === 0 ) {
						return diff === 0;

					} else {
						return ( diff % first === 0 && diff / first >= 0 );
					}
			}
		},

		ID: function( elem, match ) {
			return elem.nodeType === 1 && elem.getAttribute("id") === match;
		},

		TAG: function( elem, match ) {
			return (match === "*" && elem.nodeType === 1) || !!elem.nodeName && elem.nodeName.toLowerCase() === match;
		},

		CLASS: function( elem, match ) {
			return (" " + (elem.className || elem.getAttribute("class")) + " ")
				.indexOf( match ) > -1;
		},

		ATTR: function( elem, match ) {
			var name = match[1],
				result = Sizzle.attr ?
					Sizzle.attr( elem, name ) :
					Expr.attrHandle[ name ] ?
					Expr.attrHandle[ name ]( elem ) :
					elem[ name ] != null ?
						elem[ name ] :
						elem.getAttribute( name ),
				value = result + "",
				type = match[2],
				check = match[4];

			return result == null ?
				type === "!=" :
				!type && Sizzle.attr ?
				result != null :
				type === "=" ?
				value === check :
				type === "*=" ?
				value.indexOf(check) >= 0 :
				type === "~=" ?
				(" " + value + " ").indexOf(check) >= 0 :
				!check ?
				value && result !== false :
				type === "!=" ?
				value !== check :
				type === "^=" ?
				value.indexOf(check) === 0 :
				type === "$=" ?
				value.substr(value.length - check.length) === check :
				type === "|=" ?
				value === check || value.substr(0, check.length + 1) === check + "-" :
				false;
		},

		POS: function( elem, match, i, array ) {
			var name = match[2],
				filter = Expr.setFilters[ name ];

			if ( filter ) {
				return filter( elem, i, match, array );
			}
		}
	}
};

var origPOS = Expr.match.POS,
	fescape = function(all, num){
		return "\\" + (num - 0 + 1);
	};

for ( var type in Expr.match ) {
	Expr.match[ type ] = new RegExp( Expr.match[ type ].source + (/(?![^\[]*\])(?![^\(]*\))/.source) );
	Expr.leftMatch[ type ] = new RegExp( /(^(?:.|\r|\n)*?)/.source + Expr.match[ type ].source.replace(/\\(\d+)/g, fescape) );
}
// Expose origPOS
// "global" as in regardless of relation to brackets/parens
Expr.match.globalPOS = origPOS;

var makeArray = function( array, results ) {
	array = Array.prototype.slice.call( array, 0 );

	if ( results ) {
		results.push.apply( results, array );
		return results;
	}

	return array;
};

// Perform a simple check to determine if the browser is capable of
// converting a NodeList to an array using builtin methods.
// Also verifies that the returned array holds DOM nodes
// (which is not the case in the Blackberry browser)
try {
	Array.prototype.slice.call( document.documentElement.childNodes, 0 )[0].nodeType;

// Provide a fallback method if it does not work
} catch( e ) {
	makeArray = function( array, results ) {
		var i = 0,
			ret = results || [];

		if ( toString.call(array) === "[object Array]" ) {
			Array.prototype.push.apply( ret, array );

		} else {
			if ( typeof array.length === "number" ) {
				for ( var l = array.length; i < l; i++ ) {
					ret.push( array[i] );
				}

			} else {
				for ( ; array[i]; i++ ) {
					ret.push( array[i] );
				}
			}
		}

		return ret;
	};
}

var sortOrder, siblingCheck;

if ( document.documentElement.compareDocumentPosition ) {
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		if ( !a.compareDocumentPosition || !b.compareDocumentPosition ) {
			return a.compareDocumentPosition ? -1 : 1;
		}

		return a.compareDocumentPosition(b) & 4 ? -1 : 1;
	};

} else {
	sortOrder = function( a, b ) {
		// The nodes are identical, we can exit early
		if ( a === b ) {
			hasDuplicate = true;
			return 0;

		// Fallback to using sourceIndex (in IE) if it's available on both nodes
		} else if ( a.sourceIndex && b.sourceIndex ) {
			return a.sourceIndex - b.sourceIndex;
		}

		var al, bl,
			ap = [],
			bp = [],
			aup = a.parentNode,
			bup = b.parentNode,
			cur = aup;

		// If the nodes are siblings (or identical) we can do a quick check
		if ( aup === bup ) {
			return siblingCheck( a, b );

		// If no parents were found then the nodes are disconnected
		} else if ( !aup ) {
			return -1;

		} else if ( !bup ) {
			return 1;
		}

		// Otherwise they're somewhere else in the tree so we need
		// to build up a full list of the parentNodes for comparison
		while ( cur ) {
			ap.unshift( cur );
			cur = cur.parentNode;
		}

		cur = bup;

		while ( cur ) {
			bp.unshift( cur );
			cur = cur.parentNode;
		}

		al = ap.length;
		bl = bp.length;

		// Start walking down the tree looking for a discrepancy
		for ( var i = 0; i < al && i < bl; i++ ) {
			if ( ap[i] !== bp[i] ) {
				return siblingCheck( ap[i], bp[i] );
			}
		}

		// We ended someplace up the tree so do a sibling check
		return i === al ?
			siblingCheck( a, bp[i], -1 ) :
			siblingCheck( ap[i], b, 1 );
	};

	siblingCheck = function( a, b, ret ) {
		if ( a === b ) {
			return ret;
		}

		var cur = a.nextSibling;

		while ( cur ) {
			if ( cur === b ) {
				return -1;
			}

			cur = cur.nextSibling;
		}

		return 1;
	};
}

// Check to see if the browser returns elements by name when
// querying by getElementById (and provide a workaround)
(function(){
	// We're going to inject a fake input element with a specified name
	var form = document.createElement("div"),
		id = "script" + (new Date()).getTime(),
		root = document.documentElement;

	form.innerHTML = "<a name='" + id + "'/>";

	// Inject it into the root element, check its status, and remove it quickly
	root.insertBefore( form, root.firstChild );

	// The workaround has to do additional checks after a getElementById
	// Which slows things down for other browsers (hence the branching)
	if ( document.getElementById( id ) ) {
		Expr.find.ID = function( match, context, isXML ) {
			if ( typeof context.getElementById !== "undefined" && !isXML ) {
				var m = context.getElementById(match[1]);

				return m ?
					m.id === match[1] || typeof m.getAttributeNode !== "undefined" && m.getAttributeNode("id").nodeValue === match[1] ?
						[m] :
						undefined :
					[];
			}
		};

		Expr.filter.ID = function( elem, match ) {
			var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");

			return elem.nodeType === 1 && node && node.nodeValue === match;
		};
	}

	root.removeChild( form );

	// release memory in IE
	root = form = null;
})();

(function(){
	// Check to see if the browser returns only elements
	// when doing getElementsByTagName("*")

	// Create a fake element
	var div = document.createElement("div");
	div.appendChild( document.createComment("") );

	// Make sure no comments are found
	if ( div.getElementsByTagName("*").length > 0 ) {
		Expr.find.TAG = function( match, context ) {
			var results = context.getElementsByTagName( match[1] );

			// Filter out possible comments
			if ( match[1] === "*" ) {
				var tmp = [];

				for ( var i = 0; results[i]; i++ ) {
					if ( results[i].nodeType === 1 ) {
						tmp.push( results[i] );
					}
				}

				results = tmp;
			}

			return results;
		};
	}

	// Check to see if an attribute returns normalized href attributes
	div.innerHTML = "<a href='#'></a>";

	if ( div.firstChild && typeof div.firstChild.getAttribute !== "undefined" &&
			div.firstChild.getAttribute("href") !== "#" ) {

		Expr.attrHandle.href = function( elem ) {
			return elem.getAttribute( "href", 2 );
		};
	}

	// release memory in IE
	div = null;
})();

if ( document.querySelectorAll ) {
	(function(){
		var oldSizzle = Sizzle,
			div = document.createElement("div"),
			id = "__sizzle__";

		div.innerHTML = "<p class='TEST'></p>";

		// Safari can't handle uppercase or unicode characters when
		// in quirks mode.
		if ( div.querySelectorAll && div.querySelectorAll(".TEST").length === 0 ) {
			return;
		}

		Sizzle = function( query, context, extra, seed ) {
			context = context || document;

			// Only use querySelectorAll on non-XML documents
			// (ID selectors don't work in non-HTML documents)
			if ( !seed && !Sizzle.isXML(context) ) {
				// See if we find a selector to speed up
				var match = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec( query );

				if ( match && (context.nodeType === 1 || context.nodeType === 9) ) {
					// Speed-up: Sizzle("TAG")
					if ( match[1] ) {
						return makeArray( context.getElementsByTagName( query ), extra );

					// Speed-up: Sizzle(".CLASS")
					} else if ( match[2] && Expr.find.CLASS && context.getElementsByClassName ) {
						return makeArray( context.getElementsByClassName( match[2] ), extra );
					}
				}

				if ( context.nodeType === 9 ) {
					// Speed-up: Sizzle("body")
					// The body element only exists once, optimize finding it
					if ( query === "body" && context.body ) {
						return makeArray( [ context.body ], extra );

					// Speed-up: Sizzle("#ID")
					} else if ( match && match[3] ) {
						var elem = context.getElementById( match[3] );

						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id === match[3] ) {
								return makeArray( [ elem ], extra );
							}

						} else {
							return makeArray( [], extra );
						}
					}

					try {
						return makeArray( context.querySelectorAll(query), extra );
					} catch(qsaError) {}

				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				} else if ( context.nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					var oldContext = context,
						old = context.getAttribute( "id" ),
						nid = old || id,
						hasParent = context.parentNode,
						relativeHierarchySelector = /^\s*[+~]/.test( query );

					if ( !old ) {
						context.setAttribute( "id", nid );
					} else {
						nid = nid.replace( /'/g, "\\$&" );
					}
					if ( relativeHierarchySelector && hasParent ) {
						context = context.parentNode;
					}

					try {
						if ( !relativeHierarchySelector || hasParent ) {
							return makeArray( context.querySelectorAll( "[id='" + nid + "'] " + query ), extra );
						}

					} catch(pseudoError) {
					} finally {
						if ( !old ) {
							oldContext.removeAttribute( "id" );
						}
					}
				}
			}

			return oldSizzle(query, context, extra, seed);
		};

		for ( var prop in oldSizzle ) {
			Sizzle[ prop ] = oldSizzle[ prop ];
		}

		// release memory in IE
		div = null;
	})();
}

(function(){
	var html = document.documentElement,
		matches = html.matchesSelector || html.mozMatchesSelector || html.webkitMatchesSelector || html.msMatchesSelector;

	if ( matches ) {
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node (IE 9 fails this)
		var disconnectedMatch = !matches.call( document.createElement( "div" ), "div" ),
			pseudoWorks = false;

		try {
			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( document.documentElement, "[test!='']:sizzle" );

		} catch( pseudoError ) {
			pseudoWorks = true;
		}

		Sizzle.matchesSelector = function( node, expr ) {
			// Make sure that attribute selectors are quoted
			expr = expr.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']");

			if ( !Sizzle.isXML( node ) ) {
				try {
					if ( pseudoWorks || !Expr.match.PSEUDO.test( expr ) && !/!=/.test( expr ) ) {
						var ret = matches.call( node, expr );

						// IE 9's matchesSelector returns false on disconnected nodes
						if ( ret || !disconnectedMatch ||
								// As well, disconnected nodes are said to be in a document
								// fragment in IE 9, so check for that
								node.document && node.document.nodeType !== 11 ) {
							return ret;
						}
					}
				} catch(e) {}
			}

			return Sizzle(expr, null, null, [node]).length > 0;
		};
	}
})();

(function(){
	var div = document.createElement("div");

	div.innerHTML = "<div class='test e'></div><div class='test'></div>";

	// Opera can't find a second classname (in 9.6)
	// Also, make sure that getElementsByClassName actually exists
	if ( !div.getElementsByClassName || div.getElementsByClassName("e").length === 0 ) {
		return;
	}

	// Safari caches class attributes, doesn't catch changes (in 3.2)
	div.lastChild.className = "e";

	if ( div.getElementsByClassName("e").length === 1 ) {
		return;
	}

	Expr.order.splice(1, 0, "CLASS");
	Expr.find.CLASS = function( match, context, isXML ) {
		if ( typeof context.getElementsByClassName !== "undefined" && !isXML ) {
			return context.getElementsByClassName(match[1]);
		}
	};

	// release memory in IE
	div = null;
})();

function dirNodeCheck( dir, cur, doneName, checkSet, nodeCheck, isXML ) {
	for ( var i = 0, l = checkSet.length; i < l; i++ ) {
		var elem = checkSet[i];

		if ( elem ) {
			var match = false;

			elem = elem[dir];

			while ( elem ) {
				if ( elem[ expando ] === doneName ) {
					match = checkSet[elem.sizset];
					break;
				}

				if ( elem.nodeType === 1 && !isXML ){
					elem[ expando ] = doneName;
					elem.sizset = i;
				}

				if ( elem.nodeName.toLowerCase() === cur ) {
					match = elem;
					break;
				}

				elem = elem[dir];
			}

			checkSet[i] = match;
		}
	}
}

function dirCheck( dir, cur, doneName, checkSet, nodeCheck, isXML ) {
	for ( var i = 0, l = checkSet.length; i < l; i++ ) {
		var elem = checkSet[i];

		if ( elem ) {
			var match = false;

			elem = elem[dir];

			while ( elem ) {
				if ( elem[ expando ] === doneName ) {
					match = checkSet[elem.sizset];
					break;
				}

				if ( elem.nodeType === 1 ) {
					if ( !isXML ) {
						elem[ expando ] = doneName;
						elem.sizset = i;
					}

					if ( typeof cur !== "string" ) {
						if ( elem === cur ) {
							match = true;
							break;
						}

					} else if ( Sizzle.filter( cur, [elem] ).length > 0 ) {
						match = elem;
						break;
					}
				}

				elem = elem[dir];
			}

			checkSet[i] = match;
		}
	}
}

if ( document.documentElement.contains ) {
	Sizzle.contains = function( a, b ) {
		return a !== b && (a.contains ? a.contains(b) : true);
	};

} else if ( document.documentElement.compareDocumentPosition ) {
	Sizzle.contains = function( a, b ) {
		return !!(a.compareDocumentPosition(b) & 16);
	};

} else {
	Sizzle.contains = function() {
		return false;
	};
}

Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = (elem ? elem.ownerDocument || elem : 0).documentElement;

	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

var posProcess = function( selector, context, seed ) {
	var match,
		tmpSet = [],
		later = "",
		root = context.nodeType ? [context] : context;

	// Position selectors must be done after the filter
	// And so must :not(positional) so we move all PSEUDOs to the end
	while ( (match = Expr.match.PSEUDO.exec( selector )) ) {
		later += match[0];
		selector = selector.replace( Expr.match.PSEUDO, "" );
	}

	selector = Expr.relative[selector] ? selector + "*" : selector;

	for ( var i = 0, l = root.length; i < l; i++ ) {
		Sizzle( selector, root[i], tmpSet, seed );
	}

	return Sizzle.filter( later, tmpSet );
};

// EXPOSE
// Override sizzle attribute retrieval
Sizzle.attr = jQuery.attr;
Sizzle.selectors.attrMap = {};
jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.filters;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;


})();


var runtil = /Until$/,
	rparentsprev = /^(?:parents|prevUntil|prevAll)/,
	// Note: This RegExp should be improved, or likely pulled from Sizzle
	rmultiselector = /,/,
	isSimple = /^.[^:#\[\.,]*$/,
	slice = Array.prototype.slice,
	POS = jQuery.expr.match.globalPOS,
	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend({
	find: function( selector ) {
		var self = this,
			i, l;

		if ( typeof selector !== "string" ) {
			return jQuery( selector ).filter(function() {
				for ( i = 0, l = self.length; i < l; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			});
		}

		var ret = this.pushStack( "", "find", selector ),
			length, n, r;

		for ( i = 0, l = this.length; i < l; i++ ) {
			length = ret.length;
			jQuery.find( selector, this[i], ret );

			if ( i > 0 ) {
				// Make sure that the results are unique
				for ( n = length; n < ret.length; n++ ) {
					for ( r = 0; r < length; r++ ) {
						if ( ret[r] === ret[n] ) {
							ret.splice(n--, 1);
							break;
						}
					}
				}
			}
		}

		return ret;
	},

	has: function( target ) {
		var targets = jQuery( target );
		return this.filter(function() {
			for ( var i = 0, l = targets.length; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	not: function( selector ) {
		return this.pushStack( winnow(this, selector, false), "not", selector);
	},

	filter: function( selector ) {
		return this.pushStack( winnow(this, selector, true), "filter", selector );
	},

	is: function( selector ) {
		return !!selector && (
			typeof selector === "string" ?
				// If this is a positional selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				POS.test( selector ) ?
					jQuery( selector, this.context ).index( this[0] ) >= 0 :
					jQuery.filter( selector, this ).length > 0 :
				this.filter( selector ).length > 0 );
	},

	closest: function( selectors, context ) {
		var ret = [], i, l, cur = this[0];

		// Array (deprecated as of jQuery 1.7)
		if ( jQuery.isArray( selectors ) ) {
			var level = 1;

			while ( cur && cur.ownerDocument && cur !== context ) {
				for ( i = 0; i < selectors.length; i++ ) {

					if ( jQuery( cur ).is( selectors[ i ] ) ) {
						ret.push({ selector: selectors[ i ], elem: cur, level: level });
					}
				}

				cur = cur.parentNode;
				level++;
			}

			return ret;
		}

		// String
		var pos = POS.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( i = 0, l = this.length; i < l; i++ ) {
			cur = this[i];

			while ( cur ) {
				if ( pos ? pos.index(cur) > -1 : jQuery.find.matchesSelector(cur, selectors) ) {
					ret.push( cur );
					break;

				} else {
					cur = cur.parentNode;
					if ( !cur || !cur.ownerDocument || cur === context || cur.nodeType === 11 ) {
						break;
					}
				}
			}
		}

		ret = ret.length > 1 ? jQuery.unique( ret ) : ret;

		return this.pushStack( ret, "closest", selectors );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[0] && this[0].parentNode ) ? this.prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[0], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(
			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem, this );
	},

	add: function( selector, context ) {
		var set = typeof selector === "string" ?
				jQuery( selector, context ) :
				jQuery.makeArray( selector && selector.nodeType ? [ selector ] : selector ),
			all = jQuery.merge( this.get(), set );

		return this.pushStack( isDisconnected( set[0] ) || isDisconnected( all[0] ) ?
			all :
			jQuery.unique( all ) );
	},

	andSelf: function() {
		return this.add( this.prevObject );
	}
});

// A painfully simple check to see if an element is disconnected
// from a document (should be improved, where feasible).
function isDisconnected( node ) {
	return !node || !node.parentNode || node.parentNode.nodeType === 11;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return jQuery.nth( elem, 2, "nextSibling" );
	},
	prev: function( elem ) {
		return jQuery.nth( elem, 2, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.makeArray( elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( !runtil.test( name ) ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		ret = this.length > 1 && !guaranteedUnique[ name ] ? jQuery.unique( ret ) : ret;

		if ( (this.length > 1 || rmultiselector.test( selector )) && rparentsprev.test( name ) ) {
			ret = ret.reverse();
		}

		return this.pushStack( ret, name, slice.call( arguments ).join(",") );
	};
});

jQuery.extend({
	filter: function( expr, elems, not ) {
		if ( not ) {
			expr = ":not(" + expr + ")";
		}

		return elems.length === 1 ?
			jQuery.find.matchesSelector(elems[0], expr) ? [ elems[0] ] : [] :
			jQuery.find.matches(expr, elems);
	},

	dir: function( elem, dir, until ) {
		var matched = [],
			cur = elem[ dir ];

		while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
			if ( cur.nodeType === 1 ) {
				matched.push( cur );
			}
			cur = cur[dir];
		}
		return matched;
	},

	nth: function( cur, result, dir, elem ) {
		result = result || 1;
		var num = 0;

		for ( ; cur; cur = cur[dir] ) {
			if ( cur.nodeType === 1 && ++num === result ) {
				break;
			}
		}

		return cur;
	},

	sibling: function( n, elem ) {
		var r = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				r.push( n );
			}
		}

		return r;
	}
});

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, keep ) {

	// Can't pass null or undefined to indexOf in Firefox 4
	// Set to 0 to skip string check
	qualifier = qualifier || 0;

	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep(elements, function( elem, i ) {
			var retVal = !!qualifier.call( elem, i, elem );
			return retVal === keep;
		});

	} else if ( qualifier.nodeType ) {
		return jQuery.grep(elements, function( elem, i ) {
			return ( elem === qualifier ) === keep;
		});

	} else if ( typeof qualifier === "string" ) {
		var filtered = jQuery.grep(elements, function( elem ) {
			return elem.nodeType === 1;
		});

		if ( isSimple.test( qualifier ) ) {
			return jQuery.filter(qualifier, filtered, !keep);
		} else {
			qualifier = jQuery.filter( qualifier, filtered );
		}
	}

	return jQuery.grep(elements, function( elem, i ) {
		return ( jQuery.inArray( elem, qualifier ) >= 0 ) === keep;
	});
}




function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
	safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
		"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
	rinlinejQuery = / jQuery\d+="(?:\d+|null)"/g,
	rleadingWhitespace = /^\s+/,
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
	rtagName = /<([\w:]+)/,
	rtbody = /<tbody/i,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style)/i,
	rnocache = /<(?:script|object|embed|option|style)/i,
	rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /\/(java|ecma)script/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|\-\-)/,
	wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		area: [ 1, "<map>", "</map>" ],
		_default: [ 0, "", "" ]
	},
	safeFragment = createSafeFragment( document );

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// IE can't serialize <link> and <script> tags normally
if ( !jQuery.support.htmlSerialize ) {
	wrapMap._default = [ 1, "div<div>", "</div>" ];
}

jQuery.fn.extend({
	text: function( value ) {
		return jQuery.access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
		}, null, value, arguments.length );
	},

	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapAll( html.call(this, i) );
			});
		}

		if ( this[0] ) {
			// The elements to wrap the target around
			var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);

			if ( this[0].parentNode ) {
				wrap.insertBefore( this[0] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function(i) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	},

	append: function() {
		return this.domManip(arguments, true, function( elem ) {
			if ( this.nodeType === 1 ) {
				this.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip(arguments, true, function( elem ) {
			if ( this.nodeType === 1 ) {
				this.insertBefore( elem, this.firstChild );
			}
		});
	},

	before: function() {
		if ( this[0] && this[0].parentNode ) {
			return this.domManip(arguments, false, function( elem ) {
				this.parentNode.insertBefore( elem, this );
			});
		} else if ( arguments.length ) {
			var set = jQuery.clean( arguments );
			set.push.apply( set, this.toArray() );
			return this.pushStack( set, "before", arguments );
		}
	},

	after: function() {
		if ( this[0] && this[0].parentNode ) {
			return this.domManip(arguments, false, function( elem ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			});
		} else if ( arguments.length ) {
			var set = this.pushStack( this, "after", arguments );
			set.push.apply( set, jQuery.clean(arguments) );
			return set;
		}
	},

	// keepData is for internal use only--do not document
	remove: function( selector, keepData ) {
		for ( var i = 0, elem; (elem = this[i]) != null; i++ ) {
			if ( !selector || jQuery.filter( selector, [ elem ] ).length ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( elem.getElementsByTagName("*") );
					jQuery.cleanData( [ elem ] );
				}

				if ( elem.parentNode ) {
					elem.parentNode.removeChild( elem );
				}
			}
		}

		return this;
	},

	empty: function() {
		for ( var i = 0, elem; (elem = this[i]) != null; i++ ) {
			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( elem.getElementsByTagName("*") );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function () {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return jQuery.access( this, function( value ) {
			var elem = this[0] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					null;
			}


			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( jQuery.support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ ( rtagName.exec( value ) || ["", ""] )[1].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for (; i < l; i++ ) {
						// Remove element nodes and prevent memory leaks
						elem = this[i] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( elem.getElementsByTagName( "*" ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch(e) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function( value ) {
		if ( this[0] && this[0].parentNode ) {
			// Make sure that the elements are removed from the DOM before they are inserted
			// this can help fix replacing a parent with child elements
			if ( jQuery.isFunction( value ) ) {
				return this.each(function(i) {
					var self = jQuery(this), old = self.html();
					self.replaceWith( value.call( this, i, old ) );
				});
			}

			if ( typeof value !== "string" ) {
				value = jQuery( value ).detach();
			}

			return this.each(function() {
				var next = this.nextSibling,
					parent = this.parentNode;

				jQuery( this ).remove();

				if ( next ) {
					jQuery(next).before( value );
				} else {
					jQuery(parent).append( value );
				}
			});
		} else {
			return this.length ?
				this.pushStack( jQuery(jQuery.isFunction(value) ? value() : value), "replaceWith", value ) :
				this;
		}
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, table, callback ) {
		var results, first, fragment, parent,
			value = args[0],
			scripts = [];

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( !jQuery.support.checkClone && arguments.length === 3 && typeof value === "string" && rchecked.test( value ) ) {
			return this.each(function() {
				jQuery(this).domManip( args, table, callback, true );
			});
		}

		if ( jQuery.isFunction(value) ) {
			return this.each(function(i) {
				var self = jQuery(this);
				args[0] = value.call(this, i, table ? self.html() : undefined);
				self.domManip( args, table, callback );
			});
		}

		if ( this[0] ) {
			parent = value && value.parentNode;

			// If we're in a fragment, just use that instead of building a new one
			if ( jQuery.support.parentNode && parent && parent.nodeType === 11 && parent.childNodes.length === this.length ) {
				results = { fragment: parent };

			} else {
				results = jQuery.buildFragment( args, this, scripts );
			}

			fragment = results.fragment;

			if ( fragment.childNodes.length === 1 ) {
				first = fragment = fragment.firstChild;
			} else {
				first = fragment.firstChild;
			}

			if ( first ) {
				table = table && jQuery.nodeName( first, "tr" );

				for ( var i = 0, l = this.length, lastIndex = l - 1; i < l; i++ ) {
					callback.call(
						table ?
							root(this[i], first) :
							this[i],
						// Make sure that we do not leak memory by inadvertently discarding
						// the original fragment (which might have attached data) instead of
						// using it; in addition, use the original fragment object for the last
						// item instead of first because it can end up being emptied incorrectly
						// in certain situations (Bug #8070).
						// Fragments from the fragment cache must always be cloned and never used
						// in place.
						results.cacheable || ( l > 1 && i < lastIndex ) ?
							jQuery.clone( fragment, true, true ) :
							fragment
					);
				}
			}

			if ( scripts.length ) {
				jQuery.each( scripts, function( i, elem ) {
					if ( elem.src ) {
						jQuery.ajax({
							type: "GET",
							global: false,
							url: elem.src,
							async: false,
							dataType: "script"
						});
					} else {
						jQuery.globalEval( ( elem.text || elem.textContent || elem.innerHTML || "" ).replace( rcleanScript, "/*$0*/" ) );
					}

					if ( elem.parentNode ) {
						elem.parentNode.removeChild( elem );
					}
				});
			}
		}

		return this;
	}
});

function root( elem, cur ) {
	return jQuery.nodeName(elem, "table") ?
		(elem.getElementsByTagName("tbody")[0] ||
		elem.appendChild(elem.ownerDocument.createElement("tbody"))) :
		elem;
}

function cloneCopyEvent( src, dest ) {

	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function cloneFixAttributes( src, dest ) {
	var nodeName;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	// clearAttributes removes the attributes, which we don't want,
	// but also removes the attachEvent events, which we *do* want
	if ( dest.clearAttributes ) {
		dest.clearAttributes();
	}

	// mergeAttributes, in contrast, only merges back on the
	// original attributes, not the events
	if ( dest.mergeAttributes ) {
		dest.mergeAttributes( src );
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 fail to clone children inside object elements that use
	// the proprietary classid attribute value (rather than the type
	// attribute) to identify the type of content to display
	if ( nodeName === "object" ) {
		dest.outerHTML = src.outerHTML;

	} else if ( nodeName === "input" && (src.type === "checkbox" || src.type === "radio") ) {
		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set
		if ( src.checked ) {
			dest.defaultChecked = dest.checked = src.checked;
		}

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;

	// IE blanks contents when cloning scripts
	} else if ( nodeName === "script" && dest.text !== src.text ) {
		dest.text = src.text;
	}

	// Event data gets referenced instead of copied if the expando
	// gets copied too
	dest.removeAttribute( jQuery.expando );

	// Clear flags for bubbling special change/submit events, they must
	// be reattached when the newly cloned events are first activated
	dest.removeAttribute( "_submit_attached" );
	dest.removeAttribute( "_change_attached" );
}

jQuery.buildFragment = function( args, nodes, scripts ) {
	var fragment, cacheable, cacheresults, doc,
	first = args[ 0 ];

	// nodes may contain either an explicit document object,
	// a jQuery collection or context object.
	// If nodes[0] contains a valid object to assign to doc
	if ( nodes && nodes[0] ) {
		doc = nodes[0].ownerDocument || nodes[0];
	}

	// Ensure that an attr object doesn't incorrectly stand in as a document object
	// Chrome and Firefox seem to allow this to occur and will throw exception
	// Fixes #8950
	if ( !doc.createDocumentFragment ) {
		doc = document;
	}

	// Only cache "small" (1/2 KB) HTML strings that are associated with the main document
	// Cloning options loses the selected state, so don't cache them
	// IE 6 doesn't like it when you put <object> or <embed> elements in a fragment
	// Also, WebKit does not clone 'checked' attributes on cloneNode, so don't cache
	// Lastly, IE6,7,8 will not correctly reuse cached fragments that were created from unknown elems #10501
	if ( args.length === 1 && typeof first === "string" && first.length < 512 && doc === document &&
		first.charAt(0) === "<" && !rnocache.test( first ) &&
		(jQuery.support.checkClone || !rchecked.test( first )) &&
		(jQuery.support.html5Clone || !rnoshimcache.test( first )) ) {

		cacheable = true;

		cacheresults = jQuery.fragments[ first ];
		if ( cacheresults && cacheresults !== 1 ) {
			fragment = cacheresults;
		}
	}

	if ( !fragment ) {
		fragment = doc.createDocumentFragment();
		jQuery.clean( args, doc, fragment, scripts );
	}

	if ( cacheable ) {
		jQuery.fragments[ first ] = cacheresults ? fragment : 1;
	}

	return { fragment: fragment, cacheable: cacheable };
};

jQuery.fragments = {};

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var ret = [],
			insert = jQuery( selector ),
			parent = this.length === 1 && this[0].parentNode;

		if ( parent && parent.nodeType === 11 && parent.childNodes.length === 1 && insert.length === 1 ) {
			insert[ original ]( this[0] );
			return this;

		} else {
			for ( var i = 0, l = insert.length; i < l; i++ ) {
				var elems = ( i > 0 ? this.clone(true) : this ).get();
				jQuery( insert[i] )[ original ]( elems );
				ret = ret.concat( elems );
			}

			return this.pushStack( ret, name, insert.selector );
		}
	};
});

function getAll( elem ) {
	if ( typeof elem.getElementsByTagName !== "undefined" ) {
		return elem.getElementsByTagName( "*" );

	} else if ( typeof elem.querySelectorAll !== "undefined" ) {
		return elem.querySelectorAll( "*" );

	} else {
		return [];
	}
}

// Used in clean, fixes the defaultChecked property
function fixDefaultChecked( elem ) {
	if ( elem.type === "checkbox" || elem.type === "radio" ) {
		elem.defaultChecked = elem.checked;
	}
}
// Finds all inputs and passes them to fixDefaultChecked
function findInputs( elem ) {
	var nodeName = ( elem.nodeName || "" ).toLowerCase();
	if ( nodeName === "input" ) {
		fixDefaultChecked( elem );
	// Skip scripts, get other children
	} else if ( nodeName !== "script" && typeof elem.getElementsByTagName !== "undefined" ) {
		jQuery.grep( elem.getElementsByTagName("input"), fixDefaultChecked );
	}
}

// Derived From: http://www.iecss.com/shimprove/javascript/shimprove.1-0-1.js
function shimCloneNode( elem ) {
	var div = document.createElement( "div" );
	safeFragment.appendChild( div );

	div.innerHTML = elem.outerHTML;
	return div.firstChild;
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var srcElements,
			destElements,
			i,
			// IE<=8 does not properly clone detached, unknown element nodes
			clone = jQuery.support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ?
				elem.cloneNode( true ) :
				shimCloneNode( elem );

		if ( (!jQuery.support.noCloneEvent || !jQuery.support.noCloneChecked) &&
				(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {
			// IE copies events bound via attachEvent when using cloneNode.
			// Calling detachEvent on the clone will also remove the events
			// from the original. In order to get around this, we use some
			// proprietary methods to clear the events. Thanks to MooTools
			// guys for this hotness.

			cloneFixAttributes( elem, clone );

			// Using Sizzle here is crazy slow, so we use getElementsByTagName instead
			srcElements = getAll( elem );
			destElements = getAll( clone );

			// Weird iteration because IE will replace the length property
			// with an element if you are cloning the body and one of the
			// elements on the page has a name or id of "length"
			for ( i = 0; srcElements[i]; ++i ) {
				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[i] ) {
					cloneFixAttributes( srcElements[i], destElements[i] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			cloneCopyEvent( elem, clone );

			if ( deepDataAndEvents ) {
				srcElements = getAll( elem );
				destElements = getAll( clone );

				for ( i = 0; srcElements[i]; ++i ) {
					cloneCopyEvent( srcElements[i], destElements[i] );
				}
			}
		}

		srcElements = destElements = null;

		// Return the cloned set
		return clone;
	},

	clean: function( elems, context, fragment, scripts ) {
		var checkScriptType, script, j,
				ret = [];

		context = context || document;

		// !context.createElement fails in IE with an error but returns typeof 'object'
		if ( typeof context.createElement === "undefined" ) {
			context = context.ownerDocument || context[0] && context[0].ownerDocument || document;
		}

		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			if ( typeof elem === "number" ) {
				elem += "";
			}

			if ( !elem ) {
				continue;
			}

			// Convert html string into DOM nodes
			if ( typeof elem === "string" ) {
				if ( !rhtml.test( elem ) ) {
					elem = context.createTextNode( elem );
				} else {
					// Fix "XHTML"-style tags in all browsers
					elem = elem.replace(rxhtmlTag, "<$1></$2>");

					// Trim whitespace, otherwise indexOf won't work as expected
					var tag = ( rtagName.exec( elem ) || ["", ""] )[1].toLowerCase(),
						wrap = wrapMap[ tag ] || wrapMap._default,
						depth = wrap[0],
						div = context.createElement("div"),
						safeChildNodes = safeFragment.childNodes,
						remove;

					// Append wrapper element to unknown element safe doc fragment
					if ( context === document ) {
						// Use the fragment we've already created for this document
						safeFragment.appendChild( div );
					} else {
						// Use a fragment created with the owner document
						createSafeFragment( context ).appendChild( div );
					}

					// Go to html and back, then peel off extra wrappers
					div.innerHTML = wrap[1] + elem + wrap[2];

					// Move to the right depth
					while ( depth-- ) {
						div = div.lastChild;
					}

					// Remove IE's autoinserted <tbody> from table fragments
					if ( !jQuery.support.tbody ) {

						// String was a <table>, *may* have spurious <tbody>
						var hasBody = rtbody.test(elem),
							tbody = tag === "table" && !hasBody ?
								div.firstChild && div.firstChild.childNodes :

								// String was a bare <thead> or <tfoot>
								wrap[1] === "<table>" && !hasBody ?
									div.childNodes :
									[];

						for ( j = tbody.length - 1; j >= 0 ; --j ) {
							if ( jQuery.nodeName( tbody[ j ], "tbody" ) && !tbody[ j ].childNodes.length ) {
								tbody[ j ].parentNode.removeChild( tbody[ j ] );
							}
						}
					}

					// IE completely kills leading whitespace when innerHTML is used
					if ( !jQuery.support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						div.insertBefore( context.createTextNode( rleadingWhitespace.exec(elem)[0] ), div.firstChild );
					}

					elem = div.childNodes;

					// Clear elements from DocumentFragment (safeFragment or otherwise)
					// to avoid hoarding elements. Fixes #11356
					if ( div ) {
						div.parentNode.removeChild( div );

						// Guard against -1 index exceptions in FF3.6
						if ( safeChildNodes.length > 0 ) {
							remove = safeChildNodes[ safeChildNodes.length - 1 ];

							if ( remove && remove.parentNode ) {
								remove.parentNode.removeChild( remove );
							}
						}
					}
				}
			}

			// Resets defaultChecked for any radios and checkboxes
			// about to be appended to the DOM in IE 6/7 (#8060)
			var len;
			if ( !jQuery.support.appendChecked ) {
				if ( elem[0] && typeof (len = elem.length) === "number" ) {
					for ( j = 0; j < len; j++ ) {
						findInputs( elem[j] );
					}
				} else {
					findInputs( elem );
				}
			}

			if ( elem.nodeType ) {
				ret.push( elem );
			} else {
				ret = jQuery.merge( ret, elem );
			}
		}

		if ( fragment ) {
			checkScriptType = function( elem ) {
				return !elem.type || rscriptType.test( elem.type );
			};
			for ( i = 0; ret[i]; i++ ) {
				script = ret[i];
				if ( scripts && jQuery.nodeName( script, "script" ) && (!script.type || rscriptType.test( script.type )) ) {
					scripts.push( script.parentNode ? script.parentNode.removeChild( script ) : script );

				} else {
					if ( script.nodeType === 1 ) {
						var jsTags = jQuery.grep( script.getElementsByTagName( "script" ), checkScriptType );

						ret.splice.apply( ret, [i + 1, 0].concat( jsTags ) );
					}
					fragment.appendChild( script );
				}
			}
		}

		return ret;
	},

	cleanData: function( elems ) {
		var data, id,
			cache = jQuery.cache,
			special = jQuery.event.special,
			deleteExpando = jQuery.support.deleteExpando;

		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			if ( elem.nodeName && jQuery.noData[elem.nodeName.toLowerCase()] ) {
				continue;
			}

			id = elem[ jQuery.expando ];

			if ( id ) {
				data = cache[ id ];

				if ( data && data.events ) {
					for ( var type in data.events ) {
						if ( special[ type ] ) {
							jQuery.event.remove( elem, type );

						// This is a shortcut to avoid jQuery.event.remove's overhead
						} else {
							jQuery.removeEvent( elem, type, data.handle );
						}
					}

					// Null the DOM reference to avoid IE6/7/8 leak (#7054)
					if ( data.handle ) {
						data.handle.elem = null;
					}
				}

				if ( deleteExpando ) {
					delete elem[ jQuery.expando ];

				} else if ( elem.removeAttribute ) {
					elem.removeAttribute( jQuery.expando );
				}

				delete cache[ id ];
			}
		}
	}
});




var ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity=([^)]*)/,
	// fixed for IE9, see #8346
	rupper = /([A-Z]|^ms)/g,
	rnum = /^[\-+]?(?:\d*\.)?\d+$/i,
	rnumnonpx = /^-?(?:\d*\.)?\d+(?!px)[^\d\s]+$/i,
	rrelNum = /^([\-+])=([\-+.\de]+)/,
	rmargin = /^margin/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },

	// order is important!
	cssExpand = [ "Top", "Right", "Bottom", "Left" ],

	curCSS,

	getComputedStyle,
	currentStyle;

jQuery.fn.css = function( name, value ) {
	return jQuery.access( this, function( elem, name, value ) {
		return value !== undefined ?
			jQuery.style( elem, name, value ) :
			jQuery.css( elem, name );
	}, name, value, arguments.length > 1 );
};

jQuery.extend({
	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {
					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;

				} else {
					return elem.style.opacity;
				}
			}
		}
	},

	// Exclude the following css properties to add px
	cssNumber: {
		"fillOpacity": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		// normalize float css property
		"float": jQuery.support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {
		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, origName = jQuery.camelCase( name ),
			style = elem.style, hooks = jQuery.cssHooks[ origName ];

		name = jQuery.cssProps[ origName ] || origName;

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// convert relative number strings (+= or -=) to relative numbers. #7345
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( +( ret[1] + 1) * +ret[2] ) + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that NaN and null values aren't set. See: #7116
			if ( value == null || type === "number" && isNaN( value ) ) {
				return;
			}

			// If a number was passed in, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value )) !== undefined ) {
				// Wrapped to prevent IE from throwing errors when 'invalid' values are provided
				// Fixes bug #5509
				try {
					style[ name ] = value;
				} catch(e) {}
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra ) {
		var ret, hooks;

		// Make sure that we're working with the right name
		name = jQuery.camelCase( name );
		hooks = jQuery.cssHooks[ name ];
		name = jQuery.cssProps[ name ] || name;

		// cssFloat needs a special treatment
		if ( name === "cssFloat" ) {
			name = "float";
		}

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks && (ret = hooks.get( elem, true, extra )) !== undefined ) {
			return ret;

		// Otherwise, if a way to get the computed value exists, use that
		} else if ( curCSS ) {
			return curCSS( elem, name );
		}
	},

	// A method for quickly swapping in/out CSS properties to get correct calculations
	swap: function( elem, options, callback ) {
		var old = {},
			ret, name;

		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}

		ret = callback.call( elem );

		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}

		return ret;
	}
});

// DEPRECATED in 1.3, Use jQuery.css() instead
jQuery.curCSS = jQuery.css;

if ( document.defaultView && document.defaultView.getComputedStyle ) {
	getComputedStyle = function( elem, name ) {
		var ret, defaultView, computedStyle, width,
			style = elem.style;

		name = name.replace( rupper, "-$1" ).toLowerCase();

		if ( (defaultView = elem.ownerDocument.defaultView) &&
				(computedStyle = defaultView.getComputedStyle( elem, null )) ) {

			ret = computedStyle.getPropertyValue( name );
			if ( ret === "" && !jQuery.contains( elem.ownerDocument.documentElement, elem ) ) {
				ret = jQuery.style( elem, name );
			}
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// WebKit uses "computed value (percentage if specified)" instead of "used value" for margins
		// which is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !jQuery.support.pixelMargin && computedStyle && rmargin.test( name ) && rnumnonpx.test( ret ) ) {
			width = style.width;
			style.width = ret;
			ret = computedStyle.width;
			style.width = width;
		}

		return ret;
	};
}

if ( document.documentElement.currentStyle ) {
	currentStyle = function( elem, name ) {
		var left, rsLeft, uncomputed,
			ret = elem.currentStyle && elem.currentStyle[ name ],
			style = elem.style;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && (uncomputed = style[ name ]) ) {
			ret = uncomputed;
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		if ( rnumnonpx.test( ret ) ) {

			// Remember the original values
			left = style.left;
			rsLeft = elem.runtimeStyle && elem.runtimeStyle.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				elem.runtimeStyle.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				elem.runtimeStyle.left = rsLeft;
			}
		}

		return ret === "" ? "auto" : ret;
	};
}

curCSS = getComputedStyle || currentStyle;

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property
	var val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		i = name === "width" ? 1 : 0,
		len = 4;

	if ( val > 0 ) {
		if ( extra !== "border" ) {
			for ( ; i < len; i += 2 ) {
				if ( !extra ) {
					val -= parseFloat( jQuery.css( elem, "padding" + cssExpand[ i ] ) ) || 0;
				}
				if ( extra === "margin" ) {
					val += parseFloat( jQuery.css( elem, extra + cssExpand[ i ] ) ) || 0;
				} else {
					val -= parseFloat( jQuery.css( elem, "border" + cssExpand[ i ] + "Width" ) ) || 0;
				}
			}
		}

		return val + "px";
	}

	// Fall back to computed then uncomputed css if necessary
	val = curCSS( elem, name );
	if ( val < 0 || val == null ) {
		val = elem.style[ name ];
	}

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test(val) ) {
		return val;
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Add padding, border, margin
	if ( extra ) {
		for ( ; i < len; i += 2 ) {
			val += parseFloat( jQuery.css( elem, "padding" + cssExpand[ i ] ) ) || 0;
			if ( extra !== "padding" ) {
				val += parseFloat( jQuery.css( elem, "border" + cssExpand[ i ] + "Width" ) ) || 0;
			}
			if ( extra === "margin" ) {
				val += parseFloat( jQuery.css( elem, extra + cssExpand[ i ]) ) || 0;
			}
		}
	}

	return val + "px";
}

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {
				if ( elem.offsetWidth !== 0 ) {
					return getWidthOrHeight( elem, name, extra );
				} else {
					return jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					});
				}
			}
		},

		set: function( elem, value ) {
			return rnum.test( value ) ?
				value + "px" :
				value;
		}
	};
});

if ( !jQuery.support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {
			// IE uses filters for opacity
			return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
				( parseFloat( RegExp.$1 ) / 100 ) + "" :
				computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
			if ( value >= 1 && jQuery.trim( filter.replace( ralpha, "" ) ) === "" ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there there is no filter style applied in a css rule, we are done
				if ( currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery(function() {
	// This hook cannot be added until DOM ready because the support test
	// for it is not run until after DOM ready
	if ( !jQuery.support.reliableMarginRight ) {
		jQuery.cssHooks.marginRight = {
			get: function( elem, computed ) {
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// Work around by temporarily setting element display to inline-block
				return jQuery.swap( elem, { "display": "inline-block" }, function() {
					if ( computed ) {
						return curCSS( elem, "margin-right" );
					} else {
						return elem.style.marginRight;
					}
				});
			}
		};
	}
});

if ( jQuery.expr && jQuery.expr.filters ) {
	jQuery.expr.filters.hidden = function( elem ) {
		var width = elem.offsetWidth,
			height = elem.offsetHeight;

		return ( width === 0 && height === 0 ) || (!jQuery.support.reliableHiddenOffsets && ((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
	};

	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
}

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {

	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i,

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ],
				expanded = {};

			for ( i = 0; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};
});




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rhash = /#.*$/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
	rinput = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rquery = /\?/,
	rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
	rselectTextarea = /^(?:select|textarea)/i,
	rspacesAjax = /\s+/,
	rts = /([?&])_=[^&]*/,
	rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,

	// Keep a copy of the old load method
	_load = jQuery.fn.load,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Document location
	ajaxLocation,

	// Document location segments
	ajaxLocParts,

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = ["*/"] + ["*"];

// #8138, IE may throw an exception when accessing
// a field from window.location if document.domain has been set
try {
	ajaxLocation = location.href;
} catch( e ) {
	// Use the href attribute of an A element
	// since IE will modify it given document.location
	ajaxLocation = document.createElement( "a" );
	ajaxLocation.href = "";
	ajaxLocation = ajaxLocation.href;
}

// Segment location into parts
ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		if ( jQuery.isFunction( func ) ) {
			var dataTypes = dataTypeExpression.toLowerCase().split( rspacesAjax ),
				i = 0,
				length = dataTypes.length,
				dataType,
				list,
				placeBefore;

			// For each dataType in the dataTypeExpression
			for ( ; i < length; i++ ) {
				dataType = dataTypes[ i ];
				// We control if we're asked to add before
				// any existing element
				placeBefore = /^\+/.test( dataType );
				if ( placeBefore ) {
					dataType = dataType.substr( 1 ) || "*";
				}
				list = structure[ dataType ] = structure[ dataType ] || [];
				// then we add to the structure accordingly
				list[ placeBefore ? "unshift" : "push" ]( func );
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR,
		dataType /* internal */, inspected /* internal */ ) {

	dataType = dataType || options.dataTypes[ 0 ];
	inspected = inspected || {};

	inspected[ dataType ] = true;

	var list = structure[ dataType ],
		i = 0,
		length = list ? list.length : 0,
		executeOnly = ( structure === prefilters ),
		selection;

	for ( ; i < length && ( executeOnly || !selection ); i++ ) {
		selection = list[ i ]( options, originalOptions, jqXHR );
		// If we got redirected to another dataType
		// we try there if executing only and not done already
		if ( typeof selection === "string" ) {
			if ( !executeOnly || inspected[ selection ] ) {
				selection = undefined;
			} else {
				options.dataTypes.unshift( selection );
				selection = inspectPrefiltersOrTransports(
						structure, options, originalOptions, jqXHR, selection, inspected );
			}
		}
	}
	// If we're only executing or nothing was selected
	// we try the catchall dataType if not done already
	if ( ( executeOnly || !selection ) && !inspected[ "*" ] ) {
		selection = inspectPrefiltersOrTransports(
				structure, options, originalOptions, jqXHR, "*", inspected );
	}
	// unnecessary when only executing (prefilters)
	// but it'll be ignored by the caller in that case
	return selection;
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};
	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}
}

jQuery.fn.extend({
	load: function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );

		// Don't do a request if no elements are being requested
		} else if ( !this.length ) {
			return this;
		}

		var off = url.indexOf( " " );
		if ( off >= 0 ) {
			var selector = url.slice( off, url.length );
			url = url.slice( 0, off );
		}

		// Default to a GET request
		var type = "GET";

		// If the second parameter was provided
		if ( params ) {
			// If it's a function
			if ( jQuery.isFunction( params ) ) {
				// We assume that it's the callback
				callback = params;
				params = undefined;

			// Otherwise, build a param string
			} else if ( typeof params === "object" ) {
				params = jQuery.param( params, jQuery.ajaxSettings.traditional );
				type = "POST";
			}
		}

		var self = this;

		// Request the remote document
		jQuery.ajax({
			url: url,
			type: type,
			dataType: "html",
			data: params,
			// Complete callback (responseText is used internally)
			complete: function( jqXHR, status, responseText ) {
				// Store the response as specified by the jqXHR object
				responseText = jqXHR.responseText;
				// If successful, inject the HTML into all the matched elements
				if ( jqXHR.isResolved() ) {
					// #4825: Get the actual response in case
					// a dataFilter is present in ajaxSettings
					jqXHR.done(function( r ) {
						responseText = r;
					});
					// See if a selector was specified
					self.html( selector ?
						// Create a dummy div to hold the results
						jQuery("<div>")
							// inject the contents of the document in, removing the scripts
							// to avoid any 'Permission Denied' errors in IE
							.append(responseText.replace(rscript, ""))

							// Locate the specified elements
							.find(selector) :

						// If not, just inject the full result
						responseText );
				}

				if ( callback ) {
					self.each( callback, [ responseText, status, jqXHR ] );
				}
			}
		});

		return this;
	},

	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},

	serializeArray: function() {
		return this.map(function(){
			return this.elements ? jQuery.makeArray( this.elements ) : this;
		})
		.filter(function(){
			return this.name && !this.disabled &&
				( this.checked || rselectTextarea.test( this.nodeName ) ||
					rinput.test( this.type ) );
		})
		.map(function( i, elem ){
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val, i ){
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});

// Attach a bunch of functions for handling common AJAX events
jQuery.each( "ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split( " " ), function( i, o ){
	jQuery.fn[ o ] = function( f ){
		return this.on( o, f );
	};
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			type: method,
			url: url,
			data: data,
			success: callback,
			dataType: type
		});
	};
});

jQuery.extend({

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		if ( settings ) {
			// Building a settings object
			ajaxExtend( target, jQuery.ajaxSettings );
		} else {
			// Extending ajaxSettings
			settings = target;
			target = jQuery.ajaxSettings;
		}
		ajaxExtend( target, settings );
		return target;
	},

	ajaxSettings: {
		url: ajaxLocation,
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		type: "GET",
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		processData: true,
		async: true,
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		traditional: false,
		headers: {},
		*/

		accepts: {
			xml: "application/xml, text/xml",
			html: "text/html",
			text: "text/plain",
			json: "application/json, text/javascript",
			"*": allTypes
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText"
		},

		// List of data converters
		// 1) key format is "source_type destination_type" (a single space in-between)
		// 2) the catchall symbol "*" can be used for source_type
		converters: {

			// Convert anything to text
			"* text": window.String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			context: true,
			url: true
		}
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var // Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events
			// It's the callbackContext if one was provided in the options
			// and if it's a DOM node or a jQuery collection
			globalEventContext = callbackContext !== s &&
				( callbackContext.nodeType || callbackContext instanceof jQuery ) ?
						jQuery( callbackContext ) : jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// ifModified key
			ifModifiedKey,
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// Response headers
			responseHeadersString,
			responseHeaders,
			// transport
			transport,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// The jqXHR state
			state = 0,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Fake xhr
			jqXHR = {

				readyState: 0,

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( !state ) {
						var lname = name.toLowerCase();
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match === undefined ? null : match;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					statusText = statusText || "abort";
					if ( transport ) {
						transport.abort( statusText );
					}
					done( 0, statusText );
					return this;
				}
			};

		// Callback for when everything is done
		// It is defined here because jslint complains if it is declared
		// at the end of the function (which would be more logical and readable)
		function done( status, nativeStatusText, responses, headers ) {

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			var isSuccess,
				success,
				error,
				statusText = nativeStatusText,
				response = responses ? ajaxHandleResponses( s, jqXHR, responses ) : undefined,
				lastModified,
				etag;

			// If successful, handle type chaining
			if ( status >= 200 && status < 300 || status === 304 ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {

					if ( ( lastModified = jqXHR.getResponseHeader( "Last-Modified" ) ) ) {
						jQuery.lastModified[ ifModifiedKey ] = lastModified;
					}
					if ( ( etag = jqXHR.getResponseHeader( "Etag" ) ) ) {
						jQuery.etag[ ifModifiedKey ] = etag;
					}
				}

				// If not modified
				if ( status === 304 ) {

					statusText = "notmodified";
					isSuccess = true;

				// If we have data
				} else {

					try {
						success = ajaxConvert( s, response );
						statusText = "success";
						isSuccess = true;
					} catch(e) {
						// We have a parsererror
						statusText = "parsererror";
						error = e;
					}
				}
			} else {
				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( !statusText || status ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = "" + ( nativeStatusText || statusText );

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajax" + ( isSuccess ? "Success" : "Error" ),
						[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		// Attach deferreds
		deferred.promise( jqXHR );
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;
		jqXHR.complete = completeDeferred.add;

		// Status-dependent callbacks
		jqXHR.statusCode = function( map ) {
			if ( map ) {
				var tmp;
				if ( state < 2 ) {
					for ( tmp in map ) {
						statusCode[ tmp ] = [ statusCode[tmp], map[tmp] ];
					}
				} else {
					tmp = map[ jqXHR.status ];
					jqXHR.then( tmp, tmp );
				}
			}
			return this;
		};

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// We also use the url parameter if available
		s.url = ( ( url || s.url ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().split( rspacesAjax );

		// Determine if a cross-domain request is in order
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] != ajaxLocParts[ 1 ] || parts[ 2 ] != ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? 80 : 443 ) ) !=
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? 80 : 443 ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return false;
		}

		// We can fire global events as of now if asked to
		fireGlobals = s.global;

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.data;
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Get ifModifiedKey before adding the anti-cache parameter
			ifModifiedKey = s.url;

			// Add anti-cache in url if needed
			if ( s.cache === false ) {

				var ts = jQuery.now(),
					// try replacing _= if it is there
					ret = s.url.replace( rts, "$1_=" + ts );

				// if nothing was replaced, add timestamp to the end
				s.url = ret + ( ( ret === s.url ) ? ( rquery.test( s.url ) ? "&" : "?" ) + "_=" + ts : "" );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			ifModifiedKey = ifModifiedKey || s.url;
			if ( jQuery.lastModified[ ifModifiedKey ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ ifModifiedKey ] );
			}
			if ( jQuery.etag[ ifModifiedKey ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ ifModifiedKey ] );
			}
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already
				jqXHR.abort();
				return false;

		}

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;
			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout( function(){
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch (e) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		return jqXHR;
	},

	// Serialize an array of form elements or a set of
	// key/values into a query string
	param: function( a, traditional ) {
		var s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : value;
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};

		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings.traditional;
		}

		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});

		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( var prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}

		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	}
});

function buildParams( prefix, obj, traditional, add ) {
	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// If array item is non-scalar (array or object), encode its
				// numeric index to resolve deserialization ambiguity issues.
				// Note that rack (as of 1.0.0) can't currently deserialize
				// nested arrays properly, and attempting to do so may cause
				// a server error. Possible fixes are to modify rack's
				// deserialization algorithm or to provide an option or flag
				// to force array serialization to be shallow.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( var name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// This is still on the jQuery object... for now
// Want to move this to jQuery.ajax some day
jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {}

});

/* Handles responses to an ajax request:
 * - sets all responseXXX fields accordingly
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var contents = s.contents,
		dataTypes = s.dataTypes,
		responseFields = s.responseFields,
		ct,
		type,
		finalDataType,
		firstDataType;

	// Fill responseXXX fields
	for ( type in responseFields ) {
		if ( type in responses ) {
			jqXHR[ responseFields[type] ] = responses[ type ];
		}
	}

	// Remove auto dataType and get content-type in the process
	while( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "content-type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

// Chain conversions given the request and the original response
function ajaxConvert( s, response ) {

	// Apply the dataFilter if provided
	if ( s.dataFilter ) {
		response = s.dataFilter( response, s.dataType );
	}

	var dataTypes = s.dataTypes,
		converters = {},
		i,
		key,
		length = dataTypes.length,
		tmp,
		// Current and previous dataTypes
		current = dataTypes[ 0 ],
		prev,
		// Conversion expression
		conversion,
		// Conversion function
		conv,
		// Conversion functions (transitive conversion)
		conv1,
		conv2;

	// For each dataType in the chain
	for ( i = 1; i < length; i++ ) {

		// Create converters map
		// with lowercased keys
		if ( i === 1 ) {
			for ( key in s.converters ) {
				if ( typeof key === "string" ) {
					converters[ key.toLowerCase() ] = s.converters[ key ];
				}
			}
		}

		// Get the dataTypes
		prev = current;
		current = dataTypes[ i ];

		// If current is auto dataType, update it to prev
		if ( current === "*" ) {
			current = prev;
		// If no auto and dataTypes are actually different
		} else if ( prev !== "*" && prev !== current ) {

			// Get the converter
			conversion = prev + " " + current;
			conv = converters[ conversion ] || converters[ "* " + current ];

			// If there is no direct converter, search transitively
			if ( !conv ) {
				conv2 = undefined;
				for ( conv1 in converters ) {
					tmp = conv1.split( " " );
					if ( tmp[ 0 ] === prev || tmp[ 0 ] === "*" ) {
						conv2 = converters[ tmp[1] + " " + current ];
						if ( conv2 ) {
							conv1 = converters[ conv1 ];
							if ( conv1 === true ) {
								conv = conv2;
							} else if ( conv2 === true ) {
								conv = conv1;
							}
							break;
						}
					}
				}
			}
			// If we found no converter, dispatch an error
			if ( !( conv || conv2 ) ) {
				jQuery.error( "No conversion from " + conversion.replace(" "," to ") );
			}
			// If found converter is not an equivalence
			if ( conv !== true ) {
				// Convert with 1 or 2 converters accordingly
				response = conv ? conv( response ) : conv2( conv1(response) );
			}
		}
	}
	return response;
}




var jsc = jQuery.now(),
	jsre = /(\=)\?(&|$)|\?\?/i;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		return jQuery.expando + "_" + ( jsc++ );
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var inspectData = ( typeof s.data === "string" ) && /^application\/x\-www\-form\-urlencoded/.test( s.contentType );

	if ( s.dataTypes[ 0 ] === "jsonp" ||
		s.jsonp !== false && ( jsre.test( s.url ) ||
				inspectData && jsre.test( s.data ) ) ) {

		var responseContainer,
			jsonpCallback = s.jsonpCallback =
				jQuery.isFunction( s.jsonpCallback ) ? s.jsonpCallback() : s.jsonpCallback,
			previous = window[ jsonpCallback ],
			url = s.url,
			data = s.data,
			replace = "$1" + jsonpCallback + "$2";

		if ( s.jsonp !== false ) {
			url = url.replace( jsre, replace );
			if ( s.url === url ) {
				if ( inspectData ) {
					data = data.replace( jsre, replace );
				}
				if ( s.data === data ) {
					// Add callback manually
					url += (/\?/.test( url ) ? "&" : "?") + s.jsonp + "=" + jsonpCallback;
				}
			}
		}

		s.url = url;
		s.data = data;

		// Install callback
		window[ jsonpCallback ] = function( response ) {
			responseContainer = [ response ];
		};

		// Clean-up function
		jqXHR.always(function() {
			// Set callback back to previous value
			window[ jsonpCallback ] = previous;
			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( previous ) ) {
				window[ jsonpCallback ]( responseContainer[ 0 ] );
			}
		});

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( jsonpCallback + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Delegate to script
		return "script";
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /javascript|ecmascript/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function(s) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || document.getElementsByTagName( "head" )[0] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement( "script" );

				script.async = "async";

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( head && script.parentNode ) {
							head.removeChild( script );
						}

						// Dereference the script
						script = undefined;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};
				// Use insertBefore instead of appendChild  to circumvent an IE6 bug.
				// This arises when a base node is used (#2709 and #4378).
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( 0, 1 );
				}
			}
		};
	}
});




var // #5280: Internet Explorer will keep connections alive if we don't abort on unload
	xhrOnUnloadAbort = window.ActiveXObject ? function() {
		// Abort all pending requests
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( 0, 1 );
		}
	} : false,
	xhrId = 0,
	xhrCallbacks;

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch( e ) {}
}

// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject ?
	/* Microsoft failed to properly
	 * implement the XMLHttpRequest in IE7 (can't request local files),
	 * so we use the ActiveXObject when it is available
	 * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
	 * we need a fallback.
	 */
	function() {
		return !this.isLocal && createStandardXHR() || createActiveXHR();
	} :
	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

// Determine support properties
(function( xhr ) {
	jQuery.extend( jQuery.support, {
		ajax: !!xhr,
		cors: !!xhr && ( "withCredentials" in xhr )
	});
})( jQuery.ajaxSettings.xhr() );

// Create transport if the browser can provide an xhr
if ( jQuery.support.ajax ) {

	jQuery.ajaxTransport(function( s ) {
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !s.crossDomain || jQuery.support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {

					// Get a new xhr
					var xhr = s.xhr(),
						handle,
						i;

					// Open the socket
					// Passing null username, generates a login popup on Opera (#2865)
					if ( s.username ) {
						xhr.open( s.type, s.url, s.async, s.username, s.password );
					} else {
						xhr.open( s.type, s.url, s.async );
					}

					// Apply custom fields if provided
					if ( s.xhrFields ) {
						for ( i in s.xhrFields ) {
							xhr[ i ] = s.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( s.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( s.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !s.crossDomain && !headers["X-Requested-With"] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Need an extra try/catch for cross domain requests in Firefox 3
					try {
						for ( i in headers ) {
							xhr.setRequestHeader( i, headers[ i ] );
						}
					} catch( _ ) {}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( s.hasContent && s.data ) || null );

					// Listener
					callback = function( _, isAbort ) {

						var status,
							statusText,
							responseHeaders,
							responses,
							xml;

						// Firefox throws exceptions when accessing properties
						// of an xhr when a network error occured
						// http://helpful.knobs-dials.com/index.php/Component_returned_failure_code:_0x80040111_(NS_ERROR_NOT_AVAILABLE)
						try {

							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {

								// Only called once
								callback = undefined;

								// Do not keep as active anymore
								if ( handle ) {
									xhr.onreadystatechange = jQuery.noop;
									if ( xhrOnUnloadAbort ) {
										delete xhrCallbacks[ handle ];
									}
								}

								// If it's an abort
								if ( isAbort ) {
									// Abort it manually if needed
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									status = xhr.status;
									responseHeaders = xhr.getAllResponseHeaders();
									responses = {};
									xml = xhr.responseXML;

									// Construct response list
									if ( xml && xml.documentElement /* #4958 */ ) {
										responses.xml = xml;
									}

									// When requesting binary data, IE6-9 will throw an exception
									// on any attempt to access responseText (#11426)
									try {
										responses.text = xhr.responseText;
									} catch( _ ) {
									}

									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch( e ) {
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}

									// Filter status for non standard behaviors

									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && s.isLocal && !s.crossDomain ) {
										status = responses.text ? 200 : 404;
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
						} catch( firefoxAccessException ) {
							if ( !isAbort ) {
								complete( -1, firefoxAccessException );
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, responseHeaders );
						}
					};

					// if we're in sync mode or it's in cache
					// and has been retrieved directly (IE6 & IE7)
					// we need to manually fire the callback
					if ( !s.async || xhr.readyState === 4 ) {
						callback();
					} else {
						handle = ++xhrId;
						if ( xhrOnUnloadAbort ) {
							// Create the active xhrs callbacks list if needed
							// and attach the unload handler
							if ( !xhrCallbacks ) {
								xhrCallbacks = {};
								jQuery( window ).unload( xhrOnUnloadAbort );
							}
							// Add to list of active xhrs callbacks
							xhrCallbacks[ handle ] = callback;
						}
						xhr.onreadystatechange = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback(0,1);
					}
				}
			};
		}
	});
}




var elemdisplay = {},
	iframe, iframeDoc,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,
	timerId,
	fxAttrs = [
		// height animations
		[ "height", "marginTop", "marginBottom", "paddingTop", "paddingBottom" ],
		// width animations
		[ "width", "marginLeft", "marginRight", "paddingLeft", "paddingRight" ],
		// opacity animations
		[ "opacity" ]
	],
	fxNow;

jQuery.fn.extend({
	show: function( speed, easing, callback ) {
		var elem, display;

		if ( speed || speed === 0 ) {
			return this.animate( genFx("show", 3), speed, easing, callback );

		} else {
			for ( var i = 0, j = this.length; i < j; i++ ) {
				elem = this[ i ];

				if ( elem.style ) {
					display = elem.style.display;

					// Reset the inline display of this element to learn if it is
					// being hidden by cascaded rules or not
					if ( !jQuery._data(elem, "olddisplay") && display === "none" ) {
						display = elem.style.display = "";
					}

					// Set elements which have been overridden with display: none
					// in a stylesheet to whatever the default browser style is
					// for such an element
					if ( (display === "" && jQuery.css(elem, "display") === "none") ||
						!jQuery.contains( elem.ownerDocument.documentElement, elem ) ) {
						jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
					}
				}
			}

			// Set the display of most of the elements in a second loop
			// to avoid the constant reflow
			for ( i = 0; i < j; i++ ) {
				elem = this[ i ];

				if ( elem.style ) {
					display = elem.style.display;

					if ( display === "" || display === "none" ) {
						elem.style.display = jQuery._data( elem, "olddisplay" ) || "";
					}
				}
			}

			return this;
		}
	},

	hide: function( speed, easing, callback ) {
		if ( speed || speed === 0 ) {
			return this.animate( genFx("hide", 3), speed, easing, callback);

		} else {
			var elem, display,
				i = 0,
				j = this.length;

			for ( ; i < j; i++ ) {
				elem = this[i];
				if ( elem.style ) {
					display = jQuery.css( elem, "display" );

					if ( display !== "none" && !jQuery._data( elem, "olddisplay" ) ) {
						jQuery._data( elem, "olddisplay", display );
					}
				}
			}

			// Set the display of the elements in a second loop
			// to avoid the constant reflow
			for ( i = 0; i < j; i++ ) {
				if ( this[i].style ) {
					this[i].style.display = "none";
				}
			}

			return this;
		}
	},

	// Save the old toggle function
	_toggle: jQuery.fn.toggle,

	toggle: function( fn, fn2, callback ) {
		var bool = typeof fn === "boolean";

		if ( jQuery.isFunction(fn) && jQuery.isFunction(fn2) ) {
			this._toggle.apply( this, arguments );

		} else if ( fn == null || bool ) {
			this.each(function() {
				var state = bool ? fn : jQuery(this).is(":hidden");
				jQuery(this)[ state ? "show" : "hide" ]();
			});

		} else {
			this.animate(genFx("toggle", 3), fn, fn2, callback);
		}

		return this;
	},

	fadeTo: function( speed, to, easing, callback ) {
		return this.filter(":hidden").css("opacity", 0).show().end()
					.animate({opacity: to}, speed, easing, callback);
	},

	animate: function( prop, speed, easing, callback ) {
		var optall = jQuery.speed( speed, easing, callback );

		if ( jQuery.isEmptyObject( prop ) ) {
			return this.each( optall.complete, [ false ] );
		}

		// Do not change referenced properties as per-property easing will be lost
		prop = jQuery.extend( {}, prop );

		function doAnimation() {
			// XXX 'this' does not always have a nodeName when running the
			// test suite

			if ( optall.queue === false ) {
				jQuery._mark( this );
			}

			var opt = jQuery.extend( {}, optall ),
				isElement = this.nodeType === 1,
				hidden = isElement && jQuery(this).is(":hidden"),
				name, val, p, e, hooks, replace,
				parts, start, end, unit,
				method;

			// will store per property easing and be used to determine when an animation is complete
			opt.animatedProperties = {};

			// first pass over propertys to expand / normalize
			for ( p in prop ) {
				name = jQuery.camelCase( p );
				if ( p !== name ) {
					prop[ name ] = prop[ p ];
					delete prop[ p ];
				}

				if ( ( hooks = jQuery.cssHooks[ name ] ) && "expand" in hooks ) {
					replace = hooks.expand( prop[ name ] );
					delete prop[ name ];

					// not quite $.extend, this wont overwrite keys already present.
					// also - reusing 'p' from above because we have the correct "name"
					for ( p in replace ) {
						if ( ! ( p in prop ) ) {
							prop[ p ] = replace[ p ];
						}
					}
				}
			}

			for ( name in prop ) {
				val = prop[ name ];
				// easing resolution: per property > opt.specialEasing > opt.easing > 'swing' (default)
				if ( jQuery.isArray( val ) ) {
					opt.animatedProperties[ name ] = val[ 1 ];
					val = prop[ name ] = val[ 0 ];
				} else {
					opt.animatedProperties[ name ] = opt.specialEasing && opt.specialEasing[ name ] || opt.easing || 'swing';
				}

				if ( val === "hide" && hidden || val === "show" && !hidden ) {
					return opt.complete.call( this );
				}

				if ( isElement && ( name === "height" || name === "width" ) ) {
					// Make sure that nothing sneaks out
					// Record all 3 overflow attributes because IE does not
					// change the overflow attribute when overflowX and
					// overflowY are set to the same value
					opt.overflow = [ this.style.overflow, this.style.overflowX, this.style.overflowY ];

					// Set display property to inline-block for height/width
					// animations on inline elements that are having width/height animated
					if ( jQuery.css( this, "display" ) === "inline" &&
							jQuery.css( this, "float" ) === "none" ) {

						// inline-level elements accept inline-block;
						// block-level elements need to be inline with layout
						if ( !jQuery.support.inlineBlockNeedsLayout || defaultDisplay( this.nodeName ) === "inline" ) {
							this.style.display = "inline-block";

						} else {
							this.style.zoom = 1;
						}
					}
				}
			}

			if ( opt.overflow != null ) {
				this.style.overflow = "hidden";
			}

			for ( p in prop ) {
				e = new jQuery.fx( this, opt, p );
				val = prop[ p ];

				if ( rfxtypes.test( val ) ) {

					// Tracks whether to show or hide based on private
					// data attached to the element
					method = jQuery._data( this, "toggle" + p ) || ( val === "toggle" ? hidden ? "show" : "hide" : 0 );
					if ( method ) {
						jQuery._data( this, "toggle" + p, method === "show" ? "hide" : "show" );
						e[ method ]();
					} else {
						e[ val ]();
					}

				} else {
					parts = rfxnum.exec( val );
					start = e.cur();

					if ( parts ) {
						end = parseFloat( parts[2] );
						unit = parts[3] || ( jQuery.cssNumber[ p ] ? "" : "px" );

						// We need to compute starting value
						if ( unit !== "px" ) {
							jQuery.style( this, p, (end || 1) + unit);
							start = ( (end || 1) / e.cur() ) * start;
							jQuery.style( this, p, start + unit);
						}

						// If a +=/-= token was provided, we're doing a relative animation
						if ( parts[1] ) {
							end = ( (parts[ 1 ] === "-=" ? -1 : 1) * end ) + start;
						}

						e.custom( start, end, unit );

					} else {
						e.custom( start, val, "" );
					}
				}
			}

			// For JS strict compliance
			return true;
		}

		return optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},

	stop: function( type, clearQueue, gotoEnd ) {
		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var index,
				hadTimers = false,
				timers = jQuery.timers,
				data = jQuery._data( this );

			// clear marker counters if we know they won't be
			if ( !gotoEnd ) {
				jQuery._unmark( true, this );
			}

			function stopQueue( elem, data, index ) {
				var hooks = data[ index ];
				jQuery.removeData( elem, index, true );
				hooks.stop( gotoEnd );
			}

			if ( type == null ) {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && index.indexOf(".run") === index.length - 4 ) {
						stopQueue( this, data, index );
					}
				}
			} else if ( data[ index = type + ".run" ] && data[ index ].stop ){
				stopQueue( this, data, index );
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					if ( gotoEnd ) {

						// force the next step to be the last
						timers[ index ]( true );
					} else {
						timers[ index ].saveState();
					}
					hadTimers = true;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( !( gotoEnd && hadTimers ) ) {
				jQuery.dequeue( this, type );
			}
		});
	}

});

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout( clearFxNow, 0 );
	return ( fxNow = jQuery.now() );
}

function clearFxNow() {
	fxNow = undefined;
}

// Generate parameters to create a standard animation
function genFx( type, num ) {
	var obj = {};

	jQuery.each( fxAttrs.concat.apply([], fxAttrs.slice( 0, num )), function() {
		obj[ this ] = type;
	});

	return obj;
}

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx( "show", 1 ),
	slideUp: genFx( "hide", 1 ),
	slideToggle: genFx( "toggle", 1 ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.extend({
	speed: function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};

		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function( noUnmark ) {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}

			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			} else if ( noUnmark !== false ) {
				jQuery._unmark( this );
			}
		};

		return opt;
	},

	easing: {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return ( -Math.cos( p*Math.PI ) / 2 ) + 0.5;
		}
	},

	timers: [],

	fx: function( elem, options, prop ) {
		this.options = options;
		this.elem = elem;
		this.prop = prop;

		options.orig = options.orig || {};
	}

});

jQuery.fx.prototype = {
	// Simple function for setting a style value
	update: function() {
		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		( jQuery.fx.step[ this.prop ] || jQuery.fx.step._default )( this );
	},

	// Get the current size
	cur: function() {
		if ( this.elem[ this.prop ] != null && (!this.elem.style || this.elem.style[ this.prop ] == null) ) {
			return this.elem[ this.prop ];
		}

		var parsed,
			r = jQuery.css( this.elem, this.prop );
		// Empty strings, null, undefined and "auto" are converted to 0,
		// complex values such as "rotate(1rad)" are returned as is,
		// simple values such as "10px" are parsed to Float.
		return isNaN( parsed = parseFloat( r ) ) ? !r || r === "auto" ? 0 : r : parsed;
	},

	// Start an animation from one number to another
	custom: function( from, to, unit ) {
		var self = this,
			fx = jQuery.fx;

		this.startTime = fxNow || createFxNow();
		this.end = to;
		this.now = this.start = from;
		this.pos = this.state = 0;
		this.unit = unit || this.unit || ( jQuery.cssNumber[ this.prop ] ? "" : "px" );

		function t( gotoEnd ) {
			return self.step( gotoEnd );
		}

		t.queue = this.options.queue;
		t.elem = this.elem;
		t.saveState = function() {
			if ( jQuery._data( self.elem, "fxshow" + self.prop ) === undefined ) {
				if ( self.options.hide ) {
					jQuery._data( self.elem, "fxshow" + self.prop, self.start );
				} else if ( self.options.show ) {
					jQuery._data( self.elem, "fxshow" + self.prop, self.end );
				}
			}
		};

		if ( t() && jQuery.timers.push(t) && !timerId ) {
			timerId = setInterval( fx.tick, fx.interval );
		}
	},

	// Simple 'show' function
	show: function() {
		var dataShow = jQuery._data( this.elem, "fxshow" + this.prop );

		// Remember where we started, so that we can go back to it later
		this.options.orig[ this.prop ] = dataShow || jQuery.style( this.elem, this.prop );
		this.options.show = true;

		// Begin the animation
		// Make sure that we start at a small width/height to avoid any flash of content
		if ( dataShow !== undefined ) {
			// This show is picking up where a previous hide or show left off
			this.custom( this.cur(), dataShow );
		} else {
			this.custom( this.prop === "width" || this.prop === "height" ? 1 : 0, this.cur() );
		}

		// Start by showing the element
		jQuery( this.elem ).show();
	},

	// Simple 'hide' function
	hide: function() {
		// Remember where we started, so that we can go back to it later
		this.options.orig[ this.prop ] = jQuery._data( this.elem, "fxshow" + this.prop ) || jQuery.style( this.elem, this.prop );
		this.options.hide = true;

		// Begin the animation
		this.custom( this.cur(), 0 );
	},

	// Each step of an animation
	step: function( gotoEnd ) {
		var p, n, complete,
			t = fxNow || createFxNow(),
			done = true,
			elem = this.elem,
			options = this.options;

		if ( gotoEnd || t >= options.duration + this.startTime ) {
			this.now = this.end;
			this.pos = this.state = 1;
			this.update();

			options.animatedProperties[ this.prop ] = true;

			for ( p in options.animatedProperties ) {
				if ( options.animatedProperties[ p ] !== true ) {
					done = false;
				}
			}

			if ( done ) {
				// Reset the overflow
				if ( options.overflow != null && !jQuery.support.shrinkWrapBlocks ) {

					jQuery.each( [ "", "X", "Y" ], function( index, value ) {
						elem.style[ "overflow" + value ] = options.overflow[ index ];
					});
				}

				// Hide the element if the "hide" operation was done
				if ( options.hide ) {
					jQuery( elem ).hide();
				}

				// Reset the properties, if the item has been hidden or shown
				if ( options.hide || options.show ) {
					for ( p in options.animatedProperties ) {
						jQuery.style( elem, p, options.orig[ p ] );
						jQuery.removeData( elem, "fxshow" + p, true );
						// Toggle data is no longer needed
						jQuery.removeData( elem, "toggle" + p, true );
					}
				}

				// Execute the complete function
				// in the event that the complete function throws an exception
				// we must ensure it won't be called twice. #5684

				complete = options.complete;
				if ( complete ) {

					options.complete = false;
					complete.call( elem );
				}
			}

			return false;

		} else {
			// classical easing cannot be used with an Infinity duration
			if ( options.duration == Infinity ) {
				this.now = t;
			} else {
				n = t - this.startTime;
				this.state = n / options.duration;

				// Perform the easing function, defaults to swing
				this.pos = jQuery.easing[ options.animatedProperties[this.prop] ]( this.state, n, 0, 1, options.duration );
				this.now = this.start + ( (this.end - this.start) * this.pos );
			}
			// Perform the next step of the animation
			this.update();
		}

		return true;
	}
};

jQuery.extend( jQuery.fx, {
	tick: function() {
		var timer,
			timers = jQuery.timers,
			i = 0;

		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}

		if ( !timers.length ) {
			jQuery.fx.stop();
		}
	},

	interval: 13,

	stop: function() {
		clearInterval( timerId );
		timerId = null;
	},

	speeds: {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	},

	step: {
		opacity: function( fx ) {
			jQuery.style( fx.elem, "opacity", fx.now );
		},

		_default: function( fx ) {
			if ( fx.elem.style && fx.elem.style[ fx.prop ] != null ) {
				fx.elem.style[ fx.prop ] = fx.now + fx.unit;
			} else {
				fx.elem[ fx.prop ] = fx.now;
			}
		}
	}
});

// Ensure props that can't be negative don't go there on undershoot easing
jQuery.each( fxAttrs.concat.apply( [], fxAttrs ), function( i, prop ) {
	// exclude marginTop, marginLeft, marginBottom and marginRight from this list
	if ( prop.indexOf( "margin" ) ) {
		jQuery.fx.step[ prop ] = function( fx ) {
			jQuery.style( fx.elem, prop, Math.max(0, fx.now) + fx.unit );
		};
	}
});

if ( jQuery.expr && jQuery.expr.filters ) {
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
}

// Try to restore the default display value of an element
function defaultDisplay( nodeName ) {

	if ( !elemdisplay[ nodeName ] ) {

		var body = document.body,
			elem = jQuery( "<" + nodeName + ">" ).appendTo( body ),
			display = elem.css( "display" );
		elem.remove();

		// If the simple way fails,
		// get element's real default display by attaching it to a temp iframe
		if ( display === "none" || display === "" ) {
			// No iframe to use yet, so create it
			if ( !iframe ) {
				iframe = document.createElement( "iframe" );
				iframe.frameBorder = iframe.width = iframe.height = 0;
			}

			body.appendChild( iframe );

			// Create a cacheable copy of the iframe document on first call.
			// IE and Opera will allow us to reuse the iframeDoc without re-writing the fake HTML
			// document to it; WebKit & Firefox won't allow reusing the iframe document.
			if ( !iframeDoc || !iframe.createElement ) {
				iframeDoc = ( iframe.contentWindow || iframe.contentDocument ).document;
				iframeDoc.write( ( jQuery.support.boxModel ? "<!doctype html>" : "" ) + "<html><body>" );
				iframeDoc.close();
			}

			elem = iframeDoc.createElement( nodeName );

			iframeDoc.body.appendChild( elem );

			display = jQuery.css( elem, "display" );
			body.removeChild( iframe );
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return elemdisplay[ nodeName ];
}




var getOffset,
	rtable = /^t(?:able|d|h)$/i,
	rroot = /^(?:body|html)$/i;

if ( "getBoundingClientRect" in document.documentElement ) {
	getOffset = function( elem, doc, docElem, box ) {
		try {
			box = elem.getBoundingClientRect();
		} catch(e) {}

		// Make sure we're not dealing with a disconnected DOM node
		if ( !box || !jQuery.contains( docElem, elem ) ) {
			return box ? { top: box.top, left: box.left } : { top: 0, left: 0 };
		}

		var body = doc.body,
			win = getWindow( doc ),
			clientTop  = docElem.clientTop  || body.clientTop  || 0,
			clientLeft = docElem.clientLeft || body.clientLeft || 0,
			scrollTop  = win.pageYOffset || jQuery.support.boxModel && docElem.scrollTop  || body.scrollTop,
			scrollLeft = win.pageXOffset || jQuery.support.boxModel && docElem.scrollLeft || body.scrollLeft,
			top  = box.top  + scrollTop  - clientTop,
			left = box.left + scrollLeft - clientLeft;

		return { top: top, left: left };
	};

} else {
	getOffset = function( elem, doc, docElem ) {
		var computedStyle,
			offsetParent = elem.offsetParent,
			prevOffsetParent = elem,
			body = doc.body,
			defaultView = doc.defaultView,
			prevComputedStyle = defaultView ? defaultView.getComputedStyle( elem, null ) : elem.currentStyle,
			top = elem.offsetTop,
			left = elem.offsetLeft;

		while ( (elem = elem.parentNode) && elem !== body && elem !== docElem ) {
			if ( jQuery.support.fixedPosition && prevComputedStyle.position === "fixed" ) {
				break;
			}

			computedStyle = defaultView ? defaultView.getComputedStyle(elem, null) : elem.currentStyle;
			top  -= elem.scrollTop;
			left -= elem.scrollLeft;

			if ( elem === offsetParent ) {
				top  += elem.offsetTop;
				left += elem.offsetLeft;

				if ( jQuery.support.doesNotAddBorder && !(jQuery.support.doesAddBorderForTableAndCells && rtable.test(elem.nodeName)) ) {
					top  += parseFloat( computedStyle.borderTopWidth  ) || 0;
					left += parseFloat( computedStyle.borderLeftWidth ) || 0;
				}

				prevOffsetParent = offsetParent;
				offsetParent = elem.offsetParent;
			}

			if ( jQuery.support.subtractsBorderForOverflowNotVisible && computedStyle.overflow !== "visible" ) {
				top  += parseFloat( computedStyle.borderTopWidth  ) || 0;
				left += parseFloat( computedStyle.borderLeftWidth ) || 0;
			}

			prevComputedStyle = computedStyle;
		}

		if ( prevComputedStyle.position === "relative" || prevComputedStyle.position === "static" ) {
			top  += body.offsetTop;
			left += body.offsetLeft;
		}

		if ( jQuery.support.fixedPosition && prevComputedStyle.position === "fixed" ) {
			top  += Math.max( docElem.scrollTop, body.scrollTop );
			left += Math.max( docElem.scrollLeft, body.scrollLeft );
		}

		return { top: top, left: left };
	};
}

jQuery.fn.offset = function( options ) {
	if ( arguments.length ) {
		return options === undefined ?
			this :
			this.each(function( i ) {
				jQuery.offset.setOffset( this, options, i );
			});
	}

	var elem = this[0],
		doc = elem && elem.ownerDocument;

	if ( !doc ) {
		return null;
	}

	if ( elem === doc.body ) {
		return jQuery.offset.bodyOffset( elem );
	}

	return getOffset( elem, doc, doc.documentElement );
};

jQuery.offset = {

	bodyOffset: function( body ) {
		var top = body.offsetTop,
			left = body.offsetLeft;

		if ( jQuery.support.doesNotIncludeMarginInBodyOffset ) {
			top  += parseFloat( jQuery.css(body, "marginTop") ) || 0;
			left += parseFloat( jQuery.css(body, "marginLeft") ) || 0;
		}

		return { top: top, left: left };
	},

	setOffset: function( elem, options, i ) {
		var position = jQuery.css( elem, "position" );

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		var curElem = jQuery( elem ),
			curOffset = curElem.offset(),
			curCSSTop = jQuery.css( elem, "top" ),
			curCSSLeft = jQuery.css( elem, "left" ),
			calculatePosition = ( position === "absolute" || position === "fixed" ) && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1,
			props = {}, curPosition = {}, curTop, curLeft;

		// need to be able to calculate position if either top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};


jQuery.fn.extend({

	position: function() {
		if ( !this[0] ) {
			return null;
		}

		var elem = this[0],

		// Get *real* offsetParent
		offsetParent = this.offsetParent(),

		// Get correct offsets
		offset       = this.offset(),
		parentOffset = rroot.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();

		// Subtract element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		offset.top  -= parseFloat( jQuery.css(elem, "marginTop") ) || 0;
		offset.left -= parseFloat( jQuery.css(elem, "marginLeft") ) || 0;

		// Add offsetParent borders
		parentOffset.top  += parseFloat( jQuery.css(offsetParent[0], "borderTopWidth") ) || 0;
		parentOffset.left += parseFloat( jQuery.css(offsetParent[0], "borderLeftWidth") ) || 0;

		// Subtract the two offsets
		return {
			top:  offset.top  - parentOffset.top,
			left: offset.left - parentOffset.left
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || document.body;
			while ( offsetParent && (!rroot.test(offsetParent.nodeName) && jQuery.css(offsetParent, "position") === "static") ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent;
		});
	}
});


// Create scrollLeft and scrollTop methods
jQuery.each( {scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return jQuery.access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? (prop in win) ? win[ prop ] :
					jQuery.support.boxModel && win.document.documentElement[ method ] ||
						win.document.body[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					 top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}




// Create width, height, innerHeight, innerWidth, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	var clientProp = "client" + name,
		scrollProp = "scroll" + name,
		offsetProp = "offset" + name;

	// innerHeight and innerWidth
	jQuery.fn[ "inner" + name ] = function() {
		var elem = this[0];
		return elem ?
			elem.style ?
			parseFloat( jQuery.css( elem, type, "padding" ) ) :
			this[ type ]() :
			null;
	};

	// outerHeight and outerWidth
	jQuery.fn[ "outer" + name ] = function( margin ) {
		var elem = this[0];
		return elem ?
			elem.style ?
			parseFloat( jQuery.css( elem, type, margin ? "margin" : "border" ) ) :
			this[ type ]() :
			null;
	};

	jQuery.fn[ type ] = function( value ) {
		return jQuery.access( this, function( elem, type, value ) {
			var doc, docElemProp, orig, ret;

			if ( jQuery.isWindow( elem ) ) {
				// 3rd condition allows Nokia support, as it supports the docElem prop but not CSS1Compat
				doc = elem.document;
				docElemProp = doc.documentElement[ clientProp ];
				return jQuery.support.boxModel && docElemProp ||
					doc.body && doc.body[ clientProp ] || docElemProp;
			}

			// Get document width or height
			if ( elem.nodeType === 9 ) {
				// Either scroll[Width/Height] or offset[Width/Height], whichever is greater
				doc = elem.documentElement;

				// when a window > document, IE6 reports a offset[Width/Height] > client[Width/Height]
				// so we can't use max, as it'll choose the incorrect offset[Width/Height]
				// instead we use the correct client[Width/Height]
				// support:IE6
				if ( doc[ clientProp ] >= doc[ scrollProp ] ) {
					return doc[ clientProp ];
				}

				return Math.max(
					elem.body[ scrollProp ], doc[ scrollProp ],
					elem.body[ offsetProp ], doc[ offsetProp ]
				);
			}

			// Get width or height on the element
			if ( value === undefined ) {
				orig = jQuery.css( elem, type );
				ret = parseFloat( orig );
				return jQuery.isNumeric( ret ) ? ret : orig;
			}

			// Set the width or height on the element
			jQuery( elem ).css( type, value );
		}, type, value, arguments.length, null );
	};
});




// Expose jQuery to the global object
window.jQuery = window.$ = jQuery;

// Expose jQuery as an AMD module, but only for AMD loaders that
// understand the issues with loading multiple versions of jQuery
// in a page that all might call define(). The loader will indicate
// they have special allowances for multiple jQuery versions by
// specifying define.amd.jQuery = true. Register as a named module,
// since jQuery can be concatenated with other files that may use define,
// but not use a proper concatenation script that understands anonymous
// AMD modules. A named AMD is safest and most robust way to register.
// Lowercase jquery is used because AMD module names are derived from
// file names, and jQuery is normally delivered in a lowercase file name.
// Do this after creating the global so that if an AMD module wants to call
// noConflict to hide this version of jQuery, it will work.
if ( typeof define === "function" && define.amd && define.amd.jQuery ) {
	define( "jquery", [], function () { return jQuery; } );
}



})( window );

/*!
 * jQuery Placeholder Plugin v2.3.1
 * https://github.com/mathiasbynens/jquery-placeholder
 *
 * Copyright 2011, 2015 Mathias Bynens
 * Released under the MIT license
 */
(function(factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define('jquery-placeholder',['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {

    /****
     * Allows plugin behavior simulation in modern browsers for easier debugging. 
     * When setting to true, use attribute "placeholder-x" rather than the usual "placeholder" in your inputs/textareas 
     * i.e. <input type="text" placeholder-x="my placeholder text" />
     */
    var debugMode = false; 

    // Opera Mini v7 doesn't support placeholder although its DOM seems to indicate so
    var isOperaMini = Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
    var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini && !debugMode;
    var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini && !debugMode;
    var valHooks = $.valHooks;
    var propHooks = $.propHooks;
    var hooks;
    var placeholder;
    var settings = {};

    if (isInputSupported && isTextareaSupported) {

        placeholder = $.fn.placeholder = function() {
            return this;
        };

        placeholder.input = true;
        placeholder.textarea = true;

    } else {

        placeholder = $.fn.placeholder = function(options) {

            var defaults = {customClass: 'placeholder'};
            settings = $.extend({}, defaults, options);

            return this.filter((isInputSupported ? 'textarea' : ':input') + '[' + (debugMode ? 'placeholder-x' : 'placeholder') + ']')
                .not('.'+settings.customClass)
                .not(':radio, :checkbox, [type=hidden]')
                .bind({
                    'focus.placeholder': clearPlaceholder,
                    'blur.placeholder': setPlaceholder
                })
                .data('placeholder-enabled', true)
                .trigger('blur.placeholder');
        };

        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;

        hooks = {
            'get': function(element) {

                var $element = $(element);
                var $passwordInput = $element.data('placeholder-password');

                if ($passwordInput) {
                    return $passwordInput[0].value;
                }

                return $element.data('placeholder-enabled') && $element.hasClass(settings.customClass) ? '' : element.value;
            },
            'set': function(element, value) {

                var $element = $(element);
                var $replacement;
                var $passwordInput;

                if (value !== '') {

                    $replacement = $element.data('placeholder-textinput');
                    $passwordInput = $element.data('placeholder-password');

                    if ($replacement) {
                        clearPlaceholder.call($replacement[0], true, value) || (element.value = value);
                        $replacement[0].value = value;

                    } else if ($passwordInput) {
                        clearPlaceholder.call(element, true, value) || ($passwordInput[0].value = value);
                        element.value = value;
                    }
                }

                if (!$element.data('placeholder-enabled')) {
                    element.value = value;
                    return $element;
                }

                if (value === '') {
                    
                    element.value = value;
                    
                    // Setting the placeholder causes problems if the element continues to have focus.
                    if (element != safeActiveElement()) {
                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
                        setPlaceholder.call(element);
                    }

                } else {
                    
                    if ($element.hasClass(settings.customClass)) {
                        clearPlaceholder.call(element);
                    }

                    element.value = value;
                }
                // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };

        if (!isInputSupported) {
            valHooks.input = hooks;
            propHooks.value = hooks;
        }

        if (!isTextareaSupported) {
            valHooks.textarea = hooks;
            propHooks.value = hooks;
        }

        $(function() {
            // Look for forms
            $(document).delegate('form', 'submit.placeholder', function() {
                
                // Clear the placeholder values so they don't get submitted
                var $inputs = $('.'+settings.customClass, this).each(function() {
                    clearPlaceholder.call(this, true, '');
                });

                setTimeout(function() {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });

        // Clear placeholder values upon page reload
        $(window).bind('beforeunload.placeholder', function() {

            var clearPlaceholders = true;

            try {
                // Prevent IE javascript:void(0) anchors from causing cleared values
                if (document.activeElement.toString() === 'javascript:void(0)') {
                    clearPlaceholders = false;
                }
            } catch (exception) { }

            if (clearPlaceholders) {
                $('.'+settings.customClass).each(function() {
                    this.value = '';
                });
            }
        });
    }

    function args(elem) {
        // Return an object of element attributes
        var newAttrs = {};
        var rinlinejQuery = /^jQuery\d+$/;

        $.each(elem.attributes, function(i, attr) {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });

        return newAttrs;
    }

    function clearPlaceholder(event, value) {
        
        var input = this;
        var $input = $(this);
        
        if (input.value === $input.attr((debugMode ? 'placeholder-x' : 'placeholder')) && $input.hasClass(settings.customClass)) {
            
            input.value = '';
            $input.removeClass(settings.customClass);

            if ($input.data('placeholder-password')) {

                $input = $input.hide().nextAll('input[type="password"]:first').show().attr('id', $input.removeAttr('id').data('placeholder-id'));
                
                // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) {
                    $input[0].value = value;

                    return value;
                }

                $input.focus();

            } else {
                input == safeActiveElement() && input.select();
            }
        }
    }

    function setPlaceholder(event) {
        var $replacement;
        var input = this;
        var $input = $(this);
        var id = input.id;

        // If the placeholder is activated, triggering blur event (`$input.trigger('blur')`) should do nothing.
        if (event && event.type === 'blur' && $input.hasClass(settings.customClass)) {
            return;
        }

        if (input.value === '') {
            if (input.type === 'password') {
                if (!$input.data('placeholder-textinput')) {
                    
                    try {
                        $replacement = $input.clone().prop({ 'type': 'text' });
                    } catch(e) {
                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
                    }

                    $replacement
                        .removeAttr('name')
                        .data({
                            'placeholder-enabled': true,
                            'placeholder-password': $input,
                            'placeholder-id': id
                        })
                        .bind('focus.placeholder', clearPlaceholder);

                    $input
                        .data({
                            'placeholder-textinput': $replacement,
                            'placeholder-id': id
                        })
                        .before($replacement);
                }

                input.value = '';
                $input = $input.removeAttr('id').hide().prevAll('input[type="text"]:first').attr('id', $input.data('placeholder-id')).show();

            } else {
                
                var $passwordInput = $input.data('placeholder-password');

                if ($passwordInput) {
                    $passwordInput[0].value = '';
                    $input.attr('id', $input.data('placeholder-id')).show().nextAll('input[type="password"]:last').hide().removeAttr('id');
                }
            }

            $input.addClass(settings.customClass);
            $input[0].value = $input.attr((debugMode ? 'placeholder-x' : 'placeholder'));

        } else {
            $input.removeClass(settings.customClass);
        }
    }

    function safeActiveElement() {
        // Avoid IE9 `document.activeElement` of death
        try {
            return document.activeElement;
        } catch (exception) {}
    }
}));

/*
 * css.normalize.js
 *
 * CSS Normalization
 *
 * CSS paths are normalized based on an optional basePath and the RequireJS config
 *
 * Usage:
 *   normalize(css, fromBasePath, toBasePath);
 *
 * css: the stylesheet content to normalize
 * fromBasePath: the absolute base path of the css relative to any root (but without ../ backtracking)
 * toBasePath: the absolute new base path of the css relative to the same root
 * 
 * Absolute dependencies are left untouched.
 *
 * Urls in the CSS are picked up by regular expressions.
 * These will catch all statements of the form:
 *
 * url(*)
 * url('*')
 * url("*")
 * 
 * @import '*'
 * @import "*"
 *
 * (and so also @import url(*) variations)
 *
 * For urls needing normalization
 *
 */

define('normalize',['require', 'module'], function(require, module) {
  
  // regular expression for removing double slashes
  // eg http://www.example.com//my///url/here -> http://www.example.com/my/url/here
  var slashes = /([^:])\/+/g
  var removeDoubleSlashes = function(uri) {
    return uri.replace(slashes, '$1/');
  }

  // given a relative URI, and two absolute base URIs, convert it from one base to another
  var protocolRegEx = /[^\:\/]*:\/\/([^\/])*/
  function convertURIBase(uri, fromBase, toBase) {
    if(uri.indexOf("data:") === 0)
      return uri;
    uri = removeDoubleSlashes(uri);
    // absolute urls are left in tact
    if (uri.match(/^\//) || uri.match(protocolRegEx))
      return uri;
    // if toBase specifies a protocol path, ensure this is the same protocol as fromBase, if not
    // use absolute path at fromBase
    var toBaseProtocol = toBase.match(protocolRegEx);
    var fromBaseProtocol = fromBase.match(protocolRegEx);
    if (fromBaseProtocol && (!toBaseProtocol || toBaseProtocol[1] != fromBaseProtocol[1] || toBaseProtocol[2] != fromBaseProtocol[2]))
      return absoluteURI(uri, fromBase);
    
    else {
      return relativeURI(absoluteURI(uri, fromBase), toBase);
    }
  };
  
  // given a relative URI, calculate the absolute URI
  function absoluteURI(uri, base) {
    if (uri.substr(0, 2) == './')
      uri = uri.substr(2);    
    
    var baseParts = base.split('/');
    var uriParts = uri.split('/');
    
    baseParts.pop();
    
    while (curPart = uriParts.shift())
      if (curPart == '..')
        baseParts.pop();
      else
        baseParts.push(curPart);
    
    return baseParts.join('/');
  };


  // given an absolute URI, calculate the relative URI
  function relativeURI(uri, base) {
    
    // reduce base and uri strings to just their difference string
    var baseParts = base.split('/');
    baseParts.pop();
    base = baseParts.join('/') + '/';
    i = 0;
    while (base.substr(i, 1) == uri.substr(i, 1))
      i++;
    while (base.substr(i, 1) != '/')
      i--;
    base = base.substr(i + 1);
    uri = uri.substr(i + 1);

    // each base folder difference is thus a backtrack
    baseParts = base.split('/');
    var uriParts = uri.split('/');
    out = '';
    while (baseParts.shift())
      out += '../';
    
    // finally add uri parts
    while (curPart = uriParts.shift())
      out += curPart + '/';
    
    return out.substr(0, out.length - 1);
  };
  
  var normalizeCSS = function(source, fromBase, toBase, cssBase) {

    fromBase = removeDoubleSlashes(fromBase);
    toBase = removeDoubleSlashes(toBase);

    var urlRegEx = /@import\s*("([^"]*)"|'([^']*)')|url\s*\(\s*(\s*"([^"]*)"|'([^']*)'|[^\)]*\s*)\s*\)/ig;
    var result, url, source;

    while (result = urlRegEx.exec(source)) {
      url = result[3] || result[2] || result[5] || result[6] || result[4];
      var newUrl;
      if (cssBase && url.substr(0, 1) == '/')
        newUrl = cssBase + url;
      else
        newUrl = convertURIBase(url, fromBase, toBase);
      var quoteLen = result[5] || result[6] ? 1 : 0;
      source = source.substr(0, urlRegEx.lastIndex - url.length - quoteLen - 1) + newUrl + source.substr(urlRegEx.lastIndex - quoteLen - 1);
      urlRegEx.lastIndex = urlRegEx.lastIndex + (newUrl.length - url.length);
    }
    
    return source;
  };
  
  normalizeCSS.convertURIBase = convertURIBase;
  
  return normalizeCSS;
});

/*
 * Require-CSS RequireJS css! loader plugin
 * 0.0.8
 * Guy Bedford 2013
 * MIT
 */

/*
 *
 * Usage:
 *  require(['css!./mycssFile']);
 *
 * NB leave out the '.css' extension.
 *
 * - Fully supports cross origin CSS loading
 * - Works with builds
 *
 * Tested and working in (up to latest versions as of March 2013):
 * Android
 * iOS 6
 * IE 6 - 10
 * Chome 3 - 26
 * Firefox 3.5 - 19
 * Opera 10 - 12
 * 
 * browserling.com used for virtual testing environment
 *
 * Credit to B Cavalier & J Hann for the elegant IE 6 - 9 hack.
 * 
 * Sources that helped along the way:
 * - https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
 * - http://www.phpied.com/when-is-a-stylesheet-really-loaded/
 * - https://github.com/cujojs/curl/blob/master/src/curl/plugin/css.js
 *
 */

define('css',['./normalize'], function(normalize) {
  function indexOf(a, e) { for (var i=0, l=a.length; i < l; i++) if (a[i] === e) return i; return -1 }

  if (typeof window == 'undefined')
    return { load: function(n, r, load){ load() } };

  // set to true to enable test prompts for device testing
  var testing = false;
  
  var head = document.getElementsByTagName('head')[0];

  var engine = window.navigator.userAgent.match(/Trident\/([^ ;]*)|AppleWebKit\/([^ ;]*)|Opera\/([^ ;]*)|rv\:([^ ;]*)(.*?)Gecko\/([^ ;]*)|MSIE\s([^ ;]*)/);
  var hackLinks = false;

  if (!engine) {}
  else if (engine[1] || engine[7]) {
    hackLinks = parseInt(engine[1]) < 6 || parseInt(engine[7]) <= 9;
    engine = 'trident';
  }
  else if (engine[2]) {
    // unfortunately style querying still doesnt work with onload callback in webkit
    hackLinks = true;
    engine = 'webkit';
  }
  else if (engine[3]) {
    // engine = 'opera';
  }
  else if (engine[4]) {
    hackLinks = parseInt(engine[4]) < 18;
    engine = 'gecko';
  }
  else if (testing)
    alert('Engine detection failed');
  
  //main api object
  var cssAPI = {};

  var absUrlRegEx = /^\/|([^\:\/]*:)/;
  
  cssAPI.pluginBuilder = './css-builder';

  // used by layer builds to register their css buffers
  
  // the current layer buffer items (from addBuffer)
  var curBuffer = [];

  // the callbacks for buffer loads
  var onBufferLoad = {};

  // the full list of resources in the buffer
  var bufferResources = [];

  cssAPI.addBuffer = function(resourceId) {
    // just in case layer scripts are included twice, also check
    // against the previous buffers
    if (indexOf(curBuffer, resourceId) != -1)
      return;
    if (indexOf(bufferResources, resourceId) != -1)
      return;
    curBuffer.push(resourceId);
    bufferResources.push(resourceId);
  }
  cssAPI.setBuffer = function(css, isLess) {
    var pathname = window.location.pathname.split('/');
    pathname.pop();
    pathname = pathname.join('/') + '/';

    var baseParts = require.toUrl('base_url').split('/');
    baseParts.pop();
    var baseUrl = baseParts.join('/') + '/';
    baseUrl = normalize.convertURIBase(baseUrl, pathname, '/');
    if (!baseUrl.match(absUrlRegEx))
      baseUrl = '/' + baseUrl;
    if (baseUrl.substr(baseUrl.length - 1, 1) != '/')
      baseUrl = baseUrl + '/';

    cssAPI.inject(normalize(css, baseUrl, pathname));

    // set up attach callback if registered
    // clear the current buffer for the next layer
    // (just the less or css part as we have two buffers in one effectively)
    for (var i = 0; i < curBuffer.length; i++) {
      // find the resources in the less or css buffer dependening which one this is
      if ((isLess && curBuffer[i].substr(curBuffer[i].length - 5, 5) == '.less') ||
        (!isLess && curBuffer[i].substr(curBuffer[i].length - 4, 4) == '.css')) {
        (function(resourceId) {
          // mark that the onBufferLoad is about to be called (set to true if not already a callback function)
          onBufferLoad[resourceId] = onBufferLoad[resourceId] || true;

          // set a short timeout (as injection isn't instant in Chrome), then call the load
          setTimeout(function() {
            if (typeof onBufferLoad[resourceId] == 'function')
              onBufferLoad[resourceId]();
            // remove from onBufferLoad to indicate loaded
            delete onBufferLoad[resourceId];
          }, 7);
        })(curBuffer[i]);

        // remove the current resource from the buffer
        curBuffer.splice(i--, 1);
      }
    }
  }
  cssAPI.attachBuffer = function(resourceId, load) {
    // attach can happen during buffer collecting, or between injection and callback
    // we assume it is not possible to attach multiple callbacks
    // requirejs plugin load function ensures this by queueing duplicate calls

    // check if the resourceId is in the current buffer
    for (var i = 0; i < curBuffer.length; i++)
      if (curBuffer[i] == resourceId) {
        onBufferLoad[resourceId] = load;
        return true;
      }

    // check if the resourceId is waiting for injection callback
    // (onBufferLoad === true is a shortcut indicator for this)
    if (onBufferLoad[resourceId] === true) {
      onBufferLoad[resourceId] = load;
      return true;
    }

    // if it's in the full buffer list and not either of the above, its loaded already
    if (indexOf(bufferResources, resourceId) != -1) {
      load();
      return true;
    }
  }

  var webkitLoadCheck = function(link, callback) {
    setTimeout(function() {
      for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (sheet.href == link.href)
          return callback();
      }
      webkitLoadCheck(link, callback);
    }, 10);
  }

  var mozillaLoadCheck = function(style, callback) {
    setTimeout(function() {
      try {
        style.sheet.cssRules;
        return callback();
      } catch (e){}
      mozillaLoadCheck(style, callback);
    }, 10);
  }

  // ie link detection, as adapted from https://github.com/cujojs/curl/blob/master/src/curl/plugin/css.js
  if (engine == 'trident' && hackLinks) {
    var ieStyles = [],
      ieQueue = [],
      ieStyleCnt = 0;
    var ieLoad = function(url, callback) {
      var style;
      ieQueue.push({
        url: url,
        cb: callback
      });
      style = ieStyles.shift();
      if (!style && ieStyleCnt++ < 31) {
        style = document.createElement('style');
        head.appendChild(style);
      }
      if (style)
        ieLoadNextImport(style);
    }
    var ieLoadNextImport = function(style) {
      var curImport = ieQueue.shift();
      if (!curImport) {
        style.onload = noop;
        ieStyles.push(style);
        return;  
      }
      style.onload = function() {
        curImport.cb(curImport.ss);
        ieLoadNextImport(style);
      };
      var curSheet = style.styleSheet;
      curImport.ss = curSheet.imports[curSheet.addImport(curImport.url)];
    }
  }

  // uses the <link> load method
  var createLink = function(url) {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    return link;
  }

  var noop = function(){}

  cssAPI.linkLoad = function(url, callback) {
    var timeout = setTimeout(function() {
      if (testing) alert('timeout');
      callback();
    }, waitSeconds * 1000 - 100);
    var _callback = function() {
      clearTimeout(timeout);
      if (link)
        link.onload = noop;
      // for style querying, a short delay still seems necessary
      setTimeout(callback, 7);
    }
    if (!hackLinks) {
      var link = createLink(url);
      link.onload = _callback;
      head.appendChild(link);
    }
    // hacks
    else {
      if (engine == 'webkit') {
        var link = createLink(url);
        webkitLoadCheck(link, _callback);
        head.appendChild(link);
      }
      else if (engine == 'gecko') {
        var style = document.createElement('style');
        style.textContent = '@import "' + url + '"';
        mozillaLoadCheck(style, _callback);
        head.appendChild(style);
      }
      else if (engine == 'trident')
        ieLoad(url, _callback);
    }
  }

  /* injection api */
  var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
  var fileCache = {};
  var get = function(url, callback, errback) {
    if (fileCache[url]) {
      callback(fileCache[url]);
      return;
    }

    var xhr, i, progId;
    if (typeof XMLHttpRequest !== 'undefined')
      xhr = new XMLHttpRequest();
    else if (typeof ActiveXObject !== 'undefined')
      for (i = 0; i < 3; i += 1) {
        progId = progIds[i];
        try {
          xhr = new ActiveXObject(progId);
        }
        catch (e) {}
  
        if (xhr) {
          progIds = [progId];  // so faster next time
          break;
        }
      }
    
    xhr.open('GET', url, requirejs.inlineRequire ? false : true);
  
    xhr.onreadystatechange = function (evt) {
      var status, err;
      //Do not explicitly handle errors, those should be
      //visible via console output in the browser.
      if (xhr.readyState === 4) {
        status = xhr.status;
        if (status > 399 && status < 600) {
          //An http 4xx or 5xx error. Signal an error.
          err = new Error(url + ' HTTP status: ' + status);
          err.xhr = xhr;
          errback(err);
        }
        else {
          fileCache[url] = xhr.responseText;
          callback(xhr.responseText);
        }
      }
    };
    
    xhr.send(null);
  }
  //uses the <style> load method
  var styleCnt = 0;
  var curStyle;
  cssAPI.inject = function(css) {
    if (styleCnt < 31) {
      curStyle = document.createElement('style');
      curStyle.type = 'text/css';
      head.appendChild(curStyle);
      styleCnt++;
    }
    if (curStyle.styleSheet)
      curStyle.styleSheet.cssText += css;
    else
      curStyle.appendChild(document.createTextNode(css));
  }
  
  // NB add @media query support for media imports
  var importRegEx = /@import\s*(url)?\s*(('([^']*)'|"([^"]*)")|\(('([^']*)'|"([^"]*)"|([^\)]*))\))\s*;?/g;

  var pathname = window.location.pathname.split('/');
  pathname.pop();
  pathname = pathname.join('/') + '/';

  var loadCSS = function(fileUrl, callback, errback) {

    //make file url absolute
    if (!fileUrl.match(absUrlRegEx))
      fileUrl = '/' + normalize.convertURIBase(fileUrl, pathname, '/');

    get(fileUrl, function(css) {

      // normalize the css (except import statements)
      css = normalize(css, fileUrl, pathname);

      // detect all import statements in the css and normalize
      var importUrls = [];
      var importIndex = [];
      var importLength = [];
      var match;
      while (match = importRegEx.exec(css)) {
        var importUrl = match[4] || match[5] || match[7] || match[8] || match[9];

        importUrls.push(importUrl);
        importIndex.push(importRegEx.lastIndex - match[0].length);
        importLength.push(match[0].length);
      }

      // load the import stylesheets and substitute into the css
      var completeCnt = 0;
      for (var i = 0; i < importUrls.length; i++)
        (function(i) {
          loadCSS(importUrls[i], function(importCSS) {
            css = css.substr(0, importIndex[i]) + importCSS + css.substr(importIndex[i] + importLength[i]);
            var lenDiff = importCSS.length - importLength[i];
            for (var j = i + 1; j < importUrls.length; j++)
              importIndex[j] += lenDiff;
            completeCnt++;
            if (completeCnt == importUrls.length) {
              callback(css);
            }
          }, errback);
        })(i);

      if (importUrls.length == 0)
        callback(css);
    }, errback);
  }

  
  cssAPI.normalize = function(name, normalize) {
    if (name.substr(name.length - 4, 4) == '.css')
      name = name.substr(0, name.length - 4);
    
    return normalize(name);
  }
  
  var waitSeconds;
  var alerted = false;
  cssAPI.load = function(cssId, req, load, config, parse) {
    
    waitSeconds = waitSeconds || config.waitSeconds || 7;

    var resourceId = cssId + (!parse ? '.css' : '.less');

    // attach the load function to a buffer if there is one in registration
    // if not, we do a full injection load
    if (cssAPI.attachBuffer(resourceId, load))
      return;

    var fileUrl = req.toUrl(resourceId);
    
    if (!alerted && testing) {
      alert(hackLinks ? 'hacking links' : 'not hacking');
      alerted = true;
    }

    if (!parse) {
      cssAPI.linkLoad(fileUrl, load);
    }
    else {
      loadCSS(fileUrl, function(css) {
        // run parsing after normalization - since less is a CSS subset this works fine
        if (parse)
          css = parse(css, function(css) {
            cssAPI.inject(css);
            setTimeout(load, 7);
          });
      });
    }
  }

  if (testing)
    cssAPI.inspect = function() {
      if (stylesheet.styleSheet)
        return stylesheet.styleSheet.cssText;
      else if (stylesheet.innerHTML)
        return stylesheet.innerHTML;
    }
  
  return cssAPI;
});


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('jquery-ui-custom-css.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*!
 * jQuery UI 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI
 */
(function( $, undefined ) {

// prevent duplicate loading
// this is only a problem because we proxy existing functions
// and we don't want to double proxy them
$.ui = $.ui || {};
if ( $.ui.version ) {
	return;
}

$.extend( $.ui, {
	version: "1.8.18",

	keyCode: {
		ALT: 18,
		BACKSPACE: 8,
		CAPS_LOCK: 20,
		COMMA: 188,
		COMMAND: 91,
		COMMAND_LEFT: 91, // COMMAND
		COMMAND_RIGHT: 93,
		CONTROL: 17,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		INSERT: 45,
		LEFT: 37,
		MENU: 93, // COMMAND_RIGHT
		NUMPAD_ADD: 107,
		NUMPAD_DECIMAL: 110,
		NUMPAD_DIVIDE: 111,
		NUMPAD_ENTER: 108,
		NUMPAD_MULTIPLY: 106,
		NUMPAD_SUBTRACT: 109,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SHIFT: 16,
		SPACE: 32,
		TAB: 9,
		UP: 38,
		WINDOWS: 91 // COMMAND
	}
});

// plugins
$.fn.extend({
	propAttr: $.fn.prop || $.fn.attr,

	_focus: $.fn.focus,
	focus: function( delay, fn ) {
		return typeof delay === "number" ?
			this.each(function() {
				var elem = this;
				setTimeout(function() {
					$( elem ).focus();
					if ( fn ) {
						fn.call( elem );
					}
				}, delay );
			}) :
			this._focus.apply( this, arguments );
	},

	scrollParent: function() {
		var scrollParent;
		if (($.browser.msie && (/(static|relative)/).test(this.css('position'))) || (/absolute/).test(this.css('position'))) {
			scrollParent = this.parents().filter(function() {
				return (/(relative|absolute|fixed)/).test($.curCSS(this,'position',1)) && (/(auto|scroll)/).test($.curCSS(this,'overflow',1)+$.curCSS(this,'overflow-y',1)+$.curCSS(this,'overflow-x',1));
			}).eq(0);
		} else {
			scrollParent = this.parents().filter(function() {
				return (/(auto|scroll)/).test($.curCSS(this,'overflow',1)+$.curCSS(this,'overflow-y',1)+$.curCSS(this,'overflow-x',1));
			}).eq(0);
		}

		return (/fixed/).test(this.css('position')) || !scrollParent.length ? $(document) : scrollParent;
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	},

	disableSelection: function() {
		return this.bind( ( $.support.selectstart ? "selectstart" : "mousedown" ) +
			".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
	},

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	}
});

$.each( [ "Width", "Height" ], function( i, name ) {
	var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
		type = name.toLowerCase(),
		orig = {
			innerWidth: $.fn.innerWidth,
			innerHeight: $.fn.innerHeight,
			outerWidth: $.fn.outerWidth,
			outerHeight: $.fn.outerHeight
		};

	function reduce( elem, size, border, margin ) {
		$.each( side, function() {
			size -= parseFloat( $.curCSS( elem, "padding" + this, true) ) || 0;
			if ( border ) {
				size -= parseFloat( $.curCSS( elem, "border" + this + "Width", true) ) || 0;
			}
			if ( margin ) {
				size -= parseFloat( $.curCSS( elem, "margin" + this, true) ) || 0;
			}
		});
		return size;
	}

	$.fn[ "inner" + name ] = function( size ) {
		if ( size === undefined ) {
			return orig[ "inner" + name ].call( this );
		}

		return this.each(function() {
			$( this ).css( type, reduce( this, size ) + "px" );
		});
	};

	$.fn[ "outer" + name] = function( size, margin ) {
		if ( typeof size !== "number" ) {
			return orig[ "outer" + name ].call( this, size );
		}

		return this.each(function() {
			$( this).css( type, reduce( this, size, true, margin ) + "px" );
		});
	};
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		var map = element.parentNode,
			mapName = map.name,
			img;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap=#" + mapName + "]" )[0];
		return !!img && visible( img );
	}
	return ( /input|select|textarea|button|object/.test( nodeName )
		? !element.disabled
		: "a" == nodeName
			? element.href || isTabIndexNotNaN
			: isTabIndexNotNaN)
		// the element and all of its ancestors must be visible
		&& visible( element );
}

function visible( element ) {
	return !$( element ).parents().andSelf().filter(function() {
		return $.curCSS( this, "visibility" ) === "hidden" ||
			$.expr.filters.hidden( this );
	}).length;
}

$.extend( $.expr[ ":" ], {
	data: function( elem, i, match ) {
		return !!$.data( elem, match[ 3 ] );
	},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support
$(function() {
	var body = document.body,
		div = body.appendChild( div = document.createElement( "div" ) );

	// access offsetHeight before setting the style to prevent a layout bug
	// in IE 9 which causes the elemnt to continue to take up space even
	// after it is removed from the DOM (#8026)
	div.offsetHeight;

	$.extend( div.style, {
		minHeight: "100px",
		height: "auto",
		padding: 0,
		borderWidth: 0
	});

	$.support.minHeight = div.offsetHeight === 100;
	$.support.selectstart = "onselectstart" in div;

	// set display to none to avoid a layout bug in IE
	// http://dev.jquery.com/ticket/4014
	body.removeChild( div ).style.display = "none";
});





// deprecated
$.extend( $.ui, {
	// $.ui.plugin is deprecated.  Use the proxy pattern instead.
	plugin: {
		add: function( module, option, set ) {
			var proto = $.ui[ module ].prototype;
			for ( var i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args ) {
			var set = instance.plugins[ name ];
			if ( !set || !instance.element[ 0 ].parentNode ) {
				return;
			}
	
			for ( var i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	},
	
	// will be deprecated when we switch to jQuery 1.4 - use jQuery.contains()
	contains: function( a, b ) {
		return document.compareDocumentPosition ?
			a.compareDocumentPosition( b ) & 16 :
			a !== b && a.contains( b );
	},
	
	// only used by resizable
	hasScroll: function( el, a ) {
	
		//If overflow is hidden, the element might have extra content, but the user wants to hide it
		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}
	
		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;
	
		if ( el[ scroll ] > 0 ) {
			return true;
		}
	
		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},
	
	// these are odd functions, fix the API or move into individual plugins
	isOverAxis: function( x, reference, size ) {
		//Determines when x coordinate is over "b" element axis
		return ( x > reference ) && ( x < ( reference + size ) );
	},
	isOver: function( y, x, top, left, height, width ) {
		//Determines when x, y coordinates is over "b" element
		return $.ui.isOverAxis( y, top, height ) && $.ui.isOverAxis( x, left, width );
	}
});

})( jQuery );
/*!
 * jQuery UI Widget 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Widget
 */
(function( $, undefined ) {

// jQuery 1.4+
if ( $.cleanData ) {
	var _cleanData = $.cleanData;
	$.cleanData = function( elems ) {
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			// http://bugs.jquery.com/ticket/8235
			} catch( e ) {}
		}
		_cleanData( elems );
	};
} else {
	var _remove = $.fn.remove;
	$.fn.remove = function( selector, keepData ) {
		return this.each(function() {
			if ( !keepData ) {
				if ( !selector || $.filter( selector, [ this ] ).length ) {
					$( "*", this ).add( [ this ] ).each(function() {
						try {
							$( this ).triggerHandler( "remove" );
						// http://bugs.jquery.com/ticket/8235
						} catch( e ) {}
					});
				}
			}
			return _remove.call( $(this), selector, keepData );
		});
	};
}

$.widget = function( name, base, prototype ) {
	var namespace = name.split( "." )[ 0 ],
		fullName;
	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName ] = function( elem ) {
		return !!$.data( elem, name );
	};

	$[ namespace ] = $[ namespace ] || {};
	$[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without initializing for simple inheritance
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	var basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
//	$.each( basePrototype, function( key, val ) {
//		if ( $.isPlainObject(val) ) {
//			basePrototype[ key ] = $.extend( {}, val );
//		}
//	});
	basePrototype.options = $.extend( true, {}, basePrototype.options );
	$[ namespace ][ name ].prototype = $.extend( true, basePrototype, {
		namespace: namespace,
		widgetName: name,
		widgetEventPrefix: $[ namespace ][ name ].prototype.widgetEventPrefix || name,
		widgetBaseClass: fullName
	}, prototype );

	$.widget.bridge( name, $[ namespace ][ name ] );
};

$.widget.bridge = function( name, object ) {
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = Array.prototype.slice.call( arguments, 1 ),
			returnValue = this;

		// allow multiple hashes to be passed on init
		options = !isMethodCall && args.length ?
			$.extend.apply( null, [ true, options ].concat(args) ) :
			options;

		// prevent calls to internal methods
		if ( isMethodCall && options.charAt( 0 ) === "_" ) {
			return returnValue;
		}

		if ( isMethodCall ) {
			this.each(function() {
				var instance = $.data( this, name ),
					methodValue = instance && $.isFunction( instance[options] ) ?
						instance[ options ].apply( instance, args ) :
						instance;
				// TODO: add this back in 1.9 and use $.error() (see #5972)
//				if ( !instance ) {
//					throw "cannot call methods on " + name + " prior to initialization; " +
//						"attempted to call method '" + options + "'";
//				}
//				if ( !$.isFunction( instance[options] ) ) {
//					throw "no such method '" + options + "' for " + name + " widget instance";
//				}
//				var methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue;
					return false;
				}
			});
		} else {
			this.each(function() {
				var instance = $.data( this, name );
				if ( instance ) {
					instance.option( options || {} )._init();
				} else {
					$.data( this, name, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( options, element ) {
	// allow instantiation without initializing for simple inheritance
	if ( arguments.length ) {
		this._createWidget( options, element );
	}
};

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	options: {
		disabled: false
	},
	_createWidget: function( options, element ) {
		// $.widget.bridge stores the plugin instance, but we do it anyway
		// so that it's stored even before the _create function runs
		$.data( element, this.widgetName, this );
		this.element = $( element );
		this.options = $.extend( true, {},
			this.options,
			this._getCreateOptions(),
			options );

		var self = this;
		this.element.bind( "remove." + this.widgetName, function() {
			self.destroy();
		});

		this._create();
		this._trigger( "create" );
		this._init();
	},
	_getCreateOptions: function() {
		return $.metadata && $.metadata.get( this.element[0] )[ this.widgetName ];
	},
	_create: function() {},
	_init: function() {},

	destroy: function() {
		this.element
			.unbind( "." + this.widgetName )
			.removeData( this.widgetName );
		this.widget()
			.unbind( "." + this.widgetName )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetBaseClass + "-disabled " +
				"ui-state-disabled" );
	},

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.extend( {}, this.options );
		}

		if  (typeof key === "string" ) {
			if ( value === undefined ) {
				return this.options[ key ];
			}
			options = {};
			options[ key ] = value;
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var self = this;
		$.each( options, function( key, value ) {
			self._setOption( key, value );
		});

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				[ value ? "addClass" : "removeClass"](
					this.widgetBaseClass + "-disabled" + " " +
					"ui-state-disabled" )
				.attr( "aria-disabled", value );
		}

		return this;
	},

	enable: function() {
		return this._setOption( "disabled", false );
	},
	disable: function() {
		return this._setOption( "disabled", true );
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );

		return !( $.isFunction(callback) &&
			callback.call( this.element[0], event, data ) === false ||
			event.isDefaultPrevented() );
	}
};

})( jQuery );
/*!
 * jQuery UI Mouse 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Mouse
 *
 * Depends:
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

var mouseHandled = false;
$( document ).mouseup( function( e ) {
	mouseHandled = false;
});

$.widget("ui.mouse", {
	options: {
		cancel: ':input,option',
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var self = this;

		this.element
			.bind('mousedown.'+this.widgetName, function(event) {
				return self._mouseDown(event);
			})
			.bind('click.'+this.widgetName, function(event) {
				if (true === $.data(event.target, self.widgetName + '.preventClickEvent')) {
				    $.removeData(event.target, self.widgetName + '.preventClickEvent');
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind('.'+this.widgetName);
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if( mouseHandled ) { return };

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var self = this,
			btnIsLeft = (event.which == 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel == "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				self.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + '.preventClickEvent')) {
			$.removeData(event.target, this.widgetName + '.preventClickEvent');
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return self._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return self._mouseUp(event);
		};
		$(document)
			.bind('mousemove.'+this.widgetName, this._mouseMoveDelegate)
			.bind('mouseup.'+this.widgetName, this._mouseUpDelegate);

		event.preventDefault();
		
		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// IE mouseup check - mouseup happened when mouse was out of window
		if ($.browser.msie && !(document.documentMode >= 9) && !event.button) {
			return this._mouseUp(event);
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		$(document)
			.unbind('mousemove.'+this.widgetName, this._mouseMoveDelegate)
			.unbind('mouseup.'+this.widgetName, this._mouseUpDelegate);

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target == this._mouseDownEvent.target) {
			    $.data(event.target, this.widgetName + '.preventClickEvent', true);
			}

			this._mouseStop(event);
		}

		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(event) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(event) {},
	_mouseDrag: function(event) {},
	_mouseStop: function(event) {},
	_mouseCapture: function(event) { return true; }
});

})(jQuery);
/*
 * jQuery UI Draggable 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Draggables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget("ui.draggable", $.ui.mouse, {
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false
	},
	_create: function() {

		if (this.options.helper == 'original' && !(/^(?:r|a|f)/).test(this.element.css("position")))
			this.element[0].style.position = 'relative';

		(this.options.addClasses && this.element.addClass("ui-draggable"));
		(this.options.disabled && this.element.addClass("ui-draggable-disabled"));

		this._mouseInit();

	},

	destroy: function() {
		if(!this.element.data('draggable')) return;
		this.element
			.removeData("draggable")
			.unbind(".draggable")
			.removeClass("ui-draggable"
				+ " ui-draggable-dragging"
				+ " ui-draggable-disabled");
		this._mouseDestroy();

		return this;
	},

	_mouseCapture: function(event) {

		var o = this.options;

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).is('.ui-resizable-handle'))
			return false;

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle)
			return false;
		
		if ( o.iframeFix ) {
			$(o.iframeFix === true ? "iframe" : o.iframeFix).each(function() {
				$('<div class="ui-draggable-iframeFix" style="background: #fff;"></div>')
				.css({
					width: this.offsetWidth+"px", height: this.offsetHeight+"px",
					position: "absolute", opacity: "0.001", zIndex: 1000
				})
				.css($(this).offset())
				.appendTo("body");
			});
		}

		return true;

	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if($.ui.ddmanager)
			$.ui.ddmanager.current = this;

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css("position");
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.positionAbs = this.element.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend(this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
		});

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition(event);
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if 'cursorAt' is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		if(o.containment)
			this._setContainment();

		//Trigger event + callbacks
		if(this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour)
			$.ui.ddmanager.prepareOffsets(this, event);

		this.helper.addClass("ui-draggable-dragging");
		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position
		
		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) $.ui.ddmanager.dragStart(this, event);
		
		return true;
	},

	_mouseDrag: function(event, noPropagation) {

		//Compute the helpers position
		this.position = this._generatePosition(event);
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if(this._trigger('drag', event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		if(!this.options.axis || this.options.axis != "y") this.helper[0].style.left = this.position.left+'px';
		if(!this.options.axis || this.options.axis != "x") this.helper[0].style.top = this.position.top+'px';
		if($.ui.ddmanager) $.ui.ddmanager.drag(this, event);

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour)
			dropped = $.ui.ddmanager.drop(this, event);

		//if a drop comes from outside (a sortable)
		if(this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}
		
		//if the original element is removed, don't bother to continue if helper is set to "original"
		if((!this.element[0] || !this.element[0].parentNode) && this.options.helper == "original")
			return false;

		if((this.options.revert == "invalid" && !dropped) || (this.options.revert == "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			var self = this;
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if(self._trigger("stop", event) !== false) {
					self._clear();
				}
			});
		} else {
			if(this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},
	
	_mouseUp: function(event) {
		if (this.options.iframeFix === true) {
			$("div.ui-draggable-iframeFix").each(function() { 
				this.parentNode.removeChild(this); 
			}); //Remove frame helpers
		}
		
		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if( $.ui.ddmanager ) $.ui.ddmanager.dragStop(this, event);
		
		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},
	
	cancel: function() {
		
		if(this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}
		
		return this;
		
	},

	_getHandle: function(event) {

		var handle = !this.options.handle || !$(this.options.handle, this.element).length ? true : false;
		$(this.options.handle, this.element)
			.find("*")
			.andSelf()
			.each(function() {
				if(this == event.target) handle = true;
			});

		return handle;

	},

	_createHelper: function(event) {

		var o = this.options;
		var helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event])) : (o.helper == 'clone' ? this.element.clone().removeAttr('id') : this.element);

		if(!helper.parents('body').length)
			helper.appendTo((o.appendTo == 'parent' ? this.element[0].parentNode : o.appendTo));

		if(helper[0] != this.element[0] && !(/(fixed|absolute)/).test(helper.css("position")))
			helper.css("position", "absolute");

		return helper;

	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj == 'string') {
			obj = obj.split(' ');
		}
		if ($.isArray(obj)) {
			obj = {left: +obj[0], top: +obj[1] || 0};
		}
		if ('left' in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ('right' in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ('top' in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ('bottom' in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if(this.cssPosition == 'absolute' && this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if((this.offsetParent[0] == document.body) //This needs to be actually done for all browsers, since pageX/pageY includes this information
		|| (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && $.browser.msie)) //Ugly IE fix
			po = { top: 0, left: 0 };

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
		};

	},

	_getRelativeOffset: function() {

		if(this.cssPosition == "relative") {
			var p = this.element.position();
			return {
				top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
				left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"),10) || 0),
			top: (parseInt(this.element.css("marginTop"),10) || 0),
			right: (parseInt(this.element.css("marginRight"),10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"),10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var o = this.options;
		if(o.containment == 'parent') o.containment = this.helper[0].parentNode;
		if(o.containment == 'document' || o.containment == 'window') this.containment = [
			o.containment == 'document' ? 0 : $(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
			o.containment == 'document' ? 0 : $(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
			(o.containment == 'document' ? 0 : $(window).scrollLeft()) + $(o.containment == 'document' ? document : window).width() - this.helperProportions.width - this.margins.left,
			(o.containment == 'document' ? 0 : $(window).scrollTop()) + ($(o.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
		];

		if(!(/^(document|window|parent)$/).test(o.containment) && o.containment.constructor != Array) {
		        var c = $(o.containment);
			var ce = c[0]; if(!ce) return;
			var co = c.offset();
			var over = ($(ce).css("overflow") != 'hidden');

			this.containment = [
				(parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0),
				(parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0),
				(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right,
				(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top  - this.margins.bottom
			];
			this.relative_container = c;

		} else if(o.containment.constructor == Array) {
			this.containment = o.containment;
		}

	},

	_convertPositionTo: function(d, pos) {

		if(!pos) pos = this.position;
		var mod = d == "absolute" ? 1 : -1;
		var o = this.options, scroll = this.cssPosition == 'absolute' && !(this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		return {
			top: (
				pos.top																	// The absolute mouse position
				+ this.offset.relative.top * mod										// Only for relative positioned nodes: Relative offset from element to offset parent
				+ this.offset.parent.top * mod											// The offsetParent's offset without borders (offset + border)
				- ($.browser.safari && $.browser.version < 526 && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
			),
			left: (
				pos.left																// The absolute mouse position
				+ this.offset.relative.left * mod										// Only for relative positioned nodes: Relative offset from element to offset parent
				+ this.offset.parent.left * mod											// The offsetParent's offset without borders (offset + border)
				- ($.browser.safari && $.browser.version < 526 && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
			)
		};

	},

	_generatePosition: function(event) {

		var o = this.options, scroll = this.cssPosition == 'absolute' && !(this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);
		var pageX = event.pageX;
		var pageY = event.pageY;

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if(this.originalPosition) { //If we are not dragging yet, we won't check for options
		         var containment;
		         if(this.containment) {
				 if (this.relative_container){
				     var co = this.relative_container.offset();
				     containment = [ this.containment[0] + co.left,
						     this.containment[1] + co.top,
						     this.containment[2] + co.left,
						     this.containment[3] + co.top ];
				 }
				 else {
				     containment = this.containment;
				 }

				if(event.pageX - this.offset.click.left < containment[0]) pageX = containment[0] + this.offset.click.left;
				if(event.pageY - this.offset.click.top < containment[1]) pageY = containment[1] + this.offset.click.top;
				if(event.pageX - this.offset.click.left > containment[2]) pageX = containment[2] + this.offset.click.left;
				if(event.pageY - this.offset.click.top > containment[3]) pageY = containment[3] + this.offset.click.top;
			}

			if(o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				var top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? (!(top - this.offset.click.top < containment[1] || top - this.offset.click.top > containment[3]) ? top : (!(top - this.offset.click.top < containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				var left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? (!(left - this.offset.click.left < containment[0] || left - this.offset.click.left > containment[2]) ? left : (!(left - this.offset.click.left < containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

		}

		return {
			top: (
				pageY																// The absolute mouse position
				- this.offset.click.top													// Click offset (relative to the element)
				- this.offset.relative.top												// Only for relative positioned nodes: Relative offset from element to offset parent
				- this.offset.parent.top												// The offsetParent's offset without borders (offset + border)
				+ ($.browser.safari && $.browser.version < 526 && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
			),
			left: (
				pageX																// The absolute mouse position
				- this.offset.click.left												// Click offset (relative to the element)
				- this.offset.relative.left												// Only for relative positioned nodes: Relative offset from element to offset parent
				- this.offset.parent.left												// The offsetParent's offset without borders (offset + border)
				+ ($.browser.safari && $.browser.version < 526 && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if(this.helper[0] != this.element[0] && !this.cancelHelperRemoval) this.helper.remove();
		//if($.ui.ddmanager) $.ui.ddmanager.current = null;
		this.helper = null;
		this.cancelHelperRemoval = false;
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function(type, event, ui) {
		ui = ui || this._uiHash();
		$.ui.plugin.call(this, type, [event, ui]);
		if(type == "drag") this.positionAbs = this._convertPositionTo("absolute"); //The absolute position has to be recalculated after plugins
		return $.Widget.prototype._trigger.call(this, type, event, ui);
	},

	plugins: {},

	_uiHash: function(event) {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.extend($.ui.draggable, {
	version: "1.8.18"
});

$.ui.plugin.add("draggable", "connectToSortable", {
	start: function(event, ui) {

		var inst = $(this).data("draggable"), o = inst.options,
			uiSortable = $.extend({}, ui, { item: inst.element });
		inst.sortables = [];
		$(o.connectToSortable).each(function() {
			var sortable = $.data(this, 'sortable');
			if (sortable && !sortable.options.disabled) {
				inst.sortables.push({
					instance: sortable,
					shouldRevert: sortable.options.revert
				});
				sortable.refreshPositions();	// Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
				sortable._trigger("activate", event, uiSortable);
			}
		});

	},
	stop: function(event, ui) {

		//If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
		var inst = $(this).data("draggable"),
			uiSortable = $.extend({}, ui, { item: inst.element });

		$.each(inst.sortables, function() {
			if(this.instance.isOver) {

				this.instance.isOver = 0;

				inst.cancelHelperRemoval = true; //Don't remove the helper in the draggable instance
				this.instance.cancelHelperRemoval = false; //Remove it in the sortable instance (so sortable plugins like revert still work)

				//The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: 'valid/invalid'
				if(this.shouldRevert) this.instance.options.revert = true;

				//Trigger the stop of the sortable
				this.instance._mouseStop(event);

				this.instance.options.helper = this.instance.options._helper;

				//If the helper has been the original item, restore properties in the sortable
				if(inst.options.helper == 'original')
					this.instance.currentItem.css({ top: 'auto', left: 'auto' });

			} else {
				this.instance.cancelHelperRemoval = false; //Remove the helper in the sortable instance
				this.instance._trigger("deactivate", event, uiSortable);
			}

		});

	},
	drag: function(event, ui) {

		var inst = $(this).data("draggable"), self = this;

		var checkPos = function(o) {
			var dyClick = this.offset.click.top, dxClick = this.offset.click.left;
			var helperTop = this.positionAbs.top, helperLeft = this.positionAbs.left;
			var itemHeight = o.height, itemWidth = o.width;
			var itemTop = o.top, itemLeft = o.left;

			return $.ui.isOver(helperTop + dyClick, helperLeft + dxClick, itemTop, itemLeft, itemHeight, itemWidth);
		};

		$.each(inst.sortables, function(i) {
			
			//Copy over some variables to allow calling the sortable's native _intersectsWith
			this.instance.positionAbs = inst.positionAbs;
			this.instance.helperProportions = inst.helperProportions;
			this.instance.offset.click = inst.offset.click;
			
			if(this.instance._intersectsWith(this.instance.containerCache)) {

				//If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
				if(!this.instance.isOver) {

					this.instance.isOver = 1;
					//Now we fake the start of dragging for the sortable instance,
					//by cloning the list group item, appending it to the sortable and using it as inst.currentItem
					//We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
					this.instance.currentItem = $(self).clone().removeAttr('id').appendTo(this.instance.element).data("sortable-item", true);
					this.instance.options._helper = this.instance.options.helper; //Store helper option to later restore it
					this.instance.options.helper = function() { return ui.helper[0]; };

					event.target = this.instance.currentItem[0];
					this.instance._mouseCapture(event, true);
					this.instance._mouseStart(event, true, true);

					//Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
					this.instance.offset.click.top = inst.offset.click.top;
					this.instance.offset.click.left = inst.offset.click.left;
					this.instance.offset.parent.left -= inst.offset.parent.left - this.instance.offset.parent.left;
					this.instance.offset.parent.top -= inst.offset.parent.top - this.instance.offset.parent.top;

					inst._trigger("toSortable", event);
					inst.dropped = this.instance.element; //draggable revert needs that
					//hack so receive/update callbacks work (mostly)
					inst.currentItem = inst.element;
					this.instance.fromOutside = inst;

				}

				//Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
				if(this.instance.currentItem) this.instance._mouseDrag(event);

			} else {

				//If it doesn't intersect with the sortable, and it intersected before,
				//we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
				if(this.instance.isOver) {

					this.instance.isOver = 0;
					this.instance.cancelHelperRemoval = true;
					
					//Prevent reverting on this forced stop
					this.instance.options.revert = false;
					
					// The out event needs to be triggered independently
					this.instance._trigger('out', event, this.instance._uiHash(this.instance));
					
					this.instance._mouseStop(event, true);
					this.instance.options.helper = this.instance.options._helper;

					//Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
					this.instance.currentItem.remove();
					if(this.instance.placeholder) this.instance.placeholder.remove();

					inst._trigger("fromSortable", event);
					inst.dropped = false; //draggable revert needs that
				}

			};

		});

	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function(event, ui) {
		var t = $('body'), o = $(this).data('draggable').options;
		if (t.css("cursor")) o._cursor = t.css("cursor");
		t.css("cursor", o.cursor);
	},
	stop: function(event, ui) {
		var o = $(this).data('draggable').options;
		if (o._cursor) $('body').css("cursor", o._cursor);
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function(event, ui) {
		var t = $(ui.helper), o = $(this).data('draggable').options;
		if(t.css("opacity")) o._opacity = t.css("opacity");
		t.css('opacity', o.opacity);
	},
	stop: function(event, ui) {
		var o = $(this).data('draggable').options;
		if(o._opacity) $(ui.helper).css('opacity', o._opacity);
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function(event, ui) {
		var i = $(this).data("draggable");
		if(i.scrollParent[0] != document && i.scrollParent[0].tagName != 'HTML') i.overflowOffset = i.scrollParent.offset();
	},
	drag: function(event, ui) {

		var i = $(this).data("draggable"), o = i.options, scrolled = false;

		if(i.scrollParent[0] != document && i.scrollParent[0].tagName != 'HTML') {

			if(!o.axis || o.axis != 'x') {
				if((i.overflowOffset.top + i.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity)
					i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop + o.scrollSpeed;
				else if(event.pageY - i.overflowOffset.top < o.scrollSensitivity)
					i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop - o.scrollSpeed;
			}

			if(!o.axis || o.axis != 'y') {
				if((i.overflowOffset.left + i.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity)
					i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft + o.scrollSpeed;
				else if(event.pageX - i.overflowOffset.left < o.scrollSensitivity)
					i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft - o.scrollSpeed;
			}

		} else {

			if(!o.axis || o.axis != 'x') {
				if(event.pageY - $(document).scrollTop() < o.scrollSensitivity)
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity)
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
			}

			if(!o.axis || o.axis != 'y') {
				if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity)
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity)
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
			}

		}

		if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour)
			$.ui.ddmanager.prepareOffsets(i, event);

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function(event, ui) {

		var i = $(this).data("draggable"), o = i.options;
		i.snapElements = [];

		$(o.snap.constructor != String ? ( o.snap.items || ':data(draggable)' ) : o.snap).each(function() {
			var $t = $(this); var $o = $t.offset();
			if(this != i.element[0]) i.snapElements.push({
				item: this,
				width: $t.outerWidth(), height: $t.outerHeight(),
				top: $o.top, left: $o.left
			});
		});

	},
	drag: function(event, ui) {

		var inst = $(this).data("draggable"), o = inst.options;
		var d = o.snapTolerance;

		var x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (var i = inst.snapElements.length - 1; i >= 0; i--){

			var l = inst.snapElements[i].left, r = l + inst.snapElements[i].width,
				t = inst.snapElements[i].top, b = t + inst.snapElements[i].height;

			//Yes, I know, this is insane ;)
			if(!((l-d < x1 && x1 < r+d && t-d < y1 && y1 < b+d) || (l-d < x1 && x1 < r+d && t-d < y2 && y2 < b+d) || (l-d < x2 && x2 < r+d && t-d < y1 && y1 < b+d) || (l-d < x2 && x2 < r+d && t-d < y2 && y2 < b+d))) {
				if(inst.snapElements[i].snapping) (inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				inst.snapElements[i].snapping = false;
				continue;
			}

			if(o.snapMode != 'inner') {
				var ts = Math.abs(t - y2) <= d;
				var bs = Math.abs(b - y1) <= d;
				var ls = Math.abs(l - x2) <= d;
				var rs = Math.abs(r - x1) <= d;
				if(ts) ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
				if(bs) ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top - inst.margins.top;
				if(ls) ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left - inst.margins.left;
				if(rs) ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left - inst.margins.left;
			}

			var first = (ts || bs || ls || rs);

			if(o.snapMode != 'outer') {
				var ts = Math.abs(t - y1) <= d;
				var bs = Math.abs(b - y2) <= d;
				var ls = Math.abs(l - x1) <= d;
				var rs = Math.abs(r - x2) <= d;
				if(ts) ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top - inst.margins.top;
				if(bs) ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
				if(ls) ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left - inst.margins.left;
				if(rs) ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left - inst.margins.left;
			}

			if(!inst.snapElements[i].snapping && (ts || bs || ls || rs || first))
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		};

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function(event, ui) {

		var o = $(this).data("draggable").options;

		var group = $.makeArray($(o.stack)).sort(function(a,b) {
			return (parseInt($(a).css("zIndex"),10) || 0) - (parseInt($(b).css("zIndex"),10) || 0);
		});
		if (!group.length) { return; }
		
		var min = parseInt(group[0].style.zIndex) || 0;
		$(group).each(function(i) {
			this.style.zIndex = min + i;
		});

		this[0].style.zIndex = min + group.length;

	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function(event, ui) {
		var t = $(ui.helper), o = $(this).data("draggable").options;
		if(t.css("zIndex")) o._zIndex = t.css("zIndex");
		t.css('zIndex', o.zIndex);
	},
	stop: function(event, ui) {
		var o = $(this).data("draggable").options;
		if(o._zIndex) $(ui.helper).css('zIndex', o._zIndex);
	}
});

})(jQuery);
/*
 * jQuery UI Droppable 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Droppables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.mouse.js
 *	jquery.ui.draggable.js
 */
(function( $, undefined ) {

$.widget("ui.droppable", {
	widgetEventPrefix: "drop",
	options: {
		accept: '*',
		activeClass: false,
		addClasses: true,
		greedy: false,
		hoverClass: false,
		scope: 'default',
		tolerance: 'intersect'
	},
	_create: function() {

		var o = this.options, accept = o.accept;
		this.isover = 0; this.isout = 1;

		this.accept = $.isFunction(accept) ? accept : function(d) {
			return d.is(accept);
		};

		//Store the droppable's proportions
		this.proportions = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[o.scope] = $.ui.ddmanager.droppables[o.scope] || [];
		$.ui.ddmanager.droppables[o.scope].push(this);

		(o.addClasses && this.element.addClass("ui-droppable"));

	},

	destroy: function() {
		var drop = $.ui.ddmanager.droppables[this.options.scope];
		for ( var i = 0; i < drop.length; i++ )
			if ( drop[i] == this )
				drop.splice(i, 1);

		this.element
			.removeClass("ui-droppable ui-droppable-disabled")
			.removeData("droppable")
			.unbind(".droppable");

		return this;
	},

	_setOption: function(key, value) {

		if(key == 'accept') {
			this.accept = $.isFunction(value) ? value : function(d) {
				return d.is(value);
			};
		}
		$.Widget.prototype._setOption.apply(this, arguments);
	},

	_activate: function(event) {
		var draggable = $.ui.ddmanager.current;
		if(this.options.activeClass) this.element.addClass(this.options.activeClass);
		(draggable && this._trigger('activate', event, this.ui(draggable)));
	},

	_deactivate: function(event) {
		var draggable = $.ui.ddmanager.current;
		if(this.options.activeClass) this.element.removeClass(this.options.activeClass);
		(draggable && this._trigger('deactivate', event, this.ui(draggable)));
	},

	_over: function(event) {

		var draggable = $.ui.ddmanager.current;
		if (!draggable || (draggable.currentItem || draggable.element)[0] == this.element[0]) return; // Bail if draggable and droppable are same element

		if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
			if(this.options.hoverClass) this.element.addClass(this.options.hoverClass);
			this._trigger('over', event, this.ui(draggable));
		}

	},

	_out: function(event) {

		var draggable = $.ui.ddmanager.current;
		if (!draggable || (draggable.currentItem || draggable.element)[0] == this.element[0]) return; // Bail if draggable and droppable are same element

		if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
			if(this.options.hoverClass) this.element.removeClass(this.options.hoverClass);
			this._trigger('out', event, this.ui(draggable));
		}

	},

	_drop: function(event,custom) {

		var draggable = custom || $.ui.ddmanager.current;
		if (!draggable || (draggable.currentItem || draggable.element)[0] == this.element[0]) return false; // Bail if draggable and droppable are same element

		var childrenIntersection = false;
		this.element.find(":data(droppable)").not(".ui-draggable-dragging").each(function() {
			var inst = $.data(this, 'droppable');
			if(
				inst.options.greedy
				&& !inst.options.disabled
				&& inst.options.scope == draggable.options.scope
				&& inst.accept.call(inst.element[0], (draggable.currentItem || draggable.element))
				&& $.ui.intersect(draggable, $.extend(inst, { offset: inst.element.offset() }), inst.options.tolerance)
			) { childrenIntersection = true; return false; }
		});
		if(childrenIntersection) return false;

		if(this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
			if(this.options.activeClass) this.element.removeClass(this.options.activeClass);
			if(this.options.hoverClass) this.element.removeClass(this.options.hoverClass);
			this._trigger('drop', event, this.ui(draggable));
			return this.element;
		}

		return false;

	},

	ui: function(c) {
		return {
			draggable: (c.currentItem || c.element),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	}

});

$.extend($.ui.droppable, {
	version: "1.8.18"
});

$.ui.intersect = function(draggable, droppable, toleranceMode) {

	if (!droppable.offset) return false;

	var x1 = (draggable.positionAbs || draggable.position.absolute).left, x2 = x1 + draggable.helperProportions.width,
		y1 = (draggable.positionAbs || draggable.position.absolute).top, y2 = y1 + draggable.helperProportions.height;
	var l = droppable.offset.left, r = l + droppable.proportions.width,
		t = droppable.offset.top, b = t + droppable.proportions.height;

	switch (toleranceMode) {
		case 'fit':
			return (l <= x1 && x2 <= r
				&& t <= y1 && y2 <= b);
			break;
		case 'intersect':
			return (l < x1 + (draggable.helperProportions.width / 2) // Right Half
				&& x2 - (draggable.helperProportions.width / 2) < r // Left Half
				&& t < y1 + (draggable.helperProportions.height / 2) // Bottom Half
				&& y2 - (draggable.helperProportions.height / 2) < b ); // Top Half
			break;
		case 'pointer':
			var draggableLeft = ((draggable.positionAbs || draggable.position.absolute).left + (draggable.clickOffset || draggable.offset.click).left),
				draggableTop = ((draggable.positionAbs || draggable.position.absolute).top + (draggable.clickOffset || draggable.offset.click).top),
				isOver = $.ui.isOver(draggableTop, draggableLeft, t, l, droppable.proportions.height, droppable.proportions.width);
			return isOver;
			break;
		case 'touch':
			return (
					(y1 >= t && y1 <= b) ||	// Top edge touching
					(y2 >= t && y2 <= b) ||	// Bottom edge touching
					(y1 < t && y2 > b)		// Surrounded vertically
				) && (
					(x1 >= l && x1 <= r) ||	// Left edge touching
					(x2 >= l && x2 <= r) ||	// Right edge touching
					(x1 < l && x2 > r)		// Surrounded horizontally
				);
			break;
		default:
			return false;
			break;
		}

};

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { 'default': [] },
	prepareOffsets: function(t, event) {

		var m = $.ui.ddmanager.droppables[t.options.scope] || [];
		var type = event ? event.type : null; // workaround for #2317
		var list = (t.currentItem || t.element).find(":data(droppable)").andSelf();

		droppablesLoop: for (var i = 0; i < m.length; i++) {

			if(m[i].options.disabled || (t && !m[i].accept.call(m[i].element[0],(t.currentItem || t.element)))) continue;	//No disabled and non-accepted
			for (var j=0; j < list.length; j++) { if(list[j] == m[i].element[0]) { m[i].proportions.height = 0; continue droppablesLoop; } }; //Filter out elements in the current dragged item
			m[i].visible = m[i].element.css("display") != "none"; if(!m[i].visible) continue; 									//If the element is not visible, continue

			if(type == "mousedown") m[i]._activate.call(m[i], event); //Activate the droppable if used directly from draggables

			m[i].offset = m[i].element.offset();
			m[i].proportions = { width: m[i].element[0].offsetWidth, height: m[i].element[0].offsetHeight };

		}

	},
	drop: function(draggable, event) {

		var dropped = false;
		$.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {

			if(!this.options) return;
			if (!this.options.disabled && this.visible && $.ui.intersect(draggable, this, this.options.tolerance))
				dropped = this._drop.call(this, event) || dropped;

			if (!this.options.disabled && this.visible && this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
				this.isout = 1; this.isover = 0;
				this._deactivate.call(this, event);
			}

		});
		return dropped;

	},
	dragStart: function( draggable, event ) {
		//Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
		draggable.element.parents( ":not(body,html)" ).bind( "scroll.droppable", function() {
			if( !draggable.options.refreshPositions ) $.ui.ddmanager.prepareOffsets( draggable, event );
		});
	},
	drag: function(draggable, event) {

		//If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
		if(draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);

		//Run through all droppables and check their positions based on specific tolerance options
		$.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {

			if(this.options.disabled || this.greedyChild || !this.visible) return;
			var intersects = $.ui.intersect(draggable, this, this.options.tolerance);

			var c = !intersects && this.isover == 1 ? 'isout' : (intersects && this.isover == 0 ? 'isover' : null);
			if(!c) return;

			var parentInstance;
			if (this.options.greedy) {
				var parent = this.element.parents(':data(droppable):eq(0)');
				if (parent.length) {
					parentInstance = $.data(parent[0], 'droppable');
					parentInstance.greedyChild = (c == 'isover' ? 1 : 0);
				}
			}

			// we just moved into a greedy child
			if (parentInstance && c == 'isover') {
				parentInstance['isover'] = 0;
				parentInstance['isout'] = 1;
				parentInstance._out.call(parentInstance, event);
			}

			this[c] = 1; this[c == 'isout' ? 'isover' : 'isout'] = 0;
			this[c == "isover" ? "_over" : "_out"].call(this, event);

			// we just moved out of a greedy child
			if (parentInstance && c == 'isout') {
				parentInstance['isout'] = 0;
				parentInstance['isover'] = 1;
				parentInstance._over.call(parentInstance, event);
			}
		});

	},
	dragStop: function( draggable, event ) {
		draggable.element.parents( ":not(body,html)" ).unbind( "scroll.droppable" );
		//Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
		if( !draggable.options.refreshPositions ) $.ui.ddmanager.prepareOffsets( draggable, event );
	}
};

})(jQuery);
/*
 * jQuery UI Resizable 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Resizables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget("ui.resizable", $.ui.mouse, {
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,
		zIndex: 1000
	},
	_create: function() {

		var self = this, o = this.options;
		this.element.addClass("ui-resizable");

		$.extend(this, {
			_aspectRatio: !!(o.aspectRatio),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || 'ui-resizable-helper' : null
		});

		//Wrap the element if it cannot hold child nodes
		if(this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)) {

			//Create a wrapper element and set the wrapper to the new current internal element
			this.element.wrap(
				$('<div class="ui-wrapper" style="overflow: hidden;"></div>').css({
					position: this.element.css('position'),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css('top'),
					left: this.element.css('left')
				})
			);

			//Overwrite the original this.element
			this.element = this.element.parent().data(
				"resizable", this.element.data('resizable')
			);

			this.elementIsWrapper = true;

			//Move margins to the wrapper
			this.element.css({ marginLeft: this.originalElement.css("marginLeft"), marginTop: this.originalElement.css("marginTop"), marginRight: this.originalElement.css("marginRight"), marginBottom: this.originalElement.css("marginBottom") });
			this.originalElement.css({ marginLeft: 0, marginTop: 0, marginRight: 0, marginBottom: 0});

			//Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css('resize');
			this.originalElement.css('resize', 'none');

			//Push the actual element to our proportionallyResize internal array
			this._proportionallyResizeElements.push(this.originalElement.css({ position: 'static', zoom: 1, display: 'block' }));

			// avoid IE jump (hard set the margin)
			this.originalElement.css({ margin: this.originalElement.css('margin') });

			// fix handlers offset
			this._proportionallyResize();

		}

		this.handles = o.handles || (!$('.ui-resizable-handle', this.element).length ? "e,s,se" : { n: '.ui-resizable-n', e: '.ui-resizable-e', s: '.ui-resizable-s', w: '.ui-resizable-w', se: '.ui-resizable-se', sw: '.ui-resizable-sw', ne: '.ui-resizable-ne', nw: '.ui-resizable-nw' });
		if(this.handles.constructor == String) {

			if(this.handles == 'all') this.handles = 'n,e,s,w,se,sw,ne,nw';
			var n = this.handles.split(","); this.handles = {};

			for(var i = 0; i < n.length; i++) {

				var handle = $.trim(n[i]), hname = 'ui-resizable-'+handle;
				var axis = $('<div class="ui-resizable-handle ' + hname + '"></div>');

				// increase zIndex of sw, se, ne, nw axis
				//TODO : this modifies original option
				if(/sw|se|ne|nw/.test(handle)) axis.css({ zIndex: ++o.zIndex });

				//TODO : What's going on here?
				if ('se' == handle) {
					axis.addClass('ui-icon ui-icon-gripsmall-diagonal-se');
				};

				//Insert into internal handles object and append to element
				this.handles[handle] = '.ui-resizable-'+handle;
				this.element.append(axis);
			}

		}

		this._renderAxis = function(target) {

			target = target || this.element;

			for(var i in this.handles) {

				if(this.handles[i].constructor == String)
					this.handles[i] = $(this.handles[i], this.element).show();

				//Apply pad to wrapper element, needed to fix axis position (textarea, inputs, scrolls)
				if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/textarea|input|select|button/i)) {

					var axis = $(this.handles[i], this.element), padWrapper = 0;

					//Checking the correct pad and border
					padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

					//The padding type i have to apply...
					var padPos = [ 'padding',
						/ne|nw|n/.test(i) ? 'Top' :
						/se|sw|s/.test(i) ? 'Bottom' :
						/^e$/.test(i) ? 'Right' : 'Left' ].join("");

					target.css(padPos, padWrapper);

					this._proportionallyResize();

				}

				//TODO: What's that good for? There's not anything to be executed left
				if(!$(this.handles[i]).length)
					continue;

			}
		};

		//TODO: make renderAxis a prototype function
		this._renderAxis(this.element);

		this._handles = $('.ui-resizable-handle', this.element)
			.disableSelection();

		//Matching axis name
		this._handles.mouseover(function() {
			if (!self.resizing) {
				if (this.className)
					var axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
				//Axis, default = se
				self.axis = axis && axis[1] ? axis[1] : 'se';
			}
		});

		//If we want to auto hide the elements
		if (o.autoHide) {
			this._handles.hide();
			$(this.element)
				.addClass("ui-resizable-autohide")
				.hover(function() {
					if (o.disabled) return;
					$(this).removeClass("ui-resizable-autohide");
					self._handles.show();
				},
				function(){
					if (o.disabled) return;
					if (!self.resizing) {
						$(this).addClass("ui-resizable-autohide");
						self._handles.hide();
					}
				});
		}

		//Initialize the mouse interaction
		this._mouseInit();

	},

	destroy: function() {

		this._mouseDestroy();

		var _destroy = function(exp) {
			$(exp).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
				.removeData("resizable").unbind(".resizable").find('.ui-resizable-handle').remove();
		};

		//TODO: Unwrap at same DOM position
		if (this.elementIsWrapper) {
			_destroy(this.element);
			var wrapper = this.element;
			wrapper.after(
				this.originalElement.css({
					position: wrapper.css('position'),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css('top'),
					left: wrapper.css('left')
				})
			).remove();
		}

		this.originalElement.css('resize', this.originalResizeStyle);
		_destroy(this.originalElement);

		return this;
	},

	_mouseCapture: function(event) {
		var handle = false;
		for (var i in this.handles) {
			if ($(this.handles[i])[0] == event.target) {
				handle = true;
			}
		}

		return !this.options.disabled && handle;
	},

	_mouseStart: function(event) {

		var o = this.options, iniPos = this.element.position(), el = this.element;

		this.resizing = true;
		this.documentScroll = { top: $(document).scrollTop(), left: $(document).scrollLeft() };

		// bugfix for http://dev.jquery.com/ticket/1749
		if (el.is('.ui-draggable') || (/absolute/).test(el.css('position'))) {
			el.css({ position: 'absolute', top: iniPos.top, left: iniPos.left });
		}

		this._renderProxy();

		var curleft = num(this.helper.css('left')), curtop = num(this.helper.css('top'));

		if (o.containment) {
			curleft += $(o.containment).scrollLeft() || 0;
			curtop += $(o.containment).scrollTop() || 0;
		}

		//Store needed variables
		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };
		this.size = this._helper ? { width: el.outerWidth(), height: el.outerHeight() } : { width: el.width(), height: el.height() };
		this.originalSize = this._helper ? { width: el.outerWidth(), height: el.outerHeight() } : { width: el.width(), height: el.height() };
		this.originalPosition = { left: curleft, top: curtop };
		this.sizeDiff = { width: el.outerWidth() - el.width(), height: el.outerHeight() - el.height() };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		//Aspect Ratio
		this.aspectRatio = (typeof o.aspectRatio == 'number') ? o.aspectRatio : ((this.originalSize.width / this.originalSize.height) || 1);

	    var cursor = $('.ui-resizable-' + this.axis).css('cursor');
	    $('body').css('cursor', cursor == 'auto' ? this.axis + '-resize' : cursor);

		el.addClass("ui-resizable-resizing");
		this._propagate("start", event);
		return true;
	},

	_mouseDrag: function(event) {

		//Increase performance, avoid regex
		var el = this.helper, o = this.options, props = {},
			self = this, smp = this.originalMousePosition, a = this.axis;

		var dx = (event.pageX-smp.left)||0, dy = (event.pageY-smp.top)||0;
		var trigger = this._change[a];
		if (!trigger) return false;

		// Calculate the attrs that will be change
		var data = trigger.apply(this, [event, dx, dy]), ie6 = $.browser.msie && $.browser.version < 7, csdif = this.sizeDiff;

		// Put this in the mouseDrag handler since the user can start pressing shift while resizing
		this._updateVirtualBoundaries(event.shiftKey);
		if (this._aspectRatio || event.shiftKey)
			data = this._updateRatio(data, event);

		data = this._respectSize(data, event);

		// plugins callbacks need to be called first
		this._propagate("resize", event);

		el.css({
			top: this.position.top + "px", left: this.position.left + "px",
			width: this.size.width + "px", height: this.size.height + "px"
		});

		if (!this._helper && this._proportionallyResizeElements.length)
			this._proportionallyResize();

		this._updateCache(data);

		// calling the user callback at the end
		this._trigger('resize', event, this.ui());

		return false;
	},

	_mouseStop: function(event) {

		this.resizing = false;
		var o = this.options, self = this;

		if(this._helper) {
			var pr = this._proportionallyResizeElements, ista = pr.length && (/textarea/i).test(pr[0].nodeName),
				soffseth = ista && $.ui.hasScroll(pr[0], 'left') /* TODO - jump height */ ? 0 : self.sizeDiff.height,
				soffsetw = ista ? 0 : self.sizeDiff.width;

			var s = { width: (self.helper.width()  - soffsetw), height: (self.helper.height() - soffseth) },
				left = (parseInt(self.element.css('left'), 10) + (self.position.left - self.originalPosition.left)) || null,
				top = (parseInt(self.element.css('top'), 10) + (self.position.top - self.originalPosition.top)) || null;

			if (!o.animate)
				this.element.css($.extend(s, { top: top, left: left }));

			self.helper.height(self.size.height);
			self.helper.width(self.size.width);

			if (this._helper && !o.animate) this._proportionallyResize();
		}

		$('body').css('cursor', 'auto');

		this.element.removeClass("ui-resizable-resizing");

		this._propagate("stop", event);

		if (this._helper) this.helper.remove();
		return false;

	},

    _updateVirtualBoundaries: function(forceAspectRatio) {
        var o = this.options, pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b;

        b = {
            minWidth: isNumber(o.minWidth) ? o.minWidth : 0,
            maxWidth: isNumber(o.maxWidth) ? o.maxWidth : Infinity,
            minHeight: isNumber(o.minHeight) ? o.minHeight : 0,
            maxHeight: isNumber(o.maxHeight) ? o.maxHeight : Infinity
        };

        if(this._aspectRatio || forceAspectRatio) {
            // We want to create an enclosing box whose aspect ration is the requested one
            // First, compute the "projected" size for each dimension based on the aspect ratio and other dimension
            pMinWidth = b.minHeight * this.aspectRatio;
            pMinHeight = b.minWidth / this.aspectRatio;
            pMaxWidth = b.maxHeight * this.aspectRatio;
            pMaxHeight = b.maxWidth / this.aspectRatio;

            if(pMinWidth > b.minWidth) b.minWidth = pMinWidth;
            if(pMinHeight > b.minHeight) b.minHeight = pMinHeight;
            if(pMaxWidth < b.maxWidth) b.maxWidth = pMaxWidth;
            if(pMaxHeight < b.maxHeight) b.maxHeight = pMaxHeight;
        }
        this._vBoundaries = b;
    },

	_updateCache: function(data) {
		var o = this.options;
		this.offset = this.helper.offset();
		if (isNumber(data.left)) this.position.left = data.left;
		if (isNumber(data.top)) this.position.top = data.top;
		if (isNumber(data.height)) this.size.height = data.height;
		if (isNumber(data.width)) this.size.width = data.width;
	},

	_updateRatio: function(data, event) {

		var o = this.options, cpos = this.position, csize = this.size, a = this.axis;

		if (isNumber(data.height)) data.width = (data.height * this.aspectRatio);
		else if (isNumber(data.width)) data.height = (data.width / this.aspectRatio);

		if (a == 'sw') {
			data.left = cpos.left + (csize.width - data.width);
			data.top = null;
		}
		if (a == 'nw') {
			data.top = cpos.top + (csize.height - data.height);
			data.left = cpos.left + (csize.width - data.width);
		}

		return data;
	},

	_respectSize: function(data, event) {

		var el = this.helper, o = this._vBoundaries, pRatio = this._aspectRatio || event.shiftKey, a = this.axis,
				ismaxw = isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width), ismaxh = isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
					isminw = isNumber(data.width) && o.minWidth && (o.minWidth > data.width), isminh = isNumber(data.height) && o.minHeight && (o.minHeight > data.height);

		if (isminw) data.width = o.minWidth;
		if (isminh) data.height = o.minHeight;
		if (ismaxw) data.width = o.maxWidth;
		if (ismaxh) data.height = o.maxHeight;

		var dw = this.originalPosition.left + this.originalSize.width, dh = this.position.top + this.size.height;
		var cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);

		if (isminw && cw) data.left = dw - o.minWidth;
		if (ismaxw && cw) data.left = dw - o.maxWidth;
		if (isminh && ch)	data.top = dh - o.minHeight;
		if (ismaxh && ch)	data.top = dh - o.maxHeight;

		// fixing jump error on top/left - bug #2330
		var isNotwh = !data.width && !data.height;
		if (isNotwh && !data.left && data.top) data.top = null;
		else if (isNotwh && !data.top && data.left) data.left = null;

		return data;
	},

	_proportionallyResize: function() {

		var o = this.options;
		if (!this._proportionallyResizeElements.length) return;
		var element = this.helper || this.element;

		for (var i=0; i < this._proportionallyResizeElements.length; i++) {

			var prel = this._proportionallyResizeElements[i];

			if (!this.borderDif) {
				var b = [prel.css('borderTopWidth'), prel.css('borderRightWidth'), prel.css('borderBottomWidth'), prel.css('borderLeftWidth')],
					p = [prel.css('paddingTop'), prel.css('paddingRight'), prel.css('paddingBottom'), prel.css('paddingLeft')];

				this.borderDif = $.map(b, function(v, i) {
					var border = parseInt(v,10)||0, padding = parseInt(p[i],10)||0;
					return border + padding;
				});
			}

			if ($.browser.msie && !(!($(element).is(':hidden') || $(element).parents(':hidden').length)))
				continue;

			prel.css({
				height: (element.height() - this.borderDif[0] - this.borderDif[2]) || 0,
				width: (element.width() - this.borderDif[1] - this.borderDif[3]) || 0
			});

		};

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if(this._helper) {

			this.helper = this.helper || $('<div style="overflow:hidden;"></div>');

			// fix ie6 offset TODO: This seems broken
			var ie6 = $.browser.msie && $.browser.version < 7, ie6offset = (ie6 ? 1 : 0),
			pxyoffset = ( ie6 ? 2 : -1 );

			this.helper.addClass(this._helper).css({
				width: this.element.outerWidth() + pxyoffset,
				height: this.element.outerHeight() + pxyoffset,
				position: 'absolute',
				left: this.elementOffset.left - ie6offset +'px',
				top: this.elementOffset.top - ie6offset +'px',
				zIndex: ++o.zIndex //TODO: Don't modify option
			});

			this.helper
				.appendTo("body")
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function(event, dx, dy) {
			return { width: this.originalSize.width + dx };
		},
		w: function(event, dx, dy) {
			var o = this.options, cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function(event, dx, dy) {
			var o = this.options, cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function(event, dx, dy) {
			return { height: this.originalSize.height + dy };
		},
		se: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [event, dx, dy]));
		},
		sw: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [event, dx, dy]));
		},
		ne: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [event, dx, dy]));
		},
		nw: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [event, dx, dy]));
		}
	},

	_propagate: function(n, event) {
		$.ui.plugin.call(this, n, [event, this.ui()]);
		(n != "resize" && this._trigger(n, event, this.ui()));
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

});

$.extend($.ui.resizable, {
	version: "1.8.18"
});

/*
 * Resizable Extensions
 */

$.ui.plugin.add("resizable", "alsoResize", {

	start: function (event, ui) {
		var self = $(this).data("resizable"), o = self.options;

		var _store = function (exp) {
			$(exp).each(function() {
				var el = $(this);
				el.data("resizable-alsoresize", {
					width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
					left: parseInt(el.css('left'), 10), top: parseInt(el.css('top'), 10)
				});
			});
		};

		if (typeof(o.alsoResize) == 'object' && !o.alsoResize.parentNode) {
			if (o.alsoResize.length) { o.alsoResize = o.alsoResize[0]; _store(o.alsoResize); }
			else { $.each(o.alsoResize, function (exp) { _store(exp); }); }
		}else{
			_store(o.alsoResize);
		}
	},

	resize: function (event, ui) {
		var self = $(this).data("resizable"), o = self.options, os = self.originalSize, op = self.originalPosition;

		var delta = {
			height: (self.size.height - os.height) || 0, width: (self.size.width - os.width) || 0,
			top: (self.position.top - op.top) || 0, left: (self.position.left - op.left) || 0
		},

		_alsoResize = function (exp, c) {
			$(exp).each(function() {
				var el = $(this), start = $(this).data("resizable-alsoresize"), style = {}, 
					css = c && c.length ? c : el.parents(ui.originalElement[0]).length ? ['width', 'height'] : ['width', 'height', 'top', 'left'];

				$.each(css, function (i, prop) {
					var sum = (start[prop]||0) + (delta[prop]||0);
					if (sum && sum >= 0)
						style[prop] = sum || null;
				});

				el.css(style);
			});
		};

		if (typeof(o.alsoResize) == 'object' && !o.alsoResize.nodeType) {
			$.each(o.alsoResize, function (exp, c) { _alsoResize(exp, c); });
		}else{
			_alsoResize(o.alsoResize);
		}
	},

	stop: function (event, ui) {
		$(this).removeData("resizable-alsoresize");
	}
});

$.ui.plugin.add("resizable", "animate", {

	stop: function(event, ui) {
		var self = $(this).data("resizable"), o = self.options;

		var pr = self._proportionallyResizeElements, ista = pr.length && (/textarea/i).test(pr[0].nodeName),
					soffseth = ista && $.ui.hasScroll(pr[0], 'left') /* TODO - jump height */ ? 0 : self.sizeDiff.height,
						soffsetw = ista ? 0 : self.sizeDiff.width;

		var style = { width: (self.size.width - soffsetw), height: (self.size.height - soffseth) },
					left = (parseInt(self.element.css('left'), 10) + (self.position.left - self.originalPosition.left)) || null,
						top = (parseInt(self.element.css('top'), 10) + (self.position.top - self.originalPosition.top)) || null;

		self.element.animate(
			$.extend(style, top && left ? { top: top, left: left } : {}), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseInt(self.element.css('width'), 10),
						height: parseInt(self.element.css('height'), 10),
						top: parseInt(self.element.css('top'), 10),
						left: parseInt(self.element.css('left'), 10)
					};

					if (pr && pr.length) $(pr[0]).css({ width: data.width, height: data.height });

					// propagating resize, and updating values for each animation step
					self._updateCache(data);
					self._propagate("resize", event);

				}
			}
		);
	}

});

$.ui.plugin.add("resizable", "containment", {

	start: function(event, ui) {
		var self = $(this).data("resizable"), o = self.options, el = self.element;
		var oc = o.containment,	ce = (oc instanceof $) ? oc.get(0) : (/parent/.test(oc)) ? el.parent().get(0) : oc;
		if (!ce) return;

		self.containerElement = $(ce);

		if (/document/.test(oc) || oc == document) {
			self.containerOffset = { left: 0, top: 0 };
			self.containerPosition = { left: 0, top: 0 };

			self.parentData = {
				element: $(document), left: 0, top: 0,
				width: $(document).width(), height: $(document).height() || document.body.parentNode.scrollHeight
			};
		}

		// i'm a node, so compute top, left, right, bottom
		else {
			var element = $(ce), p = [];
			$([ "Top", "Right", "Left", "Bottom" ]).each(function(i, name) { p[i] = num(element.css("padding" + name)); });

			self.containerOffset = element.offset();
			self.containerPosition = element.position();
			self.containerSize = { height: (element.innerHeight() - p[3]), width: (element.innerWidth() - p[1]) };

			var co = self.containerOffset, ch = self.containerSize.height,	cw = self.containerSize.width,
						width = ($.ui.hasScroll(ce, "left") ? ce.scrollWidth : cw ), height = ($.ui.hasScroll(ce) ? ce.scrollHeight : ch);

			self.parentData = {
				element: ce, left: co.left, top: co.top, width: width, height: height
			};
		}
	},

	resize: function(event, ui) {
		var self = $(this).data("resizable"), o = self.options,
				ps = self.containerSize, co = self.containerOffset, cs = self.size, cp = self.position,
				pRatio = self._aspectRatio || event.shiftKey, cop = { top:0, left:0 }, ce = self.containerElement;

		if (ce[0] != document && (/static/).test(ce.css('position'))) cop = co;

		if (cp.left < (self._helper ? co.left : 0)) {
			self.size.width = self.size.width + (self._helper ? (self.position.left - co.left) : (self.position.left - cop.left));
			if (pRatio) self.size.height = self.size.width / o.aspectRatio;
			self.position.left = o.helper ? co.left : 0;
		}

		if (cp.top < (self._helper ? co.top : 0)) {
			self.size.height = self.size.height + (self._helper ? (self.position.top - co.top) : self.position.top);
			if (pRatio) self.size.width = self.size.height * o.aspectRatio;
			self.position.top = self._helper ? co.top : 0;
		}

		self.offset.left = self.parentData.left+self.position.left;
		self.offset.top = self.parentData.top+self.position.top;

		var woset = Math.abs( (self._helper ? self.offset.left - cop.left : (self.offset.left - cop.left)) + self.sizeDiff.width ),
					hoset = Math.abs( (self._helper ? self.offset.top - cop.top : (self.offset.top - co.top)) + self.sizeDiff.height );

		var isParent = self.containerElement.get(0) == self.element.parent().get(0),
		    isOffsetRelative = /relative|absolute/.test(self.containerElement.css('position'));

		if(isParent && isOffsetRelative) woset -= self.parentData.left;

		if (woset + self.size.width >= self.parentData.width) {
			self.size.width = self.parentData.width - woset;
			if (pRatio) self.size.height = self.size.width / self.aspectRatio;
		}

		if (hoset + self.size.height >= self.parentData.height) {
			self.size.height = self.parentData.height - hoset;
			if (pRatio) self.size.width = self.size.height * self.aspectRatio;
		}
	},

	stop: function(event, ui){
		var self = $(this).data("resizable"), o = self.options, cp = self.position,
				co = self.containerOffset, cop = self.containerPosition, ce = self.containerElement;

		var helper = $(self.helper), ho = helper.offset(), w = helper.outerWidth() - self.sizeDiff.width, h = helper.outerHeight() - self.sizeDiff.height;

		if (self._helper && !o.animate && (/relative/).test(ce.css('position')))
			$(this).css({ left: ho.left - cop.left - co.left, width: w, height: h });

		if (self._helper && !o.animate && (/static/).test(ce.css('position')))
			$(this).css({ left: ho.left - cop.left - co.left, width: w, height: h });

	}
});

$.ui.plugin.add("resizable", "ghost", {

	start: function(event, ui) {

		var self = $(this).data("resizable"), o = self.options, cs = self.size;

		self.ghost = self.originalElement.clone();
		self.ghost
			.css({ opacity: .25, display: 'block', position: 'relative', height: cs.height, width: cs.width, margin: 0, left: 0, top: 0 })
			.addClass('ui-resizable-ghost')
			.addClass(typeof o.ghost == 'string' ? o.ghost : '');

		self.ghost.appendTo(self.helper);

	},

	resize: function(event, ui){
		var self = $(this).data("resizable"), o = self.options;
		if (self.ghost) self.ghost.css({ position: 'relative', height: self.size.height, width: self.size.width });
	},

	stop: function(event, ui){
		var self = $(this).data("resizable"), o = self.options;
		if (self.ghost && self.helper) self.helper.get(0).removeChild(self.ghost.get(0));
	}

});

$.ui.plugin.add("resizable", "grid", {

	resize: function(event, ui) {
		var self = $(this).data("resizable"), o = self.options, cs = self.size, os = self.originalSize, op = self.originalPosition, a = self.axis, ratio = o._aspectRatio || event.shiftKey;
		o.grid = typeof o.grid == "number" ? [o.grid, o.grid] : o.grid;
		var ox = Math.round((cs.width - os.width) / (o.grid[0]||1)) * (o.grid[0]||1), oy = Math.round((cs.height - os.height) / (o.grid[1]||1)) * (o.grid[1]||1);

		if (/^(se|s|e)$/.test(a)) {
			self.size.width = os.width + ox;
			self.size.height = os.height + oy;
		}
		else if (/^(ne)$/.test(a)) {
			self.size.width = os.width + ox;
			self.size.height = os.height + oy;
			self.position.top = op.top - oy;
		}
		else if (/^(sw)$/.test(a)) {
			self.size.width = os.width + ox;
			self.size.height = os.height + oy;
			self.position.left = op.left - ox;
		}
		else {
			self.size.width = os.width + ox;
			self.size.height = os.height + oy;
			self.position.top = op.top - oy;
			self.position.left = op.left - ox;
		}
	}

});

var num = function(v) {
	return parseInt(v, 10) || 0;
};

var isNumber = function(value) {
	return !isNaN(parseInt(value, 10));
};

})(jQuery);
/*
 * jQuery UI Selectable 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Selectables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget("ui.selectable", $.ui.mouse, {
	options: {
		appendTo: 'body',
		autoRefresh: true,
		distance: 0,
		filter: '*',
		tolerance: 'touch'
	},
	_create: function() {
		var self = this;

		this.element.addClass("ui-selectable");

		this.dragged = false;

		// cache selectee children based on filter
		var selectees;
		this.refresh = function() {
			selectees = $(self.options.filter, self.element[0]);
			selectees.addClass("ui-selectee");
			selectees.each(function() {
				var $this = $(this);
				var pos = $this.offset();
				$.data(this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass('ui-selected'),
					selecting: $this.hasClass('ui-selecting'),
					unselecting: $this.hasClass('ui-unselecting')
				});
			});
		};
		this.refresh();

		this.selectees = selectees.addClass("ui-selectee");

		this._mouseInit();

		this.helper = $("<div class='ui-selectable-helper'></div>");
	},

	destroy: function() {
		this.selectees
			.removeClass("ui-selectee")
			.removeData("selectable-item");
		this.element
			.removeClass("ui-selectable ui-selectable-disabled")
			.removeData("selectable")
			.unbind(".selectable");
		this._mouseDestroy();

		return this;
	},

	_mouseStart: function(event) {
		var self = this;

		this.opos = [event.pageX, event.pageY];

		if (this.options.disabled)
			return;

		var options = this.options;

		this.selectees = $(options.filter, this.element[0]);

		this._trigger("start", event);

		$(options.appendTo).append(this.helper);
		// position helper (lasso)
		this.helper.css({
			"left": event.clientX,
			"top": event.clientY,
			"width": 0,
			"height": 0
		});

		if (options.autoRefresh) {
			this.refresh();
		}

		this.selectees.filter('.ui-selected').each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.startselected = true;
			if (!event.metaKey && !event.ctrlKey) {
				selectee.$element.removeClass('ui-selected');
				selectee.selected = false;
				selectee.$element.addClass('ui-unselecting');
				selectee.unselecting = true;
				// selectable UNSELECTING callback
				self._trigger("unselecting", event, {
					unselecting: selectee.element
				});
			}
		});

		$(event.target).parents().andSelf().each(function() {
			var selectee = $.data(this, "selectable-item");
			if (selectee) {
				var doSelect = (!event.metaKey && !event.ctrlKey) || !selectee.$element.hasClass('ui-selected');
				selectee.$element
					.removeClass(doSelect ? "ui-unselecting" : "ui-selected")
					.addClass(doSelect ? "ui-selecting" : "ui-unselecting");
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;
				// selectable (UN)SELECTING callback
				if (doSelect) {
					self._trigger("selecting", event, {
						selecting: selectee.element
					});
				} else {
					self._trigger("unselecting", event, {
						unselecting: selectee.element
					});
				}
				return false;
			}
		});

	},

	_mouseDrag: function(event) {
		var self = this;
		this.dragged = true;

		if (this.options.disabled)
			return;

		var options = this.options;

		var x1 = this.opos[0], y1 = this.opos[1], x2 = event.pageX, y2 = event.pageY;
		if (x1 > x2) { var tmp = x2; x2 = x1; x1 = tmp; }
		if (y1 > y2) { var tmp = y2; y2 = y1; y1 = tmp; }
		this.helper.css({left: x1, top: y1, width: x2-x1, height: y2-y1});

		this.selectees.each(function() {
			var selectee = $.data(this, "selectable-item");
			//prevent helper from being selected if appendTo: selectable
			if (!selectee || selectee.element == self.element[0])
				return;
			var hit = false;
			if (options.tolerance == 'touch') {
				hit = ( !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1) );
			} else if (options.tolerance == 'fit') {
				hit = (selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2);
			}

			if (hit) {
				// SELECT
				if (selectee.selected) {
					selectee.$element.removeClass('ui-selected');
					selectee.selected = false;
				}
				if (selectee.unselecting) {
					selectee.$element.removeClass('ui-unselecting');
					selectee.unselecting = false;
				}
				if (!selectee.selecting) {
					selectee.$element.addClass('ui-selecting');
					selectee.selecting = true;
					// selectable SELECTING callback
					self._trigger("selecting", event, {
						selecting: selectee.element
					});
				}
			} else {
				// UNSELECT
				if (selectee.selecting) {
					if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
						selectee.$element.removeClass('ui-selecting');
						selectee.selecting = false;
						selectee.$element.addClass('ui-selected');
						selectee.selected = true;
					} else {
						selectee.$element.removeClass('ui-selecting');
						selectee.selecting = false;
						if (selectee.startselected) {
							selectee.$element.addClass('ui-unselecting');
							selectee.unselecting = true;
						}
						// selectable UNSELECTING callback
						self._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
				}
				if (selectee.selected) {
					if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
						selectee.$element.removeClass('ui-selected');
						selectee.selected = false;

						selectee.$element.addClass('ui-unselecting');
						selectee.unselecting = true;
						// selectable UNSELECTING callback
						self._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
				}
			}
		});

		return false;
	},

	_mouseStop: function(event) {
		var self = this;

		this.dragged = false;

		var options = this.options;

		$('.ui-unselecting', this.element[0]).each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.$element.removeClass('ui-unselecting');
			selectee.unselecting = false;
			selectee.startselected = false;
			self._trigger("unselected", event, {
				unselected: selectee.element
			});
		});
		$('.ui-selecting', this.element[0]).each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.$element.removeClass('ui-selecting').addClass('ui-selected');
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			self._trigger("selected", event, {
				selected: selectee.element
			});
		});
		this._trigger("stop", event);

		this.helper.remove();

		return false;
	}

});

$.extend($.ui.selectable, {
	version: "1.8.18"
});

})(jQuery);
/*
 * jQuery UI Sortable 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Sortables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget("ui.sortable", $.ui.mouse, {
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: 'auto',
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: '> *',
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000
	},
	_create: function() {

		var o = this.options;
		this.containerCache = {};
		this.element.addClass("ui-sortable");

		//Get the items
		this.refresh();

		//Let's determine if the items are being displayed horizontally
		this.floating = this.items.length ? o.axis === 'x' || (/left|right/).test(this.items[0].item.css('float')) || (/inline|table-cell/).test(this.items[0].item.css('display')) : false;

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();
		
		//We're ready to go
		this.ready = true

	},

	destroy: function() {
		$.Widget.prototype.destroy.call( this );
		this.element
			.removeClass("ui-sortable ui-sortable-disabled");
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- )
			this.items[i].item.removeData(this.widgetName + "-item");

		return this;
	},

	_setOption: function(key, value){
		if ( key === "disabled" ) {
			this.options[ key ] = value;
	
			this.widget()
				[ value ? "addClass" : "removeClass"]( "ui-sortable-disabled" );
		} else {
			// Don't call widget base _setOption for disable as it adds ui-state-disabled class
			$.Widget.prototype._setOption.apply(this, arguments);
		}
	},

	_mouseCapture: function(event, overrideHandle) {
		var that = this;

		if (this.reverting) {
			return false;
		}

		if(this.options.disabled || this.options.type == 'static') return false;

		//We have to refresh the items data once first
		this._refreshItems(event);

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		var currentItem = null, self = this, nodes = $(event.target).parents().each(function() {
			if($.data(this, that.widgetName + '-item') == self) {
				currentItem = $(this);
				return false;
			}
		});
		if($.data(event.target, that.widgetName + '-item') == self) currentItem = $(event.target);

		if(!currentItem) return false;
		if(this.options.handle && !overrideHandle) {
			var validHandle = false;

			$(this.options.handle, currentItem).find("*").andSelf().each(function() { if(this == event.target) validHandle = true; });
			if(!validHandle) return false;
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function(event, overrideHandle, noActivation) {

		var o = this.options, self = this;
		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css("position", "absolute");
		this.cssPosition = this.helper.css("position");

		$.extend(this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
		});

		//Generate the original position
		this.originalPosition = this._generatePosition(event);
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if 'cursorAt' is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Cache the former DOM position
		this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };

		//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
		if(this.helper[0] != this.currentItem[0]) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if(o.containment)
			this._setContainment();

		if(o.cursor) { // cursor option
			if ($('body').css("cursor")) this._storedCursor = $('body').css("cursor");
			$('body').css("cursor", o.cursor);
		}

		if(o.opacity) { // opacity option
			if (this.helper.css("opacity")) this._storedOpacity = this.helper.css("opacity");
			this.helper.css("opacity", o.opacity);
		}

		if(o.zIndex) { // zIndex option
			if (this.helper.css("zIndex")) this._storedZIndex = this.helper.css("zIndex");
			this.helper.css("zIndex", o.zIndex);
		}

		//Prepare scrolling
		if(this.scrollParent[0] != document && this.scrollParent[0].tagName != 'HTML')
			this.overflowOffset = this.scrollParent.offset();

		//Call callbacks
		this._trigger("start", event, this._uiHash());

		//Recache the helper size
		if(!this._preserveHelperProportions)
			this._cacheHelperProportions();


		//Post 'activate' events to possible containers
		if(!noActivation) {
			 for (var i = this.containers.length - 1; i >= 0; i--) { this.containers[i]._trigger("activate", event, self._uiHash(this)); }
		}

		//Prepare possible droppables
		if($.ui.ddmanager)
			$.ui.ddmanager.current = this;

		if ($.ui.ddmanager && !o.dropBehaviour)
			$.ui.ddmanager.prepareOffsets(this, event);

		this.dragging = true;

		this.helper.addClass("ui-sortable-helper");
		this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
		return true;

	},

	_mouseDrag: function(event) {

		//Compute the helpers position
		this.position = this._generatePosition(event);
		this.positionAbs = this._convertPositionTo("absolute");

		if (!this.lastPositionAbs) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if(this.options.scroll) {
			var o = this.options, scrolled = false;
			if(this.scrollParent[0] != document && this.scrollParent[0].tagName != 'HTML') {

				if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity)
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
				else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity)
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;

				if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity)
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
				else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity)
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;

			} else {

				if(event.pageY - $(document).scrollTop() < o.scrollSensitivity)
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity)
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);

				if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity)
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity)
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);

			}

			if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour)
				$.ui.ddmanager.prepareOffsets(this, event);
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo("absolute");

		//Set the helper position
		if(!this.options.axis || this.options.axis != "y") this.helper[0].style.left = this.position.left+'px';
		if(!this.options.axis || this.options.axis != "x") this.helper[0].style.top = this.position.top+'px';

		//Rearrange
		for (var i = this.items.length - 1; i >= 0; i--) {

			//Cache variables and intersection, continue if no intersection
			var item = this.items[i], itemElement = item.item[0], intersection = this._intersectsWithPointer(item);
			if (!intersection) continue;

			if(itemElement != this.currentItem[0] //cannot intersect with itself
				&&	this.placeholder[intersection == 1 ? "next" : "prev"]()[0] != itemElement //no useless actions that have been done before
				&&	!$.ui.contains(this.placeholder[0], itemElement) //no action if the item moved is the parent of the item checked
				&& (this.options.type == 'semi-dynamic' ? !$.ui.contains(this.element[0], itemElement) : true)
				//&& itemElement.parentNode == this.placeholder[0].parentNode // only rearrange items within the same container
			) {

				this.direction = intersection == 1 ? "down" : "up";

				if (this.options.tolerance == "pointer" || this._intersectsWithSides(item)) {
					this._rearrange(event, item);
				} else {
					break;
				}

				this._trigger("change", event, this._uiHash());
				break;
			}
		}

		//Post events to containers
		this._contactContainers(event);

		//Interconnect with droppables
		if($.ui.ddmanager) $.ui.ddmanager.drag(this, event);

		//Call callbacks
		this._trigger('sort', event, this._uiHash());

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function(event, noPropagation) {

		if(!event) return;

		//If we are using droppables, inform the manager about the drop
		if ($.ui.ddmanager && !this.options.dropBehaviour)
			$.ui.ddmanager.drop(this, event);

		if(this.options.revert) {
			var self = this;
			var cur = self.placeholder.offset();

			self.reverting = true;

			$(this.helper).animate({
				left: cur.left - this.offset.parent.left - self.margins.left + (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollLeft),
				top: cur.top - this.offset.parent.top - self.margins.top + (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollTop)
			}, parseInt(this.options.revert, 10) || 500, function() {
				self._clear(event);
			});
		} else {
			this._clear(event, noPropagation);
		}

		return false;

	},

	cancel: function() {

		var self = this;

		if(this.dragging) {

			this._mouseUp({ target: null });

			if(this.options.helper == "original")
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			else
				this.currentItem.show();

			//Post deactivating events to containers
			for (var i = this.containers.length - 1; i >= 0; i--){
				this.containers[i]._trigger("deactivate", null, self._uiHash(this));
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", null, self._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}

		if (this.placeholder) {
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			if(this.placeholder[0].parentNode) this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
			if(this.options.helper != "original" && this.helper && this.helper[0].parentNode) this.helper.remove();

			$.extend(this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			});

			if(this.domPosition.prev) {
				$(this.domPosition.prev).after(this.currentItem);
			} else {
				$(this.domPosition.parent).prepend(this.currentItem);
			}
		}

		return this;

	},

	serialize: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected);
		var str = []; o = o || {};

		$(items).each(function() {
			var res = ($(o.item || this).attr(o.attribute || 'id') || '').match(o.expression || (/(.+)[-=_](.+)/));
			if(res) str.push((o.key || res[1]+'[]')+'='+(o.key && o.expression ? res[1] : res[2]));
		});

		if(!str.length && o.key) {
			str.push(o.key + '=');
		}

		return str.join('&');

	},

	toArray: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected);
		var ret = []; o = o || {};

		items.each(function() { ret.push($(o.item || this).attr(o.attribute || 'id') || ''); });
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function(item) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height;

		var l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height;

		var dyClick = this.offset.click.top,
			dxClick = this.offset.click.left;

		var isOverElement = (y1 + dyClick) > t && (y1 + dyClick) < b && (x1 + dxClick) > l && (x1 + dxClick) < r;

		if(	   this.options.tolerance == "pointer"
			|| this.options.forcePointerForContainers
			|| (this.options.tolerance != "pointer" && this.helperProportions[this.floating ? 'width' : 'height'] > item[this.floating ? 'width' : 'height'])
		) {
			return isOverElement;
		} else {

			return (l < x1 + (this.helperProportions.width / 2) // Right Half
				&& x2 - (this.helperProportions.width / 2) < r // Left Half
				&& t < y1 + (this.helperProportions.height / 2) // Bottom Half
				&& y2 - (this.helperProportions.height / 2) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function(item) {

		var isOverElementHeight = $.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
			isOverElementWidth = $.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
			isOverElement = isOverElementHeight && isOverElementWidth,
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (!isOverElement)
			return false;

		return this.floating ?
			( ((horizontalDirection && horizontalDirection == "right") || verticalDirection == "down") ? 2 : 1 )
			: ( verticalDirection && (verticalDirection == "down" ? 2 : 1) );

	},

	_intersectsWithSides: function(item) {

		var isOverBottomHalf = $.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
			isOverRightHalf = $.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (this.floating && horizontalDirection) {
			return ((horizontalDirection == "right" && isOverRightHalf) || (horizontalDirection == "left" && !isOverRightHalf));
		} else {
			return verticalDirection && ((verticalDirection == "down" && isOverBottomHalf) || (verticalDirection == "up" && !isOverBottomHalf));
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta != 0 && (delta > 0 ? "down" : "up");
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta != 0 && (delta > 0 ? "right" : "left");
	},

	refresh: function(event) {
		this._refreshItems(event);
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor == String
			? [options.connectWith]
			: options.connectWith;
	},
	
	_getItemsAsjQuery: function(connected) {

		var self = this;
		var items = [];
		var queries = [];
		var connectWith = this._connectWith();

		if(connectWith && connected) {
			for (var i = connectWith.length - 1; i >= 0; i--){
				var cur = $(connectWith[i]);
				for (var j = cur.length - 1; j >= 0; j--){
					var inst = $.data(cur[j], this.widgetName);
					if(inst && inst != this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not('.ui-sortable-placeholder'), inst]);
					}
				};
			};
		}

		queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not('.ui-sortable-placeholder'), this]);

		for (var i = queries.length - 1; i >= 0; i--){
			queries[i][0].each(function() {
				items.push(this);
			});
		};

		return $(items);

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find(":data(" + this.widgetName + "-item)");

		for (var i=0; i < this.items.length; i++) {

			for (var j=0; j < list.length; j++) {
				if(list[j] == this.items[i].item[0])
					this.items.splice(i,1);
			};

		};

	},

	_refreshItems: function(event) {

		this.items = [];
		this.containers = [this];
		var items = this.items;
		var self = this;
		var queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]];
		var connectWith = this._connectWith();

		if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
			for (var i = connectWith.length - 1; i >= 0; i--){
				var cur = $(connectWith[i]);
				for (var j = cur.length - 1; j >= 0; j--){
					var inst = $.data(cur[j], this.widgetName);
					if(inst && inst != this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
						this.containers.push(inst);
					}
				};
			};
		}

		for (var i = queries.length - 1; i >= 0; i--) {
			var targetData = queries[i][1];
			var _queries = queries[i][0];

			for (var j=0, queriesLength = _queries.length; j < queriesLength; j++) {
				var item = $(_queries[j]);

				item.data(this.widgetName + '-item', targetData); // Data for target checking (mouse manager)

				items.push({
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				});
			};
		};

	},

	refreshPositions: function(fast) {

		//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
		if(this.offsetParent && this.helper) {
			this.offset.parent = this._getParentOffset();
		}

		for (var i = this.items.length - 1; i >= 0; i--){
			var item = this.items[i];

			//We ignore calculating positions of all connected containers when we're not over them
			if(item.instance != this.currentContainer && this.currentContainer && item.item[0] != this.currentItem[0])
				continue;

			var t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;

			if (!fast) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			var p = t.offset();
			item.left = p.left;
			item.top = p.top;
		};

		if(this.options.custom && this.options.custom.refreshContainers) {
			this.options.custom.refreshContainers.call(this);
		} else {
			for (var i = this.containers.length - 1; i >= 0; i--){
				var p = this.containers[i].element.offset();
				this.containers[i].containerCache.left = p.left;
				this.containers[i].containerCache.top = p.top;
				this.containers[i].containerCache.width	= this.containers[i].element.outerWidth();
				this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
			};
		}

		return this;
	},

	_createPlaceholder: function(that) {

		var self = that || this, o = self.options;

		if(!o.placeholder || o.placeholder.constructor == String) {
			var className = o.placeholder;
			o.placeholder = {
				element: function() {

					var el = $(document.createElement(self.currentItem[0].nodeName))
						.addClass(className || self.currentItem[0].className+" ui-sortable-placeholder")
						.removeClass("ui-sortable-helper")[0];

					if(!className)
						el.style.visibility = "hidden";

					return el;
				},
				update: function(container, p) {

					// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
					if(className && !o.forcePlaceholderSize) return;

					//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
					if(!p.height()) { p.height(self.currentItem.innerHeight() - parseInt(self.currentItem.css('paddingTop')||0, 10) - parseInt(self.currentItem.css('paddingBottom')||0, 10)); };
					if(!p.width()) { p.width(self.currentItem.innerWidth() - parseInt(self.currentItem.css('paddingLeft')||0, 10) - parseInt(self.currentItem.css('paddingRight')||0, 10)); };
				}
			};
		}

		//Create the placeholder
		self.placeholder = $(o.placeholder.element.call(self.element, self.currentItem));

		//Append it after the actual current item
		self.currentItem.after(self.placeholder);

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update(self, self.placeholder);

	},

	_contactContainers: function(event) {
		
		// get innermost container that intersects with item 
		var innermostContainer = null, innermostIndex = null;		
		
		
		for (var i = this.containers.length - 1; i >= 0; i--){

			// never consider a container that's located within the item itself 
			if($.ui.contains(this.currentItem[0], this.containers[i].element[0]))
				continue;

			if(this._intersectsWith(this.containers[i].containerCache)) {

				// if we've already found a container and it's more "inner" than this, then continue 
				if(innermostContainer && $.ui.contains(this.containers[i].element[0], innermostContainer.element[0]))
					continue;

				innermostContainer = this.containers[i]; 
				innermostIndex = i;
					
			} else {
				// container doesn't intersect. trigger "out" event if necessary 
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", event, this._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}
		
		// if no intersecting containers found, return 
		if(!innermostContainer) return; 

		// move the item into the container if it's not there already
		if(this.containers.length === 1) {
			this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
			this.containers[innermostIndex].containerCache.over = 1;
		} else if(this.currentContainer != this.containers[innermostIndex]) { 

			//When entering a new container, we will find the item with the least distance and append our item near it 
			var dist = 10000; var itemWithLeastDistance = null; var base = this.positionAbs[this.containers[innermostIndex].floating ? 'left' : 'top']; 
			for (var j = this.items.length - 1; j >= 0; j--) { 
				if(!$.ui.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) continue; 
				var cur = this.items[j][this.containers[innermostIndex].floating ? 'left' : 'top']; 
				if(Math.abs(cur - base) < dist) { 
					dist = Math.abs(cur - base); itemWithLeastDistance = this.items[j]; 
				} 
			} 

			if(!itemWithLeastDistance && !this.options.dropOnEmpty) //Check if dropOnEmpty is enabled 
				return; 

			this.currentContainer = this.containers[innermostIndex]; 
			itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true); 
			this._trigger("change", event, this._uiHash()); 
			this.containers[innermostIndex]._trigger("change", event, this._uiHash(this)); 

			//Update the placeholder 
			this.options.placeholder.update(this.currentContainer, this.placeholder); 
		
			this.containers[innermostIndex]._trigger("over", event, this._uiHash(this)); 
			this.containers[innermostIndex].containerCache.over = 1;
		} 
	
		
	},

	_createHelper: function(event) {

		var o = this.options;
		var helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper == 'clone' ? this.currentItem.clone() : this.currentItem);

		if(!helper.parents('body').length) //Add the helper to the DOM if that didn't happen already
			$(o.appendTo != 'parent' ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);

		if(helper[0] == this.currentItem[0])
			this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };

		if(helper[0].style.width == '' || o.forceHelperSize) helper.width(this.currentItem.width());
		if(helper[0].style.height == '' || o.forceHelperSize) helper.height(this.currentItem.height());

		return helper;

	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj == 'string') {
			obj = obj.split(' ');
		}
		if ($.isArray(obj)) {
			obj = {left: +obj[0], top: +obj[1] || 0};
		}
		if ('left' in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ('right' in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ('top' in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ('bottom' in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {


		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if(this.cssPosition == 'absolute' && this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if((this.offsetParent[0] == document.body) //This needs to be actually done for all browsers, since pageX/pageY includes this information
		|| (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && $.browser.msie)) //Ugly IE fix
			po = { top: 0, left: 0 };

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
		};

	},

	_getRelativeOffset: function() {

		if(this.cssPosition == "relative") {
			var p = this.currentItem.position();
			return {
				top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
				left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
			top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var o = this.options;
		if(o.containment == 'parent') o.containment = this.helper[0].parentNode;
		if(o.containment == 'document' || o.containment == 'window') this.containment = [
			0 - this.offset.relative.left - this.offset.parent.left,
			0 - this.offset.relative.top - this.offset.parent.top,
			$(o.containment == 'document' ? document : window).width() - this.helperProportions.width - this.margins.left,
			($(o.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
		];

		if(!(/^(document|window|parent)$/).test(o.containment)) {
			var ce = $(o.containment)[0];
			var co = $(o.containment).offset();
			var over = ($(ce).css("overflow") != 'hidden');

			this.containment = [
				co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
				co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
				co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
				co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function(d, pos) {

		if(!pos) pos = this.position;
		var mod = d == "absolute" ? 1 : -1;
		var o = this.options, scroll = this.cssPosition == 'absolute' && !(this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		return {
			top: (
				pos.top																	// The absolute mouse position
				+ this.offset.relative.top * mod										// Only for relative positioned nodes: Relative offset from element to offset parent
				+ this.offset.parent.top * mod											// The offsetParent's offset without borders (offset + border)
				- ($.browser.safari && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
			),
			left: (
				pos.left																// The absolute mouse position
				+ this.offset.relative.left * mod										// Only for relative positioned nodes: Relative offset from element to offset parent
				+ this.offset.parent.left * mod											// The offsetParent's offset without borders (offset + border)
				- ($.browser.safari && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
			)
		};

	},

	_generatePosition: function(event) {

		var o = this.options, scroll = this.cssPosition == 'absolute' && !(this.scrollParent[0] != document && $.ui.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if(this.cssPosition == 'relative' && !(this.scrollParent[0] != document && this.scrollParent[0] != this.offsetParent[0])) {
			this.offset.relative = this._getRelativeOffset();
		}

		var pageX = event.pageX;
		var pageY = event.pageY;

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if(this.originalPosition) { //If we are not dragging yet, we won't check for options

			if(this.containment) {
				if(event.pageX - this.offset.click.left < this.containment[0]) pageX = this.containment[0] + this.offset.click.left;
				if(event.pageY - this.offset.click.top < this.containment[1]) pageY = this.containment[1] + this.offset.click.top;
				if(event.pageX - this.offset.click.left > this.containment[2]) pageX = this.containment[2] + this.offset.click.left;
				if(event.pageY - this.offset.click.top > this.containment[3]) pageY = this.containment[3] + this.offset.click.top;
			}

			if(o.grid) {
				var top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
				pageY = this.containment ? (!(top - this.offset.click.top < this.containment[1] || top - this.offset.click.top > this.containment[3]) ? top : (!(top - this.offset.click.top < this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				var left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
				pageX = this.containment ? (!(left - this.offset.click.left < this.containment[0] || left - this.offset.click.left > this.containment[2]) ? left : (!(left - this.offset.click.left < this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

		}

		return {
			top: (
				pageY																// The absolute mouse position
				- this.offset.click.top													// Click offset (relative to the element)
				- this.offset.relative.top												// Only for relative positioned nodes: Relative offset from element to offset parent
				- this.offset.parent.top												// The offsetParent's offset without borders (offset + border)
				+ ($.browser.safari && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
			),
			left: (
				pageX																// The absolute mouse position
				- this.offset.click.left												// Click offset (relative to the element)
				- this.offset.relative.left												// Only for relative positioned nodes: Relative offset from element to offset parent
				- this.offset.parent.left												// The offsetParent's offset without borders (offset + border)
				+ ($.browser.safari && this.cssPosition == 'fixed' ? 0 : ( this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
			)
		};

	},

	_rearrange: function(event, i, a, hardRefresh) {

		a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction == 'down' ? i.item[0] : i.item[0].nextSibling));

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var self = this, counter = this.counter;

		window.setTimeout(function() {
			if(counter == self.counter) self.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
		},0);

	},

	_clear: function(event, noPropagation) {

		this.reverting = false;
		// We delay all events that have to be triggered to after the point where the placeholder has been removed and
		// everything else normalized again
		var delayedTriggers = [], self = this;

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
		if(!this._noFinalSort && this.currentItem.parent().length) this.placeholder.before(this.currentItem);
		this._noFinalSort = null;

		if(this.helper[0] == this.currentItem[0]) {
			for(var i in this._storedCSS) {
				if(this._storedCSS[i] == 'auto' || this._storedCSS[i] == 'static') this._storedCSS[i] = '';
			}
			this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
		} else {
			this.currentItem.show();
		}

		if(this.fromOutside && !noPropagation) delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
		if((this.fromOutside || this.domPosition.prev != this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent != this.currentItem.parent()[0]) && !noPropagation) delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
		if(!$.ui.contains(this.element[0], this.currentItem[0])) { //Node was moved out of the current element
			if(!noPropagation) delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
			for (var i = this.containers.length - 1; i >= 0; i--){
				if($.ui.contains(this.containers[i].element[0], this.currentItem[0]) && !noPropagation) {
					delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
					delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.containers[i]));
				}
			};
		};

		//Post events to containers
		for (var i = this.containers.length - 1; i >= 0; i--){
			if(!noPropagation) delayedTriggers.push((function(c) { return function(event) { c._trigger("deactivate", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
			if(this.containers[i].containerCache.over) {
				delayedTriggers.push((function(c) { return function(event) { c._trigger("out", event, this._uiHash(this)); };  }).call(this, this.containers[i]));
				this.containers[i].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if(this._storedCursor) $('body').css("cursor", this._storedCursor); //Reset cursor
		if(this._storedOpacity) this.helper.css("opacity", this._storedOpacity); //Reset opacity
		if(this._storedZIndex) this.helper.css("zIndex", this._storedZIndex == 'auto' ? '' : this._storedZIndex); //Reset z-index

		this.dragging = false;
		if(this.cancelHelperRemoval) {
			if(!noPropagation) {
				this._trigger("beforeStop", event, this._uiHash());
				for (var i=0; i < delayedTriggers.length; i++) { delayedTriggers[i].call(this, event); }; //Trigger all delayed events
				this._trigger("stop", event, this._uiHash());
			}
			return false;
		}

		if(!noPropagation) this._trigger("beforeStop", event, this._uiHash());

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
		this.placeholder[0].parentNode.removeChild(this.placeholder[0]);

		if(this.helper[0] != this.currentItem[0]) this.helper.remove(); this.helper = null;

		if(!noPropagation) {
			for (var i=0; i < delayedTriggers.length; i++) { delayedTriggers[i].call(this, event); }; //Trigger all delayed events
			this._trigger("stop", event, this._uiHash());
		}

		this.fromOutside = false;
		return true;

	},

	_trigger: function() {
		if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
			this.cancel();
		}
	},

	_uiHash: function(inst) {
		var self = inst || this;
		return {
			helper: self.helper,
			placeholder: self.placeholder || $([]),
			position: self.position,
			originalPosition: self.originalPosition,
			offset: self.positionAbs,
			item: self.currentItem,
			sender: inst ? inst.element : null
		};
	}

});

$.extend($.ui.sortable, {
	version: "1.8.18"
});

})(jQuery);
/*
 * jQuery UI Effects 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/
 */
;jQuery.effects || (function($, undefined) {

$.effects = {};



/******************************************************************************/
/****************************** COLOR ANIMATIONS ******************************/
/******************************************************************************/

// override the animation for color styles
$.each(['backgroundColor', 'borderBottomColor', 'borderLeftColor',
	'borderRightColor', 'borderTopColor', 'borderColor', 'color', 'outlineColor'],
function(i, attr) {
	$.fx.step[attr] = function(fx) {
		if (!fx.colorInit) {
			fx.start = getColor(fx.elem, attr);
			fx.end = getRGB(fx.end);
			fx.colorInit = true;
		}

		fx.elem.style[attr] = 'rgb(' +
			Math.max(Math.min(parseInt((fx.pos * (fx.end[0] - fx.start[0])) + fx.start[0], 10), 255), 0) + ',' +
			Math.max(Math.min(parseInt((fx.pos * (fx.end[1] - fx.start[1])) + fx.start[1], 10), 255), 0) + ',' +
			Math.max(Math.min(parseInt((fx.pos * (fx.end[2] - fx.start[2])) + fx.start[2], 10), 255), 0) + ')';
	};
});

// Color Conversion functions from highlightFade
// By Blair Mitchelmore
// http://jquery.offput.ca/highlightFade/

// Parse strings looking for color tuples [255,255,255]
function getRGB(color) {
		var result;

		// Check if we're already dealing with an array of colors
		if ( color && color.constructor == Array && color.length == 3 )
				return color;

		// Look for rgb(num,num,num)
		if (result = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(color))
				return [parseInt(result[1],10), parseInt(result[2],10), parseInt(result[3],10)];

		// Look for rgb(num%,num%,num%)
		if (result = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(color))
				return [parseFloat(result[1])*2.55, parseFloat(result[2])*2.55, parseFloat(result[3])*2.55];

		// Look for #a0b1c2
		if (result = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(color))
				return [parseInt(result[1],16), parseInt(result[2],16), parseInt(result[3],16)];

		// Look for #fff
		if (result = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(color))
				return [parseInt(result[1]+result[1],16), parseInt(result[2]+result[2],16), parseInt(result[3]+result[3],16)];

		// Look for rgba(0, 0, 0, 0) == transparent in Safari 3
		if (result = /rgba\(0, 0, 0, 0\)/.exec(color))
				return colors['transparent'];

		// Otherwise, we're most likely dealing with a named color
		return colors[$.trim(color).toLowerCase()];
}

function getColor(elem, attr) {
		var color;

		do {
				color = $.curCSS(elem, attr);

				// Keep going until we find an element that has color, or we hit the body
				if ( color != '' && color != 'transparent' || $.nodeName(elem, "body") )
						break;

				attr = "backgroundColor";
		} while ( elem = elem.parentNode );

		return getRGB(color);
};

// Some named colors to work with
// From Interface by Stefan Petre
// http://interface.eyecon.ro/

var colors = {
	aqua:[0,255,255],
	azure:[240,255,255],
	beige:[245,245,220],
	black:[0,0,0],
	blue:[0,0,255],
	brown:[165,42,42],
	cyan:[0,255,255],
	darkblue:[0,0,139],
	darkcyan:[0,139,139],
	darkgrey:[169,169,169],
	darkgreen:[0,100,0],
	darkkhaki:[189,183,107],
	darkmagenta:[139,0,139],
	darkolivegreen:[85,107,47],
	darkorange:[255,140,0],
	darkorchid:[153,50,204],
	darkred:[139,0,0],
	darksalmon:[233,150,122],
	darkviolet:[148,0,211],
	fuchsia:[255,0,255],
	gold:[255,215,0],
	green:[0,128,0],
	indigo:[75,0,130],
	khaki:[240,230,140],
	lightblue:[173,216,230],
	lightcyan:[224,255,255],
	lightgreen:[144,238,144],
	lightgrey:[211,211,211],
	lightpink:[255,182,193],
	lightyellow:[255,255,224],
	lime:[0,255,0],
	magenta:[255,0,255],
	maroon:[128,0,0],
	navy:[0,0,128],
	olive:[128,128,0],
	orange:[255,165,0],
	pink:[255,192,203],
	purple:[128,0,128],
	violet:[128,0,128],
	red:[255,0,0],
	silver:[192,192,192],
	white:[255,255,255],
	yellow:[255,255,0],
	transparent: [255,255,255]
};



/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/

var classAnimationActions = ['add', 'remove', 'toggle'],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

function getElementStyles() {
	var style = document.defaultView
			? document.defaultView.getComputedStyle(this, null)
			: this.currentStyle,
		newStyle = {},
		key,
		camelCase;

	// webkit enumerates style porperties
	if (style && style.length && style[0] && style[style[0]]) {
		var len = style.length;
		while (len--) {
			key = style[len];
			if (typeof style[key] == 'string') {
				camelCase = key.replace(/\-(\w)/g, function(all, letter){
					return letter.toUpperCase();
				});
				newStyle[camelCase] = style[key];
			}
		}
	} else {
		for (key in style) {
			if (typeof style[key] === 'string') {
				newStyle[key] = style[key];
			}
		}
	}
	
	return newStyle;
}

function filterStyles(styles) {
	var name, value;
	for (name in styles) {
		value = styles[name];
		if (
			// ignore null and undefined values
			value == null ||
			// ignore functions (when does this occur?)
			$.isFunction(value) ||
			// shorthand styles that need to be expanded
			name in shorthandStyles ||
			// ignore scrollbars (break in IE)
			(/scrollbar/).test(name) ||

			// only colors or values that can be converted to numbers
			(!(/color/i).test(name) && isNaN(parseFloat(value)))
		) {
			delete styles[name];
		}
	}
	
	return styles;
}

function styleDifference(oldStyle, newStyle) {
	var diff = { _: 0 }, // http://dev.jquery.com/ticket/5459
		name;

	for (name in newStyle) {
		if (oldStyle[name] != newStyle[name]) {
			diff[name] = newStyle[name];
		}
	}

	return diff;
}

$.effects.animateClass = function(value, duration, easing, callback) {
	if ($.isFunction(easing)) {
		callback = easing;
		easing = null;
	}

	return this.queue(function() {
		var that = $(this),
			originalStyleAttr = that.attr('style') || ' ',
			originalStyle = filterStyles(getElementStyles.call(this)),
			newStyle,
			className = that.attr('class');

		$.each(classAnimationActions, function(i, action) {
			if (value[action]) {
				that[action + 'Class'](value[action]);
			}
		});
		newStyle = filterStyles(getElementStyles.call(this));
		that.attr('class', className);

		that.animate(styleDifference(originalStyle, newStyle), {
			queue: false,
			duration: duration,
			easing: easing,
			complete: function() {
				$.each(classAnimationActions, function(i, action) {
					if (value[action]) { that[action + 'Class'](value[action]); }
				});
				// work around bug in IE by clearing the cssText before setting it
				if (typeof that.attr('style') == 'object') {
					that.attr('style').cssText = '';
					that.attr('style').cssText = originalStyleAttr;
				} else {
					that.attr('style', originalStyleAttr);
				}
				if (callback) { callback.apply(this, arguments); }
				$.dequeue( this );
			}
		});
	});
};

$.fn.extend({
	_addClass: $.fn.addClass,
	addClass: function(classNames, speed, easing, callback) {
		return speed ? $.effects.animateClass.apply(this, [{ add: classNames },speed,easing,callback]) : this._addClass(classNames);
	},

	_removeClass: $.fn.removeClass,
	removeClass: function(classNames,speed,easing,callback) {
		return speed ? $.effects.animateClass.apply(this, [{ remove: classNames },speed,easing,callback]) : this._removeClass(classNames);
	},

	_toggleClass: $.fn.toggleClass,
	toggleClass: function(classNames, force, speed, easing, callback) {
		if ( typeof force == "boolean" || force === undefined ) {
			if ( !speed ) {
				// without speed parameter;
				return this._toggleClass(classNames, force);
			} else {
				return $.effects.animateClass.apply(this, [(force?{add:classNames}:{remove:classNames}),speed,easing,callback]);
			}
		} else {
			// without switch parameter;
			return $.effects.animateClass.apply(this, [{ toggle: classNames },force,speed,easing]);
		}
	},

	switchClass: function(remove,add,speed,easing,callback) {
		return $.effects.animateClass.apply(this, [{ add: add, remove: remove },speed,easing,callback]);
	}
});



/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

$.extend($.effects, {
	version: "1.8.18",

	// Saves a set of properties in a data storage
	save: function(element, set) {
		for(var i=0; i < set.length; i++) {
			if(set[i] !== null) element.data("ec.storage."+set[i], element[0].style[set[i]]);
		}
	},

	// Restores a set of previously saved properties from a data storage
	restore: function(element, set) {
		for(var i=0; i < set.length; i++) {
			if(set[i] !== null) element.css(set[i], element.data("ec.storage."+set[i]));
		}
	},

	setMode: function(el, mode) {
		if (mode == 'toggle') mode = el.is(':hidden') ? 'show' : 'hide'; // Set for toggle
		return mode;
	},

	getBaseline: function(origin, original) { // Translates a [top,left] array into a baseline value
		// this should be a little more flexible in the future to handle a string & hash
		var y, x;
		switch (origin[0]) {
			case 'top': y = 0; break;
			case 'middle': y = 0.5; break;
			case 'bottom': y = 1; break;
			default: y = origin[0] / original.height;
		};
		switch (origin[1]) {
			case 'left': x = 0; break;
			case 'center': x = 0.5; break;
			case 'right': x = 1; break;
			default: x = origin[1] / original.width;
		};
		return {x: x, y: y};
	},

	// Wraps the element around a wrapper that copies position properties
	createWrapper: function(element) {

		// if the element is already wrapped, return it
		if (element.parent().is('.ui-effects-wrapper')) {
			return element.parent();
		}

		// wrap the element
		var props = {
				width: element.outerWidth(true),
				height: element.outerHeight(true),
				'float': element.css('float')
			},
			wrapper = $('<div></div>')
				.addClass('ui-effects-wrapper')
				.css({
					fontSize: '100%',
					background: 'transparent',
					border: 'none',
					margin: 0,
					padding: 0
				}),
			active = document.activeElement;

		element.wrap(wrapper);

		// Fixes #7595 - Elements lose focus when wrapped.
		if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
			$( active ).focus();
		}
		
		wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually loose the reference to the wrapped element

		// transfer positioning properties to the wrapper
		if (element.css('position') == 'static') {
			wrapper.css({ position: 'relative' });
			element.css({ position: 'relative' });
		} else {
			$.extend(props, {
				position: element.css('position'),
				zIndex: element.css('z-index')
			});
			$.each(['top', 'left', 'bottom', 'right'], function(i, pos) {
				props[pos] = element.css(pos);
				if (isNaN(parseInt(props[pos], 10))) {
					props[pos] = 'auto';
				}
			});
			element.css({position: 'relative', top: 0, left: 0, right: 'auto', bottom: 'auto' });
		}

		return wrapper.css(props).show();
	},

	removeWrapper: function(element) {
		var parent,
			active = document.activeElement;
		
		if (element.parent().is('.ui-effects-wrapper')) {
			parent = element.parent().replaceWith(element);
			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).focus();
			}
			return parent;
		}
			
		return element;
	},

	setTransition: function(element, list, factor, value) {
		value = value || {};
		$.each(list, function(i, x){
			unit = element.cssUnit(x);
			if (unit[0] > 0) value[x] = unit[0] * factor + unit[1];
		});
		return value;
	}
});


function _normalizeArguments(effect, options, speed, callback) {
	// shift params for method overloading
	if (typeof effect == 'object') {
		callback = options;
		speed = null;
		options = effect;
		effect = options.effect;
	}
	if ($.isFunction(options)) {
		callback = options;
		speed = null;
		options = {};
	}
        if (typeof options == 'number' || $.fx.speeds[options]) {
		callback = speed;
		speed = options;
		options = {};
	}
	if ($.isFunction(speed)) {
		callback = speed;
		speed = null;
	}

	options = options || {};

	speed = speed || options.duration;
	speed = $.fx.off ? 0 : typeof speed == 'number'
		? speed : speed in $.fx.speeds ? $.fx.speeds[speed] : $.fx.speeds._default;

	callback = callback || options.complete;

	return [effect, options, speed, callback];
}

function standardSpeed( speed ) {
	// valid standard speeds
	if ( !speed || typeof speed === "number" || $.fx.speeds[ speed ] ) {
		return true;
	}
	
	// invalid strings - treat as "normal" speed
	if ( typeof speed === "string" && !$.effects[ speed ] ) {
		return true;
	}
	
	return false;
}

$.fn.extend({
	effect: function(effect, options, speed, callback) {
		var args = _normalizeArguments.apply(this, arguments),
			// TODO: make effects take actual parameters instead of a hash
			args2 = {
				options: args[1],
				duration: args[2],
				callback: args[3]
			},
			mode = args2.options.mode,
			effectMethod = $.effects[effect];
		
		if ( $.fx.off || !effectMethod ) {
			// delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args2.duration, args2.callback );
			} else {
				return this.each(function() {
					if ( args2.callback ) {
						args2.callback.call( this );
					}
				});
			}
		}
		
		return effectMethod.call(this, args2);
	},

	_show: $.fn.show,
	show: function(speed) {
		if ( standardSpeed( speed ) ) {
			return this._show.apply(this, arguments);
		} else {
			var args = _normalizeArguments.apply(this, arguments);
			args[1].mode = 'show';
			return this.effect.apply(this, args);
		}
	},

	_hide: $.fn.hide,
	hide: function(speed) {
		if ( standardSpeed( speed ) ) {
			return this._hide.apply(this, arguments);
		} else {
			var args = _normalizeArguments.apply(this, arguments);
			args[1].mode = 'hide';
			return this.effect.apply(this, args);
		}
	},

	// jQuery core overloads toggle and creates _toggle
	__toggle: $.fn.toggle,
	toggle: function(speed) {
		if ( standardSpeed( speed ) || typeof speed === "boolean" || $.isFunction( speed ) ) {
			return this.__toggle.apply(this, arguments);
		} else {
			var args = _normalizeArguments.apply(this, arguments);
			args[1].mode = 'toggle';
			return this.effect.apply(this, args);
		}
	},

	// helper functions
	cssUnit: function(key) {
		var style = this.css(key), val = [];
		$.each( ['em','px','%','pt'], function(i, unit){
			if(style.indexOf(unit) > 0)
				val = [parseFloat(style), unit];
		});
		return val;
	}
});



/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing.jswing = $.easing.swing;

$.extend($.easing,
{
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		//alert($.easing.default);
		return $.easing[$.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - $.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return $.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return $.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright 2001 Robert Penner
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

})(jQuery);
/*
 * jQuery UI Effects Blind 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Blind
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.blind = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'hide'); // Set Mode
		var direction = o.options.direction || 'vertical'; // Default direction

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		var wrapper = $.effects.createWrapper(el).css({overflow:'hidden'}); // Create Wrapper
		var ref = (direction == 'vertical') ? 'height' : 'width';
		var distance = (direction == 'vertical') ? wrapper.height() : wrapper.width();
		if(mode == 'show') wrapper.css(ref, 0); // Shift

		// Animation
		var animation = {};
		animation[ref] = mode == 'show' ? distance : 0;

		// Animate
		wrapper.animate(animation, o.duration, o.options.easing, function() {
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(el[0], arguments); // Callback
			el.dequeue();
		});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Bounce 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Bounce
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.bounce = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'effect'); // Set Mode
		var direction = o.options.direction || 'up'; // Default direction
		var distance = o.options.distance || 20; // Default distance
		var times = o.options.times || 5; // Default # of times
		var speed = o.duration || 250; // Default speed per bounce
		if (/show|hide/.test(mode)) props.push('opacity'); // Avoid touching opacity to prevent clearType and PNG issues in IE

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		$.effects.createWrapper(el); // Create Wrapper
		var ref = (direction == 'up' || direction == 'down') ? 'top' : 'left';
		var motion = (direction == 'up' || direction == 'left') ? 'pos' : 'neg';
		var distance = o.options.distance || (ref == 'top' ? el.outerHeight({margin:true}) / 3 : el.outerWidth({margin:true}) / 3);
		if (mode == 'show') el.css('opacity', 0).css(ref, motion == 'pos' ? -distance : distance); // Shift
		if (mode == 'hide') distance = distance / (times * 2);
		if (mode != 'hide') times--;

		// Animate
		if (mode == 'show') { // Show Bounce
			var animation = {opacity: 1};
			animation[ref] = (motion == 'pos' ? '+=' : '-=') + distance;
			el.animate(animation, speed / 2, o.options.easing);
			distance = distance / 2;
			times--;
		};
		for (var i = 0; i < times; i++) { // Bounces
			var animation1 = {}, animation2 = {};
			animation1[ref] = (motion == 'pos' ? '-=' : '+=') + distance;
			animation2[ref] = (motion == 'pos' ? '+=' : '-=') + distance;
			el.animate(animation1, speed / 2, o.options.easing).animate(animation2, speed / 2, o.options.easing);
			distance = (mode == 'hide') ? distance * 2 : distance / 2;
		};
		if (mode == 'hide') { // Last Bounce
			var animation = {opacity: 0};
			animation[ref] = (motion == 'pos' ? '-=' : '+=')  + distance;
			el.animate(animation, speed / 2, o.options.easing, function(){
				el.hide(); // Hide
				$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
				if(o.callback) o.callback.apply(this, arguments); // Callback
			});
		} else {
			var animation1 = {}, animation2 = {};
			animation1[ref] = (motion == 'pos' ? '-=' : '+=') + distance;
			animation2[ref] = (motion == 'pos' ? '+=' : '-=') + distance;
			el.animate(animation1, speed / 2, o.options.easing).animate(animation2, speed / 2, o.options.easing, function(){
				$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
				if(o.callback) o.callback.apply(this, arguments); // Callback
			});
		};
		el.queue('fx', function() { el.dequeue(); });
		el.dequeue();
	});

};

})(jQuery);
/*
 * jQuery UI Effects Clip 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Clip
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.clip = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right','height','width'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'hide'); // Set Mode
		var direction = o.options.direction || 'vertical'; // Default direction

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		var wrapper = $.effects.createWrapper(el).css({overflow:'hidden'}); // Create Wrapper
		var animate = el[0].tagName == 'IMG' ? wrapper : el;
		var ref = {
			size: (direction == 'vertical') ? 'height' : 'width',
			position: (direction == 'vertical') ? 'top' : 'left'
		};
		var distance = (direction == 'vertical') ? animate.height() : animate.width();
		if(mode == 'show') { animate.css(ref.size, 0); animate.css(ref.position, distance / 2); } // Shift

		// Animation
		var animation = {};
		animation[ref.size] = mode == 'show' ? distance : 0;
		animation[ref.position] = mode == 'show' ? 0 : distance / 2;

		// Animate
		animate.animate(animation, { queue: false, duration: o.duration, easing: o.options.easing, complete: function() {
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(el[0], arguments); // Callback
			el.dequeue();
		}});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Drop 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Drop
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.drop = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right','opacity'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'hide'); // Set Mode
		var direction = o.options.direction || 'left'; // Default Direction

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		$.effects.createWrapper(el); // Create Wrapper
		var ref = (direction == 'up' || direction == 'down') ? 'top' : 'left';
		var motion = (direction == 'up' || direction == 'left') ? 'pos' : 'neg';
		var distance = o.options.distance || (ref == 'top' ? el.outerHeight({margin:true}) / 2 : el.outerWidth({margin:true}) / 2);
		if (mode == 'show') el.css('opacity', 0).css(ref, motion == 'pos' ? -distance : distance); // Shift

		// Animation
		var animation = {opacity: mode == 'show' ? 1 : 0};
		animation[ref] = (mode == 'show' ? (motion == 'pos' ? '+=' : '-=') : (motion == 'pos' ? '-=' : '+=')) + distance;

		// Animate
		el.animate(animation, { queue: false, duration: o.duration, easing: o.options.easing, complete: function() {
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(this, arguments); // Callback
			el.dequeue();
		}});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Explode 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Explode
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.explode = function(o) {

	return this.queue(function() {

	var rows = o.options.pieces ? Math.round(Math.sqrt(o.options.pieces)) : 3;
	var cells = o.options.pieces ? Math.round(Math.sqrt(o.options.pieces)) : 3;

	o.options.mode = o.options.mode == 'toggle' ? ($(this).is(':visible') ? 'hide' : 'show') : o.options.mode;
	var el = $(this).show().css('visibility', 'hidden');
	var offset = el.offset();

	//Substract the margins - not fixing the problem yet.
	offset.top -= parseInt(el.css("marginTop"),10) || 0;
	offset.left -= parseInt(el.css("marginLeft"),10) || 0;

	var width = el.outerWidth(true);
	var height = el.outerHeight(true);

	for(var i=0;i<rows;i++) { // =
		for(var j=0;j<cells;j++) { // ||
			el
				.clone()
				.appendTo('body')
				.wrap('<div></div>')
				.css({
					position: 'absolute',
					visibility: 'visible',
					left: -j*(width/cells),
					top: -i*(height/rows)
				})
				.parent()
				.addClass('ui-effects-explode')
				.css({
					position: 'absolute',
					overflow: 'hidden',
					width: width/cells,
					height: height/rows,
					left: offset.left + j*(width/cells) + (o.options.mode == 'show' ? (j-Math.floor(cells/2))*(width/cells) : 0),
					top: offset.top + i*(height/rows) + (o.options.mode == 'show' ? (i-Math.floor(rows/2))*(height/rows) : 0),
					opacity: o.options.mode == 'show' ? 0 : 1
				}).animate({
					left: offset.left + j*(width/cells) + (o.options.mode == 'show' ? 0 : (j-Math.floor(cells/2))*(width/cells)),
					top: offset.top + i*(height/rows) + (o.options.mode == 'show' ? 0 : (i-Math.floor(rows/2))*(height/rows)),
					opacity: o.options.mode == 'show' ? 1 : 0
				}, o.duration || 500);
		}
	}

	// Set a timeout, to call the callback approx. when the other animations have finished
	setTimeout(function() {

		o.options.mode == 'show' ? el.css({ visibility: 'visible' }) : el.css({ visibility: 'visible' }).hide();
				if(o.callback) o.callback.apply(el[0]); // Callback
				el.dequeue();

				$('div.ui-effects-explode').remove();

	}, o.duration || 500);


	});

};

})(jQuery);
/*
 * jQuery UI Effects Fade 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Fade
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.fade = function(o) {
	return this.queue(function() {
		var elem = $(this),
			mode = $.effects.setMode(elem, o.options.mode || 'hide');

		elem.animate({ opacity: mode }, {
			queue: false,
			duration: o.duration,
			easing: o.options.easing,
			complete: function() {
				(o.callback && o.callback.apply(this, arguments));
				elem.dequeue();
			}
		});
	});
};

})(jQuery);
/*
 * jQuery UI Effects Fold 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Fold
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.fold = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'hide'); // Set Mode
		var size = o.options.size || 15; // Default fold size
		var horizFirst = !(!o.options.horizFirst); // Ensure a boolean value
		var duration = o.duration ? o.duration / 2 : $.fx.speeds._default / 2;

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		var wrapper = $.effects.createWrapper(el).css({overflow:'hidden'}); // Create Wrapper
		var widthFirst = ((mode == 'show') != horizFirst);
		var ref = widthFirst ? ['width', 'height'] : ['height', 'width'];
		var distance = widthFirst ? [wrapper.width(), wrapper.height()] : [wrapper.height(), wrapper.width()];
		var percent = /([0-9]+)%/.exec(size);
		if(percent) size = parseInt(percent[1],10) / 100 * distance[mode == 'hide' ? 0 : 1];
		if(mode == 'show') wrapper.css(horizFirst ? {height: 0, width: size} : {height: size, width: 0}); // Shift

		// Animation
		var animation1 = {}, animation2 = {};
		animation1[ref[0]] = mode == 'show' ? distance[0] : size;
		animation2[ref[1]] = mode == 'show' ? distance[1] : 0;

		// Animate
		wrapper.animate(animation1, duration, o.options.easing)
		.animate(animation2, duration, o.options.easing, function() {
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(el[0], arguments); // Callback
			el.dequeue();
		});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Highlight 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Highlight
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.highlight = function(o) {
	return this.queue(function() {
		var elem = $(this),
			props = ['backgroundImage', 'backgroundColor', 'opacity'],
			mode = $.effects.setMode(elem, o.options.mode || 'show'),
			animation = {
				backgroundColor: elem.css('backgroundColor')
			};

		if (mode == 'hide') {
			animation.opacity = 0;
		}

		$.effects.save(elem, props);
		elem
			.show()
			.css({
				backgroundImage: 'none',
				backgroundColor: o.options.color || '#ffff99'
			})
			.animate(animation, {
				queue: false,
				duration: o.duration,
				easing: o.options.easing,
				complete: function() {
					(mode == 'hide' && elem.hide());
					$.effects.restore(elem, props);
					(mode == 'show' && !$.support.opacity && this.style.removeAttribute('filter'));
					(o.callback && o.callback.apply(this, arguments));
					elem.dequeue();
				}
			});
	});
};

})(jQuery);
/*
 * jQuery UI Effects Pulsate 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Pulsate
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.pulsate = function(o) {
	return this.queue(function() {
		var elem = $(this),
			mode = $.effects.setMode(elem, o.options.mode || 'show');
			times = ((o.options.times || 5) * 2) - 1;
			duration = o.duration ? o.duration / 2 : $.fx.speeds._default / 2,
			isVisible = elem.is(':visible'),
			animateTo = 0;

		if (!isVisible) {
			elem.css('opacity', 0).show();
			animateTo = 1;
		}

		if ((mode == 'hide' && isVisible) || (mode == 'show' && !isVisible)) {
			times--;
		}

		for (var i = 0; i < times; i++) {
			elem.animate({ opacity: animateTo }, duration, o.options.easing);
			animateTo = (animateTo + 1) % 2;
		}

		elem.animate({ opacity: animateTo }, duration, o.options.easing, function() {
			if (animateTo == 0) {
				elem.hide();
			}
			(o.callback && o.callback.apply(this, arguments));
		});

		elem
			.queue('fx', function() { elem.dequeue(); })
			.dequeue();
	});
};

})(jQuery);
/*
 * jQuery UI Effects Scale 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Scale
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.puff = function(o) {
	return this.queue(function() {
		var elem = $(this),
			mode = $.effects.setMode(elem, o.options.mode || 'hide'),
			percent = parseInt(o.options.percent, 10) || 150,
			factor = percent / 100,
			original = { height: elem.height(), width: elem.width() };

		$.extend(o.options, {
			fade: true,
			mode: mode,
			percent: mode == 'hide' ? percent : 100,
			from: mode == 'hide'
				? original
				: {
					height: original.height * factor,
					width: original.width * factor
				}
		});

		elem.effect('scale', o.options, o.duration, o.callback);
		elem.dequeue();
	});
};

$.effects.scale = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this);

		// Set options
		var options = $.extend(true, {}, o.options);
		var mode = $.effects.setMode(el, o.options.mode || 'effect'); // Set Mode
		var percent = parseInt(o.options.percent,10) || (parseInt(o.options.percent,10) == 0 ? 0 : (mode == 'hide' ? 0 : 100)); // Set default scaling percent
		var direction = o.options.direction || 'both'; // Set default axis
		var origin = o.options.origin; // The origin of the scaling
		if (mode != 'effect') { // Set default origin and restore for show/hide
			options.origin = origin || ['middle','center'];
			options.restore = true;
		}
		var original = {height: el.height(), width: el.width()}; // Save original
		el.from = o.options.from || (mode == 'show' ? {height: 0, width: 0} : original); // Default from state

		// Adjust
		var factor = { // Set scaling factor
			y: direction != 'horizontal' ? (percent / 100) : 1,
			x: direction != 'vertical' ? (percent / 100) : 1
		};
		el.to = {height: original.height * factor.y, width: original.width * factor.x}; // Set to state

		if (o.options.fade) { // Fade option to support puff
			if (mode == 'show') {el.from.opacity = 0; el.to.opacity = 1;};
			if (mode == 'hide') {el.from.opacity = 1; el.to.opacity = 0;};
		};

		// Animation
		options.from = el.from; options.to = el.to; options.mode = mode;

		// Animate
		el.effect('size', options, o.duration, o.callback);
		el.dequeue();
	});

};

$.effects.size = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right','width','height','overflow','opacity'];
		var props1 = ['position','top','bottom','left','right','overflow','opacity']; // Always restore
		var props2 = ['width','height','overflow']; // Copy for children
		var cProps = ['fontSize'];
		var vProps = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'];
		var hProps = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'effect'); // Set Mode
		var restore = o.options.restore || false; // Default restore
		var scale = o.options.scale || 'both'; // Default scale mode
		var origin = o.options.origin; // The origin of the sizing
		var original = {height: el.height(), width: el.width()}; // Save original
		el.from = o.options.from || original; // Default from state
		el.to = o.options.to || original; // Default to state
		// Adjust
		if (origin) { // Calculate baseline shifts
			var baseline = $.effects.getBaseline(origin, original);
			el.from.top = (original.height - el.from.height) * baseline.y;
			el.from.left = (original.width - el.from.width) * baseline.x;
			el.to.top = (original.height - el.to.height) * baseline.y;
			el.to.left = (original.width - el.to.width) * baseline.x;
		};
		var factor = { // Set scaling factor
			from: {y: el.from.height / original.height, x: el.from.width / original.width},
			to: {y: el.to.height / original.height, x: el.to.width / original.width}
		};
		if (scale == 'box' || scale == 'both') { // Scale the css box
			if (factor.from.y != factor.to.y) { // Vertical props scaling
				props = props.concat(vProps);
				el.from = $.effects.setTransition(el, vProps, factor.from.y, el.from);
				el.to = $.effects.setTransition(el, vProps, factor.to.y, el.to);
			};
			if (factor.from.x != factor.to.x) { // Horizontal props scaling
				props = props.concat(hProps);
				el.from = $.effects.setTransition(el, hProps, factor.from.x, el.from);
				el.to = $.effects.setTransition(el, hProps, factor.to.x, el.to);
			};
		};
		if (scale == 'content' || scale == 'both') { // Scale the content
			if (factor.from.y != factor.to.y) { // Vertical props scaling
				props = props.concat(cProps);
				el.from = $.effects.setTransition(el, cProps, factor.from.y, el.from);
				el.to = $.effects.setTransition(el, cProps, factor.to.y, el.to);
			};
		};
		$.effects.save(el, restore ? props : props1); el.show(); // Save & Show
		$.effects.createWrapper(el); // Create Wrapper
		el.css('overflow','hidden').css(el.from); // Shift

		// Animate
		if (scale == 'content' || scale == 'both') { // Scale the children
			vProps = vProps.concat(['marginTop','marginBottom']).concat(cProps); // Add margins/font-size
			hProps = hProps.concat(['marginLeft','marginRight']); // Add margins
			props2 = props.concat(vProps).concat(hProps); // Concat
			el.find("*[width]").each(function(){
				child = $(this);
				if (restore) $.effects.save(child, props2);
				var c_original = {height: child.height(), width: child.width()}; // Save original
				child.from = {height: c_original.height * factor.from.y, width: c_original.width * factor.from.x};
				child.to = {height: c_original.height * factor.to.y, width: c_original.width * factor.to.x};
				if (factor.from.y != factor.to.y) { // Vertical props scaling
					child.from = $.effects.setTransition(child, vProps, factor.from.y, child.from);
					child.to = $.effects.setTransition(child, vProps, factor.to.y, child.to);
				};
				if (factor.from.x != factor.to.x) { // Horizontal props scaling
					child.from = $.effects.setTransition(child, hProps, factor.from.x, child.from);
					child.to = $.effects.setTransition(child, hProps, factor.to.x, child.to);
				};
				child.css(child.from); // Shift children
				child.animate(child.to, o.duration, o.options.easing, function(){
					if (restore) $.effects.restore(child, props2); // Restore children
				}); // Animate children
			});
		};

		// Animate
		el.animate(el.to, { queue: false, duration: o.duration, easing: o.options.easing, complete: function() {
			if (el.to.opacity === 0) {
				el.css('opacity', el.from.opacity);
			}
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, restore ? props : props1); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(this, arguments); // Callback
			el.dequeue();
		}});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Shake 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Shake
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.shake = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'effect'); // Set Mode
		var direction = o.options.direction || 'left'; // Default direction
		var distance = o.options.distance || 20; // Default distance
		var times = o.options.times || 3; // Default # of times
		var speed = o.duration || o.options.duration || 140; // Default speed per shake

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		$.effects.createWrapper(el); // Create Wrapper
		var ref = (direction == 'up' || direction == 'down') ? 'top' : 'left';
		var motion = (direction == 'up' || direction == 'left') ? 'pos' : 'neg';

		// Animation
		var animation = {}, animation1 = {}, animation2 = {};
		animation[ref] = (motion == 'pos' ? '-=' : '+=')  + distance;
		animation1[ref] = (motion == 'pos' ? '+=' : '-=')  + distance * 2;
		animation2[ref] = (motion == 'pos' ? '-=' : '+=')  + distance * 2;

		// Animate
		el.animate(animation, speed, o.options.easing);
		for (var i = 1; i < times; i++) { // Shakes
			el.animate(animation1, speed, o.options.easing).animate(animation2, speed, o.options.easing);
		};
		el.animate(animation1, speed, o.options.easing).
		animate(animation, speed / 2, o.options.easing, function(){ // Last shake
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(this, arguments); // Callback
		});
		el.queue('fx', function() { el.dequeue(); });
		el.dequeue();
	});

};

})(jQuery);
/*
 * jQuery UI Effects Slide 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Slide
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.slide = function(o) {

	return this.queue(function() {

		// Create element
		var el = $(this), props = ['position','top','bottom','left','right'];

		// Set options
		var mode = $.effects.setMode(el, o.options.mode || 'show'); // Set Mode
		var direction = o.options.direction || 'left'; // Default Direction

		// Adjust
		$.effects.save(el, props); el.show(); // Save & Show
		$.effects.createWrapper(el).css({overflow:'hidden'}); // Create Wrapper
		var ref = (direction == 'up' || direction == 'down') ? 'top' : 'left';
		var motion = (direction == 'up' || direction == 'left') ? 'pos' : 'neg';
		var distance = o.options.distance || (ref == 'top' ? el.outerHeight({margin:true}) : el.outerWidth({margin:true}));
		if (mode == 'show') el.css(ref, motion == 'pos' ? (isNaN(distance) ? "-" + distance : -distance) : distance); // Shift

		// Animation
		var animation = {};
		animation[ref] = (mode == 'show' ? (motion == 'pos' ? '+=' : '-=') : (motion == 'pos' ? '-=' : '+=')) + distance;

		// Animate
		el.animate(animation, { queue: false, duration: o.duration, easing: o.options.easing, complete: function() {
			if(mode == 'hide') el.hide(); // Hide
			$.effects.restore(el, props); $.effects.removeWrapper(el); // Restore
			if(o.callback) o.callback.apply(this, arguments); // Callback
			el.dequeue();
		}});

	});

};

})(jQuery);
/*
 * jQuery UI Effects Transfer 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Transfer
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function( $, undefined ) {

$.effects.transfer = function(o) {
	return this.queue(function() {
		var elem = $(this),
			target = $(o.options.to),
			endPosition = target.offset(),
			animation = {
				top: endPosition.top,
				left: endPosition.left,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = elem.offset(),
			transfer = $('<div class="ui-effects-transfer"></div>')
				.appendTo(document.body)
				.addClass(o.options.className)
				.css({
					top: startPosition.top,
					left: startPosition.left,
					height: elem.innerHeight(),
					width: elem.innerWidth(),
					position: 'absolute'
				})
				.animate(animation, o.duration, o.options.easing, function() {
					transfer.remove();
					(o.callback && o.callback.apply(elem[0], arguments));
					elem.dequeue();
				});
	});
};

})(jQuery);
/*
 * jQuery UI Accordion 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Accordion
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget( "ui.accordion", {
	options: {
		active: 0,
		animated: "slide",
		autoHeight: true,
		clearStyle: false,
		collapsible: false,
		event: "click",
		fillSpace: false,
		header: "> li > :first-child,> :not(li):even",
		icons: {
			header: "ui-icon-triangle-1-e",
			headerSelected: "ui-icon-triangle-1-s"
		},
		navigation: false,
		navigationFilter: function() {
			return this.href.toLowerCase() === location.href.toLowerCase();
		}
	},

	_create: function() {
		var self = this,
			options = self.options;

		self.running = 0;

		self.element
			.addClass( "ui-accordion ui-widget ui-helper-reset" )
			// in lack of child-selectors in CSS
			// we need to mark top-LIs in a UL-accordion for some IE-fix
			.children( "li" )
				.addClass( "ui-accordion-li-fix" );

		self.headers = self.element.find( options.header )
			.addClass( "ui-accordion-header ui-helper-reset ui-state-default ui-corner-all" )
			.bind( "mouseenter.accordion", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).addClass( "ui-state-hover" );
			})
			.bind( "mouseleave.accordion", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( "ui-state-hover" );
			})
			.bind( "focus.accordion", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).addClass( "ui-state-focus" );
			})
			.bind( "blur.accordion", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( "ui-state-focus" );
			});

		self.headers.next()
			.addClass( "ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom" );

		if ( options.navigation ) {
			var current = self.element.find( "a" ).filter( options.navigationFilter ).eq( 0 );
			if ( current.length ) {
				var header = current.closest( ".ui-accordion-header" );
				if ( header.length ) {
					// anchor within header
					self.active = header;
				} else {
					// anchor within content
					self.active = current.closest( ".ui-accordion-content" ).prev();
				}
			}
		}

		self.active = self._findActive( self.active || options.active )
			.addClass( "ui-state-default ui-state-active" )
			.toggleClass( "ui-corner-all" )
			.toggleClass( "ui-corner-top" );
		self.active.next().addClass( "ui-accordion-content-active" );

		self._createIcons();
		self.resize();
		
		// ARIA
		self.element.attr( "role", "tablist" );

		self.headers
			.attr( "role", "tab" )
			.bind( "keydown.accordion", function( event ) {
				return self._keydown( event );
			})
			.next()
				.attr( "role", "tabpanel" );

		self.headers
			.not( self.active || "" )
			.attr({
				"aria-expanded": "false",
				"aria-selected": "false",
				tabIndex: -1
			})
			.next()
				.hide();

		// make sure at least one header is in the tab order
		if ( !self.active.length ) {
			self.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			self.active
				.attr({
					"aria-expanded": "true",
					"aria-selected": "true",
					tabIndex: 0
				});
		}

		// only need links in tab order for Safari
		if ( !$.browser.safari ) {
			self.headers.find( "a" ).attr( "tabIndex", -1 );
		}

		if ( options.event ) {
			self.headers.bind( options.event.split(" ").join(".accordion ") + ".accordion", function(event) {
				self._clickHandler.call( self, event, this );
				event.preventDefault();
			});
		}
	},

	_createIcons: function() {
		var options = this.options;
		if ( options.icons ) {
			$( "<span></span>" )
				.addClass( "ui-icon " + options.icons.header )
				.prependTo( this.headers );
			this.active.children( ".ui-icon" )
				.toggleClass(options.icons.header)
				.toggleClass(options.icons.headerSelected);
			this.element.addClass( "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this.headers.children( ".ui-icon" ).remove();
		this.element.removeClass( "ui-accordion-icons" );
	},

	destroy: function() {
		var options = this.options;

		this.element
			.removeClass( "ui-accordion ui-widget ui-helper-reset" )
			.removeAttr( "role" );

		this.headers
			.unbind( ".accordion" )
			.removeClass( "ui-accordion-header ui-accordion-disabled ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top" )
			.removeAttr( "role" )
			.removeAttr( "aria-expanded" )
			.removeAttr( "aria-selected" )
			.removeAttr( "tabIndex" );

		this.headers.find( "a" ).removeAttr( "tabIndex" );
		this._destroyIcons();
		var contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role" )
			.removeClass( "ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-accordion-disabled ui-state-disabled" );
		if ( options.autoHeight || options.fillHeight ) {
			contents.css( "height", "" );
		}

		return $.Widget.prototype.destroy.call( this );
	},

	_setOption: function( key, value ) {
		$.Widget.prototype._setOption.apply( this, arguments );
			
		if ( key == "active" ) {
			this.activate( value );
		}
		if ( key == "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
		// #5332 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		if ( key == "disabled" ) {
			this.headers.add(this.headers.next())
				[ value ? "addClass" : "removeClass" ](
					"ui-accordion-disabled ui-state-disabled" );
		}
	},

	_keydown: function( event ) {
		if ( this.options.disabled || event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
			case keyCode.RIGHT:
			case keyCode.DOWN:
				toFocus = this.headers[ ( currentIndex + 1 ) % length ];
				break;
			case keyCode.LEFT:
			case keyCode.UP:
				toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
				break;
			case keyCode.SPACE:
			case keyCode.ENTER:
				this._clickHandler( { target: event.target }, event.target );
				event.preventDefault();
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			toFocus.focus();
			return false;
		}

		return true;
	},

	resize: function() {
		var options = this.options,
			maxHeight;

		if ( options.fillSpace ) {
			if ( $.browser.msie ) {
				var defOverflow = this.element.parent().css( "overflow" );
				this.element.parent().css( "overflow", "hidden");
			}
			maxHeight = this.element.parent().height();
			if ($.browser.msie) {
				this.element.parent().css( "overflow", defOverflow );
			}

			this.headers.each(function() {
				maxHeight -= $( this ).outerHeight( true );
			});

			this.headers.next()
				.each(function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				})
				.css( "overflow", "auto" );
		} else if ( options.autoHeight ) {
			maxHeight = 0;
			this.headers.next()
				.each(function() {
					maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
				})
				.height( maxHeight );
		}

		return this;
	},

	activate: function( index ) {
		// TODO this gets called on init, changing the option without an explicit call for that
		this.options.active = index;
		// call clickHandler with custom event
		var active = this._findActive( index )[ 0 ];
		this._clickHandler( { target: active }, active );

		return this;
	},

	_findActive: function( selector ) {
		return selector
			? typeof selector === "number"
				? this.headers.filter( ":eq(" + selector + ")" )
				: this.headers.not( this.headers.not( selector ) )
			: selector === false
				? $( [] )
				: this.headers.filter( ":eq(0)" );
	},

	// TODO isn't event.target enough? why the separate target argument?
	_clickHandler: function( event, target ) {
		var options = this.options;
		if ( options.disabled ) {
			return;
		}

		// called only when using activate(false) to close all parts programmatically
		if ( !event.target ) {
			if ( !options.collapsible ) {
				return;
			}
			this.active
				.removeClass( "ui-state-active ui-corner-top" )
				.addClass( "ui-state-default ui-corner-all" )
				.children( ".ui-icon" )
					.removeClass( options.icons.headerSelected )
					.addClass( options.icons.header );
			this.active.next().addClass( "ui-accordion-content-active" );
			var toHide = this.active.next(),
				data = {
					options: options,
					newHeader: $( [] ),
					oldHeader: options.active,
					newContent: $( [] ),
					oldContent: toHide
				},
				toShow = ( this.active = $( [] ) );
			this._toggle( toShow, toHide, data );
			return;
		}

		// get the click target
		var clicked = $( event.currentTarget || target ),
			clickedIsActive = clicked[0] === this.active[0];

		// TODO the option is changed, is that correct?
		// TODO if it is correct, shouldn't that happen after determining that the click is valid?
		options.active = options.collapsible && clickedIsActive ?
			false :
			this.headers.index( clicked );

		// if animations are still active, or the active header is the target, ignore click
		if ( this.running || ( !options.collapsible && clickedIsActive ) ) {
			return;
		}

		// find elements to show and hide
		var active = this.active,
			toShow = clicked.next(),
			toHide = this.active.next(),
			data = {
				options: options,
				newHeader: clickedIsActive && options.collapsible ? $([]) : clicked,
				oldHeader: this.active,
				newContent: clickedIsActive && options.collapsible ? $([]) : toShow,
				oldContent: toHide
			},
			down = this.headers.index( this.active[0] ) > this.headers.index( clicked[0] );

		// when the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $([]) : clicked;
		this._toggle( toShow, toHide, data, clickedIsActive, down );

		// switch classes
		active
			.removeClass( "ui-state-active ui-corner-top" )
			.addClass( "ui-state-default ui-corner-all" )
			.children( ".ui-icon" )
				.removeClass( options.icons.headerSelected )
				.addClass( options.icons.header );
		if ( !clickedIsActive ) {
			clicked
				.removeClass( "ui-state-default ui-corner-all" )
				.addClass( "ui-state-active ui-corner-top" )
				.children( ".ui-icon" )
					.removeClass( options.icons.header )
					.addClass( options.icons.headerSelected );
			clicked
				.next()
				.addClass( "ui-accordion-content-active" );
		}

		return;
	},

	_toggle: function( toShow, toHide, data, clickedIsActive, down ) {
		var self = this,
			options = self.options;

		self.toShow = toShow;
		self.toHide = toHide;
		self.data = data;

		var complete = function() {
			if ( !self ) {
				return;
			}
			return self._completed.apply( self, arguments );
		};

		// trigger changestart event
		self._trigger( "changestart", null, self.data );

		// count elements to animate
		self.running = toHide.size() === 0 ? toShow.size() : toHide.size();

		if ( options.animated ) {
			var animOptions = {};

			if ( options.collapsible && clickedIsActive ) {
				animOptions = {
					toShow: $( [] ),
					toHide: toHide,
					complete: complete,
					down: down,
					autoHeight: options.autoHeight || options.fillSpace
				};
			} else {
				animOptions = {
					toShow: toShow,
					toHide: toHide,
					complete: complete,
					down: down,
					autoHeight: options.autoHeight || options.fillSpace
				};
			}

			if ( !options.proxied ) {
				options.proxied = options.animated;
			}

			if ( !options.proxiedDuration ) {
				options.proxiedDuration = options.duration;
			}

			options.animated = $.isFunction( options.proxied ) ?
				options.proxied( animOptions ) :
				options.proxied;

			options.duration = $.isFunction( options.proxiedDuration ) ?
				options.proxiedDuration( animOptions ) :
				options.proxiedDuration;

			var animations = $.ui.accordion.animations,
				duration = options.duration,
				easing = options.animated;

			if ( easing && !animations[ easing ] && !$.easing[ easing ] ) {
				easing = "slide";
			}
			if ( !animations[ easing ] ) {
				animations[ easing ] = function( options ) {
					this.slide( options, {
						easing: easing,
						duration: duration || 700
					});
				};
			}

			animations[ easing ]( animOptions );
		} else {
			if ( options.collapsible && clickedIsActive ) {
				toShow.toggle();
			} else {
				toHide.hide();
				toShow.show();
			}

			complete( true );
		}

		// TODO assert that the blur and focus triggers are really necessary, remove otherwise
		toHide.prev()
			.attr({
				"aria-expanded": "false",
				"aria-selected": "false",
				tabIndex: -1
			})
			.blur();
		toShow.prev()
			.attr({
				"aria-expanded": "true",
				"aria-selected": "true",
				tabIndex: 0
			})
			.focus();
	},

	_completed: function( cancel ) {
		this.running = cancel ? 0 : --this.running;
		if ( this.running ) {
			return;
		}

		if ( this.options.clearStyle ) {
			this.toShow.add( this.toHide ).css({
				height: "",
				overflow: ""
			});
		}

		// other classes are removed before the animation; this one needs to stay until completed
		this.toHide.removeClass( "ui-accordion-content-active" );
		// Work around for rendering bug in IE (#5421)
		if ( this.toHide.length ) {
			this.toHide.parent()[0].className = this.toHide.parent()[0].className;
		}

		this._trigger( "change", null, this.data );
	}
});

$.extend( $.ui.accordion, {
	version: "1.8.18",
	animations: {
		slide: function( options, additions ) {
			options = $.extend({
				easing: "swing",
				duration: 300
			}, options, additions );
			if ( !options.toHide.size() ) {
				options.toShow.animate({
					height: "show",
					paddingTop: "show",
					paddingBottom: "show"
				}, options );
				return;
			}
			if ( !options.toShow.size() ) {
				options.toHide.animate({
					height: "hide",
					paddingTop: "hide",
					paddingBottom: "hide"
				}, options );
				return;
			}
			var overflow = options.toShow.css( "overflow" ),
				percentDone = 0,
				showProps = {},
				hideProps = {},
				fxAttrs = [ "height", "paddingTop", "paddingBottom" ],
				originalWidth;
			// fix width before calculating height of hidden element
			var s = options.toShow;
			originalWidth = s[0].style.width;
			s.width( s.parent().width()
				- parseFloat( s.css( "paddingLeft" ) )
				- parseFloat( s.css( "paddingRight" ) )
				- ( parseFloat( s.css( "borderLeftWidth" ) ) || 0 )
				- ( parseFloat( s.css( "borderRightWidth" ) ) || 0 ) );

			$.each( fxAttrs, function( i, prop ) {
				hideProps[ prop ] = "hide";

				var parts = ( "" + $.css( options.toShow[0], prop ) ).match( /^([\d+-.]+)(.*)$/ );
				showProps[ prop ] = {
					value: parts[ 1 ],
					unit: parts[ 2 ] || "px"
				};
			});
			options.toShow.css({ height: 0, overflow: "hidden" }).show();
			options.toHide
				.filter( ":hidden" )
					.each( options.complete )
				.end()
				.filter( ":visible" )
				.animate( hideProps, {
				step: function( now, settings ) {
					// only calculate the percent when animating height
					// IE gets very inconsistent results when animating elements
					// with small values, which is common for padding
					if ( settings.prop == "height" ) {
						percentDone = ( settings.end - settings.start === 0 ) ? 0 :
							( settings.now - settings.start ) / ( settings.end - settings.start );
					}

					options.toShow[ 0 ].style[ settings.prop ] =
						( percentDone * showProps[ settings.prop ].value )
						+ showProps[ settings.prop ].unit;
				},
				duration: options.duration,
				easing: options.easing,
				complete: function() {
					if ( !options.autoHeight ) {
						options.toShow.css( "height", "" );
					}
					options.toShow.css({
						width: originalWidth,
						overflow: overflow
					});
					options.complete();
				}
			});
		},
		bounceslide: function( options ) {
			this.slide( options, {
				easing: options.down ? "easeOutBounce" : "swing",
				duration: options.down ? 1000 : 200
			});
		}
	}
});

})( jQuery );
/*
 * jQuery UI Autocomplete 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Autocomplete
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.position.js
 */
(function( $, undefined ) {

// used to prevent race conditions with remote data sources
var requestIndex = 0;

$.widget( "ui.autocomplete", {
	options: {
		appendTo: "body",
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null
	},

	pending: 0,

	_create: function() {
		var self = this,
			doc = this.element[ 0 ].ownerDocument,
			suppressKeyPress;

		this.element
			.addClass( "ui-autocomplete-input" )
			.attr( "autocomplete", "off" )
			// TODO verify these actually work as intended
			.attr({
				role: "textbox",
				"aria-autocomplete": "list",
				"aria-haspopup": "true"
			})
			.bind( "keydown.autocomplete", function( event ) {
				if ( self.options.disabled || self.element.propAttr( "readOnly" ) ) {
					return;
				}

				suppressKeyPress = false;
				var keyCode = $.ui.keyCode;
				switch( event.keyCode ) {
				case keyCode.PAGE_UP:
					self._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					self._move( "nextPage", event );
					break;
				case keyCode.UP:
					self._move( "previous", event );
					// prevent moving cursor to beginning of text field in some browsers
					event.preventDefault();
					break;
				case keyCode.DOWN:
					self._move( "next", event );
					// prevent moving cursor to end of text field in some browsers
					event.preventDefault();
					break;
				case keyCode.ENTER:
				case keyCode.NUMPAD_ENTER:
					// when menu is open and has focus
					if ( self.menu.active ) {
						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
					}
					//passthrough - ENTER and TAB both select the current element
				case keyCode.TAB:
					if ( !self.menu.active ) {
						return;
					}
					self.menu.select( event );
					break;
				case keyCode.ESCAPE:
					self.element.val( self.term );
					self.close( event );
					break;
				default:
					// keypress is triggered before the input value is changed
					clearTimeout( self.searching );
					self.searching = setTimeout(function() {
						// only search if the value has changed
						if ( self.term != self.element.val() ) {
							self.selectedItem = null;
							self.search( null, event );
						}
					}, self.options.delay );
					break;
				}
			})
			.bind( "keypress.autocomplete", function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					event.preventDefault();
				}
			})
			.bind( "focus.autocomplete", function() {
				if ( self.options.disabled ) {
					return;
				}

				self.selectedItem = null;
				self.previous = self.element.val();
			})
			.bind( "blur.autocomplete", function( event ) {
				if ( self.options.disabled ) {
					return;
				}

				clearTimeout( self.searching );
				// clicks on the menu (or a button to trigger a search) will cause a blur event
				self.closing = setTimeout(function() {
					self.close( event );
					self._change( event );
				}, 150 );
			});
		this._initSource();
		this.response = function() {
			return self._response.apply( self, arguments );
		};
		this.menu = $( "<ul></ul>" )
			.addClass( "ui-autocomplete" )
			.appendTo( $( this.options.appendTo || "body", doc )[0] )
			// prevent the close-on-blur in case of a "slow" click on the menu (long mousedown)
			.mousedown(function( event ) {
				// clicking on the scrollbar causes focus to shift to the body
				// but we can't detect a mouseup or a click immediately afterward
				// so we have to track the next mousedown and close the menu if
				// the user clicks somewhere outside of the autocomplete
				var menuElement = self.menu.element[ 0 ];
				if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
					setTimeout(function() {
						$( document ).one( 'mousedown', function( event ) {
							if ( event.target !== self.element[ 0 ] &&
								event.target !== menuElement &&
								!$.ui.contains( menuElement, event.target ) ) {
								self.close();
							}
						});
					}, 1 );
				}

				// use another timeout to make sure the blur-event-handler on the input was already triggered
				setTimeout(function() {
					clearTimeout( self.closing );
				}, 13);
			})
			.menu({
				focus: function( event, ui ) {
					var item = ui.item.data( "item.autocomplete" );
					if ( false !== self._trigger( "focus", event, { item: item } ) ) {
						// use value to match what will end up in the input, if it was a key event
						if ( /^key/.test(event.originalEvent.type) ) {
							self.element.val( item.value );
						}
					}
				},
				selected: function( event, ui ) {
					var item = ui.item.data( "item.autocomplete" ),
						previous = self.previous;

					// only trigger when focus was lost (click on menu)
					if ( self.element[0] !== doc.activeElement ) {
						self.element.focus();
						self.previous = previous;
						// #6109 - IE triggers two focus events and the second
						// is asynchronous, so we need to reset the previous
						// term synchronously and asynchronously :-(
						setTimeout(function() {
							self.previous = previous;
							self.selectedItem = item;
						}, 1);
					}

					if ( false !== self._trigger( "select", event, { item: item } ) ) {
						self.element.val( item.value );
					}
					// reset the term after the select event
					// this allows custom select handling to work properly
					self.term = self.element.val();

					self.close( event );
					self.selectedItem = item;
				},
				blur: function( event, ui ) {
					// don't set the value of the text field if it's already correct
					// this prevents moving the cursor unnecessarily
					if ( self.menu.element.is(":visible") &&
						( self.element.val() !== self.term ) ) {
						self.element.val( self.term );
					}
				}
			})
			.zIndex( this.element.zIndex() + 1 )
			// workaround for jQuery bug #5781 http://dev.jquery.com/ticket/5781
			.css({ top: 0, left: 0 })
			.hide()
			.data( "menu" );
		if ( $.fn.bgiframe ) {
			 this.menu.element.bgiframe();
		}
		// turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		self.beforeunloadHandler = function() {
			self.element.removeAttr( "autocomplete" );
		};
		$( window ).bind( "beforeunload", self.beforeunloadHandler );
	},

	destroy: function() {
		this.element
			.removeClass( "ui-autocomplete-input" )
			.removeAttr( "autocomplete" )
			.removeAttr( "role" )
			.removeAttr( "aria-autocomplete" )
			.removeAttr( "aria-haspopup" );
		this.menu.element.remove();
		$( window ).unbind( "beforeunload", this.beforeunloadHandler );
		$.Widget.prototype.destroy.call( this );
	},

	_setOption: function( key, value ) {
		$.Widget.prototype._setOption.apply( this, arguments );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( $( value || "body", this.element[0].ownerDocument )[0] )
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_initSource: function() {
		var self = this,
			array,
			url;
		if ( $.isArray(this.options.source) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter(array, request.term) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( self.xhr ) {
					self.xhr.abort();
				}
				self.xhr = $.ajax({
					url: url,
					data: request,
					dataType: "json",
					context: {
						autocompleteRequest: ++requestIndex
					},
					success: function( data, status ) {
						if ( this.autocompleteRequest === requestIndex ) {
							response( data );
						}
					},
					error: function() {
						if ( this.autocompleteRequest === requestIndex ) {
							response( [] );
						}
					}
				});
			};
		} else {
			this.source = this.options.source;
		}
	},

	search: function( value, event ) {
		value = value != null ? value : this.element.val();

		// always save the actual value, not the one passed as an argument
		this.term = this.element.val();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		clearTimeout( this.closing );
		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this.element.addClass( "ui-autocomplete-loading" );

		this.source( { term: value }, this.response );
	},

	_response: function( content ) {
		if ( !this.options.disabled && content && content.length ) {
			content = this._normalize( content );
			this._suggest( content );
			this._trigger( "open" );
		} else {
			this.close();
		}
		this.pending--;
		if ( !this.pending ) {
			this.element.removeClass( "ui-autocomplete-loading" );
		}
	},

	close: function( event ) {
		clearTimeout( this.closing );
		if ( this.menu.element.is(":visible") ) {
			this.menu.element.hide();
			this.menu.deactivate();
			this._trigger( "close", event );
		}
	},
	
	_change: function( event ) {
		if ( this.previous !== this.element.val() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {
		// assume all items have the right format when the first item is complete
		if ( items.length && items[0].label && items[0].value ) {
			return items;
		}
		return $.map( items, function(item) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend({
				label: item.label || item.value,
				value: item.value || item.label
			}, item );
		});
	},

	_suggest: function( items ) {
		var ul = this.menu.element
			.empty()
			.zIndex( this.element.zIndex() + 1 );
		this._renderMenu( ul, items );
		// TODO refresh should check if the active item is still in the dom, removing the need for a manual deactivate
		this.menu.deactivate();
		this.menu.refresh();

		// size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend({
			of: this.element
		}, this.options.position ));

		if ( this.options.autoFocus ) {
			this.menu.next( new $.Event("mouseover") );
		}
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(
			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var self = this;
		$.each( items, function( index, item ) {
			self._renderItem( ul, item );
		});
	},

	_renderItem: function( ul, item) {
		return $( "<li></li>" )
			.data( "item.autocomplete", item )
			.append( $( "<a></a>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is(":visible") ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.first() && /^previous/.test(direction) ||
				this.menu.last() && /^next/.test(direction) ) {
			this.element.val( this.term );
			this.menu.deactivate();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	}
});

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	},
	filter: function(array, term) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex(term), "i" );
		return $.grep( array, function(value) {
			return matcher.test( value.label || value.value || value );
		});
	}
});

}( jQuery ));

/*
 * jQuery UI Menu (not officially released)
 * 
 * This widget isn't yet finished and the API is subject to change. We plan to finish
 * it for the next release. You're welcome to give it a try anyway and give us feedback,
 * as long as you're okay with migrating your code later on. We can help with that, too.
 *
 * Copyright 2010, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Menu
 *
 * Depends:
 *	jquery.ui.core.js
 *  jquery.ui.widget.js
 */
(function($) {

$.widget("ui.menu", {
	_create: function() {
		var self = this;
		this.element
			.addClass("ui-menu ui-widget ui-widget-content ui-corner-all")
			.attr({
				role: "listbox",
				"aria-activedescendant": "ui-active-menuitem"
			})
			.click(function( event ) {
				if ( !$( event.target ).closest( ".ui-menu-item a" ).length ) {
					return;
				}
				// temporary
				event.preventDefault();
				self.select( event );
			});
		this.refresh();
	},
	
	refresh: function() {
		var self = this;

		// don't refresh list items that are already adapted
		var items = this.element.children("li:not(.ui-menu-item):has(a)")
			.addClass("ui-menu-item")
			.attr("role", "menuitem");
		
		items.children("a")
			.addClass("ui-corner-all")
			.attr("tabindex", -1)
			// mouseenter doesn't work with event delegation
			.mouseenter(function( event ) {
				self.activate( event, $(this).parent() );
			})
			.mouseleave(function() {
				self.deactivate();
			});
	},

	activate: function( event, item ) {
		this.deactivate();
		if (this.hasScroll()) {
			var offset = item.offset().top - this.element.offset().top,
				scroll = this.element.scrollTop(),
				elementHeight = this.element.height();
			if (offset < 0) {
				this.element.scrollTop( scroll + offset);
			} else if (offset >= elementHeight) {
				this.element.scrollTop( scroll + offset - elementHeight + item.height());
			}
		}
		this.active = item.eq(0)
			.children("a")
				.addClass("ui-state-hover")
				.attr("id", "ui-active-menuitem")
			.end();
		this._trigger("focus", event, { item: item });
	},

	deactivate: function() {
		if (!this.active) { return; }

		this.active.children("a")
			.removeClass("ui-state-hover")
			.removeAttr("id");
		this._trigger("blur");
		this.active = null;
	},

	next: function(event) {
		this.move("next", ".ui-menu-item:first", event);
	},

	previous: function(event) {
		this.move("prev", ".ui-menu-item:last", event);
	},

	first: function() {
		return this.active && !this.active.prevAll(".ui-menu-item").length;
	},

	last: function() {
		return this.active && !this.active.nextAll(".ui-menu-item").length;
	},

	move: function(direction, edge, event) {
		if (!this.active) {
			this.activate(event, this.element.children(edge));
			return;
		}
		var next = this.active[direction + "All"](".ui-menu-item").eq(0);
		if (next.length) {
			this.activate(event, next);
		} else {
			this.activate(event, this.element.children(edge));
		}
	},

	// TODO merge with previousPage
	nextPage: function(event) {
		if (this.hasScroll()) {
			// TODO merge with no-scroll-else
			if (!this.active || this.last()) {
				this.activate(event, this.element.children(".ui-menu-item:first"));
				return;
			}
			var base = this.active.offset().top,
				height = this.element.height(),
				result = this.element.children(".ui-menu-item").filter(function() {
					var close = $(this).offset().top - base - height + $(this).height();
					// TODO improve approximation
					return close < 10 && close > -10;
				});

			// TODO try to catch this earlier when scrollTop indicates the last page anyway
			if (!result.length) {
				result = this.element.children(".ui-menu-item:last");
			}
			this.activate(event, result);
		} else {
			this.activate(event, this.element.children(".ui-menu-item")
				.filter(!this.active || this.last() ? ":first" : ":last"));
		}
	},

	// TODO merge with nextPage
	previousPage: function(event) {
		if (this.hasScroll()) {
			// TODO merge with no-scroll-else
			if (!this.active || this.first()) {
				this.activate(event, this.element.children(".ui-menu-item:last"));
				return;
			}

			var base = this.active.offset().top,
				height = this.element.height();
				result = this.element.children(".ui-menu-item").filter(function() {
					var close = $(this).offset().top - base + height - $(this).height();
					// TODO improve approximation
					return close < 10 && close > -10;
				});

			// TODO try to catch this earlier when scrollTop indicates the last page anyway
			if (!result.length) {
				result = this.element.children(".ui-menu-item:first");
			}
			this.activate(event, result);
		} else {
			this.activate(event, this.element.children(".ui-menu-item")
				.filter(!this.active || this.first() ? ":last" : ":first"));
		}
	},

	hasScroll: function() {
		return this.element.height() < this.element[ $.fn.prop ? "prop" : "attr" ]("scrollHeight");
	},

	select: function( event ) {
		this._trigger("selected", event, { item: this.active });
	}
});

}(jQuery));
/*
 * jQuery UI Button 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Button
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

var lastActive, startXPos, startYPos, clickDragged,
	baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
	stateClasses = "ui-state-hover ui-state-active ",
	typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	formResetHandler = function() {
		var buttons = $( this ).find( ":ui-button" );
		setTimeout(function() {
			buttons.button( "refresh" );
		}, 1 );
	},
	radioGroup = function( radio ) {
		var name = radio.name,
			form = radio.form,
			radios = $( [] );
		if ( name ) {
			if ( form ) {
				radios = $( form ).find( "[name='" + name + "']" );
			} else {
				radios = $( "[name='" + name + "']", radio.ownerDocument )
					.filter(function() {
						return !this.form;
					});
			}
		}
		return radios;
	};

$.widget( "ui.button", {
	options: {
		disabled: null,
		text: true,
		label: null,
		icons: {
			primary: null,
			secondary: null
		}
	},
	_create: function() {
		this.element.closest( "form" )
			.unbind( "reset.button" )
			.bind( "reset.button", formResetHandler );

		if ( typeof this.options.disabled !== "boolean" ) {
			this.options.disabled = !!this.element.propAttr( "disabled" );
		} else {
			this.element.propAttr( "disabled", this.options.disabled );
		}

		this._determineButtonType();
		this.hasTitle = !!this.buttonElement.attr( "title" );

		var self = this,
			options = this.options,
			toggleButton = this.type === "checkbox" || this.type === "radio",
			hoverClass = "ui-state-hover" + ( !toggleButton ? " ui-state-active" : "" ),
			focusClass = "ui-state-focus";

		if ( options.label === null ) {
			options.label = this.buttonElement.html();
		}

		this.buttonElement
			.addClass( baseClasses )
			.attr( "role", "button" )
			.bind( "mouseenter.button", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).addClass( "ui-state-hover" );
				if ( this === lastActive ) {
					$( this ).addClass( "ui-state-active" );
				}
			})
			.bind( "mouseleave.button", function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( hoverClass );
			})
			.bind( "click.button", function( event ) {
				if ( options.disabled ) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});

		this.element
			.bind( "focus.button", function() {
				// no need to check disabled, focus won't be triggered anyway
				self.buttonElement.addClass( focusClass );
			})
			.bind( "blur.button", function() {
				self.buttonElement.removeClass( focusClass );
			});

		if ( toggleButton ) {
			this.element.bind( "change.button", function() {
				if ( clickDragged ) {
					return;
				}
				self.refresh();
			});
			// if mouse moves between mousedown and mouseup (drag) set clickDragged flag
			// prevents issue where button state changes but checkbox/radio checked state
			// does not in Firefox (see ticket #6970)
			this.buttonElement
				.bind( "mousedown.button", function( event ) {
					if ( options.disabled ) {
						return;
					}
					clickDragged = false;
					startXPos = event.pageX;
					startYPos = event.pageY;
				})
				.bind( "mouseup.button", function( event ) {
					if ( options.disabled ) {
						return;
					}
					if ( startXPos !== event.pageX || startYPos !== event.pageY ) {
						clickDragged = true;
					}
			});
		}

		if ( this.type === "checkbox" ) {
			this.buttonElement.bind( "click.button", function() {
				if ( options.disabled || clickDragged ) {
					return false;
				}
				$( this ).toggleClass( "ui-state-active" );
				self.buttonElement.attr( "aria-pressed", self.element[0].checked );
			});
		} else if ( this.type === "radio" ) {
			this.buttonElement.bind( "click.button", function() {
				if ( options.disabled || clickDragged ) {
					return false;
				}
				$( this ).addClass( "ui-state-active" );
				self.buttonElement.attr( "aria-pressed", "true" );

				var radio = self.element[ 0 ];
				radioGroup( radio )
					.not( radio )
					.map(function() {
						return $( this ).button( "widget" )[ 0 ];
					})
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			});
		} else {
			this.buttonElement
				.bind( "mousedown.button", function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					lastActive = this;
					$( document ).one( "mouseup", function() {
						lastActive = null;
					});
				})
				.bind( "mouseup.button", function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).removeClass( "ui-state-active" );
				})
				.bind( "keydown.button", function(event) {
					if ( options.disabled ) {
						return false;
					}
					if ( event.keyCode == $.ui.keyCode.SPACE || event.keyCode == $.ui.keyCode.ENTER ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				.bind( "keyup.button", function() {
					$( this ).removeClass( "ui-state-active" );
				});

			if ( this.buttonElement.is("a") ) {
				this.buttonElement.keyup(function(event) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						// TODO pass through original event correctly (just as 2nd argument doesn't work)
						$( this ).click();
					}
				});
			}
		}

		// TODO: pull out $.Widget's handling for the disabled option into
		// $.Widget.prototype._setOptionDisabled so it's easy to proxy and can
		// be overridden by individual plugins
		this._setOption( "disabled", options.disabled );
		this._resetButton();
	},

	_determineButtonType: function() {

		if ( this.element.is(":checkbox") ) {
			this.type = "checkbox";
		} else if ( this.element.is(":radio") ) {
			this.type = "radio";
		} else if ( this.element.is("input") ) {
			this.type = "input";
		} else {
			this.type = "button";
		}

		if ( this.type === "checkbox" || this.type === "radio" ) {
			// we don't search against the document in case the element
			// is disconnected from the DOM
			var ancestor = this.element.parents().filter(":last"),
				labelSelector = "label[for='" + this.element.attr("id") + "']";
			this.buttonElement = ancestor.find( labelSelector );
			if ( !this.buttonElement.length ) {
				ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
				this.buttonElement = ancestor.filter( labelSelector );
				if ( !this.buttonElement.length ) {
					this.buttonElement = ancestor.find( labelSelector );
				}
			}
			this.element.addClass( "ui-helper-hidden-accessible" );

			var checked = this.element.is( ":checked" );
			if ( checked ) {
				this.buttonElement.addClass( "ui-state-active" );
			}
			this.buttonElement.attr( "aria-pressed", checked );
		} else {
			this.buttonElement = this.element;
		}
	},

	widget: function() {
		return this.buttonElement;
	},

	destroy: function() {
		this.element
			.removeClass( "ui-helper-hidden-accessible" );
		this.buttonElement
			.removeClass( baseClasses + " " + stateClasses + " " + typeClasses )
			.removeAttr( "role" )
			.removeAttr( "aria-pressed" )
			.html( this.buttonElement.find(".ui-button-text").html() );

		if ( !this.hasTitle ) {
			this.buttonElement.removeAttr( "title" );
		}

		$.Widget.prototype.destroy.call( this );
	},

	_setOption: function( key, value ) {
		$.Widget.prototype._setOption.apply( this, arguments );
		if ( key === "disabled" ) {
			if ( value ) {
				this.element.propAttr( "disabled", true );
			} else {
				this.element.propAttr( "disabled", false );
			}
			return;
		}
		this._resetButton();
	},

	refresh: function() {
		var isDisabled = this.element.is( ":disabled" );
		if ( isDisabled !== this.options.disabled ) {
			this._setOption( "disabled", isDisabled );
		}
		if ( this.type === "radio" ) {
			radioGroup( this.element[0] ).each(function() {
				if ( $( this ).is( ":checked" ) ) {
					$( this ).button( "widget" )
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					$( this ).button( "widget" )
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			});
		} else if ( this.type === "checkbox" ) {
			if ( this.element.is( ":checked" ) ) {
				this.buttonElement
					.addClass( "ui-state-active" )
					.attr( "aria-pressed", "true" );
			} else {
				this.buttonElement
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			}
		}
	},

	_resetButton: function() {
		if ( this.type === "input" ) {
			if ( this.options.label ) {
				this.element.val( this.options.label );
			}
			return;
		}
		var buttonElement = this.buttonElement.removeClass( typeClasses ),
			buttonText = $( "<span></span>", this.element[0].ownerDocument )
				.addClass( "ui-button-text" )
				.html( this.options.label )
				.appendTo( buttonElement.empty() )
				.text(),
			icons = this.options.icons,
			multipleIcons = icons.primary && icons.secondary,
			buttonClasses = [];  

		if ( icons.primary || icons.secondary ) {
			if ( this.options.text ) {
				buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
			}

			if ( icons.primary ) {
				buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
			}

			if ( icons.secondary ) {
				buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
			}

			if ( !this.options.text ) {
				buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

				if ( !this.hasTitle ) {
					buttonElement.attr( "title", buttonText );
				}
			}
		} else {
			buttonClasses.push( "ui-button-text-only" );
		}
		buttonElement.addClass( buttonClasses.join( " " ) );
	}
});

$.widget( "ui.buttonset", {
	options: {
		items: ":button, :submit, :reset, :checkbox, :radio, a, :data(button)"
	},

	_create: function() {
		this.element.addClass( "ui-buttonset" );
	},
	
	_init: function() {
		this.refresh();
	},

	_setOption: function( key, value ) {
		if ( key === "disabled" ) {
			this.buttons.button( "option", key, value );
		}

		$.Widget.prototype._setOption.apply( this, arguments );
	},
	
	refresh: function() {
		var rtl = this.element.css( "direction" ) === "rtl";
		
		this.buttons = this.element.find( this.options.items )
			.filter( ":ui-button" )
				.button( "refresh" )
			.end()
			.not( ":ui-button" )
				.button()
			.end()
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
				.filter( ":first" )
					.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
				.end()
				.filter( ":last" )
					.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
				.end()
			.end();
	},

	destroy: function() {
		this.element.removeClass( "ui-buttonset" );
		this.buttons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-left ui-corner-right" )
			.end()
			.button( "destroy" );

		$.Widget.prototype.destroy.call( this );
	}
});

}( jQuery ) );
/*
 * jQuery UI Datepicker 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Datepicker
 *
 * Depends:
 *	jquery.ui.core.js
 */
(function( $, undefined ) {

$.extend($.ui, { datepicker: { version: "1.8.18" } });

var PROP_NAME = 'datepicker';
var dpuuid = new Date().getTime();
var instActive;

/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this.debug = false; // Change this to true to start debugging
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = 'ui-datepicker-div'; // The ID of the main datepicker division
	this._inlineClass = 'ui-datepicker-inline'; // The name of the inline marker class
	this._appendClass = 'ui-datepicker-append'; // The name of the append marker class
	this._triggerClass = 'ui-datepicker-trigger'; // The name of the trigger marker class
	this._dialogClass = 'ui-datepicker-dialog'; // The name of the dialog marker class
	this._disableClass = 'ui-datepicker-disabled'; // The name of the disabled covering marker class
	this._unselectableClass = 'ui-datepicker-unselectable'; // The name of the unselectable cell marker class
	this._currentClass = 'ui-datepicker-current-day'; // The name of the current day marker class
	this._dayOverClass = 'ui-datepicker-days-cell-over'; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[''] = { // Default regional settings
		closeText: 'Done', // Display text for close link
		prevText: 'Prev', // Display text for previous month link
		nextText: 'Next', // Display text for next month link
		currentText: 'Today', // Display text for current month link
		monthNames: ['January','February','March','April','May','June',
			'July','August','September','October','November','December'], // Names of months for drop-down and formatting
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], // For formatting
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], // For formatting
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // For formatting
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'], // Column headings for days starting at Sunday
		weekHeader: 'Wk', // Column header for week of the year
		dateFormat: 'mm/dd/yy', // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: '' // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: 'focus', // 'focus' for popup on focus,
			// 'button' for trigger button, or 'both' for either
		showAnim: 'fadeIn', // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: '', // Display text following the input box, e.g. showing the format
		buttonText: '...', // Text for trigger button
		buttonImage: '', // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: 'c-10:c+10', // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: '+10', // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with '+' for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: 'fast', // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or '',
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: '', // Selector for an alternate field to store selected dates into
		altFormat: '', // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend(this._defaults, this.regional['']);
	this.dpDiv = bindHover($('<div id="' + this._mainDivId + '" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>'));
}

$.extend(Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: 'hasDatepicker',
	
	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	/* Debug logging (if enabled). */
	log: function () {
		if (this.debug)
			console.log.apply('', arguments);
	},
	
	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	   @param  settings  object - the new settings to use as defaults (anonymous object)
	   @return the manager object */
	setDefaults: function(settings) {
		extendRemove(this._defaults, settings || {});
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	   @param  target    element - the target input field or division or span
	   @param  settings  object - the new settings to use for this date picker instance (anonymous) */
	_attachDatepicker: function(target, settings) {
		// check for settings on the control itself - in namespace 'date:'
		var inlineSettings = null;
		for (var attrName in this._defaults) {
			var attrValue = target.getAttribute('date:' + attrName);
			if (attrValue) {
				inlineSettings = inlineSettings || {};
				try {
					inlineSettings[attrName] = eval(attrValue);
				} catch (err) {
					inlineSettings[attrName] = attrValue;
				}
			}
		}
		var nodeName = target.nodeName.toLowerCase();
		var inline = (nodeName == 'div' || nodeName == 'span');
		if (!target.id) {
			this.uuid += 1;
			target.id = 'dp' + this.uuid;
		}
		var inst = this._newInst($(target), inline);
		inst.settings = $.extend({}, settings || {}, inlineSettings || {});
		if (nodeName == 'input') {
			this._connectDatepicker(target, inst);
		} else if (inline) {
			this._inlineDatepicker(target, inst);
		}
	},

	/* Create a new instance object. */
	_newInst: function(target, inline) {
		var id = target[0].id.replace(/([^A-Za-z0-9_-])/g, '\\\\$1'); // escape jQuery meta chars
		return {id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: (!inline ? this.dpDiv : // presentation div
			bindHover($('<div class="' + this._inlineClass + ' ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>')))};
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function(target, inst) {
		var input = $(target);
		inst.append = $([]);
		inst.trigger = $([]);
		if (input.hasClass(this.markerClassName))
			return;
		this._attachments(input, inst);
		input.addClass(this.markerClassName).keydown(this._doKeyDown).
			keypress(this._doKeyPress).keyup(this._doKeyUp).
			bind("setData.datepicker", function(event, key, value) {
				inst.settings[key] = value;
			}).bind("getData.datepicker", function(event, key) {
				return this._get(inst, key);
			});
		this._autoSize(inst);
		$.data(target, PROP_NAME, inst);
		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function(input, inst) {
		var appendText = this._get(inst, 'appendText');
		var isRTL = this._get(inst, 'isRTL');
		if (inst.append)
			inst.append.remove();
		if (appendText) {
			inst.append = $('<span class="' + this._appendClass + '">' + appendText + '</span>');
			input[isRTL ? 'before' : 'after'](inst.append);
		}
		input.unbind('focus', this._showDatepicker);
		if (inst.trigger)
			inst.trigger.remove();
		var showOn = this._get(inst, 'showOn');
		if (showOn == 'focus' || showOn == 'both') // pop-up date picker when in the marked field
			input.focus(this._showDatepicker);
		if (showOn == 'button' || showOn == 'both') { // pop-up date picker when button clicked
			var buttonText = this._get(inst, 'buttonText');
			var buttonImage = this._get(inst, 'buttonImage');
			inst.trigger = $(this._get(inst, 'buttonImageOnly') ?
				$('<img/>').addClass(this._triggerClass).
					attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
				$('<button type="button"></button>').addClass(this._triggerClass).
					html(buttonImage == '' ? buttonText : $('<img/>').attr(
					{ src:buttonImage, alt:buttonText, title:buttonText })));
			input[isRTL ? 'before' : 'after'](inst.trigger);
			inst.trigger.click(function() {
				if ($.datepicker._datepickerShowing && $.datepicker._lastInput == input[0])
					$.datepicker._hideDatepicker();
				else if ($.datepicker._datepickerShowing && $.datepicker._lastInput != input[0]) {
					$.datepicker._hideDatepicker(); 
					$.datepicker._showDatepicker(input[0]);
				} else
					$.datepicker._showDatepicker(input[0]);
				return false;
			});
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function(inst) {
		if (this._get(inst, 'autoSize') && !inst.inline) {
			var date = new Date(2009, 12 - 1, 20); // Ensure double digits
			var dateFormat = this._get(inst, 'dateFormat');
			if (dateFormat.match(/[DM]/)) {
				var findMax = function(names) {
					var max = 0;
					var maxI = 0;
					for (var i = 0; i < names.length; i++) {
						if (names[i].length > max) {
							max = names[i].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
					'monthNames' : 'monthNamesShort'))));
				date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
					'dayNames' : 'dayNamesShort'))) + 20 - date.getDay());
			}
			inst.input.attr('size', this._formatDate(inst, date).length);
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function(target, inst) {
		var divSpan = $(target);
		if (divSpan.hasClass(this.markerClassName))
			return;
		divSpan.addClass(this.markerClassName).append(inst.dpDiv).
			bind("setData.datepicker", function(event, key, value){
				inst.settings[key] = value;
			}).bind("getData.datepicker", function(event, key){
				return this._get(inst, key);
			});
		$.data(target, PROP_NAME, inst);
		this._setDate(inst, this._getDefaultDate(inst), true);
		this._updateDatepicker(inst);
		this._updateAlternate(inst);
		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	   @param  input     element - ignored
	   @param  date      string or Date - the initial date to display
	   @param  onSelect  function - the function to call when a date is selected
	   @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	   @param  pos       int[2] - coordinates for the dialog's position within the screen or
	                     event - with x/y coordinates or
	                     leave empty for default (screen centre)
	   @return the manager object */
	_dialogDatepicker: function(input, date, onSelect, settings, pos) {
		var inst = this._dialogInst; // internal instance
		if (!inst) {
			this.uuid += 1;
			var id = 'dp' + this.uuid;
			this._dialogInput = $('<input type="text" id="' + id +
				'" style="position: absolute; top: -100px; width: 0px; z-index: -10;"/>');
			this._dialogInput.keydown(this._doKeyDown);
			$('body').append(this._dialogInput);
			inst = this._dialogInst = this._newInst(this._dialogInput, false);
			inst.settings = {};
			$.data(this._dialogInput[0], PROP_NAME, inst);
		}
		extendRemove(inst.settings, settings || {});
		date = (date && date.constructor == Date ? this._formatDate(inst, date) : date);
		this._dialogInput.val(date);

		this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
		if (!this._pos) {
			var browserWidth = document.documentElement.clientWidth;
			var browserHeight = document.documentElement.clientHeight;
			var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
		}

		// move input on screen for focus, but hidden behind dialog
		this._dialogInput.css('left', (this._pos[0] + 20) + 'px').css('top', this._pos[1] + 'px');
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass(this._dialogClass);
		this._showDatepicker(this._dialogInput[0]);
		if ($.blockUI)
			$.blockUI(this.dpDiv);
		$.data(this._dialogInput[0], PROP_NAME, inst);
		return this;
	},

	/* Detach a datepicker from its control.
	   @param  target    element - the target input field or division or span */
	_destroyDatepicker: function(target) {
		var $target = $(target);
		var inst = $.data(target, PROP_NAME);
		if (!$target.hasClass(this.markerClassName)) {
			return;
		}
		var nodeName = target.nodeName.toLowerCase();
		$.removeData(target, PROP_NAME);
		if (nodeName == 'input') {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass(this.markerClassName).
				unbind('focus', this._showDatepicker).
				unbind('keydown', this._doKeyDown).
				unbind('keypress', this._doKeyPress).
				unbind('keyup', this._doKeyUp);
		} else if (nodeName == 'div' || nodeName == 'span')
			$target.removeClass(this.markerClassName).empty();
	},

	/* Enable the date picker to a jQuery selection.
	   @param  target    element - the target input field or division or span */
	_enableDatepicker: function(target) {
		var $target = $(target);
		var inst = $.data(target, PROP_NAME);
		if (!$target.hasClass(this.markerClassName)) {
			return;
		}
		var nodeName = target.nodeName.toLowerCase();
		if (nodeName == 'input') {
			target.disabled = false;
			inst.trigger.filter('button').
				each(function() { this.disabled = false; }).end().
				filter('img').css({opacity: '1.0', cursor: ''});
		}
		else if (nodeName == 'div' || nodeName == 'span') {
			var inline = $target.children('.' + this._inlineClass);
			inline.children().removeClass('ui-state-disabled');
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				removeAttr("disabled");
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value == target ? null : value); }); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	   @param  target    element - the target input field or division or span */
	_disableDatepicker: function(target) {
		var $target = $(target);
		var inst = $.data(target, PROP_NAME);
		if (!$target.hasClass(this.markerClassName)) {
			return;
		}
		var nodeName = target.nodeName.toLowerCase();
		if (nodeName == 'input') {
			target.disabled = true;
			inst.trigger.filter('button').
				each(function() { this.disabled = true; }).end().
				filter('img').css({opacity: '0.5', cursor: 'default'});
		}
		else if (nodeName == 'div' || nodeName == 'span') {
			var inline = $target.children('.' + this._inlineClass);
			inline.children().addClass('ui-state-disabled');
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				attr("disabled", "disabled");
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value == target ? null : value); }); // delete entry
		this._disabledInputs[this._disabledInputs.length] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	   @param  target    element - the target input field or division or span
	   @return boolean - true if disabled, false if enabled */
	_isDisabledDatepicker: function(target) {
		if (!target) {
			return false;
		}
		for (var i = 0; i < this._disabledInputs.length; i++) {
			if (this._disabledInputs[i] == target)
				return true;
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	   @param  target  element - the target input field or division or span
	   @return  object - the associated instance data
	   @throws  error if a jQuery problem getting data */
	_getInst: function(target) {
		try {
			return $.data(target, PROP_NAME);
		}
		catch (err) {
			throw 'Missing instance data for this datepicker';
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	   @param  target  element - the target input field or division or span
	   @param  name    object - the new settings to update or
	                   string - the name of the setting to change or retrieve,
	                   when retrieving also 'all' for all instance settings or
	                   'defaults' for all global defaults
	   @param  value   any - the new value for the setting
	                   (omit if above is an object or to retrieve a value) */
	_optionDatepicker: function(target, name, value) {
		var inst = this._getInst(target);
		if (arguments.length == 2 && typeof name == 'string') {
			return (name == 'defaults' ? $.extend({}, $.datepicker._defaults) :
				(inst ? (name == 'all' ? $.extend({}, inst.settings) :
				this._get(inst, name)) : null));
		}
		var settings = name || {};
		if (typeof name == 'string') {
			settings = {};
			settings[name] = value;
		}
		if (inst) {
			if (this._curInst == inst) {
				this._hideDatepicker();
			}
			var date = this._getDateDatepicker(target, true);
			var minDate = this._getMinMaxDate(inst, 'min');
			var maxDate = this._getMinMaxDate(inst, 'max');
			extendRemove(inst.settings, settings);
			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if (minDate !== null && settings['dateFormat'] !== undefined && settings['minDate'] === undefined)
				inst.settings.minDate = this._formatDate(inst, minDate);
			if (maxDate !== null && settings['dateFormat'] !== undefined && settings['maxDate'] === undefined)
				inst.settings.maxDate = this._formatDate(inst, maxDate);
			this._attachments($(target), inst);
			this._autoSize(inst);
			this._setDate(inst, date);
			this._updateAlternate(inst);
			this._updateDatepicker(inst);
		}
	},

	// change method deprecated
	_changeDatepicker: function(target, name, value) {
		this._optionDatepicker(target, name, value);
	},

	/* Redraw the date picker attached to an input field or division.
	   @param  target  element - the target input field or division or span */
	_refreshDatepicker: function(target) {
		var inst = this._getInst(target);
		if (inst) {
			this._updateDatepicker(inst);
		}
	},

	/* Set the dates for a jQuery selection.
	   @param  target   element - the target input field or division or span
	   @param  date     Date - the new date */
	_setDateDatepicker: function(target, date) {
		var inst = this._getInst(target);
		if (inst) {
			this._setDate(inst, date);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	   @param  target     element - the target input field or division or span
	   @param  noDefault  boolean - true if no default date is to be used
	   @return Date - the current date */
	_getDateDatepicker: function(target, noDefault) {
		var inst = this._getInst(target);
		if (inst && !inst.inline)
			this._setDateFromField(inst, noDefault);
		return (inst ? this._getDate(inst) : null);
	},

	/* Handle keystrokes. */
	_doKeyDown: function(event) {
		var inst = $.datepicker._getInst(event.target);
		var handled = true;
		var isRTL = inst.dpDiv.is('.ui-datepicker-rtl');
		inst._keyEvent = true;
		if ($.datepicker._datepickerShowing)
			switch (event.keyCode) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: var sel = $('td.' + $.datepicker._dayOverClass + ':not(.' + 
									$.datepicker._currentClass + ')', inst.dpDiv);
						if (sel[0])
							$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
							var onSelect = $.datepicker._get(inst, 'onSelect');
							if (onSelect) {
								var dateStr = $.datepicker._formatDate(inst);

								// trigger custom callback
								onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
							}
						else
							$.datepicker._hideDatepicker();
						return false; // don't submit the form
						break; // select the value on enter
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							-$.datepicker._get(inst, 'stepBigMonths') :
							-$.datepicker._get(inst, 'stepMonths')), 'M');
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							+$.datepicker._get(inst, 'stepBigMonths') :
							+$.datepicker._get(inst, 'stepMonths')), 'M');
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) $.datepicker._clearDate(event.target);
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if (event.ctrlKey || event.metaKey) $.datepicker._gotoToday(event.target);
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), 'D');
						handled = event.ctrlKey || event.metaKey;
						// -1 day on ctrl or command +left
						if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, (event.ctrlKey ?
									-$.datepicker._get(inst, 'stepBigMonths') :
									-$.datepicker._get(inst, 'stepMonths')), 'M');
						// next month/year on alt +left on Mac
						break;
				case 38: if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, -7, 'D');
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), 'D');
						handled = event.ctrlKey || event.metaKey;
						// +1 day on ctrl or command +right
						if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, (event.ctrlKey ?
									+$.datepicker._get(inst, 'stepBigMonths') :
									+$.datepicker._get(inst, 'stepMonths')), 'M');
						// next month/year on alt +right
						break;
				case 40: if (event.ctrlKey || event.metaKey) $.datepicker._adjustDate(event.target, +7, 'D');
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		else if (event.keyCode == 36 && event.ctrlKey) // display the date picker on ctrl+home
			$.datepicker._showDatepicker(this);
		else {
			handled = false;
		}
		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function(event) {
		var inst = $.datepicker._getInst(event.target);
		if ($.datepicker._get(inst, 'constrainInput')) {
			var chars = $.datepicker._possibleChars($.datepicker._get(inst, 'dateFormat'));
			var chr = String.fromCharCode(event.charCode == undefined ? event.keyCode : event.charCode);
			return event.ctrlKey || event.metaKey || (chr < ' ' || !chars || chars.indexOf(chr) > -1);
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function(event) {
		var inst = $.datepicker._getInst(event.target);
		if (inst.input.val() != inst.lastVal) {
			try {
				var date = $.datepicker.parseDate($.datepicker._get(inst, 'dateFormat'),
					(inst.input ? inst.input.val() : null),
					$.datepicker._getFormatConfig(inst));
				if (date) { // only if valid
					$.datepicker._setDateFromField(inst);
					$.datepicker._updateAlternate(inst);
					$.datepicker._updateDatepicker(inst);
				}
			}
			catch (event) {
				$.datepicker.log(event);
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
       If false returned from beforeShow event handler do not show. 
	   @param  input  element - the input field attached to the date picker or
	                  event - if triggered by focus */
	_showDatepicker: function(input) {
		input = input.target || input;
		if (input.nodeName.toLowerCase() != 'input') // find from button/image trigger
			input = $('input', input.parentNode)[0];
		if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput == input) // already here
			return;
		var inst = $.datepicker._getInst(input);
		if ($.datepicker._curInst && $.datepicker._curInst != inst) {
			$.datepicker._curInst.dpDiv.stop(true, true);
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
			}
		}
		var beforeShow = $.datepicker._get(inst, 'beforeShow');
		var beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
		if(beforeShowSettings === false){
            //false
			return;
		}
		extendRemove(inst.settings, beforeShowSettings);
		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField(inst);
		if ($.datepicker._inDialog) // hide cursor
			input.value = '';
		if (!$.datepicker._pos) { // position below input
			$.datepicker._pos = $.datepicker._findPos(input);
			$.datepicker._pos[1] += input.offsetHeight; // add the height
		}
		var isFixed = false;
		$(input).parents().each(function() {
			isFixed |= $(this).css('position') == 'fixed';
			return !isFixed;
		});
		if (isFixed && $.browser.opera) { // correction for Opera when fixed and scrolled
			$.datepicker._pos[0] -= document.documentElement.scrollLeft;
			$.datepicker._pos[1] -= document.documentElement.scrollTop;
		}
		var offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
		$.datepicker._pos = null;
		//to avoid flashes on Firefox
		inst.dpDiv.empty();
		// determine sizing offscreen
		inst.dpDiv.css({position: 'absolute', display: 'block', top: '-1000px'});
		$.datepicker._updateDatepicker(inst);
		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset(inst, offset, isFixed);
		inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
			'static' : (isFixed ? 'fixed' : 'absolute')), display: 'none',
			left: offset.left + 'px', top: offset.top + 'px'});
		if (!inst.inline) {
			var showAnim = $.datepicker._get(inst, 'showAnim');
			var duration = $.datepicker._get(inst, 'duration');
			var postProcess = function() {
				var cover = inst.dpDiv.find('iframe.ui-datepicker-cover'); // IE6- only
				if( !! cover.length ){
					var borders = $.datepicker._getBorders(inst.dpDiv);
					cover.css({left: -borders[0], top: -borders[1],
						width: inst.dpDiv.outerWidth(), height: inst.dpDiv.outerHeight()});
				}
			};
			inst.dpDiv.zIndex($(input).zIndex()+1);
			$.datepicker._datepickerShowing = true;
			if ($.effects && $.effects[showAnim])
				inst.dpDiv.show(showAnim, $.datepicker._get(inst, 'showOptions'), duration, postProcess);
			else
				inst.dpDiv[showAnim || 'show']((showAnim ? duration : null), postProcess);
			if (!showAnim || !duration)
				postProcess();
			if (inst.input.is(':visible') && !inst.input.is(':disabled'))
				inst.input.focus();
			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function(inst) {
		var self = this;
		self.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		var borders = $.datepicker._getBorders(inst.dpDiv);
		instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append(this._generateHTML(inst));
		var cover = inst.dpDiv.find('iframe.ui-datepicker-cover'); // IE6- only
		if( !!cover.length ){ //avoid call to outerXXXX() when not in IE6
			cover.css({left: -borders[0], top: -borders[1], width: inst.dpDiv.outerWidth(), height: inst.dpDiv.outerHeight()})
		}
		inst.dpDiv.find('.' + this._dayOverClass + ' a').mouseover();
		var numMonths = this._getNumberOfMonths(inst);
		var cols = numMonths[1];
		var width = 17;
		inst.dpDiv.removeClass('ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4').width('');
		if (cols > 1)
			inst.dpDiv.addClass('ui-datepicker-multi-' + cols).css('width', (width * cols) + 'em');
		inst.dpDiv[(numMonths[0] != 1 || numMonths[1] != 1 ? 'add' : 'remove') +
			'Class']('ui-datepicker-multi');
		inst.dpDiv[(this._get(inst, 'isRTL') ? 'add' : 'remove') +
			'Class']('ui-datepicker-rtl');
		if (inst == $.datepicker._curInst && $.datepicker._datepickerShowing && inst.input &&
				// #6694 - don't focus the input if it's already focused
				// this breaks the change event in IE
				inst.input.is(':visible') && !inst.input.is(':disabled') && inst.input[0] != document.activeElement)
			inst.input.focus();
		// deffered render of the years select (to avoid flashes on Firefox) 
		if( inst.yearshtml ){
			var origyearshtml = inst.yearshtml;
			setTimeout(function(){
				//assure that inst.yearshtml didn't change.
				if( origyearshtml === inst.yearshtml && inst.yearshtml ){
					inst.dpDiv.find('select.ui-datepicker-year:first').replaceWith(inst.yearshtml);
				}
				origyearshtml = inst.yearshtml = null;
			}, 0);
		}
	},

	/* Retrieve the size of left and top borders for an element.
	   @param  elem  (jQuery object) the element of interest
	   @return  (number[2]) the left and top borders */
	_getBorders: function(elem) {
		var convert = function(value) {
			return {thin: 1, medium: 2, thick: 3}[value] || value;
		};
		return [parseFloat(convert(elem.css('border-left-width'))),
			parseFloat(convert(elem.css('border-top-width')))];
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function(inst, offset, isFixed) {
		var dpWidth = inst.dpDiv.outerWidth();
		var dpHeight = inst.dpDiv.outerHeight();
		var inputWidth = inst.input ? inst.input.outerWidth() : 0;
		var inputHeight = inst.input ? inst.input.outerHeight() : 0;
		var viewWidth = document.documentElement.clientWidth + $(document).scrollLeft();
		var viewHeight = document.documentElement.clientHeight + $(document).scrollTop();

		offset.left -= (this._get(inst, 'isRTL') ? (dpWidth - inputWidth) : 0);
		offset.left -= (isFixed && offset.left == inst.input.offset().left) ? $(document).scrollLeft() : 0;
		offset.top -= (isFixed && offset.top == (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

		// now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
			Math.abs(offset.left + dpWidth - viewWidth) : 0);
		offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
			Math.abs(dpHeight + inputHeight) : 0);

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function(obj) {
		var inst = this._getInst(obj);
		var isRTL = this._get(inst, 'isRTL');
        while (obj && (obj.type == 'hidden' || obj.nodeType != 1 || $.expr.filters.hidden(obj))) {
            obj = obj[isRTL ? 'previousSibling' : 'nextSibling'];
        }
        var position = $(obj).offset();
	    return [position.left, position.top];
	},

	/* Hide the date picker from view.
	   @param  input  element - the input field attached to the date picker */
	_hideDatepicker: function(input) {
		var inst = this._curInst;
		if (!inst || (input && inst != $.data(input, PROP_NAME)))
			return;
		if (this._datepickerShowing) {
			var showAnim = this._get(inst, 'showAnim');
			var duration = this._get(inst, 'duration');
			var self = this;
			var postProcess = function() {
				$.datepicker._tidyDialog(inst);
				self._curInst = null;
			};
			if ($.effects && $.effects[showAnim])
				inst.dpDiv.hide(showAnim, $.datepicker._get(inst, 'showOptions'), duration, postProcess);
			else
				inst.dpDiv[(showAnim == 'slideDown' ? 'slideUp' :
					(showAnim == 'fadeIn' ? 'fadeOut' : 'hide'))]((showAnim ? duration : null), postProcess);
			if (!showAnim)
				postProcess();
			this._datepickerShowing = false;
			var onClose = this._get(inst, 'onClose');
			if (onClose)
				onClose.apply((inst.input ? inst.input[0] : null),
					[(inst.input ? inst.input.val() : ''), inst]);
			this._lastInput = null;
			if (this._inDialog) {
				this._dialogInput.css({ position: 'absolute', left: '0', top: '-100px' });
				if ($.blockUI) {
					$.unblockUI();
					$('body').append(this.dpDiv);
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function(inst) {
		inst.dpDiv.removeClass(this._dialogClass).unbind('.ui-datepicker-calendar');
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function(event) {
		if (!$.datepicker._curInst)
			return;

		var $target = $(event.target),
			inst = $.datepicker._getInst($target[0]);

		if ( ( ( $target[0].id != $.datepicker._mainDivId &&
				$target.parents('#' + $.datepicker._mainDivId).length == 0 &&
				!$target.hasClass($.datepicker.markerClassName) &&
				!$target.closest("." + $.datepicker._triggerClass).length &&
				$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
			( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst != inst ) )
			$.datepicker._hideDatepicker();
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function(id, offset, period) {
		var target = $(id);
		var inst = this._getInst(target[0]);
		if (this._isDisabledDatepicker(target[0])) {
			return;
		}
		this._adjustInstDate(inst, offset +
			(period == 'M' ? this._get(inst, 'showCurrentAtPos') : 0), // undo positioning
			period);
		this._updateDatepicker(inst);
	},

	/* Action for current link. */
	_gotoToday: function(id) {
		var target = $(id);
		var inst = this._getInst(target[0]);
		if (this._get(inst, 'gotoCurrent') && inst.currentDay) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		}
		else {
			var date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function(id, select, period) {
		var target = $(id);
		var inst = this._getInst(target[0]);
		inst['selected' + (period == 'M' ? 'Month' : 'Year')] =
		inst['draw' + (period == 'M' ? 'Month' : 'Year')] =
			parseInt(select.options[select.selectedIndex].value,10);
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a day. */
	_selectDay: function(id, month, year, td) {
		var target = $(id);
		if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
			return;
		}
		var inst = this._getInst(target[0]);
		inst.selectedDay = inst.currentDay = $('a', td).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate(id, this._formatDate(inst,
			inst.currentDay, inst.currentMonth, inst.currentYear));
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function(id) {
		var target = $(id);
		var inst = this._getInst(target[0]);
		this._selectDate(target, '');
	},

	/* Update the input field with the selected date. */
	_selectDate: function(id, dateStr) {
		var target = $(id);
		var inst = this._getInst(target[0]);
		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (inst.input)
			inst.input.val(dateStr);
		this._updateAlternate(inst);
		var onSelect = this._get(inst, 'onSelect');
		if (onSelect)
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		else if (inst.input)
			inst.input.trigger('change'); // fire the change event
		if (inst.inline)
			this._updateDatepicker(inst);
		else {
			this._hideDatepicker();
			this._lastInput = inst.input[0];
			if (typeof(inst.input[0]) != 'object')
				inst.input.focus(); // restore focus
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function(inst) {
		var altField = this._get(inst, 'altField');
		if (altField) { // update alternate field too
			var altFormat = this._get(inst, 'altFormat') || this._get(inst, 'dateFormat');
			var date = this._getDate(inst);
			var dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
			$(altField).each(function() { $(this).val(dateStr); });
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	   @param  date  Date - the date to customise
	   @return [boolean, string] - is this date selectable?, what is its CSS class? */
	noWeekends: function(date) {
		var day = date.getDay();
		return [(day > 0 && day < 6), ''];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	   @param  date  Date - the date to get the week for
	   @return  number - the number of the week within the year that contains this date */
	iso8601Week: function(date) {
		var checkDate = new Date(date.getTime());
		// Find Thursday of this week starting on Monday
		checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
		var time = checkDate.getTime();
		checkDate.setMonth(0); // Compare with Jan 1
		checkDate.setDate(1);
		return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	},

	/* Parse a string value into a date object.
	   See formatDate below for the possible formats.

	   @param  format    string - the expected format of the date
	   @param  value     string - the date in the above format
	   @param  settings  Object - attributes include:
	                     shortYearCutoff  number - the cutoff year for determining the century (optional)
	                     dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
	                     dayNames         string[7] - names of the days from Sunday (optional)
	                     monthNamesShort  string[12] - abbreviated names of the months (optional)
	                     monthNames       string[12] - names of the months (optional)
	   @return  Date - the extracted date value or null if value is blank */
	parseDate: function (format, value, settings) {
		if (format == null || value == null)
			throw 'Invalid arguments';
		value = (typeof value == 'object' ? value.toString() : value + '');
		if (value == '')
			return null;
		var shortYearCutoff = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff;
		shortYearCutoff = (typeof shortYearCutoff != 'string' ? shortYearCutoff :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		var dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort;
		var dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames;
		var monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort;
		var monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames;
		var year = -1;
		var month = -1;
		var day = -1;
		var doy = -1;
		var literal = false;
		// Check whether a format character is doubled
		var lookAhead = function(match) {
			var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) == match);
			if (matches)
				iFormat++;
			return matches;
		};
		// Extract a number from the string value
		var getNumber = function(match) {
			var isDoubled = lookAhead(match);
			var size = (match == '@' ? 14 : (match == '!' ? 20 :
				(match == 'y' && isDoubled ? 4 : (match == 'o' ? 3 : 2))));
			var digits = new RegExp('^\\d{1,' + size + '}');
			var num = value.substring(iValue).match(digits);
			if (!num)
				throw 'Missing number at position ' + iValue;
			iValue += num[0].length;
			return parseInt(num[0], 10);
		};
		// Extract a name from the string value and convert to an index
		var getName = function(match, shortNames, longNames) {
			var names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
				return [ [k, v] ];
			}).sort(function (a, b) {
				return -(a[1].length - b[1].length);
			});
			var index = -1;
			$.each(names, function (i, pair) {
				var name = pair[1];
				if (value.substr(iValue, name.length).toLowerCase() == name.toLowerCase()) {
					index = pair[0];
					iValue += name.length;
					return false;
				}
			});
			if (index != -1)
				return index + 1;
			else
				throw 'Unknown name at position ' + iValue;
		};
		// Confirm that a literal character matches the string value
		var checkLiteral = function() {
			if (value.charAt(iValue) != format.charAt(iFormat))
				throw 'Unexpected literal at position ' + iValue;
			iValue++;
		};
		var iValue = 0;
		for (var iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal)
				if (format.charAt(iFormat) == "'" && !lookAhead("'"))
					literal = false;
				else
					checkLiteral();
			else
				switch (format.charAt(iFormat)) {
					case 'd':
						day = getNumber('d');
						break;
					case 'D':
						getName('D', dayNamesShort, dayNames);
						break;
					case 'o':
						doy = getNumber('o');
						break;
					case 'm':
						month = getNumber('m');
						break;
					case 'M':
						month = getName('M', monthNamesShort, monthNames);
						break;
					case 'y':
						year = getNumber('y');
						break;
					case '@':
						var date = new Date(getNumber('@'));
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case '!':
						var date = new Date((getNumber('!') - this._ticksTo1970) / 10000);
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if (lookAhead("'"))
							checkLiteral();
						else
							literal = true;
						break;
					default:
						checkLiteral();
				}
		}
		if (iValue < value.length){
			throw "Extra/unparsed characters found in date: " + value.substring(iValue);
		}
		if (year == -1)
			year = new Date().getFullYear();
		else if (year < 100)
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				(year <= shortYearCutoff ? 0 : -100);
		if (doy > -1) {
			month = 1;
			day = doy;
			do {
				var dim = this._getDaysInMonth(year, month - 1);
				if (day <= dim)
					break;
				month++;
				day -= dim;
			} while (true);
		}
		var date = this._daylightSavingAdjust(new Date(year, month - 1, day));
		if (date.getFullYear() != year || date.getMonth() + 1 != month || date.getDate() != day)
			throw 'Invalid date'; // E.g. 31/02/00
		return date;
	},

	/* Standard date formats. */
	ATOM: 'yy-mm-dd', // RFC 3339 (ISO 8601)
	COOKIE: 'D, dd M yy',
	ISO_8601: 'yy-mm-dd',
	RFC_822: 'D, d M y',
	RFC_850: 'DD, dd-M-y',
	RFC_1036: 'D, d M y',
	RFC_1123: 'D, d M yy',
	RFC_2822: 'D, d M yy',
	RSS: 'D, d M y', // RFC 822
	TICKS: '!',
	TIMESTAMP: '@',
	W3C: 'yy-mm-dd', // ISO 8601

	_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
		Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

	/* Format a date object into a string value.
	   The format can be combinations of the following:
	   d  - day of month (no leading zero)
	   dd - day of month (two digit)
	   o  - day of year (no leading zeros)
	   oo - day of year (three digit)
	   D  - day name short
	   DD - day name long
	   m  - month of year (no leading zero)
	   mm - month of year (two digit)
	   M  - month name short
	   MM - month name long
	   y  - year (two digit)
	   yy - year (four digit)
	   @ - Unix timestamp (ms since 01/01/1970)
	   ! - Windows ticks (100ns since 01/01/0001)
	   '...' - literal text
	   '' - single quote

	   @param  format    string - the desired format of the date
	   @param  date      Date - the date value to format
	   @param  settings  Object - attributes include:
	                     dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
	                     dayNames         string[7] - names of the days from Sunday (optional)
	                     monthNamesShort  string[12] - abbreviated names of the months (optional)
	                     monthNames       string[12] - names of the months (optional)
	   @return  string - the date in the above format */
	formatDate: function (format, date, settings) {
		if (!date)
			return '';
		var dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort;
		var dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames;
		var monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort;
		var monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames;
		// Check whether a format character is doubled
		var lookAhead = function(match) {
			var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) == match);
			if (matches)
				iFormat++;
			return matches;
		};
		// Format a number, with leading zero if necessary
		var formatNumber = function(match, value, len) {
			var num = '' + value;
			if (lookAhead(match))
				while (num.length < len)
					num = '0' + num;
			return num;
		};
		// Format a name, short or long as requested
		var formatName = function(match, value, shortNames, longNames) {
			return (lookAhead(match) ? longNames[value] : shortNames[value]);
		};
		var output = '';
		var literal = false;
		if (date)
			for (var iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal)
					if (format.charAt(iFormat) == "'" && !lookAhead("'"))
						literal = false;
					else
						output += format.charAt(iFormat);
				else
					switch (format.charAt(iFormat)) {
						case 'd':
							output += formatNumber('d', date.getDate(), 2);
							break;
						case 'D':
							output += formatName('D', date.getDay(), dayNamesShort, dayNames);
							break;
						case 'o':
							output += formatNumber('o',
								Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
							break;
						case 'm':
							output += formatNumber('m', date.getMonth() + 1, 2);
							break;
						case 'M':
							output += formatName('M', date.getMonth(), monthNamesShort, monthNames);
							break;
						case 'y':
							output += (lookAhead('y') ? date.getFullYear() :
								(date.getYear() % 100 < 10 ? '0' : '') + date.getYear() % 100);
							break;
						case '@':
							output += date.getTime();
							break;
						case '!':
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if (lookAhead("'"))
								output += "'";
							else
								literal = true;
							break;
						default:
							output += format.charAt(iFormat);
					}
			}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function (format) {
		var chars = '';
		var literal = false;
		// Check whether a format character is doubled
		var lookAhead = function(match) {
			var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) == match);
			if (matches)
				iFormat++;
			return matches;
		};
		for (var iFormat = 0; iFormat < format.length; iFormat++)
			if (literal)
				if (format.charAt(iFormat) == "'" && !lookAhead("'"))
					literal = false;
				else
					chars += format.charAt(iFormat);
			else
				switch (format.charAt(iFormat)) {
					case 'd': case 'm': case 'y': case '@':
						chars += '0123456789';
						break;
					case 'D': case 'M':
						return null; // Accept anything
					case "'":
						if (lookAhead("'"))
							chars += "'";
						else
							literal = true;
						break;
					default:
						chars += format.charAt(iFormat);
				}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function(inst, name) {
		return inst.settings[name] !== undefined ?
			inst.settings[name] : this._defaults[name];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function(inst, noDefault) {
		if (inst.input.val() == inst.lastVal) {
			return;
		}
		var dateFormat = this._get(inst, 'dateFormat');
		var dates = inst.lastVal = inst.input ? inst.input.val() : null;
		var date, defaultDate;
		date = defaultDate = this._getDefaultDate(inst);
		var settings = this._getFormatConfig(inst);
		try {
			date = this.parseDate(dateFormat, dates, settings) || defaultDate;
		} catch (event) {
			this.log(event);
			dates = (noDefault ? '' : dates);
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = (dates ? date.getDate() : 0);
		inst.currentMonth = (dates ? date.getMonth() : 0);
		inst.currentYear = (dates ? date.getFullYear() : 0);
		this._adjustInstDate(inst);
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function(inst) {
		return this._restrictMinMax(inst,
			this._determineDate(inst, this._get(inst, 'defaultDate'), new Date()));
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function(inst, date, defaultDate) {
		var offsetNumeric = function(offset) {
			var date = new Date();
			date.setDate(date.getDate() + offset);
			return date;
		};
		var offsetString = function(offset) {
			try {
				return $.datepicker.parseDate($.datepicker._get(inst, 'dateFormat'),
					offset, $.datepicker._getFormatConfig(inst));
			}
			catch (e) {
				// Ignore
			}
			var date = (offset.toLowerCase().match(/^c/) ?
				$.datepicker._getDate(inst) : null) || new Date();
			var year = date.getFullYear();
			var month = date.getMonth();
			var day = date.getDate();
			var pattern = /([+-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g;
			var matches = pattern.exec(offset);
			while (matches) {
				switch (matches[2] || 'd') {
					case 'd' : case 'D' :
						day += parseInt(matches[1],10); break;
					case 'w' : case 'W' :
						day += parseInt(matches[1],10) * 7; break;
					case 'm' : case 'M' :
						month += parseInt(matches[1],10);
						day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
						break;
					case 'y': case 'Y' :
						year += parseInt(matches[1],10);
						day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
						break;
				}
				matches = pattern.exec(offset);
			}
			return new Date(year, month, day);
		};
		var newDate = (date == null || date === '' ? defaultDate : (typeof date == 'string' ? offsetString(date) :
			(typeof date == 'number' ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));
		newDate = (newDate && newDate.toString() == 'Invalid Date' ? defaultDate : newDate);
		if (newDate) {
			newDate.setHours(0);
			newDate.setMinutes(0);
			newDate.setSeconds(0);
			newDate.setMilliseconds(0);
		}
		return this._daylightSavingAdjust(newDate);
	},

	/* Handle switch to/from daylight saving.
	   Hours may be non-zero on daylight saving cut-over:
	   > 12 when midnight changeover, but then cannot generate
	   midnight datetime, so jump to 1AM, otherwise reset.
	   @param  date  (Date) the date to check
	   @return  (Date) the corrected date */
	_daylightSavingAdjust: function(date) {
		if (!date) return null;
		date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function(inst, date, noChange) {
		var clear = !date;
		var origMonth = inst.selectedMonth;
		var origYear = inst.selectedYear;
		var newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));
		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ((origMonth != inst.selectedMonth || origYear != inst.selectedYear) && !noChange)
			this._notifyChange(inst);
		this._adjustInstDate(inst);
		if (inst.input) {
			inst.input.val(clear ? '' : this._formatDate(inst));
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function(inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() == '') ? null :
			this._daylightSavingAdjust(new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay)));
			return startDate;
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function(inst) {
		var today = new Date();
		today = this._daylightSavingAdjust(
			new Date(today.getFullYear(), today.getMonth(), today.getDate())); // clear time
		var isRTL = this._get(inst, 'isRTL');
		var showButtonPanel = this._get(inst, 'showButtonPanel');
		var hideIfNoPrevNext = this._get(inst, 'hideIfNoPrevNext');
		var navigationAsDateFormat = this._get(inst, 'navigationAsDateFormat');
		var numMonths = this._getNumberOfMonths(inst);
		var showCurrentAtPos = this._get(inst, 'showCurrentAtPos');
		var stepMonths = this._get(inst, 'stepMonths');
		var isMultiMonth = (numMonths[0] != 1 || numMonths[1] != 1);
		var currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
			new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		var minDate = this._getMinMaxDate(inst, 'min');
		var maxDate = this._getMinMaxDate(inst, 'max');
		var drawMonth = inst.drawMonth - showCurrentAtPos;
		var drawYear = inst.drawYear;
		if (drawMonth < 0) {
			drawMonth += 12;
			drawYear--;
		}
		if (maxDate) {
			var maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
				maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
			maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
			while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
				drawMonth--;
				if (drawMonth < 0) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;
		var prevText = this._get(inst, 'prevText');
		prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
			this._getFormatConfig(inst)));
		var prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
			'<a class="ui-datepicker-prev ui-corner-all" onclick="DP_jQuery_' + dpuuid +
			'.datepicker._adjustDate(\'#' + inst.id + '\', -' + stepMonths + ', \'M\');"' +
			' title="' + prevText + '"><span class="ui-icon ui-icon-circle-triangle-' + ( isRTL ? 'e' : 'w') + '">' + prevText + '</span></a>' :
			(hideIfNoPrevNext ? '' : '<a class="ui-datepicker-prev ui-corner-all ui-state-disabled" title="'+ prevText +'"><span class="ui-icon ui-icon-circle-triangle-' + ( isRTL ? 'e' : 'w') + '">' + prevText + '</span></a>'));
		var nextText = this._get(inst, 'nextText');
		nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
			this._getFormatConfig(inst)));
		var next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
			'<a class="ui-datepicker-next ui-corner-all" onclick="DP_jQuery_' + dpuuid +
			'.datepicker._adjustDate(\'#' + inst.id + '\', +' + stepMonths + ', \'M\');"' +
			' title="' + nextText + '"><span class="ui-icon ui-icon-circle-triangle-' + ( isRTL ? 'w' : 'e') + '">' + nextText + '</span></a>' :
			(hideIfNoPrevNext ? '' : '<a class="ui-datepicker-next ui-corner-all ui-state-disabled" title="'+ nextText + '"><span class="ui-icon ui-icon-circle-triangle-' + ( isRTL ? 'w' : 'e') + '">' + nextText + '</span></a>'));
		var currentText = this._get(inst, 'currentText');
		var gotoDate = (this._get(inst, 'gotoCurrent') && inst.currentDay ? currentDate : today);
		currentText = (!navigationAsDateFormat ? currentText :
			this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));
		var controls = (!inst.inline ? '<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all" onclick="DP_jQuery_' + dpuuid +
			'.datepicker._hideDatepicker();">' + this._get(inst, 'closeText') + '</button>' : '');
		var buttonPanel = (showButtonPanel) ? '<div class="ui-datepicker-buttonpane ui-widget-content">' + (isRTL ? controls : '') +
			(this._isInRange(inst, gotoDate) ? '<button type="button" class="ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all" onclick="DP_jQuery_' + dpuuid +
			'.datepicker._gotoToday(\'#' + inst.id + '\');"' +
			'>' + currentText + '</button>' : '') + (isRTL ? '' : controls) + '</div>' : '';
		var firstDay = parseInt(this._get(inst, 'firstDay'),10);
		firstDay = (isNaN(firstDay) ? 0 : firstDay);
		var showWeek = this._get(inst, 'showWeek');
		var dayNames = this._get(inst, 'dayNames');
		var dayNamesShort = this._get(inst, 'dayNamesShort');
		var dayNamesMin = this._get(inst, 'dayNamesMin');
		var monthNames = this._get(inst, 'monthNames');
		var monthNamesShort = this._get(inst, 'monthNamesShort');
		var beforeShowDay = this._get(inst, 'beforeShowDay');
		var showOtherMonths = this._get(inst, 'showOtherMonths');
		var selectOtherMonths = this._get(inst, 'selectOtherMonths');
		var calculateWeek = this._get(inst, 'calculateWeek') || this.iso8601Week;
		var defaultDate = this._getDefaultDate(inst);
		var html = '';
		for (var row = 0; row < numMonths[0]; row++) {
			var group = '';
			this.maxRows = 4;
			for (var col = 0; col < numMonths[1]; col++) {
				var selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
				var cornerClass = ' ui-corner-all';
				var calender = '';
				if (isMultiMonth) {
					calender += '<div class="ui-datepicker-group';
					if (numMonths[1] > 1)
						switch (col) {
							case 0: calender += ' ui-datepicker-group-first';
								cornerClass = ' ui-corner-' + (isRTL ? 'right' : 'left'); break;
							case numMonths[1]-1: calender += ' ui-datepicker-group-last';
								cornerClass = ' ui-corner-' + (isRTL ? 'left' : 'right'); break;
							default: calender += ' ui-datepicker-group-middle'; cornerClass = ''; break;
						}
					calender += '">';
				}
				calender += '<div class="ui-datepicker-header ui-widget-header ui-helper-clearfix' + cornerClass + '">' +
					(/all|left/.test(cornerClass) && row == 0 ? (isRTL ? next : prev) : '') +
					(/all|right/.test(cornerClass) && row == 0 ? (isRTL ? prev : next) : '') +
					this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
					'</div><table class="ui-datepicker-calendar"><thead>' +
					'<tr>';
				var thead = (showWeek ? '<th class="ui-datepicker-week-col">' + this._get(inst, 'weekHeader') + '</th>' : '');
				for (var dow = 0; dow < 7; dow++) { // days of the week
					var day = (dow + firstDay) % 7;
					thead += '<th' + ((dow + firstDay + 6) % 7 >= 5 ? ' class="ui-datepicker-week-end"' : '') + '>' +
						'<span title="' + dayNames[day] + '">' + dayNamesMin[day] + '</span></th>';
				}
				calender += thead + '</tr></thead><tbody>';
				var daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
				if (drawYear == inst.selectedYear && drawMonth == inst.selectedMonth)
					inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
				var leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
				var curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
				var numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				var printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
				for (var dRow = 0; dRow < numRows; dRow++) { // create date picker rows
					calender += '<tr>';
					var tbody = (!showWeek ? '' : '<td class="ui-datepicker-week-col">' +
						this._get(inst, 'calculateWeek')(printDate) + '</td>');
					for (var dow = 0; dow < 7; dow++) { // create date picker days
						var daySettings = (beforeShowDay ?
							beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, '']);
						var otherMonth = (printDate.getMonth() != drawMonth);
						var unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
							(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
						tbody += '<td class="' +
							((dow + firstDay + 6) % 7 >= 5 ? ' ui-datepicker-week-end' : '') + // highlight weekends
							(otherMonth ? ' ui-datepicker-other-month' : '') + // highlight days from other months
							((printDate.getTime() == selectedDate.getTime() && drawMonth == inst.selectedMonth && inst._keyEvent) || // user pressed key
							(defaultDate.getTime() == printDate.getTime() && defaultDate.getTime() == selectedDate.getTime()) ?
							// or defaultDate is current printedDate and defaultDate is selectedDate
							' ' + this._dayOverClass : '') + // highlight selected day
							(unselectable ? ' ' + this._unselectableClass + ' ui-state-disabled': '') +  // highlight unselectable days
							(otherMonth && !showOtherMonths ? '' : ' ' + daySettings[1] + // highlight custom dates
							(printDate.getTime() == currentDate.getTime() ? ' ' + this._currentClass : '') + // highlight selected day
							(printDate.getTime() == today.getTime() ? ' ui-datepicker-today' : '')) + '"' + // highlight today (if different)
							((!otherMonth || showOtherMonths) && daySettings[2] ? ' title="' + daySettings[2] + '"' : '') + // cell title
							(unselectable ? '' : ' onclick="DP_jQuery_' + dpuuid + '.datepicker._selectDay(\'#' +
							inst.id + '\',' + printDate.getMonth() + ',' + printDate.getFullYear() + ', this);return false;"') + '>' + // actions
							(otherMonth && !showOtherMonths ? '&#xa0;' : // display for other months
							(unselectable ? '<span class="ui-state-default">' + printDate.getDate() + '</span>' : '<a class="ui-state-default' +
							(printDate.getTime() == today.getTime() ? ' ui-state-highlight' : '') +
							(printDate.getTime() == currentDate.getTime() ? ' ui-state-active' : '') + // highlight selected day
							(otherMonth ? ' ui-priority-secondary' : '') + // distinguish dates from other months
							'" href="#">' + printDate.getDate() + '</a>')) + '</td>'; // display selectable date
						printDate.setDate(printDate.getDate() + 1);
						printDate = this._daylightSavingAdjust(printDate);
					}
					calender += tbody + '</tr>';
				}
				drawMonth++;
				if (drawMonth > 11) {
					drawMonth = 0;
					drawYear++;
				}
				calender += '</tbody></table>' + (isMultiMonth ? '</div>' + 
							((numMonths[0] > 0 && col == numMonths[1]-1) ? '<div class="ui-datepicker-row-break"></div>' : '') : '');
				group += calender;
			}
			html += group;
		}
		html += buttonPanel + ($.browser.msie && parseInt($.browser.version,10) < 7 && !inst.inline ?
			'<iframe src="javascript:false;" class="ui-datepicker-cover" frameborder="0"></iframe>' : '');
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort) {
		var changeMonth = this._get(inst, 'changeMonth');
		var changeYear = this._get(inst, 'changeYear');
		var showMonthAfterYear = this._get(inst, 'showMonthAfterYear');
		var html = '<div class="ui-datepicker-title">';
		var monthHtml = '';
		// month selection
		if (secondary || !changeMonth)
			monthHtml += '<span class="ui-datepicker-month">' + monthNames[drawMonth] + '</span>';
		else {
			var inMinYear = (minDate && minDate.getFullYear() == drawYear);
			var inMaxYear = (maxDate && maxDate.getFullYear() == drawYear);
			monthHtml += '<select class="ui-datepicker-month" ' +
				'onchange="DP_jQuery_' + dpuuid + '.datepicker._selectMonthYear(\'#' + inst.id + '\', this, \'M\');" ' +
			 	'>';
			for (var month = 0; month < 12; month++) {
				if ((!inMinYear || month >= minDate.getMonth()) &&
						(!inMaxYear || month <= maxDate.getMonth()))
					monthHtml += '<option value="' + month + '"' +
						(month == drawMonth ? ' selected="selected"' : '') +
						'>' + monthNamesShort[month] + '</option>';
			}
			monthHtml += '</select>';
		}
		if (!showMonthAfterYear)
			html += monthHtml + (secondary || !(changeMonth && changeYear) ? '&#xa0;' : '');
		// year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = '';
			if (secondary || !changeYear)
				html += '<span class="ui-datepicker-year">' + drawYear + '</span>';
			else {
				// determine range of years to display
				var years = this._get(inst, 'yearRange').split(':');
				var thisYear = new Date().getFullYear();
				var determineYear = function(value) {
					var year = (value.match(/c[+-].*/) ? drawYear + parseInt(value.substring(1), 10) :
						(value.match(/[+-].*/) ? thisYear + parseInt(value, 10) :
						parseInt(value, 10)));
					return (isNaN(year) ? thisYear : year);
				};
				var year = determineYear(years[0]);
				var endYear = Math.max(year, determineYear(years[1] || ''));
				year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
				endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
				inst.yearshtml += '<select class="ui-datepicker-year" ' +
					'onchange="DP_jQuery_' + dpuuid + '.datepicker._selectMonthYear(\'#' + inst.id + '\', this, \'Y\');" ' +
					'>';
				for (; year <= endYear; year++) {
					inst.yearshtml += '<option value="' + year + '"' +
						(year == drawYear ? ' selected="selected"' : '') +
						'>' + year + '</option>';
				}
				inst.yearshtml += '</select>';
				
				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}
		html += this._get(inst, 'yearSuffix');
		if (showMonthAfterYear)
			html += (secondary || !(changeMonth && changeYear) ? '&#xa0;' : '') + monthHtml;
		html += '</div>'; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function(inst, offset, period) {
		var year = inst.drawYear + (period == 'Y' ? offset : 0);
		var month = inst.drawMonth + (period == 'M' ? offset : 0);
		var day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) +
			(period == 'D' ? offset : 0);
		var date = this._restrictMinMax(inst,
			this._daylightSavingAdjust(new Date(year, month, day)));
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if (period == 'M' || period == 'Y')
			this._notifyChange(inst);
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, 'min');
		var maxDate = this._getMinMaxDate(inst, 'max');
		var newDate = (minDate && date < minDate ? minDate : date);
		newDate = (maxDate && newDate > maxDate ? maxDate : newDate);
		return newDate;
	},

	/* Notify change of month/year. */
	_notifyChange: function(inst) {
		var onChange = this._get(inst, 'onChangeMonthYear');
		if (onChange)
			onChange.apply((inst.input ? inst.input[0] : null),
				[inst.selectedYear, inst.selectedMonth + 1, inst]);
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function(inst) {
		var numMonths = this._get(inst, 'numberOfMonths');
		return (numMonths == null ? [1, 1] : (typeof numMonths == 'number' ? [1, numMonths] : numMonths));
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function(inst, minMax) {
		return this._determineDate(inst, this._get(inst, minMax + 'Date'), null);
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function(year, month) {
		return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function(year, month) {
		return new Date(year, month, 1).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function(inst, offset, curYear, curMonth) {
		var numMonths = this._getNumberOfMonths(inst);
		var date = this._daylightSavingAdjust(new Date(curYear,
			curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));
		if (offset < 0)
			date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
		return this._isInRange(inst, date);
	},

	/* Is the given date in the accepted range? */
	_isInRange: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, 'min');
		var maxDate = this._getMinMaxDate(inst, 'max');
		return ((!minDate || date.getTime() >= minDate.getTime()) &&
			(!maxDate || date.getTime() <= maxDate.getTime()));
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function(inst) {
		var shortYearCutoff = this._get(inst, 'shortYearCutoff');
		shortYearCutoff = (typeof shortYearCutoff != 'string' ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		return {shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get(inst, 'dayNamesShort'), dayNames: this._get(inst, 'dayNames'),
			monthNamesShort: this._get(inst, 'monthNamesShort'), monthNames: this._get(inst, 'monthNames')};
	},

	/* Format the given date for display. */
	_formatDate: function(inst, day, month, year) {
		if (!day) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = (day ? (typeof day == 'object' ? day :
			this._daylightSavingAdjust(new Date(year, month, day))) :
			this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		return this.formatDate(this._get(inst, 'dateFormat'), date, this._getFormatConfig(inst));
	}
});

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */ 
function bindHover(dpDiv) {
	var selector = 'button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a';
	return dpDiv.bind('mouseout', function(event) {
			var elem = $( event.target ).closest( selector );
			if ( !elem.length ) {
				return;
			}
			elem.removeClass( "ui-state-hover ui-datepicker-prev-hover ui-datepicker-next-hover" );
		})
		.bind('mouseover', function(event) {
			var elem = $( event.target ).closest( selector );
			if ($.datepicker._isDisabledDatepicker( instActive.inline ? dpDiv.parent()[0] : instActive.input[0]) ||
					!elem.length ) {
				return;
			}
			elem.parents('.ui-datepicker-calendar').find('a').removeClass('ui-state-hover');
			elem.addClass('ui-state-hover');
			if (elem.hasClass('ui-datepicker-prev')) elem.addClass('ui-datepicker-prev-hover');
			if (elem.hasClass('ui-datepicker-next')) elem.addClass('ui-datepicker-next-hover');
		});
}

/* jQuery extend now ignores nulls! */
function extendRemove(target, props) {
	$.extend(target, props);
	for (var name in props)
		if (props[name] == null || props[name] == undefined)
			target[name] = props[name];
	return target;
};

/* Determine whether an object is an array. */
function isArray(a) {
	return (a && (($.browser.safari && typeof a == 'object' && a.length) ||
		(a.constructor && a.constructor.toString().match(/\Array\(\)/))));
};

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
                    Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function(options){
	
	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}
	
	/* Initialise the date picker. */
	if (!$.datepicker.initialized) {
		$(document).mousedown($.datepicker._checkExternalClick).
			find('body').append($.datepicker.dpDiv);
		$.datepicker.initialized = true;
	}

	var otherArgs = Array.prototype.slice.call(arguments, 1);
	if (typeof options == 'string' && (options == 'isDisabled' || options == 'getDate' || options == 'widget'))
		return $.datepicker['_' + options + 'Datepicker'].
			apply($.datepicker, [this[0]].concat(otherArgs));
	if (options == 'option' && arguments.length == 2 && typeof arguments[1] == 'string')
		return $.datepicker['_' + options + 'Datepicker'].
			apply($.datepicker, [this[0]].concat(otherArgs));
	return this.each(function() {
		typeof options == 'string' ?
			$.datepicker['_' + options + 'Datepicker'].
				apply($.datepicker, [this].concat(otherArgs)) :
			$.datepicker._attachDatepicker(this, options);
	});
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.8.18";

// Workaround for #4055
// Add another global to avoid noConflict issues with inline event handlers
window['DP_jQuery_' + dpuuid] = $;

})(jQuery);
/*
 * jQuery UI Dialog 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Dialog
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *  jquery.ui.button.js
 *	jquery.ui.draggable.js
 *	jquery.ui.mouse.js
 *	jquery.ui.position.js
 *	jquery.ui.resizable.js
 */
(function( $, undefined ) {

var uiDialogClasses =
		'ui-dialog ' +
		'ui-widget ' +
		'ui-widget-content ' +
		'ui-corner-all ',
	sizeRelatedOptions = {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},
	resizableRelatedOptions = {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},
	// support for jQuery 1.3.2 - handle common attrFn methods for dialog
	attrFn = $.attrFn || {
		val: true,
		css: true,
		html: true,
		text: true,
		data: true,
		width: true,
		height: true,
		offset: true,
		click: true
	};

$.widget("ui.dialog", {
	options: {
		autoOpen: true,
		buttons: {},
		closeOnEscape: true,
		closeText: 'close',
		dialogClass: '',
		draggable: true,
		hide: null,
		height: 'auto',
		maxHeight: false,
		maxWidth: false,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: 'center',
			at: 'center',
			collision: 'fit',
			// ensure that the titlebar is never outside the document
			using: function(pos) {
				var topOffset = $(this).css(pos).offset().top;
				if (topOffset < 0) {
					$(this).css('top', pos.top - topOffset);
				}
			}
		},
		resizable: true,
		show: null,
		stack: true,
		title: '',
		width: 300,
		zIndex: 1000
	},

	_create: function() {
		this.originalTitle = this.element.attr('title');
		// #5742 - .attr() might return a DOMElement
		if ( typeof this.originalTitle !== "string" ) {
			this.originalTitle = "";
		}

		this.options.title = this.options.title || this.originalTitle;
		var self = this,
			options = self.options,

			title = options.title || '&#160;',
			titleId = $.ui.dialog.getTitleId(self.element),

			uiDialog = (self.uiDialog = $('<div></div>'))
				.appendTo(document.body)
				.hide()
				.addClass(uiDialogClasses + options.dialogClass)
				.css({
					zIndex: options.zIndex
				})
				// setting tabIndex makes the div focusable
				// setting outline to 0 prevents a border on focus in Mozilla
				.attr('tabIndex', -1).css('outline', 0).keydown(function(event) {
					if (options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE) {
						
						self.close(event);
						event.preventDefault();
					}
				})
				.attr({
					role: 'dialog',
					'aria-labelledby': titleId
				})
				.mousedown(function(event) {
					self.moveToTop(false, event);
				}),

			uiDialogContent = self.element
				.show()
				.removeAttr('title')
				.addClass(
					'ui-dialog-content ' +
					'ui-widget-content')
				.appendTo(uiDialog),

			uiDialogTitlebar = (self.uiDialogTitlebar = $('<div></div>'))
				.addClass(
					'ui-dialog-titlebar ' +
					'ui-widget-header ' +
					'ui-corner-all ' +
					'ui-helper-clearfix'
				)
				.prependTo(uiDialog),

			uiDialogTitlebarClose = $('<a href="#"></a>')
				.addClass(
					'ui-dialog-titlebar-close ' +
					'ui-corner-all'
				)
				.attr('role', 'button')
				.hover(
					function() {
						uiDialogTitlebarClose.addClass('ui-state-hover');
					},
					function() {
						uiDialogTitlebarClose.removeClass('ui-state-hover');
					}
				)
				.focus(function() {
					uiDialogTitlebarClose.addClass('ui-state-focus');
				})
				.blur(function() {
					uiDialogTitlebarClose.removeClass('ui-state-focus');
				})
				.click(function(event) {
					self.close(event);
					return false;
				})
				.appendTo(uiDialogTitlebar),

			uiDialogTitlebarCloseText = (self.uiDialogTitlebarCloseText = $('<span></span>'))
				.addClass(
					'ui-icon ' +
					'ui-icon-closethick'
				)
				.text(options.closeText)
				.appendTo(uiDialogTitlebarClose),

			uiDialogTitle = $('<span></span>')
				.addClass('ui-dialog-title')
				.attr('id', titleId)
				.html(title)
				.prependTo(uiDialogTitlebar);

		//handling of deprecated beforeclose (vs beforeClose) option
		//Ticket #4669 http://dev.jqueryui.com/ticket/4669
		//TODO: remove in 1.9pre
		if ($.isFunction(options.beforeclose) && !$.isFunction(options.beforeClose)) {
			options.beforeClose = options.beforeclose;
		}

		uiDialogTitlebar.find("*").add(uiDialogTitlebar).disableSelection();

		if (options.draggable && $.fn.draggable) {
			self._makeDraggable();
		}
		if (options.resizable && $.fn.resizable) {
			self._makeResizable();
		}

		self._createButtons(options.buttons);
		self._isOpen = false;

		if ($.fn.bgiframe) {
			uiDialog.bgiframe();
		}
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	destroy: function() {
		var self = this;
		
		if (self.overlay) {
			self.overlay.destroy();
		}
		self.uiDialog.hide();
		self.element
			.unbind('.dialog')
			.removeData('dialog')
			.removeClass('ui-dialog-content ui-widget-content')
			.hide().appendTo('body');
		self.uiDialog.remove();

		if (self.originalTitle) {
			self.element.attr('title', self.originalTitle);
		}

		return self;
	},

	widget: function() {
		return this.uiDialog;
	},

	close: function(event) {
		var self = this,
			maxZ, thisZ;
		
		if (false === self._trigger('beforeClose', event)) {
			return;
		}

		if (self.overlay) {
			self.overlay.destroy();
		}
		self.uiDialog.unbind('keypress.ui-dialog');

		self._isOpen = false;

		if (self.options.hide) {
			self.uiDialog.hide(self.options.hide, function() {
				self._trigger('close', event);
			});
		} else {
			self.uiDialog.hide();
			self._trigger('close', event);
		}

		$.ui.dialog.overlay.resize();

		// adjust the maxZ to allow other modal dialogs to continue to work (see #4309)
		if (self.options.modal) {
			maxZ = 0;
			$('.ui-dialog').each(function() {
				if (this !== self.uiDialog[0]) {
					thisZ = $(this).css('z-index');
					if(!isNaN(thisZ)) {
						maxZ = Math.max(maxZ, thisZ);
					}
				}
			});
			$.ui.dialog.maxZ = maxZ;
		}

		return self;
	},

	isOpen: function() {
		return this._isOpen;
	},

	// the force parameter allows us to move modal dialogs to their correct
	// position on open
	moveToTop: function(force, event) {
		var self = this,
			options = self.options,
			saveScroll;

		if ((options.modal && !force) ||
			(!options.stack && !options.modal)) {
			return self._trigger('focus', event);
		}

		if (options.zIndex > $.ui.dialog.maxZ) {
			$.ui.dialog.maxZ = options.zIndex;
		}
		if (self.overlay) {
			$.ui.dialog.maxZ += 1;
			self.overlay.$el.css('z-index', $.ui.dialog.overlay.maxZ = $.ui.dialog.maxZ);
		}

		//Save and then restore scroll since Opera 9.5+ resets when parent z-Index is changed.
		//  http://ui.jquery.com/bugs/ticket/3193
		saveScroll = { scrollTop: self.element.scrollTop(), scrollLeft: self.element.scrollLeft() };
		$.ui.dialog.maxZ += 1;
		self.uiDialog.css('z-index', $.ui.dialog.maxZ);
		self.element.attr(saveScroll);
		self._trigger('focus', event);

		return self;
	},

	open: function() {
		if (this._isOpen) { return; }

		var self = this,
			options = self.options,
			uiDialog = self.uiDialog;

		self.overlay = options.modal ? new $.ui.dialog.overlay(self) : null;
		self._size();
		self._position(options.position);
		uiDialog.show(options.show);
		self.moveToTop(true);

		// prevent tabbing out of modal dialogs
		if ( options.modal ) {
			uiDialog.bind( "keydown.ui-dialog", function( event ) {
				if ( event.keyCode !== $.ui.keyCode.TAB ) {
					return;
				}

				var tabbables = $(':tabbable', this),
					first = tabbables.filter(':first'),
					last  = tabbables.filter(':last');

				if (event.target === last[0] && !event.shiftKey) {
					first.focus(1);
					return false;
				} else if (event.target === first[0] && event.shiftKey) {
					last.focus(1);
					return false;
				}
			});
		}

		// set focus to the first tabbable element in the content area or the first button
		// if there are no tabbable elements, set focus on the dialog itself
		$(self.element.find(':tabbable').get().concat(
			uiDialog.find('.ui-dialog-buttonpane :tabbable').get().concat(
				uiDialog.get()))).eq(0).focus();

		self._isOpen = true;
		self._trigger('open');

		return self;
	},

	_createButtons: function(buttons) {
		var self = this,
			hasButtons = false,
			uiDialogButtonPane = $('<div></div>')
				.addClass(
					'ui-dialog-buttonpane ' +
					'ui-widget-content ' +
					'ui-helper-clearfix'
				),
			uiButtonSet = $( "<div></div>" )
				.addClass( "ui-dialog-buttonset" )
				.appendTo( uiDialogButtonPane );

		// if we already have a button pane, remove it
		self.uiDialog.find('.ui-dialog-buttonpane').remove();

		if (typeof buttons === 'object' && buttons !== null) {
			$.each(buttons, function() {
				return !(hasButtons = true);
			});
		}
		if (hasButtons) {
			$.each(buttons, function(name, props) {
				props = $.isFunction( props ) ?
					{ click: props, text: name } :
					props;
				var button = $('<button type="button"></button>')
					.click(function() {
						props.click.apply(self.element[0], arguments);
					})
					.appendTo(uiButtonSet);
				// can't use .attr( props, true ) with jQuery 1.3.2.
				$.each( props, function( key, value ) {
					if ( key === "click" ) {
						return;
					}
					if ( key in attrFn ) {
						button[ key ]( value );
					} else {
						button.attr( key, value );
					}
				});
				if ($.fn.button) {
					button.button();
				}
			});
			uiDialogButtonPane.appendTo(self.uiDialog);
		}
	},

	_makeDraggable: function() {
		var self = this,
			options = self.options,
			doc = $(document),
			heightBeforeDrag;

		function filteredUi(ui) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		self.uiDialog.draggable({
			cancel: '.ui-dialog-content, .ui-dialog-titlebar-close',
			handle: '.ui-dialog-titlebar',
			containment: 'document',
			start: function(event, ui) {
				heightBeforeDrag = options.height === "auto" ? "auto" : $(this).height();
				$(this).height($(this).height()).addClass("ui-dialog-dragging");
				self._trigger('dragStart', event, filteredUi(ui));
			},
			drag: function(event, ui) {
				self._trigger('drag', event, filteredUi(ui));
			},
			stop: function(event, ui) {
				options.position = [ui.position.left - doc.scrollLeft(),
					ui.position.top - doc.scrollTop()];
				$(this).removeClass("ui-dialog-dragging").height(heightBeforeDrag);
				self._trigger('dragStop', event, filteredUi(ui));
				$.ui.dialog.overlay.resize();
			}
		});
	},

	_makeResizable: function(handles) {
		handles = (handles === undefined ? this.options.resizable : handles);
		var self = this,
			options = self.options,
			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = self.uiDialog.css('position'),
			resizeHandles = (typeof handles === 'string' ?
				handles	:
				'n,e,s,w,se,sw,ne,nw'
			);

		function filteredUi(ui) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		self.uiDialog.resizable({
			cancel: '.ui-dialog-content',
			containment: 'document',
			alsoResize: self.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: self._minHeight(),
			handles: resizeHandles,
			start: function(event, ui) {
				$(this).addClass("ui-dialog-resizing");
				self._trigger('resizeStart', event, filteredUi(ui));
			},
			resize: function(event, ui) {
				self._trigger('resize', event, filteredUi(ui));
			},
			stop: function(event, ui) {
				$(this).removeClass("ui-dialog-resizing");
				options.height = $(this).height();
				options.width = $(this).width();
				self._trigger('resizeStop', event, filteredUi(ui));
				$.ui.dialog.overlay.resize();
			}
		})
		.css('position', position)
		.find('.ui-resizable-se').addClass('ui-icon ui-icon-grip-diagonal-se');
	},

	_minHeight: function() {
		var options = this.options;

		if (options.height === 'auto') {
			return options.minHeight;
		} else {
			return Math.min(options.minHeight, options.height);
		}
	},

	_position: function(position) {
		var myAt = [],
			offset = [0, 0],
			isVisible;

		if (position) {
			// deep extending converts arrays to objects in jQuery <= 1.3.2 :-(
	//		if (typeof position == 'string' || $.isArray(position)) {
	//			myAt = $.isArray(position) ? position : position.split(' ');

			if (typeof position === 'string' || (typeof position === 'object' && '0' in position)) {
				myAt = position.split ? position.split(' ') : [position[0], position[1]];
				if (myAt.length === 1) {
					myAt[1] = myAt[0];
				}

				$.each(['left', 'top'], function(i, offsetPosition) {
					if (+myAt[i] === myAt[i]) {
						offset[i] = myAt[i];
						myAt[i] = offsetPosition;
					}
				});

				position = {
					my: myAt.join(" "),
					at: myAt.join(" "),
					offset: offset.join(" ")
				};
			} 

			position = $.extend({}, $.ui.dialog.prototype.options.position, position);
		} else {
			position = $.ui.dialog.prototype.options.position;
		}

		// need to show the dialog to get the actual offset in the position plugin
		isVisible = this.uiDialog.is(':visible');
		if (!isVisible) {
			this.uiDialog.show();
		}
		this.uiDialog
			// workaround for jQuery bug #5781 http://dev.jquery.com/ticket/5781
			.css({ top: 0, left: 0 })
			.position($.extend({ of: window }, position));
		if (!isVisible) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var self = this,
			resizableOptions = {},
			resize = false;

		$.each( options, function( key, value ) {
			self._setOption( key, value );
			
			if ( key in sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		});

		if ( resize ) {
			this._size();
		}
		if ( this.uiDialog.is( ":data(resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function(key, value){
		var self = this,
			uiDialog = self.uiDialog;

		switch (key) {
			//handling of deprecated beforeclose (vs beforeClose) option
			//Ticket #4669 http://dev.jqueryui.com/ticket/4669
			//TODO: remove in 1.9pre
			case "beforeclose":
				key = "beforeClose";
				break;
			case "buttons":
				self._createButtons(value);
				break;
			case "closeText":
				// ensure that we always pass a string
				self.uiDialogTitlebarCloseText.text("" + value);
				break;
			case "dialogClass":
				uiDialog
					.removeClass(self.options.dialogClass)
					.addClass(uiDialogClasses + value);
				break;
			case "disabled":
				if (value) {
					uiDialog.addClass('ui-dialog-disabled');
				} else {
					uiDialog.removeClass('ui-dialog-disabled');
				}
				break;
			case "draggable":
				var isDraggable = uiDialog.is( ":data(draggable)" );
				if ( isDraggable && !value ) {
					uiDialog.draggable( "destroy" );
				}
				
				if ( !isDraggable && value ) {
					self._makeDraggable();
				}
				break;
			case "position":
				self._position(value);
				break;
			case "resizable":
				// currently resizable, becoming non-resizable
				var isResizable = uiDialog.is( ":data(resizable)" );
				if (isResizable && !value) {
					uiDialog.resizable('destroy');
				}

				// currently resizable, changing handles
				if (isResizable && typeof value === 'string') {
					uiDialog.resizable('option', 'handles', value);
				}

				// currently non-resizable, becoming resizable
				if (!isResizable && value !== false) {
					self._makeResizable(value);
				}
				break;
			case "title":
				// convert whatever was passed in o a string, for html() to not throw up
				$(".ui-dialog-title", self.uiDialogTitlebar).html("" + (value || '&#160;'));
				break;
		}

		$.Widget.prototype._setOption.apply(self, arguments);
	},

	_size: function() {
		/* If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		 * divs will both have width and height set, so we need to reset them
		 */
		var options = this.options,
			nonContentHeight,
			minContentHeight,
			isVisible = this.uiDialog.is( ":visible" );

		// reset content sizing
		this.element.show().css({
			width: 'auto',
			minHeight: 0,
			height: 0
		});

		if (options.minWidth > options.width) {
			options.width = options.minWidth;
		}

		// reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css({
				height: 'auto',
				width: options.width
			})
			.height();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		
		if ( options.height === "auto" ) {
			// only needed for IE6 support
			if ( $.support.minHeight ) {
				this.element.css({
					minHeight: minContentHeight,
					height: "auto"
				});
			} else {
				this.uiDialog.show();
				var autoHeight = this.element.css( "height", "auto" ).height();
				if ( !isVisible ) {
					this.uiDialog.hide();
				}
				this.element.height( Math.max( autoHeight, minContentHeight ) );
			}
		} else {
			this.element.height( Math.max( options.height - nonContentHeight, 0 ) );
		}

		if (this.uiDialog.is(':data(resizable)')) {
			this.uiDialog.resizable('option', 'minHeight', this._minHeight());
		}
	}
});

$.extend($.ui.dialog, {
	version: "1.8.18",

	uuid: 0,
	maxZ: 0,

	getTitleId: function($el) {
		var id = $el.attr('id');
		if (!id) {
			this.uuid += 1;
			id = this.uuid;
		}
		return 'ui-dialog-title-' + id;
	},

	overlay: function(dialog) {
		this.$el = $.ui.dialog.overlay.create(dialog);
	}
});

$.extend($.ui.dialog.overlay, {
	instances: [],
	// reuse old instances due to IE memory leak with alpha transparency (see #5185)
	oldInstances: [],
	maxZ: 0,
	events: $.map('focus,mousedown,mouseup,keydown,keypress,click'.split(','),
		function(event) { return event + '.dialog-overlay'; }).join(' '),
	create: function(dialog) {
		if (this.instances.length === 0) {
			// prevent use of anchors and inputs
			// we use a setTimeout in case the overlay is created from an
			// event that we're going to be cancelling (see #2804)
			setTimeout(function() {
				// handle $(el).dialog().dialog('close') (see #4065)
				if ($.ui.dialog.overlay.instances.length) {
					$(document).bind($.ui.dialog.overlay.events, function(event) {
						// stop events if the z-index of the target is < the z-index of the overlay
						// we cannot return true when we don't want to cancel the event (#3523)
						if ($(event.target).zIndex() < $.ui.dialog.overlay.maxZ) {
							return false;
						}
					});
				}
			}, 1);

			// allow closing by pressing the escape key
			$(document).bind('keydown.dialog-overlay', function(event) {
				if (dialog.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
					event.keyCode === $.ui.keyCode.ESCAPE) {
					
					dialog.close(event);
					event.preventDefault();
				}
			});

			// handle window resize
			$(window).bind('resize.dialog-overlay', $.ui.dialog.overlay.resize);
		}

		var $el = (this.oldInstances.pop() || $('<div></div>').addClass('ui-widget-overlay'))
			.appendTo(document.body)
			.css({
				width: this.width(),
				height: this.height()
			});

		if ($.fn.bgiframe) {
			$el.bgiframe();
		}

		this.instances.push($el);
		return $el;
	},

	destroy: function($el) {
		var indexOf = $.inArray($el, this.instances);
		if (indexOf != -1){
			this.oldInstances.push(this.instances.splice(indexOf, 1)[0]);
		}

		if (this.instances.length === 0) {
			$([document, window]).unbind('.dialog-overlay');
		}

		$el.remove();
		
		// adjust the maxZ to allow other modal dialogs to continue to work (see #4309)
		var maxZ = 0;
		$.each(this.instances, function() {
			maxZ = Math.max(maxZ, this.css('z-index'));
		});
		this.maxZ = maxZ;
	},

	height: function() {
		var scrollHeight,
			offsetHeight;
		// handle IE 6
		if ($.browser.msie && $.browser.version < 7) {
			scrollHeight = Math.max(
				document.documentElement.scrollHeight,
				document.body.scrollHeight
			);
			offsetHeight = Math.max(
				document.documentElement.offsetHeight,
				document.body.offsetHeight
			);

			if (scrollHeight < offsetHeight) {
				return $(window).height() + 'px';
			} else {
				return scrollHeight + 'px';
			}
		// handle "good" browsers
		} else {
			return $(document).height() + 'px';
		}
	},

	width: function() {
		var scrollWidth,
			offsetWidth;
		// handle IE
		if ( $.browser.msie ) {
			scrollWidth = Math.max(
				document.documentElement.scrollWidth,
				document.body.scrollWidth
			);
			offsetWidth = Math.max(
				document.documentElement.offsetWidth,
				document.body.offsetWidth
			);

			if (scrollWidth < offsetWidth) {
				return $(window).width() + 'px';
			} else {
				return scrollWidth + 'px';
			}
		// handle "good" browsers
		} else {
			return $(document).width() + 'px';
		}
	},

	resize: function() {
		/* If the dialog is draggable and the user drags it past the
		 * right edge of the window, the document becomes wider so we
		 * need to stretch the overlay. If the user then drags the
		 * dialog back to the left, the document will become narrower,
		 * so we need to shrink the overlay to the appropriate size.
		 * This is handled by shrinking the overlay before setting it
		 * to the full document size.
		 */
		var $overlays = $([]);
		$.each($.ui.dialog.overlay.instances, function() {
			$overlays = $overlays.add(this);
		});

		$overlays.css({
			width: 0,
			height: 0
		}).css({
			width: $.ui.dialog.overlay.width(),
			height: $.ui.dialog.overlay.height()
		});
	}
});

$.extend($.ui.dialog.overlay.prototype, {
	destroy: function() {
		$.ui.dialog.overlay.destroy(this.$el);
	}
});

}(jQuery));
/*
 * jQuery UI Position 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Position
 */
(function( $, undefined ) {

$.ui = $.ui || {};

var horizontalPositions = /left|center|right/,
	verticalPositions = /top|center|bottom/,
	center = "center",
	support = {},
	_position = $.fn.position,
	_offset = $.fn.offset;

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var target = $( options.of ),
		targetElem = target[0],
		collision = ( options.collision || "flip" ).split( " " ),
		offset = options.offset ? options.offset.split( " " ) : [ 0, 0 ],
		targetWidth,
		targetHeight,
		basePosition;

	if ( targetElem.nodeType === 9 ) {
		targetWidth = target.width();
		targetHeight = target.height();
		basePosition = { top: 0, left: 0 };
	// TODO: use $.isWindow() in 1.9
	} else if ( targetElem.setTimeout ) {
		targetWidth = target.width();
		targetHeight = target.height();
		basePosition = { top: target.scrollTop(), left: target.scrollLeft() };
	} else if ( targetElem.preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
		targetWidth = targetHeight = 0;
		basePosition = { top: options.of.pageY, left: options.of.pageX };
	} else {
		targetWidth = target.outerWidth();
		targetHeight = target.outerHeight();
		basePosition = target.offset();
	}

	// force my and at to have valid horizontal and veritcal positions
	// if a value is missing or invalid, it will be converted to center 
	$.each( [ "my", "at" ], function() {
		var pos = ( options[this] || "" ).split( " " );
		if ( pos.length === 1) {
			pos = horizontalPositions.test( pos[0] ) ?
				pos.concat( [center] ) :
				verticalPositions.test( pos[0] ) ?
					[ center ].concat( pos ) :
					[ center, center ];
		}
		pos[ 0 ] = horizontalPositions.test( pos[0] ) ? pos[ 0 ] : center;
		pos[ 1 ] = verticalPositions.test( pos[1] ) ? pos[ 1 ] : center;
		options[ this ] = pos;
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	// normalize offset option
	offset[ 0 ] = parseInt( offset[0], 10 ) || 0;
	if ( offset.length === 1 ) {
		offset[ 1 ] = offset[ 0 ];
	}
	offset[ 1 ] = parseInt( offset[1], 10 ) || 0;

	if ( options.at[0] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[0] === center ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[1] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[1] === center ) {
		basePosition.top += targetHeight / 2;
	}

	basePosition.left += offset[ 0 ];
	basePosition.top += offset[ 1 ];

	return this.each(function() {
		var elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseInt( $.curCSS( this, "marginLeft", true ) ) || 0,
			marginTop = parseInt( $.curCSS( this, "marginTop", true ) ) || 0,
			collisionWidth = elemWidth + marginLeft +
				( parseInt( $.curCSS( this, "marginRight", true ) ) || 0 ),
			collisionHeight = elemHeight + marginTop +
				( parseInt( $.curCSS( this, "marginBottom", true ) ) || 0 ),
			position = $.extend( {}, basePosition ),
			collisionPosition;

		if ( options.my[0] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[0] === center ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[1] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[1] === center ) {
			position.top -= elemHeight / 2;
		}

		// prevent fractions if jQuery version doesn't support them (see #5280)
		if ( !support.fractions ) {
			position.left = Math.round( position.left );
			position.top = Math.round( position.top );
		}

		collisionPosition = {
			left: position.left - marginLeft,
			top: position.top - marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[i] ] ) {
				$.ui.position[ collision[i] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: offset,
					my: options.my,
					at: options.at
				});
			}
		});

		if ( $.fn.bgiframe ) {
			elem.bgiframe();
		}
		elem.offset( $.extend( position, { using: options.using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var win = $( window ),
				over = data.collisionPosition.left + data.collisionWidth - win.width() - win.scrollLeft();
			position.left = over > 0 ? position.left - over : Math.max( position.left - data.collisionPosition.left, position.left );
		},
		top: function( position, data ) {
			var win = $( window ),
				over = data.collisionPosition.top + data.collisionHeight - win.height() - win.scrollTop();
			position.top = over > 0 ? position.top - over : Math.max( position.top - data.collisionPosition.top, position.top );
		}
	},

	flip: {
		left: function( position, data ) {
			if ( data.at[0] === center ) {
				return;
			}
			var win = $( window ),
				over = data.collisionPosition.left + data.collisionWidth - win.width() - win.scrollLeft(),
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					-data.targetWidth,
				offset = -2 * data.offset[ 0 ];
			position.left += data.collisionPosition.left < 0 ?
				myOffset + atOffset + offset :
				over > 0 ?
					myOffset + atOffset + offset :
					0;
		},
		top: function( position, data ) {
			if ( data.at[1] === center ) {
				return;
			}
			var win = $( window ),
				over = data.collisionPosition.top + data.collisionHeight - win.height() - win.scrollTop(),
				myOffset = data.my[ 1 ] === "top" ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					-data.targetHeight,
				offset = -2 * data.offset[ 1 ];
			position.top += data.collisionPosition.top < 0 ?
				myOffset + atOffset + offset :
				over > 0 ?
					myOffset + atOffset + offset :
					0;
		}
	}
};

// offset setter from jQuery 1.4
if ( !$.offset.setOffset ) {
	$.offset.setOffset = function( elem, options ) {
		// set position first, in-case top/left are set even on static elem
		if ( /static/.test( $.curCSS( elem, "position" ) ) ) {
			elem.style.position = "relative";
		}
		var curElem   = $( elem ),
			curOffset = curElem.offset(),
			curTop    = parseInt( $.curCSS( elem, "top",  true ), 10 ) || 0,
			curLeft   = parseInt( $.curCSS( elem, "left", true ), 10)  || 0,
			props     = {
				top:  (options.top  - curOffset.top)  + curTop,
				left: (options.left - curOffset.left) + curLeft
			};
		
		if ( 'using' in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	};

	$.fn.offset = function( options ) {
		var elem = this[ 0 ];
		if ( !elem || !elem.ownerDocument ) { return null; }
		if ( options ) { 
			return this.each(function() {
				$.offset.setOffset( this, options );
			});
		}
		return _offset.call( this );
	};
}

// fraction support test (older versions of jQuery don't support fractions)
(function () {
	var body = document.getElementsByTagName( "body" )[ 0 ], 
		div = document.createElement( "div" ),
		testElement, testElementParent, testElementStyle, offset, offsetTotal;

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( var i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px; top: 10.432325px; height: 30px; width: 201px;";

	offset = $( div ).offset( function( _, offset ) {
		return offset;
	}).offset();

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );

	offsetTotal = offset.top + offset.left + ( body ? 2000 : 0 );
	support.fractions = offsetTotal > 21 && offsetTotal < 22;
})();

}( jQuery ));
/*
 * jQuery UI Progressbar 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Progressbar
 *
 * Depends:
 *   jquery.ui.core.js
 *   jquery.ui.widget.js
 */
(function( $, undefined ) {

$.widget( "ui.progressbar", {
	options: {
		value: 0,
		max: 100
	},

	min: 0,

	_create: function() {
		this.element
			.addClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
			.attr({
				role: "progressbar",
				"aria-valuemin": this.min,
				"aria-valuemax": this.options.max,
				"aria-valuenow": this._value()
			});

		this.valueDiv = $( "<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>" )
			.appendTo( this.element );

		this.oldValue = this._value();
		this._refreshValue();
	},

	destroy: function() {
		this.element
			.removeClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
			.removeAttr( "role" )
			.removeAttr( "aria-valuemin" )
			.removeAttr( "aria-valuemax" )
			.removeAttr( "aria-valuenow" );

		this.valueDiv.remove();

		$.Widget.prototype.destroy.apply( this, arguments );
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this._value();
		}

		this._setOption( "value", newValue );
		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "value" ) {
			this.options.value = value;
			this._refreshValue();
			if ( this._value() === this.options.max ) {
				this._trigger( "complete" );
			}
		}

		$.Widget.prototype._setOption.apply( this, arguments );
	},

	_value: function() {
		var val = this.options.value;
		// normalize invalid value
		if ( typeof val !== "number" ) {
			val = 0;
		}
		return Math.min( this.options.max, Math.max( this.min, val ) );
	},

	_percentage: function() {
		return 100 * this._value() / this.options.max;
	},

	_refreshValue: function() {
		var value = this.value();
		var percentage = this._percentage();

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}

		this.valueDiv
			.toggle( value > this.min )
			.toggleClass( "ui-corner-right", value === this.options.max )
			.width( percentage.toFixed(0) + "%" );
		this.element.attr( "aria-valuenow", value );
	}
});

$.extend( $.ui.progressbar, {
	version: "1.8.18"
});

})( jQuery );
/*
 * jQuery UI Slider 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Slider
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

// number of pages in a slider
// (how many times can you page up/down to go through the whole range)
var numPages = 5;

$.widget( "ui.slider", $.ui.mouse, {

	widgetEventPrefix: "slide",

	options: {
		animate: false,
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null
	},

	_create: function() {
		var self = this,
			o = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
			handle = "<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",
			handleCount = ( o.values && o.values.length ) || 1,
			handles = [];

		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();

		this.element
			.addClass( "ui-slider" +
				" ui-slider-" + this.orientation +
				" ui-widget" +
				" ui-widget-content" +
				" ui-corner-all" +
				( o.disabled ? " ui-slider-disabled ui-disabled" : "" ) );

		this.range = $([]);

		if ( o.range ) {
			if ( o.range === true ) {
				if ( !o.values ) {
					o.values = [ this._valueMin(), this._valueMin() ];
				}
				if ( o.values.length && o.values.length !== 2 ) {
					o.values = [ o.values[0], o.values[0] ];
				}
			}

			this.range = $( "<div></div>" )
				.appendTo( this.element )
				.addClass( "ui-slider-range" +
				// note: this isn't the most fittingly semantic framework class for this element,
				// but worked best visually with a variety of themes
				" ui-widget-header" + 
				( ( o.range === "min" || o.range === "max" ) ? " ui-slider-range-" + o.range : "" ) );
		}

		for ( var i = existingHandles.length; i < handleCount; i += 1 ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( self.element ) );

		this.handle = this.handles.eq( 0 );

		this.handles.add( this.range ).filter( "a" )
			.click(function( event ) {
				event.preventDefault();
			})
			.hover(function() {
				if ( !o.disabled ) {
					$( this ).addClass( "ui-state-hover" );
				}
			}, function() {
				$( this ).removeClass( "ui-state-hover" );
			})
			.focus(function() {
				if ( !o.disabled ) {
					$( ".ui-slider .ui-state-focus" ).removeClass( "ui-state-focus" );
					$( this ).addClass( "ui-state-focus" );
				} else {
					$( this ).blur();
				}
			})
			.blur(function() {
				$( this ).removeClass( "ui-state-focus" );
			});

		this.handles.each(function( i ) {
			$( this ).data( "index.ui-slider-handle", i );
		});

		this.handles
			.keydown(function( event ) {
				var index = $( this ).data( "index.ui-slider-handle" ),
					allowed,
					curVal,
					newVal,
					step;
	
				if ( self.options.disabled ) {
					return;
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						event.preventDefault();
						if ( !self._keySliding ) {
							self._keySliding = true;
							$( this ).addClass( "ui-state-active" );
							allowed = self._start( event, index );
							if ( allowed === false ) {
								return;
							}
						}
						break;
				}
	
				step = self.options.step;
				if ( self.options.values && self.options.values.length ) {
					curVal = newVal = self.values( index );
				} else {
					curVal = newVal = self.value();
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
						newVal = self._valueMin();
						break;
					case $.ui.keyCode.END:
						newVal = self._valueMax();
						break;
					case $.ui.keyCode.PAGE_UP:
						newVal = self._trimAlignValue( curVal + ( (self._valueMax() - self._valueMin()) / numPages ) );
						break;
					case $.ui.keyCode.PAGE_DOWN:
						newVal = self._trimAlignValue( curVal - ( (self._valueMax() - self._valueMin()) / numPages ) );
						break;
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
						if ( curVal === self._valueMax() ) {
							return;
						}
						newVal = self._trimAlignValue( curVal + step );
						break;
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						if ( curVal === self._valueMin() ) {
							return;
						}
						newVal = self._trimAlignValue( curVal - step );
						break;
				}
	
				self._slide( event, index, newVal );
			})
			.keyup(function( event ) {
				var index = $( this ).data( "index.ui-slider-handle" );
	
				if ( self._keySliding ) {
					self._keySliding = false;
					self._stop( event, index );
					self._change( event, index );
					$( this ).removeClass( "ui-state-active" );
				}
	
			});

		this._refreshValue();

		this._animateOff = false;
	},

	destroy: function() {
		this.handles.remove();
		this.range.remove();

		this.element
			.removeClass( "ui-slider" +
				" ui-slider-horizontal" +
				" ui-slider-vertical" +
				" ui-slider-disabled" +
				" ui-widget" +
				" ui-widget-content" +
				" ui-corner-all" )
			.removeData( "slider" )
			.unbind( ".slider" );

		this._mouseDestroy();

		return this;
	},

	_mouseCapture: function( event ) {
		var o = this.options,
			position,
			normValue,
			distance,
			closestHandle,
			self,
			index,
			allowed,
			offset,
			mouseOverHandle;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		self = this;
		this.handles.each(function( i ) {
			var thisDistance = Math.abs( normValue - self.values(i) );
			if ( distance > thisDistance ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		});

		// workaround for bug #3736 (if both handles of a range are at 0,
		// the first is always used as the one with least distance,
		// and moving it is obviously prevented by preventing negative ranges)
		if( o.range === true && this.values(1) === o.min ) {
			index += 1;
			closestHandle = $( this.handles[index] );
		}

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		self._handleIndex = index;

		closestHandle
			.addClass( "ui-state-active" )
			.focus();
		
		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().andSelf().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
				( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
				( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function( event ) {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );
		
		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this.handles.removeClass( "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},
	
	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_start: function( event, index ) {
		var uiHash = {
			handle: this.handles[ index ],
			value: this.value()
		};
		if ( this.options.values && this.options.values.length ) {
			uiHash.value = this.values( index );
			uiHash.values = this.values();
		}
		return this._trigger( "start", event, uiHash );
	},

	_slide: function( event, index, newVal ) {
		var otherVal,
			newValues,
			allowed;

		if ( this.options.values && this.options.values.length ) {
			otherVal = this.values( index ? 0 : 1 );

			if ( ( this.options.values.length === 2 && this.options.range === true ) && 
					( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
				) {
				newVal = otherVal;
			}

			if ( newVal !== this.values( index ) ) {
				newValues = this.values();
				newValues[ index ] = newVal;
				// A slide can be canceled by returning false from the slide callback
				allowed = this._trigger( "slide", event, {
					handle: this.handles[ index ],
					value: newVal,
					values: newValues
				} );
				otherVal = this.values( index ? 0 : 1 );
				if ( allowed !== false ) {
					this.values( index, newVal, true );
				}
			}
		} else {
			if ( newVal !== this.value() ) {
				// A slide can be canceled by returning false from the slide callback
				allowed = this._trigger( "slide", event, {
					handle: this.handles[ index ],
					value: newVal
				} );
				if ( allowed !== false ) {
					this.value( newVal );
				}
			}
		}
	},

	_stop: function( event, index ) {
		var uiHash = {
			handle: this.handles[ index ],
			value: this.value()
		};
		if ( this.options.values && this.options.values.length ) {
			uiHash.value = this.values( index );
			uiHash.values = this.values();
		}

		this._trigger( "stop", event, uiHash );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}

			this._trigger( "change", event, uiHash );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( $.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this.options.values && this.options.values.length ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( $.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		$.Widget.prototype._setOption.apply( this, arguments );

		switch ( key ) {
			case "disabled":
				if ( value ) {
					this.handles.filter( ".ui-state-focus" ).blur();
					this.handles.removeClass( "ui-state-hover" );
					this.handles.propAttr( "disabled", true );
					this.element.addClass( "ui-disabled" );
				} else {
					this.handles.propAttr( "disabled", false );
					this.element.removeClass( "ui-disabled" );
				}
				break;
			case "orientation":
				this._detectOrientation();
				this.element
					.removeClass( "ui-slider-horizontal ui-slider-vertical" )
					.addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();
				for ( i = 0; i < valsLength; i += 1 ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
		}
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else {
			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i+= 1) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		}
	},
	
	// returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = (val - this._valueMin()) % step,
			alignValue = val - valModStep;

		if ( Math.abs(valModStep) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed(5) );
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.options.max;
	},
	
	_refreshValue: function() {
		var oRange = this.options.range,
			o = this.options,
			self = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			valPercent,
			_set = {},
			lastValPercent,
			value,
			valueMin,
			valueMax;

		if ( this.options.values && this.options.values.length ) {
			this.handles.each(function( i, j ) {
				valPercent = ( self.values(i) - self._valueMin() ) / ( self._valueMax() - self._valueMin() ) * 100;
				_set[ self.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( self.options.range === true ) {
					if ( self.orientation === "horizontal" ) {
						if ( i === 0 ) {
							self.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
						}
						if ( i === 1 ) {
							self.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
						}
					} else {
						if ( i === 0 ) {
							self.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
						}
						if ( i === 1 ) {
							self.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
						}
					}
				}
				lastValPercent = valPercent;
			});
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ self.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
			}
		}
	}

});

$.extend( $.ui.slider, {
	version: "1.8.18"
});

}(jQuery));
/*
 * jQuery UI Tabs 1.8.18
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Tabs
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 */
(function( $, undefined ) {

var tabId = 0,
	listId = 0;

function getNextTabId() {
	return ++tabId;
}

function getNextListId() {
	return ++listId;
}

$.widget( "ui.tabs", {
	options: {
		add: null,
		ajaxOptions: null,
		cache: false,
		cookie: null, // e.g. { expires: 7, path: '/', domain: 'jquery.com', secure: true }
		collapsible: false,
		disable: null,
		disabled: [],
		enable: null,
		event: "click",
		fx: null, // e.g. { height: 'toggle', opacity: 'toggle', duration: 200 }
		idPrefix: "ui-tabs-",
		load: null,
		panelTemplate: "<div></div>",
		remove: null,
		select: null,
		show: null,
		spinner: "<em>Loading&#8230;</em>",
		tabTemplate: "<li><a href='#{href}'><span>#{label}</span></a></li>"
	},

	_create: function() {
		this._tabify( true );
	},

	_setOption: function( key, value ) {
		if ( key == "selected" ) {
			if (this.options.collapsible && value == this.options.selected ) {
				return;
			}
			this.select( value );
		} else {
			this.options[ key ] = value;
			this._tabify();
		}
	},

	_tabId: function( a ) {
		return a.title && a.title.replace( /\s/g, "_" ).replace( /[^\w\u00c0-\uFFFF-]/g, "" ) ||
			this.options.idPrefix + getNextTabId();
	},

	_sanitizeSelector: function( hash ) {
		// we need this because an id may contain a ":"
		return hash.replace( /:/g, "\\:" );
	},

	_cookie: function() {
		var cookie = this.cookie ||
			( this.cookie = this.options.cookie.name || "ui-tabs-" + getNextListId() );
		return $.cookie.apply( null, [ cookie ].concat( $.makeArray( arguments ) ) );
	},

	_ui: function( tab, panel ) {
		return {
			tab: tab,
			panel: panel,
			index: this.anchors.index( tab )
		};
	},

	_cleanup: function() {
		// restore all former loading tabs labels
		this.lis.filter( ".ui-state-processing" )
			.removeClass( "ui-state-processing" )
			.find( "span:data(label.tabs)" )
				.each(function() {
					var el = $( this );
					el.html( el.data( "label.tabs" ) ).removeData( "label.tabs" );
				});
	},

	_tabify: function( init ) {
		var self = this,
			o = this.options,
			fragmentId = /^#.+/; // Safari 2 reports '#' for an empty hash

		this.list = this.element.find( "ol,ul" ).eq( 0 );
		this.lis = $( " > li:has(a[href])", this.list );
		this.anchors = this.lis.map(function() {
			return $( "a", this )[ 0 ];
		});
		this.panels = $( [] );

		this.anchors.each(function( i, a ) {
			var href = $( a ).attr( "href" );
			// For dynamically created HTML that contains a hash as href IE < 8 expands
			// such href to the full page url with hash and then misinterprets tab as ajax.
			// Same consideration applies for an added tab with a fragment identifier
			// since a[href=#fragment-identifier] does unexpectedly not match.
			// Thus normalize href attribute...
			var hrefBase = href.split( "#" )[ 0 ],
				baseEl;
			if ( hrefBase && ( hrefBase === location.toString().split( "#" )[ 0 ] ||
					( baseEl = $( "base" )[ 0 ]) && hrefBase === baseEl.href ) ) {
				href = a.hash;
				a.href = href;
			}

			// inline tab
			if ( fragmentId.test( href ) ) {
				self.panels = self.panels.add( self.element.find( self._sanitizeSelector( href ) ) );
			// remote tab
			// prevent loading the page itself if href is just "#"
			} else if ( href && href !== "#" ) {
				// required for restore on destroy
				$.data( a, "href.tabs", href );

				// TODO until #3808 is fixed strip fragment identifier from url
				// (IE fails to load from such url)
				$.data( a, "load.tabs", href.replace( /#.*$/, "" ) );

				var id = self._tabId( a );
				a.href = "#" + id;
				var $panel = self.element.find( "#" + id );
				if ( !$panel.length ) {
					$panel = $( o.panelTemplate )
						.attr( "id", id )
						.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
						.insertAfter( self.panels[ i - 1 ] || self.list );
					$panel.data( "destroy.tabs", true );
				}
				self.panels = self.panels.add( $panel );
			// invalid tab href
			} else {
				o.disabled.push( i );
			}
		});

		// initialization from scratch
		if ( init ) {
			// attach necessary classes for styling
			this.element.addClass( "ui-tabs ui-widget ui-widget-content ui-corner-all" );
			this.list.addClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" );
			this.lis.addClass( "ui-state-default ui-corner-top" );
			this.panels.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" );

			// Selected tab
			// use "selected" option or try to retrieve:
			// 1. from fragment identifier in url
			// 2. from cookie
			// 3. from selected class attribute on <li>
			if ( o.selected === undefined ) {
				if ( location.hash ) {
					this.anchors.each(function( i, a ) {
						if ( a.hash == location.hash ) {
							o.selected = i;
							return false;
						}
					});
				}
				if ( typeof o.selected !== "number" && o.cookie ) {
					o.selected = parseInt( self._cookie(), 10 );
				}
				if ( typeof o.selected !== "number" && this.lis.filter( ".ui-tabs-selected" ).length ) {
					o.selected = this.lis.index( this.lis.filter( ".ui-tabs-selected" ) );
				}
				o.selected = o.selected || ( this.lis.length ? 0 : -1 );
			} else if ( o.selected === null ) { // usage of null is deprecated, TODO remove in next release
				o.selected = -1;
			}

			// sanity check - default to first tab...
			o.selected = ( ( o.selected >= 0 && this.anchors[ o.selected ] ) || o.selected < 0 )
				? o.selected
				: 0;

			// Take disabling tabs via class attribute from HTML
			// into account and update option properly.
			// A selected tab cannot become disabled.
			o.disabled = $.unique( o.disabled.concat(
				$.map( this.lis.filter( ".ui-state-disabled" ), function( n, i ) {
					return self.lis.index( n );
				})
			) ).sort();

			if ( $.inArray( o.selected, o.disabled ) != -1 ) {
				o.disabled.splice( $.inArray( o.selected, o.disabled ), 1 );
			}

			// highlight selected tab
			this.panels.addClass( "ui-tabs-hide" );
			this.lis.removeClass( "ui-tabs-selected ui-state-active" );
			// check for length avoids error when initializing empty list
			if ( o.selected >= 0 && this.anchors.length ) {
				self.element.find( self._sanitizeSelector( self.anchors[ o.selected ].hash ) ).removeClass( "ui-tabs-hide" );
				this.lis.eq( o.selected ).addClass( "ui-tabs-selected ui-state-active" );

				// seems to be expected behavior that the show callback is fired
				self.element.queue( "tabs", function() {
					self._trigger( "show", null,
						self._ui( self.anchors[ o.selected ], self.element.find( self._sanitizeSelector( self.anchors[ o.selected ].hash ) )[ 0 ] ) );
				});

				this.load( o.selected );
			}

			// clean up to avoid memory leaks in certain versions of IE 6
			// TODO: namespace this event
			$( window ).bind( "unload", function() {
				self.lis.add( self.anchors ).unbind( ".tabs" );
				self.lis = self.anchors = self.panels = null;
			});
		// update selected after add/remove
		} else {
			o.selected = this.lis.index( this.lis.filter( ".ui-tabs-selected" ) );
		}

		// update collapsible
		// TODO: use .toggleClass()
		this.element[ o.collapsible ? "addClass" : "removeClass" ]( "ui-tabs-collapsible" );

		// set or update cookie after init and add/remove respectively
		if ( o.cookie ) {
			this._cookie( o.selected, o.cookie );
		}

		// disable tabs
		for ( var i = 0, li; ( li = this.lis[ i ] ); i++ ) {
			$( li )[ $.inArray( i, o.disabled ) != -1 &&
				// TODO: use .toggleClass()
				!$( li ).hasClass( "ui-tabs-selected" ) ? "addClass" : "removeClass" ]( "ui-state-disabled" );
		}

		// reset cache if switching from cached to not cached
		if ( o.cache === false ) {
			this.anchors.removeData( "cache.tabs" );
		}

		// remove all handlers before, tabify may run on existing tabs after add or option change
		this.lis.add( this.anchors ).unbind( ".tabs" );

		if ( o.event !== "mouseover" ) {
			var addState = function( state, el ) {
				if ( el.is( ":not(.ui-state-disabled)" ) ) {
					el.addClass( "ui-state-" + state );
				}
			};
			var removeState = function( state, el ) {
				el.removeClass( "ui-state-" + state );
			};
			this.lis.bind( "mouseover.tabs" , function() {
				addState( "hover", $( this ) );
			});
			this.lis.bind( "mouseout.tabs", function() {
				removeState( "hover", $( this ) );
			});
			this.anchors.bind( "focus.tabs", function() {
				addState( "focus", $( this ).closest( "li" ) );
			});
			this.anchors.bind( "blur.tabs", function() {
				removeState( "focus", $( this ).closest( "li" ) );
			});
		}

		// set up animations
		var hideFx, showFx;
		if ( o.fx ) {
			if ( $.isArray( o.fx ) ) {
				hideFx = o.fx[ 0 ];
				showFx = o.fx[ 1 ];
			} else {
				hideFx = showFx = o.fx;
			}
		}

		// Reset certain styles left over from animation
		// and prevent IE's ClearType bug...
		function resetStyle( $el, fx ) {
			$el.css( "display", "" );
			if ( !$.support.opacity && fx.opacity ) {
				$el[ 0 ].style.removeAttribute( "filter" );
			}
		}

		// Show a tab...
		var showTab = showFx
			? function( clicked, $show ) {
				$( clicked ).closest( "li" ).addClass( "ui-tabs-selected ui-state-active" );
				$show.hide().removeClass( "ui-tabs-hide" ) // avoid flicker that way
					.animate( showFx, showFx.duration || "normal", function() {
						resetStyle( $show, showFx );
						self._trigger( "show", null, self._ui( clicked, $show[ 0 ] ) );
					});
			}
			: function( clicked, $show ) {
				$( clicked ).closest( "li" ).addClass( "ui-tabs-selected ui-state-active" );
				$show.removeClass( "ui-tabs-hide" );
				self._trigger( "show", null, self._ui( clicked, $show[ 0 ] ) );
			};

		// Hide a tab, $show is optional...
		var hideTab = hideFx
			? function( clicked, $hide ) {
				$hide.animate( hideFx, hideFx.duration || "normal", function() {
					self.lis.removeClass( "ui-tabs-selected ui-state-active" );
					$hide.addClass( "ui-tabs-hide" );
					resetStyle( $hide, hideFx );
					self.element.dequeue( "tabs" );
				});
			}
			: function( clicked, $hide, $show ) {
				self.lis.removeClass( "ui-tabs-selected ui-state-active" );
				$hide.addClass( "ui-tabs-hide" );
				self.element.dequeue( "tabs" );
			};

		// attach tab event handler, unbind to avoid duplicates from former tabifying...
		this.anchors.bind( o.event + ".tabs", function() {
			var el = this,
				$li = $(el).closest( "li" ),
				$hide = self.panels.filter( ":not(.ui-tabs-hide)" ),
				$show = self.element.find( self._sanitizeSelector( el.hash ) );

			// If tab is already selected and not collapsible or tab disabled or
			// or is already loading or click callback returns false stop here.
			// Check if click handler returns false last so that it is not executed
			// for a disabled or loading tab!
			if ( ( $li.hasClass( "ui-tabs-selected" ) && !o.collapsible) ||
				$li.hasClass( "ui-state-disabled" ) ||
				$li.hasClass( "ui-state-processing" ) ||
				self.panels.filter( ":animated" ).length ||
				self._trigger( "select", null, self._ui( this, $show[ 0 ] ) ) === false ) {
				this.blur();
				return false;
			}

			o.selected = self.anchors.index( this );

			self.abort();

			// if tab may be closed
			if ( o.collapsible ) {
				if ( $li.hasClass( "ui-tabs-selected" ) ) {
					o.selected = -1;

					if ( o.cookie ) {
						self._cookie( o.selected, o.cookie );
					}

					self.element.queue( "tabs", function() {
						hideTab( el, $hide );
					}).dequeue( "tabs" );

					this.blur();
					return false;
				} else if ( !$hide.length ) {
					if ( o.cookie ) {
						self._cookie( o.selected, o.cookie );
					}

					self.element.queue( "tabs", function() {
						showTab( el, $show );
					});

					// TODO make passing in node possible, see also http://dev.jqueryui.com/ticket/3171
					self.load( self.anchors.index( this ) );

					this.blur();
					return false;
				}
			}

			if ( o.cookie ) {
				self._cookie( o.selected, o.cookie );
			}

			// show new tab
			if ( $show.length ) {
				if ( $hide.length ) {
					self.element.queue( "tabs", function() {
						hideTab( el, $hide );
					});
				}
				self.element.queue( "tabs", function() {
					showTab( el, $show );
				});

				self.load( self.anchors.index( this ) );
			} else {
				throw "jQuery UI Tabs: Mismatching fragment identifier.";
			}

			// Prevent IE from keeping other link focussed when using the back button
			// and remove dotted border from clicked link. This is controlled via CSS
			// in modern browsers; blur() removes focus from address bar in Firefox
			// which can become a usability and annoying problem with tabs('rotate').
			if ( $.browser.msie ) {
				this.blur();
			}
		});

		// disable click in any case
		this.anchors.bind( "click.tabs", function(){
			return false;
		});
	},

    _getIndex: function( index ) {
		// meta-function to give users option to provide a href string instead of a numerical index.
		// also sanitizes numerical indexes to valid values.
		if ( typeof index == "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$=" + index + "]" ) );
		}

		return index;
	},

	destroy: function() {
		var o = this.options;

		this.abort();

		this.element
			.unbind( ".tabs" )
			.removeClass( "ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible" )
			.removeData( "tabs" );

		this.list.removeClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" );

		this.anchors.each(function() {
			var href = $.data( this, "href.tabs" );
			if ( href ) {
				this.href = href;
			}
			var $this = $( this ).unbind( ".tabs" );
			$.each( [ "href", "load", "cache" ], function( i, prefix ) {
				$this.removeData( prefix + ".tabs" );
			});
		});

		this.lis.unbind( ".tabs" ).add( this.panels ).each(function() {
			if ( $.data( this, "destroy.tabs" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeClass([
					"ui-state-default",
					"ui-corner-top",
					"ui-tabs-selected",
					"ui-state-active",
					"ui-state-hover",
					"ui-state-focus",
					"ui-state-disabled",
					"ui-tabs-panel",
					"ui-widget-content",
					"ui-corner-bottom",
					"ui-tabs-hide"
				].join( " " ) );
			}
		});

		if ( o.cookie ) {
			this._cookie( null, o.cookie );
		}

		return this;
	},

	add: function( url, label, index ) {
		if ( index === undefined ) {
			index = this.anchors.length;
		}

		var self = this,
			o = this.options,
			$li = $( o.tabTemplate.replace( /#\{href\}/g, url ).replace( /#\{label\}/g, label ) ),
			id = !url.indexOf( "#" ) ? url.replace( "#", "" ) : this._tabId( $( "a", $li )[ 0 ] );

		$li.addClass( "ui-state-default ui-corner-top" ).data( "destroy.tabs", true );

		// try to find an existing element before creating a new one
		var $panel = self.element.find( "#" + id );
		if ( !$panel.length ) {
			$panel = $( o.panelTemplate )
				.attr( "id", id )
				.data( "destroy.tabs", true );
		}
		$panel.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom ui-tabs-hide" );

		if ( index >= this.lis.length ) {
			$li.appendTo( this.list );
			$panel.appendTo( this.list[ 0 ].parentNode );
		} else {
			$li.insertBefore( this.lis[ index ] );
			$panel.insertBefore( this.panels[ index ] );
		}

		o.disabled = $.map( o.disabled, function( n, i ) {
			return n >= index ? ++n : n;
		});

		this._tabify();

		if ( this.anchors.length == 1 ) {
			o.selected = 0;
			$li.addClass( "ui-tabs-selected ui-state-active" );
			$panel.removeClass( "ui-tabs-hide" );
			this.element.queue( "tabs", function() {
				self._trigger( "show", null, self._ui( self.anchors[ 0 ], self.panels[ 0 ] ) );
			});

			this.load( 0 );
		}

		this._trigger( "add", null, this._ui( this.anchors[ index ], this.panels[ index ] ) );
		return this;
	},

	remove: function( index ) {
		index = this._getIndex( index );
		var o = this.options,
			$li = this.lis.eq( index ).remove(),
			$panel = this.panels.eq( index ).remove();

		// If selected tab was removed focus tab to the right or
		// in case the last tab was removed the tab to the left.
		if ( $li.hasClass( "ui-tabs-selected" ) && this.anchors.length > 1) {
			this.select( index + ( index + 1 < this.anchors.length ? 1 : -1 ) );
		}

		o.disabled = $.map(
			$.grep( o.disabled, function(n, i) {
				return n != index;
			}),
			function( n, i ) {
				return n >= index ? --n : n;
			});

		this._tabify();

		this._trigger( "remove", null, this._ui( $li.find( "a" )[ 0 ], $panel[ 0 ] ) );
		return this;
	},

	enable: function( index ) {
		index = this._getIndex( index );
		var o = this.options;
		if ( $.inArray( index, o.disabled ) == -1 ) {
			return;
		}

		this.lis.eq( index ).removeClass( "ui-state-disabled" );
		o.disabled = $.grep( o.disabled, function( n, i ) {
			return n != index;
		});

		this._trigger( "enable", null, this._ui( this.anchors[ index ], this.panels[ index ] ) );
		return this;
	},

	disable: function( index ) {
		index = this._getIndex( index );
		var self = this, o = this.options;
		// cannot disable already selected tab
		if ( index != o.selected ) {
			this.lis.eq( index ).addClass( "ui-state-disabled" );

			o.disabled.push( index );
			o.disabled.sort();

			this._trigger( "disable", null, this._ui( this.anchors[ index ], this.panels[ index ] ) );
		}

		return this;
	},

	select: function( index ) {
		index = this._getIndex( index );
		if ( index == -1 ) {
			if ( this.options.collapsible && this.options.selected != -1 ) {
				index = this.options.selected;
			} else {
				return this;
			}
		}
		this.anchors.eq( index ).trigger( this.options.event + ".tabs" );
		return this;
	},

	load: function( index ) {
		index = this._getIndex( index );
		var self = this,
			o = this.options,
			a = this.anchors.eq( index )[ 0 ],
			url = $.data( a, "load.tabs" );

		this.abort();

		// not remote or from cache
		if ( !url || this.element.queue( "tabs" ).length !== 0 && $.data( a, "cache.tabs" ) ) {
			this.element.dequeue( "tabs" );
			return;
		}

		// load remote from here on
		this.lis.eq( index ).addClass( "ui-state-processing" );

		if ( o.spinner ) {
			var span = $( "span", a );
			span.data( "label.tabs", span.html() ).html( o.spinner );
		}

		this.xhr = $.ajax( $.extend( {}, o.ajaxOptions, {
			url: url,
			success: function( r, s ) {
				self.element.find( self._sanitizeSelector( a.hash ) ).html( r );

				// take care of tab labels
				self._cleanup();

				if ( o.cache ) {
					$.data( a, "cache.tabs", true );
				}

				self._trigger( "load", null, self._ui( self.anchors[ index ], self.panels[ index ] ) );
				try {
					o.ajaxOptions.success( r, s );
				}
				catch ( e ) {}
			},
			error: function( xhr, s, e ) {
				// take care of tab labels
				self._cleanup();

				self._trigger( "load", null, self._ui( self.anchors[ index ], self.panels[ index ] ) );
				try {
					// Passing index avoid a race condition when this method is
					// called after the user has selected another tab.
					// Pass the anchor that initiated this request allows
					// loadError to manipulate the tab content panel via $(a.hash)
					o.ajaxOptions.error( xhr, s, index, a );
				}
				catch ( e ) {}
			}
		} ) );

		// last, so that load event is fired before show...
		self.element.dequeue( "tabs" );

		return this;
	},

	abort: function() {
		// stop possibly running animations
		this.element.queue( [] );
		this.panels.stop( false, true );

		// "tabs" queue must not contain more than two elements,
		// which are the callbacks for the latest clicked tab...
		this.element.queue( "tabs", this.element.queue( "tabs" ).splice( -2, 2 ) );

		// terminate pending requests from other tabs
		if ( this.xhr ) {
			this.xhr.abort();
			delete this.xhr;
		}

		// take care of tab labels
		this._cleanup();
		return this;
	},

	url: function( index, url ) {
		this.anchors.eq( index ).removeData( "cache.tabs" ).data( "load.tabs", url );
		return this;
	},

	length: function() {
		return this.anchors.length;
	}
});

$.extend( $.ui.tabs, {
	version: "1.8.18"
});

/*
 * Tabs Extensions
 */

/*
 * Rotate
 */
$.extend( $.ui.tabs.prototype, {
	rotation: null,
	rotate: function( ms, continuing ) {
		var self = this,
			o = this.options;

		var rotate = self._rotate || ( self._rotate = function( e ) {
			clearTimeout( self.rotation );
			self.rotation = setTimeout(function() {
				var t = o.selected;
				self.select( ++t < self.anchors.length ? t : 0 );
			}, ms );
			
			if ( e ) {
				e.stopPropagation();
			}
		});

		var stop = self._unrotate || ( self._unrotate = !continuing
			? function(e) {
				if (e.clientX) { // in case of a true click
					self.rotate(null);
				}
			}
			: function( e ) {
				t = o.selected;
				rotate();
			});

		// start rotation
		if ( ms ) {
			this.element.bind( "tabsshow", rotate );
			this.anchors.bind( o.event + ".tabs", stop );
			rotate();
		// stop rotation
		} else {
			clearTimeout( self.rotation );
			this.element.unbind( "tabsshow", rotate );
			this.anchors.unbind( o.event + ".tabs", stop );
			delete this._rotate;
			delete this._unrotate;
		}

		return this;
	}
});

})( jQuery );

define("jquery-ui-plugins", ["jquery","css!jquery-ui-custom-css"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.tabs;
    };
}(this)));

/* Afrikaans initialisation for the jQuery UI date picker plugin. */
/* Written by Renier Pretorius. */
jQuery(function($){
	$.datepicker.regional['af'] = {
		closeText: 'Selekteer',
		prevText: 'Vorige',
		nextText: 'Volgende',
		currentText: 'Vandag',
		monthNames: ['Januarie','Februarie','Maart','April','Mei','Junie',
		'Julie','Augustus','September','Oktober','November','Desember'],
		monthNamesShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun',
		'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
		dayNames: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag'],
		dayNamesShort: ['Son', 'Maa', 'Din', 'Woe', 'Don', 'Vry', 'Sat'],
		dayNamesMin: ['So','Ma','Di','Wo','Do','Vr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['af']);
});
/* Algerian Arabic Translation for jQuery UI date picker plugin. (can be used for Tunisia)*/
/* Mohamed Cherif BOUCHELAGHEM -- cherifbouchelaghem@yahoo.fr */

jQuery(function($){
	$.datepicker.regional['ar-DZ'] = {
		closeText: 'إغلاق',
		prevText: '&#x3c;السابق',
		nextText: 'التالي&#x3e;',
		currentText: 'اليوم',
		monthNames: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان',
		'جويلية', 'أوت', 'سبتمبر','أكتوبر', 'نوفمبر', 'ديسمبر'],
		monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
		dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		dayNamesShort: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		dayNamesMin: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		weekHeader: 'أسبوع',
		dateFormat: 'dd/mm/yy',
		firstDay: 6,
  		isRTL: true,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ar-DZ']);
});
/* Arabic Translation for jQuery UI date picker plugin. */
/* Khaled Alhourani -- me@khaledalhourani.com */
/* NOTE: monthNames are the original months names and they are the Arabic names, not the new months name فبراير - يناير and there isn't any Arabic roots for these months */
jQuery(function($){
	$.datepicker.regional['ar'] = {
		closeText: 'إغلاق',
		prevText: '&#x3c;السابق',
		nextText: 'التالي&#x3e;',
		currentText: 'اليوم',
		monthNames: ['كانون الثاني', 'شباط', 'آذار', 'نيسان', 'مايو', 'حزيران',
		'تموز', 'آب', 'أيلول',	'تشرين الأول', 'تشرين الثاني', 'كانون الأول'],
		monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
		dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		dayNamesShort: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		dayNamesMin: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
		weekHeader: 'أسبوع',
		dateFormat: 'dd/mm/yy',
		firstDay: 6,
  		isRTL: true,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ar']);
});/* Azerbaijani (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Jamil Najafov (necefov33@gmail.com). */
jQuery(function($) {
	$.datepicker.regional['az'] = {
		closeText: 'Bağla',
		prevText: '&#x3c;Geri',
		nextText: 'İrəli&#x3e;',
		currentText: 'Bugün',
		monthNames: ['Yanvar','Fevral','Mart','Aprel','May','İyun',
		'İyul','Avqust','Sentyabr','Oktyabr','Noyabr','Dekabr'],
		monthNamesShort: ['Yan','Fev','Mar','Apr','May','İyun',
		'İyul','Avq','Sen','Okt','Noy','Dek'],
		dayNames: ['Bazar','Bazar ertəsi','Çərşənbə axşamı','Çərşənbə','Cümə axşamı','Cümə','Şənbə'],
		dayNamesShort: ['B','Be','Ça','Ç','Ca','C','Ş'],
		dayNamesMin: ['B','B','Ç','С','Ç','C','Ş'],
		weekHeader: 'Hf',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['az']);
});/* Bulgarian initialisation for the jQuery UI date picker plugin. */
/* Written by Stoyan Kyosev (http://svest.org). */
jQuery(function($){
    $.datepicker.regional['bg'] = {
        closeText: 'затвори',
        prevText: '&#x3c;назад',
        nextText: 'напред&#x3e;',
		nextBigText: '&#x3e;&#x3e;',
        currentText: 'днес',
        monthNames: ['Януари','Февруари','Март','Април','Май','Юни',
        'Юли','Август','Септември','Октомври','Ноември','Декември'],
        monthNamesShort: ['Яну','Фев','Мар','Апр','Май','Юни',
        'Юли','Авг','Сеп','Окт','Нов','Дек'],
        dayNames: ['Неделя','Понеделник','Вторник','Сряда','Четвъртък','Петък','Събота'],
        dayNamesShort: ['Нед','Пон','Вто','Сря','Чет','Пет','Съб'],
        dayNamesMin: ['Не','По','Вт','Ср','Че','Пе','Съ'],
		weekHeader: 'Wk',
        dateFormat: 'dd.mm.yy',
		firstDay: 1,
        isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
    $.datepicker.setDefaults($.datepicker.regional['bg']);
});
/* Bosnian i18n for the jQuery UI date picker plugin. */
/* Written by Kenan Konjo. */
jQuery(function($){
	$.datepicker.regional['bs'] = {
		closeText: 'Zatvori', 
		prevText: '&#x3c;', 
		nextText: '&#x3e;', 
		currentText: 'Danas', 
		monthNames: ['Januar','Februar','Mart','April','Maj','Juni',
		'Juli','August','Septembar','Oktobar','Novembar','Decembar'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
		'Jul','Aug','Sep','Okt','Nov','Dec'],
		dayNames: ['Nedelja','Ponedeljak','Utorak','Srijeda','Četvrtak','Petak','Subota'],
		dayNamesShort: ['Ned','Pon','Uto','Sri','Čet','Pet','Sub'],
		dayNamesMin: ['Ne','Po','Ut','Sr','Če','Pe','Su'],
		weekHeader: 'Wk',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['bs']);
});/* Inicialització en català per a l'extenció 'calendar' per jQuery. */
/* Writers: (joan.leon@gmail.com). */
jQuery(function($){
	$.datepicker.regional['ca'] = {
		closeText: 'Tancar',
		prevText: '&#x3c;Ant',
		nextText: 'Seg&#x3e;',
		currentText: 'Avui',
		monthNames: ['Gener','Febrer','Mar&ccedil;','Abril','Maig','Juny',
		'Juliol','Agost','Setembre','Octubre','Novembre','Desembre'],
		monthNamesShort: ['Gen','Feb','Mar','Abr','Mai','Jun',
		'Jul','Ago','Set','Oct','Nov','Des'],
		dayNames: ['Diumenge','Dilluns','Dimarts','Dimecres','Dijous','Divendres','Dissabte'],
		dayNamesShort: ['Dug','Dln','Dmt','Dmc','Djs','Dvn','Dsb'],
		dayNamesMin: ['Dg','Dl','Dt','Dc','Dj','Dv','Ds'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ca']);
});/* Czech initialisation for the jQuery UI date picker plugin. */
/* Written by Tomas Muller (tomas@tomas-muller.net). */
jQuery(function($){
	$.datepicker.regional['cs'] = {
		closeText: 'Zavřít',
		prevText: '&#x3c;Dříve',
		nextText: 'Později&#x3e;',
		currentText: 'Nyní',
		monthNames: ['leden','únor','březen','duben','květen','červen',
        'červenec','srpen','září','říjen','listopad','prosinec'],
		monthNamesShort: ['led','úno','bře','dub','kvě','čer',
		'čvc','srp','zář','říj','lis','pro'],
		dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
		dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
		dayNamesMin: ['ne','po','út','st','čt','pá','so'],
		weekHeader: 'Týd',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['cs']);
});
/* Welsh/UK initialisation for the jQuery UI date picker plugin. */
/* Written by William Griffiths. */
jQuery(function($){
	$.datepicker.regional['cy-GB'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['Ionawr','Chwefror','Mawrth','Ebrill','Mai','Mehefin',
		'Gorffennaf','Awst','Medi','Hydref','Tachwedd','Rhagfyr'],
		monthNamesShort: ['Ion', 'Chw', 'Maw', 'Ebr', 'Mai', 'Meh',
		'Gor', 'Aws', 'Med', 'Hyd', 'Tac', 'Rha'],
		dayNames: ['Dydd Sul', 'Dydd Llun', 'Dydd Mawrth', 'Dydd Mercher', 'Dydd Iau', 'Dydd Gwener', 'Dydd Sadwrn'],
		dayNamesShort: ['Sul', 'Llu', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
		dayNamesMin: ['Su','Ll','Ma','Me','Ia','Gw','Sa'],
		weekHeader: 'Wy',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['cy-GB']);
});/* Danish initialisation for the jQuery UI date picker plugin. */
/* Written by Jan Christensen ( deletestuff@gmail.com). */
jQuery(function($){
    $.datepicker.regional['da'] = {
		closeText: 'Luk',
        prevText: '&#x3c;Forrige',
		nextText: 'Næste&#x3e;',
		currentText: 'Idag',
        monthNames: ['Januar','Februar','Marts','April','Maj','Juni',
        'Juli','August','September','Oktober','November','December'],
        monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
        'Jul','Aug','Sep','Okt','Nov','Dec'],
		dayNames: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
		dayNamesShort: ['Søn','Man','Tir','Ons','Tor','Fre','Lør'],
		dayNamesMin: ['Sø','Ma','Ti','On','To','Fr','Lø'],
		weekHeader: 'Uge',
        dateFormat: 'dd-mm-yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
    $.datepicker.setDefaults($.datepicker.regional['da']);
});
/* German initialisation for the jQuery UI date picker plugin. */
/* Written by Milian Wolff (mail@milianw.de). */
jQuery(function($){
	$.datepicker.regional['de'] = {
		closeText: 'schließen',
		prevText: '&#x3c;zurück',
		nextText: 'Vor&#x3e;',
		currentText: 'heute',
		monthNames: ['Januar','Februar','März','April','Mai','Juni',
		'Juli','August','September','Oktober','November','Dezember'],
		monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun',
		'Jul','Aug','Sep','Okt','Nov','Dez'],
		dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
		dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
		dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
		weekHeader: 'Wo',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['de']);
});
/* Greek (el) initialisation for the jQuery UI date picker plugin. */
/* Written by Alex Cicovic (http://www.alexcicovic.com) */
jQuery(function($){
	$.datepicker.regional['el'] = {
		closeText: 'Κλείσιμο',
		prevText: 'Προηγούμενος',
		nextText: 'Επόμενος',
		currentText: 'Τρέχων Μήνας',
		monthNames: ['Ιανουάριος','Φεβρουάριος','Μάρτιος','Απρίλιος','Μάιος','Ιούνιος',
		'Ιούλιος','Αύγουστος','Σεπτέμβριος','Οκτώβριος','Νοέμβριος','Δεκέμβριος'],
		monthNamesShort: ['Ιαν','Φεβ','Μαρ','Απρ','Μαι','Ιουν',
		'Ιουλ','Αυγ','Σεπ','Οκτ','Νοε','Δεκ'],
		dayNames: ['Κυριακή','Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο'],
		dayNamesShort: ['Κυρ','Δευ','Τρι','Τετ','Πεμ','Παρ','Σαβ'],
		dayNamesMin: ['Κυ','Δε','Τρ','Τε','Πε','Πα','Σα'],
		weekHeader: 'Εβδ',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['el']);
});/* English/Australia initialisation for the jQuery UI date picker plugin. */
/* Based on the en-GB initialisation. */
jQuery(function($){
	$.datepicker.regional['en-AU'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['January','February','March','April','May','June',
		'July','August','September','October','November','December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['en-AU']);
});
/* USA English */
jQuery(function($){
	$.datepicker.regional['en'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['January','February','March','April','May','June',
		'July','August','September','October','November','December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['en-AU']);
});
/* English/UK initialisation for the jQuery UI date picker plugin. */
/* Written by Stuart. */
jQuery(function($){
	$.datepicker.regional['en-GB'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['January','February','March','April','May','June',
		'July','August','September','October','November','December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['en-GB']);
});
/* English/New Zealand initialisation for the jQuery UI date picker plugin. */
/* Based on the en-GB initialisation. */
jQuery(function($){
	$.datepicker.regional['en-NZ'] = {
		closeText: 'Done',
		prevText: 'Prev',
		nextText: 'Next',
		currentText: 'Today',
		monthNames: ['January','February','March','April','May','June',
		'July','August','September','October','November','December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['en-NZ']);
});
/* Esperanto initialisation for the jQuery UI date picker plugin. */
/* Written by Olivier M. (olivierweb@ifrance.com). */
jQuery(function($){
	$.datepicker.regional['eo'] = {
		closeText: 'Fermi',
		prevText: '&lt;Anta',
		nextText: 'Sekv&gt;',
		currentText: 'Nuna',
		monthNames: ['Januaro','Februaro','Marto','Aprilo','Majo','Junio',
		'Julio','Aŭgusto','Septembro','Oktobro','Novembro','Decembro'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
		'Jul','Aŭg','Sep','Okt','Nov','Dec'],
		dayNames: ['Dimanĉo','Lundo','Mardo','Merkredo','Ĵaŭdo','Vendredo','Sabato'],
		dayNamesShort: ['Dim','Lun','Mar','Mer','Ĵaŭ','Ven','Sab'],
		dayNamesMin: ['Di','Lu','Ma','Me','Ĵa','Ve','Sa'],
		weekHeader: 'Sb',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['eo']);
});
/* Inicialización en español para la extensión 'UI date picker' para jQuery. */
/* Traducido por Vester (xvester@gmail.com). */
jQuery(function($){
	$.datepicker.regional['es'] = {
		closeText: 'Cerrar',
		prevText: '&#x3c;Ant',
		nextText: 'Sig&#x3e;',
		currentText: 'Hoy',
		monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
		'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
		monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun',
		'Jul','Ago','Sep','Oct','Nov','Dic'],
		dayNames: ['Domingo','Lunes','Martes','Mi&eacute;rcoles','Jueves','Viernes','S&aacute;bado'],
		dayNamesShort: ['Dom','Lun','Mar','Mi&eacute;','Juv','Vie','S&aacute;b'],
		dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','S&aacute;'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['es']);
});/* Estonian initialisation for the jQuery UI date picker plugin. */
/* Written by Mart Sõmermaa (mrts.pydev at gmail com). */
jQuery(function($){
	$.datepicker.regional['et'] = {
		closeText: 'Sulge',
		prevText: 'Eelnev',
		nextText: 'Järgnev',
		currentText: 'Täna',
		monthNames: ['Jaanuar','Veebruar','Märts','Aprill','Mai','Juuni',
		'Juuli','August','September','Oktoober','November','Detsember'],
		monthNamesShort: ['Jaan', 'Veebr', 'Märts', 'Apr', 'Mai', 'Juuni',
		'Juuli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dets'],
		dayNames: ['Pühapäev', 'Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev'],
		dayNamesShort: ['Pühap', 'Esmasp', 'Teisip', 'Kolmap', 'Neljap', 'Reede', 'Laup'],
		dayNamesMin: ['P','E','T','K','N','R','L'],
		weekHeader: 'Sm',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['et']);
}); /* Euskarako oinarria 'UI date picker' jquery-ko extentsioarentzat */
/* Karrikas-ek itzulia (karrikas@karrikas.com) */
jQuery(function($){
	$.datepicker.regional['eu'] = {
		closeText: 'Egina',
		prevText: '&#x3c;Aur',
		nextText: 'Hur&#x3e;',
		currentText: 'Gaur',
		monthNames: ['Urtarrila','Otsaila','Martxoa','Apirila','Maiatza','Ekaina',
		'Uztaila','Abuztua','Iraila','Urria','Azaroa','Abendua'],
		monthNamesShort: ['Urt','Ots','Mar','Api','Mai','Eka',
		'Uzt','Abu','Ira','Urr','Aza','Abe'],
		dayNames: ['Igandea','Astelehena','Asteartea','Asteazkena','Osteguna','Ostirala','Larunbata'],
		dayNamesShort: ['Iga','Ast','Ast','Ast','Ost','Ost','Lar'],
		dayNamesMin: ['Ig','As','As','As','Os','Os','La'],
		weekHeader: 'Wk',
		dateFormat: 'yy/mm/dd',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['eu']);
});/* Persian (Farsi) Translation for the jQuery UI date picker plugin. */
/* Javad Mowlanezhad -- jmowla@gmail.com */
/* Jalali calendar should supported soon! (Its implemented but I have to test it) */
jQuery(function($) {
	$.datepicker.regional['fa'] = {
		closeText: 'بستن',
		prevText: '&#x3c;قبلي',
		nextText: 'بعدي&#x3e;',
		currentText: 'امروز',
		monthNames: ['فروردين','ارديبهشت','خرداد','تير','مرداد','شهريور',
		'مهر','آبان','آذر','دي','بهمن','اسفند'],
		monthNamesShort: ['1','2','3','4','5','6','7','8','9','10','11','12'],
		dayNames: ['يکشنبه','دوشنبه','سه‌شنبه','چهارشنبه','پنجشنبه','جمعه','شنبه'],
		dayNamesShort: ['ي','د','س','چ','پ','ج', 'ش'],
		dayNamesMin: ['ي','د','س','چ','پ','ج', 'ش'],
		weekHeader: 'هف',
		dateFormat: 'yy/mm/dd',
		firstDay: 6,
		isRTL: true,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['fa']);
});/* Finnish initialisation for the jQuery UI date picker plugin. */
/* Written by Harri Kilpi� (harrikilpio@gmail.com). */
jQuery(function($){
    $.datepicker.regional['fi'] = {
		closeText: 'Sulje',
		prevText: '&laquo;Edellinen',
		nextText: 'Seuraava&raquo;',
		currentText: 'T&auml;n&auml;&auml;n',
        monthNames: ['Tammikuu','Helmikuu','Maaliskuu','Huhtikuu','Toukokuu','Kes&auml;kuu',
        'Hein&auml;kuu','Elokuu','Syyskuu','Lokakuu','Marraskuu','Joulukuu'],
        monthNamesShort: ['Tammi','Helmi','Maalis','Huhti','Touko','Kes&auml;',
        'Hein&auml;','Elo','Syys','Loka','Marras','Joulu'],
		dayNamesShort: ['Su','Ma','Ti','Ke','To','Pe','Su'],
		dayNames: ['Sunnuntai','Maanantai','Tiistai','Keskiviikko','Torstai','Perjantai','Lauantai'],
		dayNamesMin: ['Su','Ma','Ti','Ke','To','Pe','La'],
		weekHeader: 'Vk',
        dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
    $.datepicker.setDefaults($.datepicker.regional['fi']);
});
/* Faroese initialisation for the jQuery UI date picker plugin */
/* Written by Sverri Mohr Olsen, sverrimo@gmail.com */
jQuery(function($){
	$.datepicker.regional['fo'] = {
		closeText: 'Lat aftur',
		prevText: '&#x3c;Fyrra',
		nextText: 'Næsta&#x3e;',
		currentText: 'Í dag',
		monthNames: ['Januar','Februar','Mars','Apríl','Mei','Juni',
		'Juli','August','September','Oktober','November','Desember'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Mei','Jun',
		'Jul','Aug','Sep','Okt','Nov','Des'],
		dayNames: ['Sunnudagur','Mánadagur','Týsdagur','Mikudagur','Hósdagur','Fríggjadagur','Leyardagur'],
		dayNamesShort: ['Sun','Mán','Týs','Mik','Hós','Frí','Ley'],
		dayNamesMin: ['Su','Má','Tý','Mi','Hó','Fr','Le'],
		weekHeader: 'Vk',
		dateFormat: 'dd-mm-yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['fo']);
});
/* Swiss-French initialisation for the jQuery UI date picker plugin. */
/* Written Martin Voelkle (martin.voelkle@e-tc.ch). */
jQuery(function($){
	$.datepicker.regional['fr-CH'] = {
		closeText: 'Fermer',
		prevText: '&#x3c;Préc',
		nextText: 'Suiv&#x3e;',
		currentText: 'Courant',
		monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin',
		'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
		monthNamesShort: ['Jan','Fév','Mar','Avr','Mai','Jun',
		'Jul','Aoû','Sep','Oct','Nov','Déc'],
		dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
		dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
		dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
		weekHeader: 'Sm',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['fr-CH']);
});/* French initialisation for the jQuery UI date picker plugin. */
/* Written by Keith Wood (kbwood{at}iinet.com.au),
              Stéphane Nahmani (sholby@sholby.net),
              Stéphane Raimbault <stephane.raimbault@gmail.com> */
jQuery(function($){
	$.datepicker.regional['fr'] = {
		closeText: 'Fermer',
		prevText: 'Précédent',
		nextText: 'Suivant',
		currentText: 'Aujourd\'hui',
		monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin',
		'Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
		monthNamesShort: ['Janv.','Févr.','Mars','Avril','Mai','Juin',
		'Juil.','Août','Sept.','Oct.','Nov.','Déc.'],
		dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
		dayNamesShort: ['Dim.','Lun.','Mar.','Mer.','Jeu.','Ven.','Sam.'],
		dayNamesMin: ['D','L','M','M','J','V','S'],
		weekHeader: 'Sem.',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['fr']);
});
/* Galician localization for 'UI date picker' jQuery extension. */
/* Translated by Jorge Barreiro <yortx.barry@gmail.com>. */
jQuery(function($){
	$.datepicker.regional['gl'] = {
		closeText: 'Pechar',
		prevText: '&#x3c;Ant',
		nextText: 'Seg&#x3e;',
		currentText: 'Hoxe',
		monthNames: ['Xaneiro','Febreiro','Marzo','Abril','Maio','Xuño',
		'Xullo','Agosto','Setembro','Outubro','Novembro','Decembro'],
		monthNamesShort: ['Xan','Feb','Mar','Abr','Mai','Xuñ',
		'Xul','Ago','Set','Out','Nov','Dec'],
		dayNames: ['Domingo','Luns','Martes','M&eacute;rcores','Xoves','Venres','S&aacute;bado'],
		dayNamesShort: ['Dom','Lun','Mar','M&eacute;r','Xov','Ven','S&aacute;b'],
		dayNamesMin: ['Do','Lu','Ma','M&eacute;','Xo','Ve','S&aacute;'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['gl']);
});/* Hebrew initialisation for the UI Datepicker extension. */
/* Written by Amir Hardon (ahardon at gmail dot com). */
jQuery(function($){
	$.datepicker.regional['he'] = {
		closeText: 'סגור',
		prevText: '&#x3c;הקודם',
		nextText: 'הבא&#x3e;',
		currentText: 'היום',
		monthNames: ['ינואר','פברואר','מרץ','אפריל','מאי','יוני',
		'יולי','אוגוסט','ספטמבר','אוקטובר','נובמבר','דצמבר'],
		monthNamesShort: ['ינו','פבר','מרץ','אפר','מאי','יוני',
		'יולי','אוג','ספט','אוק','נוב','דצמ'],
		dayNames: ['ראשון','שני','שלישי','רביעי','חמישי','שישי','שבת'],
		dayNamesShort: ['א\'','ב\'','ג\'','ד\'','ה\'','ו\'','שבת'],
		dayNamesMin: ['א\'','ב\'','ג\'','ד\'','ה\'','ו\'','שבת'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: true,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['he']);
});
/* Hindi initialisation for the jQuery UI date picker plugin. */
/* Written by Michael Dawart. */
jQuery(function($){
	$.datepicker.regional['hi'] = {
		closeText: 'होकर',
		prevText: 'अगला',
		nextText: 'नेक्स्ट',
		currentText: 'आज',
		monthNames: ['जनवरी ','फरवरी','मार्च','अप्रेल','मै','जून',
		'जूलाई','अगस्त ','सितम्बर','आक्टोबर','नवम्बर','दिसम्बर'],
		monthNamesShort: ['जन', 'फर', 'मार्च', 'अप्रेल', 'मै', 'जून',
		'जूलाई', 'अग', 'सित', 'आक्ट', 'नव', 'िद'],
		dayNames: ['रविवासर', 'सोमवासर', 'मंगलवासर', 'बुधवासर', 'गुरुवासर', 'शुक्रवासर', 'शनिवासर'],
		dayNamesShort: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
		dayNamesMin: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
		weekHeader: 'हफ्ता',
		dateFormat: 'mm/dd/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['hi']);
});
/* Croatian i18n for the jQuery UI date picker plugin. */
/* Written by Vjekoslav Nesek. */
jQuery(function($){
	$.datepicker.regional['hr'] = {
		closeText: 'Zatvori',
		prevText: '&#x3c;',
		nextText: '&#x3e;',
		currentText: 'Danas',
		monthNames: ['Siječanj','Veljača','Ožujak','Travanj','Svibanj','Lipanj',
		'Srpanj','Kolovoz','Rujan','Listopad','Studeni','Prosinac'],
		monthNamesShort: ['Sij','Velj','Ožu','Tra','Svi','Lip',
		'Srp','Kol','Ruj','Lis','Stu','Pro'],
		dayNames: ['Nedjelja','Ponedjeljak','Utorak','Srijeda','Četvrtak','Petak','Subota'],
		dayNamesShort: ['Ned','Pon','Uto','Sri','Čet','Pet','Sub'],
		dayNamesMin: ['Ne','Po','Ut','Sr','Če','Pe','Su'],
		weekHeader: 'Tje',
		dateFormat: 'dd.mm.yy.',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['hr']);
});/* Hungarian initialisation for the jQuery UI date picker plugin. */
/* Written by Istvan Karaszi (jquery@spam.raszi.hu). */
jQuery(function($){
	$.datepicker.regional['hu'] = {
		closeText: 'bezár',
		prevText: 'vissza',
		nextText: 'előre',
		currentText: 'ma',
		monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június',
		'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
		monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún',
		'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
		dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
		dayNamesShort: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
		dayNamesMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
		weekHeader: 'Hét',
		dateFormat: 'yy.mm.dd.',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['hu']);
});
/* Armenian(UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Levon Zakaryan (levon.zakaryan@gmail.com)*/
jQuery(function($){
	$.datepicker.regional['hy'] = {
		closeText: 'Փակել',
		prevText: '&#x3c;Նախ.',
		nextText: 'Հաջ.&#x3e;',
		currentText: 'Այսօր',
		monthNames: ['Հունվար','Փետրվար','Մարտ','Ապրիլ','Մայիս','Հունիս',
		'Հուլիս','Օգոստոս','Սեպտեմբեր','Հոկտեմբեր','Նոյեմբեր','Դեկտեմբեր'],
		monthNamesShort: ['Հունվ','Փետր','Մարտ','Ապր','Մայիս','Հունիս',
		'Հուլ','Օգս','Սեպ','Հոկ','Նոյ','Դեկ'],
		dayNames: ['կիրակի','եկուշաբթի','երեքշաբթի','չորեքշաբթի','հինգշաբթի','ուրբաթ','շաբաթ'],
		dayNamesShort: ['կիր','երկ','երք','չրք','հնգ','ուրբ','շբթ'],
		dayNamesMin: ['կիր','երկ','երք','չրք','հնգ','ուրբ','շբթ'],
		weekHeader: 'ՇԲՏ',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['hy']);
});/* Indonesian initialisation for the jQuery UI date picker plugin. */
/* Written by Deden Fathurahman (dedenf@gmail.com). */
jQuery(function($){
	$.datepicker.regional['id'] = {
		closeText: 'Tutup',
		prevText: '&#x3c;mundur',
		nextText: 'maju&#x3e;',
		currentText: 'hari ini',
		monthNames: ['Januari','Februari','Maret','April','Mei','Juni',
		'Juli','Agustus','September','Oktober','Nopember','Desember'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Mei','Jun',
		'Jul','Agus','Sep','Okt','Nop','Des'],
		dayNames: ['Minggu','Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'],
		dayNamesShort: ['Min','Sen','Sel','Rab','kam','Jum','Sab'],
		dayNamesMin: ['Mg','Sn','Sl','Rb','Km','jm','Sb'],
		weekHeader: 'Mg',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['id']);
});/* Icelandic initialisation for the jQuery UI date picker plugin. */
/* Written by Haukur H. Thorsson (haukur@eskill.is). */
jQuery(function($){
	$.datepicker.regional['is'] = {
		closeText: 'Loka',
		prevText: '&#x3c; Fyrri',
		nextText: 'N&aelig;sti &#x3e;',
		currentText: '&Iacute; dag',
		monthNames: ['Jan&uacute;ar','Febr&uacute;ar','Mars','Apr&iacute;l','Ma&iacute','J&uacute;n&iacute;',
		'J&uacute;l&iacute;','&Aacute;g&uacute;st','September','Okt&oacute;ber','N&oacute;vember','Desember'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Ma&iacute;','J&uacute;n',
		'J&uacute;l','&Aacute;g&uacute;','Sep','Okt','N&oacute;v','Des'],
		dayNames: ['Sunnudagur','M&aacute;nudagur','&THORN;ri&eth;judagur','Mi&eth;vikudagur','Fimmtudagur','F&ouml;studagur','Laugardagur'],
		dayNamesShort: ['Sun','M&aacute;n','&THORN;ri','Mi&eth;','Fim','F&ouml;s','Lau'],
		dayNamesMin: ['Su','M&aacute;','&THORN;r','Mi','Fi','F&ouml;','La'],
		weekHeader: 'Vika',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['is']);
});/* Italian initialisation for the jQuery UI date picker plugin. */
/* Written by Antonello Pasella (antonello.pasella@gmail.com). */
jQuery(function($){
	$.datepicker.regional['it'] = {
		closeText: 'Chiudi',
		prevText: '&#x3c;Prec',
		nextText: 'Succ&#x3e;',
		currentText: 'Oggi',
		monthNames: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
			'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
		monthNamesShort: ['Gen','Feb','Mar','Apr','Mag','Giu',
			'Lug','Ago','Set','Ott','Nov','Dic'],
		dayNames: ['Domenica','Luned&#236','Marted&#236','Mercoled&#236','Gioved&#236','Venerd&#236','Sabato'],
		dayNamesShort: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],
		dayNamesMin: ['Do','Lu','Ma','Me','Gi','Ve','Sa'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['it']);
});
/* Japanese initialisation for the jQuery UI date picker plugin. */
/* Written by Kentaro SATO (kentaro@ranvis.com). */
jQuery(function($){
	$.datepicker.regional['ja'] = {
		closeText: '閉じる',
		prevText: '&#x3c;前',
		nextText: '次&#x3e;',
		currentText: '今日',
		monthNames: ['1月','2月','3月','4月','5月','6月',
		'7月','8月','9月','10月','11月','12月'],
		monthNamesShort: ['1月','2月','3月','4月','5月','6月',
		'7月','8月','9月','10月','11月','12月'],
		dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
		dayNamesShort: ['日','月','火','水','木','金','土'],
		dayNamesMin: ['日','月','火','水','木','金','土'],
		weekHeader: '週',
		dateFormat: 'yy/mm/dd',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: '年'};
	$.datepicker.setDefaults($.datepicker.regional['ja']);
});/* Kazakh (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Dmitriy Karasyov (dmitriy.karasyov@gmail.com). */
jQuery(function($){
	$.datepicker.regional['kk'] = {
		closeText: 'Жабу',
		prevText: '&#x3c;Алдыңғы',
		nextText: 'Келесі&#x3e;',
		currentText: 'Бүгін',
		monthNames: ['Қаңтар','Ақпан','Наурыз','Сәуір','Мамыр','Маусым',
		'Шілде','Тамыз','Қыркүйек','Қазан','Қараша','Желтоқсан'],
		monthNamesShort: ['Қаң','Ақп','Нау','Сәу','Мам','Мау',
		'Шіл','Там','Қыр','Қаз','Қар','Жел'],
		dayNames: ['Жексенбі','Дүйсенбі','Сейсенбі','Сәрсенбі','Бейсенбі','Жұма','Сенбі'],
		dayNamesShort: ['жкс','дсн','ссн','срс','бсн','жма','снб'],
		dayNamesMin: ['Жк','Дс','Сс','Ср','Бс','Жм','Сн'],
		weekHeader: 'Не',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['kk']);
});
/* Khmer initialisation for the jQuery calendar extension. */
/* Written by Chandara Om (chandara.teacher@gmail.com). */
jQuery(function($){
	$.datepicker.regional['km'] = {
		closeText: 'ធ្វើ​រួច',
		prevText: 'មុន',
		nextText: 'បន្ទាប់',
		currentText: 'ថ្ងៃ​នេះ',
		monthNames: ['មករា','កុម្ភៈ','មីនា','មេសា','ឧសភា','មិថុនា',
		'កក្កដា','សីហា','កញ្ញា','តុលា','វិច្ឆិកា','ធ្នូ'],
		monthNamesShort: ['មករា','កុម្ភៈ','មីនា','មេសា','ឧសភា','មិថុនា',
		'កក្កដា','សីហា','កញ្ញា','តុលា','វិច្ឆិកា','ធ្នូ'],
		dayNames: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'],
		dayNamesShort: ['អា', 'ច', 'អ', 'ពុ', 'ព្រហ', 'សុ', 'សៅ'],
		dayNamesMin: ['អា', 'ច', 'អ', 'ពុ', 'ព្រហ', 'សុ', 'សៅ'],
		weekHeader: 'សប្ដាហ៍',
		dateFormat: 'dd-mm-yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['km']);
});
/* Korean initialisation for the jQuery calendar extension. */
/* Written by DaeKwon Kang (ncrash.dk@gmail.com), Edited by Genie. */
jQuery(function($){
	$.datepicker.regional['ko'] = {
		closeText: '닫기',
		prevText: '이전달',
		nextText: '다음달',
		currentText: '오늘',
		monthNames: ['1월','2월','3월','4월','5월','6월',
		'7월','8월','9월','10월','11월','12월'],
		monthNamesShort: ['1월','2월','3월','4월','5월','6월',
		'7월','8월','9월','10월','11월','12월'],
		dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'],
		dayNamesShort: ['일','월','화','수','목','금','토'],
		dayNamesMin: ['일','월','화','수','목','금','토'],
		weekHeader: 'Wk',
		dateFormat: 'yy-mm-dd',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: '년'};
	$.datepicker.setDefaults($.datepicker.regional['ko']);
});/* Luxembourgish initialisation for the jQuery UI date picker plugin. */
/* Written by Michel Weimerskirch <michel@weimerskirch.net> */
jQuery(function($){
	$.datepicker.regional['lb'] = {
		closeText: 'Fäerdeg',
		prevText: 'Zréck',
		nextText: 'Weider',
		currentText: 'Haut',
		monthNames: ['Januar','Februar','Mäerz','Abrëll','Mee','Juni',
		'Juli','August','September','Oktober','November','Dezember'],
		monthNamesShort: ['Jan', 'Feb', 'Mäe', 'Abr', 'Mee', 'Jun',
		'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		dayNames: ['Sonndeg', 'Méindeg', 'Dënschdeg', 'Mëttwoch', 'Donneschdeg', 'Freideg', 'Samschdeg'],
		dayNamesShort: ['Son', 'Méi', 'Dën', 'Mët', 'Don', 'Fre', 'Sam'],
		dayNamesMin: ['So','Mé','Dë','Më','Do','Fr','Sa'],
		weekHeader: 'W',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['lb']);
});
/* Lithuanian (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* @author Arturas Paleicikas <arturas@avalon.lt> */
jQuery(function($){
	$.datepicker.regional['lt'] = {
		closeText: 'Uždaryti',
		prevText: '&#x3c;Atgal',
		nextText: 'Pirmyn&#x3e;',
		currentText: 'Šiandien',
		monthNames: ['Sausis','Vasaris','Kovas','Balandis','Gegužė','Birželis',
		'Liepa','Rugpjūtis','Rugsėjis','Spalis','Lapkritis','Gruodis'],
		monthNamesShort: ['Sau','Vas','Kov','Bal','Geg','Bir',
		'Lie','Rugp','Rugs','Spa','Lap','Gru'],
		dayNames: ['sekmadienis','pirmadienis','antradienis','trečiadienis','ketvirtadienis','penktadienis','šeštadienis'],
		dayNamesShort: ['sek','pir','ant','tre','ket','pen','šeš'],
		dayNamesMin: ['Se','Pr','An','Tr','Ke','Pe','Še'],
		weekHeader: 'Wk',
		dateFormat: 'yy-mm-dd',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['lt']);
});/* Latvian (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* @author Arturas Paleicikas <arturas.paleicikas@metasite.net> */
jQuery(function($){
	$.datepicker.regional['lv'] = {
		closeText: 'Aizvērt',
		prevText: 'Iepr',
		nextText: 'Nāka',
		currentText: 'Šodien',
		monthNames: ['Janvāris','Februāris','Marts','Aprīlis','Maijs','Jūnijs',
		'Jūlijs','Augusts','Septembris','Oktobris','Novembris','Decembris'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Mai','Jūn',
		'Jūl','Aug','Sep','Okt','Nov','Dec'],
		dayNames: ['svētdiena','pirmdiena','otrdiena','trešdiena','ceturtdiena','piektdiena','sestdiena'],
		dayNamesShort: ['svt','prm','otr','tre','ctr','pkt','sst'],
		dayNamesMin: ['Sv','Pr','Ot','Tr','Ct','Pk','Ss'],
		weekHeader: 'Nav',
		dateFormat: 'dd-mm-yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['lv']);
});/* Macedonian i18n for the jQuery UI date picker plugin. */
/* Written by Stojce Slavkovski. */
jQuery(function($){
	$.datepicker.regional['mk'] = {
		closeText: 'Затвори',
		prevText: '&#x3C;',
		nextText: '&#x3E;',
		currentText: 'Денес',
		monthNames: ['Јануари','Фебруари','Март','Април','Мај','Јуни',
		'Јули','Август','Септември','Октомври','Ноември','Декември'],
		monthNamesShort: ['Јан','Феб','Мар','Апр','Мај','Јун',
		'Јул','Авг','Сеп','Окт','Ное','Дек'],
		dayNames: ['Недела','Понеделник','Вторник','Среда','Четврток','Петок','Сабота'],
		dayNamesShort: ['Нед','Пон','Вто','Сре','Чет','Пет','Саб'],
		dayNamesMin: ['Не','По','Вт','Ср','Че','Пе','Са'],
		weekHeader: 'Сед',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['mk']);
});
/* Malayalam (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Saji Nediyanchath (saji89@gmail.com). */
jQuery(function($){
	$.datepicker.regional['ml'] = {
		closeText: 'ശരി',
		prevText: 'മുന്നത്തെ',  
		nextText: 'അടുത്തത് ',
		currentText: 'ഇന്ന്',
		monthNames: ['ജനുവരി','ഫെബ്രുവരി','മാര്‍ച്ച്','ഏപ്രില്‍','മേയ്','ജൂണ്‍',
		'ജൂലൈ','ആഗസ്റ്റ്','സെപ്റ്റംബര്‍','ഒക്ടോബര്‍','നവംബര്‍','ഡിസംബര്‍'],
		monthNamesShort: ['ജനു', 'ഫെബ്', 'മാര്‍', 'ഏപ്രി', 'മേയ്', 'ജൂണ്‍',
		'ജൂലാ', 'ആഗ', 'സെപ്', 'ഒക്ടോ', 'നവം', 'ഡിസ'],
		dayNames: ['ഞായര്‍', 'തിങ്കള്‍', 'ചൊവ്വ', 'ബുധന്‍', 'വ്യാഴം', 'വെള്ളി', 'ശനി'],
		dayNamesShort: ['ഞായ', 'തിങ്ക', 'ചൊവ്വ', 'ബുധ', 'വ്യാഴം', 'വെള്ളി', 'ശനി'],
		dayNamesMin: ['ഞാ','തി','ചൊ','ബു','വ്യാ','വെ','ശ'],
		weekHeader: 'ആ',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ml']);
});
/* Malaysian initialisation for the jQuery UI date picker plugin. */
/* Written by Mohd Nawawi Mohamad Jamili (nawawi@ronggeng.net). */
jQuery(function($){
	$.datepicker.regional['ms'] = {
		closeText: 'Tutup',
		prevText: '&#x3c;Sebelum',
		nextText: 'Selepas&#x3e;',
		currentText: 'hari ini',
		monthNames: ['Januari','Februari','Mac','April','Mei','Jun',
		'Julai','Ogos','September','Oktober','November','Disember'],
		monthNamesShort: ['Jan','Feb','Mac','Apr','Mei','Jun',
		'Jul','Ogo','Sep','Okt','Nov','Dis'],
		dayNames: ['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu'],
		dayNamesShort: ['Aha','Isn','Sel','Rab','kha','Jum','Sab'],
		dayNamesMin: ['Ah','Is','Se','Ra','Kh','Ju','Sa'],
		weekHeader: 'Mg',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ms']);
});/* Dutch (Belgium) initialisation for the jQuery UI date picker plugin. */
/* David De Sloovere @DavidDeSloovere */
jQuery(function($){
	$.datepicker.regional['nl-BE'] = {
		closeText: 'Sluiten',
		prevText: '←',
		nextText: '→',
		currentText: 'Vandaag',
		monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
		'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
		monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
		'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
		dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
		dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
		dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['nl-BE']);
});
/* Dutch (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Mathias Bynens <http://mathiasbynens.be/> */
jQuery(function($){
	$.datepicker.regional.nl = {
		closeText: 'Sluiten',
		prevText: '←',
		nextText: '→',
		currentText: 'Vandaag',
		monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
		'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
		monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
		'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
		dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
		dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
		dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
		weekHeader: 'Wk',
		dateFormat: 'dd-mm-yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional.nl);
});/* Norwegian initialisation for the jQuery UI date picker plugin. */
/* Written by Naimdjon Takhirov (naimdjon@gmail.com). */

jQuery(function($){
  $.datepicker.regional['no'] = {
    closeText: 'Lukk',
    prevText: '&laquo;Forrige',
    nextText: 'Neste&raquo;',
    currentText: 'I dag',
    monthNames: ['januar','februar','mars','april','mai','juni','juli','august','september','oktober','november','desember'],
    monthNamesShort: ['jan','feb','mar','apr','mai','jun','jul','aug','sep','okt','nov','des'],
    dayNamesShort: ['søn','man','tir','ons','tor','fre','lør'],
    dayNames: ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'],
    dayNamesMin: ['sø','ma','ti','on','to','fr','lø'],
    weekHeader: 'Uke',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional['no']);
});
/* Polish initialisation for the jQuery UI date picker plugin. */
/* Written by Jacek Wysocki (jacek.wysocki@gmail.com). */
jQuery(function($){
	$.datepicker.regional['pl'] = {
		closeText: 'Zamknij',
		prevText: '&#x3c;Poprzedni',
		nextText: 'Następny&#x3e;',
		currentText: 'Dziś',
		monthNames: ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec',
		'Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
		monthNamesShort: ['Sty','Lu','Mar','Kw','Maj','Cze',
		'Lip','Sie','Wrz','Pa','Lis','Gru'],
		dayNames: ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
		dayNamesShort: ['Nie','Pn','Wt','Śr','Czw','Pt','So'],
		dayNamesMin: ['N','Pn','Wt','Śr','Cz','Pt','So'],
		weekHeader: 'Tydz',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['pl']);
});
/* Brazilian initialisation for the jQuery UI date picker plugin. */
/* Written by Leonildo Costa Silva (leocsilva@gmail.com). */
jQuery(function($){
	$.datepicker.regional['pt-BR'] = {
		closeText: 'Fechar',
		prevText: '&#x3c;Anterior',
		nextText: 'Pr&oacute;ximo&#x3e;',
		currentText: 'Hoje',
		monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
		'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
		monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
		'Jul','Ago','Set','Out','Nov','Dez'],
		dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','S&aacute;bado'],
		dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','S&aacute;b'],
		dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','S&aacute;b'],
		weekHeader: 'Sm',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['pt-BR']);
});/* Portuguese initialisation for the jQuery UI date picker plugin. */
jQuery(function($){
	$.datepicker.regional['pt'] = {
		closeText: 'Fechar',
		prevText: '&#x3c;Anterior',
		nextText: 'Seguinte',
		currentText: 'Hoje',
		monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
		'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
		monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
		'Jul','Ago','Set','Out','Nov','Dez'],
		dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','S&aacute;bado'],
		dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','S&aacute;b'],
		dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','S&aacute;b'],
		weekHeader: 'Sem',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['pt']);
});/* Romansh initialisation for the jQuery UI date picker plugin. */
/* Written by Yvonne Gienal (yvonne.gienal@educa.ch). */
jQuery(function($){
	$.datepicker.regional['rm'] = {
		closeText: 'Serrar',
		prevText: '&#x3c;Suandant',
		nextText: 'Precedent&#x3e;',
		currentText: 'Actual',
		monthNames: ['Schaner','Favrer','Mars','Avrigl','Matg','Zercladur', 'Fanadur','Avust','Settember','October','November','December'],
		monthNamesShort: ['Scha','Fev','Mar','Avr','Matg','Zer', 'Fan','Avu','Sett','Oct','Nov','Dec'],
		dayNames: ['Dumengia','Glindesdi','Mardi','Mesemna','Gievgia','Venderdi','Sonda'],
		dayNamesShort: ['Dum','Gli','Mar','Mes','Gie','Ven','Som'],
		dayNamesMin: ['Du','Gl','Ma','Me','Gi','Ve','So'],
		weekHeader: 'emna',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['rm']);
});
/* Romanian initialisation for the jQuery UI date picker plugin.
 *
 * Written by Edmond L. (ll_edmond@walla.com)
 * and Ionut G. Stan (ionut.g.stan@gmail.com)
 */
jQuery(function($){
	$.datepicker.regional['ro'] = {
		closeText: 'Închide',
		prevText: '&laquo; Luna precedentă',
		nextText: 'Luna următoare &raquo;',
		currentText: 'Azi',
		monthNames: ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie',
		'Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'],
		monthNamesShort: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun',
		'Iul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		dayNames: ['Duminică', 'Luni', 'Marţi', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
		dayNamesShort: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
		dayNamesMin: ['Du','Lu','Ma','Mi','Jo','Vi','Sâ'],
		weekHeader: 'Săpt',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ro']);
});
/* Russian (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Andrew Stromnov (stromnov@gmail.com). */
jQuery(function($){
	$.datepicker.regional['ru'] = {
		closeText: 'Закрыть',
		prevText: '&#x3c;Пред',
		nextText: 'След&#x3e;',
		currentText: 'Сегодня',
		monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь',
		'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
		monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
		'Июл','Авг','Сен','Окт','Ноя','Дек'],
		dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
		dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
		dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
		weekHeader: 'Нед',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ru']);
});/* Slovak initialisation for the jQuery UI date picker plugin. */
/* Written by Vojtech Rinik (vojto@hmm.sk). */
jQuery(function($){
	$.datepicker.regional['sk'] = {
		closeText: 'Zavrieť',
		prevText: '&#x3c;Predchádzajúci',
		nextText: 'Nasledujúci&#x3e;',
		currentText: 'Dnes',
		monthNames: ['Január','Február','Marec','Apríl','Máj','Jún',
		'Júl','August','September','Október','November','December'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Máj','Jún',
		'Júl','Aug','Sep','Okt','Nov','Dec'],
		dayNames: ['Nedeľa','Pondelok','Utorok','Streda','Štvrtok','Piatok','Sobota'],
		dayNamesShort: ['Ned','Pon','Uto','Str','Štv','Pia','Sob'],
		dayNamesMin: ['Ne','Po','Ut','St','Št','Pia','So'],
		weekHeader: 'Ty',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['sk']);
});
/* Slovenian initialisation for the jQuery UI date picker plugin. */
/* Written by Jaka Jancar (jaka@kubje.org). */
/* c = &#x10D;, s = &#x161; z = &#x17E; C = &#x10C; S = &#x160; Z = &#x17D; */
jQuery(function($){
	$.datepicker.regional['sl'] = {
		closeText: 'Zapri',
		prevText: '&lt;Prej&#x161;nji',
		nextText: 'Naslednji&gt;',
		currentText: 'Trenutni',
		monthNames: ['Januar','Februar','Marec','April','Maj','Junij',
		'Julij','Avgust','September','Oktober','November','December'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
		'Jul','Avg','Sep','Okt','Nov','Dec'],
		dayNames: ['Nedelja','Ponedeljek','Torek','Sreda','&#x10C;etrtek','Petek','Sobota'],
		dayNamesShort: ['Ned','Pon','Tor','Sre','&#x10C;et','Pet','Sob'],
		dayNamesMin: ['Ne','Po','To','Sr','&#x10C;e','Pe','So'],
		weekHeader: 'Teden',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['sl']);
});
/* Albanian initialisation for the jQuery UI date picker plugin. */
/* Written by Flakron Bytyqi (flakron@gmail.com). */
jQuery(function($){
	$.datepicker.regional['sq'] = {
		closeText: 'mbylle',
		prevText: '&#x3c;mbrapa',
		nextText: 'Përpara&#x3e;',
		currentText: 'sot',
		monthNames: ['Janar','Shkurt','Mars','Prill','Maj','Qershor',
		'Korrik','Gusht','Shtator','Tetor','Nëntor','Dhjetor'],
		monthNamesShort: ['Jan','Shk','Mar','Pri','Maj','Qer',
		'Kor','Gus','Sht','Tet','Nën','Dhj'],
		dayNames: ['E Diel','E Hënë','E Martë','E Mërkurë','E Enjte','E Premte','E Shtune'],
		dayNamesShort: ['Di','Hë','Ma','Më','En','Pr','Sh'],
		dayNamesMin: ['Di','Hë','Ma','Më','En','Pr','Sh'],
		weekHeader: 'Ja',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['sq']);
});
/* Serbian i18n for the jQuery UI date picker plugin. */
/* Written by Dejan Dimić. */
jQuery(function($){
	$.datepicker.regional['sr-SR'] = {
		closeText: 'Zatvori',
		prevText: '&#x3c;',
		nextText: '&#x3e;',
		currentText: 'Danas',
		monthNames: ['Januar','Februar','Mart','April','Maj','Jun',
		'Jul','Avgust','Septembar','Oktobar','Novembar','Decembar'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
		'Jul','Avg','Sep','Okt','Nov','Dec'],
		dayNames: ['Nedelja','Ponedeljak','Utorak','Sreda','Četvrtak','Petak','Subota'],
		dayNamesShort: ['Ned','Pon','Uto','Sre','Čet','Pet','Sub'],
		dayNamesMin: ['Ne','Po','Ut','Sr','Če','Pe','Su'],
		weekHeader: 'Sed',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['sr-SR']);
});
/* Serbian i18n for the jQuery UI date picker plugin. */
/* Written by Dejan Dimić. */
jQuery(function($){
	$.datepicker.regional['sr'] = {
		closeText: 'Затвори',
		prevText: '&#x3c;',
		nextText: '&#x3e;',
		currentText: 'Данас',
		monthNames: ['Јануар','Фебруар','Март','Април','Мај','Јун',
		'Јул','Август','Септембар','Октобар','Новембар','Децембар'],
		monthNamesShort: ['Јан','Феб','Мар','Апр','Мај','Јун',
		'Јул','Авг','Сеп','Окт','Нов','Дец'],
		dayNames: ['Недеља','Понедељак','Уторак','Среда','Четвртак','Петак','Субота'],
		dayNamesShort: ['Нед','Пон','Уто','Сре','Чет','Пет','Суб'],
		dayNamesMin: ['Не','По','Ут','Ср','Че','Пе','Су'],
		weekHeader: 'Сед',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['sr']);
});
/* Swedish initialisation for the jQuery UI date picker plugin. */
/* Written by Anders Ekdahl ( anders@nomadiz.se). */
jQuery(function($){
    $.datepicker.regional['sv'] = {
		closeText: 'Stäng',
        prevText: '&laquo;Förra',
		nextText: 'Nästa&raquo;',
		currentText: 'Idag',
        monthNames: ['Januari','Februari','Mars','April','Maj','Juni',
        'Juli','Augusti','September','Oktober','November','December'],
        monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun',
        'Jul','Aug','Sep','Okt','Nov','Dec'],
		dayNamesShort: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'],
		dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
		dayNamesMin: ['Sö','Må','Ti','On','To','Fr','Lö'],
		weekHeader: 'Ve',
        dateFormat: 'yy-mm-dd',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
    $.datepicker.setDefaults($.datepicker.regional['sv']);
});
/* Tamil (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by S A Sureshkumar (saskumar@live.com). */
jQuery(function($){
	$.datepicker.regional['ta'] = {
		closeText: 'மூடு',
		prevText: 'முன்னையது',
		nextText: 'அடுத்தது',
		currentText: 'இன்று',
		monthNames: ['தை','மாசி','பங்குனி','சித்திரை','வைகாசி','ஆனி',
		'ஆடி','ஆவணி','புரட்டாசி','ஐப்பசி','கார்த்திகை','மார்கழி'],
		monthNamesShort: ['தை','மாசி','பங்','சித்','வைகா','ஆனி',
		'ஆடி','ஆவ','புர','ஐப்','கார்','மார்'],
		dayNames: ['ஞாயிற்றுக்கிழமை','திங்கட்கிழமை','செவ்வாய்க்கிழமை','புதன்கிழமை','வியாழக்கிழமை','வெள்ளிக்கிழமை','சனிக்கிழமை'],
		dayNamesShort: ['ஞாயிறு','திங்கள்','செவ்வாய்','புதன்','வியாழன்','வெள்ளி','சனி'],
		dayNamesMin: ['ஞா','தி','செ','பு','வி','வெ','ச'],
		weekHeader: 'Не',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['ta']);
});
/* Thai initialisation for the jQuery UI date picker plugin. */
/* Written by pipo (pipo@sixhead.com). */
jQuery(function($){
	$.datepicker.regional['th'] = {
		closeText: 'ปิด',
		prevText: '&laquo;&nbsp;ย้อน',
		nextText: 'ถัดไป&nbsp;&raquo;',
		currentText: 'วันนี้',
		monthNames: ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน',
		'กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'],
		monthNamesShort: ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.',
		'ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],
		dayNames: ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์'],
		dayNamesShort: ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.'],
		dayNamesMin: ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.'],
		weekHeader: 'Wk',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['th']);
});/* Tajiki (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Abdurahmon Saidov (saidovab@gmail.com). */
jQuery(function($){
	$.datepicker.regional['tj'] = {
		closeText: 'Идома',
		prevText: '&#x3c;Қафо',
		nextText: 'Пеш&#x3e;',
		currentText: 'Имрӯз',
		monthNames: ['Январ','Феврал','Март','Апрел','Май','Июн',
		'Июл','Август','Сентябр','Октябр','Ноябр','Декабр'],
		monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
		'Июл','Авг','Сен','Окт','Ноя','Дек'],
		dayNames: ['якшанбе','душанбе','сешанбе','чоршанбе','панҷшанбе','ҷумъа','шанбе'],
		dayNamesShort: ['якш','душ','сеш','чор','пан','ҷум','шан'],
		dayNamesMin: ['Як','Дш','Сш','Чш','Пш','Ҷм','Шн'],
		weekHeader: 'Хф',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['tj']);
});/* Turkish initialisation for the jQuery UI date picker plugin. */
/* Written by Izzet Emre Erkan (kara@karalamalar.net). */
jQuery(function($){
	$.datepicker.regional['tr'] = {
		closeText: 'kapat',
		prevText: '&#x3c;geri',
		nextText: 'ileri&#x3e',
		currentText: 'bugün',
		monthNames: ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
		'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
		monthNamesShort: ['Oca','Şub','Mar','Nis','May','Haz',
		'Tem','Ağu','Eyl','Eki','Kas','Ara'],
		dayNames: ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
		dayNamesShort: ['Pz','Pt','Sa','Ça','Pe','Cu','Ct'],
		dayNamesMin: ['Pz','Pt','Sa','Ça','Pe','Cu','Ct'],
		weekHeader: 'Hf',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['tr']);
});/* Ukrainian (UTF-8) initialisation for the jQuery UI date picker plugin. */
/* Written by Maxim Drogobitskiy (maxdao@gmail.com). */
/* Corrected by Igor Milla (igor.fsp.milla@gmail.com). */
jQuery(function($){
	$.datepicker.regional['uk'] = {
		closeText: 'Закрити',
		prevText: '&#x3c;',
		nextText: '&#x3e;',
		currentText: 'Сьогодні',
		monthNames: ['Січень','Лютий','Березень','Квітень','Травень','Червень',
		'Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'],
		monthNamesShort: ['Січ','Лют','Бер','Кві','Тра','Чер',
		'Лип','Сер','Вер','Жов','Лис','Гру'],
		dayNames: ['неділя','понеділок','вівторок','середа','четвер','п’ятниця','субота'],
		dayNamesShort: ['нед','пнд','вів','срд','чтв','птн','сбт'],
		dayNamesMin: ['Нд','Пн','Вт','Ср','Чт','Пт','Сб'],
		weekHeader: 'Тиж',
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['uk']);
});/* Vietnamese initialisation for the jQuery UI date picker plugin. */
/* Translated by Le Thanh Huy (lthanhhuy@cit.ctu.edu.vn). */
jQuery(function($){
	$.datepicker.regional['vi'] = {
		closeText: 'Đóng',
		prevText: '&#x3c;Trước',
		nextText: 'Tiếp&#x3e;',
		currentText: 'Hôm nay',
		monthNames: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu',
		'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai'],
		monthNamesShort: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
		'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
		dayNames: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
		dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
		dayNamesMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
		weekHeader: 'Tu',
		dateFormat: 'dd/mm/yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['vi']);
});
/* Chinese initialisation for the jQuery UI date picker plugin. */
/* Written by Cloudream (cloudream@gmail.com). */
jQuery(function($){
	$.datepicker.regional['zh-CN'] = {
		closeText: '关闭',
		prevText: '&#x3c;上月',
		nextText: '下月&#x3e;',
		currentText: '今天',
		monthNames: ['一月','二月','三月','四月','五月','六月',
		'七月','八月','九月','十月','十一月','十二月'],
		monthNamesShort: ['一','二','三','四','五','六',
		'七','八','九','十','十一','十二'],
		dayNames: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
		dayNamesShort: ['周日','周一','周二','周三','周四','周五','周六'],
		dayNamesMin: ['日','一','二','三','四','五','六'],
		weekHeader: '周',
		dateFormat: 'yy-mm-dd',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: '年'};
	$.datepicker.setDefaults($.datepicker.regional['zh-CN']);
});
/* Chinese initialisation for the jQuery UI date picker plugin. */
/* Written by SCCY (samuelcychan@gmail.com). */
jQuery(function($){
	$.datepicker.regional['zh-HK'] = {
		closeText: '關閉',
		prevText: '&#x3c;上月',
		nextText: '下月&#x3e;',
		currentText: '今天',
		monthNames: ['一月','二月','三月','四月','五月','六月',
		'七月','八月','九月','十月','十一月','十二月'],
		monthNamesShort: ['一','二','三','四','五','六',
		'七','八','九','十','十一','十二'],
		dayNames: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
		dayNamesShort: ['周日','周一','周二','周三','周四','周五','周六'],
		dayNamesMin: ['日','一','二','三','四','五','六'],
		weekHeader: '周',
		dateFormat: 'dd-mm-yy',
		firstDay: 0,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: '年'};
	$.datepicker.setDefaults($.datepicker.regional['zh-HK']);
});
/* Chinese initialisation for the jQuery UI date picker plugin. */
/* Written by Ressol (ressol@gmail.com). */
jQuery(function($){
	$.datepicker.regional['zh-TW'] = {
		closeText: '關閉',
		prevText: '&#x3c;上月',
		nextText: '下月&#x3e;',
		currentText: '今天',
		monthNames: ['一月','二月','三月','四月','五月','六月',
		'七月','八月','九月','十月','十一月','十二月'],
		monthNamesShort: ['一','二','三','四','五','六',
		'七','八','九','十','十一','十二'],
		dayNames: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
		dayNamesShort: ['周日','周一','周二','周三','周四','周五','周六'],
		dayNamesMin: ['日','一','二','三','四','五','六'],
		weekHeader: '周',
		dateFormat: 'yy/mm/dd',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: true,
		yearSuffix: '年'};
	$.datepicker.setDefaults($.datepicker.regional['zh-TW']);
});

define("jquery-ui", ["jquery-ui-plugins"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.widget;
    };
}(this)));


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('jquery-ui-selectmenu-css.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
 /*
 * jQuery UI Selectmenu version 1.2.2
 *
 * Copyright (c) 2009-2010 filament group, http://filamentgroup.com
 * Copyright (c) 2010-2012 Felix Nagel, http://www.felixnagel.com
 * Licensed under the MIT (MIT-LICENSE.txt)
 *
 * https://github.com/fnagel/jquery-ui/wiki/Selectmenu
 */

(function($) {

$.widget("ui.selectmenu", {
	options: {
		appendTo: "body",
		typeAhead: 1000,
		style: 'dropdown',
		positionOptions: {
			my: "left top",
			at: "left bottom",
			offset: null
		},
		width: null,
		menuWidth: null,
		handleWidth: 26,
		maxHeight: null,
		icons: null,
		format: null,
		escapeHtml: false,
		bgImage: function() {}
	},

	_create: function() {
		var self = this, o = this.options;

		// set a default id value, generate a new random one if not set by developer
		var selectmenuId = (this.element.attr( 'id' ) || 'ui-selectmenu-' + Math.random().toString( 16 ).slice( 2, 10 )).replace(/(:|\.)/g,'')

		// quick array of button and menu id's
		this.ids = [ selectmenuId, selectmenuId + '-button', selectmenuId + '-menu' ];

		// define safe mouseup for future toggling
		this._safemouseup = true;
		this.isOpen = false;

		// create menu button wrapper
		this.newelement = $( '<a />', {
			'class': this.widgetBaseClass + ' ui-widget ui-state-default ui-corner-all',
			'id' : this.ids[ 1 ],
			'role': 'button',
			'href': '#nogo',
			'tabindex': this.element.attr( 'disabled' ) ? 1 : 0,
			'aria-haspopup': true,
			'aria-owns': this.ids[ 2 ]
		});
		this.newelementWrap = $( "<span />" )
			.append( this.newelement )
			.insertAfter( this.element );

		// transfer tabindex
		var tabindex = this.element.attr( 'tabindex' );
		if ( tabindex ) {
			this.newelement.attr( 'tabindex', tabindex );
		}

		// save reference to select in data for ease in calling methods
		this.newelement.data( 'selectelement', this.element );

		// menu icon
		this.selectmenuIcon = $( '<span class="' + this.widgetBaseClass + '-icon ui-icon"></span>' )
			.prependTo( this.newelement );

		// append status span to button
		this.newelement.prepend( '<span class="' + self.widgetBaseClass + '-status" />' );

		// make associated form label trigger focus
		this.element.bind({
			'click.selectmenu':  function( event ) {
				self.newelement.focus();
				event.preventDefault();
			}
		});

		// click toggle for menu visibility
		this.newelement
			.bind('mousedown.selectmenu', function(event) {
				self._toggle(event, true);
				// make sure a click won't open/close instantly
				if (o.style == "popup") {
					self._safemouseup = false;
					setTimeout(function() { self._safemouseup = true; }, 300);
				}
				return false;
			})
			.bind('click.selectmenu', function() {
				return false;
			})
			.bind("keydown.selectmenu", function(event) {
				var ret = false;
				switch (event.keyCode) {
					case $.ui.keyCode.ENTER:
						ret = true;
						break;
					case $.ui.keyCode.SPACE:
						self._toggle(event);
						break;
					case $.ui.keyCode.UP:
						if (event.altKey) {
							self.open(event);
						} else {
							self._moveSelection(-1);
						}
						break;
					case $.ui.keyCode.DOWN:
						if (event.altKey) {
							self.open(event);
						} else {
							self._moveSelection(1);
						}
						break;
					case $.ui.keyCode.LEFT:
						self._moveSelection(-1);
						break;
					case $.ui.keyCode.RIGHT:
						self._moveSelection(1);
						break;
					case $.ui.keyCode.TAB:
						ret = true;
						break;
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.HOME:
						self.index(0);
						break;
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.END:
						self.index(self._optionLis.length);
						break;
					default:
						ret = true;
				}
				return ret;
			})
			.bind('keypress.selectmenu', function(event) {
				if (event.which > 0) {
					self._typeAhead(event.which, 'mouseup');
				}
				return true;
			})
			.bind('mouseover.selectmenu', function() {
				if (!o.disabled) $(this).addClass('ui-state-hover');
			})
			.bind('mouseout.selectmenu', function() {
				if (!o.disabled) $(this).removeClass('ui-state-hover');
			})
			.bind('focus.selectmenu', function() {
				if (!o.disabled) $(this).addClass('ui-state-focus');
			})
			.bind('blur.selectmenu', function() {
				if (!o.disabled) $(this).removeClass('ui-state-focus');
			});

		// document click closes menu
		$(document).bind("mousedown.selectmenu-" + this.ids[0], function(event) {
			if ( self.isOpen ) {
				self.close( event );
			}
		});

		// change event on original selectmenu
		this.element
			.bind("click.selectmenu", function() {
				self._refreshValue();
			})
			// FIXME: newelement can be null under unclear circumstances in IE8
			// TODO not sure if this is still a problem (fnagel 20.03.11)
			.bind("focus.selectmenu", function() {
				if (self.newelement) {
					self.newelement[0].focus();
				}
			});

		// set width when not set via options
		if (!o.width) {
			o.width = this.element.outerWidth();
		}
		// set menu button width
		this.newelement.width(o.width);

		// hide original selectmenu element
		this.element.hide();

		// create menu portion, append to body
		this.list = $( '<ul />', {
			'class': 'ui-widget ui-widget-content',
			'aria-hidden': true,
			'role': 'listbox',
			'aria-labelledby': this.ids[1],
			'id': this.ids[2]
		});
		this.listWrap = $( "<div />", {
			'class': self.widgetBaseClass + '-menu'
		}).append( this.list ).appendTo( o.appendTo );

		// transfer menu click to menu button
		this.list
			.bind("keydown.selectmenu", function(event) {
				var ret = false;
				switch (event.keyCode) {
					case $.ui.keyCode.UP:
						if (event.altKey) {
							self.close(event, true);
						} else {
							self._moveFocus(-1);
						}
						break;
					case $.ui.keyCode.DOWN:
						if (event.altKey) {
							self.close(event, true);
						} else {
							self._moveFocus(1);
						}
						break;
					case $.ui.keyCode.LEFT:
						self._moveFocus(-1);
						break;
					case $.ui.keyCode.RIGHT:
						self._moveFocus(1);
						break;
					case $.ui.keyCode.HOME:
						self._moveFocus(':first');
						break;
					case $.ui.keyCode.PAGE_UP:
						self._scrollPage('up');
						break;
					case $.ui.keyCode.PAGE_DOWN:
						self._scrollPage('down');
						break;
					case $.ui.keyCode.END:
						self._moveFocus(':last');
						break;
					case $.ui.keyCode.ENTER:
					case $.ui.keyCode.SPACE:
						self.close(event, true);
						$(event.target).parents('li:eq(0)').trigger('mouseup');
						break;
					case $.ui.keyCode.TAB:
						ret = true;
						self.close(event, true);
						$(event.target).parents('li:eq(0)').trigger('mouseup');
						break;
					case $.ui.keyCode.ESCAPE:
						self.close(event, true);
						break;
					default:
						ret = true;
				}
				return ret;
			})
			.bind('keypress.selectmenu', function(event) {
				if (event.which > 0) {
					self._typeAhead(event.which, 'focus');
				}
				return true;
			})
			// this allows for using the scrollbar in an overflowed list
			.bind( 'mousedown.selectmenu mouseup.selectmenu', function() { return false; });

		// needed when window is resized
		$(window).bind( "resize.selectmenu-" + this.ids[0], $.proxy( self.close, this ) );
	},

	_init: function() {
		var self = this, o = this.options;

		// serialize selectmenu element options
		var selectOptionData = [];
		this.element.find('option').each(function() {
			var opt = $(this);
			selectOptionData.push({
				value: opt.attr('value'),
				text: self._formatText(opt.text(), opt),
				selected: opt.attr('selected'),
				disabled: opt.attr('disabled'),
				classes: opt.attr('class'),
				typeahead: opt.attr('typeahead'),
				parentOptGroup: opt.parent('optgroup'),
				bgImage: o.bgImage.call(opt)
			});
		});

		// active state class is only used in popup style
		var activeClass = (self.options.style == "popup") ? " ui-state-active" : "";

		// empty list so we can refresh the selectmenu via selectmenu()
		this.list.html("");

		// write li's
		if (selectOptionData.length) {
			for (var i = 0; i < selectOptionData.length; i++) {
				var thisLiAttr = { role : 'presentation' };
				if ( selectOptionData[ i ].disabled ) {
					thisLiAttr[ 'class' ] = this.namespace + '-state-disabled';
				}
				var thisAAttr = {
					html: selectOptionData[i].text || '&nbsp;',
					href : '#nogo',
					tabindex : -1,
					role : 'option',
					'aria-selected' : false
				};
				if ( selectOptionData[ i ].disabled ) {
					thisAAttr[ 'aria-disabled' ] = selectOptionData[ i ].disabled;
				}
				if ( selectOptionData[ i ].typeahead ) {
					thisAAttr[ 'typeahead' ] = selectOptionData[ i ].typeahead;
				}
				var thisA = $('<a/>', thisAAttr)
					.bind('focus.selectmenu', function() {
						$(this).parent().mouseover();
					})
					.bind('blur.selectmenu', function() {
						$(this).parent().mouseout();
					});					
				var thisLi = $('<li/>', thisLiAttr)
					.append(thisA)
					.data('index', i)
					.addClass(selectOptionData[i].classes)
					.data('optionClasses', selectOptionData[i].classes || '')
					.bind("mouseup.selectmenu", function(event) {
						if (self._safemouseup && !self._disabled(event.currentTarget) && !self._disabled($( event.currentTarget ).parents( "ul>li." + self.widgetBaseClass + "-group " )) ) {
							var changed = $(this).data('index') != self._selectedIndex();
							self.index($(this).data('index'));
							self.select(event);
							if (changed) {
								self.change(event);
							}
							self.close(event, true);
						}
						return false;
					})
					.bind("click.selectmenu", function() {
						return false;
					})
					.bind('mouseover.selectmenu', function() {
						// no hover if diabled
						if (!$(this).hasClass(self.namespace + '-state-disabled') && !$(this).parent("ul").parent("li").hasClass(self.namespace + '-state-disabled')) {
							self._selectedOptionLi().addClass(activeClass);
							self._focusedOptionLi().removeClass(self.widgetBaseClass + '-item-focus ui-state-hover');
							$(this).removeClass('ui-state-active').addClass(self.widgetBaseClass + '-item-focus ui-state-hover');
						}
					})
					.bind('mouseout.selectmenu', function() {
						if ($(this).is(self._selectedOptionLi())) {
							$(this).addClass(activeClass);
						}
						$(this).removeClass(self.widgetBaseClass + '-item-focus ui-state-hover');
					});

				// optgroup or not...
				if ( selectOptionData[i].parentOptGroup.length ) {
					var optGroupName = self.widgetBaseClass + '-group-' + this.element.find( 'optgroup' ).index( selectOptionData[i].parentOptGroup );
					if (this.list.find( 'li.' + optGroupName ).length ) {
						this.list.find( 'li.' + optGroupName + ':last ul' ).append( thisLi );
					} else {
						$(' <li role="presentation" class="' + self.widgetBaseClass + '-group ' + optGroupName + (selectOptionData[i].parentOptGroup.attr("disabled") ? ' ' + this.namespace + '-state-disabled" aria-disabled="true"' : '"' ) + '><span class="' + self.widgetBaseClass + '-group-label">' + selectOptionData[i].parentOptGroup.attr('label') + '</span><ul></ul></li> ')
							.appendTo( this.list )
							.find( 'ul' )
							.append( thisLi );
					}
				} else {
					thisLi.appendTo(this.list);
				}

				// append icon if option is specified
				if (o.icons) {
					for (var j in o.icons) {
						if (thisLi.is(o.icons[j].find)) {
							thisLi
								.data('optionClasses', selectOptionData[i].classes + ' ' + self.widgetBaseClass + '-hasIcon')
								.addClass(self.widgetBaseClass + '-hasIcon');
							var iconClass = o.icons[j].icon || "";
							thisLi
								.find('a:eq(0)')
								.prepend('<span class="' + self.widgetBaseClass + '-item-icon ui-icon ' + iconClass + '"></span>');
							if (selectOptionData[i].bgImage) {
								thisLi.find('span').css('background-image', selectOptionData[i].bgImage);
							}
						}
					}
				}
			}
		} else {
			$('<li role="presentation"><a href="#nogo" tabindex="-1" role="option"></a></li>').appendTo(this.list);
		}
		// we need to set and unset the CSS classes for dropdown and popup style
		var isDropDown = ( o.style == 'dropdown' );
		this.newelement
			.toggleClass( self.widgetBaseClass + '-dropdown', isDropDown )
			.toggleClass( self.widgetBaseClass + '-popup', !isDropDown );
		this.list
			.toggleClass( self.widgetBaseClass + '-menu-dropdown ui-corner-bottom', isDropDown )
			.toggleClass( self.widgetBaseClass + '-menu-popup ui-corner-all', !isDropDown )
			// add corners to top and bottom menu items
			.find( 'li:first' )
			.toggleClass( 'ui-corner-top', !isDropDown )
			.end().find( 'li:last' )
			.addClass( 'ui-corner-bottom' );
		this.selectmenuIcon
			.toggleClass( 'ui-icon-triangle-1-s', isDropDown )
			.toggleClass( 'ui-icon-triangle-2-n-s', !isDropDown );

		// set menu width to either menuWidth option value, width option value, or select width
		if ( o.style == 'dropdown' ) {
			this.list.width( o.menuWidth ? o.menuWidth : o.width );
		} else {
			this.list.width( o.menuWidth ? o.menuWidth : o.width - o.handleWidth );
		}

		// reset height to auto
		this.list.css( 'height', 'auto' );
		var listH = this.listWrap.height();
		var winH = $( window ).height();
		// calculate default max height
		var maxH = o.maxHeight ? Math.min( o.maxHeight, winH ) : winH / 3;
		if ( listH > maxH ) this.list.height( maxH );

		// save reference to actionable li's (not group label li's)
		this._optionLis = this.list.find( 'li:not(.' + self.widgetBaseClass + '-group)' );

		// transfer disabled state
		if ( this.element.attr( 'disabled' ) ) {
			this.disable();
		} else {
			this.enable();
		}

		// update value
		this._refreshValue();

		// set selected item so movefocus has intial state
		this._selectedOptionLi().addClass(this.widgetBaseClass + '-item-focus');

		// needed when selectmenu is placed at the very bottom / top of the page
		clearTimeout(this.refreshTimeout);
		this.refreshTimeout = window.setTimeout(function () {
			self._refreshPosition();
		}, 200);
	},

	destroy: function() {
		this.element.removeData( this.widgetName )
			.removeClass( this.widgetBaseClass + '-disabled' + ' ' + this.namespace + '-state-disabled' )
			.removeAttr( 'aria-disabled' )
			.unbind( ".selectmenu" );

		$( window ).unbind( ".selectmenu-" + this.ids[0] );
		$( document ).unbind( ".selectmenu-" + this.ids[0] );

		this.newelementWrap.remove();
		this.listWrap.remove();

		// unbind click event and show original select
		this.element
			.unbind(".selectmenu")
			.show();

		// call widget destroy function
		$.Widget.prototype.destroy.apply(this, arguments);
	},

	_typeAhead: function( code, eventType ) {
		var self = this,
			c = String.fromCharCode(code).toLowerCase(),
			matchee = null,
			nextIndex = null;

		// Clear any previous timer if present
		if ( self._typeAhead_timer ) {
			window.clearTimeout( self._typeAhead_timer );
			self._typeAhead_timer = undefined;
		}

		// Store the character typed
		self._typeAhead_chars = (self._typeAhead_chars === undefined ? "" : self._typeAhead_chars).concat(c);

		// Detect if we are in cyciling mode or direct selection mode
		if ( self._typeAhead_chars.length < 2 ||
		     (self._typeAhead_chars.substr(-2, 1) === c && self._typeAhead_cycling) ) {
			self._typeAhead_cycling = true;

			// Match only the first character and loop
			matchee = c;
		}
		else {
			// We won't be cycling anymore until the timer expires
			self._typeAhead_cycling = false;

			// Match all the characters typed
			matchee = self._typeAhead_chars;
		}

		// We need to determine the currently active index, but it depends on
		// the used context: if it's in the element, we want the actual
		// selected index, if it's in the menu, just the focused one
		// I copied this code from _moveSelection() and _moveFocus()
		// respectively --thg2k
		var selectedIndex = (eventType !== 'focus' ?
			this._selectedOptionLi().data('index') :
			this._focusedOptionLi().data('index')) || 0;

		for (var i = 0; i < this._optionLis.length; i++) {
			var thisText = this._optionLis.eq(i).text().substr(0, matchee.length).toLowerCase();

			if ( thisText === matchee ) {
				if ( self._typeAhead_cycling ) {
					if ( nextIndex === null )
						nextIndex = i;

					if ( i > selectedIndex ) {
						nextIndex = i;
						break;
					}
				} else {
					nextIndex = i;
				}
			}
		}

		if ( nextIndex !== null ) {
			// Why using trigger() instead of a direct method to select the
			// index? Because we don't what is the exact action to do, it
			// depends if the user is typing on the element or on the popped
			// up menu
			this._optionLis.eq(nextIndex).find("a").trigger( eventType );
		}

		self._typeAhead_timer = window.setTimeout(function() {
			self._typeAhead_timer = undefined;
			self._typeAhead_chars = undefined;
			self._typeAhead_cycling = undefined;
		}, self.options.typeAhead);
	},

	// returns some usefull information, called by callbacks only
	_uiHash: function() {
		var index = this.index();
		return {
			index: index,
			option: $("option", this.element).get(index),
			value: this.element[0].value
		};
	},

	open: function(event) {
		var self = this, o = this.options;
		if ( self.newelement.attr("aria-disabled") != 'true' ) {
			self._closeOthers(event);
			self.newelement.addClass('ui-state-active');

			self.list.attr('aria-hidden', false);
			self.listWrap.addClass( self.widgetBaseClass + '-open' );

			var selected = this._selectedOptionLi();
			if ( o.style == "dropdown" ) {
				self.newelement.removeClass('ui-corner-all').addClass('ui-corner-top');
			} else {
				// center overflow and avoid flickering
				this.list
					.css("left", -5000)
					.scrollTop( this.list.scrollTop() + selected.position().top - this.list.outerHeight()/2 + selected.outerHeight()/2 )
					.css("left","auto");
			}

			self._refreshPosition();

			var link = selected.find("a");
			if (link.length) link[0].focus();

			self.isOpen = true;
			self._trigger("open", event, self._uiHash());
		}
	},

	close: function(event, retainFocus) {
		if ( this.newelement.is('.ui-state-active') ) {
			this.newelement
				.removeClass('ui-state-active');
			this.listWrap.removeClass(this.widgetBaseClass + '-open');
			this.list.attr('aria-hidden', true);
			if ( this.options.style == "dropdown" ) {
				this.newelement.removeClass('ui-corner-top').addClass('ui-corner-all');
			}
			if ( retainFocus ) {
				this.newelement.focus();
			}
			this.isOpen = false;
			this._trigger("close", event, this._uiHash());
		}
	},

	change: function(event) {
		this.element.trigger("change");
		this._trigger("change", event, this._uiHash());
	},

	select: function(event) {
		if (this._disabled(event.currentTarget)) { return false; }
		this._trigger("select", event, this._uiHash());
	},

	widget: function() {
		return this.listWrap.add( this.newelementWrap );
	},

	_closeOthers: function(event) {
		$('.' + this.widgetBaseClass + '.ui-state-active').not(this.newelement).each(function() {
			$(this).data('selectelement').selectmenu('close', event);
		});
		$('.' + this.widgetBaseClass + '.ui-state-hover').trigger('mouseout');
	},

	_toggle: function(event, retainFocus) {
		if ( this.isOpen ) {
			this.close(event, retainFocus);
		} else {
			this.open(event);
		}
	},

	_formatText: function(text, opt) {
		if (this.options.format) {
			text = this.options.format(text, opt);
		} else if (this.options.escapeHtml) {
			text = $('<div />').text(text).html();
		}
		return text;
	},

	_selectedIndex: function() {
		return this.element[0].selectedIndex;
	},

	_selectedOptionLi: function() {
		return this._optionLis.eq(this._selectedIndex());
	},

	_focusedOptionLi: function() {
		return this.list.find('.' + this.widgetBaseClass + '-item-focus');
	},

	_moveSelection: function(amt, recIndex) {
		// do nothing if disabled
		if (!this.options.disabled) {
			var currIndex = parseInt(this._selectedOptionLi().data('index') || 0, 10);
			var newIndex = currIndex + amt;
			// do not loop when using up key

			if (newIndex < 0) {
				newIndex = 0;
			}
			if (newIndex > this._optionLis.size() - 1) {
				newIndex = this._optionLis.size() - 1;
			}
			// Occurs when a full loop has been made
			if (newIndex === recIndex) { return false; }

			if (this._optionLis.eq(newIndex).hasClass( this.namespace + '-state-disabled' )) {
				// if option at newIndex is disabled, call _moveFocus, incrementing amt by one
				(amt > 0) ? ++amt : --amt;
				this._moveSelection(amt, newIndex);
			} else {
				this._optionLis.eq(newIndex).trigger('mouseover').trigger('mouseup');
			}
		}
	},

	_moveFocus: function(amt, recIndex) {
		if (!isNaN(amt)) {
			var currIndex = parseInt(this._focusedOptionLi().data('index') || 0, 10);
			var newIndex = currIndex + amt;
		} else {
			var newIndex = parseInt(this._optionLis.filter(amt).data('index'), 10);
		}

		if (newIndex < 0) {
			newIndex = 0;
		}
		if (newIndex > this._optionLis.size() - 1) {
			newIndex = this._optionLis.size() - 1;
		}

		//Occurs when a full loop has been made
		if (newIndex === recIndex) { return false; }

		var activeID = this.widgetBaseClass + '-item-' + Math.round(Math.random() * 1000);

		this._focusedOptionLi().find('a:eq(0)').attr('id', '');

		if (this._optionLis.eq(newIndex).hasClass( this.namespace + '-state-disabled' )) {
			// if option at newIndex is disabled, call _moveFocus, incrementing amt by one
			(amt > 0) ? ++amt : --amt;
			this._moveFocus(amt, newIndex);
		} else {
			this._optionLis.eq(newIndex).find('a:eq(0)').attr('id',activeID).focus();
		}

		this.list.attr('aria-activedescendant', activeID);
	},

	_scrollPage: function(direction) {
		var numPerPage = Math.floor(this.list.outerHeight() / this._optionLis.first().outerHeight());
		numPerPage = (direction == 'up' ? -numPerPage : numPerPage);
		this._moveFocus(numPerPage);
	},

	_setOption: function(key, value) {
		this.options[key] = value;
		// set
		if (key == 'disabled') {
			if (value) this.close();
			this.element
				.add(this.newelement)
				.add(this.list)[value ? 'addClass' : 'removeClass'](
					this.widgetBaseClass + '-disabled' + ' ' +
					this.namespace + '-state-disabled')
				.attr("aria-disabled", value);
		}
	},

	disable: function(index, type){
			// if options is not provided, call the parents disable function
			if ( typeof( index ) == 'undefined' ) {
				this._setOption( 'disabled', true );
			} else {
				if ( type == "optgroup" ) {
					this._disableOptgroup(index);
				} else {
					this._disableOption(index);
				}
			}
	},

	enable: function(index, type) {
			// if options is not provided, call the parents enable function
			if ( typeof( index ) == 'undefined' ) {
				this._setOption('disabled', false);
			} else {
				if ( type == "optgroup" ) {
					this._enableOptgroup(index);
				} else {
					this._enableOption(index);
				}
			}
	},

	_disabled: function(elem) {
			return $(elem).hasClass( this.namespace + '-state-disabled' );
	},

	_disableOption: function(index) {
			var optionElem = this._optionLis.eq(index);
			if (optionElem) {
				optionElem.addClass(this.namespace + '-state-disabled')
					.find("a").attr("aria-disabled", true);
				this.element.find("option").eq(index).attr("disabled", "disabled");
			}
	},

	_enableOption: function(index) {
			var optionElem = this._optionLis.eq(index);
			if (optionElem) {
				optionElem.removeClass( this.namespace + '-state-disabled' )
					.find("a").attr("aria-disabled", false);
				this.element.find("option").eq(index).removeAttr("disabled");
			}
	},

	_disableOptgroup: function(index) {
			var optGroupElem = this.list.find( 'li.' + this.widgetBaseClass + '-group-' + index );
			if (optGroupElem) {
				optGroupElem.addClass(this.namespace + '-state-disabled')
					.attr("aria-disabled", true);
				this.element.find("optgroup").eq(index).attr("disabled", "disabled");
			}
	},

	_enableOptgroup: function(index) {
			var optGroupElem = this.list.find( 'li.' + this.widgetBaseClass + '-group-' + index );
			if (optGroupElem) {
				optGroupElem.removeClass(this.namespace + '-state-disabled')
					.attr("aria-disabled", false);
				this.element.find("optgroup").eq(index).removeAttr("disabled");
			}
	},

	index: function(newValue) {
		if (arguments.length) {
			if (!this._disabled($(this._optionLis[newValue]))) {
				this.element[0].selectedIndex = newValue;
				this._refreshValue();
			} else {
				return false;
			}
		} else {
			return this._selectedIndex();
		}
	},

	value: function(newValue) {
		if (arguments.length) {
			this.element[0].value = newValue;
			this._refreshValue();
		} else {
			return this.element[0].value;
		}
	},

	_refreshValue: function() {
		var activeClass = (this.options.style == "popup") ? " ui-state-active" : "";
		var activeID = this.widgetBaseClass + '-item-' + Math.round(Math.random() * 1000);
		// deselect previous
		this.list
			.find('.' + this.widgetBaseClass + '-item-selected')
			.removeClass(this.widgetBaseClass + "-item-selected" + activeClass)
			.find('a')
			.attr('aria-selected', 'false')
			.attr('id', '');
		// select new
		this._selectedOptionLi()
			.addClass(this.widgetBaseClass + "-item-selected" + activeClass)
			.find('a')
			.attr('aria-selected', 'true')
			.attr('id', activeID);

		// toggle any class brought in from option
		var currentOptionClasses = (this.newelement.data('optionClasses') ? this.newelement.data('optionClasses') : "");
		var newOptionClasses = (this._selectedOptionLi().data('optionClasses') ? this._selectedOptionLi().data('optionClasses') : "");
		this.newelement
			.removeClass(currentOptionClasses)
			.data('optionClasses', newOptionClasses)
			.addClass( newOptionClasses )
			.find('.' + this.widgetBaseClass + '-status')
			.html(
				this._selectedOptionLi()
					.find('a:eq(0)')
					.html()
			);

		this.list.attr('aria-activedescendant', activeID);
	},

	_refreshPosition: function() {
		var o = this.options;

		// if its a pop-up we need to calculate the position of the selected li
		if ( o.style == "popup" && !o.positionOptions.offset ) {
			var selected = this._selectedOptionLi();
			var _offset = "0 " + ( this.list.offset().top  - selected.offset().top - ( this.newelement.outerHeight() + selected.outerHeight() ) / 2);
		}
		this.listWrap
			.removeAttr('style')
			.zIndex( this.element.zIndex() + 1 )
			.position({
				// set options for position plugin
				of: o.positionOptions.of || this.newelement,
				my: o.positionOptions.my,
				at: o.positionOptions.at,
				offset: o.positionOptions.offset || _offset,
				collision: o.positionOptions.collision || (o.style == "popup" ? 'fit' :'flip')
			});
	}
});

})(jQuery);

define("jquery-ui-selectmenu", ["jquery","jquery-ui","css!jquery-ui-selectmenu-css"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.selectmenu;
    };
}(this)));

/*!
 * jQuery Cookie Plugin v1.3.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function ($, document, undefined) {

	var pluses = /\+/g;

	function raw(s) {
		return s;
	}

	function decoded(s) {
		return unRfc2068(decodeURIComponent(s.replace(pluses, ' ')));
	}

	function unRfc2068(value) {
		if (value.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape
			value = value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}
		return value;
	}

	function fromJSON(value) {
		return config.json ? JSON.parse(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// write
		if (value !== undefined) {
			options = $.extend({}, config.defaults, options);

			if (value === null) {
				options.expires = -1;
			}

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setDate(t.getDate() + days);
			}

			value = config.json ? JSON.stringify(value) : String(value);

			return (document.cookie = [
				encodeURIComponent(key), '=', config.raw ? value : encodeURIComponent(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// read
		var decode = config.raw ? raw : decoded;
		var cookies = document.cookie.split('; ');
		var result = key ? null : {};
		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = decode(parts.join('='));

			if (key && key === name) {
				result = fromJSON(cookie);
				break;
			}

			if (!key) {
				result[name] = fromJSON(cookie);
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) !== null) {
			$.cookie(key, null, options);
			return true;
		}
		return false;
	};

})(jQuery, document);

define("jquery-cookie", function(){});

/*jslint adsafe: false, bitwise: true, browser: true, cap: false, css: false,
  debug: false, devel: true, eqeqeq: true, es5: false, evil: false,
  forin: false, fragment: false, immed: true, laxbreak: false, newcap: true,
  nomen: false, on: false, onevar: true, passfail: false, plusplus: true,
  regexp: false, rhino: true, safe: false, strict: false, sub: false,
  undef: true, white: false, widget: false, windows: false */
/*global jQuery: false, window: false */


/*
 * Original code (c) 2010 Nick Galbreath
 * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
 *
 * jQuery port (c) 2010 Carlo Zottmann
 * http://github.com/carlo/jquery-base64
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
*/

/* base64 encode/decode compatible with window.btoa/atob
 *
 * window.atob/btoa is a Firefox extension to convert binary data (the "b")
 * to base64 (ascii, the "a").
 *
 * It is also found in Safari and Chrome.  It is not available in IE.
 *
 * if (!window.btoa) window.btoa = $.base64.encode
 * if (!window.atob) window.atob = $.base64.decode
 *
 * The original spec's for atob/btoa are a bit lacking
 * https://developer.mozilla.org/en/DOM/window.atob
 * https://developer.mozilla.org/en/DOM/window.btoa
 *
 * window.btoa and $.base64.encode takes a string where charCodeAt is [0,255]
 * If any character is not [0,255], then an exception is thrown.
 *
 * window.atob and $.base64.decode take a base64-encoded string
 * If the input length is not a multiple of 4, or contains invalid characters
 *   then an exception is thrown.
 */
 
jQuery.base64 = ( function( $ ) {
  
  var _PADCHAR = "=",
    _ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    _VERSION = "1.0";


  function _getbyte64( s, i ) {
    // This is oddly fast, except on Chrome/V8.
    // Minimal or no improvement in performance by using a
    // object with properties mapping chars to value (eg. 'A': 0)

    var idx = _ALPHA.indexOf( s.charAt( i ) );

    if ( idx === -1 ) {
      throw "Cannot decode base64";
    }

    return idx;
  }
  
  
  function _decode( s ) {
    var pads = 0,
      i,
      b10,
      imax = s.length,
      x = [];

    s = String( s );
    
    if ( imax === 0 ) {
      return s;
    }

    if ( imax % 4 !== 0 ) {
      throw "Cannot decode base64";
    }

    if ( s.charAt( imax - 1 ) === _PADCHAR ) {
      pads = 1;

      if ( s.charAt( imax - 2 ) === _PADCHAR ) {
        pads = 2;
      }

      // either way, we want to ignore this last block
      imax -= 4;
    }

    for ( i = 0; i < imax; i += 4 ) {
      b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 ) | _getbyte64( s, i + 3 );
      x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff, b10 & 0xff ) );
    }

    switch ( pads ) {
      case 1:
        b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 );
        x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff ) );
        break;

      case 2:
        b10 = ( _getbyte64( s, i ) << 18) | ( _getbyte64( s, i + 1 ) << 12 );
        x.push( String.fromCharCode( b10 >> 16 ) );
        break;
    }

    return x.join( "" );
  }
  
  
  function _getbyte( s, i ) {
    var x = s.charCodeAt( i );

    if ( x > 255 ) {
      throw "INVALID_CHARACTER_ERR: DOM Exception 5";
    }
    
    return x;
  }


  function _encode( s ) {
    if ( arguments.length !== 1 ) {
      throw "SyntaxError: exactly one argument required";
    }

    s = String( s );

    var i,
      b10,
      x = [],
      imax = s.length - s.length % 3;

    if ( s.length === 0 ) {
      return s;
    }

    for ( i = 0; i < imax; i += 3 ) {
      b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 ) | _getbyte( s, i + 2 );
      x.push( _ALPHA.charAt( b10 >> 18 ) );
      x.push( _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) );
      x.push( _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) );
      x.push( _ALPHA.charAt( b10 & 0x3f ) );
    }

    switch ( s.length - imax ) {
      case 1:
        b10 = _getbyte( s, i ) << 16;
        x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _PADCHAR + _PADCHAR );
        break;

      case 2:
        b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 );
        x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) + _PADCHAR );
        break;
    }

    return x.join( "" );
  }


  return {
    decode: _decode,
    encode: _encode,
    VERSION: _VERSION
  };
      
}( jQuery ) );


define("jquery-base64", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.base64;
    };
}(this)));

(function ($) {
  'use strict';

  function findTruncPoint(dim, max, txt, start, end, $worker, token, reverse) {
    var makeContent = function (content) {
      $worker.text(content);
      $worker[reverse ? 'prepend' : 'append'](token);
    };

    var opt1, opt2, mid, opt1dim, opt2dim;

    if (reverse) {
      opt1 = start === 0 ? '' : txt.slice(-start);
      opt2 = txt.slice(-end);
    } else {
      opt1 = txt.slice(0, start);
      opt2 = txt.slice(0, end);
    }

    if (max < $worker.html(token)[dim]()) {
      return 0;
    }

    makeContent(opt2);
    opt1dim = $worker[dim]();
    makeContent(opt1);
    opt2dim = $worker[dim]();
    if (opt1dim < opt2dim) {
      return end;
    }

    mid = parseInt((start + end) / 2, 10);
    opt1 = reverse ? txt.slice(-mid) : txt.slice(0, mid);

    makeContent(opt1);
    if ($worker[dim]() === max) {
      return mid;
    }

    if ($worker[dim]() > max) {
      end = mid - 1;
    } else {
      start = mid + 1;
    }

    return findTruncPoint(dim, max, txt, start, end, $worker, token, reverse);
  }

  $.fn.truncate = function (options) {
    // backward compatibility
    if (options && !!options.center && !options.side) {
      options.side = 'center';
      delete options.center;
    }

    if (options && !(/^(left|right|center)$/).test(options.side)) {
      delete options.side;
    }

    var defaults = {
      width: 'auto',
      token: '&hellip;',
      side: 'right',
      addclass: false,
      addtitle: false,
      multiline: false,
      assumeSameStyle: false
    };
    options = $.extend(defaults, options);

    var fontCSS;
    var $element;
    var $truncateWorker;
    var elementText;
    
    if (options.assumeSameStyle) {
      $element = $(this[0]);
      fontCSS = {
        'fontFamily': $element.css('fontFamily'),
        'fontSize': $element.css('fontSize'),
        'fontStyle': $element.css('fontStyle'),
        'fontWeight': $element.css('fontWeight'),
        'font-variant': $element.css('font-variant'),
        'text-indent': $element.css('text-indent'),
        'text-transform': $element.css('text-transform'),
        'letter-spacing': $element.css('letter-spacing'),
        'word-spacing': $element.css('word-spacing'),
        'display': 'none'
      };
      $truncateWorker = $('<span/>')
                         .css(fontCSS)
                         .appendTo('body');
    }

    return this.each(function () {
      $element = $(this);
      elementText = $element.text();
      if (!options.assumeSameStyle) {
        fontCSS = {
          'fontFamily': $element.css('fontFamily'),
          'fontSize': $element.css('fontSize'),
          'fontStyle': $element.css('fontStyle'),
          'fontWeight': $element.css('fontWeight'),
          'font-variant': $element.css('font-variant'),
          'text-indent': $element.css('text-indent'),
          'text-transform': $element.css('text-transform'),
          'letter-spacing': $element.css('letter-spacing'),
          'word-spacing': $element.css('word-spacing'),
          'display': 'none'
        };
        $truncateWorker = $('<span/>')
                           .css(fontCSS)
                           .text(elementText)
                           .appendTo('body');
      } else {
        $truncateWorker.text(elementText);
      }
      
      var originalWidth = $truncateWorker.width();
      var truncateWidth = parseInt(options.width, 10) || $element.width();
      var dimension = 'width';
      var truncatedText, originalDim, truncateDim;

      if (options.multiline) {
        $truncateWorker.width($element.width());
        dimension = 'height';
        originalDim = $truncateWorker.height();
        truncateDim = $element.height() + 1;
      }
      else {
        originalDim = originalWidth;
        truncateDim = truncateWidth;
      }

      truncatedText = {before: '', after: ''};
      if (originalDim > truncateDim) {
        var truncPoint, truncPoint2;
        $truncateWorker.text('');

        if (options.side === 'left') {
          truncPoint = findTruncPoint(
            dimension, truncateDim, elementText, 0, elementText.length,
            $truncateWorker, options.token, true
          );
          truncatedText.after = elementText.slice(-1 * truncPoint);

        } else if (options.side === 'center') {
          truncateDim = parseInt(truncateDim / 2, 10) - 1;
          truncPoint = findTruncPoint(
            dimension, truncateDim, elementText, 0, elementText.length,
            $truncateWorker, options.token, false
          );
          truncPoint2 = findTruncPoint(
            dimension, truncateDim, elementText, 0, elementText.length,
            $truncateWorker, '', true
          );
          truncatedText.before = elementText.slice(0, truncPoint);
          truncatedText.after = elementText.slice(-1 * truncPoint2);

        } else if (options.side === 'right') {
          truncPoint = findTruncPoint(
            dimension, truncateDim, elementText, 0, elementText.length,
            $truncateWorker, options.token, false
          );
          truncatedText.before = elementText.slice(0, truncPoint);
        }

        if (options.addclass) {
          $element.addClass(options.addclass);
        }

        if (options.addtitle) {
          $element.attr('title', elementText);
        }

        truncatedText.before = $truncateWorker
                               .text(truncatedText
                                .before).html();
        truncatedText.after = $truncateWorker
                               .text(truncatedText.after)
                               .html();
        $element.empty().html(
          truncatedText.before + options.token + truncatedText.after
        );

      }

      if (!options.assumeSameStyle) {
        $truncateWorker.remove();
      }
    });
    
    if (options.assumeSameStyle) {
      $truncateWorker.remove();
    }
  };
})(jQuery);

define("jquery-truncate", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.truncate;
    };
}(this)));

/**
 * @preserve  textfill
 * @name      jquery.textfill.js
 * @author    Russ Painter
 * @author    Yu-Jie Lin
 * @version   0.4.0
 * @date      2013-08-16
 * @copyright (c) 2012-2013 Yu-Jie Lin
 * @copyright (c) 2009 Russ Painter
 * @license   MIT License
 * @homepage  https://github.com/jquery-textfill/jquery-textfill
 * @example   http://jquery-textfill.github.io/jquery-textfill/index.html
*/
; (function($) {
  /**
  * Resizes an inner element's font so that the inner element completely fills the outer element.
  * @param {Object} Options which are maxFontPixels (default=40), innerTag (default='span')
  * @return All outer elements processed
  */
  $.fn.textfill = function(options) {
    var defaults = {
      debug: false,
      maxFontPixels: 40,
      minFontPixels: 4,
      innerTag: 'span',
      widthOnly: false,
      success: null,          // callback when a resizing is done
      callback: null,         // callback when a resizing is done (deprecated, use success)
      fail: null,             // callback when a resizing is failed
      complete: null,         // callback when all is done
      explicitWidth: null,
      explicitHeight: null
    };
    var Opts = $.extend(defaults, options);

    function _debug() {
      if (!Opts.debug
      ||  typeof console == 'undefined'
      ||  typeof console.debug == 'undefined') {
        return;
      }

      console.debug.apply(console, arguments);
    }

    function _warn() {
      if (typeof console == 'undefined'
      ||  typeof console.warn == 'undefined') {
        return;
      }

      console.warn.apply(console, arguments);
    }

    function _debug_sizing(prefix, ourText, maxHeight, maxWidth, minFontPixels, maxFontPixels) {
      function _m(v1, v2) {
        var marker = ' / ';
        if (v1 > v2) {
          marker = ' > ';
        } else if (v1 == v2) {
          marker = ' = ';
        }
        return marker;
      }

      _debug(
        prefix +
        'font: ' + ourText.css('font-size') +
        ', H: ' + ourText.height() + _m(ourText.height(), maxHeight) + maxHeight +
        ', W: ' + ourText.width()  + _m(ourText.width() , maxWidth)  + maxWidth +
        ', minFontPixels: ' + minFontPixels +
        ', maxFontPixels: ' + maxFontPixels
      );
    }

    function _sizing(prefix, ourText, func, max, maxHeight, maxWidth, minFontPixels, maxFontPixels) {
      _debug_sizing(prefix + ': ', ourText, maxHeight, maxWidth, minFontPixels, maxFontPixels);
      while (minFontPixels < maxFontPixels - 1) {
        var fontSize = Math.floor((minFontPixels + maxFontPixels) / 2)
        ourText.css('font-size', fontSize);
        if (func.call(ourText) <= max) {
          minFontPixels = fontSize;
          if (func.call(ourText) == max) {
            break;
          }
        } else {
          maxFontPixels = fontSize;
        }
        _debug_sizing(prefix + ': ', ourText, maxHeight, maxWidth, minFontPixels, maxFontPixels);
      }
      ourText.css('font-size', maxFontPixels);
      if (func.call(ourText) <= max) {
        minFontPixels = maxFontPixels;
        _debug_sizing(prefix + '* ', ourText, maxHeight, maxWidth, minFontPixels, maxFontPixels);
      }
      return minFontPixels;
    }

    this.each(function() {
      var ourText = $(Opts.innerTag + ':visible:first', this);
      // Use explicit dimensions when specified
      var maxHeight = Opts.explicitHeight || $(this).height();
      var maxWidth = Opts.explicitWidth || $(this).width();
      var oldFontSize = ourText.css('font-size');
      var fontSize;

      _debug('Opts: ', Opts);
      _debug('Vars:' +
        ' maxHeight: ' + maxHeight +
        ', maxWidth: ' + maxWidth
      );

      var minFontPixels = Opts.minFontPixels;
      var maxFontPixels = Opts.maxFontPixels <= 0 ? maxHeight : Opts.maxFontPixels;
      var HfontSize = undefined;
      if (!Opts.widthOnly) {
        HfontSize = _sizing('H', ourText, $.fn.height, maxHeight, maxHeight, maxWidth, minFontPixels, maxFontPixels);
      }
      var WfontSize = _sizing('W', ourText, $.fn.width, maxWidth, maxHeight, maxWidth, minFontPixels, maxFontPixels);

      if (Opts.widthOnly) {
        ourText.css('font-size', WfontSize);
      } else {
        ourText.css('font-size', Math.min(HfontSize, WfontSize));
      }
      _debug('Final: ' + ourText.css('font-size'));

      if (ourText.width()  > maxWidth 
      || (ourText.height() > maxHeight && !Opts.widthOnly)
      ) {
        ourText.css('font-size', oldFontSize);
        if (Opts.fail) {
          Opts.fail(this);
        }
      } else if (Opts.success) {
        Opts.success(this);
      } else if (Opts.callback) {
        _warn('callback is deprecated, use success, instead');
        // call callback on each result
        Opts.callback(this);
      }
    });

    // call complete when all is complete
    if (Opts.complete) Opts.complete(this);

    return this;
  };
})(window.jQuery);

define("jquery-textfill", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.textfill;
    };
}(this)));

/*!
 * jQuery Templates Plugin
 * http://github.com/jquery/jquery-tmpl
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 */
(function( jQuery, undefined ){
	var oldManip = jQuery.fn.domManip, tmplItmAtt = "_tmplitem", htmlExpr = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,
		newTmplItems = {}, wrappedItems = {}, appendToTmplItems, topTmplItem = { key: 0, data: {} }, itemKey = 0, cloneIndex = 0, stack = [];

	function newTmplItem( options, parentItem, fn, data ) {
		// Returns a template item data structure for a new rendered instance of a template (a 'template item').
		// The content field is a hierarchical array of strings and nested items (to be
		// removed and replaced by nodes field of dom elements, once inserted in DOM).
		var newItem = {
			data: data || (parentItem ? parentItem.data : {}),
			_wrap: parentItem ? parentItem._wrap : null,
			tmpl: null,
			parent: parentItem || null,
			nodes: [],
			calls: tiCalls,
			nest: tiNest,
			wrap: tiWrap,
			html: tiHtml,
			update: tiUpdate
		};
		if ( options ) {
			jQuery.extend( newItem, options, { nodes: [], parent: parentItem } );
		}
		if ( fn ) {
			// Build the hierarchical content to be used during insertion into DOM
			newItem.tmpl = fn;
			newItem._ctnt = newItem._ctnt || newItem.tmpl( jQuery, newItem );
			newItem.key = ++itemKey;
			// Keep track of new template item, until it is stored as jQuery Data on DOM element
			(stack.length ? wrappedItems : newTmplItems)[itemKey] = newItem;
		}
		return newItem;
	}

	// Override appendTo etc., in order to provide support for targeting multiple elements. (This code would disappear if integrated in jquery core).
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var ret = [], insert = jQuery( selector ), elems, i, l, tmplItems,
				parent = this.length === 1 && this[0].parentNode;

			appendToTmplItems = newTmplItems || {};
			if ( parent && parent.nodeType === 11 && parent.childNodes.length === 1 && insert.length === 1 ) {
				insert[ original ]( this[0] );
				ret = this;
			} else {
				for ( i = 0, l = insert.length; i < l; i++ ) {
					cloneIndex = i;
					elems = (i > 0 ? this.clone(true) : this).get();
					jQuery.fn[ original ].apply( jQuery(insert[i]), elems );
					ret = ret.concat( elems );
				}
				cloneIndex = 0;
				ret = this.pushStack( ret, name, insert.selector );
			}
			tmplItems = appendToTmplItems;
			appendToTmplItems = null;
			jQuery.tmpl.complete( tmplItems );
			return ret;
		};
	});

	jQuery.fn.extend({
		// Use first wrapped element as template markup.
		// Return wrapped set of template items, obtained by rendering template against data.
		tmpl: function( data, options, parentItem ) {
			return jQuery.tmpl( this[0], data, options, parentItem );
		},

		// Find which rendered template item the first wrapped DOM element belongs to
		tmplItem: function() {
			return jQuery.tmplItem( this[0] );
		},

		// Consider the first wrapped element as a template declaration, and get the compiled template or store it as a named template.
		template: function( name ) {
			return jQuery.template( name, this[0] );
		},

		domManip: function( args, table, callback, options ) {
			// This appears to be a bug in the appendTo, etc. implementation
			// it should be doing .call() instead of .apply(). See #6227
			if ( args[0] && args[0].nodeType ) {
				var dmArgs = jQuery.makeArray( arguments ), argsLength = args.length, i = 0, tmplItem;
				while ( i < argsLength && !(tmplItem = jQuery.data( args[i++], "tmplItem" ))) {}
				if ( argsLength > 1 ) {
					dmArgs[0] = [jQuery.makeArray( args )];
				}
				if ( tmplItem && cloneIndex ) {
					dmArgs[2] = function( fragClone ) {
						// Handler called by oldManip when rendered template has been inserted into DOM.
						jQuery.tmpl.afterManip( this, fragClone, callback );
					};
				}
				oldManip.apply( this, dmArgs );
			} else {
				oldManip.apply( this, arguments );
			}
			cloneIndex = 0;
			if ( !appendToTmplItems ) {
				jQuery.tmpl.complete( newTmplItems );
			}
			return this;
		}
	});

	jQuery.extend({
		// Return wrapped set of template items, obtained by rendering template against data.
		tmpl: function( tmpl, data, options, parentItem ) {
			var ret, topLevel = !parentItem;
			if ( topLevel ) {
				// This is a top-level tmpl call (not from a nested template using {{tmpl}})
				parentItem = topTmplItem;
				tmpl = jQuery.template[tmpl] || jQuery.template( null, tmpl );
				wrappedItems = {}; // Any wrapped items will be rebuilt, since this is top level
			} else if ( !tmpl ) {
				// The template item is already associated with DOM - this is a refresh.
				// Re-evaluate rendered template for the parentItem
				tmpl = parentItem.tmpl;
				newTmplItems[parentItem.key] = parentItem;
				parentItem.nodes = [];
				if ( parentItem.wrapped ) {
					updateWrapped( parentItem, parentItem.wrapped );
				}
				// Rebuild, without creating a new template item
				return jQuery( build( parentItem, null, parentItem.tmpl( jQuery, parentItem ) ));
			}
			if ( !tmpl ) {
				return []; // Could throw...
			}
			if ( typeof data === "function" ) {
				data = data.call( parentItem || {} );
			}
			if ( options && options.wrapped ) {
				updateWrapped( options, options.wrapped );
			}
			ret = jQuery.isArray( data ) ? 
				jQuery.map( data, function( dataItem ) {
					return dataItem ? newTmplItem( options, parentItem, tmpl, dataItem ) : null;
				}) :
				[ newTmplItem( options, parentItem, tmpl, data ) ];
			return topLevel ? jQuery( build( parentItem, null, ret ) ) : ret;
		},

		// Return rendered template item for an element.
		tmplItem: function( elem ) {
			var tmplItem;
			if ( elem instanceof jQuery ) {
				elem = elem[0];
			}
			while ( elem && elem.nodeType === 1 && !(tmplItem = jQuery.data( elem, "tmplItem" )) && (elem = elem.parentNode) ) {}
			return tmplItem || topTmplItem;
		},

		// Set:
		// Use $.template( name, tmpl ) to cache a named template,
		// where tmpl is a template string, a script element or a jQuery instance wrapping a script element, etc.
		// Use $( "selector" ).template( name ) to provide access by name to a script block template declaration.

		// Get:
		// Use $.template( name ) to access a cached template.
		// Also $( selectorToScriptBlock ).template(), or $.template( null, templateString )
		// will return the compiled template, without adding a name reference.
		// If templateString includes at least one HTML tag, $.template( templateString ) is equivalent
		// to $.template( null, templateString )
		template: function( name, tmpl ) {
			if (tmpl) {
				// Compile template and associate with name
				if ( typeof tmpl === "string" ) {
					// This is an HTML string being passed directly in.
					tmpl = buildTmplFn( tmpl )
				} else if ( tmpl instanceof jQuery ) {
					tmpl = tmpl[0] || {};
				}
				if ( tmpl.nodeType ) {
					// If this is a template block, use cached copy, or generate tmpl function and cache.
					tmpl = jQuery.data( tmpl, "tmpl" ) || jQuery.data( tmpl, "tmpl", buildTmplFn( tmpl.innerHTML ));
				}
				return typeof name === "string" ? (jQuery.template[name] = tmpl) : tmpl;
			}
			// Return named compiled template
			return name ? (typeof name !== "string" ? jQuery.template( null, name ): 
				(jQuery.template[name] || 
					// If not in map, treat as a selector. (If integrated with core, use quickExpr.exec) 
					jQuery.template( null, htmlExpr.test( name ) ? name : jQuery( name )))) : null; 
		},

		encode: function( text ) {
			// Do HTML encoding replacing < > & and ' and " by corresponding entities.
			return ("" + text).split("<").join("&lt;").split(">").join("&gt;").split('"').join("&#34;").split("'").join("&#39;");
		}
	});

	jQuery.extend( jQuery.tmpl, {
		tag: {
			"tmpl": {
				_default: { $2: "null" },
				open: "if($notnull_1){_=_.concat($item.nest($1,$2));}"
				// tmpl target parameter can be of type function, so use $1, not $1a (so not auto detection of functions)
				// This means that {{tmpl foo}} treats foo as a template (which IS a function). 
				// Explicit parens can be used if foo is a function that returns a template: {{tmpl foo()}}.
			},
			"wrap": {
				_default: { $2: "null" },
				open: "$item.calls(_,$1,$2);_=[];",
				close: "call=$item.calls();_=call._.concat($item.wrap(call,_));"
			},
			"each": {
				_default: { $2: "$index, $value" },
				open: "if($notnull_1){$.each($1a,function($2){with(this){",
				close: "}});}"
			},
			"if": {
				open: "if(($notnull_1) && $1a){",
				close: "}"
			},
			"else": {
				_default: { $1: "true" },
				open: "}else if(($notnull_1) && $1a){"
			},
			"html": {
				// Unecoded expression evaluation. 
				open: "if($notnull_1){_.push($1a);}"
			},
			"=": {
				// Encoded expression evaluation. Abbreviated form is ${}.
				_default: { $1: "$data" },
				open: "if($notnull_1){_.push($.encode($1a));}"
			},
			"!": {
				// Comment tag. Skipped by parser
				open: ""
			}
		},

		// This stub can be overridden, e.g. in jquery.tmplPlus for providing rendered events
		complete: function( items ) {
			newTmplItems = {};
		},

		// Call this from code which overrides domManip, or equivalent
		// Manage cloning/storing template items etc.
		afterManip: function afterManip( elem, fragClone, callback ) {
			// Provides cloned fragment ready for fixup prior to and after insertion into DOM
			var content = fragClone.nodeType === 11 ?
				jQuery.makeArray(fragClone.childNodes) :
				fragClone.nodeType === 1 ? [fragClone] : [];

			// Return fragment to original caller (e.g. append) for DOM insertion
			callback.call( elem, fragClone );

			// Fragment has been inserted:- Add inserted nodes to tmplItem data structure. Replace inserted element annotations by jQuery.data.
			storeTmplItems( content );
			cloneIndex++;
		}
	});

	//========================== Private helper functions, used by code above ==========================

	function build( tmplItem, nested, content ) {
		// Convert hierarchical content into flat string array 
		// and finally return array of fragments ready for DOM insertion
		var frag, ret = content ? jQuery.map( content, function( item ) {
			return (typeof item === "string") ? 
				// Insert template item annotations, to be converted to jQuery.data( "tmplItem" ) when elems are inserted into DOM.
				(tmplItem.key ? item.replace( /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g, "$1 " + tmplItmAtt + "=\"" + tmplItem.key + "\" $2" ) : item) :
				// This is a child template item. Build nested template.
				build( item, tmplItem, item._ctnt );
		}) : 
		// If content is not defined, insert tmplItem directly. Not a template item. May be a string, or a string array, e.g. from {{html $item.html()}}. 
		tmplItem;
		if ( nested ) {
			return ret;
		}

		// top-level template
		ret = ret.join("");

		// Support templates which have initial or final text nodes, or consist only of text
		// Also support HTML entities within the HTML markup.
		ret.replace( /^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/, function( all, before, middle, after) {
			frag = jQuery( middle ).get();

			storeTmplItems( frag );
			if ( before ) {
				frag = unencode( before ).concat(frag);
			}
			if ( after ) {
				frag = frag.concat(unencode( after ));
			}
		});
		return frag ? frag : unencode( ret );
	}

	function unencode( text ) {
		// Use createElement, since createTextNode will not render HTML entities correctly
		var el = document.createElement( "div" );
		el.innerHTML = text;
		return jQuery.makeArray(el.childNodes);
	}

	// Generate a reusable function that will serve to render a template against data
	function buildTmplFn( markup ) {
		return new Function("jQuery","$item",
			"var $=jQuery,call,_=[],$data=$item.data;" +

			// Introduce the data as local variables using with(){}
			"with($data){_.push('" +

			// Convert the template into pure JavaScript
			jQuery.trim(markup)
				.replace( /([\\'])/g, "\\$1" )
				.replace( /[\r\t\n]/g, " " )
				.replace( /\$\{([^\}]*)\}/g, "{{= $1}}" )
				.replace( /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
				function( all, slash, type, fnargs, target, parens, args ) {
					var tag = jQuery.tmpl.tag[ type ], def, expr, exprAutoFnDetect;
					if ( !tag ) {
						throw "Template command not found: " + type;
					}
					def = tag._default || [];
					if ( parens && !/\w$/.test(target)) {
						target += parens;
						parens = "";
					}
					if ( target ) {
						target = unescape( target ); 
						args = args ? ("," + unescape( args ) + ")") : (parens ? ")" : "");
						// Support for target being things like a.toLowerCase();
						// In that case don't call with template item as 'this' pointer. Just evaluate...
						expr = parens ? (target.indexOf(".") > -1 ? target + parens : ("(" + target + ").call($item" + args)) : target;
						exprAutoFnDetect = parens ? expr : "(typeof(" + target + ")==='function'?(" + target + ").call($item):(" + target + "))";
					} else {
						exprAutoFnDetect = expr = def.$1 || "null";
					}
					fnargs = unescape( fnargs );
					return "');" + 
						tag[ slash ? "close" : "open" ]
							.split( "$notnull_1" ).join( target ? "typeof(" + target + ")!=='undefined' && (" + target + ")!=null" : "true" )
							.split( "$1a" ).join( exprAutoFnDetect )
							.split( "$1" ).join( expr )
							.split( "$2" ).join( fnargs ?
								fnargs.replace( /\s*([^\(]+)\s*(\((.*?)\))?/g, function( all, name, parens, params ) {
									params = params ? ("," + params + ")") : (parens ? ")" : "");
									return params ? ("(" + name + ").call($item" + params) : all;
								})
								: (def.$2||"")
							) +
						"_.push('";
				}) +
			"');}return _;"
		);
	}
	function updateWrapped( options, wrapped ) {
		// Build the wrapped content. 
		options._wrap = build( options, true, 
			// Suport imperative scenario in which options.wrapped can be set to a selector or an HTML string.
			jQuery.isArray( wrapped ) ? wrapped : [htmlExpr.test( wrapped ) ? wrapped : jQuery( wrapped ).html()]
		).join("");
	}

	function unescape( args ) {
		return args ? args.replace( /\\'/g, "'").replace(/\\\\/g, "\\" ) : null;
	}
	function outerHtml( elem ) {
		var div = document.createElement("div");
		div.appendChild( elem.cloneNode(true) );
		return div.innerHTML;
	}

	// Store template items in jQuery.data(), ensuring a unique tmplItem data data structure for each rendered template instance.
	function storeTmplItems( content ) {
		var keySuffix = "_" + cloneIndex, elem, elems, newClonedItems = {}, i, l, m;
		for ( i = 0, l = content.length; i < l; i++ ) {
			if ( (elem = content[i]).nodeType !== 1 ) {
				continue;
			}
			elems = elem.getElementsByTagName("*");
			for ( m = elems.length - 1; m >= 0; m-- ) {
				processItemKey( elems[m] );
			}
			processItemKey( elem );
		}
		function processItemKey( el ) {
			var pntKey, pntNode = el, pntItem, tmplItem, key;
			// Ensure that each rendered template inserted into the DOM has its own template item,
			if ( (key = el.getAttribute( tmplItmAtt ))) {
				while ( pntNode.parentNode && (pntNode = pntNode.parentNode).nodeType === 1 && !(pntKey = pntNode.getAttribute( tmplItmAtt ))) { }
				if ( pntKey !== key ) {
					// The next ancestor with a _tmplitem expando is on a different key than this one.
					// So this is a top-level element within this template item
					// Set pntNode to the key of the parentNode, or to 0 if pntNode.parentNode is null, or pntNode is a fragment.
					pntNode = pntNode.parentNode ? (pntNode.nodeType === 11 ? 0 : (pntNode.getAttribute( tmplItmAtt ) || 0)) : 0;
					if ( !(tmplItem = newTmplItems[key]) ) {
						// The item is for wrapped content, and was copied from the temporary parent wrappedItem.
						tmplItem = wrappedItems[key];
						tmplItem = newTmplItem( tmplItem, newTmplItems[pntNode]||wrappedItems[pntNode], null, true );
						tmplItem.key = ++itemKey;
						newTmplItems[itemKey] = tmplItem;
					}
					if ( cloneIndex ) {
						cloneTmplItem( key );
					}
				}
				el.removeAttribute( tmplItmAtt );
			} else if ( cloneIndex && (tmplItem = jQuery.data( el, "tmplItem" )) ) {
				// This was a rendered element, cloned during append or appendTo etc.
				// TmplItem stored in jQuery data has already been cloned in cloneCopyEvent. We must replace it with a fresh cloned tmplItem.
				cloneTmplItem( tmplItem.key );
				newTmplItems[tmplItem.key] = tmplItem;
				pntNode = jQuery.data( el.parentNode, "tmplItem" );
				pntNode = pntNode ? pntNode.key : 0;
			}
			if ( tmplItem ) {
				pntItem = tmplItem;
				// Find the template item of the parent element. 
				// (Using !=, not !==, since pntItem.key is number, and pntNode may be a string)
				while ( pntItem && pntItem.key != pntNode ) { 
					// Add this element as a top-level node for this rendered template item, as well as for any
					// ancestor items between this item and the item of its parent element
					pntItem.nodes.push( el );
					pntItem = pntItem.parent;
				}
				// Delete content built during rendering - reduce API surface area and memory use, and avoid exposing of stale data after rendering...
				delete tmplItem._ctnt;
				delete tmplItem._wrap;
				// Store template item as jQuery data on the element
				jQuery.data( el, "tmplItem", tmplItem );
			}
			function cloneTmplItem( key ) {
				key = key + keySuffix;
				tmplItem = newClonedItems[key] = 
					(newClonedItems[key] || newTmplItem( tmplItem, newTmplItems[tmplItem.parent.key + keySuffix] || tmplItem.parent, null, true ));
			}
		}
	}

	//---- Helper functions for template item ----

	function tiCalls( content, tmpl, data, options ) {
		if ( !content ) {
			return stack.pop();
		}
		stack.push({ _: content, tmpl: tmpl, item:this, data: data, options: options });
	}

	function tiNest( tmpl, data, options ) {
		// nested template, using {{tmpl}} tag
		return jQuery.tmpl( jQuery.template( tmpl ), data, options, this );
	}

	function tiWrap( call, wrapped ) {
		// nested template, using {{wrap}} tag
		var options = call.options || {};
		options.wrapped = wrapped;
		// Apply the template, which may incorporate wrapped content, 
		return jQuery.tmpl( jQuery.template( call.tmpl ), call.data, options, call.item );
	}

	function tiHtml( filter, textOnly ) {
		var wrapped = this._wrap;
		return jQuery.map(
			jQuery( jQuery.isArray( wrapped ) ? wrapped.join("") : wrapped ).filter( filter || "*" ),
			function(e) {
				return textOnly ?
					e.innerText || e.textContent :
					e.outerHTML || outerHtml(e);
			});
	}

	function tiUpdate() {
		var coll = this.nodes;
		jQuery.tmpl( null, null, null, this).insertBefore( coll[0] );
		jQuery( coll ).remove();
	}
})( jQuery );

define("jquery-tmpl", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.tmpl;
    };
}(this)));

/*!
 * jQuery hashchange event - v1.3 - 7/21/2010
 * http://benalman.com/projects/jquery-hashchange-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery hashchange event
//
// *Version: 1.3, Last updated: 7/21/2010*
// 
// Project Home - http://benalman.com/projects/jquery-hashchange-plugin/
// GitHub       - http://github.com/cowboy/jquery-hashchange/
// Source       - http://github.com/cowboy/jquery-hashchange/raw/master/jquery.ba-hashchange.js
// (Minified)   - http://github.com/cowboy/jquery-hashchange/raw/master/jquery.ba-hashchange.min.js (0.8kb gzipped)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// hashchange event - http://benalman.com/code/projects/jquery-hashchange/examples/hashchange/
// document.domain - http://benalman.com/code/projects/jquery-hashchange/examples/document_domain/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - 1.2.6, 1.3.2, 1.4.1, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-4, Chrome 5-6, Safari 3.2-5,
//                   Opera 9.6-10.60, iPhone 3.1, Android 1.6-2.2, BlackBerry 4.6-5.
// Unit Tests      - http://benalman.com/code/projects/jquery-hashchange/unit/
// 
// About: Known issues
// 
// While this jQuery hashchange event implementation is quite stable and
// robust, there are a few unfortunate browser bugs surrounding expected
// hashchange event-based behaviors, independent of any JavaScript
// window.onhashchange abstraction. See the following examples for more
// information:
// 
// Chrome: Back Button - http://benalman.com/code/projects/jquery-hashchange/examples/bug-chrome-back-button/
// Firefox: Remote XMLHttpRequest - http://benalman.com/code/projects/jquery-hashchange/examples/bug-firefox-remote-xhr/
// WebKit: Back Button in an Iframe - http://benalman.com/code/projects/jquery-hashchange/examples/bug-webkit-hash-iframe/
// Safari: Back Button from a different domain - http://benalman.com/code/projects/jquery-hashchange/examples/bug-safari-back-from-diff-domain/
// 
// Also note that should a browser natively support the window.onhashchange 
// event, but not report that it does, the fallback polling loop will be used.
// 
// About: Release History
// 
// 1.3   - (7/21/2010) Reorganized IE6/7 Iframe code to make it more
//         "removable" for mobile-only development. Added IE6/7 document.title
//         support. Attempted to make Iframe as hidden as possible by using
//         techniques from http://www.paciellogroup.com/blog/?p=604. Added 
//         support for the "shortcut" format $(window).hashchange( fn ) and
//         $(window).hashchange() like jQuery provides for built-in events.
//         Renamed jQuery.hashchangeDelay to <jQuery.fn.hashchange.delay> and
//         lowered its default value to 50. Added <jQuery.fn.hashchange.domain>
//         and <jQuery.fn.hashchange.src> properties plus document-domain.html
//         file to address access denied issues when setting document.domain in
//         IE6/7.
// 1.2   - (2/11/2010) Fixed a bug where coming back to a page using this plugin
//         from a page on another domain would cause an error in Safari 4. Also,
//         IE6/7 Iframe is now inserted after the body (this actually works),
//         which prevents the page from scrolling when the event is first bound.
//         Event can also now be bound before DOM ready, but it won't be usable
//         before then in IE6/7.
// 1.1   - (1/21/2010) Incorporated document.documentMode test to fix IE8 bug
//         where browser version is incorrectly reported as 8.0, despite
//         inclusion of the X-UA-Compatible IE=EmulateIE7 meta tag.
// 1.0   - (1/9/2010) Initial Release. Broke out the jQuery BBQ event.special
//         window.onhashchange functionality into a separate plugin for users
//         who want just the basic event & back button support, without all the
//         extra awesomeness that BBQ provides. This plugin will be included as
//         part of jQuery BBQ, but also be available separately.

(function($,window,undefined){
  '$:nomunge'; // Used by YUI compressor.
  
  // Reused string.
  var str_hashchange = 'hashchange',
    
    // Method / object references.
    doc = document,
    fake_onhashchange,
    special = $.event.special,
    
    // Does the browser support window.onhashchange? Note that IE8 running in
    // IE7 compatibility mode reports true for 'onhashchange' in window, even
    // though the event isn't supported, so also test document.documentMode.
    doc_mode = doc.documentMode,
    supports_onhashchange = 'on' + str_hashchange in window && ( doc_mode === undefined || doc_mode > 7 );
  
  // Get location.hash (or what you'd expect location.hash to be) sans any
  // leading #. Thanks for making this necessary, Firefox!
  function get_fragment( url ) {
    url = url || location.href;
    return '#' + url.replace( /^[^#]*#?(.*)$/, '$1' );
  };
  
  // Method: jQuery.fn.hashchange
  // 
  // Bind a handler to the window.onhashchange event or trigger all bound
  // window.onhashchange event handlers. This behavior is consistent with
  // jQuery's built-in event handlers.
  // 
  // Usage:
  // 
  // > jQuery(window).hashchange( [ handler ] );
  // 
  // Arguments:
  // 
  //  handler - (Function) Optional handler to be bound to the hashchange
  //    event. This is a "shortcut" for the more verbose form:
  //    jQuery(window).bind( 'hashchange', handler ). If handler is omitted,
  //    all bound window.onhashchange event handlers will be triggered. This
  //    is a shortcut for the more verbose
  //    jQuery(window).trigger( 'hashchange' ). These forms are described in
  //    the <hashchange event> section.
  // 
  // Returns:
  // 
  //  (jQuery) The initial jQuery collection of elements.
  
  // Allow the "shortcut" format $(elem).hashchange( fn ) for binding and
  // $(elem).hashchange() for triggering, like jQuery does for built-in events.
  $.fn[ str_hashchange ] = function( fn ) {
    return fn ? this.bind( str_hashchange, fn ) : this.trigger( str_hashchange );
  };
  
  // Property: jQuery.fn.hashchange.delay
  // 
  // The numeric interval (in milliseconds) at which the <hashchange event>
  // polling loop executes. Defaults to 50.
  
  // Property: jQuery.fn.hashchange.domain
  // 
  // If you're setting document.domain in your JavaScript, and you want hash
  // history to work in IE6/7, not only must this property be set, but you must
  // also set document.domain BEFORE jQuery is loaded into the page. This
  // property is only applicable if you are supporting IE6/7 (or IE8 operating
  // in "IE7 compatibility" mode).
  // 
  // In addition, the <jQuery.fn.hashchange.src> property must be set to the
  // path of the included "document-domain.html" file, which can be renamed or
  // modified if necessary (note that the document.domain specified must be the
  // same in both your main JavaScript as well as in this file).
  // 
  // Usage:
  // 
  // jQuery.fn.hashchange.domain = document.domain;
  
  // Property: jQuery.fn.hashchange.src
  // 
  // If, for some reason, you need to specify an Iframe src file (for example,
  // when setting document.domain as in <jQuery.fn.hashchange.domain>), you can
  // do so using this property. Note that when using this property, history
  // won't be recorded in IE6/7 until the Iframe src file loads. This property
  // is only applicable if you are supporting IE6/7 (or IE8 operating in "IE7
  // compatibility" mode).
  // 
  // Usage:
  // 
  // jQuery.fn.hashchange.src = 'path/to/file.html';
  
  $.fn[ str_hashchange ].delay = 50;
  /*
  $.fn[ str_hashchange ].domain = null;
  $.fn[ str_hashchange ].src = null;
  */
  
  // Event: hashchange event
  // 
  // Fired when location.hash changes. In browsers that support it, the native
  // HTML5 window.onhashchange event is used, otherwise a polling loop is
  // initialized, running every <jQuery.fn.hashchange.delay> milliseconds to
  // see if the hash has changed. In IE6/7 (and IE8 operating in "IE7
  // compatibility" mode), a hidden Iframe is created to allow the back button
  // and hash-based history to work.
  // 
  // Usage as described in <jQuery.fn.hashchange>:
  // 
  // > // Bind an event handler.
  // > jQuery(window).hashchange( function(e) {
  // >   var hash = location.hash;
  // >   ...
  // > });
  // > 
  // > // Manually trigger the event handler.
  // > jQuery(window).hashchange();
  // 
  // A more verbose usage that allows for event namespacing:
  // 
  // > // Bind an event handler.
  // > jQuery(window).bind( 'hashchange', function(e) {
  // >   var hash = location.hash;
  // >   ...
  // > });
  // > 
  // > // Manually trigger the event handler.
  // > jQuery(window).trigger( 'hashchange' );
  // 
  // Additional Notes:
  // 
  // * The polling loop and Iframe are not created until at least one handler
  //   is actually bound to the 'hashchange' event.
  // * If you need the bound handler(s) to execute immediately, in cases where
  //   a location.hash exists on page load, via bookmark or page refresh for
  //   example, use jQuery(window).hashchange() or the more verbose 
  //   jQuery(window).trigger( 'hashchange' ).
  // * The event can be bound before DOM ready, but since it won't be usable
  //   before then in IE6/7 (due to the necessary Iframe), recommended usage is
  //   to bind it inside a DOM ready handler.
  
  // Override existing $.event.special.hashchange methods (allowing this plugin
  // to be defined after jQuery BBQ in BBQ's source code).
  special[ str_hashchange ] = $.extend( special[ str_hashchange ], {
    
    // Called only when the first 'hashchange' event is bound to window.
    setup: function() {
      // If window.onhashchange is supported natively, there's nothing to do..
      if ( supports_onhashchange ) { return false; }
      
      // Otherwise, we need to create our own. And we don't want to call this
      // until the user binds to the event, just in case they never do, since it
      // will create a polling loop and possibly even a hidden Iframe.
      $( fake_onhashchange.start );
    },
    
    // Called only when the last 'hashchange' event is unbound from window.
    teardown: function() {
      // If window.onhashchange is supported natively, there's nothing to do..
      if ( supports_onhashchange ) { return false; }
      
      // Otherwise, we need to stop ours (if possible).
      $( fake_onhashchange.stop );
    }
    
  });
  
  // fake_onhashchange does all the work of triggering the window.onhashchange
  // event for browsers that don't natively support it, including creating a
  // polling loop to watch for hash changes and in IE 6/7 creating a hidden
  // Iframe to enable back and forward.
  fake_onhashchange = (function(){
    var self = {},
      timeout_id,
      
      // Remember the initial hash so it doesn't get triggered immediately.
      last_hash = get_fragment(),
      
      fn_retval = function(val){ return val; },
      history_set = fn_retval,
      history_get = fn_retval;
    
    // Start the polling loop.
    self.start = function() {
      timeout_id || poll();
    };
    
    // Stop the polling loop.
    self.stop = function() {
      timeout_id && clearTimeout( timeout_id );
      timeout_id = undefined;
    };
    
    // This polling loop checks every $.fn.hashchange.delay milliseconds to see
    // if location.hash has changed, and triggers the 'hashchange' event on
    // window when necessary.
    function poll() {
      var hash = get_fragment(),
        history_hash = history_get( last_hash );
      
      if ( hash !== last_hash ) {
        history_set( last_hash = hash, history_hash );
        
        $(window).trigger( str_hashchange );
        
      } else if ( history_hash !== last_hash ) {
        location.href = location.href.replace( /#.*/, '' ) + history_hash;
      }
      
      timeout_id = setTimeout( poll, $.fn[ str_hashchange ].delay );
    };
    
    // vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
    // vvvvvvvvvvvvvvvvvvv REMOVE IF NOT SUPPORTING IE6/7/8 vvvvvvvvvvvvvvvvvvv
    // vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
    $.browser.msie && !supports_onhashchange && (function(){
      // Not only do IE6/7 need the "magical" Iframe treatment, but so does IE8
      // when running in "IE7 compatibility" mode.
      
      var iframe,
        iframe_src;
      
      // When the event is bound and polling starts in IE 6/7, create a hidden
      // Iframe for history handling.
      self.start = function(){
        if ( !iframe ) {
          iframe_src = $.fn[ str_hashchange ].src;
          iframe_src = iframe_src && iframe_src + get_fragment();
          
          // Create hidden Iframe. Attempt to make Iframe as hidden as possible
          // by using techniques from http://www.paciellogroup.com/blog/?p=604.
          iframe = $('<iframe tabindex="-1" title="empty"/>').hide()
            
            // When Iframe has completely loaded, initialize the history and
            // start polling.
            .one( 'load', function(){
              iframe_src || history_set( get_fragment() );
              poll();
            })
            
            // Load Iframe src if specified, otherwise nothing.
            .attr( 'src', iframe_src || 'javascript:0' )
            
            // Append Iframe after the end of the body to prevent unnecessary
            // initial page scrolling (yes, this works).
            .insertAfter( 'body' )[0].contentWindow;
          
          // Whenever `document.title` changes, update the Iframe's title to
          // prettify the back/next history menu entries. Since IE sometimes
          // errors with "Unspecified error" the very first time this is set
          // (yes, very useful) wrap this with a try/catch block.
          doc.onpropertychange = function(){
            try {
              if ( event.propertyName === 'title' ) {
                iframe.document.title = doc.title;
              }
            } catch(e) {}
          };
          
        }
      };
      
      // Override the "stop" method since an IE6/7 Iframe was created. Even
      // if there are no longer any bound event handlers, the polling loop
      // is still necessary for back/next to work at all!
      self.stop = fn_retval;
      
      // Get history by looking at the hidden Iframe's location.hash.
      history_get = function() {
        return get_fragment( iframe.location.href );
      };
      
      // Set a new history item by opening and then closing the Iframe
      // document, *then* setting its location.hash. If document.domain has
      // been set, update that as well.
      history_set = function( hash, history_hash ) {
        var iframe_doc = iframe.document,
          domain = $.fn[ str_hashchange ].domain;
        
        if ( hash !== history_hash ) {
          // Update Iframe with any initial `document.title` that might be set.
          iframe_doc.title = doc.title;
          
          // Opening the Iframe's document after it has been closed is what
          // actually adds a history entry.
          iframe_doc.open();
          
          // Set document.domain for the Iframe document as well, if necessary.
          domain && iframe_doc.write( '<script>document.domain="' + domain + '"</script>' );
          
          iframe_doc.close();
          
          // Update the Iframe's hash, for great justice.
          iframe.location.hash = hash;
        }
      };
      
    })();
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    // ^^^^^^^^^^^^^^^^^^^ REMOVE IF NOT SUPPORTING IE6/7/8 ^^^^^^^^^^^^^^^^^^^
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    
    return self;
  })();
  
})(jQuery,this);

define("hashchange", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.hashchange;
    };
}(this)));

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/ui_components/widget',['jquery', 'jquery-ui'], function ($) {
    // Base widget with utility methods
    $.widget('ty.widget', {
      /**
       * Attaches and records one or more event handlers. This method delegates to jQuery.on.
       * Handlers attached with this method can be removed by passing the same parameters to _off.
       * @param tuple an array of arguments that will be passed ot jQuery.on
       * @param [$element] the element to attach the handler to
       * @protected
       */
      _on: function (tuple, $element) {
        var _$element;

        var eventHandlers = this.eventHandlers;

        // A list of event handlers registered on the widget
        if (!eventHandlers) {
          eventHandlers = this.eventHandlers = [];
        }
        if (!$element) {
          $element = this.element;
        }
        eventHandlers.push({ tuple: tuple, $element: $element });
        (_$element = $element).on.apply(_$element, _toConsumableArray(tuple));
      },


      /**
       * Removes an event handler attached with _on. The arguments must be the same
       * as the ones passed when attaching the handler (event, selector, data, handler)
       * @protected
       */
      _off: function (tuple, $element) {
        var attached = void 0,
            i = void 0;
        var eventHandlers = this.eventHandlers;
        if (!eventHandlers) {
          return;
        }

        if (!$element) {
          $element = this.element;
        }

        var tupleEq = function (t1, t2) {
          var j = void 0;
          if (t1 === t2) {
            return true;
          }
          if (t1.length !== t2.length) {
            return false;
          }
          for (j = 0; j < t1.length; j += 1) {
            if (t1[j] !== t2[j]) {
              return false;
            }
          }
          return true;
        };

        for (i = eventHandlers.length - 1; i >= 0; i -= 1) {
          attached = eventHandlers[i];
          if ($element.is(attached.$element) && tupleEq(attached.tuple, tuple)) {
            var _$element2;

            (_$element2 = $element).off.apply(_$element2, _toConsumableArray(tuple));
            eventHandlers.splice(i, 1);
          }
        }
      },


      /**
       * Removes all the event handlers attached with _on.
       * @protected
       */
      _removeEventHandlers: function () {
        var attached = void 0;
        var eventHandlers = this.eventHandlers;
        while (eventHandlers && eventHandlers.length) {
          attached = eventHandlers[eventHandlers.length - 1];
          this._off(attached.tuple, attached.$element);
        }
      },


      /**
       * Performs cleanup, before calling the base widget's destroy.
       */
      destroy: function () {
        // allow the subclass to clean up
        this._destroy.apply(this, arguments); // eslint-disable-line prefer-rest-params

        // remove event handlers
        this._removeEventHandlers();

        // super
        return $.Widget.prototype.destroy.apply(this, arguments); // eslint-disable-line prefer-rest-params
      },


      // stub method
      _destroy: function () {},


      /**
       * Returns a function that will call 'fn' if 'this.disabled' is falsy. Useful to create
       * event handlers that don't fire when the widget is disabled.
       * @param fn
       * @return {Function}
       * @protected
       */
      _callWhenEnabled: function (fn) {
        var self = this;
        return function () {
          if (self.disabled) {
            return;
          }
          fn.apply(this, arguments); // eslint-disable-line prefer-rest-params
        };
      }
    });

    return $.ty.widget;
  });
})();
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
eval(function(p,a,c,k,e,r){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)r[e(c)]=k[c]||e(c);k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('h.i[\'1a\']=h.i[\'z\'];h.O(h.i,{y:\'D\',z:9(x,t,b,c,d){6 h.i[h.i.y](x,t,b,c,d)},17:9(x,t,b,c,d){6 c*(t/=d)*t+b},D:9(x,t,b,c,d){6-c*(t/=d)*(t-2)+b},13:9(x,t,b,c,d){e((t/=d/2)<1)6 c/2*t*t+b;6-c/2*((--t)*(t-2)-1)+b},X:9(x,t,b,c,d){6 c*(t/=d)*t*t+b},U:9(x,t,b,c,d){6 c*((t=t/d-1)*t*t+1)+b},R:9(x,t,b,c,d){e((t/=d/2)<1)6 c/2*t*t*t+b;6 c/2*((t-=2)*t*t+2)+b},N:9(x,t,b,c,d){6 c*(t/=d)*t*t*t+b},M:9(x,t,b,c,d){6-c*((t=t/d-1)*t*t*t-1)+b},L:9(x,t,b,c,d){e((t/=d/2)<1)6 c/2*t*t*t*t+b;6-c/2*((t-=2)*t*t*t-2)+b},K:9(x,t,b,c,d){6 c*(t/=d)*t*t*t*t+b},J:9(x,t,b,c,d){6 c*((t=t/d-1)*t*t*t*t+1)+b},I:9(x,t,b,c,d){e((t/=d/2)<1)6 c/2*t*t*t*t*t+b;6 c/2*((t-=2)*t*t*t*t+2)+b},G:9(x,t,b,c,d){6-c*8.C(t/d*(8.g/2))+c+b},15:9(x,t,b,c,d){6 c*8.n(t/d*(8.g/2))+b},12:9(x,t,b,c,d){6-c/2*(8.C(8.g*t/d)-1)+b},Z:9(x,t,b,c,d){6(t==0)?b:c*8.j(2,10*(t/d-1))+b},Y:9(x,t,b,c,d){6(t==d)?b+c:c*(-8.j(2,-10*t/d)+1)+b},W:9(x,t,b,c,d){e(t==0)6 b;e(t==d)6 b+c;e((t/=d/2)<1)6 c/2*8.j(2,10*(t-1))+b;6 c/2*(-8.j(2,-10*--t)+2)+b},V:9(x,t,b,c,d){6-c*(8.o(1-(t/=d)*t)-1)+b},S:9(x,t,b,c,d){6 c*8.o(1-(t=t/d-1)*t)+b},Q:9(x,t,b,c,d){e((t/=d/2)<1)6-c/2*(8.o(1-t*t)-1)+b;6 c/2*(8.o(1-(t-=2)*t)+1)+b},P:9(x,t,b,c,d){f s=1.l;f p=0;f a=c;e(t==0)6 b;e((t/=d)==1)6 b+c;e(!p)p=d*.3;e(a<8.w(c)){a=c;f s=p/4}m f s=p/(2*8.g)*8.r(c/a);6-(a*8.j(2,10*(t-=1))*8.n((t*d-s)*(2*8.g)/p))+b},H:9(x,t,b,c,d){f s=1.l;f p=0;f a=c;e(t==0)6 b;e((t/=d)==1)6 b+c;e(!p)p=d*.3;e(a<8.w(c)){a=c;f s=p/4}m f s=p/(2*8.g)*8.r(c/a);6 a*8.j(2,-10*t)*8.n((t*d-s)*(2*8.g)/p)+c+b},T:9(x,t,b,c,d){f s=1.l;f p=0;f a=c;e(t==0)6 b;e((t/=d/2)==2)6 b+c;e(!p)p=d*(.3*1.5);e(a<8.w(c)){a=c;f s=p/4}m f s=p/(2*8.g)*8.r(c/a);e(t<1)6-.5*(a*8.j(2,10*(t-=1))*8.n((t*d-s)*(2*8.g)/p))+b;6 a*8.j(2,-10*(t-=1))*8.n((t*d-s)*(2*8.g)/p)*.5+c+b},F:9(x,t,b,c,d,s){e(s==u)s=1.l;6 c*(t/=d)*t*((s+1)*t-s)+b},E:9(x,t,b,c,d,s){e(s==u)s=1.l;6 c*((t=t/d-1)*t*((s+1)*t+s)+1)+b},16:9(x,t,b,c,d,s){e(s==u)s=1.l;e((t/=d/2)<1)6 c/2*(t*t*(((s*=(1.B))+1)*t-s))+b;6 c/2*((t-=2)*t*(((s*=(1.B))+1)*t+s)+2)+b},A:9(x,t,b,c,d){6 c-h.i.v(x,d-t,0,c,d)+b},v:9(x,t,b,c,d){e((t/=d)<(1/2.k)){6 c*(7.q*t*t)+b}m e(t<(2/2.k)){6 c*(7.q*(t-=(1.5/2.k))*t+.k)+b}m e(t<(2.5/2.k)){6 c*(7.q*(t-=(2.14/2.k))*t+.11)+b}m{6 c*(7.q*(t-=(2.18/2.k))*t+.19)+b}},1b:9(x,t,b,c,d){e(t<d/2)6 h.i.A(x,t*2,0,c,d)*.5+b;6 h.i.v(x,t*2-d,0,c,d)*.5+c*.5+b}});',62,74,'||||||return||Math|function|||||if|var|PI|jQuery|easing|pow|75|70158|else|sin|sqrt||5625|asin|||undefined|easeOutBounce|abs||def|swing|easeInBounce|525|cos|easeOutQuad|easeOutBack|easeInBack|easeInSine|easeOutElastic|easeInOutQuint|easeOutQuint|easeInQuint|easeInOutQuart|easeOutQuart|easeInQuart|extend|easeInElastic|easeInOutCirc|easeInOutCubic|easeOutCirc|easeInOutElastic|easeOutCubic|easeInCirc|easeInOutExpo|easeInCubic|easeOutExpo|easeInExpo||9375|easeInOutSine|easeInOutQuad|25|easeOutSine|easeInOutBack|easeInQuad|625|984375|jswing|easeInOutBounce'.split('|'),0,{}))

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */
;
define("easing", ["jquery"], function(){});


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('fancyboxCss.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*
 * FancyBox - jQuery Plugin
 * Simple and fancy lightbox alternative
 *
 * Examples and documentation at: http://fancybox.net
 *
 * Copyright (c) 2008 - 2010 Janis Skarnelis
 * That said, it is hardly a one-person project. Many people have submitted bugs, code, and offered their advice freely. Their support is greatly appreciated.
 *
 * Version: 1.3.4 (11/11/2010)
 * Requires: jQuery v1.3+
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */

;(function($) {
	var tmp, loading, overlay, wrap, outer, content, close, title, nav_left, nav_right,

		selectedIndex = 0, selectedOpts = {}, selectedArray = [], currentIndex = 0, currentOpts = {}, currentArray = [],

		ajaxLoader = null, imgPreloader = new Image(), imgRegExp = /\.(jpg|gif|png|bmp|jpeg)(.*)?$/i, swfRegExp = /[^\.]\.(swf)\s*$/i,

		loadingTimer, loadingFrame = 1,

		titleHeight = 0, titleStr = '', start_pos, final_pos, busy = false, fx = $.extend($('<div/>')[0], { prop: 0 }),

		isIE6 = $.browser.msie && $.browser.version < 7 && !window.XMLHttpRequest,

		/*
		 * Private methods 
		 */

		_abort = function() {
			loading.hide();

			imgPreloader.onerror = imgPreloader.onload = null;

			if (ajaxLoader) {
				ajaxLoader.abort();
			}

			tmp.empty();
		},

		_error = function() {
			if (false === selectedOpts.onError(selectedArray, selectedIndex, selectedOpts)) {
				loading.hide();
				busy = false;
				return;
			}

			selectedOpts.titleShow = false;

			selectedOpts.width = 'auto';
			selectedOpts.height = 'auto';

			tmp.html( '<p id="fancybox-error">The requested content cannot be loaded.<br />Please try again later.</p>' );

			_process_inline();
		},

		_start = function() {
			var obj = selectedArray[ selectedIndex ],
				href, 
				type, 
				title,
				str,
				emb,
				ret;

			_abort();

			selectedOpts = $.extend({}, $.fn.fancybox.defaults, (typeof $(obj).data('fancybox') == 'undefined' ? selectedOpts : $(obj).data('fancybox')));

			ret = selectedOpts.onStart(selectedArray, selectedIndex, selectedOpts);

			if (ret === false) {
				busy = false;
				return;
			} else if (typeof ret == 'object') {
				selectedOpts = $.extend(selectedOpts, ret);
			}

			title = selectedOpts.title || (obj.nodeName ? $(obj).attr('title') : obj.title) || '';

			if (obj.nodeName && !selectedOpts.orig) {
				selectedOpts.orig = $(obj).children("img:first").length ? $(obj).children("img:first") : $(obj);
			}

			if (title === '' && selectedOpts.orig && selectedOpts.titleFromAlt) {
				title = selectedOpts.orig.attr('alt');
			}

			href = selectedOpts.href || (obj.nodeName ? $(obj).attr('href') : obj.href) || null;

			if ((/^(?:javascript)/i).test(href) || href == '#') {
				href = null;
			}

			if (selectedOpts.type) {
				type = selectedOpts.type;

				if (!href) {
					href = selectedOpts.content;
				}

			} else if (selectedOpts.content) {
				type = 'html';

			} else if (href) {
				if (href.match(imgRegExp)) {
					type = 'image';

				} else if (href.match(swfRegExp)) {
					type = 'swf';

				} else if ($(obj).hasClass("iframe")) {
					type = 'iframe';

				} else if (href.indexOf("#") === 0) {
					type = 'inline';

				} else {
					type = 'ajax';
				}
			}

			if (!type) {
				_error();
				return;
			}

			if (type == 'inline') {
				obj	= href.substr(href.indexOf("#"));
				type = $(obj).length > 0 ? 'inline' : 'ajax';
			}

			selectedOpts.type = type;
			selectedOpts.href = href;
			selectedOpts.title = title;

			if (selectedOpts.autoDimensions) {
				if (selectedOpts.type == 'html' || selectedOpts.type == 'inline' || selectedOpts.type == 'ajax') {
					selectedOpts.width = 'auto';
					selectedOpts.height = 'auto';
				} else {
					selectedOpts.autoDimensions = false;	
				}
			}

			if (selectedOpts.modal) {
				selectedOpts.overlayShow = true;
				selectedOpts.hideOnOverlayClick = false;
				selectedOpts.hideOnContentClick = false;
				selectedOpts.enableEscapeButton = false;
				selectedOpts.showCloseButton = false;
			}

			selectedOpts.padding = parseInt(selectedOpts.padding, 10);
			selectedOpts.margin = parseInt(selectedOpts.margin, 10);

			tmp.css('padding', (selectedOpts.padding + selectedOpts.margin));

			$('.fancybox-inline-tmp').unbind('fancybox-cancel').bind('fancybox-change', function() {
				$(this).replaceWith(content.children());				
			});

			switch (type) {
				case 'html' :
					tmp.html( selectedOpts.content );
					_process_inline();
				break;

				case 'inline' :
					if ( $(obj).parent().is('#fancybox-content') === true) {
						busy = false;
						return;
					}

					$('<div class="fancybox-inline-tmp" />')
						.hide()
						.insertBefore( $(obj) )
						.bind('fancybox-cleanup', function() {
							$(this).replaceWith(content.children());
						}).bind('fancybox-cancel', function() {
							$(this).replaceWith(tmp.children());
						});

					$(obj).appendTo(tmp);

					_process_inline();
				break;

				case 'image':
					busy = false;

					$.fancybox.showActivity();

					imgPreloader = new Image();

					imgPreloader.onerror = function() {
						_error();
					};

					imgPreloader.onload = function() {
						busy = true;

						imgPreloader.onerror = imgPreloader.onload = null;

						_process_image();
					};

					imgPreloader.src = href;
				break;

				case 'swf':
					selectedOpts.scrolling = 'no';

					str = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"><param name="movie" value="' + href + '"></param>';
					emb = '';

					$.each(selectedOpts.swf, function(name, val) {
						str += '<param name="' + name + '" value="' + val + '"></param>';
						emb += ' ' + name + '="' + val + '"';
					});

					str += '<embed src="' + href + '" type="application/x-shockwave-flash" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"' + emb + '></embed></object>';

					tmp.html(str);

					_process_inline();
				break;

				case 'ajax':
					busy = false;

					$.fancybox.showActivity();

					selectedOpts.ajax.win = selectedOpts.ajax.success;

					ajaxLoader = $.ajax($.extend({}, selectedOpts.ajax, {
						url	: href,
						data : selectedOpts.ajax.data || {},
						error : function(XMLHttpRequest, textStatus, errorThrown) {
							if ( XMLHttpRequest.status > 0 ) {
								_error();
							}
						},
						success : function(data, textStatus, XMLHttpRequest) {
							var o = typeof XMLHttpRequest == 'object' ? XMLHttpRequest : ajaxLoader;
							if (o.status == 200) {
								if ( typeof selectedOpts.ajax.win == 'function' ) {
									ret = selectedOpts.ajax.win(href, data, textStatus, XMLHttpRequest);

									if (ret === false) {
										loading.hide();
										return;
									} else if (typeof ret == 'string' || typeof ret == 'object') {
										data = ret;
									}
								}

								tmp.html( data );
								_process_inline();
							}
						}
					}));

				break;

				case 'iframe':
					_show();
				break;
			}
		},

		_process_inline = function() {
			var
				w = selectedOpts.width,
				h = selectedOpts.height;

			if (w.toString().indexOf('%') > -1) {
				w = parseInt( ($(window).width() - (selectedOpts.margin * 2)) * parseFloat(w) / 100, 10) + 'px';

			} else {
				w = w == 'auto' ? 'auto' : w + 'px';	
			}

			if (h.toString().indexOf('%') > -1) {
				h = parseInt( ($(window).height() - (selectedOpts.margin * 2)) * parseFloat(h) / 100, 10) + 'px';

			} else {
				h = h == 'auto' ? 'auto' : h + 'px';	
			}

			tmp.wrapInner('<div style="width:' + w + ';height:' + h + ';overflow: ' + (selectedOpts.scrolling == 'auto' ? 'auto' : (selectedOpts.scrolling == 'yes' ? 'scroll' : 'hidden')) + ';position:relative;"></div>');

			selectedOpts.width = tmp.width();
			selectedOpts.height = tmp.height();

			_show();
		},

		_process_image = function() {
			selectedOpts.width = imgPreloader.width;
			selectedOpts.height = imgPreloader.height;

			$("<img />").attr({
				'id' : 'fancybox-img',
				'src' : imgPreloader.src,
				'alt' : selectedOpts.title
			}).appendTo( tmp );

			_show();
		},

		_show = function() {
			var pos, equal;

			loading.hide();

			if (wrap.is(":visible") && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
				$.event.trigger('fancybox-cancel');

				busy = false;
				return;
			}

			busy = true;

			$(content.add( overlay )).unbind();

			$(window).unbind("resize.fb scroll.fb");
			$(document).unbind('keydown.fb');

			if (wrap.is(":visible") && currentOpts.titlePosition !== 'outside') {
				wrap.css('height', wrap.height());
			}

			currentArray = selectedArray;
			currentIndex = selectedIndex;
			currentOpts = selectedOpts;

			if (currentOpts.overlayShow) {
				overlay.css({
					'background-color' : currentOpts.overlayColor,
					'opacity' : currentOpts.overlayOpacity,
					'cursor' : currentOpts.hideOnOverlayClick ? 'pointer' : 'auto',
					'height' : $(document).height()
				});

				if (!overlay.is(':visible')) {
					if (isIE6) {
						$('select:not(#fancybox-tmp select)').filter(function() {
							return this.style.visibility !== 'hidden';
						}).css({'visibility' : 'hidden'}).one('fancybox-cleanup', function() {
							this.style.visibility = 'inherit';
						});
					}

					overlay.show();
				}
			} else {
				overlay.hide();
			}

			final_pos = _get_zoom_to();

			_process_title();

			if (wrap.is(":visible")) {
				$( close.add( nav_left ).add( nav_right ) ).hide();

				pos = wrap.position(),

				start_pos = {
					top	 : pos.top,
					left : pos.left,
					width : wrap.width(),
					height : wrap.height()
				};

				equal = (start_pos.width == final_pos.width && start_pos.height == final_pos.height);

				content.fadeTo(currentOpts.changeFade, 0.3, function() {
					var finish_resizing = function() {
						content.html( tmp.contents() ).fadeTo(currentOpts.changeFade, 1, _finish);
					};

					$.event.trigger('fancybox-change');

					content
						.empty()
						.removeAttr('filter')
						.css({
							'border-width' : currentOpts.padding,
							'width'	: final_pos.width - currentOpts.padding * 2,
							'height' : selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
						});

					if (equal) {
						finish_resizing();

					} else {
						fx.prop = 0;

						$(fx).animate({prop: 1}, {
							 duration : currentOpts.changeSpeed,
							 easing : currentOpts.easingChange,
							 step : _draw,
							 complete : finish_resizing
						});
					}
				});

				return;
			}

			wrap.removeAttr("style");

			content.css('border-width', currentOpts.padding);

			if (currentOpts.transitionIn == 'elastic') {
				start_pos = _get_zoom_from();

				content.html( tmp.contents() );

				wrap.show();

				if (currentOpts.opacity) {
					final_pos.opacity = 0;
				}

				fx.prop = 0;

				$(fx).animate({prop: 1}, {
					 duration : currentOpts.speedIn,
					 easing : currentOpts.easingIn,
					 step : _draw,
					 complete : _finish
				});

				return;
			}

			if (currentOpts.titlePosition == 'inside' && titleHeight > 0) {	
				title.show();	
			}

			content
				.css({
					'width' : final_pos.width - currentOpts.padding * 2,
					'height' : selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
				})
				.html( tmp.contents() );

			wrap
				.css(final_pos)
				.fadeIn( currentOpts.transitionIn == 'none' ? 0 : currentOpts.speedIn, _finish );
		},

		_format_title = function(title) {
			if (title && title.length) {
				if (currentOpts.titlePosition == 'float') {
					return '<table id="fancybox-title-float-wrap" cellpadding="0" cellspacing="0"><tr><td id="fancybox-title-float-left"></td><td id="fancybox-title-float-main">' + title + '</td><td id="fancybox-title-float-right"></td></tr></table>';
				}

				return '<div id="fancybox-title-' + currentOpts.titlePosition + '">' + title + '</div>';
			}

			return false;
		},

		_process_title = function() {
			titleStr = currentOpts.title || '';
			titleHeight = 0;

			title
				.empty()
				.removeAttr('style')
				.removeClass();

			if (currentOpts.titleShow === false) {
				title.hide();
				return;
			}

			titleStr = $.isFunction(currentOpts.titleFormat) ? currentOpts.titleFormat(titleStr, currentArray, currentIndex, currentOpts) : _format_title(titleStr);

			if (!titleStr || titleStr === '') {
				title.hide();
				return;
			}

			title
				.addClass('fancybox-title-' + currentOpts.titlePosition)
				.html( titleStr )
				.appendTo( 'body' )
				.show();

			switch (currentOpts.titlePosition) {
				case 'inside':
					title
						.css({
							'width' : final_pos.width - (currentOpts.padding * 2),
							'marginLeft' : currentOpts.padding,
							'marginRight' : currentOpts.padding
						});

					titleHeight = title.outerHeight(true);

					title.appendTo( outer );

					final_pos.height += titleHeight;
				break;

				case 'over':
					title
						.css({
							'marginLeft' : currentOpts.padding,
							'width'	: final_pos.width - (currentOpts.padding * 2),
							'bottom' : currentOpts.padding
						})
						.appendTo( outer );
				break;

				case 'float':
					title
						.css('left', parseInt((title.width() - final_pos.width - 40)/ 2, 10) * -1)
						.appendTo( wrap );
				break;

				default:
					title
						.css({
							'width' : final_pos.width - (currentOpts.padding * 2),
							'paddingLeft' : currentOpts.padding,
							'paddingRight' : currentOpts.padding
						})
						.appendTo( wrap );
				break;
			}

			title.hide();
		},

		_set_navigation = function() {
			if (currentOpts.enableEscapeButton || currentOpts.enableKeyboardNav) {
				$(document).bind('keydown.fb', function(e) {
					if (e.keyCode == 27 && currentOpts.enableEscapeButton) {
						e.preventDefault();
						$.fancybox.close();

					} else if ((e.keyCode == 37 || e.keyCode == 39) && currentOpts.enableKeyboardNav && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') {
						e.preventDefault();
						$.fancybox[ e.keyCode == 37 ? 'prev' : 'next']();
					}
				});
			}

			if (!currentOpts.showNavArrows) { 
				nav_left.hide();
				nav_right.hide();
				return;
			}

			if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex !== 0) {
				nav_left.show();
			}

			if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex != (currentArray.length -1)) {
				nav_right.show();
			}
		},

		_finish = function () {
			if (!$.support.opacity) {
				content.get(0).style.removeAttribute('filter');
				wrap.get(0).style.removeAttribute('filter');
			}

			if (selectedOpts.autoDimensions) {
				content.css('height', 'auto');
			}

			wrap.css('height', 'auto');

			if (titleStr && titleStr.length) {
				title.show();
			}

			if (currentOpts.showCloseButton) {
				close.show();
			}

			_set_navigation();
	
			if (currentOpts.hideOnContentClick)	{
				content.bind('click', $.fancybox.close);
			}

			if (currentOpts.hideOnOverlayClick)	{
				overlay.bind('click', $.fancybox.close);
			}

			$(window).bind("resize.fb", $.fancybox.resize);

			if (currentOpts.centerOnScroll) {
				$(window).bind("scroll.fb", $.fancybox.center);
			}

			if (currentOpts.type == 'iframe') {
				$('<iframe id="fancybox-frame" name="fancybox-frame' + new Date().getTime() + '" frameborder="0" hspace="0" ' + ($.browser.msie ? 'allowtransparency="true""' : '') + ' scrolling="' + selectedOpts.scrolling + '" src="' + currentOpts.href + '"></iframe>').appendTo(content);
			}

			wrap.show();

			busy = false;

			$.fancybox.center();

			currentOpts.onComplete(currentArray, currentIndex, currentOpts);

			_preload_images();
		},

		_preload_images = function() {
			var href, 
				objNext;

			if ((currentArray.length -1) > currentIndex) {
				href = currentArray[ currentIndex + 1 ].href;

				if (typeof href !== 'undefined' && href.match(imgRegExp)) {
					objNext = new Image();
					objNext.src = href;
				}
			}

			if (currentIndex > 0) {
				href = currentArray[ currentIndex - 1 ].href;

				if (typeof href !== 'undefined' && href.match(imgRegExp)) {
					objNext = new Image();
					objNext.src = href;
				}
			}
		},

		_draw = function(pos) {
			var dim = {
				width : parseInt(start_pos.width + (final_pos.width - start_pos.width) * pos, 10),
				height : parseInt(start_pos.height + (final_pos.height - start_pos.height) * pos, 10),

				top : parseInt(start_pos.top + (final_pos.top - start_pos.top) * pos, 10),
				left : parseInt(start_pos.left + (final_pos.left - start_pos.left) * pos, 10)
			};

			if (typeof final_pos.opacity !== 'undefined') {
				dim.opacity = pos < 0.5 ? 0.5 : pos;
			}

			wrap.css(dim);

			content.css({
				'width' : dim.width - currentOpts.padding * 2,
				'height' : dim.height - (titleHeight * pos) - currentOpts.padding * 2
			});
		},

		_get_viewport = function() {
			return [
				$(window).width() - (currentOpts.margin * 2),
				$(window).height() - (currentOpts.margin * 2),
				$(document).scrollLeft() + currentOpts.margin,
				$(document).scrollTop() + currentOpts.margin
			];
		},

		_get_zoom_to = function () {
			var view = _get_viewport(),
				to = {},
				resize = currentOpts.autoScale,
				double_padding = currentOpts.padding * 2,
				ratio;

			if (currentOpts.width.toString().indexOf('%') > -1) {
				to.width = parseInt((view[0] * parseFloat(currentOpts.width)) / 100, 10);
			} else {
				to.width = currentOpts.width + double_padding;
			}

			if (currentOpts.height.toString().indexOf('%') > -1) {
				to.height = parseInt((view[1] * parseFloat(currentOpts.height)) / 100, 10);
			} else {
				to.height = currentOpts.height + double_padding;
			}

			if (resize && (to.width > view[0] || to.height > view[1])) {
				if (selectedOpts.type == 'image' || selectedOpts.type == 'swf') {
					ratio = (currentOpts.width ) / (currentOpts.height );

					if ((to.width ) > view[0]) {
						to.width = view[0];
						to.height = parseInt(((to.width - double_padding) / ratio) + double_padding, 10);
					}

					if ((to.height) > view[1]) {
						to.height = view[1];
						to.width = parseInt(((to.height - double_padding) * ratio) + double_padding, 10);
					}

				} else {
					to.width = Math.min(to.width, view[0]);
					to.height = Math.min(to.height, view[1]);
				}
			}

			to.top = parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - to.height - 40) * 0.5)), 10);
			to.left = parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - to.width - 40) * 0.5)), 10);

			return to;
		},

		_get_obj_pos = function(obj) {
			var pos = obj.offset();

			pos.top += parseInt( obj.css('paddingTop'), 10 ) || 0;
			pos.left += parseInt( obj.css('paddingLeft'), 10 ) || 0;

			pos.top += parseInt( obj.css('border-top-width'), 10 ) || 0;
			pos.left += parseInt( obj.css('border-left-width'), 10 ) || 0;

			pos.width = obj.width();
			pos.height = obj.height();

			return pos;
		},

		_get_zoom_from = function() {
			var orig = selectedOpts.orig ? $(selectedOpts.orig) : false,
				from = {},
				pos,
				view;

			if (orig && orig.length) {
				pos = _get_obj_pos(orig);

				from = {
					width : pos.width + (currentOpts.padding * 2),
					height : pos.height + (currentOpts.padding * 2),
					top	: pos.top - currentOpts.padding - 20,
					left : pos.left - currentOpts.padding - 20
				};

			} else {
				view = _get_viewport();

				from = {
					width : currentOpts.padding * 2,
					height : currentOpts.padding * 2,
					top	: parseInt(view[3] + view[1] * 0.5, 10),
					left : parseInt(view[2] + view[0] * 0.5, 10)
				};
			}

			return from;
		},

		_animate_loading = function() {
			if (!loading.is(':visible')){
				clearInterval(loadingTimer);
				return;
			}

			$('div', loading).css('top', (loadingFrame * -40) + 'px');

			loadingFrame = (loadingFrame + 1) % 12;
		};

	/*
	 * Public methods 
	 */

	$.fn.fancybox = function(options) {
		if (!$(this).length) {
			return this;
		}

		$(this)
			.data('fancybox', $.extend({}, options, ($.metadata ? $(this).metadata() : {})))
			.unbind('click.fb')
			.bind('click.fb', function(e) {
				e.preventDefault();

				if (busy) {
					return;
				}

				busy = true;

				$(this).blur();

				selectedArray = [];
				selectedIndex = 0;

				var rel = $(this).attr('rel') || '';

				if (!rel || rel == '' || rel === 'nofollow') {
					selectedArray.push(this);

				} else {
					selectedArray = $("a[rel=" + rel + "], area[rel=" + rel + "]");
					selectedIndex = selectedArray.index( this );
				}

				_start();

				return;
			});

		return this;
	};

	$.fancybox = function(obj) {
		var opts;

		if (busy) {
			return;
		}

		busy = true;
		opts = typeof arguments[1] !== 'undefined' ? arguments[1] : {};

		selectedArray = [];
		selectedIndex = parseInt(opts.index, 10) || 0;

		if ($.isArray(obj)) {
			for (var i = 0, j = obj.length; i < j; i++) {
				if (typeof obj[i] == 'object') {
					$(obj[i]).data('fancybox', $.extend({}, opts, obj[i]));
				} else {
					obj[i] = $({}).data('fancybox', $.extend({content : obj[i]}, opts));
				}
			}

			selectedArray = jQuery.merge(selectedArray, obj);

		} else {
			if (typeof obj == 'object') {
				$(obj).data('fancybox', $.extend({}, opts, obj));
			} else {
				obj = $({}).data('fancybox', $.extend({content : obj}, opts));
			}

			selectedArray.push(obj);
		}

		if (selectedIndex > selectedArray.length || selectedIndex < 0) {
			selectedIndex = 0;
		}

		_start();
	};

	$.fancybox.showActivity = function() {
		clearInterval(loadingTimer);

		loading.show();
		loadingTimer = setInterval(_animate_loading, 66);
	};

	$.fancybox.hideActivity = function() {
		loading.hide();
	};

	$.fancybox.next = function() {
		return $.fancybox.pos( currentIndex + 1);
	};

	$.fancybox.prev = function() {
		return $.fancybox.pos( currentIndex - 1);
	};

	$.fancybox.pos = function(pos) {
		if (busy) {
			return;
		}

		pos = parseInt(pos);

		selectedArray = currentArray;

		if (pos > -1 && pos < currentArray.length) {
			selectedIndex = pos;
			_start();

		} else if (currentOpts.cyclic && currentArray.length > 1) {
			selectedIndex = pos >= currentArray.length ? 0 : currentArray.length - 1;
			_start();
		}

		return;
	};

	$.fancybox.cancel = function() {
		if (busy) {
			return;
		}

		busy = true;

		$.event.trigger('fancybox-cancel');

		_abort();

		selectedOpts.onCancel(selectedArray, selectedIndex, selectedOpts);

		busy = false;
	};

	// Note: within an iframe use - parent.$.fancybox.close();
	$.fancybox.close = function() {
		if (busy || wrap.is(':hidden')) {
			return;
		}

		busy = true;

		if (currentOpts && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
			busy = false;
			return;
		}

		_abort();

		$(close.add( nav_left ).add( nav_right )).hide();

		$(content.add( overlay )).unbind();

		$(window).unbind("resize.fb scroll.fb");
		$(document).unbind('keydown.fb');

		content.find('iframe').attr('src', isIE6 && /^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank');

		if (currentOpts.titlePosition !== 'inside') {
			title.empty();
		}

		wrap.stop();

		function _cleanup() {
			overlay.fadeOut('fast');

			title.empty().hide();
			wrap.hide();

			$.event.trigger('fancybox-cleanup');

			content.empty();

			currentOpts.onClosed(currentArray, currentIndex, currentOpts);

			currentArray = selectedOpts	= [];
			currentIndex = selectedIndex = 0;
			currentOpts = selectedOpts	= {};

			busy = false;
		}

		if (currentOpts.transitionOut == 'elastic') {
			start_pos = _get_zoom_from();

			var pos = wrap.position();

			final_pos = {
				top	 : pos.top ,
				left : pos.left,
				width :	wrap.width(),
				height : wrap.height()
			};

			if (currentOpts.opacity) {
				final_pos.opacity = 1;
			}

			title.empty().hide();

			fx.prop = 1;

			$(fx).animate({ prop: 0 }, {
				 duration : currentOpts.speedOut,
				 easing : currentOpts.easingOut,
				 step : _draw,
				 complete : _cleanup
			});

		} else {
			wrap.fadeOut( currentOpts.transitionOut == 'none' ? 0 : currentOpts.speedOut, _cleanup);
		}
	};

	$.fancybox.resize = function() {
		if (overlay.is(':visible')) {
			overlay.css('height', $(document).height());
		}

		$.fancybox.center(true);
	};

	$.fancybox.center = function() {
		var view, align;

		if (busy) {
			return;	
		}

		align = arguments[0] === true ? 1 : 0;
		view = _get_viewport();

		if (!align && (wrap.width() > view[0] || wrap.height() > view[1])) {
			return;	
		}

		wrap
			.stop()
			.animate({
				'top' : parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - content.height() - 40) * 0.5) - currentOpts.padding)),
				'left' : parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - content.width() - 40) * 0.5) - currentOpts.padding))
			}, typeof arguments[0] == 'number' ? arguments[0] : 200);
	};

	$.fancybox.init = function() {
		if ($("#fancybox-wrap").length) {
			return;
		}

		$('body').append(
			tmp	= $('<div id="fancybox-tmp"></div>'),
			loading	= $('<div id="fancybox-loading"><div></div></div>'),
			overlay	= $('<div id="fancybox-overlay"></div>'),
			wrap = $('<div id="fancybox-wrap"></div>')
		);

		outer = $('<div id="fancybox-outer"></div>')
			.append('<div class="fancybox-bg" id="fancybox-bg-n"></div><div class="fancybox-bg" id="fancybox-bg-ne"></div><div class="fancybox-bg" id="fancybox-bg-e"></div><div class="fancybox-bg" id="fancybox-bg-se"></div><div class="fancybox-bg" id="fancybox-bg-s"></div><div class="fancybox-bg" id="fancybox-bg-sw"></div><div class="fancybox-bg" id="fancybox-bg-w"></div><div class="fancybox-bg" id="fancybox-bg-nw"></div>')
			.appendTo( wrap );

		outer.append(
			content = $('<div id="fancybox-content"></div>'),
			close = $('<a id="fancybox-close"></a>'),
			title = $('<div id="fancybox-title"></div>'),

			nav_left = $('<a href="javascript:;" id="fancybox-left"><span class="fancy-ico" id="fancybox-left-ico"></span></a>'),
			nav_right = $('<a href="javascript:;" id="fancybox-right"><span class="fancy-ico" id="fancybox-right-ico"></span></a>')
		);

		close.click($.fancybox.close);
		loading.click($.fancybox.cancel);

		nav_left.click(function(e) {
			e.preventDefault();
			$.fancybox.prev();
		});

		nav_right.click(function(e) {
			e.preventDefault();
			$.fancybox.next();
		});

		if ($.fn.mousewheel) {
			wrap.bind('mousewheel.fb', function(e, delta) {
				if (busy) {
					e.preventDefault();

				} else if ($(e.target).get(0).clientHeight == 0 || $(e.target).get(0).scrollHeight === $(e.target).get(0).clientHeight) {
					e.preventDefault();
					$.fancybox[ delta > 0 ? 'prev' : 'next']();
				}
			});
		}

		if (!$.support.opacity) {
			wrap.addClass('fancybox-ie');
		}

		if (isIE6) {
			loading.addClass('fancybox-ie6');
			wrap.addClass('fancybox-ie6');

			$('<iframe id="fancybox-hide-sel-frame" src="' + (/^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank' ) + '" scrolling="no" border="0" frameborder="0" tabindex="-1"></iframe>').prependTo(outer);
		}
	};

	$.fn.fancybox.defaults = {
		padding : 10,
		margin : 40,
		opacity : false,
		modal : false,
		cyclic : false,
		scrolling : 'auto',	// 'auto', 'yes' or 'no'

		width : 560,
		height : 340,

		autoScale : true,
		autoDimensions : true,
		centerOnScroll : false,

		ajax : {},
		swf : { wmode: 'transparent' },

		hideOnOverlayClick : true,
		hideOnContentClick : false,

		overlayShow : true,
		overlayOpacity : 0.7,
		overlayColor : '#777',

		titleShow : true,
		titlePosition : 'float', // 'float', 'outside', 'inside' or 'over'
		titleFormat : null,
		titleFromAlt : false,

		transitionIn : 'fade', // 'elastic', 'fade' or 'none'
		transitionOut : 'fade', // 'elastic', 'fade' or 'none'

		speedIn : 300,
		speedOut : 300,

		changeSpeed : 300,
		changeFade : 'fast',

		easingIn : 'swing',
		easingOut : 'swing',

		showCloseButton	 : true,
		showNavArrows : true,
		enableEscapeButton : true,
		enableKeyboardNav : true,

		onStart : function(){},
		onCancel : function(){},
		onComplete : function(){},
		onCleanup : function(){},
		onClosed : function(){},
		onError : function(){}
	};

	$(document).ready(function() {
		$.fancybox.init();
	});

})(jQuery);
define("fancybox", ["jquery","easing","css!fancyboxCss"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fancybox;
    };
}(this)));


jade = (function(exports){
/*!
 * Jade - runtime
 * Copyright(c) 2010 TJ Holowaychuk <tj@vision-media.ca>
 * MIT Licensed
 */

/**
 * Lame Array.isArray() polyfill for now.
 */

if (!Array.isArray) {
  Array.isArray = function(arr){
    return '[object Array]' == Object.prototype.toString.call(arr);
  };
}

/**
 * Lame Object.keys() polyfill for now.
 */

if (!Object.keys) {
  Object.keys = function(obj){
    var arr = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        arr.push(key);
      }
    }
    return arr;
  }
}

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = function merge(a, b) {
  var ac = a['class'];
  var bc = b['class'];

  if (ac || bc) {
    ac = ac || [];
    bc = bc || [];
    if (!Array.isArray(ac)) ac = [ac];
    if (!Array.isArray(bc)) bc = [bc];
    ac = ac.filter(nulls);
    bc = bc.filter(nulls);
    a['class'] = ac.concat(bc).join(' ');
  }

  for (var key in b) {
    if (key != 'class') {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Filter null `val`s.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function nulls(val) {
  return val != null;
}

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} escaped
 * @return {String}
 * @api private
 */

exports.attrs = function attrs(obj, escaped){
  var buf = []
    , terse = obj.terse;

  delete obj.terse;
  var keys = Object.keys(obj)
    , len = keys.length;

  if (len) {
    buf.push('');
    for (var i = 0; i < len; ++i) {
      var key = keys[i]
        , val = obj[key];

      if ('boolean' == typeof val || null == val) {
        if (val) {
          terse
            ? buf.push(key)
            : buf.push(key + '="' + key + '"');
        }
      } else if (0 == key.indexOf('data') && 'string' != typeof val) {
        buf.push(key + "='" + JSON.stringify(val) + "'");
      } else if ('class' == key && Array.isArray(val)) {
        buf.push(key + '="' + exports.escape(val.join(' ')) + '"');
      } else if (escaped && escaped[key]) {
        buf.push(key + '="' + exports.escape(val) + '"');
      } else {
        buf.push(key + '="' + val + '"');
      }
    }
  }

  return buf.join(' ');
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

exports.escape = function escape(html){
  return String(html)
    .replace(/&(?!(\w+|\#\d+);)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

/**
 * Re-throw the given `err` in context to the
 * the jade in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @api private
 */

exports.rethrow = function rethrow(err, filename, lineno){
  if (!filename) throw err;

  var context = 3
    , str = require('fs').readFileSync(filename, 'utf8')
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Jade') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};

  return exports;

})({});

define("jadeRuntime", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jade;
    };
}(this)));

define('commons/public/jadec/ui_components/slide-modal',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var printHTML_mixin = function(obj, tag, className){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( obj)
{
if ( obj instanceof jQuery)
{
if ( tag)
{
buf.push("<" + (tag) + (jade.attrs({ "class": (className) }, {"class":true})) + ">" + (((jade.interp = obj[0].outerHTML) == null ? '' : jade.interp)) + "</" + (tag) + ">");
}
else
{
buf.push("" + (((jade.interp = obj[0].outerHTML) == null ? '' : jade.interp)) + "");
}
}
else
{
if ( tag)
{
buf.push("<" + (tag) + (jade.attrs({ "class": (className) }, {"class":true})) + ">" + (((jade.interp = obj) == null ? '' : jade.interp)) + "</" + (tag) + ">");
}
else
{
buf.push("" + (((jade.interp = obj) == null ? '' : jade.interp)) + "");
}
}
}
};
buf.push("<div class=\"trustyou-ui card card-slider\"><div class=\"card-header\"><div class=\"card-title\">");
if ( slides.length === 1 || counter === false)
{
buf.push("<h2>" + (jade.escape((jade.interp = title) == null ? '' : jade.interp)) + "</h2>");
}
else
{
buf.push("<h3>" + (jade.escape((jade.interp = title) == null ? '' : jade.interp)) + "</h3><h4>" + (jade.escape((jade.interp = currentSlide + 1) == null ? '' : jade.interp)) + " / " + (jade.escape((jade.interp = slides.length) == null ? '' : jade.interp)) + "</h4>");
}
buf.push("</div><ul class=\"actions\">");
if ( controls.header)
{
buf.push("<li id=\"prev-slide-arrow\"><a" + (jade.attrs({ 'title':(prevLabel), 'data-tooltip':("top"), "class": (currentSlide === 0 ? 'is-disabled' : null) }, {"title":true,"data-tooltip":true,"class":true})) + "> <i class=\"ty-icon ty-icon-chevron-left\"></i></a></li><li id=\"next-slide-arrow\"><a" + (jade.attrs({ 'title':(nextLabel), 'data-tooltip':("top"), "class": (currentSlide === slides.length - 1 ? 'is-disabled' : null) }, {"title":true,"data-tooltip":true,"class":true})) + "> <i class=\"ty-icon ty-icon-chevron-right\"></i></a></li>");
}
buf.push("<li><a class=\"close-modal\"><i class=\"ty-icon ty-icon-remove\"></i></a></li></ul></div><div class=\"card-body\">");
printHTML_mixin(body, 'div', 'trustyou-ui slideshow ' + slideshowClass);
buf.push("</div>");
if ( controls.footer)
{
if ( controls.footer.custom)
{
buf.push("<div class=\"card-footer\"><a" + (jade.attrs({ 'id':(controls.footer.buttons.left.id), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + ('l-left') }, {"id":true})) + ">" + (jade.escape((jade.interp = controls.footer.buttons.left.label) == null ? '' : jade.interp)) + "</a><a" + (jade.attrs({ 'id':(controls.footer.buttons.right.id), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + ('btn-positive') }, {"id":true})) + ">" + (jade.escape((jade.interp = controls.footer.buttons.right.label) == null ? '' : jade.interp)) + "</a></div>");
}
else
{
buf.push("<div class=\"card-footer\"><a" + (jade.attrs({ 'id':('prev-slide-button'), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + ('l-left') + ' ' + (currentSlide === 0 ? 'is-disabled' : null) }, {"class":true})) + ">" + (jade.escape((jade.interp = prevLabel) == null ? '' : jade.interp)) + "</a><a" + (jade.attrs({ 'id':('next-slide-button'), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + ('btn-positive') + ' ' + (currentSlide === slides.length - 1 ? 'is-disabled' : null) }, {"class":true})) + ">" + (jade.escape((jade.interp = nextLabel) == null ? '' : jade.interp)) + "</a></div>");
}
}
buf.push("</div>");
}
return buf.join("");
};

});

/*
 * Modal showing slides in the form of HTMLElement nodes
 *
 * Usage example:
 * require(['slide-modal'], function() {
 *	var $elem = $('#element-id'),
 *		options = {}
 * 	$elem.slideModal(options)
 *	$elem.slideModal('showSlide', 42)
 * })
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/slide-modal',['jquery', 'widget', 'fancybox', 'slide-modal-template'], function ($, widget, fancybox, template) {
    var trueFn = function () {
      return true;
    };
    $.widget('ty.slideModal', widget, {
      currentSlide: null,
      options: {
        /**
         * list of slides objects
         * [{
         *		title: String,
         *		body: HTMLElement|String,
         *		controls: {
         *			header: Boolean,
         *			footer: Boolean
         *		},
         *		helpBox: {
         *			label: String,
         *			href: String,
         *			icon: String,
         *			iconHover: String
         *		},
         *		onSlide: Function,
         *		beforeSlide: Function
         * }]
         */
        slides: [],
        startSlide: 0,
        prevLabel: 'Previous',
        nextLabel: 'Next',
        modalClass: '',
        slideshowClass: '',

        // Called after modal is closed
        onClosed: $.noop,

        // Called before modal is closed with current slide index
        // Return true to proceed, false to prevent modal from closing
        // @param {Integer} Current slide index
        beforeClose: trueFn,

        // Called when slide is being switched
        // @param {Integer} Next slide index
        onSlide: $.noop,

        // Called before slide is being switched
        // Return true to proceed, false to prevent slide change
        // @param {Integer} Next slide index
        beforeSlide: trueFn,

        helpBox: {
          label: '',
          href: '',
          icon: 'ty-icon-bell',
          iconHover: 'ty-icon-help-o'
        },
        isModal: false,
        controls: {
          header: true,
          footer: false
        },
        counter: true
      },
      _init: function () {
        var $element = this.element,
            options = this.options;

        if (!options.slides || !options.slides.length) {
          throw new Error('Empty slides array');
        }

        $element.empty();

        var onComplete = function () {
          $('#fancybox-wrap').removeClass().addClass('trustyou-ui modal').addClass(options.modalClass);
          if (options.isModal) {
            $('html').addClass('fancybox-lock');
          }
          $element.on('click', '.close-modal', function () {
            if (!options.beforeClose(this.currentSlide)) {
              return;
            }
            $.fancybox.close();
          });

          this._goTo(options.startSlide);
        };

        var onClosed = function () {
          $('#fancybox-wrap').removeClass();
          if ($('html').hasClass('fancybox-lock')) {
            $('html').removeClass('fancybox-lock');
          }
          options.onClosed();
        };

        $.fancybox({
          openMethod: 'dropIn',
          openSpeed: 250,

          closeMethod: 'dropOut',
          closeSpeed: 150,

          content: $element,
          padding: 0,
          width: 'auto',
          showCloseButton: false,
          onComplete: onComplete.bind(this),
          onClosed: onClosed.bind(this),
          modal: this.options.isModal,
          scrolling: 'no'
        });

        this.update();
      },
      _getSlide: function (slideIdx) {
        return this.options.slides[slideIdx];
      },
      _getSlideIndexById: function (slideId) {
        var index = -1;
        for (var i = 0; i < this.options.slides.length; i++) {
          if (this.options.slides[i].id === slideId) {
            index = i;
            break;
          }
        }
        return index;
      },
      _next: function () {
        if (this.currentSlide + 1 < this.options.slides.length) {
          this._goTo(this.currentSlide + 1);
        }
      },
      _prev: function () {
        if (this.currentSlide > 0) {
          this._goTo(this.currentSlide - 1);
        }
      },
      _goTo: function (slideIdx) {
        var beforeSlide = this._getSlide(slideIdx).beforeSlide || this.options.beforeSlide;
        if (!beforeSlide(slideIdx)) {
          return;
        }

        this.currentSlide = slideIdx;
        this._renderSlide(slideIdx);
      },
      _renderSlide: function (slideIdx, silent) {
        silent = silent || false;
        var slide = this._getSlide(slideIdx),
            $this = this.element,
            params = {};
        $.extend(params, this.options, slide, {
          currentSlide: slideIdx
        });
        var content = template(params);
        $this.empty().append($(content));
        this.update();

        $this.find(this._buttonSelector('next')).click(this._next.bind(this));
        $this.find(this._buttonSelector('prev')).click(this._prev.bind(this));

        if (!silent) {
          params.onSlide(slideIdx);
        }
      },
      update: function (timeout) {
        timeout = timeout || 50;
        setTimeout(function () {
          $('#fancybox-wrap, #fancybox-outer, #fancybox-content').css('width', 'auto');
          $.fancybox.center();
          $.fancybox.resize();
        }, timeout);
      },
      _buttonSelector: function (name) {
        return '#{name}-slide-arrow,#{name}-slide-button'.replace(/\{name\}/g, name);
      },
      _validIndex: function (slideIdx) {
        return slideIdx >= 0 && slideIdx < this.options.slides.length;
      },

      /*
       * Replaces slide with given content
       * @params {Integer} slideIdx Slide to update
       * @param {Object} slide Slide object
       */
      updateSlide: function (slideIdx, slide) {
        if (!this._validIndex(slideIdx)) {
          throw new Error('Invalid slide index');
        }

        this.options.slides[slideIdx] = slide;
        if (slideIdx === this.currentSlide) {
          this._renderSlide(slideIdx, true);
        }
      },

      /* Updates given button
       * @params {String} buttonName 'prev'|'next'
       * @param {Boolean} disabled
       * @param {String} label
       * @param {String} buttonClass
       */
      updateButton: function (buttonName, disabled, label, buttonClass) {
        var names = ['prev', 'next'];
        if (names.indexOf(buttonName) === -1) {
          throw new Error('Invalid button name');
        }

        $(this._buttonSelector(buttonName)).each(function (_, button) {
          var $button = $(button);
          var lbl = void 0;
          if ($button.prop('tagName') === 'A') {
            // footer button
            var cl = buttonClass || $button.prop('class');
            lbl = label || $button.text();
            $button.prop('class', cl).text(lbl).toggleClass('is-disabled', disabled);
          } else {
            // arrow button
            lbl = label || $button.prop('title');
            $button.find('a').prop('title', lbl).toggleClass('is-disabled', disabled);
          }
        });
      },

      /*
       * Closes the modal
       */
      closeModal: function () {
        $.fancybox.close();
      },

      /*
       * Switches to given slide
       * @param {Integer} slideIdx Index of slide to show
       */
      showSlide: function (slideIdx) {
        if (!this._validIndex(slideIdx)) {
          throw new Error('Invalid slide index');
        }

        this._goTo(slideIdx);
      },

      /*
       * Switches to given slide
       * @param {String} slideId id of the slide to show
       */
      showSlideById: function (slideId) {
        var slideIdx = this._getSlideIndexById(slideId);

        if (!this._validIndex(slideIdx)) {
          throw new Error('Invalid slide index');
        }

        this._goTo(slideIdx);
      },

      /**
       * Changes all the slides in the modal and goes to desiredSlide
       * @param slides
       * @param slides desiredSlide
       */
      changeSlides: function (options) {
        this.options.slides = options.slides;
        this._goTo(options.desiredSlide || 0);
      },
      /*
       * Returns DOM element corresponding to the current slide body.
       * Useful for dynamically changing slides content.
       */
      getCurrentSlideContent: function () {
        return $(this.element).find('.card-body>.slideshow');
      },

      /*
       * Returns current slide index
       */
      getCurrentSlideIndex: function () {
        return this.currentSlide;
      }
    });

    return $.ty.slideModal;
  });
})();
/*
 * waitForImages 1.4.1
 * -----------------
 * Provides a callback when all images have loaded in your given selector.
 * http://alexanderdickson.com/
 *
 *
 * Copyright (c) 2011-2012 Alex Dickson
 * Licensed under the MIT licenses.
 * See website for more info.
 *
 */

;(function($) {
    // Namespace all events.
    var eventNamespace = 'waitForImages';

    // CSS properties which contain references to images. 
    $.waitForImages = {
        hasImageProperties: [
	        'backgroundImage',
	        'listStyleImage',
	        'borderImage',
	        'borderCornerImage'
        ]
    };
    
    // Custom selector to find `img` elements that have a valid `src` attribute and have not already loaded.
    $.expr[':'].uncached = function(obj) {
        // Ensure we are dealing with an `img` element with a valid `src` attribute.
        if ( ! $(obj).is('img[src!=""]')) {
            return false;
        }

        // Firefox's `complete` property will always be `true` even if the image has not been downloaded.
        // Doing it this way works in Firefox.
        var img = document.createElement('img');
        img.src = obj.src;
        return ! img.complete;
    };

    $.fn.waitForImages = function(finishedCallback, eachCallback, waitForAll) {
		
        var allImgsLength = 0;
        var allImgsLoaded = 0;

        // Handle options object.
        if ($.isPlainObject(arguments[0])) {
            finishedCallback = finishedCallback.finished;
            eachCallback = finishedCallback.each;
            waitForAll = finishedCallback.waitForAll;
        }

        // Handle missing callbacks.
        finishedCallback = finishedCallback || $.noop;
        eachCallback = eachCallback || $.noop;

        // Convert waitForAll to Boolean
        waitForAll = !! waitForAll;

        // Ensure callbacks are functions.
        if ( ! $.isFunction(finishedCallback) || ! $.isFunction(eachCallback)) {
            throw new TypeError('An invalid callback was supplied.');
        }

        return this.each(function() {
            // Build a list of all imgs, dependent on what images will be considered.
            var obj = $(this);
			var allImgs = [];
            // CSS properties which may contain an image.
            var hasImgProperties = $.waitForImages.hasImageProperties || [];
			// To match `url()` references.
			// Spec: http://www.w3.org/TR/CSS2/syndata.html#value-def-uri
            var matchUrl = /url\(\s*(['"]?)(.*?)\1\s*\)/g;

            if (waitForAll) {
                
                // Get all elements (including the original), as any one of them could have a background image.
                obj.find('*').andSelf().each(function() {
                    var element = $(this);

                    // If an `img` element, add it. But keep iterating in case it has a background image too.
                    if (element.is('img:uncached')) {
                        allImgs.push({
                            src: element.attr('src'),
                            element: element[0]
                        });
                    }

                    $.each(hasImgProperties, function(i, property) {
                        var propertyValue = element.css(property);
						var match;
						
                        // If it doesn't contain this property, skip.
                        if ( ! propertyValue) {
                            return true;
                        }

                        // Get all url() of this element.
                        while (match = matchUrl.exec(propertyValue)) {
                            allImgs.push({
                                src: match[2],
                                element: element[0]
                            });
                        };
                    });
                });
            } else {
                // For images only, the task is simpler.
                obj
                 .find('img:uncached')
                 .each(function() {
                    allImgs.push({
                        src: this.src,
                        element: this
                    });
                });
            };

            allImgsLength = allImgs.length;
            allImgsLoaded = 0;

            // If no images found, don't bother.
            if (allImgsLength == 0) {
                finishedCallback.call(obj[0]);
            }

            $.each(allImgs, function(i, img) {
                
                var image = new Image;
                
                // Handle the image loading and error with the same callback.
                $(image).bind('load.' + eventNamespace + ' error.' + eventNamespace, function(event) {
                    allImgsLoaded++;
                    
                    // If an error occurred with loading the image, set the third argument accordingly.
                    eachCallback.call(img.element, allImgsLoaded, allImgsLength, event.type == 'load');
                    
                    if (allImgsLoaded == allImgsLength) {
                        finishedCallback.call(obj[0]);
                        return false;
                    };
                    
                });

                image.src = img.src;
            });
        });
    };
})(jQuery)
;
define("waitForImages", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.waitForImages;
    };
}(this)));

/*
 * Sidr
 * https://github.com/artberri/sidr
 *
 * Copyright (c) 2013 Alberto Varela
 * Licensed under the MIT license.
 */

/* TrustYou Changelog:
1.) TM-1730 Displaced content is not aligned when opening side-panel
*/

;(function( $ ){

  var sidrMoving = false,
      sidrOpened = false;

  // Private methods
  var privateMethods = {
    // Check for valids urls
    // From : http://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-an-url
    isUrl: function (str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      if(!pattern.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    // Loads the content into the menu bar
    loadContent: function($menu, content) {
      $menu.html(content);
    },
    // Add sidr prefixes
    addPrefix: function($element) {
      var elementId = $element.attr('id'),
          elementClass = $element.attr('class');

      if(typeof elementId === 'string' && '' !== elementId) {
        $element.attr('id', elementId.replace(/([A-Za-z0-9_.\-]+)/g, 'sidr-id-$1'));
      }
      if(typeof elementClass === 'string' && '' !== elementClass && 'sidr-inner' !== elementClass) {
        $element.attr('class', elementClass.replace(/([A-Za-z0-9_.\-]+)/g, 'sidr-class-$1'));
      }
      $element.removeAttr('style');
    },
    execute: function(action, name, callback) {
      // Check arguments
      if(typeof name === 'function') {
        callback = name;
        name = 'sidr';
      }
      else if(!name) {
        name = 'sidr';
      }

      // Declaring
      var $menu = $('#' + name),
          $body = $($menu.data('body')),

          $html = $('html'),
          menuWidth = $menu.outerWidth(true),
          bodyWidth = $body.outerWidth(true),
          newBodyWidth,
          speed = $menu.data('speed'),
          side = $menu.data('side'),
          gutterWidth = $menu.data('gutterWidth'),
          containerWidth = $menu.data('containerWidth'),
          displace = $menu.data('displace'),
          onOpen = $menu.data('onOpen'),
          onClose = $menu.data('onClose'),
          bodyAnimation,
          menuAnimation,
          scrollTop,
          bodyClass = (name === 'sidr' ? 'sidr-open' : 'sidr-open ' + name + '-open');

      // Open Sidr
      if('open' === action || ('toggle' === action && !$menu.is(':visible'))) {
        // Check if we can open it
        if( $menu.is(':visible') || sidrMoving ) {
          return;
        }

        // If another menu opened close first
        if(sidrOpened !== false) {
          methods.close(sidrOpened, function() {
            methods.open(name);
          });

          return;
        }

        // Lock sidr
        sidrMoving = true;
        realignContainer = false;

        // calculate body width based on available screen space
        if (containerWidth) {
          // if side-panel has enough free space in body
          if ((bodyWidth - menuWidth - gutterWidth * 2) > containerWidth){
            newBodyWidth = bodyWidth - menuWidth;
          }
          else {
            newBodyWidth = containerWidth + menuWidth + gutterWidth * 2;
            realignContainer = true;
          }
        }

        // Left or right?
        if(side === 'left') {
          bodyAnimation = newBodyWidth ? {left: menuWidth + 'px',  width: newBodyWidth} : {left: menuWidth + 'px'};
          menuAnimation = {left: '0px'};
        }
        else {
          bodyAnimation = newBodyWidth ? {left: 0,  width: newBodyWidth} : {left: 0};
          menuAnimation = {right: '0px'};
        }

        // Prepare page if container is body
        if($body.is('body')){
          scrollTop = $html.scrollTop();
          $html.css('overflow-x', 'hidden').scrollTop(scrollTop);
        }

        // Open menu
        if(displace){
          // Change body width and reposition
          $body.addClass('sidr-animating').css({
            width: $body.width(),
            position: 'absolute'
          }).animate(bodyAnimation, speed, function() {
            $(this).addClass(bodyClass);

            // Align container to left
            if (realignContainer) {
              $body.find('.container:first').css({
                'margin-left': 0
              });
            }
          });
        }
        else {
          setTimeout(function() {
            $(this).addClass(bodyClass);
          }, speed);
        }
        $menu.css('display', 'block').animate(menuAnimation, speed, function() {
          sidrMoving = false;
          sidrOpened = name;
          // Callback
          if(typeof callback === 'function') {
            callback(name);
          }
          var left = $(document).outerWidth();
          $body.removeClass('sidr-animating').scrollLeft(left);
        });

        // onOpen callback
        onOpen();
      }
      // Close Sidr
      else {
        // Check if we can close it
        if( !$menu.is(':visible') || sidrMoving ) {
          return;
        }

        // Lock sidr
        sidrMoving = true;

        // Right or left menu?
        if(side === 'left') {
          bodyAnimation = {left: 0, width: '100%'};
          menuAnimation = {left: '-' + menuWidth + 'px'};
        }
        else {
          bodyAnimation = {right: 0, width: '100%'};
          menuAnimation = {right: '-' + menuWidth + 'px'};
        }

        // Close menu
        if($body.is('body')){
          scrollTop = $html.scrollTop();
          $html.removeAttr('style').scrollTop(scrollTop);
        }
        $body.addClass('sidr-animating').animate(bodyAnimation, speed).removeClass(bodyClass);
        $menu.animate(menuAnimation, speed, function() {
          $menu.removeAttr('style').hide();
          $body.removeAttr('style');
          $('html').removeAttr('style');
          sidrMoving = false;
          sidrOpened = false;
          // Callback
          if(typeof callback === 'function') {
            callback(name);
          }
          $body.removeClass('sidr-animating');
        });

        // Align container to center again
        $body.find('.container:first').removeAttr('style')

        // onClose callback
        onClose();
      }
    }
  };

  // Sidr public methods
  var methods = {
    open: function(name, callback) {
      privateMethods.execute('open', name, callback);
    },
    close: function(name, callback) {
      privateMethods.execute('close', name, callback);
    },
    toggle: function(name, callback) {
      privateMethods.execute('toggle', name, callback);
    },
    // I made a typo, so I mantain this method to keep backward compatibilty with 1.1.1v and previous
    toogle: function(name, callback) {
      privateMethods.execute('toggle', name, callback);
    }
  };

  $.sidr = function( method ) {

    if ( methods[method] ) {
      return methods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
    }
    else if ( typeof method === 'function' || typeof method === 'string' || ! method ) {
      return methods.toggle.apply( this, arguments );
    }
    else {
      $.error( 'Method ' + method + ' does not exist on jQuery.sidr' );
    }

  };

  $.fn.sidr = function( options ) {

    var settings = $.extend( {
      name          : 'sidr',         // Name for the 'sidr'
      speed         : 200,            // Accepts standard jQuery effects speeds (i.e. fast, normal or milliseconds)
      side          : 'left',         // Accepts 'left' or 'right'
      source        : null,           // Override the source of the content.
      renaming      : true,           // The ids and classes will be prepended with a prefix when loading existent content
      gutterWidth   : 0,             // Add gutterWidth to body when displacing
      containerWidth: 0,          // Consider containerWidth when displacing
      body          : 'body',         // Page container selector,
      displace: true, // Displace the body content or not
      onOpen        : function() {},  // Callback when sidr opened
      onClose       : function() {}   // Callback when sidr closed
    }, options);

    var name = settings.name,
        $sideMenu = $('#' + name);

    // If the side menu do not exist create it
    if( $sideMenu.length === 0 ) {
      $sideMenu = $('<div />')
        .attr('id', name)
        .appendTo($('body'));
    }

    // Adding styles and options
    $sideMenu
      .addClass('sidr')
      .addClass(settings.side)
      .data({
        speed          : settings.speed,
        side           : settings.side,
        body           : settings.body,
        gutterWidth    : settings.gutterWidth,
        containerWidth    : settings.containerWidth,
        displace      : settings.displace,
        onOpen         : settings.onOpen,
        onClose        : settings.onClose
      });

    // The menu content
    if(typeof settings.source === 'function') {
      var newContent = settings.source(name);
      privateMethods.loadContent($sideMenu, newContent);
    }
    else if(typeof settings.source === 'string' && privateMethods.isUrl(settings.source)) {
      $.get(settings.source, function(data) {
        privateMethods.loadContent($sideMenu, data);
      });
    }
    else if(typeof settings.source === 'string') {
      var htmlContent = '',
          selectors = settings.source.split(',');

      $.each(selectors, function(index, element) {
        htmlContent += '<div class="sidr-inner">' + $(element).html() + '</div>';
      });

      // Renaming ids and classes
      if(settings.renaming) {
        var $htmlContent = $('<div />').html(htmlContent);
        $htmlContent.find('*').each(function(index, element) {
          var $element = $(element);
          privateMethods.addPrefix($element);
        });
        htmlContent = $htmlContent.html();
      }
      privateMethods.loadContent($sideMenu, htmlContent);
    }
    else if(settings.source !== null) {
      $.error('Invalid Sidr Source');
    }

    return this.each(function(){
      var $this = $(this),
          data = $this.data('sidr');

      // If the plugin hasn't been initialized yet
      if ( ! data ) {

        $this.data('sidr', name);
        if('ontouchstart' in document.documentElement) {
          $this.bind('touchstart', function(e) {
            var theEvent = e.originalEvent.touches[0];
            this.touched = e.timeStamp;
          });
          $this.bind('touchend', function(e) {
            var delta = Math.abs(e.timeStamp - this.touched);
            if(delta < 200) {
              e.preventDefault();
              methods.toggle(name);
            }
          });
        }
        else {
          $this.click(function(e) {
            e.preventDefault();
            methods.toggle(name);
          });
        }
      }
    });
  };

})( jQuery );
define("jquery-sidr", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.sidr;
    };
}(this)));

// Expanding Textareas v0.1.1
// MIT License
// https://github.com/bgrins/ExpandingTextareas

(function(factory) {
  // Add jQuery via AMD registration or browser globals
  if (typeof define === 'function' && define.amd) {
    define('expanding',[ 'jquery' ], factory);
  }
  else {
    factory(jQuery);
  }
}(function ($) {

  var Expanding = function($textarea, opts) {
    Expanding._registry.push(this);

    this.$textarea = $textarea;
    this.$textCopy = $("<span />");
    this.$clone = $("<pre class='expanding-clone'><br /></pre>").prepend(this.$textCopy);

    this._resetStyles();
    this._setCloneStyles();
    this._setTextareaStyles();

    $textarea
      .wrap($("<div class='expanding-wrapper' style='position:relative' />"))
      .after(this.$clone);

    this.attach();
    this.update();
    if (opts.update) $textarea.bind("update.expanding", opts.update);
  };

  // Stores (active) `Expanding` instances
  // Destroyed instances are removed
  Expanding._registry = [];

  // Returns the `Expanding` instance given a DOM node
  Expanding.getExpandingInstance = function(textarea) {
    var $textareas = $.map(Expanding._registry, function(instance) {
        return instance.$textarea[0];
      }),
      index = $.inArray(textarea, $textareas);
    return index > -1 ? Expanding._registry[index] : null;
  };

  // Returns the version of Internet Explorer or -1
  // (indicating the use of another browser).
  // From: http://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx#ParsingUA
  var ieVersion = (function() {
    var v = -1;
    if (navigator.appName === "Microsoft Internet Explorer") {
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
      if (re.exec(ua) !== null) v = parseFloat(RegExp.$1);
    }
    return v;
  })();

  // Check for oninput support
  // IE9 supports oninput, but not when deleting text, so keyup is used.
  // onpropertychange _is_ supported by IE8/9, but may not be fired unless
  // attached with `attachEvent`
  // (see: http://stackoverflow.com/questions/18436424/ie-onpropertychange-event-doesnt-fire),
  // and so is avoided altogether.
  var inputSupported = "oninput" in document.createElement("input") && ieVersion !== 9;

  Expanding.prototype = {

    // Attaches input events
    // Only attaches `keyup` events if `input` is not fully suported
    attach: function() {
      var events = 'input.expanding change.expanding',
        _this = this;
      if(!inputSupported) events += ' keyup.expanding';
      this.$textarea.bind(events, function() { _this.update(); });
    },

    // Updates the clone with the textarea value
    update: function() {
      this.$textCopy.text(this.$textarea.val().replace(/\r\n/g, "\n"));

      // Use `triggerHandler` to prevent conflicts with `update` in Prototype.js
      this.$textarea.triggerHandler("update.expanding");
    },

    // Tears down the plugin: removes generated elements, applies styles
    // that were prevously present, removes instance from registry,
    // unbinds events
    destroy: function() {
      this.$clone.remove();
      this.$textarea
        .unwrap()
        .attr('style', this._oldTextareaStyles || '');
      delete this._oldTextareaStyles;
      var index = $.inArray(this, Expanding._registry);
      if (index > -1) Expanding._registry.splice(index, 1);
      this.$textarea.unbind(
        'input.expanding change.expanding keyup.expanding update.expanding');
    },

    // Applies reset styles to the textarea and clone
    // Stores the original textarea styles in case of destroying
    _resetStyles: function() {
      this._oldTextareaStyles = this.$textarea.attr('style');

      this.$textarea.add(this.$clone).css({
        margin: 0,
        webkitBoxSizing: "border-box",
        mozBoxSizing: "border-box",
        boxSizing: "border-box",
        width: "100%"
      });
    },

    // Sets the basic clone styles and copies styles over from the textarea
    _setCloneStyles: function() {
      var css = {
        display: 'block',
        border: '0 solid',
        visibility: 'hidden',
        minHeight: this.$textarea.outerHeight()
      };

      if(this.$textarea.attr("wrap") === "off") css.overflowX = "scroll";
      else css.whiteSpace = "pre-wrap";

      this.$clone.css(css);
      this._copyTextareaStylesToClone();
    },

    _copyTextareaStylesToClone: function() {
      var _this = this,
        properties = [
          'lineHeight', 'textDecoration', 'letterSpacing',
          'fontSize', 'fontFamily', 'fontStyle',
          'fontWeight', 'textTransform', 'textAlign',
          'direction', 'wordSpacing', 'fontSizeAdjust',
          'wordWrap', 'word-break',
          'borderLeftWidth', 'borderRightWidth',
          'borderTopWidth','borderBottomWidth',
          'paddingLeft', 'paddingRight',
          'paddingTop','paddingBottom', 'maxHeight'];

      $.each(properties, function(i, property) {
        var val = _this.$textarea.css(property);

        // Prevent overriding percentage css values.
        if(_this.$clone.css(property) !== val) {
          _this.$clone.css(property, val);
          if(property === 'maxHeight' && val !== 'none') {
            _this.$clone.css('overflow', 'hidden');
          }
        }
      });
    },

    _setTextareaStyles: function() {
      this.$textarea.css({
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        resize: "none",
        overflow: "auto"
      });
    }
  };

  $.expanding = $.extend({
    autoInitialize: true,
    initialSelector: "textarea.expanding",
    opts: {
      update: function() { }
    }
  }, $.expanding || {});

  $.fn.expanding = function(o) {

    if (o === "destroy") {
      this.each(function() {
        var instance = Expanding.getExpandingInstance(this);
        if (instance) instance.destroy();
      });
      return this;
    }

    // Checks to see if any of the given DOM nodes have the
    // expanding behaviour.
    if (o === "active") {
      return !!this.filter(function() {
        return !!Expanding.getExpandingInstance(this);
      }).length;
    }

    var opts = $.extend({ }, $.expanding.opts, o);

    this.filter("textarea").each(function() {
      var visible = this.offsetWidth > 0 || this.offsetHeight > 0,
          initialized = Expanding.getExpandingInstance(this);

      if(visible && !initialized) new Expanding($(this), opts);
      else {
        if(!visible) _warn("ExpandingTextareas: attempt to initialize an invisible textarea. Call expanding() again once it has been inserted into the page and/or is visible.");
        if(initialized) _warn("ExpandingTextareas: attempt to initialize a textarea that has already been initialized. Subsequent calls are ignored.");
      }
    });
    return this;
  };

  function _warn(text) {
    if(window.console && console.warn) console.warn(text);
  }

  $(function () {
    if ($.expanding.autoInitialize) {
      $($.expanding.initialSelector).expanding();
    }
  });

}));
/*
*
*  jQuery MD5 Plugin
*
*  string jQuery.MD5( string )
*  input string and return string
*  The $.MD5() function convert string to MD5
*
*  (c) 2012 Winai Reungjam
*  licensed under the MIT licenses.
*
*  This function orginally get from the WebToolkit and rewrite for using as the jQuery plugin.
*  MD5 (Message-Digest Algorithm)
*  http://www.webtoolkit.info/
*
*/

(function($) {
  var MD5;
  MD5 = function(string) {
    var AA, AddUnsigned, BB, CC, ConvertToWordArray, DD, F, FF, G, GG, H, HH, I, II, RotateLeft, S11, S12, S13, S14, S21, S22, S23, S24, S31, S32, S33, S34, S41, S42, S43, S44, Utf8Encode, WordToHex, a, b, c, d, k, temp, x;
    RotateLeft = function(lValue, iShiftBits) {
      return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    };
    AddUnsigned = function(lX, lY) {
      var lResult, lX4, lX8, lY4, lY8;
      lX8 = lX & 0x80000000;
      lY8 = lY & 0x80000000;
      lX4 = lX & 0x40000000;
      lY4 = lY & 0x40000000;
      lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
      if (lX4 & lY4) {
        return lResult ^ 0x80000000 ^ lX8 ^ lY8;
      }
      if (lX4 | lY4) {
        if (lResult & 0x40000000) {
          return lResult ^ 0xC0000000 ^ lX8 ^ lY8;
        } else {
          return lResult ^ 0x40000000 ^ lX8 ^ lY8;
        }
      } else {
        return lResult ^ lX8 ^ lY8;
      }
    };
    F = function(x, y, z) {
      return (x & y) | ((~x) & z);
    };
    G = function(x, y, z) {
      return (x & z) | (y & (~z));
    };
    H = function(x, y, z) {
      return x ^ y ^ z;
    };
    I = function(x, y, z) {
      return y ^ (x | (~z));
    };
    FF = function(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };
    GG = function(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };
    HH = function(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };
    II = function(a, b, c, d, x, s, ac) {
      a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
      return AddUnsigned(RotateLeft(a, s), b);
    };
    ConvertToWordArray = function(string) {
      var lByteCount, lBytePosition, lMessageLength, lNumberOfWords, lNumberOfWords_temp1, lNumberOfWords_temp2, lWordArray, lWordCount;
      lMessageLength = string.length;
      lNumberOfWords_temp1 = lMessageLength + 8;
      lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
      lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
      lWordArray = Array(lNumberOfWords - 1);
      lBytePosition = 0;
      lByteCount = 0;
      while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition);
        lByteCount++;
      }
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
      lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
      lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
      return lWordArray;
    };
    WordToHex = function(lValue) {
      var WordToHexValue, WordToHexValue_temp, lByte, lCount;
      WordToHexValue = "";
      WordToHexValue_temp = "";
      lCount = 0;
      while (lCount <= 3) {
        lByte = (lValue >>> (lCount * 8)) & 255;
        WordToHexValue_temp = "0" + lByte.toString(16);
        WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
        lCount++;
      }
      return WordToHexValue;
    };
    Utf8Encode = function(string) {
      var c, n, utftext;
      string = string.replace(/\r\n/g, "\n");
      utftext = "";
      n = 0;
      while (n < string.length) {
        c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
        n++;
      }
      return utftext;
    };
    x = Array();
    S11 = 7;
    S12 = 12;
    S13 = 17;
    S14 = 22;
    S21 = 5;
    S22 = 9;
    S23 = 14;
    S24 = 20;
    S31 = 4;
    S32 = 11;
    S33 = 16;
    S34 = 23;
    S41 = 6;
    S42 = 10;
    S43 = 15;
    S44 = 21;
    string = Utf8Encode(string);
    x = ConvertToWordArray(string);
    a = 0x67452301;
    b = 0xEFCDAB89;
    c = 0x98BADCFE;
    d = 0x10325476;
    k = 0;
    while (k < x.length) {
      AA = a;
      BB = b;
      CC = c;
      DD = d;
      a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
      d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
      c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
      b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
      a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
      d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
      c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
      b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
      a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
      d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
      c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
      b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
      a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
      d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
      c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
      b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
      a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
      d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
      c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
      b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
      a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
      d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
      c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
      b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
      a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
      d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
      c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
      b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
      a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
      d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
      c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
      b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
      a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
      d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
      c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
      b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
      a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
      d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
      c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
      b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
      a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
      d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
      c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
      b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
      a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
      d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
      c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
      b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
      a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
      d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
      c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
      b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
      a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
      d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
      c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
      b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
      a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
      d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
      c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
      b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
      a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
      d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
      c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
      b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
      a = AddUnsigned(a, AA);
      b = AddUnsigned(b, BB);
      c = AddUnsigned(c, CC);
      d = AddUnsigned(d, DD);
      k += 16;
    }
    temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);
    return temp.toLowerCase();
  };
  return $.extend({
    MD5: MD5
  });
})(jQuery);
define("jquery-md5", function(){});

/*!
* ZeroClipboard
* The ZeroClipboard library provides an easy way to copy text to the clipboard using an invisible Adobe Flash movie and a JavaScript interface.
* Copyright (c) 2014 Jon Rohan, James M. Greene
* Licensed MIT
* http://zeroclipboard.org/
* v1.3.5
*/
(function(window) {
  "use strict";
  var currentElement;
  var flashState = {
    bridge: null,
    version: "0.0.0",
    disabled: null,
    outdated: null,
    ready: null
  };
  var _clipData = {};
  var clientIdCounter = 0;
  var _clientMeta = {};
  var elementIdCounter = 0;
  var _elementMeta = {};
  var _amdModuleId = null;
  var _cjsModuleId = null;
  var _swfPath = function() {
    var i, jsDir, tmpJsPath, jsPath, swfPath = "ZeroClipboard.swf";
    if (document.currentScript && (jsPath = document.currentScript.src)) {} else {
      var scripts = document.getElementsByTagName("script");
      if ("readyState" in scripts[0]) {
        for (i = scripts.length; i--; ) {
          if (scripts[i].readyState === "interactive" && (jsPath = scripts[i].src)) {
            break;
          }
        }
      } else if (document.readyState === "loading") {
        jsPath = scripts[scripts.length - 1].src;
      } else {
        for (i = scripts.length; i--; ) {
          tmpJsPath = scripts[i].src;
          if (!tmpJsPath) {
            jsDir = null;
            break;
          }
          tmpJsPath = tmpJsPath.split("#")[0].split("?")[0];
          tmpJsPath = tmpJsPath.slice(0, tmpJsPath.lastIndexOf("/") + 1);
          if (jsDir == null) {
            jsDir = tmpJsPath;
          } else if (jsDir !== tmpJsPath) {
            jsDir = null;
            break;
          }
        }
        if (jsDir !== null) {
          jsPath = jsDir;
        }
      }
    }
    if (jsPath) {
      jsPath = jsPath.split("#")[0].split("?")[0];
      swfPath = jsPath.slice(0, jsPath.lastIndexOf("/") + 1) + swfPath;
    }
    return swfPath;
  }();
  var _camelizeCssPropName = function() {
    var matcherRegex = /\-([a-z])/g, replacerFn = function(match, group) {
      return group.toUpperCase();
    };
    return function(prop) {
      return prop.replace(matcherRegex, replacerFn);
    };
  }();
  var _getStyle = function(el, prop) {
    var value, camelProp, tagName, possiblePointers, i, len;
    if (window.getComputedStyle) {
      value = window.getComputedStyle(el, null).getPropertyValue(prop);
    } else {
      camelProp = _camelizeCssPropName(prop);
      if (el.currentStyle) {
        value = el.currentStyle[camelProp];
      } else {
        value = el.style[camelProp];
      }
    }
    if (prop === "cursor") {
      if (!value || value === "auto") {
        tagName = el.tagName.toLowerCase();
        if (tagName === "a") {
          return "pointer";
        }
      }
    }
    return value;
  };
  var _elementMouseOver = function(event) {
    if (!event) {
      event = window.event;
    }
    var target;
    if (this !== window) {
      target = this;
    } else if (event.target) {
      target = event.target;
    } else if (event.srcElement) {
      target = event.srcElement;
    }
    ZeroClipboard.activate(target);
  };
  var _addEventHandler = function(element, method, func) {
    if (!element || element.nodeType !== 1) {
      return;
    }
    if (element.addEventListener) {
      element.addEventListener(method, func, false);
    } else if (element.attachEvent) {
      element.attachEvent("on" + method, func);
    }
  };
  var _removeEventHandler = function(element, method, func) {
    if (!element || element.nodeType !== 1) {
      return;
    }
    if (element.removeEventListener) {
      element.removeEventListener(method, func, false);
    } else if (element.detachEvent) {
      element.detachEvent("on" + method, func);
    }
  };
  var _addClass = function(element, value) {
    if (!element || element.nodeType !== 1) {
      return element;
    }
    if (element.classList) {
      if (!element.classList.contains(value)) {
        element.classList.add(value);
      }
      return element;
    }
    if (value && typeof value === "string") {
      var classNames = (value || "").split(/\s+/);
      if (element.nodeType === 1) {
        if (!element.className) {
          element.className = value;
        } else {
          var className = " " + element.className + " ", setClass = element.className;
          for (var c = 0, cl = classNames.length; c < cl; c++) {
            if (className.indexOf(" " + classNames[c] + " ") < 0) {
              setClass += " " + classNames[c];
            }
          }
          element.className = setClass.replace(/^\s+|\s+$/g, "");
        }
      }
    }
    return element;
  };
  var _removeClass = function(element, value) {
    if (!element || element.nodeType !== 1) {
      return element;
    }
    if (element.classList) {
      if (element.classList.contains(value)) {
        element.classList.remove(value);
      }
      return element;
    }
    if (value && typeof value === "string" || value === undefined) {
      var classNames = (value || "").split(/\s+/);
      if (element.nodeType === 1 && element.className) {
        if (value) {
          var className = (" " + element.className + " ").replace(/[\n\t]/g, " ");
          for (var c = 0, cl = classNames.length; c < cl; c++) {
            className = className.replace(" " + classNames[c] + " ", " ");
          }
          element.className = className.replace(/^\s+|\s+$/g, "");
        } else {
          element.className = "";
        }
      }
    }
    return element;
  };
  var _getZoomFactor = function() {
    var rect, physicalWidth, logicalWidth, zoomFactor = 1;
    if (typeof document.body.getBoundingClientRect === "function") {
      rect = document.body.getBoundingClientRect();
      physicalWidth = rect.right - rect.left;
      logicalWidth = document.body.offsetWidth;
      zoomFactor = Math.round(physicalWidth / logicalWidth * 100) / 100;
    }
    return zoomFactor;
  };
  var _getDOMObjectPosition = function(obj, defaultZIndex) {
    var info = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      zIndex: _getSafeZIndex(defaultZIndex) - 1
    };
    if (obj.getBoundingClientRect) {
      var rect = obj.getBoundingClientRect();
      var pageXOffset, pageYOffset, zoomFactor;
      if ("pageXOffset" in window && "pageYOffset" in window) {
        pageXOffset = window.pageXOffset;
        pageYOffset = window.pageYOffset;
      } else {
        zoomFactor = _getZoomFactor();
        pageXOffset = Math.round(document.documentElement.scrollLeft / zoomFactor);
        pageYOffset = Math.round(document.documentElement.scrollTop / zoomFactor);
      }
      var leftBorderWidth = document.documentElement.clientLeft || 0;
      var topBorderWidth = document.documentElement.clientTop || 0;
      info.left = rect.left + pageXOffset - leftBorderWidth;
      info.top = rect.top + pageYOffset - topBorderWidth;
      info.width = "width" in rect ? rect.width : rect.right - rect.left;
      info.height = "height" in rect ? rect.height : rect.bottom - rect.top;
    }
    return info;
  };
  var _cacheBust = function(path, options) {
    var cacheBust = options == null || options && options.cacheBust === true && options.useNoCache === true;
    if (cacheBust) {
      return (path.indexOf("?") === -1 ? "?" : "&") + "noCache=" + new Date().getTime();
    } else {
      return "";
    }
  };
  var _vars = function(options) {
    var i, len, domain, str = [], domains = [], trustedOriginsExpanded = [];
    if (options.trustedOrigins) {
      if (typeof options.trustedOrigins === "string") {
        domains.push(options.trustedOrigins);
      } else if (typeof options.trustedOrigins === "object" && "length" in options.trustedOrigins) {
        domains = domains.concat(options.trustedOrigins);
      }
    }
    if (options.trustedDomains) {
      if (typeof options.trustedDomains === "string") {
        domains.push(options.trustedDomains);
      } else if (typeof options.trustedDomains === "object" && "length" in options.trustedDomains) {
        domains = domains.concat(options.trustedDomains);
      }
    }
    if (domains.length) {
      for (i = 0, len = domains.length; i < len; i++) {
        if (domains.hasOwnProperty(i) && domains[i] && typeof domains[i] === "string") {
          domain = _extractDomain(domains[i]);
          if (!domain) {
            continue;
          }
          if (domain === "*") {
            trustedOriginsExpanded = [ domain ];
            break;
          }
          trustedOriginsExpanded.push.apply(trustedOriginsExpanded, [ domain, "//" + domain, window.location.protocol + "//" + domain ]);
        }
      }
    }
    if (trustedOriginsExpanded.length) {
      str.push("trustedOrigins=" + encodeURIComponent(trustedOriginsExpanded.join(",")));
    }
    if (typeof options.jsModuleId === "string" && options.jsModuleId) {
      str.push("jsModuleId=" + encodeURIComponent(options.jsModuleId));
    }
    return str.join("&");
  };
  var _inArray = function(elem, array, fromIndex) {
    if (typeof array.indexOf === "function") {
      return array.indexOf(elem, fromIndex);
    }
    var i, len = array.length;
    if (typeof fromIndex === "undefined") {
      fromIndex = 0;
    } else if (fromIndex < 0) {
      fromIndex = len + fromIndex;
    }
    for (i = fromIndex; i < len; i++) {
      if (array.hasOwnProperty(i) && array[i] === elem) {
        return i;
      }
    }
    return -1;
  };
  var _prepClip = function(elements) {
    if (typeof elements === "string") throw new TypeError("ZeroClipboard doesn't accept query strings.");
    if (!elements.length) return [ elements ];
    return elements;
  };
  var _dispatchCallback = function(func, context, args, async) {
    if (async) {
      window.setTimeout(function() {
        func.apply(context, args);
      }, 0);
    } else {
      func.apply(context, args);
    }
  };
  var _getSafeZIndex = function(val) {
    var zIndex, tmp;
    if (val) {
      if (typeof val === "number" && val > 0) {
        zIndex = val;
      } else if (typeof val === "string" && (tmp = parseInt(val, 10)) && !isNaN(tmp) && tmp > 0) {
        zIndex = tmp;
      }
    }
    if (!zIndex) {
      if (typeof _globalConfig.zIndex === "number" && _globalConfig.zIndex > 0) {
        zIndex = _globalConfig.zIndex;
      } else if (typeof _globalConfig.zIndex === "string" && (tmp = parseInt(_globalConfig.zIndex, 10)) && !isNaN(tmp) && tmp > 0) {
        zIndex = tmp;
      }
    }
    return zIndex || 0;
  };
  var _deprecationWarning = function(deprecatedApiName, debugEnabled) {
    if (deprecatedApiName && debugEnabled !== false && typeof console !== "undefined" && console && (console.warn || console.log)) {
      var deprecationWarning = "`" + deprecatedApiName + "` is deprecated. See docs for more info:\n" + "    https://github.com/zeroclipboard/zeroclipboard/blob/master/docs/instructions.md#deprecations";
      if (console.warn) {
        console.warn(deprecationWarning);
      } else {
        console.log(deprecationWarning);
      }
    }
  };
  var _extend = function() {
    var i, len, arg, prop, src, copy, target = arguments[0] || {};
    for (i = 1, len = arguments.length; i < len; i++) {
      if ((arg = arguments[i]) != null) {
        for (prop in arg) {
          if (arg.hasOwnProperty(prop)) {
            src = target[prop];
            copy = arg[prop];
            if (target === copy) {
              continue;
            }
            if (copy !== undefined) {
              target[prop] = copy;
            }
          }
        }
      }
    }
    return target;
  };
  var _extractDomain = function(originOrUrl) {
    if (originOrUrl == null || originOrUrl === "") {
      return null;
    }
    originOrUrl = originOrUrl.replace(/^\s+|\s+$/g, "");
    if (originOrUrl === "") {
      return null;
    }
    var protocolIndex = originOrUrl.indexOf("//");
    originOrUrl = protocolIndex === -1 ? originOrUrl : originOrUrl.slice(protocolIndex + 2);
    var pathIndex = originOrUrl.indexOf("/");
    originOrUrl = pathIndex === -1 ? originOrUrl : protocolIndex === -1 || pathIndex === 0 ? null : originOrUrl.slice(0, pathIndex);
    if (originOrUrl && originOrUrl.slice(-4).toLowerCase() === ".swf") {
      return null;
    }
    return originOrUrl || null;
  };
  var _determineScriptAccess = function() {
    var _extractAllDomains = function(origins, resultsArray) {
      var i, len, tmp;
      if (origins != null && resultsArray[0] !== "*") {
        if (typeof origins === "string") {
          origins = [ origins ];
        }
        if (typeof origins === "object" && "length" in origins) {
          for (i = 0, len = origins.length; i < len; i++) {
            if (origins.hasOwnProperty(i)) {
              tmp = _extractDomain(origins[i]);
              if (tmp) {
                if (tmp === "*") {
                  resultsArray.length = 0;
                  resultsArray.push("*");
                  break;
                }
                if (_inArray(tmp, resultsArray) === -1) {
                  resultsArray.push(tmp);
                }
              }
            }
          }
        }
      }
    };
    var _accessLevelLookup = {
      always: "always",
      samedomain: "sameDomain",
      never: "never"
    };
    return function(currentDomain, configOptions) {
      var asaLower, allowScriptAccess = configOptions.allowScriptAccess;
      if (typeof allowScriptAccess === "string" && (asaLower = allowScriptAccess.toLowerCase()) && /^always|samedomain|never$/.test(asaLower)) {
        return _accessLevelLookup[asaLower];
      }
      var swfDomain = _extractDomain(configOptions.moviePath);
      if (swfDomain === null) {
        swfDomain = currentDomain;
      }
      var trustedDomains = [];
      _extractAllDomains(configOptions.trustedOrigins, trustedDomains);
      _extractAllDomains(configOptions.trustedDomains, trustedDomains);
      var len = trustedDomains.length;
      if (len > 0) {
        if (len === 1 && trustedDomains[0] === "*") {
          return "always";
        }
        if (_inArray(currentDomain, trustedDomains) !== -1) {
          if (len === 1 && currentDomain === swfDomain) {
            return "sameDomain";
          }
          return "always";
        }
      }
      return "never";
    };
  }();
  var _objectKeys = function(obj) {
    if (obj == null) {
      return [];
    }
    if (Object.keys) {
      return Object.keys(obj);
    }
    var keys = [];
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        keys.push(prop);
      }
    }
    return keys;
  };
  var _deleteOwnProperties = function(obj) {
    if (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          delete obj[prop];
        }
      }
    }
    return obj;
  };
  var _safeActiveElement = function() {
    try {
      return document.activeElement;
    } catch (err) {}
    return null;
  };
  var _detectFlashSupport = function() {
    var hasFlash = false;
    if (typeof flashState.disabled === "boolean") {
      hasFlash = flashState.disabled === false;
    } else {
      if (typeof ActiveXObject === "function") {
        try {
          if (new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) {
            hasFlash = true;
          }
        } catch (error) {}
      }
      if (!hasFlash && navigator.mimeTypes["application/x-shockwave-flash"]) {
        hasFlash = true;
      }
    }
    return hasFlash;
  };
  function _parseFlashVersion(flashVersion) {
    return flashVersion.replace(/,/g, ".").replace(/[^0-9\.]/g, "");
  }
  function _isFlashVersionSupported(flashVersion) {
    return parseFloat(_parseFlashVersion(flashVersion)) >= 10;
  }
  var ZeroClipboard = function(elements, options) {
    if (!(this instanceof ZeroClipboard)) {
      return new ZeroClipboard(elements, options);
    }
    this.id = "" + clientIdCounter++;
    _clientMeta[this.id] = {
      instance: this,
      elements: [],
      handlers: {}
    };
    if (elements) {
      this.clip(elements);
    }
    if (typeof options !== "undefined") {
      _deprecationWarning("new ZeroClipboard(elements, options)", _globalConfig.debug);
      ZeroClipboard.config(options);
    }
    this.options = ZeroClipboard.config();
    if (typeof flashState.disabled !== "boolean") {
      flashState.disabled = !_detectFlashSupport();
    }
    if (flashState.disabled === false && flashState.outdated !== true) {
      if (flashState.bridge === null) {
        flashState.outdated = false;
        flashState.ready = false;
        _bridge();
      }
    }
  };
  ZeroClipboard.prototype.setText = function(newText) {
    if (newText && newText !== "") {
      _clipData["text/plain"] = newText;
      if (flashState.ready === true && flashState.bridge && typeof flashState.bridge.setText === "function") {
        flashState.bridge.setText(newText);
      } else {
        flashState.ready = false;
      }
    }
    return this;
  };
  ZeroClipboard.prototype.setSize = function(width, height) {
    if (flashState.ready === true && flashState.bridge && typeof flashState.bridge.setSize === "function") {
      flashState.bridge.setSize(width, height);
    } else {
      flashState.ready = false;
    }
    return this;
  };
  var _setHandCursor = function(enabled) {
    if (flashState.ready === true && flashState.bridge && typeof flashState.bridge.setHandCursor === "function") {
      flashState.bridge.setHandCursor(enabled);
    } else {
      flashState.ready = false;
    }
  };
  ZeroClipboard.prototype.destroy = function() {
    this.unclip();
    this.off();
    delete _clientMeta[this.id];
  };
  var _getAllClients = function() {
    var i, len, client, clients = [], clientIds = _objectKeys(_clientMeta);
    for (i = 0, len = clientIds.length; i < len; i++) {
      client = _clientMeta[clientIds[i]].instance;
      if (client && client instanceof ZeroClipboard) {
        clients.push(client);
      }
    }
    return clients;
  };
  ZeroClipboard.version = "1.3.5";
  var _globalConfig = {
    swfPath: _swfPath,
    trustedDomains: window.location.host ? [ window.location.host ] : [],
    cacheBust: true,
    forceHandCursor: false,
    zIndex: 999999999,
    debug: true,
    title: null,
    autoActivate: true
  };
  ZeroClipboard.config = function(options) {
    if (typeof options === "object" && options !== null) {
      _extend(_globalConfig, options);
    }
    if (typeof options === "string" && options) {
      if (_globalConfig.hasOwnProperty(options)) {
        return _globalConfig[options];
      }
      return;
    }
    var copy = {};
    for (var prop in _globalConfig) {
      if (_globalConfig.hasOwnProperty(prop)) {
        if (typeof _globalConfig[prop] === "object" && _globalConfig[prop] !== null) {
          if ("length" in _globalConfig[prop]) {
            copy[prop] = _globalConfig[prop].slice(0);
          } else {
            copy[prop] = _extend({}, _globalConfig[prop]);
          }
        } else {
          copy[prop] = _globalConfig[prop];
        }
      }
    }
    return copy;
  };
  ZeroClipboard.destroy = function() {
    ZeroClipboard.deactivate();
    for (var clientId in _clientMeta) {
      if (_clientMeta.hasOwnProperty(clientId) && _clientMeta[clientId]) {
        var client = _clientMeta[clientId].instance;
        if (client && typeof client.destroy === "function") {
          client.destroy();
        }
      }
    }
    var htmlBridge = _getHtmlBridge(flashState.bridge);
    if (htmlBridge && htmlBridge.parentNode) {
      htmlBridge.parentNode.removeChild(htmlBridge);
      flashState.ready = null;
      flashState.bridge = null;
    }
  };
  ZeroClipboard.activate = function(element) {
    if (currentElement) {
      _removeClass(currentElement, _globalConfig.hoverClass);
      _removeClass(currentElement, _globalConfig.activeClass);
    }
    currentElement = element;
    _addClass(element, _globalConfig.hoverClass);
    _reposition();
    var newTitle = _globalConfig.title || element.getAttribute("title");
    if (newTitle) {
      var htmlBridge = _getHtmlBridge(flashState.bridge);
      if (htmlBridge) {
        htmlBridge.setAttribute("title", newTitle);
      }
    }
    var useHandCursor = _globalConfig.forceHandCursor === true || _getStyle(element, "cursor") === "pointer";
    _setHandCursor(useHandCursor);
  };
  ZeroClipboard.deactivate = function() {
    var htmlBridge = _getHtmlBridge(flashState.bridge);
    if (htmlBridge) {
      htmlBridge.style.left = "0px";
      htmlBridge.style.top = "-9999px";
      htmlBridge.removeAttribute("title");
    }
    if (currentElement) {
      _removeClass(currentElement, _globalConfig.hoverClass);
      _removeClass(currentElement, _globalConfig.activeClass);
      currentElement = null;
    }
  };
  var _bridge = function() {
    var flashBridge, len;
    var container = document.getElementById("global-zeroclipboard-html-bridge");
    if (!container) {
      var opts = ZeroClipboard.config();
      opts.jsModuleId = typeof _amdModuleId === "string" && _amdModuleId || typeof _cjsModuleId === "string" && _cjsModuleId || null;
      var allowScriptAccess = _determineScriptAccess(window.location.host, _globalConfig);
      var flashvars = _vars(opts);
      var swfUrl = _globalConfig.moviePath + _cacheBust(_globalConfig.moviePath, _globalConfig);
      var html = '      <object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" id="global-zeroclipboard-flash-bridge" width="100%" height="100%">         <param name="movie" value="' + swfUrl + '"/>         <param name="allowScriptAccess" value="' + allowScriptAccess + '"/>         <param name="scale" value="exactfit"/>         <param name="loop" value="false"/>         <param name="menu" value="false"/>         <param name="quality" value="best" />         <param name="bgcolor" value="#ffffff"/>         <param name="wmode" value="transparent"/>         <param name="flashvars" value="' + flashvars + '"/>         <embed src="' + swfUrl + '"           loop="false" menu="false"           quality="best" bgcolor="#ffffff"           width="100%" height="100%"           name="global-zeroclipboard-flash-bridge"           allowScriptAccess="' + allowScriptAccess + '"           allowFullScreen="false"           type="application/x-shockwave-flash"           wmode="transparent"           pluginspage="http://www.macromedia.com/go/getflashplayer"           flashvars="' + flashvars + '"           scale="exactfit">         </embed>       </object>';
      container = document.createElement("div");
      container.id = "global-zeroclipboard-html-bridge";
      container.setAttribute("class", "global-zeroclipboard-container");
      container.style.position = "absolute";
      container.style.left = "0px";
      container.style.top = "-9999px";
      container.style.width = "15px";
      container.style.height = "15px";
      container.style.zIndex = "" + _getSafeZIndex(_globalConfig.zIndex);
      document.body.appendChild(container);
      container.innerHTML = html;
    }
    flashBridge = document["global-zeroclipboard-flash-bridge"];
    if (flashBridge && (len = flashBridge.length)) {
      flashBridge = flashBridge[len - 1];
    }
    flashState.bridge = flashBridge || container.children[0].lastElementChild;
  };
  var _getHtmlBridge = function(flashBridge) {
    var isFlashElement = /^OBJECT|EMBED$/;
    var htmlBridge = flashBridge && flashBridge.parentNode;
    while (htmlBridge && isFlashElement.test(htmlBridge.nodeName) && htmlBridge.parentNode) {
      htmlBridge = htmlBridge.parentNode;
    }
    return htmlBridge || null;
  };
  var _reposition = function() {
    if (currentElement) {
      var pos = _getDOMObjectPosition(currentElement, _globalConfig.zIndex);
      var htmlBridge = _getHtmlBridge(flashState.bridge);
      if (htmlBridge) {
        htmlBridge.style.top = pos.top + "px";
        htmlBridge.style.left = pos.left + "px";
        htmlBridge.style.width = pos.width + "px";
        htmlBridge.style.height = pos.height + "px";
        htmlBridge.style.zIndex = pos.zIndex + 1;
      }
      if (flashState.ready === true && flashState.bridge && typeof flashState.bridge.setSize === "function") {
        flashState.bridge.setSize(pos.width, pos.height);
      } else {
        flashState.ready = false;
      }
    }
    return this;
  };
  ZeroClipboard.prototype.on = function(eventName, func) {
    var i, len, events, added = {}, handlers = _clientMeta[this.id] && _clientMeta[this.id].handlers;
    if (typeof eventName === "string" && eventName) {
      events = eventName.toLowerCase().split(/\s+/);
    } else if (typeof eventName === "object" && eventName && typeof func === "undefined") {
      for (i in eventName) {
        if (eventName.hasOwnProperty(i) && typeof i === "string" && i && typeof eventName[i] === "function") {
          this.on(i, eventName[i]);
        }
      }
    }
    if (events && events.length) {
      for (i = 0, len = events.length; i < len; i++) {
        eventName = events[i].replace(/^on/, "");
        added[eventName] = true;
        if (!handlers[eventName]) {
          handlers[eventName] = [];
        }
        handlers[eventName].push(func);
      }
      if (added.noflash && flashState.disabled) {
        _receiveEvent.call(this, "noflash", {});
      }
      if (added.wrongflash && flashState.outdated) {
        _receiveEvent.call(this, "wrongflash", {
          flashVersion: flashState.version
        });
      }
      if (added.load && flashState.ready) {
        _receiveEvent.call(this, "load", {
          flashVersion: flashState.version
        });
      }
    }
    return this;
  };
  ZeroClipboard.prototype.off = function(eventName, func) {
    var i, len, foundIndex, events, perEventHandlers, handlers = _clientMeta[this.id] && _clientMeta[this.id].handlers;
    if (arguments.length === 0) {
      events = _objectKeys(handlers);
    } else if (typeof eventName === "string" && eventName) {
      events = eventName.split(/\s+/);
    } else if (typeof eventName === "object" && eventName && typeof func === "undefined") {
      for (i in eventName) {
        if (eventName.hasOwnProperty(i) && typeof i === "string" && i && typeof eventName[i] === "function") {
          this.off(i, eventName[i]);
        }
      }
    }
    if (events && events.length) {
      for (i = 0, len = events.length; i < len; i++) {
        eventName = events[i].toLowerCase().replace(/^on/, "");
        perEventHandlers = handlers[eventName];
        if (perEventHandlers && perEventHandlers.length) {
          if (func) {
            foundIndex = _inArray(func, perEventHandlers);
            while (foundIndex !== -1) {
              perEventHandlers.splice(foundIndex, 1);
              foundIndex = _inArray(func, perEventHandlers, foundIndex);
            }
          } else {
            handlers[eventName].length = 0;
          }
        }
      }
    }
    return this;
  };
  ZeroClipboard.prototype.handlers = function(eventName) {
    var prop, copy = null, handlers = _clientMeta[this.id] && _clientMeta[this.id].handlers;
    if (handlers) {
      if (typeof eventName === "string" && eventName) {
        return handlers[eventName] ? handlers[eventName].slice(0) : null;
      }
      copy = {};
      for (prop in handlers) {
        if (handlers.hasOwnProperty(prop) && handlers[prop]) {
          copy[prop] = handlers[prop].slice(0);
        }
      }
    }
    return copy;
  };
  var _dispatchClientCallbacks = function(eventName, context, args, async) {
    var handlers = _clientMeta[this.id] && _clientMeta[this.id].handlers[eventName];
    if (handlers && handlers.length) {
      var i, len, func, originalContext = context || this;
      for (i = 0, len = handlers.length; i < len; i++) {
        func = handlers[i];
        context = originalContext;
        if (typeof func === "string" && typeof window[func] === "function") {
          func = window[func];
        }
        if (typeof func === "object" && func && typeof func.handleEvent === "function") {
          context = func;
          func = func.handleEvent;
        }
        if (typeof func === "function") {
          _dispatchCallback(func, context, args, async);
        }
      }
    }
    return this;
  };
  ZeroClipboard.prototype.clip = function(elements) {
    elements = _prepClip(elements);
    for (var i = 0; i < elements.length; i++) {
      if (elements.hasOwnProperty(i) && elements[i] && elements[i].nodeType === 1) {
        if (!elements[i].zcClippingId) {
          elements[i].zcClippingId = "zcClippingId_" + elementIdCounter++;
          _elementMeta[elements[i].zcClippingId] = [ this.id ];
          if (_globalConfig.autoActivate === true) {
            _addEventHandler(elements[i], "mouseover", _elementMouseOver);
          }
        } else if (_inArray(this.id, _elementMeta[elements[i].zcClippingId]) === -1) {
          _elementMeta[elements[i].zcClippingId].push(this.id);
        }
        var clippedElements = _clientMeta[this.id].elements;
        if (_inArray(elements[i], clippedElements) === -1) {
          clippedElements.push(elements[i]);
        }
      }
    }
    return this;
  };
  ZeroClipboard.prototype.unclip = function(elements) {
    var meta = _clientMeta[this.id];
    if (meta) {
      var clippedElements = meta.elements;
      var arrayIndex;
      if (typeof elements === "undefined") {
        elements = clippedElements.slice(0);
      } else {
        elements = _prepClip(elements);
      }
      for (var i = elements.length; i--; ) {
        if (elements.hasOwnProperty(i) && elements[i] && elements[i].nodeType === 1) {
          arrayIndex = 0;
          while ((arrayIndex = _inArray(elements[i], clippedElements, arrayIndex)) !== -1) {
            clippedElements.splice(arrayIndex, 1);
          }
          var clientIds = _elementMeta[elements[i].zcClippingId];
          if (clientIds) {
            arrayIndex = 0;
            while ((arrayIndex = _inArray(this.id, clientIds, arrayIndex)) !== -1) {
              clientIds.splice(arrayIndex, 1);
            }
            if (clientIds.length === 0) {
              if (_globalConfig.autoActivate === true) {
                _removeEventHandler(elements[i], "mouseover", _elementMouseOver);
              }
              delete elements[i].zcClippingId;
            }
          }
        }
      }
    }
    return this;
  };
  ZeroClipboard.prototype.elements = function() {
    var meta = _clientMeta[this.id];
    return meta && meta.elements ? meta.elements.slice(0) : [];
  };
  var _getAllClientsClippedToElement = function(element) {
    var elementMetaId, clientIds, i, len, client, clients = [];
    if (element && element.nodeType === 1 && (elementMetaId = element.zcClippingId) && _elementMeta.hasOwnProperty(elementMetaId)) {
      clientIds = _elementMeta[elementMetaId];
      if (clientIds && clientIds.length) {
        for (i = 0, len = clientIds.length; i < len; i++) {
          client = _clientMeta[clientIds[i]].instance;
          if (client && client instanceof ZeroClipboard) {
            clients.push(client);
          }
        }
      }
    }
    return clients;
  };
  _globalConfig.hoverClass = "zeroclipboard-is-hover";
  _globalConfig.activeClass = "zeroclipboard-is-active";
  _globalConfig.trustedOrigins = null;
  _globalConfig.allowScriptAccess = null;
  _globalConfig.useNoCache = true;
  _globalConfig.moviePath = "ZeroClipboard.swf";
  ZeroClipboard.detectFlashSupport = function() {
    _deprecationWarning("ZeroClipboard.detectFlashSupport", _globalConfig.debug);
    return _detectFlashSupport();
  };
  ZeroClipboard.dispatch = function(eventName, args) {
    if (typeof eventName === "string" && eventName) {
      var cleanEventName = eventName.toLowerCase().replace(/^on/, "");
      if (cleanEventName) {
        var clients = currentElement && _globalConfig.autoActivate === true ? _getAllClientsClippedToElement(currentElement) : _getAllClients();
        for (var i = 0, len = clients.length; i < len; i++) {
          _receiveEvent.call(clients[i], cleanEventName, args);
        }
      }
    }
  };
  ZeroClipboard.prototype.setHandCursor = function(enabled) {
    _deprecationWarning("ZeroClipboard.prototype.setHandCursor", _globalConfig.debug);
    enabled = typeof enabled === "boolean" ? enabled : !!enabled;
    _setHandCursor(enabled);
    _globalConfig.forceHandCursor = enabled;
    return this;
  };
  ZeroClipboard.prototype.reposition = function() {
    _deprecationWarning("ZeroClipboard.prototype.reposition", _globalConfig.debug);
    return _reposition();
  };
  ZeroClipboard.prototype.receiveEvent = function(eventName, args) {
    _deprecationWarning("ZeroClipboard.prototype.receiveEvent", _globalConfig.debug);
    if (typeof eventName === "string" && eventName) {
      var cleanEventName = eventName.toLowerCase().replace(/^on/, "");
      if (cleanEventName) {
        _receiveEvent.call(this, cleanEventName, args);
      }
    }
  };
  ZeroClipboard.prototype.setCurrent = function(element) {
    _deprecationWarning("ZeroClipboard.prototype.setCurrent", _globalConfig.debug);
    ZeroClipboard.activate(element);
    return this;
  };
  ZeroClipboard.prototype.resetBridge = function() {
    _deprecationWarning("ZeroClipboard.prototype.resetBridge", _globalConfig.debug);
    ZeroClipboard.deactivate();
    return this;
  };
  ZeroClipboard.prototype.setTitle = function(newTitle) {
    _deprecationWarning("ZeroClipboard.prototype.setTitle", _globalConfig.debug);
    newTitle = newTitle || _globalConfig.title || currentElement && currentElement.getAttribute("title");
    if (newTitle) {
      var htmlBridge = _getHtmlBridge(flashState.bridge);
      if (htmlBridge) {
        htmlBridge.setAttribute("title", newTitle);
      }
    }
    return this;
  };
  ZeroClipboard.setDefaults = function(options) {
    _deprecationWarning("ZeroClipboard.setDefaults", _globalConfig.debug);
    ZeroClipboard.config(options);
  };
  ZeroClipboard.prototype.addEventListener = function(eventName, func) {
    _deprecationWarning("ZeroClipboard.prototype.addEventListener", _globalConfig.debug);
    return this.on(eventName, func);
  };
  ZeroClipboard.prototype.removeEventListener = function(eventName, func) {
    _deprecationWarning("ZeroClipboard.prototype.removeEventListener", _globalConfig.debug);
    return this.off(eventName, func);
  };
  ZeroClipboard.prototype.ready = function() {
    _deprecationWarning("ZeroClipboard.prototype.ready", _globalConfig.debug);
    return flashState.ready === true;
  };
  var _receiveEvent = function(eventName, args) {
    eventName = eventName.toLowerCase().replace(/^on/, "");
    var cleanVersion = args && args.flashVersion && _parseFlashVersion(args.flashVersion) || null;
    var element = currentElement;
    var performCallbackAsync = true;
    switch (eventName) {
     case "load":
      if (cleanVersion) {
        if (!_isFlashVersionSupported(cleanVersion)) {
          _receiveEvent.call(this, "onWrongFlash", {
            flashVersion: cleanVersion
          });
          return;
        }
        flashState.outdated = false;
        flashState.ready = true;
        flashState.version = cleanVersion;
      }
      break;

     case "wrongflash":
      if (cleanVersion && !_isFlashVersionSupported(cleanVersion)) {
        flashState.outdated = true;
        flashState.ready = false;
        flashState.version = cleanVersion;
      }
      break;

     case "mouseover":
      _addClass(element, _globalConfig.hoverClass);
      break;

     case "mouseout":
      if (_globalConfig.autoActivate === true) {
        ZeroClipboard.deactivate();
      }
      break;

     case "mousedown":
      _addClass(element, _globalConfig.activeClass);
      break;

     case "mouseup":
      _removeClass(element, _globalConfig.activeClass);
      break;

     case "datarequested":
      if (element) {
        var targetId = element.getAttribute("data-clipboard-target"), targetEl = !targetId ? null : document.getElementById(targetId);
        if (targetEl) {
          var textContent = targetEl.value || targetEl.textContent || targetEl.innerText;
          if (textContent) {
            this.setText(textContent);
          }
        } else {
          var defaultText = element.getAttribute("data-clipboard-text");
          if (defaultText) {
            this.setText(defaultText);
          }
        }
      }
      performCallbackAsync = false;
      break;

     case "complete":
      _deleteOwnProperties(_clipData);
      if (element && element !== _safeActiveElement() && element.focus) {
        element.focus();
      }
      break;
    }
    var context = element;
    var eventArgs = [ this, args ];
    return _dispatchClientCallbacks.call(this, eventName, context, eventArgs, performCallbackAsync);
  };
  if (typeof define === "function" && define.amd) {
    define('zero-clipboard',[ "require", "exports", "module" ], function(require, exports, module) {
      _amdModuleId = module && module.id || null;
      return ZeroClipboard;
    });
  } else if (typeof module === "object" && module && typeof module.exports === "object" && module.exports && typeof window.require === "function") {
    _cjsModuleId = module.id || null;
    module.exports = ZeroClipboard;
  } else {
    window.ZeroClipboard = ZeroClipboard;
  }
})(function() {
  return this;
}());
/*!
 * clipboard.js v1.7.1
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define('clipboard',[],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.Clipboard=t()}}(function(){var t,e,n;return function t(e,n,o){function i(a,c){if(!n[a]){if(!e[a]){var l="function"==typeof require&&require;if(!c&&l)return l(a,!0);if(r)return r(a,!0);var s=new Error("Cannot find module '"+a+"'");throw s.code="MODULE_NOT_FOUND",s}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,o)}return n[a].exports}for(var r="function"==typeof require&&require,a=0;a<o.length;a++)i(o[a]);return i}({1:[function(t,e,n){function o(t,e){for(;t&&t.nodeType!==i;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}var i=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var r=Element.prototype;r.matches=r.matchesSelector||r.mozMatchesSelector||r.msMatchesSelector||r.oMatchesSelector||r.webkitMatchesSelector}e.exports=o},{}],2:[function(t,e,n){function o(t,e,n,o,r){var a=i.apply(this,arguments);return t.addEventListener(n,a,r),{destroy:function(){t.removeEventListener(n,a,r)}}}function i(t,e,n,o){return function(n){n.delegateTarget=r(n.target,e),n.delegateTarget&&o.call(t,n)}}var r=t("./closest");e.exports=o},{"./closest":1}],3:[function(t,e,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},{}],4:[function(t,e,n){function o(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.fn(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return i(t,e,n);if(c.nodeList(t))return r(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function i(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function r(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return l(document.body,t,e,n)}var c=t("./is"),l=t("delegate");e.exports=o},{"./is":3,delegate:2}],5:[function(t,e,n){function o(t){var e;if("SELECT"===t.nodeName)t.focus(),e=t.value;else if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName){var n=t.hasAttribute("readonly");n||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),n||t.removeAttribute("readonly"),e=t.value}else{t.hasAttribute("contenteditable")&&t.focus();var o=window.getSelection(),i=document.createRange();i.selectNodeContents(t),o.removeAllRanges(),o.addRange(i),e=o.toString()}return e}e.exports=o},{}],6:[function(t,e,n){function o(){}o.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function o(){i.off(t,o),e.apply(n,arguments)}var i=this;return o._=e,this.on(t,o,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,i=n.length;for(o;o<i;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],i=[];if(o&&e)for(var r=0,a=o.length;r<a;r++)o[r].fn!==e&&o[r].fn._!==e&&i.push(o[r]);return i.length?n[t]=i:delete n[t],this}},e.exports=o},{}],7:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","select"],r);else if(void 0!==o)r(n,e("select"));else{var a={exports:{}};r(a,i.select),i.clipboardAction=a.exports}}(this,function(t,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i=n(e),r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),c=function(){function t(e){o(this,t),this.resolveOptions(e),this.initSelection()}return a(t,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=e.action,this.container=e.container,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""}},{key:"initSelection",value:function t(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function t(){var e=this,n="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return e.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[n?"right":"left"]="-9999px";var o=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=o+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,i.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function t(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function t(){this.selectedText=(0,i.default)(this.target),this.copyText()}},{key:"copyText",value:function t(){var e=void 0;try{e=document.execCommand(this.action)}catch(t){e=!1}this.handleResult(e)}},{key:"handleResult",value:function t(e){this.emitter.emit(e?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function t(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function t(){this.removeFake()}},{key:"action",set:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function t(){return this._action}},{key:"target",set:function t(e){if(void 0!==e){if(!e||"object"!==(void 0===e?"undefined":r(e))||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=e}},get:function t(){return this._target}}]),t}();t.exports=c})},{select:5}],8:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","./clipboard-action","tiny-emitter","good-listener"],r);else if(void 0!==o)r(n,e("./clipboard-action"),e("tiny-emitter"),e("good-listener"));else{var a={exports:{}};r(a,i.clipboardAction,i.tinyEmitter,i.goodListener),i.clipboard=a.exports}}(this,function(t,e,n,o){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}var s=i(e),u=i(n),f=i(o),d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),p=function(t){function e(t,n){r(this,e);var o=a(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return o.resolveOptions(n),o.listenClick(t),o}return c(e,t),h(e,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText,this.container="object"===d(e.container)?e.container:document.body}},{key:"listenClick",value:function t(e){var n=this;this.listener=(0,f.default)(e,"click",function(t){return n.onClick(t)})}},{key:"onClick",value:function t(e){var n=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new s.default({action:this.action(n),target:this.target(n),text:this.text(n),container:this.container,trigger:n,emitter:this})}},{key:"defaultAction",value:function t(e){return l("action",e)}},{key:"defaultTarget",value:function t(e){var n=l("target",e);if(n)return document.querySelector(n)}},{key:"defaultText",value:function t(e){return l("text",e)}},{key:"destroy",value:function t(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],n="string"==typeof e?[e]:e,o=!!document.queryCommandSupported;return n.forEach(function(t){o=o&&!!document.queryCommandSupported(t)}),o}}]),e}(u.default);t.exports=p})},{"./clipboard-action":7,"good-listener":4,"tiny-emitter":6}]},{},[8])(8)});
// Fine Uploader 5.13.0 - (c) 2013-present Widen Enterprises, Inc. MIT licensed. http://fineuploader.com
!function(global){var qq=function(e){"use strict";return{hide:function(){return e.style.display="none",this},attach:function(t,n){return e.addEventListener?e.addEventListener(t,n,!1):e.attachEvent&&e.attachEvent("on"+t,n),function(){qq(e).detach(t,n)}},detach:function(t,n){return e.removeEventListener?e.removeEventListener(t,n,!1):e.attachEvent&&e.detachEvent("on"+t,n),this},contains:function(t){return!!t&&(e===t||(e.contains?e.contains(t):!!(8&t.compareDocumentPosition(e))))},insertBefore:function(t){return t.parentNode.insertBefore(e,t),this},remove:function(){return e.parentNode.removeChild(e),this},css:function(t){if(null==e.style)throw new qq.Error("Can't apply style to node as it is not on the HTMLElement prototype chain!");return null!=t.opacity&&"string"!=typeof e.style.opacity&&"undefined"!=typeof e.filters&&(t.filter="alpha(opacity="+Math.round(100*t.opacity)+")"),qq.extend(e.style,t),this},hasClass:function(t,n){var i=new RegExp("(^| )"+t+"( |$)");return i.test(e.className)||!(!n||!i.test(e.parentNode.className))},addClass:function(t){return qq(e).hasClass(t)||(e.className+=" "+t),this},removeClass:function(t){var n=new RegExp("(^| )"+t+"( |$)");return e.className=e.className.replace(n," ").replace(/^\s+|\s+$/g,""),this},getByClass:function(t,n){var i,o=[];return n&&e.querySelector?e.querySelector("."+t):e.querySelectorAll?e.querySelectorAll("."+t):(i=e.getElementsByTagName("*"),qq.each(i,function(e,n){qq(n).hasClass(t)&&o.push(n)}),n?o[0]:o)},getFirstByClass:function(t){return qq(e).getByClass(t,!0)},children:function(){for(var t=[],n=e.firstChild;n;)1===n.nodeType&&t.push(n),n=n.nextSibling;return t},setText:function(t){return e.innerText=t,e.textContent=t,this},clearText:function(){return qq(e).setText("")},hasAttribute:function(t){var n;return e.hasAttribute?!!e.hasAttribute(t)&&null==/^false$/i.exec(e.getAttribute(t)):(n=e[t],void 0!==n&&null==/^false$/i.exec(n))}}};!function(){"use strict";qq.canvasToBlob=function(e,t,n){return qq.dataUriToBlob(e.toDataURL(t,n))},qq.dataUriToBlob=function(e){var t,n,i,o,r=function(e,t){var n=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder,i=n&&new n;return i?(i.append(e),i.getBlob(t)):new Blob([e],{type:t})};return n=e.split(",")[0].indexOf("base64")>=0?atob(e.split(",")[1]):decodeURI(e.split(",")[1]),o=e.split(",")[0].split(":")[1].split(";")[0],t=new ArrayBuffer(n.length),i=new Uint8Array(t),qq.each(n,function(e,t){i[e]=t.charCodeAt(0)}),r(t,o)},qq.log=function(e,t){window.console&&(t&&"info"!==t?window.console[t]?window.console[t](e):window.console.log("<"+t+"> "+e):window.console.log(e))},qq.isObject=function(e){return e&&!e.nodeType&&"[object Object]"===Object.prototype.toString.call(e)},qq.isFunction=function(e){return"function"==typeof e},qq.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)||e&&window.ArrayBuffer&&e.buffer&&e.buffer.constructor===ArrayBuffer},qq.isItemList=function(e){return"[object DataTransferItemList]"===Object.prototype.toString.call(e)},qq.isNodeList=function(e){return"[object NodeList]"===Object.prototype.toString.call(e)||e.item&&e.namedItem},qq.isString=function(e){return"[object String]"===Object.prototype.toString.call(e)},qq.trimStr=function(e){return String.prototype.trim?e.trim():e.replace(/^\s+|\s+$/g,"")},qq.format=function(e){var t=Array.prototype.slice.call(arguments,1),n=e,i=n.indexOf("{}");return qq.each(t,function(e,t){var o=n.substring(0,i),r=n.substring(i+2);if(n=o+t+r,i=n.indexOf("{}",i+t.length),i<0)return!1}),n},qq.isFile=function(e){return window.File&&"[object File]"===Object.prototype.toString.call(e)},qq.isFileList=function(e){return window.FileList&&"[object FileList]"===Object.prototype.toString.call(e)},qq.isFileOrInput=function(e){return qq.isFile(e)||qq.isInput(e)},qq.isInput=function(e,t){var n=function(e){var n=e.toLowerCase();return t?"file"!==n:"file"===n};return!!(window.HTMLInputElement&&"[object HTMLInputElement]"===Object.prototype.toString.call(e)&&e.type&&n(e.type))||!!(e.tagName&&"input"===e.tagName.toLowerCase()&&e.type&&n(e.type))},qq.isBlob=function(e){if(window.Blob&&"[object Blob]"===Object.prototype.toString.call(e))return!0},qq.isXhrUploadSupported=function(){var e=document.createElement("input");return e.type="file",void 0!==e.multiple&&"undefined"!=typeof File&&"undefined"!=typeof FormData&&"undefined"!=typeof qq.createXhrInstance().upload},qq.createXhrInstance=function(){if(window.XMLHttpRequest)return new XMLHttpRequest;try{return new ActiveXObject("MSXML2.XMLHTTP.3.0")}catch(e){return qq.log("Neither XHR or ActiveX are supported!","error"),null}},qq.isFolderDropSupported=function(e){return e.items&&e.items.length>0&&e.items[0].webkitGetAsEntry},qq.isFileChunkingSupported=function(){return!qq.androidStock()&&qq.isXhrUploadSupported()&&(void 0!==File.prototype.slice||void 0!==File.prototype.webkitSlice||void 0!==File.prototype.mozSlice)},qq.sliceBlob=function(e,t,n){var i=e.slice||e.mozSlice||e.webkitSlice;return i.call(e,t,n)},qq.arrayBufferToHex=function(e){var t="",n=new Uint8Array(e);return qq.each(n,function(e,n){var i=n.toString(16);i.length<2&&(i="0"+i),t+=i}),t},qq.readBlobToHex=function(e,t,n){var i=qq.sliceBlob(e,t,t+n),o=new FileReader,r=new qq.Promise;return o.onload=function(){r.success(qq.arrayBufferToHex(o.result))},o.onerror=r.failure,o.readAsArrayBuffer(i),r},qq.extend=function(e,t,n){return qq.each(t,function(t,i){n&&qq.isObject(i)?(void 0===e[t]&&(e[t]={}),qq.extend(e[t],i,!0)):e[t]=i}),e},qq.override=function(e,t){var n={},i=t(n);return qq.each(i,function(t,i){void 0!==e[t]&&(n[t]=e[t]),e[t]=i}),e},qq.indexOf=function(e,t,n){if(e.indexOf)return e.indexOf(t,n);n=n||0;var i=e.length;for(n<0&&(n+=i);n<i;n+=1)if(e.hasOwnProperty(n)&&e[n]===t)return n;return-1},qq.getUniqueId=function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0,n="x"==e?t:3&t|8;return n.toString(16)})},qq.ie=function(){return navigator.userAgent.indexOf("MSIE")!==-1||navigator.userAgent.indexOf("Trident")!==-1},qq.ie7=function(){return navigator.userAgent.indexOf("MSIE 7")!==-1},qq.ie8=function(){return navigator.userAgent.indexOf("MSIE 8")!==-1},qq.ie10=function(){return navigator.userAgent.indexOf("MSIE 10")!==-1},qq.ie11=function(){return qq.ie()&&navigator.userAgent.indexOf("rv:11")!==-1},qq.edge=function(){return navigator.userAgent.indexOf("Edge")>=0},qq.safari=function(){return void 0!==navigator.vendor&&navigator.vendor.indexOf("Apple")!==-1},qq.chrome=function(){return void 0!==navigator.vendor&&navigator.vendor.indexOf("Google")!==-1},qq.opera=function(){return void 0!==navigator.vendor&&navigator.vendor.indexOf("Opera")!==-1},qq.firefox=function(){return!qq.edge()&&!qq.ie11()&&navigator.userAgent.indexOf("Mozilla")!==-1&&void 0!==navigator.vendor&&""===navigator.vendor},qq.windows=function(){return"Win32"===navigator.platform},qq.android=function(){return navigator.userAgent.toLowerCase().indexOf("android")!==-1},qq.androidStock=function(){return qq.android()&&navigator.userAgent.toLowerCase().indexOf("chrome")<0},qq.ios6=function(){return qq.ios()&&navigator.userAgent.indexOf(" OS 6_")!==-1},qq.ios7=function(){return qq.ios()&&navigator.userAgent.indexOf(" OS 7_")!==-1},qq.ios8=function(){return qq.ios()&&navigator.userAgent.indexOf(" OS 8_")!==-1},qq.ios800=function(){return qq.ios()&&navigator.userAgent.indexOf(" OS 8_0 ")!==-1},qq.ios=function(){return navigator.userAgent.indexOf("iPad")!==-1||navigator.userAgent.indexOf("iPod")!==-1||navigator.userAgent.indexOf("iPhone")!==-1},qq.iosChrome=function(){return qq.ios()&&navigator.userAgent.indexOf("CriOS")!==-1},qq.iosSafari=function(){return qq.ios()&&!qq.iosChrome()&&navigator.userAgent.indexOf("Safari")!==-1},qq.iosSafariWebView=function(){return qq.ios()&&!qq.iosChrome()&&!qq.iosSafari()},qq.preventDefault=function(e){e.preventDefault?e.preventDefault():e.returnValue=!1},qq.toElement=function(){var e=document.createElement("div");return function(t){e.innerHTML=t;var n=e.firstChild;return e.removeChild(n),n}}(),qq.each=function(e,t){var n,i;if(e)if(window.Storage&&e.constructor===window.Storage)for(n=0;n<e.length&&(i=t(e.key(n),e.getItem(e.key(n))),i!==!1);n++);else if(qq.isArray(e)||qq.isItemList(e)||qq.isNodeList(e))for(n=0;n<e.length&&(i=t(n,e[n]),i!==!1);n++);else if(qq.isString(e))for(n=0;n<e.length&&(i=t(n,e.charAt(n)),i!==!1);n++);else for(n in e)if(Object.prototype.hasOwnProperty.call(e,n)&&(i=t(n,e[n]),i===!1))break},qq.bind=function(e,t){if(qq.isFunction(e)){var n=Array.prototype.slice.call(arguments,2);return function(){var i=qq.extend([],n);return arguments.length&&(i=i.concat(Array.prototype.slice.call(arguments))),e.apply(t,i)}}throw new Error("first parameter must be a function!")},qq.obj2url=function(e,t,n){var i=[],o="&",r=function(e,n){var o=t?/\[\]$/.test(t)?t:t+"["+n+"]":n;"undefined"!==o&&"undefined"!==n&&i.push("object"==typeof e?qq.obj2url(e,o,!0):"[object Function]"===Object.prototype.toString.call(e)?encodeURIComponent(o)+"="+encodeURIComponent(e()):encodeURIComponent(o)+"="+encodeURIComponent(e))};return!n&&t?(o=/\?/.test(t)?/\?$/.test(t)?"":"&":"?",i.push(t),i.push(qq.obj2url(e))):"[object Array]"===Object.prototype.toString.call(e)&&"undefined"!=typeof e?qq.each(e,function(e,t){r(t,e)}):"undefined"!=typeof e&&null!==e&&"object"==typeof e?qq.each(e,function(e,t){r(t,e)}):i.push(encodeURIComponent(t)+"="+encodeURIComponent(e)),t?i.join(o):i.join(o).replace(/^&/,"").replace(/%20/g,"+")},qq.obj2FormData=function(e,t,n){return t||(t=new FormData),qq.each(e,function(e,i){e=n?n+"["+e+"]":e,qq.isObject(i)?qq.obj2FormData(i,t,e):qq.isFunction(i)?t.append(e,i()):t.append(e,i)}),t},qq.obj2Inputs=function(e,t){var n;return t||(t=document.createElement("form")),qq.obj2FormData(e,{append:function(e,i){n=document.createElement("input"),n.setAttribute("name",e),n.setAttribute("value",i),t.appendChild(n)}}),t},qq.parseJson=function(json){return window.JSON&&qq.isFunction(JSON.parse)?JSON.parse(json):eval("("+json+")")},qq.getExtension=function(e){var t=e.lastIndexOf(".")+1;if(t>0)return e.substr(t,e.length-t)},qq.getFilename=function(e){return qq.isInput(e)?e.value.replace(/.*(\/|\\)/,""):qq.isFile(e)&&null!==e.fileName&&void 0!==e.fileName?e.fileName:e.name},qq.DisposeSupport=function(){var e=[];return{dispose:function(){var t;do t=e.shift(),t&&t();while(t)},attach:function(){var e=arguments;this.addDisposer(qq(e[0]).attach.apply(this,Array.prototype.slice.call(arguments,1)))},addDisposer:function(t){e.push(t)}}}}(),function(){"use strict";"function"==typeof define&&define.amd?define('fine-uploader',[],function(){return qq}):"undefined"!=typeof module&&module.exports?module.exports=qq:global.qq=qq}(),function(){"use strict";qq.Error=function(e){this.message="[Fine Uploader "+qq.version+"] "+e},qq.Error.prototype=new Error}(),qq.version="5.13.0",qq.supportedFeatures=function(){"use strict";function e(){var e,t=!0;try{e=document.createElement("input"),e.type="file",qq(e).hide(),e.disabled&&(t=!1)}catch(e){t=!1}return t}function t(){return(qq.chrome()||qq.opera())&&void 0!==navigator.userAgent.match(/Chrome\/[2][1-9]|Chrome\/[3-9][0-9]/)}function n(){return(qq.chrome()||qq.opera())&&void 0!==navigator.userAgent.match(/Chrome\/[1][4-9]|Chrome\/[2-9][0-9]/)}function i(){if(window.XMLHttpRequest){var e=qq.createXhrInstance();return void 0!==e.withCredentials}return!1}function o(){return void 0!==window.XDomainRequest}function r(){return!!i()||o()}function a(){return void 0!==document.createElement("input").webkitdirectory}function s(){try{return!!window.localStorage&&qq.isFunction(window.localStorage.setItem)}catch(e){return!1}}function l(){var e=document.createElement("span");return("draggable"in e||"ondragstart"in e&&"ondrop"in e)&&!qq.android()&&!qq.ios()}var u,c,d,p,h,q,f,m,g,_,v,b,y,S,w;return u=e(),p=u&&qq.isXhrUploadSupported(),c=p&&!qq.androidStock(),d=p&&l(),h=d&&t(),q=p&&qq.isFileChunkingSupported(),f=p&&q&&s(),m=p&&n(),g=u&&(void 0!==window.postMessage||p),v=i(),_=o(),b=r(),y=a(),S=p&&void 0!==window.FileReader,w=function(){return!!p&&(!qq.androidStock()&&!qq.iosChrome())}(),{ajaxUploading:p,blobUploading:c,canDetermineSize:p,chunking:q,deleteFileCors:b,deleteFileCorsXdr:_,deleteFileCorsXhr:v,dialogElement:!!window.HTMLDialogElement,fileDrop:d,folderDrop:h,folderSelection:y,imagePreviews:S,imageValidation:S,itemSizeValidation:p,pause:q,progressBar:w,resume:f,scaling:S&&c,tiffPreviews:qq.safari(),unlimitedScaledImageSize:!qq.ios(),uploading:u,uploadCors:g,uploadCustomHeaders:p,uploadNonMultipart:p,uploadViaPaste:m}}(),qq.isGenericPromise=function(e){"use strict";return!!(e&&e.then&&qq.isFunction(e.then))},qq.Promise=function(){"use strict";var e,t,n=[],i=[],o=[],r=0;qq.extend(this,{then:function(o,a){return 0===r?(o&&n.push(o),a&&i.push(a)):r===-1?a&&a.apply(null,t):o&&o.apply(null,e),this},done:function(n){return 0===r?o.push(n):n.apply(null,void 0===t?e:t),this},success:function(){return r=1,e=arguments,n.length&&qq.each(n,function(t,n){n.apply(null,e)}),o.length&&qq.each(o,function(t,n){n.apply(null,e)}),this},failure:function(){return r=-1,t=arguments,i.length&&qq.each(i,function(e,n){n.apply(null,t)}),o.length&&qq.each(o,function(e,n){n.apply(null,t)}),this}})},qq.BlobProxy=function(e,t){"use strict";qq.extend(this,{referenceBlob:e,create:function(){return t(e)}})},qq.UploadButton=function(e){"use strict";function t(){var e=document.createElement("input");return e.setAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME,i),e.setAttribute("title",a.title),o.setMultiple(a.multiple,e),a.folders&&qq.supportedFeatures.folderSelection&&e.setAttribute("webkitdirectory",""),a.acceptFiles&&e.setAttribute("accept",a.acceptFiles),e.setAttribute("type","file"),e.setAttribute("name",a.name),qq(e).css({position:"absolute",right:0,top:0,fontFamily:"Arial",fontSize:qq.ie()&&!qq.ie8()?"3500px":"118px",margin:0,padding:0,cursor:"pointer",opacity:0}),!qq.ie7()&&qq(e).css({height:"100%"}),a.element.appendChild(e),r.attach(e,"change",function(){a.onChange(e)}),r.attach(e,"mouseover",function(){qq(a.element).addClass(a.hoverClass)}),r.attach(e,"mouseout",function(){qq(a.element).removeClass(a.hoverClass)}),r.attach(e,"focus",function(){qq(a.element).addClass(a.focusClass)}),r.attach(e,"blur",function(){qq(a.element).removeClass(a.focusClass)}),e}var n,i,o=this,r=new qq.DisposeSupport,a={acceptFiles:null,element:null,focusClass:"qq-upload-button-focus",folders:!1,hoverClass:"qq-upload-button-hover",ios8BrowserCrashWorkaround:!1,multiple:!1,name:"qqfile",onChange:function(e){},title:null};qq.extend(a,e),i=qq.getUniqueId(),qq(a.element).css({position:"relative",overflow:"hidden",direction:"ltr"}),qq.extend(this,{getInput:function(){return n},getButtonId:function(){return i},setMultiple:function(e,t){var n=t||this.getInput();a.ios8BrowserCrashWorkaround&&qq.ios8()&&(qq.iosChrome()||qq.iosSafariWebView())?n.setAttribute("multiple",""):e?n.setAttribute("multiple",""):n.removeAttribute("multiple")},setAcceptFiles:function(e){e!==a.acceptFiles&&n.setAttribute("accept",e)},reset:function(){n.parentNode&&qq(n).remove(),qq(a.element).removeClass(a.focusClass),n=null,n=t()}}),n=t()},qq.UploadButton.BUTTON_ID_ATTR_NAME="qq-button-id",qq.UploadData=function(e){"use strict";function t(e){if(qq.isArray(e)){var t=[];return qq.each(e,function(e,n){t.push(o[n])}),t}return o[e]}function n(e){if(qq.isArray(e)){var t=[];return qq.each(e,function(e,n){t.push(o[r[n]])}),t}return o[r[e]]}function i(e){var t=[],n=[].concat(e);return qq.each(n,function(e,n){var i=a[n];void 0!==i&&qq.each(i,function(e,n){t.push(o[n])})}),t}var o=[],r={},a={},s={},l={};qq.extend(this,{addFile:function(t){var n=t.status||qq.status.SUBMITTING,i=o.push({name:t.name,originalName:t.name,uuid:t.uuid,size:null==t.size?-1:t.size,status:n})-1;return t.batchId&&(o[i].batchId=t.batchId,void 0===l[t.batchId]&&(l[t.batchId]=[]),l[t.batchId].push(i)),t.proxyGroupId&&(o[i].proxyGroupId=t.proxyGroupId,void 0===s[t.proxyGroupId]&&(s[t.proxyGroupId]=[]),s[t.proxyGroupId].push(i)),o[i].id=i,r[t.uuid]=i,void 0===a[n]&&(a[n]=[]),a[n].push(i),e.onStatusChange(i,null,n),i},retrieve:function(e){return qq.isObject(e)&&o.length?void 0!==e.id?t(e.id):void 0!==e.uuid?n(e.uuid):e.status?i(e.status):void 0:qq.extend([],o,!0)},reset:function(){o=[],r={},a={},l={}},setStatus:function(t,n){var i=o[t].status,r=qq.indexOf(a[i],t);a[i].splice(r,1),o[t].status=n,void 0===a[n]&&(a[n]=[]),a[n].push(t),e.onStatusChange(t,i,n)},uuidChanged:function(e,t){var n=o[e].uuid;o[e].uuid=t,r[t]=e,delete r[n]},updateName:function(e,t){o[e].name=t},updateSize:function(e,t){o[e].size=t},setParentId:function(e,t){o[e].parentId=t},getIdsInProxyGroup:function(e){var t=o[e].proxyGroupId;return t?s[t]:[]},getIdsInBatch:function(e){var t=o[e].batchId;return l[t]}})},qq.status={SUBMITTING:"submitting",SUBMITTED:"submitted",REJECTED:"rejected",QUEUED:"queued",CANCELED:"canceled",PAUSED:"paused",UPLOADING:"uploading",UPLOAD_RETRYING:"retrying upload",UPLOAD_SUCCESSFUL:"upload successful",UPLOAD_FAILED:"upload failed",DELETE_FAILED:"delete failed",DELETING:"deleting",DELETED:"deleted"},function(){"use strict";qq.basePublicApi={addBlobs:function(e,t,n){this.addFiles(e,t,n)},addInitialFiles:function(e){var t=this;qq.each(e,function(e,n){t._addCannedFile(n)})},addFiles:function(e,t,n){this._maybeHandleIos8SafariWorkaround();var i=0===this._storedIds.length?qq.getUniqueId():this._currentBatchId,o=qq.bind(function(e){this._handleNewFile({blob:e,name:this._options.blobs.defaultName},i,d)},this),r=qq.bind(function(e){this._handleNewFile(e,i,d)},this),a=qq.bind(function(e){var t=qq.canvasToBlob(e);this._handleNewFile({blob:t,name:this._options.blobs.defaultName+".png"},i,d)},this),s=qq.bind(function(e){var t=e.quality&&e.quality/100,n=qq.canvasToBlob(e.canvas,e.type,t);this._handleNewFile({blob:n,name:e.name},i,d)},this),l=qq.bind(function(e){if(qq.isInput(e)&&qq.supportedFeatures.ajaxUploading){var t=Array.prototype.slice.call(e.files),n=this;qq.each(t,function(e,t){n._handleNewFile(t,i,d)})}else this._handleNewFile(e,i,d)},this),u=function(){qq.isFileList(e)&&(e=Array.prototype.slice.call(e)),e=[].concat(e)},c=this,d=[];this._currentBatchId=i,e&&(u(),qq.each(e,function(e,t){qq.isFileOrInput(t)?l(t):qq.isBlob(t)?o(t):qq.isObject(t)?t.blob&&t.name?r(t):t.canvas&&t.name&&s(t):t.tagName&&"canvas"===t.tagName.toLowerCase()?a(t):c.log(t+" is not a valid file container!  Ignoring!","warn")}),this.log("Received "+d.length+" files."),this._prepareItemsForUpload(d,t,n))},cancel:function(e){this._handler.cancel(e)},cancelAll:function(){var e=[],t=this;qq.extend(e,this._storedIds),qq.each(e,function(e,n){t.cancel(n)}),this._handler.cancelAll()},clearStoredFiles:function(){this._storedIds=[]},continueUpload:function(e){var t=this._uploadData.retrieve({id:e});return!(!qq.supportedFeatures.pause||!this._options.chunking.enabled)&&(t.status===qq.status.PAUSED?(this.log(qq.format("Paused file ID {} ({}) will be continued.  Not paused.",e,this.getName(e))),this._uploadFile(e),!0):(this.log(qq.format("Ignoring continue for file ID {} ({}).  Not paused.",e,this.getName(e)),"error"),!1))},deleteFile:function(e){return this._onSubmitDelete(e)},doesExist:function(e){return this._handler.isValid(e)},drawThumbnail:function(e,t,n,i,o){var r,a,s=new qq.Promise;return this._imageGenerator?(r=this._thumbnailUrls[e],a={customResizeFunction:o,maxSize:n>0?n:null,scale:n>0},!i&&qq.supportedFeatures.imagePreviews&&(r=this.getFile(e)),null==r?s.failure({container:t,error:"File or URL not found."}):this._imageGenerator.generate(r,t,a).then(function(e){s.success(e)},function(e,t){s.failure({container:e,error:t||"Problem generating thumbnail"})})):s.failure({container:t,error:"Missing image generator module"}),s},getButton:function(e){return this._getButton(this._buttonIdsForFileIds[e])},getEndpoint:function(e){return this._endpointStore.get(e)},getFile:function(e){return this._handler.getFile(e)||null},getInProgress:function(){return this._uploadData.retrieve({status:[qq.status.UPLOADING,qq.status.UPLOAD_RETRYING,qq.status.QUEUED]}).length},getName:function(e){return this._uploadData.retrieve({id:e}).name},getParentId:function(e){var t=this.getUploads({id:e}),n=null;return t&&void 0!==t.parentId&&(n=t.parentId),n},getResumableFilesData:function(){return this._handler.getResumableFilesData()},getSize:function(e){return this._uploadData.retrieve({id:e}).size},getNetUploads:function(){return this._netUploaded},getRemainingAllowedItems:function(){var e=this._currentItemLimit;return e>0?e-this._netUploadedOrQueued:null},getUploads:function(e){return this._uploadData.retrieve(e)},getUuid:function(e){return this._uploadData.retrieve({id:e}).uuid},log:function(e,t){!this._options.debug||t&&"info"!==t?t&&"info"!==t&&qq.log("[Fine Uploader "+qq.version+"] "+e,t):qq.log("[Fine Uploader "+qq.version+"] "+e)},pauseUpload:function(e){var t=this._uploadData.retrieve({id:e});if(!qq.supportedFeatures.pause||!this._options.chunking.enabled)return!1;if(qq.indexOf([qq.status.UPLOADING,qq.status.UPLOAD_RETRYING],t.status)>=0){if(this._handler.pause(e))return this._uploadData.setStatus(e,qq.status.PAUSED),!0;this.log(qq.format("Unable to pause file ID {} ({}).",e,this.getName(e)),"error")}else this.log(qq.format("Ignoring pause for file ID {} ({}).  Not in progress.",e,this.getName(e)),"error");return!1},reset:function(){this.log("Resetting uploader..."),this._handler.reset(),this._storedIds=[],this._autoRetries=[],this._retryTimeouts=[],this._preventRetries=[],this._thumbnailUrls=[],qq.each(this._buttons,function(e,t){t.reset()}),this._paramsStore.reset(),this._endpointStore.reset(),this._netUploadedOrQueued=0,this._netUploaded=0,this._uploadData.reset(),this._buttonIdsForFileIds=[],this._pasteHandler&&this._pasteHandler.reset(),this._options.session.refreshOnReset&&this._refreshSessionData(),this._succeededSinceLastAllComplete=[],this._failedSinceLastAllComplete=[],this._totalProgress&&this._totalProgress.reset()},retry:function(e){return this._manualRetry(e)},scaleImage:function(e,t){var n=this;return qq.Scaler.prototype.scaleImage(e,t,{log:qq.bind(n.log,n),getFile:qq.bind(n.getFile,n),uploadData:n._uploadData})},setCustomHeaders:function(e,t){this._customHeadersStore.set(e,t)},setDeleteFileCustomHeaders:function(e,t){this._deleteFileCustomHeadersStore.set(e,t)},setDeleteFileEndpoint:function(e,t){this._deleteFileEndpointStore.set(e,t)},setDeleteFileParams:function(e,t){this._deleteFileParamsStore.set(e,t)},setEndpoint:function(e,t){this._endpointStore.set(e,t)},setForm:function(e){this._updateFormSupportAndParams(e)},setItemLimit:function(e){this._currentItemLimit=e},setName:function(e,t){this._uploadData.updateName(e,t)},setParams:function(e,t){this._paramsStore.set(e,t)},setUuid:function(e,t){return this._uploadData.uuidChanged(e,t)},uploadStoredFiles:function(){0===this._storedIds.length?this._itemError("noFilesError"):this._uploadStoredFiles()}},qq.basePrivateApi={_addCannedFile:function(e){var t=this._uploadData.addFile({uuid:e.uuid,name:e.name,size:e.size,status:qq.status.UPLOAD_SUCCESSFUL});return e.deleteFileEndpoint&&this.setDeleteFileEndpoint(e.deleteFileEndpoint,t),e.deleteFileParams&&this.setDeleteFileParams(e.deleteFileParams,t),e.thumbnailUrl&&(this._thumbnailUrls[t]=e.thumbnailUrl),this._netUploaded++,this._netUploadedOrQueued++,t},_annotateWithButtonId:function(e,t){qq.isFile(e)&&(e.qqButtonId=this._getButtonId(t))},_batchError:function(e){this._options.callbacks.onError(null,null,e,void 0)},_createDeleteHandler:function(){var e=this;return new qq.DeleteFileAjaxRequester({method:this._options.deleteFile.method.toUpperCase(),maxConnections:this._options.maxConnections,uuidParamName:this._options.request.uuidName,customHeaders:this._deleteFileCustomHeadersStore,paramsStore:this._deleteFileParamsStore,endpointStore:this._deleteFileEndpointStore,cors:this._options.cors,log:qq.bind(e.log,e),onDelete:function(t){e._onDelete(t),e._options.callbacks.onDelete(t)},onDeleteComplete:function(t,n,i){e._onDeleteComplete(t,n,i),e._options.callbacks.onDeleteComplete(t,n,i)}})},_createPasteHandler:function(){var e=this;return new qq.PasteSupport({targetElement:this._options.paste.targetElement,callbacks:{log:qq.bind(e.log,e),pasteReceived:function(t){e._handleCheckedCallback({name:"onPasteReceived",callback:qq.bind(e._options.callbacks.onPasteReceived,e,t),onSuccess:qq.bind(e._handlePasteSuccess,e,t),identifier:"pasted image"})}}})},_createStore:function(e,t){var n={},i=e,o={},r=t,a=function(e){return qq.isObject(e)?qq.extend({},e):e},s=function(){return qq.isFunction(r)?r():r},l=function(e,t){r&&qq.isObject(t)&&qq.extend(t,s()),o[e]&&qq.extend(t,o[e])};return{set:function(e,t){null==t?(n={},i=a(e)):n[t]=a(e)},get:function(e){var t;return t=null!=e&&n[e]?n[e]:a(i),l(e,t),a(t)},addReadOnly:function(e,t){qq.isObject(n)&&(null===e?qq.isFunction(t)?r=t:(r=r||{},qq.extend(r,t)):(o[e]=o[e]||{},qq.extend(o[e],t)))},remove:function(e){return delete n[e]},reset:function(){n={},o={},i=e}}},_createUploadDataTracker:function(){var e=this;return new qq.UploadData({getName:function(t){return e.getName(t)},getUuid:function(t){return e.getUuid(t)},getSize:function(t){return e.getSize(t)},onStatusChange:function(t,n,i){e._onUploadStatusChange(t,n,i),e._options.callbacks.onStatusChange(t,n,i),e._maybeAllComplete(t,i),e._totalProgress&&setTimeout(function(){e._totalProgress.onStatusChange(t,n,i)},0)}})},_createUploadButton:function(e){function t(){return!!qq.supportedFeatures.ajaxUploading&&(!(i._options.workarounds.iosEmptyVideos&&qq.ios()&&!qq.ios6()&&i._isAllowedExtension(r,".mov"))&&(void 0===e.multiple?i._options.multiple:e.multiple))}var n,i=this,o=e.accept||this._options.validation.acceptFiles,r=e.allowedExtensions||this._options.validation.allowedExtensions;return n=new qq.UploadButton({acceptFiles:o,element:e.element,focusClass:this._options.classes.buttonFocus,folders:e.folders,hoverClass:this._options.classes.buttonHover,ios8BrowserCrashWorkaround:this._options.workarounds.ios8BrowserCrash,multiple:t(),name:this._options.request.inputName,onChange:function(e){i._onInputChange(e)},title:null==e.title?this._options.text.fileInputTitle:e.title}),this._disposeSupport.addDisposer(function(){n.dispose()}),i._buttons.push(n),n},_createUploadHandler:function(e,t){var n=this,i={},o={debug:this._options.debug,maxConnections:this._options.maxConnections,cors:this._options.cors,paramsStore:this._paramsStore,endpointStore:this._endpointStore,chunking:this._options.chunking,resume:this._options.resume,blobs:this._options.blobs,log:qq.bind(n.log,n),preventRetryParam:this._options.retry.preventRetryResponseProperty,onProgress:function(e,t,o,r){o<0||r<0||(i[e]?i[e].loaded===o&&i[e].total===r||(n._onProgress(e,t,o,r),n._options.callbacks.onProgress(e,t,o,r)):(n._onProgress(e,t,o,r),n._options.callbacks.onProgress(e,t,o,r)),i[e]={loaded:o,total:r})},onComplete:function(e,t,o,r){delete i[e];var a,s=n.getUploads({id:e}).status;s!==qq.status.UPLOAD_SUCCESSFUL&&s!==qq.status.UPLOAD_FAILED&&(a=n._onComplete(e,t,o,r),a instanceof qq.Promise?a.done(function(){n._options.callbacks.onComplete(e,t,o,r)}):n._options.callbacks.onComplete(e,t,o,r))},onCancel:function(e,t,i){var o=new qq.Promise;return n._handleCheckedCallback({name:"onCancel",callback:qq.bind(n._options.callbacks.onCancel,n,e,t),onFailure:o.failure,onSuccess:function(){i.then(function(){n._onCancel(e,t)}),o.success()},identifier:e}),o},onUploadPrep:qq.bind(this._onUploadPrep,this),onUpload:function(e,t){n._onUpload(e,t),n._options.callbacks.onUpload(e,t)},onUploadChunk:function(e,t,i){n._onUploadChunk(e,i),n._options.callbacks.onUploadChunk(e,t,i)},onUploadChunkSuccess:function(e,t,i,o){n._options.callbacks.onUploadChunkSuccess.apply(n,arguments)},onResume:function(e,t,i){return n._options.callbacks.onResume(e,t,i)},onAutoRetry:function(e,t,i,o){return n._onAutoRetry.apply(n,arguments)},onUuidChanged:function(e,t){n.log("Server requested UUID change from '"+n.getUuid(e)+"' to '"+t+"'"),n.setUuid(e,t)},getName:qq.bind(n.getName,n),getUuid:qq.bind(n.getUuid,n),getSize:qq.bind(n.getSize,n),setSize:qq.bind(n._setSize,n),getDataByUuid:function(e){return n.getUploads({uuid:e})},isQueued:function(e){var t=n.getUploads({id:e}).status;return t===qq.status.QUEUED||t===qq.status.SUBMITTED||t===qq.status.UPLOAD_RETRYING||t===qq.status.PAUSED},getIdsInProxyGroup:n._uploadData.getIdsInProxyGroup,getIdsInBatch:n._uploadData.getIdsInBatch};return qq.each(this._options.request,function(e,t){o[e]=t}),o.customHeaders=this._customHeadersStore,e&&qq.each(e,function(e,t){o[e]=t}),new qq.UploadHandlerController(o,t)},_fileOrBlobRejected:function(e){this._netUploadedOrQueued--,this._uploadData.setStatus(e,qq.status.REJECTED)},_formatSize:function(e){if(0===e)return e+this._options.text.sizeSymbols[0];var t=-1;do e/=1e3,t++;while(e>999);return Math.max(e,.1).toFixed(1)+this._options.text.sizeSymbols[t]},_generateExtraButtonSpecs:function(){var e=this;this._extraButtonSpecs={},qq.each(this._options.extraButtons,function(t,n){var i=n.multiple,o=qq.extend({},e._options.validation,!0),r=qq.extend({},n);void 0===i&&(i=e._options.multiple),r.validation&&qq.extend(o,n.validation,!0),qq.extend(r,{multiple:i,validation:o},!0),e._initExtraButton(r)})},_getButton:function(e){var t=this._extraButtonSpecs[e];return t?t.element:e===this._defaultButtonId?this._options.button:void 0},_getButtonId:function(e){var t,n,i=e;if(i instanceof qq.BlobProxy&&(i=i.referenceBlob),i&&!qq.isBlob(i)){if(qq.isFile(i))return i.qqButtonId;if("input"===i.tagName.toLowerCase()&&"file"===i.type.toLowerCase())return i.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);if(t=i.getElementsByTagName("input"),qq.each(t,function(e,t){if("file"===t.getAttribute("type"))return n=t,!1}),n)return n.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME)}},_getNotFinished:function(){return this._uploadData.retrieve({status:[qq.status.UPLOADING,qq.status.UPLOAD_RETRYING,qq.status.QUEUED,qq.status.SUBMITTING,qq.status.SUBMITTED,qq.status.PAUSED]}).length},_getValidationBase:function(e){var t=this._extraButtonSpecs[e];return t?t.validation:this._options.validation},_getValidationDescriptor:function(e){return e.file instanceof qq.BlobProxy?{name:qq.getFilename(e.file.referenceBlob),size:e.file.referenceBlob.size}:{name:this.getUploads({id:e.id}).name,size:this.getUploads({id:e.id}).size}},_getValidationDescriptors:function(e){var t=this,n=[];return qq.each(e,function(e,i){n.push(t._getValidationDescriptor(i))}),n},_handleCameraAccess:function(){if(this._options.camera.ios&&qq.ios()){var e="image/*;capture=camera",t=this._options.camera.button,n=t?this._getButtonId(t):this._defaultButtonId,i=this._options;n&&n!==this._defaultButtonId&&(i=this._extraButtonSpecs[n]),i.multiple=!1,null===i.validation.acceptFiles?i.validation.acceptFiles=e:i.validation.acceptFiles+=","+e,qq.each(this._buttons,function(e,t){if(t.getButtonId()===n)return t.setMultiple(i.multiple),t.setAcceptFiles(i.acceptFiles),!1})}},_handleCheckedCallback:function(e){var t=this,n=e.callback();return qq.isGenericPromise(n)?(this.log(e.name+" - waiting for "+e.name+" promise to be fulfilled for "+e.identifier),n.then(function(n){t.log(e.name+" promise success for "+e.identifier),e.onSuccess(n)},function(){e.onFailure?(t.log(e.name+" promise failure for "+e.identifier),e.onFailure()):t.log(e.name+" promise failure for "+e.identifier)})):(n!==!1?e.onSuccess(n):e.onFailure?(this.log(e.name+" - return value was 'false' for "+e.identifier+".  Invoking failure callback."),e.onFailure()):this.log(e.name+" - return value was 'false' for "+e.identifier+".  Will not proceed."),n)},_handleNewFile:function(e,t,n){var i=this,o=qq.getUniqueId(),r=-1,a=qq.getFilename(e),s=e.blob||e,l=this._customNewFileHandler?this._customNewFileHandler:qq.bind(i._handleNewFileGeneric,i);!qq.isInput(s)&&s.size>=0&&(r=s.size),l(s,a,o,r,n,t,this._options.request.uuidName,{uploadData:i._uploadData,paramsStore:i._paramsStore,addFileToHandler:function(e,t){i._handler.add(e,t),i._netUploadedOrQueued++,i._trackButton(e);
}})},_handleNewFileGeneric:function(e,t,n,i,o,r){var a=this._uploadData.addFile({uuid:n,name:t,size:i,batchId:r});this._handler.add(a,e),this._trackButton(a),this._netUploadedOrQueued++,o.push({id:a,file:e})},_handlePasteSuccess:function(e,t){var n=e.type.split("/")[1],i=t;null==i&&(i=this._options.paste.defaultName),i+="."+n,this.addFiles({name:i,blob:e})},_initExtraButton:function(e){var t=this._createUploadButton({accept:e.validation.acceptFiles,allowedExtensions:e.validation.allowedExtensions,element:e.element,folders:e.folders,multiple:e.multiple,title:e.fileInputTitle});this._extraButtonSpecs[t.getButtonId()]=e},_initFormSupportAndParams:function(){this._formSupport=qq.FormSupport&&new qq.FormSupport(this._options.form,qq.bind(this.uploadStoredFiles,this),qq.bind(this.log,this)),this._formSupport&&this._formSupport.attachedToForm?(this._paramsStore=this._createStore(this._options.request.params,this._formSupport.getFormInputsAsObject),this._options.autoUpload=this._formSupport.newAutoUpload,this._formSupport.newEndpoint&&(this._options.request.endpoint=this._formSupport.newEndpoint)):this._paramsStore=this._createStore(this._options.request.params)},_isDeletePossible:function(){return!(!qq.DeleteFileAjaxRequester||!this._options.deleteFile.enabled)&&(!this._options.cors.expected||(!!qq.supportedFeatures.deleteFileCorsXhr||!(!qq.supportedFeatures.deleteFileCorsXdr||!this._options.cors.allowXdr)))},_isAllowedExtension:function(e,t){var n=!1;return!e.length||(qq.each(e,function(e,i){if(qq.isString(i)){var o=new RegExp("\\."+i+"$","i");if(null!=t.match(o))return n=!0,!1}}),n)},_itemError:function(e,t,n){function i(e,t){a=a.replace(e,t)}var o,r,a=this._options.messages[e],s=[],l=[].concat(t),u=l[0],c=this._getButtonId(n),d=this._getValidationBase(c);return qq.each(d.allowedExtensions,function(e,t){qq.isString(t)&&s.push(t)}),o=s.join(", ").toLowerCase(),i("{file}",this._options.formatFileName(u)),i("{extensions}",o),i("{sizeLimit}",this._formatSize(d.sizeLimit)),i("{minSizeLimit}",this._formatSize(d.minSizeLimit)),r=a.match(/(\{\w+\})/g),null!==r&&qq.each(r,function(e,t){i(t,l[e])}),this._options.callbacks.onError(null,u,a,void 0),a},_manualRetry:function(e,t){if(this._onBeforeManualRetry(e))return this._netUploadedOrQueued++,this._uploadData.setStatus(e,qq.status.UPLOAD_RETRYING),t?t(e):this._handler.retry(e),!0},_maybeAllComplete:function(e,t){var n=this,i=this._getNotFinished();t===qq.status.UPLOAD_SUCCESSFUL?this._succeededSinceLastAllComplete.push(e):t===qq.status.UPLOAD_FAILED&&this._failedSinceLastAllComplete.push(e),0===i&&(this._succeededSinceLastAllComplete.length||this._failedSinceLastAllComplete.length)&&setTimeout(function(){n._onAllComplete(n._succeededSinceLastAllComplete,n._failedSinceLastAllComplete)},0)},_maybeHandleIos8SafariWorkaround:function(){var e=this;if(this._options.workarounds.ios8SafariUploads&&qq.ios800()&&qq.iosSafari())throw setTimeout(function(){window.alert(e._options.messages.unsupportedBrowserIos8Safari)},0),new qq.Error(this._options.messages.unsupportedBrowserIos8Safari)},_maybeParseAndSendUploadError:function(e,t,n,i){if(!n.success)if(i&&200!==i.status&&!n.error)this._options.callbacks.onError(e,t,"XHR returned response code "+i.status,i);else{var o=n.error?n.error:this._options.text.defaultResponseError;this._options.callbacks.onError(e,t,o,i)}},_maybeProcessNextItemAfterOnValidateCallback:function(e,t,n,i,o){var r=this;if(t.length>n)if(e||!this._options.validation.stopOnFirstInvalidFile)setTimeout(function(){var e=r._getValidationDescriptor(t[n]),a=r._getButtonId(t[n].file),s=r._getButton(a);r._handleCheckedCallback({name:"onValidate",callback:qq.bind(r._options.callbacks.onValidate,r,e,s),onSuccess:qq.bind(r._onValidateCallbackSuccess,r,t,n,i,o),onFailure:qq.bind(r._onValidateCallbackFailure,r,t,n,i,o),identifier:"Item '"+e.name+"', size: "+e.size})},0);else if(!e)for(;n<t.length;n++)r._fileOrBlobRejected(t[n].id)},_onAllComplete:function(e,t){this._totalProgress&&this._totalProgress.onAllComplete(e,t,this._preventRetries),this._options.callbacks.onAllComplete(qq.extend([],e),qq.extend([],t)),this._succeededSinceLastAllComplete=[],this._failedSinceLastAllComplete=[]},_onAutoRetry:function(e,t,n,i,o){var r=this;if(r._preventRetries[e]=n[r._options.retry.preventRetryResponseProperty],r._shouldAutoRetry(e,t,n)){var a=1e3*r._options.retry.autoAttemptDelay;return r._maybeParseAndSendUploadError.apply(r,arguments),r._options.callbacks.onAutoRetry(e,t,r._autoRetries[e]),r._onBeforeAutoRetry(e,t),r._uploadData.setStatus(e,qq.status.UPLOAD_RETRYING),r._retryTimeouts[e]=setTimeout(function(){r.log("Starting retry for "+t+"..."),o?o(e):r._handler.retry(e)},a),!0}},_onBeforeAutoRetry:function(e,t){this.log("Waiting "+this._options.retry.autoAttemptDelay+" seconds before retrying "+t+"...")},_onBeforeManualRetry:function(e){var t,n=this._currentItemLimit;return this._preventRetries[e]?(this.log("Retries are forbidden for id "+e,"warn"),!1):this._handler.isValid(e)?(t=this.getName(e),this._options.callbacks.onManualRetry(e,t)!==!1&&(n>0&&this._netUploadedOrQueued+1>n?(this._itemError("retryFailTooManyItems"),!1):(this.log("Retrying upload for '"+t+"' (id: "+e+")..."),!0))):(this.log("'"+e+"' is not a valid file ID","error"),!1)},_onCancel:function(e,t){this._netUploadedOrQueued--,clearTimeout(this._retryTimeouts[e]);var n=qq.indexOf(this._storedIds,e);!this._options.autoUpload&&n>=0&&this._storedIds.splice(n,1),this._uploadData.setStatus(e,qq.status.CANCELED)},_onComplete:function(e,t,n,i){return n.success?(n.thumbnailUrl&&(this._thumbnailUrls[e]=n.thumbnailUrl),this._netUploaded++,this._uploadData.setStatus(e,qq.status.UPLOAD_SUCCESSFUL)):(this._netUploadedOrQueued--,this._uploadData.setStatus(e,qq.status.UPLOAD_FAILED),n[this._options.retry.preventRetryResponseProperty]===!0&&(this._preventRetries[e]=!0)),this._maybeParseAndSendUploadError(e,t,n,i),!!n.success},_onDelete:function(e){this._uploadData.setStatus(e,qq.status.DELETING)},_onDeleteComplete:function(e,t,n){var i=this.getName(e);n?(this._uploadData.setStatus(e,qq.status.DELETE_FAILED),this.log("Delete request for '"+i+"' has failed.","error"),void 0===t.withCredentials?this._options.callbacks.onError(e,i,"Delete request failed",t):this._options.callbacks.onError(e,i,"Delete request failed with response code "+t.status,t)):(this._netUploadedOrQueued--,this._netUploaded--,this._handler.expunge(e),this._uploadData.setStatus(e,qq.status.DELETED),this.log("Delete request for '"+i+"' has succeeded."))},_onInputChange:function(e){var t;if(qq.supportedFeatures.ajaxUploading){for(t=0;t<e.files.length;t++)this._annotateWithButtonId(e.files[t],e);this.addFiles(e.files)}else e.value.length>0&&this.addFiles(e);qq.each(this._buttons,function(e,t){t.reset()})},_onProgress:function(e,t,n,i){this._totalProgress&&this._totalProgress.onIndividualProgress(e,n,i)},_onSubmit:function(e,t){},_onSubmitCallbackSuccess:function(e,t){this._onSubmit.apply(this,arguments),this._uploadData.setStatus(e,qq.status.SUBMITTED),this._onSubmitted.apply(this,arguments),this._options.autoUpload?(this._options.callbacks.onSubmitted.apply(this,arguments),this._uploadFile(e)):(this._storeForLater(e),this._options.callbacks.onSubmitted.apply(this,arguments))},_onSubmitDelete:function(e,t,n){var i,o=this.getUuid(e);return t&&(i=qq.bind(t,this,e,o,n)),this._isDeletePossible()?(this._handleCheckedCallback({name:"onSubmitDelete",callback:qq.bind(this._options.callbacks.onSubmitDelete,this,e),onSuccess:i||qq.bind(this._deleteHandler.sendDelete,this,e,o,n),identifier:e}),!0):(this.log("Delete request ignored for ID "+e+", delete feature is disabled or request not possible due to CORS on a user agent that does not support pre-flighting.","warn"),!1)},_onSubmitted:function(e){},_onTotalProgress:function(e,t){this._options.callbacks.onTotalProgress(e,t)},_onUploadPrep:function(e){},_onUpload:function(e,t){this._uploadData.setStatus(e,qq.status.UPLOADING)},_onUploadChunk:function(e,t){},_onUploadStatusChange:function(e,t,n){n===qq.status.PAUSED&&clearTimeout(this._retryTimeouts[e])},_onValidateBatchCallbackFailure:function(e){var t=this;qq.each(e,function(e,n){t._fileOrBlobRejected(n.id)})},_onValidateBatchCallbackSuccess:function(e,t,n,i,o){var r,a=this._currentItemLimit,s=this._netUploadedOrQueued;0===a||s<=a?t.length>0?this._handleCheckedCallback({name:"onValidate",callback:qq.bind(this._options.callbacks.onValidate,this,e[0],o),onSuccess:qq.bind(this._onValidateCallbackSuccess,this,t,0,n,i),onFailure:qq.bind(this._onValidateCallbackFailure,this,t,0,n,i),identifier:"Item '"+t[0].file.name+"', size: "+t[0].file.size}):this._itemError("noFilesError"):(this._onValidateBatchCallbackFailure(t),r=this._options.messages.tooManyItemsError.replace(/\{netItems\}/g,s).replace(/\{itemLimit\}/g,a),this._batchError(r))},_onValidateCallbackFailure:function(e,t,n,i){var o=t+1;this._fileOrBlobRejected(e[t].id,e[t].file.name),this._maybeProcessNextItemAfterOnValidateCallback(!1,e,o,n,i)},_onValidateCallbackSuccess:function(e,t,n,i){var o=this,r=t+1,a=this._getValidationDescriptor(e[t]);this._validateFileOrBlobData(e[t],a).then(function(){o._upload(e[t].id,n,i),o._maybeProcessNextItemAfterOnValidateCallback(!0,e,r,n,i)},function(){o._maybeProcessNextItemAfterOnValidateCallback(!1,e,r,n,i)})},_prepareItemsForUpload:function(e,t,n){if(0===e.length)return void this._itemError("noFilesError");var i=this._getValidationDescriptors(e),o=this._getButtonId(e[0].file),r=this._getButton(o);this._handleCheckedCallback({name:"onValidateBatch",callback:qq.bind(this._options.callbacks.onValidateBatch,this,i,r),onSuccess:qq.bind(this._onValidateBatchCallbackSuccess,this,i,e,t,n,r),onFailure:qq.bind(this._onValidateBatchCallbackFailure,this,e),identifier:"batch validation"})},_preventLeaveInProgress:function(){var e=this;this._disposeSupport.attach(window,"beforeunload",function(t){if(e.getInProgress())return t=t||window.event,t.returnValue=e._options.messages.onLeave,e._options.messages.onLeave})},_refreshSessionData:function(){var e=this,t=this._options.session;qq.Session&&null!=this._options.session.endpoint&&(this._session||(qq.extend(t,{cors:this._options.cors}),t.log=qq.bind(this.log,this),t.addFileRecord=qq.bind(this._addCannedFile,this),this._session=new qq.Session(t)),setTimeout(function(){e._session.refresh().then(function(t,n){e._sessionRequestComplete(),e._options.callbacks.onSessionRequestComplete(t,!0,n)},function(t,n){e._options.callbacks.onSessionRequestComplete(t,!1,n)})},0))},_sessionRequestComplete:function(){},_setSize:function(e,t){this._uploadData.updateSize(e,t),this._totalProgress&&this._totalProgress.onNewSize(e)},_shouldAutoRetry:function(e,t,n){var i=this._uploadData.retrieve({id:e});return!!(!this._preventRetries[e]&&this._options.retry.enableAuto&&i.status!==qq.status.PAUSED&&(void 0===this._autoRetries[e]&&(this._autoRetries[e]=0),this._autoRetries[e]<this._options.retry.maxAutoAttempts))&&(this._autoRetries[e]+=1,!0)},_storeForLater:function(e){this._storedIds.push(e)},_trackButton:function(e){var t;t=qq.supportedFeatures.ajaxUploading?this._handler.getFile(e).qqButtonId:this._getButtonId(this._handler.getInput(e)),t&&(this._buttonIdsForFileIds[e]=t)},_updateFormSupportAndParams:function(e){this._options.form.element=e,this._formSupport=qq.FormSupport&&new qq.FormSupport(this._options.form,qq.bind(this.uploadStoredFiles,this),qq.bind(this.log,this)),this._formSupport&&this._formSupport.attachedToForm&&(this._paramsStore.addReadOnly(null,this._formSupport.getFormInputsAsObject),this._options.autoUpload=this._formSupport.newAutoUpload,this._formSupport.newEndpoint&&this.setEndpoint(this._formSupport.newEndpoint))},_upload:function(e,t,n){var i=this.getName(e);t&&this.setParams(t,e),n&&this.setEndpoint(n,e),this._handleCheckedCallback({name:"onSubmit",callback:qq.bind(this._options.callbacks.onSubmit,this,e,i),onSuccess:qq.bind(this._onSubmitCallbackSuccess,this,e,i),onFailure:qq.bind(this._fileOrBlobRejected,this,e,i),identifier:e})},_uploadFile:function(e){this._handler.upload(e)||this._uploadData.setStatus(e,qq.status.QUEUED)},_uploadStoredFiles:function(){for(var e,t,n=this;this._storedIds.length;)e=this._storedIds.shift(),this._uploadFile(e);t=this.getUploads({status:qq.status.SUBMITTING}).length,t&&(qq.log("Still waiting for "+t+" files to clear submit queue. Will re-parse stored IDs array shortly."),setTimeout(function(){n._uploadStoredFiles()},1e3))},_validateFileOrBlobData:function(e,t){var n=this,i=function(){return e.file instanceof qq.BlobProxy?e.file.referenceBlob:e.file}(),o=t.name,r=t.size,a=this._getButtonId(e.file),s=this._getValidationBase(a),l=new qq.Promise;return l.then(function(){},function(){n._fileOrBlobRejected(e.id,o)}),qq.isFileOrInput(i)&&!this._isAllowedExtension(s.allowedExtensions,o)?(this._itemError("typeError",o,i),l.failure()):this._options.validation.allowEmpty||0!==r?r>0&&s.sizeLimit&&r>s.sizeLimit?(this._itemError("sizeError",o,i),l.failure()):r>0&&r<s.minSizeLimit?(this._itemError("minSizeError",o,i),l.failure()):(qq.ImageValidation&&qq.supportedFeatures.imagePreviews&&qq.isFile(i)?new qq.ImageValidation(i,qq.bind(n.log,n)).validate(s.image).then(l.success,function(e){n._itemError(e+"ImageError",o,i),l.failure()}):l.success(),l):(this._itemError("emptyError",o,i),l.failure())},_wrapCallbacks:function(){var e,t,n;e=this,t=function(t,n,i){var o;try{return n.apply(e,i)}catch(n){o=n.message||n.toString(),e.log("Caught exception in '"+t+"' callback - "+o,"error")}};for(n in this._options.callbacks)!function(){var i,o;i=n,o=e._options.callbacks[i],e._options.callbacks[i]=function(){return t(i,o,arguments)}}()}}}(),function(){"use strict";qq.FineUploaderBasic=function(e){var t=this;this._options={debug:!1,button:null,multiple:!0,maxConnections:3,disableCancelForFormUploads:!1,autoUpload:!0,request:{customHeaders:{},endpoint:"/server/upload",filenameParam:"qqfilename",forceMultipart:!0,inputName:"qqfile",method:"POST",params:{},paramsInBody:!0,totalFileSizeName:"qqtotalfilesize",uuidName:"qquuid"},validation:{allowedExtensions:[],sizeLimit:0,minSizeLimit:0,itemLimit:0,stopOnFirstInvalidFile:!0,acceptFiles:null,image:{maxHeight:0,maxWidth:0,minHeight:0,minWidth:0},allowEmpty:!1},callbacks:{onSubmit:function(e,t){},onSubmitted:function(e,t){},onComplete:function(e,t,n,i){},onAllComplete:function(e,t){},onCancel:function(e,t){},onUpload:function(e,t){},onUploadChunk:function(e,t,n){},onUploadChunkSuccess:function(e,t,n,i){},onResume:function(e,t,n){},onProgress:function(e,t,n,i){},onTotalProgress:function(e,t){},onError:function(e,t,n,i){},onAutoRetry:function(e,t,n){},onManualRetry:function(e,t){},onValidateBatch:function(e){},onValidate:function(e){},onSubmitDelete:function(e){},onDelete:function(e){},onDeleteComplete:function(e,t,n){},onPasteReceived:function(e){},onStatusChange:function(e,t,n){},onSessionRequestComplete:function(e,t,n){}},messages:{typeError:"{file} has an invalid extension. Valid extension(s): {extensions}.",sizeError:"{file} is too large, maximum file size is {sizeLimit}.",minSizeError:"{file} is too small, minimum file size is {minSizeLimit}.",emptyError:"{file} is empty, please select files again without it.",noFilesError:"No files to upload.",tooManyItemsError:"Too many items ({netItems}) would be uploaded.  Item limit is {itemLimit}.",maxHeightImageError:"Image is too tall.",maxWidthImageError:"Image is too wide.",minHeightImageError:"Image is not tall enough.",minWidthImageError:"Image is not wide enough.",retryFailTooManyItems:"Retry failed - you have reached your file limit.",onLeave:"The files are being uploaded, if you leave now the upload will be canceled.",unsupportedBrowserIos8Safari:"Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari.  Please use iOS8 Chrome until Apple fixes these issues."},retry:{enableAuto:!1,maxAutoAttempts:3,autoAttemptDelay:5,preventRetryResponseProperty:"preventRetry"},classes:{buttonHover:"qq-upload-button-hover",buttonFocus:"qq-upload-button-focus"},chunking:{enabled:!1,concurrent:{enabled:!1},mandatory:!1,paramNames:{partIndex:"qqpartindex",partByteOffset:"qqpartbyteoffset",chunkSize:"qqchunksize",totalFileSize:"qqtotalfilesize",totalParts:"qqtotalparts"},partSize:2e6,success:{endpoint:null}},resume:{enabled:!1,recordsExpireIn:7,paramNames:{resuming:"qqresume"}},formatFileName:function(e){return e},text:{defaultResponseError:"Upload failure reason unknown",fileInputTitle:"file input",sizeSymbols:["kB","MB","GB","TB","PB","EB"]},deleteFile:{enabled:!1,method:"DELETE",endpoint:"/server/upload",customHeaders:{},params:{}},cors:{expected:!1,sendCredentials:!1,allowXdr:!1},blobs:{defaultName:"misc_data"},paste:{targetElement:null,defaultName:"pasted_image"},camera:{ios:!1,button:null},extraButtons:[],session:{endpoint:null,params:{},customHeaders:{},refreshOnReset:!0},form:{element:"qq-form",autoUpload:!1,interceptSubmit:!0},scaling:{customResizer:null,sendOriginal:!0,orient:!0,defaultType:null,defaultQuality:80,failureText:"Failed to scale",includeExif:!1,sizes:[]},workarounds:{iosEmptyVideos:!0,ios8SafariUploads:!0,ios8BrowserCrash:!1}},qq.extend(this._options,e,!0),this._buttons=[],this._extraButtonSpecs={},this._buttonIdsForFileIds=[],this._wrapCallbacks(),this._disposeSupport=new qq.DisposeSupport,this._storedIds=[],this._autoRetries=[],this._retryTimeouts=[],this._preventRetries=[],this._thumbnailUrls=[],this._netUploadedOrQueued=0,this._netUploaded=0,this._uploadData=this._createUploadDataTracker(),this._initFormSupportAndParams(),this._customHeadersStore=this._createStore(this._options.request.customHeaders),this._deleteFileCustomHeadersStore=this._createStore(this._options.deleteFile.customHeaders),this._deleteFileParamsStore=this._createStore(this._options.deleteFile.params),this._endpointStore=this._createStore(this._options.request.endpoint),this._deleteFileEndpointStore=this._createStore(this._options.deleteFile.endpoint),this._handler=this._createUploadHandler(),this._deleteHandler=qq.DeleteFileAjaxRequester&&this._createDeleteHandler(),this._options.button&&(this._defaultButtonId=this._createUploadButton({element:this._options.button,title:this._options.text.fileInputTitle}).getButtonId()),this._generateExtraButtonSpecs(),this._handleCameraAccess(),this._options.paste.targetElement&&(qq.PasteSupport?this._pasteHandler=this._createPasteHandler():this.log("Paste support module not found","error")),this._preventLeaveInProgress(),this._imageGenerator=qq.ImageGenerator&&new qq.ImageGenerator(qq.bind(this.log,this)),this._refreshSessionData(),this._succeededSinceLastAllComplete=[],this._failedSinceLastAllComplete=[],this._scaler=qq.Scaler&&new qq.Scaler(this._options.scaling,qq.bind(this.log,this))||{},this._scaler.enabled&&(this._customNewFileHandler=qq.bind(this._scaler.handleNewFile,this._scaler)),qq.TotalProgress&&qq.supportedFeatures.progressBar&&(this._totalProgress=new qq.TotalProgress(qq.bind(this._onTotalProgress,this),function(e){var n=t._uploadData.retrieve({id:e});return n&&n.size||0})),this._currentItemLimit=this._options.validation.itemLimit},qq.FineUploaderBasic.prototype=qq.basePublicApi,qq.extend(qq.FineUploaderBasic.prototype,qq.basePrivateApi)}(),qq.AjaxRequester=function(e){"use strict";function t(){return qq.indexOf(["GET","POST","HEAD"],S.method)>=0}function n(e){var t=!1;return qq.each(t,function(e,n){if(qq.indexOf(["Accept","Accept-Language","Content-Language","Content-Type"],n)<0)return t=!0,!1}),t}function i(e){return S.cors.expected&&void 0===e.withCredentials}function o(){var e;return(window.XMLHttpRequest||window.ActiveXObject)&&(e=qq.createXhrInstance(),void 0===e.withCredentials&&(e=new XDomainRequest,e.onload=function(){},e.onerror=function(){},e.ontimeout=function(){},e.onprogress=function(){})),e}function r(e,t){var n=y[e].xhr;return n||(n=t?t:S.cors.expected?o():qq.createXhrInstance(),y[e].xhr=n),n}function a(e){var t,n=qq.indexOf(b,e),i=S.maxConnections;delete y[e],b.splice(n,1),b.length>=i&&n<i&&(t=b[i-1],u(t))}function s(e,t){var n=r(e),o=S.method,s=t===!0;a(e),s?_(o+" request for "+e+" has failed","error"):i(n)||m(n.status)||(s=!0,_(o+" request for "+e+" has failed - response code "+n.status,"error")),S.onComplete(e,n,s)}function l(e){var t,n=y[e].additionalParams,i=S.mandatedParams;return S.paramsStore.get&&(t=S.paramsStore.get(e)),n&&qq.each(n,function(e,n){t=t||{},t[e]=n}),i&&qq.each(i,function(e,n){t=t||{},t[e]=n}),t}function u(e,t){var n,o=r(e,t),a=S.method,s=l(e),u=y[e].payload;return S.onSend(e),n=c(e,s,y[e].additionalQueryParams),i(o)?(o.onload=h(e),o.onerror=q(e)):o.onreadystatechange=d(e),p(e),o.open(a,n,!0),S.cors.expected&&S.cors.sendCredentials&&!i(o)&&(o.withCredentials=!0),f(e),_("Sending "+a+" request for "+e),u?o.send(u):v||!s?o.send():s&&S.contentType&&S.contentType.toLowerCase().indexOf("application/x-www-form-urlencoded")>=0?o.send(qq.obj2url(s,"")):s&&S.contentType&&S.contentType.toLowerCase().indexOf("application/json")>=0?o.send(JSON.stringify(s)):o.send(s),o}function c(e,t,n){var i=S.endpointStore.get(e),o=y[e].addToPath;return void 0!=o&&(i+="/"+o),v&&t&&(i=qq.obj2url(t,i)),n&&(i=qq.obj2url(n,i)),i}function d(e){return function(){4===r(e).readyState&&s(e)}}function p(e){var t=S.onProgress;t&&(r(e).upload.onprogress=function(n){n.lengthComputable&&t(e,n.loaded,n.total)})}function h(e){return function(){s(e)}}function q(e){return function(){s(e,!0)}}function f(e){var o=r(e),a=S.customHeaders,s=y[e].additionalHeaders||{},l=S.method,u={};i(o)||(S.acceptHeader&&o.setRequestHeader("Accept",S.acceptHeader),S.allowXRequestedWithAndCacheControl&&(S.cors.expected&&t()&&!n(a)||(o.setRequestHeader("X-Requested-With","XMLHttpRequest"),o.setRequestHeader("Cache-Control","no-cache"))),!S.contentType||"POST"!==l&&"PUT"!==l||o.setRequestHeader("Content-Type",S.contentType),qq.extend(u,qq.isFunction(a)?a(e):a),qq.extend(u,s),qq.each(u,function(e,t){o.setRequestHeader(e,t)}))}function m(e){return qq.indexOf(S.successfulResponseCodes[S.method],e)>=0}function g(e,t,n,i,o,r,a){y[e]={addToPath:n,additionalParams:i,additionalQueryParams:o,additionalHeaders:r,payload:a};var s=b.push(e);if(s<=S.maxConnections)return u(e,t)}var _,v,b=[],y={},S={acceptHeader:null,validMethods:["PATCH","POST","PUT"],method:"POST",contentType:"application/x-www-form-urlencoded",maxConnections:3,customHeaders:{},endpointStore:{},paramsStore:{},mandatedParams:{},allowXRequestedWithAndCacheControl:!0,successfulResponseCodes:{DELETE:[200,202,204],PATCH:[200,201,202,203,204],POST:[200,201,202,203,204],PUT:[200,201,202,203,204],GET:[200]},cors:{expected:!1,sendCredentials:!1},log:function(e,t){},onSend:function(e){},onComplete:function(e,t,n){},onProgress:null};if(qq.extend(S,e),_=S.log,qq.indexOf(S.validMethods,S.method)<0)throw new Error("'"+S.method+"' is not a supported method for this type of request!");v="GET"===S.method||"DELETE"===S.method,qq.extend(this,{initTransport:function(e){var t,n,i,o,r,a;return{withPath:function(e){return t=e,this},withParams:function(e){return n=e,this},withQueryParams:function(e){return a=e,this},withHeaders:function(e){return i=e,this},withPayload:function(e){return o=e,this},withCacheBuster:function(){return r=!0,this},send:function(s){return r&&qq.indexOf(["GET","DELETE"],S.method)>=0&&(n.qqtimestamp=(new Date).getTime()),g(e,s,t,n,a,i,o)}}},canceled:function(e){a(e)}})},qq.UploadHandler=function(e){"use strict";var t=e.proxy,n={},i=t.onCancel,o=t.getName;qq.extend(this,{add:function(e,t){n[e]=t,n[e].temp={}},cancel:function(e){var t=this,r=new qq.Promise,a=i(e,o(e),r);a.then(function(){t.isValid(e)&&(n[e].canceled=!0,t.expunge(e)),r.success()})},expunge:function(e){delete n[e]},getThirdPartyFileId:function(e){return n[e].key},isValid:function(e){return void 0!==n[e]},reset:function(){n={}},_getFileState:function(e){return n[e]},_setThirdPartyFileId:function(e,t){n[e].key=t},_wasCanceled:function(e){return!!n[e].canceled}})},qq.UploadHandlerController=function(e,t){"use strict";var n,i,o,r=this,a=!1,s=!1,l={paramsStore:{},maxConnections:3,chunking:{enabled:!1,multiple:{enabled:!1}},log:function(e,t){},onProgress:function(e,t,n,i){},onComplete:function(e,t,n,i){},onCancel:function(e,t){},onUploadPrep:function(e){},onUpload:function(e,t){},onUploadChunk:function(e,t,n){},onUploadChunkSuccess:function(e,t,n,i){},onAutoRetry:function(e,t,n,i){},onResume:function(e,t,n){},onUuidChanged:function(e,t){},getName:function(e){},setSize:function(e,t){},isQueued:function(e){},getIdsInProxyGroup:function(e){},getIdsInBatch:function(e){}},u={done:function(e,t,n,i){var r=o._getChunkData(e,t);o._getFileState(e).attemptingResume=!1,delete o._getFileState(e).temp.chunkProgress[t],o._getFileState(e).loaded+=r.size,l.onUploadChunkSuccess(e,o._getChunkDataForCallback(r),n,i)},finalize:function(e){var t=l.getSize(e),n=l.getName(e);i("All chunks have been uploaded for "+e+" - finalizing...."),o.finalizeChunks(e).then(function(r,a){i("Finalize successful for "+e);var s=p.normalizeResponse(r,!0);l.onProgress(e,n,t,t),o._maybeDeletePersistedChunkData(e),p.cleanup(e,s,a)},function(t,o){var r=p.normalizeResponse(t,!1);i("Problem finalizing chunks for file ID "+e+" - "+r.error,"error"),r.reset&&u.reset(e),l.onAutoRetry(e,n,r,o)||p.cleanup(e,r,o)})},handleFailure:function(e,t,n,r){var a=l.getName(t);i("Chunked upload request failed for "+t+", chunk "+e),o.clearCachedChunk(t,e);var d,h=p.normalizeResponse(n,!1);h.reset?u.reset(t):(d=qq.indexOf(o._getFileState(t).chunking.inProgress,e),d>=0&&(o._getFileState(t).chunking.inProgress.splice(d,1),o._getFileState(t).chunking.remaining.unshift(e))),o._getFileState(t).temp.ignoreFailure||(s&&(o._getFileState(t).temp.ignoreFailure=!0,i(qq.format("Going to attempt to abort these chunks: {}. These are currently in-progress: {}.",JSON.stringify(Object.keys(o._getXhrs(t))),JSON.stringify(o._getFileState(t).chunking.inProgress))),qq.each(o._getXhrs(t),function(e,n){i(qq.format("Attempting to abort file {}.{}. XHR readyState {}. ",t,e,n.readyState)),n.abort(),n._cancelled=!0}),o.moveInProgressToRemaining(t),c.free(t,!0)),l.onAutoRetry(t,a,h,r)||p.cleanup(t,h,r))},hasMoreParts:function(e){return!!o._getFileState(e).chunking.remaining.length},nextPart:function(e){var t=o._getFileState(e).chunking.remaining.shift();return t>=o._getTotalChunks(e)&&(t=null),t},reset:function(e){i("Server or callback has ordered chunking effort to be restarted on next attempt for item ID "+e,"error"),o._maybeDeletePersistedChunkData(e),o.reevaluateChunking(e),o._getFileState(e).loaded=0},sendNext:function(e){var t=l.getSize(e),n=l.getName(e),r=u.nextPart(e),a=o._getChunkData(e,r),d=o._getFileState(e).attemptingResume,h=o._getFileState(e).chunking.inProgress||[];null==o._getFileState(e).loaded&&(o._getFileState(e).loaded=0),d&&l.onResume(e,n,a)===!1&&(u.reset(e),r=u.nextPart(e),a=o._getChunkData(e,r),d=!1),null==r&&0===h.length?u.finalize(e):(i(qq.format("Sending chunked upload request for item {}.{}, bytes {}-{} of {}.",e,r,a.start+1,a.end,t)),l.onUploadChunk(e,n,o._getChunkDataForCallback(a)),h.push(r),o._getFileState(e).chunking.inProgress=h,s&&c.open(e,r),s&&c.available()&&o._getFileState(e).chunking.remaining.length&&u.sendNext(e),0===a.blob.size?(i(qq.format("Chunk {} for file {} will not be uploaded, zero sized chunk.",r,e),"error"),u.handleFailure(r,e,"File is no longer available",null)):o.uploadChunk(e,r,d).then(function(t,n){i("Chunked upload request succeeded for "+e+", chunk "+r),o.clearCachedChunk(e,r);var a=o._getFileState(e).chunking.inProgress||[],s=p.normalizeResponse(t,!0),l=qq.indexOf(a,r);i(qq.format("Chunk {} for file {} uploaded successfully.",r,e)),u.done(e,r,s,n),l>=0&&a.splice(l,1),o._maybePersistChunkedState(e),u.hasMoreParts(e)||0!==a.length?u.hasMoreParts(e)?u.sendNext(e):i(qq.format("File ID {} has no more chunks to send and these chunk indexes are still marked as in-progress: {}",e,JSON.stringify(a))):u.finalize(e)},function(t,n){u.handleFailure(r,e,t,n)}).done(function(){o.clearXhr(e,r)}))}},c={_open:[],_openChunks:{},_waiting:[],available:function(){var e=l.maxConnections,t=0,n=0;return qq.each(c._openChunks,function(e,i){t++,n+=i.length}),e-(c._open.length-t+n)},free:function(e,t){var n,r=!t,a=qq.indexOf(c._waiting,e),s=qq.indexOf(c._open,e);delete c._openChunks[e],p.getProxyOrBlob(e)instanceof qq.BlobProxy&&(i("Generated blob upload has ended for "+e+", disposing generated blob."),delete o._getFileState(e).file),a>=0?c._waiting.splice(a,1):r&&s>=0&&(c._open.splice(s,1),n=c._waiting.shift(),n>=0&&(c._open.push(n),p.start(n)))},getWaitingOrConnected:function(){var e=[];return qq.each(c._openChunks,function(t,n){n&&n.length&&e.push(parseInt(t))}),qq.each(c._open,function(t,n){c._openChunks[n]||e.push(parseInt(n))}),e=e.concat(c._waiting)},isUsingConnection:function(e){return qq.indexOf(c._open,e)>=0},open:function(e,t){return null==t&&c._waiting.push(e),!!c.available()&&(null==t?(c._waiting.pop(),c._open.push(e)):!function(){var n=c._openChunks[e]||[];n.push(t),c._openChunks[e]=n}(),!0)},reset:function(){c._waiting=[],c._open=[]}},d={send:function(e,t){o._getFileState(e).loaded=0,i("Sending simple upload request for "+e),o.uploadFile(e).then(function(n,o){i("Simple upload request succeeded for "+e);var r=p.normalizeResponse(n,!0),a=l.getSize(e);l.onProgress(e,t,a,a),p.maybeNewUuid(e,r),p.cleanup(e,r,o)},function(n,o){i("Simple upload request failed for "+e);var r=p.normalizeResponse(n,!1);l.onAutoRetry(e,t,r,o)||p.cleanup(e,r,o)})}},p={cancel:function(e){i("Cancelling "+e),l.paramsStore.remove(e),c.free(e)},cleanup:function(e,t,n){var i=l.getName(e);l.onComplete(e,i,t,n),o._getFileState(e)&&o._clearXhrs&&o._clearXhrs(e),c.free(e)},getProxyOrBlob:function(e){return o.getProxy&&o.getProxy(e)||o.getFile&&o.getFile(e)},initHandler:function(){var e=t?qq[t]:qq.traditional,n=qq.supportedFeatures.ajaxUploading?"Xhr":"Form";o=new e[n+"UploadHandler"](l,{getDataByUuid:l.getDataByUuid,getName:l.getName,getSize:l.getSize,getUuid:l.getUuid,log:i,onCancel:l.onCancel,onProgress:l.onProgress,onUuidChanged:l.onUuidChanged}),o._removeExpiredChunkingRecords&&o._removeExpiredChunkingRecords()},isDeferredEligibleForUpload:function(e){return l.isQueued(e)},maybeDefer:function(e,t){return t&&!o.getFile(e)&&t instanceof qq.BlobProxy?(l.onUploadPrep(e),i("Attempting to generate a blob on-demand for "+e),t.create().then(function(t){i("Generated an on-demand blob for "+e),o.updateBlob(e,t),l.setSize(e,t.size),o.reevaluateChunking(e),p.maybeSendDeferredFiles(e)},function(t){var o={};t&&(o.error=t),i(qq.format("Failed to generate blob for ID {}.  Error message: {}.",e,t),"error"),l.onComplete(e,l.getName(e),qq.extend(o,n),null),p.maybeSendDeferredFiles(e),c.free(e)}),!1):p.maybeSendDeferredFiles(e)},maybeSendDeferredFiles:function(e){var t=l.getIdsInProxyGroup(e),n=!1;return t&&t.length?(i("Maybe ready to upload proxy group file "+e),qq.each(t,function(t,i){if(p.isDeferredEligibleForUpload(i)&&o.getFile(i))n=i===e,p.now(i);else if(p.isDeferredEligibleForUpload(i))return!1})):(n=!0,p.now(e)),n},maybeNewUuid:function(e,t){void 0!==t.newUuid&&l.onUuidChanged(e,t.newUuid)},normalizeResponse:function(e,t){var n=e;return qq.isObject(e)||(n={},qq.isString(e)&&!t&&(n.error=e)),n.success=t,n},now:function(e){var t=l.getName(e);if(!r.isValid(e))throw new qq.Error(e+" is not a valid file ID to upload!");l.onUpload(e,t),a&&o._shouldChunkThisFile(e)?u.sendNext(e):d.send(e,t)},start:function(e){var t=p.getProxyOrBlob(e);return t?p.maybeDefer(e,t):(p.now(e),!0)}};qq.extend(this,{add:function(e,t){o.add.apply(this,arguments)},upload:function(e){return!!c.open(e)&&p.start(e)},retry:function(e){return s&&(o._getFileState(e).temp.ignoreFailure=!1),c.isUsingConnection(e)?p.start(e):r.upload(e)},cancel:function(e){var t=o.cancel(e);qq.isGenericPromise(t)?t.then(function(){p.cancel(e)}):t!==!1&&p.cancel(e)},cancelAll:function(){var e,t=c.getWaitingOrConnected();if(t.length)for(e=t.length-1;e>=0;e--)r.cancel(t[e]);c.reset()},getFile:function(e){return o.getProxy&&o.getProxy(e)?o.getProxy(e).referenceBlob:o.getFile&&o.getFile(e);
},isProxied:function(e){return!(!o.getProxy||!o.getProxy(e))},getInput:function(e){if(o.getInput)return o.getInput(e)},reset:function(){i("Resetting upload handler"),r.cancelAll(),c.reset(),o.reset()},expunge:function(e){if(r.isValid(e))return o.expunge(e)},isValid:function(e){return o.isValid(e)},getResumableFilesData:function(){return o.getResumableFilesData?o.getResumableFilesData():[]},getThirdPartyFileId:function(e){if(r.isValid(e))return o.getThirdPartyFileId(e)},pause:function(e){return!!(r.isResumable(e)&&o.pause&&r.isValid(e)&&o.pause(e))&&(c.free(e),o.moveInProgressToRemaining(e),!0)},isResumable:function(e){return!!o.isResumable&&o.isResumable(e)}}),qq.extend(l,e),i=l.log,a=l.chunking.enabled&&qq.supportedFeatures.chunking,s=a&&l.chunking.concurrent.enabled,n=function(){var e={};return e[l.preventRetryParam]=!0,e}(),p.initHandler()},qq.WindowReceiveMessage=function(e){"use strict";var t={log:function(e,t){}},n={};qq.extend(t,e),qq.extend(this,{receiveMessage:function(e,t){var i=function(e){t(e.data)};window.postMessage?n[e]=qq(window).attach("message",i):log("iframe message passing not supported in this browser!","error")},stopReceivingMessages:function(e){if(window.postMessage){var t=n[e];t&&t()}}})},qq.FormUploadHandler=function(e){"use strict";function t(e){delete c[e],p&&(clearTimeout(d[e]),delete d[e],m.stopReceivingMessages(e));var t=document.getElementById(a._getIframeName(e));t&&(t.setAttribute("src","javascript:false;"),qq(t).remove())}function n(e){return e.split("_")[0]}function i(e){var t=qq.toElement("<iframe src='javascript:false;' name='"+e+"' />");return t.setAttribute("id",e),t.style.display="none",document.body.appendChild(t),t}function o(e,t){var i=e.id,o=n(i),r=q(o);u[r]=t,c[o]=qq(e).attach("load",function(){a.getInput(o)&&(f("Received iframe load event for CORS upload request (iframe name "+i+")"),d[i]=setTimeout(function(){var e="No valid message received from loaded iframe for iframe name "+i;f(e,"error"),t({error:e})},1e3))}),m.receiveMessage(i,function(e){f("Received the following window message: '"+e+"'");var t,o=(n(i),a._parseJsonResponse(e)),r=o.uuid;r&&u[r]?(f("Handling response for iframe name "+i),clearTimeout(d[i]),delete d[i],a._detachLoadEvent(i),t=u[r],delete u[r],m.stopReceivingMessages(i),t(o)):r||f("'"+e+"' does not contain a UUID - ignoring.")})}var r=e.options,a=this,s=e.proxy,l=qq.getUniqueId(),u={},c={},d={},p=r.isCors,h=r.inputName,q=s.getUuid,f=s.log,m=new qq.WindowReceiveMessage({log:f});qq.extend(this,new qq.UploadHandler(e)),qq.override(this,function(e){return{add:function(t,n){e.add(t,{input:n}),n.setAttribute("name",h),n.parentNode&&qq(n).remove()},expunge:function(n){t(n),e.expunge(n)},isValid:function(t){return e.isValid(t)&&void 0!==a._getFileState(t).input}}}),qq.extend(this,{getInput:function(e){return a._getFileState(e).input},_attachLoadEvent:function(e,t){var n;p?o(e,t):c[e.id]=qq(e).attach("load",function(){if(f("Received response for "+e.id),e.parentNode){try{if(e.contentDocument&&e.contentDocument.body&&"false"==e.contentDocument.body.innerHTML)return}catch(e){f("Error when attempting to access iframe during handling of upload response ("+e.message+")","error"),n={success:!1}}t(n)}})},_createIframe:function(e){var t=a._getIframeName(e);return i(t)},_detachLoadEvent:function(e){void 0!==c[e]&&(c[e](),delete c[e])},_getIframeName:function(e){return e+"_"+l},_initFormForUpload:function(e){var t=e.method,n=e.endpoint,i=e.params,o=e.paramsInBody,r=e.targetName,a=qq.toElement("<form method='"+t+"' enctype='multipart/form-data'></form>"),s=n;return o?qq.obj2Inputs(i,a):s=qq.obj2url(i,n),a.setAttribute("action",s),a.setAttribute("target",r),a.style.display="none",document.body.appendChild(a),a},_parseJsonResponse:function(e){var t={};try{t=qq.parseJson(e)}catch(e){f("Error when attempting to parse iframe upload response ("+e.message+")","error")}return t}})},qq.XhrUploadHandler=function(e){"use strict";function t(e){qq.each(n._getXhrs(e),function(t,i){var o=n._getAjaxRequester(e,t);i.onreadystatechange=null,i.upload.onprogress=null,i.abort(),o&&o.canceled&&o.canceled(e)})}var n=this,i=e.options.namespace,o=e.proxy,r=e.options.chunking,a=e.options.resume,s=r&&e.options.chunking.enabled&&qq.supportedFeatures.chunking,l=a&&e.options.resume.enabled&&s&&qq.supportedFeatures.resume,u=o.getName,c=o.getSize,d=o.getUuid,p=o.getEndpoint,h=o.getDataByUuid,q=o.onUuidChanged,f=o.onProgress,m=o.log;qq.extend(this,new qq.UploadHandler(e)),qq.override(this,function(e){return{add:function(t,i){if(qq.isFile(i)||qq.isBlob(i))e.add(t,{file:i});else{if(!(i instanceof qq.BlobProxy))throw new Error("Passed obj is not a File, Blob, or proxy");e.add(t,{proxy:i})}n._initTempState(t),l&&n._maybePrepareForResume(t)},expunge:function(i){t(i),n._maybeDeletePersistedChunkData(i),n._clearXhrs(i),e.expunge(i)}}}),qq.extend(this,{clearCachedChunk:function(e,t){delete n._getFileState(e).temp.cachedChunks[t]},clearXhr:function(e,t){var i=n._getFileState(e).temp;i.xhrs&&delete i.xhrs[t],i.ajaxRequesters&&delete i.ajaxRequesters[t]},finalizeChunks:function(e,t){var i=n._getTotalChunks(e)-1,o=n._getXhr(e,i);return t?(new qq.Promise).success(t(o),o):(new qq.Promise).success({},o)},getFile:function(e){return n.isValid(e)&&n._getFileState(e).file},getProxy:function(e){return n.isValid(e)&&n._getFileState(e).proxy},getResumableFilesData:function(){var e=[];return n._iterateResumeRecords(function(t,i){n.moveInProgressToRemaining(null,i.chunking.inProgress,i.chunking.remaining);var o={name:i.name,remaining:i.chunking.remaining,size:i.size,uuid:i.uuid};i.key&&(o.key=i.key),e.push(o)}),e},isResumable:function(e){return!!r&&n.isValid(e)&&!n._getFileState(e).notResumable},moveInProgressToRemaining:function(e,t,i){var o=t||n._getFileState(e).chunking.inProgress,r=i||n._getFileState(e).chunking.remaining;o&&(m(qq.format("Moving these chunks from in-progress {}, to remaining.",JSON.stringify(o))),o.reverse(),qq.each(o,function(e,t){r.unshift(t)}),o.length=0)},pause:function(e){if(n.isValid(e))return m(qq.format("Aborting XHR upload for {} '{}' due to pause instruction.",e,u(e))),n._getFileState(e).paused=!0,t(e),!0},reevaluateChunking:function(e){if(r&&n.isValid(e)){var t,i,o=n._getFileState(e);if(delete o.chunking,o.chunking={},t=n._getTotalChunks(e),t>1||r.mandatory){for(o.chunking.enabled=!0,o.chunking.parts=t,o.chunking.remaining=[],i=0;i<t;i++)o.chunking.remaining.push(i);n._initTempState(e)}else o.chunking.enabled=!1}},updateBlob:function(e,t){n.isValid(e)&&(n._getFileState(e).file=t)},_clearXhrs:function(e){var t=n._getFileState(e).temp;qq.each(t.ajaxRequesters,function(e){delete t.ajaxRequesters[e]}),qq.each(t.xhrs,function(e){delete t.xhrs[e]})},_createXhr:function(e,t){return n._registerXhr(e,t,qq.createXhrInstance())},_getAjaxRequester:function(e,t){var i=null==t?-1:t;return n._getFileState(e).temp.ajaxRequesters[i]},_getChunkData:function(e,t){var i=r.partSize,o=c(e),a=n.getFile(e),s=i*t,l=s+i>=o?o:s+i,u=n._getTotalChunks(e),d=this._getFileState(e).temp.cachedChunks,p=d[t]||qq.sliceBlob(a,s,l);return d[t]=p,{part:t,start:s,end:l,count:u,blob:p,size:l-s}},_getChunkDataForCallback:function(e){return{partIndex:e.part,startByte:e.start+1,endByte:e.end,totalParts:e.count}},_getLocalStorageId:function(e){var t="5.0",n=u(e),o=c(e),a=r.partSize,s=p(e);return qq.format("qq{}resume{}-{}-{}-{}-{}",i,t,n,o,a,s)},_getMimeType:function(e){return n.getFile(e).type},_getPersistableData:function(e){return n._getFileState(e).chunking},_getTotalChunks:function(e){if(r){var t=c(e),n=r.partSize;return Math.ceil(t/n)}},_getXhr:function(e,t){var i=null==t?-1:t;return n._getFileState(e).temp.xhrs[i]},_getXhrs:function(e){return n._getFileState(e).temp.xhrs},_iterateResumeRecords:function(e){l&&qq.each(localStorage,function(t,n){if(0===t.indexOf(qq.format("qq{}resume",i))){var o=JSON.parse(n);e(t,o)}})},_initTempState:function(e){n._getFileState(e).temp={ajaxRequesters:{},chunkProgress:{},xhrs:{},cachedChunks:{}}},_markNotResumable:function(e){n._getFileState(e).notResumable=!0},_maybeDeletePersistedChunkData:function(e){var t;return!!(l&&n.isResumable(e)&&(t=n._getLocalStorageId(e),t&&localStorage.getItem(t)))&&(localStorage.removeItem(t),!0)},_maybePrepareForResume:function(e){var t,i,o=n._getFileState(e);l&&void 0===o.key&&(t=n._getLocalStorageId(e),i=localStorage.getItem(t),i&&(i=JSON.parse(i),h(i.uuid)?n._markNotResumable(e):(m(qq.format("Identified file with ID {} and name of {} as resumable.",e,u(e))),q(e,i.uuid),o.key=i.key,o.chunking=i.chunking,o.loaded=i.loaded,o.attemptingResume=!0,n.moveInProgressToRemaining(e))))},_maybePersistChunkedState:function(e){var t,i,o=n._getFileState(e);if(l&&n.isResumable(e)){t=n._getLocalStorageId(e),i={name:u(e),size:c(e),uuid:d(e),key:o.key,chunking:o.chunking,loaded:o.loaded,lastUpdated:Date.now()};try{localStorage.setItem(t,JSON.stringify(i))}catch(t){m(qq.format("Unable to save resume data for '{}' due to error: '{}'.",e,t.toString()),"warn")}}},_registerProgressHandler:function(e,t,i){var o=n._getXhr(e,t),r=u(e),a={simple:function(t,n){var i=c(e);t===n?f(e,r,i,i):f(e,r,t>=i?i-1:t,i)},chunked:function(o,a){var s=n._getFileState(e).temp.chunkProgress,l=n._getFileState(e).loaded,u=o,d=a,p=c(e),h=u-(d-i),q=l;s[t]=h,qq.each(s,function(e,t){q+=t}),f(e,r,q,p)}};o.upload.onprogress=function(e){if(e.lengthComputable){var t=null==i?"simple":"chunked";a[t](e.loaded,e.total)}}},_registerXhr:function(e,t,i,o){var r=null==t?-1:t,a=n._getFileState(e).temp;return a.xhrs=a.xhrs||{},a.ajaxRequesters=a.ajaxRequesters||{},a.xhrs[r]=i,o&&(a.ajaxRequesters[r]=o),i},_removeExpiredChunkingRecords:function(){var e=a.recordsExpireIn;n._iterateResumeRecords(function(t,n){var i=new Date(n.lastUpdated);i.setDate(i.getDate()+e),i.getTime()<=Date.now()&&(m("Removing expired resume record with key "+t),localStorage.removeItem(t))})},_shouldChunkThisFile:function(e){var t=n._getFileState(e);return t.chunking||n.reevaluateChunking(e),t.chunking.enabled}})},qq.DeleteFileAjaxRequester=function(e){"use strict";function t(){return"POST"===i.method.toUpperCase()?{_method:"DELETE"}:{}}var n,i={method:"DELETE",uuidParamName:"qquuid",endpointStore:{},maxConnections:3,customHeaders:function(e){return{}},paramsStore:{},cors:{expected:!1,sendCredentials:!1},log:function(e,t){},onDelete:function(e){},onDeleteComplete:function(e,t,n){}};qq.extend(i,e),n=qq.extend(this,new qq.AjaxRequester({acceptHeader:"application/json",validMethods:["POST","DELETE"],method:i.method,endpointStore:i.endpointStore,paramsStore:i.paramsStore,mandatedParams:t(),maxConnections:i.maxConnections,customHeaders:function(e){return i.customHeaders.get(e)},log:i.log,onSend:i.onDelete,onComplete:i.onDeleteComplete,cors:i.cors})),qq.extend(this,{sendDelete:function(e,t,o){var r=o||{};i.log("Submitting delete file request for "+e),"DELETE"===i.method?n.initTransport(e).withPath(t).withParams(r).send():(r[i.uuidParamName]=t,n.initTransport(e).withParams(r).send())}})},function(){function e(e){var t,n=e.naturalWidth,i=e.naturalHeight,o=document.createElement("canvas");return n*i>1048576&&(o.width=o.height=1,t=o.getContext("2d"),t.drawImage(e,-n+1,0),0===t.getImageData(0,0,1,1).data[3])}function t(e,t,n){var i,o,r,a,s=document.createElement("canvas"),l=0,u=n,c=n;for(s.width=1,s.height=n,i=s.getContext("2d"),i.drawImage(e,0,0),o=i.getImageData(0,0,1,n).data;c>l;)r=o[4*(c-1)+3],0===r?u=c:l=c,c=u+l>>1;return a=c/n,0===a?1:a}function n(e,t,n,i){var r=document.createElement("canvas"),a=n.mime||"image/jpeg",s=new qq.Promise;return o(e,t,r,n,i).then(function(){s.success(r.toDataURL(a,n.quality||.8))}),s}function i(e){var t=5241e3;if(!qq.ios())throw new qq.Error("Downsampled dimensions can only be reliably calculated for iOS!");if(e.origHeight*e.origWidth>t)return{newHeight:Math.round(Math.sqrt(t*(e.origHeight/e.origWidth))),newWidth:Math.round(Math.sqrt(t*(e.origWidth/e.origHeight)))}}function o(n,o,s,l,u){var c,d=n.naturalWidth,p=n.naturalHeight,h=l.width,q=l.height,f=s.getContext("2d"),m=new qq.Promise;return f.save(),l.resize?r({blob:o,canvas:s,image:n,imageHeight:p,imageWidth:d,orientation:l.orientation,resize:l.resize,targetHeight:q,targetWidth:h}):(qq.supportedFeatures.unlimitedScaledImageSize||(c=i({origWidth:h,origHeight:q}),c&&(qq.log(qq.format("Had to reduce dimensions due to device limitations from {}w / {}h to {}w / {}h",h,q,c.newWidth,c.newHeight),"warn"),h=c.newWidth,q=c.newHeight)),a(s,h,q,l.orientation),qq.ios()?!function(){e(n)&&(d/=2,p/=2);var i,o,r,a=1024,s=document.createElement("canvas"),l=u?t(n,d,p):1,c=Math.ceil(a*h/d),m=Math.ceil(a*q/p/l),g=0,_=0;for(s.width=s.height=a,i=s.getContext("2d");g<p;){for(o=0,r=0;o<d;)i.clearRect(0,0,a,a),i.drawImage(n,-o,-g),f.drawImage(s,0,0,a,a,r,_,c,m),o+=a,r+=c;g+=a,_+=m}f.restore(),s=i=null}():f.drawImage(n,0,0,h,q),s.qqImageRendered&&s.qqImageRendered(),m.success(),m)}function r(e){var t=e.blob,n=e.image,i=e.imageHeight,o=e.imageWidth,r=e.orientation,s=new qq.Promise,l=e.resize,u=document.createElement("canvas"),c=u.getContext("2d"),d=e.canvas,p=e.targetHeight,h=e.targetWidth;return a(u,o,i,r),d.height=p,d.width=h,c.drawImage(n,0,0),l({blob:t,height:p,image:n,sourceCanvas:u,targetCanvas:d,width:h}).then(function(){d.qqImageRendered&&d.qqImageRendered(),s.success()},s.failure),s}function a(e,t,n,i){switch(i){case 5:case 6:case 7:case 8:e.width=n,e.height=t;break;default:e.width=t,e.height=n}var o=e.getContext("2d");switch(i){case 2:o.translate(t,0),o.scale(-1,1);break;case 3:o.translate(t,n),o.rotate(Math.PI);break;case 4:o.translate(0,n),o.scale(1,-1);break;case 5:o.rotate(.5*Math.PI),o.scale(1,-1);break;case 6:o.rotate(.5*Math.PI),o.translate(0,-n);break;case 7:o.rotate(.5*Math.PI),o.translate(t,-n),o.scale(-1,1);break;case 8:o.rotate(-.5*Math.PI),o.translate(-t,0)}}function s(e,t){var n=this;window.Blob&&e instanceof Blob&&!function(){var t=new Image,i=window.URL&&window.URL.createObjectURL?window.URL:window.webkitURL&&window.webkitURL.createObjectURL?window.webkitURL:null;if(!i)throw Error("No createObjectURL function found to create blob url");t.src=i.createObjectURL(e),n.blob=e,e=t}(),e.naturalWidth||e.naturalHeight||(e.onload=function(){var e=n.imageLoadListeners;e&&(n.imageLoadListeners=null,setTimeout(function(){for(var t=0,n=e.length;t<n;t++)e[t]()},0))},e.onerror=t,this.imageLoadListeners=[]),this.srcImage=e}s.prototype.render=function(e,t){t=t||{};var i,r=this,a=this.srcImage.naturalWidth,s=this.srcImage.naturalHeight,l=t.width,u=t.height,c=t.maxWidth,d=t.maxHeight,p=!this.blob||"image/jpeg"===this.blob.type,h=e.tagName.toLowerCase();return this.imageLoadListeners?void this.imageLoadListeners.push(function(){r.render(e,t)}):(l&&!u?u=s*l/a<<0:u&&!l?l=a*u/s<<0:(l=a,u=s),c&&l>c&&(l=c,u=s*l/a<<0),d&&u>d&&(u=d,l=a*u/s<<0),i={width:l,height:u},qq.each(t,function(e,t){i[e]=t}),"img"===h?!function(){var t=e.src;n(r.srcImage,r.blob,i,p).then(function(n){e.src=n,t===e.src&&e.onload()})}():"canvas"===h&&o(this.srcImage,this.blob,e,i,p),void("function"==typeof this.onrender&&this.onrender(e)))},qq.MegaPixImage=s}(),qq.ImageGenerator=function(e){"use strict";function t(e){return"img"===e.tagName.toLowerCase()}function n(e){return"canvas"===e.tagName.toLowerCase()}function i(){return void 0!==(new Image).crossOrigin}function o(){var e=document.createElement("canvas");return e.getContext&&e.getContext("2d")}function r(e){var t=e.split("/"),n=t[t.length-1].split("?")[0],i=qq.getExtension(n);switch(i=i&&i.toLowerCase()){case"jpeg":case"jpg":return"image/jpeg";case"png":return"image/png";case"bmp":return"image/bmp";case"gif":return"image/gif";case"tiff":case"tif":return"image/tiff"}}function a(e){var t,n,i,o=document.createElement("a");return o.href=e,t=o.protocol,i=o.port,n=o.hostname,t.toLowerCase()!==window.location.protocol.toLowerCase()||(n.toLowerCase()!==window.location.hostname.toLowerCase()||i!==window.location.port&&!qq.ie())}function s(t,n){t.onload=function(){t.onload=null,t.onerror=null,n.success(t)},t.onerror=function(){t.onload=null,t.onerror=null,e("Problem drawing thumbnail!","error"),n.failure(t,"Problem drawing thumbnail!")}}function l(e,t){e.qqImageRendered=function(){t.success(e)}}function u(i,o){var r=t(i)||n(i);return t(i)?s(i,o):n(i)?l(i,o):(o.failure(i),e(qq.format("Element container of type {} is not supported!",i.tagName),"error")),r}function c(t,n,i){var o=new qq.Promise,r=new qq.Identify(t,e),a=i.maxSize,s=null==i.orient||i.orient,l=function(){n.onerror=null,n.onload=null,e("Could not render preview, file may be too large!","error"),o.failure(n,"Browser cannot render image!")};return r.isPreviewable().then(function(r){var c={parse:function(){return(new qq.Promise).success()}},d=s?new qq.Exif(t,e):c,p=new qq.MegaPixImage(t,l);u(n,o)&&d.parse().then(function(e){var t=e&&e.Orientation;p.render(n,{maxWidth:a,maxHeight:a,orientation:t,mime:r,resize:i.customResizeFunction})},function(t){e(qq.format("EXIF data could not be parsed ({}).  Assuming orientation = 1.",t)),p.render(n,{maxWidth:a,maxHeight:a,mime:r,resize:i.customResizeFunction})})},function(){e("Not previewable"),o.failure(n,"Not previewable")}),o}function d(e,t,n,i,o){var s=new Image,l=new qq.Promise;u(s,l),a(e)&&(s.crossOrigin="anonymous"),s.src=e,l.then(function(){u(t,n);var a=new qq.MegaPixImage(s);a.render(t,{maxWidth:i,maxHeight:i,mime:r(e),resize:o})},n.failure)}function p(e,t,n,i){u(t,n),qq(t).css({maxWidth:i+"px",maxHeight:i+"px"}),t.src=e}function h(e,r,s){var l=new qq.Promise,c=s.scale,h=c?s.maxSize:null;return c&&t(r)?o()?a(e)&&!i()?p(e,r,l,h):d(e,r,l,h):p(e,r,l,h):n(r)?d(e,r,l,h):u(r,l)&&(r.src=e),l}qq.extend(this,{generate:function(t,n,i){return qq.isString(t)?(e("Attempting to update thumbnail based on server response."),h(t,n,i||{})):(e("Attempting to draw client-side image preview."),c(t,n,i||{}))}}),this._testing={},this._testing.isImg=t,this._testing.isCanvas=n,this._testing.isCrossOrigin=a,this._testing.determineMimeOfFileName=r},qq.Exif=function(e,t){"use strict";function n(e){for(var t=0,n=0;e.length>0;)t+=parseInt(e.substring(0,2),16)*Math.pow(2,n),e=e.substring(2,e.length),n+=8;return t}function i(t,n){var o=t,r=n;return void 0===o&&(o=2,r=new qq.Promise),qq.readBlobToHex(e,o,4).then(function(e){var t,n=/^ffe([0-9])/.exec(e);n?"1"!==n[1]?(t=parseInt(e.slice(4,8),16),i(o+t+2,r)):r.success(o):r.failure("No EXIF header to be found!")}),r}function o(){var t=new qq.Promise;return qq.readBlobToHex(e,0,6).then(function(e){0!==e.indexOf("ffd8")?t.failure("Not a valid JPEG!"):i().then(function(e){t.success(e)},function(e){t.failure(e)})}),t}function r(t){var n=new qq.Promise;return qq.readBlobToHex(e,t+10,2).then(function(e){n.success("4949"===e)}),n}function a(t,i){var o=new qq.Promise;return qq.readBlobToHex(e,t+18,2).then(function(e){return i?o.success(n(e)):void o.success(parseInt(e,16))}),o}function s(t,n){var i=t+20,o=12*n;return qq.readBlobToHex(e,i,o)}function l(e){for(var t=[],n=0;n+24<=e.length;)t.push(e.slice(n,n+24)),n+=24;return t}function u(e,t){var i=16,o=qq.extend([],c),r={};return qq.each(t,function(t,a){var s,l,u,c=a.slice(0,4),p=e?n(c):parseInt(c,16),h=o.indexOf(p);if(h>=0&&(l=d[p].name,u=d[p].bytes,s=a.slice(i,i+2*u),r[l]=e?n(s):parseInt(s,16),o.splice(h,1)),0===o.length)return!1}),r}var c=[274],d={274:{name:"Orientation",bytes:2}};qq.extend(this,{parse:function(){var n=new qq.Promise,i=function(e){t(qq.format("EXIF header parse failed: '{}' ",e)),n.failure(e)};return o().then(function(o){t(qq.format("Moving forward with EXIF header parsing for '{}'",void 0===e.name?"blob":e.name)),r(o).then(function(e){t(qq.format("EXIF Byte order is {} endian",e?"little":"big")),a(o,e).then(function(r){t(qq.format("Found {} APP1 directory entries",r)),s(o,r).then(function(i){var o=l(i),r=u(e,o);t("Successfully parsed some EXIF tags"),n.success(r)},i)},i)},i)},i),n}}),this._testing={},this._testing.parseLittleEndian=n},qq.Identify=function(e,t){"use strict";function n(e,t){var n=!1,i=[].concat(e);return qq.each(i,function(e,i){if(0===t.indexOf(i))return n=!0,!1}),n}qq.extend(this,{isPreviewable:function(){var i=this,o=new qq.Promise,r=!1,a=void 0===e.name?"blob":e.name;return t(qq.format("Attempting to determine if {} can be rendered in this browser",a)),t("First pass: check type attribute of blob object."),this.isPreviewableSync()?(t("Second pass: check for magic bytes in file header."),qq.readBlobToHex(e,0,4).then(function(e){qq.each(i.PREVIEWABLE_MIME_TYPES,function(t,i){if(n(i,e))return("image/tiff"!==t||qq.supportedFeatures.tiffPreviews)&&(r=!0,o.success(t)),!1}),t(qq.format("'{}' is {} able to be rendered in this browser",a,r?"":"NOT")),r||o.failure()},function(){t("Error reading file w/ name '"+a+"'.  Not able to be rendered in this browser."),o.failure()})):o.failure(),o},isPreviewableSync:function(){var n=e.type,i=qq.indexOf(Object.keys(this.PREVIEWABLE_MIME_TYPES),n)>=0,o=!1,r=void 0===e.name?"blob":e.name;return i&&(o="image/tiff"!==n||qq.supportedFeatures.tiffPreviews),!o&&t(r+" is not previewable in this browser per the blob's type attr"),o}})},qq.Identify.prototype.PREVIEWABLE_MIME_TYPES={"image/jpeg":"ffd8ff","image/gif":"474946","image/png":"89504e","image/bmp":"424d","image/tiff":["49492a00","4d4d002a"]},qq.ImageValidation=function(e,t){"use strict";function n(e){var t=!1;return qq.each(e,function(e,n){if(n>0)return t=!0,!1}),t}function i(){var n=new qq.Promise;return new qq.Identify(e,t).isPreviewable().then(function(){var i=new Image,o=window.URL&&window.URL.createObjectURL?window.URL:window.webkitURL&&window.webkitURL.createObjectURL?window.webkitURL:null;o?(i.onerror=function(){t("Cannot determine dimensions for image.  May be too large.","error"),n.failure()},i.onload=function(){n.success({width:this.width,height:this.height})},i.src=o.createObjectURL(e)):(t("No createObjectURL function available to generate image URL!","error"),n.failure())},n.failure),n}function o(e,t){var n;return qq.each(e,function(e,i){if(i>0){var o=/(max|min)(Width|Height)/.exec(e),r=o[2].charAt(0).toLowerCase()+o[2].slice(1),a=t[r];switch(o[1]){case"min":if(a<i)return n=e,!1;break;case"max":if(a>i)return n=e,!1}}}),n}this.validate=function(e){var r=new qq.Promise;return t("Attempting to validate image."),n(e)?i().then(function(t){var n=o(e,t);n?r.failure(n):r.success()},r.success):r.success(),r}},qq.Session=function(e){"use strict";function t(e){return!!qq.isArray(e)||void i.log("Session response is not an array.","error")}function n(e,n,o,r){var a=!1;n=n&&t(e),n&&qq.each(e,function(e,t){if(null==t.uuid)a=!0,i.log(qq.format("Session response item {} did not include a valid UUID - ignoring.",e),"error");else if(null==t.name)a=!0,i.log(qq.format("Session response item {} did not include a valid name - ignoring.",e),"error");else try{return i.addFileRecord(t),!0}catch(e){a=!0,i.log(e.message,"error")}return!1}),r[n&&!a?"success":"failure"](e,o)}var i={endpoint:null,params:{},customHeaders:{},cors:{},addFileRecord:function(e){},log:function(e,t){}};qq.extend(i,e,!0),this.refresh=function(){var e=new qq.Promise,t=function(t,i,o){n(t,i,o,e)},o=qq.extend({},i),r=new qq.SessionAjaxRequester(qq.extend(o,{onComplete:t}));return r.queryServer(),e}},qq.SessionAjaxRequester=function(e){"use strict";function t(e,t,n){var o=null;if(null!=t.responseText)try{o=qq.parseJson(t.responseText)}catch(e){i.log("Problem parsing session response: "+e.message,"error"),n=!0}i.onComplete(o,!n,t)}var n,i={endpoint:null,customHeaders:{},params:{},cors:{expected:!1,sendCredentials:!1},onComplete:function(e,t,n){},log:function(e,t){}};qq.extend(i,e),n=qq.extend(this,new qq.AjaxRequester({acceptHeader:"application/json",validMethods:["GET"],method:"GET",endpointStore:{get:function(){return i.endpoint}},customHeaders:i.customHeaders,log:i.log,onComplete:t,cors:i.cors})),qq.extend(this,{queryServer:function(){var e=qq.extend({},i.params);i.log("Session query request."),n.initTransport("sessionRefresh").withParams(e).withCacheBuster().send()}})},qq.Scaler=function(e,t){"use strict";var n=e.customResizer,i=e.sendOriginal,o=e.orient,r=e.defaultType,a=e.defaultQuality/100,s=e.failureText,l=e.includeExif,u=this._getSortedSizes(e.sizes);qq.extend(this,{enabled:qq.supportedFeatures.scaling&&u.length>0,getFileRecords:function(e,c,d){var p=this,h=[],q=d.blob?d.blob:d,f=new qq.Identify(q,t);return f.isPreviewableSync()?(qq.each(u,function(e,i){var u=p._determineOutputType({defaultType:r,requestedType:i.type,refType:q.type});h.push({uuid:qq.getUniqueId(),name:p._getName(c,{name:i.name,type:u,refType:q.type}),blob:new qq.BlobProxy(q,qq.bind(p._generateScaledImage,p,{customResizeFunction:n,maxSize:i.maxSize,orient:o,type:u,quality:a,failedText:s,includeExif:l,log:t}))})}),h.push({uuid:e,name:c,size:q.size,blob:i?q:null})):h.push({uuid:e,name:c,size:q.size,blob:q}),h},handleNewFile:function(e,t,n,i,o,r,a,s){var l=this,u=(e.qqButtonId||e.blob&&e.blob.qqButtonId,[]),c=null,d=s.addFileToHandler,p=s.uploadData,h=s.paramsStore,q=qq.getUniqueId();qq.each(l.getFileRecords(n,t,e),function(e,t){var n,i=t.size;t.blob instanceof qq.BlobProxy&&(i=-1),n=p.addFile({uuid:t.uuid,name:t.name,size:i,batchId:r,proxyGroupId:q}),t.blob instanceof qq.BlobProxy?u.push(n):c=n,t.blob?(d(n,t.blob),o.push({id:n,file:t.blob})):p.setStatus(n,qq.status.REJECTED)}),null!==c&&(qq.each(u,function(e,t){var n={qqparentuuid:p.retrieve({id:c}).uuid,qqparentsize:p.retrieve({id:c}).size};n[a]=p.retrieve({id:t}).uuid,p.setParentId(t,c),h.addReadOnly(t,n)}),u.length&&!function(){var e={};e[a]=p.retrieve({id:c}).uuid,h.addReadOnly(c,e)}())}})},qq.extend(qq.Scaler.prototype,{scaleImage:function(e,t,n){"use strict";if(!qq.supportedFeatures.scaling)throw new qq.Error("Scaling is not supported in this browser!");var i=new qq.Promise,o=n.log,r=n.getFile(e),a=n.uploadData.retrieve({id:e}),s=a&&a.name,l=a&&a.uuid,u={customResizer:t.customResizer,sendOriginal:!1,orient:t.orient,defaultType:t.type||null,defaultQuality:t.quality,failedToScaleText:"Unable to scale",sizes:[{name:"",maxSize:t.maxSize}]},c=new qq.Scaler(u,o);return qq.Scaler&&qq.supportedFeatures.imagePreviews&&r?qq.bind(function(){var t=c.getFileRecords(l,s,r)[0];t&&t.blob instanceof qq.BlobProxy?t.blob.create().then(i.success,i.failure):(o(e+" is not a scalable image!","error"),i.failure())},this)():(i.failure(),o("Could not generate requested scaled image for "+e+".  Scaling is either not possible in this browser, or the file could not be located.","error")),i},_determineOutputType:function(e){"use strict";var t=e.requestedType,n=e.defaultType,i=e.refType;return n||t?t&&qq.indexOf(Object.keys(qq.Identify.prototype.PREVIEWABLE_MIME_TYPES),t)>=0?"image/tiff"===t?qq.supportedFeatures.tiffPreviews?t:n:t:n:"image/jpeg"!==i?"image/png":i},_getName:function(e,t){"use strict";var n=e.lastIndexOf("."),i=t.type||"image/png",o=t.refType,r="",a=qq.getExtension(e),s="";return t.name&&t.name.trim().length&&(s=" ("+t.name+")"),n>=0?(r=e.substr(0,n),o!==i&&(a=i.split("/")[1]),r+=s+"."+a):r=e+s,r},_getSortedSizes:function(e){"use strict";return e=qq.extend([],e),e.sort(function(e,t){return e.maxSize>t.maxSize?1:e.maxSize<t.maxSize?-1:0})},_generateScaledImage:function(e,t){"use strict";var n=this,i=e.customResizeFunction,o=e.log,r=e.maxSize,a=e.orient,s=e.type,l=e.quality,u=e.failedText,c=e.includeExif&&"image/jpeg"===t.type&&"image/jpeg"===s,d=new qq.Promise,p=new qq.ImageGenerator(o),h=document.createElement("canvas");return o("Attempting to generate scaled version for "+t.name),p.generate(t,h,{maxSize:r,orient:a,customResizeFunction:i}).then(function(){var e=h.toDataURL(s,l),i=function(){o("Success generating scaled version for "+t.name);var n=qq.dataUriToBlob(e);d.success(n)};c?n._insertExifHeader(t,e,o).then(function(t){e=t,i()},function(){o("Problem inserting EXIF header into scaled image.  Using scaled image w/out EXIF data.","error"),i()}):i()},function(){o("Failed attempt to generate scaled version for "+t.name,"error"),d.failure(u)}),d},_insertExifHeader:function(e,t,n){"use strict";var i=new FileReader,o=new qq.Promise,r="";return i.onload=function(){r=i.result,o.success(qq.ExifRestorer.restore(r,t))},i.onerror=function(){n("Problem reading "+e.name+" during attempt to transfer EXIF data to scaled version.","error"),o.failure()},i.readAsDataURL(e),o},_dataUriToBlob:function(e){"use strict";var t,n,i,o;return t=e.split(",")[0].indexOf("base64")>=0?atob(e.split(",")[1]):decodeURI(e.split(",")[1]),n=e.split(",")[0].split(":")[1].split(";")[0],i=new ArrayBuffer(t.length),o=new Uint8Array(i),qq.each(t,function(e,t){o[e]=t.charCodeAt(0)}),this._createBlob(i,n)},_createBlob:function(e,t){"use strict";var n=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder,i=n&&new n;return i?(i.append(e),i.getBlob(t)):new Blob([e],{type:t})}}),qq.ExifRestorer=function(){var e={};return e.KEY_STR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",e.encode64=function(e){var t,n,i,o,r,a="",s="",l="",u=0;do t=e[u++],n=e[u++],s=e[u++],i=t>>2,o=(3&t)<<4|n>>4,r=(15&n)<<2|s>>6,l=63&s,isNaN(n)?r=l=64:isNaN(s)&&(l=64),a=a+this.KEY_STR.charAt(i)+this.KEY_STR.charAt(o)+this.KEY_STR.charAt(r)+this.KEY_STR.charAt(l),t=n=s="",i=o=r=l="";while(u<e.length);return a},e.restore=function(e,t){var n="data:image/jpeg;base64,";if(!e.match(n))return t;var i=this.decode64(e.replace(n,"")),o=this.slice2Segments(i),r=this.exifManipulation(t,o);return n+this.encode64(r)},e.exifManipulation=function(e,t){var n=this.getExifArray(t),i=this.insertExif(e,n),o=new Uint8Array(i);return o},e.getExifArray=function(e){for(var t,n=0;n<e.length;n++)if(t=e[n],255==t[0]&225==t[1])return t;return[]},e.insertExif=function(e,t){var n=e.replace("data:image/jpeg;base64,",""),i=this.decode64(n),o=i.indexOf(255,3),r=i.slice(0,o),a=i.slice(o),s=r;return s=s.concat(t),s=s.concat(a)},e.slice2Segments=function(e){for(var t=0,n=[];;){if(255==e[t]&218==e[t+1])break;if(255==e[t]&216==e[t+1])t+=2;else{var i=256*e[t+2]+e[t+3],o=t+i+2,r=e.slice(t,o);n.push(r),t=o}if(t>e.length)break}return n},e.decode64=function(e){var t,n,i,o,r,a="",s="",l=0,u=[],c=/[^A-Za-z0-9\+\/\=]/g;if(c.exec(e))throw new Error("There were invalid base64 characters in the input text.  Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='");e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");do i=this.KEY_STR.indexOf(e.charAt(l++)),o=this.KEY_STR.indexOf(e.charAt(l++)),r=this.KEY_STR.indexOf(e.charAt(l++)),s=this.KEY_STR.indexOf(e.charAt(l++)),t=i<<2|o>>4,n=(15&o)<<4|r>>2,a=(3&r)<<6|s,u.push(t),64!=r&&u.push(n),64!=s&&u.push(a),t=n=a="",i=o=r=s="";while(l<e.length);return u},e}(),qq.TotalProgress=function(e,t){"use strict";var n={},i=0,o=0,r=-1,a=-1,s=function(t,n){t===r&&n===a||e(t,n),r=t,a=n},l=function(e,t){var n=!0;return qq.each(e,function(e,i){if(qq.indexOf(t,i)>=0)return n=!1,!1}),n},u=function(e){p(e,-1,-1),delete n[e]},c=function(e,t,n){(0===t.length||l(t,n))&&(s(o,o),this.reset())},d=function(e){var i=t(e);i>0&&(p(e,0,i),n[e]={loaded:0,total:i})},p=function(e,t,r){var a=n[e]?n[e].loaded:0,l=n[e]?n[e].total:0;t===-1&&r===-1?(i-=a,o-=l):(t&&(i+=t-a),r&&(o+=r-l)),s(i,o)};qq.extend(this,{onAllComplete:c,onStatusChange:function(e,t,n){n===qq.status.CANCELED||n===qq.status.REJECTED?u(e):n===qq.status.SUBMITTING&&d(e)},onIndividualProgress:function(e,t,i){p(e,t,i),n[e]={loaded:t,total:i}},onNewSize:function(e){d(e)},reset:function(){n={},i=0,o=0}})},qq.PasteSupport=function(e){"use strict";function t(e){return e.type&&0===e.type.indexOf("image/")}function n(){r=qq(o.targetElement).attach("paste",function(e){var n=e.clipboardData;n&&qq.each(n.items,function(e,n){if(t(n)){var i=n.getAsFile();o.callbacks.pasteReceived(i)}})})}function i(){r&&r()}var o,r;o={targetElement:null,callbacks:{log:function(e,t){},pasteReceived:function(e){}}},qq.extend(o,e),n(),qq.extend(this,{reset:function(){i()}})},qq.FormSupport=function(e,t,n){"use strict";function i(e){e.getAttribute("action")&&(s.newEndpoint=e.getAttribute("action"))}function o(e,t){return!(e.checkValidity&&!e.checkValidity())||(n("Form did not pass validation checks - will not upload.","error"),void t())}function r(e){var n=e.submit;
qq(e).attach("submit",function(i){i=i||window.event,i.preventDefault?i.preventDefault():i.returnValue=!1,o(e,n)&&t()}),e.submit=function(){o(e,n)&&t()}}function a(e){return e&&(qq.isString(e)&&(e=document.getElementById(e)),e&&(n("Attaching to form element."),i(e),l&&r(e))),e}var s=this,l=e.interceptSubmit,u=e.element,c=e.autoUpload;qq.extend(this,{newEndpoint:null,newAutoUpload:c,attachedToForm:!1,getFormInputsAsObject:function(){return null==u?null:s._form2Obj(u)}}),u=a(u),this.attachedToForm=!!u},qq.extend(qq.FormSupport.prototype,{_form2Obj:function(e){"use strict";var t={},n=function(e){var t=["button","image","reset","submit"];return qq.indexOf(t,e.toLowerCase())<0},i=function(e){return qq.indexOf(["checkbox","radio"],e.toLowerCase())>=0},o=function(e){return!(!i(e.type)||e.checked)||e.disabled&&"hidden"!==e.type.toLowerCase()},r=function(e){var t=null;return qq.each(qq(e).children(),function(e,n){if("option"===n.tagName.toLowerCase()&&n.selected)return t=n.value,!1}),t};return qq.each(e.elements,function(e,i){if(!qq.isInput(i,!0)&&"textarea"!==i.tagName.toLowerCase()||!n(i.type)||o(i)){if("select"===i.tagName.toLowerCase()&&!o(i)){var a=r(i);null!==a&&(t[i.name]=a)}}else t[i.name]=i.value}),t}}),qq.traditional=qq.traditional||{},qq.traditional.FormUploadHandler=function(e,t){"use strict";function n(e,t){var n,i,r;try{i=t.contentDocument||t.contentWindow.document,r=i.body.innerHTML,s("converting iframe's innerHTML to JSON"),s("innerHTML = "+r),r&&r.match(/^<pre/i)&&(r=i.body.firstChild.firstChild.nodeValue),n=o._parseJsonResponse(r)}catch(e){s("Error when attempting to parse form upload response ("+e.message+")","error"),n={success:!1}}return n}function i(t,n){var i=e.paramsStore.get(t),s="get"===e.method.toLowerCase()?"GET":"POST",l=e.endpointStore.get(t),u=r(t);return i[e.uuidName]=a(t),i[e.filenameParam]=u,o._initFormForUpload({method:s,endpoint:l,params:i,paramsInBody:e.paramsInBody,targetName:n.name})}var o=this,r=t.getName,a=t.getUuid,s=t.log;this.uploadFile=function(t){var r,a=o.getInput(t),l=o._createIframe(t),u=new qq.Promise;return r=i(t,l),r.appendChild(a),o._attachLoadEvent(l,function(i){s("iframe loaded");var r=i?i:n(t,l);o._detachLoadEvent(t),e.cors.expected||qq(l).remove(),r.success?u.success(r):u.failure(r)}),s("Sending upload request for "+t),r.submit(),qq(r).remove(),u},qq.extend(this,new qq.FormUploadHandler({options:{isCors:e.cors.expected,inputName:e.inputName},proxy:{onCancel:e.onCancel,getName:r,getUuid:a,log:s}}))},qq.traditional=qq.traditional||{},qq.traditional.XhrUploadHandler=function(e,t){"use strict";var n=this,i=t.getName,o=t.getSize,r=t.getUuid,a=t.log,s=e.forceMultipart||e.paramsInBody,l=function(t,n,r){var a=o(t),l=i(t);n[e.chunking.paramNames.partIndex]=r.part,n[e.chunking.paramNames.partByteOffset]=r.start,n[e.chunking.paramNames.chunkSize]=r.size,n[e.chunking.paramNames.totalParts]=r.count,n[e.totalFileSizeName]=a,s&&(n[e.filenameParam]=l)},u=new qq.traditional.AllChunksDoneAjaxRequester({cors:e.cors,endpoint:e.chunking.success.endpoint,log:a}),c=function(e,t){var n=new qq.Promise;return t.onreadystatechange=function(){if(4===t.readyState){var i=h(e,t);i.success?n.success(i.response,t):n.failure(i.response,t)}},n},d=function(t){var a=e.paramsStore.get(t),s=i(t),l=o(t);return a[e.uuidName]=r(t),a[e.filenameParam]=s,a[e.totalFileSizeName]=l,a[e.chunking.paramNames.totalParts]=n._getTotalChunks(t),a},p=function(e,t){return qq.indexOf([200,201,202,203,204],e.status)<0||!t.success||t.reset},h=function(e,t){var n;return a("xhr - server response received for "+e),a("responseText = "+t.responseText),n=q(!0,t),{success:!p(t,n),response:n}},q=function(e,t){var n={};try{a(qq.format("Received response status {} with body: {}",t.status,t.responseText)),n=qq.parseJson(t.responseText)}catch(t){e&&a("Error when attempting to parse xhr response text ("+t.message+")","error")}return n},f=function(t){var i=new qq.Promise;return u.complete(t,n._createXhr(t),d(t),e.customHeaders.get(t)).then(function(e){i.success(q(!1,e),e)},function(e){i.failure(q(!1,e),e)}),i},m=function(t,n,a,l){var u=new FormData,c=e.method,d=e.endpointStore.get(l),p=i(l),h=o(l);return t[e.uuidName]=r(l),t[e.filenameParam]=p,s&&(t[e.totalFileSizeName]=h),e.paramsInBody||(s||(t[e.inputName]=p),d=qq.obj2url(t,d)),n.open(c,d,!0),e.cors.expected&&e.cors.sendCredentials&&(n.withCredentials=!0),s?(e.paramsInBody&&qq.obj2FormData(t,u),u.append(e.inputName,a),u):a},g=function(t,i){var o=e.customHeaders.get(t),r=n.getFile(t);i.setRequestHeader("Accept","application/json"),i.setRequestHeader("X-Requested-With","XMLHttpRequest"),i.setRequestHeader("Cache-Control","no-cache"),s||(i.setRequestHeader("Content-Type","application/octet-stream"),i.setRequestHeader("X-Mime-Type",r.type)),qq.each(o,function(e,t){i.setRequestHeader(e,t)})};qq.extend(this,{uploadChunk:function(t,i,r){var a,s,u,d=n._getChunkData(t,i),p=n._createXhr(t,i);o(t);return a=c(t,p),n._registerProgressHandler(t,i,d.size),u=e.paramsStore.get(t),l(t,u,d),r&&(u[e.resume.paramNames.resuming]=!0),s=m(u,p,d.blob,t),g(t,p),p.send(s),a},uploadFile:function(t){var i,o,r,a,s=n.getFile(t);return o=n._createXhr(t),n._registerProgressHandler(t),i=c(t,o),r=e.paramsStore.get(t),a=m(r,o,s,t),g(t,o),o.send(a),i}}),qq.extend(this,new qq.XhrUploadHandler({options:qq.extend({namespace:"traditional"},e),proxy:qq.extend({getEndpoint:e.endpointStore.get},t)})),qq.override(this,function(t){return{finalizeChunks:function(n){return e.chunking.success.endpoint?f(n):t.finalizeChunks(n,qq.bind(q,this,!0))}}})},qq.traditional.AllChunksDoneAjaxRequester=function(e){"use strict";var t,n="POST",i={cors:{allowXdr:!1,expected:!1,sendCredentials:!1},endpoint:null,log:function(e,t){}},o={},r={get:function(e){return i.endpoint}};qq.extend(i,e),t=qq.extend(this,new qq.AjaxRequester({acceptHeader:"application/json",validMethods:[n],method:n,endpointStore:r,allowXRequestedWithAndCacheControl:!1,cors:i.cors,log:i.log,onComplete:function(e,t,n){var i=o[e];delete o[e],n?i.failure(t):i.success(t)}})),qq.extend(this,{complete:function(e,n,r,a){var s=new qq.Promise;return i.log("Submitting All Chunks Done request for "+e),o[e]=s,t.initTransport(e).withParams(r).withHeaders(a).send(n),s}})},qq.DragAndDrop=function(e){"use strict";function t(e,t){var n=Array.prototype.slice.call(e);u.callbacks.dropLog("Grabbed "+e.length+" dropped files."),t.dropDisabled(!1),u.callbacks.processingDroppedFilesComplete(n,t.getElement())}function n(e){var t=new qq.Promise;return e.isFile?e.file(function(n){var i=e.name,o=e.fullPath,r=o.indexOf(i);o=o.substr(0,r),"/"===o.charAt(0)&&(o=o.substr(1)),n.qqPath=o,h.push(n),t.success()},function(n){u.callbacks.dropLog("Problem parsing '"+e.fullPath+"'.  FileError code "+n.code+".","error"),t.failure()}):e.isDirectory&&i(e).then(function(e){var i=e.length;qq.each(e,function(e,o){n(o).done(function(){i-=1,0===i&&t.success()})}),e.length||t.success()},function(n){u.callbacks.dropLog("Problem parsing '"+e.fullPath+"'.  FileError code "+n.code+".","error"),t.failure()}),t}function i(e,t,n,o){var r=o||new qq.Promise,a=t||e.createReader();return a.readEntries(function(t){var o=n?n.concat(t):t;t.length?setTimeout(function(){i(e,a,o,r)},0):r.success(o)},r.failure),r}function o(e,t){var i=[],o=new qq.Promise;return u.callbacks.processingDroppedFiles(),t.dropDisabled(!0),e.files.length>1&&!u.allowMultipleItems?(u.callbacks.processingDroppedFilesComplete([]),u.callbacks.dropError("tooManyFilesError",""),t.dropDisabled(!1),o.failure()):(h=[],qq.isFolderDropSupported(e)?qq.each(e.items,function(e,t){var r=t.webkitGetAsEntry();r&&(r.isFile?h.push(t.getAsFile()):i.push(n(r).done(function(){i.pop(),0===i.length&&o.success()})))}):h=e.files,0===i.length&&o.success()),o}function r(e){var n=new qq.UploadDropZone({HIDE_ZONES_EVENT_NAME:c,element:e,onEnter:function(t){qq(e).addClass(u.classes.dropActive),t.stopPropagation()},onLeaveNotDescendants:function(t){qq(e).removeClass(u.classes.dropActive)},onDrop:function(e){o(e.dataTransfer,n).then(function(){t(h,n)},function(){u.callbacks.dropLog("Drop event DataTransfer parsing failed.  No files will be uploaded.","error")})}});return q.addDisposer(function(){n.dispose()}),qq(e).hasAttribute(d)&&qq(e).hide(),p.push(n),n}function a(e){var t;return qq.each(e.dataTransfer.types,function(e,n){if("Files"===n)return t=!0,!1}),t}function s(e){return qq.firefox()?!e.relatedTarget:qq.safari()?e.x<0||e.y<0:0===e.x&&0===e.y}function l(){var e=u.dropZoneElements,t=function(){setTimeout(function(){qq.each(e,function(e,t){qq(t).hasAttribute(d)&&qq(t).hide(),qq(t).removeClass(u.classes.dropActive)})},10)};qq.each(e,function(t,n){var i=r(n);e.length&&qq.supportedFeatures.fileDrop&&q.attach(document,"dragenter",function(t){!i.dropDisabled()&&a(t)&&qq.each(e,function(e,t){t instanceof HTMLElement&&qq(t).hasAttribute(d)&&qq(t).css({display:"block"})})})}),q.attach(document,"dragleave",function(e){s(e)&&t()}),q.attach(qq(document).children()[0],"mouseenter",function(e){t()}),q.attach(document,"drop",function(e){e.preventDefault(),t()}),q.attach(document,c,t)}var u,c="qq-hidezones",d="qq-hide-dropzone",p=[],h=[],q=new qq.DisposeSupport;u={dropZoneElements:[],allowMultipleItems:!0,classes:{dropActive:null},callbacks:new qq.DragAndDrop.callbacks},qq.extend(u,e,!0),l(),qq.extend(this,{setupExtraDropzone:function(e){u.dropZoneElements.push(e),r(e)},removeDropzone:function(e){var t,n=u.dropZoneElements;for(t in n)if(n[t]===e)return n.splice(t,1)},dispose:function(){q.dispose(),qq.each(p,function(e,t){t.dispose()})}})},qq.DragAndDrop.callbacks=function(){"use strict";return{processingDroppedFiles:function(){},processingDroppedFilesComplete:function(e,t){},dropError:function(e,t){qq.log("Drag & drop error code '"+e+" with these specifics: '"+t+"'","error")},dropLog:function(e,t){qq.log(e,t)}}},qq.UploadDropZone=function(e){"use strict";function t(){return qq.safari()||qq.firefox()&&qq.windows()}function n(e){c||(t?d.attach(document,"dragover",function(e){e.preventDefault()}):d.attach(document,"dragover",function(e){e.dataTransfer&&(e.dataTransfer.dropEffect="none",e.preventDefault())}),c=!0)}function i(e){if(!qq.supportedFeatures.fileDrop)return!1;var t,n=e.dataTransfer,i=qq.safari();return t=!(!qq.ie()||!qq.supportedFeatures.fileDrop)||"none"!==n.effectAllowed,n&&t&&(n.files||!i&&n.types.contains&&n.types.contains("Files"))}function o(e){return void 0!==e&&(u=e),u}function r(){function e(){t=document.createEvent("Event"),t.initEvent(s.HIDE_ZONES_EVENT_NAME,!0,!0)}var t;if(window.CustomEvent)try{t=new CustomEvent(s.HIDE_ZONES_EVENT_NAME)}catch(t){e()}else e();document.dispatchEvent(t)}function a(){d.attach(l,"dragover",function(e){if(i(e)){var t=qq.ie()&&qq.supportedFeatures.fileDrop?null:e.dataTransfer.effectAllowed;"move"===t||"linkMove"===t?e.dataTransfer.dropEffect="move":e.dataTransfer.dropEffect="copy",e.stopPropagation(),e.preventDefault()}}),d.attach(l,"dragenter",function(e){if(!o()){if(!i(e))return;s.onEnter(e)}}),d.attach(l,"dragleave",function(e){if(i(e)){s.onLeave(e);var t=document.elementFromPoint(e.clientX,e.clientY);qq(this).contains(t)||s.onLeaveNotDescendants(e)}}),d.attach(l,"drop",function(e){if(!o()){if(!i(e))return;e.preventDefault(),e.stopPropagation(),s.onDrop(e),r()}})}var s,l,u,c,d=new qq.DisposeSupport;s={element:null,onEnter:function(e){},onLeave:function(e){},onLeaveNotDescendants:function(e){},onDrop:function(e){}},qq.extend(s,e),l=s.element,n(),a(),qq.extend(this,{dropDisabled:function(e){return o(e)},dispose:function(){d.dispose()},getElement:function(){return l}})},function(){"use strict";qq.uiPublicApi={addInitialFiles:function(e){this._parent.prototype.addInitialFiles.apply(this,arguments),this._templating.addCacheToDom()},clearStoredFiles:function(){this._parent.prototype.clearStoredFiles.apply(this,arguments),this._templating.clearFiles()},addExtraDropzone:function(e){this._dnd&&this._dnd.setupExtraDropzone(e)},removeExtraDropzone:function(e){if(this._dnd)return this._dnd.removeDropzone(e)},getItemByFileId:function(e){if(!this._templating.isHiddenForever(e))return this._templating.getFileContainer(e)},reset:function(){this._parent.prototype.reset.apply(this,arguments),this._templating.reset(),!this._options.button&&this._templating.getButton()&&(this._defaultButtonId=this._createUploadButton({element:this._templating.getButton(),title:this._options.text.fileInputTitle}).getButtonId()),this._dnd&&(this._dnd.dispose(),this._dnd=this._setupDragAndDrop()),this._totalFilesInBatch=0,this._filesInBatchAddedToUi=0,this._setupClickAndEditEventHandlers()},setName:function(e,t){var n=this._options.formatFileName(t);this._parent.prototype.setName.apply(this,arguments),this._templating.updateFilename(e,n)},pauseUpload:function(e){var t=this._parent.prototype.pauseUpload.apply(this,arguments);return t&&this._templating.uploadPaused(e),t},continueUpload:function(e){var t=this._parent.prototype.continueUpload.apply(this,arguments);return t&&this._templating.uploadContinued(e),t},getId:function(e){return this._templating.getFileId(e)},getDropTarget:function(e){var t=this.getFile(e);return t.qqDropTarget}},qq.uiPrivateApi={_getButton:function(e){var t=this._parent.prototype._getButton.apply(this,arguments);return t||e===this._defaultButtonId&&(t=this._templating.getButton()),t},_removeFileItem:function(e){this._templating.removeFile(e)},_setupClickAndEditEventHandlers:function(){this._fileButtonsClickHandler=qq.FileButtonsClickHandler&&this._bindFileButtonsClickEvent(),this._focusinEventSupported=!qq.firefox(),this._isEditFilenameEnabled()&&(this._filenameClickHandler=this._bindFilenameClickEvent(),this._filenameInputFocusInHandler=this._bindFilenameInputFocusInEvent(),this._filenameInputFocusHandler=this._bindFilenameInputFocusEvent())},_setupDragAndDrop:function(){var e=this,t=this._options.dragAndDrop.extraDropzones,n=this._templating,i=n.getDropZone();return i&&t.push(i),new qq.DragAndDrop({dropZoneElements:t,allowMultipleItems:this._options.multiple,classes:{dropActive:this._options.classes.dropActive},callbacks:{processingDroppedFiles:function(){n.showDropProcessing()},processingDroppedFilesComplete:function(t,i){n.hideDropProcessing(),qq.each(t,function(e,t){t.qqDropTarget=i}),t.length&&e.addFiles(t,null,null)},dropError:function(t,n){e._itemError(t,n)},dropLog:function(t,n){e.log(t,n)}}})},_bindFileButtonsClickEvent:function(){var e=this;return new qq.FileButtonsClickHandler({templating:this._templating,log:function(t,n){e.log(t,n)},onDeleteFile:function(t){e.deleteFile(t)},onCancel:function(t){e.cancel(t)},onRetry:function(t){e.retry(t)},onPause:function(t){e.pauseUpload(t)},onContinue:function(t){e.continueUpload(t)},onGetName:function(t){return e.getName(t)}})},_isEditFilenameEnabled:function(){return this._templating.isEditFilenamePossible()&&!this._options.autoUpload&&qq.FilenameClickHandler&&qq.FilenameInputFocusHandler&&qq.FilenameInputFocusHandler},_filenameEditHandler:function(){var e=this,t=this._templating;return{templating:t,log:function(t,n){e.log(t,n)},onGetUploadStatus:function(t){return e.getUploads({id:t}).status},onGetName:function(t){return e.getName(t)},onSetName:function(t,n){e.setName(t,n)},onEditingStatusChange:function(e,n){var i=qq(t.getEditInput(e)),o=qq(t.getFileContainer(e));n?(i.addClass("qq-editing"),t.hideFilename(e),t.hideEditIcon(e)):(i.removeClass("qq-editing"),t.showFilename(e),t.showEditIcon(e)),o.addClass("qq-temp").removeClass("qq-temp")}}},_onUploadStatusChange:function(e,t,n){this._parent.prototype._onUploadStatusChange.apply(this,arguments),this._isEditFilenameEnabled()&&this._templating.getFileContainer(e)&&n!==qq.status.SUBMITTED&&(this._templating.markFilenameEditable(e),this._templating.hideEditIcon(e)),t===qq.status.UPLOAD_RETRYING&&n===qq.status.UPLOADING?(this._templating.hideRetry(e),this._templating.setStatusText(e),qq(this._templating.getFileContainer(e)).removeClass(this._classes.retrying)):n===qq.status.UPLOAD_FAILED&&this._templating.hidePause(e)},_bindFilenameInputFocusInEvent:function(){var e=qq.extend({},this._filenameEditHandler());return new qq.FilenameInputFocusInHandler(e)},_bindFilenameInputFocusEvent:function(){var e=qq.extend({},this._filenameEditHandler());return new qq.FilenameInputFocusHandler(e)},_bindFilenameClickEvent:function(){var e=qq.extend({},this._filenameEditHandler());return new qq.FilenameClickHandler(e)},_storeForLater:function(e){this._parent.prototype._storeForLater.apply(this,arguments),this._templating.hideSpinner(e)},_onAllComplete:function(e,t){this._parent.prototype._onAllComplete.apply(this,arguments),this._templating.resetTotalProgress()},_onSubmit:function(e,t){var n=this.getFile(e);n&&n.qqPath&&this._options.dragAndDrop.reportDirectoryPaths&&this._paramsStore.addReadOnly(e,{qqpath:n.qqPath}),this._parent.prototype._onSubmit.apply(this,arguments),this._addToList(e,t)},_onSubmitted:function(e){this._isEditFilenameEnabled()&&(this._templating.markFilenameEditable(e),this._templating.showEditIcon(e),this._focusinEventSupported||this._filenameInputFocusHandler.addHandler(this._templating.getEditInput(e)))},_onProgress:function(e,t,n,i){this._parent.prototype._onProgress.apply(this,arguments),this._templating.updateProgress(e,n,i),0===i||100===Math.round(n/i*100)?(this._templating.hideCancel(e),this._templating.hidePause(e),this._templating.hideProgress(e),this._templating.setStatusText(e,this._options.text.waitingForResponse),this._displayFileSize(e)):this._displayFileSize(e,n,i)},_onTotalProgress:function(e,t){this._parent.prototype._onTotalProgress.apply(this,arguments),this._templating.updateTotalProgress(e,t)},_onComplete:function(e,t,n,i){function o(t){s&&(a.setStatusText(e),qq(s).removeClass(l._classes.retrying),a.hideProgress(e),l.getUploads({id:e}).status!==qq.status.UPLOAD_FAILED&&a.hideCancel(e),a.hideSpinner(e),t.success?l._markFileAsSuccessful(e):(qq(s).addClass(l._classes.fail),a.showCancel(e),a.isRetryPossible()&&!l._preventRetries[e]&&(qq(s).addClass(l._classes.retryable),a.showRetry(e)),l._controlFailureTextDisplay(e,t)))}var r=this._parent.prototype._onComplete.apply(this,arguments),a=this._templating,s=a.getFileContainer(e),l=this;return r instanceof qq.Promise?r.done(function(e){o(e)}):o(n),r},_markFileAsSuccessful:function(e){var t=this._templating;this._isDeletePossible()&&t.showDeleteButton(e),qq(t.getFileContainer(e)).addClass(this._classes.success),this._maybeUpdateThumbnail(e)},_onUploadPrep:function(e){this._parent.prototype._onUploadPrep.apply(this,arguments),this._templating.showSpinner(e)},_onUpload:function(e,t){var n=this._parent.prototype._onUpload.apply(this,arguments);return this._templating.showSpinner(e),n},_onUploadChunk:function(e,t){this._parent.prototype._onUploadChunk.apply(this,arguments),t.partIndex>0&&this._handler.isResumable(e)&&this._templating.allowPause(e)},_onCancel:function(e,t){this._parent.prototype._onCancel.apply(this,arguments),this._removeFileItem(e),0===this._getNotFinished()&&this._templating.resetTotalProgress()},_onBeforeAutoRetry:function(e){var t,n,i;this._parent.prototype._onBeforeAutoRetry.apply(this,arguments),this._showCancelLink(e),this._options.retry.showAutoRetryNote&&(t=this._autoRetries[e],n=this._options.retry.maxAutoAttempts,i=this._options.retry.autoRetryNote.replace(/\{retryNum\}/g,t),i=i.replace(/\{maxAuto\}/g,n),this._templating.setStatusText(e,i),qq(this._templating.getFileContainer(e)).addClass(this._classes.retrying))},_onBeforeManualRetry:function(e){return this._parent.prototype._onBeforeManualRetry.apply(this,arguments)?(this._templating.resetProgress(e),qq(this._templating.getFileContainer(e)).removeClass(this._classes.fail),this._templating.setStatusText(e),this._templating.showSpinner(e),this._showCancelLink(e),!0):(qq(this._templating.getFileContainer(e)).addClass(this._classes.retryable),this._templating.showRetry(e),!1)},_onSubmitDelete:function(e){var t=qq.bind(this._onSubmitDeleteSuccess,this);this._parent.prototype._onSubmitDelete.call(this,e,t)},_onSubmitDeleteSuccess:function(e,t,n){this._options.deleteFile.forceConfirm?this._showDeleteConfirm.apply(this,arguments):this._sendDeleteRequest.apply(this,arguments)},_onDeleteComplete:function(e,t,n){this._parent.prototype._onDeleteComplete.apply(this,arguments),this._templating.hideSpinner(e),n?(this._templating.setStatusText(e,this._options.deleteFile.deletingFailedText),this._templating.showDeleteButton(e)):this._removeFileItem(e)},_sendDeleteRequest:function(e,t,n){this._templating.hideDeleteButton(e),this._templating.showSpinner(e),this._templating.setStatusText(e,this._options.deleteFile.deletingStatusText),this._deleteHandler.sendDelete.apply(this,arguments)},_showDeleteConfirm:function(e,t,n){var i,o=this.getName(e),r=this._options.deleteFile.confirmMessage.replace(/\{filename\}/g,o),a=(this.getUuid(e),arguments),s=this;i=this._options.showConfirm(r),qq.isGenericPromise(i)?i.then(function(){s._sendDeleteRequest.apply(s,a)}):i!==!1&&s._sendDeleteRequest.apply(s,a)},_addToList:function(e,t,n){var i,o,r=0,a=this._handler.isProxied(e)&&this._options.scaling.hideScaled;this._options.display.prependFiles&&(this._totalFilesInBatch>1&&this._filesInBatchAddedToUi>0&&(r=this._filesInBatchAddedToUi-1),i={index:r}),n||(this._options.disableCancelForFormUploads&&!qq.supportedFeatures.ajaxUploading&&this._templating.disableCancel(),this._options.multiple||(o=this.getUploads({id:e}),this._handledProxyGroup=this._handledProxyGroup||o.proxyGroupId,o.proxyGroupId===this._handledProxyGroup&&o.proxyGroupId||(this._handler.cancelAll(),this._clearList(),this._handledProxyGroup=null))),n?(this._templating.addFileToCache(e,this._options.formatFileName(t),i,a),this._templating.updateThumbnail(e,this._thumbnailUrls[e],!0,this._options.thumbnails.customResizer)):(this._templating.addFile(e,this._options.formatFileName(t),i,a),this._templating.generatePreview(e,this.getFile(e),this._options.thumbnails.customResizer)),this._filesInBatchAddedToUi+=1,(n||this._options.display.fileSizeOnSubmit&&qq.supportedFeatures.ajaxUploading)&&this._displayFileSize(e)},_clearList:function(){this._templating.clearFiles(),this.clearStoredFiles()},_displayFileSize:function(e,t,n){var i=this.getSize(e),o=this._formatSize(i);i>=0&&(void 0!==t&&void 0!==n&&(o=this._formatProgress(t,n)),this._templating.updateSize(e,o))},_formatProgress:function(e,t){function n(e,t){i=i.replace(e,t)}var i=this._options.text.formatProgress;return n("{percent}",Math.round(e/t*100)),n("{total_size}",this._formatSize(t)),i},_controlFailureTextDisplay:function(e,t){var n,i,o;n=this._options.failedUploadTextDisplay.mode,i=this._options.failedUploadTextDisplay.responseProperty,"custom"===n?(o=t[i],o||(o=this._options.text.failUpload),this._templating.setStatusText(e,o),this._options.failedUploadTextDisplay.enableTooltip&&this._showTooltip(e,o)):"default"===n?this._templating.setStatusText(e,this._options.text.failUpload):"none"!==n&&this.log("failedUploadTextDisplay.mode value of '"+n+"' is not valid","warn")},_showTooltip:function(e,t){this._templating.getFileContainer(e).title=t},_showCancelLink:function(e){this._options.disableCancelForFormUploads&&!qq.supportedFeatures.ajaxUploading||this._templating.showCancel(e)},_itemError:function(e,t,n){var i=this._parent.prototype._itemError.apply(this,arguments);this._options.showMessage(i)},_batchError:function(e){this._parent.prototype._batchError.apply(this,arguments),this._options.showMessage(e)},_setupPastePrompt:function(){var e=this;this._options.callbacks.onPasteReceived=function(){var t=e._options.paste.namePromptMessage,n=e._options.paste.defaultName;return e._options.showPrompt(t,n)}},_fileOrBlobRejected:function(e,t){this._totalFilesInBatch-=1,this._parent.prototype._fileOrBlobRejected.apply(this,arguments)},_prepareItemsForUpload:function(e,t,n){this._totalFilesInBatch=e.length,this._filesInBatchAddedToUi=0,this._parent.prototype._prepareItemsForUpload.apply(this,arguments)},_maybeUpdateThumbnail:function(e){var t=this._thumbnailUrls[e],n=this.getUploads({id:e}).status;n===qq.status.DELETED||!t&&!this._options.thumbnails.placeholders.waitUntilResponse&&qq.supportedFeatures.imagePreviews||this._templating.updateThumbnail(e,t,this._options.thumbnails.customResizer)},_addCannedFile:function(e){var t=this._parent.prototype._addCannedFile.apply(this,arguments);return this._addToList(t,this.getName(t),!0),this._templating.hideSpinner(t),this._templating.hideCancel(t),this._markFileAsSuccessful(t),t},_setSize:function(e,t){this._parent.prototype._setSize.apply(this,arguments),this._templating.updateSize(e,this._formatSize(t))},_sessionRequestComplete:function(){this._templating.addCacheToDom(),this._parent.prototype._sessionRequestComplete.apply(this,arguments)}}}(),qq.FineUploader=function(e,t){"use strict";var n=this;this._parent=t?qq[t].FineUploaderBasic:qq.FineUploaderBasic,this._parent.apply(this,arguments),qq.extend(this._options,{element:null,button:null,listElement:null,dragAndDrop:{extraDropzones:[],reportDirectoryPaths:!1},text:{formatProgress:"{percent}% of {total_size}",failUpload:"Upload failed",waitingForResponse:"Processing...",paused:"Paused"},template:"qq-template",classes:{retrying:"qq-upload-retrying",retryable:"qq-upload-retryable",success:"qq-upload-success",fail:"qq-upload-fail",editable:"qq-editable",hide:"qq-hide",dropActive:"qq-upload-drop-area-active"},failedUploadTextDisplay:{mode:"default",responseProperty:"error",enableTooltip:!0},messages:{tooManyFilesError:"You may only drop one file",unsupportedBrowser:"Unrecoverable error - this browser does not permit file uploading of any kind."},retry:{showAutoRetryNote:!0,autoRetryNote:"Retrying {retryNum}/{maxAuto}..."},deleteFile:{forceConfirm:!1,confirmMessage:"Are you sure you want to delete {filename}?",deletingStatusText:"Deleting...",deletingFailedText:"Delete failed"},display:{fileSizeOnSubmit:!1,prependFiles:!1},paste:{promptForName:!1,namePromptMessage:"Please name this image"},thumbnails:{customResizer:null,maxCount:0,placeholders:{waitUntilResponse:!1,notAvailablePath:null,waitingPath:null},timeBetweenThumbs:750},scaling:{hideScaled:!1},showMessage:function(e){return n._templating.hasDialog("alert")?n._templating.showDialog("alert",e):void setTimeout(function(){window.alert(e)},0)},showConfirm:function(e){return n._templating.hasDialog("confirm")?n._templating.showDialog("confirm",e):window.confirm(e)},showPrompt:function(e,t){return n._templating.hasDialog("prompt")?n._templating.showDialog("prompt",e,t):window.prompt(e,t)}},!0),qq.extend(this._options,e,!0),this._templating=new qq.Templating({log:qq.bind(this.log,this),templateIdOrEl:this._options.template,containerEl:this._options.element,fileContainerEl:this._options.listElement,button:this._options.button,imageGenerator:this._imageGenerator,classes:{hide:this._options.classes.hide,editable:this._options.classes.editable},limits:{maxThumbs:this._options.thumbnails.maxCount,timeBetweenThumbs:this._options.thumbnails.timeBetweenThumbs},placeholders:{waitUntilUpdate:this._options.thumbnails.placeholders.waitUntilResponse,thumbnailNotAvailable:this._options.thumbnails.placeholders.notAvailablePath,waitingForThumbnail:this._options.thumbnails.placeholders.waitingPath},text:this._options.text}),this._options.workarounds.ios8SafariUploads&&qq.ios800()&&qq.iosSafari()?this._templating.renderFailure(this._options.messages.unsupportedBrowserIos8Safari):!qq.supportedFeatures.uploading||this._options.cors.expected&&!qq.supportedFeatures.uploadCors?this._templating.renderFailure(this._options.messages.unsupportedBrowser):(this._wrapCallbacks(),this._templating.render(),this._classes=this._options.classes,!this._options.button&&this._templating.getButton()&&(this._defaultButtonId=this._createUploadButton({element:this._templating.getButton(),title:this._options.text.fileInputTitle}).getButtonId()),this._setupClickAndEditEventHandlers(),qq.DragAndDrop&&qq.supportedFeatures.fileDrop&&(this._dnd=this._setupDragAndDrop()),this._options.paste.targetElement&&this._options.paste.promptForName&&(qq.PasteSupport?this._setupPastePrompt():this.log("Paste support module not found.","error")),this._totalFilesInBatch=0,this._filesInBatchAddedToUi=0)},qq.extend(qq.FineUploader.prototype,qq.basePublicApi),qq.extend(qq.FineUploader.prototype,qq.basePrivateApi),qq.extend(qq.FineUploader.prototype,qq.uiPublicApi),qq.extend(qq.FineUploader.prototype,qq.uiPrivateApi),qq.Templating=function(e){"use strict";var t,n,i,o,r,a,s,l,u="qq-file-id",c="qq-file-id-",d="qq-max-size",p="qq-server-scale",h="qq-hide-dropzone",q="qq-drop-area-text",f="qq-in-progress",m="qq-hidden-forever",g={content:document.createDocumentFragment(),map:{}},_=!1,v=0,b=!1,y=[],S=-1,w={log:null,limits:{maxThumbs:0,timeBetweenThumbs:750},templateIdOrEl:"qq-template",containerEl:null,fileContainerEl:null,button:null,imageGenerator:null,classes:{hide:"qq-hide",editable:"qq-editable"},placeholders:{waitUntilUpdate:!1,thumbnailNotAvailable:null,waitingForThumbnail:null},text:{paused:"Paused"}},F={button:"qq-upload-button-selector",alertDialog:"qq-alert-dialog-selector",dialogCancelButton:"qq-cancel-button-selector",confirmDialog:"qq-confirm-dialog-selector",dialogMessage:"qq-dialog-message-selector",dialogOkButton:"qq-ok-button-selector",promptDialog:"qq-prompt-dialog-selector",uploader:"qq-uploader-selector",drop:"qq-upload-drop-area-selector",list:"qq-upload-list-selector",progressBarContainer:"qq-progress-bar-container-selector",progressBar:"qq-progress-bar-selector",totalProgressBarContainer:"qq-total-progress-bar-container-selector",totalProgressBar:"qq-total-progress-bar-selector",file:"qq-upload-file-selector",spinner:"qq-upload-spinner-selector",size:"qq-upload-size-selector",cancel:"qq-upload-cancel-selector",pause:"qq-upload-pause-selector",continueButton:"qq-upload-continue-selector",deleteButton:"qq-upload-delete-selector",retry:"qq-upload-retry-selector",statusText:"qq-upload-status-text-selector",editFilenameInput:"qq-edit-filename-selector",editNameIcon:"qq-edit-filename-icon-selector",dropText:"qq-upload-drop-area-text-selector",dropProcessing:"qq-drop-processing-selector",dropProcessingSpinner:"qq-drop-processing-spinner-selector",thumbnail:"qq-thumbnail-selector"},x={},C=new qq.Promise,E=new qq.Promise,I=function(){var e=w.placeholders.thumbnailNotAvailable,n=w.placeholders.waitingForThumbnail,i={maxSize:S,scale:l};s&&(e?w.imageGenerator.generate(e,new Image,i).then(function(e){C.success(e)},function(){C.failure(),t("Problem loading 'not available' placeholder image at "+e,"error")}):C.failure(),n?w.imageGenerator.generate(n,new Image,i).then(function(e){E.success(e)},function(){E.failure(),t("Problem loading 'waiting for thumbnail' placeholder image at "+n,"error")}):E.failure())},P=function(e){var t=new qq.Promise;return E.then(function(n){Q(n,e),e.src?t.success():(e.src=n.src,e.onload=function(){e.onload=null,te(e),t.success()})},function(){W(e),t.success()}),t},D=function(e,n,i){var o=X(e);return t("Generating new thumbnail for "+e),n.qqThumbnailId=e,w.imageGenerator.generate(n,o,i).then(function(){v++,te(o),x[e].success()},function(){x[e].failure(),w.placeholders.waitUntilUpdate||Y(e,o)})},T=function(){if(y.length){b=!0;var e=y.shift();e.update?$(e):K(e)}else b=!1},U=function(e){return V(L(e),F.cancel)},k=function(e){return V(L(e),F.continueButton)},A=function(e){return V(r,F[e+"Dialog"])},R=function(e){return V(L(e),F.deleteButton)},B=function(){return V(r,F.dropProcessing)},N=function(e){return V(L(e),F.editNameIcon)},L=function(e){return g.map[e]||qq(a).getFirstByClass(c+e)},O=function(e){return V(L(e),F.file)},H=function(e){return V(L(e),F.pause)},z=function(e){return null==e?V(r,F.totalProgressBarContainer)||V(r,F.totalProgressBar):V(L(e),F.progressBarContainer)||V(L(e),F.progressBar)},M=function(e){return V(L(e),F.retry)},j=function(e){return V(L(e),F.size)},G=function(e){return V(L(e),F.spinner)},V=function(e,t){return e&&qq(e).getFirstByClass(t)},X=function(e){return s&&V(L(e),F.thumbnail)},W=function(e){e&&qq(e).addClass(w.classes.hide)},Q=function(e,t){
var n=e.style.maxWidth,i=e.style.maxHeight;i&&n&&!t.style.maxWidth&&!t.style.maxHeight&&qq(t).css({maxWidth:n,maxHeight:i})},Y=function(e,t){var n=x[e]||(new qq.Promise).failure(),i=new qq.Promise;return C.then(function(e){n.then(function(){i.success()},function(){Q(e,t),t.onload=function(){t.onload=null,i.success()},t.src=e.src,te(t)})}),i},J=function(){var e,o,r,a,u,c,f,m,g,_,v;if(t("Parsing template"),null==w.templateIdOrEl)throw new Error("You MUST specify either a template element or ID!");if(qq.isString(w.templateIdOrEl)){if(e=document.getElementById(w.templateIdOrEl),null===e)throw new Error(qq.format("Cannot find template script at ID '{}'!",w.templateIdOrEl));o=e.innerHTML}else{if(void 0===w.templateIdOrEl.innerHTML)throw new Error("You have specified an invalid value for the template option!  It must be an ID or an Element.");o=w.templateIdOrEl.innerHTML}if(o=qq.trimStr(o),a=document.createElement("div"),a.appendChild(qq.toElement(o)),v=qq(a).getFirstByClass(F.uploader),w.button&&(c=qq(a).getFirstByClass(F.button),c&&qq(c).remove()),qq.DragAndDrop&&qq.supportedFeatures.fileDrop||(g=qq(a).getFirstByClass(F.dropProcessing),g&&qq(g).remove()),f=qq(a).getFirstByClass(F.drop),f&&!qq.DragAndDrop&&(t("DnD module unavailable.","info"),qq(f).remove()),qq.supportedFeatures.fileDrop?qq(v).hasAttribute(q)&&f&&(_=qq(f).getFirstByClass(F.dropText),_&&qq(_).remove()):(v.removeAttribute(q),f&&qq(f).hasAttribute(h)&&qq(f).css({display:"none"})),m=qq(a).getFirstByClass(F.thumbnail),s?m&&(S=parseInt(m.getAttribute(d)),S=S>0?S:null,l=qq(m).hasAttribute(p)):m&&qq(m).remove(),s=s&&m,n=qq(a).getByClass(F.editFilenameInput).length>0,i=qq(a).getByClass(F.retry).length>0,r=qq(a).getFirstByClass(F.list),null==r)throw new Error("Could not find the file list container in the template!");return u=r.innerHTML,r.innerHTML="",a.getElementsByTagName("DIALOG").length&&document.createElement("dialog"),t("Template parsing complete"),{template:qq.trimStr(a.innerHTML),fileTemplate:qq.trimStr(u)}},Z=function(e,t,n){var i=n,o=i.firstChild;t>0&&(o=qq(i).children()[t].nextSibling),i.insertBefore(e,o)},K=function(e){var t=e.id,n=e.optFileOrBlob,i=n&&n.qqThumbnailId,o=X(t),r={customResizeFunction:e.customResizeFunction,maxSize:S,orient:!0,scale:!0};qq.supportedFeatures.imagePreviews?o?w.limits.maxThumbs&&w.limits.maxThumbs<=v?(Y(t,o),T()):P(o).done(function(){x[t]=new qq.Promise,x[t].done(function(){setTimeout(T,w.limits.timeBetweenThumbs)}),null!=i?ne(t,i):D(t,n,r)}):T():o&&(P(o),T())},$=function(e){var t=e.id,n=e.thumbnailUrl,i=e.showWaitingImg,o=X(t),r={customResizeFunction:e.customResizeFunction,scale:l,maxSize:S};if(o)if(n){if(!(w.limits.maxThumbs&&w.limits.maxThumbs<=v))return i&&P(o),w.imageGenerator.generate(n,o,r).then(function(){te(o),v++,setTimeout(T,w.limits.timeBetweenThumbs)},function(){Y(t,o),setTimeout(T,w.limits.timeBetweenThumbs)});Y(t,o),T()}else Y(t,o),T()},ee=function(e,t){var n=z(e),i=null==e?F.totalProgressBar:F.progressBar;n&&!qq(n).hasClass(i)&&(n=qq(n).getFirstByClass(i)),n&&(qq(n).css({width:t+"%"}),n.setAttribute("aria-valuenow",t))},te=function(e){e&&qq(e).removeClass(w.classes.hide)},ne=function(e,n){var i=X(e),o=X(n);t(qq.format("ID {} is the same file as ID {}.  Will use generated thumbnail from ID {} instead.",e,n,n)),x[n].then(function(){v++,x[e].success(),t(qq.format("Now using previously generated thumbnail created for ID {} on ID {}.",n,e)),i.src=o.src,te(i)},function(){x[e].failure(),w.placeholders.waitUntilUpdate||Y(e,i)})};qq.extend(w,e),t=w.log,qq.supportedFeatures.imagePreviews||(w.limits.timeBetweenThumbs=0,w.limits.maxThumbs=0),r=w.containerEl,s=void 0!==w.imageGenerator,o=J(),I(),qq.extend(this,{render:function(){t("Rendering template in DOM."),v=0,r.innerHTML=o.template,W(B()),this.hideTotalProgress(),a=w.fileContainerEl||V(r,F.list),t("Template rendering complete")},renderFailure:function(e){var t=qq.toElement(e);r.innerHTML="",r.appendChild(t)},reset:function(){this.render()},clearFiles:function(){a.innerHTML=""},disableCancel:function(){_=!0},addFile:function(e,t,n,i,s){var l,d=qq.toElement(o.fileTemplate),p=V(d,F.file),h=V(r,F.uploader),f=s?g.content:a;s&&(g.map[e]=d),qq(d).addClass(c+e),h.removeAttribute(q),p&&(qq(p).setText(t),p.setAttribute("title",t)),d.setAttribute(u,e),n?Z(d,n.index,f):f.appendChild(d),i?(d.style.display="none",qq(d).addClass(m)):(W(z(e)),W(j(e)),W(R(e)),W(M(e)),W(H(e)),W(k(e)),_&&this.hideCancel(e),l=X(e),l&&!l.src&&E.then(function(e){l.src=e.src,e.style.maxHeight&&e.style.maxWidth&&qq(l).css({maxHeight:e.style.maxHeight,maxWidth:e.style.maxWidth}),te(l)}))},addFileToCache:function(e,t,n,i){this.addFile(e,t,n,i,!0)},addCacheToDom:function(){a.appendChild(g.content),g.content=document.createDocumentFragment(),g.map={}},removeFile:function(e){qq(L(e)).remove()},getFileId:function(e){var t=e;if(t){for(;null==t.getAttribute(u);)t=t.parentNode;return parseInt(t.getAttribute(u))}},getFileList:function(){return a},markFilenameEditable:function(e){var t=O(e);t&&qq(t).addClass(w.classes.editable)},updateFilename:function(e,t){var n=O(e);n&&(qq(n).setText(t),n.setAttribute("title",t))},hideFilename:function(e){W(O(e))},showFilename:function(e){te(O(e))},isFileName:function(e){return qq(e).hasClass(F.file)},getButton:function(){return w.button||V(r,F.button)},hideDropProcessing:function(){W(B())},showDropProcessing:function(){te(B())},getDropZone:function(){return V(r,F.drop)},isEditFilenamePossible:function(){return n},hideRetry:function(e){W(M(e))},isRetryPossible:function(){return i},showRetry:function(e){te(M(e))},getFileContainer:function(e){return L(e)},showEditIcon:function(e){var t=N(e);t&&qq(t).addClass(w.classes.editable)},isHiddenForever:function(e){return qq(L(e)).hasClass(m)},hideEditIcon:function(e){var t=N(e);t&&qq(t).removeClass(w.classes.editable)},isEditIcon:function(e){return qq(e).hasClass(F.editNameIcon,!0)},getEditInput:function(e){return V(L(e),F.editFilenameInput)},isEditInput:function(e){return qq(e).hasClass(F.editFilenameInput,!0)},updateProgress:function(e,t,n){var i,o=z(e);o&&n>0&&(i=Math.round(t/n*100),100===i?W(o):te(o),ee(e,i))},updateTotalProgress:function(e,t){this.updateProgress(null,e,t)},hideProgress:function(e){var t=z(e);t&&W(t)},hideTotalProgress:function(){this.hideProgress()},resetProgress:function(e){ee(e,0),this.hideTotalProgress(e)},resetTotalProgress:function(){this.resetProgress()},showCancel:function(e){if(!_){var t=U(e);t&&qq(t).removeClass(w.classes.hide)}},hideCancel:function(e){W(U(e))},isCancel:function(e){return qq(e).hasClass(F.cancel,!0)},allowPause:function(e){te(H(e)),W(k(e))},uploadPaused:function(e){this.setStatusText(e,w.text.paused),this.allowContinueButton(e),W(G(e))},hidePause:function(e){W(H(e))},isPause:function(e){return qq(e).hasClass(F.pause,!0)},isContinueButton:function(e){return qq(e).hasClass(F.continueButton,!0)},allowContinueButton:function(e){te(k(e)),W(H(e))},uploadContinued:function(e){this.setStatusText(e,""),this.allowPause(e),te(G(e))},showDeleteButton:function(e){te(R(e))},hideDeleteButton:function(e){W(R(e))},isDeleteButton:function(e){return qq(e).hasClass(F.deleteButton,!0)},isRetry:function(e){return qq(e).hasClass(F.retry,!0)},updateSize:function(e,t){var n=j(e);n&&(te(n),qq(n).setText(t))},setStatusText:function(e,t){var n=V(L(e),F.statusText);n&&(null==t?qq(n).clearText():qq(n).setText(t))},hideSpinner:function(e){qq(L(e)).removeClass(f),W(G(e))},showSpinner:function(e){qq(L(e)).addClass(f),te(G(e))},generatePreview:function(e,t,n){this.isHiddenForever(e)||(y.push({id:e,customResizeFunction:n,optFileOrBlob:t}),!b&&T())},updateThumbnail:function(e,t,n,i){this.isHiddenForever(e)||(y.push({customResizeFunction:i,update:!0,id:e,thumbnailUrl:t,showWaitingImg:n}),!b&&T())},hasDialog:function(e){return qq.supportedFeatures.dialogElement&&!!A(e)},showDialog:function(e,t,n){var i=A(e),o=V(i,F.dialogMessage),r=i.getElementsByTagName("INPUT")[0],a=V(i,F.dialogCancelButton),s=V(i,F.dialogOkButton),l=new qq.Promise,u=function(){a.removeEventListener("click",c),s&&s.removeEventListener("click",d),l.failure()},c=function(){a.removeEventListener("click",c),i.close()},d=function(){i.removeEventListener("close",u),s.removeEventListener("click",d),i.close(),l.success(r&&r.value)};return i.addEventListener("close",u),a.addEventListener("click",c),s&&s.addEventListener("click",d),r&&(r.value=n),o.textContent=t,i.showModal(),l}})},qq.UiEventHandler=function(e,t){"use strict";function n(e){i.attach(e,o.eventType,function(e){e=e||window.event;var t=e.target||e.srcElement;o.onHandled(t,e)})}var i=new qq.DisposeSupport,o={eventType:"click",attachTo:null,onHandled:function(e,t){}};qq.extend(this,{addHandler:function(e){n(e)},dispose:function(){i.dispose()}}),qq.extend(t,{getFileIdFromItem:function(e){return e.qqFileId},getDisposeSupport:function(){return i}}),qq.extend(o,e),o.attachTo&&n(o.attachTo)},qq.FileButtonsClickHandler=function(e){"use strict";function t(e,t){qq.each(o,function(n,o){var r,a=n.charAt(0).toUpperCase()+n.slice(1);if(i.templating["is"+a](e))return r=i.templating.getFileId(e),qq.preventDefault(t),i.log(qq.format("Detected valid file button click event on file '{}', ID: {}.",i.onGetName(r),r)),o(r),!1})}var n={},i={templating:null,log:function(e,t){},onDeleteFile:function(e){},onCancel:function(e){},onRetry:function(e){},onPause:function(e){},onContinue:function(e){},onGetName:function(e){}},o={cancel:function(e){i.onCancel(e)},retry:function(e){i.onRetry(e)},deleteButton:function(e){i.onDeleteFile(e)},pause:function(e){i.onPause(e)},continueButton:function(e){i.onContinue(e)}};qq.extend(i,e),i.eventType="click",i.onHandled=t,i.attachTo=i.templating.getFileList(),qq.extend(this,new qq.UiEventHandler(i,n))},qq.FilenameClickHandler=function(e){"use strict";function t(e,t){if(i.templating.isFileName(e)||i.templating.isEditIcon(e)){var o=i.templating.getFileId(e),r=i.onGetUploadStatus(o);r===qq.status.SUBMITTED&&(i.log(qq.format("Detected valid filename click event on file '{}', ID: {}.",i.onGetName(o),o)),qq.preventDefault(t),n.handleFilenameEdit(o,e,!0))}}var n={},i={templating:null,log:function(e,t){},classes:{file:"qq-upload-file",editNameIcon:"qq-edit-filename-icon"},onGetUploadStatus:function(e){},onGetName:function(e){}};qq.extend(i,e),i.eventType="click",i.onHandled=t,qq.extend(this,new qq.FilenameEditHandler(i,n))},qq.FilenameInputFocusInHandler=function(e,t){"use strict";function n(e,n){if(i.templating.isEditInput(e)){var o=i.templating.getFileId(e),r=i.onGetUploadStatus(o);r===qq.status.SUBMITTED&&(i.log(qq.format("Detected valid filename input focus event on file '{}', ID: {}.",i.onGetName(o),o)),t.handleFilenameEdit(o,e))}}var i={templating:null,onGetUploadStatus:function(e){},log:function(e,t){}};t||(t={}),i.eventType="focusin",i.onHandled=n,qq.extend(i,e),qq.extend(this,new qq.FilenameEditHandler(i,t))},qq.FilenameInputFocusHandler=function(e){"use strict";e.eventType="focus",e.attachTo=null,qq.extend(this,new qq.FilenameInputFocusInHandler(e,{}))},qq.FilenameEditHandler=function(e,t){"use strict";function n(e){var t=s.onGetName(e),n=t.lastIndexOf(".");return n>0&&(t=t.substr(0,n)),t}function i(e){var t=s.onGetName(e);return qq.getExtension(t)}function o(e,t){var n,o=e.value;void 0!==o&&qq.trimStr(o).length>0&&(n=i(t),void 0!==n&&(o=o+"."+n),s.onSetName(t,o)),s.onEditingStatusChange(t,!1)}function r(e,n){t.getDisposeSupport().attach(e,"blur",function(){o(e,n)})}function a(e,n){t.getDisposeSupport().attach(e,"keyup",function(t){var i=t.keyCode||t.which;13===i&&o(e,n)})}var s={templating:null,log:function(e,t){},onGetUploadStatus:function(e){},onGetName:function(e){},onSetName:function(e,t){},onEditingStatusChange:function(e,t){}};qq.extend(s,e),s.attachTo=s.templating.getFileList(),qq.extend(this,new qq.UiEventHandler(s,t)),qq.extend(t,{handleFilenameEdit:function(e,t,i){var o=s.templating.getEditInput(e);s.onEditingStatusChange(e,!0),o.value=n(e),i&&o.focus(),r(o,e),a(o,e)}})}}(window);
//# sourceMappingURL=fine-uploader.min.js.map;


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (window) {

  // Phoenix Channels JavaScript client
  //
  // ## Socket Connection
  //
  // A single connection is established to the server and
  // channels are mulitplexed over the connection.
  // Connect to the server using the `Socket` class:
  //
  //     let socket = new Socket("/ws", {params: {userToken: "123"}})
  //     socket.connect()
  //
  // The `Socket` constructor takes the mount point of the socket,
  // the authentication params, as well as options that can be found in
  // the Socket docs, such as configuring the `LongPoll` transport, and
  // heartbeat.
  //
  // ## Channels
  //
  // Channels are isolated, concurrent processes on the server that
  // subscribe to topics and broker events between the client and server.
  // To join a channel, you must provide the topic, and channel params for
  // authorization. Here's an example chat room example where `"new_msg"`
  // events are listened for, messages are pushed to the server, and
  // the channel is joined with ok/error/timeout matches:
  //
  //     let channel = socket.channel("rooms:123", {token: roomToken})
  //     channel.on("new_msg", msg => console.log("Got message", msg) )
  //     $input.onEnter( e => {
  //       channel.push("new_msg", {body: e.target.val}, 10000)
  //        .receive("ok", (msg) => console.log("created message", msg) )
  //        .receive("error", (reasons) => console.log("create failed", reasons) )
  //        .receive("timeout", () => console.log("Networking issue...") )
  //     })
  //     channel.join()
  //       .receive("ok", ({messages}) => console.log("catching up", messages) )
  //       .receive("error", ({reason}) => console.log("failed join", reason) )
  //       .receive("timeout", () => console.log("Networking issue. Still waiting...") )
  //
  //
  // ## Joining
  //
  // Creating a channel with `socket.channel(topic, params)`, binds the params to
  // `channel.params`, which are sent up on `channel.join()`.
  // Subsequent rejoins will send up the modified params for
  // updating authorization params, or passing up last_message_id information.
  // Successful joins receive an "ok" status, while unsuccessful joins
  // receive "error".
  //
  //
  // ## Pushing Messages
  //
  // From the previous example, we can see that pushing messages to the server
  // can be done with `channel.push(eventName, payload)` and we can optionally
  // receive responses from the push. Additionally, we can use
  // `receive("timeout", callback)` to abort waiting for our other `receive` hooks
  //  and take action after some period of waiting. The default timeout is 5000ms.
  //
  //
  // ## Socket Hooks
  //
  // Lifecycle events of the multiplexed connection can be hooked into via
  // `socket.onError()` and `socket.onClose()` events, ie:
  //
  //     socket.onError( () => console.log("there was an error with the connection!") )
  //     socket.onClose( () => console.log("the connection dropped") )
  //
  //
  // ## Channel Hooks
  //
  // For each joined channel, you can bind to `onError` and `onClose` events
  // to monitor the channel lifecycle, ie:
  //
  //     channel.onError( () => console.log("there was an error!") )
  //     channel.onClose( () => console.log("the channel has gone away gracefully") )
  //
  // ### onError hooks
  //
  // `onError` hooks are invoked if the socket connection drops, or the channel
  // crashes on the server. In either case, a channel rejoin is attemtped
  // automatically in an exponential backoff manner.
  //
  // ### onClose hooks
  //
  // `onClose` hooks are invoked only in two cases. 1) the channel explicitly
  // closed on the server, or 2). The client explicitly closed, by calling
  // `channel.leave()`
  //

  var VSN = "1.0.0";
  var SOCKET_STATES = { connecting: 0, open: 1, closing: 2, closed: 3 };
  var DEFAULT_TIMEOUT = 10000;
  var CHANNEL_STATES = {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining"
  };
  var CHANNEL_EVENTS = {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
  };
  var TRANSPORTS = {
    longpoll: "longpoll",
    websocket: "websocket"
  };

  var Push = function () {

    // Initializes the Push
    //
    // channel - The Channel
    // event - The event, for example `"phx_join"`
    // payload - The payload, for example `{user_id: 123}`
    // timeout - The push timeout in milliseconds
    //
    function Push(channel, event, payload, timeout) {
      _classCallCheck(this, Push);

      this.channel = channel;
      this.event = event;
      this.payload = payload || {};
      this.receivedResp = null;
      this.timeout = timeout;
      this.timeoutTimer = null;
      this.recHooks = [];
      this.sent = false;
    }

    _createClass(Push, [{
      key: "resend",
      value: function resend(timeout) {
        this.timeout = timeout;
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
      }
    }, {
      key: "send",
      value: function send() {
        if (this.hasReceived("timeout")) {
          return;
        }
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
          topic: this.channel.topic,
          event: this.event,
          payload: this.payload,
          ref: this.ref
        });
      }
    }, {
      key: "receive",
      value: function receive(status, callback) {
        if (this.hasReceived(status)) {
          callback(this.receivedResp.response);
        }

        this.recHooks.push({ status: status, callback: callback });
        return this;
      }

      // private

    }, {
      key: "matchReceive",
      value: function matchReceive(_ref) {
        var status = _ref.status,
            response = _ref.response,
            ref = _ref.ref;

        this.recHooks.filter(function (h) {
          return h.status === status;
        }).forEach(function (h) {
          return h.callback(response);
        });
      }
    }, {
      key: "cancelRefEvent",
      value: function cancelRefEvent() {
        if (!this.refEvent) {
          return;
        }
        this.channel.off(this.refEvent);
      }
    }, {
      key: "cancelTimeout",
      value: function cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
      }
    }, {
      key: "startTimeout",
      value: function startTimeout() {
        var _this = this;

        if (this.timeoutTimer) {
          return;
        }
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);

        this.channel.on(this.refEvent, function (payload) {
          _this.cancelRefEvent();
          _this.cancelTimeout();
          _this.receivedResp = payload;
          _this.matchReceive(payload);
        });

        this.timeoutTimer = setTimeout(function () {
          _this.trigger("timeout", {});
        }, this.timeout);
      }
    }, {
      key: "hasReceived",
      value: function hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
      }
    }, {
      key: "trigger",
      value: function trigger(status, response) {
        this.channel.trigger(this.refEvent, { status: status, response: response });
      }
    }]);

    return Push;
  }();

  var Channel = function () {
    function Channel(topic, params, socket) {
      var _this2 = this;

      _classCallCheck(this, Channel);

      this.state = CHANNEL_STATES.closed;
      this.topic = topic;
      this.params = params || {};
      this.socket = socket;
      this.bindings = [];
      this.timeout = this.socket.timeout;
      this.joinedOnce = false;
      this.joinPush = new Push(this, CHANNEL_EVENTS.join, this.params, this.timeout);
      this.pushBuffer = [];
      this.rejoinTimer = new Timer(function () {
        return _this2.rejoinUntilConnected();
      }, this.socket.reconnectAfterMs);
      this.joinPush.receive("ok", function () {
        _this2.state = CHANNEL_STATES.joined;
        _this2.rejoinTimer.reset();
        _this2.pushBuffer.forEach(function (pushEvent) {
          return pushEvent.send();
        });
        _this2.pushBuffer = [];
      });
      this.onClose(function () {
        _this2.socket.log("channel", "close " + _this2.topic);
        _this2.state = CHANNEL_STATES.closed;
        _this2.socket.remove(_this2);
      });
      this.onError(function (reason) {
        _this2.socket.log("channel", "error " + _this2.topic, reason);
        _this2.state = CHANNEL_STATES.errored;
        _this2.rejoinTimer.scheduleTimeout();
      });
      this.joinPush.receive("timeout", function () {
        if (_this2.state !== CHANNEL_STATES.joining) {
          return;
        }

        _this2.socket.log("channel", "timeout " + _this2.topic, _this2.joinPush.timeout);
        _this2.state = CHANNEL_STATES.errored;
        _this2.rejoinTimer.scheduleTimeout();
      });
      this.on(CHANNEL_EVENTS.reply, function (payload, ref) {
        _this2.trigger(_this2.replyEventName(ref), payload);
      });
    }

    _createClass(Channel, [{
      key: "rejoinUntilConnected",
      value: function rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) {
          this.rejoin();
        }
      }
    }, {
      key: "join",
      value: function join() {
        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;

        if (this.joinedOnce) {
          throw "tried to join multiple times. 'join' can only be called a single time per channel instance";
        } else {
          this.joinedOnce = true;
        }
        this.rejoin(timeout);
        return this.joinPush;
      }
    }, {
      key: "onClose",
      value: function onClose(callback) {
        this.on(CHANNEL_EVENTS.close, callback);
      }
    }, {
      key: "onError",
      value: function onError(callback) {
        this.on(CHANNEL_EVENTS.error, function (reason) {
          return callback(reason);
        });
      }
    }, {
      key: "on",
      value: function on(event, callback) {
        this.bindings.push({ event: event, callback: callback });
      }
    }, {
      key: "off",
      value: function off(event) {
        this.bindings = this.bindings.filter(function (bind) {
          return bind.event !== event;
        });
      }
    }, {
      key: "canPush",
      value: function canPush() {
        return this.socket.isConnected() && this.state === CHANNEL_STATES.joined;
      }
    }, {
      key: "push",
      value: function push(event, payload) {
        var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.timeout;

        if (!this.joinedOnce) {
          throw "tried to push '" + event + "' to '" + this.topic + "' before joining. Use channel.join() before pushing events";
        }
        var pushEvent = new Push(this, event, payload, timeout);
        if (this.canPush()) {
          pushEvent.send();
        } else {
          pushEvent.startTimeout();
          this.pushBuffer.push(pushEvent);
        }

        return pushEvent;
      }

      // Leaves the channel
      //
      // Unsubscribes from server events, and
      // instructs channel to terminate on server
      //
      // Triggers onClose() hooks
      //
      // To receive leave acknowledgements, use the a `receive`
      // hook to bind to the server ack, ie:
      //
      //     channel.leave().receive("ok", () => alert("left!") )
      //

    }, {
      key: "leave",
      value: function leave() {
        var _this3 = this;

        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;

        var onClose = function onClose() {
          _this3.socket.log("channel", "leave " + _this3.topic);
          _this3.trigger(CHANNEL_EVENTS.close, "leave");
        };
        var leavePush = new Push(this, CHANNEL_EVENTS.leave, {}, timeout);
        leavePush.receive("ok", function () {
          return onClose();
        }).receive("timeout", function () {
          return onClose();
        });
        leavePush.send();
        if (!this.canPush()) {
          leavePush.trigger("ok", {});
        }

        return leavePush;
      }

      // Overridable message hook
      //
      // Receives all events for specialized message handling

    }, {
      key: "onMessage",
      value: function onMessage(event, payload, ref) {}

      // private

    }, {
      key: "isMember",
      value: function isMember(topic) {
        return this.topic === topic;
      }
    }, {
      key: "sendJoin",
      value: function sendJoin(timeout) {
        this.state = CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
      }
    }, {
      key: "rejoin",
      value: function rejoin() {
        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.timeout;
        this.sendJoin(timeout);
      }
    }, {
      key: "trigger",
      value: function trigger(triggerEvent, payload, ref) {
        this.onMessage(triggerEvent, payload, ref);
        this.bindings.filter(function (bind) {
          return bind.event === triggerEvent;
        }).map(function (bind) {
          return bind.callback(payload, ref);
        });
      }
    }, {
      key: "replyEventName",
      value: function replyEventName(ref) {
        return "chan_reply_" + ref;
      }
    }]);

    return Channel;
  }();

  var Socket = function () {

    // Initializes the Socket
    //
    // endPoint - The string WebSocket endpoint, ie, "ws://example.com/ws",
    //                                               "wss://example.com"
    //                                               "/ws" (inherited host & protocol)
    // opts - Optional configuration
    //   transport - The Websocket Transport, for example WebSocket or Phoenix.LongPoll.
    //               Defaults to WebSocket with automatic LongPoll fallback.
    //   timeout - The default timeout in milliseconds to trigger push timeouts.
    //             Defaults `DEFAULT_TIMEOUT`
    //   heartbeatIntervalMs - The millisec interval to send a heartbeat message
    //   reconnectAfterMs - The optional function that returns the millsec
    //                      reconnect interval. Defaults to stepped backoff of:
    //
    //     function(tries){
    //       return [1000, 5000, 10000][tries - 1] || 10000
    //     }
    //
    //   logger - The optional function for specialized logging, ie:
    //     `logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
    //
    //   longpollerTimeout - The maximum timeout of a long poll AJAX request.
    //                        Defaults to 20s (double the server long poll timer).
    //
    //   params - The optional params to pass when connecting
    //
    // For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
    //
    function Socket(endPoint) {
      var _this4 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Socket);

      this.stateChangeCallbacks = { open: [], close: [], error: [], message: [] };
      this.channels = [];
      this.sendBuffer = [];
      this.ref = 0;
      this.timeout = opts.timeout || DEFAULT_TIMEOUT;
      this.transport = opts.transport || window.WebSocket || LongPoll;
      this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 30000;
      this.reconnectAfterMs = opts.reconnectAfterMs || function (tries) {
        return [1000, 2000, 5000, 10000][tries - 1] || 10000;
      };
      this.logger = opts.logger || function () {}; // noop
      this.longpollerTimeout = opts.longpollerTimeout || 20000;
      this.params = opts.params || {};
      this.endPoint = endPoint + "/" + TRANSPORTS.websocket;
      this.reconnectTimer = new Timer(function () {
        _this4.disconnect(function () {
          return _this4.connect();
        });
      }, this.reconnectAfterMs);
    }

    _createClass(Socket, [{
      key: "protocol",
      value: function protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
      }
    }, {
      key: "endPointURL",
      value: function endPointURL() {
        var uri = Ajax.appendParams(Ajax.appendParams(this.endPoint, this.params), { vsn: VSN });
        if (uri.charAt(0) !== "/") {
          return uri;
        }
        if (uri.charAt(1) === "/") {
          return this.protocol() + ":" + uri;
        }

        return this.protocol() + "://" + location.host + uri;
      }
    }, {
      key: "disconnect",
      value: function disconnect(callback, code, reason) {
        if (this.conn) {
          this.conn.onclose = function () {}; // noop
          if (code) {
            this.conn.close(code, reason || "");
          } else {
            this.conn.close();
          }
          this.conn = null;
        }
        callback && callback();
      }

      // params - The params to send when connecting, for example `{user_id: userToken}`

    }, {
      key: "connect",
      value: function connect(params) {
        var _this5 = this;

        if (params) {
          console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
          this.params = params;
        }
        if (this.conn) {
          return;
        }

        this.conn = new this.transport(this.endPointURL());
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = function () {
          return _this5.onConnOpen();
        };
        this.conn.onerror = function (error) {
          return _this5.onConnError(error);
        };
        this.conn.onmessage = function (event) {
          return _this5.onConnMessage(event);
        };
        this.conn.onclose = function (event) {
          return _this5.onConnClose(event);
        };
      }

      // Logs the message. Override `this.logger` for specialized logging. noops by default

    }, {
      key: "log",
      value: function log(kind, msg, data) {
        this.logger(kind, msg, data);
      }

      // Registers callbacks for connection state change events
      //
      // Examples
      //
      //    socket.onError(function(error){ alert("An error occurred") })
      //

    }, {
      key: "onOpen",
      value: function onOpen(callback) {
        this.stateChangeCallbacks.open.push(callback);
      }
    }, {
      key: "onClose",
      value: function onClose(callback) {
        this.stateChangeCallbacks.close.push(callback);
      }
    }, {
      key: "onError",
      value: function onError(callback) {
        this.stateChangeCallbacks.error.push(callback);
      }
    }, {
      key: "onMessage",
      value: function onMessage(callback) {
        this.stateChangeCallbacks.message.push(callback);
      }
    }, {
      key: "onConnOpen",
      value: function onConnOpen() {
        var _this6 = this;

        this.log("transport", "connected to " + this.endPointURL(), this.transport.prototype);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.conn.skipHeartbeat) {
          clearInterval(this.heartbeatTimer);
          this.heartbeatTimer = setInterval(function () {
            return _this6.sendHeartbeat();
          }, this.heartbeatIntervalMs);
        }
        this.stateChangeCallbacks.open.forEach(function (callback) {
          return callback();
        });
      }
    }, {
      key: "onConnClose",
      value: function onConnClose(event) {
        this.log("transport", "close", event);
        this.triggerChanError();
        clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach(function (callback) {
          return callback(event);
        });
      }
    }, {
      key: "onConnError",
      value: function onConnError(error) {
        this.log("transport", error);
        this.triggerChanError();
        this.stateChangeCallbacks.error.forEach(function (callback) {
          return callback(error);
        });
      }
    }, {
      key: "triggerChanError",
      value: function triggerChanError() {
        this.channels.forEach(function (channel) {
          return channel.trigger(CHANNEL_EVENTS.error);
        });
      }
    }, {
      key: "connectionState",
      value: function connectionState() {
        switch (this.conn && this.conn.readyState) {
          case SOCKET_STATES.connecting:
            return "connecting";
          case SOCKET_STATES.open:
            return "open";
          case SOCKET_STATES.closing:
            return "closing";
          default:
            return "closed";
        }
      }
    }, {
      key: "isConnected",
      value: function isConnected() {
        return this.connectionState() === "open";
      }
    }, {
      key: "remove",
      value: function remove(channel) {
        this.channels = this.channels.filter(function (c) {
          return !c.isMember(channel.topic);
        });
      }
    }, {
      key: "channel",
      value: function channel(topic) {
        var chanParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var chan = new Channel(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
      }
    }, {
      key: "push",
      value: function push(data) {
        var _this7 = this;

        var topic = data.topic,
            event = data.event,
            payload = data.payload,
            ref = data.ref;

        var callback = function callback() {
          return _this7.conn.send(JSON.stringify(data));
        };
        this.log("push", topic + " " + event + " (" + ref + ")", payload);
        if (this.isConnected()) {
          callback();
        } else {
          this.sendBuffer.push(callback);
        }
      }

      // Return the next message ref, accounting for overflows

    }, {
      key: "makeRef",
      value: function makeRef() {
        var newRef = this.ref + 1;
        if (newRef === this.ref) {
          this.ref = 0;
        } else {
          this.ref = newRef;
        }

        return this.ref.toString();
      }
    }, {
      key: "sendHeartbeat",
      value: function sendHeartbeat() {
        if (!this.isConnected()) {
          return;
        }
        this.push({ topic: "phoenix", event: "heartbeat", payload: {}, ref: this.makeRef() });
      }
    }, {
      key: "flushSendBuffer",
      value: function flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
          this.sendBuffer.forEach(function (callback) {
            return callback();
          });
          this.sendBuffer = [];
        }
      }
    }, {
      key: "onConnMessage",
      value: function onConnMessage(rawMessage) {
        var msg = JSON.parse(rawMessage.data);
        var topic = msg.topic,
            event = msg.event,
            payload = msg.payload,
            ref = msg.ref;

        this.log("receive", (payload.status || "") + " " + topic + " " + event + " " + (ref && "(" + ref + ")" || ""), payload);
        this.channels.filter(function (channel) {
          return channel.isMember(topic);
        }).forEach(function (channel) {
          return channel.trigger(event, payload, ref);
        });
        this.stateChangeCallbacks.message.forEach(function (callback) {
          return callback(msg);
        });
      }
    }]);

    return Socket;
  }();

  var LongPoll = function () {
    function LongPoll(endPoint) {
      _classCallCheck(this, LongPoll);

      this.endPoint = null;
      this.token = null;
      this.skipHeartbeat = true;
      this.onopen = function () {}; // noop
      this.onerror = function () {}; // noop
      this.onmessage = function () {}; // noop
      this.onclose = function () {}; // noop
      this.pollEndpoint = this.normalizeEndpoint(endPoint);
      this.readyState = SOCKET_STATES.connecting;

      this.poll();
    }

    _createClass(LongPoll, [{
      key: "normalizeEndpoint",
      value: function normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)\/" + TRANSPORTS.websocket), "$1/" + TRANSPORTS.longpoll);
      }
    }, {
      key: "endpointURL",
      value: function endpointURL() {
        return Ajax.appendParams(this.pollEndpoint, { token: this.token });
      }
    }, {
      key: "closeAndRetry",
      value: function closeAndRetry() {
        this.close();
        this.readyState = SOCKET_STATES.connecting;
      }
    }, {
      key: "ontimeout",
      value: function ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry();
      }
    }, {
      key: "poll",
      value: function poll() {
        var _this8 = this;

        if (!(this.readyState === SOCKET_STATES.open || this.readyState === SOCKET_STATES.connecting)) {
          return;
        }

        Ajax.request("GET", this.endpointURL(), "application/json", null, this.timeout, this.ontimeout.bind(this), function (resp) {
          if (resp) {
            var status = resp.status,
                token = resp.token,
                messages = resp.messages;

            _this8.token = token;
          } else {
            var status = 0;
          }

          switch (status) {
            case 200:
              messages.forEach(function (msg) {
                return _this8.onmessage({ data: JSON.stringify(msg) });
              });
              _this8.poll();
              break;
            case 204:
              _this8.poll();
              break;
            case 410:
              _this8.readyState = SOCKET_STATES.open;
              _this8.onopen();
              _this8.poll();
              break;
            case 0:
            case 500:
              _this8.onerror();
              _this8.closeAndRetry();
              break;
            default:
              throw "unhandled poll status " + status;
          }
        });
      }
    }, {
      key: "send",
      value: function send(body) {
        var _this9 = this;

        Ajax.request("POST", this.endpointURL(), "application/json", body, this.timeout, this.onerror.bind(this, "timeout"), function (resp) {
          if (!resp || resp.status !== 200) {
            _this9.onerror(status);
            _this9.closeAndRetry();
          }
        });
      }
    }, {
      key: "close",
      value: function close(code, reason) {
        this.readyState = SOCKET_STATES.closed;
        this.onclose();
      }
    }]);

    return LongPoll;
  }();

  var Ajax = function () {
    function Ajax() {
      _classCallCheck(this, Ajax);
    }

    _createClass(Ajax, null, [{
      key: "request",
      value: function request(method, endPoint, accept, body, timeout, ontimeout, callback) {
        if (window.XDomainRequest) {
          var req = new XDomainRequest(); // IE8, IE9
          this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else {
          var _req = window.XMLHttpRequest ? new XMLHttpRequest() : // IE7+, Firefox, Chrome, Opera, Safari
          new ActiveXObject("Microsoft.XMLHTTP"); // IE6, IE5
          this.xhrRequest(_req, method, endPoint, accept, body, timeout, ontimeout, callback);
        }
      }
    }, {
      key: "xdomainRequest",
      value: function xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        var _this10 = this;

        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = function () {
          var response = _this10.parseJSON(req.responseText);
          callback && callback(response);
        };
        if (ontimeout) {
          req.ontimeout = ontimeout;
        }

        // Work around bug in IE9 that requires an attached onprogress handler
        req.onprogress = function () {};

        req.send(body);
      }
    }, {
      key: "xhrRequest",
      value: function xhrRequest(req, method, endPoint, accept, body, timeout, ontimeout, callback) {
        var _this11 = this;

        req.timeout = timeout;
        req.open(method, endPoint, true);
        req.setRequestHeader("Content-Type", accept);
        req.onerror = function () {
          callback && callback(null);
        };
        req.onreadystatechange = function () {
          if (req.readyState === _this11.states.complete && callback) {
            var response = _this11.parseJSON(req.responseText);
            callback(response);
          }
        };
        if (ontimeout) {
          req.ontimeout = ontimeout;
        }

        req.send(body);
      }
    }, {
      key: "parseJSON",
      value: function parseJSON(resp) {
        return resp && resp !== "" ? JSON.parse(resp) : null;
      }
    }, {
      key: "serialize",
      value: function serialize(obj, parentKey) {
        var queryStr = [];
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) {
            continue;
          }
          var paramKey = parentKey ? parentKey + "[" + key + "]" : key;
          var paramVal = obj[key];
          if ((typeof paramVal === "undefined" ? "undefined" : _typeof(paramVal)) === "object") {
            queryStr.push(this.serialize(paramVal, paramKey));
          } else {
            queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
          }
        }
        return queryStr.join("&");
      }
    }, {
      key: "appendParams",
      value: function appendParams(url, params) {
        if (Object.keys(params).length === 0) {
          return url;
        }

        var prefix = url.match(/\?/) ? "&" : "?";
        return "" + url + prefix + this.serialize(params);
      }
    }]);

    return Ajax;
  }();

  Ajax.states = { complete: 4 };

  // Creates a timer that accepts a `timerCalc` function to perform
  // calculated timeout retries, such as exponential backoff.
  //
  // ## Examples
  //
  //    let reconnectTimer = new Timer(() => this.connect(), function(tries){
  //      return [1000, 5000, 10000][tries - 1] || 10000
  //    })
  //    reconnectTimer.scheduleTimeout() // fires after 1000
  //    reconnectTimer.scheduleTimeout() // fires after 5000
  //    reconnectTimer.reset()
  //    reconnectTimer.scheduleTimeout() // fires after 1000
  //

  var Timer = function () {
    function Timer(callback, timerCalc) {
      _classCallCheck(this, Timer);

      this.callback = callback;
      this.timerCalc = timerCalc;
      this.timer = null;
      this.tries = 0;
    }

    _createClass(Timer, [{
      key: "reset",
      value: function reset() {
        this.tries = 0;
        clearTimeout(this.timer);
      }

      // Cancels any previous scheduleTimeout and schedules callback

    }, {
      key: "scheduleTimeout",
      value: function scheduleTimeout() {
        var _this12 = this;

        clearTimeout(this.timer);

        this.timer = setTimeout(function () {
          _this12.tries = _this12.tries + 1;
          _this12.callback();
        }, this.timerCalc(this.tries + 1));
      }
    }]);

    return Timer;
  }();

  // Expose socket globally.


  window.Socket = Socket;
})(window);
define("phoenix-socket", function(){});


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('textext-core-css.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/**
 * jQuery TextExt Plugin
 * http://textextjs.com
 *
 * @version 1.3.1
 * @copyright Copyright (C) 2011 Alex Gorbatchev. All rights reserved.
 * @license MIT License
 */
(function($, undefined)
{
	/**
	 * TextExt is the main core class which by itself doesn't provide any functionality
	 * that is user facing, however it has the underlying mechanics to bring all the
	 * plugins together under one roof and make them work with each other or on their
	 * own.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt
	 */
	function TextExt() {};

	/**
	 * ItemManager is used to seamlessly convert between string that come from the user input to whatever 
	 * the format the item data is being passed around in. It's used by all plugins that in one way or 
	 * another operate with items, such as Tags, Filter, Autocomplete and Suggestions. Default implementation 
	 * works with `String` type. 
	 *
	 * Each instance of `TextExt` creates a new instance of default implementation of `ItemManager`
	 * unless `itemManager` option was set to another implementation.
	 *
	 * To satisfy requirements of managing items of type other than a `String`, different implementation
	 * if `ItemManager` should be supplied.
	 *
	 * If you wish to bring your own implementation, you need to create a new class and implement all the 
	 * methods that `ItemManager` has. After, you need to supply your pass via the `itemManager` option during
	 * initialization like so:
	 *
	 *     $('#input').textext({
	 *         itemManager : CustomItemManager
	 *     })
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager
	 */
	function ItemManager() {};

	/**
	 * TextExtPlugin is a base class for all plugins. It provides common methods which are reused
	 * by majority of plugins.
	 *
	 * All plugins must register themselves by calling the `$.fn.textext.addPlugin(name, constructor)`
	 * function while providing plugin name and constructor. The plugin name is the same name that user
	 * will identify the plugin in the `plugins` option when initializing TextExt component and constructor
	 * function will create a new instance of the plugin. *Without registering, the core won't
	 * be able to see the plugin.*
	 *
	 * <span class="new label version">new in 1.2.0</span> You can get instance of each plugin from the core 
	 * via associated function with the same name as the plugin. For example:
	 *
	 *     $('#input').textext()[0].tags()
	 *     $('#input').textext()[0].autocomplete()
	 *     ...
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin
	 */
	function TextExtPlugin() {};

	var stringify = (JSON || {}).stringify,
		slice     = Array.prototype.slice,
		p,
		UNDEFINED = 'undefined',

		/**
		 * TextExt provides a way to pass in the options to configure the core as well as
		 * each plugin that is being currently used. The jQuery exposed plugin `$().textext()` 
		 * function takes a hash object with key/value set of options. For example:
		 *
		 *     $('textarea').textext({
		 *         enabled: true
		 *     })
		 *
		 * There are multiple ways of passing in the options:
		 *
		 * 1. Options could be nested multiple levels deep and accessed using all lowercased, dot
		 * separated style, eg `foo.bar.world`. The manual is using this style for clarity and
		 * consistency. For example:
		 *
		 *        {
		 *            item: {
		 *                manager: ...
		 *            },
		 *
		 *            html: {
		 *                wrap: ...
		 *            },
		 *
		 *            autocomplete: {
		 *                enabled: ...,
		 *                dropdown: {
		 *                   position: ...
		 *                }
		 *            }
		 *        }
		 *
		 * 2. Options could be specified using camel cased names in a flat key/value fashion like so:
		 *
		 *        {
		 *            itemManager: ...,
		 *            htmlWrap: ...,
		 *            autocompleteEnabled: ...,
		 *            autocompleteDropdownPosition: ...
		 *        }
		 *
		 * 3. Finally, options could be specified in mixed style. It's important to understand that
		 * for each dot separated name, its alternative in camel case is also checked for, eg for 
		 * `foo.bar.world` it's alternatives could be `fooBarWorld`, `foo.barWorld` or `fooBar.world`, 
		 * which translates to `{ foo: { bar: { world: ... } } }`, `{ fooBarWorld: ... }`, 
		 * `{ foo : { barWorld : ... } }` or `{ fooBar: { world: ... } }` respectively. For example:
		 *
		 *        {
		 *            itemManager : ...,
		 *            htmlWrap: ...,
		 *            autocomplete: {
		 *                enabled: ...,
		 *                dropdownPosition: ...
		 *            }
		 *        }
		 *
		 * Mixed case is used through out the code, wherever it seems appropriate. However in the code, all option
		 * names are specified in the dot notation because it works both ways where as camel case is not
		 * being converted to its alternative dot notation.
		 *
		 * @author agorbatchev
		 * @date 2011/08/17
		 * @id TextExt.options
		 */

		/**
		 * Default instance of `ItemManager` which takes `String` type as default for tags.
		 *
		 * @name item.manager
		 * @default ItemManager
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.options.item.manager
		 */
		OPT_ITEM_MANAGER = 'item.manager',
		
		/**
		 * List of plugins that should be used with the current instance of TextExt. The list could be
		 * specified as array of strings or as comma or space separated string.
		 *
		 * @name plugins
		 * @default []
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.options.plugins
		 */
		OPT_PLUGINS = 'plugins',
		
		/**
		 * TextExt allows for overriding of virtually any method that the core or any of its plugins
		 * use. This could be accomplished through the use of the `ext` option.
		 *
		 * It's possible to specifically target the core or any plugin, as well as overwrite all the
		 * desired methods everywhere.
		 *
		 * 1. Targeting the core:
		 *
		 *        ext: {
		 *            core: {
		 *                trigger: function()
		 *                {
		 *                    console.log('TextExt.trigger', arguments);
		 *                    $.fn.textext.TextExt.prototype.trigger.apply(this, arguments);
		 *                }
		 *            }
		 *        }
		 *
		 * 2. Targeting individual plugins:
		 *
		 *        ext: {
		 *            tags: {
		 *                addTags: function(tags)
		 *                {
		 *                    console.log('TextExtTags.addTags', tags);
		 *                    $.fn.textext.TextExtTags.prototype.addTags.apply(this, arguments);
		 *                }
		 *            }
		 *        }
		 *
		 * 3. Targeting `ItemManager` instance:
		 *
		 *        ext: {
		 *            itemManager: {
		 *                stringToItem: function(str)
		 *                {
		 *                    console.log('ItemManager.stringToItem', str);
		 *                    return $.fn.textext.ItemManager.prototype.stringToItem.apply(this, arguments);
		 *                }
		 *            }
		 *        }
		 *
		 * 4. And finally, in edge cases you can extend everything at once:
		 *
		 *        ext: {
		 *            '*': {
		 *                fooBar: function() {}
		 *            }
		 *        }
		 *
		 * @name ext
		 * @default {}
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.options.ext
		 */
		OPT_EXT = 'ext',
		
		/**
		 * HTML source that is used to generate elements necessary for the core and all other
		 * plugins to function.
		 *
		 * @name html.wrap
		 * @default '<div class="text-core"><div class="text-wrap"/></div>'
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.options.html.wrap
		 */
		OPT_HTML_WRAP = 'html.wrap',

		/**
		 * HTML source that is used to generate hidden input value of which will be submitted 
		 * with the HTML form.
		 *
		 * @name html.hidden
		 * @default '<input type="hidden" />'
		 * @author agorbatchev
		 * @date 2011/08/20
		 * @id TextExt.options.html.hidden
		 */
		OPT_HTML_HIDDEN = 'html.hidden',
		
		/**
		 * Hash table of key codes and key names for which special events will be created
		 * by the core. For each entry a `[name]KeyDown`, `[name]KeyUp` and `[name]KeyPress` events 
		 * will be triggered along side with `anyKeyUp` and `anyKeyDown` events for every 
		 * key stroke.
		 *
		 * Here's a list of default keys:
		 *
		 *     {
		 *         8   : 'backspace',
		 *         9   : 'tab',
		 *         13  : 'enter!',
		 *         27  : 'escape!',
		 *         37  : 'left',
		 *         38  : 'up!',
		 *         39  : 'right',
		 *         40  : 'down!',
		 *         46  : 'delete',
		 *         108 : 'numpadEnter'
		 *     }
		 *
		 * Please note the `!` at the end of some keys. This tells the core that by default
		 * this keypress will be trapped and not passed on to the text input.
		 *
		 * @name keys
		 * @default { ... }
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.options.keys
		 */
		OPT_KEYS = 'keys',

		/**
		 * The core triggers or reacts to the following events.
		 *
		 * @author agorbatchev
		 * @date 2011/08/17
		 * @id TextExt.events
		 */

		/**
		 * Core triggers `preInvalidate` event before the dimensions of padding on the text input
		 * are set.
		 *
		 * @name preInvalidate
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.preInvalidate
		 */
		EVENT_PRE_INVALIDATE = 'preInvalidate',

		/**
		 * Core triggers `postInvalidate` event after the dimensions of padding on the text input
		 * are set.
		 *
		 * @name postInvalidate
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.postInvalidate
		 */
		EVENT_POST_INVALIDATE = 'postInvalidate',
		
		/**
		 * Core triggers `getFormData` on every key press to collect data that will be populated
		 * into the hidden input that will be submitted with the HTML form and data that will
		 * be displayed in the input field that user is currently interacting with.
		 *
		 * All plugins that wish to affect how the data is presented or sent must react to 
		 * `getFormData` and populate the data in the following format:
		 *
		 *     {
		 *         input : {String},
		 *         form  : {Object}
		 *     }
		 *
		 * The data key must be a numeric weight which will be used to determine which data
		 * ends up being used. Data with the highest numerical weight gets the priority. This
		 * allows plugins to set the final data regardless of their initialization order, which
		 * otherwise would be impossible.
		 *
		 * For example, the Tags and Autocomplete plugins have to work side by side and Tags
		 * plugin must get priority on setting the data. Therefore the Tags plugin sets data
		 * with the weight 200 where as the Autocomplete plugin sets data with the weight 100.
		 *
		 * Here's an example of a typical `getFormData` handler:
		 * 
		 *     TextExtPlugin.prototype.onGetFormData = function(e, data, keyCode)
		 *     {
		 *         data[100] = self.formDataObject('input value', 'form value');
		 *     };
		 *
		 * Core also reacts to the `getFormData` and updates hidden input with data which will be
		 * submitted with the HTML form.
		 *
		 * @name getFormData
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.getFormData
		 */
		EVENT_GET_FORM_DATA = 'getFormData',

		/**
		 * Core triggers and reacts to the `setFormData` event to update the actual value in the
		 * hidden input that will be submitted with the HTML form. Second argument can be value
		 * of any type and by default it will be JSON serialized with `TextExt.serializeData()`
		 * function.
		 *
		 * @name setFormData
		 * @author agorbatchev
		 * @date 2011/08/22
		 * @id TextExt.events.setFormData
		 */
		EVENT_SET_FORM_DATA = 'setFormData',

		/**
		 * Core triggers and reacts to the `setInputData` event to update the actual value in the
		 * text input that user is interacting with. Second argument must be of a `String` type
		 * the value of which will be set into the text input.
		 *
		 * @name setInputData
		 * @author agorbatchev
		 * @date 2011/08/22
		 * @id TextExt.events.setInputData
		 */
		EVENT_SET_INPUT_DATA = 'setInputData',
		
		/**
		 * Core triggers `postInit` event to let plugins run code after all plugins have been 
		 * created and initialized. This is a good place to set some kind of global values before 
		 * somebody gets to use them. This is not the right place to expect all plugins to finish
		 * their initialization.
		 *
		 * @name postInit
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.postInit
		 */
		EVENT_POST_INIT = 'postInit',

		/**
		 * Core triggers `ready` event after all global configuration and prepearation has been
		 * done and the TextExt component is ready for use. Event handlers should expect all 
		 * values to be set and the plugins to be in the final state.
		 *
		 * @name ready
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.ready
		 */
		EVENT_READY = 'ready',

		/**
		 * Core triggers `anyKeyUp` event for every key up event triggered within the component.
		 *
		 * @name anyKeyUp
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.anyKeyUp
		 */

		/**
		 * Core triggers `anyKeyDown` event for every key down event triggered within the component.
		 *
		 * @name anyKeyDown
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.anyKeyDown
		 */

		/**
		 * Core triggers `[name]KeyUp` event for every key specifid in the `keys` option that is 
		 * triggered within the component.
		 *
		 * @name [name]KeyUp
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.[name]KeyUp
		 */

		/**
		 * Core triggers `[name]KeyDown` event for every key specified in the `keys` option that is 
		 * triggered within the component.
		 *
		 * @name [name]KeyDown
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.[name]KeyDown
		 */

		/**
		 * Core triggers `[name]KeyPress` event for every key specified in the `keys` option that is 
		 * triggered within the component.
		 *
		 * @name [name]KeyPress
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExt.events.[name]KeyPress
		 */

		DEFAULT_OPTS = {
			itemManager : ItemManager,

			plugins : [],
			ext : {},

			html : {
				wrap   : '<div class="text-core"><div class="text-wrap"/></div>',
				hidden : '<input type="hidden" />'
			},

			keys : {
				8   : 'backspace',
				9   : 'tab',
				13  : 'enter!',
				27  : 'escape!',
				37  : 'left',
				38  : 'up!',
				39  : 'right',
				40  : 'down!',
				46  : 'delete',
				108 : 'numpadEnter'
			}
		}
		;

	// Freak out if there's no JSON.stringify function found
	if(!stringify)
		throw new Error('JSON.stringify() not found');

	/**
	 * Returns object property by name where name is dot-separated and object is multiple levels deep.
	 * @param target Object Source object.
	 * @param name String Dot separated property name, ie `foo.bar.world`
	 * @id core.getProperty
	 */
	function getProperty(source, name)
	{
		if(typeof(name) === 'string')
			name = name.split('.');

		var fullCamelCaseName = name.join('.').replace(/\.(\w)/g, function(match, letter) { return letter.toUpperCase() }),
			nestedName        = name.shift(),
			result
			;

		if(typeof(result = source[fullCamelCaseName]) != UNDEFINED)
			result = result;

		else if(typeof(result = source[nestedName]) != UNDEFINED && name.length > 0)
			result = getProperty(result, name);

		// name.length here should be zero
		return result;
	};

	/**
	 * Hooks up specified events in the scope of the current object.
	 * @author agorbatchev
	 * @date 2011/08/09
	 */
	function hookupEvents()
	{
		var args   = slice.apply(arguments),
			self   = this,
			target = args.length === 1 ? self : args.shift(),
			event
			;

		args = args[0] || {};

		function bind(event, handler)
		{
			target.bind(event, function()
			{
				// apply handler to our PLUGIN object, not the target
				return handler.apply(self, arguments);
			});
		}

		for(event in args)
			bind(event, args[event]);
	};

	function formDataObject(input, form)
	{
		return { 'input' : input, 'form' : form };
	};

	//--------------------------------------------------------------------------------
	// ItemManager core component
	
	p = ItemManager.prototype;

	/**
	 * Initialization method called by the core during instantiation.
	 *
	 * @signature ItemManager.init(core)
	 *
	 * @param core {TextExt} Instance of the TextExt core class.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.init
	 */
	p.init = function(core)
	{
	};

	/**
	 * Filters out items from the list that don't match the query and returns remaining items. Default 
	 * implementation checks if the item starts with the query.
	 *
	 * @signature ItemManager.filter(list, query)
	 *
	 * @param list {Array} List of items. Default implementation works with strings.
	 * @param query {String} Query string.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.filter
	 */
	p.filter = function(list, query)
	{
		var result = [],
			i, item
			;

		for(i = 0; i < list.length; i++)
		{
			item = list[i];
			if(this.itemContains(item, query))
				result.push(item);
		}

		return result;
	};

	/**
	 * Returns `true` if specified item contains another string, `false` otherwise. In the default implementation 
	 * `String.indexOf()` is used to check if item string begins with the needle string.
	 *
	 * @signature ItemManager.itemContains(item, needle)
	 *
	 * @param item {Object} Item to check. Default implementation works with strings.
	 * @param needle {String} Search string to be found within the item.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.itemContains
	 */
	p.itemContains = function(item, needle)
	{
		return this.itemToString(item).toLowerCase().indexOf(needle.toLowerCase()) == 0;
	};

	/**
	 * Converts specified string to item. Because default implemenation works with string, input string
	 * is simply returned back. To use custom objects, different implementation of this method could
	 * return something like `{ name : {String} }`.
	 *
	 * @signature ItemManager.stringToItem(str)
	 *
	 * @param str {String} Input string.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.stringToItem
	 */
	p.stringToItem = function(str)
	{
		return str;
	};

	/**
	 * Converts specified item to string. Because default implemenation works with string, input string
	 * is simply returned back. To use custom objects, different implementation of this method could
	 * for example return `name` field of `{ name : {String} }`.
	 *
	 * @signature ItemManager.itemToString(item)
	 *
	 * @param item {Object} Input item to be converted to string.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.itemToString
	 */
	p.itemToString = function(item)
	{
		return item;
	};

	/**
	 * Returns `true` if both items are equal, `false` otherwise. Because default implemenation works with 
	 * string, input items are compared as strings. To use custom objects, different implementation of this 
	 * method could for example compare `name` fields of `{ name : {String} }` type object.
	 *
	 * @signature ItemManager.compareItems(item1, item2)
	 *
	 * @param item1 {Object} First item.
	 * @param item2 {Object} Second item.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id ItemManager.compareItems
	 */
	p.compareItems = function(item1, item2)
	{
		return item1 == item2;
	};

	//--------------------------------------------------------------------------------
	// TextExt core component

	p = TextExt.prototype;
		
	/**
	 * Initializes current component instance with work with the supplied text input and options.
	 *
	 * @signature TextExt.init(input, opts)
	 *
	 * @param input {HTMLElement} Text input.
	 * @param opts {Object} Options.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.init
	 */
	p.init = function(input, opts)
	{
		var self = this,
			hiddenInput,
			itemManager,
			container
			;

		self._defaults    = $.extend({}, DEFAULT_OPTS);
		self._opts        = opts || {};
		self._plugins     = {};
		self._itemManager = itemManager = new (self.opts(OPT_ITEM_MANAGER))();
		input             = $(input);
		container         = $(self.opts(OPT_HTML_WRAP));
		hiddenInput       = $(self.opts(OPT_HTML_HIDDEN));

		input
			.wrap(container)
			.keydown(function(e) { return self.onKeyDown(e) })
			.keyup(function(e) { return self.onKeyUp(e) })
			.data('textext', self)
			;

		// keep references to html elements using jQuery.data() to avoid circular references
		$(self).data({
			'hiddenInput'   : hiddenInput,
			'wrapElement' : input.parents('.text-wrap').first(),
			'input'         : input
		});

		// set the name of the hidden input to the text input's name
		hiddenInput.attr('name', input.attr('name'));
		// remove name attribute from the text input
		input.attr('name', null);
		// add hidden input to the DOM
		hiddenInput.insertAfter(input);

		$.extend(true, itemManager, self.opts(OPT_EXT + '.item.manager'));
		$.extend(true, self, self.opts(OPT_EXT + '.*'), self.opts(OPT_EXT + '.core'));
		
		self.originalWidth = input.outerWidth();

		self.invalidateBounds();

		itemManager.init(self);

		self.initPatches();
		self.initPlugins(self.opts(OPT_PLUGINS), $.fn.textext.plugins);

		self.on({
			setFormData  : self.onSetFormData,
			getFormData  : self.onGetFormData,
			setInputData : self.onSetInputData,
			anyKeyUp     : self.onAnyKeyUp
		});

		self.trigger(EVENT_POST_INIT);
		self.trigger(EVENT_READY);

		self.getFormData(0);
	};

	/**
	 * Initialized all installed patches against current instance. The patches are initialized based on their
	 * initialization priority which is returned by each patch's `initPriority()` method. Priority
	 * is a `Number` where patches with higher value gets their `init()` method called before patches
	 * with lower priority value.
	 *
	 * This facilitates initializing of patches in certain order to insure proper dependencies
	 * regardless of which order they are loaded.
	 *
	 * By default all patches have the same priority - zero, which means they will be initialized
	 * in rorder they are loaded, that is unless `initPriority()` is overriden.
	 *
	 * @signature TextExt.initPatches()
	 *
	 * @author agorbatchev
	 * @date 2011/10/11
	 * @id TextExt.initPatches
	 */
	p.initPatches = function()
	{
		var list   = [],
			source = $.fn.textext.patches,
			name
			;

		for(name in source)
			list.push(name);

		this.initPlugins(list, source);
	};

	/**
	 * Creates and initializes all specified plugins. The plugins are initialized based on their
	 * initialization priority which is returned by each plugin's `initPriority()` method. Priority
	 * is a `Number` where plugins with higher value gets their `init()` method called before plugins
	 * with lower priority value.
	 *
	 * This facilitates initializing of plugins in certain order to insure proper dependencies
	 * regardless of which order user enters them in the `plugins` option field.
	 *
	 * By default all plugins have the same priority - zero, which means they will be initialized
	 * in the same order as entered by the user.
	 *
	 * @signature TextExt.initPlugins(plugins)
	 *
	 * @param plugins {Array} List of plugin names to initialize.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.initPlugins
	 */
	p.initPlugins = function(plugins, source)
	{
		var self = this,
			ext, name, plugin, initList = [], i
			;

		if(typeof(plugins) == 'string')
			plugins = plugins.split(/\s*,\s*|\s+/g);

		for(i = 0; i < plugins.length; i++)
		{
			name   = plugins[i];
			plugin = source[name];

			if(plugin)
			{
				self._plugins[name] = plugin = new plugin();
				self[name] = (function(plugin) { 
				  return function(){ return plugin; } 
				})(plugin);
				initList.push(plugin);
				$.extend(true, plugin, self.opts(OPT_EXT + '.*'), self.opts(OPT_EXT + '.' + name));
			}
		}

		// sort plugins based on their priority values
		initList.sort(function(p1, p2)
		{
			p1 = p1.initPriority();
			p2 = p2.initPriority();

			return p1 === p2
				? 0
				: p1 < p2 ? 1 : -1
				;
		});

		for(i = 0; i < initList.length; i++)
			initList[i].init(self);
	};

	/**
	 * Returns true if specified plugin is was instantiated for the current instance of core.
	 *
	 * @signature TextExt.hasPlugin(name)
	 *
	 * @param name {String} Name of the plugin to check.
	 *
	 * @author agorbatchev
	 * @date 2011/12/28
	 * @id TextExt.hasPlugin
	 * @version 1.1
	 */
	p.hasPlugin = function(name)
	{
		return !!this._plugins[name];
	};

	/**
	 * Allows to add multiple event handlers which will be execued in the scope of the current object.
	 * 
	 * @signature TextExt.on([target], handlers)
	 *
	 * @param target {Object} **Optional**. Target object which has traditional `bind(event, handler)` method.
	 *                        Handler function will still be executed in the current object's scope.
	 * @param handlers {Object} Key/value pairs of event names and handlers, eg `{ event: handler }`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.on
	 */
	p.on = hookupEvents;

	/**
	 * Binds an event handler to the input box that user interacts with.
	 *
	 * @signature TextExt.bind(event, handler)
	 *
	 * @param event {String} Event name.
	 * @param handler {Function} Event handler.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.bind
	 */
	p.bind = function(event, handler)
	{
		this.input().bind(event, handler);
	};

	/**
	 * Triggers an event on the input box that user interacts with. All core events are originated here.
	 * 
	 * @signature TextExt.trigger(event, ...args)
	 *
	 * @param event {String} Name of the event to trigger.
	 * @param ...args All remaining arguments will be passed to the event handler.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.trigger
	 */
	p.trigger = function()
	{
		var args = arguments;
		this.input().trigger(args[0], slice.call(args, 1));
	};

	/**
	 * Returns instance of `itemManager` that is used by the component.
	 *
	 * @signature TextExt.itemManager()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.itemManager
	 */
	p.itemManager = function()
	{
		return this._itemManager;
	};

	/**
	 * Returns jQuery input element with which user is interacting with.
	 *
	 * @signature TextExt.input()
	 *
	 * @author agorbatchev
	 * @date 2011/08/10
	 * @id TextExt.input
	 */
	p.input = function()
	{
		return $(this).data('input');
	};

	/**
	 * Returns option value for the specified option by name. If the value isn't found in the user
	 * provided options, it will try looking for default value.
	 *
	 * @signature TextExt.opts(name)
	 *
	 * @param name {String} Option name as described in the options.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.opts
	 */
	p.opts = function(name)
	{
		var result = getProperty(this._opts, name);
		return typeof(result) == 'undefined' ? getProperty(this._defaults, name) : result;
	};

	/**
	 * Returns HTML element that was created from the `html.wrap` option. This is the top level HTML
	 * container for the text input with which user is interacting with.
	 *
	 * @signature TextExt.wrapElement()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.wrapElement
	 */
	p.wrapElement = function()
	{
		return $(this).data('wrapElement');
	};

	/**
	 * Updates container to match dimensions of the text input. Triggers `preInvalidate` and `postInvalidate`
	 * events.
	 *
	 * @signature TextExt.invalidateBounds()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.invalidateBounds
	 */
	p.invalidateBounds = function()
	{
		var self      = this,
			input     = self.input(),
			wrap      = self.wrapElement(),
			container = wrap.parent(),
			width     = self.originalWidth + 'px',
			height
			;

		self.trigger(EVENT_PRE_INVALIDATE);

		height = input.outerHeight() + 'px';

		// using css() method instead of width() and height() here because they don't seem to do the right thing in jQuery 1.8.x
		// https://github.com/alexgorbatchev/jquery-textext/issues/74
		input.css({ 'width' : width });
		wrap.css({ 'width' : width, 'height' : height });
		container.css({ 'height' : height }); 

		self.trigger(EVENT_POST_INVALIDATE);
	};

	/**
	 * Focuses user input on the text box.
	 *
	 * @signature TextExt.focusInput()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.focusInput
	 */
	p.focusInput = function()
	{
		this.input()[0].focus();
	};

	/**
	 * Serializes data for to be set into the hidden input field and which will be submitted 
	 * with the HTML form.
	 *
	 * By default simple JSON serialization is used. It's expected that `JSON.stringify`
	 * method would be available either through built in class in most modern browsers
	 * or through JSON2 library.
	 *
	 * @signature TextExt.serializeData(data)
	 *
	 * @param data {Object} Data to serialize.
	 *
	 * @author agorbatchev
	 * @date 2011/08/09
	 * @id TextExt.serializeData
	 */
	p.serializeData = stringify;

	/**
	 * Returns the hidden input HTML element which will be submitted with the HTML form.
	 *
	 * @signature TextExt.hiddenInput()
	 *
	 * @author agorbatchev
	 * @date 2011/08/09
	 * @id TextExt.hiddenInput
	 */
	p.hiddenInput = function(value)
	{
		return $(this).data('hiddenInput');
	};

	/**
	 * Abstracted functionality to trigger an event and get the data with maximum weight set by all
	 * the event handlers. This functionality is used for the `getFormData` event.
	 *
	 * @signature TextExt.getWeightedEventResponse(event, args)
	 *
	 * @param event {String} Event name.
	 * @param args {Object} Argument to be passed with the event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExt.getWeightedEventResponse
	 */
	p.getWeightedEventResponse = function(event, args)
	{
		var self      = this,
			data      = {},
			maxWeight = 0
			;

		self.trigger(event, data, args);

		for(var weight in data)
			maxWeight = Math.max(maxWeight, weight);

		return data[maxWeight];
	};

	/**
	 * Triggers the `getFormData` event to get all the plugins to return their data.
	 *
	 * After the data is returned, triggers `setFormData` and `setInputData` to update appopriate values.
	 *
	 * @signature TextExt.getFormData(keyCode)
	 *
	 * @param keyCode {Number} Key code number which has triggered this update. It's impotant to pass
	 * this value to the plugins because they might return different values based on the key that was 
	 * pressed. For example, the Tags plugin returns an empty string for the `input` value if the enter
	 * key was pressed, otherwise it returns whatever is currently in the text input.
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExt.getFormData
	 */
	p.getFormData = function(keyCode)
	{
		var self = this,
			data = self.getWeightedEventResponse(EVENT_GET_FORM_DATA, keyCode || 0)
			;

		self.trigger(EVENT_SET_FORM_DATA  , data['form']);
		self.trigger(EVENT_SET_INPUT_DATA , data['input']);
	};

	//--------------------------------------------------------------------------------
	// Event handlers

	/**
	 * Reacts to the `anyKeyUp` event and triggers the `getFormData` to change data that will be submitted
	 * with the form. Default behaviour is that everything that is typed in will be JSON serialized, so
	 * the end result will be a JSON string.
	 *
	 * @signature TextExt.onAnyKeyUp(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.onAnyKeyUp
	 */
	p.onAnyKeyUp = function(e, keyCode)
	{
		this.getFormData(keyCode);
	};

	/**
	 * Reacts to the `setInputData` event and populates the input text field that user is currently
	 * interacting with.
	 *
	 * @signature TextExt.onSetInputData(e, data)
	 *
	 * @param e {Event} jQuery event.
	 * @param data {String} Value to be set.
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExt.onSetInputData
	 */
	p.onSetInputData = function(e, data)
	{
		this.input().val(data);
	};

	/**
	 * Reacts to the `setFormData` event and populates the hidden input with will be submitted with
	 * the HTML form. The value will be serialized with `serializeData()` method.
	 *
	 * @signature TextExt.onSetFormData(e, data)
	 *
	 * @param e {Event} jQuery event.
	 * @param data {Object} Data that will be set.
	 * 
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExt.onSetFormData
	 */
	p.onSetFormData = function(e, data)
	{
		var self = this;
		self.hiddenInput().val(self.serializeData(data));
	};

	/**
	 * Reacts to `getFormData` event triggered by the core. At the bare minimum the core will tell
	 * itself to use the current value in the text input as the data to be submitted with the HTML
	 * form.
	 *
	 * @signature TextExt.onGetFormData(e, data)
	 *
	 * @param e {Event} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/09
	 * @id TextExt.onGetFormData
	 */
	p.onGetFormData = function(e, data)
	{
		var val = this.input().val();
		data[0] = formDataObject(val, val);
	};

	//--------------------------------------------------------------------------------
	// User mouse/keyboard input

	/**
	 * Triggers `[name]KeyUp` and `[name]KeyPress` for every keystroke as described in the events.
	 *
	 * @signature TextExt.onKeyUp(e)
	 *
	 * @param e {Object} jQuery event.
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.onKeyUp
	 */

	/**
	 * Triggers `[name]KeyDown` for every keystroke as described in the events.
	 *
	 * @signature TextExt.onKeyDown(e)
	 *
	 * @param e {Object} jQuery event.
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.onKeyDown
	 */
	
	$(['Down', 'Up']).each(function()
	{
		var type = this.toString();

		p['onKey' + type] = function(e)
		{
			var self          = this,
				keyName       = self.opts(OPT_KEYS)[e.keyCode],
				defaultResult = true
				;

			if(keyName)
			{
				defaultResult = keyName.substr(-1) != '!';
				keyName       = keyName.replace('!', '');

				self.trigger(keyName + 'Key' + type);

				// manual *KeyPress event fimplementation for the function keys like Enter, Backspace, etc.
				if(type == 'Up' && self._lastKeyDown == e.keyCode)
				{
					self._lastKeyDown = null;
					self.trigger(keyName + 'KeyPress');
				}

				if(type == 'Down')
					self._lastKeyDown = e.keyCode;
			}

			self.trigger('anyKey' + type, e.keyCode);

			return defaultResult;
		};
	});

	//--------------------------------------------------------------------------------
	// Plugin Base
	
	p = TextExtPlugin.prototype;

	/**
	 * Allows to add multiple event handlers which will be execued in the scope of the current object.
	 * 
	 * @signature TextExt.on([target], handlers)
	 *
	 * @param target {Object} **Optional**. Target object which has traditional `bind(event, handler)` method.
	 *                        Handler function will still be executed in the current object's scope.
	 * @param handlers {Object} Key/value pairs of event names and handlers, eg `{ event: handler }`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.on
	 */
	p.on = hookupEvents;

	/**
	 * Returns the hash object that `getFormData` triggered by the core expects.
	 *
	 * @signature TextExtPlugin.formDataObject(input, form)
	 *
	 * @param input {String} Value that will go into the text input that user is interacting with.
	 * @param form {Object} Value that will be serialized and put into the hidden that will be submitted
	 * with the HTML form.
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExtPlugin.formDataObject
	 */
	p.formDataObject = formDataObject;

	/**
	 * Initialization method called by the core during plugin instantiation. This method must be implemented
	 * by each plugin individually.
	 *
	 * @signature TextExtPlugin.init(core)
	 *
	 * @param core {TextExt} Instance of the TextExt core class.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.init
	 */
	p.init = function(core) { throw new Error('Not implemented') };

	/**
	 * Initialization method wich should be called by the plugin during the `init()` call.
	 *
	 * @signature TextExtPlugin.baseInit(core, defaults)
	 *
	 * @param core {TextExt} Instance of the TextExt core class.
	 * @param defaults {Object} Default plugin options. These will be checked if desired value wasn't
	 * found in the options supplied by the user.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.baseInit
	 */
	p.baseInit = function(core, defaults)
	{
		var self = this;

		core._defaults = $.extend(true, core._defaults, defaults);
		self._core     = core;
		self._timers   = {};
	};

	/**
	 * Allows starting of multiple timeout calls. Each time this method is called with the same
	 * timer name, the timer is reset. This functionality is useful in cases where an action needs
	 * to occur only after a certain period of inactivity. For example, making an AJAX call after 
	 * user stoped typing for 1 second.
	 *
	 * @signature TextExtPlugin.startTimer(name, delay, callback)
	 *
	 * @param name {String} Timer name.
	 * @param delay {Number} Delay in seconds.
	 * @param callback {Function} Callback function.
	 *
	 * @author agorbatchev
	 * @date 2011/08/25
	 * @id TextExtPlugin.startTimer
	 */
	p.startTimer = function(name, delay, callback)
	{
		var self = this;

		self.stopTimer(name);

		self._timers[name] = setTimeout(
			function()
			{
				delete self._timers[name];
				callback.apply(self);
			},
			delay * 1000
		);
	};

	/**
	 * Stops the timer by name without resetting it.
	 *
	 * @signature TextExtPlugin.stopTimer(name)
	 *
	 * @param name {String} Timer name.
	 *
	 * @author agorbatchev
	 * @date 2011/08/25
	 * @id TextExtPlugin.stopTimer
	 */
	p.stopTimer = function(name)
	{
		clearTimeout(this._timers[name]);
	};

	/**
	 * Returns instance of the `TextExt` to which current instance of the plugin is attached to.
	 *
	 * @signature TextExtPlugin.core()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.core
	 */
	p.core = function()
	{
		return this._core;
	};

	/**
	 * Shortcut to the core's `opts()` method. Returns option value.
	 *
	 * @signature TextExtPlugin.opts(name)
	 * 
	 * @param name {String} Option name as described in the options.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.opts
	 */
	p.opts = function(name)
	{
		return this.core().opts(name);
	};

	/**
	 * Shortcut to the core's `itemManager()` method. Returns instance of the `ItemManger` that is
	 * currently in use.
	 *
	 * @signature TextExtPlugin.itemManager()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.itemManager
	 */
	p.itemManager = function()
	{
		return this.core().itemManager();
	};

	/**
	 * Shortcut to the core's `input()` method. Returns instance of the HTML element that represents
	 * current text input.
	 *
	 * @signature TextExtPlugin.input()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.input
	 */
	p.input = function()
	{
		return this.core().input();
	};

	/**
	 * Shortcut to the commonly used `this.input().val()` call to get or set value of the text input.
	 *
	 * @signature TextExtPlugin.val(value)
	 *
	 * @param value {String} Optional value. If specified, the value will be set, otherwise it will be
	 * returned.
	 *
	 * @author agorbatchev
	 * @date 2011/08/20
	 * @id TextExtPlugin.val
	 */
	p.val = function(value)
	{
		var input = this.input();

		if(typeof(value) === UNDEFINED)
			return input.val();
		else
			input.val(value);
	};

	/**
	 * Shortcut to the core's `trigger()` method. Triggers specified event with arguments on the
	 * component core.
	 *
	 * @signature TextExtPlugin.trigger(event, ...args)
	 *
	 * @param event {String} Name of the event to trigger.
	 * @param ...args All remaining arguments will be passed to the event handler.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtPlugin.trigger
	 */
	p.trigger = function()
	{
		var core = this.core();
		core.trigger.apply(core, arguments);
	};

	/**
	 * Shortcut to the core's `bind()` method. Binds specified handler to the event.
	 *
	 * @signature TextExtPlugin.bind(event, handler)
	 *
	 * @param event {String} Event name.
	 * @param handler {Function} Event handler.
	 *
	 * @author agorbatchev
	 * @date 2011/08/20
	 * @id TextExtPlugin.bind
	 */
	p.bind = function(event, handler)
	{
		this.core().bind(event, handler);
	};

	/**
	 * Returns initialization priority for this plugin. If current plugin depends upon some other plugin
	 * to be initialized before or after, priority needs to be adjusted accordingly. Plugins with higher
	 * priority initialize before plugins with lower priority.
	 *
	 * Default initialization priority is `0`.
	 *
	 * @signature TextExtPlugin.initPriority()
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExtPlugin.initPriority
	 */
	p.initPriority = function()
	{
		return 0;
	};

	//--------------------------------------------------------------------------------
	// jQuery Integration
	
	/**
	 * TextExt integrates as a jQuery plugin available through the `$(selector).textext(opts)` call. If
	 * `opts` argument is passed, then a new instance of `TextExt` will be created for all the inputs
	 * that match the `selector`. If `opts` wasn't passed and TextExt was already intantiated for 
	 * inputs that match the `selector`, array of `TextExt` instances will be returned instead.
	 *
	 *     // will create a new instance of `TextExt` for all elements that match `.sample`
	 *     $('.sample').textext({ ... });
	 *
	 *     // will return array of all `TextExt` instances
	 *     var list = $('.sample').textext();
	 *
	 * The following properties are also exposed through the jQuery `$.fn.textext`:
	 *
	 * * `TextExt` -- `TextExt` class.
	 * * `TextExtPlugin` -- `TextExtPlugin` class.
	 * * `ItemManager` -- `ItemManager` class.
	 * * `plugins` -- Key/value table of all registered plugins.
	 * * `addPlugin(name, constructor)` -- All plugins should register themselves using this function.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExt.jquery
	 */

	var cssInjected = false;

	var textext = $.fn.textext = function(opts)
	{
		var css;
		
		if(!cssInjected && (css = $.fn.textext.css) != null)
		{
			$('head').append('<style>' + css + '</style>');
			cssInjected = true;
		}

		return this.map(function()
		{
			var self = $(this);

			if(opts == null)
				return self.data('textext');

			var instance = new TextExt();

			instance.init(self, opts);
			self.data('textext', instance);

			return instance.input()[0];
		});
	};

	/**
	 * This static function registers a new plugin which makes it available through the `plugins` option
	 * to the end user. The name specified here is the name the end user would put in the `plugins` option
	 * to add this plugin to a new instance of TextExt.
	 * 
	 * @signature $.fn.textext.addPlugin(name, constructor)
	 *
	 * @param name {String} Name of the plugin.
	 * @param constructor {Function} Plugin constructor.
	 *
	 * @author agorbatchev
	 * @date 2011/10/11
	 * @id TextExt.addPlugin
	 */
	textext.addPlugin = function(name, constructor)
	{
		textext.plugins[name] = constructor;
		constructor.prototype = new textext.TextExtPlugin();
	};

	/**
	 * This static function registers a new patch which is added to each instance of TextExt. If you are
	 * adding a new patch, make sure to call this method.
	 * 
	 * @signature $.fn.textext.addPatch(name, constructor)
	 *
	 * @param name {String} Name of the patch.
	 * @param constructor {Function} Patch constructor.
	 *
	 * @author agorbatchev
	 * @date 2011/10/11
	 * @id TextExt.addPatch
	 */
	textext.addPatch = function(name, constructor)
	{
		textext.patches[name] = constructor;
		constructor.prototype = new textext.TextExtPlugin();
	};

	textext.TextExt       = TextExt;
	textext.TextExtPlugin = TextExtPlugin;
	textext.ItemManager   = ItemManager;
	textext.plugins       = {};
	textext.patches       = {};
})(jQuery);

(function($)
{
	function TextExtIE9Patches() {};

	$.fn.textext.TextExtIE9Patches = TextExtIE9Patches;
	$.fn.textext.addPatch('ie9',TextExtIE9Patches);

	var p = TextExtIE9Patches.prototype;

	p.init = function(core)
	{
		if(navigator.userAgent.indexOf('MSIE 9') == -1)
			return;

		var self = this;

		core.on({ postInvalidate : self.onPostInvalidate });
	};

	p.onPostInvalidate = function()
	{
		var self  = this,
			input = self.input(),
			val   = input.val()
			;

		// agorbatchev :: IE9 doesn't seem to update the padding if box-sizing is on until the
		// text box value changes, so forcing this change seems to do the trick of updating
		// IE's padding visually.
		input.val(Math.random());
		input.val(val);
	};
})(jQuery);


define("textext-core", ["jquery","css!textext-core-css"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.textext;
    };
}(this)));


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('textext-tags-css.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/**
 * jQuery TextExt Plugin
 * http://textextjs.com
 *
 * @version 1.3.1
 * @copyright Copyright (C) 2011 Alex Gorbatchev. All rights reserved.
 * @license MIT License
 */
(function($)
{
	/**
	 * Tags plugin brings in the traditional tag functionality where user can assemble and
	 * edit list of tags. Tags plugin works especially well together with Autocomplete, Filter,
	 * Suggestions and Ajax plugins to provide full spectrum of features. It can also work on
	 * its own and just do one thing -- tags.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags
	 */
	function TextExtTags() {};

	$.fn.textext.TextExtTags = TextExtTags;
	$.fn.textext.addPlugin('tags', TextExtTags);

	var p = TextExtTags.prototype,

		CSS_DOT             = '.',
		CSS_TAGS_ON_TOP     = 'text-tags-on-top',
		CSS_DOT_TAGS_ON_TOP = CSS_DOT + CSS_TAGS_ON_TOP,
		CSS_TAG             = 'text-tag',
		CSS_DOT_TAG         = CSS_DOT + CSS_TAG,
		CSS_TAGS            = 'text-tags',
		CSS_DOT_TAGS        = CSS_DOT + CSS_TAGS,
		CSS_LABEL           = 'text-label',
		CSS_DOT_LABEL       = CSS_DOT + CSS_LABEL,
		CSS_REMOVE          = 'text-remove',
		CSS_DOT_REMOVE      = CSS_DOT + CSS_REMOVE,

		/**
		 * Tags plugin options are grouped under `tags` when passed to the
		 * `$().textext()` function. For example:
		 *
		 *     $('textarea').textext({
		 *         plugins: 'tags',
		 *         tags: {
		 *             items: [ "tag1", "tag2" ]
		 *         }
		 *     })
		 *
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.options
		 */

		/**
		 * This is a toggle switch to enable or disable the Tags plugin. The value is checked
		 * each time at the top level which allows you to toggle this setting on the fly.
		 *
		 * @name tags.enabled
		 * @default true
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.options.tags.enabled
		 */
		OPT_ENABLED = 'tags.enabled',

		/**
		 * Allows to specify tags which will be added to the input by default upon initialization.
		 * Each item in the array must be of the type that current `ItemManager` can understand.
		 * Default type is `String`.
		 *
		 * @name tags.items
		 * @default null
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.options.tags.items
		 */
		OPT_ITEMS = 'tags.items',

		/**
		 * HTML source that is used to generate a single tag.
		 *
		 * @name html.tag
		 * @default '<div class="text-tags"/>'
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.options.html.tag
		 */
		OPT_HTML_TAG  = 'html.tag',

		/**
		 * HTML source that is used to generate container for the tags.
		 *
		 * @name html.tags
		 * @default '<div class="text-tag"><div class="text-button"><span class="text-label"/><a class="text-remove"/></div></div>'
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.options.html.tags
		 */
		OPT_HTML_TAGS = 'html.tags',

		/**
		 * Tags plugin dispatches or reacts to the following events.
		 *
		 * @author agorbatchev
		 * @date 2011/08/17
		 * @id TextExtTags.events
		 */

		/**
		 * Tags plugin triggers the `isTagAllowed` event before adding each tag to the tag list. Other plugins have
		 * an opportunity to interrupt this by setting `result` of the second argument to `false`. For example:
		 *
		 *     $('textarea').textext({...}).bind('isTagAllowed', function(e, data)
		 *     {
		 *         if(data.tag === 'foo')
		 *             data.result = false;
		 *     })
		 *
		 * The second argument `data` has the following format: `{ tag : {Object}, result : {Boolean} }`. `tag`
		 * property is in the format that the current `ItemManager` can understand.
		 *
		 * @name isTagAllowed
		 * @author agorbatchev
		 * @date 2011/08/19
		 * @id TextExtTags.events.isTagAllowed
		 */
		EVENT_IS_TAG_ALLOWED = 'isTagAllowed',

		/**
		 * Tags plugin triggers the `tagClick` event when user clicks on one of the tags. This allows to process
		 * the click and potentially change the value of the tag (for example in case of user feedback).
		 *
		 *     $('textarea').textext({...}).bind('tagClick', function(e, tag, value, callback)
		 *     {
		 *         var newValue = window.prompt('New value', value);

		 *         if(newValue)
		 *             callback(newValue, true);
		 *     })
		 *
		 *  Callback argument has the following signature:
		 *
		 *     function(newValue, refocus)
		 *     {
		 *         ...
		 *     }
		 *
		 * Please check out [example](/manual/examples/tags-changing.html).
		 *
		 * @name tagClick
		 * @version 1.3.0
		 * @author s.stok
		 * @date 2011/01/23
		 * @id TextExtTags.events.tagClick
		 */
		EVENT_TAG_CLICK = 'tagClick',

		DEFAULT_OPTS = {
			tags : {
				enabled : true,
				items   : null
			},

			html : {
				tags : '<div class="text-tags"/>',
				tag  : '<div class="text-tag"><div class="text-button"><span class="text-label"/><a class="text-remove"/></div></div>'
			}
		}
		;

	/**
	 * Initialization method called by the core during plugin instantiation.
	 *
	 * @signature TextExtTags.init(core)
	 *
	 * @param core {TextExt} Instance of the TextExt core class.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.init
	 */
	p.init = function(core)
	{
		this.baseInit(core, DEFAULT_OPTS);
		var self  = this,
			input = self.input(),
			container
			;

		if(self.opts(OPT_ENABLED))
		{
			container = $(self.opts(OPT_HTML_TAGS));
			input.after(container);

			$(self).data('container', container);

			self.on({
				enterKeyPress    : self.onEnterKeyPress,
				backspaceKeyDown : self.onBackspaceKeyDown,
				preInvalidate    : self.onPreInvalidate,
				postInit         : self.onPostInit,
				getFormData      : self.onGetFormData
			});

			self.on(container, {
				click     : self.onClick,
				mousemove : self.onContainerMouseMove
			});

			self.on(input, {
				mousemove : self.onInputMouseMove
			});
		}

		self._originalPadding = {
			left : parseInt(input.css('paddingLeft') || 0),
			top  : parseInt(input.css('paddingTop') || 0)
		};

		self._paddingBox = {
			left : 0,
			top  : 0
		};

		self.updateFormCache();
	};

	/**
	 * Returns HTML element in which all tag HTML elements are residing.
	 *
	 * @signature TextExtTags.containerElement()
	 *
	 * @author agorbatchev
	 * @date 2011/08/15
	 * @id TextExtTags.containerElement
	 */
	p.containerElement = function()
	{
		return $(this).data('container');
	};

	//--------------------------------------------------------------------------------
	// Event handlers

	/**
	 * Reacts to the `postInit` event triggered by the core and sets default tags
	 * if any were specified.
	 *
	 * @signature TextExtTags.onPostInit(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/09
	 * @id TextExtTags.onPostInit
	 */
	p.onPostInit = function(e)
	{
		var self = this;
		self.addTags(self.opts(OPT_ITEMS));
	};

	/**
	 * Reacts to the [`getFormData`][1] event triggered by the core. Returns data with the
	 * weight of 200 to be *greater than the Autocomplete plugin* data weight. The weights
	 * system is covered in greater detail in the [`getFormData`][1] event documentation.
	 *
	 * [1]: /manual/textext.html#getformdata
	 *
	 * @signature TextExtTags.onGetFormData(e, data, keyCode)
	 *
	 * @param e {Object} jQuery event.
	 * @param data {Object} Data object to be populated.
	 * @param keyCode {Number} Key code that triggered the original update request.
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExtTags.onGetFormData
	 */
	p.onGetFormData = function(e, data, keyCode)
	{
		var self       = this,
			inputValue = keyCode === 13 ? '' : self.val(),
			formValue  = self._formData
			;

		data[200] = self.formDataObject(inputValue, formValue);
	};

	/**
	 * Returns initialization priority of the Tags plugin which is expected to be
	 * *less than the Autocomplete plugin* because of the dependencies. The value is
	 * 100.
	 *
	 * @signature TextExtTags.initPriority()
	 *
	 * @author agorbatchev
	 * @date 2011/08/22
	 * @id TextExtTags.initPriority
	 */
	p.initPriority = function()
	{
		return 100;
	};

	/**
	 * Reacts to user moving mouse over the text area when cursor is over the text
	 * and not over the tags. Whenever mouse cursor is over the area covered by
	 * tags, the tags container is flipped to be on top of the text area which
	 * makes all tags functional with the mouse.
	 *
	 * @signature TextExtTags.onInputMouseMove(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/08
	 * @id TextExtTags.onInputMouseMove
	 */
	p.onInputMouseMove = function(e)
	{
		this.toggleZIndex(e);
	};

	/**
	 * Reacts to user moving mouse over the tags. Whenever the cursor moves out
	 * of the tags and back into where the text input is happening visually,
	 * the tags container is sent back under the text area which allows user
	 * to interact with the text using mouse cursor as expected.
	 *
	 * @signature TextExtTags.onContainerMouseMove(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/08
	 * @id TextExtTags.onContainerMouseMove
	 */
	p.onContainerMouseMove = function(e)
	{
		this.toggleZIndex(e);
	};

	/**
	 * Reacts to the `backspaceKeyDown` event. When backspace key is pressed in an empty text field,
	 * deletes last tag from the list.
	 *
	 * @signature TextExtTags.onBackspaceKeyDown(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/02
	 * @id TextExtTags.onBackspaceKeyDown
	 */
	p.onBackspaceKeyDown = function(e)
	{
		var self    = this,
			lastTag = self.tagElements().last()
			;

		if(self.val().length == 0)
			self.removeTag(lastTag);
	};

	/**
	 * Reacts to the `preInvalidate` event and updates the input box to look like the tags are
	 * positioned inside it.
	 *
	 * @signature TextExtTags.onPreInvalidate(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.onPreInvalidate
	 */
	p.onPreInvalidate = function(e)
	{
		var self    = this,
			lastTag = self.tagElements().last(),
			pos     = lastTag.position()
			;

		if(lastTag.length > 0)
			pos.left += lastTag.innerWidth();
		else
			pos = self._originalPadding;

		self._paddingBox = pos;

		self.input().css({
			paddingLeft : pos.left,
			paddingTop  : pos.top
		});
	};

	/**
	 * Reacts to the mouse `click` event.
	 *
	 * @signature TextExtTags.onClick(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.onClick
	 */
	p.onClick = function(e)
	{
		var self   = this,
			core   = self.core(),
			source = $(e.target),
			focus  = 0,
			tag
			;

		if(source.is(CSS_DOT_TAGS))
		{
			focus = 1;
		}
		else if(source.is(CSS_DOT_REMOVE))
		{
			self.removeTag(source.parents(CSS_DOT_TAG + ':first'));
			focus = 1;
		}
		else if(source.is(CSS_DOT_LABEL))
		{
			tag = source.parents(CSS_DOT_TAG + ':first');
			self.trigger(EVENT_TAG_CLICK, tag, tag.data(CSS_TAG), tagClickCallback);
		}

		function tagClickCallback(newValue, refocus)
		{
			tag.data(CSS_TAG, newValue);
			tag.find(CSS_DOT_LABEL).text(self.itemManager().itemToString(newValue));

			self.updateFormCache();
			core.getFormData();
			core.invalidateBounds();

			if(refocus)
				core.focusInput();
		}

		if(focus)
			core.focusInput();
	};

	/**
	 * Reacts to the `enterKeyPress` event and adds whatever is currently in the text input
	 * as a new tag. Triggers `isTagAllowed` to check if the tag could be added first.
	 *
	 * @signature TextExtTags.onEnterKeyPress(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.onEnterKeyPress
	 */
	p.onEnterKeyPress = function(e)
	{
		var self = this,
			val  = self.val(),
			tag  = self.itemManager().stringToItem(val)
			;

		if(self.isTagAllowed(tag))
		{
			self.addTags([ tag ]);
			// refocus the textarea just in case it lost the focus
			self.core().focusInput();
		}
	};

	//--------------------------------------------------------------------------------
	// Core functionality

	/**
	 * Creates a cache object with all the tags currently added which will be returned
	 * in the `onGetFormData` handler.
	 *
	 * @signature TextExtTags.updateFormCache()
	 *
	 * @author agorbatchev
	 * @date 2011/08/09
	 * @id TextExtTags.updateFormCache
	 */
	p.updateFormCache = function()
	{
		var self   = this,
			result = []
			;

		self.tagElements().each(function()
		{
			result.push($(this).data(CSS_TAG));
		});

		// cache the results to be used in the onGetFormData
		self._formData = result;
	};

	/**
	 * Toggles tag container to be on top of the text area or under based on where
	 * the mouse cursor is located. When cursor is above the text input and out of
	 * any of the tags, the tags container is sent under the text area. If cursor
	 * is over any of the tags, the tag container is brought to be over the text
	 * area.
	 *
	 * @signature TextExtTags.toggleZIndex(e)
	 *
	 * @param e {Object} jQuery event.
	 *
	 * @author agorbatchev
	 * @date 2011/08/08
	 * @id TextExtTags.toggleZIndex
	 */
	p.toggleZIndex = function(e)
	{
		var self            = this,
			offset          = self.input().offset(),
			mouseX          = e.clientX - offset.left,
			mouseY          = e.clientY - offset.top,
			box             = self._paddingBox,
			container       = self.containerElement(),
			isOnTop         = container.is(CSS_DOT_TAGS_ON_TOP),
			isMouseOverText = mouseX > box.left && mouseY > box.top
			;

		if(!isOnTop && !isMouseOverText || isOnTop && isMouseOverText)
			container[(!isOnTop ? 'add' : 'remove') + 'Class'](CSS_TAGS_ON_TOP);
	};

	/**
	 * Returns all tag HTML elements.
	 *
	 * @signature TextExtTags.tagElements()
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.tagElements
	 */
	p.tagElements = function()
	{
		return this.containerElement().find(CSS_DOT_TAG);
	};

	/**
	 * Wrapper around the `isTagAllowed` event which triggers it and returns `true`
	 * if `result` property of the second argument remains `true`.
	 *
	 * @signature TextExtTags.isTagAllowed(tag)
	 *
	 * @param tag {Object} Tag object that the current `ItemManager` can understand.
	 * Default is `String`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.isTagAllowed
	 */
	p.isTagAllowed = function(tag)
	{
		var opts = { tag : tag, result : true };
		this.trigger(EVENT_IS_TAG_ALLOWED, opts);
		return opts.result === true;
	};

	/**
	 * Adds specified tags to the tag list. Triggers `isTagAllowed` event for each tag
	 * to insure that it could be added. Calls `TextExt.getFormData()` to refresh the data.
	 *
	 * @signature TextExtTags.addTags(tags)
	 *
	 * @param tags {Array} List of tags that current `ItemManager` can understand. Default
	 * is `String`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.addTags
	 */
	p.addTags = function(tags)
	{
		if(!tags || tags.length == 0)
			return;

		var self      = this,
			core      = self.core(),
			container = self.containerElement(),
			i, tag
			;

		for(i = 0; i < tags.length; i++)
		{
			tag = tags[i];

			if(tag && self.isTagAllowed(tag))
				container.append(self.renderTag(tag));
		}

		self.updateFormCache();
		core.getFormData();
		core.invalidateBounds();
	};

	/**
	 * Returns HTML element for the specified tag.
	 *
	 * @signature TextExtTags.getTagElement(tag)
	 *
	 * @param tag {Object} Tag object in the format that current `ItemManager` can understand.
	 * Default is `String`.

	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.getTagElement
	 */
	p.getTagElement = function(tag)
	{
		var self = this,
			list = self.tagElements(),
			i, item
			;

		for(i = 0; i < list.length, item = $(list[i]); i++)
			if(self.itemManager().compareItems(item.data(CSS_TAG), tag))
				return item;
	};

	/**
	 * Removes specified tag from the list. Calls `TextExt.getFormData()` to refresh the data.
	 *
	 * @signature TextExtTags.removeTag(tag)
	 *
	 * @param tag {Object} Tag object in the format that current `ItemManager` can understand.
	 * Default is `String`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.removeTag
	 */
	p.removeTag = function(tag)
	{
		var self = this,
			core = self.core(),
			element
			;

		if(tag instanceof $)
		{
			element = tag;
			tag = tag.data(CSS_TAG);
		}
		else
		{
			element = self.getTagElement(tag);
		}

		element.remove();
		self.updateFormCache();
		core.getFormData();
		core.invalidateBounds();
	};

	/**
	 * Creates and returns new HTML element from the source code specified in the `html.tag` option.
	 *
	 * @signature TextExtTags.renderTag(tag)
	 *
	 * @param tag {Object} Tag object in the format that current `ItemManager` can understand.
	 * Default is `String`.
	 *
	 * @author agorbatchev
	 * @date 2011/08/19
	 * @id TextExtTags.renderTag
	 */
	p.renderTag = function(tag)
	{
		var self = this,
			node = $(self.opts(OPT_HTML_TAG))
			;

		node.find('.text-label').text(self.itemManager().itemToString(tag));
		node.data(CSS_TAG, tag);
		return node;
	};
})(jQuery);

define("textext-tags", ["textext-core","css!textext-tags-css"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.textext.TextExtTags;
    };
}(this)));

/**
 * @license text 2.0.15 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/text/LICENSE
 */
/*jslint regexp: true */
/*global require, XMLHttpRequest, ActiveXObject,
  define, window, process, Packages,
  java, location, Components, FileUtils */

define('text',['module'], function (module) {
    'use strict';

    var text, fs, Cc, Ci, xpcIsWindows,
        progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'],
        xmlRegExp = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im,
        bodyRegExp = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
        hasLocation = typeof location !== 'undefined' && location.href,
        defaultProtocol = hasLocation && location.protocol && location.protocol.replace(/\:/, ''),
        defaultHostName = hasLocation && location.hostname,
        defaultPort = hasLocation && (location.port || undefined),
        buildMap = {},
        masterConfig = (module.config && module.config()) || {};

    function useDefault(value, defaultValue) {
        return value === undefined || value === '' ? defaultValue : value;
    }

    //Allow for default ports for http and https.
    function isSamePort(protocol1, port1, protocol2, port2) {
        if (port1 === port2) {
            return true;
        } else if (protocol1 === protocol2) {
            if (protocol1 === 'http') {
                return useDefault(port1, '80') === useDefault(port2, '80');
            } else if (protocol1 === 'https') {
                return useDefault(port1, '443') === useDefault(port2, '443');
            }
        }
        return false;
    }

    text = {
        version: '2.0.15',

        strip: function (content) {
            //Strips <?xml ...?> declarations so that external SVG and XML
            //documents can be added to a document without worry. Also, if the string
            //is an HTML document, only the part inside the body tag is returned.
            if (content) {
                content = content.replace(xmlRegExp, "");
                var matches = content.match(bodyRegExp);
                if (matches) {
                    content = matches[1];
                }
            } else {
                content = "";
            }
            return content;
        },

        jsEscape: function (content) {
            return content.replace(/(['\\])/g, '\\$1')
                .replace(/[\f]/g, "\\f")
                .replace(/[\b]/g, "\\b")
                .replace(/[\n]/g, "\\n")
                .replace(/[\t]/g, "\\t")
                .replace(/[\r]/g, "\\r")
                .replace(/[\u2028]/g, "\\u2028")
                .replace(/[\u2029]/g, "\\u2029");
        },

        createXhr: masterConfig.createXhr || function () {
            //Would love to dump the ActiveX crap in here. Need IE 6 to die first.
            var xhr, i, progId;
            if (typeof XMLHttpRequest !== "undefined") {
                return new XMLHttpRequest();
            } else if (typeof ActiveXObject !== "undefined") {
                for (i = 0; i < 3; i += 1) {
                    progId = progIds[i];
                    try {
                        xhr = new ActiveXObject(progId);
                    } catch (e) {}

                    if (xhr) {
                        progIds = [progId];  // so faster next time
                        break;
                    }
                }
            }

            return xhr;
        },

        /**
         * Parses a resource name into its component parts. Resource names
         * look like: module/name.ext!strip, where the !strip part is
         * optional.
         * @param {String} name the resource name
         * @returns {Object} with properties "moduleName", "ext" and "strip"
         * where strip is a boolean.
         */
        parseName: function (name) {
            var modName, ext, temp,
                strip = false,
                index = name.lastIndexOf("."),
                isRelative = name.indexOf('./') === 0 ||
                             name.indexOf('../') === 0;

            if (index !== -1 && (!isRelative || index > 1)) {
                modName = name.substring(0, index);
                ext = name.substring(index + 1);
            } else {
                modName = name;
            }

            temp = ext || modName;
            index = temp.indexOf("!");
            if (index !== -1) {
                //Pull off the strip arg.
                strip = temp.substring(index + 1) === "strip";
                temp = temp.substring(0, index);
                if (ext) {
                    ext = temp;
                } else {
                    modName = temp;
                }
            }

            return {
                moduleName: modName,
                ext: ext,
                strip: strip
            };
        },

        xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/,

        /**
         * Is an URL on another domain. Only works for browser use, returns
         * false in non-browser environments. Only used to know if an
         * optimized .js version of a text resource should be loaded
         * instead.
         * @param {String} url
         * @returns Boolean
         */
        useXhr: function (url, protocol, hostname, port) {
            var uProtocol, uHostName, uPort,
                match = text.xdRegExp.exec(url);
            if (!match) {
                return true;
            }
            uProtocol = match[2];
            uHostName = match[3];

            uHostName = uHostName.split(':');
            uPort = uHostName[1];
            uHostName = uHostName[0];

            return (!uProtocol || uProtocol === protocol) &&
                   (!uHostName || uHostName.toLowerCase() === hostname.toLowerCase()) &&
                   ((!uPort && !uHostName) || isSamePort(uProtocol, uPort, protocol, port));
        },

        finishLoad: function (name, strip, content, onLoad) {
            content = strip ? text.strip(content) : content;
            if (masterConfig.isBuild) {
                buildMap[name] = content;
            }
            onLoad(content);
        },

        load: function (name, req, onLoad, config) {
            //Name has format: some.module.filext!strip
            //The strip part is optional.
            //if strip is present, then that means only get the string contents
            //inside a body tag in an HTML string. For XML/SVG content it means
            //removing the <?xml ...?> declarations so the content can be inserted
            //into the current doc without problems.

            // Do not bother with the work if a build and text will
            // not be inlined.
            if (config && config.isBuild && !config.inlineText) {
                onLoad();
                return;
            }

            masterConfig.isBuild = config && config.isBuild;

            var parsed = text.parseName(name),
                nonStripName = parsed.moduleName +
                    (parsed.ext ? '.' + parsed.ext : ''),
                url = req.toUrl(nonStripName),
                useXhr = (masterConfig.useXhr) ||
                         text.useXhr;

            // Do not load if it is an empty: url
            if (url.indexOf('empty:') === 0) {
                onLoad();
                return;
            }

            //Load the text. Use XHR if possible and in a browser.
            if (!hasLocation || useXhr(url, defaultProtocol, defaultHostName, defaultPort)) {
                text.get(url, function (content) {
                    text.finishLoad(name, parsed.strip, content, onLoad);
                }, function (err) {
                    if (onLoad.error) {
                        onLoad.error(err);
                    }
                });
            } else {
                //Need to fetch the resource across domains. Assume
                //the resource has been optimized into a JS module. Fetch
                //by the module name + extension, but do not include the
                //!strip part to avoid file system issues.
                req([nonStripName], function (content) {
                    text.finishLoad(parsed.moduleName + '.' + parsed.ext,
                                    parsed.strip, content, onLoad);
                });
            }
        },

        write: function (pluginName, moduleName, write, config) {
            if (buildMap.hasOwnProperty(moduleName)) {
                var content = text.jsEscape(buildMap[moduleName]);
                write.asModule(pluginName + "!" + moduleName,
                               "define(function () { return '" +
                                   content +
                               "';});\n");
            }
        },

        writeFile: function (pluginName, moduleName, req, write, config) {
            var parsed = text.parseName(moduleName),
                extPart = parsed.ext ? '.' + parsed.ext : '',
                nonStripName = parsed.moduleName + extPart,
                //Use a '.js' file name so that it indicates it is a
                //script that can be loaded across domains.
                fileName = req.toUrl(parsed.moduleName + extPart) + '.js';

            //Leverage own load() method to load plugin value, but only
            //write out values that do not have the strip argument,
            //to avoid any potential issues with ! in file names.
            text.load(nonStripName, req, function (value) {
                //Use own write() method to construct full module value.
                //But need to create shell that translates writeFile's
                //write() to the right interface.
                var textWrite = function (contents) {
                    return write(fileName, contents);
                };
                textWrite.asModule = function (moduleName, contents) {
                    return write.asModule(moduleName, fileName, contents);
                };

                text.write(pluginName, nonStripName, textWrite, config);
            }, config);
        }
    };

    if (masterConfig.env === 'node' || (!masterConfig.env &&
            typeof process !== "undefined" &&
            process.versions &&
            !!process.versions.node &&
            !process.versions['node-webkit'] &&
            !process.versions['atom-shell'])) {
        //Using special require.nodeRequire, something added by r.js.
        fs = require.nodeRequire('fs');

        text.get = function (url, callback, errback) {
            try {
                var file = fs.readFileSync(url, 'utf8');
                //Remove BOM (Byte Mark Order) from utf8 files if it is there.
                if (file[0] === '\uFEFF') {
                    file = file.substring(1);
                }
                callback(file);
            } catch (e) {
                if (errback) {
                    errback(e);
                }
            }
        };
    } else if (masterConfig.env === 'xhr' || (!masterConfig.env &&
            text.createXhr())) {
        text.get = function (url, callback, errback, headers) {
            var xhr = text.createXhr(), header;
            xhr.open('GET', url, true);

            //Allow plugins direct access to xhr headers
            if (headers) {
                for (header in headers) {
                    if (headers.hasOwnProperty(header)) {
                        xhr.setRequestHeader(header.toLowerCase(), headers[header]);
                    }
                }
            }

            //Allow overrides specified in config
            if (masterConfig.onXhr) {
                masterConfig.onXhr(xhr, url);
            }

            xhr.onreadystatechange = function (evt) {
                var status, err;
                //Do not explicitly handle errors, those should be
                //visible via console output in the browser.
                if (xhr.readyState === 4) {
                    status = xhr.status || 0;
                    if (status > 399 && status < 600) {
                        //An http 4xx or 5xx error. Signal an error.
                        err = new Error(url + ' HTTP status: ' + status);
                        err.xhr = xhr;
                        if (errback) {
                            errback(err);
                        }
                    } else {
                        callback(xhr.responseText);
                    }

                    if (masterConfig.onXhrComplete) {
                        masterConfig.onXhrComplete(xhr, url);
                    }
                }
            };
            xhr.send(null);
        };
    } else if (masterConfig.env === 'rhino' || (!masterConfig.env &&
            typeof Packages !== 'undefined' && typeof java !== 'undefined')) {
        //Why Java, why is this so awkward?
        text.get = function (url, callback) {
            var stringBuffer, line,
                encoding = "utf-8",
                file = new java.io.File(url),
                lineSeparator = java.lang.System.getProperty("line.separator"),
                input = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(file), encoding)),
                content = '';
            try {
                stringBuffer = new java.lang.StringBuffer();
                line = input.readLine();

                // Byte Order Mark (BOM) - The Unicode Standard, version 3.0, page 324
                // http://www.unicode.org/faq/utf_bom.html

                // Note that when we use utf-8, the BOM should appear as "EF BB BF", but it doesn't due to this bug in the JDK:
                // http://bugs.sun.com/bugdatabase/view_bug.do?bug_id=4508058
                if (line && line.length() && line.charAt(0) === 0xfeff) {
                    // Eat the BOM, since we've already found the encoding on this file,
                    // and we plan to concatenating this buffer with others; the BOM should
                    // only appear at the top of a file.
                    line = line.substring(1);
                }

                if (line !== null) {
                    stringBuffer.append(line);
                }

                while ((line = input.readLine()) !== null) {
                    stringBuffer.append(lineSeparator);
                    stringBuffer.append(line);
                }
                //Make sure we return a JavaScript string and not a Java string.
                content = String(stringBuffer.toString()); //String
            } finally {
                input.close();
            }
            callback(content);
        };
    } else if (masterConfig.env === 'xpconnect' || (!masterConfig.env &&
            typeof Components !== 'undefined' && Components.classes &&
            Components.interfaces)) {
        //Avert your gaze!
        Cc = Components.classes;
        Ci = Components.interfaces;
        Components.utils['import']('resource://gre/modules/FileUtils.jsm');
        xpcIsWindows = ('@mozilla.org/windows-registry-key;1' in Cc);

        text.get = function (url, callback) {
            var inStream, convertStream, fileObj,
                readData = {};

            if (xpcIsWindows) {
                url = url.replace(/\//g, '\\');
            }

            fileObj = new FileUtils.File(url);

            //XPCOM, you so crazy
            try {
                inStream = Cc['@mozilla.org/network/file-input-stream;1']
                           .createInstance(Ci.nsIFileInputStream);
                inStream.init(fileObj, 1, 0, false);

                convertStream = Cc['@mozilla.org/intl/converter-input-stream;1']
                                .createInstance(Ci.nsIConverterInputStream);
                convertStream.init(inStream, "utf-8", inStream.available(),
                Ci.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER);

                convertStream.readString(inStream.available(), readData);
                convertStream.close();
                inStream.close();
                callback(readData.value);
            } catch (e) {
                throw new Error((fileObj && fileObj.path || '') + ': ' + e);
            }
        };
    }
    return text;
});

/** @license
 * RequireJS plugin for async dependency load like JSONP and Google Maps
 * Author: Miller Medeiros
 * Version: 0.1.2 (2014/02/24)
 * Released under the MIT license
 */
define('async',[],function(){

    var DEFAULT_PARAM_NAME = 'callback',
        _uid = 0;

    function injectScript(src){
        var s, t;
        s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = src;
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s,t);
    }

    function formatUrl(name, id){
        var paramRegex = /!(.+)/,
            url = name.replace(paramRegex, ''),
            param = (paramRegex.test(name))? name.replace(/.+!/, '') : DEFAULT_PARAM_NAME;
        url += (url.indexOf('?') < 0)? '?' : '&';
        return url + param +'='+ id;
    }

    function uid() {
        _uid += 1;
        return '__async_req_'+ _uid +'__';
    }

    return{
        load : function(name, req, onLoad, config){
            if(config.isBuild){
                onLoad(null); //avoid errors on the optimizer
            }else{
                var id = uid();
                //create a global variable that stores onLoad so callback
                //function can define new module after async load
                window[id] = onLoad;
                injectScript(formatUrl(req.toUrl(name), id));
            }
        }
    };
});

/**
 * Basic parser for URL properties
 * @author Miller Medeiros
 * @version 0.1.0 (2011/12/06)
 * MIT license
 */
define('propertyParser',[],function(){

    var rProps = /([\w-]+)\s*:\s*(?:(\[[^\]]+\])|([^,]+)),?/g, //match "foo:bar" and "lorem:[ipsum,dolor]" capturing name as $1 and val as $2 or $3
        rArr = /^\[([^\]]+)\]$/; //match "[foo,bar]" capturing "foo,bar"

    function parseProperties(str){
        var match, obj = {};
        while (match = rProps.exec(str)) {
            obj[ match[1] ] = typecastVal(match[2] || match[3]);
        }
        return obj;
    }

    function typecastVal(val){
        if (rArr.test(val)){
            val = val.replace(rArr, '$1').split(',');
        } else if (val === 'null'){
            val = null;
        } else if (val === 'false'){
            val = false;
        } else if (val === 'true'){
            val = true;
        } else if (val === '' || val === "''" || val === '""'){
            val = '';
        } else if (! isNaN(val)) {
            //isNaN('') == false
            val = +val;
        }
        return val;
    }

    //API
    return {
        parseProperties : parseProperties,
        typecastVal : typecastVal
    };
});

/** @license
 * RequireJS plugin for loading web fonts using the WebFont Loader
 * Author: Miller Medeiros
 * Version: 0.2.0 (2011/12/06)
 * Released under the MIT license
 */
define('font',['propertyParser'], function (propertyParser) {

    var rParts = /^([^,]+),([^\|]+)\|?/;

    function parseName(name) {
        var data = {},
            vendors = name.split('|'),
            n = vendors.length,
            match;

        while (n--) {
            match = rParts.exec(vendors[n]);
            data[ match[1] ] = propertyParser.parseProperties(match[2]);
        }
        return data;
    }

    // API
    return {

        //example: font!google,families:[Tangerine,Cantarell,Yanone Kaffeesatz:700]
        load : function(name, req, onLoad, config){
            if (config.isBuild) {
                onLoad(null); //avoid errors on the optimizer
            } else {
                var data = parseName(name);
                data.active = onLoad;
                data.inactive = function(){
                    onLoad(false);
                };
                req([(document.location.protocol === 'https:'? 'https' : 'http') +'://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js'], function(){
                    WebFont.load(data);
                });
            }
        }

    };

});

define('goog',[],function () {
    return {
        load : function(name, req, onLoad, config){
            if (config.isBuild) {
                onLoad(null); //avoid errors on the optimizer
            } else {
                onLoad({});
            }
        }
    };
});

/** @license
 * RequireJS plugin for loading JSON files
 * - depends on Text plugin and it was HEAVILY "inspired" by it as well.
 * Author: Miller Medeiros
 * Version: 0.4.0 (2014/04/10)
 * Released under the MIT license
 */
define('json',['text'], function(text){

    var CACHE_BUST_QUERY_PARAM = 'bust',
        CACHE_BUST_FLAG = '!bust',
        jsonParse = (typeof JSON !== 'undefined' && typeof JSON.parse === 'function')? JSON.parse : function(val){
            return eval('('+ val +')'); //quick and dirty
        },
        buildMap = {};

    function cacheBust(url){
        url = url.replace(CACHE_BUST_FLAG, '');
        url += (url.indexOf('?') < 0)? '?' : '&';
        return url + CACHE_BUST_QUERY_PARAM +'='+ Math.round(2147483647 * Math.random());
    }

    //API
    return {

        load : function(name, req, onLoad, config) {
            if (( config.isBuild && (config.inlineJSON === false || name.indexOf(CACHE_BUST_QUERY_PARAM +'=') !== -1)) || (req.toUrl(name).indexOf('empty:') === 0)) {
                //avoid inlining cache busted JSON or if inlineJSON:false
                //and don't inline files marked as empty!
                onLoad(null);
            } else {
                text.get(req.toUrl(name), function(data){
                    if (config.isBuild) {
                        buildMap[name] = data;
                        onLoad(data);
                    } else {
                        onLoad(jsonParse(data));
                    }
                },
                    onLoad.error, {
                        accept: 'application/json'
                    }
                );
            }
        },

        normalize : function (name, normalize) {
            // used normalize to avoid caching references to a "cache busted" request
            if (name.indexOf(CACHE_BUST_FLAG) !== -1) {
                name = cacheBust(name);
            }
            // resolve any relative paths
            return normalize(name);
        },

        //write method based on RequireJS official text plugin by James Burke
        //https://github.com/jrburke/requirejs/blob/master/text.js
        write : function(pluginName, moduleName, write){
            if(moduleName in buildMap){
                var content = buildMap[moduleName];
                write('define("'+ pluginName +'!'+ moduleName +'", function(){ return '+ content +';});\n');
            }
        }

    };
});

/**
 * @version: 1.0 Alpha-1
 * @author: Coolite Inc. http://www.coolite.com/
 * @date: 2008-05-13
 * @copyright: Copyright (c) 2006-2008, Coolite Inc. (http://www.coolite.com/). All rights reserved.
 * @license: Licensed under The MIT License. See license.txt and http://www.datejs.com/license/. 
 * @website: http://www.datejs.com/
 */
Date.CultureInfo={name:"en-US",englishName:"English (United States)",nativeName:"English (United States)",dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],abbreviatedDayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],shortestDayNames:["Su","Mo","Tu","We","Th","Fr","Sa"],firstLetterDayNames:["S","M","T","W","T","F","S"],monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],abbreviatedMonthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],amDesignator:"AM",pmDesignator:"PM",firstDayOfWeek:0,twoDigitYearMax:2029,dateElementOrder:"mdy",formatPatterns:{shortDate:"M/d/yyyy",longDate:"dddd, MMMM dd, yyyy",shortTime:"h:mm tt",longTime:"h:mm:ss tt",fullDateTime:"dddd, MMMM dd, yyyy h:mm:ss tt",sortableDateTime:"yyyy-MM-ddTHH:mm:ss",universalSortableDateTime:"yyyy-MM-dd HH:mm:ssZ",rfc1123:"ddd, dd MMM yyyy HH:mm:ss GMT",monthDay:"MMMM dd",yearMonth:"MMMM, yyyy"},regexPatterns:{jan:/^jan(uary)?/i,feb:/^feb(ruary)?/i,mar:/^mar(ch)?/i,apr:/^apr(il)?/i,may:/^may/i,jun:/^jun(e)?/i,jul:/^jul(y)?/i,aug:/^aug(ust)?/i,sep:/^sep(t(ember)?)?/i,oct:/^oct(ober)?/i,nov:/^nov(ember)?/i,dec:/^dec(ember)?/i,sun:/^su(n(day)?)?/i,mon:/^mo(n(day)?)?/i,tue:/^tu(e(s(day)?)?)?/i,wed:/^we(d(nesday)?)?/i,thu:/^th(u(r(s(day)?)?)?)?/i,fri:/^fr(i(day)?)?/i,sat:/^sa(t(urday)?)?/i,future:/^next/i,past:/^last|past|prev(ious)?/i,add:/^(\+|aft(er)?|from|hence)/i,subtract:/^(\-|bef(ore)?|ago)/i,yesterday:/^yes(terday)?/i,today:/^t(od(ay)?)?/i,tomorrow:/^tom(orrow)?/i,now:/^n(ow)?/i,millisecond:/^ms|milli(second)?s?/i,second:/^sec(ond)?s?/i,minute:/^mn|min(ute)?s?/i,hour:/^h(our)?s?/i,week:/^w(eek)?s?/i,month:/^m(onth)?s?/i,day:/^d(ay)?s?/i,year:/^y(ear)?s?/i,shortMeridian:/^(a|p)/i,longMeridian:/^(a\.?m?\.?|p\.?m?\.?)/i,timezone:/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,ordinalSuffix:/^\s*(st|nd|rd|th)/i,timeContext:/^\s*(\:|a(?!u|p)|p)/i},timezones:[{name:"UTC",offset:"-000"},{name:"GMT",offset:"-000"},{name:"EST",offset:"-0500"},{name:"EDT",offset:"-0400"},{name:"CST",offset:"-0600"},{name:"CDT",offset:"-0500"},{name:"MST",offset:"-0700"},{name:"MDT",offset:"-0600"},{name:"PST",offset:"-0800"},{name:"PDT",offset:"-0700"}]};
(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo,p=function(s,l){if(!l){l=2;}
return("000"+s).slice(l*-1);};$P.clearTime=function(){this.setHours(0);this.setMinutes(0);this.setSeconds(0);this.setMilliseconds(0);return this;};$P.setTimeToNow=function(){var n=new Date();this.setHours(n.getHours());this.setMinutes(n.getMinutes());this.setSeconds(n.getSeconds());this.setMilliseconds(n.getMilliseconds());return this;};$D.today=function(){return new Date().clearTime();};$D.compare=function(date1,date2){if(isNaN(date1)||isNaN(date2)){throw new Error(date1+" - "+date2);}else if(date1 instanceof Date&&date2 instanceof Date){return(date1<date2)?-1:(date1>date2)?1:0;}else{throw new TypeError(date1+" - "+date2);}};$D.equals=function(date1,date2){return(date1.compareTo(date2)===0);};$D.getDayNumberFromName=function(name){var n=$C.dayNames,m=$C.abbreviatedDayNames,o=$C.shortestDayNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s||o[i].toLowerCase()==s){return i;}}
return-1;};$D.getMonthNumberFromName=function(name){var n=$C.monthNames,m=$C.abbreviatedMonthNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s){return i;}}
return-1;};$D.isLeapYear=function(year){return((year%4===0&&year%100!==0)||year%400===0);};$D.getDaysInMonth=function(year,month){return[31,($D.isLeapYear(year)?29:28),31,30,31,30,31,31,30,31,30,31][month];};$D.getTimezoneAbbreviation=function(offset){var z=$C.timezones,p;for(var i=0;i<z.length;i++){if(z[i].offset===offset){return z[i].name;}}
return null;};$D.getTimezoneOffset=function(name){var z=$C.timezones,p;for(var i=0;i<z.length;i++){if(z[i].name===name.toUpperCase()){return z[i].offset;}}
return null;};$P.clone=function(){return new Date(this.getTime());};$P.compareTo=function(date){return Date.compare(this,date);};$P.equals=function(date){return Date.equals(this,date||new Date());};$P.between=function(start,end){return this.getTime()>=start.getTime()&&this.getTime()<=end.getTime();};$P.isAfter=function(date){return this.compareTo(date||new Date())===1;};$P.isBefore=function(date){return(this.compareTo(date||new Date())===-1);};$P.isToday=function(){return this.isSameDay(new Date());};$P.isSameDay=function(date){return this.clone().clearTime().equals(date.clone().clearTime());};$P.addMilliseconds=function(value){this.setMilliseconds(this.getMilliseconds()+value);return this;};$P.addSeconds=function(value){return this.addMilliseconds(value*1000);};$P.addMinutes=function(value){return this.addMilliseconds(value*60000);};$P.addHours=function(value){return this.addMilliseconds(value*3600000);};$P.addDays=function(value){this.setDate(this.getDate()+value);return this;};$P.addWeeks=function(value){return this.addDays(value*7);};$P.addMonths=function(value){var n=this.getDate();this.setDate(1);this.setMonth(this.getMonth()+value);this.setDate(Math.min(n,$D.getDaysInMonth(this.getFullYear(),this.getMonth())));return this;};$P.addYears=function(value){return this.addMonths(value*12);};$P.add=function(config){if(typeof config=="number"){this._orient=config;return this;}
var x=config;if(x.milliseconds){this.addMilliseconds(x.milliseconds);}
if(x.seconds){this.addSeconds(x.seconds);}
if(x.minutes){this.addMinutes(x.minutes);}
if(x.hours){this.addHours(x.hours);}
if(x.weeks){this.addWeeks(x.weeks);}
if(x.months){this.addMonths(x.months);}
if(x.years){this.addYears(x.years);}
if(x.days){this.addDays(x.days);}
return this;};var $y,$m,$d;$P.getWeek=function(){var a,b,c,d,e,f,g,n,s,w;$y=(!$y)?this.getFullYear():$y;$m=(!$m)?this.getMonth()+1:$m;$d=(!$d)?this.getDate():$d;if($m<=2){a=$y-1;b=(a/4|0)-(a/100|0)+(a/400|0);c=((a-1)/4|0)-((a-1)/100|0)+((a-1)/400|0);s=b-c;e=0;f=$d-1+(31*($m-1));}else{a=$y;b=(a/4|0)-(a/100|0)+(a/400|0);c=((a-1)/4|0)-((a-1)/100|0)+((a-1)/400|0);s=b-c;e=s+1;f=$d+((153*($m-3)+2)/5)+58+s;}
g=(a+b)%7;d=(f+g-e)%7;n=(f+3-d)|0;if(n<0){w=53-((g-s)/5|0);}else if(n>364+s){w=1;}else{w=(n/7|0)+1;}
$y=$m=$d=null;return w;};$P.getISOWeek=function(){$y=this.getUTCFullYear();$m=this.getUTCMonth()+1;$d=this.getUTCDate();return p(this.getWeek());};$P.setWeek=function(n){return this.moveToDayOfWeek(1).addWeeks(n-this.getWeek());};$D._validate=function(n,min,max,name){if(typeof n=="undefined"){return false;}else if(typeof n!="number"){throw new TypeError(n+" is not a Number.");}else if(n<min||n>max){throw new RangeError(n+" is not a valid value for "+name+".");}
return true;};$D.validateMillisecond=function(value){return $D._validate(value,0,999,"millisecond");};$D.validateSecond=function(value){return $D._validate(value,0,59,"second");};$D.validateMinute=function(value){return $D._validate(value,0,59,"minute");};$D.validateHour=function(value){return $D._validate(value,0,23,"hour");};$D.validateDay=function(value,year,month){return $D._validate(value,1,$D.getDaysInMonth(year,month),"day");};$D.validateMonth=function(value){return $D._validate(value,0,11,"month");};$D.validateYear=function(value){return $D._validate(value,0,9999,"year");};$P.set=function(config){if($D.validateMillisecond(config.millisecond)){this.addMilliseconds(config.millisecond-this.getMilliseconds());}
if($D.validateSecond(config.second)){this.addSeconds(config.second-this.getSeconds());}
if($D.validateMinute(config.minute)){this.addMinutes(config.minute-this.getMinutes());}
if($D.validateHour(config.hour)){this.addHours(config.hour-this.getHours());}
if($D.validateMonth(config.month)){this.addMonths(config.month-this.getMonth());}
if($D.validateYear(config.year)){this.addYears(config.year-this.getFullYear());}
if($D.validateDay(config.day,this.getFullYear(),this.getMonth())){this.addDays(config.day-this.getDate());}
if(config.timezone){this.setTimezone(config.timezone);}
if(config.timezoneOffset){this.setTimezoneOffset(config.timezoneOffset);}
if(config.week&&$D._validate(config.week,0,53,"week")){this.setWeek(config.week);}
return this;};$P.moveToFirstDayOfMonth=function(){return this.set({day:1});};$P.moveToLastDayOfMonth=function(){return this.set({day:$D.getDaysInMonth(this.getFullYear(),this.getMonth())});};$P.moveToNthOccurrence=function(dayOfWeek,occurrence){var shift=0;if(occurrence>0){shift=occurrence-1;}
else if(occurrence===-1){this.moveToLastDayOfMonth();if(this.getDay()!==dayOfWeek){this.moveToDayOfWeek(dayOfWeek,-1);}
return this;}
return this.moveToFirstDayOfMonth().addDays(-1).moveToDayOfWeek(dayOfWeek,+1).addWeeks(shift);};$P.moveToDayOfWeek=function(dayOfWeek,orient){var diff=(dayOfWeek-this.getDay()+7*(orient||+1))%7;return this.addDays((diff===0)?diff+=7*(orient||+1):diff);};$P.moveToMonth=function(month,orient){var diff=(month-this.getMonth()+12*(orient||+1))%12;return this.addMonths((diff===0)?diff+=12*(orient||+1):diff);};$P.getOrdinalNumber=function(){return Math.ceil((this.clone().clearTime()-new Date(this.getFullYear(),0,1))/86400000)+1;};$P.getTimezone=function(){return $D.getTimezoneAbbreviation(this.getUTCOffset());};$P.setTimezoneOffset=function(offset){var here=this.getTimezoneOffset(),there=Number(offset)*-6/10;return this.addMinutes(there-here);};$P.setTimezone=function(offset){return this.setTimezoneOffset($D.getTimezoneOffset(offset));};$P.hasDaylightSavingTime=function(){return(Date.today().set({month:0,day:1}).getTimezoneOffset()!==Date.today().set({month:6,day:1}).getTimezoneOffset());};$P.isDaylightSavingTime=function(){return(this.hasDaylightSavingTime()&&new Date().getTimezoneOffset()===Date.today().set({month:6,day:1}).getTimezoneOffset());};$P.getUTCOffset=function(){var n=this.getTimezoneOffset()*-10/6,r;if(n<0){r=(n-10000).toString();return r.charAt(0)+r.substr(2);}else{r=(n+10000).toString();return"+"+r.substr(1);}};$P.getElapsed=function(date){return(date||new Date())-this;};if(!$P.toISOString){$P.toISOString=function(){function f(n){return n<10?'0'+n:n;}
return'"'+this.getUTCFullYear()+'-'+
f(this.getUTCMonth()+1)+'-'+
f(this.getUTCDate())+'T'+
f(this.getUTCHours())+':'+
f(this.getUTCMinutes())+':'+
f(this.getUTCSeconds())+'Z"';};}
$P._toString=$P.toString;$P.toString=function(format){var x=this;if(format&&format.length==1){var c=$C.formatPatterns;x.t=x.toString;switch(format){case"d":return x.t(c.shortDate);case"D":return x.t(c.longDate);case"F":return x.t(c.fullDateTime);case"m":return x.t(c.monthDay);case"r":return x.t(c.rfc1123);case"s":return x.t(c.sortableDateTime);case"t":return x.t(c.shortTime);case"T":return x.t(c.longTime);case"u":return x.t(c.universalSortableDateTime);case"y":return x.t(c.yearMonth);}}
var ord=function(n){switch(n*1){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th";}};return format?format.replace(/(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,function(m){if(m.charAt(0)==="\\"){return m.replace("\\","");}
x.h=x.getHours;switch(m){case"hh":return p(x.h()<13?(x.h()===0?12:x.h()):(x.h()-12));case"h":return x.h()<13?(x.h()===0?12:x.h()):(x.h()-12);case"HH":return p(x.h());case"H":return x.h();case"mm":return p(x.getMinutes());case"m":return x.getMinutes();case"ss":return p(x.getSeconds());case"s":return x.getSeconds();case"yyyy":return p(x.getFullYear(),4);case"yy":return p(x.getFullYear());case"dddd":return $C.dayNames[x.getDay()];case"ddd":return $C.abbreviatedDayNames[x.getDay()];case"dd":return p(x.getDate());case"d":return x.getDate();case"MMMM":return $C.monthNames[x.getMonth()];case"MMM":return $C.abbreviatedMonthNames[x.getMonth()];case"MM":return p((x.getMonth()+1));case"M":return x.getMonth()+1;case"t":return x.h()<12?$C.amDesignator.substring(0,1):$C.pmDesignator.substring(0,1);case"tt":return x.h()<12?$C.amDesignator:$C.pmDesignator;case"S":return ord(x.getDate());default:return m;}}):this._toString();};}());
(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo,$N=Number.prototype;$P._orient=+1;$P._nth=null;$P._is=false;$P._same=false;$P._isSecond=false;$N._dateElement="day";$P.next=function(){this._orient=+1;return this;};$D.next=function(){return $D.today().next();};$P.last=$P.prev=$P.previous=function(){this._orient=-1;return this;};$D.last=$D.prev=$D.previous=function(){return $D.today().last();};$P.is=function(){this._is=true;return this;};$P.same=function(){this._same=true;this._isSecond=false;return this;};$P.today=function(){return this.same().day();};$P.weekday=function(){if(this._is){this._is=false;return(!this.is().sat()&&!this.is().sun());}
return false;};$P.at=function(time){return(typeof time==="string")?$D.parse(this.toString("d")+" "+time):this.set(time);};$N.fromNow=$N.after=function(date){var c={};c[this._dateElement]=this;return((!date)?new Date():date.clone()).add(c);};$N.ago=$N.before=function(date){var c={};c[this._dateElement]=this*-1;return((!date)?new Date():date.clone()).add(c);};var dx=("sunday monday tuesday wednesday thursday friday saturday").split(/\s/),mx=("january february march april may june july august september october november december").split(/\s/),px=("Millisecond Second Minute Hour Day Week Month Year").split(/\s/),pxf=("Milliseconds Seconds Minutes Hours Date Week Month FullYear").split(/\s/),nth=("final first second third fourth fifth").split(/\s/),de;$P.toObject=function(){var o={};for(var i=0;i<px.length;i++){o[px[i].toLowerCase()]=this["get"+pxf[i]]();}
return o;};$D.fromObject=function(config){config.week=null;return Date.today().set(config);};var df=function(n){return function(){if(this._is){this._is=false;return this.getDay()==n;}
if(this._nth!==null){if(this._isSecond){this.addSeconds(this._orient*-1);}
this._isSecond=false;var ntemp=this._nth;this._nth=null;var temp=this.clone().moveToLastDayOfMonth();this.moveToNthOccurrence(n,ntemp);if(this>temp){throw new RangeError($D.getDayName(n)+" does not occur "+ntemp+" times in the month of "+$D.getMonthName(temp.getMonth())+" "+temp.getFullYear()+".");}
return this;}
return this.moveToDayOfWeek(n,this._orient);};};var sdf=function(n){return function(){var t=$D.today(),shift=n-t.getDay();if(n===0&&$C.firstDayOfWeek===1&&t.getDay()!==0){shift=shift+7;}
return t.addDays(shift);};};for(var i=0;i<dx.length;i++){$D[dx[i].toUpperCase()]=$D[dx[i].toUpperCase().substring(0,3)]=i;$D[dx[i]]=$D[dx[i].substring(0,3)]=sdf(i);$P[dx[i]]=$P[dx[i].substring(0,3)]=df(i);}
var mf=function(n){return function(){if(this._is){this._is=false;return this.getMonth()===n;}
return this.moveToMonth(n,this._orient);};};var smf=function(n){return function(){return $D.today().set({month:n,day:1});};};for(var j=0;j<mx.length;j++){$D[mx[j].toUpperCase()]=$D[mx[j].toUpperCase().substring(0,3)]=j;$D[mx[j]]=$D[mx[j].substring(0,3)]=smf(j);$P[mx[j]]=$P[mx[j].substring(0,3)]=mf(j);}
var ef=function(j){return function(){if(this._isSecond){this._isSecond=false;return this;}
if(this._same){this._same=this._is=false;var o1=this.toObject(),o2=(arguments[0]||new Date()).toObject(),v="",k=j.toLowerCase();for(var m=(px.length-1);m>-1;m--){v=px[m].toLowerCase();if(o1[v]!=o2[v]){return false;}
if(k==v){break;}}
return true;}
if(j.substring(j.length-1)!="s"){j+="s";}
return this["add"+j](this._orient);};};var nf=function(n){return function(){this._dateElement=n;return this;};};for(var k=0;k<px.length;k++){de=px[k].toLowerCase();$P[de]=$P[de+"s"]=ef(px[k]);$N[de]=$N[de+"s"]=nf(de);}
$P._ss=ef("Second");var nthfn=function(n){return function(dayOfWeek){if(this._same){return this._ss(arguments[0]);}
if(dayOfWeek||dayOfWeek===0){return this.moveToNthOccurrence(dayOfWeek,n);}
this._nth=n;if(n===2&&(dayOfWeek===undefined||dayOfWeek===null)){this._isSecond=true;return this.addSeconds(this._orient);}
return this;};};for(var l=0;l<nth.length;l++){$P[nth[l]]=(l===0)?nthfn(-1):nthfn(l);}}());
(function(){Date.Parsing={Exception:function(s){this.message="Parse error at '"+s.substring(0,10)+" ...'";}};var $P=Date.Parsing;var _=$P.Operators={rtoken:function(r){return function(s){var mx=s.match(r);if(mx){return([mx[0],s.substring(mx[0].length)]);}else{throw new $P.Exception(s);}};},token:function(s){return function(s){return _.rtoken(new RegExp("^\s*"+s+"\s*"))(s);};},stoken:function(s){return _.rtoken(new RegExp("^"+s));},until:function(p){return function(s){var qx=[],rx=null;while(s.length){try{rx=p.call(this,s);}catch(e){qx.push(rx[0]);s=rx[1];continue;}
break;}
return[qx,s];};},many:function(p){return function(s){var rx=[],r=null;while(s.length){try{r=p.call(this,s);}catch(e){return[rx,s];}
rx.push(r[0]);s=r[1];}
return[rx,s];};},optional:function(p){return function(s){var r=null;try{r=p.call(this,s);}catch(e){return[null,s];}
return[r[0],r[1]];};},not:function(p){return function(s){try{p.call(this,s);}catch(e){return[null,s];}
throw new $P.Exception(s);};},ignore:function(p){return p?function(s){var r=null;r=p.call(this,s);return[null,r[1]];}:null;},product:function(){var px=arguments[0],qx=Array.prototype.slice.call(arguments,1),rx=[];for(var i=0;i<px.length;i++){rx.push(_.each(px[i],qx));}
return rx;},cache:function(rule){var cache={},r=null;return function(s){try{r=cache[s]=(cache[s]||rule.call(this,s));}catch(e){r=cache[s]=e;}
if(r instanceof $P.Exception){throw r;}else{return r;}};},any:function(){var px=arguments;return function(s){var r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){r=null;}
if(r){return r;}}
throw new $P.Exception(s);};},each:function(){var px=arguments;return function(s){var rx=[],r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){throw new $P.Exception(s);}
rx.push(r[0]);s=r[1];}
return[rx,s];};},all:function(){var px=arguments,_=_;return _.each(_.optional(px));},sequence:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;if(px.length==1){return px[0];}
return function(s){var r=null,q=null;var rx=[];for(var i=0;i<px.length;i++){try{r=px[i].call(this,s);}catch(e){break;}
rx.push(r[0]);try{q=d.call(this,r[1]);}catch(ex){q=null;break;}
s=q[1];}
if(!r){throw new $P.Exception(s);}
if(q){throw new $P.Exception(q[1]);}
if(c){try{r=c.call(this,r[1]);}catch(ey){throw new $P.Exception(r[1]);}}
return[rx,(r?r[1]:s)];};},between:function(d1,p,d2){d2=d2||d1;var _fn=_.each(_.ignore(d1),p,_.ignore(d2));return function(s){var rx=_fn.call(this,s);return[[rx[0][0],r[0][2]],rx[1]];};},list:function(p,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return(p instanceof Array?_.each(_.product(p.slice(0,-1),_.ignore(d)),p.slice(-1),_.ignore(c)):_.each(_.many(_.each(p,_.ignore(d))),px,_.ignore(c)));},set:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return function(s){var r=null,p=null,q=null,rx=null,best=[[],s],last=false;for(var i=0;i<px.length;i++){q=null;p=null;r=null;last=(px.length==1);try{r=px[i].call(this,s);}catch(e){continue;}
rx=[[r[0]],r[1]];if(r[1].length>0&&!last){try{q=d.call(this,r[1]);}catch(ex){last=true;}}else{last=true;}
if(!last&&q[1].length===0){last=true;}
if(!last){var qx=[];for(var j=0;j<px.length;j++){if(i!=j){qx.push(px[j]);}}
p=_.set(qx,d).call(this,q[1]);if(p[0].length>0){rx[0]=rx[0].concat(p[0]);rx[1]=p[1];}}
if(rx[1].length<best[1].length){best=rx;}
if(best[1].length===0){break;}}
if(best[0].length===0){return best;}
if(c){try{q=c.call(this,best[1]);}catch(ey){throw new $P.Exception(best[1]);}
best[1]=q[1];}
return best;};},forward:function(gr,fname){return function(s){return gr[fname].call(this,s);};},replace:function(rule,repl){return function(s){var r=rule.call(this,s);return[repl,r[1]];};},process:function(rule,fn){return function(s){var r=rule.call(this,s);return[fn.call(this,r[0]),r[1]];};},min:function(min,rule){return function(s){var rx=rule.call(this,s);if(rx[0].length<min){throw new $P.Exception(s);}
return rx;};}};var _generator=function(op){return function(){var args=null,rx=[];if(arguments.length>1){args=Array.prototype.slice.call(arguments);}else if(arguments[0]instanceof Array){args=arguments[0];}
if(args){for(var i=0,px=args.shift();i<px.length;i++){args.unshift(px[i]);rx.push(op.apply(null,args));args.shift();return rx;}}else{return op.apply(null,arguments);}};};var gx="optional not ignore cache".split(/\s/);for(var i=0;i<gx.length;i++){_[gx[i]]=_generator(_[gx[i]]);}
var _vector=function(op){return function(){if(arguments[0]instanceof Array){return op.apply(null,arguments[0]);}else{return op.apply(null,arguments);}};};var vx="each any all".split(/\s/);for(var j=0;j<vx.length;j++){_[vx[j]]=_vector(_[vx[j]]);}}());(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo;var flattenAndCompact=function(ax){var rx=[];for(var i=0;i<ax.length;i++){if(ax[i]instanceof Array){rx=rx.concat(flattenAndCompact(ax[i]));}else{if(ax[i]){rx.push(ax[i]);}}}
return rx;};$D.Grammar={};$D.Translator={hour:function(s){return function(){this.hour=Number(s);};},minute:function(s){return function(){this.minute=Number(s);};},second:function(s){return function(){this.second=Number(s);};},meridian:function(s){return function(){this.meridian=s.slice(0,1).toLowerCase();};},timezone:function(s){return function(){var n=s.replace(/[^\d\+\-]/g,"");if(n.length){this.timezoneOffset=Number(n);}else{this.timezone=s.toLowerCase();}};},day:function(x){var s=x[0];return function(){this.day=Number(s.match(/\d+/)[0]);};},month:function(s){return function(){this.month=(s.length==3)?"jan feb mar apr may jun jul aug sep oct nov dec".indexOf(s)/4:Number(s)-1;};},year:function(s){return function(){var n=Number(s);this.year=((s.length>2)?n:(n+(((n+2000)<$C.twoDigitYearMax)?2000:1900)));};},rday:function(s){return function(){switch(s){case"yesterday":this.days=-1;break;case"tomorrow":this.days=1;break;case"today":this.days=0;break;case"now":this.days=0;this.now=true;break;}};},finishExact:function(x){x=(x instanceof Array)?x:[x];for(var i=0;i<x.length;i++){if(x[i]){x[i].call(this);}}
var now=new Date();if((this.hour||this.minute)&&(!this.month&&!this.year&&!this.day)){this.day=now.getDate();}
if(!this.year){this.year=now.getFullYear();}
if(!this.month&&this.month!==0){this.month=now.getMonth();}
if(!this.day){this.day=1;}
if(!this.hour){this.hour=0;}
if(!this.minute){this.minute=0;}
if(!this.second){this.second=0;}
if(this.meridian&&this.hour){if(this.meridian=="p"&&this.hour<12){this.hour=this.hour+12;}else if(this.meridian=="a"&&this.hour==12){this.hour=0;}}
if(this.day>$D.getDaysInMonth(this.year,this.month)){throw new RangeError(this.day+" is not a valid value for days.");}
var r=new Date(this.year,this.month,this.day,this.hour,this.minute,this.second);if(this.timezone){r.set({timezone:this.timezone});}else if(this.timezoneOffset){r.set({timezoneOffset:this.timezoneOffset});}
return r;},finish:function(x){x=(x instanceof Array)?flattenAndCompact(x):[x];if(x.length===0){return null;}
for(var i=0;i<x.length;i++){if(typeof x[i]=="function"){x[i].call(this);}}
var today=$D.today();if(this.now&&!this.unit&&!this.operator){return new Date();}else if(this.now){today=new Date();}
var expression=!!(this.days&&this.days!==null||this.orient||this.operator);var gap,mod,orient;orient=((this.orient=="past"||this.operator=="subtract")?-1:1);if(!this.now&&"hour minute second".indexOf(this.unit)!=-1){today.setTimeToNow();}
if(this.month||this.month===0){if("year day hour minute second".indexOf(this.unit)!=-1){this.value=this.month+1;this.month=null;expression=true;}}
if(!expression&&this.weekday&&!this.day&&!this.days){var temp=Date[this.weekday]();this.day=temp.getDate();if(!this.month){this.month=temp.getMonth();}
this.year=temp.getFullYear();}
if(expression&&this.weekday&&this.unit!="month"){this.unit="day";gap=($D.getDayNumberFromName(this.weekday)-today.getDay());mod=7;this.days=gap?((gap+(orient*mod))%mod):(orient*mod);}
if(this.month&&this.unit=="day"&&this.operator){this.value=(this.month+1);this.month=null;}
if(this.value!=null&&this.month!=null&&this.year!=null){this.day=this.value*1;}
if(this.month&&!this.day&&this.value){today.set({day:this.value*1});if(!expression){this.day=this.value*1;}}
if(!this.month&&this.value&&this.unit=="month"&&!this.now){this.month=this.value;expression=true;}
if(expression&&(this.month||this.month===0)&&this.unit!="year"){this.unit="month";gap=(this.month-today.getMonth());mod=12;this.months=gap?((gap+(orient*mod))%mod):(orient*mod);this.month=null;}
if(!this.unit){this.unit="day";}
if(!this.value&&this.operator&&this.operator!==null&&this[this.unit+"s"]&&this[this.unit+"s"]!==null){this[this.unit+"s"]=this[this.unit+"s"]+((this.operator=="add")?1:-1)+(this.value||0)*orient;}else if(this[this.unit+"s"]==null||this.operator!=null){if(!this.value){this.value=1;}
this[this.unit+"s"]=this.value*orient;}
if(this.meridian&&this.hour){if(this.meridian=="p"&&this.hour<12){this.hour=this.hour+12;}else if(this.meridian=="a"&&this.hour==12){this.hour=0;}}
if(this.weekday&&!this.day&&!this.days){var temp=Date[this.weekday]();this.day=temp.getDate();if(temp.getMonth()!==today.getMonth()){this.month=temp.getMonth();}}
if((this.month||this.month===0)&&!this.day){this.day=1;}
if(!this.orient&&!this.operator&&this.unit=="week"&&this.value&&!this.day&&!this.month){return Date.today().setWeek(this.value);}
if(expression&&this.timezone&&this.day&&this.days){this.day=this.days;}
return(expression)?today.add(this):today.set(this);}};var _=$D.Parsing.Operators,g=$D.Grammar,t=$D.Translator,_fn;g.datePartDelimiter=_.rtoken(/^([\s\-\.\,\/\x27]+)/);g.timePartDelimiter=_.stoken(":");g.whiteSpace=_.rtoken(/^\s*/);g.generalDelimiter=_.rtoken(/^(([\s\,]|at|@|on)+)/);var _C={};g.ctoken=function(keys){var fn=_C[keys];if(!fn){var c=$C.regexPatterns;var kx=keys.split(/\s+/),px=[];for(var i=0;i<kx.length;i++){px.push(_.replace(_.rtoken(c[kx[i]]),kx[i]));}
fn=_C[keys]=_.any.apply(null,px);}
return fn;};g.ctoken2=function(key){return _.rtoken($C.regexPatterns[key]);};g.h=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2]|[1-9])/),t.hour));g.hh=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2])/),t.hour));g.H=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3]|[0-9])/),t.hour));g.HH=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3])/),t.hour));g.m=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.minute));g.mm=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.minute));g.s=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.second));g.ss=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.second));g.hms=_.cache(_.sequence([g.H,g.m,g.s],g.timePartDelimiter));g.t=_.cache(_.process(g.ctoken2("shortMeridian"),t.meridian));g.tt=_.cache(_.process(g.ctoken2("longMeridian"),t.meridian));g.z=_.cache(_.process(_.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),t.timezone));g.zz=_.cache(_.process(_.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),t.timezone));g.zzz=_.cache(_.process(g.ctoken2("timezone"),t.timezone));g.timeSuffix=_.each(_.ignore(g.whiteSpace),_.set([g.tt,g.zzz]));g.time=_.each(_.optional(_.ignore(_.stoken("T"))),g.hms,g.timeSuffix);g.d=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1]|\d)/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.dd=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1])/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.ddd=g.dddd=_.cache(_.process(g.ctoken("sun mon tue wed thu fri sat"),function(s){return function(){this.weekday=s;};}));g.M=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d|\d)/),t.month));g.MM=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d)/),t.month));g.MMM=g.MMMM=_.cache(_.process(g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"),t.month));g.y=_.cache(_.process(_.rtoken(/^(\d\d?)/),t.year));g.yy=_.cache(_.process(_.rtoken(/^(\d\d)/),t.year));g.yyy=_.cache(_.process(_.rtoken(/^(\d\d?\d?\d?)/),t.year));g.yyyy=_.cache(_.process(_.rtoken(/^(\d\d\d\d)/),t.year));_fn=function(){return _.each(_.any.apply(null,arguments),_.not(g.ctoken2("timeContext")));};g.day=_fn(g.d,g.dd);g.month=_fn(g.M,g.MMM);g.year=_fn(g.yyyy,g.yy);g.orientation=_.process(g.ctoken("past future"),function(s){return function(){this.orient=s;};});g.operator=_.process(g.ctoken("add subtract"),function(s){return function(){this.operator=s;};});g.rday=_.process(g.ctoken("yesterday tomorrow today now"),t.rday);g.unit=_.process(g.ctoken("second minute hour day week month year"),function(s){return function(){this.unit=s;};});g.value=_.process(_.rtoken(/^\d\d?(st|nd|rd|th)?/),function(s){return function(){this.value=s.replace(/\D/g,"");};});g.expression=_.set([g.rday,g.operator,g.value,g.unit,g.orientation,g.ddd,g.MMM]);_fn=function(){return _.set(arguments,g.datePartDelimiter);};g.mdy=_fn(g.ddd,g.month,g.day,g.year);g.ymd=_fn(g.ddd,g.year,g.month,g.day);g.dmy=_fn(g.ddd,g.day,g.month,g.year);g.date=function(s){return((g[$C.dateElementOrder]||g.mdy).call(this,s));};g.format=_.process(_.many(_.any(_.process(_.rtoken(/^(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),function(fmt){if(g[fmt]){return g[fmt];}else{throw $D.Parsing.Exception(fmt);}}),_.process(_.rtoken(/^[^dMyhHmstz]+/),function(s){return _.ignore(_.stoken(s));}))),function(rules){return _.process(_.each.apply(null,rules),t.finishExact);});var _F={};var _get=function(f){return _F[f]=(_F[f]||g.format(f)[0]);};g.formats=function(fx){if(fx instanceof Array){var rx=[];for(var i=0;i<fx.length;i++){rx.push(_get(fx[i]));}
return _.any.apply(null,rx);}else{return _get(fx);}};g._formats=g.formats(["\"yyyy-MM-ddTHH:mm:ssZ\"","yyyy-MM-ddTHH:mm:ssZ","yyyy-MM-ddTHH:mm:ssz","yyyy-MM-ddTHH:mm:ss","yyyy-MM-ddTHH:mmZ","yyyy-MM-ddTHH:mmz","yyyy-MM-ddTHH:mm","ddd, MMM dd, yyyy H:mm:ss tt","ddd MMM d yyyy HH:mm:ss zzz","MMddyyyy","ddMMyyyy","Mddyyyy","ddMyyyy","Mdyyyy","dMyyyy","yyyy","Mdyy","dMyy","d"]);g._start=_.process(_.set([g.date,g.time,g.expression],g.generalDelimiter,g.whiteSpace),t.finish);g.start=function(s){try{var r=g._formats.call({},s);if(r[1].length===0){return r;}}catch(e){}
return g._start.call({},s);};$D._parse=$D.parse;$D.parse=function(s){var r=null;if(!s){return null;}
if(s instanceof Date){return s;}
try{r=$D.Grammar.start.call({},s.replace(/^\s*(\S*(\s+\S+)*)\s*$/,"$1"));}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};$D.getParseFunction=function(fx){var fn=$D.Grammar.formats(fx);return function(s){var r=null;try{r=fn.call({},s);}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};};$D.parseExact=function(s,fx){return $D.getParseFunction(fx)(s);};}());

define("datejs", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Date.CultureInfo;
    };
}(this)));

//! moment.js
//! version : 2.6.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (undefined) {

    /************************************
        Constants
    ************************************/

    var moment,
        VERSION = "2.6.0",
        // the global-scope this is NOT the global object in Node.js
        globalScope = typeof global !== 'undefined' ? global : this,
        oldGlobalMoment,
        round = Math.round,
        i,

        YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,

        // internal storage for language config files
        languages = {},

        // moment internal properties
        momentProperties = {
            _isAMomentObject: null,
            _i : null,
            _f : null,
            _l : null,
            _strict : null,
            _isUTC : null,
            _offset : null,  // optional. Combine with _isUTC
            _pf : null,
            _lang : null  // optional
        },

        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),

        // ASP.NET json date format regex
        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,

        // format tokens
        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,

        // parsing token regexes
        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
        parseTokenDigits = /\d+/, // nonzero number of digits
        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        parseTokenT = /T/i, // T (ISO separator)
        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        parseTokenOrdinal = /\d{1,2}/,

        //strict parsing regexes
        parseTokenOneDigit = /\d/, // 0 - 9
        parseTokenTwoDigits = /\d\d/, // 00 - 99
        parseTokenThreeDigits = /\d{3}/, // 000 - 999
        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf

        // iso 8601 regex
        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,

        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',

        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
            ['YYYY-DDD', /\d{4}-\d{3}/]
        ],

        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
            ['HH:mm', /(T| )\d\d:\d\d/],
            ['HH', /(T| )\d\d/]
        ],

        // timezone chunker "+10:00" > ["10", "00"] or "-1530" > ["-15", "30"]
        parseTimezoneChunker = /([\+\-]|\d\d)/gi,

        // getter and setter names
        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
        unitMillisecondFactors = {
            'Milliseconds' : 1,
            'Seconds' : 1e3,
            'Minutes' : 6e4,
            'Hours' : 36e5,
            'Days' : 864e5,
            'Months' : 2592e6,
            'Years' : 31536e6
        },

        unitAliases = {
            ms : 'millisecond',
            s : 'second',
            m : 'minute',
            h : 'hour',
            d : 'day',
            D : 'date',
            w : 'week',
            W : 'isoWeek',
            M : 'month',
            Q : 'quarter',
            y : 'year',
            DDD : 'dayOfYear',
            e : 'weekday',
            E : 'isoWeekday',
            gg: 'weekYear',
            GG: 'isoWeekYear'
        },

        camelFunctions = {
            dayofyear : 'dayOfYear',
            isoweekday : 'isoWeekday',
            isoweek : 'isoWeek',
            weekyear : 'weekYear',
            isoweekyear : 'isoWeekYear'
        },

        // format function strings
        formatFunctions = {},

        // tokens to ordinalize and pad
        ordinalizeTokens = 'DDD w W M D d'.split(' '),
        paddedTokens = 'M D H h m s w W'.split(' '),

        formatTokenFunctions = {
            M    : function () {
                return this.month() + 1;
            },
            MMM  : function (format) {
                return this.lang().monthsShort(this, format);
            },
            MMMM : function (format) {
                return this.lang().months(this, format);
            },
            D    : function () {
                return this.date();
            },
            DDD  : function () {
                return this.dayOfYear();
            },
            d    : function () {
                return this.day();
            },
            dd   : function (format) {
                return this.lang().weekdaysMin(this, format);
            },
            ddd  : function (format) {
                return this.lang().weekdaysShort(this, format);
            },
            dddd : function (format) {
                return this.lang().weekdays(this, format);
            },
            w    : function () {
                return this.week();
            },
            W    : function () {
                return this.isoWeek();
            },
            YY   : function () {
                return leftZeroFill(this.year() % 100, 2);
            },
            YYYY : function () {
                return leftZeroFill(this.year(), 4);
            },
            YYYYY : function () {
                return leftZeroFill(this.year(), 5);
            },
            YYYYYY : function () {
                var y = this.year(), sign = y >= 0 ? '+' : '-';
                return sign + leftZeroFill(Math.abs(y), 6);
            },
            gg   : function () {
                return leftZeroFill(this.weekYear() % 100, 2);
            },
            gggg : function () {
                return leftZeroFill(this.weekYear(), 4);
            },
            ggggg : function () {
                return leftZeroFill(this.weekYear(), 5);
            },
            GG   : function () {
                return leftZeroFill(this.isoWeekYear() % 100, 2);
            },
            GGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 4);
            },
            GGGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 5);
            },
            e : function () {
                return this.weekday();
            },
            E : function () {
                return this.isoWeekday();
            },
            a    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), true);
            },
            A    : function () {
                return this.lang().meridiem(this.hours(), this.minutes(), false);
            },
            H    : function () {
                return this.hours();
            },
            h    : function () {
                return this.hours() % 12 || 12;
            },
            m    : function () {
                return this.minutes();
            },
            s    : function () {
                return this.seconds();
            },
            S    : function () {
                return toInt(this.milliseconds() / 100);
            },
            SS   : function () {
                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
            },
            SSS  : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            SSSS : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            Z    : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + ":" + leftZeroFill(toInt(a) % 60, 2);
            },
            ZZ   : function () {
                var a = -this.zone(),
                    b = "+";
                if (a < 0) {
                    a = -a;
                    b = "-";
                }
                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
            },
            z : function () {
                return this.zoneAbbr();
            },
            zz : function () {
                return this.zoneName();
            },
            X    : function () {
                return this.unix();
            },
            Q : function () {
                return this.quarter();
            }
        },

        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'];

    function defaultParsingFlags() {
        // We need to deep clone this object, and es5 standard is not very
        // helpful.
        return {
            empty : false,
            unusedTokens : [],
            unusedInput : [],
            overflow : -2,
            charsLeftOver : 0,
            nullInput : false,
            invalidMonth : null,
            invalidFormat : false,
            userInvalidated : false,
            iso: false
        };
    }

    function deprecate(msg, fn) {
        var firstTime = true;
        function printMsg() {
            if (moment.suppressDeprecationWarnings === false &&
                    typeof console !== 'undefined' && console.warn) {
                console.warn("Deprecation warning: " + msg);
            }
        }
        return extend(function () {
            if (firstTime) {
                printMsg();
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    function padToken(func, count) {
        return function (a) {
            return leftZeroFill(func.call(this, a), count);
        };
    }
    function ordinalizeToken(func, period) {
        return function (a) {
            return this.lang().ordinal(func.call(this, a), period);
        };
    }

    while (ordinalizeTokens.length) {
        i = ordinalizeTokens.pop();
        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
    }
    while (paddedTokens.length) {
        i = paddedTokens.pop();
        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
    }
    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);


    /************************************
        Constructors
    ************************************/

    function Language() {

    }

    // Moment prototype object
    function Moment(config) {
        checkOverflow(config);
        extend(this, config);
    }

    // Duration Constructor
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._bubble();
    }

    /************************************
        Helpers
    ************************************/


    function extend(a, b) {
        for (var i in b) {
            if (b.hasOwnProperty(i)) {
                a[i] = b[i];
            }
        }

        if (b.hasOwnProperty("toString")) {
            a.toString = b.toString;
        }

        if (b.hasOwnProperty("valueOf")) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function cloneMoment(m) {
        var result = {}, i;
        for (i in m) {
            if (m.hasOwnProperty(i) && momentProperties.hasOwnProperty(i)) {
                result[i] = m[i];
            }
        }

        return result;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    // left zero fill a number
    // see http://jsperf.com/left-zero-filling for performance comparison
    function leftZeroFill(number, targetLength, forceSign) {
        var output = '' + Math.abs(number),
            sign = number >= 0;

        while (output.length < targetLength) {
            output = '0' + output;
        }
        return (sign ? (forceSign ? '+' : '') : '-') + output;
    }

    // helper function for _.addTime and _.subtractTime
    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
        }
        if (months) {
            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            moment.updateOffset(mom, days || months);
        }
    }

    // check if is an array
    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return  Object.prototype.toString.call(input) === '[object Date]' ||
                input instanceof Date;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function normalizeUnits(units) {
        if (units) {
            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
            units = unitAliases[units] || camelFunctions[lowered] || lowered;
        }
        return units;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (inputObject.hasOwnProperty(prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeList(field) {
        var count, setter;

        if (field.indexOf('week') === 0) {
            count = 7;
            setter = 'day';
        }
        else if (field.indexOf('month') === 0) {
            count = 12;
            setter = 'month';
        }
        else {
            return;
        }

        moment[field] = function (format, index) {
            var i, getter,
                method = moment.fn._lang[field],
                results = [];

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            getter = function (i) {
                var m = moment().utc().set(setter, i);
                return method.call(moment.fn._lang, m, format || '');
            };

            if (index != null) {
                return getter(index);
            }
            else {
                for (i = 0; i < count; i++) {
                    results.push(getter(i));
                }
                return results;
            }
        };
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            if (coercedNumber >= 0) {
                value = Math.floor(coercedNumber);
            } else {
                value = Math.ceil(coercedNumber);
            }
        }

        return value;
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    function weeksInYear(year, dow, doy) {
        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function checkOverflow(m) {
        var overflow;
        if (m._a && m._pf.overflow === -2) {
            overflow =
                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
                m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
                m._a[HOUR] < 0 || m._a[HOUR] > 23 ? HOUR :
                m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
                m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            m._pf.overflow = overflow;
        }
    }

    function isValid(m) {
        if (m._isValid == null) {
            m._isValid = !isNaN(m._d.getTime()) &&
                m._pf.overflow < 0 &&
                !m._pf.empty &&
                !m._pf.invalidMonth &&
                !m._pf.nullInput &&
                !m._pf.invalidFormat &&
                !m._pf.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    m._pf.charsLeftOver === 0 &&
                    m._pf.unusedTokens.length === 0;
            }
        }
        return m._isValid;
    }

    function normalizeLanguage(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function makeAs(input, model) {
        return model._isUTC ? moment(input).zone(model._offset || 0) :
            moment(input).local();
    }

    /************************************
        Languages
    ************************************/


    extend(Language.prototype, {

        set : function (config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        },

        _months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        months : function (m) {
            return this._months[m.month()];
        },

        _monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        monthsShort : function (m) {
            return this._monthsShort[m.month()];
        },

        monthsParse : function (monthName) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                if (!this._monthsParse[i]) {
                    mom = moment.utc([2000, i]);
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        },

        _weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdays : function (m) {
            return this._weekdays[m.day()];
        },

        _weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysShort : function (m) {
            return this._weekdaysShort[m.day()];
        },

        _weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        weekdaysMin : function (m) {
            return this._weekdaysMin[m.day()];
        },

        weekdaysParse : function (weekdayName) {
            var i, mom, regex;

            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = moment([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        },

        _longDateFormat : {
            LT : "h:mm A",
            L : "MM/DD/YYYY",
            LL : "MMMM D YYYY",
            LLL : "MMMM D YYYY LT",
            LLLL : "dddd, MMMM D YYYY LT"
        },
        longDateFormat : function (key) {
            var output = this._longDateFormat[key];
            if (!output && this._longDateFormat[key.toUpperCase()]) {
                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function (val) {
                    return val.slice(1);
                });
                this._longDateFormat[key] = output;
            }
            return output;
        },

        isPM : function (input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return ((input + '').toLowerCase().charAt(0) === 'p');
        },

        _meridiemParse : /[ap]\.?m?\.?/i,
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        },

        _calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.apply(mom) : output;
        },

        _relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        relativeTime : function (number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return (typeof output === 'function') ?
                output(number, withoutSuffix, string, isFuture) :
                output.replace(/%d/i, number);
        },
        pastFuture : function (diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        },

        ordinal : function (number) {
            return this._ordinal.replace("%d", number);
        },
        _ordinal : "%d",

        preparse : function (string) {
            return string;
        },

        postformat : function (string) {
            return string;
        },

        week : function (mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        },

        _week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        },

        _invalidDate: 'Invalid date',
        invalidDate: function () {
            return this._invalidDate;
        }
    });

    // Loads a language definition into the `languages` cache.  The function
    // takes a key and optionally values.  If not in the browser and no values
    // are provided, it will load the language file module.  As a convenience,
    // this function also returns the language values.
    function loadLang(key, values) {
        values.abbr = key;
        if (!languages[key]) {
            languages[key] = new Language();
        }
        languages[key].set(values);
        return languages[key];
    }

    // Remove a language from the `languages` cache. Mostly useful in tests.
    function unloadLang(key) {
        delete languages[key];
    }

    // Determines which language definition to use and returns it.
    //
    // With no parameters, it will return the global language.  If you
    // pass in a language key, such as 'en', it will return the
    // definition for 'en', so long as 'en' has already been loaded using
    // moment.lang.
    function getLangDefinition(key) {
        var i = 0, j, lang, next, split,
            get = function (k) {
                if (!languages[k] && hasModule) {
                    try {
                        require('./lang/' + k);
                    } catch (e) { }
                }
                return languages[k];
            };

        if (!key) {
            return moment.fn._lang;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            lang = get(key);
            if (lang) {
                return lang;
            }
            key = [key];
        }

        //pick the language from the array
        //try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
        //substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
        while (i < key.length) {
            split = normalizeLanguage(key[i]).split('-');
            j = split.length;
            next = normalizeLanguage(key[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                lang = get(split.slice(0, j).join('-'));
                if (lang) {
                    return lang;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return moment.fn._lang;
    }

    /************************************
        Formatting
    ************************************/


    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, "");
        }
        return input.replace(/\\/g, "");
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = "";
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {

        if (!m.isValid()) {
            return m.lang().invalidDate();
        }

        format = expandFormat(format, m.lang());

        if (!formatFunctions[format]) {
            formatFunctions[format] = makeFormatFunction(format);
        }

        return formatFunctions[format](m);
    }

    function expandFormat(format, lang) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return lang.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }


    /************************************
        Parsing
    ************************************/


    // get the regex to find the next token
    function getParseRegexForToken(token, config) {
        var a, strict = config._strict;
        switch (token) {
        case 'Q':
            return parseTokenOneDigit;
        case 'DDDD':
            return parseTokenThreeDigits;
        case 'YYYY':
        case 'GGGG':
        case 'gggg':
            return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
        case 'Y':
        case 'G':
        case 'g':
            return parseTokenSignedNumber;
        case 'YYYYYY':
        case 'YYYYY':
        case 'GGGGG':
        case 'ggggg':
            return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
        case 'S':
            if (strict) { return parseTokenOneDigit; }
            /* falls through */
        case 'SS':
            if (strict) { return parseTokenTwoDigits; }
            /* falls through */
        case 'SSS':
            if (strict) { return parseTokenThreeDigits; }
            /* falls through */
        case 'DDD':
            return parseTokenOneToThreeDigits;
        case 'MMM':
        case 'MMMM':
        case 'dd':
        case 'ddd':
        case 'dddd':
            return parseTokenWord;
        case 'a':
        case 'A':
            return getLangDefinition(config._l)._meridiemParse;
        case 'X':
            return parseTokenTimestampMs;
        case 'Z':
        case 'ZZ':
            return parseTokenTimezone;
        case 'T':
            return parseTokenT;
        case 'SSSS':
            return parseTokenDigits;
        case 'MM':
        case 'DD':
        case 'YY':
        case 'GG':
        case 'gg':
        case 'HH':
        case 'hh':
        case 'mm':
        case 'ss':
        case 'ww':
        case 'WW':
            return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
        case 'M':
        case 'D':
        case 'd':
        case 'H':
        case 'h':
        case 'm':
        case 's':
        case 'w':
        case 'W':
        case 'e':
        case 'E':
            return parseTokenOneOrTwoDigits;
        case 'Do':
            return parseTokenOrdinal;
        default :
            a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), "i"));
            return a;
        }
    }

    function timezoneMinutesFromString(string) {
        string = string || "";
        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
            minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? -minutes : minutes;
    }

    // function to convert string input to date
    function addTimeToArrayFromToken(token, input, config) {
        var a, datePartArray = config._a;

        switch (token) {
        // QUARTER
        case 'Q':
            if (input != null) {
                datePartArray[MONTH] = (toInt(input) - 1) * 3;
            }
            break;
        // MONTH
        case 'M' : // fall through to MM
        case 'MM' :
            if (input != null) {
                datePartArray[MONTH] = toInt(input) - 1;
            }
            break;
        case 'MMM' : // fall through to MMMM
        case 'MMMM' :
            a = getLangDefinition(config._l).monthsParse(input);
            // if we didn't find a month name, mark the date as invalid.
            if (a != null) {
                datePartArray[MONTH] = a;
            } else {
                config._pf.invalidMonth = input;
            }
            break;
        // DAY OF MONTH
        case 'D' : // fall through to DD
        case 'DD' :
            if (input != null) {
                datePartArray[DATE] = toInt(input);
            }
            break;
        case 'Do' :
            if (input != null) {
                datePartArray[DATE] = toInt(parseInt(input, 10));
            }
            break;
        // DAY OF YEAR
        case 'DDD' : // fall through to DDDD
        case 'DDDD' :
            if (input != null) {
                config._dayOfYear = toInt(input);
            }

            break;
        // YEAR
        case 'YY' :
            datePartArray[YEAR] = moment.parseTwoDigitYear(input);
            break;
        case 'YYYY' :
        case 'YYYYY' :
        case 'YYYYYY' :
            datePartArray[YEAR] = toInt(input);
            break;
        // AM / PM
        case 'a' : // fall through to A
        case 'A' :
            config._isPm = getLangDefinition(config._l).isPM(input);
            break;
        // 24 HOUR
        case 'H' : // fall through to hh
        case 'HH' : // fall through to hh
        case 'h' : // fall through to hh
        case 'hh' :
            datePartArray[HOUR] = toInt(input);
            break;
        // MINUTE
        case 'm' : // fall through to mm
        case 'mm' :
            datePartArray[MINUTE] = toInt(input);
            break;
        // SECOND
        case 's' : // fall through to ss
        case 'ss' :
            datePartArray[SECOND] = toInt(input);
            break;
        // MILLISECOND
        case 'S' :
        case 'SS' :
        case 'SSS' :
        case 'SSSS' :
            datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
            break;
        // UNIX TIMESTAMP WITH MS
        case 'X':
            config._d = new Date(parseFloat(input) * 1000);
            break;
        // TIMEZONE
        case 'Z' : // fall through to ZZ
        case 'ZZ' :
            config._useUTC = true;
            config._tzm = timezoneMinutesFromString(input);
            break;
        case 'w':
        case 'ww':
        case 'W':
        case 'WW':
        case 'd':
        case 'dd':
        case 'ddd':
        case 'dddd':
        case 'e':
        case 'E':
            token = token.substr(0, 1);
            /* falls through */
        case 'gg':
        case 'gggg':
        case 'GG':
        case 'GGGG':
        case 'GGGGG':
            token = token.substr(0, 2);
            if (input) {
                config._w = config._w || {};
                config._w[token] = input;
            }
            break;
        }
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function dateFromConfig(config) {
        var i, date, input = [], currentDate,
            yearToUse, fixYear, w, temp, lang, weekday, week;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            fixYear = function (val) {
                var intVal = parseInt(val, 10);
                return val ?
                  (val.length < 3 ? (intVal > 68 ? 1900 + intVal : 2000 + intVal) : intVal) :
                  (config._a[YEAR] == null ? moment().weekYear() : config._a[YEAR]);
            };

            w = config._w;
            if (w.GG != null || w.W != null || w.E != null) {
                temp = dayOfYearFromWeeks(fixYear(w.GG), w.W || 1, w.E, 4, 1);
            }
            else {
                lang = getLangDefinition(config._l);
                weekday = w.d != null ?  parseWeekday(w.d, lang) :
                  (w.e != null ?  parseInt(w.e, 10) + lang._week.dow : 0);

                week = parseInt(w.w, 10) || 1;

                //if we're parsing 'd', then the low day numbers may be next week
                if (w.d != null && weekday < lang._week.dow) {
                    week++;
                }

                temp = dayOfYearFromWeeks(fixYear(w.gg), week, weekday, lang._week.doy, lang._week.dow);
            }

            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = config._a[YEAR] == null ? currentDate[YEAR] : config._a[YEAR];

            if (config._dayOfYear > daysInYear(yearToUse)) {
                config._pf._overflowDayOfYear = true;
            }

            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // add the offsets to the time to be parsed so that we can have a clean array for checking isValid
        input[HOUR] += toInt((config._tzm || 0) / 60);
        input[MINUTE] += toInt((config._tzm || 0) % 60);

        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
    }

    function dateFromObject(config) {
        var normalizedInput;

        if (config._d) {
            return;
        }

        normalizedInput = normalizeObjectUnits(config._i);
        config._a = [
            normalizedInput.year,
            normalizedInput.month,
            normalizedInput.day,
            normalizedInput.hour,
            normalizedInput.minute,
            normalizedInput.second,
            normalizedInput.millisecond
        ];

        dateFromConfig(config);
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate()
            ];
        } else {
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }
    }

    // date from string and format string
    function makeDateFromStringAndFormat(config) {

        config._a = [];
        config._pf.empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var lang = getLangDefinition(config._l),
            string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, lang).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    config._pf.unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    config._pf.empty = false;
                }
                else {
                    config._pf.unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                config._pf.unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            config._pf.unusedInput.push(string);
        }

        // handle am pm
        if (config._isPm && config._a[HOUR] < 12) {
            config._a[HOUR] += 12;
        }
        // if is 12 am, change hours to 0
        if (config._isPm === false && config._a[HOUR] === 12) {
            config._a[HOUR] = 0;
        }

        dateFromConfig(config);
        checkOverflow(config);
    }

    function unescapeFormat(s) {
        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        });
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function regexpEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    // date from string and array of format strings
    function makeDateFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            config._pf.invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = extend({}, config);
            tempConfig._pf = defaultParsingFlags();
            tempConfig._f = config._f[i];
            makeDateFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += tempConfig._pf.charsLeftOver;

            //or tokens
            currentScore += tempConfig._pf.unusedTokens.length * 10;

            tempConfig._pf.score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    // date from iso format
    function makeDateFromString(config) {
        var i, l,
            string = config._i,
            match = isoRegex.exec(string);

        if (match) {
            config._pf.iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    // match[5] should be "T" or undefined
                    config._f = isoDates[i][0] + (match[6] || " ");
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    config._f += isoTimes[i][0];
                    break;
                }
            }
            if (string.match(parseTokenTimezone)) {
                config._f += "Z";
            }
            makeDateFromStringAndFormat(config);
        }
        else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDateFromInput(config) {
        var input = config._i,
            matched = aspNetJsonRegex.exec(input);

        if (input === undefined) {
            config._d = new Date();
        } else if (matched) {
            config._d = new Date(+matched[1]);
        } else if (typeof input === 'string') {
            makeDateFromString(config);
        } else if (isArray(input)) {
            config._a = input.slice(0);
            dateFromConfig(config);
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof(input) === 'object') {
            dateFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function makeUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function parseWeekday(input, language) {
        if (typeof input === 'string') {
            if (!isNaN(input)) {
                input = parseInt(input, 10);
            }
            else {
                input = language.weekdaysParse(input);
                if (typeof input !== 'number') {
                    return null;
                }
            }
        }
        return input;
    }

    /************************************
        Relative Time
    ************************************/


    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, lang) {
        return lang.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime(milliseconds, withoutSuffix, lang) {
        var seconds = round(Math.abs(milliseconds) / 1000),
            minutes = round(seconds / 60),
            hours = round(minutes / 60),
            days = round(hours / 24),
            years = round(days / 365),
            args = seconds < 45 && ['s', seconds] ||
                minutes === 1 && ['m'] ||
                minutes < 45 && ['mm', minutes] ||
                hours === 1 && ['h'] ||
                hours < 22 && ['hh', hours] ||
                days === 1 && ['d'] ||
                days <= 25 && ['dd', days] ||
                days <= 45 && ['M'] ||
                days < 345 && ['MM', round(days / 30)] ||
                years === 1 && ['y'] || ['yy', years];
        args[2] = withoutSuffix;
        args[3] = milliseconds > 0;
        args[4] = lang;
        return substituteTimeAgo.apply({}, args);
    }


    /************************************
        Week of Year
    ************************************/


    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = moment(mom).add('d', daysToDayOfWeek);
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;

        weekday = weekday != null ? weekday : firstDayOfWeek;
        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    /************************************
        Top Level Functions
    ************************************/

    function makeMoment(config) {
        var input = config._i,
            format = config._f;

        if (input === null || (format === undefined && input === '')) {
            return moment.invalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = getLangDefinition().preparse(input);
        }

        if (moment.isMoment(input)) {
            config = cloneMoment(input);

            config._d = new Date(+input._d);
        } else if (format) {
            if (isArray(format)) {
                makeDateFromStringAndArray(config);
            } else {
                makeDateFromStringAndFormat(config);
            }
        } else {
            makeDateFromInput(config);
        }

        return new Moment(config);
    }

    moment = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._i = input;
        c._f = format;
        c._l = lang;
        c._strict = strict;
        c._isUTC = false;
        c._pf = defaultParsingFlags();

        return makeMoment(c);
    };

    moment.suppressDeprecationWarnings = false;

    moment.createFromInputFallback = deprecate(
            "moment construction falls back to js Date. This is " +
            "discouraged and will be removed in upcoming major " +
            "release. Please refer to " +
            "https://github.com/moment/moment/issues/1407 for more info.",
            function (config) {
        config._d = new Date(config._i);
    });

    // creating with utc
    moment.utc = function (input, format, lang, strict) {
        var c;

        if (typeof(lang) === "boolean") {
            strict = lang;
            lang = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._useUTC = true;
        c._isUTC = true;
        c._l = lang;
        c._i = input;
        c._f = format;
        c._strict = strict;
        c._pf = defaultParsingFlags();

        return makeMoment(c).utc();
    };

    // creating with unix timestamp (in seconds)
    moment.unix = function (input) {
        return moment(input * 1000);
    };

    // duration
    moment.duration = function (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            parseIso;

        if (moment.isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoDurationRegex.exec(input))) {
            sign = (match[1] === "-") ? -1 : 1;
            parseIso = function (inp) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            };
            duration = {
                y: parseIso(match[2]),
                M: parseIso(match[3]),
                d: parseIso(match[4]),
                h: parseIso(match[5]),
                m: parseIso(match[6]),
                s: parseIso(match[7]),
                w: parseIso(match[8])
            };
        }

        ret = new Duration(duration);

        if (moment.isDuration(input) && input.hasOwnProperty('_lang')) {
            ret._lang = input._lang;
        }

        return ret;
    };

    // version number
    moment.version = VERSION;

    // default format
    moment.defaultFormat = isoFormat;

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    moment.momentProperties = momentProperties;

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    moment.updateOffset = function () {};

    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    moment.lang = function (key, values) {
        var r;
        if (!key) {
            return moment.fn._lang._abbr;
        }
        if (values) {
            loadLang(normalizeLanguage(key), values);
        } else if (values === null) {
            unloadLang(key);
            key = 'en';
        } else if (!languages[key]) {
            getLangDefinition(key);
        }
        r = moment.duration.fn._lang = moment.fn._lang = getLangDefinition(key);
        return r._abbr;
    };

    // returns language data
    moment.langData = function (key) {
        if (key && key._lang && key._lang._abbr) {
            key = key._lang._abbr;
        }
        return getLangDefinition(key);
    };

    // compare moment object
    moment.isMoment = function (obj) {
        return obj instanceof Moment ||
            (obj != null &&  obj.hasOwnProperty('_isAMomentObject'));
    };

    // for typechecking Duration objects
    moment.isDuration = function (obj) {
        return obj instanceof Duration;
    };

    for (i = lists.length - 1; i >= 0; --i) {
        makeList(lists[i]);
    }

    moment.normalizeUnits = function (units) {
        return normalizeUnits(units);
    };

    moment.invalid = function (flags) {
        var m = moment.utc(NaN);
        if (flags != null) {
            extend(m._pf, flags);
        }
        else {
            m._pf.userInvalidated = true;
        }

        return m;
    };

    moment.parseZone = function () {
        return moment.apply(null, arguments).parseZone();
    };

    moment.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    /************************************
        Moment Prototype
    ************************************/


    extend(moment.fn = Moment.prototype, {

        clone : function () {
            return moment(this);
        },

        valueOf : function () {
            return +this._d + ((this._offset || 0) * 60000);
        },

        unix : function () {
            return Math.floor(+this / 1000);
        },

        toString : function () {
            return this.clone().lang('en').format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        },

        toDate : function () {
            return this._offset ? new Date(+this) : this._d;
        },

        toISOString : function () {
            var m = moment(this).utc();
            if (0 < m.year() && m.year() <= 9999) {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        },

        toArray : function () {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hours(),
                m.minutes(),
                m.seconds(),
                m.milliseconds()
            ];
        },

        isValid : function () {
            return isValid(this);
        },

        isDSTShifted : function () {

            if (this._a) {
                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
            }

            return false;
        },

        parsingFlags : function () {
            return extend({}, this._pf);
        },

        invalidAt: function () {
            return this._pf.overflow;
        },

        utc : function () {
            return this.zone(0);
        },

        local : function () {
            this.zone(0);
            this._isUTC = false;
            return this;
        },

        format : function (inputString) {
            var output = formatMoment(this, inputString || moment.defaultFormat);
            return this.lang().postformat(output);
        },

        add : function (input, val) {
            var dur;
            // switch args to support add('s', 1) and add(1, 's')
            if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, 1);
            return this;
        },

        subtract : function (input, val) {
            var dur;
            // switch args to support subtract('s', 1) and subtract(1, 's')
            if (typeof input === 'string') {
                dur = moment.duration(+val, input);
            } else {
                dur = moment.duration(input, val);
            }
            addOrSubtractDurationFromMoment(this, dur, -1);
            return this;
        },

        diff : function (input, units, asFloat) {
            var that = makeAs(input, this),
                zoneDiff = (this.zone() - that.zone()) * 6e4,
                diff, output;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month') {
                // average number of days in the months in the given dates
                diff = (this.daysInMonth() + that.daysInMonth()) * 432e5; // 24 * 60 * 60 * 1000 / 2
                // difference in months
                output = ((this.year() - that.year()) * 12) + (this.month() - that.month());
                // adjust by taking difference in days, average number of days
                // and dst in the given months.
                output += ((this - moment(this).startOf('month')) -
                        (that - moment(that).startOf('month'))) / diff;
                // same as above but with zones, to negate all dst
                output -= ((this.zone() - moment(this).startOf('month').zone()) -
                        (that.zone() - moment(that).startOf('month').zone())) * 6e4 / diff;
                if (units === 'year') {
                    output = output / 12;
                }
            } else {
                diff = (this - that);
                output = units === 'second' ? diff / 1e3 : // 1000
                    units === 'minute' ? diff / 6e4 : // 1000 * 60
                    units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
                    units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                    units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                    diff;
            }
            return asFloat ? output : absRound(output);
        },

        from : function (time, withoutSuffix) {
            return moment.duration(this.diff(time)).lang(this.lang()._abbr).humanize(!withoutSuffix);
        },

        fromNow : function (withoutSuffix) {
            return this.from(moment(), withoutSuffix);
        },

        calendar : function () {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're zone'd or not.
            var sod = makeAs(moment(), this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' :
                    diff < -1 ? 'lastWeek' :
                    diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                    diff < 2 ? 'nextDay' :
                    diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(this.lang().calendar(format, this));
        },

        isLeapYear : function () {
            return isLeapYear(this.year());
        },

        isDST : function () {
            return (this.zone() < this.clone().month(0).zone() ||
                this.zone() < this.clone().month(5).zone());
        },

        day : function (input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.lang());
                return this.add({ d : input - day });
            } else {
                return day;
            }
        },

        month : makeAccessor('Month', true),

        startOf: function (units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
                /* falls through */
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            } else if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        },

        endOf: function (units) {
            units = normalizeUnits(units);
            return this.startOf(units).add((units === 'isoWeek' ? 'week' : units), 1).subtract('ms', 1);
        },

        isAfter: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) > +moment(input).startOf(units);
        },

        isBefore: function (input, units) {
            units = typeof units !== 'undefined' ? units : 'millisecond';
            return +this.clone().startOf(units) < +moment(input).startOf(units);
        },

        isSame: function (input, units) {
            units = units || 'ms';
            return +this.clone().startOf(units) === +makeAs(input, this).startOf(units);
        },

        min: function (other) {
            other = moment.apply(null, arguments);
            return other < this ? this : other;
        },

        max: function (other) {
            other = moment.apply(null, arguments);
            return other > this ? this : other;
        },

        // keepTime = true means only change the timezone, without affecting
        // the local hour. So 5:31:26 +0300 --[zone(2, true)]--> 5:31:26 +0200
        // It is possible that 5:31:26 doesn't exist int zone +0200, so we
        // adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        zone : function (input, keepTime) {
            var offset = this._offset || 0;
            if (input != null) {
                if (typeof input === "string") {
                    input = timezoneMinutesFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                this._offset = input;
                this._isUTC = true;
                if (offset !== input) {
                    if (!keepTime || this._changeInProgress) {
                        addOrSubtractDurationFromMoment(this,
                                moment.duration(offset - input, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        moment.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
            } else {
                return this._isUTC ? offset : this._d.getTimezoneOffset();
            }
            return this;
        },

        zoneAbbr : function () {
            return this._isUTC ? "UTC" : "";
        },

        zoneName : function () {
            return this._isUTC ? "Coordinated Universal Time" : "";
        },

        parseZone : function () {
            if (this._tzm) {
                this.zone(this._tzm);
            } else if (typeof this._i === 'string') {
                this.zone(this._i);
            }
            return this;
        },

        hasAlignedHourOffset : function (input) {
            if (!input) {
                input = 0;
            }
            else {
                input = moment(input).zone();
            }

            return (this.zone() - input) % 60 === 0;
        },

        daysInMonth : function () {
            return daysInMonth(this.year(), this.month());
        },

        dayOfYear : function (input) {
            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add("d", (input - dayOfYear));
        },

        quarter : function (input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        },

        weekYear : function (input) {
            var year = weekOfYear(this, this.lang()._week.dow, this.lang()._week.doy).year;
            return input == null ? year : this.add("y", (input - year));
        },

        isoWeekYear : function (input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add("y", (input - year));
        },

        week : function (input) {
            var week = this.lang().week(this);
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        isoWeek : function (input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add("d", (input - week) * 7);
        },

        weekday : function (input) {
            var weekday = (this.day() + 7 - this.lang()._week.dow) % 7;
            return input == null ? weekday : this.add("d", input - weekday);
        },

        isoWeekday : function (input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        },

        isoWeeksInYear : function () {
            return weeksInYear(this.year(), 1, 4);
        },

        weeksInYear : function () {
            var weekInfo = this._lang._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units]();
        },

        set : function (units, value) {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                this[units](value);
            }
            return this;
        },

        // If passed a language key, it will set the language for this
        // instance.  Otherwise, it will return the language configuration
        // variables for this instance.
        lang : function (key) {
            if (key === undefined) {
                return this._lang;
            } else {
                this._lang = getLangDefinition(key);
                return this;
            }
        }
    });

    function rawMonthSetter(mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.lang().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(),
                daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function rawGetter(mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function rawSetter(mom, unit, value) {
        if (unit === 'Month') {
            return rawMonthSetter(mom, value);
        } else {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function makeAccessor(unit, keepTime) {
        return function (value) {
            if (value != null) {
                rawSetter(this, unit, value);
                moment.updateOffset(this, keepTime);
                return this;
            } else {
                return rawGetter(this, unit);
            }
        };
    }

    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
    // moment.fn.month is defined separately
    moment.fn.date = makeAccessor('Date', true);
    moment.fn.dates = deprecate("dates accessor is deprecated. Use date instead.", makeAccessor('Date', true));
    moment.fn.year = makeAccessor('FullYear', true);
    moment.fn.years = deprecate("years accessor is deprecated. Use year instead.", makeAccessor('FullYear', true));

    // add plural methods
    moment.fn.days = moment.fn.day;
    moment.fn.months = moment.fn.month;
    moment.fn.weeks = moment.fn.week;
    moment.fn.isoWeeks = moment.fn.isoWeek;
    moment.fn.quarters = moment.fn.quarter;

    // add aliased format methods
    moment.fn.toJSON = moment.fn.toISOString;

    /************************************
        Duration Prototype
    ************************************/


    extend(moment.duration.fn = Duration.prototype, {

        _bubble : function () {
            var milliseconds = this._milliseconds,
                days = this._days,
                months = this._months,
                data = this._data,
                seconds, minutes, hours, years;

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absRound(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absRound(seconds / 60);
            data.minutes = minutes % 60;

            hours = absRound(minutes / 60);
            data.hours = hours % 24;

            days += absRound(hours / 24);
            data.days = days % 30;

            months += absRound(days / 30);
            data.months = months % 12;

            years = absRound(months / 12);
            data.years = years;
        },

        weeks : function () {
            return absRound(this.days() / 7);
        },

        valueOf : function () {
            return this._milliseconds +
              this._days * 864e5 +
              (this._months % 12) * 2592e6 +
              toInt(this._months / 12) * 31536e6;
        },

        humanize : function (withSuffix) {
            var difference = +this,
                output = relativeTime(difference, !withSuffix, this.lang());

            if (withSuffix) {
                output = this.lang().pastFuture(difference, output);
            }

            return this.lang().postformat(output);
        },

        add : function (input, val) {
            // supports only 2.0-style add(1, 's') or add(moment)
            var dur = moment.duration(input, val);

            this._milliseconds += dur._milliseconds;
            this._days += dur._days;
            this._months += dur._months;

            this._bubble();

            return this;
        },

        subtract : function (input, val) {
            var dur = moment.duration(input, val);

            this._milliseconds -= dur._milliseconds;
            this._days -= dur._days;
            this._months -= dur._months;

            this._bubble();

            return this;
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units.toLowerCase() + 's']();
        },

        as : function (units) {
            units = normalizeUnits(units);
            return this['as' + units.charAt(0).toUpperCase() + units.slice(1) + 's']();
        },

        lang : moment.fn.lang,

        toIsoString : function () {
            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var years = Math.abs(this.years()),
                months = Math.abs(this.months()),
                days = Math.abs(this.days()),
                hours = Math.abs(this.hours()),
                minutes = Math.abs(this.minutes()),
                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);

            if (!this.asSeconds()) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (this.asSeconds() < 0 ? '-' : '') +
                'P' +
                (years ? years + 'Y' : '') +
                (months ? months + 'M' : '') +
                (days ? days + 'D' : '') +
                ((hours || minutes || seconds) ? 'T' : '') +
                (hours ? hours + 'H' : '') +
                (minutes ? minutes + 'M' : '') +
                (seconds ? seconds + 'S' : '');
        }
    });

    function makeDurationGetter(name) {
        moment.duration.fn[name] = function () {
            return this._data[name];
        };
    }

    function makeDurationAsGetter(name, factor) {
        moment.duration.fn['as' + name] = function () {
            return +this / factor;
        };
    }

    for (i in unitMillisecondFactors) {
        if (unitMillisecondFactors.hasOwnProperty(i)) {
            makeDurationAsGetter(i, unitMillisecondFactors[i]);
            makeDurationGetter(i.toLowerCase());
        }
    }

    makeDurationAsGetter('Weeks', 6048e5);
    moment.duration.fn.asMonths = function () {
        return (+this - this.years() * 31536e6) / 2592e6 + this.years() * 12;
    };


    /************************************
        Default Lang
    ************************************/


    // Set default language, other languages will inherit from English.
    moment.lang('en', {
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // moment.js language configuration
// language : Moroccan Arabic (ar-ma)
// author : ElFadili Yassine : https://github.com/ElFadiliY
// author : Abdel Said : https://github.com/abdelsaid

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ar-ma', {
        months : "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        monthsShort : "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        weekdays : "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort : "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin : "ح_ن_ث_ر_خ_ج_س".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[اليوم على الساعة] LT",
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "في %s",
            past : "منذ %s",
            s : "ثوان",
            m : "دقيقة",
            mm : "%d دقائق",
            h : "ساعة",
            hh : "%d ساعات",
            d : "يوم",
            dd : "%d أيام",
            M : "شهر",
            MM : "%d أشهر",
            y : "سنة",
            yy : "%d سنوات"
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Arabic (ar)
// author : Abdel Said : https://github.com/abdelsaid
// changes in months, weekdays : Ahmed Elkhatib

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ar', {
        months : "يناير/ كانون الثاني_فبراير/ شباط_مارس/ آذار_أبريل/ نيسان_مايو/ أيار_يونيو/ حزيران_يوليو/ تموز_أغسطس/ آب_سبتمبر/ أيلول_أكتوبر/ تشرين الأول_نوفمبر/ تشرين الثاني_ديسمبر/ كانون الأول".split("_"),
        monthsShort : "يناير/ كانون الثاني_فبراير/ شباط_مارس/ آذار_أبريل/ نيسان_مايو/ أيار_يونيو/ حزيران_يوليو/ تموز_أغسطس/ آب_سبتمبر/ أيلول_أكتوبر/ تشرين الأول_نوفمبر/ تشرين الثاني_ديسمبر/ كانون الأول".split("_"),
        weekdays : "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort : "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysMin : "ح_ن_ث_ر_خ_ج_س".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[اليوم على الساعة] LT",
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "في %s",
            past : "منذ %s",
            s : "ثوان",
            m : "دقيقة",
            mm : "%d دقائق",
            h : "ساعة",
            hh : "%d ساعات",
            d : "يوم",
            dd : "%d أيام",
            M : "شهر",
            MM : "%d أشهر",
            y : "سنة",
            yy : "%d سنوات"
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : bulgarian (bg)
// author : Krasen Borisov : https://github.com/kraz

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('bg', {
        months : "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),
        monthsShort : "янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
        weekdays : "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),
        weekdaysShort : "нед_пон_вто_сря_чет_пет_съб".split("_"),
        weekdaysMin : "нд_пн_вт_ср_чт_пт_сб".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "D.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "след %s",
            past : "преди %s",
            s : "няколко секунди",
            m : "минута",
            mm : "%d минути",
            h : "час",
            hh : "%d часа",
            d : "ден",
            dd : "%d дни",
            M : "месец",
            MM : "%d месеца",
            y : "година",
            yy : "%d години"
        },
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : breton (br)
// author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

(function (factory) {
    factory(moment);
}(function (moment) {
    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': "munutenn",
            'MM': "miz",
            'dd': "devezh"
        };
        return number + ' ' + mutation(format[key], number);
    }

    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
        }
    }

    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }

    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }

    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    return moment.lang('br', {
        months : "Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
        monthsShort : "Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        weekdays : "Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),
        weekdaysShort : "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        weekdaysMin : "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
        longDateFormat : {
            LT : "h[e]mm A",
            L : "DD/MM/YYYY",
            LL : "D [a viz] MMMM YYYY",
            LLL : "D [a viz] MMMM YYYY LT",
            LLLL : "dddd, D [a viz] MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "a-benn %s",
            past : "%s 'zo",
            s : "un nebeud segondennoù",
            m : "ur vunutenn",
            mm : relativeTimeWithMutation,
            h : "un eur",
            hh : "%d eur",
            d : "un devezh",
            dd : relativeTimeWithMutation,
            M : "ur miz",
            MM : relativeTimeWithMutation,
            y : "ur bloaz",
            yy : specialMutationForYears
        },
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : bosnian (bs)
// author : Nedim Cholich : https://github.com/frontyard
// based on (hr) translation by Bojan Marković

(function (factory) {
    factory(moment);
}(function (moment) {

    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
        }
    }

    return moment.lang('bs', {
		months : "januar_februar_mart_april_maj_juni_juli_avgust_septembar_oktobar_novembar_decembar".split("_"),
		monthsShort : "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        weekdays : "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        weekdaysShort : "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        weekdaysMin : "ne_po_ut_sr_če_pe_su".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD. MM. YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd, D. MMMM YYYY LT"
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',

            nextWeek : function () {
                switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "za %s",
            past   : "prije %s",
            s      : "par sekundi",
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : "dan",
            dd     : translate,
            M      : "mjesec",
            MM     : translate,
            y      : "godinu",
            yy     : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : catalan (ca)
// author : Juan G. Hurtado : https://github.com/juanghurtado

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ca', {
        months : "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
        monthsShort : "gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.".split("_"),
        weekdays : "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
        weekdaysShort : "dg._dl._dt._dc._dj._dv._ds.".split("_"),
        weekdaysMin : "Dg_Dl_Dt_Dc_Dj_Dv_Ds".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "en %s",
            past : "fa %s",
            s : "uns segons",
            m : "un minut",
            mm : "%d minuts",
            h : "una hora",
            hh : "%d hores",
            d : "un dia",
            dd : "%d dies",
            M : "un mes",
            MM : "%d mesos",
            y : "un any",
            yy : "%d anys"
        },
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : czech (cs)
// author : petrbela : https://github.com/petrbela

(function (factory) {
    factory(moment);
}(function (moment) {
    var months = "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
        monthsShort = "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_");

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }

    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
        }
    }

    return moment.lang('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        weekdays : "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),
        weekdaysShort : "ne_po_út_st_čt_pá_so".split("_"),
        weekdaysMin : "ne_po_út_st_čt_pá_so".split("_"),
        longDateFormat : {
            LT: "H.mm",
            L : "DD. MM. YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd D. MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[dnes v] LT",
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
                }
            },
            sameElse: "L"
        },
        relativeTime : {
            future : "za %s",
            past : "před %s",
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : chuvash (cv)
// author : Anatoly Mironov : https://github.com/mirontoli

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('cv', {
        months : "кăрлач_нарăс_пуш_ака_май_çĕртме_утă_çурла_авăн_юпа_чӳк_раштав".split("_"),
        monthsShort : "кăр_нар_пуш_ака_май_çĕр_утă_çур_ав_юпа_чӳк_раш".split("_"),
        weekdays : "вырсарникун_тунтикун_ытларикун_юнкун_кĕçнерникун_эрнекун_шăматкун".split("_"),
        weekdaysShort : "выр_тун_ытл_юн_кĕç_эрн_шăм".split("_"),
        weekdaysMin : "вр_тн_ыт_юн_кç_эр_шм".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD-MM-YYYY",
            LL : "YYYY [çулхи] MMMM [уйăхĕн] D[-мĕшĕ]",
            LLL : "YYYY [çулхи] MMMM [уйăхĕн] D[-мĕшĕ], LT",
            LLLL : "dddd, YYYY [çулхи] MMMM [уйăхĕн] D[-мĕшĕ], LT"
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ĕнер] LT [сехетре]',
            nextWeek: '[Çитес] dddd LT [сехетре]',
            lastWeek: '[Иртнĕ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? "рен" : /çул$/i.exec(output) ? "тан" : "ран";
                return output + affix;
            },
            past : "%s каялла",
            s : "пĕр-ик çеккунт",
            m : "пĕр минут",
            mm : "%d минут",
            h : "пĕр сехет",
            hh : "%d сехет",
            d : "пĕр кун",
            dd : "%d кун",
            M : "пĕр уйăх",
            MM : "%d уйăх",
            y : "пĕр çул",
            yy : "%d çул"
        },
        ordinal : '%d-мĕш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Welsh (cy)
// author : Robert Allen

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang("cy", {
        months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
        monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
        weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
        weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
        // time formats are the same as en-gb
        longDateFormat: {
            LT: "HH:mm",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY LT",
            LLLL: "dddd, D MMMM YYYY LT"
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "mewn %s",
            past: "%s yn àl",
            s: "ychydig eiliadau",
            m: "munud",
            mm: "%d munud",
            h: "awr",
            hh: "%d awr",
            d: "diwrnod",
            dd: "%d diwrnod",
            M: "mis",
            MM: "%d mis",
            y: "blwyddyn",
            yy: "%d flynedd"
        },
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];

            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }

            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : danish (da)
// author : Ulrik Nielsen : https://github.com/mrbase

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('da', {
        months : "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        monthsShort : "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays : "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        weekdaysShort : "søn_man_tir_ons_tor_fre_lør".split("_"),
        weekdaysMin : "sø_ma_ti_on_to_fr_lø".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D. MMMM, YYYY LT"
        },
        calendar : {
            sameDay : '[I dag kl.] LT',
            nextDay : '[I morgen kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[I går kl.] LT',
            lastWeek : '[sidste] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "om %s",
            past : "%s siden",
            s : "få sekunder",
            m : "et minut",
            mm : "%d minutter",
            h : "en time",
            hh : "%d timer",
            d : "en dag",
            dd : "%d dage",
            M : "en måned",
            MM : "%d måneder",
            y : "et år",
            yy : "%d år"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : german (de)
// author : lluchs : https://github.com/lluchs
// author: Menelion Elensúle: https://github.com/Oire

(function (factory) {
    factory(moment);
}(function (moment) {
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    return moment.lang('de', {
        months : "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort : "Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        weekdays : "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort : "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin : "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        longDateFormat : {
            LT: "HH:mm [Uhr]",
            L : "DD.MM.YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd, D. MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[Heute um] LT",
            sameElse: "L",
            nextDay: '[Morgen um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gestern um] LT',
            lastWeek: '[letzten] dddd [um] LT'
        },
        relativeTime : {
            future : "in %s",
            past : "vor %s",
            s : "ein paar Sekunden",
            m : processRelativeTime,
            mm : "%d Minuten",
            h : processRelativeTime,
            hh : "%d Stunden",
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : modern greek (el)
// author : Aggelos Karalias : https://github.com/mehiel

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('el', {
        monthsNominativeEl : "Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),
        monthsGenitiveEl : "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),
        months : function (momentToFormat, format) {
            if (/D/.test(format.substring(0, format.indexOf("MMMM")))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
        weekdays : "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),
        weekdaysShort : "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
        weekdaysMin : "Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        longDateFormat : {
            LT : "h:mm A",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : '[την προηγούμενη] dddd [{}] LT',
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();

            return output.replace("{}", (hours % 12 === 1 ? "στη" : "στις"));
        },
        relativeTime : {
            future : "σε %s",
            past : "%s πριν",
            s : "δευτερόλεπτα",
            m : "ένα λεπτό",
            mm : "%d λεπτά",
            h : "μία ώρα",
            hh : "%d ώρες",
            d : "μία μέρα",
            dd : "%d μέρες",
            M : "ένας μήνας",
            MM : "%d μήνες",
            y : "ένας χρόνος",
            yy : "%d χρόνια"
        },
        ordinal : function (number) {
            return number + 'η';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : australian english (en-au)

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('en-au', {
        months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat : {
            LT : "h:mm A",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        ordinal : function (number) {
            var b = number % 10,
                output = (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : canadian english (en-ca)
// author : Jonathan Abourbih : https://github.com/jonbca

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('en-ca', {
        months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat : {
            LT : "h:mm A",
            L : "YYYY-MM-DD",
            LL : "D MMMM, YYYY",
            LLL : "D MMMM, YYYY LT",
            LLLL : "dddd, D MMMM, YYYY LT"
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        ordinal : function (number) {
            var b = number % 10,
                output = (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });
}));
// moment.js language configuration
// language : great britain english (en-gb)
// author : Chris Gedrim : https://github.com/chrisgedrim

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('en-gb', {
        months : "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort : "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays : "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort : "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin : "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "in %s",
            past : "%s ago",
            s : "a few seconds",
            m : "a minute",
            mm : "%d minutes",
            h : "an hour",
            hh : "%d hours",
            d : "a day",
            dd : "%d days",
            M : "a month",
            MM : "%d months",
            y : "a year",
            yy : "%d years"
        },
        ordinal : function (number) {
            var b = number % 10,
                output = (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : esperanto (eo)
// author : Colin Dean : https://github.com/colindean
// komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
//          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('eo', {
        months : "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),
        monthsShort : "jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec".split("_"),
        weekdays : "Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato".split("_"),
        weekdaysShort : "Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab".split("_"),
        weekdaysMin : "Di_Lu_Ma_Me_Ĵa_Ve_Sa".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "YYYY-MM-DD",
            LL : "D[-an de] MMMM, YYYY",
            LLL : "D[-an de] MMMM, YYYY LT",
            LLLL : "dddd, [la] D[-an de] MMMM, YYYY LT"
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "je %s",
            past : "antaŭ %s",
            s : "sekundoj",
            m : "minuto",
            mm : "%d minutoj",
            h : "horo",
            hh : "%d horoj",
            d : "tago",//ne 'diurno', ĉar estas uzita por proksimumo
            dd : "%d tagoj",
            M : "monato",
            MM : "%d monatoj",
            y : "jaro",
            yy : "%d jaroj"
        },
        ordinal : "%da",
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : spanish (es)
// author : Julio Napurí : https://github.com/julionc

(function (factory) {
    factory(moment);
}(function (moment) {
    var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
        monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");

    return moment.lang('es', {
        months : "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        weekdays : "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        weekdaysShort : "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        weekdaysMin : "Do_Lu_Ma_Mi_Ju_Vi_Sá".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD/MM/YYYY",
            LL : "D [de] MMMM [del] YYYY",
            LLL : "D [de] MMMM [del] YYYY LT",
            LLLL : "dddd, D [de] MMMM [del] YYYY LT"
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "en %s",
            past : "hace %s",
            s : "unos segundos",
            m : "un minuto",
            mm : "%d minutos",
            h : "una hora",
            hh : "%d horas",
            d : "un día",
            dd : "%d días",
            M : "un mes",
            MM : "%d meses",
            y : "un año",
            yy : "%d años"
        },
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : estonian (et)
// author : Henry Kehlmann : https://github.com/madhenry
// improvements : Illimar Tambek : https://github.com/ragulka

(function (factory) {
    factory(moment);
}(function (moment) {
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    return moment.lang('et', {
        months        : "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
        monthsShort   : "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
        weekdays      : "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),
        weekdaysShort : "P_E_T_K_N_R_L".split("_"),
        weekdaysMin   : "P_E_T_K_N_R_L".split("_"),
        longDateFormat : {
            LT   : "H:mm",
            L    : "DD.MM.YYYY",
            LL   : "D. MMMM YYYY",
            LLL  : "D. MMMM YYYY LT",
            LLLL : "dddd, D. MMMM YYYY LT"
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s pärast",
            past   : "%s tagasi",
            s      : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : euskara (eu)
// author : Eneko Illarramendi : https://github.com/eillarra

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('eu', {
        months : "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
        monthsShort : "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
        weekdays : "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
        weekdaysShort : "ig._al._ar._az._og._ol._lr.".split("_"),
        weekdaysMin : "ig_al_ar_az_og_ol_lr".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "YYYY-MM-DD",
            LL : "YYYY[ko] MMMM[ren] D[a]",
            LLL : "YYYY[ko] MMMM[ren] D[a] LT",
            LLLL : "dddd, YYYY[ko] MMMM[ren] D[a] LT",
            l : "YYYY-M-D",
            ll : "YYYY[ko] MMM D[a]",
            lll : "YYYY[ko] MMM D[a] LT",
            llll : "ddd, YYYY[ko] MMM D[a] LT"
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s barru",
            past : "duela %s",
            s : "segundo batzuk",
            m : "minutu bat",
            mm : "%d minutu",
            h : "ordu bat",
            hh : "%d ordu",
            d : "egun bat",
            dd : "%d egun",
            M : "hilabete bat",
            MM : "%d hilabete",
            y : "urte bat",
            yy : "%d urte"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Persian Language
// author : Ebrahim Byagowi : https://github.com/ebraminio

(function (factory) {
    factory(moment);
}(function (moment) {
    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    return moment.lang('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY LT',
            LLLL : 'dddd, D MMMM YYYY LT'
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return "قبل از ظهر";
            } else {
                return "بعد از ظهر";
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چندین ثانیه',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : finnish (fi)
// author : Tarmo Aidantausta : https://github.com/bleadof

(function (factory) {
    factory(moment);
}(function (moment) {
    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
                          numbersPast[7], numbersPast[8], numbersPast[9]];

    function translate(number, withoutSuffix, key, isFuture) {
        var result = "";
        switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
        }
        result = verbalNumber(number, isFuture) + " " + result;
        return result;
    }

    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    return moment.lang('fi', {
        months : "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
        monthsShort : "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),
        weekdays : "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
        weekdaysShort : "su_ma_ti_ke_to_pe_la".split("_"),
        weekdaysMin : "su_ma_ti_ke_to_pe_la".split("_"),
        longDateFormat : {
            LT : "HH.mm",
            L : "DD.MM.YYYY",
            LL : "Do MMMM[ta] YYYY",
            LLL : "Do MMMM[ta] YYYY, [klo] LT",
            LLLL : "dddd, Do MMMM[ta] YYYY, [klo] LT",
            l : "D.M.YYYY",
            ll : "Do MMM YYYY",
            lll : "Do MMM YYYY, [klo] LT",
            llll : "ddd, Do MMM YYYY, [klo] LT"
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s päästä",
            past : "%s sitten",
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinal : "%d.",
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : faroese (fo)
// author : Ragnar Johannesen : https://github.com/ragnar123

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('fo', {
        months : "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort : "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays : "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),
        weekdaysShort : "sun_mán_týs_mik_hós_frí_ley".split("_"),
        weekdaysMin : "su_má_tý_mi_hó_fr_le".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D. MMMM, YYYY LT"
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "um %s",
            past : "%s síðani",
            s : "fá sekund",
            m : "ein minutt",
            mm : "%d minuttir",
            h : "ein tími",
            hh : "%d tímar",
            d : "ein dagur",
            dd : "%d dagar",
            M : "ein mánaði",
            MM : "%d mánaðir",
            y : "eitt ár",
            yy : "%d ár"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : canadian french (fr-ca)
// author : Jonathan Abourbih : https://github.com/jonbca

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('fr-ca', {
        months : "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort : "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        weekdays : "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort : "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin : "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "YYYY-MM-DD",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[Aujourd'hui à] LT",
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "dans %s",
            past : "il y a %s",
            s : "quelques secondes",
            m : "une minute",
            mm : "%d minutes",
            h : "une heure",
            hh : "%d heures",
            d : "un jour",
            dd : "%d jours",
            M : "un mois",
            MM : "%d mois",
            y : "un an",
            yy : "%d ans"
        },
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : '');
        }
    });
}));
// moment.js language configuration
// language : french (fr)
// author : John Fischer : https://github.com/jfroffice

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('fr', {
        months : "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort : "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        weekdays : "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort : "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin : "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[Aujourd'hui à] LT",
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "dans %s",
            past : "il y a %s",
            s : "quelques secondes",
            m : "une minute",
            mm : "%d minutes",
            h : "une heure",
            hh : "%d heures",
            d : "un jour",
            dd : "%d jours",
            M : "un mois",
            MM : "%d mois",
            y : "un an",
            yy : "%d ans"
        },
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : '');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : galician (gl)
// author : Juan G. Hurtado : https://github.com/juanghurtado

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('gl', {
        months : "Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro".split("_"),
        monthsShort : "Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.".split("_"),
        weekdays : "Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado".split("_"),
        weekdaysShort : "Dom._Lun._Mar._Mér._Xov._Ven._Sáb.".split("_"),
        weekdaysMin : "Do_Lu_Ma_Mé_Xo_Ve_Sá".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str === "uns segundos") {
                    return "nuns segundos";
                }
                return "en " + str;
            },
            past : "hai %s",
            s : "uns segundos",
            m : "un minuto",
            mm : "%d minutos",
            h : "unha hora",
            hh : "%d horas",
            d : "un día",
            dd : "%d días",
            M : "un mes",
            MM : "%d meses",
            y : "un ano",
            yy : "%d anos"
        },
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Hebrew (he)
// author : Tomer Cohen : https://github.com/tomer
// author : Moshe Simantov : https://github.com/DevelopmentIL
// author : Tal Ater : https://github.com/TalAter

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('he', {
        months : "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
        monthsShort : "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),
        weekdays : "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
        weekdaysShort : "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
        weekdaysMin : "א_ב_ג_ד_ה_ו_ש".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D [ב]MMMM YYYY",
            LLL : "D [ב]MMMM YYYY LT",
            LLLL : "dddd, D [ב]MMMM YYYY LT",
            l : "D/M/YYYY",
            ll : "D MMM YYYY",
            lll : "D MMM YYYY LT",
            llll : "ddd, D MMM YYYY LT"
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "בעוד %s",
            past : "לפני %s",
            s : "מספר שניות",
            m : "דקה",
            mm : "%d דקות",
            h : "שעה",
            hh : function (number) {
                if (number === 2) {
                    return "שעתיים";
                }
                return number + " שעות";
            },
            d : "יום",
            dd : function (number) {
                if (number === 2) {
                    return "יומיים";
                }
                return number + " ימים";
            },
            M : "חודש",
            MM : function (number) {
                if (number === 2) {
                    return "חודשיים";
                }
                return number + " חודשים";
            },
            y : "שנה",
            yy : function (number) {
                if (number === 2) {
                    return "שנתיים";
                }
                return number + " שנים";
            }
        }
    });
}));
// moment.js language configuration
// language : hindi (hi)
// author : Mayank Singhal : https://github.com/mayanksinghal

(function (factory) {
    factory(moment);
}(function (moment) {
    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    return moment.lang('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split("_"),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split("_"),
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split("_"),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split("_"),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split("_"),
        longDateFormat : {
            LT : "A h:mm बजे",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY, LT",
            LLLL : "dddd, D MMMM YYYY, LT"
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s में",
            past : "%s पहले",
            s : "कुछ ही क्षण",
            m : "एक मिनट",
            mm : "%d मिनट",
            h : "एक घंटा",
            hh : "%d घंटे",
            d : "एक दिन",
            dd : "%d दिन",
            M : "एक महीने",
            MM : "%d महीने",
            y : "एक वर्ष",
            yy : "%d वर्ष"
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return "रात";
            } else if (hour < 10) {
                return "सुबह";
            } else if (hour < 17) {
                return "दोपहर";
            } else if (hour < 20) {
                return "शाम";
            } else {
                return "रात";
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : hrvatski (hr)
// author : Bojan Marković : https://github.com/bmarkovic

// based on (sl) translation by Robert Sedovšek

(function (factory) {
    factory(moment);
}(function (moment) {

    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
        }
    }

    return moment.lang('hr', {
        months : "sječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_"),
        monthsShort : "sje._vel._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
        weekdays : "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        weekdaysShort : "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        weekdaysMin : "ne_po_ut_sr_če_pe_su".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD. MM. YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd, D. MMMM YYYY LT"
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',

            nextWeek : function () {
                switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "za %s",
            past   : "prije %s",
            s      : "par sekundi",
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : "dan",
            dd     : translate,
            M      : "mjesec",
            MM     : translate,
            y      : "godinu",
            yy     : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : hungarian (hu)
// author : Adam Brunner : https://github.com/adambrunner

(function (factory) {
    factory(moment);
}(function (moment) {
    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

    function translate(number, withoutSuffix, key, isFuture) {
        var num = number,
            suffix;

        switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }

        return '';
    }

    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    return moment.lang('hu', {
        months : "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
        monthsShort : "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),
        weekdays : "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
        weekdaysShort : "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
        weekdaysMin : "v_h_k_sze_cs_p_szo".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "YYYY.MM.DD.",
            LL : "YYYY. MMMM D.",
            LLL : "YYYY. MMMM D., LT",
            LLLL : "YYYY. MMMM D., dddd LT"
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s múlva",
            past : "%s",
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Armenian (hy-am)
// author : Armendarabyan : https://github.com/armendarabyan

(function (factory) {
    factory(moment);
}(function (moment) {

    function monthsCaseReplace(m, format) {
        var months = {
            'nominative': 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_'),
            'accusative': 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_')
        },

        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
            'accusative' :
            'nominative';

        return months[nounCase][m.month()];
    }

    function monthsShortCaseReplace(m, format) {
        var monthsShort = 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_');

        return monthsShort[m.month()];
    }

    function weekdaysCaseReplace(m, format) {
        var weekdays = 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_');

        return weekdays[m.day()];
    }

    return moment.lang('hy-am', {
        months : monthsCaseReplace,
        monthsShort : monthsShortCaseReplace,
        weekdays : weekdaysCaseReplace,
        weekdaysShort : "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
        weekdaysMin : "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY թ.",
            LLL : "D MMMM YYYY թ., LT",
            LLLL : "dddd, D MMMM YYYY թ., LT"
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "%s հետո",
            past : "%s առաջ",
            s : "մի քանի վայրկյան",
            m : "րոպե",
            mm : "%d րոպե",
            h : "ժամ",
            hh : "%d ժամ",
            d : "օր",
            dd : "%d օր",
            M : "ամիս",
            MM : "%d ամիս",
            y : "տարի",
            yy : "%d տարի"
        },

        meridiem : function (hour) {
            if (hour < 4) {
                return "գիշերվա";
            } else if (hour < 12) {
                return "առավոտվա";
            } else if (hour < 17) {
                return "ցերեկվա";
            } else {
                return "երեկոյան";
            }
        },

        ordinal: function (number, period) {
            switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
            }
        },

        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Bahasa Indonesia (id)
// author : Mohammad Satrio Utomo : https://github.com/tyok
// reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('id', {
        months : "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
        monthsShort : "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),
        weekdays : "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
        weekdaysShort : "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
        weekdaysMin : "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat : {
            LT : "HH.mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY [pukul] LT",
            LLLL : "dddd, D MMMM YYYY [pukul] LT"
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "dalam %s",
            past : "%s yang lalu",
            s : "beberapa detik",
            m : "semenit",
            mm : "%d menit",
            h : "sejam",
            hh : "%d jam",
            d : "sehari",
            dd : "%d hari",
            M : "sebulan",
            MM : "%d bulan",
            y : "setahun",
            yy : "%d tahun"
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : icelandic (is)
// author : Hinrik Örn Sigurðsson : https://github.com/hinrik

(function (factory) {
    factory(moment);
}(function (moment) {
    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }

    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    return moment.lang('is', {
        months : "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),
        monthsShort : "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
        weekdays : "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),
        weekdaysShort : "sun_mán_þri_mið_fim_fös_lau".split("_"),
        weekdaysMin : "Su_Má_Þr_Mi_Fi_Fö_La".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD/MM/YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY [kl.] LT",
            LLLL : "dddd, D. MMMM YYYY [kl.] LT"
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "eftir %s",
            past : "fyrir %s síðan",
            s : translate,
            m : translate,
            mm : translate,
            h : "klukkustund",
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : italian (it)
// author : Lorenzo : https://github.com/aliem
// author: Mattia Larentis: https://github.com/nostalgiaz

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('it', {
        months : "Gennaio_Febbraio_Marzo_Aprile_Maggio_Giugno_Luglio_Agosto_Settembre_Ottobre_Novembre_Dicembre".split("_"),
        monthsShort : "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_"),
        weekdays : "Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),
        weekdaysShort : "Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),
        weekdaysMin : "D_L_Ma_Me_G_V_S".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: '[lo scorso] dddd [alle] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? "tra" : "in") + " " + s;
            },
            past : "%s fa",
            s : "alcuni secondi",
            m : "un minuto",
            mm : "%d minuti",
            h : "un'ora",
            hh : "%d ore",
            d : "un giorno",
            dd : "%d giorni",
            M : "un mese",
            MM : "%d mesi",
            y : "un anno",
            yy : "%d anni"
        },
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : japanese (ja)
// author : LI Long : https://github.com/baryon

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ja', {
        months : "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        monthsShort : "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays : "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
        weekdaysShort : "日_月_火_水_木_金_土".split("_"),
        weekdaysMin : "日_月_火_水_木_金_土".split("_"),
        longDateFormat : {
            LT : "Ah時m分",
            L : "YYYY/MM/DD",
            LL : "YYYY年M月D日",
            LLL : "YYYY年M月D日LT",
            LLLL : "YYYY年M月D日LT dddd"
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return "午前";
            } else {
                return "午後";
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : '[来週]dddd LT',
            lastDay : '[昨日] LT',
            lastWeek : '[前週]dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s後",
            past : "%s前",
            s : "数秒",
            m : "1分",
            mm : "%d分",
            h : "1時間",
            hh : "%d時間",
            d : "1日",
            dd : "%d日",
            M : "1ヶ月",
            MM : "%dヶ月",
            y : "1年",
            yy : "%d年"
        }
    });
}));
// moment.js language configuration
// language : Georgian (ka)
// author : Irakli Janiashvili : https://github.com/irakli-janiashvili

(function (factory) {
    factory(moment);
}(function (moment) {

    function monthsCaseReplace(m, format) {
        var months = {
            'nominative': 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            'accusative': 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },

        nounCase = (/D[oD] *MMMM?/).test(format) ?
            'accusative' :
            'nominative';

        return months[nounCase][m.month()];
    }

    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            'accusative': 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_')
        },

        nounCase = (/(წინა|შემდეგ)/).test(format) ?
            'accusative' :
            'nominative';

        return weekdays[nounCase][m.day()];
    }

    return moment.lang('ka', {
        months : monthsCaseReplace,
        monthsShort : "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
        weekdaysMin : "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
        longDateFormat : {
            LT : "h:mm A",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, "ში") :
                    s + "ში";
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, "ის წინ");
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, "წლის წინ");
                }
            },
            s : "რამდენიმე წამი",
            m : "წუთი",
            mm : "%d წუთი",
            h : "საათი",
            hh : "%d საათი",
            d : "დღე",
            dd : "%d დღე",
            M : "თვე",
            MM : "%d თვე",
            y : "წელი",
            yy : "%d წელი"
        },
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }

            if (number === 1) {
                return number + "-ლი";
            }

            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return "მე-" + number;
            }

            return number + "-ე";
        },
        week : {
            dow : 1,
            doy : 7
        }
    });
}));
// moment.js language configuration
// language : khmer (km)
// author : Kruy Vanna : https://github.com/kruyvanna

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('km', {
        months: "មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        monthsShort: "មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        weekdaysShort: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        weekdaysMin: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY LT",
            LLLL: "dddd, D MMMM YYYY LT"
        },
        calendar: {
            sameDay: '[ថ្ងៃនៈ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "%sទៀត",
            past: "%sមុន",
            s: "ប៉ុន្មានវិនាទី",
            m: "មួយនាទី",
            mm: "%d នាទី",
            h: "មួយម៉ោង",
            hh: "%d ម៉ោង",
            d: "មួយថ្ងៃ",
            dd: "%d ថ្ងៃ",
            M: "មួយខែ",
            MM: "%d ខែ",
            y: "មួយឆ្នាំ",
            yy: "%d ឆ្នាំ"
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : korean (ko)
//
// authors 
//
// - Kyungwook, Park : https://github.com/kyungw00k
// - Jeeeyul Lee <jeeeyul@gmail.com>
(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ko', {
        months : "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        monthsShort : "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        weekdays : "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),
        weekdaysShort : "일_월_화_수_목_금_토".split("_"),
        weekdaysMin : "일_월_화_수_목_금_토".split("_"),
        longDateFormat : {
            LT : "A h시 mm분",
            L : "YYYY.MM.DD",
            LL : "YYYY년 MMMM D일",
            LLL : "YYYY년 MMMM D일 LT",
            LLLL : "YYYY년 MMMM D일 dddd LT"
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s 후",
            past : "%s 전",
            s : "몇초",
            ss : "%d초",
            m : "일분",
            mm : "%d분",
            h : "한시간",
            hh : "%d시간",
            d : "하루",
            dd : "%d일",
            M : "한달",
            MM : "%d달",
            y : "일년",
            yy : "%d년"
        },
        ordinal : '%d일',
        meridiemParse : /(오전|오후)/,
        isPM : function (token) {
            return token === "오후";
        }
    });
}));
// moment.js language configuration
// language : Luxembourgish (lb)
// author : mweimerskirch : https://github.com/mweimerskirch

// Note: Luxembourgish has a very particular phonological rule ("Eifeler Regel") that causes the
// deletion of the final "n" in certain contexts. That's what the "eifelerRegelAppliesToWeekday"
// and "eifelerRegelAppliesToNumber" methods are meant for

(function (factory) {
    factory(moment);
}(function (moment) {
    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'dd': [number + ' Deeg', number + ' Deeg'],
            'M': ['ee Mount', 'engem Mount'],
            'MM': [number + ' Méint', number + ' Méint'],
            'y': ['ee Joer', 'engem Joer'],
            'yy': [number + ' Joer', number + ' Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return "a " + string;
        }
        return "an " + string;
    }

    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return "viru " + string;
        }
        return "virun " + string;
    }

    function processLastWeek(string1) {
        var weekday = this.format('d');
        if (eifelerRegelAppliesToWeekday(weekday)) {
            return '[Leschte] dddd [um] LT';
        }
        return '[Leschten] dddd [um] LT';
    }

    /**
     * Returns true if the word before the given week day loses the "-n" ending.
     * e.g. "Leschten Dënschdeg" but "Leschte Méindeg"
     *
     * @param weekday {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToWeekday(weekday) {
        weekday = parseInt(weekday, 10);
        switch (weekday) {
        case 0: // Sonndeg
        case 1: // Méindeg
        case 3: // Mëttwoch
        case 5: // Freideg
        case 6: // Samschdeg
            return true;
        default: // 2 Dënschdeg, 4 Donneschdeg
            return false;
        }
    }

    /**
     * Returns true if the word before the given number loses the "-n" ending.
     * e.g. "an 10 Deeg" but "a 5 Deeg"
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    return moment.lang('lb', {
        months: "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        weekdays: "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
        weekdaysShort: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mé_Dë_Më_Do_Fr_Sa".split("_"),
        longDateFormat: {
            LT: "H:mm [Auer]",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY LT",
            LLLL: "dddd, D. MMMM YYYY LT"
        },
        calendar: {
            sameDay: "[Haut um] LT",
            sameElse: "L",
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: processLastWeek
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: "e puer Sekonnen",
            m: processRelativeTime,
            mm: "%d Minutten",
            h: processRelativeTime,
            hh: "%d Stonnen",
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Lithuanian (lt)
// author : Mindaugas Mozūras : https://github.com/mmozuras

(function (factory) {
    factory(moment);
}(function (moment) {
    var units = {
        "m" : "minutė_minutės_minutę",
        "mm": "minutės_minučių_minutes",
        "h" : "valanda_valandos_valandą",
        "hh": "valandos_valandų_valandas",
        "d" : "diena_dienos_dieną",
        "dd": "dienos_dienų_dienas",
        "M" : "mėnuo_mėnesio_mėnesį",
        "MM": "mėnesiai_mėnesių_mėnesius",
        "y" : "metai_metų_metus",
        "yy": "metai_metų_metus"
    },
    weekDays = "pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis_sekmadienis".split("_");

    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return "kelios sekundės";
        } else {
            return isFuture ? "kelių sekundžių" : "kelias sekundes";
        }
    }

    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }

    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }

    function forms(key) {
        return units[key].split("_");
    }

    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }

    function relativeWeekDay(moment, format) {
        var nominative = format.indexOf('dddd HH:mm') === -1,
            weekDay = weekDays[moment.weekday()];

        return nominative ? weekDay : weekDay.substring(0, weekDay.length - 2) + "į";
    }

    return moment.lang("lt", {
        months : "sausio_vasario_kovo_balandžio_gegužės_biržėlio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
        monthsShort : "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
        weekdays : relativeWeekDay,
        weekdaysShort : "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
        weekdaysMin : "S_P_A_T_K_Pn_Š".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "YYYY-MM-DD",
            LL : "YYYY [m.] MMMM D [d.]",
            LLL : "YYYY [m.] MMMM D [d.], LT [val.]",
            LLLL : "YYYY [m.] MMMM D [d.], dddd, LT [val.]",
            l : "YYYY-MM-DD",
            ll : "YYYY [m.] MMMM D [d.]",
            lll : "YYYY [m.] MMMM D [d.], LT [val.]",
            llll : "YYYY [m.] MMMM D [d.], ddd, LT [val.]"
        },
        calendar : {
            sameDay : "[Šiandien] LT",
            nextDay : "[Rytoj] LT",
            nextWeek : "dddd LT",
            lastDay : "[Vakar] LT",
            lastWeek : "[Praėjusį] dddd LT",
            sameElse : "L"
        },
        relativeTime : {
            future : "po %s",
            past : "prieš %s",
            s : translateSeconds,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : latvian (lv)
// author : Kristaps Karlsons : https://github.com/skakri

(function (factory) {
    factory(moment);
}(function (moment) {
    var units = {
        'mm': 'minūti_minūtes_minūte_minūtes',
        'hh': 'stundu_stundas_stunda_stundas',
        'dd': 'dienu_dienas_diena_dienas',
        'MM': 'mēnesi_mēnešus_mēnesis_mēneši',
        'yy': 'gadu_gadus_gads_gadi'
    };

    function format(word, number, withoutSuffix) {
        var forms = word.split('_');
        if (withoutSuffix) {
            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
        } else {
            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
        }
    }

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }

    return moment.lang('lv', {
        months : "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
        monthsShort : "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
        weekdays : "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),
        weekdaysShort : "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysMin : "Sv_P_O_T_C_Pk_S".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "YYYY. [gada] D. MMMM",
            LLL : "YYYY. [gada] D. MMMM, LT",
            LLLL : "YYYY. [gada] D. MMMM, dddd, LT"
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s vēlāk",
            past : "%s agrāk",
            s : "dažas sekundes",
            m : "minūti",
            mm : relativeTimeWithPlural,
            h : "stundu",
            hh : relativeTimeWithPlural,
            d : "dienu",
            dd : relativeTimeWithPlural,
            M : "mēnesi",
            MM : relativeTimeWithPlural,
            y : "gadu",
            yy : relativeTimeWithPlural
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : macedonian (mk)
// author : Borislav Mickov : https://github.com/B0k0

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('mk', {
        months : "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),
        monthsShort : "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
        weekdays : "недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),
        weekdaysShort : "нед_пон_вто_сре_чет_пет_саб".split("_"),
        weekdaysMin : "нe_пo_вт_ср_че_пе_сa".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "D.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : 'dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Во изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Во изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "после %s",
            past : "пред %s",
            s : "неколку секунди",
            m : "минута",
            mm : "%d минути",
            h : "час",
            hh : "%d часа",
            d : "ден",
            dd : "%d дена",
            M : "месец",
            MM : "%d месеци",
            y : "година",
            yy : "%d години"
        },
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : malayalam (ml)
// author : Floyd Pink : https://github.com/floydpink

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split("_"),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split("_"),
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split("_"),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split("_"),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split("_"),
        longDateFormat : {
            LT : "A h:mm -നു",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY, LT",
            LLLL : "dddd, D MMMM YYYY, LT"
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s കഴിഞ്ഞ്",
            past : "%s മുൻപ്",
            s : "അൽപ നിമിഷങ്ങൾ",
            m : "ഒരു മിനിറ്റ്",
            mm : "%d മിനിറ്റ്",
            h : "ഒരു മണിക്കൂർ",
            hh : "%d മണിക്കൂർ",
            d : "ഒരു ദിവസം",
            dd : "%d ദിവസം",
            M : "ഒരു മാസം",
            MM : "%d മാസം",
            y : "ഒരു വർഷം",
            yy : "%d വർഷം"
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return "രാത്രി";
            } else if (hour < 12) {
                return "രാവിലെ";
            } else if (hour < 17) {
                return "ഉച്ച കഴിഞ്ഞ്";
            } else if (hour < 20) {
                return "വൈകുന്നേരം";
            } else {
                return "രാത്രി";
            }
        }
    });
}));
// moment.js language configuration
// language : Marathi (mr)
// author : Harshad Kale : https://github.com/kalehv

(function (factory) {
    factory(moment);
}(function (moment) {
    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    return moment.lang('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split("_"),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split("_"),
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split("_"),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split("_"),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split("_"),
        longDateFormat : {
            LT : "A h:mm वाजता",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY, LT",
            LLLL : "dddd, D MMMM YYYY, LT"
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s नंतर",
            past : "%s पूर्वी",
            s : "सेकंद",
            m: "एक मिनिट",
            mm: "%d मिनिटे",
            h : "एक तास",
            hh : "%d तास",
            d : "एक दिवस",
            dd : "%d दिवस",
            M : "एक महिना",
            MM : "%d महिने",
            y : "एक वर्ष",
            yy : "%d वर्षे"
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiem: function (hour, minute, isLower)
        {
            if (hour < 4) {
                return "रात्री";
            } else if (hour < 10) {
                return "सकाळी";
            } else if (hour < 17) {
                return "दुपारी";
            } else if (hour < 20) {
                return "सायंकाळी";
            } else {
                return "रात्री";
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Bahasa Malaysia (ms-MY)
// author : Weldan Jamili : https://github.com/weldan

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('ms-my', {
        months : "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort : "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays : "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort : "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin : "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat : {
            LT : "HH.mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY [pukul] LT",
            LLLL : "dddd, D MMMM YYYY [pukul] LT"
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "dalam %s",
            past : "%s yang lepas",
            s : "beberapa saat",
            m : "seminit",
            mm : "%d minit",
            h : "sejam",
            hh : "%d jam",
            d : "sehari",
            dd : "%d hari",
            M : "sebulan",
            MM : "%d bulan",
            y : "setahun",
            yy : "%d tahun"
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : norwegian bokmål (nb)
// authors : Espen Hovlandsdal : https://github.com/rexxars
//           Sigurd Gartmann : https://github.com/sigurdga

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('nb', {
        months : "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort : "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        weekdays : "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        weekdaysShort : "sø._ma._ti._on._to._fr._lø.".split("_"),
        weekdaysMin : "sø_ma_ti_on_to_fr_lø".split("_"),
        longDateFormat : {
            LT : "H.mm",
            L : "DD.MM.YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY [kl.] LT",
            LLLL : "dddd D. MMMM YYYY [kl.] LT"
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "om %s",
            past : "for %s siden",
            s : "noen sekunder",
            m : "ett minutt",
            mm : "%d minutter",
            h : "en time",
            hh : "%d timer",
            d : "en dag",
            dd : "%d dager",
            M : "en måned",
            MM : "%d måneder",
            y : "ett år",
            yy : "%d år"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : nepali/nepalese
// author : suvash : https://github.com/suvash

(function (factory) {
    factory(moment);
}(function (moment) {
    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    return moment.lang('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split("_"),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split("_"),
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split("_"),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split("_"),
        weekdaysMin : 'आइ._सो._मङ्_बु._बि._शु._श.'.split("_"),
        longDateFormat : {
            LT : "Aको h:mm बजे",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY, LT",
            LLLL : "dddd, D MMMM YYYY, LT"
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return "राती";
            } else if (hour < 10) {
                return "बिहान";
            } else if (hour < 15) {
                return "दिउँसो";
            } else if (hour < 18) {
                return "बेलुका";
            } else if (hour < 20) {
                return "साँझ";
            } else {
                return "राती";
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोली] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%sमा",
            past : "%s अगाडी",
            s : "केही समय",
            m : "एक मिनेट",
            mm : "%d मिनेट",
            h : "एक घण्टा",
            hh : "%d घण्टा",
            d : "एक दिन",
            dd : "%d दिन",
            M : "एक महिना",
            MM : "%d महिना",
            y : "एक बर्ष",
            yy : "%d बर्ष"
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : dutch (nl)
// author : Joris Röling : https://github.com/jjupiter

(function (factory) {
    factory(moment);
}(function (moment) {
    var monthsShortWithDots = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
        monthsShortWithoutDots = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_");

    return moment.lang('nl', {
        months : "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort : function (m, format) {
            if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        weekdays : "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort : "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin : "Zo_Ma_Di_Wo_Do_Vr_Za".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD-MM-YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "over %s",
            past : "%s geleden",
            s : "een paar seconden",
            m : "één minuut",
            mm : "%d minuten",
            h : "één uur",
            hh : "%d uur",
            d : "één dag",
            dd : "%d dagen",
            M : "één maand",
            MM : "%d maanden",
            y : "één jaar",
            yy : "%d jaar"
        },
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : norwegian nynorsk (nn)
// author : https://github.com/mechuwind

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('nn', {
        months : "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort : "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays : "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
        weekdaysShort : "sun_mån_tys_ons_tor_fre_lau".split("_"),
        weekdaysMin : "su_må_ty_on_to_fr_lø".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "om %s",
            past : "for %s sidan",
            s : "nokre sekund",
            m : "eit minutt",
            mm : "%d minutt",
            h : "ein time",
            hh : "%d timar",
            d : "ein dag",
            dd : "%d dagar",
            M : "ein månad",
            MM : "%d månader",
            y : "eit år",
            yy : "%d år"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : polish (pl)
// author : Rafal Hirsz : https://github.com/evoL

(function (factory) {
    factory(moment);
}(function (moment) {
    var monthsNominative = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
        monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_");

    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }

    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    return moment.lang('pl', {
        months : function (momentToFormat, format) {
            if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
        weekdays : "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
        weekdaysShort : "nie_pon_wt_śr_czw_pt_sb".split("_"),
        weekdaysMin : "N_Pn_Wt_Śr_Cz_Pt_So".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: '[W] dddd [o] LT',
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "za %s",
            past : "%s temu",
            s : "kilka sekund",
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : "1 dzień",
            dd : '%d dni',
            M : "miesiąc",
            MM : translate,
            y : "rok",
            yy : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : brazilian portuguese (pt-br)
// author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('pt-br', {
        months : "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort : "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays : "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
        weekdaysShort : "dom_seg_ter_qua_qui_sex_sáb".split("_"),
        weekdaysMin : "dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D [de] MMMM [de] YYYY",
            LLL : "D [de] MMMM [de] YYYY [às] LT",
            LLLL : "dddd, D [de] MMMM [de] YYYY [às] LT"
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "em %s",
            past : "%s atrás",
            s : "segundos",
            m : "um minuto",
            mm : "%d minutos",
            h : "uma hora",
            hh : "%d horas",
            d : "um dia",
            dd : "%d dias",
            M : "um mês",
            MM : "%d meses",
            y : "um ano",
            yy : "%d anos"
        },
        ordinal : '%dº'
    });
}));
// moment.js language configuration
// language : portuguese (pt)
// author : Jefferson : https://github.com/jalex79

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('pt', {
        months : "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort : "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        weekdays : "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
        weekdaysShort : "dom_seg_ter_qua_qui_sex_sáb".split("_"),
        weekdaysMin : "dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D [de] MMMM [de] YYYY",
            LLL : "D [de] MMMM [de] YYYY LT",
            LLLL : "dddd, D [de] MMMM [de] YYYY LT"
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "em %s",
            past : "%s atrás",
            s : "segundos",
            m : "um minuto",
            mm : "%d minutos",
            h : "uma hora",
            hh : "%d horas",
            d : "um dia",
            dd : "%d dias",
            M : "um mês",
            MM : "%d meses",
            y : "um ano",
            yy : "%d anos"
        },
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : romanian (ro)
// author : Vlad Gurdiga : https://github.com/gurdiga
// author : Valentin Agachi : https://github.com/avaly

(function (factory) {
    factory(moment);
}(function (moment) {
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }

        return number + separator + format[key];
    }

    return moment.lang('ro', {
        months : "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
        monthsShort : "ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
        weekdays : "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),
        weekdaysShort : "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
        weekdaysMin : "Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY H:mm",
            LLLL : "dddd, D MMMM YYYY H:mm"
        },
        calendar : {
            sameDay: "[azi la] LT",
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "peste %s",
            past : "%s în urmă",
            s : "câteva secunde",
            m : "un minut",
            mm : relativeTimeWithPlural,
            h : "o oră",
            hh : relativeTimeWithPlural,
            d : "o zi",
            dd : relativeTimeWithPlural,
            M : "o lună",
            MM : relativeTimeWithPlural,
            y : "un an",
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : russian (ru)
// author : Viktorminator : https://github.com/Viktorminator
// Author : Menelion Elensúle : https://github.com/Oire

(function (factory) {
    factory(moment);
}(function (moment) {
    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    function monthsCaseReplace(m, format) {
        var months = {
            'nominative': 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
            'accusative': 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_')
        },

        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
            'accusative' :
            'nominative';

        return months[nounCase][m.month()];
    }

    function monthsShortCaseReplace(m, format) {
        var monthsShort = {
            'nominative': 'янв_фев_мар_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
            'accusative': 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_')
        },

        nounCase = (/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/).test(format) ?
            'accusative' :
            'nominative';

        return monthsShort[nounCase][m.month()];
    }

    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            'accusative': 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_')
        },

        nounCase = (/\[ ?[Вв] ?(?:прошлую|следующую)? ?\] ?dddd/).test(format) ?
            'accusative' :
            'nominative';

        return weekdays[nounCase][m.day()];
    }

    return moment.lang('ru', {
        months : monthsCaseReplace,
        monthsShort : monthsShortCaseReplace,
        weekdays : weekdaysCaseReplace,
        weekdaysShort : "вс_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin : "вс_пн_вт_ср_чт_пт_сб".split("_"),
        monthsParse : [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i],
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY г.",
            LLL : "D MMMM YYYY г., LT",
            LLLL : "dddd, D MMMM YYYY г., LT"
        },
        calendar : {
            sameDay: '[Сегодня в] LT',
            nextDay: '[Завтра в] LT',
            lastDay: '[Вчера в] LT',
            nextWeek: function () {
                return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[В прошлое] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                    return '[В прошлый] dddd [в] LT';
                case 3:
                case 5:
                case 6:
                    return '[В прошлую] dddd [в] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "через %s",
            past : "%s назад",
            s : "несколько секунд",
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : "час",
            hh : relativeTimeWithPlural,
            d : "день",
            dd : relativeTimeWithPlural,
            M : "месяц",
            MM : relativeTimeWithPlural,
            y : "год",
            yy : relativeTimeWithPlural
        },

        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason

        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return "ночи";
            } else if (hour < 12) {
                return "утра";
            } else if (hour < 17) {
                return "дня";
            } else {
                return "вечера";
            }
        },

        ordinal: function (number, period) {
            switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
            }
        },

        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : slovak (sk)
// author : Martin Minka : https://github.com/k2s
// based on work of petrbela : https://github.com/petrbela

(function (factory) {
    factory(moment);
}(function (moment) {
    var months = "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),
        monthsShort = "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");

    function plural(n) {
        return (n > 1) && (n < 5);
    }

    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + " ";
        switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
        }
    }

    return moment.lang('sk', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        weekdays : "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
        weekdaysShort : "ne_po_ut_st_št_pi_so".split("_"),
        weekdaysMin : "ne_po_ut_st_št_pi_so".split("_"),
        longDateFormat : {
            LT: "H:mm",
            L : "DD.MM.YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd D. MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[dnes o] LT",
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
                }
            },
            sameElse: "L"
        },
        relativeTime : {
            future : "za %s",
            past : "pred %s",
            s : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : slovenian (sl)
// author : Robert Sedovšek : https://github.com/sedovsek

(function (factory) {
    factory(moment);
}(function (moment) {
    function translate(number, withoutSuffix, key) {
        var result = number + " ";
        switch (key) {
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2) {
                result += 'minuti';
            } else if (number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minut';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += 'ura';
            } else if (number === 2) {
                result += 'uri';
            } else if (number === 3 || number === 4) {
                result += 'ure';
            } else {
                result += 'ur';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dni';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mesec';
            } else if (number === 2) {
                result += 'meseca';
            } else if (number === 3 || number === 4) {
                result += 'mesece';
            } else {
                result += 'mesecev';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'leto';
            } else if (number === 2) {
                result += 'leti';
            } else if (number === 3 || number === 4) {
                result += 'leta';
            } else {
                result += 'let';
            }
            return result;
        }
    }

    return moment.lang('sl', {
        months : "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
        monthsShort : "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        weekdays : "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
        weekdaysShort : "ned._pon._tor._sre._čet._pet._sob.".split("_"),
        weekdaysMin : "ne_po_to_sr_če_pe_so".split("_"),
        longDateFormat : {
            LT : "H:mm",
            L : "DD. MM. YYYY",
            LL : "D. MMMM YYYY",
            LLL : "D. MMMM YYYY LT",
            LLLL : "dddd, D. MMMM YYYY LT"
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[prejšnja] dddd [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "čez %s",
            past   : "%s nazaj",
            s      : "nekaj sekund",
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : "en dan",
            dd     : translate,
            M      : "en mesec",
            MM     : translate,
            y      : "eno leto",
            yy     : translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Albanian (sq)
// author : Flakërim Ismani : https://github.com/flakerimi
// author: Menelion Elensúle: https://github.com/Oire (tests)
// author : Oerd Cukalla : https://github.com/oerd (fixes)

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('sq', {
        months : "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),
        monthsShort : "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
        weekdays : "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),
        weekdaysShort : "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
        weekdaysMin : "D_H_Ma_Më_E_P_Sh".split("_"),
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "në %s",
            past : "%s më parë",
            s : "disa sekonda",
            m : "një minutë",
            mm : "%d minuta",
            h : "një orë",
            hh : "%d orë",
            d : "një ditë",
            dd : "%d ditë",
            M : "një muaj",
            MM : "%d muaj",
            y : "një vit",
            yy : "%d vite"
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Serbian-cyrillic (sr-cyr)
// author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

(function (factory) {
    factory(moment);
}(function (moment) {

    var translator = {
        words: { //Different grammatical cases
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    return moment.lang('sr-cyr', {
        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
        longDateFormat: {
            LT: "H:mm",
            L: "DD. MM. YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY LT",
            LLLL: "dddd, D. MMMM YYYY LT"
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',

            nextWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "за %s",
            past   : "пре %s",
            s      : "неколико секунди",
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : "дан",
            dd     : translator.translate,
            M      : "месец",
            MM     : translator.translate,
            y      : "годину",
            yy     : translator.translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Serbian-latin (sr)
// author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

(function (factory) {
    factory(moment);
}(function (moment) {

    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    return moment.lang('sr', {
        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
        longDateFormat: {
            LT: "H:mm",
            L: "DD. MM. YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY LT",
            LLLL: "dddd, D. MMMM YYYY LT"
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : "za %s",
            past   : "pre %s",
            s      : "nekoliko sekundi",
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : "dan",
            dd     : translator.translate,
            M      : "mesec",
            MM     : translator.translate,
            y      : "godinu",
            yy     : translator.translate
        },
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : swedish (sv)
// author : Jens Alm : https://github.com/ulmus

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('sv', {
        months : "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        monthsShort : "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays : "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),
        weekdaysShort : "sön_mån_tis_ons_tor_fre_lör".split("_"),
        weekdaysMin : "sö_må_ti_on_to_fr_lö".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "YYYY-MM-DD",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: 'dddd LT',
            lastWeek: '[Förra] dddd[en] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "om %s",
            past : "för %s sedan",
            s : "några sekunder",
            m : "en minut",
            mm : "%d minuter",
            h : "en timme",
            hh : "%d timmar",
            d : "en dag",
            dd : "%d dagar",
            M : "en månad",
            MM : "%d månader",
            y : "ett år",
            yy : "%d år"
        },
        ordinal : function (number) {
            var b = number % 10,
                output = (~~ (number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : tamil (ta)
// author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

(function (factory) {
    factory(moment);
}(function (moment) {
    /*var symbolMap = {
            '1': '௧',
            '2': '௨',
            '3': '௩',
            '4': '௪',
            '5': '௫',
            '6': '௬',
            '7': '௭',
            '8': '௮',
            '9': '௯',
            '0': '௦'
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0'
        }; */

    return moment.lang('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split("_"),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split("_"),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split("_"),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split("_"),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY, LT",
            LLLL : "dddd, D MMMM YYYY, LT"
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s இல்",
            past : "%s முன்",
            s : "ஒரு சில விநாடிகள்",
            m : "ஒரு நிமிடம்",
            mm : "%d நிமிடங்கள்",
            h : "ஒரு மணி நேரம்",
            hh : "%d மணி நேரம்",
            d : "ஒரு நாள்",
            dd : "%d நாட்கள்",
            M : "ஒரு மாதம்",
            MM : "%d மாதங்கள்",
            y : "ஒரு வருடம்",
            yy : "%d ஆண்டுகள்"
        },
/*        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },*/
        ordinal : function (number) {
            return number + 'வது';
        },


// refer http://ta.wikipedia.org/s/1er1      

        meridiem : function (hour, minute, isLower) {
            if (hour >= 6 && hour <= 10) {
                return " காலை";
            } else   if (hour >= 10 && hour <= 14) {
                return " நண்பகல்";
            } else    if (hour >= 14 && hour <= 18) {
                return " எற்பாடு";
            } else   if (hour >= 18 && hour <= 20) {
                return " மாலை";
            } else  if (hour >= 20 && hour <= 24) {
                return " இரவு";
            } else  if (hour >= 0 && hour <= 6) {
                return " வைகறை";
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : thai (th)
// author : Kridsada Thanabulpong : https://github.com/sirn

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('th', {
        months : "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),
        monthsShort : "มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา".split("_"),
        weekdays : "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),
        weekdaysShort : "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"), // yes, three characters difference
        weekdaysMin : "อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),
        longDateFormat : {
            LT : "H นาฬิกา m นาที",
            L : "YYYY/MM/DD",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY เวลา LT",
            LLLL : "วันddddที่ D MMMM YYYY เวลา LT"
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return "ก่อนเที่ยง";
            } else {
                return "หลังเที่ยง";
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "อีก %s",
            past : "%sที่แล้ว",
            s : "ไม่กี่วินาที",
            m : "1 นาที",
            mm : "%d นาที",
            h : "1 ชั่วโมง",
            hh : "%d ชั่วโมง",
            d : "1 วัน",
            dd : "%d วัน",
            M : "1 เดือน",
            MM : "%d เดือน",
            y : "1 ปี",
            yy : "%d ปี"
        }
    });
}));
// moment.js language configuration
// language : Tagalog/Filipino (tl-ph)
// author : Dan Hagman

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('tl-ph', {
        months : "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort : "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays : "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort : "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin : "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "MM/D/YYYY",
            LL : "MMMM D, YYYY",
            LLL : "MMMM D, YYYY LT",
            LLLL : "dddd, MMMM DD, YYYY LT"
        },
        calendar : {
            sameDay: "[Ngayon sa] LT",
            nextDay: '[Bukas sa] LT',
            nextWeek: 'dddd [sa] LT',
            lastDay: '[Kahapon sa] LT',
            lastWeek: 'dddd [huling linggo] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "sa loob ng %s",
            past : "%s ang nakalipas",
            s : "ilang segundo",
            m : "isang minuto",
            mm : "%d minuto",
            h : "isang oras",
            hh : "%d oras",
            d : "isang araw",
            dd : "%d araw",
            M : "isang buwan",
            MM : "%d buwan",
            y : "isang taon",
            yy : "%d taon"
        },
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : turkish (tr)
// authors : Erhan Gundogan : https://github.com/erhangundogan,
//           Burak Yiğit Kaya: https://github.com/BYK

(function (factory) {
    factory(moment);
}(function (moment) {

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",

        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",

        3: "'üncü",
        4: "'üncü",
        100: "'üncü",

        6: "'ncı",

        9: "'uncu",
        10: "'uncu",
        30: "'uncu",

        60: "'ıncı",
        90: "'ıncı"
    };

    return moment.lang('tr', {
        months : "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
        monthsShort : "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
        weekdays : "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
        weekdaysShort : "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
        weekdaysMin : "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd, D MMMM YYYY LT"
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[haftaya] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen hafta] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : "%s sonra",
            past : "%s önce",
            s : "birkaç saniye",
            m : "bir dakika",
            mm : "%d dakika",
            h : "bir saat",
            hh : "%d saat",
            d : "bir gün",
            dd : "%d gün",
            M : "bir ay",
            MM : "%d ay",
            y : "bir yıl",
            yy : "%d yıl"
        },
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + "'ıncı";
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;

            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Morocco Central Atlas Tamaziɣt in Latin (tzm-la)
// author : Abdel Said : https://github.com/abdelsaid

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('tzm-la', {
        months : "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        monthsShort : "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        weekdays : "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        weekdaysShort : "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        weekdaysMin : "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[asdkh g] LT",
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "dadkh s yan %s",
            past : "yan %s",
            s : "imik",
            m : "minuḍ",
            mm : "%d minuḍ",
            h : "saɛa",
            hh : "%d tassaɛin",
            d : "ass",
            dd : "%d ossan",
            M : "ayowr",
            MM : "%d iyyirn",
            y : "asgas",
            yy : "%d isgasn"
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : Morocco Central Atlas Tamaziɣt (tzm)
// author : Abdel Said : https://github.com/abdelsaid

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('tzm', {
        months : "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        monthsShort : "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        weekdays : "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        weekdaysShort : "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        weekdaysMin : "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
            sameDay: "[ⴰⵙⴷⵅ ⴴ] LT",
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",
            past : "ⵢⴰⵏ %s",
            s : "ⵉⵎⵉⴽ",
            m : "ⵎⵉⵏⵓⴺ",
            mm : "%d ⵎⵉⵏⵓⴺ",
            h : "ⵙⴰⵄⴰ",
            hh : "%d ⵜⴰⵙⵙⴰⵄⵉⵏ",
            d : "ⴰⵙⵙ",
            dd : "%d oⵙⵙⴰⵏ",
            M : "ⴰⵢoⵓⵔ",
            MM : "%d ⵉⵢⵢⵉⵔⵏ",
            y : "ⴰⵙⴳⴰⵙ",
            yy : "%d ⵉⵙⴳⴰⵙⵏ"
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : ukrainian (uk)
// author : zemlanin : https://github.com/zemlanin
// Author : Menelion Elensúle : https://github.com/Oire

(function (factory) {
    factory(moment);
}(function (moment) {
    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'mm': 'хвилина_хвилини_хвилин',
            'hh': 'година_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    function monthsCaseReplace(m, format) {
        var months = {
            'nominative': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_'),
            'accusative': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_')
        },

        nounCase = (/D[oD]? *MMMM?/).test(format) ?
            'accusative' :
            'nominative';

        return months[nounCase][m.month()];
    }

    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        },

        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');

        return weekdays[nounCase][m.day()];
    }

    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    return moment.lang('uk', {
        months : monthsCaseReplace,
        monthsShort : "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : "нд_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin : "нд_пн_вт_ср_чт_пт_сб".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD.MM.YYYY",
            LL : "D MMMM YYYY р.",
            LLL : "D MMMM YYYY р., LT",
            LLLL : "dddd, D MMMM YYYY р., LT"
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : "за %s",
            past : "%s тому",
            s : "декілька секунд",
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : "годину",
            hh : relativeTimeWithPlural,
            d : "день",
            dd : relativeTimeWithPlural,
            M : "місяць",
            MM : relativeTimeWithPlural,
            y : "рік",
            yy : relativeTimeWithPlural
        },

        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason

        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return "ночі";
            } else if (hour < 12) {
                return "ранку";
            } else if (hour < 17) {
                return "дня";
            } else {
                return "вечора";
            }
        },

        ordinal: function (number, period) {
            switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
            }
        },

        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : uzbek
// author : Sardor Muminov : https://github.com/muminoff

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('uz', {
        months : "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
        monthsShort : "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
        weekdays : "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
        weekdaysShort : "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
        weekdaysMin : "Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM YYYY",
            LLL : "D MMMM YYYY LT",
            LLLL : "D MMMM YYYY, dddd LT"
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : "Якин %s ичида",
            past : "Бир неча %s олдин",
            s : "фурсат",
            m : "бир дакика",
            mm : "%d дакика",
            h : "бир соат",
            hh : "%d соат",
            d : "бир кун",
            dd : "%d кун",
            M : "бир ой",
            MM : "%d ой",
            y : "бир йил",
            yy : "%d йил"
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : vietnamese (vi)
// author : Bang Nguyen : https://github.com/bangnk

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('vi', {
        months : "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),
        monthsShort : "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),
        weekdays : "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),
        weekdaysShort : "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysMin : "CN_T2_T3_T4_T5_T6_T7".split("_"),
        longDateFormat : {
            LT : "HH:mm",
            L : "DD/MM/YYYY",
            LL : "D MMMM [năm] YYYY",
            LLL : "D MMMM [năm] YYYY LT",
            LLLL : "dddd, D MMMM [năm] YYYY LT",
            l : "DD/M/YYYY",
            ll : "D MMM YYYY",
            lll : "D MMM YYYY LT",
            llll : "ddd, D MMM YYYY LT"
        },
        calendar : {
            sameDay: "[Hôm nay lúc] LT",
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : "%s tới",
            past : "%s trước",
            s : "vài giây",
            m : "một phút",
            mm : "%d phút",
            h : "một giờ",
            hh : "%d giờ",
            d : "một ngày",
            dd : "%d ngày",
            M : "một tháng",
            MM : "%d tháng",
            y : "một năm",
            yy : "%d năm"
        },
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : chinese
// author : suupic : https://github.com/suupic
// author : Zeno Zeng : https://github.com/zenozeng

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('zh-cn', {
        months : "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort : "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays : "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort : "周日_周一_周二_周三_周四_周五_周六".split("_"),
        weekdaysMin : "日_一_二_三_四_五_六".split("_"),
        longDateFormat : {
            LT : "Ah点mm",
            L : "YYYY-MM-DD",
            LL : "YYYY年MMMD日",
            LLL : "YYYY年MMMD日LT",
            LLLL : "YYYY年MMMD日ddddLT",
            l : "YYYY-MM-DD",
            ll : "YYYY年MMMD日",
            lll : "YYYY年MMMD日LT",
            llll : "YYYY年MMMD日ddddLT"
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return "凌晨";
            } else if (hm < 900) {
                return "早上";
            } else if (hm < 1130) {
                return "上午";
            } else if (hm < 1230) {
                return "中午";
            } else if (hm < 1800) {
                return "下午";
            } else {
                return "晚上";
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? "[今天]Ah[点整]" : "[今天]LT";
            },
            nextDay : function () {
                return this.minutes() === 0 ? "[明天]Ah[点整]" : "[明天]LT";
            },
            lastDay : function () {
                return this.minutes() === 0 ? "[昨天]Ah[点整]" : "[昨天]LT";
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
            },
            sameElse : 'LL'
        },
        ordinal : function (number, period) {
            switch (period) {
            case "d":
            case "D":
            case "DDD":
                return number + "日";
            case "M":
                return number + "月";
            case "w":
            case "W":
                return number + "周";
            default:
                return number;
            }
        },
        relativeTime : {
            future : "%s内",
            past : "%s前",
            s : "几秒",
            m : "1分钟",
            mm : "%d分钟",
            h : "1小时",
            hh : "%d小时",
            d : "1天",
            dd : "%d天",
            M : "1个月",
            MM : "%d个月",
            y : "1年",
            yy : "%d年"
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));
// moment.js language configuration
// language : traditional chinese (zh-tw)
// author : Ben : https://github.com/ben-lin

(function (factory) {
    factory(moment);
}(function (moment) {
    return moment.lang('zh-tw', {
        months : "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort : "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays : "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort : "週日_週一_週二_週三_週四_週五_週六".split("_"),
        weekdaysMin : "日_一_二_三_四_五_六".split("_"),
        longDateFormat : {
            LT : "Ah點mm",
            L : "YYYY年MMMD日",
            LL : "YYYY年MMMD日",
            LLL : "YYYY年MMMD日LT",
            LLLL : "YYYY年MMMD日ddddLT",
            l : "YYYY年MMMD日",
            ll : "YYYY年MMMD日",
            lll : "YYYY年MMMD日LT",
            llll : "YYYY年MMMD日ddddLT"
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 900) {
                return "早上";
            } else if (hm < 1130) {
                return "上午";
            } else if (hm < 1230) {
                return "中午";
            } else if (hm < 1800) {
                return "下午";
            } else {
                return "晚上";
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        ordinal : function (number, period) {
            switch (period) {
            case "d" :
            case "D" :
            case "DDD" :
                return number + "日";
            case "M" :
                return number + "月";
            case "w" :
            case "W" :
                return number + "週";
            default :
                return number;
            }
        },
        relativeTime : {
            future : "%s內",
            past : "%s前",
            s : "幾秒",
            m : "一分鐘",
            mm : "%d分鐘",
            h : "一小時",
            hh : "%d小時",
            d : "一天",
            dd : "%d天",
            M : "一個月",
            MM : "%d個月",
            y : "一年",
            yy : "%d年"
        }
    });
}));

    moment.lang('en');


    /************************************
        Exposing Moment
    ************************************/

    function makeGlobal(shouldDeprecate) {
        /*global ender:false */
        if (typeof ender !== 'undefined') {
            return;
        }
        oldGlobalMoment = globalScope.moment;
        if (shouldDeprecate) {
            globalScope.moment = deprecate(
                    "Accessing Moment through the global scope is " +
                    "deprecated, and will be removed in an upcoming " +
                    "release.",
                    moment);
        } else {
            globalScope.moment = moment;
        }
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = moment;
    } else if (typeof define === "function" && define.amd) {
        define("moment", ['require','exports','module'],function (require, exports, module) {
            if (module.config && module.config() && module.config().noGlobal === true) {
                // release the global variable
                globalScope.moment = oldGlobalMoment;
            }

            return moment;
        });
        makeGlobal(true);
    } else {
        makeGlobal();
    }
}).call(this);

// Generated by CoffeeScript 1.6.2
(function() {
  var hasModule, makeTwix,
    __slice = [].slice;

  hasModule = (typeof module !== "undefined" && module !== null) && (module.exports != null);

  makeTwix = function(moment) {
    var Twix, getPrototypeOf, languagesLoaded;

    if (moment == null) {
      throw "Can't find moment";
    }
    languagesLoaded = false;
    Twix = (function() {
      function Twix(start, end, allDay) {
        this.start = moment(start);
        this.end = moment(end);
        this.allDay = allDay || false;
      }

      Twix._extend = function() {
        var attr, first, other, others, _i, _len;

        first = arguments[0], others = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
        for (_i = 0, _len = others.length; _i < _len; _i++) {
          other = others[_i];
          for (attr in other) {
            if (typeof other[attr] !== "undefined") {
              first[attr] = other[attr];
            }
          }
        }
        return first;
      };

      Twix.defaults = {
        twentyFourHour: false,
        allDaySimple: {
          fn: function(options) {
            return function() {
              return options.allDay;
            };
          },
          slot: 0,
          pre: " "
        },
        dayOfWeek: {
          fn: function(options) {
            return function(date) {
              return date.format(options.weekdayFormat);
            };
          },
          slot: 1,
          pre: " "
        },
        allDayMonth: {
          fn: function(options) {
            return function(date) {
              return date.format("" + options.monthFormat + " " + options.dayFormat);
            };
          },
          slot: 2,
          pre: " "
        },
        month: {
          fn: function(options) {
            return function(date) {
              return date.format(options.monthFormat);
            };
          },
          slot: 2,
          pre: " "
        },
        date: {
          fn: function(options) {
            return function(date) {
              return date.format(options.dayFormat);
            };
          },
          slot: 3,
          pre: " "
        },
        year: {
          fn: function(options) {
            return function(date) {
              return date.format(options.yearFormat);
            };
          },
          slot: 4,
          pre: ", "
        },
        time: {
          fn: function(options) {
            return function(date) {
              var str;

              str = date.minutes() === 0 && options.implicitMinutes && !options.twentyFourHour ? date.format(options.hourFormat) : date.format("" + options.hourFormat + ":" + options.minuteFormat);
              if (!options.groupMeridiems && !options.twentyFourHour) {
                if (options.spaceBeforeMeridiem) {
                  str += " ";
                }
                str += date.format(options.meridiemFormat);
              }
              return str;
            };
          },
          slot: 5,
          pre: ", "
        },
        meridiem: {
          fn: function(options) {
            var _this = this;

            return function(t) {
              return t.format(options.meridiemFormat);
            };
          },
          slot: 6,
          pre: function(options) {
            if (options.spaceBeforeMeridiem) {
              return " ";
            } else {
              return "";
            }
          }
        }
      };

      Twix.registerLang = function(name, options) {
        return moment.lang(name, {
          twix: Twix._extend({}, Twix.defaults, options)
        });
      };

      Twix.prototype.isSame = function(period) {
        return this.start.isSame(this.end, period);
      };

      Twix.prototype.length = function(period) {
        return this._trueEnd().add(1, "millisecond").diff(this._trueStart(), period);
      };

      Twix.prototype.count = function(period) {
        var end, start;

        start = this.start.clone().startOf(period);
        end = this.end.clone().startOf(period);
        return end.diff(start, period) + 1;
      };

      Twix.prototype.countInner = function(period) {
        var end, start, _ref;

        _ref = this._inner(period), start = _ref[0], end = _ref[1];
        if (start >= end) {
          return 0;
        }
        return end.diff(start, period);
      };

      Twix.prototype.iterate = function(intervalAmount, period, minHours) {
        var end, hasNext, start, _ref,
          _this = this;

        if (intervalAmount == null) {
          intervalAmount = 1;
        }
        _ref = this._prepIterateInputs(intervalAmount, period, minHours), intervalAmount = _ref[0], period = _ref[1], minHours = _ref[2];
        start = this.start.clone().startOf(period);
        end = this.end.clone().startOf(period);
        hasNext = function() {
          return start <= end && (!minHours || start.valueOf() !== end.valueOf() || _this.end.hours() > minHours || _this.allDay);
        };
        return this._iterateHelper(period, start, hasNext, intervalAmount);
      };

      Twix.prototype.iterateInner = function(intervalAmount, period) {
        var end, hasNext, start, _ref, _ref1;

        if (intervalAmount == null) {
          intervalAmount = 1;
        }
        _ref = this._prepIterateInputs(intervalAmount, period), intervalAmount = _ref[0], period = _ref[1];
        _ref1 = this._inner(period, intervalAmount), start = _ref1[0], end = _ref1[1];
        hasNext = function() {
          return start < end;
        };
        return this._iterateHelper(period, start, hasNext, intervalAmount);
      };

      Twix.prototype.humanizeLength = function() {
        if (this.allDay) {
          if (this.isSame("day")) {
            return "all day";
          } else {
            return this.start.from(this.end.clone().add(1, "day"), true);
          }
        } else {
          return this.start.from(this.end, true);
        }
      };

      Twix.prototype.asDuration = function(units) {
        var diff;

        diff = this.end.diff(this.start);
        return moment.duration(diff);
      };

      Twix.prototype.isPast = function() {
        if (this.allDay) {
          return this.end.clone().endOf("day") < moment();
        } else {
          return this.end < moment();
        }
      };

      Twix.prototype.isFuture = function() {
        if (this.allDay) {
          return this.start.clone().startOf("day") > moment();
        } else {
          return this.start > moment();
        }
      };

      Twix.prototype.isCurrent = function() {
        return !this.isPast() && !this.isFuture();
      };

      Twix.prototype.contains = function(mom) {
        mom = moment(mom);
        return this._trueStart() <= mom && this._trueEnd() >= mom;
      };

      Twix.prototype.overlaps = function(other) {
        return this._trueEnd().isAfter(other._trueStart()) && this._trueStart().isBefore(other._trueEnd());
      };

      Twix.prototype.engulfs = function(other) {
        return this._trueStart() <= other._trueStart() && this._trueEnd() >= other._trueEnd();
      };

      Twix.prototype.union = function(other) {
        var allDay, newEnd, newStart;

        allDay = this.allDay && other.allDay;
        if (allDay) {
          newStart = this.start < other.start ? this.start : other.start;
          newEnd = this.end > other.end ? this.end : other.end;
        } else {
          newStart = this._trueStart() < other._trueStart() ? this._trueStart() : other._trueStart();
          newEnd = this._trueEnd() > other._trueEnd() ? this._trueEnd() : other._trueEnd();
        }
        return new Twix(newStart, newEnd, allDay);
      };

      Twix.prototype.intersection = function(other) {
        var allDay, end, newEnd, newStart;

        newStart = this.start > other.start ? this.start : other.start;
        if (this.allDay) {
          end = moment(this.end);
          end.add(1, "day");
          end.subtract(1, "millisecond");
          if (other.allDay) {
            newEnd = end < other.end ? this.end : other.end;
          } else {
            newEnd = end < other.end ? end : other.end;
          }
        } else {
          newEnd = this.end < other.end ? this.end : other.end;
        }
        allDay = this.allDay && other.allDay;
        return new Twix(newStart, newEnd, allDay);
      };

      Twix.prototype.isValid = function() {
        return this._trueStart() <= this._trueEnd();
      };

      Twix.prototype.equals = function(other) {
        return (other instanceof Twix) && this.allDay === other.allDay && this.start.valueOf() === other.start.valueOf() && this.end.valueOf() === other.end.valueOf();
      };

      Twix.prototype.toString = function() {
        var _ref;

        return "{start: " + (this.start.format()) + ", end: " + (this.end.format()) + ", allDay: " + ((_ref = this.allDay) != null ? _ref : {
          "true": "false"
        }) + "}";
      };

      Twix.prototype.simpleFormat = function(momentOpts, inopts) {
        var options, s;

        options = {
          allDay: "(all day)"
        };
        Twix._extend(options, inopts || {});
        s = "" + (this.start.format(momentOpts)) + " - " + (this.end.format(momentOpts));
        if (this.allDay && options.allDay) {
          s += " " + options.allDay;
        }
        return s;
      };

      Twix.prototype.format = function(inopts) {
        var common_bucket, end_bucket, fold, format, fs, global_first, goesIntoTheMorning, needDate, options, process, start_bucket, together, _i, _len,
          _this = this;

        this._lazyLang();
        options = {
          groupMeridiems: true,
          spaceBeforeMeridiem: true,
          showDate: true,
          showDayOfWeek: false,
          twentyFourHour: this.langData.twentyFourHour,
          implicitMinutes: true,
          implicitYear: true,
          yearFormat: "YYYY",
          monthFormat: "MMM",
          weekdayFormat: "ddd",
          dayFormat: "D",
          meridiemFormat: "A",
          hourFormat: "h",
          minuteFormat: "mm",
          allDay: "all day",
          explicitAllDay: false,
          lastNightEndsAt: 0
        };
        Twix._extend(options, inopts || {});
        fs = [];
        if (options.twentyFourHour) {
          options.hourFormat = options.hourFormat.replace("h", "H");
        }
        goesIntoTheMorning = options.lastNightEndsAt > 0 && !this.allDay && this.end.clone().startOf("day").valueOf() === this.start.clone().add(1, "day").startOf("day").valueOf() && this.start.hours() > 12 && this.end.hours() < options.lastNightEndsAt;
        needDate = options.showDate || (!this.isSame("day") && !goesIntoTheMorning);
        if (this.allDay && this.isSame("day") && (!options.showDate || options.explicitAllDay)) {
          fs.push({
            name: "all day simple",
            fn: this._formatFn('allDaySimple', options),
            pre: this._formatPre('allDaySimple', options),
            slot: this._formatSlot('allDaySimple')
          });
        }
        if (needDate && (!options.implicitYear || this.start.year() !== moment().year() || !this.isSame("year"))) {
          fs.push({
            name: "year",
            fn: this._formatFn('year', options),
            pre: this._formatPre('year', options),
            slot: this._formatSlot('year')
          });
        }
        if (!this.allDay && needDate) {
          fs.push({
            name: "all day month",
            fn: this._formatFn('allDayMonth', options),
            ignoreEnd: function() {
              return goesIntoTheMorning;
            },
            pre: this._formatPre('allDayMonth', options),
            slot: this._formatSlot('allDayMonth')
          });
        }
        if (this.allDay && needDate) {
          fs.push({
            name: "month",
            fn: this._formatFn('month', options),
            pre: this._formatPre('month', options),
            slot: this._formatSlot('month')
          });
        }
        if (this.allDay && needDate) {
          fs.push({
            name: "date",
            fn: this._formatFn('date', options),
            pre: this._formatPre('date', options),
            slot: this._formatSlot('date')
          });
        }
        if (needDate && options.showDayOfWeek) {
          fs.push({
            name: "day of week",
            fn: this._formatFn('dayOfWeek', options),
            pre: this._formatPre('dayOfWeek', options),
            slot: this._formatSlot('dayOfWeek')
          });
        }
        if (options.groupMeridiems && !options.twentyFourHour && !this.allDay) {
          fs.push({
            name: "meridiem",
            fn: this._formatFn('meridiem', options),
            pre: this._formatPre('meridiem', options),
            slot: this._formatSlot('meridiem')
          });
        }
        if (!this.allDay) {
          fs.push({
            name: "time",
            fn: this._formatFn('time', options),
            pre: this._formatPre('time', options),
            slot: this._formatSlot('time')
          });
        }
        start_bucket = [];
        end_bucket = [];
        common_bucket = [];
        together = true;
        process = function(format) {
          var end_str, start_group, start_str;

          start_str = format.fn(_this.start);
          end_str = format.ignoreEnd && format.ignoreEnd() ? start_str : format.fn(_this.end);
          start_group = {
            format: format,
            value: function() {
              return start_str;
            }
          };
          if (end_str === start_str && together) {
            return common_bucket.push(start_group);
          } else {
            if (together) {
              together = false;
              common_bucket.push({
                format: {
                  slot: format.slot,
                  pre: ""
                },
                value: function() {
                  return "" + (fold(start_bucket)) + " -" + (fold(end_bucket, true));
                }
              });
            }
            start_bucket.push(start_group);
            return end_bucket.push({
              format: format,
              value: function() {
                return end_str;
              }
            });
          }
        };
        for (_i = 0, _len = fs.length; _i < _len; _i++) {
          format = fs[_i];
          process(format);
        }
        global_first = true;
        fold = function(array, skip_pre) {
          var local_first, section, str, _j, _len1, _ref;

          local_first = true;
          str = "";
          _ref = array.sort(function(a, b) {
            return a.format.slot - b.format.slot;
          });
          for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
            section = _ref[_j];
            if (!global_first) {
              if (local_first && skip_pre) {
                str += " ";
              } else {
                str += section.format.pre;
              }
            }
            str += section.value();
            global_first = false;
            local_first = false;
          }
          return str;
        };
        return fold(common_bucket);
      };

      Twix.prototype._trueStart = function() {
        if (this.allDay) {
          return this.start.clone().startOf("day");
        } else {
          return this.start.clone();
        }
      };

      Twix.prototype._trueEnd = function(diffableEnd) {
        if (diffableEnd == null) {
          diffableEnd = false;
        }
        if (this.allDay) {
          if (diffableEnd) {
            return this.end.clone().add(1, "day");
          } else {
            return this.end.clone().endOf("day");
          }
        } else {
          return this.end.clone();
        }
      };

      Twix.prototype._iterateHelper = function(period, iter, hasNext, intervalAmount) {
        var _this = this;

        if (intervalAmount == null) {
          intervalAmount = 1;
        }
        return {
          next: function() {
            var val;

            if (!hasNext()) {
              return null;
            } else {
              val = iter.clone();
              iter.add(intervalAmount, period);
              return val;
            }
          },
          hasNext: hasNext
        };
      };

      Twix.prototype._prepIterateInputs = function() {
        var inputs, intervalAmount, minHours, period, _ref, _ref1;

        inputs = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
        if (typeof inputs[0] === 'number') {
          return inputs;
        }
        if (typeof inputs[0] === 'string') {
          period = inputs.shift();
          intervalAmount = (_ref = inputs.pop()) != null ? _ref : 1;
          if (inputs.length) {
            minHours = (_ref1 = inputs[0]) != null ? _ref1 : false;
          }
        }
        if (moment.isDuration(inputs[0])) {
          period = 'milliseconds';
          intervalAmount = inputs[0].as(period);
        }
        return [intervalAmount, period, minHours];
      };

      Twix.prototype._inner = function(period, intervalAmount) {
        var durationCount, durationPeriod, end, modulus, start;

        if (period == null) {
          period = "milliseconds";
        }
        if (intervalAmount == null) {
          intervalAmount = 1;
        }
        start = this._trueStart();
        end = this._trueEnd(true);
        if (start > start.clone().startOf(period)) {
          start.startOf(period).add(intervalAmount, period);
        }
        if (end < end.clone().endOf(period)) {
          end.startOf(period);
        }
        durationPeriod = start.twix(end).asDuration(period);
        durationCount = durationPeriod.get(period);
        modulus = durationCount % intervalAmount;
        end.subtract(modulus, period);
        return [start, end];
      };

      Twix.prototype._lazyLang = function() {
        var e, langData, languages, _ref;

        langData = this.start.lang();
        if ((langData != null) && this.end.lang()._abbr !== langData._abbr) {
          this.end.lang(langData._abbr);
        }
        if ((this.langData != null) && this.langData._abbr === langData._abbr) {
          return;
        }
        if (hasModule && !(languagesLoaded || langData._abbr === "en")) {
          try {
            languages = require("./lang");
            languages(moment, Twix);
          } catch (_error) {
            e = _error;
          }
          languagesLoaded = true;
        }
        return this.langData = (_ref = langData != null ? langData._twix : void 0) != null ? _ref : Twix.defaults;
      };

      Twix.prototype._formatFn = function(name, options) {
        return this.langData[name].fn(options);
      };

      Twix.prototype._formatSlot = function(name) {
        return this.langData[name].slot;
      };

      Twix.prototype._formatPre = function(name, options) {
        if (typeof this.langData[name].pre === "function") {
          return this.langData[name].pre(options);
        } else {
          return this.langData[name].pre;
        }
      };

      Twix.prototype._deprecate = function(name, instead, fn) {
        if ((typeof console !== "undefined" && console !== null) && (console.warn != null)) {
          console.warn("#" + name + " is deprecated. Use #" + instead + " instead.");
        }
        return fn.apply(this);
      };

      Twix.prototype.sameDay = function() {
        return this._deprecate("sameDay", "isSame('day')", function() {
          return this.isSame("day");
        });
      };

      Twix.prototype.sameYear = function() {
        return this._deprecate("sameYear", "isSame('year')", function() {
          return this.isSame("year");
        });
      };

      Twix.prototype.countDays = function() {
        return this._deprecate("countDays", "countOuter('days')", function() {
          return this.countOuter("days");
        });
      };

      Twix.prototype.daysIn = function(minHours) {
        return this._deprecate("daysIn", "iterate('days' [,minHours])", function() {
          return this.iterate('days', minHours);
        });
      };

      Twix.prototype.past = function() {
        return this._deprecate("past", "isPast()", function() {
          return this.isPast();
        });
      };

      Twix.prototype.duration = function() {
        return this._deprecate("duration", "humanizeLength()", function() {
          return this.humanizeLength();
        });
      };

      Twix.prototype.merge = function(other) {
        return this._deprecate("merge", "union(other)", function() {
          return this.union(other);
        });
      };

      return Twix;

    })();
    getPrototypeOf = function(o) {
      if (typeof Object.getPrototypeOf === "function") {
        return Object.getPrototypeOf(o);
      } else if ("".__proto__ === String.prototype) {
        return o.__proto__;
      } else {
        return o.constructor.prototype;
      }
    };
    Twix._extend(getPrototypeOf(moment.fn._lang), {
      _twix: Twix.defaults
    });
    moment.twix = function() {
      return (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(Twix, arguments, function(){});
    };
    moment.fn.twix = function() {
      return (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(Twix, [this].concat(__slice.call(arguments)), function(){});
    };
    moment.fn.forDuration = function(duration, allDay) {
      return new Twix(this, this.clone().add(duration), allDay);
    };
    moment.duration.fn.afterMoment = function(startingTime, allDay) {
      return new Twix(startingTime, moment(startingTime).clone().add(this), allDay);
    };
    moment.duration.fn.beforeMoment = function(startingTime, allDay) {
      return new Twix(moment(startingTime).clone().subtract(this), startingTime, allDay);
    };
    return Twix;
  };

  if (hasModule) {
    module.exports = makeTwix(require("moment"));
  }

  if (typeof define === "function") {
    define("twix", ["moment"], function(moment) {
      return makeTwix(moment);
    });
  }

  if (this.moment != null) {
    this.Twix = makeTwix(this.moment);
  }

}).call(this);

/*! iFrame Resizer (iframeSizer.min.js ) - v2.8.7 - 2015-05-19
 *  Desc: Force cross domain iframes to size to content.
 *  Requires: iframeResizer.contentWindow.min.js to be loaded into the target frame.
 *  Copyright: (c) 2015 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */

!function(){"use strict";function a(a,b,c){"addEventListener"in window?a.addEventListener(b,c,!1):"attachEvent"in window&&a.attachEvent("on"+b,c)}function b(){var a,b=["moz","webkit","o","ms"];for(a=0;a<b.length&&!A;a+=1)A=window[b[a]+"RequestAnimationFrame"];A||e(" RequestAnimationFrame not supported")}function c(){var a="Host page";return window.top!==window.self&&(a=window.parentIFrame?window.parentIFrame.getId():"Nested host page"),a}function d(a){return x+"["+c()+"]"+a}function e(a){u&&"object"==typeof window.console&&console.log(d(a))}function f(a){"object"==typeof window.console&&console.warn(d(a))}function g(a){function b(){function a(){k(G),i(),C[H].resizedCallback(G)}g("Height"),g("Width"),l(a,G,"resetPage")}function c(a){var b=a.id;e(" Removing iFrame: "+b),a.parentNode.removeChild(a),C[b].closedCallback(b),delete C[b],e(" --")}function d(){var a=F.substr(y).split(":");return{iframe:document.getElementById(a[0]),id:a[0],height:a[1],width:a[2],type:a[3]}}function g(a){var b=Number(C[H]["max"+a]),c=Number(C[H]["min"+a]),d=a.toLowerCase(),f=Number(G[d]);if(c>b)throw new Error("Value for min"+a+" can not be greater than max"+a);e(" Checking "+d+" is in range "+c+"-"+b),c>f&&(f=c,e(" Set "+d+" to min value")),f>b&&(f=b,e(" Set "+d+" to max value")),G[d]=""+f}function m(){function b(){function a(){e(" Checking connection is from allowed list of origins: "+d);var a;for(a=0;a<d.length;a++)if(d[a]===c)return!0;return!1}function b(){return e(" Checking connection is from: "+f),c==f}return d.constructor===Array?a():b()}var c=a.origin,d=C[H].checkOrigin,f=G.iframe.src.split("/").slice(0,3).join("/");if(d&&""+c!="null"&&!b())throw new Error("Unexpected message received from: "+c+" for "+G.iframe.id+". Message was: "+a.data+". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.");return!0}function n(){return x===(""+F).substr(0,y)}function o(){var a=G.type in{"true":1,"false":1,undefined:1};return a&&e(" Ignoring init message from meta parent page"),a}function p(a){return F.substr(F.indexOf(":")+w+a)}function q(a){e(" MessageCallback passed: {iframe: "+G.iframe.id+", message: "+a+"}"),C[H].messageCallback({iframe:G.iframe,message:JSON.parse(a)}),e(" --")}function r(){return null===G.iframe?(f(" IFrame ("+G.id+") not found"),!1):!0}function s(a){var b=a.getBoundingClientRect();return h(),{x:parseInt(b.left,10)+parseInt(z.x,10),y:parseInt(b.top,10)+parseInt(z.y,10)}}function v(a){function b(){z=g,A(),e(" --")}function c(){return{x:Number(G.width)+d.x,y:Number(G.height)+d.y}}var d=a?s(G.iframe):{x:0,y:0},g=c();e(" Reposition requested from iFrame (offset x:"+d.x+" y:"+d.y+")"),window.top!==window.self?window.parentIFrame?a?parentIFrame.scrollToOffset(g.x,g.y):parentIFrame.scrollTo(G.width,G.height):f(" Unable to scroll to requested position, window.parentIFrame not found"):b()}function A(){!1!==C[H].scrollCallback(z)&&i()}function B(a){function b(a){var b=s(a);e(" Moving to in page link (#"+c+") at x: "+b.x+" y: "+b.y),z={x:b.x,y:b.y},A(),e(" --")}var c=a.split("#")[1]||"",d=decodeURIComponent(c),f=document.getElementById(d)||document.getElementsByName(d)[0];window.top!==window.self?window.parentIFrame?parentIFrame.moveToAnchor(c):e(" In page link #"+c+" not found and window.parentIFrame not found"):f?b(f):e(" In page link #"+c+" not found")}function D(){switch(G.type){case"close":c(G.iframe);break;case"message":q(p(6));break;case"scrollTo":v(!1);break;case"scrollToOffset":v(!0);break;case"inPageLink":B(p(9));break;case"reset":j(G);break;case"init":b(),C[H].initCallback(G.iframe);break;default:b()}}function E(a){var b=!0;return C[a]||(b=!1,f(G.type+" No settings for "+a+". Message was: "+F)),b}var F=a.data,G={},H=null;n()&&(G=d(),H=G.id,!o()&&E(H)&&(u=C[H].log,e(" Received: "+F),r()&&m()&&(D(),t=!1)))}function h(){null===z&&(z={x:void 0!==window.pageXOffset?window.pageXOffset:document.documentElement.scrollLeft,y:void 0!==window.pageYOffset?window.pageYOffset:document.documentElement.scrollTop},e(" Get page position: "+z.x+","+z.y))}function i(){null!==z&&(window.scrollTo(z.x,z.y),e(" Set page position: "+z.x+","+z.y),z=null)}function j(a){function b(){k(a),m("reset","reset",a.iframe,a.id)}e(" Size reset requested by "+("init"===a.type?"host page":"iFrame")),h(),l(b,a,"init")}function k(a){function b(b){a.iframe.style[b]=a[b]+"px",e(" IFrame ("+c+") "+b+" set to "+a[b]+"px")}var c=a.iframe.id;C[c].sizeHeight&&b("height"),C[c].sizeWidth&&b("width")}function l(a,b,c){c!==b.type&&A?(e(" Requesting animation frame"),A(a)):a()}function m(a,b,c,d){c&&c.contentWindow?(e("["+a+"] Sending msg to iframe ("+b+")"),c.contentWindow.postMessage(x+b,"*")):(f("["+a+"] IFrame not found"),C[d]&&delete C[d])}function n(b){function c(){function a(a){1/0!==C[o][a]&&0!==C[o][a]&&(n.style[a]=C[o][a]+"px",e(" Set "+a+" = "+C[o][a]+"px"))}a("maxHeight"),a("minHeight"),a("maxWidth"),a("minWidth")}function d(a){return""===a&&(n.id=a="iFrameResizer"+s++,u=(b||{}).log,e(" Added missing iframe ID: "+a+" ("+n.src+")")),a}function f(){e(" IFrame scrolling "+(C[o].scrolling?"enabled":"disabled")+" for "+o),n.style.overflow=!1===C[o].scrolling?"hidden":"auto",n.scrolling=!1===C[o].scrolling?"no":"yes"}function g(){("number"==typeof C[o].bodyMargin||"0"===C[o].bodyMargin)&&(C[o].bodyMarginV1=C[o].bodyMargin,C[o].bodyMargin=""+C[o].bodyMargin+"px")}function h(){return o+":"+C[o].bodyMarginV1+":"+C[o].sizeWidth+":"+C[o].log+":"+C[o].interval+":"+C[o].enablePublicMethods+":"+C[o].autoResize+":"+C[o].bodyMargin+":"+C[o].heightCalculationMethod+":"+C[o].bodyBackground+":"+C[o].bodyPadding+":"+C[o].tolerance+":"+C[o].enableInPageLinks+":"+C[o].resizeFrom}function i(b){a(n,"load",function(){var a=t;m("iFrame.onload",b,n),!a&&C[o].heightCalculationMethod in B&&j({iframe:n,height:0,width:0,type:"init"})}),m("init",b,n)}function k(a){if("object"!=typeof a)throw new TypeError("Options is not an object.")}function l(a){a=a||{},C[o]={},k(a);for(var b in E)E.hasOwnProperty(b)&&(C[o][b]=a.hasOwnProperty(b)?a[b]:E[b]);u=C[o].log}var n=this,o=d(n.id);l(b),f(),c(),g(),i(h())}function o(a,b){null===D&&(D=setTimeout(function(){D=null,a()},b))}function p(){o(function(){for(var a in C)"parent"===C[a].resizeFrom&&m("Window resize","resize",document.getElementById(a),a)},66)}function q(){function c(a,b){if(!a.tagName)throw new TypeError("Object is not a valid DOM element");if("IFRAME"!==a.tagName.toUpperCase())throw new TypeError("Expected <IFRAME> tag, found <"+a.tagName+">.");n.call(a,b)}return b(),a(window,"message",g),a(window,"resize",p),function(a,b){switch(typeof b){case"undefined":case"string":Array.prototype.forEach.call(document.querySelectorAll(b||"iframe"),function(b){c(b,a)});break;case"object":c(b,a);break;default:throw new TypeError("Unexpected data type ("+typeof b+").")}}}function r(a){a.fn.iFrameResize=function(a){return this.filter("iframe").each(function(b,c){n.call(c,a)}).end()}}var s=0,t=!0,u=!1,v="message",w=v.length,x="[iFrameSizer]",y=x.length,z=null,A=window.requestAnimationFrame,B={max:1,scroll:1,bodyScroll:1,documentElementScroll:1},C={},D=null,E={autoResize:!0,bodyBackground:null,bodyMargin:null,bodyMarginV1:8,bodyPadding:null,checkOrigin:!0,enableInPageLinks:!1,enablePublicMethods:!1,heightCalculationMethod:"offset",interval:32,log:!1,maxHeight:1/0,maxWidth:1/0,minHeight:0,minWidth:0,resizeFrom:"parent",scrolling:!1,sizeHeight:!0,sizeWidth:!1,tolerance:0,closedCallback:function(){},initCallback:function(){},messageCallback:function(){},resizedCallback:function(){},scrollCallback:function(){return!0}};window.jQuery&&r(jQuery),"function"==typeof define&&define.amd?define('iframeResizer',[],q):"object"==typeof module&&"object"==typeof module.exports?module.exports=q():window.iFrameResize=window.iFrameResize||q()}();
//# sourceMappingURL=iframeResizer.map;
/*!
 * verge        viewport utilities module
 * @link        verge.airve.com
 * @license     MIT
 * @copyright   2012 Ryan Van Etten
 * @version     1.7.0
 */

/*jshint expr:true, laxcomma:true, sub:true, debug:true, eqnull:true, boss:true, node:true, evil:true,
  undef:true, unused:true, browser:true, devel:true, jquery:true, supernew:true, maxerr:100 */

(function(root, name, make) {
    if (typeof module != 'undefined' && module['exports']) module['exports'] = make();
    else root[name] = make();
}(this, 'verge', function() {

    var win = window
      , docElem = document.documentElement
      , Modernizr = win['Modernizr']
      , matchMedia = win['matchMedia'] || win['msMatchMedia']
      , mq = matchMedia ? function(q) {
            return !!matchMedia.call(win, q).matches;
        } : function() {
            return false;
        }
      , makeViewportGetter = function(dim, inner, client) {
            // @link  responsejs.com/labs/dimensions/
            // @link  quirksmode.org/mobile/viewports2.html
            // @link  github.com/ryanve/response.js/issues/17
            return docElem[client] < win[inner] && mq('(min-' + dim + ':' + win[inner] + 'px)') ? function() {
                return win[inner]; 
            } : function() {
                return docElem[client];
            };
        }
      , viewportW = makeViewportGetter('width', 'innerWidth', 'clientWidth')
      , viewportH = makeViewportGetter('height', 'innerHeight', 'clientHeight')
      , xports = {};
    
    /** 
     * Test if a media query is active. (Fallback uses Modernizr if avail.)
     * @since   1.6.0
     * @return  {boolean}
     */    
    xports['mq'] = !matchMedia && Modernizr && Modernizr['mq'] || mq;

    /** 
     * Normalized, gracefully-degrading matchMedia.
     * @since   1.6.0
     * @return  {Object}
     */ 
    xports['matchMedia'] = matchMedia ? function() {
        // matchMedia must be binded to window
        return matchMedia.apply(win, arguments);
    } : function() {
        return {};
    };

    /** 
     * Get the layout viewport width.
     * @since   1.0.0
     * @return  {number}
     */
    xports['viewportW'] = viewportW;

    /** 
     * Get the layout viewport height.
     * @since   1.0.0
     * @return  {number}
     */
    xports['viewportH'] = viewportH;
    
    /**
     * alternate syntax for getting viewport dims
     * @return {Object}
     */
    function viewport() {
        return {'width':viewportW(), 'height':viewportH()};
    }
    // May add this to future version
    //xports['viewport'] = viewport;
    
    /** 
     * Cross-browser window.scrollX
     * @since   1.0.0
     * @return  {number}
     */
    xports['scrollX'] = function() {
        return win.pageXOffset || docElem.scrollLeft; 
    };

    /** 
     * Cross-browser window.scrollY
     * @since   1.0.0
     * @return  {number}
     */
    xports['scrollY'] = function() {
        return win.pageYOffset || docElem.scrollTop; 
    };

    /** 
     * Cross-browser element.getBoundingClientRect plus optional cushion.
     * Coords are relative to the top-left corner of the viewport.
     * @since  1.0.0
     * @param  {Object|Array} el       DOM element or collection (defaults to first item)
     * @param  {number=}      cushion  +/- pixel amount to act as a cushion around the viewport
     * @return {Object|boolean}
     */
    function rectangle(el, cushion) {
        var o = {};
        el && !el.nodeType && (el = el[0]);
        if (!el || 1 !== el.nodeType) { return false; }
        cushion = typeof cushion == 'number' && cushion || 0;
        el = el.getBoundingClientRect(); // read-only
        o['width'] = (o['right'] = el['right'] + cushion) - (o['left'] = el['left'] - cushion);
        o['height'] = (o['bottom'] = el['bottom'] + cushion) - (o['top'] = el['top'] - cushion);
        return o;
    }
    xports['rectangle'] = rectangle;
    
    /**
     * Get the viewport aspect ratio (or the aspect ratio of an object or element)
     * @since  1.7.0
     * @param  {Object=}  o    optional object with width/height props or methods
     * @return {number}
     * @link   w3.org/TR/css3-mediaqueries/#orientation
     */
    function aspect(o) {
        o = o && 1 === o.nodeType ? rectangle(o) : o;
        var h = null == o ? viewportH : o['height']
          , w = null == o ? viewportW : o['width'];
        h = typeof h == 'function' ? h.call(o) : h;
        w = typeof w == 'function' ? w.call(o) : w;
        return w/h;
    }
    xports['aspect'] = aspect;

    /**
     * Test if an element is in the same x-axis section as the viewport.
     * @since   1.0.0
     * @param   {Object}   el
     * @param   {number=}  cushion
     * @return  {boolean}
     */
    xports['inX'] = function(el, cushion) {
        var r = rectangle(el, cushion);
        return !!r && r.right >= 0 && r.left <= viewportW();
    };

    /**
     * Test if an element is in the same y-axis section as the viewport.
     * @since   1.0.0
     * @param   {Object}   el
     * @param   {number=}  cushion
     * @return  {boolean}
     */
    xports['inY'] = function(el, cushion) {
        var r = rectangle(el, cushion);
        return !!r && r.bottom >= 0 && r.top <= viewportH();
    };

    /**
     * Test if an element is in the viewport.
     * @since   1.0.0
     * @param   {Object}   el
     * @param   {number=}  cushion
     * @return  {boolean}
     */
    xports['inViewport'] = function(el, cushion) {
        // Equiv to `inX(el, cushion) && inY(el, cushion)` but just manually do both 
        // to avoid calling rectangle() twice. It gzips just as small like this.
        var r = rectangle(el, cushion);
        return !!r && r.bottom >= 0 && r.right >= 0 && r.top <= viewportH() && r.left <= viewportW();
    };

    return xports;
}));
define("verge", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.verge;
    };
}(this)));


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('qTipCss.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*
 * qTip2 - Pretty powerful tooltips - v2.1.1
 * http://qtip2.com
 *
 * Copyright (c) 2013 Craig Michael Thompson
 * Released under the MIT, GPL licenses
 * http://jquery.org/license
 *
 * Date: Wed Sep 11 2013 11:17 GMT+0100+0100
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

/* Cache window, document, undefined */
(function( window, document, undefined ) {

// Uses AMD or browser globals to create a jQuery plugin.
(function( factory ) {
	"use strict";
	if(typeof define === 'function' && define.amd) {
		define('qTip',['jquery'], factory);
	}
	else if(jQuery && !jQuery.fn.qtip) {
		factory(jQuery);
	}
}
(function($) {
	"use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/

;// Munge the primitives - Paul Irish tip
var TRUE = true,
FALSE = false,
NULL = null,

// Common variables
X = 'x', Y = 'y',
WIDTH = 'width',
HEIGHT = 'height',

// Positioning sides
TOP = 'top',
LEFT = 'left',
BOTTOM = 'bottom',
RIGHT = 'right',
CENTER = 'center',

// Position adjustment types
FLIP = 'flip',
FLIPINVERT = 'flipinvert',
SHIFT = 'shift',

// Shortcut vars
QTIP, PROTOTYPE, CORNER, CHECKS,
PLUGINS = {},
NAMESPACE = 'qtip',
ATTR_HAS = 'data-hasqtip',
ATTR_ID = 'data-qtip-id',
WIDGET = ['ui-widget', 'ui-tooltip'],
SELECTOR = '.'+NAMESPACE,
INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),

CLASS_FIXED = NAMESPACE+'-fixed',
CLASS_DEFAULT = NAMESPACE + '-default',
CLASS_FOCUS = NAMESPACE + '-focus',
CLASS_HOVER = NAMESPACE + '-hover',
CLASS_DISABLED = NAMESPACE+'-disabled',

replaceSuffix = '_replacedByqTip',
oldtitle = 'oldtitle',
trackingBound,

// Browser detection
BROWSER = {
	/*
	 * IE version detection
	 *
	 * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
	 * Credit to James Padolsey for the original implemntation!
	 */
	ie: (function(){
		var v = 3, div = document.createElement('div');
		while ((div.innerHTML = '<!--[if gt IE '+(++v)+']><i></i><![endif]-->')) {
			if(!div.getElementsByTagName('i')[0]) { break; }
		}
		return v > 4 ? v : NaN;
	}()),
 
	/*
	 * iOS version detection
	 */
	iOS: parseFloat( 
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
		.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || FALSE
};

;function QTip(target, options, id, attr) {
	// Elements and ID
	this.id = id;
	this.target = target;
	this.tooltip = NULL;
	this.elements = { target: target };

	// Internal constructs
	this._id = NAMESPACE + '-' + id;
	this.timers = { img: {} };
	this.options = options;
	this.plugins = {};

	// Cache object
	this.cache = {
		event: {},
		target: $(),
		disabled: FALSE,
		attr: attr,
		onTooltip: FALSE,
		lastClass: ''
	};

	// Set the initial flags
	this.rendered = this.destroyed = this.disabled = this.waiting = 
		this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
}
PROTOTYPE = QTip.prototype;

PROTOTYPE.render = function(show) {
	if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit

	var self = this,
		options = this.options,
		cache = this.cache,
		elements = this.elements,
		text = options.content.text,
		title = options.content.title,
		button = options.content.button,
		posOptions = options.position,
		namespace = '.'+this._id+' ',
		deferreds = [],
		tooltip;

	// Add ARIA attributes to target
	$.attr(this.target[0], 'aria-describedby', this._id);

	// Create tooltip element
	this.tooltip = elements.tooltip = tooltip = $('<div/>', {
		'id': this._id,
		'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, NAMESPACE + '-pos-' + options.position.my.abbrev() ].join(' '),
		'width': options.style.width || '',
		'height': options.style.height || '',
		'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,

		/* ARIA specific attributes */
		'role': 'alert',
		'aria-live': 'polite',
		'aria-atomic': FALSE,
		'aria-describedby': this._id + '-content',
		'aria-hidden': TRUE
	})
	.toggleClass(CLASS_DISABLED, this.disabled)
	.attr(ATTR_ID, this.id)
	.data(NAMESPACE, this)
	.appendTo(posOptions.container)
	.append(
		// Create content element
		elements.content = $('<div />', {
			'class': NAMESPACE + '-content',
			'id': this._id + '-content',
			'aria-atomic': TRUE
		})
	);

	// Set rendered flag and prevent redundant reposition calls for now
	this.rendered = -1;
	this.positioning = TRUE;

	// Create title...
	if(title) {
		this._createTitle();

		// Update title only if its not a callback (called in toggle if so)
		if(!$.isFunction(title)) {
			deferreds.push( this._updateTitle(title, FALSE) );
		}
	}

	// Create button
	if(button) { this._createButton(); }

	// Set proper rendered flag and update content if not a callback function (called in toggle)
	if(!$.isFunction(text)) {
		deferreds.push( this._updateContent(text, FALSE) );
	}
	this.rendered = TRUE;

	// Setup widget classes
	this._setWidget();

	// Initialize 'render' plugins
	$.each(PLUGINS, function(name) {
		var instance;
		if(this.initialize === 'render' && (instance = this(self))) {
			self.plugins[name] = instance;
		}
	});

	// Unassign initial events and assign proper events
	this._unassignEvents();
	this._assignEvents();

	// When deferreds have completed
	$.when.apply($, deferreds).then(function() {
		// tooltiprender event
		self._trigger('render');

		// Reset flags
		self.positioning = FALSE;

		// Show tooltip if not hidden during wait period
		if(!self.hiddenDuringWait && (options.show.ready || show)) {
			self.toggle(TRUE, cache.event, FALSE);
		}
		self.hiddenDuringWait = FALSE;
	});

	// Expose API
	QTIP.api[this.id] = this;

	return this;
};

PROTOTYPE.destroy = function(immediate) {
	// Set flag the signify destroy is taking place to plugins
	// and ensure it only gets destroyed once!
	if(this.destroyed) { return this.target; }

	function process() {
		if(this.destroyed) { return; }
		this.destroyed = TRUE;
		
		var target = this.target,
			title = target.attr(oldtitle);

		// Destroy tooltip if rendered
		if(this.rendered) {
			this.tooltip.stop(1,0).find('*').remove().end().remove();
		}

		// Destroy all plugins
		$.each(this.plugins, function(name) {
			this.destroy && this.destroy();
		});

		// Clear timers and remove bound events
		clearTimeout(this.timers.show);
		clearTimeout(this.timers.hide);
		this._unassignEvents();

		// Remove api object and ARIA attributes
		target.removeData(NAMESPACE).removeAttr(ATTR_ID)
			.removeAttr('aria-describedby');

		// Reset old title attribute if removed
		if(this.options.suppress && title) {
			target.attr('title', title).removeAttr(oldtitle);
		}

		// Remove qTip events associated with this API
		this._unbind(target);

		// Remove ID from used id objects, and delete object references
		// for better garbage collection and leak protection
		this.options = this.elements = this.cache = this.timers = 
			this.plugins = this.mouse = NULL;

		// Delete epoxsed API object
		delete QTIP.api[this.id];
	}

	// If an immediate destory is needed
	if(immediate !== TRUE && this.rendered) {
		this.tooltip.one('tooltiphidden', $.proxy(process, this));
		!this.triggering && this.hide();
	}

	// If we're not in the process of hiding... process
	else { process.call(this); }

	return this.target;
};

;function invalidOpt(a) {
	return a === NULL || $.type(a) !== 'object';
}

function invalidContent(c) {
	return !( $.isFunction(c) || (c && c.attr) || c.length || ($.type(c) === 'object' && (c.jquery || c.then) ));
}

// Option object sanitizer
function sanitizeOptions(opts) {
	var content, text, ajax, once;

	if(invalidOpt(opts)) { return FALSE; }

	if(invalidOpt(opts.metadata)) {
		opts.metadata = { type: opts.metadata };
	}

	if('content' in opts) {
		content = opts.content;

		if(invalidOpt(content) || content.jquery || content.done) {
			content = opts.content = {
				text: (text = invalidContent(content) ? FALSE : content)
			};
		}
		else { text = content.text; }

		// DEPRECATED - Old content.ajax plugin functionality
		// Converts it into the proper Deferred syntax
		if('ajax' in content) {
			ajax = content.ajax;
			once = ajax && ajax.once !== FALSE;
			delete content.ajax;

			content.text = function(event, api) {
				var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',

				deferred = $.ajax(
					$.extend({}, ajax, { context: api })
				)
				.then(ajax.success, NULL, ajax.error)
				.then(function(content) {
					if(content && once) { api.set('content.text', content); }
					return content;
				},
				function(xhr, status, error) {
					if(api.destroyed || xhr.status === 0) { return; }
					api.set('content.text', status + ': ' + error);
				});

				return !once ? (api.set('content.text', loading), deferred) : loading;
			};
		}

		if('title' in content) {
			if(!invalidOpt(content.title)) {
				content.button = content.title.button;
				content.title = content.title.text;
			}

			if(invalidContent(content.title || FALSE)) {
				content.title = FALSE;
			}
		}
	}

	if('position' in opts && invalidOpt(opts.position)) {
		opts.position = { my: opts.position, at: opts.position };
	}

	if('show' in opts && invalidOpt(opts.show)) {
		opts.show = opts.show.jquery ? { target: opts.show } : 
			opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
	}

	if('hide' in opts && invalidOpt(opts.hide)) {
		opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
	}

	if('style' in opts && invalidOpt(opts.style)) {
		opts.style = { classes: opts.style };
	}

	// Sanitize plugin options
	$.each(PLUGINS, function() {
		this.sanitize && this.sanitize(opts);
	});

	return opts;
}

// Setup builtin .set() option checks
CHECKS = PROTOTYPE.checks = {
	builtin: {
		// Core checks
		'^id$': function(obj, o, v, prev) {
			var id = v === TRUE ? QTIP.nextid : v,
				new_id = NAMESPACE + '-' + id;

			if(id !== FALSE && id.length > 0 && !$('#'+new_id).length) {
				this._id = new_id;

				if(this.rendered) {
					this.tooltip[0].id = this._id;
					this.elements.content[0].id = this._id + '-content';
					this.elements.title[0].id = this._id + '-title';
				}
			}
			else { obj[o] = prev; }
		},
		'^prerender': function(obj, o, v) {
			v && !this.rendered && this.render(this.options.show.ready);
		},

		// Content checks
		'^content.text$': function(obj, o, v) {
			this._updateContent(v);
		},
		'^content.attr$': function(obj, o, v, prev) {
			if(this.options.content.text === this.target.attr(prev)) {
				this._updateContent( this.target.attr(v) );
			}
		},
		'^content.title$': function(obj, o, v) {
			// Remove title if content is null
			if(!v) { return this._removeTitle(); }

			// If title isn't already created, create it now and update
			v && !this.elements.title && this._createTitle();
			this._updateTitle(v);
		},
		'^content.button$': function(obj, o, v) {
			this._updateButton(v);
		},
		'^content.title.(text|button)$': function(obj, o, v) {
			this.set('content.'+o, v); // Backwards title.text/button compat
		}, 

		// Position checks
		'^position.(my|at)$': function(obj, o, v){
			'string' === typeof v && (obj[o] = new CORNER(v, o === 'at'));
		},
		'^position.container$': function(obj, o, v){
			this.rendered && this.tooltip.appendTo(v);
		},

		// Show checks
		'^show.ready$': function(obj, o, v) {
			v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
		},

		// Style checks
		'^style.classes$': function(obj, o, v, p) {
			this.rendered && this.tooltip.removeClass(p).addClass(v);
		},
		'^style.(width|height)': function(obj, o, v) {
			this.rendered && this.tooltip.css(o, v);
		},
		'^style.widget|content.title': function() {
			this.rendered && this._setWidget();
		},
		'^style.def': function(obj, o, v) {
			this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
		},

		// Events check
		'^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
			this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
		},

		// Properties which require event reassignment
		'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
			if(!this.rendered) { return; }

			// Set tracking flag
			var posOptions = this.options.position;
			this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);

			// Reassign events
			this._unassignEvents();
			this._assignEvents();
		}
	}
};

// Dot notation converter
function convertNotation(options, notation) {
	var i = 0, obj, option = options,

	// Split notation into array
	levels = notation.split('.');

	// Loop through
	while( option = option[ levels[i++] ] ) {
		if(i < levels.length) { obj = option; }
	}

	return [obj || options, levels.pop()];
}

PROTOTYPE.get = function(notation) {
	if(this.destroyed) { return this; }

	var o = convertNotation(this.options, notation.toLowerCase()),
		result = o[0][ o[1] ];

	return result.precedance ? result.string() : result;
};

function setCallback(notation, args) {
	var category, rule, match;

	for(category in this.checks) {
		for(rule in this.checks[category]) {
			if(match = (new RegExp(rule, 'i')).exec(notation)) {
				args.push(match);

				if(category === 'builtin' || this.plugins[category]) {
					this.checks[category][rule].apply(
						this.plugins[category] || this, args
					);
				}
			}
		}
	}
}

var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
	rrender = /^prerender|show\.ready/i;

PROTOTYPE.set = function(option, value) {
	if(this.destroyed) { return this; }

	var rendered = this.rendered,
		reposition = FALSE,
		options = this.options,
		checks = this.checks,
		name;

	// Convert singular option/value pair into object form
	if('string' === typeof option) {
		name = option; option = {}; option[name] = value;
	}
	else { option = $.extend({}, option); }

	// Set all of the defined options to their new values
	$.each(option, function(notation, value) {
		if(rendered && rrender.test(notation)) {
			delete option[notation]; return;
		}

		// Set new obj value
		var obj = convertNotation(options, notation.toLowerCase()), previous;
		previous = obj[0][ obj[1] ];
		obj[0][ obj[1] ] = value && value.nodeType ? $(value) : value;

		// Also check if we need to reposition
		reposition = rmove.test(notation) || reposition;

		// Set the new params for the callback
		option[notation] = [obj[0], obj[1], value, previous];
	});

	// Re-sanitize options
	sanitizeOptions(options);

	/*
	 * Execute any valid callbacks for the set options
	 * Also set positioning flag so we don't get loads of redundant repositioning calls.
	 */
	this.positioning = TRUE;
	$.each(option, $.proxy(setCallback, this));
	this.positioning = FALSE;

	// Update position if needed
	if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
		this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
	}

	return this;
};

;PROTOTYPE._update = function(content, element, reposition) {
	var self = this,
		cache = this.cache;

	// Make sure tooltip is rendered and content is defined. If not return
	if(!this.rendered || !content) { return FALSE; }

	// Use function to parse content
	if($.isFunction(content)) {
		content = content.call(this.elements.target, cache.event, this) || '';
	}

	// Handle deferred content
	if($.isFunction(content.then)) {
		cache.waiting = TRUE;
		return content.then(function(c) {
			cache.waiting = FALSE;
			return self._update(c, element);
		}, NULL, function(e) {
			return self._update(e, element);
		});
	}

	// If content is null... return false
	if(content === FALSE || (!content && content !== '')) { return FALSE; }

	// Append new content if its a DOM array and show it if hidden
	if(content.jquery && content.length > 0) {
		element.children().detach().end().append( content.css({ display: 'block', visibility: 'visible' }) );
	}

	// Content is a regular string, insert the new content
	else { element.html(content); }

	// If imagesLoaded is included, ensure images have loaded and return promise
	cache.waiting = TRUE;

	return ( $.fn.imagesLoaded ? element.imagesLoaded() : $.Deferred().resolve($([])) )
		.done(function(images) {
			cache.waiting = FALSE;

			// Reposition if rendered
			if(images.length && self.rendered && self.tooltip[0].offsetWidth > 0) {
				self.reposition(cache.event, !images.length);
			}
		})
		.promise();
};

PROTOTYPE._updateContent = function(content, reposition) {
	this._update(content, this.elements.content, reposition);
};

PROTOTYPE._updateTitle = function(content, reposition) {
	if(this._update(content, this.elements.title, reposition) === FALSE) {
		this._removeTitle(FALSE);
	}
};

PROTOTYPE._createTitle = function()
{
	var elements = this.elements,
		id = this._id+'-title';

	// Destroy previous title element, if present
	if(elements.titlebar) { this._removeTitle(); }

	// Create title bar and title elements
	elements.titlebar = $('<div />', {
		'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
	})
	.append(
		elements.title = $('<div />', {
			'id': id,
			'class': NAMESPACE + '-title',
			'aria-atomic': TRUE
		})
	)
	.insertBefore(elements.content)

	// Button-specific events
	.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
		$(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
	})
	.delegate('.qtip-close', 'mouseover mouseout', function(event){
		$(this).toggleClass('ui-state-hover', event.type === 'mouseover');
	});

	// Create button if enabled
	if(this.options.content.button) { this._createButton(); }
};

PROTOTYPE._removeTitle = function(reposition)
{
	var elements = this.elements;

	if(elements.title) {
		elements.titlebar.remove();
		elements.titlebar = elements.title = elements.button = NULL;

		// Reposition if enabled
		if(reposition !== FALSE) { this.reposition(); }
	}
};

;PROTOTYPE.reposition = function(event, effect) {
	if(!this.rendered || this.positioning || this.destroyed) { return this; }

	// Set positioning flag
	this.positioning = TRUE;

	var cache = this.cache,
		tooltip = this.tooltip,
		posOptions = this.options.position,
		target = posOptions.target,
		my = posOptions.my,
		at = posOptions.at,
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		tooltipWidth = tooltip.outerWidth(FALSE),
		tooltipHeight = tooltip.outerHeight(FALSE),
		targetWidth = 0,
		targetHeight = 0,
		type = tooltip.css('position'),
		position = { left: 0, top: 0 },
		visible = tooltip[0].offsetWidth > 0,
		isScroll = event && event.type === 'scroll',
		win = $(window),
		doc = container[0].ownerDocument,
		mouse = this.mouse,
		pluginCalculations, offset;

	// Check if absolute position was passed
	if($.isArray(target) && target.length === 2) {
		// Force left top and set position
		at = { x: LEFT, y: TOP };
		position = { left: target[0], top: target[1] };
	}

	// Check if mouse was the target
	else if(target === 'mouse') {
		// Force left top to allow flipping
		at = { x: LEFT, y: TOP };

		// Use the cached mouse coordinates if available, or passed event has no coordinates
		if(mouse && mouse.pageX && (adjust.mouse || !event || !event.pageX) ) {
			event = mouse;
		}
		
		// If the passed event has no coordinates (such as a scroll event)
		else if(!event || !event.pageX) {
			// Use cached event for resize/scroll events
			if(event && (event.type === 'resize' || event.type === 'scroll')) {
				event = cache.event;
			}

			// Use the mouse origin that caused the show event, if distance hiding is enabled
			else if((!adjust.mouse || this.options.show.distance) && cache.origin && cache.origin.pageX) {
				event =  cache.origin;
			}
		}

		// Calculate body and container offset and take them into account below
		if(type !== 'static') { position = container.offset(); }
		if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
			offset = $(document.body).offset();
		}

		// Use event coordinates for position
		position = {
			left: event.pageX - position.left + (offset && offset.left || 0),
			top: event.pageY - position.top + (offset && offset.top || 0)
		};

		// Scroll events are a pain, some browsers
		if(adjust.mouse && isScroll && mouse) {
			position.left -= (mouse.scrollX || 0) - win.scrollLeft();
			position.top -= (mouse.scrollY || 0) - win.scrollTop();
		}
	}

	// Target wasn't mouse or absolute...
	else {
		// Check if event targetting is being used
		if(target === 'event' && event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
			cache.target = $(event.target);
		}
		else if(target !== 'event'){
			cache.target = $(target.jquery ? target : this.elements.target);
		}
		target = cache.target;

		// Parse the target into a jQuery object and make sure there's an element present
		target = $(target).eq(0);
		if(target.length === 0) { return this; }

		// Check if window or document is the target
		else if(target[0] === document || target[0] === window) {
			targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
			targetHeight = BROWSER.iOS ? window.innerHeight : target.height();

			if(target[0] === window) {
				position = {
					top: (viewport || target).scrollTop(),
					left: (viewport || target).scrollLeft()
				};
			}
		}

		// Check if the target is an <AREA> element
		else if(PLUGINS.imagemap && target.is('area')) {
			pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Check if the target is an SVG element
		else if(PLUGINS.svg && target[0].ownerSVGElement) {
			pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Otherwise use regular jQuery methods
		else {
			targetWidth = target.outerWidth(FALSE);
			targetHeight = target.outerHeight(FALSE);
			position = target.offset();
		}

		// Parse returned plugin values into proper variables
		if(pluginCalculations) {
			targetWidth = pluginCalculations.width;
			targetHeight = pluginCalculations.height;
			offset = pluginCalculations.offset;
			position = pluginCalculations.position;
		}

		// Adjust position to take into account offset parents
		position = this.reposition.offset(target, position, container);

		// Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
		if((BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1) || 
			(BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33) || 
			(!BROWSER.iOS && type === 'fixed')
		){
			position.left -= win.scrollLeft();
			position.top -= win.scrollTop();
		}

		// Adjust position relative to target
		if(!pluginCalculations || (pluginCalculations && pluginCalculations.adjustable !== FALSE)) {
			position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
			position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
		}
	}

	// Adjust position relative to tooltip
	position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
	position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);

	// Use viewport adjustment plugin if enabled
	if(PLUGINS.viewport) {
		position.adjusted = PLUGINS.viewport(
			this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
		);

		// Apply offsets supplied by positioning plugin (if used)
		if(offset && position.adjusted.left) { position.left += offset.left; }
		if(offset && position.adjusted.top) {  position.top += offset.top; }
	}

	// Viewport adjustment is disabled, set values to zero
	else { position.adjusted = { left: 0, top: 0 }; }

	// tooltipmove event
	if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
	delete position.adjusted;

	// If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
	if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
		tooltip.css(position);
	}

	// Use custom function if provided
	else if($.isFunction(posOptions.effect)) {
		posOptions.effect.call(tooltip, this, $.extend({}, position));
		tooltip.queue(function(next) {
			// Reset attributes to avoid cross-browser rendering bugs
			$(this).css({ opacity: '', height: '' });
			if(BROWSER.ie) { this.style.removeAttribute('filter'); }

			next();
		});
	}

	// Set positioning flag
	this.positioning = FALSE;

	return this;
};

// Custom (more correct for qTip!) offset calculator
PROTOTYPE.reposition.offset = function(elem, pos, container) {
	if(!container[0]) { return pos; }

	var ownerDocument = $(elem[0].ownerDocument),
		quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
		parent = container[0],
		scrolled, position, parentOffset, overflow;

	function scroll(e, i) {
		pos.left += i * e.scrollLeft();
		pos.top += i * e.scrollTop();
	}

	// Compensate for non-static containers offset
	do {
		if((position = $.css(parent, 'position')) !== 'static') {
			if(position === 'fixed') {
				parentOffset = parent.getBoundingClientRect();
				scroll(ownerDocument, -1);
			}
			else {
				parentOffset = $(parent).position();
				parentOffset.left += (parseFloat($.css(parent, 'borderLeftWidth')) || 0);
				parentOffset.top += (parseFloat($.css(parent, 'borderTopWidth')) || 0);
			}

			pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
			pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);

			// If this is the first parent element with an overflow of "scroll" or "auto", store it
			if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible') { scrolled = $(parent); }
		}
	}
	while((parent = parent.offsetParent));

	// Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
	if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
		scroll(scrolled, 1);
	}

	return pos;
};

// Corner class
var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
	corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
	this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
	this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
	this.forceY = !!forceY;

	var f = corner.charAt(0);
	this.precedance = (f === 't' || f === 'b' ? Y : X);
}).prototype;

C.invert = function(z, center) {
	this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];	
};

C.string = function() {
	var x = this.x, y = this.y;
	return x === y ? x : this.precedance === Y || (this.forceY && y !== 'center') ? y+' '+x : x+' '+y;
};

C.abbrev = function() {
	var result = this.string().split(' ');
	return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
};

C.clone = function() {
	return new CORNER( this.string(), this.forceY );
};;
PROTOTYPE.toggle = function(state, event) {
	var cache = this.cache,
		options = this.options,
		tooltip = this.tooltip;

	// Try to prevent flickering when tooltip overlaps show element
	if(event) {
		if((/over|enter/).test(event.type) && (/out|leave/).test(cache.event.type) &&
			options.show.target.add(event.target).length === options.show.target.length &&
			tooltip.has(event.relatedTarget).length) {
			return this;
		}

		// Cache event
		cache.event = cloneEvent(event);
	}
		
	// If we're currently waiting and we've just hidden... stop it
	this.waiting && !state && (this.hiddenDuringWait = TRUE);

	// Render the tooltip if showing and it isn't already
	if(!this.rendered) { return state ? this.render(1) : this; }
	else if(this.destroyed || this.disabled) { return this; }

	var type = state ? 'show' : 'hide',
		opts = this.options[type],
		otherOpts = this.options[ !state ? 'show' : 'hide' ],
		posOptions = this.options.position,
		contentOptions = this.options.content,
		width = this.tooltip.css('width'),
		visible = this.tooltip[0].offsetWidth > 0,
		animate = state || opts.target.length === 1,
		sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
		identicalState, allow, showEvent, delay, after;

	// Detect state if valid one isn't provided
	if((typeof state).search('boolean|number')) { state = !visible; }

	// Check if the tooltip is in an identical state to the new would-be state
	identicalState = !tooltip.is(':animated') && visible === state && sameTarget;

	// Fire tooltip(show/hide) event and check if destroyed
	allow = !identicalState ? !!this._trigger(type, [90]) : NULL;

	// If the user didn't stop the method prematurely and we're showing the tooltip, focus it
	if(allow !== FALSE && state) { this.focus(event); }

	// If the state hasn't changed or the user stopped it, return early
	if(!allow || identicalState) { return this; }

	// Set ARIA hidden attribute
	$.attr(tooltip[0], 'aria-hidden', !!!state);

	// Execute state specific properties
	if(state) {
		// Store show origin coordinates
		cache.origin = cloneEvent(this.mouse);

		// Update tooltip content & title if it's a dynamic function
		if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
		if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }

		// Cache mousemove events for positioning purposes (if not already tracking)
		if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
			$(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
			trackingBound = TRUE;
		}

		// Update the tooltip position (set width first to prevent viewport/max-width issues)
		if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
		this.reposition(event, arguments[2]);
		if(!width) { tooltip.css('width', ''); }

		// Hide other tooltips if tooltip is solo
		if(!!opts.solo) {
			(typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
				.not(tooltip).not(opts.target).qtip('hide', $.Event('tooltipsolo'));
		}
	}
	else {
		// Clear show timer if we're hiding
		clearTimeout(this.timers.show);

		// Remove cached origin on hide
		delete cache.origin;

		// Remove mouse tracking event if not needed (all tracking qTips are hidden)
		if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
			$(document).unbind('mousemove.'+NAMESPACE);
			trackingBound = FALSE;
		}

		// Blur the tooltip
		this.blur(event);
	}

	// Define post-animation, state specific properties
	after = $.proxy(function() {
		if(state) {
			// Prevent antialias from disappearing in IE by removing filter
			if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }

			// Remove overflow setting to prevent tip bugs
			tooltip.css('overflow', '');

			// Autofocus elements if enabled
			if('string' === typeof opts.autofocus) {
				$(this.options.show.autofocus, tooltip).focus();
			}

			// If set, hide tooltip when inactive for delay period
			this.options.show.target.trigger('qtip-'+this.id+'-inactive');
		}
		else {
			// Reset CSS states
			tooltip.css({
				display: '',
				visibility: '',
				opacity: '',
				left: '',
				top: ''
			});
		}

		// tooltipvisible/tooltiphidden events
		this._trigger(state ? 'visible' : 'hidden');
	}, this);

	// If no effect type is supplied, use a simple toggle
	if(opts.effect === FALSE || animate === FALSE) {
		tooltip[ type ]();
		after();
	}

	// Use custom function if provided
	else if($.isFunction(opts.effect)) {
		tooltip.stop(1, 1);
		opts.effect.call(tooltip, this);
		tooltip.queue('fx', function(n) {
			after(); n();
		});
	}

	// Use basic fade function by default
	else { tooltip.fadeTo(90, state ? 1 : 0, after); }

	// If inactive hide method is set, active it
	if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }

	return this;
};

PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };

PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };

;PROTOTYPE.focus = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	var qtips = $(SELECTOR),
		tooltip = this.tooltip,
		curIndex = parseInt(tooltip[0].style.zIndex, 10),
		newIndex = QTIP.zindex + qtips.length,
		focusedElem;

	// Only update the z-index if it has changed and tooltip is not already focused
	if(!tooltip.hasClass(CLASS_FOCUS)) {
		// tooltipfocus event
		if(this._trigger('focus', [newIndex], event)) {
			// Only update z-index's if they've changed
			if(curIndex !== newIndex) {
				// Reduce our z-index's and keep them properly ordered
				qtips.each(function() {
					if(this.style.zIndex > curIndex) {
						this.style.zIndex = this.style.zIndex - 1;
					}
				});

				// Fire blur event for focused tooltip
				qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
			}

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
		}
	}

	return this;
};

PROTOTYPE.blur = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	// Set focused status to FALSE
	this.tooltip.removeClass(CLASS_FOCUS);

	// tooltipblur event
	this._trigger('blur', [ this.tooltip.css('zIndex') ], event);

	return this;
};

;PROTOTYPE.disable = function(state) {
	if(this.destroyed) { return this; }

	if('boolean' !== typeof state) {
		state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
	}

	if(this.rendered) {
		this.tooltip.toggleClass(CLASS_DISABLED, state)
			.attr('aria-disabled', state);
	}

	this.disabled = !!state;

	return this;
};

PROTOTYPE.enable = function() { return this.disable(FALSE); };

;PROTOTYPE._createButton = function()
{
	var self = this,
		elements = this.elements,
		tooltip = elements.tooltip,
		button = this.options.content.button,
		isString = typeof button === 'string',
		close = isString ? button : 'Close tooltip';

	if(elements.button) { elements.button.remove(); }

	// Use custom button if one was supplied by user, else use default
	if(button.jquery) {
		elements.button = button;
	}
	else {
		elements.button = $('<a />', {
			'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
			'title': close,
			'aria-label': close
		})
		.prepend(
			$('<span />', {
				'class': 'ui-icon ui-icon-close',
				'html': '&times;'
			})
		);
	}

	// Create button and setup attributes
	elements.button.appendTo(elements.titlebar || tooltip)
		.attr('role', 'button')
		.click(function(event) {
			if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
			return FALSE;
		});
};

PROTOTYPE._updateButton = function(button)
{
	// Make sure tooltip is rendered and if not, return
	if(!this.rendered) { return FALSE; }

	var elem = this.elements.button;
	if(button) { this._createButton(); }
	else { elem.remove(); }
};

;// Widget class creator
function createWidgetClass(cls) {
	return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
}

// Widget class setter method
PROTOTYPE._setWidget = function()
{
	var on = this.options.style.widget,
		elements = this.elements,
		tooltip = elements.tooltip,
		disabled = tooltip.hasClass(CLASS_DISABLED);

	tooltip.removeClass(CLASS_DISABLED);
	CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
	tooltip.toggleClass(CLASS_DISABLED, disabled);

	tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);
	
	if(elements.content) {
		elements.content.toggleClass( createWidgetClass('content'), on);
	}
	if(elements.titlebar) {
		elements.titlebar.toggleClass( createWidgetClass('header'), on);
	}
	if(elements.button) {
		elements.button.toggleClass(NAMESPACE+'-icon', !on);
	}
};;function cloneEvent(event) {
	return event && {
		type: event.type,
		pageX: event.pageX,
		pageY: event.pageY,
		target: event.target,
		relatedTarget: event.relatedTarget,
		scrollX: event.scrollX || window.pageXOffset || document.body.scrollLeft || document.documentElement.scrollLeft,
		scrollY: event.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
	} || {};
}

function delay(callback, duration) {
	// If tooltip has displayed, start hide timer
	if(duration > 0) {
		return setTimeout(
			$.proxy(callback, this), duration
		);
	}
	else{ callback.call(this); }
}

function showMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return FALSE; }

	// Clear hide timers
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Start show timer
	this.timers.show = delay.call(this,
		function() { this.toggle(TRUE, event); },
		this.options.show.delay
	);
}

function hideMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return FALSE; }

	// Check if new target was actually the tooltip element
	var relatedTarget = $(event.relatedTarget),
		ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
		ontoTarget = relatedTarget[0] === this.options.show.target[0];

	// Clear timers and stop animation queue
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Prevent hiding if tooltip is fixed and event target is the tooltip.
	// Or if mouse positioning is enabled and cursor momentarily overlaps
	if(this !== relatedTarget[0] && 
		(this.options.position.target === 'mouse' && ontoTooltip) || 
		(this.options.hide.fixed && (
			(/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
		))
	{
		try {
			event.preventDefault();
			event.stopImmediatePropagation();
		} catch(e) {}

		return;
	}

	// If tooltip has displayed, start hide timer
	this.timers.hide = delay.call(this,
		function() { this.toggle(FALSE, event); },
		this.options.hide.delay,
		this
	);
}

function inactiveMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return FALSE; }

	// Clear timer
	clearTimeout(this.timers.inactive);

	this.timers.inactive = delay.call(this,
		function(){ this.hide(event); },
		this.options.hide.inactive
	);
}

function repositionMethod(event) {
	if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
}

// Store mouse coordinates
PROTOTYPE._storeMouse = function(event) {
	(this.mouse = cloneEvent(event)).type = 'mousemove';
};

// Bind events
PROTOTYPE._bind = function(targets, events, method, suffix, context) {
	var ns = '.' + this._id + (suffix ? '-'+suffix : '');
	events.length && $(targets).bind(
		(events.split ? events : events.join(ns + ' ')) + ns,
		$.proxy(method, context || this)
	);
};
PROTOTYPE._unbind = function(targets, suffix) {
	$(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
};

// Apply common event handlers using delegate (avoids excessive .bind calls!)
var ns = '.'+NAMESPACE;
function delegate(selector, events, method) {	
	$(document.body).delegate(selector,
		(events.split ? events : events.join(ns + ' ')) + ns,
		function() {
			var api = QTIP.api[ $.attr(this, ATTR_ID) ];
			api && !api.disabled && method.apply(api, arguments);
		}
	);
}

$(function() {
	delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
		var state = event.type === 'mouseenter',
			tooltip = $(event.currentTarget),
			target = $(event.relatedTarget || event.target),
			options = this.options;

		// On mouseenter...
		if(state) {
			// Focus the tooltip on mouseenter (z-index stacking)
			this.focus(event);

			// Clear hide timer on tooltip hover to prevent it from closing
			tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
		}

		// On mouseleave...
		else {
			// Hide when we leave the tooltip and not onto the show target (if a hide event is set)
			if(options.position.target === 'mouse' && options.hide.event && 
				options.show.target && !target.closest(options.show.target[0]).length) {
				this.hide(event);
			}
		}

		// Add hover class
		tooltip.toggleClass(CLASS_HOVER, state);
	});

	// Define events which reset the 'inactive' event handler
	delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
});

// Event trigger
PROTOTYPE._trigger = function(type, args, event) {
	var callback = $.Event('tooltip'+type);
	callback.originalEvent = (event && $.extend({}, event)) || this.cache.event || NULL;

	this.triggering = TRUE;
	this.tooltip.trigger(callback, [this].concat(args || []));
	this.triggering = FALSE;

	return !callback.isDefaultPrevented();
};

PROTOTYPE._assignInitialEvents = function(event) {
	var options = this.options,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];

	/*
	 * Make sure hoverIntent functions properly by using mouseleave as a hide event if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
		hideEvents.push('mouseleave');
	}

	/*
	 * Also make sure initial mouse targetting works correctly by caching mousemove coords
	 * on show targets before the tooltip has rendered. Also set onTarget when triggered to
	 * keep mouse tracking working.
	 */
	this._bind(showTarget, 'mousemove', function(event) {
		this._storeMouse(event);
		this.cache.onTarget = TRUE;
	});

	// Define hoverIntent function
	function hoverIntent(event) {
		// Only continue if tooltip isn't disabled
		if(this.disabled || this.destroyed) { return FALSE; }

		// Cache the event data
		this.cache.event = cloneEvent(event);
		this.cache.target = event ? $(event.target) : [undefined];

		// Start the event sequence
		clearTimeout(this.timers.show);
		this.timers.show = delay.call(this,
			function() { this.render(typeof event === 'object' || options.show.ready); },
			options.show.delay
		);
	}

	// Bind events to target
	this._bind(showTarget, showEvents, hoverIntent);
	if(options.show.event !== options.hide.event) {
		this._bind(hideTarget, hideEvents, function() { clearTimeout(this.timers.show); });
	}

	// Prerendering is enabled, create tooltip now
	if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
};


// Event assignment method
PROTOTYPE._assignEvents = function() {
	var self = this,
		options = this.options,
		posOptions = options.position,

		tooltip = this.tooltip,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		containerTarget = posOptions.container,
		viewportTarget = posOptions.viewport,
		documentTarget = $(document),
		bodyTarget = $(document.body),
		windowTarget = $(window),

		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [],
		toggleEvents = [];

	// Assign passed event callbacks
	$.each(options.events, function(name, callback) {
		self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
	});

	// Hide tooltips when leaving current window/frame (but not select/option elements)
	if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
		this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
			if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
				this.hide(event);
			}
		});
	}

	// Enable hide.fixed by adding appropriate class
	if(options.hide.fixed) {
		hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
	}

	/*
	 * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	else if(/mouse(over|enter)/i.test(options.show.event)) {
		this._bind(hideTarget, 'mouseleave', function() {
			clearTimeout(this.timers.show);
		});
	}

	// Hide tooltip on document mousedown if unfocus events are enabled
	if(('' + options.hide.event).indexOf('unfocus') > -1) {
		this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
			var elem = $(event.target),
				enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
				isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;

			if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
				!this.target.has(elem[0]).length && enabled
			) {
				this.hide(event);
			}
		});
	}

	// Check if the tooltip hides when inactive
	if('number' === typeof options.hide.inactive) {
		// Bind inactive method to show target(s) as a custom event
		this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod);

		// Define events which reset the 'inactive' event handler
		this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod, '-inactive');
	}

	// Apply hide events (and filter identical show events)
	hideEvents = $.map(hideEvents, function(type) {
		var showIndex = $.inArray(type, showEvents);

		// Both events and targets are identical, apply events using a toggle
		if((showIndex > -1 && hideTarget.add(showTarget).length === hideTarget.length)) {
			toggleEvents.push( showEvents.splice( showIndex, 1 )[0] ); return;
		}

		return type;
	});

	// Apply show/hide/toggle events
	this._bind(showTarget, showEvents, showMethod);
	this._bind(hideTarget, hideEvents, hideMethod);
	this._bind(showTarget, toggleEvents, function(event) {
		(this.tooltip[0].offsetWidth > 0 ? hideMethod : showMethod).call(this, event);
	});


	// Mouse movement bindings
	this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
		// Check if the tooltip hides when mouse is moved a certain distance
		if('number' === typeof options.hide.distance) {
			var origin = this.cache.origin || {},
				limit = this.options.hide.distance,
				abs = Math.abs;

			// Check if the movement has gone beyond the limit, and hide it if so
			if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
				this.hide(event);
			}
		}

		// Cache mousemove coords on show targets
		this._storeMouse(event);
	});

	// Mouse positioning events
	if(posOptions.target === 'mouse') {
		// If mouse adjustment is on...
		if(posOptions.adjust.mouse) {
			// Apply a mouseleave event so we don't get problems with overlapping
			if(options.hide.event) {
				// Track if we're on the target or not
				this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
					this.cache.onTarget = event.type === 'mouseenter';
				});
			}

			// Update tooltip position on mousemove
			this._bind(documentTarget, 'mousemove', function(event) {
				// Update the tooltip position only if the tooltip is visible and adjustment is enabled
				if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
					this.reposition(event);
				}
			});
		}
	}

	// Adjust positions of the tooltip on window resize if enabled
	if(posOptions.adjust.resize || viewportTarget.length) {
		this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
	}

	// Adjust tooltip position on scroll of the window or viewport element if present
	if(posOptions.adjust.scroll) {
		this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
	}
};

// Un-assignment method
PROTOTYPE._unassignEvents = function() {
	var targets = [
		this.options.show.target[0],
		this.options.hide.target[0],
		this.rendered && this.tooltip[0],
		this.options.position.container[0],
		this.options.position.viewport[0],
		this.options.position.container.closest('html')[0], // unfocus
		window,
		document
	];

	this._unbind($([]).pushStack( $.grep(targets, function(i) {
		return typeof i === 'object';
	})));
};

;// Initialization method
function init(elem, id, opts) {
	var obj, posOptions, attr, config, title,

	// Setup element references
	docBody = $(document.body),

	// Use document body instead of document element if needed
	newTarget = elem[0] === document ? docBody : elem,

	// Grab metadata from element if plugin is present
	metadata = (elem.metadata) ? elem.metadata(opts.metadata) : NULL,

	// If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
	metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,

	// Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
	html5 = elem.data(opts.metadata.name || 'qtipopts');

	// If we don't get an object returned attempt to parse it manualyl without parseJSON
	try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; } catch(e) {}

	// Merge in and sanitize metadata
	config = $.extend(TRUE, {}, QTIP.defaults, opts,
		typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
		sanitizeOptions(metadata5 || metadata));

	// Re-grab our positioning options now we've merged our metadata and set id to passed value
	posOptions = config.position;
	config.id = id;

	// Setup missing content if none is detected
	if('boolean' === typeof config.content.text) {
		attr = elem.attr(config.content.attr);

		// Grab from supplied attribute if available
		if(config.content.attr !== FALSE && attr) { config.content.text = attr; }

		// No valid content was found, abort render
		else { return FALSE; }
	}

	// Setup target options
	if(!posOptions.container.length) { posOptions.container = docBody; }
	if(posOptions.target === FALSE) { posOptions.target = newTarget; }
	if(config.show.target === FALSE) { config.show.target = newTarget; }
	if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
	if(config.hide.target === FALSE) { config.hide.target = newTarget; }
	if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }

	// Ensure we only use a single container
	posOptions.container = posOptions.container.eq(0);

	// Convert position corner values into x and y strings
	posOptions.at = new CORNER(posOptions.at, TRUE);
	posOptions.my = new CORNER(posOptions.my);

	// Destroy previous tooltip if overwrite is enabled, or skip element if not
	if(elem.data(NAMESPACE)) {
		if(config.overwrite) {
			elem.qtip('destroy', true);
		}
		else if(config.overwrite === FALSE) {
			return FALSE;
		}
	}

	// Add has-qtip attribute
	elem.attr(ATTR_HAS, id);

	// Remove title attribute and store it if present
	if(config.suppress && (title = elem.attr('title'))) {
		// Final attr call fixes event delegatiom and IE default tooltip showing problem
		elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
	}

	// Initialize the tooltip and add API reference
	obj = new QTip(elem, config, id, !!attr);
	elem.data(NAMESPACE, obj);

	// Catch remove/removeqtip events on target element to destroy redundant tooltip
	elem.one('remove.qtip-'+id+' removeqtip.qtip-'+id, function() { 
		var api; if((api = $(this).data(NAMESPACE))) { api.destroy(true); }
	});

	return obj;
}

// jQuery $.fn extension method
QTIP = $.fn.qtip = function(options, notation, newValue)
{
	var command = ('' + options).toLowerCase(), // Parse command
		returned = NULL,
		args = $.makeArray(arguments).slice(1),
		event = args[args.length - 1],
		opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;

	// Check for API request
	if((!arguments.length && opts) || command === 'api') {
		return opts;
	}

	// Execute API command if present
	else if('string' === typeof options) {
		this.each(function() {
			var api = $.data(this, NAMESPACE);
			if(!api) { return TRUE; }

			// Cache the event if possible
			if(event && event.timeStamp) { api.cache.event = event; }

			// Check for specific API commands
			if(notation && (command === 'option' || command === 'options')) {
				if(newValue !== undefined || $.isPlainObject(notation)) {
					api.set(notation, newValue);
				}
				else {
					returned = api.get(notation);
					return FALSE;
				}
			}

			// Execute API command
			else if(api[command]) {
				api[command].apply(api, args);
			}
		});

		return returned !== NULL ? returned : this;
	}

	// No API commands. validate provided options and setup qTips
	else if('object' === typeof options || !arguments.length) {
		// Sanitize options first
		opts = sanitizeOptions($.extend(TRUE, {}, options));

		return this.each(function(i) {
			var api, id;

			// Find next available ID, or use custom ID if provided
			id = $.isArray(opts.id) ? opts.id[i] : opts.id;
			id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;

			// Initialize the qTip and re-grab newly sanitized options
			api = init($(this), id, opts);
			if(api === FALSE) { return TRUE; }
			else { QTIP.api[id] = api; }

			// Initialize plugins
			$.each(PLUGINS, function() {
				if(this.initialize === 'initialize') { this(api); }
			});

			// Assign initial pre-render events
			api._assignInitialEvents(event);
		});
	}
};

// Populated in render method
QTIP.api = {};
;$.each({
	/* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
	attr: function(attr, val) {
		if(this.length) {
			var self = this[0],
				title = 'title',
				api = $.data(self, 'qtip');

			if(attr === title && api && 'object' === typeof api && api.options.suppress) {
				if(arguments.length < 2) {
					return $.attr(self, oldtitle);
				}

				// If qTip is rendered and title was originally used as content, update it
				if(api && api.options.content.attr === title && api.cache.attr) {
					api.set('content.text', val);
				}

				// Use the regular attr method to set, then cache the result
				return this.attr(oldtitle, val);
			}
		}

		return $.fn['attr'+replaceSuffix].apply(this, arguments);
	},

	/* Allow clone to correctly retrieve cached title attributes */
	clone: function(keepData) {
		var titles = $([]), title = 'title',

		// Clone our element using the real clone method
		elems = $.fn['clone'+replaceSuffix].apply(this, arguments);

		// Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
		if(!keepData) {
			elems.filter('['+oldtitle+']').attr('title', function() {
				return $.attr(this, oldtitle);
			})
			.removeAttr(oldtitle);
		}

		return elems;
	}
}, function(name, func) {
	if(!func || $.fn[name+replaceSuffix]) { return TRUE; }

	var old = $.fn[name+replaceSuffix] = $.fn[name];
	$.fn[name] = function() {
		return func.apply(this, arguments) || old.apply(this, arguments);
	};
});

/* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
 * This snippet is taken directly from jQuery UI source code found here:
 *     http://code.jquery.com/ui/jquery-ui-git.js
 */
if(!$.ui) {
	$['cleanData'+replaceSuffix] = $.cleanData;
	$.cleanData = function( elems ) {
		for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
			if(elem.attr(ATTR_HAS)) {
				try { elem.triggerHandler('removeqtip'); } 
				catch( e ) {}
			}
		}
		$['cleanData'+replaceSuffix].apply(this, arguments);
	};
}

;// qTip version
QTIP.version = '2.1.1';

// Base ID for all qTips
QTIP.nextid = 0;

// Inactive events array
QTIP.inactiveEvents = INACTIVE_EVENTS;

// Base z-index for all qTips
QTIP.zindex = 15000;

// Define configuration defaults
QTIP.defaults = {
	prerender: FALSE,
	id: FALSE,
	overwrite: TRUE,
	suppress: TRUE,
	content: {
		text: TRUE,
		attr: 'title',
		title: FALSE,
		button: FALSE
	},
	position: {
		my: 'top left',
		at: 'bottom right',
		target: FALSE,
		container: FALSE,
		viewport: FALSE,
		adjust: {
			x: 0, y: 0,
			mouse: TRUE,
			scroll: TRUE,
			resize: TRUE,
			method: 'flipinvert flipinvert'
		},
		effect: function(api, pos, viewport) {
			$(this).animate(pos, {
				duration: 200,
				queue: FALSE
			});
		}
	},
	show: {
		target: FALSE,
		event: 'mouseenter',
		effect: TRUE,
		delay: 90,
		solo: FALSE,
		ready: FALSE,
		autofocus: FALSE
	},
	hide: {
		target: FALSE,
		event: 'mouseleave',
		effect: TRUE,
		delay: 0,
		fixed: FALSE,
		inactive: FALSE,
		leave: 'window',
		distance: FALSE
	},
	style: {
		classes: '',
		widget: FALSE,
		width: FALSE,
		height: FALSE,
		def: TRUE
	},
	events: {
		render: NULL,
		move: NULL,
		show: NULL,
		hide: NULL,
		toggle: NULL,
		visible: NULL,
		hidden: NULL,
		focus: NULL,
		blur: NULL
	}
};

;var TIP, createVML, 

// .bind()/.on() namespace
TIPNS = '.qtip-tip',

// Common CSS strings
MARGIN = 'margin',
BORDER = 'border',
COLOR = 'color',
BG_COLOR = 'background-color',
TRANSPARENT = 'transparent',
IMPORTANT = ' !important',

// Check if the browser supports <canvas/> elements
HASCANVAS = !!document.createElement('canvas').getContext,

// Fetch device pixel ratio
PIXEL_RATIO = window.devicePixelRatio || 1,

// Invalid colour values used in parseColours()
INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;

// Camel-case method, taken from jQuery source
// http://code.jquery.com/jquery-1.8.0.js
function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

/*
 * Modified from Modernizr's testPropsAll()
 * http://modernizr.com/downloads/modernizr-latest.js
 */
var cssProps = {}, cssPrefixes = ["Webkit", "O", "Moz", "ms"];
function vendorCss(elem, prop) {
	var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
		props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
		cur, val, i = 0;

	// If the property has already been mapped...
	if(cssProps[prop]) { return elem.css(cssProps[prop]); }

	while((cur = props[i++])) {
		if((val = elem.css(cur)) !== undefined) {
			return cssProps[prop] = cur, val;
		}
	}
}

// Parse a given elements CSS property into an int
function intCss(elem, prop) {
	return Math.ceil(parseFloat(vendorCss(elem, prop)));
}


// VML creation (for IE only)
if(!HASCANVAS) {
	createVML = function(tag, props, style) {
		return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
			' style="behavior: url(#default#VML); '+(style||'')+ '" />';
	};
}



function Tip(qtip, options) {
	this._ns = 'tip';
	this.options = options;
	this.offset = options.offset;
	this.size = [ options.width, options.height ];

	// Initialize
	this.init( (this.qtip = qtip) );
}

$.extend(Tip.prototype, {
	init: function(qtip) {
		var context, tip;

		// Create tip element and prepend to the tooltip
		tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);

		// Create tip drawing element(s)
		if(HASCANVAS) {
			// save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
			context = $('<canvas />').appendTo(this.element)[0].getContext('2d');

			// Setup constant parameters
			context.lineJoin = 'miter';
			context.miterLimit = 100000;
			context.save();
		}
		else {
			context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
			this.element.html(context + context);

			// Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
			qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
		}

		// Bind update events
		qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);

		// Create it
		this.create();
	},

	_swapDimensions: function() {
		this.size[0] = this.options.height;
		this.size[1] = this.options.width;
	},
	_resetDimensions: function() {
		this.size[0] = this.options.width;
		this.size[1] = this.options.height;
	},

	_useTitle: function(corner) {
		var titlebar = this.qtip.elements.titlebar;
		return titlebar && (
			corner.y === TOP || (corner.y === CENTER && this.element.position().top + (this.size[1] / 2) + this.options.offset < titlebar.outerHeight(TRUE))
		);
	},

	_parseCorner: function(corner) {
		var my = this.qtip.options.position.my;

		// Detect corner and mimic properties
		if(corner === FALSE || my === FALSE) {
			corner = FALSE;
		}
		else if(corner === TRUE) {
			corner = new CORNER( my.string() );
		}
		else if(!corner.string) {
			corner = new CORNER(corner);
			corner.fixed = TRUE;
		}

		return corner;
	},

	_parseWidth: function(corner, side, use) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(side) + 'Width';

		return (use ? intCss(use, prop) : (
			intCss(elements.content, prop) ||
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop)
		)) || 0;
	},

	_parseRadius: function(corner) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';

		return BROWSER.ie < 9 ? 0 :
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) || 
			intCss(elements.tooltip, prop) || 0;
	},

	_invalidColour: function(elem, prop, compare) {
		var val = elem.css(prop);
		return !val || (compare && val === elem.css(compare)) || INVALID.test(val) ? FALSE : val;
	},

	_parseColours: function(corner) {
		var elements = this.qtip.elements,
			tip = this.element.css('cssText', ''),
			borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
			colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
			css = this._invalidColour, color = [];

		// Attempt to detect the background colour from various elements, left-to-right precedance
		color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) || 
			css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);

		// Attempt to detect the correct border side colour from various elements, left-to-right precedance
		color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) || 
			css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);

		// Reset background and border colours
		$('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');

		return color;
	},

	_calculateSize: function(corner) {
		var y = corner.precedance === Y,
			width = this.options['width'],
			height = this.options['height'],
			isCenter = corner.abbrev() === 'c',
			base = (y ? width: height) * (isCenter ? 0.5 : 1),
			pow = Math.pow,
			round = Math.round,
			bigHyp, ratio, result,

		smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
		hyp = [ (this.border / base) * smallHyp, (this.border / height) * smallHyp ];

		hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
		hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );

		bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
		ratio = bigHyp / smallHyp;

		result = [ round(ratio * width), round(ratio * height) ];
		return y ? result : result.reverse();
	},

	// Tip coordinates calculator
	_calculateTip: function(corner, size, scale) {
		scale = scale || 1;
		size = size || this.size;

		var width = size[0] * scale,
			height = size[1] * scale,
			width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),

		// Define tip coordinates in terms of height and width values
		tips = {
			br:	[0,0,		width,height,	width,0],
			bl:	[0,0,		width,0,		0,height],
			tr:	[0,height,	width,0,		width,height],
			tl:	[0,0,		0,height,		width,height],
			tc:	[0,height,	width2,0,		width,height],
			bc:	[0,0,		width,0,		width2,height],
			rc:	[0,0,		width,height2,	0,height],
			lc:	[width,0,	width,height,	0,height2]
		};

		// Set common side shapes
		tips.lt = tips.br; tips.rt = tips.bl;
		tips.lb = tips.tr; tips.rb = tips.tl;

		return tips[ corner.abbrev() ];
	},

	// Tip coordinates drawer (canvas)
	_drawCoords: function(context, coords) {
		context.beginPath();
		context.moveTo(coords[0], coords[1]);
		context.lineTo(coords[2], coords[3]);
		context.lineTo(coords[4], coords[5]);
		context.closePath();
	},

	create: function() {
		// Determine tip corner
		var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);
		
		// If we have a tip corner...
		if( (this.enabled = !!this.corner && this.corner.abbrev() !== 'c') ) {
			// Cache it
			this.qtip.cache.corner = c.clone();

			// Create it
			this.update();
		}

		// Toggle tip element
		this.element.toggle(this.enabled);

		return this.corner;
	},

	update: function(corner, position) {
		if(!this.enabled) { return this; }

		var elements = this.qtip.elements,
			tip = this.element,
			inner = tip.children(),
			options = this.options,
			curSize = this.size,
			mimic = options.mimic,
			round = Math.round,
			color, precedance, context, scale, scaledSize,
			coords, bigCoords, translate, newSize, border, backingStoreRatio;

		// Re-determine tip if not already set
		if(!corner) { corner = this.qtip.cache.corner || this.corner; }

		// Use corner property if we detect an invalid mimic value
		if(mimic === FALSE) { mimic = corner; }

		// Otherwise inherit mimic properties from the corner object as necessary
		else {
			mimic = new CORNER(mimic);
			mimic.precedance = corner.precedance;

			if(mimic.x === 'inherit') { mimic.x = corner.x; }
			else if(mimic.y === 'inherit') { mimic.y = corner.y; }
			else if(mimic.x === mimic.y) {
				mimic[ corner.precedance ] = corner[ corner.precedance ];
			}
		}
		precedance = mimic.precedance;

		// Ensure the tip width.height are relative to the tip position
		if(corner.precedance === X) { this._swapDimensions(); }
		else { this._resetDimensions(); }

		// Update our colours
		color = this.color = this._parseColours(corner);

		// Detect border width, taking into account colours
		if(color[1] !== TRANSPARENT) {
			// Grab border width
			border = this.border = this._parseWidth(corner, corner[corner.precedance]);

			// If border width isn't zero, use border color as fill (1.0 style tips)
			if(options.border && border < 1) { color[0] = color[1]; }

			// Set border width (use detected border width if options.border is true)
			this.border = border = options.border !== TRUE ? options.border : border;
		}

		// Border colour was invalid, set border to zero
		else { this.border = border = 0; }

		// Determine tip size
		newSize = this.size = this._calculateSize(corner);
		tip.css({
			width: newSize[0],
			height: newSize[1],
			lineHeight: newSize[1]+'px'
		});

		// Calculate tip translation
		if(corner.precedance === Y) {
			translate = [
				round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
				round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
			];
		}
		else {
			translate = [
				round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
				round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
			];
		}

		// Canvas drawing implementation
		if(HASCANVAS) {
			// Grab canvas context and clear/save it
			context = inner[0].getContext('2d');
			context.restore(); context.save();
			context.clearRect(0,0,6000,6000);
			
			backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
			scale = PIXEL_RATIO / backingStoreRatio;

			// Calculate coordinates
			coords = this._calculateTip(mimic, curSize, scale);
			bigCoords = this._calculateTip(mimic, this.size, scale);

			// Set the canvas size using calculated size
			inner.attr(WIDTH, newSize[0] * scale).attr(HEIGHT, newSize[1] * scale);
			inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);

			// Draw the outer-stroke tip
			this._drawCoords(context, bigCoords);
			context.fillStyle = color[1];
			context.fill();

			// Draw the actual tip
			context.translate(translate[0] * scale, translate[1] * scale);
			this._drawCoords(context, coords);
			context.fillStyle = color[0];
			context.fill();
		}

		// VML (IE Proprietary implementation)
		else {
			// Calculate coordinates
			coords = this._calculateTip(mimic);

			// Setup coordinates string
			coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
				',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';

			// Setup VML-specific offset for pixel-perfection
			translate[2] = border && /^(r|b)/i.test(corner.string()) ?
				BROWSER.ie === 8 ? 2 : 1 : 0;

			// Set initial CSS
			inner.css({
				coordsize: (newSize[0]+border) + ' ' + (newSize[1]+border),
				antialias: ''+(mimic.string().indexOf(CENTER) > -1),
				left: translate[0] - (translate[2] * Number(precedance === X)),
				top: translate[1] - (translate[2] * Number(precedance === Y)),
				width: newSize[0] + border,
				height: newSize[1] + border
			})
			.each(function(i) {
				var $this = $(this);

				// Set shape specific attributes
				$this[ $this.prop ? 'prop' : 'attr' ]({
					coordsize: (newSize[0]+border) + ' ' + (newSize[1]+border),
					path: coords,
					fillcolor: color[0],
					filled: !!i,
					stroked: !i
				})
				.toggle(!!(border || i));

				// Check if border is enabled and add stroke element
				!i && $this.html( createVML(
					'stroke', 'weight="'+(border*2)+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
				) );
			});
		}

		// Opera bug #357 - Incorrect tip position
		// https://github.com/Craga89/qTip2/issues/367
		window.opera && setTimeout(function() {
			elements.tip.css({
				display: 'inline-block',
				visibility: 'visible'
			});
		}, 1);

		// Position if needed
		if(position !== FALSE) { this.calculate(corner, newSize); }
	},

	calculate: function(corner, size) {
		if(!this.enabled) { return FALSE; }

		var self = this,
			elements = this.qtip.elements,
			tip = this.element,
			userOffset = this.options.offset,
			isWidget = elements.tooltip.hasClass('ui-widget'),
			position = {  },
			precedance, corners;

		// Inherit corner if not provided
		corner = corner || this.corner;
		precedance = corner.precedance;

		// Determine which tip dimension to use for adjustment
		size = size || this._calculateSize(corner);

		// Setup corners and offset array
		corners = [ corner.x, corner.y ];
		if(precedance === X) { corners.reverse(); }

		// Calculate tip position
		$.each(corners, function(i, side) {
			var b, bc, br;

			if(side === CENTER) {
				b = precedance === Y ? LEFT : TOP;
				position[ b ] = '50%';
				position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
			}
			else {
				b = self._parseWidth(corner, side, elements.tooltip);
				bc = self._parseWidth(corner, side, elements.content);
				br = self._parseRadius(corner);

				position[ side ] = Math.max(-self.border, i ? bc : (userOffset + (br > b ? br : -b)));
			}
		});

		// Adjust for tip size
		position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];

		// Set and return new position
		tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
		return position;
	},

	reposition: function(event, api, pos, viewport) {
		if(!this.enabled) { return; }

		var cache = api.cache,
			newCorner = this.corner.clone(),
			adjust = pos.adjusted,
			method = api.options.position.adjust.method.split(' '),
			horizontal = method[0],
			vertical = method[1] || method[0],
			shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
			offset, css = {}, props;

		function shiftflip(direction, precedance, popposite, side, opposite) {
			// Horizontal - Shift or flip method
			if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
				newCorner.precedance = newCorner.precedance === X ? Y : X;
			}
			else if(direction !== SHIFT && adjust[side]){
				newCorner[precedance] = newCorner[precedance] === CENTER ? 
					(adjust[side] > 0 ? side : opposite) : (newCorner[precedance] === side ? opposite : side);
			}
		}

		function shiftonly(xy, side, opposite) {
			if(newCorner[xy] === CENTER) {
				css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
			}
			else {
				props = offset[opposite] !== undefined ?
					[ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];

				if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
					pos[side] -= adjust[side];
					shift[side] = FALSE;
				}
				
				css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
			}
		}

		// If our tip position isn't fixed e.g. doesn't adjust with viewport...
		if(this.corner.fixed !== TRUE) {
			// Perform shift/flip adjustments
			shiftflip(horizontal, X, Y, LEFT, RIGHT);
			shiftflip(vertical, Y, X, TOP, BOTTOM);

			// Update and redraw the tip if needed (check cached details of last drawn tip)
			if(newCorner.string() !== cache.corner.string() && (cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left)) {
				this.update(newCorner, FALSE);
			}
		}

		// Setup tip offset properties
		offset = this.calculate(newCorner);

		// Readjust offset object to make it left/top
		if(offset.right !== undefined) { offset.left = -offset.right; }
		if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
		offset.user = this.offset;

		// Perform shift adjustments
		if(shift.left = (horizontal === SHIFT && !!adjust.left)) { shiftonly(X, LEFT, RIGHT); }
		if(shift.top = (vertical === SHIFT && !!adjust.top)) { shiftonly(Y, TOP, BOTTOM); }

		/*
		* If the tip is adjusted in both dimensions, or in a
		* direction that would cause it to be anywhere but the
		* outer border, hide it!
		*/
		this.element.css(css).toggle(
			!((shift.x && shift.y) || (newCorner.x === CENTER && shift.y) || (newCorner.y === CENTER && shift.x))
		);

		// Adjust position to accomodate tip dimensions
		pos.left -= offset.left.charAt ? offset.user : 
			horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
		pos.top -= offset.top.charAt ? offset.user : 
			vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;

		// Cache details
		cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
		cache.corner = newCorner.clone();
	},

	destroy: function() {
		// Unbind events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Remove the tip element(s)
		if(this.qtip.elements.tip) {
			this.qtip.elements.tip.find('*')
				.remove().end().remove();
		}
	}
});

TIP = PLUGINS.tip = function(api) {
	return new Tip(api, api.options.style.tip);
};

// Initialize tip on render
TIP.initialize = 'render';

// Setup plugin sanitization options
TIP.sanitize = function(options) {
	if(options.style && 'tip' in options.style) {
		var opts = options.style.tip;
		if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
		if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
	}
};

// Add new option checks for the plugin
CHECKS.tip = {
	'^position.my|style.tip.(corner|mimic|border)$': function() {
		// Make sure a tip can be drawn
		this.create();
		
		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^style.tip.(height|width)$': function(obj) {
		// Re-set dimensions and redraw the tip
		this.size = [ obj.width, obj.height ];
		this.update();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^content.title|style.(classes|widget)$': function() {
		this.update();
	}
};

// Extend original qTip defaults
$.extend(TRUE, QTIP.defaults, {
	style: {
		tip: {
			corner: TRUE,
			mimic: FALSE,
			width: 6,
			height: 6,
			border: TRUE,
			offset: 0
		}
	}
});

;var MODAL, OVERLAY,
	MODALCLASS = 'qtip-modal',
	MODALSELECTOR = '.'+MODALCLASS;

OVERLAY = function()
{
	var self = this,
		focusableElems = {},
		current, onLast,
		prevState, elem;

	// Modified code from jQuery UI 1.10.0 source
	// http://code.jquery.com/ui/1.10.0/jquery-ui.js
	function focusable(element) {
		// Use the defined focusable checker when possible
		if($.expr[':'].focusable) { return $.expr[':'].focusable; }

		var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
			nodeName = element.nodeName && element.nodeName.toLowerCase(),
			map, mapName, img;

		if('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && img.is(':visible');
		}
		return (/input|select|textarea|button|object/.test( nodeName ) ?
				!element.disabled :
				'a' === nodeName ? 
					element.href || isTabIndexNotNaN : 
					isTabIndexNotNaN
			);
	}

	// Focus inputs using cached focusable elements (see update())
	function focusInputs(blurElems) {
		// Blurring body element in IE causes window.open windows to unfocus!
		if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }

		// Focus the inputs
		else { focusableElems.first().focus(); }
	}

	// Steal focus from elements outside tooltip
	function stealFocus(event) {
		if(!elem.is(':visible')) { return; }

		var target = $(event.target),
			tooltip = current.tooltip,
			container = target.closest(SELECTOR),
			targetOnTop;

		// Determine if input container target is above this
		targetOnTop = container.length < 1 ? FALSE :
			(parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10));

		// If we're showing a modal, but focus has landed on an input below
		// this modal, divert focus to the first visible input in this modal
		// or if we can't find one... the tooltip itself
		if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
			focusInputs(target);
		}

		// Detect when we leave the last focusable element...
		onLast = event.target === focusableElems[focusableElems.length - 1];
	}

	$.extend(self, {
		init: function() {
			// Create document overlay
			elem = self.elem = $('<div />', {
				id: 'qtip-overlay',
				html: '<div></div>',
				mousedown: function() { return FALSE; }
			})
			.hide();

			// Make sure we can't focus anything outside the tooltip
			$(document.body).bind('focusin'+MODALSELECTOR, stealFocus);

			// Apply keyboard "Escape key" close handler
			$(document).bind('keydown'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.escape && event.keyCode === 27) {
					current.hide(event);
				}
			});

			// Apply click handler for blur option
			elem.bind('click'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.blur) {
					current.hide(event);
				}
			});

			return self;
		},

		update: function(api) {
			// Update current API reference
			current = api;

			// Update focusable elements if enabled
			if(api.options.show.modal.stealfocus !== FALSE) {
				focusableElems = api.tooltip.find('*').filter(function() {
					return focusable(this);
				});
			}
			else { focusableElems = []; }
		},

		toggle: function(api, state, duration) {
			var docBody = $(document.body),
				tooltip = api.tooltip,
				options = api.options.show.modal,
				effect = options.effect,
				type = state ? 'show': 'hide',
				visible = elem.is(':visible'),
				visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip),
				zindex;

			// Set active tooltip API reference
			self.update(api);

			// If the modal can steal the focus...
			// Blur the current item and focus anything in the modal we an
			if(state && options.stealfocus !== FALSE) {
				focusInputs( $(':focus') );
			}

			// Toggle backdrop cursor style on show
			elem.toggleClass('blurs', options.blur);

			// Append to body on show
			if(state) {
				elem.appendTo(document.body);
			}

			// Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
			if((elem.is(':animated') && visible === state && prevState !== FALSE) || (!state && visibleModals.length)) {
				return self;
			}

			// Stop all animations
			elem.stop(TRUE, FALSE);

			// Use custom function if provided
			if($.isFunction(effect)) {
				effect.call(elem, state);
			}

			// If no effect type is supplied, use a simple toggle
			else if(effect === FALSE) {
				elem[ type ]();
			}

			// Use basic fade function
			else {
				elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
					if(!state) { elem.hide(); }
				});
			}

			// Reset position and detach from body on hide
			if(!state) {
				elem.queue(function(next) {
					elem.css({ left: '', top: '' });
					if(!$(MODALSELECTOR).length) { elem.detach(); }
					next();
				});
			}

			// Cache the state
			prevState = state;

			// If the tooltip is destroyed, set reference to null
			if(current.destroyed) { current = NULL; }

			return self;
		}
	});	

	self.init();
};
OVERLAY = new OVERLAY();

function Modal(api, options) {
	this.options = options;
	this._ns = '-modal';

	this.init( (this.qtip = api) );
}

$.extend(Modal.prototype, {
	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// If modal is disabled... return
		if(!this.options.on) { return this; }

		// Set overlay reference
		qtip.elements.overlay = OVERLAY.elem;

		// Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
		tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);
		
		// Apply our show/hide/focus modal events
		qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
			var oEvent = event.originalEvent;

			// Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
			if(event.target === tooltip[0]) {
				if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
					try { event.preventDefault(); } catch(e) {}
				}
				else if(!oEvent || (oEvent && !oEvent.solo)) {
					this.toggle(event, event.type === 'tooltipshow', duration);
				}
			}
		}, this._ns, this);

		// Adjust modal z-index on tooltip focus
		qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
			// If focus was cancelled before it reached us, don't do anything
			if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }

			var qtips = $(MODALSELECTOR),

			// Keep the modal's lower than other, regular qtips
			newIndex = QTIP.modal_zindex + qtips.length,
			curIndex = parseInt(tooltip[0].style.zIndex, 10);

			// Set overlay z-index
			OVERLAY.elem[0].style.zIndex = newIndex - 1;

			// Reduce modal z-index's and keep them properly ordered
			qtips.each(function() {
				if(this.style.zIndex > curIndex) {
					this.style.zIndex -= 1;
				}
			});

			// Fire blur event for focused tooltip
			qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;

			// Set current
			OVERLAY.update(api);

			// Prevent default handling
			try { event.preventDefault(); } catch(e) {}
		}, this._ns, this);

		// Focus any other visible modals when this one hides
		qtip._bind(tooltip, 'tooltiphide', function(event) {
			if(event.target === tooltip[0]) {
				$(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
			}
		}, this._ns, this);
	},

	toggle: function(event, state, duration) {
		// Make sure default event hasn't been prevented
		if(event && event.isDefaultPrevented()) { return this; }

		// Toggle it
		OVERLAY.toggle(this.qtip, !!state, duration);
	},

	destroy: function() {
		// Remove modal class
		this.qtip.tooltip.removeClass(MODALCLASS);

		// Remove bound events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Delete element reference
		OVERLAY.toggle(this.qtip, FALSE);
		delete this.qtip.elements.overlay;
	}
});


MODAL = PLUGINS.modal = function(api) {
	return new Modal(api, api.options.show.modal);
};

// Setup sanitiztion rules
MODAL.sanitize = function(opts) {
	if(opts.show) { 
		if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
		else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
	}
};

// Base z-index for all modal tooltips (use qTip core z-index as a base)
QTIP.modal_zindex = QTIP.zindex - 200;

// Plugin needs to be initialized on render
MODAL.initialize = 'render';

// Setup option set checks
CHECKS.modal = {
	'^show.modal.(on|blur)$': function() {
		// Initialise
		this.destroy();
		this.init();
		
		// Show the modal if not visible already and tooltip is visible
		this.qtip.elems.overlay.toggle(
			this.qtip.tooltip[0].offsetWidth > 0
		);
	}
};

// Extend original api defaults
$.extend(TRUE, QTIP.defaults, {
	show: {
		modal: {
			on: FALSE,
			effect: TRUE,
			blur: TRUE,
			stealfocus: TRUE,
			escape: TRUE
		}
	}
});
;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
{
	var target = posOptions.target,
		tooltip = api.elements.tooltip,
		my = posOptions.my,
		at = posOptions.at,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		methodX = method[0],
		methodY = method[1] || method[0],
		viewport = posOptions.viewport,
		container = posOptions.container,
		cache = api.cache,
		adjusted = { left: 0, top: 0 },
		fixed, newMy, newClass;

	// If viewport is not a jQuery element, or it's the window/document or no adjustment method is used... return
	if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
		return adjusted;
	}

	// Cache our viewport details
	fixed = tooltip.css('position') === 'fixed';
	viewport = {
		elem: viewport,
		width: viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE),
		height: viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE),
		scrollleft: fixed ? 0 : viewport.scrollLeft(),
		scrolltop: fixed ? 0 : viewport.scrollTop(),
		offset: viewport.offset() || { left: 0, top: 0 }
	};
	container = {
		elem: container,
		scrollLeft: container.scrollLeft(),
		scrollTop: container.scrollTop(),
		offset: container.offset() || { left: 0, top: 0 }
	};

	// Generic calculation method
	function calculate(side, otherSide, type, adjust, side1, side2, lengthName, targetLength, elemLength) {
		var initialPos = position[side1],
			mySide = my[side], atSide = at[side],
			isShift = type === SHIFT,
			viewportScroll = -container.offset[side1] + viewport.offset[side1] + viewport['scroll'+side1],
			myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
			atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
			overflow1 = viewportScroll - initialPos,
			overflow2 = initialPos + elemLength - viewport[lengthName] - viewportScroll,
			offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);

		// shift
		if(isShift) {
			offset = (mySide === side1 ? 1 : -1) * myLength;

			// Adjust position but keep it within viewport dimensions
			position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
			position[side1] = Math.max(
				-container.offset[side1] + viewport.offset[side1],
				initialPos - offset,
				Math.min(
					Math.max(-container.offset[side1] + viewport.offset[side1] + viewport[lengthName], initialPos + offset),
					position[side1]
				)
			);
		}

		// flip/flipinvert
		else {
			// Update adjustment amount depending on if using flipinvert or flip
			adjust *= (type === FLIPINVERT ? 2 : 0);

			// Check for overflow on the left/top
			if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
				position[side1] -= offset + adjust;
				newMy.invert(side, side1);
			}

			// Check for overflow on the bottom/right
			else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
				position[side1] -= (mySide === CENTER ? -offset : offset) + adjust;
				newMy.invert(side, side2);
			}

			// Make sure we haven't made things worse with the adjustment and reset if so
			if(position[side1] < viewportScroll && -position[side1] > overflow2) {
				position[side1] = initialPos; newMy = my.clone();
			}
		}

		return position[side1] - initialPos;
	}

	// Set newMy if using flip or flipinvert methods
	if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }

	// Adjust position based onviewport and adjustment options
	adjusted = {
		left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
		top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0
	};

	// Set tooltip position class if it's changed
	if(newMy && cache.lastClass !== (newClass = NAMESPACE + '-pos-' + newMy.abbrev())) {
		tooltip.removeClass(api.cache.lastClass).addClass( (api.cache.lastClass = newClass) );
	}

	return adjusted;
};;PLUGINS.polys = {
	// POLY area coordinate calculator
	//	Special thanks to Ed Cradock for helping out with this.
	//	Uses a binary search algorithm to find suitable coordinates.
	polygon: function(baseCoords, corner) {
		var result = {
			width: 0, height: 0,
			position: {
				top: 1e10, right: 0,
				bottom: 0, left: 1e10
			},
			adjustable: FALSE
		},
		i = 0, next,
		coords = [],
		compareX = 1, compareY = 1,
		realX = 0, realY = 0,
		newWidth, newHeight;

		// First pass, sanitize coords and determine outer edges
		i = baseCoords.length; while(i--) {
			next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];

			if(next[0] > result.position.right){ result.position.right = next[0]; }
			if(next[0] < result.position.left){ result.position.left = next[0]; }
			if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
			if(next[1] < result.position.top){ result.position.top = next[1]; }

			coords.push(next);
		}

		// Calculate height and width from outer edges
		newWidth = result.width = Math.abs(result.position.right - result.position.left);
		newHeight = result.height = Math.abs(result.position.bottom - result.position.top);

		// If it's the center corner...
		if(corner.abbrev() === 'c') {
			result.position = {
				left: result.position.left + (result.width / 2),
				top: result.position.top + (result.height / 2)
			};
		}
		else {
			// Second pass, use a binary search algorithm to locate most suitable coordinate
			while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
			{
				newWidth = Math.floor(newWidth / 2);
				newHeight = Math.floor(newHeight / 2);

				if(corner.x === LEFT){ compareX = newWidth; }
				else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
				else{ compareX += Math.floor(newWidth / 2); }

				if(corner.y === TOP){ compareY = newHeight; }
				else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
				else{ compareY += Math.floor(newHeight / 2); }

				i = coords.length; while(i--)
				{
					if(coords.length < 2){ break; }

					realX = coords[i][0] - result.position.left;
					realY = coords[i][1] - result.position.top;

					if((corner.x === LEFT && realX >= compareX) ||
					(corner.x === RIGHT && realX <= compareX) ||
					(corner.x === CENTER && (realX < compareX || realX > (result.width - compareX))) ||
					(corner.y === TOP && realY >= compareY) ||
					(corner.y === BOTTOM && realY <= compareY) ||
					(corner.y === CENTER && (realY < compareY || realY > (result.height - compareY)))) {
						coords.splice(i, 1);
					}
				}
			}
			result.position = { left: coords[0][0], top: coords[0][1] };
		}

		return result;
	},

	rect: function(ax, ay, bx, by) {
		return {
			width: Math.abs(bx - ax),
			height: Math.abs(by - ay),
			position: {
				left: Math.min(ax, bx),
				top: Math.min(ay, by)
			}
		};
	},

	_angles: {
		tc: 3 / 2, tr: 7 / 4, tl: 5 / 4, 
		bc: 1 / 2, br: 1 / 4, bl: 3 / 4, 
		rc: 2, lc: 1, c: 0
	},
	ellipse: function(cx, cy, rx, ry, corner) {
		var c = PLUGINS.polys._angles[ corner.abbrev() ],
			rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
			rys = ry * Math.sin( c * Math.PI );

		return {
			width: (rx * 2) - Math.abs(rxc),
			height: (ry * 2) - Math.abs(rys),
			position: {
				left: cx + rxc,
				top: cy + rys
			},
			adjustable: FALSE
		};
	},
	circle: function(cx, cy, r, corner) {
		return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
	}
};;PLUGINS.svg = function(api, svg, corner)
{
	var doc = $(document),
		elem = svg[0],
		root = $(elem.ownerSVGElement),
		xScale = 1, yScale = 1,
		complex = true,
		rootWidth, rootHeight,
		mtx, transformed, viewBox,
		len, next, i, points,
		result, position, dimensions;

	// Ascend the parentNode chain until we find an element with getBBox()
	while(!elem.getBBox) { elem = elem.parentNode; }
	if(!elem.getBBox || !elem.parentNode) { return FALSE; }

	// Determine dimensions where possible
	rootWidth = root.attr('width') || root.width() || parseInt(root.css('width'), 10);
	rootHeight = root.attr('height') || root.height() || parseInt(root.css('height'), 10);

	// Add stroke characteristics to scaling
	var strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2;
	if(strokeWidth2) {
		xScale += strokeWidth2 / rootWidth;
		yScale += strokeWidth2 / rootHeight;
	}

	// Determine which shape calculation to use
	switch(elem.nodeName) {
		case 'ellipse':
		case 'circle':
			result = PLUGINS.polys.ellipse(
				elem.cx.baseVal.value,
				elem.cy.baseVal.value,
				(elem.rx || elem.r).baseVal.value + strokeWidth2,
				(elem.ry || elem.r).baseVal.value + strokeWidth2,
				corner
			);
		break;

		case 'line':
		case 'polygon':
		case 'polyline':
			// Determine points object (line has none, so mimic using array)
			points = elem.points || [ 
				{ x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
				{ x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
			];

			for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
				next = points.getItem ? points.getItem(i) : points[i];
				result.push.apply(result, [next.x, next.y]);
			}

			result = PLUGINS.polys.polygon(result, corner);
		break;

		// Unknown shape or rectangle? Use bounding box
		default:
			result = elem.getBoundingClientRect();
			result = {
				width: result.width, height: result.height,
				position: {
					left: result.left,
					top: result.top
				}
			};
			complex = false;
		break;
	}

	// Shortcut assignments
	position = result.position;
	root = root[0];

	// If the shape was complex (i.e. not using bounding box calculations)
	if(complex) {
		// Convert position into a pixel value
		if(root.createSVGPoint) {
			mtx = elem.getScreenCTM();
			points = root.createSVGPoint();

			points.x = position.left;
			points.y = position.top;
			transformed = points.matrixTransform( mtx );
			position.left = transformed.x;
			position.top = transformed.y;
		}

		// Calculate viewBox characteristics
		if(root.viewBox && (viewBox = root.viewBox.baseVal) && viewBox.width && viewBox.height) {
			xScale *= rootWidth / viewBox.width;
			yScale *= rootHeight / viewBox.height;
		}
	}

	// Adjust by scroll offset
	position.left += doc.scrollLeft();
	position.top += doc.scrollTop();

	return result;
};;PLUGINS.imagemap = function(api, area, corner, adjustMethod)
{
	if(!area.jquery) { area = $(area); }

	var shape = area.attr('shape').toLowerCase().replace('poly', 'polygon'),
		image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
		coordsString = area.attr('coords'),
		coordsArray = coordsString.split(','),
		imageOffset, coords, i, next, result, len;

	// If we can't find the image using the map...
	if(!image.length) { return FALSE; }

	// Pass coordinates string if polygon
	if(shape === 'polygon') {
		result = PLUGINS.polys.polygon(coordsArray, corner);
	}

	// Otherwise parse the coordinates and pass them as arguments
	else if(PLUGINS.polys[shape]) {
		for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
			coords.push( parseInt(coordsArray[i], 10) );
		}

		result = PLUGINS.polys[shape].apply(
			this, coords.concat(corner)
		);
	}

	// If no shapre calculation method was found, return false
	else { return FALSE; }

	// Make sure we account for padding and borders on the image
	imageOffset = image.offset();
	imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
	imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);

	// Add image position to offset coordinates
	result.position.left += imageOffset.left;
	result.position.top += imageOffset.top;

	return result;
};;var IE6,

/* 
 * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
 * Special thanks to Brandon Aaron
 */
BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
	' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
		'-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';

function Ie6(api, qtip) {
	this._ns = 'ie6';
	this.init( (this.qtip = api) );
}

$.extend(Ie6.prototype, {
	_scroll : function() {
		var overlay = this.qtip.elements.overlay;
		overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
	},

	init: function(qtip) {
		var tooltip = qtip.tooltip,
			scroll;

		// Create the BGIFrame element if needed
		if($('select, object').length < 1) {
			this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);

			// Update BGIFrame on tooltip move
			qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
		}

		// redraw() container for width/height calculations
		this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
			.appendTo(document.body);

		// Fixup modal plugin if present too
		if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
			qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
			qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
		}

		// Set dimensions
		this.redraw();
	},

	adjustBGIFrame: function() {
		var tooltip = this.qtip.tooltip,
			dimensions = {
				height: tooltip.outerHeight(FALSE),
				width: tooltip.outerWidth(FALSE)
			},
			plugin = this.qtip.plugins.tip,
			tip = this.qtip.elements.tip,
			tipAdjust, offset;

		// Adjust border offset
		offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
		offset = { left: -offset, top: -offset };

		// Adjust for tips plugin
		if(plugin && tip) {
			tipAdjust = (plugin.corner.precedance === 'x') ? [WIDTH, LEFT] : [HEIGHT, TOP];
			offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
		}

		// Update bgiframe
		this.bgiframe.css(offset).css(dimensions);
	},

	// Max/min width simulator function
	redraw: function() {
		if(this.qtip.rendered < 1 || this.drawing) { return this; }

		var tooltip = this.qtip.tooltip,
			style = this.qtip.options.style,
			container = this.qtip.options.position.container,
			perc, width, max, min;

		// Set drawing flag
		this.qtip.drawing = 1;

		// If tooltip has a set height/width, just set it... like a boss!
		if(style.height) { tooltip.css(HEIGHT, style.height); }
		if(style.width) { tooltip.css(WIDTH, style.width); }

		// Simulate max/min width if not set width present...
		else {
			// Reset width and add fluid class
			tooltip.css(WIDTH, '').appendTo(this.redrawContainer);

			// Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
			width = tooltip.width();
			if(width % 2 < 1) { width += 1; }

			// Grab our max/min properties
			max = tooltip.css('maxWidth') || '';
			min = tooltip.css('minWidth') || '';

			// Parse into proper pixel values
			perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
		max = ((max.indexOf('%') > -1 ? perc : 1) * parseInt(max, 10)) || width;
			min = ((min.indexOf('%') > -1 ? perc : 1) * parseInt(min, 10)) || 0;

			// Determine new dimension size based on max/min/current values
			width = max + min ? Math.min(Math.max(width, min), max) : width;

			// Set the newly calculated width and remvoe fluid class
			tooltip.css(WIDTH, Math.round(width)).appendTo(container);
		}

		// Set drawing flag
		this.drawing = 0;

		return this;
	},

	destroy: function() {
		// Remove iframe
		this.bgiframe && this.bgiframe.remove();

		// Remove bound events
		this.qtip._unbind([window, this.qtip.tooltip], this._ns);
	}
});

IE6 = PLUGINS.ie6 = function(api) {
	// Proceed only if the browser is IE6
	return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
};

IE6.initialize = 'render';

CHECKS.ie6 = {
	'^content|style$': function() { 
		this.redraw();
	}
};;}));
}( window, document ));




requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('wavesCss.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*!
 * Waves v0.7.5
 * http://fian.my.id/Waves
 *
 * Copyright 2014-2016 Alfiana E. Sibuea and other contributors
 * Released under the MIT license
 * https://github.com/fians/Waves/blob/master/LICENSE
 */
!function(a,b){"use strict";"function"==typeof define&&define.amd?define('waves',[],function(){return b.apply(a)}):"object"==typeof exports?module.exports=b.call(a):a.Waves=b.call(a)}("object"==typeof global?global:this,function(){"use strict";function a(a){return null!==a&&a===a.window}function b(b){return a(b)?b:9===b.nodeType&&b.defaultView}function c(a){var b=typeof a;return"function"===b||"object"===b&&!!a}function d(a){return c(a)&&a.nodeType>0}function e(a){var b=m.call(a);return"[object String]"===b?l(a):c(a)&&/^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(b)&&a.hasOwnProperty("length")?a:d(a)?[a]:[]}function f(a){var c,d,e={top:0,left:0},f=a&&a.ownerDocument;return c=f.documentElement,"undefined"!=typeof a.getBoundingClientRect&&(e=a.getBoundingClientRect()),d=b(f),{top:e.top+d.pageYOffset-c.clientTop,left:e.left+d.pageXOffset-c.clientLeft}}function g(a){var b="";for(var c in a)a.hasOwnProperty(c)&&(b+=c+":"+a[c]+";");return b}function h(a,b,c){if(c){c.classList.remove("waves-rippling");var d=c.getAttribute("data-x"),e=c.getAttribute("data-y"),f=c.getAttribute("data-scale"),h=c.getAttribute("data-translate"),i=Date.now()-Number(c.getAttribute("data-hold")),j=350-i;0>j&&(j=0),"mousemove"===a.type&&(j=150);var k="mousemove"===a.type?2500:o.duration;setTimeout(function(){var a={top:e+"px",left:d+"px",opacity:"0","-webkit-transition-duration":k+"ms","-moz-transition-duration":k+"ms","-o-transition-duration":k+"ms","transition-duration":k+"ms","-webkit-transform":f+" "+h,"-moz-transform":f+" "+h,"-ms-transform":f+" "+h,"-o-transform":f+" "+h,transform:f+" "+h};c.setAttribute("style",g(a)),setTimeout(function(){try{b.removeChild(c)}catch(a){return!1}},k)},j)}}function i(a){if(q.allowEvent(a)===!1)return null;for(var b=null,c=a.target||a.srcElement;null!==c.parentElement;){if(c.classList.contains("waves-effect")&&!(c instanceof SVGElement)){b=c;break}c=c.parentElement}return b}function j(a){var b=i(a);if(null!==b){if(b.disabled||b.getAttribute("disabled")||b.classList.contains("disabled"))return;if(q.registerEvent(a),"touchstart"===a.type&&o.delay){var c=!1,d=setTimeout(function(){d=null,o.show(a,b)},o.delay),e=function(e){d&&(clearTimeout(d),d=null,o.show(a,b)),c||(c=!0,o.hide(e,b))},f=function(a){d&&(clearTimeout(d),d=null),e(a)};b.addEventListener("touchmove",f,!1),b.addEventListener("touchend",e,!1),b.addEventListener("touchcancel",e,!1)}else o.show(a,b),n&&(b.addEventListener("touchend",o.hide,!1),b.addEventListener("touchcancel",o.hide,!1)),b.addEventListener("mouseup",o.hide,!1),b.addEventListener("mouseleave",o.hide,!1)}}var k=k||{},l=document.querySelectorAll.bind(document),m=Object.prototype.toString,n="ontouchstart"in window,o={duration:750,delay:200,show:function(a,b,c){if(2===a.button)return!1;b=b||this;var d=document.createElement("div");d.className="waves-ripple waves-rippling",b.appendChild(d);var e=f(b),h=0,i=0;"touches"in a&&a.touches.length?(h=a.touches[0].pageY-e.top,i=a.touches[0].pageX-e.left):(h=a.pageY-e.top,i=a.pageX-e.left),i=i>=0?i:0,h=h>=0?h:0;var j="scale("+b.clientWidth/100*3+")",k="translate(0,0)";c&&(k="translate("+c.x+"px, "+c.y+"px)"),d.setAttribute("data-hold",Date.now()),d.setAttribute("data-x",i),d.setAttribute("data-y",h),d.setAttribute("data-scale",j),d.setAttribute("data-translate",k);var l={top:h+"px",left:i+"px"};d.classList.add("waves-notransition"),d.setAttribute("style",g(l)),d.classList.remove("waves-notransition"),l["-webkit-transform"]=j+" "+k,l["-moz-transform"]=j+" "+k,l["-ms-transform"]=j+" "+k,l["-o-transform"]=j+" "+k,l.transform=j+" "+k,l.opacity="1";var m="mousemove"===a.type?2500:o.duration;l["-webkit-transition-duration"]=m+"ms",l["-moz-transition-duration"]=m+"ms",l["-o-transition-duration"]=m+"ms",l["transition-duration"]=m+"ms",d.setAttribute("style",g(l))},hide:function(a,b){b=b||this;for(var c=b.getElementsByClassName("waves-rippling"),d=0,e=c.length;e>d;d++)h(a,b,c[d])}},p={input:function(a){var b=a.parentNode;if("i"!==b.tagName.toLowerCase()||!b.classList.contains("waves-effect")){var c=document.createElement("i");c.className=a.className+" waves-input-wrapper",a.className="waves-button-input",b.replaceChild(c,a),c.appendChild(a);var d=window.getComputedStyle(a,null),e=d.color,f=d.backgroundColor;c.setAttribute("style","color:"+e+";background:"+f),a.setAttribute("style","background-color:rgba(0,0,0,0);")}},img:function(a){var b=a.parentNode;if("i"!==b.tagName.toLowerCase()||!b.classList.contains("waves-effect")){var c=document.createElement("i");b.replaceChild(c,a),c.appendChild(a)}}},q={touches:0,allowEvent:function(a){var b=!0;return/^(mousedown|mousemove)$/.test(a.type)&&q.touches&&(b=!1),b},registerEvent:function(a){var b=a.type;"touchstart"===b?q.touches+=1:/^(touchend|touchcancel)$/.test(b)&&setTimeout(function(){q.touches&&(q.touches-=1)},500)}};return k.init=function(a){var b=document.body;a=a||{},"duration"in a&&(o.duration=a.duration),"delay"in a&&(o.delay=a.delay),n&&(b.addEventListener("touchstart",j,!1),b.addEventListener("touchcancel",q.registerEvent,!1),b.addEventListener("touchend",q.registerEvent,!1)),b.addEventListener("mousedown",j,!1)},k.attach=function(a,b){a=e(a),"[object Array]"===m.call(b)&&(b=b.join(" ")),b=b?" "+b:"";for(var c,d,f=0,g=a.length;g>f;f++)c=a[f],d=c.tagName.toLowerCase(),-1!==["input","img"].indexOf(d)&&(p[d](c),c=c.parentElement),-1===c.className.indexOf("waves-effect")&&(c.className+=" waves-effect"+b)},k.ripple=function(a,b){a=e(a);var c=a.length;if(b=b||{},b.wait=b.wait||0,b.position=b.position||null,c)for(var d,g,h,i={},j=0,k={type:"mousedown",button:1},l=function(a,b){return function(){o.hide(a,b)}};c>j;j++)if(d=a[j],g=b.position||{x:d.clientWidth/2,y:d.clientHeight/2},h=f(d),i.x=h.left+g.x,i.y=h.top+g.y,k.pageX=i.x,k.pageY=i.y,o.show(k,d),b.wait>=0&&null!==b.wait){var m={type:"mouseup",button:1};setTimeout(l(m,d),b.wait)}},k.calm=function(a){a=e(a);for(var b={type:"mouseup",button:1},c=0,d=a.length;d>c;c++)o.hide(b,a[c])},k.displayEffect=function(a){k.init(a)},k});
//# sourceMappingURL=waves.min.js.map;
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define('commons/public/bower_components/eventEmitter/EventEmitter',[],function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {



var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( 'commons/public/bower_components/eventie/eventie',eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

/*!
 * imagesLoaded v3.0.4
 * JavaScript is all like "You images are done yet or what?"
 */

( function( window ) {



var $ = window.jQuery;
var console = window.console;
var hasConsole = typeof console !== 'undefined';

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) === '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length === 'number' ) {
    // convert nodeList to array
    for ( var i=0, len = obj.length; i < len; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

// --------------------------  -------------------------- //

function defineImagesLoaded( EventEmitter, eventie ) {

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options );
    }
    // use elem as selector string
    if ( typeof elem === 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options === 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0, len = this.elements.length; i < len; i++ ) {
      var elem = this.elements[i];
      // filter siblings
      if ( elem.nodeName === 'IMG' ) {
        this.addImage( elem );
      }
      // find children
      var childElems = elem.querySelectorAll('img');
      // concat childElems to filterFound array
      for ( var j=0, jLen = childElems.length; j < jLen; j++ ) {
        var img = childElems[j];
        this.addImage( img );
      }
    }
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    var checkedCount = 0;
    var length = this.images.length;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !length ) {
      this.complete();
      return;
    }

    function onConfirm( image, message ) {
      if ( _this.options.debug && hasConsole ) {
        console.log( 'confirm', image, message );
      }

      _this.progress( image );
      checkedCount++;
      if ( checkedCount === length ) {
        _this.complete();
      }
      return true; // bind once
    }

    for ( var i=0; i < length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.on( 'confirm', onConfirm );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image ) {
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // HACK - Chrome triggers event before object properties have changed. #83
    var _this = this;
    setTimeout( function() {
      _this.emit( 'progress', _this, image );
      if ( _this.jqDeferred ) {
        _this.jqDeferred.notify( _this, image );
      }
    });
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    var _this = this;
    // HACK - another setTimeout so that confirm happens after progress
    setTimeout( function() {
      _this.emit( eventName, _this );
      _this.emit( 'always', _this );
      if ( _this.jqDeferred ) {
        var jqMethod = _this.hasAnyBroken ? 'reject' : 'resolve';
        _this.jqDeferred[ jqMethod ]( _this );
      }
    });
  };

  // -------------------------- jquery -------------------------- //

  if ( $ ) {
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  }


  // --------------------------  -------------------------- //

  var cache = {};

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // first check cached any previous images that have same src
    var cached = cache[ this.img.src ];
    if ( cached ) {
      this.useCached( cached );
      return;
    }
    // add this to cache
    cache[ this.img.src ] = this;

    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    if ( this.img.complete && this.img.naturalWidth !== undefined ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    var proxyImage = this.proxyImage = new Image();
    eventie.bind( proxyImage, 'load', this );
    eventie.bind( proxyImage, 'error', this );
    proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.useCached = function( cached ) {
    if ( cached.isConfirmed ) {
      this.confirm( cached.isLoaded, 'cached was confirmed' );
    } else {
      var _this = this;
      cached.on( 'confirm', function( image ) {
        _this.confirm( image.isLoaded, 'cache emitted confirmed' );
        return true; // bind once
      });
    }
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isConfirmed = true;
    this.isLoaded = isLoaded;
    this.emit( 'confirm', this, message );
  };

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindProxyEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindProxyEvents();
  };

  LoadingImage.prototype.unbindProxyEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
  };

  // -----  ----- //

  return ImagesLoaded;
}

// -------------------------- transport -------------------------- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( 'imagesloaded',[
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ],
    defineImagesLoaded );
} else {
  // browser global
  window.imagesLoaded = defineImagesLoaded(
    window.EventEmitter,
    window.eventie
  );
}

})( window );


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('commons/public/3rd-party/select2-3.4.5/select2.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*
Copyright 2012 Igor Vaynberg

Version: 3.4.5 Timestamp: Mon Nov  4 08:22:42 PST 2013

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

http://www.apache.org/licenses/LICENSE-2.0
http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the Apache License
or the GPL Licesnse is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
either express or implied. See the Apache License and the GPL License for the specific language governing
permissions and limitations under the Apache License and the GPL License.

TrustYou changelog:
WANALYTIC-4617: Hotel filter in Surveys not working in IE8
*/

(function(e){if(typeof e.fn.each2=="undefined"){e.extend(e.fn,{each2:function(t){var n=e([0]),r=-1,i=this.length;while(++r<i&&(n.context=n[0]=this[r])&&t.call(n[0],r,n)!==false);return this}})}})(jQuery);(function(e,t){"use strict";function p(e){var t,n,r,i;if(!e||e.length<1)return e;t="";for(n=0,r=e.length;n<r;n++){i=e.charAt(n);t+=h[i]||i}return t}function d(e,t){var n=0,r=t.length;for(;n<r;n=n+1){if(m(e,t[n]))return n}return-1}function v(){var t=e(c);t.appendTo("body");var n={width:t.width()-t[0].clientWidth,height:t.height()-t[0].clientHeight};t.remove();return n}function m(e,n){if(e===n)return true;if(e===t||n===t)return false;if(e===null||n===null)return false;if(e.constructor===String)return e+""===n+"";if(n.constructor===String)return n+""===e+"";return false}function g(t,n){var r,i,s;if(t===null||t.length<1)return[];r=t.split(n);for(i=0,s=r.length;i<s;i=i+1)r[i]=e.trim(r[i]);return r}function y(e){return e.outerWidth(false)-e.width()}function b(n){var r="keyup-change-value";n.on("keydown",function(){if(e.data(n,r)===t){e.data(n,r,n.val())}});n.on("keyup",function(){var i=e.data(n,r);if(i!==t&&n.val()!==i){e.removeData(n,r);n.trigger("keyup-change")}})}function w(n){n.on("mousemove",function(n){var r=a;if(r===t||r.x!==n.pageX||r.y!==n.pageY){e(n.target).trigger("mousemove-filtered",n)}})}function E(e,n,r){r=r||t;var i;return function(){var t=arguments;window.clearTimeout(i);i=window.setTimeout(function(){n.apply(r,t)},e)}}function S(e){var t=false,n;return function(){if(t===false){n=e();t=true}return n}}function x(e,t){var n=E(e,function(e){t.trigger("scroll-debounced",e)});t.on("scroll",function(e){if(d(e.target,t.get())>=0)n(e)})}function T(e){if(e[0]===document.activeElement)return;window.setTimeout(function(){var t=e[0],n=e.val().length,r;e.focus();if(e.is(":visible")&&t===document.activeElement){if(t.setSelectionRange){t.setSelectionRange(n,n)}else if(t.createTextRange){r=t.createTextRange();r.collapse(false);r.select()}}},0)}function N(t){t=e(t)[0];var n=0;var r=0;if("selectionStart"in t){n=t.selectionStart;r=t.selectionEnd-n}else if("selection"in document){t.focus();var i=document.selection.createRange();r=document.selection.createRange().text.length;i.moveStart("character",-t.value.length);n=i.text.length-r}return{offset:n,length:r}}function C(e){e.preventDefault();e.stopPropagation()}function k(e){e.preventDefault();e.stopImmediatePropagation()}function L(t){if(!u){var n=t[0].currentStyle||window.getComputedStyle(t[0],null);u=e(document.createElement("div")).css({position:"absolute",left:"-10000px",top:"-10000px",display:"none",fontSize:n.fontSize,fontFamily:n.fontFamily,fontStyle:n.fontStyle,fontWeight:n.fontWeight,letterSpacing:n.letterSpacing,textTransform:n.textTransform,whiteSpace:"nowrap"});u.attr("class","select2-sizer");e("body").append(u)}u.text(t.val());return u.width()}function A(t,n,r){var i,s=[],o;i=t.attr("class");if(i){i=""+i;e(i.split(" ")).each2(function(){if(this.indexOf("select2-")===0){s.push(this)}})}i=n.attr("class");if(i){i=""+i;e(i.split(" ")).each2(function(){if(this.indexOf("select2-")!==0){o=r(this);if(o){s.push(o)}}})}t.attr("class",s.join(" "))}function O(e,t,n,r){var i=p(e.toUpperCase()).indexOf(p(t.toUpperCase())),s=t.length;if(i<0){n.push(r(e));return}n.push(r(e.substring(0,i)));n.push("<span class='select2-match'>");n.push(r(e.substring(i,i+s)));n.push("</span>");n.push(r(e.substring(i+s,e.length)))}function M(e){var t={"\\":"&#92;","&":"&","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return String(e).replace(/[&<>"'\/\\]/g,function(e){return t[e]})}function _(n){var r,i=null,s=n.quietMillis||100,o=n.url,u=this;return function(a){window.clearTimeout(r);r=window.setTimeout(function(){var r=n.data,s=o,f=n.transport||e.fn.select2.ajaxDefaults.transport,l={type:n.type||"GET",cache:n.cache||false,jsonpCallback:n.jsonpCallback||t,dataType:n.dataType||"json"},c=e.extend({},e.fn.select2.ajaxDefaults.params,l);r=r?r.call(u,a.term,a.page,a.context):null;s=typeof s==="function"?s.call(u,a.term,a.page,a.context):s;if(i){i.abort()}if(n.params){if(e.isFunction(n.params)){e.extend(c,n.params.call(u))}else{e.extend(c,n.params)}}e.extend(c,{url:s,dataType:n.dataType,data:r,success:function(e){var t=n.results(e,a.page);a.callback(t)}});i=f.call(u,c)},s)}}function D(t){var n=t,r,i,s=function(e){return""+e.text};if(e.isArray(n)){i=n;n={results:i}}if(e.isFunction(n)===false){i=n;n=function(){return i}}var o=n();if(o.text){s=o.text;if(!e.isFunction(s)){r=o.text;s=function(e){return e[r]}}}return function(t){var r=t.term,i={results:[]},o;if(r===""){t.callback(n());return}o=function(n,i){var u,a;n=n[0];if(n.children){u={};for(a in n){if(n.hasOwnProperty(a))u[a]=n[a]}u.children=[];e(n.children).each2(function(e,t){o(t,u.children)});if(u.children.length||t.matcher(r,s(u),n)){i.push(u)}}else{if(t.matcher(r,s(n),n)){i.push(n)}}};e(n().results).each2(function(e,t){o(t,i.results)});t.callback(i)}}function P(n){var r=e.isFunction(n);return function(i){var s=i.term,o={results:[]};e(r?n():n).each(function(){var e=this.text!==t,n=e?this.text:this;if(s===""||i.matcher(s,n)){o.results.push(e?this:{id:this,text:this})}});i.callback(o)}}function H(t,n){if(e.isFunction(t))return true;if(!t)return false;throw new Error(n+" must be a function or a falsy value")}function B(t){return e.isFunction(t)?t():t}function j(t){var n=0;e.each(t,function(e,t){if(t.children){n+=j(t.children)}else{n++}});return n}function F(e,n,r,i){var s=e,o=false,u,a,f,l,c;if(!i.createSearchChoice||!i.tokenSeparators||i.tokenSeparators.length<1)return t;while(true){a=-1;for(f=0,l=i.tokenSeparators.length;f<l;f++){c=i.tokenSeparators[f];a=e.indexOf(c);if(a>=0)break}if(a<0)break;u=e.substring(0,a);e=e.substring(a+c.length);if(u.length>0){u=i.createSearchChoice.call(this,u,n);if(u!==t&&u!==null&&i.id(u)!==t&&i.id(u)!==null){o=false;for(f=0,l=n.length;f<l;f++){if(m(i.id(u),i.id(n[f]))){o=true;break}}if(!o)r(u)}}}if(s!==e)return e}function I(t,n){var r=function(){};r.prototype=new t;r.prototype.constructor=r;r.prototype.parent=t.prototype;r.prototype=e.extend(r.prototype,n);return r}if(window.Select2!==t){return}var n,r,i,s,o,u,a={x:0,y:0},f,l,n={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,isArrow:function(e){e=e.which?e.which:e;switch(e){case n.LEFT:case n.RIGHT:case n.UP:case n.DOWN:return true}return false},isControl:function(e){var t=e.which;switch(t){case n.SHIFT:case n.CTRL:case n.ALT:return true}if(e.metaKey)return true;return false},isFunctionKey:function(e){e=e.which?e.which:e;return e>=112&&e<=123}},c="<div class='select2-measure-scrollbar'></div>",h={"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z"};f=e(document);o=function(){var e=1;return function(){return e++}}();f.on("mousemove",function(e){a.x=e.pageX;a.y=e.pageY});r=I(Object,{bind:function(e){var t=this;return function(){e.apply(t,arguments)}},init:function(n){var r,i,s=".select2-results";this.opts=n=this.prepareOpts(n);this.id=n.id;if(n.element.data("select2")!==t&&n.element.data("select2")!==null){n.element.data("select2").destroy()}this.container=this.createContainer();this.containerId="s2id_"+(n.element.attr("id")||"autogen"+o());this.containerSelector="#"+this.containerId.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g,"\\$1");this.container.attr("id",this.containerId);this.body=S(function(){return n.element.closest("body")});A(this.container,this.opts.element,this.opts.adaptContainerCssClass);this.container.attr("style",n.element.attr("style"));this.container.css(B(n.containerCss));this.container.addClass(B(n.containerCssClass));this.elementTabIndex=this.opts.element.attr("tabindex");this.opts.element.data("select2",this).attr("tabindex","-1").before(this.container).on("click.select2",C);this.container.data("select2",this);this.dropdown=this.container.find(".select2-drop");A(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass);this.dropdown.addClass(B(n.dropdownCssClass));this.dropdown.data("select2",this);this.dropdown.on("click",C);this.results=r=this.container.find(s);this.search=i=this.container.find("input.select2-input");this.queryCount=0;this.resultsPage=0;this.context=null;this.initContainer();this.container.on("click",C);w(this.results);this.dropdown.on("mousemove-filtered touchstart touchmove touchend",s,this.bind(this.highlightUnderEvent));x(80,this.results);this.dropdown.on("scroll-debounced",s,this.bind(this.loadMoreIfNeeded));e(this.container).on("change",".select2-input",function(e){e.stopPropagation()});e(this.dropdown).on("change",".select2-input",function(e){e.stopPropagation()});if(e.fn.mousewheel){r.mousewheel(function(e,t,n,i){var s=r.scrollTop();if(i>0&&s-i<=0){r.scrollTop(0);C(e)}else if(i<0&&r.get(0).scrollHeight-r.scrollTop()+i<=r.height()){r.scrollTop(r.get(0).scrollHeight-r.height());C(e)}})}b(i);i.on("keyup-change input paste",this.bind(this.updateResults));i.on("focus",function(){i.addClass("select2-focused")});i.on("blur",function(){i.removeClass("select2-focused")});this.dropdown.on("mouseup",s,this.bind(function(t){if(e(t.target).closest(".select2-result-selectable").length>0){this.highlightUnderEvent(t);this.selectHighlighted(t)}}));this.dropdown.on("click mouseup mousedown",function(e){e.stopPropagation()});if(e.isFunction(this.opts.initSelection)){this.initSelection();this.monitorSource()}if(n.maximumInputLength!==null){this.search.attr("maxlength",n.maximumInputLength)}var u=n.element.prop("disabled");if(u===t)u=false;this.enable(!u);var a=n.element.prop("readonly");if(a===t)a=false;this.readonly(a);l=l||v();this.autofocus=n.element.prop("autofocus");n.element.prop("autofocus",false);if(this.autofocus)this.focus();this.nextSearchTerm=t},destroy:function(){var e=this.opts.element,n=e.data("select2");this.close();if(this.propertyObserver){delete this.propertyObserver;this.propertyObserver=null}if(n!==t){n.container.remove();n.dropdown.remove();e.removeClass("select2-offscreen").removeData("select2").off(".select2").prop("autofocus",this.autofocus||false);if(this.elementTabIndex){e.attr({tabindex:this.elementTabIndex})}else{e.removeAttr("tabindex")}e.show()}},optionToData:function(e){if(e.is("option")){return{id:e.prop("value"),text:e.text(),element:e.get(),css:e.attr("class"),disabled:e.prop("disabled"),locked:m(e.attr("locked"),"locked")||m(e.data("locked"),true)}}else if(e.is("optgroup")){return{text:e.attr("label"),children:[],element:e.get(),css:e.attr("class")}}},prepareOpts:function(n){var r,i,s,o,u=this;r=n.element;if(r.get(0).tagName.toLowerCase()==="select"){this.select=i=n.element}if(i){e.each(["id","multiple","ajax","query","createSearchChoice","initSelection","data","tags"],function(){if(this in n){throw new Error("Option '"+this+"' is not allowed for Select2 when attached to a <select> element.")}})}n=e.extend({},{populateResults:function(r,i,s){var o,a=this.opts.id;o=function(r,i,f){var l,c,h,p,d,v,m,g,y,b;r=n.sortResults(r,i,s);for(l=0,c=r.length;l<c;l=l+1){h=r[l];d=h.disabled===true;p=!d&&a(h)!==t;v=h.children&&h.children.length>0;m=e("<li></li>");m.addClass("select2-results-dept-"+f);m.addClass("select2-result");m.addClass(p?"select2-result-selectable":"select2-result-unselectable");if(d){m.addClass("select2-disabled")}if(v){m.addClass("select2-result-with-children")}m.addClass(u.opts.formatResultCssClass(h));g=e(document.createElement("div"));g.addClass("select2-result-label");b=n.formatResult(h,g,s,u.opts.escapeMarkup);if(b!==t){g.html(b)}m.append(g);if(v){y=e("<ul></ul>");y.addClass("select2-result-sub");o(h.children,y,f+1);m.append(y)}m.data("select2-data",h);i.append(m)}};o(i,r,0)}},e.fn.select2.defaults,n);if(typeof n.id!=="function"){s=n.id;n.id=function(e){return e[s]}}if(e.isArray(n.element.data("select2Tags"))){if("tags"in n){throw"tags specified as both an attribute 'data-select2-tags' and in options of Select2 "+n.element.attr("id")}n.tags=n.element.data("select2Tags")}if(i){n.query=this.bind(function(e){var n={results:[],more:false},i=e.term,s,o,a;a=function(t,n){var r;if(t.is("option")){if(e.matcher(i,t.text(),t)){n.push(u.optionToData(t))}}else if(t.is("optgroup")){r=u.optionToData(t);t.children().each2(function(e,t){a(t,r.children)});if(r.children.length>0){n.push(r)}}};s=r.children();if(this.getPlaceholder()!==t&&s.length>0){o=this.getPlaceholderOption();if(o){s=s.not(o)}}s.each2(function(e,t){a(t,n.results)});e.callback(n)});n.id=function(e){return e.id};n.formatResultCssClass=function(e){return e.css}}else{if(!("query"in n)){if("ajax"in n){o=n.element.data("ajax-url");if(o&&o.length>0){n.ajax.url=o}n.query=_.call(n.element,n.ajax)}else if("data"in n){n.query=D(n.data)}else if("tags"in n){n.query=P(n.tags);if(n.createSearchChoice===t){n.createSearchChoice=function(t){return{id:e.trim(t),text:e.trim(t)}}}if(n.initSelection===t){n.initSelection=function(t,r){var i=[];e(g(t.val(),n.separator)).each(function(){var t={id:this,text:this},r=n.tags;if(e.isFunction(r))r=r();e(r).each(function(){if(m(this.id,t.id)){t=this;return false}});i.push(t)});r(i)}}}}}if(typeof n.query!=="function"){throw"query function not defined for Select2 "+n.element.attr("id")}return n},monitorSource:function(){var e=this.opts.element,n,r;e.on("change.select2",this.bind(function(e){if(this.opts.element.data("select2-change-triggered")!==true){this.initSelection()}}));n=this.bind(function(){var n=e.prop("disabled");if(n===t)n=false;this.enable(!n);var r=e.prop("readonly");if(r===t)r=false;this.readonly(r);A(this.container,this.opts.element,this.opts.adaptContainerCssClass);this.container.addClass(B(this.opts.containerCssClass));A(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass);this.dropdown.addClass(B(this.opts.dropdownCssClass))});e.on("propertychange.select2",n);if(this.mutationCallback===t){this.mutationCallback=function(e){e.forEach(n)}}r=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;if(r!==t){if(this.propertyObserver){delete this.propertyObserver;this.propertyObserver=null}this.propertyObserver=new r(this.mutationCallback);this.propertyObserver.observe(e.get(0),{attributes:true,subtree:false})}},triggerSelect:function(t){var n=e.Event("select2-selecting",{val:this.id(t),object:t});this.opts.element.trigger(n);return!n.isDefaultPrevented()},triggerChange:function(t){t=t||{};t=e.extend({},t,{type:"change",val:this.val()});this.opts.element.data("select2-change-triggered",true);this.opts.element.trigger(t);this.opts.element.data("select2-change-triggered",false);this.opts.element.click();if(this.opts.blurOnChange)this.opts.element.blur()},isInterfaceEnabled:function(){return this.enabledInterface===true},enableInterface:function(){var e=this._enabled&&!this._readonly,t=!e;if(e===this.enabledInterface)return false;this.container.toggleClass("select2-container-disabled",t);this.close();this.enabledInterface=e;return true},enable:function(e){if(e===t)e=true;if(this._enabled===e)return;this._enabled=e;this.opts.element.prop("disabled",!e);this.enableInterface()},disable:function(){this.enable(false)},readonly:function(e){if(e===t)e=false;if(this._readonly===e)return false;this._readonly=e;this.opts.element.prop("readonly",e);this.enableInterface();return true},opened:function(){return this.container.hasClass("select2-dropdown-open")},positionDropdown:function(){var t=this.dropdown,n=this.container.offset(),r=this.container.outerHeight(false),i=this.container.outerWidth(false),s=t.outerHeight(false),o=e(window),u=o.width(),a=o.height(),f=o.scrollLeft()+u,c=o.scrollTop()+a,h=n.top+r,p=n.left,d=h+s<=c,v=n.top-s>=this.body().scrollTop(),m=t.outerWidth(false),g=p+m<=f,y=t.hasClass("select2-drop-above"),b,w,E,S,x;if(y){w=true;if(!v&&d){E=true;w=false}}else{w=false;if(!d&&v){E=true;w=true}}if(E){t.hide();n=this.container.offset();r=this.container.outerHeight(false);i=this.container.outerWidth(false);s=t.outerHeight(false);f=o.scrollLeft()+u;c=o.scrollTop()+a;h=n.top+r;p=n.left;m=t.outerWidth(false);g=p+m<=f;t.show()}if(this.opts.dropdownAutoWidth){x=e(".select2-results",t)[0];t.addClass("select2-drop-auto-width");t.css("width","");m=t.outerWidth(false)+(x.scrollHeight===x.clientHeight?0:l.width);m>i?i=m:m=i;g=p+m<=f}else{this.container.removeClass("select2-drop-auto-width")}if(this.body().css("position")!=="static"){b=this.body().offset();h-=b.top;p-=b.left}if(!g){p=n.left+i-m}S={left:p,width:i};if(w){S.bottom=a-n.top;S.top="auto";this.container.addClass("select2-drop-above");t.addClass("select2-drop-above")}else{S.top=h;S.bottom="auto";this.container.removeClass("select2-drop-above");t.removeClass("select2-drop-above")}S=e.extend(S,B(this.opts.dropdownCss));t.css(S)},shouldOpen:function(){var t;if(this.opened())return false;if(this._enabled===false||this._readonly===true)return false;t=e.Event("select2-opening");this.opts.element.trigger(t);return!t.isDefaultPrevented()},clearDropdownAlignmentPreference:function(){this.container.removeClass("select2-drop-above");this.dropdown.removeClass("select2-drop-above")},open:function(){if(!this.shouldOpen())return false;this.opening();return true},opening:function(){var t=this.containerId,n="scroll."+t,r="resize."+t,i="orientationchange."+t,s;this.container.addClass("select2-dropdown-open").addClass("select2-container-active");this.clearDropdownAlignmentPreference();if(this.dropdown[0]!==this.body().children().last()[0]){this.dropdown.detach().appendTo(this.body())}s=e("#select2-drop-mask");if(s.length==0){s=e(document.createElement("div"));s.attr("id","select2-drop-mask").attr("class","select2-drop-mask");s.hide();s.appendTo(this.body());s.on("mousedown touchstart click",function(t){var n=e("#select2-drop"),r;if(n.length>0){r=n.data("select2");if(r.opts.selectOnBlur){r.selectHighlighted({noFocus:true})}r.close({focus:true});t.preventDefault();t.stopPropagation()}})}if(this.dropdown.prev()[0]!==s[0]){this.dropdown.before(s)}e("#select2-drop").removeAttr("id");this.dropdown.attr("id","select2-drop");s.show();this.positionDropdown();this.dropdown.show();this.positionDropdown();this.dropdown.addClass("select2-drop-active");var o=this;this.container.parents().add(window).each(function(){e(this).on(r+" "+n+" "+i,function(e){o.positionDropdown()})})},close:function(){if(!this.opened())return;var t=this.containerId,n="scroll."+t,r="resize."+t,i="orientationchange."+t;this.container.parents().add(window).each(function(){e(this).off(n).off(r).off(i)});this.clearDropdownAlignmentPreference();e("#select2-drop-mask").hide();this.dropdown.removeAttr("id");this.dropdown.hide();this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");this.results.empty();this.clearSearch();this.search.removeClass("select2-active");this.opts.element.trigger(e.Event("select2-close"))},externalSearch:function(e){this.open();this.search.val(e);this.updateResults(false)},clearSearch:function(){},getMaximumSelectionSize:function(){return B(this.opts.maximumSelectionSize)},ensureHighlightVisible:function(){var t=this.results,n,r,i,s,o,u,a;r=this.highlight();if(r<0)return;if(r==0){t.scrollTop(0);return}n=this.findHighlightableChoices().find(".select2-result-label");i=e(n[r]);s=i.offset().top+i.outerHeight(true);if(r===n.length-1){a=t.find("li.select2-more-results");if(a.length>0){s=a.offset().top+a.outerHeight(true)}}o=t.offset().top+t.outerHeight(true);if(s>o){t.scrollTop(t.scrollTop()+(s-o))}u=i.offset().top-t.offset().top;if(u<0&&i.css("display")!="none"){t.scrollTop(t.scrollTop()+u)}},findHighlightableChoices:function(){return this.results.find(".select2-result-selectable:not(.select2-disabled, .select2-selected)")},moveHighlight:function(t){var n=this.findHighlightableChoices(),r=this.highlight();while(r>-1&&r<n.length){r+=t;var i=e(n[r]);if(i.hasClass("select2-result-selectable")&&!i.hasClass("select2-disabled")&&!i.hasClass("select2-selected")){this.highlight(r);break}}},highlight:function(t){var n=this.findHighlightableChoices(),r,i;if(arguments.length===0){return d(n.filter(".select2-highlighted")[0],n.get())}if(t>=n.length)t=n.length-1;if(t<0)t=0;this.removeHighlight();r=e(n[t]);r.addClass("select2-highlighted");this.ensureHighlightVisible();i=r.data("select2-data");if(i){this.opts.element.trigger({type:"select2-highlight",val:this.id(i),choice:i})}},removeHighlight:function(){this.results.find(".select2-highlighted").removeClass("select2-highlighted")},countSelectableResults:function(){return this.findHighlightableChoices().length},highlightUnderEvent:function(t){var n=e(t.target).closest(".select2-result-selectable");if(n.length>0&&!n.is(".select2-highlighted")){var r=this.findHighlightableChoices();this.highlight(r.index(n))}else if(n.length==0){this.removeHighlight()}},loadMoreIfNeeded:function(){var e=this.results,t=e.find("li.select2-more-results"),n,r=this.resultsPage+1,i=this,s=this.search.val(),o=this.context;if(t.length===0)return;n=t.offset().top-e.offset().top-e.height();if(n<=this.opts.loadMorePadding){t.addClass("select2-active");this.opts.query({element:this.opts.element,term:s,page:r,context:o,matcher:this.opts.matcher,callback:this.bind(function(n){if(!i.opened())return;i.opts.populateResults.call(this,e,n.results,{term:s,page:r,context:o});i.postprocessResults(n,false,false);if(n.more===true){t.detach().appendTo(e).text(i.opts.formatLoadMore(r+1));window.setTimeout(function(){i.loadMoreIfNeeded()},10)}else{t.remove()}i.positionDropdown();i.resultsPage=r;i.context=n.context;this.opts.element.trigger({type:"select2-loaded",items:n})})})}},tokenize:function(){},updateResults:function(n){function h(){r.removeClass("select2-active");u.positionDropdown()}function p(e){i.html(e);h()}var r=this.search,i=this.results,s=this.opts,o,u=this,a,f=r.val(),l=e.data(this.container,"select2-last-term"),c;if(n!==true&&l&&m(f,l))return;e.data(this.container,"select2-last-term",f);if(n!==true&&(this.showSearchInput===false||!this.opened())){return}c=++this.queryCount;var d=this.getMaximumSelectionSize();if(d>=1){o=this.data();if(e.isArray(o)&&o.length>=d&&H(s.formatSelectionTooBig,"formatSelectionTooBig")){p("<li class='select2-selection-limit'>"+s.formatSelectionTooBig(d)+"</li>");return}}if(r.val().length<s.minimumInputLength){if(H(s.formatInputTooShort,"formatInputTooShort")){p("<li class='select2-no-results'>"+s.formatInputTooShort(r.val(),s.minimumInputLength)+"</li>")}else{p("")}if(n&&this.showSearch)this.showSearch(true);return}if(s.maximumInputLength&&r.val().length>s.maximumInputLength){if(H(s.formatInputTooLong,"formatInputTooLong")){p("<li class='select2-no-results'>"+s.formatInputTooLong(r.val(),s.maximumInputLength)+"</li>")}else{p("")}return}if(s.formatSearching&&this.findHighlightableChoices().length===0){p("<li class='select2-searching'>"+s.formatSearching()+"</li>")}r.addClass("select2-active");this.removeHighlight();a=this.tokenize();if(a!=t&&a!=null){r.val(a)}this.resultsPage=1;s.query({element:s.element,term:r.val(),page:this.resultsPage,context:null,matcher:s.matcher,callback:this.bind(function(o){var a;if(c!=this.queryCount){return}if(!this.opened()){this.search.removeClass("select2-active");return}this.context=o.context===t?null:o.context;if(this.opts.createSearchChoice&&r.val()!==""){a=this.opts.createSearchChoice.call(u,r.val(),o.results);if(a!==t&&a!==null&&u.id(a)!==t&&u.id(a)!==null){if(e(o.results).filter(function(){return m(u.id(this),u.id(a))}).length===0){o.results.unshift(a)}}}if(o.results.length===0&&H(s.formatNoMatches,"formatNoMatches")){p("<li class='select2-no-results'>"+s.formatNoMatches(r.val())+"</li>");return}i.empty();u.opts.populateResults.call(this,i,o.results,{term:r.val(),page:this.resultsPage,context:null});if(o.more===true&&H(s.formatLoadMore,"formatLoadMore")){i.append("<li class='select2-more-results'>"+u.opts.escapeMarkup(s.formatLoadMore(this.resultsPage))+"</li>");window.setTimeout(function(){u.loadMoreIfNeeded()},10)}this.postprocessResults(o,n);h();this.opts.element.trigger({type:"select2-loaded",items:o})})})},cancel:function(){this.close()},blur:function(){if(this.opts.selectOnBlur)this.selectHighlighted({noFocus:true});this.close();this.container.removeClass("select2-container-active");if(this.search[0]===document.activeElement){this.search.blur()}this.clearSearch();this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus")},focusSearch:function(){T(this.search)},selectHighlighted:function(e){var t=this.highlight(),n=this.results.find(".select2-highlighted"),r=n.closest(".select2-result").data("select2-data");if(r){this.highlight(t);this.onSelect(r,e)}else if(e&&e.noFocus){this.close()}},getPlaceholder:function(){var e;return this.opts.element.attr("placeholder")||this.opts.element.attr("data-placeholder")||this.opts.element.data("placeholder")||this.opts.placeholder||((e=this.getPlaceholderOption())!==t?e.text():t)},getPlaceholderOption:function(){if(this.select){var e=this.select.children("option").first();if(this.opts.placeholderOption!==t){return this.opts.placeholderOption==="first"&&e||typeof this.opts.placeholderOption==="function"&&this.opts.placeholderOption(this.select)}else if(e.text()===""&&e.val()===""){return e}}},initContainerWidth:function(){function n(){var n,r,i,s,o,u;if(this.opts.width==="off"){return null}else if(this.opts.width==="element"){return this.opts.element.outerWidth(false)===0?"auto":this.opts.element.outerWidth(false)+"px"}else if(this.opts.width==="copy"||this.opts.width==="resolve"){n=this.opts.element.attr("style");if(n!==t){r=n.split(";");for(s=0,o=r.length;s<o;s=s+1){u=r[s].replace(/\s/g,"");i=u.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);if(i!==null&&i.length>=1)return i[1]}}if(this.opts.width==="resolve"){n=this.opts.element.css("width");if(n.indexOf("%")>0)return n;return this.opts.element.outerWidth(false)===0?"auto":this.opts.element.outerWidth(false)+"px"}return null}else if(e.isFunction(this.opts.width)){return this.opts.width()}else{return this.opts.width}}var r=n.call(this);if(r!==null){this.container.css("width",r)}}});i=I(r,{createContainer:function(){var t=e(document.createElement("div")).attr({"class":"select2-container"}).html(["<a href='javascript:void(0)' onclick='return false;' class='select2-choice' tabindex='-1'>","   <span class='select2-chosen'>&nbsp;</span><abbr class='select2-search-choice-close'></abbr>","   <span class='select2-arrow'><b></b></span>","</a>","<input class='select2-focusser select2-offscreen' type='text'/>","<div class='select2-drop select2-display-none'>","   <div class='select2-search'>","       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'/>","   </div>","   <ul class='select2-results'>","   </ul>","</div>"].join(""));return t},enableInterface:function(){if(this.parent.enableInterface.apply(this,arguments)){this.focusser.prop("disabled",!this.isInterfaceEnabled())}},opening:function(){var n,r,i;if(this.opts.minimumResultsForSearch>=0){this.showSearch(true)}this.parent.opening.apply(this,arguments);if(this.showSearchInput!==false){this.search.val(this.focusser.val())}this.search.focus();n=this.search.get(0);if(n.createTextRange){r=n.createTextRange();r.collapse(false);r.select()}else if(n.setSelectionRange){i=this.search.val().length;n.setSelectionRange(i,i)}if(this.search.val()===""){if(this.nextSearchTerm!=t){this.search.val(this.nextSearchTerm);this.search.select()}}this.focusser.prop("disabled",true).val("");this.updateResults(true);this.opts.element.trigger(e.Event("select2-open"))},close:function(e){if(!this.opened())return;this.parent.close.apply(this,arguments);e=e||{focus:true};this.focusser.removeAttr("disabled");if(e.focus){this.focusser.focus()}},focus:function(){if(this.opened()){this.close()}else{this.focusser.removeAttr("disabled");this.focusser.focus()}},isFocused:function(){return this.container.hasClass("select2-container-active")},cancel:function(){this.parent.cancel.apply(this,arguments);this.focusser.removeAttr("disabled");this.focusser.focus()},destroy:function(){e("label[for='"+this.focusser.attr("id")+"']").attr("for",this.opts.element.attr("id"));this.parent.destroy.apply(this,arguments)},initContainer:function(){var t,r=this.container,i=this.dropdown;if(this.opts.minimumResultsForSearch<0){this.showSearch(false)}else{this.showSearch(true)}this.selection=t=r.find(".select2-choice");this.focusser=r.find(".select2-focusser");this.focusser.attr("id","s2id_autogen"+o());e("label[for='"+this.opts.element.attr("id")+"']").attr("for",this.focusser.attr("id"));this.focusser.attr("tabindex",this.elementTabIndex);this.search.on("keydown",this.bind(function(e){if(!this.isInterfaceEnabled())return;if(e.which===n.PAGE_UP||e.which===n.PAGE_DOWN){C(e);return}switch(e.which){case n.UP:case n.DOWN:this.moveHighlight(e.which===n.UP?-1:1);C(e);return;case n.ENTER:this.selectHighlighted();C(e);return;case n.TAB:this.selectHighlighted({noFocus:true});return;case n.ESC:this.cancel(e);C(e);return}}));this.search.on("blur",this.bind(function(e){if(document.activeElement===this.body().get(0)){window.setTimeout(this.bind(function(){this.search.focus()}),0)}}));this.focusser.on("keydown",this.bind(function(e){if(!this.isInterfaceEnabled())return;if(e.which===n.TAB||n.isControl(e)||n.isFunctionKey(e)||e.which===n.ESC){return}if(this.opts.openOnEnter===false&&e.which===n.ENTER){C(e);return}if(e.which==n.DOWN||e.which==n.UP||e.which==n.ENTER&&this.opts.openOnEnter){if(e.altKey||e.ctrlKey||e.shiftKey||e.metaKey)return;this.open();C(e);return}if(e.which==n.DELETE||e.which==n.BACKSPACE){if(this.opts.allowClear){this.clear()}C(e);return}}));b(this.focusser);this.focusser.on("keyup-change input",this.bind(function(e){if(this.opts.minimumResultsForSearch>=0){e.stopPropagation();if(this.opened())return;this.open()}}));t.on("mousedown","abbr",this.bind(function(e){if(!this.isInterfaceEnabled())return;this.clear();k(e);this.close();this.selection.focus()}));t.on("mousedown",this.bind(function(t){if(!this.container.hasClass("select2-container-active")){this.opts.element.trigger(e.Event("select2-focus"))}if(this.opened()){this.close()}else if(this.isInterfaceEnabled()){this.open()}C(t)}));i.on("mousedown",this.bind(function(){this.search.focus()}));t.on("focus",this.bind(function(e){C(e)}));this.focusser.on("focus",this.bind(function(){if(!this.container.hasClass("select2-container-active")){this.opts.element.trigger(e.Event("select2-focus"))}this.container.addClass("select2-container-active")})).on("blur",this.bind(function(){if(!this.opened()){this.container.removeClass("select2-container-active");this.opts.element.trigger(e.Event("select2-blur"))}}));this.search.on("focus",this.bind(function(){if(!this.container.hasClass("select2-container-active")){this.opts.element.trigger(e.Event("select2-focus"))}this.container.addClass("select2-container-active")}));this.initContainerWidth();this.opts.element.addClass("select2-offscreen");this.setPlaceholder()},clear:function(t){var n=this.selection.data("select2-data");if(n){var r=e.Event("select2-clearing");this.opts.element.trigger(r);if(r.isDefaultPrevented()){return}var i=this.getPlaceholderOption();this.opts.element.val(i?i.val():"");this.selection.find(".select2-chosen").empty();this.selection.removeData("select2-data");this.setPlaceholder();if(t!==false){this.opts.element.trigger({type:"select2-removed",val:this.id(n),choice:n});this.triggerChange({removed:n})}}},initSelection:function(){var e;if(this.isPlaceholderOptionSelected()){this.updateSelection(null);this.close();this.setPlaceholder()}else{var n=this;this.opts.initSelection.call(null,this.opts.element,function(e){if(e!==t&&e!==null){n.updateSelection(e);n.close();n.setPlaceholder()}})}},isPlaceholderOptionSelected:function(){var e;if(!this.getPlaceholder())return false;return(e=this.getPlaceholderOption())!==t&&e.prop("selected")||this.opts.element.val()===""||this.opts.element.val()===t||this.opts.element.val()===null},prepareOpts:function(){var t=this.parent.prepareOpts.apply(this,arguments),n=this;if(t.element.get(0).tagName.toLowerCase()==="select"){t.initSelection=function(e,t){var r=e.find("option").filter(function(){return this.selected});t(n.optionToData(r))}}else if("data"in t){t.initSelection=t.initSelection||function(n,r){var i=n.val();var s=null;t.query({matcher:function(e,n,r){var o=m(i,t.id(r));if(o){s=r}return o},callback:!e.isFunction(r)?e.noop:function(){r(s)}})}}return t},getPlaceholder:function(){if(this.select){if(this.getPlaceholderOption()===t){return t}}return this.parent.getPlaceholder.apply(this,arguments)},setPlaceholder:function(){var e=this.getPlaceholder();if(this.isPlaceholderOptionSelected()&&e!==t){if(this.select&&this.getPlaceholderOption()===t)return;this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(e));this.selection.addClass("select2-default");this.container.removeClass("select2-allowclear")}},postprocessResults:function(e,t,n){var r=0,i=this,s=true;this.findHighlightableChoices().each2(function(e,t){if(m(i.id(t.data("select2-data")),i.opts.element.val())){r=e;return false}});if(n!==false){if(t===true&&r>=0){this.highlight(r)}else{this.highlight(0)}}if(t===true){var o=this.opts.minimumResultsForSearch;if(o>=0){this.showSearch(j(e.results)>=o)}}},showSearch:function(t){if(this.showSearchInput===t)return;this.showSearchInput=t;this.dropdown.find(".select2-search").toggleClass("select2-search-hidden",!t);this.dropdown.find(".select2-search").toggleClass("select2-offscreen",!t);e(this.dropdown,this.container).toggleClass("select2-with-searchbox",t)},onSelect:function(e,t){if(!this.triggerSelect(e)){return}var n=this.opts.element.val(),r=this.data();this.opts.element.val(this.id(e));this.updateSelection(e);this.opts.element.trigger({type:"select2-selected",val:this.id(e),choice:e});this.nextSearchTerm=this.opts.nextSearchTerm(e,this.search.val());this.close();if(!t||!t.noFocus)this.focusser.focus();if(!m(n,this.id(e))){this.triggerChange({added:e,removed:r})}},updateSelection:function(e){var n=this.selection.find(".select2-chosen"),r,i;this.selection.data("select2-data",e);n.empty();if(e!==null){r=this.opts.formatSelection(e,n,this.opts.escapeMarkup)}if(r!==t){n.append(r)}i=this.opts.formatSelectionCssClass(e,n);if(i!==t){n.addClass(i)}this.selection.removeClass("select2-default");if(this.opts.allowClear&&this.getPlaceholder()!==t){this.container.addClass("select2-allowclear")}},val:function(){var e,n=false,r=null,i=this,s=this.data();if(arguments.length===0){return this.opts.element.val()}e=arguments[0];if(arguments.length>1){n=arguments[1]}if(this.select){this.select.val(e).find("option").filter(function(){return this.selected}).each2(function(e,t){r=i.optionToData(t);return false});this.updateSelection(r);this.setPlaceholder();if(n){this.triggerChange({added:r,removed:s})}}else{if(!e&&e!==0){this.clear(n);return}if(this.opts.initSelection===t){throw new Error("cannot call val() if initSelection() is not defined")}this.opts.element.val(e);this.opts.initSelection(this.opts.element,function(e){i.opts.element.val(!e?"":i.id(e));i.updateSelection(e);i.setPlaceholder();if(n){i.triggerChange({added:e,removed:s})}})}},clearSearch:function(){this.search.val("");this.focusser.val("")},data:function(e){var n,r=false;if(arguments.length===0){n=this.selection.data("select2-data");if(n==t)n=null;return n}else{if(arguments.length>1){r=arguments[1]}if(!e){this.clear(r)}else{n=this.data();this.opts.element.val(!e?"":this.id(e));this.updateSelection(e);if(r){this.triggerChange({added:e,removed:n})}}}}});s=I(r,{createContainer:function(){var t=e(document.createElement("div")).attr({"class":"select2-container select2-container-multi"}).html(["<ul class='select2-choices'>","  <li class='select2-search-field'>","    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>","  </li>","</ul>","<div class='select2-drop select2-drop-multi select2-display-none'>","   <ul class='select2-results'>","   </ul>","</div>"].join(""));return t},prepareOpts:function(){var t=this.parent.prepareOpts.apply(this,arguments),n=this;if(t.element.get(0).tagName.toLowerCase()==="select"){t.initSelection=function(e,t){var r=[];e.find("option").filter(function(){return this.selected}).each2(function(e,t){r.push(n.optionToData(t))});t(r)}}else if("data"in t){t.initSelection=t.initSelection||function(n,r){var i=g(n.val(),t.separator);var s=[];t.query({matcher:function(n,r,o){var u=e.grep(i,function(e){return m(e,t.id(o))}).length;if(u){s.push(o)}return u},callback:!e.isFunction(r)?e.noop:function(){var e=[];for(var n=0;n<i.length;n++){var o=i[n];for(var u=0;u<s.length;u++){var a=s[u];if(m(o,t.id(a))){e.push(a);s.splice(u,1);break}}}r(e)}})}}return t},selectChoice:function(e){var t=this.container.find(".select2-search-choice-focus");if(t.length&&e&&e[0]==t[0]){}else{if(t.length){this.opts.element.trigger("choice-deselected",t)}t.removeClass("select2-search-choice-focus");if(e&&e.length){this.close();e.addClass("select2-search-choice-focus");this.opts.element.trigger("choice-selected",e)}}},destroy:function(){e("label[for='"+this.search.attr("id")+"']").attr("for",this.opts.element.attr("id"));this.parent.destroy.apply(this,arguments)},initContainer:function(){var t=".select2-choices",r;this.searchContainer=this.container.find(".select2-search-field");this.selection=r=this.container.find(t);var i=this;this.selection.on("click",".select2-search-choice:not(.select2-locked)",function(t){i.search[0].focus();i.selectChoice(e(this))});this.search.attr("id","s2id_autogen"+o());e("label[for='"+this.opts.element.attr("id")+"']").attr("for",this.search.attr("id"));this.search.on("input paste",this.bind(function(){if(!this.isInterfaceEnabled())return;if(!this.opened()){this.open()}}));this.search.attr("tabindex",this.elementTabIndex);this.keydowns=0;this.search.on("keydown",this.bind(function(e){if(!this.isInterfaceEnabled())return;++this.keydowns;var t=r.find(".select2-search-choice-focus");var i=t.prev(".select2-search-choice:not(.select2-locked)");var s=t.next(".select2-search-choice:not(.select2-locked)");var o=N(this.search);if(t.length&&(e.which==n.LEFT||e.which==n.RIGHT||e.which==n.BACKSPACE||e.which==n.DELETE||e.which==n.ENTER)){var u=t;if(e.which==n.LEFT&&i.length){u=i}else if(e.which==n.RIGHT){u=s.length?s:null}else if(e.which===n.BACKSPACE){this.unselect(t.first());this.search.width(10);u=i.length?i:s}else if(e.which==n.DELETE){this.unselect(t.first());this.search.width(10);u=s.length?s:null}else if(e.which==n.ENTER){u=null}this.selectChoice(u);C(e);if(!u||!u.length){this.open()}return}else if((e.which===n.BACKSPACE&&this.keydowns==1||e.which==n.LEFT)&&o.offset==0&&!o.length){this.selectChoice(r.find(".select2-search-choice:not(.select2-locked)").last());C(e);return}else{this.selectChoice(null)}if(this.opened()){switch(e.which){case n.UP:case n.DOWN:this.moveHighlight(e.which===n.UP?-1:1);C(e);return;case n.ENTER:this.selectHighlighted();C(e);return;case n.TAB:this.selectHighlighted({noFocus:true});this.close();return;case n.ESC:this.cancel(e);C(e);return}}if(e.which===n.TAB||n.isControl(e)||n.isFunctionKey(e)||e.which===n.BACKSPACE||e.which===n.ESC){return}if(e.which===n.ENTER){if(this.opts.openOnEnter===false){return}else if(e.altKey||e.ctrlKey||e.shiftKey||e.metaKey){return}}this.open();if(e.which===n.PAGE_UP||e.which===n.PAGE_DOWN){C(e)}if(e.which===n.ENTER){C(e)}}));this.search.on("keyup",this.bind(function(e){this.keydowns=0;this.resizeSearch()}));this.search.on("blur",this.bind(function(t){this.container.removeClass("select2-container-active");this.search.removeClass("select2-focused");this.selectChoice(null);if(!this.opened())this.clearSearch();t.stopImmediatePropagation();this.opts.element.trigger(e.Event("select2-blur"))}));this.container.on("click",t,this.bind(function(t){if(!this.isInterfaceEnabled())return;if(e(t.target).closest(".select2-search-choice").length>0){return}this.selectChoice(null);this.clearPlaceholder();if(!this.container.hasClass("select2-container-active")){this.opts.element.trigger(e.Event("select2-focus"))}this.open();this.focusSearch();t.preventDefault()}));this.container.on("focus",t,this.bind(function(){if(!this.isInterfaceEnabled())return;if(!this.container.hasClass("select2-container-active")){this.opts.element.trigger(e.Event("select2-focus"))}this.container.addClass("select2-container-active");this.dropdown.addClass("select2-drop-active");this.clearPlaceholder()}));this.initContainerWidth();this.opts.element.addClass("select2-offscreen");this.clearSearch()},enableInterface:function(){if(this.parent.enableInterface.apply(this,arguments)){this.search.prop("disabled",!this.isInterfaceEnabled())}},initSelection:function(){var e;if(this.opts.element.val()===""&&this.opts.element.text()===""){this.updateSelection([]);this.close();this.clearSearch()}if(this.select||this.opts.element.val()!==""){var n=this;this.opts.initSelection.call(null,this.opts.element,function(e){if(e!==t&&e!==null){n.updateSelection(e);n.close();n.clearSearch()}})}},clearSearch:function(){var e=this.getPlaceholder(),n=this.getMaxSearchWidth();if(e!==t&&this.getVal().length===0&&this.search.hasClass("select2-focused")===false){this.search.val(e).addClass("select2-default");this.search.width(n>0?n:this.container.css("width"))}else{this.search.val("").width(10)}},clearPlaceholder:function(){if(this.search.hasClass("select2-default")){this.search.val("").removeClass("select2-default")}},opening:function(){this.clearPlaceholder();this.resizeSearch();this.parent.opening.apply(this,arguments);this.focusSearch();this.updateResults(true);this.search.focus();this.opts.element.trigger(e.Event("select2-open"))},close:function(){if(!this.opened())return;this.parent.close.apply(this,arguments)},focus:function(){this.close();this.search.focus()},isFocused:function(){return this.search.hasClass("select2-focused")},updateSelection:function(t){var n=[],r=[],i=this;e(t).each(function(){if(d(i.id(this),n)<0){n.push(i.id(this));r.push(this)}});t=r;this.selection.find(".select2-search-choice").remove();e(t).each(function(){i.addSelectedChoice(this)});i.postprocessResults()},tokenize:function(){var e=this.search.val();e=this.opts.tokenizer.call(this,e,this.data(),this.bind(this.onSelect),this.opts);if(e!=null&&e!=t){this.search.val(e);if(e.length>0){this.open()}}},onSelect:function(e,t){if(!this.triggerSelect(e)){return}this.addSelectedChoice(e);this.opts.element.trigger({type:"selected",val:this.id(e),choice:e});if(this.select||!this.opts.closeOnSelect)this.postprocessResults(e,false,this.opts.closeOnSelect===true);if(this.opts.closeOnSelect){this.close();this.search.width(10)}else{if(this.countSelectableResults()>0){this.search.width(10);this.resizeSearch();if(this.getMaximumSelectionSize()>0&&this.val().length>=this.getMaximumSelectionSize()){this.updateResults(true)}this.positionDropdown()}else{this.close();this.search.width(10)}}this.triggerChange({added:e});if(!t||!t.noFocus)this.focusSearch()},cancel:function(){this.close();this.focusSearch()},addSelectedChoice:function(n){var r=!n.locked,i=e("<li class='select2-search-choice'>"+"    <div></div>"+"    <a href='#' onclick='return false;' class='select2-search-choice-close' tabindex='-1'></a>"+"</li>"),s=e("<li class='select2-search-choice select2-locked'>"+"<div></div>"+"</li>");var o=r?i:s,u=this.id(n),a=this.getVal(),f,l;f=this.opts.formatSelection(n,o.find("div"),this.opts.escapeMarkup);if(f!=t){o.find("div").replaceWith("<div>"+f+"</div>")}l=this.opts.formatSelectionCssClass(n,o.find("div"));if(l!=t){o.addClass(l)}if(r){o.find(".select2-search-choice-close").on("mousedown",C).on("click dblclick",this.bind(function(t){if(!this.isInterfaceEnabled())return;e(t.target).closest(".select2-search-choice").hide();this.unselect(e(t.target));this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");this.close();this.focusSearch();C(t)})).on("focus",this.bind(function(){if(!this.isInterfaceEnabled())return;this.container.addClass("select2-container-active");this.dropdown.addClass("select2-drop-active")}))}o.data("select2-data",n);o.insertBefore(this.searchContainer);a.push(u);this.setVal(a)},unselect:function(t){var n=this.getVal(),r,i;t=t.closest(".select2-search-choice");if(t.length===0){throw"Invalid argument: "+t+". Must be .select2-search-choice"}r=t.data("select2-data");if(!r){return}while((i=d(this.id(r),n))>=0){n.splice(i,1);this.setVal(n);if(this.select)this.postprocessResults()}var s=e.Event("select2-removing");s.val=this.id(r);s.choice=r;this.opts.element.trigger(s);if(s.isDefaultPrevented()){return}t.remove();this.opts.element.trigger({type:"select2-removed",val:this.id(r),choice:r});this.triggerChange({removed:r})},postprocessResults:function(e,t,n){var r=this.getVal(),i=this.results.find(".select2-result"),s=this.results.find(".select2-result-with-children"),o=this;i.each2(function(e,t){var n=o.id(t.data("select2-data"));if(d(n,r)>=0){t.addClass("select2-selected");t.find(".select2-result-selectable").addClass("select2-selected")}});s.each2(function(e,t){if(!t.is(".select2-result-selectable")&&t.find(".select2-result-selectable:not(.select2-selected)").length===0){t.addClass("select2-selected")}});if(this.highlight()==-1&&n!==false){o.highlight(0)}if(!this.opts.createSearchChoice&&!i.filter(".select2-result:not(.select2-selected)").length>0){if(!e||e&&!e.more&&this.results.find(".select2-no-results").length===0){if(H(o.opts.formatNoMatches,"formatNoMatches")){this.results.append("<li class='select2-no-results'>"+o.opts.formatNoMatches(o.search.val())+"</li>")}}}},getMaxSearchWidth:function(){return this.selection.width()-y(this.search)},resizeSearch:function(){var e,t,n,r,i,s=y(this.search);e=L(this.search)+10;t=this.search.offset().left;n=this.selection.width();r=this.selection.offset().left;i=n-(t-r)-s;if(i<e){i=n-s}if(i<40){i=n-s}if(i<=0){i=e}this.search.width(Math.floor(i))},getVal:function(){var e;if(this.select){e=this.select.val();return e===null?[]:e}else{e=this.opts.element.val();return g(e,this.opts.separator)}},setVal:function(t){var n;if(this.select){this.select.val(t)}else{n=[];e(t).each(function(){if(d(this,n)<0)n.push(this)});this.opts.element.val(n.length===0?"":n.join(this.opts.separator))}},buildChangeDetails:function(e,t){var t=t.slice(0),e=e.slice(0);for(var n=0;n<t.length;n++){for(var r=0;r<e.length;r++){if(m(this.opts.id(t[n]),this.opts.id(e[r]))){t.splice(n,1);if(n>0){n--}e.splice(r,1);r--}}}return{added:t,removed:e}},val:function(n,r){var i,s=this;if(arguments.length===0){return this.getVal()}i=this.data();if(!i.length)i=[];if(!n&&n!==0){this.opts.element.val("");this.updateSelection([]);this.clearSearch();if(r){this.triggerChange({added:this.data(),removed:i})}return}this.setVal(n);if(this.select){this.opts.initSelection(this.select,this.bind(this.updateSelection));if(r){this.triggerChange(this.buildChangeDetails(i,this.data()))}}else{if(this.opts.initSelection===t){throw new Error("val() cannot be called if initSelection() is not defined")}this.opts.initSelection(this.opts.element,function(t){var n=e.map(t,s.id);s.setVal(n);s.updateSelection(t);s.clearSearch();if(r){s.triggerChange(s.buildChangeDetails(i,s.data()))}})}this.clearSearch()},onSortStart:function(){if(this.select){throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.")}this.search.width(0);this.searchContainer.hide()},onSortEnd:function(){var t=[],n=this;this.searchContainer.show();this.searchContainer.appendTo(this.searchContainer.parent());this.resizeSearch();this.selection.find(".select2-search-choice").each(function(){t.push(n.opts.id(e(this).data("select2-data")))});this.setVal(t);this.triggerChange()},data:function(t,n){var r=this,i,s;if(arguments.length===0){return this.selection.find(".select2-search-choice").map(function(){return e(this).data("select2-data")}).get()}else{s=this.data();if(!t){t=[]}i=e.map(t,function(e){return r.opts.id(e)});this.setVal(i);this.updateSelection(t);this.clearSearch();if(n){this.triggerChange(this.buildChangeDetails(s,this.data()))}}}});e.fn.select2=function(){var n=Array.prototype.slice.call(arguments,0),r,o,u,a,f,l=["val","destroy","opened","open","close","focus","isFocused","container","dropdown","onSortStart","onSortEnd","enable","disable","readonly","positionDropdown","data","search"],c=["opened","isFocused","container","dropdown"],h=["val","data"],p={search:"externalSearch"};this.each(function(){if(n.length===0||typeof n[0]==="object"){r=n.length===0?{}:e.extend({},n[0]);r.element=e(this);if(r.element.get(0).tagName.toLowerCase()==="select"){f=r.element.prop("multiple")}else{f=r.multiple||false;if("tags"in r){r.multiple=f=true}}o=f?new s:new i;o.init(r)}else if(typeof n[0]==="string"){if(d(n[0],l)<0){throw"Unknown method: "+n[0]}a=t;o=e(this).data("select2");if(o===t)return;u=n[0];if(u==="container"){a=o.container}else if(u==="dropdown"){a=o.dropdown}else{if(p[u])u=p[u];a=o[u].apply(o,n.slice(1))}if(d(n[0],c)>=0||d(n[0],h)&&n.length==1){return false}}else{throw"Invalid arguments to select2 plugin: "+n}});return a===t?this:a};e.fn.select2.defaults={width:"copy",loadMorePadding:0,closeOnSelect:true,openOnEnter:true,containerCss:{},dropdownCss:{},containerCssClass:"",dropdownCssClass:"",formatResult:function(e,t,n,r){var i=[];O(e.text,n.term,i,r);return i.join("")},formatSelection:function(e,n,r){return e?r(e.text):t},sortResults:function(e,t,n){return e},formatResultCssClass:function(e){return t},formatSelectionCssClass:function(e,n){return t},formatNoMatches:function(){return"No matches found"},formatInputTooShort:function(e,t){var n=t-e.length;return"Please enter "+n+" more character"+(n==1?"":"s")},formatInputTooLong:function(e,t){var n=e.length-t;return"Please delete "+n+" character"+(n==1?"":"s")},formatSelectionTooBig:function(e){return"You can only select "+e+" item"+(e==1?"":"s")},formatLoadMore:function(e){return"Loading more results..."},formatSearching:function(){return"Searching..."},minimumResultsForSearch:0,minimumInputLength:0,maximumInputLength:null,maximumSelectionSize:0,id:function(e){return e.id},matcher:function(e,t){return p(""+t).toUpperCase().indexOf(p(""+e).toUpperCase())>=0},separator:",",tokenSeparators:[],tokenizer:F,escapeMarkup:M,blurOnChange:false,selectOnBlur:false,adaptContainerCssClass:function(e){return e},adaptDropdownCssClass:function(e){return null},nextSearchTerm:function(e,n){return t}};e.fn.select2.ajaxDefaults={transport:e.ajax,params:{type:"GET",cache:false,dataType:"json"}};window.Select2={query:{ajax:_,local:D,tags:P},util:{debounce:E,markMatch:O,escapeMarkup:M,stripDiacritics:p},"class":{"abstract":r,single:i,multi:s}}})(jQuery);
define("select2", ["jquery","css!commons/public/3rd-party/select2-3.4.5/select2"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.fn.select2;
    };
}(this)));

/* tooltipsy by Brian Cray
 * Lincensed under GPL2 - http://www.gnu.org/licenses/gpl-2.0.html
 * Option quick reference:
 * - alignTo: "element" or "cursor" (Defaults to "element")
 * - offset: Tooltipsy distance from element or mouse cursor, dependent on alignTo setting. Set as array [x, y] (Defaults to [0, -1])
 * - content: HTML or text content of tooltip. Defaults to "" (empty string), which pulls content from target element's title attribute
 * - show: function(event, tooltip) to show the tooltip. Defaults to a show(100) effect
 * - hide: function(event, tooltip) to hide the tooltip. Defaults to a fadeOut(100) effect
 * - delay: A delay in milliseconds before showing a tooltip. Set to 0 for no delay. Defaults to 200
 * - css: object containing CSS properties and values. Defaults to {} to use stylesheet for styles
 * - className: DOM class for styling tooltips with CSS. Defaults to "tooltipsy"
 * - showEvent: Set a custom event to bind the show function. Defaults to mouseenter
 * - hideEvent: Set a custom event to bind the show function. Defaults to mouseleave
 * Method quick reference:
 * - $('element').data('tooltipsy').show(): Force the tooltip to show
 * - $('element').data('tooltipsy').hide(): Force the tooltip to hide
 * - $('element').data('tooltipsy').destroy(): Remove tooltip from DOM
 * More information visit http://tooltipsy.com/
 */
;(function(a){a.tooltipsy=function(c,b){this.options=b;this.$el=a(c);this.title=this.$el.attr("title")||"";this.$el.attr("title","");this.random=parseInt(Math.random()*10000);this.ready=false;this.shown=false;this.width=0;this.height=0;this.delaytimer=null;this.$el.data("tooltipsy",this);this.init()};a.tooltipsy.prototype={init:function(){var e=this,d,b=e.$el,c=b[0];e.settings=d=a.extend({},e.defaults,e.options);d.delay=+d.delay;if(typeof d.content==="function"){e.readify()}if(d.showEvent===d.hideEvent&&d.showEvent==="click"){b.toggle(function(f){if(d.showEvent==="click"&&c.tagName=="A"){f.preventDefault()}if(d.delay>0){e.delaytimer=window.setTimeout(function(){e.show(f)},d.delay)}else{e.show(f)}},function(f){if(d.showEvent==="click"&&c.tagName=="A"){f.preventDefault()}window.clearTimeout(e.delaytimer);e.delaytimer=null;e.hide(f)})}else{b.bind(d.showEvent,function(f){if(d.showEvent==="click"&&c.tagName=="A"){f.preventDefault()}e.delaytimer=window.setTimeout(function(){e.show(f)},d.delay||0)}).bind(d.hideEvent,function(f){if(d.showEvent==="click"&&c.tagName=="A"){f.preventDefault()}window.clearTimeout(e.delaytimer);e.delaytimer=null;e.hide(f)})}},show:function(i){if(this.ready===false){this.readify()}var b=this,f=b.settings,h=b.$tipsy,k=b.$el,d=k[0],g=b.offset(d);if(b.shown===false){if((function(m){var l=0,e;for(e in m){if(m.hasOwnProperty(e)){l++}}return l})(f.css)>0){b.$tip.css(f.css)}b.width=h.outerWidth();b.height=h.outerHeight()}if(f.alignTo==="cursor"&&i){var j=[i.clientX+f.offset[0],i.clientY+f.offset[1]];if(j[0]+b.width>a(window).width()){var c={top:j[1]+"px",right:j[0]+"px",left:"auto"}}else{var c={top:j[1]+"px",left:j[0]+"px",right:"auto"}}}else{var j=[(function(){if(f.offset[0]<0){return g.left-Math.abs(f.offset[0])-b.width}else{if(f.offset[0]===0){return g.left-((b.width-k.outerWidth())/2)}else{return g.left+k.outerWidth()+f.offset[0]}}})(),(function(){if(f.offset[1]<0){return g.top-Math.abs(f.offset[1])-b.height}else{if(f.offset[1]===0){return g.top-((b.height-b.$el.outerHeight())/2)}else{return g.top+b.$el.outerHeight()+f.offset[1]}}})()]}h.css({top:j[1]+"px",left:j[0]+"px"});b.settings.show(i,h.stop(true,true))},hide:function(c){var b=this;if(b.ready===false){return}if(c&&c.relatedTarget===b.$tip[0]){b.$tip.bind("mouseleave",function(d){if(d.relatedTarget===b.$el[0]){return}b.settings.hide(d,b.$tipsy.stop(true,true))});return}b.settings.hide(c,b.$tipsy.stop(true,true))},readify:function(){this.ready=true;this.$tipsy=a('<div id="tooltipsy'+this.random+'" style="position:fixed;z-index:2147483647;display:none">').appendTo("body");this.$tip=a('<div class="'+this.settings.className+'">').appendTo(this.$tipsy);this.$tip.data("rootel",this.$el);var c=this.$el;var b=this.$tip;this.$tip.html(this.settings.content!=""?(typeof this.settings.content=="string"?this.settings.content:this.settings.content(c,b)):this.title)},offset:function(b){return this.$el[0].getBoundingClientRect()},destroy:function(){if(this.$tipsy){this.$tipsy.remove();a.removeData(this.$el,"tooltipsy")}},defaults:{alignTo:"element",offset:[0,-1],content:"",show:function(c,b){b.fadeIn(100)},hide:function(c,b){b.fadeOut(100)},css:{},className:"tooltipsy",delay:200,showEvent:"mouseenter",hideEvent:"mouseleave"}};a.fn.tooltipsy=function(b){return this.each(function(){new a.tooltipsy(this,b)})}})(jQuery);
define("tooltipsy", function(){});


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('commons/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, boss:true, undef:true, curly:true, browser:true, jquery:true */
/*
 * jQuery MultiSelect UI Widget 1.13
 * Copyright (c) 2012 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery 1.4.2+
 *   - jQuery UI 1.8 widget factory
 *
 * Optional:
 *   - jQuery UI effects
 *   - jQuery UI position utility
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
*/
(function($, undefined){

var multiselectID = 0;

$.widget("ech.multiselect", {

	// default options
	options: {
		header: true,
		height: 175,
		minWidth: 225,
		classes: '',
		checkAllText: 'Check all',
		uncheckAllText: 'Uncheck all',
		noneSelectedText: 'Select options',
		selectedText: '# selected',
		selectedList: 0,
		show: null,
		hide: null,
		autoOpen: false,
		multiple: true,
		position: {}
	},

	_create: function(){
		var el = this.element.hide(),
			o = this.options;

		this.speed = $.fx.speeds._default; // default speed for effects
		this._isOpen = false; // assume no

		var
			button = (this.button = $('<button type="button"><span class="ui-icon ui-icon-triangle-2-n-s"></span></button>'))
				.addClass('ui-multiselect ui-widget ui-state-default ui-corner-all')
				.addClass( o.classes )
				.attr({ 'title':el.attr('title'), 'aria-haspopup':true, 'tabIndex':el.attr('tabIndex') })
				.insertAfter( el ),

			buttonlabel = (this.buttonlabel = $('<span />'))
				.html( o.noneSelectedText )
				.appendTo( button ),

			menu = (this.menu = $('<div />'))
				.addClass('ui-multiselect-menu ui-widget ui-widget-content ui-corner-all')
				.addClass( o.classes )
				.appendTo( document.body ),

			header = (this.header = $('<div />'))
				.addClass('ui-widget-header ui-corner-all ui-multiselect-header ui-helper-clearfix')
				.appendTo( menu ),

			headerLinkContainer = (this.headerLinkContainer = $('<ul />'))
				.addClass('ui-helper-reset')
				.html(function(){
					if( o.header === true ){
						return '<li><a class="ui-multiselect-all" href="#"><span class="ui-icon ui-icon-check"></span><span>' + o.checkAllText + '</span></a></li><li><a class="ui-multiselect-none" href="#"><span class="ui-icon ui-icon-closethick"></span><span>' + o.uncheckAllText + '</span></a></li>';
					} else if(typeof o.header === "string"){
						return '<li>' + o.header + '</li>';
					} else {
						return '';
					}
				})
				.append('<li class="ui-multiselect-close"><a href="#" class="ui-multiselect-close"><span class="ui-icon ui-icon-circle-close"></span></a></li>')
				.appendTo( header ),

			checkboxContainer = (this.checkboxContainer = $('<ul />'))
				.addClass('ui-multiselect-checkboxes ui-helper-reset')
				.appendTo( menu );

		// perform event bindings
		this._bindEvents();

		// build menu
		this.refresh( true );

		// some addl. logic for single selects
		if( !o.multiple ){
			menu.addClass('ui-multiselect-single');
		}
	},

	_init: function(){
		if( this.options.header === false ){
			this.header.hide();
		}
		if( !this.options.multiple ){
			this.headerLinkContainer.find('.ui-multiselect-all, .ui-multiselect-none').hide();
		}
		if( this.options.autoOpen ){
			this.open();
		}
		if( this.element.is(':disabled') ){
			this.disable();
		}
	},

	refresh: function( init ){
		var el = this.element,
			o = this.options,
			menu = this.menu,
			checkboxContainer = this.checkboxContainer,
			optgroups = [],
			html = "",
			id = el.attr('id') || multiselectID++; // unique ID for the label & option tags

		// build items
		el.find('option').each(function( i ){
			var $this = $(this),
				parent = this.parentNode,
				title = this.innerHTML,
				description = this.title,
				value = this.value,
				inputID = 'ui-multiselect-' + (this.id || id + '-option-' + i),
				isDisabled = this.disabled,
				isSelected = this.selected,
				labelClasses = [ 'ui-corner-all' ],
				liClasses = (isDisabled ? 'ui-multiselect-disabled ' : ' ') + this.className,
				optLabel;

			// is this an optgroup?
			if( parent.tagName === 'OPTGROUP' ){
				optLabel = parent.getAttribute( 'label' );

				// has this optgroup been added already?
				if( $.inArray(optLabel, optgroups) === -1 ){
					html += '<li class="ui-multiselect-optgroup-label ' + parent.className + '"><a href="#">' + optLabel + '</a></li>';
					optgroups.push( optLabel );
				}
			}

			if( isDisabled ){
				labelClasses.push( 'ui-state-disabled' );
			}

			// browsers automatically select the first option
			// by default with single selects
			if( isSelected && !o.multiple ){
				labelClasses.push( 'ui-state-active' );
			}

			html += '<li class="' + liClasses + '">';

			// create the label
			html += '<label for="' + inputID + '" title="' + description + '" class="' + labelClasses.join(' ') + '">';
			html += '<input id="' + inputID + '" name="multiselect_' + id + '" type="' + (o.multiple ? "checkbox" : "radio") + '" value="' + value + '" title="' + title + '"';

			// pre-selected?
			if( isSelected ){
				html += ' checked="checked"';
				html += ' aria-selected="true"';
			}

			// disabled?
			if( isDisabled ){
				html += ' disabled="disabled"';
				html += ' aria-disabled="true"';
			}

			// add the title and close everything off
			html += ' /><span>' + title + '</span></label></li>';
		});

		// insert into the DOM
		checkboxContainer.html( html );

		// cache some moar useful elements
		this.labels = menu.find('label');
		this.inputs = this.labels.children('input');

		// set widths
		this._setButtonWidth();
		this._setMenuWidth();

		// remember default value
		this.button[0].defaultValue = this.update();

		// broadcast refresh event; useful for widgets
		if( !init ){
			this._trigger('refresh');
		}
	},

	// updates the button text. call refresh() to rebuild
	update: function(){
		var o = this.options,
			$inputs = this.inputs,
			$checked = $inputs.filter(':checked'),
			numChecked = $checked.length,
			value;

		if( numChecked === 0 ){
			value = o.noneSelectedText;
		} else {
			if($.isFunction( o.selectedText )){
				value = o.selectedText.call(this, numChecked, $inputs.length, $checked.get());
			} else if( /\d/.test(o.selectedList) && o.selectedList > 0 && numChecked <= o.selectedList){
				value = $checked.map(function(){ return $(this).next().html(); }).get().join(', ');
			} else {
				value = o.selectedText.replace('#', numChecked).replace('#', $inputs.length);
			}
		}

		this.buttonlabel.html( value );
		return value;
	},

	// binds events
	_bindEvents: function(){
		var self = this, button = this.button;

		function clickHandler(){
			self[ self._isOpen ? 'close' : 'open' ]();
			return false;
		}

		// webkit doesn't like it when you click on the span :(
		button
			.find('span')
			.bind('click.multiselect', clickHandler);

		// button events
		button.bind({
			click: clickHandler,
			keypress: function( e ){
				switch(e.which){
					case 27: // esc
					case 38: // up
					case 37: // left
						self.close();
						break;
					case 39: // right
					case 40: // down
						self.open();
						break;
				}
			},
			mouseenter: function(){
				if( !button.hasClass('ui-state-disabled') ){
					$(this).addClass('ui-state-hover');
				}
			},
			mouseleave: function(){
				$(this).removeClass('ui-state-hover');
			},
			focus: function(){
				if( !button.hasClass('ui-state-disabled') ){
					$(this).addClass('ui-state-focus');
				}
			},
			blur: function(){
				$(this).removeClass('ui-state-focus');
			}
		});

		// header links
		this.header
			.delegate('a', 'click.multiselect', function( e ){
				// close link
				if( $(this).hasClass('ui-multiselect-close') ){
					self.close();

				// check all / uncheck all
				} else {
					self[ $(this).hasClass('ui-multiselect-all') ? 'checkAll' : 'uncheckAll' ]();
				}

				e.preventDefault();
			});

		// optgroup label toggle support
		this.menu
			.delegate('li.ui-multiselect-optgroup-label a', 'click.multiselect', function( e ){
				e.preventDefault();

				var $this = $(this),
					$inputs = $this.parent().nextUntil('li.ui-multiselect-optgroup-label').find('input:visible:not(:disabled)'),
					nodes = $inputs.get(),
					label = $this.parent().text();

				// trigger event and bail if the return is false
				if( self._trigger('beforeoptgrouptoggle', e, { inputs:nodes, label:label }) === false ){
					return;
				}

				// toggle inputs
				self._toggleChecked(
					$inputs.filter(':checked').length !== $inputs.length,
					$inputs
				);

				self._trigger('optgrouptoggle', e, {
				    inputs: nodes,
				    label: label,
				    checked: nodes[0].checked
				});
			})
			.delegate('label', 'mouseenter.multiselect', function(){
				if( !$(this).hasClass('ui-state-disabled') ){
					self.labels.removeClass('ui-state-hover');
					$(this).addClass('ui-state-hover').find('input').focus();
				}
			})
			.delegate('label', 'keydown.multiselect', function( e ){
				e.preventDefault();

				switch(e.which){
					case 9: // tab
					case 27: // esc
						self.close();
						break;
					case 38: // up
					case 40: // down
					case 37: // left
					case 39: // right
						self._traverse(e.which, this);
						break;
					case 13: // enter
						$(this).find('input')[0].click();
						break;
				}
			})
			.delegate('input[type="checkbox"], input[type="radio"]', 'click.multiselect', function( e ){
				var $this = $(this),
					val = this.value,
					checked = this.checked,
					tags = self.element.find('option');

				// bail if this input is disabled or the event is cancelled
				if( this.disabled || self._trigger('click', e, { value: val, text: this.title, checked: checked }) === false ){
					e.preventDefault();
					return;
				}

				// make sure the input has focus. otherwise, the esc key
				// won't close the menu after clicking an item.
				$this.focus();

				// toggle aria state
				$this.attr('aria-selected', checked);

				// change state on the original option tags
				tags.each(function(){
					if( this.value === val ){
						this.selected = checked;
					} else if( !self.options.multiple ){
						this.selected = false;
					}
				});

				// some additional single select-specific logic
				if( !self.options.multiple ){
					self.labels.removeClass('ui-state-active');
					$this.closest('label').toggleClass('ui-state-active', checked );

					// close menu
					self.close();
				}

				// fire change on the select box
				self.element.trigger("change");

				// setTimeout is to fix multiselect issue #14 and #47. caused by jQuery issue #3827
				// http://bugs.jquery.com/ticket/3827
				setTimeout($.proxy(self.update, self), 10);
			});

		// close each widget when clicking on any other element/anywhere else on the page
		$(document).bind('mousedown.multiselect', function( e ){
			if(self._isOpen && !$.contains(self.menu[0], e.target) && !$.contains(self.button[0], e.target) && e.target !== self.button[0]){
				self.close();
			}
		});

		// deal with form resets.  the problem here is that buttons aren't
		// restored to their defaultValue prop on form reset, and the reset
		// handler fires before the form is actually reset.  delaying it a bit
		// gives the form inputs time to clear.
		$(this.element[0].form).bind('reset.multiselect', function(){
			setTimeout($.proxy(self.refresh, self), 10);
		});
	},

	// set button width
	_setButtonWidth: function(){
		var width = this.element.outerWidth(),
			o = this.options;

		if( /\d/.test(o.minWidth) && width < o.minWidth){
			width = o.minWidth;
		}

		// set widths
		this.button.width( width );
	},

	// set menu width
	_setMenuWidth: function(){
		var m = this.menu,
			width = this.button.outerWidth()-
				parseInt(m.css('padding-left'),10)-
				parseInt(m.css('padding-right'),10)-
				parseInt(m.css('border-right-width'),10)-
				parseInt(m.css('border-left-width'),10);

		m.width( width || this.button.outerWidth() );
	},

	// move up or down within the menu
	_traverse: function( which, start ){
		var $start = $(start),
			moveToLast = which === 38 || which === 37,

			// select the first li that isn't an optgroup label / disabled
			$next = $start.parent()[moveToLast ? 'prevAll' : 'nextAll']('li:not(.ui-multiselect-disabled, .ui-multiselect-optgroup-label)')[ moveToLast ? 'last' : 'first']();

		// if at the first/last element
		if( !$next.length ){
			var $container = this.menu.find('ul').last();

			// move to the first/last
			this.menu.find('label')[ moveToLast ? 'last' : 'first' ]().trigger('mouseover');

			// set scroll position
			$container.scrollTop( moveToLast ? $container.height() : 0 );

		} else {
			$next.find('label').trigger('mouseover');
		}
	},

	// This is an internal function to toggle the checked property and
	// other related attributes of a checkbox.
	//
	// The context of this function should be a checkbox; do not proxy it.
	_toggleState: function( prop, flag ){
		return function(){
			if( !this.disabled ) {
				this[ prop ] = flag;
			}

			if( flag ){
				this.setAttribute('aria-selected', true);
			} else {
				this.removeAttribute('aria-selected');
			}
		};
	},

	_toggleChecked: function( flag, group ){
		var $inputs = (group && group.length) ?  group : this.inputs,
			self = this;

		// toggle state on inputs
		$inputs.each(this._toggleState('checked', flag));

		// give the first input focus
		$inputs.eq(0).focus();

		// update button text
		this.update();

		// gather an array of the values that actually changed
		var values = $inputs.map(function(){
			return this.value;
		}).get();

		// toggle state on original option tags
		this.element
			.find('option')
			.each(function(){
				if( !this.disabled && $.inArray(this.value, values) > -1 ){
					self._toggleState('selected', flag).call( this );
				}
			});

		// trigger the change event on the select
		if( $inputs.length ) {
			this.element.trigger("change");
		}
	},

	_toggleDisabled: function( flag ){
		this.button
			.attr({ 'disabled':flag, 'aria-disabled':flag })[ flag ? 'addClass' : 'removeClass' ]('ui-state-disabled');

		var inputs = this.menu.find('input');
		var key = "ech-multiselect-disabled";

		if(flag) {
			// remember which elements this widget disabled (not pre-disabled)
			// elements, so that they can be restored if the widget is re-enabled.
			inputs = inputs.filter(':enabled')
				.data(key, true)
		} else {
			inputs = inputs.filter(function() {
				return $.data(this, key) === true;
			}).removeData(key);
		}

		inputs
			.attr({ 'disabled':flag, 'arial-disabled':flag })
			.parent()[ flag ? 'addClass' : 'removeClass' ]('ui-state-disabled');

		this.element
			.attr({ 'disabled':flag, 'aria-disabled':flag });
	},

	// open the menu
	open: function( e ){
		var self = this,
			button = this.button,
			menu = this.menu,
			speed = this.speed,
			o = this.options,
			args = [];

		// bail if the multiselectopen event returns false, this widget is disabled, or is already open
		if( this._trigger('beforeopen') === false || button.hasClass('ui-state-disabled') || this._isOpen ){
			return;
		}

		var $container = menu.find('ul').last(),
			effect = o.show,
			pos = button.offset();

		// figure out opening effects/speeds
		if( $.isArray(o.show) ){
			effect = o.show[0];
			speed = o.show[1] || self.speed;
		}

		// if there's an effect, assume jQuery UI is in use
		// build the arguments to pass to show()
		if( effect ) {
      args = [ effect, speed ];
		}

		// set the scroll of the checkbox container
		$container.scrollTop(0).height(o.height);

		// position and show menu
		if( $.ui.position && !$.isEmptyObject(o.position) ){
			o.position.of = o.position.of || button;

			menu
				.show()
				.position( o.position )
				.hide();

		// if position utility is not available...
		} else {
			menu.css({
				top: pos.top + button.outerHeight(),
				left: pos.left
			});
		}

		// show the menu, maybe with a speed/effect combo
		$.fn.show.apply(menu, args);

		// select the first option
		// triggering both mouseover and mouseover because 1.4.2+ has a bug where triggering mouseover
		// will actually trigger mouseenter.  the mouseenter trigger is there for when it's eventually fixed
		this.labels.eq(0).trigger('mouseover').trigger('mouseenter').find('input').trigger('focus');

		button.addClass('ui-state-active');
		this._isOpen = true;
		this._trigger('open');
	},

	// close the menu
	close: function(){
		if(this._trigger('beforeclose') === false){
			return;
		}

		var o = this.options,
		    effect = o.hide,
		    speed = this.speed,
		    args = [];

		// figure out opening effects/speeds
		if( $.isArray(o.hide) ){
			effect = o.hide[0];
			speed = o.hide[1] || this.speed;
		}

    if( effect ) {
      args = [ effect, speed ];
    }

    $.fn.hide.apply(this.menu, args);
		this.button.removeClass('ui-state-active').trigger('blur').trigger('mouseleave');
		this._isOpen = false;
		this._trigger('close');
	},

	enable: function(){
		this._toggleDisabled(false);
	},

	disable: function(){
		this._toggleDisabled(true);
	},

	checkAll: function( e ){
		this._toggleChecked(true);
		this._trigger('checkAll');
	},

	uncheckAll: function(){
		this._toggleChecked(false);
		this._trigger('uncheckAll');
	},

	getChecked: function(){
		return this.menu.find('input').filter(':checked');
	},

	destroy: function(){
		// remove classes + data
		$.Widget.prototype.destroy.call( this );

		this.button.remove();
		this.menu.remove();
		this.element.show();

		return this;
	},

	isOpen: function(){
		return this._isOpen;
	},

	widget: function(){
		return this.menu;
	},

	getButton: function(){
	  return this.button;
  },

	// react to option changes after initialization
	_setOption: function( key, value ){
		var menu = this.menu;

		switch(key){
			case 'header':
				menu.find('div.ui-multiselect-header')[ value ? 'show' : 'hide' ]();
				break;
			case 'checkAllText':
				menu.find('a.ui-multiselect-all span').eq(-1).text(value);
				break;
			case 'uncheckAllText':
				menu.find('a.ui-multiselect-none span').eq(-1).text(value);
				break;
			case 'height':
				menu.find('ul').last().height( parseInt(value,10) );
				break;
			case 'minWidth':
				this.options[ key ] = parseInt(value,10);
				this._setButtonWidth();
				this._setMenuWidth();
				break;
			case 'selectedText':
			case 'selectedList':
			case 'noneSelectedText':
				this.options[key] = value; // these all needs to update immediately for the update() call
				this.update();
				break;
			case 'classes':
				menu.add(this.button).removeClass(this.options.classes).addClass(value);
				break;
			case 'multiple':
				menu.toggleClass('ui-multiselect-single', !value);
				this.options.multiple = value;
				this.element[0].multiple = value;
				this.refresh();
		}

		$.Widget.prototype._setOption.apply( this, arguments );
	}
});

})(jQuery);

define("jquery.multiselect.raw", ["jquery","jquery-ui","css!commons/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.ech.multiselect;
    };
}(this)));


requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('commons/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.filter.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, boss:true, undef:true, curly:true, browser:true, jquery:true */
/*
 * jQuery MultiSelect UI Widget Filtering Plugin 1.5pre
 * Copyright (c) 2012 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery UI MultiSelect widget
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 */
(function($) {
  var rEscape = /[\-\[\]{}()*+?.,\\\^$|#\s]/g;

  $.widget('ech.multiselectfilter', {

    options: {
      label: 'Filter:',
      width: null, /* override default width set in css file (px). null will inherit */
      placeholder: 'Enter keywords',
      autoReset: false
    },

    _create: function() {
      var opts = this.options;
      var elem = $(this.element);

      // get the multiselect instance
      var instance = (this.instance = (elem.data('echMultiselect') || elem.data("multiselect") || elem.data("ech-multiselect")));

      // store header; add filter class so the close/check all/uncheck all links can be positioned correctly
      var header = (this.header = instance.menu.find('.ui-multiselect-header').addClass('ui-multiselect-hasfilter'));

      // wrapper elem
      var wrapper = (this.wrapper = $('<div class="ui-multiselect-filter">' + (opts.label.length ? opts.label : '') + '<input placeholder="'+opts.placeholder+'" type="search"' + (/\d/.test(opts.width) ? 'style="width:'+opts.width+'px"' : '') + ' /></div>').prependTo(this.header));

      // reference to the actual inputs
      this.inputs = instance.menu.find('input[type="checkbox"], input[type="radio"]');

      // build the input box
      this.input = wrapper.find('input').bind({
        keydown: function(e) {
          // prevent the enter key from submitting the form / closing the widget
          if(e.which === 13) {
            e.preventDefault();
          }
        },
        keyup: $.proxy(this._handler, this),
        click: $.proxy(this._handler, this)
      });

      // cache input values for searching
      this.updateCache();

      // rewrite internal _toggleChecked fn so that when checkAll/uncheckAll is fired,
      // only the currently filtered elements are checked
      instance._toggleChecked = function(flag, group) {
        var $inputs = (group && group.length) ?  group : this.labels.find('input');
        var _self = this;

        // do not include hidden elems if the menu isn't open.
        var selector = instance._isOpen ?  ':disabled, :hidden' : ':disabled';

        $inputs = $inputs
          .not(selector)
          .each(this._toggleState('checked', flag));

        // update text
        this.update();

        // gather an array of the values that actually changed
        var values = $inputs.map(function() {
          return this.value;
        }).get();

        // select option tags
        this.element.find('option').filter(function() {
          if(!this.disabled && $.inArray(this.value, values) > -1) {
            _self._toggleState('selected', flag).call(this);
          }
        });

        // trigger the change event on the select
        if($inputs.length) {
          this.element.trigger('change');
        }
      };

      // rebuild cache when multiselect is updated
      var doc = $(document).bind('multiselectrefresh', $.proxy(function() {
        this.updateCache();
        this._handler();
      }, this));

      // automatically reset the widget on close?
      if(this.options.autoReset) {
        doc.bind('multiselectclose', $.proxy(this._reset, this));
      }
    },

    // thx for the logic here ben alman
    _handler: function(e) {
      var term = $.trim(this.input[0].value.toLowerCase()),

      // speed up lookups
      rows = this.rows, inputs = this.inputs, cache = this.cache;

      if(!term) {
        rows.show();
      } else {
        rows.hide();

        var regex = new RegExp(term.replace(rEscape, "\\$&"), 'gi');

        this._trigger("filter", e, $.map(cache, function(v, i) {
          if(v.search(regex) !== -1) {
            rows.eq(i).show();
            return inputs.get(i);
          }

          return null;
        }));
      }

      // show/hide optgroups
      this.instance.menu.find(".ui-multiselect-optgroup-label").each(function() {
        var $this = $(this);
        var isVisible = $this.nextUntil('.ui-multiselect-optgroup-label').filter(function() {
          return $.css(this, "display") !== 'none';
        }).length;

        $this[isVisible ? 'show' : 'hide']();
      });
    },

    _reset: function() {
      this.input.val('').trigger('keyup');
    },

    updateCache: function() {
      // each list item
      this.rows = this.instance.menu.find(".ui-multiselect-checkboxes li:not(.ui-multiselect-optgroup-label)");

      // cache
      this.cache = this.element.children().map(function() {
        var elem = $(this);

        // account for optgroups
        if(this.tagName.toLowerCase() === "optgroup") {
          elem = elem.children();
        }

        return elem.map(function() {
          return this.innerHTML.toLowerCase();
        }).get();
      }).get();
    },

    widget: function() {
      return this.wrapper;
    },

    destroy: function() {
      $.Widget.prototype.destroy.call(this);
      this.input.val('').trigger("keyup");
      this.wrapper.remove();
    }
  });

})(jQuery);

define("jquery.multiselect.filter", ["jquery.multiselect.raw","css!commons/public/3rd-party/jquery.multiselect.1.13/jquery.multiselect.filter"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.ech.multiselectfilter;
    };
}(this)));

;(function (window, document, $) {
	"use strict";
	$.widget("ty.multiselectcustomfilter", $.ech.multiselectfilter, {
		options: {
			getMatches: null
		},

		_handler: function (e) {
			var term, cache, rows, inputs, matched;

			term = $.trim(this.input[0].value.toLowerCase());
			if (term && typeof this.options.getMatches === "function") {
				cache = this.cache;
				rows = this.rows;
				inputs = this.inputs;
				rows.hide();
				matched = this.options.getMatches(term, cache).map(function (i) {
					rows.eq(i).show();
					return inputs[i];
				});
				this._trigger("filter", e, matched);
				// show/hide optgroups
				this.instance.menu.find(".ui-multiselect-optgroup-label").each(function() {
					var $this, isVisible;
					$this = $(this);
					isVisible = $this.nextUntil('.ui-multiselect-optgroup-label').filter(function () {
						return $.css(this, "display") !== 'none';
					}).length;

					$this[isVisible ? 'show' : 'hide']();
				});
			} else {
				$.ech.multiselectfilter.prototype._handler.call(this, e);
			}
		}
	});
}(window, document, jQuery));
define("jquery.multiselect", ["jquery.multiselect.filter"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.jQuery.ty.multiselectcustomfilter;
    };
}(this)));

/*!
 * jQuery Feeds v0.5
 * https://camagu.github.com/jquery-feeds
 * 
 * Copyright (c) 2012, Camilo Aguilar
 * Dual licensed under the MIT and GPL licenses:
 *     http://www.opensource.org/licenses/mit-license.php
 *     http://www.gnu.org/licenses/gpl.html
 * 
 * Includes a modified version of Simple JavaScript Templating
 * http://ejohn.org/blog/javascript-micro-templating/
 * Copyright (c) John Resig (http://ejohn.org)
 * MIT licensed
 * 
 * Date: 2012-07-12
 */

/*jshint evil: true */
( function( $ ) {
	
	var cache = {};
	
	$.fn.feeds = function( options ) {

		var engine = {
			service: '/feed/load?v=1.0',
			
			settings: {
				loadingTemplate: '<p class="feeds-loader">Loading entries ...</p>',
				entryTemplate:	'<div class="feeds-entry feeds-source-<!=source!>">' + 
								'<a class="feed-entry-title" target="_blank" href="<!=link!>" title="<!=title!>"><!=title!></a>' +
								'<div class="feed-entry-date"><!=publishedDate!></div>' + 
								'<div class="feed-entry-content"><!=contentSnippet!></div>' + 
								'</div>',
				feeds: {},
				max: -1,
				ssl: 'auto',
				onComplete: function( entries ) {

				},
				preprocess: function( entry, feed ) {

				}
			},
			
			feeds: { },
			entries: [ ],
			
			feedsLength: 0,
			feedsLoaded: 0,
			
			$element: null,
			$loader: null,
			
			init: function( element, options ) {
				this.settings = $.extend( this.settings, options );
				this.feeds = this.settings.feeds;
				
				for ( var i in this.feeds ) {
					if ( this.feeds.hasOwnProperty( i ) ) {
						this.feedsLength++;
					}
				}
				
				var protocol = this.settings.ssl === 'auto' ? document.location.protocol : this.settings.ssl ? 'https:' : 'http:';
				if ( $.inArray( protocol, [ 'http:', 'https' ]) === -1 ) {
					protocol = 'https:';
				}
				
				this.service = protocol + this.service;
				
				this.$element = $( element );
				
				var render = typeof this.settings.loadingTemplate === 'function' ? this.settings.loadingTemplate : this.tmpl( this.settings.loadingTemplate );
				this.$loader = $( render.call( this, { } ) );
				this.$element.html( this.$loader );
				
				for ( var j in this.feeds ) {
					this.fetchFeed( j, this.feeds[ j ], this.settings.max );
				}
			},
			
			fetchFeed: function( key, feed, max ) {
				var self = this;
				
				var cacheKey = feed + '**' + max;
				if ( typeof cache[ cacheKey ] !== 'undefined' ) {
					self.processResponse( cache[ cacheKey ], key, feed );
					return;
				}
				
				$.ajax( {
					url: this.service,
					dataType: 'jsonp',
					data: {
						q: feed,
						num: max
					},
					beforeSend: function( ) {
						this.feed = feed;
						this.key = key;
					},
					success: function( data ) {
						cache[ cacheKey ] = data;
						self.processResponse( data, this.key, this.feed );
					}
				} );
			},
			
			processResponse: function( data, key, feed ) {
				if ( data.responseStatus !== 200 ) {
					if ( window.console && window.console.log ) {
						console.log( 'Unable to load feed ' + feed + ': (' + data.responseStatus + ') ' + data.responseDetails );
					}
				} else {
					var feedEntries = data.responseData.feed.entries;
					
					for ( var i in feedEntries ) {
						var entry = $.extend( {}, feedEntries[ i ] );
						entry.source = key;
						entry.publishedDateRaw = entry.publishedDate;
						
						entry.feedUrl = data.responseData.feed.feedUrl;
						entry.feedTitle = data.responseData.feed.title;
						entry.feedLink = data.responseData.feed.link;
						entry.feedDescription = data.responseData.feed.description;
						entry.feedAuthor = data.responseData.feed.author;
						
						this.settings.preprocess.call( entry, data.responseData.feed );
						
						this.entries.push( entry );
					}
				}
				
				this.feedsLoaded++;
				this.checkComplete();
			},
			
			checkComplete: function( ) {
				if ( this.feedsLoaded === this.feedsLength ) {
					this.$loader.remove( );
					
					this.entries.sort( function( a, b) {
						var aDate = new Date( a.publishedDateRaw ).getTime( );
						var bDate = new Date( b.publishedDateRaw ).getTime( );

						return bDate - aDate;
					} );
					
					var render = typeof this.settings.entryTemplate === 'function' ? this.settings.entryTemplate : this.tmpl( this.settings.entryTemplate );
					
					for ( var i in this.entries ) {
						var entry = this.entries[ i ];
						
						var html = render.call( this, entry );
						
						this.$element.append( html );
					}
					
					this.settings.onComplete.call( this.$element[ 0 ], this.entries );
				}
			},
			

			// Simple JavaScript Templating (modified)
			// John Resig - http://ejohn.org/ - MIT Licensed
			// @see http://ejohn.org/blog/javascript-micro-templating/
			tmplCache: {},
			tmpl: function tmpl( str, data ) {

				var fn = !/\W/.test( str ) ? this.tmplCache[ str ] = this.tmplCache[ str ] || this.tmpl( document.getElementById( str ).innerHTML ) :

				new Function( "obj",
					"var p=[],print=function(){p.push.apply(p,arguments);};" +

					"with(obj){p.push('" +
					str
						.replace( /[\r\t\n]/g, " " )
						.split( "<!" ).join( "\t" )
						.replace( /((^|!>)[^\t]*)'/g, "$1\r" )
						.replace( /\t=(.*?)!>/g, "',typeof $1 != 'undefined' ? $1 : '','" )
						.split( "\t" ).join( "');" )
						.split( "!>" ).join( "p.push('" )
						.split( "\r" ).join( "\\'" ) +
					"');}return p.join('');"
				);

				return data ? fn( data ) : fn;
			}
		};
		
		return $( this ).each( function( ) {
			engine.init( this, options );
		});
	};
}( jQuery ) );
define("jfeeds", function(){});

// {"urls":{"cdn":"https://cdn-rest.staging.hcloud.trustyou.net/apps","commons":"/commons","tasks":"/tasks","goals":"/goals","dashboard":"/dashboard","social":"/social","portfolio":"/portfolio","survey":"/surveys","reports":"/export","reviews":"/reviews","export_app":"/export-tmp","tyra":"/tyra-5","metaresponse":"/metaresponse","hoteladmin":"/hoteladmin","products":"/products","messaging_api":"","messaging":"","cluster":"/cluster","sso":"https://restaurant-analytics.staging.trustyou.com/sso","links":"","i18n":"/i18n","login":"https://login.staging.trustyou.com"},"social":{"facebook_app_id":"369833126389025","facebook_api_version":"v2.6"},"gaq":{"enabled":"false","account":"","site_speed_sample_rate":"25","ga4_account":"","debug_timing":"false"},"zendesk_chat":{"enabled":true,"locales":"","cluster_countries":"","basic_roles":"","excluded_domains":""},"sidebar_tabs":{"social":"disabled"},"sidebar_modules":{"survey_module":"disabled","messaging_module":"disabled","marketing_module":"disabled"}} will be replaced with the configuration object at build time
define('commons/public/js/config',{ "urls": { "cdn": "https://cdn-rest.staging.hcloud.trustyou.net/apps", "commons": "/commons", "tasks": "/tasks", "goals": "/goals", "dashboard": "/dashboard", "social": "/social", "portfolio": "/portfolio", "survey": "/surveys", "reports": "/export", "reviews": "/reviews", "export_app": "/export-tmp", "tyra": "/tyra-5", "metaresponse": "/metaresponse", "hoteladmin": "/hoteladmin", "products": "/products", "messaging_api": "", "messaging": "", "cluster": "/cluster", "sso": "https://restaurant-analytics.staging.trustyou.com/sso", "links": "", "i18n": "/i18n", "login": "https://login.staging.trustyou.com" }, "social": { "facebook_app_id": "369833126389025", "facebook_api_version": "v2.6" }, "gaq": { "enabled": "false", "account": "", "site_speed_sample_rate": "25", "ga4_account": "", "debug_timing": "false" }, "zendesk_chat": { "enabled": true, "locales": "", "cluster_countries": "", "basic_roles": "", "excluded_domains": "" }, "sidebar_tabs": { "social": "disabled" }, "sidebar_modules": { "survey_module": "disabled", "messaging_module": "disabled", "marketing_module": "disabled" } });
(function () {
  'use strict';

  /*
   This is an internal part of the 'session' module and should not be used directly by any other ones!.
    This plugin is an implementation workaround to make RequireJS wait for some Ajax requests before
   declaring a module as loaded.
   An alternative would have been to export a Deferred from the 'session' module, but I believe that
   goes against the goal of RequireJS (asynchronously load dependencies,
   while hiding the associated complexity).
   */

  // required by contexts where no cookies are available(eg. partner iframe app)

  var defaultSsoToken = void 0;

  define('commons/public/js/old_components/_session_data',['require'], function (require) {
    return {
      load: function (resource, parentRequire, load, reqConfig) {
        if (reqConfig.isBuild) {
          load();

          return;
        }

        require(['jquery', './../config', './../utils', 'moment', 'product-service', 'jquery-cookie', 'jquery-base64'], function ($, config, utils, moment, productService) {
          var userCookie = void 0,
              encodedSession = void 0,
              sess = void 0,
              ssoToken = void 0;
          var logoutPath = config.urls.sso + '/api/logout?callback=' + config.urls.login,
              userProfileDeferred = $.Deferred(),
              token = resource;

          var sessionDataCookie = 'sso_user_profile';

          ssoToken = $.cookie('sso_token');
          if (!ssoToken) {
            if (!utils.validateUUID(token)) {
              ssoToken = defaultSsoToken;
            } else {
              defaultSsoToken = ssoToken = token;
            }
          } else {
            // take into consideration the sso_user_profile cookie only when we have the sso_token cookie
            userCookie = $.cookie(sessionDataCookie);
          }

          if (userCookie) {
            encodedSession = userCookie.split('|')[0];
            sess = JSON.parse($.base64.decode(encodedSession));
            userProfileDeferred.resolve(sess);
          } else {
            $.ajax({
              data: {
                sso_token: ssoToken
              },
              type: 'GET',
              cache: false,
              url: config.urls.sso + '/api/users/profile/',
              dataType: 'json'
            }).done(function (response) {
              if (response && response.user_profile) {
                sess = response.user_profile;

                userProfileDeferred.resolve(sess);
              } else {
                userProfileDeferred.reject();
              }
            }).fail(function () {
              location.replace(logoutPath);
            });
          }

          $.when(userProfileDeferred).done(function (session) {
            $.extend(true, session);

            // TODO Convert all properties to JSON?
            $.each(session.properties, function (key, value) {
              try {
                session.properties[key] = JSON.parse(value);
              } catch (e) {
                // Leave the value as a string
              }
            });

            $.extend(true, session, {
              properties: {
                // TODO this should be removed and each client should compute it itself
                displayname: (session.properties.first_name || '') + ' ' + (session.properties.last_name || '')
              },

              ssoToken: ssoToken
            });

            // TODO: FIX temporarily until permissions per user are implemented
            if (session.properties.synchronize_sessions === true) {
              session.permissions.push('synchronize_sessions');
            }

            // end of FIX

            // Get the default and selected clusters data and attach it to the session object
            if (!session.properties.default_cluster) {
              session.defaultCluster = {
                id: null,
                name: null
              };
              load(session);
              return;
            }

            var url = config.urls.cluster + '/clusters';

            var clusterList = [session.properties.default_cluster];
            if (session.properties.selected_cluster) {
              clusterList.push(session.properties.selected_cluster);
            }
            // TODO: FIX temporarily until a better solution for products from a user is discussed and implemented
            session.products = productService.getProductsList(session);

            $.ajax({
              url: url,
              type: 'post',
              data: JSON.stringify({
                cluster_list: clusterList
              }),
              dataType: 'json',
              cache: true
            }).done(function (data) {
              if (data.meta && data.meta.code === 200) {
                // Success

                // TODO what if one id is missing?
                $.each(data.response.cluster_list, function (idx, cluster) {
                  // Check for both properties because they may be the same
                  if (cluster.id === session.properties.default_cluster) {
                    session.defaultCluster = cluster;
                  }
                  if (cluster.id === session.properties.selected_cluster) {
                    session.selectedCluster = cluster;
                  }
                });

                // The session is completely loaded
                load(session);
              } else {
                // Fail
                load.error(new Error('Cluster app error: ' + JSON.stringify(data)));
              }
            }).fail(function (jqXHR) {
              load.error(new Error(url + ': HTTP ' + jqXHR.status));
            });
          }).fail(function () {
            load.error(new Error('Could not load user profile'));
          });
        }, load.error);
      }
    };
  });
})();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  'use strict';

  define('commons/public/js/old_components/session',['jquery', 'moment', './../config', './_session_data!stub', 'jquery-cookie'], function ($, moment, config, session) {
    var logoutPath = config.urls.sso + '/api/logout?callback=' + config.urls.login;

    var checkSession = function () {
      var $self = $(document),
          keepaliveAttr = 'lastKeepalive',
          lastKeepalive = $self.data(keepaliveAttr);
      var ssoToken = void 0;

      ssoToken = $.cookie('sso_token');

      if (!ssoToken) {
        ssoToken = session.ssoToken;
      }

      var now = moment();

      // The timeout is 15 minutes
      // IMPROVE make timeout configurable
      if (!lastKeepalive || now.diff(lastKeepalive, 'minutes') >= 15) {
        $self.data(keepaliveAttr, now.valueOf());

        // The call checks for the state of the session and also extends its expiration
        // date if it's active.
        $.ajax({
          url: config.urls.sso + '/api/sessions/' + ssoToken,
          cache: false
        }).fail(function (jqXHR) {
          if (jqXHR.status === 404) {
            // The session expired
            location.replace(logoutPath);
          }
        }).done(function (data) {
          session.zendesk_bot_jwt = data.session.zendesk_bot_jwt;
        });
      }
    };

    // Check the session when loading the plugin, don't wait for the first click
    checkSession();

    /*
     Keep the session alive. This doesn't work for all clicks because some plugins
     may prevent the event from bubbling.
     */
    $(document).click(function () {
      checkSession();
    });

    // Check the session in case of an auth request error
    $(document).ajaxError(function (event, jqXHR) {
      var $self = $(document),
          keepaliveAttr = 'lastKeepalive';

      if (jqXHR.status === 401 || jqXHR.status === 403) {
        $self.data(keepaliveAttr, null);

        checkSession();
      }
    });

    // Session manipulation
    $.extend(session, {
      /**
       * @param permission
       * @return {Boolean} true if the current user has the permission, false otherwise
       */
      has: function (permission) {
        return session.permissions.indexOf(permission) !== -1;
      },


      /**
       * Set a single property for the current user. If it already exists the value will be overridden.
       *
       * @param name
       * @param value
       * @param nextTab specifies which tab will be loaded after the property is
       set successfully. If it's missing the current tab will be reloaded.
       * @return {$.Deferred} a deferred that will be resolved when the property has been set
       successfully. It will be rejected if the call fails.
       */
      setProperty: function (name, value, nextTab, reload) {
        reload = typeof reload !== 'undefined' ? reload : true;

        var prop = { name: name, value: value };

        return this.setProperties([prop], nextTab, reload);
      },


      /**
       * Set several properties for the current user.
       *
       * @param properties an array of objects that contain a 'name' and a 'value'
       * @param nextTab specifies which tab will be loaded after the property is set
       successfully. If it's missing the current tab will be reloaded.
       * @return {$.Deferred} a deferred that will be resolved when all the properties have
       been set successfully. It will be rejected
       * if any one of the properties fails to be set. In this case there is no guarantee which
       ones succeeded.
       */
      setProperties: function (properties, nextTab, reload) {
        reload = typeof reload !== 'undefined' ? reload : true;

        var propertyDeferred = $.Deferred().resolve();

        $.each(properties, function (idx, property) {
          propertyDeferred = propertyDeferred.pipe(function () {
            return $.ajax({
              url: config.urls.sso + '/api/users/properties/' + session.user.id,
              type: 'put',
              cache: false,
              data: {
                name: property.name,
                value: _typeof(property.value) === 'object' ? JSON.stringify(property.value) : property.value,
                sso_token: session.ssoToken
              },
              dataType: 'json'
            });
          });
        });

        return propertyDeferred.done(function () {
          if (nextTab) {
            location.hash = nextTab;
          }

          if (reload) {
            location.reload();
          }
        });
      },


      /**
       * @param type the type of the url: contact or upgrade
       * @param productName the targeted product
       * @return {string} the url with the user data
       */
      getLink: function (type, productName) {
        var params = {
          'first-name': session.properties.first_name,
          'last-name': session.properties.last_name,
          email: session.user.email,
          'hotel-name': session.defaultCluster.name,
          country: session.defaultCluster.iso2_country,
          city: session.defaultCluster.city,
          'hotel-id': session.defaultCluster.id
        };

        var b64EncodeUnicode = function (str) {
          return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
          }));
        };
        var userData = 'user-data=' + b64EncodeUnicode(JSON.stringify(params));
        var productType = 'product-types=' + productName;
        var sourceName = this.has('stars_lite') ? 'trustyou-stars-lite' : null;
        if (sourceName === null) {
          sourceName = this.has('stars') ? 'trustyou-stars' : 'trustyou-meta-review';
        }
        var source = 'source=' + sourceName;
        var lang = 'lang=' + session.properties.locale;
        var partner = 'brand=' + (session.properties.account || '');

        var urlParams = [productType, source, lang, partner, userData];
        if (type === 'contact') {
          urlParams.unshift('client=true');
        }

        return config.urls[type] + '?' + urlParams.join('&');
      },


      /**
       * Deprecated function!
       * @param productName the targeted product
       * @return {string} the upgrade url with the user data
       */
      getUpgradeLink: function (productName) {
        return this.getLink('contact', productName);
      },


      /**
       * @param productName the targeted product
       * @return {string} the contact url with the user data
       */
      getContactLink: function (productName) {
        return this.getLink('contact', productName);
      }
    });

    return session;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/old_components/ty-i18n',['require'], function (require) {
    return {
      load: function (bundleResource, parentRequire, load, config) {
        if (config.isBuild) {
          load();

          return;
        }

        require(['jquery', './../config', 'session'], function ($, tyConfig, session) {
          var bundle = void 0,
              optional = void 0;

          var optionalIdx = bundleResource.indexOf('#optional');
          if (optionalIdx !== -1) {
            bundle = bundleResource.substr(0, optionalIdx);
            optional = true;
          } else {
            bundle = bundleResource;
            optional = false;
          }

          var url = tyConfig.urls.i18n + '/bundles/' + bundle + '/' + session.properties.locale;

          $.ajax({
            url: url,
            dataType: 'json',
            cache: false
          }).done(function (data) {
            load(data);
          }).fail(function (jsXHR) {
            var status = jsXHR.status;

            if (optional && status === 404) {
              // The missing bundle is optional. Use an empty object
              load({});
            } else {
              load.error(new Error(url + ': HTTP ' + status));
            }
          });
        }, load.error);
      },
      normalize: function (bundle) {
        return bundle;
      }
    };
  });
})();

(function () {
  'use strict';

  define('commons/public/js/old_components/time-dropdown',['jquery', 'ty-i18n!analytics_js_4x', 'moment', 'jquery-ui', 'fancybox'], function ($, i18n, moment) {
    var defaults = {
      filter: null,
      options: ['last7days', 'last30days', 'last60days', 'last120days', 'thisMonth', 'lastMonth', 'last3Months', 'last6Months', 'last12Months', 'last24Months', 'currentQuarter', 'previousQuarter', 'currentYear', 'previousYear', 'custom'],
      changed: $.noop
    };

    if ($.fn.TimeDropdown) {
      throw new Error('timeFilter plugin is already defeind');
    }
    $.fn.TimeDropdown = function () {
      return $.extend(this, $.fn.TimeDropdown.API);
    };

    $.fn.TimeDropdown.API = {
      init: function (params) {
        var self = this;

        params = $.extend(true, {}, defaults, params);

        // Parse filter
        params.filter = $.fn.TimeDropdown.relativeTimeFilter(params.filter);

        var labels = $.fn.TimeDropdown.timeFilterLabels(params.filter);

        self.addClass('time-dropdown-select').attr('tabindex', '100');
        self._timeData({ params: params });

        var button = $('<div class="drop"></div>').text(labels.label).button({
          icons: {
            primary: 'ui-icon-calendar'
          }
        }).appendTo(self);

        // Render options
        var $options = $('<div class="dropdown-options"></div>');
        $.each(params.options, function (idx, option) {
          var label = $.fn.TimeDropdown.timeFilterLabels({
            time: option
          }).option;

          $('<div class="dropdown-option" data-option="{option}"></div>'.replace('{option}', option)).text(label).appendTo($options);
        });
        $options.appendTo(self);

        // Event handlers
        button.click(function () {
          if ($options.is(':visible')) {
            self.blur();
          } else {
            $options.show();
          }
        });

        self.blur(function () {
          $options.hide();
        });

        $options.on('click', '.dropdown-option', function () {
          var option = $(this).data('option');
          var $dialogContent = void 0,
              dates = void 0,
              limitDatePicker = void 0,
              currentFilter = void 0;

          self.blur();

          if (option !== 'custom') {
            self.setFilter({
              time: option
            });
          } else {
            // Render from-to dialog
            $dialogContent = $('<div id="custom-time-range"></div>');
            $dialogContent.html(i18n.filtering_fromdatetodate.replace('{fromdate}', '<div id="customFrom"></div>').replace('{todate}', '<div id="customTo"></div>'));

            /**
             * Limits the other datepicker's selection range based on the current one's value.
             * The function is used as a jQuery callback so the current datepicker is available as 'this'.
             */
            limitDatePicker = function () {
              var datePickerOpt = this.id === 'customFrom' ? 'minDate' : 'maxDate',
                  date = $(this).datepicker('getDate');

              // Set the option on the other datepicker
              dates.not(this).datepicker('option', datePickerOpt, date);
            };

            // From & to datepickers
            dates = $dialogContent.find('#customFrom, #customTo').datepicker({
              changeMonth: true,
              onSelect: limitDatePicker
            });

            currentFilter = self.getFilter();

            // Set the beginning of the current time range as 'from'
            dates.filter('#customFrom').datepicker('setDate', moment(currentFilter.fromDate, 'YYYY-MM-DD').toDate());

            // Set the end of the current time range as 'to'
            if (currentFilter.toDate) {
              dates.filter('#customTo').datepicker('setDate', moment(currentFilter.toDate, 'YYYY-MM-DD').toDate());
            } else {
              // Today
              dates.filter('#customTo').datepicker('setDate', '+0');
            }

            // Limit the date picker selection
            dates.each(limitDatePicker);

            $('<div id="saveCustomTimeRange"></div>').text(i18n.common_save).button({
              icons: {
                primary: 'ui-icon-disk'
              }
            }).appendTo($dialogContent);

            $.fancybox({
              content: $dialogContent,
              padding: 20,

              onComplete: function () {
                // Save filter
                $('#saveCustomTimeRange').click(function () {
                  var from = $('#customFrom').datepicker('getDate'),
                      to = $('#customTo').datepicker('getDate');

                  $.fancybox.close();

                  self.setFilter({
                    fromDate: $.fn.TimeDropdown.dateToString(from),
                    toDate: $.fn.TimeDropdown.dateToString(to),
                    time: option
                  });
                });
              }
            });
          }
        });

        return self;
      },
      _timeData: function (data) {
        var dataAttr = 'timeDropdown';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      getFilter: function () {
        return $.extend(true, {}, this._timeData().params.filter);
      },
      setFilter: function (filter) {
        filter = $.fn.TimeDropdown.relativeTimeFilter(filter);
        var label = $.fn.TimeDropdown.timeFilterLabels(filter).label;

        // Save new state
        var params = this._timeData().params;
        params.filter = filter;
        this.find('.ui-button-text').text(label);

        // Callback
        params.changed($.extend(true, {}, filter));
      },
      getLabel: function () {
        var label = $.fn.TimeDropdown.timeFilterLabels(this.getFilter());

        return label ? label.label : null;
      }
    };

    $.extend($.fn.TimeDropdown, {
      dateToString: function (date) {
        return moment(date).format('YYYY-MM-DD');
      },


      // TODO use MomentJS
      addDays: function (date, days) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
      },
      addMonths: function (date, months) {
        return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
      },
      addMonthsAndRound: function (date, months) {
        return new Date(date.getFullYear(), date.getMonth() + months, 1);
      },
      addQuarter: function (date, quarters) {
        var month = date.getMonth(),
            quarterStart = Math.floor(month / 3) * 3;

        return new Date(date.getFullYear(), quarterStart + quarters * 3, date.getDate());
      },
      addQuarterAndRound: function (date, quarters) {
        var month = date.getMonth(),
            quarterStart = Math.floor(month / 3) * 3;

        return new Date(date.getFullYear(), quarterStart + quarters * 3, 1);
      },
      addYears: function (date, years) {
        return new Date(date.getFullYear() + years, date.getMonth(), date.getDate());
      },
      addYearsAndRound: function (date, years) {
        return new Date(date.getFullYear() + years, 0, 1);
      },
      today: function () {
        var date = new Date();

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
      },
      relativeTimeFilter: function (filter) {
        var self = this;

        if (!filter) {
          return filter;
        }

        var today = self.today();
        var relative = {
          fromDate: filter.fromDate || null,
          time: filter.time,
          toDate: filter.toDate || null
        };

        switch (filter.time) {
          case 'custom':
            {
              return filter;
            }
          case 'noTimeFilter':
            {
              return null;
            }
          case 'lastDay':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -1))
              });
            }
          case 'last3days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -3))
              });
            }
          case 'last7days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -7))
              });
            }
          case 'last30days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -30))
              });
            }
          case 'last60days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -60))
              });
            }
          case 'last120days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -120))
              });
            }
          case 'thisMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 0))
              });
            }
          case 'lastMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'last3Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -3)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'last6Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -6)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'last12Months':
          case 'last12months':
          case 'lastYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -12)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'last24Months':
          case 'last2Years':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -24)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'currentQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, 0))
              });
            }
          case 'previousQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addQuarterAndRound(today, 0), -1))
              });
            }
          case 'currentYear':
          case 'yearToDate':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, 0))
              });
            }
          case 'previousYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addYearsAndRound(today, 0), -1))
              });
            }
        }
        return null;
      },
      timeFilterLabels: function (filter) {
        if (!filter) {
          return null;
        }

        switch (filter.time) {
          case 'custom':
            {
              return {
                option: i18n.common_fromto,
                label: i18n.filtering_fromdatetodate.replace('{fromdate}', filter.fromDate).replace('{todate}', filter.toDate)
              };
            }
          case 'noTimeFilter':
            {
              return {
                label: i18n.common_alltime
              };
            }
          case 'lastDay':
            {
              return {
                option: i18n.common_lastday,
                label: i18n.common_lastday
              };
            }
          case 'last3days':
            {
              return {
                option: i18n.common_last3days,
                label: i18n.common_last3days
              };
            }
          case 'last7days':
            {
              return {
                option: i18n.common_last7days,
                label: i18n.common_last7days
              };
            }
          case 'last30days':
            {
              return {
                option: i18n.common_last30days,
                label: i18n.common_last30days
              };
            }
          case 'last60days':
            {
              return {
                option: i18n.common_last60days,
                label: i18n.common_last60days
              };
            }
          case 'last120days':
            {
              return {
                option: i18n.common_last120days,
                label: i18n.common_last120days
              };
            }
          case 'thisMonth':
            {
              return {
                option: i18n.common_thismonth,
                label: i18n.common_thismonth
              };
            }
          case 'lastMonth':
            {
              return {
                option: i18n.common_lastmonth,
                label: i18n.common_lastmonth
              };
            }
          case 'last3Months':
            {
              return {
                option: i18n.common_last3months,
                label: i18n.common_last3months
              };
            }
          case 'last6Months':
            {
              return {
                option: i18n.common_last6months,
                label: i18n.common_last6months
              };
            }
          case 'last12Months':
          case 'last12months':
          case 'lastYear':
            {
              return {
                option: i18n.common_last12months,
                label: i18n.common_last12months
              };
            }
          case 'last24Months':
          case 'last2Years':
            {
              return {
                option: i18n.common_last24months,
                label: i18n.common_last24months
              };
            }
          case 'currentQuarter':
            {
              return {
                option: i18n.common_currentquarter,
                label: i18n.common_currentquarter
              };
            }
          case 'previousQuarter':
            {
              return {
                option: i18n.common_previousquarter,
                label: i18n.common_previousquarter
              };
            }
          case 'currentYear':
          case 'yearToDate':
            {
              return {
                option: i18n.common_currentyear,
                label: i18n.common_currentyear
              };
            }
          case 'previousYear':
            {
              return {
                option: i18n.common_previousyear,
                label: i18n.common_previousyear
              };
            }
        }
        return null;
      }
    });
  });
})();
define('commons/public/jadec/ui_components/single-barchart',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
if ( (isSentiment === true))
{
var hiddenRegionPos = (values[0].width === "0" || values[0].width === 0) ? "display:none;" : ""
var hiddenRegionNeu = (values[1].width === "0" || values[1].width === 0) ? "display:none;" : ""
var hiddenRegionNeg = (values[2].width === "0" || values[2].width === 0) ? "display:none;" : ""
if ( (showTooltip === true))
{
buf.push("<div" + (jade.attrs({ 'data-id':(values[0].id), 'data-tooltip':("top"), 'style':("width: " + values[0].width + "%;" + hiddenRegionPos), 'title':(values[0].displayedValue), "class": ('value') + ' ' + ('value-pos') }, {"data-id":true,"data-tooltip":true,"style":true,"title":true})) + "></div><div" + (jade.attrs({ 'data-id':(values[1].id), 'data-tooltip':("top"), 'style':("width: " + values[1].width + "%;" + hiddenRegionNeu), 'title':(values[1].displayedValue), "class": ('value') + ' ' + ('value-neu') }, {"data-id":true,"data-tooltip":true,"style":true,"title":true})) + "></div><div" + (jade.attrs({ 'data-id':(values[2].id), 'data-tooltip':("top"), 'style':("width: " + values[2].width + "%;" + hiddenRegionNeg), 'title':(values[2].displayedValue), "class": ('value') + ' ' + ('value-neg') }, {"data-id":true,"data-tooltip":true,"style":true,"title":true})) + "></div>");
}
else
{
buf.push("<div" + (jade.attrs({ 'data-id':(values[0].id), 'style':("width: " + values[0].width + "%;" + hiddenRegionPos), "class": ('value') + ' ' + ('value-pos') }, {"data-id":true,"style":true})) + "></div><div" + (jade.attrs({ 'data-id':(values[1].id), 'style':("width: " + values[1].width + "%;" + hiddenRegionNeu), "class": ('value') + ' ' + ('value-neu') }, {"data-id":true,"style":true})) + "></div><div" + (jade.attrs({ 'data-id':(values[2].id), 'style':("width: " + values[2].width + "%;" + hiddenRegionNeg), "class": ('value') + ' ' + ('value-neg') }, {"data-id":true,"style":true})) + "></div>");
}
}
else
{
// iterate values
;(function(){
  var $$obj = values;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var value = $$obj[$index];

var hiddenRegion = (value.width === "0" || value.width === 0) ? "display:none;" : ""
if ( (showTooltip === true))
{
buf.push("<div" + (jade.attrs({ 'data-id':(value.id), 'data-tooltip':("top"), 'title':(value.displayedValue), 'style':("width: " + value.width + "%;background: " + value.color + "; border-color:" + value.color + ";" + hiddenRegion), "class": ('value') }, {"data-id":true,"data-tooltip":true,"title":true,"style":true})) + "></div>");
}
else
{
buf.push("<div" + (jade.attrs({ 'data-id':(value.id), 'style':("width: " + value.width + "%;background: " + value.color + "; border-color:" + value.color + ";" + hiddenRegion), "class": ('value') }, {"data-id":true,"style":true})) + "></div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var value = $$obj[$index];

var hiddenRegion = (value.width === "0" || value.width === 0) ? "display:none;" : ""
if ( (showTooltip === true))
{
buf.push("<div" + (jade.attrs({ 'data-id':(value.id), 'data-tooltip':("top"), 'title':(value.displayedValue), 'style':("width: " + value.width + "%;background: " + value.color + "; border-color:" + value.color + ";" + hiddenRegion), "class": ('value') }, {"data-id":true,"data-tooltip":true,"title":true,"style":true})) + "></div>");
}
else
{
buf.push("<div" + (jade.attrs({ 'data-id':(value.id), 'style':("width: " + value.width + "%;background: " + value.color + "; border-color:" + value.color + ";" + hiddenRegion), "class": ('value') }, {"data-id":true,"style":true})) + "></div>");
}
      }

    }

  }
}).call(this);

}
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 * $div_element.singlebarchart({
 * 		values,
 * 		maxTotal,
 * 		showTooltip: true|false,
 * 		isSentiment: true|false
 * });
 *
 * Note: To see the specification of the values in each case:
 * isSentiment == true or isSentiment = false, check at the end of the file.
 *
 */
(function () {
  'use strict';

  define('commons/public/js/ui_components/single-barchart',['jquery', 'widget', 'single-barchart-template'], function ($, widget, barchartTemplate) {
    $.widget('ty.singlebarchart', widget, {
      options: {
        id: undefined,
        values: [],
        maxTotal: 10,
        /* if isSentiment == true then values.length == 3
         * else values.length == 1
         * In each case, the elements in values should follow the specification found at the end of this file.
         */
        isSentiment: true,
        showTooltip: true
      },

      _create: function () {
        var self = this,
            $element = self.element,
            options = self.options;

        $element.empty().addClass('trustyou-ui bar-chart');
        $element.data('id', options.id);

        // item click
        this._on(['click', '.value', this._callWhenEnabled(function (e) {
          var selectedId = $(this).data('id');
          self.click(selectedId);
          e.stopPropagation();
        })]);

        // item click
        this._on(['click', undefined, this._callWhenEnabled(function (e) {
          var selectedId = $(this).data('id');
          self.click(selectedId);
        })]);
      },

      // It just calls _showSingleBarchart, which will render the barchart
      _init: function () {
        var widths = {};
        this._showSingleBarchart(widths);
      },

      // It renders the paginator
      _showSingleBarchart: function () {
        var $element = this.element,
            options = this.options;
        this._computeChartWidths();
        $element.empty().append(barchartTemplate({
          isSentiment: options.isSentiment,
          showTooltip: options.showTooltip,
          values: options.values
        }));
      },

      // It calculates how big the boxes should be
      _computeChartWidths: function () {
        var options = this.options;
        var totalNumber = 0,
            countNoWidth = 0,
            widthSum = 0,
            totalCount = 0;

        if (!isNaN(parseFloat(options.maxTotal)) && isFinite(options.maxTotal)) {
          totalNumber = options.maxTotal;
        } else {
          $.each(options.values, function (_, val) {
            totalNumber += val.value;
          });
        }

        $.each(options.values, function (_, val) {
          if (val.value > totalNumber) {
            val.value = totalNumber;
          }

          if (val.value !== 0) {
            totalCount += 1;
            val.width = val.value * 100 / totalNumber;

            if (val.width < 5) {
              widthSum += 5;
              countNoWidth += 1;
            } else {
              widthSum += val.width;
            }
          } else {
            val.width = 0;
          }
        });

        // HACK: update widths because there's a min-width of 3%
        if (widthSum > 100 && countNoWidth > 0) {
          $.each(options.values, function (_, val) {
            if (val.width > 7) {
              val.width -= 5 * countNoWidth / (totalCount - countNoWidth);
            }
          });
        }
      },

      // Click event
      click: function (id) {
        this._trigger('click', null, { id: id });
      },

      // Create a public method to get or set the values
      value: function (values) {
        // No value passed, act as a getter
        if (values === undefined) {
          return this.options.values;
        }
        this.options.values = values;
        this._showSingleBarchart();
        return this.options.values;
      }
    });

    // public classes
    /* The singlebarchart element could contain just one element (isSentiment = false):
     *  values -> [new $.ty.singlebarchart.Element(id, value, displayedValue, color)]
     *				(Note: Color must be an empty string to use the prefefined blue)
     *
     * Or it could have 3 elements (isSentiment = true):
     * 	values: [
     *			new $.ty.singlebarchart.Element(category + '-pos', posValue, posValue),
     *			new $.ty.singlebarchart.Element(category + '-neu', neuValue, neuValue),
     *			new $.ty.singlebarchart.Element(category + '-neg', negValue, negValue)
     *			]
     */
    $.extend($.ty.singlebarchart, {
      Element: function (id, value, displayedValue, color) {
        if (!(this instanceof $.ty.singlebarchart.Element)) {
          return new $.ty.singlebarchart.Element(value, displayedValue, color);
        }
        this.id = id;
        this.value = value;
        this.displayedValue = displayedValue;
        this.color = color;
        return this;
      }
    });

    return $.ty.singlebarchart;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Flex table formatter plugin. Usage and param details:
 *
 */

(function () {
  'use strict';

  define('commons/public/js/old_components/flextable-formatter',['jquery', 'session', 'single-barchart'], function ($, session) {
    var benchmarkDiffTypes = ['change', 'change_positive', 'goal_progress'];

    var roundToFixed = function (number, precision) {
      var multiplier = Math.pow(10, precision + 1),
          wholeNumber = Math.floor(number * multiplier);
      return Math.round(wholeNumber / 10) * 10 / multiplier;
    };

    var Formatter = function (params) {
      params = params || {};

      this.scale = params.scale || 100;
      this.fixed_decimals = params.fixed_decimals;
      this.is_trend = params.is_trend;
      this.comp_index = params.comp_index;
      this.benchmark_type = params.benchmark_type;
      this.hide_benchmark_percentage = false;
      this.hide_percentage = false;
      this.display_type = params.display_type || 'html';
      this.special_type = params.special_type;
      this.simple_view = params.simple_view;
      this.only_value = params.only_value;
      this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      if (this.comp_index) {
        this.normal_num_format = '0.00';
      }
      if (this.special_type === 'PORTFOLIO_footer') {
        this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      } else if (this.special_type === 'COMPARISON_footer') {
        this.normal_num_format = this.scale < 20 && !this.comp_index ? '0.0' : '0.00';
      }
      if (this.is_trend) {
        this.normal_num_format = '0.00';
      }
      this.postfix_num_format = 0x0a;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    Formatter.prototype.format = function (value) {
      if (this.benchmark_type === 'change') {
        return this.formatBenchmarkChangeValue(value);
      } else if (this.benchmark_type === 'change_positive') {
        return this.formatBenchmarkChangePositiveValue(value);
      } else if (this.benchmark_type === 'goal_progress') {
        return this.formatGoalBenchmarkProgressValue(value);
      } else {
        return this.formatValue(value);
      }
    };

    Formatter.prototype.formatValue = function (value) {
      if (this.is_trend) {
        return this.formatTrendValue(value);
      } else {
        return this.formatAbsoluteValue(value);
      }
    };

    Formatter.prototype.transformGoalBenchmarkProgressValue = function (value) {
      return roundToFixed(value, 0);
    };

    Formatter.prototype.getAlignment = function () {
      return '';
    };

    Formatter.prototype.getFormattedDisplay = function (type, value, rawValue, color, numFormat) {
      var dataType = void 0,
          style = void 0,
          prefixSymbol = void 0,
          postfixSymbol = void 0;
      var signMandatory = this.is_trend || ['change', 'change_positive'].indexOf(this.benchmark_type) > -1;

      if ($.inArray(type, ['number', 'percentage']) !== -1) {
        dataType = 'number';
      } else {
        dataType = type;
      }

      prefixSymbol = signMandatory && value > 0 ? '+' : '';
      postfixSymbol = type === 'percentage' ? '%' : '';

      if (numFormat === null) {
        numFormat = postfixSymbol ? this.postfix_num_format : this.normal_num_format;
      }

      if (this.display_type === 'html') {
        if (color === 'red') {
          style = 'text-negative';
        } else if (color === 'yellow') {
          style = 'text-neutral';
        } else if (color === 'green') {
          style = 'text-positive';
        } else {
          style = '';
        }

        if (rawValue === null) {
          value = '-';
          postfixSymbol = '';
          prefixSymbol = '';
          style = '';
        }

        if (this.only_value) {
          return value;
        }

        var decimalsValue = value > 0 && this.fixed_decimals && value.toFixed(this.fixed_decimals);

        return '<span class="' + style + '">' + prefixSymbol + (decimalsValue || value) + postfixSymbol + '</span>';
      } else if (this.display_type === 'excel') {
        if (color === 'red') {
          style = '#E0470B';
        } else if (color === 'yellow') {
          style = '#F39814';
        } else if (color === 'green') {
          style = '#469E4B';
        } else {
          style = null;
        }

        if (rawValue === null) {
          value = null;
          style = null;
          postfixSymbol = '';
        }

        if (this.only_value) {
          return postfixSymbol ? value / 100 : value;
        }

        return {
          type: dataType,
          value: postfixSymbol ? value / 100 : value,
          rawvalue: rawValue,
          format: {
            align: 'center',
            text_wrap: 1,
            color: style || undefined,
            num_format: numFormat
          }
        };
      } else {
        throw new Error('Invalid format display type for flex table formatter!');
      }
    };

    Formatter.prototype.transformBenchmarkValue = function (value) {
      throw new Error('Method not implemented!');
    };

    Formatter.prototype.absoluteValueStyle = function (value) {
      throw new Error('Method not implemented!');
    };

    Formatter.prototype.transformAbsoluteValue = function (value) {
      throw new Error('Method not implemented!');
    };

    Formatter.prototype.transformRelativeValue = function (value) {
      throw new Error('Method not implemented!');
    };

    Formatter.prototype.formatCompIndex = function (value) {
      var rawValue = value;

      var style = value < 1 ? 'red' : null;
      if (style === null) {
        style = value > 0 ? 'green' : '';
      }

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return this.getFormattedDisplay('number', value, rawValue, style, null);
    };

    Formatter.prototype.formatBenchmarkChangeValue = function (value) {
      var rawValue = value,
          type = !this.hide_benchmark_percentage ? 'percentage' : 'number';

      value = this.transformBenchmarkValue(value);

      var style = value < 0 ? 'red' : null;
      if (style === null) {
        style = value === 0 ? 'yellow' : 'green';
      }

      return this.getFormattedDisplay(type, value, rawValue, style, this.benchmark_num_format);
    };

    Formatter.prototype.formatBenchmarkChangePositiveValue = function (value) {
      var rawValue = value,
          type = !this.hide_benchmark_percentage ? 'percentage' : 'number';

      value = this.transformBenchmarkValue(value);

      var style = value < 0 ? 'green' : null;
      if (style === null) {
        style = value === 0 ? 'yellow' : 'red';
      }

      return this.getFormattedDisplay(type, value, rawValue, style, this.benchmark_num_format);
    };

    Formatter.prototype.formatGoalBenchmarkProgressValue = function (value) {
      var rawValue = value,
          type = 'percentage';

      value = this.transformGoalBenchmarkProgressValue(value);

      var style = value < 0 ? 'red' : null;
      if (style === null) {
        style = value === 0 ? 'yellow' : 'green';
      }

      return this.getFormattedDisplay(type, value, rawValue, style, this.benchmark_num_format);
    };

    Formatter.prototype.formatAbsoluteValue = function (value) {
      var type = !this.hide_percentage ? 'percentage' : 'number';

      if (this.comp_index) {
        return this.formatCompIndex(value);
      } else {
        var transformedValue = this.transformAbsoluteValue(value);

        var style = this.absoluteValueStyle(value);

        return this.getFormattedDisplay(type, transformedValue, value, style, null);
      }
    };

    Formatter.prototype.formatTrendValue = function (value) {
      var rawValue = value,
          type = !this.hide_percentage ? 'percentage' : 'number';

      value = this.transformRelativeValue(value);

      var style = value < 0 ? 'red' : null;
      if (style === null) {
        style = value > 0 ? 'green' : '';
      }

      return this.getFormattedDisplay(type, value, rawValue, style, null);
    };

    var ScoreFormatter = function (params) {
      params = params || {};

      Formatter.call(this, params);

      this.hide_benchmark_percentage = this.is_trend || this.comp_index;
      this.hide_percentage = true;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    ScoreFormatter.prototype = new Formatter();
    ScoreFormatter.prototype.constructor = ScoreFormatter;

    ScoreFormatter.prototype.transformBenchmarkValue = function (value) {
      if (this.is_trend && !this.comp_index) {
        value = value * this.scale / 100.0;
      }

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return value;
    };

    ScoreFormatter.prototype.transformAbsoluteValue = function (value) {
      var specialTypeRound = this.special_type === 'COMPARISON_footer' ? 2 : 0;
      var defaultRound = this.scale >= 20 ? specialTypeRound : 1;
      var round = this.fixed_decimals || defaultRound;
      value = value * this.scale / 100.0;

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, round);
      }

      return value;
    };

    ScoreFormatter.prototype.transformRelativeValue = function (value) {
      value = value * this.scale / 100.0;

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return value;
    };

    ScoreFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 68 ? 'red' : null;
      if (val === null) {
        val = value < 80 ? 'yellow' : 'green';
      }
      return val;
    };

    var CountFormatter = function (params) {
      params = params || {};

      Formatter.call(this, params);

      this.max_count = params.max_count || 0;
      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = true;
      this.is_trend = false;
      this.normal_num_format = this.comp_index ? '0.00' : 0x01;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    CountFormatter.prototype = new Formatter();
    CountFormatter.prototype.constructor = CountFormatter;

    CountFormatter.prototype.getAlignment = function () {
      var alignment = 'left';

      if ($.inArray(this.benchmark_type, benchmarkDiffTypes) !== -1) {
        alignment = '';
      }

      return alignment;
    };

    CountFormatter.prototype.transformAbsoluteValue = function (value) {
      var roundedValue = roundToFixed(value, 0);

      if (this.display_type === 'html' && this.max_count > 0) {
        if (this.only_value) {
          return roundedValue;
        }
        if (this.simple_view) {
          return '<div>' + roundedValue + '</div>';
        } else {
          var barchart = $('<div></div>').singlebarchart({
            values: [new $.ty.singlebarchart.Element('singlebarchart', value, roundedValue, '')],
            maxTotal: this.max_count,
            showTooltip: false,
            isSentiment: false
          }).prop('outerHTML');
          return '<div>' + barchart + roundedValue + '</div>';
        }
      } else {
        return roundedValue;
      }
    };

    CountFormatter.prototype.transformBenchmarkValue = function (value) {
      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return value;
    };

    CountFormatter.prototype.absoluteValueStyle = function (value) {
      return '';
    };

    var RecommendationRateFormatter = function (params) {
      params = params || {};

      Formatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = false;
      this.postfix_num_format = 0x09;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x09 : '0.00';
    };

    RecommendationRateFormatter.prototype = new Formatter();
    RecommendationRateFormatter.prototype.constructor = RecommendationRateFormatter;

    RecommendationRateFormatter.prototype.transformAbsoluteValue = function (value) {
      return roundToFixed(value, 0);
    };

    RecommendationRateFormatter.prototype.transformBenchmarkValue = function (value) {
      if (this.is_trend && !this.comp_index) {
        value *= 100;
      }

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return value;
    };

    RecommendationRateFormatter.prototype.transformRelativeValue = function (value) {
      value *= 100;

      value = roundToFixed(value, 0);

      return value;
    };

    RecommendationRateFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 20 ? 'red' : null;
      if (val === null) {
        val = value < 80 ? 'yellow' : 'green';
      }
      return val;
    };

    var PopularityRankFormatter = function (params) {
      params = params || {};

      Formatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = false;
      this.postfix_num_format = 0x09;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
      if (this.is_trend) {
        this.benchmark_num_format = 0x0a;
      }
    };

    PopularityRankFormatter.prototype = new Formatter();
    PopularityRankFormatter.prototype.constructor = PopularityRankFormatter;

    PopularityRankFormatter.prototype.transformBenchmarkValue = function (value) {
      if (this.is_trend && !this.comp_index) {
        value *= -100;
      }

      if (this.display_type !== 'excel') {
        value = roundToFixed(value, 2);
      }

      return value;
    };

    PopularityRankFormatter.prototype.transformAbsoluteValue = function (value) {
      return roundToFixed(value, 0);
    };

    PopularityRankFormatter.prototype.transformRelativeValue = function (value) {
      value *= -100.0;

      value = roundToFixed(value, 2);

      return value;
    };

    PopularityRankFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 20 ? 'red' : null;
      if (val === null) {
        val = value < 80 ? 'yellow' : 'green';
      }
      return val;
    };

    var ResponseRateFormatter = function (params) {
      params = params || {};

      Formatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = false;
      this.is_trend = false;
      this.postfix_num_format = 0x09;
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x09 : '0.00';
    };

    ResponseRateFormatter.prototype = new Formatter();
    ResponseRateFormatter.prototype.constructor = ResponseRateFormatter;

    ResponseRateFormatter.prototype.transformAbsoluteValue = function (value) {
      return roundToFixed(value, 0);
    };

    ResponseRateFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 15 ? 'red' : null;
      if (val === null) {
        val = value < 30 ? 'yellow' : 'green';
      }
      return val;
    };

    ResponseRateFormatter.prototype.transformBenchmarkValue = function (value) {
      if (this.display_type !== 'excel') {
        if (this.comp_index) {
          return roundToFixed(value, 2);
        } else {
          return roundToFixed(value, 0);
        }
      }
      return value;
    };

    var SourceCategoryFormatter = function (params) {
      params = params || {};

      ScoreFormatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = true;
      this.is_trend = false;
      this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      if (this.comp_index) {
        this.normal_num_format = '0.00';
      }
      if (this.special_type === 'PORTFOLIO_footer') {
        this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      } else if (this.special_type === 'COMPARISON_footer') {
        this.normal_num_format = this.scale < 20 && !this.comp_index ? '0.0' : '0.00';
      }
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    SourceCategoryFormatter.prototype = new ScoreFormatter();
    SourceCategoryFormatter.prototype.constructor = SourceCategoryFormatter;

    SourceCategoryFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 0 ? 'red' : null;
      if (val === null) {
        val = value === 0 ? '' : 'green';
      }
      return val;
    };

    var SentimentFormatter = function (params) {
      params = params || {};

      ScoreFormatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = true;
      this.is_trend = false;
      this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      if (this.comp_index) {
        this.normal_num_format = '0.00';
      }
      if (this.special_type === 'PORTFOLIO_footer') {
        this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      } else if (this.special_type === 'COMPARISON_footer') {
        this.normal_num_format = this.scale < 20 && !this.comp_index ? '0.0' : '0.00';
      }
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    SentimentFormatter.prototype = new ScoreFormatter();
    SentimentFormatter.prototype.constructor = SentimentFormatter;

    SentimentFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 50 ? 'red' : null;
      if (val === null) {
        val = value < 70 ? 'yellow' : 'green';
      }
      return val;
    };

    var PerformanceScoreFormatter = function (params) {
      params = params || {};

      ScoreFormatter.call(this, params);

      this.hide_benchmark_percentage = !!this.comp_index;
      this.hide_percentage = true;
      this.is_trend = false;
      this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      if (this.comp_index) {
        this.normal_num_format = '0.00';
      }
      if (this.special_type === 'PORTFOLIO_footer') {
        this.normal_num_format = this.scale < 20 ? '0.0' : 0x01;
      } else if (this.special_type === 'COMPARISON_footer') {
        this.normal_num_format = this.scale < 20 && !this.comp_index ? '0.0' : '0.00';
      }
      this.benchmark_num_format = !this.hide_benchmark_percentage ? 0x0a : '0.00';
    };

    PerformanceScoreFormatter.prototype = new ScoreFormatter();
    PerformanceScoreFormatter.prototype.constructor = PerformanceScoreFormatter;

    var RankFormatter = function (params) {
      params = params || {};

      ScoreFormatter.call(this, params);

      this.hide_benchmark_percentage = true;
      this.hide_percentage = true;
      this.is_trend = false;
      this.normal_num_format = 0x01;
      this.benchmark_num_format = 0x01;
    };

    RankFormatter.prototype = new ScoreFormatter();
    RankFormatter.prototype.constructor = RankFormatter;

    RankFormatter.prototype.absoluteValueStyle = function (value) {
      var val = value < 0 ? 'red' : null;
      if (val === null) {
        val = value === 0 ? '' : 'green';
      }
      return val;
    };

    RankFormatter.prototype.transformBenchmarkValue = function (value) {
      return roundToFixed(value, 0);
    };

    RankFormatter.prototype.transformAbsoluteValue = function (value) {
      value = roundToFixed(value, 0);

      return value;
    };

    var InboundOutboundRatioFormatter = function (_Formatter) {
      _inherits(InboundOutboundRatioFormatter, _Formatter);

      function InboundOutboundRatioFormatter(params) {
        _classCallCheck(this, InboundOutboundRatioFormatter);

        params = params || {};

        var _this = _possibleConstructorReturn(this, (InboundOutboundRatioFormatter.__proto__ || Object.getPrototypeOf(InboundOutboundRatioFormatter)).call(this, params));

        _this.hide_benchmark_percentage = !!_this.comp_index;
        _this.hide_percentage = false;
        _this.is_trend = false;
        _this.postfix_num_format = 0x09;
        _this.benchmark_num_format = _this.hide_benchmark_percentage ? '0.00' : 0x09;
        return _this;
      }

      _createClass(InboundOutboundRatioFormatter, [{
        key: 'transformAbsoluteValue',
        value: function transformAbsoluteValue(value) {
          return roundToFixed(value, 0);
        }
      }, {
        key: 'absoluteValueStyle',
        value: function absoluteValueStyle() {
          return '';
        }
      }, {
        key: 'transformBenchmarkValue',
        value: function transformBenchmarkValue(value) {
          if (this.display_type === 'excel') {
            return value;
          }

          return this.comp_index ? roundToFixed(value, 2) : roundToFixed(value, 0);
        }
      }]);

      return InboundOutboundRatioFormatter;
    }(Formatter);

    var formatterMap = {
      recommendation_rate: RecommendationRateFormatter,
      score: ScoreFormatter,
      popularity: PopularityRankFormatter,
      response_rate: ResponseRateFormatter,
      category: SourceCategoryFormatter,
      sema_category: SentimentFormatter,
      performance_score: PerformanceScoreFormatter,
      rank: RankFormatter,
      rank_out_of: RankFormatter,
      reviews: CountFormatter,
      reviews_by_star: CountFormatter,
      responses_by_star: CountFormatter,
      response_rate_by_star: ResponseRateFormatter,
      reviews_to_respond_by_score: CountFormatter,
      twitter_tweets: CountFormatter,
      twitter_followers: CountFormatter,
      twitter_following: CountFormatter,
      facebook_likes: CountFormatter,
      facebook_checkins: CountFormatter,
      foursquare_tips: CountFormatter,
      foursquare_checkins: CountFormatter,
      responses: CountFormatter,
      matches: CountFormatter,
      inbound_messages: CountFormatter,
      outbound_messages: CountFormatter,
      inbound_outbound_ratio: InboundOutboundRatioFormatter
    };

    if ($.fn.FlexTableFormatter) {
      throw new Error('FlexTableFormatter plugin is already defined');
    }

    var defaults = {
      value: null,
      column: null,
      scale: session.properties.scale
    };

    $.fn.FlexTableFormatter = function (params) {
      var formatter = void 0,
          formatterParams = void 0;

      this.params = $.extend(true, {}, defaults, params);

      var currentColumn = this.params.column || {};

      var displayType = this.params.display_type || null;

      var FormatterType = formatterMap[currentColumn.type];

      if (FormatterType) {
        formatterParams = {
          scale: this.params.scale,
          fixed_decimals: currentColumn.fixed_decimals,
          is_trend: currentColumn.is_trend,
          comp_index: currentColumn.comp_index,
          benchmark_type: currentColumn.benchmark_type,
          max_count: currentColumn.max_count,
          display_type: displayType,
          special_type: currentColumn.special_type,
          simple_view: currentColumn.simple_view,
          only_value: currentColumn.only_value
        };

        formatter = new FormatterType(formatterParams);
      }

      return {
        getFormattedValue: function (value) {
          return formatter ? formatter.format(value) : value;
        },
        getAlignment: function () {
          return formatter ? formatter.getAlignment() : '';
        }
      };
    };

    $.fn.FlexTableFormatter.roundToFixed = roundToFixed;

    $.fn.FlexTableFormatter.getAggregationColumns = function () {
      var columns = [];

      $.each(formatterMap || {}, function (key, FormatterClass) {
        var formatter = new FormatterClass();

        if (formatter instanceof CountFormatter) {
          columns.push(key);
        }
      });

      return columns;
    };
  });
})();
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/old_components/_gaq',['./../config', 'jquery', 'session'], function (config, $, session) {
    if (config.gaq.enabled === 'false' || window.isExport) {
      // return dummy function to avoid crashes
      var nihil = function () {
        return null;
      };
      window.ga = nihil;
      window._gaq = {
        push: nihil,
        sendEvent: nihil
      };
      return window._gaq;
    }

    /* eslint-disable */
    (function (i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    /* eslint-enable */

    window.ga('create', config.gaq.account, {
      siteSpeedSampleRate: +config.gaq.site_speed_sample_rate,
      userId: session.user.id
    });
    window.ga('send', 'pageview');

    window._gaq = {
      // backward compatibility with old _gaq
      // could be removed after all apps are migrated to new GA
      push: function () {
        var _window;

        var args = arguments[0]; // eslint-disable-line prefer-rest-params
        if (!args) {
          return;
        }
        var entityType = args.shift();
        var entityString = entityType === '_trackTiming' ? 'timing' : 'event';
        args.unshift('send', entityString);
        (_window = window).ga.apply(_window, _toConsumableArray(args));
      },


      // custom shorthand function
      sendEvent: function () {
        var _window2;

        var args = [].concat(Array.prototype.slice.call(arguments)); // eslint-disable-line prefer-rest-params
        args.unshift('send', 'event');
        (_window2 = window).ga.apply(_window2, _toConsumableArray(args));
      },


      // ga4 events
      sendGa4Event: function (appName, event, screenName) {
        /* eslint-disable no-undef */
        if (typeof dataLayer != 'undefined') {
          dataLayer.push({
            category: 'click',
            event: event,
            ty_app_name: appName,
            ty_screen_name: screenName
          });
        }
      }
    };

    // Add event tracking for UI
    $(document).on('click', '[data-ga-category]', function () {
      var $target = $(this);
      window._gaq.sendEvent($target.attr('data-ga-category'), $target.attr('data-ga-action'), $target.attr('data-ga-label'));
    });

    return window._gaq;
  });
})();

(function () {
  /*
   * Zendesk chat wrapper
   * Returns object with interface to work with Zendesk chat
   * Do not call zendesk API directly in other apps
   *
   * Department naming scheme:
   * In order to support automatic department binding the following convention should be followed.
   * Each department name should contain either 'lang_{language code}' or 'lang_{language code}_trial'
   * Language codes should match those used in session.properties.local - 2 letter lowercase codes
   * In case no suitable department is founds we fallback to english
   * In case english department is not there too we fallback to first available department
   */

  'use strict';

  define('commons/public/js/old_components/_zendesk_chat',['./../config', 'session', 'ty-i18n!tyra-5'], function (config, session, i18n) {
    var trimAndSplit = function (s) {
      return (s || '').split(',').map(function (t) {
        return t.trim();
      }).filter(function (u) {
        return u.length > 0;
      });
    };

    var locales = trimAndSplit(config.zendesk_chat.locales),
        clusterCountries = trimAndSplit(config.zendesk_chat.cluster_countries),
        basicRoles = trimAndSplit(config.zendesk_chat.basic_roles),
        excludedDomains = trimAndSplit(config.zendesk_chat.excluded_domains);

    var checkBasicRole = function (role) {
      return session.roles.indexOf(role) >= 0;
    },
        checkEmailDomain = function (excludedDomain) {
      var parts = session.user.email.split('@');
      if (parts.length !== 2) {
        return true;
      }
      return parts.length === 2 && parts[1] !== excludedDomain;
    };

    var chatEnabled = config.zendesk_chat.enabled && (locales.length === 0 || locales.includes(session.properties.locale)) && (clusterCountries.length === 0 || clusterCountries.includes(session.defaultCluster.iso2_country)) && (basicRoles.length === 0 || basicRoles.every(checkBasicRole)) && (excludedDomains.length === 0 || excludedDomains.every(checkEmailDomain)) && !session.has('stars_lite');

    if (chatEnabled) {
      var langTag = 'lang_' + session.properties.locale;

      window.zESettings = {
        authenticate: { jwt: session.zendesk_bot_jwt },
        webWidget: {
          launcher: {
            label: {
              '*': i18n.chat_bubble_label
            }
          }
        }
      };

      // Load Zendesk Chat
      // eslint-disable-next-line
      window.zEmbed || function (e, n) {
        var t = void 0,
            o = void 0,
            d = void 0,
            s = void 0,
            i = void 0,
            a = [],
            r = document.createElement('iframe');window.zEmbed = function () {
          a.push(arguments);
        }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), s = r.contentWindow, i = s.document;try {
          o = i;
        } catch (e) {
          t = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + t + '";void(0);', o = i;
        }o.open()._l = function () {
          var e = this.createElement('script');t && (this.domain = t), e.id = 'js-iframe-async', e.src = 'https://assets.zendesk.com/embeddable_framework/main.js', this.t = +new Date(), this.zendeskHost = 'trustyou.zendesk.com', this.zEQueue = a, this.body.appendChild(e);
        }, o.write('<body onload="document._l();">'), o.close();
      }('{{zendeskFrameworkUrl}}', '{{zendeskHost}}');

      window.zE(function () {
        window.$zopim(function () {
          var name = session.properties.first_name + ' ' + session.properties.last_name;
          window.$zopim.livechat.clearAll();
          window.$zopim.livechat.set({
            name: name,
            email: session.user.email,
            language: session.properties.locale
          });

          window.zE.identify({
            name: name,
            email: session.user.email
          });

          window.$zopim.livechat.setOnConnected(function () {
            var deps = window.$zopim.livechat.departments.getAllDepartments();
            var defaultDep = deps.find(function (d) {
              return d.name.includes(langTag);
            }) || deps[0];
            var langDep = deps.find(function (d) {
              return d.name.includes(langTag);
            }) || defaultDep;
            window.$zopim.livechat.departments.setVisitorDepartment(langDep.id);
            // set the same widget language as the selected department language
            var widgetLang = langDep.id !== defaultDep.id ? session.properties.locale : 'en';
            window.zE.setLocale(widgetLang);

            window.$zopim.livechat.setOnStatus(function (status) {
              if (status === 'offline') {
                return;
              }
              var dep = window.$zopim.livechat.departments.getDepartment(langDep.id);
              if (dep.status === 'offline') {
                window.$zopim.livechat.setStatus(dep.status);
              }
            });
          });
        });

        window.zE.hide();
      });
    }

    // Encapsulate Zopim API into our own module
    return {
      chatEnabled: chatEnabled,
      showChat: function () {
        return window.zE.activate();
      },
      hideChat: function () {
        return window.zE.hide();
      },
      showBubble: function () {
        return window.zE.show();
      },
      hideBubble: function () {
        return window.zE.hide();
      }
    };
  });
})();
(function () {
  'use strict';

  define('commons/public/js/old_components/timing-tracker',['./../config', '_gaq'], function (config) {
    var Tracker = function (category, variable, label) {
      this.category = category;
      this.variable = variable;
      this.label = label;
      this.startTime = null;
      this.stopTime = null;
    };

    Tracker.prototype.start = function () {
      if (this.startTime === null) {
        this.startTime = new Date().getTime();
      }

      return this;
    };

    Tracker.prototype.send = function (category, variable, label) {
      var duration = void 0;
      var hourInMillis = 60 * 60 * 1000,

      /*
      More about sample rate: https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiUserTiming
      More about ga limits definitions: http://stackoverflow.com/questions/22686879/google-analytics-limits-definitions
      */
      sampleRate = 100;

      if (this.stopTime === null) {
        if (category) {
          this.category = category;
        }

        if (variable) {
          this.variable = variable;
        }

        if (label) {
          this.label = label;
        }

        this.stopTime = new Date().getTime();
        duration = this.stopTime - this.startTime;

        if (duration >= 0 && duration <= hourInMillis) {
          window.ga('send', 'timing', this.category, this.variable, duration, this.label, sampleRate);
          if (config.gaq.debug_timing === 'true') {
            console.log(this.category + '::', this.variable + '::', this.label, duration); // eslint-disable-line no-console
          }
        }
      }

      return this;
    };

    return function (category, variable, label) {
      return new Tracker(category, variable, label);
    };
  });
})();
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/old_components/timing-by-key',['jquery', 'timing-tracker'], function ($, timingTracker) {
    var _all = '(Data + Render)';

    if ($.fn.TimingByKey) {
      throw new Error('TimingByKey plugin is already defined');
    }

    /**
     * jQuery plugin to track timing statistics by specified key and support promises.
     * Documentation: https://sites.google.com/a/trustyou.net/trustyou-wiki/app-team/timingbykey
     *
     * @param params object of configurable params
     * @returns object
     * @constructor
     */
    $.fn.TimingByKey = function (params) {
      var app = params.app,
          variable = params.variable,
          tile = params.tile,
          permission = typeof params.permission !== 'undefined' ? params.permission : true,
          canTrack = app && variable && permission,
          timers = { _all: [] },
          promises = { _all: [] },
          reveal = {};

      /**
       * Sends collected data to track at ga
       *
       * @param timer instance of timingTracker
       * @param category ga category param
       * @param suffix suffix for ga variable param
       * @param label ga label param
       * @private
       */
      var _proxy = function (timer, category, suffix, label) {
        timer.send(category, variable + ' ' + suffix, label);
      };

      /**
       * Iterates over input array and collects(duck-typing) promises from it
       *
       * @param data array of something
       * @returns {Array}
       * @private
       */
      var _collectPromises = function (data) {
        var collection = [];
        $.each(data, function (_, obj) {
          if (obj && obj.promise) {
            collection.push(obj);
          }
        });

        return collection;
      };

      /**
       * Transform key to _all if it's not specified
       *
       * @param key
       * @returns {*}
       * @private
       */
      var _getKey = function (key) {
        return typeof key === 'undefined' ? _all : key;
      };

      /**
       * Starts timing tracker and associates key with timers and promises objects
       *
       * @param key association for timers and promises objects
       */
      var start = function (key) {
        key = _getKey(key);
        timers[key] = timingTracker().start();
        promises[key] = [];
      };

      /**
       * Collect promises and wait until they are resolved to send timing to ga
       *
       * @param key
       * @param data array of promises
       */
      var send = function (key, data) {
        key = _getKey(key);
        if (data) {
          promises[key] = _collectPromises(data);
          if (key !== _all) {
            $.merge(promises[_all], promises[key]);
          }
        }

        if (promises[key].length === 0) {
          _proxy(timers[key], app, key, tile);
        } else {
          $.when.apply($, _toConsumableArray(promises[key])).done(function () {
            _proxy(timers[key], app, key, tile);
          });
        }
      };

      /**
       * To handle lazy loading cases it's necessary to pass promise down stacktrace and wait until it resolved
       * Add this promise to track timing for specified key and _all
       *
       * @param key association for promises object
       * @param promise
       */
      var addPromise = function (key, promise) {
        promises[key].push(promise);
        if (key !== _all) {
          promises[_all].push(promise);
        }
      };

      /**
       * Expose real methods only if canTrack == True
       */
      reveal.start = canTrack ? start : function () {};
      reveal.send = canTrack ? send : function (key, data) {};
      reveal.addPromise = canTrack ? addPromise : function (key, promise) {};

      return reveal;
    };
  });
})();
(function () {
  'use strict';

  define('commons/public/js/old_components/export-pane',['jquery', 'export-app'], function ($) {
    return (

      // Make the slide pane available to other modules without them hard-coding the id
      $('#side-panel-reports').ExportSlidePane()
    );
  });
})();
(function () {
  'use strict';

  define('commons/public/js/old_components/manage-users',['jquery', 'users-management'], function ($) {
    return $('<div></div>').UsersManagementSidePanel();
  });
})();
define('commons/public/jadec/old_components/list',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
if ( search)
{
buf.push("<div class=\"search-bar\"><input type=\"text\" class=\"search\"/></div>");
}
buf.push("<div style=\"display: block\" class=\"ty-loading\"></div><div style=\"display: none\" class=\"content\"><div class=\"list-container\"></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/old_components/list-item',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<li" + (jade.attrs({ 'id':(id), "class": (item.selected ? ["ui-widget-content", "selected"] : "ui-widget-content") }, {"id":true,"class":true})) + "><span class=\"checkmark right\"></span><span class=\"label\">");
if ( escapeHtml)
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.detailsLabel )
{
buf.push("<span class=\"detailsLabel\">" + (jade.escape((jade.interp = item.detailsLabel) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</span><span class=\"clear\"></span></li>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/old_components/list',['jquery', './../../jadec/old_components/list', './../../jadec/old_components/list-item'], function ($, listTmpl, listItemTmpl) {
    if ($.fn.List) {
      throw new Error('List plugin is already defined');
    }

    $.fn.List = function () {
      return $.extend(this, $.fn.List.API);
    };

    // TODO put these methods in utils?
    var uuid4 = function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise, no-mixed-operators
        return v.toString(16);
      });
    };

    var tokenize = function (label) {
      return $.map(label.split(' '), function (token) {
        // Split the name into parts in order to perform prefix matches on them
        var normalized = $.trim(token).toLowerCase();

        if (normalized) {
          return normalized;
        }
        return null;
      });
    };

    var defaults = {
      multiselect: false,
      minPrefix: 3,
      /**
       * A string used to split the prefix into several tokens. Don't split if 'null'.
       */
      prefixDelimiter: null,
      /**
       * Filter by prefix in memory. If 'false' then call the dataprovider with the new prefix.
       */
      inMemFilter: true,

      /**
       * Whether or not to escape item labels. Defaults to 'true'.
       */
      escapeHtml: true,

      /**
       * Whether or not to display the search bar. Defaults to 'true'.
       */
      search: true,

      /**
       * Should return a deferred resolved with a list of items. Each item should have the following properties:
       * 1. label - will be displayed in the list and the search will be based on it
       * 2. selected - true / false: initially selected
       *
       * @param prefix the prefix to filter by
       * @return $.Deferred the default is resolved with an empty list
       */
      dataprovider: function (prefix) {
        return $.Deferred().resolve([]);
      },

      /**
       * Renders the list.
       *
       * @param list the output of the data provider
       * @return $.Deferred a resolved deferred
       */
      renderer: function (list) {
        var self = this,
            listData = self._listData(),
            params = listData.params,
            selected = listData.selected;

        // Add the list items
        var $ul = $('<ul></ul>');

        $.each(list, function (idx, item) {
          var id = uuid4();

          var $li = $(listItemTmpl({
            id: id,
            item: item,
            escapeHtml: params.escapeHtml
          }));

          if (item.selected) {
            selected[id] = item;
          }

          // The search tokens
          if (params.inMemFilter) {
            item.tokens = tokenize(item.label.replace(/(<([^>]+)>)/ig, ''));
          }

          $li.data('listItem', item);

          $ul.append($li);
        });

        $ul.appendTo(self.find('.list-container').empty());

        // Select / deselect handlers
        $ul.on('click', 'li', function () {
          var selecteds = self._listData().selected,
              $li = $(this),
              id = $li.attr('id'),
              item = $li.data('listItem');

          var select = !selecteds.hasOwnProperty(id);

          if (!select) {
            // Deselect
            $li.removeClass('selected');
            delete selecteds[id];
          } else {
            // Select
            if (!params.multiselect) {
              $.each(Object.keys(selecteds), function (_, idx) {
                // Max. 1 item can be selected in this case
                $('#' + idx).removeClass('selected');
                delete selecteds[idx];
              });
            }

            $li.addClass('selected');
            selecteds[id] = item;
          }

          // Callback
          params.toggleSelect.call(self, item, select);
        });

        return $.Deferred().resolve();
      },

      toggleSelect: $.noop,
      rendered: $.noop,
      error: $.noop
    };

    $.fn.List.API = {

      cssMarker: 'ty-list',

      /**
       * Initialize the plugin on the current element.
       *
       * @param [params]
       * @return {$.fn.List} this
       */
      init: function (params) {
        var self = this;

        params = $.extend(true, {}, defaults, params);

        self.addClass($.fn.List.API.cssMarker).html(listTmpl({ search: params.search }))._listData({
          params: params,

          // Use a map for the selected items so we can easily add and remove them
          selected: {}
        });
        var delay = function () {
          var timer = 0;
          return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
          };
        }();

        // Search handler
        self.find('.search').keyup(function () {
          var prefix = $(this).val().toLowerCase();
          delay(function () {
            self.filter(prefix);
          }, 500);
        });

        self.refresh();

        return self;
      },

      /**
       * Set or get the list data.
       *
       * @param [data] if truthy set the new data object, otherwise retrieve it
       * @return Object the list data if the parameter is missing, otherwise the return value is not specified
       * @private
       */
      _listData: function (data) {
        var dataAttr = 'listData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },

      /**
       * Refresh the list:
       * 1. Call the data provider
       * 2. Call the renderer
       * 3. Call the rendered callback
       *
       * In case of errors call the error callback and interrupt the normal flow.
       *
       * @param [prefix] what to filter by
       * @return {$.fn.List} this
       */
      refresh: function (prefix) {
        var self = this,
            listData = self._listData(),
            params = listData.params,
            handleError = function (data) {
          if (this === 'canceled') {
            // Ignore canceled requests
            return;
          }

          params.error.call(self, data);
        };

        if (self._isLoading()) {
          // Cancel the current call
          listData.inProgress.cancel();
        }

        self._toggleLoading(true);

        listData.inProgress = params.dataprovider.call(self, prefix);
        listData.inProgress.done(function (list) {
          listData.inProgress = params.renderer.call(self, list);
          listData.inProgress.done(function () {
            delete listData.inProgress;

            self._toggleLoading(false);

            params.rendered.call(self);
          }).fail(handleError);
        }).fail(handleError);

        return this;
      },

      _isLoading: function () {
        return !!this._listData().loading;
      },

      _toggleLoading: function (loading) {
        this._listData().loading = loading;
        this.children('.ty-loading').toggle(loading);
        this.children('.content').toggle(!loading);

        return this;
      },

      /**
       * @return jQuery the content element of the list. The renderer should only add markup in here.
       */
      content: function () {
        return this.children('.content');
      },

      /**
       * @return Array list of the selected items. The order is not guaranteed.
       */
      getSelected: function () {
        return $.map(this._listData().selected, function (item) {
          return item;
        });
      },

      /**
       * Filter the list by the given prefix.
       *
       * @param [prefix]
       * @return {$.fn.List} this
       */
      filter: function (prefix) {
        var self = this,
            listData = self._listData(),
            prefixDelimiter = listData.params.prefixDelimiter,
            inMemFilter = listData.params.inMemFilter,
            minPrefix = listData.params.minPrefix;
        var hasMinLength = void 0,
            joinedPrefix = void 0;

        if (prefixDelimiter) {
          prefix = prefix.split(prefixDelimiter);
        } else {
          prefix = [prefix];
        }

        // Check that at least one token has the minimum length
        hasMinLength = false;
        $.each(prefix, function (idx, token) {
          token = $.trim(token);

          if (token.length >= minPrefix) {
            hasMinLength = true;

            return false;
          }
          return null;
        });

        // Nothing to search by
        if (!hasMinLength) {
          prefix = [];
        }

        if (!inMemFilter) {
          // Just refresh
          return self.refresh(prefix);
        }

        // Filter in memory
        var ul = self.find('ul');
        var ulParent = ul.parent();

        if (prefix.length) {
          joinedPrefix = prefix.join(' ');

          if (joinedPrefix === listData.filteredBy) {
            // Nothing to do
            return self;
          }

          // For performance reasons we first detach the list and then hide/show the elements
          ul.detach();

          // Filter
          ul.children().each(function () {
            var $li = $(this),
                item = $li.data('listItem');
            var match = true;

            $.each(prefix, function (idx, prefixToken) {
              var prefixMatch = false;

              $.each(item.tokens, function (_, token) {
                if (token.indexOf(prefixToken) === 0) {
                  prefixMatch = true;

                  return false;
                }
                return null;
              });

              // Short-circuit
              if (!prefixMatch) {
                match = false;

                return false;
              }
              return null;
            });

            $li.toggle(match);
          });

          // Save the filter
          listData.filteredBy = joinedPrefix;

          // Reattach
          ul.appendTo(ulParent);
        } else {
          // Display all the items
          if (!listData.filteredBy) {
            // Nothing to do
            return this;
          }

          // For performance reasons we first detach the list and then hide/show the elements
          ul.detach();

          // Show all
          ul.children().show();

          // Delete the filter
          delete listData.filteredBy;

          // Reattach
          ul.appendTo(ulParent);
        }

        return self;
      },

      /**
       * @return {$.fn.List} this
       */
      clearSelection: function () {
        // Remove the data
        this._listData().selected = {};

        // Update the UI
        var ul = this.find('.list-container ul');
        ul.detach();

        ul.find('li.selected').removeClass('selected');
        ul.appendTo(this.find('.list-container'));

        return this;
      }
    };

    return $.fn.List;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/ui_components/ui-component',['jquery'], function ($) {
    // base component class
    var UiComponent = function () {};
    UiComponent.prototype = Object.create({

      // Initially the ui might not match the state
      _changed: true,

      /**
       * Update the UI if the state has changed.
       */
      $updateUi: function () {
        if (!this._changed) {
          return;
        }
        this._$updateUi();
        this._changed = false;
      },

      /**
       * No default implementation.
       * @protected
       */
      _$updateUi: function () {
        throw new Error('Abstract method not implemented');
      }
    });

    /**
     * Wraps the given function in a method that marks the state as changed.
     * @param fn a function that can modify the state of the component. It should return 'true' if the state changed;
     * @return {Function}
     */
    UiComponent.change = function (fn) {
      return function () {
        this._changed = fn.apply(this, arguments) || this._changed; // eslint-disable-line prefer-rest-params
      };
    };

    /**
     * Updates one or more UiComponents or collections of UiComponents:
     * 1. if one of the parameters is an instance of UiComponent its $updateUi method is called.
     * 2. if an Array/Object the method will recursively iterate over it's items/properties
     */
    UiComponent.$updateUi = function () {
      var iterator = function (i, ui) {
        if (ui instanceof UiComponent) {
          ui.$updateUi();
        } else {
          $.each(ui, iterator);
        }
      };
      $.each(arguments, iterator); // eslint-disable-line prefer-rest-params
    };

    return UiComponent;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/ui_components/smart-list',['jquery', 'widget', 'UiComponent'], function ($, widget, UiComponent) {
    var tridentRegexp = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');

    // utils
    var uuid = function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise, no-mixed-operators
        return v.toString(16);
      });
    };

    var parseJsonString = function (str) {
      if (!str) {
        return null;
      }
      try {
        return JSON.parse(str);
      } catch (e) {
        return null;
      }
    };

    // Item group
    var Group = function ($group, selectedClass) {
      this.$group = $group;

      // generate and save a unique value
      this.value = uuid();
      $group.data(Group.valueName, this.value);
      this.items = [];
      this.childGroups = [];
      this.selectedClass = selectedClass;
    };

    Group.prototype = $.extend(Object.create(UiComponent.prototype), {
      /* eslint-disable consistent-return */
      show: UiComponent.change(function (show) {
        if (this.visible === show) {
          return;
        }
        this.visible = show;
        return true;
      }),
      _select: UiComponent.change(function (select) {
        if (this.selected === select) {
          return;
        }
        this.selected = select;
        return true;
      }),
      /* eslint-enable consistent-return */
      sync: function () {
        var checkGroupVisibility = function (group) {
          var visibleItems = group.items.filter(function (it) {
            return it.visible;
          });
          var visible = false;
          group.childGroups.forEach(function (childGroup) {
            visible = visible || checkGroupVisibility(childGroup);
          });
          return !!visibleItems.length || visible;
        };

        var visibleItems = this.items.filter(function (it) {
          return it.visible;
        });
        var selected = visibleItems.every(function (it) {
          return it.selected;
        });
        var visible = checkGroupVisibility(this);

        this._select(selected);
        this.show(visible);
      },
      _$updateUi: function () {
        if (this.visible) {
          this.$group.removeClass('is-hidden');
        } else {
          this.$group.addClass('is-hidden');
        }

        if (this.selected) {
          this.$group.addClass(this.selectedClass);
        } else {
          this.$group.removeClass(this.selectedClass);
        }
      }
    });

    Group.valueName = 'smartlistGroupValue';

    Group.value = function ($group) {
      return $group.data(Group.valueName);
    };

    // Item
    var Item = function ($item, selectedClass, group) {
      this.$item = $item;
      this.selectedClass = selectedClass;
      this.group = group;
      this.value = Item.value($item);
      this.label = Item.label($item);
      this.extra = Item.extra($item);
      this.subtitle = $item.find('>a.value>.smart-list-item-subtitle') ? $item.find('>a.value>.smart-list-item-subtitle').html() : null;
      this.selected = $item.hasClass(selectedClass);
      this.visible = !$item.hasClass('is-hidden');

      // The ui matches in the beginning
      this._changed = false;
    };

    Item.prototype = $.extend(Object.create(UiComponent.prototype), {
      /* eslint-disable consistent-return */
      show: UiComponent.change(function (show) {
        if (this.visible === show) {
          return;
        }
        this.visible = show;
        return true;
      }),
      select: UiComponent.change(function (select) {
        if (this.selected === select) {
          return;
        }
        this.selected = select;
        return true;
      }),
      /* eslint-enable consistent-return */
      _$updateUi: function () {
        if (this.visible) {
          this.$item.removeClass('is-hidden');
        } else {
          this.$item.addClass('is-hidden');
        }

        if (this.selected) {
          this.$item.addClass(this.selectedClass);
        } else {
          this.$item.removeClass(this.selectedClass);
        }
      }
    });

    Item.value = function ($item) {
      return $item.attr('data-value');
    };

    Item.label = function ($item) {
      if ($item.attr('data-label')) {
        return $item.attr('data-label');
      }
      return $item.find('>a.value>.smart-list-item').html();
    };

    Item.extra = function ($item) {
      return $item.attr('data-extra');
    };

    // toggle select all
    var SelectAll = function ($selectAll, items) {
      this.$selectAll = $selectAll;
      this.items = items;
    };

    SelectAll.prototype = $.extend(Object.create(UiComponent.prototype), {
      /* eslint-disable consistent-return */
      _select: UiComponent.change(function (select) {
        if (this.selected === select) {
          return;
        }
        this.selected = select;
        return true;
      }),
      /* eslint-enable consistent-return */
      sync: function () {
        var visible = this.items.filter(function (it) {
          return it.visible;
        });
        var all = visible.length && visible.every(function (it) {
          return it.selected;
        });
        this._select(!!all);
      },
      _$updateUi: function () {
        this.$selectAll.prop('checked', this.selected);
      }
    });

    // widget
    $.widget('ty.smartlist', widget, {
      options: {
        multiple: true,
        allowTooltip: true,
        filter: '.smart-list-searchbox input',
        toggleSelectAll: '.smart-list-select-all input',
        toggleAccept: '.smart-list-accept a',
        itemGroup: '.smart-list-group, .divider',
        itemGroupSelect: '.smart-list-group-title',
        item: '.smart-list-items li:not(.smart-list-group,.is-disabled, .divider)',
        selectedClass: 'selected',
        disabledClass: 'is-disabled',
        onSearchQueryChange: $.noop,
        onItemSelect: $.noop,
        filterCallback: function (term, items) {
          // search only word prefixes
          var terms = $.map(term.split(' '), function (t) {
            var regexEscape = function (str) {
              return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
            },
                regex = new RegExp('\\b' + regexEscape(t), 'i');

            if (t && regex.test(regexEscape(t))) {
              return regex;
            } else if (t) {
              return new RegExp('\\B' + regexEscape(t), 'i');
            } else {
              return null;
            }
          });
          return $.map(items, function (it) {
            return (
              // TODO remove non alphanumeric characters?
              terms.every(function (t) {
                return t.test(it.label);
              }) ? it : null
            );
          });
        },
        filterDelay: 500
      },

      // Nasty hack for IE11, somehow doesnt redraw the element when toggling the class
      _ie11redraw: function () {
        if (navigator.appName === 'Netscape' && tridentRegexp.test(navigator.userAgent) || navigator.appName === 'Microsoft Internet Explorer') {
          this.element.hide().show();
        }
      },

      // to show the placeholder if the filter result is empty
      _updateEmptyPlaceholder: function () {
        var self = this;
        if ($(self.element).find('li:not(".is-hidden")').length === 0) {
          $(self.element).find('.placeholder-box').removeClass('is-hidden');
        } else {
          $(self.element).find('.placeholder-box').addClass('is-hidden');
        }
      },

      _create: function () {
        var self = this,
            options = self.options;

        // item click
        this._on(['click', options.item, this._callWhenEnabled(function () {
          var value = Item.value($(this));
          var it = self.itemMap[value];
          self.select([it]);
          options.onItemSelect(this, it);
        })]);

        // selectable groups work only for multiple selection lists
        if (options.multiple) {
          this._on(['click', options.itemGroupSelect, this._callWhenEnabled(function () {
            var value = Group.value($(this).closest(options.itemGroup));
            var g = self.groupMap[value];

            // select visible group items
            self.select(g.items.filter(function (it) {
              return it.visible;
            }), !g.selected);
          })]);
        }

        // triger accept
        this._on(['click', options.toggleAccept, this._callWhenEnabled(function () {
          self._trigger('accept', null, { val: self.val() });
        })]);

        // select all
        this._on(['change', options.toggleSelectAll, this._callWhenEnabled(function () {
          var select = $(this).prop('checked');

          // select visible items
          self.select(self.itemList.filter(function (it) {
            return it.visible;
          }), select);
        })]);

        // filter items
        var filterHandler = function ($filterInput) {
          var term = $.trim($filterInput.val());

          // filter items
          var matched = options.filterCallback(term, self.itemList);
          if (!matched) {
            // nothing to do (e.g. the term didn't change)
            return;
          }

          var matchedSet = {};
          matched.forEach(function (it) {
            matchedSet[it.value] = true;
          });

          // hide all the items and show the ones we need
          self.itemList.forEach(function (it) {
            it.show(!!matchedSet[it.value]);
          });

          // hide empty item groups
          self.groupList.forEach(function (g) {
            g.sync();
          });

          self.selectAllBtn.sync();

          // update ui
          UiComponent.$updateUi(self.itemList, self.groupList, self.selectAllBtn);
          self._updateEmptyPlaceholder();
          self._ie11redraw();
        };
        (function () {
          var timer = null;
          self._on(['keyup', options.filter, function () {
            var $this = $(this);
            if (timer) {
              clearTimeout(timer);
            }
            timer = setTimeout(function () {
              filterHandler($this);
              timer = null;
              options.onSearchQueryChange($this.val());
            }, options.filterDelay);
          }]);
        })();

        if (options.allowTooltip) {
          // long item tooltips
          self._on(['mouseenter', options.item + ',' + options.itemGroup, function () {
            var $this = $(this);
            var text = $this.text();
            if ($this.attr('title') === text) {
              // nothing to do
              return;
            }

            // clone and measure the width difference
            var $clone = $this.clone().css({ display: 'inline', width: 'auto', visibility: 'hidden', position: 'absolute' }).appendTo($this.parent());
            if ($this.width() < $clone.width()) {
              $this.attr('title', text);
            } else {
              $this.removeAttr('title');
            }
            $clone.remove();
          }]);
        }
      },

      _init: function () {
        var $element = this.element,
            options = this.options;

        // disabled
        this.disabled = $element.hasClass(options.disabledClass);

        // item groups
        var groupMap = {};
        var groupList = [];

        $element.find(options.itemGroup).each(function () {
          var g = new Group($(this), options.selectedClass);
          var parentGroup = groupMap[Group.value($(this).parent().closest(options.itemGroup))];
          if (parentGroup) {
            parentGroup.childGroups.push(g);
          }
          groupMap[g.value] = g;
          groupList.push(g);
        });

        this.groupMap = groupMap;
        this.groupList = groupList;

        // items
        var itemList = [];
        var itemMap = {};
        $element.find(options.item).each(function () {
          // item and group
          var $it = $(this);
          var g = groupMap[Group.value($it.closest(options.itemGroup))];
          var item = new Item($it, options.selectedClass, g);

          if (g) {
            g.items.push(item);
          }
          itemList.push(item);
          itemMap[item.value] = item;
        });
        this.itemList = itemList;
        this.itemMap = itemMap;

        // toggle group selected state
        groupList.forEach(function (g) {
          g.sync();
        });

        // select all state
        this.selectAllBtn = new SelectAll($element.find(options.toggleSelectAll), this.itemList);
        this.selectAllBtn.sync();

        // update ui
        UiComponent.$updateUi(groupList, this.selectAllBtn);
        this._updateEmptyPlaceholder();
        this._ie11redraw();
      },

      select: function (items, select) {
        if (select === undefined && items.length > 1) {
          throw new Error('cannot infer select from multiple items');
        }

        var options = this.options;

        // infer the select
        if (select === undefined) {
          if (options.multiple) {
            // toggle
            select = !items[0].selected;
          } else {
            // always select
            select = true;
          }
        }

        // break if the state doesn't change
        items = items.filter(function (it) {
          return it.selected !== select;
        });
        if (!items.length) {
          return;
        }

        // deselect existing item in case of single selection lists
        if (!options.multiple) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = this.itemList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var it = _step.value;

              if (it.selected) {
                it.select(false);
                it.$updateUi();
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        // keep a record of the groups that should be updated
        var changedGroups = {};
        items.forEach(function (it) {
          it.select(select);
          if (it.group) {
            changedGroups[it.group.value] = it.group;
          }
        });

        // sync groups
        $.each(changedGroups, function (v, g) {
          g.sync();
        });

        // sync select all
        this.selectAllBtn.sync();

        // update ui
        UiComponent.$updateUi(items, changedGroups, this.selectAllBtn);
        this._updateEmptyPlaceholder();
        this._ie11redraw();

        // fire event
        this._trigger('change', null, { val: this.val() });
      },

      /**
       * if 'values' is present, only the specified values will be selected.
       * If not, the function returns
       * the selected values: an array for multiple selection lists, or the value for
       * single selections (null if missing)
       * @param [values]
       * @return {*}
       */
      /* eslint-disable consistent-return */
      val: function (values) {
        var selected = void 0,
            itemMap = void 0,
            valuesMap = void 0,
            multipleDeselect = void 0,
            multipleSelect = void 0;

        if (values) {
          // select only the specified values
          itemMap = this.itemMap;

          if (!this.options.multiple) {
            // single-select
            this.select([itemMap[values]], true);
          } else {
            valuesMap = {};
            values.forEach(function (v) {
              valuesMap[v] = true;
            });

            multipleDeselect = [];
            multipleSelect = [];
            this.itemList.forEach(function (it) {
              if (valuesMap[it.value]) {
                multipleSelect.push(it);
              } else {
                multipleDeselect.push(it);
              }
            });
            this.select(multipleDeselect, false);
            this.select(multipleSelect, true);
          }
        } else {
          // return selected values
          selected = $.map(this.itemList, function (it) {
            if (it.selected) {
              return it.value;
            }
          });

          if (this.options.multiple) {
            return selected;
          }
          if (selected.length > 1) {
            throw new Error('multiple items are selected in a single-selection list');
          }
          if (selected.length === 1) {
            return selected[0];
          }
          return null;
        }
      },
      /* eslint-enable consistent-return */

      items: function () {
        return this.itemList.map(function (it) {
          return {
            value: it.value,
            label: it.label,
            extra: parseJsonString(it.extra)
          };
        });
      },

      itemlist: function () {
        return this.itemList;
      },

      selectAll: function (select) {
        this.select(this.itemList, select);
        UiComponent.$updateUi(this.itemList, this.groupList, this.selectAllBtn);
        this._updateEmptyPlaceholder();
        this._ie11redraw();
      }
    });

    return $.ty.smartlist;
  });
})();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/ui_components/dropdown',['jquery', 'widget', 'UiComponent'], function ($, widget, UiComponent) {
    var Dropdown = function ($dd, openClass) {
      this.$dd = $dd;
      this.openClass = openClass;
      this.open = $dd.hasClass(openClass);
      this._change = false;
    };
    Dropdown.prototype = $.extend(Object.create(UiComponent.prototype), {
      toggle: UiComponent.change(function (open) {
        if (this.open === open) {
          return false;
        }
        this.open = open !== undefined ? open : !this.open;
        return true;
      }),
      _$updateUi: function () {
        this.$dd.toggleClass(this.openClass, this.open);
      }
    });

    // keep track of dropdowns from which an event originated
    var bindDropdown = function (dropdown, evt) {
      var dds = void 0;
      if (evt.originalEvent) {
        // ie8 only allows returnValue to be modified in the bubbling event object
        // chrome and other browser do not allow the editing of returnValue
        // therefore we set 2 fields to cover both cases
        if (_typeof(evt.originalEvent.returnValue) === 'object') {
          evt.originalEvent.returnValue = {
            ty_dropdown: 'ty_dropdown' in evt.originalEvent.returnValue ? evt.originalEvent.returnValue.ty_dropdown : [],
            status: 'status' in evt.originalEvent.returnValue ? evt.originalEvent.returnValue.status : true
          };
        } else {
          evt.originalEvent.returnValue = {
            ty_dropdown: [],
            status: true
          };
        }

        if (_typeof(evt.originalEvent.returnValue) === 'object') {
          dds = evt.originalEvent.returnValue.ty_dropdown = evt.originalEvent.returnValue.ty_dropdown || [];
        } else {
          dds = evt.originalEvent.ty_dropdown = evt.originalEvent.ty_dropdown || [];
        }
      } else {
        dds = evt.ty_dropdown = evt.ty_dropdown || [];
      }
      dds.push(dropdown);
    };
    var getDropdown = function (evt) {
      if (evt.originalEvent) {
        if (_typeof(evt.originalEvent.returnValue) === 'object') {
          return 'ty_dropdown' in evt.originalEvent.returnValue ? evt.originalEvent.returnValue.ty_dropdown : [];
        } else {
          return evt.originalEvent.ty_dropdown || [];
        }
      } else {
        return evt.ty_dropdown || [];
      }
    };
    var clearDropdown = function (evt) {
      var status = true;

      if (evt.originalEvent) {
        if (_typeof(evt.originalEvent.returnValue) === 'object') {
          status = 'status' in evt.originalEvent.returnValue ? evt.originalEvent.returnValue.status : true;

          delete evt.originalEvent.returnValue;

          evt.originalEvent.returnValue = status;
        } else if (evt.originalEvent.ty_dropdown) {
          delete evt.originalEvent.ty_dropdown;
        }
      } else {
        delete evt.ty_dropdown;
      }
    };

    /*
     **************** 'blur' event ******************
     The problem with blur events is that they fire even when you click on a child of the focused element.
     The workaround:
     1. Register a global click handler on the document
     2. When it catches an event look through the list of open widgets and if it occurred outside of them, close them
     */
    var openWidgets = {
      cache: [],
      indexOf: function (wgt) {
        var i = void 0;
        var element = wgt.element;
        for (i = this.cache.length - 1; i >= 0; i -= 1) {
          if (element === this.cache[i].element) {
            return i;
          }
        }
        return -1;
      },
      add: function (wgt) {
        var i = this.indexOf(wgt);
        if (i === -1) {
          this.cache.push(wgt);
        }
      },
      remove: function (wgt) {
        var i = this.indexOf(wgt);
        if (i !== -1) {
          this.cache.splice(i, 1);
        }
      }
    };

    $(document).on('click', function (evt) {
      var i = void 0,
          wgt = void 0;

      // close a dropdown if the event didn't originate from it
      var dropdownOrigin = getDropdown(evt);
      for (i = openWidgets.cache.length - 1; i >= 0; i -= 1) {
        wgt = openWidgets.cache[i];
        if (dropdownOrigin.indexOf(wgt) === -1) {
          wgt.open(false);
        }
      }
      clearDropdown(evt);
    });

    $.widget('ty.dropdown', widget, {
      options: {
        toggle: '.dropdown-toggle, [data-toggle="dropdown"]',
        label: '.dropdown-toggle span, [data-toggle="dropdown"]',
        openClass: 'open',
        disabledClass: 'is-disabled',
        iconAnimation: true
      },

      _create: function () {
        var self = this,
            $element = this.element,
            options = this.options;
        this._on(['click', function (evt) {
          // mark the event as having originated from this dropdown, so that it doesn't collapse
          bindDropdown(self, evt);
        }]);
        this._on(['click', options.toggle, this._callWhenEnabled(function () {
          // bind only to min level elements
          if (!self._isLevel($(this), $element, self.toggleLevel)) {
            return;
          }
          self.open();
        })]);

        // long label tooltip
        self._on(['mouseenter', options.label, function () {
          var $this = $(this);

          // bind only to min level elements
          if (!self._isLevel($this, $element, self.labelLevel)) {
            return;
          }

          var text = $this.text();
          if ($this.attr('title') === text) {
            // nothing to do
            return;
          }

          // clone and measure the width difference
          var $clone = $this.clone().css({ display: 'inline', width: 'auto', visibility: 'hidden' }).appendTo($this.parent());
          if ($this.width() < $clone.width()) {
            $this.attr('title', text);
          } else {
            $this.removeAttr('title');
          }
          $clone.remove();
        }]);
      },
      _init: function () {
        var $element = this.element,
            options = this.options;

        this.toggleLevel = this._minLevel($element, options.toggle);
        this.labelLevel = this._minLevel($element, options.label);

        // disabled
        this.disabled = $element.hasClass(options.disabledClass);

        this.dropdown = new Dropdown($element, options.openClass);
        this.dropdown.$updateUi();
      },
      open: function (open) {
        this.dropdown.toggle(open);
        if (this.dropdown.open) {
          openWidgets.add(this);
        } else {
          openWidgets.remove(this);
        }
        this.dropdown.$updateUi();
        this._trigger('open', null, { open: this.dropdown.open });
      },
      /**
       * Returns the minimum level where a descendat of $context matches the selector. Example:
       * Given the markup:
       * ul
       *   li
       *     a
       *       span
       *   li
       *     span
       *
       * _minLevel($('ul'), 'li') -> 1
       * _minLevel($('ul'), 'span') -> 2  // the second span is closer to the list element
       *
       * @param $context
       * @param selector
       * @return {number}
       * @protected
       */
      _minLevel: function ($context, selector) {
        return Math.min.apply(Math, _toConsumableArray($context.find(selector).toArray().map(function (c) {
          return $(c).parentsUntil($context).length;
        })));
      },
      /**
       * Checks if the $element is a descendat of $context, at the given level.
       *
       * @param $element
       * @param $context
       * @param level
       * @return {boolean}
       * @protected
       */
      _isLevel: function ($element, $context, level) {
        return !!$context.has($element[0]).length && $element.parentsUntil($context).length === level;
      }
    });

    return $.ty.dropdown;
  });
})();
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/ui_components/dropdown-smartlist',['jquery', 'dropdown', 'smartlist'], function ($, dropdown) {
    $.widget('ty.dropdownsmartlist', dropdown, {
      options: {
        content: '.dropdown-smart-list',
        label: '.dropdown-toggle span, [data-toggle="dropdown"] span',
        smartlist: '.smart-list',
        multiple: true,
        allowTooltip: true,
        iconAnimation: true,
        showSelectOption: false,
        selectLabel: 'Select',
        item: undefined,
        /* eslint-disable consistent-return */
        getLabel: function (val, items) {
          var options = this.dropdownsmartlist('option');

          // Get the selected label for single selection lists
          if (!options.multiple) {
            var results = items.filter(function (item) {
              return item.value === val;
            });
            return results.length ? results[0].label : undefined;
          }
        }
        /* eslint-enable consistent-return */
      },

      _create: function () {
        var self = this;
        // super
        dropdown.prototype._create.apply(this, arguments); // eslint-disable-line prefer-rest-params

        var options = this.options;
        this._on(['smartlistchange', options.smartlist, this._callWhenEnabled(function (e, data) {
          self.updateLabel(data.val);

          // close single-selection lists
          if (!options.multiple) {
            self.open(false);
          }

          // trigger the event
          self._trigger('change', e, data);
        })]);
        this._on(['smartlistaccept', options.smartlist, this._callWhenEnabled(function (e, data) {
          self._trigger('accept', e, data);
          self.open(false);
        })]);
      },
      _init: function () {
        // super
        dropdown.prototype._init.apply(this, arguments); // eslint-disable-line prefer-rest-params

        var options = this.options;
        var $element = this.element;
        this.$label = $element.find(options.label);
        this.$smartlist = $element.find(options.smartlist).smartlist({
          multiple: options.multiple,
          allowTooltip: options.allowTooltip,
          disabled: options.disabled,
          item: options.item,
          onItemSelect: options.onItemSelect,
          filterCallback: options.filterCallback
        });
        this.updateLabel();
      },
      _destroy: function () {
        this.$smartlist.smartlist('destroy');
        dropdown.prototype._destroy.apply(this, arguments); // eslint-disable-line prefer-rest-params
      },
      updateLabel: function (val) {
        var options = this.options;
        var label = void 0;
        if (options.getLabel) {
          if (!val) {
            val = this.val();
          }
          label = options.getLabel.call(this.widget(), val, this.$smartlist.smartlist('items'));

          // show select label in case no item is selected and this option is activated
          if (label === undefined && options.showSelectOption) {
            this.$label.html(options.selectLabel);
          } else if (label !== undefined) {
            this.$label.html(label);
          }
        }
      },
      _delegateSmartList: function (method, args) {
        var $smartlist = this.$smartlist;
        args = Array.prototype.slice.apply(args);
        args.unshift(method);
        return $smartlist.smartlist.apply($smartlist, _toConsumableArray(args));
      },
      val: function () {
        return this._delegateSmartList('val', arguments); // eslint-disable-line prefer-rest-params
      },
      selectAll: function () {
        var result = this._delegateSmartList('selectAll', arguments); // eslint-disable-line prefer-rest-params
        this.updateLabel();
        return result;
      },
      items: function () {
        return this._delegateSmartList('items', arguments); // eslint-disable-line prefer-rest-params
      },
      smartlist: function () {
        return this.$smartlist;
      }
    });

    return $.ty.dropdownsmartlist;
  });
})();
define('commons/public/jadec/ui_components/ty-checkbox',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div" + (jade.attrs({ 'id':("" + (id) + ""), "class": ('trustyou-ui') + ' ' + ('toggle') + ' ' + ('toggle-sm') + ' ' + ('l-right') + ' ' + ("" + (activeClass) + "") }, {"class":true,"id":true})) + "><div class=\"toggle-handle\"></div></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/ui_components/ty-checkbox',['jquery', '../../jadec/ui_components/ty-checkbox'], function ($, checkBoxTemplate) {
    // From https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    function uuidv4() {
      var crypto = window.crypto || window.msCrypto;
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      } // eslint-disable-line
      );
    }

    /*
     * Nice styled checkbox
     *
     * @params {boolean} isChecked - state of the checkbox
     * @params {string}	id - id for the element
     * @params {function} onChange(state) - callback with the state after the click happend
     */
    function TYCheckbox(isChecked, id, onChange) {
      var checkBoxId = id || 'checkbox-' + uuidv4();
      var activeCssClass = isChecked ? 'is-active' : '';

      var $checkBoxEl = $(checkBoxTemplate({
        id: checkBoxId,
        activeClass: activeCssClass
      }));

      $(document).on('click', '#' + checkBoxId, function (event) {
        var $elem = $(event.target);
        $elem.toggleClass('is-active');

        onChange && onChange($elem.hasClass('is-active'));
      });

      return $checkBoxEl;
    }

    return TYCheckbox;
  });
})();
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  define('commons/public/js/ui_components/dropdown-2level-smartlist',['jquery', 'dropdown', 'smartlist'], function ($, dropdown) {
    $.widget('ty.dropdown2levelsmartlist', dropdown, {

      options: {

        // Generic
        content: '.dropdown-tabs',
        smartlist: '.outer-list',
        innerItems: '.inner-lists .custom-input-container',
        innerLists: '.inner-lists .list-input-container',
        label: '.dropdown-toggle span',
        multiple: false,
        outerActiveClass: 'active',
        outerSelectedClass: 'selected',
        outerSelectedTag: '.ty-icon-check',
        iconAnimation: true,

        // Custom Input Fields related:
        customInputContainerClass: 'custom-input-container',
        customInputFieldClass: 'custom-input-field',
        customInputResetBtnClass: 'custom-input-field-reset-btn',
        dateFormat: 'yy-mm-dd',
        textBoxInputType: 'textbox',
        datePickerInputType: 'datepicker',

        // getLabel Helper
        /* eslint-disable consistent-return */
        getLabel: function (val, items) {
          var label = void 0;
          var options = this.dropdown2levelsmartlist('option');

          // Get the selected label for single selection lists
          if (!options.multiple) {
            $.each(items || [], function (idx, it) {
              if (it.value === val) {
                label = it.label;
                return false;
              }
            });
            return label;
          }
        }
        /* eslint-enable consistent-return */
      },

      _create: function () {
        var self = this;

        // super
        dropdown.prototype._create.apply(this, arguments); // eslint-disable-line prefer-rest-params

        var options = this.options;

        // Smart List Events
        this._on(['smartlistchange', options.smartlist, this._callWhenEnabled(function (e, data) {
          // show selected panel
          var $element = self.element;

          // $element.find('.tab-panel').removeClass(options.outerActiveClass);
          // $element.find('#' + data.val).addClass(options.outerActiveClass);

          // FIXME: short term solution as we had IE11 problems
          // using the classes only (display:block was popping up there automagically)
          $element.find('.tab-panel').hide();
          $element.find('#' + data.val).show();

          // trigger the event
          self._trigger('change', e, data);
        })]);

        this._on(['smartlistchange', options.innerLists, this._callWhenEnabled(function (e, data) {
          self.updateLabel();
          self.updateOuterLabels();

          // trigger the event
          self._trigger('change', e, data);
        })]);

        this._on(['smartlistaccept', options.innerLists, this._callWhenEnabled(function (e, data) {
          self._trigger('accept', e, data);
          self.open(false);
        })]);

        // Custom-Input-Field Container's 'valueChanged' event
        this._on(['valueChanged', options.innerItems, this._callWhenEnabled(function (e, data) {
          self.updateLabel();
          self.updateOuterLabels();

          // trigger the event
          self._trigger('change', e, data);
        })]);
      },

      _init: function () {
        // super
        dropdown.prototype._init.apply(this, arguments); // eslint-disable-line prefer-rest-params

        var options = this.options;
        var $element = this.element;
        this.$label = $element.find(options.label);

        // outer list
        this.$smartlist = $element.find(options.smartlist).smartlist({
          multiple: options.multiple,
          disabled: options.disabled,
          selectedClass: options.outerActiveClass
        });

        // inner lists
        var items = this.items();
        var innerLists = {};

        // helper function
        var formatDataValueAttr = function (outerItemProp, innerItemVal) {
          return outerItemProp + '::' + innerItemVal;
        };

        /**
         * Loop over the given items and either create the specified input fields for them.
         * If an item specifies which input field to create via its 'inputType' object attribute then create that,
         * otherwise create the default one, which is a smartlist.
         */
        $.each(items || [], function (idx, item) {
          var $currentElement = $element.find('#' + item.value);
          var $innerElement = null;

          // A Custom Input Container
          if ($currentElement && $currentElement.hasClass(options.customInputContainerClass)) {
            // Selectors
            var customInputFieldSelector = '#' + item.value + ' .' + options.customInputFieldClass;
            var customInputResetBtnSelector = '#' + item.value + ' .' + options.customInputResetBtnClass;

            // Elements
            var $customInputField = $element.find(customInputFieldSelector);

            // input-type attribute
            var inputTypeAttrVal = $customInputField.attr('input-type').toString().toLowerCase();

            // selected attribute
            var preSelectedAttrVal = $customInputField.attr('pre-selected').toString().toLowerCase();

            // data-value attribute
            var dataValueAttrVal = $customInputField.attr('data-value').toString();

            var $customInputFieldResetBtn = void 0,
                parts = void 0;

            // DatePicker widget
            if (inputTypeAttrVal === options.datePickerInputType) {
              //
              // Destroy any existing DatePicker widget
              $element.find(customInputFieldSelector).datepicker('destroy');

              // Initialize the DatePicker widget
              $innerElement = $element.find(customInputFieldSelector).datepicker({
                dateFormat: options.dateFormat,
                defaultDate: null,
                minDate: null,
                maxDate: null,
                onSelect: function (selectedDate) {
                  if (selectedDate && selectedDate.toString() !== '') {
                    // Format the data-value attribute value
                    var dataValAttr = formatDataValueAttr(item.value, selectedDate);

                    // Update data-value attribute
                    $(this).attr('data-value', dataValAttr);

                    // Trigger valueChanged custom event on the container element
                    $($currentElement).trigger('valueChanged', dataValAttr);
                  }
                }
              }).click('click', function (event) {
                event.preventDefault();
              }).on('reset', function () {
                // Clear the selected date
                $(this).attr('value', '');
                $.datepicker._clearDate(this);

                // Trigger valueChanged custom event on the container element
                $($currentElement).trigger('valueChanged', null);
              });

              // Setup the Reset button if it exists
              $customInputFieldResetBtn = $element.find(customInputResetBtnSelector);
              if ($customInputFieldResetBtn) {
                $element.find(customInputResetBtnSelector).click(function () {
                  $innerElement.trigger('reset');
                });
              }

              // If this segment was selected, then set the date
              if (preSelectedAttrVal === 'selected') {
                var selectedDateStr = null;
                parts = dataValueAttrVal.split('::') || [];

                if (parts.length > 1 && parts[1] && parts[1].toString() !== '') {
                  selectedDateStr = $.datepicker.formatDate(options.dateFormat, new Date(parts[1]));
                  $innerElement.datepicker('setDate', selectedDateStr);
                }
              } else {
                $innerElement.trigger('reset');
              }

              // Disable any anchor click event side effects for the container div
              $currentElement.on('click', 'a[href=#]', false);
            } else if (inputTypeAttrVal === options.textBoxInputType) {
              // TextBox Component
              // Setup textbox and its events
              $innerElement = $element.find(customInputFieldSelector).keyup(function () {
                var dataValAttr = null;
                var textboxVal = $(this).val();

                if (textboxVal !== undefined && textboxVal !== null && textboxVal !== '') {
                  dataValAttr = formatDataValueAttr(item.value, textboxVal);
                }

                // Update the data-value attribute
                $(this).attr('data-value', dataValAttr);

                // Trigger valueChanged custom event on the container element
                $($currentElement).trigger('valueChanged', dataValAttr);
              }).on('reset', function () {
                // Update value and data-value attributes
                $(this).val('');
                $(this).attr('data-value', null);

                // Trigger valueChanged custom event on the container element
                $($currentElement).trigger('valueChanged', null);
              });

              // Setup the Reset button if it exists
              $customInputFieldResetBtn = $element.find(customInputResetBtnSelector);
              if ($customInputFieldResetBtn) {
                $element.find(customInputResetBtnSelector).click(function () {
                  $innerElement.trigger('reset');
                });
              }

              // If this segment was selected, then set the date
              if (preSelectedAttrVal === 'selected') {
                parts = dataValueAttrVal.split('::') || [];

                if (parts.length > 1 && parts[1] && parts[1].toString() !== '') {
                  $innerElement.val(parts[1]).trigger('keyup');
                }
              } else {
                $innerElement.trigger('reset');
              }

              // Disable any anchor click event side effects for the container div
              $currentElement.on('click', 'a[href=#]', false);
            } else {
              // Unknown input-type value.
              // Leave $innerElement set to null, will be handled below.
              $innerElement = null;
            }
          }

          // Default: SmartList
          if ($currentElement && $innerElement === null) {
            $innerElement = $currentElement.smartlist({
              multiple: true,
              disabled: options.disabled
            });
          }

          innerLists[item.value] = $innerElement;
        });

        this.innerLists = innerLists;
        this.updateLabel();
        this.updateOuterLabels();

        // FIXME: short term solution as we had IE problems
        $element.find('.outer-list .smart-list-items li').removeClass(options.outerActiveClass);
        $element.find('.outer-list .smart-list-items li:first-child').addClass(options.outerActiveClass);
        $element.find('.tab-panel').hide();
        $element.find('.tab-panel:first-child').show();
      },

      _destroy: function () {
        var self = this;

        // Destroy CustomInput components
        $.each(self.innerLists || [], function (prop, $innerItem) {
          if ($innerItem.hasClass(self.options.customInputFieldClass)) {
            var inputType = ($innerItem.attr('input-type') || '').toString().toLowerCase();

            // DatePicker widget
            if (inputType === self.options.datePickerInputType) {
              $innerItem.datepicker('destroy');
            }
          }
        });

        // Destroy SmartLists
        this.$smartlist.smartlist('destroy');
        dropdown.prototype._destroy.apply(this, arguments); // eslint-disable-line prefer-rest-params
      },

      updateLabel: function (val) {
        var options = this.options;
        var label = void 0;

        if (options.getLabel) {
          if (!val) {
            val = this.val();
          }

          label = options.getLabel.call(this.widget(), val, this.$smartlist.smartlist('items'));

          if (label !== undefined) {
            this.$label.text(label);
          }
        }
      },

      updateOuterLabels: function () {
        var $element = this.element,
            options = this.options;

        var formatCustomInputValue = function (outerItemProp, inputValueAsStr) {
          return [outerItemProp + '::' + inputValueAsStr];
        };

        $.each(this.innerLists || [], function (prop, $innerItem) {
          var innerVal = [],
              selectedTag = null,
              $outerElement = null;

          if ($innerItem.hasClass(options.customInputFieldClass)) {
            var inputType = $innerItem.attr('input-type').toString().toLowerCase();

            // DatePicker widget
            if (inputType === options.datePickerInputType) {
              var date = $innerItem.datepicker('getDate');

              if (date !== null) {
                date = $.datepicker.formatDate(options.dateFormat, date);
                innerVal = formatCustomInputValue(prop, date);
              } else {
                innerVal = [];
              }
            } else if (inputType === options.textBoxInputType) {
              // TextBox Component
              var textboxVal = $innerItem.val();
              if (textboxVal !== null && textboxVal !== '') {
                innerVal = formatCustomInputValue(prop, textboxVal);
              } else {
                innerVal = [];
              }
            }

            $outerElement = $element.find(options.smartlist).find('[data-value=' + prop + ']');
            selectedTag = $outerElement.find(options.outerSelectedTag);

            if (innerVal.length > 0) {
              selectedTag.show();
              $outerElement.addClass(options.outerSelectedClass);
            } else {
              selectedTag.hide();
              $outerElement.removeClass(options.outerSelectedClass);
            }
          } else {
            innerVal = $innerItem.smartlist('val');
            $outerElement = $element.find(options.smartlist).find('[data-value=' + prop + ']');

            selectedTag = $outerElement.find(options.outerSelectedTag);

            if (innerVal && innerVal.length && innerVal.length > 0) {
              selectedTag.show();
              $outerElement.addClass(options.outerSelectedClass);
            } else {
              selectedTag.hide();
              $outerElement.removeClass(options.outerSelectedClass);
            }
          }
        });
      },

      val: function () {
        var aggrVal = [],
            options = this.options;

        var formatCustomInputValue = function (outerItemProp, inputValueAsStr) {
          return [outerItemProp + '::' + inputValueAsStr];
        };

        $.each(this.innerLists || [], function (prop, $innerItem) {
          var innerVal = [];

          // Major Case #1: the inner item is a custom input field.
          if ($innerItem.hasClass(options.customInputFieldClass)) {
            var inputType = $innerItem.attr('input-type').toString().toLowerCase();

            // DatePicker widget
            if (inputType === options.datePickerInputType) {
              var date = $innerItem.datepicker('getDate');
              if (date !== null) {
                date = $.datepicker.formatDate(options.dateFormat, date);
                innerVal = formatCustomInputValue(prop, date);
              }
            } else if (inputType === options.textBoxInputType) {
              // TextBox Component
              var textboxVal = $innerItem.val();
              if (textboxVal !== null && textboxVal !== '') {
                innerVal = formatCustomInputValue(prop, textboxVal);
              }
            }
          } else if ($innerItem.smartlist('instance')) {
            // Major Case #2: inner item is a smartlist
            innerVal = $innerItem.smartlist('val');
          }

          aggrVal.push.apply(aggrVal, _toConsumableArray(innerVal));
        });

        return aggrVal;
      },

      selectAll: function (state) {
        var $element = this.element,
            options = this.options;

        $.each(this.innerLists || [], function (prop, $innerItem) {
          // Major Case #1: the inner item is a custom input field.
          if (state === false && $innerItem.hasClass(options.customInputFieldClass)) {
            $innerItem.trigger('reset');
          } else if ($innerItem.smartlist('instance')) {
            // Major Case #2: inner item is a smartlist
            $innerItem.smartlist('selectAll', state);
          }
        });

        this.updateLabel();
        this.updateOuterLabels();

        // FIXME: short term solution as we had IE problems
        $element.find('.outer-list .smart-list-items li').removeClass(options.outerActiveClass);
        $element.find('.outer-list .smart-list-items li:first-child').addClass(options.outerActiveClass);
        $element.find('.tab-panel').hide();
        $element.find('.tab-panel:first-child').show();
      },

      items: function () {
        // outer list items returned
        return this._delegateSmartList('items', arguments); // eslint-disable-line prefer-rest-params
      },

      smartlist: function () {
        return this.$smartlist;
      },

      _delegateSmartList: function (method, args) {
        var $smartlist = this.$smartlist;

        args = Array.prototype.slice.apply(args);
        args.unshift(method);

        return $smartlist.smartlist.apply($smartlist, _toConsumableArray(args));
      }
    });

    return $.ty.dropdown2levelsmartlist;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/ui_components/dropdown-menu',['jquery', 'dropdown'], function ($, dropdown) {
    $.widget('ty.dropdownmenu', dropdown, {
      options: {
        item: 'li:not(.dropdown)',
        submenu: '.dropdown',
        disabledClass: 'is-disabled',
        iconAnimation: true
      },

      _create: function () {
        var self = this,
            $element = this.element,
            options = this.options;

        // super
        dropdown.prototype._create.apply(this, arguments); // eslint-disable-line prefer-rest-params

        // item event
        self._on(['click', options.item, this._callWhenEnabled(function (evt) {
          var $this = $(this);
          if (!$this.hasClass('is-disabled')) {
            // bind only to min level elements
            if (!self._isLevel($this, $element, self.itemLevel)) {
              return;
            }
            if ($(this).hasClass('disable-select')) {
              return;
            }
            self._trigger('select', null, { val: $this.data('value') });

            if ($(this).hasClass('close-disabled')) {
              return;
            }
            self.open(false);
          }
        })]);

        // submenu event
        self._on([self.widgetName.toLowerCase() + 'select', options.submenu, function (evt, data) {
          // bind only to min level elements
          if (!self._isLevel($(this), $element, self.submenuLevel)) {
            return;
          }
          evt.stopPropagation();
          if (!self.disabled) {
            self._trigger('select', null, data);
            self.open(false);
          }
        }]);
      },

      _init: function () {
        var self = this,
            $element = this.element,
            options = this.options;

        // super
        dropdown.prototype._init.apply(this, arguments); // eslint-disable-line prefer-rest-params

        // first-level of items & submenus
        this.itemLevel = this._minLevel($element, options.item);
        this.submenuLevel = this._minLevel($element, options.submenu);

        // submenus
        $element.find(options.submenu).each(function () {
          var $this = $(this);

          // only first level submenus
          if (!self._isLevel($this, $element, self.submenuLevel)) {
            return;
          }
          $this.dropdownmenu(options);
        });
      },

      _destroy: function () {
        // submenus
        this.element.find(this.options.submenu).each(function () {
          $(this).dropdownmenu('destroy');
        });

        // super
        dropdown.prototype._destroy.apply(this, arguments); // eslint-disable-line prefer-rest-params
      }
    });
    return $.ty.dropdownmenu;
  });
})();
/**
 * How to use:
 *
 * // Initialization
 * $('#selector').multipleentries({
 * 	tagsItems: ['tag 1', 'tag 2'],
 * })
 * // Options
 * tagsItems - array of tags
 * verifyEntry - array of keys to add tag (comma, space)
 * itemsSeporators - array of keys separate each tag (comma, space, tab, new line)
 * validateItem - function to validate item (if validateItem returns true, tag will be added, otherwise not)
 * focusOutAdd - add tag when focusOut
 *
 * // change trigger
 * $('#selector').multipleentries({
 * 	change: function (e, data) { console.log('change occurred'); }
 * })
 * // Getting all tags, returns as array ['tag 1', 'tag 2']
 * $('#selector').multipleentries('getTagElements');
 *
 * // Refresh height
 * $('#selector').multipleentries('refreshHeight');
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/multiple-entries',['jquery', 'textext-tags'], function ($) {
    $.widget('ty.multipleentries', {
      options: {
        tagsItems: [],
        verifyEntry: [],
        verifyEntryKeys: {
          space: 32,
          comma: 44
        },
        itemsSeporators: [],
        itemsSeporatorsKeys: {
          space: '\\s',
          comma: ',',
          tab: '\\t',
          'new line': '\\n'
        },
        focusOutAdd: false,
        validateItem: function (item) {
          return true;
        }
      },
      _create: function () {
        var self = this,
            $element = this.element,
            options = this.options;

        this.$textarea = $('<textarea rows="1"></textarea>');
        $element.addClass('trustyou-ui multiple-entries');
        $element.append(this.$textarea);

        this.$textarea.focus(function () {
          $(this).textext()[0].invalidateBounds();
        }).bind('isTagAllowed', function (e, data) {
          self._validateItem(e, data);
        }).bind('setFormData', function (e, data, isEmpty) {
          self.setHeight();
          self._trigger('change', e, data);
        }).bind('paste', function () {
          setTimeout(function () {
            self._addTags();
          }, 100);
        });

        if (options.focusOutAdd) {
          this.$textarea.focusout(function () {
            self._addTags();
          });
        }

        if (options.verifyEntry.length > 0) {
          var eWhichList = [];
          $.each(options.verifyEntry, function (index, value) {
            if (value in options.verifyEntryKeys) {
              eWhichList.push(options.verifyEntryKeys[value]);
            }
          });
          if (eWhichList.length > 0) {
            this.$textarea.keypress(function (e) {
              if ($.inArray(e.which, eWhichList) !== -1) {
                self._addTags();
                e.preventDefault();
              }
            });
          }
        }
      },
      _init: function () {
        var options = this.options;

        this.$textarea.textext($.extend(true, {}, {
          plugins: 'tags',
          ext: {
            itemManager: {
              stringToItem: function (str) {
                str = $.trim(str);
                return str;
              }
            }
          }
        }, options));
        this.setHeight();
      },
      _addTags: function (tags) {
        tags = tags || this.$textarea.val();
        if (tags) {
          var tagsToAdd = $.isArray(tags) ? tags : [$.trim(tags)];
          this.$textarea.textext()[0].tags().addTags(tagsToAdd);
          this.$textarea.val('');
        }
      },
      _validateItem: function (e, data) {
        var self = this,
            options = this.options;
        var items = void 0;

        if (data && data.tag) {
          if (options.itemsSeporators.length > 0) {
            var reString = '';
            $.each(options.itemsSeporators, function (index, value) {
              if (value in options.itemsSeporatorsKeys) {
                reString += options.itemsSeporatorsKeys[value];
              }
            });
            var re = new RegExp('[^' + reString + ']+', 'g');
            items = data.tag.toString().match(re);
            if (items && items.length > 1) {
              self._addTags($.map(items, $.trim));
              data.result = false;
              return false;
            }
          }
          if (!options.validateItem(data.tag)) {
            data.result = false;
          }
        }
        return data;
      },
      getTagElements: function () {
        var tags = [];
        this.$textarea.textext()[0].tags().tagElements().each(function (idx, tag) {
          tags.push($(tag).text());
        });
        return tags;
      },
      setHeight: function () {
        var tagHeight = 25;
        var tagsCount = this.element.find('.text-tag').length;
        var elemPadding = 6;
        var minHeight = 30;
        var calcHeight = tagHeight * tagsCount || minHeight;
        var elemHeight = calcHeight + elemPadding + 'px';
        this.$textarea.css({ height: elemHeight });
        this.element.find('.text-wrap').css({ height: elemHeight });
        this.element.find('.text-core').css({ height: elemHeight });
      },
      refreshHeight: function () {
        this.$textarea.textext()[0].invalidateBounds();
      }
    });

    return $.ty.multipleentries;
  });
})();
define('commons/public/jadec/ui_components/smartlist',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var uuidGen = {
uuid: null,
generate: function () {
return this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
return v.toString(16);
});
}
};
var smartlistClass, searchLabel;
var header = header !== undefined ? header : undefined;
var search = search !== undefined ? search : true;
var hide_if_empty = hide_if_empty !== undefined ? hide_if_empty : false;
var selectAll = selectAll !== undefined ? selectAll : true;
var items = items || [];
var disabled = disabled !== undefined ? disabled : false;
var disabledClass = disabled ? ["is-disabled"] : [];
smartlistClasses = disabled ? ["is-disabled"] : [];
smartlistClasses && smartlistClasses.push(smartlistClass);
smartlistClasses = smartlistClasses.join(" ");
var accept = accept !== undefined ? accept : false;
var acceptLabel = acceptLabel !== undefined ? acceptLabel : "Ok";
var dataValue = dataValue !== undefined ? dataValue : "";
var additionalEmptyClass = additionalEmptyClass !== undefined ? additionalEmptyClass : "placeholder-box-no-data";
var emptyLabel = emptyLabel !== undefined ? emptyLabel : "No results found";
var hideEmptyResults = hideEmptyResults !== undefined ? hideEmptyResults : false
var callToAction = callToAction || null
buf.push("<div" + (jade.attrs({ 'data-value':(dataValue), "class": ('trustyou-ui') + ' ' + ('smart-list') + ' ' + (smartlistClasses) }, {"class":true,"data-value":true})) + ">");
if ( header)
{
buf.push("<h3>" + (((jade.interp = header) == null ? '' : jade.interp)) + "</h3>");
}
if ( items.length > 0 || !hide_if_empty)
{
if ( search || selectAll || callToAction)
{
buf.push("<div class=\"smart-list-header\">");
if ( callToAction)
{
buf.push("<div class=\"smart-list-cta\"><p>" + (jade.escape((jade.interp = callToAction.text) == null ? '' : jade.interp)) + "</p><a class=\"trustyou-ui btn btn-primary btn-sm waves-effect\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (callToAction.buttonClass) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = callToAction.buttonText) == null ? '' : jade.interp)) + "</span></a></div>");
}
if ( search)
{
buf.push("<div class=\"smart-list-searchbox\"><input" + (jade.attrs({ 'type':("text"), 'disabled':(disabled), 'placeholder':(searchLabel) }, {"type":true,"disabled":true,"placeholder":true})) + "/><i class=\"ty-icon ty-icon-search\"></i></div>");
}
if ( selectAll)
{
buf.push("<div class=\"smart-list-select-all\"><div class=\"control-wrapper\"><input" + (jade.attrs({ 'id':(uuidGen.generate()), 'type':("checkbox"), 'disabled':(disabled) }, {"id":true,"type":true,"disabled":true})) + "/><label" + (jade.attrs({ 'for':(uuidGen.uuid), "class": (disabledClass) }, {"for":true,"class":true})) + ">" + (jade.escape((jade.interp = selectAllLabel) == null ? '' : jade.interp)) + "</label></div></div>");
}
buf.push("</div>");
}
if ( items.length > 0 || !hideEmptyResults)
{
buf.push("<div class=\"smart-list-scroll\"><ul class=\"smart-list-items\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul>");
if ( search)
{
buf.push("<div class=\"trustyou-ui placeholder-box placeholder-box-sm is-hidden\"><div class=\"placeholder-box-icon\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (additionalEmptyClass) }, {"class":true})) + "></i></div><div class=\"placeholder-box-title\">" + (jade.escape((jade.interp = emptyLabel) == null ? '' : jade.interp)) + "</div></div>");
}
buf.push("</div>");
}
if ( accept)
{
buf.push("<div class=\"smart-list-footer\"><div class=\"smart-list-accept\"><a class=\"trustyou-ui btn btn-primary btn-sm l-right\">" + (jade.escape((jade.interp = acceptLabel) == null ? '' : jade.interp)) + "</a></div></div>");
}
}
buf.push("</div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/smartlist-item',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/dropdown',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var toggle, content, disabled, icon, _allClasses = [];
toggle = typeof toggle !== "undefined" ? toggle : "";
content = typeof content !== "undefined" ? content : "";
icon = typeof icon !== "undefined" ? icon : "ty-icon-chevron-down";
additionalClasses = typeof additionalClasses !== "undefined" ? additionalClasses : [];
disabled && _allClasses.push("is-disabled");
_allClasses = _allClasses.concat(additionalClasses);
alignment = typeof alignment !== "undefined" ? alignment : "";
iconAnimationClass = (typeof iconAnimation === "undefined" || iconAnimation) ? "is-icon-animated" : "";
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + (_allClasses) }, {"class":true})) + "><a" + (jade.attrs({ "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ('l-right') + ' ' + (icon) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span></a><div" + (jade.attrs({ "class": ("dropdown-content " + (alignment) + "") }, {"class":true})) + ">" + (((jade.interp = content) == null ? '' : jade.interp)) + "</div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/dropdown-menu',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var toggle, badge, open, disabled, icon, title, _allClasses = [];
toggle = typeof toggle !== "undefined" ? toggle : "";
title = typeof title !== "undefined" ? title : "";
icon = typeof icon !== "undefined" ? icon : "ty-icon-chevron-down";
iconAnimationClass = (typeof iconAnimation === "undefined" || iconAnimation) ? "is-icon-animated" : "";
additionalClasses = typeof additionalClasses !== "undefined" ? additionalClasses : [];
disabled && _allClasses.push("is-disabled");
_allClasses = _allClasses.concat(additionalClasses);
customToggle = typeof customToggle !== "undefined" ? customToggle : false
badge = typeof badge !== "undefined" ? badge : false
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + (_allClasses) }, {"class":true})) + ">");
if ( customToggle)
{
buf.push("<h1 data-toggle=\"dropdown\"><i" + (jade.attrs({ "class": (icon) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span><i class=\"ty-icon ty-icon-chevron-down\"></i></h1>");
if ( badge)
{
buf.push("<span style=\"margin-top:7px\" class=\"trustyou-ui badge badge-negative\">" + (jade.escape((jade.interp = badge) == null ? '' : jade.interp)) + "</span>");
}
buf.push("<div class=\"dropdown-menu\"><ul>");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul></div>");
}
else
{
if ( title)
{
buf.push("<a" + (jade.attrs({ 'data-tooltip':("top"), 'title':(title), "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true,"data-tooltip":true,"title":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ('l-right') + ' ' + (icon) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span></a>");
}
else
{
buf.push("<a" + (jade.attrs({ "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ('l-right') + ' ' + (icon) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span></a>");
}
buf.push("<div class=\"dropdown-menu\"><ul>");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul></div>");
}
buf.push("</div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/dropdown-smartlist',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var toggle, text_help, disabled, icon, lright, additionalClasses, _allClasses = [];
toggle = typeof toggle !== "undefined" ? toggle : "";
text_help = typeof text_help !== "undefined" ? text_help : "";
icon = typeof icon !== "undefined" ? icon : "ty-icon-chevron-down";
additionalClasses = typeof additionalClasses !== "undefined" ? additionalClasses : [];
disabled && _allClasses.push("is-disabled")
_allClasses = _allClasses.concat(additionalClasses)
iconAnimationClass = (typeof iconAnimation === "undefined" || iconAnimation) ? "is-icon-animated" : "";
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + (_allClasses.join(" ")) }, {"class":true})) + "><a" + (jade.attrs({ "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ('l-right') + ' ' + (icon) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "<span class=\"text-help\">" + (jade.escape((jade.interp = text_help) == null ? '' : jade.interp)) + "</span></span></a><div" + (jade.attrs({ "class": ('dropdown-smart-list') + ' ' + (lright ? ["l-right"] : "") }, {"class":true})) + ">");
var uuidGen = {
uuid: null,
generate: function () {
return this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
return v.toString(16);
});
}
};
var smartlistClass, searchLabel;
var header = header !== undefined ? header : undefined;
var search = search !== undefined ? search : true;
var hide_if_empty = hide_if_empty !== undefined ? hide_if_empty : false;
var selectAll = selectAll !== undefined ? selectAll : true;
var items = items || [];
var disabled = disabled !== undefined ? disabled : false;
var disabledClass = disabled ? ["is-disabled"] : [];
smartlistClasses = disabled ? ["is-disabled"] : [];
smartlistClasses && smartlistClasses.push(smartlistClass);
smartlistClasses = smartlistClasses.join(" ");
var accept = accept !== undefined ? accept : false;
var acceptLabel = acceptLabel !== undefined ? acceptLabel : "Ok";
var dataValue = dataValue !== undefined ? dataValue : "";
var additionalEmptyClass = additionalEmptyClass !== undefined ? additionalEmptyClass : "placeholder-box-no-data";
var emptyLabel = emptyLabel !== undefined ? emptyLabel : "No results found";
var hideEmptyResults = hideEmptyResults !== undefined ? hideEmptyResults : false
var callToAction = callToAction || null
buf.push("<div" + (jade.attrs({ 'data-value':(dataValue), "class": ('trustyou-ui') + ' ' + ('smart-list') + ' ' + (smartlistClasses) }, {"class":true,"data-value":true})) + ">");
if ( header)
{
buf.push("<h3>" + (((jade.interp = header) == null ? '' : jade.interp)) + "</h3>");
}
if ( items.length > 0 || !hide_if_empty)
{
if ( search || selectAll || callToAction)
{
buf.push("<div class=\"smart-list-header\">");
if ( callToAction)
{
buf.push("<div class=\"smart-list-cta\"><p>" + (jade.escape((jade.interp = callToAction.text) == null ? '' : jade.interp)) + "</p><a class=\"trustyou-ui btn btn-primary btn-sm waves-effect\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (callToAction.buttonClass) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = callToAction.buttonText) == null ? '' : jade.interp)) + "</span></a></div>");
}
if ( search)
{
buf.push("<div class=\"smart-list-searchbox\"><input" + (jade.attrs({ 'type':("text"), 'disabled':(disabled), 'placeholder':(searchLabel) }, {"type":true,"disabled":true,"placeholder":true})) + "/><i class=\"ty-icon ty-icon-search\"></i></div>");
}
if ( selectAll)
{
buf.push("<div class=\"smart-list-select-all\"><div class=\"control-wrapper\"><input" + (jade.attrs({ 'id':(uuidGen.generate()), 'type':("checkbox"), 'disabled':(disabled) }, {"id":true,"type":true,"disabled":true})) + "/><label" + (jade.attrs({ 'for':(uuidGen.uuid), "class": (disabledClass) }, {"for":true,"class":true})) + ">" + (jade.escape((jade.interp = selectAllLabel) == null ? '' : jade.interp)) + "</label></div></div>");
}
buf.push("</div>");
}
if ( items.length > 0 || !hideEmptyResults)
{
buf.push("<div class=\"smart-list-scroll\"><ul class=\"smart-list-items\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul>");
if ( search)
{
buf.push("<div class=\"trustyou-ui placeholder-box placeholder-box-sm is-hidden\"><div class=\"placeholder-box-icon\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (additionalEmptyClass) }, {"class":true})) + "></i></div><div class=\"placeholder-box-title\">" + (jade.escape((jade.interp = emptyLabel) == null ? '' : jade.interp)) + "</div></div>");
}
buf.push("</div>");
}
if ( accept)
{
buf.push("<div class=\"smart-list-footer\"><div class=\"smart-list-accept\"><a class=\"trustyou-ui btn btn-primary btn-sm l-right\">" + (jade.escape((jade.interp = acceptLabel) == null ? '' : jade.interp)) + "</a></div></div>");
}
}
buf.push("</div></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/dropdown-2level-smartlist',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var _allClasses = [], tabsOnly, disabled;
var outerItems = outerItems || [];
var toggle = typeof toggle !== "undefined" ? toggle : "";
var icon = typeof icon !== "undefined" ? icon : "ty-icon-chevron-down";
var defaultClasses = (tabsOnly ? ["open"] : []) + (disabled ? ["is-disabled"] : []);
iconClasses = ["ty-icon", "l-right", icon];
iconAnimationClass = (typeof iconAnimation === "undefined" || iconAnimation) ? "is-icon-animated" : "";
additionalClasses = typeof additionalClasses !== "undefined" ? additionalClasses : [];
disabled && _allClasses.push("is-disabled");
_allClasses = _allClasses.concat(additionalClasses);
_allClasses = _allClasses.concat(defaultClasses);
var datePickerResetLabel = datePickerResetLabel || "Reset";
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + (_allClasses) }, {"class":true})) + ">");
if ( (!tabsOnly))
{
buf.push("<a" + (jade.attrs({ "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true})) + "><i" + (jade.attrs({ "class": (iconClasses) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span></a>");
}
buf.push("<div" + (jade.attrs({ "class": ('dropdown-tabs') + ' ' + (tabsOnly ? ["tabs-only"] : "") }, {"class":true})) + "><span class=\"outer-list\"><ul class=\"trustyou-ui tabs vertical smart-list-items\">");
var outerItemsWithCustomInputs = [];
var outerItemsDefault = [];
var firstItemWasActivated = false;
// iterate outerItems
;(function(){
  var $$obj = outerItems;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var outerItem = $$obj[index];

outerItemsDefault.push(outerItem)
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(index)){      var outerItem = $$obj[index];

outerItemsDefault.push(outerItem)
      }

    }

  }
}).call(this);

// iterate outerItemsDefault
;(function(){
  var $$obj = outerItemsDefault;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var outerItem = $$obj[index];

buf.push("<li" + (jade.attrs({ 'data-value':(outerItem.value), 'data-label':(outerItem.label), 'data-extra':(outerItem.extra), "class": (index == 0 && firstItemWasActivated == false ? "active" : "") }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + "><a href=\"javascript:void(0)\" data-toggle=\"tab\">" + (jade.escape((jade.interp = outerItem.label) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-check\"></i></a></li>");
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(index)){      var outerItem = $$obj[index];

buf.push("<li" + (jade.attrs({ 'data-value':(outerItem.value), 'data-label':(outerItem.label), 'data-extra':(outerItem.extra), "class": (index == 0 && firstItemWasActivated == false ? "active" : "") }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + "><a href=\"javascript:void(0)\" data-toggle=\"tab\">" + (jade.escape((jade.interp = outerItem.label) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-check\"></i></a></li>");
      }

    }

  }
}).call(this);

buf.push("</ul></span><span class=\"inner-lists\"><div class=\"trustyou-ui tab-container\">");
// iterate outerItems
;(function(){
  var $$obj = outerItems;
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var outerItem = $$obj[index];

var customInputType = (outerItem.inputType !== null && outerItem.inputType !== undefined && outerItem.inputType !== "") ? outerItem.inputType.toString().toLowerCase() : null;
if ( customInputType === "datepicker")
{
var selectedValue = (outerItem.items && outerItem.items.length && outerItem.items.length > 0) ? outerItem.items[0] : null;
var isSelected = selectedValue !== null && selectedValue.selected === true;
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("custom-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + "><div class=\"trustyou-ui calendar\"><div" + (jade.attrs({ 'id':(outerItem.value + "-" + customInputType), 'input-type':(customInputType), 'pre-selected':((isSelected ? "selected" : "")), 'data-value':((isSelected ? selectedValue.value : "")), "class": ("custom-input-field datepicker") }, {"id":true,"input-type":true,"pre-selected":true,"data-value":true,"class":true})) + "></div></div><div class=\"l-align-right\"><a class=\"custom-input-field-reset-btn trustyou-ui btn btn-sm\">" + (jade.escape((jade.interp = datePickerResetLabel) == null ? '' : jade.interp)) + "<li class=\"ty-icon ty-icon-undo\"></li></a></div></div>");
}
else if ( customInputType === "textbox")
{
var selectedValue = (outerItem.items && outerItem.items.length && outerItem.items.length > 0) ? outerItem.items[0] : null;
var isSelected = selectedValue !== null && selectedValue.selected === true;
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("custom-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + "><div class=\"trustyou-ui control-group custom-input-item\"><div class=\"controls\"><input" + (jade.attrs({ 'id':(outerItem.value + "-" + customInputType), 'type':("text"), 'input-type':(customInputType), 'pre-selected':((isSelected ? "selected" : "")), 'data-value':((isSelected ? selectedValue.value : "")), 'placeholder':(outerItem.label), 'value':(""), "class": ("custom-input-field " + (outerItem.label_element_class ? outerItem.label_element_class : '') + " ext-field") }, {"id":true,"type":true,"input-type":true,"pre-selected":true,"data-value":true,"placeholder":true,"class":true,"value":true})) + "/></div></div></div>");
}
else
{
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("list-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + ">");
var items = outerItem.items
var selectAllLabel = innerSelectAllLabel
var searchLabel = innerSearchLabel
var uuidGen = {
uuid: null,
generate: function () {
return this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
return v.toString(16);
});
}
};
var smartlistClass, searchLabel;
var header = header !== undefined ? header : undefined;
var search = search !== undefined ? search : true;
var hide_if_empty = hide_if_empty !== undefined ? hide_if_empty : false;
var selectAll = selectAll !== undefined ? selectAll : true;
var items = items || [];
var disabled = disabled !== undefined ? disabled : false;
var disabledClass = disabled ? ["is-disabled"] : [];
smartlistClasses = disabled ? ["is-disabled"] : [];
smartlistClasses && smartlistClasses.push(smartlistClass);
smartlistClasses = smartlistClasses.join(" ");
var accept = accept !== undefined ? accept : false;
var acceptLabel = acceptLabel !== undefined ? acceptLabel : "Ok";
var dataValue = dataValue !== undefined ? dataValue : "";
var additionalEmptyClass = additionalEmptyClass !== undefined ? additionalEmptyClass : "placeholder-box-no-data";
var emptyLabel = emptyLabel !== undefined ? emptyLabel : "No results found";
var hideEmptyResults = hideEmptyResults !== undefined ? hideEmptyResults : false
var callToAction = callToAction || null
buf.push("<div" + (jade.attrs({ 'data-value':(dataValue), "class": ('trustyou-ui') + ' ' + ('smart-list') + ' ' + (smartlistClasses) }, {"class":true,"data-value":true})) + ">");
if ( header)
{
buf.push("<h3>" + (((jade.interp = header) == null ? '' : jade.interp)) + "</h3>");
}
if ( items.length > 0 || !hide_if_empty)
{
if ( search || selectAll || callToAction)
{
buf.push("<div class=\"smart-list-header\">");
if ( callToAction)
{
buf.push("<div class=\"smart-list-cta\"><p>" + (jade.escape((jade.interp = callToAction.text) == null ? '' : jade.interp)) + "</p><a class=\"trustyou-ui btn btn-primary btn-sm waves-effect\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (callToAction.buttonClass) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = callToAction.buttonText) == null ? '' : jade.interp)) + "</span></a></div>");
}
if ( search)
{
buf.push("<div class=\"smart-list-searchbox\"><input" + (jade.attrs({ 'type':("text"), 'disabled':(disabled), 'placeholder':(searchLabel) }, {"type":true,"disabled":true,"placeholder":true})) + "/><i class=\"ty-icon ty-icon-search\"></i></div>");
}
if ( selectAll)
{
buf.push("<div class=\"smart-list-select-all\"><div class=\"control-wrapper\"><input" + (jade.attrs({ 'id':(uuidGen.generate()), 'type':("checkbox"), 'disabled':(disabled) }, {"id":true,"type":true,"disabled":true})) + "/><label" + (jade.attrs({ 'for':(uuidGen.uuid), "class": (disabledClass) }, {"for":true,"class":true})) + ">" + (jade.escape((jade.interp = selectAllLabel) == null ? '' : jade.interp)) + "</label></div></div>");
}
buf.push("</div>");
}
if ( items.length > 0 || !hideEmptyResults)
{
buf.push("<div class=\"smart-list-scroll\"><ul class=\"smart-list-items\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul>");
if ( search)
{
buf.push("<div class=\"trustyou-ui placeholder-box placeholder-box-sm is-hidden\"><div class=\"placeholder-box-icon\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (additionalEmptyClass) }, {"class":true})) + "></i></div><div class=\"placeholder-box-title\">" + (jade.escape((jade.interp = emptyLabel) == null ? '' : jade.interp)) + "</div></div>");
}
buf.push("</div>");
}
if ( accept)
{
buf.push("<div class=\"smart-list-footer\"><div class=\"smart-list-accept\"><a class=\"trustyou-ui btn btn-primary btn-sm l-right\">" + (jade.escape((jade.interp = acceptLabel) == null ? '' : jade.interp)) + "</a></div></div>");
}
}
buf.push("</div></div>");
}
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(index)){      var outerItem = $$obj[index];

var customInputType = (outerItem.inputType !== null && outerItem.inputType !== undefined && outerItem.inputType !== "") ? outerItem.inputType.toString().toLowerCase() : null;
if ( customInputType === "datepicker")
{
var selectedValue = (outerItem.items && outerItem.items.length && outerItem.items.length > 0) ? outerItem.items[0] : null;
var isSelected = selectedValue !== null && selectedValue.selected === true;
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("custom-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + "><div class=\"trustyou-ui calendar\"><div" + (jade.attrs({ 'id':(outerItem.value + "-" + customInputType), 'input-type':(customInputType), 'pre-selected':((isSelected ? "selected" : "")), 'data-value':((isSelected ? selectedValue.value : "")), "class": ("custom-input-field datepicker") }, {"id":true,"input-type":true,"pre-selected":true,"data-value":true,"class":true})) + "></div></div><div class=\"l-align-right\"><a class=\"custom-input-field-reset-btn trustyou-ui btn btn-sm\">" + (jade.escape((jade.interp = datePickerResetLabel) == null ? '' : jade.interp)) + "<li class=\"ty-icon ty-icon-undo\"></li></a></div></div>");
}
else if ( customInputType === "textbox")
{
var selectedValue = (outerItem.items && outerItem.items.length && outerItem.items.length > 0) ? outerItem.items[0] : null;
var isSelected = selectedValue !== null && selectedValue.selected === true;
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("custom-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + "><div class=\"trustyou-ui control-group custom-input-item\"><div class=\"controls\"><input" + (jade.attrs({ 'id':(outerItem.value + "-" + customInputType), 'type':("text"), 'input-type':(customInputType), 'pre-selected':((isSelected ? "selected" : "")), 'data-value':((isSelected ? selectedValue.value : "")), 'placeholder':(outerItem.label), 'value':(""), "class": ("custom-input-field " + (outerItem.label_element_class ? outerItem.label_element_class : '') + " ext-field") }, {"id":true,"type":true,"input-type":true,"pre-selected":true,"data-value":true,"placeholder":true,"class":true,"value":true})) + "/></div></div></div>");
}
else
{
buf.push("<div" + (jade.attrs({ 'id':(outerItem.value), 'style':((index == 0 ? "display: block;" : "display: none;")), "class": ("list-input-container") + ' ' + ('tab-panel') }, {"id":true,"style":true})) + ">");
var items = outerItem.items
var selectAllLabel = innerSelectAllLabel
var searchLabel = innerSearchLabel
var uuidGen = {
uuid: null,
generate: function () {
return this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
return v.toString(16);
});
}
};
var smartlistClass, searchLabel;
var header = header !== undefined ? header : undefined;
var search = search !== undefined ? search : true;
var hide_if_empty = hide_if_empty !== undefined ? hide_if_empty : false;
var selectAll = selectAll !== undefined ? selectAll : true;
var items = items || [];
var disabled = disabled !== undefined ? disabled : false;
var disabledClass = disabled ? ["is-disabled"] : [];
smartlistClasses = disabled ? ["is-disabled"] : [];
smartlistClasses && smartlistClasses.push(smartlistClass);
smartlistClasses = smartlistClasses.join(" ");
var accept = accept !== undefined ? accept : false;
var acceptLabel = acceptLabel !== undefined ? acceptLabel : "Ok";
var dataValue = dataValue !== undefined ? dataValue : "";
var additionalEmptyClass = additionalEmptyClass !== undefined ? additionalEmptyClass : "placeholder-box-no-data";
var emptyLabel = emptyLabel !== undefined ? emptyLabel : "No results found";
var hideEmptyResults = hideEmptyResults !== undefined ? hideEmptyResults : false
var callToAction = callToAction || null
buf.push("<div" + (jade.attrs({ 'data-value':(dataValue), "class": ('trustyou-ui') + ' ' + ('smart-list') + ' ' + (smartlistClasses) }, {"class":true,"data-value":true})) + ">");
if ( header)
{
buf.push("<h3>" + (((jade.interp = header) == null ? '' : jade.interp)) + "</h3>");
}
if ( items.length > 0 || !hide_if_empty)
{
if ( search || selectAll || callToAction)
{
buf.push("<div class=\"smart-list-header\">");
if ( callToAction)
{
buf.push("<div class=\"smart-list-cta\"><p>" + (jade.escape((jade.interp = callToAction.text) == null ? '' : jade.interp)) + "</p><a class=\"trustyou-ui btn btn-primary btn-sm waves-effect\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (callToAction.buttonClass) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = callToAction.buttonText) == null ? '' : jade.interp)) + "</span></a></div>");
}
if ( search)
{
buf.push("<div class=\"smart-list-searchbox\"><input" + (jade.attrs({ 'type':("text"), 'disabled':(disabled), 'placeholder':(searchLabel) }, {"type":true,"disabled":true,"placeholder":true})) + "/><i class=\"ty-icon ty-icon-search\"></i></div>");
}
if ( selectAll)
{
buf.push("<div class=\"smart-list-select-all\"><div class=\"control-wrapper\"><input" + (jade.attrs({ 'id':(uuidGen.generate()), 'type':("checkbox"), 'disabled':(disabled) }, {"id":true,"type":true,"disabled":true})) + "/><label" + (jade.attrs({ 'for':(uuidGen.uuid), "class": (disabledClass) }, {"for":true,"class":true})) + ">" + (jade.escape((jade.interp = selectAllLabel) == null ? '' : jade.interp)) + "</label></div></div>");
}
buf.push("</div>");
}
if ( items.length > 0 || !hideEmptyResults)
{
buf.push("<div class=\"smart-list-scroll\"><ul class=\"smart-list-items\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

function highlightLabel(label, match) {
var term;
term = match.trim().replace(/\s+/g, " ");
term = term.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
term = "(" + term.split(" ").join("|") + ")";
return label.replace(new RegExp(term, "gi"), "<span class='text-highlight-neutral'>$&</span>");
}
var itemContent_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var label = item.label;
if ( item.extra)
{
var extraLabel = "";
if ( item.extra.externalId)
{
extraLabel = item.extra.externalId;
if ( item.extra.match)
{
extraLabel = " (ID:" + highlightLabel(extraLabel, item.extra.match) + ")";
}
else
{
extraLabel = " (ID:" + extraLabel + ")";
}
}
if ( item.extra.match)
{
item.isHtml = true;
label = highlightLabel(label, item.extra.match);
}
label = label + extraLabel
}
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
buf.push("<a" + (jade.attrs({ 'href':("javascript:void(0)"), "class": ('value') + ' ' + ("" + (item.label_element_class ? item.label_element_class : '') + "") }, {"class":true,"href":true})) + "><span class=\"smart-list-item\">");
if ( item.isHtml)
{
buf.push("" + (((jade.interp = label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = label) == null ? '' : jade.interp)) + "");
}
buf.push("</span>");
if ( item.subtitle)
{
buf.push("<span class=\"smart-list-item-subtitle\">" + (((jade.interp = item.subtitle) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
};
var listItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = item.class_element ? item.class_element : ""
if ( item.selected)
{
var itemClass = ("selected " + itemClass);
}
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'data-extra':(item.extra), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"data-extra":true})) + ">");
itemContent_mixin(item);
buf.push("</li>");
};
var addItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( item.items)
{
if ( item.divider)
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + ('divider') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
else
{
buf.push("" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "");
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
}
buf.push("</li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), "class": ('smart-list-group') + ' ' + (item.class_element ? item.class_element : "") }, {"class":true,"data-value":true})) + ">");
if ( item.additionalContent)
{
buf.push("" + (((jade.interp = item.additionalContent) == null ? '' : jade.interp)) + "");
}
if ( item.label !== undefined)
{
if ( item.isHtml)
{
buf.push("<a class=\"smart-list-group-title\">" + (((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
else
{
buf.push("<a class=\"smart-list-group-title\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a>");
}
}
if ( item.items.length > 0)
{
buf.push("<ul class=\"smart-list-group-items\">");
// iterate item.items
;(function(){
  var $$obj = item.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var it = $$obj[$index];

addItem_mixin(it);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var it = $$obj[$index];

addItem_mixin(it);
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
buf.push("</li>");
}
}
else
{
listItem_mixin(item);
}
};
addItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul>");
if ( search)
{
buf.push("<div class=\"trustyou-ui placeholder-box placeholder-box-sm is-hidden\"><div class=\"placeholder-box-icon\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (additionalEmptyClass) }, {"class":true})) + "></i></div><div class=\"placeholder-box-title\">" + (jade.escape((jade.interp = emptyLabel) == null ? '' : jade.interp)) + "</div></div>");
}
buf.push("</div>");
}
if ( accept)
{
buf.push("<div class=\"smart-list-footer\"><div class=\"smart-list-accept\"><a class=\"trustyou-ui btn btn-primary btn-sm l-right\">" + (jade.escape((jade.interp = acceptLabel) == null ? '' : jade.interp)) + "</a></div></div>");
}
}
buf.push("</div></div>");
}
      }

    }

  }
}).call(this);

buf.push("</div></span></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/dropdown-jumbomenu',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var menuItem_mixin = function(item){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var itemClass = [(item.noSelect ? "no-select" : ""), (item.isDisabled ? "is-disabled" : "")]
buf.push("<li" + (jade.attrs({ 'data-value':(item.value), 'data-label':(item.label), 'title':(item.label), "class": (itemClass) }, {"class":true,"data-value":true,"data-label":true,"title":true})) + "><a href=\"javascript:void(0)\">" + (jade.escape((jade.interp = item.label) == null ? '' : jade.interp)) + "</a></li>");
};
var toggle, open, disabled, icon, items, moreToggle, blockClass, _allClasses = [];
toggle = typeof toggle !== "undefined" ? toggle : "";
icon = typeof icon !== "undefined" ? icon : "ty-icon-chevron-down";
iconPosition = typeof iconPosition !== "undefined" ? iconPosition : "l-right";
iconClass = icon + " " + iconPosition
blocks = blocks || [];
alignment = alignment || ""
iconAnimationClass = (iconAnimation) ? "is-icon-animated" : ""
iconAnimationClass += (!dropdown) ? " is-hidden" : ""
additionalClasses = typeof additionalClasses !== "undefined" ? additionalClasses : [];
disabled && _allClasses.push("is-disabled");
_allClasses = _allClasses.concat(additionalClasses);
dropdown && _allClasses.push("dropdown")
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown-jumbo-menu') + ' ' + (_allClasses) }, {"class":true})) + "><a" + (jade.attrs({ "class": ('dropdown-toggle') + ' ' + (iconAnimationClass) }, {"class":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (iconClass) }, {"class":true})) + "></i><span>" + (jade.escape((jade.interp = toggle) == null ? '' : jade.interp)) + "</span></a><div" + (jade.attrs({ "class": ("dropdown-content " + (alignment) + "") }, {"class":true})) + "><div class=\"jumbo-menu\">");
// iterate blocks
;(function(){
  var $$obj = blocks;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var block = $$obj[$index];

blockClass = block.span ? ["jumbo-block-span"] : ["jumbo-block"];
if(block.class_){blockClass.push.apply(blockClass, block.class_)}
buf.push("<div" + (jade.attrs({ "class": (blockClass) }, {"class":true})) + "><ul>");
if ( block.label)
{
buf.push("<li class=\"jumbo-block-title\">" + (jade.escape((jade.interp = block.label) == null ? '' : jade.interp)) + "</li>");
}
// iterate block.items
;(function(){
  var $$obj = block.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

menuItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

menuItem_mixin(item);
      }

    }

  }
}).call(this);

if ( block.more)
{
buf.push("<li" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + ('more') + ' ' + ('disable-select') + ' ' + ((block.more.isDisabled ? "is-disabled" : "")) }, {"class":true})) + "><a href=\"javascript:void(0)\" class=\"dropdown-toggle\"><span>" + (jade.escape((jade.interp = block.more.label) == null ? '' : jade.interp)) + "&hellip;</span></a><div class=\"dropdown-menu\"><ul>");
// iterate block.more.items
;(function(){
  var $$obj = block.more.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

menuItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

menuItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul></div></li>");
}
buf.push("</ul></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var block = $$obj[$index];

blockClass = block.span ? ["jumbo-block-span"] : ["jumbo-block"];
if(block.class_){blockClass.push.apply(blockClass, block.class_)}
buf.push("<div" + (jade.attrs({ "class": (blockClass) }, {"class":true})) + "><ul>");
if ( block.label)
{
buf.push("<li class=\"jumbo-block-title\">" + (jade.escape((jade.interp = block.label) == null ? '' : jade.interp)) + "</li>");
}
// iterate block.items
;(function(){
  var $$obj = block.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

menuItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

menuItem_mixin(item);
      }

    }

  }
}).call(this);

if ( block.more)
{
buf.push("<li" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('dropdown') + ' ' + ('more') + ' ' + ('disable-select') + ' ' + ((block.more.isDisabled ? "is-disabled" : "")) }, {"class":true})) + "><a href=\"javascript:void(0)\" class=\"dropdown-toggle\"><span>" + (jade.escape((jade.interp = block.more.label) == null ? '' : jade.interp)) + "&hellip;</span></a><div class=\"dropdown-menu\"><ul>");
// iterate block.more.items
;(function(){
  var $$obj = block.more.items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

menuItem_mixin(item);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

menuItem_mixin(item);
      }

    }

  }
}).call(this);

buf.push("</ul></div></li>");
}
buf.push("</ul></div>");
      }

    }

  }
}).call(this);

buf.push("</div></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/timedropdown-customrange',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"date-from datepicker\"></div><div class=\"date-to datepicker\"></div><div class=\"cta\"><button type=\"button\" class=\"trustyou-ui btn btn-positive\">" + (jade.escape((jade.interp = apply) == null ? '' : jade.interp)) + "</button></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/ui_components/timedropdown',['jquery', 'ty-i18n!analytics_js_4x', 'moment', 'dropdownjumbomenu-template', './../../jadec/ui_components/timedropdown-customrange', 'widget', 'dropdownmenu', 'fancybox', 'twix'], function ($, i18n, moment, jumboTemplate, customRangeTemplate, widget) {
    /**
     * Limits the other datepicker's selection range based on the current one's value.
     * The function is used as a jQuery callback so the current datepicker is available as 'this'.
     *
     * !!! This function expects 'this' to be a datepicker from the custom range panel
     */
    var limitDatePicker = function () {
      var $this = $(this);
      var date = $this.datepicker('getDate');

      /*
       * If we have a FROM picker we need:
          *		* the lower limit to be 2000
          *		* the higher limit to be the lowest between today and the TO date
          * If we have a TO picker, we need:
          *		* the lower limit to be the FROM picker
          *		* the higher limit to be 5 years from today
          *
          * The minDate of the FROM and the MAX date of the TO are preselected in the
          * yearRange in the _init function initialisation
       */
      if ($this.hasClass('date-from')) {
        $this.siblings('.datepicker').datepicker('option', 'minDate', date);
      } else {
        // This is 'today' in JS (O_o)
        var today = new Date();
        var lowestDate = today < date ? today : date;
        $this.siblings('.datepicker').datepicker('option', 'maxDate', lowestDate);
      }
    };

    $.widget('ty.timedropdown', widget, {
      options: {
        val: null,
        dropdown: true,
        mainLabel: null,
        _defaultranges: [

        // days
        {
          label: i18n.jumbo_timedropdown_days || '@Days',
          items: ['last7days', 'last30days', 'last60days', 'last120days']
        },

        // months
        {
          label: i18n.jumbo_timedropdown_months || '@Months',
          items: ['thisMonth', 'lastMonth', 'last3Months', 'last6Months', 'last12Months', 'last24Months'],
          more: {
            label: i18n.jumbo_timedropdown_more_ranges || '@More',
            items: ['moreMonths']
          }
        },

        // quarters
        {
          label: i18n.jumbo_timedropdown_quarters || '@Quarters',
          items: ['currentQuarter', 'previousQuarter'],
          more: {
            label: i18n.jumbo_timedropdown_more_ranges || '@More',
            items: ['moreQuarters']
          }
        },

        // years
        {
          label: i18n.jumbo_timedropdown_years || '@Years',
          items: ['currentYear', 'previousYear'],
          more: {
            label: i18n.jumbo_timedropdown_more_ranges || '@More',
            items: ['moreYears']
          }
        },

        // custom
        {
          label: i18n.jumbo_timedropdown_custom || '@Custom',
          items: ['custom']
        }],
        ranges: null,
        moreYears: 2,
        labels: {
          customFrom: i18n.common_from || '@From',
          customTo: i18n.common_to || '@To',
          customApply: i18n.common_apply || '@Apply'
        },
        icon: 'ty-icon-chevron-down',
        iconPosition: 'l-right',
        iconAnimation: true,
        isRestricted: false,
        additionalContent: '',

        /**
         * Parse a range into a list of items to display in the UI
         * @param range
         * @param _super the built-in method that parses the predefined ranges
         * @return {[{value: string, label: string, selected: boolean}]}
         */
        listItems: function (range, _super) {
          return _super(range);
        },

        /**
         * Parse the selected item into an object that will be set as the value of the plugin.
         * @param itemValue whatever was in the 'value' field of each item returned by 'listItems'
         * @param _super the built-in method that parses the predefined ranges
         * @return {Object}
         */
        parseValue: function (itemValue, _super) {
          return _super(itemValue);
        },

        /**
         * The 2 labels corresponding to the value.
         * @param value an object returned by 'parseValue'
         * @param _super the built-in method that parses the predefined ranges
         * @return {{item: string, selected: string}} 'item' appears in the UI list,
         * 'selected' appears when displaying the selected value
         */
        valueLabels: function (value, _super) {
          return _super(value);
        }
      },

      _create: function () {
        var self = this,
            $element = this.element,
            options = this.options;
        $element.addClass('timedropdown trustyou-ui dropdown-jumbo-menu');

        if (options.dropdown) {
          $element.addClass('dropdown');
        }

        // the widget factory merges object/array options instead of overriding, if the client provides any
        // we work around this by having 'private' defaults and using them only if the client doesn't provide a value
        if (!options.ranges) {
          options.ranges = $.extend(true, {}, { r: options._defaultranges }).r;
        }

        // select time range
        this._on(['dropdownmenuselect', function (evt, data) {
          // the range is either predefined (e.g. last30days) or has its extremities already computed
          self.val(data.val);
        }]);

        // display the date pickers
        this._on(['click', '.no-select', function () {
          $(this).find('a').toggleClass('active');
          $element.find('.datepickers').fadeToggle();
        }]);

        // apply the custom range
        this._on(['click', '.cta .btn', this._callWhenEnabled(function () {
          // get values
          var pickers = $(this).closest('.datepickers');
          var from = pickers.find('.date-from').datepicker('getDate');
          var to = pickers.find('.date-to').datepicker('getDate');
          self.val(self._customValue(from, to));
          $element.dropdownmenu('open', false);
        })]);
      },

      /**
       * Sets the from and to dates for the custom range date pickers.
       * @private
       */
      _setDatepickers: function (val) {
        var customRangeDialog = this.element.find('.datepickers');
        var pickers = customRangeDialog.find('.datepicker');

        // Set the beginning of the current time range as 'from'
        pickers.filter('.date-from').datepicker('setDate', $.ty.timedropdown.stringToDate(val.fromDate).toDate());

        // Set the end of the current time range as 'to'
        pickers.filter('.date-to').datepicker('setDate',

        // default to 'today' if no 'to' date is available
        val.toDate ? $.ty.timedropdown.stringToDate(val.toDate).toDate() : '+0');

        // Limit the datepicker selection
        pickers.each(limitDatePicker);
      },

      _init: function () {
        var self = this,
            $element = this.element,
            options = this.options;
        var superListItems = void 0,
            hasCustom = void 0,
            toggleCustom = void 0,
            customRangePanel = void 0,
            pickers = void 0,
            additionalContentPanel = void 0;

        // destroy any existing datepickers
        $element.find('.datepicker').datepicker('destroy');

        // iteration callbacks
        /**
         * Parse the UI list items, from a range item.
         *
         * @param item
         * @return {{value: string, label: string, selected: boolean}[]}
         */
        var parseListItems = function (item) {
          hasCustom = hasCustom || item === 'custom';
          return options.listItems(item, superListItems);
        };

        // get a list of items and render the template
        superListItems = function (range) {
          return self._listItems(range);
        };
        var blocks = $.extend(true, {}, { r: options.ranges }).r;
        blocks.forEach(function (block) {
          block.items = $.map(block.items, parseListItems);
          if (block.more) {
            block.more.isDisabled = options.isRestricted;
            block.more.items = $.map(block.more.items, parseListItems);
          }
        });

        // add custom range pickers
        if (hasCustom) {
          blocks.push({
            span: true,
            class_: ['datepickers'],
            items: [],
            more: false
          });
        }

        // additional content
        if (options.additionalContent !== '') {
          blocks.push({
            span: true,
            class_: ['additional'],
            items: [],
            more: false
          });
        }
        $element.html($(jumboTemplate({
          blocks: blocks,
          icon: options.icon,
          iconPosition: options.iconPosition,
          iconAnimation: options.iconAnimation,
          alignment: options.alignment,
          dropdown: options.dropdown
        })).html());
        var jumboMenu = $element.dropdownmenu({
          toggle: 'a',
          label: 'a span',
          item: '.jumbo-menu li:not(.jumbo-block-title,.no-select), .dropdown-menu li',
          submenu: '.more',
          disabledClass: 'is-disabled',
          open: function (evt, data) {
            if (!jumboMenu.is(evt.target)) {
              return;
            }

            // collapse the datepickers
            if (!data.open && hasCustom) {
              toggleCustom.removeClass('active');
              customRangePanel.hide();
            }
          }
        });

        // initialize the custom range date pickers
        if (hasCustom) {
          toggleCustom = $element.find('.no-select a');
          customRangePanel = $element.find('.datepickers').hide();
          customRangePanel.html(customRangeTemplate({
            from: options.labels.customFrom,
            to: options.labels.customTo,
            apply: options.labels.customApply
          }));

          // from & to datepickers
          pickers = customRangePanel.find('.datepicker');
          pickers.datepicker({
            onSelect: limitDatePicker,
            changeMonth: true,
            changeYear: true,
            yearRange: '2000:+5',
            minDate: options.minDate,
            onChangeMonthYear: function (year, month, instance) {
              // The month comes in the [1,12] range, but Date is using [0,11]
              month -= 1;

              // If we didn't change the month or year, do nothing
              if (instance.currentYear === year && instance.currentMonth === month) {
                return;
              }

              // The day that will be selected on the datepicker
              var day = instance.currentDay;

              // The date for the other datepicker, needed if we use the same month and year
              var otherDate = $(this).siblings('.datepicker').datepicker('getDate');

              // The comparison is different for FROM and TO datepickers, so we need a
              // dynamic function to be able to handle an dynamic < or > operator
              var compare = function (firstVal, operator, secondVal) {
                switch (operator) {
                  case '>':
                    return firstVal > secondVal;
                  case '<':
                    return firstVal < secondVal;
                }
                throw new Error('Unknown operator ' + operator + ' in compare function');
              };
              // Use different operator based on the datepicker type (TO or FROM)
              var operator = $(this).hasClass('date-from') ? '>' : '<';

              // The day threshold is the last day of the selected month
              // (for cases like 31 Jan -> Feb where 31 is not available)
              // month + 1 -> next month; 0 -> last day of the previous month
              var dayThreshold = new Date(year, month + 1, 0).getDate();

              // If the newly selected month/year is the same as the one from the
              // other datepicker we need to makes sure that FROM <= TO
              if (otherDate && otherDate.getMonth() === month && otherDate.getFullYear() === year) {
                if (compare(day, operator, otherDate.getDate())) {
                  day = dayThreshold;
                }
              }

              // They day can never be more that the last day of the month
              if (day > dayThreshold) {
                day = dayThreshold;
              }

              var fullDate = new Date(year, month, day);
              $(this).datepicker('setDate', fullDate);
              limitDatePicker.bind(this)();
            }
          });

          // prevent the datepicker anchors from changing the url fragment
          customRangePanel.on('click', 'a[href=#]', false);
        }

        // add additional content
        if (options.additionalContent !== '') {
          additionalContentPanel = $element.find('.additional');
          additionalContentPanel.html(options.additionalContent);
        }

        this.val(options.val, true);
      },

      /**
       * Parse an option and return an array of items to be displayed in the ui
       * @param range
       * @protected
       */
      _listItems: function (range) {
        var options = this.options;
        var moreItem = function (v) {
          return {
            value: JSON.stringify(v),
            label: $.ty.timedropdown.labels(v).selected,
            selected: false
          };
        };
        var years = options.moreYears;
        switch (range) {
          case 'moreMonths':
            {
              return this._moreItems('months', years, true).map(moreItem);
            }
          case 'moreQuarters':
            {
              return this._moreItems('quarters', years, true).map(moreItem);
            }
          case 'moreYears':
            {
              return this._moreItems('years', years, true).map(moreItem);
            }
          case 'moreFutureMonths':
            {
              return this._moreItems('months', years, false).map(moreItem);
            }
          case 'moreFutureQuarters':
            {
              return this._moreItems('quarters', years, false).map(moreItem);
            }
          case 'moreFutureYears':
            {
              return this._moreItems('years', years, false).map(moreItem);
            }
          default:
            {
              return [{
                value: JSON.stringify({ time: range }),
                label: $.ty.timedropdown.labels({ time: range }).item,
                selected: false,
                noSelect: range === 'custom',
                isDisabled: !!(options.isRestricted && $.inArray(range, ['last7days', 'last30days', 'thisMonth']) === -1)
              }];
            }
        }
      },

      /**
       * Start with the past 'years' years and return a list of all the 'timeUnit's
       * contained in the period, up until today.
       * The last time slice may be incomplete.
       * @param timeUnit a MomentJS compatible unit e.g. 'days', 'months'
       * @param years the number of years to go back
       * @return {Array}
       * @protected
       */
      _moreItems: function (timeUnit, years, past) {
        var from = void 0,
            to = void 0,
            maxTo = void 0,
            rangeIterator = void 0,
            value = void 0;
        var today = $.ty.timedropdown.today();
        if (past) {
          from = moment().subtract('years', years).startOf('year');
          rangeIterator = from.twix(today).iterate(timeUnit);
        } else {
          from = $.ty.timedropdown.today();
          rangeIterator = from.twix(today.add('years', years).startOf('year')).iterate(timeUnit);
        }

        var ranges = [];
        while (rangeIterator.hasNext()) {
          from = rangeIterator.next();
          to = moment(from).endOf(timeUnit).startOf('day');

          // no time travel
          if (past) {
            if (to.isAfter(today)) {
              maxTo = to;

              // this will cause the range to always run until 'today', even when reloaded after a couple of days
              to = null;
            }
          }
          value = this._customValue(from, to);

          // be careful not to exceed the time unit
          if (maxTo) {
            value.maxToDate = $.ty.timedropdown.dateToString(maxTo);
          }
          if (past) {
            ranges.unshift(value);
          } else {
            ranges.push(value);
          }
        }
        return ranges;
      },

      /**
       * Creates a custom value from the specified dates
       * @param from
       * @param to
       * @return {{time: string, fromDate: string, toDate: string}}
       * @private
       */
      _customValue: function (from, to) {
        return {
          time: 'custom',
          fromDate: $.ty.timedropdown.dateToString(from),
          toDate: to ? $.ty.timedropdown.dateToString(to) : null
        };
      },

      _destroy: function () {
        var $element = this.element;
        $element.find('.datepickers').off('click', 'a[href=#]', false);
        $element.find('.datepicker').datepicker('destroy');
        $element.dropdownmenu('destroy');
        $element.removeClass('timedropdown trustyou-ui dropdown dropdown-jumbo-menu');
      },

      /**
       * Get/set the filter value.
       * @param [value]
       * @param [silent] if true, the 'change' event won't be fired
       * @return {*} the value, if no parameters are provided, nothing otherwise
       */
      val: function (value, silent) {
        if (value === undefined) {
          return $.extend(true, {}, this._currentFilter);
        }

        // set
        var options = this.options;
        this._currentFilter = options.parseValue(value, function (v) {
          return $.ty.timedropdown.relativeValue(v);
        });

        // update the filter label
        if (options.mainLabel) {
          this.element.find('> a span').text(options.mainLabel);
        } else {
          this.element.find('> a span').text(options.valueLabels(this._currentFilter, function (v) {
            return $.ty.timedropdown.labels(v);
          }).selected);
        }
        var val = this.val();

        // set date pickers
        this._setDatepickers(val);

        // event
        if (!silent) {
          this._trigger('change', null, { val: val });
        }
        return $.extend(true, {}, this._currentFilter);
      }
    });

    // static utility methods
    $.extend($.ty.timedropdown, {
      stringToDate: function (s) {
        return moment(s, 'YYYY-MM-DD');
      },
      dateToString: function (date) {
        var m = moment.isMoment(date) ? date : moment(date);
        return m.format('YYYY-MM-DD');
      },
      addDays: function (date, days) {
        return moment(date).add('days', days);
      },
      addMonths: function (date, months) {
        return moment(date).add('months', months);
      },
      addMonthsAndRound: function (date, months) {
        return this.addMonths(date, months).startOf('month');
      },
      addQuarter: function (date, quarters) {
        var m = moment(date),
            quarterStart = Math.floor(m.month() / 3) * 3;
        return m.month(quarterStart).add('months', quarters * 3);
      },
      addQuarterAndRound: function (date, quarters) {
        return this.addQuarter(date, quarters).startOf('month');
      },
      addYears: function (date, years) {
        return moment(date).add('years', years);
      },
      addYearsAndRound: function (date, years) {
        return this.addYears(date, years).startOf('year');
      },
      today: function () {
        return moment().startOf('day');
      },


      /**
       * Populates the from and to fields for relative filter values (e.g. last30days)
       * @param value {Object} { time: String }
       * @return {Object} { from: String, to: String/null, time: String }
       */
      relativeValue: function (value) {
        var self = this;
        var maxTo = void 0;
        if (!value) {
          return value;
        }

        var today = self.today();
        var relative = $.extend(true, {}, value);
        relative.fromDate = relative.fromDate || null;
        relative.toDate = relative.toDate || null;

        switch (value.time) {
          case 'custom':
            {
              // make sure we don't exceed the maximum value for the 'to' date
              if (relative.maxToDate && !relative.toDate) {
                maxTo = this.stringToDate(relative.maxToDate);
                if (today.isAfter(maxTo)) {
                  relative.toDate = relative.maxToDate;
                }
              }
              return relative;
            }
          case 'noTimeFilter':
            {
              return null;
            }
          case 'lastDay':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -1)),
                toDate: null
              });
            }
          case 'nextDay':
            {
              return $.extend(relative, {
                fromDate: today,
                toDate: self.dateToString(self.addDays(today, +1))
              });
            }
          case 'last3days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -3)),
                toDate: null
              });
            }
          case 'next3days':
            {
              return $.extend(relative, {
                fromDate: today,
                toDate: self.dateToString(self.addDays(today, +3))
              });
            }
          case 'last7days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -7)),
                toDate: null
              });
            }
          case 'next7days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, +1)),
                toDate: self.dateToString(self.addDays(today, +8))
              });
            }
          case 'last30days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -30)),
                toDate: null
              });
            }
          case 'next30days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, +1)),
                toDate: self.dateToString(self.addDays(today, +31))
              });
            }
          case 'last60days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -60)),
                toDate: null
              });
            }
          case 'next60days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, +1)),
                toDate: self.dateToString(self.addDays(today, +61))
              });
            }
          case 'last120days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, -120)),
                toDate: null
              });
            }
          case 'next120days':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addDays(today, +1)),
                toDate: self.dateToString(self.addDays(today, +121))
              });
            }
          case 'thisMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 0)),
                toDate: null
              });
            }
          case 'currentMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 0)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 1), -1))
              });
            }
          case 'nextMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 2), -1))
              });
            }
          case 'lastMonth':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'last3Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -3)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'next3Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 4), -1))
              });
            }
          case 'last6Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -6)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'next6Months':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 7), -1))
              });
            }
          case 'last12Months':
          case 'last12months':
          case 'lastYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -12)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'next12Months':
          case 'next12months':
          case 'nextYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 13), -1))
              });
            }
          case 'last24Months':
          case 'last2Years':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, -24)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 0), -1))
              });
            }
          case 'next24Months':
          case 'next2Years':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addMonthsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addMonthsAndRound(today, 25), -1))
              });
            }
          case 'currentQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, 0)),
                toDate: null
              });
            }
          case 'previousQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addQuarterAndRound(today, 0), -1))
              });
            }
          case 'currentFullQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, 0)),
                toDate: self.dateToString(self.addDays(self.addQuarterAndRound(today, 1), -1))
              });
            }
          case 'nextQuarter':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addQuarterAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addQuarterAndRound(today, 2), -1))
              });
            }
          case 'currentYear':
          case 'yearToDate':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, 0)),
                toDate: null
              });
            }
          case 'currentFullYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, 0)),
                toDate: self.dateToString(self.addDays(self.addYearsAndRound(today, 1), -1))
              });
            }
          case 'previousYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, -1)),
                toDate: self.dateToString(self.addDays(self.addYearsAndRound(today, 0), -1))
              });
            }
          case 'followingYear':
            {
              return $.extend(relative, {
                fromDate: self.dateToString(self.addYearsAndRound(today, 1)),
                toDate: self.dateToString(self.addDays(self.addYearsAndRound(today, 2), -1))
              });
            }
          default:
            {
              throw new Error('unknown timedropdown value');
            }
        }
      },


      /**
       * Returns the list item label and the selected label for a value.
       * The 2 are different for the custom range.
       * @param value {Object} { fromDate: String, toDate: String/null, time: String }
       * @return {Object} { item: String, selected: String }
       */
      labels: function (value, lang) {
        var from = void 0,
            to = void 0,
            range = void 0;
        if (!value) {
          return null;
        }

        if (lang) {
          moment.lang(lang);
        }

        switch (value.time) {
          case 'custom':
            {
              from = this.stringToDate(value.fromDate);
              to = value.toDate ? this.stringToDate(value.toDate) : this.today();
              range = from.twix(to, true);
              return {
                item: i18n.common_fromto,
                selected: range.format({ implicitYear: false })
              };
            }
          case 'noTimeFilter':
            {
              return {
                selected: i18n.common_alltime
              };
            }

          // days
          case 'lastDay':
            {
              return {
                item: i18n.common_lastday,
                selected: i18n.common_lastday
              };
            }
          case 'nextDay':
            {
              return {
                item: i18n.common_nextday,
                selected: i18n.common_nextday
              };
            }
          case 'last3days':
            {
              return {
                item: i18n.common_last3days,
                selected: i18n.common_last3days
              };
            }
          case 'next3days':
            {
              return {
                item: i18n.common_next3days,
                selected: i18n.common_next3days
              };
            }
          case 'last7days':
            {
              return {
                item: i18n.common_last7days,
                selected: i18n.common_last7days
              };
            }
          case 'next7days':
            {
              return {
                item: i18n.common_next7days,
                selected: i18n.common_next7days
              };
            }
          case 'last30days':
            {
              return {
                item: i18n.common_last30days,
                selected: i18n.common_last30days
              };
            }
          case 'next30days':
            {
              return {
                item: i18n.common_next30days,
                selected: i18n.common_next30days
              };
            }
          case 'last60days':
            {
              return {
                item: i18n.common_last60days,
                selected: i18n.common_last60days
              };
            }
          case 'next60days':
            {
              return {
                item: i18n.common_next60days,
                selected: i18n.common_next60days
              };
            }
          case 'last120days':
            {
              return {
                item: i18n.common_last120days,
                selected: i18n.common_last120days
              };
            }
          case 'next120days':
            {
              return {
                item: i18n.common_next120days,
                selected: i18n.common_next120days
              };
            }

          // months
          case 'thisMonth':
            {
              return {
                item: i18n.common_thismonth,
                selected: i18n.common_thismonth
              };
            }
          case 'currentMonth':
            {
              return {
                item: i18n.common_currentmonth,
                selected: i18n.common_currentmonth
              };
            }
          case 'lastMonth':
            {
              return {
                item: i18n.common_lastmonth,
                selected: i18n.common_lastmonth
              };
            }
          case 'nextMonth':
            {
              return {
                item: i18n.common_nextmonth,
                selected: i18n.common_nextmonth
              };
            }
          case 'last3Months':
            {
              return {
                item: i18n.common_last3months,
                selected: i18n.common_last3months
              };
            }
          case 'next3Months':
            {
              return {
                item: i18n.common_next3months,
                selected: i18n.common_next3months
              };
            }
          case 'last6Months':
            {
              return {
                item: i18n.common_last6months,
                selected: i18n.common_last6months
              };
            }
          case 'next6Months':
            {
              return {
                item: i18n.common_next6months,
                selected: i18n.common_next6months
              };
            }
          case 'last12Months':
          case 'last12months':
          case 'lastYear':
            {
              return {
                item: i18n.common_last12months,
                selected: i18n.common_last12months
              };
            }
          case 'next12Months':
          case 'next12months':
          case 'nextYear':
            {
              return {
                item: i18n.common_next12months,
                selected: i18n.common_next12months
              };
            }
          case 'last24Months':
          case 'last2Years':
            {
              return {
                item: i18n.common_last24months,
                selected: i18n.common_last24months
              };
            }
          case 'next24Months':
          case 'next24months':
            {
              return {
                item: i18n.common_next24months,
                selected: i18n.common_next24months
              };
            }

          // quarters
          case 'currentQuarter':
            {
              return {
                item: i18n.common_qtd,
                selected: i18n.common_qtd
              };
            }
          case 'previousQuarter':
            {
              return {
                item: i18n.common_previousquarter,
                selected: i18n.common_previousquarter
              };
            }
          case 'currentFullQuarter':
            {
              return {
                item: i18n.common_currentquarter,
                selected: i18n.common_currentquarter
              };
            }
          case 'nextQuarter':
            {
              return {
                item: i18n.common_nextquarter,
                selected: i18n.common_nextquarter
              };
            }

          // years
          case 'currentYear':
          case 'yearToDate':
            {
              return {
                item: i18n.common_ytd,
                selected: i18n.common_ytd
              };
            }
          case 'previousYear':
            {
              return {
                item: i18n.common_previousyear,
                selected: i18n.common_previousyear
              };
            }
          case 'currentFullYear':
            {
              return {
                item: i18n.common_currentyear,
                selected: i18n.common_currentyear
              };
            }
          case 'followingYear':
            {
              return {
                item: i18n.common_nextyear,
                selected: i18n.common_nextyear
              };
            }
          default:
            {
              throw new Error('unknown timedropdown value');
            }
        }
      }
    });

    return $.ty.timedropdown;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/old_components/side-panel',['jquery', 'jquery-ui', 'jquery-sidr', 'tooltipsy'], function ($) {
    if ($.fn.SidePanel) {
      throw new Error('$.fn.SidePanel is already defined');
    }

    $.fn.SidePanel = function () {
      return $.extend(this, $.fn.SidePanel.API);
    };

    var defaults = {
      dataprovider: function () {
        return $.Deferred().resolve();
      },

      renderer: function () {
        var self = this,
            deferred = $.Deferred();

        if (self._container().html() !== '') {
          self._container().empty();
        }

        self._create();

        self._open().done(function () {
          deferred.resolve();
        });

        return deferred;
      },

      onOpen: function () {
        var self = this,
            data = self._data(),
            params = data.params,
            $pageBody = $('body');

        $('<div class="side-panel-overlay" data-panel="' + params.templatePanel + '"></div>').hide().prependTo('body');
        $pageBody.addClass('has-overlay');
        $('.side-panel-overlay').fadeIn();
      },

      onClose: function () {
        var self = this,
            $pageBody = $('body');

        $('.side-panel-overlay').fadeOut(function () {
          $(this).remove();
          $pageBody.removeClass('has-overlay');

          self._container().remove();
        });
      },

      onRendered: function () {},

      onBeforeClose: function () {
        // continue to close by default
        return true;
      },

      onAfterClose: undefined,

      getSource: function () {
        return this.html();
      },

      body: '#sidr-slidepane',

      sidePanelContainer: 'sidr-slidepane',

      templatePanel: 'template-panel',

      side: 'right',

      displace: false,
      coverScreen: true,

      rendered: $.noop,
      error: $.noop,

      labels: {},

      disableForceRefreshIE8Fix: false
    };

    $.fn.SidePanel.API = {
      init: function (params) {
        var self = this;

        params = $.extend(true, {}, defaults, params);

        if (!$('#' + params.sidePanelContainer).length) {
          $('body').append('<div id="' + params.sidePanelContainer + '" class="trustyou-ui"></div>');
        }

        var $panelContainer = $('#' + params.sidePanelContainer);

        var panel = $panelContainer.children('#' + params.templatePanel);

        if (!panel.length) {
          $panelContainer.append('<div id="' + params.templatePanel + '" class="trustyou-ui side-panel"></div>');
        }

        if (!params.keyUpHandler) {
          params.keyUpHandler = function (e) {
            if (e.keyCode === 27) {
              self._close();
            }
          };
        }

        self._data({ params: params });

        self.refresh();

        return this;
      },
      refresh: function () {
        var self = this,
            data = self._data(),
            params = data.params,
            handleError = function (ddata) {
          params.error.call(self, ddata);
        };

        params.dataprovider.call(self).done(function (ddata) {
          params.renderer.call(self, ddata).done(function () {
            params.rendered.call(self);
          }).fail(handleError);
        }).fail(handleError);

        return this;
      },
      _bindEvents: function () {
        var self = this,
            data = self._data(),
            params = data.params;

        // remove side panel by clicking [Cancel] or [X]
        self._container().find('.btn-close, .side-panel [id*="cancel-"], [data-toggle="side-panel"]').on('click', function () {
          self._close();
        });

        // remove side panel by clicking the empty space next to the panel (overlay)
        $('.side-panel-overlay').on('click', function () {
          self._close();
        });

        // remove side panel by pressing the Esc key
        $(document).keyup(params.keyUpHandler);

        // adding tooltipsy for all elements with data-tooltip attributes
        self._container().find('[data-tooltip]').each(function () {
          var align = $(this).attr('data-tooltip');
          var offset = void 0;

          switch (align) {
            case 'left':
              {
                offset = [-1, 0];
                break;
              }
            case 'top':
              {
                offset = [0, -1];
                break;
              }
            case 'bottom':
              {
                offset = [0, 1];
                break;
              }
            default:
              {
                offset = [1, 0];
              }
          }

          if (!$(this).hasClass('tooltip-init')) {
            $(this).tooltipsy({
              offset: offset,
              className: 'trustyou-ui tooltip l-' + align
            });
          }
          $(this).addClass('tooltip-init');
        });
      },
      _unbindEvents: function () {
        var self = this,
            data = self._data(),
            params = data.params;

        self._container().find('[data-tooltip]').each(function () {
          if ($(this).data('tooltipsy')) {
            $(this).data('tooltipsy').destroy();
          }
        });

        $(document).unbind('keyup', params.keyUpHandler);
      },
      _create: function () {
        var self = this,
            data = self._data(),
            params = data.params;

        $('<div></div>').sidr({
          name: params.templatePanel,
          body: params.body,
          displace: params.displace,
          coverScreen: params.coverScreen,
          side: params.side,
          containerWidth: $(params.body).find('.container:first').width(),
          gutterWidth: 30,
          onOpen: function () {
            params.onOpen.call(self);
          },
          onClose: function () {
            params.onClose.call(self);
          },
          source: function () {
            return params.getSource.call(self);
          }
        });
      },
      _open: function () {
        var self = this,
            data = self._data(),
            params = data.params,
            deferred = $.Deferred(),
            $pageBody = $('body'),
            $body = $(params.body);

        // add classes to body based on panel state
        $body.removeClass('l-displaced has-side-panel-left has-side-panel-right');
        $body.addClass('has-side-panel-' + params.side);

        if (params.displace) {
          $pageBody.addClass('l-displaced');
        }

        // Card header title try to expand as miximum, with flex
        var cardHeaderTitle = $('#' + params.templatePanel + '.side-panel .card-header')[0];
        if (typeof cardHeaderTitle !== 'undefined') {
          var hElems = $(cardHeaderTitle).find(':header');
          if (hElems.length === 1) {
            $(cardHeaderTitle).css('display', 'flex');
            $(hElems).css({
              'flex-grow': '1',
              order: '-1',
              'max-width': 'unset'
            });
          }
        }

        self._unbindEvents();

        // HACK: fix when trying to open several times the same panel (by clicking on the button)
        if ($('#' + params.templatePanel + '.side-panel').is(':visible')) {
          params.onRendered.call(self);

          if ($('.side-panel-overlay').length > 0) {
            $pageBody.addClass('has-overlay');
          }

          self._bindEvents();

          deferred.resolve();
        } else {
          // open side panel after loading it
          $.sidr('open', params.templatePanel, function () {
            if (!params.disableForceRefreshIE8Fix) {
              // ie8 fix for icons that are not shown
              if ($('html').hasClass('ie8')) {
                self._container().html(self._container().html());
              }
            }

            params.onRendered.call(self);

            if ($('.side-panel-overlay').length > 0) {
              $pageBody.addClass('has-overlay');
            }

            self._bindEvents();

            deferred.resolve();
          });
        }

        $('html').css('overflow-x', '');

        return deferred;
      },


      /*
       * Method used to close the side-panel
       *
       * @params	proceed		parameter used to skip the execution of the `onBeforeClose` callback
       * @params	callback	parameter used to replace the normal `onAfterClose`	callback
       *						that gets executed by default when the $.sidr() method is done
       */
      _close: function (proceed, callback) {
        var self = this,
            data = self._data(),
            params = data.params;
        var afterCloseCallback = void 0;

        if (typeof proceed === 'undefined') {
          proceed = params.onBeforeClose.call(self);
        }

        if (proceed) {
          $('body').removeClass('l-displaced has-overlay has-side-panel-' + params.side);

          if (callback) {
            afterCloseCallback = callback;
          } else if (params.onAfterClose) {
            afterCloseCallback = params.onAfterClose;
          }

          $.sidr('close', self._container().attr('id'), afterCloseCallback);

          self._unbindEvents();
        }
      },
      _container: function () {
        var self = this;

        var data = self._data();
        var params = data.params;

        return $('#' + params.templatePanel);
      },
      _data: function (data) {
        var dataAttr = 'sidePanelData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      }
    };
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  define('commons/public/js/old_components/messaging-auth-link',['jquery', './../config', 'session'], function ($, config, session) {
    var MessagingAuthLink = function () {
      function MessagingAuthLink(targetUrl) {
        _classCallCheck(this, MessagingAuthLink);

        this.targetUrl = targetUrl || config.urls.messaging;
      }

      _createClass(MessagingAuthLink, [{
        key: 'callLinksWithJWT',
        value: function callLinksWithJWT(deferred, jwt) {
          if (config.urls.links) {
            $.ajax({
              url: config.urls.links,
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: '' + jwt
              },
              type: 'post',
              cache: false,
              data: JSON.stringify({
                url: this.targetUrl,
                sso_token: session.ssoToken
              })
            }).done(function (response) {
              if (response && response.data && response.data.tokenized_url) {
                deferred.resolve(response.data.tokenized_url);
              } else {
                deferred.reject();
              }
            }).fail(function () {
              deferred.reject();
            });
          } else {
            deferred.resolve(null);
          }
        }

        /**
         * Generate auth link
         * @returns deferred that is resolved with the valud of the auth link
         */

      }, {
        key: 'generate',
        value: function generate() {
          var _this = this;

          var deferred = $.Deferred();

          $.get(config.urls.sso + '/api/jwt').done(function (response) {
            _this.callLinksWithJWT(deferred, response.jwt);
          }).fail(function () {
            deferred.reject();
          });

          return deferred;
        }
      }]);

      return MessagingAuthLink;
    }();

    return MessagingAuthLink;
  });
})();
define('commons/public/jadec/ui_components/accordion',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('accordion') + ' ' + (chained ? ["accordion-chained"] : "") }, {"class":true})) + ">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

var refresh_item, hint_classes = ["hint"]
refresh_item = refresh_item !== undefined ? refresh_item : false
item.hint_class && hint_classes.push(item.hint_class);
if ( refresh_item)
{
buf.push("<div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div>");
}
else
{
if ( item.id)
{
buf.push("<div" + (jade.attrs({ 'id':(item.id), "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true,"id":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
else
{
buf.push("<div" + (jade.attrs({ "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

var refresh_item, hint_classes = ["hint"]
refresh_item = refresh_item !== undefined ? refresh_item : false
item.hint_class && hint_classes.push(item.hint_class);
if ( refresh_item)
{
buf.push("<div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div>");
}
else
{
if ( item.id)
{
buf.push("<div" + (jade.attrs({ 'id':(item.id), "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true,"id":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
else
{
buf.push("<div" + (jade.attrs({ "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
}
      }

    }

  }
}).call(this);

buf.push("</div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/accordion-element',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var refresh_item, hint_classes = ["hint"]
refresh_item = refresh_item !== undefined ? refresh_item : false
item.hint_class && hint_classes.push(item.hint_class);
if ( refresh_item)
{
buf.push("<div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div>");
}
else
{
if ( item.id)
{
buf.push("<div" + (jade.attrs({ 'id':(item.id), "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true,"id":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
else
{
buf.push("<div" + (jade.attrs({ "class": ('accordion-group') + ' ' + (item.group_class) }, {"class":true})) + "><div class=\"accordion-header\"><span class=\"title\">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</span>" + (((jade.interp = item.additional_content) == null ? '' : jade.interp)) + "<i class=\"ty-icon ty-icon-chevron-down\"></i><span" + (jade.attrs({ "class": (hint_classes) }, {"class":true})) + ">" + (((jade.interp = item.hint) == null ? '' : jade.interp)) + "</span></div><div class=\"accordion-body\">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div></div>");
}
}
}
return buf.join("");
};

});

/**
 * How to use:
 *
 * Initialization
 * $('#selector').Accordion({
 * 	chained: true,
 * 	elements: [
 * 		{title: 'title 1', content: 'content 1', hint: 'optional hint'},
 * 		{title: 'title 2', content: 'content 2'}
 * 	]
 * })
 *
 * Getting options
 * $('#selector').Accordion('option', 'chained')
 *
 * Setting options
 * $('#selector').Accordion('option', 'chained', true)
 *
 * Expanding/collapsing accordion item programatically
 * $('#selector').Accordion('selected', 'id', true/false)
 *
 */
(function () {
  'use strict';

  define('commons/public/js/ui_components/accordion',['jquery', 'widget', 'accordion-template', 'accordion-element-template'], function ($, widget, tmpl, tmplElement) {
    $.widget('ty.Accordion', widget, {
      options: {
        elements: [],
        chained: true,
        onChange: function (value) {},
        additional_data_selector: undefined
      },

      _create: function () {},

      _init: function () {
        var $element = this.element,
            options = this.options;

        var items = options.elements.map(function (element) {
          return {
            id: element.id || undefined,
            title: element.title,
            content: element.content,
            hint: element.hint || '',
            additional_content: element.additional_content || '',
            group_class: element.group_class || '',
            hint_class: element.hint_class || ''
          };
        });

        $element.empty().append(tmpl({
          items: items,
          chained: options.chained
        }));

        this._bindEvents();
      },

      _bindEvents: function () {
        var $element = this.element,
            options = this.options,
            self = this;

        $element.on('click', '.accordion-group:not(.is-disabled) .accordion-header', function (e) {
          if (options.additional_data_selector && $(e.target).closest(options.additional_data_selector).length > 0) {
            return;
          }

          var group = $(this).parents('.accordion-group');
          var accordion = group.parent();

          // toggle current slide
          group.find('.accordion-body').slideToggle(100, function () {
            // Trigger event only if there's an id
            if (group.attr('id')) {
              self.selected.call(self, group.attr('id'), !group.hasClass('is-active'));
            }
            group.toggleClass('is-active');
          });

          // if accordion is chained, collapse other groups
          if (options.chained) {
            accordion.find('.accordion-group').not(group).find('.accordion-body').each(function () {
              $(this).slideUp(100, function () {
                $(this).parent().removeClass('is-active');
              });
            });
          }
        });
      },

      _unbindEvents: function () {
        var $element = this.element;

        $element.off('click', '.accordion-group:not(.is-disabled) .accordion-header');
      },

      // Select event
      selected: function (rowId, state) {
        this._trigger('select', null, { id: rowId, state: state });
      },

      // Select event
      select: function (rowId, state) {
        var $element = this.element,
            options = this.options,
            self = this,
            $groupElement = $element.find('#' + rowId);
        var accordion = void 0;

        // Trigger event only if there's an id
        if ($groupElement.length === 1) {
          accordion = $groupElement.parent();

          // toggle current slide
          $groupElement.find('.accordion-body').slideToggle(100, function () {
            // Trigger event only if there's an id
            if ($groupElement.attr('id')) {
              self.selected.call(self, $groupElement.attr('id'), state);
            }
            if (state) {
              if (!$groupElement.hasClass('is-active')) {
                $groupElement.toggleClass('is-active');
              }
            } else {
              $groupElement.removeClass('is-active');
            }
          });

          // if accordion is chained, collapse other groups
          if (options.chained) {
            accordion.find('.accordion-group').not($groupElement).find('.accordion-body').each(function () {
              $(this).slideUp(100, function () {
                $(this).parent().removeClass('is-active');
              });
            });
          }
        }
      },

      refreshItem: function (item) {
        var $element = this.element;
        if ($element.find('#' + item.id).length === 1) {
          $element.find('#' + item.id).empty().append(tmplElement({
            refresh_item: true,
            item: item
          }));
        }
        this._unbindEvents();
        this._bindEvents();
      },
      updateHint: function (itemId, hintContent) {
        var $element = this.element;
        if ($element.find('#' + itemId).length === 1) {
          $element.find('#' + itemId + ' .accordion-header .hint').empty().append(hintContent);
        }
        this._unbindEvents();
        this._bindEvents();
      }
    });

    return $.ty.Accordion;
  });
})();
define('commons/public/jadec/ui_components/paginator',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
if ( boxes.length > 1)
{
buf.push("<ul class=\"trustyou-ui pagination\"><li" + (jade.attrs({ 'data-value':(prevValue.value), "class": ('prev') + ' ' + ((prevValue.value !== undefined) ? "" : "is-disabled") }, {"class":true,"data-value":true})) + "><a><i class=\"ty-icon ty-icon-chevron-left\"></i></a></li>");
// iterate boxes
;(function(){
  var $$obj = boxes;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var box = $$obj[$index];

if ( (box.value !== undefined))
{
if ( (box.value === selectedValue))
{
buf.push("<li" + (jade.attrs({ 'data-value':(box.value), "class": ('is-active') }, {"data-value":true})) + "><a>" + (jade.escape((jade.interp = box.displayedValue) == null ? '' : jade.interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(box.value) }, {"data-value":true})) + "><a>" + (jade.escape((jade.interp = box.displayedValue) == null ? '' : jade.interp)) + "</a></li>");
}
}
else
{
buf.push("<li class=\"more\"><a><i class=\"ty-icon ty-icon-more\"></i></a></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var box = $$obj[$index];

if ( (box.value !== undefined))
{
if ( (box.value === selectedValue))
{
buf.push("<li" + (jade.attrs({ 'data-value':(box.value), "class": ('is-active') }, {"data-value":true})) + "><a>" + (jade.escape((jade.interp = box.displayedValue) == null ? '' : jade.interp)) + "</a></li>");
}
else
{
buf.push("<li" + (jade.attrs({ 'data-value':(box.value) }, {"data-value":true})) + "><a>" + (jade.escape((jade.interp = box.displayedValue) == null ? '' : jade.interp)) + "</a></li>");
}
}
else
{
buf.push("<li class=\"more\"><a><i class=\"ty-icon ty-icon-more\"></i></a></li>");
}
      }

    }

  }
}).call(this);

buf.push("<li" + (jade.attrs({ 'data-value':(nextValue.value), "class": ('next') + ' ' + ((nextValue.value !== undefined) ? "" : "is-disabled") }, {"class":true,"data-value":true})) + "><a><i class=\"ty-icon ty-icon-chevron-right\"></i></a></li></ul>");
}
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 *		$div_element.paginator({ selected: selected_page_number, numPages: numPages,
 *								displayNumPages: displayNumPages, showFirstLastPages: true/false })
 *
 * Select page event:
 *
 *		$div_element.on('paginatorselect', function (e, data) {
 *			data will contain an object like {selectedValue: new_page_number}
 *		});
 *
 * Get page:
 *
 * 		$div_element.paginator('value')
 *
 * Set page:
 *
 *		$div_element.paginator('value', new_page_number)
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/paginator',['jquery', 'widget', 'paginator-template'], function ($, widget, paginatorTemplate) {
    $.widget('ty.paginator', widget, {
      options: {
        // Selected row, should be from range 0...numPages-1
        selected: 0,

        // Total number of pages
        numPages: 1,

        // How many pages do we want to show
        displayNumPages: 5,

        // Show first and last page,
        showFirstLastPages: true
      },

      _create: function () {
        var self = this,
            options = self.options;

        // item click
        this._on(['click', '.pagination li:not(.is-active, .is-disabled, .more)', this._callWhenEnabled(function () {
          options.selected = parseInt($(this).data('value'));
          self.select();
          self._showPaginator();
        })]);
      },

      // It just calls _showPaginator, which will render the paginator
      _init: function () {
        this._showPaginator();
      },

      // It renders the paginator
      _showPaginator: function () {
        var options = this.options,
            boxes = this._getVisibleValues(options.selected, options.numPages, options.displayNumPages, options.showFirstLastPages);
        this._renderBoxes(boxes);
      },

      // It renders as many boxes as existing in the passed param
      _renderBoxes: function (boxes) {
        var $element = this.element,
            selectedValue = this.options.selected,
            numPages = this.options.numPages;
        $element.empty().append(paginatorTemplate({
          boxes: boxes,
          prevValue: selectedValue - 1 >= 0 ? { value: selectedValue - 1 } : { value: undefined },
          nextValue: selectedValue + 1 >= numPages ? { value: undefined } : { value: selectedValue + 1 },
          selectedValue: selectedValue
        }));
      },

      // Computes the boxes that should be visible.
      // Visible boxes number will be the same as displayNumPages if odd number, +1 boxes if even
      _getVisibleValues: function (currentValue, numPages, displayNumPages, showFirstLastPages) {
        var values = [];
        var startPage = void 0,
            endPage = void 0,
            firstPageValue = void 0,
            lastPageValue = void 0,
            dotsValue = void 0;

        var currentPage = currentValue + 1;

        // compute start and end pages
        if (numPages <= Math.floor(displayNumPages / 2)) {
          startPage = 1;
          endPage = numPages;
        } else if (currentPage <= Math.floor(displayNumPages / 2)) {
          startPage = 1;
          endPage = currentPage + Math.floor(displayNumPages / 2);
        } else if (currentPage + Math.floor(displayNumPages / 2) >= numPages) {
          startPage = currentPage - Math.floor(displayNumPages / 2);
          endPage = numPages;
        } else {
          startPage = currentPage - Math.floor(displayNumPages / 2);
          endPage = currentPage + Math.floor(displayNumPages / 2);
        }

        // create list of boxes without first and last boxes
        for (var page = startPage; page <= endPage; page++) {
          values.push({ value: page - 1, displayedValue: page });
        }

        // add first and last pages
        if (showFirstLastPages) {
          // `...` dots value to add after first box and before last box
          dotsValue = { value: undefined, displayedValue: undefined };

          // adding first page and dots if needed
          firstPageValue = { value: 0, displayedValue: 1 };
          if (startPage - 1 > 0) {
            if (startPage - 1 > 1) {
              values.unshift(dotsValue);
            }
            values.unshift(firstPageValue);
          }

          // adding last page and dots if needed
          lastPageValue = { value: numPages - 1, displayedValue: numPages };
          if (numPages - endPage > 0) {
            if (numPages - endPage > 1) {
              values.push(dotsValue);
            }
            values.push(lastPageValue);
          }
        }

        return values;
      },

      // Select event
      select: function () {
        var selectedValue = this.options.selected;
        this._trigger('select', null, { selectedValue: selectedValue });
      },

      // Create a public method to get or set selected value
      value: function (value) {
        // No value passed, act as a getter
        if (value === undefined) {
          return this.options.selected;
        }

        // Value passed, act as a setter
        if (value >= this.options.numPages) {
          value = this.options.numPages - 1;
        } else if (value < 0) {
          value = 0;
        }
        this.options.selected = value;
        this._showPaginator();
        return this.options.selected;
      }
    });

    return $.ty.paginator;
  });
})();
define('commons/public/jadec/ui_components/ty_tab',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<ul class=\"trustyou-ui tabs\">");
// iterate tabs
;(function(){
  var $$obj = tabs;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

var additionalClass = ""
var href = '#' + item.id
buf.push("<li" + (jade.attrs({ "class": ("" + (additionalClass) + "") }, {"class":true})) + "><a" + (jade.attrs({ 'href':("" + (href) + ""), 'data-toggle':("tab") }, {"href":true,"data-toggle":true})) + ">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</a></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

var additionalClass = ""
var href = '#' + item.id
buf.push("<li" + (jade.attrs({ "class": ("" + (additionalClass) + "") }, {"class":true})) + "><a" + (jade.attrs({ 'href':("" + (href) + ""), 'data-toggle':("tab") }, {"href":true,"data-toggle":true})) + ">" + (jade.escape((jade.interp = item.title) == null ? '' : jade.interp)) + "</a></li>");
      }

    }

  }
}).call(this);

buf.push("</ul><div class=\"trustyou-ui tab-container\">");
// iterate tabs
;(function(){
  var $$obj = tabs;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

var additionalClass = "tab-panel " + item.id
buf.push("<div" + (jade.attrs({ 'id':("" + (item.id) + ""), "class": ("" + (additionalClass) + "") }, {"id":true,"class":true})) + ">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

var additionalClass = "tab-panel " + item.id
buf.push("<div" + (jade.attrs({ 'id':("" + (item.id) + ""), "class": ("" + (additionalClass) + "") }, {"id":true,"class":true})) + ">" + (((jade.interp = item.content) == null ? '' : jade.interp)) + "</div>");
      }

    }

  }
}).call(this);

buf.push("</div>");
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 *   $div_element.ty_tab({
 *       selectedId: '#id1',
 *       tabs: [
 *           new $.ty.tab.Tab('id1', 'title1', 'content1')
 *           new $.ty.tab.Tab('id2', 'title2', 'content2')
 *       ]
 *   })
 *
 *   Arguments:
 *      - selectedId - ID of the selected tab
 *      - tabs - array of ty.tab.Tab objects (check doc at the bottom)
 *
 *   Notes:
 *   - If *tabs* is passed, the default widget template will be used
 *   - If you want to use custom markup for the widget, you don't pass *tabs*. In this
 *     case, please check the widget code and template to see which markup this widget expects.
 *
 * Handling tab *select* event:
 *
 * 		$div_element.on('ty_tabselect', function (e, data) {
 * 	        console.log(data)  # -> { selectedId: '#tabID' }
 * 		});
 *
 * Selecting tab programatically:
 *
 * 		$div_element.ty_tab('select', '#tabID')
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/ty_tab',['jquery', 'widget', 'ty_tab-template'], function ($, widget, tyTabTemplate) {
    $.widget('ty.ty_tab', widget, {
      options: {
        selectedId: '',

        /*
         * Buttons should be an array of button data:
         *	[
         *		{id: id, title: title, content: content},
         *		{id: id, title: title, content: content},
         *		...
         *	]
         * To make it easier, the class Tab (check doc at the bottom) can be used. Example:
         *	[
         *		new $.ty.tab.Tab('id1', 'title1', 'content1'),
         *		new $.ty.tab.Tab('id2', 'title2', 'content2'),
         *		new $.ty.tab.Tab('id3', 'title3', 'content3')
         *	],
         */
        tabs: []
      },

      _create: function () {
        var self = this,
            options = self.options;

        // item click
        this._on(['click', '[data-toggle=tab]', this._callWhenEnabled(function (e) {
          e.preventDefault();
          e.stopPropagation();

          options.selectedId = $(this).attr('href');
          self.select(options.selectedId);
        })]);
      },

      _init: function () {
        var self = this,
            options = self.options;

        if (!$.isEmptyObject(options.tabs)) {
          self._showTabs();
        }

        if (!$.isEmptyObject(options.selectedId)) {
          self.select(options.selectedId);
        }
      },

      // Renders the tabs
      _showTabs: function () {
        var self = this,
            $element = self.element,
            options = self.options;

        $element.empty().append(tyTabTemplate({
          tabs: options.tabs
        }));
      },

      // Select event
      select: function (selectedId) {
        var $element = this.element,
            options = this.options;

        options.selectedId = selectedId;

        this._trigger('select', null, { selectedId: selectedId });

        if (!$(selectedId).hasClass('is-active')) {
          $element.find('> .tabs').children('li').removeClass('is-active');
          $element.find('> .tabs').find('a[href="' + selectedId + '"]').parent().addClass('is-active');

          if (typeof options._selectedId !== 'undefined') {
            $(options._selectedId).removeClass('is-active');
          }

          $(selectedId).addClass('is-active');
          options._selectedId = selectedId;
        }
      }
    });

    // public classes
    $.extend($.ty.ty_tab, {

      /*
       * id: the tab id for connecting the button and the content
       * title: the title displayed on the button
       * content: additional content added to the content element
       */
      Tab: function (id, title, content) {
        if (!(this instanceof $.ty.ty_tab.Tab)) {
          return new $.ty.ty_tab.Tab(id, title, content);
        }
        this.id = id;
        this.title = title;
        this.content = content;
        return this;
      }
    });

    return $.ty.ty_tab;
  });
})();
define('commons/public/jadec/ui_components/modal',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var printHTML_mixin = function(obj, tag, className){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( obj)
{
if ( obj instanceof jQuery)
{
if ( tag)
{
buf.push("<" + (tag) + (jade.attrs({ "class": (className) }, {"class":true})) + ">" + (((jade.interp = obj[0].outerHTML) == null ? '' : jade.interp)) + "</" + (tag) + ">");
}
else
{
buf.push("" + (((jade.interp = obj[0].outerHTML) == null ? '' : jade.interp)) + "");
}
}
else
{
if ( tag)
{
buf.push("<" + (tag) + (jade.attrs({ "class": (className) }, {"class":true})) + ">" + (((jade.interp = obj) == null ? '' : jade.interp)) + "</" + (tag) + ">");
}
else
{
buf.push("" + (((jade.interp = obj) == null ? '' : jade.interp)) + "");
}
}
}
};
buf.push("<div class=\"trustyou-ui card\"><div class=\"card-header\"><ul class=\"actions\"><li><a class=\"close-modal\"><i class=\"ty-icon ty-icon-remove\"></i></a></li></ul>");
if ( titleWrapper)
{
printHTML_mixin(title, titleWrapper, '');
}
else
{
printHTML_mixin(title);
}
buf.push("</div>");
printHTML_mixin(body, 'div', 'card-body');
printHTML_mixin(footer, 'div', 'card-footer');
buf.push("</div>");
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 *		$div_element.modal({ title: title, content: content })
 *
 * Close modal event:
 *
 * 		$div_element.on('modalclose', function (e) {});
 *
 * Close modal programatically:
 *
 * 		$div_element.modal('close')
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/modal',['jquery', 'widget', 'modal-template', 'fancybox'], function ($, widget, modalTemplate, fancybox) {
    $.widget('ty.modal', widget, {
      options: {
        title: '', // title of the modal
        content: '', // content of the modal
        footer: '', // footer content, optional
        onBeforeRender: $.noop, // fired before rendering
        onComplete: $.noop, // fired when content is rendered
        onClosed: $.noop, // fired when fancybox is closed,
        modalClass: '', // optional classes for modal wrapper
        titleWrapper: 'h2'
      },

      _create: $.noop,

      _init: function () {
        var $element = this.element,
            options = this.options;

        $element.empty().append(modalTemplate({
          title: options.title,
          body: options.content,
          footer: options.footer,
          modalClass: options.modalClass,
          titleWrapper: options.titleWrapper
        }));

        options.onBeforeRender($element);

        $.fancybox({
          openMethod: 'dropIn',
          openSpeed: 250,

          closeMethod: 'dropOut',
          closeSpeed: 150,

          content: $element,
          padding: 0,
          width: 'auto',
          overlayColor: '#000',
          showCloseButton: false,
          onComplete: options.onComplete,
          onClosed: options.onClosed
        });

        $('#fancybox-wrap, #fancybox-content').addClass('trustyou-ui modal');
        if (options.modalClass) {
          $('#fancybox-wrap').addClass(options.modalClass);
        }

        this._bindEvents();
      },

      _bindEvents: function () {
        this.element.on('click', '.close-modal', function () {
          $.fancybox.close();
        });
      },

      update: function () {
        $('#fancybox-wrap, #fancybox-outer, #fancybox-content').css('width', 'auto');
        $.fancybox.center();
      },

      // Close event
      close: function () {
        $.fancybox.close();
        this._trigger('close', null, null);
      }

    });

    return $.ty.modal;
  });
})();
define('commons/public/jadec/ui_components/dialog',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card\"><div class=\"card-body\"><a class=\"dialog-close\"><i class=\"ty-icon ty-icon-remove\"></i></a><h1" + (jade.attrs({ "class": ('l-align-center') + ' ' + ("" + (titleClass) + "") }, {"class":true})) + ">" + (((jade.interp = title) == null ? '' : jade.interp)) + "</h1><p class=\"l-align-center\">" + (((jade.interp = message) == null ? '' : jade.interp)) + "</p>");
if ( messageConfirmation !== '')
{
buf.push("<p class=\"l-align-center\">" + (((jade.interp = messageConfirmation) == null ? '' : jade.interp)) + "</p>");
}
buf.push("<div class=\"dialog-actions l-align-center\">");
// iterate actions
;(function(){
  var $$obj = actions;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var action = $$obj[$index];

buf.push("<a" + (jade.attrs({ 'name':(action.name), 'href':(action.href), 'target':(action.linkTarget), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + (action.positive ? "btn-positive": (action.negative ? "btn-negative": (action.neutral ? "btn-neutral": ""))) }, {"class":true,"name":true,"href":true,"target":true})) + ">" + (jade.escape((jade.interp = action.label) == null ? '' : jade.interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var action = $$obj[$index];

buf.push("<a" + (jade.attrs({ 'name':(action.name), 'href':(action.href), 'target':(action.linkTarget), "class": ('trustyou-ui') + ' ' + ('btn') + ' ' + (action.positive ? "btn-positive": (action.negative ? "btn-negative": (action.neutral ? "btn-neutral": ""))) }, {"class":true,"name":true,"href":true,"target":true})) + ">" + (jade.escape((jade.interp = action.label) == null ? '' : jade.interp)) + "</a>");
      }

    }

  }
}).call(this);

buf.push("</div>");
if ( altActions && altActions.length > 0)
{
buf.push("<div class=\"dialog-actions-alt l-align-center\">");
// iterate altActions
;(function(){
  var $$obj = altActions;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var action = $$obj[$index];

buf.push("<a" + (jade.attrs({ 'href':(action.href), 'target':(action.linkTarget) }, {"href":true,"target":true})) + ">" + (jade.escape((jade.interp = action.label) == null ? '' : jade.interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var action = $$obj[$index];

buf.push("<a" + (jade.attrs({ 'href':(action.href), 'target':(action.linkTarget) }, {"href":true,"target":true})) + ">" + (jade.escape((jade.interp = action.label) == null ? '' : jade.interp)) + "</a>");
      }

    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div></div>");
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 *		$div_element.dialog({
 *			title: title,
 *			message: message,
 *			messageConfirmation: messageConfirmation,
 *			actions: [
 *				{name: 'cancel', label: 'Cancel'},
 *				{name: 'delete', label: 'Delete', negative: true}
 * 			],
 * 			delete: function(){},
 * 			cancel: function(){},
 *		});
 *
 * Close dialog programatically:
 *
 * 		$div_element.dialog('close')
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/dialog',['jquery', 'widget', 'dialog-template', 'fancybox'], function ($, widget, dialogTemplate, fancybox) {
    $.widget('ty.dialog', widget, {
      options: {
        /*
         * @param {String} title title text of the dialog
         */
        title: '',
        /*
         * @param {String} titleClass CSS class(es) applied to the title element
         */
        titleClass: '',
        /*
         * @param {String} message message text displayed under the title
         */
        message: '',
        /*
         * @param {String} messageConfirmation confirmation message text (usually question) displayed under the main message
         */
        messageConfirmation: '',
        /*
         * @param {Object[]} actions buttons to display in dialog
         * Array of objects
         * {
         *		name: 'event_name',
         *		label: 'Displayed name',
         *		positive: false/true/null,
         *		negative: false/true/null,
         *		href: 'http://trustyou.com',
         *		linkTarget: '_blank'
         * }
         * JqueryUI event will be triggered with the name of the action
         * which can be handled with an option with the same name
         * as illustrated at the top
         */
        actions: [],
        /*
         * @param {Object[]} alt actions to display in dialog
         * Array of objects
         * {
         *		label: 'Displayed name',
         *		href: 'http://trustyou.com',
         *		linkTarget: '_blank'
         * }
         */
        altActions: [],
        /*
         * @param {Object} fancyboxOptions extra options for fancybox
         */
        fancyboxOptions: {},
        /*
         * @param {String} extra class to add on wrapper
         */
        dialogClass: ''
      },

      _init: function () {
        var $element = this.element,
            options = this.options;

        $element.empty().append(dialogTemplate({
          title: options.title,
          titleClass: options.titleClass,
          message: options.message,
          messageConfirmation: options.messageConfirmation,
          actions: options.actions,
          altActions: options.altActions,
          dialogClass: options.dialogClass
        }));

        var fancyboxOptions = {
          openMethod: 'dropIn',
          openSpeed: 250,

          closeMethod: 'dropOut',
          closeSpeed: 150,

          autoScale: true,
          width: 'auto',
          height: 'auto',
          padding: 0,
          margin: 0,
          overlayColor: '#000',
          showCloseButton: false,
          centerOnScroll: true,

          content: $element,
          onClosed: function () {
            $('#fancybox-wrap').removeClass('trustyou-ui dialog');
            $('#fancybox-overlay').removeClass('dialog-overlay');
            if ($('html').hasClass('fancybox-lock')) {
              $('html').removeClass('fancybox-lock');
            }
            if (options.dialogClass) {
              $('#fancybox-wrap').removeClass(options.dialogClass);
            }
          }
        };
        $.fancybox($.extend(fancyboxOptions, options.fancyboxOptions));

        $('#fancybox-wrap').addClass('trustyou-ui dialog');
        $('#fancybox-overlay').addClass('dialog-overlay');
        if (fancyboxOptions.modal) {
          $('html').addClass('fancybox-lock');
        }
        if (options.dialogClass) {
          $('#fancybox-wrap').addClass(options.dialogClass);
        }

        this._bindEvents();
        this.update();
      },

      _bindEvents: function () {
        var self = this,
            $element = this.element,
            options = this.options;

        var buttonAction = function (action) {
          var selector = 'a[name="' + action.name + '"]';
          self.element.on('click', selector, function (e) {
            self._trigger(action.name, e, action);
          });
        };

        if (this.options.actions && this.options.actions.length !== 0) {
          for (var i = 0; i < this.options.actions.length; i++) {
            buttonAction(options.actions[i]);
          }
        }

        $element.on('click', '.dialog-close', function () {
          self.close();
        });
      },

      update: function () {
        $('#fancybox-wrap, #fancybox-outer, #fancybox-content').css('width', 'auto');
        $.fancybox.center();
      },

      // Close event
      close: function () {
        $.fancybox.close();
        this._trigger('close', null, null);
      }
    });

    return $.ty.dialog;
  });
})();
define('commons/public/jadec/ui_components/table',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui spinner-wrapper\"><div class=\"trustyou-ui spinner\"></div></div><table" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('table') + ' ' + ((bordered ? "table-bordered " : " ") + ((selectable === "all"||selectable === "parents") ? "table-selectable " : " ") + (striped ? "table-striped " : " ")) }, {"class":true})) + "></table>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/table-content',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var one_level_table_mixin = function(rows, labels, selectable, level, visible, parentSiblingAfter, numColumns){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
if ( rows.length === 0)
{
var colspanValue = (selectable === "parents" || selectable === "all") ? numColumns+1 : numColumns
buf.push("<tr class=\"is-disabled\"><td" + (jade.attrs({ 'data-value':("no_data"), 'colspan':(colspanValue) }, {"data-value":true,"colspan":true})) + "><div class=\"trustyou-ui placeholder-box\"><div class=\"placeholder-box-icon\"><i class=\"ty-icon ty-icon-database-search\"></i></div><div class=\"placeholder-box-title\">" + (((jade.interp = labels.no_table_rows) == null ? '' : jade.interp)) + "</div></div></td></tr>");
}
// iterate rows
;(function(){
  var $$obj = rows;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var row = $$obj[i];

var levelClass = ((row.selected)?"is-selected":"")+" lvl-"+level
var levelClassExtra = (parentSiblingAfter)?("lvl-"+level +"-"+(level-1)):""
var isLastClass = (i === rows.length - 1)?"is-last":""
var dataRow = (row.data_attr_value) ? row.data_attr_value : ""
var additionalClass = (row.additionalClass) ? row.additionalClass : ""
var childrenCount = (row.children_count) ? row.children_count : ""
buf.push("<tr" + (jade.attrs({ 'data-row':(dataRow), 'data-depth':(level), 'data-id':(row.id), 'data-expanded':((row.expanded)?1:0), 'style':((visible===false)?"display:none":""), "class": (levelClass + " " +levelClassExtra + " " + isLastClass + " " + additionalClass) }, {"data-row":true,"data-depth":true,"data-id":true,"data-expanded":true,"class":true,"style":true})) + ">");
if ( selectable === 'all' || selectable === "parents")
{
buf.push("<td>");
if (!( (selectable === "parents" && level > 0) || row.actions_disabled))
{
if ( row.selected)
{
buf.push("<input type=\"checkbox\" checked=\"checked\"/>");
}
else
{
buf.push("<input type=\"checkbox\"/>");
}
}
if ( row.actions_disabled)
{
buf.push("<input type=\"checkbox\" disabled=\"disabled\"/>");
}
buf.push("</td>");
}
// iterate row.values
;(function(){
  var $$obj = row.values;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var column = $$obj[i];

var colspanValue = (i === row.values.length - 1 && i < numColumns - 1) ? numColumns-i : 1
var alignClass = (column.align) ? 'l-align-' + column.align : ''
alignClass = (column.additionalClass) ? alignClass + ' ' + column.additionalClass : alignClass
if ( i === 0)
{
alignClass = alignClass + ' l-align-left'
if ( (row.children && row.children.length > 0 || childrenCount))
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + "><a class=\"toggle-expand\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("ty-icon-caret-"+(row.expanded?"down":"right")) }, {"class":true})) + "></i></a><span>" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</span></td>");
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"colspan":true,"class":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var column = $$obj[i];

var colspanValue = (i === row.values.length - 1 && i < numColumns - 1) ? numColumns-i : 1
var alignClass = (column.align) ? 'l-align-' + column.align : ''
alignClass = (column.additionalClass) ? alignClass + ' ' + column.additionalClass : alignClass
if ( i === 0)
{
alignClass = alignClass + ' l-align-left'
if ( (row.children && row.children.length > 0 || childrenCount))
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + "><a class=\"toggle-expand\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("ty-icon-caret-"+(row.expanded?"down":"right")) }, {"class":true})) + "></i></a><span>" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</span></td>");
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"colspan":true,"class":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
      }

    }

  }
}).call(this);

buf.push("</tr>");
if ( row.children && row.children.length > 0)
{
if ( i < rows.length - 1)
{
one_level_table_mixin(row.children, labels, selectable, level+1, row.expanded && visible, true, numColumns);
}
else
{
one_level_table_mixin(row.children, labels, selectable, level+1, row.expanded && visible, false, numColumns);
}
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var row = $$obj[i];

var levelClass = ((row.selected)?"is-selected":"")+" lvl-"+level
var levelClassExtra = (parentSiblingAfter)?("lvl-"+level +"-"+(level-1)):""
var isLastClass = (i === rows.length - 1)?"is-last":""
var dataRow = (row.data_attr_value) ? row.data_attr_value : ""
var additionalClass = (row.additionalClass) ? row.additionalClass : ""
var childrenCount = (row.children_count) ? row.children_count : ""
buf.push("<tr" + (jade.attrs({ 'data-row':(dataRow), 'data-depth':(level), 'data-id':(row.id), 'data-expanded':((row.expanded)?1:0), 'style':((visible===false)?"display:none":""), "class": (levelClass + " " +levelClassExtra + " " + isLastClass + " " + additionalClass) }, {"data-row":true,"data-depth":true,"data-id":true,"data-expanded":true,"class":true,"style":true})) + ">");
if ( selectable === 'all' || selectable === "parents")
{
buf.push("<td>");
if (!( (selectable === "parents" && level > 0) || row.actions_disabled))
{
if ( row.selected)
{
buf.push("<input type=\"checkbox\" checked=\"checked\"/>");
}
else
{
buf.push("<input type=\"checkbox\"/>");
}
}
if ( row.actions_disabled)
{
buf.push("<input type=\"checkbox\" disabled=\"disabled\"/>");
}
buf.push("</td>");
}
// iterate row.values
;(function(){
  var $$obj = row.values;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var column = $$obj[i];

var colspanValue = (i === row.values.length - 1 && i < numColumns - 1) ? numColumns-i : 1
var alignClass = (column.align) ? 'l-align-' + column.align : ''
alignClass = (column.additionalClass) ? alignClass + ' ' + column.additionalClass : alignClass
if ( i === 0)
{
alignClass = alignClass + ' l-align-left'
if ( (row.children && row.children.length > 0 || childrenCount))
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + "><a class=\"toggle-expand\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("ty-icon-caret-"+(row.expanded?"down":"right")) }, {"class":true})) + "></i></a><span>" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</span></td>");
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"colspan":true,"class":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var column = $$obj[i];

var colspanValue = (i === row.values.length - 1 && i < numColumns - 1) ? numColumns-i : 1
var alignClass = (column.align) ? 'l-align-' + column.align : ''
alignClass = (column.additionalClass) ? alignClass + ' ' + column.additionalClass : alignClass
if ( i === 0)
{
alignClass = alignClass + ' l-align-left'
if ( (row.children && row.children.length > 0 || childrenCount))
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + "><a class=\"toggle-expand\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("ty-icon-caret-"+(row.expanded?"down":"right")) }, {"class":true})) + "></i></a><span>" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</span></td>");
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"class":true,"colspan":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
}
else
{
buf.push("<td" + (jade.attrs({ 'data-value':(column.value), 'colspan':(colspanValue), "class": (alignClass) }, {"data-value":true,"colspan":true,"class":true})) + ">" + (((jade.interp = column.displayedValue) == null ? '' : jade.interp)) + "</td>");
}
      }

    }

  }
}).call(this);

buf.push("</tr>");
if ( row.children && row.children.length > 0)
{
if ( i < rows.length - 1)
{
one_level_table_mixin(row.children, labels, selectable, level+1, row.expanded && visible, true, numColumns);
}
else
{
one_level_table_mixin(row.children, labels, selectable, level+1, row.expanded && visible, false, numColumns);
}
}
      }

    }

  }
}).call(this);

};
buf.push("<thead>");
if ( header.length > 0)
{
var dataRow = (header.data_attr_value) ? header.data_attr_value : ""
buf.push("<tr" + (jade.attrs({ 'data-row':(dataRow) }, {"data-row":true})) + ">");
if ( selectable === 'all' || selectable === "parents")
{
buf.push("<th>");
if ( show_select_all)
{
buf.push("<input type=\"checkbox\"/>");
}
buf.push("</th>");
}
// iterate header
;(function(){
  var $$obj = header;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var header_col = $$obj[i];

var additionalClass = (header_col.align) ? 'l-align-' + header_col.align : ''
if ( i === 0)
{
additionalClass = "l-align-left"
}
if ( sorting_column && sorting_column.column !== null && sorting_column.column === header_col.value)
{
additionalClass = additionalClass + " " + sorting_column.order
}
additionalClass = (enable_sorting && $.inArray(header_col.value, exclude_from_sorting) == -1) ? additionalClass + ' is-sortable' : additionalClass
additionalClass = (header_col.additionalClass) ? additionalClass + ' ' + header_col.additionalClass : additionalClass
if ( enable_tooltips && header_col.tooltip)
{
additionalClass = additionalClass + ' has-tooltip'
buf.push("<th" + (jade.attrs({ 'data-value':(header_col.value), 'title':(header_col.tooltip), 'data-tooltip':("top"), 'colspan':((header_col.colspan? header_col.colspan: false)), "class": (additionalClass) }, {"data-value":true,"class":true,"title":true,"data-tooltip":true,"colspan":true})) + "><div class=\"th-title\">" + (((jade.interp = header_col.displayedValue) == null ? '' : jade.interp)) + "</div>");
if ( enable_sorting && sorting_column && $.inArray(header_col.value, exclude_from_sorting) == -1)
{
buf.push("<a class=\"sort-by\">");
if ( sorting_column.order === 'desc')
{
buf.push("<i class=\"ty-icon ty-icon-caret-down\"></i>");
}
else
{
buf.push("<i class=\"ty-icon ty-icon-caret-up\"></i>");
}
buf.push("</a>");
}
buf.push("</th>");
}
else
{
buf.push("<th" + (jade.attrs({ 'data-value':(header_col.value), 'colspan':((header_col.colspan? header_col.colspan: false)), "class": (additionalClass) }, {"data-value":true,"class":true,"colspan":true})) + "><div class=\"th-title\">" + (((jade.interp = header_col.displayedValue) == null ? '' : jade.interp)) + "</div>");
if ( enable_sorting && sorting_column && $.inArray(header_col.value, exclude_from_sorting) == -1)
{
buf.push("<a class=\"sort-by\">");
if ( sorting_column.order === 'desc')
{
buf.push("<i class=\"ty-icon ty-icon-caret-down\"></i>");
}
else
{
buf.push("<i class=\"ty-icon ty-icon-caret-up\"></i>");
}
buf.push("</a>");
}
buf.push("</th>");
}
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var header_col = $$obj[i];

var additionalClass = (header_col.align) ? 'l-align-' + header_col.align : ''
if ( i === 0)
{
additionalClass = "l-align-left"
}
if ( sorting_column && sorting_column.column !== null && sorting_column.column === header_col.value)
{
additionalClass = additionalClass + " " + sorting_column.order
}
additionalClass = (enable_sorting && $.inArray(header_col.value, exclude_from_sorting) == -1) ? additionalClass + ' is-sortable' : additionalClass
additionalClass = (header_col.additionalClass) ? additionalClass + ' ' + header_col.additionalClass : additionalClass
if ( enable_tooltips && header_col.tooltip)
{
additionalClass = additionalClass + ' has-tooltip'
buf.push("<th" + (jade.attrs({ 'data-value':(header_col.value), 'title':(header_col.tooltip), 'data-tooltip':("top"), 'colspan':((header_col.colspan? header_col.colspan: false)), "class": (additionalClass) }, {"data-value":true,"class":true,"title":true,"data-tooltip":true,"colspan":true})) + "><div class=\"th-title\">" + (((jade.interp = header_col.displayedValue) == null ? '' : jade.interp)) + "</div>");
if ( enable_sorting && sorting_column && $.inArray(header_col.value, exclude_from_sorting) == -1)
{
buf.push("<a class=\"sort-by\">");
if ( sorting_column.order === 'desc')
{
buf.push("<i class=\"ty-icon ty-icon-caret-down\"></i>");
}
else
{
buf.push("<i class=\"ty-icon ty-icon-caret-up\"></i>");
}
buf.push("</a>");
}
buf.push("</th>");
}
else
{
buf.push("<th" + (jade.attrs({ 'data-value':(header_col.value), 'colspan':((header_col.colspan? header_col.colspan: false)), "class": (additionalClass) }, {"data-value":true,"class":true,"colspan":true})) + "><div class=\"th-title\">" + (((jade.interp = header_col.displayedValue) == null ? '' : jade.interp)) + "</div>");
if ( enable_sorting && sorting_column && $.inArray(header_col.value, exclude_from_sorting) == -1)
{
buf.push("<a class=\"sort-by\">");
if ( sorting_column.order === 'desc')
{
buf.push("<i class=\"ty-icon ty-icon-caret-down\"></i>");
}
else
{
buf.push("<i class=\"ty-icon ty-icon-caret-up\"></i>");
}
buf.push("</a>");
}
buf.push("</th>");
}
      }

    }

  }
}).call(this);

buf.push("</tr>");
}
buf.push("</thead><tbody>");
one_level_table_mixin(rows, labels, selectable, 0, true, false, header.length);
buf.push("</tbody><tfoot>");
if ( footer.length > 0)
{
// iterate footer
;(function(){
  var $$obj = footer;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var footer_row = $$obj[i];

var dataRow = (footer_row.data_attr_value) ? footer_row.data_attr_value : ""
buf.push("<tr" + (jade.attrs({ 'data-row':(dataRow), 'data-id':(footer_row.id) }, {"data-row":true,"data-id":true})) + ">");
if ( (selectable === 'all' || selectable === "parents") && footer_row.values.length > 0)
{
buf.push("<td></td>");
}
// iterate footer_row.values
;(function(){
  var $$obj = footer_row.values;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var footer_col = $$obj[i];

var alignClass = (footer_col.align) ? 'l-align-' + footer_col.align : ''
if ( i === 0)
{
alignClass = "l-align-left"
}
alignClass = (footer_col.additionalClass) ? alignClass + ' ' + footer_col.additionalClass : alignClass
buf.push("<td" + (jade.attrs({ 'data-value':(footer_col.value), "class": (alignClass) }, {"data-value":true,"class":true})) + ">" + (((jade.interp = footer_col.displayedValue) == null ? '' : jade.interp)) + "</td>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var footer_col = $$obj[i];

var alignClass = (footer_col.align) ? 'l-align-' + footer_col.align : ''
if ( i === 0)
{
alignClass = "l-align-left"
}
alignClass = (footer_col.additionalClass) ? alignClass + ' ' + footer_col.additionalClass : alignClass
buf.push("<td" + (jade.attrs({ 'data-value':(footer_col.value), "class": (alignClass) }, {"data-value":true,"class":true})) + ">" + (((jade.interp = footer_col.displayedValue) == null ? '' : jade.interp)) + "</td>");
      }

    }

  }
}).call(this);

buf.push("</tr>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var footer_row = $$obj[i];

var dataRow = (footer_row.data_attr_value) ? footer_row.data_attr_value : ""
buf.push("<tr" + (jade.attrs({ 'data-row':(dataRow), 'data-id':(footer_row.id) }, {"data-row":true,"data-id":true})) + ">");
if ( (selectable === 'all' || selectable === "parents") && footer_row.values.length > 0)
{
buf.push("<td></td>");
}
// iterate footer_row.values
;(function(){
  var $$obj = footer_row.values;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var footer_col = $$obj[i];

var alignClass = (footer_col.align) ? 'l-align-' + footer_col.align : ''
if ( i === 0)
{
alignClass = "l-align-left"
}
alignClass = (footer_col.additionalClass) ? alignClass + ' ' + footer_col.additionalClass : alignClass
buf.push("<td" + (jade.attrs({ 'data-value':(footer_col.value), "class": (alignClass) }, {"data-value":true,"class":true})) + ">" + (((jade.interp = footer_col.displayedValue) == null ? '' : jade.interp)) + "</td>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(i)){      var footer_col = $$obj[i];

var alignClass = (footer_col.align) ? 'l-align-' + footer_col.align : ''
if ( i === 0)
{
alignClass = "l-align-left"
}
alignClass = (footer_col.additionalClass) ? alignClass + ' ' + footer_col.additionalClass : alignClass
buf.push("<td" + (jade.attrs({ 'data-value':(footer_col.value), "class": (alignClass) }, {"data-value":true,"class":true})) + ">" + (((jade.interp = footer_col.displayedValue) == null ? '' : jade.interp)) + "</td>");
      }

    }

  }
}).call(this);

buf.push("</tr>");
      }

    }

  }
}).call(this);

}
buf.push("</tfoot>");
}
return buf.join("");
};

});

/*
 * How to use it, check documentation below for param details:
 *
 * $div_element.table({
 * 		striped: striped,
 * 		bordered: bordered,
 * 		selectable: selectable,
 * 		header: header,
 * 		rows: rows,
 * 		footer: footer
 * })
 *
 * Select/check event:
 * $div_element.on('tableselect', function (e, data) {
 *		data will contain an object like {id: row_id, state: selected_or_not}
 * });
 *
 * Select programatically:
 * $div_element.table('select', rowId, true/false)
 * $div_element.table('selectAll', true/false)
 *
 * Expand event:
 * $div_element.on('tableexpand', function (e, data) {
 *		data will contain an object like {id: row_id, state: expanded_or_not}
 * });
 *
 * Expand programatically:
 * $div_element.table('expand', row_id, true/false)
 * $div_element.table('expandAll', true/false)
 *
 * Get current row values:
 * $div_element.table('getRows')
 * -> returns exactly the same structure as the parameter 'rows'
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/table',['jquery', 'widget', 'table-template', 'table-content', 'ty-i18n!tyra-5'], function ($, widget, tableTemplate, tableContentTemplate, i18n) {
    var NO_VALUE = -1;
    $.widget('ty.table', widget, {
      options: {
        // related to styles
        striped: true,
        bordered: false,
        enable_sorting: false,
        enable_show_all: false,
        exclude_from_sorting: [],
        multiple_footer: false,

        show_all_after: NO_VALUE,
        // Object with name and order, ie {column:'score', order: 'desc'}
        sorting_column: undefined,

        // it can be 'all', in which case it will accept select more than one
        // row (parents and children), 'parents', in which only parents are
        // selectable or 'none', in which no selection will be possible
        selectable: 'parents',

        // enabling the tooltips in the header
        enable_tooltips: false,

        // enable checkbox to select all rows
        select_all_checkbox: false,

        /*
         * Header should be an array of columns:
         *	[
         * 		{value:value, displayedValue: displayedValue},
         * 		{value:value, displayedValue: displayedValue},
         * 		...
         *	]
         * To make it easier, the class Cell (check doc at the bottom) can be used.
         * Example:
         *	[
         *		new $.ty.table.Cell('value1', 'displayedValue1'),
         *		new $.ty.table.Cell('value2', 'displayedValue2'),
         *		new $.ty.table.Cell('value3', 'displayedValue3')
         *	],
         */
        header: [],

        /*
         * rows should be an array of rows:
         * 	[
         * 		{
         * 			id:id,
         * 			selected:selected,
         * 			expanded:expanded,
         * 			values:[
         * 				{value:value, displayedValue: displayedValue}
         * 			],
         * 			children[]
         * 		},
         * 		...
         * 	]
         * To make it easier, the classes Row and Cell (check doc at the bottom) can
         * be used. Example:
         *
         * [
         *		new $.ty.table.Row(identifier, selected_bool, expanded_bool, [
         *				new $.ty.table.Cell('value1', 'displayedValue1'),
         *				new $.ty.table.Cell('value2', 'displayedValue2'),
         *				new $.ty.table.Cell('value3', 'displayedValue3')
         *			],
         *			[
         *				new $.ty.table.Row(identifier, selected_bool, expanded_bool, [
         *					new $.ty.table.Cell('value1', 'displayedValue1'),
         *					new $.ty.table.Cell('value2', 'displayedValue2'),
         *					new $.ty.table.Cell('value3', 'displayedValue3')
         *					],
         *					[]
         *				),
         *				new $.ty.table.Row(identifier, selected_bool, expanded_bool, [
         *					new $.ty.table.Cell('value1', 'displayedValue1'),
         *					new $.ty.table.Cell('value2', 'displayedValue2'),
         *					new $.ty.table.Cell('value3', 'displayedValue3')
         *					],
         *					[]
         *				)
         *			]
         *		)
         *]
         */
        rows: [],

        /*
         * Footer should be an array of values:
         * [
         * 		{value:value, displayedValue: displayedValue},
         * 		{value:value, displayedValue: displayedValue},
         * 		...
         * ]
         * To make it easier, the class Cell can be used. Example:
         *	[
         *		new $.ty.table.Cell('footer1', 'Footer 1'),
         *		new $.ty.table.Cell('footer2', 'Footer 2'),
         *		new $.ty.table.Cell('footer3', 'Footer 3')
         *	],
         * or if it's a multiple footer then it will be the same as rows (with no children)
         */
        footer: []
      },

      _create: function () {
        var self = this,
            $element = self.element,
            options = self.options;
        $element.empty().addClass('trustyou-ui table-wrapper').append(tableTemplate({
          striped: options.striped,
          bordered: options.bordered,
          selectable: options.selectable
        }));

        self._bindEventHandlers();
      },

      _init: function () {
        var self = this,
            $element = self.element,
            options = self.options;
        $element.find('.table').empty().append(tableContentTemplate({
          header: options.header,
          rows: options.rows,
          footer: options.multiple_footer ? options.footer : [$.ty.table.Row('footer', false, false, options.footer)],
          selectable: options.selectable,
          labels: i18n,
          enable_sorting: options.enable_sorting,
          sorting_column: options.sorting_column,
          exclude_from_sorting: options.exclude_from_sorting,
          enable_tooltips: options.enable_tooltips,
          show_select_all: options.select_all_checkbox
        }));

        if (options.enable_show_all) {
          if (options.show_all_after === NO_VALUE) {
            throw new Error('enable_show_all requires show_all_after to be set');
          }

          self._hideAndBindShowAll(options.show_all_after);
        }

        if (options.enable_tooltips) {
          self._bindTooltips();
        }

        if (options.rows.length === 1 && options.selectable && options.selectable !== 'none') {
          self.expand(options.rows[0].id, true);
        }
      },

      _hideAndBindShowAll: function (hidingIndex) {
        if (hidingIndex > 0) {
          var self = this,
              $element = self.element;

          var hideRows = function ($elem, hideIndex) {
            var lastHiddenRow = NO_VALUE;
            $elem.find('.table tbody tr').each(function (i, r) {
              if (i >= hideIndex) {
                $(r).hide();
                lastHiddenRow = i;
              }
            });
            return lastHiddenRow;
          };

          var showRows = function ($elem) {
            $elem.find('.table tbody tr:hidden').each(function (i, r) {
              $(r).show();
            });
          };

          var lastHiddenRow = hideRows($element, hidingIndex);

          if (lastHiddenRow !== NO_VALUE) {
            var showAllRowsLabel = i18n.common_show_more_rows.replace('{rows}', (lastHiddenRow - hidingIndex).toString());
            var hideAllRowsLabel = i18n.common_show_less_rows;
            var showAllRowsButton = $element.after('<button class=\'trustyou-ui btn table-row-button show-all-rows\'>' + showAllRowsLabel + '</button>');
            showAllRowsButton.after('<button class=\'trustyou-ui btn table-row-button show-less-rows\'>' + hideAllRowsLabel + '</button>');
            $element.siblings('.show-less-rows').hide();

            $element.siblings('.show-all-rows').on('click', function (elem) {
              showRows($element);

              $(elem.target).hide();
              $element.siblings('.show-less-rows').show();
            });

            $element.siblings('.show-less-rows').on('click', function (elem) {
              hideRows($element, hidingIndex);

              $(elem.target).hide();
              $element.siblings('.show-all-rows').show();
            });
          }
        }
      },

      _bindTooltips: function () {
        var self = this,
            $element = self.element;

        $element.find('th.has-tooltip[data-tooltip]').each(function () {
          var align = $(this).attr('data-tooltip');
          var offset = void 0,
              hoverHand = false;

          switch (align) {
            case 'left':
              {
                offset = [-1, 0];
                break;
              }
            case 'top':
              {
                offset = [0, -1];
                break;
              }
            case 'bottom':
              {
                offset = [0, 1];
                break;
              }
            default:
              {
                offset = [1, 0];
              }
          }

          if (!$(this).hasClass('tooltip-init')) {
            $(this).tooltipsy({
              offset: offset,
              className: 'trustyou-ui tooltip l-' + align,
              show: function (e, $el) {
                $el.hover(function () {
                  hoverHand = true;
                }, function () {
                  hoverHand = false;
                });
                $el.fadeIn(100);
              },
              hide: function (e, $el) {
                var tooltipCloserInterval = setInterval(function () {
                  if (hoverHand === false) {
                    $el.fadeOut(100);
                    $el.off('mouseenter mouseleave');
                    clearInterval(tooltipCloserInterval);
                  }
                }, 500);
              }
            });
          }
          $(this).addClass('tooltip-init');
        });
      },

      _bindEventHandlers: function () {
        var self = this;

        // expand-collapse toggle
        this._on(['click', 'tbody td a.toggle-expand', this._callWhenEnabled(function () {
          var $icon = $(this).find('.ty-icon'),
              $rowParent = $(this).closest('tr'),
              parentId = $rowParent.data('id').toString();
          var showChildren = void 0;
          if ($icon.hasClass('ty-icon-caret-right')) {
            showChildren = true;
            $icon.removeClass('ty-icon-caret-right').addClass('ty-icon-caret-down');
          } else if ($icon.hasClass('ty-icon-caret-down')) {
            showChildren = false;
            $icon.removeClass('ty-icon-caret-down').addClass('ty-icon-caret-right');
          }

          self._updateVisibility.call(self, $rowParent, showChildren);
          self._updateData.call(self, parentId, 'expanded', showChildren);
          self.expanded.call(self, parentId, showChildren);
        })]);

        // checkbox change
        this._on(['change', 'tbody input[type="checkbox"]', this._callWhenEnabled(function () {
          var rowElement = $(this).closest('tr'),
              rowId = $(rowElement).data('id').toString();
          if ($(this).prop('checked')) {
            $(rowElement).addClass('is-selected');
          } else {
            $(rowElement).removeClass('is-selected');
          }
          self._updateData.call(self, rowId, 'selected', $(this).prop('checked'));
          self.selected.call(self, rowId, $(this).prop('checked'));
        })]);

        this._on(['change', 'thead input[type="checkbox"]', this._callWhenEnabled(function () {
          self.selectAll($(this).prop('checked'));
        })]);

        // sort event
        this._on(['click', 'th.is-sortable', this._callWhenEnabled(function () {
          var headers = $(this).siblings(),
              column = $(this).data('value');
          var sort = void 0;

          headers.removeClass('asc desc');

          if ($(this).hasClass('asc')) {
            $(this).removeClass('asc').addClass('desc');
            $(this).find('.ty-icon').removeClass('ty-icon-caret-up').addClass('ty-icon-caret-down');
            sort = 'desc';
          } else if ($(this).hasClass('desc')) {
            $(this).removeClass('desc').addClass('asc');
            $(this).find('.ty-icon').removeClass('ty-icon-caret-down').addClass('ty-icon-caret-up');
            sort = 'asc';
          } else {
            $(this).addClass('desc');
            sort = 'desc';
          }

          // TODO: added a sort event
          self.sorted.call(self, column, sort);
        })]);
      },

      _updateVisibility: function ($element, visibility) {
        var parentDepth = $element.data('depth'),
            visibilityMap = {};
        var $rowParentSibling = $element.next();

        visibilityMap[parentDepth] = visibility;

        // Updates data
        $element.data('expanded', visibility ? 1 : 0);

        // Used to show or hide children
        while ($rowParentSibling.length > 0 && parentDepth < $rowParentSibling.data('depth')) {
          if (visibility) {
            if (visibilityMap[$rowParentSibling.data('depth') - 1]) {
              $rowParentSibling.css('display', '');
              visibilityMap[$rowParentSibling.data('depth')] = $rowParentSibling.data('expanded') === 1;
            }
          } else {
            $rowParentSibling.hide();
          }
          $rowParentSibling = $rowParentSibling.next();
        }
      },

      _updateData: function (rowId, property, value) {
        var self = this,
            options = self.options;
        self._updateDateRecursive(options.rows, rowId, property, value);
      },

      _updateDateRecursive: function (rows, rowId, property, value) {
        var self = this;
        $.each(rows, function (i, row) {
          if (row.id === rowId) {
            row[property] = value;
          }

          if (row.children && row.children.length > 0) {
            self._updateDateRecursive(row.children, rowId, property, value);
          }
        });
      },

      // Public method to get the current state of the rows
      getRows: function () {
        return this.options.rows;
      },

      // Expand event
      expanded: function (rowId, state) {
        this._trigger('expand', null, { id: rowId, state: state });
      },

      // Select event
      selected: function (rowId, state) {
        this._trigger('select', null, { id: rowId, state: state });
      },

      // Select multiple rows event
      selectedRows: function (rows) {
        this._trigger('multipleselect', null, { rows: rows });
      },

      // Sort event
      sorted: function (column, order) {
        this._trigger('sort', null, { column: column, order: order });
      },

      select: function (rowId, state) {
        var self = this,
            options = self.options;

        if (state) {
          self.element.find('tbody tr[data-id="' + rowId + '"]').addClass('is-selected');
        } else {
          self.element.find('tbody tr[data-id="' + rowId + '"]').removeClass('is-selected');
        }

        var $elementToSelect = self.element.find('tbody tr[data-id="' + rowId + '"] td:first-child input[type=checkbox]');

        if (options.selectable !== 'none') {
          $.each($elementToSelect, function (_, el) {
            $(el).prop('checked', state);
          });

          if ($elementToSelect.length === 1) {
            self._updateData(rowId, 'selected', state);
          }
          self.selected.call(self, rowId, state);
        }
      },

      selectRows: function (rows) {
        var self = this,
            options = self.options,
            rowStates = [],
            detachedElement = $(self.element).find('table').detach();
        var $elementToSelect = void 0;
        $.each(rows, function (_, row) {
          if (row.state) {
            detachedElement.find('tbody tr[data-id=' + row.row_id + ']').addClass('is-selected');
          } else {
            detachedElement.find('tbody tr[data-id=' + row.row_id + ']').removeClass('is-selected');
          }

          $elementToSelect = detachedElement.find('tbody tr[data-id=' + row.row_id + '] td:first-child input[type=checkbox]');

          if (options.selectable !== 'none') {
            $.each($elementToSelect, function (k, el) {
              $elementToSelect.prop('checked', row.state);
            });

            if ($elementToSelect.length === 1) {
              self._updateData(row.row_id, 'selected', row.state);
            }
            rowStates.push({ id: row.row_id, state: row.state });
          }
        });

        detachedElement.appendTo($(self.element));

        self.selectedRows.call(self, rowStates);
      },

      selectAll: function (state) {
        var self = this;

        $.each(self.element.find('tbody tr:has(td:first-child input[type=checkbox])'), function (_, element) {
          self.select($(element).data('id'), state);
        });
      },

      expandRows: function (rows) {
        var self = this,
            rowStates = [];
        var $icon = void 0,
            $rowParent = void 0;

        var detachedElement = $(self.element).find('table').detach();

        $.each(rows, function (_, row) {
          $rowParent = detachedElement.find('tbody tr[data-id=' + row.row_id + ']');
          $icon = $rowParent.find('td:nth-child(2) .ty-icon');

          if ($rowParent.length === 1 && $icon.length === 1) {
            if ($icon.hasClass('ty-icon-caret-right') && row.state === true) {
              $icon.removeClass('ty-icon-caret-right').addClass('ty-icon-caret-down');
            } else if ($icon.hasClass('ty-icon-caret-down') && row.state === false) {
              $icon.removeClass('ty-icon-caret-down').addClass('ty-icon-caret-right');
            }

            self._updateVisibility.call(self, $rowParent, row.state);
            self._updateData.call(self, row.row_id, 'expanded', row.state);
            rowStates.push({ id: row.row_id, state: row.state });
          }
        });

        detachedElement.appendTo($(self.element));

        self.expandedRows.call(self, rowStates);
      },

      // Select event
      expandedRows: function (rows) {
        this._trigger('multipleexpand', null, { rows: rows });
      },

      expand: function (rowId, state) {
        var self = this,
            $rowParent = self.element.find('tbody tr[data-id=' + rowId + ']'),
            $icon = $rowParent.find('td:nth-child(2) .ty-icon');

        if ($rowParent.length === 1 && $icon.length === 1) {
          if ($icon.hasClass('ty-icon-caret-right') && state === true) {
            $icon.removeClass('ty-icon-caret-right').addClass('ty-icon-caret-down');
          } else if ($icon.hasClass('ty-icon-caret-down') && state === false) {
            $icon.removeClass('ty-icon-caret-down').addClass('ty-icon-caret-right');
          }

          self._updateVisibility.call(self, $rowParent, state);
          self._updateData.call(self, rowId, 'expanded', state);
          self.expanded.call(self, rowId, state);
        }
      },

      expandAll: function (state) {
        var self = this;

        $.each(self.element.find('tbody tr'), function (_, element) {
          if ($(element).find('td:nth-child(2) .ty-icon').length === 1) {
            self.expand($(element).data('id'), state);
          }
        });
      },

      showLoading: function (state) {
        var self = this;

        if (state) {
          self.element.addClass('is-loading');
        } else {
          self.element.removeClass('is-loading');
        }
      }

    });

    // public classes
    $.extend($.ty.table, {

      /*
       * value: the value stored for the cell, it might be used when sorting,
       * deleting rows or anything else
       * displayedValue: value that will be shown in the table
       * align: can be left, right or empty
       */
      Cell: function (value, displayedValue, align, additionalClass, tooltip, colspan) {
        if (!(this instanceof $.ty.table.Cell)) {
          return new $.ty.table.Cell(value, displayedValue, align, additionalClass, tooltip, colspan);
        }
        this.value = value;
        this.displayedValue = displayedValue;
        this.align = align;
        this.additionalClass = additionalClass;
        this.tooltip = tooltip;
        this.colspan = colspan;
        return this;
      },


      /*
       * id: identifier of the row
       * selected: whether the checkbox should be checked or not (in case the table
       * 	is selectable)
       * expanded: whether the children of these row should be expanded or not
       * values: list of values for the row columns
       * children: list of Rows that represent children of the current row.
       * 	This is recursive, children can have also children, and so on...
       */
      Row: function (id, selected, expanded, values, children, dataAttrValue, additionalClass, actionsDisabled, childrenCount) {
        if (!(this instanceof $.ty.table.Row)) {
          return new $.ty.table.Row(id, selected, expanded, values, children, dataAttrValue, additionalClass, actionsDisabled, childrenCount);
        }
        this.id = id;
        this.selected = selected;
        this.expanded = expanded;
        this.values = values;
        this.children = children;
        this.data_attr_value = dataAttrValue;
        this.additionalClass = additionalClass;
        this.actions_disabled = actionsDisabled;
        this.children_count = childrenCount;
        return this;
      }
    });

    return $.ty.table;
  });
})();
define('commons/public/jadec/ui_components/wordcloud',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<ul>");
// iterate values
;(function(){
  var $$obj = values;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var value = $$obj[$index];

buf.push("<li" + (jade.attrs({ 'data-id':(value.value), "class": ("weight-" + value.weight) }, {"class":true,"data-id":true})) + "> <div class=\"word\">" + (jade.escape((jade.interp = value.displayedValue) == null ? '' : jade.interp)) + "</div></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var value = $$obj[$index];

buf.push("<li" + (jade.attrs({ 'data-id':(value.value), "class": ("weight-" + value.weight) }, {"class":true,"data-id":true})) + "> <div class=\"word\">" + (jade.escape((jade.interp = value.displayedValue) == null ? '' : jade.interp)) + "</div></li>");
      }

    }

  }
}).call(this);

buf.push("</ul>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/ui_components/wordcloud',['jquery', 'widget', 'wordcloud-template'], function ($, widget, wordcloudTemplate) {
    $.widget('ty.wordcloud', widget, {
      options: {
        id: undefined,
        values: [],
        maxTotal: 10
      },

      _create: function () {
        var self = this,
            $element = self.element;
        $element.addClass('word-cloud');

        // item click
        this._on(['click', 'li', this._callWhenEnabled(function (e) {
          var selectedId = $(this).data('id');
          self.click(selectedId);
          e.stopPropagation();
        })]);
      },

      // It just calls _showSingleBarchart, which will render the barchart
      _init: function () {
        var widths = {};
        this._showWordCloud(widths);
      },

      // It renders the paginator
      _showWordCloud: function () {
        var $element = this.element,
            options = this.options;
        var orderedValues = this._computeWeights();
        $element.empty().append(wordcloudTemplate({
          id: options.id,
          values: orderedValues
        }));
      },

      // It calculates how big the boxes should be
      _computeWeights: function () {
        var options = this.options,
            self = this,
            orderedValues = [];
        var totalNumber = 0;

        if (options.maxTotal) {
          totalNumber = options.maxTotal;
        }

        $.each(options.values, function (_, val) {
          val.weight = Math.ceil(val.weight * 10 / totalNumber);
          self._randomSort(orderedValues, val);
        });

        return orderedValues;
      },

      _randomSort: function (array, val) {
        if (array.length === 0) {
          array.push(val);
        } else {
          // Inserting in random position
          array.splice(Math.floor(Math.random() * (array.length + 2)), 0, val);
        }
      },

      // Click event
      click: function (id) {
        this._trigger('click', null, { id: id });
      },

      // Create a public method to get or set the values
      value: function (values) {
        // No value passed, act as a getter
        if (values === undefined) {
          return this.options.values;
        }
        this.options.values = values;
        this._showWordCloud();
        return this.options.values;
      }

    });

    // public classes
    $.extend($.ty.wordcloud, {
      Element: function (value, displayedValue, weight) {
        if (!(this instanceof $.ty.wordcloud.Element)) {
          return new $.ty.wordcloud.Element(value, displayedValue, weight);
        }
        this.value = value;
        this.displayedValue = displayedValue;
        this.weight = weight;
        return this;
      }
    });

    return $.ty.wordcloud;
  });
})();
define('commons/public/jadec/ui_components/welcome-message',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"welcome-message trustyou-ui notification notification-rich is-closable\"><a data-toggle=\"notification\" class=\"close-welcome\"><i class=\"ty-icon ty-icon-remove\"></i></a><img" + (jade.attrs({ 'src':("" + (image) + "") }, {"src":true})) + "/><h3>" + (jade.escape((jade.interp = title) == null ? '' : jade.interp)) + "</h3><div class=\"welcome-content\">" + (((jade.interp = content) == null ? '' : jade.interp)) + "</div></div>");
}
return buf.join("");
};

});

/*
* This plugin is used to display welcome messages.
*	Initialization: $div_element.welcome_message({title: messageTitle,
*												 content: messageContent,
*												 image: imageUrl,
*												 close: callback })
*	@title - html or text for message title (would be wrapped in h3 tag)
*	@content - html or text of the message
*	@image - url to image file that would be displayed in the message
*	@close - function that will be called on message close
*
*/
(function () {
  'use strict';

  define('commons/public/js/ui_components/welcome-message',['jquery', 'widget', 'welcome-message-template'], function ($, widget, messageTemplate) {
    $.widget('ty.welcomeMessage', widget, {
      options: {
        title: '',
        content: '',
        image: '',
        close: function () {}
      },
      _create: function () {
        this.element.prepend(messageTemplate(this.options));
        this.element.find('.close-welcome').on('click', this.options.close);
      }
    });
  });
})();
define('commons/public/jadec/ui_components/donutchart',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"chart\"></div><div class=\"chart-score\"></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/ui_components/donutchart',['jquery', 'widget', 'donutchart-template'], function ($, widget, donutchartTemplate) {
    $.widget('ty.donutchart', widget, {
      options: {
        value: 100, // can be any value on any scale as long as it's consistent with the scale option value
        scale: 100, // the maximum value for the value option, used in calculating the remainder
        round: function () {}, // a round function for the values during animation
        thresholds: null, // threshold object used to determine colors to be shown for values
        inactiveColour: '#F0F0F0', // color used for the remainder value
        colors: {
          // arrays of two elements, the first is the colour of the original
          // value and the second is the colour of the increment
          greenColors: ['', ''],
          yellowColors: ['', ''],
          redColors: ['', '']
        },
        animate: true,
        startingAnimationTime: 100, // total animation time for the starting animation
        // interval time after every step in the animation,
        // anything below 10 is probably undoable for the computer
        animationTimePerStep: 10,
        chartOptions: { // google chart options
          chartArea: {
            width: '100%',
            height: '100%'
          },
          backgroundColor: {
            fill: 'transparent'
          },
          pieHole: 0.75,
          pieSliceTextStyle: {
            color: 'transparent'
          },
          pieSliceBorderColor: 'transparent',
          legend: 'none',
          tooltip: {
            trigger: 'none'
          },
          enableInteractivity: false
        }
      },

      // the constructor
      _create: function () {
        this.element.empty().append(donutchartTemplate({}));
        this.chartElem = this.element.find('.chart');
        this.scoreElem = this.element.find('.chart-score');
        this.data = google.visualization.arrayToDataTable([['', ''], ['', 0], ['', 0], ['', 0]]);

        var donutOptions = this._setChartOptions();

        this.chart = new google.visualization.PieChart(this.chartElem[0]);
        this.chart.draw(this.data, donutOptions);

        this.finalValue = this.options.value; // this is the value that the widget will reach after animation
        this.currentVal = 0; // this is the current value displayed by the widget
        this.currentIncrement = 0; // this is the current Increment value displayed by the widget
        this.startingAnimationComplete = false; // one-time flag for knowing whether we are conducting a starting animation
        this.animationPointer = null; // used for cancelling animations

        if (this.options.animate) {
          this.animateValue(this.finalValue, true); // set text only once on startup
        } else {
          this.setValue(this.finalValue, 0, false);
        }
      },

      // returns the colors to display for the donut parts based on the value passed
      _getColors: function (val) {
        var thresholds = this.options.thresholds;
        var colors = this.options.colors;
        if (!thresholds) {
          throw new Error('Specify color thresholds');
        }

        var cmp = function (value, thrs) {
          return thresholds.exclusive ? value > thrs : value >= thrs;
        };

        var colorHexValues = colors.yellowColors;
        if (cmp(val, thresholds.green)) {
          colorHexValues = colors.greenColors;
        } else if (cmp(val, thresholds.yellow)) {
          colorHexValues = colors.yellowColors;
        } else if (!thresholds.hasOwnProperty('red') || cmp(val, thresholds.red)) {
          // The threshold for 'red' may be missing, meaning everything that's neither 'green' nor 'yellow'
          colorHexValues = colors.redColors;
        }
        return colorHexValues;
      },

      // for updating the slice colors
      _setChartOptions: function () {
        var colorsToUse = this._getColors(this.currentVal + this.currentIncrement);
        var donutOptions = $.extend(true, {}, {
          slices: {
            0: { color: colorsToUse[0] },
            1: { color: colorsToUse[1] },
            2: { color: this.options.inactiveColour }
          }
        }, this.options.chartOptions);

        return donutOptions;
      },

      _getValueIncrement: function () {
        if (this.options.scale === 100) {
          return 1;
        } else {
          return 0.1;
        }
      },

      // javascript implementation of python's range function
      _range: function (start, stop, step) {
        if (typeof stop === 'undefined') {
          // one param defined
          stop = start;
          start = 0;
        }
        if (typeof step === 'undefined') {
          step = 1;
        }
        var result = [];
        for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
          result.push(i);
        }
        return result;
      },

      // gets the range of values the animation will go through
      _getRange: function (start, stop) {
        // we don't want the start animation to be too slow if we use the regular value increments from
        // _getValueIncrement(), so we specify a fixed time period for the start animation only and calculate
        // the step based on it
        var step = 0;
        var diff = stop - start;
        if (this.startingAnimationComplete) {
          step = this._getValueIncrement();
          step = diff > 0 ? step : -step;
        } else {
          step = Math.abs(stop - start) / (this.options.startingAnimationTime / this.options.animationTimePerStep);
          this.startingAnimationComplete = true;
        }
        var range = this._range(start, stop, step);

        // the regular range function doesn't include the stop value, so we include it here
        range.push(stop);

        return range;
      },

      // animates the displayed value till it reaches newValue
      animateValue: function (newValue, setTextOnce) {
        if (this.animationPointer) {
          clearInterval(this.animationPointer);
        }
        setTextOnce = setTextOnce || false;
        this.finalValue = newValue;
        var self = this;
        this.options.value = newValue;
        var range = this._getRange(this.currentVal, newValue);
        if (setTextOnce) {
          // set the text only once at the beginning instead of updating every time the animation loop executes
          this.setText(newValue);
        }
        if (range.length > 0) {
          var i = 0;
          this.animationPointer = setInterval(function () {
            var newIntermediateValue = range[i];
            self.setValue(Number(self.options.round(newIntermediateValue)), 0, setTextOnce);
            i++;
            if (i >= range.length) {
              clearInterval(self.animationPointer);

              // self.setValue(self.options.round(newValue));
            }
          }, this.options.animationTimePerStep);
        }
      },

      // for animating the increment value
      animateIncrement: function (newIncrement, setTextOnce) {
        if (this.animationPointer) {
          clearInterval(this.animationPointer);
        }
        setTextOnce = setTextOnce || false;
        var self = this;
        var range = this._getRange(this.currentIncrement, Math.max(newIncrement, 0));
        if (range.length > 0) {
          var i = 0;
          this.animationPointer = setInterval(function () {
            var newIntermediateValue = range[i];
            self.setValue(self.currentVal, Number(self.options.round(newIntermediateValue)), setTextOnce);
            i++;
            if (i >= range.length) {
              clearInterval(self.animationPointer);
            }
          }, this.options.animationTimePerStep);
        }
      },

      incrementValue: function (valueToIncrement, setTextOnce) {
        this.animateIncrement(valueToIncrement, setTextOnce);
      },

      // performs one step of the animation
      setValue: function (newValue, newIncrement, setTextOnce) {
        setTextOnce = setTextOnce || false;
        this.currentVal = newValue;
        this.currentIncrement = newIncrement;
        this.remainder = this.options.scale - this.currentVal - this.currentIncrement;
        this.data.setValue(0, 1, this.currentVal);
        this.data.setValue(1, 1, this.currentIncrement);
        this.data.setValue(2, 1, this.remainder);
        var donutOptions = this._setChartOptions();
        this.chart.draw(this.data, donutOptions);

        if (!setTextOnce) {
          this.setText(newValue + newIncrement);
        }
        this.scoreElem.css('color', this._getColors(this.currentVal + this.currentIncrement)[0]);
      },

      setText: function (newValue) {
        this.scoreElem.text(this.options.round(newValue));
      }
    });

    return $.ty.donutchart;
  });
})();
define('commons/public/jadec/ui_components/card',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var headerRenderer = typeof headerRenderer !== "undefined" ? headerRenderer : null;
var icon = typeof icon !== "undefined" ? icon : null;
var additionalClass = typeof additionalClass !== "undefined" ? additionalClass : "";
var helpText = typeof helpText !== "undefined" ? helpText : "";
var helpUrl = typeof helpUrl !== "undefined" ? helpUrl: "";
var mainTitle = typeof mainTitle !== "undefined" ? mainTitle : "";
var subTitle = typeof subTitle !== "undefined" ? subTitle : "";
var actions = typeof actions !== "undefined" ? actions : [];
var bodyRenderer = typeof bodyRenderer !== "undefined" ? bodyRenderer: null;
var footer = typeof footer !== "undefined" ? footer: null;
var controlLabel = typeof controlLabel !== "undefined" ? controlLabel: null;
var footerButton_mixin = function(button){
var block = this.block, attributes = this.attributes || {}, escaped = this.escaped || {};
var button = typeof button !== "undefined" ? button : {};
var primaryClass = button.primary? "btn-primary": "";
var alignClass = button.align == "left"? "l-left": "l-right";
var additionalClasses = primaryClass + " " + alignClass;
buf.push("<a" + (jade.attrs({ 'name':("" + (button.label) + ""), "class": ("trustyou-ui btn " + (additionalClasses) + "") }, {"class":true,"name":true})) + ">" + (jade.escape((jade.interp = button.label) == null ? '' : jade.interp)) + "</a>");
};
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('card') + ' ' + ("" + (additionalClass) + "") }, {"class":true})) + ">");
if ( mainTitle || headerRenderer)
{
buf.push("<div class=\"card-header\">");
if ( ! headerRenderer)
{
buf.push("<ul class=\"actions\">");
if ( actions)
{
// iterate actions
;(function(){
  var $$obj = actions;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var action = $$obj[$index];

buf.push("<li" + (jade.attrs({ 'name':("" + (action.name) + ""), "class": ("" + (action.actionClass) + "") }, {"class":true,"name":true})) + ">" + (null == (jade.interp = action.content) ? "" : jade.interp) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var action = $$obj[$index];

buf.push("<li" + (jade.attrs({ 'name':("" + (action.name) + ""), "class": ("" + (action.actionClass) + "") }, {"class":true,"name":true})) + ">" + (null == (jade.interp = action.content) ? "" : jade.interp) + "</li>");
      }

    }

  }
}).call(this);

}
buf.push("</ul>");
if ( icon)
{
if ( helpText)
{
if ( helpUrl)
{
buf.push("<a" + (jade.attrs({ 'title':("" + (helpText) + ""), 'data-tooltip':("top"), 'href':("" + (helpUrl) + ""), 'target':("_blank"), "class": ('icon-box') }, {"title":true,"data-tooltip":true,"href":true,"target":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("" + (icon) + "") }, {"class":true})) + "></i><i class=\"ty-icon ty-icon-help-o\"></i></a>");
}
else
{
buf.push("<a" + (jade.attrs({ 'title':("" + (helpText) + ""), 'data-tooltip':("top"), "class": ('icon-box') }, {"title":true,"data-tooltip":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("" + (icon) + "") }, {"class":true})) + "></i><i class=\"ty-icon ty-icon-help-o\"></i></a>");
}
}
else
{
buf.push("<a class=\"icon-box is-disabled\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("" + (icon) + "") }, {"class":true})) + "></i></a>");
}
}
if ( subTitle)
{
buf.push("<h3 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(mainTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = mainTitle) == null ? '' : jade.interp)) + "</span></h3><h4 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(subTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = subTitle) == null ? '' : jade.interp)) + "</span></h4>");
}
else
{
buf.push("<h2 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(mainTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = mainTitle) == null ? '' : jade.interp)) + "</span></h2>");
}
}
buf.push("</div>");
}
if ( bodyRenderer)
{
buf.push("<div class=\"card-body\"></div>");
}
if ( footerButtons)
{
buf.push("<div class=\"card-footer\">");
if ( controlLabel)
{
buf.push("<div class=\"controls l-left\"><label><input type=\"checkbox\"/>" + (((jade.interp = controlLabel) == null ? '' : jade.interp)) + "</label></div>");
}
// iterate footerButtons
;(function(){
  var $$obj = footerButtons;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var btn = $$obj[$index];

footerButton_mixin(btn);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var btn = $$obj[$index];

footerButton_mixin(btn);
      }

    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/card-footer-button',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var button = typeof button !== "undefined" ? button : {};
var primaryClass = button.primary? "btn-primary": "";
var alignClass = button.align == "left"? "l-left": "l-right";
var additionalClasses = primaryClass + " " + alignClass;
buf.push("<a" + (jade.attrs({ 'name':("" + (button.label) + ""), "class": ("trustyou-ui btn " + (additionalClasses) + "") }, {"class":true,"name":true})) + ">" + (jade.escape((jade.interp = button.label) == null ? '' : jade.interp)) + "</a>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/card-title',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
if ( subTitle)
{
buf.push("<h3 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(mainTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = mainTitle) == null ? '' : jade.interp)) + "</span></h3><h4 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(subTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = subTitle) == null ? '' : jade.interp)) + "</span></h4>");
}
else
{
buf.push("<h2 class=\"card-title-selector\"><span" + (jade.attrs({ 'title':(mainTitleTooltip), 'data-tooltip':('top') }, {"title":true,"data-tooltip":true})) + ">" + (jade.escape((jade.interp = mainTitle) == null ? '' : jade.interp)) + "</span></h2>");
}
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/utils',['jquery'], function ($) {
    var utils = {
      doAjax: function () {
        var defaults = {
          dataType: 'json',
          cache: false
        };

        return function (params) {
          var req = $.ajax($.extend({}, defaults, params));

          var promise = req.pipe(
          // Done
          function (data, textStatus, jqXHR) {
            if (data.meta && data.meta.code !== 200) {
              return $.Deferred().reject(data, jqXHR);
            }

            return $.Deferred().resolve(data, jqXHR);
          },

          // Fail
          function (jqXHR) {
            var data = null;

            try {
              data = JSON.parse(jqXHR.responseText);
            } catch (e) {
              // no-op
            }

            return $.Deferred().reject(data, jqXHR);
          });

          promise.jqXHR = req;

          return promise;
        };
      }(),

      normalizeDate: function (date) {
        var dateArr = date.split('-');

        // Add leading zeros to month and day if needed
        if (dateArr[1].length === 1) {
          dateArr[1] = '0' + dateArr[1];
        }
        if (dateArr[2].length === 1) {
          dateArr[2] = '0' + dateArr[2];
        }

        return dateArr.join('-');
      },

      dateToString: function (date) {
        var s = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

        return utils.normalizeDate(s);
      },
      validateEmail: function (email) {
        var re = new RegExp(['^(([^<>()[]\\.,;:\\s@"]+(\\.[^<>(),[]\\.,;:\\s@"]+)*)', '|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.', '[0-9]{1,3}])|(([a-zA-Z-0-9]+\\.)+', '[a-zA-Z]{2,}))$'].join(''));

        return re.test(email);
      },
      validateUUID: function (uuid) {
        var re = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

        return re.test(uuid);
      },
      createTooltip: function (tooltipText) {
        var icon = $('<span></span>').addClass('ui-icon ui-icon-help widget-header-icon widget-header-icon-help');
        var tooltip = $('<div></div>').addClass('tooltip').html(tooltipText);

        icon.append($('<div></div>').css({ clear: 'both', padding: '0', margin: '0' })).append(tooltip).hover(function () {
          $('.tooltip').hide();
          tooltip.stop(true, true).fadeIn();
        }, function () {
          tooltip.stop(true, true).hide();
        });

        return icon;
      },
      preloadImages: function (urls) {
        urls = urls instanceof Array ? urls : [urls];
        urls.map(function (url) {
          var img = new Image();
          img.src = url;
          return url;
        });
      },
      getTooltipsyOffset: function (align) {
        var offset = void 0;

        switch (align) {
          case 'left':
            {
              offset = [-1, 0];
              break;
            }
          case 'top':
            {
              offset = [0, -1];
              break;
            }
          case 'bottom':
            {
              offset = [0, 1];
              break;
            }
          default:
            {
              offset = [1, 0];
            }
        }

        return offset;
      },
      destroyTooltips: function ($element) {
        $element.find('[data-tooltip]').each(function () {
          if ($(this).data('tooltipsy')) {
            $(this).data('tooltipsy').destroy();
          }
        });
      },
      refreshTooltips: function ($element) {
        var self = this;

        self.destroyTooltips($element);

        $element.find('[data-tooltip]').each(function () {
          if (!$(this).attr('title')) {
            return true;
          }

          var align = $(this).attr('data-tooltip');

          $(this).tooltipsy({
            offset: self.getTooltipsyOffset(align),
            className: 'trustyou-ui tooltip l-' + align
          });
          return null;
        });
      }
    };

    return utils;
  });
})();
/*
* This plugin is used to display cards in various forms.
* It is designed to be versatile, the three parts body, footer and header
* can all be added or left out. If you don't want to show one of the parts,
* simply don't pass the related argument at initialisation.
*
*	Initialization: $div_element.card({ (contents) })
*
*	@bodyRenderer - function that receives the body element and handles drawing its content
* @footerButtons - buttons displayed in the footer. List of objects like this:
*              [{label:'', primary:true/false, align:'left'/'right', callback:function}]
* @controlLabel - adds a checkbox + label to the footer. The state of the checkbox can be
*                 checked via $div_element.card('controlSelected')
*	@additionalClass - name of an addional CSS-class to be applied to the card
*
* Header: Pass either a custom renderer or define the desired parts of the other settings
* @headerRenderer - function that receives the header element and handles drawing its content.
*	@mainTitle - html or text of the title in the header
*              (required if header is supposed to be shown)
*	@subTitle - html or text of the sub-title in the header
* @icon - class name of the icon in the header
* @helpText - text of the help-text displayed on mouse-over of the icon
* @helpUrl - URL to open when the icon is clicked. Requires @helpText parameter to be set.
*	@actions - actions displayed at the right side of the header. List of objects like this:
*              [{content:'', name:'', actionClass:'', callback:function}]
*/

(function () {
  'use strict';

  define('commons/public/js/ui_components/card',['jquery', 'widget', 'card-template', 'card-footer-button-template', 'card-title-template', '../utils'], function ($, widget, CardTemplate, CardFooterButtonTemplate, cardTitleTemplate, utils) {
    $.widget('ty.card', widget, {
      options: {
        additionalClass: '',
        headerRenderer: null,
        bodyRenderer: null,
        controlLabel: '',
        footerButtons: null,
        mainTitle: '',
        subTitle: '',
        mainTitleTooltip: '',
        subTitleTooltip: '',
        icon: '',
        helpText: '',
        helpUrl: '',
        actions: null
      },
      draw_card: function () {
        this.element.prepend(CardTemplate(this.options));
        if (this.options.headerRenderer !== null) {
          this.options.headerRenderer(this.element.find('.card-header'));
        }
        if (this.options.bodyRenderer !== null) {
          this.options.bodyRenderer(this.element.find('.card-body'));
        }
        utils.refreshTooltips(this.element.find('.card-header'));

        var self = this;

        var actionFunc = function (action) {
          var selector = 'li[name="' + action.name + '"]';
          self.element.off('click', selector + ':not(.is-disabled)').on('click', selector + ':not(.is-disabled)', function (evt) {
            action.callback(evt);
          });
        };

        if (this.options.actions) {
          for (var i = 0; i < this.options.actions.length; i++) {
            actionFunc(this.options.actions[i]);
          }
        }

        var buttonFunc = function (button) {
          var selector = 'a[name="' + button.label + '"]';
          self.element.off('click', selector + ':not(.is-disabled)').on('click', selector + ':not(.is-disabled)', function (evt) {
            button.callback(evt);
          });
        };

        if (this.options.footerButtons) {
          for (var j = 0; j < this.options.footerButtons.length; j++) {
            buttonFunc(this.options.footerButtons[j]);
          }
        }
      },

      controlSelected: function () {
        return this.element.find('.card-footer input').is(':checked');
      },

      setTitle: function (mainTitle, subTitle, mainTitleTooltip, subTitleTooltip) {
        this.element.find('.card-title-selector').first().before(cardTitleTemplate({
          mainTitle: mainTitle,
          subTitle: subTitle,
          mainTitleTooltip: mainTitleTooltip,
          subTitleTooltip: subTitleTooltip
        })).end().remove();

        utils.refreshTooltips(this.element.find('.card-title-selector'));
      },

      replaceFooter: function (newFooterButtons) {
        var self = this;

        // remove the old footer button handlers
        if (this.options.footerButtons) {
          for (var i = 0; i < this.options.footerButtons.length; i++) {
            var button = this.options.footerButtons[i];
            var selector = 'a[name="' + button.label + '""]';
            self.element.off('click', selector + ':not(.is-disabled)');
          }
        }

        this.element.find('.card-footer').empty();

        var buttonAction = function (button) {
          var selector = 'a[name="' + button.label + '"]';
          self.element.off('click', selector).on('click', selector, function (evt) {
            button.callback(evt);
          });
        };

        if (newFooterButtons) {
          for (var j = 0; j < newFooterButtons.length; j++) {
            this.element.find('.card-footer').append(CardFooterButtonTemplate({ button: newFooterButtons[j] }));
            buttonAction(newFooterButtons[j]);
          }
        }
      },

      _init: function () {
        this.element.empty();
        this.draw_card();
      }
    });
  });
})();
define('commons/public/jadec/ui_components/tile',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
classes = typeof classes !== "undefined" ? classes : (typeof cssClasses !== "undefined")? cssClasses : "";
header = typeof header !== "undefined" ? header : null;
body = typeof body !== "undefined" ? body: null;
footer = typeof footer !== "undefined" ? footer: null;
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('tile') + ' ' + ("" + (classes) + "") }, {"class":true})) + "><div class=\"tile-header\">" + (((jade.interp = header) == null ? '' : jade.interp)) + "</div><div class=\"tile-body\">" + (((jade.interp = body) == null ? '' : jade.interp)) + "</div><div class=\"tile-footer\">" + (((jade.interp = footer) == null ? '' : jade.interp)) + "</div></div>");
}
return buf.join("");
};

});

/*
* This plugin creates a tile. They are usually used in a grid.
*
*	Initialization: $div_element.tile({ (contents) })
*
*	@header - html or text to be displayed in the footer
*	@body - html or text to be displayed in the body
* @footer - html or text to be displayed in the footer (usually links)
*	@classes - name of an additional CSS classes to be applied to the card
*/

(function () {
  'use strict';

  define('commons/public/js/ui_components/tile',['jquery', 'widget', 'tile-template'], function ($, widget, tileTemplate) {
    $.widget('ty.tile', widget, {
      options: {
        classes: '',
        header: null,
        body: null,
        footer: null
      },
      _create: function () {
        this.element.prepend(tileTemplate(this.options));
      }
    });
  });
})();
define('commons/public/jadec/ui_components/tile-grid/tile-grid-tile',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
closeable = typeof closeable !== "undefined" ? closeable : true;
moveable = typeof moveable !== "undefined" ? moveable : true;
loadingHtml = typeof loadingHtml !== "undefined" ? loadingHtml : '';
classes = typeof classes !== "undefined" ? classes: "";
buf.push("<div style=\"position: relative\" class=\"relative-panel\">");
if ( closeable)
{
buf.push("<div class=\"delete-bar\"><div class=\"destroy-module clickable\"></div></div>");
}
if ( moveable)
{
buf.push("<div class=\"moveable-icon\"></div>");
}
buf.push("<div style=\"position: absolute; z-index: 100; width: 100%\" class=\"loading\">" + (((jade.interp = loadingHtml) == null ? '' : jade.interp)) + "</div><div style=\"position: relative\" class=\"panel\">");
classes = typeof classes !== "undefined" ? classes : (typeof cssClasses !== "undefined")? cssClasses : "";
header = typeof header !== "undefined" ? header : null;
body = typeof body !== "undefined" ? body: null;
footer = typeof footer !== "undefined" ? footer: null;
buf.push("<div" + (jade.attrs({ "class": ('trustyou-ui') + ' ' + ('tile') + ' ' + ("" + (classes) + "") }, {"class":true})) + "><div class=\"tile-header\">" + (((jade.interp = header) == null ? '' : jade.interp)) + "</div><div class=\"tile-body\">" + (((jade.interp = body) == null ? '' : jade.interp)) + "</div><div class=\"tile-footer\">" + (((jade.interp = footer) == null ? '' : jade.interp)) + "</div></div></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/tile-grid/tile-grid-details',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div style=\"position: relative\" class=\"relative-panel\"><div style=\"display: none; z-index: 100; width: 100%\" class=\"loading\">" + (((jade.interp = loadingHtml) == null ? '' : jade.interp)) + "</div><div style=\"position: relative\" class=\"panel\"></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/tile-grid/tile-grid-row',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
gridUid = typeof gridUid !== "undefined" ? gridUid: null;
buf.push("<div" + (jade.attrs({ "class": ('grid-row') + ' ' + ('grid-' + (gridUid) + '') }, {"class":true})) + "><div class=\"icons\"></div><div class=\"clear\"></div><div style=\"display: none\" class=\"details\"></div></div>");
}
return buf.join("");
};

});

/*
* This plugin creates a tile grid like the one used in tyra's dashboard.
* Its icons are usually tile components and the details for those tiles are usually
* card components, although that is not strictly required
*
*  Initialization: $div_element.TileGrid().init({
*            expandMultiple: false/true,
*            moveable: true/true
*          });
*  Adding Tiles: grid.addModule(iconParams, detailsParams);
*           where iconParams and detailsParams both contain a pair of functions:
*            dataprovider: gets the data required for the icon/details and returns a deferred
*            renderer: gets the data loaded by the deferred and renders the view
*/

(function () {
  'use strict';

  define('commons/public/js/ui_components/tile-grid',['jquery', 'tile', 'tile-grid-tile-template', 'tile-grid-details-template', 'tile-grid-row-template'], function ($, tile, gridTileTemplate, gridTileDetailsTemplate, gridRowTemplate) {
    var TileModuleDetails = null;

    function generateUid() {
      return Math.random().toString().replace('.', '') + '-' + $.now();
    }

    function centerLoadingPanel(el) {
      var loading = el.find('.loading').first();

      loading.css('top', (el.height() - loading.height()) / 2);
    }

    function toggleLoading(el, loading) {
      // Only consider the first elements. This is because the details panel can contain other modules.
      var panel = el.find('.panel').first(),
          loadingPanel = el.find('.loading').first();

      el.data('internal').loading = loading;

      if (loading) {
        centerLoadingPanel(el);

        panel.css({ visibility: 'hidden' });
        loadingPanel.css({ visibility: 'visible' });
      } else {
        loadingPanel.css({ visibility: 'hidden' });
        panel.css({ visibility: 'visible' });
      }
    }

    function isFirstLevelEmbeddedModule(module, parentsToMatch, parentSelector) {
      var parentArr = parentsToMatch.toArray();
      var parent = $(module).closest(parentSelector)[0];

      return parentArr.indexOf(parent) !== -1;
    }

    function findFirstLevel(context, childSelector, parentSelector) {
      return context.find(childSelector).filter(function () {
        return isFirstLevelEmbeddedModule(this, context, parentSelector);
      });
    }

    /**
     * Module details plugin. This is internal and cannot be accessed directly by the client.
     */
    (function () {
      var defaults = {
        classes: '',
        loadingHtml: '',
        reloadOnMove: false,

        // IE8 has problems rendering charts in hidden containers (WANALYTIC-1754).
        // This option helps dealing with such cases: 'true' means the content will be shown before the renderer runs
        showBeforeRender: false,
        dataprovider: null,
        renderer: null,
        rendered: null
      };

      function renderDetailsData(module, detailsParams) {
        var dataDeferred = void 0;
        var $el = $(module),
            loadDeferred = $.Deferred();
        var content = $el.find('.panel').first().html('');

        toggleLoading($el, true);

        // Call data provider if any
        if (detailsParams.dataprovider) {
          dataDeferred = detailsParams.dataprovider(module);
        } else {
          dataDeferred = $.Deferred().resolve();
        }

        // TODO add error handler
        dataDeferred.done(function (data) {
          var rendererDeferred = void 0;

          if (detailsParams.showBeforeRender) {
            $el.closest('.tile-grid').trigger('moduleExpanded', $el);

            toggleLoading($el, false);
          }

          if (detailsParams.renderer) {
            try {
              rendererDeferred = detailsParams.renderer(data, content[0]);
            } catch (e) {
              // Show the loader again in case of an unexpected error
              if (detailsParams.showBeforeRender) {
                toggleLoading($el, true);
              }
              throw e;
            }
          } else {
            rendererDeferred = $.Deferred().resolve();
          }

          rendererDeferred.done(function () {
            // Show the content if needed
            if (!detailsParams.showBeforeRender) {
              toggleLoading($el, false);
            }

            loadDeferred.resolve();
          });
        });

        return loadDeferred;
      }

      TileModuleDetails = function (items) {
        // Attach the API
        items = $.extend($(items), TileModuleDetails.API);

        return items;
      };

      TileModuleDetails.defaults = function (newDefaults) {
        $.extend(defaults, newDefaults);
      };

      TileModuleDetails.API = {
        init: function (module, params) {
          params = $.extend({}, defaults, params);

          // Render details template
          $(gridTileDetailsTemplate(params)).appendTo(this.html('').addClass('tile-details ' + params.classes).hide());

          // Attach rearrange handler
          this.on('rearranged', false).on('rearranged', function () {
            var $el = $(this);

            if (params.reloadOnMove) {
              TileModuleDetails(this).refresh();
            }

            // Notify first level embedded modules
            findFirstLevel($el, '.tile-icon', '.tile-details').trigger('rearranged');
          });

          this.each(function () {
            var $el = $(this);

            // Save state
            $el.data('internal', { module: module, params: params });
          });

          return this;
        },
        expand: function (cloaked) {
          var $el = $(this);
          var state = $el.data('internal');

          this.addClass('expanded');

          if (!cloaked) {
            this.show();
          }

          if (!$el.data('rendering')) {
            // no content yet --> lazy loading
            $el.data('rendering', 'true');

            renderDetailsData(this, state.params).done(function () {
              // Collapse handler
              $el.find('.collapse-details').first().click(function () {
                $(state.module).TileGridModule().collapse();
              });

              // should the module display the sourceLogo?
              if (state.params.sourceLogoClass) {
                $el.find('.source-logo').addClass(state.params.sourceLogoClass);
              }
              $el.data('rendering', 'done');

              // Fire callbacks if any
              if (state.params.rendered) {
                state.params.rendered($el[0]);
              }
            });
          }

          this.each(function () {
            centerLoadingPanel($(this));
          });

          /*
           * If the details panel contains other modules notify them of the event.
           * Filter only the first level of embedded module.
           */
          findFirstLevel(this, '.tile-icon', '.tile-details').trigger('parentVisible');

          return this;
        },
        collapse: function () {
          this.hide().removeClass('expanded');

          return this;
        },
        refresh: function () {
          this.each(function () {
            var $el = $(this),
                state = $el.data('internal'),
                params = state.params;

            if (!state.loading) {
              renderDetailsData(this, params).done(function () {
                // Fire callbacks if any
                if (params.rendered) {
                  params.rendered($el[0]);
                }
              });
            }
          });

          return this;
        },
        destroy: function () {
          this.remove();

          return this;
        }
      };
    })();

    /**
     * Tile Grid Module plugin.
     */
    (function () {
      var iconDefaults = {
        classes: '',
        sourceLogoClass: null,
        loadingHtml: '',
        moveable: true,
        closeable: true,
        expanded: false,
        slideToDetails: true,
        slideSpeed: 'slow',
        slideTarget: 'html, body',
        slideOffset: -240,
        dataprovider: null,
        renderer: null,
        rendered: null,
        beforeDestroy: null,
        destroyed: null,
        beforeExpandedToggle: null,
        expandedToggled: null
      };

      function renderModuleData(module, iconParams) {
        var dataDeferred = void 0;
        var $el = $(module),
            loadDeferred = $.Deferred();

        // No need to select .first() because a module icon cannot have embedded modules
        var header = $el.find('.tile-header').html('');
        var content = $el.find('.tile-body').html('');
        var footer = $el.find('.tile-footer').html('');

        toggleLoading($el, true);

        // Call data provider if any
        if (iconParams.dataprovider) {
          dataDeferred = iconParams.dataprovider(module);
        } else {
          dataDeferred = $.Deferred().resolve();
        }

        // TODO add error handler
        dataDeferred.done(function (data) {
          var rendererDeferred = void 0;

          if (iconParams.renderer) {
            rendererDeferred = iconParams.renderer(data, header[0], content[0], footer[0]);
          } else {
            rendererDeferred = $.Deferred().resolve();
          }

          rendererDeferred.done(function () {
            toggleLoading($el, false);

            loadDeferred.resolve();
          });
        });

        return loadDeferred;
      }

      if ($.fn.TileGridModule) {
        throw new Error('Cannot add TileGridModule plugin because it is already there');
      }
      $.fn.TileGridModule = function () {
        // Attach the API
        $.extend(this, $.fn.TileGridModule.API);

        return this;
      };

      $.fn.TileGridModule.defaults = function (newIconDefaults, newDetailsDefaults) {
        $.extend(iconDefaults, newIconDefaults);
        TileModuleDetails.defaults(newDetailsDefaults);
      };

      $.fn.TileGridModule.API = {
        init: function (iconParams, detailsParams) {
          // Merge the default parameters
          iconParams = $.extend({}, iconDefaults, iconParams);

          // Render icon
          this.each(function () {
            var $el = $(this);

            var gridUid = $el.closest('.grid-row').data().gridUid;

            if (iconParams.cloaked) {
              $el.removeClass('visible-module').addClass('cloaked-module');
            } else {
              $el.removeClass('cloaked-module').addClass('visible-module');
            }

            $(gridTileTemplate(iconParams)).appendTo($el.html('').addClass('grid-' + gridUid + ' tile-icon'));
          });

          this.on('rearranged', false).on('rearranged', function () {
            var $el = $(this),
                details = $($el.data('internal').details);

            // Move details panel to the correct container
            details.detach();
            details.appendTo($el.closest('.grid-row').find('.details').first());

            // Notify the details panel that it was moved
            details.trigger('rearranged');
          });

          // The parent element (TileModuleDetails) is now visible
          this.on('parentVisible', false).on('parentVisible', function () {
            centerLoadingPanel($(this));
          });

          this.each(function () {
            var $el = $(this);

            // Add empty details container.
            var $details = $('<div></div>');

            if (detailsParams.cloaked) {
              $details.hide();
            }

            $details.appendTo($el.closest('.grid-row').find('.details').first());
            TileModuleDetails($details).init(this, detailsParams);

            // Save modules and states
            $el.data('internal', {
              details: $details,
              params: {
                icon: iconParams,
                details: detailsParams
              }
            });

            renderModuleData(this, iconParams).done(function () {
              // Handlers
              $el.find('.destroy-module').click(false).click(function () {
                $(this).closest('.tile-icon').TileGridModule().destroy();
              });
              $el.find('.tile-header, .tile-body, .tile-footer').click(function () {
                var $current = $(this).closest('.tile-icon');

                if ($current.hasClass('expanded')) {
                  $current.TileGridModule().collapse();
                } else {
                  $current.TileGridModule().expand();
                }
              });

              // should the module display the sourceLogo?
              if (iconParams.sourceLogoClass) {
                $el.find('.source-logo').addClass(iconParams.sourceLogoClass);
              }

              // Fire callbacks
              if (iconParams.rendered) {
                iconParams.rendered($el[0]);
              }
            });
          });

          // Expand if needed
          if (iconParams.expanded) {
            this.expand(true, iconParams.cloaked);
          }

          return this;
        },
        destroy: function () {
          var $grid = $(this).closest('.tile-grid');

          this.each(function () {
            var $el = $(this),
                state = $el.data('internal');

            // Fire beforeDestroy callback
            if (state.params.icon.beforeDestroy) {
              state.params.icon.beforeDestroy(this);
            }

            // Remove the details panel and the icon
            TileModuleDetails(state.details).destroy();
            $el.remove();

            // Fire callback
            if (state.params.icon.destroyed) {
              state.params.icon.destroyed(this);
            }
          });

          // Signal the grid that this element was destroyed
          $grid.trigger('modulesDestroyed', {
            modules: this
          });

          return this;
        },
        cloak: function () {
          var $grid = $(this).closest('.tile-grid');

          this.each(function () {
            var $el = $(this),
                state = $el.data('internal');

            TileModuleDetails(state.details).hide();

            $el.removeClass('visible-module').addClass('cloaked-module');
          });

          // Signal the grid that this element was hidden
          $grid.trigger('modulesCloaked', {
            modules: this
          });

          return this;
        },
        reveal: function () {
          var $grid = $(this).closest('.tile-grid'),
              self = this;

          this.each(function () {
            var $el = $(this),
                state = $el.data('internal');

            if (self.isExpanded()) {
              TileModuleDetails(state.details).show();
            }

            $el.removeClass('cloaked-module').addClass('visible-module');
          });

          // Signal the grid that this element was revealed
          $grid.trigger('modulesRevealed', {
            modules: this
          });

          return this;
        },


        // TODO maybe use an internal function instead of passing this parameter
        expand: function (silent, cloaked) {
          this.not('.expanded').each(function () {
            var $el = $(this).TileGridModule(),
                state = $el.data('internal');

            // Fire callback
            if (!silent && state.params.icon.beforeExpandedToggle) {
              state.params.icon.beforeExpandedToggle(this, true);
            }

            $el.addClass('expanded');
            $el.find('.tile').addClass('is-active');

            // Notify grid
            $el.closest('.tile-grid').trigger('modulePreExpand', this, silent);

            // Show details
            TileModuleDetails(state.details).expand(cloaked);

            // Notify grid
            $el.closest('.tile-grid').trigger('moduleExpanded', this, silent);

            if (!silent && state.params.icon.slideToDetails) {
              $el.slideToDetails();
            }

            // Fire callback
            if (!silent && state.params.icon.expandedToggled) {
              state.params.icon.expandedToggled(this, true);
            }
          });

          return this;
        },
        collapse: function (silent) {
          this.filter('.expanded').each(function () {
            var $el = $(this),
                state = $el.data('internal');

            // Fire callback
            if (!silent && state.params.icon.beforeExpandedToggle) {
              state.params.icon.beforeExpandedToggle(this, false);
            }

            // Hide details
            TileModuleDetails(state.details).collapse();

            $el.removeClass('expanded');
            $el.find('.tile').removeClass('is-active');

            // Notify grid
            $el.closest('.tile-grid').trigger('moduleCollapsed', this, silent);

            // Fire callback
            if (!silent && state.params.icon.expandedToggled) {
              state.params.icon.expandedToggled(this, false);
            }
          });

          return this;
        },
        isExpanded: function () {
          var expanded = [];

          this.each(function () {
            var $el = $(this);

            if ($el.hasClass('tile-icon')) {
              expanded.push($el.hasClass('expanded'));
            }
          });

          if (expanded.length === 0) {
            // Return 'null' if the method was called without any context elements
            return null;
          } else if (expanded.length === 1) {
            // Return the boolean value if there is only one element in the context
            return expanded[0];
          } else {
            return expanded;
          }
        },
        refresh: function (refreshIcon, refreshDetails) {
          if (typeof refreshIcon !== 'boolean') {
            refreshIcon = true;
          }
          if (typeof refreshDetails !== 'boolean') {
            refreshDetails = true;
          }

          this.each(function () {
            var state = $(this).data('internal'),
                self = this;

            // Refresh icon
            if (refreshIcon && !state.loading) {
              renderModuleData(this, state.params.icon).done(function () {
                // Fire callbacks
                if (state.params.icon.rendered) {
                  state.params.icon.rendered(self);
                }
              });
            }

            // Refresh details
            if (refreshDetails) {
              TileModuleDetails(state.details).refresh();
            }
          });

          return this;
        },
        slideToDetails: function (speed, $slideTarget, offset) {
          var state = void 0,
              details = void 0;

          if (this.isExpanded() === true) {
            state = this.data('internal');
            details = state.details;

            speed = speed || state.params.icon.slideSpeed;
            $slideTarget = $($slideTarget || state.params.icon.slideTarget);
            offset = offset || state.params.icon.slideOffset;

            $slideTarget.animate({
              // scrollTop : slideTarget.scrollTop() + $(details).offset().top + offset
              scrollTop: $(details).offset().top + offset
            }, speed);
          }
        },
        getGrid: function () {
          return this.first().closest('.tile-grid').TileGrid();
        },
        getDetailPanel: function () {
          var detailPanel = $(this).data('internal').details;
          return detailPanel;
        }
      };
    })();

    /**
     * Tile grid plugin. This renders a container for the tile modules defined above
     */
    (function () {
      var hasExpanded = function (gridRow) {
        var expanded = gridRow.find('.icons').first().find('.tile-icon.visible-module').TileGridModule().isExpanded();

        return expanded === true || expanded && expanded.indexOf(true) !== -1;
      };

      var defaults = {
        modulesPerRow: 5,
        expandMultiple: true,
        rearranged: null
      };

      if ($.fn.TileGrid) {
        throw new Error('Cannot add TileGrid plugin because it is already there');
      }
      $.fn.TileGrid = function () {
        // Attach the API
        $.extend(this, $.fn.TileGrid.API);

        return this;
      };

      $.fn.TileGrid.API = {
        init: function (params) {
          // Merge the default parameters
          params = $.extend({}, defaults, params);

          this.html('').addClass('tile-grid').addClass('trustyou-ui');

          // Event handlers
          this.on('modulesDestroyed', false).on('modulesDestroyed', function () {
            $(this).TileGrid().rearrange();
          });
          this.on('modulesCloaked', false).on('modulesCloaked', function () {
            $(this).TileGrid().rearrange();
          });
          this.on('modulesRevealed', false).on('modulesRevealed', function () {
            $(this).TileGrid().rearrange();
          });
          this.on('modulePreExpand', false).on('modulePreExpand', function (e, module, silent) {
            // Collapse other modules if needed
            if (!silent && !params.expandMultiple) {
              $(this).TileGrid().getModules().each(function () {
                if (module !== this) {
                  $(this).TileGridModule().collapse(true);
                }
              });
            }
          });
          this.on('moduleExpanded', false).on('moduleExpanded', function (e, module) {
            // Show the details container
            $(module).closest('.grid-row').find('.details').first().show();
          });
          this.on('moduleCollapsed', false).on('moduleCollapsed', function (e, module) {
            var row = $(module).closest('.grid-row');

            // Hide details container if there are no expanded modules in the row
            if (!hasExpanded(row)) {
              row.find('.details').first().hide();
            }
          });

          // Add internal state
          this.each(function () {
            $(this).data('internal', {
              uid: generateUid(),
              params: params
            });
          });

          return this;
        },
        addModule: function (moduleParams, detailsParams) {
          var self = this;

          this.each(function () {
            var $el = $(this),
                state = $el.data('internal'),
                icons = findFirstLevel($el, '.icons', '.tile-grid');
            if (!icons.length || icons.last().find('.tile-icon.visible-module').length === state.params.modulesPerRow) {
              // Create a new row if we have none or if the last one is full
              self._createNewRow();
            }

            $('<div></div>').appendTo(findFirstLevel($el, '.icons', '.tile-grid').last()).TileGridModule().init(moduleParams, detailsParams);
          });

          return this;
        },
        _createNewRow: function () {
          var received = false;
          var $el = $(this),
              state = $el.data('internal');

          if (state.params.moveable !== undefined && state.params.moveable === false) {
            $(gridRowTemplate({
              gridUid: state.uid
            })).appendTo($el).data({
              gridUid: state.uid
            });
          } else {
            $(gridRowTemplate({
              gridUid: state.uid
            })).appendTo($el).data({
              gridUid: state.uid
            }).sortable({
              items: '.tile-icon.grid-' + state.uid,
              handle: '.relative-panel',
              connectWith: '.grid-row.grid-' + state.uid,
              forcePlaceholderSize: false,
              placeholder: 'module-placeholder',
              distance: 5,
              opacity: 0.5,
              tolerance: 'pointer',
              receive: function () {
                received = true;
              },
              update: function () {
                if (!received) {
                  // Rearrange the modules
                  $el.TileGrid().rearrange();

                  if (state.params.rearranged) {
                    // Pass all the icons as an array
                    state.params.rearranged(findFirstLevel($el, '.tile-icon', '.tile-grid').toArray());
                  }
                }

                // Clear flags
                received = false;
              }
            });
          }
        },
        destroy: function () {
          // TODO maybe destroy each module individually to clear the cache
          this.html('').removeClass('tile-grid');

          return this;
        },
        rearrange: function () {
          var self = this;

          this.each(function () {
            var $el = $(this),
                state = $el.data('internal');
            var icons = findFirstLevel($el, '.icons', '.tile-grid');

            for (var i = 0; i < icons.length; ++i) {
              var currentIcons = $(icons[i]).find('.tile-icon.visible-module');
              if (currentIcons.length < state.params.modulesPerRow) {
                var visibleIconToMove = $(icons[i + 1]).find('.tile-icon.visible-module').first();
                var cloakedIconsToMove = visibleIconToMove.prevAll('.tile-icon.cloaked-module');

                visibleIconToMove.detach();
                cloakedIconsToMove.detach();

                var iconsToMove = cloakedIconsToMove.add(visibleIconToMove);

                iconsToMove.appendTo(icons[i]);
              } else if (currentIcons.length > state.params.modulesPerRow) {
                var _visibleIconToMove = currentIcons.last();
                var _cloakedIconsToMove = _visibleIconToMove.nextAll('.tile-icon.cloaked-module');

                _visibleIconToMove.detach();
                _cloakedIconsToMove.detach();

                var _iconsToMove = _visibleIconToMove.add(_cloakedIconsToMove);

                if (i + 1 >= icons.length) {
                  self._createNewRow();

                  icons = findFirstLevel($el, '.icons', '.tile-grid');
                }

                _iconsToMove.prependTo(icons[i + 1]);
              }
            }

            // Notify modules of the change
            icons.find('.tile-icon').trigger('rearranged');

            $el.find('.grid-row').each(function () {
              var $row = $(this);

              // Show the details container if there are expanded modules in
              // this row, hide otherwise
              $row.find('.details').first().toggle(hasExpanded($row));
            });

            // Delete the last row if it's empty. This can happen after deleting a module
            if (!icons.last().find('.tile-icon').length) {
              icons.last().closest('.grid-row').sortable('destroy').remove();
            }
          });

          return this;
        },
        getModules: function () {
          return findFirstLevel(this, '.tile-icon', '.tile-grid').TileGridModule();
        }
      };
    })();

    return $.fn.TileGrid;
  });
})();

/*
 * A module to change the number of rows displayed in a table.
 * Shows a dropdown-menu with the possible page sizes;
 * when the page size is passes the new number back and redraws itself,
 * showing the new page size.
 *
 * Initialization: $div_element.pageSizeSelector({ (options) })
 *
 * Options:
 * @onChange - the function called when a new size is selected (function, required)
 * @sizes - the possible page sizes. '-1' means 'show all rows'. (array of ints)
 * @selectedSize - the initially selected page size (int)
 * @isRightAligned - if the dropdown is right-aligned (boolean)
 * @labels - the i18n labels used in the module.
 *           Keys are 'rows_per_page' and 'show_all'. (dictionary)
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/pagesize',['jquery', 'widget', 'ty-i18n!portfolio', 'dropdown-menu-template', 'dropdownmenu'], function ($, widget, i18n, dropdownTemplate) {
    $.widget('ty.pageSizeSelector', widget, {
      // not using options here, since we want to do the merging of properties manually due to the weird
      // way jquery extends arrays when using the deep flag
      defaults: {
        sizes: [5, 10, 20, 50, 100, -1],
        selectedSize: 10,
        onChange: function (value) {},
        isRightAligned: false,
        labels: {
          rows_per_page: i18n.rows_per_page || '@rows/page',
          show_all: i18n.show_all || '@Show all'
        }
      },

      draw_template: function () {
        var self = this;

        var items = self.options.sizes.map(function (size) {
          var label = void 0;
          if (size === -1) {
            label = self.options.labels.show_all;
          } else {
            label = size + ' ' + self.options.labels.rows_per_page;
          }
          return {
            value: size,
            label: label,
            selected: size === self.options.selectedSize
          };
        });

        self.element.prepend(dropdownTemplate({
          items: items,
          search: false,
          selectAll: false,
          icon: 'ty-icon-list',
          toggle: self.options.selectedSize === -1 ? self.options.labels.show_all : self.options.selectedSize
        }));
        if (self.options.isRightAligned) {
          this.element.find('.dropdown-menu').addClass('l-right');
        }

        this.element.find('.dropdown').dropdownmenu({});
      },

      _init: function () {
        var self = this;

        // jquery's $.extend(deep=true) which is used by default in jquery ui leads to the passed-in size array
        // being concatendated instead of replaced, so we do this merge manually and we don't use deep for sizes
        var mergedOptions = $.extend(true, {}, this.defaults, this.options);
        mergedOptions.sizes = this.options.sizes || this.defaults.sizes;
        this.options = mergedOptions;

        this.draw_template();

        this._on(['dropdownmenuselect', function (evt, data) {
          self.options.selectedSize = data.val;
          var classes = self.element.find('.dropdown-menu').attr('class');
          self.element.empty();
          self.draw_template();
          self.element.find('.dropdown-menu').addClass(classes);
          self.options.onChange(data.val);
        }]);
      }
    });
  });
})();

requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.addBuffer('toastrCss.css'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick;
/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
(function (define) {
    define('toastr',['jquery'], function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.3',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass);

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null) {
                        source = '';
                    }

                    return source
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }

                function setAria() {
                    var ariaValue = '';
                    switch (map.iconClass) {
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue =  'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }

                function handleEvents() {
                    if (options.closeOnHover) {
                        $toastElement.hover(stickAround, delayedHideToast);
                    }

                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }

                            if (options.onCloseClick) {
                                options.onCloseClick(event);
                            }

                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.title);
                        }
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.message);
                        }
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }

                function setRTL() {
                    if (options.rtl) {
                        $toastElement.addClass('rtl');
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    });
}(typeof define === 'function' && define.amd ? define : function (deps, factory) {
    if (typeof module !== 'undefined' && module.exports) { //Node
        module.exports = factory(require('jquery'));
    } else {
        window.toastr = factory(window.jQuery);
    }
}));

/*
 * Toast Plugin for showing automatically dismissible notifications
 *
 * How to use it, check params below and toastr plugin at
 * https://github.com/CodeSeven/toastr
 *
 *		$.toast({
 *			'positionClass': '',
 *			'showDuration': '',
 *			...
 *		}).success({title:'', message:''});
 *
 */

(function () {
  'use strict';

  define('commons/public/js/ui_components/toast',['jquery', 'toastr'], function ($, toastr) {
    $.toast = function (options) {
      var defaults = {
        toastClass: 'trustyou-ui notification toast',
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: false,
        positionClass: 'toast-top-right',
        preventDuplicates: false,
        onclick: null,
        showDuration: '300',
        hideDuration: '1000',
        timeOut: '3000',
        extendedTimeOut: '1000',
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
      };

      // This is the easiest way to have default options.
      var settings = $.extend(defaults, options);

      return {
        success: function (opts) {
          toastr.options = settings;
          toastr.options.toastClass = toastr.options.toastClass + ' notification-positive';
          toastr.success(opts.message, opts.title);
        },
        error: function (opts) {
          toastr.options = settings;
          toastr.options.toastClass = toastr.options.toastClass + ' notification-negative';
          toastr.error(opts.message, opts.title);
        },
        warning: function (opts) {
          toastr.options = settings;
          toastr.options.toastClass = toastr.options.toastClass + ' notification-neutral';
          toastr.warning(opts.message, opts.title);
        },
        info: function (opts) {
          toastr.options = settings;
          toastr.options.toastClass = toastr.options.toastClass + ' notification-primary';
          toastr.info(opts.message, opts.title);
        }
      };
    };

    return $.toast;
  });
})();
define('commons/public/jadec/ui_components/sidebar',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<a class=\"brand\"><img src=\"https://cdn-rest.staging.hcloud.trustyou.net/apps/commons/public/img/ty_logo_icon_512x512.svg\" alt=\"TrustYou\"/></a><div class=\"sidebar-wrapper\"><ul id=\"modulesList\" class=\"nav-primary l-top\"></ul></div>");
}
return buf.join("");
};

});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  define('commons/public/js/permission_managers',['session', './config'], function (session, config) {
    // ================= SHARED ================= //

    var Permission = {
      DASHBOARD: 'dashboard',
      PORTFOLIO: 'portfolio',
      ANALYTICS: 'analytics',
      SURVEY: 'survey',
      SURVEY_LITE: 'survey_lite',
      SURVEY_TEMPLATES: 'survey_templates_management',
      MESSAGING: 'messaging',
      MESSAGING_EMPLOYEE: 'messaging_employee',
      MESSAGING_ADMIN: 'messaging_admin',
      MESSAGING_INTEGRATIONS: 'messaging_integrations',
      MESSAGING_OUTREACHES: 'messaging_outreaches',
      MESSAGING_STATISTICS: 'messaging_statistics',
      OPERATIONS: 'operations',
      SETTINGS: 'settings',
      REVIEWS: 'reviews',
      SOCIAL: 'social',
      COMPARISON: 'comparison',
      MANAGE_USERS: 'manage_users',
      MARKETING: 'marketing',
      HIDE_SURVEY: 'hide_module_survey',
      HIDE_ANALYTICS: 'hide_module_analytics',
      HIDE_MARKETING: 'hide_module_marketing',
      HIDE_MESSAGING: 'hide_module_messaging',
      HIDE_OPERATIONS: 'hide_module_operations',
      ONSITE: 'on_site'
    };

    var Product = {
      ANALYTICS: 'analytics',
      SURVEY: 'survey',
      MESSAGING: 'messaging',
      OPERATIONS: 'operations',
      MARKETING: 'marketing'
    };

    var ModuleId = {
      ADMIN: 'admin_module',
      ANALYTICS: 'analytics_module',
      SURVEY: 'survey_module',
      MESSAGING: 'messaging_module',
      MARKETING: 'marketing_module',
      OPERATIONS: 'operations_module',
      ONSITE: 'onsite_module'
    };

    var ModuleStatus = {
      HIDDEN: 'hidden',
      TRIALLED: 'trialled',
      GRANTED: 'granted',
      LOCKED: 'locked'
    };

    var TabId = {
      TEMPLATES: 'templates',
      SURVEY: 'survey',
      SETTINGS: 'settings',
      INBOX: 'reviews',
      DASHBOARD: 'dashboard',
      SOCIAL: 'social',
      PORTFOLIO: 'portfolio',
      COMPETITORS: 'comparison',
      GOALS: 'goals',
      TASKS: 'tasks',
      HOTEL: 'hotel-admin',
      USERS: 'users-admin',
      SURVEYS: 'surveys-admin',
      NEW_USERS: 'new-users-admin', // In the future this will replace the old USERS tab
      WIDGETS: 'metaresponse',
      INTEGRATIONS: 'integrations',
      OUTREACHES: 'outreaches',
      STATISTICS: 'statistics'
    };

    var TabStatus = {
      VISIBLE: 'visible',
      HIDDEN: 'hidden',
      TRIALLED: 'trialled',
      LOCKED: 'locked'
    };

    var PermissionWorker = function () {
      /*
       * Wrapper around the permission data structure
       *
       * TODO: Maybe make it a singleton?
       */
      function PermissionWorker() {
        _classCallCheck(this, PermissionWorker);

        this.types = {
          OR: 'or',
          AND: 'and'
        };
        this.session = session;
      }

      _createClass(PermissionWorker, [{
        key: 'data',
        value: function data() {
          /*
           * Return the data structure for non-standard operations
           * ! This method should be avoided as much as possible !
           */

          return this.session;
        }
      }, {
        key: 'hasPermission',
        value: function hasPermission(permissions) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.types.OR;

          return this._check(session.permissions, permissions, type);
        }
      }, {
        key: 'hasTrial',
        value: function hasTrial(permissions) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.types.OR;

          return this._check(session.trial_permissions, permissions, type);
        }
      }, {
        key: 'hasExpired',
        value: function hasExpired(permissions) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.types.OR;

          return this._check(session.expired_permissions, permissions, type);
        }
      }, {
        key: '_check',
        value: function _check(arr, permissions, type) {
          var _this = this;

          PermissionWorker._checkNotEmpty(permissions);
          var initialVal = type !== this.types.OR;

          return permissions.reduce(function (acc, curr) {
            if (type === _this.types.OR) {
              return acc || arr.indexOf(curr) !== -1;
            } else if (type === _this.types.AND) {
              return acc && arr.indexOf(curr) !== -1;
            } else {
              throw new Error('Unknown type ' + type);
            }
          }, initialVal);
        }
      }], [{
        key: '_checkNotEmpty',
        value: function _checkNotEmpty(arr) {
          if (!arr || arr.length === 0) {
            throw new Error('At least 1 element is needed!');
          }
        }
      }]);

      return PermissionWorker;
    }();

    var ConfigWorker = function () {
      function ConfigWorker() {
        _classCallCheck(this, ConfigWorker);
      }

      _createClass(ConfigWorker, [{
        key: 'isModuleDisabled',
        value: function isModuleDisabled(moduleId) {
          var sidebarModulesSectionExists = config.sidebar_modules !== undefined;
          var moduleOptionExists = sidebarModulesSectionExists && config.sidebar_modules[moduleId] !== undefined;
          var modulOptionIsDisabled = moduleOptionExists && config.sidebar_modules[moduleId] === 'disabled';

          return modulOptionIsDisabled;
        }
      }, {
        key: 'isTabDisabled',
        value: function isTabDisabled(tabId) {
          var sidebarTabsSectionExists = config.sidebar_tabs !== undefined;
          var tabOptionExists = sidebarTabsSectionExists && config.sidebar_tabs[tabId] !== undefined;
          var tabOptionIsDisabled = tabOptionExists && config.sidebar_tabs[tabId] === 'disabled';

          return tabOptionIsDisabled;
        }
      }]);

      return ConfigWorker;
    }();

    // ================= MODULE ================= //

    var ModulePermissionChecker = function () {
      /*
       * Base class for all module permission checkers
       */

      function ModulePermissionChecker() {
        _classCallCheck(this, ModulePermissionChecker);

        this.permission_worker = new PermissionWorker();
        this.config_worker = new ConfigWorker();
      }

      _createClass(ModulePermissionChecker, [{
        key: 'status',
        value: function status() {
          // This check orded is important! Don't change it!
          if (this.isHidden()) {
            return ModuleStatus.HIDDEN;
          } else if (this.isOnTrial()) {
            return ModuleStatus.TRIALLED;
          } else if (this.isGranted()) {
            return ModuleStatus.GRANTED;
          } else {
            return ModuleStatus.LOCKED;
          }
        }
      }, {
        key: 'isHidden',
        value: function isHidden() {
          var isNotDisabledByConfig = !this.config_worker.isModuleDisabled(this.id);
          if (isNotDisabledByConfig) {
            return this.permission_worker.hasPermission(this.hiddenPermissions);
          } else {
            // Since it's disabled by config, it's hidden
            return true;
          }
        }
      }, {
        key: 'isOnTrial',
        value: function isOnTrial() {
          return this.permission_worker.hasTrial(this.trialPermissions);
        }
      }, {
        key: 'isGranted',
        value: function isGranted() {
          return this.permission_worker.hasPermission(this.grantedPermissions);
        }
      }, {
        key: 'isLocked',
        value: function isLocked() {
          return !this.isHidden() && !this.isOnTrial() && !this.isGranted();
        }
      }, {
        key: 'isExpired',
        value: function isExpired() {
          return this.permission_worker.hasExpired(this.trialPermissions);
        }
      }]);

      return ModulePermissionChecker;
    }();

    var AdminModuleChecker = function (_ModulePermissionChec) {
      _inherits(AdminModuleChecker, _ModulePermissionChec);

      /*
       * The admin cannot be on trial or locked
       */

      function AdminModuleChecker() {
        _classCallCheck(this, AdminModuleChecker);

        var _this2 = _possibleConstructorReturn(this, (AdminModuleChecker.__proto__ || Object.getPrototypeOf(AdminModuleChecker)).call(this));

        _this2.id = ModuleId.ADMIN;
        _this2.grantedPermissions = [Permission.MANAGE_USERS];
        return _this2;
      }

      _createClass(AdminModuleChecker, [{
        key: 'status',
        value: function status() {
          // It has a special status check :)
          if (this.isGranted()) {
            return ModuleStatus.GRANTED;
          } else {
            return ModuleStatus.HIDDEN;
          }
        }
      }, {
        key: 'isHidden',
        value: function isHidden() {
          return !this.isGranted();
        }
      }, {
        key: 'isOnTrial',
        value: function isOnTrial() {
          // eslint-disable-line class-methods-use-this
          return false;
        }
      }, {
        key: 'isLocked',
        value: function isLocked() {
          // eslint-disable-line class-methods-use-this
          return false;
        }
      }, {
        key: 'isExpired',
        value: function isExpired() {
          // eslint-disable-line class-methods-use-this
          return false;
        }
      }]);

      return AdminModuleChecker;
    }(ModulePermissionChecker);

    var AnalyticsModuleChecker = function (_ModulePermissionChec2) {
      _inherits(AnalyticsModuleChecker, _ModulePermissionChec2);

      function AnalyticsModuleChecker() {
        _classCallCheck(this, AnalyticsModuleChecker);

        var _this3 = _possibleConstructorReturn(this, (AnalyticsModuleChecker.__proto__ || Object.getPrototypeOf(AnalyticsModuleChecker)).call(this));

        _this3.id = ModuleId.ANALYTICS;
        _this3.hiddenPermissions = [Permission.MANAGE_USERS, Permission.HIDE_ANALYTICS];
        _this3.trialPermissions = [Permission.PORTFOLIO, Permission.ANALYTICS];
        _this3.grantedPermissions = [Permission.PORTFOLIO, Permission.ANALYTICS];
        _this3.fullAccessProduct = [Product.ANALYTICS];
        _this3.fullAccessPermission = [Permission.ANALYTICS];
        return _this3;
      }

      return AnalyticsModuleChecker;
    }(ModulePermissionChecker);

    var SurveyModuleChecker = function (_ModulePermissionChec3) {
      _inherits(SurveyModuleChecker, _ModulePermissionChec3);

      function SurveyModuleChecker() {
        _classCallCheck(this, SurveyModuleChecker);

        var _this4 = _possibleConstructorReturn(this, (SurveyModuleChecker.__proto__ || Object.getPrototypeOf(SurveyModuleChecker)).call(this));

        _this4.id = ModuleId.SURVEY;
        _this4.hiddenPermissions = [Permission.MANAGE_USERS, Permission.HIDE_SURVEY];
        _this4.trialPermissions = [Permission.SURVEY, Permission.SURVEY_LITE];
        _this4.grantedPermissions = [Permission.SURVEY, Permission.SURVEY_LITE, Permission.MESSAGING];
        _this4.fullAccessProduct = [Product.SURVEY];
        _this4.fullAccessPermission = [Permission.SURVEY];
        return _this4;
      }

      return SurveyModuleChecker;
    }(ModulePermissionChecker);

    var MarketingModuleChecker = function (_ModulePermissionChec4) {
      _inherits(MarketingModuleChecker, _ModulePermissionChec4);

      /*
       * Access to marketing module only to users possessing marketing
       */

      function MarketingModuleChecker() {
        _classCallCheck(this, MarketingModuleChecker);

        var _this5 = _possibleConstructorReturn(this, (MarketingModuleChecker.__proto__ || Object.getPrototypeOf(MarketingModuleChecker)).call(this));

        _this5.id = ModuleId.MARKETING;
        _this5.hiddenPermissions = [Permission.MANAGE_USERS, Permission.HIDE_MARKETING];
        _this5.trialPermissions = [Permission.MARKETING];
        _this5.grantedPermissions = [Permission.MARKETING];
        _this5.fullAccessProduct = [Product.MARKETING];
        _this5.fullAccessPermission = [Permission.MARKETING];
        return _this5;
      }

      return MarketingModuleChecker;
    }(ModulePermissionChecker);

    var MessagingModuleChecker = function (_ModulePermissionChec5) {
      _inherits(MessagingModuleChecker, _ModulePermissionChec5);

      /*
       * Messaging has a special trial check
       */

      function MessagingModuleChecker() {
        _classCallCheck(this, MessagingModuleChecker);

        var _this6 = _possibleConstructorReturn(this, (MessagingModuleChecker.__proto__ || Object.getPrototypeOf(MessagingModuleChecker)).call(this));

        _this6.id = ModuleId.MESSAGING;
        _this6.hiddenPermissions = [Permission.MANAGE_USERS, Permission.HIDE_MESSAGING];
        _this6.grantedPermissions = [Permission.MESSAGING, Permission.MESSAGING_EMPLOYEE, Permission.MESSAGING_ADMIN, Permission.MESSAGING_INTEGRATIONS, Permission.MESSAGING_OUTREACHES, Permission.MESSAGING_STATISTICS];
        _this6.fullAccessProduct = [Product.MESSAGING];
        _this6.fullAccessPermission = [Permission.MESSAGING];
        return _this6;
      }

      _createClass(MessagingModuleChecker, [{
        key: 'isOnTrial',
        value: function isOnTrial() {
          return this.permission_worker.data().properties.messaging_trial;
        }
      }, {
        key: 'isExpired',
        value: function isExpired() {
          // eslint-disable-line class-methods-use-this
          return false;
        }
      }]);

      return MessagingModuleChecker;
    }(ModulePermissionChecker);

    var OnsiteModuleChecker = function (_ModulePermissionChec6) {
      _inherits(OnsiteModuleChecker, _ModulePermissionChec6);

      /*
       * Messaging has a special trial check
       */

      function OnsiteModuleChecker() {
        _classCallCheck(this, OnsiteModuleChecker);

        var _this7 = _possibleConstructorReturn(this, (OnsiteModuleChecker.__proto__ || Object.getPrototypeOf(OnsiteModuleChecker)).call(this));

        _this7.id = ModuleId.ONSITE;
        _this7.hiddenPermissions = [Permission.MANAGE_USERS];
        _this7.trialPermissions = [Permission.ONSITE];
        _this7.grantedPermissions = [Permission.ONSITE];
        _this7.fullAccessProduct = [Permission.ONSITE];
        _this7.fullAccessPermission = [Permission.ONSITE];
        return _this7;
      }

      return OnsiteModuleChecker;
    }(ModulePermissionChecker);

    var OperationsModuleChecker = function (_ModulePermissionChec7) {
      _inherits(OperationsModuleChecker, _ModulePermissionChec7);

      /*
       * Messaging has a special trial check
       */

      function OperationsModuleChecker() {
        _classCallCheck(this, OperationsModuleChecker);

        var _this8 = _possibleConstructorReturn(this, (OperationsModuleChecker.__proto__ || Object.getPrototypeOf(OperationsModuleChecker)).call(this));

        _this8.id = ModuleId.OPERATIONS;
        _this8.hiddenPermissions = [Permission.MANAGE_USERS, Permission.HIDE_OPERATIONS];
        _this8.grantedPermissions = [Permission.OPERATIONS];
        _this8.fullAccessProduct = [Product.OPERATIONS];
        _this8.fullAccessPermission = [Permission.OPERATIONS];
        return _this8;
      }

      _createClass(OperationsModuleChecker, [{
        key: 'isOnTrial',
        value: function isOnTrial() {
          return false;
        }
      }, {
        key: 'isExpired',
        value: function isExpired() {
          // eslint-disable-line class-methods-use-this
          return false;
        }
      }]);

      return OperationsModuleChecker;
    }(ModulePermissionChecker);

    var ModulePermissionManager = function () {
      /*
       * TODO: Make this singleton!
       */
      function ModulePermissionManager() {
        _classCallCheck(this, ModulePermissionManager);

        this.module_map = {};
        this.module_map[ModuleId.ADMIN] = new AdminModuleChecker();
        this.module_map[ModuleId.ANALYTICS] = new AnalyticsModuleChecker();
        this.module_map[ModuleId.SURVEY] = new SurveyModuleChecker();
        this.module_map[ModuleId.MESSAGING] = new MessagingModuleChecker();
        this.module_map[ModuleId.ONSITE] = new OnsiteModuleChecker();
        this.module_map[ModuleId.OPERATIONS] = new OperationsModuleChecker();
        this.module_map[ModuleId.MARKETING] = new MarketingModuleChecker();
      }

      _createClass(ModulePermissionManager, [{
        key: 'status',
        value: function status(moduleId) {
          return this.module_map[moduleId].status();
        }
      }, {
        key: 'isHidden',
        value: function isHidden(moduleId) {
          return this.module_map[moduleId].isHidden();
        }
      }, {
        key: 'isOnTrial',
        value: function isOnTrial(moduleId) {
          return this.module_map[moduleId].isOnTrial();
        }
      }, {
        key: 'isGranted',
        value: function isGranted(moduleId) {
          return this.module_map[moduleId].isGranted();
        }
      }, {
        key: 'isLocked',
        value: function isLocked(moduleId) {
          return this.module_map[moduleId].isLocked();
        }
      }, {
        key: 'isExpired',
        value: function isExpired(moduleId) {
          return this.module_map[moduleId].isExpired();
        }
      }]);

      return ModulePermissionManager;
    }();

    // ================= TAB ================= //

    var TabPermissionChecker = function () {
      /*
       * Base class for all tab permission checkers
       */

      function TabPermissionChecker() {
        _classCallCheck(this, TabPermissionChecker);

        this.permission_worker = new PermissionWorker();
        this.config_worker = new ConfigWorker();
      }

      _createClass(TabPermissionChecker, [{
        key: 'status',
        value: function status() {
          // This check orded is important! Don't change it!
          if (this.isHidden()) {
            return TabStatus.HIDDEN;
          } else {
            return TabStatus.VISIBLE;
          }
        }
      }, {
        key: 'isVisible',
        value: function isVisible() {
          return this.permission_worker.hasPermission(this.visiblePermissions);
        }
      }, {
        key: 'isHidden',
        value: function isHidden() {
          var isNotDisabledByConfig = !this.config_worker.isTabDisabled(this.id);
          if (isNotDisabledByConfig) {
            return !this.isVisible();
          } else {
            // Since it's disabled by config, it's hidden
            return true;
          }
        }
      }, {
        key: 'isLocked',
        value: function isLocked() {
          // eslint-disable-line class-methods-use-this
          /*
           * Not yet used for Tabs
           */
          return false;
        }
      }, {
        key: 'isOnTrial',
        value: function isOnTrial() {
          // eslint-disable-line class-methods-use-this
          /*
           * Not yet used for Tabs
           */
          return false;
        }
      }, {
        key: 'isExpired',
        value: function isExpired() {
          // eslint-disable-line class-methods-use-this
          /*
           * Not yet used for Tabs
           */
          return false;
        }
      }]);

      return TabPermissionChecker;
    }();

    var TemplatesTabChecker = function (_TabPermissionChecker) {
      _inherits(TemplatesTabChecker, _TabPermissionChecker);

      function TemplatesTabChecker() {
        _classCallCheck(this, TemplatesTabChecker);

        var _this9 = _possibleConstructorReturn(this, (TemplatesTabChecker.__proto__ || Object.getPrototypeOf(TemplatesTabChecker)).call(this));

        _this9.id = TabId.TEMPLATES;
        _this9.visiblePermissions = [Permission.SURVEY_TEMPLATES];
        return _this9;
      }

      return TemplatesTabChecker;
    }(TabPermissionChecker);

    var SurveyTabChecker = function (_TabPermissionChecker2) {
      _inherits(SurveyTabChecker, _TabPermissionChecker2);

      function SurveyTabChecker() {
        _classCallCheck(this, SurveyTabChecker);

        var _this10 = _possibleConstructorReturn(this, (SurveyTabChecker.__proto__ || Object.getPrototypeOf(SurveyTabChecker)).call(this));

        _this10.id = TabId.SURVEY;
        _this10.visiblePermissions = [Permission.SURVEY, Permission.SURVEY_LITE, Permission.MESSAGING];
        return _this10;
      }

      return SurveyTabChecker;
    }(TabPermissionChecker);

    var SettingsTabChecker = function (_TabPermissionChecker3) {
      _inherits(SettingsTabChecker, _TabPermissionChecker3);

      function SettingsTabChecker() {
        _classCallCheck(this, SettingsTabChecker);

        var _this11 = _possibleConstructorReturn(this, (SettingsTabChecker.__proto__ || Object.getPrototypeOf(SettingsTabChecker)).call(this));

        _this11.id = TabId.SETTINGS;
        _this11.visiblePermissions = [Permission.SETTINGS];
        return _this11;
      }

      return SettingsTabChecker;
    }(TabPermissionChecker);

    var InboxTabChecker = function (_TabPermissionChecker4) {
      _inherits(InboxTabChecker, _TabPermissionChecker4);

      function InboxTabChecker() {
        _classCallCheck(this, InboxTabChecker);

        var _this12 = _possibleConstructorReturn(this, (InboxTabChecker.__proto__ || Object.getPrototypeOf(InboxTabChecker)).call(this));

        _this12.id = TabId.INBOX;
        _this12.visiblePermissions = [Permission.REVIEWS];
        return _this12;
      }

      return InboxTabChecker;
    }(TabPermissionChecker);

    var DashboardTabChecker = function (_TabPermissionChecker5) {
      _inherits(DashboardTabChecker, _TabPermissionChecker5);

      function DashboardTabChecker() {
        _classCallCheck(this, DashboardTabChecker);

        var _this13 = _possibleConstructorReturn(this, (DashboardTabChecker.__proto__ || Object.getPrototypeOf(DashboardTabChecker)).call(this));

        _this13.id = TabId.DASHBOARD;
        _this13.visiblePermissions = [Permission.DASHBOARD];
        return _this13;
      }

      return DashboardTabChecker;
    }(TabPermissionChecker);

    var SocialTabChecker = function (_TabPermissionChecker6) {
      _inherits(SocialTabChecker, _TabPermissionChecker6);

      function SocialTabChecker() {
        _classCallCheck(this, SocialTabChecker);

        var _this14 = _possibleConstructorReturn(this, (SocialTabChecker.__proto__ || Object.getPrototypeOf(SocialTabChecker)).call(this));

        _this14.id = TabId.SOCIAL;
        _this14.visiblePermissions = [Permission.SOCIAL];
        return _this14;
      }

      return SocialTabChecker;
    }(TabPermissionChecker);

    var PortfolioTabChecker = function (_TabPermissionChecker7) {
      _inherits(PortfolioTabChecker, _TabPermissionChecker7);

      function PortfolioTabChecker() {
        _classCallCheck(this, PortfolioTabChecker);

        var _this15 = _possibleConstructorReturn(this, (PortfolioTabChecker.__proto__ || Object.getPrototypeOf(PortfolioTabChecker)).call(this));

        _this15.id = TabId.PORTFOLIO;
        _this15.visiblePermissions = [Permission.PORTFOLIO];
        return _this15;
      }

      return PortfolioTabChecker;
    }(TabPermissionChecker);

    var CompetitorsTabChecker = function (_TabPermissionChecker8) {
      _inherits(CompetitorsTabChecker, _TabPermissionChecker8);

      function CompetitorsTabChecker() {
        _classCallCheck(this, CompetitorsTabChecker);

        var _this16 = _possibleConstructorReturn(this, (CompetitorsTabChecker.__proto__ || Object.getPrototypeOf(CompetitorsTabChecker)).call(this));

        _this16.id = TabId.COMPETITORS;
        _this16.visiblePermissions = [Permission.COMPARISON];
        return _this16;
      }

      return CompetitorsTabChecker;
    }(TabPermissionChecker);

    var GoalsTabChecker = function (_TabPermissionChecker9) {
      _inherits(GoalsTabChecker, _TabPermissionChecker9);

      function GoalsTabChecker() {
        _classCallCheck(this, GoalsTabChecker);

        var _this17 = _possibleConstructorReturn(this, (GoalsTabChecker.__proto__ || Object.getPrototypeOf(GoalsTabChecker)).call(this));

        _this17.id = TabId.GOALS;
        _this17.visiblePermissions = [Permission.OPERATIONS];
        return _this17;
      }

      return GoalsTabChecker;
    }(TabPermissionChecker);

    var TasksTabChecker = function (_TabPermissionChecker10) {
      _inherits(TasksTabChecker, _TabPermissionChecker10);

      function TasksTabChecker() {
        _classCallCheck(this, TasksTabChecker);

        var _this18 = _possibleConstructorReturn(this, (TasksTabChecker.__proto__ || Object.getPrototypeOf(TasksTabChecker)).call(this));

        _this18.id = TabId.TASKS;
        _this18.visiblePermissions = [Permission.OPERATIONS];
        return _this18;
      }

      return TasksTabChecker;
    }(TabPermissionChecker);

    var HotelsTabChecker = function (_TabPermissionChecker11) {
      _inherits(HotelsTabChecker, _TabPermissionChecker11);

      function HotelsTabChecker() {
        _classCallCheck(this, HotelsTabChecker);

        var _this19 = _possibleConstructorReturn(this, (HotelsTabChecker.__proto__ || Object.getPrototypeOf(HotelsTabChecker)).call(this));

        _this19.id = TabId.HOTEL;
        _this19.visiblePermissions = [Permission.MANAGE_USERS];
        return _this19;
      }

      return HotelsTabChecker;
    }(TabPermissionChecker);

    var UsersTabChecker = function (_TabPermissionChecker12) {
      _inherits(UsersTabChecker, _TabPermissionChecker12);

      function UsersTabChecker() {
        _classCallCheck(this, UsersTabChecker);

        var _this20 = _possibleConstructorReturn(this, (UsersTabChecker.__proto__ || Object.getPrototypeOf(UsersTabChecker)).call(this));

        _this20.id = TabId.USERS;
        _this20.visiblePermissions = [Permission.MANAGE_USERS];
        return _this20;
      }

      return UsersTabChecker;
    }(TabPermissionChecker);

    var SurveysTabChecker = function (_TabPermissionChecker13) {
      _inherits(SurveysTabChecker, _TabPermissionChecker13);

      function SurveysTabChecker() {
        _classCallCheck(this, SurveysTabChecker);

        var _this21 = _possibleConstructorReturn(this, (SurveysTabChecker.__proto__ || Object.getPrototypeOf(SurveysTabChecker)).call(this));

        _this21.id = TabId.SURVEYS;
        _this21.visiblePermissions = [Permission.MANAGE_USERS];
        return _this21;
      }

      return SurveysTabChecker;
    }(TabPermissionChecker);

    var NewUsersTabChecker = function (_TabPermissionChecker14) {
      _inherits(NewUsersTabChecker, _TabPermissionChecker14);

      function NewUsersTabChecker() {
        _classCallCheck(this, NewUsersTabChecker);

        var _this22 = _possibleConstructorReturn(this, (NewUsersTabChecker.__proto__ || Object.getPrototypeOf(NewUsersTabChecker)).call(this));

        _this22.id = TabId.NEW_USERS;
        _this22.visiblePermissions = [Permission.MANAGE_USERS];
        return _this22;
      }

      return NewUsersTabChecker;
    }(TabPermissionChecker);

    var WidgetsTabChecker = function (_TabPermissionChecker15) {
      _inherits(WidgetsTabChecker, _TabPermissionChecker15);

      function WidgetsTabChecker() {
        _classCallCheck(this, WidgetsTabChecker);

        var _this23 = _possibleConstructorReturn(this, (WidgetsTabChecker.__proto__ || Object.getPrototypeOf(WidgetsTabChecker)).call(this));

        _this23.id = TabId.WIDGETS;
        return _this23;
      }

      /*
       * Widgets tab is always visible
       */


      _createClass(WidgetsTabChecker, [{
        key: 'isVisible',
        value: function isVisible() {
          // eslint-disable-line class-methods-use-this
          return TabStatus.VISIBLE;
        }
      }]);

      return WidgetsTabChecker;
    }(TabPermissionChecker);

    var IntegrationsTabChecker = function (_TabPermissionChecker16) {
      _inherits(IntegrationsTabChecker, _TabPermissionChecker16);

      function IntegrationsTabChecker() {
        _classCallCheck(this, IntegrationsTabChecker);

        var _this24 = _possibleConstructorReturn(this, (IntegrationsTabChecker.__proto__ || Object.getPrototypeOf(IntegrationsTabChecker)).call(this));

        _this24.id = TabId.INTEGRATIONS;
        _this24.visiblePermissions = [Permission.MESSAGING_INTEGRATIONS];
        return _this24;
      }

      return IntegrationsTabChecker;
    }(TabPermissionChecker);

    var OutreachesTabChecker = function (_TabPermissionChecker17) {
      _inherits(OutreachesTabChecker, _TabPermissionChecker17);

      function OutreachesTabChecker() {
        _classCallCheck(this, OutreachesTabChecker);

        var _this25 = _possibleConstructorReturn(this, (OutreachesTabChecker.__proto__ || Object.getPrototypeOf(OutreachesTabChecker)).call(this));

        _this25.id = TabId.OUTREACHES;
        _this25.visiblePermissions = [Permission.MESSAGING_OUTREACHES];
        return _this25;
      }

      return OutreachesTabChecker;
    }(TabPermissionChecker);

    var StatisticsTabChecker = function (_TabPermissionChecker18) {
      _inherits(StatisticsTabChecker, _TabPermissionChecker18);

      function StatisticsTabChecker() {
        _classCallCheck(this, StatisticsTabChecker);

        var _this26 = _possibleConstructorReturn(this, (StatisticsTabChecker.__proto__ || Object.getPrototypeOf(StatisticsTabChecker)).call(this));

        _this26.id = TabId.STATISTICS;
        _this26.visiblePermissions = [Permission.MESSAGING_STATISTICS];
        return _this26;
      }

      return StatisticsTabChecker;
    }(TabPermissionChecker);

    var TabPermissionManager = function () {
      /*
       * TODO: Make this singleton!
       */
      function TabPermissionManager() {
        _classCallCheck(this, TabPermissionManager);

        this.tab_map = {};
        this.tab_map[TabId.TEMPLATES] = new TemplatesTabChecker();
        this.tab_map[TabId.SURVEY] = new SurveyTabChecker();
        this.tab_map[TabId.SETTINGS] = new SettingsTabChecker();
        this.tab_map[TabId.INBOX] = new InboxTabChecker();
        this.tab_map[TabId.DASHBOARD] = new DashboardTabChecker();
        this.tab_map[TabId.SOCIAL] = new SocialTabChecker();
        this.tab_map[TabId.PORTFOLIO] = new PortfolioTabChecker();
        this.tab_map[TabId.COMPETITORS] = new CompetitorsTabChecker();
        this.tab_map[TabId.GOALS] = new GoalsTabChecker();
        this.tab_map[TabId.TASKS] = new TasksTabChecker();
        this.tab_map[TabId.HOTEL] = new HotelsTabChecker();
        this.tab_map[TabId.USERS] = new UsersTabChecker();
        this.tab_map[TabId.SURVEYS] = new SurveysTabChecker();
        this.tab_map[TabId.NEW_USERS] = new NewUsersTabChecker();
        this.tab_map[TabId.WIDGETS] = new WidgetsTabChecker();
        this.tab_map[TabId.INTEGRATIONS] = new IntegrationsTabChecker();
        this.tab_map[TabId.OUTREACHES] = new OutreachesTabChecker();
        this.tab_map[TabId.STATISTICS] = new StatisticsTabChecker();
      }

      _createClass(TabPermissionManager, [{
        key: 'status',
        value: function status(tabId) {
          return this.tab_map[tabId].status();
        }
      }, {
        key: 'isVisible',
        value: function isVisible(tabId) {
          return this.tab_map[tabId].isVisible();
        }
      }, {
        key: 'isHidden',
        value: function isHidden(tabId) {
          return this.tab_map[tabId].isHidden();
        }
      }, {
        key: 'isLocked',
        value: function isLocked(tabId) {
          return this.tab_map[tabId].isLocked();
        }
      }, {
        key: 'isOnTrial',
        value: function isOnTrial(tabId) {
          return this.tab_map[tabId].isOnTrial();
        }
      }, {
        key: 'isExpired',
        value: function isExpired(tabId) {
          return this.tab_map[tabId].isExpired();
        }
      }]);

      return TabPermissionManager;
    }();

    return {
      ModulePermissionManager: ModulePermissionManager,
      TabPermissionManager: TabPermissionManager,
      Permission: Permission,
      ModuleId: ModuleId,
      ModuleStatus: ModuleStatus,
      TabId: TabId,
      TabStatus: TabStatus
    };
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  define('commons/public/js/product_service',[], function () {
    var PRODUCTS = {
      analytics: ['analytics', 'portfolio'],
      survey: ['survey', '!stars', '!survey_lite'],
      survey_stars_view: ['stars'],
      survey_lite: ['survey_lite'],
      messaging: ['messaging', 'messaging_employee', 'messaging_admin', 'messaging_integrations', 'messaging_outreaches', 'messaging_statistics'],
      marketing: ['marketing'],
      marketing_lite: ['marketing_lite'],
      operations: ['operations']
    };

    var ProductService = function () {
      function ProductService() {
        _classCallCheck(this, ProductService);
      }

      _createClass(ProductService, null, [{
        key: 'hasProduct',
        value: function hasProduct(product, session) {
          var permissionsByProduct = PRODUCTS[product];

          var atLeastOnePermission = false;
          var noNegativePermission = true;

          permissionsByProduct.forEach(function (productPermission) {
            var negatePermission = false;
            if (productPermission[0] === '!') {
              negatePermission = true;
            }

            if (!negatePermission && session.permissions.indexOf(productPermission) !== -1) {
              atLeastOnePermission = true;
            }

            if (negatePermission && session.permissions.indexOf(productPermission.slice(1)) !== -1) {
              noNegativePermission = false;
            }
          });

          return atLeastOnePermission && noNegativePermission;
        }
      }, {
        key: 'getProductsList',
        value: function getProductsList(session) {
          var productsList = [];

          Object.keys(PRODUCTS).forEach(function (product) {
            if (ProductService.hasProduct(product, session)) {
              productsList.push(product);
            }
          });

          return productsList;
        }
      }]);

      return ProductService;
    }();

    return ProductService;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  define('commons/public/js/permissions/permissions-repository',[], function () {
    var PermissionsRepository = function () {
      function PermissionsRepository(session) {
        _classCallCheck(this, PermissionsRepository);

        this.session = session;
      }

      _createClass(PermissionsRepository, [{
        key: 'enabled',
        value: function enabled(permissionName) {
          return this.session.has(permissionName);
        }
      }, {
        key: 'disabled',
        value: function disabled(permissionName) {
          return !this.enabled(permissionName);
        }
      }]);

      return PermissionsRepository;
    }();

    return PermissionsRepository;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  'use strict';

  define('commons/public/js/permissions/settings',['./permissions-repository'], function (PermissionsRepository) {
    var SettingsPermissions = function (_PermissionsRepositor) {
      _inherits(SettingsPermissions, _PermissionsRepositor);

      function SettingsPermissions() {
        _classCallCheck(this, SettingsPermissions);

        return _possibleConstructorReturn(this, (SettingsPermissions.__proto__ || Object.getPrototypeOf(SettingsPermissions)).apply(this, arguments));
      }

      _createClass(SettingsPermissions, [{
        key: 'canEditSettingsSection',

        /*
        Permission enables (makes them visible) all sections in users settings
        except the ones that have their specific enabling permissions (see below).
        The idea of the catch all permission with exceptions defined by section
        specific permission is to make it possible to introduce new sections
        without a need of introducing permissions in each and every case.
        Permission will be granted to all basic roles except MEB.
        (described by Jacek Mech in the Messaging Enterprise - New Permissions document)
        */
        value: function canEditSettingsSection() {
          return this.enabled('user_settings_section');
        }

        /*
        Permission enables (makes it visible) user profile section in users settings.
        Permission will be granted to all basic roles including MEB.
        (described by Jacek Mech in the Messaging Enterprise - New Permissions document)
        */

      }, {
        key: 'canEditUserProfile',
        value: function canEditUserProfile() {
          return this.enabled('user_settings_profile_section');
        }
      }, {
        key: 'canEditAlerts',
        value: function canEditAlerts() {
          return this.enabled('alert_settings');
        }
      }, {
        key: 'canEditSocial',
        value: function canEditSocial() {
          return this.enabled('social');
        }
      }, {
        key: 'canViewResponseTemplates',
        value: function canViewResponseTemplates() {
          /* There is no specific permission to control visibility of response templates
           therefore we use the 'user_settings_section' catch all permission as per the spec
           */
          return this.canEditSettingsSection();
        }
      }, {
        key: 'canEditResponseTemplates',
        value: function canEditResponseTemplates() {
          return this.canViewResponseTemplates() && this.disabled('disable_manage_response_templates');
        }
      }, {
        key: 'canEditSurveyAlerts',
        value: function canEditSurveyAlerts() {
          /* There is no specific permission to control visibility of survey alerts section
           therefore we use the 'user_settings_section' catch all permission as per the spec
           */
          return this.canEditSettingsSection() && this.enabled('survey') && this.disabled('disable_manage_surveys');
        }
      }, {
        key: 'canManageIntegrations',
        value: function canManageIntegrations() {
          return this.enabled('manage_integrations') && this.disabled('portfolio');
        }
      }, {
        key: 'canManageDirectResponses',
        value: function canManageDirectResponses() {
          /*
          Allowed to single-property users, best way to detect it, no portfolio permission.
           */
          return this.disabled('portfolio');
        }
      }]);

      return SettingsPermissions;
    }(PermissionsRepository);

    return SettingsPermissions;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  'use strict';

  define('commons/public/js/permissions/users',['./permissions-repository'], function (PermissionsRepository) {
    var UsersPermissions = function (_PermissionsRepositor) {
      _inherits(UsersPermissions, _PermissionsRepositor);

      function UsersPermissions() {
        _classCallCheck(this, UsersPermissions);

        return _possibleConstructorReturn(this, (UsersPermissions.__proto__ || Object.getPrototypeOf(UsersPermissions)).apply(this, arguments));
      }

      _createClass(UsersPermissions, [{
        key: 'canUseMessagingAPIs',

        /**
         * Check if the user can use messaging APIs
         * @returns boolean: messaging access of the user
         */
        value: function canUseMessagingAPIs() {
          return this.enabled('messaging');
        }
      }]);

      return UsersPermissions;
    }(PermissionsRepository);

    return UsersPermissions;
  });
})();
define('commons/public/jadec/ui_components/sidebar-module',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var locked = module.status() === MODULE_STATUS_VALUES.LOCKED
var trialled = module.status() === MODULE_STATUS_VALUES.TRIALLED
var lite = module.isLite()
var type = module.id
var open = module.opened
var icon = "ty-icon-" + module.iconClass
var classLocked = ""
var classTrialled = ""
var classOpen = ""
var trialBadgeInfo = {color: "", label: ""}
if ( locked == true)
{
var classLocked = "is-locked"
}
if ( trialled == true)
{
var classLocked = "is-trial"
var trialBadgeInfo = module.trialBadgeInfo()
}
if ( open == true)
{
var classOpen = "is-open"
}
buf.push("<style type=\"text/css\">.module-badge {\n    font-size: 9px;\n    border-radius: 20px;\n    margin-right: -14px;\n}\n</style>");
if ( module.status() != MODULE_STATUS_VALUES.HIDDEN)
{
buf.push("<li" + (jade.attrs({ 'id':("" + (module.id) + ""), "class": (classOpen + classLocked + classTrialled) }, {"class":true,"id":true})) + ">");
if ( locked == true)
{
buf.push("<a" + (jade.attrs({ 'href':("#" + type + "-teaser"), "class": ('waves-effect') + ' ' + ('sidebar-module') }, {"href":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (icon) }, {"class":true})) + "></i>" + (jade.escape((jade.interp = module.name()) == null ? '' : jade.interp)) + "<span" + (jade.attrs({ 'data-tooltip':("right"), 'title':("" + (module.labels.upgrade_to_unlock) + ""), "class": ('trustyou-ui') + ' ' + ('badge') + ' ' + ('badge-round') + ' ' + ('badge-inverted') + ' ' + ('is-disabled') }, {"data-tooltip":true,"title":true})) + "><i class=\"ty-icon ty-icon-lock\"></i></span></a>");
}
else if ( trialled == true)
{
buf.push("<a data-toggle=\"module\" class=\"waves-effect sidebar-module\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (icon) }, {"class":true})) + "></i>" + (jade.escape((jade.interp = module.name()) == null ? '' : jade.interp)) + "<span" + (jade.attrs({ 'data-tooltip':("right"), 'title':("" + (trialBadgeInfo.label) + ""), "class": ('trustyou-ui') + ' ' + ('badge') + ' ' + ('badge-round') + ' ' + ("badge-" + (trialBadgeInfo.color) + "") }, {"class":true,"data-tooltip":true,"title":true})) + "><i class=\"ty-icon ty-icon-clock\"></i></span></a>");
}
else if ( lite == true)
{
buf.push("<a data-toggle=\"module\" class=\"waves-effect sidebar-module\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (icon) }, {"class":true})) + "></i>" + (jade.escape((jade.interp = module.name()) == null ? '' : jade.interp)) + "<span class=\"trustyou-ui badge badge-neutral\">" + (jade.escape((jade.interp = module.labels.lite) == null ? '' : jade.interp)) + "</span></a>");
}
else
{
buf.push("<a data-toggle=\"module\" class=\"waves-effect sidebar-module\"><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + (icon) }, {"class":true})) + "></i>" + (jade.escape((jade.interp = module.name()) == null ? '' : jade.interp)) + "");
if ( module.isNew())
{
buf.push("<span class=\"trustyou-ui badge badge-inverted module-badge\">" + (jade.escape((jade.interp = module.labels.beta) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a>");
}
buf.push("<ul id=\"tabsList\" class=\"nav-secondary\"></ul></li>");
}
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/sidebar-tab',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
if ( tab.isSelected())
{
var classIsSelected = "is-default"
}
else
{
var classIsSelected = ""
}
if ( tab.status() != TAB_STATUS_VALUES.HIDDEN)
{
buf.push("<li" + (jade.attrs({ 'id':("" + (tab.id) + "_tab_item"), "class": (classIsSelected) }, {"class":true,"id":true})) + "><a" + (jade.attrs({ 'href':("#" + (tab.hash) + ""), 'data-toggle':("tab"), 'data-title':("" + (tab.name()) + ""), 'data-icon':("" + (tab.iconClass) + "") }, {"href":true,"data-toggle":true,"data-title":true,"data-icon":true})) + "><i" + (jade.attrs({ "class": ('ty-icon') + ' ' + ("ty-icon-" + (tab.iconClass) + "") }, {"class":true})) + "></i>" + (jade.escape((jade.interp = tab.name()) == null ? '' : jade.interp)) + "");
if ( tab.isNew())
{
buf.push("<span class=\"trustyou-ui badge badge-positive\">" + (jade.escape((jade.interp = tab.labels.new) == null ? '' : jade.interp)) + "</span>");
}
buf.push("</a></li>");
}
}
return buf.join("");
};

});

define('commons/public/jadec/ui_components/email-input',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui email-input\"><div" + (jade.attrs({ "class": ('email-editor') + ' ' + (multiline ? null : 'single-line') }, {"class":true})) + "><textarea class=\"email-editor-box\"></textarea></div></div>");
}
return buf.join("");
};

});

/*
 * Input field for emails with validation
 */
(function () {
  'use strict';

  define('commons/public/js/ui_components/email-input',['jquery', 'widget', 'email-input-template', 'textext-tags'], function ($, widget, template) {
    $.widget('ty.emailInput', widget, {
      options: {
        emails: [],
        multiline: true,
        onChange: function () {
          return null;
        }
      },
      emailList: [],
      _init: function () {
        var $element = this.element,
            options = this.options,
            self = this;

        this.emailList = this.options.emails || [];

        var content = template(options);
        $element.empty().append($(content));

        var validateEmail = function (email) {
          var re = new RegExp(['^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@', '((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|', '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'].join(''));

          return re.test(email);
        };

        var stringToItem = function (str) {
          var emailList = str.match(/[^,\n\t ]+/g);
          if (emailList && emailList.length > 0) {
            return emailList;
          }
          return [];
        };

        var isTagAllowed = function (e, data) {
          if (!data || !data.tag) {
            return;
          }
          data.tag = Array.from(data.tag);
          data.tag.forEach(function (tag) {
            if (!validateEmail(tag)) {
              data.result = false;
            }
          });
        };

        var customValidate = function (emailContainer) {
          var tags = $(emailContainer).data('textext').tags();
          var core = tags.core();
          var tagList = stringToItem(tags.val());
          var data = {
            result: true,
            tag: tagList
          };

          isTagAllowed(null, data);

          if (data && data.result) {
            data.tag.forEach(function (tag) {
              tags.containerElement().append(tags.renderTag(tag));
            });
          }

          tags.updateFormCache();
          core.getFormData();
          core.invalidateBounds();

          tags.val('');

          self.options.onChange(self.emails());
        };

        $element.find('textarea').textext({
          plugins: 'tags',
          tagsItems: this.emailList,
          ext: {
            itemManager: {
              stringToItem: stringToItem
            }
          }
        }).bind('isTagAllowed', isTagAllowed).bind('paste', function () {
          setTimeout(customValidate.bind(null, this), 50);
        }).keypress(function (e) {
          if (e.which === 32 || e.which === 44) {
            customValidate(this);
            e.preventDefault();
          }
        }).focusout(function () {
          customValidate(this);
        }).focus(function () {
          $(this).data('textext').invalidateBounds();
        });
      },

      emails: function (argument) {
        var elements = this.element.find('textarea').textext()[0].tags().tagElements();
        this.emailList = Array.from(elements).map(function (elem) {
          return elem.innerText;
        });
        return this.emailList;
      }

    });

    return $.ty.emailInput;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  define('commons/public/js/ui_components/add-tile-button',['jquery', 'ty-i18n!tyra-5'], function ($, i18n) {
    var AddTileButton = function () {
      function AddTileButton(onClick) {
        _classCallCheck(this, AddTileButton);

        this.onClick = onClick;
      }

      _createClass(AddTileButton, [{
        key: 'iconParams',
        get: function () {
          var _this = this;

          return {
            app: 'tyra-5',
            tile: 'AddTileButton',
            renderer: function (data, header, content, footer) {
              var tile = $(content).parents('.module-icon');
              tile.attr('data-tile', '{}').attr('data-module', '{}');
              var $tileBody = $('<div class="tile-body">\n\t\t\t\t\t\t\t\t<i class="ty-icon ty-icon-plus"></i>\n\t\t\t\t\t\t\t\t<span>' + i18n.addTile + '</span>\n\t\t\t\t\t\t\t</div>');
              tile.empty().append($tileBody);
              tile.click(_this.onClick);
              return $.Deferred().resolve();
            },
            closeable: false,
            moveable: false,
            nonExpandable: true,
            classes: 'trustyou-ui tile tile-blank'
          };
        }

        /* eslint-disable class-methods-use-this */

      }, {
        key: 'detailsParams',
        get: function () {
          return {};
        }
        /* eslint-enable class-methods-use-this */

      }]);

      return AddTileButton;
    }();

    return AddTileButton;
  });
})();
/**
 * Publisher-subscriber implementation.
 * Pub-sub pattern allows different parts of the system to communicate
 * without unnecessary coupling.
 * Publisher and subscribers are unaware of each other.
 * Convention for naming channels is '${tab-name}/event-name'.
 * $.Topic registers itself globally, no need to require() it.
 * It's available whenever commons bundle is loaded by browser.
 *
 * Important: message published before creating subscriber wouldn't be delivered.
 *
 * Example:
 * // publish in the channel
 * $.Topic('social/tilesLoaded').publish(someData);
 *
 * // subscribe for the channel
 * $.Topic('social/tilesLoaded').subscribe((someData) => console.log('New event in the channel'));
 */
(function ($) {
  'use strict';

  var eventTopics = {};

  $.Topic = function (id) {
    var topic = id && eventTopics[id];
    if (!topic) {
      var callbacks = $.Callbacks();
      topic = {
        publish: callbacks.fire,
        subscribe: callbacks.add,
        unsubscribe: callbacks.remove
      };
      if (id) {
        eventTopics[id] = topic;
      }
    }
    return topic;
  };
})(window.$);
define("commons/public/js/old_components/topic", function(){});

(function () {
  'use strict';

  define('commons/public/js/old_components/_facebook_rplugin',{
    load: function (resource, parentRequire, load, config) {
      if (config.isBuild) {
        load();
        return;
      }

      var sdkError = function (requireErr) {
        var error = new Error('optional dependency failed');
        error.requireErr = requireErr;
        return error;
      };

      // in case of failure, don't signal an error so we can still use the sdk as a dependency
      // the client will have to check the returned object to determine if an error occurred
      parentRequire(['./../config', '_facebook_external'],

      // success
      function (conf, FB) {
        if (FB && typeof FB.init === 'function') {
          FB.init({
            appId: conf.social.facebook_app_id,
            status: true,
            xfbml: false,
            version: conf.social.facebook_api_version
          });
          load(FB);
        } else {
          load(sdkError(null));
        }
      },

      // error
      function (err) {
        load(sdkError(err));
      });
    }
  });
})();

(function () {
  'use strict';

  define('commons/public/js/old_components/facebook-sdk',['./_facebook_rplugin!'], function (FB) {
    return FB;
  });
})();
define('commons/public/jadec/old_components/facebook-dialog',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui notification notification-positive\"></div><div class=\"trustyou-ui notification notification-negative\"></div><div class=\"fb-page\"><span>" + (jade.escape((jade.interp = facebook_dialog_share_as) == null ? '' : jade.interp)) + ":</span><div class=\"fb-target-container\"></div></div><textarea" + (jade.attrs({ 'id':("fb-message"), 'placeholder':(say_something), 'rows':("3"), "class": ('fb-message') }, {"id":true,"placeholder":true,"rows":true})) + ">" + (jade.escape((jade.interp = message) == null ? '' : jade.interp)) + "</textarea><div class=\"fb-section\"><button id=\"fb-auth\" class=\"trustyou-ui btn l-left\">" + (jade.escape((jade.interp = login) == null ? '' : jade.interp)) + "</button><button id=\"fb-share\" class=\"trustyou-ui btn btn-primary l-right\">" + (jade.escape((jade.interp = share) == null ? '' : jade.interp)) + "</button><button id=\"fb-cancel\" class=\"trustyou-ui btn l-right\">" + (jade.escape((jade.interp = cancel) == null ? '' : jade.interp)) + "</button></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/old_components/facebook-dialog',['jquery', './../utils', 'ty-i18n!analytics_js_4x', 'ty-i18n!tyra-5', 'facebook-sdk', './../../jadec/old_components/facebook-dialog', 'dropdownsmartlist-template', 'modal', 'jquery-ui', 'jquery-truncate', 'dropdownsmartlist'], function ($, utils, i18n, tyra5I18n, FB, shareToFacebookTemplate, ddSmartList) {
    if ($.fn.FacebookDialog) {
      throw new Error('FacebookDialog plugin is already defined');
    }

    $.fn.FacebookDialog = function () {
      // Attach API
      return $.extend(this, $.fn.FacebookDialog.API);
    };

    var defaults = {
      message: null,
      labels: {
        cancel: i18n.common_cancel,
        login: i18n.common_login,
        logout: i18n.common_logout,
        share: i18n.common_share,
        saySomething: tyra5I18n.say_something,
        error: tyra5I18n.facebook_error
      },

      dataprovider: function () {
        return $.Deferred().resolve();
      },

      renderer: function () {
        var self = this,
            facebookDialogData = self._facebookDialogData(),
            params = facebookDialogData.params,
            handleLogin = function (response) {
          self.updateUI(response);
        },
            $content = $('<div class="content"></div>');

        $content.append($(shareToFacebookTemplate({
          message: params.message,
          cancel: params.labels.cancel,
          login: params.labels.login,
          share: params.labels.share,
          say_something: params.labels.saySomething,
          descriptionLabel: tyra5I18n.description,
          facebook_dialog_share_as: i18n.facebook_dialog_share_as
        })));

        $(self).modal({
          title: i18n.facebook_dialog_title,
          content: $content,
          onClosed: function () {
            $('#fancybox-content').removeClass('facebook-dialog-wrapper');
            FB.Event.unsubscribe('auth.statusChange', handleLogin);
          }
        });

        $(self).on('click', '#fb-cancel', $.fancybox.close);
        $(self).on('click', '#fb-share', self.share.bind(self));
        $('#fancybox-content').addClass('facebook-dialog-wrapper');

        // run once with current status and whenever the status changes
        FB.getLoginStatus(handleLogin);
        FB.Event.subscribe('auth.statusChange', handleLogin);

        return $.Deferred().resolve();
      },

      rendered: $.noop,
      error: $.noop
    };

    $.fn.FacebookDialog.API = {
      init: function (params) {
        params = $.extend(true, {}, defaults, params);

        this.addClass('trustyou-ui facebook-dialog').html('<div class="ty-loading"></div><div class="content"></div>')._facebookDialogData({ params: params });
        this.refresh();

        return this;
      },
      login: function (response, info, accounts) {
        var self = this,
            facebookDialogData = self._facebookDialogData(),
            params = facebookDialogData.params,
            content = self.content(),
            authButton = content.find('#fb-auth'),
            shareButton = content.find('#fb-share'),
            shareTarget = content.find('.fb-target-container'),
            items = [];

        if (!info.error && !accounts.error) {
          if (response.authResponse) {
            self._toggleLoading(false);

            shareTarget.empty();

            shareButton.removeClass('is-disabled');
            authButton.text(params.labels.logout);

            items.push({
              label: info.name,
              selected: true,
              value: info.id + '::' + response.authResponse.accessToken
            });

            if (accounts && accounts.data && accounts.data.length > 0) {
              $.each(accounts.data, function (_, account) {
                items.push({
                  label: account.name,
                  selected: false,
                  value: account.id + '::' + account.access_token
                });
              });
            }

            shareTarget.append($(ddSmartList({
              items: items,
              selectAll: false,
              search: false
            })).attr('id', 'fb-target').dropdownsmartlist({
              multiple: false
            }));

            shareTarget.show();

            authButton.unbind('click').click(function () {
              FB.logout(function (resp) {
                self.logout(resp);
              });
            });
          }
        } else {
          self._toggleLoading(false);

          self.showError(tyra5I18n.facebook_connection_error);
        }
      },
      logout: function (response) {
        var self = this,
            facebookDialogData = self._facebookDialogData(),
            params = facebookDialogData.params,
            content = self.content(),
            authButton = content.find('#fb-auth'),
            shareButton = content.find('#fb-share'),
            shareTarget = content.find('.fb-target-container');

        // cleanup actions after logout (ex. hide loading, etc)
        authButton.text(params.labels.login);

        shareButton.addClass('is-disabled');
        shareTarget.hide();

        shareTarget.empty();

        authButton.unbind('click').click(function () {
          self._toggleLoading(true);
          FB.login(function (resp) {
            if (resp.authResponse) {
              FB.api('/me', function (info) {
                FB.api('/me/accounts', function (accounts) {
                  self.login(resp, info, accounts);
                });
              });
            } else {
              // user cancelled login or did not grant authorization
              self._toggleLoading(false);
            }
          }, { scope: 'user_photos, manage_pages, publish_pages, publish_to_groups' });
        });

        self._toggleLoading(false);
      },
      share: function () {
        var self = this,
            facebookDialogData = self._facebookDialogData(),
            params = facebookDialogData.params,
            content = self.content();

        self._toggleLoading(true);

        var values = content.find('#fb-target').dropdownsmartlist('val').split('::');

        var accessToken = values[1];

        var message = content.find('#fb-message').val();

        FB.api('/me/feed', 'post', {
          access_token: accessToken,
          message: message || undefined
        }, function (resp) {
          self._toggleLoading(false);
          if (!resp || resp.error) {
            self.showError(params.labels.error);
          } else {
            window._gaq.sendEvent('Reviews', 'Share', 'Facebook');
            self.showSuccess();
          }
        });
      },
      showError: function (message) {
        var self = this,
            status = self.content().find('.notification-negative');

        status.empty();
        status.append('<p>' + message + '</p>');
        status.show();
      },
      showSuccess: function () {
        var self = this,
            status = self.content().find('.notification-positive');

        status.empty();
        status.append('<p>' + tyra5I18n.facebook_post_review_success + '</p>');
        status.show();
      },
      updateUI: function (response) {
        var self = this;

        self.content().find('.notification').hide();

        if (response.authResponse) {
          // user is already logged in and connected
          FB.api('/me', function (info) {
            FB.api('/me/accounts', function (accounts) {
              self.login(response, info, accounts);
            });
          });
        } else {
          // user is not connected to your app or logged out
          self.logout(response);
        }
      },
      _facebookDialogData: function (data) {
        var dataAttr = 'facebookDialogInternal';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            facebookDialogData = self._facebookDialogData(),
            params = facebookDialogData.params,
            handleError = function (data) {
          self._toggleLoading(false);
          params.error.call(self, data);
        };

        if (!self._isLoading()) {
          self._toggleLoading(true);

          params.dataprovider.call(self)

          // Success
          .done(function (data) {
            params.renderer.call(self, data)

            // Success
            .done(function () {
              self._toggleLoading(false);

              // Callback
              params.rendered.call(self);
            })

            // Fail
            .fail(handleError);
          })

          // Fail
          .fail(handleError);
        }

        return this;
      },
      _isLoading: function () {
        return !!this._facebookDialogData().loading;
      },
      _toggleLoading: function (loading) {
        var data = this._facebookDialogData(),
            loadingPanel = this.children('.ty-loading'),
            content = this.children('.content');

        data.loading = loading;
        loadingPanel.toggle(loading);
        content.toggle(!loading);
        content.find('#fb-share').toggleClass('is-disabled', loading);

        return this;
      },
      content: function () {
        return this.find('.content');
      }
    };

    return $.fn.FacebookDialog;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This namespace includes the definition of a Tile for the Tyra ecosystem.
 * It includes the abstract classes TileSpec and TileRenderable, extend them to create Tyra compatible Tiles.
 * @namespace ui_utils
 * @memberOf commons
 */
(function () {
  define('UUIDBuilder', [], function () {
    /**
     * This class generates different UUID strings.
     */
    var UUIDBuilder = function () {
      function UUIDBuilder() {
        _classCallCheck(this, UUIDBuilder);
      }

      _createClass(UUIDBuilder, [{
        key: 'uuid4',
        value: function uuid4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise, no-mixed-operators
            return v.toString(16);
          });
        }
      }]);

      return UUIDBuilder;
    }();

    return UUIDBuilder;
  });
})();
define("commons/public/js/ui_utils/uuid", function(){});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace base
 * @memberOf commons
 */
/**
 * @namespace observer
 * @memberOf commons.base
 */
/**
 * @module Observer
 * @memberOf common.base.observer
 */
(function () {
  'use strict';

  define('Observer', ['Subject'], function (Subject) {
    /**
     * Implements the Observer in the Observer Pattern.
     * Every class that has to be notified has to extend this class.
     * @class
     * @memberOf commons.base.observer
     */
    var Observer = function () {
      /**
       * Automatically registers the observer to the subject class.
       */
      function Observer() {
        _classCallCheck(this, Observer);

        // Register this component as observer
        Subject.observe(this);
      }

      /**
       * Notifies the observer of an event.
       * @param {*} event
       */


      _createClass(Observer, [{
        key: 'notify',
        value: function notify(event) {} // eslint-disable-line class-methods-use-this

      }]);

      return Observer;
    }();

    return Observer;
  });
})();
define("commons/public/js/ui_components/base/observer/observer", function(){});

/**
 * Implements the Subject in the Observer pattern
 * @module Subject
 * @memberOf commons.base.observer
 */
define('Subject', [], function () {
  return { // eslint-disable-line object-shorthand
    EVENTS: {
      TAB_OPEN: 'tab_open',
      MODULE_OPEN: 'module_open'
    },

    OBSERVERS: [],

    /**
     * Register an observer for this Subject
     * @param {Observer} observer
     */
    observe: function (observer) {
      this.OBSERVERS.push(observer);
    },


    /**
     * Emits an event to the observers.
     * @param event
     */
    emit: function (event) {
      this.OBSERVERS.forEach(function (observer) {
        observer.notify(event);
      });
    },


    /**
     * Registers a supported event.
     * @param {string} key
     * @param {string} value
     */
    addSupportedEvent: function (key, value) {
      if (this.EVENTS[key] === undefined) {
        this.EVENTS[key] = value;
      } else {
        throw new Error('Event already defined for this subject!');
      }
    },


    /**
     * Registers many supported events.
     * @param {*} eventsMap
     */
    addSupportedEvents: function (eventsMap) {
      for (var property in eventsMap) {
        // eslint-disable-line prefer-const
        if (eventsMap.hasOwnProperty(property)) {
          this.addSupportedEvent(property, eventsMap[property]);
        }
      }
    }
  };
});
define("commons/public/js/ui_components/base/observer/subject", function(){});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @memberOf tilespec
 */
(function () {
		'use strict';

		/**
   * This AMD module contains the TileRenderable class.
   * It exports the TileRenderable class by default
   * @module TileRenderable
   */

		define('commons/public/js/ui_components/tilespec/tileRenderable',['jquery', 'Observer', 'Subject'], function ($, Observer, Subject) {
				/**
     * This class implements an object that could be rendered by TYRA Tile System.
     * This could be either the tile or the tile's detail.
     * Inherit from this class in order to build a TYRA renderable component.
     * @class
     * @memberOf commons.tilespec
     */
				var TileRenderable = function (_Observer) {
						_inherits(TileRenderable, _Observer);

						_createClass(TileRenderable, null, [{
								key: 'init',


								/**
         * Based on this
         * https://esdiscuss.org/topic/es6-iteration-over-object-values#content-1
         * @private
         * @param instance
         * @param params
         */
								value: function init(instance, params) {
										Object.assign(instance, params);
								}

								/**
         * @param {TileAPI} context - The API that is building all tiles in Portfolio, it implements the FactoryMethod pattern
         * @param {*} tyra - Tyra instance, contains urls and other systemwide parameters.
         * @param {*} tileParams - Backward compatible TileRenderable specification.
         * @param {*} params - Contains the external parameters passed to the tile, such as filters, timespans.
         * They depend on the specific Tile impementation
         */

						}]);

						function TileRenderable(context, tyra, tileParams, params) {
								_classCallCheck(this, TileRenderable);

								/**
         * Tyra instance, contains urls and other systemwide parameters.
         * @type {*}
         */
								var _this = _possibleConstructorReturn(this, (TileRenderable.__proto__ || Object.getPrototypeOf(TileRenderable)).call(this));

								_this.tyra = tyra;
								/**
         * The API that is building all tiles in Portfolio, it implements the FactoryMethod pattern
         * @type {TileAPI}
         */
								_this.context = context;
								/**
         * The CSS classes that has to be applied.
         * @type {String[]}
         */
								_this.cssClasses = [];
								/**
         *
         * @type {null}
         */
								_this.template = null;
								_this.showBeforeRender = $.browser.msie;

								/**
         * If true the tile is rendered every time is moved, otherwise is not.
         * @type {boolean}
         */
								_this.reloadOnMove = false;

								/**
         * The tileParams
         * @type {*}
         */
								_this.tileParams = {};

								/**
         * A name for this TileRenderer
         * @type {*}
         */
								_this.name = '';

								/**
         * The UniqueID
         * @type {}
         */
								_this.id = '';

								_this.extendTileParams(context, tyra, tileParams, params);
								TileRenderable.init(_this, params);
								return _this;
						}

						/**
       * This method is called before the expanded flag is toggled (expanded/collapsed)
       * @param tileGrid
       * @param expanded
       */


						_createClass(TileRenderable, [{
								key: 'beforeExpandedToggle',
								value: function beforeExpandedToggle(tileGrid, expanded) {} // eslint-disable-line class-methods-use-this

								/**
         * This method is called when the expanded flag is toggled (expanded/collapsed)
         * @param tileGrid
         * @param expanded
         */

						}, {
								key: 'onExpandedToggle',
								value: function onExpandedToggle(tileGrid, expanded) {} // eslint-disable-line class-methods-use-this

								/**
         * This method is called before destroying the tile.
         * @param tileGrid
         */

						}, {
								key: 'beforeDestroy',
								value: function beforeDestroy(tileGrid) {} // eslint-disable-line class-methods-use-this

								/**
         * This method is called when the tile is destroyed
         * @param {TileAPI} tileGrid
         */

						}, {
								key: 'onDestroy',
								value: function onDestroy(tileGrid) {} // eslint-disable-line class-methods-use-this


								/**
         * Extends params passed from outside.
         * This method is usually called to assign external tileParams passed as arguments to the constructor
         * to internal tileParams property and to ensure that required values are properly set inside it.
         *
         * @param {TileAPI} context - The API that is building all tiles in Portfolio, it implements the FactoryMethod pattern
         * @param {*} tyra - Tyra instance, contains urls and other systemwide parameters.
         * @param {*} tileParams - Backward compatible TileRenderable specification, contains data shared between
         * icon and details.
         * @param {*} params - Specific renderable params, previously known as iconParams or detailParams.
         */

						}, {
								key: 'extendTileParams',
								value: function extendTileParams(context, tyra, tileParams, params) {
										this.tileParams = tileParams;
								}

								/**
         * Retrieves data for the tile.
         * @returns {$.Deferred}
         */

						}, {
								key: 'dataprovider',
								value: function dataprovider() {
										if (this.tileParams.dataprovider === undefined || this.tileParams.dataprovider === null) {
												var deferred = $.Deferred();
												return deferred.resolve(this.tileParams);
										} else {
												return this.tileParams.dataprovider();
										}
								}

								/**
         * Renders the tile.
         * @param {*} data - data returned by dataprovider() method
         * @param {*|jQuery|HTMLElement} header - DOM element which will contain the header
         * @param {*|jQuery|HTMLElement} content - DOM element which will contain the content
         * @returns {$.Deferred}
         */

						}, {
								key: 'renderer',
								value: function renderer(data, header, content) {
										if (this.tileParams.renderer === undefined || this.tileParams.renderer === null) {
												var deferred = $.Deferred();
												return deferred.resolve(this.tileParams);
										} else {
												return this.tileParams.renderer(data, header, content);
										}
								}

								/**
         * Called when the tile is rendered
         * @param {*|jQuery|HTMLElement} content - DOM element which contains the content
         * @returns {$.Deferred}
         */

						}, {
								key: 'rendered',
								value: function rendered(content) {
										if (this.tileParams.rendered === undefined || this.tileParams === null) {
												var deferred = $.Deferred();
												return deferred.resolve(this.tileParams);
										} else {
												return this.tileParams.rendered(content);
										}
								}

								/**
         * Do not override this method. Use onDestroy instead.
         * @private
         * @param {TileAPI} tileGrid
         */

						}, {
								key: 'destroyed',
								value: function destroyed(tileGrid) {
										if (this.tileParams.destroyed) {
												this.tileParams.destroyed(tileGrid);
										}
										this.onDestroy(tileGrid);
								}

								/**
         * Do not override this method. Use onExpandedToggle instead.
         * @private
         * @param {TileAPI} tileGrid
         */

						}, {
								key: 'expandedToggled',
								value: function expandedToggled(tileGrid, expanded) {
										if (this.tileParams.expandedToggled) {
												this.tileParams.expandedToggled(tileGrid, expanded);
										}
										this.onExpandedToggle(tileGrid, expanded);
								}

								/**
         * Allows to set the UUID of the parent Tile,
         * this can be used for filtering events with the Observer/Subject pattern.
         */

						}, {
								key: 'setTileUUID',
								value: function setTileUUID(tileUUID) {
										this.tileUUID = tileUUID;
								}

								/**
         * Implements the notify method from Observer interface. It de-encapsulate the tileEvent built from
         * emitTileRelatedEvent.
         * @param event
         */

						}, {
								key: 'notify',
								value: function notify(event) {
										if (this.tileUUID !== undefined && this.tileUUID !== null && event.tileUUID === this.tileUUID) {
												this.onTileRelatedEvent(event.original);
										}
								}

								/**
         * Handles a Observer event related to the tile this renderable belongs to.
         */

						}, {
								key: 'onTileRelatedEvent',
								value: function onTileRelatedEvent(event) {} // eslint-disable-line class-methods-use-this

								/**
         * Emits an event with a pre-configured tileUUID using Subject.emit, it wraps the original event in a
         * tileEvent as follows
         * ```
         *  {
         *  	tileUUID: '<tileUIID value>',
         *   	original: eventPassedAsParameter
         *  }
         * ```
         * @param event
         */

						}, {
								key: 'emitTileRelatedEvent',
								value: function emitTileRelatedEvent(event) {
										if (event !== undefined && event !== null) {
												var tileEvent = { tileUUID: this.tileUUID, original: event };
												Subject.emit(tileEvent);
										} else {
												throw new Error('A null or undefined event can\'t be dispatched');
										}
								}
						}]);

						return TileRenderable;
				}(Observer);

				return TileRenderable;
		});
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace commons
 */

/**
 * This namespace includes the definition of a Tile for the Tyra ecosystem.
 * It includes the abstract classes TileSpec and TileRenderable, extend them to create Tyra compatible Tiles.
 * @namespace tilespec
 * @memberOf commons
 */
(function () {
  'use strict';

  /**
   * This AMD module contains the TileSpec class.
   * It exports the TileSpec class by default.
   * @module TileSpec
   */

  define('commons/public/js/ui_components/tilespec/tileSpec',['jquery', 'TileRenderable', 'UUIDBuilder'], function ($, TileRenderable, UUIDBuilder) {
    /**
     * This class represents the specification for a Tile, is basically composed by two TileRenderable and accepts
     * all the parameters passed from predefined.js script.
     * @class
     * @memberOf commons.tilespec
     */
    var TileSpec = function () {

      /**
       * @param {TileAPI} context - The API that is building all tiles in Portfolio, it implements the FactoryMethod pattern
       * @param {*} tyra - Tyra instance, contains urls and other systemwide parameters.
       * @param {*} gfParams - Contains the external parameters passed to the tile, such as filters, timespans.
       * They depend on the specific Tile impementation
       * @param {*} iconParams - Backward compatible TileRenderable specification.
       * @param {*} detailsParams - Backward compatible TileRenderable specification.
       */
      function TileSpec(context, tyra, gfParams, iconParams, detailsParams) {
        _classCallCheck(this, TileSpec);

        this.setIconRenderable(new TileRenderable(context, tyra, gfParams, iconParams));
        this.setDetailsRenderable(new TileRenderable(context, tyra, gfParams, detailsParams));
        this.tyra = tyra;
        this.context = context;
        this.tileUUID = new UUIDBuilder().uuid4();
      }

      /**
       * Sets the Icon's TileRenderable object, if is defined and not null it also sets the tileUUID on the
       * TileRenderable.
       * @param tileRenderable
       */


      _createClass(TileSpec, [{
        key: 'setIconRenderable',
        value: function setIconRenderable(tileRenderable) {
          this.iconParams = tileRenderable;
          if (this.iconParams !== undefined && this.iconParams !== null) {
            this.iconParams.setTileUUID(this.tileUUID);
          }
        }

        /**
         * Sets the Detail's TileRenderable object, if is defined and not null it also sets the tileUUID on the
         * TileRenderable.
         * @param tileRenderable
         */

      }, {
        key: 'setDetailsRenderable',
        value: function setDetailsRenderable(tileRenderable) {
          this.detailsParams = tileRenderable;
          if (this.detailsParams !== undefined && this.detailsParams !== null) {
            this.detailsParams.setTileUUID(this.tileUUID);
          }
        }

        /**
         * Checks if the user has the authorization to show the tile using session.
         * @param {Session} session - The session object for the current user
         * @returns {boolean} - True if the user is allowed, false otherwise.
         */

      }], [{
        key: 'hasAuth',
        value: function hasAuth(session, tyra) {
          return true;
        }

        /**
         * Returns the name of this class.
         * @returns {string} - the name of this class. Ovverride it for every concrete class.
         */

      }, {
        key: 'getName',
        value: function getName() {
          return 'TileSpec';
        }

        /**
         * Makes the tileSpect compatible with $.extend() function.
         * $.extend only extends ownProperties.
         * It also sets the tileUUID to children.
         * @param {TileSpec} tileSpec
         * @private
         */

      }, {
        key: 'enforceTileSpec',
        value: function enforceTileSpec(tileSpec) {
          var enforceMethod = function (instance, methodName) {
            var method = instance[methodName];
            if (method !== undefined && method !== null) {
              instance[methodName] = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                return method.apply(instance, args);
              };
            } else {
              instance[methodName] = null;
            }
          };

          ['destroyed', 'beforeDestroy', 'dataprovider', 'renderer', 'rendered', 'beforeExpandedToggle', 'expandedToggled'].forEach(function (method) {
            [tileSpec.iconParams, tileSpec.detailsParams].forEach(function (instance) {
              enforceMethod(instance, method);
            });
          });

          if (tileSpec.iconParams !== undefined) {
            tileSpec.iconParams.setTileUUID(tileSpec.tileUUID);
          }

          if (tileSpec.detailsParams !== undefined) {
            tileSpec.detailsParams.setTileUUID(tileSpec.tileUUID);
          }
        }
      }]);

      return TileSpec;
    }();

    return TileSpec;
  });
})();
define('commons/public/jadec/tyra-5/topbar',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card card-selected-hotel\"><div class=\"card-header\">");
if ( !hideTopbarLeft)
{
buf.push("<div class=\"topbar-cluster\">");
if ( cluster)
{
var clusterLabel = (cluster.city ? cluster.name + " - " + cluster.city : cluster.name);
buf.push("<h2 class=\"cluster-label\">" + (jade.escape((jade.interp = clusterLabel) == null ? '' : jade.interp)) + "</h2>");
}
buf.push("</div>");
}
buf.push("<ul class=\"actions\"><li class=\"change-time\"></li>");
if ( canChangeCluster)
{
buf.push("<li><a" + (jade.attrs({ 'href':("javascript:void(0)"), 'data-tooltip':("top"), 'title':("" + (labels.changeCluster) + ""), "class": ('change-cluster') }, {"href":true,"data-tooltip":true,"title":true})) + "><i class=\"ty-icon ty-icon-shuffle\"></i></a></li>");
}
if ( !isDefaultCluster)
{
buf.push("<li id=\"dashboard-return-to-default-hotel\"><a" + (jade.attrs({ 'href':("javascript:void(0)"), 'data-tooltip':("top"), 'title':("" + (labels.resetCluster) + ""), "class": ('reset-default') }, {"href":true,"data-tooltip":true,"title":true})) + "><i class=\"ty-icon ty-icon-undo\"></i></a></li>");
}
buf.push("</ul></div></div><div class=\"trustyou-ui notification notification-positive info\"></div><div class=\"trustyou-ui notification notification-negative error\"></div>");
}
return buf.join("");
};

});


(function () {
  'use strict';

  define('commons/public/js/tyra-5/config',['json!/tyra-5/config'], function (config) {
    return config.response;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/utils',['jquery'], function ($) {
    var utils = {
      getUrlParam: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
      },
      doAjax: function () {
        var defaults = {
          dataType: 'json',
          cache: false
        };

        return function (params) {
          var req = $.ajax($.extend({}, defaults, params));

          var promise = req.pipe(

          // Done
          function (data, textStatus, jqXHR) {
            if (data.meta && data.meta.code !== 200) {
              return $.Deferred().reject(data, jqXHR);
            }

            return $.Deferred().resolve(data, jqXHR);
          },

          // Fail
          function (jqXHR) {
            var data = null;

            try {
              data = JSON.parse(jqXHR.responseText);
            } catch (e) {
              // no-op
            }

            return $.Deferred().reject(data, jqXHR);
          });

          promise.jqXHR = req;

          return promise;
        };
      }(),

      normalizeDate: function (date) {
        var dateArr = date.split('-');

        // Add leading zeros to month and day if needed
        if (dateArr[1].length === 1) {
          dateArr[1] = '0' + dateArr[1];
        }
        if (dateArr[2].length === 1) {
          dateArr[2] = '0' + dateArr[2];
        }

        return dateArr.join('-');
      },

      dateToString: function (date) {
        var s = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

        return utils.normalizeDate(s);
      },
      validateUUID: function (uuid) {
        var re = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

        return re.test(uuid);
      },
      createTooltip: function (tooltipText) {
        var icon = $('<span></span>').addClass('ui-icon ui-icon-help widget-header-icon widget-header-icon-help');
        var tooltip = $('<div></div>').addClass('tooltip').html(tooltipText);

        icon.append($('<div></div>').css({ clear: 'both', padding: '0', margin: '0' })).append(tooltip).hover(function () {
          $('.tooltip').hide();
          tooltip.stop(true, true).fadeIn();
        }, function () {
          tooltip.stop(true, true).hide();
        });

        return icon;
      },
      isTileDisabledByConfig: function (config, tileType) {
        var areDisabledTiles = config.feature_flags && config.feature_flags.disabled_tiles !== undefined;
        if (areDisabledTiles) {
          var disabledTiles = config.feature_flags.disabled_tiles;

          return disabledTiles.includes(tileType.toLowerCase());
        }

        return false;
      },
      isFeatureDisabledByConfig: function (config, feature) {
        var areDisabledFeatures = config.feature_flags && config.feature_flags.disabled_features !== undefined;

        if (areDisabledFeatures) {
          var disabledFeatures = config.feature_flags.disabled_features;

          return disabledFeatures.includes(feature);
        }

        return false;
      }
    };

    return utils;
  });
})();
define('commons/public/jadec/tyra-5/common/cluster-selector',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"title\">" + (jade.escape((jade.interp = params.labels.title) == null ? '' : jade.interp)) + "</div><div class=\"description\">" + (jade.escape((jade.interp = params.labels.description) == null ? '' : jade.interp)) + "</div><div class=\"groups left\"><div class=\"title\">" + (jade.escape((jade.interp = params.labels.groups) == null ? '' : jade.interp)) + "</div><div class=\"list\"></div></div><div class=\"clusters left\"><div class=\"title\">" + (jade.escape((jade.interp = params.labels.clusters) == null ? '' : jade.interp)) + "</div><div class=\"list\"></div></div><div class=\"clear\"></div>");
if ( hasMappings)
{
buf.push("<div class=\"search-id right\">" + (jade.escape((jade.interp = params.labels.searchId) == null ? '' : jade.interp)) + "</div>");
}
buf.push("<div class=\"search-prefix right\">" + (jade.escape((jade.interp = params.labels.searchPrefix) == null ? '' : jade.interp)) + "</div><div class=\"save-selected right\">" + (jade.escape((jade.interp = params.labels.saveSelected) == null ? '' : jade.interp)) + "</div><div class=\"clear\"></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/tyra-5/common/cluster-search-dialog',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"title\">" + (jade.escape((jade.interp = labels.title) == null ? '' : jade.interp)) + "</div><div class=\"description\">" + (jade.escape((jade.interp = labels.description) == null ? '' : jade.interp)) + "</div><div class=\"list\"></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/tyra-5/common/cluster-search-dialog',['jquery', 'session', 'ty-i18n!tyra-5', './../../../jadec/tyra-5/common/cluster-search-dialog', 'list'], function ($, session, i18n, searchTmpl) {
    if ($.fn.ClusterSearchDialog) {
      throw new Error('ClusterSearchDialog plugin is already defined');
    }

    $.fn.ClusterSearchDialog = function () {
      return $.extend(this, $.fn.ClusterSearchDialog.API);
    };

    var defaults = {
      minPrefix: 3,
      prefixDelimiter: null,

      dataprovider: function () {
        return $.Deferred().resolve([]);
      },

      /**
       * By default render an empty list at the beginning. Only display items after filtering.
       *
       * @return {$.Deferred}
       */
      renderer: function () {
        var self = this,
            data = self._searchData(),
            params = data.params;

        self.html(searchTmpl(params));

        self.find('.list').List().init({
          prefixDelimiter: params.prefixDelimiter,
          minPrefix: params.minPrefix,
          inMemFilter: false,

          dataprovider: function (prefix) {
            if (prefix && prefix.length) {
              return params.dataprovider.call(self, prefix);
            } else {
              return $.Deferred().resolve([]);
            }
          },

          rendered: function () {
            self.centerPopup();
          },

          toggleSelect: function (item, selected) {
            if (selected) {
              // TODO introduce a 'selected' callback to make this more generic?
              session.setProperty('selected_cluster', item.id);

              $.fancybox.close();
            }
          }
        });

        return $.Deferred().resolve();
      },

      rendered: $.noop,
      error: $.noop,

      labels: {
        title: i18n.change_cluster_title,
        description: null
      }
    };
    $.fn.ClusterSearchDialog.API = {
      /**
       * Initialize the plugin on the current element.
       *
       * @param [params]
       * @return {$.fn.ClusterSearchDialog} this
       */
      init: function (params) {
        var self = this;

        params = $.extend(true, {}, defaults, params);

        self.detach().addClass('cluster-search-dialog').empty()._searchData({
          params: params
        });

        setTimeout(function () {
          $.fancybox({
            padding: 0,
            content: self,
            onComplete: function () {
              self.refresh();
            }
          });
        }, 0);

        return self;
      },


      /**
       * Set or get the plugin data.
       *
       * @param [data] if truthy set the new data object, otherwise retrieve it
       * @return Object the selector data if the parameter is missing, otherwise the return value is not specified
       * @private
       */
      _searchData: function (data) {
        var dataAttr = 'clusterSearchDialog';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },


      /**
       * Refresh the plugin:
       * 1. Call the data provider
       * 2. Call the renderer
       * 3. Call the rendered callback
       *
       * In case of errors call the error callback and interrupt the normal flow.
       *
       * @return {$.fn.ClusterSearchDialog} this
       */
      refresh: function () {
        var self = this,
            searchData = self._searchData(),
            params = searchData.params,
            handleError = function (data) {
          params.error.call(self, data);
        };

        // No dataprovider call here. It will be passed to the List plugin instead
        params.renderer.call(self).done(function () {
          self.centerPopup();

          params.rendered.call(self);
        }).fail(handleError);

        return this;
      },


      /**
       * @return {$.fn.ClusterSearchDialog} this
       */
      centerPopup: function () {
        $.fancybox.resize();
        $.fancybox.center();

        return this;
      }
    };
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/common/cluster-selector',['jquery', './../config', 'session', './../utils', 'ty-i18n!tyra-5', './../../../jadec/tyra-5/common/cluster-selector', 'list', './cluster-search-dialog', 'jquery-ui'], function ($, config, session, utils, i18n, selectorTmpl) {
    if ($.fn.ClusterSelector) {
      throw new Error('ClusterSelector is already defined');
    }

    $.fn.ClusterSelector = function () {
      return $.extend(this, $.fn.ClusterSelector.API);
    };

    var defaults = {
      /**
       * @return {Object} contains 2 fields:
       *     1. groups: the groups of the current user
       *     2. mappings: the custom cluster id mappings of the current user
       */

      saveCallback: function (selected) {
        session.setProperty('selected_cluster', selected.id);
      },
      showSearchCluster: true,
      showSearchById: true,
      dataprovider: function () {
        // Get portfolio groups
        var groupsReq = utils.doAjax({
          url: config.urls.portfolio + 'groups',
          cache: true,
          data: {
            user_id: session.user.id,
            location: 'PORTFOLIO'
          }
        });

        // Get custom cluster id mappings
        var mappingsReq = utils.doAjax({
          url: config.urls.cluster + 'mappings',
          cache: true,
          data: {
            user_id: session.user.id
          }
        });

        return $.when(groupsReq, mappingsReq).pipe(

        // Success
        function (groups, mappings) {
          var groupList = $.map(groups[0].response.group_list, function (group) {
            if (group.count !== 0) {
              return {
                id: group.group_id,
                type: group.type,
                label: $.trim(group.group_name),
                normalizedName: $.trim(group.group_name).toLowerCase()
              };
            }
            return null;
          });

          // Sort by name
          groupList.sort(function (a, b) {
            return a.normalizedName.localeCompare(b.normalizedName);
          });

          return {
            groups: groupList,
            mappings: mappings[0].response.mapping_list
          };
        });
      },

      renderer: function (data) {
        var self = this,
            groups = data.groups,
            params = self._selectorData().params;

        self.content().html(selectorTmpl({
          hasMappings: !!data.mappings.length,
          params: params
        }));

        // Buttons
        self.find('.save-selected').button({
          disabled: true,
          icons: {
            primary: 'ui-icon-arrowthick-1-e'
          }
        }).one('click', function () {
          var selected = self.find('.clusters .list').List().getSelected()[0];
          params.saveCallback.call(self, selected);

          $(this).button('disable');

          $.fancybox.close();
        });

        if (params.showSearchCluster) {
          self.find('.search-prefix').button({
            icons: { primary: 'ui-icon-search' }
          }).one('click', function () {
            $('<div></div>').ClusterSearchDialog().init({
              prefixDelimiter: ' ',
              minPrefix: 3,

              dataprovider: function (prefix) {
                var req = utils.doAjax({
                  url: config.urls.widget5 + 'hotels/search',
                  cache: true,
                  dataType: 'jsonp',
                  data: {
                    prefix: prefix.join(' '),
                    page_size: 100
                  }
                });

                return $.extend(req.pipe(

                // Success
                function (newData) {
                  return $.map(newData.response.cluster_list, function (cluster) {
                    var name = $.trim(cluster.name),
                        city = $.trim(cluster.city);

                    return {
                      id: cluster.cluster_id,
                      name: name,
                      city: city,
                      label: name + ' - ' + city
                    };
                  });
                },

                // Fail
                function (newData, jqXHR) {
                  if (jqXHR.statusText === 'abort') {
                    return $.Deferred().rejectWith('canceled');
                  }

                  if (newData.meta && (newData.meta.code === 400 || newData.meta.code === 404)) {
                    return $.Deferred().resolve([]);
                  }
                  return $.Deferred().resolve();
                }), {
                  cancel: req.jqXHR.abort
                });
              },

              labels: {
                description: i18n.search_cluster_prefix_description
              }
            });
          });
        } else {
          self.find('.search-prefix').hide();
        }

        if (params.showSearchById) {
          self.find('.search-id').button({
            icons: { primary: 'ui-icon-search' }
          }).one('click', function () {
            $('<div></div>').ClusterSearchDialog().init({
              minPrefix: 1,

              dataprovider: function (prefix) {
                var req = utils.doAjax({
                  url: config.urls.cluster + 'mappings/clusters',
                  cache: true,
                  data: {
                    user_id: session.user.id,
                    prefix: prefix[0]
                  }
                });

                return $.extend(req.pipe(

                // Success
                function (newData) {
                  return $.map(newData.response.mapping_list, function (cluster) {
                    var name = $.trim(cluster.cluster_name),
                        city = $.trim(cluster.cluster_city);

                    return {
                      id: cluster.cluster_id,
                      name: name,
                      city: city,
                      label: '{name} - {city} ({id})'.replace('{name}', name).replace('{city}', city).replace('{id}', cluster.external_id)
                    };
                  });
                },

                // Fail
                function (newData, jqXHR) {
                  if (jqXHR.statusText === 'abort') {
                    return $.Deferred().rejectWith('canceled');
                  }
                  return $.Deferred().resolve();
                }), {
                  cancel: req.jqXHR.abort
                });
              },

              labels: {
                description: i18n.search_cluster_id_description
              }
            });
          });
        } else {
          self.find('.search-id').hide();
        }

        // Group list
        self.find('.groups .list').List().init({
          prefixDelimiter: ' ',

          dataprovider: function () {
            return $.Deferred().resolve(groups);
          },

          toggleSelect: function (group, select) {
            // Cluster list
            if (select) {
              self.find('.clusters .list').List().init({
                prefixDelimiter: ' ',

                toggleSelect: function (item, selected) {
                  if (selected) {
                    self.find('.save-selected').button('enable');
                  } else {
                    self.find('.save-selected').button('disable');
                  }
                },

                dataprovider: function () {
                  var clusterReq = void 0;

                  // Get clusters
                  if (group.type === 'CLUSTER') {
                    clusterReq = utils.doAjax({
                      url: config.urls.portfolio + 'groups/clusters',
                      type: 'post',
                      data: JSON.stringify({
                        group_list: [group.id]
                      })
                    }).pipe(

                    // Success
                    function (newData) {
                      return newData.response.results[0].cluster_list;
                    });
                  } else {
                    // type === 'FILTER'

                    // First get the filters
                    clusterReq = utils.doAjax({
                      url: config.urls.portfolio + 'groups/clusters',
                      type: 'post',
                      data: JSON.stringify({
                        group_list: [group.id],
                        include_group_details: false
                      }),
                      cache: true
                    }).pipe(

                    // Success
                    function (newData) {
                      return newData.response.results[0].cluster_list;
                    });
                  }

                  return clusterReq.pipe(function (clusters) {
                    return $.map(clusters, function (cluster) {
                      return {
                        id: cluster.cluster_id,
                        label: $.trim(cluster.cluster_name),
                        normalizedName: $.trim(cluster.cluster_name).toLowerCase()
                      };
                    }).sort(function (a, b) {
                      return (
                        // Sort by name
                        a.normalizedName.localeCompare(b.normalizedName)
                      );
                    });
                  });
                },

                rendered: function () {
                  self.centerPopup();
                }
              });
            } else {
              self.find('.clusters .list').empty();
              self.find('.save-selected').button('disable');
            }
          }
        });

        return $.Deferred().resolve();
      },

      rendered: $.noop,
      error: $.noop,

      labels: {
        title: i18n.change_cluster_title,
        description: i18n.select_cluster_description,
        groups: i18n.select_cluster_groups_title,
        clusters: i18n.select_cluster_clusters_title,
        saveSelected: i18n.select_cluster_save,
        searchPrefix: i18n.select_cluster_search_prefix,
        searchId: i18n.select_cluster_search_id
      }
    };

    $.fn.ClusterSelector.API = {

      /**
       * Initialize the plugin on the current element.
       *
       * @param [params]
       * @return {$.fn.GroupClusterSelector} this
       */
      init: function (params) {
        var self = this;

        params = $.extend(true, {}, defaults, params);

        self.detach().addClass('cluster-selector').html('<div class="trustyou-ui spinner spinner-lg"></div><div class="content"></div>')._selectorData({
          params: params
        });

        setTimeout(function () {
          $.fancybox({
            padding: 0,
            content: self,
            onComplete: function () {
              self.refresh();
            }
          });
        }, 0);

        return self;
      },


      /**
       * Set or get the selector data.
       *
       * @param [data] if truthy set the new data object, otherwise retrieve it
       * @return Object the selector data if the parameter is missing, otherwise the return value is not specified
       * @private
       */
      _selectorData: function (data) {
        var dataAttr = 'selectorData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },


      /**
       * Refresh the selector:
       * 1. Call the data provider
       * 2. Call the renderer
       * 3. Call the rendered callback
       *
       * In case of errors call the error callback and interrupt the normal flow.
       *
       * @return {$.fn.GroupClusterSelector} this
       */
      refresh: function () {
        var self = this,
            selectorData = self._selectorData(),
            params = selectorData.params,
            handleError = function (data) {
          params.error.call(self, data);
        };

        if (!self._isLoading()) {
          self._toggleLoading(true);

          params.dataprovider.call(self).done(function (list) {
            params.renderer.call(self, list).done(function () {
              self._toggleLoading(false);
              self.centerPopup();

              params.rendered.call(self);
            }).fail(handleError);
          }).fail(handleError);
        }

        return this;
      },
      _isLoading: function () {
        return !!this._selectorData().loading;
      },
      _toggleLoading: function (loading) {
        this._selectorData().loading = loading;
        this.children('.spinner').toggle(loading);
        this.children('.content').toggle(!loading);

        return this;
      },


      /**
       * @return jQuery the content element of the plugin. The renderer should only add markup in here.
       */
      content: function () {
        return this.children('.content');
      },


      /**
       * @return {$.fn.GroupClusterSelector} this
       */
      centerPopup: function () {
        $.fancybox.resize();
        $.fancybox.center();

        return this;
      }
    };

    return $.fn.ClusterSelector;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/topbar',['jquery', './../../jadec/tyra-5/topbar', 'session', 'ty-i18n!tyra-5', 'moment', './common/cluster-selector', 'tooltipsy'], function ($, topbar, session, i18n, moment) {
    if ($.fn.TopBar) {
      throw new Error('TopBar plugin is already defined');
    }

    $.fn.TopBar = function () {
      // Attach API
      return $.extend(this, $.fn.TopBar.API);
    };

    var defaults = {
      cluster: session.selectedCluster,
      canChangeCluster: session.has('portfolio'),
      filterAdded: null,
      timeDropdown: true,
      hideTopbarLeft: false,
      saveCallback: undefined,
      resetCallback: function (selected) {
        session.setProperty('selected_cluster', selected);
      },
      showSearchCluster: true,
      showSearchById: true,
      descriptionLabel: undefined,
      labels: {
        changeCluster: i18n.change_hotel,
        resetCluster: i18n.back_to_hotel
      }
    };
    $.fn.TopBar.API = {
      init: function (params) {
        var self = this;
        var currentTime = void 0,
            today = void 0,
            timeLabel = void 0,
            $timeDropdown = void 0;

        params = $.extend(true, {}, defaults, params);

        var templateParams = $.extend(true, {}, params, {
          isDefaultCluster: params.cluster && params.cluster.id === session.defaultCluster.id
        });

        self.addClass('ty-topbar').append(topbar(templateParams))._barData({
          params: params
        });

        if (params.timeDropdown) {
          currentTime = params.timeDropdownParams.time;

          today = moment().format('YYYY-MM-DD');
          timeLabel = '{from} - {to}';

          $timeDropdown = self.find('.change-time');

          // Time dropdown
          $timeDropdown.timedropdown({
            val: currentTime,
            alignment: 'l-right',
            icon: 'ty-icon-calendar',
            iconPosition: 'l-left',
            iconAnimation: false,
            minDate: params.timeDropdownParams.minDate
          }).bind('timedropdownchange', function (event, data) {
            // TODO localize time labels
            if (data.val && data.val.time !== 'custom') {
              var newLabel = timeLabel.replace('{from}', data.val.fromDate || today).replace('{to}', data.val.toDate || today);
              if ($timeDropdown.hasClass('tooltip-init')) {
                if ($timeDropdown.data('tooltipsy')) {
                  $timeDropdown.data('tooltipsy').$tip.html(newLabel);
                }
              } else {
                $timeDropdown.attr('title', newLabel);
                $timeDropdown.tooltipsy({
                  offset: [0, -1],
                  className: 'trustyou-ui tooltip l-top'
                });
                $timeDropdown.addClass('tooltip-init');
              }
            } else if ($timeDropdown.data('tooltipsy')) {
              $timeDropdown.data('tooltipsy').destroy();
              $timeDropdown.removeClass('tooltip-init');
            }

            params.timeDropdownParams.saveTimeToView(data.val);
          });

          // Label
          $timeDropdown.attr('data-tooltip', 'top');
          if (currentTime.time !== 'custom') {
            $timeDropdown.attr('title', timeLabel.replace('{from}', currentTime.fromDate || today).replace('{to}', currentTime.toDate || today));
            if (!$timeDropdown.hasClass('tooltip-init')) {
              $timeDropdown.tooltipsy({
                offset: [0, -1],
                className: 'trustyou-ui tooltip l-top'
              });
            }
            $timeDropdown.addClass('tooltip-init');
          }
        }

        // adding tooltipsy for all elements with data-tooltip attributes
        $(self).find('[data-tooltip]').each(function () {
          var align = $(this).attr('data-tooltip');
          var offset = void 0;

          switch (align) {
            case 'left':
              {
                offset = [-1, 0];
                break;
              }
            case 'top':
              {
                offset = [0, -1];
                break;
              }
            case 'bottom':
              {
                offset = [0, 1];
                break;
              }
            default:
              {
                offset = [1, 0];
              }
          }

          if (!$(this).hasClass('tooltip-init')) {
            $(this).tooltipsy({
              offset: offset,
              className: 'trustyou-ui tooltip l-' + align
            });
          }
          $(this).addClass('tooltip-init');
        });

        // Actions
        self.find('.change-cluster').click(function () {
          $('<div></div>').ClusterSelector().init({
            saveCallback: params.saveCallback,
            showSearchCluster: params.showSearchCluster,
            showSearchById: params.showSearchById,
            labels: params.labels
          });
        });

        self.find('.reset-default').click(function () {
          // track only for single-property users
          if (!session.has('portfolio')) {
            window._gaq.sendEvent('Dashboard', 'HotelSelector', 'DefaultHotel');
          }
          params.resetCallback.call(this, session.defaultCluster.id);
        });

        return self;
      },
      _barData: function (data) {
        var dataAttr = 'ty_topbar';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      addAction: function (filter, position) {
        // if no position is passed or list is empty add action at end of list
        if (position === undefined || position === null || !this.find('.actions li').length) {
          filter.appendTo(this.find('.actions'));
        } else if (position === 0) {
          // if position is zero insert action at beginning of list
          filter.prependTo(this.find('.actions'));
        } else {
          // if position is any number insert action at that position
          var elem = this.find('.actions>:nth-child(' + position + ')');
          if (elem.length) {
            filter.insertBefore(elem);
          } else {
            filter.appendTo(this.find('.actions'));
          }
        }

        var filterAdded = this._barData().params.filterAdded;
        if (filterAdded) {
          filterAdded.call(this, filter);
        }
      },
      _notify: function (panel, notification, fadeIn, fadeOut, timeout) {
        var data = this._barData();

        fadeIn = fadeIn || 0;
        fadeOut = fadeOut || 0;

        var clearScheduled = function () {
          if (data.scheduled) {
            clearTimeout(data.scheduled);
            data.scheduled = null;
          }
        };

        var hide = function (newFadeOut) {
          var duration = typeof newFadeOut === 'number' ? newFadeOut : fadeOut;

          panel.stop().fadeOut(duration, 'easeInQuint');
        };

        panel.off('hover');
        clearScheduled();

        panel.empty().append(notification).stop().fadeIn(fadeIn, function () {
          // Notification fading
          if (timeout) {
            panel.hover(

            // in
            function () {
              clearScheduled();

              panel.stop().css({
                display: 'block',
                opacity: '1'
              });
            },

            // out
            function () {
              if (!data.scheduled) {
                data.scheduled = setTimeout(function () {
                  hide();
                }, timeout);
              }
            });
          }
        });

        // Rebind
        panel.off('click').click(function () {
          hide();
        });

        // Return a controller for the notification
        return {
          hide: hide
        };
      },
      notifyInfo: function (notification, fadeIn, fadeOut, timeout) {
        var panel = this.find('.info');

        return this._notify(panel, notification, fadeIn, fadeOut, timeout);
      },
      notifyError: function (notification, fadeIn, fadeOut, timeout) {
        var panel = this.find('.error');

        return this._notify(panel, notification, fadeIn, fadeOut, timeout);
      }
    };

    return $.fn.TopBar;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/init-slidepane',['require', 'jquery', './config', './utils', 'session', 'export-pane'], function (require, $, config, utils, session, exportPane) {
    var exportViewType = 'EXPORT_PANE';

    return function ($triggerElement) {
      if (!session.has('export')) {
        return;
      }

      // Try to get the export view
      utils.doAjax({
        url: '/tyra-5/view/',
        data: { type: exportViewType }
      }).pipe(

      // success
      function (data) {
        return data.response[0];
      },

      // fail
      function (data) {
        // It's ok if nothing was found
        if (data && data.meta && data.meta.code === 404) {
          return $.Deferred().resolve(null);
        }
        return $.Deferred().resolve(null);
      }).done(function (view) {
        var parameters = void 0,
            updateCall = void 0;

        parameters = view && view.parameters ? JSON.parse(view.parameters) : {};

        // The last update call for this view
        updateCall = $.Deferred().resolve();

        /**
         * Updates the parameters of the export view.
         *
         * @param viewParameters
         * @return {$.Deferred} the Ajax call
         */
        var updateParameters = function (viewParameters) {
          var requestType = void 0;

          if (!view) {
            // create
            view = {
              type: exportViewType,
              page_id: null,
              index: 0,
              parameters: null,
              filter: null
            };

            requestType = 'post';
          } else {
            // update
            requestType = 'put';
          }

          parameters = viewParameters;
          view.parameters = viewParameters ? JSON.stringify(viewParameters) : null;

          // Make the call
          return utils.doAjax({
            url: '/tyra-5/view/' + (view.id || ''),
            data: {
              view: JSON.stringify(view)
            },
            type: requestType
          }).done(function (data) {
            // Keep the variable in sync
            view = data.response;
          });
        };

        // Before initializing any plugins bind event handlers. This way we don't risk missing events.
        exportPane.on('init.' + $.fn.ExportEditor.API.cssMarker, '.' + $.fn.ExportEditor.API.cssMarker, function () {
          // This event is fired once after the export editor is initialized

          // Populate the editor with the last report, if any
          if (parameters.last_report) {
            $(this).ExportEditor().edit(parameters.last_report);
          }

          // Save the new report state every 5 seconds
          // TODO this should be done in a smarter way, only when we detect change events

          // Use a closure to encapsulate some state
          (function () {
            var previousState = void 0;

            // Keep the last report's string representation for future comparisons
            previousState = parameters.last_report ? JSON.stringify(parameters.last_report) : null;

            setInterval(function () {
              if (updateCall.state() === 'pending') {
                // Don't do anything if there's a running call
                return;
              }

              var report = exportPane.getEditor().getReport();
              var reportString = report ? JSON.stringify(report) : null;

              // If the report state changed, persist it.
              // Comparing the string representations is enough in this case
              if (reportString !== previousState) {
                parameters.last_report = report;
                updateCall = updateParameters(parameters);

                previousState = reportString;
              }
            }, 5000);
          })();
        });

        exportPane.init({
          borderElement: $($triggerElement),

          getExportModule: function (report, newParameters) {
            var deferred = $.Deferred();

            // TODO add other apps here
            switch (newParameters.app) {
              case 'portfolio':
                {
                  // TODO we need to load the rest of the app code because of the CSS dependencies.
                  require(['portfolio-app'], function () {
                    require(['portfolio-app-export'], function (getModule) {
                      deferred.resolve(getModule($('<div></div>'), $('<div></div>'), newParameters, exportPane));
                    }, deferred.reject);
                  });
                  break;
                }
              case 'dashboard':
                {
                  require(['dashboard-agg'], function () {
                    require(['dashboard-app-export', 'dashboard-predefined'], function (getModule) {
                      getModule($('<div></div>'), newParameters).done(deferred.resolve).fail(deferred.reject);
                    }, deferred.reject);
                  });
                  break;
                }
              case 'social':
                {
                  require(['social-app-export', 'social-plugins'], function (getModule) {
                    getModule($('<div></div>'), newParameters).done(deferred.resolve).fail(deferred.reject);
                  }, deferred.reject);
                  break;
                }
              case 'survey':
                {
                  require(['survey-app-export'], function (createModule) {
                    var module = createModule($('<div></div>'), newParameters, true);
                    deferred.resolve(module);
                  }, deferred.reject);
                  break;
                }
              case 'review':
                {
                  require(['review-plugins'], function () {
                    require(['review-app-export'], function (createModule) {
                      var module = createModule($('<div></div>'), null, newParameters, true);
                      deferred.resolve(module);
                    }, deferred.reject);
                  });
                  break;
                }
              case 'meta-response':
                {
                  require(['meta-response-app'], function () {
                    require(['meta-response-app-export'], function (createModule) {
                      createModule($('<div></div>'), newParameters, null, true).done(deferred.resolve).fail(deferred.reject);
                    }, deferred.reject);
                  });
                  break;
                }
              case 'assignments':
                {
                  require(['assignments-export-module'], function (createModule) {
                    var module = createModule($('<div></div>'), null, newParameters, true);
                    deferred.resolve(module);
                  }, deferred.reject);
                  break;
                }
              default:
                {
                  var msg = 'Module rendering for app "' + parameters.app + '" is not implemented';
                  console.error(msg); // eslint-disable-line no-console
                  deferred.reject(msg);
                }
            }

            return deferred;
          },

          getPresets: function () {
            // Exports Sidebar > Saved Reports > Global Presets
            // Portfolio presets
            var portfolioDeferred = $.Deferred();
            require(['portfolio-app'], function () {
              require(['portfolio/static/js/export/presets/presets'], function (presets) {
                presets({
                  groupURL: config.urls.group,
                  portfolioURL: config.urls.portfolio,
                  publicWidgetsURL: config.urls.widget5,
                  ssoURL: config.urls.sso,
                  clusterURL: config.urls.cluster,
                  tasksURL: config.urls.tasks,
                  goalsURL: config.urls.goals
                }).done(portfolioDeferred.resolve).fail(portfolioDeferred.reject);
              }, portfolioDeferred.reject);
            });
            // Dashboard presets
            var dashboardDeferred = $.Deferred();
            require(['dashboard-agg'], function () {
              require(['dashboard-static/js/export/presets/presets'], function (presets) {
                presets({
                  widget5: config.urls.widget5,
                  clusterUrl: config.urls.cluster,
                  tasks: config.urls.tasks,
                  social: config.urls.social
                }).done(dashboardDeferred.resolve).fail(dashboardDeferred.reject);
              }, dashboardDeferred.reject);
            });

            // Stars presets
            var starsDeferred = $.Deferred();
            if (session.has('stars')) {
              require(['survey-app'], function () {
                // global variable
                // eslint-disable-next-line no-undef
                TYAPP_SURVEYS.exporter.presets({
                  widget5: config.urls.widget5,
                  clusterUrl: config.urls.cluster,
                  ssoURL: config.urls.sso,
                  groupURL: config.urls.group,
                  surveyURL: config.urls.survey,
                  tyraURL: config.urls.tyra,
                  surveyMailingStatsAppUrl: config.urls.survey_mailing_stats
                }).done(starsDeferred.resolve).fail(starsDeferred.reject);
              }, starsDeferred.reject);
            } else {
              starsDeferred.resolve([]);
            }

            // return a deferred with all the presets
            return $.when(portfolioDeferred, dashboardDeferred, starsDeferred).pipe(function (portfolio, dashboard, stars) {
              return portfolio.concat(dashboard).concat(stars);
            });
          },

          // Move the main-content to make room for the slidepane
          toggled: function (expanded) {},

          rendered: function () {
            // remove line bellow to not add left margin when rendering export panel
            // mainContent.css('margin-left', borderWidth);
          }
        });
      });
    };
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/dashboard_modules_utils',['jquery', './../config', './../utils', 'ty-i18n!analytics_js_4x'], function ($, config, utils, i18n) {
    function exportParameters(tabKey, module, parameters, moduleData) {
      var _this = this;

      var selectedSubtiles = void 0,
          options = void 0,
          subtileFilters = void 0;

      parameters = $.extend(true, {}, parameters);

      options = {
        filter: module.filter
      };

      delete parameters.labels.header;

      // Source tiles have subtiles
      if (module.type === 'Source') {
        // selected_subtile_type -> 'true'
        selectedSubtiles = {};

        subtileFilters = {};

        module.details.forEach(function (mod) {
          selectedSubtiles[mod.type] = true;

          if (mod.filter) {
            subtileFilters[mod.type] = mod.filter;
          }
        });

        // Add details
        parameters.allSubtiles = [{
          type: 'Comparison',
          sourceId: parameters.sourceId,
          expanded: false
        }, {
          type: 'PerformanceIndex',
          sourceId: parameters.sourceId,
          expanded: false
        }, {
          type: 'Reviews',
          sourceId: parameters.sourceId,
          expanded: false
        }, {
          type: 'Responses',
          sourceId: parameters.sourceId,
          expanded: false
        }, {
          type: 'CategoryScores',
          sourceId: parameters.sourceId,
          filter: subtileFilters.CategoryScores,
          expanded: false
        }];

        if (parameters.sourceId !== config.sources.holidaycheck) {
          parameters.allSubtiles.push({
            type: 'SourcePopularityRank',
            sourceId: parameters.sourceId,
            expanded: false
          });
        }

        if (parameters.sourceId === config.sources.tripadvisor) {
          parameters.allSubtiles.push({
            type: 'SourceGuestProfile',
            sourceId: parameters.sourceId,
            expanded: false
          });
        }

        if (parameters.sourceId === config.sources.holidaycheck) {
          // if holiday check or tripadvisor
          parameters.allSubtiles.push({
            type: 'SourceRecommendationRate',
            sourceId: parameters.sourceId,
            expanded: false
          });
        }

        parameters.allSubtiles = parameters.allSubtiles.map(function (details) {
          var subModuleData = void 0;

          if (moduleData && moduleData.length > 0) {
            subModuleData = moduleData.filter(function (idx, el) {
              return details.type === el.type;
            });
          }

          if (subModuleData && subModuleData.length > 0) {
            return exportParameters(tabKey, details, _this.moduleParams(details), subModuleData[0]);
          } else {
            return exportParameters(tabKey, details, _this.moduleParams(details));
          }
        });

        parameters.details = parameters.allSubtiles.filter(function (subtile) {
          return !!selectedSubtiles[subtile.module];
        });

        options = $.extend(true, options, parameters);
      } else if (moduleData) {
        options = $.extend(true, options, parameters, moduleData);
      } else {
        options = $.extend(true, options, parameters);
      }

      return {
        app: tabKey || 'dashboard', // Todo: Change the Worst Hack in the world
        module: module.type,
        options: $.extend(true, options, {
          labels: {
            pickedFromKey: 'tab_' + tabKey
          }
        })
      };
    }

    function sourceName(id, sources) {
      var match = sources.find(function (x) {
        return x.id === id;
      });
      return match && match.name || null;
    }

    // Render review lists
    // reviewDeferred is used for ga tracking, when it resolved it signals that review was loaded
    function renderReviewList(container, reqData, totalReviews, extraParams, reviewDeferred) {
      var params = $.extend(true, {}, {
        dataprovider: function (page) {
          var readyDeferred = $.Deferred();
          page -= 1;

          var reviewsReq = utils.doAjax({
            url: config.urls.reviews + 'reviews',
            data: $.extend({}, reqData, {
              page: page
            }),
            cache: true
          });

          var assigneesReq = utils.doAjax({
            url: config.urls.tasks + 'tasks/',
            data: {
              dictionary: 'assignees'
            },
            cache: true
          });

          var onRequestSuccess = function (reviews, assignees, namedMap) {
            reviews = reviews[0];
            assignees = assignees[0];

            var associationIds = (reviews.response.review_list || []).map(function (review) {
              return review.review_id;
            });

            var tasksReq = void 0;
            if (associationIds && associationIds.length > 0) {
              tasksReq = utils.doAjax({
                url: config.urls.tasks + 'tasks/',
                data: {
                  association_type: 'review',
                  type: 'action',
                  association_ids: JSON.stringify(associationIds)
                }
              });
            } else {
              tasksReq = $.Deferred().resolve([]);
            }

            tasksReq.done(function (data) {
              var tasks = data || [];

              if (!reviews.response.review_list || !reviews.response.review_list.length) {
                // No reviews were found. This may happen if the total number of reviews is unknown
                readyDeferred.resolve({
                  reviews: [],
                  assignees: []
                });
              } else {
                $.each(reviews.response.review_list, function (idx, review) {
                  review.cluster_name = extraParams.displayName;
                  review.source_name = sourceName(review.source_id, extraParams.sourceList);
                  review.task = tasks.find(function (t) {
                    return t.association.ref_id === review.review_id;
                  });
                  review.hotel_name = namedMap[review.cluster_id];
                });
                readyDeferred.resolve({
                  reviews: reviews.response.review_list,
                  assignees: assignees,
                  totalPages: typeof totalReviews === 'number' && isFinite(totalReviews) ? Math.ceil(totalReviews / reqData.page_size) : undefined
                });
              }

              // Anyway resolve deferred to signal ga to send stats
              if (reviewDeferred) {
                reviewDeferred.resolve({});
              }
            });
          };
          // Get name of hotel per review
          var namedReviewsReq = $.Deferred();

          reviewsReq.then(function (reviews) {
            var clusterIds = [];
            reviews.response.review_list.forEach(function (review) {
              clusterIds.push(review.cluster_id);
            });
            utils.doAjax({
              url: config.urls.group + 'table',
              data: {
                cluster_list: JSON.stringify(clusterIds),
                column_list: JSON.stringify([['name']]),
                v: JSON.stringify(8)
              },
              cache: true
            }).then(function (response) {
              var namedMap = {};
              var reviewNames = response['-1']; // API returns -1 object
              for (var i = 1; i < reviewNames.length; i++) {
                // skip 0 per API call response format
                namedMap[reviewNames[i][0]] = reviewNames[i][1];
              }
              namedReviewsReq.resolve(namedMap);
            });
          });

          $.when(reviewsReq, assigneesReq, namedReviewsReq).pipe(onRequestSuccess, function (err) {
            console.error(err); // eslint-disable-line no-console
            readyDeferred.reject();
          });

          return readyDeferred;
        }
      }, extraParams);

      $('<div></div>').appendTo(container).ReviewList().init(params);
    }

    function categoryReviewsPopup(data, categoryId, categoryName, sentimentList, customFrom, customTo, sourceId) {
      $.fancybox({
        content: '<div class="review-list-popup"></div>',
        padding: 0,
        scrolling: 'no',
        autoScale: false,
        autoDimensions: true,
        centerOnScroll: true,
        onComplete: function () {
          var $fancyboxContent = $('#fancybox-content'),
              container = $fancyboxContent.find('.review-list-popup');

          // This is a hack to override predefined fancybox styles
          $fancyboxContent.css('overflow', 'visible');
          container.parent().css('overflow', 'visible');

          // Show review list

          var reqData = {
            category_list: JSON.stringify([categoryId]),
            from: customFrom || data.from,
            page_size: data.reviewsPerPage
          };

          if (!data.clusterId && data.groupId) {
            reqData.group_list = JSON.stringify([data.groupId]);
          } else {
            reqData.cluster_list = JSON.stringify([data.clusterId]);
          }

          // Hack for reviews app, as it currently not supporting: source_list = [-1]
          if (sourceId && +sourceId[0] !== -1 && +sourceId !== -1) {
            reqData.source_list = JSON.stringify(sourceId);
          }

          var snippetMatches = {
            category_list: [categoryId]
          };

          // Add sentiment if needed
          if (sentimentList && sentimentList.length) {
            reqData.sentiment_list = JSON.stringify(sentimentList);
            snippetMatches.sentiment_list = sentimentList;
          }

          if (customTo || data.to) {
            reqData.to = customTo || data.to;
          }

          renderReviewList(container, reqData, Infinity, {
            snippetMatches: snippetMatches,
            rendered: function () {
              $.fancybox.resize();
              $.fancybox.center();
              $('#fancybox-overlay').addClass('trustyou-ui');
              $('#fancybox-wrap, #fancybox-outer, #fancybox-content').css('width', 'auto');
            },
            labels: {
              header: i18n.reviews_with_matches.replace('{category}', categoryName)
            },
            clusterName: data.clusterName,
            sourceList: data.sourceList,
            page: this.page,
            parentFancyBox: this
          });
        }
      });
    }

    function moduleHeader(label, sourceLogo) {
      if (!label) {
        return null;
      }
      var header = '<div class="header-label">';
      if (sourceLogo) {
        header += '<span class="source-logo">' + label + '</span>';
      } else {
        header += label;
      }
      header += '</div>';

      return header;
    }

    return {
      exportParameters: exportParameters,
      renderReviewList: renderReviewList,
      categoryReviewsPopup: categoryReviewsPopup,
      moduleHeader: moduleHeader
    };
  });
})();


(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/tileExportUtils',['jquery', 'moment'], function ($, moment) {
    function resetTime(date) {
      date.setHours(0, 0, 0, 0);

      return date;
    }

    return {
      createTemplate: function (template) {
        return $.template(template);
      },
      moduleReportParams: function () {
        return this.createTemplate('' + '<div class="module-report-params">' + '<div class="export-module-major-header">' + '<span class="capitalized"> ${app} </span> &#187; ' + '<span class="capitalized"> ${header} </span> &#187; ' + '<span class="capitalized"> ${clusterName ? clusterName : notApplicableLabel} </span>' + '</div>' + '<span class="export-module-minor-header">${timeFilter}: ${timeLabel ? timeLabel : notApplicableLabel}</span>' + '</div>');
      },
      doAjax: function (params) {
        var defaults = {
          dataType: 'json',
          cache: true
        };

        return $.ajax($.extend({}, defaults, params));
      },
      doJSONP: function (params) {
        return $.when(this.doAjax($.extend({
          dataType: 'jsonp',
          jsonp: 'callback'
        }, params))).pipe(function (data) {
          // The failure of a JSONP request can be determined only through its metadata
          if (data.meta.code !== 200) {
            return $.Deferred().reject(data);
          } else {
            return data;
          }
        });
      },


      /** *
       * This method is used to parse all API responses that emulate Table API (tabular json
       * structure).
       * Changes to this method might break the parsing of Goals API data.
       */
      parseTableApi: function (tableData, columns) {
        var parsed = {};

        var createRowData = function (data, i) {
          var rowData = {};
          $.each(columns, function (idx, name) {
            rowData[name] = data[i][idx];
          });
          return rowData;
        };

        $.each(tableData, function (sourceId, data) {
          var i = void 0,
              rowData = void 0;

          parsed[sourceId] = [];

          // Omit the header
          for (i = 1; i < data.length; ++i) {
            rowData = createRowData(data, i);
            parsed[sourceId].push(rowData);
          }
        });

        return parsed;
      },


      /**
       * Returns a color formatted html element.
       *
       * @param val the color is based on this value
       * @param thresholds the color thresholds
       * @param [text] the text of the element. Defaults to 'val'
       * @return {String} the html string
       */
      colored: function (val, thresholds, text) {
        if (!thresholds) {
          throw new Error('Specify color thresholds');
        }

        // Compare inclusive or exclusive
        var cmp = function (value, thrs) {
          return thresholds.exclusive ? value > thrs : value >= thrs;
        };

        var $el = $('<b></b>');

        if (cmp(val, thresholds.green)) {
          $el.addClass('green');
        } else if (cmp(val, thresholds.yellow)) {
          $el.addClass('yellow');
        } else if (!thresholds.hasOwnProperty('red') || cmp(val, thresholds.red)) {
          // The threshold for 'red' may be missing, meaning everything that's neither
          // 'green' nor 'yellow'
          $el.addClass('red');
        }

        return $('<b></b>').append($el.text(text || val)).html();
      },
      excelColored: function (val, thresholds) {
        if (thresholds.exclusive ? val > thresholds.green : val >= thresholds.green) {
          // dark green
          return '#009900';
        } else if (thresholds.exclusive ? val > thresholds.yellow : val >= thresholds.yellow) {
          // dark yellow
          return '#f39814';
        } else {
          // dark red
          return '#CC0000';
        }
      },
      isNumber: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      },
      isoToDate: function (s) {
        var parts = s.split('-');
        var date = new Date();

        date.setFullYear(parts[0], +parts[1] - 1, parts[2]);
        date.setHours(0, 0, 0, 0);

        return date;
      },
      scaleUtils: function (scale) {
        if (scale !== 100 && scale !== 5 && scale !== 10) {
          throw new Error('Unsupported scale: ' + scale);
        }

        return {
          scale: function (n) {
            if (n === null) {
              return null;
            }
            return n / (100 / scale);
          },
          round: function (n) {
            if (n === null) {
              return null;
            }

            switch (scale) {
              case 100:
                {
                  return Math.round(n);
                }
              default:
                {
                  // for both 5 and 10
                  // One decimal
                  return +n.toFixed(1);
                }
            }
          },
          trustscoreColorThresholds: {
            green: scale * 0.746, // 100: 74.6, 10: 7.46, 5: 3.73
            yellow: scale * 0.6705, // 100: 67.05, 10: 6.705, 5: 3.3525
            exclusive: true
          },
          sentimentColorThresholds: {
            green: scale * 0.70, // 100: 70, 10: 3.5, 5: 3.5
            yellow: scale * 0.50, // 100: 50, 10: 5.0, 5: 2.5
            exclusive: true
          },
          popularityColorThresholds: {
            green: scale * 0.8, // 100: 80, 10: 8, 5: 4
            yellow: scale * 0.2 // 100: 20, 10: 2, 5: 1
          },
          responseRateColorThresholds: {
            green: 30,
            yellow: 15
          },
          reviewColorThresholds: {
            green: scale * 0.6, // 100: 60, 10: 6, 5: 3
            yellow: scale * 0.4, // 100: 40, 10: 4, 5: 2
            exclusive: true
          }
        };
      },
      addTimeRange: function (data, from, to) {
        if (from) {
          data.from = from;
        }
        if (to) {
          data.to = to;
        }

        return data;
      },
      appendTrend: function (prefix, from, to) {
        var column = [].concat(prefix);

        var date = moment(from ? this.isoToDate(from) : new Date());
        var fromDate = date.format('YYYY-MM-DD');
        column.push(fromDate);

        if (to) {
          column.push(to);
        }

        return column;
      },
      refreshClusterName: function (params) {
        var url = params.clusterUrl + 'clusters';
        var deferred = $.Deferred();

        $.ajax({
          url: url,
          type: 'post',
          data: JSON.stringify({
            cluster_list: [params.clusterId]
          }),
          dataType: 'json',
          cache: true
        }).done(function (data) {
          if (data.meta && data.meta.code === 200) {
            // Success

            $.each(data.response.cluster_list, function (idx, cluster) {
              if (params.clusterId === cluster.id) {
                params.clusterName = cluster.name;
              }
            });

            deferred.resolve(params);
          } else {
            // Fail
            deferred.reject('Cluster app error: ' + JSON.stringify(data));
          }
        }).fail(function (jqXHR) {
          deferred.reject(url + ': HTTP ' + jqXHR.status);
        });

        return deferred;
      },
      checkDetailsLink: function (label, data) {
        var link = $('<a class="check-details" href="javascript:void(0)"></a>').text(label);

        $.each(data, function (key, value) {
          link.attr('data-' + key, value);
        });

        return $('<div></div>').append(link).html();
      },
      refreshTimeParams: function (currentFilter, params, i18n) {
        var timeFilter = $.ty.timedropdown.relativeValue(currentFilter);

        if (timeFilter.fromDate) {
          params.from = timeFilter.fromDate;
        } else {
          delete params.from;
        }

        if (timeFilter.toDate) {
          params.to = timeFilter.toDate;
        } else {
          delete params.to;
        }

        params.timeLabel = i18n.filtering_fromdatetodate.replace('{fromdate}', timeFilter.fromDate).replace('{todate}', timeFilter.toDate ? timeFilter.toDate : $.ty.timedropdown.dateToString($.ty.timedropdown.today()));

        return params;
      },
      moduleHeader: function (label, sourceLogo) {
        var header = '<div class="header-label">';
        if (sourceLogo) {
          header += '<span class="source-logo">' + label + '</span>';
        } else {
          header += label;
        }
        header += '</div>';

        return header;
      },
      tableHeaderCaption: function (table, params) {
        var caption = params.labels.noClusterFilter;
        if (params.clusterName) {
          caption = params.clusterName;
        } else if (params.groupName) {
          caption = params.groupName;
        }

        var clusterCaption = [{
          type: 'string',
          value: caption
        }];

        var timeFrameCaption = [{
          type: 'string',
          value: params.timeLabel ? params.timeLabel : params.labels.noTimeFilter
        }];

        if (table && table.length > 0) {
          table.push(['c', JSON.stringify({
            format: {
              text_wrap: 1
            }
          }), JSON.stringify(clusterCaption)]);

          table.push(['c', JSON.stringify({
            format: {
              text_wrap: 1
            }
          }), JSON.stringify(timeFrameCaption)]);
        }
      },
      coloredClass: function (val, thresholds, text) {
        var clazz = void 0;

        if (!thresholds) {
          throw new Error('Specify color thresholds');
        }

        var cmp = function (value, thrs) {
          return thresholds.exclusive ? value > thrs : value >= thrs;
        };

        if (cmp(val, thresholds.green)) {
          clazz = 'text-positive';
        } else if (cmp(val, thresholds.yellow)) {
          clazz = 'text-neutral';
        } else if (!thresholds.hasOwnProperty('red') || cmp(val, thresholds.red)) {
          // The threshold for 'red' may be missing, meaning everything that's neither 'green' nor 'yellow'
          clazz = 'text-negative';
        }

        return clazz;
      },
      getMatchingTrendArrow: function (trendValue, label, noTrendLabel) {
        if (!label) {
          label = '';
        }
        var trendIncreaseArrow = '' + ('<span class="trend text-positive">' + '<i class="ty-icon ty-icon-arrow-up"></i> ') + label + '</span>';
        var trendDecreaseArrow = '' + ('<span class="trend text-negative">' + '<i class="ty-icon ty-icon-arrow-down"></i> ') + label + '</span>';
        var trendStable = '<span class="trend"><i class="ty-icon ty-icon-blank"></i></span>';
        if (noTrendLabel) {
          trendStable = '<span class="trend text-help">' + noTrendLabel + '</span>';
        }

        var trendArrow = trendValue > 0 ? trendIncreaseArrow : null;
        if (trendArrow === null) {
          trendArrow = trendValue < 0 ? trendDecreaseArrow : trendStable;
        }

        return trendArrow;
      },
      comparisonPeriod: function (from, to) {
        var now = resetTime(new Date());
        from = moment(from ? this.isoToDate(from) : now);
        to = moment(to ? this.isoToDate(to) : now);

        // Compute to-from
        var days = to.diff(from, 'days');

        // The previous period ends one day before the current one. The extremities are inclusive.
        var previousTo = from.subtract('days', 1);
        var previousFrom = moment(previousTo).subtract('days', days);

        return {
          from: previousFrom.format('YYYY-MM-DD'),
          to: previousTo.format('YYYY-MM-DD')
        };
      }
    };
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/sentiment/export',['jquery', 'session', 'ty-i18n!analytics_js_4x', 'ty-i18n!tyra-5', 'ty-i18n!metacategory', 'ty-i18n!dashboard-app', 'ty-i18n!portfolio', './../tileExportUtils', './../../config', 'timedropdown-v2', 'wordcloud'], function ($, session, i18n, tyra5I18n, metacategoryI18n, dashboardI18n, portfolioI18n, _utils, tyraConfig) {
    var getSourceId = function (csParams) {
      if (!csParams.sourceId) {
        return [-1];
      }
      var sourceList = csParams.sourceId;
      if (!(sourceList instanceof Array)) {
        sourceList = [sourceList];
      }
      return sourceList.map(function (x) {
        return +x;
      });
    };

    var refreshParams = function (tileParams) {
      var deferred = $.Deferred();
      var params = $.extend(true, {}, tileParams);

      _utils.refreshTimeParams({
        fromDate: params.from,
        toDate: params.to,
        time: params.time
      }, params, i18n);

      params.lang = session.properties.locale || 'en';
      params.scale = session.properties.scale || 100;

      params.dashboardI18n = dashboardI18n;
      params.metacategoryI18n = metacategoryI18n;

      var tileName = params.clusterId ? i18n.dashboard_sentiment_header : params.labels.groupSentiment;

      $.extend(true, params.labels, {
        pickedFrom: tyra5I18n[params.labels.pickedFromKey],
        header: _utils.moduleHeader(tileName),
        topsFlopsTab: i18n.dashboard_tops_flops_tab,
        chartsTab: i18n.dashboard_category_charts_tab,
        tableTab: i18n.dashboard_category_table_tab,
        positive: i18n.charts_positive,
        negative: i18n.charts_negative,
        category: i18n.renderers_dashboard_category,
        score: i18n.score,
        performance: portfolioI18n.sema_category,
        mentions: i18n.common_mentions,
        tops: i18n.common_tops,
        flops: i18n.common_flops,
        trendingDownLabel: tyra5I18n.trending_down,
        sentiment: i18n.dashboard_sentiment_header,
        numberOf: tyra5I18n.number_of,
        notApplicable: tyra5I18n.not_applicable,
        cluster: tyra5I18n.cluster,
        timeFilter: tyra5I18n.time_filter,
        noTimeFilter: tyra5I18n.not_applicable_time_filter,
        noClusterFilter: tyra5I18n.not_applicable_cluster_filter,
        trend: i18n.common_trend,
        common_positive: i18n.common_positive,
        common_neutral: i18n.common_neutral,
        common_negative: i18n.common_negative,
        select: i18n.show_in_word_cloud_element,
        reset_cloud: i18n.reset_cloud,
        all: i18n.common_all,
        none: i18n.common_none,
        categories: i18n.common_categories,
        subcategories: i18n.common_subcategories,
        positive_mentions: i18n.common_positive_mentions,
        neutral_mentions: i18n.common_neutral_mentions,
        negative_mentions: i18n.common_negative_mentions,
        meta_review: i18n.meta_review,
        show_reviews: i18n.show_reviews,
        custom: i18n.common_custom
      });

      if (params.clusterId) {
        _utils.refreshClusterName(params).done(deferred.resolve).fail(deferred.reject);
      } else {
        deferred.resolve(params);
      }

      return deferred;
    },
        extendParams = function (clientParams) {
      return $.extend(true, {
        clusterId: null,
        categoryId: null,
        from: null,
        to: null,
        lang: null,

        // Toggle the tops & flops tab in the details panel because the feature is not supported for all verticals.
        topsFlopsTab: true,

        cloudOptions: {
          width: 920,
          height: 300,
          mentionsToWeight: function (mentions, maxMentions) {
            // The size is between [14, 50] px
            return Math.max(Math.round(mentions * 50 / maxMentions), 14) + 'px';
          },

          // Plugin options
          maxSpeed: 0.02,
          freezeActive: true,
          frontSelect: true,
          reverse: true,
          txtOpt: false,
          stretchX: 3,
          weight: true,
          textColour: null
        },
        semaChartOptions: {
          isStacked: true,
          colors: ['#7cb342', '#f7aa5c', '#f37159'],
          chartArea: {
            left: 50,
            top: 20,
            width: 690,
            height: 200
          },
          hAxis: {
            slantedText: true,
            slantedTextAngle: 90
          },
          width: 920,
          height: 340
        },
        footerColor: '#f0f0f0',
        tableOptions: {
          sortColumn: 3,
          sortAscending: false,
          sort: 'disable'
        },
        labels: {
          header: '',
          detailsHeader: '',
          lastTimeLabel: '',
          iconDescription: '',
          rangeTimeLabel: '',
          chartsTab: '',
          tableTab: '',
          category: '',
          score: '',
          performance: '',
          mentions: '',
          tops: '',
          flops: '',
          positive: '',
          negative: '',
          trendingDownLabel: ''
        }
      }, clientParams, {
        widget5: tyraConfig.urls.widget5,
        clusterUrl: tyraConfig.urls.cluster,
        departments: tyraConfig.departments,
        departmentIcons: tyraConfig.department_icons
      });
    },
        allCategoriesTemplate = _utils.createTemplate('' + '<span class="tile-description">${description}:</span>' + '<div class="one-row">' + '{{if categories.length}}' + '<ul class="categories">' + '{{each(idx, category) categories }}' + '<li><span>${category.name}</span>{{html category.formattedTrend}}</li>' + '{{/each}}' + '</ul>' + '{{else}}' + '<p>${none}</p>' + '{{/if}}' + '<div class="time-label">${rangeTimeLabel}</div>' + '</div>'),
        singleCategoryTemplate = _utils.createTemplate('' + '<div class="two-row">' + '<div>' + '<span class="score big">{{html performance}}</span>' + '/${scale}' + '</div>' + '<div>${labels.iconDescription}</div>' + '<div class="time-label">${rangeTimeLabel}</div>' + '</div>'),
        detailsTemplate = _utils.createTemplate('' + '<div>' + '<div class="sentiment_table" style="margin-top:10px"></div>' + '<div class="word-cloud-wrapper">' + '<div class="word-cloud-pos"></div>' + '<div class="word-cloud-neu"></div>' + '<div class="word-cloud-neg"></div>' + '</div>' + '</div>'),
        singleDepartmentTemplate = _utils.createTemplate('' + '<div class="score">' + '<div class="score-info">' + '<span class="value ${performanceClass}">${performance}</span>' + '{{html trend}}' + '</div>' + '<div class="score-icon">' + '<i class="ty-icon ${icon}"></i>' + '</div>' + '</div>');

    /*
     * Sums column data across multiple sources
     * Casts string and null values to integers
     */
    var aggregateSourceData = function (parsedObject) {
      var agg = {};
      for (var k in parsedObject) {
        if (parsedObject.hasOwnProperty(k)) {
          var dataSlice = parsedObject[k][0];
          for (var i in dataSlice) {
            if (dataSlice.hasOwnProperty(i)) {
              agg[i] = (agg[i] || 0) + +dataSlice[i];
            }
          }
        }
      }
      return agg;
    };

    if (!$.fn.TyraExport) {
      $.fn.TyraExport = {};
    }

    if (!$.fn.TyraExport.predefined) {
      $.fn.TyraExport.predefined = {};
    }

    $.fn.TyraExport.predefined.CategoryScores = {
      dataprovider: function () {
        var self = this;
        var exportData = self._exportData();
        var csParams = extendParams(exportData.params.module.options),
            deferred = $.Deferred();

        refreshParams(csParams).done(function (params) {
          $.extend(true, csParams, params);

          $.extend(true, exportData.params.module.options, csParams);

          self._exportData(exportData);

          // Get categories
          $.when(_utils.doJSONP({
            url: csParams.widget5 + 'hotels/sources/-1',
            data: {
              lang: csParams.lang
            }
          }), _utils.doAjax({
            url: csParams.i18n + 'bundles/metacategory/' + csParams.lang
          }), _utils.doAjax({
            url: csParams.i18n + 'bundles/widget_tops_flops_v2/' + csParams.lang
          })).done(function (widgetData, bundleReq, topFlopsBundleReq) {
            var bundleData = bundleReq[0],
                topFlopsData = topFlopsBundleReq[0],
                categoryIds = [],
                columns = [],
                departmentNeededCategories = {};
            var categories = [],
                departmentCategories = void 0;

            if (csParams.departmentId) {
              departmentCategories = csParams.departments[csParams.departmentId].split(',');
              departmentNeededCategories[csParams.departmentId] = true;
            }

            var comparison = _utils.comparisonPeriod(csParams.from, csParams.to);

            $.each(widgetData.response.cluster_category_list, function (idx, category) {
              var categoryId = category.category_id,
                  parentIds = category.parent_category_list;

              // Only the specified category and its children, if any
              if (!csParams.categoryId || csParams.categoryId === categoryId || parentIds.indexOf(csParams.categoryId) !== -1) {
                if (csParams.departmentId && $.inArray(categoryId, departmentCategories) !== -1) {
                  departmentNeededCategories[categoryId] = true;
                  $.map(parentIds, function (parentId) {
                    departmentNeededCategories[parentId] = true;
                  });
                }

                categories.push({
                  id: categoryId,
                  name: category.name,
                  positiveName: topFlopsData['good_to_know_' + categoryId + '_pos'],
                  neutralName: topFlopsData['good_to_know_' + categoryId + '_neu'],
                  negativeName: topFlopsData['good_to_know_' + categoryId + '_neg'],
                  parentIds: parentIds
                });
              }
            });

            categories = $.map(categories, function (category) {
              var categoryId = category.id;

              if (!csParams.departmentId || departmentNeededCategories[categoryId]) {
                categoryIds.push(categoryId);

                // Add to table API columns
                columns.push(_utils.appendTrend(['matches', categoryId, 'all', 'trend'], csParams.from, csParams.to));
                columns.push(_utils.appendTrend(['matches', categoryId, 'pos', 'trend'], csParams.from, csParams.to));
                columns.push(_utils.appendTrend(['matches', categoryId, 'neg', 'trend'], csParams.from, csParams.to));
                columns.push(_utils.appendTrend(['matches', categoryId, 'neu', 'trend'], csParams.from, csParams.to));
                columns.push(_utils.appendTrend(['matches', categoryId, 'all', 'trend'], comparison.from, comparison.to));
                columns.push(_utils.appendTrend(['matches', categoryId, 'pos', 'trend'], comparison.from, comparison.to));

                return category;
              }
              return null;
            });

            var sourceId = getSourceId(csParams);
            var tableData = {
              column_list: JSON.stringify(columns),
              v: JSON.stringify(8),
              source_list: JSON.stringify(sourceId)
            };

            if (!csParams.clusterId && csParams.groupId) {
              tableData.group_list = JSON.stringify([csParams.groupId]);
            } else {
              tableData.cluster_list = JSON.stringify([csParams.clusterId]);
            }

            // Add time range
            _utils.addTimeRange(tableData, csParams.from, csParams.to);

            // Get score and counts
            var requestUrl = csParams.group + 'table';
            _utils.doAjax({
              url: requestUrl,
              type: 'post',
              data: tableData
            }).done(function (data) {
              var newColumns = ['id'].concat($.map(categoryIds, function (id) {
                return [id + '_count', id + '_pos_count', id + '_neg_count', id + '_neu_count', id + '_count-past', id + '_pos_count-past'];
              }));
              var parsed = aggregateSourceData(_utils.parseTableApi(data, newColumns));

              $.each(categories, function (_, category) {
                var categoryId = category.id;

                $.extend(category, {
                  header: category.name,
                  count: parsed[categoryId + '_count'],
                  posCount: parsed[categoryId + '_pos_count'],
                  negCount: parsed[categoryId + '_neg_count'],
                  neuCount: parsed[categoryId + '_neu_count'],
                  pastCount: parsed[categoryId + '_count-past'],
                  posPastCount: parsed[categoryId + '_pos_count-past']
                });
              });

              deferred.resolve({
                categories: categories,
                categoryLabels: bundleData
              });
            }).fail(function () {
              deferred.reject('' + ('Sentiment tile export: Table API call failed. ' + 'POST ') + requestUrl + ' payload: \n' + JSON.stringify(tableData));
            });
          }).fail(function () {
            deferred.reject('Sentiment tile export: data call failed');
          });
        }).fail(function () {
          deferred.reject('Sentiment tile export: data call failed');
        });

        return deferred;
      },
      renderer: function (data) {
        var self = this,
            rendererDeferred = $.Deferred(),
            renderFn = function () {
          var csParams = extendParams(self._exportData().params.module.options);
          var scaled = _utils.scaleUtils(csParams.scale),
              iconCategories = [],
              departmentCategory = void 0;

          var detailsContent = self._detailsContent();
          var maxMentions = 0,
              departmentCategories = void 0;

          if (csParams.departmentId) {
            departmentCategories = csParams.departments[csParams.departmentId].split(',');
          }

          // Icon header and content

          // Compute performance index and choose icon categories

          $.each(data.categories, function (_, category) {
            var performance = category.count > 0 ? category.posCount * 100 / category.count : undefined;

            if (isNaN(performance)) {
              category.performance = Infinity;
            } else {
              category.performance = scaled.round(scaled.scale(performance));
            }

            category.performanceLabel = isFinite(category.performance) ? _utils.colored(category.performance, scaled.sentimentColorThresholds) : '-';
            category.formattedPerformance = isFinite(category.performance) ? _utils.colored(category.performance, scaled.sentimentColorThresholds) : '-';
            category.performanceClass = isFinite(category.performance) ? _utils.coloredClass(category.performance, scaled.sentimentColorThresholds) : '';

            iconCategories.push(category);

            // Only the department category is show in the icon
            if (category.id === csParams.departmentId) {
              departmentCategory = category;
            }
          });

          var isGroupSentiment = !csParams.clusterId && csParams.groupId;
          var sourceId = getSourceId(csParams);
          if ((sourceId.includes(-1) && !isGroupSentiment || isGroupSentiment) && !csParams.departmentId) {
            $.tmpl(_utils.moduleReportParams(), {
              app: csParams.labels.pickedFrom,
              header: $(csParams.labels.header).text(),
              timeFilter: csParams.labels.timeFilter,
              clusterName: csParams.groupName || csParams.clusterName,
              timeLabel: csParams.timeLabel,
              notApplicableLabel: csParams.labels.notApplicable
            }).insertBefore(self._icon());
          } else if (csParams.departmentId) {
            $.tmpl(_utils.moduleReportParams(), {
              app: csParams.labels.pickedFrom,
              header: csParams.metacategoryI18n[csParams.departmentId] + ' - ' + csParams.dashboardI18n.sentiment,
              timeFilter: csParams.labels.timeFilter,
              clusterName: csParams.groupName || csParams.clusterName,
              timeLabel: csParams.timeLabel,
              notApplicableLabel: csParams.labels.notApplicable
            }).insertBefore(self._icon());
          }

          self._icon().addClass((csParams.departmentId ? 'tile-sentiment-department' : 'tile-sentiment') + ' category-icon ' + (csParams.categoryId ? 'category-id-' + csParams.categoryId : ''));

          // Render header & content
          self._iconHeader().html(csParams.labels.header);

          if (csParams.departmentId) {
            self._iconHeader().html(csParams.metacategoryI18n[csParams.departmentId] + '<span class="subtitle">' + csParams.dashboardI18n.sentiment + '</span>');

            var trend = 0;
            var pastPerformance = departmentCategory.pastCount > 0 ? departmentCategory.posPastCount * 100 / departmentCategory.pastCount : 0;

            if (departmentCategory.pastCount > 0 && departmentCategory.performance) {
              if (pastPerformance !== 0) {
                trend = Math.round((departmentCategory.performance - pastPerformance) / pastPerformance * 100 * 10) / 10;
              } else if (departmentCategory.performance > pastPerformance) {
                trend = 100;
              } else if (performance < pastPerformance) {
                trend = -100;
              }
            }

            $.tmpl(singleDepartmentTemplate, {
              rangeTimeLabel: csParams.labels.rangeTimeLabel,
              performance: departmentCategory.performance && departmentCategory.performance !== Infinity ? departmentCategory.performance : '-',
              performanceClass: departmentCategory.performanceClass,
              scale: csParams.scale,
              labels: csParams.labels,
              trend: _utils.getMatchingTrendArrow(trend, csParams.labels.trend, csParams.dashboardI18n.no_trend),
              icon: csParams.departmentIcons[csParams.departmentId]
            }).appendTo(self._iconContent());
          } else if (!csParams.categoryId) {
            scaled = _utils.scaleUtils(csParams.scale);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = iconCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var category = _step.value;

                if (!(category.count && category.count > 0 || csParams.departmentId && csParams.departments[category.id])) {
                  continue;
                }
                var _trend = 0;
                var _performance = category.count > 0 ? category.posCount * 100 / category.count : undefined;
                var _pastPerformance = category.pastCount > 0 ? category.posPastCount * 100 / category.pastCount : 0;

                _pastPerformance = scaled.round(scaled.scale(_pastPerformance));
                _performance = category.count > 0 ? scaled.round(scaled.scale(_performance)) : undefined;

                if (category.pastCount > 0 && _performance) {
                  if (_pastPerformance !== 0) {
                    _trend = Math.round((_performance - _pastPerformance) / _pastPerformance * 100 * 10) / 10;
                  } else if (_performance > _pastPerformance) {
                    _trend = 100;
                  } else if (_performance < _pastPerformance) {
                    _trend = -100;
                  }
                }

                category.trend = _trend;
                category.formattedTrend = _utils.colored(category.trend, scaled.sentimentColorThresholds, category.trend + '%');
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            iconCategories = jQuery.grep(iconCategories, function (category, i) {
              return category.trend < 0 && category.negCount >= 5;
            }).sort(function (categoryA, categoryB) {
              return categoryA.trend - categoryB.trend;
            });

            // Display TOP 3 trending down categories
            $.tmpl(allCategoriesTemplate, {
              rangeTimeLabel: csParams.labels.rangeTimeLabel,
              description: csParams.labels.trendingDownLabel,
              none: csParams.labels.none,
              categories: iconCategories.slice(0, Math.min(iconCategories.length, 3))
            }).appendTo(self._iconContent());
          } else {
            // Display category performance
            $.tmpl(singleCategoryTemplate, {
              rangeTimeLabel: csParams.labels.rangeTimeLabel,
              performance: iconCategories[0].performanceLabel,
              scale: csParams.scale,
              labels: csParams.labels
            }).appendTo(self._iconContent());
          }

          // Details header and content
          self._details().addClass('category-scores-details' + (csParams.categoryId ? ' category-id-' + csParams.categoryId : ''));

          // Render header & content
          self._detailsHeader().html(csParams.labels.detailsHeader || csParams.labels.header);

          if (csParams.departmentId) {
            self._detailsHeader().html(csParams.metacategoryI18n[csParams.departmentId] + ' - ' + csParams.dashboardI18n.sentiment);
          }

          // Generating data for renderer
          var visibleParents = [],
              tableData = {},
              categoryExpand = [];

          var isRowSelected = function (category) {
            return $.inArray(category.id, csParams.filter.categorySelection) !== -1;
          };

          var generateRow = function (category, maxMent, storeExpand, isFooter) {
            var trendArrow = '',
                row = void 0,
                expanded = true; // Expand all rows in export.
            var children = [];

            if (category.data.trend !== 0) {
              if (category.data.trend > 0) {
                trendArrow = '<span class="trend text-positive"><i class="ty-icon ty-icon-arrow-up"></i></span> ';
              } else {
                trendArrow = '<span class="trend text-negative"><i class="ty-icon ty-icon-arrow-down"></i></span> ';
              }
            }

            if (category.children) {
              $.each(category.children, function (_, child) {
                children.push(generateRow(child, maxMent));

                // Parent expanded if one child selected
                if (storeExpand && csParams.filter.preselection === 'custom' && $.inArray(child.id, csParams.filter.categorySelection) !== -1) {
                  expanded = true;
                }
                if ($.inArray(category.id, categoryExpand) === -1) {
                  categoryExpand.push(category.id);
                }
              });

              // Parent expanded if one child selected
              if (!storeExpand && $.inArray(category.id, categoryExpand) !== -1) {
                expanded = true;
              }
            }

            if (!csParams.departmentId && !category.id.match('^dept_') || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1 || isFooter) {
              row = $.ty.table.Row(category.id, isRowSelected(category), expanded, [$.ty.table.Cell(category.id, category.data.performance !== undefined ? '<a class="placeholder-category-name">' + data.categoryLabels[category.id] + '</a>' : '-'), $.ty.table.Cell(category.data.performance, category.data.performance !== undefined ? '' + (trendArrow + _utils.colored(category.data.performance, scaled.sentimentColorThresholds)) : '-'), $.ty.table.Cell(category.data.trend, category.data.performance !== undefined ? (category.data.trend > 0 ? '+' : '') + category.data.trend.toString() + '%' : '-'), $.ty.table.Cell(category.data.count, category.data.performance !== undefined ? '<div class="placeholder-category" data-category="' + category.id + '" >' + ('</div>' + category.data.count) : '-', 'left'), $.ty.table.Cell(category.data.posCount, category.data.performance !== undefined ? '' + category.data.posCount : '-'), $.ty.table.Cell(category.data.neuCount, category.data.performance !== undefined ? '' + category.data.neuCount : '-'), $.ty.table.Cell(category.data.negCount, category.data.performance !== undefined ? '' + category.data.negCount : '-')], children);
            } else if (csParams.departmentId && !category.id.match('^dept_')) {
              // Special case for departments, it's used to show empty main categories
              if (children.length > 0) {
                row = $.ty.table.Row(category.id, !($.inArray(category.id, csParams.filter.categorySelection) === -1 || csParams.filter.preselection !== 'custom'), expanded, [$.ty.table.Cell(category.id, '<a class="placeholder-category-name">' + data.categoryLabels[category.id] + '</a>'), $.ty.table.Cell('', csParams.dashboardI18n.not_department_category.replace('{department}', csParams.metacategoryI18n[csParams.departmentId]), undefined, 'text-help text-xs')], children, undefined, undefined, true);
              }
            }

            return row;
          };

          var sortCategories = function (cData, storeExpand) {
            var sortOrder = cData.order === 'asc' ? 1 : -1,
                columnOrder = void 0;
            var sortedRows = [];

            switch (cData.column) {
              case 'category':
                {
                  columnOrder = 'name';
                  sortOrder *= -1;
                  break;
                }
              case 'performance':
              case 'trend':
                {
                  columnOrder = cData.column;
                  break;
                }
              case 'mentions':
                {
                  columnOrder = 'count';
                  break;
                }
              case 'positive':
                {
                  columnOrder = 'posCount';
                  break;
                }
              case 'neutral':
                {
                  columnOrder = 'neuCount';
                  break;
                }
              case 'negative':
                {
                  columnOrder = 'negCount';
                  break;
                }
            }

            // Sort Parents
            if (!csParams.departmentId) {
              visibleParents.sort(function (a, b) {
                if (tableData[a.id].data[columnOrder] < tableData[b.id].data[columnOrder]) {
                  return -1 * sortOrder;
                }
                if (tableData[a.id].data[columnOrder] > tableData[b.id].data[columnOrder]) {
                  return 1 * sortOrder;
                }
                return 0;
              });
            } else {
              visibleParents.sort(function (a, b) {
                // Show empty parents at the bottom
                if (cData.column !== 'category') {
                  if ($.inArray(a.id, departmentCategories) === -1) {
                    return -1 * sortOrder;
                  }
                  if ($.inArray(b.id, departmentCategories) === -1) {
                    return 1 * sortOrder;
                  }
                }

                if (tableData[a.id].data[columnOrder] < tableData[b.id].data[columnOrder]) {
                  return -1 * sortOrder;
                }
                if (tableData[a.id].data[columnOrder] > tableData[b.id].data[columnOrder]) {
                  return 1 * sortOrder;
                }
                return 0;
              });
            }

            // Sort children
            $.each(visibleParents, function (_, category) {
              if (tableData[category.id].children) {
                // Sort children
                tableData[category.id].children.sort(function (a, b) {
                  if (a.data[columnOrder] < b.data[columnOrder]) {
                    return -1 * sortOrder;
                  }
                  if (a.data[columnOrder] > b.data[columnOrder]) {
                    return 1 * sortOrder;
                  }
                  return 0;
                });
              }
              var row = generateRow(tableData[category.id], maxMentions, storeExpand);
              if (row) {
                sortedRows.push(row);
              }
            });

            return {
              rows: sortedRows
            };
          };

          maxMentions = 1;

          $.each(data.categories, function (_, category) {
            var unscaledPerformance = void 0,
                performance = void 0,
                pastPerformance = void 0,
                trend = 0;
            if (category.count && category.count > 0) {
              unscaledPerformance = category.count > 0 ? category.posCount * 100 / category.count : undefined;
              performance = unscaledPerformance;

              unscaledPerformance = category.pastCount > 0 ? category.posPastCount * 100 / category.pastCount : 0;
              pastPerformance = unscaledPerformance;

              pastPerformance = scaled.round(scaled.scale(pastPerformance));
              performance = category.count > 0 ? scaled.round(scaled.scale(performance)) : undefined;

              if (pastPerformance !== 0 && pastPerformance) {
                trend = Math.round((performance - pastPerformance) / pastPerformance * 100 * 10) / 10;
              }

              category.performance = performance;
              category.pastPerformance = pastPerformance;
              category.trend = trend;

              if (maxMentions < category.count) {
                maxMentions = category.count;
              }

              if (category.parentIds && category.parentIds.length > 0) {
                category.parentIds.forEach(function (parent) {
                  if (!tableData[parent]) {
                    tableData[parent] = {
                      id: parent,
                      data: undefined,
                      children: [],
                      isParent: true
                    };
                  }

                  tableData[parent].children.push({
                    id: category.id,
                    data: category
                  });
                  tableData[category.id] = {
                    id: category.id,
                    isParent: false,
                    data: category
                  };
                });
              } else {
                if (!tableData[category.id]) {
                  tableData[category.id] = {
                    id: category.id,
                    children: [],
                    isParent: true
                  };
                }
                tableData[category.id].data = category;
                visibleParents.push({
                  id: category.id
                });
              }
            }
          });

          if (!csParams.filter || csParams.filter.length === 0 || !csParams.filter.categorySelection) {
            csParams.filter = {
              categorySelection: $.map(visibleParents, function (category) {
                if (!csParams.departmentId && !category.id.match('^dept_') || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1) {
                  return category.id;
                }
                return null;
              })
            };
          }

          if (!csParams.filter.sorting_column) {
            csParams.filter.sorting_column = {
              column: 'category',
              order: 'desc'
            };
          }

          var allRows = sortCategories(csParams.filter.sorting_column, true);
          if (csParams.departmentId && tableData[csParams.departmentId]) {
            allRows.footer = [generateRow(tableData[csParams.departmentId], maxMentions, false, true)];
          }

          var tableRows = allRows.rows;

          $.tmpl(detailsTemplate, {
            labels: csParams.labels,
            clusterId: csParams.clusterId,
            lang: csParams.lang,
            widgetUrl: csParams.widget5
          }, {
            checkDetailsLink: _utils.checkDetailsLink
          }).appendTo(detailsContent);

          var headers = [new $.ty.table.Cell('category', csParams.labels.category), new $.ty.table.Cell('performance', csParams.labels.performance), new $.ty.table.Cell('trend', csParams.labels.trend), new $.ty.table.Cell('mentions', csParams.labels.mentions, 'left'), new $.ty.table.Cell('positive', csParams.labels.common_positive), new $.ty.table.Cell('neutral', csParams.labels.common_neutral), new $.ty.table.Cell('negative', csParams.labels.common_negative)];

          // Resizing iframe
          $(detailsContent).find('.category-details-tabs iframe').iFrameResize();

          // Rendering table
          var $table = $(detailsContent).find('.sentiment_table');
          $table.table({
            selectable: 'all',
            header: headers,
            rows: tableRows,
            footer: allRows.footer,
            multiple_footer: true,
            striped: false,
            enable_sorting: true,
            sorting_column: csParams.filter.sorting_column
          });

          $table.find('.placeholder-category').each(function (index) {
            var category = $(this).data('category');
            if (tableData && category && tableData[category] && tableData[category].data) {
              $(this).singlebarchart({
                id: category,
                values: [new $.ty.singlebarchart.Element(category + '-pos', tableData[category].data.posCount, csParams.labels.positive_mentions.replace('{number}', tableData[category].data.posCount)), new $.ty.singlebarchart.Element(category + '-neu', tableData[category].data.neuCount, csParams.labels.neutral_mentions.replace('{number}', tableData[category].data.neuCount)), new $.ty.singlebarchart.Element(category + '-neg', tableData[category].data.negCount, csParams.labels.negative_mentions.replace('{number}', tableData[category].data.negCount))],
                maxTotal: maxMentions
              });
            }
          });

          // Rendering wordclouds
          var $wordcloud = $(detailsContent).find('.word-cloud-wrapper');
          var $wordcloudPos = $wordcloud.find('.word-cloud-pos').addClass('l-left');
          var $wordcloudNeu = $wordcloud.find('.word-cloud-neu').addClass('l-left');
          var $wordcloudNeg = $wordcloud.find('.word-cloud-neg').addClass('l-left');

          var updateWordClouds = function () {
            var wordCloudCategories = {
              pos: [],
              neg: [],
              neu: [],
              maxMentions: 1
            };
            var count = 0;

            /**
             * Use this data structure to check if categories are already mentioned in wordcloud
             * Workaround to fix TM-7278
             * @type {{pos: Array, neu: Array, neg: Array}}
             */
            var alreadyMentionedCategories = {
              pos: [],
              neu: [],
              neg: []
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = csParams.filter.categorySelection[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _category = _step2.value;

                if (tableData && _category && tableData[_category] && tableData[_category].data) {
                  if (tableData[_category] && tableData[_category].data.posCount > 0 && alreadyMentionedCategories.pos.indexOf(_category) === -1) {
                    if (tableData[_category].data.posCount > wordCloudCategories.maxMentions) {
                      wordCloudCategories.maxMentions = tableData[_category].data.posCount;
                    }
                    wordCloudCategories.pos.push(new $.ty.wordcloud.Element(tableData[_category].data.id + '-pos', tableData[_category].data.positiveName, tableData[_category].data.posCount));
                    alreadyMentionedCategories.pos.push(_category);
                  }

                  if (tableData[_category] && tableData[_category].data.negCount > 0 && alreadyMentionedCategories.neg.indexOf(_category) === -1) {
                    if (tableData[_category].data.negCount > wordCloudCategories.maxMentions) {
                      wordCloudCategories.maxMentions = tableData[_category].data.negCount;
                    }
                    wordCloudCategories.neg.push(new $.ty.wordcloud.Element(tableData[_category].data.id + '-neg', tableData[_category].data.negativeName, tableData[_category].data.negCount));
                    alreadyMentionedCategories.neg.push(_category);
                  }

                  if (tableData[_category] && tableData[_category].data.neuCount > 0 && alreadyMentionedCategories.neu.indexOf(_category) === -1) {
                    if (tableData[_category].data.neuCount > wordCloudCategories.maxMentions) {
                      wordCloudCategories.maxMentions = tableData[_category].data.neuCount;
                    }
                    wordCloudCategories.neu.push(new $.ty.wordcloud.Element(tableData[_category].data.id + '-neu', tableData[_category].data.neutralName, tableData[_category].data.neuCount));
                    alreadyMentionedCategories.neu.push(_category);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (wordCloudCategories.pos.length > 0) {
              count += 1;
            }
            if (wordCloudCategories.neu.length > 0) {
              count += 1;
            }
            if (wordCloudCategories.neg.length > 0) {
              count += 1;
            }

            $wordcloudPos.wordcloud({
              values: wordCloudCategories.pos,
              maxTotal: wordCloudCategories.maxMentions
            });

            if (wordCloudCategories.pos.length > 0) {
              if (wordCloudCategories.neu.length + wordCloudCategories.neg.length > 0) {
                $wordcloudPos.removeClass('l-align-right l-align-justify').addClass('l-align-right');
              } else {
                $wordcloudPos.removeClass('l-align-right l-align-justify').addClass('l-align-justify');
              }

              $wordcloudPos.css('width', (100 / count).toString() + '%');
            }

            $wordcloudNeu.wordcloud({
              values: wordCloudCategories.neu,
              maxTotal: wordCloudCategories.maxMentions
            });

            if (wordCloudCategories.neu.length > 0) {
              if (wordCloudCategories.neg.length > 0) {
                if (wordCloudCategories.pos.length > 0) {
                  $wordcloudNeu.removeClass('l-align-right l-align-left l-align-justify').addClass('l-align-justify');
                } else {
                  $wordcloudNeu.removeClass('l-align-right l-align-left l-align-justify').addClass('l-align-right');
                }
              } else if (wordCloudCategories.pos.length > 0) {
                $wordcloudNeu.removeClass('l-align-right l-align-left l-align-justify').addClass('l-align-left');
              } else {
                $wordcloudNeu.removeClass('l-align-right l-align-left l-align-justify').addClass('l-align-justify');
              }

              $wordcloudNeu.css('width', (100 / count).toString() + '%');
            }

            $wordcloudNeg.wordcloud({
              values: wordCloudCategories.neg,
              maxTotal: wordCloudCategories.maxMentions
            });

            if (wordCloudCategories.neg.length > 0) {
              if (wordCloudCategories.pos.length + wordCloudCategories.neu.length > 0) {
                $wordcloudNeg.removeClass('l-align-left l-align-justify').addClass('l-align-left');
              } else {
                $wordcloudNeg.removeClass('l-align-left l-align-justify').addClass('l-align-justify');
              }

              $wordcloudNeg.css('width', (100 / count).toString() + '%');
            }
          };

          // Hack to make it nicer
          $(detailsContent).find('.sentiment_table').css('overflow', 'visible');

          csParams.filter.preselection = csParams.filter.preselection || 'custom';
          if (csParams.filter.preselection !== 'custom') {
            var computePreselection = function (action) {
              var rowStates = [],
                  expandParents = [];
              var selection = void 0;
              csParams.filter.categorySelection = [];

              var addSelection = function (id) {
                if ($.inArray(id, csParams.filter.categorySelection) === -1) {
                  csParams.filter.categorySelection.push(id);
                }
              };

              var isValidCategory = function (category) {
                if (category.count && category.count > 0 && (!csParams.departmentId && !category.id.match('^dept_') || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1)) {
                  return true;
                }
                return false;
              };

              if (action === 'all') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.all);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: true
                    });
                    addSelection(category.id);
                    if (tableData[category.id].isParent === false) {
                      $.map(tableData[category.id].data.parentIds, function (value) {
                        if ($.inArray(value, expandParents) === -1) {
                          expandParents.push(value);
                        }
                      });
                    }
                  }
                });
              } else if (action === 'none') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.none);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: false
                    });
                  }
                });
              } else if (action === 'categories') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.categories);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: tableData[category.id].isParent
                    });
                    if (tableData[category.id].isParent) {
                      addSelection(category.id);
                    }
                  }
                });
              } else if (action === 'subcategories') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.subcategories);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: tableData[category.id].isParent === false
                    });
                    if (tableData[category.id].isParent === false) {
                      $.map(tableData[category.id].data.parentIds, function (value) {
                        if ($.inArray(value, expandParents) === -1) {
                          expandParents.push(value);
                        }
                      });
                      addSelection(category.id);
                    }
                  }
                });
              } else if (action === 'positive') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.common_positive);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: tableData[category.id].data.performance > scaled.sentimentColorThresholds.green
                    });
                    if (tableData[category.id].isParent === false && tableData[category.id].data.performance > scaled.sentimentColorThresholds.green) {
                      $.map(tableData[category.id].data.parentIds, function (value) {
                        if ($.inArray(value, expandParents) === -1) {
                          expandParents.push(value);
                        }
                      });
                    }
                    if (tableData[category.id].data.performance > scaled.sentimentColorThresholds.green) {
                      addSelection(category.id);
                    }
                  }
                });
              } else if (action === 'neutral') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.common_neutral);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green
                    });
                    if (tableData[category.id].isParent === false && tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green) {
                      $.map(tableData[category.id].data.parentIds, function (value) {
                        if ($.inArray(value, expandParents) === -1) {
                          expandParents.push(value);
                        }
                      });
                    }
                    if (tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green) {
                      addSelection(category.id);
                    }
                  }
                });
              } else if (action === 'negative') {
                selection = csParams.labels.select.replace('{selection}', csParams.labels.common_negative);
                $.each(data.categories, function (_, category) {
                  if (isValidCategory(category)) {
                    rowStates.push({
                      row_id: category.id,
                      state: tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow
                    });
                    if (tableData[category.id].isParent === false && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow) {
                      $.map(tableData[category.id].data.parentIds, function (value) {
                        if ($.inArray(value, expandParents) === -1) {
                          expandParents.push(value);
                        }
                      });
                    }
                    if (tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow) {
                      addSelection(category.id);
                    }
                  }
                });
              }

              $table.table('selectRows', rowStates);

              return {
                expand_parents: expandParents,
                selection: selection
              };
            };

            if (!csParams.filter.preselection) {
              if (csParams.departmentId) {
                csParams.filter.preselection = 'all';
              } else {
                csParams.filter.preselection = 'custom';
              }
            }

            var preselection = computePreselection(csParams.filter.preselection);
            var expandParentsState = preselection.expand_parents.map(function (parent) {
              return {
                row_id: parent,
                state: true
              };
            });

            if (expandParentsState.length) {
              $table.table('expandRows', expandParentsState);
            }
          }
          updateWordClouds();

          // Waiting 5s for the iframe to load
          setTimeout(function () {
            rendererDeferred.resolve();
          }, 5000);
        };

        // Hack for MIM incident, just load the google charts here to avoid having to configure the optimizer due to MIM - AM-1828
        require(['goog!visualization,1,packages:[table,corechart,gauge]']);

        // Hack for MIM incident with phantomjs in export-app not loading ever charts lib (never calls renderFN) - AM-1642
        // Removed google.load call - AM-1828
        renderFn();
        // Hack for MIM incident with phantomjs in export-app not loading ever charts lib (never calls renderFN) - AM-1642

        return rendererDeferred;
      },
      excelRenderer: function (data) {
        var self = this;
        var csParams = extendParams(self._exportData().params.module.options),
            scaled = _utils.scaleUtils(csParams.scale),
            categoriesWithData = [],
            groupedTableCategoryRows = [],
            tableCategoryRows = [],
            sourceId = getSourceId(csParams),
            departmentNeededCategories = {},
            footers = [];
        var departmentCategories = void 0;

        if (csParams.departmentId) {
          departmentCategories = csParams.departments[csParams.departmentId].split(',');
          departmentNeededCategories[csParams.departmentId] = true;
        }

        // Compute performance index and choose icon categories
        $.each(data.categories, function (_, category) {
          var performance = category.posCount * 100 / category.count;
          var unscaledPerformance = void 0,
              pastPerformance = void 0;

          if (isNaN(performance)) {
            category.performance = Infinity;
            category.trend = 0;
          } else {
            category.performance = scaled.round(scaled.scale(performance));
            unscaledPerformance = category.pastCount > 0 ? category.posPastCount * 100 / category.pastCount : 0;
            pastPerformance = scaled.round(scaled.scale(unscaledPerformance));
            if (!isNaN(pastPerformance) && pastPerformance !== 0 && category.performance) {
              category.trend = (category.performance - pastPerformance) / pastPerformance;
            } else {
              category.trend = 0;
            }
          }
        });

        var sortCategories = function (cData, rows) {
          var sortOrder = cData.order === 'asc' ? 1 : -1,
              columnOrder = void 0;

          switch (cData.column) {
            case 'category':
              {
                columnOrder = 0;

                // The sort by name should be reversed
                sortOrder *= -1;
                break;
              }
            case 'performance':
              {
                columnOrder = 1;
                break;
              }
            case 'trend':
              {
                columnOrder = 2;
                break;
              }
            case 'mentions':
              {
                columnOrder = 3;
                break;
              }
            case 'positive':
              {
                columnOrder = 4;
                break;
              }
            case 'neutral':
              {
                columnOrder = 5;
                break;
              }
            case 'negative':
              {
                columnOrder = 6;
                break;
              }
          }

          // Sort Parents
          tableCategoryRows.sort(function (a, b) {
            if (a[columnOrder].value < b[columnOrder].value) {
              return -1 * sortOrder;
            } else if (a[columnOrder].value > b[columnOrder].value) {
              return 1 * sortOrder;
            } else {
              return 0;
            }
          });
        };

        var tileName = (csParams.clusterId ? csParams.labels.sentiment : csParams.labels.groupSentiment) + ' - ';
        var columnChartTitle = void 0,
            tableCategoryTitle = void 0;
        if (csParams.departmentId) {
          tableCategoryTitle = csParams.metacategoryI18n[csParams.departmentId] + ' - ' + csParams.labels.sentiment;
        } else if (sourceId.includes(-1)) {
          columnChartTitle = tileName + csParams.labels.chartsTab;
          tableCategoryTitle = tileName + csParams.labels.tableTab;
        } else {
          var sourceName = csParams.sourceName ? csParams.sourceName + ' - ' : '';
          columnChartTitle = sourceName + tileName + csParams.labels.chartsTab;
          tableCategoryTitle = sourceName + tileName + csParams.labels.tableTab;
        }

        var columnChartData = [['s', JSON.stringify({
          label: columnChartTitle
        })]];

        var tableCategoryData = [['s', JSON.stringify({
          label: tableCategoryTitle
        })]];

        _utils.tableHeaderCaption(columnChartData, csParams);

        _utils.tableHeaderCaption(tableCategoryData, csParams);

        var columnChartHeaders = [{
          type: 'string',
          width: 30,
          value: ' '
        }];

        var columnChartRows = [[{
          type: 'string',
          value: csParams.labels.common_positive
        }], [{
          type: 'string',
          value: csParams.labels.common_neutral
        }], [{
          type: 'string',
          value: csParams.labels.common_negative
        }]];

        var tableCategoryHeaders = [{
          type: 'string',
          width: 30,
          value: csParams.labels.category
        }, {
          type: 'string',
          format: {
            align: 'center'
          },
          value: csParams.labels.performance
        }, {
          type: 'string',
          format: {
            align: 'center',
            num_format: '0.0%'
          },
          value: csParams.labels.trend
        }, {
          type: 'string',
          format: {
            align: 'center'
          },
          value: csParams.labels.mentions
        }, {
          type: 'string',
          value: csParams.labels.common_positive
        }, {
          type: 'string',
          value: csParams.labels.common_neutral
        }, {
          type: 'string',
          value: csParams.labels.common_negative
        }];

        // Store the category ids that have data (matches)
        $.each(data.categories, function (idx, category) {
          if (Math.round(category.count)) {
            categoriesWithData.push(category.id);
          }
        });

        $.each(data.categories, function (__, category) {
          var mentions = Math.round(category.count),
              posCount = Math.round(category.posCount) || 0,
              neuCount = Math.round(category.neuCount) || 0,
              negCount = Math.round(category.negCount) || 0;
          var tableCategory = void 0;

          if (mentions) {
            // Add table row(s)

            if (!csParams.departmentId && !category.id.match('^dept_') || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1) {
              tableCategory = [{
                type: 'string',
                categoryId: category.id,
                value: category.parentIds.length ? ' - ' + category.name : category.name
              }, {
                type: 'number',
                format: {
                  font_color: _utils.excelColored(category.performance, scaled.sentimentColorThresholds)
                },
                value: _utils.isNumber(category.performance) ? category.performance : null
              }, {
                type: 'number',
                value: _utils.isNumber(category.trend) ? category.trend : null
              }, {
                type: 'number',
                value: _utils.isNumber(mentions) ? mentions : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(posCount) ? posCount : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(neuCount) ? neuCount : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(negCount) ? negCount : null
              }];
            } else if (csParams.departmentId && !category.id.match('^dept_')) {
              tableCategory = [{
                type: 'string',
                categoryId: category.id,
                value: category.parentIds.length ? ' - ' + category.name : category.name
              }, {
                type: 'number',
                value: null
              }, {
                type: 'number',
                value: null
              }, {
                type: 'number',
                value: null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: null
              }];
            } else if (csParams.departmentId && csParams.departments[category.id]) {
              footers.push([{
                type: 'string',
                categoryId: category.id,
                value: category.parentIds.length ? ' - ' + category.name : category.name
              }, {
                type: 'number',
                format: {
                  font_color: _utils.excelColored(category.performance, scaled.sentimentColorThresholds)
                },
                value: _utils.isNumber(category.performance) ? category.performance : null
              }, {
                type: 'number',
                value: _utils.isNumber(category.trend) ? category.trend : null
              }, {
                type: 'number',
                value: _utils.isNumber(mentions) ? mentions : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(posCount) ? posCount : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(neuCount) ? neuCount : null
              }, {
                type: 'number',
                format: {
                  align: 'center'
                },
                value: _utils.isNumber(negCount) ? negCount : null
              }]);
              return true;
            } else {
              return true;
            }

            if (category.parentIds.length) {
              // Add one subcategory for each parent
              $.each(category.parentIds, function (idx, parentId) {
                var tableCategoryParent = $.extend(true, [], tableCategory);

                // TODO remove the 'if' when the described issue is fixed
                if (categoriesWithData.indexOf(parentId) !== -1) {
                  /*
                     Only for parents with matches.
                      There is a known issue which may result in a top-level category count being 0,
                     even though the subcategories have matches of their own.
                     */

                  tableCategoryParent[0] = $.extend(true, {}, tableCategoryParent[0], {
                    parentId: parentId
                  });
                  tableCategoryRows.push(tableCategoryParent);
                }
              });
            } else {
              tableCategoryRows.push(tableCategory);
            }

            /*
               If we display all the categories add only the top-level ones to the column chart.
               If a specific category was requested also add its children.
               */
            if (!csParams.categoryId && !category.parentIds.length && !csParams.departmentId || csParams.categoryId && !csParams.departmentId) {
              columnChartHeaders.push({
                type: 'string',
                value: category.name
              });

              columnChartRows[0].push({
                type: 'number',
                value: _utils.isNumber(posCount) ? posCount : null
              });

              columnChartRows[1].push({
                type: 'number',
                value: _utils.isNumber(neuCount) ? neuCount : null
              });

              columnChartRows[2].push({
                type: 'number',
                value: _utils.isNumber(negCount) ? negCount : null
              });
            }
          }
          return true;
        });

        if (!csParams.filter) {
          csParams.filter = {};
        }

        if (!csParams.filter.sorting_column) {
          csParams.filter.sorting_column = {
            column: 'category',
            order: 'desc'
          };
        }

        sortCategories(csParams.filter.sorting_column, tableCategoryRows);

        $.each(tableCategoryRows, function (_, row) {
          if (!row[0].parentId) {
            groupedTableCategoryRows.push(row);

            $.each(tableCategoryRows, function (__, child) {
              if (child[0].parentId === row[0].categoryId) {
                groupedTableCategoryRows.push(child);
              }
            });
          }
        });

        if (!csParams.departmentId) {
          columnChartData.push(['r', JSON.stringify({
            height: 47,
            format: {
              align: 'center',
              text_wrap: 1
            },
            chart: {
              type: 'column',
              subtype: 'stacked'
            }
          }), JSON.stringify(columnChartHeaders)]);

          $.each(columnChartRows, function (idx, row) {
            columnChartData.push(['r', JSON.stringify({
              format: {
                text_wrap: 1
              },
              chart: {
                border: {
                  color: csParams.semaChartOptions.colors[idx]
                },
                fill: {
                  color: csParams.semaChartOptions.colors[idx]
                }
              }
            }), JSON.stringify(row)]);
          });
        }

        tableCategoryData.push(['r', JSON.stringify({
          height: 47,
          format: {
            align: 'center',
            text_wrap: 1
          }
        }), JSON.stringify(tableCategoryHeaders)]);

        $.each(groupedTableCategoryRows, function (idx, row) {
          tableCategoryData.push(['r', JSON.stringify({
            height: 25,
            format: {
              text_wrap: 1
            }
          }), JSON.stringify(row)]);
        });

        if (!csParams.departmentId) {
          return $.Deferred().resolve(tableCategoryData.concat(columnChartData));
        }

        $.each(footers, function (idx, row) {
          tableCategoryData.push(['r', JSON.stringify({
            height: 25,
            format: {
              text_wrap: 1,
              bg_color: csParams.footerColor
            }
          }), JSON.stringify(row)]);
        });
        return $.Deferred().resolve(tableCategoryData);
      }
    };

    return $.fn.TyraExport.predefined.CategoryScores;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/export',['./tiles/sentiment/export'], function (CategoryScores) {
    return {
      CategoryScores: CategoryScores
    };
  });
})();
(function ($) {
  'use strict';

  define('commons/public/js/tyra-5/tiles/tileUtils',['moment'], function (moment) {
    function doAjax(params) {
      var defaults = {
        dataType: 'json',
        cache: false
      };
      return $.ajax($.extend({}, defaults, params));
    }

    function doJSONP(params) {
      return $.when(doAjax($.extend({
        dataType: 'jsonp',
        jsonp: 'callback'
      }, params))).pipe(function (data) {
        // The failure of a JSONP request can be determined only through its metadata
        if (data.meta.code !== 200) {
          return $.Deferred().reject(data);
        } else {
          return data;
        }
      });
    }

    function isoToDate(s) {
      var parts = s.split('-');
      var date = new Date();

      date.setFullYear(parts[0], +parts[1] - 1, parts[2]);
      date.setHours(0, 0, 0, 0);

      return date;
    }

    /**
     * Table API trends exclude the 'from' day so we have to make the call with from date
     *
     * @param prefix an array of column fields that precede the 'from' date. e.g. for
     * review counts this parameter would be
     *         ['reviews', 'trend'].
     * @param from the 'from' date as an iso string
     * @param to the 'to' date as an iso string
     *
     * @return the previous day as a string
     */
    function _hackedTrend(prefix, from, to) {
      var column = [].concat(prefix);

      var fromDate = moment(from ? isoToDate(from) : new Date());
      var fromDateFormatted = fromDate.format('YYYY-MM-DD');
      column.push(fromDateFormatted);
      if (to) {
        column.push(to);
      }

      return column;
    }

    /** *
     * This method is used to parse all API responses that emulate Table API (tabular json structure).
     * Changes to this method might break the parsing of Goals API data.
     */
    function parseTableApi(tableData, columns) {
      var parsed = {};
      var createRowData = function (data, i) {
        var rowData = {};
        columns.forEach(function (name, idx) {
          rowData[name] = data[i][idx];
        });
        return rowData;
      };

      $.each(tableData, function (sourceId, data) {
        parsed[sourceId] = [];

        // Omit the header
        for (var i = 1; i < data.length; ++i) {
          var rowData = createRowData(data, i);
          parsed[sourceId].push(rowData);
        }
      });

      return parsed;
    }

    function resetTime(date) {
      date.setHours(0, 0, 0, 0);
      return date;
    }

    function comparisonPeriod(from, to) {
      var now = resetTime(new Date());
      from = moment(from ? isoToDate(from) : now);
      to = moment(to ? isoToDate(to) : now);

      // Compute to-from
      var days = to.diff(from, 'days');

      // The previous period ends one day before the current one. The extremities are inclusive.
      var previousTo = from.subtract('days', 1);
      var previousFrom = moment(previousTo).subtract('days', days);

      return {
        from: previousFrom.format('YYYY-MM-DD'),
        to: previousTo.format('YYYY-MM-DD')
      };
    }

    function scaleUtils(scale) {
      if (scale !== 100 && scale !== 5 && scale !== 10) {
        throw new Error('Unsupported scale: ' + scale);
      }

      return {
        scale: function (n) {
          if (n === null) {
            return null;
          }
          return n / (100 / scale);
        },
        round: function (n) {
          if (n === null) {
            return null;
          }

          switch (scale) {
            case 100:
              {
                return Math.round(n);
              }
            default:
              {
                // for both 5 and 10
                // One decimal
                return +n.toFixed(1);
              }
          }
        },
        trustscoreColorThresholds: {
          green: scale * 0.746, // 100: 74.6, 10: 7.46, 5: 3.73
          yellow: scale * 0.6705, // 100: 67.05, 10: 6.705, 5: 3.3525
          exclusive: true
        },
        sentimentColorThresholds: {
          green: scale * 0.70, // 100: 70, 10: 3.5, 5: 3.5
          yellow: scale * 0.50, // 100: 50, 10: 5.0, 5: 2.5
          exclusive: true
        },
        popularityColorThresholds: {
          green: scale * 0.8, // 100: 80, 10: 8, 5: 4
          yellow: scale * 0.2 // 100: 20, 10: 2, 5: 1
        },
        responseRateColorThresholds: {
          green: 30,
          yellow: 15
        }
      };
    }

    function getMatchingTrendArrow(trendValue, label, noTrendLabel) {
      if (!label) {
        label = '';
      }
      var trendIncreaseArrow = '' + ('<span class="trend text-positive">' + '<i class="ty-icon ty-icon-arrow-up"></i> ') + label + '</span> ';
      var trendDecreaseArrow = '' + ('<span class="trend text-negative">' + '<i class="ty-icon ty-icon-arrow-down"></i> ') + label + '</span> ';
      var trendStable = '<span class="trend"><i class="ty-icon ty-icon-blank"></i></span> ';
      if (noTrendLabel) {
        trendStable = '<span class="trend text-help">' + noTrendLabel + '</span>';
      }

      var trendArrow = trendValue > 0 ? trendIncreaseArrow : null;
      if (trendArrow === null) {
        trendArrow = trendValue < 0 ? trendDecreaseArrow : trendStable;
      }

      return trendArrow;
    }

    // TODO replace all time range setters with this
    function addTimeRange(data, from, to) {
      if (from) {
        data.from = from;
      }
      if (to) {
        data.to = to;
      }

      return data;
    }

    function colored(val, thresholds, text) {
      if (!thresholds) {
        throw new Error('Specify color thresholds');
      }

      var cmp = function (value, thrs) {
        return thresholds.exclusive ? value > thrs : value >= thrs;
      };

      var $el = $('<b></b>');

      if (cmp(val, thresholds.green)) {
        $el.addClass('text-positive');
      } else if (cmp(val, thresholds.yellow)) {
        $el.addClass('text-neutral');
      } else if (!thresholds.hasOwnProperty('red') || cmp(val, thresholds.red)) {
        // The threshold for 'red' may be missing, meaning everything that's neither 'green' nor 'yellow'
        $el.addClass('text-negative');
      }

      return $('<b></b>').append($el.text(text || val)).html();
    }

    function coloredClass(val, thresholds, text) {
      var clazz = void 0;

      if (!thresholds) {
        throw new Error('Specify color thresholds');
      }

      var cmp = function (value, thrs) {
        return thresholds.exclusive ? value > thrs : value >= thrs;
      };

      if (cmp(val, thresholds.green)) {
        clazz = 'text-positive';
      } else if (cmp(val, thresholds.yellow)) {
        clazz = 'text-neutral';
      } else if (!thresholds.hasOwnProperty('red') || cmp(val, thresholds.red)) {
        // The threshold for 'red' may be missing, meaning everything that's neither 'green' nor 'yellow'
        clazz = 'text-negative';
      }

      return clazz;
    }

    function createTemplate(template) {
      return $.template(template);
    }

    function checkDetailsLink(label, data) {
      var link = $('<a class="check-details" href="javascript:void(0)"></a>').text(label);

      $.each(data, function (key, value) {
        link.attr('data-' + key, value);
      });

      return $('<div></div>').append(link).html();
    }

    var tileDefaults = {
      widget4: '/widget-api4/',
      widget5: '/',
      group: '/group/',
      tasks: '/tasks/',
      goals: '/goals/',
      i18n: '/i18n/',
      reviews: '/reviews/',
      impact: '___impact_app_url___', // replaced by gulp file
      scale: 100,
      chartWidth: 920,
      colorsNoRedGreen: ['#36c', '#F90', '#909', '#088A85', '#610B0B', '#0B0B61', '#DF01D7', '#00FFFF', '#FFFF00']
    };

    return {
      doAjax: doAjax,
      doJSONP: doJSONP,
      _hacked_trend: _hackedTrend,
      isoToDate: isoToDate,
      parseTableApi: parseTableApi,
      comparisonPeriod: comparisonPeriod,
      resetTime: resetTime,
      scaleUtils: scaleUtils,
      getMatchingTrendArrow: getMatchingTrendArrow,
      addTimeRange: addTimeRange,
      colored: colored,
      coloredClass: coloredClass,
      createTemplate: createTemplate,
      checkDetailsLink: checkDetailsLink,
      tileDefaults: tileDefaults
    };
  });
})(jQuery);
(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/sentiment/tile.tpl',['jquery', './../tileUtils'], function ($, utils) {
    return {
      categoryScores: utils.createTemplate('' + '<p>${description}:</p>' + '{{if categories.length}}' + '<ul>' + '{{each(idx, category) categories }}' + '<li><span>${category.name}</span>{{html category.formattedTrend}}</li>' + '{{/each}}' + '</ul>' + '{{else}}' + '<p>${none}</p>' + '{{/if}}' + '<div class="time-label">${rangeTimeLabel}</div>'),
      singleCategory: utils.createTemplate('' + '<div class="two-row">' + '<div>' + '<span class="score big">{{html performance}}</span>' + '/${scale}' + '</div>' + '<div>${labels.iconDescription}</div>' + '<div class="time-label">${rangeTimeLabel}</div>' + '</div>'),
      singleDepartment: utils.createTemplate('' + '<div class="score">' + '<div class="score-info">' + '<span class="value ${performanceClass}">${performance}</span>' + '{{html trend}}' + '</div>' + '<div class="score-icon">' + '<i class="ty-icon ${icon}"></i>' + '</div>' + '</div>'),
      categoryDetails: utils.createTemplate('' + '<div class="category-details-tabs">' + '<div id="category-details-tab-sentiment">' + '<div class="trustyou-ui toolbar">' + '{{if showSourceDropdown}}' + '<div class="trustyou-ui control-group">' + '<div id="sentiment-tile-source-dropdown"></div>' + '<a class="trustyou-ui btn btn-positive" id="sentiment-tile-source-button">${labels.apply}</a>' + '</div>' + '{{/if}}' + '<div class="trustyou-ui control-group {{if showSourceDropdown}} l-right {{else}} l-left {{/if}}">' + '<div id="sentiment-tile-category-dropdown"></div>' + '<div class="trustyou-ui btn btn-light reset-cloud">' + '<span>${labels.reset_cloud}</span>' + '</div>' + '</div>' + '</div>' + '<div class="sentiment_table" style="margin-top:10px"></div>' + '<div class="word-cloud-wrapper">' + '<div class="word-cloud-pos"></div>' + '<div class="word-cloud-neu"></div>' + '<div class="word-cloud-neg"></div>' + '</div>' + '</div>' + '</div>')
    };
  });
})(jQuery);
(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/sentiment/tile',['jquery', './../tileUtils', './tile.tpl', 'dropdownsmartlist-template', 'ty-i18n!dashboard-app', 'ty-i18n!metacategory', 'single-barchart', 'wordcloud', 'dropdownsmartlist', 'table'], function ($, utils, templates, ddSmartList, dashboardI18n, metacategoryI18n) {
    var scaled = void 0;

    var getTableData = function (csParams, columns) {
      var tableData = {
        column_list: JSON.stringify(columns),
        source_list: JSON.stringify(csParams.sourceId),
        v: JSON.stringify(8)
      };

      if (!csParams.clusterId && csParams.groupId) {
        tableData.group_list = JSON.stringify([csParams.groupId]);
      } else {
        tableData.cluster_list = JSON.stringify([csParams.clusterId]);
      }

      utils.addTimeRange(tableData, csParams.from, csParams.to);

      return utils.doAjax({
        url: csParams.group + 'table',
        type: 'post',
        data: tableData
      });
    };

    /*
     * Sums column data across multiple sources
     * Casts string and null values to integers
     */
    var aggregateSourceData = function (parsedObject) {
      var agg = {};
      for (var k in parsedObject) {
        if (parsedObject.hasOwnProperty(k)) {
          var dataSlice = parsedObject[k][0];
          for (var i in dataSlice) {
            if (dataSlice.hasOwnProperty(i)) {
              agg[i] = (agg[i] || 0) + +dataSlice[i];
            }
          }
        }
      }
      return agg;
    };

    var getCategories = function (csParams) {
      return utils.doJSONP({
        url: csParams.widget5 + 'hotels/sources/' + -1, // csParams.sourceId.join(','),
        data: {
          lang: csParams.lang
        }
      });
    };

    var sourceIdToArray = function (anyValue) {
      if (!anyValue) {
        return [-1];
      }
      if (typeof anyValue === 'string' || Number.isInteger(anyValue)) {
        return [String(anyValue)];
      }
      return anyValue;
    };

    var getModuleIconElem = function (contentEl) {
      return $(contentEl).closest('.dashboard-grid').find('.module-icon.expanded');
    };

    var getViewData = function (csParams, contentEl, visibleParents) {
      var viewData = csParams.getModuleData(getModuleIconElem(contentEl));
      if (!viewData.filter || viewData.filter.length === 0 || !viewData.filter.categorySelection) {
        viewData.filter = {
          categorySelection: visibleParents.map(function (category) {
            if (!csParams.departmentId && !csParams.departments[category.id] || csParams.departmentId && csParams.department_categories.includes(category.id) || category.id === '36') {
              return category.id;
            }
            return null;
          }).filter(Boolean)
        };
      }

      if (!viewData.filter.sorting_column) {
        viewData.filter.sorting_column = {
          column: 'category',
          order: 'desc'
        };
      }

      if (!viewData.filter.preselection) {
        viewData.filter.preselection = csParams.departmentId ? 'all' : 'custom';
      }

      if (!viewData.filter.selectedSources) {
        viewData.filter.selectedSources = sourceIdToArray(csParams.sourceId);
      }

      viewData.parentFilterUpdated = csParams.parentFilterUpdated;

      return viewData;
    };

    var updateFilters = function (csParams, contentEl, viewData) {
      var triggerUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      csParams.setModuleData(getModuleIconElem(contentEl), viewData);
      if (triggerUpdate) {
        csParams.filterUpdated($(contentEl));
      }
    };

    var iconDataprovider = function (csParams) {
      var deferred = $.Deferred();

      // Get names
      getCategories(csParams).done(function (data) {
        var categories = [],
            categoryIds = [],
            columns = [];
        var comparison = void 0;

        $.each(data.response.cluster_category_list, function (idx, category) {
          var categoryId = category.category_id;

          // Keep only top-level categories or only the specified category, if any
          if (csParams.departmentId) {
            if (csParams.departmentId === categoryId) {
              categories.push({
                id: categoryId,
                name: category.name
              });

              categoryIds.push(categoryId);

              comparison = utils.comparisonPeriod(csParams.from, csParams.to);

              // Add to table API columns
              columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], csParams.from, csParams.to));
              columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], csParams.from, csParams.to));
              columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], comparison.from, comparison.to));
              columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], comparison.from, comparison.to));
            }
          } else if (!csParams.categoryId || csParams.categoryId === categoryId) {
            categories.push({
              id: categoryId,
              name: category.name
            });

            categoryIds.push(categoryId);

            comparison = utils.comparisonPeriod(csParams.from, csParams.to);

            // Add to table API columns
            columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'neg', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], comparison.from, comparison.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], comparison.from, comparison.to));
          }
        });

        getTableData(csParams, columns).done(function (dat) {
          if (!csParams.departmentId) {
            var newColumns = ['id'].concat($.map(categoryIds, function (id) {
              return [id + '_count', id + '_pos_count', id + '_neg_count', id + '_count-past', id + '_pos_count-past'];
            }));

            var parsedObject = utils.parseTableApi(dat, newColumns);
            var parsed = aggregateSourceData(parsedObject);

            $.each(categories, function (_, category) {
              var categoryId = category.id;

              $.extend(category, {
                count: parsed[categoryId + '_count'],
                posCount: parsed[categoryId + '_pos_count'],
                negCount: parsed[categoryId + '_neg_count'],
                pastCount: parsed[categoryId + '_count-past'],
                posPastCount: parsed[categoryId + '_pos_count-past']
              });
            });
          } else {
            var _newColumns = ['id'].concat($.map(categoryIds, function (id) {
              return [id + '_count', id + '_pos_count', id + '_count_past', id + '_pos_count_past'];
            }));

            var _parsedObject = utils.parseTableApi(dat, _newColumns);
            var _parsed = aggregateSourceData(_parsedObject);

            $.each(categories, function (_, category) {
              var categoryId = category.id;

              $.extend(category, {
                header: category.name,
                count: _parsed[categoryId + '_count'],
                posCount: _parsed[categoryId + '_pos_count'],
                pastCount: _parsed[categoryId + '_count_past'],
                posPastCount: _parsed[categoryId + '_pos_count_past']
              });
            });
          }

          deferred.resolve(categories);
        });
      });
      return deferred;
    };

    var iconRenderer = function (csParams, data, header, content) {
      // Render header & content
      $(header).html(csParams.labels.header);
      $(content).empty();

      scaled = utils.scaleUtils(csParams.scale);

      // Compute performance index
      $.each(data, function (_, category) {
        var performance = category.count > 0 ? category.posCount * 100 / category.count : undefined;
        category.unscaledPerformance = performance;

        if (!isNaN(performance)) {
          category.performance = scaled.round(scaled.scale(performance));
        }

        category.formattedPerformance = isFinite(category.performance) ? utils.colored(category.performance, scaled.sentimentColorThresholds) : '-';
        category.performanceClass = isFinite(category.performance) ? utils.coloredClass(category.performance, scaled.sentimentColorThresholds) : '';
      });

      if (csParams.departmentId) {
        $(header).html(metacategoryI18n[csParams.departmentId] + '<span class="subtitle">' + dashboardI18n.sentiment + '</span>');

        var trend = 0;
        var pastPerformance = data[0].pastCount > 0 ? data[0].posPastCount * 100 / data[0].pastCount : 0;

        if (data[0].pastCount > 0 && data[0].unscaledPerformance !== undefined) {
          if (pastPerformance !== 0) {
            trend = Math.round((data[0].unscaledPerformance - pastPerformance) / pastPerformance * 100 * 10) / 10;
          } else if (data[0].unscaledPerformance > pastPerformance) {
            trend = 100;
          } else if (data[0].unscaledPerformance < pastPerformance) {
            trend = -100;
          }
        }

        $.tmpl(templates.singleDepartment, {
          rangeTimeLabel: csParams.labels.rangeTimeLabel,
          performance: data[0].performance && data[0].performance !== Infinity ? data[0].performance : '-',
          performanceClass: data[0].performanceClass,
          scale: csParams.scale,
          labels: csParams.labels,
          trend: utils.getMatchingTrendArrow(trend, csParams.labels.trend, dashboardI18n.no_trend),
          icon: csParams.departmentIcons[csParams.departmentId]
        }).appendTo(content);
      } else if (!csParams.categoryId) {
        scaled = utils.scaleUtils(csParams.scale);

        $.each(data, function (_, category) {
          var unscaledPerformance = void 0,
              performance = void 0,
              pastPerformance = void 0,
              trend = 0;
          if (category.count && category.count > 0 || csParams.departmentId && csParams.departments[category.id]) {
            unscaledPerformance = category.count > 0 ? category.posCount * 100 / category.count : undefined;
            performance = unscaledPerformance;

            unscaledPerformance = category.pastCount > 0 ? category.posPastCount * 100 / category.pastCount : 0;
            pastPerformance = unscaledPerformance;

            pastPerformance = scaled.round(scaled.scale(pastPerformance));
            performance = category.count > 0 ? scaled.round(scaled.scale(performance)) : undefined;

            if (category.pastCount > 0 && performance !== undefined) {
              if (pastPerformance !== 0) {
                trend = Math.round((performance - pastPerformance) / pastPerformance * 100 * 10) / 10;
              } else if (performance > pastPerformance) {
                trend = 100;
              } else if (performance < pastPerformance) {
                trend = -100;
              }
            }

            category.trend = trend;
            category.formattedTrend = utils.colored(category.trend, scaled.sentimentColorThresholds, category.trend + '%');
          }
        });

        data = jQuery.grep(data, function (category, i) {
          return category.trend < 0 && category.negCount >= 5;
        }).sort(function (categoryA, categoryB) {
          return categoryA.trend - categoryB.trend;
        });

        // Display TOP 3 trending down categories
        $.tmpl(templates.categoryScores, {
          rangeTimeLabel: csParams.labels.rangeTimeLabel,
          description: csParams.labels.trendingDownLabel,
          none: csParams.labels.none,
          categories: data.slice(0, Math.min(data.length, 3))
        }).appendTo(content);
      } else {
        // Display the category performance

        $.tmpl(templates.singleCategory, {
          rangeTimeLabel: csParams.labels.rangeTimeLabel,
          performance: data[0].formattedPerformance,
          scale: csParams.scale,
          labels: csParams.labels
        }).appendTo(content);
      }

      return $.Deferred().resolve(content);
    };

    var detailsDataprovider = function (csParams) {
      var deferred = $.Deferred(),
          reviewsData = {
        cluster_list: JSON.stringify([csParams.clusterId]),
        lang: JSON.stringify([csParams.lang])
      };

      if (!csParams.filter) {
        csParams.filter = {};
      }

      // Add time filter if necessary
      utils.addTimeRange(reviewsData, csParams.from, csParams.to);

      // Get categories
      $.when(getCategories(csParams), utils.doAjax({
        url: csParams.i18n + 'bundles/widget_tops_flops_v2/' + csParams.lang
      }), utils.doAjax({
        url: csParams.i18n + 'bundles/metacategory/' + csParams.lang
      })).done(function (widgetData, bundleReq, bundleCategoriesReq) {
        var bundleData = bundleReq[0],
            bundleCategory = bundleCategoriesReq[0],
            categoryIds = [],
            columns = [],
            departmentNeededCategories = {};
        var departmentCategories = void 0;

        if (csParams.departmentId) {
          departmentCategories = csParams.departments[csParams.departmentId].split(',');
          departmentNeededCategories[csParams.departmentId] = true;
        }

        var comparison = utils.comparisonPeriod(csParams.from, csParams.to);

        var categories = widgetData.response.cluster_category_list.map(function (category) {
          var categoryId = category.category_id,
              parentIds = category.parent_category_list;

          // Only the specified category and its children, if any
          if (!csParams.categoryId || csParams.categoryId === categoryId || parentIds.indexOf(csParams.categoryId) !== -1) {
            if (csParams.departmentId && $.inArray(categoryId, departmentCategories) !== -1) {
              departmentNeededCategories[categoryId] = true;
              $.map(parentIds, function (parentId) {
                departmentNeededCategories[parentId] = true;
              });
            }

            return {
              id: categoryId,
              name: category.name,
              positiveName: bundleData['good_to_know_' + categoryId + '_pos'],
              neutralName: bundleData['good_to_know_' + categoryId + '_neu'],
              negativeName: bundleData['good_to_know_' + categoryId + '_neg'],
              parentIds: parentIds
            };
          }
          return null;
        }).filter(Boolean).map(function (category) {
          var categoryId = category.id;

          if (!csParams.departmentId || departmentNeededCategories[categoryId]) {
            categoryIds.push(categoryId);

            // Add to table API columns
            columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'neg', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'neu', 'trend'], csParams.from, csParams.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'all', 'trend'], comparison.from, comparison.to));
            columns.push(utils._hacked_trend(['matches', categoryId, 'pos', 'trend'], comparison.from, comparison.to));

            return category;
          }
          return null;
        }).filter(Boolean);

        getTableData(csParams, columns).done(function (data) {
          var newColumns = ['id'].concat($.map(categoryIds, function (id) {
            return [id + '_count', id + '_pos_count', id + '_neg_count', id + '_neu_count', id + '_count-past', id + '_pos_count-past'];
          }));
          var parsedObject = utils.parseTableApi(data, newColumns);
          var parsed = aggregateSourceData(parsedObject);

          $.each(categories, function (_, category) {
            var categoryId = category.id;

            $.extend(category, {
              count: +parsed[categoryId + '_count'],
              posCount: parsed[categoryId + '_pos_count'],
              negCount: parsed[categoryId + '_neg_count'],
              neuCount: parsed[categoryId + '_neu_count'],
              pastCount: parsed[categoryId + '_count-past'],
              posPastCount: parsed[categoryId + '_pos_count-past']
            });
          });

          deferred.resolve({
            categoryLabels: bundleCategory,
            categories: categories
          });
        });
      });

      return deferred;
    };

    var detailsRenderer = function (csParams, data, header, content) {
      var $contentEl = $(content),
          visibleParents = [],
          tableData = {},
          deferred = $.Deferred(),
          categoryExpand = [];
      var maxMentions = 1,
          rerenderWordCloud = false;

      var departmentCategories = csParams.departmentId ? csParams.departments[csParams.departmentId].split(',') : [];
      csParams.department_categories = departmentCategories;

      $contentEl.empty();

      // START Methods used in the renderer

      var convertPublicHealthFromCategoryToDepartment = function (category) {
        if (category.id === '36') {
          category.id = 'dept_36';
        }
      };

      var convertPublicHealthFromDepartmentToCategory = function (category) {
        if (category.id === 'dept_36') {
          category.id = '36';
        }
      };

      // Generates a row for the table
      // storeExpand is used to store expanded the first time it loads, but use the array when sorting
      var generateRow = function (category, maxMent, storeExpand, isFooter) {
        var children = [],
            trendArrow = utils.getMatchingTrendArrow(category.data.trend);
        var row = void 0,
            expanded = false;

        if (category.children) {
          $.each(category.children, function (_, child) {
            child = generateRow(child, maxMent, storeExpand);
            if (child) {
              children.push(child);

              // Parent expanded if one child selected and we have custom selection
              // (if not, it will be selected later when calling computePreselection)
              if (storeExpand && viewData.filter.preselection === 'custom' && // eslint-disable-line no-use-before-define
              $.inArray(child.id, viewData.filter.categorySelection) !== -1) {
                // eslint-disable-line no-use-before-define
                expanded = true;
                if ($.inArray(category.id, categoryExpand) === -1) {
                  categoryExpand.push(category.id);
                }
              }
            }
          });

          // Parent expanded if one child selected
          if (!storeExpand && $.inArray(category.id, categoryExpand) !== -1) {
            expanded = true;
          }
        }

        /*  As long as we have to include the Public Health tile on Dashboard panel, we have to keep it on Sentiment tile.
         *  We are aware that aading it to department.properties remove it from Sentiment tile.
         *  Adding this function solves the problem, because the prefix of parent category is not "dept_36",
         *  it's just 36 and without it the public health doesn't appear on Sentiment Tile.
         *  More info for categories where you can see the parent categories:
         *  https://docs.google.com/spreadsheets/d/1uTT0a2vdEDDvyuVH1zD3SkszwqOMqkJ1rneUNeDKth0/edit#gid=157688581 */
        convertPublicHealthFromCategoryToDepartment(category);

        /*  We have to add the condition for public health tile just to make it selectable (creating it as a
         *  children) */
        if (!csParams.departmentId && !csParams.departments[category.id] || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1 || isFooter || category.id === 'dept_36') {
          /* Recovering the original id just to show it on Public Health Tile */
          convertPublicHealthFromDepartmentToCategory(category);
          row = $.ty.table.Row(category.id, !($.inArray(category.id, viewData.filter.categorySelection) === -1 || // eslint-disable-line no-use-before-define
          viewData.filter.preselection !== 'custom'), // eslint-disable-line no-use-before-define
          expanded, [$.ty.table.Cell(category.id, '<a class="placeholder-category-name">' + data.categoryLabels[category.id] + '</a>'), $.ty.table.Cell(category.data.performance, category.data.performance !== undefined ? trendArrow + utils.colored(category.data.performance, scaled.sentimentColorThresholds) : '-'), $.ty.table.Cell(category.data.trend, category.data.performance !== undefined ? (category.data.trend > 0 ? '+' : '') + category.data.trend.toString() + '%' : '-'), $.ty.table.Cell(category.data.count, category.data.performance !== undefined ? '<div class="placeholder-category" title="' + csParams.labels.show_reviews + '" data-category="' + category.id + '" >' + ('</div>' + category.data.count) : '-', 'left'), $.ty.table.Cell(category.data.posCount, category.data.performance !== undefined ? '<a class="placeholder-category-positive-mentions">' + category.data.posCount + '</a>' : '-'), $.ty.table.Cell(category.data.neuCount, category.data.performance !== undefined ? '<a class="placeholder-category-neutral-mentions">' + category.data.neuCount + '</a>' : '-'), $.ty.table.Cell(category.data.negCount, category.data.performance !== undefined ? '<a class="placeholder-category-negative-mentions">' + category.data.negCount + '</a>' : '-')], children);
        } else if (csParams.departmentId && !csParams.departments[category.id]) {
          // Special case for departments, it's used to show empty main categories
          // If no children, then dont show the empty parent
          if (children.length > 0) {
            /* Recovering the original id just to show it on Public Health Tile */
            convertPublicHealthFromDepartmentToCategory(category);
            row = $.ty.table.Row(category.id, !($.inArray(category.id, viewData.filter.categorySelection) === -1 || // eslint-disable-line no-use-before-define
            viewData.filter.preselection !== 'custom'), // eslint-disable-line no-use-before-define
            expanded, [$.ty.table.Cell(category.id, '<a class="placeholder-category-name">' + data.categoryLabels[category.id] + '</a>'), $.ty.table.Cell('', dashboardI18n.not_department_category.replace('{department}', metacategoryI18n[csParams.departmentId]), undefined, 'text-help text-xs')], children, undefined, undefined, true);
          }
        }
        return row;
      };

      // Takes care of showing popup when clicking on the words in the cloud
      var wordCloudPopup = function (e, pData) {
        var category = pData.id.toString();
        var sentimentList = [],
            id = pData.id.toString().split('-');
        var sentiment = id.pop();
        if ($.inArray(sentiment, ['pos', 'neu', 'neg']) !== -1) {
          sentimentList.push(sentiment);
          category = id.join('-');
        }
        csParams.categoryReviewsPopup(category, tableData[category].data.name, sentimentList, null, null, csParams.sourceId);
      };

      // Returns which categories should be shown in the clouds
      var computeWordCloudCategories = function () {
        var words = {
          pos: [],
          neg: [],
          neu: [],
          maxMentions: 1
        };
        $.each(viewData.filter.categorySelection, function (_, category) {
          // eslint-disable-line no-use-before-define
          if (!csParams.departmentId && !csParams.departments[category] || csParams.departmentId && $.inArray(category, departmentCategories) !== -1) {
            if (tableData && category && tableData[category] && tableData[category].data) {
              if (tableData[category] && tableData[category].data.posCount > 0) {
                if (tableData[category].data.posCount > words.maxMentions) {
                  words.maxMentions = tableData[category].data.posCount;
                }
                words.pos.push(new $.ty.wordcloud.Element(tableData[category].data.id + '-pos', tableData[category].data.positiveName, tableData[category].data.posCount));
              }
              if (tableData[category] && tableData[category].data.negCount > 0) {
                if (tableData[category].data.negCount > words.maxMentions) {
                  words.maxMentions = tableData[category].data.negCount;
                }
                words.neg.push(new $.ty.wordcloud.Element(tableData[category].data.id + '-neg', tableData[category].data.negativeName, tableData[category].data.negCount));
              }
              if (tableData[category] && tableData[category].data.neuCount > 0) {
                if (tableData[category].data.neuCount > words.maxMentions) {
                  words.maxMentions = tableData[category].data.neuCount;
                }
                words.neu.push(new $.ty.wordcloud.Element(tableData[category].data.id + '-neu', tableData[category].data.neutralName, tableData[category].data.neuCount));
              }
            }
          }
        });
        return words;
      };

      // Updates the content in the clouds
      var updateWordClouds = function () {
        var wordCloudCategories = computeWordCloudCategories(),
            count = (wordCloudCategories.pos.length > 0) + (wordCloudCategories.neu.length > 0) + (wordCloudCategories.neg.length > 0);

        $wordcloudPos.wordcloud({ // eslint-disable-line no-use-before-define
          values: wordCloudCategories.pos,
          maxTotal: wordCloudCategories.maxMentions
        });

        if (wordCloudCategories.pos.length > 0) {
          var className = wordCloudCategories.neu.length + wordCloudCategories.neg.length > 0 ? 'l-align-right' : 'l-align-justify';
          $wordcloudPos // eslint-disable-line no-use-before-define
          .removeClass('l-align-right l-align-justify').addClass(className).css('width', (100 / count).toString() + '%');
        }

        $wordcloudNeu.wordcloud({ // eslint-disable-line no-use-before-define
          values: wordCloudCategories.neu,
          maxTotal: wordCloudCategories.maxMentions
        });

        if (wordCloudCategories.neu.length > 0) {
          var neuClassName = void 0;
          if (wordCloudCategories.neg.length > 0) {
            neuClassName = wordCloudCategories.pos.length > 0 ? 'l-align-justify' : 'l-align-right';
          } else {
            neuClassName = wordCloudCategories.pos.length > 0 ? 'l-align-left' : 'l-align-justify';
          }
          $wordcloudNeu // eslint-disable-line no-use-before-define
          .removeClass('l-align-right l-align-left l-align-justify').addClass(neuClassName).css('width', (100 / count).toString() + '%');
        }

        $wordcloudNeg.wordcloud({ // eslint-disable-line no-use-before-define
          values: wordCloudCategories.neg,
          maxTotal: wordCloudCategories.maxMentions
        });

        if (wordCloudCategories.neg.length > 0) {
          var negClassName = wordCloudCategories.pos.length + wordCloudCategories.neu.length > 0 ? 'l-align-left' : 'l-align-justify';
          $wordcloudNeg // eslint-disable-line no-use-before-define
          .removeClass('l-align-left l-align-justify').addClass(negClassName).css('width', (100 / count).toString() + '%');
        }
      };

      // Used to detect what's the current status of the selection, it returns a name (All, None, Custom, Neutral, ...)
      var selectionName = function () {
        var name = csParams.labels.custom,
            action = 'custom',
            remainingPossibilities = 7;
        var states = {
          all: {
            state: true,
            label: csParams.labels.all
          },
          none: {
            state: true,
            label: csParams.labels.none
          },
          categories: {
            state: true,
            label: csParams.labels.categories
          },
          subcategories: {
            state: true,
            label: csParams.labels.subcategories
          },
          positive: {
            state: true,
            label: csParams.labels.common_positive
          },
          negative: {
            state: true,
            label: csParams.labels.common_negative
          },
          neutral: {
            state: true,
            label: csParams.labels.common_neutral
          }
        };

        $.each(data.categories, function (_, category) {
          if (remainingPossibilities === 0) {
            return false;
          }

          if (category.count && category.count > 0 && (!csParams.departmentId && !csParams.departments[category.id] || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1)) {
            if ($.inArray(category.id.toString(), viewData.filter.categorySelection) === -1) {
              // eslint-disable-line no-use-before-define
              if (states.all.state) {
                states.all.state = false;
                remainingPossibilities -= 1;
              }
              if (tableData[category.id].isParent) {
                if (states.categories.state) {
                  states.categories.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].isParent === false) {
                if (states.subcategories.state) {
                  states.subcategories.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].data.performance > scaled.sentimentColorThresholds.green) {
                if (states.positive.state) {
                  states.positive.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green) {
                if (states.neutral.state) {
                  states.neutral.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow) {
                if (states.negative.state) {
                  states.negative.state = false;
                  remainingPossibilities -= 1;
                }
              }
            }
            if ($.inArray(category.id.toString(), viewData.filter.categorySelection) !== -1) {
              // eslint-disable-line no-use-before-define
              if (states.none.state) {
                states.none.state = false;
                remainingPossibilities -= 1;
              }
              if (tableData[category.id].isParent) {
                if (states.subcategories.state) {
                  states.subcategories.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].isParent === false) {
                if (states.categories.state) {
                  states.categories.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green) {
                if (states.positive.state) {
                  states.positive.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (!(tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green)) {
                if (states.neutral.state) {
                  states.neutral.state = false;
                  remainingPossibilities -= 1;
                }
              }
              if (tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow) {
                if (states.negative.state) {
                  states.negative.state = false;
                  remainingPossibilities -= 1;
                }
              }
            }
          }
          return remainingPossibilities;
        });

        if (remainingPossibilities > 0) {
          for (var key in states) {
            if (states[key].state) {
              name = states[key].label;
              action = key;
              break;
            }
          }
        }
        return { name: name, action: action };
      };

      // Sorts categories by selected column
      var sortCategories = function (cData, storeExpand) {
        var sortOrder = cData.order === 'asc' ? 1 : -1,
            columnOrder = void 0,
            row = void 0;
        var sortedRows = [];

        switch (cData.column) {
          case 'category':
            {
              columnOrder = 'name';

              // The sort by name should be reversed
              sortOrder *= -1;
              break;
            }
          case 'performance':
          case 'trend':
            {
              columnOrder = cData.column;
              break;
            }
          case 'mentions':
            {
              columnOrder = 'count';
              break;
            }
          case 'positive':
            {
              columnOrder = 'posCount';
              break;
            }
          case 'neutral':
            {
              columnOrder = 'neuCount';
              break;
            }
          case 'negative':
            {
              columnOrder = 'negCount';
              break;
            }
        }

        if (!csParams.departmentId) {
          // Sort Parents
          visibleParents.sort(function (a, b) {
            if (tableData[a.id].data[columnOrder] < tableData[b.id].data[columnOrder]) {
              return -1 * sortOrder;
            }
            if (tableData[a.id].data[columnOrder] > tableData[b.id].data[columnOrder]) {
              return 1 * sortOrder;
            }
            return 0;
          });
        } else {
          visibleParents.sort(function (a, b) {
            // Show empty parents at the bottom
            if (data.column !== 'category') {
              if ($.inArray(a.id, departmentCategories) === -1) {
                return -1 * sortOrder;
              }
              if ($.inArray(b.id, departmentCategories) === -1) {
                return 1 * sortOrder;
              }
            }

            if (tableData[a.id].data[columnOrder] < tableData[b.id].data[columnOrder]) {
              return -1 * sortOrder;
            }
            if (tableData[a.id].data[columnOrder] > tableData[b.id].data[columnOrder]) {
              return 1 * sortOrder;
            }
            return 0;
          });
        }

        // Sort children
        $.each(visibleParents, function (_, category) {
          if (tableData[category.id].children) {
            // Sort children
            tableData[category.id].children.sort(function (a, b) {
              if (a.data[columnOrder] < b.data[columnOrder]) {
                return -1 * sortOrder;
              }
              if (a.data[columnOrder] > b.data[columnOrder]) {
                return 1 * sortOrder;
              }
              return 0;
            });
          }
          row = generateRow(tableData[category.id], maxMentions, storeExpand);
          if (row) {
            sortedRows.push(row);
          }
        });
        return {
          rows: sortedRows,
          footer: []
        };
      };

      // Computes a preselection
      var computePreselection = function (action) {
        var rowStates = [],
            expandParents = [];
        var selection = void 0;

        var isValidCategory = function (category) {
          if (category.count && category.count > 0 && (!csParams.departmentId && !csParams.departments[category.id] || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1)) {
            return true;
          }
          return false;
        };

        if (action === 'all') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.all);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: true
              });
              if (tableData[category.id].isParent === false) {
                $.map(tableData[category.id].data.parentIds, function (value) {
                  if ($.inArray(value, expandParents) === -1) {
                    expandParents.push(value);
                  }
                });
              }
            }
          });
        } else if (action === 'none') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.none);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: false
              });
            }
          });
        } else if (action === 'categories') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.categories);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: tableData[category.id].isParent
              });
            }
          });
        } else if (action === 'subcategories') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.subcategories);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: tableData[category.id].isParent === false
              });
              if (tableData[category.id].isParent === false) {
                $.map(tableData[category.id].data.parentIds, function (value) {
                  if ($.inArray(value, expandParents) === -1) {
                    expandParents.push(value);
                  }
                });
              }
            }
          });
        } else if (action === 'positive') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.common_positive);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: tableData[category.id].data.performance > scaled.sentimentColorThresholds.green
              });
              if (tableData[category.id].isParent === false && tableData[category.id].data.performance > scaled.sentimentColorThresholds.green) {
                $.map(tableData[category.id].data.parentIds, function (value) {
                  if ($.inArray(value, expandParents) === -1) {
                    expandParents.push(value);
                  }
                });
              }
            }
          });
        } else if (action === 'neutral') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.common_neutral);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green
              });
              if (tableData[category.id].isParent === false && tableData[category.id].data.performance > scaled.sentimentColorThresholds.yellow && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.green) {
                $.map(tableData[category.id].data.parentIds, function (value) {
                  if ($.inArray(value, expandParents) === -1) {
                    expandParents.push(value);
                  }
                });
              }
            }
          });
        } else if (action === 'negative') {
          selection = csParams.labels.select.replace('{selection}', csParams.labels.common_negative);
          $.each(data.categories, function (_, category) {
            if (isValidCategory(category)) {
              rowStates.push({
                row_id: category.id,
                state: tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow
              });
              if (tableData[category.id].isParent === false && tableData[category.id].data.performance <= scaled.sentimentColorThresholds.yellow) {
                $.map(tableData[category.id].data.parentIds, function (value) {
                  if ($.inArray(value, expandParents) === -1) {
                    expandParents.push(value);
                  }
                });
              }
            }
          });
        }
        $table.table('selectRows', rowStates); // eslint-disable-line no-use-before-define

        return {
          expand_parents: expandParents,
          selection: selection
        };
      };

      var _updateCategoryDropdownLabel = function (dropdown, label) {
        var useTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (useTemplate) {
          label = csParams.labels.select.replace('{selection}', label);
        }

        dropdown.find('.dropdown-toggle span').html(label);
      };
      var updateCategoryDropdownLabel = null; // binded to the element in the function below

      var renderCategoryDropdown = function (categoryDropdownId) {
        $contentEl.find('#' + categoryDropdownId).dropdownsmartlist('destroy');

        var $dropdownSelect = $(ddSmartList({
          items: [{
            value: 'all',
            label: csParams.labels.all
          }, {
            value: 'none',
            label: csParams.labels.none
          }, {
            value: 'categories',
            label: csParams.labels.categories
          }, {
            value: 'subcategories',
            label: csParams.labels.subcategories
          }, {
            value: 'positive',
            label: csParams.labels.common_positive
          }, {
            value: 'neutral',
            label: csParams.labels.common_neutral
          }, {
            value: 'negative',
            label: csParams.labels.common_negative
          }],
          search: false,
          selectAll: false
        })).attr('id', categoryDropdownId).replaceAll($contentEl.find('#' + categoryDropdownId)).dropdownsmartlist({
          multiple: false,
          getLabel: function () {
            return csParams.labels.select;
          },
          change: function (evt, cData) {
            var action = cData.val,
                preselection = computePreselection(action);

            rerenderWordCloud = true;
            viewData.filter.preselection = action; // eslint-disable-line no-use-before-define

            updateFilters(csParams, $contentEl, viewData); // eslint-disable-line no-use-before-define

            updateCategoryDropdownLabel(preselection.selection);

            var expandParentsState = preselection.expand_parents.map(function (parent) {
              return {
                row_id: parent,
                state: true
              };
            });

            if (expandParentsState.length) {
              $table.table('expandRows', expandParentsState); // eslint-disable-line no-use-before-define
            }

            $dropdownSelect.dropdownsmartlist('open', false);
          }
        });

        updateCategoryDropdownLabel = _updateCategoryDropdownLabel.bind(null, $dropdownSelect);

        return $dropdownSelect;
      };

      var renderSourceDropdown = function (sourceDropdownId) {
        $contentEl.find('#' + sourceDropdownId).dropdownsmartlist('destroy');

        var selectedSources = viewData.filter.selectedSources; // eslint-disable-line no-use-before-define
        var items = $.grep(csParams.sourceList, function (source) {
          return source.id !== '-1';
        }).map(function (source) {
          return {
            value: source.id,
            label: source.name,
            selected: +selectedSources[0] === -1 ? true : !!selectedSources.find(function (x) {
              return +x === +source.id;
            })
          };
        });

        return $(ddSmartList({
          items: items,
          search: true,
          selectAll: true,
          selectAllLabel: csParams.labels.select_all_options
        })).attr('id', sourceDropdownId).replaceAll($contentEl.find('#' + sourceDropdownId)).dropdownsmartlist({
          multiple: true,
          getLabel: function (selectedSourceList) {
            if (selectedSourceList.includes('-1') || selectedSourceList.length === csParams.sourceList.length - 1) {
              return csParams.labels.all_sources;
            }
            return selectedSourceList.length + ' ' + csParams.labels.sources;
          }
        });
      };

      var onSourceButtonClick = function (sourceDropdownSelectElement, e) {
        var sourceList = function () {
          var sources = sourceDropdownSelectElement.dropdownsmartlist('val').map(function (x) {
            return +x;
          });
          return sources.length && sources.length < csParams.sourceList.length - 1 ? sources : [-1];
        }();

        viewData.filter.selectedSources = csParams.sourceId = // eslint-disable-line no-use-before-define
        csParams.filter.selectedSources = viewData.sourceId = sourceList; // eslint-disable-line no-use-before-define
        updateFilters(csParams, $contentEl, viewData); // eslint-disable-line no-use-before-define

        $contentEl.closest('.dashboard-grid').DashboardGrid().find('.module-icon.expanded').DashboardModule().refresh();
      };

      // END Methods used in the renderer

      var headers = [new $.ty.table.Cell('category', csParams.labels.category), new $.ty.table.Cell('performance', csParams.labels.sema_score), new $.ty.table.Cell('trend', csParams.labels.trend), new $.ty.table.Cell('mentions', csParams.labels.mentions, 'left'), new $.ty.table.Cell('positive', csParams.labels.common_positive), new $.ty.table.Cell('neutral', csParams.labels.common_neutral), new $.ty.table.Cell('negative', csParams.labels.common_negative)];

      var addParentData = function (category, parentIds) {
        parentIds.forEach(function (parent) {
          if (!tableData[parent]) {
            tableData[parent] = {
              id: parent,
              data: undefined,
              children: [],
              isParent: true
            };
          }

          tableData[parent].children.push({
            id: category.id,
            data: category
          });
          tableData[category.id] = {
            id: category.id,
            isParent: false,
            data: category
          };
        });
      };

      // Iterates through all categories and computes scores
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data.categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var category = _step.value;

          if (!(category.count && category.count > 0 || csParams.departmentId && csParams.departments[category.id])) {
            continue;
          }

          var trend = 0;
          var performance = category.count > 0 ? category.posCount * 100 / category.count : undefined;
          var pastPerformance = category.pastCount > 0 ? category.posPastCount * 100 / category.pastCount : 0;

          pastPerformance = scaled.round(scaled.scale(pastPerformance));
          performance = category.count > 0 ? scaled.round(scaled.scale(performance)) : undefined;

          if (category.pastCount > 0 && performance !== undefined) {
            if (pastPerformance !== 0) {
              trend = Math.round((performance - pastPerformance) / pastPerformance * 100 * 10) / 10;
            } else if (performance > pastPerformance) {
              trend = 100;
            } else if (performance < pastPerformance) {
              trend = -100;
            }
          }

          category.performance = performance;
          category.pastPerformance = pastPerformance;
          category.trend = trend;

          if (maxMentions < category.count) {
            maxMentions = category.count;
          }

          if (category.parentIds && category.parentIds.length > 0) {
            addParentData(category, category.parentIds);
          } else {
            if (!tableData[category.id]) {
              tableData[category.id] = {
                id: category.id,
                children: [],
                isParent: true
              };
            }
            tableData[category.id].data = category;
            visibleParents.push({
              id: category.id
            });
          }
        }

        // Use of values stored in the view
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var viewData = getViewData(csParams, content, visibleParents);

      var allRows = sortCategories(viewData.filter.sorting_column, true);
      if (csParams.departmentId && tableData[csParams.departmentId]) {
        allRows.footer = [generateRow(tableData[csParams.departmentId], maxMentions, false, true)];
      }

      /*  We have to check if is Public Health Tile and, if it have no children, it is empty, so "no data is
       *  available should be shown */
      if (allRows.rows.length > 0 && allRows.rows[0].id === '36' && allRows.rows[0].children.length === 0) {
        allRows.rows = [];
      }
      var tableRows = allRows.rows;

      // Render header & content
      $(header).html(csParams.labels.detailsHeader || csParams.labels.header);

      if (csParams.departmentId) {
        $(header).html(metacategoryI18n[csParams.departmentId] + ' - ' + dashboardI18n.sentiment);
      }

      $.tmpl(templates.categoryDetails, {
        labels: csParams.labels,
        clusterId: csParams.clusterId,
        lang: csParams.lang,
        widgetUrl: csParams.widget5,
        showSourceDropdown: csParams.showSourceDropdown
      }, {
        checkDetailsLink: utils.checkDetailsLink
      }).appendTo($contentEl);

      // Add tabs
      $contentEl.find('.category-details-tabs').tabs({
        select: function (event, ui) {
          // for IE11, an initially hidden iframe is not displayed automatically, so we need to reload it
          if ($(ui.panel).children('iframe').length > 0) {
            $(ui.panel).children('iframe').attr('src', $(ui.panel).children('iframe').attr('src'));
          }
        }
      });

      // Resizing iframe
      $contentEl.find('.category-details-tabs iframe').iFrameResize();

      // renders dropdowns
      var $dropdownSelect = renderCategoryDropdown('sentiment-tile-category-dropdown');
      if (csParams.showSourceDropdown) {
        var dropdownId = 'sentiment-tile-source-dropdown';
        var $sourceDropdownSelect = renderSourceDropdown(dropdownId);
        $contentEl.find('#sentiment-tile-source-button').click(onSourceButtonClick.bind(null, $sourceDropdownSelect));
      }

      // Category name click handler
      $contentEl.on('click', '.placeholder-category-name', function (e) {
        var category = $(e.target).closest('tr').data('id').toString();
        csParams.categoryReviewsPopup(category, tableData[category].data.name, null, null, null, csParams.sourceId);
      });

      // Category mentions click handler
      $contentEl.on('click', '.placeholder-category-positive-mentions, ' + '.placeholder-category-neutral-mentions, .placeholder-category-negative-mentions', function (e) {
        var category = $(e.target).closest('tr').data('id').toString(),
            sentimentList = [];
        if ($(this).hasClass('placeholder-category-positive-mentions')) {
          sentimentList.push('pos');
        } else if ($(this).hasClass('placeholder-category-neutral-mentions')) {
          sentimentList.push('neu');
        } else if ($(this).hasClass('placeholder-category-negative-mentions')) {
          sentimentList.push('neg');
        }
        csParams.categoryReviewsPopup(category, tableData[category].data.name, sentimentList, null, null, csParams.sourceId);
      });

      // Rendering table
      var $table = $contentEl.find('.sentiment_table');
      $table.table({
        selectable: 'all',
        header: headers,
        rows: tableRows,
        footer: allRows.footer,
        multiple_footer: true,
        striped: false,
        enable_sorting: true,
        sorting_column: viewData.filter.sorting_column
      });

      // Rendering singlebarcharts in the table
      $table.find('.placeholder-category').each(function (index) {
        var category = $(this).data('category');
        if (tableData && category && tableData[category] && tableData[category].data) {
          $(this).singlebarchart({
            id: category,
            values: [new $.ty.singlebarchart.Element(category + '-pos', tableData[category].data.posCount, tableData[category].data.posCount), new $.ty.singlebarchart.Element(category + '-neu', tableData[category].data.neuCount, tableData[category].data.neuCount), new $.ty.singlebarchart.Element(category + '-neg', tableData[category].data.negCount, tableData[category].data.negCount)],
            maxTotal: maxMentions,
            showTooltip: false
          });
          $(this).on('singlebarchartclick', wordCloudPopup);
        }
      });

      // Adding tooltips
      $table.find('.placeholder-category').tooltipsy({
        offset: [-1, 0],
        className: 'trustyou-ui tooltip l-left'
      });
      $contentEl.on('mouseenter', '.sentiment_table td', function () {
        if ($(this).parents('tr').find('.placeholder-category').length > 0) {
          $(this).parents('tr').find('.placeholder-category').data('tooltipsy').show();
        }
      });
      $contentEl.on('mouseleave', '.sentiment_table td', function () {
        if ($(this).parents('tr').find('.placeholder-category').length > 0) {
          $(this).parents('tr').find('.placeholder-category').data('tooltipsy').hide();
        }
      });
      $contentEl.on('click', '.sentiment_table .placeholder-category', function () {
        $(this).data('tooltipsy').hide();
      });

      // Rendering wordclouds
      var $wordcloud = $contentEl.find('.word-cloud-wrapper');
      var $wordcloudPos = $wordcloud.find('.word-cloud-pos').addClass('l-left');
      var $wordcloudNeu = $wordcloud.find('.word-cloud-neu').addClass('l-left');
      var $wordcloudNeg = $wordcloud.find('.word-cloud-neg').addClass('l-left');

      var selectionNameAction = selectionName();

      updateCategoryDropdownLabel(selectionNameAction.name, true);

      // Table event handlers
      $table.on('tableselect', function (e, tabData) {
        if (!tabData.state && $.inArray(tabData.id.toString(), viewData.filter.categorySelection) > -1) {
          viewData.filter.categorySelection.splice($.inArray(tabData.id.toString(), viewData.filter.categorySelection), 1);
          updateWordClouds();
        } else if (tabData.state && $.inArray(tabData.id.toString(), viewData.filter.categorySelection) === -1) {
          viewData.filter.categorySelection.push(tabData.id.toString());
          updateWordClouds();
        }

        // Every time a new manual selection is done, we need to update the selection label
        selectionNameAction = selectionName();
        updateCategoryDropdownLabel(selectionNameAction.name, true);
        viewData.filter.preselection = selectionNameAction.action;

        updateFilters(csParams, $contentEl, viewData);
      });
      $table.on('tablemultipleselect', function (e, tabData) {
        // When using preselections, everything gets cleaned
        viewData.filter.categorySelection = [];
        $.each(tabData.rows, function (_, row) {
          if (!row.state && $.inArray(row.id.toString(), viewData.filter.categorySelection) > -1) {
            viewData.filter.categorySelection.splice($.inArray(row.id.toString(), viewData.filter.categorySelection), 1);
          } else if (row.state && $.inArray(row.id.toString(), viewData.filter.categorySelection) === -1) {
            viewData.filter.categorySelection.push(row.id.toString());
          }
        });
        if (rerenderWordCloud) {
          updateWordClouds();
        }
        rerenderWordCloud = false;
      });
      $contentEl.on('tablesort', '.sentiment_table', function (e, tabData) {
        var allRow = sortCategories(tabData, false);
        if (csParams.departmentId && tableData[csParams.departmentId]) {
          allRow.footer = [generateRow(tableData[csParams.departmentId], maxMentions, false, true)];
        }
        var newRows = allRow.rows;

        $table.table({
          selectable: 'all',
          header: headers,
          rows: newRows,
          footer: allRows.footer,
          multiple_footer: true,
          striped: false,
          enable_sorting: true,
          sorting_column: tabData
        });

        // Rendering singlebarcharts in the table
        $table.find('.placeholder-category').each(function (index) {
          var category = $(this).data('category');
          if (tableData && category && tableData[category] && tableData[category].data) {
            $(this).singlebarchart({
              id: category,
              values: [new $.ty.singlebarchart.Element(category + '-pos', tableData[category].data.posCount, tableData[category].data.posCount), new $.ty.singlebarchart.Element(category + '-neu', tableData[category].data.neuCount, tableData[category].data.neuCount), new $.ty.singlebarchart.Element(category + '-neg', tableData[category].data.negCount, tableData[category].data.negCount)],
              maxTotal: maxMentions,
              showTooltip: false
            });
            $(this).on('singlebarchartclick', wordCloudPopup);
          }
        });

        $table.find('.placeholder-category').tooltipsy({
          offset: [-1, 0],
          className: 'trustyou-ui tooltip l-left'
        });

        // Click selection again, but no need to expand anything
        rerenderWordCloud = false;
        computePreselection(viewData.filter.preselection);

        viewData.filter.sorting_column = tabData;

        updateFilters(csParams, $contentEl, viewData);
      });

      $contentEl.on('tableexpand', '.sentiment_table', function (e, tabData) {
        if (!tabData.state && $.inArray(tabData.id.toString(), categoryExpand) > -1) {
          categoryExpand.splice($.inArray(tabData.id.toString(), categoryExpand), 1);
        } else if (tabData.state && $.inArray(tabData.id.toString(), categoryExpand) === -1) {
          categoryExpand.push(tabData.id.toString());
        }
      });
      $contentEl.on('tablemultipleexpand', '.sentiment_table', function (e, tabData) {
        $.each(tabData.rows, function (_, row) {
          if (!row.state && $.inArray(row.id.toString(), categoryExpand) > -1) {
            categoryExpand.splice($.inArray(row.id.toString(), categoryExpand), 1);
          } else if (row.state && $.inArray(row.id.toString(), categoryExpand) === -1) {
            categoryExpand.push(row.id.toString());
          }
        });
      });

      // If the preselection is not custom, then we need to preselect, which will fire the updateWordClouds
      if (viewData.filter.preselection !== 'custom') {
        var expandParentsState = [];
        rerenderWordCloud = true;
        var preselection = computePreselection(viewData.filter.preselection);

        updateCategoryDropdownLabel(preselection.selection);

        $.each(preselection.expand_parents, function (_, parent) {
          expandParentsState.push({
            row_id: parent,
            state: true
          });
        });

        if (expandParentsState.length > 0) {
          $table.table('expandRows', expandParentsState);
        }

        $dropdownSelect.dropdownsmartlist('open', false);
      } else {
        // Else, we can just fire the updateWordClouds
        updateWordClouds();
      }

      $wordcloudPos.on('wordcloudclick', wordCloudPopup);
      $wordcloudNeu.on('wordcloudclick', wordCloudPopup);
      $wordcloudNeg.on('wordcloudclick', wordCloudPopup);

      // Reset cloud action
      $contentEl.find('.reset-cloud').on('click', function () {
        $.each(data.categories, function (_, category) {
          if (category.count && category.count > 0) {
            if (tableData[category.id].isParent) {
              $table.table('select', category.id, !csParams.departmentId || csParams.departmentId && $.inArray(category.id, departmentCategories) !== -1);
            } else {
              $table.table('select', category.id, csParams.departmentId !== undefined && $.inArray(category.id, departmentCategories) !== -1);
            }
          }
          // TM-7256 Bruteforce solution
          $dropdownSelect = renderCategoryDropdown('sentiment-tile-category-dropdown');
          selectionNameAction = selectionName();
          updateCategoryDropdownLabel(selectionNameAction.name, true);
          viewData.filter.preselection = selectionNameAction.action;
        });
      });
      deferred.resolve(content);
      return deferred;
    };

    return {
      icon_dataprovider: iconDataprovider,
      icon_renderer: iconRenderer,
      details_dataprovider: detailsDataprovider,
      details_renderer: detailsRenderer
    };
  });
})(jQuery);
(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/sentiment/index',['require', 'jquery', 'session', 'ty-i18n!analytics_js_4x', 'ty-i18n!tyra-5', 'ty-i18n!portfolio', './../../config', './../tileUtils', './tile', './../../views/dashboard_modules_utils'], function (require, $, session, i18n, tyra5I18n, portfolioI18n, config, utils, categoryScoresTile, moduleUtils) {
    return function (csParams, iconParams, detailsParams) {
      // Add defaults
      var csParamsExtended = $.extend(true, {}, utils.tileDefaults, {
        clusterId: null,
        groupId: null,
        categoryId: null,
        departmentId: undefined,
        from: null,
        to: null,

        cloudOptions: {
          id: undefined, // A default value is specified in the details renderer
          width: 920,
          height: 300,
          mentionsToWeight: function (mentions, maxMentions) {
            // The size is between [14, 50] px
            return Math.max(Math.round(mentions * 50 / maxMentions), 14) + 'px';
          },

          // Plugin options
          maxSpeed: 0.02,
          freezeActive: true,
          frontSelect: true,
          reverse: true,
          txtOpt: false,
          stretchX: 3,
          weight: true,
          textColour: null
        },
        semaChartOptions: {
          isStacked: true,
          colors: ['#7cb342', '#f06748'],
          chartArea: {
            left: 50,
            top: 20,
            width: 690,
            height: 200
          },
          hAxis: {
            slantedText: true,
            slantedTextAngle: 90
          },
          width: 920,
          height: 340
        },
        semaChartEvents: {},
        tableOptions: {
          sortColumn: 3,
          sortAscending: false,
          page: 'enable'
        },
        labels: {
          header: '',
          lastTimeLabel: '',
          rangeTimeLabel: '',
          iconDescription: '',

          topsFlopsTab: i18n.dashboard_tops_flops_tab,
          chartsTab: i18n.dashboard_category_charts_tab,
          tableTab: i18n.dashboard_category_table_tab,
          positive: i18n.charts_positive,
          negative: i18n.charts_negative,
          category: i18n.renderers_dashboard_category,
          score: i18n.score,
          performance: portfolioI18n.sema_category,
          sema_score: portfolioI18n.sema_category,
          mentions: i18n.common_mentions,
          tops: i18n.common_tops,
          flops: i18n.common_flops,
          trendingDownLabel: tyra5I18n.trending_down,
          sentiment: i18n.dashboard_sentiment_header,
          numberOf: tyra5I18n.number_of,
          summary: i18n.dashboard_tops_flops_tab_summary,
          hotel_type: i18n.dashboard_tops_flops_hotel_type,
          good_to_know: i18n.dashboard_tops_flops_good_to_know,
          trend: i18n.common_trend,
          common_positive: i18n.common_positive,
          common_neutral: i18n.common_neutral,
          common_negative: i18n.common_negative,
          select: i18n.show_in_word_cloud_element,
          reset_cloud: i18n.reset_cloud,
          all: i18n.common_all,
          none: i18n.common_none,
          categories: i18n.common_categories,
          subcategories: i18n.common_subcategories,
          positive_mentions: i18n.common_positive_mentions,
          neutral_mentions: i18n.common_neutral_mentions,
          negative_mentions: i18n.common_negative_mentions,
          meta_review: i18n.meta_review,
          show_reviews: i18n.show_reviews,
          custom: i18n.common_custom,
          sources: i18n.sources,

          noClusterFilter: '',
          noTimeFilter: ''
        },
        departments: config.departments,
        departmentIcons: config.department_icons,
        scale: session.properties.scale,
        lang: session.properties.locale,
        widget5: config.urls.widget5,
        clusterUrl: config.urls.cluster,
        i18n: config.urls.i18n,

        filterUpdated: function (details) {
          var updatedParams = moduleUtils.exportParameters(csParamsExtended.tabKey, csParamsExtended.module, $.extend(true, {}, csParamsExtended, csParamsExtended.getModuleData($(details).closest('.dashboard-grid').find('.module-icon.expanded'))));
          var $categoryScoresIcon = $(details).closest('.dashboard-grid').find('> .grid-row > .icons > .module-icon.expanded');
          var $categoryScoresDetails = $(details).closest('.module-details');
          var $parentDetails = $categoryScoresDetails.closest('.module-details-content').closest('.module-details');

          // Mark the tile as exportable
          require(['dashboard-agg'], function () {
            require(['dashboard-app-export'], function (exportModule) {
              exportModule($categoryScoresIcon, updatedParams, $(details).find('.module-details-header').first(), true);
              exportModule($categoryScoresDetails, updatedParams, $(details).find('.module-details-header').first(), true);
            });
          });

          // TM-3678: if its a subtile bubble event to parent tile
          if (updatedParams.options.parentFilterUpdated) {
            updatedParams.options.parentFilterUpdated($parentDetails);
          }
        }
      }, csParams);
      csParamsExtended.categoryReviewsPopup = moduleUtils.categoryReviewsPopup.bind(null, {
        groupId: csParamsExtended.groupId,
        clusterId: csParamsExtended.clusterId,
        from: csParamsExtended.from,
        to: csParamsExtended.to,
        reviewsPerPage: csParamsExtended.reviewsPerPage || 5,
        clusterName: csParamsExtended.clusterName || csParamsExtended.groupName,
        sourceList: csParamsExtended.sourceList
      });
      csParamsExtended.labels.header = moduleUtils.moduleHeader(csParamsExtended.labels.header);
      csParamsExtended.labels.detailsHeader = moduleUtils.moduleHeader(csParamsExtended.labels.detailsHeader);
      var selectedSources = [isNaN(+csParams.sourceId) ? -1 : +csParams.sourceId];
      csParamsExtended.sourceId = csParams.showSourceDropdown ? csParams.module.filter && csParams.module.filter.selectedSources || csParams.module && csParams.module.sourceId || [-1] : selectedSources;

      // Used in portfolio to get export data
      var paramsGetter = function () {
        return csParamsExtended;
      };

      // Add defaults
      var iconClassList = [csParamsExtended.departmentId ? 'tile-sentiment-department' : 'tile-sentiment', 'category-icon', csParamsExtended.categoryId ? 'category-id-' + csParamsExtended.categoryId : null, iconParams.classes || null];
      var iconParamsExtended = $.extend({}, iconParams || {}, {
        classes: iconClassList.join(' '),

        dataprovider: categoryScoresTile.icon_dataprovider.bind(this, csParamsExtended),
        renderer: categoryScoresTile.icon_renderer.bind(this, csParamsExtended),
        paramsGetter: paramsGetter
      });

      // Add defaults
      var detailsClassList = ['category-scores-details', csParamsExtended.categoryId ? 'category-id-' + csParamsExtended.categoryId : null, detailsParams.classes || null];
      var detailsParamsExtended = $.extend({}, detailsParams || {}, {
        classes: detailsClassList.join(' '),

        showBeforeRender: $.browser.msie,
        dataprovider: categoryScoresTile.details_dataprovider.bind(this, csParamsExtended),
        renderer: categoryScoresTile.details_renderer.bind(this, csParamsExtended),
        paramsGetter: paramsGetter
      });

      this.addModule(iconParamsExtended, detailsParamsExtended);

      return this;
    };
  });
})();
/**
 * Created by iulian on 30.10.2017.
 */

(function () {
  'use strict';

  define('commons/public/js/tyra-5/compset-utils',['jquery', './utils', './config'], function ($, reqUtils, config) {
    var compsetSharingUtils = {
      getGroups: function (userId, location, type) {
        var portfolioURL = '' + config.urls.portfolio;
        var data = {
          user_id: userId,
          location: location,
          type: type
        };
        var groupsDeferred = reqUtils.doAjax({
          url: portfolioURL + 'groups',
          type: 'get',
          data: data
        });
        return groupsDeferred;
      },

      getFriendsGroups: function (userId, defaultCluster) {
        var portfolioURL = '' + config.urls.portfolio;
        var data = {
          user_id: userId,
          default_cluster: defaultCluster
        };
        var groupsDeferred = reqUtils.doAjax({
          url: portfolioURL + 'groups/friends',
          type: 'get',
          data: data
        });
        return groupsDeferred;
      },

      clonePortfolios: function (oldUserId, newUserId) {
        var portfolioURL = '' + config.urls.portfolio;
        var data = {
          source_user_id: oldUserId,
          target_user_id: newUserId
        };
        var groupsDeferred = reqUtils.doAjax({
          url: portfolioURL + 'clone',
          type: 'get',
          data: data
        });
        return groupsDeferred;
      }
    };
    return compsetSharingUtils;
  });
})();
/**
 * Created by iulian on 30.10.2017.
 */

(function () {
  'use strict';

  define('commons/public/js/tyra-5/compset-share-manager',['jquery', './compset-utils'], function ($, compsetUtils) {
    var compsetSharingHelper = {
      loadCompsetsFromFriends: function (params) {
        var compsetDeferred = $.Deferred();
        if (params.isEnterprise !== true) {
          $.when(compsetUtils.getGroups(params.userId, 'COMPARISON', 'BENCHMARK')).then(function (cGroups) {
            if (cGroups.response.group_list.length === 0) {
              compsetUtils.getFriendsGroups(params.userId, params.defaultCluster.id).then(function (groupsData) {
                var groups = groupsData.response.group_list;
                if (Object.keys(groups).length > 0) {
                  var groupIds = Object.keys(groups);
                  groupIds.sort(function (a, b) {
                    return groups[a].owner_list.length - groups[b].owner_list.length || groups[a].hotel_count - groups[b].hotel_count;
                  });
                  $.when(compsetUtils.clonePortfolios(Object.values(groups)[0].owner_list[0], params.userId)).done(function (data) {
                    if (data.meta.code === 200) {
                      compsetDeferred.resolve();
                    } else {
                      compsetDeferred.reject();
                    }
                  });
                } else {
                  compsetDeferred.resolve();
                }
              });
            } else {
              compsetDeferred.resolve();
            }
          });
        } else {
          compsetDeferred.resolve();
        }
        return compsetDeferred;
      }
    };
    return compsetSharingHelper;
  });
})();
define('commons/public/jadec/tyra-5/common/chooser',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"chooserHeader\">");
if ( search)
{
buf.push("<input" + (jade.attrs({ 'type':("text"), 'placeholder':(labels.title), "class": ('search') }, {"type":true,"placeholder":true})) + "/>");
}
buf.push("</div><div class=\"chooserWrapper\"><ul class=\"chooser\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

var classes = ["chooser-item", "ui-widget-content"];
if ( item.disabled)
{
classes.push("disabled");
}
if ( item.selected)
{
classes.push("ui-selected");
}
var attributes = {}, escaped = {};
// iterate item.data
;(function(){
  var $$obj = item.data;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var value = $$obj[key];

var attr = "data-" + key;
attributes[attr] = value;
escaped[attr] = true;
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(key)){      var value = $$obj[key];

var attr = "data-" + key;
attributes[attr] = value;
escaped[attr] = true;
      }

    }

  }
}).call(this);

buf.push("<li" + (jade.attrs(jade.merge({ "class": (classes) }, attributes), jade.merge({"class":true}, escaped, true))) + "><span class=\"chooser-item-text\">" + (jade.escape((jade.interp = item.name) == null ? '' : jade.interp)) + "</span></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var item = $$obj[$index];

var classes = ["chooser-item", "ui-widget-content"];
if ( item.disabled)
{
classes.push("disabled");
}
if ( item.selected)
{
classes.push("ui-selected");
}
var attributes = {}, escaped = {};
// iterate item.data
;(function(){
  var $$obj = item.data;
  if ('number' == typeof $$obj.length) {

    for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
      var value = $$obj[key];

var attr = "data-" + key;
attributes[attr] = value;
escaped[attr] = true;
    }

  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty(key)){      var value = $$obj[key];

var attr = "data-" + key;
attributes[attr] = value;
escaped[attr] = true;
      }

    }

  }
}).call(this);

buf.push("<li" + (jade.attrs(jade.merge({ "class": (classes) }, attributes), jade.merge({"class":true}, escaped, true))) + "><span class=\"chooser-item-text\">" + (jade.escape((jade.interp = item.name) == null ? '' : jade.interp)) + "</span></li>");
      }

    }

  }
}).call(this);

buf.push("</ul></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/tyra-5/common/chooser',['jquery', './../../../jadec/tyra-5/common/chooser'], function ($, template) {
    var normalizeName = function (name) {
      return name ? $.trim(name).toLowerCase() : '';
    };

    var compareItems = function (a, b) {
      return normalizeName(a.name).localeCompare(normalizeName(b.name));
    };

    var defaults = {
      items: [],
      selected: $.noop,
      sort: true,
      search: true,
      multiselect: true,
      labels: {
        title: ''
      }
    };

    if ($.fn.chooser) {
      throw new Error('Chooser plugin is already defined');
    }
    $.fn.chooser = function (params) {
      var self = this;

      params = $.extend(true, {}, defaults, params);

      if (params.sort) {
        params.items.sort(compareItems);
      }

      self.addClass('chooser').html(template(params));

      var input = self.find('input');
      var list = self.find('ul');
      var items = list.find('.chooser-item');

      // Search
      if (params.search) {
        input.keyup(function () {
          var toSearch = input.val().toLowerCase(),
              searchRegex = new RegExp('(' + toSearch + ')', 'gi'),
              highlight = '<span class="highlight">$1</span>';

          // Needed for performance reasons
          items.detach();
          items.each(function () {
            var $el = $(this),
                textItem = $el.find('.chooser-item-text'),
                text = textItem.text();

            if (text.toLowerCase().indexOf(toSearch) !== -1) {
              textItem.html(text.replace(searchRegex, highlight));
              $el.show();
            } else {
              $el.hide();
            }
          });

          items.appendTo(list);
        });
      }

      var clearSearch = function () {
        if (params.search && input.val()) {
          input.val('').trigger('keyup');
        }
      };

      // Click handler
      self.on('click', '.chooser-item', function () {
        var $clicked = $(this);

        // Don't do anything for disabled items
        if ($clicked.hasClass('disabled')) {
          return;
        }

        clearSearch();

        if (!params.multiselect) {
          items.detach().removeClass('ui-selected');
          $clicked.addClass('ui-selected');
          items.appendTo(list);

          params.selected($clicked);
        } else {
          $clicked.toggleClass('ui-selected');

          params.selected(items.filter('.ui-selected'));
        }
      });

      return this;
    };

    return $.fn.chooser;
  });
})();

(function () {
  'use strict';

  define('commons/public/js/tyra-5/assignments/export/assignments-helpers',['ty-i18n!assignments-app'], function (i18n) {
    var helpers = {
      statusesMap: {
        OPEN: {
          color: '#ffa726',
          i18nKey: 'open'
        },
        ACHIEVED: {
          color: '#7cb342',
          i18nKey: 'achieved'
        },
        NOT_ACHIEVED: {
          color: '#f06748',
          i18nKey: 'not_achieved'
        },
        CLOSED: {
          color: '#7cb342',
          i18nKey: 'closed'
        },
        OVERDUE: {
          color: '#f06748',
          i18nKey: 'overdue'
        }
      },

      preparePropertyInfo: function (selectedProperty) {
        var selectedPropLabel = i18n.selected_hotel || '@Selected hotel';
        if (selectedProperty.type === 'GROUP') {
          selectedPropLabel = i18n.selected_group || '@Selected group';
        }

        return {
          name: selectedPropLabel,
          value: selectedProperty.name
        };
      },

      prepareRangeInfo: function (selectedPage, elementsPerPage, total) {
        var rangeLabel = (i18n.rows_out_of_total || '@{range} of {total} rows').replace('{range}', selectedPage * elementsPerPage + 1 + '-' + Math.min((selectedPage + 1) * elementsPerPage, total)).replace('{total}', total);

        return {
          name: i18n.showing || '@Showing',
          value: rangeLabel
        };
      },

      prepareStatusesInfo: function (selectedStatuses) {
        var statusesLabel = i18n.all || '@All';
        var statusesLabelsList = selectedStatuses.map(function (status) {
          return i18n[status.i18nKey] || status.label;
        });
        if (statusesLabelsList.length > 0) {
          statusesLabel = statusesLabelsList.sort().join(',');
        }

        return {
          name: i18n.selected_statuses || '@Selected statuses',
          value: statusesLabel
        };
      },

      prepareAssigneesInfo: function (selectedAssignees) {
        var assigneesLabel = i18n.all || '@All';
        var assigneesLabelsList = selectedAssignees.map(function (assignee) {
          return assignee.label;
        });
        if (assigneesLabelsList.length > 0) {
          assigneesLabel = assigneesLabelsList.sort().join(',');
          assigneesLabel = assigneesLabel.length > 500 ? assigneesLabel.substring(0, 500) + '...' : assigneesLabel;
        }

        return {
          name: i18n.selected_assignees || '@Selected assignees',
          value: assigneesLabel
        };
      }
    };

    return helpers;
  });
})();
define('commons/public/jadec/tyra-5/assignments/export-module',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var title, info_list;
title = title !== undefined ? title: '';
info_list = info_list !== undefined ? info_list : [];
buf.push("<div class=\"card-header\"><ul class=\"actions\"><li><a data-tooltip=\"top\" class=\"action-edit\"><i class=\"ty-icon ty-icon-pencil\"></i></a></li><li><a data-tooltip=\"top\" class=\"action-delete\"><i class=\"ty-icon ty-icon-trash\"></i></a></li><li><a data-tooltip=\"top\" class=\"action-duplicate\"><i class=\"ty-icon ty-icon-copy\"></i></a></li><li><a data-tooltip=\"top\" class=\"action-move\"><i class=\"ty-icon ty-icon-grab\"></i></a></li></ul><h2 data-tooltip=\"top\" class=\"module-title\">" + (((jade.interp = title) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body\">");
// iterate info_list
;(function(){
  var $$obj = info_list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var info = $$obj[$index];

buf.push("<div class=\"module-detail\"><div class=\"row\"><div class=\"col-3\">" + (jade.escape((jade.interp = info.name) == null ? '' : jade.interp)) + ":</div><div class=\"col-9\"><span>" + (jade.escape((jade.interp = info.value) == null ? '' : jade.interp)) + "</span></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var info = $$obj[$index];

buf.push("<div class=\"module-detail\"><div class=\"row\"><div class=\"col-3\">" + (jade.escape((jade.interp = info.name) == null ? '' : jade.interp)) + ":</div><div class=\"col-9\"><span>" + (jade.escape((jade.interp = info.value) == null ? '' : jade.interp)) + "</span></div></div></div>");
      }

    }

  }
}).call(this);

buf.push("</div>");
}
return buf.join("");
};

});

define('commons/public/jadec/tyra-5/assignments/preview-module',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card card-sm review-export-preview\"><div class=\"card-header\"><h2>" + (((jade.interp = title) == null ? '' : jade.interp)) + "</h2></div></div>");
}
return buf.join("");
};

});

// responsible for export side-panel assignments modules (UI)
(function () {
  'use strict';

  define('commons/public/js/tyra-5/assignments/export/assignments-export-module',['jquery', 'export-pane', 'ty-i18n!tyra-5', './assignments-helpers', './../../../../jadec/tyra-5/assignments/export-module', './../../../../jadec/tyra-5/assignments/preview-module'], function ($, exportPane, i18nTyra, helpers, moduleTmpl, modulePreviewTmpl) {
    /**
     * @param moduleParameters
     * @param label
     * @return {$.fn.ExportListItem} a new instance based on the given parameters
     */
    var listItem = function (moduleParameters, label) {
      var filter = moduleParameters && moduleParameters.options && moduleParameters.options.filter || {};

      moduleParameters = $.extend(true, {}, moduleParameters);

      return $("<div class='assignments-module'></div>").ExportListItem().init({
        formats: ['excel', 'pdf'],

        dataprovider: function () {
          return $.Deferred().resolve(null);
        },

        renderer: function (data) {
          var self = this,
              content = self.content();

          var newElement = moduleTmpl({
            title: label,
            info_list: [helpers.preparePropertyInfo(filter.selectedProperty), helpers.prepareStatusesInfo(filter.selectedStatuses), helpers.prepareAssigneesInfo(filter.selectedAssignees)]
          });
          content.append(newElement);
          content.addClass('is-expandable');
          return $.Deferred().resolve();
        },

        moduleParameters: function () {
          return moduleParameters;
        },

        preview: function () {
          return modulePreviewTmpl({ title: label });
        },

        deepClone: function () {
          return listItem(this.moduleParameters(), label);
        }
      });
    };

    return function (element, actionContainer, parameters, alwaysShow) {
      var type = parameters.module;
      var label = (i18nTyra.module_operations || '@Operations') + ' &#x00BB; ';
      switch (type) {
        case 'Tasks':
          label += i18nTyra.tab_tasks;
          break;
        case 'Goals':
          label += i18nTyra.tab_goals;
          break;
      }

      element = $(element).ExportModule();
      // Prevent duplicate bindings
      if (element.hasClass($.fn.ExportModule.API.cssMarker)) {
        element.destroy();
      }
      return element.init({
        formElement: function () {
          return listItem(parameters, label);
        },
        actionContainer: actionContainer,
        exportPane: exportPane,
        autoHide: !alwaysShow
      });
    };
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  define('commons/public/js/tyra-5/assignments/services/session/adaptee',['session', 'TYAssignments'], function (session, TYAssignments) {
    /**
     * Adaptee for the session module.
     * This class is used to adapt the original tyra's session module and use it
     * with a common interface in all new npm apps.
     * @class
     * @memberOf tyra.services.session.TYRASessionAdaptee
     *
     */
    var TYRASessionAdaptee = function (_TYAssignments$servic) {
      _inherits(TYRASessionAdaptee, _TYAssignments$servic);

      function TYRASessionAdaptee() {
        _classCallCheck(this, TYRASessionAdaptee);

        return _possibleConstructorReturn(this, (TYRASessionAdaptee.__proto__ || Object.getPrototypeOf(TYRASessionAdaptee)).apply(this, arguments));
      }

      _createClass(TYRASessionAdaptee, [{
        key: 'init',

        /**
         * Initializes the Session, returns a promise.
         * @returns {Promise}
         */
        value: function init() {
          // Session object is already initialized so we can directly return the
          // session instance.
          var turnback = new Promise(function (resolve, reject) {
            resolve();
          });

          return turnback;
        }

        /**
         * Returns the current user.
         * @returns {{}} - The user object,
         * ```
         * {
         *    username: "<string - the username>",
         *    creation_time: 1290787996, //timestamp
         *    id: "<uuid>",
         *    suspension_time: null, //timestamp
         *    email: "<string - the email>"
         * };
         * ```
         */

      }, {
        key: 'getUser',
        value: function getUser() {
          return session.user;
        }

        /**
         * Returns the list of permissions granted to the actual user.
         * @returns {string[]} - The list of granted permissions.
         * ```
         * [ 'portfolio', 'dashboard', ... ]
         * ```
         */

      }, {
        key: 'getPermissions',
        value: function getPermissions() {
          return session.permissions;
        }

        /**
         * Checks if the actual user has a certain permission.
         * @param {string} permissionLabel - the permission to be checked.
         * @returns {boolean}
         */

      }, {
        key: 'hasPermission',
        value: function hasPermission(permissionLabel) {
          return session.has(permissionLabel);
        }

        /**
         * Returns the default cluster for the actual user.
         * @returns {{}} - The default cluster object,
         * ```
         * {
         *    iso2_country: "<string- country code>",
         *    city: "<string - name of the city>",
         *    id: "<uuid>",
         *    coordinates: {
         *      latitude: 45.4978704,
         *      longitude: 12.6224592
         *    },
         *    name: "<string - name of the hotel>"
         * }
         * ```
         */

      }, {
        key: 'getDefaultCluster',
        value: function getDefaultCluster() {
          return session.defaultCluster;
        }

        /**
         * Returns the selected cluster for the actual user.
         * @returns {{}} - The selected cluster object,
         * ```
         * {
         *    iso2_country: "<string- country code>",
         *    city: "<string - name of the city>",
         *    id: "<uuid>",
         *    coordinates: {
         *      latitude: 45.4978704,
         *      longitude: 12.6224592
         *    },
         *    name: "<string - name of the hotel>"
         * }
         * ```
         */

      }, {
        key: 'getSelectedCluster',
        value: function getSelectedCluster() {
          return session.selectedCluster;
        }

        /**
         * Returns the properties object for the actual user.
         * @returns {{}}
         * ```
         * {
         *   "keyX": "valueX",
         *   "keyY": "valueY",
         *   ...
         * }
         * ```
         */

      }, {
        key: 'getProperties',
        value: function getProperties() {
          return session.properties;
        }

        /**
         * Returns the list of roles granted to the user.
         * @returns {string[]}
         */

      }, {
        key: 'getRoles',
        value: function getRoles() {
          return session.roles;
        }

        /**
         * Sets user properties using the ones passed as parameter. Returns a promise.
         * @param {{}} properties - The properties that has to be sent to the server.
         * @param {mixed} args - The rest of parameters, this interface could be customized as needed.
         * @returns {Promise}
         */

      }, {
        key: 'setProperties',
        value: function setProperties(properties) {
          var nextTab = void 0,
              reload = void 0;
          if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 1) {
            nextTab = arguments.length <= 1 ? undefined : arguments[1];
          }
          if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 2) {
            reload = arguments.length <= 2 ? undefined : arguments[2];
          }

          var propertiesSetter = function (resolve, reject) {
            session.setProperties(properties, nextTab, reload).done(function () {
              resolve();
            });
          };

          return new Promise(propertiesSetter);
        }

        /**
         * Sets one user property using the value passed as parameter. Returns a promise.
         * @param {string} propertyName - The name of the property that has to be updated.
         * @param {mixed} propertyValue - The new value for the property.
         * @param {mixed} args - The rest of parameters, this interface could be customized as needed.
         * @returns {Promise}
         */

      }, {
        key: 'setProperty',
        value: function setProperty(propertyName, propertyValue) {
          var property = {};
          property[propertyName] = propertyValue;

          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          return this.setProperties.apply(this, [[property]].concat(args));
        }

        /**
         * Gets the array of active trials for this user.
         * @returns {{}} - The trials object
         * ```
         * {
         *   active: false,
         *   expired: true
         * }
         * ```
         */

      }, {
        key: 'getTrials',
        value: function getTrials() {
          return session.trials;
        }

        /**
         * Returns the list of permissions granted to the current user as part of a trial.
         * @returns {string[]}
         */

      }, {
        key: 'getTrialPermissions',
        value: function getTrialPermissions() {
          return session.trial_permissions;
        }

        /**
         * Checks if the current user has a trialPermission
         * @param permissionLabel - The permission to be checked.
         */

      }, {
        key: 'hasTrialPermission',
        value: function hasTrialPermission(permissionLabel) {
          return this.getTrialPermissions().includes(permissionLabel);
        }

        /**
         * Returns the list of previously owned but expired permissions.
         * @returns {string[]}
         */

      }, {
        key: 'getExpiredPermissions',
        value: function getExpiredPermissions() {
          return session.expired_permissions;
        }

        /**
         * Checks if the current user has a expiredPermission
         * @param permissionLabel - The permission to be checked.
         */

      }, {
        key: 'hasExpiredPermission',
        value: function hasExpiredPermission(permissionLabel) {
          return this.getExpiredPermissions().includes(permissionLabel);
        }

        /**
         * @returns {string} - The actual ssoToken
         */

      }, {
        key: 'getSsoToken',
        value: function getSsoToken() {
          return session.ssoToken;
        }

        /**
         * @returns {{}} - Returns account propery is available otherwise returns undefined
         * * ```
         * {
         *   "id":"7ad2f997-9f73-4dd8-a334-637d5d1c9f0b",
         *   "name":"accor",
         *   "type":"CENTRALIZED_ONLINE"
         * }
         * ```
         */

      }, {
        key: 'getAccount',
        value: function getAccount() {
          return session.account;
        }
      }]);

      return TYRASessionAdaptee;
    }(TYAssignments.services.session.SessionAdaptee);

    return TYRASessionAdaptee;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  define('commons/public/js/tyra-5/assignments/services/i18n/adaptee',['session', 'TYAssignments'], function (session, TYAssignments) {
    /**
     * Adaptee for the i18n module.
     * This class is used to adapt the original tyra's i18n mechanism and use it
     * with a common interface in all new npm apps.
     * @class
     * @memberOf tyra.services.i18n.TYRAI18NAdaptee
     */
    var TYRAI18NAdaptee = function (_TYAssignments$servic) {
      _inherits(TYRAI18NAdaptee, _TYAssignments$servic);

      function TYRAI18NAdaptee() {
        _classCallCheck(this, TYRAI18NAdaptee);

        var _this = _possibleConstructorReturn(this, (TYRAI18NAdaptee.__proto__ || Object.getPrototypeOf(TYRAI18NAdaptee)).call(this));

        _this.labels = {};
        return _this;
      }

      /**
       * Initializes the bundles, returns a promise.
       * @returns {Promise}
       */


      _createClass(TYRAI18NAdaptee, [{
        key: 'init',
        value: function init() {
          return Promise.all([this.loadBundle('assignments-app'), this.loadBundle('survey-app'), this.loadBundle('metacategory')]).then(function (bundles) {
            // eslint-disable-line arrow-body-style
            return true;
          });
        }
      }, {
        key: 'loadBundle',
        value: function loadBundle(bundleName) {
          var _this2 = this;

          var self = this;
          var requireBundle = function (resolve, reject) {
            if (_this2._doesBundleExists(self.getCurrentLanguage(), bundleName)) {
              resolve(self);
            }
            try {
              require(['ty-i18n!' + bundleName], function (i18n) {
                var labels = {};
                if (labels[self.getCurrentLanguage()] === undefined) {
                  labels[self.getCurrentLanguage()] = {};
                }
                labels[self.getCurrentLanguage()][bundleName] = i18n;
                self.addLabels(labels);
                resolve(i18n);
              });
            } catch (e) {
              reject(e);
            }
          };
          return new Promise(requireBundle);
        }

        /**
         * Gets the label for the key passed as parameter, undefined if not found.
         * @param bundle - the bundle, i.e. dashboard, tyra.
         * @param {string} key - the desired key.
         * @returns {string} - the desired label in the current language.
         */

      }, {
        key: 'getLabel',
        value: function getLabel(bundle, key) {
          var label = void 0;
          try {
            label = this.labels[this.getCurrentLanguage()][bundle][key];
          } catch (e) {
            label = undefined;
          }
          return label;
        }

        /**
         * Adds new labels to the repository.
         * @param {*} labels - An object containing the labels and keys to be added
         * ```
         * {
         *    "langW":{
         *     "bundleX":{
         *       "keyY":"labelZ"
         *       ...
         *     },
         *     ...
         *    }
         *    ...
         * }
         * ```
         */

      }, {
        key: 'addLabels',
        value: function addLabels(labels) {
          var _this3 = this;

          Object.keys(labels).forEach(function (langKey) {
            Object.keys(labels[langKey]).forEach(function (bundleKey) {
              Object.keys(labels[langKey][bundleKey]).forEach(function (labelKey) {
                if (!_this3._doesLabelExists(langKey, bundleKey, labelKey)) {
                  var value = labels[langKey][bundleKey][labelKey];
                  _this3._createLabel(langKey, bundleKey, labelKey, value);
                }
              });
            });
          });
        }
      }, {
        key: '_doesLabelExists',
        value: function _doesLabelExists(lang, bundle, key) {
          return lang in this.labels && bundle in this.labels[lang] && key in this.labels[lang][bundle];
        }
      }, {
        key: '_doesBundleExists',
        value: function _doesBundleExists(lang, bundle) {
          return lang in this.labels && bundle in this.labels[lang];
        }
      }, {
        key: '_createLabel',
        value: function _createLabel(lang, bundle, key, value) {
          if (!(lang in this.labels)) {
            this.labels[lang] = {};
          }
          if (!(bundle in this.labels[lang])) {
            this.labels[lang][bundle] = {};
          }
          this.labels[lang][bundle][key] = value;
        }

        /**
         * Returns the current language.
         * @returns {string}
         */

      }, {
        key: 'getCurrentLanguage',
        value: function getCurrentLanguage() {
          return session.properties.locale;
        }

        /**
         * Sets the current language.
         * @param {string} lang - the desired language.
         * @returns {Promise}
         */

      }, {
        key: 'setCurrentLanguage',
        value: function setCurrentLanguage(lang) {
          return this.adapter.setCurrentLanguage(lang);
        }
      }]);

      return TYRAI18NAdaptee;
    }(TYAssignments.services.i18n.I18NAdaptee);

    return TYRAI18NAdaptee;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  define('commons/public/js/tyra-5/assignments/services/url/adaptee',['TYAssignments', './../../../config', 'session'], function (TYAssignments, config, session) {
    /**
     * Adaptee for the url module.
     * This class is used to pass the localized urls and use it
     * with a common interface in all new npm apps.
     * @class
     * @memberOf tyra.services.url.TYRAUrlAdaptee
     */
    var TYRAUrlAdaptee = function (_TYAssignments$servic) {
      _inherits(TYRAUrlAdaptee, _TYAssignments$servic);

      function TYRAUrlAdaptee() {
        _classCallCheck(this, TYRAUrlAdaptee);

        var _this = _possibleConstructorReturn(this, (TYRAUrlAdaptee.__proto__ || Object.getPrototypeOf(TYRAUrlAdaptee)).call(this));

        _this.urls = config.urls;
        _this.zendeskUrls = _this.getZendeskUrls();
        return _this;
      }

      /**
       * Gets the name of the app, returns a string with the localized url
       * @param app - the app
       * @abstract
       * @returns {string}
       */


      _createClass(TYRAUrlAdaptee, [{
        key: 'getUrl',
        value: function getUrl(app) {
          var url = this.urls[app];
          if (url !== undefined) {
            url = url.endsWith('/') ? url : url + '/';
          }
          return url;
        }
      }, {
        key: 'getZendeskUrls',
        value: function getZendeskUrls() {
          var zendeskUrls = {};
          var ssoToken = session.ssoToken;
          var userId = session.user.id;
          var baseUrl = '' + config.urls.zendesk_token + ssoToken;
          var goalsRedirect = config.zendesk_redirects.goals;
          var tasksRedirect = config.zendesk_redirects.tasks;
          var cardAssigments = config.zendesk_redirects.card_assignments;
          zendeskUrls.goals = baseUrl + '?sso_token=' + ssoToken + '&user_id=' + userId + '&return_to=' + goalsRedirect;
          zendeskUrls.tasks = baseUrl + '?sso_token=' + ssoToken + '&user_id=' + userId + '&return_to=' + tasksRedirect;
          zendeskUrls.cardAssigments = baseUrl + '?sso_token=' + ssoToken + '&user_id=' + userId + '&return_to=' + cardAssigments;
          return zendeskUrls;
        }
      }]);

      return TYRAUrlAdaptee;
    }(TYAssignments.services.url.UrlAdaptee);

    return TYRAUrlAdaptee;
  });
})();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(function () {
  define('commons/public/js/tyra-5/assignments/services/sidePanels/adaptee',['jquery', 'require', 'TYAssignments'], function ($, require, TYAssignments) {
    /**
     * Adaptee for the i18n module.
     * This class is used to adapt the original tyra's i18n mechanism and use it
     * with a common interface in all new npm apps.
     * @class
     * @memberOf tyra.services.sidePanels.TYRASidePanelsAdaptee
     */
    var TYRASidePanelsAdaptee = function (_TYAssignments$servic) {
      _inherits(TYRASidePanelsAdaptee, _TYAssignments$servic);

      function TYRASidePanelsAdaptee() {
        _classCallCheck(this, TYRASidePanelsAdaptee);

        return _possibleConstructorReturn(this, (TYRASidePanelsAdaptee.__proto__ || Object.getPrototypeOf(TYRASidePanelsAdaptee)).apply(this, arguments));
      }

      _createClass(TYRASidePanelsAdaptee, [{
        key: 'editTaskPanel',
        value: function editTaskPanel(params) {
          require(['tasks-app'], function () {
            $('<div></div>').AlertPanel().init(params);
          });
        }
      }, {
        key: 'addTaskPanel',
        value: function addTaskPanel(params, onSave) {
          require(['tasks-app'], function () {
            require(['TaskPanel'], function (TaskPanel) {
              TaskPanel.open(params, onSave);
            });
          });
        }
      }, {
        key: 'manageRulesPanel',
        value: function manageRulesPanel(params) {
          require(['survey-app'], function () {
            require(['ManageRulesPanel'], function (ManageRulesPanel) {
              ManageRulesPanel.open(params);
            });
          });
        }
      }, {
        key: 'editGoalPanel',
        value: function editGoalPanel(params, onDelete) {
          require(['goals-app'], function () {
            params.onDelete = function (id) {
              $.fancybox.close();
              onDelete && onDelete(id);
            };
            $.fancybox({
              content: $('<div/>').editGoal(params).html(),
              padding: 20,
              onComplete: function () {
                $.fn.editGoal.attachHandlers(params);
              }
            });
          });
        }
      }, {
        key: 'addGoalPanel',
        value: function addGoalPanel(params) {
          require(['goals-app'], function () {
            $('<div></div>').GoalPanel().init(params);
          });
        }
      }, {
        key: 'exportModule',
        value: function exportModule(params) {
          require(['assignments-export-module'], function (createModule) {
            var moduleParams = {
              app: 'assignments',
              module: params.module,
              options: {
                filter: params.filter
              }
            };
            createModule($('<div></div>'), null, moduleParams).addToExportPane();
          });
        }
      }]);

      return TYRASidePanelsAdaptee;
    }(TYAssignments.services.sidePanels.SidePanelsAdaptee);

    return TYRASidePanelsAdaptee;
  });
})();
(function () {
  /**
   * This module is executed only once and ensures that all the adapters required for assignments app are properly
   * configured.
   *
   * It returns a promise, wait for it to resolve in every component
   */
  define('commons/public/js/tyra-5/assignments/bootstrap',['./services/session/adaptee', './services/i18n/adaptee', './services/url/adaptee', './services/sidePanels/adaptee', 'TYAssignments'], function (TYRASessionAdaptee, TYRAI18NAdaptee, TYRAUrlAdaptee, TYRASidePanelsAdaptee, TYAssignments) {
    var allDoneCallback = function (resolve, reject) {
      // Assign concrete SessionAdaptee
      TYAssignments.services.session.SessionAdapter.setAdapteeClass(TYRASessionAdaptee);
      // Assign concrete I18NAdaptee
      TYAssignments.services.i18n.I18NAdapter.setAdapteeClass(TYRAI18NAdaptee);
      // Assign concrete UrlAdaptee
      TYAssignments.services.url.UrlAdapter.setAdapteeClass(TYRAUrlAdaptee);
      // Assign concrete TYRASidePanelsAdaptee
      TYAssignments.services.sidePanels.SidePanelsAdapter.setAdapteeClass(TYRASidePanelsAdaptee);

      resolve();
    };
    return new Promise(allDoneCallback);
  });
})();
define('commons/public/jadec/tyra-5/assignments/header-module',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var title, error, info_list;
title = title !== undefined ? title: '';
info_list = info_list !== undefined ? info_list : [];
buf.push("<div class=\"trustyou-ui card\"><div class=\"card-header\"><h2>" + (((jade.interp = title) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body\"><ul>");
// iterate info_list
;(function(){
  var $$obj = info_list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var info = $$obj[$index];

buf.push("<li>" + (jade.escape((jade.interp = info.name) == null ? '' : jade.interp)) + ": " + (jade.escape((jade.interp = info.value) == null ? '' : jade.interp)) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      if ($$obj.hasOwnProperty($index)){      var info = $$obj[$index];

buf.push("<li>" + (jade.escape((jade.interp = info.name) == null ? '' : jade.interp)) + ": " + (jade.escape((jade.interp = info.value) == null ? '' : jade.interp)) + "</li>");
      }

    }

  }
}).call(this);

buf.push("</ul></div></div>");
if ( error)
{
buf.push("<div class=\"trustyou-ui notification notification-negative\">" + (jade.escape((jade.interp = error) == null ? '' : jade.interp)) + "</div>");
}
}
return buf.join("");
};

});


(function () {
  'use strict';

  define('commons/public/js/tyra-5/assignments/export/assignments-tasks-export',['jquery', 'TYAssignments', './../bootstrap', './../../../../jadec/tyra-5/assignments/header-module', 'ty-i18n!tyra-5', 'ty-i18n!assignments-app', 'ty-i18n!tasks-app_js', './assignments-helpers'], function ($, TYAssignments, AssignmentsBootstrap, headerTmpl, i18nTyra, i18n, i18nTasks, helpers) {
    var defaults = {
      dataprovider: function () {
        var params = this._data().params,
            isPdf = params.format === 'pdf',
            deferred = $.Deferred();

        AssignmentsBootstrap.then(function () {
          var _TYAssignments$app;

          // selectedProperty, assignees, statuses, page, pageSize, sortHeader, sortType
          var args = [params.filter.selectedProperty, params.filter.selectedAssignees, params.filter.selectedStatuses, isPdf ? params.filter.selectedPage : null, isPdf ? params.filter.elementsPerPage : null, isPdf ? params.filter.selectedOrderHeader : null, isPdf ? params.filter.selectedOrderType : null];

          (_TYAssignments$app = TYAssignments.app).getTasksTableProgressData.apply(_TYAssignments$app, [deferred.resolve, deferred.reject].concat(args));
        });
        return deferred;
      },

      pdfRenderer: function (data) {
        var deferred = $.Deferred(),
            params = this._data().params,
            error = data === null ? '' + (i18nTyra.error_generation_module || '@Error occurred') : null,
            totalRowsCount = data && data.tableData && data.tableData.rowsCount || 0;

        var header = headerTmpl({
          title: (i18nTyra.module_operations || '@Operations') + ' &#x00BB; ' + (i18nTyra.tab_tasks || '@Tasks'),
          info_list: [helpers.preparePropertyInfo(params.filter.selectedProperty), helpers.prepareRangeInfo(params.filter.selectedPage, params.filter.elementsPerPage, totalRowsCount), helpers.prepareStatusesInfo(params.filter.selectedStatuses), helpers.prepareAssigneesInfo(params.filter.selectedAssignees)],
          error: error
        });
        this.append(header);

        if (data === null) {
          return deferred.resolve();
        }

        var progressData = data.progressData || {};
        var progressContainer = $('<div/>');
        this.append(progressContainer);
        TYAssignments.app.renderProgress(progressContainer[0], progressData, '' + (i18n.task_progress || '@Task progress'));

        var tableData = data.tableData || {};
        tableData.headers = tableData.headers || [];
        tableData.rows = tableData.rows || [];

        var tableContainer = $('<div/>');
        this.append(tableContainer);
        TYAssignments.app.renderTable(tableContainer[0], tableData.headers, tableData.rows);

        return deferred.resolve();
      },

      excelRenderer: function (data) {
        var deferred = $.Deferred(),
            params = this._data().params,
            error = data === null ? '' + (i18nTyra.error_generation_module || '@Error occurred') : null,
            propertyInfo = helpers.preparePropertyInfo(params.filter.selectedProperty),
            statusesInfo = helpers.prepareStatusesInfo(params.filter.selectedStatuses),
            assigneesInfo = helpers.prepareAssigneesInfo(params.filter.selectedAssignees);

        var exportData = [['s', JSON.stringify({ label: (i18nTyra.module_operations || '@Operations') + ' - ' + (i18nTyra.tab_tasks || '@Tasks') })], ['c', '', JSON.stringify([propertyInfo.name + ': ' + propertyInfo.value])], ['c', '', JSON.stringify([statusesInfo.name + ': ' + statusesInfo.value])], ['c', '', JSON.stringify([assigneesInfo.name + ': ' + assigneesInfo.value])]];

        if (data === null) {
          exportData.push(['c', JSON.stringify({ format: { bg_color: '#f8b5a6', font_color: '#ed4c27' } }), JSON.stringify([{ type: 'string', value: error }, '', '', '', '', '', '', '', '', '', '', ''])]);
          return deferred.resolve(exportData);
        }

        var tableData = data.tableData || {};
        tableData.headers = tableData.headers || [];
        tableData.headers.push({
          title: i18nTasks.comments,
          fieldRef: 'task',
          type: 'comments'
        });
        var tableHeader = tableData.headers.map(function (header) {
          return header.title;
        });
        exportData.push(['r', JSON.stringify({ height: 47, format: { align: 'center', text_wrap: 1 } }), JSON.stringify(tableHeader)]);

        tableData.rows = tableData.rows || [];
        var exportRows = tableData.rows.map(function (row) {
          var tableRow = tableData.headers.map(function (header) {
            var cell = {
              value: row.data[header.fieldRef]
            };
            if (!isNaN(parseFloat(cell.value)) && isFinite(cell.value)) {
              cell.type = 'number';
              cell.format = { num_format: '0.00' };
            }
            switch (header.type) {
              case 'date':
                {
                  cell.type = 'date';
                  cell.format = { num_format: 'yyyy/mm/dd' };
                  break;
                }
              case 'taskStatus':
                {
                  var status = helpers.statusesMap[cell.value];
                  if (status) {
                    cell.value = i18n[status.i18nKey];
                    cell.format = { font_color: status.color };
                  }
                  break;
                }
              case 'comments':
                {
                  var comments = cell.value.comments;
                  comments = comments.map(function (comment) {
                    return comment.author + ': ' + comment.content;
                  });
                  cell.value = comments.join('\n');
                  cell.format = { text_wrap: true };
                  break;
                }
            }
            return cell;
          });
          return ['r', '', JSON.stringify(tableRow)];
        });

        return $.Deferred().resolve(exportData.concat(exportRows));
      },

      rendered: $.noop,
      error: $.noop
    };

    $.fn.TasksExport = function () {
      // Attach the API
      return $.extend(this, $.fn.TasksExport.API);
    };

    // Plugin API
    $.fn.TasksExport.API = {
      init: function (params) {
        params = $.extend(true, {}, defaults, params);
        this._data({ params: params });
        this.refresh();
        return this;
      },
      _data: function (data) {
        var attr = 'assignmentsTasksExport';
        if (data) {
          return this.data(attr, data);
        } else {
          return this.data(attr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        // Format
        if (params.format === 'pdf') {
          params.renderer = params.pdfRenderer;
        } else {
          params.renderer = params.excelRenderer;
        }

        params.dataprovider.call(self).done(function (data) {
          // render report
          params.renderer.call(self, data).done(function (rendererData) {
            params.rendered.call(self, rendererData);
          }).fail(function (e) {
            params.error.call(self, e);
          });
        }).fail(function (e) {
          // render report with null data, it will show error msg for module
          params.renderer.call(self, null).done(function (data) {
            params.rendered.call(self, data);
          }).fail(function (rendererErr) {
            params.error.call(self, rendererErr);
          });
        });

        return this;
      }
    };

    $.fn.TasksExport.canHandle = function (moduleParams) {
      return moduleParams.module === 'Tasks';
    };

    return $.fn.TasksExport;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/assignments/export/assignments-goals-export',['jquery', 'TYAssignments', './../bootstrap', './../../../../jadec/tyra-5/assignments/header-module', 'ty-i18n!tyra-5', 'ty-i18n!assignments-app', './assignments-helpers'], function ($, TYAssignments, AssignmentsBootstrap, headerTmpl, i18nTyra, i18n, helpers) {
    var defaults = {
      dataprovider: function () {
        var params = this._data().params,
            isPdf = params.format === 'pdf',
            deferred = $.Deferred();

        AssignmentsBootstrap.then(function () {
          var _TYAssignments$app;

          // selectedProperty, assignees, statuses, page, pageSize, sortHeader, sortType
          var args = [params.filter.selectedProperty, params.filter.selectedAssignees, params.filter.selectedStatuses, isPdf ? params.filter.selectedPage : null, isPdf ? params.filter.elementsPerPage : null, isPdf ? params.filter.selectedOrderHeader : null, isPdf ? params.filter.selectedOrderType : null];
          (_TYAssignments$app = TYAssignments.app).getGoalsTableProgressData.apply(_TYAssignments$app, [deferred.resolve, deferred.reject].concat(args));
        });
        return deferred;
      },

      pdfRenderer: function (data) {
        var deferred = $.Deferred(),
            params = this._data().params,
            error = data === null ? '' + (i18nTyra.error_generation_module || '@Error occurred') : null,
            totalRowsCount = data && data.tableData && data.tableData.rowsCount || 0;

        var header = headerTmpl({
          title: (i18nTyra.module_operations || '@Operations') + ' &#x00BB; ' + (i18nTyra.tab_goals || '@Goals'),
          info_list: [helpers.preparePropertyInfo(params.filter.selectedProperty), helpers.prepareRangeInfo(params.filter.selectedPage, params.filter.elementsPerPage, totalRowsCount), helpers.prepareStatusesInfo(params.filter.selectedStatuses), helpers.prepareAssigneesInfo(params.filter.selectedAssignees)],
          error: error
        });
        this.append(header);

        if (data === null) {
          return deferred.resolve();
        }

        var progressData = data.progressData || {};
        var progressContainer = $('<div/>');
        this.append(progressContainer);
        TYAssignments.app.renderProgress(progressContainer[0], progressData, '' + (i18n.goal_progress || '@Goal progress'));

        var tableData = data.tableData || {};
        tableData.headers = tableData.headers || [];
        tableData.rows = tableData.rows || [];

        var nameHeader = tableData.headers.slice(0, 1);
        var firstTableHeaders = tableData.headers.slice(1, 8);
        var firstTableContainer = $('<div/>');
        this.append(firstTableContainer);
        TYAssignments.app.renderTable(firstTableContainer[0], nameHeader.concat(firstTableHeaders), tableData.rows);

        var secondTableHeaders = tableData.headers.slice(8);
        var secondTableContainer = $('<div/>');
        this.append(secondTableContainer);
        TYAssignments.app.renderTable(secondTableContainer[0], nameHeader.concat(secondTableHeaders), tableData.rows);

        return deferred.resolve();
      },

      excelRenderer: function (data) {
        var deferred = $.Deferred(),
            params = this._data().params,
            error = data === null ? '' + (i18nTyra.error_generation_module || '@Error occurred') : null,
            propertyInfo = helpers.preparePropertyInfo(params.filter.selectedProperty),
            statusesInfo = helpers.prepareStatusesInfo(params.filter.selectedStatuses),
            assigneesInfo = helpers.prepareAssigneesInfo(params.filter.selectedAssignees);

        var exportData = [['s', JSON.stringify({ label: (i18nTyra.module_operations || '@Operations') + ' - ' + (i18nTyra.tab_goals || '@Goals') })], ['c', '', JSON.stringify([propertyInfo.name + ': ' + propertyInfo.value])], ['c', '', JSON.stringify([statusesInfo.name + ': ' + statusesInfo.value])], ['c', '', JSON.stringify([assigneesInfo.name + ': ' + assigneesInfo.value])]];

        if (data === null) {
          exportData.push(['c', JSON.stringify({ format: { bg_color: '#f8b5a6', font_color: '#ed4c27' } }), JSON.stringify([{ type: 'string', value: error }, '', '', '', '', '', '', '', '', '', '', ''])]);
          return deferred.resolve(exportData);
        }

        var tableData = data.tableData || {};
        tableData.headers = tableData.headers || [];
        var tableHeader = tableData.headers.map(function (header) {
          return header.title;
        });
        exportData.push(['r', JSON.stringify({ height: 47, format: { align: 'center', text_wrap: 1 } }), JSON.stringify(tableHeader)]);

        tableData.rows = tableData.rows || [];
        var exportRows = tableData.rows.map(function (row) {
          var tableRow = tableData.headers.map(function (header) {
            var cell = {
              value: row.data[header.fieldRef]
            };
            if (!isNaN(parseFloat(cell.value)) && isFinite(cell.value)) {
              cell.type = 'number';
              cell.format = { num_format: '0.00' };
            }
            switch (header.type) {
              case 'date':
                {
                  cell.type = 'date';
                  cell.format = { num_format: 'yyyy/mm/dd' };
                  break;
                }
              case 'goalStatus':
                {
                  var status = helpers.statusesMap[cell.value];
                  if (status) {
                    cell.value = i18n[status.i18nKey];
                    cell.format = { font_color: status.color };
                  }
                  break;
                }
            }
            return cell;
          });
          return ['r', '', JSON.stringify(tableRow)];
        });

        return deferred.resolve(exportData.concat(exportRows));
      },

      rendered: $.noop,
      error: $.noop
    };

    $.fn.GoalsExport = function () {
      // Attach the API
      return $.extend(this, $.fn.GoalsExport.API);
    };

    // Plugin API
    $.fn.GoalsExport.API = {
      init: function (params) {
        params = $.extend(true, {}, defaults, params);
        this._data({ params: params });
        this.refresh();
        return this;
      },
      _data: function (data) {
        var attr = 'assignmentsGoalsExport';
        if (data) {
          return this.data(attr, data);
        } else {
          return this.data(attr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        // Format
        if (params.format === 'pdf') {
          params.renderer = params.pdfRenderer;
        } else {
          params.renderer = params.excelRenderer;
        }

        params.dataprovider.call(self).done(function (data) {
          // render report
          params.renderer.call(self, data).done(function (rendererData) {
            params.rendered.call(self, rendererData);
          }).fail(function (e) {
            params.error.call(self, e);
          });
        }).fail(function (e) {
          // render report with null data, it will show error msg for module
          params.renderer.call(self, null).done(function (data) {
            params.rendered.call(self, data);
          }).fail(function (rendererErr) {
            params.error.call(self, rendererErr);
          });
        });

        return this;
      }
    };

    $.fn.GoalsExport.canHandle = function (moduleParams) {
      return moduleParams.module === 'Goals';
    };

    return $.fn.GoalsExport;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/assignments/export/assignments-export',['jquery', './assignments-tasks-export', './assignments-goals-export'], function ($, tasksExport, goalsExport) {
    var exportPlugins = [tasksExport, goalsExport];

    return function (report, moduleParams, container, callback, errback) {
      // eslint-disable-line consistent-return
      var plugin = exportPlugins.find(function (p) {
        return p.canHandle(moduleParams);
      });
      if (!plugin) {
        console.error('No plugin found for module ' + moduleParams.module); // eslint-disable-line no-console
        return callback(null);
      }

      var processPlugin = function (pluginToProcess) {
        // eslint-disable-line consistent-return
        // Render the module
        $(container).addClass('assignments-export');
        pluginToProcess.call($(container)).init($.extend(true, {}, moduleParams.options, {
          type: moduleParams.module,
          rendered: callback,
          error: errback,
          format: report.format
        }));
        return false;
      };

      processPlugin(plugin);
    };
  });
})();
define('commons/public/jadec/tyra-5/views/settings/basic_section',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right basic-section\"><div class=\"card-header\"><a class=\"icon-box is-disabled\"><i class=\"ty-icon ty-icon-profile\"></i><i class=\"ty-icon ty-icon-help-o\"></i></a><h2>" + (jade.escape((jade.interp = basicSettings) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body settings-basic-container\"><form class=\"basic-settings\"><div id=\"basic-settings-form-container\"><div class=\"row\"><div class=\"col-4\"><label for=\"userName\">" + (jade.escape((jade.interp = username) == null ? '' : jade.interp)) + "</label><input type=\"text\" disabled=\"disabled\" name=\"userNameDisplay\" id=\"userName\" style=\"width:180px\"/></div><div class=\"col-4 select-language\"><label for=\"locale\">" + (jade.escape((jade.interp = language) == null ? '' : jade.interp)) + "</label><div class=\"languages\"></div></div>");
if ( renderScoreScaling)
{
buf.push("<div class=\"col-4\"><label for=\"scale\">" + (jade.escape((jade.interp = scaling) == null ? '' : jade.interp)) + "<a" + (jade.attrs({ 'title':("" + (scalingTooltip) + ""), "class": ('help-trigger') + ' ' + ('help-scaling') }, {"title":true})) + "><i class=\"ty-icon ty-icon-help-o\"></i></a></label><div class=\"scaling\"></div></div>");
}
buf.push("</div><div class=\"row\"><div class=\"col-4\"><label for=\"currentPassword\">" + (jade.escape((jade.interp = currentPassword) == null ? '' : jade.interp)) + "</label><input type=\"password\" name=\"currentPassword\" id=\"currentPassword\" style=\"width:180px\"/></div><div class=\"col-4\"><label for=\"password\">" + (jade.escape((jade.interp = newPassword) == null ? '' : jade.interp)) + "</label><input type=\"password\" name=\"password\" id=\"password\" style=\"width:180px\"/></div><div class=\"col-4\"><label for=\"passwordConfirmed\">" + (jade.escape((jade.interp = retypePassword) == null ? '' : jade.interp)) + "</label><input type=\"password\" name=\"passwordConfirmed\" id=\"passwordConfirmed\" style=\"width:180px\"/></div></div><div class=\"row\"><div class=\"col-4\"></div><div class=\"col-4\"><ul class=\"password-rules\"><li class=\"rule-length\"><i class=\"ty-icon ty-icon-remove\"></i>" + (jade.escape((jade.interp = passwordPolicyLength) == null ? '' : jade.interp)) + "</li><li class=\"rule-digit\"><i class=\"ty-icon ty-icon-remove\"></i>" + (jade.escape((jade.interp = passwordPolicyDigit) == null ? '' : jade.interp)) + "</li><li class=\"rule-letter\"><i class=\"ty-icon ty-icon-remove\"></i>" + (jade.escape((jade.interp = passwordPolicyLetter) == null ? '' : jade.interp)) + "</li><li class=\"rule-confirm\"><i class=\"ty-icon ty-icon-remove\"></i>" + (jade.escape((jade.interp = passwordPolicyConfirm) == null ? '' : jade.interp)) + "</li></ul></div><div class=\"col-4\"></div></div><div id=\"errorSection\"></div></div></form></div><div class=\"card-footer\"><div id=\"save-button-container\"></div></div></div>");
}
return buf.join("");
};

});


(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/settings/basic',['jquery', 'session', './../../config', 'settings-permissions', './../../../../jadec/tyra-5/views/settings/basic_section', 'ty-i18n!tyra-5', 'ty-i18n!package_4x', 'email-input'], function ($, session, config, SettingsPermissions, sectionTmpl, i18n, i18nTyra4) {
    if ($.fn.SettingsBasic) {
      throw new Error('SettingsBasic plugin is already defined');
    }

    $.fn.SettingsBasic = function (params) {
      // Attach the API
      $.extend(this, $.fn.SettingsBasic.API);
      return this.init(params);
    };

    var permissions = new SettingsPermissions(session);

    var defaults = {
      userName: session.user.username,
      scale: session.properties.scale,
      locale: session.properties.locale,
      isMetareviewOnlyUser: session.has('metareview') && !session.has('stars'),
      languages: config.tool_languages,
      labels: {
        username: i18n.username || '@Username',
        basicSettings: i18n.basic_settings || '@Basic Settings',
        language: i18n.language || '@Language',
        scaling: i18n.scaling || '@Score Scaling',
        currentPassword: i18n.current_password || '@Current Password',
        newPassword: i18n.new_password || '@New Password',
        retypePassword: i18n.retype_password || '@Retype Password',
        passwordPolicyLength: i18nTyra4.password_policy_length || '@Must be at least 8 characters long',
        passwordPolicyDigit: i18nTyra4.password_policy_digit || '@Must contain at least one digit',
        passwordPolicyLetter: i18nTyra4.password_policy_letter || '@Must contain at least one letter',
        passwordPolicyConfirm: i18nTyra4.password_policy_confirm || '@Must be confirmed by retyping',
        save: i18n.save_changes || 'Save',
        scaleTo: i18n.common_scale_to || '@Scale to',
        scalingTooltip: i18n.scaling_tooltip,
        isNotValid: i18n.is_not_valid || '@{field} is not correct',
        incorrectPasswords: i18n.incorrect_passwords || '@The passwords are not correct',
        differentPasswords: i18n.different_passwords || '@The passwords do not match',
        notSecurePassword: i18nTyra4.users_password_not_secure || '@The must follow the policy',
        shortPassword: i18n.password_too_short || '@The password is too short'
      },

      dataprovider: function () {
        return $.Deferred().resolve();
      },

      renderer: function () {
        var self = this;
        var params = self._data().params;

        self.html(sectionTmpl($.extend(true, {}, params.labels, {
          renderScoreScaling: !params.isMetareviewOnlyUser
        })));

        // Add save button for basic settings
        self.find('#save-button-container').append($('<a class="trustyou-ui btn btn-primary waves-effect submit-password"></a>').text(params.labels.save).click(function () {
          var sessionValues = [];
          sessionValues.push({
            name: 'locale',
            value: self.find('#locale').val()
          });
          sessionValues.push({
            name: 'scale',
            value: parseInt(self.find('#scale').val()) || 100
          });

          self.save(sessionValues);
        }));

        self.find('#userName').val(params.userName);

        // Add languages
        self.find('.languages').append('<select id="locale">');
        $.each(params.languages, function (idx, language) {
          self.find('.languages select').append('<option value="' + language.code + '">' + language.name + '</option>');
        });
        self.find('.languages').append('</select>');
        self.find('.languages #locale').selectmenu({
          style: 'dropdown',
          width: '180px',
          menuWidth: '180px'
        });

        self.find('.languages #locale').selectmenu('value', params.locale);

        if (!params.isMetareviewOnlyUser) {
          // Add scaling
          self.find('.scaling').append('' + ('<select id="scale">' + '<option value="5">') + params.labels.scaleTo + ' 5</option>' + ('<option value="10">' + params.labels.scaleTo + ' 10</option>') + ('<option value="100">' + params.labels.scaleTo + ' 100</option>') + '</select>');

          self.find('.scaling #scale').selectmenu({
            style: 'dropdown',
            width: '180px',
            menuWidth: '180px'
          });

          self.find('.scaling #scale').selectmenu('value', params.scale);
        }

        // Adding event to control if passwords are equal
        self.find('#password, #passwordConfirmed').keyup(function () {
          self.controlPasswords();
        });

        require(['sso/static/js/users-utils/utils'], function (PasswordInput) {
          PasswordInput.addHandlers('password', 'passwordConfirmed', false);
        });

        return $.Deferred().resolve();
      },
      rendered: $.noop,
      error: $.noop
    };

    $.fn.SettingsBasic.API = {
      init: function (params) {
        if (!permissions.canEditUserProfile()) {
          return this;
        }

        params = $.extend(true, {}, defaults, params);
        this._data({ params: params }).refresh();
        return this;
      },
      _data: function (data) {
        var dataAttr = 'basicData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        params.dataprovider.call(self).done(function () {
          params.renderer.call(self).done(function () {
            params.rendered.call(self);
          });
        });

        return this;
      },
      controlPasswords: function () {
        var password = this.find('#password').val();
        var passwordConfirmed = this.find('#passwordConfirmed').val();

        if (password === passwordConfirmed && password.length >= 1) {
          this.find('#password').addClass('highlight-correct');
          this.find('#passwordConfirmed').addClass('highlight-correct');
        } else {
          this.find('#password').removeClass('highlight-correct');
          this.find('#passwordConfirmed').removeClass('highlight-correct');
          this.find('#password').removeClass('highlight-error');
          this.find('#passwordConfirmed').removeClass('highlight-error');
        }
      },


      /* eslint-disable consistent-return */
      save: function (sessionParams) {
        var self = this,
            params = self._data().params;

        self.find('#currentPassword').removeClass('highlight-error');
        self.find('#password').removeClass('highlight-error');
        self.find('#passwordConfirmed').removeClass('highlight-error');
        self.find('#errorSection').empty();

        var ssoTokenCookie = 'sso_token';

        var currentPassword = self.find('#currentPassword').val();
        var password = self.find('#password').val();
        var passwordConfirmed = self.find('#passwordConfirmed').val();

        if (password.length >= 1 && password === passwordConfirmed) {
          return $.ajax({
            url: config.urls.sso + '/api/users/passwords/' + session.user.id,
            type: 'post',
            cache: false,
            data: {
              old_password: currentPassword,
              new_password: password,
              sso_token: $.cookie(ssoTokenCookie)
            }
          }).done(function (data) {
            session.setProperties(sessionParams);
            self.find('#errorSection').hide();
          }).fail(function (error) {
            var errorMessage = JSON.parse(error.responseText);
            if (errorMessage.meta.code === '404') {
              self.find('#currentPassword').addClass('highlight-error');
              self.find('#errorSection').hide();
              self.find('#errorSection').append('<p class="section-error">' + params.labels.isNotValid.replace('{field}', params.labels.currentPassword) + '.</p>');
              self.find('#errorSection').fadeIn();
            } else {
              var errors = errorMessage.meta.errors;

              if (errors[0].parameter === 'new_password') {
                self.find('#password').addClass('highlight-error');
                self.find('#errorSection').hide();
                self.find('#errorSection').append('<p class="section-error">' + params.labels.notSecurePassword + '.</p>');
                self.find('#errorSection').fadeIn();
              } else if (errors[0].parameter === 'new_password_confirm') {
                self.find('#password').addClass('highlight-error');
                self.find('#passwordConfirmed').addClass('highlight-error');
                self.find('#errorSection').hide();
                self.find('#errorSection').append('<p class="section-error">' + params.labels.incorrectPasswords + '.</p>');
                self.find('#errorSection').fadeIn();
              }
            }
          });
        } else if (password.length === 0 && passwordConfirmed.length === 0) {
          self.find('#errorSection').hide();
          session.setProperties(sessionParams);
        } else if (password !== passwordConfirmed) {
          self.find('#password').addClass('highlight-error');
          self.find('#passwordConfirmed').addClass('highlight-error');
          self.find('#errorSection').hide();
          self.find('#errorSection').append('<p class="section-error">' + params.labels.differentPasswords + '.</p>');
          self.find('#errorSection').fadeIn();
        } else {
          self.find('#password').addClass('highlight-error');
          self.find('#passwordConfirmed').addClass('highlight-error');
          self.find('#errorSection').hide();
          self.find('#errorSection').append('<p class="section-error">' + params.labels.shortPassword + '.</p>');
          self.find('#errorSection').fadeIn();
        }
      }
    };

    return $.fn.SettingsBasic;
  });
})();
define('commons/public/jadec/tyra-5/views/settings/alerts_section',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right\"><div class=\"card-header\"><a class=\"icon-box is-disabled\"><i class=\"ty-icon ty-icon-email\"></i><i class=\"ty-icon ty-icon-help-o\"></i></a><h2>" + (jade.escape((jade.interp = settings_alerting) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body settings-alerts-container\">");
if ( showPortfolio)
{
buf.push("<div class=\"trustyou-ui notification\"><p>" + (jade.escape((jade.interp = settings_alerting_tooltip) == null ? '' : jade.interp)) + "</p></div>");
}
buf.push("<div class=\"basic_container\"><input type=\"checkbox\" name=\"enableAlerts\" id=\"enableAlerts\"/><label for=\"enableAlerts\" id=\"enableAlertsLabel\">" + (jade.escape((jade.interp = enable_email_alerts) == null ? '' : jade.interp)) + "</label></div><div class=\"row selection-emails\"><div class=\"col-6\"><h3>" + (jade.escape((jade.interp = help_email_list) == null ? '' : jade.interp)) + "</h3><div id=\"email-input-placeholder\"></div></div></div>");
if ( showPortfolio)
{
buf.push("<div class=\"row selection-clusters\"><div class=\"col-6\"><div class=\"groups\"><h3>" + (jade.escape((jade.interp = portfolio_groups) == null ? '' : jade.interp)) + "</h3><p>" + (jade.escape((jade.interp = help_text_select_hotels) == null ? '' : jade.interp)) + "</p><div class=\"list\"></div></div></div><div class=\"col-6\"><div class=\"clusters\"><h3>" + (jade.escape((jade.interp = hotels) == null ? '' : jade.interp)) + "</h3><div class=\"list\"></div></div></div></div>");
}
buf.push("<div class=\"row selection\">");
if ( showAlertSections)
{
buf.push("<div class=\"col-6\"><div class=\"sections ty-list\"><h3>" + (jade.escape((jade.interp = sections_of_alerts) == null ? '' : jade.interp)) + "</h3><p>" + (jade.escape((jade.interp = help_text_sections_of_alert) == null ? '' : jade.interp)) + "</p><div class=\"list content list-container\"></div></div></div>");
}
if ( showKeywordAlerts)
{
buf.push("<div class=\"col-6\"><div class=\"keywords ty-list\"><h3>" + (jade.escape((jade.interp = keywords) == null ? '' : jade.interp)) + "</h3><p>" + (jade.escape((jade.interp = help_text_keywords) == null ? '' : jade.interp)) + "</p><textarea id=\"keyword_list\" row=\"4\" cols=\"50\"></textarea></div></div>");
}
buf.push("</div></div><div class=\"card-footer\"><div id=\"save-alerts-button-container\" class=\"l-right\"></div></div></div>");
}
return buf.join("");
};

});

define('commons/public/jadec/tyra-5/views/settings/stump_section',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
var error = error !== undefined ? error : false
var loading = loading !== undefined ? loading : false
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right\"><div class=\"card-header\"><h2>" + (jade.escape((jade.interp = header) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body\">");
if ( error)
{
buf.push("<div class=\"trustyou-ui notification notification-negative\"><p>" + (((jade.interp = error) == null ? '' : jade.interp)) + "</p></div>");
}
if ( loading)
{
buf.push("<div class=\"trustyou-ui spinner\"></div>");
}
buf.push("</div></div>");
}
return buf.join("");
};

});


(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/settings/alerts',['jquery', 'session', './../../config', './../../utils', 'settings-permissions', './../../../../jadec/tyra-5/views/settings/alerts_section', './../../../../jadec/tyra-5/views/settings/stump_section', 'ty-i18n!tyra-5', 'ty-i18n!alerts', 'ty-i18n!analytics_js_4x'], function ($, session, config, utils, SettingsPermissions, sectionTmpl, stumpTmpl, i18n, i18nAlerts, i18nAnalyticsJs4x) {
    if ($.fn.SettingsAlerts) {
      throw new Error('SettingsAlerts plugin is already defined');
    }

    $.fn.SettingsAlerts = function (params) {
      // Attach the API
      $.extend(this, $.fn.SettingsAlerts.API);
      return this.init(params);
    };

    var permissions = new SettingsPermissions(session);
    var permitted = permissions.canEditAlerts();

    var defaults = {
      showPortfolio: session.has('portfolio'),
      showAlertSections: !session.has('stars'),
      showKeywordAlerts: !session.has('stars'),
      section_list: config.alerts_section,

      // set in dataprovider
      selectedClusters: {},
      keyword_list: '',
      section: {},
      email_list: '',
      alert_enabled: null,

      labels: {
        error_getting_data: i18nAnalyticsJs4x.error_getting_data,
        detailsLabel: i18n.selected_items,
        email_settings_tooltip: i18n.email_settings_tooltip,
        settings_alerting_tooltip: i18nAnalyticsJs4x.settings_alerting_tooltip,
        save: i18n.save_changes,
        settings_alerting: i18nAnalyticsJs4x.settings_alerting,
        enable_email_alerts: i18nAlerts.enable_email_alerts,
        show_full_review: i18n.show_full_review,
        help_email_list: i18nAlerts.help_email_list,
        portfolio_groups: i18nAlerts.portfolio_groups,
        help_text_select_hotels: i18nAlerts.help_text_select_hotels,
        hotels: i18nAlerts.hotels,
        sections_of_alerts: i18nAlerts.sections_of_alerts,
        help_text_sections_of_alert: i18nAlerts.help_text_sections_of_alert,
        keywords: i18nAlerts.keywords,
        help_text_keywords: i18nAlerts.help_text_keywords,
        // section list labels
        keyword_review: i18nAlerts.keyw_review,
        negative_review: i18nAlerts.neg_review,
        positive_neutral_review: i18nAlerts.pos_neu_review,
        social_media_statistics: i18nAlerts.social_media_stats,
        surveys: i18nAlerts.surveys,
        open_task: i18nAlerts.open_task
      },

      dataprovider: function () {
        var self = this,
            params = self._data().params;

        return utils.doAjax({
          url: config.urls.alerts + 'settings.json',
          data: {
            userid: session.user.id
          }
        }).pipe(function (data) {
          // Getting setting values
          if (data.response.length > 0) {
            params.selectedClusters = data.response[0].hotel_list;
            params.keyword_list = data.response[0].keyword_list;
            params.section = data.response[0].alert_section;
            params.alert_enabled = data.response[0].alert_enabled;
            params.email_list = data.response[0].email_list || '';
          } else {
            params.selectedClusters = {};
            params.keyword_list = '';
            params.section = {};
            params.alert_enabled = false;
            params.email_list = '';
          }

          // Getting user portfolio groups
          return utils.doAjax({
            url: config.urls.portfolio + 'groups',
            cache: true,
            data: {
              user_id: session.user.id,
              location: 'PORTFOLIO'
            }
          });
        }).pipe(
        // Success
        function (data) {
          return $.map(data.response.group_list, function (group) {
            if (group.count !== 0 && group.count !== '0') {
              return {
                id: group.group_id,
                type: group.type,
                label: $('<div></div>').text($.trim(group.group_name)).addClass('item-name').wrap('<span></span>').parent().html(),
                normalizedName: $.trim(group.group_name).toLowerCase(),
                count: group.count
              };
            }
            return null;
          }).sort(function (a, b) {
            return a.normalizedName.localeCompare(b.normalizedName);
          });
        });
      },

      renderer: function (groups) {
        var self = this,
            params = self._data().params;

        self.html(sectionTmpl($.extend(true, {}, params.labels, {
          showPortfolio: params.showPortfolio,
          showAlertSections: params.showAlertSections,
          showKeywordAlerts: params.showKeywordAlerts
        })));

        if (params.showPortfolio) {
          self.find('.groups .list').List().init({
            prefixDelimiter: ' ',
            escapeHtml: false,

            dataprovider: function () {
              $.each(groups, function (_, element) {
                var alertedClusters = Object.keys(params.selectedClusters[element.id] || {}).length || 0;
                if (element.count) {
                  element.detailsLabel = params.labels.detailsLabel.replace('{selected}', alertedClusters).replace('{total}', element.count);
                }
              });
              return $.Deferred().resolve(groups);
            },

            toggleSelect: function (group, select) {
              var selectedClusters = params.selectedClusters;

              // Cluster list
              if (select) {
                if (!selectedClusters[group.id]) {
                  selectedClusters[group.id] = {};
                }

                self.find('.clusters .list').List().init({
                  multiselect: true,
                  prefixDelimiter: ' ',

                  toggleSelect: function (item, selected) {
                    if (selected) {
                      selectedClusters[group.id][item.id] = '';
                    } else {
                      delete selectedClusters[group.id][item.id];
                    }

                    self.find('.groups .list .selected .detailsLabel').text(params.labels.detailsLabel.replace('{selected}', Object.keys(params.selectedClusters[group.id] || {}).length || 0).replace('{total}', group.count));
                  },

                  dataprovider: function () {
                    var clusterReq = utils.doAjax({
                      url: config.urls.portfolio + 'groups/clusters',
                      type: 'post',
                      data: JSON.stringify({
                        group_list: [group.id],
                        include_group_details: false
                      }),
                      cache: true
                    }).pipe(
                    // Success
                    function (data) {
                      return data.response.results[0].cluster_list;
                    });

                    return clusterReq.pipe(function (clusters) {
                      return $.map(clusters, function (cluster) {
                        return {
                          id: cluster.cluster_id,
                          label: $.trim(cluster.cluster_name),
                          normalizedName: $.trim(cluster.cluster_name).toLowerCase(),
                          selected: selectedClusters[group.id][cluster.cluster_id] !== undefined
                        };
                      }).sort(function (a, b) {
                        return (
                          // Sort by name
                          a.normalizedName.localeCompare(b.normalizedName)
                        );
                      });
                    });
                  }
                });
              } else {
                self.find('.clusters .list').empty();
                self.find('.save-selected').button('disable');
              }
            }
          });
        }

        // Alerts checkbox
        if (params.alert_enabled) {
          self.find('#enableAlerts').attr('checked', 'checked');
        }

        if (!session.has('stars_lite')) {
          // Alerts checkbox
          self.find('#alert-type').attr('disabled', self.find('#enableAlerts').attr('checked') !== 'checked');

          $('#enableAlerts').change(function () {
            self.find('#alert-type').attr('disabled', $(this).attr('checked') !== 'checked');
          });
        }

        var emailInputElement = self.find('#email-input-placeholder');
        emailInputElement.emailInput({
          emails: params.email_list.split(',')
        });

        // Adds tooltip to email settings
        var emailIcon = $('<span></span>').addClass('ui-icon ui-icon-help widget-header-icon widget-header-icon-help');
        var emailTooltip = $('<div></div>').addClass('tooltip').html(params.labels.email_settings_tooltip);

        emailIcon.css({ position: 'relative' }).append($('<div></div>').css({ clear: 'both', padding: '0', margin: '0' })).append(emailTooltip).hover(function () {
          $('.tooltip').hide();
          emailTooltip.stop(true, true).fadeIn();
        }, function () {
          emailTooltip.stop(true, true).fadeOut();
        });

        var emailIconContainer = $('<div class="email-editor-icons"></div>').append(emailIcon);
        emailInputElement.find('.email-input').append(emailIconContainer);

        // Add save button for alerts
        self.find('#save-alerts-button-container').append($('<a class="trustyou-ui btn btn-primary waves-effect"></a>').text(params.labels.save).click(function () {
          var settingsParams = {};
          var emails = null;

          $.each(params.selectedClusters, function (group, hotels) {
            settingsParams[group] = {};
            $.each(hotels, function (key, value) {
              settingsParams[group][key] = true;
            });
          });

          var keywordList = '';
          if (!session.has('stars')) {
            keywordList = self.find('#keyword_list').val().replace(/\n/g, ',').replace(/\t/g, ' ').replace(/[.*+?^$|(){}[\]\\]/g, '');
          }

          var section = {};
          if (!session.has('stars')) {
            $.each(self.find('.sections .list li'), function (idx, value) {
              section[$(this).attr('id')] = $(this).hasClass('selected');
            });
          }

          var alertEnabled = false;
          if (self.find('#enableAlerts').attr('checked') === 'checked') {
            alertEnabled = true;
          }

          var fullTextAlert = false;
          if (session.has('stars_lite')) {
            fullTextAlert = true;
          } else if (self.find('#alert-type').attr('checked') === 'checked') {
            fullTextAlert = true;
          }

          emails = self.find('#email-input-placeholder').emailInput('emails').join(',');

          self.save(settingsParams, keywordList, section, alertEnabled, emails, fullTextAlert);
        }));

        if (!session.has('stars')) {
          // Section list
          var $sectionUl = $('<ul></ul>');

          $.each(params.section_list, function (idx, value) {
            //(CORE-516) Removing these email alerts from frontend
            if (value === 'social_media_statistics' || value === 'open_task') {
              return;
            }
            var $li = $('<li></li>');
            $li.attr('id', value);
            var $span = $('<span></span>');
            $span.text(params.labels[value]);
            $li.html($span);
            $li.addClass('ui-widget-content');

            if (params.section[value]) {
              $li.addClass('selected');
            }

            $sectionUl.append($li);
          });

          $sectionUl.appendTo(self.find('.sections .list').empty());

          // Select / deselect handlers
          $sectionUl.on('click', 'li', function () {
            $(this).toggleClass('selected');
          });

          var keywordsArea = params.keyword_list.length > 0 ? $.map(params.keyword_list.split(','), $.trim) : [];
          var textKeywords = '';
          $.each(keywordsArea, function (_, value) {
            textKeywords += value + '\n';
          });
          self.find('#keyword_list').val(textKeywords);
        }

        return $.Deferred().resolve();
      },
      loading: function () {
        var self = this,
            params = self._data().params;

        this.html(stumpTmpl({
          header: params.labels.settings_alerting,
          loading: true
        }));
      },
      error: function () {
        var self = this,
            params = self._data().params;

        this.html(stumpTmpl({
          header: params.labels.settings_alerting,
          error: params.labels.error_getting_data
        }));
      },
      rendered: $.noop
    };

    $.fn.SettingsAlerts.API = {
      permitted: permitted,
      init: function (params) {
        if (!this.permitted) {
          return this;
        }

        params = $.extend(true, {}, defaults, params);
        this._data({ params: params }).refresh();
        return this;
      },
      _data: function (data) {
        var dataAttr = 'alertsData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        params.loading.call(self);
        params.dataprovider.call(self).done(function (groups) {
          params.renderer.call(self, groups).done(function () {
            params.rendered.call(self);
          });
        }).fail(function () {
          return params.error.call(self);
        });

        return this;
      },

      /* eslint-enable consistent-return */
      save: function (settings, keywordList, section, alertEnabled, emailList, fullTextAlert) {
        if ($('#save-alerts-button-container .btn').hasClass('ui-state-disabled')) {
          return;
        }

        $('#save-alerts-button-container .btn').addClass('ui-state-disabled');

        var data = JSON.stringify({
          hotel_list: settings,
          alert_enabled: alertEnabled,
          keyword_list: keywordList,
          alert_section: section,
          email_list: emailList
        });

        $.ajax({
          type: 'POST',
          url: config.urls.alerts + 'settings.json?userid=' + session.user.id,
          data: data
        }).done(function () {
          return $('#save-alerts-button-container .btn').removeClass('ui-state-disabled');
        });
      }
    };

    return $.fn.SettingsAlerts;
  });
})();
define('commons/public/jadec/tyra-5/views/settings/response_templates_section',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right\"><div class=\"card-header\">");
if ( canEditResponseTemplates)
{
buf.push("<ul class=\"actions\"><li class=\"action-create-response-template\"><a class=\"toggle-side-panel\"><span>" + (jade.escape((jade.interp = create_new_template) == null ? '' : jade.interp)) + "</span><i class=\"ty-icon ty-icon-plus\"></i></a></li></ul>");
}
buf.push("<a class=\"icon-box is-disabled\"><i class=\"ty-icon ty-icon-reply-plus\"></i><i class=\"ty-icon ty-icon-help-o\"></i></a><h2>" + (jade.escape((jade.interp = settings_response_templates) == null ? '' : jade.interp)) + "</h2></div><div class=\"card-body settings-management-response-templates-container\"><div class=\"row\"><div class=\"col-12\"><div class=\"management-response-templates\"></div></div></div><div class=\"row\"><div class=\"col-12\"><div class=\"signature-editor-container\"><h3>" + (jade.escape((jade.interp = configure_email_signature) == null ? '' : jade.interp)) + "</h3><textarea id=\"user-signature\" rows=\"3\" cols=\"50\"></textarea></div></div></div></div><div class=\"card-footer\"><div id=\"save-user-signature-button-container\" class=\"l-right\"></div></div></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/settings/response_templates',['jquery', 'session', './../../config', './../../utils', 'settings-permissions', './../../../../jadec/tyra-5/views/settings/response_templates_section', './../../../../jadec/tyra-5/views/settings/stump_section', 'ty-i18n!tyra-5', 'ty-i18n!analytics_js_4x'], function ($, session, config, utils, SettingsPermissions, sectionTmpl, stumpTmpl, i18n, i18nAnalyticsJs4x) {
    if ($.fn.SettingsResponseTemplates) {
      throw new Error('SettingsResponseTemplates plugin is already defined');
    }

    $.fn.SettingsResponseTemplates = function (params) {
      // Attach the API
      $.extend(this, $.fn.SettingsResponseTemplates.API);
      return this.init(params);
    };

    var permissions = new SettingsPermissions(session);
    var isMetareviewOnlyUser = session.has('metareview') && !session.has('stars');
    var permitted = permissions.canViewResponseTemplates() && !isMetareviewOnlyUser;

    var defaults = {
      labels: {
        error_getting_data: i18nAnalyticsJs4x.error_getting_data,
        save: i18n.save_changes,
        create_new_template: i18n.create_new_template,
        settings_response_templates: i18n.settings_response_templates,
        configure_email_signature: i18n.configure_email_signature
      },

      dataprovider: function () {
        return utils.doAjax({
          url: config.urls.reviews + 'response_templates/signature',
          cache: false,
          type: 'get'
        }).pipe(function (signatureResponse) {
          return signatureResponse.response.signature;
        });
      },

      renderer: function (signature) {
        var self = this;
        var params = self._data().params;
        self.html(sectionTmpl($.extend(true, {}, params.labels, {
          canEditResponseTemplates: permissions.canEditResponseTemplates()
        })));

        self.find('.management-response-templates').ResponseTemplateList().init();

        self.find('.action-create-response-template .toggle-side-panel').click(function () {
          $('<div></div>').ResponseTemplateEditor().init({
            templateSaved: function () {
              self.find('.management-response-templates').ResponseTemplateList().refresh();
            }
          });
        });

        if (signature) {
          self.find('#user-signature').val(signature);
        }

        self.find('#save-user-signature-button-container').append($('<a class="trustyou-ui btn btn-primary waves-effect"></a>').text(params.labels.save).click(function () {
          var newSignature = self.find('#user-signature').val();

          if ($('#save-user-signature-button-container .btn').hasClass('ui-state-disabled')) {
            return;
          }

          $('#save-user-signature-button-container .btn').addClass('ui-state-disabled');

          // insert/update signature
          utils.doAjax({
            url: config.urls.reviews + 'response_templates/signature',
            type: signature === null ? 'post' : 'put',
            cache: false,
            data: {
              signature: newSignature
            }
          }).done(function () {
            $('#save-user-signature-button-container .btn').delay(1000).queue(function (next) {
              $(this).removeClass('ui-state-disabled');

              next();
            });
          });
        }));

        return $.Deferred().resolve();
      },
      loading: function () {
        var self = this,
            params = self._data().params;

        this.html(stumpTmpl({
          header: params.labels.settings_response_templates,
          loading: true
        }));
      },
      error: function () {
        var self = this,
            params = self._data().params;

        this.html(stumpTmpl({
          header: params.labels.settings_response_templates,
          error: params.labels.error_getting_data
        }));
      },
      rendered: $.noop
    };

    $.fn.SettingsResponseTemplates.API = {
      permitted: permitted,
      init: function (params) {
        if (!this.permitted) {
          return this;
        }

        params = $.extend(true, {}, defaults, params);
        this._data({ params: params }).refresh();
        return this;
      },
      _data: function (data) {
        var dataAttr = 'responseTemplatesData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        params.loading.call(self);
        params.dataprovider.call(self).done(function (signature) {
          params.renderer.call(self, signature).done(function () {
            params.rendered.call(self);
          });
        }).fail(function () {
          return params.error.call(self);
        });

        return this;
      }
    };

    return $.fn.SettingsResponseTemplates;
  });
})();
define('commons/public/jadec/tyra-5/views/settings/pms_integrations_section',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right\"></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/settings/pms_integrations',['jquery', 'session', './../../config', 'settings-permissions', './../../../../jadec/tyra-5/views/settings/pms_integrations_section', './../../../../jadec/tyra-5/views/settings/stump_section'], function ($, session, config, SettingsPermissions, sectionTmpl, stumpTmpl) {
    if ($.fn.SettingsPMSIntegrations) {
      throw new Error('SettingsPMSIntegrations plugin is already defined');
    }

    $.fn.SettingsPMSIntegrations = function (params) {
      // Attach the API
      $.extend(this, $.fn.SettingsPMSIntegrations.API);
      return this.init(params);
    };

    var permissions = new SettingsPermissions(session);
    var permitted = permissions.canManageIntegrations() && config.feature_flags.settings_integrations === 'true';

    var defaults = {
      labels: {},

      dataprovider: function () {
        return $.Deferred().resolve();
      },

      renderer: function (signature) {
        var self = this;
        var params = self._data().params;
        self.html(sectionTmpl($.extend(true, {}, params.labels, {})));

        return $.Deferred().resolve();
      },
      loading: function () {
        this.html(stumpTmpl({
          header: '@PMS Integrations',
          loading: true
        }));
      },
      error: function () {
        this.html(stumpTmpl({
          header: '@PMS Integrations',
          error: '@PMS Integrations error'
        }));
      },
      rendered: $.noop
    };

    $.fn.SettingsPMSIntegrations.API = {
      permitted: permitted,
      init: function (params) {
        if (!this.permitted) {
          return this;
        }

        params = $.extend(true, {}, defaults, params);
        this._data({ params: params }).refresh();
        return this;
      },
      _data: function (data) {
        var dataAttr = 'pmsIntegrationsData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        params.loading.call(self);
        params.dataprovider.call(self).done(function (signature) {
          params.renderer.call(self, signature).done(function () {
            params.rendered.call(self);
          });
        }).fail(function () {
          return params.error.call(self);
        });

        return this;
      }
    };

    return $.fn.SettingsPMSIntegrations;
  });
})();
define('commons/public/jadec/tyra-5/views/settings/direct_responses',["jadeRuntime"],function(jade){

return function anonymous(locals
/*``*/) {
var buf = [];
with (locals || {}) {
buf.push("<div class=\"trustyou-ui card FULL_PAGE_WIDTH view-right\"></div>");
}
return buf.join("");
};

});

(function () {
  'use strict';

  define('commons/public/js/tyra-5/views/settings/direct_responses',['jquery', 'session', './../../config', 'settings-permissions', './../../../../jadec/tyra-5/views/settings/direct_responses', './../../../../jadec/tyra-5/views/settings/stump_section'], function ($, session, config, SettingsPermissions, sectionTmpl, stumpTmpl) {
    if ($.fn.SettingsDirectResponses) {
      throw new Error('SettingsDirectResponses plugin is already defined');
    }

    $.fn.SettingsDirectResponses = function (params) {
      // Attach the API
      $.extend(this, $.fn.SettingsDirectResponses.API);
      return this.init(params);
    };

    var permissions = new SettingsPermissions(session);
    var drFlagConfigEnabled = config.feature_flags.settings_direct_responses === 'true';
    var drEnabledByEnterprise = drFlagConfigEnabled && session.roles.indexOf('enterprise') !== -1;
    var drEnabledBySingleProperty = drFlagConfigEnabled && permissions.canManageDirectResponses();
    var permitted = (drEnabledBySingleProperty || drEnabledByEnterprise) && session.has('analytics');

    var defaults = {
      labels: {},

      dataprovider: function () {
        return $.Deferred().resolve();
      },

      renderer: function (signature) {
        var self = this;
        var params = self._data().params;
        self.html(sectionTmpl($.extend(true, {}, params.labels, {})));

        return $.Deferred().resolve();
      },
      loading: function () {
        this.html(stumpTmpl({
          header: '@Direct Responses',
          loading: true
        }));
      },
      error: function () {
        this.html(stumpTmpl({
          header: '@Direct Responses',
          error: '@Direct Responses error'
        }));
      },
      rendered: $.noop
    };

    $.fn.SettingsDirectResponses.API = {
      permitted: permitted,
      init: function (params) {
        if (!this.permitted) {
          return this;
        }

        params = $.extend(true, {}, defaults, params);
        this._data({ params: params }).refresh();
        return this;
      },
      _data: function (data) {
        var dataAttr = 'directResponsesData';

        if (data) {
          return this.data(dataAttr, data);
        } else {
          return this.data(dataAttr);
        }
      },
      refresh: function () {
        var self = this,
            params = self._data().params;

        params.loading.call(self);
        params.dataprovider.call(self).done(function (signature) {
          params.renderer.call(self, signature).done(function () {
            params.rendered.call(self);
          });
        }).fail(function () {
          return params.error.call(self);
        });

        return this;
      }
    };

    return $.fn.SettingsDirectResponses;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/common/rss-reader',['jquery', 'session'], function ($) {
    $.fn.readRSS = function (options) {
      // Cleanup: used in metaresponse-app!!!
      /*
      *  function to retrieve rss feed and convert it to list of js object conatining properties of the feed
      * @url - url to rss feed;
      * @onComplete - on complete callback that recieves feed array as parameter
      * Example:
      * $(div_element).readRSS({
      *  url: 'http://www.trustyou.com/feed/?post_type=marketing',
      *  onComplete: function(items){
      *    $.each(item, function(index, value) {
      *      console.log(vlaue);
      *    })
      *  }
      * });
      */
      var engine = {
        settings: {
          url: '',
          onComplete: function (items) {}
        },
        items: [],

        init: function (element, opts) {
          this.settings = $.extend(this.settings, opts);
          this.$element = $(this.element);
          this.fetchXml();
        },

        fetchXml: function () {
          var self = this;
          if (this.settings.url === '') {
            console.error('"url" parameter is required'); // eslint-disable-line no-console
          } else {
            /* eslint-disable no-unused-vars */
            var feed = $.ajax({
              url: '/tyra-5/proxy?url=' + encodeURIComponent(this.settings.url),
              type: 'GET',
              dataType: 'json',
              success: function (data) {
                if (data.meta.code !== 200) {
                  console.error('Can not fetch RSS feed.'); // eslint-disable-line no-console
                  return;
                }
                var xml = data.response.content;
                self.parseFeed(xml);
              }
            });
            /* eslint-enable no-unused-vars */
          }
        },
        findNS: function (o, nodeName) {
          return o.children().filter(function () {
            if (this.nodeName) {
              return this.nodeName.toUpperCase() === nodeName.toUpperCase();
            } else {
              return false;
            }
          });
        },

        parseFeed: function (text) {
          var self = this;
          text = typeof text === 'string' ? text.trim() : text;
          var feed = $.parseXML(text);
          $(feed).find('item').each(function (index, el) {
            var item = {};
            item.title = $(el).find('title').text();
            item.creator = $(el).find('creator').text();
            item.link = $(el).find('link').text();
            item.description = $(el).find('description').text();
            item.comments = $(el).find('comments').text();
            item.pubDate = $(el).find('pubDate').text();
            item.image = $(el).find('image').text();
            item.content = $('<div></div>').html($(self.findNS($(el), 'content:encoded')).text()).html();
            item.subtitle = $(el).find('subtitle').text();
            item.guid = $(el).find('guid').text();
            self.items.push(item);
          });
          this.settings.onComplete(this.items);
        }
      };
      return $(this).each(function () {
        engine.init(this, options);
      });
    };

    $.extend($.fn.readRSS, {
      staticFetchXml: function (url, onComplete) {
        var self = this;
        if (url === '') {
          console.error('"url" parameter is required'); // eslint-disable-line no-console
        } else {
          /* eslint-disable no-unused-vars */
          var feed = $.ajax({
            url: '/tyra-5/proxy?url=' + encodeURIComponent(url),
            type: 'GET',
            dataType: 'json',
            success: function (data) {
              if (data.meta.code !== 200) {
                console.error('Can not fetch RSS feed.'); // eslint-disable-line no-console
                return;
              }
              var xml = data.response.content;
              if ($(xml).find('item').length === 0 && url.split('&lang=').length !== 1) {
                url = url.split('&lang=')[0];
                self.staticFetchXml(url, onComplete);
              } else {
                self.staticParseFeed(xml, onComplete);
              }
            }
          });
          /* eslint-enable no-unused-vars */
        }
      },
      staticfindNS: function (o, nodeName) {
        return o.children().filter(function () {
          if (this.nodeName) {
            return this.nodeName.toUpperCase() === nodeName.toUpperCase();
          } else {
            return false;
          }
        });
      },
      staticParseFeed: function (text, onComplete) {
        text = typeof text === 'string' ? text.trim() : text;
        var self = this,
            feed = $.parseXML(text),
            items = [];
        $(feed).find('item').each(function (index, el) {
          var item = {};
          item.title = $(el).find('title').text();
          item.creator = $(el).find('creator').text();
          item.link = $(el).find('link').text();
          item.description = $(el).find('description').text();
          item.comments = $(el).find('comments').text();
          item.pubDate = $(el).find('pubDate').text();
          item.image = $(el).find('image').text();
          item.content = $('<div></div>').html($(self.staticfindNS($(el), 'content:encoded')).text()).html();
          item.subtitle = $(el).find('subtitle').text();
          items.push(item);
        });
        onComplete.call(self, items);
      }
    });
  });
})();
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @namespace portfolio
 */

/**
 * @namespace tiles
 * @memberOf portfolio
 */

/**
 * @namespace goals
 * @memberOf portfolio.tiles
 */

/**
 * This tile depends on Messaging API.
 */
(function () {
  'use strict';

  define('commons/public/js/tyra-5/tiles/messageDirection/tile',['jquery', 'TileSpec', 'TileRenderable', 'Cyclops', 'session', 'moment', 'ty-i18n!tyra-5'], function ($, TileSpec, TileRenderable, Cyclops, session, moment, labels) {
    /**
     * The Message Direction Tile's Icon TileRenderable, extends
     * {@link https://stash.trustyou.com/projects/TM/repos/commons/browse/public/js/ui_components/tilespec/tileRenderable.js?at=refs/heads/feature-TM-7869|TileRenderable}
     * @augments TileRenderable
     * @class
     * @memberOf portfolio.tiles.messageDirection
     */
    var MessageDirectionIcon = function (_TileRenderable) {
      _inherits(MessageDirectionIcon, _TileRenderable);

      function MessageDirectionIcon(context, tyra, tileParams, params) {
        _classCallCheck(this, MessageDirectionIcon);

        var _this = _possibleConstructorReturn(this, (MessageDirectionIcon.__proto__ || Object.getPrototypeOf(MessageDirectionIcon)).call(this, context, tyra, tileParams, params));

        _this.classes = 'messageDirection-icon ty-tile with-analytics ' + (params.classes || '');
        return _this;
      }

      _createClass(MessageDirectionIcon, [{
        key: 'dataprovider',
        value: function dataprovider() {
          var environments = ['integration', 'staging'];
          var environment = environments.find(function (env) {
            return location.host.includes(env);
          }) || 'production';
          var deferred = $.Deferred();
          Cyclops.init(session.properties.locale, session.ssoToken, environment).then(deferred.resolve).catch(deferred.reject);
          return deferred;
        }
      }, {
        key: 'renderer',
        value: function renderer(data, header, content, footer) {
          var gParams = this.tileParams;
          var contentElement = this.context.find('.messageDirection-details .module-details-content')[0];

          // Those props could be considered immutable during tile lifespan
          this.externalProps = {
            groupId: gParams.groupId,
            clusterId: gParams.clusterId,
            timeFrame: { from: gParams.from || moment().subtract('days', 7).format('YYYY-MM-DD'), to: gParams.to || moment().format('YYYY-MM-DD') },
            previewElement: content,
            contentElement: contentElement
          };
          this.hostElement = footer;

          var deferred = $.Deferred();
          this.renderReactComponent().then(function () {
            return deferred.resolve();
          });
          return deferred;
        }
      }, {
        key: 'renderReactComponent',
        value: function renderReactComponent() {
          var _this2 = this;

          // It renders the component only the first time
          // After that is just updates it to reflect the provided state
          return new Promise(function (resolve) {
            return Cyclops.renderComponent(Cyclops.components.tiles.MessageDirection, _this2.hostElement, _extends({}, _this2.externalProps, {
              toggled: _this2.expanded
            }), resolve);
          });
        }
      }, {
        key: 'beforeExpandedToggle',
        value: function beforeExpandedToggle(event, expanded) {
          var _this3 = this;

          this.expanded = expanded;
          // Content element can get overwritten by jquery code
          // Wait to ensure React component is rendered afterwards
          setTimeout(function () {
            return _this3.renderReactComponent();
          }, 100);
        }
      }]);

      return MessageDirectionIcon;
    }(TileRenderable);

    /**
     * The Message Direction Tile's Details TileRenderable, extends
     * {@link https://stash.trustyou.com/projects/TM/repos/commons/browse/public/js/ui_components/tilespec/tileRenderable.js?at=refs/heads/feature-TM-7869|TileRenderable}
     * @augments TileRenderable
     * @class
     * @memberOf portfolio.tiles.messageDirection
     */


    var MessageDirectionDetails = function (_TileRenderable2) {
      _inherits(MessageDirectionDetails, _TileRenderable2);

      function MessageDirectionDetails(context, tyra, tileParams, params) {
        _classCallCheck(this, MessageDirectionDetails);

        var _this4 = _possibleConstructorReturn(this, (MessageDirectionDetails.__proto__ || Object.getPrototypeOf(MessageDirectionDetails)).call(this, context, tyra, tileParams, params));

        _this4.classes = 'messageDirection-details ty-tile with-analytics ' + (params.classes || '');
        return _this4;
      }

      _createClass(MessageDirectionDetails, [{
        key: 'renderer',
        value: function renderer(data, header, content, footer) {
          $(header).html(labels.messageDirectionTileTitle);
          return $.Deferred().resolve();
        }
      }]);

      return MessageDirectionDetails;
    }(TileRenderable);

    /**
     * The Message Direction Tile's Tile Specification, extends
     * {@link https://stash.trustyou.com/projects/TM/repos/commons/browse/public/js/ui_components/tilespec/tileSpec.js?at=refs/heads/feature-TM-7869|TileSpec}
     * @class
     * @memberOf portfolio.tiles.messageDirection
     */


    var MessageDirectionTileSpec = function (_TileSpec) {
      _inherits(MessageDirectionTileSpec, _TileSpec);

      function MessageDirectionTileSpec() {
        var _ref;

        _classCallCheck(this, MessageDirectionTileSpec);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this5 = _possibleConstructorReturn(this, (_ref = MessageDirectionTileSpec.__proto__ || Object.getPrototypeOf(MessageDirectionTileSpec)).call.apply(_ref, [this].concat(args)));

        _this5.iconParams = new (Function.prototype.bind.apply(MessageDirectionIcon, [null].concat(args)))();
        _this5.detailsParams = new (Function.prototype.bind.apply(MessageDirectionDetails, [null].concat(args)))();
        return _this5;
      }

      _createClass(MessageDirectionTileSpec, null, [{
        key: 'getName',
        value: function getName() {
          return 'MessageDirection';
        }
      }]);

      return MessageDirectionTileSpec;
    }(TileSpec);

    return MessageDirectionTileSpec;
  });
})();
(function () {
  'use strict';

  define('commons/public/js/tyra-5/user-events-manager',['jquery', './config'], function ($, config) {
    return {
      registerUserEvent: function (event, description) {
        var url = '' + config.urls.tyra;
        var params = {
          url: url + '/user_event/',
          type: 'post',
          data: {
            user_event: JSON.stringify({
              event: event,
              description: description
            })
          }
        };
        var defaults = {
          dataType: 'json',
          cache: false
        };
        return $.ajax($.extend({}, defaults, params));
      }
    };
  });
})();

requirejs.s.contexts._.nextTick = function(f){f()}; require(['css'], function(css) { css.setBuffer('/*!\n * jQuery UI CSS Framework 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Theming/API\n */\n\n/* Layout helpers\n----------------------------------*/\n.ui-helper-hidden { display: none; }\n.ui-helper-hidden-accessible { position: absolute !important; clip: rect(1px 1px 1px 1px); clip: rect(1px,1px,1px,1px); }\n.ui-helper-reset { margin: 0; padding: 0; border: 0; outline: 0; line-height: 1.3; text-decoration: none; font-size: 100%; list-style: none; }\n.ui-helper-clearfix:before, .ui-helper-clearfix:after { content: \"\"; display: table; }\n.ui-helper-clearfix:after { clear: both; }\n.ui-helper-clearfix { zoom: 1; }\n.ui-helper-zfix { width: 100%; height: 100%; top: 0; left: 0; position: absolute; opacity: 0; filter:Alpha(Opacity=0); }\n\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-disabled { cursor: default !important; }\n\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon { display: block; text-indent: -99999px; overflow: hidden; background-repeat: no-repeat; }\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Overlays */\n.ui-widget-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }\n\n\n/*!\n * jQuery UI CSS Framework 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Theming/API\n *\n * To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Lucida%20Grande,%20Lucida%20Sans,%20Arial,%20sans-serif&fwDefault=bold&fsDefault=12px&cornerRadius=5px&bgColorHeader=5c9ccc&bgTextureHeader=12_gloss_wave.png&bgImgOpacityHeader=55&borderColorHeader=4297d7&fcHeader=ffffff&iconColorHeader=d8e7f3&bgColorContent=fcfdfd&bgTextureContent=06_inset_hard.png&bgImgOpacityContent=100&borderColorContent=a6c9e2&fcContent=222222&iconColorContent=469bdd&bgColorDefault=dfeffc&bgTextureDefault=02_glass.png&bgImgOpacityDefault=60&borderColorDefault=c5dbec&fcDefault=0b60ab&iconColorDefault=0b60ab&bgColorHover=d0e5f5&bgTextureHover=02_glass.png&bgImgOpacityHover=60&borderColorHover=79b7e7&fcHover=074073&iconColorHover=074073&bgColorActive=f5f8f9&bgTextureActive=06_inset_hard.png&bgImgOpacityActive=100&borderColorActive=79b7e7&fcActive=e17009&iconColorActive=f9bd01&bgColorHighlight=fbec88&bgTextureHighlight=01_flat.png&bgImgOpacityHighlight=55&borderColorHighlight=fad42e&fcHighlight=363636&iconColorHighlight=2e83ff&bgColorError=fef1ec&bgTextureError=02_glass.png&bgImgOpacityError=95&borderColorError=cd0a0a&fcError=cd0a0a&iconColorError=cd0a0a&bgColorOverlay=000000&bgTextureOverlay=01_flat.png&bgImgOpacityOverlay=0&opacityOverlay=40&bgColorShadow=000000&bgTextureShadow=01_flat.png&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=8px&offsetTopShadow=-8px&offsetLeftShadow=-8px&cornerRadiusShadow=8px\n */\n\n\n/* Component containers\n----------------------------------*/\n.ui-widget { font-family: Roboto, Arial, sans-serif; font-size: 12px; }\n.ui-widget .ui-widget { font-size: 1em; }\n.ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button { font-family: Lucida Grande, Lucida Sans, Arial, sans-serif; font-size: 1em; }\n.ui-widget-content { border: 1px solid #a6c9e2; background: #fcfdfd url(commons/public/3rd-party/jqueryui/images/ui-bg_inset-hard_100_fcfdfd_1x100.png) 50% bottom repeat-x; color: #222222; }\n.ui-widget-content a { color: #222222; }\n.ui-widget-header { border: 1px solid #4297d7; background: #5c9ccc url(commons/public/3rd-party/jqueryui/images/ui-bg_gloss-wave_55_5c9ccc_500x100.png) 50% 50% repeat-x; color: #ffffff; font-weight: bold; }\n.ui-widget-header a { color: #ffffff; }\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default, .ui-widget-content .ui-state-default, .ui-widget-header .ui-state-default { border: 1px solid #c5dbec; background: #dfeffc url(commons/public/3rd-party/jqueryui/images/ui-bg_glass_60_dfeffc_1x400.png) 50% 50% repeat-x; font-weight: bold; color: #0b60ab; }\n.ui-state-default a, .ui-state-default a:link, .ui-state-default a:visited { color: #0b60ab; text-decoration: none; }\n.ui-state-hover, .ui-widget-content .ui-state-hover, .ui-widget-header .ui-state-hover, .ui-state-focus, .ui-widget-content .ui-state-focus, .ui-widget-header .ui-state-focus { border: 1px solid #79b7e7; background: #d0e5f5 url(commons/public/3rd-party/jqueryui/images/ui-bg_glass_60_d0e5f5_1x400.png) 50% 50% repeat-x; font-weight: bold; color: #074073; }\n.ui-state-hover a, .ui-state-hover a:hover { color: #074073; text-decoration: none; }\n.ui-state-active, .ui-widget-content .ui-state-active, .ui-widget-header .ui-state-active { border: 1px solid #79b7e7; background: #f5f8f9 url(commons/public/3rd-party/jqueryui/images/ui-bg_inset-hard_100_f5f8f9_1x100.png) 50% 50% repeat-x; font-weight: bold; color: #e17009; }\n.ui-state-active a, .ui-state-active a:link, .ui-state-active a:visited { color: #e17009; text-decoration: none; }\n.ui-widget :active { outline: none; }\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight, .ui-widget-content .ui-state-highlight, .ui-widget-header .ui-state-highlight  {border: 1px solid #fad42e; background: #fbec88 url(commons/public/3rd-party/jqueryui/images/ui-bg_flat_55_fbec88_40x100.png) 50% 50% repeat-x; color: #363636; }\n.ui-state-highlight a, .ui-widget-content .ui-state-highlight a,.ui-widget-header .ui-state-highlight a { color: #363636; }\n.ui-state-error, .ui-widget-content .ui-state-error, .ui-widget-header .ui-state-error {border: 1px solid #cd0a0a; background: #fef1ec url(commons/public/3rd-party/jqueryui/images/ui-bg_glass_95_fef1ec_1x400.png) 50% 50% repeat-x; color: #cd0a0a; }\n.ui-state-error a, .ui-widget-content .ui-state-error a, .ui-widget-header .ui-state-error a { color: #cd0a0a; }\n.ui-state-error-text, .ui-widget-content .ui-state-error-text, .ui-widget-header .ui-state-error-text { color: #cd0a0a; }\n.ui-priority-primary, .ui-widget-content .ui-priority-primary, .ui-widget-header .ui-priority-primary { font-weight: bold; }\n.ui-priority-secondary, .ui-widget-content .ui-priority-secondary,  .ui-widget-header .ui-priority-secondary { opacity: .7; filter:Alpha(Opacity=70); font-weight: normal; }\n.ui-state-disabled, .ui-widget-content .ui-state-disabled, .ui-widget-header .ui-state-disabled { opacity: .35; filter:Alpha(Opacity=35); background-image: none; }\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon { width: 16px; height: 16px; background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_469bdd_256x240.png); }\n.ui-widget-content .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_469bdd_256x240.png); }\n.ui-widget-header .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_d8e7f3_256x240.png); }\n.ui-state-default .ui-icon { background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_0b60ab_256x240.png); }\n.ui-state-hover .ui-icon, .ui-state-focus .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_074073_256x240.png); }\n.ui-state-active .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_f9bd01_256x240.png); }\n.ui-state-highlight .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_2e83ff_256x240.png); }\n.ui-state-error .ui-icon, .ui-state-error-text .ui-icon {background-image: url(commons/public/3rd-party/jqueryui/images/ui-icons_cd0a0a_256x240.png); }\n\n/* positioning */\n.ui-icon-carat-1-n { background-position: 0 0; }\n.ui-icon-carat-1-ne { background-position: -16px 0; }\n.ui-icon-carat-1-e { background-position: -32px 0; }\n.ui-icon-carat-1-se { background-position: -48px 0; }\n.ui-icon-carat-1-s { background-position: -64px 0; }\n.ui-icon-carat-1-sw { background-position: -80px 0; }\n.ui-icon-carat-1-w { background-position: -96px 0; }\n.ui-icon-carat-1-nw { background-position: -112px 0; }\n.ui-icon-carat-2-n-s { background-position: -128px 0; }\n.ui-icon-carat-2-e-w { background-position: -144px 0; }\n.ui-icon-triangle-1-n { background-position: 0 -16px; }\n.ui-icon-triangle-1-ne { background-position: -16px -16px; }\n.ui-icon-triangle-1-e { background-position: -32px -16px; }\n.ui-icon-triangle-1-se { background-position: -48px -16px; }\n.ui-icon-triangle-1-s { background-position: -64px -16px; }\n.ui-icon-triangle-1-sw { background-position: -80px -16px; }\n.ui-icon-triangle-1-w { background-position: -96px -16px; }\n.ui-icon-triangle-1-nw { background-position: -112px -16px; }\n.ui-icon-triangle-2-n-s { background-position: -128px -16px; }\n.ui-icon-triangle-2-e-w { background-position: -144px -16px; }\n.ui-icon-arrow-1-n { background-position: 0 -32px; }\n.ui-icon-arrow-1-ne { background-position: -16px -32px; }\n.ui-icon-arrow-1-e { background-position: -32px -32px; }\n.ui-icon-arrow-1-se { background-position: -48px -32px; }\n.ui-icon-arrow-1-s { background-position: -64px -32px; }\n.ui-icon-arrow-1-sw { background-position: -80px -32px; }\n.ui-icon-arrow-1-w { background-position: -96px -32px; }\n.ui-icon-arrow-1-nw { background-position: -112px -32px; }\n.ui-icon-arrow-2-n-s { background-position: -128px -32px; }\n.ui-icon-arrow-2-ne-sw { background-position: -144px -32px; }\n.ui-icon-arrow-2-e-w { background-position: -160px -32px; }\n.ui-icon-arrow-2-se-nw { background-position: -176px -32px; }\n.ui-icon-arrowstop-1-n { background-position: -192px -32px; }\n.ui-icon-arrowstop-1-e { background-position: -208px -32px; }\n.ui-icon-arrowstop-1-s { background-position: -224px -32px; }\n.ui-icon-arrowstop-1-w { background-position: -240px -32px; }\n.ui-icon-arrowthick-1-n { background-position: 0 -48px; }\n.ui-icon-arrowthick-1-ne { background-position: -16px -48px; }\n.ui-icon-arrowthick-1-e { background-position: -32px -48px; }\n.ui-icon-arrowthick-1-se { background-position: -48px -48px; }\n.ui-icon-arrowthick-1-s { background-position: -64px -48px; }\n.ui-icon-arrowthick-1-sw { background-position: -80px -48px; }\n.ui-icon-arrowthick-1-w { background-position: -96px -48px; }\n.ui-icon-arrowthick-1-nw { background-position: -112px -48px; }\n.ui-icon-arrowthick-2-n-s { background-position: -128px -48px; }\n.ui-icon-arrowthick-2-ne-sw { background-position: -144px -48px; }\n.ui-icon-arrowthick-2-e-w { background-position: -160px -48px; }\n.ui-icon-arrowthick-2-se-nw { background-position: -176px -48px; }\n.ui-icon-arrowthickstop-1-n { background-position: -192px -48px; }\n.ui-icon-arrowthickstop-1-e { background-position: -208px -48px; }\n.ui-icon-arrowthickstop-1-s { background-position: -224px -48px; }\n.ui-icon-arrowthickstop-1-w { background-position: -240px -48px; }\n.ui-icon-arrowreturnthick-1-w { background-position: 0 -64px; }\n.ui-icon-arrowreturnthick-1-n { background-position: -16px -64px; }\n.ui-icon-arrowreturnthick-1-e { background-position: -32px -64px; }\n.ui-icon-arrowreturnthick-1-s { background-position: -48px -64px; }\n.ui-icon-arrowreturn-1-w { background-position: -64px -64px; }\n.ui-icon-arrowreturn-1-n { background-position: -80px -64px; }\n.ui-icon-arrowreturn-1-e { background-position: -96px -64px; }\n.ui-icon-arrowreturn-1-s { background-position: -112px -64px; }\n.ui-icon-arrowrefresh-1-w { background-position: -128px -64px; }\n.ui-icon-arrowrefresh-1-n { background-position: -144px -64px; }\n.ui-icon-arrowrefresh-1-e { background-position: -160px -64px; }\n.ui-icon-arrowrefresh-1-s { background-position: -176px -64px; }\n.ui-icon-arrow-4 { background-position: 0 -80px; }\n.ui-icon-arrow-4-diag { background-position: -16px -80px; }\n.ui-icon-extlink { background-position: -32px -80px; }\n.ui-icon-newwin { background-position: -48px -80px; }\n.ui-icon-refresh { background-position: -64px -80px; }\n.ui-icon-shuffle { background-position: -80px -80px; }\n.ui-icon-transfer-e-w { background-position: -96px -80px; }\n.ui-icon-transferthick-e-w { background-position: -112px -80px; }\n.ui-icon-folder-collapsed { background-position: 0 -96px; }\n.ui-icon-folder-open { background-position: -16px -96px; }\n.ui-icon-document { background-position: -32px -96px; }\n.ui-icon-document-b { background-position: -48px -96px; }\n.ui-icon-note { background-position: -64px -96px; }\n.ui-icon-mail-closed { background-position: -80px -96px; }\n.ui-icon-mail-open { background-position: -96px -96px; }\n.ui-icon-suitcase { background-position: -112px -96px; }\n.ui-icon-comment { background-position: -128px -96px; }\n.ui-icon-person { background-position: -144px -96px; }\n.ui-icon-print { background-position: -160px -96px; }\n.ui-icon-trash { background-position: -176px -96px; }\n.ui-icon-locked { background-position: -192px -96px; }\n.ui-icon-unlocked { background-position: -208px -96px; }\n.ui-icon-bookmark { background-position: -224px -96px; }\n.ui-icon-tag { background-position: -240px -96px; }\n.ui-icon-home { background-position: 0 -112px; }\n.ui-icon-flag { background-position: -16px -112px; }\n.ui-icon-calendar { background-position: -32px -112px; }\n.ui-icon-cart { background-position: -48px -112px; }\n.ui-icon-pencil { background-position: -64px -112px; }\n.ui-icon-clock { background-position: -80px -112px; }\n.ui-icon-disk { background-position: -96px -112px; }\n.ui-icon-calculator { background-position: -112px -112px; }\n.ui-icon-zoomin { background-position: -128px -112px; }\n.ui-icon-zoomout { background-position: -144px -112px; }\n.ui-icon-search { background-position: -160px -112px; }\n.ui-icon-wrench { background-position: -176px -112px; }\n.ui-icon-gear { background-position: -192px -112px; }\n.ui-icon-heart { background-position: -208px -112px; }\n.ui-icon-star { background-position: -224px -112px; }\n.ui-icon-link { background-position: -240px -112px; }\n.ui-icon-cancel { background-position: 0 -128px; }\n.ui-icon-plus { background-position: -16px -128px; }\n.ui-icon-plusthick { background-position: -32px -128px; }\n.ui-icon-minus { background-position: -48px -128px; }\n.ui-icon-minusthick { background-position: -64px -128px; }\n.ui-icon-close { background-position: -80px -128px; }\n.ui-icon-closethick { background-position: -96px -128px; }\n.ui-icon-key { background-position: -112px -128px; }\n.ui-icon-lightbulb { background-position: -128px -128px; }\n.ui-icon-scissors { background-position: -144px -128px; }\n.ui-icon-clipboard { background-position: -160px -128px; }\n.ui-icon-copy { background-position: -176px -128px; }\n.ui-icon-contact { background-position: -192px -128px; }\n.ui-icon-image { background-position: -208px -128px; }\n.ui-icon-video { background-position: -224px -128px; }\n.ui-icon-script { background-position: -240px -128px; }\n.ui-icon-alert { background-position: 0 -144px; }\n.ui-icon-info { background-position: -16px -144px; }\n.ui-icon-notice { background-position: -32px -144px; }\n.ui-icon-help { background-position: -48px -144px; }\n.ui-icon-check { background-position: -64px -144px; }\n.ui-icon-bullet { background-position: -80px -144px; }\n.ui-icon-radio-off { background-position: -96px -144px; }\n.ui-icon-radio-on { background-position: -112px -144px; }\n.ui-icon-pin-w { background-position: -128px -144px; }\n.ui-icon-pin-s { background-position: -144px -144px; }\n.ui-icon-play { background-position: 0 -160px; }\n.ui-icon-pause { background-position: -16px -160px; }\n.ui-icon-seek-next { background-position: -32px -160px; }\n.ui-icon-seek-prev { background-position: -48px -160px; }\n.ui-icon-seek-end { background-position: -64px -160px; }\n.ui-icon-seek-start { background-position: -80px -160px; }\n/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */\n.ui-icon-seek-first { background-position: -80px -160px; }\n.ui-icon-stop { background-position: -96px -160px; }\n.ui-icon-eject { background-position: -112px -160px; }\n.ui-icon-volume-off { background-position: -128px -160px; }\n.ui-icon-volume-on { background-position: -144px -160px; }\n.ui-icon-power { background-position: 0 -176px; }\n.ui-icon-signal-diag { background-position: -16px -176px; }\n.ui-icon-signal { background-position: -32px -176px; }\n.ui-icon-battery-0 { background-position: -48px -176px; }\n.ui-icon-battery-1 { background-position: -64px -176px; }\n.ui-icon-battery-2 { background-position: -80px -176px; }\n.ui-icon-battery-3 { background-position: -96px -176px; }\n.ui-icon-circle-plus { background-position: 0 -192px; }\n.ui-icon-circle-minus { background-position: -16px -192px; }\n.ui-icon-circle-close { background-position: -32px -192px; }\n.ui-icon-circle-triangle-e { background-position: -48px -192px; }\n.ui-icon-circle-triangle-s { background-position: -64px -192px; }\n.ui-icon-circle-triangle-w { background-position: -80px -192px; }\n.ui-icon-circle-triangle-n { background-position: -96px -192px; }\n.ui-icon-circle-arrow-e { background-position: -112px -192px; }\n.ui-icon-circle-arrow-s { background-position: -128px -192px; }\n.ui-icon-circle-arrow-w { background-position: -144px -192px; }\n.ui-icon-circle-arrow-n { background-position: -160px -192px; }\n.ui-icon-circle-zoomin { background-position: -176px -192px; }\n.ui-icon-circle-zoomout { background-position: -192px -192px; }\n.ui-icon-circle-check { background-position: -208px -192px; }\n.ui-icon-circlesmall-plus { background-position: 0 -208px; }\n.ui-icon-circlesmall-minus { background-position: -16px -208px; }\n.ui-icon-circlesmall-close { background-position: -32px -208px; }\n.ui-icon-squaresmall-plus { background-position: -48px -208px; }\n.ui-icon-squaresmall-minus { background-position: -64px -208px; }\n.ui-icon-squaresmall-close { background-position: -80px -208px; }\n.ui-icon-grip-dotted-vertical { background-position: 0 -224px; }\n.ui-icon-grip-dotted-horizontal { background-position: -16px -224px; }\n.ui-icon-grip-solid-vertical { background-position: -32px -224px; }\n.ui-icon-grip-solid-horizontal { background-position: -48px -224px; }\n.ui-icon-gripsmall-diagonal-se { background-position: -64px -224px; }\n.ui-icon-grip-diagonal-se { background-position: -80px -224px; }\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Corner radius */\n.ui-corner-all, .ui-corner-top, .ui-corner-left, .ui-corner-tl { -moz-border-radius-topleft: 5px; -webkit-border-top-left-radius: 5px; -khtml-border-top-left-radius: 5px; border-top-left-radius: 5px; }\n.ui-corner-all, .ui-corner-top, .ui-corner-right, .ui-corner-tr { -moz-border-radius-topright: 5px; -webkit-border-top-right-radius: 5px; -khtml-border-top-right-radius: 5px; border-top-right-radius: 5px; }\n.ui-corner-all, .ui-corner-bottom, .ui-corner-left, .ui-corner-bl { -moz-border-radius-bottomleft: 5px; -webkit-border-bottom-left-radius: 5px; -khtml-border-bottom-left-radius: 5px; border-bottom-left-radius: 5px; }\n.ui-corner-all, .ui-corner-bottom, .ui-corner-right, .ui-corner-br { -moz-border-radius-bottomright: 5px; -webkit-border-bottom-right-radius: 5px; -khtml-border-bottom-right-radius: 5px; border-bottom-right-radius: 5px; }\n\n/* Overlays */\n.ui-widget-overlay { background: #000000 url(commons/public/3rd-party/jqueryui/images/ui-bg_flat_0_000000_40x100.png) 50% 50% repeat-x; opacity: .40;filter:Alpha(Opacity=40); }\n.ui-widget-shadow { margin: -8px 0 0 -8px; padding: 8px; background: #000000 url(commons/public/3rd-party/jqueryui/images/ui-bg_flat_0_000000_40x100.png) 50% 50% repeat-x; opacity: .30;filter:Alpha(Opacity=30); -moz-border-radius: 8px; -khtml-border-radius: 8px; -webkit-border-radius: 8px; border-radius: 8px; }/*!\n * jQuery UI Resizable 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Resizable#theming\n */\n.ui-resizable { position: relative;}\n.ui-resizable-handle { position: absolute;font-size: 0.1px; display: block; }\n.ui-resizable-disabled .ui-resizable-handle, .ui-resizable-autohide .ui-resizable-handle { display: none; }\n.ui-resizable-n { cursor: n-resize; height: 7px; width: 100%; top: -5px; left: 0; }\n.ui-resizable-s { cursor: s-resize; height: 7px; width: 100%; bottom: -5px; left: 0; }\n.ui-resizable-e { cursor: e-resize; width: 7px; right: -5px; top: 0; height: 100%; }\n.ui-resizable-w { cursor: w-resize; width: 7px; left: -5px; top: 0; height: 100%; }\n.ui-resizable-se { cursor: se-resize; width: 12px; height: 12px; right: 1px; bottom: 1px; }\n.ui-resizable-sw { cursor: sw-resize; width: 9px; height: 9px; left: -5px; bottom: -5px; }\n.ui-resizable-nw { cursor: nw-resize; width: 9px; height: 9px; left: -5px; top: -5px; }\n.ui-resizable-ne { cursor: ne-resize; width: 9px; height: 9px; right: -5px; top: -5px;}/*!\n * jQuery UI Selectable 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Selectable#theming\n */\n.ui-selectable-helper { position: absolute; z-index: 100; border:1px dotted black; }\n/*!\n * jQuery UI Accordion 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Accordion#theming\n */\n/* IE/Win - Fix animation bug - #4615 */\n.ui-accordion { width: 100%; }\n.ui-accordion .ui-accordion-header { cursor: pointer; position: relative; margin-top: 1px; zoom: 1; }\n.ui-accordion .ui-accordion-li-fix { display: inline; }\n.ui-accordion .ui-accordion-header-active { border-bottom: 0 !important; }\n.ui-accordion .ui-accordion-header a { display: block; font-size: 1em; padding: .5em .5em .5em .7em; }\n.ui-accordion-icons .ui-accordion-header a { padding-left: 2.2em; }\n.ui-accordion .ui-accordion-header .ui-icon { position: absolute; left: .5em; top: 50%; margin-top: -8px; }\n.ui-accordion .ui-accordion-content { padding: 1em 2.2em; border-top: 0; margin-top: -2px; position: relative; top: 1px; margin-bottom: 2px; overflow: auto; display: none; zoom: 1; }\n.ui-accordion .ui-accordion-content-active { display: block; }\n/*!\n * jQuery UI Autocomplete 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Autocomplete#theming\n */\n.ui-autocomplete { position: absolute; cursor: default; }\n\n/* workarounds */\n* html .ui-autocomplete { width:1px; } /* without this, the menu expands to 100% in IE6 */\n\n/*\n * jQuery UI Menu 1.8.24\n *\n * Copyright 2010, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Menu#theming\n */\n.ui-menu {\n\tlist-style:none;\n\tpadding: 2px;\n\tmargin: 0;\n\tdisplay:block;\n\tfloat: left;\n}\n.ui-menu .ui-menu {\n\tmargin-top: -3px;\n}\n.ui-menu .ui-menu-item {\n\tmargin:0;\n\tpadding: 0;\n\tzoom: 1;\n\tfloat: left;\n\tclear: left;\n\twidth: 100%;\n}\n.ui-menu .ui-menu-item a {\n\ttext-decoration:none;\n\tdisplay:block;\n\tpadding:.2em .4em;\n\tline-height:1.5;\n\tzoom:1;\n}\n.ui-menu .ui-menu-item a.ui-state-hover,\n.ui-menu .ui-menu-item a.ui-state-active {\n\tfont-weight: normal;\n\tmargin: -1px;\n}\n/*!\n * jQuery UI Button 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Button#theming\n */\n.ui-button { display: inline-block; position: relative; padding: 0; margin-right: .1em; text-decoration: none !important; cursor: pointer; text-align: center; zoom: 1; overflow: visible; } /* the overflow property removes extra width in IE */\n.ui-button-icon-only { width: 2.2em; } /* to make room for the icon, a width needs to be set here */\nbutton.ui-button-icon-only { width: 2.4em; } /* button elements seem to need a little more width */\n.ui-button-icons-only { width: 3.4em; }\nbutton.ui-button-icons-only { width: 3.7em; }\n\n/*button text element */\n.ui-button .ui-button-text { display: block; line-height: 1.4;  }\n.ui-button-text-only .ui-button-text { padding: .4em 1em; }\n.ui-button-icon-only .ui-button-text, .ui-button-icons-only .ui-button-text { padding: .4em; text-indent: -9999999px; }\n.ui-button-text-icon-primary .ui-button-text, .ui-button-text-icons .ui-button-text { padding: .4em 1em .4em 2.1em; }\n.ui-button-text-icon-secondary .ui-button-text, .ui-button-text-icons .ui-button-text { padding: .4em 2.1em .4em 1em; }\n.ui-button-text-icons .ui-button-text { padding-left: 2.1em; padding-right: 2.1em; }\n/* no icon support for input elements, provide padding by default */\ninput.ui-button { padding: .4em 1em; }\n\n/*button icon element(s) */\n.ui-button-icon-only .ui-icon, .ui-button-text-icon-primary .ui-icon, .ui-button-text-icon-secondary .ui-icon, .ui-button-text-icons .ui-icon, .ui-button-icons-only .ui-icon { position: absolute; top: 50%; margin-top: -8px; }\n.ui-button-icon-only .ui-icon { left: 50%; margin-left: -8px; }\n.ui-button-text-icon-primary .ui-button-icon-primary, .ui-button-text-icons .ui-button-icon-primary, .ui-button-icons-only .ui-button-icon-primary { left: .5em; }\n.ui-button-text-icon-secondary .ui-button-icon-secondary, .ui-button-text-icons .ui-button-icon-secondary, .ui-button-icons-only .ui-button-icon-secondary { right: .5em; }\n.ui-button-text-icons .ui-button-icon-secondary, .ui-button-icons-only .ui-button-icon-secondary { right: .5em; }\n\n/*button sets*/\n.ui-buttonset { margin-right: 7px; }\n.ui-buttonset .ui-button { margin-left: 0; margin-right: -.3em; }\n\n/* workarounds */\nbutton.ui-button::-moz-focus-inner { border: 0; padding: 0; } /* reset extra padding in Firefox */\n/*!\n * jQuery UI Dialog 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Dialog#theming\n */\n.ui-dialog { position: absolute; padding: .2em; width: 300px; overflow: hidden; }\n.ui-dialog .ui-dialog-titlebar { padding: .4em 1em; position: relative;  }\n.ui-dialog .ui-dialog-title { float: left; margin: .1em 16px .1em 0; }\n.ui-dialog .ui-dialog-titlebar-close { position: absolute; right: .3em; top: 50%; width: 19px; margin: -10px 0 0 0; padding: 1px; height: 18px; }\n.ui-dialog .ui-dialog-titlebar-close span { display: block; margin: 1px; }\n.ui-dialog .ui-dialog-titlebar-close:hover, .ui-dialog .ui-dialog-titlebar-close:focus { padding: 0; }\n.ui-dialog .ui-dialog-content { position: relative; border: 0; padding: .5em 1em; background: none; overflow: auto; zoom: 1; }\n.ui-dialog .ui-dialog-buttonpane { text-align: left; border-width: 1px 0 0 0; background-image: none; margin: .5em 0 0 0; padding: .3em 1em .5em .4em; }\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset { float: right; }\n.ui-dialog .ui-dialog-buttonpane button { margin: .5em .4em .5em 0; cursor: pointer; }\n.ui-dialog .ui-resizable-se { width: 14px; height: 14px; right: 3px; bottom: 3px; }\n.ui-draggable .ui-dialog-titlebar { cursor: move; }\n/*!\n * jQuery UI Slider 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Slider#theming\n */\n\n\n.ui-slider {\n\tposition: relative;\n\ttext-align: left;\n    border: none;\n    background: #ddd;\n}\n\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n\tfilter: inherit;\n}\n\n.ui-slider .ui-slider-handle {\n \t-webkit-transition: background 0.1s ease-in-out;\n \t-moz-transition: background 0.1s ease-in-out;\n \t-o-transition: background 0.1s ease-in-out;\n \ttransition: background 0.1s ease-in-out;\n    border-radius: 50%;\n    border: 1px solid #fff;\n\tposition: absolute;\n\tz-index: 2;\n\twidth: 14px;\n\theight: 14px;\n\tcursor: default;\n\tbackground: #3498db;\n    cursor: pointer;\n    outline: none;\n}\n\n.ui-slider .ui-slider-handle:hover {\n    background: #109fff;\n}\n\n.ui-slider .ui-slider-handle:active {\n    background: #2386c8;\n}\n\n.ui-slider .ui-slider-range {\n\tposition: absolute;\n\tz-index: 1;\n\tdisplay: block;\n\tborder: 0;\n\tcolor: #fff;\n\tbackground: #3498db;\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n    cursor: pointer;\n    border: none;\n}\n\n.ui-slider-horizontal {\n\theight: 4px;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n\ttop: -6px;\n\tmargin-left: -4px;\n}\n\n.ui-slider-horizontal .ui-slider-range {\n\ttop: 0;\n\theight: 100%;\n}\n\n.ui-slider-horizontal .ui-slider-range-min {\n\tleft: 0;\n}\n\n.ui-slider-horizontal .ui-slider-range-max {\n\tright: 0;\n}\n\n.ui-slider-vertical {\n\twidth: 5px;\n\theight: 100px;\n}\n\n.ui-slider-vertical .ui-slider-handle {\n\tleft: -6px;\n\tmargin-left: 0;\n\tmargin-bottom: -4px;\n}\n\n.ui-slider-vertical .ui-slider-range {\n\tleft: 0;\n\twidth: 100%;\n}\n\n.ui-slider-vertical .ui-slider-range-min {\n\tbottom: 0;\n}\n\n.ui-slider-vertical .ui-slider-range-max {\n\ttop: 0;\n}\n/*!\n * jQuery UI Tabs 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Tabs#theming\n */\n.ui-tabs { position: relative; padding: .2em; zoom: 1; } /* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\n.ui-tabs .ui-tabs-nav { margin: 0; padding: .2em .2em 0; }\n.ui-tabs .ui-tabs-nav li { list-style: none; float: left; position: relative; top: 1px; margin: 0 .2em 1px 0; border-bottom: 0 !important; padding: 0; white-space: nowrap; }\n.ui-tabs .ui-tabs-nav li a { float: left; padding: .5em 1em; text-decoration: none; }\n.ui-tabs .ui-tabs-nav li.ui-tabs-selected { margin-bottom: 0; padding-bottom: 1px; }\n.ui-tabs .ui-tabs-nav li.ui-tabs-selected a, .ui-tabs .ui-tabs-nav li.ui-state-disabled a, .ui-tabs .ui-tabs-nav li.ui-state-processing a { cursor: text; }\n.ui-tabs .ui-tabs-nav li a, .ui-tabs.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-selected a { cursor: pointer; } /* first selector in group seems obsolete, but required to overcome bug in Opera applying cursor: text overall if defined elsewhere... */\n.ui-tabs .ui-tabs-panel { display: block; border-width: 0; padding: 1em 1.4em; background: none; }\n.ui-tabs .ui-tabs-hide { display: none !important; }\n/*!\n * jQuery UI Datepicker 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Datepicker#theming\n */\n\n .card-filters .jumbo-block-span.datepickers {\n    margin: 15px -15px 0;\n    width: calc(100% + 30px);\n }\n\n .card-filters .jumbo-block-span.datepickers::after {\n    border-bottom-color: #f5f5f5;\n }\n\n .card-filters .jumbo-menu .jumbo-block-span .datepicker {\n\tfloat: none;\n\tmargin: 0;\n\twidth: 100%;\n}\n\n .card-filters .jumbo-menu .jumbo-block-span .datepicker + .datepicker {\n\tmargin-top: 20px;\n}\n\n .card-filters .jumbo-menu .jumbo-block-span .datepicker .ui-datepicker.ui-widget {\n \tmargin: 0 auto;\n }\n\n .card-filters .jumbo-menu .jumbo-block-span .datepicker .ui-datepicker td {\n \tpadding: 3px;\n}\n\n .card-filters .jumbo-menu .jumbo-block-span .datepicker .ui-datepicker .ui-state-default {\n \tpadding: 8px 0px;\n}\n\n .ui-datepicker.ui-widget  {\n \twidth: 190px;\n \twidth: 100%;\n \tmax-width: 260px;\n \tpadding: 0;\n \tdisplay:  none;\n \tborder: none;\n \tbackground: #fff;\n \tfont-family: Roboto, Arial, Helvetica, sans-serif !important;\n }\n\n .accordion-group.filter-item .ui-datepicker.ui-widget  {\n \tbackground: transparent;\n }\n\n .ui-datepicker .ui-datepicker-header  {\n \tposition: relative;\n \tpadding: 0;\n \tbackground: none;\n \tborder: none;\n \tfont-size: 12px;\n }\n\n .ui-datepicker .ui-datepicker-prev,\n .ui-datepicker .ui-datepicker-next  {\n \t-webkit-transition: color 0.1s ease-in-out;\n \t-moz-transition: color 0.1s ease-in-out;\n \t-o-transition: color 0.1s ease-in-out;\n \ttransition: color 0.1s ease-in-out;\n \tfont-family: \'TrustYou Iconic\';\n \t-webkit-font-smoothing: antialiased;\n \tcursor: pointer;\n \tfont-style: normal;\n \tfont-weight: normal;\n \tfont-size: 16px;\n \theight: auto;\n \tline-height: 1;\n \tmargin: 0;\n \twidth: 20px;\n \tcolor: #aaa;\n \ttop: 0;\n \tpadding: 10px 3px;\n \ttext-align: center;\n \tdisplay: block;\n \tposition: absolute;\n }\n\n .ui-datepicker .ui-datepicker-prev-hover,\n .ui-datepicker .ui-datepicker-next-hover  {\n \ttop:  0;\n }\n\n .ui-datepicker .ui-datepicker-prev  {\n \tleft: 0;\n }\n\n .ui-datepicker .ui-datepicker-next  {\n \tright: 0;\n }\n\n .ui-datepicker .ui-datepicker-prev-hover.ui-state-hover,\n .ui-datepicker .ui-datepicker-next-hover.ui-state-hover {\n \ttop: 0;\n \tborder: none;\n \tbackground:none;\n \tcolor: #666;\n \t-moz-transform: scale(1.2);\n \t-ms-transform: scale(1.2);\n \t-webkit-transform: scale(1.2);\n \ttransform: scale(1.2);\n }\n\n .ui-datepicker .ui-datepicker-prev.ui-state-hover:active,\n .ui-datepicker .ui-datepicker-next.ui-state-hover:active {\n \tbackground:none;\n \tcolor: #3498db;\n \t-moz-transform: scale(.9);\n \t-ms-transform: scale(.9);\n \t-webkit-transform: scale(.9);\n \ttransform: scale(.9);\n }\n\n .ui-datepicker .ui-datepicker-prev:before {\n \tcontent: \"\\25C2\";\n }\n\n .ui-datepicker .ui-datepicker-next:before {\n \tcontent: \"\\25B8\";\n }\n\n .ui-datepicker .ui-datepicker-prev span,\n .ui-datepicker .ui-datepicker-next span  {\n \tdisplay: block;\n \tposition: absolute;\n \tleft:  50%;\n \tmargin-left: -8px;\n \ttop:  50%;\n \tmargin-top: -8px;\n \tdisplay: none;\n }\n\n .ui-datepicker .ui-datepicker-title  {\n \tmargin: 0;\n \tpadding: 0 20px;\n \tline-height: 12px;\n \ttext-align: center;\n \tfont-size: 13px;\n \tfont-weight: 400;\n \tcolor: #3498db;\n }\n\n .ui-datepicker .ui-datepicker-month,\n .ui-datepicker .ui-datepicker-year {\n \t-webkit-transition: all 0.1s ease-in-out;\n \t-moz-transition: all 0.1s ease-in-out;\n \t-o-transition: all 0.1s ease-in-out;\n \ttransition: all 0.1s ease-in-out;\n \tmax-width: 65px;\n \twidth: 50%;\n \tbackground-color: transparent;\n \tbackground-size: 30% 100%;\n \tborder: none;\n \tpadding: 10px 15px 10px 10px;\n \tfont-weight: 700;\n \tdisplay: inline-block;\n }\n\n .ui-datepicker select.ui-datepicker-month:hover,\n .ui-datepicker select.ui-datepicker-year:hover {\n\tbackground-color: #eaeaea;\n }\n\n .ui-datepicker select.ui-datepicker-month:active,\n .ui-datepicker select.ui-datepicker-year:active {\n\tbackground-color: #ddd;\n }\n\n .ui-datepicker .ui-datepicker-month-year  {\n \twidth: 100%;\n }\n\n .ui-datepicker table  {\n \twidth: 100%;\n \tfont-size: .9em;\n \tborder-collapse: collapse;\n \tmargin: 0 0 .4em;\n }\n\n .ui-datepicker th  {\n \tpadding: 10px 0;\n    text-align: center;\n    border: 0;\n    color: #3498db;\n    font-size: 11px;\n    border-bottom: 1px solid #ddd;\n }\n\n .ui-datepicker td {\n \tborder: 0;\n \tpadding: 0;\n \tborder: none;\n \tbackground: none;\n \tfont-weight: 400;\n \tpadding: 1px;\n }\n\n .ui-datepicker a {\n \t-webkit-transition: all 0.1s ease-in-out;\n \t-moz-transition: all 0.1s ease-in-out;\n \t-o-transition: all 0.1s ease-in-out;\n \ttransition: all 0.1s ease-in-out;\n }\n\n .ui-datepicker .ui-state-default {\n \tfont-size: 11px;\n \tdisplay: block;\n \tcolor: #333;\n \tfont-weight: 400;\n \tpadding: 5px 0px;\n \ttext-align: center;\n \ttext-decoration: none;\n \tborder: none;\n \tbackground: transparent;\n \t-moz-border-radius: 3px;\n \t-webkit-border-radius: 3px;\n \tborder-radius: 3px;\n }\n\n .ui-datepicker .ui-state-hover {\n \tbackground: #eee;\n \tcolor: #333;\n \tcursor: pointer;\n }\n\n .ui-datepicker .ui-state-hover:active {\n \tbackground: #ccc;\n \tcolor: #000;\n }\n\n .ui-datepicker .ui-datepicker-current-day .ui-state-default {\n \tbackground: #3498db;\n \tcolor: #fff;\n \tline-height: normal;\n }\n\n/* with multiple calendars */\n.ui-datepicker.ui-datepicker-multi { width:auto; }\n.ui-datepicker-multi .ui-datepicker-group { float:left; }\n.ui-datepicker-multi .ui-datepicker-group table { width:95%; margin:0 auto .4em; }\n.ui-datepicker-multi-2 .ui-datepicker-group { width:50%; }\n.ui-datepicker-multi-3 .ui-datepicker-group { width:33.3%; }\n.ui-datepicker-multi-4 .ui-datepicker-group { width:25%; }\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header { border-left-width:0; }\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header { border-left-width:0; }\n.ui-datepicker-multi .ui-datepicker-buttonpane { clear:left; }\n.ui-datepicker-row-break { clear:both; width:100%; font-size:0em; }\n\n/* RTL support */\n.ui-datepicker-rtl { direction: rtl; }\n.ui-datepicker-rtl .ui-datepicker-prev { right: 2px; left: auto; }\n.ui-datepicker-rtl .ui-datepicker-next { left: 2px; right: auto; }\n.ui-datepicker-rtl .ui-datepicker-prev:hover { right: 1px; left: auto; }\n.ui-datepicker-rtl .ui-datepicker-next:hover { left: 1px; right: auto; }\n.ui-datepicker-rtl .ui-datepicker-buttonpane { clear:right; }\n.ui-datepicker-rtl .ui-datepicker-buttonpane button { float: left; }\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current { float:right; }\n.ui-datepicker-rtl .ui-datepicker-group { float:right; }\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header { border-right-width:0; border-left-width:1px; }\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header { border-right-width:0; border-left-width:1px; }\n\n/* IE6 IFRAME FIX (taken from datepicker 1.5.3 */\n.ui-datepicker-cover {\n    position: absolute; /*must have*/\n    z-index: -1; /*must have*/\n    filter: mask(); /*must have*/\n    top: -4px; /*must have*/\n    left: -4px; /*must have*/\n    width: 200px; /*must have*/\n    height: 200px; /*must have*/\n}/*!\n * jQuery UI Progressbar 1.8.24\n *\n * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)\n * Dual licensed under the MIT or GPL Version 2 licenses.\n * http://jquery.org/license\n *\n * http://docs.jquery.com/UI/Progressbar#theming\n */\n.ui-progressbar { height:2em; text-align: left; overflow: hidden; }\n.ui-progressbar .ui-progressbar-value {margin: -1px; height:100%; }/* Selectmenu\n----------------------------------*/\n.ui-selectmenu { display: block; display: inline-block; position: relative; height: 2.2em; vertical-align: middle; text-decoration: none; overflow: hidden; zoom: 1; }\n.ui-selectmenu-icon { position:absolute; right:6px; margin-top:-8px; top: 50%; }\n.ui-selectmenu-menu { padding:0; margin:0; position:absolute; top: 0; display: none; z-index: 1005;} /* z-index: 1005 to make selectmenu work with dialog */\n.ui-selectmenu-menu  ul { padding:0; margin:0; list-style:none; position: relative; overflow: auto; overflow-y: auto ; overflow-x: hidden; -webkit-overflow-scrolling: touch;} \n.ui-selectmenu-open { display: block; }\n.ui-selectmenu-menu-popup { margin-top: -1px; }\n.ui-selectmenu-menu li { padding:0; margin:0; display: block; border-top: 1px dotted transparent; border-bottom: 1px dotted transparent; border-right-width: 0 !important; border-left-width: 0 !important; font-weight: normal !important; }\n.ui-selectmenu-menu li a,.ui-selectmenu-status { line-height: 1.4em; display: block; padding: .405em 2.1em .405em 1em; outline:none; text-decoration:none; }\n.ui-selectmenu-menu li.ui-state-disabled a, .ui-state-disabled { cursor: default; }\n.ui-selectmenu-menu li.ui-selectmenu-hasIcon a,\n.ui-selectmenu-hasIcon .ui-selectmenu-status { padding-left: 20px; position: relative; margin-left: 5px; }\n.ui-selectmenu-menu li .ui-icon, .ui-selectmenu-status .ui-icon { position: absolute; top: 1em; margin-top: -8px; left: 0; }\n.ui-selectmenu-status { line-height: 1.4em; }\n.ui-selectmenu-menu li span,.ui-selectmenu-status span { display:block; margin-bottom: .2em; }\n.ui-selectmenu-menu li .ui-selectmenu-item-header { font-weight: bold; }\n.ui-selectmenu-menu li .ui-selectmenu-item-footer { opacity: .8; }\n/* for optgroups */\n.ui-selectmenu-menu .ui-selectmenu-group { font-size: 1em; }\n.ui-selectmenu-menu .ui-selectmenu-group .ui-selectmenu-group-label { line-height: 1.4em; display:block; padding: .6em .5em 0; font-weight: bold; }\n.ui-selectmenu-menu .ui-selectmenu-group ul { margin: 0; padding: 0; }\n/* IE6 workaround (dotted transparent borders) */\n* html .ui-selectmenu-menu li { border-color: pink; filter:chroma(color=pink); width:100%; }\n* html .ui-selectmenu-menu li a { position: relative }\n/* IE7 workaround (opacity disabled) */\n*+html .ui-state-disabled, *+html .ui-state-disabled a { color: silver; }/*\r\n * FancyBox - jQuery Plugin\r\n * Simple and fancy lightbox alternative\r\n *\r\n * Examples and documentation at: http://fancybox.net\r\n * \r\n * Copyright (c) 2008 - 2010 Janis Skarnelis\r\n * That said, it is hardly a one-person project. Many people have submitted bugs, code, and offered their advice freely. Their support is greatly appreciated.\r\n * \r\n * Version: 1.3.4 (11/11/2010)\r\n * Requires: jQuery v1.3+\r\n *\r\n * Dual licensed under the MIT and GPL licenses:\r\n *   http://www.opensource.org/licenses/mit-license.php\r\n *   http://www.gnu.org/licenses/gpl.html\r\n */\r\n\r\n#fancybox-loading {\r\n\tposition: fixed;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tmargin-top: -20px;\r\n\tmargin-left: -20px;\r\n\tcursor: pointer;\r\n\toverflow: hidden;\r\n\tz-index: 1104;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-loading div {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 40px;\r\n\theight: 480px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n}\r\n\r\n#fancybox-overlay {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\tz-index: 1100;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-tmp {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tborder: 0;\r\n\toverflow: auto;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-wrap {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tpadding: 20px;\r\n\tz-index: 1101;\r\n\toutline: none;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-outer {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: #fff;\r\n}\r\n\r\n#fancybox-content {\r\n\twidth: 0;\r\n\theight: 0;\r\n\tpadding: 0;\r\n\toutline: none;\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n\tz-index: 1102;\r\n\tborder: 0px solid #fff;\r\n}\r\n\r\n#fancybox-hide-sel-frame {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: transparent;\r\n\tz-index: 1101;\r\n}\r\n\r\n#fancybox-close {\r\n\tposition: absolute;\r\n\ttop: -15px;\r\n\tright: -15px;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tbackground: transparent url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\') -40px 0px;\r\n\tcursor: pointer;\r\n\tz-index: 1103;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-error {\r\n\tcolor: #444;\r\n\tfont: normal 12px/20px Arial;\r\n\tpadding: 14px;\r\n\tmargin: 0;\r\n}\r\n\r\n#fancybox-img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tborder: none;\r\n\toutline: none;\r\n\tline-height: 0;\r\n\tvertical-align: top;\r\n}\r\n\r\n#fancybox-frame {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder: none;\r\n\tdisplay: block;\r\n}\r\n\r\n#fancybox-left, #fancybox-right {\r\n\tposition: absolute;\r\n\tbottom: 0px;\r\n\theight: 100%;\r\n\twidth: 35%;\r\n\tcursor: pointer;\r\n\toutline: none;\r\n\tbackground: transparent url(\'commons/public/bower_components/jquery.fancybox/fancybox/blank.gif\');\r\n\tz-index: 1102;\r\n\tdisplay: none;\r\n}\r\n\r\n#fancybox-left {\r\n\tleft: 0px;\r\n}\r\n\r\n#fancybox-right {\r\n\tright: 0px;\r\n}\r\n\r\n#fancybox-left-ico, #fancybox-right-ico {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: -9999px;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tmargin-top: -15px;\r\n\tcursor: pointer;\r\n\tz-index: 1102;\r\n\tdisplay: block;\r\n}\r\n\r\n#fancybox-left-ico {\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -30px;\r\n}\r\n\r\n#fancybox-right-ico {\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -60px;\r\n}\r\n\r\n#fancybox-left:hover, #fancybox-right:hover {\r\n\tvisibility: visible; /* IE6 */\r\n}\r\n\r\n#fancybox-left:hover span {\r\n\tleft: 20px;\r\n}\r\n\r\n#fancybox-right:hover span {\r\n\tleft: auto;\r\n\tright: 20px;\r\n}\r\n\r\n.fancybox-bg {\r\n\tposition: absolute;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tborder: 0;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tz-index: 1001;\r\n}\r\n\r\n#fancybox-bg-n {\r\n\ttop: -20px;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox-x.png\');\r\n}\r\n\r\n#fancybox-bg-ne {\r\n\ttop: -20px;\r\n\tright: -20px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -162px;\r\n}\r\n\r\n#fancybox-bg-e {\r\n\ttop: 0;\r\n\tright: -20px;\r\n\theight: 100%;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox-y.png\');\r\n\tbackground-position: -20px 0px;\r\n}\r\n\r\n#fancybox-bg-se {\r\n\tbottom: -20px;\r\n\tright: -20px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -182px; \r\n}\r\n\r\n#fancybox-bg-s {\r\n\tbottom: -20px;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox-x.png\');\r\n\tbackground-position: 0px -20px;\r\n}\r\n\r\n#fancybox-bg-sw {\r\n\tbottom: -20px;\r\n\tleft: -20px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -142px;\r\n}\r\n\r\n#fancybox-bg-w {\r\n\ttop: 0;\r\n\tleft: -20px;\r\n\theight: 100%;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox-y.png\');\r\n}\r\n\r\n#fancybox-bg-nw {\r\n\ttop: -20px;\r\n\tleft: -20px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\');\r\n\tbackground-position: -40px -122px;\r\n}\r\n\r\n#fancybox-title {\r\n\tfont-family: Helvetica;\r\n\tfont-size: 12px;\r\n\tz-index: 1102;\r\n}\r\n\r\n.fancybox-title-inside {\r\n\tpadding-bottom: 10px;\r\n\ttext-align: center;\r\n\tcolor: #333;\r\n\tbackground: #fff;\r\n\tposition: relative;\r\n}\r\n\r\n.fancybox-title-outside {\r\n\tpadding-top: 10px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.fancybox-title-over {\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tcolor: #FFF;\r\n\ttext-align: left;\r\n}\r\n\r\n#fancybox-title-over {\r\n\tpadding: 10px;\r\n\tbackground-image: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancy_title_over.png\');\r\n\tdisplay: block;\r\n}\r\n\r\n.fancybox-title-float {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tbottom: -20px;\r\n\theight: 32px;\r\n}\r\n\r\n#fancybox-title-float-wrap {\r\n\tborder: none;\r\n\tborder-collapse: collapse;\r\n\twidth: auto;\r\n}\r\n\r\n#fancybox-title-float-wrap td {\r\n\tborder: none;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n#fancybox-title-float-left {\r\n\tpadding: 0 0 0 15px;\r\n\tbackground: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\') -40px -90px no-repeat;\r\n}\r\n\r\n#fancybox-title-float-main {\r\n\tcolor: #FFF;\r\n\tline-height: 29px;\r\n\tfont-weight: bold;\r\n\tpadding: 0 0 3px 0;\r\n\tbackground: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox-x.png\') 0px -40px;\r\n}\r\n\r\n#fancybox-title-float-right {\r\n\tpadding: 0 0 0 15px;\r\n\tbackground: url(\'commons/public/bower_components/jquery.fancybox/fancybox/fancybox.png\') -55px -90px no-repeat;\r\n}\r\n\r\n/* IE6 */\r\n\r\n.fancybox-ie6 #fancybox-close { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_close.png\', sizingMethod=\'scale\'); }\r\n\r\n.fancybox-ie6 #fancybox-left-ico { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_nav_left.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie6 #fancybox-right-ico { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_nav_right.png\', sizingMethod=\'scale\'); }\r\n\r\n.fancybox-ie6 #fancybox-title-over { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_title_over.png\', sizingMethod=\'scale\'); zoom: 1; }\r\n.fancybox-ie6 #fancybox-title-float-left { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_title_left.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie6 #fancybox-title-float-main { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_title_main.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie6 #fancybox-title-float-right { background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_title_right.png\', sizingMethod=\'scale\'); }\r\n\r\n.fancybox-ie6 #fancybox-bg-w, .fancybox-ie6 #fancybox-bg-e, .fancybox-ie6 #fancybox-left, .fancybox-ie6 #fancybox-right, #fancybox-hide-sel-frame {\r\n\theight: expression(this.parentNode.clientHeight + \"px\");\r\n}\r\n\r\n#fancybox-loading.fancybox-ie6 {\r\n\tposition: absolute; margin-top: 0;\r\n\ttop: expression( (-20 + (document.documentElement.clientHeight ? document.documentElement.clientHeight/2 : document.body.clientHeight/2 ) + ( ignoreMe = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop )) + \'px\');\r\n}\r\n\r\n#fancybox-loading.fancybox-ie6 div\t{ background: transparent; filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_loading.png\', sizingMethod=\'scale\'); }\r\n\r\n/* IE6, IE7, IE8 */\r\n\r\n.fancybox-ie .fancybox-bg { background: transparent !important; }\r\n\r\n.fancybox-ie #fancybox-bg-n { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_n.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-ne { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_ne.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-e { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_e.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-se { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_se.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-s { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_s.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-sw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_sw.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-w { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_w.png\', sizingMethod=\'scale\'); }\r\n.fancybox-ie #fancybox-bg-nw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src=\'fancybox/fancy_shadow_nw.png\', sizingMethod=\'scale\'); }.text-core {\n  position: relative;\n}\n.text-core .text-wrap {\n  background: #fff;\n  position: absolute;\n}\n.text-core .text-wrap textarea,\n.text-core .text-wrap input {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-border-radius: 0px;\n  -moz-border-radius: 0px;\n  border-radius: 0px;\n  border: 1px solid #9daccc;\n  outline: none;\n  resize: none;\n  position: absolute;\n  z-index: 1;\n  background: none;\n  overflow: hidden;\n  margin: 0;\n  padding: 3px 5px 4px 5px;\n  white-space: nowrap;\n  font: 11px \"lucida grande\", tahoma, verdana, arial, sans-serif;\n  line-height: 13px;\n  height: auto;\n}\n.text-core .text-wrap .text-tags {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 3px 35px 3px 3px;\n  cursor: text;\n}\n.text-core .text-wrap .text-tags.text-tags-on-top {\n  z-index: 2;\n}\n.text-core .text-wrap .text-tags .text-tag {\n  float: left;\n}\n.text-core .text-wrap .text-tags .text-tag .text-button {\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  position: relative;\n  float: left;\n  border: 1px solid #9daccc;\n  background: #e2e6f0;\n  color: #000;\n  padding: 0px 17px 0px 3px;\n  margin: 0 2px 2px 0;\n  cursor: pointer;\n  height: 16px;\n  font: 11px \"lucida grande\", tahoma, verdana, arial, sans-serif;\n}\n.text-core .text-wrap .text-tags .text-tag .text-button a.text-remove {\n  position: absolute;\n  right: 3px;\n  top: 2px;\n  display: block;\n  width: 11px;\n  height: 11px;\n  background: url(\"commons/public/bower_components/jquery-textext/src/css/close.png\") 0 0 no-repeat;\n}\n.text-core .text-wrap .text-tags .text-tag .text-button a.text-remove:hover {\n  background-position: 0 -11px;\n}\n.text-core .text-wrap .text-tags .text-tag .text-button a.text-remove:active {\n  background-position: 0 -22px;\n}\n/*\n * qTip2 - Pretty powerful tooltips - v2.1.1\n * http://qtip2.com\n *\n * Copyright (c) 2013 Craig Michael Thompson\n * Released under the MIT, GPL licenses\n * http://jquery.org/license\n *\n * Date: Wed Sep 11 2013 11:17 GMT+0100+0100\n * Plugins: tips modal viewport svg imagemap ie6\n * Styles: basic css3\n */\n.qtip{\n\tposition: absolute;\n\tleft: -28000px;\n\ttop: -28000px;\n\tdisplay: none;\n\n\tmax-width: 280px;\n\tmin-width: 50px;\n\t\n\tfont-size: 10.5px;\n\tline-height: 12px;\n\n\tdirection: ltr;\n\n\tbox-shadow: none;\n\tpadding: 0;\n}\n\n\t.qtip-content{\n\t\tposition: relative;\n\t\tpadding: 5px 9px;\n\t\toverflow: hidden;\n\n\t\ttext-align: left;\n\t\tword-wrap: break-word;\n\t}\n\n\t.qtip-titlebar{\n\t\tposition: relative;\n\t\tpadding: 5px 35px 5px 10px;\n\t\toverflow: hidden;\n\n\t\tborder-width: 0 0 1px;\n\t\tfont-weight: bold;\n\t}\n\n\t.qtip-titlebar + .qtip-content{ border-top-width: 0 !important; }\n\n\t/* Default close button class */\n\t.qtip-close{\n\t\tposition: absolute;\n\t\tright: -9px; top: -9px;\n\n\t\tcursor: pointer;\n\t\toutline: medium none;\n\n\t\tborder-width: 1px;\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t}\n\n\t\t.qtip-titlebar .qtip-close{\n\t\t\tright: 4px; top: 50%;\n\t\t\tmargin-top: -9px;\n\t\t}\n\t\n\t\t* html .qtip-titlebar .qtip-close{ top: 16px; } /* IE fix */\n\n\t\t.qtip-titlebar .ui-icon,\n\t\t.qtip-icon .ui-icon{\n\t\t\tdisplay: block;\n\t\t\ttext-indent: -1000em;\n\t\t\tdirection: ltr;\n\t\t}\n\n\t\t.qtip-icon, .qtip-icon .ui-icon{\n\t\t\t-moz-border-radius: 3px;\n\t\t\t-webkit-border-radius: 3px;\n\t\t\tborder-radius: 3px;\n\t\t\ttext-decoration: none;\n\t\t}\n\n\t\t\t.qtip-icon .ui-icon{\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 14px;\n\n\t\t\t\tline-height: 14px;\n\t\t\t\ttext-align: center;\n\t\t\t\ttext-indent: 0;\n\t\t\t\tfont: normal bold 10px/13px Tahoma,sans-serif;\n\n\t\t\t\tcolor: inherit;\n\t\t\t\tbackground: transparent none no-repeat -100em -100em;\n\t\t\t}\n\n/* Applied to \'focused\' tooltips e.g. most recently displayed/interacted with */\n.qtip-focus{}\n\n/* Applied on hover of tooltips i.e. added/removed on mouseenter/mouseleave respectively */\n.qtip-hover{}\n\n/* Default tooltip style */\n.qtip-default{\n\tborder-width: 1px;\n\tborder-style: solid;\n\tborder-color: #F1D031;\n\n\tbackground-color: #FFFFA3;\n\tcolor: #555;\n}\n\n\t.qtip-default .qtip-titlebar{\n\t\tbackground-color: #FFEF93;\n\t}\n\n\t.qtip-default .qtip-icon{\n\t\tborder-color: #CCC;\n\t\tbackground: #F1F1F1;\n\t\tcolor: #777;\n\t}\n\t\n\t.qtip-default .qtip-titlebar .qtip-close{\n\t\tborder-color: #AAA;\n\t\tcolor: #111;\n\t}\n\n\n\n/*! Light tooltip style */\n.qtip-light{\n\tbackground-color: white;\n\tborder-color: #E2E2E2;\n\tcolor: #454545;\n}\n\n\t.qtip-light .qtip-titlebar{\n\t\tbackground-color: #f1f1f1;\n\t}\n\n\n/*! Dark tooltip style */\n.qtip-dark{\n\tbackground-color: #505050;\n\tborder-color: #303030;\n\tcolor: #f3f3f3;\n}\n\n\t.qtip-dark .qtip-titlebar{\n\t\tbackground-color: #404040;\n\t}\n\n\t.qtip-dark .qtip-icon{\n\t\tborder-color: #444;\n\t}\n\n\t.qtip-dark .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #303030;\n\t}\n\n\n/*! Cream tooltip style */\n.qtip-cream{\n\tbackground-color: #FBF7AA;\n\tborder-color: #F9E98E;\n\tcolor: #A27D35;\n}\n\n\t.qtip-cream .qtip-titlebar{\n\t\tbackground-color: #F0DE7D;\n\t}\n\n\t.qtip-cream .qtip-close .qtip-icon{\n\t\tbackground-position: -82px 0;\n\t}\n\n\n/*! Red tooltip style */\n.qtip-red{\n\tbackground-color: #F78B83;\n\tborder-color: #D95252;\n\tcolor: #912323;\n}\n\n\t.qtip-red .qtip-titlebar{\n\t\tbackground-color: #F06D65;\n\t}\n\n\t.qtip-red .qtip-close .qtip-icon{\n\t\tbackground-position: -102px 0;\n\t}\n\n\t.qtip-red .qtip-icon{\n\t\tborder-color: #D95252;\n\t}\n\n\t.qtip-red .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #D95252;\n\t}\n\n\n/*! Green tooltip style */\n.qtip-green{\n\tbackground-color: #CAED9E;\n\tborder-color: #90D93F;\n\tcolor: #3F6219;\n}\n\n\t.qtip-green .qtip-titlebar{\n\t\tbackground-color: #B0DE78;\n\t}\n\n\t.qtip-green .qtip-close .qtip-icon{\n\t\tbackground-position: -42px 0;\n\t}\n\n\n/*! Blue tooltip style */\n.qtip-blue{\n\tbackground-color: #E5F6FE;\n\tborder-color: #ADD9ED;\n\tcolor: #5E99BD;\n}\n\n\t.qtip-blue .qtip-titlebar{\n\t\tbackground-color: #D0E9F5;\n\t}\n\n\t.qtip-blue .qtip-close .qtip-icon{\n\t\tbackground-position: -2px 0;\n\t}\n\n\n\n.qtip-shadow{\n\t-webkit-box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.15);\n\t-moz-box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.15);\n\tbox-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.15);\n}\n\n/* Add rounded corners to your tooltips in: FF3+, Chrome 2+, Opera 10.6+, IE9+, Safari 2+ */\n.qtip-rounded,\n.qtip-tipsy,\n.qtip-bootstrap{\n\t-moz-border-radius: 5px;\n\t-webkit-border-radius: 5px;\n\tborder-radius: 5px;\n}\n\n.qtip-rounded .qtip-titlebar{\n\t-moz-border-radius: 4px 4px 0 0;\n\t-webkit-border-radius: 4px 4px 0 0;\n\tborder-radius: 4px 4px 0 0;\n}\n\n/* Youtube tooltip style */\n.qtip-youtube{\n\t-moz-border-radius: 2px;\n\t-webkit-border-radius: 2px;\n\tborder-radius: 2px;\n\t\n\t-webkit-box-shadow: 0 0 3px #333;\n\t-moz-box-shadow: 0 0 3px #333;\n\tbox-shadow: 0 0 3px #333;\n\n\tcolor: white;\n\tborder-width: 0;\n\n\tbackground: #4A4A4A;\n\tbackground-image: -webkit-gradient(linear,left top,left bottom,color-stop(0,#4A4A4A),color-stop(100%,black));\n\tbackground-image: -webkit-linear-gradient(top,#4A4A4A 0,black 100%);\n\tbackground-image: -moz-linear-gradient(top,#4A4A4A 0,black 100%);\n\tbackground-image: -ms-linear-gradient(top,#4A4A4A 0,black 100%);\n\tbackground-image: -o-linear-gradient(top,#4A4A4A 0,black 100%);\n}\n\n\t.qtip-youtube .qtip-titlebar{\n\t\tbackground-color: #4A4A4A;\n\t\tbackground-color: rgba(0,0,0,0);\n\t}\n\t\n\t.qtip-youtube .qtip-content{\n\t\tpadding: .75em;\n\t\tfont: 12px arial,sans-serif;\n\t\t\n\t\tfilter: progid:DXImageTransform.Microsoft.Gradient(GradientType=0,StartColorStr=#4a4a4a,EndColorStr=#000000);\n\t\t-ms-filter: \"progid:DXImageTransform.Microsoft.Gradient(GradientType=0,StartColorStr=#4a4a4a,EndColorStr=#000000);\";\n\t}\n\n\t.qtip-youtube .qtip-icon{\n\t\tborder-color: #222;\n\t}\n\n\t.qtip-youtube .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #303030;\n\t}\n\n\n/* jQuery TOOLS Tooltip style */\n.qtip-jtools{\n\tbackground: #232323;\n\tbackground: rgba(0, 0, 0, 0.7);\n\tbackground-image: -webkit-gradient(linear, left top, left bottom, from(#717171), to(#232323));\n\tbackground-image: -moz-linear-gradient(top, #717171, #232323);\n\tbackground-image: -webkit-linear-gradient(top, #717171, #232323);\n\tbackground-image: -ms-linear-gradient(top, #717171, #232323);\n\tbackground-image: -o-linear-gradient(top, #717171, #232323);\n\n\tborder: 2px solid #ddd;\n\tborder: 2px solid rgba(241,241,241,1);\n\n\t-moz-border-radius: 2px;\n\t-webkit-border-radius: 2px;\n\tborder-radius: 2px;\n\n\t-webkit-box-shadow: 0 0 12px #333;\n\t-moz-box-shadow: 0 0 12px #333;\n\tbox-shadow: 0 0 12px #333;\n}\n\n\t/* IE Specific */\n\t.qtip-jtools .qtip-titlebar{\n\t\tbackground-color: transparent;\n\t\tfilter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#717171,endColorstr=#4A4A4A);\n\t\t-ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#717171,endColorstr=#4A4A4A)\";\n\t}\n\t.qtip-jtools .qtip-content{\n\t\tfilter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#4A4A4A,endColorstr=#232323);\n\t\t-ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#4A4A4A,endColorstr=#232323)\";\n\t}\n\n\t.qtip-jtools .qtip-titlebar,\n\t.qtip-jtools .qtip-content{\n\t\tbackground: transparent;\n\t\tcolor: white;\n\t\tborder: 0 dashed transparent;\n\t}\n\n\t.qtip-jtools .qtip-icon{\n\t\tborder-color: #555;\n\t}\n\n\t.qtip-jtools .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #333;\n\t}\n\n\n/* Cluetip style */\n.qtip-cluetip{\n\t-webkit-box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.4);\n\t-moz-box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.4);\n\tbox-shadow: 4px 4px 5px rgba(0, 0, 0, 0.4);\n\n\tbackground-color: #D9D9C2;\n\tcolor: #111;\n\tborder: 0 dashed transparent;\n}\n\n\t.qtip-cluetip .qtip-titlebar{\n\t\tbackground-color: #87876A;\n\t\tcolor: white;\n\t\tborder: 0 dashed transparent;\n\t}\n\t\n\t.qtip-cluetip .qtip-icon{\n\t\tborder-color: #808064;\n\t}\n\t\n\t.qtip-cluetip .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #696952;\n\t\tcolor: #696952;\n\t}\n\n\n/* Tipsy style */\n.qtip-tipsy{\n\tbackground: black;\n\tbackground: rgba(0, 0, 0, .87);\n\n\tcolor: white;\n\tborder: 0 solid transparent;\n\n\tfont-size: 11px;\n\tfont-family: \'Lucida Grande\', sans-serif;\n\tfont-weight: bold;\n\tline-height: 16px;\n\ttext-shadow: 0 1px black;\n}\n\n\t.qtip-tipsy .qtip-titlebar{\n\t\tpadding: 6px 35px 0 10px;\n\t\tbackground-color: transparent;\n\t}\n\n\t.qtip-tipsy .qtip-content{\n\t\tpadding: 6px 10px;\n\t}\n\t\n\t.qtip-tipsy .qtip-icon{\n\t\tborder-color: #222;\n\t\ttext-shadow: none;\n\t}\n\n\t.qtip-tipsy .qtip-titlebar .ui-state-hover{\n\t\tborder-color: #303030;\n\t}\n\n\n/* Tipped style */\n.qtip-tipped{\n\tborder: 3px solid #959FA9;\n\n\t-moz-border-radius: 3px;\n\t-webkit-border-radius: 3px;\n\tborder-radius: 3px;\n\n\tbackground-color: #F9F9F9;\n\tcolor: #454545;\n\n\tfont-weight: normal;\n\tfont-family: serif;\n}\n\n\t.qtip-tipped .qtip-titlebar{\n\t\tborder-bottom-width: 0;\n\n\t\tcolor: white;\n\t\tbackground: #3A79B8;\n\t\tbackground-image: -webkit-gradient(linear, left top, left bottom, from(#3A79B8), to(#2E629D));\n\t\tbackground-image: -webkit-linear-gradient(top, #3A79B8, #2E629D);\n\t\tbackground-image: -moz-linear-gradient(top, #3A79B8, #2E629D);\n\t\tbackground-image: -ms-linear-gradient(top, #3A79B8, #2E629D);\n\t\tbackground-image: -o-linear-gradient(top, #3A79B8, #2E629D);\n\t\tfilter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#3A79B8,endColorstr=#2E629D);\n\t\t-ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#3A79B8,endColorstr=#2E629D)\";\n\t}\n\n\t.qtip-tipped .qtip-icon{\n\t\tborder: 2px solid #285589;\n\t\tbackground: #285589;\n\t}\n\n\t\t.qtip-tipped .qtip-icon .ui-icon{\n\t\t\tbackground-color: #FBFBFB;\n\t\t\tcolor: #555;\n\t\t}\n\n\n/**\n * Twitter Bootstrap style.\n *\n * Tested with IE 8, IE 9, Chrome 18, Firefox 9, Opera 11.\n * Does not work with IE 7.\n */\n.qtip-bootstrap{\n\t/** Taken from Bootstrap body */\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #333333;\n\n\t/** Taken from Bootstrap .popover */\n\tpadding: 1px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #ccc;\n\tborder: 1px solid rgba(0, 0, 0, 0.2);\n\t-webkit-border-radius: 6px;\n\t-moz-border-radius: 6px;\n\tborder-radius: 6px;\n\t-webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\t-moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\tbox-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n\t-webkit-background-clip: padding-box;\n\t-moz-background-clip: padding;\n\tbackground-clip: padding-box;\n}\n\n\t.qtip-bootstrap .qtip-titlebar{\n\t\t/** Taken from Bootstrap .popover-title */\n\t\tpadding: 8px 14px;\n\t\tmargin: 0;\n\t\tfont-size: 14px;\n\t\tfont-weight: normal;\n\t\tline-height: 18px;\n\t\tbackground-color: #f7f7f7;\n\t\tborder-bottom: 1px solid #ebebeb;\n\t\t-webkit-border-radius: 5px 5px 0 0;\n\t\t-moz-border-radius: 5px 5px 0 0;\n\t\tborder-radius: 5px 5px 0 0;\n\t}\n\n\t\t.qtip-bootstrap .qtip-titlebar .qtip-close{\n\t\t\t/**\n\t\t\t * Overrides qTip2:\n\t\t\t * .qtip-titlebar .qtip-close{\n\t\t\t *   [...]\n\t\t\t *   right: 4px;\n\t\t\t *   top: 50%;\n\t\t\t *   [...]\n\t\t\t *   border-style: solid;\n\t\t\t * }\n\t\t\t */\n\t\t\tright: 11px;\n\t\t\ttop: 45%;\n\t\t\tborder-style: none;\n\t\t}\n\n\t.qtip-bootstrap .qtip-content{\n\t\t/** Taken from Bootstrap .popover-content */\n\t\tpadding: 9px 14px;\n\t}\n\n\t.qtip-bootstrap .qtip-icon{\n\t\t/**\n\t\t * Overrides qTip2:\n\t\t * .qtip-default .qtip-icon {\n\t\t *   border-color: #CCC;\n\t\t *   background: #F1F1F1;\n\t\t *   color: #777;\n\t\t * }\n\t\t */\n\t\tbackground: transparent;\n\t}\n\n\t\t.qtip-bootstrap .qtip-icon .ui-icon{\n\t\t\t/**\n\t\t\t * Overrides qTip2:\n\t\t\t * .qtip-icon .ui-icon{\n\t\t\t *   width: 18px;\n\t\t\t *   height: 14px;\n\t\t\t * }\n\t\t\t */\n\t\t\twidth: auto;\n\t\t\theight: auto;\n\n\t\t\t/* Taken from Bootstrap .close */\n\t\t\tfloat: right;\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: bold;\n\t\t\tline-height: 18px;\n\t\t\tcolor: #000000;\n\t\t\ttext-shadow: 0 1px 0 #ffffff;\n\t\t\topacity: 0.2;\n\t\t\tfilter: alpha(opacity=20);\n\t\t}\n\n\t\t.qtip-bootstrap .qtip-icon .ui-icon:hover{\n\t\t\t/* Taken from Bootstrap .close:hover */\n\t\t\tcolor: #000000;\n\t\t\ttext-decoration: none;\n\t\t\tcursor: pointer;\n\t\t\topacity: 0.4;\n\t\t\tfilter: alpha(opacity=40);\n\t\t}\n\n\n/* IE9 fix - removes all filters */\n.qtip:not(.ie9haxors) div.qtip-content,\n.qtip:not(.ie9haxors) div.qtip-titlebar{\n\tfilter: none;\n\t-ms-filter: none;\n}\n\n\n\n.qtip .qtip-tip{\n\tmargin: 0 auto;\n\toverflow: hidden;\n\tz-index: 10;\n\t\n}\n\n\t/* Opera bug #357 - Incorrect tip position\n\thttps://github.com/Craga89/qTip2/issues/367 */\n\tx:-o-prefocus, .qtip .qtip-tip{\n\t\tvisibility: hidden;\n\t}\n\n\t.qtip .qtip-tip,\n\t.qtip .qtip-tip .qtip-vml,\n\t.qtip .qtip-tip canvas{\n\t\tposition: absolute;\n\n\t\tcolor: #123456;\n\t\tbackground: transparent;\n\t\tborder: 0 dashed transparent;\n\t}\n\t\n\t.qtip .qtip-tip canvas{ top: 0; left: 0; }\n\n\t.qtip .qtip-tip .qtip-vml{\n\t\tbehavior: url(commons/public/bower_components/qtip2/#default#VML);\n\t\tdisplay: inline-block;\n\t\tvisibility: visible;\n\t}\n\n#qtip-overlay{\n\tposition: fixed;\n\tleft: 0; top: 0;\n\twidth: 100%; height: 100%;\n}\n\n\t/* Applied to modals with show.modal.blur set to true */\n\t#qtip-overlay.blurs{ cursor: pointer; }\n\n\t/* Change opacity of overlay here */\n\t#qtip-overlay div{\n\t\tposition: absolute;\n\t\tleft: 0; top: 0;\n\t\twidth: 100%; height: 100%;\n\n\t\tbackground-color: black;\n\n\t\topacity: 0.7;\n\t\tfilter:alpha(opacity=70);\n\t\t-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\n\t}\n\n\n\n.qtipmodal-ie6fix{\n\tposition: absolute !important;\n}/*!\n * Waves v0.7.5\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2016 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE \n */.waves-effect{position:relative;cursor:pointer;display:inline-block;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.waves-effect .waves-ripple{position:absolute;border-radius:50%;width:100px;height:100px;margin-top:-50px;margin-left:-50px;opacity:0;background:rgba(0,0,0,.2);background:-webkit-radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,rgba(255,255,255,0) 70%);background:-o-radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,rgba(255,255,255,0) 70%);background:-moz-radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,rgba(255,255,255,0) 70%);background:radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,rgba(255,255,255,0) 70%);-webkit-transition:all .5s ease-out;-moz-transition:all .5s ease-out;-o-transition:all .5s ease-out;transition:all .5s ease-out;-webkit-transition-property:-webkit-transform,opacity;-moz-transition-property:-moz-transform,opacity;-o-transition-property:-o-transform,opacity;transition-property:transform,opacity;-webkit-transform:scale(0) translate(0,0);-moz-transform:scale(0) translate(0,0);-ms-transform:scale(0) translate(0,0);-o-transform:scale(0) translate(0,0);transform:scale(0) translate(0,0);pointer-events:none}.waves-effect.waves-light .waves-ripple{background:rgba(255,255,255,.4);background:-webkit-radial-gradient(rgba(255,255,255,.2) 0,rgba(255,255,255,.3) 40%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 70%);background:-o-radial-gradient(rgba(255,255,255,.2) 0,rgba(255,255,255,.3) 40%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 70%);background:-moz-radial-gradient(rgba(255,255,255,.2) 0,rgba(255,255,255,.3) 40%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 70%);background:radial-gradient(rgba(255,255,255,.2) 0,rgba(255,255,255,.3) 40%,rgba(255,255,255,.4) 50%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0) 70%)}.waves-effect.waves-classic .waves-ripple{background:rgba(0,0,0,.2)}.waves-effect.waves-classic.waves-light .waves-ripple{background:rgba(255,255,255,.4)}.waves-notransition{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;transition:none!important}.waves-button,.waves-circle{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0);-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 100%)}.waves-button,.waves-button:hover,.waves-button:visited,.waves-button-input{white-space:nowrap;vertical-align:middle;cursor:pointer;border:none;outline:0;color:inherit;background-color:transparent;font-size:1em;line-height:1em;text-align:center;text-decoration:none;z-index:1}.waves-button{padding:.85em 1.1em;border-radius:.2em}.waves-button-input{margin:0;padding:.85em 1.1em}.waves-input-wrapper{border-radius:.2em;vertical-align:bottom}.waves-input-wrapper.waves-button{padding:0}.waves-input-wrapper .waves-button-input{position:relative;top:0;left:0;z-index:1}.waves-circle{text-align:center;width:2.5em;height:2.5em;line-height:2.5em;border-radius:50%}.waves-float{-webkit-mask-image:none;-webkit-box-shadow:0 1px 1.5px 1px rgba(0,0,0,.12);box-shadow:0 1px 1.5px 1px rgba(0,0,0,.12);-webkit-transition:all 300ms;-moz-transition:all 300ms;-o-transition:all 300ms;transition:all 300ms}.waves-float:active{-webkit-box-shadow:0 8px 20px 1px rgba(0,0,0,.3);box-shadow:0 8px 20px 1px rgba(0,0,0,.3)}.waves-block{display:block}/*\nVersion: 3.4.5 Timestamp: Mon Nov  4 08:22:42 PST 2013\n\nTrustYou changelog:\nWANALYTIC-4617 Hotel filter in Surveys not working in IE8\n*/\n.select2-container {\n    margin: 0;\n    position: relative;\n    display: inline-block;\n    /* inline-block for ie7 */\n    zoom: 1;\n    *display: inline;\n    vertical-align: middle;\n}\n\n.select2-container,\n.select2-drop,\n.select2-search,\n.select2-search input {\n  /*\n    Force border-box so that % widths fit the parent\n    container without overlap because of margin/padding.\n\n    More Info : http://www.quirksmode.org/css/box.html\n  */\n  -webkit-box-sizing: border-box; /* webkit */\n     -moz-box-sizing: border-box; /* firefox */\n          box-sizing: border-box; /* css3 */\n}\n\n.select2-container .select2-choice {\n    display: block;\n    height: 26px;\n    padding: 0 0 0 8px;\n    overflow: hidden;\n    position: relative;\n\n    border: 1px solid #aaa;\n    white-space: nowrap;\n    line-height: 26px;\n    color: #444;\n    text-decoration: none;\n\n    border-radius: 4px;\n\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n\n    background-color: #fff;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.5, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    /*WANALYTIC-4617*/\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = \'#ffffff\', endColorstr = \'#eeeeee\', GradientType = 0);*/\n    background-image: linear-gradient(top, #fff 0%, #eee 50%);\n}\n\n.select2-container.select2-drop-above .select2-choice {\n    border-bottom-color: #aaa;\n\n    border-radius: 0 0 4px 4px;\n\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.9, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    /*WANALYTIC-4617*/\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#ffffff\', endColorstr=\'#eeeeee\', GradientType=0);*/\n    background-image: linear-gradient(top, #eee 0%, #fff 90%);\n}\n\n.select2-container.select2-allowclear .select2-choice .select2-chosen {\n    margin-right: 42px;\n}\n\n.select2-container .select2-choice > .select2-chosen {\n    margin-right: 26px;\n    display: block;\n    overflow: hidden;\n\n    white-space: nowrap;\n\n    text-overflow: ellipsis;\n}\n\n.select2-container .select2-choice abbr {\n    display: none;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 24px;\n    top: 8px;\n\n    font-size: 1px;\n    text-decoration: none;\n\n    border: 0;\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') right top no-repeat;\n    cursor: pointer;\n    outline: 0;\n}\n\n.select2-container.select2-allowclear .select2-choice abbr {\n    display: inline-block;\n}\n\n.select2-container .select2-choice abbr:hover {\n    background-position: right -11px;\n    cursor: pointer;\n}\n\n.select2-drop-mask {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    position: fixed;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    min-width: 100%;\n    height: auto;\n    width: auto;\n    opacity: 0;\n    z-index: 9998;\n    /* styles required for IE to work */\n    background-color: #fff;\n    filter: alpha(opacity=0);\n}\n\n.select2-drop {\n    width: 100%;\n    margin-top: -1px;\n    position: absolute;\n    z-index: 9999;\n    top: 100%;\n\n    background: #fff;\n    color: #000;\n    border: 1px solid #aaa;\n    border-top: 0;\n\n    border-radius: 0 0 4px 4px;\n\n    -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop-auto-width {\n    border-top: 1px solid #aaa;\n    width: auto;\n}\n\n.select2-drop-auto-width .select2-search {\n    padding-top: 4px;\n}\n\n.select2-drop.select2-drop-above {\n    margin-top: 1px;\n    border-top: 1px solid #aaa;\n    border-bottom: 0;\n\n    border-radius: 4px 4px 0 0;\n\n    -webkit-box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop-active {\n    border: 1px solid #5897fb;\n    border-top: none;\n}\n\n.select2-drop.select2-drop-above.select2-drop-active {\n    border-top: 1px solid #5897fb;\n}\n\n.select2-container .select2-choice .select2-arrow {\n    display: inline-block;\n    width: 18px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    border-left: 1px solid #aaa;\n    border-radius: 0 4px 4px 0;\n\n    background-clip: padding-box;\n\n    background: #ccc;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #ccc), color-stop(0.6, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    background-image: -moz-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    /*WANALYTIC-4617*/\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = \'#eeeeee\', endColorstr = \'#cccccc\', GradientType = 0);*/\n    background-image: linear-gradient(top, #ccc 0%, #eee 60%);\n}\n\n.select2-container .select2-choice .select2-arrow b {\n    display: block;\n    width: 100%;\n    height: 100%;\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 0 1px;\n}\n\n.select2-search {\n    display: inline-block;\n    width: 100%;\n    min-height: 26px;\n    margin: 0;\n    padding-left: 4px;\n    padding-right: 4px;\n\n    position: relative;\n    z-index: 10000;\n\n    white-space: nowrap;\n}\n\n.select2-search input {\n    width: 100%;\n    height: auto !important;\n    min-height: 26px;\n    padding: 4px 20px 4px 5px;\n    margin: 0;\n\n    outline: 0;\n    font-family: sans-serif;\n    font-size: 1em;\n\n    border: 1px solid #aaa;\n    border-radius: 0;\n\n    -webkit-box-shadow: none;\n            box-shadow: none;\n\n    background: #fff url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 100% -22px;\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') no-repeat 100% -22px, linear-gradient(top, #fff 85%, #eee 99%);\n}\n\n.select2-drop.select2-drop-above .select2-search input {\n    margin-top: 4px;\n}\n\n.select2-search input.select2-active {\n    background: #fff url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%;\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%, linear-gradient(top, #fff 85%, #eee 99%);\n}\n\n.select2-container-active .select2-choice,\n.select2-container-active .select2-choices {\n    border: 1px solid #5897fb;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n\n.select2-dropdown-open .select2-choice {\n    border-bottom-color: transparent;\n    -webkit-box-shadow: 0 1px 0 #fff inset;\n            box-shadow: 0 1px 0 #fff inset;\n\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n    background-color: #eee;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    /*WANALYTIC-4617*/\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#eeeeee\', endColorstr=\'#ffffff\', GradientType=0);*/\n    background-image: linear-gradient(top, #fff 0%, #eee 50%);\n}\n\n.select2-dropdown-open.select2-drop-above .select2-choice,\n.select2-dropdown-open.select2-drop-above .select2-choices {\n    border: 1px solid #5897fb;\n    border-top-color: transparent;\n\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center top, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center top, #fff 0%, #eee 50%);\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#eeeeee\', endColorstr=\'#ffffff\', GradientType=0);*/\n    background-image: linear-gradient(bottom, #fff 0%, #eee 50%);\n}\n\n.select2-dropdown-open .select2-choice .select2-arrow {\n    background: transparent;\n    border-left: none;\n    filter: none;\n}\n.select2-dropdown-open .select2-choice .select2-arrow b {\n    background-position: -18px 1px;\n}\n\n/* results */\n.select2-results {\n    max-height: 200px;\n    padding: 0 0 0 4px;\n    margin: 4px 4px 4px 0;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.select2-results ul.select2-result-sub {\n    margin: 0;\n    padding-left: 0;\n}\n\n.select2-results ul.select2-result-sub > li .select2-result-label { padding-left: 20px }\n.select2-results ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 40px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 60px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 80px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 100px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 110px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 120px }\n\n.select2-results li {\n    list-style: none;\n    display: list-item;\n    background-image: none;\n}\n\n.select2-results li.select2-result-with-children > .select2-result-label {\n    font-weight: bold;\n}\n\n.select2-results .select2-result-label {\n    padding: 3px 7px 4px;\n    margin: 0;\n    cursor: pointer;\n\n    min-height: 1em;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n}\n\n.select2-results .select2-highlighted {\n    background: #3875d7;\n    color: #fff;\n}\n\n.select2-results li em {\n    background: #feffde;\n    font-style: normal;\n}\n\n.select2-results .select2-highlighted em {\n    background: transparent;\n}\n\n.select2-results .select2-highlighted ul {\n    background: #fff;\n    color: #000;\n}\n\n\n.select2-results .select2-no-results,\n.select2-results .select2-searching,\n.select2-results .select2-selection-limit {\n    background: #f4f4f4;\n    display: list-item;\n}\n\n/*\ndisabled look for disabled choices in the results dropdown\n*/\n.select2-results .select2-disabled.select2-highlighted {\n    color: #666;\n    background: #f4f4f4;\n    display: list-item;\n    cursor: default;\n}\n.select2-results .select2-disabled {\n  background: #f4f4f4;\n  display: list-item;\n  cursor: default;\n}\n\n.select2-results .select2-selected {\n    display: none;\n}\n\n.select2-more-results.select2-active {\n    background: #f4f4f4 url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100%;\n}\n\n.select2-more-results {\n    background: #f4f4f4;\n    display: list-item;\n}\n\n/* disabled styles */\n\n.select2-container.select2-container-disabled .select2-choice {\n    background-color: #f4f4f4;\n    background-image: none;\n    border: 1px solid #ddd;\n    cursor: default;\n}\n\n.select2-container.select2-container-disabled .select2-choice .select2-arrow {\n    background-color: #f4f4f4;\n    background-image: none;\n    border-left: 0;\n}\n\n.select2-container.select2-container-disabled .select2-choice abbr {\n    display: none;\n}\n\n\n/* multiselect */\n\n.select2-container-multi .select2-choices {\n    height: auto !important;\n    height: 1%;\n    margin: 0;\n    padding: 0;\n    position: relative;\n\n    border: 1px solid #aaa;\n    cursor: text;\n    overflow: hidden;\n\n    background-color: #fff;\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(1%, #eee), color-stop(15%, #fff));\n    background-image: -webkit-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: -moz-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: linear-gradient(top, #eee 1%, #fff 15%);\n}\n\n.select2-locked {\n  padding: 3px 5px 3px 5px !important;\n}\n\n.select2-container-multi .select2-choices {\n    min-height: 26px;\n}\n\n.select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #5897fb;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n.select2-container-multi .select2-choices li {\n    float: left;\n    list-style: none;\n}\n.select2-container-multi .select2-choices .select2-search-field {\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input {\n    padding: 5px;\n    margin: 1px 0;\n\n    font-family: sans-serif;\n    font-size: 100%;\n    color: #666;\n    outline: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    background: transparent !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input.select2-active {\n    background: #fff url(\'commons/public/3rd-party/select2-3.4.5/select2-spinner.gif\') no-repeat 100% !important;\n}\n\n.select2-default {\n    color: #999 !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 18px;\n    margin: 3px 0 3px 5px;\n    position: relative;\n\n    line-height: 13px;\n    color: #333;\n    cursor: default;\n    border: 1px solid #aaaaaa;\n\n    border-radius: 3px;\n\n    -webkit-box-shadow: 0 0 2px #fff inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n            box-shadow: 0 0 2px #fff inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n\n    background-color: #e4e4e4;\n    /*WANALYTIC-4617*/\n    /*filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#eeeeee\', endColorstr=\'#f4f4f4\', GradientType=0);*/\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(20%, #f4f4f4), color-stop(50%, #f0f0f0), color-stop(52%, #e8e8e8), color-stop(100%, #eee));\n    background-image: -webkit-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: -moz-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n}\n.select2-container-multi .select2-choices .select2-search-choice .select2-chosen {\n    cursor: default;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus {\n    background: #d4d4d4;\n}\n\n.select2-search-choice-close {\n    display: block;\n    width: 12px;\n    height: 13px;\n    position: absolute;\n    right: 3px;\n    top: 4px;\n\n    font-size: 1px;\n    outline: none;\n    background: url(\'commons/public/3rd-party/select2-3.4.5/select2.png\') right top no-repeat;\n}\n\n.select2-container-multi .select2-search-choice-close {\n    left: 3px;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover {\n  background-position: right -11px;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close {\n    background-position: right -11px;\n}\n\n/* disabled styles */\n.select2-container-multi.select2-container-disabled .select2-choices {\n    background-color: #f4f4f4;\n    background-image: none;\n    border: 1px solid #ddd;\n    cursor: default;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 5px;\n    border: 1px solid #ddd;\n    background-image: none;\n    background-color: #f4f4f4;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close {    display: none;\n    background: none;\n}\n/* end multiselect */\n\n\n.select2-result-selectable .select2-match,\n.select2-result-unselectable .select2-match {\n    text-decoration: underline;\n}\n\n.select2-offscreen, .select2-offscreen:focus {\n    clip: rect(0 0 0 0) !important;\n    width: 1px !important;\n    height: 1px !important;\n    border: 0 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    position: absolute !important;\n    outline: 0 !important;\n    left: 0px !important;\n    top: 0px !important;\n}\n\n.select2-display-none {\n    display: none;\n}\n\n.select2-measure-scrollbar {\n    position: absolute;\n    top: -10000px;\n    left: -10000px;\n    width: 100px;\n    height: 100px;\n    overflow: scroll;\n}\n/* Retina-ize icons */\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (min-resolution: 144dpi)  {\n  .select2-search input, .select2-search-choice-close, .select2-container .select2-choice abbr, .select2-container .select2-choice .select2-arrow b {\n      background-image: url(\'commons/public/3rd-party/select2-3.4.5/select2x2.png\') !important;\n      background-repeat: no-repeat !important;\n      background-size: 60px 40px !important;\n  }\n  .select2-search input {\n      background-position: 100% -21px !important;\n  }\n}\n\n/* TrustYou custom styles */\n.control-group .select2-container-multi .select2-choices .select2-search-field input {\n\tborder: none;\n\tfont-size: .9em;\n\tpadding: 5px 5px 3px;\n}\n.control-group .select2-container-multi.select2-container-active .select2-choices {\n\tbox-shadow: none;\n}\n.control-group .select2-container-multi .select2-choices {\n\tborder: 1px solid #e5e5e5;\n\tborder-left: none;\n\tborder-right: none;\n\tborder-radius: 0;\n}\n.select2-drop-active {\n\tborder-color: #e5e5e5;\n\tbox-shadow: none;\n}\n.select2-results .select2-no-results,\n.select2-results .select2-searching,\n.select2-results .select2-selection-limit {\n\tbackground: #fff;\n\tcolor: #999;\n\tfont-size: .9em;\n}\n\n.select2-match {\n\tbackground-color: #fff4e3;\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n\tcolor: #ffa726 !important;\n}.ui-multiselect { padding:2px 0 2px 4px; text-align:left }\n.ui-multiselect span.ui-icon { float:right }\n.ui-multiselect-single .ui-multiselect-checkboxes input { position:absolute !important; top: auto !important; left:-9999px; }\n.ui-multiselect-single .ui-multiselect-checkboxes label { padding:5px !important }\n\n.ui-multiselect-header { margin-bottom:3px; padding:3px 0 3px 4px }\n.ui-multiselect-header ul { font-size:0.9em }\n.ui-multiselect-header ul li { float:left; padding:0 10px 0 0 }\n.ui-multiselect-header a { text-decoration:none }\n.ui-multiselect-header a:hover { text-decoration:underline }\n.ui-multiselect-header span.ui-icon { float:left }\n.ui-multiselect-header li.ui-multiselect-close { float:right; text-align:right; padding-right:0 }\n\n.ui-multiselect-menu { display:none; padding:3px; position:absolute; z-index:10000; text-align: left }\n.ui-multiselect-checkboxes { position:relative /* fixes bug in IE6/7 */; overflow-y:scroll }\n.ui-multiselect-checkboxes label { cursor:default; display:block; border:1px solid transparent; padding:3px 1px }\n.ui-multiselect-checkboxes label input { position:relative; top:1px }\n.ui-multiselect-checkboxes li { clear:both; font-size:0.9em; padding-right:3px }\n.ui-multiselect-checkboxes li.ui-multiselect-optgroup-label { text-align:center; font-weight:bold; border-bottom:1px solid }\n.ui-multiselect-checkboxes li.ui-multiselect-optgroup-label a { display:block; padding:3px; margin:1px 0; text-decoration:none }\n\n/* remove label borders in IE6 because IE6 does not support transparency */\n* html .ui-multiselect-checkboxes label { border:none }\n.ui-multiselect-hasfilter ul { position:relative; top:2px }\n.ui-multiselect-filter { float:left; margin-right:10px; font-size:11px }\n.ui-multiselect-filter input { width:100px; font-size:10px; margin-left:5px; height:15px; padding:2px; border:1px solid #292929; -webkit-appearance:textfield; -webkit-box-sizing:content-box; }\n.toast-title {\n  font-weight: bold;\n}\n.toast-message {\n  -ms-word-wrap: break-word;\n  word-wrap: break-word;\n}\n.toast-message a,\n.toast-message label {\n  color: #FFFFFF;\n}\n.toast-message a:hover {\n  color: #CCCCCC;\n  text-decoration: none;\n}\n.toast-close-button {\n  position: relative;\n  right: -0.3em;\n  top: -0.3em;\n  float: right;\n  font-size: 20px;\n  font-weight: bold;\n  color: #FFFFFF;\n  -webkit-text-shadow: 0 1px 0 #ffffff;\n  text-shadow: 0 1px 0 #ffffff;\n  opacity: 0.8;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\n  filter: alpha(opacity=80);\n  line-height: 1;\n}\n.toast-close-button:hover,\n.toast-close-button:focus {\n  color: #000000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0.4;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);\n  filter: alpha(opacity=40);\n}\n.rtl .toast-close-button {\n  left: -0.3em;\n  float: left;\n  right: 0.3em;\n}\n/*Additional properties for button version\n iOS requires the button element instead of an anchor tag.\n If you want the anchor version, it requires `href=\"#\"`.*/\nbutton.toast-close-button {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n.toast-top-center {\n  top: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-bottom-center {\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-top-full-width {\n  top: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-bottom-full-width {\n  bottom: 0;\n  right: 0;\n  width: 100%;\n}\n.toast-top-left {\n  top: 12px;\n  left: 12px;\n}\n.toast-top-right {\n  top: 12px;\n  right: 12px;\n}\n.toast-bottom-right {\n  right: 12px;\n  bottom: 12px;\n}\n.toast-bottom-left {\n  bottom: 12px;\n  left: 12px;\n}\n#toast-container {\n  position: fixed;\n  z-index: 999999;\n  pointer-events: none;\n  /*overrides*/\n}\n#toast-container * {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n#toast-container > div {\n  position: relative;\n  pointer-events: auto;\n  overflow: hidden;\n  margin: 0 0 6px;\n  padding: 15px 15px 15px 50px;\n  width: 300px;\n  -moz-border-radius: 3px 3px 3px 3px;\n  -webkit-border-radius: 3px 3px 3px 3px;\n  border-radius: 3px 3px 3px 3px;\n  background-position: 15px center;\n  background-repeat: no-repeat;\n  -moz-box-shadow: 0 0 12px #999999;\n  -webkit-box-shadow: 0 0 12px #999999;\n  box-shadow: 0 0 12px #999999;\n  color: #FFFFFF;\n  opacity: 0.8;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\n  filter: alpha(opacity=80);\n}\n#toast-container > div.rtl {\n  direction: rtl;\n  padding: 15px 50px 15px 15px;\n  background-position: right 15px center;\n}\n#toast-container > div:hover {\n  -moz-box-shadow: 0 0 12px #000000;\n  -webkit-box-shadow: 0 0 12px #000000;\n  box-shadow: 0 0 12px #000000;\n  opacity: 1;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n  filter: alpha(opacity=100);\n  cursor: pointer;\n}\n#toast-container > .toast-info {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\") !important;\n}\n#toast-container > .toast-error {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\") !important;\n}\n#toast-container > .toast-success {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\") !important;\n}\n#toast-container > .toast-warning {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\") !important;\n}\n#toast-container.toast-top-center > div,\n#toast-container.toast-bottom-center > div {\n  width: 300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n#toast-container.toast-top-full-width > div,\n#toast-container.toast-bottom-full-width > div {\n  width: 96%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.toast {\n  background-color: #030303;\n}\n.toast-success {\n  background-color: #51A351;\n}\n.toast-error {\n  background-color: #BD362F;\n}\n.toast-info {\n  background-color: #2F96B4;\n}\n.toast-warning {\n  background-color: #F89406;\n}\n.toast-progress {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 4px;\n  background-color: #000000;\n  opacity: 0.4;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);\n  filter: alpha(opacity=40);\n}\n/*Responsive Design*/\n@media all and (max-width: 240px) {\n  #toast-container > div {\n    padding: 8px 8px 8px 50px;\n    width: 11em;\n  }\n  #toast-container > div.rtl {\n    padding: 8px 50px 8px 8px;\n  }\n  #toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em;\n  }\n  #toast-container .rtl .toast-close-button {\n    left: -0.2em;\n    right: 0.2em;\n  }\n}\n@media all and (min-width: 241px) and (max-width: 480px) {\n  #toast-container > div {\n    padding: 8px 8px 8px 50px;\n    width: 18em;\n  }\n  #toast-container > div.rtl {\n    padding: 8px 50px 8px 8px;\n  }\n  #toast-container .toast-close-button {\n    right: -0.2em;\n    top: -0.2em;\n  }\n  #toast-container .rtl .toast-close-button {\n    left: -0.2em;\n    right: 0.2em;\n  }\n}\n@media all and (min-width: 481px) and (max-width: 768px) {\n  #toast-container > div {\n    padding: 15px 15px 15px 50px;\n    width: 25em;\n  }\n  #toast-container > div.rtl {\n    padding: 15px 50px 15px 15px;\n  }\n}\n'); }); requirejs.s.contexts._.nextTick = requirejs.nextTick; 